/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/publish/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1447);
	module.exports = __webpack_require__(1562);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1751);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.9.12
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  colors: true,
	  AppBar: true,
	  Avatar: true,
	  Backdrop: true,
	  Badge: true,
	  BottomNavigation: true,
	  BottomNavigationAction: true,
	  Box: true,
	  Breadcrumbs: true,
	  Button: true,
	  ButtonBase: true,
	  ButtonGroup: true,
	  Card: true,
	  CardActionArea: true,
	  CardActions: true,
	  CardContent: true,
	  CardHeader: true,
	  CardMedia: true,
	  Checkbox: true,
	  Chip: true,
	  CircularProgress: true,
	  ClickAwayListener: true,
	  Collapse: true,
	  Container: true,
	  CssBaseline: true,
	  Dialog: true,
	  DialogActions: true,
	  DialogContent: true,
	  DialogContentText: true,
	  DialogTitle: true,
	  Divider: true,
	  Drawer: true,
	  ExpansionPanel: true,
	  ExpansionPanelActions: true,
	  ExpansionPanelDetails: true,
	  ExpansionPanelSummary: true,
	  Fab: true,
	  Fade: true,
	  FilledInput: true,
	  FormControl: true,
	  FormControlLabel: true,
	  FormGroup: true,
	  FormHelperText: true,
	  FormLabel: true,
	  Grid: true,
	  GridList: true,
	  GridListTile: true,
	  GridListTileBar: true,
	  Grow: true,
	  Hidden: true,
	  Icon: true,
	  IconButton: true,
	  Input: true,
	  InputAdornment: true,
	  InputBase: true,
	  InputLabel: true,
	  LinearProgress: true,
	  Link: true,
	  List: true,
	  ListItem: true,
	  ListItemAvatar: true,
	  ListItemIcon: true,
	  ListItemSecondaryAction: true,
	  ListItemText: true,
	  ListSubheader: true,
	  Menu: true,
	  MenuItem: true,
	  MenuList: true,
	  MobileStepper: true,
	  Modal: true,
	  NativeSelect: true,
	  NoSsr: true,
	  OutlinedInput: true,
	  Paper: true,
	  Popover: true,
	  Popper: true,
	  Portal: true,
	  Radio: true,
	  RadioGroup: true,
	  RootRef: true,
	  Select: true,
	  Slide: true,
	  Slider: true,
	  Snackbar: true,
	  SnackbarContent: true,
	  Step: true,
	  StepButton: true,
	  StepConnector: true,
	  StepContent: true,
	  StepIcon: true,
	  StepLabel: true,
	  Stepper: true,
	  SvgIcon: true,
	  SwipeableDrawer: true,
	  Switch: true,
	  Tab: true,
	  Table: true,
	  TableBody: true,
	  TableCell: true,
	  TableContainer: true,
	  TableFooter: true,
	  TableHead: true,
	  TablePagination: true,
	  TableRow: true,
	  TableSortLabel: true,
	  Tabs: true,
	  TextField: true,
	  TextareaAutosize: true,
	  Toolbar: true,
	  Tooltip: true,
	  Typography: true,
	  useMediaQuery: true,
	  useScrollTrigger: true,
	  withMobileDialog: true,
	  withWidth: true,
	  Zoom: true
	};
	Object.defineProperty(exports, "AppBar", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	Object.defineProperty(exports, "Backdrop", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigation", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigationAction", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	Object.defineProperty(exports, "Box", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "Breadcrumbs", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	Object.defineProperty(exports, "ButtonBase", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	Object.defineProperty(exports, "ButtonGroup", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	Object.defineProperty(exports, "CardActionArea", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	Object.defineProperty(exports, "CardActions", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	Object.defineProperty(exports, "CardContent", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	Object.defineProperty(exports, "CardHeader", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	Object.defineProperty(exports, "CardMedia", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	Object.defineProperty(exports, "Chip", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	Object.defineProperty(exports, "CircularProgress", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	Object.defineProperty(exports, "ClickAwayListener", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	Object.defineProperty(exports, "Container", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	Object.defineProperty(exports, "CssBaseline", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	Object.defineProperty(exports, "Dialog", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	Object.defineProperty(exports, "DialogActions", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	Object.defineProperty(exports, "DialogContent", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	Object.defineProperty(exports, "DialogContentText", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	Object.defineProperty(exports, "DialogTitle", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanel", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelActions", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelDetails", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelSummary", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	Object.defineProperty(exports, "Fab", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	Object.defineProperty(exports, "Fade", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	Object.defineProperty(exports, "FilledInput", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	Object.defineProperty(exports, "FormControl", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "FormControlLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	Object.defineProperty(exports, "FormGroup", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	Object.defineProperty(exports, "FormHelperText", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	Object.defineProperty(exports, "FormLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	Object.defineProperty(exports, "Grid", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	Object.defineProperty(exports, "GridList", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	Object.defineProperty(exports, "GridListTile", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	Object.defineProperty(exports, "GridListTileBar", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	Object.defineProperty(exports, "Grow", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	Object.defineProperty(exports, "Hidden", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	Object.defineProperty(exports, "IconButton", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	Object.defineProperty(exports, "InputAdornment", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	Object.defineProperty(exports, "InputBase", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	Object.defineProperty(exports, "InputLabel", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	Object.defineProperty(exports, "LinearProgress", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	Object.defineProperty(exports, "Link", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	Object.defineProperty(exports, "ListItem", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	Object.defineProperty(exports, "ListItemAvatar", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	Object.defineProperty(exports, "ListItemIcon", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	Object.defineProperty(exports, "ListItemSecondaryAction", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	Object.defineProperty(exports, "ListItemText", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	Object.defineProperty(exports, "ListSubheader", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuList", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	Object.defineProperty(exports, "MobileStepper", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "NativeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	Object.defineProperty(exports, "NoSsr", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedInput", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	Object.defineProperty(exports, "Paper", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	Object.defineProperty(exports, "RadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "RootRef", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Slide", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	Object.defineProperty(exports, "Snackbar", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	Object.defineProperty(exports, "SnackbarContent", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	Object.defineProperty(exports, "StepButton", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	Object.defineProperty(exports, "StepConnector", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	Object.defineProperty(exports, "StepContent", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	Object.defineProperty(exports, "StepIcon", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	Object.defineProperty(exports, "StepLabel", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	Object.defineProperty(exports, "Stepper", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	Object.defineProperty(exports, "SvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "SwipeableDrawer", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	Object.defineProperty(exports, "TableBody", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	Object.defineProperty(exports, "TableCell", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	Object.defineProperty(exports, "TableContainer", {
	  enumerable: true,
	  get: function get() {
	    return _TableContainer.default;
	  }
	});
	Object.defineProperty(exports, "TableFooter", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	Object.defineProperty(exports, "TableHead", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	Object.defineProperty(exports, "TablePagination", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	Object.defineProperty(exports, "TableRow", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	Object.defineProperty(exports, "TableSortLabel", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	Object.defineProperty(exports, "TextField", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	Object.defineProperty(exports, "TextareaAutosize", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	Object.defineProperty(exports, "Toolbar", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	Object.defineProperty(exports, "useMediaQuery", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	Object.defineProperty(exports, "useScrollTrigger", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	Object.defineProperty(exports, "withMobileDialog", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	Object.defineProperty(exports, "withWidth", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	Object.defineProperty(exports, "Zoom", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	exports.colors = void 0;
	
	var colors = _interopRequireWildcard(__webpack_require__(235));
	
	exports.colors = colors;
	
	var _styles = __webpack_require__(30);
	
	Object.keys(_styles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styles[key];
	    }
	  });
	});
	
	var _utils = __webpack_require__(34);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _AppBar = _interopRequireWildcard(__webpack_require__(715));
	
	Object.keys(_AppBar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AppBar[key];
	    }
	  });
	});
	
	var _Avatar = _interopRequireWildcard(__webpack_require__(717));
	
	Object.keys(_Avatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Avatar[key];
	    }
	  });
	});
	
	var _Backdrop = _interopRequireWildcard(__webpack_require__(220));
	
	Object.keys(_Backdrop).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Backdrop[key];
	    }
	  });
	});
	
	var _Badge = _interopRequireWildcard(__webpack_require__(720));
	
	Object.keys(_Badge).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Badge[key];
	    }
	  });
	});
	
	var _BottomNavigation = _interopRequireWildcard(__webpack_require__(722));
	
	Object.keys(_BottomNavigation).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomNavigation[key];
	    }
	  });
	});
	
	var _BottomNavigationAction = _interopRequireWildcard(__webpack_require__(724));
	
	Object.keys(_BottomNavigationAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomNavigationAction[key];
	    }
	  });
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(221));
	
	Object.keys(_Box).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Box[key];
	    }
	  });
	});
	
	var _Breadcrumbs = _interopRequireWildcard(__webpack_require__(728));
	
	Object.keys(_Breadcrumbs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Breadcrumbs[key];
	    }
	  });
	});
	
	var _Button = _interopRequireWildcard(__webpack_require__(108));
	
	Object.keys(_Button).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Button[key];
	    }
	  });
	});
	
	var _ButtonBase = _interopRequireWildcard(__webpack_require__(44));
	
	Object.keys(_ButtonBase).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ButtonBase[key];
	    }
	  });
	});
	
	var _ButtonGroup = _interopRequireWildcard(__webpack_require__(734));
	
	Object.keys(_ButtonGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ButtonGroup[key];
	    }
	  });
	});
	
	var _Card = _interopRequireWildcard(__webpack_require__(129));
	
	Object.keys(_Card).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Card[key];
	    }
	  });
	});
	
	var _CardActionArea = _interopRequireWildcard(__webpack_require__(737));
	
	Object.keys(_CardActionArea).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActionArea[key];
	    }
	  });
	});
	
	var _CardActions = _interopRequireWildcard(__webpack_require__(739));
	
	Object.keys(_CardActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActions[key];
	    }
	  });
	});
	
	var _CardContent = _interopRequireWildcard(__webpack_require__(130));
	
	Object.keys(_CardContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardContent[key];
	    }
	  });
	});
	
	var _CardHeader = _interopRequireWildcard(__webpack_require__(742));
	
	Object.keys(_CardHeader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardHeader[key];
	    }
	  });
	});
	
	var _CardMedia = _interopRequireWildcard(__webpack_require__(744));
	
	Object.keys(_CardMedia).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardMedia[key];
	    }
	  });
	});
	
	var _Checkbox = _interopRequireWildcard(__webpack_require__(746));
	
	Object.keys(_Checkbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Checkbox[key];
	    }
	  });
	});
	
	var _Chip = _interopRequireWildcard(__webpack_require__(157));
	
	Object.keys(_Chip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Chip[key];
	    }
	  });
	});
	
	var _CircularProgress = _interopRequireWildcard(__webpack_require__(313));
	
	Object.keys(_CircularProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CircularProgress[key];
	    }
	  });
	});
	
	var _ClickAwayListener = _interopRequireWildcard(__webpack_require__(109));
	
	Object.keys(_ClickAwayListener).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ClickAwayListener[key];
	    }
	  });
	});
	
	var _Collapse = _interopRequireWildcard(__webpack_require__(70));
	
	Object.keys(_Collapse).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Collapse[key];
	    }
	  });
	});
	
	var _Container = _interopRequireWildcard(__webpack_require__(752));
	
	Object.keys(_Container).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Container[key];
	    }
	  });
	});
	
	var _CssBaseline = _interopRequireWildcard(__webpack_require__(754));
	
	Object.keys(_CssBaseline).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CssBaseline[key];
	    }
	  });
	});
	
	var _Dialog = _interopRequireWildcard(__webpack_require__(756));
	
	Object.keys(_Dialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Dialog[key];
	    }
	  });
	});
	
	var _DialogActions = _interopRequireWildcard(__webpack_require__(758));
	
	Object.keys(_DialogActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogActions[key];
	    }
	  });
	});
	
	var _DialogContent = _interopRequireWildcard(__webpack_require__(760));
	
	Object.keys(_DialogContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContent[key];
	    }
	  });
	});
	
	var _DialogContentText = _interopRequireWildcard(__webpack_require__(762));
	
	Object.keys(_DialogContentText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContentText[key];
	    }
	  });
	});
	
	var _DialogTitle = _interopRequireWildcard(__webpack_require__(764));
	
	Object.keys(_DialogTitle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogTitle[key];
	    }
	  });
	});
	
	var _Divider = _interopRequireWildcard(__webpack_require__(91));
	
	Object.keys(_Divider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Divider[key];
	    }
	  });
	});
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(766));
	
	Object.keys(_Drawer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Drawer[key];
	    }
	  });
	});
	
	var _ExpansionPanel = _interopRequireWildcard(__webpack_require__(768));
	
	Object.keys(_ExpansionPanel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanel[key];
	    }
	  });
	});
	
	var _ExpansionPanelActions = _interopRequireWildcard(__webpack_require__(770));
	
	Object.keys(_ExpansionPanelActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelActions[key];
	    }
	  });
	});
	
	var _ExpansionPanelDetails = _interopRequireWildcard(__webpack_require__(772));
	
	Object.keys(_ExpansionPanelDetails).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelDetails[key];
	    }
	  });
	});
	
	var _ExpansionPanelSummary = _interopRequireWildcard(__webpack_require__(774));
	
	Object.keys(_ExpansionPanelSummary).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelSummary[key];
	    }
	  });
	});
	
	var _Fab = _interopRequireWildcard(__webpack_require__(776));
	
	Object.keys(_Fab).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Fab[key];
	    }
	  });
	});
	
	var _Fade = _interopRequireWildcard(__webpack_require__(158));
	
	Object.keys(_Fade).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Fade[key];
	    }
	  });
	});
	
	var _FilledInput = _interopRequireWildcard(__webpack_require__(223));
	
	Object.keys(_FilledInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FilledInput[key];
	    }
	  });
	});
	
	var _FormControl = _interopRequireWildcard(__webpack_require__(224));
	
	Object.keys(_FormControl).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormControl[key];
	    }
	  });
	});
	
	var _FormControlLabel = _interopRequireWildcard(__webpack_require__(781));
	
	Object.keys(_FormControlLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormControlLabel[key];
	    }
	  });
	});
	
	var _FormGroup = _interopRequireWildcard(__webpack_require__(317));
	
	Object.keys(_FormGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormGroup[key];
	    }
	  });
	});
	
	var _FormHelperText = _interopRequireWildcard(__webpack_require__(318));
	
	Object.keys(_FormHelperText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormHelperText[key];
	    }
	  });
	});
	
	var _FormLabel = _interopRequireWildcard(__webpack_require__(319));
	
	Object.keys(_FormLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormLabel[key];
	    }
	  });
	});
	
	var _Grid = _interopRequireWildcard(__webpack_require__(71));
	
	Object.keys(_Grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Grid[key];
	    }
	  });
	});
	
	var _GridList = _interopRequireWildcard(__webpack_require__(787));
	
	Object.keys(_GridList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridList[key];
	    }
	  });
	});
	
	var _GridListTile = _interopRequireWildcard(__webpack_require__(789));
	
	Object.keys(_GridListTile).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridListTile[key];
	    }
	  });
	});
	
	var _GridListTileBar = _interopRequireWildcard(__webpack_require__(791));
	
	Object.keys(_GridListTileBar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridListTileBar[key];
	    }
	  });
	});
	
	var _Grow = _interopRequireWildcard(__webpack_require__(80));
	
	Object.keys(_Grow).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Grow[key];
	    }
	  });
	});
	
	var _Hidden = _interopRequireWildcard(__webpack_require__(796));
	
	Object.keys(_Hidden).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Hidden[key];
	    }
	  });
	});
	
	var _Icon = _interopRequireWildcard(__webpack_require__(798));
	
	Object.keys(_Icon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Icon[key];
	    }
	  });
	});
	
	var _IconButton = _interopRequireWildcard(__webpack_require__(40));
	
	Object.keys(_IconButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconButton[key];
	    }
	  });
	});
	
	var _Input = _interopRequireWildcard(__webpack_require__(160));
	
	Object.keys(_Input).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Input[key];
	    }
	  });
	});
	
	var _InputAdornment = _interopRequireWildcard(__webpack_require__(802));
	
	Object.keys(_InputAdornment).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputAdornment[key];
	    }
	  });
	});
	
	var _InputBase = _interopRequireWildcard(__webpack_require__(131));
	
	Object.keys(_InputBase).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputBase[key];
	    }
	  });
	});
	
	var _InputLabel = _interopRequireWildcard(__webpack_require__(321));
	
	Object.keys(_InputLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputLabel[key];
	    }
	  });
	});
	
	var _LinearProgress = _interopRequireWildcard(__webpack_require__(322));
	
	Object.keys(_LinearProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _LinearProgress[key];
	    }
	  });
	});
	
	var _Link = _interopRequireWildcard(__webpack_require__(161));
	
	Object.keys(_Link).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Link[key];
	    }
	  });
	});
	
	var _List = _interopRequireWildcard(__webpack_require__(162));
	
	Object.keys(_List).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _List[key];
	    }
	  });
	});
	
	var _ListItem = _interopRequireWildcard(__webpack_require__(163));
	
	Object.keys(_ListItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItem[key];
	    }
	  });
	});
	
	var _ListItemAvatar = _interopRequireWildcard(__webpack_require__(810));
	
	Object.keys(_ListItemAvatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemAvatar[key];
	    }
	  });
	});
	
	var _ListItemIcon = _interopRequireWildcard(__webpack_require__(812));
	
	Object.keys(_ListItemIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemIcon[key];
	    }
	  });
	});
	
	var _ListItemSecondaryAction = _interopRequireWildcard(__webpack_require__(814));
	
	Object.keys(_ListItemSecondaryAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemSecondaryAction[key];
	    }
	  });
	});
	
	var _ListItemText = _interopRequireWildcard(__webpack_require__(226));
	
	Object.keys(_ListItemText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemText[key];
	    }
	  });
	});
	
	var _ListSubheader = _interopRequireWildcard(__webpack_require__(323));
	
	Object.keys(_ListSubheader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListSubheader[key];
	    }
	  });
	});
	
	var _Menu = _interopRequireWildcard(__webpack_require__(817));
	
	Object.keys(_Menu).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Menu[key];
	    }
	  });
	});
	
	var _MenuItem = _interopRequireWildcard(__webpack_require__(111));
	
	Object.keys(_MenuItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuItem[key];
	    }
	  });
	});
	
	var _MenuList = _interopRequireWildcard(__webpack_require__(133));
	
	Object.keys(_MenuList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuList[key];
	    }
	  });
	});
	
	var _MobileStepper = _interopRequireWildcard(__webpack_require__(821));
	
	Object.keys(_MobileStepper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MobileStepper[key];
	    }
	  });
	});
	
	var _Modal = _interopRequireWildcard(__webpack_require__(164));
	
	Object.keys(_Modal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Modal[key];
	    }
	  });
	});
	
	var _NativeSelect = _interopRequireWildcard(__webpack_require__(825));
	
	Object.keys(_NativeSelect).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NativeSelect[key];
	    }
	  });
	});
	
	var _NoSsr = _interopRequireWildcard(__webpack_require__(328));
	
	Object.keys(_NoSsr).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NoSsr[key];
	    }
	  });
	});
	
	var _OutlinedInput = _interopRequireWildcard(__webpack_require__(227));
	
	Object.keys(_OutlinedInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _OutlinedInput[key];
	    }
	  });
	});
	
	var _Paper = _interopRequireWildcard(__webpack_require__(38));
	
	Object.keys(_Paper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Paper[key];
	    }
	  });
	});
	
	var _Popover = _interopRequireWildcard(__webpack_require__(134));
	
	Object.keys(_Popover).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Popover[key];
	    }
	  });
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(135));
	
	Object.keys(_Popper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Popper[key];
	    }
	  });
	});
	
	var _Portal = _interopRequireWildcard(__webpack_require__(228));
	
	Object.keys(_Portal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Portal[key];
	    }
	  });
	});
	
	var _Radio = _interopRequireWildcard(__webpack_require__(835));
	
	Object.keys(_Radio).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Radio[key];
	    }
	  });
	});
	
	var _RadioGroup = _interopRequireWildcard(__webpack_require__(837));
	
	Object.keys(_RadioGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RadioGroup[key];
	    }
	  });
	});
	
	var _RootRef = _interopRequireWildcard(__webpack_require__(839));
	
	Object.keys(_RootRef).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RootRef[key];
	    }
	  });
	});
	
	var _Select = _interopRequireWildcard(__webpack_require__(165));
	
	Object.keys(_Select).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Select[key];
	    }
	  });
	});
	
	var _Slide = _interopRequireWildcard(__webpack_require__(229));
	
	Object.keys(_Slide).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Slide[key];
	    }
	  });
	});
	
	var _Slider = _interopRequireWildcard(__webpack_require__(845));
	
	Object.keys(_Slider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Slider[key];
	    }
	  });
	});
	
	var _Snackbar = _interopRequireWildcard(__webpack_require__(847));
	
	Object.keys(_Snackbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Snackbar[key];
	    }
	  });
	});
	
	var _SnackbarContent = _interopRequireWildcard(__webpack_require__(332));
	
	Object.keys(_SnackbarContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SnackbarContent[key];
	    }
	  });
	});
	
	var _Step = _interopRequireWildcard(__webpack_require__(850));
	
	Object.keys(_Step).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Step[key];
	    }
	  });
	});
	
	var _StepButton = _interopRequireWildcard(__webpack_require__(852));
	
	Object.keys(_StepButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepButton[key];
	    }
	  });
	});
	
	var _StepConnector = _interopRequireWildcard(__webpack_require__(333));
	
	Object.keys(_StepConnector).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepConnector[key];
	    }
	  });
	});
	
	var _StepContent = _interopRequireWildcard(__webpack_require__(855));
	
	Object.keys(_StepContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepContent[key];
	    }
	  });
	});
	
	var _StepIcon = _interopRequireWildcard(__webpack_require__(334));
	
	Object.keys(_StepIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepIcon[key];
	    }
	  });
	});
	
	var _StepLabel = _interopRequireWildcard(__webpack_require__(335));
	
	Object.keys(_StepLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepLabel[key];
	    }
	  });
	});
	
	var _Stepper = _interopRequireWildcard(__webpack_require__(859));
	
	Object.keys(_Stepper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Stepper[key];
	    }
	  });
	});
	
	var _SvgIcon = _interopRequireWildcard(__webpack_require__(166));
	
	Object.keys(_SvgIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SvgIcon[key];
	    }
	  });
	});
	
	var _SwipeableDrawer = _interopRequireWildcard(__webpack_require__(863));
	
	Object.keys(_SwipeableDrawer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SwipeableDrawer[key];
	    }
	  });
	});
	
	var _Switch = _interopRequireWildcard(__webpack_require__(865));
	
	Object.keys(_Switch).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Switch[key];
	    }
	  });
	});
	
	var _Tab = _interopRequireWildcard(__webpack_require__(867));
	
	Object.keys(_Tab).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tab[key];
	    }
	  });
	});
	
	var _Table = _interopRequireWildcard(__webpack_require__(230));
	
	Object.keys(_Table).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Table[key];
	    }
	  });
	});
	
	var _TableBody = _interopRequireWildcard(__webpack_require__(231));
	
	Object.keys(_TableBody).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableBody[key];
	    }
	  });
	});
	
	var _TableCell = _interopRequireWildcard(__webpack_require__(167));
	
	Object.keys(_TableCell).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableCell[key];
	    }
	  });
	});
	
	var _TableContainer = _interopRequireWildcard(__webpack_require__(232));
	
	Object.keys(_TableContainer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableContainer[key];
	    }
	  });
	});
	
	var _TableFooter = _interopRequireWildcard(__webpack_require__(873));
	
	Object.keys(_TableFooter).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableFooter[key];
	    }
	  });
	});
	
	var _TableHead = _interopRequireWildcard(__webpack_require__(233));
	
	Object.keys(_TableHead).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableHead[key];
	    }
	  });
	});
	
	var _TablePagination = _interopRequireWildcard(__webpack_require__(877));
	
	Object.keys(_TablePagination).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TablePagination[key];
	    }
	  });
	});
	
	var _TableRow = _interopRequireWildcard(__webpack_require__(234));
	
	Object.keys(_TableRow).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableRow[key];
	    }
	  });
	});
	
	var _TableSortLabel = _interopRequireWildcard(__webpack_require__(880));
	
	Object.keys(_TableSortLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableSortLabel[key];
	    }
	  });
	});
	
	var _Tabs = _interopRequireWildcard(__webpack_require__(885));
	
	Object.keys(_Tabs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tabs[key];
	    }
	  });
	});
	
	var _TextField = _interopRequireWildcard(__webpack_require__(887));
	
	Object.keys(_TextField).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextField[key];
	    }
	  });
	});
	
	var _TextareaAutosize = _interopRequireWildcard(__webpack_require__(337));
	
	Object.keys(_TextareaAutosize).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextareaAutosize[key];
	    }
	  });
	});
	
	var _Toolbar = _interopRequireWildcard(__webpack_require__(338));
	
	Object.keys(_Toolbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Toolbar[key];
	    }
	  });
	});
	
	var _Tooltip = _interopRequireWildcard(__webpack_require__(339));
	
	Object.keys(_Tooltip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tooltip[key];
	    }
	  });
	});
	
	var _Typography = _interopRequireWildcard(__webpack_require__(43));
	
	Object.keys(_Typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Typography[key];
	    }
	  });
	});
	
	var _useMediaQuery = _interopRequireWildcard(__webpack_require__(356));
	
	Object.keys(_useMediaQuery).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useMediaQuery[key];
	    }
	  });
	});
	
	var _useScrollTrigger = _interopRequireWildcard(__webpack_require__(932));
	
	Object.keys(_useScrollTrigger).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useScrollTrigger[key];
	    }
	  });
	});
	
	var _withMobileDialog = _interopRequireWildcard(__webpack_require__(936));
	
	Object.keys(_withMobileDialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withMobileDialog[key];
	    }
	  });
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(239));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});
	
	var _Zoom = _interopRequireWildcard(__webpack_require__(341));
	
	Object.keys(_Zoom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Zoom[key];
	    }
	  });
	});

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(79);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1395)();
	}


/***/ },
/* 6 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.26.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1385)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged and will be removed in an upcoming major release. Please refer to ' +
	            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.26.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.15';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
	      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      // Like with sourceURL, we take care to not check the option's prototype,
	      // as this configuration is a code injection vector.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(107)(module)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(90);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ },
/* 10 */
/***/ function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
		if (mix) {
			if (typeof mix === 'object') {
				if (!!mix.push) {
					for (k=0; k < mix.length; k++) {
						if (mix[k] && (y = toVal(mix[k]))) {
							str && (str += ' ');
							str += y;
						}
					}
				} else {
					for (k in mix) {
						if (mix[k] && (y = toVal(k))) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else if (typeof mix !== 'boolean' && !mix.call) {
				str && (str += ' ');
				str += mix;
			}
		}
		return str;
	}
	
	module.exports = function () {
		var i=0, x, str='';
		while (i < arguments.length) {
			if (x = toVal(arguments[i++])) {
				str && (str += ' ');
				str += x
			}
		}
		return str;
	}


/***/ },
/* 11 */
[1913, 917],
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(52);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(137));
	
	function withStyles(stylesOrCreator, options) {
	  return (0, _styles.withStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    var invalidType;
	
	    if (input === null) {
	      invalidType = 'null';
	    } else {
	      invalidType = _typeof(input);
	
	      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
	        invalidType = input.constructor.name;
	      } else {
	        invalidType = "a ".concat(invalidType);
	      }
	    }
	
	    throw new TypeError("Expected string but received ".concat(invalidType, "."));
	  }
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ADD_APIPLAN_ACTION_TEXT = exports.CHANGE_ACTION_TEXT = exports.VERSION_TEXT = exports.GRID_ROWS_PER_PAGE_DEFAULT_OPTION = exports.GRID_ROWS_PER_PAGE_OPTIONS = exports.DONE_TEXT = exports.NEXT_TEXT = exports.UNSAVED_DIALOG_EXIT_TEXT = exports.UNSAVED_DIALOG_SUBMIT_TEXT = exports.UNSAVED_DIALOG_CANCEL_TEXT = exports.UNSAVED_DIALOG_DESCRIPTIONS = exports.UNSAVED_DIALOG_TITLE = exports.HTTP_STATUS_SUCCESS = exports.HTTP_STATUS_UNAUTHORIZED = exports.HTTP_STATUS_BAD_REQUEST = exports.API_PLANS_GET_ERROR = exports.API_PLANS_GET_SUCCESS = exports.ACCOUNT_PLANS_GET_ERROR = exports.ACCOUNT_PLANS_GET_SUCCESS = exports.API_KEYS_COUNT_GET_ERROR = exports.API_KEYS_COUNT_GET_SUCCESS = exports.API_KEYS_COUNT_GET_REQUEST = exports.DIALOG_TITLE_ERROR = exports.COPY_CLOSE_TEXT = exports.COPY_TEXT = exports.CLOSE_TEXT = exports.PROXY_APIS_KEY_STATUS_FILTER_BY = exports.APIS_DEPLOYMENT_STATUS_FILTER_BY = exports.APIS_PUBLISH_SOURCES_FILTER_BY = exports.PROXY_APIS_STATES_FILTER_BY = exports.PROXY_APIS_SORT_BY = exports.APIS_STATES_FILTER_BY = exports.APIS_SORT_BY = exports.APIS_GET_ERROR = exports.APIS_GET_SUCCESS = exports.PROXY_KEYS_QUERY_PARAMS = exports.PROXY_API_QUERY_PARAMS = exports.PROXY_ENROLLMENT_HELP_ITEMS = exports.PROXY_DETAILS_URL = exports.PROXY_DEPLOYEMT_AUTOMATIC = exports.BULK_DEPLOYMENT_STATUS_RUNNING = exports.BULK_DEPLOYMENT_STATUS_DONE = exports.PROXY_DISCONNECTED = undefined;
	exports.PROXY_CONNECTED = exports.PROXY_ENROLMENT_STATUS_PENDING = exports.PROXY_ENROLMENT_STATUS_ACTIVE = exports.PROXY_APIS_KEYS_COUNT_GET_ERROR = exports.PROXY_APIS_KEYS_COUNT_GET_SUCCESS = exports.PROXY_APIS_KEYS_LIST_GET_ERROR = exports.PROXY_APIS_KEYS_LIST_GET_SUCCESS = exports.PROXY_APIS_LIST_GET_ERROR = exports.PROXY_APIS_LIST_GET_SUCCESS = exports.PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR = exports.PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS = exports.PROXY_ORGANIZATIONS_GET_ERROR = exports.PROXY_ORGANIZATIONS_GET_SUCCESS = exports.PROXY_APIS_GET_ERROR = exports.PROXY_APIS_GET_SUCCESS = exports.PROXY_APIS_GET_REQUEST = exports.PROXY_GATEWAY_GET_ERROR = exports.PROXY_GATEWAY_GET_SUCCESS = exports.PROXY_GATEWAY_GET_REQUEST = exports.PROXY_DETAILS_GET_ERROR = exports.PROXY_DETAILS_GET_SUCCESS = exports.PROXY_DELETE_ERROR = exports.PROXY_DELETE_SUCCESS = exports.PROXY_GET_ERROR = exports.PROXY_GET_SUCCESS = exports.PROXY_DEPLOYMENT_TYPE_SCRIPTED = exports.PROXY_DEPLOYMENT_TYPE_ON_DEMAND = exports.PROXY_DEPLOYMENT_TYPE_AUTOMATIC = exports.USERS_DELETE_RESET = exports.USERS_GET_ERROR = exports.USERS_GET_SUCCESS = exports.USER_LIST_SORT_BY = exports.USER_LIST_STATUS_FILTER_BY = exports.USER_STATUS_LABEL = exports.USER_STATUS_REGISTRATION_PENDING_APPROVAL = exports.USER_STATUS_REGISTRATION_INIT = exports.USER_STATUS_LOCKED = exports.USER_STATUS_DISABLED = exports.USER_STATUS_ENABLED = exports.USER_LIST_ROLE = exports.ROLE_ORG_PUBLISHER = exports.ROLE_ORG_PUBLISHER_UUID = exports.ROLE_DEVELOPER = exports.ROLE_DEVELOPER_UUID = exports.ROLE_ORG_ADMIN = exports.ROLE_ORG_ADMIN_UUID = exports.ROLE_API_OWNER = exports.ROLE_API_OWNER_UUID = exports.ROLE_PORTAL_ADMIN = exports.ROLE_PORTAL_ADMIN_UUID = exports.ORGANIZATION_LIST_TYPE_BY = exports.ORGANIZATION_TYPE_CONSUMER = exports.ORGANIZATION_TYPE_PUBLISHER = exports.ORGANIZATION_UPDATE_ERROR = exports.ORGANIZATION_UPDATE_SUCCESS = exports.ORGANIZATION_UPDATE_REQUEST = exports.ORGANIZATION_CREATE_ERROR = exports.ORGANIZATION_CREATE_SUCCESS = exports.ORGANIZATION_CREATE_REQUEST = exports.ORGANIZATION_NAME_UNIQUE_ERROR = exports.ORGANIZATION_NAME_UNIQUE_SUCCESS = exports.ORGANIZATION_NAME_UNIQUE_REQUEST = exports.ACCOUNTPLANS_GET_ERROR = exports.ACCOUNTPLANS_GET_SUCCESS = exports.ACCOUNTPLANS_GET_REQUEST = exports.ORGANIZATION_GET_ERROR = exports.ORGANIZATION_GET_SUCCESS = exports.ORGANIZATION_GET_REQUEST = exports.ORGANIZATION_LIST_GET_ERROR = exports.ORGANIZATION_LIST_GET_SUCCESS = exports.ORGANIZATIONS_GET_ERROR = exports.ORGANIZATIONS_GET_SUCCESS = exports.ORGANIZATION_STATUS_ENABLED = exports.GATEWAY_BUNDLES_ENCAPSULATED_ASSERTION = exports.GATEWAY_BUNDLES_DELETE_RESET = exports.GATEWAY_BUNDLES_REDEPLOY_PROXY_ERROR = exports.GATEWAY_BUNDLES_UNDEPLOY_PROXY_ERROR = exports.GATEWAY_BUNDLES_DEPLOY_PROXY_ERROR = exports.GATEWAY_BUNDLES_UNDEPLOY_PROXY_SUCCESS = exports.GATEWAY_BUNDLES_REDEPLOY_PROXY_SUCCESS = exports.GATEWAY_BUNDLES_DEPLOY_PROXY_SUCCESS = exports.GATEWAY_BUNDLES_GET_APIS_ERROR = exports.GATEWAY_BUNDLES_GET_APIS_SUCCESS = exports.GATEWAY_BUNDLES_GET_PROXY_LIST_ERROR = exports.GATEWAY_BUNDLES_GET_PROXY_LIST_SUCCESS = exports.GATEWAY_BUNDLES_GET_PROXY_ERROR = exports.GATEWAY_BUNDLES_GET_PROXY_SUCCESS = exports.GATEWAY_BUNDLES_DELETE_ERROR = exports.GATEWAY_BUNDLES_DELETE_SUCCESS = exports.GATEWAY_BUNDLES_GET_USAGE_ERROR = exports.GATEWAY_BUNDLES_GET_USAGE_SUCCESS = exports.GATEWAY_BUNDLES_SAVE_ERROR = exports.GATEWAY_BUNDLES_SAVE_SUCCESS = exports.GATEWAY_BUNDLES_GET_ERROR = exports.GATEWAY_BUNDLES_GET_SUCCESS = exports.GATEWAY_BUNDLES_DETAILS_ERROR = exports.GATEWAY_BUNDLES_DETAILS_SUCCESS = exports.GATEWAY_BUNDLES_API_STATES_FILTER_BY = exports.GATEWAY_BUNDLES_API_SORT_BY = exports.GATEWAY_BUNDLES_LIST_PORTAL_TEMPLATE_BY = undefined;
	exports.GATEWAY_BUNDLES_LIST_TYPE_BY = exports.GATEWAY_BUNDLES_LIST_SORT_BY = exports.MULTIKEY_HELP_ITEMS = exports.HELP_ITEMS = exports.DEPLOYMENT_STATUS_NOT_DEPLOYED = exports.DEPLOYMENT_STATUS_ERROR_UNDEPLOY = exports.DEPLOYMENT_STATUS_ERROR = exports.DEPLOYMENT_STATUS_PENDING_UNDEPLOYMENT = exports.DEPLOYMENT_STATUS_PENDING_DEPLOYMENT = exports.DEPLOYMENT_STATUS_DEPLOYED = exports.DASHBOARD_CHART_DATA_ERROR = exports.DASHBOARD_CHART_DATA_SUCCESS = exports.DASHBOARD_GET_ENTITY_COUNT_ERROR = exports.DASHBOARD_GET_ENTITY_COUNT_SUCCESS = exports.DASHBOARD_AUTOSUGGEST_SHOW_ERROR = exports.DASHBOARD_AUTOSUGGEST_SHOW_SUCCESS = exports.APPLICATION_DISABLED_BY_TYPE_EXTERNAL = exports.APPLICATION_STATUS_REJECTED = exports.APPLICATION_STATUS_EDIT_PENDING_APPROVAL = exports.APPLICATION_STATUS_PENDING_APPROVAL = exports.APPLICATION_STATUS_DISABLED = exports.APPLICATION_STATUS_ENABLED = exports.API_STATUS_PENDING_BUNDLE = exports.API_STATUS_INCOMPLETE = exports.API_STATUS_DEPRECATED = exports.API_STATUS_NEW = exports.API_STATUS_ENABLED = exports.API_STATUS_DISABLED = exports.TYPE_API_GROUP = exports.TYPE_API = exports.APPLICATION_STATUS_UPDATE_ERROR = exports.APPLICATION_STATUS_UPDATE_SUCCESS = exports.APPLICATION_STATUS_UPDATE_RESET = exports.APPLICATION_DELETE_ERROR = exports.APPLICATION_DELETE_SUCCESS = exports.APPLICATION_DELETE_RESET = exports.APPLICATION_API_PLANS_GET_SUCCESS = exports.APPLICATION_SINGLE_GET_SUCCESS = exports.KEY_DELETE_ERROR = exports.KEY_DELETE_SUCCESS = exports.KEY_UPDATE_ERROR = exports.KEY_UPDATE_SUCCESS = exports.KEY_CREATE_ERROR = exports.KEY_CREATE_SUCCESS = exports.KEY_STATUS_RESET = exports.KEY_NAME_UNIQUE_ERROR = exports.KEY_NAME_UNIQUE_SUCCESS = exports.APPLICATION_ALL_KEYS_COUNT_GET_ERROR = exports.APPLICATION_ALL_KEYS_COUNT_GET_SUCCESS = exports.APPLICATION_ALL_KEYS_GET_ERROR = exports.APPLICATION_ALL_KEYS_GET_SUCCESS = exports.API_KEY_UNDEPLOY_ERROR = exports.API_KEY_UNDEPLOY_SUCCESS = exports.API_KEY_REDEPLOY_ERROR = exports.API_KEY_REDEPLOY_SUCCESS = exports.API_KEY_DEPLOY_ERROR = exports.API_KEY_DEPLOY_SUCCESS = exports.API_KEY_PROXIES_GET_ERROR = exports.API_KEY_PROXIES_GET_SUCCESS = exports.API_KEY_STATUS_ENABLED = exports.API_KEY_STATUS_DISABLED = exports.PROXIES_ERROR = exports.PROXIES_GET_SUCCESS = exports.APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB = exports.TENANT_INFO_GET_SUCCESS = exports.APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS = exports.APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS = exports.APPLICATION_GENERATE_SECRET_GET_SUCCESS = exports.APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS = exports.APPLICATION_API_EULA_GET_SUCCESS = exports.APPLICATION_AVAILABLE_ORGS_GET_SUCCESS = exports.APPLICATION_AVAILABLE_APPS_GET_SUCCESS = exports.APPLICATION_AVAILABLE_APIS_GET_SUCCESS = exports.APPLICATION_SELECTED_APIS_GET_SUCCESS = exports.APPLICATION_CUSTOM_FIELDS_GET_SUCCESS = exports.APPLICATION_ORGANIZATIONS_GET_SUCCESS = exports.APPLICATION_NAME_UNIQUE_SUCCESS = exports.APPLICATION_SECRET_UPDATE_SUCCESS = exports.APPLICATION_UPDATE_AND_GET_SUCCESS = exports.APPLICATION_UPDATE_SUCCESS = exports.APPLICATION_CREATE_SUCCESS = exports.APPLICATION_GET_SUCCESS = exports.APPLICATION_ERROR = exports.APPLICATION_LOADING = exports.API_POLICY_TEMPLATES_SAVE_SUCCESS = exports.API_POLICY_TEMPLATES_GET_SUCCESS = exports.API_CUSTOM_FIELDS_SAVE_SUCCESS = exports.API_CUSTOM_FIELDS_GET_SUCCESS = exports.API_USAGE_GET_SUCCESS = exports.API_ASSETS_GET_SUCCESS = exports.API_PUBLISH_SAVE_SUCCESS = exports.API_UPDATE_SUCCESS = exports.API_SAVE_SUCCESS = exports.API_GET_SUCCESS = exports.API_PROXY_URL_UNIQUE_SUCCESS = exports.API_NAME_UNIQUE_SUCCESS = exports.APPLICATION_API_GROUP_EULAS_GET_SUCCESS = exports.API_EULAS_SUCCESS = exports.POLICY_TEMPLATES_GET_SUCCESS = exports.CUSTOM_FIELDS_GET_SUCCESS = undefined;
	exports.ORGANIZATION_ADMIN_TEXT = exports.DEVELOPER_TEXT = exports.API_OWNER_TEXT = exports.PENDING_DEPLOYMENT = exports.ALERT_ERROR = exports.ALERT_SUCCESS = exports.UPDATE_FAIL = exports.UPDATE_SUCCESS = exports.CREATE_FAIL = exports.CREATE_SUCCESS = exports.RESET = exports.FAIL = exports.SUCCESS = exports.NONE = exports.FETCH_API_PLANS_ERROR = exports.FETCH_API_PLANS_SUCCESS = exports.FETCH_ACCOUNT_PLANS_ERROR = exports.FETCH_ACCOUNT_PLANS_SUCCESS = exports.FETCH_APPS_ERROR = exports.FETCH_APPS_SUCCESS = exports.FETCH_APIS_ERROR = exports.FETCH_APIS_SUCCESS = exports.FETCH_GATEWAY_DETAILS_ERROR = exports.FETCH_GATEWAY_DETAILS_SUCCESS = exports.FETCH_GATEWAYS_ERROR = exports.FETCH_GATEWAYS_SUCCESS = exports.FETCH_API_SYNC_COUNT_ERROR = exports.FETCH_API_SYNC_COUNT_SUCCESS = exports.FETCH_API_SYNC_FEATURE_FLAG_ERROR = exports.FETCH_API_SYNC_FEATURE_FLAG_SUCCESS = exports.API_PROXY_FETCH_DETAILS_ERROR = exports.API_PROXY_FETCH_DETAILS_SUCCESS = exports.API_PROXY_UPDATE_ORGS_ERROR = exports.API_PROXY_UPDATE_ORGS_SUCCESS = exports.API_PROXY_FETCH_SELECTED_ORGANIZATIONS_ERROR = exports.API_PROXY_FETCH_SELECTED_ORGANIZATIONS_SUCCESS = exports.API_PROXY_FETCH_ORGANIZATIONS_ERROR = exports.API_PROXY_FETCH_ORGANIZATIONS_SUCCESS = exports.API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_ERROR = exports.API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_SUCCESS = exports.API_PROXY_FETCH_DEPLOYMENT_TYPE_ERROR = exports.API_PROXY_FETCH_DEPLOYMENT_TYPE_SUCCESS = exports.API_PROXY_DELETE_ERROR = exports.API_PROXY_DELETE_SUCCESS = exports.API_PROXY_UPDATE_ERROR = exports.API_PROXY_UPDATE_SUCCESS = exports.API_PROXY_CREATE_ERROR = exports.API_PROXY_CREATE_SUCCESS = exports.API_PROXY_SAVE_STATUS_RESET = exports.API_PROXY_VALIDATE_UNIQUE_NAME_ERROR = exports.API_PROXY_VALIDATE_UNIQUE_NAME_SUCCESS = exports.API_PROXY_VALIDATE_UNIQUE_NAME_RESET = exports.API_PROXY_RESET = exports.API_PROXY_LOADING = exports.CHANGE = exports.API_USER_CONTEXTS = exports.API_TAGS_ASSOCIATE_SUCCESS = exports.API_TAGS_ASSOCIATE_REQUEST = exports.API_TAGS_CREATE_TAGS_SUCCESS = exports.API_SWAGGER_SUCCESS = exports.API_TAGS_API_TAGS_SUCCESS = exports.API_TAGS_API_TAGS_REQUEST = exports.API_TAGS_ALL_TAGS_SUCCESS = exports.API_TAGS_ALL_TAGS_REQUEST = exports.API_PERMISSION_PERMITTED_ERROR = exports.API_PERMISSION_PERMITTED_SUCCESS = exports.API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS = exports.API_PERMISSION_ACCESS_STATUS_SUCCESS = exports.API_PERMISSION_REDIRECT_API_TAB = exports.API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS = exports.API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS = exports.API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS = exports.API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS = exports.API_PERMISSION_ORGANIZATIONS_SUCCESS = exports.API_PERMISSION_SELECTED_USER_SUCCESS = exports.API_PERMISSION_SAVE_SUCCESS = exports.API_PERMISSION_AVAILABLE_USER_SUCCESS = exports.API_ERROR_CLOSE = exports.API_ERROR = exports.API_SUCCESS = exports.FETCH_SETTING_USER_LOCK_CREATION_SUCCESS = exports.FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS = exports.FETCH_APPLICATION_REQUEST_SETTING_SUCCESS = exports.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_ERROR = exports.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS = exports.FETCH_APP_SECRET_HASHING_METADATA_ERROR = exports.FETCH_APP_SECRET_HASHING_METADATA_SUCCESS = exports.FETCH_REQUESTS_ERROR = exports.FETCH_REQUESTS_SUCCESS = exports.USER_CONTEXTS_UPDATE_SUCCESS = exports.API_ACCESS_STATUS_PRIVATE = exports.PORTAL_STATUS_ENABLED = exports.PORTAL_STATUS_NEW = exports.APP_LOADING = exports.APP_RESET = exports.LIST_SORT_BY = exports.KEYS = exports.ALL = exports.ANY = exports.KEY_ENTER = undefined;
	
	var _USER_LIST_ROLE, _USER_STATUS_LABEL;
	
	var _intl = __webpack_require__(15);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/** Common */
	var KEY_ENTER = exports.KEY_ENTER = 'Enter';
	var ANY = exports.ANY = 'any';
	var ALL = exports.ALL = 'all';
	var KEYS = exports.KEYS = 'keys';
	
	var LIST_SORT_BY = exports.LIST_SORT_BY = [{
	  uuid: 'name,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.name.asc')
	}, {
	  uuid: 'name,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.name.desc')
	}, {
	  uuid: 'modifyTs,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.updated.asc')
	}, {
	  uuid: 'modifyTs,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.updated.desc')
	}, {
	  uuid: 'createTs,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.created.asc')
	}, {
	  uuid: 'createTs,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.created.desc')
	}];
	
	var APP_RESET = exports.APP_RESET = 'APP_RESET';
	var APP_LOADING = exports.APP_LOADING = 'APP_LOADING';
	
	var PORTAL_STATUS_NEW = exports.PORTAL_STATUS_NEW = 'NEW';
	var PORTAL_STATUS_ENABLED = exports.PORTAL_STATUS_ENABLED = 'ENABLED';
	
	var API_ACCESS_STATUS_PRIVATE = exports.API_ACCESS_STATUS_PRIVATE = 'PRIVATE';
	
	var USER_CONTEXTS_UPDATE_SUCCESS = exports.USER_CONTEXTS_UPDATE_SUCCESS = 'API_PERMISSION_SAVE_USER_CONTEXTS_SUCCESS';
	
	var FETCH_REQUESTS_SUCCESS = exports.FETCH_REQUESTS_SUCCESS = 'FETCH_REQUESTS_SUCCESS';
	var FETCH_REQUESTS_ERROR = exports.FETCH_REQUESTS_ERROR = 'FETCH_REQUESTS_ERROR';
	
	var FETCH_APP_SECRET_HASHING_METADATA_SUCCESS = exports.FETCH_APP_SECRET_HASHING_METADATA_SUCCESS = 'FETCH_APP_SECRET_HASHING_METADATA_SUCCESS';
	var FETCH_APP_SECRET_HASHING_METADATA_ERROR = exports.FETCH_APP_SECRET_HASHING_METADATA_ERROR = 'FETCH_APP_SECRET_HASHING_METADATA_ERROR';
	var FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS = exports.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS = 'FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS';
	var FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_ERROR = exports.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_ERROR = 'FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_ERROR';
	
	var FETCH_APPLICATION_REQUEST_SETTING_SUCCESS = exports.FETCH_APPLICATION_REQUEST_SETTING_SUCCESS = 'FETCH_APPLICATION_REQUEST_SETTING_SUCCESS';
	var FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS = exports.FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS = 'FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS';
	
	var FETCH_SETTING_USER_LOCK_CREATION_SUCCESS = exports.FETCH_SETTING_USER_LOCK_CREATION_SUCCESS = 'FETCH_SETTING_USER_LOCK_CREATION_SUCCESS';
	
	var API_SUCCESS = exports.API_SUCCESS = 'API_SUCCESS';
	var API_ERROR = exports.API_ERROR = 'API_ERROR';
	var API_ERROR_CLOSE = exports.API_ERROR_CLOSE = 'API_ERROR_CLOSE';
	
	var API_PERMISSION_AVAILABLE_USER_SUCCESS = exports.API_PERMISSION_AVAILABLE_USER_SUCCESS = 'API_PERMISSION_AVAILABLE_USER_SUCCESS';
	var API_PERMISSION_SAVE_SUCCESS = exports.API_PERMISSION_SAVE_SUCCESS = 'API_PERMISSION_SAVE_SUCCESS';
	var API_PERMISSION_SELECTED_USER_SUCCESS = exports.API_PERMISSION_SELECTED_USER_SUCCESS = 'API_PERMISSION_SELECTED_USER_SUCCESS';
	
	var API_PERMISSION_ORGANIZATIONS_SUCCESS = exports.API_PERMISSION_ORGANIZATIONS_SUCCESS = 'API_PERMISSION_ORGANIZATIONS_SUCCESS';
	var API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS = exports.API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS = 'API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS';
	var API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS = exports.API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS = 'API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS';
	var API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS = exports.API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS = 'API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS';
	var API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS = exports.API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS = 'API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS';
	var API_PERMISSION_REDIRECT_API_TAB = exports.API_PERMISSION_REDIRECT_API_TAB = 'API_PERMISSION_REDIRECT_API_TAB';
	
	var API_PERMISSION_ACCESS_STATUS_SUCCESS = exports.API_PERMISSION_ACCESS_STATUS_SUCCESS = 'API_PERMISSION_ACCESS_STATUS_SUCCESS';
	var API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS = exports.API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS = 'API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS';
	var API_PERMISSION_PERMITTED_SUCCESS = exports.API_PERMISSION_PERMITTED_SUCCESS = 'API_PERMISSION_PERMITTED_SUCCESS';
	var API_PERMISSION_PERMITTED_ERROR = exports.API_PERMISSION_PERMITTED_ERROR = 'API_PERMISSION_PERMITTED_ERROR';
	
	var API_TAGS_ALL_TAGS_REQUEST = exports.API_TAGS_ALL_TAGS_REQUEST = 'API_TAGS_ALL_TAGS_REQUEST';
	var API_TAGS_ALL_TAGS_SUCCESS = exports.API_TAGS_ALL_TAGS_SUCCESS = 'API_TAGS_ALL_TAGS_SUCCESS';
	var API_TAGS_API_TAGS_REQUEST = exports.API_TAGS_API_TAGS_REQUEST = 'API_TAGS_API_TAGS_REQUEST';
	var API_TAGS_API_TAGS_SUCCESS = exports.API_TAGS_API_TAGS_SUCCESS = 'API_TAGS_API_TAGS_SUCCESS';
	var API_SWAGGER_SUCCESS = exports.API_SWAGGER_SUCCESS = 'API_SWAGGER_SUCCESS';
	var API_TAGS_CREATE_TAGS_SUCCESS = exports.API_TAGS_CREATE_TAGS_SUCCESS = 'API_TAGS_CREATE_TAGS_SUCCESS';
	var API_TAGS_ASSOCIATE_REQUEST = exports.API_TAGS_ASSOCIATE_REQUEST = 'API_TAGS_ASSOCIATE_REQUEST';
	var API_TAGS_ASSOCIATE_SUCCESS = exports.API_TAGS_ASSOCIATE_SUCCESS = 'API_TAGS_ASSOCIATE_SUCCESS';
	
	var API_USER_CONTEXTS = exports.API_USER_CONTEXTS = 'API_USER_CONTEXTS';
	
	var CHANGE = exports.CHANGE = 'CHANGE';
	var API_PROXY_LOADING = exports.API_PROXY_LOADING = 'API_PROXY_LOADING';
	var API_PROXY_RESET = exports.API_PROXY_RESET = 'API_PROXY_RESET';
	var API_PROXY_VALIDATE_UNIQUE_NAME_RESET = exports.API_PROXY_VALIDATE_UNIQUE_NAME_RESET = 'API_PROXY_VALIDATE_UNIQUE_NAME_RESET';
	var API_PROXY_VALIDATE_UNIQUE_NAME_SUCCESS = exports.API_PROXY_VALIDATE_UNIQUE_NAME_SUCCESS = 'API_PROXY_VALIDATE_UNIQUE_NAME_SUCCESS';
	var API_PROXY_VALIDATE_UNIQUE_NAME_ERROR = exports.API_PROXY_VALIDATE_UNIQUE_NAME_ERROR = 'API_PROXY_VALIDATE_UNIQUE_NAME_ERROR';
	var API_PROXY_SAVE_STATUS_RESET = exports.API_PROXY_SAVE_STATUS_RESET = 'API_PROXY_SAVE_STATUS_RESET';
	var API_PROXY_CREATE_SUCCESS = exports.API_PROXY_CREATE_SUCCESS = 'API_PROXY_CREATE_SUCCESS';
	var API_PROXY_CREATE_ERROR = exports.API_PROXY_CREATE_ERROR = 'API_PROXY_CREATE_ERROR';
	var API_PROXY_UPDATE_SUCCESS = exports.API_PROXY_UPDATE_SUCCESS = 'API_PROXY_UPDATE_SUCCESS';
	var API_PROXY_UPDATE_ERROR = exports.API_PROXY_UPDATE_ERROR = 'API_PROXY_UPDATE_ERROR';
	var API_PROXY_DELETE_SUCCESS = exports.API_PROXY_DELETE_SUCCESS = 'API_PROXY_DELETE_SUCCESS';
	var API_PROXY_DELETE_ERROR = exports.API_PROXY_DELETE_ERROR = 'API_PROXY_DELETE_ERROR';
	var API_PROXY_FETCH_DEPLOYMENT_TYPE_SUCCESS = exports.API_PROXY_FETCH_DEPLOYMENT_TYPE_SUCCESS = 'API_PROXY_FETCH_DEPLOYMENT_TYPE_SUCCESS';
	var API_PROXY_FETCH_DEPLOYMENT_TYPE_ERROR = exports.API_PROXY_FETCH_DEPLOYMENT_TYPE_ERROR = 'API_PROXY_FETCH_DEPLOYMENT_TYPE_ERROR';
	var API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_SUCCESS = exports.API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_SUCCESS = 'API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_SUCCESS';
	var API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_ERROR = exports.API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_ERROR = 'API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_ERROR';
	var API_PROXY_FETCH_ORGANIZATIONS_SUCCESS = exports.API_PROXY_FETCH_ORGANIZATIONS_SUCCESS = 'API_PROXY_FETCH_ORGANIZATIONS_SUCCESS';
	var API_PROXY_FETCH_ORGANIZATIONS_ERROR = exports.API_PROXY_FETCH_ORGANIZATIONS_ERROR = 'API_PROXY_FETCH_ORGANIZATIONS_ERROR';
	var API_PROXY_FETCH_SELECTED_ORGANIZATIONS_SUCCESS = exports.API_PROXY_FETCH_SELECTED_ORGANIZATIONS_SUCCESS = 'API_PROXY_FETCH_SELECTED_ORGANIZATIONS_SUCCESS';
	var API_PROXY_FETCH_SELECTED_ORGANIZATIONS_ERROR = exports.API_PROXY_FETCH_SELECTED_ORGANIZATIONS_ERROR = 'API_PROXY_FETCH_SELECTED_ORGANIZATIONS_ERROR';
	var API_PROXY_UPDATE_ORGS_SUCCESS = exports.API_PROXY_UPDATE_ORGS_SUCCESS = 'API_PROXY_UPDATE_ORGS_SUCCESS';
	var API_PROXY_UPDATE_ORGS_ERROR = exports.API_PROXY_UPDATE_ORGS_ERROR = 'API_PROXY_UPDATE_ORGS_ERROR';
	var API_PROXY_FETCH_DETAILS_SUCCESS = exports.API_PROXY_FETCH_DETAILS_SUCCESS = 'API_PROXY_FETCH_DETAILS_SUCCESS';
	var API_PROXY_FETCH_DETAILS_ERROR = exports.API_PROXY_FETCH_DETAILS_ERROR = 'API_PROXY_FETCH_DETAILS_ERROR';
	var FETCH_API_SYNC_FEATURE_FLAG_SUCCESS = exports.FETCH_API_SYNC_FEATURE_FLAG_SUCCESS = 'FETCH_API_SYNC_FEATURE_FLAG_SUCCESS';
	var FETCH_API_SYNC_FEATURE_FLAG_ERROR = exports.FETCH_API_SYNC_FEATURE_FLAG_ERROR = 'FETCH_API_SYNC_FEATURE_FLAG_ERROR';
	var FETCH_API_SYNC_COUNT_SUCCESS = exports.FETCH_API_SYNC_COUNT_SUCCESS = 'FETCH_API_SYNC_COUNT_SUCCESS';
	var FETCH_API_SYNC_COUNT_ERROR = exports.FETCH_API_SYNC_COUNT_ERROR = 'FETCH_API_SYNC_COUNT_ERROR';
	
	var FETCH_GATEWAYS_SUCCESS = exports.FETCH_GATEWAYS_SUCCESS = 'FETCH_GATEWAYS_SUCCESS';
	var FETCH_GATEWAYS_ERROR = exports.FETCH_GATEWAYS_ERROR = 'FETCH_GATEWAYS_ERROR';
	var FETCH_GATEWAY_DETAILS_SUCCESS = exports.FETCH_GATEWAY_DETAILS_SUCCESS = 'FETCH_GATEWAY_DETAILS_SUCCESS';
	var FETCH_GATEWAY_DETAILS_ERROR = exports.FETCH_GATEWAY_DETAILS_ERROR = 'FETCH_GATEWAY_DETAILS_ERROR';
	var FETCH_APIS_SUCCESS = exports.FETCH_APIS_SUCCESS = 'FETCH_APIS_SUCCESS';
	var FETCH_APIS_ERROR = exports.FETCH_APIS_ERROR = 'FETCH_APIS_ERROR';
	var FETCH_APPS_SUCCESS = exports.FETCH_APPS_SUCCESS = 'FETCH_APPS_SUCCESS';
	var FETCH_APPS_ERROR = exports.FETCH_APPS_ERROR = 'FETCH_APPS_ERROR';
	var FETCH_ACCOUNT_PLANS_SUCCESS = exports.FETCH_ACCOUNT_PLANS_SUCCESS = 'FETCH_ACCOUNT_PLANS_SUCCESS';
	var FETCH_ACCOUNT_PLANS_ERROR = exports.FETCH_ACCOUNT_PLANS_ERROR = 'FETCH_ACCOUNT_PLANS_ERROR';
	var FETCH_API_PLANS_SUCCESS = exports.FETCH_API_PLANS_SUCCESS = 'FETCH_API_PLANS_SUCCESS';
	var FETCH_API_PLANS_ERROR = exports.FETCH_API_PLANS_ERROR = 'FETCH_API_PLANS_ERROR';
	
	var NONE = exports.NONE = '';
	var SUCCESS = exports.SUCCESS = 'SUCCESS';
	var FAIL = exports.FAIL = 'FAIL';
	var RESET = exports.RESET = 'RESET';
	var CREATE_SUCCESS = exports.CREATE_SUCCESS = 'CREATE_SUCCESS';
	var CREATE_FAIL = exports.CREATE_FAIL = 'CREATE_FAIL';
	var UPDATE_SUCCESS = exports.UPDATE_SUCCESS = 'UPDATE_SUCCESS';
	var UPDATE_FAIL = exports.UPDATE_FAIL = 'UPDATE_FAIL';
	var ALERT_SUCCESS = exports.ALERT_SUCCESS = 'success';
	var ALERT_ERROR = exports.ALERT_ERROR = 'error';
	
	var PENDING_DEPLOYMENT = exports.PENDING_DEPLOYMENT = 'PENDING_DEPLOYMENT';
	
	var API_OWNER_TEXT = exports.API_OWNER_TEXT = 'API Owner';
	var DEVELOPER_TEXT = exports.DEVELOPER_TEXT = 'Organization Admin';
	var ORGANIZATION_ADMIN_TEXT = exports.ORGANIZATION_ADMIN_TEXT = 'Developer';
	
	var CUSTOM_FIELDS_GET_SUCCESS = exports.CUSTOM_FIELDS_GET_SUCCESS = 'CUSTOM_FIELDS_GET_SUCCESS';
	var POLICY_TEMPLATES_GET_SUCCESS = exports.POLICY_TEMPLATES_GET_SUCCESS = 'POLICY_TEMPLATES_GET_SUCCESS';
	
	var API_EULAS_SUCCESS = exports.API_EULAS_SUCCESS = 'API_EULAS_SUCCESS';
	var APPLICATION_API_GROUP_EULAS_GET_SUCCESS = exports.APPLICATION_API_GROUP_EULAS_GET_SUCCESS = 'APPLICATION_API_GROUP_EULAS_GET_SUCCESS';
	var API_NAME_UNIQUE_SUCCESS = exports.API_NAME_UNIQUE_SUCCESS = 'API_NAME_UNIQUE_SUCCESS';
	var API_PROXY_URL_UNIQUE_SUCCESS = exports.API_PROXY_URL_UNIQUE_SUCCESS = 'API_PROXY_URL_UNIQUE_SUCCESS';
	var API_GET_SUCCESS = exports.API_GET_SUCCESS = 'API_GET_SUCCESS';
	var API_SAVE_SUCCESS = exports.API_SAVE_SUCCESS = 'API_SAVE_SUCCESS';
	var API_UPDATE_SUCCESS = exports.API_UPDATE_SUCCESS = 'API_UPDATE_SUCCESS';
	var API_PUBLISH_SAVE_SUCCESS = exports.API_PUBLISH_SAVE_SUCCESS = 'API_PUBLISH_SAVE_SUCCESS';
	var API_ASSETS_GET_SUCCESS = exports.API_ASSETS_GET_SUCCESS = 'API_ASSETS_GET_SUCCESS';
	var API_USAGE_GET_SUCCESS = exports.API_USAGE_GET_SUCCESS = 'API_USAGE_GET_SUCCESS';
	var API_CUSTOM_FIELDS_GET_SUCCESS = exports.API_CUSTOM_FIELDS_GET_SUCCESS = 'API_CUSTOM_FIELDS_GET_SUCCESS';
	var API_CUSTOM_FIELDS_SAVE_SUCCESS = exports.API_CUSTOM_FIELDS_SAVE_SUCCESS = 'API_CUSTOM_FIELDS_SAVE_SUCCESS';
	var API_POLICY_TEMPLATES_GET_SUCCESS = exports.API_POLICY_TEMPLATES_GET_SUCCESS = 'API_POLICY_TEMPLATES_GET_SUCCESS';
	var API_POLICY_TEMPLATES_SAVE_SUCCESS = exports.API_POLICY_TEMPLATES_SAVE_SUCCESS = 'API_POLICY_TEMPLATES_SAVE_SUCCESS';
	
	var APPLICATION_LOADING = exports.APPLICATION_LOADING = 'APPLICATION_LOADING';
	var APPLICATION_ERROR = exports.APPLICATION_ERROR = 'APPLICATION_ERROR';
	
	var APPLICATION_GET_SUCCESS = exports.APPLICATION_GET_SUCCESS = 'APPLICATION_GET_SUCCESS';
	var APPLICATION_CREATE_SUCCESS = exports.APPLICATION_CREATE_SUCCESS = 'APPLICATION_CREATE_SUCCESS';
	var APPLICATION_UPDATE_SUCCESS = exports.APPLICATION_UPDATE_SUCCESS = 'APPLICATION_UPDATE_SUCCESS';
	var APPLICATION_UPDATE_AND_GET_SUCCESS = exports.APPLICATION_UPDATE_AND_GET_SUCCESS = 'APPLICATION_UPDATE_AND_GET_SUCCESS';
	var APPLICATION_SECRET_UPDATE_SUCCESS = exports.APPLICATION_SECRET_UPDATE_SUCCESS = 'APPLICATION_SECRET_UPDATE_SUCCESS';
	var APPLICATION_NAME_UNIQUE_SUCCESS = exports.APPLICATION_NAME_UNIQUE_SUCCESS = 'APPLICATION_NAME_UNIQUE_SUCCESS';
	var APPLICATION_ORGANIZATIONS_GET_SUCCESS = exports.APPLICATION_ORGANIZATIONS_GET_SUCCESS = 'APPLICATION_ORGANIZATIONS_GET_SUCCESS';
	var APPLICATION_CUSTOM_FIELDS_GET_SUCCESS = exports.APPLICATION_CUSTOM_FIELDS_GET_SUCCESS = 'APPLICATION_CUSTOM_FIELDS_GET_SUCCESS';
	var APPLICATION_SELECTED_APIS_GET_SUCCESS = exports.APPLICATION_SELECTED_APIS_GET_SUCCESS = 'APPLICATION_SELECTED_APIS_GET_SUCCESS';
	var APPLICATION_AVAILABLE_APIS_GET_SUCCESS = exports.APPLICATION_AVAILABLE_APIS_GET_SUCCESS = 'APPLICATION_AVAILABLE_APIS_GET_SUCCESS';
	var APPLICATION_AVAILABLE_APPS_GET_SUCCESS = exports.APPLICATION_AVAILABLE_APPS_GET_SUCCESS = 'APPLICATION_AVAILABLE_APPS_GET_SUCCESS';
	var APPLICATION_AVAILABLE_ORGS_GET_SUCCESS = exports.APPLICATION_AVAILABLE_ORGS_GET_SUCCESS = 'APPLICATION_AVAILABLE_ORGS_GET_SUCCESS';
	var APPLICATION_API_EULA_GET_SUCCESS = exports.APPLICATION_API_EULA_GET_SUCCESS = 'APPLICATION_API_EULA_GET_SUCCESS';
	var APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS = exports.APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS = 'APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS';
	var APPLICATION_GENERATE_SECRET_GET_SUCCESS = exports.APPLICATION_GENERATE_SECRET_GET_SUCCESS = 'APPLICATION_GENERATE_SECRET_GET_SUCCESS';
	var APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS = exports.APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS = 'APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS';
	var APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS = exports.APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS = 'APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS';
	var TENANT_INFO_GET_SUCCESS = exports.TENANT_INFO_GET_SUCCESS = 'TENANT_INFO_GET_SUCCESS';
	var APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB = exports.APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB = '********';
	
	var PROXIES_GET_SUCCESS = exports.PROXIES_GET_SUCCESS = 'PROXIES_GET_SUCCESS';
	var PROXIES_ERROR = exports.PROXIES_ERROR = 'PROXIES_ERROR';
	
	var API_KEY_STATUS_DISABLED = exports.API_KEY_STATUS_DISABLED = 'DISABLED';
	var API_KEY_STATUS_ENABLED = exports.API_KEY_STATUS_ENABLED = 'ENABLED';
	var API_KEY_PROXIES_GET_SUCCESS = exports.API_KEY_PROXIES_GET_SUCCESS = 'API_KEY_PROXIES_GET_SUCCESS';
	var API_KEY_PROXIES_GET_ERROR = exports.API_KEY_PROXIES_GET_ERROR = 'API_KEY_PROXIES_GET_ERROR';
	var API_KEY_DEPLOY_SUCCESS = exports.API_KEY_DEPLOY_SUCCESS = 'API_KEY_DEPLOY_SUCCESS';
	var API_KEY_DEPLOY_ERROR = exports.API_KEY_DEPLOY_ERROR = 'API_KEY_DEPLOY_ERROR';
	var API_KEY_REDEPLOY_SUCCESS = exports.API_KEY_REDEPLOY_SUCCESS = 'API_KEY_REDEPLOY_SUCCESS';
	var API_KEY_REDEPLOY_ERROR = exports.API_KEY_REDEPLOY_ERROR = 'API_KEY_REDEPLOY_ERROR';
	var API_KEY_UNDEPLOY_SUCCESS = exports.API_KEY_UNDEPLOY_SUCCESS = 'API_KEY_UNDEPLOY_SUCCESS';
	var API_KEY_UNDEPLOY_ERROR = exports.API_KEY_UNDEPLOY_ERROR = 'API_KEY_UNDEPLOY_ERROR';
	
	var APPLICATION_ALL_KEYS_GET_SUCCESS = exports.APPLICATION_ALL_KEYS_GET_SUCCESS = 'APPLICATION_ALL_KEYS_GET_SUCCESS';
	var APPLICATION_ALL_KEYS_GET_ERROR = exports.APPLICATION_ALL_KEYS_GET_ERROR = 'APPLICATION_ALL_KEYS_GET_ERROR';
	var APPLICATION_ALL_KEYS_COUNT_GET_SUCCESS = exports.APPLICATION_ALL_KEYS_COUNT_GET_SUCCESS = 'APPLICATION_ALL_KEYS_COUNT_GET_SUCCESS';
	var APPLICATION_ALL_KEYS_COUNT_GET_ERROR = exports.APPLICATION_ALL_KEYS_COUNT_GET_ERROR = 'APPLICATION_ALL_KEYS_COUNT_GET_ERROR';
	var KEY_NAME_UNIQUE_SUCCESS = exports.KEY_NAME_UNIQUE_SUCCESS = 'KEY_NAME_UNIQUE_SUCCESS';
	var KEY_NAME_UNIQUE_ERROR = exports.KEY_NAME_UNIQUE_ERROR = 'KEY_NAME_UNIQUE_ERROR';
	var KEY_STATUS_RESET = exports.KEY_STATUS_RESET = 'KEY_STATUS_RESET';
	var KEY_CREATE_SUCCESS = exports.KEY_CREATE_SUCCESS = 'KEY_CREATE_SUCCESS';
	var KEY_CREATE_ERROR = exports.KEY_CREATE_ERROR = 'KEY_CREATE_ERROR';
	var KEY_UPDATE_SUCCESS = exports.KEY_UPDATE_SUCCESS = 'KEY_UPDATE_SUCCESS';
	var KEY_UPDATE_ERROR = exports.KEY_UPDATE_ERROR = 'KEY_UPDATE_ERROR';
	var KEY_DELETE_SUCCESS = exports.KEY_DELETE_SUCCESS = 'KEY_DELETE_SUCCESS';
	var KEY_DELETE_ERROR = exports.KEY_DELETE_ERROR = 'KEY_DELETE_ERROR';
	var APPLICATION_SINGLE_GET_SUCCESS = exports.APPLICATION_SINGLE_GET_SUCCESS = 'APPLICATION_SINGLE_GET_SUCCESS';
	var APPLICATION_API_PLANS_GET_SUCCESS = exports.APPLICATION_API_PLANS_GET_SUCCESS = 'APPLICATION_API_PLANS_GET_SUCCESS';
	var APPLICATION_DELETE_RESET = exports.APPLICATION_DELETE_RESET = 'APPLICATION_DELETE_RESET';
	var APPLICATION_DELETE_SUCCESS = exports.APPLICATION_DELETE_SUCCESS = 'APPLICATION_DELETE_SUCCESS';
	var APPLICATION_DELETE_ERROR = exports.APPLICATION_DELETE_ERROR = 'APPLICATION_DELETE_ERROR';
	var APPLICATION_STATUS_UPDATE_RESET = exports.APPLICATION_STATUS_UPDATE_RESET = 'APPLICATION_STATUS_UPDATE_RESET';
	var APPLICATION_STATUS_UPDATE_SUCCESS = exports.APPLICATION_STATUS_UPDATE_SUCCESS = 'APPLICATION_STATUS_UPDATE_SUCCESS';
	var APPLICATION_STATUS_UPDATE_ERROR = exports.APPLICATION_STATUS_UPDATE_ERROR = 'APPLICATION_STATUS_UPDATE_ERROR';
	
	var TYPE_API = exports.TYPE_API = 'TYPE_API';
	var TYPE_API_GROUP = exports.TYPE_API_GROUP = 'TYPE_API_GROUP';
	
	var API_STATUS_DISABLED = exports.API_STATUS_DISABLED = 'DISABLED';
	var API_STATUS_ENABLED = exports.API_STATUS_ENABLED = 'ENABLED';
	var API_STATUS_NEW = exports.API_STATUS_NEW = 'NEW';
	var API_STATUS_DEPRECATED = exports.API_STATUS_DEPRECATED = 'DEPRECATED';
	var API_STATUS_INCOMPLETE = exports.API_STATUS_INCOMPLETE = 'INCOMPLETE';
	var API_STATUS_PENDING_BUNDLE = exports.API_STATUS_PENDING_BUNDLE = 'PENDING_BUNDLE';
	
	var APPLICATION_STATUS_ENABLED = exports.APPLICATION_STATUS_ENABLED = 'ENABLED';
	var APPLICATION_STATUS_DISABLED = exports.APPLICATION_STATUS_DISABLED = 'DISABLED';
	var APPLICATION_STATUS_PENDING_APPROVAL = exports.APPLICATION_STATUS_PENDING_APPROVAL = 'APPLICATION_PENDING_APPROVAL';
	var APPLICATION_STATUS_EDIT_PENDING_APPROVAL = exports.APPLICATION_STATUS_EDIT_PENDING_APPROVAL = 'EDIT_APPLICATION_PENDING_APPROVAL';
	var APPLICATION_STATUS_REJECTED = exports.APPLICATION_STATUS_REJECTED = 'REJECTED';
	
	var APPLICATION_DISABLED_BY_TYPE_EXTERNAL = exports.APPLICATION_DISABLED_BY_TYPE_EXTERNAL = 'EXTERNAL';
	
	var DASHBOARD_AUTOSUGGEST_SHOW_SUCCESS = exports.DASHBOARD_AUTOSUGGEST_SHOW_SUCCESS = 'DASHBOARD_AUTOSUGGEST_SHOW_SUCCESS';
	var DASHBOARD_AUTOSUGGEST_SHOW_ERROR = exports.DASHBOARD_AUTOSUGGEST_SHOW_ERROR = 'DASHBOARD_AUTOSUGGEST_SHOW_ERROR';
	var DASHBOARD_GET_ENTITY_COUNT_SUCCESS = exports.DASHBOARD_GET_ENTITY_COUNT_SUCCESS = 'DASHBOARD_GET_ENTITY_COUNT_SUCCESS';
	var DASHBOARD_GET_ENTITY_COUNT_ERROR = exports.DASHBOARD_GET_ENTITY_COUNT_ERROR = 'DASHBOARD_GET_ENTITY_COUNT_ERROR';
	var DASHBOARD_CHART_DATA_SUCCESS = exports.DASHBOARD_CHART_DATA_SUCCESS = 'DASHBOARD_CHART_DATA_SUCCESS';
	var DASHBOARD_CHART_DATA_ERROR = exports.DASHBOARD_CHART_DATA_ERROR = 'DASHBOARD_CHART_DATA_ERROR';
	
	var DEPLOYMENT_STATUS_DEPLOYED = exports.DEPLOYMENT_STATUS_DEPLOYED = 'DEPLOYED';
	var DEPLOYMENT_STATUS_PENDING_DEPLOYMENT = exports.DEPLOYMENT_STATUS_PENDING_DEPLOYMENT = 'PENDING_DEPLOYMENT';
	var DEPLOYMENT_STATUS_PENDING_UNDEPLOYMENT = exports.DEPLOYMENT_STATUS_PENDING_UNDEPLOYMENT = 'PENDING_UNDEPLOYMENT';
	var DEPLOYMENT_STATUS_ERROR = exports.DEPLOYMENT_STATUS_ERROR = 'ERROR';
	var DEPLOYMENT_STATUS_ERROR_UNDEPLOY = exports.DEPLOYMENT_STATUS_ERROR_UNDEPLOY = 'ERROR_UNDEPLOY';
	var DEPLOYMENT_STATUS_NOT_DEPLOYED = exports.DEPLOYMENT_STATUS_NOT_DEPLOYED = 'NOT_DEPLOYED';
	
	/** Applications */
	var HELP_ITEMS = exports.HELP_ITEMS = {
	  details: {
	    title: 'How do I Publish an Application?',
	    descriptions: '',
	    subItems: [{
	      id: 0,
	      title: '',
	      descriptions: 'On the Details tab, select the organization (if you are a Global Publisher) and enter a name and description. Note: If you are an Org User, the org for the application will be the org that you belong to.'
	    }, {
	      id: 1,
	      title: '',
	      descriptions: 'On the API Management tab, add APIs.'
	    }, {
	      id: 2,
	      title: '',
	      descriptions: 'On the Authentication tab, if any of the added APIs use OAuth, specify the callback/redirect URL and scope. Set the type to public or confidential.'
	    }, {
	      id: 3,
	      title: '',
	      descriptions: 'On the Key tab, you can view the API Key and Shared Secret and you can generate a new plain or hashed secret.'
	    }, {
	      id: 4,
	      title: '',
	      descriptions: 'You can add multiple API keys to your application. First, add your application. This generates the default API key for the application. To add other API keys, edit your application.'
	    }]
	  }
	};
	
	var MULTIKEY_HELP_ITEMS = exports.MULTIKEY_HELP_ITEMS = {
	  details: {
	    title: 'How do I publish an Application?',
	    descriptions: '',
	    subItems: [{
	      id: 0,
	      title: '',
	      descriptions: 'On the Details tab, select the organization (if you are a Global Publisher) and enter a name and description. Note: If you are an Org User, the org for the application will be the org that you belong to.'
	    }, {
	      id: 1,
	      title: '',
	      descriptions: 'On the API Management tab, add APIs.'
	    }, {
	      id: 2,
	      title: '',
	      descriptions: 'On the Authentication & Keys tab, manage the API keys for the application. API Portal auto-generates an API key, a shared secret, and the other settings that you defined for the application when a user adds an application to API Portal. This is the default API key for the application. You can add more keys to the application.'
	    }]
	  }
	};
	
	/** Gateway Bundles */
	
	var GATEWAY_BUNDLES_LIST_SORT_BY = exports.GATEWAY_BUNDLES_LIST_SORT_BY = [{
	  uuid: 'createTs,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.sort.by.date.created.desc')
	}, {
	  uuid: 'createTs,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.sort.by.date.created.asc')
	}, {
	  uuid: 'name,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.name.asc')
	}, {
	  uuid: 'name,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.name.desc')
	}];
	
	var GATEWAY_BUNDLES_LIST_TYPE_BY = exports.GATEWAY_BUNDLES_LIST_TYPE_BY = [{
	  uuid: 'any',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.type.by.any.bundle.types')
	}, {
	  uuid: 'ALL',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.type.by.all.bundle.types')
	}, {
	  uuid: 'ENCAPSULATED_ASSERTION',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.type.by.encapsulated.assertion')
	}, {
	  uuid: 'ENVIRONMENT',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.type.by.environment')
	}];
	
	var GATEWAY_BUNDLES_LIST_PORTAL_TEMPLATE_BY = exports.GATEWAY_BUNDLES_LIST_PORTAL_TEMPLATE_BY = [{
	  uuid: 'any',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.policy.template.by.any')
	}, {
	  uuid: 'true',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.policy.template.by.true')
	}, {
	  uuid: 'false',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.list.page.policy.template.by.false')
	}];
	
	var GATEWAY_BUNDLES_API_SORT_BY = exports.GATEWAY_BUNDLES_API_SORT_BY = [{
	  uuid: 'apiModifyTs,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.page.sort.by.date.modified.desc')
	}, {
	  uuid: 'apiModifyTs,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.page.sort.by.date.modified.asc')
	}, {
	  uuid: 'apiName,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.api.name.asc')
	}, {
	  uuid: 'apiName,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.api.name.desc')
	}];
	
	var GATEWAY_BUNDLES_API_STATES_FILTER_BY = exports.GATEWAY_BUNDLES_API_STATES_FILTER_BY = [{
	  uuid: 'all',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.states.all')
	}, {
	  uuid: 'Enabled',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.states.enabled')
	}, {
	  uuid: 'Disabled',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.states.disabled')
	}, {
	  uuid: 'Deprecated',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.states.deprecated')
	}, {
	  uuid: 'New',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.states.unpublished')
	}];
	
	var GATEWAY_BUNDLES_DETAILS_SUCCESS = exports.GATEWAY_BUNDLES_DETAILS_SUCCESS = 'GATEWAY_BUNDLES_DETAILS_SUCCESS';
	var GATEWAY_BUNDLES_DETAILS_ERROR = exports.GATEWAY_BUNDLES_DETAILS_ERROR = 'GATEWAY_BUNDLES_DETAILS_ERROR';
	var GATEWAY_BUNDLES_GET_SUCCESS = exports.GATEWAY_BUNDLES_GET_SUCCESS = 'GATEWAY_BUNDLES_GET_SUCCESS';
	var GATEWAY_BUNDLES_GET_ERROR = exports.GATEWAY_BUNDLES_GET_ERROR = 'GATEWAY_BUNDLES_GET_ERROR';
	var GATEWAY_BUNDLES_SAVE_SUCCESS = exports.GATEWAY_BUNDLES_SAVE_SUCCESS = 'GATEWAY_BUNDLES_SAVE_SUCCESS';
	var GATEWAY_BUNDLES_SAVE_ERROR = exports.GATEWAY_BUNDLES_SAVE_ERROR = 'GATEWAY_BUNDLES_SAVE_ERROR';
	var GATEWAY_BUNDLES_GET_USAGE_SUCCESS = exports.GATEWAY_BUNDLES_GET_USAGE_SUCCESS = 'GATEWAY_BUNDLES_GET_USAGE_SUCCESS';
	var GATEWAY_BUNDLES_GET_USAGE_ERROR = exports.GATEWAY_BUNDLES_GET_USAGE_ERROR = 'GATEWAY_BUNDLES_GET_USAGE_ERROR';
	
	var GATEWAY_BUNDLES_DELETE_SUCCESS = exports.GATEWAY_BUNDLES_DELETE_SUCCESS = 'GATEWAY_BUNDLES_DELETE_SUCCESS';
	var GATEWAY_BUNDLES_DELETE_ERROR = exports.GATEWAY_BUNDLES_DELETE_ERROR = 'GATEWAY_BUNDLES_DELETE_ERROR';
	
	var GATEWAY_BUNDLES_GET_PROXY_SUCCESS = exports.GATEWAY_BUNDLES_GET_PROXY_SUCCESS = 'GATEWAY_BUNDLES_GET_PROXY_SUCCESS';
	var GATEWAY_BUNDLES_GET_PROXY_ERROR = exports.GATEWAY_BUNDLES_GET_PROXY_ERROR = 'GATEWAY_BUNDLES_GET_PROXY_ERROR';
	var GATEWAY_BUNDLES_GET_PROXY_LIST_SUCCESS = exports.GATEWAY_BUNDLES_GET_PROXY_LIST_SUCCESS = 'GATEWAY_BUNDLES_GET_PROXY_LIST_SUCCESS';
	var GATEWAY_BUNDLES_GET_PROXY_LIST_ERROR = exports.GATEWAY_BUNDLES_GET_PROXY_LIST_ERROR = 'GATEWAY_BUNDLES_GET_PROXY_LIST_ERROR';
	
	var GATEWAY_BUNDLES_GET_APIS_SUCCESS = exports.GATEWAY_BUNDLES_GET_APIS_SUCCESS = 'GATEWAY_BUNDLES_GET_APIS_SUCCESS';
	var GATEWAY_BUNDLES_GET_APIS_ERROR = exports.GATEWAY_BUNDLES_GET_APIS_ERROR = 'GATEWAY_BUNDLES_GET_APIS_ERROR';
	
	var GATEWAY_BUNDLES_DEPLOY_PROXY_SUCCESS = exports.GATEWAY_BUNDLES_DEPLOY_PROXY_SUCCESS = 'GATEWAY_BUNDLES_DEPLOY_PROXY_SUCCESS';
	var GATEWAY_BUNDLES_REDEPLOY_PROXY_SUCCESS = exports.GATEWAY_BUNDLES_REDEPLOY_PROXY_SUCCESS = 'GATEWAY_BUNDLES_REDEPLOY_PROXY_SUCCESS';
	var GATEWAY_BUNDLES_UNDEPLOY_PROXY_SUCCESS = exports.GATEWAY_BUNDLES_UNDEPLOY_PROXY_SUCCESS = 'GATEWAY_BUNDLES_UNDEPLOY_PROXY_SUCCESS';
	var GATEWAY_BUNDLES_DEPLOY_PROXY_ERROR = exports.GATEWAY_BUNDLES_DEPLOY_PROXY_ERROR = 'GATEWAY_BUNDLES_DEPLOY_PROXY_ERROR';
	var GATEWAY_BUNDLES_UNDEPLOY_PROXY_ERROR = exports.GATEWAY_BUNDLES_UNDEPLOY_PROXY_ERROR = 'GATEWAY_BUNDLES_UNDEPLOY_PROXY_ERROR';
	var GATEWAY_BUNDLES_REDEPLOY_PROXY_ERROR = exports.GATEWAY_BUNDLES_REDEPLOY_PROXY_ERROR = 'GATEWAY_BUNDLES_REDEPLOY_PROXY_ERROR';
	var GATEWAY_BUNDLES_DELETE_RESET = exports.GATEWAY_BUNDLES_DELETE_RESET = 'GATEWAY_BUNDLES_DELETE_RESET';
	var GATEWAY_BUNDLES_ENCAPSULATED_ASSERTION = exports.GATEWAY_BUNDLES_ENCAPSULATED_ASSERTION = 'ENCAPSULATED_ASSERTION';
	
	/* Organizations */
	var ORGANIZATION_STATUS_ENABLED = exports.ORGANIZATION_STATUS_ENABLED = 'ENABLED';
	
	var ORGANIZATIONS_GET_SUCCESS = exports.ORGANIZATIONS_GET_SUCCESS = 'ORGANIZATIONS_GET_SUCCESS';
	var ORGANIZATIONS_GET_ERROR = exports.ORGANIZATIONS_GET_ERROR = 'ORGANIZATIONS_GET_ERROR';
	var ORGANIZATION_LIST_GET_SUCCESS = exports.ORGANIZATION_LIST_GET_SUCCESS = 'ORGANIZATION_LIST_GET_SUCCESS';
	var ORGANIZATION_LIST_GET_ERROR = exports.ORGANIZATION_LIST_GET_ERROR = 'ORGANIZATION_LIST_GET_ERROR';
	var ORGANIZATION_GET_REQUEST = exports.ORGANIZATION_GET_REQUEST = 'ORGANIZATION_GET_REQUEST';
	var ORGANIZATION_GET_SUCCESS = exports.ORGANIZATION_GET_SUCCESS = 'ORGANIZATION_GET_SUCCESS';
	var ORGANIZATION_GET_ERROR = exports.ORGANIZATION_GET_ERROR = 'ORGANIZATION_GET_ERROR';
	var ACCOUNTPLANS_GET_REQUEST = exports.ACCOUNTPLANS_GET_REQUEST = 'ACCOUNTPLANS_GET_REQUEST';
	var ACCOUNTPLANS_GET_SUCCESS = exports.ACCOUNTPLANS_GET_SUCCESS = 'ACCOUNTPLANS_GET_SUCCESS';
	var ACCOUNTPLANS_GET_ERROR = exports.ACCOUNTPLANS_GET_ERROR = 'ACCOUNTPLANS_GET_ERROR';
	var ORGANIZATION_NAME_UNIQUE_REQUEST = exports.ORGANIZATION_NAME_UNIQUE_REQUEST = 'ORGANIZATION_NAME_UNIQUE_REQUEST';
	var ORGANIZATION_NAME_UNIQUE_SUCCESS = exports.ORGANIZATION_NAME_UNIQUE_SUCCESS = 'ORGANIZATION_NAME_UNIQUE_SUCCESS';
	var ORGANIZATION_NAME_UNIQUE_ERROR = exports.ORGANIZATION_NAME_UNIQUE_ERROR = 'ORGANIZATION_NAME_UNIQUE_ERROR';
	var ORGANIZATION_CREATE_REQUEST = exports.ORGANIZATION_CREATE_REQUEST = 'ORGANIZATION_CREATE_REQUEST';
	var ORGANIZATION_CREATE_SUCCESS = exports.ORGANIZATION_CREATE_SUCCESS = 'ORGANIZATION_CREATE_SUCCESS';
	var ORGANIZATION_CREATE_ERROR = exports.ORGANIZATION_CREATE_ERROR = 'ORGANIZATION_CREATE_ERROR';
	var ORGANIZATION_UPDATE_REQUEST = exports.ORGANIZATION_UPDATE_REQUEST = 'ORGANIZATION_UPDATE_REQUEST';
	var ORGANIZATION_UPDATE_SUCCESS = exports.ORGANIZATION_UPDATE_SUCCESS = 'ORGANIZATION_UPDATE_SUCCESS';
	var ORGANIZATION_UPDATE_ERROR = exports.ORGANIZATION_UPDATE_ERROR = 'ORGANIZATION_UPDATE_ERROR';
	var ORGANIZATION_TYPE_PUBLISHER = exports.ORGANIZATION_TYPE_PUBLISHER = 'PUBLISHER';
	var ORGANIZATION_TYPE_CONSUMER = exports.ORGANIZATION_TYPE_CONSUMER = 'CONSUMER';
	
	var ORGANIZATION_LIST_TYPE_BY = exports.ORGANIZATION_LIST_TYPE_BY = [{
	  uuid: 'any',
	  text: (0, _intl.getI18nFormattedMessage)('label.organization.list.page.filter.by.all.types')
	}, {
	  uuid: 'PUBLISHER',
	  text: (0, _intl.getI18nFormattedMessage)('label.organization.list.page.filter.by.publisher.types')
	}, {
	  uuid: 'CONSUMER',
	  text: (0, _intl.getI18nFormattedMessage)('label.organization.list.page.filter.by.consumer.types')
	}];
	
	/** Users */
	var ROLE_PORTAL_ADMIN_UUID = exports.ROLE_PORTAL_ADMIN_UUID = '00000001-0001-0001-0001-000000000001';
	var ROLE_PORTAL_ADMIN = exports.ROLE_PORTAL_ADMIN = 'portaladministrators';
	var ROLE_API_OWNER_UUID = exports.ROLE_API_OWNER_UUID = '00000004-0004-0004-0004-000000000004';
	var ROLE_API_OWNER = exports.ROLE_API_OWNER = 'apiowners';
	var ROLE_ORG_ADMIN_UUID = exports.ROLE_ORG_ADMIN_UUID = '00000005-0005-0005-0005-000000000005';
	var ROLE_ORG_ADMIN = exports.ROLE_ORG_ADMIN = 'devorgadministrators';
	var ROLE_DEVELOPER_UUID = exports.ROLE_DEVELOPER_UUID = '00000006-0006-0006-0006-000000000006';
	var ROLE_DEVELOPER = exports.ROLE_DEVELOPER = 'developers';
	var ROLE_ORG_PUBLISHER_UUID = exports.ROLE_ORG_PUBLISHER_UUID = '00000009-0009-0009-0009-000000000009';
	var ROLE_ORG_PUBLISHER = exports.ROLE_ORG_PUBLISHER = 'orgpublishers';
	
	var USER_LIST_ROLE = exports.USER_LIST_ROLE = (_USER_LIST_ROLE = {}, _defineProperty(_USER_LIST_ROLE, ROLE_PORTAL_ADMIN_UUID, 'label.user.role.' + ROLE_PORTAL_ADMIN), _defineProperty(_USER_LIST_ROLE, ROLE_API_OWNER_UUID, 'label.user.role.' + ROLE_API_OWNER), _defineProperty(_USER_LIST_ROLE, ROLE_ORG_ADMIN_UUID, 'label.user.role.' + ROLE_ORG_ADMIN), _defineProperty(_USER_LIST_ROLE, ROLE_ORG_PUBLISHER_UUID, 'label.user.role.' + ROLE_ORG_PUBLISHER), _defineProperty(_USER_LIST_ROLE, ROLE_DEVELOPER_UUID, 'label.user.role.' + ROLE_DEVELOPER), _USER_LIST_ROLE);
	
	var USER_STATUS_ENABLED = exports.USER_STATUS_ENABLED = 'ENABLED';
	var USER_STATUS_DISABLED = exports.USER_STATUS_DISABLED = 'DISABLED';
	var USER_STATUS_LOCKED = exports.USER_STATUS_LOCKED = 'LOCKED';
	var USER_STATUS_REGISTRATION_INIT = exports.USER_STATUS_REGISTRATION_INIT = 'REGISTRATION_INIT';
	var USER_STATUS_REGISTRATION_PENDING_APPROVAL = exports.USER_STATUS_REGISTRATION_PENDING_APPROVAL = 'REGISTRATION_PENDING_APPROVAL';
	
	var USER_STATUS_LABEL = exports.USER_STATUS_LABEL = (_USER_STATUS_LABEL = {}, _defineProperty(_USER_STATUS_LABEL, USER_STATUS_ENABLED, (0, _intl.getI18nFormattedMessage)('label.user.status.enabled')), _defineProperty(_USER_STATUS_LABEL, USER_STATUS_DISABLED, (0, _intl.getI18nFormattedMessage)('label.user.status.disabled')), _defineProperty(_USER_STATUS_LABEL, USER_STATUS_LOCKED, (0, _intl.getI18nFormattedMessage)('label.user.status.locked')), _defineProperty(_USER_STATUS_LABEL, USER_STATUS_REGISTRATION_INIT, (0, _intl.getI18nFormattedMessage)('label.user.status.registration.init')), _defineProperty(_USER_STATUS_LABEL, USER_STATUS_REGISTRATION_PENDING_APPROVAL, (0, _intl.getI18nFormattedMessage)('label.user.status.registration.pending.approval')), _USER_STATUS_LABEL);
	
	var USER_LIST_STATUS_FILTER_BY = exports.USER_LIST_STATUS_FILTER_BY = [{
	  uuid: ALL,
	  text: (0, _intl.getI18nFormattedMessage)('label.user.list.page.status.by.all.statuses')
	}, {
	  uuid: USER_STATUS_ENABLED,
	  text: USER_STATUS_LABEL[USER_STATUS_ENABLED]
	}, {
	  uuid: USER_STATUS_DISABLED,
	  text: USER_STATUS_LABEL[USER_STATUS_DISABLED]
	}, {
	  uuid: USER_STATUS_LOCKED,
	  text: USER_STATUS_LABEL[USER_STATUS_LOCKED]
	}, {
	  uuid: USER_STATUS_REGISTRATION_INIT,
	  text: USER_STATUS_LABEL[USER_STATUS_REGISTRATION_INIT]
	}, {
	  uuid: USER_STATUS_REGISTRATION_PENDING_APPROVAL,
	  text: USER_STATUS_LABEL[USER_STATUS_REGISTRATION_PENDING_APPROVAL]
	}];
	
	var USER_LIST_SORT_BY = exports.USER_LIST_SORT_BY = [{
	  uuid: 'username,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.name.asc')
	}, {
	  uuid: 'username,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.name.desc')
	}, {
	  uuid: 'status,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.status.asc')
	}, {
	  uuid: 'status,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.status.desc')
	}];
	
	var USERS_GET_SUCCESS = exports.USERS_GET_SUCCESS = 'USERS_GET_SUCCESS';
	var USERS_GET_ERROR = exports.USERS_GET_ERROR = 'USERS_GET_ERROR';
	var USERS_DELETE_RESET = exports.USERS_DELETE_RESET = 'USERS_DELETE_RESET';
	
	/** Proxies **/
	var PROXY_DEPLOYMENT_TYPE_AUTOMATIC = exports.PROXY_DEPLOYMENT_TYPE_AUTOMATIC = 'AUTOMATIC';
	var PROXY_DEPLOYMENT_TYPE_ON_DEMAND = exports.PROXY_DEPLOYMENT_TYPE_ON_DEMAND = 'ON_DEMAND';
	var PROXY_DEPLOYMENT_TYPE_SCRIPTED = exports.PROXY_DEPLOYMENT_TYPE_SCRIPTED = 'MANUAL';
	
	var PROXY_GET_SUCCESS = exports.PROXY_GET_SUCCESS = 'PROXY_GET_SUCCESS';
	var PROXY_GET_ERROR = exports.PROXY_GET_ERROR = 'PROXY_GET_ERROR';
	var PROXY_DELETE_SUCCESS = exports.PROXY_DELETE_SUCCESS = 'PROXY_DELETE_SUCCESS';
	var PROXY_DELETE_ERROR = exports.PROXY_DELETE_ERROR = 'PROXY_DELETE_ERROR';
	var PROXY_DETAILS_GET_SUCCESS = exports.PROXY_DETAILS_GET_SUCCESS = 'PROXY_DETAILS_GET_SUCCESS';
	var PROXY_DETAILS_GET_ERROR = exports.PROXY_DETAILS_GET_ERROR = 'PROXY_DETAILS_GET_ERROR';
	var PROXY_GATEWAY_GET_REQUEST = exports.PROXY_GATEWAY_GET_REQUEST = 'PROXY_GATEWAY_GET_REQUEST';
	var PROXY_GATEWAY_GET_SUCCESS = exports.PROXY_GATEWAY_GET_SUCCESS = 'PROXY_GATEWAY_GET_SUCCESS';
	var PROXY_GATEWAY_GET_ERROR = exports.PROXY_GATEWAY_GET_ERROR = 'PROXY_GATEWAY_GET_ERROR';
	var PROXY_APIS_GET_REQUEST = exports.PROXY_APIS_GET_REQUEST = 'PROXY_APIS_GET_REQUEST';
	var PROXY_APIS_GET_SUCCESS = exports.PROXY_APIS_GET_SUCCESS = 'PROXY_APIS_GET_SUCCESS';
	var PROXY_APIS_GET_ERROR = exports.PROXY_APIS_GET_ERROR = 'PROXY_APIS_GET_ERROR';
	var PROXY_ORGANIZATIONS_GET_SUCCESS = exports.PROXY_ORGANIZATIONS_GET_SUCCESS = 'PROXY_ORGANIZATIONS_GET_SUCCESS';
	var PROXY_ORGANIZATIONS_GET_ERROR = exports.PROXY_ORGANIZATIONS_GET_ERROR = 'PROXY_ORGANIZATIONS_GET_ERROR';
	var PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS = exports.PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS = 'PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS';
	var PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR = exports.PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR = 'PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR';
	var PROXY_APIS_LIST_GET_SUCCESS = exports.PROXY_APIS_LIST_GET_SUCCESS = 'PROXY_APIS_LIST_GET_SUCCESS';
	var PROXY_APIS_LIST_GET_ERROR = exports.PROXY_APIS_LIST_GET_ERROR = 'PROXY_APIS_LIST_GET_ERROR';
	var PROXY_APIS_KEYS_LIST_GET_SUCCESS = exports.PROXY_APIS_KEYS_LIST_GET_SUCCESS = 'PROXY_APIS_KEYS_LIST_GET_SUCCESS';
	var PROXY_APIS_KEYS_LIST_GET_ERROR = exports.PROXY_APIS_KEYS_LIST_GET_ERROR = 'PROXY_APIS_KEYS_LIST_GET_ERROR';
	var PROXY_APIS_KEYS_COUNT_GET_SUCCESS = exports.PROXY_APIS_KEYS_COUNT_GET_SUCCESS = 'PROXY_APIS_KEYS_COUNT_GET_SUCCESS';
	var PROXY_APIS_KEYS_COUNT_GET_ERROR = exports.PROXY_APIS_KEYS_COUNT_GET_ERROR = 'PROXY_APIS_KEYS_COUNT_GET_ERROR';
	
	var PROXY_ENROLMENT_STATUS_ACTIVE = exports.PROXY_ENROLMENT_STATUS_ACTIVE = 'ACTIVE';
	var PROXY_ENROLMENT_STATUS_PENDING = exports.PROXY_ENROLMENT_STATUS_PENDING = 'PENDING';
	
	var PROXY_CONNECTED = exports.PROXY_CONNECTED = 'PROXY_CONNECTED';
	var PROXY_DISCONNECTED = exports.PROXY_DISCONNECTED = 'PROXY_DISCONNECTED';
	
	var BULK_DEPLOYMENT_STATUS_DONE = exports.BULK_DEPLOYMENT_STATUS_DONE = 'DONE';
	var BULK_DEPLOYMENT_STATUS_RUNNING = exports.BULK_DEPLOYMENT_STATUS_RUNNING = 'RUNNING';
	
	var PROXY_DEPLOYEMT_AUTOMATIC = exports.PROXY_DEPLOYEMT_AUTOMATIC = 'AUTOMATIC';
	
	var PROXY_DETAILS_URL = exports.PROXY_DETAILS_URL = '/publish/api-proxy/details/';
	
	var PROXY_ENROLLMENT_HELP_ITEMS = exports.PROXY_ENROLLMENT_HELP_ITEMS = {
	  title: 'Help',
	  subItems: [{
	    id: 0,
	    title: '',
	    descriptions: 'For more information, refer to Integrate On-Premise API Proxies > Enroll the On-Premise API Proxy Cluster step in the documentation.'
	  }, {
	    id: 1,
	    title: '',
	    descriptions: 'The enrollment URL is only valid for 24 hours. After 24 hours have elapsed, a new link must be generated by refreshing this page.'
	  }, {
	    id: 2,
	    title: '',
	    descriptions: 'Upon successful enrollment, you can view the Proxy details and manage the configurations of the proxy.'
	  }]
	};
	
	var PROXY_API_QUERY_PARAMS = exports.PROXY_API_QUERY_PARAMS = {
	  portalPublished: '?source=true',
	  portalPending: '?source=true&status=PENDING_DEPLOYMENT',
	  portalDeployed: '?source=true&status=DEPLOYED',
	  portalError: '?source=true&status=ERROR',
	  gatewayPublished: '?source=false',
	  gatewayPending: '?source=false&status=PENDING_DEPLOYMENT',
	  gatewayDeployed: '?source=false&status=DEPLOYED',
	  gatewayError: '?source=false&status=ERROR',
	  totalPublished: '',
	  totalPending: '?status=PENDING_DEPLOYMENT',
	  totalDeployed: '?status=DEPLOYED',
	  totalError: '?status=ERROR'
	};
	
	var PROXY_KEYS_QUERY_PARAMS = exports.PROXY_KEYS_QUERY_PARAMS = {
	  totalPublished: '',
	  totalPending: '?status=PENDING_DEPLOYMENT',
	  totalDeployed: '?status=DEPLOYED',
	  totalError: '?status=ERROR'
	};
	
	/** APIs */
	var APIS_GET_SUCCESS = exports.APIS_GET_SUCCESS = 'APIS_GET_SUCCESS';
	var APIS_GET_ERROR = exports.APIS_GET_ERROR = 'APIS_GET_ERROR';
	
	var APIS_SORT_BY = exports.APIS_SORT_BY = [{
	  uuid: 'apiModifyTs,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.page.sort.by.date.modified.desc')
	}, {
	  uuid: 'apiModifyTs,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.api.page.sort.by.date.modified.asc')
	}, {
	  uuid: 'apiName,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.api.name.asc')
	}, {
	  uuid: 'apiName,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.sort.by.api.name.desc')
	}];
	
	var APIS_STATES_FILTER_BY = exports.APIS_STATES_FILTER_BY = [{
	  uuid: 'all',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.all')
	}, {
	  uuid: 'Enabled',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.enabled')
	}, {
	  uuid: 'Disabled',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.disabled')
	}, {
	  uuid: 'Deprecated',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.deprecated')
	}, {
	  uuid: 'New',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.unpublished')
	}];
	
	var PROXY_APIS_SORT_BY = exports.PROXY_APIS_SORT_BY = [{
	  uuid: 'lastTimeDeployed,DESC',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.page.sort.by.last.deployed.desc')
	}, {
	  uuid: 'lastTimeDeployed,ASC',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.page.sort.by.last.deployed.asc')
	}];
	
	var PROXY_APIS_STATES_FILTER_BY = exports.PROXY_APIS_STATES_FILTER_BY = [{
	  uuid: 'all',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.all')
	}, {
	  uuid: 'NEW',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.unpublished')
	}, {
	  uuid: 'ENABLED',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.enabled')
	}, {
	  uuid: 'DISABLED',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.disabled')
	}, {
	  uuid: 'DEPRECATED',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.deprecated')
	}, {
	  uuid: 'DELETED',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.deleted')
	}];
	
	var APIS_PUBLISH_SOURCES_FILTER_BY = exports.APIS_PUBLISH_SOURCES_FILTER_BY = [{
	  uuid: 'all',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.publish.source.all')
	}, {
	  uuid: true,
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.publish.source.portal')
	}, {
	  uuid: false,
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.publish.source.gateway')
	}];
	
	var APIS_DEPLOYMENT_STATUS_FILTER_BY = exports.APIS_DEPLOYMENT_STATUS_FILTER_BY = [{
	  uuid: 'all',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.any')
	}, {
	  uuid: 'DEPLOYED',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.deployed')
	}, {
	  uuid: 'PENDING_DEPLOYMENT',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.pending.deployment')
	}, {
	  uuid: 'PENDING_UNDEPLOYMENT',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.pending.undeployment')
	}, {
	  uuid: 'ERROR_UNDEPLOY',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.error.undeploy')
	}, {
	  uuid: 'ERROR',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.error')
	}];
	
	var PROXY_APIS_KEY_STATUS_FILTER_BY = exports.PROXY_APIS_KEY_STATUS_FILTER_BY = [{
	  uuid: 'all',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.key.status.any')
	}, {
	  uuid: 'ENABLED',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.enabled')
	}, {
	  uuid: 'DISABLED',
	  text: (0, _intl.getI18nFormattedMessage)('label.apis.states.disabled')
	}];
	
	var CLOSE_TEXT = exports.CLOSE_TEXT = (0, _intl.getI18nFormattedMessage)('label.close.button');
	var COPY_TEXT = exports.COPY_TEXT = (0, _intl.getI18nFormattedMessage)('label.copy.button');
	var COPY_CLOSE_TEXT = exports.COPY_CLOSE_TEXT = (0, _intl.getI18nFormattedMessage)('label.copy.close.button');
	var DIALOG_TITLE_ERROR = exports.DIALOG_TITLE_ERROR = 'Error';
	
	/** Applications **/
	var API_KEYS_COUNT_GET_REQUEST = exports.API_KEYS_COUNT_GET_REQUEST = 'API_KEYS_COUNT_GET_REQUEST';
	var API_KEYS_COUNT_GET_SUCCESS = exports.API_KEYS_COUNT_GET_SUCCESS = 'API_KEYS_COUNT_GET_SUCCESS';
	var API_KEYS_COUNT_GET_ERROR = exports.API_KEYS_COUNT_GET_ERROR = 'API_KEYS_COUNT_GET_ERROR';
	
	/** Account Plans **/
	var ACCOUNT_PLANS_GET_SUCCESS = exports.ACCOUNT_PLANS_GET_SUCCESS = 'ACCOUNT_PLANS_GET_SUCCESS';
	var ACCOUNT_PLANS_GET_ERROR = exports.ACCOUNT_PLANS_GET_ERROR = 'ACCOUNT_PLANS_GET_ERROR';
	
	/** API Plans **/
	var API_PLANS_GET_SUCCESS = exports.API_PLANS_GET_SUCCESS = 'API_PLANS_GET_SUCCESS';
	var API_PLANS_GET_ERROR = exports.API_PLANS_GET_ERROR = 'API_PLANS_GET_ERROR';
	
	var HTTP_STATUS_BAD_REQUEST = exports.HTTP_STATUS_BAD_REQUEST = 400;
	var HTTP_STATUS_UNAUTHORIZED = exports.HTTP_STATUS_UNAUTHORIZED = 401;
	var HTTP_STATUS_SUCCESS = exports.HTTP_STATUS_SUCCESS = 200;
	
	var UNSAVED_DIALOG_TITLE = exports.UNSAVED_DIALOG_TITLE = 'Unsaved Changes';
	var UNSAVED_DIALOG_DESCRIPTIONS = exports.UNSAVED_DIALOG_DESCRIPTIONS = 'Your changes will be lost if you leave this page. Are you sure you want to continue away from this page?';
	var UNSAVED_DIALOG_CANCEL_TEXT = exports.UNSAVED_DIALOG_CANCEL_TEXT = 'Stay';
	var UNSAVED_DIALOG_SUBMIT_TEXT = exports.UNSAVED_DIALOG_SUBMIT_TEXT = 'Continue';
	var UNSAVED_DIALOG_EXIT_TEXT = exports.UNSAVED_DIALOG_EXIT_TEXT = 'Exit';
	var NEXT_TEXT = exports.NEXT_TEXT = 'Next';
	var DONE_TEXT = exports.DONE_TEXT = 'Done';
	
	var GRID_ROWS_PER_PAGE_OPTIONS = exports.GRID_ROWS_PER_PAGE_OPTIONS = [12, 24];
	var GRID_ROWS_PER_PAGE_DEFAULT_OPTION = exports.GRID_ROWS_PER_PAGE_DEFAULT_OPTION = 12;
	
	var VERSION_TEXT = exports.VERSION_TEXT = 'Version';
	var CHANGE_ACTION_TEXT = exports.CHANGE_ACTION_TEXT = 'Change';
	var ADD_APIPLAN_ACTION_TEXT = exports.ADD_APIPLAN_ACTION_TEXT = 'Add API Plan';

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getI18nFormattedMessage = exports.getI18n = exports.getIntlMessage = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* please use getI18n:getI18nMessage instead of this function.
	  will remove this function and replace usages with getI18nMessage in next refactoring
	*/
	var getIntlMessage = exports.getIntlMessage = function getIntlMessage(messageObj, dict) {
	  var id = messageObj.id,
	      defaultMessage = messageObj.defaultMessage;
	
	  var message = dict[id];
	  return {
	    id: id,
	    description: message || defaultMessage,
	    defaultMessage: message || '+++ ' + defaultMessage
	  };
	};
	
	exports.default = {
	  getIntlMessage: getIntlMessage
	};
	var getI18n = exports.getI18n = function getI18n(intl) {
	  var _intl$messages = intl.messages,
	      messages = _intl$messages === undefined ? {} : _intl$messages,
	      _intl$formatMessage = intl.formatMessage,
	      formatMessage = _intl$formatMessage === undefined ? function () {} : _intl$formatMessage;
	
	  return {
	    /**
	     * Function to resolve i18n message using an 'intl' instance
	     * @param labelKey: message key in the bundle
	     * @param values: object with values for tokens
	     * @param defaultMessage: when id / tokens are not resolved in the bundle
	     * @returns Resolved i18n plain-string message from react-intl
	     */
	    getI18nMessage: function getI18nMessage(labelKey, values, defaultMessage) {
	      var message = messages[labelKey];
	      return formatMessage({
	        id: labelKey,
	        description: message || defaultMessage,
	        defaultMessage: message || '+++ ' + defaultMessage
	      }, values);
	    },
	    /**
	     * Function to resolve i18n message using an 'intl' instance
	     * @param id: message key in the bundle
	     * @param values: object with values for tokens
	     * @param defaultMessage: when id / tokens are not resolved in the bundle
	     * @returns Resolved i18n FormattedMessage from react-intl
	     */
	    getI18nFormattedMessage: function getI18nFormattedMessage(id, values, defaultMessage) {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: id,
	        defaultMessage: messages[id] || defaultMessage,
	        values: values
	      });
	    }
	  };
	};
	
	/**
	 * Static function to resolve i18n message if an 'intl' instance is not available
	 * @param id: message key in the bundle
	 * @param values: object with values for tokens
	 * @param defaultMessage: when id / tokens are not resolved in the bundle
	 * @returns Formatted i18n message from react-intl
	 */
	var getI18nFormattedMessage = exports.getI18nFormattedMessage = function getI18nFormattedMessage(id, values, defaultMessage) {
	  return _react2.default.createElement(_reactIntl.FormattedMessage, {
	    id: id,
	    values: values,
	    defaultMessage: defaultMessage
	  });
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var macro_1 = __webpack_require__(713);
	exports.defineMessages = macro_1.defineMessages;
	var createFormattedComponent_1 = __webpack_require__(591);
	var injectIntl_1 = __webpack_require__(84);
	exports.injectIntl = injectIntl_1.default;
	exports.RawIntlProvider = injectIntl_1.Provider;
	exports.IntlContext = injectIntl_1.Context;
	var useIntl_1 = __webpack_require__(1408);
	exports.useIntl = useIntl_1.default;
	var provider_1 = __webpack_require__(1406);
	exports.IntlProvider = provider_1.default;
	exports.createIntl = provider_1.createIntl;
	// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./types').CustomFormatConfig`
	exports.FormattedDate = createFormattedComponent_1.createFormattedComponent('formatDate');
	exports.FormattedTime = createFormattedComponent_1.createFormattedComponent('formatTime');
	exports.FormattedNumber = createFormattedComponent_1.createFormattedComponent('formatNumber');
	exports.FormattedList = createFormattedComponent_1.createFormattedComponent('formatList');
	exports.FormattedDateParts = createFormattedComponent_1.createFormattedDateTimePartsComponent('formatDate');
	exports.FormattedTimeParts = createFormattedComponent_1.createFormattedDateTimePartsComponent('formatTime');
	var createFormattedComponent_2 = __webpack_require__(591);
	exports.FormattedNumberParts = createFormattedComponent_2.FormattedNumberParts;
	var relative_1 = __webpack_require__(1407);
	exports.FormattedRelativeTime = relative_1.default;
	var plural_1 = __webpack_require__(1405);
	exports.FormattedPlural = plural_1.default;
	var message_1 = __webpack_require__(592);
	exports.FormattedMessage = message_1.default;
	var html_message_1 = __webpack_require__(1404);
	exports.FormattedHTMLMessage = html_message_1.default;
	var utils_1 = __webpack_require__(50);
	exports.createIntlCache = utils_1.createIntlCache;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StatusContent = exports.TagsGroup = exports.TableWithSelectableRow = exports.TableMultiValueCell = exports.TablePagination = exports.Table = exports.TabsContainer = exports.TabPanel = exports.StatusIndicator = exports.SearchTextListContainer = exports.RefreshCounter = exports.RadioGroupSection = exports.Pagination = exports.MultiSelect = exports.HelpContainer = exports.LoadingDialog = exports.Loading = exports.Header = exports.GlobalHeader = exports.FormDialog = exports.FormActionButtons = exports.FormRadioGroup = exports.FormAutoCompleteCombo = exports.FormButtonGroup = exports.FormComboCheckBox = exports.FormSelect = exports.FormDefaultTextField = exports.FormTextField = exports.Footer = exports.FileDropzone = exports.ExpandPanelContainer = exports.ExpandableList = exports.ErrorContainer = exports.DynamicForm = exports.DetailsPanelContainer = exports.DetailsHeader = exports.CookiePolicyBanner = exports.AlertInfo = exports.AlertMessages = exports.AlertDialog = undefined;
	
	var _AlertDialog = __webpack_require__(197);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _AlertMessages = __webpack_require__(1456);
	
	var _AlertMessages2 = _interopRequireDefault(_AlertMessages);
	
	var _AlertInfo = __webpack_require__(1454);
	
	var _AlertInfo2 = _interopRequireDefault(_AlertInfo);
	
	var _CookiePolicyBanner = __webpack_require__(1458);
	
	var _CookiePolicyBanner2 = _interopRequireDefault(_CookiePolicyBanner);
	
	var _Header = __webpack_require__(1460);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _PanelContainer = __webpack_require__(1462);
	
	var _PanelContainer2 = _interopRequireDefault(_PanelContainer);
	
	var _DynamicForm = __webpack_require__(1464);
	
	var _DynamicForm2 = _interopRequireDefault(_DynamicForm);
	
	var _ErrorContainer = __webpack_require__(1466);
	
	var _ErrorContainer2 = _interopRequireDefault(_ErrorContainer);
	
	var _ExpandableList = __webpack_require__(605);
	
	var _ExpandableList2 = _interopRequireDefault(_ExpandableList);
	
	var _ExpandPanelContainer = __webpack_require__(1468);
	
	var _ExpandPanelContainer2 = _interopRequireDefault(_ExpandPanelContainer);
	
	var _FileDropzone = __webpack_require__(1472);
	
	var _FileDropzone2 = _interopRequireDefault(_FileDropzone);
	
	var _Footer = __webpack_require__(607);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _FormActionButtons = __webpack_require__(1474);
	
	var _FormActionButtons2 = _interopRequireDefault(_FormActionButtons);
	
	var _FormAutoCompleteCombo = __webpack_require__(1476);
	
	var _FormAutoCompleteCombo2 = _interopRequireDefault(_FormAutoCompleteCombo);
	
	var _FormRadioGroup = __webpack_require__(1486);
	
	var _FormRadioGroup2 = _interopRequireDefault(_FormRadioGroup);
	
	var _FormDialog = __webpack_require__(1484);
	
	var _FormDialog2 = _interopRequireDefault(_FormDialog);
	
	var _FormTextField = __webpack_require__(1490);
	
	var _FormTextField2 = _interopRequireDefault(_FormTextField);
	
	var _FormDefaultTextField = __webpack_require__(1482);
	
	var _FormDefaultTextField2 = _interopRequireDefault(_FormDefaultTextField);
	
	var _FormSelect = __webpack_require__(1488);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _FormComboCheckBox = __webpack_require__(1480);
	
	var _FormComboCheckBox2 = _interopRequireDefault(_FormComboCheckBox);
	
	var _FormButtonGroup = __webpack_require__(1478);
	
	var _FormButtonGroup2 = _interopRequireDefault(_FormButtonGroup);
	
	var _GlobalHeader = __webpack_require__(608);
	
	var _GlobalHeader2 = _interopRequireDefault(_GlobalHeader);
	
	var _Header3 = __webpack_require__(1523);
	
	var _Header4 = _interopRequireDefault(_Header3);
	
	var _HelpContainer = __webpack_require__(1526);
	
	var _HelpContainer2 = _interopRequireDefault(_HelpContainer);
	
	var _Loading = __webpack_require__(1528);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _LoadingDialog = __webpack_require__(1530);
	
	var _LoadingDialog2 = _interopRequireDefault(_LoadingDialog);
	
	var _MultiSelect = __webpack_require__(1532);
	
	var _MultiSelect2 = _interopRequireDefault(_MultiSelect);
	
	var _Pagination = __webpack_require__(1547);
	
	var _RadioGroupSection = __webpack_require__(1534);
	
	var _RadioGroupSection2 = _interopRequireDefault(_RadioGroupSection);
	
	var _RefreshCounter = __webpack_require__(1536);
	
	var _RefreshCounter2 = _interopRequireDefault(_RefreshCounter);
	
	var _SearchTextListContainer = __webpack_require__(1540);
	
	var _SearchTextListContainer2 = _interopRequireDefault(_SearchTextListContainer);
	
	var _StatusIndicator = __webpack_require__(612);
	
	var _StatusIndicator2 = _interopRequireDefault(_StatusIndicator);
	
	var _Table = __webpack_require__(1549);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _MultiValueCell = __webpack_require__(1545);
	
	var _MultiValueCell2 = _interopRequireDefault(_MultiValueCell);
	
	var _TableWithSelectableRow = __webpack_require__(1551);
	
	var _TableWithSelectableRow2 = _interopRequireDefault(_TableWithSelectableRow);
	
	var _TabPanel = __webpack_require__(1544);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _TabsContainer = __webpack_require__(1553);
	
	var _TabsContainer2 = _interopRequireDefault(_TabsContainer);
	
	var _TagsGroup = __webpack_require__(1555);
	
	var _TagsGroup2 = _interopRequireDefault(_TagsGroup);
	
	var _StatusContent = __webpack_require__(611);
	
	var _StatusContent2 = _interopRequireDefault(_StatusContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AlertDialog = _AlertDialog2.default;
	exports.AlertMessages = _AlertMessages2.default;
	exports.AlertInfo = _AlertInfo2.default;
	exports.CookiePolicyBanner = _CookiePolicyBanner2.default;
	exports.DetailsHeader = _Header2.default;
	exports.DetailsPanelContainer = _PanelContainer2.default;
	exports.DynamicForm = _DynamicForm2.default;
	exports.ErrorContainer = _ErrorContainer2.default;
	exports.ExpandableList = _ExpandableList2.default;
	exports.ExpandPanelContainer = _ExpandPanelContainer2.default;
	exports.FileDropzone = _FileDropzone2.default;
	exports.Footer = _Footer2.default;
	exports.FormTextField = _FormTextField2.default;
	exports.FormDefaultTextField = _FormDefaultTextField2.default;
	exports.FormSelect = _FormSelect2.default;
	exports.FormComboCheckBox = _FormComboCheckBox2.default;
	exports.FormButtonGroup = _FormButtonGroup2.default;
	exports.FormAutoCompleteCombo = _FormAutoCompleteCombo2.default;
	exports.FormRadioGroup = _FormRadioGroup2.default;
	exports.FormActionButtons = _FormActionButtons2.default;
	exports.FormDialog = _FormDialog2.default;
	exports.GlobalHeader = _GlobalHeader2.default;
	exports.Header = _Header4.default;
	exports.Loading = _Loading2.default;
	exports.LoadingDialog = _LoadingDialog2.default;
	exports.HelpContainer = _HelpContainer2.default;
	exports.MultiSelect = _MultiSelect2.default;
	exports.Pagination = _Pagination.Pagination;
	exports.RadioGroupSection = _RadioGroupSection2.default;
	exports.RefreshCounter = _RefreshCounter2.default;
	exports.SearchTextListContainer = _SearchTextListContainer2.default;
	exports.StatusIndicator = _StatusIndicator2.default;
	exports.TabPanel = _TabPanel2.default;
	exports.TabsContainer = _TabsContainer2.default;
	exports.Table = _Table2.default;
	exports.TablePagination = _Pagination.TablePagination;
	exports.TableMultiValueCell = _MultiValueCell2.default;
	exports.TableWithSelectableRow = _TableWithSelectableRow2.default;
	exports.TagsGroup = _TagsGroup2.default;
	exports.StatusContent = _StatusContent2.default;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uuidv4 = exports.convertHexToRGB = exports.getCookieMessage = exports.getTabIndex = exports.getTitleCaseText = exports.getVersion = exports.formatStatusMessage = exports.getBundlesExtension = exports.createCookie = exports.readCookie = exports.isEditApplicationKeysDisabled = exports.isEditApplicationDisabled = exports.listToObject = exports.getFileExtension = exports.isNumericVersion = exports.hasError = exports.getApiOwnerUser = exports.hasAccessPermissionsPage = exports.hasOrgPublisherRole = exports.hasAdminRole = exports.hasDeveloperRole = exports.hasOrgBoundRole = exports.hasPublisherRole = exports.getSingularRoleName = exports.getUserRole = exports.getValidationErrors = exports.getErrorMessage = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var _validator = __webpack_require__(651);
	
	var _base = __webpack_require__(1197);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _utf = __webpack_require__(1772);
	
	var _utf2 = _interopRequireDefault(_utf);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MAX_LENGTH = 255;
	
	var getLastExtension = function getLastExtension(fileName, search) {
	  if (!fileName) return null;
	  return fileName.substr(fileName.lastIndexOf(search) + 1).toLowerCase();
	};
	
	var getErrorMessage = exports.getErrorMessage = function getErrorMessage(error) {
	  return (0, _lodash.get)(error, 'message') && [(0, _lodash.get)(error, 'message')];
	};
	
	var getValidationErrors = exports.getValidationErrors = function getValidationErrors(error) {
	  return (0, _lodash.get)(error, 'response.data.error.detail.validationErrors') || [error];
	};
	
	var getUserRole = exports.getUserRole = function getUserRole() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      portalAdmin = _ref.portalAdmin,
	      apiOwner = _ref.apiOwner,
	      orgAdmin = _ref.orgAdmin,
	      developer = _ref.developer,
	      orgPublisher = _ref.orgPublisher;
	
	  var roleName = void 0;
	  if (portalAdmin) {
	    roleName = _constants.ROLE_PORTAL_ADMIN;
	  }
	  if (apiOwner) {
	    roleName = _constants.ROLE_API_OWNER;
	  }
	  if (orgAdmin) {
	    roleName = _constants.ROLE_ORG_ADMIN;
	  }
	  if (developer) {
	    roleName = _constants.ROLE_DEVELOPER;
	  }
	  if (orgPublisher) {
	    roleName = _constants.ROLE_ORG_PUBLISHER;
	  }
	  return roleName;
	};
	
	var getSingularRoleName = exports.getSingularRoleName = function getSingularRoleName(role) {
	  var ROLE_ROLENAME = {
	    apiowners: _constants.API_OWNER_TEXT,
	    devorgadministrators: _constants.ORGANIZATION_ADMIN_TEXT,
	    developers: _constants.DEVELOPER_TEXT
	  };
	  var roleName = ROLE_ROLENAME[role.roleName] || role.roleName;
	  return role.organization ? role.organization + ' (' + roleName + ')' : roleName;
	};
	
	var hasPublisherRole = exports.hasPublisherRole = function hasPublisherRole(user) {
	  return getUserRole(user) === _constants.ROLE_PORTAL_ADMIN || getUserRole(user) === _constants.ROLE_API_OWNER;
	};
	
	var hasOrgBoundRole = exports.hasOrgBoundRole = function hasOrgBoundRole(user) {
	  return [_constants.ROLE_ORG_ADMIN, _constants.ROLE_ORG_PUBLISHER, _constants.ROLE_DEVELOPER].includes(getUserRole(user));
	};
	
	var hasDeveloperRole = exports.hasDeveloperRole = function hasDeveloperRole(user) {
	  return getUserRole(user) === _constants.ROLE_ORG_ADMIN || getUserRole(user) === _constants.ROLE_DEVELOPER;
	};
	
	var hasAdminRole = exports.hasAdminRole = function hasAdminRole(user) {
	  return getUserRole(user) === _constants.ROLE_PORTAL_ADMIN;
	};
	
	var hasOrgPublisherRole = exports.hasOrgPublisherRole = function hasOrgPublisherRole(user) {
	  return getUserRole(user) === _constants.ROLE_ORG_PUBLISHER;
	};
	
	var hasAccessPermissionsPage = exports.hasAccessPermissionsPage = function hasAccessPermissionsPage(portalStatus) {
	  return portalStatus === _constants.PORTAL_STATUS_NEW;
	};
	
	var getApiOwnerUser = exports.getApiOwnerUser = function getApiOwnerUser(userDetails) {
	  var apiOwnerName = userDetails.firstName + ' ' + userDetails.lastName;
	  var apiOwner = { uuid: userDetails.uuid, name: apiOwnerName, roleOrgs: [{ roleName: 'apiOwner' }] };
	  return apiOwner;
	};
	
	var hasError = exports.hasError = function hasError(value, isRequired) {
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_LENGTH;
	  return isRequired && (0, _validator.isEmpty)((0, _lodash.trim)(value)) || !(0, _validator.isLength)(value, { max: max });
	};
	
	var isNumericVersion = exports.isNumericVersion = function isNumericVersion(value) {
	  var numeric = /^\d+([.|_|-]*\d+)*$/;
	  return !numeric.test(value);
	};
	
	var getFileExtension = exports.getFileExtension = function getFileExtension(filename) {
	  return getLastExtension(filename, '.');
	};
	
	var listToObject = exports.listToObject = function listToObject() {
	  var entities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var type = arguments[1];
	  return entities.reduce(function (acc, props) {
	    return Object.assign({}, acc, _defineProperty({}, props.uuid, Object.assign({}, props, { type: type })));
	  }, {});
	};
	
	var isEditApplicationDisabled = exports.isEditApplicationDisabled = function isEditApplicationDisabled(userContext, _ref2) {
	  var status = _ref2.status,
	      disabledByType = _ref2.disabledByType;
	
	  if (hasPublisherRole(userContext)) {
	    // Internal applications
	    return [_constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL].includes(status);
	  } else if (hasOrgBoundRole(userContext)) {
	    // External applications
	    return !(0, _lodash.isUndefined)(status) && !(0, _lodash.isUndefined)(disabledByType) && (!(disabledByType === null || disabledByType === _constants.APPLICATION_DISABLED_BY_TYPE_EXTERNAL) || [_constants.APPLICATION_STATUS_PENDING_APPROVAL, _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL].includes(status));
	  }
	  return false;
	};
	
	var isEditApplicationKeysDisabled = exports.isEditApplicationKeysDisabled = function isEditApplicationKeysDisabled(userContext, _ref3) {
	  var status = _ref3.status;
	
	  if (hasPublisherRole(userContext)) {
	    // Internal applications
	    return ![_constants.APPLICATION_STATUS_ENABLED, _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL].includes(status);
	  } else if (hasOrgBoundRole(userContext)) {
	    // External applications
	    return true;
	  }
	  return false;
	};
	
	var readCookie = exports.readCookie = function readCookie(name) {
	  var cookieName = name + '=';
	  var cookies = document.cookie.split(';');
	  for (var i = 0; i < cookies.length; i++) {
	    var cookie = cookies[i];
	    while (cookie.charAt(0) === ' ') {
	      cookie = cookie.substring(1, cookie.length);
	    }if (cookie.indexOf(cookieName) === 0) return cookie.substring(cookieName.length, cookie.length);
	  }
	  return null;
	};
	
	var createCookie = exports.createCookie = function createCookie(name, value, days, path) {
	  var expires = void 0;
	  if (days) {
	    var date = new Date();
	    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	    expires = '; expires=  ' + date.toGMTString();
	  } else expires = '';
	  document.cookie = name + '=' + value + expires + '; path=' + path;
	};
	
	var getBundlesExtension = exports.getBundlesExtension = function getBundlesExtension(filename, ALLOWED_FILE_EXTENSIONS) {
	  var last2Index = filename.lastIndexOf('.', filename.lastIndexOf('.') - 1) + 1;
	  var extension = filename.substr(last2Index).toLocaleLowerCase();
	  if ((0, _lodash.includes)(ALLOWED_FILE_EXTENSIONS, extension)) {
	    return extension;
	  }
	  return getLastExtension(filename, '.');
	};
	
	var entityMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '/': '&#x2F;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};
	
	var escapeHtml = function escapeHtml(str) {
	  return str.replace(/[&<>"'`=/]/g, function (s) {
	    return entityMap[s];
	  });
	};
	
	var isJsonString = function isJsonString(str) {
	  try {
	    JSON.parse(str);
	  } catch (e) {
	    return false;
	  }
	  return true;
	};
	
	var formatStatusMessage = exports.formatStatusMessage = function formatStatusMessage(message) {
	  var modalBody = '';
	  var jsonObj = null;
	
	  if (message) {
	    if (isJsonString(message)) {
	      jsonObj = JSON.parse(message);
	    }
	    if (jsonObj && jsonObj.length) {
	      for (var i = 0; i < jsonObj.length; i++) {
	        modalBody += jsonObj[i].message;
	      }
	    } else if (jsonObj) {
	      modalBody = JSON.stringify(jsonObj, null, 2);
	    } else {
	      modalBody = escapeHtml(message);
	    }
	  }
	  return modalBody;
	};
	
	var getVersion = exports.getVersion = function getVersion(version) {
	  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
	
	  var len = version ? version.indexOf(char, version.indexOf(char) + 1) : 0;
	  return len > 0 ? version.substr(0, len) : version;
	};
	
	var getTitleCaseText = exports.getTitleCaseText = function getTitleCaseText(value) {
	  var str = value ? value.replace('_', ' ') : value;
	  return str ? str.toLowerCase().replace(/\b(\w)/g, function (s) {
	    return s.toUpperCase();
	  }) : str;
	};
	
	var getTabIndex = exports.getTabIndex = function getTabIndex(tabs, match) {
	  var tabName = (0, _lodash.get)(match, 'params.tabName');
	  var index = (0, _lodash.findIndex)(tabs, function (tab) {
	    return tab.id === tabName;
	  });
	  // if none found default to 0
	  return index > 0 ? index : 0;
	};
	
	var getCookieMessage = exports.getCookieMessage = function getCookieMessage(message) {
	  var text = _utf2.default.decode(_base2.default.decode(message));
	  return text.replace(/<script>.*<\/script>/g, '').replace(/javascript:([^"]+)/g, '').replace(/(o|&#111;)(n|&#110;)[\S]*=([^)]+)/g, '');
	};
	
	/* converHexToRGB */
	var convertHexToRGB = exports.convertHexToRGB = function convertHexToRGB() {
	  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var hexValue = hex.replace('#', '');
	  var r = parseInt(hexValue.substring(0, 2), 16);
	  var g = parseInt(hexValue.substring(2, 4), 16);
	  var b = parseInt(hexValue.substring(4, 6), 16);
	
	  return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
	};
	
	/* eslint-disable */
	/*
	found from: https://stackoverflow.com/a/2117523
	 */
	var uuidv4 = exports.uuidv4 = function uuidv4() {
	  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
	    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
	  });
	};
	/* eslint-enable */

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryAnimation", {
	  enumerable: true,
	  get: function () {
	    return _victoryAnimation.default;
	  }
	});
	Object.defineProperty(exports, "VictoryContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryContainer.default;
	  }
	});
	Object.defineProperty(exports, "VictoryLabel", {
	  enumerable: true,
	  get: function () {
	    return _victoryLabel.default;
	  }
	});
	Object.defineProperty(exports, "VictoryTransition", {
	  enumerable: true,
	  get: function () {
	    return _victoryTransition.default;
	  }
	});
	Object.defineProperty(exports, "VictoryClipContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryClipContainer.default;
	  }
	});
	Object.defineProperty(exports, "VictoryTheme", {
	  enumerable: true,
	  get: function () {
	    return _victoryTheme.default;
	  }
	});
	Object.defineProperty(exports, "VictoryPortal", {
	  enumerable: true,
	  get: function () {
	    return _victoryPortal.default;
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function () {
	    return _portal.default;
	  }
	});
	Object.defineProperty(exports, "Arc", {
	  enumerable: true,
	  get: function () {
	    return _arc.default;
	  }
	});
	Object.defineProperty(exports, "Border", {
	  enumerable: true,
	  get: function () {
	    return _border.default;
	  }
	});
	Object.defineProperty(exports, "Box", {
	  enumerable: true,
	  get: function () {
	    return _border.default;
	  }
	});
	Object.defineProperty(exports, "ClipPath", {
	  enumerable: true,
	  get: function () {
	    return _clipPath.default;
	  }
	});
	Object.defineProperty(exports, "LineSegment", {
	  enumerable: true,
	  get: function () {
	    return _lineSegment.default;
	  }
	});
	Object.defineProperty(exports, "Point", {
	  enumerable: true,
	  get: function () {
	    return _point.default;
	  }
	});
	Object.defineProperty(exports, "Whisker", {
	  enumerable: true,
	  get: function () {
	    return _whisker.default;
	  }
	});
	Object.defineProperty(exports, "addEvents", {
	  enumerable: true,
	  get: function () {
	    return _addEvents.default;
	  }
	});
	Object.defineProperty(exports, "Collection", {
	  enumerable: true,
	  get: function () {
	    return _collection.default;
	  }
	});
	Object.defineProperty(exports, "Data", {
	  enumerable: true,
	  get: function () {
	    return _data.default;
	  }
	});
	Object.defineProperty(exports, "DefaultTransitions", {
	  enumerable: true,
	  get: function () {
	    return _defaultTransitions.default;
	  }
	});
	Object.defineProperty(exports, "Domain", {
	  enumerable: true,
	  get: function () {
	    return _domain.default;
	  }
	});
	Object.defineProperty(exports, "Events", {
	  enumerable: true,
	  get: function () {
	    return _events.default;
	  }
	});
	Object.defineProperty(exports, "Helpers", {
	  enumerable: true,
	  get: function () {
	    return _helpers.default;
	  }
	});
	Object.defineProperty(exports, "Immutable", {
	  enumerable: true,
	  get: function () {
	    return _immutable.default;
	  }
	});
	Object.defineProperty(exports, "LabelHelpers", {
	  enumerable: true,
	  get: function () {
	    return _labelHelpers.default;
	  }
	});
	Object.defineProperty(exports, "Log", {
	  enumerable: true,
	  get: function () {
	    return _log.default;
	  }
	});
	Object.defineProperty(exports, "PropTypes", {
	  enumerable: true,
	  get: function () {
	    return _propTypes.default;
	  }
	});
	Object.defineProperty(exports, "Scale", {
	  enumerable: true,
	  get: function () {
	    return _scale.default;
	  }
	});
	Object.defineProperty(exports, "Selection", {
	  enumerable: true,
	  get: function () {
	    return _selection.default;
	  }
	});
	Object.defineProperty(exports, "Style", {
	  enumerable: true,
	  get: function () {
	    return _style.default;
	  }
	});
	Object.defineProperty(exports, "TextSize", {
	  enumerable: true,
	  get: function () {
	    return _textsize.default;
	  }
	});
	Object.defineProperty(exports, "Timer", {
	  enumerable: true,
	  get: function () {
	    return _timer.default;
	  }
	});
	Object.defineProperty(exports, "Transitions", {
	  enumerable: true,
	  get: function () {
	    return _transitions.default;
	  }
	});
	Object.defineProperty(exports, "Rect", {
	  enumerable: true,
	  get: function () {
	    return _rect.default;
	  }
	});
	Object.defineProperty(exports, "Path", {
	  enumerable: true,
	  get: function () {
	    return _path.default;
	  }
	});
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function () {
	    return _line.default;
	  }
	});
	Object.defineProperty(exports, "Circle", {
	  enumerable: true,
	  get: function () {
	    return _circle.default;
	  }
	});
	Object.defineProperty(exports, "TSpan", {
	  enumerable: true,
	  get: function () {
	    return _tspan.default;
	  }
	});
	Object.defineProperty(exports, "Text", {
	  enumerable: true,
	  get: function () {
	    return _text.default;
	  }
	});
	Object.defineProperty(exports, "CommonProps", {
	  enumerable: true,
	  get: function () {
	    return _commonProps.default;
	  }
	});
	Object.defineProperty(exports, "Wrapper", {
	  enumerable: true,
	  get: function () {
	    return _wrapper.default;
	  }
	});
	Object.defineProperty(exports, "Axis", {
	  enumerable: true,
	  get: function () {
	    return _axis.default;
	  }
	});
	
	var _victoryAnimation = _interopRequireDefault(__webpack_require__(670));
	
	var _victoryContainer = _interopRequireDefault(__webpack_require__(1861));
	
	var _victoryLabel = _interopRequireDefault(__webpack_require__(1862));
	
	var _victoryTransition = _interopRequireDefault(__webpack_require__(677));
	
	var _victoryClipContainer = _interopRequireDefault(__webpack_require__(1860));
	
	var _victoryTheme = _interopRequireDefault(__webpack_require__(1871));
	
	var _victoryPortal = _interopRequireDefault(__webpack_require__(672));
	
	var _portal = _interopRequireDefault(__webpack_require__(671));
	
	var _arc = _interopRequireDefault(__webpack_require__(1863));
	
	var _border = _interopRequireDefault(__webpack_require__(1864));
	
	var _clipPath = _interopRequireDefault(__webpack_require__(674));
	
	var _lineSegment = _interopRequireDefault(__webpack_require__(1865));
	
	var _point = _interopRequireDefault(__webpack_require__(1867));
	
	var _whisker = _interopRequireDefault(__webpack_require__(1868));
	
	var _addEvents = _interopRequireDefault(__webpack_require__(1872));
	
	var _collection = _interopRequireDefault(__webpack_require__(89));
	
	var _data = _interopRequireDefault(__webpack_require__(300));
	
	var _defaultTransitions = _interopRequireDefault(__webpack_require__(1873));
	
	var _domain = _interopRequireDefault(__webpack_require__(301));
	
	var _events = _interopRequireDefault(__webpack_require__(302));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _immutable = _interopRequireDefault(__webpack_require__(679));
	
	var _labelHelpers = _interopRequireDefault(__webpack_require__(680));
	
	var _log = _interopRequireDefault(__webpack_require__(212));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(128));
	
	var _scale = _interopRequireDefault(__webpack_require__(213));
	
	var _selection = _interopRequireDefault(__webpack_require__(1874));
	
	var _style = _interopRequireDefault(__webpack_require__(303));
	
	var _textsize = _interopRequireDefault(__webpack_require__(1875));
	
	var _timer = _interopRequireDefault(__webpack_require__(214));
	
	var _transitions = _interopRequireDefault(__webpack_require__(304));
	
	var _rect = _interopRequireDefault(__webpack_require__(299));
	
	var _path = _interopRequireDefault(__webpack_require__(298));
	
	var _line = _interopRequireDefault(__webpack_require__(297));
	
	var _circle = _interopRequireDefault(__webpack_require__(673));
	
	var _tspan = _interopRequireDefault(__webpack_require__(676));
	
	var _text = _interopRequireDefault(__webpack_require__(675));
	
	var _commonProps = _interopRequireDefault(__webpack_require__(127));
	
	var _wrapper = _interopRequireDefault(__webpack_require__(1876));
	
	var _axis = _interopRequireDefault(__webpack_require__(678));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(260),
	    copyObject = __webpack_require__(1304),
	    createAssigner = __webpack_require__(1307),
	    isArrayLike = __webpack_require__(66),
	    isPrototype = __webpack_require__(188),
	    keys = __webpack_require__(56);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.2
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "chainPropTypes", {
	  enumerable: true,
	  get: function get() {
	    return _chainPropTypes.default;
	  }
	});
	Object.defineProperty(exports, "deepmerge", {
	  enumerable: true,
	  get: function get() {
	    return _deepmerge.default;
	  }
	});
	Object.defineProperty(exports, "elementAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "elementTypeAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementTypeAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "exactProp", {
	  enumerable: true,
	  get: function get() {
	    return _exactProp.default;
	  }
	});
	Object.defineProperty(exports, "formatMuiErrorMessage", {
	  enumerable: true,
	  get: function get() {
	    return _formatMuiErrorMessage.default;
	  }
	});
	Object.defineProperty(exports, "getDisplayName", {
	  enumerable: true,
	  get: function get() {
	    return _getDisplayName.default;
	  }
	});
	Object.defineProperty(exports, "HTMLElementType", {
	  enumerable: true,
	  get: function get() {
	    return _HTMLElementType.default;
	  }
	});
	Object.defineProperty(exports, "ponyfillGlobal", {
	  enumerable: true,
	  get: function get() {
	    return _ponyfillGlobal.default;
	  }
	});
	Object.defineProperty(exports, "refType", {
	  enumerable: true,
	  get: function get() {
	    return _refType.default;
	  }
	});
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(249));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(1028));
	
	var _elementAcceptingRef = _interopRequireDefault(__webpack_require__(1029));
	
	var _elementTypeAcceptingRef = _interopRequireDefault(__webpack_require__(1030));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(1031));
	
	var _formatMuiErrorMessage = _interopRequireDefault(__webpack_require__(1032));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(1033));
	
	var _HTMLElementType = _interopRequireDefault(__webpack_require__(1027));
	
	var _ponyfillGlobal = _interopRequireDefault(__webpack_require__(1036));
	
	var _refType = _interopRequireDefault(__webpack_require__(1037));

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(166));
	
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(262);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalize;
	
	// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
	//
	// A strict capitalization should uppercase the first letter of each word a the sentence.
	// We only handle the first word.
	function capitalize(string) {
	  if (false) {
	    if (typeof string !== 'string') {
	      throw new Error('Material-UI: capitalize(string) expects a string argument.');
	    }
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(182),
	    eq = __webpack_require__(118),
	    isIterateeCall = __webpack_require__(187),
	    keysIn = __webpack_require__(446);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getThemeBrandedLabels = exports.getCookieConsent = exports.getIsAnonymousRole = exports.getIsOrgPublisher = exports.getIsApiOwner = exports.getIsOnlyPortalAdmin = exports.getIsPortalAdmin = exports.getDeploymentRefreshTime = exports.getAppSecretHashingMetadata = exports.getRequests = exports.getIsEditApplicationRequestWorkflowEnabled = exports.getIsApplicationRequestWorkflowEnabled = exports.getRequestSettings = exports.getLockUserCreation = exports.getUseMultiApiKeys = exports.getNewLandingPage = exports.getUseLegacyApplicationPages = exports.getUseLegacyApiPages = exports.getFeatureFlagApiPlans = exports.getFeatureFlags = exports.getSettingsNavigation = exports.getDeveloperNavigations = exports.getPublisherNavigation = exports.getDisplayCopyright = exports.getThemes = exports.getCQNavigation = exports.getGlobalNavigation = exports.getServices = exports.getUserDetails = exports.getUserActiveOrgUuid = exports.getUserAccessibleOrgs = exports.getUserContexts = exports.getDict = exports.getUserPrefs = exports.getConfig = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _responseParser = __webpack_require__(1706);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.FETCH_REQUESTS_SUCCESS:
	      return Object.assign({}, state, {
	        requests: action.payload
	      });
	    case constants.FETCH_APP_SECRET_HASHING_METADATA_SUCCESS:
	      return Object.assign({}, state, {
	        appSecretHashingMetadata: (0, _responseParser.getHashingMetadata)((0, _lodash.get)(action, 'payload.Value'))
	      });
	    case constants.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS:
	      return Object.assign({}, state, {
	        deploymentRefreshTime: (0, _lodash.get)(action, 'payload.Value')
	      });
	    case constants.FETCH_APPLICATION_REQUEST_SETTING_SUCCESS:
	      {
	        var requestSettings = state.requestSettings;
	
	        return Object.assign({}, state, {
	          requestSettings: Object.assign({}, requestSettings, {
	            isApplicationRequestWorkflowEnabled: (0, _lodash.get)(action, 'payload')
	          })
	        });
	      }
	    case constants.FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS:
	      {
	        var _requestSettings = state.requestSettings;
	
	        return Object.assign({}, state, {
	          requestSettings: Object.assign({}, _requestSettings, {
	            isEditApplicationRequestWorkflowEnabled: (0, _lodash.get)(action, 'payload')
	          })
	        });
	      }
	    case constants.FETCH_SETTING_USER_LOCK_CREATION_SUCCESS:
	      {
	        var featureFlags = state.featureFlags;
	
	        return Object.assign({}, state, {
	          featureFlags: Object.assign({}, featureFlags, {
	            lockUserCreation: action.payload
	          })
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	var getConfig = exports.getConfig = function getConfig(state) {
	  return state.portalConfig && state.portalConfig.config;
	};
	var getUserPrefs = exports.getUserPrefs = function getUserPrefs(state) {
	  return state.portalConfig && state.portalConfig.userPrefs;
	};
	var getDict = exports.getDict = function getDict(state) {
	  return state.portalConfig && state.portalConfig.dict;
	};
	var getUserContexts = exports.getUserContexts = function getUserContexts(state) {
	  return state.portalConfig && state.portalConfig.userContexts;
	};
	var getUserAccessibleOrgs = exports.getUserAccessibleOrgs = function getUserAccessibleOrgs(state) {
	  return (0, _lodash.map)(getUserContexts(state) && getUserContexts(state).userContexts[0].accessibleOrgs, function (uuid, name) {
	    return { uuid: uuid, name: name };
	  });
	};
	var getUserActiveOrgUuid = exports.getUserActiveOrgUuid = function getUserActiveOrgUuid(state) {
	  return getUserContexts(state) && getUserContexts(state).userContexts[0].activeOrgUuid;
	};
	var getUserDetails = exports.getUserDetails = function getUserDetails(state) {
	  return getUserContexts(state) && getUserContexts(state).userContexts[0].userDetails;
	};
	var getServices = exports.getServices = function getServices(state) {
	  return state.portalConfig && state.portalConfig.services;
	};
	var getGlobalNavigation = exports.getGlobalNavigation = function getGlobalNavigation(state) {
	  return state.portalConfig && state.portalConfig.globalNavigation;
	};
	var getCQNavigation = exports.getCQNavigation = function getCQNavigation(state) {
	  return state.portalConfig && state.portalConfig.cqNavigation;
	};
	var getThemes = exports.getThemes = function getThemes(state) {
	  return state.portalConfig && state.portalConfig.themes;
	};
	var getDisplayCopyright = exports.getDisplayCopyright = function getDisplayCopyright(state) {
	  return (0, _lodash.get)(state, 'portalConfig.themes.display.copyright', true);
	};
	var getPublisherNavigation = exports.getPublisherNavigation = function getPublisherNavigation(state) {
	  return state.portalConfig && state.portalConfig.publisherNavigation;
	};
	var getDeveloperNavigations = exports.getDeveloperNavigations = function getDeveloperNavigations(state) {
	  return state.portalConfig && state.portalConfig.developerNavigation;
	};
	var getSettingsNavigation = exports.getSettingsNavigation = function getSettingsNavigation(state) {
	  return state.portalConfig && state.portalConfig.settingsNavigation;
	};
	
	var getFeatureFlags = exports.getFeatureFlags = function getFeatureFlags(state) {
	  return state.portalConfig && state.portalConfig.featureFlags;
	};
	var getFeatureFlagApiPlans = exports.getFeatureFlagApiPlans = function getFeatureFlagApiPlans(state) {
	  return (0, _lodash.get)(getFeatureFlags(state), 'apiPlans.Value') === 'true';
	};
	var getUseLegacyApiPages = exports.getUseLegacyApiPages = function getUseLegacyApiPages(state) {
	  return (0, _lodash.get)(getFeatureFlags(state), 'useLegacyApiPages.Value') === 'true';
	};
	var getUseLegacyApplicationPages = exports.getUseLegacyApplicationPages = function getUseLegacyApplicationPages(state) {
	  return (0, _lodash.get)(getFeatureFlags(state), 'useLegacyApplicationPages.Value') === 'true';
	};
	var getNewLandingPage = exports.getNewLandingPage = function getNewLandingPage(state) {
	  return (0, _lodash.get)(getFeatureFlags(state), 'newLandingPage.Value') === 'true';
	};
	var getUseMultiApiKeys = exports.getUseMultiApiKeys = function getUseMultiApiKeys(state) {
	  return (0, _lodash.get)(getFeatureFlags(state), 'useMultiApiKeys.Value') === 'true';
	};
	var getLockUserCreation = exports.getLockUserCreation = function getLockUserCreation(state) {
	  return (0, _lodash.get)(getFeatureFlags(state), 'lockUserCreation.Value') === 'true';
	};
	
	var getRequestSettings = exports.getRequestSettings = function getRequestSettings(state) {
	  return (0, _lodash.get)(state, 'portalConfig.requestSettings');
	};
	var getIsApplicationRequestWorkflowEnabled = exports.getIsApplicationRequestWorkflowEnabled = function getIsApplicationRequestWorkflowEnabled(state) {
	  return (0, _lodash.get)(getRequestSettings(state), 'isApplicationRequestWorkflowEnabled.Value') === 'ENABLED';
	};
	var getIsEditApplicationRequestWorkflowEnabled = exports.getIsEditApplicationRequestWorkflowEnabled = function getIsEditApplicationRequestWorkflowEnabled(state) {
	  return (0, _lodash.get)(getRequestSettings(state), 'isEditApplicationRequestWorkflowEnabled.Value') === 'ENABLED';
	};
	
	var getRequests = exports.getRequests = function getRequests(state) {
	  return state.portalConfig && state.portalConfig.requests;
	};
	var getAppSecretHashingMetadata = exports.getAppSecretHashingMetadata = function getAppSecretHashingMetadata(state) {
	  return (0, _lodash.get)(state, 'portalConfig.appSecretHashingMetadata');
	};
	var getDeploymentRefreshTime = exports.getDeploymentRefreshTime = function getDeploymentRefreshTime(state) {
	  return (0, _lodash.get)(state, 'portalConfig.deploymentRefreshTime');
	};
	
	var reducePortalAdminAuthorities = function reducePortalAdminAuthorities(acc, value) {
	  var adminAuthorities = ['portaladministrators', 'apiowners'];
	  return acc || adminAuthorities.includes(value.authority);
	};
	
	var getIsPortalAdmin = exports.getIsPortalAdmin = function getIsPortalAdmin(state) {
	  return getUserDetails(state) && getUserDetails(state).authorities && (0, _lodash.reduce)(getUserDetails(state).authorities, reducePortalAdminAuthorities, false);
	};
	
	var reduceOnlyPortalAdminAuthorities = function reduceOnlyPortalAdminAuthorities(acc, value) {
	  var adminAuthorities = ['portaladministrators'];
	  return acc || adminAuthorities.includes(value.authority);
	};
	
	var getIsOnlyPortalAdmin = exports.getIsOnlyPortalAdmin = function getIsOnlyPortalAdmin(state) {
	  return getUserDetails(state) && getUserDetails(state).authorities && (0, _lodash.reduce)(getUserDetails(state).authorities, reduceOnlyPortalAdminAuthorities, false);
	};
	
	var reduceApiOwnerAuthorities = function reduceApiOwnerAuthorities(acc, value) {
	  var adminAuthorities = ['apiowners'];
	  return acc || adminAuthorities.includes(value.authority);
	};
	
	var getIsApiOwner = exports.getIsApiOwner = function getIsApiOwner(state) {
	  return getUserDetails(state) && getUserDetails(state).authorities && (0, _lodash.reduce)(getUserDetails(state).authorities, reduceApiOwnerAuthorities, false);
	};
	
	var reduceOrgPublisherAuthorities = function reduceOrgPublisherAuthorities(acc, value) {
	  var adminAuthorities = ['orgpublishers'];
	  return acc || adminAuthorities.includes(value.authority);
	};
	
	var getIsOrgPublisher = exports.getIsOrgPublisher = function getIsOrgPublisher(state) {
	  return getUserDetails(state) && getUserDetails(state).authorities && (0, _lodash.reduce)(getUserDetails(state).authorities, reduceOrgPublisherAuthorities, false);
	};
	
	var getIsAnonymousRole = exports.getIsAnonymousRole = function getIsAnonymousRole(state) {
	  return getUserDetails(state) && getUserDetails(state).authorities && getUserDetails(state).authorities.length === 0;
	};
	
	var getCookieConsent = exports.getCookieConsent = function getCookieConsent(state) {
	  return (0, _lodash.get)(state, 'portalConfig.themes.display.cookieConsent');
	};
	var getThemeBrandedLabels = exports.getThemeBrandedLabels = function getThemeBrandedLabels(state) {
	  return (0, _lodash.get)(state, 'portalConfig.themes.label');
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(1423));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(594));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(101);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(1424));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(1430);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(1431);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(597);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _batch = __webpack_require__(598);
	
	var _reactBatchedUpdates = __webpack_require__(1433);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(599));
	
	exports.shallowEqual = _shallowEqual["default"];
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var compose = function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  }, function (arg) {
	    return arg;
	  });
	};
	
	var _default = compose;
	exports.default = _default;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1195);


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createMuiTheme: true,
	  unstable_createMuiStrictModeTheme: true,
	  createStyles: true,
	  makeStyles: true,
	  responsiveFontSizes: true,
	  styled: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true,
	  createGenerateClassName: true,
	  jssPreset: true,
	  ServerStyleSheets: true,
	  StylesProvider: true,
	  MuiThemeProvider: true,
	  ThemeProvider: true
	};
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiTheme.default;
	  }
	});
	Object.defineProperty(exports, "unstable_createMuiStrictModeTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiStrictModeTheme.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "responsiveFontSizes", {
	  enumerable: true,
	  get: function get() {
	    return _responsiveFontSizes.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createGenerateClassName;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _styles.jssPreset;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ServerStyleSheets;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.StylesProvider;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	
	var _colorManipulator = __webpack_require__(41);
	
	Object.keys(_colorManipulator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colorManipulator[key];
	    }
	  });
	});
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(237));
	
	var _createMuiStrictModeTheme = _interopRequireDefault(__webpack_require__(920));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(923));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(926));
	
	var _responsiveFontSizes = _interopRequireDefault(__webpack_require__(927));
	
	var _styled = _interopRequireDefault(__webpack_require__(354));
	
	var _transitions = __webpack_require__(60);
	
	Object.keys(_transitions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _transitions[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(930));
	
	var _styles = __webpack_require__(52);

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(74),
	    isObject = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1398);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useForkRef;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _setRef = _interopRequireDefault(__webpack_require__(94));
	
	function useForkRef(refA, refB) {
	  /**
	   * This will create a new function if the ref props change and are defined.
	   * This means react will call the old forkRef with `null` and the new forkRef
	   * with the ref. Cleanup naturally emerges from this behavior
	   */
	  return React.useMemo(function () {
	    if (refA == null && refB == null) {
	      return null;
	    }
	
	    return function (refValue) {
	      (0, _setRef.default)(refA, refValue);
	      (0, _setRef.default)(refB, refValue);
	    };
	  }, [refA, refB]);
	}

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "capitalize", {
	  enumerable: true,
	  get: function get() {
	    return _capitalize.default;
	  }
	});
	Object.defineProperty(exports, "createChainedFunction", {
	  enumerable: true,
	  get: function get() {
	    return _deprecatedPropType.default;
	  }
	});
	Object.defineProperty(exports, "deprecatedPropType", {
	  enumerable: true,
	  get: function get() {
	    return _deprecatedPropType.default;
	  }
	});
	Object.defineProperty(exports, "createSvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _createSvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "debounce", {
	  enumerable: true,
	  get: function get() {
	    return _debounce.default;
	  }
	});
	Object.defineProperty(exports, "isMuiElement", {
	  enumerable: true,
	  get: function get() {
	    return _isMuiElement.default;
	  }
	});
	Object.defineProperty(exports, "ownerDocument", {
	  enumerable: true,
	  get: function get() {
	    return _ownerDocument.default;
	  }
	});
	Object.defineProperty(exports, "ownerWindow", {
	  enumerable: true,
	  get: function get() {
	    return _ownerWindow.default;
	  }
	});
	Object.defineProperty(exports, "requirePropFactory", {
	  enumerable: true,
	  get: function get() {
	    return _requirePropFactory.default;
	  }
	});
	Object.defineProperty(exports, "setRef", {
	  enumerable: true,
	  get: function get() {
	    return _setRef.default;
	  }
	});
	Object.defineProperty(exports, "unsupportedProp", {
	  enumerable: true,
	  get: function get() {
	    return _unsupportedProp.default;
	  }
	});
	Object.defineProperty(exports, "useControlled", {
	  enumerable: true,
	  get: function get() {
	    return _useControlled.default;
	  }
	});
	Object.defineProperty(exports, "useEventCallback", {
	  enumerable: true,
	  get: function get() {
	    return _useEventCallback.default;
	  }
	});
	Object.defineProperty(exports, "useForkRef", {
	  enumerable: true,
	  get: function get() {
	    return _useForkRef.default;
	  }
	});
	Object.defineProperty(exports, "unstable_useId", {
	  enumerable: true,
	  get: function get() {
	    return _unstable_useId.default;
	  }
	});
	Object.defineProperty(exports, "useIsFocusVisible", {
	  enumerable: true,
	  get: function get() {
	    return _useIsFocusVisible.default;
	  }
	});
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(934));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	var _debounce = _interopRequireDefault(__webpack_require__(93));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(139));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(168));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(358));
	
	var _setRef = _interopRequireDefault(__webpack_require__(94));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(169));
	
	var _useControlled = _interopRequireDefault(__webpack_require__(95));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(238));
	
	var _useIsFocusVisible = _interopRequireDefault(__webpack_require__(140));

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(416),
	    getTag = __webpack_require__(267),
	    isArguments = __webpack_require__(191),
	    isArray = __webpack_require__(36),
	    isArrayLike = __webpack_require__(66),
	    isBuffer = __webpack_require__(270),
	    isPrototype = __webpack_require__(188),
	    isTypedArray = __webpack_require__(272);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 37 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(829));

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _styles = __webpack_require__(52);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(137));
	
	function useTheme() {
	  var theme = (0, _styles.useTheme)() || _defaultTheme.default;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(799));

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hexToRgb = hexToRgb;
	exports.rgbToHex = rgbToHex;
	exports.hslToRgb = hslToRgb;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	/* eslint-disable no-use-before-define */
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  if (false) {
	    if (value < min || value > max) {
	      console.error("Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
	    }
	  }
	
	  return Math.min(Math.max(min, value), max);
	}
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 * @returns {string} A CSS rgb color string
	 */
	
	
	function hexToRgb(color) {
	  color = color.substr(1);
	  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? "rgb(".concat(colors.map(function (n) {
	    return parseInt(n, 16);
	  }).join(', '), ")") : '';
	}
	
	function intToHex(int) {
	  var hex = int.toString(16);
	  return hex.length === 1 ? "0".concat(hex) : hex;
	}
	/**
	 * Converts a color from CSS rgb format to CSS hex format.
	 *
	 * @param {string} color - RGB color, i.e. rgb(n, n, n)
	 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
	 */
	
	
	function rgbToHex(color) {
	  // Idempotent
	  if (color.indexOf('#') === 0) {
	    return color;
	  }
	
	  var _decomposeColor = decomposeColor(color),
	      values = _decomposeColor.values;
	
	  return "#".concat(values.map(function (n) {
	    return intToHex(n);
	  }).join(''));
	}
	/**
	 * Converts a color from hsl format to rgb format.
	 *
	 * @param {string} color - HSL color values
	 * @returns {string} rgb color values
	 */
	
	
	function hslToRgb(color) {
	  color = decomposeColor(color);
	  var _color = color,
	      values = _color.values;
	  var h = values[0];
	  var s = values[1] / 100;
	  var l = values[2] / 100;
	  var a = s * Math.min(l, 1 - l);
	
	  var f = function f(n) {
	    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
	    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
	  };
	
	  var type = 'rgb';
	  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
	
	  if (color.type === 'hsla') {
	    type += 'a';
	    rgb.push(values[3]);
	  }
	
	  return recomposeColor({
	    type: type,
	    values: rgb
	  });
	}
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	
	
	function decomposeColor(color) {
	  // Idempotent
	  if (color.type) {
	    return color;
	  }
	
	  if (color.charAt(0) === '#') {
	    return decomposeColor(hexToRgb(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	
	  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
	    throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
	  }
	
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	  return {
	    type: type,
	    values: values
	  };
	}
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	
	
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	  if (type.indexOf('rgb') !== -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  } else if (type.indexOf('hsl') !== -1) {
	    values[1] = "".concat(values[1], "%");
	    values[2] = "".concat(values[2], "%");
	  }
	
	  return "".concat(type, "(").concat(values.join(', '), ")");
	}
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	
	
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	
	
	function getLuminance(color) {
	  color = decomposeColor(color);
	  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
	  rgb = rgb.map(function (val) {
	    val /= 255; // normalized
	
	    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	  }); // Truncate at 3 digits
	
	  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	}
	/**
	 * Darken or lighten a color, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	
	  color.values[3] = value;
	  return recomposeColor(color);
	}
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _pick2 = _interopRequireDefault(__webpack_require__(152));
	
	var _property2 = _interopRequireDefault(__webpack_require__(274));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable func-style */
	
	/* eslint-disable no-use-before-define */
	// Private Functions
	function getCartesianRange(props, axis) {
	  // determine how to lay the axis and what direction positive and negative are
	  var vertical = axis !== "x";
	  var padding = getPadding(props);
	
	  if (vertical) {
	    return [props.height - padding.bottom, padding.top];
	  }
	
	  return [padding.left, props.width - padding.right];
	}
	
	function getPolarRange(props, axis) {
	  if (axis === "x") {
	    var startAngle = degreesToRadians(props.startAngle || 0);
	    var endAngle = degreesToRadians(props.endAngle || 360);
	    return [startAngle, endAngle];
	  }
	
	  return [props.innerRadius || 0, getRadius(props)];
	} // Exported Functions
	
	/**
	 * creates an object with some keys excluded
	 * replacement for lodash.omit for performance. does not mimick the entire lodash.omit api
	 * @param {Object} originalObject: created object will be based on this object
	 * @param {Array<String>} keys: an array of keys to omit from the new object
	 * @returns {Object} new object with same properties as originalObject
	 */
	
	
	function omit(originalObject) {
	  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  // code based on babel's _objectWithoutProperties
	  var newObject = {};
	
	  for (var key in originalObject) {
	    if (keys.indexOf(key) >= 0) {
	      continue;
	    }
	
	    if (!Object.prototype.hasOwnProperty.call(originalObject, key)) {
	      continue;
	    }
	
	    newObject[key] = originalObject[key];
	  }
	
	  return newObject;
	}
	
	function getPoint(datum) {
	  var exists = function (val) {
	    return val !== undefined;
	  };
	
	  var _x = datum._x,
	      _x1 = datum._x1,
	      _x0 = datum._x0,
	      _voronoiX = datum._voronoiX,
	      _y = datum._y,
	      _y1 = datum._y1,
	      _y0 = datum._y0,
	      _voronoiY = datum._voronoiY;
	  var defaultX = exists(_x1) ? _x1 : _x;
	  var defaultY = exists(_y1) ? _y1 : _y;
	  var point = {
	    x: exists(_voronoiX) ? _voronoiX : defaultX,
	    x0: exists(_x0) ? _x0 : _x,
	    y: exists(_voronoiY) ? _voronoiY : defaultY,
	    y0: exists(_y0) ? _y0 : _y
	  };
	  return (0, _defaults2.default)({}, point, datum);
	}
	
	function scalePoint(props, datum) {
	  var scale = props.scale,
	      polar = props.polar,
	      horizontal = props.horizontal;
	  var d = getPoint(datum);
	  var origin = props.origin || {
	    x: 0,
	    y: 0
	  };
	  var x = horizontal ? scale.y(d.y) : scale.x(d.x);
	  var x0 = horizontal ? scale.y(d.y0) : scale.x(d.x0);
	  var y = horizontal ? scale.x(d.x) : scale.y(d.y);
	  var y0 = horizontal ? scale.x(d.x0) : scale.y(d.y0);
	  return {
	    x: polar ? y * Math.cos(x) + origin.x : x,
	    x0: polar ? y0 * Math.cos(x0) + origin.x : x0,
	    y: polar ? -y * Math.sin(x) + origin.y : y,
	    y0: polar ? -y0 * Math.sin(x0) + origin.x : y0
	  };
	}
	
	function getPadding(props) {
	  var padding = props.padding;
	  var paddingVal = typeof padding === "number" ? padding : 0;
	  var paddingObj = typeof padding === "object" ? padding : {};
	  return {
	    top: paddingObj.top || paddingVal,
	    bottom: paddingObj.bottom || paddingVal,
	    left: paddingObj.left || paddingVal,
	    right: paddingObj.right || paddingVal
	  };
	}
	
	function getStyles(style, defaultStyles) {
	  var width = "100%";
	  var height = "100%";
	
	  if (!style) {
	    return (0, _defaults2.default)({
	      parent: {
	        height: height,
	        width: width
	      }
	    }, defaultStyles);
	  }
	
	  var data = style.data,
	      labels = style.labels,
	      parent = style.parent;
	  var defaultParent = defaultStyles && defaultStyles.parent || {};
	  var defaultLabels = defaultStyles && defaultStyles.labels || {};
	  var defaultData = defaultStyles && defaultStyles.data || {};
	  return {
	    parent: (0, _defaults2.default)({}, parent, defaultParent, {
	      width: width,
	      height: height
	    }),
	    labels: (0, _defaults2.default)({}, labels, defaultLabels),
	    data: (0, _defaults2.default)({}, data, defaultData)
	  };
	}
	
	function evaluateProp(prop, props) {
	  return (0, _isFunction2.default)(prop) ? prop(props) : prop;
	}
	
	function evaluateStyle(style, props) {
	  if (!style || !Object.keys(style).some(function (value) {
	    return (0, _isFunction2.default)(style[value]);
	  })) {
	    return style;
	  }
	
	  return Object.keys(style).reduce(function (prev, curr) {
	    prev[curr] = evaluateProp(style[curr], props);
	    return prev;
	  }, {});
	}
	
	function degreesToRadians(degrees) {
	  return typeof degrees === "number" ? degrees * (Math.PI / 180) : degrees;
	}
	
	function radiansToDegrees(radians) {
	  return typeof radians === "number" ? radians / (Math.PI / 180) : radians;
	}
	
	function getRadius(props) {
	  var _getPadding = getPadding(props),
	      left = _getPadding.left,
	      right = _getPadding.right,
	      top = _getPadding.top,
	      bottom = _getPadding.bottom;
	
	  var width = props.width,
	      height = props.height;
	  return Math.min(width - left - right, height - top - bottom) / 2;
	}
	
	function getPolarOrigin(props) {
	  var width = props.width,
	      height = props.height;
	
	  var _getPadding2 = getPadding(props),
	      top = _getPadding2.top,
	      bottom = _getPadding2.bottom,
	      left = _getPadding2.left,
	      right = _getPadding2.right;
	
	  var radius = Math.min(width - left - right, height - top - bottom) / 2;
	  var offsetWidth = width / 2 + left - right;
	  var offsetHeight = height / 2 + top - bottom;
	  return {
	    x: offsetWidth + radius > width ? radius + left - right : offsetWidth,
	    y: offsetHeight + radius > height ? radius + top - bottom : offsetHeight
	  };
	}
	
	function getRange(props, axis) {
	  if (props.range && props.range[axis]) {
	    return props.range[axis];
	  } else if (props.range && Array.isArray(props.range)) {
	    return props.range;
	  }
	
	  return props.polar ? getPolarRange(props, axis) : getCartesianRange(props, axis);
	}
	
	function createAccessor(key) {
	  // creates a data accessor function
	  // given a property key, path, array index, or null for identity.
	  if ((0, _isFunction2.default)(key)) {
	    return key;
	  } else if (key === null || key === undefined) {
	    // null/undefined means "return the data item itself"
	    return function (x) {
	      return x;
	    };
	  } // otherwise, assume it is an array index, property key or path (_.property handles all three)
	
	
	  return (0, _property2.default)(key);
	}
	
	function modifyProps(props, fallbackProps, role) {
	  var theme = props.theme && props.theme[role] ? props.theme[role] : {};
	  var themeProps = omit(theme, ["style"]);
	  var horizontal = isHorizontal(props);
	  var defaultObject = horizontal === undefined ? {} : {
	    horizontal: horizontal
	  };
	  return (0, _defaults2.default)(defaultObject, props, themeProps, fallbackProps);
	}
	/**
	 * Returns the given axis or the opposite axis when horizontal
	 * @param {string} axis: the given axis, either "x" pr "y"
	 * @param {Boolean} horizontal: true when the chart is flipped to the horizontal orientation
	 * @returns {String} the dimension appropriate for the axis given its props "x" or "y"
	 */
	
	
	function getCurrentAxis(axis, horizontal) {
	  var otherAxis = axis === "x" ? "y" : "x";
	  return horizontal ? otherAxis : axis;
	}
	/**
	 * @param {Array} children: an array of child components
	 * @param {Function} iteratee: a function with arguments "child", "childName", and "parent"
	 * @param {Object} parentProps: props from the parent that are applied to children
	 * @param {any}  initialMemo: The object in which the iteration results are combined.
	 * @param {Function} combine: Combines the result of the iteratee with the current memo
	 *   to the memo for the next iteration step
	 * @returns {Array} returns an array of results from calling the iteratee on all nested children
	 */
	
	/* eslint-disable max-params */
	
	
	function reduceChildren(children, iteratee) {
	  var parentProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var initialMemo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var combine = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (memo, item) {
	    return memo.concat(item);
	  };
	  var sharedProps = ["data", "domain", "categories", "polar", "startAngle", "endAngle", "minDomain", "maxDomain", "horizontal"];
	
	  var traverseChildren = function (childArray, names, parent) {
	    return childArray.reduce(function (memo, child, index) {
	      var childRole = child.type && child.type.role;
	      var childName = child.props.name || "".concat(childRole, "-").concat(names[index]);
	
	      if (child.props && child.props.children) {
	        var childProps = (0, _assign2.default)({}, child.props, (0, _pick2.default)(parentProps, sharedProps));
	        var nestedChildren = child.type && (0, _isFunction2.default)(child.type.getChildren) ? child.type.getChildren(childProps) : _react.default.Children.toArray(child.props.children).map(function (c) {
	          var nestedChildProps = (0, _assign2.default)({}, c.props, (0, _pick2.default)(childProps, sharedProps));
	          return _react.default.cloneElement(c, nestedChildProps);
	        });
	
	        var _childNames = nestedChildren.map(function (c, i) {
	          return "".concat(childName, "-").concat(i);
	        });
	
	        var nestedResults = traverseChildren(nestedChildren, _childNames, child);
	        memo = combine(memo, nestedResults);
	      } else {
	        var result = iteratee(child, childName, parent);
	
	        if (result) {
	          memo = combine(memo, result);
	        }
	      }
	
	      return memo;
	    }, initialMemo);
	  };
	
	  var childNames = children.map(function (c, i) {
	    return i;
	  });
	  return traverseChildren(children, childNames);
	}
	/**
	 * @param {Object} props: the props object
	 * @returns {Boolean} returns true if the props object contains `horizontal: true` of if any
	 * children or nested children are hoizontal
	 */
	
	
	function isHorizontal(props) {
	  if (props.horizontal !== undefined || !props.children) {
	    return props.horizontal;
	  }
	
	  var traverseChildren = function (childArray) {
	    return childArray.reduce(function (memo, child) {
	      var childProps = child.props || {};
	
	      if (memo || childProps.horizontal || !childProps.children) {
	        memo = memo || childProps.horizontal;
	        return memo;
	      }
	
	      return traverseChildren(_react.default.Children.toArray(childProps.children));
	    }, false);
	  };
	
	  return traverseChildren(_react.default.Children.toArray(props.children));
	}
	
	var _default = {
	  omit: omit,
	  getPoint: getPoint,
	  scalePoint: scalePoint,
	  getPadding: getPadding,
	  getStyles: getStyles,
	  evaluateProp: evaluateProp,
	  evaluateStyle: evaluateStyle,
	  degreesToRadians: degreesToRadians,
	  radiansToDegrees: radiansToDegrees,
	  getRadius: getRadius,
	  getPolarOrigin: getPolarOrigin,
	  getRange: getRange,
	  createAccessor: createAccessor,
	  modifyProps: modifyProps,
	  getCurrentAxis: getCurrentAxis,
	  reduceChildren: reduceChildren,
	  isHorizontal: isHorizontal
	};
	exports.default = _default;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	
	var _Typography = _interopRequireDefault(__webpack_require__(891));

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(730));

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(166));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var colorString = __webpack_require__(1204);
	var convert = __webpack_require__(1202);
	
	var _slice = [].slice;
	
	var skippedModels = [
		// to be honest, I don't really feel like keyword belongs in color convert, but eh.
		'keyword',
	
		// gray conflicts with some method names, and has its own method defined.
		'gray',
	
		// shouldn't really be in color-convert either...
		'hex'
	];
	
	var hashedModelKeys = {};
	Object.keys(convert).forEach(function (model) {
		hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
	});
	
	var limiters = {};
	
	function Color(obj, model) {
		if (!(this instanceof Color)) {
			return new Color(obj, model);
		}
	
		if (model && model in skippedModels) {
			model = null;
		}
	
		if (model && !(model in convert)) {
			throw new Error('Unknown model: ' + model);
		}
	
		var i;
		var channels;
	
		if (!obj) {
			this.model = 'rgb';
			this.color = [0, 0, 0];
			this.valpha = 1;
		} else if (obj instanceof Color) {
			this.model = obj.model;
			this.color = obj.color.slice();
			this.valpha = obj.valpha;
		} else if (typeof obj === 'string') {
			var result = colorString.get(obj);
			if (result === null) {
				throw new Error('Unable to parse color from string: ' + obj);
			}
	
			this.model = result.model;
			channels = convert[this.model].channels;
			this.color = result.value.slice(0, channels);
			this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
		} else if (obj.length) {
			this.model = model || 'rgb';
			channels = convert[this.model].channels;
			var newArr = _slice.call(obj, 0, channels);
			this.color = zeroArray(newArr, channels);
			this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
		} else if (typeof obj === 'number') {
			// this is always RGB - can be converted later on.
			obj &= 0xFFFFFF;
			this.model = 'rgb';
			this.color = [
				(obj >> 16) & 0xFF,
				(obj >> 8) & 0xFF,
				obj & 0xFF
			];
			this.valpha = 1;
		} else {
			this.valpha = 1;
	
			var keys = Object.keys(obj);
			if ('alpha' in obj) {
				keys.splice(keys.indexOf('alpha'), 1);
				this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
			}
	
			var hashedKeys = keys.sort().join('');
			if (!(hashedKeys in hashedModelKeys)) {
				throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
			}
	
			this.model = hashedModelKeys[hashedKeys];
	
			var labels = convert[this.model].labels;
			var color = [];
			for (i = 0; i < labels.length; i++) {
				color.push(obj[labels[i]]);
			}
	
			this.color = zeroArray(color);
		}
	
		// perform limitations (clamping, etc.)
		if (limiters[this.model]) {
			channels = convert[this.model].channels;
			for (i = 0; i < channels; i++) {
				var limit = limiters[this.model][i];
				if (limit) {
					this.color[i] = limit(this.color[i]);
				}
			}
		}
	
		this.valpha = Math.max(0, Math.min(1, this.valpha));
	
		if (Object.freeze) {
			Object.freeze(this);
		}
	}
	
	Color.prototype = {
		toString: function () {
			return this.string();
		},
	
		toJSON: function () {
			return this[this.model]();
		},
	
		string: function (places) {
			var self = this.model in colorString.to ? this : this.rgb();
			self = self.round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to[self.model](args);
		},
	
		percentString: function (places) {
			var self = this.rgb().round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to.rgb.percent(args);
		},
	
		array: function () {
			return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
		},
	
		object: function () {
			var result = {};
			var channels = convert[this.model].channels;
			var labels = convert[this.model].labels;
	
			for (var i = 0; i < channels; i++) {
				result[labels[i]] = this.color[i];
			}
	
			if (this.valpha !== 1) {
				result.alpha = this.valpha;
			}
	
			return result;
		},
	
		unitArray: function () {
			var rgb = this.rgb().color;
			rgb[0] /= 255;
			rgb[1] /= 255;
			rgb[2] /= 255;
	
			if (this.valpha !== 1) {
				rgb.push(this.valpha);
			}
	
			return rgb;
		},
	
		unitObject: function () {
			var rgb = this.rgb().object();
			rgb.r /= 255;
			rgb.g /= 255;
			rgb.b /= 255;
	
			if (this.valpha !== 1) {
				rgb.alpha = this.valpha;
			}
	
			return rgb;
		},
	
		round: function (places) {
			places = Math.max(places || 0, 0);
			return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
		},
	
		alpha: function (val) {
			if (arguments.length) {
				return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
			}
	
			return this.valpha;
		},
	
		// rgb
		red: getset('rgb', 0, maxfn(255)),
		green: getset('rgb', 1, maxfn(255)),
		blue: getset('rgb', 2, maxfn(255)),
	
		hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style
	
		saturationl: getset('hsl', 1, maxfn(100)),
		lightness: getset('hsl', 2, maxfn(100)),
	
		saturationv: getset('hsv', 1, maxfn(100)),
		value: getset('hsv', 2, maxfn(100)),
	
		chroma: getset('hcg', 1, maxfn(100)),
		gray: getset('hcg', 2, maxfn(100)),
	
		white: getset('hwb', 1, maxfn(100)),
		wblack: getset('hwb', 2, maxfn(100)),
	
		cyan: getset('cmyk', 0, maxfn(100)),
		magenta: getset('cmyk', 1, maxfn(100)),
		yellow: getset('cmyk', 2, maxfn(100)),
		black: getset('cmyk', 3, maxfn(100)),
	
		x: getset('xyz', 0, maxfn(100)),
		y: getset('xyz', 1, maxfn(100)),
		z: getset('xyz', 2, maxfn(100)),
	
		l: getset('lab', 0, maxfn(100)),
		a: getset('lab', 1),
		b: getset('lab', 2),
	
		keyword: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return convert[this.model].keyword(this.color);
		},
	
		hex: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return colorString.to.hex(this.rgb().round().color);
		},
	
		rgbNumber: function () {
			var rgb = this.rgb().color;
			return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.rgb().color;
	
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
	
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
	
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
	
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.rgb().color;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = this.rgb();
			for (var i = 0; i < 3; i++) {
				rgb.color[i] = 255 - rgb.color[i];
			}
			return rgb;
		},
	
		lighten: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] += hsl.color[2] * ratio;
			return hsl;
		},
	
		darken: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] -= hsl.color[2] * ratio;
			return hsl;
		},
	
		saturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] += hsl.color[1] * ratio;
			return hsl;
		},
	
		desaturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] -= hsl.color[1] * ratio;
			return hsl;
		},
	
		whiten: function (ratio) {
			var hwb = this.hwb();
			hwb.color[1] += hwb.color[1] * ratio;
			return hwb;
		},
	
		blacken: function (ratio) {
			var hwb = this.hwb();
			hwb.color[2] += hwb.color[2] * ratio;
			return hwb;
		},
	
		grayscale: function () {
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var rgb = this.rgb().color;
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			return Color.rgb(val, val, val);
		},
	
		fade: function (ratio) {
			return this.alpha(this.valpha - (this.valpha * ratio));
		},
	
		opaquer: function (ratio) {
			return this.alpha(this.valpha + (this.valpha * ratio));
		},
	
		rotate: function (degrees) {
			var hsl = this.hsl();
			var hue = hsl.color[0];
			hue = (hue + degrees) % 360;
			hue = hue < 0 ? 360 + hue : hue;
			hsl.color[0] = hue;
			return hsl;
		},
	
		mix: function (mixinColor, weight) {
			// ported from sass implementation in C
			// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
			var color1 = this.rgb();
			var color2 = mixinColor.rgb();
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return Color.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue(),
					color1.alpha() * p + color2.alpha() * (1 - p));
		}
	};
	
	// model conversion methods and static constructors
	Object.keys(convert).forEach(function (model) {
		if (skippedModels.indexOf(model) !== -1) {
			return;
		}
	
		var channels = convert[model].channels;
	
		// conversion methods
		Color.prototype[model] = function () {
			if (this.model === model) {
				return new Color(this);
			}
	
			if (arguments.length) {
				return new Color(arguments, model);
			}
	
			var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
			return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
		};
	
		// 'static' construction methods
		Color[model] = function (color) {
			if (typeof color === 'number') {
				color = zeroArray(_slice.call(arguments), channels);
			}
			return new Color(color, model);
		};
	});
	
	function roundTo(num, places) {
		return Number(num.toFixed(places));
	}
	
	function roundToPlace(places) {
		return function (num) {
			return roundTo(num, places);
		};
	}
	
	function getset(model, channel, modifier) {
		model = Array.isArray(model) ? model : [model];
	
		model.forEach(function (m) {
			(limiters[m] || (limiters[m] = []))[channel] = modifier;
		});
	
		model = model[0];
	
		return function (val) {
			var result;
	
			if (arguments.length) {
				if (modifier) {
					val = modifier(val);
				}
	
				result = this[model]();
				result.color[channel] = val;
				return result;
			}
	
			result = this[model]().color[channel];
			if (modifier) {
				result = modifier(result);
			}
	
			return result;
		};
	}
	
	function maxfn(max) {
		return function (v) {
			return Math.max(0, Math.min(max, v));
		};
	}
	
	function assertArray(val) {
		return Array.isArray(val) ? val : [val];
	}
	
	function zeroArray(arr, length) {
		for (var i = 0; i < length; i++) {
			if (typeof arr[i] !== 'number') {
				arr[i] = 0;
			}
		}
	
		return arr;
	}
	
	module.exports = Color;


/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1414);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	HTML escaping is the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var intl_messageformat_1 = __webpack_require__(402);
	var intl_format_cache_1 = __webpack_require__(398);
	var intl_utils_1 = __webpack_require__(218);
	var ESCAPED_CHARS = {
	    38: '&amp;',
	    62: '&gt;',
	    60: '&lt;',
	    34: '&quot;',
	    39: '&#x27;',
	};
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) { return ESCAPED_CHARS[match.charCodeAt(0)]; });
	}
	exports.escape = escape;
	function filterProps(props, whitelist, defaults) {
	    if (defaults === void 0) { defaults = {}; }
	    return whitelist.reduce(function (filtered, name) {
	        if (name in props) {
	            filtered[name] = props[name];
	        }
	        else if (name in defaults) {
	            filtered[name] = defaults[name];
	        }
	        return filtered;
	    }, {});
	}
	exports.filterProps = filterProps;
	function invariantIntlContext(intl) {
	    intl_utils_1.invariant(intl, '[React Intl] Could not find required `intl` object. ' +
	        '<IntlProvider> needs to exist in the component ancestry.');
	}
	exports.invariantIntlContext = invariantIntlContext;
	function createError(message, exception) {
	    var eMsg = exception ? "\n" + exception.stack : '';
	    return "[React Intl] " + message + eMsg;
	}
	exports.createError = createError;
	function defaultErrorHandler(error) {
	    if (false) {
	        console.error(error);
	    }
	}
	exports.defaultErrorHandler = defaultErrorHandler;
	exports.DEFAULT_INTL_CONFIG = {
	    formats: {},
	    messages: {},
	    timeZone: undefined,
	    textComponent: React.Fragment,
	    defaultLocale: 'en',
	    defaultFormats: {},
	    onError: defaultErrorHandler,
	};
	function createIntlCache() {
	    return {
	        dateTime: {},
	        number: {},
	        message: {},
	        relativeTime: {},
	        pluralRules: {},
	        list: {},
	    };
	}
	exports.createIntlCache = createIntlCache;
	/**
	 * Create intl formatters and populate cache
	 * @param cache explicit cache to prevent leaking memory
	 */
	function createFormatters(cache) {
	    if (cache === void 0) { cache = createIntlCache(); }
	    var RelativeTimeFormat = Intl.RelativeTimeFormat;
	    var ListFormat = Intl.ListFormat;
	    return {
	        getDateTimeFormat: intl_format_cache_1.default(Intl.DateTimeFormat, cache.dateTime),
	        getNumberFormat: intl_format_cache_1.default(Intl.NumberFormat, cache.number),
	        getMessageFormat: intl_format_cache_1.default(intl_messageformat_1.default, cache.message),
	        getRelativeTimeFormat: intl_format_cache_1.default(RelativeTimeFormat, cache.relativeTime),
	        getPluralRules: intl_format_cache_1.default(Intl.PluralRules, cache.pluralRules),
	        getListFormat: intl_format_cache_1.default(ListFormat, cache.list),
	    };
	}
	exports.createFormatters = createFormatters;
	function getNamedFormat(formats, type, name, onError) {
	    var formatType = formats && formats[type];
	    var format;
	    if (formatType) {
	        format = formatType[name];
	    }
	    if (format) {
	        return format;
	    }
	    onError(createError("No " + type + " format named: " + name));
	}
	exports.getNamedFormat = getNamedFormat;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(696);
	
	var iterableToArray = __webpack_require__(309);
	
	var unsupportedIterableToArray = __webpack_require__(217);
	
	var nonIterableSpread = __webpack_require__(700);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.2
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createGenerateClassName: true,
	  createStyles: true,
	  getThemeProps: true,
	  jssPreset: true,
	  makeStyles: true,
	  mergeClasses: true,
	  ServerStyleSheets: true,
	  styled: true,
	  StylesProvider: true,
	  ThemeProvider: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true
	};
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "getThemeProps", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "mergeClasses", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _utils = __webpack_require__(21);
	
	var _createGenerateClassName = _interopRequireWildcard(__webpack_require__(245));
	
	Object.keys(_createGenerateClassName).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createGenerateClassName[key];
	    }
	  });
	});
	
	var _createStyles = _interopRequireWildcard(__webpack_require__(995));
	
	Object.keys(_createStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createStyles[key];
	    }
	  });
	});
	
	var _getThemeProps = _interopRequireWildcard(__webpack_require__(372));
	
	Object.keys(_getThemeProps).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getThemeProps[key];
	    }
	  });
	});
	
	var _jssPreset = _interopRequireWildcard(__webpack_require__(373));
	
	Object.keys(_jssPreset).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _jssPreset[key];
	    }
	  });
	});
	
	var _makeStyles = _interopRequireWildcard(__webpack_require__(246));
	
	Object.keys(_makeStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _makeStyles[key];
	    }
	  });
	});
	
	var _mergeClasses = _interopRequireWildcard(__webpack_require__(374));
	
	Object.keys(_mergeClasses).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mergeClasses[key];
	    }
	  });
	});
	
	var _ServerStyleSheets = _interopRequireWildcard(__webpack_require__(989));
	
	Object.keys(_ServerStyleSheets).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ServerStyleSheets[key];
	    }
	  });
	});
	
	var _styled = _interopRequireWildcard(__webpack_require__(1006));
	
	Object.keys(_styled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styled[key];
	    }
	  });
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(244));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});
	
	var _ThemeProvider = _interopRequireWildcard(__webpack_require__(992));
	
	Object.keys(_ThemeProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ThemeProvider[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireWildcard(__webpack_require__(145));
	
	Object.keys(_useTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useTheme[key];
	    }
	  });
	});
	
	var _withStyles = _interopRequireWildcard(__webpack_require__(1009));
	
	Object.keys(_withStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withStyles[key];
	    }
	  });
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(1011));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});
	
	/* eslint-disable import/export */
	
	/* Warning if there are several instances of @material-ui/styles */
	if (false) {
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] = _utils.ponyfillGlobal['__@material-ui/styles-init__'] || 0;
	
	  if (_utils.ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
	    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
	  }
	
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] += 1;
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(384);
	var isBuffer = __webpack_require__(1251);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Function equal to merge with the difference being that no reference
	 * to original objects is kept.
	 *
	 * @see merge
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function deepMerge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = deepMerge(result[key], val);
	    } else if (typeof val === 'object') {
	      result[key] = deepMerge({}, val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  deepMerge: deepMerge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createEmotion = _interopDefault(__webpack_require__(1215));
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var _createEmotion = createEmotion(context),
	    flush = _createEmotion.flush,
	    hydrate = _createEmotion.hydrate,
	    cx = _createEmotion.cx,
	    merge = _createEmotion.merge,
	    getRegisteredStyles = _createEmotion.getRegisteredStyles,
	    injectGlobal = _createEmotion.injectGlobal,
	    keyframes = _createEmotion.keyframes,
	    css = _createEmotion.css,
	    sheet = _createEmotion.sheet,
	    caches = _createEmotion.caches;
	
	exports.flush = flush;
	exports.hydrate = hydrate;
	exports.cx = cx;
	exports.merge = merge;
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.injectGlobal = injectGlobal;
	exports.keyframes = keyframes;
	exports.css = css;
	exports.sheet = sheet;
	exports.caches = caches;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "LOCATION_CHANGE", {
	  enumerable: true,
	  get: function get() {
	    return _actions.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, "CALL_HISTORY_METHOD", {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, "onLocationChanged", {
	  enumerable: true,
	  get: function get() {
	    return _actions.onLocationChanged;
	  }
	});
	Object.defineProperty(exports, "push", {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, "replace", {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, "go", {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, "goBack", {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, "goForward", {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, "routerActions", {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	Object.defineProperty(exports, "routerMiddleware", {
	  enumerable: true,
	  get: function get() {
	    return _middleware.default;
	  }
	});
	exports.createMatchSelector = exports.getSearch = exports.getHash = exports.getAction = exports.getLocation = exports.connectRouter = exports.ConnectedRouter = void 0;
	
	var _ConnectedRouter = _interopRequireDefault(__webpack_require__(1205));
	
	var _reducer = _interopRequireDefault(__webpack_require__(1207));
	
	var _selectors = _interopRequireDefault(__webpack_require__(389));
	
	var _plain = _interopRequireDefault(__webpack_require__(1209));
	
	var _actions = __webpack_require__(174);
	
	var _middleware = _interopRequireDefault(__webpack_require__(1206));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConnectedRouter =
	/*#__PURE__*/
	(0, _ConnectedRouter.default)(_plain.default);
	exports.ConnectedRouter = ConnectedRouter;
	var connectRouter =
	/*#__PURE__*/
	(0, _reducer.default)(_plain.default);
	exports.connectRouter = connectRouter;
	
	var _createSelectors =
	/*#__PURE__*/
	(0, _selectors.default)(_plain.default),
	    getLocation = _createSelectors.getLocation,
	    getAction = _createSelectors.getAction,
	    getHash = _createSelectors.getHash,
	    getSearch = _createSelectors.getSearch,
	    createMatchSelector = _createSelectors.createMatchSelector;
	
	exports.createMatchSelector = createMatchSelector;
	exports.getSearch = getSearch;
	exports.getHash = getHash;
	exports.getAction = getAction;
	exports.getLocation = getLocation;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(410),
	    baseKeys = __webpack_require__(416),
	    isArrayLike = __webpack_require__(66);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1180);

/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 59 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.duration = exports.easing = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	exports.easing = easing;
	var duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	exports.duration = duration;
	
	function formatMs(milliseconds) {
	  return "".concat(Math.round(milliseconds), "ms");
	}
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	
	
	var _default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$duration = options.duration,
	        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
	        _options$easing = options.easing,
	        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
	        _options$delay = options.delay,
	        delay = _options$delay === void 0 ? 0 : _options$delay,
	        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
	
	    if (false) {
	      var isString = function isString(value) {
	        return typeof value === 'string';
	      };
	
	      var isNumber = function isNumber(value) {
	        return !isNaN(parseFloat(value));
	      };
	
	      if (!isString(props) && !Array.isArray(props)) {
	        console.error('Material-UI: argument "props" must be a string or Array.');
	      }
	
	      if (!isNumber(durationOption) && !isString(durationOption)) {
	        console.error("Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
	      }
	
	      if (!isString(easingOption)) {
	        console.error('Material-UI: argument "easing" must be a string.');
	      }
	
	      if (!isNumber(delay) && !isString(delay)) {
	        console.error('Material-UI: argument "delay" must be a number or a string.');
	      }
	
	      if (Object.keys(other).length !== 0) {
	        console.error("Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]"));
	      }
	    }
	
	    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
	    }).join(',');
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};
	exports.default = _default;

/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
	}), 'Help');
	
	exports.default = _default;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(377));
	
	var _breakpoints = __webpack_require__(247);
	
	function getPath(obj, path) {
	  if (!path || typeof path !== 'string') {
	    return null;
	  }
	
	  return path.split('.').reduce(function (acc, item) {
	    return acc && acc[item] ? acc[item] : null;
	  }, obj);
	}
	
	function style(options) {
	  var prop = options.prop,
	      _options$cssProperty = options.cssProperty,
	      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
	      themeKey = options.themeKey,
	      transform = options.transform;
	
	  var fn = function fn(props) {
	    if (props[prop] == null) {
	      return null;
	    }
	
	    var propValue = props[prop];
	    var theme = props.theme;
	    var themeMapping = getPath(theme, themeKey) || {};
	
	    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
	      var value;
	
	      if (typeof themeMapping === 'function') {
	        value = themeMapping(propValueFinal);
	      } else if (Array.isArray(themeMapping)) {
	        value = themeMapping[propValueFinal] || propValueFinal;
	      } else {
	        value = getPath(themeMapping, propValueFinal) || propValueFinal;
	
	        if (transform) {
	          value = transform(value);
	        }
	      }
	
	      if (cssProperty === false) {
	        return value;
	      }
	
	      return (0, _defineProperty2.default)({}, cssProperty, value);
	    };
	
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  };
	
	  fn.propTypes =  false ? (0, _defineProperty2.default)({}, prop, _responsivePropType.default) : {};
	  fn.filterProps = [prop];
	  return fn;
	}
	
	var _default = style;
	exports.default = _default;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(423);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(31),
	    isLength = __webpack_require__(271);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(74),
	    getPrototype = __webpack_require__(426),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCompatibleBundleVersion = exports.convertBundleVersionDate = exports.formatDateString = exports.zone = exports.getTimeZoneAbbr = exports.getTimeZone = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var _momentTimezone = __webpack_require__(1383);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTimeZone = exports.getTimeZone = function getTimeZone() {
	  return _momentTimezone2.default.tz.guess();
	};
	
	var getTimeZoneAbbr = exports.getTimeZoneAbbr = function getTimeZoneAbbr() {
	  return _momentTimezone2.default.tz([2012, 5], getTimeZone()).zoneAbbr();
	};
	
	var zone = exports.zone = getTimeZone(); //'America/Los_Angeles';
	
	var formatDateString = exports.formatDateString = function formatDateString(dateString) {
	  if (dateString) {
	    var arrDateFields = dateString.split(' ');
	    var month = arrDateFields[1];
	    var date = arrDateFields[2];
	    var year = arrDateFields[3];
	
	    var formattedTimeString = '';
	    if (arrDateFields[4]) {
	      // time string
	      var arrTimeFields = arrDateFields[4].split(':');
	      var hour = arrTimeFields[0];
	      var mins = arrTimeFields[1];
	      formattedTimeString = hour + ':' + mins;
	    }
	    return month + ' ' + date + ' ' + year + ' ' + formattedTimeString;
	  }
	  return '';
	};
	
	exports.default = function (value) {
	  var _value = value && (0, _lodash.toNumber)(value);
	  var date = (0, _lodash.isFinite)(_value) ? _value : value;
	  return date && _momentTimezone2.default.tz(new Date(date), zone).format('MMM DD YYYY HH:mm');
	};
	
	var convertBundleVersionDate = exports.convertBundleVersionDate = function convertBundleVersionDate(bundleDate) {
	  var arrDateFields = bundleDate.split('.');
	  var year = arrDateFields[1].substr(0, 4);
	  var month = arrDateFields[1].substr(4, 2);
	  var day = arrDateFields[1].substr(6, 2);
	  var hour = arrDateFields[2].substr(0, 2);
	  var mins = arrDateFields[2].substr(2, 2);
	  var seconds = arrDateFields[3];
	  return new Date(Date.UTC(year, month, day, hour, mins, seconds)).getTime();
	};
	
	var isCompatibleBundleVersion = exports.isCompatibleBundleVersion = function isCompatibleBundleVersion(bundleVersion) {
	  var supportedBundleVersion = "UTC.20201126.1200.00";
	  if (bundleVersion && bundleVersion.split('.').length === 4) {
	    var supportedTime = convertBundleVersionDate(supportedBundleVersion);
	    var bundleTime = convertBundleVersionDate(bundleVersion);
	    return supportedTime <= bundleTime;
	  }
	  return false;
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(307);
	
	var iterableToArrayLimit = __webpack_require__(699);
	
	var unsupportedIterableToArray = __webpack_require__(217);
	
	var nonIterableRest = __webpack_require__(310);
	
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}
	
	module.exports = _slicedToArray;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	Object.defineProperty(exports, "unstable_StrictModeCollapse", {
	  enumerable: true,
	  get: function get() {
	    return _StrictModeCollapse.default;
	  }
	});
	
	var _Collapse = _interopRequireDefault(__webpack_require__(314));
	
	var _StrictModeCollapse = _interopRequireDefault(__webpack_require__(750));

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	
	var _Grid = _interopRequireDefault(__webpack_require__(785));

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useEventCallback;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
	 *
	 * @param {function} fn
	 */
	
	function useEventCallback(fn) {
	  var ref = React.useRef(fn);
	  useEnhancedEffect(function () {
	    ref.current = fn;
	  });
	  return React.useCallback(function () {
	    return (0, ref.current).apply(void 0, arguments);
	  }, []);
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _merge = _interopRequireDefault(__webpack_require__(173));
	
	function compose() {
	  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var fn = function fn(props) {
	    return styles.reduce(function (acc, style) {
	      var output = style(props);
	
	      if (output) {
	        return (0, _merge.default)(acc, output);
	      }
	
	      return acc;
	    }, {});
	  }; // Alternative approach that doesn't yield any performance gain.
	  // const handlers = styles.reduce((acc, style) => {
	  //   style.filterProps.forEach(prop => {
	  //     acc[prop] = style;
	  //   });
	  //   return acc;
	  // }, {});
	  // const fn = props => {
	  //   return Object.keys(props).reduce((acc, prop) => {
	  //     if (handlers[prop]) {
	  //       return merge(acc, handlers[prop](props));
	  //     }
	  //     return acc;
	  //   }, {});
	  // };
	
	
	  fn.propTypes =  false ? styles.reduce(function (acc, style) {
	    return (0, _extends2.default)(acc, style.propTypes);
	  }, {}) : {};
	  fn.filterProps = styles.reduce(function (acc, style) {
	    return acc.concat(style.filterProps);
	  }, []);
	  return fn;
	}
	
	var _default = compose;
	exports.default = _default;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(148),
	    getRawTag = __webpack_require__(1321),
	    objectToString = __webpack_require__(1348);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1284),
	    baseMatchesProperty = __webpack_require__(1285),
	    identity = __webpack_require__(76),
	    isArray = __webpack_require__(36),
	    property = __webpack_require__(274);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var HELPITEMS = exports.HELPITEMS = {
	  visibilityHelp: {
	    title: 'Visibility Help',
	    descriptions: 'Set up which users can view this API.',
	    subItems: [{
	      id: 0,
	      title: 'Public',
	      descriptions: 'If you set the visibility to Public, any user can view or consume this API.'
	    }, {
	      id: 1,
	      title: 'Private',
	      descriptions: 'If you set the visibility to Private, all API Owners and Org Users of the managing org (if selected) can view or consume this API.'
	    }, {
	      id: 2,
	      title: 'Restricted',
	      descriptions: 'If you set the visibility to Restricted, all API Owners and Org Users of selected organizations can view or consume this API.'
	    }]
	  },
	  permissionsHelp: {
	    title: 'Management Permissions',
	    descriptions: 'You must specify at least one Managing Organization OR API Owner.',
	    subItems: [{
	      id: 0,
	      title: 'Managing Org',
	      descriptions: 'Selecting a managing org allows all users in that org that have permission to edit apis (e.g. org publishers) to edit this API.'
	    }, {
	      id: 1,
	      title: 'API Owner',
	      descriptions: 'By default all APIs are open to be edited by all API Owners, but it can be restricted on to select individuals.'
	    }, {
	      id: 2,
	      title: '',
	      descriptions: 'For API owners that are always assigned to edit individual APIs, consider adding them to the appropriate organizations in an org publisher role instead.'
	    }]
	  },
	  detailsHelp: {
	    title: 'How do I publish an API?',
	    descriptions: '',
	    subItems: [{
	      id: 1,
	      title: '',
	      descriptions: 'Select the type of API you would like to publish (REST or SOAP).'
	    }, {
	      id: 2,
	      title: '',
	      descriptions: 'Upload the corresponding definition files. For REST, Swagger or WADL files are supported. For SOAP, a WSDL file is required and XSD files are optional. Once uploaded, this will pre-fill the API details for you.'
	    }, {
	      id: 3,
	      title: '',
	      descriptions: 'If you do not have any definition files, provide API details manually in the next section, and any mandatory fields that are not filled.'
	    }, {
	      id: 4,
	      title: '',
	      descriptions: 'Add your proxy URI to the Proxy Details field. The proxy URL is the public URL of the API on the API proxy. Developers use this URL in their applications to send requests to the API.'
	    }, {
	      id: 5,
	      title: '',
	      descriptions: 'For Gateway published APIs, select an API EULA, complete the remaining mandatory fields and save. This will enable the API.'
	    }]
	  },
	  customFieldsHelp: {
	    title: '',
	    descriptions: '',
	    subItems: [{
	      id: 1,
	      title: '',
	      descriptions: 'Custom fields are defined by your Administrator to provide additional metadata for your API.'
	    }]
	  },
	  policyTemplatesHelp: {
	    title: '',
	    descriptions: '',
	    subItems: [{
	      id: 1,
	      title: '',
	      descriptions: 'Policy Templates are defined by your Administrator and enable you to apply advanced runtime protection.'
	    }, {
	      id: 2,
	      title: '',
	      descriptions: 'You can add one or more policies and they will be applied in the selected order when requests to your API are processed.'
	    }]
	  },
	  specAuthenticationHelp: {
	    title: '',
	    descriptions: '',
	    subItems: [{
	      id: 1,
	      title: '',
	      descriptions: 'For REST APIs, the Spec Authentication tab will allow you to configure the authentication settings to test your API via the Spec tab. Note that the Spec Authentication tab and testing via the Spec tab is not available for SOAP APIs.'
	    }]
	  },
	  tagsHelp: {
	    title: '',
	    descriptions: 'Adding tags is a way to group categories of relevant APIs. Tags surface on the APIs’ list view and card view. Consumers can then search and discover APIs according to their visibility permissions using these tags.',
	    subItems: [{
	      id: 1,
	      title: '',
	      descriptions: 'You can add up to 25 tags to an API. Maximum tag length is 60 characters.'
	    }, {
	      id: 2,
	      title: '',
	      descriptions: 'Only global and API level tags are added. Endpoint level tags will not be shown.'
	    }]
	  },
	  publishStateHelp: {
	    title: '',
	    descriptions: 'Select the state of your API. States surface on the APIs’ list view and card view and can be filtered accordingly.',
	    subItems: []
	  }
	};
	
	var UNSAVED_DIALOG_TITLE = exports.UNSAVED_DIALOG_TITLE = 'Unsaved Changes';
	var UNSAVED_DIALOG_DESCRIPTIONS = exports.UNSAVED_DIALOG_DESCRIPTIONS = 'Your changes will be lost if you leave this page. Are you sure you want to continue away from this page?';
	var UNSAVED_DIALOG_CANCEL_TEXT = exports.UNSAVED_DIALOG_CANCEL_TEXT = 'Stay';
	var UNSAVED_DIALOG_SUBMIT_TEXT = exports.UNSAVED_DIALOG_SUBMIT_TEXT = 'Continue';
	var UNSAVED_DIALOG_EXIT_TEXT = exports.UNSAVED_DIALOG_EXIT_TEXT = 'Exit';
	var API_DETAILS_UPDATE_SUCCESS = exports.API_DETAILS_UPDATE_SUCCESS = 'Api updated.';
	var API_CUSTOM_FIELDS_UPDATE_SUCCESS = exports.API_CUSTOM_FIELDS_UPDATE_SUCCESS = 'Custom Fields updated.';
	var POLICY_TEMPLATE_SAVE_SUCCESS = exports.POLICY_TEMPLATE_SAVE_SUCCESS = 'Policy Templates updated.';
	var PUBLISH_STATE_SAVE_SUCCESS = exports.PUBLISH_STATE_SAVE_SUCCESS = 'Publish state updated.';
	var SPEC_AUTHENTICATION_SAVE_SUCCESS = exports.SPEC_AUTHENTICATION_SAVE_SUCCESS = 'Spec Authentication updated.';
	var VISIBILITY_SAVE_SUCCESS = exports.VISIBILITY_SAVE_SUCCESS = 'Visibility permissions updated.';
	var MANAGEMENT_SAVE_SUCCESS = exports.MANAGEMENT_SAVE_SUCCESS = 'Management permissions updated.';
	var TAGS_ASSOCIATION_SAVE_SUCCESS = exports.TAGS_ASSOCIATION_SAVE_SUCCESS = 'Tags association updated.';
	
	var ID_PRIVATE = exports.ID_PRIVATE = '0';
	var ID_PUBLIC = exports.ID_PUBLIC = '1';
	var ID_RESTRICTED = exports.ID_RESTRICTED = '2';
	var API_ACCESS_STATUS_PUBLIC = exports.API_ACCESS_STATUS_PUBLIC = 'PUBLIC';
	var API_ACCESS_STATUS_PRIVATE = exports.API_ACCESS_STATUS_PRIVATE = 'PRIVATE';
	
	// VISIBILiTY PAGE
	var VISIBILTY_PERMISSIONS_DATA = exports.VISIBILTY_PERMISSIONS_DATA = [{
	  id: ID_PUBLIC,
	  name: 'Public',
	  description: 'The API is visible to users in all organizations.'
	}, {
	  id: ID_PRIVATE,
	  name: 'Private',
	  description: 'The API is visible to my organization users only (if applicable).'
	}, {
	  id: ID_RESTRICTED,
	  name: 'Restricted',
	  description: 'Specify which organization\'s users can see this API.'
	}];
	
	var VISIBILITY_ORG_TITLE = exports.VISIBILITY_ORG_TITLE = 'Organizations';
	var VISIBILITY_ORG_SUB_TITLE = exports.VISIBILITY_ORG_SUB_TITLE = 'All available organizations.';
	var VISIBILITY_ORG_PLACE_HOLDER_TEXT = exports.VISIBILITY_ORG_PLACE_HOLDER_TEXT = 'Filter by organization name';
	var VISIBILITY_SELECTED_ORG_TITLE = exports.VISIBILITY_SELECTED_ORG_TITLE = 'Selected';
	var VISIBILITY_SELECTED_ORG_SUB_TITLE = exports.VISIBILITY_SELECTED_ORG_SUB_TITLE = 'Selected organization\'s users can see the API.';
	var VISIBILITY_SELECTED_ORG_PLACE_HOLDER_TEXT = exports.VISIBILITY_SELECTED_ORG_PLACE_HOLDER_TEXT = 'Search selected organizations';
	var VISIBILITY_NEXT_TEXT = exports.VISIBILITY_NEXT_TEXT = 'Save & Next';
	var VISIBILITY_ASSIST_TEXT = exports.VISIBILITY_ASSIST_TEXT = 'Set permissions and proceed to next step.';
	var VISIBILITY_SELECTED_ITEM_ERROR_MESSAGE = exports.VISIBILITY_SELECTED_ITEM_ERROR_MESSAGE = 'Select at least one organization.';
	
	// Management page
	var MANAGEMENT_PERMISSIONS_DATA = exports.MANAGEMENT_PERMISSIONS_DATA = [{
	  id: ID_PUBLIC,
	  name: 'Open',
	  description: 'Global Publishers with API management permissions can edit this API.'
	}, {
	  id: ID_PRIVATE,
	  name: 'Private',
	  description: 'Only I can edit this API.'
	}, {
	  id: ID_RESTRICTED,
	  name: 'Restricted',
	  description: 'Specify users with API management permissions to edit this API.'
	}];
	
	var MANAGEMENT_USER_TITLE = exports.MANAGEMENT_USER_TITLE = 'Users';
	var MANAGEMENT_USER_SUB_TITLE = exports.MANAGEMENT_USER_SUB_TITLE = 'All users that can edit this API.';
	var MANAGEMENT_USER__PLACE_HOLDER_TEXT = exports.MANAGEMENT_USER__PLACE_HOLDER_TEXT = 'Filter by user name';
	var MANAGEMENT_SELECTED_USER_TITLE = exports.MANAGEMENT_SELECTED_USER_TITLE = 'Selected';
	var MANAGEMENT_SELECTED_USER_SUB_TITLE = exports.MANAGEMENT_SELECTED_USER_SUB_TITLE = 'Selected users can edit this API.';
	var MANAGEMENT_USER_PLACE_HOLDER_TEXT = exports.MANAGEMENT_USER_PLACE_HOLDER_TEXT = 'Search selected users';
	var MANAGEMENT_SELECTED_ITEM_ERROR_MESSAGE = exports.MANAGEMENT_SELECTED_ITEM_ERROR_MESSAGE = 'Select at least one user.';
	var ERROR_TITLE_TEXT = exports.ERROR_TITLE_TEXT = 'Unable to carry out the operation. No updates have been made. See details below.';
	
	var TAGS_TITLE = exports.TAGS_TITLE = 'label.api.tags.title';
	var TAGS_SUB_TITLE = exports.TAGS_SUB_TITLE = 'label.api.tags.subtitle';
	var TAGS_PLACE_HOLDER_TEXT = exports.TAGS_PLACE_HOLDER_TEXT = 'label.api.tags.placeholder';
	var TAGS_SELECTED_TAG_TITLE = exports.TAGS_SELECTED_TAG_TITLE = 'label.api.tags.title.selected';
	var TAGS_SELECTED_TAG_SUB_TITLE = exports.TAGS_SELECTED_TAG_SUB_TITLE = 'label.api.tags.subtitle.selected';
	var TAGS_ADD_NEW_TAG = exports.TAGS_ADD_NEW_TAG = 'label.api.tags.add.newtag.text';
	var TAGS_SELECT_SWAGGER_TAGS = exports.TAGS_SELECT_SWAGGER_TAGS = 'label.api.tags.select.swagger.tags';
	var TAGS_UNSELECT_SWAGGER_TAGS = exports.TAGS_UNSELECT_SWAGGER_TAGS = 'label.api.tags.clear.swagger.tags';
	var TAGS_SOURCE_SWAGGER_TEXT = exports.TAGS_SOURCE_SWAGGER_TEXT = 'label.api.tags.source.swagger.swagger';
	var TAGS_SOURCE_PORTAL_TEXT = exports.TAGS_SOURCE_PORTAL_TEXT = 'label.api.tags.source.swagger.portal';
	var TAGS_IMPORT_SWAGGER_TAGS_ERROR = exports.TAGS_IMPORT_SWAGGER_TAGS_ERROR = 'error.api.tags.import.swagger.tags';
	var TAGS_ASSOCIATION_LIMIT_MSG = exports.TAGS_ASSOCIATION_LIMIT_MSG = 'error.api.tags.max.assoication.limit';
	var TAGS_INVALID_ERROR = exports.TAGS_INVALID_ERROR = 'error.api.tags.validation.new.tag';
	
	var API_DETAILS_SAVE_SUCCESS = exports.API_DETAILS_SAVE_SUCCESS = 'Api is created.';
	var ID_REST = exports.ID_REST = '0';
	var ID_SOAP = exports.ID_SOAP = '1';
	var REST_TYPE = exports.REST_TYPE = 'REST';
	var SOAP_TYPE = exports.SOAP_TYPE = 'SOAP';
	var API_DETAILS_TYPE = exports.API_DETAILS_TYPE = [{
	  id: ID_REST,
	  name: 'REST',
	  description: ''
	}, {
	  id: ID_SOAP,
	  name: 'SOAP',
	  description: 'SOAP APIs will not have an interactive spec.'
	}];
	var REST_FILE_HELPER_TEXT = exports.REST_FILE_HELPER_TEXT = 'Upload a Swagger or WADL file. Maximum file size is 10MB';
	var SOAP_FILE_HELPER_TEXT = exports.SOAP_FILE_HELPER_TEXT = 'Upload a WSDL file (required) and XSD files (optional). Maximum file size is 10MB.';
	var VALIDATION_FILE_NAME_UNIQUE_MESSAGE = exports.VALIDATION_FILE_NAME_UNIQUE_MESSAGE = 'Unable to upload the file. API asset files with the same name specified.';
	var VALIDATION_ONE_WSDL_MESSAGE = exports.VALIDATION_ONE_WSDL_MESSAGE = 'Unable to upload the file. Only one wsdl file allowed to upload.';
	
	var API_SPEC_AUTHENTICATION_TYPE_LABEL = exports.API_SPEC_AUTHENTICATION_TYPE_LABEL = 'Authentication Type';
	var API_SPEC_AUTHENTICATION_TYPE_NONE = exports.API_SPEC_AUTHENTICATION_TYPE_NONE = 'NONE';
	var API_SPEC_AUTHENTICATION_TYPE_API_KEY = exports.API_SPEC_AUTHENTICATION_TYPE_API_KEY = 'APIKEY';
	var API_SPEC_AUTHENTICATION_TYPE_API_KEY_TYPE_QUERY = exports.API_SPEC_AUTHENTICATION_TYPE_API_KEY_TYPE_QUERY = 'query';
	var API_SPEC_AUTHENTICATION_TYPE_OAUTH2 = exports.API_SPEC_AUTHENTICATION_TYPE_OAUTH2 = 'OAUTH2';
	var API_SPEC_AUTHENTICATION_TYPE_OAUTH2_GRANT_TYPE_CODE = exports.API_SPEC_AUTHENTICATION_TYPE_OAUTH2_GRANT_TYPE_CODE = 'CODE';
	var API_SPEC_AUTHENTICATION_TYPES = exports.API_SPEC_AUTHENTICATION_TYPES = [{
	  id: API_SPEC_AUTHENTICATION_TYPE_NONE,
	  name: 'None'
	}, {
	  id: API_SPEC_AUTHENTICATION_TYPE_API_KEY,
	  name: 'API Key'
	}, {
	  id: API_SPEC_AUTHENTICATION_TYPE_OAUTH2,
	  name: 'OAuth 2'
	}];
	
	var API_PUBLISH_STATE_LABEL = exports.API_PUBLISH_STATE_LABEL = 'Publish State';
	var API_PUBLISH_STATE_INCOMPLETE = exports.API_PUBLISH_STATE_INCOMPLETE = 'INCOMPLETE';
	var API_PUBLISH_STATE_ENABLED = exports.API_PUBLISH_STATE_ENABLED = 'ENABLED';
	var API_PUBLISH_STATE_DISABLED = exports.API_PUBLISH_STATE_DISABLED = 'DISABLED';
	var API_PUBLISH_STATE_DEPRECATED = exports.API_PUBLISH_STATE_DEPRECATED = 'DEPRECATED';
	var API_PUBLISH_STATE_NEW = exports.API_PUBLISH_STATE_NEW = 'NEW';
	
	var API_PUBLISH_STATE_TYPES = exports.API_PUBLISH_STATE_TYPES = [{
	  id: API_PUBLISH_STATE_ENABLED,
	  name: 'Enable',
	  description: 'The API can be added to applications and applications can consume them.'
	}, {
	  id: API_PUBLISH_STATE_DISABLED,
	  name: 'Disable',
	  description: 'The API cannot be added to applications. If an API is already added to an application and the state changes from Enable to Disable, the application cannot continue to consume the API.'
	}, {
	  id: API_PUBLISH_STATE_DEPRECATED,
	  name: 'Deprecate',
	  description: 'The API cannot be added to applications. If an API is already added to an application and the state of the API changes from Enable to Deprecate, the application can continue to consume the API.'
	}];
	
	var SUCCESS_TEXT = exports.SUCCESS_TEXT = 'success';
	var ERROR_TEXT = exports.ERROR_TEXT = 'error';
	
	var NEXT_TEXT = exports.NEXT_TEXT = 'Next';
	var CANCEL_TEXT = exports.CANCEL_TEXT = 'Cancel';
	var SAVE_AND_NEXT_TEXT = exports.SAVE_AND_NEXT_TEXT = 'Save & Next';
	var SAVE_TEXT = exports.SAVE_TEXT = 'Save';
	
	var API_CUSTOM_FIELDS_ASSIST_TEXT = exports.API_CUSTOM_FIELDS_ASSIST_TEXT = 'Set Custom Fields and proceed to next step.';
	
	var API_MANAGING_ORG_POPUP_TITLE = exports.API_MANAGING_ORG_POPUP_TITLE = 'label.api.managing.org.retain.visibility.title';
	var API_MANAGING_ORG_POPUP_MESSAGE = exports.API_MANAGING_ORG_POPUP_MESSAGE = 'label.api.managing.org.retain.visibility.message';
	var API_MANAGING_ORG_POPUP_SUBMIT_TEXT = exports.API_MANAGING_ORG_POPUP_SUBMIT_TEXT = 'label.api.managing.org.retain.visibility.submit.text';
	var API_MANAGING_ORG_POPUP_CANCEL_TEXT = exports.API_MANAGING_ORG_POPUP_CANCEL_TEXT = 'label.api.managing.org.retain.visibility.cancel.text';

/***/ },
/* 78 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APPLICATION = exports.APPLICATION = 'Application';
	var API = exports.API = 'API';
	var ORGANIZATION = exports.ORGANIZATION = 'Organization';
	var PROXY = exports.PROXY = 'Proxy';
	var API_PLAN = exports.API_PLAN = 'API Plan';
	var API_GROUP = exports.API_GROUP = 'API Group';
	var USER = exports.USER = 'User';
	var ACCOUNT_PLAN = exports.ACCOUNT_PLAN = 'Account Plan';
	var HELLO = exports.HELLO = 'Hello';
	var GO = exports.GO = 'Go';
	var COLLAPSE_PANEL = exports.COLLAPSE_PANEL = 'Collapse Panel';
	var EXPAND_PANEL = exports.EXPAND_PANEL = 'Expand Panel';
	var CHART = exports.CHART = 'Chart';
	var TOP_3_APIS = exports.TOP_3_APIS = 'Top 3 APIs';
	var TOP_3_ORGS = exports.TOP_3_ORGS = 'Top 3 Organizations';
	var TOP_3_APPS = exports.TOP_3_APPS = 'Top 3 Applications';
	var TOP_3_PROXIES = exports.TOP_3_PROXIES = 'Top 3 Proxies';
	var UNAUTHORIZED = exports.UNAUTHORIZED = 'UNAUTHORIZED';
	
	var MOVE_PANEL_UP = exports.MOVE_PANEL_UP = 'Move Panel Up';
	var MOVE_PANEL_DOWN = exports.MOVE_PANEL_DOWN = 'Move Panel Down';
	var APIS_LABEL = exports.APIS_LABEL = 'APIS';
	var APPLICATIONS_LABEL = exports.APPLICATIONS_LABEL = 'APPLICATIONS';
	var API_GROUPS_LABEL = exports.API_GROUPS_LABEL = 'API GROUPS';
	var PROXIES_LABEL = exports.PROXIES_LABEL = 'PROXIES';
	var USERS_LABEL = exports.USERS_LABEL = 'USERS';
	var ACCOUNT_PLANS_LABEL = exports.ACCOUNT_PLANS_LABEL = 'ACCOUNT PLANS';
	var API_PLANS_LABEL = exports.API_PLANS_LABEL = 'API PLANS';
	var ORGANIZATIONS_LABEL = exports.ORGANIZATIONS_LABEL = 'ORGANIZATIONS';
	var APIS_TRAFFIC = exports.APIS_TRAFFIC = 'APIs: Traffic';
	var APPLICATIONS_TRAFFIC = exports.APPLICATIONS_TRAFFIC = 'Applications: Traffic';
	var ORGANIZATIONS_TRAFFIC = exports.ORGANIZATIONS_TRAFFIC = 'Organizations: Traffic';
	var APIS_PANEL_TITLE = exports.APIS_PANEL_TITLE = 'APIs';
	var APPS_PANEL_TITLE = exports.APPS_PANEL_TITLE = 'Applications';
	var ORGS_PANEL_TITLE = exports.ORGS_PANEL_TITLE = 'Organizations';
	var PROXIES_PANEL_TITLE = exports.PROXIES_PANEL_TITLE = 'Proxies';
	var PROXIES_TRAFFIC = exports.PROXIES_TRAFFIC = 'Proxies: Traffic';
	var APPLICATION_ENTITY = exports.APPLICATION_ENTITY = 'app';
	var API_ENTITY = exports.API_ENTITY = 'api';
	var ORGANIZATION_ENTITY = exports.ORGANIZATION_ENTITY = 'org';
	var PROXY_ENTITY = exports.PROXY_ENTITY = 'proxy';
	var ADD_TO_CHART = exports.ADD_TO_CHART = 'Add to chart';
	var REMOVE_FROM_CHART = exports.REMOVE_FROM_CHART = 'Remove from chart';
	
	var TRAFFIC = exports.TRAFFIC = 'TRAFFIC';
	
	var GUEST_USER_TITLE = exports.GUEST_USER_TITLE = 'One more step before you can access Portal.';
	var GUEST_USER_MESSAGE = exports.GUEST_USER_MESSAGE = 'For access, contact your Portal Administrator to get your account request approved.';

/***/ },
/* 79 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	Object.defineProperty(exports, "unstable_StrictModeGrow", {
	  enumerable: true,
	  get: function get() {
	    return _StrictModeGrow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(320));
	
	var _StrictModeGrow = _interopRequireDefault(__webpack_require__(792));

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
	}), 'ExpandMore');
	
	exports.default = _default;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(48);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(415),
	    isArrayLike = __webpack_require__(66),
	    isString = __webpack_require__(444),
	    toInteger = __webpack_require__(451),
	    values = __webpack_require__(193);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var hoistNonReactStatics_ = __webpack_require__(82);
	// Since rollup cannot deal with namespace being a function,
	// this is to interop with TypeScript since `invariant`
	// does not export a default
	// https://github.com/rollup/rollup/issues/1267
	var hoistNonReactStatics = hoistNonReactStatics_.default || hoistNonReactStatics_;
	var utils_1 = __webpack_require__(50);
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	// TODO: We should provide initial value here
	var IntlContext = React.createContext(null);
	var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
	exports.Provider = IntlProvider;
	exports.Context = IntlContext;
	function injectIntl(WrappedComponent, options) {
	    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
	    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
	        var _a;
	        if (enforceContext) {
	            utils_1.invariantIntlContext(intl);
	        }
	        return (React.createElement(WrappedComponent, __assign({}, props, (_a = {},
	            _a[intlPropName] = intl,
	            _a), { ref: forwardRef ? props.forwardedRef : null })));
	    })); };
	    WithIntl.displayName = "injectIntl(" + getDisplayName(WrappedComponent) + ")";
	    WithIntl.WrappedComponent = WrappedComponent;
	    if (forwardRef) {
	        return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, __assign({}, props, { forwardedRef: ref }))); }), WrappedComponent);
	    }
	    return hoistNonReactStatics(WithIntl, WrappedComponent);
	}
	exports.default = injectIntl;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchLockUserCreation = exports.fetchApplicationEditRequestSetting = exports.fetchApplicationRequestSetting = exports.fetchDeploymentRefreshTime = exports.fetchAppSecretHashingMetadata = exports.fetchRequests = exports.updateUserContexts = exports.checkSession = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _utils = __webpack_require__(18);
	
	var _portalConfig = __webpack_require__(26);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var checkSession = exports.checkSession = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(state) {
	    var config, portal;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            config = (0, _portalConfig.getConfig)(state);
	            portal = config.portal;
	            return _context.abrupt('return', _axios2.default.get(portal.hostname + '/admin/sessionCheck', { credentials: 'include' }).then(function (res) {
	              return (0, _get2.default)(res, 'data.status', '');
	            }).catch(function (err) {
	              return (0, _get2.default)(err, 'response.data.status', '');
	            }));
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function checkSession(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var updateUserContexts = exports.updateUserContexts = function updateUserContexts(data) {
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/userContexts';
	
	
	              _axios2.default.put(url, data, { credentials: 'include' }).then(function () {
	                dispatch({
	                  type: Constants.USER_CONTEXTS_UPDATE_SUCCESS,
	                  isLoading: false
	                });
	                window.location.href = '/admin/app/dashboard';
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.API_ERROR,
	                  isLoading: false,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x2, _x3) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchRequests = exports.fetchRequests = function fetchRequests() {
	  return function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/Requests?$filter=RequestStatus eq \'PENDING\'';
	
	
	              _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.FETCH_REQUESTS_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.FETCH_REQUESTS_ERROR,
	                  isLoading: false,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAppSecretHashingMetadata = exports.fetchAppSecretHashingMetadata = function fetchAppSecretHashingMetadata() {
	  return function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/Settings(\'APP_SECRET_HASHING_METADATA\')';
	
	
	              _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.FETCH_APP_SECRET_HASHING_METADATA_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.FETCH_APP_SECRET_HASHING_METADATA_ERROR,
	                  isLoading: false,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchDeploymentRefreshTime = exports.fetchDeploymentRefreshTime = function fetchDeploymentRefreshTime() {
	  return function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/Settings(\'DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS\')';
	
	
	              _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x8, _x9) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApplicationRequestSetting = exports.fetchApplicationRequestSetting = function fetchApplicationRequestSetting() {
	  return function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/Settings(\'APPLICATION_REQUEST_WORKFLOW\')';
	
	              _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.FETCH_APPLICATION_REQUEST_SETTING_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function () {});
	
	            case 4:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined);
	    }));
	
	    return function (_x10, _x11) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApplicationEditRequestSetting = exports.fetchApplicationEditRequestSetting = function fetchApplicationEditRequestSetting() {
	  return function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/Settings(\'EDIT_APPLICATION_REQUEST_WORKFLOW\')';
	
	              _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function () {});
	
	            case 4:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined);
	    }));
	
	    return function (_x12, _x13) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchLockUserCreation = exports.fetchLockUserCreation = function fetchLockUserCreation() {
	  return function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/Settings(\'LOCK_USER_CREATION\')';
	
	              _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.FETCH_SETTING_USER_LOCK_CREATION_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function () {});
	
	            case 4:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined);
	    }));
	
	    return function (_x14, _x15) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCreatedKey = exports.getKeysResults = exports.getKeysTotalElements = exports.getKeysTotalPages = exports.getDeleteApplicationStatus = exports.getUpdateApplicationStatus = exports.getSingleApplication = exports.getAllApiPlans = exports.getAllApps = exports.getAllApis = exports.getDeleteKeyStatus = exports.getUpdateKeyStatus = exports.getCreateKeyStatus = exports.getIsUniqueKey = exports.getProxiesByApiKey = exports.getProxies = exports.getProxyErrors = exports.getTenantInfos = exports.getSecret = exports.getAvailableApiPlans = exports.getApiGroupEulas = exports.getAvailableApiGroupsCount = exports.getAvailableApiGroups = exports.getAvailableApiGroups1 = exports.getSelectedApiGroups = exports.getApiEula = exports.getAvailableOrgsCount = exports.getAvailableOrgs = exports.getAvailableAppsCount = exports.getAvailableApps = exports.getAvailableApisCount = exports.getAvailableApis = exports.getSelectedApis = exports.getCustomFields = exports.getOrganizationsCount = exports.getOrganizations = exports.getOrganizations1 = exports.getIsSaveApplicationSecretSuccess = exports.getIsSaveApplicationSuccess = exports.getApplicationDetails = exports.getIsApplicationNameUnique = exports.getIsError = exports.getErrors = exports.getIsLoading = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case Constants.APPLICATION_LOADING:
	      return Object.assign({}, state, {
	        apiEula: {},
	        apiGroupEulas: [],
	        isLoading: action.isLoading,
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APP_RESET:
	      return Object.assign({}, state, {
	        errors: []
	      });
	    case Constants.APPLICATION_ERROR:
	      return Object.assign({}, state, {
	        isLoading: false,
	        errors: action.payload,
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: action.isLoading,
	        errors: [],
	        applicationDetails: (0, _responseParser.getParsedApplicationDetails)((0, _lodash.get)(action, 'payload.d')),
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_CREATE_SUCCESS:
	    case Constants.APPLICATION_UPDATE_SUCCESS:
	      {
	        var applicationDetails = (0, _responseParser.getParsedApplicationDetails)((0, _lodash.get)(action, 'payload.d'));
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: []
	        }, applicationDetails && { applicationDetails: applicationDetails }, {
	          isApplicationSaveSuccess: true
	        });
	      }
	    case Constants.APPLICATION_UPDATE_AND_GET_SUCCESS:
	      {
	        var _applicationDetails = (0, _responseParser.getParsedApplicationDetails)((0, _lodash.get)(action, 'payload.d'));
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: []
	        }, _applicationDetails && { applicationDetails: _applicationDetails }, {
	          isApplicationSaveSuccess: true
	        });
	      }
	    case Constants.APPLICATION_SECRET_UPDATE_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isApplicationSecretSaveSuccess: true
	        });
	      }
	    case Constants.APPLICATION_ORGANIZATIONS_GET_SUCCESS:
	      {
	        var organizations1 = state.organizations1;
	        var payload = action.payload;
	        if ((0, _lodash.has)(payload, 'results') && (0, _lodash.has)(organizations1, 'results')) {
	          payload.results = [].concat(_toConsumableArray(organizations1.results), _toConsumableArray(action.payload.results));
	        }
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: [],
	          organizations1: payload,
	          organizations: (0, _lodash.get)(action, 'payload.results'),
	          organizationsCount: (0, _lodash.get)(action, 'payload.totalElements'),
	          isApplicationSaveSuccess: false,
	          isApplicationSecretSaveSuccess: false
	        });
	      }
	    case Constants.APPLICATION_NAME_UNIQUE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: action.isLoading,
	        applicationNameUnique: action.payload,
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_CUSTOM_FIELDS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: action.isLoading,
	        errors: [],
	        customFields: (0, _responseParser.getParsedCustomFields)((0, _lodash.get)(action, 'payload.d.results')),
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_SELECTED_APIS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        errors: [],
	        selectedApis: (0, _lodash.get)(action, 'payload.d.results').map(function (_ref) {
	          var ApiUuid = _ref.ApiUuid,
	              Name = _ref.Name,
	              Description = _ref.Description,
	              PortalStatus = _ref.PortalStatus;
	          return {
	            uuid: ApiUuid,
	            name: Name,
	            description: Description,
	            portalStatus: PortalStatus
	          };
	        }),
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_AVAILABLE_APIS_GET_SUCCESS:
	      {
	        var availableApis = (0, _lodash.get)(action, 'payload.results');
	        /* if page number is valid and > 0, add the apis from
	        response to already pulled apis. else clear it.
	        */
	        if (Number.isInteger(action.page) && action.page > 0) {
	          var cachedAPIs = state.availableApis;
	          availableApis = [].concat(_toConsumableArray(cachedAPIs), _toConsumableArray(availableApis));
	        }
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: [],
	          availableApis: availableApis,
	          availableApisCount: (0, _lodash.get)(action, 'payload.totalElements'),
	          isApplicationSaveSuccess: false,
	          isApplicationSecretSaveSuccess: false
	        });
	      }
	    case Constants.APPLICATION_AVAILABLE_APPS_GET_SUCCESS:
	      {
	        var availableApps = (0, _lodash.get)(action, 'payload.results');
	        /* if page number is valid and > 0, add the apps from
	        response to already pulled apps. else clear it.
	        */
	        if (Number.isInteger(action.page) && action.page > 0) {
	          var cachedAPPs = state.availableApps;
	          availableApps = [].concat(_toConsumableArray(cachedAPPs), _toConsumableArray(availableApps));
	        }
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: [],
	          availableApps: availableApps,
	          availableAppsCount: (0, _lodash.get)(action, 'payload.totalElements'),
	          isApplicationSaveSuccess: false,
	          isApplicationSecretSaveSuccess: false
	        });
	      }
	    case Constants.APPLICATION_AVAILABLE_ORGS_GET_SUCCESS:
	      {
	        var availableOrgs = (0, _lodash.get)(action, 'payload.results');
	        /* if page number is valid and > 0, add the apps from
	        response to already pulled apps. else clear it.
	        */
	        if (Number.isInteger(action.page) && action.page > 0) {
	          var cachedORGs = state.availableOrgs;
	          availableOrgs = [].concat(_toConsumableArray(cachedORGs), _toConsumableArray(availableOrgs));
	        }
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: [],
	          availableOrgs: availableOrgs,
	          availableOrgsCount: (0, _lodash.get)(action, 'payload.totalElements'),
	          isApplicationSaveSuccess: false,
	          isApplicationSecretSaveSuccess: false
	        });
	      }
	    case Constants.APPLICATION_API_EULA_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: action.isLoading,
	        errors: [],
	        apiEula: (0, _responseParser.getParsedApiEula)((0, _lodash.get)(action, 'payload.d')),
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_GENERATE_SECRET_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: action.isLoading,
	        errors: [],
	        secret: (0, _lodash.get)(action, 'payload.d.result'),
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        errors: [],
	        selectedApiGroups: (0, _lodash.uniqBy)((0, _lodash.get)(action, 'payload.d.results'), function (_ref2) {
	          var uuid = _ref2.uuid;
	          return uuid;
	        }),
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS:
	      {
	        var availableApiGroups1 = state.availableApiGroups1;
	        var _payload = action.payload;
	        if ((0, _lodash.has)(action, 'payload.results') && (0, _lodash.has)(availableApiGroups1, 'results') && action.page !== 0) {
	          _payload.results = [].concat(_toConsumableArray(availableApiGroups1.results), _toConsumableArray(action.payload.results));
	        }
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: [],
	          availableApiGroups1: _payload,
	          availableApiGroups: (0, _lodash.get)(action, 'payload.results'),
	          availableApiGroupsCount: (0, _lodash.get)(action, 'payload.totalElements'),
	          isApplicationSaveSuccess: false,
	          isApplicationSecretSaveSuccess: false
	        });
	      }
	    case Constants.APPLICATION_API_GROUP_EULAS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: action.isLoading,
	        errors: [],
	        apiGroupEulas: (0, _lodash.get)(action, 'payload.d.results'),
	        isApplicationSaveSuccess: false,
	        isApplicationSecretSaveSuccess: false
	      });
	    case Constants.APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS:
	      {
	        var availableApiPlans = state.availableApiPlans;
	
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: [],
	          availableApiPlans: Object.assign({}, availableApiPlans, action.payload),
	          isApplicationSaveSuccess: false,
	          isApplicationSecretSaveSuccess: false
	        });
	      }
	    case Constants.TENANT_INFO_GET_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: action.isLoading,
	          errors: [],
	          tenantInfos: (0, _responseParser.getHashingMetadata)((0, _lodash.get)(action, 'payload.d')),
	          isApplicationSaveSuccess: false,
	          isApplicationSecretSaveSuccess: false
	        });
	      }
	    case Constants.PROXIES_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload,
	          proxies: []
	        });
	      }
	    case Constants.PROXIES_GET_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          proxies: action.payload
	        });
	      }
	    case Constants.API_KEY_PROXIES_GET_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          apiKeyProxies: updateApiKeyProxies((0, _lodash.get)(state, 'apiKeyProxies'), action.payload)
	        });
	      }
	    case Constants.APPLICATION_ALL_KEYS_GET_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          keys: action.payload,
	          deleteKeyStatus: ''
	        });
	      }
	    case Constants.APPLICATION_ALL_KEYS_GET_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload
	        });
	      }
	    case Constants.APPLICATION_SINGLE_GET_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          singleApplication: action.payload
	        });
	      }
	    case Constants.APPLICATION_API_PLANS_GET_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          allApiPlans: action.payload
	        });
	      }
	    case Constants.APPLICATION_STATUS_UPDATE_RESET:
	      {
	        return Object.assign({}, state, {
	          updateApplicationStatus: ''
	        });
	      }
	    case Constants.APPLICATION_STATUS_UPDATE_SUCCESS:
	      {
	        var _applicationDetails2 = (0, _responseParser.getParsedApplicationDetails)((0, _lodash.get)(action, 'payload.d'));
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: []
	        }, _applicationDetails2 && { applicationDetails: _applicationDetails2 }, {
	          updateApplicationStatus: Constants.SUCCESS
	        });
	      }
	    case Constants.APPLICATION_STATUS_UPDATE_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload,
	          updateApplicationStatus: Constants.FAIL
	        });
	      }
	    case Constants.APPLICATION_DELETE_RESET:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          deleteApplicationStatus: Constants.NONE
	        });
	      }
	    case Constants.APPLICATION_DELETE_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          deleteApplicationStatus: Constants.SUCCESS
	        });
	      }
	    case Constants.APPLICATION_DELETE_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload,
	          deleteApplicationStatus: Constants.FAIL
	        });
	      }
	    case Constants.API_KEY_DEPLOY_SUCCESS:
	    case Constants.API_KEY_REDEPLOY_SUCCESS:
	    case Constants.API_KEY_UNDEPLOY_SUCCESS:
	      {
	        var obj = {
	          apiKey: (0, _lodash.get)(action.payload, 'apiKey'),
	          proxyUuid: (0, _lodash.get)(action.payload, 'proxyUuid'),
	          errorMessage: '',
	          validation: Constants.SUCCESS
	        };
	        return Object.assign({}, state, {
	          proxyErrors: updateProxyErrors((0, _lodash.get)(state, 'proxyErrors'), obj)
	        });
	      }
	    case Constants.API_KEY_DEPLOY_ERROR:
	    case Constants.API_KEY_REDEPLOY_ERROR:
	    case Constants.API_KEY_UNDEPLOY_ERROR:
	      {
	        var _obj = {
	          apiKey: (0, _lodash.get)(action.payload, 'apiKey'),
	          proxyUuid: (0, _lodash.get)(action.payload, 'proxyUuid'),
	          errorMessage: (0, _lodash.get)(action.payload, 'errorMessage'),
	          validation: Constants.FAIL
	        };
	        return Object.assign({}, state, {
	          proxyErrors: updateProxyErrors((0, _lodash.get)(state, 'proxyErrors'), _obj)
	        });
	      }
	    case Constants.API_KEY_PROXIES_GET_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload
	        });
	      }
	    case Constants.KEY_NAME_UNIQUE_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          isUniqueKey: action.payload
	        });
	      }
	    case Constants.KEY_NAME_UNIQUE_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload,
	          isUniqueKey: ''
	        });
	      }
	    case Constants.KEY_STATUS_RESET:
	      {
	        return Object.assign({}, state, {
	          createKeyStatus: '',
	          updateKeyStatus: ''
	        });
	      }
	    case Constants.KEY_CREATE_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          createKeyStatus: Constants.SUCCESS,
	          createdKey: action.payload
	        });
	      }
	    case Constants.KEY_CREATE_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload,
	          createKeyStatus: Constants.FAIL,
	          createdKey: null
	        });
	      }
	    case Constants.KEY_UPDATE_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          updateKeyStatus: Constants.SUCCESS,
	          createdKey: null
	        });
	      }
	    case Constants.KEY_UPDATE_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload,
	          updateKeyStatus: Constants.FAIL,
	          createdKey: null
	        });
	      }
	    case Constants.KEY_DELETE_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: [],
	          deleteKeyStatus: Constants.SUCCESS,
	          createdKey: null
	        });
	      }
	    case Constants.KEY_DELETE_ERROR:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          errors: action.payload,
	          deleteKeyStatus: Constants.FAIL,
	          createdKey: null
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _responseParser = __webpack_require__(1703);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  isLoading: true,
	  errors: [],
	  organizations1: {},
	  organizations: [],
	  organizationsCount: 0,
	  applicationDetails: {
	    apiIds: [],
	    apiApiPlanIds: [],
	    apiGroupIds: [],
	    customFieldValues: {}
	  },
	  applicationNameUnique: { d: { result: true } },
	  customFields: [],
	  selectedApis: [],
	  availableApis: [],
	  availableApisCount: 0,
	  availableApps: [],
	  availableAppsCount: 0,
	  availableOrgs: [],
	  availableOrgsCount: 0,
	  apiEula: {},
	  apiGroupEulas: [],
	  selectedApiGroups: [],
	  availableApiGroups1: {},
	  availableApiGroups: [],
	  availableApiGroupsCount: 0,
	  availableApiPlans: {},
	  isApplicationSaveSuccess: false,
	  tenantInfos: {},
	  proxyErrors: [],
	  proxies: [],
	  apiKeyProxies: [],
	  singleApplication: {},
	  allApis: [],
	  allApps: [],
	  allApiPlans: [],
	  updateApplicationStatus: '',
	  deleteApplicationStatus: Constants.NONE,
	  createdKey: null,
	  createKeyStatus: '',
	  updateKeyStatus: '',
	  deleteKeyStatus: '',
	  isUniqueKey: '',
	  keys: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  }
	};
	
	var updateProxyErrors = function updateProxyErrors() {
	  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var obj = arguments[1];
	
	  var tempArr = (0, _lodash.cloneDeep)(arr);
	  var index = arr.findIndex(function (e) {
	    return e.proxyUuid === obj.proxyUuid && e.apiKey === obj.apiKey;
	  });
	  if (index === -1) {
	    tempArr.push(obj);
	  } else {
	    tempArr[index] = obj;
	  }
	  return tempArr;
	};
	
	var updateApiKeyProxies = function updateApiKeyProxies() {
	  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var obj = arguments[1];
	
	  var tempArr = (0, _lodash.cloneDeep)(arr);
	  var index = arr.findIndex(function (e) {
	    return e.key === obj.key;
	  });
	  if (index === -1) {
	    tempArr.push(obj);
	  } else {
	    tempArr[index] = obj;
	  }
	  return tempArr;
	};
	
	var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
	  return (0, _lodash.get)(state, 'application.isLoading');
	};
	
	var getErrors = exports.getErrors = function getErrors(state) {
	  return (0, _lodash.get)(state, 'application.errors');
	};
	var getIsError = exports.getIsError = function getIsError(state) {
	  return !(0, _lodash.isEmpty)(getErrors(state));
	};
	
	var getIsApplicationNameUnique = exports.getIsApplicationNameUnique = function getIsApplicationNameUnique(state) {
	  return (0, _lodash.get)(state, 'application.applicationNameUnique.d.result');
	};
	var getApplicationDetails = exports.getApplicationDetails = function getApplicationDetails(state) {
	  return (0, _lodash.get)(state, 'application.applicationDetails');
	};
	var getIsSaveApplicationSuccess = exports.getIsSaveApplicationSuccess = function getIsSaveApplicationSuccess(state) {
	  return (0, _lodash.get)(state, 'application.isApplicationSaveSuccess');
	};
	var getIsSaveApplicationSecretSuccess = exports.getIsSaveApplicationSecretSuccess = function getIsSaveApplicationSecretSuccess(state) {
	  return (0, _lodash.get)(state, 'application.isApplicationSecretSaveSuccess');
	};
	
	// TODO: Clean the multiple getters for Organizations
	var getOrganizations1 = exports.getOrganizations1 = function getOrganizations1(state) {
	  return (0, _lodash.get)(state, 'application.organizations1');
	};
	var getOrganizations = exports.getOrganizations = function getOrganizations(state) {
	  return (0, _lodash.get)(state, 'application.organizations');
	};
	var getOrganizationsCount = exports.getOrganizationsCount = function getOrganizationsCount(state) {
	  return (0, _lodash.get)(state, 'application.organizationsCount');
	};
	
	var getCustomFields = exports.getCustomFields = function getCustomFields(state) {
	  return (0, _lodash.get)(state, 'application.customFields');
	};
	
	var getSelectedApis = exports.getSelectedApis = function getSelectedApis(state) {
	  return (0, _lodash.get)(state, 'application.selectedApis');
	};
	var getAvailableApis = exports.getAvailableApis = function getAvailableApis(state) {
	  return (0, _lodash.get)(state, 'application.availableApis');
	};
	var getAvailableApisCount = exports.getAvailableApisCount = function getAvailableApisCount(state) {
	  return (0, _lodash.get)(state, 'application.availableApisCount');
	};
	
	var getAvailableApps = exports.getAvailableApps = function getAvailableApps(state) {
	  return (0, _lodash.get)(state, 'application.availableApps');
	};
	var getAvailableAppsCount = exports.getAvailableAppsCount = function getAvailableAppsCount(state) {
	  return (0, _lodash.get)(state, 'application.availableAppsCount');
	};
	
	var getAvailableOrgs = exports.getAvailableOrgs = function getAvailableOrgs(state) {
	  return (0, _lodash.get)(state, 'application.availableOrgs');
	};
	var getAvailableOrgsCount = exports.getAvailableOrgsCount = function getAvailableOrgsCount(state) {
	  return (0, _lodash.get)(state, 'application.availableOrgsCount');
	};
	
	var getApiEula = exports.getApiEula = function getApiEula(state) {
	  return (0, _lodash.get)(state, 'application.apiEula');
	};
	
	var getSelectedApiGroups = exports.getSelectedApiGroups = function getSelectedApiGroups(state) {
	  return (0, _lodash.get)(state, 'application.selectedApiGroups');
	};
	
	// TODO: Clean the multiple getters for Organizations
	var getAvailableApiGroups1 = exports.getAvailableApiGroups1 = function getAvailableApiGroups1(state) {
	  return (0, _lodash.get)(state, 'application.availableApiGroups1');
	};
	var getAvailableApiGroups = exports.getAvailableApiGroups = function getAvailableApiGroups(state) {
	  return (0, _lodash.get)(state, 'application.availableApiGroups');
	};
	var getAvailableApiGroupsCount = exports.getAvailableApiGroupsCount = function getAvailableApiGroupsCount(state) {
	  return (0, _lodash.get)(state, 'application.availableApiGroupsCount');
	};
	
	var getApiGroupEulas = exports.getApiGroupEulas = function getApiGroupEulas(state) {
	  return (0, _lodash.get)(state, 'application.apiGroupEulas');
	};
	
	var getAvailableApiPlans = exports.getAvailableApiPlans = function getAvailableApiPlans(state) {
	  return (0, _lodash.get)(state, 'application.availableApiPlans');
	};
	
	var getSecret = exports.getSecret = function getSecret(state) {
	  return (0, _lodash.get)(state, 'application.secret');
	};
	var getTenantInfos = exports.getTenantInfos = function getTenantInfos(state) {
	  return (0, _lodash.get)(state, 'application.tenantInfos');
	};
	
	var getProxyErrors = exports.getProxyErrors = function getProxyErrors(state) {
	  return (0, _lodash.get)(state, 'application.proxyErrors');
	};
	var getProxies = exports.getProxies = function getProxies(state) {
	  return (0, _lodash.get)(state, 'application.proxies');
	};
	var getProxiesByApiKey = exports.getProxiesByApiKey = function getProxiesByApiKey(state) {
	  return (0, _lodash.get)(state, 'application.apiKeyProxies');
	};
	
	var getIsUniqueKey = exports.getIsUniqueKey = function getIsUniqueKey(state) {
	  return (0, _lodash.get)(state, 'application.isUniqueKey');
	};
	var getCreateKeyStatus = exports.getCreateKeyStatus = function getCreateKeyStatus(state) {
	  return (0, _lodash.get)(state, 'application.createKeyStatus');
	};
	var getUpdateKeyStatus = exports.getUpdateKeyStatus = function getUpdateKeyStatus(state) {
	  return (0, _lodash.get)(state, 'application.updateKeyStatus');
	};
	var getDeleteKeyStatus = exports.getDeleteKeyStatus = function getDeleteKeyStatus(state) {
	  return (0, _lodash.get)(state, 'application.deleteKeyStatus');
	};
	
	var getAllApis = exports.getAllApis = function getAllApis(state) {
	  return (0, _lodash.get)(state, 'application.allApis');
	};
	var getAllApps = exports.getAllApps = function getAllApps(state) {
	  return (0, _lodash.get)(state, 'application.allApps');
	};
	var getAllApiPlans = exports.getAllApiPlans = function getAllApiPlans(state) {
	  return (0, _lodash.get)(state, 'application.allApiPlans');
	};
	var getSingleApplication = exports.getSingleApplication = function getSingleApplication(state) {
	  return (0, _lodash.get)(state, 'application.singleApplication');
	};
	var getUpdateApplicationStatus = exports.getUpdateApplicationStatus = function getUpdateApplicationStatus(state) {
	  return (0, _lodash.get)(state, 'application.updateApplicationStatus');
	};
	var getDeleteApplicationStatus = exports.getDeleteApplicationStatus = function getDeleteApplicationStatus(state) {
	  return (0, _lodash.get)(state, 'application.deleteApplicationStatus');
	};
	
	var getKeysTotalPages = exports.getKeysTotalPages = function getKeysTotalPages(state) {
	  return (0, _lodash.get)(state, 'application.keys.totalPages');
	};
	var getKeysTotalElements = exports.getKeysTotalElements = function getKeysTotalElements(state) {
	  return (0, _lodash.get)(state, 'application.keys.totalElements');
	};
	var getKeysResults = exports.getKeysResults = function getKeysResults(state) {
	  return (0, _lodash.get)(state, 'application.keys.results');
	};
	
	var getCreatedKey = exports.getCreatedKey = function getCreatedKey(state) {
	  return (0, _lodash.get)(state, 'application.createdKey');
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modifyAlpha = exports.greyscale = exports.darken = exports.lighten = undefined;
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var specialColorValues = ['transparent', 'inherit'];
	
	var isSpecialColor = function isSpecialColor(col) {
	  return specialColorValues.indexOf(col) !== -1;
	};
	
	var callColorMethodUnlessSpecialColor = function callColorMethodUnlessSpecialColor(method, col, amount) {
	  return isSpecialColor(col) ? col : (0, _color2.default)(col)[method](amount).hexString();
	};
	
	var lighten = exports.lighten = callColorMethodUnlessSpecialColor.bind(null, 'lighten');
	var darken = exports.darken = callColorMethodUnlessSpecialColor.bind(null, 'darken');
	var greyscale = exports.greyscale = callColorMethodUnlessSpecialColor.bind(null, 'greyscale');
	
	var modifyAlpha = exports.modifyAlpha = function modifyAlpha(colorValue, alpha) {
	  return (0, _color2.default)(colorValue).alpha(alpha).string();
	};
	
	exports.default = function (col, method, amount) {
	  return (0, _color2.default)(col)[method](amount).rgb().string();
	};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	/* eslint-disable func-style */
	
	/* eslint-disable no-use-before-define */
	function isNonEmptyArray(collection) {
	  return Array.isArray(collection) && collection.length > 0;
	}
	
	function containsStrings(collection) {
	  return Array.isArray(collection) && collection.some(function (value) {
	    return typeof value === "string";
	  });
	}
	
	function containsDates(collection) {
	  return Array.isArray(collection) && collection.some(function (value) {
	    return value instanceof Date;
	  });
	}
	
	function containsNumbers(collection) {
	  return Array.isArray(collection) && collection.some(function (value) {
	    return typeof value === "number";
	  });
	}
	
	function containsOnlyStrings(collection) {
	  return isNonEmptyArray(collection) && collection.every(function (value) {
	    return typeof value === "string";
	  });
	}
	
	function isArrayOfArrays(collection) {
	  return isNonEmptyArray(collection) && collection.every(Array.isArray);
	}
	
	function removeUndefined(arr) {
	  return arr.filter(function (el) {
	    return el !== undefined;
	  });
	}
	
	function getMaxValue(arr) {
	  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  var array = arr.concat(values);
	  return containsDates(array) ? new Date(Math.max.apply(Math, _toConsumableArray(array))) : Math.max.apply(Math, _toConsumableArray(array));
	}
	
	function getMinValue(arr) {
	  for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    values[_key2 - 1] = arguments[_key2];
	  }
	
	  var array = arr.concat(values);
	  return containsDates(array) ? new Date(Math.min.apply(Math, _toConsumableArray(array))) : Math.min.apply(Math, _toConsumableArray(array));
	}
	
	var _default = {
	  containsDates: containsDates,
	  containsNumbers: containsNumbers,
	  containsOnlyStrings: containsOnlyStrings,
	  containsStrings: containsStrings,
	  getMaxValue: getMaxValue,
	  getMinValue: getMinValue,
	  isArrayOfArrays: isArrayOfArrays,
	  removeUndefined: removeUndefined
	};
	exports.default = _default;

/***/ },
/* 90 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	
	var _Divider = _interopRequireDefault(__webpack_require__(765));

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useFormControl;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(159));
	
	function useFormControl() {
	  return React.useContext(_FormControlContext.default);
	}

/***/ },
/* 93 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	// Corresponds to 10 frames at 60 Hz.
	// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
	function debounce(func) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
	  var timeout;
	
	  function debounced() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // eslint-disable-next-line consistent-this
	    var that = this;
	
	    var later = function later() {
	      func.apply(that, args);
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  }
	
	  debounced.clear = function () {
	    clearTimeout(timeout);
	  };
	
	  return debounced;
	}

/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRef;
	
	// TODO v5: consider to make it private
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useControlled;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
	function useControlled(_ref) {
	  var controlled = _ref.controlled,
	      defaultProp = _ref.default,
	      name = _ref.name,
	      _ref$state = _ref.state,
	      state = _ref$state === void 0 ? 'value' : _ref$state;
	
	  var _React$useRef = React.useRef(controlled !== undefined),
	      isControlled = _React$useRef.current;
	
	  var _React$useState = React.useState(defaultProp),
	      valueState = _React$useState[0],
	      setValue = _React$useState[1];
	
	  var value = isControlled ? controlled : valueState;
	
	  if (false) {
	    React.useEffect(function () {
	      if (isControlled !== (controlled !== undefined)) {
	        console.error(["Material-UI: a component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [controlled]);
	
	    var _React$useRef2 = React.useRef(defaultProp),
	        defaultValue = _React$useRef2.current;
	
	    React.useEffect(function () {
	      if (defaultValue !== defaultProp) {
	        console.error(["Material-UI: a component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
	      }
	    }, [JSON.stringify(defaultProp)]);
	  }
	
	  var setValueIfUncontrolled = React.useCallback(function (newValue) {
	    if (!isControlled) {
	      setValue(newValue);
	    }
	  }, []);
	  return [value, setValueIfUncontrolled];
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var isInBrowser = __webpack_require__(403);
	var warning = __webpack_require__(88);
	var _createClass = __webpack_require__(155);
	var _inheritsLoose = __webpack_require__(156);
	var _assertThisInitialized = __webpack_require__(308);
	var _objectWithoutPropertiesLoose = __webpack_require__(90);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var isInBrowser__default = /*#__PURE__*/_interopDefaultLegacy(isInBrowser);
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	
	var plainObjectConstrurctor = {}.constructor;
	function cloneStyle(style) {
	  if (style == null || typeof style !== 'object') return style;
	  if (Array.isArray(style)) return style.map(cloneStyle);
	  if (style.constructor !== plainObjectConstrurctor) return style;
	  var newStyle = {};
	
	  for (var name in style) {
	    newStyle[name] = cloneStyle(style[name]);
	  }
	
	  return newStyle;
	}
	
	/**
	 * Create a rule instance.
	 */
	
	function createRule(name, decl, options) {
	  if (name === void 0) {
	    name = 'unnamed';
	  }
	
	  var jss = options.jss;
	  var declCopy = cloneStyle(decl);
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule; // It is an at-rule and it has no instance.
	
	  if (name[0] === '@') {
	     false ? warning__default['default'](false, "[JSS] Unknown rule " + name) : void 0;
	  }
	
	  return null;
	}
	
	var join = function join(value, by) {
	  var result = '';
	
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	
	  return result;
	};
	
	/**
	 * Converts array values to string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	var toCssValue = function toCssValue(value, ignoreImportant) {
	  if (ignoreImportant === void 0) {
	    ignoreImportant = false;
	  }
	
	  if (!Array.isArray(value)) return value;
	  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
	
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', '); // Add !important, because it was ignored.
	
	
	  if (!ignoreImportant && value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	};
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }
	
	  return result + str;
	}
	/**
	 * Converts a Rule to CSS string.
	 */
	
	
	function toCss(selector, style, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var result = '';
	  if (!style) return result;
	  var _options = options,
	      _options$indent = _options.indent,
	      indent = _options$indent === void 0 ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	  if (selector) indent++; // Apply fallbacks first.
	
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	
	        for (var prop in fallback) {
	          var value = fallback[prop];
	
	          if (value != null) {
	            if (result) result += '\n';
	            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	
	        if (_value != null) {
	          if (result) result += '\n';
	          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      if (result) result += '\n';
	      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
	    }
	  } // Allow empty style in this case, because properties will be added dynamically.
	
	
	  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
	
	  if (!selector) return result;
	  indent--;
	  if (result) result = "\n" + result + "\n";
	  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
	}
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
	var escape = (function (str) {
	  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
	});
	
	var BaseStyleRule =
	/*#__PURE__*/
	function () {
	  function BaseStyleRule(key, style, options) {
	    this.type = 'style';
	    this.key = void 0;
	    this.isProcessed = false;
	    this.style = void 0;
	    this.renderer = void 0;
	    this.renderable = void 0;
	    this.options = void 0;
	    var sheet = options.sheet,
	        Renderer = options.Renderer;
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
	  }
	  /**
	   * Get or set a style property.
	   */
	
	
	  var _proto = BaseStyleRule.prototype;
	
	  _proto.prop = function prop(name, value, options) {
	    // It's a getter.
	    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
	
	    var force = options ? options.force : false;
	    if (!force && this.style[name] === value) return this;
	    var newValue = value;
	
	    if (!options || options.process !== false) {
	      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
	    }
	
	    var isEmpty = newValue == null || newValue === false;
	    var isDefined = name in this.style; // Value is empty and wasn't defined before.
	
	    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
	
	    var remove = isEmpty && isDefined;
	    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
	
	    if (this.renderable && this.renderer) {
	      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
	      return this;
	    }
	
	    var sheet = this.options.sheet;
	
	    if (sheet && sheet.attached) {
	       false ? warning__default['default'](false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
	    }
	
	    return this;
	  };
	
	  return BaseStyleRule;
	}();
	var StyleRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose__default['default'](StyleRule, _BaseStyleRule);
	
	  function StyleRule(key, style, options) {
	    var _this;
	
	    _this = _BaseStyleRule.call(this, key, style, options) || this;
	    _this.selectorText = void 0;
	    _this.id = void 0;
	    _this.renderable = void 0;
	    var selector = options.selector,
	        scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	
	    if (selector) {
	      _this.selectorText = selector;
	    } else if (scoped !== false) {
	      _this.id = generateId(_assertThisInitialized__default['default'](_assertThisInitialized__default['default'](_this)), sheet);
	      _this.selectorText = "." + escape(_this.id);
	    }
	
	    return _this;
	  }
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  var _proto2 = StyleRule.prototype;
	
	  /**
	   * Apply rule to an element inline.
	   */
	  _proto2.applyTo = function applyTo(renderable) {
	    var renderer = this.renderer;
	
	    if (renderer) {
	      var json = this.toJSON();
	
	      for (var prop in json) {
	        renderer.setProperty(renderable, prop, json[prop]);
	      }
	    }
	
	    return this;
	  }
	  /**
	   * Returns JSON representation of the rule.
	   * Fallbacks are not supported.
	   * Useful for inline styles.
	   */
	  ;
	
	  _proto2.toJSON = function toJSON() {
	    var json = {};
	
	    for (var prop in this.style) {
	      var value = this.style[prop];
	      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
	    }
	
	    return json;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto2.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends__default['default']({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.selectorText, this.style, opts);
	  };
	
	  _createClass__default['default'](StyleRule, [{
	    key: "selector",
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	      this.selectorText = selector;
	      var renderer = this.renderer,
	          renderable = this.renderable;
	      if (!renderable || !renderer) return;
	      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
	
	      if (!hasChanged) {
	        renderer.replaceRule(renderable, this);
	      }
	    }
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}(BaseStyleRule);
	var pluginStyleRule = {
	  onCreateRule: function onCreateRule(name, style, options) {
	    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
	      return null;
	    }
	
	    return new StyleRule(name, style, options);
	  }
	};
	
	var defaultToStringOptions = {
	  indent: 1,
	  children: true
	};
	var atRegExp = /@([\w-]+)/;
	/**
	 * Conditional rule for @media, @supports
	 */
	
	var ConditionalRule =
	/*#__PURE__*/
	function () {
	  function ConditionalRule(key, styles, options) {
	    this.type = 'conditional';
	    this.at = void 0;
	    this.key = void 0;
	    this.query = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    var atMatch = key.match(atRegExp);
	    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
	
	    this.query = options.name || "@" + this.at;
	    this.options = options;
	    this.rules = new RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = ConditionalRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions.indent;
	    if (options.children == null) options.children = defaultToStringOptions.children;
	
	    if (options.children === false) {
	      return this.query + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    return children ? this.query + " {\n" + children + "\n}" : '';
	  };
	
	  return ConditionalRule;
	}();
	var keyRegExp = /@media|@supports\s+/;
	var pluginConditionalRule = {
	  onCreateRule: function onCreateRule(key, styles, options) {
	    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
	  }
	};
	
	var defaultToStringOptions$1 = {
	  indent: 1,
	  children: true
	};
	var nameRegExp = /@keyframes\s+([\w-]+)/;
	/**
	 * Rule for @keyframes
	 */
	
	var KeyframesRule =
	/*#__PURE__*/
	function () {
	  function KeyframesRule(key, frames, options) {
	    this.type = 'keyframes';
	    this.at = '@keyframes';
	    this.key = void 0;
	    this.name = void 0;
	    this.id = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    var nameMatch = key.match(nameRegExp);
	
	    if (nameMatch && nameMatch[1]) {
	      this.name = nameMatch[1];
	    } else {
	      this.name = 'noname';
	       false ? warning__default['default'](false, "[JSS] Bad keyframes name " + key) : void 0;
	    }
	
	    this.key = this.type + "-" + this.name;
	    this.options = options;
	    var scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
	    this.rules = new RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends__default['default']({}, options, {
	        parent: this
	      }));
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = KeyframesRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions$1;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
	    if (options.children == null) options.children = defaultToStringOptions$1.children;
	
	    if (options.children === false) {
	      return this.at + " " + this.id + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    if (children) children = "\n" + children + "\n";
	    return this.at + " " + this.id + " {" + children + "}";
	  };
	
	  return KeyframesRule;
	}();
	var keyRegExp$1 = /@keyframes\s+/;
	var refRegExp = /\$([\w-]+)/g;
	
	var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
	  if (typeof val === 'string') {
	    return val.replace(refRegExp, function (match, name) {
	      if (name in keyframes) {
	        return keyframes[name];
	      }
	
	       false ? warning__default['default'](false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
	      return match;
	    });
	  }
	
	  return val;
	};
	/**
	 * Replace the reference for a animation name.
	 */
	
	
	var replaceRef = function replaceRef(style, prop, keyframes) {
	  var value = style[prop];
	  var refKeyframe = findReferencedKeyframe(value, keyframes);
	
	  if (refKeyframe !== value) {
	    style[prop] = refKeyframe;
	  }
	};
	
	var plugin = {
	  onCreateRule: function onCreateRule(key, frames, options) {
	    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
	  },
	  // Animation name ref replacer.
	  onProcessStyle: function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return style;
	    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
	    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
	    return style;
	  },
	  onChangeValue: function onChangeValue(val, prop, rule) {
	    var sheet = rule.options.sheet;
	
	    if (!sheet) {
	      return val;
	    }
	
	    switch (prop) {
	      case 'animation':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      case 'animation-name':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      default:
	        return val;
	    }
	  }
	};
	
	var KeyframeRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose__default['default'](KeyframeRule, _BaseStyleRule);
	
	  function KeyframeRule() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
	    _this.renderable = void 0;
	    return _this;
	  }
	
	  var _proto = KeyframeRule.prototype;
	
	  /**
	   * Generates a CSS string.
	   */
	  _proto.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends__default['default']({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.key, this.style, opts);
	  };
	
	  return KeyframeRule;
	}(BaseStyleRule);
	var pluginKeyframeRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (options.parent && options.parent.type === 'keyframes') {
	      return new KeyframeRule(key, style, options);
	    }
	
	    return null;
	  }
	};
	
	var FontFaceRule =
	/*#__PURE__*/
	function () {
	  function FontFaceRule(key, style, options) {
	    this.type = 'font-face';
	    this.at = '@font-face';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = FontFaceRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.style)) {
	      var str = '';
	
	      for (var index = 0; index < this.style.length; index++) {
	        str += toCss(this.at, this.style[index]);
	        if (this.style[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return toCss(this.at, this.style, options);
	  };
	
	  return FontFaceRule;
	}();
	var keyRegExp$2 = /@font-face/;
	var pluginFontFaceRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
	  }
	};
	
	var ViewportRule =
	/*#__PURE__*/
	function () {
	  function ViewportRule(key, style, options) {
	    this.type = 'viewport';
	    this.at = '@viewport';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = ViewportRule.prototype;
	
	  _proto.toString = function toString(options) {
	    return toCss(this.key, this.style, options);
	  };
	
	  return ViewportRule;
	}();
	var pluginViewportRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
	  }
	};
	
	var SimpleRule =
	/*#__PURE__*/
	function () {
	  function SimpleRule(key, value, options) {
	    this.type = 'simple';
	    this.key = void 0;
	    this.value = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  var _proto = SimpleRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.value)) {
	      var str = '';
	
	      for (var index = 0; index < this.value.length; index++) {
	        str += this.key + " " + this.value[index] + ";";
	        if (this.value[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return this.key + " " + this.value + ";";
	  };
	
	  return SimpleRule;
	}();
	var keysMap = {
	  '@charset': true,
	  '@import': true,
	  '@namespace': true
	};
	var pluginSimpleRule = {
	  onCreateRule: function onCreateRule(key, value, options) {
	    return key in keysMap ? new SimpleRule(key, value, options) : null;
	  }
	};
	
	var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
	
	var defaultUpdateOptions = {
	  process: true
	};
	var forceUpdateOptions = {
	  force: true,
	  process: true
	  /**
	   * Contains rules objects and allows adding/removing etc.
	   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	   */
	
	};
	
	var RuleList =
	/*#__PURE__*/
	function () {
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	  // Original styles object.
	  // Used to ensure correct rules order.
	  function RuleList(options) {
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	    this.counter = 0;
	    this.options = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.options = options;
	    this.classes = options.classes;
	    this.keyframes = options.keyframes;
	  }
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  var _proto = RuleList.prototype;
	
	  _proto.add = function add(name, decl, ruleOptions) {
	    var _this$options = this.options,
	        parent = _this$options.parent,
	        sheet = _this$options.sheet,
	        jss = _this$options.jss,
	        Renderer = _this$options.Renderer,
	        generateId = _this$options.generateId,
	        scoped = _this$options.scoped;
	
	    var options = _extends__default['default']({
	      classes: this.classes,
	      parent: parent,
	      sheet: sheet,
	      jss: jss,
	      Renderer: Renderer,
	      generateId: generateId,
	      scoped: scoped,
	      name: name,
	      keyframes: this.keyframes,
	      selector: undefined
	    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
	    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
	    // we need to make the key unique within this RuleList instance scope.
	
	
	    var key = name;
	
	    if (name in this.raw) {
	      key = name + "-d" + this.counter++;
	    } // We need to save the original decl before creating the rule
	    // because cache plugin needs to use it as a key to return a cached rule.
	
	
	    this.raw[key] = decl;
	
	    if (key in this.classes) {
	      // E.g. rules inside of @media container
	      options.selector = "." + escape(this.classes[key]);
	    }
	
	    var rule = createRule(key, decl, options);
	    if (!rule) return null;
	    this.register(rule);
	    var index = options.index === undefined ? this.index.length : options.index;
	    this.index.splice(index, 0, rule);
	    return rule;
	  }
	  /**
	   * Get a rule.
	   */
	  ;
	
	  _proto.get = function get(name) {
	    return this.map[name];
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.remove = function remove(rule) {
	    this.unregister(rule);
	    delete this.raw[rule.key];
	    this.index.splice(this.index.indexOf(rule), 1);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.index.indexOf(rule);
	  }
	  /**
	   * Run `onProcessRule()` plugins on every rule.
	   */
	  ;
	
	  _proto.process = function process() {
	    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
	    // we end up with very hard-to-track-down side effects.
	
	    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
	  }
	  /**
	   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
	   */
	  ;
	
	  _proto.register = function register(rule) {
	    this.map[rule.key] = rule;
	
	    if (rule instanceof StyleRule) {
	      this.map[rule.selector] = rule;
	      if (rule.id) this.classes[rule.key] = rule.id;
	    } else if (rule instanceof KeyframesRule && this.keyframes) {
	      this.keyframes[rule.name] = rule.id;
	    }
	  }
	  /**
	   * Unregister a rule.
	   */
	  ;
	
	  _proto.unregister = function unregister(rule) {
	    delete this.map[rule.key];
	
	    if (rule instanceof StyleRule) {
	      delete this.map[rule.selector];
	      delete this.classes[rule.key];
	    } else if (rule instanceof KeyframesRule) {
	      delete this.keyframes[rule.name];
	    }
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var name;
	    var data;
	    var options;
	
	    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
	      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]
	
	      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]
	
	      options = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]
	
	      options = arguments.length <= 1 ? undefined : arguments[1];
	      name = null;
	    }
	
	    if (name) {
	      this.updateOne(this.map[name], data, options);
	    } else {
	      for (var index = 0; index < this.index.length; index++) {
	        this.updateOne(this.index[index], data, options);
	      }
	    }
	  }
	  /**
	   * Execute plugins, update rule props.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    if (options === void 0) {
	      options = defaultUpdateOptions;
	    }
	
	    var _this$options2 = this.options,
	        plugins = _this$options2.jss.plugins,
	        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
	
	    if (rule.rules instanceof RuleList) {
	      rule.rules.update(data, options);
	      return;
	    }
	
	    var styleRule = rule;
	    var style = styleRule.style;
	    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
	
	    if (options.process && style && style !== styleRule.style) {
	      // We need to run the plugins in case new `style` relies on syntax plugins.
	      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.
	
	      for (var prop in styleRule.style) {
	        var nextValue = styleRule.style[prop];
	        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (nextValue !== prevValue) {
	          styleRule.prop(prop, nextValue, forceUpdateOptions);
	        }
	      } // Remove props.
	
	
	      for (var _prop in style) {
	        var _nextValue = styleRule.style[_prop];
	        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (_nextValue == null && _nextValue !== _prevValue) {
	          styleRule.prop(_prop, null, forceUpdateOptions);
	        }
	      }
	    }
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    var str = '';
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	
	    for (var index = 0; index < this.index.length; index++) {
	      var rule = this.index[index];
	      var css = rule.toString(options); // No need to render an empty rule.
	
	      if (!css && !link) continue;
	      if (str) str += '\n';
	      str += css;
	    }
	
	    return str;
	  };
	
	  return RuleList;
	}();
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(styles, options) {
	    this.options = void 0;
	    this.deployed = void 0;
	    this.attached = void 0;
	    this.rules = void 0;
	    this.renderer = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.queue = void 0;
	    this.attached = false;
	    this.deployed = false;
	    this.classes = {};
	    this.keyframes = {};
	    this.options = _extends__default['default']({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes,
	      keyframes: this.keyframes
	    });
	
	    if (options.Renderer) {
	      this.renderer = new options.Renderer(this);
	    }
	
	    this.rules = new RuleList(this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.attach = function attach() {
	    if (this.attached) return this;
	    if (this.renderer) this.renderer.attach();
	    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
	
	    if (!this.deployed) this.deploy();
	    return this;
	  }
	  /**
	   * Remove renderable from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.attached) return this;
	    if (this.renderer) this.renderer.detach();
	    this.attached = false;
	    return this;
	  }
	  /**
	   * Add a rule to the current stylesheet.
	   * Will insert a rule also after the stylesheet has been rendered first time.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, decl, options) {
	    var queue = this.queue; // Plugins can create rules.
	    // In order to preserve the right order, we need to queue all `.addRule` calls,
	    // which happen after the first `rules.add()` call.
	
	    if (this.attached && !queue) this.queue = [];
	    var rule = this.rules.add(name, decl, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	
	    if (this.attached) {
	      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (queue) queue.push(rule);else {
	        this.insertRule(rule);
	
	        if (this.queue) {
	          this.queue.forEach(this.insertRule, this);
	          this.queue = undefined;
	        }
	      }
	      return rule;
	    } // We can't add rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return rule;
	  }
	  /**
	   * Insert rule into the StyleSheet
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule) {
	    if (this.renderer) {
	      this.renderer.insertRule(rule);
	    }
	  }
	  /**
	   * Create and add rules.
	   * Will render also after Style Sheet was rendered the first time.
	   */
	  ;
	
	  _proto.addRules = function addRules(styles, options) {
	    var added = [];
	
	    for (var name in styles) {
	      var rule = this.addRule(name, styles[name], options);
	      if (rule) added.push(rule);
	    }
	
	    return added;
	  }
	  /**
	   * Get a rule by name.
	   */
	  ;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Delete a rule by name.
	   * Returns `true`: if rule has been deleted from the DOM.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(name) {
	    var rule = typeof name === 'object' ? name : this.rules.get(name);
	
	    if (!rule || // Style sheet was created without link: true and attached, in this case we
	    // won't be able to remove the CSS rule from the DOM.
	    this.attached && !rule.renderable) {
	      return false;
	    }
	
	    this.rules.remove(rule);
	
	    if (this.attached && rule.renderable && this.renderer) {
	      return this.renderer.deleteRule(rule.renderable);
	    }
	
	    return true;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Deploy pure CSS string to a renderable.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    if (this.renderer) this.renderer.deploy();
	    this.deployed = true;
	    return this;
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this$rules;
	
	    (_this$rules = this.rules).update.apply(_this$rules, arguments);
	
	    return this;
	  }
	  /**
	   * Updates a single rule.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    this.rules.updateOne(rule, data, options);
	    return this;
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return StyleSheet;
	}();
	
	var PluginsRegistry =
	/*#__PURE__*/
	function () {
	  function PluginsRegistry() {
	    this.plugins = {
	      internal: [],
	      external: []
	    };
	    this.registry = void 0;
	  }
	
	  var _proto = PluginsRegistry.prototype;
	
	  /**
	   * Call `onCreateRule` hooks and return an object if returned by a hook.
	   */
	  _proto.onCreateRule = function onCreateRule(name, decl, options) {
	    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
	      var rule = this.registry.onCreateRule[i](name, decl, options);
	      if (rule) return rule;
	    }
	
	    return null;
	  }
	  /**
	   * Call `onProcessRule` hooks.
	   */
	  ;
	
	  _proto.onProcessRule = function onProcessRule(rule) {
	    if (rule.isProcessed) return;
	    var sheet = rule.options.sheet;
	
	    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
	      this.registry.onProcessRule[i](rule, sheet);
	    }
	
	    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	    rule.isProcessed = true;
	  }
	  /**
	   * Call `onProcessStyle` hooks.
	   */
	  ;
	
	  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
	    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
	      // $FlowFixMe[prop-missing]
	      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
	    }
	  }
	  /**
	   * Call `onProcessSheet` hooks.
	   */
	  ;
	
	  _proto.onProcessSheet = function onProcessSheet(sheet) {
	    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
	      this.registry.onProcessSheet[i](sheet);
	    }
	  }
	  /**
	   * Call `onUpdate` hooks.
	   */
	  ;
	
	  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
	    for (var i = 0; i < this.registry.onUpdate.length; i++) {
	      this.registry.onUpdate[i](data, rule, sheet, options);
	    }
	  }
	  /**
	   * Call `onChangeValue` hooks.
	   */
	  ;
	
	  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
	    var processedValue = value;
	
	    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
	      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
	    }
	
	    return processedValue;
	  }
	  /**
	   * Register a plugin.
	   */
	  ;
	
	  _proto.use = function use(newPlugin, options) {
	    if (options === void 0) {
	      options = {
	        queue: 'external'
	      };
	    }
	
	    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
	
	    if (plugins.indexOf(newPlugin) !== -1) {
	      return;
	    }
	
	    plugins.push(newPlugin);
	    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
	      for (var name in plugin) {
	        if (name in registry) {
	          registry[name].push(plugin[name]);
	        } else {
	           false ? warning__default['default'](false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
	        }
	      }
	
	      return registry;
	    }, {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	    });
	  };
	
	  return PluginsRegistry;
	}();
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry =
	/*#__PURE__*/
	function () {
	  function SheetsRegistry() {
	    this.registry = [];
	  }
	
	  var _proto = SheetsRegistry.prototype;
	
	  /**
	   * Register a Style Sheet.
	   */
	  _proto.add = function add(sheet) {
	    var registry = this.registry;
	    var index = sheet.options.index;
	    if (registry.indexOf(sheet) !== -1) return;
	
	    if (registry.length === 0 || index >= this.index) {
	      registry.push(sheet);
	      return;
	    } // Find a position.
	
	
	    for (var i = 0; i < registry.length; i++) {
	      if (registry[i].options.index > index) {
	        registry.splice(i, 0, sheet);
	        return;
	      }
	    }
	  }
	  /**
	   * Reset the registry.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    this.registry = [];
	  }
	  /**
	   * Remove a Style Sheet.
	   */
	  ;
	
	  _proto.remove = function remove(sheet) {
	    var index = this.registry.indexOf(sheet);
	    this.registry.splice(index, 1);
	  }
	  /**
	   * Convert all attached sheets to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        attached = _ref.attached,
	        options = _objectWithoutPropertiesLoose__default['default'](_ref, ["attached"]);
	
	    var css = '';
	
	    for (var i = 0; i < this.registry.length; i++) {
	      var sheet = this.registry[i];
	
	      if (attached != null && sheet.attached !== attached) {
	        continue;
	      }
	
	      if (css) css += '\n';
	      css += sheet.toString(options);
	    }
	
	    return css;
	  };
	
	  _createClass__default['default'](SheetsRegistry, [{
	    key: "index",
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	
	var registry = new SheetsRegistry();
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	
	var moduleId = globalThis[ns]++;
	
	var maxRules = 1e10;
	
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	var createGenerateId = function createGenerateId(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var ruleCounter = 0;
	  return function (rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	       false ? warning__default['default'](false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
	    }
	
	    var jssId = '';
	    var prefix = '';
	
	    if (sheet) {
	      if (sheet.options.classNamePrefix) {
	        prefix = sheet.options.classNamePrefix;
	      }
	
	      if (sheet.options.jss.id != null) {
	        jssId = String(sheet.options.jss.id);
	      }
	    }
	
	    if (options.minify) {
	      // Using "c" because a number can't be the first char in a class name.
	      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
	  };
	};
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	var memoize = function memoize(fn) {
	  var value;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	
	/**
	 * Get a style property value.
	 */
	var getPropertyValue = function getPropertyValue(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      return cssRule.attributeStyleMap.get(prop);
	    }
	
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	};
	
	/**
	 * Set a style property.
	 */
	var setProperty = function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = toCssValue(value, true);
	
	      if (value[value.length - 1] === '!important') {
	        cssRule.style.setProperty(prop, cssValue, 'important');
	        return true;
	      }
	    } // Support CSSTOM.
	
	
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.set(prop, cssValue);
	    } else {
	      cssRule.style.setProperty(prop, cssValue);
	    }
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	
	  return true;
	};
	
	/**
	 * Remove a style property.
	 */
	var removeProperty = function removeProperty(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.delete(prop);
	    } else {
	      cssRule.style.removeProperty(prop);
	    }
	  } catch (err) {
	     false ? warning__default['default'](false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
	  }
	};
	
	/**
	 * Set the selector.
	 */
	var setSelector = function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText; // Return false if setter was not successful.
	  // Currently works in chrome only.
	
	  return cssRule.selectorText === selectorText;
	};
	/**
	 * Gets the `head` element upon the first call and caches it.
	 * We assume it can't be null.
	 */
	
	
	var getHead = memoize(function () {
	  return document.querySelector('head');
	});
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find attached sheet with the highest index.
	 */
	
	
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a comment with "jss" inside.
	 */
	
	
	function findCommentNode(text) {
	  var head = getHead();
	
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry$1 = registry.registry;
	
	  if (registry$1.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry$1, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element
	      };
	    } // Otherwise insert after the last attached.
	
	
	    sheet = findHighestSheet(registry$1, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element.nextSibling
	      };
	    }
	  } // Try to find a comment placeholder if registry is empty.
	
	
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	
	    if (comment) {
	      return {
	        parent: comment.parentNode,
	        node: comment.nextSibling
	      };
	    } // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	
	
	     false ? warning__default['default'](false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
	  }
	
	  return false;
	}
	/**
	 * Insert style element into the DOM.
	 */
	
	
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	  var nextNode = findPrevNode(options);
	
	  if (nextNode !== false && nextNode.parent) {
	    nextNode.parent.insertBefore(style, nextNode.node);
	    return;
	  } // Works with iframes and any node types.
	
	
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	    var insertionPointElement = insertionPoint;
	    var parentNode = insertionPointElement.parentNode;
	    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning__default['default'](false, '[JSS] Insertion point is not in the DOM.') : void 0;
	    return;
	  }
	
	  getHead().appendChild(style);
	}
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	
	
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var _insertRule = function insertRule(container, rule, index) {
	  try {
	    if ('insertRule' in container) {
	      var c = container;
	      c.insertRule(rule, index);
	    } // Keyframes rule.
	    else if ('appendRule' in container) {
	        var _c = container;
	
	        _c.appendRule(rule);
	      }
	  } catch (err) {
	     false ? warning__default['default'](false, "[JSS] " + err.message) : void 0;
	    return false;
	  }
	
	  return container.cssRules[index];
	};
	
	var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
	  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
	
	  if (index === undefined || index > maxIndex) {
	    // eslint-disable-next-line no-param-reassign
	    return maxIndex;
	  }
	
	  return index;
	};
	
	var createStyle = function createStyle() {
	  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
	  // insert rules after we insert the style tag.
	  // It seems to kick-off the source order specificity algorithm.
	
	  el.textContent = '\n';
	  return el;
	};
	
	var DomRenderer =
	/*#__PURE__*/
	function () {
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	  // Will be empty if link: true option is not set, because
	  // it is only for use together with insertRule API.
	  function DomRenderer(sheet) {
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.element = void 0;
	    this.sheet = void 0;
	    this.hasInsertedRules = false;
	    this.cssRules = [];
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) registry.add(sheet);
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || createStyle();
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  var _proto = DomRenderer.prototype;
	
	  _proto.attach = function attach() {
	    // In the case the element node is external and it is already in the DOM.
	    if (this.element.parentNode || !this.sheet) return;
	    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	    // most browsers create a new CSSStyleSheet, except of all IEs.
	
	    var deployed = Boolean(this.sheet && this.sheet.deployed);
	
	    if (this.hasInsertedRules && deployed) {
	      this.hasInsertedRules = false;
	      this.deploy();
	    }
	  }
	  /**
	   * Remove style element from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.sheet) return;
	    var parentNode = this.element.parentNode;
	    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
	    // Though IE will keep them and we need a consistent behavior.
	
	    if (this.sheet.options.link) {
	      this.cssRules = [];
	      this.element.textContent = '\n';
	    }
	  }
	  /**
	   * Inject CSS string into element.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    var sheet = this.sheet;
	    if (!sheet) return;
	
	    if (sheet.options.link) {
	      this.insertRules(sheet.rules);
	      return;
	    }
	
	    this.element.textContent = "\n" + sheet.toString() + "\n";
	  }
	  /**
	   * Insert RuleList into an element.
	   */
	  ;
	
	  _proto.insertRules = function insertRules(rules, nativeParent) {
	    for (var i = 0; i < rules.index.length; i++) {
	      this.insertRule(rules.index[i], i, nativeParent);
	    }
	  }
	  /**
	   * Insert a rule into element.
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule, index, nativeParent) {
	    if (nativeParent === void 0) {
	      nativeParent = this.element.sheet;
	    }
	
	    if (rule.rules) {
	      var parent = rule;
	      var latestNativeParent = nativeParent;
	
	      if (rule.type === 'conditional' || rule.type === 'keyframes') {
	        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
	
	
	        latestNativeParent = _insertRule(nativeParent, parent.toString({
	          children: false
	        }), _insertionIndex);
	
	        if (latestNativeParent === false) {
	          return false;
	        }
	
	        this.refCssRule(rule, _insertionIndex, latestNativeParent);
	      }
	
	      this.insertRules(parent.rules, latestNativeParent);
	      return latestNativeParent;
	    }
	
	    var ruleStr = rule.toString();
	    if (!ruleStr) return false;
	    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
	
	    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
	
	    if (nativeRule === false) {
	      return false;
	    }
	
	    this.hasInsertedRules = true;
	    this.refCssRule(rule, insertionIndex, nativeRule);
	    return nativeRule;
	  };
	
	  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
	    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
	    // like rules inside media queries or keyframes
	
	    if (rule.options.parent instanceof StyleSheet) {
	      this.cssRules[index] = cssRule;
	    }
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(cssRule) {
	    var sheet = this.element.sheet;
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    sheet.deleteRule(index);
	    this.cssRules.splice(index, 1);
	    return true;
	  }
	  /**
	   * Get index of a CSS Rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(cssRule) {
	    return this.cssRules.indexOf(cssRule);
	  }
	  /**
	   * Generate a new CSS rule and replace the existing one.
	   *
	   * Only used for some old browsers because they can't set a selector.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(cssRule, rule) {
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    this.element.sheet.deleteRule(index);
	    this.cssRules.splice(index, 1);
	    return this.insertRule(rule, index);
	  }
	  /**
	   * Get all rules elements.
	   */
	  ;
	
	  _proto.getRules = function getRules() {
	    return this.element.sheet.cssRules;
	  };
	
	  return DomRenderer;
	}();
	
	var instanceCounter = 0;
	
	var Jss =
	/*#__PURE__*/
	function () {
	  function Jss(options) {
	    this.id = instanceCounter++;
	    this.version = "10.5.0";
	    this.plugins = new PluginsRegistry();
	    this.options = {
	      id: {
	        minify: false
	      },
	      createGenerateId: createGenerateId,
	      Renderer: isInBrowser__default['default'] ? DomRenderer : null,
	      plugins: []
	    };
	    this.generateId = createGenerateId({
	      minify: false
	    });
	
	    for (var i = 0; i < plugins.length; i++) {
	      this.plugins.use(plugins[i], {
	        queue: 'internal'
	      });
	    }
	
	    this.setup(options);
	  }
	  /**
	   * Prepares various options, applies plugins.
	   * Should not be used twice on the same instance, because there is no plugins
	   * deduplication logic.
	   */
	
	
	  var _proto = Jss.prototype;
	
	  _proto.setup = function setup(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (options.createGenerateId) {
	      this.options.createGenerateId = options.createGenerateId;
	    }
	
	    if (options.id) {
	      this.options.id = _extends__default['default']({}, this.options.id, options.id);
	    }
	
	    if (options.createGenerateId || options.id) {
	      this.generateId = this.options.createGenerateId(this.options.id);
	    }
	
	    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	
	    if ('Renderer' in options) {
	      this.options.Renderer = options.Renderer;
	    } // eslint-disable-next-line prefer-spread
	
	
	    if (options.plugins) this.use.apply(this, options.plugins);
	    return this;
	  }
	  /**
	   * Create a Style Sheet.
	   */
	  ;
	
	  _proto.createStyleSheet = function createStyleSheet(styles, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        index = _options.index;
	
	    if (typeof index !== 'number') {
	      index = registry.index === 0 ? 0 : registry.index + 1;
	    }
	
	    var sheet = new StyleSheet(styles, _extends__default['default']({}, options, {
	      jss: this,
	      generateId: options.generateId || this.generateId,
	      insertionPoint: this.options.insertionPoint,
	      Renderer: this.options.Renderer,
	      index: index
	    }));
	    this.plugins.onProcessSheet(sheet);
	    return sheet;
	  }
	  /**
	   * Detach the Style Sheet and remove it from the registry.
	   */
	  ;
	
	  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
	    sheet.detach();
	    registry.remove(sheet);
	    return this;
	  }
	  /**
	   * Create a rule without a Style Sheet.
	   * [Deprecated] will be removed in the next major version.
	   */
	  ;
	
	  _proto.createRule = function createRule$1(name, style, options) {
	    if (style === void 0) {
	      style = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Enable rule without name for inline styles.
	    if (typeof name === 'object') {
	      // $FlowFixMe[incompatible-call]
	      return this.createRule(undefined, name, style);
	    } // $FlowFixMe[incompatible-type]
	
	
	    var ruleOptions = _extends__default['default']({}, options, {
	      name: name,
	      jss: this,
	      Renderer: this.options.Renderer
	    });
	
	    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
	    if (!ruleOptions.classes) ruleOptions.classes = {};
	    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
	
	    var rule = createRule(name, style, ruleOptions);
	
	    if (rule) this.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Register plugin. Passed function will be invoked with a rule instance.
	   */
	  ;
	
	  _proto.use = function use() {
	    var _this = this;
	
	    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins[_key] = arguments[_key];
	    }
	
	    plugins.forEach(function (plugin) {
	      _this.plugins.use(plugin);
	    });
	    return this;
	  };
	
	  return Jss;
	}();
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	function getDynamicStyles(styles) {
	  var to = null;
	
	  for (var key in styles) {
	    var value = styles[key];
	    var type = typeof value;
	
	    if (type === 'function') {
	      if (!to) to = {};
	      to[key] = value;
	    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	      var extracted = getDynamicStyles(value);
	
	      if (extracted) {
	        if (!to) to = {};
	        to[key] = extracted;
	      }
	    }
	  }
	
	  return to;
	}
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 */
	var SheetsManager =
	/*#__PURE__*/
	function () {
	  function SheetsManager() {
	    this.length = 0;
	    this.sheets = new WeakMap();
	  }
	
	  var _proto = SheetsManager.prototype;
	
	  _proto.get = function get(key) {
	    var entry = this.sheets.get(key);
	    return entry && entry.sheet;
	  };
	
	  _proto.add = function add(key, sheet) {
	    if (this.sheets.has(key)) return;
	    this.length++;
	    this.sheets.set(key, {
	      sheet: sheet,
	      refs: 0
	    });
	  };
	
	  _proto.manage = function manage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs === 0) {
	        entry.sheet.attach();
	      }
	
	      entry.refs++;
	      return entry.sheet;
	    }
	
	    warning__default['default'](false, "[JSS] SheetsManager: can't find sheet to manage");
	    return undefined;
	  };
	
	  _proto.unmanage = function unmanage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs > 0) {
	        entry.refs--;
	        if (entry.refs === 0) entry.sheet.detach();
	      }
	    } else {
	      warning__default['default'](false, "SheetsManager: can't find sheet to unmanage");
	    }
	  };
	
	  _createClass__default['default'](SheetsManager, [{
	    key: "size",
	    get: function get() {
	      return this.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	/**
	 * A better abstraction over CSS.
	 *
	 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
	 * @website https://github.com/cssinjs/jss
	 * @license MIT
	 */
	
	/**
	 * Export a constant indicating if this browser has CSSTOM support.
	 * https://developers.google.com/web/updates/2018/03/cssom
	 */
	var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
	/**
	 * Creates a new instance of Jss.
	 */
	
	var create = function create(options) {
	  return new Jss(options);
	};
	/**
	 * A global Jss instance.
	 */
	
	var jss = create();
	
	exports.RuleList = RuleList;
	exports.SheetsManager = SheetsManager;
	exports.SheetsRegistry = SheetsRegistry;
	exports.create = create;
	exports.createGenerateId = createGenerateId;
	exports.createRule = createRule;
	exports.default = jss;
	exports.getDynamicStyles = getDynamicStyles;
	exports.hasCSSTOMSupport = hasCSSTOMSupport;
	exports.sheets = registry;
	exports.toCssValue = toCssValue;


/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1280),
	    getValue = __webpack_require__(1323);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(265);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1765);
	var objectAssign = __webpack_require__(195);
	var decodeComponent = __webpack_require__(1226);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	function extract(str) {
		var queryStart = str.indexOf('?');
		if (queryStart === -1) {
			return '';
		}
		return str.slice(queryStart + 1);
	}
	
	function parse(str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^[?#&]/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeComponent(val);
	
			formatter(decodeComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	}
	
	exports.extract = extract;
	exports.parse = parse;
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		if (opts.sort === false) {
			opts.sort = function () {};
		}
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};
	
	exports.parseUrl = function (str, opts) {
		return {
			url: str.split('?')[0] || '',
			query: parse(extract(str), opts)
		};
	};


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ReactReduxContext = _react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteKey = exports.updateKey = exports.createKey = exports.fetchKeyNameUnique = exports.getKeyNameUniqueUrl = exports.fetchTenantInfos = exports.fetchAvailableApiPlans = exports.resetSecret = exports.generateSecret = exports.fetchApiGroupEulas = exports.fetchAvailableApiGroups = exports.fetchSelectedApiGroups = exports.fetchApiEula = exports.fetchAvailableOrgs = exports.fetchAvailableApps = exports.fetchAvailableApis = exports.fetchSelectedApis = exports.fetchCustomFields = exports.fetchApplicationNameUnique = exports.getApplicationNameUniqueUrl = exports.fetchAllOrganizations = exports.fetchOrganizations = exports.deleteApplication = exports.updateApplicationSecret = exports.updateAndGetApplication = exports.updateApplication = exports.createApplication = exports.fetchApplication = exports.fetchAllApiPlans = exports.updateApplicationStatus = exports.fetchSingleApplication = exports.undeployApiKeyFromProxy = exports.redeployApiKeyToProxy = exports.deployApiKeyToProxy = exports.fetchProxiesByApiKey = exports.fetchProxies = exports.fetchApplicationKeys = exports.resetDeleteApplicationStatus = exports.resetApp = exports.showLoading = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__(100);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _portalConfig = __webpack_require__(26);
	
	var _utils = __webpack_require__(18);
	
	var _actions = __webpack_require__(204);
	
	var _requestParser = __webpack_require__(1450);
	
	var _portalConfig2 = __webpack_require__(85);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initApplication = function initApplication(dispatch) {
	  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return dispatch({
	    type: Constants.APPLICATION_LOADING,
	    isLoading: isLoading
	  });
	};
	
	var showLoading = exports.showLoading = function showLoading(isLoading) {
	  return function (dispatch) {
	    return initApplication(dispatch, isLoading);
	  };
	};
	var resetApp = exports.resetApp = function resetApp() {
	  return function (dispatch) {
	    return dispatch({ type: Constants.APP_RESET });
	  };
	};
	var resetDeleteApplicationStatus = exports.resetDeleteApplicationStatus = function resetDeleteApplicationStatus() {
	  return function (dispatch) {
	    return dispatch({ type: Constants.APPLICATION_DELETE_RESET });
	  };
	};
	
	var fetchApplicationKeys = exports.fetchApplicationKeys = function fetchApplicationKeys(appUuid) {
	  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/applications/' + appUuid + '/api-keys?page=' + page + '&size=' + size;
	              _context.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_ALL_KEYS_GET_SUCCESS,
	                  payload: (0, _lodash.get)(response, 'data')
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ALL_KEYS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchProxies = exports.fetchProxies = function fetchProxies() {
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/internal/proxies?status=ACTIVE';
	              _context2.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.PROXIES_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.PROXIES_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchProxiesByApiKey = exports.fetchProxiesByApiKey = function fetchProxiesByApiKey(apikey) {
	  return function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/api-keys/' + apikey + '/proxies';
	              _context3.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.API_KEY_PROXIES_GET_SUCCESS,
	                  payload: {
	                    key: apikey,
	                    proxies: response.data
	                  }
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.API_KEY_PROXIES_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function (_x8, _x9) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var getDeploymentValidationErrors = function getDeploymentValidationErrors(error) {
	  return (0, _lodash.get)(error, 'validationErrors');
	};
	var processDeploymentErrors = function processDeploymentErrors(validationErrors, defaultMessage) {
	  var errorMessage = defaultMessage;
	  var keys = Object.keys(validationErrors);
	  if (keys.length > 0) {
	    errorMessage = (0, _lodash.map)(keys, function (key) {
	      return validationErrors[key].devMessage;
	    }).join('\n');
	  }
	  return errorMessage;
	};
	
	var deployApiKeyToProxy = exports.deployApiKeyToProxy = function deployApiKeyToProxy(apiKey, uuid) {
	  return function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = { proxyUuid: uuid };
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/api-keys/' + apiKey + '/proxies';
	              _context4.next = 6;
	              return _axios2.default.post(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.API_KEY_DEPLOY_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                var statusCode = (0, _lodash.get)(error, 'response.status');
	                if (statusCode === Constants.HTTP_STATUS_UNAUTHORIZED) {
	                  window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	                }
	
	                var responseError = (0, _lodash.get)(error, 'response.data');
	                var strErrorMessage = statusCode === Constants.HTTP_STATUS_BAD_REQUEST ? processDeploymentErrors(getDeploymentValidationErrors(responseError), '') : (0, _lodash.get)(error, 'message');
	                dispatch({
	                  type: Constants.API_KEY_DEPLOY_ERROR,
	                  payload: {
	                    apiKey: apiKey,
	                    proxyUuid: uuid,
	                    errorMessage: strErrorMessage
	                  }
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x10, _x11) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var redeployApiKeyToProxy = exports.redeployApiKeyToProxy = function redeployApiKeyToProxy(apiKey, uuid) {
	  return function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = {
	                status: 'PENDING_DEPLOYMENT'
	              };
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/api-keys/' + apiKey + '/proxies/' + uuid;
	              _context5.next = 6;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.API_KEY_REDEPLOY_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                var statusCode = (0, _lodash.get)(error, 'response.status');
	                if (statusCode === Constants.HTTP_STATUS_UNAUTHORIZED) {
	                  window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	                }
	
	                var responseError = (0, _lodash.get)(error, 'response.data');
	                var strErrorMessage = statusCode === Constants.HTTP_STATUS_BAD_REQUEST ? processDeploymentErrors(getDeploymentValidationErrors(responseError), '') : (0, _lodash.get)(error, 'message');
	                dispatch({
	                  type: Constants.API_KEY_REDEPLOY_ERROR,
	                  payload: {
	                    apiKey: apiKey,
	                    proxyUuid: uuid,
	                    errorMessage: strErrorMessage
	                  }
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x12, _x13) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	};
	
	var undeployApiKeyFromProxy = exports.undeployApiKeyFromProxy = function undeployApiKeyFromProxy(apiKey, uuid) {
	  return function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/api-keys/' + apiKey + '/proxies/' + uuid;
	              _context6.next = 5;
	              return _axios2.default.delete(url, { credentials: 'include' }).then(function () {
	                dispatch({
	                  type: Constants.API_KEY_UNDEPLOY_SUCCESS,
	                  payload: null
	                });
	              }).catch(function (error) {
	                var statusCode = (0, _lodash.get)(error, 'response.status');
	                if (statusCode === Constants.HTTP_STATUS_UNAUTHORIZED) {
	                  window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	                }
	
	                var responseError = (0, _lodash.get)(error, 'response.data');
	                var strErrorMessage = statusCode === Constants.HTTP_STATUS_BAD_REQUEST ? processDeploymentErrors(getDeploymentValidationErrors(responseError), '') : (0, _lodash.get)(error, 'message');
	                dispatch({
	                  type: Constants.API_KEY_UNDEPLOY_ERROR,
	                  payload: {
	                    apiKey: apiKey,
	                    proxyUuid: uuid,
	                    errorMessage: strErrorMessage
	                  }
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined);
	    }));
	
	    return function (_x14, _x15) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchSingleApplication = exports.fetchSingleApplication = function fetchSingleApplication(applicationUuid) {
	  return function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/Applications(\'' + applicationUuid + '\')';
	              _context7.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_SINGLE_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined);
	    }));
	
	    return function (_x16, _x17) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	};
	
	var updateApplicationStatus = exports.updateApplicationStatus = function updateApplicationStatus(applicationDetails) {
	  return function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              dispatch({
	                type: Constants.APPLICATION_STATUS_UPDATE_RESET,
	                payload: ''
	              });
	
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getUpdateData)(applicationDetails);
	              url = portal.hostname + '/admin/Portal.svc/Applications(\'' + applicationDetails.uuid + '\')';
	              _context8.next = 7;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_STATUS_UPDATE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_STATUS_UPDATE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined);
	    }));
	
	    return function (_x18, _x19) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAllApiPlans = exports.fetchAllApiPlans = function fetchAllApiPlans() {
	  return function () {
	    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/api-plans';
	              _context9.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_API_PLANS_GET_SUCCESS,
	                  payload: (0, _lodash.get)(response, 'data.results', [])
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, undefined);
	    }));
	
	    return function (_x20, _x21) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApplication = exports.fetchApplication = function fetchApplication(applicationUuid) {
	  return function () {
	    var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              initApplication(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/Applications(\'' + applicationUuid + '\')';
	              _context10.next = 6;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, undefined);
	    }));
	
	    return function (_x22, _x23) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	};
	
	var createApplication = exports.createApplication = function createApplication(applicationDetails) {
	  return function () {
	    var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(dispatch, getState) {
	      var config, portal, data, url, isValidSession;
	      return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getCreateData)(applicationDetails);
	              url = portal.hostname + '/admin/Portal.svc/Applications';
	              _context11.next = 6;
	              return (0, _portalConfig2.checkSession)(getState());
	
	            case 6:
	              isValidSession = _context11.sent;
	
	              if (!isValidSession) {
	                _context11.next = 12;
	                break;
	              }
	
	              _context11.next = 10;
	              return _axios2.default.post(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_CREATE_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 10:
	              _context11.next = 13;
	              break;
	
	            case 12:
	              window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	
	            case 13:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, undefined);
	    }));
	
	    return function (_x24, _x25) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	};
	
	var updateApplication = exports.updateApplication = function updateApplication(applicationDetails) {
	  return function () {
	    var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(dispatch, getState) {
	      var config, portal, data, url, isValidSession;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getUpdateData)(applicationDetails);
	              url = portal.hostname + '/admin/Portal.svc/Applications(\'' + applicationDetails.uuid + '\')';
	              _context12.next = 6;
	              return (0, _portalConfig2.checkSession)(getState());
	
	            case 6:
	              isValidSession = _context12.sent;
	
	              if (!isValidSession) {
	                _context12.next = 12;
	                break;
	              }
	
	              _context12.next = 10;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_UPDATE_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 10:
	              _context12.next = 13;
	              break;
	
	            case 12:
	              window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	
	            case 13:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, undefined);
	    }));
	
	    return function (_x26, _x27) {
	      return _ref12.apply(this, arguments);
	    };
	  }();
	};
	
	var updateAndGetApplication = exports.updateAndGetApplication = function updateAndGetApplication(applicationDetails) {
	  return function () {
	    var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(dispatch, getState) {
	      var config, portal, data, updateUrl, fetchUrl, isValidSession;
	      return _regenerator2.default.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getUpdateData)(applicationDetails);
	              updateUrl = portal.hostname + '/admin/Portal.svc/Applications(\'' + applicationDetails.uuid + '\')';
	              fetchUrl = portal.hostname + '/admin/Portal.svc/Applications(\'' + applicationDetails.uuid + '\')';
	              _context13.next = 7;
	              return (0, _portalConfig2.checkSession)(getState());
	
	            case 7:
	              isValidSession = _context13.sent;
	
	              if (!isValidSession) {
	                _context13.next = 23;
	                break;
	              }
	
	              _context13.t0 = Promise;
	              _context13.next = 12;
	              return _axios2.default.put(updateUrl, data, { credentials: 'include' });
	
	            case 12:
	              _context13.t1 = _context13.sent;
	              _context13.next = 15;
	              return _axios2.default.get(fetchUrl, { credentials: 'include' });
	
	            case 15:
	              _context13.t2 = _context13.sent;
	              _context13.t3 = [_context13.t1, _context13.t2];
	
	              _context13.t4 = function (responseArr) {
	                dispatch({
	                  type: Constants.APPLICATION_UPDATE_AND_GET_SUCCESS,
	                  isLoading: false,
	                  payload: Object.assign({}, responseArr[0].data, responseArr[1].data)
	                });
	              };
	
	              _context13.t5 = function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              };
	
	              _context13.next = 21;
	              return _context13.t0.all.call(_context13.t0, _context13.t3).then(_context13.t4).catch(_context13.t5);
	
	            case 21:
	              _context13.next = 24;
	              break;
	
	            case 23:
	              window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	
	            case 24:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, undefined);
	    }));
	
	    return function (_x28, _x29) {
	      return _ref13.apply(this, arguments);
	    };
	  }();
	};
	
	var updateApplicationSecret = exports.updateApplicationSecret = function updateApplicationSecret(applicationDetails) {
	  return function () {
	    var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(dispatch, getState) {
	      var config, portal, data, url, isValidSession;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getUpdateData)(applicationDetails);
	              url = portal.hostname + '/admin/Portal.svc/Applications(\'' + applicationDetails.uuid + '\')';
	              _context14.next = 6;
	              return (0, _portalConfig2.checkSession)(getState());
	
	            case 6:
	              isValidSession = _context14.sent;
	
	              if (!isValidSession) {
	                _context14.next = 12;
	                break;
	              }
	
	              _context14.next = 10;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_SECRET_UPDATE_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 10:
	              _context14.next = 13;
	              break;
	
	            case 12:
	              window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	
	            case 13:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, undefined);
	    }));
	
	    return function (_x30, _x31) {
	      return _ref14.apply(this, arguments);
	    };
	  }();
	};
	
	var deleteApplication = exports.deleteApplication = function deleteApplication(applicationDetails) {
	  return function () {
	    var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getDeleteData)(applicationDetails);
	
	              dispatch({ type: Constants.APPLICATION_DELETE_RESET });
	
	              url = portal.hostname + '/admin/Portal.svc/Applications(\'' + applicationDetails.uuid + '\')';
	              _context15.next = 7;
	              return _axios2.default.delete(url, data, { credentials: 'include' }).then(function () {
	                dispatch({
	                  type: Constants.APPLICATION_DELETE_SUCCESS,
	                  payload: null
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_DELETE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, undefined);
	    }));
	
	    return function (_x32, _x33) {
	      return _ref15.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchOrganizations = exports.fetchOrganizations = function fetchOrganizations() {
	  var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  return function () {
	    var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/internal/organizations?status=ENABLED&size=' + size + '&page=' + pageNumber;
	              _context16.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_ORGANIZATIONS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, undefined);
	    }));
	
	    return function (_x36, _x37) {
	      return _ref16.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAllOrganizations = exports.fetchAllOrganizations = function fetchAllOrganizations() {
	  return fetchOrganizations(1000);
	};
	
	var getApplicationNameUniqueUrl = exports.getApplicationNameUniqueUrl = function getApplicationNameUniqueUrl(applicationName, currentId, organizationUuid) {
	  var name = encodeURIComponent(applicationName);
	  if (currentId && organizationUuid) {
	    return 'Name=\'' + name + '\'&CurrentId=\'' + currentId + '\'&OrganizationUuid=\'' + organizationUuid + '\'';
	  } else if (currentId) {
	    return 'Name=\'' + name + '\'&CurrentId=\'' + currentId + '\'';
	  } else if (organizationUuid) {
	    return 'Name=\'' + name + '\'&OrganizationUuid=\'' + organizationUuid + '\'';
	  }
	  return 'Name=\'' + name + '\'';
	};
	
	var fetchApplicationNameUnique = exports.fetchApplicationNameUnique = function fetchApplicationNameUnique(applicationName, currentId, organizationUuid) {
	  return function (dispatch, getState) {
	    // Run Unique check when applicationName is non-null.
	    if (!applicationName) {
	      return;
	    }
	
	    var config = (0, _portalConfig.getConfig)(getState());
	    var portal = config.portal;
	
	    var applicationNameUniqueUrl = getApplicationNameUniqueUrl(applicationName, currentId, organizationUuid);
	    var url = portal.hostname + '/admin/Portal.svc/ApplicationNameUnique()?' + applicationNameUniqueUrl;
	
	    _actions.debouncedAxiosGet.cancel();
	    (0, _actions.debouncedAxiosGet)(url, { credentials: 'include' }, function (response) {
	      return dispatch({
	        type: Constants.APPLICATION_NAME_UNIQUE_SUCCESS,
	        payload: response.data
	      });
	    }, function (error) {
	      return dispatch({
	        type: Constants.APPLICATION_ERROR,
	        payload: (0, _utils.getValidationErrors)(error)
	      });
	    });
	  };
	};
	
	var fetchCustomFields = exports.fetchCustomFields = function fetchCustomFields() {
	  return function () {
	    var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee17$(_context17) {
	        while (1) {
	          switch (_context17.prev = _context17.next) {
	            case 0:
	              initApplication(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/CustomFields?%24inlinecount=allpages&%24filter=EntityType+eq+%27APPLICATION%27+and+Status+eq+%27ENABLED%27';
	              _context17.next = 6;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_CUSTOM_FIELDS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context17.stop();
	          }
	        }
	      }, _callee17, undefined);
	    }));
	
	    return function (_x38, _x39) {
	      return _ref17.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchSelectedApis = exports.fetchSelectedApis = function fetchSelectedApis(applicationUuid) {
	  return function () {
	    var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee18$(_context18) {
	        while (1) {
	          switch (_context18.prev = _context18.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/ApplicationApiXrefs?%24inlinecount=allpages&%24filter=ApplicationUuid+eq+%27' + applicationUuid + '%27';
	              _context18.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_SELECTED_APIS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  isLoading: false,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context18.stop();
	          }
	        }
	      }, _callee18, undefined);
	    }));
	
	    return function (_x40, _x41) {
	      return _ref18.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchQueryString = function fetchQueryString(params) {
	  var queryString = _queryString2.default.stringify(params, true);
	  queryString = queryString ? '?' + queryString : '';
	  return queryString;
	};
	
	var fetchAvailableApis = function fetchAvailableApis(params) {
	  return function () {
	    var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(dispatch, getState) {
	      var defaultParams, tagsParam, searchParam, otherParams, updatedParams, queryString, config, portal, url;
	      return _regenerator2.default.wrap(function _callee19$(_context19) {
	        while (1) {
	          switch (_context19.prev = _context19.next) {
	            case 0:
	              defaultParams = {
	                size: 10,
	                page: 0,
	                portalStatus: 'ENABLED'
	              };
	              tagsParam = params.tags, searchParam = params.searchText, otherParams = _objectWithoutProperties(params, ['tags', 'searchText']);
	              updatedParams = Object.assign({}, defaultParams, otherParams, (0, _lodash.isArray)(tagsParam) && tagsParam.length > 0 && { tags: tagsParam.join(',') }, searchParam && { name: searchParam });
	              queryString = fetchQueryString(updatedParams);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis' + queryString;
	              _context19.next = 9;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_AVAILABLE_APIS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data,
	                  page: updatedParams.page
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 9:
	            case 'end':
	              return _context19.stop();
	          }
	        }
	      }, _callee19, undefined);
	    }));
	
	    return function (_x42, _x43) {
	      return _ref19.apply(this, arguments);
	    };
	  }();
	};
	
	exports.fetchAvailableApis = fetchAvailableApis;
	var fetchAvailableApps = function fetchAvailableApps(params) {
	  return function () {
	    var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(dispatch, getState) {
	      var defaultParams, tagsParam, searchParam, otherParams, updatedParams, queryString, config, portal, url;
	      return _regenerator2.default.wrap(function _callee20$(_context20) {
	        while (1) {
	          switch (_context20.prev = _context20.next) {
	            case 0:
	              defaultParams = {
	                size: 10,
	                page: 0,
	                portalStatus: 'ENABLED'
	              };
	              tagsParam = params.tags, searchParam = params.searchText, otherParams = _objectWithoutProperties(params, ['tags', 'searchText']);
	              updatedParams = Object.assign({}, defaultParams, otherParams, (0, _lodash.isArray)(tagsParam) && tagsParam.length > 0 && { tags: tagsParam.join(',') }, searchParam && { name: searchParam });
	              queryString = fetchQueryString(updatedParams);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/applications' + queryString;
	              _context20.next = 9;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_AVAILABLE_APPS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data,
	                  page: updatedParams.page
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 9:
	            case 'end':
	              return _context20.stop();
	          }
	        }
	      }, _callee20, undefined);
	    }));
	
	    return function (_x44, _x45) {
	      return _ref20.apply(this, arguments);
	    };
	  }();
	};
	
	exports.fetchAvailableApps = fetchAvailableApps;
	var fetchAvailableOrgs = function fetchAvailableOrgs(params) {
	  return function () {
	    var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(dispatch, getState) {
	      var defaultParams, tagsParam, searchParam, otherParams, updatedParams, queryString, config, portal, url;
	      return _regenerator2.default.wrap(function _callee21$(_context21) {
	        while (1) {
	          switch (_context21.prev = _context21.next) {
	            case 0:
	              defaultParams = {
	                size: 10,
	                page: 0,
	                portalStatus: 'ENABLED'
	              };
	              tagsParam = params.tags, searchParam = params.searchText, otherParams = _objectWithoutProperties(params, ['tags', 'searchText']);
	              updatedParams = Object.assign({}, defaultParams, otherParams, (0, _lodash.isArray)(tagsParam) && tagsParam.length > 0 && { tags: tagsParam.join(',') }, searchParam && { name: searchParam });
	              queryString = fetchQueryString(updatedParams);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/internal/organizations' + queryString;
	              _context21.next = 9;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_AVAILABLE_ORGS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data,
	                  page: updatedParams.page
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 9:
	            case 'end':
	              return _context21.stop();
	          }
	        }
	      }, _callee21, undefined);
	    }));
	
	    return function (_x46, _x47) {
	      return _ref21.apply(this, arguments);
	    };
	  }();
	};
	
	exports.fetchAvailableOrgs = fetchAvailableOrgs;
	var fetchApiEula = exports.fetchApiEula = function fetchApiEula(eulaUuid) {
	  return function () {
	    var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee22$(_context22) {
	        while (1) {
	          switch (_context22.prev = _context22.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/ApiEulas(\'' + eulaUuid + '\')';
	              _context22.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_API_EULA_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context22.stop();
	          }
	        }
	      }, _callee22, undefined);
	    }));
	
	    return function (_x48, _x49) {
	      return _ref22.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchSelectedApiGroups = exports.fetchSelectedApiGroups = function fetchSelectedApiGroups(applicationUuid) {
	  return function () {
	    var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee23$(_context23) {
	        while (1) {
	          switch (_context23.prev = _context23.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/api-management/internal/applications/ApplicationApiGroupXrefs?%24inlinecount=allpages&%24filter=ApplicationUuid+eq+%27' + applicationUuid + '%27';
	              _context23.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context23.stop();
	          }
	        }
	      }, _callee23, undefined);
	    }));
	
	    return function (_x50, _x51) {
	      return _ref23.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAvailableApiGroups = exports.fetchAvailableApiGroups = function fetchAvailableApiGroups(_ref24) {
	  var orgUuid = _ref24.orgUuid,
	      _ref24$size = _ref24.size,
	      size = _ref24$size === undefined ? 10 : _ref24$size,
	      _ref24$page = _ref24.page,
	      page = _ref24$page === undefined ? 0 : _ref24$page,
	      _ref24$searchText = _ref24.searchText,
	      searchText = _ref24$searchText === undefined ? '' : _ref24$searchText;
	  return function () {
	    var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee24$(_context24) {
	        while (1) {
	          switch (_context24.prev = _context24.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/api-management/internal/OrganizationApiGroups?orgUuid=' + orgUuid + '&size=' + size + '&page=' + page + '&name=' + searchText;
	              _context24.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data,
	                  page: page
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context24.stop();
	          }
	        }
	      }, _callee24, undefined);
	    }));
	
	    return function (_x52, _x53) {
	      return _ref25.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApiGroupEulas = exports.fetchApiGroupEulas = function fetchApiGroupEulas(apiGroupUuid, organizationUuid) {
	  return function () {
	    var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee25$(_context25) {
	        while (1) {
	          switch (_context25.prev = _context25.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/api-management/internal/ApiGroups/' + apiGroupUuid + '/Eulas?%24filter=OrganizationUuid+eq+%27' + organizationUuid + '%27';
	              _context25.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_API_GROUP_EULAS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context25.stop();
	          }
	        }
	      }, _callee25, undefined);
	    }));
	
	    return function (_x54, _x55) {
	      return _ref26.apply(this, arguments);
	    };
	  }();
	};
	
	var generateSecret = exports.generateSecret = function generateSecret() {
	  return function () {
	    var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee26$(_context26) {
	        while (1) {
	          switch (_context26.prev = _context26.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/GenerateNewSharedSecret';
	              _context26.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.APPLICATION_GENERATE_SECRET_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context26.stop();
	          }
	        }
	      }, _callee26, undefined);
	    }));
	
	    return function (_x56, _x57) {
	      return _ref27.apply(this, arguments);
	    };
	  }();
	};
	
	var resetSecret = exports.resetSecret = function resetSecret() {
	  return function (dispatch) {
	    dispatch({
	      type: Constants.APPLICATION_GENERATE_SECRET_GET_SUCCESS,
	      isLoading: false,
	      payload: { d: { result: null } }
	    });
	  };
	};
	
	var fetchAvailableApiPlans = exports.fetchAvailableApiPlans = function fetchAvailableApiPlans(orgUuid, apiUuid) {
	  return function () {
	    var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee27$(_context27) {
	        while (1) {
	          switch (_context27.prev = _context27.next) {
	            case 0:
	              if (orgUuid && apiUuid) {
	                _context27.next = 2;
	                break;
	              }
	
	              return _context27.abrupt('return');
	
	            case 2:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/api-management/internal/api-plans?orgUuid=' + orgUuid + '&apiUuid=' + apiUuid + '&size=10&page=0';
	              _context27.next = 7;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (_ref29) {
	                var data = _ref29.data;
	
	                dispatch({
	                  type: Constants.APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: _defineProperty({}, apiUuid, data)
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context27.stop();
	          }
	        }
	      }, _callee27, undefined);
	    }));
	
	    return function (_x58, _x59) {
	      return _ref28.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchTenantInfos = exports.fetchTenantInfos = function fetchTenantInfos() {
	  return function () {
	    var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee28$(_context28) {
	        while (1) {
	          switch (_context28.prev = _context28.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/TenantInfos(\'' + portal.tenantPrefix + '\')';
	              _context28.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.TENANT_INFO_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.APPLICATION_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context28.stop();
	          }
	        }
	      }, _callee28, undefined);
	    }));
	
	    return function (_x60, _x61) {
	      return _ref30.apply(this, arguments);
	    };
	  }();
	};
	
	var getKeyNameUniqueUrl = exports.getKeyNameUniqueUrl = function getKeyNameUniqueUrl(appUuid, keyName, apiKey) {
	  var name = encodeURIComponent(keyName);
	  if (apiKey) {
	    return appUuid + '/api-keys/isNameUnique?name=' + name + '&apiKey=' + apiKey;
	  }
	  return appUuid + '/api-keys/isNameUnique?name=' + name;
	};
	
	var fetchKeyNameUnique = exports.fetchKeyNameUnique = function fetchKeyNameUnique(keyName, apiKey, appUuid) {
	  return function () {
	    var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(dispatch, getState) {
	      var config, portal, keyNameUniqueUrl, url;
	      return _regenerator2.default.wrap(function _callee29$(_context29) {
	        while (1) {
	          switch (_context29.prev = _context29.next) {
	            case 0:
	              if (keyName) {
	                _context29.next = 2;
	                break;
	              }
	
	              return _context29.abrupt('return');
	
	            case 2:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              keyNameUniqueUrl = getKeyNameUniqueUrl(appUuid, keyName, apiKey);
	              url = portal.hostname + '/admin/api-management/internal/applications/' + keyNameUniqueUrl;
	
	
	              _actions.debouncedAxiosGet.cancel();
	              (0, _actions.debouncedAxiosGet)(url, { credentials: 'include' }, function (response) {
	                return dispatch({
	                  type: Constants.KEY_NAME_UNIQUE_SUCCESS,
	                  payload: (0, _lodash.get)(response, 'data.isUnique')
	                });
	              }, function (error) {
	                return dispatch({
	                  type: Constants.KEY_NAME_UNIQUE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 8:
	            case 'end':
	              return _context29.stop();
	          }
	        }
	      }, _callee29, undefined);
	    }));
	
	    return function (_x62, _x63) {
	      return _ref31.apply(this, arguments);
	    };
	  }();
	};
	
	var createKey = exports.createKey = function createKey(keyDetails) {
	  return function () {
	    var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(dispatch, getState) {
	      var config, portal, appUuid, data, url, isValidSession;
	      return _regenerator2.default.wrap(function _callee30$(_context30) {
	        while (1) {
	          switch (_context30.prev = _context30.next) {
	            case 0:
	              dispatch({
	                type: Constants.KEY_STATUS_RESET,
	                payload: ''
	              });
	
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              appUuid = (0, _lodash.get)(keyDetails, 'appUuid');
	              data = {
	                name: (0, _lodash.get)(keyDetails, 'name'),
	                applicationUuid: appUuid,
	                oauthCallbackUrl: (0, _lodash.get)(keyDetails, 'oauthCallbackUrl', ''),
	                oauthScope: (0, _lodash.get)(keyDetails, 'oauthScope', ''),
	                oauthType: (0, _lodash.get)(keyDetails, 'oauthType', null),
	                keySecretHashed: (0, _lodash.get)(keyDetails, 'keySecretHashed', false),
	                defaultKey: (0, _lodash.get)(keyDetails, 'defaultKey', false)
	              };
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/applications/' + appUuid + '/api-keys';
	              _context30.next = 8;
	              return (0, _portalConfig2.checkSession)(getState());
	
	            case 8:
	              isValidSession = _context30.sent;
	
	              if (!isValidSession) {
	                _context30.next = 14;
	                break;
	              }
	
	              _context30.next = 12;
	              return _axios2.default.post(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.KEY_CREATE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.KEY_CREATE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 12:
	              _context30.next = 15;
	              break;
	
	            case 14:
	              window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	
	            case 15:
	            case 'end':
	              return _context30.stop();
	          }
	        }
	      }, _callee30, undefined);
	    }));
	
	    return function (_x64, _x65) {
	      return _ref32.apply(this, arguments);
	    };
	  }();
	};
	
	var updateKey = exports.updateKey = function updateKey(keyDetails) {
	  return function () {
	    var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(dispatch, getState) {
	      var config, portal, appUuid, apiKey, data, url, isValidSession;
	      return _regenerator2.default.wrap(function _callee31$(_context31) {
	        while (1) {
	          switch (_context31.prev = _context31.next) {
	            case 0:
	              dispatch({
	                type: Constants.KEY_STATUS_RESET,
	                payload: ''
	              });
	
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              appUuid = (0, _lodash.get)(keyDetails, 'appUuid');
	              apiKey = (0, _lodash.get)(keyDetails, 'apiKey');
	              data = {
	                name: (0, _lodash.get)(keyDetails, 'name'),
	                applicationUuid: appUuid,
	                oauthCallbackUrl: (0, _lodash.get)(keyDetails, 'oauthCallbackUrl', ''),
	                oauthScope: (0, _lodash.get)(keyDetails, 'oauthScope', ''),
	                oauthType: (0, _lodash.get)(keyDetails, 'oauthType', null),
	                status: (0, _lodash.get)(keyDetails, 'status'),
	                keySecretHashed: (0, _lodash.get)(keyDetails, 'keySecretHashed', false),
	                keySecret: (0, _lodash.get)(keyDetails, 'keySecret', undefined),
	                defaultKey: (0, _lodash.get)(keyDetails, 'defaultKey', false)
	              };
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/applications/' + appUuid + '/api-keys/' + apiKey;
	              _context31.next = 9;
	              return (0, _portalConfig2.checkSession)(getState());
	
	            case 9:
	              isValidSession = _context31.sent;
	
	              if (!isValidSession) {
	                _context31.next = 15;
	                break;
	              }
	
	              _context31.next = 13;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.KEY_UPDATE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.KEY_UPDATE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 13:
	              _context31.next = 16;
	              break;
	
	            case 15:
	              window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	
	            case 16:
	            case 'end':
	              return _context31.stop();
	          }
	        }
	      }, _callee31, undefined);
	    }));
	
	    return function (_x66, _x67) {
	      return _ref33.apply(this, arguments);
	    };
	  }();
	};
	
	var deleteKey = exports.deleteKey = function deleteKey(keyDetails) {
	  return function () {
	    var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(dispatch, getState) {
	      var config, portal, appUuid, apiKey, url;
	      return _regenerator2.default.wrap(function _callee32$(_context32) {
	        while (1) {
	          switch (_context32.prev = _context32.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              appUuid = (0, _lodash.get)(keyDetails, 'appUuid');
	              apiKey = (0, _lodash.get)(keyDetails, 'apiKey');
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/applications/' + appUuid + '/api-keys/' + apiKey;
	              _context32.next = 7;
	              return _axios2.default.delete(url, { credentials: 'include' }).then(function () {
	                dispatch({
	                  type: Constants.KEY_DELETE_SUCCESS,
	                  payload: null
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.KEY_DELETE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context32.stop();
	          }
	        }
	      }, _callee32, undefined);
	    }));
	
	    return function (_x68, _x69) {
	      return _ref34.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var styles = function styles(_ref) {
	  var borderRadius = _ref.borderRadius,
	      color = _ref.color;
	  return {
	    topPanelContainer: {
	      backgroundColor: '' + (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'borderColor'), 0.1),
	      minHeight: '120px',
	      padding: '0 36px'
	    },
	    marginPanelContainer: {
	      minHeight: '350px'
	    },
	    icon: {
	      padding: 0,
	      marginRight: 8,
	      marginTop: '-3px'
	    },
	    portalCompatibility: {
	      marginTop: 14
	    },
	    compatible: {
	      color: (0, _lodash.get)(color, 'success')
	    },
	    incompatible: {
	      color: (0, _lodash.get)(color, 'danger')
	    },
	    countMismatch: {
	      color: (0, _lodash.get)(color, 'danger'),
	      borderColor: 'black'
	    },
	    divider: {
	      backgroundColor: (0, _lodash.get)(color, 'borderColor')
	    },
	    paper: {
	      border: '1px solid ' + (0, _lodash.get)(color, 'borderColor')
	    },
	    copyProxyUrl: {
	      padding: 0,
	      '& > span > p': {
	        color: (0, _lodash.get)(color, 'link')
	      }
	    },
	    selectOrganization: {
	      margin: '0 !important',
	      '& label + div': {
	        borderRadius: (0, _lodash.get)(borderRadius, 'br4') + ' 0 0 ' + (0, _lodash.get)(borderRadius, 'br4')
	      }
	    },
	    selectOrganizationGo: {
	      borderRadius: '0 ' + (0, _lodash.get)(borderRadius, 'br3') + ' ' + (0, _lodash.get)(borderRadius, 'br3') + ' 0',
	      margin: '31px 0'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getApiKeys = exports.getKeysListResults = exports.getKeysListTotalElements = exports.getKeysListTotalPages = exports.getApisListResults = exports.getApisListTotalElements = exports.getApisListTotalPages = exports.getPageErrors = exports.getHasError = exports.getApiPlans = exports.getAccountPlans = exports.getIsApiKeysLoading = exports.getApiKeysCount = exports.getApis = exports.getProxyOrganizations = exports.getIsProxyApisLoading = exports.getProxyApis = exports.getDeleteProxyErrors = exports.getIsProxyDeleteSuccess = exports.getProxyGateways = exports.getParsedProxyGatewayDetails = exports.getProxyGatewayDetails = exports.getProxyGatewayDetailsLoading = exports.getProxyDetailsBulkApiKeyDeploymentStatus = exports.getProxyDetailsBulkDeploymentStatus = exports.getProxyDetails = exports.getProxy = exports.getIsLoading = exports.getUpdateProxyOrgsStatus = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.API_PROXY_LOADING:
	      return Object.assign({}, state, {
	        hasError: false,
	        pageErrors: [],
	        isLoading: action.payload
	      });
	    case constants.API_PROXY_RESET:
	      return Object.assign({}, initialState, {
	        isProxyDeleteSuccess: false
	      });
	    case constants.PROXY_GET_SUCCESS:
	      return Object.assign({}, state, {
	        proxyDetails: (0, _get2.default)(action.payload, 'proxyDetails'),
	        proxy: (0, _get2.default)(action.payload, 'proxy'),
	        fetchProxyStatus: constants.SUCCESS,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_GET_ERROR:
	      return Object.assign({}, state, {
	        proxyUuid: '',
	        proxyDetails: {},
	        fetchProxyStatus: constants.FAIL,
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.PROXY_DELETE_SUCCESS:
	      return Object.assign({}, state, {
	        hasError: false,
	        pageErrors: [],
	        isProxyDeleteSuccess: true
	      });
	    case constants.PROXY_DELETE_ERROR:
	      return Object.assign({}, state, {
	        hasError: true,
	        pageErrors: action.payload,
	        isProxyDeleteSuccess: false
	      });
	    case constants.PROXY_DETAILS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        proxyDetails: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_DETAILS_GET_ERROR:
	      return Object.assign({}, state, {
	        proxyDetails: {},
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.PROXY_GATEWAY_GET_REQUEST:
	      return Object.assign({}, state, {
	        gatewayDetailsLoading: true,
	        isLoading: true,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_GATEWAY_GET_SUCCESS:
	      return Object.assign({}, state, {
	        gatewayDetailsLoading: false,
	        isLoading: false,
	        gatewayDetails: action.payload.gatewayDetails,
	        gateways: action.payload.gateways,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_GATEWAY_GET_ERROR:
	      return Object.assign({}, state, {
	        gatewayDetailsLoading: false,
	        isLoading: false,
	        gatewayDetails: {},
	        gateways: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS:
	      return Object.assign({}, state, {
	        proxyDetails: Object.assign({}, state.proxyDetails, { config: { useNewAutoSync: true }
	        }),
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR:
	      return Object.assign({}, state, {
	        hasError: true,
	        proxyDetails: Object.assign({}, state.proxyDetails, { config: { useNewAutoSync: false }
	        }),
	        pageErrors: action.payload
	      });
	    case constants.PROXY_APIS_GET_REQUEST:
	      return Object.assign({}, state, {
	        proxyApisLoading: true,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_APIS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        proxyApis: {
	          apis: (0, _get2.default)(action.payload, 'apis'),
	          apisPendingDeployment: (0, _get2.default)(action.payload, 'apisPendingDeployment'),
	          apisDeployed: (0, _get2.default)(action.payload, 'apisDeployed'),
	          apisError: (0, _get2.default)(action.payload, 'apisError'),
	          apisPublishedByPortal: (0, _get2.default)(action.payload, 'apisPublishedByPortal'),
	          apisPublishedByPortalPendingDeployment: (0, _get2.default)(action.payload, 'apisPublishedByPortalPendingDeployment'),
	          apisPublishedByPortalDeployed: (0, _get2.default)(action.payload, 'apisPublishedByPortalDeployed'),
	          apisPublishedByPortalError: (0, _get2.default)(action.payload, 'apisPublishedByPortalError'),
	          apisPublishedByGateway: (0, _get2.default)(action.payload, 'apisPublishedByGateway'),
	          apisPublishedByGatewayPendingDeployment: (0, _get2.default)(action.payload, 'apisPublishedByGatewayPendingDeployment'),
	          apisPublishedByGatewayDeployed: (0, _get2.default)(action.payload, 'apisPublishedByGatewayDeployed'),
	          apisPublishedByGatewayError: (0, _get2.default)(action.payload, 'apisPublishedByGatewayError'),
	          apisPendingUndeployment: (0, _get2.default)(action.payload, 'apisPendingUndeployment'),
	          apisPublishedByPortalPendingUndeployment: (0, _get2.default)(action.payload, 'apisPublishedByPortalPendingUndeployment'),
	          apisPublishedByGatewayPendingUndeployment: (0, _get2.default)(action.payload, 'apisPublishedByGatewayPendingUndeployment'),
	          apisErrorUndeploy: (0, _get2.default)(action.payload, 'apisErrorUndeploy'),
	          apisPublishedByPortalErrorUndeploy: (0, _get2.default)(action.payload, 'apisPublishedByPortalErrorUndeploy'),
	          apisPublishedByGatewayErrorUndeploy: (0, _get2.default)(action.payload, 'apisPublishedByGatewayErrorUndeploy')
	        },
	        proxyApisLoading: false,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_APIS_GET_ERROR:
	      return Object.assign({}, state, {
	        proxyApis: {
	          apis: 0,
	          apisPendingDeployment: 0,
	          apisDeployed: 0,
	          apisError: 0,
	          apisPublishedByPortal: 0,
	          apisPublishedByPortalPendingDeployment: 0,
	          apisPublishedByPortalDeployed: 0,
	          apisPublishedByPortalError: 0,
	          apisPublishedByGateway: 0,
	          apisPublishedByGatewayPendingDeployment: 0,
	          apisPublishedByGatewayDeployed: 0,
	          apisPublishedByGatewayError: 0
	        },
	        proxyApisLoading: false,
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.API_KEYS_COUNT_GET_REQUEST:
	      return Object.assign({}, state, {
	        apiKeysLoading: true,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.API_KEYS_COUNT_GET_SUCCESS:
	      return Object.assign({}, state, {
	        apiKeysCount: action.payload.count,
	        apiKeysLoading: false,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.API_KEYS_COUNT_GET_ERROR:
	      return Object.assign({}, state, {
	        apiKeysCount: {},
	        apiKeysLoading: false,
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.APIS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        apis: {
	          apis: (0, _get2.default)(action.payload, 'apis'),
	          apisPublishedByPortal: (0, _get2.default)(action.payload, 'apisPublishedByPortal'),
	          apisPublishedByGateway: (0, _get2.default)(action.payload, 'apisPublishedByGateway')
	        },
	        proxyApisLoading: false,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.APIS_GET_ERROR:
	      return Object.assign({}, state, {
	        apis: {
	          apis: {},
	          apisPublishedByPortal: {},
	          apisPublishedByGateway: {}
	        },
	        proxyApisLoading: false,
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.ACCOUNT_PLANS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        accountPlans: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.ACCOUNT_PLANS_GET_ERROR:
	      return Object.assign({}, state, {
	        accountPlans: {},
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.API_PLANS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        apiPlans: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.API_PLANS_GET_ERROR:
	      return Object.assign({}, state, {
	        apiPlans: {},
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.PROXY_ORGANIZATIONS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        organizations: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_ORGANIZATIONS_GET_ERROR:
	      return Object.assign({}, state, {
	        organizations: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.PROXY_APIS_LIST_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        hasError: false,
	        pageErrors: [],
	        apisList: action.payload
	      });
	    case constants.PROXY_APIS_LIST_GET_ERROR:
	      return Object.assign({}, state, {
	        hasError: true,
	        isLoading: false,
	        pageErrors: action.payload,
	        apisList: {
	          totalPages: 1,
	          totalElements: 0,
	          results: []
	        }
	      });
	    case constants.PROXY_APIS_KEYS_LIST_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        hasError: false,
	        pageErrors: [],
	        keysList: action.payload
	      });
	    case constants.PROXY_APIS_KEYS_LIST_GET_ERROR:
	      return Object.assign({}, state, {
	        hasError: true,
	        isLoading: false,
	        pageErrors: action.payload,
	        keysList: {
	          totalPages: 1,
	          totalElements: 0,
	          results: []
	        }
	      });
	    case constants.PROXY_APIS_KEYS_COUNT_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        hasError: false,
	        pageErrors: [],
	        apiKeys: action.payload
	      });
	    case constants.PROXY_APIS_KEYS_COUNT_GET_ERROR:
	      return Object.assign({}, state, {
	        hasError: true,
	        isLoading: false,
	        pageErrors: action.payload,
	        apiKeys: {}
	      });
	    default:
	      return state;
	  }
	};
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _responseParser = __webpack_require__(1707);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  hasError: false,
	  isLoading: false,
	  pageErrors: [],
	  proxyDetails: {},
	  gatewayDetails: {},
	  gateways: [],
	  proxyApis: {
	    apis: 0,
	    apisPendingDeployment: 0,
	    apisDeployed: 0,
	    apisError: 0,
	    apisPublishedByPortal: 0,
	    apisPublishedByPortalPendingDeployment: 0,
	    apisPublishedByPortalDeployed: 0,
	    apisPublishedByPortalError: 0,
	    apisPublishedByGateway: 0,
	    apisPublishedByGatewayPendingDeployment: 0,
	    apisPublishedByGatewayDeployed: 0,
	    apisPublishedByGatewayError: 0,
	    apisPendingUndeployment: 0,
	    apisPublishedByPortalPendingUndeployment: 0,
	    apisPublishedByGatewayPendingUndeployment: 0,
	    apisErrorUndeploy: 0,
	    apisPublishedByPortalErrorUndeploy: 0,
	    apisPublishedByGatewayErrorUndeploy: 0
	  },
	  apis: {
	    apis: {},
	    apisPublishedByGateway: {},
	    apisPublishedByPortal: {}
	  },
	  apps: [],
	  organizations: {},
	  apiPlans: {},
	  accountPlans: {},
	  apisList: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  },
	  keysList: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  },
	  apiKeys: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  }
	};
	
	var getUpdateProxyOrgsStatus = exports.getUpdateProxyOrgsStatus = function getUpdateProxyOrgsStatus(state) {
	  return (0, _get2.default)(state, 'apiProxy.updateProxyOrgsStatus');
	};
	var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
	  return (0, _get2.default)(state, 'proxy.isLoading');
	};
	
	var getProxy = exports.getProxy = function getProxy(state) {
	  return (0, _get2.default)(state, 'proxy.proxy');
	};
	var getProxyDetails = exports.getProxyDetails = function getProxyDetails(state) {
	  return (0, _get2.default)(state, 'proxy.proxyDetails');
	};
	var getProxyDetailsBulkDeploymentStatus = exports.getProxyDetailsBulkDeploymentStatus = function getProxyDetailsBulkDeploymentStatus(state) {
	  return (0, _get2.default)(state, 'proxy.proxyDetails.bulkDeploymentStatus');
	};
	var getProxyDetailsBulkApiKeyDeploymentStatus = exports.getProxyDetailsBulkApiKeyDeploymentStatus = function getProxyDetailsBulkApiKeyDeploymentStatus(state) {
	  return (0, _get2.default)(state, 'proxy.proxyDetails.apiKeyBulkDeploymentStatus');
	};
	
	var getProxyGatewayDetailsLoading = exports.getProxyGatewayDetailsLoading = function getProxyGatewayDetailsLoading(state) {
	  return (0, _get2.default)(state, 'proxy.gatewayDetailsLoading');
	};
	var getProxyGatewayDetails = exports.getProxyGatewayDetails = function getProxyGatewayDetails(state) {
	  return (0, _get2.default)(state, 'proxy.gatewayDetails');
	};
	var getParsedProxyGatewayDetails = exports.getParsedProxyGatewayDetails = function getParsedProxyGatewayDetails(state) {
	  var proxyGatewayDetails = getProxyGatewayDetails(state);
	  return (0, _responseParser.getParsedGatewayDetails)(proxyGatewayDetails);
	};
	var getProxyGateways = exports.getProxyGateways = function getProxyGateways(state) {
	  return (0, _get2.default)(state, 'proxy.gateways');
	};
	
	var getIsProxyDeleteSuccess = exports.getIsProxyDeleteSuccess = function getIsProxyDeleteSuccess(state) {
	  return (0, _get2.default)(state, 'proxy.isProxyDeleteSuccess');
	};
	var getDeleteProxyErrors = exports.getDeleteProxyErrors = function getDeleteProxyErrors(state) {
	  return (0, _get2.default)(state, 'proxy.deleteProxyErrors');
	};
	
	var getProxyApis = exports.getProxyApis = function getProxyApis(state) {
	  return (0, _get2.default)(state, 'proxy.proxyApis');
	};
	var getIsProxyApisLoading = exports.getIsProxyApisLoading = function getIsProxyApisLoading(state) {
	  return (0, _get2.default)(state, 'proxy.proxyApisLoading');
	};
	
	var getProxyOrganizations = exports.getProxyOrganizations = function getProxyOrganizations(state) {
	  return (0, _get2.default)(state, 'proxy.organizations');
	};
	
	var getApis = exports.getApis = function getApis(state) {
	  return (0, _get2.default)(state, 'proxy.apis');
	};
	
	var getApiKeysCount = exports.getApiKeysCount = function getApiKeysCount(state) {
	  return (0, _get2.default)(state, 'proxy.apiKeysCount');
	};
	var getIsApiKeysLoading = exports.getIsApiKeysLoading = function getIsApiKeysLoading(state) {
	  return (0, _get2.default)(state, 'proxy.apiKeysLoading');
	};
	
	var getAccountPlans = exports.getAccountPlans = function getAccountPlans(state) {
	  return (0, _get2.default)(state, 'proxy.accountPlans');
	};
	
	var getApiPlans = exports.getApiPlans = function getApiPlans(state) {
	  return (0, _get2.default)(state, 'proxy.apiPlans');
	};
	
	var getHasError = exports.getHasError = function getHasError(state) {
	  return (0, _get2.default)(state, 'proxy.hasError');
	};
	var getPageErrors = exports.getPageErrors = function getPageErrors(state) {
	  return (0, _get2.default)(state, 'proxy.pageErrors');
	};
	
	var getApisListTotalPages = exports.getApisListTotalPages = function getApisListTotalPages(state) {
	  return (0, _get2.default)(state, 'proxy.apisList.totalPages');
	};
	var getApisListTotalElements = exports.getApisListTotalElements = function getApisListTotalElements(state) {
	  return (0, _get2.default)(state, 'proxy.apisList.totalElements');
	};
	var getApisListResults = exports.getApisListResults = function getApisListResults(state) {
	  return (0, _get2.default)(state, 'proxy.apisList.results');
	};
	
	var getKeysListTotalPages = exports.getKeysListTotalPages = function getKeysListTotalPages(state) {
	  return (0, _get2.default)(state, 'proxy.keysList.totalPages');
	};
	var getKeysListTotalElements = exports.getKeysListTotalElements = function getKeysListTotalElements(state) {
	  return (0, _get2.default)(state, 'proxy.keysList.totalElements');
	};
	var getKeysListResults = exports.getKeysListResults = function getKeysListResults(state) {
	  return (0, _get2.default)(state, 'proxy.keysList.results');
	};
	
	var getApiKeys = exports.getApiKeys = function getApiKeys(state) {
	  return (0, _get2.default)(state, 'proxy.apiKeys');
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var _extends = _interopDefault(__webpack_require__(6));
	var shallowEqual = _interopDefault(__webpack_require__(1234));
	var _inheritsLoose = _interopDefault(__webpack_require__(156));
	var reactLifecyclesCompat = __webpack_require__(277);
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(90));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(1752));
	var changeEmitter = __webpack_require__(1201);
	var $$observable = _interopDefault(__webpack_require__(649));
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	
	    return BaseComponent;
	  };
	};
	
	var setDisplayName = function setDisplayName(displayName) {
	  return setStatic('displayName', displayName);
	};
	
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + "(" + getDisplayName(BaseComponent) + ")";
	};
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
	    }
	
	    return MapProps;
	  };
	};
	
	var withProps = function withProps(input) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var pick = function pick(obj, keys) {
	  var result = {};
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	
	  return result;
	};
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !shallowEqual(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          computedProps: propsMapper(_this.props),
	          prevProps: _this.props
	        };
	        return _this;
	      }
	
	      WithPropsOnChange.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	        if (shouldMap(prevState.prevProps, nextProps)) {
	          return {
	            computedProps: propsMapper(nextProps),
	            prevProps: nextProps
	          };
	        }
	
	        return {
	          prevProps: nextProps
	        };
	      };
	
	      var _proto = WithPropsOnChange.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(React.Component);
	
	    reactLifecyclesCompat.polyfill(WithPropsOnChange);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	
	    return WithPropsOnChange;
	  };
	};
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	
	
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithHandlers =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _this;
	
	        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	          _args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
	        _this.handlers = mapValues(typeof handlers === 'function' ? handlers(_this.props) : handlers, function (createHandler) {
	          return function () {
	            var handler = createHandler(_this.props);
	
	            if (false) {
	              console.error( // eslint-disable-line no-console
	              'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	            }
	
	            return handler.apply(void 0, arguments);
	          };
	        });
	        return _this;
	      }
	
	      var _proto = WithHandlers.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	
	    return WithHandlers;
	  };
	};
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	
	    DefaultProps.defaultProps = props;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	
	    return DefaultProps;
	  };
	};
	
	var omit = function omit(obj, keys) {
	  var rest = _extends({}, obj);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	
	  return rest;
	};
	
	var renameProp = function renameProp(oldName, newName) {
	  var hoc = mapProps(function (props) {
	    var _extends2;
	
	    return _extends({}, omit(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var keys = Object.keys;
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var FlattenProp = function FlattenProp(props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
	    }
	
	    return FlattenProp;
	  };
	};
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithState =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithState, _Component);
	
	      function WithState() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        };
	
	        _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        };
	
	        return _this;
	      }
	
	      var _proto = WithState.prototype;
	
	      _proto.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
	    }
	
	    return WithState;
	  };
	};
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithStateHandlers =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _this;
	
	        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	          _args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
	        _this.state = typeof initialState === 'function' ? initialState(_this.props) : initialState;
	        _this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
	          return function (mayBeEvent) {
	            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            // Having that functional form of setState can be called async
	            // we need to persist SyntheticEvent
	            if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	              mayBeEvent.persist();
	            }
	
	            _this.setState(function (state, props) {
	              return handler(state, props).apply(void 0, [mayBeEvent].concat(args));
	            });
	          };
	        });
	        return _this;
	      }
	
	      var _proto = WithStateHandlers.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	
	    return WithStateHandlers;
	  };
	};
	
	var noop = function noop() {};
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithReducer =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithReducer, _Component);
	
	      function WithReducer() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          stateValue: _this.initializeStateValue()
	        };
	
	        _this.dispatch = function (action, callback) {
	          if (callback === void 0) {
	            callback = noop;
	          }
	
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          }, function () {
	            return callback(_this.state.stateValue);
	          });
	        };
	
	        return _this;
	      }
	
	      var _proto = WithReducer.prototype;
	
	      _proto.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	
	        return reducer(undefined, {
	          type: '@@recompose/INIT'
	        });
	      };
	
	      _proto.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
	      };
	
	      return WithReducer;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
	    }
	
	    return WithReducer;
	  };
	};
	
	var identity = function identity(Component) {
	  return Component;
	};
	
	var branch = function branch(test, left, right) {
	  if (right === void 0) {
	    right = identity;
	  }
	
	  return function (BaseComponent) {
	    var leftFactory;
	    var rightFactory;
	
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || React.createFactory(left(BaseComponent));
	        return leftFactory(props);
	      }
	
	      rightFactory = rightFactory || React.createFactory(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
	    }
	
	    return Branch;
	  };
	};
	
	var renderComponent = function renderComponent(Component) {
	  return function (_) {
	    var factory = React.createFactory(Component);
	
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	
	    if (false) {
	      RenderComponent.displayName = wrapDisplayName(Component, 'renderComponent');
	    }
	
	    return RenderComponent;
	  };
	};
	
	var Nothing =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(Nothing, _Component);
	
	  function Nothing() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Nothing.prototype;
	
	  _proto.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(React.Component);
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var ShouldUpdate =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = ShouldUpdate.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _proto.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	
	    return ShouldUpdate;
	  };
	};
	
	var pure = function pure(BaseComponent) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(props, nextProps);
	  });
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(pick(nextProps, propKeys), pick(props, propKeys));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ("component with display name \"" + getDisplayName(BaseComponent) + "\"."));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
	  }
	
	  return OnlyUpdateForPropTypes;
	};
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithContext =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithContext, _Component);
	
	      function WithContext() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	
	        _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        };
	
	        return _this;
	      }
	
	      var _proto = WithContext.prototype;
	
	      _proto.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(React.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
	    }
	
	    return WithContext;
	  };
	};
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
	    }
	
	    return GetContext;
	  };
	};
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(Lifecycle, _Component);
	
	      function Lifecycle() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = Lifecycle.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(React.Component);
	
	    Object.keys(spec).forEach(function (hook) {
	      return Lifecycle.prototype[hook] = spec[hook];
	    });
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	
	    return Lifecycle;
	  };
	};
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
	};
	
	var toClass = function toClass(baseComponent) {
	  var _class, _temp;
	
	  return isClassComponent(baseComponent) ? baseComponent : (_temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(ToClass, _Component);
	
	    function ToClass() {
	      return _Component.apply(this, arguments) || this;
	    }
	
	    var _proto = ToClass.prototype;
	
	    _proto.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return React__default.createElement(baseComponent, this.props);
	      }
	
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(React.Component), _class.displayName = getDisplayName(baseComponent), _class.propTypes = baseComponent.propTypes, _class.contextTypes = baseComponent.contextTypes, _class.defaultProps = baseComponent.defaultProps, _temp);
	};
	
	function toRenderProps(hoc) {
	  var RenderPropsComponent = function RenderPropsComponent(props) {
	    return props.children(props);
	  };
	
	  return hoc(RenderPropsComponent);
	}
	
	var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
	  if (renderPropName === void 0) {
	    renderPropName = 'children';
	  }
	
	  return function (BaseComponent) {
	    var baseFactory = React__default.createFactory(BaseComponent);
	    var renderPropsFactory = React__default.createFactory(RenderPropsComponent);
	
	    var FromRenderProps = function FromRenderProps(ownerProps) {
	      var _renderPropsFactory;
	
	      return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
	        return baseFactory(_extends({}, ownerProps, propsMapper.apply(void 0, arguments)));
	      }, _renderPropsFactory));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'fromRenderProps'))(FromRenderProps);
	    }
	
	    return FromRenderProps;
	  };
	};
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return setStatic('propTypes', propTypes);
	};
	
	var compose = function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  }, function (arg) {
	    return arg;
	  });
	};
	
	var createSink = function createSink(callback) {
	  var Sink =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Sink, _Component);
	
	    function Sink() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.state = {};
	      return _this;
	    }
	
	    Sink.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
	      callback(nextProps);
	      return null;
	    };
	
	    var _proto = Sink.prototype;
	
	    _proto.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(React.Component);
	
	  reactLifecyclesCompat.polyfill(Sink);
	  return Sink;
	};
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component = function Component(props) {
	    return React.createElement(props[propName], omit(props, [propName]));
	  };
	
	  Component.displayName = "componentFromProp(" + propName + ")";
	  return Component;
	};
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = new Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(React.createFactory);
	
	  var Nest = function Nest(_ref) {
	    var children = _ref.children,
	        props = _objectWithoutPropertiesLoose(_ref, ["children"]);
	
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = "nest(" + displayNames.join(', ') + ")";
	  }
	
	  return Nest;
	};
	
	var hoistStatics = function hoistStatics(higherOrderComponent, blacklist) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    hoistNonReactStatics(NewComponent, BaseComponent, blacklist);
	    return NewComponent;
	  };
	};
	
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
	  return function (propsToVdom) {
	    return (
	      /*#__PURE__*/
	      function (_Component) {
	        _inheritsLoose(ComponentFromStream, _Component);
	
	        function ComponentFromStream() {
	          var _config$fromESObserva;
	
	          var _this;
	
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	          _this.state = {
	            vdom: null
	          };
	          _this.propsEmitter = changeEmitter.createChangeEmitter();
	          _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
	            subscribe: function subscribe(observer) {
	              var unsubscribe = _this.propsEmitter.listen(function (props) {
	                if (props) {
	                  observer.next(props);
	                } else {
	                  observer.complete();
	                }
	              });
	
	              return {
	                unsubscribe: unsubscribe
	              };
	            }
	          }, _config$fromESObserva[$$observable] = function () {
	            return this;
	          }, _config$fromESObserva));
	          _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$));
	          return _this;
	        }
	
	        var _proto = ComponentFromStream.prototype;
	
	        _proto.componentWillMount = function componentWillMount() {
	          var _this2 = this;
	
	          // Subscribe to child prop changes so we know when to re-render
	          this.subscription = this.vdom$.subscribe({
	            next: function next(vdom) {
	              _this2.setState({
	                vdom: vdom
	              });
	            }
	          });
	          this.propsEmitter.emit(this.props);
	        };
	
	        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	          // Receive new props from the owner
	          this.propsEmitter.emit(nextProps);
	        };
	
	        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	          return nextState.vdom !== this.state.vdom;
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          // Call without arguments to complete stream
	          this.propsEmitter.emit(); // Clean-up subscription before un-mounting
	
	          this.subscription.unsubscribe();
	        };
	
	        _proto.render = function render() {
	          return this.state.vdom;
	        };
	
	        return ComponentFromStream;
	      }(React.Component)
	    );
	  };
	};
	
	var componentFromStream = function componentFromStream(propsToVdom) {
	  return componentFromStreamWithConfig(config)(propsToVdom);
	};
	
	var identity$1 = function identity(t) {
	  return t;
	};
	
	var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
	  var componentFromStream$$1 = componentFromStreamWithConfig({
	    fromESObservable: identity$1,
	    toESObservable: identity$1
	  });
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = React.createFactory(BaseComponent);
	      var fromESObservable = config$$1.fromESObservable,
	          toESObservable = config$$1.toESObservable;
	      return componentFromStream$$1(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[$$observable] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = function mapPropsStream(transform) {
	  var hoc = mapPropsStreamWithConfig(config)(transform);
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = changeEmitter.createChangeEmitter();
	    var stream = config$$1.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _config$fromESObserva[$$observable] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	var createEventHandler = createEventHandlerWithConfig(config);
	
	// Higher-order component helpers
	
	exports.mapProps = mapProps;
	exports.withProps = withProps;
	exports.withPropsOnChange = withPropsOnChange;
	exports.withHandlers = withHandlers;
	exports.defaultProps = defaultProps;
	exports.renameProp = renameProp;
	exports.renameProps = renameProps;
	exports.flattenProp = flattenProp;
	exports.withState = withState;
	exports.withStateHandlers = withStateHandlers;
	exports.withReducer = withReducer;
	exports.branch = branch;
	exports.renderComponent = renderComponent;
	exports.renderNothing = renderNothing;
	exports.shouldUpdate = shouldUpdate;
	exports.pure = pure;
	exports.onlyUpdateForKeys = onlyUpdateForKeys;
	exports.onlyUpdateForPropTypes = onlyUpdateForPropTypes;
	exports.withContext = withContext;
	exports.getContext = getContext;
	exports.lifecycle = lifecycle;
	exports.toClass = toClass;
	exports.toRenderProps = toRenderProps;
	exports.fromRenderProps = fromRenderProps;
	exports.setStatic = setStatic;
	exports.setPropTypes = setPropTypes;
	exports.setDisplayName = setDisplayName;
	exports.compose = compose;
	exports.getDisplayName = getDisplayName;
	exports.wrapDisplayName = wrapDisplayName;
	exports.shallowEqual = shallowEqual;
	exports.isClassComponent = isClassComponent;
	exports.createSink = createSink;
	exports.componentFromProp = componentFromProp;
	exports.nest = nest;
	exports.hoistStatics = hoistStatics;
	exports.componentFromStream = componentFromStream;
	exports.componentFromStreamWithConfig = componentFromStreamWithConfig;
	exports.mapPropsStream = mapPropsStream;
	exports.mapPropsStreamWithConfig = mapPropsStreamWithConfig;
	exports.createEventHandler = createEventHandler;
	exports.createEventHandlerWithConfig = createEventHandlerWithConfig;
	exports.setObservableConfig = configureObservable;


/***/ },
/* 106 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments.length > 1 ? arguments[1] : undefined;
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	
	  return obj;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	
	var _Button = _interopRequireDefault(__webpack_require__(729));

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(749));

/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formControlState;
	
	function formControlState(_ref) {
	  var props = _ref.props,
	      states = _ref.states,
	      muiFormControl = _ref.muiFormControl;
	  return states.reduce(function (acc, state) {
	    acc[state] = props[state];
	
	    if (muiFormControl) {
	      if (typeof props[state] === 'undefined') {
	        acc[state] = muiFormControl[state];
	      }
	    }
	
	    return acc;
	  }, {});
	}

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(818));

/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
	    delay: style.transitionDelay
	  };
	}

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
	}), 'Check');
	
	exports.default = _default;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
	}), 'ExpandLess');
	
	exports.default = _default;

/***/ },
/* 115 */
[1913, 986],
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(1770);
	tslib_1.__exportStar(__webpack_require__(1198), exports);
	tslib_1.__exportStar(__webpack_require__(386), exports);
	tslib_1.__exportStar(__webpack_require__(1213), exports);
	tslib_1.__exportStar(__webpack_require__(175), exports);
	tslib_1.__exportStar(__webpack_require__(1236), exports);
	tslib_1.__exportStar(__webpack_require__(120), exports);
	tslib_1.__exportStar(__webpack_require__(1387), exports);
	tslib_1.__exportStar(__webpack_require__(588), exports);
	tslib_1.__exportStar(__webpack_require__(1390), exports);
	tslib_1.__exportStar(__webpack_require__(1760), exports);
	tslib_1.__exportStar(__webpack_require__(1763), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(1769);
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        e.clipboardData.clearData();
	        e.clipboardData.setData(options.format, text);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(1286),
	    isArray = __webpack_require__(36);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.noCase = void 0;
	var lower_case_1 = __webpack_require__(1382);
	// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
	var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
	// Remove all non-word characters.
	var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
	/**
	 * Normalize the string into something other libraries can manipulate easier.
	 */
	function noCase(input, options) {
	    if (options === void 0) { options = {}; }
	    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lower_case_1.lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
	    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
	    var start = 0;
	    var end = result.length;
	    // Trim the delimiter from around the output string.
	    while (result.charAt(start) === "\0")
	        start++;
	    while (result.charAt(end - 1) === "\0")
	        end--;
	    // Transform each token independently.
	    return result.slice(start, end).split("\0").map(transform).join(delimiter);
	}
	exports.noCase = noCase;
	/**
	 * Replace `re` in the input string with the replacement value.
	 */
	function replace(input, re, value) {
	    if (re instanceof RegExp)
	        return input.replace(re, value);
	    return re.reduce(function (input, re) { return input.replace(re, value); }, input);
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UNSAVED_DIALOG_EXIT_TEXT = exports.UNSAVED_DIALOG_SUBMIT_TEXT = exports.UNSAVED_DIALOG_CANCEL_TEXT = exports.UNSAVED_DIALOG_DESCRIPTIONS = exports.UNSAVED_DIALOG_TITLE = exports.APPLICATION_SECRET_COPY_CLASS = exports.APPLICATION_API_KEY_MESSAGE2 = exports.APPLICATION_API_KEY_MESSAGE1 = exports.APPLICATION_SECRET_COPY_MESSAGE2 = exports.APPLICATION_SECRET_COPY_MESSAGE1 = exports.APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB = exports.APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_CHECKBOX_LABEL = exports.APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_SUBTITLE = exports.APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_SUBMIT_TEXT = exports.APPLICATION_APP_KEY_GENERATE_SECRET_BUTTON_LABEL = exports.APPLICATION_APP_KEY_COPY_BUTTON_LABEL = exports.APPLICATION_AUTH_SELECT_HASHING_DIALOG_SUBMIT_TEXT = exports.APPLICATION_AUTH_SELECT_HASHING_DIALOG_CHECKBOX_LABEL = exports.APPLICATION_AUTH_SELECT_HASHING_DIALOG_SUBTITLE = exports.APPLICATION_AUTH_SELECT_HASHING_DIALOG_TITLE = exports.APPLICATION_API_TAG_PLACEHOLDER_TEXT = exports.APPLICATION_API_TAG_NO_OPTIONS_TEXT = exports.APPLICATION_API_TAG_SELECT_DIALOG_FILTER_TEXT = exports.APPLICATION_API_TAG_SELECT_DIALOG_TITLE = exports.APPLICATION_API_EULA_DIALOG_SUBMIT_TEXT = exports.APPLICATION_API_EULA_DIALOG_TITLE = exports.APPLICATION_API_SEARCH_AVAILABLE_API_GROUPS_PLACEHOLDER = exports.APPLICATION_API_AVAILABLE_API_GROUPS_TITLE = exports.APPLICATION_API_SEARCH_AVAILABLE_APIS_PLACEHOLDER = exports.APPLICATION_API_AVAILABLE_APIS_TITLE = exports.APPLICATION_API_SELECTED_APIS_AND_API_GROUPS_TITLE = exports.APPLICATION_API_SELECTED_APIS_TITLE = exports.APPLICATION_DETAILS_SAVE_ERROR = exports.APPLICATION_DETAILS_UPDATE_SUCCESS = exports.APPLICATION_DETAILS_CREATE_SUCCESS = exports.APPLICATION_AUTH_ASSIST_TEXT = exports.APPLICATION_API_MANAGEMENT_ASSIST_TEXT = exports.APPLICATION_CUSTOM_FIELDS_ASSIST_TEXT = exports.APPLICATION_ORGANIZATION_ASSIST_TEXT = exports.LABEL_BUTTON_NEXT = exports.DONE_TEXT = exports.CREATE_TEXT = exports.SAVE_AND_NEXT_TEXT = exports.NEXT_TEXT = exports.SAVE_TEXT = exports.CANCEL_TEXT = exports.SUCCESS_TEXT = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (dict) {
	  return function (label) {
	    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: dict[label] });
	  };
	};
	
	var SUCCESS_TEXT = exports.SUCCESS_TEXT = 'success';
	
	var CANCEL_TEXT = exports.CANCEL_TEXT = 'Cancel';
	var SAVE_TEXT = exports.SAVE_TEXT = 'Save';
	var NEXT_TEXT = exports.NEXT_TEXT = 'Next';
	
	var SAVE_AND_NEXT_TEXT = exports.SAVE_AND_NEXT_TEXT = 'Save & Next';
	var CREATE_TEXT = exports.CREATE_TEXT = 'Create';
	var DONE_TEXT = exports.DONE_TEXT = 'Done';
	
	var LABEL_BUTTON_NEXT = exports.LABEL_BUTTON_NEXT = 'label.button.next';
	
	var APPLICATION_ORGANIZATION_ASSIST_TEXT = exports.APPLICATION_ORGANIZATION_ASSIST_TEXT = 'Set an organization and proceed to next step.';
	var APPLICATION_CUSTOM_FIELDS_ASSIST_TEXT = exports.APPLICATION_CUSTOM_FIELDS_ASSIST_TEXT = 'Set Custom Fields and proceed to next step.';
	var APPLICATION_API_MANAGEMENT_ASSIST_TEXT = exports.APPLICATION_API_MANAGEMENT_ASSIST_TEXT = 'Add APIs and proceed to next step.';
	var APPLICATION_AUTH_ASSIST_TEXT = exports.APPLICATION_AUTH_ASSIST_TEXT = 'You will receive a key right away.';
	
	var APPLICATION_DETAILS_CREATE_SUCCESS = exports.APPLICATION_DETAILS_CREATE_SUCCESS = 'Application is created.';
	var APPLICATION_DETAILS_UPDATE_SUCCESS = exports.APPLICATION_DETAILS_UPDATE_SUCCESS = 'Application is updated.';
	var APPLICATION_DETAILS_SAVE_ERROR = exports.APPLICATION_DETAILS_SAVE_ERROR = 'Unable to carry out the operation. No updates have been made. See details below.';
	
	var APPLICATION_API_SELECTED_APIS_TITLE = exports.APPLICATION_API_SELECTED_APIS_TITLE = 'Selected APIs';
	var APPLICATION_API_SELECTED_APIS_AND_API_GROUPS_TITLE = exports.APPLICATION_API_SELECTED_APIS_AND_API_GROUPS_TITLE = 'Selected APIs and API Groups';
	var APPLICATION_API_AVAILABLE_APIS_TITLE = exports.APPLICATION_API_AVAILABLE_APIS_TITLE = 'Available APIs';
	var APPLICATION_API_SEARCH_AVAILABLE_APIS_PLACEHOLDER = exports.APPLICATION_API_SEARCH_AVAILABLE_APIS_PLACEHOLDER = 'Search an Available API';
	var APPLICATION_API_AVAILABLE_API_GROUPS_TITLE = exports.APPLICATION_API_AVAILABLE_API_GROUPS_TITLE = 'Available API Groups';
	var APPLICATION_API_SEARCH_AVAILABLE_API_GROUPS_PLACEHOLDER = exports.APPLICATION_API_SEARCH_AVAILABLE_API_GROUPS_PLACEHOLDER = 'Search an Available API Group';
	var APPLICATION_API_EULA_DIALOG_TITLE = exports.APPLICATION_API_EULA_DIALOG_TITLE = 'API Terms & Conditions';
	var APPLICATION_API_EULA_DIALOG_SUBMIT_TEXT = exports.APPLICATION_API_EULA_DIALOG_SUBMIT_TEXT = 'I Accept the Terms & Conditions';
	
	var APPLICATION_API_TAG_SELECT_DIALOG_TITLE = exports.APPLICATION_API_TAG_SELECT_DIALOG_TITLE = 'label.api.tags.title';
	var APPLICATION_API_TAG_SELECT_DIALOG_FILTER_TEXT = exports.APPLICATION_API_TAG_SELECT_DIALOG_FILTER_TEXT = 'label.application.api.tag.filter.text';
	var APPLICATION_API_TAG_NO_OPTIONS_TEXT = exports.APPLICATION_API_TAG_NO_OPTIONS_TEXT = 'label.application.api.tag.nooptions.text';
	var APPLICATION_API_TAG_PLACEHOLDER_TEXT = exports.APPLICATION_API_TAG_PLACEHOLDER_TEXT = 'label.application.api.tag.placeholder.text';
	
	var APPLICATION_AUTH_SELECT_HASHING_DIALOG_TITLE = exports.APPLICATION_AUTH_SELECT_HASHING_DIALOG_TITLE = 'Generate New Secret';
	var APPLICATION_AUTH_SELECT_HASHING_DIALOG_SUBTITLE = exports.APPLICATION_AUTH_SELECT_HASHING_DIALOG_SUBTITLE = 'Portal settings allow for plaintext secrets. This is not recommended for security purposes.';
	var APPLICATION_AUTH_SELECT_HASHING_DIALOG_CHECKBOX_LABEL = exports.APPLICATION_AUTH_SELECT_HASHING_DIALOG_CHECKBOX_LABEL = 'I want to use a non-secure plaintext key.';
	var APPLICATION_AUTH_SELECT_HASHING_DIALOG_SUBMIT_TEXT = exports.APPLICATION_AUTH_SELECT_HASHING_DIALOG_SUBMIT_TEXT = 'Create & Get Key';
	
	var APPLICATION_APP_KEY_COPY_BUTTON_LABEL = exports.APPLICATION_APP_KEY_COPY_BUTTON_LABEL = 'Copy';
	var APPLICATION_APP_KEY_GENERATE_SECRET_BUTTON_LABEL = exports.APPLICATION_APP_KEY_GENERATE_SECRET_BUTTON_LABEL = 'Request New Secret';
	var APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_SUBMIT_TEXT = exports.APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_SUBMIT_TEXT = 'Generate';
	var APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_SUBTITLE = exports.APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_SUBTITLE = 'The old secret will no longer be valid. The new secret must be shared with any developers coding for this ' + 'application. This action will break access for anyone using the old secret.';
	var APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_CHECKBOX_LABEL = exports.APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_CHECKBOX_LABEL = 'I want to change the key, breaking access for anyone using the old key.';
	var APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB = exports.APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB = '********';
	var APPLICATION_SECRET_COPY_MESSAGE1 = exports.APPLICATION_SECRET_COPY_MESSAGE1 = 'Secret Generated: <secret-';
	var APPLICATION_SECRET_COPY_MESSAGE2 = exports.APPLICATION_SECRET_COPY_MESSAGE2 = '> copied to clipboard.';
	var APPLICATION_API_KEY_MESSAGE1 = exports.APPLICATION_API_KEY_MESSAGE1 = 'API Key: <key-';
	var APPLICATION_API_KEY_MESSAGE2 = exports.APPLICATION_API_KEY_MESSAGE2 = '> copied to clipboard.';
	var APPLICATION_SECRET_COPY_CLASS = exports.APPLICATION_SECRET_COPY_CLASS = 'success';
	
	var UNSAVED_DIALOG_TITLE = exports.UNSAVED_DIALOG_TITLE = 'Unsaved Changes';
	var UNSAVED_DIALOG_DESCRIPTIONS = exports.UNSAVED_DIALOG_DESCRIPTIONS = 'Your changes will be lost if you leave this page. Are you sure you want to continue away from this page?';
	var UNSAVED_DIALOG_CANCEL_TEXT = exports.UNSAVED_DIALOG_CANCEL_TEXT = 'Stay';
	var UNSAVED_DIALOG_SUBMIT_TEXT = exports.UNSAVED_DIALOG_SUBMIT_TEXT = 'Continue';
	var UNSAVED_DIALOG_EXIT_TEXT = exports.UNSAVED_DIALOG_EXIT_TEXT = 'Exit';

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.List = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _core = __webpack_require__(3);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _components = __webpack_require__(17);
	
	var _list = __webpack_require__(1701);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var List = exports.List = function List(props) {
	  var classes = props.classes,
	      userContext = props.userContext,
	      listPageId = props.listPageId,
	      isLoading = props.isLoading,
	      notificationId = props.notificationId,
	      notificationStatus = props.notificationStatus,
	      setNotificationStatus = props.setNotificationStatus,
	      notificationMessage = props.notificationMessage,
	      setNotificationMessage = props.setNotificationMessage,
	      onCloseNotification = props.onCloseNotification,
	      pageHeaderTitle = props.pageHeaderTitle,
	      pageHeaderTooltipTitle = props.pageHeaderTooltipTitle,
	      addButtonLabel = props.addButtonLabel,
	      onAdd = props.onAdd,
	      disableAdd = props.disableAdd,
	      filterAndSortContent = props.filterAndSortContent,
	      columns = props.columns,
	      noResultsMessage = props.noResultsMessage,
	      page = props.page,
	      totalElements = props.totalElements,
	      totalPages = props.totalPages,
	      rowsPerPage = props.rowsPerPage,
	      onChangeRowsPerPage = props.onChangeRowsPerPage,
	      onChangePage = props.onChangePage,
	      onChangePreviousPage = props.onChangePreviousPage,
	      onChangeNextPage = props.onChangeNextPage,
	      _props$showListHeader = props.showListHeader,
	      showListHeader = _props$showListHeader === undefined ? true : _props$showListHeader,
	      _props$pageClass = props.pageClass,
	      pageClass = _props$pageClass === undefined ? null : _props$pageClass,
	      pageBodyClass = props.pageBodyClass,
	      pageFilterAndSortClass = props.pageFilterAndSortClass,
	      _props$uuidName = props.uuidName,
	      uuidName = _props$uuidName === undefined ? null : _props$uuidName,
	      notifyMessages = props.notifyMessages;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      expandedRows = _useState2[0],
	      setExpandedRows = _useState2[1];
	
	  var rows = props.rows.map(function (row) {
	    return Object.assign({}, row, {
	      expanded: expandedRows.includes(row.uuid),
	      onClick: function onClick(uuid) {
	        if (expandedRows.includes(uuid)) {
	          setExpandedRows(expandedRows.filter(function (e) {
	            return e !== uuid;
	          }));
	        } else {
	          setExpandedRows([].concat(_toConsumableArray(expandedRows), [uuid]));
	        }
	      }
	    });
	  });
	
	  var notificationMessages = function notificationMessages(status, message) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  return _react2.default.createElement(
	    _core.Grid,
	    {
	      className: (0, _clsx2.default)(pageClass, classes.page),
	      id: listPageId, 'data-apim-test': listPageId, 'data-layer7-test': listPageId
	    },
	    notificationMessage && _react2.default.createElement(_components.AlertMessages, {
	      className: classes.alertMessages,
	      id: notificationId,
	      variant: notificationStatus,
	      message: notificationMessage,
	      onClose: function onClose() {
	        notificationMessages('', '');
	        if (onCloseNotification) {
	          onCloseNotification();
	        }
	      }
	    }),
	    isLoading ? _react2.default.createElement(_components.Loading, { pageLoader: true }) : _react2.default.createElement(
	      'div',
	      { className: (0, _clsx2.default)(pageBodyClass, classes.pageBody) },
	      showListHeader && _react2.default.createElement(
	        _core.Grid,
	        { container: true, justify: 'space-between', className: classes.pageHeader },
	        _react2.default.createElement(
	          _core.Grid,
	          { item: true, md: 10, sm: 9, xs: 12 },
	          _react2.default.createElement(
	            _core.Grid,
	            { container: true },
	            _react2.default.createElement(
	              _core.Grid,
	              { item: true },
	              _react2.default.createElement(
	                _core.Typography,
	                {
	                  variant: 'h1',
	                  className: classes.pageTitle,
	                  id: listPageId + '-title', 'data-apim-test': listPageId + '-title', 'data-layer7-test': listPageId + '-title'
	                },
	                pageHeaderTitle
	              )
	            ),
	            pageHeaderTooltipTitle && _react2.default.createElement(
	              _core.Tooltip,
	              {
	                arrow: true, disableFocusListener: true, disableTouchListener: true, placement: 'top',
	                title: pageHeaderTooltipTitle
	              },
	              _react2.default.createElement(
	                _core.IconButton,
	                {
	                  size: 'small', edge: 'start', color: 'secondary',
	                  className: classes.helpIcon,
	                  id: listPageId + '-help', 'data-apim-test': listPageId + '-help', 'data-layer7-test': listPageId + '-help',
	                  'aria-label': 'gateway-bundle-help'
	                },
	                _react2.default.createElement(_Help2.default, null)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _core.Grid,
	          {
	            item: true, md: 2, sm: 3, xs: 12,
	            className: classes.addBundleButton
	          },
	          onAdd && _react2.default.createElement(
	            _core.Button,
	            {
	              variant: 'contained', color: 'secondary',
	              onClick: onAdd || function () {},
	              id: listPageId + '-add', 'data-apim-test': listPageId + '-add', 'data-layer7-test': listPageId + '-add',
	              disabled: disableAdd
	            },
	            addButtonLabel
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        {
	          container: true, justify: 'space-between',
	          className: (0, _clsx2.default)(pageFilterAndSortClass, classes.pageFilterAndSort)
	        },
	        filterAndSortContent
	      ),
	      _react2.default.createElement(_components.Table, {
	        userContext: userContext,
	        id: listPageId + '-list',
	        columns: columns,
	        rows: rows,
	        noResultsMessage: noResultsMessage,
	        uuidName: uuidName,
	        notifyMessages: notifyMessages
	      }),
	      _react2.default.createElement(_components.TablePagination, {
	        id: listPageId + '-pagination',
	        page: page,
	        count: totalElements,
	        pageCount: totalPages,
	        rowsPerPage: rowsPerPage,
	        rowsPerPageOptions: _constants.GRID_ROWS_PER_PAGE_OPTIONS,
	        onChangeRowsPerPage: onChangeRowsPerPage,
	        onChangePage: onChangePage,
	        onChangePreviousPage: onChangePreviousPage,
	        onChangeNextPage: onChangeNextPage
	      })
	    ),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	
	List.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  userContext: (0, _propTypes.shape)({}),
	  listPageId: _propTypes.string,
	  isLoading: _propTypes.bool,
	  notificationId: _propTypes.string,
	  notificationStatus: _propTypes.string,
	  setNotificationStatus: _propTypes.func,
	  notificationMessage: _propTypes.string,
	  setNotificationMessage: _propTypes.func,
	  onCloseNotification: _propTypes.func,
	  pageHeaderTitle: _propTypes.string,
	  pageHeaderTooltipTitle: _propTypes.string,
	  addButtonLabel: _propTypes.string,
	  onAdd: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.bool]),
	  disableAdd: _propTypes.bool,
	  filterAndSortContent: (0, _propTypes.shape)({}),
	  columns: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  rows: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  noResultsMessage: _propTypes.string,
	  page: _propTypes.number,
	  totalPages: _propTypes.number,
	  totalElements: _propTypes.number,
	  rowsPerPage: _propTypes.number,
	  onChangeRowsPerPage: _propTypes.func,
	  onChangePage: _propTypes.func,
	  onChangePreviousPage: _propTypes.func,
	  onChangeNextPage: _propTypes.func,
	  showListHeader: _propTypes.bool,
	  pageClass: _propTypes.string,
	  pageBodyClass: _propTypes.string,
	  pageFilterAndSortClass: _propTypes.string
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_list2.default))(List);

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGatewayBundleApisListErrors = exports.getGatewayBundlesApisListResults = exports.getGatewayBundlesApisListTotalElements = exports.getGatewayBundlesApisListTotalPages = exports.getProxyErrors = exports.getGatewayBundleProxyListErrors = exports.getGatewayBundleProxyListResults = exports.getGatewayBundlesProxyListTotalElements = exports.getGatewayBundlesProxyListTotalPages = exports.getGatewayBundlesListResults = exports.getGatewayBundlesListTotalElements = exports.getGatewayBundlesListTotalPages = exports.getGatewayBundleApiUsage = exports.getGatewayBundleDetails = exports.getDeleteBundleErrors = exports.getIsBundleDeleteSuccess = exports.getIsBundleSaveSuccess = exports.getErrors = exports.getIsError = exports.getIsLoading = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case Constants.APP_RESET:
	      return Object.assign({}, state, resetState, {
	        gatewayBundleDetails: {},
	        isBundleSaveSuccess: false,
	        isBundleDeleteSuccess: false
	      });
	    case Constants.GATEWAY_BUNDLES_DELETE_RESET:
	      return Object.assign({}, state, resetState, {
	        isBundleSaveSuccess: false,
	        isBundleDeleteSuccess: false
	      });
	    case Constants.APP_LOADING:
	      return Object.assign({}, state, resetState, {
	        isLoading: action.isLoading
	      });
	    case Constants.GATEWAY_BUNDLES_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        errors: [],
	        gatewayBundles: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_GET_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        errors: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_GET_USAGE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        errors: [],
	        gatewayBundleUsage: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_GET_USAGE_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        errors: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_DETAILS_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        errors: [],
	        gatewayBundleDetails: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_DETAILS_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        errors: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_ADD_REQUEST:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        errors: [],
	        isBundleSaveSuccess: false
	      });
	    case Constants.GATEWAY_BUNDLES_SAVE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        errors: [],
	        gatewayBundleDetails: action.payload,
	        isBundleSaveSuccess: true
	      });
	    case Constants.GATEWAY_BUNDLES_SAVE_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        errors: action.payload,
	        isBundleSaveSuccess: false
	      });
	    case Constants.GATEWAY_BUNDLES_DELETE_SUCCESS:
	      return Object.assign({}, state, resetState, {
	        deleteBundleErrors: [],
	        isBundleDeleteSuccess: true
	      });
	    case Constants.GATEWAY_BUNDLES_DELETE_ERROR:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: true,
	        deleteBundleErrors: action.payload,
	        isBundleDeleteSuccess: false
	      });
	    case Constants.GATEWAY_BUNDLES_GET_PROXY_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        listProxyErrors: [],
	        gatewayBundleProxyList: action.payload,
	        gatewayBundleDetails: Object.assign({}, state.gatewayBundleDetails, {
	          deletable: action.payload.deletable
	        })
	      });
	    case Constants.GATEWAY_BUNDLES_GET_PROXY_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        listProxyErrors: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_GET_PROXY_LIST_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        listProxyErrors: [],
	        gatewayBundleProxyList: action.payload,
	        gatewayBundleDetails: Object.assign({}, state.gatewayBundleDetails)
	      });
	    case Constants.GATEWAY_BUNDLES_GET_PROXY_LIST_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        listProxyErrors: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_DEPLOY_PROXY_SUCCESS:
	    case Constants.GATEWAY_BUNDLES_REDEPLOY_PROXY_SUCCESS:
	    case Constants.GATEWAY_BUNDLES_UNDEPLOY_PROXY_SUCCESS:
	      {
	        var obj = {
	          proxyUuid: (0, _lodash.get)(action.payload, 'proxyUuid'),
	          errorMessage: '',
	          validation: Constants.SUCCESS
	        };
	        return Object.assign({}, state, {
	          isLoading: false,
	          proxyErrors: updateProxyErrors((0, _lodash.get)(state, 'proxyErrors'), obj)
	        });
	      }
	
	    case Constants.GATEWAY_BUNDLES_DEPLOY_PROXY_ERROR:
	    case Constants.GATEWAY_BUNDLES_UNDEPLOY_PROXY_ERROR:
	    case Constants.GATEWAY_BUNDLES_REDEPLOY_PROXY_ERROR:
	      {
	        var _obj = {
	          proxyUuid: (0, _lodash.get)(action.payload, 'proxyUuid'),
	          errorMessage: (0, _lodash.get)(action.payload, 'errorMessage'),
	          validation: Constants.FAIL
	        };
	        return Object.assign({}, state, {
	          isLoading: false,
	          proxyErrors: updateProxyErrors((0, _lodash.get)(state, 'proxyErrors'), _obj)
	        });
	      }
	    case Constants.GATEWAY_BUNDLES_GET_APIS_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        listApiErrors: [],
	        gatewayBundlesApisList: action.payload
	      });
	    case Constants.GATEWAY_BUNDLES_GET_APIS_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        listApiErrors: action.payload,
	        gatewayBundlesApisList: []
	      });
	    default:
	      return state;
	  }
	};
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var resetState = {
	  isError: false,
	  errors: [],
	  listProxyErrors: [],
	  listApiErrors: [],
	  deleteBundleErrors: []
	};
	var initialState = Object.assign({}, resetState, {
	  gatewayBundleDetails: {},
	  gatewayBundleUsage: 0,
	  isLoading: false,
	  proxyErrors: [],
	  gatewayBundles: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  },
	  gatewayBundleProxyList: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  },
	  gatewayBundlesApisList: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  }
	});
	
	var updateProxyErrors = function updateProxyErrors() {
	  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var obj = arguments[1];
	
	  var tempArr = arr;
	  var index = arr.findIndex(function (e) {
	    return e.proxyUuid === obj.proxyUuid;
	  });
	  if (index === -1) {
	    tempArr.push(obj);
	  } else {
	    tempArr[index] = obj;
	  }
	  return tempArr;
	};
	
	var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.isLoading');
	};
	
	var getIsError = exports.getIsError = function getIsError(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.isError');
	};
	
	var getErrors = exports.getErrors = function getErrors(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.errors');
	};
	
	var getIsBundleSaveSuccess = exports.getIsBundleSaveSuccess = function getIsBundleSaveSuccess(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.isBundleSaveSuccess');
	};
	
	var getIsBundleDeleteSuccess = exports.getIsBundleDeleteSuccess = function getIsBundleDeleteSuccess(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.isBundleDeleteSuccess');
	};
	var getDeleteBundleErrors = exports.getDeleteBundleErrors = function getDeleteBundleErrors(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.deleteBundleErrors');
	};
	
	var getGatewayBundleDetails = exports.getGatewayBundleDetails = function getGatewayBundleDetails(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundleDetails');
	};
	
	var getGatewayBundleApiUsage = exports.getGatewayBundleApiUsage = function getGatewayBundleApiUsage(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundleUsage');
	};
	
	var getGatewayBundlesListTotalPages = exports.getGatewayBundlesListTotalPages = function getGatewayBundlesListTotalPages(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundles.totalPages');
	};
	var getGatewayBundlesListTotalElements = exports.getGatewayBundlesListTotalElements = function getGatewayBundlesListTotalElements(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundles.totalElements');
	};
	var getGatewayBundlesListResults = exports.getGatewayBundlesListResults = function getGatewayBundlesListResults(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundles.results');
	};
	
	var getGatewayBundlesProxyListTotalPages = exports.getGatewayBundlesProxyListTotalPages = function getGatewayBundlesProxyListTotalPages(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundleProxyList.totalPages');
	};
	var getGatewayBundlesProxyListTotalElements = exports.getGatewayBundlesProxyListTotalElements = function getGatewayBundlesProxyListTotalElements(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundleProxyList.totalElements');
	};
	var getGatewayBundleProxyListResults = exports.getGatewayBundleProxyListResults = function getGatewayBundleProxyListResults(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundleProxyList.results');
	};
	var getGatewayBundleProxyListErrors = exports.getGatewayBundleProxyListErrors = function getGatewayBundleProxyListErrors(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.listProxyErrors');
	};
	var getProxyErrors = exports.getProxyErrors = function getProxyErrors(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.proxyErrors');
	};
	
	var getGatewayBundlesApisListTotalPages = exports.getGatewayBundlesApisListTotalPages = function getGatewayBundlesApisListTotalPages(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundlesApisList.totalPages');
	};
	var getGatewayBundlesApisListTotalElements = exports.getGatewayBundlesApisListTotalElements = function getGatewayBundlesApisListTotalElements(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundlesApisList.totalElements');
	};
	var getGatewayBundlesApisListResults = exports.getGatewayBundlesApisListResults = function getGatewayBundlesApisListResults(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.gatewayBundlesApisList.results');
	};
	var getGatewayBundleApisListErrors = exports.getGatewayBundleApisListErrors = function getGatewayBundleApisListErrors(state) {
	  return (0, _lodash.get)(state, 'gatewayBundle.listApiErrors');
	};

/***/ },
/* 124 */
[1913, 1740],
/* 125 */
[1915, 1745, 1746, 1747, 645, 291, 646],
/* 126 */
[1913, 1749],
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _propTypes2 = _interopRequireDefault(__webpack_require__(128));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataProps = {
	  categories: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.shape({
	    x: _propTypes.default.arrayOf(_propTypes.default.string),
	    y: _propTypes.default.arrayOf(_propTypes.default.string)
	  })]),
	  data: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),
	  dataComponent: _propTypes.default.element,
	  labelComponent: _propTypes.default.element,
	  labels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array]),
	  samples: _propTypes2.default.nonNegative,
	  sortKey: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes2.default.allOfType([_propTypes2.default.integer, _propTypes2.default.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	  sortOrder: _propTypes.default.oneOf(["ascending", "descending"]),
	  style: _propTypes.default.shape({
	    parent: _propTypes.default.object,
	    data: _propTypes.default.object,
	    labels: _propTypes.default.object
	  }),
	  x: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes2.default.allOfType([_propTypes2.default.integer, _propTypes2.default.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	  y: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes2.default.allOfType([_propTypes2.default.integer, _propTypes2.default.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	  y0: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes2.default.allOfType([_propTypes2.default.integer, _propTypes2.default.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)])
	};
	var baseProps = {
	  animate: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	  containerComponent: _propTypes.default.element,
	  domain: _propTypes.default.oneOfType([_propTypes2.default.domain, _propTypes.default.shape({
	    x: _propTypes2.default.domain,
	    y: _propTypes2.default.domain
	  })]),
	  maxDomain: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.instanceOf(Date), _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.instanceOf(Date)]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.instanceOf(Date)])
	  })]),
	  minDomain: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.instanceOf(Date), _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.instanceOf(Date)]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.instanceOf(Date)])
	  })]),
	  domainPadding: _propTypes.default.oneOfType([_propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)])
	  }), _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	  eventKey: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes2.default.allOfType([_propTypes2.default.integer, _propTypes2.default.nonNegative]), _propTypes.default.string]),
	  events: _propTypes.default.arrayOf(_propTypes.default.shape({
	    target: _propTypes.default.oneOf(["data", "labels", "parent"]),
	    eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes2.default.allOfType([_propTypes2.default.integer, _propTypes2.default.nonNegative]), _propTypes.default.string]),
	    eventHandlers: _propTypes.default.object
	  })),
	  externalEventMutations: _propTypes.default.arrayOf(_propTypes.default.shape({
	    callback: _propTypes.default.function,
	    childName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	    eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes2.default.allOfType([_propTypes2.default.integer, _propTypes2.default.nonNegative]), _propTypes.default.string]),
	    mutation: _propTypes.default.function,
	    target: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array])
	  })),
	  groupComponent: _propTypes.default.element,
	  height: _propTypes2.default.nonNegative,
	  name: _propTypes.default.string,
	  origin: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number,
	    left: _propTypes.default.number,
	    right: _propTypes.default.number
	  })]),
	  polar: _propTypes.default.bool,
	  range: _propTypes.default.oneOfType([_propTypes2.default.domain, _propTypes.default.shape({
	    x: _propTypes2.default.domain,
	    y: _propTypes2.default.domain
	  })]),
	  scale: _propTypes.default.oneOfType([_propTypes2.default.scale, _propTypes.default.shape({
	    x: _propTypes2.default.scale,
	    y: _propTypes2.default.scale
	  })]),
	  sharedEvents: _propTypes.default.shape({
	    events: _propTypes.default.array,
	    getEventState: _propTypes.default.func
	  }),
	  singleQuadrantDomainPadding: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.bool]),
	    y: _propTypes.default.oneOfType([_propTypes.default.bool])
	  })]),
	  standalone: _propTypes.default.bool,
	  theme: _propTypes.default.object,
	  width: _propTypes2.default.nonNegative
	};
	var primitiveProps = {
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  clipPath: _propTypes.default.string,
	  data: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),
	  desc: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  events: _propTypes.default.object,
	  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  index: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  origin: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  polar: _propTypes.default.bool,
	  role: _propTypes.default.string,
	  scale: _propTypes.default.oneOfType([_propTypes2.default.scale, _propTypes.default.shape({
	    x: _propTypes2.default.scale,
	    y: _propTypes2.default.scale
	  })]),
	  shapeRendering: _propTypes.default.string,
	  style: _propTypes.default.object,
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  transform: _propTypes.default.string
	};
	var _default = {
	  baseProps: baseProps,
	  dataProps: dataProps,
	  primitiveProps: primitiveProps
	};
	exports.default = _default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isRegExp2 = _interopRequireDefault(__webpack_require__(443));
	
	var _find2 = _interopRequireDefault(__webpack_require__(1363));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _log = _interopRequireDefault(__webpack_require__(212));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Return a new validator based on `validator` but with the option to chain
	 * `isRequired` onto the validation. This is nearly identical to how React
	 * does it internally, but they don't expose their helper for us to use.
	 * @param {Function} validator Validation function.
	 * @returns {Function} Validator with `isRequired` option.
	 */
	var makeChainable = function (validator) {
	  /* eslint-disable max-params */
	  var _chainable = function (isRequired, props, propName, componentName) {
	    var value = props[propName];
	
	    if (value === undefined || value === null) {
	      if (isRequired) {
	        return new Error("Required `".concat(propName, "` was not specified in `").concat(componentName, "`."));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
	      rest[_key - 4] = arguments[_key];
	    }
	
	    return validator.apply(void 0, [props, propName, componentName].concat(rest));
	  };
	
	  var chainable = _chainable.bind(null, false);
	
	  chainable.isRequired = _chainable.bind(null, true);
	  return chainable;
	};
	
	var nullConstructor = function () {
	  return null;
	};
	
	var undefinedConstructor = function () {
	  return undefined;
	};
	/**
	 * Get the constructor of `value`. If `value` is null or undefined, return the
	 * special singletons `nullConstructor` or `undefinedConstructor`, respectively.
	 * @param {*} value Instance to return the constructor of.
	 * @returns {Function} Constructor of `value`.
	 */
	
	
	var getConstructor = function (value) {
	  if (value === undefined) {
	    return undefinedConstructor;
	  } else if (value === null) {
	    return nullConstructor;
	  } else {
	    return value.constructor;
	  }
	};
	/**
	 * Get the name of the constructor used to create `value`, using
	 * `Object.protoype.toString`. If the value is null or undefined, return
	 * "null" or "undefined", respectively.
	 * @param {*} value Instance to return the constructor name of.
	 * @returns {String} Name of the constructor.
	 */
	
	
	var getConstructorName = function (value) {
	  if (value === undefined) {
	    return "undefined";
	  } else if (value === null) {
	    return "null";
	  }
	
	  return Object.prototype.toString.call(value).slice(8, -1); // eslint-disable-line no-magic-numbers
	};
	
	var _default = {
	  /**
	   * Return a new validator based on `propType` but which logs a `console.error`
	   * with `explanation` if used.
	   * @param {Function} propType The old, deprecated propType.
	   * @param {String} explanation The message to provide the user of the deprecated propType.
	   * @returns {Function} Validator which logs usage of this propType
	   */
	  deprecated: function (propType, explanation) {
	    return function (props, propName, componentName) {
	      var value = props[propName];
	
	      if (value !== null && value !== undefined) {
	        _log.default.warn("\"".concat(propName, "\" property of \"").concat(componentName, "\" has been deprecated ").concat(explanation));
	      }
	
	      return _propTypes.default.checkPropTypes(_defineProperty({}, propName, propType), props, propName, componentName);
	    };
	  },
	
	  /**
	   * Return a new validator which returns true
	   * if and only if all validators passed as arguments return true.
	   * Like React.propTypes.oneOfType, except "all" instead of "any"
	   * @param {Array} validators Validation functions.
	   * @returns {Function} Combined validator function
	   */
	  allOfType: function (validators) {
	    return makeChainable(function (props, propName, componentName) {
	      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	        rest[_key2 - 3] = arguments[_key2];
	      }
	
	      return validators.reduce(function (result, validator) {
	        return result || validator.apply(void 0, [props, propName, componentName].concat(rest));
	      }, undefined);
	    });
	  },
	
	  /**
	   * Check that the value is a non-negative number.
	   */
	  nonNegative: makeChainable(function (props, propName, componentName) {
	    var value = props[propName];
	
	    if (typeof value !== "number" || value < 0) {
	      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a non-negative number."));
	    }
	
	    return undefined;
	  }),
	
	  /**
	   * Check that the value is an integer.
	   */
	  integer: makeChainable(function (props, propName, componentName) {
	    var value = props[propName];
	
	    if (typeof value !== "number" || value % 1 !== 0) {
	      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an integer."));
	    }
	
	    return undefined;
	  }),
	
	  /**
	   * Check that the value is greater than zero.
	   */
	  greaterThanZero: makeChainable(function (props, propName, componentName) {
	    var value = props[propName];
	
	    if (typeof value !== "number" || value <= 0) {
	      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a number greater than zero."));
	    }
	
	    return undefined;
	  }),
	
	  /**
	   * Check that the value is an Array of two unique values.
	   */
	  domain: makeChainable(function (props, propName, componentName) {
	    var value = props[propName];
	
	    if (!Array.isArray(value) || value.length !== 2 || value[1] === value[0]) {
	      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an array of two unique numeric values."));
	    }
	
	    return undefined;
	  }),
	
	  /**
	   * Check that the value looks like a d3 `scale` function.
	   */
	  scale: makeChainable(function (props, propName, componentName) {
	    var supportedScaleStrings = ["linear", "time", "log", "sqrt"];
	
	    var validScale = function (scl) {
	      if ((0, _isFunction2.default)(scl)) {
	        return (0, _isFunction2.default)(scl.copy) && (0, _isFunction2.default)(scl.domain) && (0, _isFunction2.default)(scl.range);
	      } else if (typeof scl === "string") {
	        return supportedScaleStrings.indexOf(scl) !== -1;
	      }
	
	      return false;
	    };
	
	    var value = props[propName];
	
	    if (!validScale(value)) {
	      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a d3 scale."));
	    }
	
	    return undefined;
	  }),
	
	  /**
	   * Check that an array contains items of the same type.
	   */
	  homogeneousArray: makeChainable(function (props, propName, componentName) {
	    var values = props[propName];
	
	    if (!Array.isArray(values)) {
	      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an array."));
	    }
	
	    if (values.length < 2) {
	      return undefined;
	    }
	
	    var comparisonConstructor = getConstructor(values[0]);
	    var typeMismatchedValue = (0, _find2.default)(values, function (value) {
	      return comparisonConstructor !== getConstructor(value);
	    });
	
	    if (typeMismatchedValue) {
	      var constructorName = getConstructorName(values[0]);
	      var otherConstructorName = getConstructorName(typeMismatchedValue);
	      return new Error("Expected `".concat(propName, "` in `").concat(componentName, "` to be a ") + "homogeneous array, but found types `".concat(constructorName, "` and ") + "`".concat(otherConstructorName, "`."));
	    }
	
	    return undefined;
	  }),
	
	  /**
	   * Check that array prop length matches props.data.length
	   */
	  matchDataLength: makeChainable(function (props, propName) {
	    if (props[propName] && Array.isArray(props[propName]) && props[propName].length !== props.data.length) {
	      return new Error("Length of data and ".concat(propName, " arrays must match."));
	    }
	
	    return undefined;
	  }),
	
	  /**
	   * Check that the value is a regular expression
	   */
	  regExp: makeChainable(function (props, propName, componentName) {
	    if (props[propName] && !(0, _isRegExp2.default)(props[propName])) {
	      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a regular expression."));
	    }
	
	    return undefined;
	  })
	};
	exports.default = _default;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	
	var _Card = _interopRequireDefault(__webpack_require__(735));

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	
	var _CardContent = _interopRequireDefault(__webpack_require__(740));

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	
	var _InputBase = _interopRequireDefault(__webpack_require__(803));

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * @ignore - internal component.
	 */
	var ListContext = React.createContext({});
	
	if (false) {
	  ListContext.displayName = 'ListContext';
	}
	
	var _default = ListContext;
	exports.default = _default;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(819));

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	
	var _Popover = _interopRequireDefault(__webpack_require__(830));

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	
	var _Popper = _interopRequireDefault(__webpack_require__(831));

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * @ignore - internal component.
	 */
	var Tablelvl2Context = React.createContext();
	
	if (false) {
	  Tablelvl2Context.displayName = 'Tablelvl2Context';
	}
	
	var _default = Tablelvl2Context;
	exports.default = _default;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(237));
	
	var defaultTheme = (0, _createMuiTheme.default)();
	var _default = defaultTheme;
	exports.default = _default;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainedFunction;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	    if (false) {
	      if (typeof func !== 'function') {
	        console.error('Material-UI: invalid Argument Type, must only provide functions, undefined, or null.');
	      }
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMuiElement;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function isMuiElement(element, muiNames) {
	  return React.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.teardown = teardown;
	exports.default = useIsFocusVisible;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
	var hadKeyboardEvent = true;
	var hadFocusVisibleRecently = false;
	var hadFocusVisibleRecentlyTimeout = null;
	var inputTypesWhitelist = {
	  text: true,
	  search: true,
	  url: true,
	  tel: true,
	  email: true,
	  password: true,
	  number: true,
	  date: true,
	  month: true,
	  week: true,
	  time: true,
	  datetime: true,
	  'datetime-local': true
	};
	/**
	 * Computes whether the given element should automatically trigger the
	 * `focus-visible` class being added, i.e. whether it should always match
	 * `:focus-visible` when focused.
	 * @param {Element} node
	 * @return {boolean}
	 */
	
	function focusTriggersKeyboardModality(node) {
	  var type = node.type,
	      tagName = node.tagName;
	
	  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
	    return true;
	  }
	
	  if (tagName === 'TEXTAREA' && !node.readOnly) {
	    return true;
	  }
	
	  if (node.isContentEditable) {
	    return true;
	  }
	
	  return false;
	}
	/**
	 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
	 * If the most recent user interaction was via the keyboard;
	 * and the key press did not include a meta, alt/option, or control key;
	 * then the modality is keyboard. Otherwise, the modality is not keyboard.
	 * @param {KeyboardEvent} event
	 */
	
	
	function handleKeyDown(event) {
	  if (event.metaKey || event.altKey || event.ctrlKey) {
	    return;
	  }
	
	  hadKeyboardEvent = true;
	}
	/**
	 * If at any point a user clicks with a pointing device, ensure that we change
	 * the modality away from keyboard.
	 * This avoids the situation where a user presses a key on an already focused
	 * element, and then clicks on a different element, focusing it with a
	 * pointing device, while we still think we're in keyboard modality.
	 */
	
	
	function handlePointerDown() {
	  hadKeyboardEvent = false;
	}
	
	function handleVisibilityChange() {
	  if (this.visibilityState === 'hidden') {
	    // If the tab becomes active again, the browser will handle calling focus
	    // on the element (Safari actually calls it twice).
	    // If this tab change caused a blur on an element with focus-visible,
	    // re-apply the class when the user switches back to the tab.
	    if (hadFocusVisibleRecently) {
	      hadKeyboardEvent = true;
	    }
	  }
	}
	
	function prepare(doc) {
	  doc.addEventListener('keydown', handleKeyDown, true);
	  doc.addEventListener('mousedown', handlePointerDown, true);
	  doc.addEventListener('pointerdown', handlePointerDown, true);
	  doc.addEventListener('touchstart', handlePointerDown, true);
	  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function teardown(doc) {
	  doc.removeEventListener('keydown', handleKeyDown, true);
	  doc.removeEventListener('mousedown', handlePointerDown, true);
	  doc.removeEventListener('pointerdown', handlePointerDown, true);
	  doc.removeEventListener('touchstart', handlePointerDown, true);
	  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function isFocusVisible(event) {
	  var target = event.target;
	
	  try {
	    return target.matches(':focus-visible');
	  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
	  // we use our own heuristic for those browsers
	  // rethrow might be better if it's not the expected error but do we really
	  // want to crash if focus-visible malfunctioned?
	  // no need for validFocusTarget check. the user does that by attaching it to
	  // focusable events only
	
	
	  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
	}
	/**
	 * Should be called if a blur event is fired on a focus-visible element
	 */
	
	
	function handleBlurVisible() {
	  // To detect a tab/window switch, we look for a blur event followed
	  // rapidly by a visibility change.
	  // If we don't see a visibility change within 100ms, it's probably a
	  // regular focus change.
	  hadFocusVisibleRecently = true;
	  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
	  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
	    hadFocusVisibleRecently = false;
	  }, 100);
	}
	
	function useIsFocusVisible() {
	  var ref = React.useCallback(function (instance) {
	    var node = ReactDOM.findDOMNode(instance);
	
	    if (node != null) {
	      prepare(node.ownerDocument);
	    }
	  }, []);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue(isFocusVisible);
	  }
	
	  return {
	    isFocusVisible: isFocusVisible,
	    onBlurVisible: handleBlurVisible,
	    ref: ref
	  };
	}

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), 'Close');
	
	exports.default = _default;

/***/ },
/* 142 */
[1913, 978],
/* 143 */
[1915, 982, 983, 984, 367, 242, 368],
/* 144 */
[1913, 1004],
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(1008));

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.RemoveUserIcon = exports.RemoveGroupIcon = exports.RefreshIcon = exports.ProcessingIcon = exports.PrinterIcon = exports.PowerUnplugedIcon = exports.PowerDefaultIcon = exports.PlusIcon = exports.PlayIcon = exports.PieChartIcon = exports.PhoneIcon = exports.PendingIcon = exports.PauseIcon = exports.PageUpIcon = exports.PageIcon = exports.PageDownIcon = exports.OverflowMenuVerticalIcon = exports.OverflowMenuHoriIcon = exports.NoAccessIcon = exports.NetworkMapIcon = exports.MobilePhoneIcon = exports.MinusIcon = exports.MicMuteIcon = exports.MicDefaultIcon = exports.MenuOpenIcon = exports.MenuClosedIcon = exports.MaintenanceIcon = exports.LockUnlockedIcon = exports.LockDefaultIcon = exports.ListIcon = exports.LinkUnlinkIcon = exports.LinkDefaultIcon = exports.LineGraphIcon = exports.LaptopIcon = exports.LaptopAndMobilePhoneIcon = exports.LanNetworkIcon = exports.IoDataTransferIcon = exports.IntentWarningSimpleIcon = exports.IntentWarningIcon = exports.IntentSuccessSimpleIcon = exports.IntentSuccessIcon = exports.IntentDangerSimpleIcon = exports.IntentDangerIcon = exports.InfoDefaultIcon = exports.ImageIcon = exports.HubIcon = exports.HomeIcon = exports.HelpDefaultIcon = exports.GridIcon = exports.GrabIcon = exports.GlobeIcon = exports.FullscreenMinimizeIcon = exports.FullscreenMaximizeIcon = exports.ForwardIcon = exports.FolderOpenedIcon = exports.FolderDefaultIcon = exports.FlagIcon = exports.FilterMinimalIcon = exports.FilterIcon = exports.FeedbackIcon = exports.ExtendIcon = exports.EmailIcon = exports.EditIcon = exports.DuplicateIcon = exports.DragAndDropVerticalIcon = exports.DragAndDropHoriIcon = exports.DownloadFileIcon = exports.DesktopIcon = exports.DataUnknownIcon = exports.DataSecureIcon = exports.DataFirewallIcon = exports.DataDatabaseIcon = exports.DashboardIcon = exports.CornerDragHandleIcon = exports.ContractIcon = exports.CloudUploadIcon = exports.CloudDownloadIcon = exports.CloudDefaultIcon = exports.CloseDefaultIcon = exports.CloseCircleIcon = exports.ClockIcon = exports.CheckmarkIcon = exports.ChatIcon = exports.CellTowerIcon = exports.CalendarIcon = exports.BarGraphIcon = exports.BackIcon = exports.ArrowPrevIcon = exports.ArrowPrevFilledIcon = exports.ArrowOpenIcon = exports.ArrowNextIcon = exports.ArrowNextFilledIcon = exports.ArrowLastIcon = exports.ArrowFirstIcon = exports.ArrowCloseIcon = exports.AreachartIcon = exports.ApplicationMenuIcon = exports.AlarmIcon = exports.AddUserIcon = exports.AddGroupIcon = void 0;
	exports.ZoomOutIcon = exports.ZoomInIcon = exports.WifiRouterIcon = exports.VideoIcon = exports.UserIcon = exports.UserGroupIcon = exports.UploadDownloadIcon = exports.UploadDefaultIcon = exports.UnknownUserIcon = exports.UnknownGroupIcon = exports.TrashIcon = exports.SyncIcon = exports.SwitchIcon = exports.StopIcon = exports.StarIcon = exports.SortZAIcon = exports.SortUpIcon = exports.SortUpAndDownIcon = exports.SortMoveToTopIcon = exports.SortMoveToBottomIcon = exports.SortDownIcon = exports.SortDescendingIcon = exports.SortDefaultIcon = exports.SortDefaultDescendingIcon = exports.SortAscendingIcon = exports.SortAZIcon = exports.Sort91Icon = exports.Sort19Icon = exports.SingleServerIcon = exports.SideMenuIcon = exports.ShowHideIcon = exports.ShowDefaultIcon = exports.SettingIcon = exports.ServerIcon = exports.SearchIcon = exports.SaveToDeviceIcon = exports.RouterIcon = exports.RestartIcon = exports.ReportsIcon = void 0;
	
	var _AddGroupIcon = _interopRequireDefault(__webpack_require__(1038));
	
	exports.AddGroupIcon = _AddGroupIcon["default"];
	
	var _AddUserIcon = _interopRequireDefault(__webpack_require__(1039));
	
	exports.AddUserIcon = _AddUserIcon["default"];
	
	var _AlarmIcon = _interopRequireDefault(__webpack_require__(1040));
	
	exports.AlarmIcon = _AlarmIcon["default"];
	
	var _ApplicationMenuIcon = _interopRequireDefault(__webpack_require__(1041));
	
	exports.ApplicationMenuIcon = _ApplicationMenuIcon["default"];
	
	var _AreachartIcon = _interopRequireDefault(__webpack_require__(1042));
	
	exports.AreachartIcon = _AreachartIcon["default"];
	
	var _ArrowCloseIcon = _interopRequireDefault(__webpack_require__(1043));
	
	exports.ArrowCloseIcon = _ArrowCloseIcon["default"];
	
	var _ArrowFirstIcon = _interopRequireDefault(__webpack_require__(1044));
	
	exports.ArrowFirstIcon = _ArrowFirstIcon["default"];
	
	var _ArrowLastIcon = _interopRequireDefault(__webpack_require__(1045));
	
	exports.ArrowLastIcon = _ArrowLastIcon["default"];
	
	var _ArrowNextFilledIcon = _interopRequireDefault(__webpack_require__(1046));
	
	exports.ArrowNextFilledIcon = _ArrowNextFilledIcon["default"];
	
	var _ArrowNextIcon = _interopRequireDefault(__webpack_require__(1047));
	
	exports.ArrowNextIcon = _ArrowNextIcon["default"];
	
	var _ArrowOpenIcon = _interopRequireDefault(__webpack_require__(1048));
	
	exports.ArrowOpenIcon = _ArrowOpenIcon["default"];
	
	var _ArrowPrevFilledIcon = _interopRequireDefault(__webpack_require__(1049));
	
	exports.ArrowPrevFilledIcon = _ArrowPrevFilledIcon["default"];
	
	var _ArrowPrevIcon = _interopRequireDefault(__webpack_require__(1050));
	
	exports.ArrowPrevIcon = _ArrowPrevIcon["default"];
	
	var _BackIcon = _interopRequireDefault(__webpack_require__(1051));
	
	exports.BackIcon = _BackIcon["default"];
	
	var _BarGraphIcon = _interopRequireDefault(__webpack_require__(1052));
	
	exports.BarGraphIcon = _BarGraphIcon["default"];
	
	var _CalendarIcon = _interopRequireDefault(__webpack_require__(1053));
	
	exports.CalendarIcon = _CalendarIcon["default"];
	
	var _CellTowerIcon = _interopRequireDefault(__webpack_require__(1054));
	
	exports.CellTowerIcon = _CellTowerIcon["default"];
	
	var _ChatIcon = _interopRequireDefault(__webpack_require__(1055));
	
	exports.ChatIcon = _ChatIcon["default"];
	
	var _CheckmarkIcon = _interopRequireDefault(__webpack_require__(1056));
	
	exports.CheckmarkIcon = _CheckmarkIcon["default"];
	
	var _ClockIcon = _interopRequireDefault(__webpack_require__(1057));
	
	exports.ClockIcon = _ClockIcon["default"];
	
	var _CloseCircleIcon = _interopRequireDefault(__webpack_require__(1058));
	
	exports.CloseCircleIcon = _CloseCircleIcon["default"];
	
	var _CloseDefaultIcon = _interopRequireDefault(__webpack_require__(1059));
	
	exports.CloseDefaultIcon = _CloseDefaultIcon["default"];
	
	var _CloudDefaultIcon = _interopRequireDefault(__webpack_require__(1060));
	
	exports.CloudDefaultIcon = _CloudDefaultIcon["default"];
	
	var _CloudDownloadIcon = _interopRequireDefault(__webpack_require__(1061));
	
	exports.CloudDownloadIcon = _CloudDownloadIcon["default"];
	
	var _CloudUploadIcon = _interopRequireDefault(__webpack_require__(1062));
	
	exports.CloudUploadIcon = _CloudUploadIcon["default"];
	
	var _ContractIcon = _interopRequireDefault(__webpack_require__(1063));
	
	exports.ContractIcon = _ContractIcon["default"];
	
	var _CornerDragHandleIcon = _interopRequireDefault(__webpack_require__(1064));
	
	exports.CornerDragHandleIcon = _CornerDragHandleIcon["default"];
	
	var _DashboardIcon = _interopRequireDefault(__webpack_require__(1065));
	
	exports.DashboardIcon = _DashboardIcon["default"];
	
	var _DataDatabaseIcon = _interopRequireDefault(__webpack_require__(1066));
	
	exports.DataDatabaseIcon = _DataDatabaseIcon["default"];
	
	var _DataFirewallIcon = _interopRequireDefault(__webpack_require__(1067));
	
	exports.DataFirewallIcon = _DataFirewallIcon["default"];
	
	var _DataSecureIcon = _interopRequireDefault(__webpack_require__(1068));
	
	exports.DataSecureIcon = _DataSecureIcon["default"];
	
	var _DataUnknownIcon = _interopRequireDefault(__webpack_require__(1069));
	
	exports.DataUnknownIcon = _DataUnknownIcon["default"];
	
	var _DesktopIcon = _interopRequireDefault(__webpack_require__(1070));
	
	exports.DesktopIcon = _DesktopIcon["default"];
	
	var _DownloadFileIcon = _interopRequireDefault(__webpack_require__(1071));
	
	exports.DownloadFileIcon = _DownloadFileIcon["default"];
	
	var _DragAndDropHoriIcon = _interopRequireDefault(__webpack_require__(1072));
	
	exports.DragAndDropHoriIcon = _DragAndDropHoriIcon["default"];
	
	var _DragAndDropVerticalIcon = _interopRequireDefault(__webpack_require__(1073));
	
	exports.DragAndDropVerticalIcon = _DragAndDropVerticalIcon["default"];
	
	var _DuplicateIcon = _interopRequireDefault(__webpack_require__(1074));
	
	exports.DuplicateIcon = _DuplicateIcon["default"];
	
	var _EditIcon = _interopRequireDefault(__webpack_require__(1075));
	
	exports.EditIcon = _EditIcon["default"];
	
	var _EmailIcon = _interopRequireDefault(__webpack_require__(1076));
	
	exports.EmailIcon = _EmailIcon["default"];
	
	var _ExtendIcon = _interopRequireDefault(__webpack_require__(1077));
	
	exports.ExtendIcon = _ExtendIcon["default"];
	
	var _FeedbackIcon = _interopRequireDefault(__webpack_require__(1078));
	
	exports.FeedbackIcon = _FeedbackIcon["default"];
	
	var _FilterIcon = _interopRequireDefault(__webpack_require__(1079));
	
	exports.FilterIcon = _FilterIcon["default"];
	
	var _FilterMinimalIcon = _interopRequireDefault(__webpack_require__(1080));
	
	exports.FilterMinimalIcon = _FilterMinimalIcon["default"];
	
	var _FlagIcon = _interopRequireDefault(__webpack_require__(1081));
	
	exports.FlagIcon = _FlagIcon["default"];
	
	var _FolderDefaultIcon = _interopRequireDefault(__webpack_require__(1082));
	
	exports.FolderDefaultIcon = _FolderDefaultIcon["default"];
	
	var _FolderOpenedIcon = _interopRequireDefault(__webpack_require__(1083));
	
	exports.FolderOpenedIcon = _FolderOpenedIcon["default"];
	
	var _ForwardIcon = _interopRequireDefault(__webpack_require__(1084));
	
	exports.ForwardIcon = _ForwardIcon["default"];
	
	var _FullscreenMaximizeIcon = _interopRequireDefault(__webpack_require__(1085));
	
	exports.FullscreenMaximizeIcon = _FullscreenMaximizeIcon["default"];
	
	var _FullscreenMinimizeIcon = _interopRequireDefault(__webpack_require__(1086));
	
	exports.FullscreenMinimizeIcon = _FullscreenMinimizeIcon["default"];
	
	var _GlobeIcon = _interopRequireDefault(__webpack_require__(1087));
	
	exports.GlobeIcon = _GlobeIcon["default"];
	
	var _GrabIcon = _interopRequireDefault(__webpack_require__(1088));
	
	exports.GrabIcon = _GrabIcon["default"];
	
	var _GridIcon = _interopRequireDefault(__webpack_require__(1089));
	
	exports.GridIcon = _GridIcon["default"];
	
	var _HelpDefaultIcon = _interopRequireDefault(__webpack_require__(1090));
	
	exports.HelpDefaultIcon = _HelpDefaultIcon["default"];
	
	var _HomeIcon = _interopRequireDefault(__webpack_require__(1091));
	
	exports.HomeIcon = _HomeIcon["default"];
	
	var _HubIcon = _interopRequireDefault(__webpack_require__(1092));
	
	exports.HubIcon = _HubIcon["default"];
	
	var _ImageIcon = _interopRequireDefault(__webpack_require__(1093));
	
	exports.ImageIcon = _ImageIcon["default"];
	
	var _InfoDefaultIcon = _interopRequireDefault(__webpack_require__(1094));
	
	exports.InfoDefaultIcon = _InfoDefaultIcon["default"];
	
	var _IntentDangerIcon = _interopRequireDefault(__webpack_require__(1095));
	
	exports.IntentDangerIcon = _IntentDangerIcon["default"];
	
	var _IntentDangerSimpleIcon = _interopRequireDefault(__webpack_require__(1096));
	
	exports.IntentDangerSimpleIcon = _IntentDangerSimpleIcon["default"];
	
	var _IntentSuccessIcon = _interopRequireDefault(__webpack_require__(1097));
	
	exports.IntentSuccessIcon = _IntentSuccessIcon["default"];
	
	var _IntentSuccessSimpleIcon = _interopRequireDefault(__webpack_require__(1098));
	
	exports.IntentSuccessSimpleIcon = _IntentSuccessSimpleIcon["default"];
	
	var _IntentWarningIcon = _interopRequireDefault(__webpack_require__(1099));
	
	exports.IntentWarningIcon = _IntentWarningIcon["default"];
	
	var _IntentWarningSimpleIcon = _interopRequireDefault(__webpack_require__(1100));
	
	exports.IntentWarningSimpleIcon = _IntentWarningSimpleIcon["default"];
	
	var _IoDataTransferIcon = _interopRequireDefault(__webpack_require__(1101));
	
	exports.IoDataTransferIcon = _IoDataTransferIcon["default"];
	
	var _LanNetworkIcon = _interopRequireDefault(__webpack_require__(1102));
	
	exports.LanNetworkIcon = _LanNetworkIcon["default"];
	
	var _LaptopAndMobilePhoneIcon = _interopRequireDefault(__webpack_require__(1103));
	
	exports.LaptopAndMobilePhoneIcon = _LaptopAndMobilePhoneIcon["default"];
	
	var _LaptopIcon = _interopRequireDefault(__webpack_require__(1104));
	
	exports.LaptopIcon = _LaptopIcon["default"];
	
	var _LineGraphIcon = _interopRequireDefault(__webpack_require__(1105));
	
	exports.LineGraphIcon = _LineGraphIcon["default"];
	
	var _LinkDefaultIcon = _interopRequireDefault(__webpack_require__(1106));
	
	exports.LinkDefaultIcon = _LinkDefaultIcon["default"];
	
	var _LinkUnlinkIcon = _interopRequireDefault(__webpack_require__(1107));
	
	exports.LinkUnlinkIcon = _LinkUnlinkIcon["default"];
	
	var _ListIcon = _interopRequireDefault(__webpack_require__(1108));
	
	exports.ListIcon = _ListIcon["default"];
	
	var _LockDefaultIcon = _interopRequireDefault(__webpack_require__(1109));
	
	exports.LockDefaultIcon = _LockDefaultIcon["default"];
	
	var _LockUnlockedIcon = _interopRequireDefault(__webpack_require__(1110));
	
	exports.LockUnlockedIcon = _LockUnlockedIcon["default"];
	
	var _MaintenanceIcon = _interopRequireDefault(__webpack_require__(1111));
	
	exports.MaintenanceIcon = _MaintenanceIcon["default"];
	
	var _MenuClosedIcon = _interopRequireDefault(__webpack_require__(1112));
	
	exports.MenuClosedIcon = _MenuClosedIcon["default"];
	
	var _MenuOpenIcon = _interopRequireDefault(__webpack_require__(1113));
	
	exports.MenuOpenIcon = _MenuOpenIcon["default"];
	
	var _MicDefaultIcon = _interopRequireDefault(__webpack_require__(1114));
	
	exports.MicDefaultIcon = _MicDefaultIcon["default"];
	
	var _MicMuteIcon = _interopRequireDefault(__webpack_require__(1115));
	
	exports.MicMuteIcon = _MicMuteIcon["default"];
	
	var _MinusIcon = _interopRequireDefault(__webpack_require__(1116));
	
	exports.MinusIcon = _MinusIcon["default"];
	
	var _MobilePhoneIcon = _interopRequireDefault(__webpack_require__(1117));
	
	exports.MobilePhoneIcon = _MobilePhoneIcon["default"];
	
	var _NetworkMapIcon = _interopRequireDefault(__webpack_require__(1118));
	
	exports.NetworkMapIcon = _NetworkMapIcon["default"];
	
	var _NoAccessIcon = _interopRequireDefault(__webpack_require__(1119));
	
	exports.NoAccessIcon = _NoAccessIcon["default"];
	
	var _OverflowMenuHoriIcon = _interopRequireDefault(__webpack_require__(1120));
	
	exports.OverflowMenuHoriIcon = _OverflowMenuHoriIcon["default"];
	
	var _OverflowMenuVerticalIcon = _interopRequireDefault(__webpack_require__(1121));
	
	exports.OverflowMenuVerticalIcon = _OverflowMenuVerticalIcon["default"];
	
	var _PageDownIcon = _interopRequireDefault(__webpack_require__(1122));
	
	exports.PageDownIcon = _PageDownIcon["default"];
	
	var _PageIcon = _interopRequireDefault(__webpack_require__(1123));
	
	exports.PageIcon = _PageIcon["default"];
	
	var _PageUpIcon = _interopRequireDefault(__webpack_require__(1124));
	
	exports.PageUpIcon = _PageUpIcon["default"];
	
	var _PauseIcon = _interopRequireDefault(__webpack_require__(1125));
	
	exports.PauseIcon = _PauseIcon["default"];
	
	var _PendingIcon = _interopRequireDefault(__webpack_require__(1126));
	
	exports.PendingIcon = _PendingIcon["default"];
	
	var _PhoneIcon = _interopRequireDefault(__webpack_require__(1127));
	
	exports.PhoneIcon = _PhoneIcon["default"];
	
	var _PieChartIcon = _interopRequireDefault(__webpack_require__(1128));
	
	exports.PieChartIcon = _PieChartIcon["default"];
	
	var _PlayIcon = _interopRequireDefault(__webpack_require__(1129));
	
	exports.PlayIcon = _PlayIcon["default"];
	
	var _PlusIcon = _interopRequireDefault(__webpack_require__(1130));
	
	exports.PlusIcon = _PlusIcon["default"];
	
	var _PowerDefaultIcon = _interopRequireDefault(__webpack_require__(1131));
	
	exports.PowerDefaultIcon = _PowerDefaultIcon["default"];
	
	var _PowerUnplugedIcon = _interopRequireDefault(__webpack_require__(1132));
	
	exports.PowerUnplugedIcon = _PowerUnplugedIcon["default"];
	
	var _PrinterIcon = _interopRequireDefault(__webpack_require__(1133));
	
	exports.PrinterIcon = _PrinterIcon["default"];
	
	var _ProcessingIcon = _interopRequireDefault(__webpack_require__(1134));
	
	exports.ProcessingIcon = _ProcessingIcon["default"];
	
	var _RefreshIcon = _interopRequireDefault(__webpack_require__(1135));
	
	exports.RefreshIcon = _RefreshIcon["default"];
	
	var _RemoveGroupIcon = _interopRequireDefault(__webpack_require__(1136));
	
	exports.RemoveGroupIcon = _RemoveGroupIcon["default"];
	
	var _RemoveUserIcon = _interopRequireDefault(__webpack_require__(1137));
	
	exports.RemoveUserIcon = _RemoveUserIcon["default"];
	
	var _ReportsIcon = _interopRequireDefault(__webpack_require__(1138));
	
	exports.ReportsIcon = _ReportsIcon["default"];
	
	var _RestartIcon = _interopRequireDefault(__webpack_require__(1139));
	
	exports.RestartIcon = _RestartIcon["default"];
	
	var _RouterIcon = _interopRequireDefault(__webpack_require__(1140));
	
	exports.RouterIcon = _RouterIcon["default"];
	
	var _SaveToDeviceIcon = _interopRequireDefault(__webpack_require__(1141));
	
	exports.SaveToDeviceIcon = _SaveToDeviceIcon["default"];
	
	var _SearchIcon = _interopRequireDefault(__webpack_require__(1142));
	
	exports.SearchIcon = _SearchIcon["default"];
	
	var _ServerIcon = _interopRequireDefault(__webpack_require__(1143));
	
	exports.ServerIcon = _ServerIcon["default"];
	
	var _SettingIcon = _interopRequireDefault(__webpack_require__(1144));
	
	exports.SettingIcon = _SettingIcon["default"];
	
	var _ShowDefaultIcon = _interopRequireDefault(__webpack_require__(1145));
	
	exports.ShowDefaultIcon = _ShowDefaultIcon["default"];
	
	var _ShowHideIcon = _interopRequireDefault(__webpack_require__(1146));
	
	exports.ShowHideIcon = _ShowHideIcon["default"];
	
	var _SideMenuIcon = _interopRequireDefault(__webpack_require__(1147));
	
	exports.SideMenuIcon = _SideMenuIcon["default"];
	
	var _SingleServerIcon = _interopRequireDefault(__webpack_require__(1148));
	
	exports.SingleServerIcon = _SingleServerIcon["default"];
	
	var _Sort19Icon = _interopRequireDefault(__webpack_require__(1149));
	
	exports.Sort19Icon = _Sort19Icon["default"];
	
	var _Sort91Icon = _interopRequireDefault(__webpack_require__(1150));
	
	exports.Sort91Icon = _Sort91Icon["default"];
	
	var _SortAZIcon = _interopRequireDefault(__webpack_require__(1151));
	
	exports.SortAZIcon = _SortAZIcon["default"];
	
	var _SortAscendingIcon = _interopRequireDefault(__webpack_require__(1152));
	
	exports.SortAscendingIcon = _SortAscendingIcon["default"];
	
	var _SortDefaultDescendingIcon = _interopRequireDefault(__webpack_require__(1153));
	
	exports.SortDefaultDescendingIcon = _SortDefaultDescendingIcon["default"];
	
	var _SortDefaultIcon = _interopRequireDefault(__webpack_require__(1154));
	
	exports.SortDefaultIcon = _SortDefaultIcon["default"];
	
	var _SortDescendingIcon = _interopRequireDefault(__webpack_require__(1155));
	
	exports.SortDescendingIcon = _SortDescendingIcon["default"];
	
	var _SortDownIcon = _interopRequireDefault(__webpack_require__(1156));
	
	exports.SortDownIcon = _SortDownIcon["default"];
	
	var _SortMoveToBottomIcon = _interopRequireDefault(__webpack_require__(1157));
	
	exports.SortMoveToBottomIcon = _SortMoveToBottomIcon["default"];
	
	var _SortMoveToTopIcon = _interopRequireDefault(__webpack_require__(1158));
	
	exports.SortMoveToTopIcon = _SortMoveToTopIcon["default"];
	
	var _SortUpAndDownIcon = _interopRequireDefault(__webpack_require__(1159));
	
	exports.SortUpAndDownIcon = _SortUpAndDownIcon["default"];
	
	var _SortUpIcon = _interopRequireDefault(__webpack_require__(1160));
	
	exports.SortUpIcon = _SortUpIcon["default"];
	
	var _SortZAIcon = _interopRequireDefault(__webpack_require__(1161));
	
	exports.SortZAIcon = _SortZAIcon["default"];
	
	var _StarIcon = _interopRequireDefault(__webpack_require__(1162));
	
	exports.StarIcon = _StarIcon["default"];
	
	var _StopIcon = _interopRequireDefault(__webpack_require__(1163));
	
	exports.StopIcon = _StopIcon["default"];
	
	var _SwitchIcon = _interopRequireDefault(__webpack_require__(1164));
	
	exports.SwitchIcon = _SwitchIcon["default"];
	
	var _SyncIcon = _interopRequireDefault(__webpack_require__(1165));
	
	exports.SyncIcon = _SyncIcon["default"];
	
	var _TrashIcon = _interopRequireDefault(__webpack_require__(1166));
	
	exports.TrashIcon = _TrashIcon["default"];
	
	var _UnknownGroupIcon = _interopRequireDefault(__webpack_require__(1167));
	
	exports.UnknownGroupIcon = _UnknownGroupIcon["default"];
	
	var _UnknownUserIcon = _interopRequireDefault(__webpack_require__(1168));
	
	exports.UnknownUserIcon = _UnknownUserIcon["default"];
	
	var _UploadDefaultIcon = _interopRequireDefault(__webpack_require__(1169));
	
	exports.UploadDefaultIcon = _UploadDefaultIcon["default"];
	
	var _UploadDownloadIcon = _interopRequireDefault(__webpack_require__(1170));
	
	exports.UploadDownloadIcon = _UploadDownloadIcon["default"];
	
	var _UserGroupIcon = _interopRequireDefault(__webpack_require__(1171));
	
	exports.UserGroupIcon = _UserGroupIcon["default"];
	
	var _UserIcon = _interopRequireDefault(__webpack_require__(1172));
	
	exports.UserIcon = _UserIcon["default"];
	
	var _VideoIcon = _interopRequireDefault(__webpack_require__(1173));
	
	exports.VideoIcon = _VideoIcon["default"];
	
	var _WifiRouterIcon = _interopRequireDefault(__webpack_require__(1174));
	
	exports.WifiRouterIcon = _WifiRouterIcon["default"];
	
	var _ZoomInIcon = _interopRequireDefault(__webpack_require__(1175));
	
	exports.ZoomInIcon = _ZoomInIcon["default"];
	
	var _ZoomOutIcon = _interopRequireDefault(__webpack_require__(1176));
	
	exports.ZoomOutIcon = _ZoomOutIcon["default"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ v1.3.7 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1221)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = y32 * x10 - x32 * y10;
	  if (t * t < epsilon) return;
	  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00),
	            oc;
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
	          var ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$1 = x,
	      y$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$1 = x,
	      y$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$1.apply(this, (argv[0] = s, argv)), +y$1.apply(this, argv), +x$1.apply(this, (argv[0] = t, argv)), +y$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), link) : x$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), link) : y$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = 0, d[1] = dy;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function appearance(series) {
	  var peaks = series.map(peak);
	  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
	}
	
	function peak(series) {
	  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	  return j;
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = appearance(series),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.areaRadial = areaRadial;
	exports.curveBasis = basis;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBundle = bundle;
	exports.curveCardinal = cardinal;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveLinear = curveLinear;
	exports.curveLinearClosed = linearClosed;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.line = line;
	exports.lineRadial = lineRadial$1;
	exports.linkHorizontal = linkHorizontal;
	exports.linkRadial = linkRadial;
	exports.linkVertical = linkVertical;
	exports.pie = pie;
	exports.pointRadial = pointRadial;
	exports.radialArea = areaRadial;
	exports.radialLine = lineRadial$1;
	exports.stack = stack;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAppearance = appearance;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	exports.symbol = symbol;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.symbols = symbols;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(65);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(151);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(261);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(74),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(1287),
	    flatRest = __webpack_require__(422);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(1362),
	    isObject = __webpack_require__(47);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.redeployGatewayBundle = exports.undeployGatewayBundle = exports.deployGatewayBundle = exports.deleteGatewayBundle = exports.saveBundleAssets = exports.fetchGatewayBundlesApis = exports.fetchDeploymentStatus = exports.fetchDeploymentProxyList = exports.fetchGatewayBundleUsage = exports.fetchGatewayBundleDetails = exports.fetchGatewayBundles = exports.showLoading = exports.resetDeleteNotification = exports.resetApp = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _queryString = __webpack_require__(100);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _portalConfig = __webpack_require__(26);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initBundle = function initBundle(dispatch) {
	  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return dispatch({
	    type: Constants.APP_LOADING,
	    isLoading: isLoading
	  });
	};
	
	var resetApp = exports.resetApp = function resetApp() {
	  return function (dispatch) {
	    return dispatch({ type: Constants.APP_RESET });
	  };
	};
	var resetDeleteNotification = exports.resetDeleteNotification = function resetDeleteNotification() {
	  return function (dispatch) {
	    return dispatch({ type: Constants.GATEWAY_BUNDLES_DELETE_RESET });
	  };
	};
	var showLoading = exports.showLoading = function showLoading(isLoading) {
	  return function (dispatch) {
	    return initBundle(dispatch, isLoading);
	  };
	};
	
	var fetchGatewayBundles = exports.fetchGatewayBundles = function fetchGatewayBundles() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'createTs,DESC';
	  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Constants.ANY;
	  var l7template = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Constants.ANY;
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	  var size = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 12;
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var config, portal, params, url;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              params = (0, _queryString.stringify)({
	                name: !(0, _lodash.isEmpty)(name) ? name : undefined,
	                groupName: !(0, _lodash.isEmpty)(groupName) ? groupName : undefined,
	                page: page,
	                size: size,
	                sort: sort,
	                type: type !== Constants.ANY ? type : undefined,
	                l7template: l7template !== Constants.ANY ? l7template : undefined
	              }, true);
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/policy-management/0.1/gateway-bundles?' + params;
	              _context.next = 7;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x9, _x10) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchGatewayBundleDetails = exports.fetchGatewayBundleDetails = function fetchGatewayBundleDetails(bundleUuid) {
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var config, portal, urlDetails, urlActions;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              urlDetails = portal.hostname + '/api/' + portal.tenantPrefix + '/policy-management/0.1/gateway-bundles/' + bundleUuid;
	              urlActions = portal.hostname + '/admin/policy-management/internal/gateway-bundles/' + bundleUuid + '/actions';
	              _context2.next = 7;
	              return Promise.all([_axios2.default.get(urlDetails, { credentials: 'include' }), _axios2.default.get(urlActions, { credentials: 'include' })]).then(function (responseArr) {
	                dispatch({
	                  type: Constants.GATEWAY_BUNDLES_DETAILS_SUCCESS,
	                  payload: Object.assign({}, responseArr[0].data, responseArr[1].data)
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_DETAILS_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x11, _x12) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchGatewayBundleUsage = exports.fetchGatewayBundleUsage = function fetchGatewayBundleUsage(bundleUuid) {
	  return function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/policy-management/internal/gateway-bundles/' + bundleUuid + '/usage';
	              _context3.next = 6;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_USAGE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function () {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_USAGE_ERROR,
	                  payload: null
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function (_x13, _x14) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchDeploymentProxyList = exports.fetchDeploymentProxyList = function fetchDeploymentProxyList(bundleUuid) {
	  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Constants.ALL;
	  var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	  var size = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 12;
	  return function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(dispatch, getState) {
	      var config, portal, params, url;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              params = (0, _queryString.stringify)({
	                proxyName: !(0, _lodash.isEmpty)(name) ? name : undefined,
	                page: page,
	                size: size,
	                status: status !== Constants.ALL ? status : undefined
	              }, true);
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/internal/gateway-bundles/' + bundleUuid + '/proxies?' + params;
	              _context4.next = 7;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_PROXY_LIST_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_PROXY_LIST_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x19, _x20) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchDeploymentStatus = exports.fetchDeploymentStatus = function fetchDeploymentStatus(bundleUuid) {
	  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Constants.ALL;
	  var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	  var size = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 12;
	  return function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(dispatch, getState) {
	      var config, portal, params, urlDeployments, urlActions;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              params = (0, _queryString.stringify)({
	                proxyName: !(0, _lodash.isEmpty)(name) ? name : undefined,
	                page: page,
	                size: size,
	                status: status !== Constants.ALL ? status : undefined
	              }, true);
	              urlDeployments = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/internal/gateway-bundles/' + bundleUuid + '/proxies?' + params;
	              urlActions = portal.hostname + '/admin/policy-management/internal/gateway-bundles/' + bundleUuid + '/actions';
	              _context5.next = 8;
	              return Promise.all([_axios2.default.get(urlDeployments, { credentials: 'include' }), _axios2.default.get(urlActions, { credentials: 'include' })]).then(function (responseArr) {
	                dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_PROXY_SUCCESS,
	                  payload: Object.assign({}, responseArr[0].data, responseArr[1].data)
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_PROXY_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 8:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x25, _x26) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchGatewayBundlesApis = exports.fetchGatewayBundlesApis = function fetchGatewayBundlesApis(bundleUuid) {
	  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var proxyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var apiStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Constants.ALL;
	  var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'apiModifyTs,DESC';
	  var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	  var size = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 12;
	  return function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(dispatch, getState) {
	      var config, portal, params, url;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              params = (0, _queryString.stringify)({
	                apiName: !(0, _lodash.isEmpty)(name) ? name : undefined,
	                proxyName: !(0, _lodash.isEmpty)(proxyName) ? proxyName : undefined,
	                page: page,
	                size: size,
	                sort: sort,
	                apiStatus: apiStatus !== Constants.ALL ? apiStatus : undefined
	              }, true);
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/policy-management/0.1/gateway-bundles/' + bundleUuid + '/apis?' + params;
	              _context6.next = 7;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_APIS_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_GET_APIS_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined);
	    }));
	
	    return function (_x33, _x34) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	};
	
	var saveBundleAssets = exports.saveBundleAssets = function saveBundleAssets(uploadedAssets) {
	  return function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(dispatch, getState) {
	      var config, portal, formData, url;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              formData = new FormData();
	
	              (0, _lodash.forEach)(uploadedAssets, function (_ref8) {
	                var blob = _ref8.blob,
	                    name = _ref8.name;
	
	                if (blob) {
	                  formData.append('files', blob, name);
	                }
	              });
	
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/policy-management/0.1/gateway-bundles';
	              _context7.next = 8;
	              return _axios2.default.post(url, formData, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.GATEWAY_BUNDLES_SAVE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_SAVE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 8:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined);
	    }));
	
	    return function (_x35, _x36) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	};
	
	var deleteGatewayBundle = exports.deleteGatewayBundle = function deleteGatewayBundle(bundleUuid) {
	  return function () {
	    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/policy-management/0.1/gateway-bundles/' + bundleUuid;
	              _context8.next = 6;
	              return _axios2.default.delete(url, { credentials: 'include' }).then(function (response) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_DELETE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_DELETE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined);
	    }));
	
	    return function (_x37, _x38) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	};
	
	var getDeploymentValidationErrors = function getDeploymentValidationErrors(error) {
	  return (0, _lodash.get)(error, 'validationErrors');
	};
	var processDeploymentErrors = function processDeploymentErrors(validationErrors, defaultMessage) {
	  var errorMessage = void 0;
	  var keys = validationErrors ? Object.keys(validationErrors) : [];
	  if (keys.length > 0) {
	    errorMessage = (0, _lodash.map)(keys, function (key) {
	      return validationErrors[key].devMessage;
	    }).join('\n');
	  }
	  return errorMessage || defaultMessage;
	};
	
	var deployGatewayBundle = exports.deployGatewayBundle = function deployGatewayBundle(bundleUuid, proxyUuid) {
	  return function () {
	    var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = { proxyUuid: proxyUuid };
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/gateway-bundles/' + bundleUuid + '/proxies';
	              _context9.next = 7;
	              return _axios2.default.post(url, data, { credentials: 'include' }).then(function (response) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_DEPLOY_PROXY_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                var statusCode = (0, _lodash.get)(error, 'response.status');
	                if (statusCode === Constants.HTTP_STATUS_UNAUTHORIZED) {
	                  window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	                }
	
	                var responseError = (0, _lodash.get)(error, 'response.data');
	                var strErrorMessage = statusCode === Constants.HTTP_STATUS_BAD_REQUEST ? processDeploymentErrors(getDeploymentValidationErrors(responseError), '') : (0, _lodash.get)(error, 'message');
	                dispatch({
	                  type: Constants.GATEWAY_BUNDLES_DEPLOY_PROXY_ERROR,
	                  payload: {
	                    proxyUuid: proxyUuid,
	                    errorMessage: strErrorMessage
	                  }
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, undefined);
	    }));
	
	    return function (_x39, _x40) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	};
	
	var undeployGatewayBundle = exports.undeployGatewayBundle = function undeployGatewayBundle(bundleUuid, proxyUuid) {
	  return function () {
	    var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/gateway-bundles/' + bundleUuid + '/proxies/' + proxyUuid;
	              _context10.next = 6;
	              return _axios2.default.delete(url, { credentials: 'include' }).then(function () {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_UNDEPLOY_PROXY_SUCCESS,
	                  payload: {
	                    proxyUuid: proxyUuid,
	                    errorMessage: ''
	                  }
	                });
	              }).catch(function (error) {
	                var statusCode = (0, _lodash.get)(error, 'response.status');
	                if (statusCode === Constants.HTTP_STATUS_UNAUTHORIZED) {
	                  window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	                }
	
	                var responseError = (0, _lodash.get)(error, 'response.data');
	                var strErrorMessage = statusCode === Constants.HTTP_STATUS_BAD_REQUEST ? processDeploymentErrors(getDeploymentValidationErrors(responseError), '') : (0, _lodash.get)(error, 'message');
	                dispatch({
	                  type: Constants.GATEWAY_BUNDLES_UNDEPLOY_PROXY_ERROR,
	                  payload: {
	                    proxyUuid: proxyUuid,
	                    errorMessage: strErrorMessage
	                  }
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, undefined);
	    }));
	
	    return function (_x41, _x42) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	};
	
	var redeployGatewayBundle = exports.redeployGatewayBundle = function redeployGatewayBundle(bundleUuid, proxyUuid) {
	  return function () {
	    var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              initBundle(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = { status: Constants.PENDING_DEPLOYMENT };
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/gateway-bundles/' + bundleUuid + '/proxies/' + proxyUuid;
	              _context11.next = 7;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                return dispatch({
	                  type: Constants.GATEWAY_BUNDLES_REDEPLOY_PROXY_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                var statusCode = (0, _lodash.get)(error, 'response.status');
	                if (statusCode === Constants.HTTP_STATUS_UNAUTHORIZED) {
	                  window.location.href = portal.hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	                }
	
	                var responseError = (0, _lodash.get)(error, 'response.data');
	                var strErrorMessage = statusCode === Constants.HTTP_STATUS_BAD_REQUEST ? processDeploymentErrors(getDeploymentValidationErrors(responseError), '') : (0, _lodash.get)(error, 'message');
	                dispatch({
	                  type: Constants.GATEWAY_BUNDLES_REDEPLOY_PROXY_ERROR,
	                  payload: {
	                    proxyUuid: proxyUuid,
	                    errorMessage: strErrorMessage
	                  }
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, undefined);
	    }));
	
	    return function (_x43, _x44) {
	      return _ref12.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 155 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 156 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(747));

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	Object.defineProperty(exports, "unstable_StrictModeFade", {
	  enumerable: true,
	  get: function get() {
	    return _StrictModeFade.default;
	  }
	});
	
	var _Fade = _interopRequireDefault(__webpack_require__(316));
	
	var _StrictModeFade = _interopRequireDefault(__webpack_require__(777));

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useFormControl = useFormControl;
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * @ignore - internal component.
	 */
	var FormControlContext = React.createContext();
	
	if (false) {
	  FormControlContext.displayName = 'FormControlContext';
	}
	
	function useFormControl() {
	  return React.useContext(FormControlContext);
	}
	
	var _default = FormControlContext;
	exports.default = _default;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	
	var _Input = _interopRequireDefault(__webpack_require__(800));

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	
	var _Link = _interopRequireDefault(__webpack_require__(806));

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(807));

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(808));

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(822));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(325));

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(840));

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(860));

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	
	var _TableCell = _interopRequireDefault(__webpack_require__(870));

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || window;
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unsupportedProp;
	
	function unsupportedProp(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propFullNameSafe = propFullName || propName;
	
	  if (typeof props[propName] !== 'undefined') {
	    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
	  }
	
	  return null;
	}

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
	}), 'KeyboardArrowDown');
	
	exports.default = _default;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
	}), 'KeyboardArrowUp');
	
	exports.default = _default;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
	}), 'Lens');
	
	exports.default = _default;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _utils = __webpack_require__(21);
	
	function merge(acc, item) {
	  if (!item) {
	    return acc;
	  }
	
	  return (0, _utils.deepmerge)(acc, item, {
	    clone: false // No need to clone deep, it's way faster.
	
	  });
	}
	
	var _default = merge;
	exports.default = _default;

/***/ },
/* 174 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.onLocationChanged = exports.LOCATION_CHANGE = void 0;
	
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	exports.LOCATION_CHANGE = LOCATION_CHANGE;
	
	var onLocationChanged = function onLocationChanged(location, action) {
	  var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  return {
	    type: LOCATION_CHANGE,
	    payload: {
	      location: location,
	      action: action,
	      isFirstRendering: isFirstRendering
	    }
	  };
	};
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	
	
	exports.onLocationChanged = onLocationChanged;
	var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	exports.CALL_HISTORY_METHOD = CALL_HISTORY_METHOD;
	
	var updateLocation = function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: {
	        method: method,
	        args: args
	      }
	    };
	  };
	};
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	
	
	var push = updateLocation('push');
	exports.push = push;
	var replace = updateLocation('replace');
	exports.replace = replace;
	var go = updateLocation('go');
	exports.go = go;
	var goBack = updateLocation('goBack');
	exports.goBack = goBack;
	var goForward = updateLocation('goForward');
	exports.goForward = goForward;
	var routerActions = {
	  push: push,
	  replace: replace,
	  go: go,
	  goBack: goBack,
	  goForward: goForward
	};
	exports.routerActions = routerActions;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.dotCase = void 0;
	var tslib_1 = __webpack_require__(1230);
	var no_case_1 = __webpack_require__(120);
	function dotCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return no_case_1.noCase(input, tslib_1.__assign({ delimiter: "." }, options));
	}
	exports.dotCase = dotCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1238);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1334),
	    listCacheDelete = __webpack_require__(1335),
	    listCacheGet = __webpack_require__(1336),
	    listCacheHas = __webpack_require__(1337),
	    listCacheSet = __webpack_require__(1338);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(118);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(420);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(181),
	    createBaseEach = __webpack_require__(1308);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1273),
	    keys = __webpack_require__(56);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(76),
	    overRest = __webpack_require__(433),
	    setToString = __webpack_require__(434);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 183 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(36),
	    isKey = __webpack_require__(268),
	    stringToPath = __webpack_require__(1360),
	    toString = __webpack_require__(452);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1331);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 186 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(118),
	    isArrayLike = __webpack_require__(66),
	    isIndex = __webpack_require__(186),
	    isObject = __webpack_require__(47);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 188 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(98);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(179),
	    createAggregator = __webpack_require__(1306);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1276),
	    isObjectLike = __webpack_require__(58);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(1313);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1300),
	    keys = __webpack_require__(56);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(1272),
	    baseRest = __webpack_require__(182),
	    isArrayLikeObject = __webpack_require__(440);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 195 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AXIOS_DEFAULT_OPTIONS = exports.AXIOS_DEFAULT_OPTIONS = { credentials: 'include' };
	
	exports.default = {};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AlertDialog;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Close = __webpack_require__(141);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(1453);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AlertDialog(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      isOpen = props.isOpen,
	      cancelText = props.cancelText,
	      submitText = props.submitText,
	      title = props.title,
	      description = props.description,
	      _props$dialogId = props.dialogId,
	      dialogId = _props$dialogId === undefined ? 'alert-dialog' : _props$dialogId,
	      handleClose = props.handleClose,
	      _props$submitButtonCl = props.submitButtonClass,
	      submitButtonClass = _props$submitButtonCl === undefined ? '' : _props$submitButtonCl,
	      _props$cancelButtonCl = props.cancelButtonClass,
	      cancelButtonClass = _props$cancelButtonCl === undefined ? '' : _props$cancelButtonCl,
	      _props$dialogActionCl = props.dialogActionClass,
	      dialogActionClass = _props$dialogActionCl === undefined ? '' : _props$dialogActionCl,
	      _props$showSubmit = props.showSubmit,
	      showSubmit = _props$showSubmit === undefined ? true : _props$showSubmit,
	      onSubmit = props.onSubmit,
	      _props$showCancel = props.showCancel,
	      showCancel = _props$showCancel === undefined ? true : _props$showCancel,
	      onCancel = props.onCancel,
	      onClose = props.onClose,
	      showCloseButton = props.showCloseButton;
	
	
	  return _react2.default.createElement(
	    _core.Dialog,
	    {
	      open: isOpen,
	      onClose: handleClose,
	      'aria-labelledby': 'alert-dialog-title',
	      'aria-describedby': 'alert-dialog-description',
	      id: id || dialogId, 'data-apim-test': id || dialogId, 'data-layer7-test': id || dialogId,
	      classes: {
	        paper: classes.dialogContainer
	      }
	    },
	    _react2.default.createElement(
	      _core.DialogTitle,
	      {
	        id: 'alert-dialog-title',
	        'data-apim-test': 'alert-dialog-title',
	        className: classes.dialogTitle
	      },
	      _react2.default.createElement(
	        _core.Typography,
	        { variant: 'h3', className: classes.title },
	        title
	      ),
	      showCloseButton ? _react2.default.createElement(
	        _IconButton2.default,
	        { 'aria-label': 'close', className: classes.closeButton, onClick: onClose },
	        _react2.default.createElement(_Close2.default, null)
	      ) : null
	    ),
	    _react2.default.createElement(
	      _core.DialogContent,
	      null,
	      _react2.default.createElement(
	        _core.DialogContentText,
	        { id: 'alert-dialog-description', 'data-apim-test': 'alert-dialog-description' },
	        description
	      )
	    ),
	    _react2.default.createElement(
	      _core.DialogActions,
	      { id: dialogId + '-actions', classes: { root: dialogActionClass } },
	      showSubmit && _react2.default.createElement(
	        _core.Button,
	        {
	          className: (0, _clsx2.default)(classes.submitButton, submitButtonClass),
	          'data-apim-test': 'alert-dialog-submit',
	          id: dialogId + '-action-submit', 'data-layer7-test': dialogId + '-action-submit',
	          onClick: onSubmit,
	          variant: 'contained',
	          color: 'secondary'
	        },
	        submitText
	      ),
	      showCancel && _react2.default.createElement(
	        _core.Button,
	        {
	          className: (0, _clsx2.default)(classes.cancelButton, cancelButtonClass),
	          'data-apim-test': 'alert-dialog-cancel',
	          id: dialogId + '-action-cancel', 'data-layer7-test': dialogId + '-action-cancel',
	          onClick: onCancel,
	          variant: 'outlined'
	        },
	        cancelText
	      )
	    )
	  );
	}
	
	AlertDialog.propTypes = {
	  id: _propTypes2.default.string,
	  isOpen: _propTypes2.default.bool,
	  cancelText: _propTypes2.default.string,
	  submitText: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  dialogId: _propTypes2.default.string,
	  handleClose: _propTypes2.default.func,
	  showSubmit: _propTypes2.default.bool,
	  onSubmit: _propTypes2.default.func,
	  showCancel: _propTypes2.default.bool,
	  onCancel: _propTypes2.default.func,
	  submitButtonClass: _propTypes2.default.string,
	  onClose: _propTypes2.default.func,
	  showCloseButton: _propTypes2.default.bool
	};

/***/ },
/* 198 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DETAILS_TAB_TITLE = exports.DETAILS_TAB_TITLE = 'Details';
	var ORG_ASSIGNMENT_TAB_TITLE = exports.ORG_ASSIGNMENT_TAB_TITLE = 'Organization Assignment';
	var ORG_ASSIGNMENT_PAGE_SUB_TITLE = exports.ORG_ASSIGNMENT_PAGE_SUB_TITLE = 'Optional: Add organizations to see the proxy.';
	
	var UNIQUE_PROXY_NAME_WARNING_MSG = exports.UNIQUE_PROXY_NAME_WARNING_MSG = 'Name already exists. Enter a unique proxy name.';
	var MAXLENGTH_PROXY_NAME_WARNING_MSG = exports.MAXLENGTH_PROXY_NAME_WARNING_MSG = 'Maximum name length is 255 characters. Name must be unique.';
	var UNIQUE_PROXY_NAME_ERROR_MSG = exports.UNIQUE_PROXY_NAME_ERROR_MSG = 'Name already exists. Enter a unique proxy name.';
	var EMPTY_PROXY_NAME_ERROR_MSG = exports.EMPTY_PROXY_NAME_ERROR_MSG = 'Enter a valid proxy name.';
	var MAXLENGTH_PROXY_NAME_ERROR_MSG = exports.MAXLENGTH_PROXY_NAME_ERROR_MSG = 'Enter a proxy name with less than 255 characters.';
	
	var PROXY_CREATE_SUCCESS_MSG = exports.PROXY_CREATE_SUCCESS_MSG = 'Proxy was successfully created.';
	var PROXY_CREATE_FAIL_MSG = exports.PROXY_CREATE_FAIL_MSG = 'There was an error while creating a proxy.';
	var PROXY_UPDATE_SUCCESS_MSG = exports.PROXY_UPDATE_SUCCESS_MSG = 'Proxy was successfully updated.';
	var PROXY_UPDATE_FAIL_MSG = exports.PROXY_UPDATE_FAIL_MSG = 'There was an error while updating a proxy.';
	var PROXY_ORGS_UPDATE_FAIL_MSG = exports.PROXY_ORGS_UPDATE_FAIL_MSG = 'There was an error while updating orgs to a proxy.';
	
	var ADD_PROXY_LABEL = exports.ADD_PROXY_LABEL = 'Add Proxy';
	var EDIT_PROXY_LABEL = exports.EDIT_PROXY_LABEL = 'Edit Proxy';
	
	var PROXY_NAME_TITLE = exports.PROXY_NAME_TITLE = 'Proxy Name';
	var API_DEPLOYMENT_TYPE_TITLE = exports.API_DEPLOYMENT_TYPE_TITLE = 'API Deployment Type';
	var API_DEPLOYMENT_TYPE_TOOLTIP_TEXT = exports.API_DEPLOYMENT_TYPE_TOOLTIP_TEXT = 'API Deployment Type determines how APIs will be deployed to this proxy.';
	var KEY_DEPLOYMENT_TYPE_TITLE = exports.KEY_DEPLOYMENT_TYPE_TITLE = 'Key Deployment Type';
	var KEY_DEPLOYMENT_TYPE_TOOLTIP_TEXT = exports.KEY_DEPLOYMENT_TYPE_TOOLTIP_TEXT = 'Key Deployment Type determines how API Keys will be deployed to this proxy.';
	
	var ORGANIZATIONS_TITLE = exports.ORGANIZATIONS_TITLE = 'Organizations';
	var AVAILABLE_ORGANIZATIONS_SUBTITLE = exports.AVAILABLE_ORGANIZATIONS_SUBTITLE = 'All available organizations.';
	var SEARCH_AVAILABLE_ORGANIZATIONS_SUBTITLE = exports.SEARCH_AVAILABLE_ORGANIZATIONS_SUBTITLE = 'Search available organizations';
	var SELECTED_ORGANIZATIONS_TITLE = exports.SELECTED_ORGANIZATIONS_TITLE = 'Selected';
	var ALL_SELECTED_ORGANIZATIONS_SUBTITLE = exports.ALL_SELECTED_ORGANIZATIONS_SUBTITLE = 'All the selected organizations.';
	var SEARCH_SELECTED_ORGANIZATIONS_SUBTITLE = exports.SEARCH_SELECTED_ORGANIZATIONS_SUBTITLE = 'Search selected organizations';
	
	var HELP_ITEMS = exports.HELP_ITEMS = [{
	  screen: 0,
	  details: {
	    title: 'Proxy Details Help',
	    descriptions: '',
	    subItems: [{
	      id: 1,
	      title: '',
	      descriptions: 'Select the API deployment type to control how API Portal deploys newly Portal-published APIs to this proxy. Select the key deployment type to control how API Portal deploys newly created applications to this proxy. API Portal automatically deploys the changes that you make to existing APIs and applications to the proxies regardless of the deployment type.'
	    }, {
	      id: 2,
	      title: 'Automatic',
	      descriptions: 'API Portal automatically deploys newly added APIs and applications.'
	    }, {
	      id: 3,
	      title: 'On Demand',
	      descriptions: 'The Portal Admin and users with deployment permissions manage API and application deployments as needed.'
	    }, {
	      id: 4,
	      title: 'Scripted (API only)',
	      descriptions: 'API deployment can be integrated into your existing CICD workflow by leveraging the deployment APIs and invoking them from your deployment script.'
	    }]
	  }
	}, {
	  screen: 1,
	  details: {
	    title: 'Org Assignment Help',
	    descriptions: '',
	    subItems: [{
	      id: 1,
	      title: '',
	      descriptions: 'Select the organization to assign it to the proxy. When no organization is assigned, only global publishers can see the proxy.'
	    }, {
	      id: 2,
	      title: '',
	      descriptions: 'Users with the right permissions within the organization will be able to see this proxy in the Deployments tab of their APIs.'
	    }, {
	      id: 3,
	      title: '',
	      descriptions: 'The users will be able to redeploy, undeploy and deploy their APIs to the proxy.'
	    }]
	  }
	}];
	
	var UNSAVED_DIALOG_TITLE = exports.UNSAVED_DIALOG_TITLE = 'Unsaved Changes';
	var UNSAVED_DIALOG_DESCRIPTION = exports.UNSAVED_DIALOG_DESCRIPTION = 'Your changes will be lost if you leave this page. Are you sure you want to continue away from this page?';
	var UNSAVED_DIALOG_CANCEL_TEXT = exports.UNSAVED_DIALOG_CANCEL_TEXT = 'Stay';
	var UNSAVED_DIALOG_SUBMIT_TEXT = exports.UNSAVED_DIALOG_SUBMIT_TEXT = 'Continue';
	var UNSAVED_DIALOG_EXIT_TEXT = exports.UNSAVED_DIALOG_EXIT_TEXT = 'Exit';
	var SAVE_TEXT = exports.SAVE_TEXT = 'Save';
	var SAVE_AND_NEXT_TEXT = exports.SAVE_AND_NEXT_TEXT = 'Save & Next';

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NOT_APPLICABLE_TEXT = exports.CANCEL_TEXT = exports.OK_TEXT = exports.CONFIRM_ACTION_TEXT = exports.WARNING_TEXT = exports.INFORMATION_TEXT = exports.KEY_STATUS_DISABLED = exports.KEY_STATUS_ENABLED = exports.APP_STATUS_DISABLED = exports.APP_STATUS_ENABLED = exports.APP_DEPLOYMENT_TYPE_ON_DEMAND = exports.APP_DEPLOYMENT_TYPE_AUTOMATIC = exports.DEPLOYMENT_STATUS_LABEL_DEPLOYMENT_ERROR = exports.DEPLOYMENT_STATUS_LABEL_VALIDATION_ERROR = exports.DEPLOYMENT_STATUS_LABEL_UNDEPLOYED = exports.DEPLOYMENT_STATUS_ERROR = exports.SECONDS_UNIT_TEXT = exports.UPDATING_STATUS_TEXT = exports.VALIDATING_TEXT = exports.UPDATING_TEXT = exports.CHECK_NOW_TEXT = exports.MORE_INFO_TEXT = exports.DEPLOYMENT_ACTION_LABEL_UNDEPLOY = exports.DEPLOYMENT_ACTION_LABEL_REDEPLOY = exports.DEPLOYMENT_ACTION_LABEL_DEPLOY = exports.DEPLOYMENT_ACTION_TYPE_UNDEPLOY = exports.DEPLOYMENT_ACTION_TYPE_REDEPLOY = exports.DEPLOYMENT_ACTION_TYPE_DEPLOY = exports.NO_RESULTS_TEXT = exports.LAST_UPDATED_LABEL = exports.KEY_DEPLOYMENT_TYPE_LABEL = exports.ADD_APIPLAN_ACTION_TEXT = exports.CHANGE_ACTION_TEXT = exports.VERSION_TEXT = exports.STATUS_LABEL = exports.KEY_NAME_LABEL = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (dict) {
	  return function (label) {
	    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: dict[label] });
	  };
	};
	
	// Configuration Tab
	
	
	var KEY_NAME_LABEL = exports.KEY_NAME_LABEL = 'Key Name';
	var STATUS_LABEL = exports.STATUS_LABEL = 'Status';
	
	// APIs Tab
	var VERSION_TEXT = exports.VERSION_TEXT = 'Version';
	var CHANGE_ACTION_TEXT = exports.CHANGE_ACTION_TEXT = 'Change';
	var ADD_APIPLAN_ACTION_TEXT = exports.ADD_APIPLAN_ACTION_TEXT = 'Add API Plan';
	
	// Deployments Tab
	var KEY_DEPLOYMENT_TYPE_LABEL = exports.KEY_DEPLOYMENT_TYPE_LABEL = 'Key Deployment Type';
	var LAST_UPDATED_LABEL = exports.LAST_UPDATED_LABEL = 'Last Updated';
	
	var NO_RESULTS_TEXT = exports.NO_RESULTS_TEXT = 'No results';
	var DEPLOYMENT_ACTION_TYPE_DEPLOY = exports.DEPLOYMENT_ACTION_TYPE_DEPLOY = 'DEPLOY';
	var DEPLOYMENT_ACTION_TYPE_REDEPLOY = exports.DEPLOYMENT_ACTION_TYPE_REDEPLOY = 'REDEPLOY';
	var DEPLOYMENT_ACTION_TYPE_UNDEPLOY = exports.DEPLOYMENT_ACTION_TYPE_UNDEPLOY = 'UNDEPLOY';
	
	var DEPLOYMENT_ACTION_LABEL_DEPLOY = exports.DEPLOYMENT_ACTION_LABEL_DEPLOY = 'Deploy';
	var DEPLOYMENT_ACTION_LABEL_REDEPLOY = exports.DEPLOYMENT_ACTION_LABEL_REDEPLOY = 'Redeploy';
	var DEPLOYMENT_ACTION_LABEL_UNDEPLOY = exports.DEPLOYMENT_ACTION_LABEL_UNDEPLOY = 'Undeploy';
	
	var MORE_INFO_TEXT = exports.MORE_INFO_TEXT = 'More Info';
	var CHECK_NOW_TEXT = exports.CHECK_NOW_TEXT = 'Check now';
	var UPDATING_TEXT = exports.UPDATING_TEXT = 'Updating...';
	var VALIDATING_TEXT = exports.VALIDATING_TEXT = 'Validating...';
	var UPDATING_STATUS_TEXT = exports.UPDATING_STATUS_TEXT = 'Updating status: check in';
	var SECONDS_UNIT_TEXT = exports.SECONDS_UNIT_TEXT = 's';
	
	var DEPLOYMENT_STATUS_ERROR = exports.DEPLOYMENT_STATUS_ERROR = 'ERROR';
	var DEPLOYMENT_STATUS_LABEL_UNDEPLOYED = exports.DEPLOYMENT_STATUS_LABEL_UNDEPLOYED = 'Not deployed';
	var DEPLOYMENT_STATUS_LABEL_VALIDATION_ERROR = exports.DEPLOYMENT_STATUS_LABEL_VALIDATION_ERROR = 'Validation error';
	var DEPLOYMENT_STATUS_LABEL_DEPLOYMENT_ERROR = exports.DEPLOYMENT_STATUS_LABEL_DEPLOYMENT_ERROR = 'Deployment error';
	
	var APP_DEPLOYMENT_TYPE_AUTOMATIC = exports.APP_DEPLOYMENT_TYPE_AUTOMATIC = 'AUTOMATIC';
	var APP_DEPLOYMENT_TYPE_ON_DEMAND = exports.APP_DEPLOYMENT_TYPE_ON_DEMAND = 'ON_DEMAND';
	
	var APP_STATUS_ENABLED = exports.APP_STATUS_ENABLED = 'ENABLED';
	var APP_STATUS_DISABLED = exports.APP_STATUS_DISABLED = 'DISABLED';
	var KEY_STATUS_ENABLED = exports.KEY_STATUS_ENABLED = 'ENABLED';
	var KEY_STATUS_DISABLED = exports.KEY_STATUS_DISABLED = 'DISABLED';
	
	var INFORMATION_TEXT = exports.INFORMATION_TEXT = 'Information';
	var WARNING_TEXT = exports.WARNING_TEXT = 'Warning';
	var CONFIRM_ACTION_TEXT = exports.CONFIRM_ACTION_TEXT = 'Are you sure you want to perform this action?';
	var OK_TEXT = exports.OK_TEXT = 'Ok';
	var CANCEL_TEXT = exports.CANCEL_TEXT = 'Cancel';
	var NOT_APPLICABLE_TEXT = exports.NOT_APPLICABLE_TEXT = 'n/a';

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OverviewPaperWithStatusTableRow = exports.OverviewPaperWithStatusTableHead = exports.OverviewPaperWithStatus = exports.OverviewPaper = undefined;
	
	var _core = __webpack_require__(3);
	
	var _paper = __webpack_require__(1682);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _paperWithStatus = __webpack_require__(1683);
	
	var _paperWithStatus2 = _interopRequireDefault(_paperWithStatus);
	
	var _table = __webpack_require__(621);
	
	var _styles = __webpack_require__(283);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OverviewPaper = exports.OverviewPaper = (0, _core.withStyles)(_styles2.default)(_paper2.default);
	
	var OverviewPaperWithStatus = exports.OverviewPaperWithStatus = (0, _core.withStyles)(_styles2.default)(_paperWithStatus2.default);
	
	var OverviewPaperWithStatusTableHead = exports.OverviewPaperWithStatusTableHead = (0, _core.withStyles)(_styles2.default)(_table.TableHead);
	
	var OverviewPaperWithStatusTableRow = exports.OverviewPaperWithStatusTableRow = (0, _core.withStyles)(_styles2.default)(_table.TableRow);

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Edit = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _components = __webpack_require__(17);
	
	var _intl = __webpack_require__(15);
	
	var _edit = __webpack_require__(1699);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Edit = exports.Edit = function Edit(props) {
	  var classes = props.classes,
	      editPageId = props.editPageId,
	      dialogId = props.dialogId,
	      isDialogOpen = props.isDialogOpen,
	      onDialogClose = props.onDialogClose,
	      dialogSubmitText = props.dialogSubmitText,
	      onDialogSubmit = props.onDialogSubmit,
	      isLoading = props.isLoading,
	      leftSidebarId = props.leftSidebarId,
	      mainContentId = props.mainContentId,
	      notificationId = props.notificationId,
	      notificationStatus = props.notificationStatus,
	      setNotificationStatus = props.setNotificationStatus,
	      notificationMessage = props.notificationMessage,
	      setNotificationMessage = props.setNotificationMessage,
	      tabsContainer = props.tabsContainer,
	      pageHeaderRef = props.pageHeaderRef,
	      pageHeaderTitle = props.pageHeaderTitle,
	      pageContent = props.pageContent,
	      rightSidebarId = props.rightSidebarId,
	      helpItems = props.helpItems;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.content,
	      id: editPageId,
	      'data-apim-test': editPageId
	    },
	    _react2.default.createElement(_components.AlertDialog, {
	      isOpen: isDialogOpen,
	      title: intl.getI18nMessage('label.dialog.unsaved.changes.title'),
	      description: intl.getI18nMessage('label.dialog.unsaved.changes.description'),
	      submitText: dialogSubmitText,
	      cancelText: intl.getI18nMessage('label.dialog.unsaved.changes.cancel'),
	      onClose: onDialogClose,
	      onSubmit: onDialogSubmit,
	      onCancel: onDialogClose,
	      dialogId: dialogId
	    }),
	    isLoading ? _react2.default.createElement(_components.Loading, null) : _react2.default.createElement(
	      _core.Grid,
	      { container: true, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        {
	          md: 2, item: true,
	          className: classes.leftSidebar,
	          id: leftSidebarId, 'data-apim-test': leftSidebarId
	        },
	        tabsContainer
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        {
	          md: 7, item: true,
	          className: classes.mainContent,
	          id: mainContentId, 'data-apim-test': mainContentId
	        },
	        notificationMessage && _react2.default.createElement(_components.AlertMessages, {
	          id: notificationId, 'data-apim-test': notificationId,
	          variant: notificationStatus,
	          message: notificationMessage,
	          onClose: function onClose() {
	            setNotificationMessage('');
	            setNotificationStatus('');
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: classes.pageHeaderTitle, ref: pageHeaderRef },
	          pageHeaderTitle
	        ),
	        _react2.default.createElement(
	          _react.Fragment,
	          null,
	          pageContent
	        )
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        {
	          md: 3, item: true,
	          className: classes.rightSidebar,
	          id: rightSidebarId, 'data-apim-test': rightSidebarId
	        },
	        _react2.default.createElement(_components.HelpContainer, { helpItems: helpItems })
	      )
	    )
	  );
	};
	
	Edit.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  editPageId: _propTypes.string,
	  dialogId: _propTypes.string,
	  isDialogOpen: _propTypes.bool,
	  onDialogClose: _propTypes.func,
	  dialogSubmitText: _propTypes.string,
	  onDialogSubmit: _propTypes.func,
	  isLoading: _propTypes.bool,
	  leftSidebarId: _propTypes.string,
	  mainContentId: _propTypes.string,
	  notificationId: _propTypes.string,
	  notificationStatus: _propTypes.string,
	  setNotificationStatus: _propTypes.func,
	  notificationMessage: _propTypes.string,
	  setNotificationMessage: _propTypes.func,
	  tabsContainer: (0, _propTypes.shape)({}),
	  pageHeaderRef: (0, _propTypes.shape)({}),
	  pageHeaderTitle: _propTypes.string,
	  pageContent: (0, _propTypes.shape)({}),
	  rightSidebarId: _propTypes.string,
	  helpItems: (0, _propTypes.shape)({})
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_edit2.default))(Edit);

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEulas = exports.getDefaultSelectedUsers = exports.getSelectedUsers = exports.getSelectedManageOrg = exports.getPublisherOrganizations = exports.getIsApiManagementSaveSuccess = exports.getPolicyTemplates = exports.getCustomFields = exports.getUsage = exports.getAssets = exports.getIsApiTagAssocSaveSuccess = exports.getIsSaveApiSuccess = exports.getIsProxyUrlUnique = exports.getManagedGateways = exports.getIsApiNameUnique = exports.getAPISwaggerData = exports.getNewTags = exports.getAPITags = exports.getAllPortalTags = exports.getApiDetails = exports.getApiCanEditPermitted = exports.getApiPortalStatus = exports.getApiAccessStatus = exports.getErrors = exports.getIsError = exports.getUserContext = exports.getIsApiVisibilitySaveSuccess = exports.getSelectedOrganizations = exports.getOrganizationsPage = exports.getAllOrganizations = exports.getOrganizations = exports.getRedirectToDetailsPage = exports.getAvailableUsers = exports.getPermissionData = exports.getIsLoading = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.APP_LOADING:
	      return Object.assign({}, state, {
	        isLoading: action.isLoading,
	        isApiSaveSuccess: false,
	        errors: [],
	        isError: false
	      });
	    case constants.API_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        data: action.payload,
	        isError: false,
	        errors: []
	      });
	    case constants.API_PERMISSION_AVAILABLE_USER_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        availableUsers: action.payload,
	        isApiSaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.API_PERMISSION_SELECTED_USER_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        defaultSelectedUsers: [].concat(_toConsumableArray(action.payload)),
	        selectedUsers: action.payload,
	        isError: false,
	        isApiSaveSuccess: false,
	        errors: []
	      });
	    case constants.API_PERMISSION_SAVE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        isApiSaveSuccess: true,
	        apiDetails: (0, _responseParser.getParsedApiDetails)(action.payload),
	        errors: []
	      });
	    case constants.API_PERMISSION_ORGANIZATIONS_SUCCESS:
	      {
	        var orgs = state.organizations;
	        var payload = action.payload;
	        if ((0, _lodash.has)(payload, 'results') && (0, _lodash.has)(orgs, 'results')) {
	          payload.results = [].concat(_toConsumableArray(orgs.results), _toConsumableArray(action.payload.results));
	        }
	        return Object.assign({}, state, {
	          isLoading: false,
	          organizations: payload,
	          isError: false,
	          isApiSaveSuccess: false,
	          errors: []
	        });
	      }
	    case constants.API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS:
	      {
	        var _payload = action.payload;
	        return Object.assign({}, state, {
	          isLoading: false,
	          allOrganizations: _payload,
	          isError: false,
	          isApiSaveSuccess: false,
	          errors: []
	        });
	      }
	    case constants.API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        selectedOrganizations: action.payload,
	        isError: false,
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        selectedManageOrg: action.payload,
	        isError: false,
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        errors: action.payload,
	        isApiSaveSuccess: false
	      });
	    case constants.API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        message: action.message,
	        isApiSaveSuccess: true,
	        errors: [],
	        isError: false
	      });
	    case constants.API_PERMISSION_REDIRECT_API_TAB:
	      return Object.assign({}, state, {
	        isApiVisibilitySaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.API_GET_SUCCESS:
	      return Object.assign({}, state, {
	        apiDetails: (0, _responseParser.getParsedApiDetails)(action.payload),
	        errors: [],
	        isApiSaveSuccess: false,
	        isError: false
	      });
	    case constants.API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        isApiSaveSuccess: true,
	        errors: []
	      });
	    case constants.API_PERMISSION_PERMITTED_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        apiPermitted: action.payload,
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_PERMISSION_PERMITTED_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        apiPermitted: { canEdit: false },
	        errors: action.payload,
	        isApiSaveSuccess: false
	      });
	    case constants.API_TAGS_ALL_TAGS_REQUEST:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        allPortalTags: [],
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_TAGS_ALL_TAGS_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        allPortalTags: action.payload.data,
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_TAGS_API_TAGS_REQUEST:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        apiTags: [],
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_TAGS_API_TAGS_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        apiTags: action.payload.data,
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_SWAGGER_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        swaggerData: action.payload.data,
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_TAGS_CREATE_TAGS_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        newTags: action.payload.data,
	        errors: [],
	        isApiSaveSuccess: false
	      });
	    case constants.API_TAGS_ASSOCIATE_REQUEST:
	      return Object.assign({}, state, {
	        isLoading: true,
	        isError: false,
	        isApiSaveSuccess: false,
	        errors: []
	      });
	    case constants.API_TAGS_ASSOCIATE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        isApiSaveSuccess: true,
	        errors: []
	      });
	    case constants.API_USER_CONTEXTS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        userContext: action.payload
	      });
	    case constants.API_EULAS_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        eulas: action.payload,
	        isApiSaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.API_NAME_UNIQUE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        apiNameUnique: action.payload,
	        isApiSaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.API_ASSETS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        assets: action.payload.map(function (_ref) {
	          var name = _ref.name,
	              type = _ref.type,
	              uuid = _ref.uuid,
	              links = _ref.links;
	          return {
	            name: name, uuid: uuid, links: links, ext: type && type.toLowerCase()
	          };
	        }),
	        isApiSaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.API_USAGE_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        usage: action.payload,
	        isApiSaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.CUSTOM_FIELDS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        customFields: (0, _responseParser.getParsedCustomFields)((0, _lodash.get)(action, 'payload.d.results')),
	        isApiSaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.API_CUSTOM_FIELDS_SAVE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isApiSaveSuccess: true,
	        isError: false,
	        errors: []
	      });
	    case constants.POLICY_TEMPLATES_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        policyTemplate: action.payload,
	        isApiSaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.API_POLICY_TEMPLATES_SAVE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isApiSaveSuccess: true,
	        isError: false,
	        errors: []
	      });
	    case constants.API_PROXY_URL_UNIQUE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        proxyUrlUnique: action.payload,
	        isApiSaveSuccess: false,
	        isError: false,
	        errors: []
	      });
	    case constants.API_SAVE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        apiDetails: (0, _responseParser.getParsedApiDetails)(action.payload),
	        isError: false,
	        errors: [],
	        isApiSaveSuccess: true
	      });
	    case constants.API_PUBLISH_SAVE_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isLoading: false,
	          isError: false,
	          errors: [],
	          isApiSaveSuccess: true
	        });
	      }
	    case constants.API_UPDATE_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        errors: [],
	        isApiSaveSuccess: true
	      });
	    default:
	      return state;
	  }
	};
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _portalConfig = __webpack_require__(26);
	
	var _utils = __webpack_require__(18);
	
	var _responseParser = __webpack_require__(1702);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  isLoading: false,
	  isError: false,
	  selectedUsers: [],
	  defaultSelectedUsers: [],
	  availableUsers: [],
	  errors: [],
	  organizations: { results: [] },
	  selectedOrganizations: [],
	  allOrganizations: { results: [] },
	  userContext: {},
	  apiPermitted: { canEdit: true },
	  allPortalTags: [],
	  apiTags: [],
	  newTags: [],
	  swaggerData: {},
	  apiDetails: { accessStatus: 'PRIVATE' },
	  eulas: {},
	  apiNameUnique: { d: { result: true } },
	  assets: [],
	  usage: {},
	  customFields: [],
	  policyTemplate: { managedGateways: [], policyTemplates: [] },
	  proxyUrlUnique: { d: { result: true } },
	  isApiSaveSuccess: false,
	  selectedManageOrg: { name: '' }
	};
	
	var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
	  return (0, _lodash.get)(state, 'permissions.isLoading');
	};
	
	var getPermissionData = exports.getPermissionData = function getPermissionData(state) {
	  return (0, _lodash.get)(state, 'permissions.data');
	};
	
	var getAvailableUsers = exports.getAvailableUsers = function getAvailableUsers(state) {
	  return (0, _lodash.get)(state, 'permissions.availableUsers');
	};
	
	var getRedirectToDetailsPage = exports.getRedirectToDetailsPage = function getRedirectToDetailsPage(state) {
	  return (0, _lodash.get)(state, 'permissions.redirectToDetailsPage');
	};
	
	var getOrganizations = exports.getOrganizations = function getOrganizations(state) {
	  return (0, _lodash.get)(state, 'permissions.organizations.results');
	};
	
	var getAllOrganizations = exports.getAllOrganizations = function getAllOrganizations(state) {
	  return (0, _lodash.get)(state, 'permissions.allOrganizations.results');
	};
	
	var getOrganizationsPage = exports.getOrganizationsPage = function getOrganizationsPage(state) {
	  return (0, _lodash.get)(state, 'permissions.organizations');
	};
	
	var getSelectedOrganizations = exports.getSelectedOrganizations = function getSelectedOrganizations(state) {
	  return (0, _lodash.get)(state, 'permissions.selectedOrganizations');
	};
	
	var getIsApiVisibilitySaveSuccess = exports.getIsApiVisibilitySaveSuccess = function getIsApiVisibilitySaveSuccess(state) {
	  return (0, _lodash.get)(state, 'permissions.isApiVisibilitySaveSuccess');
	};
	
	var getUserContext = exports.getUserContext = function getUserContext(state) {
	  return (0, _lodash.get)(state, 'permissions.userContext');
	};
	
	var getIsError = exports.getIsError = function getIsError(state) {
	  return (0, _lodash.get)(state, 'permissions.isError');
	};
	
	var getErrors = exports.getErrors = function getErrors(state) {
	  return (0, _lodash.get)(state, 'permissions.errors');
	};
	
	var getApiAccessStatus = exports.getApiAccessStatus = function getApiAccessStatus(state) {
	  return (0, _lodash.get)(state, 'permissions.apiDetails.accessStatus');
	};
	
	var getApiPortalStatus = exports.getApiPortalStatus = function getApiPortalStatus(state) {
	  return (0, _lodash.get)(state, 'permissions.apiDetails.portalStatus');
	};
	
	var getApiCanEditPermitted = exports.getApiCanEditPermitted = function getApiCanEditPermitted(state) {
	  return (0, _lodash.get)(state, 'permissions.apiPermitted.canEdit');
	};
	
	var getApiDetails = exports.getApiDetails = function getApiDetails(state) {
	  return (0, _lodash.get)(state, 'permissions.apiDetails');
	};
	
	var getAllPortalTags = exports.getAllPortalTags = function getAllPortalTags(state) {
	  return (0, _lodash.get)(state, 'permissions.allPortalTags');
	};
	
	var getAPITags = exports.getAPITags = function getAPITags(state) {
	  return (0, _lodash.get)(state, 'permissions.apiTags');
	};
	
	var getNewTags = exports.getNewTags = function getNewTags(state) {
	  return (0, _lodash.get)(state, 'permissions.newTags');
	};
	
	var getAPISwaggerData = exports.getAPISwaggerData = function getAPISwaggerData(state) {
	  return (0, _lodash.get)(state, 'permissions.swaggerData');
	};
	
	var getIsApiNameUnique = exports.getIsApiNameUnique = function getIsApiNameUnique(state) {
	  return (0, _lodash.get)(state, 'permissions.apiNameUnique.d.result');
	};
	
	var getManagedGateways = exports.getManagedGateways = function getManagedGateways(state) {
	  return (0, _lodash.get)(state, 'permissions.policyTemplate.managedGateways');
	};
	
	var getIsProxyUrlUnique = exports.getIsProxyUrlUnique = function getIsProxyUrlUnique(state) {
	  return (0, _lodash.get)(state, 'permissions.proxyUrlUnique.d.result');
	};
	
	var getIsSaveApiSuccess = exports.getIsSaveApiSuccess = function getIsSaveApiSuccess(state) {
	  return (0, _lodash.get)(state, 'permissions.isApiSaveSuccess');
	};
	
	var getIsApiTagAssocSaveSuccess = exports.getIsApiTagAssocSaveSuccess = function getIsApiTagAssocSaveSuccess(state) {
	  return (0, _lodash.get)(state, 'permissions.isApiTagAssocSaveSuccess');
	};
	
	var getAssets = exports.getAssets = function getAssets(state) {
	  return (0, _lodash.get)(state, 'permissions.assets');
	};
	
	var getUsage = exports.getUsage = function getUsage(state) {
	  return (0, _lodash.get)(state, 'permissions.usage');
	};
	
	var getCustomFields = exports.getCustomFields = function getCustomFields(state) {
	  return (0, _lodash.get)(state, 'permissions.customFields');
	};
	
	var getPolicyTemplates = exports.getPolicyTemplates = function getPolicyTemplates(state) {
	  return (0, _lodash.get)(state, 'permissions.policyTemplate.policyTemplates');
	};
	
	var getIsApiManagementSaveSuccess = exports.getIsApiManagementSaveSuccess = function getIsApiManagementSaveSuccess(state) {
	  return (0, _lodash.get)(state, 'permissions.isApiManagementSaveSuccess');
	};
	
	var getPublisherOrganizations = exports.getPublisherOrganizations = function getPublisherOrganizations(state) {
	  return (0, _lodash.get)(state, 'permissions.organizations.results', []).filter(function (org) {
	    return org.type === 'PUBLISHER';
	  });
	};
	
	var getSelectedManageOrg = exports.getSelectedManageOrg = function getSelectedManageOrg(state) {
	  return (0, _lodash.get)(state, 'permissions.selectedManageOrg');
	};
	
	var getSelectedUsers = exports.getSelectedUsers = function getSelectedUsers(state) {
	  var userDetails = (0, _portalConfig.getUserDetails)(state);
	  var selectedUsers = (0, _lodash.get)(state, 'permissions.selectedUsers');
	  if (userDetails && userDetails.apiOwner) {
	    var isApiOwner = (0, _lodash.find)(selectedUsers, { uuid: userDetails.uuid });
	    // Add the apiowner by default when logged in user as apiOwner
	    if (!isApiOwner) {
	      selectedUsers.push((0, _utils.getApiOwnerUser)(userDetails));
	    }
	  }
	  return selectedUsers;
	};
	
	var getDefaultSelectedUsers = exports.getDefaultSelectedUsers = function getDefaultSelectedUsers(state) {
	  return (0, _lodash.get)(state, 'permissions.defaultSelectedUsers');
	};
	
	var getEulas = exports.getEulas = function getEulas(state) {
	  var results = (0, _lodash.get)(state, 'permissions.eulas.d.results') || [];
	  return (0, _lodash.map)(results, function (obj) {
	    return { uuid: obj.Uuid, name: obj.Name };
	  });
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsFormLoading = exports.getAccountPlans = exports.getOrganizationDetails = exports.getIsOrganizationNameUnique = exports.getOrganizationsListResults = exports.getOrganizationsListTotalElements = exports.getOrganizationsListTotalPages = exports.getIsFormSubmissionSuccessful = exports.getUpdateErrorMsg = exports.getIsFormUpdateError = exports.getCreateErrorMsg = exports.getIsFormCreateError = exports.getIsFormValidationError = exports.getIsFormLoadingError = exports.getIsListError = exports.getOrganizationListResults = exports.getOrganizationListTotalElements = exports.getErrors = exports.getIsError = exports.getIsLoading = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case Constants.APP_RESET:
	      return Object.assign({}, state, resetState);
	    case Constants.APP_LOADING:
	      return Object.assign({}, state, resetState, {
	        isLoading: action.isLoading
	      });
	    case Constants.ORGANIZATIONS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        errors: [],
	        organizations: action.payload
	      });
	    case Constants.ORGANIZATIONS_GET_ERROR:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: true,
	        errors: action.payload
	      });
	    case Constants.ORGANIZATION_LIST_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        organizations: action.payload
	      });
	    case Constants.ORGANIZATION_LIST_GET_ERROR:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isListError: true
	      });
	    case Constants.ORGANIZATION_GET_REQUEST:
	      return Object.assign({}, state, {
	        isFetchingOrganization: true
	      });
	    case Constants.ORGANIZATION_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isFetchingOrganization: false,
	        organizationDetails: action.payload
	      });
	    case Constants.ORGANIZATION_GET_ERROR:
	      return Object.assign({}, state, {
	        isFetchingOrganization: false,
	        isFormLoadingError: true
	      });
	    case Constants.ACCOUNTPLANS_GET_REQUEST:
	      return Object.assign({}, state, {
	        isFetchingAccountPlans: true
	      });
	    case Constants.ACCOUNTPLANS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isFetchingAccountPlans: false,
	        accountPlans: (0, _responseParser.getParsedAccountPlans)(action.payload.d.results)
	      });
	    case Constants.ACCOUNTPLANS_GET_ERROR:
	      return Object.assign({}, state, {
	        isFetchingAccountPlans: false,
	        isFormLoadingError: true
	      });
	    case Constants.ORGANIZATION_NAME_UNIQUE_REQUEST:
	      return Object.assign({}, state, {
	        organizationNameUnique: true
	      });
	    case Constants.ORGANIZATION_NAME_UNIQUE_SUCCESS:
	      return Object.assign({}, state, {
	        organizationNameUnique: action.payload.d.result
	      });
	    case Constants.ORGANIZATION_NAME_UNIQUE_ERROR:
	      return Object.assign({}, state, {
	        organizationNameUnique: false,
	        isFormValidationError: true
	      });
	    case Constants.ORGANIZATION_CREATE_REQUEST:
	      return Object.assign({}, state, {
	        isCreatingOrganization: true
	      });
	    case Constants.ORGANIZATION_CREATE_SUCCESS:
	      return Object.assign({}, state, {
	        isCreatingOrganization: false,
	        isFormSubmissionSuccessful: true,
	        organizationDetails: action.payload
	      });
	    case Constants.ORGANIZATION_CREATE_ERROR:
	      {
	        var createErrorMsg = getValidationErrorMessage(action.payload);
	        return Object.assign({}, state, {
	          isCreatingOrganization: false,
	          isCreateError: true
	        }, createErrorMsg ? { createErrorMsg: createErrorMsg } : {});
	      }
	    case Constants.ORGANIZATION_UPDATE_REQUEST:
	      return Object.assign({}, state, {
	        isUpdatingOrganization: true
	      });
	    case Constants.ORGANIZATION_UPDATE_SUCCESS:
	      return Object.assign({}, state, {
	        isUpdatingOrganization: false,
	        isFormSubmissionSuccessful: true,
	        organizationDetails: action.payload
	      });
	    case Constants.ORGANIZATION_UPDATE_ERROR:
	      {
	        var updateErrorMsg = getValidationErrorMessage(action.payload);
	        return Object.assign({}, state, {
	          isUpdatingOrganization: false,
	          isUpdateError: true
	        }, updateErrorMsg ? { updateErrorMsg: updateErrorMsg } : {});
	      }
	    default:
	      return state;
	  }
	};
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _responseParser = __webpack_require__(1705);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var resetState = {
	  isError: false,
	  errors: [],
	  isFormSubmissionSuccessful: false,
	  isCreateError: false,
	  createErrorMsg: '',
	  isUpdateError: false,
	  updateErrorMsg: '',
	  isFetchingAccountPlans: false,
	  isFetchingOrganization: false,
	  isCreatingOrganization: false,
	  isUpdatingOrganization: false
	};
	
	var initialState = Object.assign({}, resetState, {
	  isLoading: false,
	  isListError: false,
	  isFormLoadingError: false,
	  isFormValidationError: false,
	  isCreateError: false,
	  isUpdateError: false,
	  createErrorMsg: '',
	  updateErrorMsg: '',
	  isFetchingAccountPlans: false,
	  isFetchingOrganization: false,
	  isCreatingOrganization: false,
	  isUpdatingOrganization: false,
	  organizationNameUnique: true,
	  isFormSubmissionSuccessful: false,
	  organizations: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  }
	});
	
	var getValidationErrorMessage = function getValidationErrorMessage(payload) {
	  var validationErrors = (0, _lodash.get)(payload, 'error.detail.validationErrors', []);
	  var errorMsg = '';
	  if ((0, _lodash.isArray)(validationErrors)) {
	    validationErrors.forEach(function (item) {
	      errorMsg += item.error;
	    });
	  }
	  return errorMsg;
	};
	
	var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
	  return (0, _lodash.get)(state, 'organization.isLoading');
	};
	
	var getIsError = exports.getIsError = function getIsError(state) {
	  return (0, _lodash.get)(state, 'organization.isError');
	};
	var getErrors = exports.getErrors = function getErrors(state) {
	  return (0, _lodash.get)(state, 'organization.errors');
	};
	
	var getOrganizationListTotalElements = exports.getOrganizationListTotalElements = function getOrganizationListTotalElements(state) {
	  return (0, _lodash.get)(state, 'organization.organizations.totalElements');
	};
	var getOrganizationListResults = exports.getOrganizationListResults = function getOrganizationListResults(state) {
	  return (0, _lodash.get)(state, 'organization.organizations.results');
	};
	
	var getIsListError = exports.getIsListError = function getIsListError(state) {
	  return (0, _lodash.get)(state, 'organization.isListError');
	};
	var getIsFormLoadingError = exports.getIsFormLoadingError = function getIsFormLoadingError(state) {
	  return (0, _lodash.get)(state, 'organization.isFormLoadingError');
	};
	var getIsFormValidationError = exports.getIsFormValidationError = function getIsFormValidationError(state) {
	  return (0, _lodash.get)(state, 'organization.isFormValidationError');
	};
	
	var getIsFormCreateError = exports.getIsFormCreateError = function getIsFormCreateError(state) {
	  return (0, _lodash.get)(state, 'organization.isCreateError');
	};
	var getCreateErrorMsg = exports.getCreateErrorMsg = function getCreateErrorMsg(state) {
	  return (0, _lodash.get)(state, 'organization.createErrorMsg');
	};
	var getIsFormUpdateError = exports.getIsFormUpdateError = function getIsFormUpdateError(state) {
	  return (0, _lodash.get)(state, 'organization.isUpdateError');
	};
	var getUpdateErrorMsg = exports.getUpdateErrorMsg = function getUpdateErrorMsg(state) {
	  return (0, _lodash.get)(state, 'organization.updateErrorMsg');
	};
	
	var getIsFormSubmissionSuccessful = exports.getIsFormSubmissionSuccessful = function getIsFormSubmissionSuccessful(state) {
	  return (0, _lodash.get)(state, 'organization.isFormSubmissionSuccessful');
	};
	
	var getOrganizationsListTotalPages = exports.getOrganizationsListTotalPages = function getOrganizationsListTotalPages(state) {
	  return (0, _lodash.get)(state, 'organization.organizations.totalPages');
	};
	var getOrganizationsListTotalElements = exports.getOrganizationsListTotalElements = function getOrganizationsListTotalElements(state) {
	  return (0, _lodash.get)(state, 'organization.organizations.totalElements');
	};
	var getOrganizationsListResults = exports.getOrganizationsListResults = function getOrganizationsListResults(state) {
	  return (0, _lodash.get)(state, 'organization.organizations.results');
	};
	
	var getIsOrganizationNameUnique = exports.getIsOrganizationNameUnique = function getIsOrganizationNameUnique(state) {
	  return (0, _lodash.get)(state, 'organization.organizationNameUnique');
	};
	
	var getOrganizationDetails = exports.getOrganizationDetails = function getOrganizationDetails(state) {
	  return (0, _lodash.get)(state, 'organization.organizationDetails');
	};
	var getAccountPlans = exports.getAccountPlans = function getAccountPlans(state) {
	  return (0, _lodash.get)(state, 'organization.accountPlans');
	};
	
	var getIsFormLoading = exports.getIsFormLoading = function getIsFormLoading(state, isEditMode) {
	  return isEditMode ? (0, _lodash.get)(state, 'organization.isFetchingOrganization') || (0, _lodash.get)(state, 'organization.isFetchingAccountPlans') || (0, _lodash.get)(state, 'organization.isUpdatingOrganization') : (0, _lodash.get)(state, 'organization.isFetchingAccountPlans') || (0, _lodash.get)(state, 'organization.isCreatingOrganization');
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stringifyUrl = exports.debouncedAxiosGet = undefined;
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _queryString = __webpack_require__(100);
	
	var _constants = __webpack_require__(1557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debouncedAxiosGet = exports.debouncedAxiosGet = (0, _lodash.debounce)(function (url, options, _then, _catch) {
	  return _axios2.default.get(url, options).then(_then).catch(_catch);
	}, _constants.DEBOUNCE_DELAY);
	
	var stringifyUrl = exports.stringifyUrl = function stringifyUrl() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      url = _ref.url,
	      query = _ref.query,
	      options = _ref.options;
	
	  if (query) {
	    var params = (0, _queryString.stringify)(query, options);
	    return url + '?' + params;
	  }
	  return url;
	};
	
	exports.default = {};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDeploymentTypeLabel = exports.getApplicationStatusColor = exports.getApplicationStatusLabel = exports.getDeployedStatusColor = exports.getDeployedStatusLabel = undefined;
	
	var _reactIntl = __webpack_require__(16);
	
	var _changeCase = __webpack_require__(116);
	
	var _constants = __webpack_require__(14);
	
	var _intl = __webpack_require__(15);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getDeployedStatusLabel = exports.getDeployedStatusLabel = function getDeployedStatusLabel() {
	  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Not deployed';
	  return (0, _changeCase.sentenceCase)(status);
	};
	var getDeployedStatusColor = exports.getDeployedStatusColor = function getDeployedStatusColor() {
	  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Not deployed';
	
	  var deploymentStatus = status.toUpperCase();
	
	  var statusColor = '';
	  switch (deploymentStatus) {
	    case _constants.DEPLOYMENT_STATUS_DEPLOYED:
	      statusColor = '#5cb449';
	      break;
	    case _constants.DEPLOYMENT_STATUS_PENDING_DEPLOYMENT:
	      statusColor = '#845120';
	      break;
	    case _constants.DEPLOYMENT_STATUS_PENDING_UNDEPLOYMENT:
	      statusColor = '#845120';
	      break;
	    case _constants.DEPLOYMENT_STATUS_ERROR:
	      statusColor = '#d84332';
	      break;
	    case _constants.DEPLOYMENT_STATUS_ERROR_UNDEPLOY:
	      statusColor = '#d84332';
	      break;
	    case _constants.DEPLOYMENT_STATUS_NOT_DEPLOYED:
	      statusColor = '#677b87';
	      break;
	    default:
	      statusColor = '#677b87'; // Not deployed API
	      break;
	  }
	  return statusColor;
	};
	
	var getApplicationStatusLabel = exports.getApplicationStatusLabel = function getApplicationStatusLabel() {
	  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return (0, _changeCase.sentenceCase)(status);
	};
	
	var getApplicationStatusColor = exports.getApplicationStatusColor = function getApplicationStatusColor() {
	  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var greenStates = [_constants.APPLICATION_STATUS_ENABLED];
	  var grayStates = [_constants.APPLICATION_STATUS_DISABLED];
	  var orangeStates = [_constants.APPLICATION_STATUS_PENDING_APPROVAL, _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL];
	  // red for APPLICATION_STATUS_REJECTED (endpoint doesn't return Application with this state)
	  var statusColor = '#d84332';
	  var applicationStatus = status.toUpperCase();
	  if (greenStates.includes(applicationStatus)) {
	    statusColor = '#59bb52';
	  } else if (orangeStates.includes(applicationStatus)) {
	    statusColor = '#f7922f';
	  } else if (grayStates.includes(applicationStatus)) {
	    statusColor = '#b3bdc2';
	  }
	  return statusColor;
	};
	
	var getDeploymentTypeLabel = exports.getDeploymentTypeLabel = function getDeploymentTypeLabel(deploymentType) {
	  var _DEPLOYMENT_TYPE_TO_L;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var DEPLOYMENT_TYPE_TO_LABEL = (_DEPLOYMENT_TYPE_TO_L = {}, _defineProperty(_DEPLOYMENT_TYPE_TO_L, _constants.PROXY_DEPLOYMENT_TYPE_AUTOMATIC, intl.getI18nMessage('label.proxy.details.page.overview.deployment.type.automatic')), _defineProperty(_DEPLOYMENT_TYPE_TO_L, _constants.PROXY_DEPLOYMENT_TYPE_ON_DEMAND, intl.getI18nMessage('label.proxy.details.page.overview.deployment.type.on.demand')), _defineProperty(_DEPLOYMENT_TYPE_TO_L, _constants.PROXY_DEPLOYMENT_TYPE_SCRIPTED, intl.getI18nMessage('label.proxy.details.page.overview.deployment.type.scripted')), _DEPLOYMENT_TYPE_TO_L);
	  return DEPLOYMENT_TYPE_TO_LABEL[deploymentType];
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _memoizeOne = _interopRequireDefault(__webpack_require__(454));
	
	var _Menu = __webpack_require__(287);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(638));
	
	var _filters = __webpack_require__(637);
	
	var _index = __webpack_require__(1736);
	
	var _index2 = __webpack_require__(1719);
	
	var _utils = __webpack_require__(208);
	
	var _builtins = __webpack_require__(1726);
	
	var _index3 = __webpack_require__(288);
	
	var _styles = __webpack_require__(639);
	
	var _theme = __webpack_require__(640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  backspaceRemovesValue: true,
	  blurInputOnSelect: (0, _utils.isTouchCapable)(),
	  captureMenuScroll: !(0, _utils.isTouchCapable)(),
	  closeMenuOnSelect: true,
	  closeMenuOnScroll: false,
	  components: {},
	  controlShouldRenderValue: true,
	  escapeClearsValue: false,
	  filterOption: (0, _filters.createFilter)(),
	  formatGroupLabel: _builtins.formatGroupLabel,
	  getOptionLabel: _builtins.getOptionLabel,
	  getOptionValue: _builtins.getOptionValue,
	  isDisabled: false,
	  isLoading: false,
	  isMulti: false,
	  isRtl: false,
	  isSearchable: true,
	  isOptionDisabled: _builtins.isOptionDisabled,
	  loadingMessage: function loadingMessage() {
	    return 'Loading...';
	  },
	  maxMenuHeight: 300,
	  minMenuHeight: 140,
	  menuIsOpen: false,
	  menuPlacement: 'bottom',
	  menuPosition: 'absolute',
	  menuShouldBlockScroll: false,
	  menuShouldScrollIntoView: !(0, _utils.isMobileDevice)(),
	  noOptionsMessage: function noOptionsMessage() {
	    return 'No options';
	  },
	  openMenuOnFocus: false,
	  openMenuOnClick: true,
	  options: [],
	  pageSize: 5,
	  placeholder: 'Select...',
	  screenReaderStatus: function screenReaderStatus(_ref) {
	    var count = _ref.count;
	    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
	  },
	  styles: {},
	  tabIndex: '0',
	  tabSelectsValue: true
	};
	exports.defaultProps = defaultProps;
	var instanceId = 1;
	
	var Select =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Select, _Component);
	
	  // Misc. Instance Properties
	  // ------------------------------
	  // TODO
	  // Refs
	  // ------------------------------
	  // Lifecycle
	  // ------------------------------
	  function Select(_props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      ariaLiveSelection: '',
	      ariaLiveContext: '',
	      focusedOption: null,
	      focusedValue: null,
	      inputIsHidden: false,
	      isFocused: false,
	      menuOptions: {
	        render: [],
	        focusable: []
	      },
	      selectValue: []
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isComposing", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
	      _this.controlRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
	      _this.focusedOptionRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
	      _this.menuListRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
	      _this.inputRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components) {
	      _this.components = (0, _index3.defaultComponents)({
	        components: components
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          name = _this$props.name;
	      onChange(newValue, _objectSpread({}, actionMeta, {
	        name: name
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
	      var option = arguments.length > 2 ? arguments[2] : undefined;
	      var _this$props2 = _this.props,
	          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
	          isMulti = _this$props2.isMulti;
	
	      _this.onInputChange('', {
	        action: 'set-value'
	      });
	
	      if (closeMenuOnSelect) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } // when the select value should change, we should reset focusedValue
	
	
	      _this.clearFocusValueOnUpdate = true;
	
	      _this.onChange(newValue, {
	        action: action,
	        option: option
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
	      var _this$props3 = _this.props,
	          blurInputOnSelect = _this$props3.blurInputOnSelect,
	          isMulti = _this$props3.isMulti;
	      var selectValue = _this.state.selectValue;
	
	      if (isMulti) {
	        if (_this.isOptionSelected(newValue, selectValue)) {
	          var candidate = _this.getOptionValue(newValue);
	
	          _this.setValue(selectValue.filter(function (i) {
	            return _this.getOptionValue(i) !== candidate;
	          }), 'deselect-option', newValue);
	
	          _this.announceAriaLiveSelection({
	            event: 'deselect-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          if (!_this.isOptionDisabled(newValue, selectValue)) {
	            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);
	
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue)
	              }
	            });
	          } else {
	            // announce that option is disabled
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue),
	                isDisabled: true
	              }
	            });
	          }
	        }
	      } else {
	        if (!_this.isOptionDisabled(newValue, selectValue)) {
	          _this.setValue(newValue, 'select-option');
	
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          // announce that option is disabled
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue),
	              isDisabled: true
	            }
	          });
	        }
	      }
	
	      if (blurInputOnSelect) {
	        _this.blurInput();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
	      var selectValue = _this.state.selectValue;
	
	      var candidate = _this.getOptionValue(removedValue);
	
	      _this.onChange(selectValue.filter(function (i) {
	        return _this.getOptionValue(i) !== candidate;
	      }), {
	        action: 'remove-value',
	        removedValue: removedValue
	      });
	
	      _this.announceAriaLiveSelection({
	        event: 'remove-value',
	        context: {
	          value: removedValue ? _this.getOptionLabel(removedValue) : ''
	        }
	      });
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
	      var isMulti = _this.props.isMulti;
	
	      _this.onChange(isMulti ? [] : null, {
	        action: 'clear'
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
	      var selectValue = _this.state.selectValue;
	      var lastSelectedValue = selectValue[selectValue.length - 1];
	
	      _this.announceAriaLiveSelection({
	        event: 'pop-value',
	        context: {
	          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
	        }
	      });
	
	      _this.onChange(selectValue.slice(0, selectValue.length - 1), {
	        action: 'pop-value',
	        removedValue: lastSelectedValue
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
	      return _this.props.getOptionLabel(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
	      return _this.props.getOptionValue(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
	      var base = _styles.defaultStyles[key](props);
	
	      base.boxSizing = 'border-box';
	      var custom = _this.props.styles[key];
	      return custom ? custom(base, props) : base;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
	      return "".concat(_this.instancePrefix, "-").concat(element);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
	      var menuIsOpen = _this.props.menuIsOpen;
	      var _this$state = _this.state,
	          menuOptions = _this$state.menuOptions,
	          focusedOption = _this$state.focusedOption;
	      if (!focusedOption || !menuIsOpen) return undefined;
	      var index = menuOptions.focusable.indexOf(focusedOption);
	      var option = menuOptions.render[index];
	      return option && option.key;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
	      var event = _ref2.event,
	          context = _ref2.context;
	
	      _this.setState({
	        ariaLiveSelection: (0, _index2.valueEventAriaMessage)(event, context)
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
	      var event = _ref3.event,
	          context = _ref3.context;
	
	      _this.setState({
	        ariaLiveContext: (0, _index2.instructionsAriaMessage)(event, _objectSpread({}, context, {
	          label: _this.props['aria-label']
	        }))
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
	      if (event.button !== 0) {
	        return;
	      }
	
	      event.stopPropagation();
	      event.preventDefault();
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
	      _this.blockOptionHover = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
	      var openMenuOnClick = _this.props.openMenuOnClick;
	
	      if (!_this.state.isFocused) {
	        if (openMenuOnClick) {
	          _this.openAfterFocus = true;
	        }
	
	        _this.focusInput();
	      } else if (!_this.props.menuIsOpen) {
	        if (openMenuOnClick) {
	          _this.openMenu('first');
	        }
	      } else {
	        //$FlowFixMe
	        if (event.target.tagName !== 'INPUT') {
	          _this.onMenuClose();
	        }
	      } //$FlowFixMe
	
	
	      if (event.target.tagName !== 'INPUT') {
	        event.preventDefault();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      if (_this.props.isDisabled) return;
	      var _this$props4 = _this.props,
	          isMulti = _this$props4.isMulti,
	          menuIsOpen = _this$props4.menuIsOpen;
	
	      _this.focusInput();
	
	      if (menuIsOpen) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } else {
	        _this.openMenu('first');
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      _this.clearValue();
	
	      event.stopPropagation();
	      _this.openAfterFocus = false;
	      setTimeout(function () {
	        return _this.focusInput();
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
	      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
	        if (event.target instanceof HTMLElement && (0, _utils.isDocumentElement)(event.target)) {
	          _this.props.onMenuClose();
	        }
	      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
	        if (_this.props.closeMenuOnScroll(event)) {
	          _this.props.onMenuClose();
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
	      _this.isComposing = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
	      _this.isComposing = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
	      var touches = _ref4.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      _this.initialTouchX = touch.clientX;
	      _this.initialTouchY = touch.clientY;
	      _this.userIsDragging = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
	      var touches = _ref5.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
	      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
	      var moveThreshold = 5;
	      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
	      if (_this.userIsDragging) return; // close the menu if the user taps outside
	      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
	      // on events on child elements, not the document (which we've attached this handler to).
	
	      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
	        _this.blurInput();
	      } // reset move vars
	
	
	      _this.initialTouchX = 0;
	      _this.initialTouchY = 0;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onControlMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onClearIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onDropdownIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
	      var inputValue = event.currentTarget.value;
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.onInputChange(inputValue, {
	        action: 'input-change'
	      });
	
	      _this.onMenuOpen();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
	      var _this$props5 = _this.props,
	          isSearchable = _this$props5.isSearchable,
	          isMulti = _this$props5.isMulti;
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	
	      _this.setState({
	        isFocused: true
	      });
	
	      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
	        _this.openMenu('first');
	      }
	
	      _this.openAfterFocus = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
	      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
	        _this.inputRef.focus();
	
	        return;
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      _this.onInputChange('', {
	        action: 'input-blur'
	      });
	
	      _this.onMenuClose();
	
	      _this.setState({
	        focusedValue: null,
	        isFocused: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
	      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
	        return;
	      }
	
	      _this.setState({
	        focusedOption: focusedOption
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
	      var _this$props6 = _this.props,
	          hideSelectedOptions = _this$props6.hideSelectedOptions,
	          isMulti = _this$props6.isMulti;
	      if (hideSelectedOptions === undefined) return isMulti;
	      return hideSelectedOptions;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
	      var _this$props7 = _this.props,
	          isMulti = _this$props7.isMulti,
	          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
	          escapeClearsValue = _this$props7.escapeClearsValue,
	          inputValue = _this$props7.inputValue,
	          isClearable = _this$props7.isClearable,
	          isDisabled = _this$props7.isDisabled,
	          menuIsOpen = _this$props7.menuIsOpen,
	          onKeyDown = _this$props7.onKeyDown,
	          tabSelectsValue = _this$props7.tabSelectsValue,
	          openMenuOnFocus = _this$props7.openMenuOnFocus;
	      var _this$state2 = _this.state,
	          focusedOption = _this$state2.focusedOption,
	          focusedValue = _this$state2.focusedValue,
	          selectValue = _this$state2.selectValue;
	      if (isDisabled) return;
	
	      if (typeof onKeyDown === 'function') {
	        onKeyDown(event);
	
	        if (event.defaultPrevented) {
	          return;
	        }
	      } // Block option hover events when the user has just pressed a key
	
	
	      _this.blockOptionHover = true;
	
	      switch (event.key) {
	        case 'ArrowLeft':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('previous');
	
	          break;
	
	        case 'ArrowRight':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('next');
	
	          break;
	
	        case 'Delete':
	        case 'Backspace':
	          if (inputValue) return;
	
	          if (focusedValue) {
	            _this.removeValue(focusedValue);
	          } else {
	            if (!backspaceRemovesValue) return;
	
	            if (isMulti) {
	              _this.popValue();
	            } else if (isClearable) {
	              _this.clearValue();
	            }
	          }
	
	          break;
	
	        case 'Tab':
	          if (_this.isComposing) return;
	
	          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
	          // option is already selected; it breaks the flow of navigation
	          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
	            return;
	          }
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'Enter':
	          if (event.keyCode === 229) {
	            // ignore the keydown event from an Input Method Editor(IME)
	            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
	            break;
	          }
	
	          if (menuIsOpen) {
	            if (!focusedOption) return;
	            if (_this.isComposing) return;
	
	            _this.selectOption(focusedOption);
	
	            break;
	          }
	
	          return;
	
	        case 'Escape':
	          if (menuIsOpen) {
	            _this.inputIsHiddenAfterUpdate = false;
	
	            _this.onInputChange('', {
	              action: 'menu-close'
	            });
	
	            _this.onMenuClose();
	          } else if (isClearable && escapeClearsValue) {
	            _this.clearValue();
	          }
	
	          break;
	
	        case ' ':
	          // space
	          if (inputValue) {
	            return;
	          }
	
	          if (!menuIsOpen) {
	            _this.openMenu('first');
	
	            break;
	          }
	
	          if (!focusedOption) return;
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'ArrowUp':
	          if (menuIsOpen) {
	            _this.focusOption('up');
	          } else {
	            _this.openMenu('last');
	          }
	
	          break;
	
	        case 'ArrowDown':
	          if (menuIsOpen) {
	            _this.focusOption('down');
	          } else {
	            _this.openMenu('first');
	          }
	
	          break;
	
	        case 'PageUp':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pageup');
	
	          break;
	
	        case 'PageDown':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pagedown');
	
	          break;
	
	        case 'Home':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('first');
	
	          break;
	
	        case 'End':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('last');
	
	          break;
	
	        default:
	          return;
	      }
	
	      event.preventDefault();
	    });
	
	    var value = _props.value;
	    _this.cacheComponents = (0, _memoizeOne.default)(_this.cacheComponents, _reactFastCompare.default).bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    _this.cacheComponents(_props.components);
	
	    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
	
	    var _selectValue = (0, _utils.cleanValue)(value);
	
	    var _menuOptions = _this.buildMenuOptions(_props, _selectValue);
	
	    _this.state.menuOptions = _menuOptions;
	    _this.state.selectValue = _selectValue;
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListeningComposition();
	      this.startListeningToTouch();
	
	      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
	        // Listen to all scroll events, and filter them out inside of 'onScroll'
	        document.addEventListener('scroll', this.onScroll, true);
	      }
	
	      if (this.props.autoFocus) {
	        this.focusInput();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props8 = this.props,
	          options = _this$props8.options,
	          value = _this$props8.value,
	          inputValue = _this$props8.inputValue; // re-cache custom components
	
	      this.cacheComponents(nextProps.components); // rebuild the menu options
	
	      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
	        var selectValue = (0, _utils.cleanValue)(nextProps.value);
	        var menuOptions = this.buildMenuOptions(nextProps, selectValue);
	        var focusedValue = this.getNextFocusedValue(selectValue);
	        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
	        this.setState({
	          menuOptions: menuOptions,
	          selectValue: selectValue,
	          focusedOption: focusedOption,
	          focusedValue: focusedValue
	        });
	      } // some updates should toggle the state of the input visibility
	
	
	      if (this.inputIsHiddenAfterUpdate != null) {
	        this.setState({
	          inputIsHidden: this.inputIsHiddenAfterUpdate
	        });
	        delete this.inputIsHiddenAfterUpdate;
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props9 = this.props,
	          isDisabled = _this$props9.isDisabled,
	          menuIsOpen = _this$props9.menuIsOpen;
	      var isFocused = this.state.isFocused;
	
	      if ( // ensure focus is restored correctly when the control becomes enabled
	      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
	      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
	        this.focusInput();
	      } // scroll the focused option into view if necessary
	
	
	      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
	        (0, _utils.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
	      }
	
	      this.scrollToFocusedOptionOnUpdate = false;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListeningComposition();
	      this.stopListeningToTouch();
	      document.removeEventListener('scroll', this.onScroll, true);
	    }
	  }, {
	    key: "onMenuOpen",
	    // ==============================
	    // Consumer Handlers
	    // ==============================
	    value: function onMenuOpen() {
	      this.props.onMenuOpen();
	    }
	  }, {
	    key: "onMenuClose",
	    value: function onMenuClose() {
	      var _this$props10 = this.props,
	          isSearchable = _this$props10.isSearchable,
	          isMulti = _this$props10.isMulti;
	      this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	      this.onInputChange('', {
	        action: 'menu-close'
	      });
	      this.props.onMenuClose();
	    }
	  }, {
	    key: "onInputChange",
	    value: function onInputChange(newValue, actionMeta) {
	      this.props.onInputChange(newValue, actionMeta);
	    } // ==============================
	    // Methods
	    // ==============================
	
	  }, {
	    key: "focusInput",
	    value: function focusInput() {
	      if (!this.inputRef) return;
	      this.inputRef.focus();
	    }
	  }, {
	    key: "blurInput",
	    value: function blurInput() {
	      if (!this.inputRef) return;
	      this.inputRef.blur();
	    } // aliased for consumers
	
	  }, {
	    key: "openMenu",
	    value: function openMenu(focusOption) {
	      var _this$state3 = this.state,
	          menuOptions = _this$state3.menuOptions,
	          selectValue = _this$state3.selectValue,
	          isFocused = _this$state3.isFocused;
	      var isMulti = this.props.isMulti;
	      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
	
	      if (!isMulti) {
	        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
	
	        if (selectedIndex > -1) {
	          openAtIndex = selectedIndex;
	        }
	      } // only scroll if the menu isn't already open
	
	
	      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
	      this.inputIsHiddenAfterUpdate = false;
	      this.onMenuOpen();
	      this.setState({
	        focusedValue: null,
	        focusedOption: menuOptions.focusable[openAtIndex]
	      });
	      this.announceAriaLiveContext({
	        event: 'menu'
	      });
	    }
	  }, {
	    key: "focusValue",
	    value: function focusValue(direction) {
	      var _this$props11 = this.props,
	          isMulti = _this$props11.isMulti,
	          isSearchable = _this$props11.isSearchable;
	      var _this$state4 = this.state,
	          selectValue = _this$state4.selectValue,
	          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
	
	      if (!isMulti) return;
	      this.setState({
	        focusedOption: null
	      });
	      var focusedIndex = selectValue.indexOf(focusedValue);
	
	      if (!focusedValue) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'value'
	        });
	      }
	
	      var lastIndex = selectValue.length - 1;
	      var nextFocus = -1;
	      if (!selectValue.length) return;
	
	      switch (direction) {
	        case 'previous':
	          if (focusedIndex === 0) {
	            // don't cycle from the start to the end
	            nextFocus = 0;
	          } else if (focusedIndex === -1) {
	            // if nothing is focused, focus the last value first
	            nextFocus = lastIndex;
	          } else {
	            nextFocus = focusedIndex - 1;
	          }
	
	          break;
	
	        case 'next':
	          if (focusedIndex > -1 && focusedIndex < lastIndex) {
	            nextFocus = focusedIndex + 1;
	          }
	
	          break;
	      }
	
	      if (nextFocus === -1) {
	        this.announceAriaLiveContext({
	          event: 'input',
	          context: {
	            isSearchable: isSearchable,
	            isMulti: isMulti
	          }
	        });
	      }
	
	      this.setState({
	        inputIsHidden: nextFocus === -1 ? false : true,
	        focusedValue: selectValue[nextFocus]
	      });
	    }
	  }, {
	    key: "focusOption",
	    value: function focusOption() {
	      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
	      var pageSize = this.props.pageSize;
	      var _this$state5 = this.state,
	          focusedOption = _this$state5.focusedOption,
	          menuOptions = _this$state5.menuOptions;
	      var options = menuOptions.focusable;
	      if (!options.length) return;
	      var nextFocus = 0; // handles 'first'
	
	      var focusedIndex = options.indexOf(focusedOption);
	
	      if (!focusedOption) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'menu'
	        });
	      }
	
	      if (direction === 'up') {
	        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
	      } else if (direction === 'down') {
	        nextFocus = (focusedIndex + 1) % options.length;
	      } else if (direction === 'pageup') {
	        nextFocus = focusedIndex - pageSize;
	        if (nextFocus < 0) nextFocus = 0;
	      } else if (direction === 'pagedown') {
	        nextFocus = focusedIndex + pageSize;
	        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
	      } else if (direction === 'last') {
	        nextFocus = options.length - 1;
	      }
	
	      this.scrollToFocusedOptionOnUpdate = true;
	      this.setState({
	        focusedOption: options[nextFocus],
	        focusedValue: null
	      });
	      this.announceAriaLiveContext({
	        event: 'menu',
	        context: {
	          isDisabled: (0, _builtins.isOptionDisabled)(options[nextFocus])
	        }
	      });
	    }
	  }, {
	    key: "getTheme",
	    // ==============================
	    // Getters
	    // ==============================
	    value: function getTheme() {
	      // Use the default theme if there are no customizations.
	      if (!this.props.theme) {
	        return _theme.defaultTheme;
	      } // If the theme prop is a function, assume the function
	      // knows how to merge the passed-in default theme with
	      // its own modifications.
	
	
	      if (typeof this.props.theme === 'function') {
	        return this.props.theme(_theme.defaultTheme);
	      } // Otherwise, if a plain theme object was passed in,
	      // overlay it with the default theme.
	
	
	      return _objectSpread({}, _theme.defaultTheme, this.props.theme);
	    }
	  }, {
	    key: "getCommonProps",
	    value: function getCommonProps() {
	      var clearValue = this.clearValue,
	          getStyles = this.getStyles,
	          setValue = this.setValue,
	          selectOption = this.selectOption,
	          props = this.props;
	      var classNamePrefix = props.classNamePrefix,
	          isMulti = props.isMulti,
	          isRtl = props.isRtl,
	          options = props.options;
	      var selectValue = this.state.selectValue;
	      var hasValue = this.hasValue();
	
	      var getValue = function getValue() {
	        return selectValue;
	      };
	
	      var cx = _utils.classNames.bind(null, classNamePrefix);
	
	      return {
	        cx: cx,
	        clearValue: clearValue,
	        getStyles: getStyles,
	        getValue: getValue,
	        hasValue: hasValue,
	        isMulti: isMulti,
	        isRtl: isRtl,
	        options: options,
	        selectOption: selectOption,
	        setValue: setValue,
	        selectProps: props,
	        theme: this.getTheme()
	      };
	    }
	  }, {
	    key: "getNextFocusedValue",
	    value: function getNextFocusedValue(nextSelectValue) {
	      if (this.clearFocusValueOnUpdate) {
	        this.clearFocusValueOnUpdate = false;
	        return null;
	      }
	
	      var _this$state6 = this.state,
	          focusedValue = _this$state6.focusedValue,
	          lastSelectValue = _this$state6.selectValue;
	      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
	
	      if (lastFocusedIndex > -1) {
	        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
	
	        if (nextFocusedIndex > -1) {
	          // the focused value is still in the selectValue, return it
	          return focusedValue;
	        } else if (lastFocusedIndex < nextSelectValue.length) {
	          // the focusedValue is not present in the next selectValue array by
	          // reference, so return the new value at the same index
	          return nextSelectValue[lastFocusedIndex];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getNextFocusedOption",
	    value: function getNextFocusedOption(options) {
	      var lastFocusedOption = this.state.focusedOption;
	      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
	    }
	  }, {
	    key: "hasValue",
	    value: function hasValue() {
	      var selectValue = this.state.selectValue;
	      return selectValue.length > 0;
	    }
	  }, {
	    key: "hasOptions",
	    value: function hasOptions() {
	      return !!this.state.menuOptions.render.length;
	    }
	  }, {
	    key: "countOptions",
	    value: function countOptions() {
	      return this.state.menuOptions.focusable.length;
	    }
	  }, {
	    key: "isClearable",
	    value: function isClearable() {
	      var _this$props12 = this.props,
	          isClearable = _this$props12.isClearable,
	          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
	      // multi select, by default, IS clearable
	
	      if (isClearable === undefined) return isMulti;
	      return isClearable;
	    }
	  }, {
	    key: "isOptionDisabled",
	    value: function isOptionDisabled(option, selectValue) {
	      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
	    }
	  }, {
	    key: "isOptionSelected",
	    value: function isOptionSelected(option, selectValue) {
	      var _this2 = this;
	
	      if (selectValue.indexOf(option) > -1) return true;
	
	      if (typeof this.props.isOptionSelected === 'function') {
	        return this.props.isOptionSelected(option, selectValue);
	      }
	
	      var candidate = this.getOptionValue(option);
	      return selectValue.some(function (i) {
	        return _this2.getOptionValue(i) === candidate;
	      });
	    }
	  }, {
	    key: "filterOption",
	    value: function filterOption(option, inputValue) {
	      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
	    }
	  }, {
	    key: "formatOptionLabel",
	    value: function formatOptionLabel(data, context) {
	      if (typeof this.props.formatOptionLabel === 'function') {
	        var inputValue = this.props.inputValue;
	        var selectValue = this.state.selectValue;
	        return this.props.formatOptionLabel(data, {
	          context: context,
	          inputValue: inputValue,
	          selectValue: selectValue
	        });
	      } else {
	        return this.getOptionLabel(data);
	      }
	    }
	  }, {
	    key: "formatGroupLabel",
	    value: function formatGroupLabel(data) {
	      return this.props.formatGroupLabel(data);
	    } // ==============================
	    // Mouse Handlers
	    // ==============================
	
	  }, {
	    key: "startListeningComposition",
	    // ==============================
	    // Composition Handlers
	    // ==============================
	    value: function startListeningComposition() {
	      if (document && document.addEventListener) {
	        document.addEventListener('compositionstart', this.onCompositionStart, false);
	        document.addEventListener('compositionend', this.onCompositionEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningComposition",
	    value: function stopListeningComposition() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('compositionstart', this.onCompositionStart);
	        document.removeEventListener('compositionend', this.onCompositionEnd);
	      }
	    }
	  }, {
	    key: "startListeningToTouch",
	    // ==============================
	    // Touch Handlers
	    // ==============================
	    value: function startListeningToTouch() {
	      if (document && document.addEventListener) {
	        document.addEventListener('touchstart', this.onTouchStart, false);
	        document.addEventListener('touchmove', this.onTouchMove, false);
	        document.addEventListener('touchend', this.onTouchEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningToTouch",
	    value: function stopListeningToTouch() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('touchstart', this.onTouchStart);
	        document.removeEventListener('touchmove', this.onTouchMove);
	        document.removeEventListener('touchend', this.onTouchEnd);
	      }
	    }
	  }, {
	    key: "buildMenuOptions",
	    // ==============================
	    // Menu Options
	    // ==============================
	    value: function buildMenuOptions(props, selectValue) {
	      var _this3 = this;
	
	      var _props$inputValue = props.inputValue,
	          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
	          options = props.options;
	
	      var toOption = function toOption(option, id) {
	        var isDisabled = _this3.isOptionDisabled(option, selectValue);
	
	        var isSelected = _this3.isOptionSelected(option, selectValue);
	
	        var label = _this3.getOptionLabel(option);
	
	        var value = _this3.getOptionValue(option);
	
	        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
	          label: label,
	          value: value,
	          data: option
	        }, inputValue)) {
	          return;
	        }
	
	        var onHover = isDisabled ? undefined : function () {
	          return _this3.onOptionHover(option);
	        };
	        var onSelect = isDisabled ? undefined : function () {
	          return _this3.selectOption(option);
	        };
	        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
	        return {
	          innerProps: {
	            id: optionId,
	            onClick: onSelect,
	            onMouseMove: onHover,
	            onMouseOver: onHover,
	            tabIndex: -1
	          },
	          data: option,
	          isDisabled: isDisabled,
	          isSelected: isSelected,
	          key: optionId,
	          label: label,
	          type: 'option',
	          value: value
	        };
	      };
	
	      return options.reduce(function (acc, item, itemIndex) {
	        if (item.options) {
	          // TODO needs a tidier implementation
	          if (!_this3.hasGroups) _this3.hasGroups = true;
	          var items = item.options;
	          var children = items.map(function (child, i) {
	            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
	            if (option) acc.focusable.push(child);
	            return option;
	          }).filter(Boolean);
	
	          if (children.length) {
	            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
	            acc.render.push({
	              type: 'group',
	              key: groupId,
	              data: item,
	              options: children
	            });
	          }
	        } else {
	          var option = toOption(item, "".concat(itemIndex));
	
	          if (option) {
	            acc.render.push(option);
	            acc.focusable.push(item);
	          }
	        }
	
	        return acc;
	      }, {
	        render: [],
	        focusable: []
	      });
	    } // ==============================
	    // Renderers
	    // ==============================
	
	  }, {
	    key: "constructAriaLiveMessage",
	    value: function constructAriaLiveMessage() {
	      var _this$state7 = this.state,
	          ariaLiveContext = _this$state7.ariaLiveContext,
	          selectValue = _this$state7.selectValue,
	          focusedValue = _this$state7.focusedValue,
	          focusedOption = _this$state7.focusedOption;
	      var _this$props13 = this.props,
	          options = _this$props13.options,
	          menuIsOpen = _this$props13.menuIsOpen,
	          inputValue = _this$props13.inputValue,
	          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.
	
	      var focusedValueMsg = focusedValue ? (0, _index2.valueFocusAriaMessage)({
	        focusedValue: focusedValue,
	        getOptionLabel: this.getOptionLabel,
	        selectValue: selectValue
	      }) : ''; // An aria live message representing the currently focused option in the select.
	
	      var focusedOptionMsg = focusedOption && menuIsOpen ? (0, _index2.optionFocusAriaMessage)({
	        focusedOption: focusedOption,
	        getOptionLabel: this.getOptionLabel,
	        options: options
	      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
	
	      var resultsMsg = (0, _index2.resultsAriaMessage)({
	        inputValue: inputValue,
	        screenReaderMessage: screenReaderStatus({
	          count: this.countOptions()
	        })
	      });
	      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      var _this$props14 = this.props,
	          isDisabled = _this$props14.isDisabled,
	          isSearchable = _this$props14.isSearchable,
	          inputId = _this$props14.inputId,
	          inputValue = _this$props14.inputValue,
	          tabIndex = _this$props14.tabIndex;
	      var Input = this.components.Input;
	      var inputIsHidden = this.state.inputIsHidden;
	      var id = inputId || this.getElementId('input');
	
	      if (!isSearchable) {
	        // use a dummy input to maintain focus/blur functionality
	        return _react.default.createElement(_index.DummyInput, {
	          id: id,
	          innerRef: this.getInputRef,
	          onBlur: this.onInputBlur,
	          onChange: _utils.noop,
	          onFocus: this.onInputFocus,
	          readOnly: true,
	          disabled: isDisabled,
	          tabIndex: tabIndex,
	          value: ""
	        });
	      } // aria attributes makes the JSX "noisy", separated for clarity
	
	
	      var ariaAttributes = {
	        'aria-autocomplete': 'list',
	        'aria-label': this.props['aria-label'],
	        'aria-labelledby': this.props['aria-labelledby']
	      };
	      var _this$commonProps = this.commonProps,
	          cx = _this$commonProps.cx,
	          theme = _this$commonProps.theme,
	          selectProps = _this$commonProps.selectProps;
	      return _react.default.createElement(Input, _extends({
	        autoCapitalize: "none",
	        autoComplete: "off",
	        autoCorrect: "off",
	        cx: cx,
	        getStyles: this.getStyles,
	        id: id,
	        innerRef: this.getInputRef,
	        isDisabled: isDisabled,
	        isHidden: inputIsHidden,
	        onBlur: this.onInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.onInputFocus,
	        selectProps: selectProps,
	        spellCheck: "false",
	        tabIndex: tabIndex,
	        theme: theme,
	        type: "text",
	        value: inputValue
	      }, ariaAttributes));
	    }
	  }, {
	    key: "renderPlaceholderOrValue",
	    value: function renderPlaceholderOrValue() {
	      var _this4 = this;
	
	      var _this$components = this.components,
	          MultiValue = _this$components.MultiValue,
	          MultiValueContainer = _this$components.MultiValueContainer,
	          MultiValueLabel = _this$components.MultiValueLabel,
	          MultiValueRemove = _this$components.MultiValueRemove,
	          SingleValue = _this$components.SingleValue,
	          Placeholder = _this$components.Placeholder;
	      var commonProps = this.commonProps;
	      var _this$props15 = this.props,
	          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
	          isDisabled = _this$props15.isDisabled,
	          isMulti = _this$props15.isMulti,
	          inputValue = _this$props15.inputValue,
	          placeholder = _this$props15.placeholder;
	      var _this$state8 = this.state,
	          selectValue = _this$state8.selectValue,
	          focusedValue = _this$state8.focusedValue,
	          isFocused = _this$state8.isFocused;
	
	      if (!this.hasValue() || !controlShouldRenderValue) {
	        return inputValue ? null : _react.default.createElement(Placeholder, _extends({}, commonProps, {
	          key: "placeholder",
	          isDisabled: isDisabled,
	          isFocused: isFocused
	        }), placeholder);
	      }
	
	      if (isMulti) {
	        var selectValues = selectValue.map(function (opt) {
	          var isOptionFocused = opt === focusedValue;
	          return _react.default.createElement(MultiValue, _extends({}, commonProps, {
	            components: {
	              Container: MultiValueContainer,
	              Label: MultiValueLabel,
	              Remove: MultiValueRemove
	            },
	            isFocused: isOptionFocused,
	            isDisabled: isDisabled,
	            key: _this4.getOptionValue(opt),
	            removeProps: {
	              onClick: function onClick() {
	                return _this4.removeValue(opt);
	              },
	              onTouchEnd: function onTouchEnd() {
	                return _this4.removeValue(opt);
	              },
	              onMouseDown: function onMouseDown(e) {
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            },
	            data: opt
	          }), _this4.formatOptionLabel(opt, 'value'));
	        });
	        return selectValues;
	      }
	
	      if (inputValue) {
	        return null;
	      }
	
	      var singleValue = selectValue[0];
	      return _react.default.createElement(SingleValue, _extends({}, commonProps, {
	        data: singleValue,
	        isDisabled: isDisabled
	      }), this.formatOptionLabel(singleValue, 'value'));
	    }
	  }, {
	    key: "renderClearIndicator",
	    value: function renderClearIndicator() {
	      var ClearIndicator = this.components.ClearIndicator;
	      var commonProps = this.commonProps;
	      var _this$props16 = this.props,
	          isDisabled = _this$props16.isDisabled,
	          isLoading = _this$props16.isLoading;
	      var isFocused = this.state.isFocused;
	
	      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
	        return null;
	      }
	
	      var innerProps = {
	        onMouseDown: this.onClearIndicatorMouseDown,
	        onTouchEnd: this.onClearIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(ClearIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderLoadingIndicator",
	    value: function renderLoadingIndicator() {
	      var LoadingIndicator = this.components.LoadingIndicator;
	      var commonProps = this.commonProps;
	      var _this$props17 = this.props,
	          isDisabled = _this$props17.isDisabled,
	          isLoading = _this$props17.isLoading;
	      var isFocused = this.state.isFocused;
	      if (!LoadingIndicator || !isLoading) return null;
	      var innerProps = {
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(LoadingIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderIndicatorSeparator",
	    value: function renderIndicatorSeparator() {
	      var _this$components2 = this.components,
	          DropdownIndicator = _this$components2.DropdownIndicator,
	          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
	
	      if (!DropdownIndicator || !IndicatorSeparator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      return _react.default.createElement(IndicatorSeparator, _extends({}, commonProps, {
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderDropdownIndicator",
	    value: function renderDropdownIndicator() {
	      var DropdownIndicator = this.components.DropdownIndicator;
	      if (!DropdownIndicator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      var innerProps = {
	        onMouseDown: this.onDropdownIndicatorMouseDown,
	        onTouchEnd: this.onDropdownIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return _react.default.createElement(DropdownIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this5 = this;
	
	      var _this$components3 = this.components,
	          Group = _this$components3.Group,
	          GroupHeading = _this$components3.GroupHeading,
	          Menu = _this$components3.Menu,
	          MenuList = _this$components3.MenuList,
	          MenuPortal = _this$components3.MenuPortal,
	          LoadingMessage = _this$components3.LoadingMessage,
	          NoOptionsMessage = _this$components3.NoOptionsMessage,
	          Option = _this$components3.Option;
	      var commonProps = this.commonProps;
	      var _this$state9 = this.state,
	          focusedOption = _this$state9.focusedOption,
	          menuOptions = _this$state9.menuOptions;
	      var _this$props18 = this.props,
	          captureMenuScroll = _this$props18.captureMenuScroll,
	          inputValue = _this$props18.inputValue,
	          isLoading = _this$props18.isLoading,
	          loadingMessage = _this$props18.loadingMessage,
	          minMenuHeight = _this$props18.minMenuHeight,
	          maxMenuHeight = _this$props18.maxMenuHeight,
	          menuIsOpen = _this$props18.menuIsOpen,
	          menuPlacement = _this$props18.menuPlacement,
	          menuPosition = _this$props18.menuPosition,
	          menuPortalTarget = _this$props18.menuPortalTarget,
	          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
	          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
	          noOptionsMessage = _this$props18.noOptionsMessage,
	          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
	          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
	      if (!menuIsOpen) return null; // TODO: Internal Option Type here
	
	      var render = function render(props) {
	        // for performance, the menu options in state aren't changed when the
	        // focused option changes so we calculate additional props based on that
	        var isFocused = focusedOption === props.data;
	        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
	        return _react.default.createElement(Option, _extends({}, commonProps, props, {
	          isFocused: isFocused
	        }), _this5.formatOptionLabel(props.data, 'menu'));
	      };
	
	      var menuUI;
	
	      if (this.hasOptions()) {
	        menuUI = menuOptions.render.map(function (item) {
	          if (item.type === 'group') {
	            var type = item.type,
	                group = _objectWithoutProperties(item, ["type"]);
	
	            var headingId = "".concat(item.key, "-heading");
	            return _react.default.createElement(Group, _extends({}, commonProps, group, {
	              Heading: GroupHeading,
	              headingProps: {
	                id: headingId
	              },
	              label: _this5.formatGroupLabel(item.data)
	            }), item.options.map(function (option) {
	              return render(option);
	            }));
	          } else if (item.type === 'option') {
	            return render(item);
	          }
	        });
	      } else if (isLoading) {
	        var message = loadingMessage({
	          inputValue: inputValue
	        });
	        if (message === null) return null;
	        menuUI = _react.default.createElement(LoadingMessage, commonProps, message);
	      } else {
	        var _message = noOptionsMessage({
	          inputValue: inputValue
	        });
	
	        if (_message === null) return null;
	        menuUI = _react.default.createElement(NoOptionsMessage, commonProps, _message);
	      }
	
	      var menuPlacementProps = {
	        minMenuHeight: minMenuHeight,
	        maxMenuHeight: maxMenuHeight,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition,
	        menuShouldScrollIntoView: menuShouldScrollIntoView
	      };
	
	      var menuElement = _react.default.createElement(_Menu.MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
	        var ref = _ref6.ref,
	            _ref6$placerProps = _ref6.placerProps,
	            placement = _ref6$placerProps.placement,
	            maxHeight = _ref6$placerProps.maxHeight;
	        return _react.default.createElement(Menu, _extends({}, commonProps, menuPlacementProps, {
	          innerRef: ref,
	          innerProps: {
	            onMouseDown: _this5.onMenuMouseDown,
	            onMouseMove: _this5.onMenuMouseMove
	          },
	          isLoading: isLoading,
	          placement: placement
	        }), _react.default.createElement(_index.ScrollCaptor, {
	          isEnabled: captureMenuScroll,
	          onTopArrive: onMenuScrollToTop,
	          onBottomArrive: onMenuScrollToBottom
	        }, _react.default.createElement(_index.ScrollBlock, {
	          isEnabled: menuShouldBlockScroll
	        }, _react.default.createElement(MenuList, _extends({}, commonProps, {
	          innerRef: _this5.getMenuListRef,
	          isLoading: isLoading,
	          maxHeight: maxHeight
	        }), menuUI))));
	      }); // positioning behaviour is almost identical for portalled and fixed,
	      // so we use the same component. the actual portalling logic is forked
	      // within the component based on `menuPosition`
	
	
	      return menuPortalTarget || menuPosition === 'fixed' ? _react.default.createElement(MenuPortal, _extends({}, commonProps, {
	        appendTo: menuPortalTarget,
	        controlElement: this.controlRef,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition
	      }), menuElement) : menuElement;
	    }
	  }, {
	    key: "renderFormField",
	    value: function renderFormField() {
	      var _this6 = this;
	
	      var _this$props19 = this.props,
	          delimiter = _this$props19.delimiter,
	          isDisabled = _this$props19.isDisabled,
	          isMulti = _this$props19.isMulti,
	          name = _this$props19.name;
	      var selectValue = this.state.selectValue;
	      if (!name || isDisabled) return;
	
	      if (isMulti) {
	        if (delimiter) {
	          var value = selectValue.map(function (opt) {
	            return _this6.getOptionValue(opt);
	          }).join(delimiter);
	          return _react.default.createElement("input", {
	            name: name,
	            type: "hidden",
	            value: value
	          });
	        } else {
	          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
	            return _react.default.createElement("input", {
	              key: "i-".concat(i),
	              name: name,
	              type: "hidden",
	              value: _this6.getOptionValue(opt)
	            });
	          }) : _react.default.createElement("input", {
	            name: name,
	            type: "hidden"
	          });
	          return _react.default.createElement("div", null, input);
	        }
	      } else {
	        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
	
	        return _react.default.createElement("input", {
	          name: name,
	          type: "hidden",
	          value: _value
	        });
	      }
	    }
	  }, {
	    key: "renderLiveRegion",
	    value: function renderLiveRegion() {
	      if (!this.state.isFocused) return null;
	      return _react.default.createElement(_index.A11yText, {
	        "aria-live": "assertive"
	      }, _react.default.createElement("p", {
	        id: "aria-selection-event"
	      }, "\xA0", this.state.ariaLiveSelection), _react.default.createElement("p", {
	        id: "aria-context"
	      }, "\xA0", this.constructAriaLiveMessage()));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$components4 = this.components,
	          Control = _this$components4.Control,
	          IndicatorsContainer = _this$components4.IndicatorsContainer,
	          SelectContainer = _this$components4.SelectContainer,
	          ValueContainer = _this$components4.ValueContainer;
	      var _this$props20 = this.props,
	          className = _this$props20.className,
	          id = _this$props20.id,
	          isDisabled = _this$props20.isDisabled,
	          menuIsOpen = _this$props20.menuIsOpen;
	      var isFocused = this.state.isFocused;
	      var commonProps = this.commonProps = this.getCommonProps();
	      return _react.default.createElement(SelectContainer, _extends({}, commonProps, {
	        className: className,
	        innerProps: {
	          id: id,
	          onKeyDown: this.onKeyDown
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }), this.renderLiveRegion(), _react.default.createElement(Control, _extends({}, commonProps, {
	        innerRef: this.getControlRef,
	        innerProps: {
	          onMouseDown: this.onControlMouseDown,
	          onTouchEnd: this.onControlTouchEnd
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused,
	        menuIsOpen: menuIsOpen
	      }), _react.default.createElement(ValueContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderPlaceholderOrValue(), this.renderInput()), _react.default.createElement(IndicatorsContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
	    }
	  }]);
	
	  return Select;
	}(_react.Component);
	
	exports.default = Select;
	
	_defineProperty(Select, "defaultProps", defaultProps);

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  defaultInputValue: '',
	  defaultMenuIsOpen: false,
	  defaultValue: null
	};
	exports.defaultProps = defaultProps;
	
	var manageState = function manageState(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(StateManager, _Component);
	
	    function StateManager() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, StateManager);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
	        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
	        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
	        _this.callProp('onChange', value, actionMeta);
	
	        _this.setState({
	          value: value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
	        // TODO: for backwards compatibility, we allow the prop to return a new
	        // value, but now inputValue is a controllable prop we probably shouldn't
	        var newValue = _this.callProp('onInputChange', value, actionMeta);
	
	        _this.setState({
	          inputValue: newValue !== undefined ? newValue : value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
	        _this.callProp('onMenuOpen');
	
	        _this.setState({
	          menuIsOpen: true
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
	        _this.callProp('onMenuClose');
	
	        _this.setState({
	          menuIsOpen: false
	        });
	      });
	
	      return _this;
	    }
	
	    _createClass(StateManager, [{
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "getProp",
	      value: function getProp(key) {
	        return this.props[key] !== undefined ? this.props[key] : this.state[key];
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "callProp",
	      value: function callProp(name) {
	        if (typeof this.props[name] === 'function') {
	          var _this$props;
	
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          return (_this$props = this.props)[name].apply(_this$props, args);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            defaultInputValue = _this$props2.defaultInputValue,
	            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
	            defaultValue = _this$props2.defaultValue,
	            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
	
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          inputValue: this.getProp('inputValue'),
	          menuIsOpen: this.getProp('menuIsOpen'),
	          onChange: this.onChange,
	          onInputChange: this.onInputChange,
	          onMenuClose: this.onMenuClose,
	          onMenuOpen: this.onMenuOpen,
	          value: this.getProp('value')
	        }));
	      }
	    }]);
	
	    return StateManager;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	var _default = manageState;
	exports.default = _default;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.classNames = classNames;
	exports.handleInputChange = handleInputChange;
	exports.isDocumentElement = isDocumentElement;
	exports.normalizedHeight = normalizedHeight;
	exports.getScrollTop = getScrollTop;
	exports.scrollTo = scrollTo;
	exports.getScrollParent = getScrollParent;
	exports.animatedScrollTo = animatedScrollTo;
	exports.scrollIntoView = scrollIntoView;
	exports.getBoundingClientObj = getBoundingClientObj;
	exports.toKey = toKey;
	exports.isTouchCapable = isTouchCapable;
	exports.isMobileDevice = isMobileDevice;
	exports.cleanValue = exports.emptyString = exports.noop = void 0;
	
	var _raf = _interopRequireDefault(__webpack_require__(1397));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	// ==============================
	// NO OP
	// ==============================
	var noop = function noop() {};
	
	exports.noop = noop;
	
	var emptyString = function emptyString() {
	  return '';
	}; // ==============================
	// Class Name Prefixer
	// ==============================
	
	/**
	 String representation of component state for styling with class names.
	
	 Expects an array of strings OR a string/object pair:
	 - className(['comp', 'comp-arg', 'comp-arg-2'])
	   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
	 - className('comp', { some: true, state: false })
	   @returns 'react-select__comp react-select__comp--some'
	*/
	
	
	exports.emptyString = emptyString;
	
	function applyPrefixToName(prefix, name) {
	  if (!name) {
	    return prefix;
	  } else if (name[0] === '-') {
	    return prefix + name;
	  } else {
	    return prefix + '__' + name;
	  }
	}
	
	function classNames(prefix, cssKey, state, className) {
	  var arr = [cssKey, className];
	
	  if (state && prefix) {
	    for (var key in state) {
	      if (state.hasOwnProperty(key) && state[key]) {
	        arr.push("".concat(applyPrefixToName(prefix, key)));
	      }
	    }
	  }
	
	  return arr.filter(function (i) {
	    return i;
	  }).map(function (i) {
	    return String(i).trim();
	  }).join(' ');
	} // ==============================
	// Clean Value
	// ==============================
	
	
	var cleanValue = function cleanValue(value) {
	  if (Array.isArray(value)) return value.filter(Boolean);
	  if (_typeof(value) === 'object' && value !== null) return [value];
	  return [];
	}; // ==============================
	// Handle Input Change
	// ==============================
	
	
	exports.cleanValue = cleanValue;
	
	function handleInputChange(inputValue, actionMeta, onInputChange) {
	  if (onInputChange) {
	    var newValue = onInputChange(inputValue, actionMeta);
	    if (typeof newValue === 'string') return newValue;
	  }
	
	  return inputValue;
	} // ==============================
	// Scroll Helpers
	// ==============================
	
	
	function isDocumentElement(el) {
	  return [document.documentElement, document.body, window].indexOf(el) > -1;
	} // Normalized Scroll Top
	// ------------------------------
	
	
	function normalizedHeight(el) {
	  if (isDocumentElement(el)) {
	    return window.innerHeight;
	  }
	
	  return el.clientHeight;
	} // Normalized scrollTo & scrollTop
	// ------------------------------
	
	
	function getScrollTop(el) {
	  if (isDocumentElement(el)) {
	    return window.pageYOffset;
	  }
	
	  return el.scrollTop;
	}
	
	function scrollTo(el, top) {
	  // with a scroll distance, we perform scroll on the element
	  if (isDocumentElement(el)) {
	    window.scrollTo(0, top);
	    return;
	  }
	
	  el.scrollTop = top;
	} // Get Scroll Parent
	// ------------------------------
	
	
	function getScrollParent(element) {
	  var style = getComputedStyle(element);
	  var excludeStaticParent = style.position === 'absolute';
	  var overflowRx = /(auto|scroll)/;
	  var docEl = document.documentElement; // suck it, flow...
	
	  if (style.position === 'fixed') return docEl;
	
	  for (var parent = element; parent = parent.parentElement;) {
	    style = getComputedStyle(parent);
	
	    if (excludeStaticParent && style.position === 'static') {
	      continue;
	    }
	
	    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
	      return parent;
	    }
	  }
	
	  return docEl;
	} // Animated Scroll To
	// ------------------------------
	
	/**
	  @param t: time (elapsed)
	  @param b: initial value
	  @param c: amount of change
	  @param d: duration
	*/
	
	
	function easeOutCubic(t, b, c, d) {
	  return c * ((t = t / d - 1) * t * t + 1) + b;
	}
	
	function animatedScrollTo(element, to) {
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
	  var start = getScrollTop(element);
	  var change = to - start;
	  var increment = 10;
	  var currentTime = 0;
	
	  function animateScroll() {
	    currentTime += increment;
	    var val = easeOutCubic(currentTime, start, change, duration);
	    scrollTo(element, val);
	
	    if (currentTime < duration) {
	      (0, _raf.default)(animateScroll);
	    } else {
	      callback(element);
	    }
	  }
	
	  animateScroll();
	} // Scroll Into View
	// ------------------------------
	
	
	function scrollIntoView(menuEl, focusedEl) {
	  var menuRect = menuEl.getBoundingClientRect();
	  var focusedRect = focusedEl.getBoundingClientRect();
	  var overScroll = focusedEl.offsetHeight / 3;
	
	  if (focusedRect.bottom + overScroll > menuRect.bottom) {
	    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
	  } else if (focusedRect.top - overScroll < menuRect.top) {
	    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
	  }
	} // ==============================
	// Get bounding client object
	// ==============================
	// cannot get keys using array notation with DOMRect
	
	
	function getBoundingClientObj(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    bottom: rect.bottom,
	    height: rect.height,
	    left: rect.left,
	    right: rect.right,
	    top: rect.top,
	    width: rect.width
	  };
	}
	
	// ==============================
	// String to Key (kebabify)
	// ==============================
	function toKey(str) {
	  return str.replace(/\W/g, '-');
	} // ==============================
	// Touch Capability Detector
	// ==============================
	
	
	function isTouchCapable() {
	  try {
	    document.createEvent('TouchEvent');
	    return true;
	  } catch (e) {
	    return false;
	  }
	} // ==============================
	// Mobile Device Detector
	// ==============================
	
	
	function isMobileDevice() {
	  try {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	  } catch (e) {
	    return false;
	  }
	}

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ },
/* 210 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.commaDecimal = exports.dotDecimal = exports.arabicLocales = exports.englishLocales = exports.decimal = exports.alphanumeric = exports.alpha = void 0;
	var alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'bg-BG': /^[А-Я]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[A-ZÆØÅ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'el-GR': /^[Α-ω]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'nb-NO': /^[A-ZÆØÅ]+$/i,
	  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[A-ZÆØÅ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
	  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
	  'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
	  he: /^[א-ת]+$/,
	  'fa-IR': /^['آابپتثجچهخدذرزژسشصضطظعغفقکگلمنوهی']+$/i
	};
	exports.alpha = alpha;
	var alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'bg-BG': /^[0-9А-Я]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'el-GR': /^[0-9Α-ω]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
	  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
	  'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
	  he: /^[0-9א-ת]+$/,
	  'fa-IR': /^['0-9آابپتثجچهخدذرزژسشصضطظعغفقکگلمنوهی۱۲۳۴۵۶۷۸۹۰']+$/i
	};
	exports.alphanumeric = alphanumeric;
	var decimal = {
	  'en-US': '.',
	  ar: '٫'
	};
	exports.decimal = decimal;
	var englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	exports.englishLocales = englishLocales;
	
	for (var locale, i = 0; i < englishLocales.length; i++) {
	  locale = "en-".concat(englishLocales[i]);
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	  decimal[locale] = decimal['en-US'];
	} // Source: http://www.localeplanet.com/java/
	
	
	var arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	exports.arabicLocales = arabicLocales;
	
	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = "ar-".concat(arabicLocales[_i]);
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	  decimal[_locale] = decimal.ar;
	} // Source: https://en.wikipedia.org/wiki/Decimal_mark
	
	
	var dotDecimal = ['ar-EG', 'ar-LB', 'ar-LY'];
	exports.dotDecimal = dotDecimal;
	var commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'en-ZM', 'es-ES', 'fr-FR', 'it-IT', 'ku-IQ', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-PL', 'pt-PT', 'ru-RU', 'sl-SI', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'];
	exports.commaDecimal = commaDecimal;
	
	for (var _i2 = 0; _i2 < dotDecimal.length; _i2++) {
	  decimal[dotDecimal[_i2]] = decimal['en-US'];
	}
	
	for (var _i3 = 0; _i3 < commaDecimal.length; _i3++) {
	  decimal[commaDecimal[_i3]] = ',';
	}
	
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	decimal['pt-BR'] = decimal['pt-PT']; // see #862
	
	alpha['pl-Pl'] = alpha['pl-PL'];
	alphanumeric['pl-Pl'] = alphanumeric['pl-PL'];
	decimal['pl-Pl'] = decimal['pl-PL'];

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	11.3.  Examples
	
	   The following addresses
	
	             fe80::1234 (on the 1st link of the node)
	             ff02::5678 (on the 5th link of the node)
	             ff08::9abc (on the 10th organization of the node)
	
	   would be represented as follows:
	
	             fe80::1234%1
	             ff02::5678%5
	             ff08::9abc%10
	
	   (Here we assume a natural translation from a zone index to the
	   <zone_id> part, where the Nth zone of any scope is translated into
	   "N".)
	
	   If we use interface names as <zone_id>, those addresses could also be
	   represented as follows:
	
	            fe80::1234%ne0
	            ff02::5678%pvc1.3
	            ff08::9abc%interface10
	
	   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
	   to the 5th link, and "interface10" belongs to the 10th organization.
	 * * */
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  (0, _assertString.default)(str);
	  version = String(version);
	
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var addressAndZone = [str]; // ipv6 addresses could have scoped architecture
	    // according to https://tools.ietf.org/html/rfc4007#section-11
	
	    if (str.includes('%')) {
	      addressAndZone = str.split('%');
	
	      if (addressAndZone.length !== 2) {
	        // it must be just two parts
	        return false;
	      }
	
	      if (!addressAndZone[0].includes(':')) {
	        // the first part must be the address
	        return false;
	      }
	
	      if (addressAndZone[1] === '') {
	        // the second part must not be empty
	        return false;
	      }
	    }
	
	    var blocks = addressAndZone[0].split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    } // initial or final ::
	
	
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {// it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	
	    return blocks.length === expectedNumberOfBlocks;
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* global console */
	
	/* eslint-disable no-console */
	// TODO: Use "warning" npm module like React is switching to.
	var _default = {
	  warn: function (message) {
	    if (false) {
	      if (console && console.warn) {
	        console.warn(message);
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(83));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _collection = _interopRequireDefault(__webpack_require__(89));
	
	var d3Scale = _interopRequireWildcard(__webpack_require__(1222));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedScaleStrings = ["linear", "time", "log", "sqrt"]; // Private Functions
	
	function toNewName(scale) {
	  // d3 scale changed the naming scheme for scale from "linear" -> "scaleLinear" etc.
	  var capitalize = function (s) {
	    return s && s[0].toUpperCase() + s.slice(1);
	  };
	
	  return "scale".concat(capitalize(scale));
	}
	
	function validScale(scale) {
	  if (typeof scale === "function") {
	    return (0, _isFunction2.default)(scale.copy) && (0, _isFunction2.default)(scale.domain) && (0, _isFunction2.default)(scale.range);
	  } else if (typeof scale === "string") {
	    return (0, _includes2.default)(supportedScaleStrings, scale);
	  }
	
	  return false;
	}
	
	function isScaleDefined(props, axis) {
	  if (!props.scale) {
	    return false;
	  } else if (props.scale.x || props.scale.y) {
	    return props.scale[axis] ? true : false;
	  }
	
	  return true;
	}
	
	function getScaleTypeFromProps(props, axis) {
	  if (!isScaleDefined(props, axis)) {
	    return undefined;
	  }
	
	  var scale = props.scale[axis] || props.scale;
	  return typeof scale === "string" ? scale : getType(scale);
	}
	
	function getScaleFromDomain(props, axis) {
	  var domain;
	
	  if (props.domain && props.domain[axis]) {
	    domain = props.domain[axis];
	  } else if (props.domain && Array.isArray(props.domain)) {
	    domain = props.domain;
	  }
	
	  if (!domain) {
	    return undefined;
	  }
	
	  return _collection.default.containsDates(domain) ? "time" : "linear";
	}
	
	function getScaleTypeFromData(props, axis) {
	  if (!props.data) {
	    return "linear";
	  }
	
	  var accessor = _helpers.default.createAccessor(props[axis]);
	
	  var axisData = props.data.map(function (datum) {
	    var processedData = (0, _isPlainObject2.default)(accessor(datum)) ? accessor(datum)[axis] : accessor(datum);
	    return processedData !== undefined ? processedData : datum[axis];
	  });
	  return _collection.default.containsDates(axisData) ? "time" : "linear";
	} // Exported Functions
	
	
	function getScaleFromName(name) {
	  return validScale(name) ? d3Scale[toNewName(name)]() : d3Scale.scaleLinear();
	}
	
	function getBaseScale(props, axis) {
	  var scale = getScaleFromProps(props, axis);
	
	  if (scale) {
	    return typeof scale === "string" ? getScaleFromName(scale) : scale;
	  }
	
	  var defaultScale = getScaleFromDomain(props, axis) || getScaleTypeFromData(props, axis);
	  return d3Scale[toNewName(defaultScale)]();
	}
	
	function getDefaultScale() {
	  return d3Scale.scaleLinear();
	}
	
	function getScaleFromProps(props, axis) {
	  if (!isScaleDefined(props, axis)) {
	    return undefined;
	  }
	
	  var scale = props.scale[axis] || props.scale;
	
	  if (validScale(scale)) {
	    return (0, _isFunction2.default)(scale) ? scale : d3Scale[toNewName(scale)]();
	  }
	
	  return undefined;
	}
	
	function getScaleType(props, axis) {
	  // if the scale was not given in props, it will be set to linear or time depending on data
	  return getScaleTypeFromProps(props, axis) || getScaleTypeFromData(props, axis);
	}
	
	function getType(scale) {
	  if (typeof scale === "string") {
	    return scale;
	  }
	
	  var duckTypes = [{
	    name: "log",
	    method: "base"
	  }, {
	    name: "ordinal",
	    method: "unknown"
	  }, {
	    name: "pow-sqrt",
	    method: "exponent"
	  }, {
	    name: "quantile",
	    method: "quantiles"
	  }, {
	    name: "quantize-threshold",
	    method: "invertExtent"
	  }];
	  var scaleType = duckTypes.filter(function (type) {
	    return scale[type.method] !== undefined;
	  })[0];
	  return scaleType ? scaleType.name : undefined;
	}
	
	var _default = {
	  getBaseScale: getBaseScale,
	  getDefaultScale: getDefaultScale,
	  getScaleFromProps: getScaleFromProps,
	  getScaleType: getScaleType,
	  getType: getType,
	  getScaleFromName: getScaleFromName
	};
	exports.default = _default;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _d3Timer = __webpack_require__(1224);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var Timer =
	/*#__PURE__*/
	function () {
	  function Timer() {
	    _classCallCheck(this, Timer);
	
	    this.shouldAnimate = true;
	    this.subscribers = [];
	    this.loop = this.loop.bind(this);
	    this.timer = (0, _d3Timer.timer)(this.loop);
	  }
	
	  _createClass(Timer, [{
	    key: "bypassAnimation",
	    value: function bypassAnimation() {
	      this.shouldAnimate = false;
	    }
	  }, {
	    key: "resumeAnimation",
	    value: function resumeAnimation() {
	      this.shouldAnimate = true;
	    }
	  }, {
	    key: "loop",
	    value: function loop() {
	      this.subscribers.forEach(function (s) {
	        s.callback((0, _d3Timer.now)() - s.startTime, s.duration);
	      });
	    }
	  }, {
	    key: "start",
	    value: function start() {
	      this.timer.start();
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.timer.stop();
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe(callback, duration) {
	      duration = this.shouldAnimate ? duration : 0;
	      return this.subscribers.push({
	        startTime: (0, _d3Timer.now)(),
	        callback: callback,
	        duration: duration
	      });
	    }
	  }, {
	    key: "unsubscribe",
	    value: function unsubscribe(id) {
	      if (id !== null) {
	        delete this.subscribers[id - 1];
	      }
	    }
	  }]);
	
	  return Timer;
	}();
	
	exports.default = Timer;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictorySharedEvents", {
	  enumerable: true,
	  get: function () {
	    return _victorySharedEvents.default;
	  }
	});
	
	var _victorySharedEvents = _interopRequireDefault(__webpack_require__(1901));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 216 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(306);
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	
	module.exports = _unsupportedIterableToArray;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var diff_1 = __webpack_require__(708);
	exports.selectUnit = diff_1.selectUnit;
	var polyfill_utils_1 = __webpack_require__(312);
	exports.defaultNumberOption = polyfill_utils_1.defaultNumberOption;
	exports.getAliasesByLang = polyfill_utils_1.getAliasesByLang;
	exports.getInternalSlot = polyfill_utils_1.getInternalSlot;
	exports.getMultiInternalSlots = polyfill_utils_1.getMultiInternalSlots;
	exports.getNumberOption = polyfill_utils_1.getNumberOption;
	exports.getOption = polyfill_utils_1.getOption;
	exports.getParentLocalesByLang = polyfill_utils_1.getParentLocalesByLang;
	exports.isLiteralPart = polyfill_utils_1.isLiteralPart;
	exports.partitionPattern = polyfill_utils_1.partitionPattern;
	exports.setInternalSlot = polyfill_utils_1.setInternalSlot;
	exports.setMultiInternalSlots = polyfill_utils_1.setMultiInternalSlots;
	exports.setNumberFormatDigitOptions = polyfill_utils_1.setNumberFormatDigitOptions;
	exports.toObject = polyfill_utils_1.toObject;
	exports.objectIs = polyfill_utils_1.objectIs;
	exports.isWellFormedCurrencyCode = polyfill_utils_1.isWellFormedCurrencyCode;
	exports.toString = polyfill_utils_1.toString;
	var resolve_locale_1 = __webpack_require__(711);
	exports.createResolveLocale = resolve_locale_1.createResolveLocale;
	exports.getLocaleHierarchy = resolve_locale_1.getLocaleHierarchy;
	exports.supportedLocales = resolve_locale_1.supportedLocales;
	exports.unpackData = resolve_locale_1.unpackData;
	exports.isMissingLocaleDataError = resolve_locale_1.isMissingLocaleDataError;
	__export(__webpack_require__(712));
	__export(__webpack_require__(709));
	var get_canonical_locales_1 = __webpack_require__(311);
	exports.getCanonicalLocales = get_canonical_locales_1.getCanonicalLocales;
	var invariant_1 = __webpack_require__(219);
	exports.invariant = invariant_1.invariant;
	//# sourceMappingURL=index.js.map

/***/ },
/* 219 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function invariant(condition, message, Err) {
	    if (Err === void 0) { Err = Error; }
	    if (!condition) {
	        throw new Err(message);
	    }
	}
	exports.invariant = invariant;
	//# sourceMappingURL=invariant.js.map

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(718));

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "styleFunction", {
	  enumerable: true,
	  get: function get() {
	    return _Box.styleFunction;
	  }
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(725));

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _Modal = _interopRequireDefault(__webpack_require__(164));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(220));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Slide = _interopRequireDefault(__webpack_require__(229));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _transitions = __webpack_require__(60);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `variant="permanent or persistent"`. */
	    docked: {
	      flex: '0 0 auto'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100%',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"`. */
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"`. */
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"`. */
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Modal` component. */
	    modal: {}
	  };
	};
	
	exports.styles = styles;
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(anchor) {
	  return ['left', 'right'].indexOf(anchor) !== -1;
	}
	
	function getAnchor(theme, anchor) {
	  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
	}
	
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The props of the [Modal](/api/modal/) component are available
	 * when `variant="temporary"` is set.
	 */
	
	var Drawer = React.forwardRef(function Drawer(props, ref) {
	  var _props$anchor = props.anchor,
	      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropPropsProp = _props$ModalProps.BackdropProps,
	      ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      _props$open = props.open,
	      open = _props$open === void 0 ? false : _props$open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SlideProps = props.SlideProps,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Slide.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)(); // Let's assume that the Drawer will always be rendered on user space.
	  // We use this state is order to skip the appear transition during the
	  // initial mount of the component.
	
	  var mounted = React.useRef(false);
	  React.useEffect(function () {
	    mounted.current = true;
	  }, []);
	  var anchor = getAnchor(theme, anchorProp);
	  var drawer = /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: variant === 'temporary' ? elevation : 0,
	    square: true
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperAnchor".concat((0, _capitalize.default)(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat((0, _capitalize.default)(anchor))])
	  }), children);
	
	  if (variant === 'permanent') {
	    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), drawer);
	  }
	
	  var slidingDrawer = /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: open,
	    direction: oppositeDirection[anchor],
	    timeout: transitionDuration,
	    appear: mounted.current
	  }, SlideProps), drawer);
	
	  if (variant === 'persistent') {
	    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), slidingDrawer);
	  } // variant === temporary
	
	
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    BackdropProps: (0, _extends2.default)({}, BackdropProps, {}, BackdropPropsProp, {
	      transitionDuration: transitionDuration
	    }),
	    BackdropComponent: _Backdrop.default,
	    className: (0, _clsx.default)(classes.root, classes.modal, className),
	    open: open,
	    onClose: onClose,
	    ref: ref
	  }, other, ModalProps), slidingDrawer);
	});
	 false ? Drawer.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['bottom', 'left', 'right', 'top']),
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Modal`](/api/modal/) element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`Slide`](/api/slide/) element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false
	})(Drawer);
	
	exports.default = _default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(778));

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "useFormControl", {
	  enumerable: true,
	  get: function get() {
	    return _useFormControl.default;
	  }
	});
	
	var _FormControl = _interopRequireDefault(__webpack_require__(779));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(92));

/***/ },
/* 225 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasValue = hasValue;
	exports.isFilled = isFilled;
	exports.isAdornedStart = isAdornedStart;
	
	// Supports determination of isControlled().
	// Controlled input accepts its current value as a prop.
	//
	// @see https://facebook.github.io/react/docs/forms.html#controlled-components
	// @param value
	// @returns {boolean} true if string (including '') or number (including zero)
	function hasValue(value) {
	  return value != null && !(Array.isArray(value) && value.length === 0);
	} // Determine if field is empty or filled.
	// Response determines if label is presented above field or as placeholder.
	//
	// @param obj
	// @param SSR
	// @returns {boolean} False when not present or empty string.
	//                    True when any number or string with length.
	
	
	function isFilled(obj) {
	  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
	} // Determine if an Input is adorned on start.
	// It's corresponding to the left with LTR.
	//
	// @param obj
	// @returns {boolean} False when no adornments.
	//                    True when adorned at the start.
	
	
	function isAdornedStart(obj) {
	  return obj.startAdornment;
	}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(815));

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(828));

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(832));

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	Object.defineProperty(exports, "unstable_StrictModeSlide", {
	  enumerable: true,
	  get: function get() {
	    return _StrictModeSlide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(331));
	
	var _StrictModeSlide = _interopRequireDefault(__webpack_require__(842));

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	
	var _Table = _interopRequireDefault(__webpack_require__(868));

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	
	var _TableBody = _interopRequireDefault(__webpack_require__(869));

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableContainer.default;
	  }
	});
	
	var _TableContainer = _interopRequireDefault(__webpack_require__(871));

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	
	var _TableHead = _interopRequireDefault(__webpack_require__(874));

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	
	var _TableRow = _interopRequireDefault(__webpack_require__(878));

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "common", {
	  enumerable: true,
	  get: function get() {
	    return _common.default;
	  }
	});
	Object.defineProperty(exports, "red", {
	  enumerable: true,
	  get: function get() {
	    return _red.default;
	  }
	});
	Object.defineProperty(exports, "pink", {
	  enumerable: true,
	  get: function get() {
	    return _pink.default;
	  }
	});
	Object.defineProperty(exports, "purple", {
	  enumerable: true,
	  get: function get() {
	    return _purple.default;
	  }
	});
	Object.defineProperty(exports, "deepPurple", {
	  enumerable: true,
	  get: function get() {
	    return _deepPurple.default;
	  }
	});
	Object.defineProperty(exports, "indigo", {
	  enumerable: true,
	  get: function get() {
	    return _indigo.default;
	  }
	});
	Object.defineProperty(exports, "blue", {
	  enumerable: true,
	  get: function get() {
	    return _blue.default;
	  }
	});
	Object.defineProperty(exports, "lightBlue", {
	  enumerable: true,
	  get: function get() {
	    return _lightBlue.default;
	  }
	});
	Object.defineProperty(exports, "cyan", {
	  enumerable: true,
	  get: function get() {
	    return _cyan.default;
	  }
	});
	Object.defineProperty(exports, "teal", {
	  enumerable: true,
	  get: function get() {
	    return _teal.default;
	  }
	});
	Object.defineProperty(exports, "green", {
	  enumerable: true,
	  get: function get() {
	    return _green.default;
	  }
	});
	Object.defineProperty(exports, "lightGreen", {
	  enumerable: true,
	  get: function get() {
	    return _lightGreen.default;
	  }
	});
	Object.defineProperty(exports, "lime", {
	  enumerable: true,
	  get: function get() {
	    return _lime.default;
	  }
	});
	Object.defineProperty(exports, "yellow", {
	  enumerable: true,
	  get: function get() {
	    return _yellow.default;
	  }
	});
	Object.defineProperty(exports, "amber", {
	  enumerable: true,
	  get: function get() {
	    return _amber.default;
	  }
	});
	Object.defineProperty(exports, "orange", {
	  enumerable: true,
	  get: function get() {
	    return _orange.default;
	  }
	});
	Object.defineProperty(exports, "deepOrange", {
	  enumerable: true,
	  get: function get() {
	    return _deepOrange.default;
	  }
	});
	Object.defineProperty(exports, "brown", {
	  enumerable: true,
	  get: function get() {
	    return _brown.default;
	  }
	});
	Object.defineProperty(exports, "grey", {
	  enumerable: true,
	  get: function get() {
	    return _grey.default;
	  }
	});
	Object.defineProperty(exports, "blueGrey", {
	  enumerable: true,
	  get: function get() {
	    return _blueGrey.default;
	  }
	});
	
	var _common = _interopRequireDefault(__webpack_require__(343));
	
	var _red = _interopRequireDefault(__webpack_require__(349));
	
	var _pink = _interopRequireDefault(__webpack_require__(348));
	
	var _purple = _interopRequireDefault(__webpack_require__(902));
	
	var _deepPurple = _interopRequireDefault(__webpack_require__(898));
	
	var _indigo = _interopRequireDefault(__webpack_require__(346));
	
	var _blue = _interopRequireDefault(__webpack_require__(342));
	
	var _lightBlue = _interopRequireDefault(__webpack_require__(899));
	
	var _cyan = _interopRequireDefault(__webpack_require__(896));
	
	var _teal = _interopRequireDefault(__webpack_require__(903));
	
	var _green = _interopRequireDefault(__webpack_require__(344));
	
	var _lightGreen = _interopRequireDefault(__webpack_require__(900));
	
	var _lime = _interopRequireDefault(__webpack_require__(901));
	
	var _yellow = _interopRequireDefault(__webpack_require__(904));
	
	var _amber = _interopRequireDefault(__webpack_require__(893));
	
	var _orange = _interopRequireDefault(__webpack_require__(347));
	
	var _deepOrange = _interopRequireDefault(__webpack_require__(897));
	
	var _brown = _interopRequireDefault(__webpack_require__(895));
	
	var _grey = _interopRequireDefault(__webpack_require__(345));
	
	var _blueGrey = _interopRequireDefault(__webpack_require__(894));

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(95));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(92));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(40));
	
	var styles = {
	  root: {
	    padding: 9
	  },
	  checked: {},
	  disabled: {},
	  input: {
	    cursor: 'inherit',
	    position: 'absolute',
	    opacity: 0,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    margin: 0,
	    padding: 0,
	    zIndex: 1
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SwitchBase = React.forwardRef(function SwitchBase(props, ref) {
	  var autoFocus = props.autoFocus,
	      checkedProp = props.checked,
	      checkedIcon = props.checkedIcon,
	      classes = props.classes,
	      className = props.className,
	      defaultChecked = props.defaultChecked,
	      disabledProp = props.disabled,
	      icon = props.icon,
	      id = props.id,
	      inputProps = props.inputProps,
	      inputRef = props.inputRef,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      readOnly = props.readOnly,
	      required = props.required,
	      tabIndex = props.tabIndex,
	      type = props.type,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: checkedProp,
	    default: Boolean(defaultChecked),
	    name: 'SwitchBase',
	    state: 'checked'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      checked = _useControlled2[0],
	      setCheckedState = _useControlled2[1];
	
	  var muiFormControl = (0, _useFormControl.default)();
	
	  var handleFocus = function handleFocus(event) {
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    var newChecked = event.target.checked;
	    setCheckedState(newChecked);
	
	    if (onChange) {
	      // TODO v5: remove the second argument.
	      onChange(event, newChecked);
	    }
	  };
	
	  var disabled = disabledProp;
	
	  if (muiFormControl) {
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	  }
	
	  var hasLabelFor = type === 'checkbox' || type === 'radio';
	  return /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    component: "span",
	    className: (0, _clsx.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
	    disabled: disabled,
	    tabIndex: null,
	    role: undefined,
	    onFocus: handleFocus,
	    onBlur: handleBlur,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    autoFocus: autoFocus,
	    checked: checkedProp,
	    defaultChecked: defaultChecked,
	    className: classes.input,
	    disabled: disabled,
	    id: hasLabelFor && id,
	    name: name,
	    onChange: handleInputChange,
	    readOnly: readOnly,
	    ref: inputRef,
	    required: required,
	    tabIndex: tabIndex,
	    type: type,
	    value: value
	  }, inputProps)), checked ? checkedIcon : icon);
	}); // NB: If changed, please update Checkbox, Switch and Radio
	// so that the API documentation is updated.
	
	 false ? SwitchBase.propTypes = {
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node.isRequired,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The input component prop `type`.
	   */
	  type: _propTypes.default.string.isRequired,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwitchBase'
	})(SwitchBase);
	
	exports.default = _default;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(21);
	
	var _createBreakpoints = _interopRequireDefault(__webpack_require__(353));
	
	var _createMixins = _interopRequireDefault(__webpack_require__(919));
	
	var _createPalette = _interopRequireDefault(__webpack_require__(921));
	
	var _createTypography = _interopRequireDefault(__webpack_require__(924));
	
	var _shadows = _interopRequireDefault(__webpack_require__(928));
	
	var _shape = _interopRequireDefault(__webpack_require__(929));
	
	var _createSpacing = _interopRequireDefault(__webpack_require__(922));
	
	var _transitions = _interopRequireDefault(__webpack_require__(60));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(355));
	
	function createMuiTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
	      _options$palette = options.palette,
	      paletteInput = _options$palette === void 0 ? {} : _options$palette,
	      spacingInput = options.spacing,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
	  var palette = (0, _createPalette.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
	  var spacing = (0, _createSpacing.default)(spacingInput);
	  var muiTheme = (0, _utils.deepmerge)({
	    breakpoints: breakpoints,
	    direction: 'ltr',
	    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
	    overrides: {},
	    // Inject custom styles
	    palette: palette,
	    props: {},
	    // Provide default props
	    shadows: _shadows.default,
	    typography: (0, _createTypography.default)(palette, typographyInput),
	    spacing: spacing,
	    shape: _shape.default,
	    transitions: _transitions.default,
	    zIndex: _zIndex.default
	  }, other);
	
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = args.reduce(function (acc, argument) {
	    return (0, _utils.deepmerge)(acc, argument);
	  }, muiTheme);
	
	  if (false) {
	    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
	
	    var traverse = function traverse(node, parentKey) {
	      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
	
	      for (key in node) {
	        var child = node[key];
	
	        if (depth === 1) {
	          if (key.indexOf('Mui') === 0 && child) {
	            traverse(child, key, depth + 1);
	          }
	        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
	          if (process.env.NODE_ENV !== 'production') {
	            console.error(["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
	              root: (0, _defineProperty2.default)({}, "&$".concat(key), child)
	            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
	          } // Remove the style to prevent global conflicts.
	
	
	          node[key] = {};
	        }
	      }
	    };
	
	    traverse(muiTheme.overrides);
	  }
	
	  return muiTheme;
	}
	
	var _default = createMuiTheme;
	exports.default = _default;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useId;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function useId(idOverride) {
	  var _React$useState = React.useState(idOverride),
	      defaultId = _React$useState[0],
	      setDefaultId = _React$useState[1];
	
	  var id = idOverride || defaultId;
	  React.useEffect(function () {
	    if (defaultId == null) {
	      // Fallback to this default id when possible.
	      // Use the random value for client-side rendering only.
	      // We can't use it server-side.
	      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
	    }
	  }, [defaultId]);
	  return id;
	}

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(938));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41L10.59 12 7.7 9.11a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
	}), 'CancelRounded');
	
	exports.default = _default;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Autocomplete.default;
	  }
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _Autocomplete.createFilterOptions;
	  }
	});
	
	var _Autocomplete = _interopRequireWildcard(__webpack_require__(963));

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(32));
	
	var _config = _interopRequireDefault(__webpack_require__(368));
	
	var _PropTypes = __webpack_require__(369);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(243));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  } // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	  ;
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = this.props.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.findDOMNode;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      // allows for nested Transitions
	      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, children(status, childProps));
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return (
	      /*#__PURE__*/
	      // allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, _react.default.cloneElement(child, childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * By default the child component does not perform the enter transition when
	   * it first mounts, regardless of the value of `in`. If you want this
	   * behavior, set both `appear` and `in` to `true`.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The function to find the rendered DOM node that is passed to the transition callbacks.
	   *
	   * By default ReactDOM.findDOMNode is used. For `React.StrictMode` compatiblity
	   * another function must be provided.
	   */
	  findDOMNode: _propTypes.default.func,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func
	} : {}; // Name the function so it is clearer in the documentation
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  findDOMNode: _reactDom.default.findDOMNode,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = UNMOUNTED;
	Transition.EXITED = EXITED;
	Transition.ENTERING = ENTERING;
	Transition.ENTERED = ENTERED;
	Transition.EXITING = EXITING;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(990));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(993));

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(1001));

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBreakpoints = handleBreakpoints;
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(79));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(248));
	
	var _merge = _interopRequireDefault(__webpack_require__(173));
	
	// The breakpoint **start** at this value.
	// For instance with the first breakpoint xs: [xs, sm[.
	var values = {
	  xs: 0,
	  sm: 600,
	  md: 960,
	  lg: 1280,
	  xl: 1920
	};
	var defaultBreakpoints = {
	  // Sorted ASC by size. That's important.
	  // It can't be configured as it's used statically for propTypes.
	  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
	  up: function up(key) {
	    return "@media (min-width:".concat(values[key], "px)");
	  }
	};
	
	function handleBreakpoints(props, propValue, styleFromPropValue) {
	  if (false) {
	    if (!props.theme) {
	      console.error('Material-UI: You are calling a style function without a theme value.');
	    }
	  }
	
	  if (Array.isArray(propValue)) {
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    return propValue.reduce(function (acc, item, index) {
	      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
	      return acc;
	    }, {});
	  }
	
	  if ((0, _typeof2.default)(propValue) === 'object') {
	    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	
	    return Object.keys(propValue).reduce(function (acc, breakpoint) {
	      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
	      return acc;
	    }, {});
	  }
	
	  var output = styleFromPropValue(propValue);
	  return output;
	}
	
	function breakpoints(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var base = styleFunction(props);
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
	      if (props[key]) {
	        acc = acc || {};
	        acc[themeBreakpoints.up(key)] = styleFunction((0, _extends2.default)({
	          theme: props.theme
	        }, props[key]));
	      }
	
	      return acc;
	    }, null);
	    return (0, _merge.default)(base, extended);
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    xs: _propTypes.default.object,
	    sm: _propTypes.default.object,
	    md: _propTypes.default.object,
	    lg: _propTypes.default.object,
	    xl: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = breakpoints;
	exports.default = _default;

/***/ },
/* 248 */
[1913, 1019],
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = chainPropTypes;
	
	function chainPropTypes(propType1, propType2) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function validate() {
	    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
	  };
	}

/***/ },
/* 250 */
[1913, 1034],
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	// tslint:disable:only-arrow-functions
	// tslint:disable:object-literal-shorthand
	// tslint:disable:trailing-comma
	// tslint:disable:object-literal-sort-keys
	// tslint:disable:one-variable-per-declaration
	// tslint:disable:max-line-length
	// tslint:disable:no-consecutive-blank-lines
	// tslint:disable:align
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Generated by PEG.js v. 0.10.0 (ts-pegjs plugin v. 0.2.6 )
	//
	// https://pegjs.org/   https://github.com/metadevpro/ts-pegjs
	var types_1 = __webpack_require__(252);
	var SyntaxError = /** @class */ (function (_super) {
	    __extends(SyntaxError, _super);
	    function SyntaxError(message, expected, found, location) {
	        var _this = _super.call(this) || this;
	        _this.message = message;
	        _this.expected = expected;
	        _this.found = found;
	        _this.location = location;
	        _this.name = "SyntaxError";
	        if (typeof Error.captureStackTrace === "function") {
	            Error.captureStackTrace(_this, SyntaxError);
	        }
	        return _this;
	    }
	    SyntaxError.buildMessage = function (expected, found) {
	        function hex(ch) {
	            return ch.charCodeAt(0).toString(16).toUpperCase();
	        }
	        function literalEscape(s) {
	            return s
	                .replace(/\\/g, "\\\\")
	                .replace(/"/g, "\\\"")
	                .replace(/\0/g, "\\0")
	                .replace(/\t/g, "\\t")
	                .replace(/\n/g, "\\n")
	                .replace(/\r/g, "\\r")
	                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
	                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
	        }
	        function classEscape(s) {
	            return s
	                .replace(/\\/g, "\\\\")
	                .replace(/\]/g, "\\]")
	                .replace(/\^/g, "\\^")
	                .replace(/-/g, "\\-")
	                .replace(/\0/g, "\\0")
	                .replace(/\t/g, "\\t")
	                .replace(/\n/g, "\\n")
	                .replace(/\r/g, "\\r")
	                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
	                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
	        }
	        function describeExpectation(expectation) {
	            switch (expectation.type) {
	                case "literal":
	                    return "\"" + literalEscape(expectation.text) + "\"";
	                case "class":
	                    var escapedParts = expectation.parts.map(function (part) {
	                        return Array.isArray(part)
	                            ? classEscape(part[0]) + "-" + classEscape(part[1])
	                            : classEscape(part);
	                    });
	                    return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
	                case "any":
	                    return "any character";
	                case "end":
	                    return "end of input";
	                case "other":
	                    return expectation.description;
	            }
	        }
	        function describeExpected(expected1) {
	            var descriptions = expected1.map(describeExpectation);
	            var i;
	            var j;
	            descriptions.sort();
	            if (descriptions.length > 0) {
	                for (i = 1, j = 1; i < descriptions.length; i++) {
	                    if (descriptions[i - 1] !== descriptions[i]) {
	                        descriptions[j] = descriptions[i];
	                        j++;
	                    }
	                }
	                descriptions.length = j;
	            }
	            switch (descriptions.length) {
	                case 1:
	                    return descriptions[0];
	                case 2:
	                    return descriptions[0] + " or " + descriptions[1];
	                default:
	                    return descriptions.slice(0, -1).join(", ")
	                        + ", or "
	                        + descriptions[descriptions.length - 1];
	            }
	        }
	        function describeFound(found1) {
	            return found1 ? "\"" + literalEscape(found1) + "\"" : "end of input";
	        }
	        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
	    };
	    return SyntaxError;
	}(Error));
	exports.SyntaxError = SyntaxError;
	function peg$parse(input, options) {
	    options = options !== undefined ? options : {};
	    var peg$FAILED = {};
	    var peg$startRuleFunctions = { start: peg$parsestart };
	    var peg$startRuleFunction = peg$parsestart;
	    var peg$c0 = function (parts) {
	        return parts.join('');
	    };
	    var peg$c1 = function (messageText) {
	        return __assign({ type: types_1.TYPE.literal, value: messageText }, insertLocation());
	    };
	    var peg$c2 = "#";
	    var peg$c3 = peg$literalExpectation("#", false);
	    var peg$c4 = function () {
	        return __assign({ type: types_1.TYPE.pound }, insertLocation());
	    };
	    var peg$c5 = peg$otherExpectation("argumentElement");
	    var peg$c6 = "{";
	    var peg$c7 = peg$literalExpectation("{", false);
	    var peg$c8 = "}";
	    var peg$c9 = peg$literalExpectation("}", false);
	    var peg$c10 = function (value) {
	        return __assign({ type: types_1.TYPE.argument, value: value }, insertLocation());
	    };
	    var peg$c11 = peg$otherExpectation("numberSkeletonId");
	    var peg$c12 = /^['\/{}]/;
	    var peg$c13 = peg$classExpectation(["'", "/", "{", "}"], false, false);
	    var peg$c14 = peg$anyExpectation();
	    var peg$c15 = peg$otherExpectation("numberSkeletonTokenOption");
	    var peg$c16 = "/";
	    var peg$c17 = peg$literalExpectation("/", false);
	    var peg$c18 = function (option) { return option; };
	    var peg$c19 = peg$otherExpectation("numberSkeletonToken");
	    var peg$c20 = function (stem, options) {
	        return { stem: stem, options: options };
	    };
	    var peg$c21 = function (tokens) {
	        return __assign({ type: 0 /* number */, tokens: tokens }, insertLocation());
	    };
	    var peg$c22 = "::";
	    var peg$c23 = peg$literalExpectation("::", false);
	    var peg$c24 = function (skeleton) { return skeleton; };
	    var peg$c25 = function () { messageCtx.push('numberArgStyle'); return true; };
	    var peg$c26 = function (style) {
	        messageCtx.pop();
	        return style.replace(/\s*$/, '');
	    };
	    var peg$c27 = ",";
	    var peg$c28 = peg$literalExpectation(",", false);
	    var peg$c29 = "number";
	    var peg$c30 = peg$literalExpectation("number", false);
	    var peg$c31 = function (value, type, style) {
	        return __assign({ type: type === 'number' ? types_1.TYPE.number : type === 'date' ? types_1.TYPE.date : types_1.TYPE.time, style: style && style[2], value: value }, insertLocation());
	    };
	    var peg$c32 = "'";
	    var peg$c33 = peg$literalExpectation("'", false);
	    var peg$c34 = /^[^']/;
	    var peg$c35 = peg$classExpectation(["'"], true, false);
	    var peg$c36 = /^[^a-zA-Z'{}]/;
	    var peg$c37 = peg$classExpectation([["a", "z"], ["A", "Z"], "'", "{", "}"], true, false);
	    var peg$c38 = /^[a-zA-Z]/;
	    var peg$c39 = peg$classExpectation([["a", "z"], ["A", "Z"]], false, false);
	    var peg$c40 = function (pattern) {
	        return __assign({ type: 1 /* dateTime */, pattern: pattern }, insertLocation());
	    };
	    var peg$c41 = function () { messageCtx.push('dateOrTimeArgStyle'); return true; };
	    var peg$c42 = "date";
	    var peg$c43 = peg$literalExpectation("date", false);
	    var peg$c44 = "time";
	    var peg$c45 = peg$literalExpectation("time", false);
	    var peg$c46 = "plural";
	    var peg$c47 = peg$literalExpectation("plural", false);
	    var peg$c48 = "selectordinal";
	    var peg$c49 = peg$literalExpectation("selectordinal", false);
	    var peg$c50 = "offset:";
	    var peg$c51 = peg$literalExpectation("offset:", false);
	    var peg$c52 = function (value, pluralType, offset, options) {
	        return __assign({ type: types_1.TYPE.plural, pluralType: pluralType === 'plural' ? 'cardinal' : 'ordinal', value: value, offset: offset ? offset[2] : 0, options: options.reduce(function (all, _a) {
	                var id = _a.id, value = _a.value, optionLocation = _a.location;
	                if (id in all) {
	                    error("Duplicate option \"" + id + "\" in plural element: \"" + text() + "\"", location());
	                }
	                all[id] = {
	                    value: value,
	                    location: optionLocation
	                };
	                return all;
	            }, {}) }, insertLocation());
	    };
	    var peg$c53 = "select";
	    var peg$c54 = peg$literalExpectation("select", false);
	    var peg$c55 = function (value, options) {
	        return __assign({ type: types_1.TYPE.select, value: value, options: options.reduce(function (all, _a) {
	                var id = _a.id, value = _a.value, optionLocation = _a.location;
	                if (id in all) {
	                    error("Duplicate option \"" + id + "\" in select element: \"" + text() + "\"", location());
	                }
	                all[id] = {
	                    value: value,
	                    location: optionLocation
	                };
	                return all;
	            }, {}) }, insertLocation());
	    };
	    var peg$c56 = "=";
	    var peg$c57 = peg$literalExpectation("=", false);
	    var peg$c58 = function (id) { messageCtx.push('select'); return true; };
	    var peg$c59 = function (id, value) {
	        messageCtx.pop();
	        return __assign({ id: id,
	            value: value }, insertLocation());
	    };
	    var peg$c60 = function (id) { messageCtx.push('plural'); return true; };
	    var peg$c61 = function (id, value) {
	        messageCtx.pop();
	        return __assign({ id: id,
	            value: value }, insertLocation());
	    };
	    var peg$c62 = peg$otherExpectation("whitespace");
	    var peg$c63 = /^[\t-\r \x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
	    var peg$c64 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\xA0", "\u1680", ["\u2000", "\u200A"], "\u2028", "\u2029", "\u202F", "\u205F", "\u3000"], false, false);
	    var peg$c65 = peg$otherExpectation("syntax pattern");
	    var peg$c66 = /^[!-\/:-@[-\^`{-~\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u2010-\u2027\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]/;
	    var peg$c67 = peg$classExpectation([["!", "/"], [":", "@"], ["[", "^"], "`", ["{", "~"], ["\xA1", "\xA7"], "\xA9", "\xAB", "\xAC", "\xAE", "\xB0", "\xB1", "\xB6", "\xBB", "\xBF", "\xD7", "\xF7", ["\u2010", "\u2027"], ["\u2030", "\u203E"], ["\u2041", "\u2053"], ["\u2055", "\u205E"], ["\u2190", "\u245F"], ["\u2500", "\u2775"], ["\u2794", "\u2BFF"], ["\u2E00", "\u2E7F"], ["\u3001", "\u3003"], ["\u3008", "\u3020"], "\u3030", "\uFD3E", "\uFD3F", "\uFE45", "\uFE46"], false, false);
	    var peg$c68 = peg$otherExpectation("optional whitespace");
	    var peg$c69 = peg$otherExpectation("number");
	    var peg$c70 = "-";
	    var peg$c71 = peg$literalExpectation("-", false);
	    var peg$c72 = function (negative, num) {
	        return num
	            ? negative
	                ? -num
	                : num
	            : 0;
	    };
	    var peg$c73 = peg$otherExpectation("apostrophe");
	    var peg$c74 = peg$otherExpectation("double apostrophes");
	    var peg$c75 = "''";
	    var peg$c76 = peg$literalExpectation("''", false);
	    var peg$c77 = function () { return "'"; };
	    var peg$c78 = function (escapedChar, quotedChars) {
	        return escapedChar + quotedChars.replace("''", "'");
	    };
	    var peg$c79 = function (x) {
	        return (x !== '{' &&
	            !(isInPluralOption() && x === '#') &&
	            !(isNestedMessageText() && x === '}'));
	    };
	    var peg$c80 = "\n";
	    var peg$c81 = peg$literalExpectation("\n", false);
	    var peg$c82 = function (x) {
	        return x === '{' || x === '}' || (isInPluralOption() && x === '#');
	    };
	    var peg$c83 = peg$otherExpectation("argNameOrNumber");
	    var peg$c84 = peg$otherExpectation("argNumber");
	    var peg$c85 = "0";
	    var peg$c86 = peg$literalExpectation("0", false);
	    var peg$c87 = function () { return 0; };
	    var peg$c88 = /^[1-9]/;
	    var peg$c89 = peg$classExpectation([["1", "9"]], false, false);
	    var peg$c90 = /^[0-9]/;
	    var peg$c91 = peg$classExpectation([["0", "9"]], false, false);
	    var peg$c92 = function (digits) {
	        return parseInt(digits.join(''), 10);
	    };
	    var peg$c93 = peg$otherExpectation("argName");
	    var peg$currPos = 0;
	    var peg$savedPos = 0;
	    var peg$posDetailsCache = [{ line: 1, column: 1 }];
	    var peg$maxFailPos = 0;
	    var peg$maxFailExpected = [];
	    var peg$silentFails = 0;
	    var peg$result;
	    if (options.startRule !== undefined) {
	        if (!(options.startRule in peg$startRuleFunctions)) {
	            throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	        }
	        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	    function text() {
	        return input.substring(peg$savedPos, peg$currPos);
	    }
	    function location() {
	        return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	    function expected(description, location1) {
	        location1 = location1 !== undefined
	            ? location1
	            : peg$computeLocation(peg$savedPos, peg$currPos);
	        throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location1);
	    }
	    function error(message, location1) {
	        location1 = location1 !== undefined
	            ? location1
	            : peg$computeLocation(peg$savedPos, peg$currPos);
	        throw peg$buildSimpleError(message, location1);
	    }
	    function peg$literalExpectation(text1, ignoreCase) {
	        return { type: "literal", text: text1, ignoreCase: ignoreCase };
	    }
	    function peg$classExpectation(parts, inverted, ignoreCase) {
	        return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
	    }
	    function peg$anyExpectation() {
	        return { type: "any" };
	    }
	    function peg$endExpectation() {
	        return { type: "end" };
	    }
	    function peg$otherExpectation(description) {
	        return { type: "other", description: description };
	    }
	    function peg$computePosDetails(pos) {
	        var details = peg$posDetailsCache[pos];
	        var p;
	        if (details) {
	            return details;
	        }
	        else {
	            p = pos - 1;
	            while (!peg$posDetailsCache[p]) {
	                p--;
	            }
	            details = peg$posDetailsCache[p];
	            details = {
	                line: details.line,
	                column: details.column
	            };
	            while (p < pos) {
	                if (input.charCodeAt(p) === 10) {
	                    details.line++;
	                    details.column = 1;
	                }
	                else {
	                    details.column++;
	                }
	                p++;
	            }
	            peg$posDetailsCache[pos] = details;
	            return details;
	        }
	    }
	    function peg$computeLocation(startPos, endPos) {
	        var startPosDetails = peg$computePosDetails(startPos);
	        var endPosDetails = peg$computePosDetails(endPos);
	        return {
	            start: {
	                offset: startPos,
	                line: startPosDetails.line,
	                column: startPosDetails.column
	            },
	            end: {
	                offset: endPos,
	                line: endPosDetails.line,
	                column: endPosDetails.column
	            }
	        };
	    }
	    function peg$fail(expected1) {
	        if (peg$currPos < peg$maxFailPos) {
	            return;
	        }
	        if (peg$currPos > peg$maxFailPos) {
	            peg$maxFailPos = peg$currPos;
	            peg$maxFailExpected = [];
	        }
	        peg$maxFailExpected.push(expected1);
	    }
	    function peg$buildSimpleError(message, location1) {
	        return new SyntaxError(message, [], "", location1);
	    }
	    function peg$buildStructuredError(expected1, found, location1) {
	        return new SyntaxError(SyntaxError.buildMessage(expected1, found), expected1, found, location1);
	    }
	    function peg$parsestart() {
	        var s0;
	        s0 = peg$parsemessage();
	        return s0;
	    }
	    function peg$parsemessage() {
	        var s0, s1;
	        s0 = [];
	        s1 = peg$parsemessageElement();
	        while (s1 !== peg$FAILED) {
	            s0.push(s1);
	            s1 = peg$parsemessageElement();
	        }
	        return s0;
	    }
	    function peg$parsemessageElement() {
	        var s0;
	        s0 = peg$parseliteralElement();
	        if (s0 === peg$FAILED) {
	            s0 = peg$parseargumentElement();
	            if (s0 === peg$FAILED) {
	                s0 = peg$parsesimpleFormatElement();
	                if (s0 === peg$FAILED) {
	                    s0 = peg$parsepluralElement();
	                    if (s0 === peg$FAILED) {
	                        s0 = peg$parseselectElement();
	                        if (s0 === peg$FAILED) {
	                            s0 = peg$parsepoundElement();
	                        }
	                    }
	                }
	            }
	        }
	        return s0;
	    }
	    function peg$parsemessageText() {
	        var s0, s1, s2;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$parsedoubleApostrophes();
	        if (s2 === peg$FAILED) {
	            s2 = peg$parsequotedString();
	            if (s2 === peg$FAILED) {
	                s2 = peg$parseunquotedString();
	            }
	        }
	        if (s2 !== peg$FAILED) {
	            while (s2 !== peg$FAILED) {
	                s1.push(s2);
	                s2 = peg$parsedoubleApostrophes();
	                if (s2 === peg$FAILED) {
	                    s2 = peg$parsequotedString();
	                    if (s2 === peg$FAILED) {
	                        s2 = peg$parseunquotedString();
	                    }
	                }
	            }
	        }
	        else {
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c0(s1);
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parseliteralElement() {
	        var s0, s1;
	        s0 = peg$currPos;
	        s1 = peg$parsemessageText();
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c1(s1);
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parsepoundElement() {
	        var s0, s1;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 35) {
	            s1 = peg$c2;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c3);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c4();
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parseargumentElement() {
	        var s0, s1, s2, s3, s4, s5;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 125) {
	                            s5 = peg$c8;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c9);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            peg$savedPos = s0;
	                            s1 = peg$c10(s3);
	                            s0 = s1;
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c5);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberSkeletonId() {
	        var s0, s1, s2, s3, s4;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$currPos;
	        s3 = peg$currPos;
	        peg$silentFails++;
	        s4 = peg$parsewhiteSpace();
	        if (s4 === peg$FAILED) {
	            if (peg$c12.test(input.charAt(peg$currPos))) {
	                s4 = input.charAt(peg$currPos);
	                peg$currPos++;
	            }
	            else {
	                s4 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c13);
	                }
	            }
	        }
	        peg$silentFails--;
	        if (s4 === peg$FAILED) {
	            s3 = undefined;
	        }
	        else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	        }
	        if (s3 !== peg$FAILED) {
	            if (input.length > peg$currPos) {
	                s4 = input.charAt(peg$currPos);
	                peg$currPos++;
	            }
	            else {
	                s4 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c14);
	                }
	            }
	            if (s4 !== peg$FAILED) {
	                s3 = [s3, s4];
	                s2 = s3;
	            }
	            else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	            while (s2 !== peg$FAILED) {
	                s1.push(s2);
	                s2 = peg$currPos;
	                s3 = peg$currPos;
	                peg$silentFails++;
	                s4 = peg$parsewhiteSpace();
	                if (s4 === peg$FAILED) {
	                    if (peg$c12.test(input.charAt(peg$currPos))) {
	                        s4 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c13);
	                        }
	                    }
	                }
	                peg$silentFails--;
	                if (s4 === peg$FAILED) {
	                    s3 = undefined;
	                }
	                else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                }
	                if (s3 !== peg$FAILED) {
	                    if (input.length > peg$currPos) {
	                        s4 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c14);
	                        }
	                    }
	                    if (s4 !== peg$FAILED) {
	                        s3 = [s3, s4];
	                        s2 = s3;
	                    }
	                    else {
	                        peg$currPos = s2;
	                        s2 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s2;
	                    s2 = peg$FAILED;
	                }
	            }
	        }
	        else {
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c11);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberSkeletonTokenOption() {
	        var s0, s1, s2;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 47) {
	            s1 = peg$c16;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c17);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsenumberSkeletonId();
	            if (s2 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c18(s2);
	                s0 = s1;
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c15);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberSkeletonToken() {
	        var s0, s1, s2, s3, s4;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = peg$parse_();
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsenumberSkeletonId();
	            if (s2 !== peg$FAILED) {
	                s3 = [];
	                s4 = peg$parsenumberSkeletonTokenOption();
	                while (s4 !== peg$FAILED) {
	                    s3.push(s4);
	                    s4 = peg$parsenumberSkeletonTokenOption();
	                }
	                if (s3 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c20(s2, s3);
	                    s0 = s1;
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c19);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberSkeleton() {
	        var s0, s1, s2;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$parsenumberSkeletonToken();
	        if (s2 !== peg$FAILED) {
	            while (s2 !== peg$FAILED) {
	                s1.push(s2);
	                s2 = peg$parsenumberSkeletonToken();
	            }
	        }
	        else {
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c21(s1);
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parsenumberArgStyle() {
	        var s0, s1, s2;
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c22) {
	            s1 = peg$c22;
	            peg$currPos += 2;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c23);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsenumberSkeleton();
	            if (s2 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s2);
	                s0 = s1;
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            peg$savedPos = peg$currPos;
	            s1 = peg$c25();
	            if (s1) {
	                s1 = undefined;
	            }
	            else {
	                s1 = peg$FAILED;
	            }
	            if (s1 !== peg$FAILED) {
	                s2 = peg$parsemessageText();
	                if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c26(s2);
	                    s0 = s1;
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberFormatElement() {
	        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 44) {
	                            s5 = peg$c27;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c28);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parse_();
	                            if (s6 !== peg$FAILED) {
	                                if (input.substr(peg$currPos, 6) === peg$c29) {
	                                    s7 = peg$c29;
	                                    peg$currPos += 6;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c30);
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    s8 = peg$parse_();
	                                    if (s8 !== peg$FAILED) {
	                                        s9 = peg$currPos;
	                                        if (input.charCodeAt(peg$currPos) === 44) {
	                                            s10 = peg$c27;
	                                            peg$currPos++;
	                                        }
	                                        else {
	                                            s10 = peg$FAILED;
	                                            if (peg$silentFails === 0) {
	                                                peg$fail(peg$c28);
	                                            }
	                                        }
	                                        if (s10 !== peg$FAILED) {
	                                            s11 = peg$parse_();
	                                            if (s11 !== peg$FAILED) {
	                                                s12 = peg$parsenumberArgStyle();
	                                                if (s12 !== peg$FAILED) {
	                                                    s10 = [s10, s11, s12];
	                                                    s9 = s10;
	                                                }
	                                                else {
	                                                    peg$currPos = s9;
	                                                    s9 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s9;
	                                                s9 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s9;
	                                            s9 = peg$FAILED;
	                                        }
	                                        if (s9 === peg$FAILED) {
	                                            s9 = null;
	                                        }
	                                        if (s9 !== peg$FAILED) {
	                                            s10 = peg$parse_();
	                                            if (s10 !== peg$FAILED) {
	                                                if (input.charCodeAt(peg$currPos) === 125) {
	                                                    s11 = peg$c8;
	                                                    peg$currPos++;
	                                                }
	                                                else {
	                                                    s11 = peg$FAILED;
	                                                    if (peg$silentFails === 0) {
	                                                        peg$fail(peg$c9);
	                                                    }
	                                                }
	                                                if (s11 !== peg$FAILED) {
	                                                    peg$savedPos = s0;
	                                                    s1 = peg$c31(s3, s7, s9);
	                                                    s0 = s1;
	                                                }
	                                                else {
	                                                    peg$currPos = s0;
	                                                    s0 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s0;
	                                                s0 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s0;
	                                            s0 = peg$FAILED;
	                                        }
	                                    }
	                                    else {
	                                        peg$currPos = s0;
	                                        s0 = peg$FAILED;
	                                    }
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsedateTimeSkeletonLiteral() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 39) {
	            s1 = peg$c32;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c33);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = [];
	            s3 = peg$parsedoubleApostrophes();
	            if (s3 === peg$FAILED) {
	                if (peg$c34.test(input.charAt(peg$currPos))) {
	                    s3 = input.charAt(peg$currPos);
	                    peg$currPos++;
	                }
	                else {
	                    s3 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c35);
	                    }
	                }
	            }
	            if (s3 !== peg$FAILED) {
	                while (s3 !== peg$FAILED) {
	                    s2.push(s3);
	                    s3 = peg$parsedoubleApostrophes();
	                    if (s3 === peg$FAILED) {
	                        if (peg$c34.test(input.charAt(peg$currPos))) {
	                            s3 = input.charAt(peg$currPos);
	                            peg$currPos++;
	                        }
	                        else {
	                            s3 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c35);
	                            }
	                        }
	                    }
	                }
	            }
	            else {
	                s2 = peg$FAILED;
	            }
	            if (s2 !== peg$FAILED) {
	                if (input.charCodeAt(peg$currPos) === 39) {
	                    s3 = peg$c32;
	                    peg$currPos++;
	                }
	                else {
	                    s3 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c33);
	                    }
	                }
	                if (s3 !== peg$FAILED) {
	                    s1 = [s1, s2, s3];
	                    s0 = s1;
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        if (s0 === peg$FAILED) {
	            s0 = [];
	            s1 = peg$parsedoubleApostrophes();
	            if (s1 === peg$FAILED) {
	                if (peg$c36.test(input.charAt(peg$currPos))) {
	                    s1 = input.charAt(peg$currPos);
	                    peg$currPos++;
	                }
	                else {
	                    s1 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c37);
	                    }
	                }
	            }
	            if (s1 !== peg$FAILED) {
	                while (s1 !== peg$FAILED) {
	                    s0.push(s1);
	                    s1 = peg$parsedoubleApostrophes();
	                    if (s1 === peg$FAILED) {
	                        if (peg$c36.test(input.charAt(peg$currPos))) {
	                            s1 = input.charAt(peg$currPos);
	                            peg$currPos++;
	                        }
	                        else {
	                            s1 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c37);
	                            }
	                        }
	                    }
	                }
	            }
	            else {
	                s0 = peg$FAILED;
	            }
	        }
	        return s0;
	    }
	    function peg$parsedateTimeSkeletonPattern() {
	        var s0, s1;
	        s0 = [];
	        if (peg$c38.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c39);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            while (s1 !== peg$FAILED) {
	                s0.push(s1);
	                if (peg$c38.test(input.charAt(peg$currPos))) {
	                    s1 = input.charAt(peg$currPos);
	                    peg$currPos++;
	                }
	                else {
	                    s1 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c39);
	                    }
	                }
	            }
	        }
	        else {
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsedateTimeSkeleton() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        s1 = peg$currPos;
	        s2 = [];
	        s3 = peg$parsedateTimeSkeletonLiteral();
	        if (s3 === peg$FAILED) {
	            s3 = peg$parsedateTimeSkeletonPattern();
	        }
	        if (s3 !== peg$FAILED) {
	            while (s3 !== peg$FAILED) {
	                s2.push(s3);
	                s3 = peg$parsedateTimeSkeletonLiteral();
	                if (s3 === peg$FAILED) {
	                    s3 = peg$parsedateTimeSkeletonPattern();
	                }
	            }
	        }
	        else {
	            s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	            s1 = input.substring(s1, peg$currPos);
	        }
	        else {
	            s1 = s2;
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c40(s1);
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parsedateOrTimeArgStyle() {
	        var s0, s1, s2;
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c22) {
	            s1 = peg$c22;
	            peg$currPos += 2;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c23);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsedateTimeSkeleton();
	            if (s2 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s2);
	                s0 = s1;
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            peg$savedPos = peg$currPos;
	            s1 = peg$c41();
	            if (s1) {
	                s1 = undefined;
	            }
	            else {
	                s1 = peg$FAILED;
	            }
	            if (s1 !== peg$FAILED) {
	                s2 = peg$parsemessageText();
	                if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c26(s2);
	                    s0 = s1;
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        return s0;
	    }
	    function peg$parsedateOrTimeFormatElement() {
	        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 44) {
	                            s5 = peg$c27;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c28);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parse_();
	                            if (s6 !== peg$FAILED) {
	                                if (input.substr(peg$currPos, 4) === peg$c42) {
	                                    s7 = peg$c42;
	                                    peg$currPos += 4;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c43);
	                                    }
	                                }
	                                if (s7 === peg$FAILED) {
	                                    if (input.substr(peg$currPos, 4) === peg$c44) {
	                                        s7 = peg$c44;
	                                        peg$currPos += 4;
	                                    }
	                                    else {
	                                        s7 = peg$FAILED;
	                                        if (peg$silentFails === 0) {
	                                            peg$fail(peg$c45);
	                                        }
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    s8 = peg$parse_();
	                                    if (s8 !== peg$FAILED) {
	                                        s9 = peg$currPos;
	                                        if (input.charCodeAt(peg$currPos) === 44) {
	                                            s10 = peg$c27;
	                                            peg$currPos++;
	                                        }
	                                        else {
	                                            s10 = peg$FAILED;
	                                            if (peg$silentFails === 0) {
	                                                peg$fail(peg$c28);
	                                            }
	                                        }
	                                        if (s10 !== peg$FAILED) {
	                                            s11 = peg$parse_();
	                                            if (s11 !== peg$FAILED) {
	                                                s12 = peg$parsedateOrTimeArgStyle();
	                                                if (s12 !== peg$FAILED) {
	                                                    s10 = [s10, s11, s12];
	                                                    s9 = s10;
	                                                }
	                                                else {
	                                                    peg$currPos = s9;
	                                                    s9 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s9;
	                                                s9 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s9;
	                                            s9 = peg$FAILED;
	                                        }
	                                        if (s9 === peg$FAILED) {
	                                            s9 = null;
	                                        }
	                                        if (s9 !== peg$FAILED) {
	                                            s10 = peg$parse_();
	                                            if (s10 !== peg$FAILED) {
	                                                if (input.charCodeAt(peg$currPos) === 125) {
	                                                    s11 = peg$c8;
	                                                    peg$currPos++;
	                                                }
	                                                else {
	                                                    s11 = peg$FAILED;
	                                                    if (peg$silentFails === 0) {
	                                                        peg$fail(peg$c9);
	                                                    }
	                                                }
	                                                if (s11 !== peg$FAILED) {
	                                                    peg$savedPos = s0;
	                                                    s1 = peg$c31(s3, s7, s9);
	                                                    s0 = s1;
	                                                }
	                                                else {
	                                                    peg$currPos = s0;
	                                                    s0 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s0;
	                                                s0 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s0;
	                                            s0 = peg$FAILED;
	                                        }
	                                    }
	                                    else {
	                                        peg$currPos = s0;
	                                        s0 = peg$FAILED;
	                                    }
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsesimpleFormatElement() {
	        var s0;
	        s0 = peg$parsenumberFormatElement();
	        if (s0 === peg$FAILED) {
	            s0 = peg$parsedateOrTimeFormatElement();
	        }
	        return s0;
	    }
	    function peg$parsepluralElement() {
	        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 44) {
	                            s5 = peg$c27;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c28);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parse_();
	                            if (s6 !== peg$FAILED) {
	                                if (input.substr(peg$currPos, 6) === peg$c46) {
	                                    s7 = peg$c46;
	                                    peg$currPos += 6;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c47);
	                                    }
	                                }
	                                if (s7 === peg$FAILED) {
	                                    if (input.substr(peg$currPos, 13) === peg$c48) {
	                                        s7 = peg$c48;
	                                        peg$currPos += 13;
	                                    }
	                                    else {
	                                        s7 = peg$FAILED;
	                                        if (peg$silentFails === 0) {
	                                            peg$fail(peg$c49);
	                                        }
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    s8 = peg$parse_();
	                                    if (s8 !== peg$FAILED) {
	                                        if (input.charCodeAt(peg$currPos) === 44) {
	                                            s9 = peg$c27;
	                                            peg$currPos++;
	                                        }
	                                        else {
	                                            s9 = peg$FAILED;
	                                            if (peg$silentFails === 0) {
	                                                peg$fail(peg$c28);
	                                            }
	                                        }
	                                        if (s9 !== peg$FAILED) {
	                                            s10 = peg$parse_();
	                                            if (s10 !== peg$FAILED) {
	                                                s11 = peg$currPos;
	                                                if (input.substr(peg$currPos, 7) === peg$c50) {
	                                                    s12 = peg$c50;
	                                                    peg$currPos += 7;
	                                                }
	                                                else {
	                                                    s12 = peg$FAILED;
	                                                    if (peg$silentFails === 0) {
	                                                        peg$fail(peg$c51);
	                                                    }
	                                                }
	                                                if (s12 !== peg$FAILED) {
	                                                    s13 = peg$parse_();
	                                                    if (s13 !== peg$FAILED) {
	                                                        s14 = peg$parsenumber();
	                                                        if (s14 !== peg$FAILED) {
	                                                            s12 = [s12, s13, s14];
	                                                            s11 = s12;
	                                                        }
	                                                        else {
	                                                            peg$currPos = s11;
	                                                            s11 = peg$FAILED;
	                                                        }
	                                                    }
	                                                    else {
	                                                        peg$currPos = s11;
	                                                        s11 = peg$FAILED;
	                                                    }
	                                                }
	                                                else {
	                                                    peg$currPos = s11;
	                                                    s11 = peg$FAILED;
	                                                }
	                                                if (s11 === peg$FAILED) {
	                                                    s11 = null;
	                                                }
	                                                if (s11 !== peg$FAILED) {
	                                                    s12 = peg$parse_();
	                                                    if (s12 !== peg$FAILED) {
	                                                        s13 = [];
	                                                        s14 = peg$parsepluralOption();
	                                                        if (s14 !== peg$FAILED) {
	                                                            while (s14 !== peg$FAILED) {
	                                                                s13.push(s14);
	                                                                s14 = peg$parsepluralOption();
	                                                            }
	                                                        }
	                                                        else {
	                                                            s13 = peg$FAILED;
	                                                        }
	                                                        if (s13 !== peg$FAILED) {
	                                                            s14 = peg$parse_();
	                                                            if (s14 !== peg$FAILED) {
	                                                                if (input.charCodeAt(peg$currPos) === 125) {
	                                                                    s15 = peg$c8;
	                                                                    peg$currPos++;
	                                                                }
	                                                                else {
	                                                                    s15 = peg$FAILED;
	                                                                    if (peg$silentFails === 0) {
	                                                                        peg$fail(peg$c9);
	                                                                    }
	                                                                }
	                                                                if (s15 !== peg$FAILED) {
	                                                                    peg$savedPos = s0;
	                                                                    s1 = peg$c52(s3, s7, s11, s13);
	                                                                    s0 = s1;
	                                                                }
	                                                                else {
	                                                                    peg$currPos = s0;
	                                                                    s0 = peg$FAILED;
	                                                                }
	                                                            }
	                                                            else {
	                                                                peg$currPos = s0;
	                                                                s0 = peg$FAILED;
	                                                            }
	                                                        }
	                                                        else {
	                                                            peg$currPos = s0;
	                                                            s0 = peg$FAILED;
	                                                        }
	                                                    }
	                                                    else {
	                                                        peg$currPos = s0;
	                                                        s0 = peg$FAILED;
	                                                    }
	                                                }
	                                                else {
	                                                    peg$currPos = s0;
	                                                    s0 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s0;
	                                                s0 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s0;
	                                            s0 = peg$FAILED;
	                                        }
	                                    }
	                                    else {
	                                        peg$currPos = s0;
	                                        s0 = peg$FAILED;
	                                    }
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parseselectElement() {
	        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 44) {
	                            s5 = peg$c27;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c28);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parse_();
	                            if (s6 !== peg$FAILED) {
	                                if (input.substr(peg$currPos, 6) === peg$c53) {
	                                    s7 = peg$c53;
	                                    peg$currPos += 6;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c54);
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    s8 = peg$parse_();
	                                    if (s8 !== peg$FAILED) {
	                                        if (input.charCodeAt(peg$currPos) === 44) {
	                                            s9 = peg$c27;
	                                            peg$currPos++;
	                                        }
	                                        else {
	                                            s9 = peg$FAILED;
	                                            if (peg$silentFails === 0) {
	                                                peg$fail(peg$c28);
	                                            }
	                                        }
	                                        if (s9 !== peg$FAILED) {
	                                            s10 = peg$parse_();
	                                            if (s10 !== peg$FAILED) {
	                                                s11 = [];
	                                                s12 = peg$parseselectOption();
	                                                if (s12 !== peg$FAILED) {
	                                                    while (s12 !== peg$FAILED) {
	                                                        s11.push(s12);
	                                                        s12 = peg$parseselectOption();
	                                                    }
	                                                }
	                                                else {
	                                                    s11 = peg$FAILED;
	                                                }
	                                                if (s11 !== peg$FAILED) {
	                                                    s12 = peg$parse_();
	                                                    if (s12 !== peg$FAILED) {
	                                                        if (input.charCodeAt(peg$currPos) === 125) {
	                                                            s13 = peg$c8;
	                                                            peg$currPos++;
	                                                        }
	                                                        else {
	                                                            s13 = peg$FAILED;
	                                                            if (peg$silentFails === 0) {
	                                                                peg$fail(peg$c9);
	                                                            }
	                                                        }
	                                                        if (s13 !== peg$FAILED) {
	                                                            peg$savedPos = s0;
	                                                            s1 = peg$c55(s3, s11);
	                                                            s0 = s1;
	                                                        }
	                                                        else {
	                                                            peg$currPos = s0;
	                                                            s0 = peg$FAILED;
	                                                        }
	                                                    }
	                                                    else {
	                                                        peg$currPos = s0;
	                                                        s0 = peg$FAILED;
	                                                    }
	                                                }
	                                                else {
	                                                    peg$currPos = s0;
	                                                    s0 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s0;
	                                                s0 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s0;
	                                            s0 = peg$FAILED;
	                                        }
	                                    }
	                                    else {
	                                        peg$currPos = s0;
	                                        s0 = peg$FAILED;
	                                    }
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsepluralRuleSelectValue() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        s1 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 61) {
	            s2 = peg$c56;
	            peg$currPos++;
	        }
	        else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c57);
	            }
	        }
	        if (s2 !== peg$FAILED) {
	            s3 = peg$parsenumber();
	            if (s3 !== peg$FAILED) {
	                s2 = [s2, s3];
	                s1 = s2;
	            }
	            else {
	                peg$currPos = s1;
	                s1 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s1;
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        if (s0 === peg$FAILED) {
	            s0 = peg$parseargName();
	        }
	        return s0;
	    }
	    function peg$parseselectOption() {
	        var s0, s1, s2, s3, s4, s5, s6, s7;
	        s0 = peg$currPos;
	        s1 = peg$parse_();
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parseargName();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parse_();
	                if (s3 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 123) {
	                        s4 = peg$c6;
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c7);
	                        }
	                    }
	                    if (s4 !== peg$FAILED) {
	                        peg$savedPos = peg$currPos;
	                        s5 = peg$c58(s2);
	                        if (s5) {
	                            s5 = undefined;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parsemessage();
	                            if (s6 !== peg$FAILED) {
	                                if (input.charCodeAt(peg$currPos) === 125) {
	                                    s7 = peg$c8;
	                                    peg$currPos++;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c9);
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    peg$savedPos = s0;
	                                    s1 = peg$c59(s2, s6);
	                                    s0 = s1;
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsepluralOption() {
	        var s0, s1, s2, s3, s4, s5, s6, s7;
	        s0 = peg$currPos;
	        s1 = peg$parse_();
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsepluralRuleSelectValue();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parse_();
	                if (s3 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 123) {
	                        s4 = peg$c6;
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c7);
	                        }
	                    }
	                    if (s4 !== peg$FAILED) {
	                        peg$savedPos = peg$currPos;
	                        s5 = peg$c60(s2);
	                        if (s5) {
	                            s5 = undefined;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parsemessage();
	                            if (s6 !== peg$FAILED) {
	                                if (input.charCodeAt(peg$currPos) === 125) {
	                                    s7 = peg$c8;
	                                    peg$currPos++;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c9);
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    peg$savedPos = s0;
	                                    s1 = peg$c61(s2, s6);
	                                    s0 = s1;
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsewhiteSpace() {
	        var s0, s1;
	        peg$silentFails++;
	        if (peg$c63.test(input.charAt(peg$currPos))) {
	            s0 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s0 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c64);
	            }
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c62);
	            }
	        }
	        return s0;
	    }
	    function peg$parsepatternSyntax() {
	        var s0, s1;
	        peg$silentFails++;
	        if (peg$c66.test(input.charAt(peg$currPos))) {
	            s0 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s0 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c67);
	            }
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c65);
	            }
	        }
	        return s0;
	    }
	    function peg$parse_() {
	        var s0, s1, s2;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$parsewhiteSpace();
	        while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            s2 = peg$parsewhiteSpace();
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c68);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumber() {
	        var s0, s1, s2;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 45) {
	            s1 = peg$c70;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c71);
	            }
	        }
	        if (s1 === peg$FAILED) {
	            s1 = null;
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parseargNumber();
	            if (s2 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c72(s1, s2);
	                s0 = s1;
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c69);
	            }
	        }
	        return s0;
	    }
	    function peg$parseapostrophe() {
	        var s0, s1;
	        peg$silentFails++;
	        if (input.charCodeAt(peg$currPos) === 39) {
	            s0 = peg$c32;
	            peg$currPos++;
	        }
	        else {
	            s0 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c33);
	            }
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c73);
	            }
	        }
	        return s0;
	    }
	    function peg$parsedoubleApostrophes() {
	        var s0, s1;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c75) {
	            s1 = peg$c75;
	            peg$currPos += 2;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c76);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c77();
	        }
	        s0 = s1;
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c74);
	            }
	        }
	        return s0;
	    }
	    function peg$parsequotedString() {
	        var s0, s1, s2, s3, s4, s5;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 39) {
	            s1 = peg$c32;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c33);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parseescapedChar();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$currPos;
	                s4 = [];
	                if (input.substr(peg$currPos, 2) === peg$c75) {
	                    s5 = peg$c75;
	                    peg$currPos += 2;
	                }
	                else {
	                    s5 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c76);
	                    }
	                }
	                if (s5 === peg$FAILED) {
	                    if (peg$c34.test(input.charAt(peg$currPos))) {
	                        s5 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s5 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c35);
	                        }
	                    }
	                }
	                while (s5 !== peg$FAILED) {
	                    s4.push(s5);
	                    if (input.substr(peg$currPos, 2) === peg$c75) {
	                        s5 = peg$c75;
	                        peg$currPos += 2;
	                    }
	                    else {
	                        s5 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c76);
	                        }
	                    }
	                    if (s5 === peg$FAILED) {
	                        if (peg$c34.test(input.charAt(peg$currPos))) {
	                            s5 = input.charAt(peg$currPos);
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c35);
	                            }
	                        }
	                    }
	                }
	                if (s4 !== peg$FAILED) {
	                    s3 = input.substring(s3, peg$currPos);
	                }
	                else {
	                    s3 = s4;
	                }
	                if (s3 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 39) {
	                        s4 = peg$c32;
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c33);
	                        }
	                    }
	                    if (s4 === peg$FAILED) {
	                        s4 = null;
	                    }
	                    if (s4 !== peg$FAILED) {
	                        peg$savedPos = s0;
	                        s1 = peg$c78(s2, s3);
	                        s0 = s1;
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parseunquotedString() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        s1 = peg$currPos;
	        if (input.length > peg$currPos) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c14);
	            }
	        }
	        if (s2 !== peg$FAILED) {
	            peg$savedPos = peg$currPos;
	            s3 = peg$c79(s2);
	            if (s3) {
	                s3 = undefined;
	            }
	            else {
	                s3 = peg$FAILED;
	            }
	            if (s3 !== peg$FAILED) {
	                s2 = [s2, s3];
	                s1 = s2;
	            }
	            else {
	                peg$currPos = s1;
	                s1 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s1;
	            s1 = peg$FAILED;
	        }
	        if (s1 === peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 10) {
	                s1 = peg$c80;
	                peg$currPos++;
	            }
	            else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c81);
	                }
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        return s0;
	    }
	    function peg$parseescapedChar() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        s1 = peg$currPos;
	        if (input.length > peg$currPos) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c14);
	            }
	        }
	        if (s2 !== peg$FAILED) {
	            peg$savedPos = peg$currPos;
	            s3 = peg$c82(s2);
	            if (s3) {
	                s3 = undefined;
	            }
	            else {
	                s3 = peg$FAILED;
	            }
	            if (s3 !== peg$FAILED) {
	                s2 = [s2, s3];
	                s1 = s2;
	            }
	            else {
	                peg$currPos = s1;
	                s1 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s1;
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        return s0;
	    }
	    function peg$parseargNameOrNumber() {
	        var s0, s1;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = peg$parseargNumber();
	        if (s1 === peg$FAILED) {
	            s1 = peg$parseargName();
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c83);
	            }
	        }
	        return s0;
	    }
	    function peg$parseargNumber() {
	        var s0, s1, s2, s3, s4;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 48) {
	            s1 = peg$c85;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c86);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c87();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            s1 = peg$currPos;
	            if (peg$c88.test(input.charAt(peg$currPos))) {
	                s2 = input.charAt(peg$currPos);
	                peg$currPos++;
	            }
	            else {
	                s2 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c89);
	                }
	            }
	            if (s2 !== peg$FAILED) {
	                s3 = [];
	                if (peg$c90.test(input.charAt(peg$currPos))) {
	                    s4 = input.charAt(peg$currPos);
	                    peg$currPos++;
	                }
	                else {
	                    s4 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c91);
	                    }
	                }
	                while (s4 !== peg$FAILED) {
	                    s3.push(s4);
	                    if (peg$c90.test(input.charAt(peg$currPos))) {
	                        s4 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c91);
	                        }
	                    }
	                }
	                if (s3 !== peg$FAILED) {
	                    s2 = [s2, s3];
	                    s1 = s2;
	                }
	                else {
	                    peg$currPos = s1;
	                    s1 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s1;
	                s1 = peg$FAILED;
	            }
	            if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c92(s1);
	            }
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c84);
	            }
	        }
	        return s0;
	    }
	    function peg$parseargName() {
	        var s0, s1, s2, s3, s4;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$currPos;
	        s3 = peg$currPos;
	        peg$silentFails++;
	        s4 = peg$parsewhiteSpace();
	        if (s4 === peg$FAILED) {
	            s4 = peg$parsepatternSyntax();
	        }
	        peg$silentFails--;
	        if (s4 === peg$FAILED) {
	            s3 = undefined;
	        }
	        else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	        }
	        if (s3 !== peg$FAILED) {
	            if (input.length > peg$currPos) {
	                s4 = input.charAt(peg$currPos);
	                peg$currPos++;
	            }
	            else {
	                s4 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c14);
	                }
	            }
	            if (s4 !== peg$FAILED) {
	                s3 = [s3, s4];
	                s2 = s3;
	            }
	            else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	            while (s2 !== peg$FAILED) {
	                s1.push(s2);
	                s2 = peg$currPos;
	                s3 = peg$currPos;
	                peg$silentFails++;
	                s4 = peg$parsewhiteSpace();
	                if (s4 === peg$FAILED) {
	                    s4 = peg$parsepatternSyntax();
	                }
	                peg$silentFails--;
	                if (s4 === peg$FAILED) {
	                    s3 = undefined;
	                }
	                else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                }
	                if (s3 !== peg$FAILED) {
	                    if (input.length > peg$currPos) {
	                        s4 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c14);
	                        }
	                    }
	                    if (s4 !== peg$FAILED) {
	                        s3 = [s3, s4];
	                        s2 = s3;
	                    }
	                    else {
	                        peg$currPos = s2;
	                        s2 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s2;
	                    s2 = peg$FAILED;
	                }
	            }
	        }
	        else {
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c93);
	            }
	        }
	        return s0;
	    }
	    var messageCtx = ['root'];
	    function isNestedMessageText() {
	        return messageCtx.length > 1;
	    }
	    function isInPluralOption() {
	        return messageCtx[messageCtx.length - 1] === 'plural';
	    }
	    function insertLocation() {
	        return options && options.captureLocation ? {
	            location: location()
	        } : {};
	    }
	    peg$result = peg$startRuleFunction();
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	        return peg$result;
	    }
	    else {
	        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	            peg$fail(peg$endExpectation());
	        }
	        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length
	            ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	            : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
	    }
	}
	exports.pegParse = peg$parse;


/***/ },
/* 252 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var TYPE;
	(function (TYPE) {
	    /**
	     * Raw text
	     */
	    TYPE[TYPE["literal"] = 0] = "literal";
	    /**
	     * Variable w/o any format, e.g `var` in `this is a {var}`
	     */
	    TYPE[TYPE["argument"] = 1] = "argument";
	    /**
	     * Variable w/ number format
	     */
	    TYPE[TYPE["number"] = 2] = "number";
	    /**
	     * Variable w/ date format
	     */
	    TYPE[TYPE["date"] = 3] = "date";
	    /**
	     * Variable w/ time format
	     */
	    TYPE[TYPE["time"] = 4] = "time";
	    /**
	     * Variable w/ select format
	     */
	    TYPE[TYPE["select"] = 5] = "select";
	    /**
	     * Variable w/ plural format
	     */
	    TYPE[TYPE["plural"] = 6] = "plural";
	    /**
	     * Only possible within plural argument.
	     * This is the `#` symbol that will be substituted with the count.
	     */
	    TYPE[TYPE["pound"] = 7] = "pound";
	})(TYPE = exports.TYPE || (exports.TYPE = {}));
	/**
	 * Type Guards
	 */
	function isLiteralElement(el) {
	    return el.type === TYPE.literal;
	}
	exports.isLiteralElement = isLiteralElement;
	function isArgumentElement(el) {
	    return el.type === TYPE.argument;
	}
	exports.isArgumentElement = isArgumentElement;
	function isNumberElement(el) {
	    return el.type === TYPE.number;
	}
	exports.isNumberElement = isNumberElement;
	function isDateElement(el) {
	    return el.type === TYPE.date;
	}
	exports.isDateElement = isDateElement;
	function isTimeElement(el) {
	    return el.type === TYPE.time;
	}
	exports.isTimeElement = isTimeElement;
	function isSelectElement(el) {
	    return el.type === TYPE.select;
	}
	exports.isSelectElement = isSelectElement;
	function isPluralElement(el) {
	    return el.type === TYPE.plural;
	}
	exports.isPluralElement = isPluralElement;
	function isPoundElement(el) {
	    return el.type === TYPE.pound;
	}
	exports.isPoundElement = isPoundElement;
	function isNumberSkeleton(el) {
	    return !!(el && typeof el === 'object' && el.type === 0 /* number */);
	}
	exports.isNumberSkeleton = isNumberSkeleton;
	function isDateTimeSkeleton(el) {
	    return !!(el && typeof el === 'object' && el.type === 1 /* dateTime */);
	}
	exports.isDateTimeSkeleton = isDateTimeSkeleton;
	function createLiteralElement(value) {
	    return {
	        type: TYPE.literal,
	        value: value,
	    };
	}
	exports.createLiteralElement = createLiteralElement;
	function createNumberElement(value, style) {
	    return {
	        type: TYPE.number,
	        value: value,
	        style: style,
	    };
	}
	exports.createNumberElement = createNumberElement;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(412),
	    baseLodash = __webpack_require__(264);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(412),
	    baseLodash = __webpack_require__(264);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(98),
	    root = __webpack_require__(65);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1339),
	    mapCacheDelete = __webpack_require__(1340),
	    mapCacheGet = __webpack_require__(1341),
	    mapCacheHas = __webpack_require__(1342),
	    mapCacheSet = __webpack_require__(1343);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(257),
	    setCacheAdd = __webpack_require__(1350),
	    setCacheHas = __webpack_require__(1351);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 259 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(179),
	    eq = __webpack_require__(118);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(259),
	    isFlattenable = __webpack_require__(1330);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(184),
	    toKey = __webpack_require__(149);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1277),
	    isObjectLike = __webpack_require__(58);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 264 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(258),
	    arrayIncludes = __webpack_require__(408),
	    arrayIncludesWith = __webpack_require__(409),
	    cacheHas = __webpack_require__(266),
	    createSet = __webpack_require__(1314),
	    setToArray = __webpack_require__(269);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 266 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1263),
	    Map = __webpack_require__(256),
	    Promise = __webpack_require__(1265),
	    Set = __webpack_require__(405),
	    WeakMap = __webpack_require__(407),
	    baseGetTag = __webpack_require__(74),
	    toSource = __webpack_require__(435);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(36),
	    isSymbol = __webpack_require__(151);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 269 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(65),
	    stubFalse = __webpack_require__(1377);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ },
/* 271 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1282),
	    baseUnary = __webpack_require__(183),
	    nodeUtil = __webpack_require__(431);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(97),
	    baseIteratee = __webpack_require__(75),
	    baseMap = __webpack_require__(417),
	    isArray = __webpack_require__(36);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1288),
	    basePropertyDeep = __webpack_require__(1289),
	    isKey = __webpack_require__(268),
	    toKey = __webpack_require__(149);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(47),
	    isSymbol = __webpack_require__(151);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(452);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 277 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _batch = __webpack_require__(598);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)(); // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      batch(function () {
	        for (var i = 0; i < listeners.length; i++) {
	          listeners[i]();
	        }
	      });
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.handleChangeWrapper = function handleChangeWrapper() {
	    if (this.onStateChange) {
	      this.onStateChange();
	    }
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports["default"] = Subscription;

/***/ },
/* 279 */
[1917, 1443],
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchApiSyncCounts = exports.fetchApiSyncFeatureFlag = exports.fetchApplicationApiKeysCount = exports.fetchApiPlans = exports.fetchAccountPlans = exports.fetchApps = exports.fetchApis = exports.fetchGatewayDetails = exports.fetchGateways = exports.fetchProxyDetails = exports.fetchGateway = exports.fetchProxy = exports.updateProxyOrganizations = exports.fetchSelectedOrganizations = exports.fetchAllOrganizations = exports.deleteProxy = exports.saveProxy = exports.updateProxy = exports.createProxy = exports.updateProxyWithKeyDeploymentType = exports.fetchProxyDeploymentTypes = exports.validateProxyUniqueName = exports.reinitializeState = exports.showLoading = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _utils = __webpack_require__(18);
	
	var _portalConfig = __webpack_require__(26);
	
	var _ = __webpack_require__(196);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var showLoading = exports.showLoading = function showLoading(_ref) {
	  var isLoading = _ref.isLoading,
	      dispatch = _ref.dispatch;
	
	  dispatch({
	    type: constants.API_PROXY_LOADING,
	    payload: isLoading
	  });
	};
	
	var reinitializeState = exports.reinitializeState = function reinitializeState(_ref2) {
	  var dispatch = _ref2.dispatch;
	
	  dispatch({
	    type: constants.API_PROXY_RESET,
	    payload: null
	  });
	};
	
	var isExistingProxyName = function isExistingProxyName(current, existing) {
	  return current && existing && current.trim().toLowerCase() === existing.trim().toLowerCase();
	};
	
	var validateProxyUniqueName = exports.validateProxyUniqueName = function validateProxyUniqueName(_ref3) {
	  var config = _ref3.config,
	      proxyName = _ref3.proxyName,
	      proxyDetails = _ref3.proxyDetails,
	      dispatch = _ref3.dispatch;
	
	  if ((0, _lodash.isEmpty)(proxyName) || isExistingProxyName(proxyName, (0, _lodash.get)(proxyDetails, 'name'))) {
	    dispatch({
	      type: constants.API_PROXY_VALIDATE_UNIQUE_NAME_RESET,
	      payload: ''
	    });
	  } else {
	    var portal = config.portal;
	
	    var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/internal/proxies/isNameUnique?name=' + proxyName;
	    _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	      dispatch({
	        type: constants.API_PROXY_VALIDATE_UNIQUE_NAME_SUCCESS,
	        payload: (0, _lodash.get)(response, 'data.isUnique') || false
	      });
	    }).catch(function (error) {
	      dispatch({
	        type: constants.API_PROXY_VALIDATE_UNIQUE_NAME_ERROR,
	        payload: (0, _utils.getValidationErrors)(error)
	      });
	    });
	  }
	};
	
	var fetchProxyDeploymentTypes = exports.fetchProxyDeploymentTypes = function fetchProxyDeploymentTypes(_ref4) {
	  var config = _ref4.config,
	      dispatch = _ref4.dispatch,
	      proxyUuid = _ref4.proxyUuid;
	
	  showLoading({ isLoading: true, dispatch: dispatch });
	
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/proxies/' + proxyUuid + '/deployment-type';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_FETCH_DEPLOYMENT_TYPE_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data') || {}
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_FETCH_DEPLOYMENT_TYPE_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var updateProxyWithKeyDeploymentType = exports.updateProxyWithKeyDeploymentType = function updateProxyWithKeyDeploymentType(_ref5) {
	  var config = _ref5.config,
	      dispatch = _ref5.dispatch,
	      proxyUuid = _ref5.proxyUuid,
	      data = _ref5.data;
	
	  showLoading({ isLoading: true, dispatch: dispatch });
	
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/proxies/' + proxyUuid + '/deployment-type/APPLICATION';
	  _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data') || {}
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var createProxy = exports.createProxy = function createProxy(_ref6) {
	  var config = _ref6.config,
	      dispatch = _ref6.dispatch,
	      data = _ref6.data,
	      apiKeyProxyType = _ref6.apiKeyProxyType;
	
	  showLoading({ isLoading: true, dispatch: dispatch });
	
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies';
	  _axios2.default.post(url, data, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_CREATE_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data') || {}
	    });
	    var proxyUuid = (0, _lodash.get)(response, 'data.uuid');
	    var reqData = { type: apiKeyProxyType };
	    updateProxyWithKeyDeploymentType({ config: config, dispatch: dispatch, proxyUuid: proxyUuid, data: reqData });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_CREATE_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var updateProxy = exports.updateProxy = function updateProxy(_ref7) {
	  var config = _ref7.config,
	      dispatch = _ref7.dispatch,
	      proxyUuid = _ref7.proxyUuid,
	      data = _ref7.data,
	      apiKeyProxyType = _ref7.apiKeyProxyType;
	
	  showLoading({ isLoading: true, dispatch: dispatch });
	
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid;
	  _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_UPDATE_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data') || {}
	    });
	    var reqData = { type: apiKeyProxyType };
	    updateProxyWithKeyDeploymentType({ config: config, dispatch: dispatch, proxyUuid: proxyUuid, data: reqData });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_UPDATE_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var saveProxy = exports.saveProxy = function saveProxy(_ref8) {
	  var config = _ref8.config,
	      dispatch = _ref8.dispatch,
	      data = _ref8.data,
	      proxyUuid = _ref8.proxyUuid,
	      apiKeyProxyType = _ref8.apiKeyProxyType;
	
	  dispatch({
	    type: constants.API_PROXY_SAVE_STATUS_RESET,
	    payload: ''
	  });
	
	  if (proxyUuid) {
	    updateProxy({ config: config, dispatch: dispatch, data: data, proxyUuid: proxyUuid, apiKeyProxyType: apiKeyProxyType });
	  } else {
	    createProxy({ config: config, dispatch: dispatch, data: data, apiKeyProxyType: apiKeyProxyType });
	  }
	};
	
	var deleteProxy = exports.deleteProxy = function deleteProxy(_ref9) {
	  var config = _ref9.config,
	      dispatch = _ref9.dispatch,
	      proxyUuid = _ref9.proxyUuid;
	
	  showLoading({ isLoading: true, dispatch: dispatch });
	
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid;
	  _axios2.default.delete(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_DELETE_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data') || ''
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_DELETE_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchAllOrganizations = exports.fetchAllOrganizations = function fetchAllOrganizations(_ref10) {
	  var config = _ref10.config,
	      dispatch = _ref10.dispatch;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/internal/organizations?status=ENABLED&type=PUBLISHER&size=1000&page=0';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_FETCH_ORGANIZATIONS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data.results') || []
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_FETCH_ORGANIZATIONS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchSelectedOrganizations = exports.fetchSelectedOrganizations = function fetchSelectedOrganizations(_ref11) {
	  var config = _ref11.config,
	      dispatch = _ref11.dispatch,
	      proxyUuid = _ref11.proxyUuid;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/organizations';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_FETCH_SELECTED_ORGANIZATIONS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data') || []
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_FETCH_SELECTED_ORGANIZATIONS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var updateProxyOrganizations = exports.updateProxyOrganizations = function updateProxyOrganizations(_ref12) {
	  var config = _ref12.config,
	      dispatch = _ref12.dispatch,
	      proxyUuid = _ref12.proxyUuid,
	      data = _ref12.data;
	
	  showLoading({ isLoading: true, dispatch: dispatch });
	
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/organizations';
	  _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_UPDATE_ORGS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data') || {}
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_UPDATE_ORGS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchProxy = exports.fetchProxy = function fetchProxy(proxyUuid) {
	  return function () {
	    var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              _context.next = 4;
	              return Promise.all([_axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid, _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/proxies/' + proxyUuid + '/deployment-type', _.AXIOS_DEFAULT_OPTIONS)]).then(function () {
	                var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                dispatch({
	                  type: constants.PROXY_GET_SUCCESS,
	                  payload: {
	                    proxyDetails: (0, _lodash.get)(response[0], 'data', {}),
	                    deploymentType: (0, _lodash.get)(response[1], 'data', {})
	                  }
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x, _x2) {
	      return _ref13.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchGateway = exports.fetchGateway = function fetchGateway(proxyUuid) {
	  return function () {
	    var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              _context2.next = 4;
	              return Promise.all([_axios2.default.get(portal.hostname + '/admin/Portal.svc/Gateways?inlinecount=allpages&filter=(EnrollmentStatus=ACTIVE or EnrollmentStatus=PENDING)', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/admin/Portal.svc/Gateways(\'' + proxyUuid + '\')', _.AXIOS_DEFAULT_OPTIONS)]).then(function () {
	                var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                dispatch({
	                  type: constants.PROXY_GATEWAY_GET_SUCCESS,
	                  payload: {
	                    gateways: (0, _lodash.get)(response[0], 'data.d.results', []),
	                    gatewayDetails: (0, _lodash.get)(response[1], 'data.d', {})
	                  }
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_GATEWAY_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref14.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchProxyDetails = exports.fetchProxyDetails = function fetchProxyDetails(_ref15) {
	  var config = _ref15.config,
	      dispatch = _ref15.dispatch,
	      proxyUuid = _ref15.proxyUuid;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid;
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.API_PROXY_FETCH_DETAILS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data') || {}
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.API_PROXY_FETCH_DETAILS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	// Details Page
	var fetchGateways = exports.fetchGateways = function fetchGateways(_ref16) {
	  var config = _ref16.config,
	      dispatch = _ref16.dispatch;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/admin/Portal.svc/Gateways?inlinecount=allpages&filter=(EnrollmentStatus=ACTIVE or EnrollmentStatus=PENDING)';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.FETCH_GATEWAYS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data.d.results') || []
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.FETCH_GATEWAYS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchGatewayDetails = exports.fetchGatewayDetails = function fetchGatewayDetails(_ref17) {
	  var config = _ref17.config,
	      dispatch = _ref17.dispatch,
	      proxyUuid = _ref17.proxyUuid;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/admin/Portal.svc/Gateways(\'' + proxyUuid + '\')';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.FETCH_GATEWAY_DETAILS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data.d') || {}
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.FETCH_GATEWAY_DETAILS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchApis = exports.fetchApis = function fetchApis(_ref18) {
	  var config = _ref18.config,
	      dispatch = _ref18.dispatch;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/admin/Portal.svc/Api2.0s?skip=0&top=10&inlinecount=allpages';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.FETCH_APIS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data.d.results') || []
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.FETCH_APIS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchApps = exports.fetchApps = function fetchApps(_ref19) {
	  var config = _ref19.config,
	      dispatch = _ref19.dispatch;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/admin/Portal.svc/Applications?skip=0&top=10&inlinecount=allpages';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.FETCH_APPS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data.d.results') || []
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.FETCH_APPS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchAccountPlans = exports.fetchAccountPlans = function fetchAccountPlans(_ref20) {
	  var config = _ref20.config,
	      dispatch = _ref20.dispatch;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/admin/Portal.svc/AccountPlans?skip=0&top=10&inlinecount=allpages';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.FETCH_ACCOUNT_PLANS_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data.d.results') || []
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.FETCH_ACCOUNT_PLANS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchApiPlans = exports.fetchApiPlans = function fetchApiPlans(_ref21) {
	  var config = _ref21.config,
	      dispatch = _ref21.dispatch;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/api-plans';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.FETCH_API_PLANS_SUCCESS,
	      payload: {
	        apiPlans: (0, _lodash.get)(response, 'data.results', []),
	        apiPlansCount: (0, _lodash.get)(response, 'data.totalElements', 0)
	      }
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.FETCH_API_PLANS_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchApplicationApiKeysCount = exports.fetchApplicationApiKeysCount = function fetchApplicationApiKeysCount(_ref22) {
	  var config = _ref22.config,
	      dispatch = _ref22.dispatch;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/admin/api-management/internal/applications/api-keys/count';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.APPLICATION_ALL_KEYS_COUNT_GET_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data')
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.APPLICATION_ALL_KEYS_COUNT_GET_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	var fetchApiSyncFeatureFlag = exports.fetchApiSyncFeatureFlag = function fetchApiSyncFeatureFlag(_ref23) {
	  var config = _ref23.config,
	      dispatch = _ref23.dispatch,
	      proxyUuid = _ref23.proxyUuid;
	  var portal = config.portal;
	
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/proxies/' + proxyUuid + '/config';
	  _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	    dispatch({
	      type: constants.FETCH_API_SYNC_FEATURE_FLAG_SUCCESS,
	      payload: (0, _lodash.get)(response, 'data.useNewAutoSync')
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.FETCH_API_SYNC_FEATURE_FLAG_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchApiSyncCounts = exports.fetchApiSyncCounts = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(_ref24) {
	    var config = _ref24.config,
	        dispatch = _ref24.dispatch,
	        proxyUuid = _ref24.proxyUuid;
	    var portal, urlPortal, urlPortalApis, urlGatewayApis;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            portal = config.portal;
	            urlPortal = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?sort=lastTimeDeployed,desc';
	            urlPortalApis = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=true';
	            urlGatewayApis = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=false';
	            _context3.next = 6;
	            return Promise.all([_axios2.default.get(urlPortal, { credentials: 'include' }), _axios2.default.get(urlPortalApis, { credentials: 'include' }), _axios2.default.get(urlGatewayApis, { credentials: 'include' })]).then(function (responseArr) {
	              dispatch({
	                type: constants.FETCH_API_SYNC_COUNT_SUCCESS,
	                payload: {
	                  portalApis: responseArr[0].data,
	                  publishedByPortal: responseArr[1].data,
	                  publishedByGateway: responseArr[2].data
	                }
	              });
	            }).catch(function (error) {
	              dispatch({
	                type: constants.FETCH_API_SYNC_COUNT_ERROR,
	                payload: (0, _utils.getValidationErrors)(error)
	              });
	            });
	
	          case 6:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function fetchApiSyncCounts(_x7) {
	    return _ref25.apply(this, arguments);
	  };
	}();

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateOrganization = exports.createOrganization = exports.fetchOrganizationNameUnique = exports.fetchAccountPlans = exports.fetchOrganization = exports.fetchOrganizations = exports.fetchAllOrganizations = exports.init = exports.showLoading = exports.resetApp = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _queryString = __webpack_require__(100);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _ = __webpack_require__(196);
	
	var _utils = __webpack_require__(18);
	
	var _actions = __webpack_require__(204);
	
	var _portalConfig = __webpack_require__(26);
	
	var _requestParser = __webpack_require__(1451);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initApplication = function initApplication(dispatch) {
	  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return dispatch({
	    type: Constants.APP_LOADING,
	    isLoading: isLoading
	  });
	};
	
	var resetApp = exports.resetApp = function resetApp() {
	  return function (dispatch) {
	    return dispatch({ type: Constants.APP_RESET });
	  };
	};
	var showLoading = exports.showLoading = function showLoading(isLoading) {
	  return function (dispatch) {
	    return initApplication(dispatch, isLoading);
	  };
	};
	
	var init = exports.init = function init(dispatch) {
	  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return dispatch({
	    type: Constants.APP_LOADING,
	    isLoading: isLoading
	  });
	};
	
	var fetchAllOrganizations = exports.fetchAllOrganizations = function fetchAllOrganizations() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 100 : _ref$size;
	
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var config, portal, urlPrefix, getCascadingRequests, url;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              urlPrefix = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/internal/organizations';
	
	              getCascadingRequests = function getCascadingRequests(totalPages) {
	                var cascadingRequests = [];
	                for (var page = 1; page < totalPages; page++) {
	                  var _url = (0, _actions.stringifyUrl)({
	                    url: urlPrefix,
	                    query: { status: Constants.ORGANIZATION_STATUS_ENABLED, page: page, size: size }
	                  });
	                  cascadingRequests.push(_axios2.default.get(_url, _.AXIOS_DEFAULT_OPTIONS));
	                }
	                return cascadingRequests;
	              };
	
	              url = (0, _actions.stringifyUrl)({
	                url: urlPrefix,
	                query: { status: Constants.ORGANIZATION_STATUS_ENABLED, page: 0, size: size }
	              });
	              _context2.next = 7;
	              return _axios2.default.get(url, _.AXIOS_DEFAULT_OPTIONS).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(response) {
	                  var totalPages, cascadingResponses, cascadingResponsesResults;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          totalPages = response.data.totalPages;
	
	                          if (!(totalPages > 1)) {
	                            _context.next = 7;
	                            break;
	                          }
	
	                          _context.next = 4;
	                          return Promise.all(getCascadingRequests(totalPages));
	
	                        case 4:
	                          cascadingResponses = _context.sent;
	                          cascadingResponsesResults = cascadingResponses.map(function (res) {
	                            return res.data.results;
	                          });
	                          return _context.abrupt('return', Object.assign({}, response.data, {
	                            results: [].concat(_toConsumableArray(response.data.results), _toConsumableArray((0, _lodash.flatten)(cascadingResponsesResults)))
	                          }));
	
	                        case 7:
	                          return _context.abrupt('return', response.data);
	
	                        case 8:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, undefined);
	                }));
	
	                return function (_x6) {
	                  return _ref3.apply(this, arguments);
	                };
	              }()).then(function (response) {
	                return dispatch({
	                  type: Constants.ORGANIZATIONS_GET_SUCCESS,
	                  payload: response
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: Constants.ORGANIZATIONS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchOrganizations = exports.fetchOrganizations = function fetchOrganizations(_ref4) {
	  var _ref4$name = _ref4.name,
	      name = _ref4$name === undefined ? null : _ref4$name,
	      _ref4$type = _ref4.type,
	      type = _ref4$type === undefined ? Constants.ANY : _ref4$type,
	      _ref4$page = _ref4.page,
	      page = _ref4$page === undefined ? 0 : _ref4$page,
	      _ref4$size = _ref4.size,
	      size = _ref4$size === undefined ? 12 : _ref4$size;
	  return function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch, getState) {
	      var config, portal, params, url;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              initApplication(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              params = (0, _queryString.stringify)({
	                name: !(0, _lodash.isEmpty)(name) ? name : undefined,
	                page: page,
	                size: size,
	                type: type !== Constants.ANY ? type : undefined,
	                status: 'ENABLED'
	              }, true);
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/internal/organizations?' + params;
	              _context3.next = 7;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                return dispatch({
	                  type: Constants.ORGANIZATION_LIST_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function () {
	                return dispatch({
	                  type: Constants.ORGANIZATION_LIST_GET_ERROR,
	                  payload: ['']
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function (_x7, _x8) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchOrganization = exports.fetchOrganization = function fetchOrganization(organizationUuid) {
	  return function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              initApplication(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/1.0/organizations/' + organizationUuid;
	
	              dispatch({
	                type: Constants.ORGANIZATION_GET_REQUEST
	              });
	              _context4.next = 7;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.ORGANIZATION_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function () {
	                return dispatch({
	                  type: Constants.ORGANIZATION_GET_ERROR,
	                  payload: ['']
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x9, _x10) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAccountPlans = exports.fetchAccountPlans = function fetchAccountPlans() {
	  return function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(dispatch, getState) {
	      var config, portal, params, url;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              initApplication(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              params = (0, _queryString.stringify)({
	                $select: 'Uuid,Name',
	                $inlinecount: 'allpages'
	              }, true);
	
	
	              dispatch({
	                type: Constants.ACCOUNTPLANS_GET_REQUEST
	              });
	              url = portal.hostname + '/admin/Portal.svc/AccountPlans?' + params;
	              _context5.next = 8;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.ACCOUNTPLANS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function () {
	                return dispatch({
	                  type: Constants.ACCOUNTPLANS_GET_ERROR,
	                  payload: ['']
	                });
	              });
	
	            case 8:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x11, _x12) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchOrganizationNameUnique = exports.fetchOrganizationNameUnique = function fetchOrganizationNameUnique(orgName) {
	  return function (dispatch, getState) {
	    // Run Unique check when orgName is non-null.
	    if (!orgName) {
	      return;
	    }
	
	    var config = (0, _portalConfig.getConfig)(getState());
	    var portal = config.portal;
	
	    var queryParam = encodeURIComponent('\'' + orgName + '\'');
	    var url = portal.hostname + '/admin/Portal.svc/OrganizationNameUnique()?Name=' + queryParam;
	
	    dispatch({
	      type: Constants.ORGANIZATION_NAME_UNIQUE_REQUEST
	    });
	    _actions.debouncedAxiosGet.cancel();
	    (0, _actions.debouncedAxiosGet)(url, { credentials: 'include' }, function (response) {
	      return dispatch({
	        type: Constants.ORGANIZATION_NAME_UNIQUE_SUCCESS,
	        payload: response.data
	      });
	    }, function () {
	      return dispatch({
	        type: Constants.ORGANIZATION_NAME_UNIQUE_ERROR,
	        payload: ['']
	      });
	    });
	  };
	};
	
	var createOrganization = exports.createOrganization = function createOrganization(orgDetails) {
	  return function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              initApplication(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getOrgPayload)(orgDetails);
	
	              dispatch({
	                type: Constants.ORGANIZATION_CREATE_REQUEST
	              });
	
	              url = portal.hostname + '/admin/Portal.svc/Organizations';
	              _context6.next = 8;
	              return _axios2.default.post(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.ORGANIZATION_CREATE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.ORGANIZATION_CREATE_ERROR,
	                  payload: (0, _lodash.get)(error, 'response.data')
	                });
	              });
	
	            case 8:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined);
	    }));
	
	    return function (_x13, _x14) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	};
	
	var updateOrganization = exports.updateOrganization = function updateOrganization(orgDetails) {
	  return function () {
	    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              initApplication(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getOrgPayload)(orgDetails);
	
	              dispatch({
	                type: Constants.ORGANIZATION_UPDATE_REQUEST
	              });
	
	              url = portal.hostname + '/admin/Portal.svc/Organizations(\'' + orgDetails.orgUuid + '\')';
	              _context7.next = 8;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: Constants.ORGANIZATION_UPDATE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: Constants.ORGANIZATION_UPDATE_ERROR,
	                  payload: (0, _lodash.get)(error, 'response.data')
	                });
	              });
	
	            case 8:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined);
	    }));
	
	    return function (_x15, _x16) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchApiKeys = exports.fetchProxyApiKeysList = exports.fetchProxyApisList = exports.updateNewProxySync = exports.fetchProxyOrganizations = exports.fetchApiPlans = exports.fetchAccountPlans = exports.deleteProxy = exports.fetchApiKeysCount = exports.fetchApis = exports.fetchProxyApis = exports.fetchProxyGateway = exports.fetchProxyDetails = exports.fetchProxy = exports.reinitializeState = exports.showLoading = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _queryString = __webpack_require__(100);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _utils = __webpack_require__(18);
	
	var _portalConfig = __webpack_require__(26);
	
	var _actions = __webpack_require__(204);
	
	var _ = __webpack_require__(196);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var showLoading = exports.showLoading = function showLoading(_ref) {
	  var isLoading = _ref.isLoading,
	      dispatch = _ref.dispatch;
	
	  dispatch({
	    type: constants.API_PROXY_LOADING,
	    payload: isLoading
	  });
	};
	
	var reinitializeState = exports.reinitializeState = function reinitializeState(_ref2) {
	  var dispatch = _ref2.dispatch;
	
	  dispatch({
	    type: constants.API_PROXY_RESET,
	    payload: null
	  });
	};
	
	var fetchProxy = exports.fetchProxy = function fetchProxy(proxyUuid) {
	  var includeMq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              _context.next = 4;
	              return Promise.all([_axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/proxies/' + proxyUuid + '/details?includeMq=' + includeMq, _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid, _.AXIOS_DEFAULT_OPTIONS)]).then(function () {
	                var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                dispatch({
	                  type: constants.PROXY_GET_SUCCESS,
	                  payload: {
	                    proxyDetails: (0, _lodash.get)(response[0], 'data', {}),
	                    proxy: (0, _lodash.get)(response[1], 'data', {})
	                  }
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x2, _x3) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchProxyDetails = exports.fetchProxyDetails = function fetchProxyDetails(proxyUuid) {
	  var includeMq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	
	
	              _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/proxies/' + proxyUuid + '/details?includeMq=' + includeMq, _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	                dispatch({
	                  type: constants.PROXY_DETAILS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_DETAILS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 3:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchProxyGateway = exports.fetchProxyGateway = function fetchProxyGateway(proxyUuid) {
	  return function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              dispatch({
	                type: constants.PROXY_GATEWAY_GET_REQUEST
	              });
	
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              _context3.next = 5;
	              return Promise.all([_axios2.default.get(portal.hostname + '/admin/Portal.svc/Gateways(\'' + proxyUuid + '\')', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/admin/Portal.svc/Gateways?inlinecount=allpages&filter=(EnrollmentStatus=ACTIVE or EnrollmentStatus=PENDING)', _.AXIOS_DEFAULT_OPTIONS)]).then(function () {
	                var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                // 0.5 sec delay to display the Loading icon for proxy status clearly
	                setTimeout(function () {
	                  return dispatch({
	                    type: constants.PROXY_GATEWAY_GET_SUCCESS,
	                    payload: {
	                      gatewayDetails: (0, _lodash.get)(response[0], 'data.d', {}),
	                      gateways: (0, _lodash.get)(response[1], 'data.d.results', [])
	                    }
	                  });
	                }, 500);
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_GATEWAY_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function (_x8, _x9) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchProxyApis = exports.fetchProxyApis = function fetchProxyApis(proxyUuid) {
	  return function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	
	              dispatch({ type: constants.PROXY_APIS_GET_REQUEST });
	              _context4.next = 5;
	              return Promise.all([_axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?sort=lastTimeDeployed,desc', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?status=PENDING_DEPLOYMENT', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?status=DEPLOYED', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?status=ERROR', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=true', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=true&status=PENDING_DEPLOYMENT', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=true&status=DEPLOYED', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=true&status=ERROR', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=false', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=false&status=PENDING_DEPLOYMENT', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=false&status=DEPLOYED', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=false&status=ERROR', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?status=PENDING_UNDEPLOYMENT', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=true&status=PENDING_UNDEPLOYMENT', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=false&status=PENDING_UNDEPLOYMENT', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?status=ERROR_UNDEPLOY', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=true&status=ERROR_UNDEPLOY', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?publishedByPortal=false&status=ERROR_UNDEPLOY', _.AXIOS_DEFAULT_OPTIONS)]).then(function () {
	                var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                dispatch({
	                  type: constants.PROXY_APIS_GET_SUCCESS,
	                  payload: {
	                    apis: response[0].data,
	                    apisPendingDeployment: response[1].data,
	                    apisDeployed: response[2].data,
	                    apisError: response[3].data,
	                    apisPublishedByPortal: response[4].data,
	                    apisPublishedByPortalPendingDeployment: response[5].data,
	                    apisPublishedByPortalDeployed: response[6].data,
	                    apisPublishedByPortalError: response[7].data,
	                    apisPublishedByGateway: response[8].data,
	                    apisPublishedByGatewayPendingDeployment: response[9].data,
	                    apisPublishedByGatewayDeployed: response[10].data,
	                    apisPublishedByGatewayError: response[11].data,
	                    apisPendingUndeployment: response[12].data,
	                    apisPublishedByPortalPendingUndeployment: response[13].data,
	                    apisPublishedByGatewayPendingUndeployment: response[14].data,
	                    apisErrorUndeploy: response[15].data,
	                    apisPublishedByPortalErrorUndeploy: response[16].data,
	                    apisPublishedByGatewayErrorUndeploy: response[17].data
	                  }
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_APIS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x11, _x12) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApis = exports.fetchApis = function fetchApis() {
	  return function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(dispatch, getState) {
	      var config, portal, urlPrefix, url;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              urlPrefix = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis';
	
	              url = function url(_ref8) {
	                var publishedByPortal = _ref8.publishedByPortal;
	                return (0, _actions.stringifyUrl)({
	                  url: urlPrefix,
	                  query: {
	                    portalStatus: [constants.API_STATUS_NEW, constants.API_STATUS_ENABLED, constants.API_STATUS_DISABLED, constants.API_STATUS_DEPRECATED],
	                    publishedByPortal: publishedByPortal
	                  }
	                });
	              };
	
	              _context5.next = 6;
	              return Promise.all([_axios2.default.get(url({}), _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(url({ publishedByPortal: true }), _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(url({ publishedByPortal: false }), _.AXIOS_DEFAULT_OPTIONS)]).then(function (response) {
	                dispatch({
	                  type: constants.APIS_GET_SUCCESS,
	                  payload: {
	                    apis: response[0].data,
	                    apisPublishedByPortal: response[1].data,
	                    apisPublishedByGateway: response[2].data
	                  }
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.APIS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x14, _x15) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApiKeysCount = exports.fetchApiKeysCount = function fetchApiKeysCount() {
	  return function () {
	    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	
	              dispatch({ type: constants.API_KEYS_COUNT_GET_REQUEST });
	              _axios2.default.get(portal.hostname + '/admin/api-management/internal/applications/api-keys/count', _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	                dispatch({
	                  type: constants.API_KEYS_COUNT_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.API_KEYS_COUNT_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined);
	    }));
	
	    return function (_x16, _x17) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	};
	
	var deleteProxy = exports.deleteProxy = function deleteProxy(proxyUuid) {
	  return function () {
	    var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid;
	
	
	              _axios2.default.delete(url, _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	                dispatch({
	                  type: constants.PROXY_DELETE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_DELETE_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 4:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined);
	    }));
	
	    return function (_x18, _x19) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAccountPlans = exports.fetchAccountPlans = function fetchAccountPlans() {
	  return function () {
	    var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	
	
	              _axios2.default.get(portal.hostname + '/admin/Portal.svc/AccountPlans', _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	                dispatch({
	                  type: constants.ACCOUNT_PLANS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.ACCOUNT_PLANS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 3:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined);
	    }));
	
	    return function (_x20, _x21) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApiPlans = exports.fetchApiPlans = function fetchApiPlans() {
	  return function () {
	    var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	
	
	              _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/api-plans', _.AXIOS_DEFAULT_OPTIONS).then(function () {
	                var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                dispatch({
	                  type: constants.API_PLANS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.API_PLANS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 3:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, undefined);
	    }));
	
	    return function (_x22, _x23) {
	      return _ref12.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchProxyOrganizations = exports.fetchProxyOrganizations = function fetchProxyOrganizations(proxyUuid) {
	  return function () {
	    var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	
	
	              _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/organizations', _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	                var orgIds = (0, _lodash.get)(response, 'data', []);
	                if ((0, _lodash.isEmpty)(orgIds)) {
	                  return Promise.resolve({});
	                }
	                var query = (0, _queryString.stringify)({
	                  page: 0,
	                  size: 100,
	                  status: 'ENABLED',
	                  orgId: orgIds.map(function (_ref14) {
	                    var uuid = _ref14.uuid;
	                    return uuid;
	                  })
	                });
	                return _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/1.0/organizations?' + query, _.AXIOS_DEFAULT_OPTIONS);
	              }).then(function (response) {
	                dispatch({
	                  type: constants.PROXY_ORGANIZATIONS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_ORGANIZATIONS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 3:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, undefined);
	    }));
	
	    return function (_x25, _x26) {
	      return _ref13.apply(this, arguments);
	    };
	  }();
	};
	
	var updateNewProxySync = exports.updateNewProxySync = function updateNewProxySync(proxyUuid) {
	  return function () {
	    var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	
	
	              _axios2.default.put(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/0.1/proxies/' + proxyUuid + '/config', { useNewAutoSync: true }).then(function () {
	                dispatch({
	                  type: constants.PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 3:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, undefined);
	    }));
	
	    return function (_x27, _x28) {
	      return _ref15.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApisList = function fetchApisList(proxyApis, dispatch, config, size) {
	  var portal = config.portal;
	
	  var ids = (0, _lodash.map)(proxyApis.results, 'apiUuid').join(',');
	  _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis?id=' + ids + '&size=' + size, _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	    var mergeResults = [];
	    (0, _lodash.map)(proxyApis.results, function (proxyObj) {
	      var apiData = (0, _lodash.filter)(response.data.results, function (apiObj) {
	        return proxyObj.apiUuid === apiObj.uuid;
	      })[0];
	      mergeResults.push((0, _lodash.extend)(proxyObj, apiData));
	    });
	    dispatch({
	      type: constants.PROXY_APIS_LIST_GET_SUCCESS,
	      payload: Object.assign({}, proxyApis, { results: mergeResults })
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.PROXY_APIS_LIST_GET_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchProxyApisList = exports.fetchProxyApisList = function fetchProxyApisList(_ref16) {
	  var proxyUuid = _ref16.proxyUuid,
	      _ref16$publishSource = _ref16.publishSource,
	      publishSource = _ref16$publishSource === undefined ? constants.ALL : _ref16$publishSource,
	      _ref16$status = _ref16.status,
	      status = _ref16$status === undefined ? constants.ALL : _ref16$status,
	      _ref16$state = _ref16.state,
	      state = _ref16$state === undefined ? constants.ALL : _ref16$state,
	      _ref16$sortBy = _ref16.sortBy,
	      sortBy = _ref16$sortBy === undefined ? 'lastTimeDeployed,DESC' : _ref16$sortBy,
	      _ref16$page = _ref16.page,
	      page = _ref16$page === undefined ? 0 : _ref16$page,
	      _ref16$rowsPerPage = _ref16.rowsPerPage,
	      rowsPerPage = _ref16$rowsPerPage === undefined ? 12 : _ref16$rowsPerPage;
	  return function () {
	    var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(dispatch, getState) {
	      var config, portal, params;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              showLoading({ dispatch: dispatch, isLoading: true });
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              params = (0, _queryString.stringify)({
	                publishedByPortal: publishSource !== constants.ALL ? publishSource : undefined,
	                status: status !== constants.ALL ? status : undefined,
	                page: page,
	                size: rowsPerPage,
	                sort: sortBy,
	                portalStatus: state !== constants.ALL ? state : undefined
	              }, true);
	              _context12.next = 6;
	              return _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/apis?' + params, _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	                if (response.data.results.length === 0) {
	                  dispatch({
	                    type: constants.PROXY_APIS_LIST_GET_SUCCESS,
	                    payload: response.data
	                  });
	                } else {
	                  fetchApisList(response.data, dispatch, config, rowsPerPage);
	                }
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.PROXY_APIS_LIST_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, undefined);
	    }));
	
	    return function (_x29, _x30) {
	      return _ref17.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchKeysList = function fetchKeysList(keys, dispatch, config, size) {
	  var portal = config.portal;
	
	  var ids = (0, _lodash.map)(keys.results, 'apiKey').join(',');
	  _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/api-keys?apiKeys=' + ids + '&size=' + size, _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	    var mergeResults = [];
	    (0, _lodash.map)(keys.results, function (proxyObj) {
	      var apiData = (0, _lodash.filter)(response.data.results, function (apiObj) {
	        if (proxyObj.apiKey === apiObj.apiKey) {
	          apiObj.keyStatus = apiObj.status;
	          delete apiObj.status;
	        }
	        return proxyObj.apiKey === apiObj.apiKey;
	      })[0];
	      mergeResults.push((0, _lodash.extend)(proxyObj, apiData));
	    });
	    dispatch({
	      type: constants.PROXY_APIS_KEYS_LIST_GET_SUCCESS,
	      payload: Object.assign({}, keys, { results: mergeResults })
	    });
	  }).catch(function (error) {
	    dispatch({
	      type: constants.PROXY_APIS_KEYS_LIST_GET_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var fetchProxyApiKeysList = exports.fetchProxyApiKeysList = function fetchProxyApiKeysList(_ref18) {
	  var proxyUuid = _ref18.proxyUuid,
	      keyName = _ref18.keyName,
	      _ref18$keyStatus = _ref18.keyStatus,
	      keyStatus = _ref18$keyStatus === undefined ? constants.ALL : _ref18$keyStatus,
	      apiKey = _ref18.apiKey,
	      _ref18$status = _ref18.status,
	      status = _ref18$status === undefined ? constants.ALL : _ref18$status,
	      _ref18$page = _ref18.page,
	      page = _ref18$page === undefined ? 0 : _ref18$page,
	      _ref18$rowsPerPage = _ref18.rowsPerPage,
	      rowsPerPage = _ref18$rowsPerPage === undefined ? 12 : _ref18$rowsPerPage,
	      _ref18$sortBy = _ref18.sortBy,
	      sortBy = _ref18$sortBy === undefined ? 'lastTimeDeployed,DESC' : _ref18$sortBy;
	  return function () {
	    var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(dispatch, getState) {
	      var config, portal, params;
	      return _regenerator2.default.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              showLoading({ dispatch: dispatch, isLoading: true });
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              params = (0, _queryString.stringify)({
	                apiKeyName: keyName ? keyName : undefined,
	                apiKey: apiKey ? apiKey : undefined,
	                apiKeyStatus: keyStatus !== constants.ALL ? keyStatus : undefined,
	                status: status !== constants.ALL ? status : undefined,
	                page: page,
	                size: rowsPerPage,
	                sort: sortBy
	              }, true);
	              _context13.next = 6;
	              return _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/api-keys?' + params, _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	                if (response.data.results.length === 0) {
	                  dispatch({
	                    type: constants.PROXY_APIS_KEYS_LIST_GET_SUCCESS,
	                    payload: response.data
	                  });
	                } else {
	                  fetchKeysList(response.data, dispatch, config, rowsPerPage);
	                }
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.PROXY_APIS_KEYS_LIST_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, undefined);
	    }));
	
	    return function (_x31, _x32) {
	      return _ref19.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApiKeys = exports.fetchApiKeys = function fetchApiKeys(proxyUuid) {
	  return function () {
	    var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(dispatch, getState) {
	      var config, portal;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              showLoading({ dispatch: dispatch, isLoading: true });
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              _context14.next = 5;
	              return Promise.all([_axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/api-keys?status=PENDING_DEPLOYMENT', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/api-keys?status=DEPLOYED', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/api-keys?status=ERROR', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/api-keys?status=PENDING_UNDEPLOYMENT', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/api-keys?status=ERROR_UNDEPLOY', _.AXIOS_DEFAULT_OPTIONS), _axios2.default.get(portal.hostname + '/api/' + portal.tenantPrefix + '/deployments/1.0/proxies/' + proxyUuid + '/api-keys?sort=lastTimeDeployed,desc', _.AXIOS_DEFAULT_OPTIONS)]).then(function () {
	                var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                dispatch({
	                  type: constants.PROXY_APIS_KEYS_COUNT_GET_SUCCESS,
	                  payload: {
	                    keysPendingDeployment: response[0].data,
	                    keysDeployed: response[1].data,
	                    keysError: response[2].data,
	                    keysPendingUnDeployment: response[3].data,
	                    keysErrorUnDeploy: response[4].data,
	                    keys: response[5].data
	                  }
	                });
	              }).catch(function (error) {
	                dispatch({
	                  type: constants.PROXY_APIS_KEYS_COUNT_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, undefined);
	    }));
	
	    return function (_x33, _x34) {
	      return _ref20.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    paper: {
	      backgroundColor: (0, _get2.default)(theme, 'color.uiBackground'),
	      minHeight: 'calc(100% - 48px)',
	      padding: (0, _get2.default)(theme, 'padding.p24') + ' ' + (0, _get2.default)(theme, 'padding.p36')
	    },
	    title: {
	      marginTop: 0
	    },
	    helpIcon: {
	      padding: '0 ' + (0, _get2.default)(theme, 'padding.p4') + ' 0 ' + (0, _get2.default)(theme, 'padding.p8'),
	      '& svg': {
	        fontSize: (0, _get2.default)(theme, 'fontSize.smallText')
	      }
	    },
	    disconnectedBackground: {
	      backgroundColor: (0, _get2.default)(theme, 'color.lightBackground')
	    },
	    disconnectedIndicatorIcon: {
	      color: (0, _get2.default)(theme, 'color.disabledGraphic'),
	      padding: '7px'
	    },
	    errorIndicatorIcon: {
	      color: (0, _get2.default)(theme, 'color.error'),
	      padding: '7px'
	    },
	    value: {
	      fontFamily: (0, _get2.default)(theme, 'typography.bodyText'),
	      fontWeight: (0, _get2.default)(theme, 'fontWeight.normal'),
	      marginTop: (0, _get2.default)(theme, 'margin.m12'),
	      minHeight: 0
	    },
	    tableRow: {
	      '& th': {
	        color: (0, _get2.default)(theme, 'color.pageTitle'),
	        fontWeight: (0, _get2.default)(theme, 'fontWeight.bold')
	      }
	    },
	    icon: {
	      padding: 0,
	      marginTop: '-3px'
	    },
	    publishedDisconnected: {
	      color: (0, _get2.default)(theme, 'color.disabledBackground')
	    },
	    published: {
	      color: (0, _get2.default)(theme, 'color.bodyText')
	    },
	    pending: {
	      color: (0, _get2.default)(theme, 'color.disabledBackground')
	    },
	    notDeployed: {
	      color: (0, _get2.default)(theme, 'color.disabledGraphic')
	    },
	    deployed: {
	      color: (0, _get2.default)(theme, 'color.success')
	    },
	    error: {
	      color: (0, _get2.default)(theme, 'color.error')
	    },
	    otkCell: {
	      marginLeft: '2px',
	      backgroundColor: (0, _get2.default)(theme, 'color.lightGrayBackground')
	    },
	    clickableCell: {
	      padding: 0,
	      '& > span > p': {
	        color: (0, _get2.default)(theme, 'color.link')
	      }
	    },
	    hideSubtotal: {
	      marginTop: (0, _get2.default)(theme, 'margin.m24'),
	      padding: 0,
	      '& > span > p': {
	        color: (0, _get2.default)(theme, 'color.link'),
	        paddingRight: (0, _get2.default)(theme, 'padding.p20')
	      }
	    },
	    type: {
	      marginTop: (0, _get2.default)(theme, 'margin.m24')
	    },
	    footerLabel: {
	      fontFamily: (0, _get2.default)(theme, 'typography.bodyText'),
	      '-webkit-font-smoothing': 'antialiased'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDeploymentType = exports.getGatewayPublishedApis = exports.getPortalPublishedApis = exports.getPortalApis = exports.getApiSyncFeatureFlag = exports.getApplicationApiKeysCount = exports.getApiPlansCount = exports.getApiPlans = exports.getAccountPlans = exports.getApps = exports.getApis = exports.getGateways = exports.getGatewayDetails = exports.getIsLoading = exports.getUpdateProxyOrgsStatus = exports.getSelectedOrganizations = exports.getOrganizations = exports.getDeleteProxyStatus = exports.getUpdateKeyDeploymentTypeStatus = exports.getSaveProxyStatus = exports.getProxyDetails = exports.getApiKeyProxyType = exports.getApiProxyType = exports.getProxyNameUniqueStatus = exports.getProxyName = exports.getProxyUuid = exports.getApiProxy = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.API_PROXY_LOADING:
	      return Object.assign({}, state, {
	        isLoading: action.payload
	      });
	    case constants.API_PROXY_RESET:
	      return Object.assign({}, initialState);
	    case constants.CHANGE:
	      {
	        var _action$payload = action.payload,
	            key = _action$payload.key,
	            value = _action$payload.value;
	
	        var newState = Object.assign({}, state);
	
	        return (0, _lodash.set)(newState, key, value);
	      }
	    case constants.API_PROXY_VALIDATE_UNIQUE_NAME_RESET:
	      return Object.assign({}, state, {
	        proxyNameUniqueStatus: constants.RESET
	      });
	    case constants.API_PROXY_VALIDATE_UNIQUE_NAME_SUCCESS:
	      return Object.assign({}, state, {
	        proxyNameUniqueStatus: action.payload ? constants.SUCCESS : constants.FAIL,
	        hasError: false,
	        pageErrors: [],
	        isLoading: false
	      });
	    case constants.API_PROXY_VALIDATE_UNIQUE_NAME_ERROR:
	      return Object.assign({}, state, {
	        proxyNameUniqueStatus: constants.FAIL,
	        hasError: true,
	        pageErrors: action.payload,
	        isLoading: false
	      });
	    case constants.API_PROXY_SAVE_STATUS_RESET:
	      return Object.assign({}, state, {
	        saveProxyStatus: action.payload
	      });
	    case constants.API_PROXY_CREATE_SUCCESS:
	      return Object.assign({}, state, {
	        proxyUuid: (0, _lodash.get)(action.payload, 'uuid'),
	        proxyName: (0, _lodash.get)(action.payload, 'name'),
	        apiProxyType: (0, _lodash.get)(action.payload, 'deploymentType'),
	        proxyDetails: action.payload,
	        saveProxyStatus: constants.CREATE_SUCCESS,
	        hasError: false,
	        pageErrors: [],
	        isLoading: false
	      });
	    case constants.API_PROXY_UPDATE_SUCCESS:
	      return Object.assign({}, state, {
	        proxyUuid: (0, _lodash.get)(action.payload, 'uuid'),
	        proxyName: (0, _lodash.get)(action.payload, 'name'),
	        apiProxyType: (0, _lodash.get)(action.payload, 'deploymentType'),
	        proxyDetails: action.payload,
	        saveProxyStatus: constants.UPDATE_SUCCESS,
	        hasError: false,
	        pageErrors: [],
	        isLoading: false
	      });
	    case constants.API_PROXY_CREATE_ERROR:
	      return Object.assign({}, state, {
	        saveProxyStatus: constants.CREATE_FAIL,
	        hasError: true,
	        pageErrors: action.payload,
	        isLoading: false
	      });
	    case constants.API_PROXY_UPDATE_ERROR:
	      return Object.assign({}, state, {
	        saveProxyStatus: constants.UPDATE_FAIL,
	        hasError: true,
	        pageErrors: action.payload,
	        isLoading: false
	      });
	    case constants.API_PROXY_DELETE_SUCCESS:
	      return Object.assign({}, state, {
	        deleteProxyStatus: constants.SUCCESS,
	        hasError: false,
	        pageErrors: [],
	        isLoading: false
	      });
	    case constants.API_PROXY_DELETE_ERROR:
	      return Object.assign({}, state, {
	        deleteProxyStatus: constants.FAIL,
	        hasError: true,
	        pageErrors: action.payload,
	        isLoading: false
	      });
	    case constants.API_PROXY_FETCH_DEPLOYMENT_TYPE_SUCCESS:
	      return Object.assign({}, state, {
	        apiProxyType: (0, _lodash.get)(action.payload, 'api', DEFAULT_API_DEPLOYMENT_TYPE),
	        apiKeyProxyType: (0, _lodash.get)(action.payload, 'application', DEFAULT_API_KEY_DEPLOYMENT_TYPE),
	        hasError: false,
	        pageErrors: [],
	        isLoading: false
	      });
	    case constants.API_PROXY_FETCH_DEPLOYMENT_TYPE_ERROR:
	      return Object.assign({}, state, {
	        hasError: true,
	        pageErrors: action.payload,
	        isLoading: false
	      });
	    case constants.API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_SUCCESS:
	      return Object.assign({}, state, {
	        updateKeyDeploymentTypeStatus: constants.SUCCESS,
	        hasError: false,
	        pageErrors: [],
	        isLoading: false
	      });
	    case constants.API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_ERROR:
	      return Object.assign({}, state, {
	        updateKeyDeploymentTypeStatus: constants.FAIL,
	        hasError: true,
	        pageErrors: action.payload,
	        isLoading: false
	      });
	    case constants.API_PROXY_FETCH_ORGANIZATIONS_SUCCESS:
	      return Object.assign({}, state, {
	        organizations: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.API_PROXY_FETCH_ORGANIZATIONS_ERROR:
	      return Object.assign({}, state, {
	        organizations: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.API_PROXY_FETCH_SELECTED_ORGANIZATIONS_SUCCESS:
	      return Object.assign({}, state, {
	        selectedOrganizations: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.API_PROXY_FETCH_SELECTED_ORGANIZATIONS_ERROR:
	      return Object.assign({}, state, {
	        selectedOrganizations: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.API_PROXY_UPDATE_ORGS_SUCCESS:
	      return Object.assign({}, state, {
	        proxyOrgsData: action.payload,
	        updateProxyOrgsStatus: constants.SUCCESS,
	        hasError: false,
	        pageErrors: [],
	        isLoading: false
	      });
	    case constants.API_PROXY_UPDATE_ORGS_ERROR:
	      return Object.assign({}, state, {
	        proxyOrgsData: {},
	        updateProxyOrgsStatus: constants.FAIL,
	        hasError: true,
	        pageErrors: action.payload,
	        isLoading: false
	      });
	    case constants.API_PROXY_FETCH_DETAILS_SUCCESS:
	      return Object.assign({}, state, {
	        proxyUuid: (0, _lodash.get)(action.payload, 'uuid'),
	        proxyName: (0, _lodash.get)(action.payload, 'name'),
	        apiProxyType: (0, _lodash.get)(action.payload, 'deploymentType'),
	        proxyDetails: action.payload,
	        fetchProxyStatus: constants.SUCCESS,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.API_PROXY_FETCH_DETAILS_ERROR:
	      return Object.assign({}, state, {
	        proxyUuid: '',
	        proxyDetails: {},
	        fetchProxyStatus: constants.FAIL,
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.FETCH_GATEWAY_DETAILS_SUCCESS:
	      return Object.assign({}, state, {
	        gatewayDetails: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.FETCH_GATEWAY_DETAILS_ERROR:
	      return Object.assign({}, state, {
	        gatewayDetails: {},
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.FETCH_GATEWAYS_SUCCESS:
	      return Object.assign({}, state, {
	        gateways: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.FETCH_GATEWAYS_ERROR:
	      return Object.assign({}, state, {
	        gateways: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.FETCH_APIS_SUCCESS:
	      return Object.assign({}, state, {
	        apis: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.FETCH_APIS_ERROR:
	      return Object.assign({}, state, {
	        apis: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.FETCH_APPS_SUCCESS:
	      return Object.assign({}, state, {
	        apps: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.FETCH_APPS_ERROR:
	      return Object.assign({}, state, {
	        apps: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.FETCH_ACCOUNT_PLANS_SUCCESS:
	      return Object.assign({}, state, {
	        accountPlans: action.payload,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.FETCH_ACCOUNT_PLANS_ERROR:
	      return Object.assign({}, state, {
	        accountPlans: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.FETCH_API_PLANS_SUCCESS:
	      return Object.assign({}, state, {
	        apiPlans: (0, _lodash.get)(action.payload, 'apiPlans'),
	        apiPlansCount: (0, _lodash.get)(action.payload, 'apiPlansCount'),
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.FETCH_API_PLANS_ERROR:
	      return Object.assign({}, state, {
	        apiPlans: [],
	        apiPlansCount: 0,
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.APPLICATION_ALL_KEYS_COUNT_GET_SUCCESS:
	      return Object.assign({}, state, {
	        applicationApiKeysCount: (0, _lodash.get)(action.payload, 'count'),
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.APPLICATION_ALL_KEYS_COUNT_GET_ERROR:
	      return Object.assign({}, state, {
	        applicationApiKeysCount: 0,
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.FETCH_API_SYNC_FEATURE_FLAG_SUCCESS:
	      return Object.assign({}, state, {
	        useNewAutoSync: action.payload
	      });
	    case constants.FETCH_API_SYNC_FEATURE_FLAG_ERROR:
	      return Object.assign({}, state, {
	        useNewAutoSync: false
	      });
	    case constants.FETCH_API_SYNC_COUNT_SUCCESS:
	      return Object.assign({}, state, {
	        syncApis: action.payload
	      });
	    case constants.FETCH_API_SYNC_COUNT_ERROR:
	      return Object.assign({}, state, {
	        syncApis: {
	          portalApis: {
	            totalElements: 0,
	            results: []
	          },
	          publishedByPortal: {
	            totalElements: 0,
	            results: []
	          },
	          publishedByGateway: {
	            totalElements: 0,
	            results: []
	          }
	        }
	      });
	    case constants.PROXY_GET_SUCCESS:
	      return Object.assign({}, state, {
	        proxyDetails: (0, _lodash.get)(action.payload, 'proxyDetails'),
	        deploymentType: (0, _lodash.get)(action.payload, 'deploymentType'),
	        fetchProxyStatus: constants.SUCCESS,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_GET_ERROR:
	      return Object.assign({}, state, {
	        proxyUuid: '',
	        proxyDetails: {},
	        fetchProxyStatus: constants.FAIL,
	        hasError: true,
	        pageErrors: action.payload
	      });
	    case constants.PROXY_GATEWAY_GET_SUCCESS:
	      return Object.assign({}, state, {
	        gatewayDetails: action.payload.gatewayDetails,
	        gateways: action.payload.gateways,
	        hasError: false,
	        pageErrors: []
	      });
	    case constants.PROXY_GATEWAY_GET_ERROR:
	      return Object.assign({}, state, {
	        gatewayDetails: {},
	        gateways: [],
	        hasError: true,
	        pageErrors: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var DEFAULT_API_DEPLOYMENT_TYPE = 'ON_DEMAND';
	var DEFAULT_API_KEY_DEPLOYMENT_TYPE = 'AUTOMATIC';
	var initialState = {
	  hasError: false,
	  pageErrors: [],
	  proxyUuid: '',
	  proxyName: '',
	  proxyNameUniqueStatus: '',
	  apiProxyType: DEFAULT_API_DEPLOYMENT_TYPE,
	  apiKeyProxyType: DEFAULT_API_KEY_DEPLOYMENT_TYPE,
	  proxyDetails: {},
	  gatewayDetails: {},
	  gateways: [],
	  apis: [],
	  apps: [],
	  applicationApiKeysCount: 0,
	  accountPlans: [],
	  apiPlans: [],
	  apiPlansCount: 0,
	  saveProxyStatus: '',
	  updateKeyDeploymentTypeStatus: '',
	  deleteProxyStatus: '',
	  proxyOrgsData: {},
	  updateProxyOrgsStatus: '',
	  organizations: [],
	  selectedOrganizations: [],
	  isLoading: false,
	  useNewAutoSync: false,
	  syncApis: {
	    portalApis: {
	      totalElements: 0,
	      results: []
	    },
	    publishedByPortal: {
	      totalElements: 0,
	      results: []
	    },
	    publishedByGateway: {
	      totalElements: 0,
	      results: []
	    }
	  }
	};
	
	var getFilteredProxyOrgs = function getFilteredProxyOrgs(orgs, proxyOrgs) {
	  var filteredList = proxyOrgs.reduce(function (selectedOrgs, proxyOrg) {
	    var matchedProxyOrg = orgs.find(function (org) {
	      return org.uuid === proxyOrg.uuid;
	    });
	    if (matchedProxyOrg) {
	      selectedOrgs.push(Object.assign({}, proxyOrg, matchedProxyOrg));
	    }
	    return selectedOrgs;
	  }, []);
	
	  return filteredList;
	};
	
	var getApiProxy = exports.getApiProxy = function getApiProxy(state) {
	  return (0, _lodash.get)(state, 'apiProxy');
	};
	var getProxyUuid = exports.getProxyUuid = function getProxyUuid(state) {
	  return (0, _lodash.get)(state, 'apiProxy.proxyUuid');
	};
	var getProxyName = exports.getProxyName = function getProxyName(state) {
	  return (0, _lodash.get)(state, 'apiProxy.proxyName');
	};
	var getProxyNameUniqueStatus = exports.getProxyNameUniqueStatus = function getProxyNameUniqueStatus(state) {
	  return (0, _lodash.get)(state, 'apiProxy.proxyNameUniqueStatus');
	};
	var getApiProxyType = exports.getApiProxyType = function getApiProxyType(state) {
	  return (0, _lodash.get)(state, 'apiProxy.apiProxyType');
	};
	var getApiKeyProxyType = exports.getApiKeyProxyType = function getApiKeyProxyType(state) {
	  return (0, _lodash.get)(state, 'apiProxy.apiKeyProxyType');
	};
	var getProxyDetails = exports.getProxyDetails = function getProxyDetails(state) {
	  return (0, _lodash.get)(state, 'apiProxy.proxyDetails');
	};
	var getSaveProxyStatus = exports.getSaveProxyStatus = function getSaveProxyStatus(state) {
	  return (0, _lodash.get)(state, 'apiProxy.saveProxyStatus');
	};
	var getUpdateKeyDeploymentTypeStatus = exports.getUpdateKeyDeploymentTypeStatus = function getUpdateKeyDeploymentTypeStatus(state) {
	  return (0, _lodash.get)(state, 'apiProxy.updateKeyDeploymentTypeStatus');
	};
	var getDeleteProxyStatus = exports.getDeleteProxyStatus = function getDeleteProxyStatus(state) {
	  return (0, _lodash.get)(state, 'apiProxy.deleteProxyStatus');
	};
	var getOrganizations = exports.getOrganizations = function getOrganizations(state) {
	  return (0, _lodash.get)(state, 'apiProxy.organizations');
	};
	var getSelectedOrganizations = exports.getSelectedOrganizations = function getSelectedOrganizations(state) {
	  var organizations = (0, _lodash.get)(state, 'apiProxy.organizations');
	  var selectedOrganizations = (0, _lodash.get)(state, 'apiProxy.selectedOrganizations');
	  return getFilteredProxyOrgs(organizations, selectedOrganizations);
	};
	var getUpdateProxyOrgsStatus = exports.getUpdateProxyOrgsStatus = function getUpdateProxyOrgsStatus(state) {
	  return (0, _lodash.get)(state, 'apiProxy.updateProxyOrgsStatus');
	};
	var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
	  return (0, _lodash.get)(state, 'apiProxy.isLoading');
	};
	var getGatewayDetails = exports.getGatewayDetails = function getGatewayDetails(state) {
	  return (0, _lodash.get)(state, 'apiProxy.gatewayDetails');
	};
	var getGateways = exports.getGateways = function getGateways(state) {
	  return (0, _lodash.get)(state, 'apiProxy.gateways');
	};
	var getApis = exports.getApis = function getApis(state) {
	  return (0, _lodash.get)(state, 'apiProxy.apis');
	};
	var getApps = exports.getApps = function getApps(state) {
	  return (0, _lodash.get)(state, 'apiProxy.apps');
	};
	var getAccountPlans = exports.getAccountPlans = function getAccountPlans(state) {
	  return (0, _lodash.get)(state, 'apiProxy.accountPlans');
	};
	var getApiPlans = exports.getApiPlans = function getApiPlans(state) {
	  return (0, _lodash.get)(state, 'apiProxy.apiPlans');
	};
	var getApiPlansCount = exports.getApiPlansCount = function getApiPlansCount(state) {
	  return (0, _lodash.get)(state, 'apiProxy.apiPlansCount');
	};
	var getApplicationApiKeysCount = exports.getApplicationApiKeysCount = function getApplicationApiKeysCount(state) {
	  return (0, _lodash.get)(state, 'apiProxy.applicationApiKeysCount');
	};
	var getApiSyncFeatureFlag = exports.getApiSyncFeatureFlag = function getApiSyncFeatureFlag(state) {
	  return (0, _lodash.get)(state, 'apiProxy.useNewAutoSync');
	};
	var getPortalApis = exports.getPortalApis = function getPortalApis(state) {
	  return (0, _lodash.get)(state, 'apiProxy.syncApis.portalApis');
	};
	var getPortalPublishedApis = exports.getPortalPublishedApis = function getPortalPublishedApis(state) {
	  return (0, _lodash.get)(state, 'apiProxy.syncApis.publishedByPortal');
	};
	var getGatewayPublishedApis = exports.getGatewayPublishedApis = function getGatewayPublishedApis(state) {
	  return (0, _lodash.get)(state, 'apiProxy.syncApis.publishedByGateway');
	};
	
	var getDeploymentType = exports.getDeploymentType = function getDeploymentType(state) {
	  return (0, _lodash.get)(state, 'apiProxy.deploymentType');
	};

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDashboardChartData = exports.getDashboardEntityCount = exports.getAutoSuggest = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.DASHBOARD_AUTOSUGGEST_SHOW_SUCCESS:
	      return Object.assign({}, state, {
	        suggestions: action.payload && action.payload.suggestions && action.payload.suggestions.length ? action.payload.suggestions : [],
	        isError: false
	      });
	    case constants.DASHBOARD_GET_ENTITY_COUNT_SUCCESS:
	      return Object.assign({}, state, {
	        entities: action.payload
	      });
	    case constants.DASHBOARD_CHART_DATA_SUCCESS:
	      return Object.assign({}, state, {
	        chartData: Object.assign({}, state.chartData, _defineProperty({}, action.entity, action.payload))
	      });
	    default:
	      return state;
	  }
	};
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  isLoading: false,
	  isError: false,
	  suggestions: [],
	  entities: [],
	  chartData: {}
	};
	
	var getAutoSuggest = exports.getAutoSuggest = function getAutoSuggest(state) {
	  return (0, _lodash.get)(state, 'dashboard.suggestions');
	};
	var getDashboardEntityCount = exports.getDashboardEntityCount = function getDashboardEntityCount(state) {
	  return (0, _lodash.get)(state, 'dashboard.entities');
	};
	var getDashboardChartData = exports.getDashboardChartData = function getDashboardChartData(state) {
	  return (0, _lodash.get)(state, 'dashboard.chartData');
	};

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collapse = exports.collapseDuration = exports.Fade = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(643);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Fade = function Fade(_ref) {
	  var Tag = _ref.component,
	      _ref$duration = _ref.duration,
	      duration = _ref$duration === void 0 ? 1 : _ref$duration,
	      inProp = _ref.in,
	      onExited = _ref.onExited,
	      props = _objectWithoutProperties(_ref, ["component", "duration", "in", "onExited"]);
	
	  var transition = {
	    entering: {
	      opacity: 0
	    },
	    entered: {
	      opacity: 1,
	      transition: "opacity ".concat(duration, "ms")
	    },
	    exiting: {
	      opacity: 0
	    },
	    exited: {
	      opacity: 0
	    }
	  };
	  return _react.default.createElement(_reactTransitionGroup.Transition, {
	    mountOnEnter: true,
	    unmountOnExit: true,
	    in: inProp,
	    timeout: duration
	  }, function (state) {
	    var innerProps = {
	      style: _objectSpread({}, transition[state])
	    };
	    return _react.default.createElement(Tag, _extends({
	      innerProps: innerProps
	    }, props));
	  });
	}; // ==============================
	// Collapse Transition
	// ==============================
	
	
	exports.Fade = Fade;
	var collapseDuration = 260;
	exports.collapseDuration = collapseDuration;
	
	// wrap each MultiValue with a collapse transition; decreases width until
	// finally removing from DOM
	var Collapse =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Collapse, _Component);
	
	  function Collapse() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Collapse);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "duration", collapseDuration);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rafID", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      width: 'auto'
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transition", {
	      exiting: {
	        width: 0,
	        transition: "width ".concat(_this.duration, "ms ease-out")
	      },
	      exited: {
	        width: 0
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getWidth", function (ref) {
	      if (ref && isNaN(_this.state.width)) {
	        /*
	          Here we're invoking requestAnimationFrame with a callback invoking our
	          call to getBoundingClientRect and setState in order to resolve an edge case
	          around portalling. Certain portalling solutions briefly remove children from the DOM
	          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
	          while the Select component is in this state.
	        */
	        // cannot use `offsetWidth` because it is rounded
	        _this.rafID = window.requestAnimationFrame(function () {
	          var _ref$getBoundingClien = ref.getBoundingClientRect(),
	              width = _ref$getBoundingClien.width;
	
	          _this.setState({
	            width: width
	          });
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function (width) {
	      return {
	        overflow: 'hidden',
	        whiteSpace: 'nowrap',
	        width: width
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransition", function (state) {
	      return _this.transition[state];
	    });
	
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.rafID) {
	        window.cancelAnimationFrame(this.rafID);
	      }
	    } // width must be calculated; cannot transition from `undefined` to `number`
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          inProp = _this$props.in;
	      var width = this.state.width;
	      return _react.default.createElement(_reactTransitionGroup.Transition, {
	        enter: false,
	        mountOnEnter: true,
	        unmountOnExit: true,
	        in: inProp,
	        timeout: this.duration
	      }, function (state) {
	        var style = _objectSpread({}, _this2.getStyle(width), _this2.getTransition(state));
	
	        return _react.default.createElement("div", {
	          ref: _this2.getWidth,
	          style: style
	        }, children);
	      });
	    }
	  }]);
	
	  return Collapse;
	}(_react.Component);
	
	exports.Collapse = Collapse;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMenuPlacement = getMenuPlacement;
	exports.MenuPortal = exports.menuPortalCSS = exports.LoadingMessage = exports.NoOptionsMessage = exports.loadingMessageCSS = exports.noOptionsMessageCSS = exports.MenuList = exports.menuListCSS = exports.default = exports.MenuPlacer = exports.menuCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	var _reactDom = __webpack_require__(32);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(124));
	
	var _utils = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getMenuPlacement(_ref) {
	  var maxHeight = _ref.maxHeight,
	      menuEl = _ref.menuEl,
	      minHeight = _ref.minHeight,
	      placement = _ref.placement,
	      shouldScroll = _ref.shouldScroll,
	      isFixedPosition = _ref.isFixedPosition,
	      theme = _ref.theme;
	  var spacing = theme.spacing;
	  var scrollParent = (0, _utils.getScrollParent)(menuEl);
	  var defaultState = {
	    placement: 'bottom',
	    maxHeight: maxHeight
	  }; // something went wrong, return default state
	
	  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
	  // the menu is rendered
	
	  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
	      scrollHeight = _scrollParent$getBoun.height;
	
	  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
	      menuBottom = _menuEl$getBoundingCl.bottom,
	      menuHeight = _menuEl$getBoundingCl.height,
	      menuTop = _menuEl$getBoundingCl.top;
	
	  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
	      containerTop = _menuEl$offsetParent$.top;
	
	  var viewHeight = window.innerHeight;
	  var scrollTop = (0, _utils.getScrollTop)(scrollParent);
	  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
	  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
	  var viewSpaceAbove = containerTop - marginTop;
	  var viewSpaceBelow = viewHeight - menuTop;
	  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
	  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
	  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
	  var scrollUp = scrollTop + menuTop - marginTop;
	  var scrollDuration = 160;
	
	  switch (placement) {
	    case 'auto':
	    case 'bottom':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceBelow >= menuHeight) {
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
	        }
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
	        } // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	
	        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
	        return {
	          placement: 'bottom',
	          maxHeight: constrainedHeight
	        };
	      } // 4. Forked beviour when there isn't enough space below
	      // AUTO: flip the menu, render above
	
	
	      if (placement === 'auto' || isFixedPosition) {
	        // may need to be constrained after flipping
	        var _constrainedHeight = maxHeight;
	        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
	
	        if (spaceAbove >= minHeight) {
	          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight
	        };
	      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
	
	
	      if (placement === 'bottom') {
	        (0, _utils.scrollTo)(scrollParent, scrollDown);
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      }
	
	      break;
	
	    case 'top':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceAbove >= menuHeight) {
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
	        }
	
	        if (shouldScroll) {
	          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight2
	        };
	      } // 4. not enough space, the browser WILL NOT increase scrollable area when
	      // absolutely positioned element rendered above the viewport (only below).
	      // Flip the menu, render below
	
	
	      return {
	        placement: 'bottom',
	        maxHeight: maxHeight
	      };
	
	    default:
	      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
	  } // fulfil contract with flow: implicit return value of undefined
	
	
	  return defaultState;
	} // Menu Component
	// ------------------------------
	
	
	function alignToControl(placement) {
	  var placementToCSSProp = {
	    bottom: 'top',
	    top: 'bottom'
	  };
	  return placement ? placementToCSSProp[placement] : 'bottom';
	}
	
	var coercePlacement = function coercePlacement(p) {
	  return p === 'auto' ? 'bottom' : p;
	};
	
	var menuCSS = function menuCSS(_ref2) {
	  var _ref3;
	
	  var placement = _ref2.placement,
	      _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      spacing = _ref2$theme.spacing,
	      colors = _ref2$theme.colors;
	  return _ref3 = {
	    label: 'menu'
	  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
	}; // NOTE: internal only
	
	
	exports.menuCSS = menuCSS;
	
	var MenuPlacer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MenuPlacer, _Component);
	
	  function MenuPlacer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, MenuPlacer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      maxHeight: _this.props.maxMenuHeight,
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
	      var _this$props = _this.props,
	          minMenuHeight = _this$props.minMenuHeight,
	          maxMenuHeight = _this$props.maxMenuHeight,
	          menuPlacement = _this$props.menuPlacement,
	          menuPosition = _this$props.menuPosition,
	          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
	          theme = _this$props.theme;
	      var getPortalPlacement = _this.context.getPortalPlacement;
	      if (!ref) return; // DO NOT scroll if position is fixed
	
	      var isFixedPosition = menuPosition === 'fixed';
	      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
	      var state = getMenuPlacement({
	        maxHeight: maxMenuHeight,
	        menuEl: ref,
	        minHeight: minMenuHeight,
	        placement: menuPlacement,
	        shouldScroll: shouldScroll,
	        isFixedPosition: isFixedPosition,
	        theme: theme
	      });
	      if (getPortalPlacement) getPortalPlacement(state);
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
	      var menuPlacement = _this.props.menuPlacement;
	      var placement = _this.state.placement || coercePlacement(menuPlacement);
	      return _objectSpread({}, _this.props, {
	        placement: placement,
	        maxHeight: _this.state.maxHeight
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(MenuPlacer, [{
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return children({
	        ref: this.getPlacement,
	        placerProps: this.getUpdatedProps()
	      });
	    }
	  }]);
	
	  return MenuPlacer;
	}(_react.Component);
	
	exports.MenuPlacer = MenuPlacer;
	
	_defineProperty(MenuPlacer, "contextTypes", {
	  getPortalPlacement: _propTypes.default.func
	});
	
	var Menu = function Menu(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  var cn = cx(
	  /*#__PURE__*/
	  (0, _emotion.css)(getStyles('menu', props)), {
	    menu: true
	  }, className);
	  return _react.default.createElement("div", _extends({
	    className: cn
	  }, innerProps, {
	    ref: innerRef
	  }), children);
	};
	
	var _default = Menu; // ==============================
	// Menu List
	// ==============================
	
	exports.default = _default;
	
	var menuListCSS = function menuListCSS(_ref4) {
	  var maxHeight = _ref4.maxHeight,
	      baseUnit = _ref4.theme.spacing.baseUnit;
	  return {
	    maxHeight: maxHeight,
	    overflowY: 'auto',
	    paddingBottom: baseUnit,
	    paddingTop: baseUnit,
	    position: 'relative',
	    // required for offset[Height, Top] > keyboard scroll
	    WebkitOverflowScrolling: 'touch'
	  };
	};
	
	exports.menuListCSS = menuListCSS;
	
	var MenuList = function MenuList(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isMulti = props.isMulti,
	      innerRef = props.innerRef;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('menuList', props)), {
	      'menu-list': true,
	      'menu-list--is-multi': isMulti
	    }, className),
	    ref: innerRef
	  }, children);
	}; // ==============================
	// Menu Notices
	// ==============================
	
	
	exports.MenuList = MenuList;
	
	var noticeCSS = function noticeCSS(_ref5) {
	  var _ref5$theme = _ref5.theme,
	      baseUnit = _ref5$theme.spacing.baseUnit,
	      colors = _ref5$theme.colors;
	  return {
	    color: colors.neutral40,
	    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
	    textAlign: 'center'
	  };
	};
	
	var noOptionsMessageCSS = noticeCSS;
	exports.noOptionsMessageCSS = noOptionsMessageCSS;
	var loadingMessageCSS = noticeCSS;
	exports.loadingMessageCSS = loadingMessageCSS;
	
	var NoOptionsMessage = function NoOptionsMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('noOptionsMessage', props)), {
	      'menu-notice': true,
	      'menu-notice--no-options': true
	    }, className)
	  }, innerProps), children);
	};
	
	exports.NoOptionsMessage = NoOptionsMessage;
	NoOptionsMessage.defaultProps = {
	  children: 'No options'
	};
	
	var LoadingMessage = function LoadingMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('loadingMessage', props)), {
	      'menu-notice': true,
	      'menu-notice--loading': true
	    }, className)
	  }, innerProps), children);
	};
	
	exports.LoadingMessage = LoadingMessage;
	LoadingMessage.defaultProps = {
	  children: 'Loading...'
	}; // ==============================
	// Menu Portal
	// ==============================
	
	var menuPortalCSS = function menuPortalCSS(_ref6) {
	  var rect = _ref6.rect,
	      offset = _ref6.offset,
	      position = _ref6.position;
	  return {
	    left: rect.left,
	    position: position,
	    top: offset,
	    width: rect.width,
	    zIndex: 1
	  };
	};
	
	exports.menuPortalCSS = menuPortalCSS;
	
	var MenuPortal =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MenuPortal, _Component2);
	
	  function MenuPortal() {
	    var _getPrototypeOf3;
	
	    var _this2;
	
	    _classCallCheck(this, MenuPortal);
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
	      var placement = _ref7.placement;
	      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
	
	      if (placement !== initialPlacement) {
	        _this2.setState({
	          placement: placement
	        });
	      }
	    });
	
	    return _this2;
	  }
	
	  _createClass(MenuPortal, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        getPortalPlacement: this.getPortalPlacement
	      };
	    } // callback for occassions where the menu must "flip"
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          appendTo = _this$props2.appendTo,
	          children = _this$props2.children,
	          controlElement = _this$props2.controlElement,
	          menuPlacement = _this$props2.menuPlacement,
	          position = _this$props2.menuPosition,
	          getStyles = _this$props2.getStyles;
	      var isFixed = position === 'fixed'; // bail early if required elements aren't present
	
	      if (!appendTo && !isFixed || !controlElement) {
	        return null;
	      }
	
	      var placement = this.state.placement || coercePlacement(menuPlacement);
	      var rect = (0, _utils.getBoundingClientObj)(controlElement);
	      var scrollDistance = isFixed ? 0 : window.pageYOffset;
	      var offset = rect[placement] + scrollDistance;
	      var state = {
	        offset: offset,
	        position: position,
	        rect: rect
	      }; // same wrapper element whether fixed or portalled
	
	      var menuWrapper = _react.default.createElement("div", {
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('menuPortal', state))
	      }, children);
	
	      return appendTo ? (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper;
	    }
	  }]);
	
	  return MenuPortal;
	}(_react.Component);
	
	exports.MenuPortal = MenuPortal;
	
	_defineProperty(MenuPortal, "childContextTypes", {
	  getPortalPlacement: _propTypes.default.func
	});

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultComponents = exports.components = void 0;
	
	var _containers = __webpack_require__(636);
	
	var _indicators = __webpack_require__(289);
	
	var _Control = _interopRequireDefault(__webpack_require__(629));
	
	var _Group = _interopRequireWildcard(__webpack_require__(630));
	
	var _Input = _interopRequireDefault(__webpack_require__(631));
	
	var _Menu = _interopRequireWildcard(__webpack_require__(287));
	
	var _MultiValue = _interopRequireWildcard(__webpack_require__(632));
	
	var _Option = _interopRequireDefault(__webpack_require__(633));
	
	var _Placeholder = _interopRequireDefault(__webpack_require__(634));
	
	var _SingleValue = _interopRequireDefault(__webpack_require__(635));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var components = {
	  ClearIndicator: _indicators.ClearIndicator,
	  Control: _Control.default,
	  DropdownIndicator: _indicators.DropdownIndicator,
	  DownChevron: _indicators.DownChevron,
	  CrossIcon: _indicators.CrossIcon,
	  Group: _Group.default,
	  GroupHeading: _Group.GroupHeading,
	  IndicatorsContainer: _containers.IndicatorsContainer,
	  IndicatorSeparator: _indicators.IndicatorSeparator,
	  Input: _Input.default,
	  LoadingIndicator: _indicators.LoadingIndicator,
	  Menu: _Menu.default,
	  MenuList: _Menu.MenuList,
	  MenuPortal: _Menu.MenuPortal,
	  LoadingMessage: _Menu.LoadingMessage,
	  NoOptionsMessage: _Menu.NoOptionsMessage,
	  MultiValue: _MultiValue.default,
	  MultiValueContainer: _MultiValue.MultiValueContainer,
	  MultiValueLabel: _MultiValue.MultiValueLabel,
	  MultiValueRemove: _MultiValue.MultiValueRemove,
	  Option: _Option.default,
	  Placeholder: _Placeholder.default,
	  SelectContainer: _containers.SelectContainer,
	  SingleValue: _SingleValue.default,
	  ValueContainer: _containers.ValueContainer
	};
	exports.components = components;
	
	var defaultComponents = function defaultComponents(props) {
	  return _objectSpread({}, components, props.components);
	};
	
	exports.defaultComponents = defaultComponents;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoadingIndicator = exports.loadingIndicatorCSS = exports.IndicatorSeparator = exports.indicatorSeparatorCSS = exports.ClearIndicator = exports.clearIndicatorCSS = exports.DropdownIndicator = exports.dropdownIndicatorCSS = exports.DownChevron = exports.CrossIcon = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// ==============================
	// Dropdown & Clear Icons
	// ==============================
	var Svg = function Svg(_ref) {
	  var size = _ref.size,
	      props = _objectWithoutProperties(_ref, ["size"]);
	
	  return _react.default.createElement("svg", _extends({
	    height: size,
	    width: size,
	    viewBox: "0 0 20 20",
	    "aria-hidden": "true",
	    focusable: "false",
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      display: 'inline-block',
	      fill: 'currentColor',
	      lineHeight: 1,
	      stroke: 'currentColor',
	      strokeWidth: 0
	    })
	  }, props));
	};
	
	var CrossIcon = function CrossIcon(props) {
	  return _react.default.createElement(Svg, _extends({
	    size: 20
	  }, props), _react.default.createElement("path", {
	    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
	  }));
	};
	
	exports.CrossIcon = CrossIcon;
	
	var DownChevron = function DownChevron(props) {
	  return _react.default.createElement(Svg, _extends({
	    size: 20
	  }, props), _react.default.createElement("path", {
	    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
	  }));
	}; // ==============================
	// Dropdown & Clear Buttons
	// ==============================
	
	
	exports.DownChevron = DownChevron;
	
	var baseCSS = function baseCSS(_ref2) {
	  var isFocused = _ref2.isFocused,
	      _ref2$theme = _ref2.theme,
	      baseUnit = _ref2$theme.spacing.baseUnit,
	      colors = _ref2$theme.colors;
	  return {
	    label: 'indicatorContainer',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    ':hover': {
	      color: isFocused ? colors.neutral80 : colors.neutral40
	    }
	  };
	};
	
	var dropdownIndicatorCSS = baseCSS;
	exports.dropdownIndicatorCSS = dropdownIndicatorCSS;
	
	var DropdownIndicator = function DropdownIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('dropdownIndicator', props)), {
	      'indicator': true,
	      'dropdown-indicator': true
	    }, className)
	  }), children || _react.default.createElement(DownChevron, null));
	};
	
	exports.DropdownIndicator = DropdownIndicator;
	var clearIndicatorCSS = baseCSS;
	exports.clearIndicatorCSS = clearIndicatorCSS;
	
	var ClearIndicator = function ClearIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('clearIndicator', props)), {
	      'indicator': true,
	      'clear-indicator': true
	    }, className)
	  }), children || _react.default.createElement(CrossIcon, null));
	}; // ==============================
	// Separator
	// ==============================
	
	
	exports.ClearIndicator = ClearIndicator;
	
	var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
	  var isDisabled = _ref3.isDisabled,
	      _ref3$theme = _ref3.theme,
	      baseUnit = _ref3$theme.spacing.baseUnit,
	      colors = _ref3$theme.colors;
	  return {
	    label: 'indicatorSeparator',
	    alignSelf: 'stretch',
	    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
	    marginBottom: baseUnit * 2,
	    marginTop: baseUnit * 2,
	    width: 1
	  };
	};
	
	exports.indicatorSeparatorCSS = indicatorSeparatorCSS;
	
	var IndicatorSeparator = function IndicatorSeparator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("span", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('indicatorSeparator', props)), {
	      'indicator-separator': true
	    }, className)
	  }));
	}; // ==============================
	// Loading
	// ==============================
	
	
	exports.IndicatorSeparator = IndicatorSeparator;
	var keyframesName = 'react-select-loading-indicator';
	var keyframesInjected = false;
	
	var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
	  var isFocused = _ref4.isFocused,
	      size = _ref4.size,
	      _ref4$theme = _ref4.theme,
	      colors = _ref4$theme.colors,
	      baseUnit = _ref4$theme.spacing.baseUnit;
	  return {
	    label: 'loadingIndicator',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    alignSelf: 'center',
	    fontSize: size,
	    lineHeight: 1,
	    marginRight: size,
	    textAlign: 'center',
	    verticalAlign: 'middle'
	  };
	};
	
	exports.loadingIndicatorCSS = loadingIndicatorCSS;
	
	var LoadingDot = function LoadingDot(_ref5) {
	  var color = _ref5.color,
	      delay = _ref5.delay,
	      offset = _ref5.offset;
	  return _react.default.createElement("span", {
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      animationDuration: '1s',
	      animationDelay: "".concat(delay, "ms"),
	      animationIterationCount: 'infinite',
	      animationName: keyframesName,
	      animationTimingFunction: 'ease-in-out',
	      backgroundColor: color,
	      borderRadius: '1em',
	      display: 'inline-block',
	      marginLeft: offset ? '1em' : null,
	      height: '1em',
	      verticalAlign: 'top',
	      width: '1em'
	    })
	  });
	};
	
	var LoadingIndicator = function LoadingIndicator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isFocused = props.isFocused,
	      isRtl = props.isRtl,
	      colors = props.theme.colors;
	  var color = isFocused ? colors.neutral80 : colors.neutral20;
	
	  if (!keyframesInjected) {
	    // eslint-disable-next-line no-unused-expressions
	    (0, _emotion.injectGlobal)("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");
	    keyframesInjected = true;
	  }
	
	  return _react.default.createElement("div", _extends({}, innerProps, {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('loadingIndicator', props)), {
	      'indicator': true,
	      'loading-indicator': true
	    }, className)
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 0,
	    offset: isRtl
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 160,
	    offset: true
	  }), _react.default.createElement(LoadingDot, {
	    color: color,
	    delay: 320,
	    offset: !isRtl
	  }));
	};
	
	exports.LoadingIndicator = LoadingIndicator;
	LoadingIndicator.defaultProps = {
	  size: 4
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(32);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var NodeResolver =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(NodeResolver, _Component);
	
	  function NodeResolver() {
	    _classCallCheck(this, NodeResolver);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
	  }
	
	  _createClass(NodeResolver, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.innerRef((0, _reactDom.findDOMNode)(this));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.innerRef(null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return NodeResolver;
	}(_react.Component);
	
	exports.default = NodeResolver;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(126));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(32));
	
	var _config = _interopRequireDefault(__webpack_require__(646));
	
	var _PropTypes = __webpack_require__(647);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(292));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  } // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	  ;
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(mounting);
	      } else {
	        this.performExit();
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	
	    var _ref2 = this.props.nodeRef ? [appearing] : [_reactDom.default.findDOMNode(this), appearing],
	        maybeNode = _ref2[0],
	        maybeAppearing = _ref2[1];
	
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onEnter(maybeNode, maybeAppearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(maybeNode, maybeAppearing);
	
	      _this2.onTransitionEnd(enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(maybeNode, maybeAppearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit() {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts();
	    var maybeNode = this.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onExit(maybeNode);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(maybeNode);
	
	      _this3.onTransitionEnd(timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(maybeNode);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
	    this.setNextCallback(handler);
	    var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
	          maybeNode = _ref3[0],
	          maybeNextCallback = _ref3[1];
	
	      this.props.addEndListener(maybeNode, maybeNextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        _in = _this$props.in,
	        _mountOnEnter = _this$props.mountOnEnter,
	        _unmountOnExit = _this$props.unmountOnExit,
	        _appear = _this$props.appear,
	        _enter = _this$props.enter,
	        _exit = _this$props.exit,
	        _timeout = _this$props.timeout,
	        _addEndListener = _this$props.addEndListener,
	        _onEnter = _this$props.onEnter,
	        _onEntering = _this$props.onEntering,
	        _onEntered = _this$props.onEntered,
	        _onExit = _this$props.onExit,
	        _onExiting = _this$props.onExiting,
	        _onExited = _this$props.onExited,
	        _nodeRef = _this$props.nodeRef,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
	
	    return (
	      /*#__PURE__*/
	      // allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, typeof children === 'function' ? children(status, childProps) : _react.default.cloneElement(_react.default.Children.only(children), childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A React reference to DOM element that need to transition:
	   * https://stackoverflow.com/a/51127130/4671932
	   *
	   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
	   *      (e.g. `onEnter`) because user already has direct access to the node.
	   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
	   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
	   *     (see
	   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
	   */
	  nodeRef: _propTypes.default.shape({
	    current: typeof Element === 'undefined' ? _propTypes.default.any : _propTypes.default.instanceOf(Element)
	  }),
	
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * By default the child component does not perform the enter transition when
	   * it first mounts, regardless of the value of `in`. If you want this
	   * behavior, set both `appear` and `in` to `true`.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. Timeouts are still used as a fallback if provided.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func
	} : {}; // Name the function so it is clearer in the documentation
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = UNMOUNTED;
	Transition.EXITED = EXITED;
	Transition.ENTERING = ENTERING;
	Transition.ENTERED = ENTERED;
	Transition.EXITING = EXITING;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 292 */
243,
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(649));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
	  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
	  }
	
	  if (enumerableOnly) keys = keys.filter(function (sym) {
	    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	  });
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread2({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	
	function isCrushed() {}
	
	if (false) {
	  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFQDN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _merge = _interopRequireDefault(__webpack_require__(106));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFQDN(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_fqdn_options);
	  /* Remove the optional trailing dot before checking validity */
	
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	
	  var parts = str.split('.');
	
	  for (var i = 0; i < parts.length; i++) {
	    if (parts[i].length > 63) {
	      return false;
	    }
	  }
	
	  if (options.require_tld) {
	    var tld = parts.pop();
	
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    } // disallow spaces
	
	
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	
	  for (var part, _i = 0; _i < parts.length; _i++) {
	    part = parts[_i];
	
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    } // disallow full-width chars
	
	
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toDate(date) {
	  (0, _assertString.default)(date);
	  date = Date.parse(date);
	  return !isNaN(date) ? new Date(date) : null;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 296 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var includes = function includes(arr, val) {
	  return arr.some(function (arrVal) {
	    return val === arrVal;
	  });
	};
	
	var _default = includes;
	exports.default = _default;
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	var Line = function (props) {
	  // eslint-disable-next-line react/prop-types
	  var desc = props.desc,
	      rest = _objectWithoutProperties(props, ["desc"]);
	
	  return desc ? _react.default.createElement("line", _extends({
	    vectorEffect: "non-scaling-stroke"
	  }, rest), _react.default.createElement("desc", null, desc)) : _react.default.createElement("line", _extends({
	    vectorEffect: "non-scaling-stroke"
	  }, rest));
	};
	
	var _default = Line;
	exports.default = _default;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	var Path = function (props) {
	  // eslint-disable-next-line react/prop-types
	  var desc = props.desc,
	      rest = _objectWithoutProperties(props, ["desc"]);
	
	  return desc ? _react.default.createElement("path", rest, _react.default.createElement("desc", null, desc)) : _react.default.createElement("path", rest);
	};
	
	var _default = Path;
	exports.default = _default;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	var Rect = function (props) {
	  // eslint-disable-next-line react/prop-types
	  var desc = props.desc,
	      rest = _objectWithoutProperties(props, ["desc"]);
	
	  return desc ? _react.default.createElement("rect", _extends({
	    vectorEffect: "non-scaling-stroke"
	  }, rest), _react.default.createElement("desc", null, desc)) : _react.default.createElement("rect", _extends({
	    vectorEffect: "non-scaling-stroke"
	  }, rest));
	};
	
	var _default = Rect;
	exports.default = _default;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _includes2 = _interopRequireDefault(__webpack_require__(83));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(1370));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _orderBy2 = _interopRequireDefault(__webpack_require__(119));
	
	var _property2 = _interopRequireDefault(__webpack_require__(274));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _last2 = _interopRequireDefault(__webpack_require__(1371));
	
	var _range2 = _interopRequireDefault(__webpack_require__(192));
	
	var _uniq2 = _interopRequireDefault(__webpack_require__(99));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _collection = _interopRequireDefault(__webpack_require__(89));
	
	var _scale = _interopRequireDefault(__webpack_require__(213));
	
	var _immutable = _interopRequireDefault(__webpack_require__(679));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	// Private Functions
	function parseDatum(datum) {
	  var immutableDatumWhitelist = {
	    errorX: true,
	    errorY: true
	  };
	  return _immutable.default.isImmutable(datum) ? _immutable.default.shallowToJS(datum, immutableDatumWhitelist) : datum;
	}
	
	function getLength(data) {
	  return _immutable.default.isIterable(data) ? data.size : data.length;
	} // Returns generated data for a given axis based on domain and sample from props
	
	
	function generateDataArray(props, axis) {
	  var propsDomain = (0, _isPlainObject2.default)(props.domain) ? props.domain[axis] : props.domain;
	
	  var domain = propsDomain || _scale.default.getBaseScale(props, axis).domain();
	
	  var samples = props.samples || 1;
	  var domainMax = Math.max.apply(Math, _toConsumableArray(domain));
	  var domainMin = Math.min.apply(Math, _toConsumableArray(domain));
	  var step = (domainMax - domainMin) / samples;
	  var values = (0, _range2.default)(domainMin, domainMax, step);
	  return (0, _last2.default)(values) === domainMax ? values : values.concat(domainMax);
	} // Returns sorted data. If no sort keys are provided, data is returned unaltered.
	
	
	function sortData(dataset, sortKey) {
	  var sortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ascending";
	
	  if (!sortKey) {
	    return dataset;
	  } // Ensures previous VictoryLine api for sortKey prop stays consistent
	
	
	  if (sortKey === "x" || sortKey === "y") {
	    sortKey = "_".concat(sortKey);
	  }
	
	  var order = sortOrder === "ascending" ? "asc" : "desc";
	  return (0, _orderBy2.default)(dataset, sortKey, order);
	} // This method will remove data points that break certain scales. (log scale only)
	
	
	function cleanData(dataset, props) {
	  var smallNumber = 1 / Number.MAX_SAFE_INTEGER;
	  var scaleType = {
	    x: _scale.default.getScaleType(props, "x"),
	    y: _scale.default.getScaleType(props, "y")
	  };
	
	  if (scaleType.x !== "log" && scaleType.y !== "log") {
	    return dataset;
	  }
	
	  var rules = function (datum, axis) {
	    return scaleType[axis] === "log" ? datum["_".concat(axis)] !== 0 : true;
	  };
	
	  var sanitize = function (datum) {
	    var _x = rules(datum, "x") ? datum._x : smallNumber;
	
	    var _y = rules(datum, "y") ? datum._y : smallNumber;
	
	    var _y0 = rules(datum, "y0") ? datum._y0 : smallNumber;
	
	    return (0, _assign2.default)({}, datum, {
	      _x: _x,
	      _y: _y,
	      _y0: _y0
	    });
	  };
	
	  return dataset.map(function (datum) {
	    if (rules(datum, "x") && rules(datum, "y") && rules(datum, "y0")) {
	      return datum;
	    }
	
	    return sanitize(datum);
	  });
	} // Returns a data accessor given an eventKey prop
	
	
	function getEventKey(key) {
	  // creates a data accessor function
	  // given a property key, path, array index, or null for identity.
	  if ((0, _isFunction2.default)(key)) {
	    return key;
	  } else if (key === null || key === undefined) {
	    return function () {
	      return undefined;
	    };
	  } // otherwise, assume it is an array index, property key or path (_.property handles all three)
	
	
	  return (0, _property2.default)(key);
	} // Returns data with an eventKey prop added to each datum
	
	
	function addEventKeys(props, data) {
	  var hasEventKeyAccessor = !!props.eventKey;
	  var eventKeyAccessor = getEventKey(props.eventKey);
	  return data.map(function (datum, index) {
	    if (datum.eventKey !== undefined) {
	      return datum;
	    } else if (hasEventKeyAccessor) {
	      var eventKey = eventKeyAccessor(datum, index);
	      return eventKey !== undefined ? (0, _assign2.default)({
	        eventKey: eventKey
	      }, datum) : datum;
	    } else {
	      return datum;
	    }
	  });
	} // Exported Functions
	
	/**
	 * Returns an object mapping string data to numeric data
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Object} an object mapping string data to numeric data
	 */
	
	
	function createStringMap(props, axis) {
	  var stringsFromAxes = getStringsFromAxes(props, axis);
	  var stringsFromCategories = getStringsFromCategories(props, axis);
	  var stringsFromData = getStringsFromData(props, axis);
	  var allStrings = (0, _uniq2.default)(_toConsumableArray(stringsFromAxes).concat(_toConsumableArray(stringsFromCategories), _toConsumableArray(stringsFromData)));
	  return allStrings.length === 0 ? null : allStrings.reduce(function (memo, string, index) {
	    memo[string] = index + 1;
	    return memo;
	  }, {});
	}
	/**
	 * Reduces the size of a data array, such that it is <= maxPoints.
	 * @param {Array} data: an array of data; must be sorted
	 * @param {Number} maxPoints: maximum number of data points to return
	 * @param {Number} startingIndex: the index of the data[0] *in the entire dataset*; this function
	                   assumes `data` param is a subset of larger dataset that has been zoommed
	  * @returns {Array} an array of data, a subset of data param
	  */
	
	
	function downsample(data, maxPoints) {
	  var startingIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  // ensures that the downampling of data while zooming looks good.
	  var dataLength = getLength(data);
	
	  if (dataLength > maxPoints) {
	    // limit k to powers of 2, e.g. 64, 128, 256
	    // so that the same points will be chosen reliably, reducing flicker on zoom
	    var k = Math.pow(2, Math.ceil(Math.log2(dataLength / maxPoints)));
	    return data.filter( // ensure modulo is always calculated from same reference: i + startingIndex
	    function (d, i) {
	      return (i + startingIndex) % k === 0;
	    });
	  }
	
	  return data;
	}
	/**
	 * Returns formatted data. Data accessors are applied, and string values are replaced.
	 * @param {Array} dataset: the original domain
	 * @param {Object} props: the props object
	 * @param {Array} expectedKeys: an array of expected data keys
	 * @returns {Array} the formatted data
	 */
	
	
	function formatData(dataset, props, expectedKeys) {
	  var isArrayOrIterable = Array.isArray(dataset) || _immutable.default.isIterable(dataset);
	
	  if (!isArrayOrIterable || getLength(dataset) < 1) {
	    return [];
	  }
	
	  var defaultKeys = ["x", "y", "y0"];
	  expectedKeys = Array.isArray(expectedKeys) ? expectedKeys : defaultKeys;
	
	  var createAccessor = function (name) {
	    return _helpers.default.createAccessor(props[name] !== undefined ? props[name] : name);
	  };
	
	  var accessor = expectedKeys.reduce(function (memo, type) {
	    memo[type] = createAccessor(type);
	    return memo;
	  }, {});
	  var preformattedData = (0, _isEqual2.default)(expectedKeys, defaultKeys) && props.x === "_x" && props.y === "_y" && props.y0 === "_y0";
	  var stringMap;
	
	  if (preformattedData === false) {
	    // stringMap is not required if the data is preformatted
	    stringMap = {
	      x: expectedKeys.indexOf("x") !== -1 ? createStringMap(props, "x") : undefined,
	      y: expectedKeys.indexOf("y") !== -1 ? createStringMap(props, "y") : undefined,
	      y0: expectedKeys.indexOf("y0") !== -1 ? createStringMap(props, "y") : undefined
	    };
	  }
	
	  var data = preformattedData ? dataset : dataset.reduce(function (dataArr, datum, index) {
	    // eslint-disable-line complexity
	    datum = parseDatum(datum);
	    var fallbackValues = {
	      x: index,
	      y: datum
	    };
	    var processedValues = expectedKeys.reduce(function (memo, type) {
	      var processedValue = accessor[type](datum);
	      var value = processedValue !== undefined ? processedValue : fallbackValues[type];
	
	      if (value !== undefined) {
	        if (typeof value === "string" && stringMap[type]) {
	          memo["".concat(type, "Name")] = value;
	          memo["_".concat(type)] = stringMap[type][value];
	        } else {
	          memo["_".concat(type)] = value;
	        }
	      }
	
	      return memo;
	    }, {});
	    var formattedDatum = (0, _assign2.default)({}, processedValues, datum);
	
	    if (!(0, _isEmpty2.default)(formattedDatum)) {
	      dataArr.push(formattedDatum);
	    }
	
	    return dataArr;
	  }, []);
	  var sortedData = sortData(data, props.sortKey, props.sortOrder);
	  var cleanedData = cleanData(sortedData, props);
	  return addEventKeys(props, cleanedData);
	}
	/**
	 * Returns generated x and y data based on domain and sample from props
	 * @param {Object} props: the props object
	 * @returns {Array} an array of data
	 */
	
	
	function generateData(props) {
	  var xValues = generateDataArray(props, "x");
	  var yValues = generateDataArray(props, "y");
	  var values = xValues.map(function (x, i) {
	    return {
	      x: x,
	      y: yValues[i]
	    };
	  });
	  return values;
	}
	/**
	 * Returns an array of categories for a given axis
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Array} an array of categories
	 */
	
	
	function getCategories(props, axis) {
	  return props.categories && !Array.isArray(props.categories) ? props.categories[axis] : props.categories;
	}
	/**
	 * Returns an array of formatted data
	 * @param {Object} props: the props object
	 * @returns {Array} an array of data
	 */
	
	
	function getData(props) {
	  return props.data ? formatData(props.data, props) : formatData(generateData(props), props);
	}
	/**
	 * Returns an array of strings from axis tickValues for a given axis
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Array} an array of strings
	 */
	
	
	function getStringsFromAxes(props, axis) {
	  var tickValues = props.tickValues,
	      tickFormat = props.tickFormat;
	  var tickValueArray;
	
	  if (!tickValues || !Array.isArray(tickValues) && !tickValues[axis]) {
	    tickValueArray = tickFormat && Array.isArray(tickFormat) ? tickFormat : [];
	  } else {
	    tickValueArray = tickValues[axis] || tickValues;
	  }
	
	  return tickValueArray.filter(function (val) {
	    return typeof val === "string";
	  });
	}
	/**
	 * Returns an array of strings from categories for a given axis
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Array} an array of strings
	 */
	
	
	function getStringsFromCategories(props, axis) {
	  if (!props.categories) {
	    return [];
	  }
	
	  var categories = getCategories(props, axis);
	  var categoryStrings = categories && categories.filter(function (val) {
	    return typeof val === "string";
	  });
	  return categoryStrings ? _collection.default.removeUndefined(categoryStrings) : [];
	}
	/**
	 * Returns an array of strings from data
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Array} an array of strings
	 */
	
	
	function getStringsFromData(props, axis) {
	  var isArrayOrIterable = Array.isArray(props.data) || _immutable.default.isIterable(props.data);
	
	  if (!isArrayOrIterable) {
	    return [];
	  }
	
	  var key = props[axis] === undefined ? axis : props[axis];
	
	  var accessor = _helpers.default.createAccessor(key); // support immutable data
	
	
	  var data = props.data.reduce(function (memo, d) {
	    memo.push(parseDatum(d));
	    return memo;
	  }, []);
	  var sortedData = sortData(data, props.sortKey, props.sortOrder);
	  var dataStrings = sortedData.reduce(function (dataArr, datum) {
	    datum = parseDatum(datum);
	    dataArr.push(accessor(datum));
	    return dataArr;
	  }, []).filter(function (datum) {
	    return typeof datum === "string";
	  }); // return a unique set of strings
	
	  return dataStrings.reduce(function (prev, curr) {
	    if (curr !== undefined && curr !== null && prev.indexOf(curr) === -1) {
	      prev.push(curr);
	    }
	
	    return prev;
	  }, []);
	}
	/**
	 * Checks whether a given component can be used to calculate date
	 * @param {Component} component: a React component instance
	 * @returns {Boolean} Returns true if the given component has a role included in the whitelist
	 */
	
	
	function isDataComponent(component) {
	  var getRole = function (child) {
	    return child && child.type ? child.type.role : "";
	  };
	
	  var role = getRole(component);
	
	  if (role === "portal") {
	    var children = _react.default.Children.toArray(component.props.children);
	
	    role = children.length ? getRole(children[0]) : "";
	  }
	
	  var whitelist = ["area", "bar", "boxplot", "candlestick", "errorbar", "group", "line", "pie", "scatter", "stack", "voronoi"];
	  return (0, _includes2.default)(whitelist, role);
	}
	
	var _default = {
	  createStringMap: createStringMap,
	  downsample: downsample,
	  formatData: formatData,
	  generateData: generateData,
	  getCategories: getCategories,
	  getData: getData,
	  getStringsFromAxes: getStringsFromAxes,
	  getStringsFromCategories: getStringsFromCategories,
	  getStringsFromData: getStringsFromData,
	  isDataComponent: isDataComponent
	};
	exports.default = _default;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _includes2 = _interopRequireDefault(__webpack_require__(83));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _sortedUniq2 = _interopRequireDefault(__webpack_require__(1376));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _flatten2 = _interopRequireDefault(__webpack_require__(150));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _data = _interopRequireDefault(__webpack_require__(300));
	
	var _scale = _interopRequireDefault(__webpack_require__(213));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _collection = _interopRequireDefault(__webpack_require__(89));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	// Private Methods
	function cleanDomain(domain, props, axis) {
	  var scaleType = _scale.default.getScaleType(props, axis);
	
	  if (scaleType !== "log") {
	    return domain;
	  }
	
	  var rules = function (dom) {
	    var almostZero = dom[0] < 0 || dom[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER;
	    var domainOne = dom[0] === 0 ? almostZero : dom[0];
	    var domainTwo = dom[1] === 0 ? almostZero : dom[1];
	    return [domainOne, domainTwo];
	  };
	
	  return rules(domain);
	}
	
	function getDomainPadding(props, axis) {
	  var formatPadding = function (padding) {
	    return Array.isArray(padding) ? {
	      left: padding[0],
	      right: padding[1]
	    } : {
	      left: padding,
	      right: padding
	    };
	  };
	
	  return (0, _isPlainObject2.default)(props.domainPadding) ? formatPadding(props.domainPadding[axis]) : formatPadding(props.domainPadding);
	}
	
	function getFlatData(dataset, axis) {
	  return (0, _flatten2.default)(dataset).map(function (datum) {
	    return datum["_".concat(axis)] && datum["_".concat(axis)][1] !== undefined ? datum["_".concat(axis)][1] : datum["_".concat(axis)];
	  });
	}
	
	function getExtremeFromData(dataset, axis) {
	  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "min";
	
	  var getExtreme = function (arr) {
	    return type === "max" ? Math.max.apply(Math, _toConsumableArray(arr)) : Math.min.apply(Math, _toConsumableArray(arr));
	  };
	
	  var initialValue = type === "max" ? -Infinity : Infinity;
	  var containsDate = false;
	  var result = (0, _flatten2.default)(dataset).reduce(function (memo, datum) {
	    var current0 = datum["_".concat(axis, "0")] !== undefined ? datum["_".concat(axis, "0")] : datum["_".concat(axis)];
	    var current1 = datum["_".concat(axis, "1")] !== undefined ? datum["_".concat(axis, "1")] : datum["_".concat(axis)];
	    var current = getExtreme([current0, current1]);
	    containsDate = containsDate || current0 instanceof Date || current1 instanceof Date;
	    return getExtreme([memo, current]);
	  }, initialValue);
	  return containsDate ? new Date(result) : result;
	} //eslint-disable-next-line max-statements
	
	
	function padDomain(domain, props, axis) {
	  if (!props.domainPadding) {
	    return domain;
	  }
	
	  var minDomain = getMinFromProps(props, axis);
	  var maxDomain = getMaxFromProps(props, axis);
	  var padding = getDomainPadding(props, axis);
	
	  if (!padding.left && !padding.right) {
	    return domain;
	  }
	
	  var min = _collection.default.getMinValue(domain);
	
	  var max = _collection.default.getMaxValue(domain);
	
	  var currentAxis = _helpers.default.getCurrentAxis(axis, props.horizontal);
	
	  var range = _helpers.default.getRange(props, currentAxis);
	
	  var rangeExtent = Math.abs(range[0] - range[1]); // Naive initial padding calculation
	
	  var initialPadding = {
	    left: Math.abs(max - min) * padding.left / rangeExtent,
	    right: Math.abs(max - min) * padding.right / rangeExtent
	  };
	  var singleQuadrantDomainPadding = (0, _isPlainObject2.default)(props.singleQuadrantDomainPadding) ? props.singleQuadrantDomainPadding[axis] : props.singleQuadrantDomainPadding;
	
	  var adjust = function (val, type) {
	    if (singleQuadrantDomainPadding === false) {
	      return val;
	    }
	
	    var coerce = type === "min" && min >= 0 && val <= 0 || type === "max" && max <= 0 && val >= 0;
	    return coerce ? 0 : val;
	  }; // Adjust the domain by the initial padding
	
	
	  var adjustedDomain = {
	    min: adjust(min.valueOf() - initialPadding.left, "min"),
	    max: adjust(max.valueOf() + initialPadding.right, "max")
	  }; // re-calculate padding, taking the adjusted domain into account
	
	  var finalPadding = {
	    left: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.left / rangeExtent,
	    right: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.right / rangeExtent
	  }; // Adjust the domain by the final padding
	
	  var paddedDomain = {
	    min: adjust(min.valueOf() - finalPadding.left, "min"),
	    max: adjust(max.valueOf() + finalPadding.right, "max")
	  }; // default to minDomain / maxDomain if they exist
	
	  var finalDomain = {
	    min: minDomain !== undefined ? minDomain : paddedDomain.min,
	    max: maxDomain !== undefined ? maxDomain : paddedDomain.max
	  };
	  return min instanceof Date || max instanceof Date ? getDomainFromMinMax(new Date(finalDomain.min), new Date(finalDomain.max)) : getDomainFromMinMax(finalDomain.min, finalDomain.max);
	} // Public Methods
	
	/**
	 * Returns a getDomain function
	 * @param {Function} getDomainFromDataFunction: a function that takes props and axis and
	 * returns a domain based on data
	 * @param {Function} formatDomainFunction: a function that takes domain, props, and axis and
	 * returns a formatted domain
	 * @returns {Function} a function that takes props and axis and returns a formatted domain
	 */
	
	
	function createDomainFunction(getDomainFromDataFunction, formatDomainFunction) {
	  getDomainFromDataFunction = (0, _isFunction2.default)(getDomainFromDataFunction) ? getDomainFromDataFunction : getDomainFromData;
	  formatDomainFunction = (0, _isFunction2.default)(formatDomainFunction) ? formatDomainFunction : formatDomain;
	  return function (props, axis) {
	    var propsDomain = getDomainFromProps(props, axis);
	
	    if (propsDomain) {
	      return formatDomainFunction(propsDomain, props, axis);
	    }
	
	    var categories = _data.default.getCategories(props, axis);
	
	    var domain = categories ? getDomainFromCategories(props, axis, categories) : getDomainFromDataFunction(props, axis);
	    return domain ? formatDomainFunction(domain, props, axis) : undefined;
	  };
	}
	/**
	 * Returns a formatted domain.
	 * @param {Array} domain: a domain in the form of a two element array
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Array} a domain in the form of a two element array
	 */
	
	
	function formatDomain(domain, props, axis) {
	  return cleanDomain(padDomain(domain, props, axis), props, axis);
	}
	/**
	 * Returns a domain for a given axis based on props, category, or data
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Array} the domain for the given axis
	 */
	
	
	function getDomain(props, axis) {
	  return createDomainFunction()(props, axis);
	}
	/**
	 * Returns a domain based on categories if they exist
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @param {Array} categories: an array of categories corresponding to a given axis
	 * @returns {Array|undefined} returns a domain from categories or undefined
	 */
	
	
	function getDomainFromCategories(props, axis, categories) {
	  categories = categories || _data.default.getCategories(props, axis);
	  var polar = props.polar,
	      _props$startAngle = props.startAngle,
	      startAngle = _props$startAngle === void 0 ? 0 : _props$startAngle,
	      _props$endAngle = props.endAngle,
	      endAngle = _props$endAngle === void 0 ? 360 : _props$endAngle;
	
	  if (!categories) {
	    return undefined;
	  }
	
	  var minDomain = getMinFromProps(props, axis);
	  var maxDomain = getMaxFromProps(props, axis);
	  var stringArray = _collection.default.containsStrings(categories) ? _data.default.getStringsFromCategories(props, axis) : [];
	  var stringMap = stringArray.length === 0 ? null : stringArray.reduce(function (memo, string, index) {
	    memo[string] = index + 1;
	    return memo;
	  }, {});
	  var categoryValues = stringMap ? categories.map(function (value) {
	    return stringMap[value];
	  }) : categories;
	  var min = minDomain !== undefined ? minDomain : _collection.default.getMinValue(categoryValues);
	  var max = maxDomain !== undefined ? maxDomain : _collection.default.getMaxValue(categoryValues);
	  var categoryDomain = getDomainFromMinMax(min, max);
	  return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(categoryDomain, categoryValues) : categoryDomain;
	}
	/**
	 * Returns a domain from a dataset for a given axis
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @param {Array} dataset: an array of data
	 * @returns {Array} the domain based on data
	 */
	
	
	function getDomainFromData(props, axis, dataset) {
	  dataset = dataset || _data.default.getData(props);
	  var polar = props.polar,
	      _props$startAngle2 = props.startAngle,
	      startAngle = _props$startAngle2 === void 0 ? 0 : _props$startAngle2,
	      _props$endAngle2 = props.endAngle,
	      endAngle = _props$endAngle2 === void 0 ? 360 : _props$endAngle2;
	  var minDomain = getMinFromProps(props, axis);
	  var maxDomain = getMaxFromProps(props, axis);
	
	  if (dataset.length < 1) {
	    return minDomain !== undefined && maxDomain !== undefined ? getDomainFromMinMax(minDomain, maxDomain) : undefined;
	  }
	
	  var min = minDomain !== undefined ? minDomain : getExtremeFromData(dataset, axis, "min");
	  var max = maxDomain !== undefined ? maxDomain : getExtremeFromData(dataset, axis, "max");
	  var domain = getDomainFromMinMax(min, max);
	  return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(domain, getFlatData(dataset, axis)) : domain;
	}
	/**
	 * Returns a domain in the form of a two element array given a min and max value.
	 * @param {Number|Date} min: the props object
	 * @param {Number|Date} max: the current axis
	 * @returns {Array} the minDomain based on props
	 */
	
	
	function getDomainFromMinMax(min, max) {
	  var getSinglePointDomain = function (val) {
	    // d3-scale does not properly resolve very small differences.
	    // eslint-disable-next-line no-magic-numbers
	    var verySmallNumber = val === 0 ? 2 * Math.pow(10, -10) : Math.pow(10, -10);
	    var verySmallDate = 1;
	    var minVal = val instanceof Date ? new Date(+val - verySmallDate) : +val - verySmallNumber;
	    var maxVal = val instanceof Date ? new Date(+val + verySmallDate) : +val + verySmallNumber;
	    return val === 0 ? [0, maxVal] : [minVal, maxVal];
	  };
	
	  return +min === +max ? getSinglePointDomain(max) : [min, max];
	}
	/**
	 * Returns a the domain for a given axis if domain is given in props
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Array|undefined} the domain based on props
	 */
	
	
	function getDomainFromProps(props, axis) {
	  var minDomain = getMinFromProps(props, axis);
	  var maxDomain = getMaxFromProps(props, axis);
	
	  if ((0, _isPlainObject2.default)(props.domain) && props.domain[axis]) {
	    return props.domain[axis];
	  } else if (Array.isArray(props.domain)) {
	    return props.domain;
	  } else if (minDomain !== undefined && maxDomain !== undefined) {
	    return getDomainFromMinMax(minDomain, maxDomain);
	  }
	
	  return undefined;
	}
	/**
	 * Returns a domain for a given axis. This method forces the domain to include
	 * zero unless the domain is explicitly specified in props.
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Array} the domain for the given axis
	 */
	
	
	function getDomainWithZero(props, axis) {
	  var propsDomain = getDomainFromProps(props, axis);
	
	  if (propsDomain) {
	    return propsDomain;
	  }
	
	  var dataset = _data.default.getData(props);
	
	  var y0Min = dataset.reduce(function (min, datum) {
	    return datum._y0 < min ? datum._y0 : min;
	  }, Infinity);
	
	  var ensureZero = function (domain) {
	    if (axis === "x") {
	      return domain;
	    }
	
	    var defaultMin = y0Min !== Infinity ? y0Min : 0;
	    var maxDomainProp = getMaxFromProps(props, axis);
	    var minDomainProp = getMinFromProps(props, axis);
	    var max = maxDomainProp !== undefined ? maxDomainProp : _collection.default.getMaxValue(domain, defaultMin);
	    var min = minDomainProp !== undefined ? minDomainProp : _collection.default.getMinValue(domain, defaultMin);
	    return getDomainFromMinMax(min, max);
	  };
	
	  var getDomainFunction = function () {
	    return getDomainFromData(props, axis, dataset);
	  };
	
	  var formatDomainFunction = function (domain) {
	    return formatDomain(ensureZero(domain), props, axis);
	  };
	
	  return createDomainFunction(getDomainFunction, formatDomainFunction)(props, axis);
	}
	/**
	 * Returns the maxDomain from props if it exists
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Number|undefined} the maxDomain based on props
	 */
	
	
	function getMaxFromProps(props, axis) {
	  if ((0, _isPlainObject2.default)(props.maxDomain) && props.maxDomain[axis] !== undefined) {
	    return props.maxDomain[axis];
	  }
	
	  return typeof props.maxDomain === "number" ? props.maxDomain : undefined;
	}
	/**
	 * Returns the minDomain from props if it exists
	 * @param {Object} props: the props object
	 * @param {String} axis: the current axis
	 * @returns {Number|undefined} the minDomain based on props
	 */
	
	
	function getMinFromProps(props, axis) {
	  if ((0, _isPlainObject2.default)(props.minDomain) && props.minDomain[axis] !== undefined) {
	    return props.minDomain[axis];
	  }
	
	  return typeof props.minDomain === "number" ? props.minDomain : undefined;
	}
	/**
	 * Returns a symmetrically padded domain for polar charts
	 * @param {Array} domain: the original domain
	 * @param {Array} values: a flat array of values corresponding to either tickValues, or data values
	 * for a given dimension i.e. only x values.
	 * @returns {Array} the symmetric domain
	 */
	
	
	function getSymmetricDomain(domain, values) {
	  var processedData = (0, _sortedUniq2.default)(values.sort(function (a, b) {
	    return a - b;
	  }));
	  var step = processedData[1] - processedData[0];
	  return [domain[0], domain[1] + step];
	}
	/**
	 * Checks whether a given component can be used to calculate domain
	 * @param {Component} component: a React component instance
	 * @returns {Boolean} Returns true if the given component has a role included in the whitelist
	 */
	
	
	function isDomainComponent(component) {
	  var getRole = function (child) {
	    return child && child.type ? child.type.role : "";
	  };
	
	  var role = getRole(component);
	
	  if (role === "portal") {
	    var children = _react.default.Children.toArray(component.props.children);
	
	    role = children.length ? getRole(children[0]) : "";
	  }
	
	  var whitelist = ["area", "axis", "bar", "boxplot", "candlestick", "errorbar", "group", "line", "pie", "scatter", "stack", "voronoi"];
	  return (0, _includes2.default)(whitelist, role);
	}
	
	var _default = {
	  createDomainFunction: createDomainFunction,
	  formatDomain: formatDomain,
	  getDomain: getDomain,
	  getDomainFromCategories: getDomainFromCategories,
	  getDomainFromData: getDomainFromData,
	  getDomainFromMinMax: getDomainFromMinMax,
	  getDomainFromProps: getDomainFromProps,
	  getDomainWithZero: getDomainWithZero,
	  getMaxFromProps: getMaxFromProps,
	  getMinFromProps: getMinFromProps,
	  getSymmetricDomain: getSymmetricDomain,
	  isDomainComponent: isDomainComponent
	};
	exports.default = _default;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _includes2 = _interopRequireDefault(__webpack_require__(83));
	
	var _uniq2 = _interopRequireDefault(__webpack_require__(99));
	
	var _pickBy2 = _interopRequireDefault(__webpack_require__(1374));
	
	var _without2 = _interopRequireDefault(__webpack_require__(194));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _assign6 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _default = {
	  /* Returns all own and shared events that should be attached to a single target element,
	   * i.e. an individual bar specified by target: "data", eventKey: [index].
	   * Returned events are scoped to the appropriate state. Either that of the component itself
	   * (i.e. VictoryBar) in the case of own events, or that of the parent component
	   * (i.e. VictoryChart) in the case of shared events
	   */
	  // eslint-disable-next-line max-params
	  getEvents: function (props, target, eventKey, getScopedEvents) {
	    var _this = this;
	
	    // Returns all events that apply to a particular target element
	    var getEventsByTarget = function (events) {
	      var getSelectedEvents = function () {
	        var targetEvents = events.reduce(function (memo, event) {
	          if (event.target !== undefined) {
	            var matchesTarget = Array.isArray(event.target) ? (0, _includes2.default)(event.target, target) : "".concat(event.target) === "".concat(target);
	            return matchesTarget ? memo.concat(event) : memo;
	          }
	
	          return memo.concat(event);
	        }, []);
	
	        if (eventKey !== undefined && target !== "parent") {
	          return targetEvents.filter(function (obj) {
	            var targetKeys = obj.eventKey;
	
	            var useKey = function (key) {
	              return key ? "".concat(key) === "".concat(eventKey) : true;
	            };
	
	            return Array.isArray(targetKeys) ? targetKeys.some(function (k) {
	              return useKey(k);
	            }) : useKey(targetKeys);
	          });
	        }
	
	        return targetEvents;
	      };
	
	      var selectedEvents = getSelectedEvents();
	      return Array.isArray(selectedEvents) && selectedEvents.reduce(function (memo, event) {
	        return event ? (0, _assign6.default)(memo, event.eventHandlers) : memo;
	      }, {});
	    };
	    /* Returns all events from props and defaultEvents from components. Events handlers
	     * specified in props will override handlers for the same event if they are also
	     * specified in defaultEvents of a sub-component
	     */
	
	
	    var getAllEvents = function () {
	      if (Array.isArray(_this.componentEvents)) {
	        var _this$componentEvents;
	
	        return Array.isArray(props.events) ? (_this$componentEvents = _this.componentEvents).concat.apply(_this$componentEvents, _toConsumableArray(props.events)) : _this.componentEvents;
	      }
	
	      return props.events;
	    };
	
	    var allEvents = getAllEvents();
	    var ownEvents = allEvents && (0, _isFunction2.default)(getScopedEvents) ? getScopedEvents(getEventsByTarget(allEvents), target) : undefined;
	
	    if (!props.sharedEvents) {
	      return ownEvents;
	    }
	
	    var getSharedEvents = props.sharedEvents.getEvents;
	    var sharedEvents = props.sharedEvents.events && getSharedEvents(getEventsByTarget(props.sharedEvents.events), target);
	    return (0, _assign6.default)({}, sharedEvents, ownEvents);
	  },
	
	  /* Returns a modified events object where each event handler is replaced by a new
	   * function that calls the original handler and then calls setState with the return
	   * of the original event handler assigned to state property that maps to the target
	   * element.
	   */
	  // eslint-disable-next-line max-params
	  getScopedEvents: function (events, namespace, childType, baseProps) {
	    var _this2 = this;
	
	    if ((0, _isEmpty2.default)(events)) {
	      return {};
	    }
	
	    baseProps = baseProps || this.baseProps; // returns the original base props or base state of a given target element
	
	    var getTargetProps = function (identifier, type) {
	      var childName = identifier.childName,
	          target = identifier.target,
	          key = identifier.key;
	      var baseType = type === "props" ? baseProps : _this2.state || {};
	      var base = childName === undefined || childName === null || !baseType[childName] ? baseType : baseType[childName];
	      return key === "parent" ? base.parent : base[key] && base[key][target];
	    }; // Returns the state object with the mutation caused by a given eventReturn
	    // applied to the appropriate property on the state object
	
	
	    var parseEvent = function (eventReturn, eventKey) {
	      var childNames = namespace === "parent" ? eventReturn.childName : eventReturn.childName || childType;
	      var target = eventReturn.target || namespace; // returns all eventKeys to modify for a targeted childName
	
	      var getKeys = function (childName) {
	        if (target === "parent") {
	          return "parent";
	        }
	
	        if (eventReturn.eventKey === "all") {
	          return baseProps[childName] ? (0, _without2.default)(Object.keys(baseProps[childName]), "parent") : (0, _without2.default)(Object.keys(baseProps), "parent");
	        } else if (eventReturn.eventKey === undefined && eventKey === "parent") {
	          return baseProps[childName] ? Object.keys(baseProps[childName]) : Object.keys(baseProps);
	        }
	
	        return eventReturn.eventKey !== undefined ? eventReturn.eventKey : eventKey;
	      }; // returns the state object with mutated props applied for a single key
	
	
	      var getMutationObject = function (key, childName) {
	        var baseState = _this2.state || {};
	
	        if (!(0, _isFunction2.default)(eventReturn.mutation)) {
	          return baseState;
	        }
	
	        var mutationTargetProps = getTargetProps({
	          childName: childName,
	          key: key,
	          target: target
	        }, "props");
	        var mutationTargetState = getTargetProps({
	          childName: childName,
	          key: key,
	          target: target
	        }, "state");
	        var mutatedProps = eventReturn.mutation((0, _assign6.default)({}, mutationTargetProps, mutationTargetState), baseProps);
	        var childState = baseState[childName] || {};
	
	        var filterState = function (state) {
	          if (state[key] && state[key][target]) {
	            delete state[key][target];
	          }
	
	          if (state[key] && !Object.keys(state[key]).length) {
	            delete state[key];
	          }
	
	          return state;
	        };
	
	        var extendState = function (state) {
	          return target === "parent" ? (0, _assign6.default)(state, _defineProperty({}, key, (0, _assign6.default)(state[key], mutatedProps))) : (0, _assign6.default)(state, _defineProperty({}, key, (0, _assign6.default)(state[key], _defineProperty({}, target, mutatedProps))));
	        };
	
	        var updateState = function (state) {
	          return mutatedProps ? extendState(state) : filterState(state);
	        };
	
	        return childName !== undefined && childName !== null ? (0, _assign6.default)(baseState, _defineProperty({}, childName, updateState(childState))) : updateState(baseState);
	      }; // returns entire mutated state for a given childName
	
	
	      var getReturnByChild = function (childName) {
	        var mutationKeys = getKeys(childName);
	        return Array.isArray(mutationKeys) ? mutationKeys.reduce(function (memo, key) {
	          return (0, _assign6.default)(memo, getMutationObject(key, childName));
	        }, {}) : getMutationObject(mutationKeys, childName);
	      }; // returns an entire mutated state for all children
	
	
	      var allChildNames = childNames === "all" ? (0, _without2.default)(Object.keys(baseProps), "parent") : childNames;
	      return Array.isArray(allChildNames) ? allChildNames.reduce(function (memo, childName) {
	        return (0, _assign6.default)(memo, getReturnByChild(childName));
	      }, {}) : getReturnByChild(allChildNames);
	    }; // Parses an array of event returns into a single state mutation
	
	
	    var parseEventReturn = function (eventReturn, eventKey) {
	      return Array.isArray(eventReturn) ? eventReturn.reduce(function (memo, props) {
	        memo = (0, _assign6.default)({}, memo, parseEvent(props, eventKey));
	        return memo;
	      }, {}) : parseEvent(eventReturn, eventKey);
	    };
	
	    var compileCallbacks = function (eventReturn) {
	      var getCallback = function (obj) {
	        return (0, _isFunction2.default)(obj.callback) && obj.callback;
	      };
	
	      var callbacks = Array.isArray(eventReturn) ? eventReturn.map(function (evtObj) {
	        return getCallback(evtObj);
	      }) : [getCallback(eventReturn)];
	      var callbackArray = callbacks.filter(function (callback) {
	        return callback !== false;
	      });
	      return callbackArray.length ? function () {
	        return callbackArray.forEach(function (callback) {
	          return callback();
	        });
	      } : undefined;
	    }; // A function that calls a particular event handler, parses its return
	    // into a state mutation, and calls setState
	    // eslint-disable-next-line max-params
	
	
	    var onEvent = function (evt, childProps, eventKey, eventName) {
	      var eventReturn = events[eventName](evt, childProps, eventKey, _this2);
	
	      if (eventReturn) {
	        var callbacks = compileCallbacks(eventReturn);
	
	        _this2.setState(parseEventReturn(eventReturn, eventKey), callbacks);
	      }
	    }; // returns a new events object with enhanced event handlers
	
	
	    return Object.keys(events).reduce(function (memo, event) {
	      memo[event] = onEvent;
	      return memo;
	    }, {});
	  },
	
	  /* Returns a partially applied event handler for a specific target element
	   * This allows event handlers to have access to props controlling each element
	   */
	  getPartialEvents: function (events, eventKey, childProps) {
	    return events ? Object.keys(events).reduce(function (memo, eventName) {
	      var appliedEvent = function (evt) {
	        return events[eventName](evt, childProps, eventKey, eventName);
	      };
	
	      memo[eventName] = appliedEvent;
	      return memo;
	    }, {}) : {};
	  },
	
	  /* Returns the property of the state object corresponding to event changes for
	   * a particular element
	   */
	  getEventState: function (eventKey, namespace, childType) {
	    var state = this.state || {};
	
	    if (!childType) {
	      return eventKey === "parent" ? state[eventKey] && state[eventKey][namespace] || state[eventKey] : state[eventKey] && state[eventKey][namespace];
	    }
	
	    return state[childType] && state[childType][eventKey] && state[childType][eventKey][namespace];
	  },
	
	  /**
	   * Returns a set of all mutations for shared events
	   *
	   * @param  {Array} mutations an array of mutations objects
	   * @param  {Object} baseProps an object that describes all props for children of VictorySharedEvents
	   * @param  {Object} baseState an object that describes state for children of VictorySharedEvents
	   * @param  {Array} childNames an array of childNames
	   *
	   * @return {Object} a object describing all mutations for VictorySharedEvents
	   */
	  // eslint-disable-next-line max-params
	  getExternalMutationsWithChildren: function (mutations, baseProps, baseState, childNames) {
	    var _this3 = this;
	
	    baseProps = baseProps || {};
	    baseState = baseState || {};
	    return childNames.reduce(function (memo, childName) {
	      var childState = baseState[childName];
	
	      var mutation = _this3.getExternalMutations(mutations, baseProps[childName], baseState[childName], childName);
	
	      memo[childName] = mutation ? mutation : childState;
	      return (0, _pickBy2.default)(memo, function (v) {
	        return !(0, _isEmpty2.default)(v);
	      });
	    }, {});
	  },
	
	  /**
	   * Returns a set of all mutations for a component
	   *
	   * @param  {Array} mutations an array of mutations objects
	   * @param  {Object} baseProps a props object (scoped to a childName when used by shared events)
	   * @param  {Object} baseState a state object (scoped to a childName when used by shared events)
	   * @param  {String} childName an optional childName
	   *
	   * @return {Object} a object describing mutations for a given component
	   */
	  // eslint-disable-next-line max-params
	  getExternalMutations: function (mutations, baseProps, baseState, childName) {
	    var _this4 = this;
	
	    baseProps = baseProps || {};
	    baseState = baseState || {};
	    var eventKeys = Object.keys(baseProps);
	    return eventKeys.reduce(function (memo, eventKey) {
	      var keyState = baseState[eventKey] || {};
	      var keyProps = baseProps[eventKey] || {};
	
	      if (eventKey === "parent") {
	        var identifier = {
	          eventKey: eventKey,
	          target: "parent"
	        };
	
	        var mutation = _this4.getExternalMutation(mutations, keyProps, keyState, identifier);
	
	        memo[eventKey] = mutation !== undefined ? (0, _assign6.default)({}, keyState, mutation) : keyState;
	      } else {
	        // use keys from both state and props so that elements not intially included in baseProps
	        // will be used. (i.e. labels)
	        var targets = (0, _uniq2.default)(Object.keys(keyProps).concat(Object.keys(keyState)));
	        memo[eventKey] = targets.reduce(function (m, target) {
	          var identifier = {
	            eventKey: eventKey,
	            target: target,
	            childName: childName
	          };
	
	          var mutation = _this4.getExternalMutation(mutations, keyProps[target], keyState[target], identifier);
	
	          m[target] = mutation !== undefined ? (0, _assign6.default)({}, keyState[target], mutation) : keyState[target];
	          return (0, _pickBy2.default)(m, function (v) {
	            return !(0, _isEmpty2.default)(v);
	          });
	        }, {});
	      }
	
	      return (0, _pickBy2.default)(memo, function (v) {
	        return !(0, _isEmpty2.default)(v);
	      });
	    }, {});
	  },
	
	  /**
	   * Returns a set of mutations for a particular element given scoped baseProps and baseState
	   *
	   * @param  {Array} mutations an array of mutations objects
	   * @param  {Object} baseProps a props object (scoped the element specified by the identifier)
	   * @param  {Object} baseState a state object (scoped the element specified by the identifier)
	   * @param  {Object} identifier { eventKey, target, childName }
	   *
	   * @return {Object | undefined} a object describing mutations for a given element, or undefined
	   */
	  // eslint-disable-next-line max-params
	  getExternalMutation: function (mutations, baseProps, baseState, identifier) {
	    var filterMutations = function (mutation, type) {
	      if (typeof mutation[type] === "string") {
	        return mutation[type] === "all" || mutation[type] === identifier[type];
	      } else if (Array.isArray(mutation[type])) {
	        // coerce arrays to strings before matching
	        var stringArray = mutation[type].map(function (m) {
	          return "".concat(m);
	        });
	        return (0, _includes2.default)(stringArray, identifier[type]);
	      } else {
	        return false;
	      }
	    };
	
	    mutations = Array.isArray(mutations) ? mutations : [mutations];
	    var scopedMutations = mutations;
	
	    if (identifier.childName) {
	      scopedMutations = mutations.filter(function (m) {
	        return filterMutations(m, "childName");
	      });
	    } // find any mutation objects that match the target
	
	
	    var targetMutations = scopedMutations.filter(function (m) {
	      return filterMutations(m, "target");
	    });
	
	    if ((0, _isEmpty2.default)(targetMutations)) {
	      return undefined;
	    }
	
	    var keyMutations = targetMutations.filter(function (m) {
	      return filterMutations(m, "eventKey");
	    });
	
	    if ((0, _isEmpty2.default)(keyMutations)) {
	      return undefined;
	    }
	
	    return keyMutations.reduce(function (memo, curr) {
	      var mutationFunction = curr && (0, _isFunction2.default)(curr.mutation) ? curr.mutation : function () {
	        return undefined;
	      };
	      var currentMutation = mutationFunction((0, _assign6.default)({}, baseProps, baseState));
	      return (0, _assign6.default)({}, memo, currentMutation);
	    }, {});
	  },
	
	  /* Returns an array of defaultEvents from sub-components of a given component.
	   * i.e. any static `defaultEvents` on `labelComponent` will be returned
	   */
	  getComponentEvents: function (props, components) {
	    var events = Array.isArray(components) && components.reduce(function (memo, componentName) {
	      var _memo;
	
	      var component = props[componentName];
	      var defaultEvents = component && component.type && component.type.defaultEvents;
	      var componentEvents = (0, _isFunction2.default)(defaultEvents) ? defaultEvents(component.props) : defaultEvents;
	      memo = Array.isArray(componentEvents) ? (_memo = memo).concat.apply(_memo, _toConsumableArray(componentEvents)) : memo;
	      return memo;
	    }, []);
	    return events && events.length ? events : undefined;
	  }
	};
	exports.default = _default;

/***/ },
/* 303 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Given an object with CSS/SVG transform definitions, return the string value
	 * for use with the `transform` CSS property or SVG attribute. Note that we
	 * can't always guarantee the order will match the author's intended order, so
	 * authors should only use the object notation if they know that their transform
	 * is commutative or that there is only one.
	 * @param {Object} obj An object of transform definitions.
	 * @returns {String} The generated transform string.
	 */
	var toTransformString = function (obj) {
	  for (var _len = arguments.length, more = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  if (more.length > 0) {
	    return more.reduce(function (memo, currentObj) {
	      return [memo, toTransformString(currentObj)].join(" ");
	    }, toTransformString(obj)).trim();
	  } else {
	    if (obj === undefined || obj === null || typeof obj === "string") {
	      return obj;
	    }
	
	    var transforms = [];
	
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        var value = obj[key];
	        transforms.push("".concat(key, "(").concat(value, ")"));
	      }
	    }
	
	    return transforms.join(" ").trim();
	  }
	};
	
	var _default = {
	  toTransformString: toTransformString,
	
	  /**
	   * Given the name of a color scale, getColorScale will return an array
	   * of 5 hex string values in that color scale. If no 'name' parameter
	   * is given, it will return the Victory default grayscale.
	   * @param {String} name The name of the color scale to return (optional).
	   * @returns {Array} An array of 5 hex string values composing a color scale.
	   */
	  getColorScale: function (name) {
	    var scales = {
	      grayscale: ["#cccccc", "#969696", "#636363", "#252525"],
	      qualitative: ["#334D5C", "#45B29D", "#EFC94C", "#E27A3F", "#DF5A49", "#4F7DA1", "#55DBC1", "#EFDA97", "#E2A37F", "#DF948A"],
	      heatmap: ["#428517", "#77D200", "#D6D305", "#EC8E19", "#C92B05"],
	      warm: ["#940031", "#C43343", "#DC5429", "#FF821D", "#FFAF55"],
	      cool: ["#2746B9", "#0B69D4", "#2794DB", "#31BB76", "#60E83B"],
	      red: ["#FCAE91", "#FB6A4A", "#DE2D26", "#A50F15", "#750B0E"],
	      blue: ["#002C61", "#004B8F", "#006BC9", "#3795E5", "#65B4F4"],
	      green: ["#354722", "#466631", "#649146", "#8AB25C", "#A9C97E"]
	    };
	    return name ? scales[name] : scales.grayscale;
	  }
	};
	exports.default = _default;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _identity2 = _interopRequireDefault(__webpack_require__(76));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDatumKey(datum, idx) {
	  return (datum.key || idx).toString();
	}
	
	function getKeyedData(data) {
	  return data.reduce(function (keyedData, datum, idx) {
	    var key = getDatumKey(datum, idx);
	    keyedData[key] = datum;
	    return keyedData;
	  }, {});
	}
	
	function getKeyedDataDifference(a, b) {
	  var hasDifference = false;
	  var difference = Object.keys(a).reduce(function (_difference, key) {
	    if (!(key in b)) {
	      hasDifference = true;
	      _difference[key] = true;
	    }
	
	    return _difference;
	  }, {});
	  return hasDifference && difference;
	}
	/**
	 * Calculate which data-points exist in oldData and not nextData -
	 * these are the `exiting` data-points.  Also calculate which
	 * data-points exist in nextData and not oldData - these are the
	 * `entering` data-points.
	 *
	 * @param  {Array} oldData   this.props.data Array
	 * @param  {Array} nextData  this.props.data Array
	 *
	 * @return {Object}          Object with `entering` and `exiting` properties.
	 *                           entering[datum.key] will be true if the data is
	 *                           entering, and similarly for `exiting`.
	 */
	
	
	function getNodeTransitions(oldData, nextData) {
	  var oldDataKeyed = oldData && getKeyedData(oldData);
	  var nextDataKeyed = nextData && getKeyedData(nextData);
	  return {
	    entering: oldDataKeyed && getKeyedDataDifference(nextDataKeyed, oldDataKeyed),
	    exiting: nextDataKeyed && getKeyedDataDifference(oldDataKeyed, nextDataKeyed)
	  };
	}
	
	function getChildData(child) {
	  if (child.type && child.type.getData) {
	    return child.type.getData(child.props);
	  }
	
	  return child.props && child.props.data || false;
	}
	/**
	 * If a parent component has animation enabled, calculate the transitions
	 * for any data of any child component that supports data transitions
	 * Data transitions are defined as any two datasets where data nodes exist
	 * in the first set and not the second, in the second and not the first,
	 * or both.
	 *
	 * @param  {Children}  oldChildren   this.props.children from old props
	 * @param  {Children}  nextChildren  this.props.children from next props
	 *
	 * @return {Object}                  Object with the following properties:
	 *                                    - nodesWillExit
	 *                                    - nodesWillEnter
	 *                                    - childrenTransitions
	 *                                    - nodesShouldEnter
	 */
	
	
	function getInitialTransitionState(oldChildren, nextChildren) {
	  var nodesWillExit = false;
	  var nodesWillEnter = false;
	
	  var getTransition = function (oldChild, newChild) {
	    if (!newChild || oldChild.type !== newChild.type) {
	      return {};
	    }
	
	    var _ref = getNodeTransitions(getChildData(oldChild), getChildData(newChild)) || {},
	        entering = _ref.entering,
	        exiting = _ref.exiting;
	
	    nodesWillExit = nodesWillExit || !!exiting;
	    nodesWillEnter = nodesWillEnter || !!entering;
	    return {
	      entering: entering || false,
	      exiting: exiting || false
	    };
	  };
	
	  var getTransitionsFromChildren = function (old, next) {
	    return old.map(function (child, idx) {
	      if (child && child.props && child.props.children && next[idx]) {
	        return getTransitionsFromChildren(_react.default.Children.toArray(old[idx].props.children), _react.default.Children.toArray(next[idx].props.children));
	      } // get Transition entering and exiting nodes
	
	
	      return getTransition(child, next[idx]);
	    });
	  };
	
	  var childrenTransitions = getTransitionsFromChildren(_react.default.Children.toArray(oldChildren), _react.default.Children.toArray(nextChildren));
	  return {
	    nodesWillExit: nodesWillExit,
	    nodesWillEnter: nodesWillEnter,
	    childrenTransitions: childrenTransitions,
	    // TODO: This may need to be refactored for the following situation.
	    //       The component receives new props, and the data provided
	    //       is a perfect match for the previous data and domain except
	    //       for new nodes. In this case, we wouldn't want a delay before
	    //       the new nodes appear.
	    nodesShouldEnter: false
	  };
	}
	
	function getInitialChildProps(animate, data) {
	  var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : _identity2.default;
	  return {
	    data: data.map(function (datum, idx) {
	      return (0, _assign2.default)({}, datum, after(datum, idx, data));
	    })
	  };
	} // eslint-disable-next-line max-params
	
	
	function getChildBeforeLoad(animate, child, data, cb) {
	  animate = (0, _assign2.default)({}, animate, {
	    onEnd: cb
	  });
	
	  if (animate && animate.onLoad && !animate.onLoad.duration) {
	    return {
	      animate: animate,
	      data: data
	    };
	  }
	
	  var before = animate.onLoad && animate.onLoad.before ? animate.onLoad.before : _identity2.default; // If nodes need to exit, transform them with the provided onLoad.before function.
	
	  data = data.map(function (datum, idx) {
	    return (0, _assign2.default)({}, datum, before(datum, idx, data));
	  });
	  return {
	    animate: animate,
	    data: data,
	    clipWidth: 0
	  };
	} // eslint-disable-next-line max-params
	
	
	function getChildOnLoad(animate, data, cb) {
	  animate = (0, _assign2.default)({}, animate, {
	    onEnd: cb
	  });
	
	  if (animate && animate.onLoad && !animate.onLoad.duration) {
	    return {
	      animate: animate,
	      data: data
	    };
	  }
	
	  var after = animate.onLoad && animate.onLoad.after ? animate.onLoad.after : _identity2.default; // If nodes need to exit, transform them with the provided onLoad.after function.
	
	  data = data.map(function (datum, idx) {
	    return (0, _assign2.default)({}, datum, after(datum, idx, data));
	  });
	  return {
	    animate: animate,
	    data: data
	  };
	} // eslint-disable-next-line max-params, max-len
	
	
	function getChildPropsOnExit(animate, child, data, exitingNodes, cb) {
	  // Whether or not _this_ child has exiting nodes, we want the exit-
	  // transition for all children to have the same duration, delay, etc.
	  var onExit = animate && animate.onExit;
	  animate = (0, _assign2.default)({}, animate, onExit);
	
	  if (exitingNodes) {
	    // After the exit transition occurs, trigger the animations for
	    // nodes that are neither exiting or entering.
	    animate.onEnd = cb;
	    var before = animate.onExit && animate.onExit.before ? animate.onExit.before : _identity2.default; // If nodes need to exit, transform them with the provided onExit.before function.
	
	    data = data.map(function (datum, idx) {
	      var key = (datum.key || idx).toString();
	      return exitingNodes[key] ? (0, _assign2.default)({}, datum, before(datum, idx, data)) : datum;
	    });
	  }
	
	  return {
	    animate: animate,
	    data: data
	  };
	} // eslint-disable-next-line max-params,max-len
	
	
	function getChildPropsBeforeEnter(animate, child, data, enteringNodes, cb) {
	  if (enteringNodes) {
	    // Perform a normal animation here, except - when it finishes - trigger
	    // the transition for entering nodes.
	    animate = (0, _assign2.default)({}, animate, {
	      onEnd: cb
	    });
	    var before = animate.onEnter && animate.onEnter.before ? animate.onEnter.before : _identity2.default; // We want the entering nodes to be included in the transition target
	    // domain.  However, we may not want these nodes to be displayed initially,
	    // so perform the `onEnter.before` transformation on each node.
	
	    data = data.map(function (datum, idx) {
	      var key = (datum.key || idx).toString();
	      return enteringNodes[key] ? (0, _assign2.default)({}, datum, before(datum, idx, data)) : datum;
	    });
	  }
	
	  return {
	    animate: animate,
	    data: data
	  };
	} // eslint-disable-next-line max-params, max-len
	
	
	function getChildPropsOnEnter(animate, data, enteringNodes, cb) {
	  // Whether or not _this_ child has entering nodes, we want the entering-
	  // transition for all children to have the same duration, delay, etc.
	  var onEnter = animate && animate.onEnter;
	  animate = (0, _assign2.default)({}, animate, onEnter);
	
	  if (enteringNodes) {
	    // Old nodes have been transitioned to their new values, and the
	    // domain should encompass the nodes that will now enter. So perform
	    // the `onEnter.after` transformation on each node.
	    animate.onEnd = cb;
	    var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : _identity2.default;
	    data = data.map(function (datum, idx) {
	      var key = getDatumKey(datum, idx);
	      return enteringNodes[key] ? (0, _assign2.default)({}, datum, after(datum, idx, data)) : datum;
	    });
	  }
	
	  return {
	    animate: animate,
	    data: data
	  };
	}
	/**
	 * getTransitionPropsFactory - putting the Java in JavaScript.  This will return a
	 * function that returns prop transformations for a child, given that child's props
	 * and its index in the parent's children array.
	 *
	 * In particular, this will include an `animate` object that is set appropriately
	 * so that each child will be synchoronized for each stage of a transition
	 * animation.  It will also include a transformed `data` object, where each datum
	 * is transformed by `animate.onExit` and `animate.onEnter` `before` and `after`
	 * functions.
	 *
	 * @param  {Object}  props       `this.props` for the parent component.
	 * @param  {Object} state        `this.state` for the parent component.
	 * @param  {Function} setState    Function that, when called, will `this.setState` on
	 *                                 the parent component with the provided object.
	 *
	 * @return {Function}              Child-prop transformation function.
	 */
	
	
	function getTransitionPropsFactory(props, state, setState) {
	  var nodesWillExit = state && state.nodesWillExit;
	  var nodesWillEnter = state && state.nodesWillEnter;
	  var nodesShouldEnter = state && state.nodesShouldEnter;
	  var nodesShouldLoad = state && state.nodesShouldLoad;
	  var nodesDoneLoad = state && state.nodesDoneLoad;
	  var childrenTransitions = state && state.childrenTransitions || [];
	  var transitionDurations = {
	    enter: props.animate && props.animate.onEnter && props.animate.onEnter.duration,
	    exit: props.animate && props.animate.onExit && props.animate.onExit.duration,
	    load: props.animate && props.animate.onLoad && props.animate.onLoad.duration,
	    move: props.animate && props.animate.duration
	  };
	
	  var onLoad = function (child, data, animate) {
	    if (nodesShouldLoad) {
	      return getChildOnLoad(animate, data, function () {
	        setState({
	          nodesShouldLoad: false,
	          nodesDoneLoad: true
	        });
	      });
	    }
	
	    return getChildBeforeLoad(animate, child, data, function () {
	      setState({
	        nodesDoneLoad: true
	      });
	    });
	  }; // eslint-disable-next-line max-params
	
	
	  var onExit = function (nodes, child, data, animate) {
	    return getChildPropsOnExit(animate, child, data, nodes, function () {
	      setState({
	        nodesWillExit: false
	      });
	    });
	  }; // eslint-disable-next-line max-params
	
	
	  var onEnter = function (nodes, child, data, animate) {
	    if (nodesShouldEnter) {
	      return getChildPropsOnEnter(animate, data, nodes, function () {
	        setState({
	          nodesWillEnter: false
	        });
	      });
	    }
	
	    return getChildPropsBeforeEnter(animate, child, data, nodes, function () {
	      setState({
	        nodesShouldEnter: true
	      });
	    });
	  };
	
	  var getChildTransitionDuration = function (child, type) {
	    var animate = child.props.animate;
	
	    if (!child.type) {
	      return {};
	    }
	
	    var defaultTransitions = child.props && child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
	
	    if (defaultTransitions) {
	      var animationDuration = animate[type] && animate[type].duration;
	      return animationDuration !== undefined ? animationDuration : defaultTransitions[type] && defaultTransitions[type].duration;
	    } else {
	      return {};
	    }
	  }; // eslint-disable-next-line max-statements, complexity, max-len
	
	
	  return function getTransitionProps(child, index) {
	    var data = getChildData(child) || [];
	    var animate = (0, _defaults2.default)({}, props.animate, child.props.animate);
	    var defaultTransitions = child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
	    animate.onExit = (0, _defaults2.default)({}, animate.onExit, defaultTransitions && defaultTransitions.onExit);
	    animate.onEnter = (0, _defaults2.default)({}, animate.onEnter, defaultTransitions && defaultTransitions.onEnter);
	    animate.onLoad = (0, _defaults2.default)({}, animate.onLoad, defaultTransitions && defaultTransitions.onLoad);
	    var childTransitions = childrenTransitions[index] || childrenTransitions[0];
	
	    if (!nodesDoneLoad) {
	      // should do onLoad animation
	      var load = transitionDurations.load !== undefined ? transitionDurations.load : getChildTransitionDuration(child, "onLoad");
	      var animation = {
	        duration: load
	      };
	      return onLoad(child, data, (0, _assign2.default)({}, animate, animation));
	    } else if (nodesWillExit) {
	      var exitingNodes = childTransitions && childTransitions.exiting;
	      var exit = transitionDurations.exit !== undefined ? transitionDurations.exit : getChildTransitionDuration(child, "onExit"); // if nodesWillExit, but this child has no exiting nodes, set a delay instead of a duration
	
	      var _animation = exitingNodes ? {
	        duration: exit
	      } : {
	        delay: exit
	      };
	
	      return onExit(exitingNodes, child, data, (0, _assign2.default)({}, animate, _animation));
	    } else if (nodesWillEnter) {
	      var enteringNodes = childTransitions && childTransitions.entering;
	      var enter = transitionDurations.enter !== undefined ? transitionDurations.enter : getChildTransitionDuration(child, "onEnter");
	      var move = transitionDurations.move !== undefined ? transitionDurations.move : child.props.animate && child.props.animate.duration;
	      var _animation2 = {
	        duration: nodesShouldEnter && enteringNodes ? enter : move
	      };
	      return onEnter(enteringNodes, child, data, (0, _assign2.default)({}, animate, _animation2));
	    } else if (!state && animate && animate.onExit) {
	      // This is the initial render, and nodes may enter when props change. Because
	      // animation interpolation is determined by old- and next- props, data may need
	      // to be augmented with certain properties.
	      //
	      // For example, it may be desired that exiting nodes go from `opacity: 1` to
	      // `opacity: 0`. Without setting this on a per-datum basis, the interpolation
	      // might go from `opacity: undefined` to `opacity: 0`, which would result in
	      // interpolated `opacity: NaN` values.
	      //
	      return getInitialChildProps(animate, data);
	    }
	
	    return {
	      animate: animate,
	      data: data
	    };
	  };
	}
	
	var _default = {
	  getInitialTransitionState: getInitialTransitionState,
	  getTransitionPropsFactory: getTransitionPropsFactory
	};
	exports.default = _default;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Border", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Border;
	  }
	});
	Object.defineProperty(exports, "Box", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Box;
	  }
	});
	Object.defineProperty(exports, "ClipPath", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.ClipPath;
	  }
	});
	Object.defineProperty(exports, "LineSegment", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.LineSegment;
	  }
	});
	Object.defineProperty(exports, "Whisker", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Whisker;
	  }
	});
	Object.defineProperty(exports, "Circle", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Circle;
	  }
	});
	Object.defineProperty(exports, "Rect", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Rect;
	  }
	});
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Line;
	  }
	});
	Object.defineProperty(exports, "Path", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Path;
	  }
	});
	Object.defineProperty(exports, "TSpan", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.TSpan;
	  }
	});
	Object.defineProperty(exports, "Text", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Text;
	  }
	});
	Object.defineProperty(exports, "Point", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Point;
	  }
	});
	Object.defineProperty(exports, "VictoryAnimation", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.VictoryAnimation;
	  }
	});
	Object.defineProperty(exports, "VictoryContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.VictoryContainer;
	  }
	});
	Object.defineProperty(exports, "VictoryLabel", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.VictoryLabel;
	  }
	});
	Object.defineProperty(exports, "VictoryTheme", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.VictoryTheme;
	  }
	});
	Object.defineProperty(exports, "VictoryTransition", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.VictoryTransition;
	  }
	});
	Object.defineProperty(exports, "VictoryPortal", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.VictoryPortal;
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Portal;
	  }
	});
	Object.defineProperty(exports, "VictoryClipContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.VictoryClipContainer;
	  }
	});
	Object.defineProperty(exports, "addEvents", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.addEvents;
	  }
	});
	Object.defineProperty(exports, "Collection", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Collection;
	  }
	});
	Object.defineProperty(exports, "Data", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Data;
	  }
	});
	Object.defineProperty(exports, "DefaultTransitions", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.DefaultTransitions;
	  }
	});
	Object.defineProperty(exports, "Domain", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Domain;
	  }
	});
	Object.defineProperty(exports, "Events", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Events;
	  }
	});
	Object.defineProperty(exports, "Helpers", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Helpers;
	  }
	});
	Object.defineProperty(exports, "Log", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Log;
	  }
	});
	Object.defineProperty(exports, "PropTypes", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.PropTypes;
	  }
	});
	Object.defineProperty(exports, "Scale", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Scale;
	  }
	});
	Object.defineProperty(exports, "Style", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Style;
	  }
	});
	Object.defineProperty(exports, "TextSize", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.TextSize;
	  }
	});
	Object.defineProperty(exports, "Transitions", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Transitions;
	  }
	});
	Object.defineProperty(exports, "Selection", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Selection;
	  }
	});
	Object.defineProperty(exports, "LabelHelpers", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.LabelHelpers;
	  }
	});
	Object.defineProperty(exports, "Axis", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Axis;
	  }
	});
	Object.defineProperty(exports, "Wrapper", {
	  enumerable: true,
	  get: function () {
	    return _victoryCore.Wrapper;
	  }
	});
	Object.defineProperty(exports, "VictoryChart", {
	  enumerable: true,
	  get: function () {
	    return _victoryChart.VictoryChart;
	  }
	});
	Object.defineProperty(exports, "VictoryGroup", {
	  enumerable: true,
	  get: function () {
	    return _victoryGroup.VictoryGroup;
	  }
	});
	Object.defineProperty(exports, "VictoryStack", {
	  enumerable: true,
	  get: function () {
	    return _victoryStack.VictoryStack;
	  }
	});
	Object.defineProperty(exports, "VictoryPie", {
	  enumerable: true,
	  get: function () {
	    return _victoryPie.VictoryPie;
	  }
	});
	Object.defineProperty(exports, "Slice", {
	  enumerable: true,
	  get: function () {
	    return _victoryPie.Slice;
	  }
	});
	Object.defineProperty(exports, "VictoryArea", {
	  enumerable: true,
	  get: function () {
	    return _victoryArea.VictoryArea;
	  }
	});
	Object.defineProperty(exports, "Area", {
	  enumerable: true,
	  get: function () {
	    return _victoryArea.Area;
	  }
	});
	Object.defineProperty(exports, "VictoryBar", {
	  enumerable: true,
	  get: function () {
	    return _victoryBar.VictoryBar;
	  }
	});
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function () {
	    return _victoryBar.Bar;
	  }
	});
	Object.defineProperty(exports, "VictoryCandlestick", {
	  enumerable: true,
	  get: function () {
	    return _victoryCandlestick.VictoryCandlestick;
	  }
	});
	Object.defineProperty(exports, "Candle", {
	  enumerable: true,
	  get: function () {
	    return _victoryCandlestick.Candle;
	  }
	});
	Object.defineProperty(exports, "VictoryErrorBar", {
	  enumerable: true,
	  get: function () {
	    return _victoryErrorbar.VictoryErrorBar;
	  }
	});
	Object.defineProperty(exports, "ErrorBar", {
	  enumerable: true,
	  get: function () {
	    return _victoryErrorbar.ErrorBar;
	  }
	});
	Object.defineProperty(exports, "VictoryLine", {
	  enumerable: true,
	  get: function () {
	    return _victoryLine.VictoryLine;
	  }
	});
	Object.defineProperty(exports, "Curve", {
	  enumerable: true,
	  get: function () {
	    return _victoryLine.Curve;
	  }
	});
	Object.defineProperty(exports, "VictoryScatter", {
	  enumerable: true,
	  get: function () {
	    return _victoryScatter.VictoryScatter;
	  }
	});
	Object.defineProperty(exports, "VictoryBoxPlot", {
	  enumerable: true,
	  get: function () {
	    return _victoryBoxPlot.VictoryBoxPlot;
	  }
	});
	Object.defineProperty(exports, "VictoryVoronoi", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoi.VictoryVoronoi;
	  }
	});
	Object.defineProperty(exports, "Voronoi", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoi.Voronoi;
	  }
	});
	Object.defineProperty(exports, "VictoryBrushLine", {
	  enumerable: true,
	  get: function () {
	    return _victoryBrushLine.VictoryBrushLine;
	  }
	});
	Object.defineProperty(exports, "VictoryBrushContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryBrushContainer.VictoryBrushContainer;
	  }
	});
	Object.defineProperty(exports, "BrushHelpers", {
	  enumerable: true,
	  get: function () {
	    return _victoryBrushContainer.BrushHelpers;
	  }
	});
	Object.defineProperty(exports, "brushContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryBrushContainer.brushContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryCursorContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryCursorContainer.VictoryCursorContainer;
	  }
	});
	Object.defineProperty(exports, "CursorHelpers", {
	  enumerable: true,
	  get: function () {
	    return _victoryCursorContainer.CursorHelpers;
	  }
	});
	Object.defineProperty(exports, "cursorContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryCursorContainer.cursorContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictorySelectionContainer", {
	  enumerable: true,
	  get: function () {
	    return _victorySelectionContainer.VictorySelectionContainer;
	  }
	});
	Object.defineProperty(exports, "SelectionHelpers", {
	  enumerable: true,
	  get: function () {
	    return _victorySelectionContainer.SelectionHelpers;
	  }
	});
	Object.defineProperty(exports, "selectionContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victorySelectionContainer.selectionContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryVoronoiContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoiContainer.VictoryVoronoiContainer;
	  }
	});
	Object.defineProperty(exports, "VoronoiHelpers", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoiContainer.VoronoiHelpers;
	  }
	});
	Object.defineProperty(exports, "voronoiContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoiContainer.voronoiContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryZoomContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryZoomContainer.VictoryZoomContainer;
	  }
	});
	Object.defineProperty(exports, "ZoomHelpers", {
	  enumerable: true,
	  get: function () {
	    return _victoryZoomContainer.ZoomHelpers;
	  }
	});
	Object.defineProperty(exports, "zoomContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryZoomContainer.zoomContainerMixin;
	  }
	});
	Object.defineProperty(exports, "RawZoomHelpers", {
	  enumerable: true,
	  get: function () {
	    return _victoryZoomContainer.RawZoomHelpers;
	  }
	});
	Object.defineProperty(exports, "combineContainerMixins", {
	  enumerable: true,
	  get: function () {
	    return _victoryCreateContainer.combineContainerMixins;
	  }
	});
	Object.defineProperty(exports, "makeCreateContainerFunction", {
	  enumerable: true,
	  get: function () {
	    return _victoryCreateContainer.makeCreateContainerFunction;
	  }
	});
	Object.defineProperty(exports, "createContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryCreateContainer.createContainer;
	  }
	});
	Object.defineProperty(exports, "VictoryTooltip", {
	  enumerable: true,
	  get: function () {
	    return _victoryTooltip.VictoryTooltip;
	  }
	});
	Object.defineProperty(exports, "Flyout", {
	  enumerable: true,
	  get: function () {
	    return _victoryTooltip.Flyout;
	  }
	});
	Object.defineProperty(exports, "VictoryLegend", {
	  enumerable: true,
	  get: function () {
	    return _victoryLegend.VictoryLegend;
	  }
	});
	Object.defineProperty(exports, "VictorySharedEvents", {
	  enumerable: true,
	  get: function () {
	    return _victorySharedEvents.VictorySharedEvents;
	  }
	});
	Object.defineProperty(exports, "VictoryAxis", {
	  enumerable: true,
	  get: function () {
	    return _victoryAxis.VictoryAxis;
	  }
	});
	Object.defineProperty(exports, "VictoryPolarAxis", {
	  enumerable: true,
	  get: function () {
	    return _victoryPolarAxis.VictoryPolarAxis;
	  }
	});
	
	var _victoryCore = __webpack_require__(19);
	
	var _victoryChart = __webpack_require__(1857);
	
	var _victoryGroup = __webpack_require__(1884);
	
	var _victoryStack = __webpack_require__(1903);
	
	var _victoryPie = __webpack_require__(1893);
	
	var _victoryArea = __webpack_require__(1839);
	
	var _victoryBar = __webpack_require__(1845);
	
	var _victoryCandlestick = __webpack_require__(1854);
	
	var _victoryErrorbar = __webpack_require__(1881);
	
	var _victoryLine = __webpack_require__(1890);
	
	var _victoryScatter = __webpack_require__(1898);
	
	var _victoryBoxPlot = __webpack_require__(1848);
	
	var _victoryVoronoi = __webpack_require__(1908);
	
	var _victoryBrushLine = __webpack_require__(1851);
	
	var _victoryBrushContainer = __webpack_require__(668);
	
	var _victoryCursorContainer = __webpack_require__(682);
	
	var _victorySelectionContainer = __webpack_require__(687);
	
	var _victoryVoronoiContainer = __webpack_require__(691);
	
	var _victoryZoomContainer = __webpack_require__(694);
	
	var _victoryCreateContainer = __webpack_require__(1878);
	
	var _victoryTooltip = __webpack_require__(690);
	
	var _victoryLegend = __webpack_require__(1887);
	
	var _victorySharedEvents = __webpack_require__(215);
	
	var _victoryAxis = __webpack_require__(664);
	
	var _victoryPolarAxis = __webpack_require__(686);

/***/ },
/* 306 */
/***/ function(module, exports) {

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	
	  return arr2;
	}
	
	module.exports = _arrayLikeToArray;

/***/ },
/* 307 */
/***/ function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	module.exports = _arrayWithHoles;

/***/ },
/* 308 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 309 */
/***/ function(module, exports) {

	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ },
/* 310 */
/***/ function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	module.exports = _nonIterableRest;

/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * IE11-safe version of getCanonicalLocales since it's ES2016
	 * @param locales locales
	 */
	function getCanonicalLocales(locales) {
	    // IE11
	    var getCanonicalLocales = Intl.getCanonicalLocales;
	    if (typeof getCanonicalLocales === 'function') {
	        return getCanonicalLocales(locales);
	    }
	    // NOTE: we must NOT call `supportedLocalesOf` of a formatjs polyfill, or their implementation
	    // will even eventually call this method recursively. Here we use `Intl.DateTimeFormat` since it
	    // is not polyfilled by `@formatjs`.
	    // TODO: Fix TypeScript type def for this bc undefined is just fine
	    return Intl.DateTimeFormat.supportedLocalesOf(locales);
	}
	exports.getCanonicalLocales = getCanonicalLocales;
	//# sourceMappingURL=get-canonical-locales.js.map

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var aliases_1 = __webpack_require__(707);
	var parentLocales_1 = __webpack_require__(710);
	var invariant_1 = __webpack_require__(219);
	/**
	 * https://tc39.es/ecma262/#sec-toobject
	 * @param arg
	 */
	function toObject(arg) {
	    if (arg == null) {
	        throw new TypeError('undefined/null cannot be converted to object');
	    }
	    return Object(arg);
	}
	exports.toObject = toObject;
	/**
	 * https://tc39.es/ecma262/#sec-tostring
	 */
	function toString(o) {
	    // Only symbol is irregular...
	    if (typeof o === 'symbol') {
	        throw TypeError('Cannot convert a Symbol value to a string');
	    }
	    return String(o);
	}
	exports.toString = toString;
	/**
	 * https://tc39.es/ecma402/#sec-getoption
	 * @param opts
	 * @param prop
	 * @param type
	 * @param values
	 * @param fallback
	 */
	function getOption(opts, prop, type, values, fallback) {
	    // const descriptor = Object.getOwnPropertyDescriptor(opts, prop);
	    var value = opts[prop];
	    if (value !== undefined) {
	        if (type !== 'boolean' && type !== 'string') {
	            throw new TypeError('invalid type');
	        }
	        if (type === 'boolean') {
	            value = Boolean(value);
	        }
	        if (type === 'string') {
	            value = toString(value);
	        }
	        if (values !== undefined && !values.filter(function (val) { return val == value; }).length) {
	            throw new RangeError(value + " is not within " + values.join(', '));
	        }
	        return value;
	    }
	    return fallback;
	}
	exports.getOption = getOption;
	/**
	 * https://tc39.es/ecma402/#sec-defaultnumberoption
	 * @param val
	 * @param min
	 * @param max
	 * @param fallback
	 */
	function defaultNumberOption(val, min, max, fallback) {
	    if (val !== undefined) {
	        val = Number(val);
	        if (isNaN(val) || val < min || val > max) {
	            throw new RangeError(val + " is outside of range [" + min + ", " + max + "]");
	        }
	        return Math.floor(val);
	    }
	    return fallback;
	}
	exports.defaultNumberOption = defaultNumberOption;
	/**
	 * https://tc39.es/ecma402/#sec-getnumberoption
	 * @param options
	 * @param property
	 * @param min
	 * @param max
	 * @param fallback
	 */
	function getNumberOption(options, property, minimum, maximum, fallback) {
	    var val = options[property];
	    return defaultNumberOption(val, minimum, maximum, fallback);
	}
	exports.getNumberOption = getNumberOption;
	function getAliasesByLang(lang) {
	    return Object.keys(aliases_1.default).reduce(function (all, locale) {
	        if (locale.split('-')[0] === lang) {
	            all[locale] = aliases_1.default[locale];
	        }
	        return all;
	    }, {});
	}
	exports.getAliasesByLang = getAliasesByLang;
	function getParentLocalesByLang(lang) {
	    return Object.keys(parentLocales_1.default).reduce(function (all, locale) {
	        if (locale.split('-')[0] === lang) {
	            all[locale] = parentLocales_1.default[locale];
	        }
	        return all;
	    }, {});
	}
	exports.getParentLocalesByLang = getParentLocalesByLang;
	function setInternalSlot(map, pl, field, value) {
	    if (!map.get(pl)) {
	        map.set(pl, Object.create(null));
	    }
	    var slots = map.get(pl);
	    slots[field] = value;
	}
	exports.setInternalSlot = setInternalSlot;
	function setMultiInternalSlots(map, pl, props) {
	    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	        var k = _a[_i];
	        setInternalSlot(map, pl, k, props[k]);
	    }
	}
	exports.setMultiInternalSlots = setMultiInternalSlots;
	function getInternalSlot(map, pl, field) {
	    return getMultiInternalSlots(map, pl, field)[field];
	}
	exports.getInternalSlot = getInternalSlot;
	function getMultiInternalSlots(map, pl) {
	    var fields = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        fields[_i - 2] = arguments[_i];
	    }
	    var slots = map.get(pl);
	    if (!slots) {
	        throw new TypeError(pl + " InternalSlot has not been initialized");
	    }
	    return fields.reduce(function (all, f) {
	        all[f] = slots[f];
	        return all;
	    }, Object.create(null));
	}
	exports.getMultiInternalSlots = getMultiInternalSlots;
	function isLiteralPart(patternPart) {
	    return patternPart.type === 'literal';
	}
	exports.isLiteralPart = isLiteralPart;
	function partitionPattern(pattern) {
	    var result = [];
	    var beginIndex = pattern.indexOf('{');
	    var endIndex = 0;
	    var nextIndex = 0;
	    var length = pattern.length;
	    while (beginIndex < pattern.length && beginIndex > -1) {
	        endIndex = pattern.indexOf('}', beginIndex);
	        invariant_1.invariant(endIndex > beginIndex, "Invalid pattern " + pattern);
	        if (beginIndex > nextIndex) {
	            result.push({
	                type: 'literal',
	                value: pattern.substring(nextIndex, beginIndex),
	            });
	        }
	        result.push({
	            type: pattern.substring(beginIndex + 1, endIndex),
	            value: undefined,
	        });
	        nextIndex = endIndex + 1;
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    if (nextIndex < length) {
	        result.push({
	            type: 'literal',
	            value: pattern.substring(nextIndex, length),
	        });
	    }
	    return result;
	}
	exports.partitionPattern = partitionPattern;
	/**
	 * https://tc39.es/ecma402/#sec-setnfdigitoptions
	 * https://tc39.es/proposal-unified-intl-numberformat/section11/numberformat_diff_out.html#sec-setnfdigitoptions
	 * @param intlObj
	 * @param opts
	 * @param mnfdDefault
	 * @param mxfdDefault
	 */
	function setNumberFormatDigitOptions(internalSlotMap, intlObj, opts, mnfdDefault, mxfdDefault) {
	    var mnid = getNumberOption(opts, 'minimumIntegerDigits', 1, 21, 1);
	    var mnfd = opts.minimumFractionDigits;
	    var mxfd = opts.maximumFractionDigits;
	    var mnsd = opts.minimumSignificantDigits;
	    var mxsd = opts.maximumSignificantDigits;
	    setInternalSlot(internalSlotMap, intlObj, 'minimumIntegerDigits', mnid);
	    if (mnsd !== undefined || mxsd !== undefined) {
	        setInternalSlot(internalSlotMap, intlObj, 'roundingType', 'significantDigits');
	        mnsd = defaultNumberOption(mnsd, 1, 21, 1);
	        mxsd = defaultNumberOption(mxsd, mnsd, 21, 21);
	        setInternalSlot(internalSlotMap, intlObj, 'minimumSignificantDigits', mnsd);
	        setInternalSlot(internalSlotMap, intlObj, 'maximumSignificantDigits', mxsd);
	    }
	    else if (mnfd !== undefined || mxfd !== undefined) {
	        setInternalSlot(internalSlotMap, intlObj, 'roundingType', 'fractionDigits');
	        mnfd = defaultNumberOption(mnfd, 0, 20, mnfdDefault);
	        var mxfdActualDefault = Math.max(mnfd, mxfdDefault);
	        mxfd = defaultNumberOption(mxfd, mnfd, 20, mxfdActualDefault);
	        setInternalSlot(internalSlotMap, intlObj, 'minimumFractionDigits', mnfd);
	        setInternalSlot(internalSlotMap, intlObj, 'maximumFractionDigits', mxfd);
	    }
	    else if (getInternalSlot(internalSlotMap, intlObj, 'notation') === 'compact') {
	        setInternalSlot(internalSlotMap, intlObj, 'roundingType', 'compactRounding');
	    }
	    else {
	        setInternalSlot(internalSlotMap, intlObj, 'roundingType', 'fractionDigits');
	        setInternalSlot(internalSlotMap, intlObj, 'minimumFractionDigits', mnfdDefault);
	        setInternalSlot(internalSlotMap, intlObj, 'maximumFractionDigits', mxfdDefault);
	    }
	}
	exports.setNumberFormatDigitOptions = setNumberFormatDigitOptions;
	function objectIs(x, y) {
	    if (Object.is) {
	        return Object.is(x, y);
	    }
	    // SameValue algorithm
	    if (x === y) {
	        // Steps 1-5, 7-10
	        // Steps 6.b-6.e: +0 != -0
	        return x !== 0 || 1 / x === 1 / y;
	    }
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	}
	exports.objectIs = objectIs;
	var NOT_A_Z_REGEX = /[^A-Z]/;
	/**
	 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
	 * @param str string to convert
	 */
	function toUpperCase(str) {
	    return str.replace(/([a-z])/g, function (_, c) { return c.toUpperCase(); });
	}
	/**
	 * https://tc39.es/proposal-unified-intl-numberformat/section6/locales-currencies-tz_proposed_out.html#sec-iswellformedcurrencycode
	 * @param currency
	 */
	function isWellFormedCurrencyCode(currency) {
	    currency = toUpperCase(currency);
	    if (currency.length !== 3) {
	        return false;
	    }
	    if (NOT_A_Z_REGEX.test(currency)) {
	        return false;
	    }
	    return true;
	}
	exports.isWellFormedCurrencyCode = isWellFormedCurrencyCode;
	//# sourceMappingURL=polyfill-utils.js.map

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(748));

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _reactTransitionGroup = __webpack_require__(125);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _transitions = __webpack_require__(60);
	
	var _utils = __webpack_require__(112);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the container element. */
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	
	    /* Styles applied to the container element when the transition has entered. */
	    entered: {
	      height: 'auto',
	      overflow: 'visible'
	    },
	
	    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
	    hidden: {
	      visibility: 'hidden'
	    },
	
	    /* Styles applied to the outer wrapper element. */
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	
	    /* Styles applied to the inner wrapper element. */
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * The Collapse transition is used by the
	 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	exports.styles = styles;
	var Collapse = React.forwardRef(function Collapse(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$collapsedHeigh = props.collapsedHeight,
	      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? _transitions.duration.standard : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "collapsedHeight", "component", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var timer = React.useRef();
	  var wrapperRef = React.useRef(null);
	  var autoTransitionDuration = React.useRef();
	  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    node.style.height = collapsedHeight;
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleEntering = function handleEntering(node, isAppearing) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  };
	
	  var handleEntered = function handleEntered(node, isAppearing) {
	    node.style.height = 'auto';
	
	    if (onEntered) {
	      onEntered(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var handleExiting = function handleExiting(node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = collapsedHeight;
	
	    if (onExiting) {
	      onExiting(node);
	    }
	  };
	
	  var addEndListener = function addEndListener(_, next) {
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: inProp,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExiting: handleExiting,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, className, {
	        'entered': classes.entered,
	        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
	      }[state]),
	      style: (0, _extends2.default)({
	        minHeight: collapsedHeight
	      }, style),
	      ref: ref
	    }, childProps), /*#__PURE__*/React.createElement("div", {
	      className: classes.wrapper,
	      ref: wrapperRef
	    }, /*#__PURE__*/React.createElement("div", {
	      className: classes.wrapperInner
	    }, children)));
	  });
	});
	 false ? Collapse.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Collapse.muiSupportAuto = true;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCollapse'
	})(Collapse);
	
	exports.default = _default;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * @ignore - internal component.
	 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
	 */
	var ExpansionPanelContext = React.createContext({});
	
	if (false) {
	  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
	}
	
	var _default = ExpansionPanelContext;
	exports.default = _default;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _reactTransitionGroup = __webpack_require__(125);
	
	var _transitions = __webpack_require__(60);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(112);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Fade transition is used by the [Modal](/components/modal/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade = React.forwardRef(function Fade(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "TransitionComponent", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var handleRef = (0, _useForkRef.default)(children.ref, ref);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Fade.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(782));

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(783));

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(784));

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _reactTransitionGroup = __webpack_require__(125);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(112);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	/**
	 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
	 * [Popover](/components/popover/) components.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow = React.forwardRef(function Grow(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout", "TransitionComponent"]);
	  var timer = React.useRef();
	  var autoTimeout = React.useRef();
	  var handleRef = (0, _useForkRef.default)(children.ref, ref);
	  var theme = (0, _useTheme.default)();
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration,
	        delay = _getTransitionProps.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay
	    })].join(',');
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration,
	        delay = _getTransitionProps2.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay || duration * 0.333
	    })].join(',');
	    node.style.opacity = '0';
	    node.style.transform = getScale(0.75);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var addEndListener = function addEndListener(_, next) {
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTimeout.current || 0);
	    }
	  };
	
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        transform: getScale(0.75),
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Grow.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Grow.muiSupportAuto = true;
	var _default = Grow;
	exports.default = _default;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(804));

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(805));

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(816));

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Popover = _interopRequireDefault(__webpack_require__(134));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(133));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _setRef = _interopRequireDefault(__webpack_require__(94));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var RTL_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'right'
	};
	var LTR_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	var styles = {
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    // specZ: The maximum height of a simple menu should be one or more rows less than the view
	    // height. This ensures a tapable area outside of the simple menu with which to dismiss
	    // the menu.
	    maxHeight: 'calc(100% - 96px)',
	    // Add iOS momentum scrolling.
	    WebkitOverflowScrolling: 'touch'
	  },
	
	  /* Styles applied to the `List` component via `MenuList`. */
	  list: {
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Menu = React.forwardRef(function Menu(props, ref) {
	  var _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      _props$disableAutoFoc = props.disableAutoFocusItem,
	      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$MenuListProps = props.MenuListProps,
	      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
	      onClose = props.onClose,
	      onEntering = props.onEntering,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      PopoverClasses = props.PopoverClasses,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
	  var menuListActionsRef = React.useRef(null);
	  var contentAnchorRef = React.useRef(null);
	
	  var getContentAnchorEl = function getContentAnchorEl() {
	    return contentAnchorRef.current;
	  };
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (menuListActionsRef.current) {
	      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
	    }
	
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	  };
	
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab') {
	      event.preventDefault();
	
	      if (onClose) {
	        onClose(event, 'tabKeyDown');
	      }
	    }
	  };
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.map(children, function (child, index) {
	    if (!React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant !== "menu" && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      return React.cloneElement(child, {
	        ref: function ref(instance) {
	          // #StrictMode ready
	          contentAnchorRef.current = ReactDOM.findDOMNode(instance);
	          (0, _setRef.default)(child.ref, instance);
	        }
	      });
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_Popover.default, (0, _extends2.default)({
	    getContentAnchorEl: getContentAnchorEl,
	    classes: PopoverClasses,
	    onClose: onClose,
	    onEntering: handleEntering,
	    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      classes: (0, _extends2.default)({}, PaperProps.classes, {
	        root: classes.paper
	      })
	    }),
	    open: open,
	    ref: ref,
	    transitionDuration: transitionDuration
	  }, other), /*#__PURE__*/React.createElement(_MenuList.default, (0, _extends2.default)({
	    onKeyDown: handleListKeyDown,
	    actions: menuListActionsRef,
	    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
	    autoFocusItem: autoFocusItem,
	    variant: variant
	  }, MenuListProps, {
	    className: (0, _clsx.default)(classes.list, MenuListProps.className)
	  }), items));
	});
	 false ? Menu.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A HTML element, or a function that returns it.
	   * It's used to set the position of the menu.
	   */
	  anchorEl: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.func]),
	
	  /**
	   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
	   * children are not focusable. If you set this prop to `false` focus will be placed
	   * on the parent modal container. This has severe accessibility implications
	   * and should only be considered if you manage focus otherwise.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Menu contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * When opening the menu will not focus the active item but the `[role="menu"]`
	   * unless `autoFocus` is also set to `false`. Not using the default means not
	   * following WAI-ARIA authoring practices. Please be considerate about possible
	   * accessibility implications.
	   */
	  disableAutoFocusItem: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`MenuList`](/api/menu-list/) element.
	   */
	  MenuListProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the menu is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * `classes` prop applied to the [`Popover`](/api/popover/) element.
	   */
	  PopoverClasses: _propTypes.default.object,
	
	  /**
	   * The length of the transition in `ms`, or 'auto'
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenu'
	})(Menu);
	
	exports.default = _default;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(216));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(155));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(357));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(168));
	
	// Is a vertical scrollbar displayed?
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	
	  if (doc.body === container) {
	    return (0, _ownerWindow.default)(doc).innerWidth > doc.documentElement.clientWidth;
	  }
	
	  return container.scrollHeight > container.clientHeight;
	}
	
	function ariaHidden(node, show) {
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function getPaddingRight(node) {
	  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
	}
	
	function ariaHiddenSiblings(container, mountNode, currentNode) {
	  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var show = arguments.length > 4 ? arguments[4] : undefined;
	  var blacklist = [mountNode, currentNode].concat((0, _toConsumableArray2.default)(nodesToExclude));
	  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
	  [].forEach.call(container.children, function (node) {
	    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
	      ariaHidden(node, show);
	    }
	  });
	}
	
	function findIndexOf(containerInfo, callback) {
	  var idx = -1;
	  containerInfo.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function handleContainer(containerInfo, props) {
	  var restoreStyle = [];
	  var restorePaddings = [];
	  var container = containerInfo.container;
	  var fixedNodes;
	
	  if (!props.disableScrollLock) {
	    if (isOverflowing(container)) {
	      // Compute the size before applying overflow hidden to avoid any scroll jumps.
	      var scrollbarSize = (0, _getScrollbarSize.default)();
	      restoreStyle.push({
	        value: container.style.paddingRight,
	        key: 'padding-right',
	        el: container
	      }); // Use computed style, here to get the real padding to add our scrollbar width.
	
	      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	      fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	      [].forEach.call(fixedNodes, function (node) {
	        restorePaddings.push(node.style.paddingRight);
	        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
	      });
	    } // Improve Gatsby support
	    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
	
	
	    var parent = container.parentElement;
	    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
	    // screensize shrink.
	
	    restoreStyle.push({
	      value: scrollContainer.style.overflow,
	      key: 'overflow',
	      el: scrollContainer
	    });
	    scrollContainer.style.overflow = 'hidden';
	  }
	
	  var restore = function restore() {
	    if (fixedNodes) {
	      [].forEach.call(fixedNodes, function (node, i) {
	        if (restorePaddings[i]) {
	          node.style.paddingRight = restorePaddings[i];
	        } else {
	          node.style.removeProperty('padding-right');
	        }
	      });
	    }
	
	    restoreStyle.forEach(function (_ref) {
	      var value = _ref.value,
	          el = _ref.el,
	          key = _ref.key;
	
	      if (value) {
	        el.style.setProperty(key, value);
	      } else {
	        el.style.removeProperty(key);
	      }
	    });
	  };
	
	  return restore;
	}
	
	function getHiddenSiblings(container) {
	  var hiddenSiblings = [];
	  [].forEach.call(container.children, function (node) {
	    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	      hiddenSiblings.push(node);
	    }
	  });
	  return hiddenSiblings;
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state management for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager = /*#__PURE__*/function () {
	  function ModalManager() {
	    (0, _classCallCheck2.default)(this, ModalManager);
	    // this.modals[modalIndex] = modal
	    this.modals = []; // this.containers[containerIndex] = {
	    //   modals: [],
	    //   container,
	    //   restore: null,
	    // }
	
	    this.containers = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex !== -1) {
	        return modalIndex;
	      }
	
	      modalIndex = this.modals.length;
	      this.modals.push(modal); // If the modal we are adding is already in the DOM.
	
	      if (modal.modalRef) {
	        ariaHidden(modal.modalRef, false);
	      }
	
	      var hiddenSiblingNodes = getHiddenSiblings(container);
	      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.container === container;
	      });
	
	      if (containerIndex !== -1) {
	        this.containers[containerIndex].modals.push(modal);
	        return modalIndex;
	      }
	
	      this.containers.push({
	        modals: [modal],
	        container: container,
	        restore: null,
	        hiddenSiblingNodes: hiddenSiblingNodes
	      });
	      return modalIndex;
	    }
	  }, {
	    key: "mount",
	    value: function mount(modal, props) {
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	
	      if (!containerInfo.restore) {
	        containerInfo.restore = handleContainer(containerInfo, props);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex === -1) {
	        return modalIndex;
	      }
	
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
	      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
	
	      if (containerInfo.modals.length === 0) {
	        // The modal might be closed before it had the chance to be mounted in the DOM.
	        if (containerInfo.restore) {
	          containerInfo.restore();
	        }
	
	        if (modal.modalRef) {
	          // In case the modal wasn't in the DOM yet.
	          ariaHidden(modal.modalRef, true);
	        }
	
	        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
	        this.containers.splice(containerIndex, 1);
	      } else {
	        // Otherwise make sure the next top modal is visible to a screen reader.
	        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
	        // aria-hidden because the dom element doesn't exist either
	        // when modal was unmounted before modalRef gets null
	
	        if (nextTop.modalRef) {
	          ariaHidden(nextTop.modalRef, false);
	        }
	      }
	
	      return modalIndex;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	exports.default = ModalManager;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(327));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(110));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(92));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(350));
	
	var _Input = _interopRequireDefault(__webpack_require__(160));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the select component `root` class. */
	    root: {},
	
	    /* Styles applied to the select component `select` class. */
	    select: {
	      '-moz-appearance': 'none',
	      // Reset
	      '-webkit-appearance': 'none',
	      // Reset
	      // When interacting quickly, the text can end up selected.
	      // Native select can't be selected either.
	      userSelect: 'none',
	      borderRadius: 0,
	      // Reset
	      minWidth: 16,
	      // So it doesn't collapse.
	      cursor: 'pointer',
	      '&:focus': {
	        // Show that it's not an text input
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
	        borderRadius: 0 // Reset Chrome style
	
	      },
	      // Remove IE 11 arrow
	      '&::-ms-expand': {
	        display: 'none'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      },
	      '&[multiple]': {
	        height: 'auto'
	      },
	      '&:not([multiple]) option, &:not([multiple]) optgroup': {
	        backgroundColor: theme.palette.background.paper
	      },
	      '&&': {
	        paddingRight: 24
	      }
	    },
	
	    /* Styles applied to the select component if `variant="filled"`. */
	    filled: {
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component if `variant="outlined"`. */
	    outlined: {
	      borderRadius: theme.shape.borderRadius,
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component `selectMenu` class. */
	    selectMenu: {
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    },
	
	    /* Pseudo-class applied to the select component `disabled` class. */
	    disabled: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      // We use a position absolute over a flexbox in order to forward the pointer events
	      // to the input and to support wrapping tags..
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 12px)',
	      // Center vertically
	      pointerEvents: 'none',
	      // Don't block pointer events on the select under the icon.
	      color: theme.palette.action.active,
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the icon component if the popup is open. */
	    iconOpen: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the icon component if `variant="filled"`. */
	    iconFilled: {
	      right: 7
	    },
	
	    /* Styles applied to the icon component if `variant="outlined"`. */
	    iconOutlined: {
	      right: 7
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultInput = /*#__PURE__*/React.createElement(_Input.default, null);
	/**
	 * An alternative to `<Select native />` with a much smaller bundle size footprint.
	 */
	
	var NativeSelect = React.forwardRef(function NativeSelect(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      _props$input = props.input,
	      input = _props$input === void 0 ? defaultInput : _props$input,
	      inputProps = props.inputProps,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  return React.cloneElement(input, (0, _extends2.default)({
	    // Most of the logic is implemented in `NativeSelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: _NativeSelectInput.default,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      classes: classes,
	      IconComponent: IconComponent,
	      variant: fcs.variant,
	      type: undefined
	    }, inputProps, {}, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? NativeSelect.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * Attributes applied to the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	NativeSelect.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiNativeSelect'
	})(NativeSelect);
	
	exports.default = _default;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	/**
	 * @ignore - internal component.
	 */
	var NativeSelectInput = React.forwardRef(function NativeSelectInput(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      disabled = props.disabled,
	      IconComponent = props.IconComponent,
	      inputRef = props.inputRef,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes[variant], className, disabled && classes.disabled),
	    disabled: disabled,
	    ref: inputRef || ref
	  }, other)), props.multiple ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], disabled && classes.disabled)
	  }));
	});
	 false ? NativeSelectInput.propTypes = {
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Use that prop to pass a ref to the native select element.
	   * @deprecated
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = NativeSelectInput;
	exports.default = _default;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(826));

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * @ignore - internal component.
	 */
	var RadioGroupContext = React.createContext();
	
	if (false) {
	  RadioGroupContext.displayName = 'RadioGroupContext';
	}
	
	var _default = RadioGroupContext;
	exports.default = _default;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useRadioGroup;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(329));
	
	function useRadioGroup() {
	  return React.useContext(_RadioGroupContext.default);
	}

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _debounce = _interopRequireDefault(__webpack_require__(93));
	
	var _reactTransitionGroup = __webpack_require__(125);
	
	var _utils = __webpack_require__(21);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _transitions = __webpack_require__(60);
	
	var _utils2 = __webpack_require__(112);
	
	// Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `none`.`
	function getTranslateValue(direction, node) {
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = window.getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(".concat(window.innerWidth, "px) translateX(-").concat(rect.left - offsetX, "px)");
	  }
	
	  if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
	  }
	
	  if (direction === 'up') {
	    return "translateY(".concat(window.innerHeight, "px) translateY(-").concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
	}
	
	function setTranslateValue(direction, node) {
	  var transform = getTranslateValue(direction, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Slide transition is used by the [Drawer](/components/drawers/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Slide = React.forwardRef(function Slide(props, ref) {
	  var children = props.children,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'down' : _props$direction,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "direction", "in", "onEnter", "onEntering", "onExit", "onExited", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var childrenRef = React.useRef(null);
	  /**
	   * used in cloneElement(children, { ref: handleRef })
	   */
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    childrenRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRefIntermediary = (0, _useForkRef.default)(children.ref, handleOwnRef);
	  var handleRef = (0, _useForkRef.default)(handleRefIntermediary, ref);
	
	  var handleEnter = function handleEnter(_, isAppearing) {
	    var node = childrenRef.current;
	    setTranslateValue(direction, node);
	    (0, _utils2.reflow)(node);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleEntering = function handleEntering(_, isAppearing) {
	    var node = childrenRef.current;
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.webkitTransform = 'none';
	    node.style.transform = 'none';
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit() {
	    var node = childrenRef.current;
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    setTranslateValue(direction, node);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var handleExited = function handleExited() {
	    var node = childrenRef.current; // No need for transitions when the component is hidden
	
	    node.style.webkitTransition = '';
	    node.style.transition = '';
	
	    if (onExited) {
	      onExited(node);
	    }
	  };
	
	  var updatePosition = React.useCallback(function () {
	    if (childrenRef.current) {
	      setTranslateValue(direction, childrenRef.current);
	    }
	  }, [direction]);
	  React.useEffect(function () {
	    // Skip configuration where the position is screen size invariant.
	    if (inProp || direction === 'down' || direction === 'right') {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      if (childrenRef.current) {
	        setTranslateValue(direction, childrenRef.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [direction, inProp]);
	  React.useEffect(function () {
	    if (!inProp) {
	      // We need to update the position of the drawer when the direction change and
	      // when it's hidden.
	      updatePosition();
	    }
	  }, [inProp, updatePosition]);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    onEnter: handleEnter,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    appear: true,
	    in: inProp,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return React.cloneElement(children, (0, _extends2.default)({
	      ref: handleRef,
	      style: (0, _extends2.default)({
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, style, {}, children.props.style)
	    }, childProps));
	  });
	});
	 false ? Slide.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef,
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['down', 'left', 'right', 'up']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Slide;
	exports.default = _default;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(848));

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(853));

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(856));

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(857));

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * @ignore - internal component.
	 */
	var TableContext = React.createContext();
	
	if (false) {
	  TableContext.displayName = 'TableContext';
	}
	
	var _default = TableContext;
	exports.default = _default;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(888));

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(889));

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(890));

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _reactTransitionGroup = __webpack_require__(125);
	
	var _transitions = __webpack_require__(60);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(112);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var styles = {
	  entering: {
	    transform: 'none'
	  },
	  entered: {
	    transform: 'none'
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Zoom transition can be used for the floating variant of the
	 * [Button](/components/buttons/#floating-action-buttons) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Zoom = React.forwardRef(function Zoom(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var handleRef = (0, _useForkRef.default)(children.ref, ref);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        transform: 'scale(0)',
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Zoom.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Zoom;
	exports.default = _default;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	Object.defineProperty(exports, "unstable_StrictModeZoom", {
	  enumerable: true,
	  get: function get() {
	    return _StrictModeZoom.default;
	  }
	});
	
	var _Zoom = _interopRequireDefault(__webpack_require__(340));
	
	var _StrictModeZoom = _interopRequireDefault(__webpack_require__(892));

/***/ },
/* 342 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	var _default = blue;
	exports.default = _default;

/***/ },
/* 343 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	var _default = common;
	exports.default = _default;

/***/ },
/* 344 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	var _default = green;
	exports.default = _default;

/***/ },
/* 345 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	var _default = grey;
	exports.default = _default;

/***/ },
/* 346 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	var _default = indigo;
	exports.default = _default;

/***/ },
/* 347 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	var _default = orange;
	exports.default = _default;

/***/ },
/* 348 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	var _default = pink;
	exports.default = _default;

/***/ },
/* 349 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	var _default = red;
	exports.default = _default;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
	}), 'KeyboardArrowLeft');
	
	exports.default = _default;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
	}), 'KeyboardArrowRight');
	
	exports.default = _default;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBreakpoints;
	exports.keys = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
	
	exports.keys = keys;
	
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === void 0 ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return "@media (min-width:".concat(value).concat(unit, ")");
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end);
	
	    if (endIndex === keys.length - 1) {
	      return up(start);
	    }
	
	    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  function width(key) {
	    return values[key];
	  }
	
	  return (0, _extends2.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(52);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(137));
	
	var styled = function styled(Component) {
	  var componentCreator = (0, _styles.styled)(Component);
	  return function (style, options) {
	    return componentCreator(style, (0, _extends2.default)({
	      defaultTheme: _defaultTheme.default
	    }, options));
	  };
	};
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 355 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  speedDial: 1050,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	var _default = zIndex;
	exports.default = _default;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(931));

/***/ },
/* 357 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScrollbarSize;
	
	// A change of the browser zoom change the scrollbar size.
	// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
	function getScrollbarSize() {
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '99px';
	  scrollDiv.style.height = '99px';
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarSize;
	}

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requirePropFactory;
	
	function requirePropFactory(componentNameInError) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
	      }
	
	      return null;
	    };
	  };
	
	  return requireProp;
	}

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AddCircleRounded');
	
	exports.default = _default;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
	}), 'Block');
	
	exports.default = _default;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
	}), 'Info');
	
	exports.default = _default;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'Warning');
	
	exports.default = _default;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = usePagination;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(34);
	
	function usePagination() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  // keep default values in sync with @default tags in Pagination.propTypes
	  var _props$boundaryCount = props.boundaryCount,
	      boundaryCountProp = _props$boundaryCount === void 0 ? 1 : _props$boundaryCount,
	      _props$componentName = props.componentName,
	      componentName = _props$componentName === void 0 ? 'usePagination' : _props$componentName,
	      _props$count = props.count,
	      count = _props$count === void 0 ? 1 : _props$count,
	      _props$defaultPage = props.defaultPage,
	      defaultPage = _props$defaultPage === void 0 ? 1 : _props$defaultPage,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$hideNextButton = props.hideNextButton,
	      hideNextButton = _props$hideNextButton === void 0 ? false : _props$hideNextButton,
	      _props$hidePrevButton = props.hidePrevButton,
	      hidePrevButton = _props$hidePrevButton === void 0 ? false : _props$hidePrevButton,
	      handleChange = props.onChange,
	      pageProp = props.page,
	      _props$showFirstButto = props.showFirstButton,
	      showFirstButton = _props$showFirstButto === void 0 ? false : _props$showFirstButto,
	      _props$showLastButton = props.showLastButton,
	      showLastButton = _props$showLastButton === void 0 ? false : _props$showLastButton,
	      _props$siblingCount = props.siblingCount,
	      siblingCount = _props$siblingCount === void 0 ? 1 : _props$siblingCount,
	      other = (0, _objectWithoutProperties2.default)(props, ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"]); // TODO: Update all formulae to remove this adjustment
	
	  var boundaryCount = boundaryCountProp - 1;
	
	  var _useControlled = (0, _utils.useControlled)({
	    controlled: pageProp,
	    default: defaultPage,
	    name: componentName,
	    state: 'page'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      page = _useControlled2[0],
	      setPageState = _useControlled2[1];
	
	  var handleClick = function handleClick(event, value) {
	    if (!pageProp) {
	      setPageState(value);
	    }
	
	    if (handleChange) {
	      handleChange(event, value);
	    }
	  }; // https://dev.to/namirsab/comment/2050
	
	
	  var range = function range(start, end) {
	    var length = end - start + 1;
	    return Array.from({
	      length: length
	    }, function (_, i) {
	      return start + i;
	    });
	  };
	
	  var startPages = range(1, Math.min(boundaryCount + 1, count));
	  var endPages = range(Math.max(count - boundaryCount, boundaryCount + 2), count);
	  var siblingsStart = Math.max(Math.min( // Natural start
	  page - siblingCount, // Lower boundary when page is high
	  count - boundaryCount - siblingCount * 2 - 2), // Greater than startPages
	  boundaryCount + 3);
	  var siblingsEnd = Math.min(Math.max( // Natural end
	  page + siblingCount, // Upper boundary when page is low
	  boundaryCount + siblingCount * 2 + 3), // Less than endPages
	  endPages[0] - 2); // Basic list of items to render
	  // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
	
	  var itemList = [].concat((0, _toConsumableArray2.default)(showFirstButton ? ['first'] : []), (0, _toConsumableArray2.default)(hidePrevButton ? [] : ['previous']), (0, _toConsumableArray2.default)(startPages), (0, _toConsumableArray2.default)(siblingsStart > boundaryCount + 3 ? ['start-ellipsis'] : 2 + boundaryCount < count - boundaryCount - 1 ? [2 + boundaryCount] : []), (0, _toConsumableArray2.default)(range(siblingsStart, siblingsEnd)), (0, _toConsumableArray2.default)(siblingsEnd < count - boundaryCount - 2 ? ['end-ellipsis'] : count - boundaryCount - 1 > boundaryCount + 1 ? [count - boundaryCount - 1] : []), (0, _toConsumableArray2.default)(endPages), (0, _toConsumableArray2.default)(hideNextButton ? [] : ['next']), (0, _toConsumableArray2.default)(showLastButton ? ['last'] : [])); // Map the button type to its page number
	
	  var buttonPage = function buttonPage(type) {
	    switch (type) {
	      case 'first':
	        return 1;
	
	      case 'previous':
	        return page - 1;
	
	      case 'next':
	        return page + 1;
	
	      case 'last':
	        return count;
	
	      default:
	        return null;
	    }
	  }; // Convert the basic item list to PaginationItem props objects
	
	
	  var items = itemList.map(function (item) {
	    return typeof item === 'number' ? {
	      onClick: function onClick(event) {
	        handleClick(event, item);
	      },
	      type: 'page',
	      page: item,
	      selected: item === page,
	      disabled: disabled,
	      'aria-current': item === page ? 'true' : undefined
	    } : {
	      onClick: function onClick(event) {
	        handleClick(event, buttonPage(item));
	      },
	      type: item,
	      page: buttonPage(item),
	      selected: false,
	      disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
	    };
	  });
	  return (0, _extends2.default)({
	    items: items
	  }, other);
	}

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Skeleton.default;
	  }
	});
	
	var _Skeleton = _interopRequireDefault(__webpack_require__(968));

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), 'Close');
	
	exports.default = _default;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(243));
	
	var _ChildMapping = __webpack_require__(985);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	/**
	 * The `<TransitionGroup>` component manages a set of transition components
	 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	 * components, `<TransitionGroup>` is a state machine for managing the mounting
	 * and unmounting of components over time.
	 *
	 * Consider the example below. As items are removed or added to the TodoList the
	 * `in` prop is toggled automatically by the `<TransitionGroup>`.
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual transition
	 * component. This means you can mix and match animations across different list
	 * items.
	 */
	
	var TransitionGroup = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, /*#__PURE__*/_react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 368 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 369 */
[1916, 115],
/* 370 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';
	
	exports.default = _default;

/***/ },
/* 371 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We use the same empty object to ref count the styles that don't need a theme object.
	var noopTheme = {};
	var _default = noopTheme;
	exports.default = _default;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(998));

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(999));

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(1003));

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ThemeContext = _react.default.createContext(null);
	
	if (false) {
	  ThemeContext.displayName = 'ThemeContext';
	}
	
	var _default = ThemeContext;
	exports.default = _default;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.2
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  borders: true,
	  breakpoints: true,
	  compose: true,
	  css: true,
	  display: true,
	  flexbox: true,
	  grid: true,
	  palette: true,
	  positions: true,
	  shadows: true,
	  sizing: true,
	  spacing: true,
	  style: true,
	  typography: true
	};
	Object.defineProperty(exports, "borders", {
	  enumerable: true,
	  get: function get() {
	    return _borders.default;
	  }
	});
	Object.defineProperty(exports, "breakpoints", {
	  enumerable: true,
	  get: function get() {
	    return _breakpoints.default;
	  }
	});
	Object.defineProperty(exports, "compose", {
	  enumerable: true,
	  get: function get() {
	    return _compose.default;
	  }
	});
	Object.defineProperty(exports, "css", {
	  enumerable: true,
	  get: function get() {
	    return _css.default;
	  }
	});
	Object.defineProperty(exports, "display", {
	  enumerable: true,
	  get: function get() {
	    return _display.default;
	  }
	});
	Object.defineProperty(exports, "flexbox", {
	  enumerable: true,
	  get: function get() {
	    return _flexbox.default;
	  }
	});
	Object.defineProperty(exports, "grid", {
	  enumerable: true,
	  get: function get() {
	    return _grid.default;
	  }
	});
	Object.defineProperty(exports, "palette", {
	  enumerable: true,
	  get: function get() {
	    return _palette.default;
	  }
	});
	Object.defineProperty(exports, "positions", {
	  enumerable: true,
	  get: function get() {
	    return _positions.default;
	  }
	});
	Object.defineProperty(exports, "shadows", {
	  enumerable: true,
	  get: function get() {
	    return _shadows.default;
	  }
	});
	Object.defineProperty(exports, "sizing", {
	  enumerable: true,
	  get: function get() {
	    return _sizing.default;
	  }
	});
	Object.defineProperty(exports, "spacing", {
	  enumerable: true,
	  get: function get() {
	    return _spacing.default;
	  }
	});
	Object.defineProperty(exports, "style", {
	  enumerable: true,
	  get: function get() {
	    return _style.default;
	  }
	});
	Object.defineProperty(exports, "typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography.default;
	  }
	});
	
	var _borders = _interopRequireWildcard(__webpack_require__(1013));
	
	Object.keys(_borders).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _borders[key];
	    }
	  });
	});
	
	var _breakpoints = _interopRequireDefault(__webpack_require__(247));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	var _css = _interopRequireDefault(__webpack_require__(1014));
	
	var _display = _interopRequireDefault(__webpack_require__(1015));
	
	var _flexbox = _interopRequireWildcard(__webpack_require__(1016));
	
	Object.keys(_flexbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _flexbox[key];
	    }
	  });
	});
	
	var _grid = _interopRequireWildcard(__webpack_require__(1017));
	
	Object.keys(_grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _grid[key];
	    }
	  });
	});
	
	var _palette = _interopRequireWildcard(__webpack_require__(1021));
	
	Object.keys(_palette).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _palette[key];
	    }
	  });
	});
	
	var _positions = _interopRequireWildcard(__webpack_require__(1022));
	
	Object.keys(_positions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _positions[key];
	    }
	  });
	});
	
	var _shadows = _interopRequireDefault(__webpack_require__(1023));
	
	var _sizing = _interopRequireWildcard(__webpack_require__(1024));
	
	Object.keys(_sizing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sizing[key];
	    }
	  });
	});
	
	var _spacing = _interopRequireWildcard(__webpack_require__(1025));
	
	Object.keys(_spacing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _spacing[key];
	    }
	  });
	});
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _typography = _interopRequireWildcard(__webpack_require__(1026));
	
	Object.keys(_typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _typography[key];
	    }
	  });
	});

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(248));
	
	var responsivePropType =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object, _propTypes.default.array]) : {};
	var _default = responsivePropType;
	exports.default = _default;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	var settle = __webpack_require__(1186);
	var buildURL = __webpack_require__(385);
	var parseHeaders = __webpack_require__(1193);
	var isURLSameOrigin = __webpack_require__(1191);
	var createError = __webpack_require__(381);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(1189);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 379 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 380 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(1185);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    }
	  });
	
	  utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
	    if (utils.isObject(config2[prop])) {
	      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
	    } else if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (utils.isObject(config1[prop])) {
	      config[prop] = utils.deepMerge(config1[prop]);
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  utils.forEach([
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength',
	    'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken',
	    'socketPath'
	  ], function defaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  return config;
	};


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(53);
	var normalizeHeaderName = __webpack_require__(1192);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  // Only Node.JS has a process variable that is of [[Class]] process
	  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(378);
	  } else if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(378);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(590)))

/***/ },
/* 384 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.capitalCase = exports.capitalCaseTransform = void 0;
	var tslib_1 = __webpack_require__(1200);
	var no_case_1 = __webpack_require__(120);
	var upper_case_first_1 = __webpack_require__(650);
	function capitalCaseTransform(input) {
	    return upper_case_first_1.upperCaseFirst(input.toLowerCase());
	}
	exports.capitalCaseTransform = capitalCaseTransform;
	function capitalCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return no_case_1.noCase(input, tslib_1.__assign({ delimiter: " ", transform: capitalCaseTransform }, options));
	}
	exports.capitalCase = capitalCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(388);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ },
/* 388 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _reactRouter = __webpack_require__(279);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var createSelectors = function createSelectors(structure) {
	  var getIn = structure.getIn,
	      toJS = structure.toJS;
	
	  var isRouter = function isRouter(value) {
	    return value != null && _typeof(value) === 'object' && getIn(value, ['location']) && getIn(value, ['action']);
	  };
	
	  var getRouter = function getRouter(state) {
	    var router = toJS(getIn(state, ['router']));
	
	    if (!isRouter(router)) {
	      throw 'Could not find router reducer in state tree, it must be mounted under "router"';
	    }
	
	    return router;
	  };
	
	  var getLocation = function getLocation(state) {
	    return toJS(getIn(getRouter(state), ['location']));
	  };
	
	  var getAction = function getAction(state) {
	    return toJS(getIn(getRouter(state), ['action']));
	  };
	
	  var getSearch = function getSearch(state) {
	    return toJS(getIn(getRouter(state), ['location', 'search']));
	  };
	
	  var getHash = function getHash(state) {
	    return toJS(getIn(getRouter(state), ['location', 'hash']));
	  }; // It only makes sense to recalculate the `matchPath` whenever the pathname
	  // of the location changes. That's why `createMatchSelector` memoizes
	  // the latest result based on the location's pathname.
	
	
	  var createMatchSelector = function createMatchSelector(path) {
	    var lastPathname = null;
	    var lastMatch = null;
	    return function (state) {
	      var _ref = getLocation(state) || {},
	          pathname = _ref.pathname;
	
	      if (pathname === lastPathname) {
	        return lastMatch;
	      }
	
	      lastPathname = pathname;
	      var match = (0, _reactRouter.matchPath)(pathname, path);
	
	      if (!match || !lastMatch || match.url !== lastMatch.url) {
	        lastMatch = match;
	      }
	
	      return lastMatch;
	    };
	  };
	
	  return {
	    getLocation: getLocation,
	    getAction: getAction,
	    getRouter: getRouter,
	    getSearch: getSearch,
	    getHash: getHash,
	    createMatchSelector: createMatchSelector
	  };
	};
	
	var _default = createSelectors;
	exports.default = _default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.4.1 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex = /^#([0-9a-f]{3,8})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  copy: function(channels) {
	    return Object.assign(new this.constructor, this, channels);
	  },
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: color_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: color_formatHex,
	  formatHsl: color_formatHsl,
	  formatRgb: color_formatRgb,
	  toString: color_formatRgb
	});
	
	function color_formatHex() {
	  return this.rgb().formatHex();
	}
	
	function color_formatHsl() {
	  return hslConvert(this).formatHsl();
	}
	
	function color_formatRgb() {
	  return this.rgb().formatRgb();
	}
	
	function color(format) {
	  var m, l;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
	      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
	      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
	      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
	      : null) // invalid hex
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (-0.5 <= this.r && this.r < 255.5)
	        && (-0.5 <= this.g && this.g < 255.5)
	        && (-0.5 <= this.b && this.b < 255.5)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: rgb_formatHex,
	  formatRgb: rgb_formatRgb,
	  toString: rgb_formatRgb
	}));
	
	function rgb_formatHex() {
	  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	}
	
	function rgb_formatRgb() {
	  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	  return (a === 1 ? "rgb(" : "rgba(")
	      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	      + (a === 1 ? ")" : ", " + a + ")");
	}
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  formatHsl: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "hsl(" : "hsla(")
	        + (this.h || 0) + ", "
	        + (this.s || 0) * 100 + "%, "
	        + (this.l || 0) * 100 + "%"
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) return hcl2lab(o);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	function hcl2lab(o) {
	  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	  var h = o.h * deg2rad;
	  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return hcl2lab(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.cubehelix = cubehelix;
	exports.gray = gray;
	exports.hcl = hcl;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.lch = lch;
	exports.rgb = rgb;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(391)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function numberArray(a, b) {
	  if (!b) b = [];
	  var n = a ? Math.min(b.length, a.length) : 0,
	      c = b.slice(),
	      i;
	  return function(t) {
	    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	    return c;
	  };
	}
	
	function isNumberArray(x) {
	  return ArrayBuffer.isView(x) && !(x instanceof DataView);
	}
	
	function array(a, b) {
	  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
	}
	
	function genericArray(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b = +b, function(t) {
	    return d.setTime(a * (1 - t) + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b = +b, function(t) {
	    return a * (1 - t) + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : isNumberArray(b) ? numberArray
	      : Array.isArray(b) ? genericArray
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b = +b, function(t) {
	    return Math.round(a * (1 - t) + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateHue = hue$1;
	exports.interpolateLab = lab;
	exports.interpolateNumber = number;
	exports.interpolateNumberArray = numberArray;
	exports.interpolateObject = object;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
	  }
	
	  interval.floor = function(date) {
	    return floori(date = new Date(+date)), date;
	  };
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1229));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 395 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    ;
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var CASE_SENSITIVE_TAG_NAMES = __webpack_require__(1239).CASE_SENSITIVE_TAG_NAMES;
	
	var caseSensitiveTagNamesMap = {};
	var tagName;
	for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
	  tagName = CASE_SENSITIVE_TAG_NAMES[i];
	  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
	}
	
	/**
	 * Gets case-sensitive tag name.
	 *
	 * @param  {String}           tagName - The lowercase tag name.
	 * @return {String|undefined}
	 */
	function getCaseSensitiveTagName(tagName) {
	  return caseSensitiveTagNamesMap[tagName];
	}
	
	/**
	 * Formats DOM attributes to a hash map.
	 *
	 * @param  {NamedNodeMap} attributes - The list of attributes.
	 * @return {Object}                  - A map of attribute name to value.
	 */
	function formatAttributes(attributes) {
	  var result = {};
	  var attribute;
	  // `NamedNodeMap` is array-like
	  for (var i = 0, len = attributes.length; i < len; i++) {
	    attribute = attributes[i];
	    result[attribute.name] = attribute.value;
	  }
	  return result;
	}
	
	/**
	 * Corrects the tag name if it is case-sensitive (SVG).
	 * Otherwise, returns the lowercase tag name (HTML).
	 *
	 * @param  {String} tagName - The lowercase tag name.
	 * @return {String}         - The formatted tag name.
	 */
	function formatTagName(tagName) {
	  tagName = tagName.toLowerCase();
	  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
	  if (caseSensitiveTagName) {
	    return caseSensitiveTagName;
	  }
	  return tagName;
	}
	
	/**
	 * Formats the browser DOM nodes to mimic the output of `htmlparser2.parseDOM()`.
	 *
	 * @param  {NodeList} nodes        - The DOM nodes.
	 * @param  {Object}   [parentObj]  - The formatted parent node.
	 * @param  {String}   [directive]  - The directive.
	 * @return {Object[]}              - The formatted DOM object.
	 */
	function formatDOM(nodes, parentObj, directive) {
	  parentObj = parentObj || null;
	
	  var result = [];
	  var node;
	  var prevNode;
	  var nodeObj;
	
	  // `NodeList` is array-like
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    node = nodes[i];
	    // reset
	    nodeObj = {
	      next: null,
	      prev: result[i - 1] || null,
	      parent: parentObj
	    };
	
	    // set the next node for the previous node (if applicable)
	    prevNode = result[i - 1];
	    if (prevNode) {
	      prevNode.next = nodeObj;
	    }
	
	    // set the node name if it's not "#text" or "#comment"
	    // e.g., "div"
	    if (node.nodeName[0] !== '#') {
	      nodeObj.name = formatTagName(node.nodeName);
	      // also, nodes of type "tag" have "attribs"
	      nodeObj.attribs = {}; // default
	      if (node.attributes && node.attributes.length) {
	        nodeObj.attribs = formatAttributes(node.attributes);
	      }
	    }
	
	    // set the node type
	    // e.g., "tag"
	    switch (node.nodeType) {
	      // 1 = element
	      case 1:
	        if (nodeObj.name === 'script' || nodeObj.name === 'style') {
	          nodeObj.type = nodeObj.name;
	        } else {
	          nodeObj.type = 'tag';
	        }
	        // recursively format the children
	        nodeObj.children = formatDOM(node.childNodes, nodeObj);
	        break;
	      // 2 = attribute
	      // 3 = text
	      case 3:
	        nodeObj.type = 'text';
	        nodeObj.data = node.nodeValue;
	        break;
	      // 8 = comment
	      case 8:
	        nodeObj.type = 'comment';
	        nodeObj.data = node.nodeValue;
	        break;
	    }
	
	    result.push(nodeObj);
	  }
	
	  if (directive) {
	    result.unshift({
	      name: directive.substring(0, directive.indexOf(' ')).toLowerCase(),
	      data: directive,
	      type: 'directive',
	      next: result[0] ? result[0] : null,
	      prev: null,
	      parent: parentObj
	    });
	
	    if (result[1]) {
	      result[1].prev = result[0];
	    }
	  }
	
	  return result;
	}
	
	/**
	 * Detects IE with or without version.
	 *
	 * @param  {Number}  [version] - The IE version to detect.
	 * @return {Boolean}           - Whether IE or the version has been detected.
	 */
	function isIE(version) {
	  if (version) {
	    return document.documentMode === version;
	  }
	  return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
	}
	
	module.exports = {
	  formatAttributes: formatAttributes,
	  formatDOM: formatDOM,
	  isIE: isIE
	};


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var hyphenPatternRegex = /-([a-z])/g;
	var CUSTOM_PROPERTY_OR_NO_HYPHEN_REGEX = /^--[a-zA-Z0-9-]+$|^[^-]+$/;
	
	/**
	 * Converts a string to camelCase.
	 *
	 * @param  {String} string - The string.
	 * @return {String}
	 */
	function camelCase(string) {
	  if (typeof string !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  // custom property or no hyphen found
	  if (CUSTOM_PROPERTY_OR_NO_HYPHEN_REGEX.test(string)) {
	    return string;
	  }
	
	  // convert to camelCase
	  return string
	    .toLowerCase()
	    .replace(hyphenPatternRegex, function(_, character) {
	      return character.toUpperCase();
	    });
	}
	
	/**
	 * Swap key with value in an object.
	 *
	 * @param  {Object}   obj        - The object.
	 * @param  {Function} [override] - The override method.
	 * @return {Object}              - The inverted object.
	 */
	function invertObject(obj, override) {
	  if (!obj || typeof obj !== 'object') {
	    throw new TypeError('First argument must be an object');
	  }
	
	  var key;
	  var value;
	  var isOverridePresent = typeof override === 'function';
	  var overrides = {};
	  var result = {};
	
	  for (key in obj) {
	    value = obj[key];
	
	    if (isOverridePresent) {
	      overrides = override(key, value);
	      if (overrides && overrides.length === 2) {
	        result[overrides[0]] = overrides[1];
	        continue;
	      }
	    }
	
	    if (typeof value === 'string') {
	      result[value] = key;
	    }
	  }
	
	  return result;
	}
	
	/**
	 * Check if a given tag is a custom component.
	 *
	 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
	 *
	 * @param {string} tagName - The name of the html tag.
	 * @param {Object} props   - The props being passed to the element.
	 * @return {boolean}
	 */
	function isCustomComponent(tagName, props) {
	  if (tagName.indexOf('-') === -1) {
	    return props && typeof props.is === 'string';
	  }
	
	  switch (tagName) {
	    // These are reserved SVG and MathML elements.
	    // We don't mind this whitelist too much because we expect it to never grow.
	    // The alternative is to track the namespace in a few places which is convoluted.
	    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
	    case 'annotation-xml':
	    case 'color-profile':
	    case 'font-face':
	    case 'font-face-src':
	    case 'font-face-uri':
	    case 'font-face-format':
	    case 'font-face-name':
	    case 'missing-glyph':
	      return false;
	    default:
	      return true;
	  }
	}
	
	/**
	 * @constant {Boolean}
	 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
	 */
	var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;
	
	module.exports = {
	  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
	  camelCase: camelCase,
	  invertObject: invertObject,
	  isCustomComponent: isCustomComponent
	};


/***/ },
/* 398 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// -- Utilities ----------------------------------------------------------------
	function getCacheId(inputs) {
	    return JSON.stringify(inputs.map(function (input) {
	        return input && typeof input === 'object' ? orderedProps(input) : input;
	    }));
	}
	function orderedProps(obj) {
	    return Object.keys(obj)
	        .sort()
	        .map(function (k) {
	        var _a;
	        return (_a = {}, _a[k] = obj[k], _a);
	    });
	}
	var memoizeFormatConstructor = function (FormatConstructor, cache) {
	    if (cache === void 0) { cache = {}; }
	    return function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	        if (!format) {
	            format = new ((_a = FormatConstructor).bind.apply(_a, __spreadArrays([void 0], args)))();
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	        return format;
	    };
	};
	exports.default = memoizeFormatConstructor;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var parser_1 = __webpack_require__(251);
	var normalize_1 = __webpack_require__(1248);
	__export(__webpack_require__(252));
	__export(__webpack_require__(251));
	__export(__webpack_require__(1249));
	function parse(input, opts) {
	    var els = parser_1.pegParse(input, opts);
	    if (!opts || opts.normalizeHashtagInPlural !== false) {
	        normalize_1.normalizeHashtagInPlural(els);
	    }
	    return els;
	}
	exports.parse = parse;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var intl_messageformat_parser_1 = __webpack_require__(399);
	var intl_format_cache_1 = __webpack_require__(398);
	var formatters_1 = __webpack_require__(401);
	// -- MessageFormat --------------------------------------------------------
	function mergeConfig(c1, c2) {
	    if (!c2) {
	        return c1;
	    }
	    return __assign(__assign(__assign({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
	        all[k] = __assign(__assign({}, c1[k]), (c2[k] || {}));
	        return all;
	    }, {}));
	}
	function mergeConfigs(defaultConfig, configs) {
	    if (!configs) {
	        return defaultConfig;
	    }
	    return Object.keys(defaultConfig).reduce(function (all, k) {
	        all[k] = mergeConfig(defaultConfig[k], configs[k]);
	        return all;
	    }, __assign({}, defaultConfig));
	}
	function createDefaultFormatters(cache) {
	    if (cache === void 0) { cache = {
	        number: {},
	        dateTime: {},
	        pluralRules: {},
	    }; }
	    return {
	        getNumberFormat: intl_format_cache_1.default(Intl.NumberFormat, cache.number),
	        getDateTimeFormat: intl_format_cache_1.default(Intl.DateTimeFormat, cache.dateTime),
	        getPluralRules: intl_format_cache_1.default(Intl.PluralRules, cache.pluralRules),
	    };
	}
	exports.createDefaultFormatters = createDefaultFormatters;
	var IntlMessageFormat = /** @class */ (function () {
	    function IntlMessageFormat(message, locales, overrideFormats, opts) {
	        var _this = this;
	        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
	        this.formatterCache = {
	            number: {},
	            dateTime: {},
	            pluralRules: {},
	        };
	        this.format = function (values) {
	            return formatters_1.formatToString(_this.ast, _this.locales, _this.formatters, _this.formats, values, _this.message);
	        };
	        this.formatToParts = function (values) {
	            return formatters_1.formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
	        };
	        this.formatHTMLMessage = function (values) {
	            return formatters_1.formatHTMLMessage(_this.ast, _this.locales, _this.formatters, _this.formats, values, _this.message);
	        };
	        this.resolvedOptions = function () { return ({
	            locale: Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
	        }); };
	        this.getAst = function () { return _this.ast; };
	        if (typeof message === 'string') {
	            this.message = message;
	            if (!IntlMessageFormat.__parse) {
	                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
	            }
	            // Parse string messages into an AST.
	            this.ast = IntlMessageFormat.__parse(message, {
	                normalizeHashtagInPlural: false,
	            });
	        }
	        else {
	            this.ast = message;
	        }
	        if (!Array.isArray(this.ast)) {
	            throw new TypeError('A message must be provided as a String or AST.');
	        }
	        // Creates a new object with the specified `formats` merged with the default
	        // formats.
	        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
	        // Defined first because it's used to build the format pattern.
	        this.locales = locales;
	        this.formatters =
	            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
	    }
	    IntlMessageFormat.defaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
	    IntlMessageFormat.__parse = intl_messageformat_parser_1.parse;
	    // Default format options used as the prototype of the `formats` provided to the
	    // constructor. These are used when constructing the internal Intl.NumberFormat
	    // and Intl.DateTimeFormat instances.
	    IntlMessageFormat.formats = {
	        number: {
	            currency: {
	                style: 'currency',
	            },
	            percent: {
	                style: 'percent',
	            },
	        },
	        date: {
	            short: {
	                month: 'numeric',
	                day: 'numeric',
	                year: '2-digit',
	            },
	            medium: {
	                month: 'short',
	                day: 'numeric',
	                year: 'numeric',
	            },
	            long: {
	                month: 'long',
	                day: 'numeric',
	                year: 'numeric',
	            },
	            full: {
	                weekday: 'long',
	                month: 'long',
	                day: 'numeric',
	                year: 'numeric',
	            },
	        },
	        time: {
	            short: {
	                hour: 'numeric',
	                minute: 'numeric',
	            },
	            medium: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	            },
	            long: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	                timeZoneName: 'short',
	            },
	            full: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	                timeZoneName: 'short',
	            },
	        },
	    };
	    return IntlMessageFormat;
	}());
	exports.IntlMessageFormat = IntlMessageFormat;
	exports.default = IntlMessageFormat;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var intl_messageformat_parser_1 = __webpack_require__(399);
	var FormatError = /** @class */ (function (_super) {
	    __extends(FormatError, _super);
	    function FormatError(msg, variableId) {
	        var _this = _super.call(this, msg) || this;
	        _this.variableId = variableId;
	        return _this;
	    }
	    return FormatError;
	}(Error));
	function mergeLiteral(parts) {
	    if (parts.length < 2) {
	        return parts;
	    }
	    return parts.reduce(function (all, part) {
	        var lastPart = all[all.length - 1];
	        if (!lastPart ||
	            lastPart.type !== 0 /* literal */ ||
	            part.type !== 0 /* literal */) {
	            all.push(part);
	        }
	        else {
	            lastPart.value += part.value;
	        }
	        return all;
	    }, []);
	}
	// TODO(skeleton): add skeleton support
	function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
	// For debugging
	originalMessage) {
	    // Hot path for straight simple msg translations
	    if (els.length === 1 && intl_messageformat_parser_1.isLiteralElement(els[0])) {
	        return [
	            {
	                type: 0 /* literal */,
	                value: els[0].value,
	            },
	        ];
	    }
	    var result = [];
	    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
	        var el = els_1[_i];
	        // Exit early for string parts.
	        if (intl_messageformat_parser_1.isLiteralElement(el)) {
	            result.push({
	                type: 0 /* literal */,
	                value: el.value,
	            });
	            continue;
	        }
	        // TODO: should this part be literal type?
	        // Replace `#` in plural rules with the actual numeric value.
	        if (intl_messageformat_parser_1.isPoundElement(el)) {
	            if (typeof currentPluralValue === 'number') {
	                result.push({
	                    type: 0 /* literal */,
	                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
	                });
	            }
	            continue;
	        }
	        var varName = el.value;
	        // Enforce that all required values are provided by the caller.
	        if (!(values && varName in values)) {
	            throw new FormatError("The intl string context variable \"" + varName + "\" was not provided to the string \"" + originalMessage + "\"");
	        }
	        var value = values[varName];
	        if (intl_messageformat_parser_1.isArgumentElement(el)) {
	            if (!value || typeof value === 'string' || typeof value === 'number') {
	                value =
	                    typeof value === 'string' || typeof value === 'number'
	                        ? String(value)
	                        : '';
	            }
	            result.push({
	                type: 1 /* argument */,
	                value: value,
	            });
	            continue;
	        }
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (intl_messageformat_parser_1.isDateElement(el)) {
	            var style = typeof el.style === 'string' ? formats.date[el.style] : undefined;
	            result.push({
	                type: 0 /* literal */,
	                value: formatters
	                    .getDateTimeFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if (intl_messageformat_parser_1.isTimeElement(el)) {
	            var style = typeof el.style === 'string'
	                ? formats.time[el.style]
	                : intl_messageformat_parser_1.isDateTimeSkeleton(el.style)
	                    ? intl_messageformat_parser_1.parseDateTimeSkeleton(el.style.pattern)
	                    : undefined;
	            result.push({
	                type: 0 /* literal */,
	                value: formatters
	                    .getDateTimeFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if (intl_messageformat_parser_1.isNumberElement(el)) {
	            var style = typeof el.style === 'string'
	                ? formats.number[el.style]
	                : intl_messageformat_parser_1.isNumberSkeleton(el.style)
	                    ? intl_messageformat_parser_1.convertNumberSkeletonToNumberFormatOptions(el.style.tokens)
	                    : undefined;
	            result.push({
	                type: 0 /* literal */,
	                value: formatters
	                    .getNumberFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if (intl_messageformat_parser_1.isSelectElement(el)) {
	            var opt = el.options[value] || el.options.other;
	            if (!opt) {
	                throw new RangeError("Invalid values for \"" + el.value + "\": \"" + value + "\". Options are \"" + Object.keys(el.options).join('", "') + "\"");
	            }
	            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
	            continue;
	        }
	        if (intl_messageformat_parser_1.isPluralElement(el)) {
	            var opt = el.options["=" + value];
	            if (!opt) {
	                if (!Intl.PluralRules) {
	                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n");
	                }
	                var rule = formatters
	                    .getPluralRules(locales, { type: el.pluralType })
	                    .select(value - (el.offset || 0));
	                opt = el.options[rule] || el.options.other;
	            }
	            if (!opt) {
	                throw new RangeError("Invalid values for \"" + el.value + "\": \"" + value + "\". Options are \"" + Object.keys(el.options).join('", "') + "\"");
	            }
	            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
	            continue;
	        }
	    }
	    return mergeLiteral(result);
	}
	exports.formatToParts = formatToParts;
	function formatToString(els, locales, formatters, formats, values, 
	// For debugging
	originalMessage) {
	    var parts = formatToParts(els, locales, formatters, formats, values, undefined, originalMessage);
	    // Hot path for straight simple msg translations
	    if (parts.length === 1) {
	        return parts[0].value;
	    }
	    return parts.reduce(function (all, part) { return (all += part.value); }, '');
	}
	exports.formatToString = formatToString;
	// Singleton
	var domParser;
	var TOKEN_DELIMITER = '@@';
	var TOKEN_REGEX = /@@(\d+_\d+)@@/g;
	var counter = 0;
	function generateId() {
	    return Date.now() + "_" + ++counter;
	}
	function restoreRichPlaceholderMessage(text, objectParts) {
	    return text
	        .split(TOKEN_REGEX)
	        .filter(Boolean)
	        .map(function (c) { return (objectParts[c] != null ? objectParts[c] : c); })
	        .reduce(function (all, c) {
	        if (!all.length) {
	            all.push(c);
	        }
	        else if (typeof c === 'string' &&
	            typeof all[all.length - 1] === 'string') {
	            all[all.length - 1] += c;
	        }
	        else {
	            all.push(c);
	        }
	        return all;
	    }, []);
	}
	/**
	 * Not exhaustive, just for sanity check
	 */
	var SIMPLE_XML_REGEX = /(<([0-9a-zA-Z-_]*?)>(.*?)<\/([0-9a-zA-Z-_]*?)>)|(<[0-9a-zA-Z-_]*?\/>)/;
	var TEMPLATE_ID = Date.now() + '@@';
	var VOID_ELEMENTS = [
	    'area',
	    'base',
	    'br',
	    'col',
	    'embed',
	    'hr',
	    'img',
	    'input',
	    'link',
	    'meta',
	    'param',
	    'source',
	    'track',
	    'wbr',
	];
	function formatHTMLElement(el, objectParts, values) {
	    var tagName = el.tagName;
	    var outerHTML = el.outerHTML, textContent = el.textContent, childNodes = el.childNodes;
	    // Regular text
	    if (!tagName) {
	        return restoreRichPlaceholderMessage(textContent || '', objectParts);
	    }
	    tagName = tagName.toLowerCase();
	    var isVoidElement = ~VOID_ELEMENTS.indexOf(tagName);
	    var formatFnOrValue = values[tagName];
	    if (formatFnOrValue && isVoidElement) {
	        throw new FormatError(tagName + " is a self-closing tag and can not be used, please use another tag name.");
	    }
	    if (!childNodes.length) {
	        return [outerHTML];
	    }
	    var chunks = Array.prototype.slice.call(childNodes).reduce(function (all, child) {
	        return all.concat(formatHTMLElement(child, objectParts, values));
	    }, []);
	    // Legacy HTML
	    if (!formatFnOrValue) {
	        return __spreadArrays(["<" + tagName + ">"], chunks, ["</" + tagName + ">"]);
	    }
	    // HTML Tag replacement
	    if (typeof formatFnOrValue === 'function') {
	        return [formatFnOrValue.apply(void 0, chunks)];
	    }
	    return [formatFnOrValue];
	}
	function formatHTMLMessage(els, locales, formatters, formats, values, 
	// For debugging
	originalMessage) {
	    var parts = formatToParts(els, locales, formatters, formats, values, undefined, originalMessage);
	    var objectParts = {};
	    var formattedMessage = parts.reduce(function (all, part) {
	        if (part.type === 0 /* literal */) {
	            return (all += part.value);
	        }
	        var id = generateId();
	        objectParts[id] = part.value;
	        return (all += "" + TOKEN_DELIMITER + id + TOKEN_DELIMITER);
	    }, '');
	    // Not designed to filter out aggressively
	    if (!SIMPLE_XML_REGEX.test(formattedMessage)) {
	        return restoreRichPlaceholderMessage(formattedMessage, objectParts);
	    }
	    if (!values) {
	        throw new FormatError('Message has placeholders but no values was given');
	    }
	    if (typeof DOMParser === 'undefined') {
	        throw new FormatError('Cannot format XML message without DOMParser');
	    }
	    if (!domParser) {
	        domParser = new DOMParser();
	    }
	    var content = domParser
	        .parseFromString("<formatted-message id=\"" + TEMPLATE_ID + "\">" + formattedMessage + "</formatted-message>", 'text/html')
	        .getElementById(TEMPLATE_ID);
	    if (!content) {
	        throw new FormatError("Malformed HTML message " + formattedMessage);
	    }
	    var tagsToFormat = Object.keys(values).filter(function (varName) { return !!content.getElementsByTagName(varName).length; });
	    // No tags to format
	    if (!tagsToFormat.length) {
	        return restoreRichPlaceholderMessage(formattedMessage, objectParts);
	    }
	    var caseSensitiveTags = tagsToFormat.filter(function (tagName) { return tagName !== tagName.toLowerCase(); });
	    if (caseSensitiveTags.length) {
	        throw new FormatError("HTML tag must be lowercased but the following tags are not: " + caseSensitiveTags.join(', '));
	    }
	    // We're doing this since top node is `<formatted-message/>` which does not have a formatter
	    return Array.prototype.slice
	        .call(content.childNodes)
	        .reduce(function (all, child) { return all.concat(formatHTMLElement(child, objectParts, values)); }, []);
	}
	exports.formatHTMLMessage = formatHTMLMessage;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(400);
	__export(__webpack_require__(401));
	__export(__webpack_require__(400));
	exports.default = core_1.default;


/***/ },
/* 403 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1262);
	module.exports = later;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(98),
	    root = __webpack_require__(65);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(177),
	    stackClear = __webpack_require__(1354),
	    stackDelete = __webpack_require__(1355),
	    stackGet = __webpack_require__(1356),
	    stackHas = __webpack_require__(1357),
	    stackSet = __webpack_require__(1358);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(98),
	    root = __webpack_require__(65);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(415);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 409 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1297),
	    isArguments = __webpack_require__(191),
	    isArray = __webpack_require__(36),
	    isBuffer = __webpack_require__(270),
	    isIndex = __webpack_require__(186),
	    isTypedArray = __webpack_require__(272);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 411 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(47);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 413 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(259),
	    isArray = __webpack_require__(36);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(413),
	    baseIsNaN = __webpack_require__(1279),
	    strictIndexOf = __webpack_require__(1359);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(188),
	    nativeKeys = __webpack_require__(1346);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(180),
	    isArrayLike = __webpack_require__(66);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(262),
	    baseSet = __webpack_require__(1291),
	    castPath = __webpack_require__(184);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(76);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(98);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(258),
	    arraySome = __webpack_require__(411),
	    cacheHas = __webpack_require__(266);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(150),
	    overRest = __webpack_require__(433),
	    setToString = __webpack_require__(434);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 423 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(1345),
	    noop = __webpack_require__(448);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(1349);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(432);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1270),
	    stubArray = __webpack_require__(449);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(47);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 429 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 430 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(423);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ },
/* 432 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1267);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1292),
	    shortOut = __webpack_require__(1353);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 435 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 436 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(438);


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(1269),
	    baseEach = __webpack_require__(180),
	    castFunction = __webpack_require__(419),
	    isArray = __webpack_require__(36);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1274),
	    hasPath = __webpack_require__(1324);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(66),
	    isObjectLike = __webpack_require__(58);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(442);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(74),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(1281),
	    baseUnary = __webpack_require__(183),
	    nodeUtil = __webpack_require__(431);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(74),
	    isArray = __webpack_require__(36),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 445 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(410),
	    baseKeysIn = __webpack_require__(1283),
	    isArrayLike = __webpack_require__(66);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(179),
	    baseForOwn = __webpack_require__(181),
	    baseIteratee = __webpack_require__(75);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 448 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 449 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(275);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(450);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1299);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(75),
	    baseUniq = __webpack_require__(265);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ },
/* 454 */
/***/ function(module, exports) {

	'use strict';
	
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (newInputs[i] !== lastInputs[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var React=__webpack_require__(1),_inheritsLoose=__webpack_require__(156),PropTypes=__webpack_require__(5),warning=__webpack_require__(88);function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var _inheritsLoose__default=/*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);var PropTypes__default=/*#__PURE__*/_interopDefaultLegacy(PropTypes);var warning__default=/*#__PURE__*/_interopDefaultLegacy(warning);var MAX_SIGNED_31_BIT_INT = 1073741823;
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
	
	function getUniqueId() {
	  var key = '__global_unique_id__';
	  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
	}
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + getUniqueId() + '__';
	
	  var Provider = /*#__PURE__*/function (_Component) {
	    _inheritsLoose__default['default'](Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning__default['default']((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes__default['default'].object.isRequired, _Provider$childContex);
	
	  var Consumer = /*#__PURE__*/function (_Component2) {
	    _inheritsLoose__default['default'](Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes__default['default'].object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default['default'].createContext || createReactContext;module.exports=index;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '1',
	            '2': '2',
	            '3': '3',
	            '4': '4',
	            '5': '5',
	            '6': '6',
	            '7': '7',
	            '8': '8',
	            '9': '9',
	            '0': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'birneçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '১',
	            '2': '২',
	            '3': '৩',
	            '4': '৪',
	            '5': '৫',
	            '6': '৬',
	            '7': '৭',
	            '8': '৮',
	            '9': '৯',
	            '0': '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '༡',
	            '2': '༢',
	            '3': '༣',
	            '4': '༤',
	            '5': '༥',
	            '6': '༦',
	            '7': '༧',
	            '8': '༨',
	            '9': '༩',
	            '0': '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha invalida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '۱',
	            '2': '۲',
	            '3': '۳',
	            '4': '۴',
	            '5': '۵',
	            '6': '۶',
	            '7': '۷',
	            '8': '۸',
	            '9': '۹',
	            '0': '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split(
	            '_'
	        ),
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '១',
	            '2': '២',
	            '3': '៣',
	            '4': '៤',
	            '5': '៥',
	            '6': '៦',
	            '7': '៧',
	            '8': '៨',
	            '9': '៩',
	            '0': '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '೧',
	            '2': '೨',
	            '3': '೩',
	            '4': '೪',
	            '5': '೫',
	            '6': '೬',
	            '7': '೭',
	            '8': '೮',
	            '9': '೯',
	            '0': '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '၁',
	            '2': '၂',
	            '3': '၃',
	            '4': '၄',
	            '5': '၅',
	            '6': '၆',
	            '7': '၇',
	            '8': '၈',
	            '9': '၉',
	            '0': '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '੧',
	            '2': '੨',
	            '3': '੩',
	            '4': '੪',
	            '5': '੫',
	            '6': '੬',
	            '7': '੭',
	            '8': '੮',
	            '9': '੯',
	            '0': '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        );
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return (
	                    '(' +
	                    monthsSubjective[momentToFormat.month()] +
	                    '|' +
	                    monthsNominative[momentToFormat.month()] +
	                    ')'
	                );
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '௧',
	            '2': '௨',
	            '3': '௩',
	            '4': '௪',
	            '5': '௫',
	            '6': '௬',
	            '7': '௭',
	            '8': '௮',
	            '9': '௯',
	            '0': '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Пагоҳ соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js language configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pascalCase = exports.pascalCaseTransformMerge = exports.pascalCaseTransform = void 0;
	var tslib_1 = __webpack_require__(1389);
	var no_case_1 = __webpack_require__(120);
	function pascalCaseTransform(input, index) {
	    var firstChar = input.charAt(0);
	    var lowerChars = input.substr(1).toLowerCase();
	    if (index > 0 && firstChar >= "0" && firstChar <= "9") {
	        return "_" + firstChar + lowerChars;
	    }
	    return "" + firstChar.toUpperCase() + lowerChars;
	}
	exports.pascalCaseTransform = pascalCaseTransform;
	function pascalCaseTransformMerge(input) {
	    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
	}
	exports.pascalCaseTransformMerge = pascalCaseTransformMerge;
	function pascalCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return no_case_1.noCase(input, tslib_1.__assign({ delimiter: "", transform: pascalCaseTransform }, options));
	}
	exports.pascalCase = pascalCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(1252)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 590 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var utils_1 = __webpack_require__(50);
	var injectIntl_1 = __webpack_require__(84);
	var DisplayName;
	(function (DisplayName) {
	    DisplayName["formatDate"] = "FormattedDate";
	    DisplayName["formatTime"] = "FormattedTime";
	    DisplayName["formatNumber"] = "FormattedNumber";
	    DisplayName["formatList"] = "FormattedList";
	})(DisplayName || (DisplayName = {}));
	var DisplayNameParts;
	(function (DisplayNameParts) {
	    DisplayNameParts["formatDate"] = "FormattedDateParts";
	    DisplayNameParts["formatTime"] = "FormattedTimeParts";
	    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
	    DisplayNameParts["formatList"] = "FormattedListParts";
	})(DisplayNameParts || (DisplayNameParts = {}));
	exports.FormattedNumberParts = function (props) { return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	    utils_1.invariantIntlContext(intl);
	    var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
	    return children(intl.formatNumberToParts(value, formatProps));
	})); };
	exports.FormattedNumberParts.displayName = 'FormattedNumberParts';
	function createFormattedDateTimePartsComponent(name) {
	    var ComponentParts = function (props) { return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	        utils_1.invariantIntlContext(intl);
	        var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
	        var date = typeof value === 'string' ? new Date(value || 0) : value;
	        var formattedParts = name === 'formatDate'
	            ? intl.formatDateToParts(date, formatProps)
	            : intl.formatTimeToParts(date, formatProps);
	        return children(formattedParts);
	    })); };
	    ComponentParts.displayName = DisplayNameParts[name];
	    return ComponentParts;
	}
	exports.createFormattedDateTimePartsComponent = createFormattedDateTimePartsComponent;
	function createFormattedComponent(name) {
	    var Component = function (props) { return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	        utils_1.invariantIntlContext(intl);
	        var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
	        // TODO: fix TS type definition for localeMatcher upstream
	        var formattedValue = intl[name](value, formatProps);
	        if (typeof children === 'function') {
	            return children(formattedValue);
	        }
	        var Text = intl.textComponent || React.Fragment;
	        return React.createElement(Text, null, formattedValue);
	    })); };
	    Component.displayName = DisplayName[name];
	    return Component;
	}
	exports.createFormattedComponent = createFormattedComponent;


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(84);
	var message_1 = __webpack_require__(593);
	var utils_1 = __webpack_require__(50);
	var shallowEquals_ = __webpack_require__(648);
	var shallowEquals = shallowEquals_.default || shallowEquals_;
	var defaultFormatMessage = function (descriptor, values) {
	    if (false) {
	        console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
	    }
	    return message_1.formatMessage(__assign(__assign({}, utils_1.DEFAULT_INTL_CONFIG), { locale: 'en' }), utils_1.createFormatters(), descriptor, values);
	};
	var FormattedMessage = /** @class */ (function (_super) {
	    __extends(FormattedMessage, _super);
	    function FormattedMessage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FormattedMessage.prototype.shouldComponentUpdate = function (nextProps) {
	        var _a = this.props, values = _a.values, otherProps = __rest(_a, ["values"]);
	        var nextValues = nextProps.values, nextOtherProps = __rest(nextProps, ["values"]);
	        return (!shallowEquals(nextValues, values) ||
	            !shallowEquals(otherProps, nextOtherProps));
	    };
	    FormattedMessage.prototype.render = function () {
	        var _this = this;
	        return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	            if (!_this.props.defaultMessage) {
	                utils_1.invariantIntlContext(intl);
	            }
	            var _a = intl || {}, _b = _a.formatMessage, formatMessage = _b === void 0 ? defaultFormatMessage : _b, _c = _a.textComponent, Text = _c === void 0 ? React.Fragment : _c;
	            var _d = _this.props, id = _d.id, description = _d.description, defaultMessage = _d.defaultMessage, values = _d.values, children = _d.children, _e = _d.tagName, Component = _e === void 0 ? Text : _e;
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var nodes = formatMessage(descriptor, values);
	            if (!Array.isArray(nodes)) {
	                nodes = [nodes];
	            }
	            if (typeof children === 'function') {
	                return children.apply(void 0, nodes);
	            }
	            if (Component) {
	                // Needs to use `createElement()` instead of JSX, otherwise React will
	                // warn about a missing `key` prop with rich-text message formatting.
	                return React.createElement.apply(React, __spreadArrays([Component, null], nodes));
	            }
	            return nodes;
	        }));
	    };
	    FormattedMessage.displayName = 'FormattedMessage';
	    FormattedMessage.defaultProps = {
	        values: {},
	    };
	    return FormattedMessage;
	}(React.Component));
	exports.default = FormattedMessage;


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var intl_utils_1 = __webpack_require__(218);
	var utils_1 = __webpack_require__(50);
	var intl_messageformat_1 = __webpack_require__(402);
	function setTimeZoneInOptions(opts, timeZone) {
	    return Object.keys(opts).reduce(function (all, k) {
	        all[k] = __assign({ timeZone: timeZone }, opts[k]);
	        return all;
	    }, {});
	}
	function deepMergeOptions(opts1, opts2) {
	    var keys = Object.keys(__assign(__assign({}, opts1), opts2));
	    return keys.reduce(function (all, k) {
	        all[k] = __assign(__assign({}, (opts1[k] || {})), (opts2[k] || {}));
	        return all;
	    }, {});
	}
	function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
	    if (!timeZone) {
	        return f1;
	    }
	    var mfFormats = intl_messageformat_1.default.formats;
	    return __assign(__assign(__assign({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
	}
	exports.prepareIntlMessageFormatHtmlOutput = function (chunks) { return React.createElement.apply(React, __spreadArrays([React.Fragment, null], chunks)); };
	function formatMessage(_a, state, messageDescriptor, values) {
	    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, onError = _a.onError, timeZone = _a.timeZone;
	    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
	    if (values === void 0) { values = {}; }
	    var id = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
	    // `id` is a required field of a Message Descriptor.
	    intl_utils_1.invariant(!!id, '[React Intl] An `id` must be provided to format a message.');
	    var message = messages && messages[String(id)];
	    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
	    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
	    var formattedMessageParts = [];
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats, {
	                formatters: state,
	            });
	            formattedMessageParts = formatter.formatHTMLMessage(values);
	        }
	        catch (e) {
	            onError(utils_1.createError("Error formatting message: \"" + id + "\" for locale: \"" + locale + "\"" +
	                (defaultMessage ? ', using default message as fallback.' : ''), e));
	        }
	    }
	    else {
	        // This prevents warnings from littering the console in development
	        // when no `messages` are passed into the <IntlProvider> for the
	        // default locale, and a default message is in the source.
	        if (!defaultMessage ||
	            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
	            onError(utils_1.createError("Missing message: \"" + id + "\" for locale: \"" + locale + "\"" +
	                (defaultMessage ? ', using default message as fallback.' : '')));
	        }
	    }
	    if (!formattedMessageParts.length && defaultMessage) {
	        try {
	            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	            formattedMessageParts = formatter.formatHTMLMessage(values);
	        }
	        catch (e) {
	            onError(utils_1.createError("Error formatting the default message for: \"" + id + "\"", e));
	        }
	    }
	    if (!formattedMessageParts.length) {
	        onError(utils_1.createError("Cannot format message: \"" + id + "\", " +
	            ("using message " + (message || defaultMessage ? 'source' : 'id') + " as fallback.")));
	        if (typeof message === 'string') {
	            return message || defaultMessage || String(id);
	        }
	        return defaultMessage || String(id);
	    }
	    if (formattedMessageParts.length === 1 &&
	        typeof formattedMessageParts[0] === 'string') {
	        return formattedMessageParts[0] || defaultMessage || String(id);
	    }
	    return exports.prepareIntlMessageFormatHtmlOutput(formattedMessageParts);
	}
	exports.formatMessage = formatMessage;
	function formatHTMLMessage(config, state, messageDescriptor, rawValues) {
	    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
	    if (rawValues === void 0) { rawValues = {}; }
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? utils_1.escape(value) : value;
	        return escaped;
	    }, {});
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	exports.formatHTMLMessage = formatHTMLMessage;


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(90));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(82));
	
	var _invariant = _interopRequireDefault(__webpack_require__(253));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(278));
	
	var _Context = __webpack_require__(101);
	
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	}; // React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect because we want
	// `connect` to perform sync updates to a ref to save the latest props after
	// a render is actually committed to the DOM.
	
	
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
	  (0, _invariant["default"])(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	  (0, _invariant["default"])(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
	  var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	  (0, _invariant["default"])(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      (0, _invariant["default"])((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var forwardedRef = props.forwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["forwardedRef"]);
	        return [props.context, forwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          forwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)(_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context
	
	      var didStoreComeFromProps = Boolean(props.store);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	      (0, _invariant["default"])(didStoreComeFromProps || didStoreComeFromContext, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      var store = props.store || contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var subscription = new _Subscription["default"](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffect(function () {
	        // We want to capture the wrapper props and child props we used for later comparisons
	        lastWrapperProps.current = wrapperProps;
	        lastChildProps.current = actualChildProps;
	        renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	        if (childPropsFromStoreUpdate.current) {
	          childPropsFromStoreUpdate.current = null;
	          notifyNestedSubs();
	        }
	      }); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffect(function () {
	        // If we're not subscribed to the store, nothing to do here
	        if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	        var didUnsubscribe = false;
	        var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	        var checkForUpdates = function checkForUpdates() {
	          if (didUnsubscribe) {
	            // Don't run stale listeners.
	            // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	            return;
	          }
	
	          var latestStoreState = store.getState();
	          var newChildProps, error;
	
	          try {
	            // Actually run the selector with the most recent store state and wrapper props
	            // to determine what the child props should be
	            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	          } catch (e) {
	            error = e;
	            lastThrownError = e;
	          }
	
	          if (!error) {
	            lastThrownError = null;
	          } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	          if (newChildProps === lastChildProps.current) {
	            if (!renderIsScheduled.current) {
	              notifyNestedSubs();
	            }
	          } else {
	            // Save references to the new child props.  Note that we track the "child props from store update"
	            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	            // forcing another re-render, which we don't want.
	            lastChildProps.current = newChildProps;
	            childPropsFromStoreUpdate.current = newChildProps;
	            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	            forceComponentUpdateDispatch({
	              type: 'STORE_UPDATED',
	              payload: {
	                latestStoreState: latestStoreState,
	                error: error
	              }
	            });
	          }
	        }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	        subscription.onStateChange = checkForUpdates;
	        subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	        // changed since we began.
	
	        checkForUpdates();
	
	        var unsubscribeWrapper = function unsubscribeWrapper() {
	          didUnsubscribe = true;
	          subscription.tryUnsubscribe();
	          subscription.onStateChange = null;
	
	          if (lastThrownError) {
	            // It's possible that we caught an error due to a bad mapState function, but the
	            // parent re-rendered without this component and we're about to unmount.
	            // This shouldn't happen as long as we do top-down subscriptions correctly, but
	            // if we ever do those wrong, this throw will surface the error in our tests.
	            // In that case, throw the error from here so it doesn't get lost.
	            throw lastThrownError;
	          }
	        };
	
	        return unsubscribeWrapper;
	      }, [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: forwardedRef
	        }));
	      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return _react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return _react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          forwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(600));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(1);
	
	var _invariant = _interopRequireDefault(__webpack_require__(253));
	
	var _Context = __webpack_require__(101);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	  (0, _invariant["default"])(contextValue, 'could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  return contextValue;
	}

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(101);
	
	var _useReduxContext2 = __webpack_require__(596);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = createStoreHook();
	exports.useStore = useStore;

/***/ },
/* 598 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getBatch = exports.setBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ },
/* 599 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(1432));
	
	var _warning = _interopRequireDefault(__webpack_require__(601));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 601 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 602 */
[1913, 1439],
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveTagsAssociation = exports.saveApiAccessStatus = exports.savePermissions = exports.saveApiPolicyEntities = exports.fetchApiPolicyEntities = exports.saveApiCustomFields = exports.fetchApiCustomFields = exports.publishApi = exports.updateApiDetailsWithAssets = exports.updateApiDetails = exports.updateApi = exports.saveApi = exports.saveAssets = exports.fetchUsage = exports.fetchAssets = exports.fetchCustomFields = exports.fetchSelectedManageOrg = exports.checkProxyUrlUnique = exports.fetchPolicyTemplates = exports.checkApiNameUnique = exports.fetchApiEulas = exports.fetchApiPermitted = exports.createTags = exports.fetchSwaggerFile = exports.fetchAPITags = exports.fetchAllTags = exports.fetchApi = exports.setRedirectApiTab = exports.fetchSelectedOrganizations = exports.fetchAllOrganizations = exports.fetchOrganizations = exports.fetchSelectedUsers = exports.fetchAvailableUsers = exports.showLoading = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _portalConfig = __webpack_require__(26);
	
	var _api = __webpack_require__(202);
	
	var _requestParser = __webpack_require__(1449);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var showLoading = exports.showLoading = function showLoading(isLoading) {
	  return function (dispatch) {
	    return dispatch({
	      type: constants.APP_LOADING,
	      isLoading: isLoading
	    });
	  };
	};
	
	var initApi = function initApi(dispatch) {
	  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return dispatch({
	    type: constants.APP_LOADING,
	    isLoading: isLoading
	  });
	};
	
	var fetchAvailableUsers = exports.fetchAvailableUsers = function fetchAvailableUsers(apiUuid) {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/0.1/permissions/apis/' + apiUuid + '/available-users';
	              _context.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_PERMISSION_AVAILABLE_USER_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x2, _x3) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchSelectedUsers = exports.fetchSelectedUsers = function fetchSelectedUsers(apiUuid) {
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/api-management/internal/permissions/apis/' + apiUuid + '/selected-users';
	              _context2.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_PERMISSION_SELECTED_USER_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchOrganizations = exports.fetchOrganizations = function fetchOrganizations(size, pageNumber) {
	  return function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/internal/organizations?status=ENABLED&size=' + size + '&page=' + pageNumber;
	              _context3.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_PERMISSION_ORGANIZATIONS_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAllOrganizations = exports.fetchAllOrganizations = function fetchAllOrganizations() {
	  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  return function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/internal/organizations?status=ENABLED&size=' + size + '&page=' + pageNumber;
	              _context4.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x10, _x11) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchSelectedOrganizations = exports.fetchSelectedOrganizations = function fetchSelectedOrganizations(apiUuid) {
	  return function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/api-management/internal/apis/' + apiUuid + '/selected-organizations';
	              _context5.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x12, _x13) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	};
	
	var setRedirectApiTab = exports.setRedirectApiTab = function setRedirectApiTab() {
	  return function (dispatch) {
	    return dispatch({
	      type: constants.API_PERMISSION_REDIRECT_API_TAB
	    });
	  };
	};
	
	var fetchApi = exports.fetchApi = function fetchApi(apiUuid) {
	  return function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid;
	              _context6.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined);
	    }));
	
	    return function (_x14, _x15) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAllTags = exports.fetchAllTags = function fetchAllTags() {
	  return function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tags';
	
	
	              dispatch({
	                type: constants.API_TAGS_ALL_TAGS_REQUEST,
	                isLoading: false
	              });
	              _context7.next = 6;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_TAGS_ALL_TAGS_SUCCESS,
	                  payload: response
	                });
	              }).catch(function (error) {
	                return (// todo: check errors
	                  dispatch({
	                    type: constants.API_ERROR,
	                    payload: (0, _utils.getValidationErrors)(error)
	                  })
	                );
	              });
	
	            case 6:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined);
	    }));
	
	    return function (_x16, _x17) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAPITags = exports.fetchAPITags = function fetchAPITags(apiUuid) {
	  return function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/tags';
	
	              dispatch({
	                type: constants.API_TAGS_API_TAGS_REQUEST
	              });
	              _context8.next = 6;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_TAGS_API_TAGS_SUCCESS,
	                  payload: response
	                });
	              }).catch(function (error) {
	                return (// todo: check errors
	                  dispatch({
	                    type: constants.API_ERROR,
	                    payload: (0, _utils.getValidationErrors)(error)
	                  })
	                );
	              });
	
	            case 6:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined);
	    }));
	
	    return function (_x18, _x19) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchSwaggerFile = exports.fetchSwaggerFile = function fetchSwaggerFile(uuid) {
	  return function () {
	    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/2.0/Apis(\'' + uuid + '\')/SpecContent';
	              _context9.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_SWAGGER_SUCCESS,
	                  payload: response
	                });
	              }).catch(function (error) {
	                return (// todo: check errors
	                  dispatch({
	                    type: constants.API_ERROR,
	                    payload: (0, _utils.getValidationErrors)(error)
	                  })
	                );
	              });
	
	            case 5:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, undefined);
	    }));
	
	    return function (_x20, _x21) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	};
	
	var createTags = exports.createTags = function createTags(data) {
	  return function () {
	    var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tags';
	              _context10.next = 5;
	              return _axios2.default.post(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_TAGS_CREATE_TAGS_SUCCESS,
	                  payload: response
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, undefined);
	    }));
	
	    return function (_x22, _x23) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApiPermitted = exports.fetchApiPermitted = function fetchApiPermitted(apiUuid) {
	  return function () {
	    var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/api-management/internal/permissions/apis/' + apiUuid + '/permitted';
	              _context11.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_PERMISSION_PERMITTED_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_PERMISSION_PERMITTED_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, undefined);
	    }));
	
	    return function (_x24, _x25) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApiEulas = exports.fetchApiEulas = function fetchApiEulas() {
	  return function () {
	    var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/ApiEulas?$select=Uuid,Name&$inlinecount=allpages';
	              _context12.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_EULAS_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, undefined);
	    }));
	
	    return function (_x26, _x27) {
	      return _ref12.apply(this, arguments);
	    };
	  }();
	};
	
	var checkApiNameUnique = exports.checkApiNameUnique = function checkApiNameUnique(apiName, currentId) {
	  return function () {
	    var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/ApiNameUnique()';
	              _context13.next = 5;
	              return _axios2.default.get(url, {
	                params: {
	                  Name: '\'' + apiName + '\'',
	                  CurrentId: '\'' + currentId + '\''
	                }
	              }, {
	                credentials: 'include'
	              }).then(function (response) {
	                dispatch({
	                  type: constants.API_NAME_UNIQUE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, undefined);
	    }));
	
	    return function (_x28, _x29) {
	      return _ref13.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchPolicyTemplates = exports.fetchPolicyTemplates = function fetchPolicyTemplates() {
	  return function () {
	    var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/resourceValues?resources=managedGateways,policyTemplates';
	              _context14.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.POLICY_TEMPLATES_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, undefined);
	    }));
	
	    return function (_x30, _x31) {
	      return _ref14.apply(this, arguments);
	    };
	  }();
	};
	
	var checkProxyUrlUnique = exports.checkProxyUrlUnique = function checkProxyUrlUnique(name) {
	  return function () {
	    var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/ProxyUrlUnique()?ProxyUrl=\'' + name + '\'';
	              _context15.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_PROXY_URL_UNIQUE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, undefined);
	    }));
	
	    return function (_x32, _x33) {
	      return _ref15.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchSelectedManageOrg = exports.fetchSelectedManageOrg = function fetchSelectedManageOrg(Uuid) {
	  return function () {
	    var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/tenant-admin/1.0/organizations/' + Uuid;
	              _context16.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, undefined);
	    }));
	
	    return function (_x34, _x35) {
	      return _ref16.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchCustomFields = exports.fetchCustomFields = function fetchCustomFields() {
	  var entityName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'API';
	  return function () {
	    var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee17$(_context17) {
	        while (1) {
	          switch (_context17.prev = _context17.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/Portal.svc/CustomFields?%24inlinecount=allpages&%24filter=EntityType+eq+%27' + entityName + '%27+and+Status+eq+%27ENABLED%27';
	              _context17.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.CUSTOM_FIELDS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context17.stop();
	          }
	        }
	      }, _callee17, undefined);
	    }));
	
	    return function (_x37, _x38) {
	      return _ref17.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchAssets = exports.fetchAssets = function fetchAssets(apiUuid) {
	  return function () {
	    var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee18$(_context18) {
	        while (1) {
	          switch (_context18.prev = _context18.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/assets';
	              _context18.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_ASSETS_GET_SUCCESS,
	                  isLoading: false,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context18.stop();
	          }
	        }
	      }, _callee18, undefined);
	    }));
	
	    return function (_x39, _x40) {
	      return _ref18.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchUsage = exports.fetchUsage = function fetchUsage(apiUuid) {
	  return function () {
	    var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee19$(_context19) {
	        while (1) {
	          switch (_context19.prev = _context19.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/usage';
	              _context19.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_USAGE_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context19.stop();
	          }
	        }
	      }, _callee19, undefined);
	    }));
	
	    return function (_x41, _x42) {
	      return _ref19.apply(this, arguments);
	    };
	  }();
	};
	
	var saveAssets = exports.saveAssets = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(apiDetails, uploadedAssets, portal, dispatch, isUploadFile, filesToDelete) {
	    var formData, url;
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            formData = new FormData();
	
	            if (isUploadFile) {
	              (0, _lodash.forEach)(uploadedAssets, function (_ref21) {
	                var blob = _ref21.blob,
	                    name = _ref21.name;
	
	                if (blob) {
	                  formData.append('files', blob, name);
	                }
	              });
	            }
	
	            if (filesToDelete.length > 0) {
	              (0, _lodash.forEach)(filesToDelete, function (uuid) {
	                formData.append('filesToDelete', uuid);
	              });
	            }
	            url = portal.hostname + '/admin/api-management/internal/apis/' + apiDetails.uuid + '/assets';
	            _context20.next = 6;
	            return _axios2.default.post(url, formData, { credentials: 'include' }).then(function (response) {
	              var data = apiDetails;
	              if (isUploadFile) {
	                data.files = response.data;
	              }
	              dispatch({
	                type: constants.API_SAVE_SUCCESS,
	                payload: data
	              });
	            }).catch(function (error) {
	              return dispatch({
	                type: constants.API_ERROR,
	                payload: (0, _utils.getValidationErrors)(error)
	              });
	            });
	
	          case 6:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, undefined);
	  }));
	
	  return function saveAssets(_x43, _x44, _x45, _x46, _x47, _x48) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	var saveApi = exports.saveApi = function saveApi(details, uploadedAssets) {
	  return function () {
	    var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(dispatch, getState) {
	      var config, portal, userContext, data, url;
	      return _regenerator2.default.wrap(function _callee21$(_context21) {
	        while (1) {
	          switch (_context21.prev = _context21.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              userContext = (0, _api.getUserContext)(getState());
	              data = (0, _requestParser.getCreateData)(userContext, details);
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/';
	              _context21.next = 8;
	              return _axios2.default.post(url, data, { credentials: 'include' }).then(function (response) {
	                if (uploadedAssets && !(0, _lodash.isEmpty)(uploadedAssets.files)) {
	                  var apiDetails = response.data;
	                  saveAssets(apiDetails, uploadedAssets.files, portal, dispatch, true, []);
	                } else {
	                  dispatch({
	                    type: constants.API_SAVE_SUCCESS,
	                    payload: response.data
	                  });
	                }
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 8:
	            case 'end':
	              return _context21.stop();
	          }
	        }
	      }, _callee21, undefined);
	    }));
	
	    return function (_x49, _x50) {
	      return _ref22.apply(this, arguments);
	    };
	  }();
	};
	
	var updateApi = exports.updateApi = function updateApi(apiUuid, details) {
	  return function () {
	    var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee22$(_context22) {
	        while (1) {
	          switch (_context22.prev = _context22.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _requestParser.getUpdateData)(apiUuid, details);
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid;
	              _context22.next = 7;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_UPDATE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context22.stop();
	          }
	        }
	      }, _callee22, undefined);
	    }));
	
	    return function (_x51, _x52) {
	      return _ref23.apply(this, arguments);
	    };
	  }();
	};
	
	var updateApiDetails = exports.updateApiDetails = function updateApiDetails(apiUuid, details) {
	  return function () {
	    var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(dispatch, getState) {
	      var config, portal, formData, url;
	      return _regenerator2.default.wrap(function _callee23$(_context23) {
	        while (1) {
	          switch (_context23.prev = _context23.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              formData = (0, _requestParser.getUpdateDetails)(apiUuid, details);
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid;
	              _context23.next = 7;
	              return _axios2.default.put(url, formData, { credentials: 'include' }).then(function () {
	                dispatch({
	                  type: constants.API_SAVE_SUCCESS,
	                  payload: details
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context23.stop();
	          }
	        }
	      }, _callee23, undefined);
	    }));
	
	    return function (_x53, _x54) {
	      return _ref24.apply(this, arguments);
	    };
	  }();
	};
	
	var updateApiDetailsWithAssets = exports.updateApiDetailsWithAssets = function updateApiDetailsWithAssets(apiUuid, details, initialAssets, uploadedAssets, isUploadFile, filesToDelete) {
	  return function () {
	    var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(dispatch, getState) {
	      var config, portal, formData, url;
	      return _regenerator2.default.wrap(function _callee24$(_context24) {
	        while (1) {
	          switch (_context24.prev = _context24.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              formData = (0, _requestParser.getUpdateDetails)(apiUuid, details);
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid;
	              _context24.next = 7;
	              return _axios2.default.put(url, formData, { credentials: 'include' }).then(function () {
	                var apiDetails = details;
	                if (isUploadFile || filesToDelete.length > 0) {
	                  saveAssets(apiDetails, uploadedAssets.files, portal, dispatch, isUploadFile, filesToDelete);
	                } else {
	                  dispatch({
	                    type: constants.API_SAVE_SUCCESS,
	                    payload: apiDetails
	                  });
	                }
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context24.stop();
	          }
	        }
	      }, _callee24, undefined);
	    }));
	
	    return function (_x55, _x56) {
	      return _ref25.apply(this, arguments);
	    };
	  }();
	};
	
	var publishApi = exports.publishApi = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(apiUuid, portal, dispatch) {
	    var url;
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/publish';
	            _context25.next = 3;
	            return _axios2.default.put(url, '', { credentials: 'include' }).then(function (response) {
	              return dispatch({
	                type: constants.API_PUBLISH_SAVE_SUCCESS,
	                isLoading: false,
	                payload: response
	              });
	            }).catch(function (error) {
	              return dispatch({
	                type: constants.API_ERROR,
	                payload: (0, _utils.getValidationErrors)(error)
	              });
	            });
	
	          case 3:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, undefined);
	  }));
	
	  return function publishApi(_x57, _x58, _x59) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	
	var fetchApiCustomFields = exports.fetchApiCustomFields = function fetchApiCustomFields(apiUuid) {
	  return function () {
	    var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee26$(_context26) {
	        while (1) {
	          switch (_context26.prev = _context26.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/custom-fields';
	              _context26.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_CUSTOM_FIELDS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context26.stop();
	          }
	        }
	      }, _callee26, undefined);
	    }));
	
	    return function (_x60, _x61) {
	      return _ref27.apply(this, arguments);
	    };
	  }();
	};
	
	var saveApiCustomFields = exports.saveApiCustomFields = function saveApiCustomFields(apiUuid, customFieldValues) {
	  return function () {
	    var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(dispatch, getState) {
	      var config, portal, data, url;
	      return _regenerator2.default.wrap(function _callee27$(_context27) {
	        while (1) {
	          switch (_context27.prev = _context27.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              data = (0, _lodash.map)(customFieldValues, function (value, key) {
	                return {
	                  customFieldUuid: key,
	                  value: value
	                };
	              });
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/custom-fields';
	              _context27.next = 7;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_CUSTOM_FIELDS_SAVE_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context27.stop();
	          }
	        }
	      }, _callee27, undefined);
	    }));
	
	    return function (_x62, _x63) {
	      return _ref28.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchApiPolicyEntities = exports.fetchApiPolicyEntities = function fetchApiPolicyEntities(apiUuid) {
	  return function () {
	    var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee28$(_context28) {
	        while (1) {
	          switch (_context28.prev = _context28.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/policy-entities';
	              _context28.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.API_POLICY_TEMPLATES_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context28.stop();
	          }
	        }
	      }, _callee28, undefined);
	    }));
	
	    return function (_x64, _x65) {
	      return _ref29.apply(this, arguments);
	    };
	  }();
	};
	
	var saveApiPolicyEntities = exports.saveApiPolicyEntities = function saveApiPolicyEntities(apiUuid, data) {
	  return function () {
	    var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee29$(_context29) {
	        while (1) {
	          switch (_context29.prev = _context29.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/policy-entities';
	              _context29.next = 6;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function () {
	                publishApi(apiUuid, portal, dispatch);
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 6:
	            case 'end':
	              return _context29.stop();
	          }
	        }
	      }, _callee29, undefined);
	    }));
	
	    return function (_x66, _x67) {
	      return _ref30.apply(this, arguments);
	    };
	  }();
	};
	
	var callSaveOrganizationsAPI = function callSaveOrganizationsAPI(data, apiUuid, portal, dispatch) {
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/organizations';
	  _axios2.default.put(url, data, { credentials: 'include' }).then(function () {
	    dispatch({
	      type: constants.API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS
	    });
	  }).catch(function (error) {
	    return dispatch({
	      type: constants.API_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var saveManageOrgApi = function saveManageOrgApi(selectedManageOrg, apiDetails, apiUuid, portal, dispatch, retainManagingOrgVisibility) {
	  var data = (0, _requestParser.getUpdateData)(apiUuid, apiDetails);
	  data.managingOrgUuid = selectedManageOrg ? selectedManageOrg.uuid : null;
	  var url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid;
	  if (retainManagingOrgVisibility === true || retainManagingOrgVisibility === false) {
	    url = url + '?retainManagingOrgVisibility=' + retainManagingOrgVisibility;
	  }
	  _axios2.default.put(url, data, { credentials: 'include' }).then(function () {
	    dispatch({
	      type: constants.API_PERMISSION_SAVE_SUCCESS,
	      payload: data
	    });
	  }).catch(function (error) {
	    return dispatch({
	      type: constants.API_ERROR,
	      payload: (0, _utils.getValidationErrors)(error)
	    });
	  });
	};
	
	var savePermissions = exports.savePermissions = function savePermissions(data, apiUuid, selectedManageOrg, isSavePermissionApi, isSaveManageOrgApi, retainManagingOrgVisibility) {
	  return function () {
	    var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(dispatch, getState) {
	      var config, portal, apiDetails, url;
	      return _regenerator2.default.wrap(function _callee30$(_context30) {
	        while (1) {
	          switch (_context30.prev = _context30.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              apiDetails = (0, _api.getApiDetails)(getState());
	
	              if (!(!isSavePermissionApi && isSaveManageOrgApi)) {
	                _context30.next = 8;
	                break;
	              }
	
	              saveManageOrgApi(selectedManageOrg, apiDetails, apiUuid, portal, dispatch, retainManagingOrgVisibility);
	              _context30.next = 11;
	              break;
	
	            case 8:
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/0.1/permissions/apis/' + apiUuid;
	              _context30.next = 11;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function () {
	                if (selectedManageOrg === null || apiDetails.managingOrgUuid !== selectedManageOrg.uuid) {
	                  saveManageOrgApi(selectedManageOrg, apiDetails, apiUuid, portal, dispatch);
	                } else {
	                  dispatch({
	                    type: constants.API_PERMISSION_SAVE_SUCCESS,
	                    payload: apiDetails
	                  });
	                }
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 11:
	            case 'end':
	              return _context30.stop();
	          }
	        }
	      }, _callee30, undefined);
	    }));
	
	    return function (_x68, _x69) {
	      return _ref31.apply(this, arguments);
	    };
	  }();
	};
	
	var saveApiAccessStatus = exports.saveApiAccessStatus = function saveApiAccessStatus(accessStatus, apiUuid, canSaveOrgadminDev, dataToSave) {
	  return function () {
	    var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(dispatch, getState) {
	      var config, portal, apiDetails, data, url;
	      return _regenerator2.default.wrap(function _callee31$(_context31) {
	        while (1) {
	          switch (_context31.prev = _context31.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              apiDetails = (0, _api.getApiDetails)(getState());
	              data = (0, _requestParser.getUpdateData)(apiUuid, apiDetails);
	
	              data.uuid = apiUuid;
	              data.accessStatus = accessStatus;
	
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid;
	              _context31.next = 10;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function (response) {
	                if (accessStatus === constants.API_ACCESS_STATUS_PRIVATE && !canSaveOrgadminDev) {
	                  callSaveOrganizationsAPI(dataToSave, apiUuid, portal, dispatch);
	                } else {
	                  dispatch({
	                    type: constants.API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS,
	                    payload: response.data
	                  });
	                }
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 10:
	            case 'end':
	              return _context31.stop();
	          }
	        }
	      }, _callee31, undefined);
	    }));
	
	    return function (_x70, _x71) {
	      return _ref32.apply(this, arguments);
	    };
	  }();
	};
	
	var saveTagsAssociation = exports.saveTagsAssociation = function saveTagsAssociation(data, apiUuid) {
	  return function () {
	    var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee32$(_context32) {
	        while (1) {
	          switch (_context32.prev = _context32.next) {
	            case 0:
	              initApi(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/api-management/1.0/apis/' + apiUuid + '/tags';
	
	              dispatch({
	                type: constants.API_TAGS_ASSOCIATE_REQUEST,
	                isLoading: false
	              });
	              _context32.next = 7;
	              return _axios2.default.put(url, data, { credentials: 'include' }).then(function () {
	                dispatch({
	                  type: constants.API_TAGS_ASSOCIATE_SUCCESS
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.API_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context32.stop();
	          }
	        }
	      }, _callee32, undefined);
	    }));
	
	    return function (_x72, _x73) {
	      return _ref33.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchDashboardChartData = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _portalConfig = __webpack_require__(26);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchDashboardEntityCount = function fetchDashboardEntityCount() {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var config, portal, url;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              url = portal.hostname + '/admin/navigation/internal/entity-counts';
	              _context.next = 5;
	              return _axios2.default.get(url, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.DASHBOARD_GET_ENTITY_COUNT_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.DASHBOARD_GET_ENTITY_COUNT_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var fetchDashboardChartData = exports.fetchDashboardChartData = function fetchDashboardChartData(body, entity) {
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var config, userContexts, activeOrgUuid, portal, url, headers;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              config = (0, _portalConfig.getConfig)(getState());
	              userContexts = (0, _portalConfig.getUserContexts)(getState());
	              activeOrgUuid = (0, _lodash.get)(userContexts, 'userContexts[0].activeOrgUuid');
	              portal = config.portal;
	              url = portal.hostname + '/api/' + portal.tenantPrefix + '/analytics/metrics/v1/_query';
	              headers = Object.assign({
	                'Content-Type': 'application/json',
	                Accept: 'application/json'
	              }, activeOrgUuid ? {
	                'APIM-OrgUuid': activeOrgUuid
	              } : {});
	              _context2.next = 8;
	              return _axios2.default.post(url, body, { headers: headers }, { credentials: 'include' }).then(function (response) {
	                dispatch({
	                  type: constants.DASHBOARD_CHART_DATA_SUCCESS,
	                  payload: response.data,
	                  entity: entity
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: constants.DASHBOARD_CHART_DATA_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 8:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	exports.default = fetchDashboardEntityCount;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _List = __webpack_require__(162);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(163);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemText = __webpack_require__(226);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _Collapse = __webpack_require__(70);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _ExpandLess = __webpack_require__(114);
	
	var _ExpandLess2 = _interopRequireDefault(_ExpandLess);
	
	var _ExpandMore = __webpack_require__(81);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _styles = __webpack_require__(1470);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandableList = function ExpandableList(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      open = _React$useState2[0],
	      setOpen = _React$useState2[1];
	
	  var handleClick = function handleClick() {
	    setOpen(!open);
	  };
	
	  var title = props.title,
	      list = props.list;
	
	  var selectedCount = list.length || 0;
	  return _react2.default.createElement(
	    _List2.default,
	    {
	      component: 'nav',
	      'aria-labelledby': 'nested-list-subheader',
	      className: classes.root
	    },
	    _react2.default.createElement(
	      _ListItem2.default,
	      { classes: { root: classes.listButton }, button: true, onClick: handleClick },
	      _react2.default.createElement(_ListItemText2.default, { primary: title + ' (' + selectedCount + ')' }),
	      open ? _react2.default.createElement(_ExpandLess2.default, { className: classes.dropdownIndicator }) : _react2.default.createElement(_ExpandMore2.default, { className: classes.dropdownIndicator })
	    ),
	    _react2.default.createElement(
	      _Collapse2.default,
	      { 'in': open, timeout: 'auto', unmountOnExit: true },
	      selectedCount > 0 ? list.map(function (obj) {
	        return _react2.default.createElement(
	          _List2.default,
	          { key: obj.key, component: 'div', disablePadding: true },
	          _react2.default.createElement(
	            _ListItem2.default,
	            { button: true, className: classes.listItem },
	            _react2.default.createElement(_ListItemText2.default, { primary: obj.value })
	          )
	        );
	      }) : _react2.default.createElement(
	        _List2.default,
	        { component: 'div', disablePadding: true },
	        _react2.default.createElement(
	          _ListItem2.default,
	          { button: true, className: classes.listItem },
	          _react2.default.createElement(_ListItemText2.default, { primary: 'No results' })
	        )
	      )
	    )
	  );
	};
	
	ExpandableList.propTypes = {
	  title: _propTypes2.default.string,
	  list: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  }))
	};
	
	exports.default = ExpandableList;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    container: {
	      border: '1px solid ' + (0, _lodash.get)(theme, 'color.borderColor'),
	      height: 200,
	      display: 'flex',
	      margin: 10,
	      marginLeft: 0,
	      width: '98%'
	    },
	    fileLabel: {
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      margin: 'auto',
	      textAlign: 'center',
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontWeight: 700,
	      '& > div': {
	        color: (0, _lodash.get)(theme, 'color.bodyText'),
	        fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	        fontSize: (0, _lodash.get)(theme, 'fontSize.title')
	      }
	    },
	    root: {
	      '&.Mui-error': {
	        color: (0, _lodash.get)(theme, 'color.error'),
	        fontSize: 14
	      }
	    },
	    selectedFileContainer: {
	      marginTop: 20,
	      marginBottom: 20
	    },
	    formLabel: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallTitle'),
	      fontWeight: 700,
	      marginBottom: 10,
	      paddingLeft: 0
	    },
	    uploadFileSection: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.disabledBackground'),
	      color: (0, _lodash.get)(theme, 'color.disabledText'),
	      marginBottom: (0, _lodash.get)(theme, 'margin.4px'),
	      '& p': {
	        display: 'inline-block'
	      },
	      '& svg': {
	        float: 'right'
	      }
	    },
	    error: {
	      color: (0, _lodash.get)(theme, 'color.error'),
	      paddingTop: 10
	    },
	    fileSizeText: {
	      paddingLeft: 10,
	      fontStyle: 'italic'
	    },
	    helperText: {
	      color: (0, _lodash.get)(theme, 'color.smallText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.smallText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapStateToProps = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(3);
	
	var _index = __webpack_require__(1473);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _portalConfig = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var copyrightText = "Broadcom. All Rights Reserved. The term 'Broadcom' refers to Broadcom Inc. and/or its subsidiaries.";
	
	var Footer = function Footer(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      supportLink = _ref.supportLink,
	      _ref$displayCopyright = _ref.displayCopyright,
	      displayCopyright = _ref$displayCopyright === undefined ? true : _ref$displayCopyright;
	  return _react2.default.createElement(
	    'div',
	    { className: classes.Footer },
	    _react2.default.createElement(
	      'div',
	      null,
	      displayCopyright && _react2.default.createElement(
	        'div',
	        {
	          'data-apim-test': 'copyright'
	        },
	        '\xA9 ' + (0, _moment2.default)().format('YYYY') + ' ',
	        copyrightText
	      )
	    ),
	    _react2.default.createElement(
	      _core.Button,
	      {
	        variant: 'contained',
	        color: 'secondary',
	        className: classes.FooterHelpButton,
	        href: supportLink
	      },
	      'Help'
	    )
	  );
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    supportLink: 'https://www.broadcom.com/support/services-support/ca-support',
	    displayCopyright: (0, _portalConfig.getDisplayCopyright)(state)
	  };
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_index2.default), (0, _reactRedux.connect)(mapStateToProps))(Footer);

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = exports.Header = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _reactRedux = __webpack_require__(27);
	
	var _recompose = __webpack_require__(105);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(30);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _portalConfig = __webpack_require__(85);
	
	var _portalConfig2 = __webpack_require__(26);
	
	var _Branding = __webpack_require__(1492);
	
	var _Branding2 = _interopRequireDefault(_Branding);
	
	var _Nav = __webpack_require__(1498);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Requests = __webpack_require__(1500);
	
	var _Requests2 = _interopRequireDefault(_Requests);
	
	var _Settings = __webpack_require__(1502);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _User = __webpack_require__(1504);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _index = __webpack_require__(1506);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function componentDidMount() {
	  var _props = this.props,
	      isPortalAdmin = _props.isPortalAdmin,
	      isOrgPublisher = _props.isOrgPublisher;
	
	  if (isPortalAdmin || isOrgPublisher) {
	    // Publisher Role
	    this.props.fetchRequests();
	  }
	}
	
	var Header = exports.Header = function Header(props) {
	  var logo = props.logo,
	      siteTitle = props.siteTitle,
	      homeHref = props.homeHref,
	      classes = props.classes,
	      navItems = props.navItems,
	      cqNavItems = props.cqNavItems,
	      requestItems = props.requestItems,
	      userAccessibleOrgs = props.userAccessibleOrgs,
	      userActiveOrgUuid = props.userActiveOrgUuid,
	      userDetails = props.userDetails,
	      isEnabledGlobalHeader = props.isEnabledGlobalHeader;
	
	  var settingsNode = navItems && navItems.find(function (item) {
	    return item.titleKey === 'label.appnav.administration';
	  });
	  var settingItems = settingsNode && (0, _lodash.isArray)(settingsNode.navigations) && settingsNode.navigations || [];
	  var devCQItems = cqNavItems && cqNavItems.developer && cqNavItems.developer.filter(function (item) {
	    return item.titleKey !== 'label.appnav.home';
	  });
	  var devCQMenu = [];
	  if (devCQItems) {
	    devCQItems.forEach(function (item) {
	      devCQMenu.push({
	        menuTitle: item.title,
	        href: item.url,
	        externalLink: true
	      });
	      if (item.subNav) {
	        item.subNav.forEach(function (subnavItem) {
	          devCQMenu.push({
	            menuTitle: subnavItem.title,
	            href: subnavItem.url,
	            externalLink: true
	          });
	        });
	      }
	    });
	  }
	  var filteredNavItems = navItems.filter(function (item) {
	    return item.titleKey !== 'label.appnav.administration';
	  });
	  var theme = (0, _core.useTheme)();
	
	  var _useState = (0, _react.useState)(window.innerWidth > (0, _lodash.get)(theme, 'misc.breakpointLarge', 1280)),
	      _useState2 = _slicedToArray(_useState, 2),
	      isLargeScreen = _useState2[0],
	      setIsLargeScreen = _useState2[1];
	
	  if (devCQMenu && devCQMenu.length > 0) {
	    var devCQTopMenu = {
	      titleKey: 'label.appnav.custompages.menu',
	      navigations: devCQMenu,
	      externalLink: false
	    };
	    filteredNavItems.splice(filteredNavItems.length - 1, 0, devCQTopMenu);
	  }
	  var updateMedia = function updateMedia() {
	    setIsLargeScreen(window.innerWidth > (0, _lodash.get)(theme, 'misc.breakpointLarge'));
	  };
	  (0, _react.useEffect)(function () {
	    window.addEventListener('resize', updateMedia);
	    return function () {
	      return window.removeEventListener('resize', updateMedia);
	    };
	  });
	  // Changes to hide all header elements except Branding while printing
	  // analytics reports
	  // To keep DOM structure intact, added styling in individual elements
	  // to skip elements while printing,
	  // which depends on classname skipPrint, so don't remove or rename it
	  var shouldSkipHeaderInPrint = function shouldSkipHeaderInPrint() {
	    return window.location.href.includes('analytics-dashboard');
	  };
	  var skipPrint = shouldSkipHeaderInPrint();
	  return isEnabledGlobalHeader ? _react2.default.createElement(
	    'div',
	    { className: (0, _clsx2.default)(classes.Header, skipPrint && 'skipPrint') },
	    _react2.default.createElement(
	      'div',
	      { className: classes.HeaderInner },
	      _react2.default.createElement(_Branding2.default, {
	        logo: logo,
	        siteTitle: siteTitle,
	        homeHref: homeHref
	      }),
	      isLargeScreen ? _react2.default.createElement(_Nav2.default, { navItems: filteredNavItems }) : _react2.default.createElement(_Nav2.default, { navItems: filteredNavItems, renderCollapsed: true }),
	      settingItems.length > 0 && _react2.default.createElement(_Settings2.default, { settingItems: settingItems }),
	      (props.isPortalAdmin || props.isOrgPublisher) && _react2.default.createElement(_Requests2.default, { fetchRequests: props.fetchRequests, requestItems: requestItems }),
	      _react2.default.createElement(_User2.default, {
	        userAccessibleOrgs: userAccessibleOrgs,
	        userActiveOrgUuid: userActiveOrgUuid,
	        userDetails: userDetails,
	        updateUserContexts: props.updateUserContexts
	      })
	    )
	  ) : _react2.default.createElement('div', null);
	};
	
	var getHomePageRef = function getHomePageRef(state) {
	  var hostName = window.location.hostname;
	  if ((0, _portalConfig2.getIsPortalAdmin)(state)) {
	    return '//' + hostName + '/admin';
	  } else if ((0, _portalConfig2.getIsAnonymousRole)(state)) {
	    return '//' + hostName + '/admin/app/guest/dashboard';
	  }
	  return '//' + hostName + '/admin/app/dashboard';
	};
	
	var getNavItems = function getNavItems(state) {
	  return (0, _portalConfig2.getGlobalNavigation)(state);
	};
	var getCqItems = function getCqItems(state) {
	  return (0, _portalConfig2.getCQNavigation)(state);
	};
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  var _getThemes = (0, _portalConfig2.getThemes)(state),
	      logo = _getThemes.logo,
	      siteTitle = _getThemes.siteTitle;
	
	  return {
	    logo: logo,
	    siteTitle: siteTitle,
	    isPortalAdmin: (0, _portalConfig2.getIsPortalAdmin)(state),
	    isOrgPublisher: (0, _portalConfig2.getIsOrgPublisher)(state),
	    homeHref: getHomePageRef(state),
	    navItems: getNavItems(state),
	    cqNavItems: getCqItems(state),
	    userAccessibleOrgs: (0, _portalConfig2.getUserAccessibleOrgs)(state),
	    userActiveOrgUuid: (0, _portalConfig2.getUserActiveOrgUuid)(state),
	    userDetails: (0, _portalConfig2.getUserDetails)(state),
	    requestItems: (0, _portalConfig2.getRequests)(state),
	    isEnabledGlobalHeader: (0, _portalConfig2.getNewLandingPage)(state)
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = {
	  updateUserContexts: _portalConfig.updateUserContexts,
	  fetchRequests: _portalConfig.fetchRequests,
	  fetchNavigation: _portalConfig.fetchNavigation
	};
	
	Header.propTypes = {
	  logo: _propTypes2.default.string,
	  siteTitle: _propTypes2.default.string,
	  homeHref: _propTypes2.default.string,
	  classes: _propTypes2.default.shape({}),
	  fetchRequests: _propTypes2.default.func,
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  cqNavItems: _propTypes2.default.shape(),
	  userAccessibleOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  userActiveOrgUuid: _propTypes2.default.string,
	  userDetails: _propTypes2.default.shape({}),
	  requestItems: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  updateUserContexts: _propTypes2.default.func,
	  isEnabledGlobalHeader: _propTypes2.default.bool,
	  isPortalAdmin: _propTypes2.default.bool,
	  isOrgPublisher: _propTypes2.default.bool
	};
	
	exports.default = (0, _recompose.compose)((0, _styles.withStyles)(_index2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.lifecycle)({ componentDidMount: componentDidMount }))(Header);

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    helpContainer: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      lineHeight: 1.6
	    },
	    helpTitle: {
	      fontSize: (0, _lodash.get)(fontSize, 'sectionTitle'),
	      margin: 0
	    },
	    helpDescription: {
	      marginBottom: 20
	    },
	    helpTextHead: {
	      fontWeight: 'bold'
	    },
	    helpTextBody: {},
	    helpSubContainer: {
	      marginTop: 20
	    },
	    listRoot: {
	      paddingTop: 0,
	      paddingBottom: 0
	    },
	    iconText: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText')
	    },
	    listIconRoot: {
	      minWidth: '20px'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = HorizontalScrollBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1527);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HorizontalScrollBar(props) {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showRightScrollBtn = _useState2[0],
	      setRightScrollBtnVisibility = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showLeftScrollBtn = _useState4[0],
	      setLeftScrollBtnVisibility = _useState4[1];
	
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	
	  function setScrollButtonVisibility() {
	    var container = document.getElementById('' + props.scrollEntity);
	    if (container.scrollWidth - container.offsetWidth > container.scrollLeft) {
	      setRightScrollBtnVisibility(true);
	    }
	    if (container.scrollWidth - container.offsetWidth === container.scrollLeft) {
	      setRightScrollBtnVisibility(false);
	    }
	    setLeftScrollBtnVisibility(container.scrollLeft > 0);
	  }
	
	  function sideScroll(elementId, direction, speed, distance, step) {
	    var element = document.getElementById(elementId);
	    var scrollAmount = 0;
	    var slideTimer = setInterval(function () {
	      if (direction === 'left') {
	        element.scrollLeft -= step;
	      } else {
	        element.scrollLeft += step;
	      }
	      scrollAmount += step;
	      if (scrollAmount >= distance) {
	        window.clearInterval(slideTimer);
	      }
	      setScrollButtonVisibility();
	    }, speed);
	  }
	
	  var scrollRight = function scrollRight() {
	    sideScroll('' + props.scrollEntity, 'right', 25, 100, 10);
	  };
	
	  var scrollLeft = function scrollLeft() {
	    sideScroll('' + props.scrollEntity, 'left', 25, 100, 10);
	  };
	
	  window.addEventListener('resize', setScrollButtonVisibility);
	
	  (0, _react.useEffect)(function () {
	    setScrollButtonVisibility();
	  });
	  var rightScrollBtnClass = showRightScrollBtn ? classes.scrollBtn : classes.scrollBtn__hide;
	  var leftScrollBtnClass = showLeftScrollBtn ? classes.leftscrollBtn : classes.scrollBtn__hide;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.container, 'data-apim-test': 'hscroll-bar-container' },
	    _react2.default.createElement(
	      'button',
	      { className: leftScrollBtnClass, onClick: scrollLeft },
	      '<'
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        id: props.scrollEntity,
	        'data-apim-test': 'hscroll-bar-entity',
	        className: classes.scrollBar
	      },
	      props.children
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: rightScrollBtnClass, onClick: scrollRight },
	      '>'
	    )
	  );
	}
	
	HorizontalScrollBar.propTypes = {
	  children: _propTypes2.default.node,
	  scrollEntity: _propTypes2.default.string
	};

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StatusContent = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _core = __webpack_require__(3);
	
	var _Lens = __webpack_require__(172);
	
	var _Lens2 = _interopRequireDefault(_Lens);
	
	var _propTypes = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _copyToClipboard = __webpack_require__(117);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _constants = __webpack_require__(14);
	
	var _AlertDialog = __webpack_require__(197);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _utils = __webpack_require__(18);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1542);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatusContent = exports.StatusContent = function StatusContent(props) {
	  var id = props.id,
	      message = props.message,
	      statusLabel = props.statusLabel,
	      classes = props.classes,
	      notifyMessages = props.notifyMessages;
	
	  var isError = [_constants.DEPLOYMENT_STATUS_ERROR, _constants.DEPLOYMENT_STATUS_ERROR_UNDEPLOY].includes(statusLabel);
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDialog = _useState2[0],
	      setIsDialog = _useState2[1];
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var errorMessage = (0, _utils.formatStatusMessage)(message);
	
	  var copy = function copy() {
	    setIsDialog(false);
	    notifyMessages(_constants.ALERT_SUCCESS, intl.getI18nMessage('label.proxy.details.tab.error.copied'));
	    (0, _copyToClipboard2.default)(errorMessage);
	    setTimeout(function () {
	      return notifyMessages('', '');
	    }, 3000);
	  };
	
	  var closeConfirmDialog = function closeConfirmDialog() {
	    setIsDialog(false);
	  };
	
	  var showErrorDialog = function showErrorDialog() {
	    if (isError) {
	      setIsDialog(true);
	    }
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    isDialog && _react2.default.createElement(_AlertDialog2.default, {
	      isOpen: isDialog,
	      title: _constants.DIALOG_TITLE_ERROR,
	      description: errorMessage,
	      submitText: _constants.COPY_CLOSE_TEXT,
	      cancelText: _constants.CLOSE_TEXT,
	      onClose: closeConfirmDialog,
	      onSubmit: copy,
	      onCancel: closeConfirmDialog,
	      dialogId: 'keys-error-dialog',
	      dialogActionClass: classes.dialogAction,
	      submitButtonClass: classes.dialogSubmit,
	      cancelButtonClass: classes.dialogCancel
	    }),
	    _react2.default.createElement(
	      _core.Typography,
	      { id: id, 'data-apim-test': id, className: classes.cardStatus },
	      _react2.default.createElement(
	        'span',
	        { className: classes[statusLabel] },
	        _react2.default.createElement(_Lens2.default, { className: classes.cardStatusIcon })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: isError ? classes.errorContent : classes.label, onClick: showErrorDialog },
	        (0, _lodash.startCase)((0, _lodash.capitalize)(statusLabel))
	      )
	    )
	  );
	};
	
	StatusContent.propTypes = {
	  id: _propTypes.string,
	  message: _propTypes.string,
	  classes: (0, _propTypes.shape)({}),
	  statusLabel: _propTypes.string,
	  notifyMessages: _propTypes.func
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(StatusContent);

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StatusIndicator = exports.getStatusColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(1543);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _intl = __webpack_require__(15);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStatusColor = exports.getStatusColor = function getStatusColor(classes, status) {
	  switch (status) {
	    case _constants.PROXY_ENROLMENT_STATUS_PENDING:
	      return {
	        statusLabel: (0, _intl.getI18nFormattedMessage)('label.proxy.details.page.status.pending.enrollment'),
	        statusColorClass: classes.disabledGraphic
	      };
	    case _constants.PROXY_CONNECTED:
	      return {
	        statusLabel: (0, _intl.getI18nFormattedMessage)('label.proxy.details.page.status.connected'),
	        statusColorClass: classes.success
	      };
	    case _constants.PROXY_DISCONNECTED:
	      return {
	        statusLabel: (0, _intl.getI18nFormattedMessage)('label.proxy.details.page.status.disconnected'),
	        statusColorClass: classes.error
	      };
	    default:
	      return {
	        statusLabel: '',
	        statusColorClass: {}
	      };
	  }
	};
	
	var StatusIndicator = exports.StatusIndicator = function StatusIndicator(props) {
	  var classes = props.classes,
	      inline = props.inline,
	      modifyTs = props.modifyTs,
	      status = props.status;
	
	  var _getStatusColor = getStatusColor(classes, status),
	      statusLabel = _getStatusColor.statusLabel,
	      statusColorClass = _getStatusColor.statusColorClass;
	
	  var lastModified = modifyTs && (0, _datetime2.default)(new Date(modifyTs).toString());
	  var statusBarClass = inline ? (0, _classnames2.default)(classes.statusBar, classes.inline) : classes.statusBar;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: statusBarClass,
	      id: 'status-indicator', 'data-layer7-test': 'status-indicator'
	    },
	    _react2.default.createElement(
	      'span',
	      { className: (0, _classnames2.default)(classes.status, statusColorClass) },
	      _react2.default.createElement(
	        _core.Typography,
	        { variant: 'body1', className: statusColorClass },
	        statusLabel
	      )
	    ),
	    lastModified && _react2.default.createElement(
	      _core.Typography,
	      { variant: 'body1', id: 'status-indicator-last-modified' },
	      intl.getI18nMessage('label.last.updated'),
	      ': ',
	      lastModified
	    )
	  );
	};
	
	StatusIndicator.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  inline: _propTypes.bool,
	  modifyTs: _propTypes.string,
	  status: _propTypes.string
	};
	StatusIndicator.displayName = 'StatusIndicator';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(StatusIndicator);

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      typography = _ref.typography,
	      fontSize = _ref.fontSize;
	  return {
	    appApisContainer: {
	      padding: '0 36px'
	    },
	    apiCard: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	    card: {
	      margin: 5,
	      minHeight: 160,
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground')
	    },
	    cardTitle: {
	      fontSize: (0, _lodash.get)(fontSize, 'smallTitle'),
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      margin: '5px 0px'
	    },
	    cardStatus: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      marginTop: 5,
	      marginBottom: 5
	    },
	    cardStatusIcon: {
	      fontSize: 12
	    },
	    available: {
	      color: (0, _lodash.get)(color, 'success'),
	      '&:before': {
	        backgroundColor: (0, _lodash.get)(color, 'success')
	      }
	    },
	    pending: {
	      color: (0, _lodash.get)(color, 'pending'),
	      '&:before': {
	        backgroundColor: (0, _lodash.get)(color, 'pending')
	      }
	    },
	    unavailable: {
	      color: (0, _lodash.get)(color, 'error'),
	      '&:before': {
	        backgroundColor: (0, _lodash.get)(color, 'error')
	      }
	    },
	    cardDescription: {
	      paddingTop: 5,
	      color: (0, _lodash.get)(color, 'smallText')
	    },
	    versionText: {
	      color: (0, _lodash.get)(color, 'bodyText')
	    },
	    boldText: {
	      fontWeight: 'bold'
	    },
	    linkWrapper: {
	      '& a': {
	        cursor: 'pointer',
	        border: 'none !important',
	        margin: '0px !important',
	        padding: '0px !important',
	        height: '0px !important',
	        fontWeight: '300 !important',
	        color: (0, _lodash.get)(color, 'link') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:hover': {
	        color: (0, _lodash.get)(color, 'linkHover') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:focus': {
	        boxShadow: 'none !important',
	        outline: '0px !important',
	        textDecoration: 'none'
	      }
	    },
	    leftMargin: {
	      '& a': {
	        marginLeft: '5px !important'
	      }
	    },
	    disabledClass: {
	      pointerEvents: 'none',
	      cursor: 'not-allowed',
	      '& a': {
	        color: (0, _lodash.get)(color, 'gray') + ' !important'
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      typography = _ref.typography,
	      fontSize = _ref.fontSize;
	  return {
	    appDeploymentsContainer: {
	      padding: '0 36px',
	      '& table': {
	        backgroundColor: (0, _lodash.get)(color, 'uiBackground')
	      },
	      '& tr': {
	        borderTop: '1px solid ' + (0, _lodash.get)(color, 'borderColor')
	      },
	      '& th': {
	        color: (0, _lodash.get)(color, 'primaryButtonBackground'),
	        padding: 12,
	        cursor: 'pointer',
	        border: 'none'
	      },
	      '& td': {
	        padding: 12,
	        border: 'none'
	      }
	    },
	    expandCollapseButton: {
	      color: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      float: 'right'
	    },
	    deploymentCard: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	    card: {
	      margin: 5,
	      marginLeft: 0,
	      minHeight: 160,
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground')
	    },
	    cardTitle: {
	      fontSize: (0, _lodash.get)(fontSize, 'smallTitle'),
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      margin: '5px 0px'
	    },
	    cardType: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      marginTop: 5,
	      marginBottom: 5,
	      verticalAlign: 'text-bottom',
	      '& span': {
	        verticalAlign: 'bottom',
	        color: (0, _lodash.get)(color, 'accentDark'),
	        fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	        margin: 'auto 0'
	      }
	    },
	    cardStatus: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      marginTop: 5,
	      marginBottom: 5
	    },
	    cardStatusIcon: {
	      fontSize: 12
	    },
	    cardLastUpdated: {
	      color: (0, _lodash.get)(color, 'smallText'),
	      marginBottom: 10
	    },
	    helpIcon: {
	      fontSize: 12,
	      margin: 4,
	      verticalAlign: 'inherit',
	      cursor: 'pointer',
	      color: (0, _lodash.get)(color, 'link') + ' !important'
	    },
	    helpTextContainer: {
	      '& ui': {
	        padding: 0,
	        listStyleType: 'none'
	      }
	    },
	    boldText: {
	      fontWeight: 'bold'
	    },
	    linkWrapper: {
	      '& a': {
	        cursor: 'pointer',
	        border: 'none !important',
	        margin: '0px !important',
	        padding: '0px !important',
	        height: '0px !important',
	        fontWeight: '300 !important',
	        color: (0, _lodash.get)(color, 'link') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:hover': {
	        color: (0, _lodash.get)(color, 'linkHover') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:focus': {
	        boxShadow: 'none !important',
	        outline: '0px !important',
	        textDecoration: 'none'
	      }
	    },
	    actionLink: {
	      margin: 10
	    },
	    deploymentButtonsContainer: {
	      margin: 5,
	      '& button:first-of-type': {
	        paddingLeft: '10px !important'
	      },
	      '& button': {
	        border: 'none !important',
	        margin: '0px !important',
	        padding: '0px !important',
	        paddingRight: '10px !important',
	        height: '0px !important',
	        lineHeight: '1 !important',
	        fontWeight: '300 !important',
	        color: (0, _lodash.get)(color, 'link') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        verticalAlign: 'initial',
	        textTransform: 'none',
	        textDecoration: 'none'
	      },
	      '& button:hover': {
	        color: (0, _lodash.get)(color, 'linkHover') + ' !important',
	        textTransform: 'none',
	        textDecoration: 'none'
	      },
	      '& button:focus': {
	        boxShadow: 'none !important',
	        outline: '0px !important',
	        textTransform: 'none',
	        textDecoration: 'none'
	      }
	    },
	    checkStatusContainer: {
	      margin: -5
	    },
	    checkStatusButtonContainer: {
	      display: 'block'
	    },
	    emptyResults: {
	      marginLeft: 10,
	      marginRight: 10
	    },
	    tableHead: {
	      '& th': {
	        color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontWeight: 'bold !important',
	        cursor: 'auto'
	      }
	    },
	    paginationContainer: {
	      margin: '0 !important',
	      '& .MuiTablePagination-toolbar': {
	        margin: '0 !important'
	      }
	    },
	    defaultChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'bodyText'), 0.05) + ' !important',
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    },
	    enabledChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'success')) + ' !important',
	      color: (0, _lodash.get)(color, 'white') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    },
	    disabledChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'error')) + ' !important',
	      color: (0, _lodash.get)(color, 'white') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    },
	    editKeyButton: {
	      color: (0, _lodash.get)(color, 'grayDark') + ' !important',
	      textTransform: 'none',
	      float: 'right'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    legend: function legend(props) {
	      return {
	        display: 'flex',
	        alignItems: 'center',
	        paddingRight: 20,
	        background: props.showOnChart ? (0, _color2.default)(props.lineColor).alpha(0.05).string() : 'transparent',
	        borderRadius: 4,
	        paddingLeft: 16,
	        paddingTop: 16,
	        paddingBottom: 16,
	        border: '1px solid',
	        borderLeftColor: props.showOnChart ? props.lineColor : color.borderColor,
	        borderLeft: props.showOnChart ? '4px solid' : '1px solid',
	        marginLeft: props.showOnChart ? 16 : 19,
	        marginTop: 16,
	        borderColor: props.showOnChart ? color.background : color.borderColor,
	        cursor: props.isNonClickable ? 'arrow' : 'pointer',
	        '&:hover': !props.isNonClickable ? {
	          marginLeft: 16,
	          border: '1px solid',
	          borderLeft: '4px solid',
	          borderColor: props.lineColor,
	          background: (0, _color2.default)(props.lineColor).alpha(0.1).string(),
	          '& button': {
	            visibility: 'visible'
	          }
	        } : {
	          '& button': {
	            visibility: 'visible'
	          }
	        },
	        '&:focus-within': !props.isNonClickable ? {
	          outline: 'none',
	          paddingLeft: 16,
	          paddingTop: 15,
	          paddingBottom: 15,
	          paddingRight: 19,
	          border: '2px solid',
	          borderLeft: '4px solid',
	          borderColor: props.lineColor,
	          background: (0, _color2.default)(props.lineColor).alpha(0.1).string(),
	          '& button': {
	            visibility: 'visible'
	          }
	        } : {
	          outline: 'none',
	          '& button': {
	            visibility: 'visible'
	          }
	        }
	      };
	    },
	    relationship: {
	      fontSize: fontSize.smallLabel,
	      lineHeight: 2,
	      fontFamily: typography.pageTitle,
	      letterSpacing: 0,
	      color: color.pageTitle,
	      textTransform: 'uppercase',
	      whiteSpace: 'nowrap'
	    },
	    title: function title(props) {
	      return {
	        fontFamily: typography.bodyText,
	        fontSize: fontSize.bodyText,
	        fontWeight: 'bold',
	        paddingRight: 5,
	        lineHeight: 2,
	        color: props.isNonClickable ? color.bodyText : color.link,
	        display: 'flex',
	        whiteSpace: 'nowrap'
	      };
	    },
	    count: {
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.bodyText,
	      fontWeight: 'normal',
	      color: color.bodyText
	    },
	    graphIconContainer: {
	      display: 'flex'
	    },
	    graphIconHolder: {
	      visibility: 'hidden',
	      display: 'contents',
	      '& span': {
	        display: 'block',
	        lineHeight: '1.2 !important'
	      }
	    },
	    icon: {
	      fill: color.primaryButtonText
	    },
	    graphIcon: {
	      marginRight: 6,
	      fill: color.primaryButtonBackground,
	      position: 'relative',
	      left: 12,
	      right: 12,
	      '&:hover': {
	        fill: color.primaryButtonHover
	      },
	      '&:focus': {
	        outline: 'none',
	        fill: color.primaryButtonHover,
	        border: '1px solid transparent',
	        borderRadius: 9,
	        boxShadow: '0 0 0 2px ' + color.primaryButtonHover
	      }
	    },
	    tooltiptext: {
	      fontSize: fontSize.bodyText,
	      fontFamily: typography.bodyText,
	      width: 120,
	      opacity: 0.9,
	      visibility: 'hidden',
	      backgroundColor: '#5a5f6d',
	      color: '#fff',
	      textAlign: 'center',
	      borderRadius: 3,
	      padding: '5px 0',
	      position: 'absolute',
	      zIndex: 1,
	      bottom: '100%',
	      left: '41%',
	      '&:after': {
	        content: 'close-quote',
	        position: 'absolute',
	        top: '100%',
	        left: '10%',
	        marginLeft: -5,
	        borderWidth: 4,
	        borderStyle: 'solid',
	        borderColor: '#5a5f6d transparent transparent transparent'
	      }
	    },
	    tooltip: {
	      position: 'relative',
	      '&:hover': {
	        '& span': {
	          visibility: 'visible'
	        }
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildSaveQuery = exports.buildQuery = undefined;
	
	var _each = __webpack_require__(437);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _keys = __webpack_require__(56);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aggregationValueMap = { hits: 'count', latency: 'avg' };
	
	var buildMetricsQueryForChartData = function buildMetricsQueryForChartData(data) {
	  return {
	    type: data.metrics.type,
	    aggregation: data.metrics.aggregation
	  };
	};
	
	var buildFilterQueryForChartData = function buildFilterQueryForChartData(data) {
	  var uriField = data.dimensions.filter.fields.find(function (field) {
	    return field.dimension === 'uri';
	  });
	  if (uriField) {
	    var groupByPresent = uriField.isGrouped === false;
	    var fields = [];
	    var patterns = [];
	    uriField.values.forEach(function (entry) {
	      fields.push({
	        type: 'regex',
	        dimension: 'uri',
	        pattern: {
	          type: 'regex',
	          value: entry.value,
	          name: entry.name
	        }
	      });
	      if (groupByPresent) {
	        patterns.push({
	          type: 'regex',
	          value: entry.value,
	          name: entry.name
	        });
	      }
	    });
	    var index = data.dimensions.filter.fields.findIndex(function (field) {
	      return field.dimension === 'uri';
	    });
	    data.dimensions.filter.fields.splice(index, 1, {
	      type: 'or',
	      fields: fields
	    });
	    if (groupByPresent) {
	      data.dimensions.groupBy.push({
	        type: 'pattern',
	        dimension: 'uri',
	        patterns: patterns
	      });
	    }
	  }
	  return data.dimensions.filter;
	};
	
	var buildGroupByQueryForChartData = function buildGroupByQueryForChartData(data) {
	  return data.dimensions.groupBy;
	};
	
	var buildQuery = exports.buildQuery = function buildQuery(data) {
	  var query = {};
	  query.metrics = buildMetricsQueryForChartData(data);
	  query.timeRange = data.timeRange;
	  if (data.dimensions && data.dimensions.filter && data.dimensions.filter.fields && data.dimensions.filter.fields.length) {
	    query.filter = buildFilterQueryForChartData(data);
	  }
	  if (data.dimensions && data.dimensions.groupBy.length) {
	    query.groupBy = buildGroupByQueryForChartData(data);
	  }
	  return query;
	};
	
	exports.default = buildQuery;
	
	
	var buildMetricsQuery = function buildMetricsQuery(data) {
	  return {
	    type: data.selectedMetric.value,
	    aggregation: aggregationValueMap[data.selectedMetric.value]
	  };
	};
	
	var buildTimeRangeQuery = function buildTimeRangeQuery(data) {
	  return data.timeRange || {
	    type: 'period',
	    period: '7D',
	    aggregation: 'day'
	  };
	};
	
	var buildDimensionsQuery = function buildDimensionsQuery(data) {
	  var selectedDataSource = data.selectedDataSource;
	
	  var filterGroupByData = [];
	  var filterFieldsData = {};
	  var filterFields = [];
	  (0, _each2.default)(selectedDataSource, function (dataSource) {
	    if (dataSource.type === 'in') {
	      var updatedDataSource = Object.assign({}, dataSource, { values: (0, _keys2.default)(dataSource.values) });
	      filterFields.push(updatedDataSource);
	    } else if (dataSource.type === 'top' || dataSource.type === 'range' || dataSource.type === 'default') {
	      filterGroupByData.push(dataSource);
	    } else if (dataSource.dimension === 'uri') {
	      filterFields.push(dataSource);
	    } else {
	      filterFields.push(dataSource);
	    }
	  });
	  if (filterFields.length > 0) {
	    filterFieldsData = { type: 'and', fields: filterFields };
	  }
	  return {
	    filter: filterFieldsData,
	    groupBy: filterGroupByData,
	    dimensionSelectionOrder: data.dimensionOrder
	  };
	};
	
	var buildSaveQuery = exports.buildSaveQuery = function buildSaveQuery(data) {
	  var saveQuery = {};
	  saveQuery.name = data.title;
	  saveQuery.description = data.description;
	  saveQuery.chartType = 'trend';
	  saveQuery.metrics = buildMetricsQuery(data);
	  saveQuery.timeRange = buildTimeRangeQuery(data);
	  saveQuery.dimensions = buildDimensionsQuery(data);
	  return saveQuery;
	};

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearMetricsHoverState = exports.clearHistoricalDataMutations = exports.convertWeekRangeToCustom = exports.getStartAndEndRangeWithTimeForLastNDays = exports.getStartAndEndRangeForLastNDays = exports.getParamsForHistoricalUsageData = exports.getParamsForHistoricalData = exports.getYAxisTicks = exports.getParamsFromQueryData = exports.getMonthlyUsageParamsFromQueryData = exports.getMonthlyUsageAggregation = exports.getAggregation = exports.getCustomReportAggregation = exports.getUsageRangeData = exports.getDateRangeData = exports.getTickValuesMap = exports.getStrokeColor = exports.lightShadeLineColors = exports.lineColors = undefined;
	exports.getDisplayDate = getDisplayDate;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _forEach = __webpack_require__(438);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _uniq = __webpack_require__(99);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _metrics = __webpack_require__(1561);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var lineColors = exports.lineColors = ['#B51629', '#8B802D', '#3C1279', '#FF9966', '#89D3E5', '#159540', '#169BD5', '#FFCC00', '#FF00FF', '#B3716C'];
	var lightShadeLineColors = exports.lightShadeLineColors = ['#FFCC0066', '#FF996666', '#15954066', '#169BD566', '#93A7B166', '#B1A0C966', '#3C127966', '#8B802D66', '#B5162966', '#00000066'];
	
	var getStrokeColor = exports.getStrokeColor = function getStrokeColor(lineColorsParam, index) {
	  return lineColorsParam[index > lineColorsParam.length ? index % lineColorsParam.length : index];
	};
	
	var getHourlyTickValuesMapForCustomRange = function getHourlyTickValuesMapForCustomRange(xAxisTickValues, startDate) {
	  var returnValues = {};
	  returnValues.xAxisValuesTickMap = {};
	  returnValues.xAxisTickValuesMap = {};
	  var startDateString = _moment2.default.utc(startDate).format('YYYY-MM-DD');
	  (0, _forEach2.default)(xAxisTickValues, function (item) {
	    var timeString = _moment2.default.utc(startDateString, 'YYYY-MM-DD').startOf('hour').add(item, 'hour').format();
	    returnValues.xAxisTickValuesMap[item] = timeString;
	    returnValues.xAxisValuesTickMap[timeString] = item;
	  });
	  return returnValues;
	};
	
	var getDailyTickValuesMapForCustomRange = function getDailyTickValuesMapForCustomRange(xAxisTickValues, startDate, days) {
	  var returnValues = {};
	  returnValues.xAxisValuesTickMap = {};
	  returnValues.xAxisTickValuesMap = {};
	  var startDateString = _moment2.default.utc(startDate).format('YYYY-MM-DD');
	  // special case if a single day was selected. show it in the middle
	  if (days === 1) {
	    var currentDayStr = _moment2.default.utc(startDateString, 'YYYY-MM-DD').startOf('day').format();
	    returnValues.xAxisTickValuesMap[1] = currentDayStr;
	    returnValues.xAxisValuesTickMap[currentDayStr] = 1;
	  } else {
	    (0, _forEach2.default)(xAxisTickValues, function (item) {
	      var timeString = _moment2.default.utc(startDateString, 'YYYY-MM-DD').startOf('day').add(item, 'day').format();
	      returnValues.xAxisTickValuesMap[item] = timeString;
	      returnValues.xAxisValuesTickMap[timeString] = item;
	    });
	  }
	  return returnValues;
	};
	
	var getUnitFromAggregation = function getUnitFromAggregation(timeAgg) {
	  return timeAgg && timeAgg.replace('by-', '');
	};
	
	var getTickValuesMap = exports.getTickValuesMap = function getTickValuesMap(timeAgg, xAxisTickValues, endDate) {
	  var returnValues = {};
	  var totalCount = xAxisTickValues.length - 1;
	  returnValues.xAxisValuesTickMap = {};
	  returnValues.xAxisTickValuesMap = {};
	  var unit = getUnitFromAggregation(timeAgg);
	  (0, _forEach2.default)(xAxisTickValues, function (item) {
	    var timeString = _moment2.default.utc(endDate).startOf(unit).subtract(totalCount - item, unit).format();
	    returnValues.xAxisTickValuesMap[item] = timeString;
	    returnValues.xAxisValuesTickMap[timeString] = item;
	  });
	  return returnValues;
	};
	
	var getMonthlyTickValuesMapForCustomRange = function getMonthlyTickValuesMapForCustomRange(xAxisTickValues, adjustedStartDate, endDateParam) {
	  var returnValues = {};
	  returnValues.xAxisValuesTickMap = {};
	  returnValues.xAxisTickValuesMap = {};
	  var startDateString = _moment2.default.utc(adjustedStartDate).format('YYYY-MM-DD');
	  if (adjustedStartDate.year() === endDateParam.year() && adjustedStartDate.month() === endDateParam.month()) {
	    var currentDayStr = _moment2.default.utc(startDateString, 'YYYY-MM-DD').startOf('day').format();
	    returnValues.xAxisTickValuesMap[1] = currentDayStr;
	    returnValues.xAxisValuesTickMap[currentDayStr] = 1;
	  } else {
	    (0, _forEach2.default)(xAxisTickValues, function (item) {
	      var timeString = _moment2.default.utc(startDateString, 'YYYY-MM-DD').startOf('month').add(item, 'month').format();
	      returnValues.xAxisTickValuesMap[item] = timeString;
	      returnValues.xAxisValuesTickMap[timeString] = item;
	    });
	  }
	  return returnValues;
	};
	
	var getUsageMonthlyTickValuesMapForCustomRange = function getUsageMonthlyTickValuesMapForCustomRange(xAxisTickValues, adjustedStartDate, endDateParam) {
	  var returnValues = {};
	  returnValues.xAxisValuesTickMap = {};
	  returnValues.xAxisTickValuesMap = {};
	  var startDateString = _moment2.default.utc(adjustedStartDate).format('YYYY-MM-DD');
	  if (adjustedStartDate.year() === endDateParam.year() && adjustedStartDate.month() === endDateParam.month()) {
	    var startDayStr = _moment2.default.utc(startDateString, 'YYYY-MM-DD').startOf('day').format();
	    returnValues.xAxisTickValuesMap[1] = startDayStr;
	    returnValues.xAxisValuesTickMap[startDayStr] = 1;
	  } else {
	    (0, _forEach2.default)(xAxisTickValues, function (item) {
	      var timeString = _moment2.default.utc(startDateString, 'YYYY-MM-DD').add(item * 30, 'days').format();
	      returnValues.xAxisTickValuesMap[item] = timeString;
	      returnValues.xAxisValuesTickMap[timeString] = item;
	    });
	  }
	  return returnValues;
	};
	
	var getWeeklyTickValuesMapForCustomRange = function getWeeklyTickValuesMapForCustomRange(xAxisTickValues, adjustedStartDate) {
	  var returnValues = {};
	  returnValues.xAxisValuesTickMap = {};
	  returnValues.xAxisTickValuesMap = {};
	  var startDateString = _moment2.default.utc(adjustedStartDate).format('YYYY-MM-DD');
	  (0, _forEach2.default)(xAxisTickValues, function (item) {
	    var timeString = _moment2.default.utc(startDateString, 'YYYY-MM-DD').add(item, 'week').format();
	    returnValues.xAxisTickValuesMap[item] = timeString;
	    returnValues.xAxisValuesTickMap[timeString] = item;
	  });
	  return returnValues;
	};
	
	var getTicksLength = function getTicksLength(dateRange, aggregation) {
	  var length = void 0;
	  var hours = void 0;
	  if (dateRange === 'day') {
	    length = 24;
	  } else if (dateRange === 'hour') {
	    length = 60;
	  } else if (dateRange === 'week') {
	    length = 7;
	    if (aggregation === 'by-hour') {
	      hours = (0, _moment2.default)().utc().hours() + 1;
	      length = 6 * 24 + hours;
	    }
	  } else if (dateRange === 'month') {
	    length = 30;
	    if (aggregation === 'by-hour') {
	      hours = (0, _moment2.default)().utc().hours() + 1;
	      length = 29 * 24 + hours;
	    }
	  }
	  return length;
	};
	
	var getDefaultTimeRangesData = function getDefaultTimeRangesData(dateRange, aggregation, endDate) {
	  var key = getTicksLength(dateRange, aggregation);
	  var xAxisTickValues = [].concat(_toConsumableArray(Array(key).keys()));
	  var returnValues = getTickValuesMap(aggregation, xAxisTickValues, endDate);
	  return {
	    xAxisTickValues: xAxisTickValues,
	    returnValues: returnValues
	  };
	};
	
	var getCustomTimeRangesData = function getCustomTimeRangesData(startDate, endDate, aggregation) {
	  var getHourlyAggData = function getHourlyAggData(startDateParam, endDateParam) {
	    var selectedDays = endDateParam.startOf('day').diff(startDateParam.startOf('day'), 'days') + 1;
	    // const totalDays = getRoundedDays(selectedDays);
	    var xAxisTickValues = [].concat(_toConsumableArray(Array(selectedDays * 24).keys()));
	    var returnValues = getHourlyTickValuesMapForCustomRange(xAxisTickValues, startDateParam);
	    return {
	      xAxisTickValues: xAxisTickValues,
	      returnValues: returnValues
	    };
	  };
	  var getDailyAggData = function getDailyAggData(startDateParam, endDateParam) {
	    var selectedDays = endDateParam.startOf('day').diff(startDateParam.startOf('day'), 'days') + 1;
	    var xAxisTickValues = void 0;
	    if (selectedDays === 1) {
	      xAxisTickValues = [].concat(_toConsumableArray(Array(3).keys()));
	    } else {
	      xAxisTickValues = [].concat(_toConsumableArray(Array(selectedDays).keys()));
	    }
	    var returnValues = getDailyTickValuesMapForCustomRange(xAxisTickValues, startDateParam, selectedDays);
	    return {
	      xAxisTickValues: xAxisTickValues,
	      returnValues: returnValues
	    };
	  };
	  var getWeeklyAggData = function getWeeklyAggData(startDateParam, endDateParam) {
	    var adjustedStartDate = _moment2.default.utc(startDateParam).startOf('isoWeek');
	    var adjustedEndDate = _moment2.default.utc(endDateParam).startOf('isoWeek');
	    var ticks = adjustedEndDate.diff(adjustedStartDate, 'weeks') + 1;
	    var xAxisTickValues = [].concat(_toConsumableArray(Array(ticks).keys()));
	    // show ticks from 1st of starting month to 1st of ending month
	    var returnValues = getWeeklyTickValuesMapForCustomRange(xAxisTickValues, adjustedStartDate, endDateParam, ticks);
	    return {
	      xAxisTickValues: xAxisTickValues,
	      returnValues: returnValues
	    };
	  };
	  var getMonthlyAggData = function getMonthlyAggData(startDateParam, endDateParam) {
	    var adjustedStartDate = _moment2.default.utc(startDateParam).startOf('month');
	    var adjustedEndDate = _moment2.default.utc(endDateParam).startOf('month');
	    var absoluteMonthsForStartDate = adjustedStartDate.year() * 12 + adjustedStartDate.month();
	    var absoluteMonthsForEndDate = adjustedEndDate.year() * 12 + adjustedEndDate.month();
	    var ticks = absoluteMonthsForEndDate - absoluteMonthsForStartDate + 1;
	    var xAxisTickValues = void 0;
	    if (adjustedStartDate.year() === endDateParam.year() && adjustedStartDate.month() === endDateParam.month()) {
	      xAxisTickValues = [].concat(_toConsumableArray(Array(3).keys()));
	    } else {
	      xAxisTickValues = [].concat(_toConsumableArray(Array(ticks).keys()));
	    }
	    // show ticks from 1st of starting month to 1st of ending month
	    var returnValues = getMonthlyTickValuesMapForCustomRange(xAxisTickValues, adjustedStartDate, endDateParam, ticks);
	    return {
	      xAxisTickValues: xAxisTickValues,
	      returnValues: returnValues
	    };
	  };
	  var data = {};
	  switch (aggregation) {
	    case 'by-hour':
	    case 'hour':
	      data = getHourlyAggData(startDate, endDate);
	      break;
	    case 'by-day':
	    case 'day':
	      data = getDailyAggData(startDate, endDate);
	      break;
	    case 'by-week':
	    case 'week':
	      data = getWeeklyAggData(startDate, endDate);
	      break;
	    case 'by-month':
	    case 'month':
	      data = getMonthlyAggData(startDate, endDate);
	      break;
	    default:
	      break;
	  }
	  return {
	    xAxisTickValues: data.xAxisTickValues,
	    returnValues: data.returnValues
	  };
	};
	
	function getDisplayDate(timeString, daterange, timeAgg, startDate, endDate, type) {
	  var nonTimeAggregated = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	  var chart = arguments[7];
	
	  var days = 0;
	  var timeObj = void 0;
	  var dateString = void 0;
	  var start = _moment2.default.utc(startDate);
	  var end = _moment2.default.utc(endDate);
	  if (daterange === 'custom') {
	    days = end.startOf('day').diff(start.startOf('day'), 'days');
	  }
	  var getWeekRange = function getWeekRange(date) {
	    var weekRangeStr = '';
	    var startOfWeek = _moment2.default.utc(date);
	    var endOfWeek = _moment2.default.utc(date).add(6, 'days');
	    var dateBreak = type === 'tooltip' ? '-' : '\n';
	
	    if (endOfWeek.isAfter(end)) {
	      endOfWeek = end;
	    } else if (startOfWeek < start) {
	      startOfWeek = start;
	    }
	
	    if (startOfWeek.isSame(endOfWeek, 'day')) {
	      weekRangeStr = startOfWeek.format('DD MMM YYYY');
	    } else {
	      weekRangeStr = startOfWeek.format('DD MMM YYYY') + ' ' + dateBreak + ' ' + endOfWeek.format('DD MMM YYYY');
	    }
	
	    return weekRangeStr;
	  };
	  var getTooltipDate = function getTooltipDate() {
	    switch (daterange) {
	      case 'hour':
	      case 'day':
	        return timeObj.format('MMM DD YYYY') + ' ' + timeObj.format('HH:mm');
	      case 'week':
	      case 'month':
	        return timeObj.format('MMM DD YYYY');
	      case 'custom':
	        {
	          var string = void 0;
	          if (timeAgg === 'by-hour' && days <= 2) {
	            string = timeObj.format('HH:mm') + ' ' + timeObj.format('MMM DD YYYY');
	          } else if (timeAgg === 'by-month') {
	            if (nonTimeAggregated) {
	              string = timeObj.format('DD MMM YYYY');
	            } else {
	              string = timeObj.format('MMM YYYY');
	            }
	          } else if (timeAgg === 'by-week') {
	            if (nonTimeAggregated) {
	              string = timeObj.format('DD MMM YYYY');
	            } else {
	              string = getWeekRange(timeObj);
	            }
	          } else {
	            string = timeObj.format('MMM DD YYYY');
	          }
	          return string;
	        }
	      default:
	        return '';
	    }
	  };
	  var getXaxisLabel = function getXaxisLabel(chartParam) {
	    switch (daterange) {
	      case 'hour':
	      case 'day':
	        return timeObj.format('MMM DD') + ' \n ' + timeObj.format('HH:mm');
	      case 'week':
	      case 'month':
	        return timeObj.format('MMM DD');
	      case 'custom':
	        {
	          var string = void 0;
	          if (timeAgg === 'by-hour' && days <= 2) {
	            string = timeObj.format('HH:mm') + ' \n ' + timeObj.format('MMM DD');
	          } else if (timeAgg === 'by-month') {
	            if (nonTimeAggregated) {
	              string = timeObj.format('DD MMM YYYY');
	            } else {
	              string = timeObj.format('MMM YYYY');
	            }
	          } else if (timeAgg === 'by-week') {
	            if (nonTimeAggregated) {
	              string = timeObj.format('DD MMM YYYY');
	            } else {
	              string = getWeekRange(timeObj);
	            }
	          } else {
	            string = timeObj.format('MMM DD');
	            if (chartParam === 'dailyQuota') {
	              string = timeObj.format('MMM DD') + ' \n ' + timeObj.format('HH:mm');
	            }
	          }
	          return string;
	        }
	      default:
	        return '';
	    }
	  };
	  var getDateLabelsForDailyQuota = function getDateLabelsForDailyQuota() {
	    var breakStr = type === 'tooltip' ? '' : '\n';
	    switch (daterange) {
	      case 'day':
	        return timeObj.format('HH:mm') + ' ' + breakStr + ' ' + timeObj.format('MMM DD');
	      case 'week':
	        return timeObj.format('HH:mm') + ' ' + breakStr + ' ' + timeObj.format('DD MMM YYYY');
	      case 'custom':
	        return timeObj.format('HH:mm') + ' ' + breakStr + ' ' + timeObj.format('DD MMM YYYY');
	      default:
	        return '';
	    }
	  };
	  if (timeString) {
	    timeObj = (0, _moment2.default)(timeString, _moment2.default.ISO_8601).utc();
	    if (chart === 'dailyQuota' && type === 'tooltip') {
	      dateString = getDateLabelsForDailyQuota();
	    } else if (type === 'tooltip') {
	      dateString = getTooltipDate();
	    } else {
	      dateString = getXaxisLabel(chart);
	    }
	  }
	  return dateString;
	}
	
	var getUsageCustomTimeRangesData = function getUsageCustomTimeRangesData(startDate, endDate, aggregation) {
	  var getHourlyAggData = function getHourlyAggData(startDateParam, endDateParam) {
	    var selectedDays = endDateParam.startOf('day').diff(startDateParam.startOf('day'), 'days') + 1;
	    // const totalDays = getRoundedDays(selectedDays);
	    var xAxisTickValues = [].concat(_toConsumableArray(Array(selectedDays * 24).keys()));
	    var returnValues = getHourlyTickValuesMapForCustomRange(xAxisTickValues, startDateParam);
	    return {
	      xAxisTickValues: xAxisTickValues,
	      returnValues: returnValues
	    };
	  };
	  var getDailyAggData = function getDailyAggData(startDateParam, endDateParam) {
	    var selectedDays = endDateParam.startOf('day').diff(startDateParam.startOf('day'), 'days') + 1;
	    var xAxisTickValues = void 0;
	    if (selectedDays === 1) {
	      xAxisTickValues = [].concat(_toConsumableArray(Array(3).keys()));
	    } else {
	      xAxisTickValues = [].concat(_toConsumableArray(Array(selectedDays).keys()));
	    }
	    var returnValues = getDailyTickValuesMapForCustomRange(xAxisTickValues, startDateParam, selectedDays);
	    return {
	      xAxisTickValues: xAxisTickValues,
	      returnValues: returnValues
	    };
	  };
	  var getWeeklyAggData = function getWeeklyAggData(startDateParam, endDateParam) {
	    var adjustedStartDate = _moment2.default.utc(startDateParam).startOf('day');
	    var adjustedEndDate = _moment2.default.utc(endDateParam).startOf('day');
	    var ticks = Math.ceil(adjustedEndDate.diff(adjustedStartDate, 'days') / 7) + 1;
	    var newStartDate = adjustedEndDate.subtract((ticks - 1) * 7, 'days');
	    var xAxisTickValues = [].concat(_toConsumableArray(Array(ticks).keys()));
	    // show ticks from 1st of starting month to 1st of ending month
	    var returnValues = getWeeklyTickValuesMapForCustomRange(xAxisTickValues, newStartDate, endDateParam, ticks);
	    return {
	      xAxisTickValues: xAxisTickValues,
	      returnValues: returnValues
	    };
	  };
	  var getMonthlyAggData = function getMonthlyAggData(startDateParam, endDateParam) {
	    var differenceInDays = _moment2.default.utc(endDateParam).diff(_moment2.default.utc(startDateParam), 'days');
	    var ticks = Math.ceil(differenceInDays / 30) + 1;
	    var xAxisTickValues = void 0;
	    if (startDateParam.year() === endDateParam.year() && startDateParam.month() === endDateParam.month()) {
	      xAxisTickValues = [].concat(_toConsumableArray(Array(3).keys()));
	    } else {
	      xAxisTickValues = [].concat(_toConsumableArray(Array(ticks).keys()));
	    }
	    var adjustedStartDate = _moment2.default.utc(endDateParam).startOf('day').subtract((ticks - 1) * 30, 'days');
	    var returnValues = getUsageMonthlyTickValuesMapForCustomRange(xAxisTickValues, adjustedStartDate, endDateParam, ticks);
	    return {
	      xAxisTickValues: xAxisTickValues,
	      returnValues: returnValues
	    };
	  };
	  var data = {};
	  switch (aggregation) {
	    case 'by-hour':
	      data = getHourlyAggData(startDate, endDate);
	      break;
	    case 'by-day':
	      data = getDailyAggData(startDate, endDate);
	      break;
	    case 'by-week':
	      data = getWeeklyAggData(startDate, endDate);
	      break;
	    case 'by-month':
	      data = getMonthlyAggData(startDate, endDate);
	      break;
	    default:
	      break;
	  }
	  return {
	    xAxisTickValues: data.xAxisTickValues,
	    returnValues: data.returnValues
	  };
	};
	
	var getDateRangeData = exports.getDateRangeData = function getDateRangeData(dateRange, timeAgg, startDate, endDate) {
	  var dateRangeData = {};
	  if (dateRange === 'custom') {
	    dateRangeData = getCustomTimeRangesData(_moment2.default.utc(startDate), _moment2.default.utc(endDate), timeAgg);
	  } else {
	    dateRangeData = getDefaultTimeRangesData(dateRange, timeAgg, endDate);
	  }
	  return {
	    xAxisTickValues: dateRangeData.xAxisTickValues,
	    xAxisValuesTickMap: dateRangeData.returnValues.xAxisValuesTickMap,
	    xAxisTickValuesMap: dateRangeData.returnValues.xAxisTickValuesMap,
	    dateRange: dateRange,
	    timeAgg: timeAgg,
	    startDate: startDate,
	    endDate: endDate
	  };
	};
	
	var timerangeTypeMap = {
	  week: _metrics.TYPE_BY_DAY,
	  day: _metrics.TYPE_BY_HOUR,
	  hour: _metrics.TYPE_BY_MINUTE
	};
	
	var getUsageRangeData = exports.getUsageRangeData = function getUsageRangeData(dateRange, timeAgg, startDate, endDate) {
	  var dateRangeData = {};
	  if (dateRange === 'custom') {
	    dateRangeData = getUsageCustomTimeRangesData(_moment2.default.utc(startDate), _moment2.default.utc(endDate), timeAgg);
	  } else {
	    dateRangeData = getDefaultTimeRangesData(dateRange, timeAgg, endDate);
	  }
	  return {
	    xAxisTickValues: dateRangeData.xAxisTickValues,
	    xAxisValuesTickMap: dateRangeData.returnValues.xAxisValuesTickMap,
	    xAxisTickValuesMap: dateRangeData.returnValues.xAxisTickValuesMap,
	    dateRange: dateRange,
	    timeAgg: timeAgg,
	    startDate: startDate,
	    endDate: endDate
	  };
	};
	
	var getCustomReportAggregation = exports.getCustomReportAggregation = function getCustomReportAggregation(days) {
	  switch (true) {
	    case days <= 2:
	      return _metrics.TIME_RANGE_HOUR;
	    case days <= 60:
	      return _metrics.TIME_RANGE_DAY;
	    case days <= 366:
	      return _metrics.TIME_RANGE_WEEK;
	    case days <= 731:
	      return _metrics.TIME_RANGE_MONTH;
	    default:
	      return _metrics.TIME_RANGE_DAY;
	  }
	};
	
	var getAggregation = exports.getAggregation = function getAggregation(timerange, startDate, endDate) {
	  var aggregation = timerangeTypeMap[timerange] || _metrics.TYPE_BY_DAY;
	  if (timerange === 'custom') {
	    var days = (0, _moment2.default)(endDate).diff(startDate, 'days') + 1;
	    switch (true) {
	      case days <= 2:
	        aggregation = _metrics.TYPE_BY_HOUR;
	        break;
	      case days <= 60:
	        aggregation = _metrics.TYPE_BY_DAY;
	        break;
	      case days <= 366:
	        aggregation = _metrics.TYPE_BY_WEEK;
	        break;
	      case days <= 1800:
	        aggregation = _metrics.TYPE_BY_MONTH;
	        break;
	      default:
	        aggregation = _metrics.TYPE_BY_DAY;
	        break;
	    }
	  }
	  return aggregation;
	};
	
	var getMonthlyUsageAggregation = exports.getMonthlyUsageAggregation = function getMonthlyUsageAggregation(timerange, startDate, endDate) {
	  var aggregation = _metrics.TYPE_BY_DAY;
	  if (timerange === 'custom') {
	    var days = (0, _moment2.default)(endDate).diff(startDate, 'days') + 1;
	    switch (true) {
	      case days <= 60:
	        aggregation = _metrics.TYPE_BY_DAY;
	        break;
	      case days <= 366:
	        aggregation = _metrics.TYPE_BY_WEEK;
	        break;
	      case days <= 1800:
	        aggregation = _metrics.TYPE_BY_MONTH;
	        break;
	      default:
	        aggregation = _metrics.TYPE_BY_DAY;
	        break;
	    }
	  }
	  return aggregation;
	};
	
	var getMonthlyUsageParamsFromQueryData = exports.getMonthlyUsageParamsFromQueryData = function getMonthlyUsageParamsFromQueryData() {
	  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var timerange = query.timerange && query.timerange.replace('(default)', '');
	  var startDate = query.startTimeGMT && query.startTimeGMT.replace('(default)', '');
	  var endDate = query.endTimeGMT && query.endTimeGMT.replace('(default)', '');
	
	  // todo: remove this hack, once it is fixed in backend
	  if (timerange === 'custom') {
	    var endDateObj = _moment2.default.utc(endDate).subtract(1, 'hour');
	    endDate = endDateObj.format('YYYY-MM-DD') + 'T' + endDateObj.format('HH:mm:SS');
	  }
	
	  return {
	    timerange: timerange,
	    timeAgg: getMonthlyUsageAggregation(timerange, startDate, endDate),
	    startDate: startDate,
	    endDate: endDate
	  };
	};
	
	var getParamsFromQueryData = exports.getParamsFromQueryData = function getParamsFromQueryData() {
	  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var timerange = query.timerange && query.timerange.replace('(default)', '');
	  var startDate = query.startTimeGMT && query.startTimeGMT.replace('(default)', '');
	  var endDate = query.endTimeGMT && query.endTimeGMT.replace('(default)', '');
	
	  // todo: remove this hack, once it is fixed in backend
	  if (timerange === 'custom') {
	    var endDateObj = _moment2.default.utc(endDate).subtract(1, 'hour');
	    endDate = endDateObj.format('YYYY-MM-DD') + 'T' + endDateObj.format('HH:mm:SS');
	  }
	
	  return {
	    timerange: timerange,
	    timeAgg: getAggregation(timerange, startDate, endDate),
	    startDate: startDate,
	    endDate: endDate
	  };
	};
	
	var getYAxisTicks = exports.getYAxisTicks = function getYAxisTicks(max) {
	  var yTicks = [];
	  var suffix = '';
	  var paddingFactor = 1;
	  var decimalPoint = 2;
	  if (max > 0) {
	    var padding = 0;
	    if (max > 0 && max <= 1) {
	      if (max < 0.01) {
	        decimalPoint = 3;
	      } else if (max < 0.001) {
	        decimalPoint = 4;
	      }
	      padding = (max / 5).toFixed(decimalPoint);
	    } else if (max < 10) {
	      padding = 1;
	      if (max > 5) {
	        padding++;
	      }
	    } else {
	      var length = max.toFixed(0).toString().length;
	      padding = Math.ceil(max / 5);
	      if (length > 12) {
	        paddingFactor = Math.pow(10, 12);
	        suffix = 'T';
	      } else if (length > 9) {
	        paddingFactor = Math.pow(10, 9);
	        suffix = 'B';
	      } else if (length > 6) {
	        paddingFactor = Math.pow(10, 6);
	        suffix = 'M';
	      } else if (length > 3) {
	        paddingFactor = Math.pow(10, 3);
	        suffix = 'K';
	      } else if (padding >= 100) {
	        paddingFactor = 100;
	      } else if (padding >= 10) {
	        paddingFactor = 10;
	      } else if (padding >= 5) {
	        paddingFactor = 5;
	      }
	      padding = Math.ceil(padding / paddingFactor) * paddingFactor;
	      paddingFactor = paddingFactor < 1000 ? 1 : paddingFactor;
	    }
	    var item = 0;
	    for (var i = 0; item < max; i++) {
	      item = padding > 0 && padding < 1 ? parseFloat((padding * i).toFixed(decimalPoint)) : padding * i;
	      yTicks.push(item);
	    }
	  }
	  return { yTicks: yTicks, paddingFactor: paddingFactor, suffix: suffix };
	};
	
	var getParamsForHistoricalData = exports.getParamsForHistoricalData = function getParamsForHistoricalData(query, timeRange, entityData) {
	  /*
	  show no data for unsupported time ranges
	  */
	  var params = {};
	  params.buckets = query.buckets ? query.buckets.split(',') : [];
	  params.limit = [];
	  var bucketMap = { apis: 'apiIds', apps: 'appIds', orgs: 'orgIds' };
	  var entityDataBucketMap = { apis: 'apiId', apps: 'appId', orgs: 'orgId' };
	  (0, _forEach2.default)(params.buckets, function (bucket) {
	    params[bucketMap[bucket]] = [];
	    (0, _forEach2.default)(entityData.buckets, function (data) {
	      params[bucketMap[bucket]].push(data[entityDataBucketMap[bucket]]);
	    });
	    params[bucketMap[bucket]] = (0, _uniq2.default)(params[bucketMap[bucket]]);
	    var entityIds = params[bucketMap[bucket]];
	    params[bucketMap[bucket]] = params[bucketMap[bucket]].join();
	    params.limit.push(entityIds.length);
	  });
	  params.stats = query.stats ? [query.stats] : null;
	  params.timerange = 'custom';
	  var startDate = query.startTimeGMT && query.startTimeGMT.replace('(default)', '');
	  var endDate = query.endTimeGMT && query.endTimeGMT.replace('(default)', '');
	  params.aggregation = getAggregation(params.timerange, startDate, endDate);
	
	  if (timeRange === _metrics.HISTORICAL_METRIC_30DAYS) {
	    var noOfDays = 30;
	    var pastStartDate = _moment2.default.utc(startDate).subtract(noOfDays, 'days');
	    params.startDate = pastStartDate.format('YYYY-MM-DD');
	    var pastEndDate = _moment2.default.utc(endDate).subtract(noOfDays, 'days');
	    params.endDate = pastEndDate.format('YYYY-MM-DD');
	    params.metricType = _metrics.HISTORICAL_METRIC_30DAYS;
	  } else if (timeRange === _metrics.HISTORICAL_METRIC_52WEEKS) {
	    var _noOfDays = 52 * 7;
	    var _pastStartDate = _moment2.default.utc(startDate).subtract(_noOfDays, 'days');
	    params.startDate = _pastStartDate.format('YYYY-MM-DD');
	    var _pastEndDate = _moment2.default.utc(endDate).subtract(_noOfDays, 'days');
	    params.endDate = _pastEndDate.format('YYYY-MM-DD');
	    params.metricType = _metrics.HISTORICAL_METRIC_52WEEKS;
	  }
	  if (query.timerange === 'day') {
	    params.endDate = params.startDate;
	  }
	  return params;
	};
	
	var getParamsForHistoricalUsageData = exports.getParamsForHistoricalUsageData = function getParamsForHistoricalUsageData(query, timeRange, orgIds, isMonthly) {
	  /*
	  show no data for unsupported time ranges
	  */
	  var params = {};
	  params.orgIds = orgIds.join(',');
	  params.limit = [orgIds.length];
	  params.planType = query.planType;
	  params.stats = query.stats ? [query.stats] : null;
	  params.timerange = 'custom';
	
	  var startDate = query.startTimeGMT && query.startTimeGMT.replace('(default)', '');
	  var endDate = query.endTimeGMT && query.endTimeGMT.replace('(default)', '');
	  // not supporting 'last 1 hour' for usage in UI, but handling it
	  if (query.timerange === 'hour' || query.timerange === 'day') {
	    endDate = startDate;
	  } else if (query.timerange === 'week') {
	    endDate = _moment2.default.utc(startDate).add(6, 'days');
	  }
	
	  if (isMonthly) {
	    params.aggregation = getMonthlyUsageAggregation(params.timerange, startDate, endDate);
	  } else {
	    params.aggregation = getAggregation(params.timerange, startDate, endDate);
	  }
	
	  if (timeRange === _metrics.HISTORICAL_METRIC_30DAYS) {
	    var noOfDays = 30;
	    var pastStartDate = _moment2.default.utc(startDate).subtract(noOfDays, 'days');
	    params.startDate = pastStartDate.format('YYYY-MM-DD');
	    var pastEndDate = _moment2.default.utc(endDate).subtract(noOfDays, 'days');
	    params.endDate = pastEndDate.format('YYYY-MM-DD');
	    params.metricType = _metrics.HISTORICAL_METRIC_30DAYS;
	  } else if (timeRange === _metrics.HISTORICAL_METRIC_52WEEKS) {
	    var _noOfDays2 = 52 * 7;
	    var _pastStartDate2 = _moment2.default.utc(startDate).subtract(_noOfDays2, 'days');
	    params.startDate = _pastStartDate2.format('YYYY-MM-DD');
	    var _pastEndDate2 = _moment2.default.utc(endDate).subtract(_noOfDays2, 'days');
	    params.endDate = _pastEndDate2.format('YYYY-MM-DD');
	    params.metricType = _metrics.HISTORICAL_METRIC_52WEEKS;
	  }
	  return params;
	};
	
	var getStartAndEndRangeForLastNDays = exports.getStartAndEndRangeForLastNDays = function getStartAndEndRangeForLastNDays(days) {
	  var endDate = _moment2.default.utc();
	  return {
	    endDate: endDate.format('YYYY-MM-DD'),
	    startDate: endDate.subtract('days', days - 1).format('YYYY-MM-DD')
	  };
	};
	
	var getStartAndEndRangeWithTimeForLastNDays = exports.getStartAndEndRangeWithTimeForLastNDays = function getStartAndEndRangeWithTimeForLastNDays(days) {
	  var endDate = _moment2.default.utc();
	  return {
	    endDate: endDate.format('YYYY-MM-DDTHH:mm:ss'),
	    startDate: endDate.subtract('days', days - 1).format('YYYY-MM-DDTHH:mm:ss')
	  };
	};
	
	var convertWeekRangeToCustom = exports.convertWeekRangeToCustom = function convertWeekRangeToCustom(params, withTime) {
	  var newParams = params;
	  if (newParams.timerange === 'week') {
	    newParams.timerange = 'custom';
	    var customDays = void 0;
	    if (withTime) {
	      customDays = getStartAndEndRangeWithTimeForLastNDays(7);
	    } else {
	      customDays = getStartAndEndRangeForLastNDays(7);
	    }
	    newParams.startDate = customDays.startDate;
	    newParams.endDate = customDays.endDate;
	  }
	  return newParams;
	};
	
	var clearHistoricalDataMutations = exports.clearHistoricalDataMutations = function clearHistoricalDataMutations(sharedMutations) {
	  var updatedSharedMutation = {};
	  (0, _forEach2.default)(sharedMutations, function (entityObj, entity) {
	    updatedSharedMutation[entity] = Object.assign({}, entityObj, {
	      metrics: Object.assign({}, entityObj && entityObj.metrics, {
	        customDate: {},
	        customWeek: {}
	      })
	    });
	  });
	  return updatedSharedMutation;
	};
	
	var clearMetricsHoverState = exports.clearMetricsHoverState = function clearMetricsHoverState(sharedMutations) {
	  var updatedSharedMutation = sharedMutations;
	  (0, _forEach2.default)(updatedSharedMutation, function (sharedMutationObj, sourceKey) {
	    (0, _forEach2.default)(sharedMutationObj.metrics, function (metricObj, metricKey) {
	      updatedSharedMutation[sourceKey].metrics[metricKey] = Object.assign({}, updatedSharedMutation[sourceKey].metrics[metricKey], {
	        hover: false
	      });
	    });
	  });
	  return updatedSharedMutation;
	};

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      typography = _ref.typography,
	      fontSize = _ref.fontSize,
	      margin = _ref.margin,
	      padding = _ref.padding;
	  return {
	    deploymentsContainer: {
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      width: '100%'
	    },
	    filterContainer: {
	      marginTop: (0, _lodash.get)(margin, 'm24')
	    },
	    fieldContainer: {
	      margin: (0, _lodash.get)(margin, 'm0') + ' !important'
	    },
	    bodyContent: {
	      padding: '0 36px'
	    },
	    selectField: {
	      padding: '2px 10px !important'
	    },
	    deploymentCard: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	    card: {
	      margin: (0, _lodash.get)(margin, 'm5'),
	      minHeight: 160,
	      marginLeft: (0, _lodash.get)(margin, 'm0')
	    },
	    cardTitle: {
	      fontSize: (0, _lodash.get)(fontSize, 'smallTitle'),
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      margin: '5px 0px'
	    },
	    cardType: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      marginTop: (0, _lodash.get)(margin, 'm5'),
	      marginBottom: (0, _lodash.get)(margin, 'm5'),
	      verticalAlign: 'text-bottom',
	      '& span': {
	        verticalAlign: 'bottom',
	        color: (0, _lodash.get)(color, 'bodyText'),
	        fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	        margin: 'auto 0'
	      }
	    },
	    cardStatus: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      marginTop: (0, _lodash.get)(margin, 'm5'),
	      marginBottom: (0, _lodash.get)(margin, 'm5')
	    },
	    cardStatusIcon: {
	      fontSize: 12
	    },
	    cardLastUpdated: {
	      color: (0, _lodash.get)(color, 'smallText'),
	      marginBottom: (0, _lodash.get)(margin, 'm10')
	    },
	    cardOldVersion: {
	      color: (0, _lodash.get)(color, 'smallText'),
	      marginBottom: (0, _lodash.get)(margin, 'm5'),
	      fontWeight: 'bold'
	    },
	    cardUpdateVersion: {
	      color: (0, _lodash.get)(color, 'smallText'),
	      marginLeft: (0, _lodash.get)(margin, 'm15'),
	      marginBottom: (0, _lodash.get)(margin, 'm5'),
	      marginTop: (0, _lodash.get)(margin, 'm5')
	    },
	    helpIcon: {
	      fontSize: 12,
	      margin: (0, _lodash.get)(margin, 'm4'),
	      verticalAlign: 'inherit',
	      cursor: 'pointer',
	      color: (0, _lodash.get)(color, 'link') + ' !important'
	    },
	    helpTextContainer: {
	      '& ui': {
	        padding: 0,
	        listStyleType: 'none'
	      }
	    },
	    boldText: {
	      fontWeight: 'bold'
	    },
	    linkWrapper: {
	      '& a': {
	        cursor: 'pointer',
	        border: 'none !important',
	        margin: (0, _lodash.get)(margin, 'm0') + ' !important',
	        padding: (0, _lodash.get)(padding, 'p0') + ' !important',
	        height: '0px !important',
	        fontWeight: '300 !important',
	        color: (0, _lodash.get)(color, 'link') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:hover': {
	        color: (0, _lodash.get)(color, 'linkHover') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:focus': {
	        boxShadow: 'none !important',
	        outline: '0px !important',
	        textDecoration: 'none'
	      }
	    },
	    actionLink: {
	      margin: (0, _lodash.get)(margin, 'm10')
	    },
	    deploymentButtonsContainer: {
	      margin: (0, _lodash.get)(margin, 'm5'),
	      '& button:first-of-type': {
	        paddingLeft: (0, _lodash.get)(padding, 'p10') + ' !important'
	      },
	      '& button': {
	        border: 'none',
	        margin: (0, _lodash.get)(margin, 'm0'),
	        padding: (0, _lodash.get)(padding, 'p0'),
	        paddingRight: (0, _lodash.get)(padding, 'p10') + ' !important',
	        paddingBottom: (0, _lodash.get)(padding, 'p5') + '  !important',
	        height: 'auto',
	        lineHeight: '1 !important',
	        fontWeight: '300 !important',
	        color: (0, _lodash.get)(color, 'link') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        verticalAlign: 'initial',
	        textTransform: 'none',
	        textDecoration: 'none'
	      },
	      '& button:hover': {
	        color: (0, _lodash.get)(color, 'linkHover') + ' !important',
	        textTransform: 'none',
	        textDecoration: 'none'
	      },
	      '& button:focus': {
	        boxShadow: 'none !important',
	        outline: '0px !important',
	        textTransform: 'none',
	        textDecoration: 'none'
	      }
	    },
	    checkStatusContainer: {
	      margin: -5
	    },
	    checkStatusButtonContainer: {
	      display: 'block'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEPLOYMENT_STATUS_DEPLOYED = exports.DEPLOYMENT_STATUS_NOT_DEPLOYED = exports.DEPLOYMENT_STATUS_UNDEPLOYED_ERROR = exports.DEPLOYMENT_STATUS_ERROR = exports.DEPLOYMENT_ACTION_TYPE_UNDEPLOY = exports.DEPLOYMENT_ACTION_TYPE_REDEPLOY = exports.DEPLOYMENT_ACTION_TYPE_DEPLOY = exports.DEPLOYMENT_STATUS_LABEL_UNDEPLOYED = exports.DEPLOYMENT_FILTER_BY_STATE = undefined;
	
	var _intl = __webpack_require__(15);
	
	var DEPLOYMENT_FILTER_BY_STATE = exports.DEPLOYMENT_FILTER_BY_STATE = [{
	  uuid: 'all',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.all')
	}, {
	  uuid: 'DEPLOYED',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.deployed')
	}, {
	  uuid: 'NOT_DEPLOYED',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.not.deployed')
	}, {
	  uuid: 'PENDING_DEPLOYMENT',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.pending.deployment')
	}, {
	  uuid: 'PENDING_UNDEPLOYMENT',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.pending.undeployment')
	}, {
	  uuid: 'ERROR_UNDEPLOY',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.error.undeploy')
	}, {
	  uuid: 'ERROR',
	  text: (0, _intl.getI18nFormattedMessage)('label.deployments.state.error')
	}];
	
	var DEPLOYMENT_STATUS_LABEL_UNDEPLOYED = exports.DEPLOYMENT_STATUS_LABEL_UNDEPLOYED = 'Not deployed';
	var DEPLOYMENT_ACTION_TYPE_DEPLOY = exports.DEPLOYMENT_ACTION_TYPE_DEPLOY = 'DEPLOY';
	var DEPLOYMENT_ACTION_TYPE_REDEPLOY = exports.DEPLOYMENT_ACTION_TYPE_REDEPLOY = 'REDEPLOY';
	var DEPLOYMENT_ACTION_TYPE_UNDEPLOY = exports.DEPLOYMENT_ACTION_TYPE_UNDEPLOY = 'UNDEPLOY';
	var DEPLOYMENT_STATUS_ERROR = exports.DEPLOYMENT_STATUS_ERROR = 'ERROR';
	var DEPLOYMENT_STATUS_UNDEPLOYED_ERROR = exports.DEPLOYMENT_STATUS_UNDEPLOYED_ERROR = 'ERROR_UNDEPLOY';
	var DEPLOYMENT_STATUS_NOT_DEPLOYED = exports.DEPLOYMENT_STATUS_NOT_DEPLOYED = 'NOT_DEPLOYED';
	var DEPLOYMENT_STATUS_DEPLOYED = exports.DEPLOYMENT_STATUS_DEPLOYED = 'DEPLOYED';

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Footer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _core = __webpack_require__(3);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _propTypes = __webpack_require__(5);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(283);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = exports.Footer = function Footer(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      id = _ref.id,
	      deploymentType = _ref.deploymentType,
	      tooltip = _ref.tooltip,
	      lastUpdated = _ref.lastUpdated;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  return _react2.default.createElement(
	    _core.Grid,
	    { container: true, className: classes.type },
	    deploymentType && _react2.default.createElement(
	      _core.Grid,
	      {
	        item: true, md: 6, sm: 6, xs: 12,
	        id: id + '-status-type', 'data-layer7-test': id + '-status-type'
	      },
	      _react2.default.createElement(
	        _core.Grid,
	        { container: true },
	        _react2.default.createElement(
	          _core.Grid,
	          { item: true },
	          _react2.default.createElement(
	            _core.Typography,
	            { variant: 'h5', className: classes.footerLabel },
	            intl.getI18nMessage('label.proxy.details.page.overview.deployment.type')
	          )
	        ),
	        tooltip && _react2.default.createElement(
	          _core.Tooltip,
	          { arrow: true, placement: 'right', title: tooltip },
	          _react2.default.createElement(
	            _core.IconButton,
	            {
	              size: 'small', edge: 'start', color: 'secondary',
	              className: classes.helpIcon,
	              'aria-label': id + '-help'
	            },
	            _react2.default.createElement(_Help2.default, null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _core.Typography,
	        { variant: 'body1' },
	        deploymentType
	      )
	    ),
	    _react2.default.createElement(
	      _core.Grid,
	      {
	        item: true, md: 6, sm: 6, xs: 12,
	        id: id + '-status-updated', 'data-layer7-test': id + '-status-updated'
	      },
	      lastUpdated && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'h5', className: classes.footerLabel },
	          intl.getI18nMessage('label.last.updated')
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'body1' },
	          (0, _datetime2.default)(lastUpdated)
	        )
	      )
	    )
	  );
	};
	
	Footer.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  deploymentType: _propTypes.string,
	  lastUpdated: _propTypes.string
	};
	Footer.displayName = 'Footer';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(Footer);

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Table = exports.TableRow = exports.TableHead = exports.getNotDeployedCount = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(8);
	
	var _core = __webpack_require__(3);
	
	var _StopRounded = __webpack_require__(960);
	
	var _StopRounded2 = _interopRequireDefault(_StopRounded);
	
	var _StopOutlined = __webpack_require__(959);
	
	var _StopOutlined2 = _interopRequireDefault(_StopOutlined);
	
	var _propTypes = __webpack_require__(5);
	
	var _intl = __webpack_require__(15);
	
	var _constants = __webpack_require__(14);
	
	var _styles = __webpack_require__(283);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getNotDeployedCount = exports.getNotDeployedCount = function getNotDeployedCount(_ref) {
	  var published = _ref.published,
	      pending = _ref.pending,
	      deployed = _ref.deployed,
	      error = _ref.error;
	
	  var notDeployedCount = published - (pending + deployed + error);
	  return notDeployedCount < 0 ? 0 : notDeployedCount;
	};
	
	var TableHead = exports.TableHead = function TableHead(_ref2) {
	  var _ref2$classes = _ref2.classes,
	      classes = _ref2$classes === undefined ? {} : _ref2$classes,
	      id = _ref2.id,
	      rowName = _ref2.rowName,
	      _ref2$cells = _ref2.cells,
	      cells = _ref2$cells === undefined ? [] : _ref2$cells;
	  return _react2.default.createElement(
	    _core.TableHead,
	    null,
	    _react2.default.createElement(
	      _core.TableRow,
	      { className: classes.tableRow },
	      id !== _constants.KEYS && _react2.default.createElement(
	        _core.TableCell,
	        { scope: 'row' },
	        rowName
	      ),
	      cells.map(function (_ref3) {
	        var key = _ref3.key,
	            value = _ref3.value,
	            cellClass = _ref3.cellClass;
	        return _react2.default.createElement(
	          _core.TableCell,
	          {
	            align: 'right',
	            key: key,
	            'data-layer7-test': id + '.' + key,
	            classes: { root: cellClass }
	          },
	          value
	        );
	      })
	    )
	  );
	};
	
	TableHead.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  rowName: _propTypes.string,
	  cells: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}))
	};
	
	var TableRow = exports.TableRow = function TableRow(_ref4) {
	  var _ref4$classes = _ref4.classes,
	      classes = _ref4$classes === undefined ? {} : _ref4$classes,
	      id = _ref4.id,
	      rowName = _ref4.rowName,
	      _ref4$cells = _ref4.cells,
	      cells = _ref4$cells === undefined ? [] : _ref4$cells;
	  return _react2.default.createElement(
	    _core.TableRow,
	    null,
	    id !== _constants.KEYS && _react2.default.createElement(
	      _core.TableCell,
	      { scope: 'row' },
	      rowName
	    ),
	    cells.map(function (_ref5) {
	      var key = _ref5.key,
	          value = _ref5.value,
	          onClick = _ref5.onClick,
	          cellClass = _ref5.cellClass;
	      return _react2.default.createElement(
	        _core.TableCell,
	        {
	          align: 'right',
	          key: key,
	          'data-layer7-test': id + '.' + key,
	          className: cellClass
	        },
	        onClick ? _react2.default.createElement(
	          _core.IconButton,
	          { className: classes.clickableCell, onClick: onClick },
	          _react2.default.createElement(
	            _core.Typography,
	            { variant: 'body1' },
	            value
	          )
	        ) : _react2.default.createElement(
	          _core.Typography,
	          { variant: 'body1' },
	          value
	        )
	      );
	    })
	  );
	};
	
	TableRow.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  rowName: _propTypes.string,
	  cells: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}))
	};
	
	var Table = exports.Table = function Table(props) {
	  var _props$classes = props.classes,
	      classes = _props$classes === undefined ? {} : _props$classes,
	      id = props.id,
	      isProxyDisconnected = props.isProxyDisconnected,
	      _props$publishedCount = props.publishedCount,
	      publishedCount = _props$publishedCount === undefined ? 0 : _props$publishedCount,
	      _props$pendingCount = props.pendingCount,
	      pendingCount = _props$pendingCount === undefined ? 0 : _props$pendingCount,
	      _props$deployedCount = props.deployedCount,
	      deployedCount = _props$deployedCount === undefined ? 0 : _props$deployedCount,
	      _props$errorCount = props.errorCount,
	      errorCount = _props$errorCount === undefined ? 0 : _props$errorCount,
	      _props$portalPublishe = props.portalPublishedCount,
	      portalPublishedCount = _props$portalPublishe === undefined ? 0 : _props$portalPublishe,
	      _props$portalPendingC = props.portalPendingCount,
	      portalPendingCount = _props$portalPendingC === undefined ? 0 : _props$portalPendingC,
	      _props$portalDeployed = props.portalDeployedCount,
	      portalDeployedCount = _props$portalDeployed === undefined ? 0 : _props$portalDeployed,
	      _props$portalErrorCou = props.portalErrorCount,
	      portalErrorCount = _props$portalErrorCou === undefined ? 0 : _props$portalErrorCou,
	      _props$gatewayPublish = props.gatewayPublishedCount,
	      gatewayPublishedCount = _props$gatewayPublish === undefined ? 0 : _props$gatewayPublish,
	      _props$gatewayPending = props.gatewayPendingCount,
	      gatewayPendingCount = _props$gatewayPending === undefined ? 0 : _props$gatewayPending,
	      _props$gatewayDeploye = props.gatewayDeployedCount,
	      gatewayDeployedCount = _props$gatewayDeploye === undefined ? 0 : _props$gatewayDeploye,
	      _props$gatewayErrorCo = props.gatewayErrorCount,
	      gatewayErrorCount = _props$gatewayErrorCo === undefined ? 0 : _props$gatewayErrorCo,
	      _props$otkCount = props.otkCount,
	      otkCount = _props$otkCount === undefined ? 0 : _props$otkCount,
	      showBreakdown = props.showBreakdown,
	      hideSubtotal = props.hideSubtotal,
	      linkUrl = props.linkUrl,
	      queryParams = props.queryParams,
	      push = props.push;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var onClickLink = function onClickLink(param) {
	    if (linkUrl) {
	      var qParam = (0, _lodash.get)(queryParams, param);
	      var link = qParam ? linkUrl + '/' + qParam : linkUrl;
	      push(link);
	    }
	  };
	
	  var portalNotDeployedCount = getNotDeployedCount({
	    published: portalPublishedCount,
	    pending: portalPendingCount,
	    deployed: portalDeployedCount,
	    error: portalErrorCount
	  });
	  var gatewayNotDeployedCount = getNotDeployedCount({
	    published: gatewayPublishedCount,
	    pending: gatewayPendingCount,
	    deployed: gatewayDeployedCount,
	    error: gatewayErrorCount
	  });
	  var notDeployedCount = getNotDeployedCount({
	    published: publishedCount,
	    pending: pendingCount,
	    deployed: deployedCount,
	    error: errorCount
	  });
	
	  var gatewayNotDeployedCountNaN = (0, _lodash.isNaN)(gatewayNotDeployedCount);
	
	  var labelPublished = id === _constants.KEYS ? intl.getI18nMessage('label.proxy.details.page.status.all.keys') : intl.getI18nMessage('label.proxy.details.page.status.published');
	
	  var tableHeadCellsDisconnected = [{
	    key: 'published',
	    value: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.IconButton,
	        { className: (0, _classnames2.default)(classes.icon, classes.publishedDisconnected) },
	        _react2.default.createElement(_StopOutlined2.default, null)
	      ),
	      intl.getI18nMessage('label.proxy.details.page.status.published')
	    )
	  }];
	
	  var tableHeadCells = [{
	    key: 'published',
	    value: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.IconButton,
	        { className: (0, _classnames2.default)(classes.icon, classes.published) },
	        _react2.default.createElement(_StopOutlined2.default, null)
	      ),
	      labelPublished
	    )
	  }, {
	    key: 'notDeployed',
	    value: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.IconButton,
	        { className: (0, _classnames2.default)(classes.icon, classes.notDeployed) },
	        _react2.default.createElement(_StopRounded2.default, null)
	      ),
	      intl.getI18nMessage('label.proxy.details.page.status.not.deployed')
	    )
	  }, {
	    key: 'pending',
	    value: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.IconButton,
	        { className: (0, _classnames2.default)(classes.icon, classes.pending) },
	        _react2.default.createElement(_StopRounded2.default, null)
	      ),
	      intl.getI18nMessage('label.proxy.details.page.status.pending')
	    )
	  }, {
	    key: 'deployed',
	    value: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.IconButton,
	        { className: (0, _classnames2.default)(classes.icon, classes.deployed) },
	        _react2.default.createElement(_StopRounded2.default, null)
	      ),
	      intl.getI18nMessage('label.proxy.details.page.status.deployed')
	    )
	  }, {
	    key: 'error',
	    value: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.IconButton,
	        { className: (0, _classnames2.default)(classes.icon, classes.error) },
	        _react2.default.createElement(_StopRounded2.default, null)
	      ),
	      intl.getI18nMessage('label.proxy.details.page.status.error')
	    )
	  }];
	
	  var otkTableHeadCell = {
	    key: 'otk',
	    value: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      intl.getI18nMessage('label.proxy.details.page.status.api.key.store')
	    ),
	    cellClass: classes.otkCell
	  };
	
	  var firstRowCells = [{
	    key: 'portal.published',
	    value: portalPublishedCount
	  }, {
	    key: 'portal.not.deployed',
	    value: portalNotDeployedCount
	  }, {
	    key: 'portal.pending',
	    value: portalPendingCount,
	    onClick: function onClick() {
	      return onClickLink('portalPending');
	    }
	  }, {
	    key: 'portal.deployed',
	    value: portalDeployedCount,
	    onClick: function onClick() {
	      return onClickLink('portalDeployed');
	    }
	  }, {
	    key: 'portal.error',
	    value: portalErrorCount,
	    onClick: function onClick() {
	      return onClickLink('portalError');
	    }
	  }];
	
	  var otkFirstRowCell = {
	    key: 'portal.otk',
	    value: otkCount,
	    cellClass: classes.otkCell
	  };
	
	  var totalRowCells = [{
	    key: 'total.published',
	    value: publishedCount
	  }, {
	    key: 'total.not.deployed',
	    value: notDeployedCount
	  }, {
	    key: 'total.pending',
	    value: pendingCount,
	    onClick: function onClick() {
	      return onClickLink('totalPending');
	    }
	  }, {
	    key: 'total.deployed',
	    value: deployedCount,
	    onClick: function onClick() {
	      return onClickLink('totalDeployed');
	    }
	  }, {
	    key: 'total.error',
	    value: errorCount,
	    onClick: function onClick() {
	      return onClickLink('totalError');
	    }
	  }];
	
	  var otkTotalRowCell = {
	    key: 'total.otk',
	    value: otkCount,
	    cellClass: classes.otkCell
	  };
	
	  if (id === _constants.KEYS) {
	    tableHeadCells.push(otkTableHeadCell);
	    firstRowCells.push(otkFirstRowCell);
	    totalRowCells.push(otkTotalRowCell);
	  }
	
	  return _react2.default.createElement(
	    _core.TableContainer,
	    null,
	    _react2.default.createElement(
	      _core.Table,
	      { size: 'small' },
	      isProxyDisconnected ? _react2.default.createElement(TableHead, {
	        classes: classes,
	        id: id,
	        rowName: intl.getI18nMessage('label.proxy.details.page.source'),
	        cells: tableHeadCellsDisconnected
	      }) : _react2.default.createElement(TableHead, {
	        classes: classes,
	        id: id,
	        rowName: intl.getI18nMessage('label.proxy.details.page.source'),
	        cells: tableHeadCells
	      }),
	      _react2.default.createElement(
	        _core.TableBody,
	        null,
	        showBreakdown && !hideSubtotal && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(TableRow, {
	            classes: classes,
	            id: id,
	            rowName: intl.getI18nMessage('label.proxy.details.api.portal.published'),
	            cells: isProxyDisconnected ? [{
	              key: 'portal.published',
	              value: portalPublishedCount
	            }] : firstRowCells
	          }),
	          _react2.default.createElement(TableRow, {
	            classes: classes,
	            id: id,
	            rowName: intl.getI18nMessage('label.proxy.details.api.gateway.published'),
	            cells: isProxyDisconnected ? [{
	              key: 'gateway.published',
	              value: gatewayPublishedCount
	            }] : [{
	              key: 'gateway.published',
	              value: gatewayPublishedCount
	            }, {
	              key: 'gateway.not.deployed',
	              value: gatewayNotDeployedCountNaN ? gatewayPublishedCount : gatewayNotDeployedCount
	            }, {
	              key: 'gateway.pending',
	              value: gatewayPendingCount,
	              onClick: !gatewayNotDeployedCountNaN && function () {
	                return onClickLink('gatewayPending');
	              }
	            }, {
	              key: 'gateway.deployed',
	              value: gatewayDeployedCount,
	              onClick: !gatewayNotDeployedCountNaN && function () {
	                return onClickLink('gatewayDeployed');
	              }
	            }, {
	              key: 'gateway.error',
	              value: gatewayErrorCount,
	              onClick: !gatewayNotDeployedCountNaN && function () {
	                return onClickLink('gatewayError');
	              }
	            }]
	          })
	        ),
	        _react2.default.createElement(TableRow, {
	          classes: classes,
	          id: id,
	          rowName: intl.getI18nMessage('label.proxy.details.api.total'),
	          cells: isProxyDisconnected ? [{
	            key: 'total.published',
	            value: publishedCount
	          }] : totalRowCells
	        })
	      )
	    )
	  );
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(Table);
	
	
	Table.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  isProxyDisconnected: _propTypes.bool,
	  publishedCount: _propTypes.number,
	  pendingCount: _propTypes.number,
	  deployedCount: _propTypes.number,
	  errorCount: _propTypes.number,
	  otkCount: _propTypes.number,
	  portalPublishedCount: _propTypes.number,
	  portalPendingCount: _propTypes.number,
	  portalDeployedCount: _propTypes.number,
	  portalErrorCount: _propTypes.number,
	  gatewayPublishedCount: _propTypes.number,
	  gatewayPendingCount: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
	  gatewayDeployedCount: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
	  gatewayErrorCount: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
	  showBreakdown: _propTypes.bool,
	  hideSubtotal: _propTypes.bool,
	  onClickLink: _propTypes.func,
	  linkUrl: _propTypes.string,
	  queryParams: (0, _propTypes.shape)({}),
	  push: _propTypes.func
	};

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Details = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _components = __webpack_require__(17);
	
	var _details = __webpack_require__(1698);
	
	var _details2 = _interopRequireDefault(_details);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Details = exports.Details = function Details(props) {
	  var classes = props.classes,
	      detailsPageId = props.detailsPageId,
	      isLoading = props.isLoading,
	      notificationId = props.notificationId,
	      notificationStatus = props.notificationStatus,
	      setNotificationStatus = props.setNotificationStatus,
	      notificationMessage = props.notificationMessage,
	      setNotificationMessage = props.setNotificationMessage,
	      _props$errors = props.errors,
	      errors = _props$errors === undefined ? [] : _props$errors,
	      header = props.header,
	      actions = props.actions,
	      pending = props.pending,
	      tabs = props.tabs,
	      page = props.page,
	      footer = props.footer;
	
	
	  var notifyMessages = function notifyMessages(status, message) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.content,
	      id: detailsPageId, 'data-apim-test': detailsPageId, 'data-layer7-test': detailsPageId
	    },
	    isLoading && _react2.default.createElement(_components.Loading, { pageLoader: true }),
	    notificationMessage && _react2.default.createElement(_components.AlertMessages, {
	      id: notificationId,
	      variant: notificationStatus,
	      message: notificationMessage,
	      containerClass: classes.notificationWidthClass,
	      onClose: function onClose() {
	        return notifyMessages('', '');
	      }
	    }),
	    errors.length > 0 && _react2.default.createElement(
	      'div',
	      { className: classes.errorContainer },
	      _react2.default.createElement(_components.ErrorContainer, { errors: errors })
	    ),
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.Grid,
	        { container: true, justify: 'space-between' },
	        _react2.default.createElement(
	          _core.Grid,
	          { item: true, md: 10, sm: 9, xs: 12 },
	          header
	        ),
	        _react2.default.createElement(
	          _core.Grid,
	          { item: true, md: 2, sm: 3, xs: 12, className: classes.actionsContainer },
	          actions
	        )
	      ),
	      pending ? _react2.default.createElement(
	        _react.Fragment,
	        null,
	        pending
	      ) : _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _core.Grid,
	          { container: true, className: classes.gridContainer },
	          tabs
	        ),
	        _react2.default.createElement(_core.Divider, { className: classes.divider }),
	        _react2.default.createElement(
	          _core.Grid,
	          null,
	          page
	        )
	      ),
	      footer
	    )
	  );
	};
	
	Details.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  detailsPageId: _propTypes.string,
	  isLoading: _propTypes.bool,
	  notificationId: _propTypes.string,
	  notificationStatus: _propTypes.string,
	  setNotificationStatus: _propTypes.func,
	  notificationMessage: _propTypes.string,
	  setNotificationMessage: _propTypes.func,
	  infoId: _propTypes.string,
	  errors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  header: (0, _propTypes.shape)({}),
	  actions: (0, _propTypes.shape)({}),
	  pending: (0, _propTypes.shape)({}),
	  tabs: (0, _propTypes.shape)({}),
	  page: (0, _propTypes.shape)({}),
	  footer: (0, _propTypes.shape)({})
	};
	Details.displayName = 'Details';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_details2.default))(Details);

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUserListResults = exports.getUserListTotalElements = exports.getIsUserDeleteSuccess = exports.getErrors = exports.getIsError = exports.getIsLoading = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case Constants.APP_RESET:
	      return Object.assign({}, state, resetState, {
	        isUserDeleteSuccess: false
	      });
	    case Constants.USERS_DELETE_RESET:
	      return Object.assign({}, state, resetState, {
	        isUserDeleteSuccess: false
	      });
	    case Constants.APP_LOADING:
	      return Object.assign({}, state, resetState, {
	        isLoading: action.isLoading
	      });
	    case Constants.USERS_GET_SUCCESS:
	      return Object.assign({}, state, {
	        isLoading: false,
	        isError: false,
	        errors: [],
	        users: action.payload,
	        isUserDeleteSuccess: localStorage.getItem('isUserDeleteSuccess') === 'true'
	      });
	    case Constants.USERS_GET_ERROR:
	      return Object.assign({}, state, {
	        isError: true,
	        isLoading: false,
	        errors: action.payload,
	        isUserDeleteSuccess: localStorage.getItem('isUserDeleteSuccess') === 'true'
	      });
	    default:
	      return state;
	  }
	};
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var resetState = {
	  isError: false,
	  errors: []
	};
	var initialState = Object.assign({}, resetState, {
	  isLoading: false,
	  users: {
	    totalPages: 1,
	    totalElements: 0,
	    results: []
	  }
	});
	
	var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
	  return (0, _lodash.get)(state, 'user.isLoading');
	};
	var getIsError = exports.getIsError = function getIsError(state) {
	  return (0, _lodash.get)(state, 'user.isError');
	};
	var getErrors = exports.getErrors = function getErrors(state) {
	  return (0, _lodash.get)(state, 'user.errors');
	};
	var getIsUserDeleteSuccess = exports.getIsUserDeleteSuccess = function getIsUserDeleteSuccess(state) {
	  return (0, _lodash.get)(state, 'user.isUserDeleteSuccess');
	};
	
	var getUserListTotalElements = exports.getUserListTotalElements = function getUserListTotalElements(state) {
	  return (0, _lodash.get)(state, 'user.users.count');
	};
	var getUserListResults = exports.getUserListResults = function getUserListResults(state) {
	  return (0, _lodash.get)(state, 'user.users.list');
	};

/***/ },
/* 624 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Refer to:
	 * 1. https://www.figma.com/file/EuhA9sV3JzlTdZuVvbz2L7/Portal-Components?node-id=118%3A1002
	 */
	exports.default = {
	  color: {
	    attention: '#F7CD3B',
	    attentionBackground: 'rgba(247, 205, 59, 0.15)',
	    danger: '#DE1B1B',
	    error: '#B30303',
	    errorBackground: 'rgba(179, 3, 3, 0.1)',
	    success: '#306204',
	    progress: '#97B081',
	    warning: '#FF944D',
	    warningBackground: 'rgba(255, 148, 77, 0.1)',
	    tooltipBackground: 'rgba(0, 0, 0, 0.9)',
	    tooltipText: '#FFFFFF'
	  },
	  borderRadius: {
	    br3: '3px',
	    br4: '4px'
	  },
	  boxShadow: {
	    none: 'none'
	  },
	  breakpoint: {
	    xl: '1920px',
	    lg: '1440px',
	    md: '1280px',
	    sm: '600px',
	    xs: '320px'
	  },
	  fontStyle: {
	    normal: 'normal'
	  },
	  fontWeight: {
	    bold: 'bold',
	    normal: 'normal',
	    semiBold: 600
	  },
	  letterSpacing: {
	    ls01: '0.1px'
	  },
	  lineHeight: {
	    lh14: '14px',
	    lh21: '21px',
	    lh20: '20px',
	    lh28: '28px',
	    lh32: '32px',
	    lh36: '36px',
	    lh48: '48px'
	  },
	  height: {
	    h40: '40px',
	    h72: '72px'
	  },
	  padding: {
	    p0: '0px',
	    p2: '2px',
	    p4: '4px',
	    p5: '5px',
	    p6: '6px',
	    p8: '8px',
	    p10: '10px',
	    p12: '12px',
	    p16: '16px',
	    p20: '20px',
	    p21: '21px',
	    p24: '24px',
	    p36: '36px',
	    p38: '38px',
	    p50: '50px'
	  },
	  margin: {
	    m0: '0px',
	    m2: '2px',
	    m4: '4px',
	    m5: '5px',
	    m6: '6px',
	    m8: '8px',
	    m10: '10px',
	    m12: '12px',
	    m15: '15px',
	    m21: '21px',
	    m24: '24px',
	    m28: '28px',
	    m36: '36px',
	    m60: '60px'
	  },
	  position: {
	    p3: '3px'
	  },
	  textTransform: {
	    capitalize: 'capitalize',
	    lowercase: 'lowercase',
	    none: 'none',
	    uppercase: 'uppercase'
	  },
	  whiteSpace: {
	    breakSpaces: 'break-spaces',
	    nowrap: 'nowrap'
	  },
	  zIndex: {
	    z800: 800
	  }
	};

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCanManageUser = exports.getCanCreateUser = exports.getCanListUsers = exports.getRoleLabel = exports.hasPublisherRole = exports.hasPortalAdminRole = exports.getUserRole = undefined;
	
	var _reactIntl = __webpack_require__(16);
	
	var _constants = __webpack_require__(14);
	
	var _intl = __webpack_require__(15);
	
	var getUserRole = exports.getUserRole = function getUserRole() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      portalAdmin = _ref.portalAdmin,
	      apiOwner = _ref.apiOwner,
	      orgAdmin = _ref.orgAdmin,
	      developer = _ref.developer,
	      orgPublisher = _ref.orgPublisher;
	
	  if (portalAdmin) {
	    return _constants.ROLE_PORTAL_ADMIN;
	  } else if (apiOwner) {
	    return _constants.ROLE_API_OWNER;
	  } else if (orgAdmin) {
	    return _constants.ROLE_ORG_ADMIN;
	  } else if (developer) {
	    return _constants.ROLE_DEVELOPER;
	  } else if (orgPublisher) {
	    return _constants.ROLE_ORG_PUBLISHER;
	  }
	  return null;
	};
	
	var hasPortalAdminRole = exports.hasPortalAdminRole = function hasPortalAdminRole(userContext) {
	  return _constants.ROLE_PORTAL_ADMIN === getUserRole(userContext);
	};
	
	var hasPublisherRole = exports.hasPublisherRole = function hasPublisherRole(userContext) {
	  return [_constants.ROLE_PORTAL_ADMIN, _constants.ROLE_API_OWNER].includes(getUserRole(userContext));
	};
	
	var getRoleLabel = exports.getRoleLabel = function getRoleLabel(_ref2) {
	  var roleName = _ref2.roleName;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  return intl.getI18nMessage('label.user.role.' + roleName);
	};
	
	var getCanListUsers = exports.getCanListUsers = function getCanListUsers(userContext) {
	  return [_constants.ROLE_PORTAL_ADMIN, _constants.ROLE_API_OWNER, _constants.ROLE_ORG_ADMIN].includes(getUserRole(userContext));
	};
	
	var getCanCreateUser = exports.getCanCreateUser = function getCanCreateUser(userContext) {
	  return [_constants.ROLE_PORTAL_ADMIN, _constants.ROLE_ORG_ADMIN].includes(getUserRole(userContext));
	};
	
	var getOrgAdminShouldNotEditOrgPublisher = function getOrgAdminShouldNotEditOrgPublisher(_ref3) {
	  var userContext = _ref3.userContext,
	      _ref3$access = _ref3.access,
	      access = _ref3$access === undefined ? [] : _ref3$access;
	
	  var isUserContextOrgAdmin = getUserRole(userContext) === _constants.ROLE_ORG_ADMIN;
	  var isOrgPublisher = access.find(function (role) {
	    return role.roleName === _constants.ROLE_ORG_PUBLISHER;
	  });
	  return !(isUserContextOrgAdmin && isOrgPublisher);
	};
	
	var getCanManageUser = exports.getCanManageUser = function getCanManageUser(_ref4) {
	  var uuid = _ref4.uuid,
	      userContext = _ref4.userContext,
	      _ref4$access = _ref4.access,
	      access = _ref4$access === undefined ? [] : _ref4$access;
	
	  var isNotSelf = userContext.uuid !== uuid;
	  var canCreateUser = getCanCreateUser(userContext);
	  return isNotSelf && getOrgAdminShouldNotEditOrgPublisher({ userContext: userContext, access: access }) && canCreateUser;
	};

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1177);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeAsyncSelect = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Select = _interopRequireDefault(__webpack_require__(206));
	
	var _utils = __webpack_require__(208);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(207));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultProps = {
	  cacheOptions: false,
	  defaultOptions: false,
	  filterOption: null
	};
	exports.defaultProps = defaultProps;
	
	var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Async, _Component);
	
	    function Async(props) {
	      var _this;
	
	      _classCallCheck(this, Async);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Async).call(this));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastRequest", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsCache", {});
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (newValue, actionMeta) {
	        var _this$props = _this.props,
	            cacheOptions = _this$props.cacheOptions,
	            onInputChange = _this$props.onInputChange; // TODO
	
	        var inputValue = (0, _utils.handleInputChange)(newValue, actionMeta, onInputChange);
	
	        if (!inputValue) {
	          delete _this.lastRequest;
	
	          _this.setState({
	            inputValue: '',
	            loadedInputValue: '',
	            loadedOptions: [],
	            isLoading: false,
	            passEmptyOptions: false
	          });
	
	          return;
	        }
	
	        if (cacheOptions && _this.optionsCache[inputValue]) {
	          _this.setState({
	            inputValue: inputValue,
	            loadedInputValue: inputValue,
	            loadedOptions: _this.optionsCache[inputValue],
	            isLoading: false,
	            passEmptyOptions: false
	          });
	        } else {
	          var request = _this.lastRequest = {};
	
	          _this.setState({
	            inputValue: inputValue,
	            isLoading: true,
	            passEmptyOptions: !_this.state.loadedInputValue
	          }, function () {
	            _this.loadOptions(inputValue, function (options) {
	              if (!_this.mounted) return;
	
	              if (options) {
	                _this.optionsCache[inputValue] = options;
	              }
	
	              if (request !== _this.lastRequest) return;
	              delete _this.lastRequest;
	
	              _this.setState({
	                isLoading: false,
	                loadedInputValue: inputValue,
	                loadedOptions: options || [],
	                passEmptyOptions: false
	              });
	            });
	          });
	        }
	
	        return inputValue;
	      });
	
	      _this.state = {
	        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
	        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
	        isLoading: props.defaultOptions === true ? true : false,
	        loadedOptions: [],
	        passEmptyOptions: false
	      };
	      return _this;
	    }
	
	    _createClass(Async, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this.mounted = true;
	        var defaultOptions = this.props.defaultOptions;
	        var inputValue = this.state.inputValue;
	
	        if (defaultOptions === true) {
	          this.loadOptions(inputValue, function (options) {
	            if (!_this2.mounted) return;
	            var isLoading = !!_this2.lastRequest;
	
	            _this2.setState({
	              defaultOptions: options || [],
	              isLoading: isLoading
	            });
	          });
	        }
	      }
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        // if the cacheOptions prop changes, clear the cache
	        if (nextProps.cacheOptions !== this.props.cacheOptions) {
	          this.optionsCache = {};
	        }
	
	        if (nextProps.defaultOptions !== this.props.defaultOptions) {
	          this.setState({
	            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
	          });
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.mounted = false;
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      }
	    }, {
	      key: "loadOptions",
	      value: function loadOptions(inputValue, callback) {
	        var loadOptions = this.props.loadOptions;
	        if (!loadOptions) return callback();
	        var loader = loadOptions(inputValue, callback);
	
	        if (loader && typeof loader.then === 'function') {
	          loader.then(callback, function () {
	            return callback();
	          });
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this3 = this;
	
	        var _this$props2 = this.props,
	            loadOptions = _this$props2.loadOptions,
	            props = _objectWithoutProperties(_this$props2, ["loadOptions"]);
	
	        var _this$state = this.state,
	            defaultOptions = _this$state.defaultOptions,
	            inputValue = _this$state.inputValue,
	            isLoading = _this$state.isLoading,
	            loadedInputValue = _this$state.loadedInputValue,
	            loadedOptions = _this$state.loadedOptions,
	            passEmptyOptions = _this$state.passEmptyOptions;
	        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this3.select = _ref;
	          },
	          options: options,
	          isLoading: isLoading,
	          onInputChange: this.handleInputChange
	        }));
	      }
	    }]);
	
	    return Async;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	exports.makeAsyncSelect = makeAsyncSelect;
	var SelectState = (0, _stateManager.default)(_Select.default);
	
	var _default = makeAsyncSelect(SelectState);
	
	exports.default = _default;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeCreatableSelect = exports.defaultProps = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Select = _interopRequireDefault(__webpack_require__(206));
	
	var _utils = __webpack_require__(208);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(207));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var compareOption = function compareOption() {
	  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var option = arguments.length > 1 ? arguments[1] : undefined;
	  var candidate = String(inputValue).toLowerCase();
	  var optionValue = String(option.value).toLowerCase();
	  var optionLabel = String(option.label).toLowerCase();
	  return optionValue === candidate || optionLabel === candidate;
	};
	
	var builtins = {
	  formatCreateLabel: function formatCreateLabel(inputValue) {
	    return "Create \"".concat(inputValue, "\"");
	  },
	  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
	    return !(!inputValue || selectValue.some(function (option) {
	      return compareOption(inputValue, option);
	    }) || selectOptions.some(function (option) {
	      return compareOption(inputValue, option);
	    }));
	  },
	  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
	    return {
	      label: optionLabel,
	      value: inputValue,
	      __isNew__: true
	    };
	  }
	};
	
	var defaultProps = _objectSpread({
	  allowCreateWhileLoading: false,
	  createOptionPosition: 'last'
	}, builtins);
	
	exports.defaultProps = defaultProps;
	
	var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Creatable, _Component);
	
	    function Creatable(props) {
	      var _this;
	
	      _classCallCheck(this, Creatable);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Creatable).call(this, props));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	        var _this$props = _this.props,
	            getNewOptionData = _this$props.getNewOptionData,
	            inputValue = _this$props.inputValue,
	            isMulti = _this$props.isMulti,
	            onChange = _this$props.onChange,
	            onCreateOption = _this$props.onCreateOption,
	            value = _this$props.value;
	
	        if (actionMeta.action !== 'select-option') {
	          return onChange(newValue, actionMeta);
	        }
	
	        var newOption = _this.state.newOption;
	        var valueArray = Array.isArray(newValue) ? newValue : [newValue];
	
	        if (valueArray[valueArray.length - 1] === newOption) {
	          if (onCreateOption) onCreateOption(inputValue);else {
	            var newOptionData = getNewOptionData(inputValue, inputValue);
	            var newActionMeta = {
	              action: 'create-option'
	            };
	
	            if (isMulti) {
	              onChange([].concat(_toConsumableArray((0, _utils.cleanValue)(value)), [newOptionData]), newActionMeta);
	            } else {
	              onChange(newOptionData, newActionMeta);
	            }
	          }
	          return;
	        }
	
	        onChange(newValue, actionMeta);
	      });
	
	      var options = props.options || [];
	      _this.state = {
	        newOption: undefined,
	        options: options
	      };
	      return _this;
	    }
	
	    _createClass(Creatable, [{
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
	            createOptionPosition = nextProps.createOptionPosition,
	            formatCreateLabel = nextProps.formatCreateLabel,
	            getNewOptionData = nextProps.getNewOptionData,
	            inputValue = nextProps.inputValue,
	            isLoading = nextProps.isLoading,
	            isValidNewOption = nextProps.isValidNewOption,
	            value = nextProps.value;
	        var options = nextProps.options || [];
	        var newOption = this.state.newOption;
	
	        if (isValidNewOption(inputValue, (0, _utils.cleanValue)(value), options)) {
	          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
	        } else {
	          newOption = undefined;
	        }
	
	        this.setState({
	          newOption: newOption,
	          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
	        });
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var props = _extends({}, this.props);
	
	        var options = this.state.options;
	        return _react.default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          options: options,
	          onChange: this.onChange
	        }));
	      }
	    }]);
	
	    return Creatable;
	  }(_react.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	}; // TODO: do this in package entrypoint
	
	
	exports.makeCreatableSelect = makeCreatableSelect;
	var SelectCreatable = makeCreatableSelect(_Select.default);
	
	var _default = (0, _stateManager.default)(SelectCreatable);
	
	exports.default = _default;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.css = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      _ref$theme = _ref.theme,
	      colors = _ref$theme.colors,
	      borderRadius = _ref$theme.borderRadius,
	      spacing = _ref$theme.spacing;
	  return {
	    label: 'control',
	    alignItems: 'center',
	    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
	    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
	    borderRadius: borderRadius,
	    borderStyle: 'solid',
	    borderWidth: 1,
	    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
	    cursor: 'default',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'space-between',
	    minHeight: spacing.controlHeight,
	    outline: '0 !important',
	    position: 'relative',
	    transition: 'all 100ms',
	    '&:hover': {
	      borderColor: isFocused ? colors.primary : colors.neutral30
	    }
	  };
	};
	
	exports.css = css;
	
	var Control = function Control(props) {
	  var children = props.children,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      className = props.className,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps,
	      menuIsOpen = props.menuIsOpen;
	  return _react.default.createElement("div", _extends({
	    ref: innerRef,
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('control', props)), {
	      'control': true,
	      'control--is-disabled': isDisabled,
	      'control--is-focused': isFocused,
	      'control--menu-is-open': menuIsOpen
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Control;
	exports.default = _default;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GroupHeading = exports.groupHeadingCSS = exports.groupCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var groupCSS = function groupCSS(_ref) {
	  var spacing = _ref.theme.spacing;
	  return {
	    paddingBottom: spacing.baseUnit * 2,
	    paddingTop: spacing.baseUnit * 2
	  };
	};
	
	exports.groupCSS = groupCSS;
	
	var Group = function Group(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      Heading = props.Heading,
	      headingProps = props.headingProps,
	      label = props.label,
	      theme = props.theme,
	      selectProps = props.selectProps;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('group', props)), {
	      'group': true
	    }, className)
	  }, _react.default.createElement(Heading, _extends({}, headingProps, {
	    selectProps: selectProps,
	    theme: theme,
	    getStyles: getStyles,
	    cx: cx
	  }), label), _react.default.createElement("div", null, children));
	};
	
	var groupHeadingCSS = function groupHeadingCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    label: 'group',
	    color: '#999',
	    cursor: 'default',
	    display: 'block',
	    fontSize: '75%',
	    fontWeight: '500',
	    marginBottom: '0.25em',
	    paddingLeft: spacing.baseUnit * 3,
	    paddingRight: spacing.baseUnit * 3,
	    textTransform: 'uppercase'
	  };
	};
	
	exports.groupHeadingCSS = groupHeadingCSS;
	
	var GroupHeading = function GroupHeading(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      theme = props.theme,
	      selectProps = props.selectProps,
	      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
	
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('groupHeading', _objectSpread({
	      theme: theme
	    }, cleanProps))), {
	      'group-heading': true
	    }, className)
	  }, cleanProps));
	};
	
	exports.GroupHeading = GroupHeading;
	var _default = Group;
	exports.default = _default;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.inputCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	var _reactInputAutosize = _interopRequireDefault(__webpack_require__(1403));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var inputCSS = function inputCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    margin: spacing.baseUnit / 2,
	    paddingBottom: spacing.baseUnit / 2,
	    paddingTop: spacing.baseUnit / 2,
	    visibility: isDisabled ? 'hidden' : 'visible',
	    color: colors.neutral80
	  };
	};
	
	exports.inputCSS = inputCSS;
	
	var inputStyle = function inputStyle(isHidden) {
	  return {
	    label: 'input',
	    background: 0,
	    border: 0,
	    fontSize: 'inherit',
	    opacity: isHidden ? 0 : 1,
	    outline: 0,
	    padding: 0,
	    color: 'inherit'
	  };
	};
	
	var Input = function Input(_ref2) {
	  var className = _ref2.className,
	      cx = _ref2.cx,
	      getStyles = _ref2.getStyles,
	      innerRef = _ref2.innerRef,
	      isHidden = _ref2.isHidden,
	      isDisabled = _ref2.isDisabled,
	      theme = _ref2.theme,
	      selectProps = _ref2.selectProps,
	      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
	
	  return _react.default.createElement("div", {
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('input', _objectSpread({
	      theme: theme
	    }, props)))
	  }, _react.default.createElement(_reactInputAutosize.default, _extends({
	    className: cx(null, {
	      'input': true
	    }, className),
	    inputRef: innerRef,
	    inputStyle: inputStyle(isHidden),
	    disabled: isDisabled
	  }, props)));
	};
	
	var _default = Input;
	exports.default = _default;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MultiValueRemove = exports.MultiValueLabel = exports.MultiValueContainer = exports.MultiValueGeneric = exports.multiValueRemoveCSS = exports.multiValueLabelCSS = exports.multiValueCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	var _indicators = __webpack_require__(289);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var multiValueCSS = function multiValueCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      borderRadius = _ref$theme.borderRadius,
	      colors = _ref$theme.colors;
	  return {
	    label: 'multiValue',
	    backgroundColor: colors.neutral10,
	    borderRadius: borderRadius / 2,
	    display: 'flex',
	    margin: spacing.baseUnit / 2,
	    minWidth: 0 // resolves flex/text-overflow bug
	
	  };
	};
	
	exports.multiValueCSS = multiValueCSS;
	
	var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
	  var _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      colors = _ref2$theme.colors,
	      cropWithEllipsis = _ref2.cropWithEllipsis;
	  return {
	    borderRadius: borderRadius / 2,
	    color: colors.neutral80,
	    fontSize: '85%',
	    overflow: 'hidden',
	    padding: 3,
	    paddingLeft: 6,
	    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
	    whiteSpace: 'nowrap'
	  };
	};
	
	exports.multiValueLabelCSS = multiValueLabelCSS;
	
	var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
	  var _ref3$theme = _ref3.theme,
	      spacing = _ref3$theme.spacing,
	      borderRadius = _ref3$theme.borderRadius,
	      colors = _ref3$theme.colors,
	      isFocused = _ref3.isFocused;
	  return {
	    alignItems: 'center',
	    borderRadius: borderRadius / 2,
	    backgroundColor: isFocused && colors.dangerLight,
	    display: 'flex',
	    paddingLeft: spacing.baseUnit,
	    paddingRight: spacing.baseUnit,
	    ':hover': {
	      backgroundColor: colors.dangerLight,
	      color: colors.danger
	    }
	  };
	};
	
	exports.multiValueRemoveCSS = multiValueRemoveCSS;
	
	var MultiValueGeneric = function MultiValueGeneric(_ref4) {
	  var children = _ref4.children,
	      innerProps = _ref4.innerProps;
	  return _react.default.createElement("div", innerProps, children);
	};
	
	exports.MultiValueGeneric = MultiValueGeneric;
	var MultiValueContainer = MultiValueGeneric;
	exports.MultiValueContainer = MultiValueContainer;
	var MultiValueLabel = MultiValueGeneric;
	exports.MultiValueLabel = MultiValueLabel;
	
	var MultiValueRemove =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MultiValueRemove, _Component);
	
	  function MultiValueRemove() {
	    _classCallCheck(this, MultiValueRemove);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
	  }
	
	  _createClass(MultiValueRemove, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          innerProps = _this$props.innerProps;
	      return _react.default.createElement("div", innerProps, children || _react.default.createElement(_indicators.CrossIcon, {
	        size: 14
	      }));
	    }
	  }]);
	
	  return MultiValueRemove;
	}(_react.Component);
	
	exports.MultiValueRemove = MultiValueRemove;
	
	var MultiValue =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MultiValue, _Component2);
	
	  function MultiValue() {
	    _classCallCheck(this, MultiValue);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
	  }
	
	  _createClass(MultiValue, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          components = _this$props2.components,
	          cx = _this$props2.cx,
	          data = _this$props2.data,
	          getStyles = _this$props2.getStyles,
	          innerProps = _this$props2.innerProps,
	          isDisabled = _this$props2.isDisabled,
	          removeProps = _this$props2.removeProps,
	          selectProps = _this$props2.selectProps;
	      var Container = components.Container,
	          Label = components.Label,
	          Remove = components.Remove;
	
	      var containerInnerProps = _objectSpread({
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValue', this.props)), {
	          'multi-value': true,
	          'multi-value--is-disabled': isDisabled
	        }, className)
	      }, innerProps);
	
	      var labelInnerProps = {
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValueLabel', this.props)), {
	          'multi-value__label': true
	        }, className)
	      };
	
	      var removeInnerProps = _objectSpread({
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('multiValueRemove', this.props)), {
	          'multi-value__remove': true
	        }, className)
	      }, removeProps);
	
	      return _react.default.createElement(Container, {
	        data: data,
	        innerProps: containerInnerProps,
	        selectProps: selectProps
	      }, _react.default.createElement(Label, {
	        data: data,
	        innerProps: labelInnerProps,
	        selectProps: selectProps
	      }, children), _react.default.createElement(Remove, {
	        data: data,
	        innerProps: removeInnerProps,
	        selectProps: selectProps
	      }));
	    }
	  }]);
	
	  return MultiValue;
	}(_react.Component);
	
	_defineProperty(MultiValue, "defaultProps", {
	  cropWithEllipsis: true
	});
	
	var _default = MultiValue;
	exports.default = _default;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.optionCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var optionCSS = function optionCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      isSelected = _ref.isSelected,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'option',
	    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
	    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
	    cursor: 'default',
	    display: 'block',
	    fontSize: 'inherit',
	    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
	    width: '100%',
	    userSelect: 'none',
	    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	    // provide some affordance on touch devices
	    ':active': {
	      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
	    }
	  };
	};
	
	exports.optionCSS = optionCSS;
	
	var Option = function Option(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      isSelected = props.isSelected,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    ref: innerRef,
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('option', props)), {
	      'option': true,
	      'option--is-disabled': isDisabled,
	      'option--is-focused': isFocused,
	      'option--is-selected': isSelected
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Option;
	exports.default = _default;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.placeholderCSS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var placeholderCSS = function placeholderCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'placeholder',
	    color: colors.neutral50,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    position: 'absolute',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	exports.placeholderCSS = placeholderCSS;
	
	var Placeholder = function Placeholder(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('placeholder', props)), {
	      'placeholder': true
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = Placeholder;
	exports.default = _default;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.css = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'singleValue',
	    color: isDisabled ? colors.neutral40 : colors.neutral80,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
	    overflow: 'hidden',
	    position: 'absolute',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	exports.css = css;
	
	var SingleValue = function SingleValue(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      innerProps = props.innerProps;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('singleValue', props)), {
	      'single-value': true,
	      'single-value--is-disabled': isDisabled
	    }, className)
	  }, innerProps), children);
	};
	
	var _default = SingleValue;
	exports.default = _default;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndicatorsContainer = exports.indicatorsContainerCSS = exports.ValueContainer = exports.valueContainerCSS = exports.SelectContainer = exports.containerCSS = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var containerCSS = function containerCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isRtl = _ref.isRtl;
	  return {
	    label: 'container',
	    direction: isRtl ? 'rtl' : null,
	    pointerEvents: isDisabled ? 'none' : null,
	    // cancel mouse events when disabled
	    position: 'relative'
	  };
	};
	
	exports.containerCSS = containerCSS;
	
	var SelectContainer = function SelectContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      isRtl = props.isRtl;
	  return _react.default.createElement("div", _extends({
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('container', props)), {
	      '--is-disabled': isDisabled,
	      '--is-rtl': isRtl
	    }, className)
	  }, innerProps), children);
	}; // ==============================
	// Value Container
	// ==============================
	
	
	exports.SelectContainer = SelectContainer;
	
	var valueContainerCSS = function valueContainerCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    alignItems: 'center',
	    display: 'flex',
	    flex: 1,
	    flexWrap: 'wrap',
	    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
	    WebkitOverflowScrolling: 'touch',
	    position: 'relative',
	    overflow: 'hidden'
	  };
	};
	
	exports.valueContainerCSS = valueContainerCSS;
	
	var ValueContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ValueContainer, _Component);
	
	  function ValueContainer() {
	    _classCallCheck(this, ValueContainer);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
	  }
	
	  _createClass(ValueContainer, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          cx = _this$props.cx,
	          isMulti = _this$props.isMulti,
	          getStyles = _this$props.getStyles,
	          hasValue = _this$props.hasValue;
	      return _react.default.createElement("div", {
	        className: cx(
	        /*#__PURE__*/
	        (0, _emotion.css)(getStyles('valueContainer', this.props)), {
	          'value-container': true,
	          'value-container--is-multi': isMulti,
	          'value-container--has-value': hasValue
	        }, className)
	      }, children);
	    }
	  }]);
	
	  return ValueContainer;
	}(_react.Component); // ==============================
	// Indicator Container
	// ==============================
	
	
	exports.ValueContainer = ValueContainer;
	
	var indicatorsContainerCSS = function indicatorsContainerCSS() {
	  return {
	    alignItems: 'center',
	    alignSelf: 'stretch',
	    display: 'flex',
	    flexShrink: 0
	  };
	};
	
	exports.indicatorsContainerCSS = indicatorsContainerCSS;
	
	var IndicatorsContainer = function IndicatorsContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles;
	  return _react.default.createElement("div", {
	    className: cx(
	    /*#__PURE__*/
	    (0, _emotion.css)(getStyles('indicatorsContainer', props)), {
	      'indicators': true
	    }, className)
	  }, children);
	};
	
	exports.IndicatorsContainer = IndicatorsContainer;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFilter = void 0;
	
	var _diacritics = __webpack_require__(1727);
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var trimString = function trimString(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	var defaultStringify = function defaultStringify(option) {
	  return "".concat(option.label, " ").concat(option.value);
	};
	
	var createFilter = function createFilter(config) {
	  return function (option, rawInput) {
	    var _ignoreCase$ignoreAcc = _objectSpread({
	      ignoreCase: true,
	      ignoreAccents: true,
	      stringify: defaultStringify,
	      trim: true,
	      matchFrom: 'any'
	    }, config),
	        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
	        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
	        stringify = _ignoreCase$ignoreAcc.stringify,
	        trim = _ignoreCase$ignoreAcc.trim,
	        matchFrom = _ignoreCase$ignoreAcc.matchFrom;
	
	    var input = trim ? trimString(rawInput) : rawInput;
	    var candidate = trim ? trimString(stringify(option)) : stringify(option);
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	      candidate = candidate.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = (0, _diacritics.stripDiacritics)(input);
	      candidate = (0, _diacritics.stripDiacritics)(candidate);
	    }
	
	    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
	  };
	};
	
	exports.createFilter = createFilter;

/***/ },
/* 638 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exportedEqual;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
	    var arrA = isArray(a),
	        arrB = isArray(b),
	        i,
	        length,
	        key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	
	      for (i = length; i-- !== 0;) {
	        if (!equal(a[i], b[i])) return false;
	      }
	
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	    var dateA = a instanceof Date,
	        dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	    var regexpA = a instanceof RegExp,
	        regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length) {
	      return false;
	    }
	
	    for (i = length; i-- !== 0;) {
	      if (!hasProp.call(b, keys[i])) return false;
	    } // end fast-deep-equal
	    // Custom handling for React
	
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    } // fast-deep-equal index.js 2.0.1
	
	
	    return true;
	  }
	
	  return a !== a && b !== b;
	} // end fast-deep-equal
	
	
	function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (error.message && error.message.match(/stack|recursion/i)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    } // some other error. we should definitely know about these
	
	
	    throw error;
	  }
	}
	
	;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeStyles = mergeStyles;
	exports.defaultStyles = void 0;
	
	var _containers = __webpack_require__(636);
	
	var _Control = __webpack_require__(629);
	
	var _Group = __webpack_require__(630);
	
	var _indicators = __webpack_require__(289);
	
	var _Input = __webpack_require__(631);
	
	var _Placeholder = __webpack_require__(634);
	
	var _Option = __webpack_require__(633);
	
	var _Menu = __webpack_require__(287);
	
	var _SingleValue = __webpack_require__(635);
	
	var _MultiValue = __webpack_require__(632);
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultStyles = {
	  clearIndicator: _indicators.clearIndicatorCSS,
	  container: _containers.containerCSS,
	  control: _Control.css,
	  dropdownIndicator: _indicators.dropdownIndicatorCSS,
	  group: _Group.groupCSS,
	  groupHeading: _Group.groupHeadingCSS,
	  indicatorsContainer: _containers.indicatorsContainerCSS,
	  indicatorSeparator: _indicators.indicatorSeparatorCSS,
	  input: _Input.inputCSS,
	  loadingIndicator: _indicators.loadingIndicatorCSS,
	  loadingMessage: _Menu.loadingMessageCSS,
	  menu: _Menu.menuCSS,
	  menuList: _Menu.menuListCSS,
	  menuPortal: _Menu.menuPortalCSS,
	  multiValue: _MultiValue.multiValueCSS,
	  multiValueLabel: _MultiValue.multiValueLabelCSS,
	  multiValueRemove: _MultiValue.multiValueRemoveCSS,
	  noOptionsMessage: _Menu.noOptionsMessageCSS,
	  option: _Option.optionCSS,
	  placeholder: _Placeholder.placeholderCSS,
	  singleValue: _SingleValue.css,
	  valueContainer: _containers.valueContainerCSS
	}; // Merge Utility
	// Allows consumers to extend a base Select with additional styles
	
	exports.defaultStyles = defaultStyles;
	
	function mergeStyles(source) {
	  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  // initialize with source styles
	  var styles = _objectSpread({}, source); // massage in target styles
	
	
	  Object.keys(target).forEach(function (key) {
	    if (source[key]) {
	      styles[key] = function (rsCss, props) {
	        return target[key](source[key](rsCss, props), props);
	      };
	    } else {
	      styles[key] = target[key];
	    }
	  });
	  return styles;
	}

/***/ },
/* 640 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultTheme = exports.spacing = exports.colors = void 0;
	var colors = {
	  primary: '#2684FF',
	  primary75: '#4C9AFF',
	  primary50: '#B2D4FF',
	  primary25: '#DEEBFF',
	  danger: '#DE350B',
	  dangerLight: '#FFBDAD',
	  neutral0: 'hsl(0, 0%, 100%)',
	  neutral5: 'hsl(0, 0%, 95%)',
	  neutral10: 'hsl(0, 0%, 90%)',
	  neutral20: 'hsl(0, 0%, 80%)',
	  neutral30: 'hsl(0, 0%, 70%)',
	  neutral40: 'hsl(0, 0%, 60%)',
	  neutral50: 'hsl(0, 0%, 50%)',
	  neutral60: 'hsl(0, 0%, 40%)',
	  neutral70: 'hsl(0, 0%, 30%)',
	  neutral80: 'hsl(0, 0%, 20%)',
	  neutral90: 'hsl(0, 0%, 10%)'
	};
	exports.colors = colors;
	var borderRadius = 4;
	var baseUnit = 4;
	/* Used to calculate consistent margin/padding on elements */
	
	var controlHeight = 38;
	/* The minimum height of the control */
	
	var menuGutter = baseUnit * 2;
	/* The amount of space between the control and menu */
	
	var spacing = {
	  baseUnit: baseUnit,
	  controlHeight: controlHeight,
	  menuGutter: menuGutter
	};
	exports.spacing = spacing;
	var defaultTheme = {
	  borderRadius: borderRadius,
	  colors: colors,
	  spacing: spacing
	};
	exports.defaultTheme = defaultTheme;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(124));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(32));
	
	var _reactLifecyclesCompat = __webpack_require__(277);
	
	var _PropTypes = __webpack_require__(644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(124));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(277);
	
	var _ChildMapping = __webpack_require__(1744);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(1742));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1743));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(642));
	
	var _Transition = _interopRequireDefault(__webpack_require__(641));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ },
/* 644 */
[1916, 124],
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(126));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(292));
	
	var _ChildMapping = __webpack_require__(1748);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	/**
	 * The `<TransitionGroup>` component manages a set of transition components
	 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	 * components, `<TransitionGroup>` is a state machine for managing the mounting
	 * and unmounting of components over time.
	 *
	 * Consider the example below. As items are removed or added to the TodoList the
	 * `in` prop is toggled automatically by the `<TransitionGroup>`.
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual transition
	 * component. This means you can mix and match animations across different list
	 * items.
	 */
	
	var TransitionGroup = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  } // node is `undefined` when user provided `nodeRef` prop
	  ;
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, /*#__PURE__*/_react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 646 */
368,
/* 647 */
[1916, 126],
/* 648 */
/***/ function(module, exports) {

	'use strict';
	
	function shallowEqualObjects(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (!objA || !objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	  var len = aKeys.length;
	
	  if (bKeys.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqualObjects;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1768);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(107)(module)))

/***/ },
/* 650 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.upperCaseFirst = void 0;
	/**
	 * Upper case the first character of an input string.
	 */
	function upperCaseFirst(input) {
	    return input.charAt(0).toUpperCase() + input.substr(1);
	}
	exports.upperCaseFirst = upperCaseFirst;
	//# sourceMappingURL=index.js.map

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _toDate = _interopRequireDefault(__webpack_require__(295));
	
	var _toFloat = _interopRequireDefault(__webpack_require__(661));
	
	var _toInt = _interopRequireDefault(__webpack_require__(1832));
	
	var _toBoolean = _interopRequireDefault(__webpack_require__(1831));
	
	var _equals = _interopRequireDefault(__webpack_require__(1774));
	
	var _contains = _interopRequireDefault(__webpack_require__(1773));
	
	var _matches = _interopRequireDefault(__webpack_require__(1828));
	
	var _isEmail = _interopRequireDefault(__webpack_require__(654));
	
	var _isURL = _interopRequireDefault(__webpack_require__(1823));
	
	var _isMACAddress = _interopRequireDefault(__webpack_require__(1809));
	
	var _isIP = _interopRequireDefault(__webpack_require__(211));
	
	var _isIPRange = _interopRequireDefault(__webpack_require__(1794));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(294));
	
	var _isBoolean = _interopRequireDefault(__webpack_require__(1784));
	
	var _isAlpha = _interopRequireWildcard(__webpack_require__(1777));
	
	var _isAlphanumeric = _interopRequireWildcard(__webpack_require__(1778));
	
	var _isNumeric = _interopRequireDefault(__webpack_require__(1816));
	
	var _isPort = _interopRequireDefault(__webpack_require__(1818));
	
	var _isLowercase = _interopRequireDefault(__webpack_require__(1808));
	
	var _isUppercase = _interopRequireDefault(__webpack_require__(1825));
	
	var _isAscii = _interopRequireDefault(__webpack_require__(1779));
	
	var _isFullWidth = _interopRequireDefault(__webpack_require__(655));
	
	var _isHalfWidth = _interopRequireDefault(__webpack_require__(656));
	
	var _isVariableWidth = _interopRequireDefault(__webpack_require__(1826));
	
	var _isMultibyte = _interopRequireDefault(__webpack_require__(1815));
	
	var _isSurrogatePair = _interopRequireDefault(__webpack_require__(1822));
	
	var _isInt = _interopRequireDefault(__webpack_require__(658));
	
	var _isFloat = _interopRequireWildcard(__webpack_require__(1791));
	
	var _isDecimal = _interopRequireDefault(__webpack_require__(1788));
	
	var _isHexadecimal = _interopRequireDefault(__webpack_require__(657));
	
	var _isOctal = _interopRequireDefault(__webpack_require__(1817));
	
	var _isDivisibleBy = _interopRequireDefault(__webpack_require__(1789));
	
	var _isHexColor = _interopRequireDefault(__webpack_require__(1793));
	
	var _isISRC = _interopRequireDefault(__webpack_require__(1800));
	
	var _isBIC = _interopRequireDefault(__webpack_require__(1780));
	
	var _isMD = _interopRequireDefault(__webpack_require__(1810));
	
	var _isHash = _interopRequireDefault(__webpack_require__(1792));
	
	var _isJWT = _interopRequireDefault(__webpack_require__(1805));
	
	var _isJSON = _interopRequireDefault(__webpack_require__(1804));
	
	var _isEmpty = _interopRequireDefault(__webpack_require__(1790));
	
	var _isLength = _interopRequireDefault(__webpack_require__(1807));
	
	var _isByteLength = _interopRequireDefault(__webpack_require__(653));
	
	var _isUUID = _interopRequireDefault(__webpack_require__(1824));
	
	var _isMongoId = _interopRequireDefault(__webpack_require__(1814));
	
	var _isAfter = _interopRequireDefault(__webpack_require__(1776));
	
	var _isBefore = _interopRequireDefault(__webpack_require__(1783));
	
	var _isIn = _interopRequireDefault(__webpack_require__(1803));
	
	var _isCreditCard = _interopRequireDefault(__webpack_require__(1785));
	
	var _isIdentityCard = _interopRequireDefault(__webpack_require__(1802));
	
	var _isISIN = _interopRequireDefault(__webpack_require__(1796));
	
	var _isISBN = _interopRequireDefault(__webpack_require__(1795));
	
	var _isISSN = _interopRequireDefault(__webpack_require__(1801));
	
	var _isMobilePhone = _interopRequireWildcard(__webpack_require__(1813));
	
	var _isCurrency = _interopRequireDefault(__webpack_require__(1786));
	
	var _isISO = _interopRequireDefault(__webpack_require__(1799));
	
	var _isRFC = _interopRequireDefault(__webpack_require__(1820));
	
	var _isISO31661Alpha = _interopRequireDefault(__webpack_require__(1797));
	
	var _isISO31661Alpha2 = _interopRequireDefault(__webpack_require__(1798));
	
	var _isBase = _interopRequireDefault(__webpack_require__(1781));
	
	var _isBase2 = _interopRequireDefault(__webpack_require__(1782));
	
	var _isDataURI = _interopRequireDefault(__webpack_require__(1787));
	
	var _isMagnetURI = _interopRequireDefault(__webpack_require__(1811));
	
	var _isMimeType = _interopRequireDefault(__webpack_require__(1812));
	
	var _isLatLong = _interopRequireDefault(__webpack_require__(1806));
	
	var _isPostalCode = _interopRequireWildcard(__webpack_require__(1819));
	
	var _ltrim = _interopRequireDefault(__webpack_require__(659));
	
	var _rtrim = _interopRequireDefault(__webpack_require__(660));
	
	var _trim = _interopRequireDefault(__webpack_require__(1833));
	
	var _escape = _interopRequireDefault(__webpack_require__(1775));
	
	var _unescape = _interopRequireDefault(__webpack_require__(1834));
	
	var _stripLow = _interopRequireDefault(__webpack_require__(1830));
	
	var _whitelist = _interopRequireDefault(__webpack_require__(1835));
	
	var _blacklist = _interopRequireDefault(__webpack_require__(652));
	
	var _isWhitelisted = _interopRequireDefault(__webpack_require__(1827));
	
	var _normalizeEmail = _interopRequireDefault(__webpack_require__(1829));
	
	var _isSlug = _interopRequireDefault(__webpack_require__(1821));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = '12.1.0';
	var validator = {
	  version: version,
	  toDate: _toDate.default,
	  toFloat: _toFloat.default,
	  toInt: _toInt.default,
	  toBoolean: _toBoolean.default,
	  equals: _equals.default,
	  contains: _contains.default,
	  matches: _matches.default,
	  isEmail: _isEmail.default,
	  isURL: _isURL.default,
	  isMACAddress: _isMACAddress.default,
	  isIP: _isIP.default,
	  isIPRange: _isIPRange.default,
	  isFQDN: _isFQDN.default,
	  isBoolean: _isBoolean.default,
	  isBIC: _isBIC.default,
	  isAlpha: _isAlpha.default,
	  isAlphaLocales: _isAlpha.locales,
	  isAlphanumeric: _isAlphanumeric.default,
	  isAlphanumericLocales: _isAlphanumeric.locales,
	  isNumeric: _isNumeric.default,
	  isPort: _isPort.default,
	  isLowercase: _isLowercase.default,
	  isUppercase: _isUppercase.default,
	  isAscii: _isAscii.default,
	  isFullWidth: _isFullWidth.default,
	  isHalfWidth: _isHalfWidth.default,
	  isVariableWidth: _isVariableWidth.default,
	  isMultibyte: _isMultibyte.default,
	  isSurrogatePair: _isSurrogatePair.default,
	  isInt: _isInt.default,
	  isFloat: _isFloat.default,
	  isFloatLocales: _isFloat.locales,
	  isDecimal: _isDecimal.default,
	  isHexadecimal: _isHexadecimal.default,
	  isOctal: _isOctal.default,
	  isDivisibleBy: _isDivisibleBy.default,
	  isHexColor: _isHexColor.default,
	  isISRC: _isISRC.default,
	  isMD5: _isMD.default,
	  isHash: _isHash.default,
	  isJWT: _isJWT.default,
	  isJSON: _isJSON.default,
	  isEmpty: _isEmpty.default,
	  isLength: _isLength.default,
	  isByteLength: _isByteLength.default,
	  isUUID: _isUUID.default,
	  isMongoId: _isMongoId.default,
	  isAfter: _isAfter.default,
	  isBefore: _isBefore.default,
	  isIn: _isIn.default,
	  isCreditCard: _isCreditCard.default,
	  isIdentityCard: _isIdentityCard.default,
	  isISIN: _isISIN.default,
	  isISBN: _isISBN.default,
	  isISSN: _isISSN.default,
	  isMobilePhone: _isMobilePhone.default,
	  isMobilePhoneLocales: _isMobilePhone.locales,
	  isPostalCode: _isPostalCode.default,
	  isPostalCodeLocales: _isPostalCode.locales,
	  isCurrency: _isCurrency.default,
	  isISO8601: _isISO.default,
	  isRFC3339: _isRFC.default,
	  isISO31661Alpha2: _isISO31661Alpha.default,
	  isISO31661Alpha3: _isISO31661Alpha2.default,
	  isBase32: _isBase.default,
	  isBase64: _isBase2.default,
	  isDataURI: _isDataURI.default,
	  isMagnetURI: _isMagnetURI.default,
	  isMimeType: _isMimeType.default,
	  isLatLong: _isLatLong.default,
	  ltrim: _ltrim.default,
	  rtrim: _rtrim.default,
	  trim: _trim.default,
	  escape: _escape.default,
	  unescape: _unescape.default,
	  stripLow: _stripLow.default,
	  whitelist: _whitelist.default,
	  blacklist: _blacklist.default,
	  isWhitelisted: _isWhitelisted.default,
	  normalizeEmail: _normalizeEmail.default,
	  toString: toString,
	  isSlug: _isSlug.default
	};
	var _default = validator;
	exports.default = _default;
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blacklist;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function blacklist(str, chars) {
	  (0, _assertString.default)(str);
	  return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isByteLength;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString.default)(str);
	  var min;
	  var max;
	
	  if (_typeof(options) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _merge = _interopRequireDefault(__webpack_require__(106));
	
	var _isByteLength = _interopRequireDefault(__webpack_require__(653));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(294));
	
	var _isIP = _interopRequireDefault(__webpack_require__(211));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	/* eslint-disable max-len */
	
	/* eslint-disable no-control-regex */
	
	var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var gmailUserPart = /^[a-z\d]+$/;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	var defaultMaxEmailLength = 254;
	/* eslint-enable max-len */
	
	/* eslint-enable no-control-regex */
	
	/**
	 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
	 * @param {String} display_name
	 */
	
	function validateDisplayName(display_name) {
	  var trim_quotes = display_name.match(/^"(.+)"$/i);
	  var display_name_without_quotes = trim_quotes ? trim_quotes[1] : display_name; // display name with only spaces is not valid
	
	  if (!display_name_without_quotes.trim()) {
	    return false;
	  } // check whether display name contains illegal character
	
	
	  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
	
	  if (contains_illegal) {
	    // if contains illegal characters,
	    // must to be enclosed in double-quotes, otherwise it's not a valid display name
	    if (!trim_quotes) {
	      return false;
	    } // the quotes in display name must start with character symbol \
	
	
	    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
	
	    if (!all_start_with_back_slash) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function isEmail(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(splitNameAddress);
	
	    if (display_email) {
	      var display_name;
	
	      var _display_email = _slicedToArray(display_email, 3);
	
	      display_name = _display_email[1];
	      str = _display_email[2];
	
	      // sometimes need to trim the last space to get the display name
	      // because there may be a space between display name and email address
	      // eg. myname <address@gmail.com>
	      // the display name is `myname` instead of `myname `, so need to trim the last space
	      if (display_name.endsWith(' ')) {
	        display_name = display_name.substr(0, display_name.length - 1);
	      }
	
	      if (!validateDisplayName(display_name)) {
	        return false;
	      }
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
	    return false;
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	  var lower_domain = domain.toLowerCase();
	
	  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
	    /*
	      Previously we removed dots for gmail addresses before validating.
	      This was removed because it allows `multiple..dots@gmail.com`
	      to be reported as valid, but it is not.
	      Gmail only normalizes single dots, removing them from here is pointless,
	      should be done in normalizeEmail
	    */
	    user = user.toLowerCase(); // Removing sub-address from username before gmail validation
	
	    var username = user.split('+')[0]; // Dots are not included in gmail length restriction
	
	    if (!(0, _isByteLength.default)(username.replace('.', ''), {
	      min: 6,
	      max: 30
	    })) {
	      return false;
	    }
	
	    var _user_parts = username.split('.');
	
	    for (var i = 0; i < _user_parts.length; i++) {
	      if (!gmailUserPart.test(_user_parts[i])) {
	        return false;
	      }
	    }
	  }
	
	  if (!(0, _isByteLength.default)(user, {
	    max: 64
	  }) || !(0, _isByteLength.default)(domain, {
	    max: 254
	  })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN.default)(domain, {
	    require_tld: options.require_tld
	  })) {
	    if (!options.allow_ip_domain) {
	      return false;
	    }
	
	    if (!(0, _isIP.default)(domain)) {
	      if (!domain.startsWith('[') || !domain.endsWith(']')) {
	        return false;
	      }
	
	      var noBracketdomain = domain.substr(1, domain.length - 2);
	
	      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
	        return false;
	      }
	    }
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	  var user_parts = user.split('.');
	
	  for (var _i2 = 0; _i2 < user_parts.length; _i2++) {
	    if (!pattern.test(user_parts[_i2])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFullWidth;
	exports.fullWidth = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	exports.fullWidth = fullWidth;
	
	function isFullWidth(str) {
	  (0, _assertString.default)(str);
	  return fullWidth.test(str);
	}

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHalfWidth;
	exports.halfWidth = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	exports.halfWidth = halfWidth;
	
	function isHalfWidth(str) {
	  (0, _assertString.default)(str);
	  return halfWidth.test(str);
	}

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexadecimal;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;
	
	function isHexadecimal(str) {
	  (0, _assertString.default)(str);
	  return hexadecimal.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInt;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	var intLeadingZeroes = /^[-+]?[0-9]+$/;
	
	function isInt(str, options) {
	  (0, _assertString.default)(str);
	  options = options || {}; // Get the regex to use for testing, based on whether
	  // leading zeroes are allowed or not.
	
	  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt
	
	  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
	  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
	  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
	  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
	  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ltrim;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ltrim(str, chars) {
	  (0, _assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
	
	  var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+"), 'g') : /^\s+/g;
	  return str.replace(pattern, '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtrim;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rtrim(str, chars) {
	  (0, _assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
	
	  var pattern = chars ? new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+$"), 'g') : /\s+$/g;
	  return str.replace(pattern, '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toFloat;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toFloat(str) {
	  (0, _assertString.default)(str);
	  return parseFloat(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 662 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toString;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function toString(input) {
	  if (_typeof(input) === 'object' && input !== null) {
	    if (typeof input.toString === 'function') {
	      input = input.toString();
	    } else {
	      input = '[object Object]';
	    }
	  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
	    input = '';
	  }
	
	  return String(input);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var d3Shape = _interopRequireWildcard(__webpack_require__(147));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defined = function (d) {
	  var y = d._y1 !== undefined ? d._y1 : d._y;
	  return y !== null && y !== undefined && d._y0 !== null;
	};
	
	var getXAccessor = function (scale) {
	  return function (d) {
	    return scale.x(d._x1 !== undefined ? d._x1 : d._x);
	  };
	};
	
	var getYAccessor = function (scale) {
	  return function (d) {
	    return scale.y(d._y1 !== undefined ? d._y1 : d._y);
	  };
	};
	
	var getY0Accessor = function (scale) {
	  return function (d) {
	    return scale.y(d._y0);
	  };
	};
	
	var getAngleAccessor = function (scale) {
	  return function (d) {
	    var x = scale.x(d._x1 !== undefined ? d._x1 : d._x);
	    return -1 * x + Math.PI / 2;
	  };
	};
	
	var toNewName = function (interpolation) {
	  // d3 shape changed the naming scheme for interpolators from "basis" -> "curveBasis" etc.
	  var capitalize = function (s) {
	    return s && s[0].toUpperCase() + s.slice(1);
	  };
	
	  return "curve".concat(capitalize(interpolation));
	};
	
	var getLineFunction = function (props) {
	  var polar = props.polar,
	      scale = props.scale,
	      horizontal = props.horizontal;
	  var interpolationFunction = typeof props.interpolation === "function" && props.interpolation;
	  var interpolationName = typeof props.interpolation === "string" && toNewName(props.interpolation);
	  return polar ? d3Shape.lineRadial().defined(defined).curve(interpolationFunction || d3Shape["".concat(interpolationName, "Closed")]).angle(getAngleAccessor(scale)).radius(getYAccessor(scale)) : d3Shape.line().defined(defined).curve(interpolationFunction || d3Shape[interpolationName]).x(horizontal ? getYAccessor(scale) : getXAccessor(scale)).y(horizontal ? getXAccessor(scale) : getYAccessor(scale));
	};
	
	var getCartesianArea = function (props, interpolation) {
	  var horizontal = props.horizontal,
	      scale = props.scale;
	  var interpolationFunction = typeof interpolation === "function" && interpolation;
	  var interpolationName = typeof interpolation === "string" && interpolation;
	  return horizontal ? d3Shape.area().defined(defined).curve(interpolationFunction || d3Shape[interpolationName]).x0(getY0Accessor(scale)).x1(getYAccessor(scale)).y(getXAccessor(scale)) : d3Shape.area().defined(defined).curve(interpolationFunction || d3Shape[interpolationName]).x(getXAccessor(scale)).y1(getYAccessor(scale)).y0(getY0Accessor(scale));
	};
	
	var getAreaFunction = function (props) {
	  var polar = props.polar,
	      scale = props.scale;
	  var interpolationFunction = typeof props.interpolation === "function" && props.interpolation;
	  var interpolationName = typeof props.interpolation === "string" && toNewName(props.interpolation);
	  var interpolation = interpolationFunction || interpolationName;
	  return polar ? d3Shape.radialArea().defined(defined).curve(interpolationFunction || d3Shape["".concat(interpolationName, "Closed")]).angle(getAngleAccessor(scale)).outerRadius(getYAccessor(scale)).innerRadius(getY0Accessor(scale)) : getCartesianArea(props, interpolation);
	};
	
	var Area = function (props) {
	  var role = props.role,
	      shapeRendering = props.shapeRendering,
	      className = props.className,
	      polar = props.polar,
	      origin = props.origin,
	      data = props.data,
	      pathComponent = props.pathComponent,
	      events = props.events,
	      groupComponent = props.groupComponent,
	      clipPath = props.clipPath,
	      id = props.id;
	
	  var style = _victoryCore.Helpers.evaluateStyle((0, _assign2.default)({
	    fill: "black"
	  }, props.style), props);
	
	  var defaultTransform = polar && origin ? "translate(".concat(origin.x, ", ").concat(origin.y, ")") : undefined;
	  var transform = props.transform || defaultTransform;
	  var renderLine = style.stroke && style.stroke !== "none" && style.stroke !== "transparent";
	  var areaFunction = getAreaFunction(props);
	  var lineFunction = renderLine && getLineFunction(props);
	  var areaStroke = style.stroke ? "none" : style.fill;
	
	  var sharedProps = _objectSpread({
	    className: className,
	    role: role,
	    shapeRendering: shapeRendering,
	    transform: transform
	  }, events, {
	    clipPath: clipPath
	  });
	
	  var area = _react.default.cloneElement(pathComponent, (0, _assign2.default)({
	    key: "".concat(id, "-area"),
	    style: (0, _assign2.default)({}, style, {
	      stroke: areaStroke
	    }),
	    d: areaFunction(data),
	    desc: _victoryCore.Helpers.evaluateProp(props.desc, props),
	    tabIndex: _victoryCore.Helpers.evaluateProp(props.tabIndex, props)
	  }, sharedProps));
	
	  var line = renderLine ? _react.default.cloneElement(pathComponent, (0, _assign2.default)({
	    key: "".concat(id, "-area-stroke"),
	    style: (0, _assign2.default)({}, style, {
	      fill: "none"
	    }),
	    d: lineFunction(data)
	  }, sharedProps)) : null;
	  return renderLine ? _react.default.cloneElement(groupComponent, {}, [area, line]) : area;
	};
	
	Area.propTypes = _objectSpread({}, _victoryCore.CommonProps.primitiveProps, {
	  groupComponent: _propTypes.default.element,
	  interpolation: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  pathComponent: _propTypes.default.element
	});
	Area.defaultProps = {
	  groupComponent: _react.default.createElement("g", null),
	  pathComponent: _react.default.createElement(_victoryCore.Path, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Area;
	exports.default = _default;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryAxis", {
	  enumerable: true,
	  get: function () {
	    return _victoryAxis.default;
	  }
	});
	
	var _victoryAxis = _interopRequireDefault(__webpack_require__(1842));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	var _pathHelperMethods = __webpack_require__(666);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getBarPath = function (props, width, cornerRadius) {
	  if (props.getPath) {
	    return (0, _pathHelperMethods.getCustomBarPath)(props, width);
	  }
	
	  return props.horizontal ? (0, _pathHelperMethods.getHorizontalBarPath)(props, width, cornerRadius) : (0, _pathHelperMethods.getVerticalBarPath)(props, width, cornerRadius);
	};
	
	var getPolarBarPath = function (props, cornerRadius) {
	  // TODO Radial bars
	  return (0, _pathHelperMethods.getVerticalPolarBarPath)(props, cornerRadius);
	};
	
	var getBarWidth = function (barWidth, props) {
	  var scale = props.scale,
	      data = props.data,
	      defaultBarWidth = props.defaultBarWidth,
	      style = props.style;
	
	  if (barWidth) {
	    return (0, _isFunction2.default)(barWidth) ? _victoryCore.Helpers.evaluateProp(barWidth, props) : barWidth;
	  } else if (style.width) {
	    return style.width;
	  }
	
	  var range = scale.x.range();
	  var extent = Math.abs(range[1] - range[0]);
	  var bars = data.length + 2;
	  var barRatio = props.barRatio || 0.5;
	  var defaultWidth = barRatio * (data.length < 2 ? defaultBarWidth : extent / bars);
	  return Math.max(1, defaultWidth);
	};
	
	var getCornerRadiusFromObject = function (cornerRadius, props) {
	  var realCornerRadius = {
	    topLeft: 0,
	    topRight: 0,
	    bottomLeft: 0,
	    bottomRight: 0
	  };
	
	  var updateCornerRadius = function (corner, fallback) {
	    if (!(0, _isNil2.default)(cornerRadius[corner])) {
	      realCornerRadius[corner] = _victoryCore.Helpers.evaluateProp(cornerRadius[corner], props);
	    } else if (!(0, _isNil2.default)(cornerRadius[fallback])) {
	      realCornerRadius[corner] = _victoryCore.Helpers.evaluateProp(cornerRadius[fallback], props);
	    }
	  };
	
	  updateCornerRadius("topLeft", "top");
	  updateCornerRadius("topRight", "top");
	  updateCornerRadius("bottomLeft", "bottom");
	  updateCornerRadius("bottomRight", "bottom");
	  return realCornerRadius;
	};
	
	var getCornerRadius = function (cornerRadius, props) {
	  var realCornerRadius = {
	    topLeft: 0,
	    topRight: 0,
	    bottomLeft: 0,
	    bottomRight: 0
	  };
	
	  if (!cornerRadius) {
	    return realCornerRadius;
	  }
	
	  if ((0, _isPlainObject2.default)(cornerRadius)) {
	    return getCornerRadiusFromObject(cornerRadius, props);
	  } else {
	    realCornerRadius.topLeft = _victoryCore.Helpers.evaluateProp(cornerRadius, props);
	    realCornerRadius.topRight = _victoryCore.Helpers.evaluateProp(cornerRadius, props);
	    return realCornerRadius;
	  }
	};
	
	var getStyle = function () {
	  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var props = arguments.length > 1 ? arguments[1] : undefined;
	  var stroke = style.fill || "black";
	  var baseStyle = {
	    fill: "black",
	    stroke: stroke
	  };
	  return _victoryCore.Helpers.evaluateStyle((0, _assign2.default)(baseStyle, style), props);
	};
	
	var evaluateProps = function (props) {
	  // Potential evaluated props are 1) `style`, 2) `barWidth` and 3) `cornerRadius`
	  var style = getStyle(props.style, props);
	  var barWidth = getBarWidth(props.barWidth, (0, _assign2.default)({}, props, {
	    style: style
	  }));
	  var cornerRadius = getCornerRadius(props.cornerRadius, (0, _assign2.default)({}, props, {
	    style: style,
	    barWidth: barWidth
	  }));
	  return (0, _assign2.default)({}, props, {
	    style: style,
	    barWidth: barWidth,
	    cornerRadius: cornerRadius
	  });
	};
	
	var Bar = function (props) {
	  props = evaluateProps(props);
	  var _props = props,
	      polar = _props.polar,
	      origin = _props.origin,
	      style = _props.style,
	      barWidth = _props.barWidth,
	      cornerRadius = _props.cornerRadius;
	  var path = polar ? getPolarBarPath(props, cornerRadius) : getBarPath(props, barWidth, cornerRadius);
	  var defaultTransform = polar && origin ? "translate(".concat(origin.x, ", ").concat(origin.y, ")") : undefined;
	  return _react.default.cloneElement(props.pathComponent, _objectSpread({}, props.events, {
	    style: style,
	    d: path,
	    transform: props.transform || defaultTransform,
	    className: props.className,
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    clipPath: props.clipPath,
	    desc: _victoryCore.Helpers.evaluateProp(props.desc, props),
	    tabIndex: _victoryCore.Helpers.evaluateProp(props.tabIndex, props)
	  }));
	};
	
	Bar.propTypes = _objectSpread({}, _victoryCore.CommonProps.primitiveProps, {
	  alignment: _propTypes.default.oneOf(["start", "middle", "end"]),
	  barRatio: _propTypes.default.number,
	  barWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  cornerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func, _propTypes.default.shape({
	    top: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	    topLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	    topRight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	    bottom: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	    bottomLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	    bottomRight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func])
	  })]),
	  datum: _propTypes.default.object,
	  getPath: _propTypes.default.func,
	  horizontal: _propTypes.default.bool,
	  pathComponent: _propTypes.default.element,
	  width: _propTypes.default.number,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number,
	  y0: _propTypes.default.number
	});
	Bar.defaultProps = {
	  defaultBarWidth: 8,
	  pathComponent: _react.default.createElement(_victoryCore.Path, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Bar;
	exports.default = _default;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVerticalPolarBarPath = exports.getHorizontalBarPath = exports.getVerticalBarPath = exports.getCustomBarPath = void 0;
	
	var d3Shape = _interopRequireWildcard(__webpack_require__(147));
	
	var _geometryHelperMethods = __webpack_require__(1843);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var getPosition = function (props, width) {
	  var x = props.x,
	      x0 = props.x0,
	      y = props.y,
	      y0 = props.y0,
	      horizontal = props.horizontal;
	  var alignment = props.alignment || "middle";
	  var size = alignment === "middle" ? width / 2 : width;
	  var sign = horizontal ? -1 : 1;
	
	  if (horizontal) {
	    return {
	      x0: x0,
	      x1: x,
	      y0: alignment === "start" ? y : y - sign * size,
	      y1: alignment === "end" ? y : y + sign * size
	    };
	  }
	
	  return {
	    x0: alignment === "start" ? x : x - sign * size,
	    x1: alignment === "end" ? x : x + sign * size,
	    y0: y0,
	    y1: y
	  };
	};
	
	var getAngle = function (props, index) {
	  var data = props.data,
	      scale = props.scale;
	  var x = data[index]._x1 === undefined ? "_x" : "_x1";
	  return scale.x(data[index][x]);
	};
	
	var getAngularWidth = function (props, width) {
	  var scale = props.scale;
	  var range = scale.y.range();
	  var r = Math.max.apply(Math, _toConsumableArray(range));
	  var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
	  return width / (2 * Math.PI * r) * angularRange;
	};
	
	var transformAngle = function (angle) {
	  return -1 * angle + Math.PI / 2;
	};
	
	var getCustomBarPath = function (props, width) {
	  var getPath = props.getPath;
	
	  var propsWithCalculatedValues = _objectSpread({}, props, getPosition(props, width));
	
	  return getPath(propsWithCalculatedValues);
	};
	
	exports.getCustomBarPath = getCustomBarPath;
	
	var getStartAngle = function (props, index) {
	  var data = props.data,
	      scale = props.scale,
	      alignment = props.alignment;
	  var currentAngle = getAngle(props, index);
	  var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
	  var previousAngle = index === 0 ? getAngle(props, data.length - 1) - Math.PI * 2 : getAngle(props, index - 1);
	
	  if (index === 0 && angularRange < 2 * Math.PI) {
	    return scale.x.range()[0];
	  } else if (alignment === "start" || alignment === "end") {
	    return alignment === "start" ? previousAngle : currentAngle;
	  } else {
	    return (currentAngle + previousAngle) / 2;
	  }
	};
	
	var getEndAngle = function (props, index) {
	  var data = props.data,
	      scale = props.scale,
	      alignment = props.alignment;
	  var currentAngle = getAngle(props, index);
	  var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
	  var lastAngle = scale.x.range()[1] === 2 * Math.PI ? getAngle(props, 0) + Math.PI * 2 : scale.x.range()[1];
	  var nextAngle = index === data.length - 1 ? getAngle(props, 0) + Math.PI * 2 : getAngle(props, index + 1);
	
	  if (index === data.length - 1 && angularRange < 2 * Math.PI) {
	    return lastAngle;
	  } else if (alignment === "start" || alignment === "end") {
	    return alignment === "start" ? currentAngle : nextAngle;
	  } else {
	    return (currentAngle + nextAngle) / 2;
	  }
	};
	
	var mapPointsToPath = function (coords, cornerRadius, direction) {
	  var topLeftPath = "".concat(cornerRadius.topLeft, " ").concat(cornerRadius.topLeft, " ").concat(direction);
	  var topRightPath = "".concat(cornerRadius.topRight, " ").concat(cornerRadius.topRight, " ").concat(direction);
	  var bottomLeftPath = "".concat(cornerRadius.bottomLeft, " ").concat(cornerRadius.bottomLeft, " ").concat(direction);
	  var bottomRightPath = "".concat(cornerRadius.bottomRight, " ").concat(cornerRadius.bottomRight, " ").concat(direction);
	  var commands = ["M", "A ".concat(bottomLeftPath, ","), "L", "A ".concat(topLeftPath, ","), "L", "A ".concat(topRightPath, ","), "L", "A ".concat(bottomRightPath, ",")];
	  var path = commands.reduce(function (acc, command, i) {
	    acc += "".concat(command, " ").concat(coords[i].x, ", ").concat(coords[i].y, " \n");
	    return acc;
	  }, "");
	  return "".concat(path, " z");
	};
	
	var getVerticalBarPoints = function (position, sign, cr) {
	  var x0 = position.x0,
	      x1 = position.x1,
	      y0 = position.y0,
	      y1 = position.y1; // eslint-disable-next-line max-statements, max-len
	
	  var getHalfPoints = function (side) {
	    var isLeft = side === "Left";
	    var signL = isLeft ? 1 : -1;
	    var x = isLeft ? x0 : x1;
	    var bottomPoint = {
	      x: x + signL * cr["bottom".concat(side)],
	      y: y0
	    };
	    var bottomMiddlePoint = {
	      x: x,
	      y: y0 - sign * cr["bottom".concat(side)]
	    };
	    var topMiddlePoint = {
	      x: x,
	      y: y1 + sign * cr["top".concat(side)]
	    };
	    var topPoint = {
	      x: x + signL * cr["top".concat(side)],
	      y: y1
	    };
	    var hasIntersection = sign === 1 ? y0 - cr["bottom".concat(side)] < y1 + cr["top".concat(side)] : y0 + cr["bottom".concat(side)] > y1 - cr["top".concat(side)];
	
	    if (hasIntersection) {
	      var topCenter = (0, _geometryHelperMethods.point)(x + signL * cr["top".concat(side)], y1 + sign * cr["top".concat(side)]);
	      var topCircle = (0, _geometryHelperMethods.circle)(topCenter, cr["top".concat(side)]);
	      var bottomCenter = (0, _geometryHelperMethods.point)(x + signL * cr["bottom".concat(side)], y0 - sign * cr["bottom".concat(side)]);
	      var bottomCircle = (0, _geometryHelperMethods.circle)(bottomCenter, cr["bottom".concat(side)]);
	      var circleIntersection = topCircle.intersection(bottomCircle);
	      var hasArcIntersection = circleIntersection.length > 0;
	
	      if (hasArcIntersection) {
	        var arcIntersection = circleIntersection[isLeft ? 0 : 1];
	        bottomMiddlePoint = {
	          x: arcIntersection.x,
	          y: arcIntersection.y
	        };
	        topMiddlePoint = {
	          x: arcIntersection.x,
	          y: arcIntersection.y
	        };
	      } else {
	        var hasBottomLineTopArcIntersection = cr["top".concat(side)] > cr["bottom".concat(side)];
	
	        if (hasBottomLineTopArcIntersection) {
	          var newX = topCircle.solveX(y0)[isLeft ? 0 : 1];
	          bottomPoint = {
	            x: newX,
	            y: y0
	          };
	          bottomMiddlePoint = {
	            x: newX,
	            y: y0
	          };
	          topMiddlePoint = {
	            x: newX,
	            y: y0
	          };
	        } else {
	          var _newX = bottomCircle.solveX(y1)[isLeft ? 0 : 1];
	          bottomMiddlePoint = {
	            x: _newX,
	            y: y1
	          };
	          topMiddlePoint = {
	            x: _newX,
	            y: y1
	          };
	          topPoint = {
	            x: _newX,
	            y: y1
	          };
	        }
	      }
	    }
	
	    var points = [bottomPoint, bottomMiddlePoint, topMiddlePoint, topPoint];
	    return isLeft ? points : points.reverse();
	  };
	
	  return getHalfPoints("Left").concat(getHalfPoints("Right"));
	};
	
	var getHorizontalBarPoints = function (position, sign, cr) {
	  var y0 = position.y0,
	      y1 = position.y1;
	  var x0 = position.x0 < position.x1 ? position.x0 : position.x1;
	  var x1 = position.x0 < position.x1 ? position.x1 : position.x0; // eslint-disable-next-line max-statements, max-len
	
	  var getHalfPoints = function (side) {
	    var isTop = side === "top";
	    var signL = isTop ? -1 : 1;
	    var y = isTop ? y1 : y0;
	    var leftPoint = {
	      x: x0,
	      y: y - signL * cr["".concat(side, "Left")]
	    };
	    var leftMiddlePoint = {
	      x: x0 + cr["".concat(side, "Left")],
	      y: y
	    };
	    var rightMiddlePoint = {
	      x: x1 - cr["".concat(side, "Right")],
	      y: y
	    };
	    var rightPoint = {
	      x: x1,
	      y: y - signL * cr["".concat(side, "Right")]
	    };
	    var hasIntersection = leftMiddlePoint.x > rightMiddlePoint.x;
	
	    if (hasIntersection) {
	      var leftCenter = (0, _geometryHelperMethods.point)(x0 + cr["".concat(side, "Left")], y - signL * cr["".concat(side, "Left")]);
	      var leftCircle = (0, _geometryHelperMethods.circle)(leftCenter, cr["".concat(side, "Left")]);
	      var rightCenter = (0, _geometryHelperMethods.point)(x1 - cr["".concat(side, "Right")], y - signL * cr["".concat(side, "Right")]);
	      var rightCircle = (0, _geometryHelperMethods.circle)(rightCenter, cr["".concat(side, "Right")]);
	      var circleIntersection = leftCircle.intersection(rightCircle);
	      var hasArcIntersection = circleIntersection.length > 0;
	
	      if (hasArcIntersection) {
	        var arcIntersection = circleIntersection[sign > 0 ? 1 : 0];
	        leftMiddlePoint = {
	          x: arcIntersection.x,
	          y: arcIntersection.y
	        };
	        rightMiddlePoint = {
	          x: arcIntersection.x,
	          y: arcIntersection.y
	        };
	      } else {
	        var hasLeftLineRightArcIntersection = cr["".concat(side, "Right")] > cr["".concat(side, "Left")];
	
	        if (hasLeftLineRightArcIntersection) {
	          var newY = rightCircle.solveY(x0)[isTop ? 0 : 1];
	          leftPoint = {
	            x: x0,
	            y: newY
	          };
	          leftMiddlePoint = {
	            x: x0,
	            y: newY
	          };
	          rightMiddlePoint = {
	            x: x0,
	            y: newY
	          };
	        } else {
	          var _newY = leftCircle.solveY(x1)[isTop ? 0 : 1];
	          rightPoint = {
	            x: x1,
	            y: _newY
	          };
	          rightMiddlePoint = {
	            x: x1,
	            y: _newY
	          };
	          leftMiddlePoint = {
	            x: x1,
	            y: _newY
	          };
	        }
	      }
	    }
	
	    return [leftPoint, leftMiddlePoint, rightMiddlePoint, rightPoint];
	  };
	
	  var topPoints = getHalfPoints("top");
	  var bottomPoints = getHalfPoints("bottom"); // eslint-disable-next-line no-magic-numbers
	
	  return [bottomPoints[1], bottomPoints[0]].concat(_toConsumableArray(topPoints), [bottomPoints[3], bottomPoints[2]]);
	};
	
	var getVerticalBarPath = function (props, width, cornerRadius) {
	  var position = getPosition(props, width);
	  var sign = position.y0 > position.y1 ? 1 : -1;
	  var direction = sign > 0 ? "0 0 1" : "0 0 0";
	  var points = getVerticalBarPoints(position, sign, cornerRadius);
	  return mapPointsToPath(points, cornerRadius, direction);
	};
	
	exports.getVerticalBarPath = getVerticalBarPath;
	
	var getHorizontalBarPath = function (props, width, cornerRadius) {
	  var position = getPosition(props, width);
	  var sign = position.x0 < position.x1 ? 1 : -1;
	  var direction = "0 0 1";
	  var cr = {
	    topRight: sign > 0 ? cornerRadius.topLeft : cornerRadius.bottomLeft,
	    bottomRight: sign > 0 ? cornerRadius.topRight : cornerRadius.bottomRight,
	    bottomLeft: sign > 0 ? cornerRadius.bottomRight : cornerRadius.topRight,
	    topLeft: sign > 0 ? cornerRadius.bottomLeft : cornerRadius.topLeft
	  };
	  var points = getHorizontalBarPoints(position, sign, cr);
	  return mapPointsToPath(points, cr, direction);
	};
	
	exports.getHorizontalBarPath = getHorizontalBarPath;
	
	var getVerticalPolarBarPath = function (props, cornerRadius) {
	  var datum = props.datum,
	      scale = props.scale,
	      index = props.index,
	      alignment = props.alignment,
	      style = props.style;
	  var r1 = scale.y(datum._y0 || 0);
	  var r2 = scale.y(datum._y1 !== undefined ? datum._y1 : datum._y);
	  var currentAngle = scale.x(datum._x1 !== undefined ? datum._x1 : datum._x);
	  var start;
	  var end;
	
	  if (style.width) {
	    var width = getAngularWidth(props, style.width);
	    var size = alignment === "middle" ? width / 2 : width;
	    start = alignment === "start" ? currentAngle : currentAngle - size;
	    end = alignment === "end" ? currentAngle : currentAngle + size;
	  } else {
	    start = getStartAngle(props, index);
	    end = getEndAngle(props, index);
	  }
	
	  var getPath = function (edge) {
	    var pathFunction = d3Shape.arc().innerRadius(r1).outerRadius(r2).startAngle(transformAngle(start)).endAngle(transformAngle(end)).cornerRadius(cornerRadius[edge]);
	    return pathFunction();
	  };
	
	  var getPathData = function (edge) {
	    var rightPath = getPath("".concat(edge, "Right"));
	    var rightMoves = rightPath.match(/[A-Z]/g);
	    var rightCoords = rightPath.split(/[A-Z]/).slice(1);
	    var rightMiddle = rightMoves.indexOf("L");
	    var leftPath = getPath("".concat(edge, "Left"));
	    var leftMoves = leftPath.match(/[A-Z]/g);
	    var leftCoords = leftPath.split(/[A-Z]/).slice(1);
	    var leftMiddle = leftMoves.indexOf("L");
	    return {
	      rightMoves: rightMoves,
	      rightCoords: rightCoords,
	      rightMiddle: rightMiddle,
	      leftMoves: leftMoves,
	      leftCoords: leftCoords,
	      leftMiddle: leftMiddle
	    };
	  }; // eslint-disable-next-line max-statements
	
	
	  var getTopPath = function () {
	    var topRight = cornerRadius.topRight,
	        topLeft = cornerRadius.topLeft;
	    var arcLength = r2 * Math.abs(end - start);
	
	    var _getPathData = getPathData("top"),
	        rightMoves = _getPathData.rightMoves,
	        rightCoords = _getPathData.rightCoords,
	        rightMiddle = _getPathData.rightMiddle,
	        leftMoves = _getPathData.leftMoves,
	        leftCoords = _getPathData.leftCoords,
	        leftMiddle = _getPathData.leftMiddle;
	
	    var moves;
	    var coords;
	
	    if (topRight === topLeft || arcLength < 2 * topRight + 2 * topLeft) {
	      moves = topRight > topLeft ? rightMoves : leftMoves;
	      coords = topRight > topLeft ? rightCoords : leftCoords;
	    } else {
	      // eslint-disable-next-line no-magic-numbers
	      var isShort = function (middle) {
	        return middle < 3;
	      };
	
	      var rightOffset = topLeft > topRight && isShort(rightMiddle) ? 1 : 2;
	      var leftOffset;
	
	      if (topRight > topLeft) {
	        var defaultOffset = isShort(rightMiddle) ? leftMiddle : leftMiddle - 2;
	        leftOffset = isShort(leftMiddle) ? leftMiddle - 1 : defaultOffset;
	      } else {
	        var _defaultOffset = isShort(leftMiddle) ? 1 : 2;
	
	        leftOffset = isShort(rightMiddle) ? _defaultOffset : leftMiddle - 2;
	      }
	
	      moves = _toConsumableArray(rightMoves.slice(0, rightOffset)).concat(_toConsumableArray(leftMoves.slice(leftOffset)));
	      coords = _toConsumableArray(rightCoords.slice(0, rightOffset)).concat(_toConsumableArray(leftCoords.slice(leftOffset)));
	    }
	
	    var middle = moves.indexOf("L");
	    var subMoves = moves.slice(0, middle);
	    var subCoords = coords.slice(0, middle);
	    return subMoves.map(function (m, i) {
	      return {
	        command: m,
	        coords: subCoords[i].split(",")
	      };
	    });
	  }; // eslint-disable-next-line max-statements
	
	
	  var getBottomPath = function () {
	    var bottomRight = cornerRadius.bottomRight,
	        bottomLeft = cornerRadius.bottomLeft;
	    var arcLength = r1 * Math.abs(end - start);
	
	    var _getPathData2 = getPathData("bottom"),
	        rightMoves = _getPathData2.rightMoves,
	        rightCoords = _getPathData2.rightCoords,
	        rightMiddle = _getPathData2.rightMiddle,
	        leftMoves = _getPathData2.leftMoves,
	        leftCoords = _getPathData2.leftCoords,
	        leftMiddle = _getPathData2.leftMiddle;
	
	    var moves;
	    var coords;
	
	    if (bottomRight === bottomLeft || arcLength < 2 * bottomRight + 2 * bottomLeft) {
	      moves = bottomRight > bottomLeft ? rightMoves : leftMoves;
	      coords = bottomRight > bottomLeft ? rightCoords : leftCoords;
	    } else {
	      // eslint-disable-next-line no-magic-numbers
	      var isShort = function (m, middle) {
	        return m.length - middle < 4;
	      };
	
	      var shortPath = bottomRight > bottomLeft ? isShort(rightMoves, rightMiddle) : isShort(leftMoves, leftMiddle); // eslint-disable-next-line no-magic-numbers
	
	      var rightOffset = shortPath ? -1 : -3;
	      moves = _toConsumableArray(leftMoves.slice(0, leftMiddle + 2)).concat(_toConsumableArray(rightMoves.slice(rightOffset)));
	      coords = _toConsumableArray(leftCoords.slice(0, leftMiddle + 2)).concat(_toConsumableArray(rightCoords.slice(rightOffset)));
	    }
	
	    var middle = moves.indexOf("L");
	    var subMoves = moves.slice(middle, -1);
	    var subCoords = coords.slice(middle, -1);
	    return subMoves.map(function (m, i) {
	      return {
	        command: m,
	        coords: subCoords[i].split(",")
	      };
	    });
	  };
	
	  var topPath = getTopPath();
	  var bottomPath = getBottomPath();
	
	  var moves = _toConsumableArray(topPath).concat(_toConsumableArray(bottomPath));
	
	  var path = moves.reduce(function (memo, move) {
	    memo += "".concat(move.command, " ").concat(move.coords.join());
	    return memo;
	  }, "");
	  return "".concat(path, " z");
	};
	
	exports.getVerticalPolarBarPath = getVerticalPolarBarPath;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _mapValues5 = _interopRequireDefault(__webpack_require__(447));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(153));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var Helpers = {
	  getDimension: function (props) {
	    var horizontal = props.horizontal,
	        brushDimension = props.brushDimension;
	
	    if (!horizontal || !brushDimension) {
	      return brushDimension;
	    }
	
	    return brushDimension === "x" ? "y" : "x";
	  },
	  withinBounds: function (point, bounds, padding) {
	    var _mapValues2 = (0, _mapValues5.default)(bounds, Number),
	        x1 = _mapValues2.x1,
	        x2 = _mapValues2.x2,
	        y1 = _mapValues2.y1,
	        y2 = _mapValues2.y2;
	
	    var _mapValues3 = (0, _mapValues5.default)(point, Number),
	        x = _mapValues3.x,
	        y = _mapValues3.y;
	
	    padding = padding ? padding / 2 : 0;
	    return x + padding >= Math.min(x1, x2) && x - padding <= Math.max(x1, x2) && y + padding >= Math.min(y1, y2) && y - padding <= Math.max(y1, y2);
	  },
	  getDomainBox: function (props, fullDomain, selectedDomain) {
	    var brushDimension = this.getDimension(props);
	    fullDomain = (0, _defaults2.default)({}, fullDomain, props.domain);
	    selectedDomain = (0, _defaults2.default)({}, selectedDomain, fullDomain);
	
	    var fullCoords = _victoryCore.Selection.getDomainCoordinates(props, fullDomain);
	
	    var selectedCoords = _victoryCore.Selection.getDomainCoordinates(props, selectedDomain);
	
	    return {
	      x1: brushDimension !== "y" ? Math.min.apply(Math, _toConsumableArray(selectedCoords.x)) : Math.min.apply(Math, _toConsumableArray(fullCoords.x)),
	      x2: brushDimension !== "y" ? Math.max.apply(Math, _toConsumableArray(selectedCoords.x)) : Math.max.apply(Math, _toConsumableArray(fullCoords.x)),
	      y1: brushDimension !== "x" ? Math.min.apply(Math, _toConsumableArray(selectedCoords.y)) : Math.min.apply(Math, _toConsumableArray(fullCoords.y)),
	      y2: brushDimension !== "x" ? Math.max.apply(Math, _toConsumableArray(selectedCoords.y)) : Math.max.apply(Math, _toConsumableArray(fullCoords.y))
	    };
	  },
	  getHandles: function (props, domainBox) {
	    var brushDimension = this.getDimension(props);
	    var x1 = domainBox.x1,
	        x2 = domainBox.x2,
	        y1 = domainBox.y1,
	        y2 = domainBox.y2;
	    var minX = Math.min(x1, x2);
	    var maxX = Math.max(x1, x2);
	    var minY = Math.min(y1, y2);
	    var maxY = Math.max(y1, y2);
	    var handleWidth = props.handleWidth / 2;
	    return {
	      left: brushDimension !== "y" && {
	        x1: minX - handleWidth,
	        x2: minX + handleWidth,
	        y1: y1,
	        y2: y2
	      },
	      right: brushDimension !== "y" && {
	        x1: maxX - handleWidth,
	        x2: maxX + handleWidth,
	        y1: y1,
	        y2: y2
	      },
	      top: brushDimension !== "x" && {
	        x1: x1,
	        x2: x2,
	        y1: minY - handleWidth,
	        y2: minY + handleWidth
	      },
	      bottom: brushDimension !== "x" && {
	        x1: x1,
	        x2: x2,
	        y1: maxY - handleWidth,
	        y2: maxY + handleWidth
	      }
	    };
	  },
	  getActiveHandles: function (point, props, domainBox) {
	    var _this = this;
	
	    var handles = this.getHandles(props, domainBox);
	    var activeHandles = ["top", "bottom", "left", "right"].reduce(function (memo, opt) {
	      memo = handles[opt] && _this.withinBounds(point, handles[opt]) ? memo.concat(opt) : memo;
	      return memo;
	    }, []);
	    return activeHandles.length && activeHandles;
	  },
	  getResizeMutation: function (box, handles) {
	    var x1 = box.x1,
	        y1 = box.y1,
	        x2 = box.x2,
	        y2 = box.y2;
	    var mutations = {
	      left: {
	        x1: Math.max(x1, x2),
	        x2: Math.min(x1, x2),
	        y1: y1,
	        y2: y2
	      },
	      right: {
	        x1: Math.min(x1, x2),
	        x2: Math.max(x1, x2),
	        y1: y1,
	        y2: y2
	      },
	      top: {
	        y1: Math.max(y1, y2),
	        y2: Math.min(y1, y2),
	        x1: x1,
	        x2: x2
	      },
	      bottom: {
	        y1: Math.min(y1, y2),
	        y2: Math.max(y1, y2),
	        x1: x1,
	        x2: x2
	      }
	    };
	    return handles.reduce(function (memo, current) {
	      return (0, _assign2.default)(memo, mutations[current]);
	    }, {});
	  },
	  getMinimumDomain: function () {
	    return {
	      x: [0, 1 / Number.MAX_SAFE_INTEGER],
	      y: [0, 1 / Number.MAX_SAFE_INTEGER]
	    };
	  },
	  getDefaultBrushArea: function (targetProps, cachedDomain, evt) {
	    var defaultBrushArea = targetProps.defaultBrushArea,
	        domain = targetProps.domain,
	        fullDomain = targetProps.fullDomain,
	        scale = targetProps.scale,
	        horizontal = targetProps.horizontal;
	
	    if (defaultBrushArea === "none") {
	      return this.getMinimumDomain();
	    } else if (defaultBrushArea === "disable") {
	      return cachedDomain;
	    } else if (defaultBrushArea === "move") {
	      var brushBox = this.getDomainBox(targetProps, fullDomain, cachedDomain);
	
	      var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	      var pannedBox = this.panBox(_objectSpread({}, targetProps, brushBox, {
	        brushDomain: cachedDomain,
	        startX: (brushBox.x1 + brushBox.x2) / 2,
	        startY: (brushBox.y1 + brushBox.y2) / 2
	      }), _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG));
	      var fullDomainBox = targetProps.fullDomainBox || this.getDomainBox(targetProps, fullDomain);
	      var constrainedBox = this.constrainBox(pannedBox, fullDomainBox);
	      return _victoryCore.Selection.getBounds(_objectSpread({}, constrainedBox, {
	        scale: scale,
	        horizontal: horizontal
	      }));
	    } else {
	      return domain;
	    }
	  },
	  getSelectionMutation: function (point, box, brushDimension) {
	    var x = point.x,
	        y = point.y;
	    var x1 = box.x1,
	        x2 = box.x2,
	        y1 = box.y1,
	        y2 = box.y2;
	    return {
	      x1: brushDimension !== "y" ? x : x1,
	      y1: brushDimension !== "x" ? y : y1,
	      x2: brushDimension !== "y" ? x : x2,
	      y2: brushDimension !== "x" ? y : y2
	    };
	  },
	  panBox: function (props, point) {
	    var domain = props.domain,
	        startX = props.startX,
	        startY = props.startY;
	    var brushDimension = this.getDimension(props);
	    var brushDomain = (0, _defaults2.default)({}, props.brushDomain, domain);
	    var fullDomain = (0, _defaults2.default)({}, props.fullDomain, domain);
	
	    var _ref = props.x1 ? props : this.getDomainBox(props, fullDomain, brushDomain),
	        x1 = _ref.x1,
	        x2 = _ref.x2,
	        y1 = _ref.y1,
	        y2 = _ref.y2;
	
	    var x = point.x,
	        y = point.y;
	    var delta = {
	      x: startX ? startX - x : 0,
	      y: startY ? startY - y : 0
	    };
	    return {
	      x1: brushDimension !== "y" ? Math.min(x1, x2) - delta.x : Math.min(x1, x2),
	      x2: brushDimension !== "y" ? Math.max(x1, x2) - delta.x : Math.max(x1, x2),
	      y1: brushDimension !== "x" ? Math.min(y1, y2) - delta.y : Math.min(y1, y2),
	      y2: brushDimension !== "x" ? Math.max(y1, y2) - delta.y : Math.max(y1, y2)
	    };
	  },
	  constrainBox: function (box, fullDomainBox) {
	    var _mapValues4 = (0, _mapValues5.default)(fullDomainBox, Number),
	        x1 = _mapValues4.x1,
	        y1 = _mapValues4.y1,
	        x2 = _mapValues4.x2,
	        y2 = _mapValues4.y2;
	
	    return {
	      x1: box.x2 > x2 ? x2 - Math.abs(box.x2 - box.x1) : Math.max(box.x1, x1),
	      y1: box.y2 > y2 ? y2 - Math.abs(box.y2 - box.y1) : Math.max(box.y1, y1),
	      x2: box.x1 < x1 ? x1 + Math.abs(box.x2 - box.x1) : Math.min(box.x2, x2),
	      y2: box.y1 < y1 ? y1 + Math.abs(box.y2 - box.y1) : Math.min(box.y2, y2)
	    };
	  },
	  hasMoved: function (props) {
	    var x1 = props.x1,
	        x2 = props.x2,
	        y1 = props.y1,
	        y2 = props.y2,
	        mouseMoveThreshold = props.mouseMoveThreshold;
	    var brushDimension = this.getDimension(props);
	    var xMoved = Math.abs(x1 - x2) >= mouseMoveThreshold;
	    var yMoved = Math.abs(y1 - y2) >= mouseMoveThreshold;
	
	    switch (brushDimension) {
	      case "x":
	        return xMoved;
	
	      case "y":
	        return yMoved;
	
	      default:
	        return xMoved || yMoved;
	    }
	  },
	  // eslint-disable-next-line max-statements, complexity
	  onMouseDown: function (evt, targetProps) {
	    var _this2 = this;
	
	    evt.preventDefault();
	    var handleWidth = targetProps.handleWidth,
	        cachedBrushDomain = targetProps.cachedBrushDomain,
	        domain = targetProps.domain,
	        allowResize = targetProps.allowResize,
	        allowDrag = targetProps.allowDrag,
	        allowDraw = targetProps.allowDraw;
	    var brushDimension = this.getDimension(targetProps); // Don't trigger events for static brushes
	
	    if (!allowResize && !allowDrag) {
	      return {};
	    }
	
	    var fullDomainBox = targetProps.fullDomainBox || this.getDomainBox(targetProps, domain);
	
	    var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	    var _Selection$getSVGEven = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG),
	        x = _Selection$getSVGEven.x,
	        y = _Selection$getSVGEven.y; // Ignore events that occur outside of the maximum domain region
	
	
	    if (!this.withinBounds({
	      x: x,
	      y: y
	    }, fullDomainBox, handleWidth)) {
	      return {};
	    }
	
	    var brushDomain = (0, _defaults2.default)({}, targetProps.brushDomain, domain);
	    var currentDomain = (0, _reactFastCompare.default)(brushDomain, cachedBrushDomain) ? targetProps.currentDomain || brushDomain || domain : brushDomain || domain;
	    var domainBox = this.getDomainBox(targetProps, domain, currentDomain);
	    var activeHandles = allowResize && this.getActiveHandles({
	      x: x,
	      y: y
	    }, targetProps, domainBox); // If the event occurs in any of the handle regions, start a resize
	
	    if (activeHandles) {
	      return [{
	        target: "parent",
	        mutation: function () {
	          return _objectSpread({
	            isSelecting: true,
	            domainBox: domainBox,
	            fullDomainBox: fullDomainBox,
	            cachedBrushDomain: brushDomain,
	            currentDomain: currentDomain,
	            parentSVG: parentSVG
	          }, _this2.getResizeMutation(domainBox, activeHandles));
	        }
	      }];
	    } else if (this.withinBounds({
	      x: x,
	      y: y
	    }, domainBox) && !(0, _reactFastCompare.default)(domain, currentDomain)) {
	      // if the event occurs within a selected region start a panning event, unless the whole
	      // domain is selected
	      return [{
	        target: "parent",
	        mutation: function () {
	          return _objectSpread({
	            isPanning: allowDrag,
	            startX: x,
	            startY: y,
	            domainBox: domainBox,
	            fullDomainBox: fullDomainBox,
	            currentDomain: currentDomain,
	            cachedBrushDomain: brushDomain,
	            parentSVG: parentSVG
	          }, domainBox);
	        }
	      }];
	    } else {
	      // if the event occurs outside the region, or if the whole domain is selected,
	      // start a new selection
	      return allowDraw ? [{
	        target: "parent",
	        mutation: function () {
	          return _objectSpread({
	            isSelecting: allowResize,
	            domainBox: domainBox,
	            fullDomainBox: fullDomainBox,
	            parentSVG: parentSVG,
	            cachedBrushDomain: brushDomain,
	            cachedCurrentDomain: currentDomain,
	            currentDomain: _this2.getMinimumDomain()
	          }, _this2.getSelectionMutation({
	            x: x,
	            y: y
	          }, domainBox, brushDimension));
	        }
	      }] : {};
	    }
	  },
	  // eslint-disable-next-line max-statements, complexity
	  onMouseMove: function (evt, targetProps) {
	    // if a panning or selection has not been started, ignore the event
	    if (!targetProps.isPanning && !targetProps.isSelecting) {
	      return {};
	    }
	
	    var scale = targetProps.scale,
	        isPanning = targetProps.isPanning,
	        isSelecting = targetProps.isSelecting,
	        fullDomainBox = targetProps.fullDomainBox,
	        onBrushDomainChange = targetProps.onBrushDomainChange,
	        allowResize = targetProps.allowResize,
	        allowDrag = targetProps.allowDrag,
	        horizontal = targetProps.horizontal,
	        mouseMoveThreshold = targetProps.mouseMoveThreshold;
	    var brushDimension = this.getDimension(targetProps);
	
	    var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	    var _Selection$getSVGEven2 = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG),
	        x = _Selection$getSVGEven2.x,
	        y = _Selection$getSVGEven2.y; // Ignore events that occur outside of the maximum domain region
	
	
	    if (!allowResize && !allowDrag || !this.withinBounds({
	      x: x,
	      y: y
	    }, fullDomainBox) || mouseMoveThreshold > 0 && !this.hasMoved(_objectSpread({}, targetProps, {
	      x2: x,
	      y2: y
	    }))) {
	      return {};
	    }
	
	    if (allowDrag && isPanning) {
	      var startX = targetProps.startX,
	          startY = targetProps.startY;
	      var pannedBox = this.panBox(targetProps, {
	        x: x,
	        y: y
	      });
	      var constrainedBox = this.constrainBox(pannedBox, fullDomainBox);
	
	      var currentDomain = _victoryCore.Selection.getBounds(_objectSpread({}, constrainedBox, {
	        scale: scale,
	        horizontal: horizontal
	      }));
	
	      var mutatedProps = _objectSpread({
	        currentDomain: currentDomain,
	        parentSVG: parentSVG,
	        startX: pannedBox.x2 >= fullDomainBox.x2 || pannedBox.x1 <= fullDomainBox.x1 ? startX : x,
	        startY: pannedBox.y2 >= fullDomainBox.y2 || pannedBox.y1 <= fullDomainBox.y1 ? startY : y
	      }, constrainedBox);
	
	      if ((0, _isFunction2.default)(onBrushDomainChange)) {
	        onBrushDomainChange(currentDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	      }
	
	      return [{
	        target: "parent",
	        mutation: function () {
	          return mutatedProps;
	        }
	      }];
	    } else if (allowResize && isSelecting) {
	      var x2 = brushDimension !== "y" ? x : targetProps.x2;
	      var y2 = brushDimension !== "x" ? y : targetProps.y2;
	
	      var _currentDomain = _victoryCore.Selection.getBounds({
	        x2: x2,
	        y2: y2,
	        x1: targetProps.x1,
	        y1: targetProps.y1,
	        scale: scale,
	        horizontal: horizontal
	      });
	
	      var _mutatedProps = {
	        x2: x2,
	        y2: y2,
	        currentDomain: _currentDomain,
	        parentSVG: parentSVG
	      };
	
	      if ((0, _isFunction2.default)(onBrushDomainChange)) {
	        onBrushDomainChange(_currentDomain, (0, _defaults2.default)({}, _mutatedProps, targetProps));
	      }
	
	      return [{
	        target: "parent",
	        mutation: function () {
	          return _mutatedProps;
	        }
	      }];
	    }
	
	    return {};
	  },
	  onMouseUp: function (evt, targetProps) {
	    // eslint-disable-line max-statements, complexity
	    var x1 = targetProps.x1,
	        y1 = targetProps.y1,
	        x2 = targetProps.x2,
	        y2 = targetProps.y2,
	        isPanning = targetProps.isPanning,
	        isSelecting = targetProps.isSelecting,
	        onBrushDomainChange = targetProps.onBrushDomainChange,
	        onBrushDomainChangeEnd = targetProps.onBrushDomainChangeEnd,
	        onBrushCleared = targetProps.onBrushCleared,
	        currentDomain = targetProps.currentDomain,
	        allowResize = targetProps.allowResize,
	        allowDrag = targetProps.allowDrag,
	        defaultBrushArea = targetProps.defaultBrushArea;
	    var defaultBrushHasArea = defaultBrushArea !== undefined && defaultBrushArea !== "none";
	    var mutatedProps = {
	      isPanning: false,
	      isSelecting: false
	    }; // if the mouse hasn't moved since a mouseDown event, select the default brush area
	
	    if ((allowResize || defaultBrushHasArea) && (x1 === x2 || y1 === y2)) {
	      var cachedDomain = targetProps.cachedCurrentDomain || currentDomain;
	      var defaultDomain = this.getDefaultBrushArea(targetProps, cachedDomain, evt);
	      mutatedProps.currentDomain = defaultDomain;
	
	      if ((0, _isFunction2.default)(onBrushDomainChange)) {
	        onBrushDomainChange(defaultDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	      }
	
	      if ((0, _isFunction2.default)(onBrushDomainChangeEnd)) {
	        onBrushDomainChangeEnd(defaultDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	      }
	
	      if ((0, _isFunction2.default)(onBrushCleared)) {
	        onBrushCleared(defaultDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	      }
	    } else if (allowDrag && isPanning || allowResize && isSelecting) {
	      if ((0, _isFunction2.default)(onBrushDomainChangeEnd)) {
	        onBrushDomainChangeEnd(currentDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	      }
	    }
	
	    return [{
	      target: "parent",
	      mutation: function () {
	        return mutatedProps;
	      }
	    }];
	  },
	  onMouseLeave: function () {
	    return [{
	      target: "parent",
	      mutation: function () {
	        return {
	          isPanning: false,
	          isSelecting: false
	        };
	      }
	    }];
	  }
	};
	
	var _default = _objectSpread({}, Helpers, {
	  onMouseDown: Helpers.onMouseDown.bind(Helpers),
	  onMouseUp: Helpers.onMouseUp.bind(Helpers),
	  onMouseLeave: Helpers.onMouseLeave.bind(Helpers),
	  onMouseMove: (0, _throttle2.default)(Helpers.onMouseMove.bind(Helpers), 16, // eslint-disable-line no-magic-numbers
	  {
	    leading: true,
	    trailing: false
	  })
	});
	
	exports.default = _default;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "brushContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryBrushContainer.brushContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryBrushContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryBrushContainer.default;
	  }
	});
	Object.defineProperty(exports, "BrushHelpers", {
	  enumerable: true,
	  get: function () {
	    return _brushHelpers.default;
	  }
	});
	
	var _victoryBrushContainer = _interopRequireWildcard(__webpack_require__(1850));
	
	var _brushHelpers = _interopRequireDefault(__webpack_require__(667));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getCandleWidth = function (candleWidth, props) {
	  var style = props.style;
	
	  if (candleWidth) {
	    return (0, _isFunction2.default)(candleWidth) ? _victoryCore.Helpers.evaluateProp(candleWidth, props) : candleWidth;
	  } else if (style.width) {
	    return style.width;
	  }
	
	  return candleWidth;
	};
	
	var getCandleProps = function (props, style) {
	  var id = props.id,
	      x = props.x,
	      close = props.close,
	      open = props.open,
	      horizontal = props.horizontal,
	      candleWidth = props.candleWidth;
	  var candleLength = Math.abs(close - open);
	  return {
	    key: "".concat(id, "-candle"),
	    style: _victoryCore.Helpers.omit(style, ["width"]),
	    x: horizontal ? Math.min(open, close) : x - candleWidth / 2,
	    y: horizontal ? x - candleWidth / 2 : Math.min(open, close),
	    width: horizontal ? candleLength : candleWidth,
	    height: horizontal ? candleWidth : candleLength
	  };
	};
	
	var getHighWickProps = function (props, style) {
	  var horizontal = props.horizontal,
	      high = props.high,
	      open = props.open,
	      close = props.close,
	      x = props.x,
	      id = props.id;
	  return {
	    key: "".concat(id, "-highWick"),
	    style: _victoryCore.Helpers.omit(style, ["width"]),
	    x1: horizontal ? high : x,
	    x2: horizontal ? Math.max(open, close) : x,
	    y1: horizontal ? x : high,
	    y2: horizontal ? x : Math.min(open, close)
	  };
	};
	
	var getLowWickProps = function (props, style) {
	  var horizontal = props.horizontal,
	      low = props.low,
	      open = props.open,
	      close = props.close,
	      x = props.x,
	      id = props.id;
	  return {
	    key: "".concat(id, "-lowWick"),
	    style: _victoryCore.Helpers.omit(style, ["width"]),
	    x1: horizontal ? Math.min(open, close) : x,
	    x2: horizontal ? low : x,
	    y1: horizontal ? x : Math.max(open, close),
	    y2: horizontal ? x : low
	  };
	};
	
	var evaluateProps = function (props) {
	  // Potential evaluated props are 1) `style`, 2) `candleWidth`
	  var style = _victoryCore.Helpers.evaluateStyle((0, _assign2.default)({
	    stroke: "black"
	  }, props.style), props);
	
	  var candleWidth = getCandleWidth(props.candleWidth, (0, _assign2.default)({}, props, {
	    style: style
	  }));
	  return (0, _assign2.default)({}, props, {
	    style: style,
	    candleWidth: candleWidth
	  });
	};
	
	var Candle = function (props) {
	  props = evaluateProps(props);
	  var _props = props,
	      events = _props.events,
	      groupComponent = _props.groupComponent,
	      clipPath = _props.clipPath,
	      rectComponent = _props.rectComponent,
	      lineComponent = _props.lineComponent,
	      role = _props.role,
	      shapeRendering = _props.shapeRendering,
	      className = _props.className,
	      wickStrokeWidth = _props.wickStrokeWidth,
	      transform = _props.transform,
	      style = _props.style;
	  var wickStyle = (0, _defaults2.default)({
	    strokeWidth: wickStrokeWidth
	  }, style);
	
	  var sharedProps = _objectSpread({}, events, {
	    role: role,
	    shapeRendering: shapeRendering,
	    className: className,
	    transform: transform,
	    clipPath: clipPath,
	    desc: _victoryCore.Helpers.evaluateProp(props.desc, props),
	    tabIndex: _victoryCore.Helpers.evaluateProp(props.tabIndex, props)
	  });
	
	  var candleProps = (0, _assign2.default)(getCandleProps(props, style), sharedProps);
	  var highWickProps = (0, _assign2.default)(getHighWickProps(props, wickStyle), sharedProps);
	  var lowWickProps = (0, _assign2.default)(getLowWickProps(props, wickStyle), sharedProps);
	  return _react.default.cloneElement(groupComponent, {}, [_react.default.cloneElement(rectComponent, candleProps), _react.default.cloneElement(lineComponent, highWickProps), _react.default.cloneElement(lineComponent, lowWickProps)]);
	};
	
	Candle.propTypes = _objectSpread({}, _victoryCore.CommonProps.primitiveProps, {
	  candleRatio: _propTypes.default.number,
	  candleWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  close: _propTypes.default.number,
	  datum: _propTypes.default.object,
	  groupComponent: _propTypes.default.element,
	  high: _propTypes.default.number,
	  lineComponent: _propTypes.default.element,
	  low: _propTypes.default.number,
	  open: _propTypes.default.number,
	  rectComponent: _propTypes.default.element,
	  wickStrokeWidth: _propTypes.default.number,
	  width: _propTypes.default.number,
	  x: _propTypes.default.number
	});
	Candle.defaultProps = {
	  groupComponent: _react.default.createElement("g", null),
	  lineComponent: _react.default.createElement(_victoryCore.Line, null),
	  rectComponent: _react.default.createElement(_victoryCore.Rect, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Candle;
	exports.default = _default;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var d3Ease = _interopRequireWildcard(__webpack_require__(1219));
	
	var _util = __webpack_require__(1859);
	
	var _timer = _interopRequireDefault(__webpack_require__(214));
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var VictoryAnimation =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryAnimation, _React$Component);
	
	  function VictoryAnimation(props) {
	    var _this;
	
	    _classCallCheck(this, VictoryAnimation);
	
	    _this = _possibleConstructorReturn(this, (VictoryAnimation.__proto__ || Object.getPrototypeOf(VictoryAnimation)).call(this, props));
	    /* defaults */
	
	    _this.state = {
	      data: Array.isArray(_this.props.data) ? _this.props.data[0] : _this.props.data,
	      animationInfo: {
	        progress: 0,
	        animating: false
	      }
	    };
	    _this.interpolator = null;
	    _this.queue = Array.isArray(_this.props.data) ? _this.props.data.slice(1) : [];
	    /* build easing function */
	
	    _this.ease = d3Ease[_this.toNewName(_this.props.easing)];
	    /*
	      There is no autobinding of this in ES6 classes
	      so we bind functionToBeRunEachFrame to current instance of victory animation class
	    */
	
	    _this.functionToBeRunEachFrame = _this.functionToBeRunEachFrame.bind(_assertThisInitialized(_this));
	    _this.getTimer = _this.getTimer.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(VictoryAnimation, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Length check prevents us from triggering `onEnd` in `traverseQueue`.
	      if (this.queue.length) {
	        this.traverseQueue();
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var equalProps = (0, _reactFastCompare.default)(this.props, nextProps);
	
	      if (!equalProps) {
	        /* cancel existing loop if it exists */
	        this.getTimer().unsubscribe(this.loopID);
	        /* If an object was supplied */
	
	        if (!Array.isArray(nextProps.data)) {
	          // Replace the tween queue. Could set `this.queue = [nextProps.data]`,
	          // but let's reuse the same array.
	          this.queue.length = 0;
	          this.queue.push(nextProps.data);
	          /* If an array was supplied */
	        } else {
	          var _queue;
	
	          /* Extend the tween queue */
	          (_queue = this.queue).push.apply(_queue, _toConsumableArray(nextProps.data));
	        }
	        /* Start traversing the tween queue */
	
	
	        this.traverseQueue();
	      }
	
	      return nextState.animationInfo.animating || nextState.animationInfo.terminating || !equalProps;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.loopID) {
	        this.getTimer().unsubscribe(this.loopID);
	      } else {
	        this.getTimer().stop();
	      }
	    }
	  }, {
	    key: "getTimer",
	    value: function getTimer() {
	      if (this.context.getTimer) {
	        return this.context.getTimer();
	      }
	
	      if (!this.timer) {
	        this.timer = new _timer.default();
	      }
	
	      return this.timer;
	    }
	  }, {
	    key: "toNewName",
	    value: function toNewName(ease) {
	      // d3-ease changed the naming scheme for ease from "linear" -> "easeLinear" etc.
	      var capitalize = function (s) {
	        return s && s[0].toUpperCase() + s.slice(1);
	      };
	
	      return "ease".concat(capitalize(ease));
	    }
	    /* Traverse the tween queue */
	
	  }, {
	    key: "traverseQueue",
	    value: function traverseQueue() {
	      var _this2 = this;
	
	      if (this.queue.length) {
	        /* Get the next index */
	        var data = this.queue[0];
	        /* compare cached version to next props */
	
	        this.interpolator = (0, _util.victoryInterpolator)(this.state.data, data);
	        /* reset step to zero */
	
	        if (this.props.delay) {
	          setTimeout(function () {
	            _this2.loopID = _this2.getTimer().subscribe(_this2.functionToBeRunEachFrame, _this2.props.duration);
	          }, this.props.delay);
	        } else {
	          this.loopID = this.getTimer().subscribe(this.functionToBeRunEachFrame, this.props.duration);
	        }
	      } else if (this.props.onEnd) {
	        this.props.onEnd();
	      }
	    }
	    /* every frame we... */
	
	  }, {
	    key: "functionToBeRunEachFrame",
	    value: function functionToBeRunEachFrame(elapsed, duration) {
	      /*
	        step can generate imprecise values, sometimes greater than 1
	        if this happens set the state to 1 and return, cancelling the timer
	      */
	      duration = duration !== undefined ? duration : this.props.duration;
	      var step = duration ? elapsed / duration : 1;
	
	      if (step >= 1) {
	        this.setState({
	          data: this.interpolator(1),
	          animationInfo: {
	            progress: 1,
	            animating: false,
	            terminating: true
	          }
	        });
	
	        if (this.loopID) {
	          this.getTimer().unsubscribe(this.loopID);
	        }
	
	        this.queue.shift();
	        this.traverseQueue();
	        return;
	      }
	      /*
	        if we're not at the end of the timer, set the state by passing
	        current step value that's transformed by the ease function to the
	        interpolator, which is cached for performance whenever props are received
	      */
	
	
	      this.setState({
	        data: this.interpolator(this.ease(step)),
	        animationInfo: {
	          progress: step,
	          animating: step < 1
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children(this.state.data, this.state.animationInfo);
	    }
	  }]);
	
	  return VictoryAnimation;
	}(_react.default.Component);
	
	exports.default = VictoryAnimation;
	Object.defineProperty(VictoryAnimation, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryAnimation"
	});
	Object.defineProperty(VictoryAnimation, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    children: _propTypes.default.func,
	    data: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
	    delay: _propTypes.default.number,
	    duration: _propTypes.default.number,
	    easing: _propTypes.default.oneOf(["back", "backIn", "backOut", "backInOut", "bounce", "bounceIn", "bounceOut", "bounceInOut", "circle", "circleIn", "circleOut", "circleInOut", "linear", "linearIn", "linearOut", "linearInOut", "cubic", "cubicIn", "cubicOut", "cubicInOut", "elastic", "elasticIn", "elasticOut", "elasticInOut", "exp", "expIn", "expOut", "expInOut", "poly", "polyIn", "polyOut", "polyInOut", "quad", "quadIn", "quadOut", "quadInOut", "sin", "sinIn", "sinOut", "sinInOut"]),
	    onEnd: _propTypes.default.func
	  }
	});
	Object.defineProperty(VictoryAnimation, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    data: {},
	    delay: 0,
	    duration: 1000,
	    easing: "quadInOut"
	  }
	});
	Object.defineProperty(VictoryAnimation, "contextTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    getTimer: _propTypes.default.func
	  }
	});

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _propTypes2 = _interopRequireDefault(__webpack_require__(128));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Portal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal(props) {
	    var _this;
	
	    _classCallCheck(this, Portal);
	
	    _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));
	    _this.map = {};
	    _this.index = 1;
	    _this.portalUpdate = _this.portalUpdate.bind(_assertThisInitialized(_this));
	    _this.portalRegister = _this.portalRegister.bind(_assertThisInitialized(_this));
	    _this.portalDeregister = _this.portalDeregister.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: "portalRegister",
	    value: function portalRegister() {
	      return ++this.index;
	    }
	  }, {
	    key: "portalUpdate",
	    value: function portalUpdate(key, element) {
	      this.map[key] = element;
	      this.forceUpdate();
	    }
	  }, {
	    key: "portalDeregister",
	    value: function portalDeregister(key) {
	      delete this.map[key];
	      this.forceUpdate();
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren() {
	      var _this2 = this;
	
	      return Object.keys(this.map).map(function (key) {
	        var el = _this2.map[key];
	        return el ? _react.default.cloneElement(el, {
	          key: key
	        }) : el;
	      });
	    } // Overridden in victory-core-native
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react.default.createElement("svg", this.props, this.getChildren());
	    }
	  }]);
	
	  return Portal;
	}(_react.default.Component);
	
	exports.default = Portal;
	Object.defineProperty(Portal, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "Portal"
	});
	Object.defineProperty(Portal, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    className: _propTypes.default.string,
	    height: _propTypes2.default.nonNegative,
	    style: _propTypes.default.object,
	    viewBox: _propTypes.default.string,
	    width: _propTypes2.default.nonNegative
	  }
	});

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _log = _interopRequireDefault(__webpack_require__(212));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VictoryPortal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryPortal, _React$Component);
	
	  function VictoryPortal() {
	    _classCallCheck(this, VictoryPortal);
	
	    return _possibleConstructorReturn(this, (VictoryPortal.__proto__ || Object.getPrototypeOf(VictoryPortal)).apply(this, arguments));
	  }
	
	  _createClass(VictoryPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.checkedContext) {
	        if (typeof this.context.portalUpdate !== "function") {
	          var msg = "`renderInPortal` is not supported outside of `VictoryContainer`. " + "Component will be rendered in place";
	
	          _log.default.warn(msg);
	
	          this.renderInPlace = true;
	        }
	
	        this.checkedContext = true;
	      }
	
	      this.forceUpdate();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (!this.renderInPlace) {
	        this.portalKey = this.portalKey || this.context.portalRegister();
	        this.context.portalUpdate(this.portalKey, this.element);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.context && this.context.portalDeregister) {
	        this.context.portalDeregister(this.portalKey);
	      }
	    } // Overridden in victory-core-native
	
	  }, {
	    key: "renderPortal",
	    value: function renderPortal(child) {
	      if (this.renderInPlace) {
	        return child;
	      }
	
	      this.element = child;
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children;
	      var groupComponent = this.props.groupComponent;
	      var childProps = children && children.props || {};
	      var standardProps = childProps.groupComponent ? {
	        groupComponent: groupComponent,
	        standalone: false
	      } : {};
	      var newProps = (0, _defaults2.default)(standardProps, childProps, _helpers.default.omit(this.props, ["children", "groupComponent"]));
	
	      var child = children && _react.default.cloneElement(children, newProps);
	
	      return this.renderPortal(child);
	    }
	  }]);
	
	  return VictoryPortal;
	}(_react.default.Component);
	
	exports.default = VictoryPortal;
	Object.defineProperty(VictoryPortal, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryPortal"
	});
	Object.defineProperty(VictoryPortal, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "portal"
	});
	Object.defineProperty(VictoryPortal, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    children: _propTypes.default.node,
	    groupComponent: _propTypes.default.element
	  }
	});
	Object.defineProperty(VictoryPortal, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    groupComponent: _react.default.createElement("g", null)
	  }
	});
	Object.defineProperty(VictoryPortal, "contextTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    portalDeregister: _propTypes.default.func,
	    portalRegister: _propTypes.default.func,
	    portalUpdate: _propTypes.default.func
	  }
	});

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	var Circle = function (props) {
	  // eslint-disable-next-line react/prop-types
	  var desc = props.desc,
	      rest = _objectWithoutProperties(props, ["desc"]);
	
	  return desc ? _react.default.createElement("circle", _extends({
	    vectorEffect: "non-scaling-stroke"
	  }, rest), _react.default.createElement("desc", null, desc)) : _react.default.createElement("circle", _extends({
	    vectorEffect: "non-scaling-stroke"
	  }, rest));
	};
	
	var _default = Circle;
	exports.default = _default;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClipPath = function (props) {
	  return _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
	    id: props.clipId
	  }, props.children));
	};
	
	ClipPath.propTypes = {
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  clipId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	};
	var _default = ClipPath;
	exports.default = _default;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	var Text = function (props) {
	  var children = props.children,
	      title = props.title,
	      desc = props.desc,
	      rest = _objectWithoutProperties(props, ["children", "title", "desc"]);
	
	  return _react.default.createElement("text", rest, title && _react.default.createElement("title", null, title), desc && _react.default.createElement("desc", null, desc), children);
	};
	
	Text.propTypes = {
	  children: _propTypes.default.node,
	  desc: _propTypes.default.string,
	  title: _propTypes.default.string
	};
	var _default = Text;
	exports.default = _default;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TSpan = function (props) {
	  return _react.default.createElement("tspan", props);
	};
	
	var _default = TSpan;
	exports.default = _default;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(47));
	
	var _pick2 = _interopRequireDefault(__webpack_require__(152));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryAnimation = _interopRequireDefault(__webpack_require__(670));
	
	var _collection = _interopRequireDefault(__webpack_require__(89));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _timer = _interopRequireDefault(__webpack_require__(214));
	
	var _transitions = _interopRequireDefault(__webpack_require__(304));
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var VictoryTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryTransition, _React$Component);
	
	  function VictoryTransition(props) {
	    var _this;
	
	    _classCallCheck(this, VictoryTransition);
	
	    _this = _possibleConstructorReturn(this, (VictoryTransition.__proto__ || Object.getPrototypeOf(VictoryTransition)).call(this, props));
	    _this.state = {
	      nodesShouldLoad: false,
	      nodesDoneLoad: false
	    };
	    var child = _this.props.children;
	    var polar = child.props.polar;
	    _this.continuous = !polar && child.type && child.type.continuous === true;
	    _this.getTransitionState = _this.getTransitionState.bind(_assertThisInitialized(_this));
	    _this.getTimer = _this.getTimer.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(VictoryTransition, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        nodesShouldLoad: true
	      }); //eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      if (!(0, _reactFastCompare.default)(this.props, nextProps)) {
	        this.getTimer().bypassAnimation();
	        this.setState(this.getTransitionState(this.props, nextProps), function () {
	          return _this2.getTimer().resumeAnimation();
	        });
	      }
	
	      return true;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.getTimer().stop();
	    }
	  }, {
	    key: "getTimer",
	    value: function getTimer() {
	      if (this.context.getTimer) {
	        return this.context.getTimer();
	      }
	
	      if (!this.timer) {
	        this.timer = new _timer.default();
	      }
	
	      return this.timer;
	    }
	  }, {
	    key: "getTransitionState",
	    value: function getTransitionState(props, nextProps) {
	      var animate = props.animate;
	
	      if (!animate) {
	        return {};
	      } else if (animate.parentState) {
	        var state = animate.parentState;
	        var oldProps = state.nodesWillExit ? props : null;
	        return {
	          oldProps: oldProps,
	          nextProps: nextProps
	        };
	      } else {
	        var oldChildren = _react.default.Children.toArray(props.children);
	
	        var nextChildren = _react.default.Children.toArray(nextProps.children);
	
	        var _Transitions$getIniti = _transitions.default.getInitialTransitionState(oldChildren, nextChildren),
	            nodesWillExit = _Transitions$getIniti.nodesWillExit,
	            nodesWillEnter = _Transitions$getIniti.nodesWillEnter,
	            childrenTransitions = _Transitions$getIniti.childrenTransitions,
	            nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;
	
	        return {
	          nodesWillExit: nodesWillExit,
	          nodesWillEnter: nodesWillEnter,
	          childrenTransitions: childrenTransitions,
	          nodesShouldEnter: nodesShouldEnter,
	          oldProps: nodesWillExit ? props : null,
	          nextProps: nextProps
	        };
	      }
	    }
	  }, {
	    key: "getDomainFromChildren",
	    value: function getDomainFromChildren(props, axis) {
	      var getChildDomains = function (children) {
	        return children.reduce(function (memo, child) {
	          if (child.type && (0, _isFunction2.default)(child.type.getDomain)) {
	            var childDomain = child.props && child.type.getDomain(child.props, axis);
	            return childDomain ? memo.concat(childDomain) : memo;
	          } else if (child.props && child.props.children) {
	            return memo.concat(getChildDomains(_react.default.Children.toArray(child.props.children)));
	          }
	
	          return memo;
	        }, []);
	      };
	
	      var child = _react.default.Children.toArray(props.children)[0];
	
	      var childProps = child.props || {};
	      var domain = Array.isArray(childProps.domain) ? childProps.domain : childProps.domain && childProps.domain[axis];
	
	      if (!childProps.children && domain) {
	        return domain;
	      } else {
	        var childDomains = getChildDomains([child]);
	        return childDomains.length === 0 ? [0, 1] : [_collection.default.getMinValue(childDomains), _collection.default.getMaxValue(childDomains)];
	      }
	    }
	  }, {
	    key: "pickProps",
	    value: function pickProps() {
	      if (!this.state) {
	        return this.props;
	      }
	
	      return this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
	    }
	  }, {
	    key: "pickDomainProps",
	    value: function pickDomainProps(props) {
	      var parentState = (0, _isObject2.default)(props.animate) && props.animate.parentState;
	
	      if (parentState && parentState.nodesWillExit) {
	        return this.continous || parentState.continuous ? parentState.nextProps || this.state.nextProps || props : props;
	      }
	
	      return this.continuous && this.state.nodesWillExit ? this.state.nextProps || props : props;
	    }
	  }, {
	    key: "getClipWidth",
	    value: function getClipWidth(props, child) {
	      var getDefaultClipWidth = function () {
	        var range = _helpers.default.getRange(child.props, "x");
	
	        return range ? Math.abs(range[1] - range[0]) : props.width;
	      };
	
	      var clipWidth = this.transitionProps ? this.transitionProps.clipWidth : undefined;
	      return clipWidth !== undefined ? clipWidth : getDefaultClipWidth();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var props = this.pickProps();
	      var getTransitionProps = (0, _isObject2.default)(this.props.animate) && this.props.animate.getTransitions ? this.props.animate.getTransitions : _transitions.default.getTransitionPropsFactory(props, this.state, function (newState) {
	        return _this3.setState(newState);
	      });
	
	      var child = _react.default.Children.toArray(props.children)[0];
	
	      var transitionProps = getTransitionProps(child);
	      this.transitionProps = transitionProps;
	      var domain = {
	        x: this.getDomainFromChildren(this.pickDomainProps(props), "x"),
	        y: this.getDomainFromChildren(props, "y")
	      };
	      var clipWidth = this.getClipWidth(props, child);
	      var combinedProps = (0, _defaults2.default)({
	        domain: domain,
	        clipWidth: clipWidth
	      }, transitionProps, child.props);
	      var animationWhitelist = props.animationWhitelist || [];
	      var whitelist = animationWhitelist.concat(["clipWidth"]);
	      var propsToAnimate = whitelist.length ? (0, _pick2.default)(combinedProps, whitelist) : combinedProps;
	      return _react.default.createElement(_victoryAnimation.default, _extends({}, combinedProps.animate, {
	        data: propsToAnimate
	      }), function (newProps) {
	        if (child.props.groupComponent) {
	          var groupComponent = _this3.continuous ? _react.default.cloneElement(child.props.groupComponent, {
	            clipWidth: newProps.clipWidth || 0
	          }) : child.props.groupComponent;
	          return _react.default.cloneElement(child, (0, _defaults2.default)({
	            animate: null,
	            animating: true,
	            groupComponent: groupComponent
	          }, newProps, combinedProps));
	        }
	
	        return _react.default.cloneElement(child, (0, _defaults2.default)({
	          animate: null,
	          animating: true
	        }, newProps, combinedProps));
	      });
	    }
	  }]);
	
	  return VictoryTransition;
	}(_react.default.Component);
	
	exports.default = VictoryTransition;
	Object.defineProperty(VictoryTransition, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryTransition"
	});
	Object.defineProperty(VictoryTransition, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    animate: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	    animationWhitelist: _propTypes.default.array,
	    children: _propTypes.default.node
	  }
	});

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _without2 = _interopRequireDefault(__webpack_require__(194));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(83));
	
	var _values2 = _interopRequireDefault(__webpack_require__(193));
	
	var _orderBy2 = _interopRequireDefault(__webpack_require__(119));
	
	var _range2 = _interopRequireDefault(__webpack_require__(192));
	
	var _uniq2 = _interopRequireDefault(__webpack_require__(99));
	
	var _invert2 = _interopRequireDefault(__webpack_require__(1369));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(47));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _identity2 = _interopRequireDefault(__webpack_require__(76));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _collection = _interopRequireDefault(__webpack_require__(89));
	
	var _domain = _interopRequireDefault(__webpack_require__(301));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	/**
	 * Returns the axis (x or y) of a particular axis component
	 * @param {Object} props: the props object.
	 * @param {Boolean} horizontal: true for horizontal charts
	 * @returns {String} the dimension appropriate for the axis given its props
	 */
	function getAxis(props) {
	  var dependentAxis = props.dependentAxis;
	  return dependentAxis ? "y" : "x";
	}
	/**
	 * Returns all axis components that pass a given predicate
	 * @param {Array} childComponents: an array of children
	 * @param {Function} predicate: a predicate function that will be called with each
	 * @returns {Array} all axis components that pass the given predicate or []
	 */
	
	
	function findAxisComponents(childComponents, predicate) {
	  predicate = predicate || _identity2.default;
	
	  var findAxes = function (children) {
	    return children.reduce(function (memo, child) {
	      if (child.type && child.type.role === "axis" && predicate(child)) {
	        return memo.concat(child);
	      } else if (child.props && child.props.children) {
	        return memo.concat(findAxes(_react.default.Children.toArray(child.props.children)));
	      }
	
	      return memo;
	    }, []);
	  };
	
	  return findAxes(childComponents);
	}
	/**
	 * Returns a single axis component of the desired axis type (x or y)
	 * @param {Array} childComponents: an array of children
	 * @param {String} axis: desired axis either "x" or "y".
	 * @returns {ReactComponent} an axis component of the desired axis or undefined
	 */
	
	
	function getAxisComponent(childComponents, axis) {
	  var matchesAxis = function (component) {
	    var type = component.type.getAxis(component.props);
	    return type === axis;
	  };
	
	  return findAxisComponents(childComponents, matchesAxis)[0];
	}
	/**
	 * Returns all axis components of the desired axis type (x or y) along with any
	 * parent components excluding VictoryChart
	 * @param {Array} childComponents: an optional array of children.
	 * @param {String} type: desired axis either "dependent" or "independent".
	 * @returns {ReactComponent} an axis component of the desired type or undefined
	 */
	
	
	function getAxisComponentsWithParent(childComponents, type) {
	  var matchesType = function (child) {
	    return type === "dependent" ? child.props.dependentAxis : !child.props.dependentAxis;
	  };
	
	  var findComponents = function (children) {
	    return children.reduce(function (memo, child) {
	      if (child.type && child.type.role === "axis" && matchesType(child)) {
	        return memo.concat(child);
	      } else if (child.props && child.props.children) {
	        var childAxis = findComponents(_react.default.Children.toArray(child.props.children));
	        return childAxis.length > 0 ? memo.concat(child) : memo;
	      }
	
	      return memo;
	    }, []);
	  };
	
	  return findComponents(childComponents);
	}
	
	function getOrigin(domain) {
	  var getSingleOrigin = function (d) {
	    var domainMin = Math.min.apply(Math, _toConsumableArray(d));
	    var domainMax = Math.max.apply(Math, _toConsumableArray(d));
	    return domainMax < 0 ? domainMax : Math.max(0, domainMin);
	  };
	
	  return {
	    x: _collection.default.containsDates(domain.x) ? new Date(Math.min.apply(Math, _toConsumableArray(domain.x))) : getSingleOrigin(domain.x),
	    y: _collection.default.containsDates(domain.y) ? new Date(Math.min.apply(Math, _toConsumableArray(domain.y))) : getSingleOrigin(domain.y)
	  };
	}
	
	function getOriginSign(origin, domain) {
	  var getSign = function () {
	    return origin <= 0 && Math.max.apply(Math, _toConsumableArray(domain)) <= 0 ? "negative" : "positive";
	  };
	
	  return _collection.default.containsDates(domain) ? "positive" : getSign();
	}
	/**
	 * @param {Object} props: axis component props
	 * @returns {Boolean} true when the axis is vertical
	 */
	
	
	function isVertical(props) {
	  var orientation = props.orientation || (props.dependentAxis ? "left" : "bottom");
	  var vertical = {
	    top: false,
	    bottom: false,
	    left: true,
	    right: true
	  };
	  return vertical[orientation];
	}
	/**
	 * @param {Object} props: axis component props
	 * @returns {Boolean} true when tickValues contain strings
	 */
	
	
	function stringTicks(props) {
	  return props.tickValues !== undefined && _collection.default.containsStrings(props.tickValues);
	}
	
	function getDefaultTickFormat(props) {
	  var tickValues = props.tickValues;
	  var axis = getAxis(props);
	  var stringMap = props.stringMap && props.stringMap[axis];
	  var fallbackFormat = tickValues && !_collection.default.containsDates(tickValues) ? function (x) {
	    return x;
	  } : undefined;
	
	  if (!stringMap) {
	    return stringTicks(props) ? function (x, index) {
	      return tickValues[index];
	    } : fallbackFormat;
	  } else {
	    var invertedStringMap = stringMap && (0, _invert2.default)(stringMap);
	    var tickValueArray = (0, _orderBy2.default)((0, _values2.default)(stringMap), function (n) {
	      return n;
	    });
	    var dataNames = tickValueArray.map(function (tick) {
	      return invertedStringMap[tick];
	    }); // string ticks should have one tick of padding at the beginning
	
	    var dataTicks = [""].concat(_toConsumableArray(dataNames), [""]);
	    return function (x) {
	      return dataTicks[x];
	    };
	  }
	}
	
	function getTickFormat(props, scale) {
	  var tickFormat = props.tickFormat;
	  var axis = getAxis(props);
	  var stringMap = props.stringMap && props.stringMap[axis];
	
	  if (!tickFormat) {
	    var defaultTickFormat = getDefaultTickFormat(props);
	    var scaleTickFormat = scale.tickFormat && (0, _isFunction2.default)(scale.tickFormat) ? scale.tickFormat() : function (x) {
	      return x;
	    };
	    return defaultTickFormat || scaleTickFormat;
	  } else if (tickFormat && Array.isArray(tickFormat)) {
	    return function (x, index) {
	      return tickFormat[index];
	    };
	  } else if (tickFormat && (0, _isFunction2.default)(tickFormat)) {
	    var applyStringTicks = function (tick, index, ticks) {
	      var invertedStringMap = (0, _invert2.default)(stringMap);
	      var stringTickArray = ticks.map(function (t) {
	        return invertedStringMap[t];
	      });
	      return props.tickFormat(invertedStringMap[tick], index, stringTickArray);
	    };
	
	    return stringMap ? applyStringTicks : tickFormat;
	  } else {
	    return function (x) {
	      return x;
	    };
	  }
	}
	
	function getStringTicks(props) {
	  var axis = getAxis(props);
	  var stringMap = props.stringMap && props.stringMap[axis];
	  var categories = Array.isArray(props.categories) ? props.categories : props.categories && props.categories[axis];
	  var ticksFromCategories = categories && _collection.default.containsOnlyStrings(categories) ? categories.map(function (tick) {
	    return stringMap[tick];
	  }) : undefined;
	  var ticksFromStringMap = stringMap && (0, _values2.default)(stringMap);
	  return ticksFromCategories && ticksFromCategories.length !== 0 ? ticksFromCategories : ticksFromStringMap;
	}
	
	function getTickArray(props) {
	  var tickValues = props.tickValues,
	      tickFormat = props.tickFormat;
	  var axis = getAxis(props);
	  var stringMap = props.stringMap && props.stringMap[axis];
	
	  var getTicksFromFormat = function () {
	    if (!tickFormat || !Array.isArray(tickFormat)) {
	      return undefined;
	    }
	
	    return _collection.default.containsStrings(tickFormat) ? tickFormat.map(function (t, i) {
	      return i;
	    }) : tickFormat;
	  };
	
	  var ticks = tickValues;
	
	  if (stringMap) {
	    ticks = getStringTicks(props);
	  }
	
	  if (tickValues && _collection.default.containsStrings(tickValues)) {
	    ticks = stringMap ? tickValues.map(function (tick) {
	      return stringMap[tick];
	    }) : (0, _range2.default)(1, tickValues.length + 1);
	  }
	
	  var tickArray = ticks ? (0, _uniq2.default)(ticks) : getTicksFromFormat(props);
	
	  var filterArray = function (arr) {
	    var domain = props.domain && props.domain[axis] || props.domain;
	    return Array.isArray(domain) ? arr.filter(function (t) {
	      return t >= Math.min.apply(Math, _toConsumableArray(domain)) && t <= Math.max.apply(Math, _toConsumableArray(domain));
	    }) : arr;
	  };
	
	  return Array.isArray(tickArray) && tickArray.length ? filterArray(tickArray) : undefined;
	}
	
	function downsampleTicks(ticks, tickCount) {
	  if (!tickCount || !Array.isArray(ticks) || ticks.length <= tickCount) {
	    return ticks;
	  }
	
	  var k = Math.floor(ticks.length / tickCount);
	  return ticks.filter(function (d, i) {
	    return i % k === 0;
	  });
	}
	
	function getTicks(props, scale, filterZero) {
	  var tickCount = props.tickCount;
	  var tickValues = getTickArray(props);
	
	  if (tickValues) {
	    return downsampleTicks(tickValues, tickCount);
	  } else if (scale.ticks && (0, _isFunction2.default)(scale.ticks)) {
	    // eslint-disable-next-line no-magic-numbers
	    var defaultTickCount = tickCount || 5;
	    var scaleTicks = scale.ticks(defaultTickCount);
	    var tickArray = Array.isArray(scaleTicks) && scaleTicks.length ? scaleTicks : scale.domain();
	    var ticks = downsampleTicks(tickArray, tickCount);
	
	    if (filterZero) {
	      var filteredTicks = (0, _includes2.default)(ticks, 0) ? (0, _without2.default)(ticks, 0) : ticks;
	      return filteredTicks.length ? filteredTicks : ticks;
	    }
	
	    return ticks;
	  }
	
	  return scale.domain();
	}
	/**
	 * Returns a domain based tickValues
	 * @param {Object} props: the props object
	 * @param {String} axis: either x or y
	 * @returns {Array} returns a domain from tickValues
	 */
	//eslint-disable-next-line max-statements
	
	
	function getDomainFromData(props, axis) {
	  var polar = props.polar,
	      _props$startAngle = props.startAngle,
	      startAngle = _props$startAngle === void 0 ? 0 : _props$startAngle,
	      _props$endAngle = props.endAngle,
	      endAngle = _props$endAngle === void 0 ? 360 : _props$endAngle;
	  var tickValues = getTickArray(props);
	
	  if (!Array.isArray(tickValues)) {
	    return undefined;
	  }
	
	  var minDomain = _domain.default.getMinFromProps(props, axis);
	
	  var maxDomain = _domain.default.getMaxFromProps(props, axis);
	
	  var tickStrings = stringTicks(props);
	  var ticks = tickValues.map(function (value) {
	    return +value;
	  });
	  var defaultMin = tickStrings ? 1 : _collection.default.getMinValue(ticks);
	  var defaultMax = tickStrings ? tickValues.length : _collection.default.getMaxValue(ticks);
	  var min = minDomain !== undefined ? minDomain : defaultMin;
	  var max = maxDomain !== undefined ? maxDomain : defaultMax;
	
	  var initialDomain = _domain.default.getDomainFromMinMax(min, max);
	
	  var domain = polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? _domain.default.getSymmetricDomain(initialDomain, ticks) : initialDomain;
	
	  if (isVertical(props) && !polar) {
	    domain.reverse();
	  }
	
	  return domain;
	} // exposed for use by VictoryChart
	
	
	function getDomain(props, axis) {
	  var inherentAxis = getAxis(props);
	
	  if (axis && axis !== inherentAxis) {
	    return undefined;
	  }
	
	  return _domain.default.createDomainFunction(getDomainFromData)(props, inherentAxis);
	}
	
	function getAxisValue(props, axis) {
	  if (!props.axisValue) {
	    return undefined;
	  }
	
	  var scaleAxis = axis === "x" ? "y" : "x";
	  var scale = (0, _isObject2.default)(props.scale) && (0, _isFunction2.default)(props.scale[scaleAxis]) ? props.scale[scaleAxis] : undefined;
	
	  if (!scale) {
	    return undefined;
	  }
	
	  var stringMapAxis = axis === "x" ? "y" : "x";
	  var stringMap = (0, _isObject2.default)(props.stringMap) && props.stringMap[stringMapAxis];
	  var axisValue = stringMap && typeof props.axisValue === "string" ? stringMap[props.axisValue] : props.axisValue;
	  return scale(axisValue);
	}
	
	function modifyProps(props, fallbackProps) {
	  if (!(0, _isObject2.default)(props.theme)) {
	    return _helpers.default.modifyProps(props, fallbackProps, "axis");
	  }
	
	  var role = "axis";
	
	  if (props.dependentAxis && props.theme.dependentAxis) {
	    role = "dependentAxis";
	  } else if (!props.dependentAxis && props.theme.independentAxis) {
	    role = "independentAxis";
	  }
	
	  if (role === "axis") {
	    return _helpers.default.modifyProps(props, fallbackProps, "axis");
	  }
	
	  var axisTheme = (0, _defaults2.default)({}, props.theme[role], props.theme.axis);
	  var theme = (0, _assign2.default)({}, props.theme, {
	    axis: axisTheme
	  });
	  return _helpers.default.modifyProps((0, _assign2.default)({}, props, {
	    theme: theme
	  }), fallbackProps, "axis");
	}
	
	var _default = {
	  getTicks: getTicks,
	  getTickFormat: getTickFormat,
	  getAxis: getAxis,
	  getAxisComponent: getAxisComponent,
	  getAxisComponentsWithParent: getAxisComponentsWithParent,
	  getAxisValue: getAxisValue,
	  findAxisComponents: findAxisComponents,
	  getOrigin: getOrigin,
	  getOriginSign: getOriginSign,
	  getDomain: getDomain,
	  isVertical: isVertical,
	  modifyProps: modifyProps,
	  stringTicks: stringTicks
	};
	exports.default = _default;

/***/ },
/* 679 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = {
	  IMMUTABLE_ITERABLE: "@@__IMMUTABLE_ITERABLE__@@",
	  IMMUTABLE_RECORD: "@@__IMMUTABLE_RECORD__@@",
	  IMMUTABLE_LIST: "@@__IMMUTABLE_LIST__@@",
	  IMMUTABLE_MAP: "@@__IMMUTABLE_MAP__@@",
	  isImmutable: function (x) {
	    return this.isIterable(x) || this.isRecord(x);
	  },
	  isIterable: function (x) {
	    return !!(x && x[this.IMMUTABLE_ITERABLE]);
	  },
	  isRecord: function (x) {
	    return !!(x && x[this.IMMUTABLE_RECORD]);
	  },
	  isList: function (x) {
	    return !!(x && x[this.IMMUTABLE_LIST]);
	  },
	  isMap: function (x) {
	    return !!(x && x[this.IMMUTABLE_MAP]);
	  },
	  shallowToJS: function (x, whitelist) {
	    var _this = this;
	
	    return this.isIterable(x) ? x.reduce(function (prev, curr, key) {
	      if (whitelist && whitelist[key]) {
	        curr = _this.shallowToJS(curr);
	      }
	
	      prev[key] = curr;
	      return prev;
	    }, this.isList(x) ? [] : {}) : x;
	  }
	};
	exports.default = _default;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable func-style */
	
	/* eslint-disable no-use-before-define */
	// Private Functions
	function getVerticalAnchor(props, datum) {
	  datum = datum || {};
	  var sign = datum._y >= 0 ? 1 : -1;
	  var labelStyle = props.style && props.style.labels || {};
	
	  if (datum.verticalAnchor || labelStyle.verticalAnchor) {
	    return datum.verticalAnchor || labelStyle.verticalAnchor;
	  } else if (!props.horizontal) {
	    return sign >= 0 ? "end" : "start";
	  } else {
	    return "middle";
	  }
	}
	
	function getTextAnchor(props, datum) {
	  datum = datum || {};
	  var style = props.style,
	      horizontal = props.horizontal;
	  var sign = datum._y >= 0 ? 1 : -1;
	  var labelStyle = style && style.labels || {};
	
	  if (datum.verticalAnchor || labelStyle.verticalAnchor) {
	    return datum.verticalAnchor || labelStyle.verticalAnchor;
	  } else if (!horizontal) {
	    return "middle";
	  } else {
	    return sign >= 0 ? "start" : "end";
	  }
	}
	
	function getAngle(props, datum) {
	  datum = datum || {};
	  var labelStyle = props.style && props.style.labels || {};
	  return datum.angle === undefined ? labelStyle.angle : datum.angle;
	}
	
	function getPadding(props, datum) {
	  datum = datum || {};
	  var horizontal = props.horizontal,
	      style = props.style;
	  var labelStyle = style.labels || {};
	  var defaultPadding = _helpers.default.evaluateProp(labelStyle.padding, props) || 0;
	  var sign = datum._y < 0 ? -1 : 1;
	  return {
	    x: horizontal ? sign * defaultPadding : 0,
	    y: horizontal ? 0 : -1 * sign * defaultPadding
	  };
	}
	
	function getOffset(props, datum) {
	  if (props.polar) {
	    return {};
	  }
	
	  var padding = getPadding(props, datum);
	  return {
	    dx: padding.x,
	    dy: padding.y
	  };
	}
	
	function getPosition(props, datum) {
	  var polar = props.polar;
	
	  var _Helpers$scalePoint = _helpers.default.scalePoint(props, datum),
	      x = _Helpers$scalePoint.x,
	      y = _Helpers$scalePoint.y;
	
	  if (!polar) {
	    return {
	      x: x,
	      y: y
	    };
	  } else {
	    var polarPadding = getPolarPadding(props, datum);
	    return {
	      x: x + polarPadding.x,
	      y: y + polarPadding.y
	    };
	  }
	}
	
	function getPolarPadding(props, datum) {
	  var style = props.style;
	  var degrees = getDegrees(props, datum);
	  var labelStyle = style.labels || {};
	  var padding = _helpers.default.evaluateProp(labelStyle.padding, props) || 0;
	
	  var angle = _helpers.default.degreesToRadians(degrees);
	
	  return {
	    x: padding * Math.cos(angle),
	    y: -padding * Math.sin(angle)
	  };
	}
	
	function getLabelPlacement(props) {
	  var labelComponent = props.labelComponent,
	      labelPlacement = props.labelPlacement,
	      polar = props.polar;
	  var defaultLabelPlacement = polar ? "perpendicular" : "vertical";
	  return labelPlacement ? labelPlacement : labelComponent.props && labelComponent.props.labelPlacement || defaultLabelPlacement;
	}
	
	function getPolarOrientation(degrees) {
	  // eslint-disable-next-line no-magic-numbers
	  if (degrees < 45 || degrees > 315) {
	    return "right"; // eslint-disable-next-line no-magic-numbers
	  } else if (degrees >= 45 && degrees <= 135) {
	    return "top"; // eslint-disable-next-line no-magic-numbers
	  } else if (degrees > 135 && degrees < 225) {
	    return "left";
	  } else {
	    return "bottom";
	  }
	} // Exported Functions
	
	
	function getText(props, datum, index) {
	  datum = datum || {};
	
	  if (datum.label !== undefined) {
	    return datum.label;
	  }
	
	  return Array.isArray(props.labels) ? props.labels[index] : props.labels;
	}
	
	function getPolarTextAnchor(props, degrees) {
	  var labelPlacement = getLabelPlacement(props);
	
	  if (labelPlacement === "perpendicular" || labelPlacement === "vertical" && (degrees === 90 || degrees === 270)) {
	    return "middle";
	  }
	
	  return degrees <= 90 || degrees > 270 ? "start" : "end";
	}
	
	function getPolarVerticalAnchor(props, degrees) {
	  var labelPlacement = getLabelPlacement(props);
	  var orientation = getPolarOrientation(degrees);
	
	  if (labelPlacement === "parallel" || orientation === "left" || orientation === "right") {
	    return "middle";
	  }
	
	  return orientation === "top" ? "end" : "start";
	}
	
	function getPolarAngle(props, baseAngle) {
	  var labelPlacement = props.labelPlacement,
	      datum = props.datum;
	
	  if (!labelPlacement || labelPlacement === "vertical") {
	    return 0;
	  }
	
	  var degrees = baseAngle !== undefined ? baseAngle : getDegrees(props, datum);
	  var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
	  var angle;
	
	  if (degrees === 0 || degrees === 180) {
	    angle = 90;
	  } else if (degrees > 0 && degrees < 180) {
	    angle = 90 - degrees;
	  } else if (degrees > 180 && degrees < 360) {
	    angle = 270 - degrees;
	  }
	
	  var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
	  return angle + sign * labelRotation;
	}
	
	function getDegrees(props, datum) {
	  var _Helpers$getPoint = _helpers.default.getPoint(datum),
	      x = _Helpers$getPoint.x;
	
	  return _helpers.default.radiansToDegrees(props.scale.x(x));
	}
	
	function getProps(props, index) {
	  var scale = props.scale,
	      data = props.data,
	      style = props.style,
	      horizontal = props.horizontal,
	      polar = props.polar,
	      width = props.width,
	      height = props.height;
	  var datum = data[index];
	  var degrees = getDegrees(props, datum);
	  var textAnchor = polar ? getPolarTextAnchor(props, degrees) : getTextAnchor(props, datum);
	  var verticalAnchor = polar ? getPolarVerticalAnchor(props, degrees) : getVerticalAnchor(props, datum);
	  var angle = getAngle(props, datum);
	  var text = getText(props, datum, index);
	  var labelPlacement = getLabelPlacement(props);
	
	  var _getPosition = getPosition(props, datum),
	      x = _getPosition.x,
	      y = _getPosition.y;
	
	  var _getOffset = getOffset(props, datum),
	      dx = _getOffset.dx,
	      dy = _getOffset.dy;
	
	  return {
	    angle: angle,
	    data: data,
	    datum: datum,
	    horizontal: horizontal,
	    index: index,
	    polar: polar,
	    scale: scale,
	    labelPlacement: labelPlacement,
	    text: text,
	    textAnchor: textAnchor,
	    verticalAnchor: verticalAnchor,
	    x: x,
	    y: y,
	    dx: dx,
	    dy: dy,
	    width: width,
	    height: height,
	    style: style.labels
	  };
	}
	
	var _default = {
	  getText: getText,
	  getPolarTextAnchor: getPolarTextAnchor,
	  getPolarVerticalAnchor: getPolarVerticalAnchor,
	  getPolarAngle: getPolarAngle,
	  getDegrees: getDegrees,
	  getProps: getProps
	};
	exports.default = _default;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _mapValues4 = _interopRequireDefault(__webpack_require__(447));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(153));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CursorHelpers = {
	  getDimension: function (props) {
	    var horizontal = props.horizontal,
	        cursorDimension = props.cursorDimension;
	
	    if (!horizontal || !cursorDimension) {
	      return cursorDimension;
	    }
	
	    return cursorDimension === "x" ? "y" : "x";
	  },
	  withinBounds: function (point, bounds) {
	    var _mapValues2 = (0, _mapValues4.default)(bounds, Number),
	        x1 = _mapValues2.x1,
	        x2 = _mapValues2.x2,
	        y1 = _mapValues2.y1,
	        y2 = _mapValues2.y2;
	
	    var _mapValues3 = (0, _mapValues4.default)(point, Number),
	        x = _mapValues3.x,
	        y = _mapValues3.y;
	
	    return x >= Math.min(x1, x2) && x <= Math.max(x1, x2) && y >= Math.min(y1, y2) && y <= Math.max(y1, y2);
	  },
	  onMouseMove: function (evt, targetProps) {
	    var onCursorChange = targetProps.onCursorChange,
	        domain = targetProps.domain;
	    var cursorDimension = this.getDimension(targetProps);
	
	    var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	    var cursorSVGPosition = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG);
	
	    var cursorValue = _victoryCore.Selection.getDataCoordinates(targetProps, targetProps.scale, cursorSVGPosition.x, cursorSVGPosition.y);
	
	    var inBounds = this.withinBounds(cursorValue, {
	      x1: domain.x[0],
	      x2: domain.x[1],
	      y1: domain.y[0],
	      y2: domain.y[1]
	    });
	
	    if (!inBounds) {
	      cursorValue = null;
	    }
	
	    if ((0, _isFunction2.default)(onCursorChange)) {
	      if (inBounds) {
	        var value = cursorDimension ? cursorValue[cursorDimension] : cursorValue;
	        onCursorChange(value, targetProps);
	      } else if (cursorValue !== targetProps.cursorValue) {
	        onCursorChange(targetProps.defaultCursorValue || null, targetProps);
	      }
	    }
	
	    return [{
	      target: "parent",
	      eventKey: "parent",
	      mutation: function () {
	        return {
	          cursorValue: cursorValue,
	          parentSVG: parentSVG
	        };
	      }
	    }];
	  },
	  onTouchEnd: function (evt, targetProps) {
	    var onCursorChange = targetProps.onCursorChange;
	
	    if ((0, _isFunction2.default)(targetProps.onCursorChange)) {
	      onCursorChange(null, targetProps);
	    }
	
	    return [{
	      target: "parent",
	      eventKey: "parent",
	      mutation: function () {
	        return {
	          cursorValue: null
	        };
	      }
	    }];
	  }
	};
	
	var _default = _objectSpread({}, CursorHelpers, {
	  onMouseMove: (0, _throttle2.default)(CursorHelpers.onMouseMove.bind(CursorHelpers), 32, // eslint-disable-line no-magic-numbers
	  {
	    leading: true,
	    trailing: false
	  }),
	  onTouchEnd: CursorHelpers.onTouchEnd.bind(CursorHelpers)
	});
	
	exports.default = _default;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "cursorContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryCursorContainer.cursorContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryCursorContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryCursorContainer.default;
	  }
	});
	Object.defineProperty(exports, "CursorHelpers", {
	  enumerable: true,
	  get: function () {
	    return _cursorHelpers.default;
	  }
	});
	
	var _victoryCursorContainer = _interopRequireWildcard(__webpack_require__(1879));
	
	var _cursorHelpers = _interopRequireDefault(__webpack_require__(681));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var renderBorder = function (props, error, type) {
	  var vertical = type === "right" || type === "left";
	  return _react.default.cloneElement(props.lineComponent, _objectSpread({}, props.events, {
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    className: props.className,
	    style: props.style,
	    transform: props.transform,
	    key: "".concat(props.id, "-border-").concat(type),
	    x1: vertical ? error[type] : props.x - props.borderWidth,
	    x2: vertical ? error[type] : props.x + props.borderWidth,
	    y1: vertical ? props.y - props.borderWidth : error[type],
	    y2: vertical ? props.y + props.borderWidth : error[type]
	  }));
	};
	
	var renderCross = function (props, error, type) {
	  var vertical = type === "top" || type === "bottom";
	  return _react.default.cloneElement(props.lineComponent, _objectSpread({}, props.events, {
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    className: props.className,
	    style: props.style,
	    transform: props.transform,
	    key: "".concat(props.id, "-cross-").concat(type),
	    x1: props.x,
	    x2: vertical ? props.x : error[type],
	    y1: props.y,
	    y2: vertical ? error[type] : props.y
	  }));
	};
	
	var calculateError = function (props) {
	  var errorX = props.errorX,
	      errorY = props.errorY;
	  var settings = {
	    right: {
	      error: errorX,
	      errorIndex: 0
	    },
	    left: {
	      error: errorX,
	      errorIndex: 1
	    },
	    top: {
	      error: errorY,
	      errorIndex: 1
	    },
	    bottom: {
	      error: errorY,
	      errorIndex: 0
	    }
	  };
	
	  var getError = function (direction) {
	    var _settings$direction = settings[direction],
	        error = _settings$direction.error,
	        errorIndex = _settings$direction.errorIndex;
	    return error ? error[errorIndex] : undefined;
	  };
	
	  var result = ["right", "left", "top", "bottom"].reduce(function (memo, dir) {
	    memo[dir] = getError(dir);
	    return memo;
	  }, {});
	  return result;
	};
	
	var ErrorBar = function (props) {
	  var style = _victoryCore.Helpers.evaluateStyle((0, _assign2.default)({
	    stroke: "black"
	  }, props.style), props);
	
	  props = (0, _assign2.default)({}, props, {
	    style: style
	  });
	  var error = calculateError(props);
	  var children = [error.right ? renderBorder(props, error, "right") : null, error.left ? renderBorder(props, error, "left") : null, error.bottom ? renderBorder(props, error, "bottom") : null, error.top ? renderBorder(props, error, "top") : null, error.right ? renderCross(props, error, "right") : null, error.left ? renderCross(props, error, "left") : null, error.bottom ? renderCross(props, error, "bottom") : null, error.top ? renderCross(props, error, "top") : null].filter(Boolean);
	  return _react.default.cloneElement(props.groupComponent, {}, children);
	};
	
	ErrorBar.propTypes = _objectSpread({}, _victoryCore.CommonProps.primitiveProps, {
	  borderWidth: _propTypes.default.number,
	  datum: _propTypes.default.object,
	  errorX: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array, _propTypes.default.bool]),
	  errorY: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array, _propTypes.default.bool]),
	  groupComponent: _propTypes.default.element,
	  lineComponent: _propTypes.default.element,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number
	});
	ErrorBar.defaultProps = {
	  groupComponent: _react.default.createElement("g", null),
	  lineComponent: _react.default.createElement(_victoryCore.Line, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = ErrorBar;
	exports.default = _default;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var d3Shape = _interopRequireWildcard(__webpack_require__(147));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defined = function (d) {
	  var y = d._y1 !== undefined ? d._y1 : d._y;
	  return y !== null && y !== undefined && d._y0 !== null;
	};
	
	var getXAccessor = function (scale) {
	  return function (d) {
	    return scale.x(d._x1 !== undefined ? d._x1 : d._x);
	  };
	};
	
	var getYAccessor = function (scale) {
	  return function (d) {
	    return scale.y(d._y1 !== undefined ? d._y1 : d._y);
	  };
	};
	
	var getAngleAccessor = function (scale) {
	  return function (d) {
	    var x = scale.x(d._x1 !== undefined ? d._x1 : d._x);
	    return -1 * x + Math.PI / 2;
	  };
	};
	
	var toNewName = function (interpolation) {
	  // d3 shape changed the naming scheme for interpolators from "basis" -> "curveBasis" etc.
	  var capitalize = function (s) {
	    return s && s[0].toUpperCase() + s.slice(1);
	  };
	
	  return "curve".concat(capitalize(interpolation));
	};
	
	var getLineFunction = function (props) {
	  var polar = props.polar,
	      scale = props.scale,
	      horizontal = props.horizontal;
	  var defaultOpenCurve = polar ? false : true;
	  var openCurve = props.openCurve === undefined ? defaultOpenCurve : props.openCurve;
	  var interpolationFunction = typeof props.interpolation === "function" && props.interpolation;
	  var interpolationName = typeof props.interpolation === "string" && (!openCurve ? "".concat(toNewName(props.interpolation), "Closed") : toNewName(props.interpolation));
	  return polar ? d3Shape.lineRadial().defined(defined).curve(interpolationFunction || d3Shape[interpolationName]).angle(getAngleAccessor(scale)).radius(getYAccessor(scale)) : d3Shape.line().defined(defined).curve(interpolationFunction || d3Shape[interpolationName]).x(horizontal ? getYAccessor(scale) : getXAccessor(scale)).y(horizontal ? getXAccessor(scale) : getYAccessor(scale));
	};
	
	var Curve = function (props) {
	  var polar = props.polar,
	      origin = props.origin;
	  var lineFunction = getLineFunction(props);
	  var defaultTransform = polar && origin ? "translate(".concat(origin.x, ", ").concat(origin.y, ")") : undefined;
	  return _react.default.cloneElement(props.pathComponent, _objectSpread({}, props.events, {
	    d: lineFunction(props.data),
	    style: _victoryCore.Helpers.evaluateStyle((0, _assign2.default)({
	      fill: "none",
	      stroke: "black"
	    }, props.style), props),
	    transform: props.transform || defaultTransform,
	    className: props.className,
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    clipPath: props.clipPath
	  }));
	};
	
	Curve.propTypes = _objectSpread({}, _victoryCore.CommonProps.primitiveProps, {
	  interpolation: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  openCurve: _propTypes.default.bool,
	  origin: _propTypes.default.object,
	  pathComponent: _propTypes.default.element,
	  polar: _propTypes.default.bool
	});
	Curve.defaultProps = {
	  pathComponent: _react.default.createElement(_victoryCore.Path, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Curve;
	exports.default = _default;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	var d3Shape = _interopRequireWildcard(__webpack_require__(147));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getPath = function (props) {
	  var slice = props.slice,
	      radius = props.radius,
	      innerRadius = props.innerRadius;
	
	  if ((0, _isFunction2.default)(props.pathFunction)) {
	    return props.pathFunction(slice);
	  }
	
	  var cornerRadius = _victoryCore.Helpers.evaluateProp(props.cornerRadius, props);
	
	  var padAngle = _victoryCore.Helpers.degreesToRadians(_victoryCore.Helpers.evaluateProp(props.padAngle, props));
	
	  var startAngle = _victoryCore.Helpers.degreesToRadians(_victoryCore.Helpers.evaluateProp(props.sliceStartAngle, props));
	
	  var endAngle = _victoryCore.Helpers.degreesToRadians(_victoryCore.Helpers.evaluateProp(props.sliceEndAngle, props));
	
	  var pathFunction = d3Shape.arc().cornerRadius(cornerRadius).outerRadius(radius).innerRadius(innerRadius);
	  return pathFunction((0, _defaults2.default)({
	    startAngle: startAngle,
	    endAngle: endAngle,
	    padAngle: padAngle
	  }, slice));
	};
	
	var evaluateProps = function (props) {
	  /* Potential evaluated props are
	    1) style
	    2) radius
	    3) innerRadius
	    4) everything else
	  */
	  var style = _victoryCore.Helpers.evaluateStyle(props.style, props);
	
	  var radius = _victoryCore.Helpers.evaluateProp(props.radius, (0, _assign2.default)({}, props, {
	    style: style
	  }));
	
	  var innerRadius = _victoryCore.Helpers.evaluateProp(props.innerRadius, (0, _assign2.default)({}, props, {
	    style: style,
	    radius: radius
	  }));
	
	  return (0, _assign2.default)({}, props, {
	    style: style,
	    radius: radius,
	    innerRadius: innerRadius
	  });
	};
	
	var Slice = function (props) {
	  props = evaluateProps(props);
	  var defaultTransform = props.origin ? "translate(".concat(props.origin.x, ", ").concat(props.origin.y, ")") : undefined;
	  return _react.default.cloneElement(props.pathComponent, _objectSpread({}, props.events, {
	    d: getPath(props),
	    style: props.style,
	    transform: props.transform || defaultTransform,
	    className: props.className,
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    clipPath: props.clipPath
	  }));
	};
	
	Slice.propTypes = _objectSpread({}, _victoryCore.CommonProps.primitiveProps, {
	  cornerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  datum: _propTypes.default.object,
	  innerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  padAngle: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  pathComponent: _propTypes.default.element,
	  pathFunction: _propTypes.default.func,
	  radius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  slice: _propTypes.default.object,
	  sliceEndAngle: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  sliceStartAngle: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func])
	});
	Slice.defaultProps = {
	  pathComponent: _react.default.createElement(_victoryCore.Path, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Slice;
	exports.default = _default;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryPolarAxis", {
	  enumerable: true,
	  get: function () {
	    return _victoryPolarAxis.default;
	  }
	});
	
	var _victoryPolarAxis = _interopRequireDefault(__webpack_require__(1896));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "selectionContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victorySelectionContainer.selectionContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictorySelectionContainer", {
	  enumerable: true,
	  get: function () {
	    return _victorySelectionContainer.default;
	  }
	});
	Object.defineProperty(exports, "SelectionHelpers", {
	  enumerable: true,
	  get: function () {
	    return _selectionHelpers.default;
	  }
	});
	
	var _victorySelectionContainer = _interopRequireWildcard(__webpack_require__(1900));
	
	var _selectionHelpers = _interopRequireDefault(__webpack_require__(688));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _includes2 = _interopRequireDefault(__webpack_require__(83));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(153));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var SelectionHelpers = {
	  getDimension: function (props) {
	    var horizontal = props.horizontal,
	        selectionDimension = props.selectionDimension;
	
	    if (!horizontal || !selectionDimension) {
	      return selectionDimension;
	    }
	
	    return selectionDimension === "x" ? "y" : "x";
	  },
	  getDatasets: function (props) {
	    if (props.data) {
	      return [{
	        data: props.data
	      }];
	    }
	
	    var getData = function (childProps) {
	      var data = _victoryCore.Data.getData(childProps);
	
	      return Array.isArray(data) && data.length > 0 ? data : undefined;
	    };
	
	    var iteratee = function (child, childName, parent) {
	      var blacklist = props.selectionBlacklist || [];
	
	      if (!_victoryCore.Data.isDataComponent(child) || (0, _includes2.default)(blacklist, childName)) {
	        return null;
	      } else if (child.type && (0, _isFunction2.default)(child.type.getData)) {
	        child = parent ? _react.default.cloneElement(child, parent.props) : child;
	        var childData = child.props && child.type.getData(child.props);
	        return childData ? {
	          childName: childName,
	          data: childData
	        } : null;
	      } else {
	        var _childData = getData(child.props);
	
	        return _childData ? {
	          childName: childName,
	          data: _childData
	        } : null;
	      }
	    };
	
	    return _victoryCore.Helpers.reduceChildren(_react.default.Children.toArray(props.children), iteratee, props);
	  },
	  filterDatasets: function (props, datasets, bounds) {
	    var _this = this;
	
	    var filtered = datasets.reduce(function (memo, dataset) {
	      var selectedData = _this.getSelectedData(props, dataset.data, bounds);
	
	      memo = selectedData ? memo.concat({
	        childName: dataset.childName,
	        eventKey: selectedData.eventKey,
	        data: selectedData.data
	      }) : memo;
	      return memo;
	    }, []);
	    return filtered.length ? filtered : null;
	  },
	  getSelectedData: function (props, dataset) {
	    var x1 = props.x1,
	        y1 = props.y1,
	        x2 = props.x2,
	        y2 = props.y2;
	
	    var withinBounds = function (d) {
	      var scaledPoint = _victoryCore.Helpers.scalePoint(props, d);
	
	      return scaledPoint.x >= Math.min(x1, x2) && scaledPoint.x <= Math.max(x1, x2) && scaledPoint.y >= Math.min(y1, y2) && scaledPoint.y <= Math.max(y1, y2);
	    };
	
	    var eventKey = [];
	    var data = [];
	    var count = 0;
	
	    for (var index = 0, len = dataset.length; index < len; index++) {
	      var datum = dataset[index];
	
	      if (withinBounds(datum)) {
	        data[count] = datum;
	        eventKey[count] = datum.eventKey === undefined ? index : datum.eventKey;
	        count++;
	      }
	    }
	
	    return count > 0 ? {
	      eventKey: eventKey,
	      data: data
	    } : null;
	  },
	  // eslint-disable-next-line complexity, max-statements
	  onMouseDown: function (evt, targetProps) {
	    evt.preventDefault();
	    var activateSelectedData = targetProps.activateSelectedData,
	        allowSelection = targetProps.allowSelection,
	        polar = targetProps.polar,
	        selectedData = targetProps.selectedData;
	
	    if (!allowSelection) {
	      return {};
	    }
	
	    var dimension = this.getDimension(targetProps);
	
	    var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	    var _Selection$getSVGEven = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG),
	        x = _Selection$getSVGEven.x,
	        y = _Selection$getSVGEven.y;
	
	    var x1 = polar || dimension !== "y" ? x : _victoryCore.Selection.getDomainCoordinates(targetProps).x[0];
	    var y1 = polar || dimension !== "x" ? y : _victoryCore.Selection.getDomainCoordinates(targetProps).y[0];
	    var x2 = polar || dimension !== "y" ? x : _victoryCore.Selection.getDomainCoordinates(targetProps).x[1];
	    var y2 = polar || dimension !== "x" ? y : _victoryCore.Selection.getDomainCoordinates(targetProps).y[1];
	    var mutatedProps = {
	      x1: x1,
	      y1: y1,
	      select: true,
	      x2: x2,
	      y2: y2,
	      parentSVG: parentSVG
	    };
	
	    if (selectedData && (0, _isFunction2.default)(targetProps.onSelectionCleared)) {
	      targetProps.onSelectionCleared((0, _defaults2.default)({}, mutatedProps, targetProps));
	    }
	
	    var parentMutation = [{
	      target: "parent",
	      mutation: function () {
	        return mutatedProps;
	      }
	    }];
	    var dataMutation = selectedData && activateSelectedData ? selectedData.map(function (d) {
	      return {
	        childName: d.childName,
	        eventKey: d.eventKey,
	        target: "data",
	        mutation: function () {
	          return null;
	        }
	      };
	    }) : [];
	    return parentMutation.concat.apply(parentMutation, _toConsumableArray(dataMutation));
	  },
	  onMouseMove: function (evt, targetProps) {
	    var allowSelection = targetProps.allowSelection,
	        select = targetProps.select,
	        polar = targetProps.polar;
	    var dimension = this.getDimension(targetProps);
	
	    if (!allowSelection || !select) {
	      return null;
	    } else {
	      var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	      var _Selection$getSVGEven2 = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG),
	          x = _Selection$getSVGEven2.x,
	          y = _Selection$getSVGEven2.y;
	
	      var x2 = polar || dimension !== "y" ? x : _victoryCore.Selection.getDomainCoordinates(targetProps).x[1];
	      var y2 = polar || dimension !== "x" ? y : _victoryCore.Selection.getDomainCoordinates(targetProps).y[1];
	      return {
	        target: "parent",
	        mutation: function () {
	          return {
	            x2: x2,
	            y2: y2,
	            parentSVG: parentSVG
	          };
	        }
	      };
	    }
	  },
	  onMouseUp: function (evt, targetProps) {
	    var activateSelectedData = targetProps.activateSelectedData,
	        allowSelection = targetProps.allowSelection,
	        x2 = targetProps.x2,
	        y2 = targetProps.y2;
	
	    if (!allowSelection) {
	      return null;
	    }
	
	    if (!x2 || !y2) {
	      return [{
	        target: "parent",
	        mutation: function () {
	          return {
	            select: false,
	            x1: null,
	            x2: null,
	            y1: null,
	            y2: null
	          };
	        }
	      }];
	    }
	
	    var datasets = this.getDatasets(targetProps);
	
	    var bounds = _victoryCore.Selection.getBounds(targetProps);
	
	    var selectedData = this.filterDatasets(targetProps, datasets, bounds);
	    var mutatedProps = {
	      selectedData: selectedData,
	      datasets: datasets,
	      select: false,
	      x1: null,
	      x2: null,
	      y1: null,
	      y2: null
	    };
	    var callbackMutation = selectedData && (0, _isFunction2.default)(targetProps.onSelection) ? targetProps.onSelection(selectedData, bounds, (0, _defaults2.default)({}, mutatedProps, targetProps)) : {};
	    var parentMutation = [{
	      target: "parent",
	      mutation: function () {
	        return mutatedProps;
	      }
	    }];
	    var dataMutation = selectedData && activateSelectedData ? selectedData.map(function (d) {
	      return {
	        childName: d.childName,
	        eventKey: d.eventKey,
	        target: "data",
	        mutation: function () {
	          return (0, _assign2.default)({
	            active: true
	          }, callbackMutation);
	        }
	      };
	    }) : [];
	    return parentMutation.concat(dataMutation);
	  }
	};
	
	var _default = _objectSpread({}, SelectionHelpers, {
	  onMouseDown: SelectionHelpers.onMouseDown.bind(SelectionHelpers),
	  onMouseUp: SelectionHelpers.onMouseUp.bind(SelectionHelpers),
	  onMouseMove: (0, _throttle2.default)(SelectionHelpers.onMouseMove.bind(SelectionHelpers), 16, // eslint-disable-line no-magic-numbers
	  {
	    leading: true,
	    trailing: false
	  })
	});
	
	exports.default = _default;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getVerticalPath = function (props) {
	  var pointerWidth = props.pointerWidth,
	      cornerRadius = props.cornerRadius,
	      orientation = props.orientation,
	      width = props.width,
	      height = props.height,
	      center = props.center;
	  var sign = orientation === "bottom" ? 1 : -1;
	  var x = props.x + (props.dx || 0);
	  var y = props.y + (props.dy || 0);
	  var centerX = (0, _isPlainObject2.default)(center) && center.x;
	  var centerY = (0, _isPlainObject2.default)(center) && center.y;
	  var pointerEdge = centerY + sign * (height / 2);
	  var oppositeEdge = centerY - sign * (height / 2);
	  var rightEdge = centerX + width / 2;
	  var leftEdge = centerX - width / 2;
	  var pointerLength = sign * (y - pointerEdge) < 0 ? 0 : props.pointerLength;
	  var direction = orientation === "bottom" ? "0 0 0" : "0 0 1";
	  var arc = "".concat(cornerRadius, " ").concat(cornerRadius, " ").concat(direction);
	  return "M ".concat(centerX - pointerWidth / 2, ", ").concat(pointerEdge, "\n    L ").concat(pointerLength ? x : centerX + pointerWidth / 2, ", ").concat(pointerLength ? y : pointerEdge, "\n    L ").concat(centerX + pointerWidth / 2, ", ").concat(pointerEdge, "\n    L ").concat(rightEdge - cornerRadius, ", ").concat(pointerEdge, "\n    A ").concat(arc, " ").concat(rightEdge, ", ").concat(pointerEdge - sign * cornerRadius, "\n    L ").concat(rightEdge, ", ").concat(oppositeEdge + sign * cornerRadius, "\n    A ").concat(arc, " ").concat(rightEdge - cornerRadius, ", ").concat(oppositeEdge, "\n    L ").concat(leftEdge + cornerRadius, ", ").concat(oppositeEdge, "\n    A ").concat(arc, " ").concat(leftEdge, ", ").concat(oppositeEdge + sign * cornerRadius, "\n    L ").concat(leftEdge, ", ").concat(pointerEdge - sign * cornerRadius, "\n    A ").concat(arc, " ").concat(leftEdge + cornerRadius, ", ").concat(pointerEdge, "\n    z");
	};
	
	var getHorizontalPath = function (props) {
	  var pointerWidth = props.pointerWidth,
	      cornerRadius = props.cornerRadius,
	      orientation = props.orientation,
	      width = props.width,
	      height = props.height,
	      center = props.center;
	  var sign = orientation === "left" ? 1 : -1;
	  var x = props.x + (props.dx || 0);
	  var y = props.y + (props.dy || 0);
	  var centerX = (0, _isPlainObject2.default)(center) && center.x;
	  var centerY = (0, _isPlainObject2.default)(center) && center.y;
	  var pointerEdge = centerX - sign * (width / 2);
	  var oppositeEdge = centerX + sign * (width / 2);
	  var bottomEdge = centerY + height / 2;
	  var topEdge = centerY - height / 2;
	  var pointerLength = sign * (x - pointerEdge) > 0 ? 0 : props.pointerLength;
	  var direction = orientation === "left" ? "0 0 0" : "0 0 1";
	  var arc = "".concat(cornerRadius, " ").concat(cornerRadius, " ").concat(direction);
	  return "M ".concat(pointerEdge, ", ").concat(centerY - pointerWidth / 2, "\n    L ").concat(pointerLength ? x : pointerEdge, ", ").concat(pointerLength ? y : centerY + pointerWidth / 2, "\n    L ").concat(pointerEdge, ", ").concat(centerY + pointerWidth / 2, "\n    L ").concat(pointerEdge, ", ").concat(bottomEdge - cornerRadius, "\n    A ").concat(arc, " ").concat(pointerEdge + sign * cornerRadius, ", ").concat(bottomEdge, "\n    L ").concat(oppositeEdge - sign * cornerRadius, ", ").concat(bottomEdge, "\n    A ").concat(arc, " ").concat(oppositeEdge, ", ").concat(bottomEdge - cornerRadius, "\n    L ").concat(oppositeEdge, ", ").concat(topEdge + cornerRadius, "\n    A ").concat(arc, " ").concat(oppositeEdge - sign * cornerRadius, ", ").concat(topEdge, "\n    L ").concat(pointerEdge + sign * cornerRadius, ", ").concat(topEdge, "\n    A ").concat(arc, " ").concat(pointerEdge, ", ").concat(topEdge + cornerRadius, "\n    z");
	};
	
	var getFlyoutPath = function (props) {
	  var orientation = props.orientation || "top";
	  return orientation === "left" || orientation === "right" ? getHorizontalPath(props) : getVerticalPath(props);
	};
	
	var Flyout = function (props) {
	  return _react.default.cloneElement(props.pathComponent, _objectSpread({}, props.events, {
	    style: _victoryCore.Helpers.evaluateStyle(props.style, props),
	    d: getFlyoutPath(props),
	    className: props.className,
	    shapeRendering: props.shapeRendering,
	    role: props.role,
	    transform: props.transform,
	    clipPath: props.clipPath
	  }));
	};
	
	Flyout.propTypes = _objectSpread({}, _victoryCore.CommonProps.primitiveProps, {
	  center: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  cornerRadius: _propTypes.default.number,
	  datum: _propTypes.default.object,
	  dx: _propTypes.default.number,
	  dy: _propTypes.default.number,
	  height: _propTypes.default.number,
	  orientation: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	  pathComponent: _propTypes.default.element,
	  pointerLength: _propTypes.default.number,
	  pointerWidth: _propTypes.default.number,
	  width: _propTypes.default.number,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number
	});
	Flyout.defaultProps = {
	  pathComponent: _react.default.createElement(_victoryCore.Path, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Flyout;
	exports.default = _default;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryTooltip", {
	  enumerable: true,
	  get: function () {
	    return _victoryTooltip.default;
	  }
	});
	Object.defineProperty(exports, "Flyout", {
	  enumerable: true,
	  get: function () {
	    return _flyout.default;
	  }
	});
	
	var _victoryTooltip = _interopRequireDefault(__webpack_require__(1905));
	
	var _flyout = _interopRequireDefault(__webpack_require__(689));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "voronoiContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoiContainer.voronoiContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryVoronoiContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoiContainer.default;
	  }
	});
	Object.defineProperty(exports, "VoronoiHelpers", {
	  enumerable: true,
	  get: function () {
	    return _voronoiHelpers.default;
	  }
	});
	
	var _victoryVoronoiContainer = _interopRequireWildcard(__webpack_require__(1906));
	
	var _voronoiHelpers = _interopRequireDefault(__webpack_require__(692));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isRegExp2 = _interopRequireDefault(__webpack_require__(443));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(444));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(83));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(153));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	var _index = _interopRequireDefault(__webpack_require__(1228));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var VoronoiHelpers = {
	  withinBounds: function (props, point) {
	    var width = props.width,
	        height = props.height,
	        voronoiPadding = props.voronoiPadding,
	        polar = props.polar,
	        origin = props.origin,
	        scale = props.scale;
	    var padding = voronoiPadding || 0;
	    var x = point.x,
	        y = point.y;
	
	    if (polar) {
	      var distanceSquared = Math.pow(x - origin.x, 2) + Math.pow(y - origin.y, 2);
	      var radius = Math.max.apply(Math, _toConsumableArray(scale.y.range()));
	      return distanceSquared < Math.pow(radius, 2);
	    } else {
	      return x >= padding && x <= width - padding && y >= padding && y <= height - padding;
	    }
	  },
	  getDatasets: function (props) {
	    var children = _react.default.Children.toArray(props.children);
	
	    var addMeta = function (data, name, child) {
	      var continuous = child && child.type && child.type.continuous;
	      var style = child ? child.props && child.props.style : props.style;
	      return data.map(function (datum, index) {
	        var _Helpers$getPoint = _victoryCore.Helpers.getPoint(datum),
	            x = _Helpers$getPoint.x,
	            y = _Helpers$getPoint.y,
	            y0 = _Helpers$getPoint.y0,
	            x0 = _Helpers$getPoint.x0;
	
	        var voronoiX = (+x + +x0) / 2;
	        var voronoiY = (+y + +y0) / 2;
	        return (0, _assign2.default)({
	          _voronoiX: props.voronoiDimension === "y" ? 0 : voronoiX,
	          _voronoiY: props.voronoiDimension === "x" ? 0 : voronoiY,
	          eventKey: index,
	          childName: name,
	          continuous: continuous,
	          style: style
	        }, datum);
	      });
	    };
	
	    if (props.data) {
	      return addMeta(props.data);
	    }
	
	    var getData = function (childProps) {
	      var data = _victoryCore.Data.getData(childProps);
	
	      return Array.isArray(data) && data.length > 0 ? data : undefined;
	    };
	
	    var iteratee = function (child, childName) {
	      var childProps = child.props || {};
	      var name = childProps.name || childName;
	      var blacklist = props.voronoiBlacklist || [];
	      var blacklistStr = blacklist.filter(_isString2.default);
	      var blacklistRegExp = blacklist.filter(_isRegExp2.default);
	      var isRegExpMatch = blacklistRegExp.some(function (regExp) {
	        return regExp.test(name);
	      });
	
	      if (!_victoryCore.Data.isDataComponent(child) || (0, _includes2.default)(blacklistStr, name) || isRegExpMatch) {
	        return null;
	      }
	
	      var getChildData = child.type && (0, _isFunction2.default)(child.type.getData) ? child.type.getData : getData;
	      var childData = getChildData(child.props);
	      return childData ? addMeta(childData, name, child) : null;
	    };
	
	    return _victoryCore.Helpers.reduceChildren(children, iteratee, props);
	  },
	  findPoints: function (datasets, point) {
	    return datasets.filter(function (d) {
	      return point._voronoiX === d._voronoiX && point._voronoiY === d._voronoiY;
	    });
	  },
	  withinRadius: function (point, mousePosition, radius) {
	    if (!radius) {
	      return true;
	    }
	
	    var x = mousePosition.x,
	        y = mousePosition.y;
	    var distanceSquared = Math.pow(x - point[0], 2) + Math.pow(y - point[1], 2);
	    return distanceSquared < Math.pow(radius, 2);
	  },
	  getVoronoiPoints: function (props, mousePosition) {
	    var datasets = this.getDatasets(props);
	    var scaledData = datasets.map(function (d) {
	      var _Helpers$scalePoint = _victoryCore.Helpers.scalePoint(props, d),
	          x = _Helpers$scalePoint.x,
	          y = _Helpers$scalePoint.y;
	
	      return [x, y];
	    });
	
	    var delaunay = _index.default.from(scaledData);
	
	    var index = delaunay.find(mousePosition.x, mousePosition.y);
	    var withinRadius = this.withinRadius(scaledData[index], mousePosition, props.radius);
	    var points = withinRadius ? this.findPoints(datasets, datasets[index]) : [];
	    return {
	      points: points,
	      index: index
	    };
	  },
	  getActiveMutations: function (props, point) {
	    var childName = point.childName,
	        continuous = point.continuous;
	    var activateData = props.activateData,
	        activateLabels = props.activateLabels,
	        labels = props.labels;
	
	    if (!activateData && !activateLabels) {
	      return [];
	    }
	
	    var defaultTarget = activateData ? ["data"] : [];
	    var targets = labels && !activateLabels ? defaultTarget : defaultTarget.concat("labels");
	
	    if ((0, _isEmpty2.default)(targets)) {
	      return [];
	    }
	
	    return targets.map(function (target) {
	      var eventKey = continuous === true && target === "data" ? "all" : point.eventKey;
	      return {
	        childName: childName,
	        eventKey: eventKey,
	        target: target,
	        mutation: function () {
	          return {
	            active: true
	          };
	        }
	      };
	    });
	  },
	  getInactiveMutations: function (props, point) {
	    var childName = point.childName,
	        continuous = point.continuous;
	    var activateData = props.activateData,
	        activateLabels = props.activateLabels,
	        labels = props.labels;
	
	    if (!activateData && !activateLabels) {
	      return [];
	    }
	
	    var defaultTarget = activateData ? ["data"] : [];
	    var targets = labels && !activateLabels ? defaultTarget : defaultTarget.concat("labels");
	
	    if ((0, _isEmpty2.default)(targets)) {
	      return [];
	    }
	
	    return targets.map(function (target) {
	      var eventKey = continuous && target === "data" ? "all" : point.eventKey;
	      return {
	        childName: childName,
	        eventKey: eventKey,
	        target: target,
	        mutation: function () {
	          return null;
	        }
	      };
	    });
	  },
	  // eslint-disable-next-line max-params
	  getParentMutation: function (activePoints, mousePosition, parentSVG, vIndex) {
	    return [{
	      target: "parent",
	      eventKey: "parent",
	      mutation: function () {
	        return {
	          activePoints: activePoints,
	          mousePosition: mousePosition,
	          parentSVG: parentSVG,
	          vIndex: vIndex
	        };
	      }
	    }];
	  },
	  onActivated: function (props, points) {
	    if ((0, _isFunction2.default)(props.onActivated)) {
	      props.onActivated(points, props);
	    }
	  },
	  onDeactivated: function (props, points) {
	    if ((0, _isFunction2.default)(props.onDeactivated)) {
	      props.onDeactivated(points, props);
	    }
	  },
	  onMouseLeave: function (evt, targetProps) {
	    var _this = this,
	        _getParentMutation;
	
	    var activePoints = targetProps.activePoints || [];
	    this.onDeactivated(targetProps, activePoints);
	    var inactiveMutations = activePoints.length ? activePoints.map(function (point) {
	      return _this.getInactiveMutations(targetProps, point);
	    }) : [];
	    return (_getParentMutation = this.getParentMutation([])).concat.apply(_getParentMutation, _toConsumableArray(inactiveMutations));
	  },
	  onMouseMove: function (evt, targetProps) {
	    var _this2 = this;
	
	    // eslint-disable-line max-statements
	    var activePoints = targetProps.activePoints || [];
	
	    var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	    var mousePosition = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG);
	
	    if (!this.withinBounds(targetProps, mousePosition)) {
	      var _getParentMutation2;
	
	      this.onDeactivated(targetProps, activePoints);
	      var inactiveMutations = activePoints.length ? activePoints.map(function (point) {
	        return _this2.getInactiveMutations(targetProps, point);
	      }) : [];
	      return (_getParentMutation2 = this.getParentMutation([], mousePosition, parentSVG)).concat.apply(_getParentMutation2, _toConsumableArray(inactiveMutations));
	    }
	
	    var _getVoronoiPoints = this.getVoronoiPoints(targetProps, mousePosition),
	        _getVoronoiPoints$poi = _getVoronoiPoints.points,
	        points = _getVoronoiPoints$poi === void 0 ? [] : _getVoronoiPoints$poi,
	        index = _getVoronoiPoints.index;
	
	    var parentMutations = this.getParentMutation(points, mousePosition, parentSVG, index);
	
	    if (activePoints.length && (0, _reactFastCompare.default)(points, activePoints)) {
	      return parentMutations;
	    } else {
	      this.onActivated(targetProps, points);
	      this.onDeactivated(targetProps, activePoints);
	      var activeMutations = points.length ? points.map(function (point) {
	        return _this2.getActiveMutations(targetProps, point);
	      }) : [];
	
	      var _inactiveMutations = activePoints.length ? activePoints.map(function (point) {
	        return _this2.getInactiveMutations(targetProps, point);
	      }) : [];
	
	      return parentMutations.concat.apply(parentMutations, _toConsumableArray(_inactiveMutations).concat(_toConsumableArray(activeMutations)));
	    }
	  }
	};
	var _default = {
	  onMouseLeave: VoronoiHelpers.onMouseLeave.bind(VoronoiHelpers),
	  onMouseMove: (0, _throttle2.default)(VoronoiHelpers.onMouseMove.bind(VoronoiHelpers), 32, // eslint-disable-line no-magic-numbers
	  {
	    leading: true,
	    trailing: false
	  })
	};
	exports.default = _default;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getVoronoiPath = function (props) {
	  var polygon = props.polygon;
	  return Array.isArray(polygon) && polygon.length ? "M ".concat(props.polygon.join("L"), " Z") : "";
	};
	
	var Voronoi = function (props) {
	  var role = props.role,
	      shapeRendering = props.shapeRendering,
	      className = props.className,
	      events = props.events,
	      transform = props.transform;
	  var voronoiPath = getVoronoiPath(props);
	
	  var style = _victoryCore.Helpers.evaluateStyle(props.style, props);
	
	  var size = _victoryCore.Helpers.evaluateProp(props.size, props);
	
	  var sharedProps = _objectSpread({
	    className: className,
	    role: role,
	    shapeRendering: shapeRendering,
	    style: style,
	    transform: transform
	  }, events);
	
	  if (size) {
	    var circle = _react.default.cloneElement(props.circleComponent, _objectSpread({}, sharedProps, {
	      key: "".concat(props.id, "-circle-clip"),
	      clipPath: "url(#".concat(props.clipId, ")"),
	      cx: props.x,
	      cy: props.y,
	      r: size
	    }));
	
	    var voronoiClipPath = _react.default.cloneElement(props.clipPathComponent, {
	      key: "".concat(props.id, "-voronoi-clip"),
	      clipId: props.clipId
	    }, _react.default.cloneElement(props.pathComponent, {
	      d: voronoiPath,
	      className: className
	    }));
	
	    return _react.default.cloneElement(props.groupComponent, {}, [voronoiClipPath, circle]);
	  }
	
	  return _react.default.cloneElement(props.pathComponent, _objectSpread({}, sharedProps, {
	    d: voronoiPath
	  }));
	};
	
	Voronoi.propTypes = _objectSpread({}, _victoryCore.CommonProps.primitiveProps, {
	  circleComponent: _propTypes.default.element,
	  clipId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  clipPathComponent: _propTypes.default.element,
	  datum: _propTypes.default.object,
	  groupComponent: _propTypes.default.element,
	  pathComponent: _propTypes.default.element,
	  polygon: _propTypes.default.array,
	  size: _propTypes.default.number,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number
	});
	Voronoi.defaultProps = {
	  pathComponent: _react.default.createElement(_victoryCore.Path, null),
	  circleComponent: _react.default.createElement(_victoryCore.Circle, null),
	  clipPathComponent: _react.default.createElement(_victoryCore.ClipPath, null),
	  groupComponent: _react.default.createElement("g", null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Voronoi;
	exports.default = _default;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "zoomContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryZoomContainer.zoomContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryZoomContainer", {
	  enumerable: true,
	  get: function () {
	    return _victoryZoomContainer.default;
	  }
	});
	Object.defineProperty(exports, "ZoomHelpers", {
	  enumerable: true,
	  get: function () {
	    return _zoomHelpers.default;
	  }
	});
	Object.defineProperty(exports, "RawZoomHelpers", {
	  enumerable: true,
	  get: function () {
	    return _zoomHelpers.RawZoomHelpers;
	  }
	});
	
	var _victoryZoomContainer = _interopRequireWildcard(__webpack_require__(1910));
	
	var _zoomHelpers = _interopRequireWildcard(__webpack_require__(695));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RawZoomHelpers = void 0;
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(153));
	
	var _react = __webpack_require__(1);
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var RawZoomHelpers = {
	  checkDomainEquality: function (a, b) {
	    var checkDimension = function (dim) {
	      var val1 = a && a[dim];
	      var val2 = b && b[dim];
	
	      if (!val1 && !val2) {
	        return true;
	      } else if (!val1 || !val2) {
	        return false;
	      }
	
	      return +val1[0] === +val2[0] && +val1[1] === +val2[1];
	    };
	
	    return checkDimension("x") && checkDimension("y");
	  },
	
	  /**
	   * Generates a new domain scaled by factor and constrained by the original domain.
	   * @param  {[Number, Number]} currentDomain  The domain to be scaled.
	   * @param  {Object} evt the event object
	   * @param  {Object} props the props of the targeted component
	   * @param  {String} axis the desired dimension (either x or y)
	   * @return {[Number, Number]}                The scale domain
	   */
	  // eslint-disable-next-line max-params
	  scale: function (currentDomain, evt, props, axis) {
	    var _currentDomain = _slicedToArray(currentDomain, 2),
	        from = _currentDomain[0],
	        to = _currentDomain[1];
	
	    var range = Math.abs(to - from);
	    var minimumZoom = props.minimumZoom && props.minimumZoom[axis];
	    var factor = this.getScaleFactor(evt);
	
	    if (minimumZoom && range <= minimumZoom && factor < 1) {
	      return currentDomain;
	    }
	
	    var _getDomain$axis = _slicedToArray(this.getDomain(props)[axis], 2),
	        fromBound = _getDomain$axis[0],
	        toBound = _getDomain$axis[1];
	
	    var percent = this.getScalePercent(evt, props, axis);
	    var point = factor * from + percent * (factor * range);
	    var minDomain = this.getMinimumDomain(point, props, axis);
	
	    var _getScaledDomain = this.getScaledDomain(currentDomain, factor, percent),
	        _getScaledDomain2 = _slicedToArray(_getScaledDomain, 2),
	        newMin = _getScaledDomain2[0],
	        newMax = _getScaledDomain2[1];
	
	    var newDomain = [newMin > fromBound && newMin < toBound ? newMin : fromBound, newMax < toBound && newMax > fromBound ? newMax : toBound];
	    var domain = Math.abs(minDomain[1] - minDomain[0]) > Math.abs(newDomain[1] - newDomain[0]) ? minDomain : newDomain;
	    return _victoryCore.Collection.containsDates([fromBound, toBound]) ? [new Date(domain[0]), new Date(domain[1])] : domain;
	  },
	  getScaledDomain: function (currentDomain, factor, percent) {
	    var _currentDomain2 = _slicedToArray(currentDomain, 2),
	        from = _currentDomain2[0],
	        to = _currentDomain2[1];
	
	    var range = Math.abs(to - from);
	    var diff = range - range * factor;
	    var newMin = +from + diff * percent;
	    var newMax = +to - diff * (1 - percent);
	    return [Math.min(newMin, newMax), Math.max(newMin, newMax)];
	  },
	  getMinimumDomain: function (point, props, axis) {
	    var minimumZoom = props.minimumZoom;
	    var originalDomain = this.getDomain(props)[axis];
	
	    var _originalDomain = _slicedToArray(originalDomain, 2),
	        from = _originalDomain[0],
	        to = _originalDomain[1];
	
	    var defaultMin = Math.abs(from - to) / 1000;
	    var extent = minimumZoom ? minimumZoom[axis] || defaultMin : defaultMin;
	    var minExtent = point - extent / 2;
	    var maxExtent = point + extent / 2;
	    return [minExtent > from && minExtent < to ? minExtent : from, maxExtent < to && maxExtent > from ? maxExtent : +from + extent / 2];
	  },
	  zoommingOut: function (evt) {
	    return evt.deltaY > 0;
	  },
	  getScaleFactor: function (evt) {
	    var sign = this.zoommingOut(evt) ? 1 : -1; // eslint-disable-next-line no-magic-numbers
	
	    var delta = Math.min(Math.abs(evt.deltaY / 300), 0.5); // TODO: Check scale factor
	
	    return Math.abs(1 + sign * delta);
	  },
	  getScalePercent: function (evt, props, axis) {
	    var originalDomain = this.getDomain(props);
	
	    var _originalDomain$axis = _slicedToArray(originalDomain[axis], 2),
	        from = _originalDomain$axis[0],
	        to = _originalDomain$axis[1];
	
	    var position = this.getPosition(evt, props, originalDomain);
	    return (position[axis] - from) / Math.abs(to - from);
	  },
	  getPosition: function (evt, props, originalDomain) {
	    var _Selection$getSVGEven = _victoryCore.Selection.getSVGEventCoordinates(evt),
	        x = _Selection$getSVGEven.x,
	        y = _Selection$getSVGEven.y;
	
	    var originalScale = {
	      x: props.scale.x.domain(originalDomain.x),
	      y: props.scale.y.domain(originalDomain.y)
	    };
	    return _victoryCore.Selection.getDataCoordinates(props, originalScale, x, y);
	  },
	
	  /**
	   * Generate a new domain translated by the delta and constrained by the original domain.
	   * @param  {[Number, Number]} currentDomain  The domain to be translated.
	   * @param  {[Number, Number]} originalDomain The original domain for the data set.
	   * @param  {Number}           delta          The delta to translate by
	   * @return {[Number, Number]}                The translated domain
	   */
	  pan: function (currentDomain, originalDomain, delta) {
	    var _currentDomain$map = currentDomain.map(function (val) {
	      return +val;
	    }),
	        _currentDomain$map2 = _slicedToArray(_currentDomain$map, 2),
	        fromCurrent = _currentDomain$map2[0],
	        toCurrent = _currentDomain$map2[1];
	
	    var _originalDomain$map = originalDomain.map(function (val) {
	      return +val;
	    }),
	        _originalDomain$map2 = _slicedToArray(_originalDomain$map, 2),
	        fromOriginal = _originalDomain$map2[0],
	        toOriginal = _originalDomain$map2[1];
	
	    var lowerBound = fromCurrent + delta;
	    var upperBound = toCurrent + delta;
	    var newDomain;
	
	    if (lowerBound > fromOriginal && upperBound < toOriginal) {
	      newDomain = [lowerBound, upperBound];
	    } else if (lowerBound < fromOriginal) {
	      // Clamp to lower limit
	      var dx = toCurrent - fromCurrent;
	      newDomain = [fromOriginal, fromOriginal + dx];
	    } else if (upperBound > toOriginal) {
	      // Clamp to upper limit
	      var _dx = toCurrent - fromCurrent;
	
	      newDomain = [toOriginal - _dx, toOriginal];
	    } else {
	      newDomain = currentDomain;
	    }
	
	    return _victoryCore.Collection.containsDates(currentDomain) || _victoryCore.Collection.containsDates(originalDomain) ? newDomain.map(function (val) {
	      return new Date(val);
	    }) : newDomain;
	  },
	  // eslint-disable-next-line max-params
	  getDomainScale: function (domain, scale, axis, horizontal) {
	    var axisDomain = Array.isArray(domain) ? domain : domain[axis];
	
	    var _axisDomain = _slicedToArray(axisDomain, 2),
	        from = _axisDomain[0],
	        to = _axisDomain[1];
	
	    var otherAxis = axis === "x" ? "y" : "x";
	    var range = horizontal ? scale[otherAxis].range() : scale[axis].range();
	    var plottableWidth = Math.abs(range[0] - range[1]);
	    return plottableWidth / (to - from);
	  },
	  handleAnimation: function (ctx) {
	    var getTimer = (0, _isFunction2.default)(ctx.getTimer) && ctx.getTimer.bind(ctx);
	
	    if (getTimer && (0, _isFunction2.default)(getTimer().bypassAnimation)) {
	      getTimer().bypassAnimation();
	      return (0, _isFunction2.default)(getTimer().resumeAnimation) ? function () {
	        return getTimer().resumeAnimation();
	      } : undefined;
	    }
	
	    return undefined;
	  },
	  getLastDomain: function (targetProps, originalDomain) {
	    var zoomDomain = targetProps.zoomDomain,
	        cachedZoomDomain = targetProps.cachedZoomDomain,
	        currentDomain = targetProps.currentDomain,
	        domain = targetProps.domain;
	
	    if (zoomDomain && !this.checkDomainEquality(zoomDomain, cachedZoomDomain)) {
	      return (0, _defaults2.default)({}, zoomDomain, domain);
	    }
	
	    return (0, _defaults2.default)({}, currentDomain || zoomDomain || originalDomain, domain);
	  },
	  getDomain: function (props) {
	    var originalDomain = props.originalDomain,
	        domain = props.domain,
	        children = props.children,
	        zoomDimension = props.zoomDimension;
	
	    var childComponents = _react.Children.toArray(children);
	
	    var childrenDomain = {};
	
	    if (childComponents.length) {
	      childrenDomain = zoomDimension ? _defineProperty({}, zoomDimension, _victoryCore.Wrapper.getDomainFromChildren(props, zoomDimension, childComponents)) : {
	        x: _victoryCore.Wrapper.getDomainFromChildren(props, "x", childComponents),
	        y: _victoryCore.Wrapper.getDomainFromChildren(props, "y", childComponents)
	      };
	    }
	
	    return (0, _defaults2.default)({}, childrenDomain, originalDomain, domain);
	  },
	  onMouseDown: function (evt, targetProps) {
	    evt.preventDefault();
	
	    if (!targetProps.allowPan) {
	      return undefined;
	    }
	
	    var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	    var _Selection$getSVGEven2 = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG),
	        x = _Selection$getSVGEven2.x,
	        y = _Selection$getSVGEven2.y;
	
	    return [{
	      target: "parent",
	      mutation: function () {
	        return {
	          startX: x,
	          startY: y,
	          panning: true,
	          parentSVG: parentSVG,
	          parentControlledProps: ["domain"]
	        };
	      }
	    }];
	  },
	  onMouseUp: function (evt, targetProps) {
	    if (!targetProps.allowPan) {
	      return undefined;
	    }
	
	    return [{
	      target: "parent",
	      mutation: function () {
	        return {
	          panning: false
	        };
	      }
	    }];
	  },
	  onMouseLeave: function (evt, targetProps) {
	    if (!targetProps.allowPan) {
	      return undefined;
	    }
	
	    return [{
	      target: "parent",
	      mutation: function () {
	        return {
	          panning: false
	        };
	      }
	    }];
	  },
	  // eslint-disable-next-line max-params, max-statements
	  onMouseMove: function (evt, targetProps, eventKey, ctx) {
	    if (targetProps.panning && targetProps.allowPan) {
	      var scale = targetProps.scale,
	          startX = targetProps.startX,
	          startY = targetProps.startY,
	          onZoomDomainChange = targetProps.onZoomDomainChange,
	          zoomDomain = targetProps.zoomDomain,
	          zoomDimension = targetProps.zoomDimension,
	          horizontal = targetProps.horizontal;
	
	      var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	      var _Selection$getSVGEven3 = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG),
	          x = _Selection$getSVGEven3.x,
	          y = _Selection$getSVGEven3.y;
	
	      var originalDomain = this.getDomain(targetProps);
	      var lastDomain = this.getLastDomain(targetProps, originalDomain);
	      var deltaX = horizontal ? y - startY : startX - x;
	      var deltaY = horizontal ? startX - x : y - startY;
	      var dx = deltaX / this.getDomainScale(lastDomain, scale, "x", horizontal);
	      var dy = deltaY / this.getDomainScale(lastDomain, scale, "y", horizontal);
	      var currentDomain = {
	        x: zoomDimension === "y" ? originalDomain.x : this.pan(lastDomain.x, originalDomain.x, dx),
	        y: zoomDimension === "x" ? originalDomain.y : this.pan(lastDomain.y, originalDomain.y, dy)
	      };
	      var resumeAnimation = this.handleAnimation(ctx);
	      var zoomActive = !this.checkDomainEquality(originalDomain, lastDomain);
	      var mutatedProps = {
	        parentControlledProps: ["domain"],
	        startX: x,
	        startY: y,
	        parentSVG: parentSVG,
	        domain: currentDomain,
	        currentDomain: currentDomain,
	        originalDomain: originalDomain,
	        cachedZoomDomain: zoomDomain,
	        zoomActive: zoomActive
	      };
	
	      if ((0, _isFunction2.default)(onZoomDomainChange)) {
	        onZoomDomainChange(currentDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	      }
	
	      return [{
	        target: "parent",
	        callback: resumeAnimation,
	        mutation: function () {
	          return mutatedProps;
	        }
	      }];
	    }
	
	    return undefined;
	  },
	  // eslint-disable-next-line max-params
	  onWheel: function (evt, targetProps, eventKey, ctx) {
	    if (!targetProps.allowZoom) {
	      return undefined;
	    }
	
	    var onZoomDomainChange = targetProps.onZoomDomainChange,
	        zoomDimension = targetProps.zoomDimension,
	        zoomDomain = targetProps.zoomDomain;
	    var originalDomain = this.getDomain(targetProps);
	    var lastDomain = this.getLastDomain(targetProps, originalDomain);
	    var x = lastDomain.x,
	        y = lastDomain.y;
	    var currentDomain = {
	      x: zoomDimension === "y" ? lastDomain.x : this.scale(x, evt, targetProps, "x"),
	      y: zoomDimension === "x" ? lastDomain.y : this.scale(y, evt, targetProps, "y")
	    };
	    var resumeAnimation = this.handleAnimation(ctx);
	    var zoomActive = !this.zoommingOut(evt) || // if zoomming in or
	    //   if zoomActive is already set AND user hasn't zoommed out all the way
	    targetProps.zoomActive && !this.checkDomainEquality(originalDomain, lastDomain);
	    var mutatedProps = {
	      domain: currentDomain,
	      currentDomain: currentDomain,
	      originalDomain: originalDomain,
	      cachedZoomDomain: zoomDomain,
	      parentControlledProps: ["domain"],
	      panning: false,
	      zoomActive: zoomActive
	    };
	
	    if ((0, _isFunction2.default)(onZoomDomainChange)) {
	      onZoomDomainChange(currentDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	    }
	
	    return [{
	      target: "parent",
	      callback: resumeAnimation,
	      mutation: function () {
	        return mutatedProps;
	      }
	    }];
	  }
	};
	exports.RawZoomHelpers = RawZoomHelpers;
	// allow victory-native to extend these helpers
	var _default = {
	  checkDomainEquality: RawZoomHelpers.checkDomainEquality.bind(RawZoomHelpers),
	  onMouseDown: RawZoomHelpers.onMouseDown.bind(RawZoomHelpers),
	  onMouseUp: RawZoomHelpers.onMouseUp.bind(RawZoomHelpers),
	  onMouseLeave: RawZoomHelpers.onMouseLeave.bind(RawZoomHelpers),
	  onMouseMove: (0, _throttle2.default)(RawZoomHelpers.onMouseMove.bind(RawZoomHelpers), 16, // eslint-disable-line no-magic-numbers
	  {
	    leading: true,
	    trailing: false
	  }),
	  onWheel: (0, _throttle2.default)(RawZoomHelpers.onWheel.bind(RawZoomHelpers), 16, // eslint-disable-line no-magic-numbers
	  {
	    leading: true,
	    trailing: false
	  })
	};
	exports.default = _default;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(306);
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return arrayLikeToArray(arr);
	}
	
	module.exports = _arrayWithoutHoles;

/***/ },
/* 697 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(702);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ },
/* 699 */
/***/ function(module, exports) {

	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;
	
	  try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	module.exports = _iterableToArrayLimit;

/***/ },
/* 700 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	module.exports = _nonIterableSpread;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(79);
	
	var assertThisInitialized = __webpack_require__(308);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ },
/* 702 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(307);
	
	var iterableToArray = __webpack_require__(309);
	
	var unsupportedIterableToArray = __webpack_require__(217);
	
	var nonIterableRest = __webpack_require__(310);
	
	function _toArray(arr) {
	  return arrayWithHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableRest();
	}
	
	module.exports = _toArray;

/***/ },
/* 704 */
/***/ function(module, exports) {

	'use strict';
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	module.exports = memoize;


/***/ },
/* 705 */
/***/ function(module, exports) {

	'use strict';
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e, m).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        switch (d.constructor) {
	          case Array:
	            for (var c = 0, e = d.length; c < e; ++c) {
	              T(d[c]);
	            }
	
	            break;
	
	          case Function:
	            S[A++] = d;
	            break;
	
	          case Boolean:
	            Y = !!d | 0;
	        }
	
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	module.exports = stylis_min;


/***/ },
/* 706 */
/***/ function(module, exports) {

	'use strict';
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	module.exports = unitlessKeys;


/***/ },
/* 707 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* @generated */
	// prettier-ignore  
	exports.default = { "aa-SAAHO": "ssy", "aam": "aas", "aar": "aa", "abk": "ab", "adp": "dz", "afr": "af", "aju": "jrb", "aka": "ak", "alb": "sq", "als": "sq", "amh": "am", "ara": "ar", "arb": "ar", "arg": "an", "arm": "hy", "art-lojban": "jbo", "asd": "snz", "asm": "as", "aue": "ktz", "ava": "av", "ave": "ae", "aym": "ay", "ayr": "ay", "ayx": "nun", "az-AZ": "az-Latn-AZ", "aze": "az", "azj": "az", "bak": "ba", "bam": "bm", "baq": "eu", "bcc": "bal", "bcl": "bik", "bel": "be", "ben": "bn", "bgm": "bcg", "bh": "bho", "bih": "bho", "bis": "bi", "bjd": "drl", "bod": "bo", "bos": "bs", "bre": "br", "bs-BA": "bs-Latn-BA", "bul": "bg", "bur": "my", "bxk": "luy", "bxr": "bua", "cat": "ca", "ccq": "rki", "cel-gaulish": "xtg-x-cel-gaulish", "ces": "cs", "cha": "ch", "che": "ce", "chi": "zh", "chu": "cu", "chv": "cv", "cjr": "mom", "cka": "cmr", "cld": "syr", "cmk": "xch", "cmn": "zh", "cnr": "sr-ME", "cor": "kw", "cos": "co", "coy": "pij", "cqu": "quh", "cre": "cr", "cwd": "cr", "cym": "cy", "cze": "cs", "dan": "da", "deu": "de", "dgo": "doi", "dhd": "mwr", "dik": "din", "diq": "zza", "dit": "dif", "div": "dv", "drh": "mn", "drw": "fa-af", "dut": "nl", "dzo": "dz", "ekk": "et", "ell": "el", "emk": "man", "eng": "en", "epo": "eo", "esk": "ik", "est": "et", "eus": "eu", "ewe": "ee", "fao": "fo", "fas": "fa", "fat": "ak", "fij": "fj", "fin": "fi", "fra": "fr", "fre": "fr", "fry": "fy", "fuc": "ff", "ful": "ff", "gav": "dev", "gaz": "om", "gbo": "grb", "geo": "ka", "ger": "de", "gfx": "vaj", "ggn": "gvr", "gla": "gd", "gle": "ga", "glg": "gl", "glv": "gv", "gno": "gon", "gre": "el", "grn": "gn", "gti": "nyc", "gug": "gn", "guj": "gu", "guv": "duz", "gya": "gba", "ha-Latn-GH": "ha-GH", "ha-Latn-NE": "ha-NE", "ha-Latn-NG": "ha-NG", "hat": "ht", "hau": "ha", "hbs": "sr-Latn", "hdn": "hai", "hea": "hmn", "heb": "he", "her": "hz", "him": "srx", "hin": "hi", "hmo": "ho", "hrr": "jal", "hrv": "hr", "hun": "hu", "hye": "hy", "i-ami": "ami", "i-bnn": "bnn", "i-hak": "hak", "i-klingon": "tlh", "i-lux": "lb", "i-navajo": "nv", "i-pwn": "pwn", "i-tao": "tao", "i-tay": "tay", "i-tsu": "tsu", "i-default": "en-x-i-default", "i-enochian": "und-x-i-enochian", "i-mingo": "see-x-i-mingo", "ibi": "opa", "ibo": "ig", "ice": "is", "ido": "io", "iii": "ii", "ike": "iu", "iku": "iu", "ile": "ie", "ilw": "gal", "in": "id", "ina": "ia", "ind": "id", "ipk": "ik", "isl": "is", "ita": "it", "iw": "he", "jav": "jv", "jeg": "oyb", "ji": "yi", "jpn": "ja", "jw": "jv", "kal": "kl", "kan": "kn", "kas": "ks", "kat": "ka", "kau": "kr", "kaz": "kk", "kgc": "tdf", "kgh": "kml", "khk": "mn", "khm": "km", "kik": "ki", "kin": "rw", "kir": "ky", "kk-Cyrl-KZ": "kk-KZ", "kmr": "ku", "knc": "kr", "kng": "kg", "knn": "kok", "koj": "kwv", "kom": "kv", "kon": "kg", "kor": "ko", "kpv": "kv", "krm": "bmf", "ks-Arab-IN": "ks-IN", "ktr": "dtp", "kua": "kj", "kur": "ku", "kvs": "gdj", "kwq": "yam", "kxe": "tvd", "ky-Cyrl-KG": "ky-KG", "kzj": "dtp", "kzt": "dtp", "lao": "lo", "lat": "la", "lav": "lv", "lbk": "bnc", "lii": "raq", "lim": "li", "lin": "ln", "lit": "lt", "llo": "ngt", "lmm": "rmx", "ltz": "lb", "lub": "lu", "lug": "lg", "lvs": "lv", "mac": "mk", "mah": "mh", "mal": "ml", "mao": "mi", "mar": "mr", "may": "ms", "meg": "cir", "mhr": "chm", "mkd": "mk", "mlg": "mg", "mlt": "mt", "mn-Cyrl-MN": "mn-MN", "mnk": "man", "mo": "ro", "mol": "ro", "mon": "mn", "mri": "mi", "ms-Latn-BN": "ms-BN", "ms-Latn-MY": "ms-MY", "ms-Latn-SG": "ms-SG", "msa": "ms", "mst": "mry", "mup": "raj", "mwj": "vaj", "mya": "my", "myd": "aog", "myt": "mry", "nad": "xny", "nau": "na", "nav": "nv", "nbl": "nr", "ncp": "kdz", "nde": "nd", "ndo": "ng", "nep": "ne", "nld": "nl", "nno": "nn", "nns": "nbr", "nnx": "ngv", "no": "nb", "no-bok": "nb", "no-BOKMAL": "nb", "no-nyn": "nn", "no-NYNORSK": "nn", "nob": "nb", "nor": "nb", "npi": "ne", "nts": "pij", "nya": "ny", "oci": "oc", "ojg": "oj", "oji": "oj", "ori": "or", "orm": "om", "ory": "or", "oss": "os", "oun": "vaj", "pa-IN": "pa-Guru-IN", "pa-PK": "pa-Arab-PK", "pan": "pa", "pbu": "ps", "pcr": "adx", "per": "fa", "pes": "fa", "pli": "pi", "plt": "mg", "pmc": "huw", "pmu": "phr", "pnb": "lah", "pol": "pl", "por": "pt", "ppa": "bfy", "ppr": "lcq", "prs": "fa-AF", "pry": "prt", "pus": "ps", "puz": "pub", "que": "qu", "quz": "qu", "rmy": "rom", "roh": "rm", "ron": "ro", "rum": "ro", "run": "rn", "rus": "ru", "sag": "sg", "san": "sa", "sca": "hle", "scc": "sr", "scr": "hr", "sgn-BE-FR": "sfb", "sgn-BE-NL": "vgt", "sgn-CH-DE": "sgg", "sh": "sr-Latn", "shi-MA": "shi-Tfng-MA", "sin": "si", "skk": "oyb", "slk": "sk", "slo": "sk", "slv": "sl", "sme": "se", "smo": "sm", "sna": "sn", "snd": "sd", "som": "so", "sot": "st", "spa": "es", "spy": "kln", "sqi": "sq", "sr-BA": "sr-Cyrl-BA", "sr-ME": "sr-Latn-ME", "sr-RS": "sr-Cyrl-RS", "sr-XK": "sr-Cyrl-XK", "src": "sc", "srd": "sc", "srp": "sr", "ssw": "ss", "sun": "su", "swa": "sw", "swc": "sw-CD", "swe": "sv", "swh": "sw", "tah": "ty", "tam": "ta", "tat": "tt", "tdu": "dtp", "tel": "te", "tgk": "tg", "tgl": "fil", "tha": "th", "thc": "tpo", "thx": "oyb", "tib": "bo", "tie": "ras", "tir": "ti", "tkk": "twm", "tl": "fil", "tlw": "weo", "tmp": "tyj", "tne": "kak", "tnf": "fa-af", "ton": "to", "tsf": "taj", "tsn": "tn", "tso": "ts", "ttq": "tmh", "tuk": "tk", "tur": "tr", "tw": "ak", "twi": "ak", "tzm-Latn-MA": "tzm-MA", "ug-Arab-CN": "ug-CN", "uig": "ug", "ukr": "uk", "umu": "del", "uok": "ema", "urd": "ur", "uz-AF": "uz-Arab-AF", "uz-UZ": "uz-Latn-UZ", "uzb": "uz", "uzn": "uz", "vai-LR": "vai-Vaii-LR", "ven": "ve", "vie": "vi", "vol": "vo", "wel": "cy", "wln": "wa", "wol": "wo", "xba": "cax", "xho": "xh", "xia": "acn", "xkh": "waw", "xpe": "kpe", "xsj": "suj", "xsl": "den", "ybd": "rki", "ydd": "yi", "yid": "yi", "yma": "lrr", "ymt": "mtm", "yor": "yo", "yos": "zom", "yue-CN": "yue-Hans-CN", "yue-HK": "yue-Hant-HK", "yuu": "yug", "zai": "zap", "zh-CN": "zh-Hans-CN", "zh-guoyu": "zh", "zh-hakka": "hak", "zh-HK": "zh-Hant-HK", "zh-min-nan": "nan", "zh-MO": "zh-Hant-MO", "zh-SG": "zh-Hans-SG", "zh-TW": "zh-Hant-TW", "zh-xiang": "hsn", "zh-min": "nan-x-zh-min", "zha": "za", "zho": "zh", "zsm": "ms", "zul": "zu", "zyb": "za" };
	//# sourceMappingURL=aliases.js.map

/***/ },
/* 708 */
/***/ function(module, exports) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var MS_PER_SECOND = 1e3;
	var SECS_PER_MIN = 60;
	var SECS_PER_HOUR = SECS_PER_MIN * 60;
	var SECS_PER_DAY = SECS_PER_HOUR * 24;
	var SECS_PER_WEEK = SECS_PER_DAY * 7;
	function selectUnit(from, to, thresholds) {
	    if (to === void 0) { to = Date.now(); }
	    if (thresholds === void 0) { thresholds = {}; }
	    var resolvedThresholds = __assign(__assign({}, exports.DEFAULT_THRESHOLDS), (thresholds || {}));
	    var secs = (+from - +to) / MS_PER_SECOND;
	    if (Math.abs(secs) < resolvedThresholds.second) {
	        return {
	            value: Math.round(secs),
	            unit: 'second',
	        };
	    }
	    var mins = secs / SECS_PER_MIN;
	    if (Math.abs(mins) < resolvedThresholds.minute) {
	        return {
	            value: Math.round(mins),
	            unit: 'minute',
	        };
	    }
	    var hours = secs / SECS_PER_HOUR;
	    if (Math.abs(hours) < resolvedThresholds.hour) {
	        return {
	            value: Math.round(hours),
	            unit: 'hour',
	        };
	    }
	    var days = secs / SECS_PER_DAY;
	    if (Math.abs(days) < resolvedThresholds.day) {
	        return {
	            value: Math.round(days),
	            unit: 'day',
	        };
	    }
	    var fromDate = new Date(from);
	    var toDate = new Date(to);
	    var years = fromDate.getFullYear() - toDate.getFullYear();
	    if (Math.round(Math.abs(years)) > 0) {
	        return {
	            value: Math.round(years),
	            unit: 'year',
	        };
	    }
	    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
	    if (Math.round(Math.abs(months)) > 0) {
	        return {
	            value: Math.round(months),
	            unit: 'month',
	        };
	    }
	    var weeks = secs / SECS_PER_WEEK;
	    return {
	        value: Math.round(weeks),
	        unit: 'week',
	    };
	}
	exports.selectUnit = selectUnit;
	exports.DEFAULT_THRESHOLDS = {
	    second: 45,
	    minute: 45,
	    hour: 22,
	    day: 5,
	};
	//# sourceMappingURL=diff.js.map

/***/ },
/* 709 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var InternalSlotToken;
	(function (InternalSlotToken) {
	    // To prevent collision with {0} in CLDR
	    InternalSlotToken["compactName"] = "compactName";
	    InternalSlotToken["compactSymbol"] = "compactSymbol";
	    InternalSlotToken["currencyCode"] = "currencyCode";
	    InternalSlotToken["currencyName"] = "currencyName";
	    InternalSlotToken["currencyNarrowSymbol"] = "currencyNarrowSymbol";
	    InternalSlotToken["currencySymbol"] = "currencySymbol";
	    InternalSlotToken["minusSign"] = "minusSign";
	    InternalSlotToken["number"] = "number";
	    InternalSlotToken["percentSign"] = "percentSign";
	    InternalSlotToken["plusSign"] = "plusSign";
	    InternalSlotToken["scientificExponent"] = "scientificExponent";
	    InternalSlotToken["scientificSeparator"] = "scientificSeparator";
	    InternalSlotToken["unitName"] = "unitName";
	    InternalSlotToken["unitNarrowSymbol"] = "unitNarrowSymbol";
	    InternalSlotToken["unitSymbol"] = "unitSymbol";
	})(InternalSlotToken = exports.InternalSlotToken || (exports.InternalSlotToken = {}));
	//# sourceMappingURL=number-types.js.map

/***/ },
/* 710 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* @generated */
	// prettier-ignore  
	exports.default = { "en-150": "en-001", "en-AG": "en-001", "en-AI": "en-001", "en-AU": "en-001", "en-BB": "en-001", "en-BM": "en-001", "en-BS": "en-001", "en-BW": "en-001", "en-BZ": "en-001", "en-CA": "en-001", "en-CC": "en-001", "en-CK": "en-001", "en-CM": "en-001", "en-CX": "en-001", "en-CY": "en-001", "en-DG": "en-001", "en-DM": "en-001", "en-ER": "en-001", "en-FJ": "en-001", "en-FK": "en-001", "en-FM": "en-001", "en-GB": "en-001", "en-GD": "en-001", "en-GG": "en-001", "en-GH": "en-001", "en-GI": "en-001", "en-GM": "en-001", "en-GY": "en-001", "en-HK": "en-001", "en-IE": "en-001", "en-IL": "en-001", "en-IM": "en-001", "en-IN": "en-001", "en-IO": "en-001", "en-JE": "en-001", "en-JM": "en-001", "en-KE": "en-001", "en-KI": "en-001", "en-KN": "en-001", "en-KY": "en-001", "en-LC": "en-001", "en-LR": "en-001", "en-LS": "en-001", "en-MG": "en-001", "en-MO": "en-001", "en-MS": "en-001", "en-MT": "en-001", "en-MU": "en-001", "en-MW": "en-001", "en-MY": "en-001", "en-NA": "en-001", "en-NF": "en-001", "en-NG": "en-001", "en-NR": "en-001", "en-NU": "en-001", "en-NZ": "en-001", "en-PG": "en-001", "en-PH": "en-001", "en-PK": "en-001", "en-PN": "en-001", "en-PW": "en-001", "en-RW": "en-001", "en-SB": "en-001", "en-SC": "en-001", "en-SD": "en-001", "en-SG": "en-001", "en-SH": "en-001", "en-SL": "en-001", "en-SS": "en-001", "en-SX": "en-001", "en-SZ": "en-001", "en-TC": "en-001", "en-TK": "en-001", "en-TO": "en-001", "en-TT": "en-001", "en-TV": "en-001", "en-TZ": "en-001", "en-UG": "en-001", "en-VC": "en-001", "en-VG": "en-001", "en-VU": "en-001", "en-WS": "en-001", "en-ZA": "en-001", "en-ZM": "en-001", "en-ZW": "en-001", "en-AT": "en-150", "en-BE": "en-150", "en-CH": "en-150", "en-DE": "en-150", "en-DK": "en-150", "en-FI": "en-150", "en-NL": "en-150", "en-SE": "en-150", "en-SI": "en-150", "es-AR": "es-419", "es-BO": "es-419", "es-BR": "es-419", "es-BZ": "es-419", "es-CL": "es-419", "es-CO": "es-419", "es-CR": "es-419", "es-CU": "es-419", "es-DO": "es-419", "es-EC": "es-419", "es-GT": "es-419", "es-HN": "es-419", "es-MX": "es-419", "es-NI": "es-419", "es-PA": "es-419", "es-PE": "es-419", "es-PR": "es-419", "es-PY": "es-419", "es-SV": "es-419", "es-US": "es-419", "es-UY": "es-419", "es-VE": "es-419", "pt-AO": "pt-PT", "pt-CH": "pt-PT", "pt-CV": "pt-PT", "pt-FR": "pt-PT", "pt-GQ": "pt-PT", "pt-GW": "pt-PT", "pt-LU": "pt-PT", "pt-MO": "pt-PT", "pt-MZ": "pt-PT", "pt-ST": "pt-PT", "pt-TL": "pt-PT", "zh-Hant-MO": "zh-Hant-HK" };
	//# sourceMappingURL=parentLocales.js.map

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var get_canonical_locales_1 = __webpack_require__(311);
	var invariant_1 = __webpack_require__(219);
	var polyfill_utils_1 = __webpack_require__(312);
	function createResolveLocale(getDefaultLocale) {
	    var lookupMatcher = createLookupMatcher(getDefaultLocale);
	    var bestFitMatcher = createBestFitMatcher(getDefaultLocale);
	    /**
	     * https://tc39.es/ecma402/#sec-resolvelocale
	     */
	    return function resolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	        var matcher = options.localeMatcher;
	        var r;
	        if (matcher === 'lookup') {
	            r = lookupMatcher(availableLocales, requestedLocales);
	        }
	        else {
	            r = bestFitMatcher(availableLocales, requestedLocales);
	        }
	        var foundLocale = r.locale;
	        var result = { locale: '', dataLocale: foundLocale };
	        var supportedExtension = '-u';
	        for (var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++) {
	            var key = relevantExtensionKeys_1[_i];
	            var foundLocaleData = localeData[foundLocale];
	            invariant_1.invariant(typeof foundLocaleData === 'object' && foundLocaleData !== null, "locale data " + key + " must be an object");
	            var keyLocaleData = foundLocaleData[key];
	            invariant_1.invariant(Array.isArray(keyLocaleData), "keyLocaleData for " + key + " must be an array");
	            var value = keyLocaleData[0];
	            invariant_1.invariant(typeof value === 'string' || value === null, 'value must be string or null');
	            var supportedExtensionAddition = '';
	            if (r.extension) {
	                var requestedValue = unicodeExtensionValue(r.extension, key);
	                if (requestedValue !== undefined) {
	                    if (requestedValue !== '') {
	                        if (~keyLocaleData.indexOf(requestedValue)) {
	                            value = requestedValue;
	                            supportedExtensionAddition = "-" + key + "-" + value;
	                        }
	                    }
	                    else if (~requestedValue.indexOf('true')) {
	                        value = 'true';
	                        supportedExtensionAddition = "-" + key;
	                    }
	                }
	            }
	            if (key in options) {
	                var optionsValue = options[key];
	                invariant_1.invariant(typeof optionsValue === 'string' ||
	                    typeof optionsValue === 'undefined' ||
	                    optionsValue === null, 'optionsValue must be String, Undefined or Null');
	                if (~keyLocaleData.indexOf(optionsValue)) {
	                    if (optionsValue !== value) {
	                        value = optionsValue;
	                        supportedExtensionAddition = '';
	                    }
	                }
	            }
	            result[key] = value;
	            supportedExtension += supportedExtensionAddition;
	        }
	        if (supportedExtension.length > 2) {
	            var privateIndex = foundLocale.indexOf('-x-');
	            if (privateIndex === -1) {
	                foundLocale = foundLocale + supportedExtension;
	            }
	            else {
	                var preExtension = foundLocale.slice(0, privateIndex);
	                var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	            foundLocale = get_canonical_locales_1.getCanonicalLocales(foundLocale)[0];
	        }
	        result.locale = foundLocale;
	        return result;
	    };
	}
	exports.createResolveLocale = createResolveLocale;
	/**
	 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
	 * @param extension
	 * @param key
	 */
	function unicodeExtensionValue(extension, key) {
	    invariant_1.invariant(key.length === 2, 'key must have 2 elements');
	    var size = extension.length;
	    var searchValue = "-" + key + "-";
	    var pos = extension.indexOf(searchValue);
	    if (pos !== -1) {
	        var start = pos + 4;
	        var end = start;
	        var k = start;
	        var done = false;
	        while (!done) {
	            var e = extension.indexOf('-', k);
	            var len = void 0;
	            if (e === -1) {
	                len = size - k;
	            }
	            else {
	                len = e - k;
	            }
	            if (len === 2) {
	                done = true;
	            }
	            else if (e === -1) {
	                end = size;
	                done = true;
	            }
	            else {
	                end = e;
	                k = e + 1;
	            }
	        }
	        return extension.slice(start, end);
	    }
	    searchValue = "-" + key;
	    pos = extension.indexOf(searchValue);
	    if (pos !== -1 && pos + 3 === size) {
	        return '';
	    }
	    return undefined;
	}
	var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
	/**
	 * https://tc39.es/ecma402/#sec-bestavailablelocale
	 * @param availableLocales
	 * @param locale
	 */
	function bestAvailableLocale(availableLocales, locale) {
	    var candidate = locale;
	    while (true) {
	        if (~availableLocales.indexOf(candidate)) {
	            return candidate;
	        }
	        var pos = candidate.lastIndexOf('-');
	        if (!~pos) {
	            return undefined;
	        }
	        if (pos >= 2 && candidate[pos - 2] === '-') {
	            pos -= 2;
	        }
	        candidate = candidate.slice(0, pos);
	    }
	}
	function createLookupMatcher(getDefaultLocale) {
	    /**
	     * https://tc39.es/ecma402/#sec-lookupmatcher
	     */
	    return function lookupMatcher(availableLocales, requestedLocales) {
	        var result = { locale: '' };
	        for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
	            var locale = requestedLocales_1[_i];
	            var noExtensionLocale = locale.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	            var availableLocale = bestAvailableLocale(availableLocales, noExtensionLocale);
	            if (availableLocale) {
	                result.locale = availableLocale;
	                if (locale !== noExtensionLocale) {
	                    result.extension = locale.slice(noExtensionLocale.length + 1, locale.length);
	                }
	                return result;
	            }
	        }
	        result.locale = getDefaultLocale();
	        return result;
	    };
	}
	function createBestFitMatcher(getDefaultLocale) {
	    return function bestFitMatcher(availableLocales, requestedLocales) {
	        var result = { locale: '' };
	        for (var _i = 0, requestedLocales_2 = requestedLocales; _i < requestedLocales_2.length; _i++) {
	            var locale = requestedLocales_2[_i];
	            var noExtensionLocale = locale.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	            var availableLocale = bestAvailableLocale(availableLocales, noExtensionLocale);
	            if (availableLocale) {
	                result.locale = availableLocale;
	                if (locale !== noExtensionLocale) {
	                    result.extension = locale.slice(noExtensionLocale.length + 1, locale.length);
	                }
	                return result;
	            }
	        }
	        result.locale = getDefaultLocale();
	        return result;
	    };
	}
	function getLocaleHierarchy(locale, aliases, parentLocales) {
	    var results = [locale];
	    if (aliases[locale]) {
	        locale = aliases[locale];
	        results.push(locale);
	    }
	    var parentLocale = parentLocales[locale];
	    if (parentLocale) {
	        results.push(parentLocale);
	    }
	    var localeParts = locale.split('-');
	    for (var i = localeParts.length; i > 1; i--) {
	        results.push(localeParts.slice(0, i - 1).join('-'));
	    }
	    return results;
	}
	exports.getLocaleHierarchy = getLocaleHierarchy;
	function lookupSupportedLocales(availableLocales, requestedLocales) {
	    var subset = [];
	    for (var _i = 0, requestedLocales_3 = requestedLocales; _i < requestedLocales_3.length; _i++) {
	        var locale = requestedLocales_3[_i];
	        var noExtensionLocale = locale.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	        var availableLocale = bestAvailableLocale(availableLocales, noExtensionLocale);
	        if (availableLocale) {
	            subset.push(availableLocale);
	        }
	    }
	    return subset;
	}
	function supportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = 'best fit';
	    if (options !== undefined) {
	        options = polyfill_utils_1.toObject(options);
	        matcher = polyfill_utils_1.getOption(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
	    }
	    if (matcher === 'best fit') {
	        return lookupSupportedLocales(availableLocales, requestedLocales);
	    }
	    return lookupSupportedLocales(availableLocales, requestedLocales);
	}
	exports.supportedLocales = supportedLocales;
	var MissingLocaleDataError = /** @class */ (function (_super) {
	    __extends(MissingLocaleDataError, _super);
	    function MissingLocaleDataError() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.type = 'MISSING_LOCALE_DATA';
	        return _this;
	    }
	    return MissingLocaleDataError;
	}(Error));
	function isMissingLocaleDataError(e) {
	    return e.type === 'MISSING_LOCALE_DATA';
	}
	exports.isMissingLocaleDataError = isMissingLocaleDataError;
	function unpackData(locale, localeData, 
	/** By default shallow merge the dictionaries. */
	reducer) {
	    if (reducer === void 0) { reducer = function (all, d) { return (__assign(__assign({}, all), d)); }; }
	    var localeHierarchy = getLocaleHierarchy(locale, localeData.aliases, localeData.parentLocales);
	    var dataToMerge = localeHierarchy
	        .map(function (l) { return localeData.data[l]; })
	        .filter(Boolean);
	    if (!dataToMerge.length) {
	        throw new MissingLocaleDataError("Missing locale data for \"" + locale + "\", lookup hierarchy: " + localeHierarchy.join(', '));
	    }
	    dataToMerge.reverse();
	    return dataToMerge.reduce(reducer, {});
	}
	exports.unpackData = unpackData;
	//# sourceMappingURL=resolve-locale.js.map

/***/ },
/* 712 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// https://tc39.es/proposal-unified-intl-numberformat/section6/locales-currencies-tz_diff_out.html#sec-issanctionedsimpleunitidentifier
	exports.SANCTIONED_UNITS = [
	    'angle-degree',
	    'area-acre',
	    'area-hectare',
	    'concentr-percent',
	    'digital-bit',
	    'digital-byte',
	    'digital-gigabit',
	    'digital-gigabyte',
	    'digital-kilobit',
	    'digital-kilobyte',
	    'digital-megabit',
	    'digital-megabyte',
	    'digital-petabyte',
	    'digital-terabit',
	    'digital-terabyte',
	    'duration-day',
	    'duration-hour',
	    'duration-millisecond',
	    'duration-minute',
	    'duration-month',
	    'duration-second',
	    'duration-week',
	    'duration-year',
	    'length-centimeter',
	    'length-foot',
	    'length-inch',
	    'length-kilometer',
	    'length-meter',
	    'length-mile-scandinavian',
	    'length-mile',
	    'length-millimeter',
	    'length-yard',
	    'mass-gram',
	    'mass-kilogram',
	    'mass-ounce',
	    'mass-pound',
	    'mass-stone',
	    'temperature-celsius',
	    'temperature-fahrenheit',
	    'volume-fluid-ounce',
	    'volume-gallon',
	    'volume-liter',
	    'volume-milliliter',
	];
	// In CLDR, the unit name always follows the form `namespace-unit` pattern.
	// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
	function removeUnitNamespace(unit) {
	    return unit.replace(/^(.*?)-/, '');
	}
	exports.removeUnitNamespace = removeUnitNamespace;
	//# sourceMappingURL=units.js.map

/***/ },
/* 713 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function _(msg) {
	    return msg;
	}
	exports._ = _;
	function defineMessages(msgs) {
	    return msgs;
	}
	exports.defineMessages = defineMessages;
	//# sourceMappingURL=index.js.map

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `position="fixed"`. */
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0,
	      '@media print': {
	        // Prevent the app bar to be visible on each printed page.
	        position: 'absolute'
	      }
	    },
	
	    /* Styles applied to the root element if `position="absolute"`. */
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="sticky"`. */
	    positionSticky: {
	      // ⚠️ sticky is not supported by IE 11.
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {
	      position: 'static',
	      transform: 'translateZ(0)' // Make sure we can see the elevation.
	
	    },
	
	    /* Styles applied to the root element if `position="relative"`. */
	    positionRelative: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if `color="default"`. */
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="transparent"`. */
	    colorTransparent: {
	      backgroundColor: 'transparent',
	      color: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var AppBar = React.forwardRef(function AppBar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'fixed' : _props$position,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "position"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _capitalize.default)(position))], classes["color".concat((0, _capitalize.default)(color))], className, position === 'fixed' && 'mui-fixed'),
	    ref: ref
	  }, other));
	});
	 false ? AppBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(714));

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Person = _interopRequireDefault(__webpack_require__(913));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      lineHeight: 1,
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the root element if not `src` or `srcSet`. */
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `variant="circle"`. */
	    circle: {},
	
	    /* Styles applied to the root element if `variant="rounded"`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="square"`. */
	    square: {
	      borderRadius: 0
	    },
	
	    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE 11.
	      objectFit: 'cover',
	      // Hide alt text.
	      color: 'transparent',
	      // Hide the image broken icon, only works on Chrome.
	      textIndent: 10000
	    },
	
	    /* Styles applied to the fallback icon */
	    fallback: {
	      width: '75%',
	      height: '75%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function useLoaded(_ref) {
	  var src = _ref.src,
	      srcSet = _ref.srcSet;
	
	  var _React$useState = React.useState(false),
	      loaded = _React$useState[0],
	      setLoaded = _React$useState[1];
	
	  React.useEffect(function () {
	    if (!src && !srcSet) {
	      return undefined;
	    }
	
	    setLoaded(false);
	    var active = true;
	    var image = new Image();
	    image.src = src;
	    image.srcSet = srcSet;
	
	    image.onload = function () {
	      if (!active) {
	        return;
	      }
	
	      setLoaded('loaded');
	    };
	
	    image.onerror = function () {
	      if (!active) {
	        return;
	      }
	
	      setLoaded('error');
	    };
	
	    return function () {
	      active = false;
	    };
	  }, [src, srcSet]);
	  return loaded;
	}
	
	var Avatar = React.forwardRef(function Avatar(props, ref) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'circle' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);
	  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.
	
	  var loaded = useLoaded({
	    src: src,
	    srcSet: srcSet
	  });
	  var hasImg = src || srcSet;
	  var hasImgNotFailing = hasImg && loaded !== 'error';
	
	  if (hasImgNotFailing) {
	    children = /*#__PURE__*/React.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  } else if (childrenProp != null) {
	    children = childrenProp;
	  } else if (hasImg && alt) {
	    children = alt[0];
	  } else {
	    children = /*#__PURE__*/React.createElement(_Person.default, {
	      className: classes.fallback
	    });
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
	    ref: ref
	  }, other), children);
	});
	 false ? Avatar.propTypes = {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar if `src` is not set.
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Attributes applied to the `img` element if the component is used to display an image.
	   * It can be used to listen for the loading error event.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   * Use this attribute for responsive image display.
	   */
	  srcSet: _propTypes.default.string,
	
	  /**
	   * The shape of the avatar.
	   */
	  variant: _propTypes.default.oneOf(['circle', 'rounded', 'square'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(716));

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Fade = _interopRequireDefault(__webpack_require__(158));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    // Improve scrollable dialog support.
	    zIndex: -1,
	    position: 'fixed',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	var Backdrop = React.forwardRef(function Backdrop(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Fade.default : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: open,
	    timeout: transitionDuration
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.root, className, invisible && classes.invisible),
	    "aria-hidden": true,
	    ref: ref
	  }, children));
	});
	 false ? Backdrop.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var RADIUS_STANDARD = 10;
	var RADIUS_DOT = 4;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'inline-flex',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the badge `span` element. */
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      boxSizing: 'border-box',
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(12),
	      minWidth: RADIUS_STANDARD * 2,
	      lineHeight: 1,
	      padding: '0 6px',
	      height: RADIUS_STANDARD * 2,
	      borderRadius: RADIUS_STANDARD,
	      zIndex: 1,
	      // Render the badge on top of potential ripples.
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.enteringScreen
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      backgroundColor: theme.palette.error.main,
	      color: theme.palette.error.contrastText
	    },
	
	    /* Styles applied to the root element if `variant="dot"`. */
	    dot: {
	      borderRadius: RADIUS_DOT,
	      height: RADIUS_DOT * 2,
	      minWidth: RADIUS_DOT * 2,
	      padding: 0
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
	    anchorOriginTopRightRectangle: {
	      top: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
	    anchorOriginBottomRightRectangle: {
	      bottom: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
	    anchorOriginTopLeftRectangle: {
	      top: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
	    anchorOriginBottomLeftRectangle: {
	      bottom: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
	    anchorOriginTopRightCircle: {
	      top: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
	    anchorOriginBottomRightCircle: {
	      bottom: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
	    anchorOriginTopLeftCircle: {
	      top: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
	    anchorOriginBottomLeftCircle: {
	      bottom: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
	    invisible: {
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.leavingScreen
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	var Badge = React.forwardRef(function Badge(props, ref) {
	  var _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'right'
	  } : _props$anchorOrigin,
	      badgeContent = props.badgeContent,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
	      invisibleProp = props.invisible,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 99 : _props$max,
	      _props$overlap = props.overlap,
	      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
	      _props$showZero = props.showZero,
	      showZero = _props$showZero === void 0 ? false : _props$showZero,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);
	  var invisible = invisibleProp;
	
	  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
	    invisible = true;
	  }
	
	  var displayValue = '';
	
	  if (variant !== 'dot') {
	    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), children, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0, _capitalize.default)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0, _capitalize.default)(anchorOrigin.vertical)).concat((0, _capitalize.default)(anchorOrigin.horizontal)).concat((0, _capitalize.default)(overlap))], color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
	  }, displayValue));
	});
	 false ? Badge.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The anchor of the badge.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The content rendered within the badge.
	   */
	  badgeContent: _propTypes.default.node,
	
	  /**
	   * The badge will be added relative to this node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'error', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the badge will be invisible.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * Max count to show.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * Wrapped shape the badge should overlap.
	   */
	  overlap: _propTypes.default.oneOf(['circle', 'rectangle']),
	
	  /**
	   * Controls whether the badge is hidden when `badgeContent` is zero.
	   */
	  showZero: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dot', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBadge'
	})(Badge);
	
	exports.default = _default;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	
	var _Badge = _interopRequireDefault(__webpack_require__(719));

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      justifyContent: 'center',
	      height: 56,
	      backgroundColor: theme.palette.background.paper
	    }
	  };
	};
	
	exports.styles = styles;
	var BottomNavigation = React.forwardRef(function BottomNavigation(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      onChange = props.onChange,
	      _props$showLabels = props.showLabels,
	      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), React.Children.map(children, function (child, childIndex) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    return React.cloneElement(child, {
	      selected: childValue === value,
	      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
	      value: childValue,
	      onChange: onChange
	    });
	  }));
	});
	 false ? BottomNavigation.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {any} value We default to the index of the child.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, all `BottomNavigationAction`s will show their labels.
	   * By default, only the selected `BottomNavigationAction` will show its label.
	   */
	  showLabels: _propTypes.default.bool,
	
	  /**
	   * The value of the currently selected `BottomNavigationAction`.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigation'
	})(BottomNavigation);
	
	exports.default = _default;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	
	var _BottomNavigation = _interopRequireDefault(__webpack_require__(721));

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(169));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      transition: theme.transitions.create(['color', 'padding-top'], {
	        duration: theme.transitions.duration.short
	      }),
	      padding: '6px 12px 8px',
	      minWidth: 80,
	      maxWidth: 168,
	      color: theme.palette.text.secondary,
	      flex: '1',
	      '&$iconOnly': {
	        paddingTop: 16
	      },
	      '&$selected': {
	        paddingTop: 6,
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if selected. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
	    iconOnly: {},
	
	    /* Styles applied to the span element that wraps the icon and label. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the label's span element. */
	    label: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(12),
	      opacity: 1,
	      transition: 'font-size 0.2s, opacity 0.2s',
	      transitionDelay: '0.1s',
	      '&$iconOnly': {
	        opacity: 0,
	        transitionDelay: '0s'
	      },
	      '&$selected': {
	        fontSize: theme.typography.pxToRem(14)
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var BottomNavigationAction = React.forwardRef(function BottomNavigationAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      icon = props.icon,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      selected = props.selected,
	      showLabel = props.showLabel,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
	    focusRipple: true,
	    onClick: handleChange
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.wrapper
	  }, icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
	  }, label)));
	});
	 false ? BottomNavigationAction.propTypes = {
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `BottomNavigationAction` will show its label.
	   * By default, only the selected `BottomNavigationAction`
	   * inside `BottomNavigation` will show its label.
	   */
	  showLabel: _propTypes.default.bool,
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigationAction'
	})(BottomNavigationAction);
	
	exports.default = _default;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	
	var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(723));

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styleFunction = void 0;
	
	var _system = __webpack_require__(376);
	
	var _styled = _interopRequireDefault(__webpack_require__(354));
	
	var styleFunction = (0, _system.css)((0, _system.compose)(_system.borders, _system.display, _system.flexbox, _system.grid, _system.positions, _system.palette, _system.shadows, _system.sizing, _system.spacing, _system.typography));
	/**
	 * @ignore - do not document.
	 */
	
	exports.styleFunction = styleFunction;
	var Box = (0, _styled.default)('div')(styleFunction, {
	  name: 'MuiBox'
	});
	var _default = Box;
	exports.default = _default;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _MoreHoriz = _interopRequireDefault(__webpack_require__(912));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      marginLeft: theme.spacing(0.5),
	      marginRight: theme.spacing(0.5),
	      backgroundColor: theme.palette.grey[100],
	      color: theme.palette.grey[700],
	      borderRadius: 2,
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: theme.palette.grey[200]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[0],
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[200], 0.12)
	      }
	    },
	    icon: {
	      width: 24,
	      height: 16
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function BreadcrumbCollapsed(props) {
	  var classes = props.classes,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "li",
	    className: classes.root,
	    focusRipple: true
	  }, other), /*#__PURE__*/React.createElement(_MoreHoriz.default, {
	    className: classes.icon
	  }));
	}
	
	 false ? BreadcrumbCollapsed.propTypes = {
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateBreadcrumbCollapsed'
	})(BreadcrumbCollapsed);
	
	exports.default = _default;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var _BreadcrumbCollapsed = _interopRequireDefault(__webpack_require__(726));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the ol element. */
	  ol: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    alignItems: 'center',
	    padding: 0,
	    margin: 0,
	    listStyle: 'none'
	  },
	
	  /* Styles applied to the li element. */
	  li: {},
	
	  /* Styles applied to the separator element. */
	  separator: {
	    display: 'flex',
	    userSelect: 'none',
	    marginLeft: 8,
	    marginRight: 8
	  }
	};
	exports.styles = styles;
	
	function insertSeparators(items, className, separator) {
	  return items.reduce(function (acc, current, index) {
	    if (index < items.length - 1) {
	      acc = acc.concat(current, /*#__PURE__*/React.createElement("li", {
	        "aria-hidden": true,
	        key: "separator-".concat(index),
	        className: className
	      }, separator));
	    } else {
	      acc.push(current);
	    }
	
	    return acc;
	  }, []);
	}
	
	var Breadcrumbs = React.forwardRef(function Breadcrumbs(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'nav' : _props$component,
	      _props$expandText = props.expandText,
	      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
	      _props$itemsAfterColl = props.itemsAfterCollapse,
	      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
	      _props$itemsBeforeCol = props.itemsBeforeCollapse,
	      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
	      _props$maxItems = props.maxItems,
	      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
	      _props$separator = props.separator,
	      separator = _props$separator === void 0 ? '/' : _props$separator,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);
	
	  var _React$useState = React.useState(false),
	      expanded = _React$useState[0],
	      setExpanded = _React$useState[1];
	
	  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
	    var handleClickExpand = function handleClickExpand(event) {
	      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
	      // Let's keep the focus in the component after expanding.
	
	      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');
	
	      if (focusable) {
	        focusable.focus();
	      }
	    }; // This defends against someone passing weird input, to ensure that if all
	    // items would be shown anyway, we just show all items without the EllipsisItem
	
	
	    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
	      if (false) {
	        console.error(['Material-UI: you have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
	      }
	
	      return allItems;
	    }
	
	    return [].concat((0, _toConsumableArray2.default)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/React.createElement(_BreadcrumbCollapsed.default, {
	      "aria-label": expandText,
	      key: "ellipsis",
	      onClick: handleClickExpand
	    })], (0, _toConsumableArray2.default)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
	  };
	
	  var allItems = React.Children.toArray(children).filter(function (child) {
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return React.isValidElement(child);
	  }).map(function (child, index) {
	    return /*#__PURE__*/React.createElement("li", {
	      className: classes.li,
	      key: "child-".concat(index)
	    }, child);
	  });
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    ref: ref,
	    component: Component,
	    color: "textSecondary",
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement("ol", {
	    className: classes.ol
	  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
	});
	 false ? Breadcrumbs.propTypes = {
	  /**
	   * The breadcrumb children.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   * By default, it maps the variant to a good default headline component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Override the default label for the expand button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  expandText: _propTypes.default.string,
	
	  /**
	   * If max items is exceeded, the number of items to show after the ellipsis.
	   */
	  itemsAfterCollapse: _propTypes.default.number,
	
	  /**
	   * If max items is exceeded, the number of items to show before the ellipsis.
	   */
	  itemsBeforeCollapse: _propTypes.default.number,
	
	  /**
	   * Specifies the maximum number of breadcrumbs to display. When there are more
	   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
	   * will be shown, with an ellipsis in between.
	   */
	  maxItems: _propTypes.default.number,
	
	  /**
	   * Custom separator node.
	   */
	  separator: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBreadcrumbs'
	})(Breadcrumbs);
	
	exports.default = _default;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	
	var _Breadcrumbs = _interopRequireDefault(__webpack_require__(727));

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minWidth: 64,
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // Ensure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `variant="text"`. */
	    text: {
	      padding: '6px 8px'
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
	    textPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
	    textSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      padding: '5px 15px',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabledBackground)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.primary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.secondary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabled)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        boxShadow: theme.shadows[4],
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          boxShadow: theme.shadows[2],
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        }
	      },
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
	    containedPrimary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
	    containedSecondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `disableElevation={true}`. */
	    disableElevation: {
	      boxShadow: 'none',
	      '&:hover': {
	        boxShadow: 'none'
	      },
	      '&$focusVisible': {
	        boxShadow: 'none'
	      },
	      '&:active': {
	        boxShadow: 'none'
	      },
	      '&$disabled': {
	        boxShadow: 'none'
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit',
	      borderColor: 'currentColor'
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
	    textSizeSmall: {
	      padding: '4px 5px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
	    textSizeLarge: {
	      padding: '8px 11px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
	    outlinedSizeSmall: {
	      padding: '3px 9px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
	    outlinedSizeLarge: {
	      padding: '7px 21px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
	    containedSizeSmall: {
	      padding: '4px 10px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
	    containedSizeLarge: {
	      padding: '8px 22px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {},
	
	    /* Styles applied to the root element if `size="large"`. */
	    sizeLarge: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the startIcon element if supplied. */
	    startIcon: {
	      display: 'inherit',
	      marginRight: 8,
	      marginLeft: -4,
	      '&$iconSizeSmall': {
	        marginLeft: -2
	      }
	    },
	
	    /* Styles applied to the endIcon element if supplied. */
	    endIcon: {
	      display: 'inherit',
	      marginRight: -4,
	      marginLeft: 8,
	      '&$iconSizeSmall': {
	        marginRight: -2
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="small"`. */
	    iconSizeSmall: {
	      '& > *:first-child': {
	        fontSize: 18
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="medium"`. */
	    iconSizeMedium: {
	      '& > *:first-child': {
	        fontSize: 20
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="large"`. */
	    iconSizeLarge: {
	      '& > *:first-child': {
	        fontSize: 22
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var Button = React.forwardRef(function Button(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableElevati = props.disableElevation,
	      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      endIconProp = props.endIcon,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      startIconProp = props.startIcon,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'text' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);
	  var startIcon = startIconProp && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.startIcon, classes["iconSize".concat((0, _capitalize.default)(size))])
	  }, startIconProp);
	  var endIcon = endIconProp && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.endIcon, classes["iconSize".concat((0, _capitalize.default)(size))])
	  }, endIconProp);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, _capitalize.default)(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat((0, _capitalize.default)(size))], classes["size".concat((0, _capitalize.default)(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref,
	    type: type
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, startIcon, children, endIcon));
	});
	 false ? Button.propTypes = {
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, no elevation is used.
	   */
	  disableElevation: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * Element placed after the children.
	   */
	  endIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * If `true`, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * Element placed before the children.
	   */
	  startIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['text', 'outlined', 'contained'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButton'
	})(Button);
	
	exports.default = _default;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(140));
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(732));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    },
	    '@media print': {
	      colorAdjust: 'exact'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Pseudo-class applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	exports.styles = styles;
	var ButtonBase = React.forwardRef(function ButtonBase(props, ref) {
	  var action = props.action,
	      buttonRefProp = props.buttonRef,
	      _props$centerRipple = props.centerRipple,
	      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$disableTouchRi = props.disableTouchRipple,
	      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
	      _props$focusRipple = props.focusRipple,
	      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
	      focusVisibleClassName = props.focusVisibleClassName,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onFocusVisible = props.onFocusVisible,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      onMouseDown = props.onMouseDown,
	      onMouseLeave = props.onMouseLeave,
	      onMouseUp = props.onMouseUp,
	      onTouchEnd = props.onTouchEnd,
	      onTouchMove = props.onTouchMove,
	      onTouchStart = props.onTouchStart,
	      onDragLeave = props.onDragLeave,
	      _props$tabIndex = props.tabIndex,
	      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
	      TouchRippleProps = props.TouchRippleProps,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);
	  var buttonRef = React.useRef(null);
	
	  function getButtonNode() {
	    // #StrictMode ready
	    return ReactDOM.findDOMNode(buttonRef.current);
	  }
	
	  var rippleRef = React.useRef(null);
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  if (disabled && focusVisible) {
	    setFocusVisible(false);
	  }
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  React.useImperativeHandle(action, function () {
	    return {
	      focusVisible: function focusVisible() {
	        setFocusVisible(true);
	        buttonRef.current.focus();
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (focusVisible && focusRipple && !disableRipple) {
	      rippleRef.current.pulsate();
	    }
	  }, [disableRipple, focusRipple, focusVisible]);
	
	  function useRippleHandler(rippleAction, eventCallback) {
	    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
	    return (0, _useEventCallback.default)(function (event) {
	      if (eventCallback) {
	        eventCallback(event);
	      }
	
	      var ignore = skipRippleAction;
	
	      if (!ignore && rippleRef.current) {
	        rippleRef.current[rippleAction](event);
	      }
	
	      return true;
	    });
	  }
	
	  var handleMouseDown = useRippleHandler('start', onMouseDown);
	  var handleDragLeave = useRippleHandler('stop', onDragLeave);
	  var handleMouseUp = useRippleHandler('stop', onMouseUp);
	  var handleMouseLeave = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      event.preventDefault();
	    }
	
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	  });
	  var handleTouchStart = useRippleHandler('start', onTouchStart);
	  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
	  var handleTouchMove = useRippleHandler('stop', onTouchMove);
	  var handleBlur = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      onBlurVisible(event);
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  }, false);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    // Fix for https://github.com/facebook/react/issues/7769
	    if (!buttonRef.current) {
	      buttonRef.current = event.currentTarget;
	    }
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	
	      if (onFocusVisible) {
	        onFocusVisible(event);
	      }
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  });
	
	  var isNonNativeButton = function isNonNativeButton() {
	    var button = getButtonNode();
	    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
	  };
	  /**
	   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
	   */
	
	
	  var keydownRef = React.useRef(false);
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    // Check if key is already down to avoid repeats being counted as multiple activations
	    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
	      keydownRef.current = true;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.start(event);
	      });
	    }
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
	      event.preventDefault();
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  });
	  var handleKeyUp = (0, _useEventCallback.default)(function (event) {
	    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
	    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
	    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
	      keydownRef.current = false;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.pulsate(event);
	      });
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
	      onClick(event);
	    }
	  });
	  var ComponentProp = component;
	
	  if (ComponentProp === 'button' && other.href) {
	    ComponentProp = 'a';
	  }
	
	  var buttonProps = {};
	
	  if (ComponentProp === 'button') {
	    buttonProps.type = type;
	    buttonProps.disabled = disabled;
	  } else {
	    if (ComponentProp !== 'a' || !other.href) {
	      buttonProps.role = 'button';
	    }
	
	    buttonProps['aria-disabled'] = disabled;
	  }
	
	  var handleUserRef = (0, _useForkRef.default)(buttonRefProp, ref);
	  var handleOwnRef = (0, _useForkRef.default)(focusVisibleRef, buttonRef);
	  var handleRef = (0, _useForkRef.default)(handleUserRef, handleOwnRef);
	
	  var _React$useState2 = React.useState(false),
	      mountedState = _React$useState2[0],
	      setMountedState = _React$useState2[1];
	
	  React.useEffect(function () {
	    setMountedState(true);
	  }, []);
	  var enableTouchRipple = mountedState && !disableRipple && !disabled;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (enableTouchRipple && !rippleRef.current) {
	        console.error(['Material-UI: the `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
	      }
	    }, [enableTouchRipple]);
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
	    onBlur: handleBlur,
	    onClick: onClick,
	    onFocus: handleFocus,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    onMouseDown: handleMouseDown,
	    onMouseLeave: handleMouseLeave,
	    onMouseUp: handleMouseUp,
	    onDragLeave: handleDragLeave,
	    onTouchEnd: handleTouchEnd,
	    onTouchMove: handleTouchMove,
	    onTouchStart: handleTouchStart,
	    ref: handleRef,
	    tabIndex: disabled ? -1 : tabIndex
	  }, buttonProps, other), children, enableTouchRipple ?
	  /*#__PURE__*/
	
	  /* TouchRipple is only needed client-side, x2 boost on the server. */
	  React.createElement(_TouchRipple.default, (0, _extends2.default)({
	    ref: rippleRef,
	    center: centerRipple
	  }, TouchRippleProps)) : null);
	});
	 false ? ButtonBase.propTypes = {
	  /**
	   * A ref for imperative actions.
	   * It currently only supports `focusVisible()` action.
	   */
	  action: _utils.refType,
	
	  /**
	   * @ignore
	   *
	   * Use that prop to pass a ref to the native button component.
	   * @deprecated Use `ref` instead.
	   */
	  buttonRef: _utils.refType,
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   * `disableRipple` must also be `false`.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This prop can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	   * if needed.
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onDragLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Props applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * Used to control the button's purpose.
	   * This prop passes the value to the `type` attribute of the native button component.
	   */
	  type: _propTypes.default.oneOf(['submit', 'reset', 'button'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * @ignore - internal component.
	 */
	
	function Ripple(props) {
	  var classes = props.classes,
	      _props$pulsate = props.pulsate,
	      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
	      rippleX = props.rippleX,
	      rippleY = props.rippleY,
	      rippleSize = props.rippleSize,
	      inProp = props.in,
	      _props$onExited = props.onExited,
	      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
	      timeout = props.timeout;
	
	  var _React$useState = React.useState(false),
	      leaving = _React$useState[0],
	      setLeaving = _React$useState[1];
	
	  var rippleClassName = (0, _clsx.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
	  var rippleStyles = {
	    width: rippleSize,
	    height: rippleSize,
	    top: -(rippleSize / 2) + rippleY,
	    left: -(rippleSize / 2) + rippleX
	  };
	  var childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
	  var handleExited = (0, _useEventCallback.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
	
	  useEnhancedEffect(function () {
	    if (!inProp) {
	      // react-transition-group#onExit
	      setLeaving(true); // react-transition-group#onExited
	
	      var timeoutId = setTimeout(handleExited, timeout);
	      return function () {
	        clearTimeout(timeoutId);
	      };
	    }
	
	    return undefined;
	  }, [handleExited, inProp, timeout]);
	  return /*#__PURE__*/React.createElement("span", {
	    className: rippleClassName,
	    style: rippleStyles
	  }, /*#__PURE__*/React.createElement("span", {
	    className: childClassName
	  }));
	}
	
	 false ? Ripple.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number,
	
	  /**
	   * exit delay
	   */
	  timeout: _propTypes.default.number.isRequired
	} : void 0;
	var _default = Ripple;
	exports.default = _default;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _reactTransitionGroup = __webpack_require__(125);
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(731));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      zIndex: 0,
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit'
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 *
	 * TODO v5: Make private
	 */
	
	
	exports.styles = styles;
	var TouchRipple = React.forwardRef(function TouchRipple(props, ref) {
	  var _props$center = props.center,
	      centerProp = _props$center === void 0 ? false : _props$center,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["center", "classes", "className"]);
	
	  var _React$useState = React.useState([]),
	      ripples = _React$useState[0],
	      setRipples = _React$useState[1];
	
	  var nextKey = React.useRef(0);
	  var rippleCallback = React.useRef(null);
	  React.useEffect(function () {
	    if (rippleCallback.current) {
	      rippleCallback.current();
	      rippleCallback.current = null;
	    }
	  }, [ripples]); // Used to filter out mouse emulated events on mobile.
	
	  var ignoringMouseDown = React.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
	  // We don't want to display the ripple for touch scroll events.
	
	  var startTimer = React.useRef(null); // This is the hook called once the previous timeout is ready.
	
	  var startTimerCommit = React.useRef(null);
	  var container = React.useRef(null);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(startTimer.current);
	    };
	  }, []);
	  var startCommit = React.useCallback(function (params) {
	    var pulsate = params.pulsate,
	        rippleX = params.rippleX,
	        rippleY = params.rippleY,
	        rippleSize = params.rippleSize,
	        cb = params.cb;
	    setRipples(function (oldRipples) {
	      return [].concat((0, _toConsumableArray2.default)(oldRipples), [/*#__PURE__*/React.createElement(_Ripple.default, {
	        key: nextKey.current,
	        classes: classes,
	        timeout: DURATION,
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	    });
	    nextKey.current += 1;
	    rippleCallback.current = cb;
	  }, [classes]);
	  var start = React.useCallback(function () {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var cb = arguments.length > 2 ? arguments[2] : undefined;
	    var _options$pulsate = options.pulsate,
	        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	        _options$center = options.center,
	        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
	        _options$fakeElement = options.fakeElement,
	        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	    if (event.type === 'mousedown' && ignoringMouseDown.current) {
	      ignoringMouseDown.current = false;
	      return;
	    }
	
	    if (event.type === 'touchstart') {
	      ignoringMouseDown.current = true;
	    }
	
	    var element = fakeElement ? null : container.current;
	    var rect = element ? element.getBoundingClientRect() : {
	      width: 0,
	      height: 0,
	      left: 0,
	      top: 0
	    }; // Get the size of the ripple
	
	    var rippleX;
	    var rippleY;
	    var rippleSize;
	
	    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	      rippleX = Math.round(rect.width / 2);
	      rippleY = Math.round(rect.height / 2);
	    } else {
	      var _ref = event.touches ? event.touches[0] : event,
	          clientX = _ref.clientX,
	          clientY = _ref.clientY;
	
	      rippleX = Math.round(clientX - rect.left);
	      rippleY = Math.round(clientY - rect.top);
	    }
	
	    if (center) {
	      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	      if (rippleSize % 2 === 0) {
	        rippleSize += 1;
	      }
	    } else {
	      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	    } // Touche devices
	
	
	    if (event.touches) {
	      // check that this isn't another touchstart due to multitouch
	      // otherwise we will only clear a single timer when unmounting while two
	      // are running
	      if (startTimerCommit.current === null) {
	        // Prepare the ripple effect.
	        startTimerCommit.current = function () {
	          startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Delay the execution of the ripple effect.
	
	
	        startTimer.current = setTimeout(function () {
	          if (startTimerCommit.current) {
	            startTimerCommit.current();
	            startTimerCommit.current = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      }
	    } else {
	      startCommit({
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize,
	        cb: cb
	      });
	    }
	  }, [centerProp, startCommit]);
	  var pulsate = React.useCallback(function () {
	    start({}, {
	      pulsate: true
	    });
	  }, [start]);
	  var stop = React.useCallback(function (event, cb) {
	    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
	    // We still want to show ripple effect.
	
	    if (event.type === 'touchend' && startTimerCommit.current) {
	      event.persist();
	      startTimerCommit.current();
	      startTimerCommit.current = null;
	      startTimer.current = setTimeout(function () {
	        stop(event, cb);
	      });
	      return;
	    }
	
	    startTimerCommit.current = null;
	    setRipples(function (oldRipples) {
	      if (oldRipples.length > 0) {
	        return oldRipples.slice(1);
	      }
	
	      return oldRipples;
	    });
	    rippleCallback.current = cb;
	  }, []);
	  React.useImperativeHandle(ref, function () {
	    return {
	      pulsate: pulsate,
	      start: start,
	      stop: stop
	    };
	  }, [pulsate, start, stop]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: container
	  }, other), /*#__PURE__*/React.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: null,
	    exit: true
	  }, ripples));
	});
	 false ? TouchRipple.propTypes = {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})(React.memo(TouchRipple));
	
	exports.default = _default;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Button = _interopRequireDefault(__webpack_require__(108));
	
	// Force a side effect so we don't have any override priority issue.
	// eslint-disable-next-line no-unused-expressions
	_Button.default.styles;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      boxShadow: theme.shadows[2]
	    },
	
	    /* Styles applied to the root element if `disableElevation={true}`. */
	    disableElevation: {
	      boxShadow: 'none'
	    },
	
	    /* Pseudo-class applied to child elements if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the children. */
	    grouped: {
	      minWidth: 40
	    },
	
	    /* Styles applied to the children if `orientation="horizontal"`. */
	    groupedHorizontal: {
	      '&:not(:first-child)': {
	        borderTopLeftRadius: 0,
	        borderBottomLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderTopRightRadius: 0,
	        borderBottomRightRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if `orientation="vertical"`. */
	    groupedVertical: {
	      '&:not(:first-child)': {
	        borderTopRightRadius: 0,
	        borderTopLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderBottomRightRadius: 0,
	        borderBottomLeftRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"`. */
	    groupedText: {},
	
	    /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
	    groupedTextHorizontal: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
	    groupedTextVertical: {
	      '&:not(:last-child)': {
	        borderBottom: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
	    groupedTextPrimary: {
	      '&:not(:last-child)': {
	        borderColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
	    groupedTextSecondary: {
	      '&:not(:last-child)': {
	        borderColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"`. */
	    groupedOutlined: {},
	
	    /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
	    groupedOutlinedHorizontal: {
	      '&:not(:first-child)': {
	        marginLeft: -1
	      },
	      '&:not(:last-child)': {
	        borderRightColor: 'transparent'
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
	    groupedOutlinedVertical: {
	      '&:not(:first-child)': {
	        marginTop: -1
	      },
	      '&:not(:last-child)': {
	        borderBottomColor: 'transparent'
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
	    groupedOutlinedPrimary: {
	      '&:hover': {
	        borderColor: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
	    groupedOutlinedSecondary: {
	      '&:hover': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"`. */
	    groupedContained: {
	      boxShadow: 'none'
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
	    groupedContainedHorizontal: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderRight: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
	    groupedContainedVertical: {
	      '&:not(:last-child)': {
	        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderBottom: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
	    groupedContainedPrimary: {
	      '&:not(:last-child)': {
	        borderColor: theme.palette.primary.dark
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
	    groupedContainedSecondary: {
	      '&:not(:last-child)': {
	        borderColor: theme.palette.secondary.dark
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var ButtonGroup = React.forwardRef(function ButtonGroup(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableElevati = props.disableElevation,
	      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"]);
	  var buttonClassName = (0, _clsx.default)(classes.grouped, classes["grouped".concat((0, _capitalize.default)(orientation))], classes["grouped".concat((0, _capitalize.default)(variant))], classes["grouped".concat((0, _capitalize.default)(variant)).concat((0, _capitalize.default)(orientation))], classes["grouped".concat((0, _capitalize.default)(variant)).concat(color !== 'default' ? (0, _capitalize.default)(color) : '')], disabled && classes.disabled);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: "group",
	    className: (0, _clsx.default)(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === 'contained' && classes.contained, orientation === 'vertical' && classes.vertical),
	    ref: ref
	  }, other), React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return React.cloneElement(child, {
	      className: (0, _clsx.default)(buttonClassName, child.props.className),
	      disabled: child.props.disabled || disabled,
	      color: child.props.color || color,
	      disableFocusRipple: disableFocusRipple,
	      disableRipple: disableRipple,
	      fullWidth: fullWidth,
	      size: child.props.size || size,
	      variant: child.props.variant || variant,
	      disableElevation: child.props.disableElevation || disableElevation
	    });
	  }));
	});
	 false ? ButtonGroup.propTypes = {
	  /**
	   * The content of the button group.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the buttons will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, no elevation is used.
	   */
	  disableElevation: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the buttons will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The group orientation.
	   */
	  orientation: _propTypes.default.oneOf(['vertical', 'horizontal']),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['text', 'outlined', 'contained'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonGroup'
	})(ButtonGroup);
	
	exports.default = _default;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(733));

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    overflow: 'hidden'
	  }
	};
	exports.styles = styles;
	var Card = React.forwardRef(function Card(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$raised = props.raised,
	      raised = _props$raised === void 0 ? false : _props$raised,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    elevation: raised ? 8 : 1,
	    ref: ref
	  }, other));
	});
	 false ? Card.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the card will use raised styling.
	   */
	  raised: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCard'
	})(Card);
	
	exports.default = _default;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      textAlign: 'inherit',
	      width: '100%',
	      '&:hover $focusHighlight': {
	        opacity: theme.palette.action.hoverOpacity
	      },
	      '&$focusVisible $focusHighlight': {
	        opacity: 0.12
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
	    focusHighlight: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit',
	      opacity: 0,
	      backgroundColor: 'currentcolor',
	      transition: theme.transitions.create('opacity', {
	        duration: theme.transitions.duration.short
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	var CardActionArea = React.forwardRef(function CardActionArea(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      focusVisibleClassName = props.focusVisibleClassName,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "focusVisibleClassName"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    focusVisibleClassName: (0, _clsx.default)(focusVisibleClassName, classes.focusVisible),
	    ref: ref
	  }, other), children, /*#__PURE__*/React.createElement("span", {
	    className: classes.focusHighlight
	  }));
	});
	 false ? CardActionArea.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActionArea'
	})(CardActionArea);
	
	exports.default = _default;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	
	var _CardActionArea = _interopRequireDefault(__webpack_require__(736));

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var CardActions = React.forwardRef(function CardActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? CardActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActions'
	})(CardActions);
	
	exports.default = _default;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	
	var _CardActions = _interopRequireDefault(__webpack_require__(738));

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    padding: 16,
	    '&:last-child': {
	      paddingBottom: 24
	    }
	  }
	};
	exports.styles = styles;
	var CardContent = React.forwardRef(function CardContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? CardContent.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardContent'
	})(CardContent);
	
	exports.default = _default;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 16
	  },
	
	  /* Styles applied to the avatar element. */
	  avatar: {
	    flex: '0 0 auto',
	    marginRight: 16
	  },
	
	  /* Styles applied to the action element. */
	  action: {
	    flex: '0 0 auto',
	    alignSelf: 'flex-start',
	    marginTop: -8,
	    marginRight: -8
	  },
	
	  /* Styles applied to the content wrapper element. */
	  content: {
	    flex: '1 1 auto'
	  },
	
	  /* Styles applied to the title Typography element. */
	  title: {},
	
	  /* Styles applied to the subheader Typography element. */
	  subheader: {}
	};
	exports.styles = styles;
	var CardHeader = React.forwardRef(function CardHeader(props, ref) {
	  var action = props.action,
	      avatar = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      subheaderProp = props.subheader,
	      subheaderTypographyProps = props.subheaderTypographyProps,
	      titleProp = props.title,
	      titleTypographyProps = props.titleTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);
	  var title = titleProp;
	
	  if (title != null && title.type !== _Typography.default && !disableTypography) {
	    title = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'h5',
	      className: classes.title,
	      component: "span",
	      display: "block"
	    }, titleTypographyProps), title);
	  }
	
	  var subheader = subheaderProp;
	
	  if (subheader != null && subheader.type !== _Typography.default && !disableTypography) {
	    subheader = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'body1',
	      className: classes.subheader,
	      color: "textSecondary",
	      component: "span",
	      display: "block"
	    }, subheaderTypographyProps), subheader);
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), avatar && /*#__PURE__*/React.createElement("div", {
	    className: classes.avatar
	  }, avatar), /*#__PURE__*/React.createElement("div", {
	    className: classes.content
	  }, title, subheader), action && /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action));
	});
	 false ? CardHeader.propTypes = {
	  /**
	   * The action to display in the card header.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The Avatar for the Card Header.
	   */
	  avatar: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `title` text, and optional `subheader` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  subheader: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the subheader
	   * (as long as disableTypography is not `true`).
	   */
	  subheaderTypographyProps: _propTypes.default.object,
	
	  /**
	   * The content of the Card Title.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the title
	   * (as long as disableTypography is not `true`).
	   */
	  titleTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardHeader'
	})(CardHeader);
	
	exports.default = _default;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(741));

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(21);
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'block',
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'center'
	  },
	
	  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
	  media: {
	    width: '100%'
	  },
	
	  /* Styles applied to the root element if `component="picture or img"`. */
	  img: {
	    // ⚠️ object-fit is not supported by IE 11.
	    objectFit: 'cover'
	  }
	};
	exports.styles = styles;
	var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
	var CardMedia = React.forwardRef(function CardMedia(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      image = props.image,
	      src = props.src,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "image", "src", "style"]);
	  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
	  var composedStyle = !isMediaComponent && image ? (0, _extends2.default)({
	    backgroundImage: "url(\"".concat(image, "\")")
	  }, style) : style;
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
	    ref: ref,
	    style: composedStyle,
	    src: isMediaComponent ? image || src : undefined
	  }, other), children);
	});
	 false ? CardMedia.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    if (!props.children && !props.image && !props.src && !props.component) {
	      return new Error('Material-UI: either `children`, `image`, `src` or `component` prop must be specified.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Component for rendering image.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Image to be displayed as a background image.
	   * Either `image` or `src` prop must be specified.
	   * Note that caller must specify height otherwise the image will not be visible.
	   */
	  image: _propTypes.default.string,
	
	  /**
	   * An alias for `image` property.
	   * Available only with media components.
	   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardMedia'
	})(CardMedia);
	
	exports.default = _default;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	
	var _CardMedia = _interopRequireDefault(__webpack_require__(743));

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(236));
	
	var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(909));
	
	var _CheckBox = _interopRequireDefault(__webpack_require__(908));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(911));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultCheckedIcon = /*#__PURE__*/React.createElement(_CheckBox.default, null);
	var defaultIcon = /*#__PURE__*/React.createElement(_CheckBoxOutlineBlank.default, null);
	var defaultIndeterminateIcon = /*#__PURE__*/React.createElement(_IndeterminateCheckBox.default, null);
	var Checkbox = React.forwardRef(function Checkbox(props, ref) {
	  var _props$checkedIcon = props.checkedIcon,
	      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$icon = props.icon,
	      icon = _props$icon === void 0 ? defaultIcon : _props$icon,
	      _props$indeterminate = props.indeterminate,
	      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
	      _props$indeterminateI = props.indeterminateIcon,
	      indeterminateIcon = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
	      inputProps = props.inputProps,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);
	  return /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], indeterminate && classes.indeterminate),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    color: color,
	    inputProps: (0, _extends2.default)({
	      'data-indeterminate': indeterminate
	    }, inputProps),
	    icon: React.cloneElement(indeterminate ? indeterminateIcon : icon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    checkedIcon: React.cloneElement(indeterminate ? indeterminateIcon : checkedIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    ref: ref
	  }, other));
	});
	 false ? Checkbox.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the checkbox will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   * This does not set the native input element to indeterminate due
	   * to inconsistent behavior across browsers.
	   * However, we set a `data-indeterminate` attribute on the input.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the checkbox.
	   * `small` is equivalent to the dense checkbox styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   * The browser uses "on" as the default value.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCheckbox'
	})(Checkbox);
	
	exports.default = _default;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(745));

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(907));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(169));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var styles = function styles(theme) {
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: 32,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: 32 / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      textDecoration: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0,
	      // Remove `button` padding
	      verticalAlign: 'middle',
	      boxSizing: 'border-box',
	      '&$disabled': {
	        opacity: 0.5,
	        pointerEvents: 'none'
	      },
	      '& $avatar': {
	        marginLeft: 5,
	        marginRight: -6,
	        width: 24,
	        height: 24,
	        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	        fontSize: theme.typography.pxToRem(12)
	      },
	      '& $avatarColorPrimary': {
	        color: theme.palette.primary.contrastText,
	        backgroundColor: theme.palette.primary.dark
	      },
	      '& $avatarColorSecondary': {
	        color: theme.palette.secondary.contrastText,
	        backgroundColor: theme.palette.secondary.dark
	      },
	      '& $avatarSmall': {
	        marginLeft: 4,
	        marginRight: -4,
	        width: 18,
	        height: 18,
	        fontSize: theme.typography.pxToRem(10)
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      height: 24
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
	    clickable: {
	      userSelect: 'none',
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1]
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
	    clickableColorPrimary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
	    clickableColorSecondary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` is defined. */
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
	    deletableColorPrimary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
	    deletableColorSecondary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      backgroundColor: 'transparent',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
	      },
	      '& $avatar': {
	        marginLeft: 4
	      },
	      '& $avatarSmall': {
	        marginLeft: 2
	      },
	      '& $icon': {
	        marginLeft: 4
	      },
	      '& $iconSmall': {
	        marginLeft: 2
	      },
	      '& $deleteIcon': {
	        marginRight: 5
	      },
	      '& $deleteIconSmall': {
	        marginRight: 3
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat(theme.palette.primary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat(theme.palette.secondary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the `avatar` element. */
	    avatar: {},
	
	    /* Styles applied to the `avatar` element if `size="small"`. */
	    avatarSmall: {},
	
	    /* Styles applied to the `avatar` element if `color="primary"`. */
	    avatarColorPrimary: {},
	
	    /* Styles applied to the `avatar` element if `color="secondary"`. */
	    avatarColorSecondary: {},
	
	    /* Styles applied to the `icon` element. */
	    icon: {
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      marginLeft: 5,
	      marginRight: -6
	    },
	
	    /* Styles applied to the `icon` element if `size="small"`. */
	    iconSmall: {
	      width: 18,
	      height: 18,
	      marginLeft: 4,
	      marginRight: -4
	    },
	
	    /* Styles applied to the `icon` element if `color="primary"`. */
	    iconColorPrimary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the `icon` element if `color="secondary"`. */
	    iconColorSecondary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the label `span` element. */
	    label: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      paddingLeft: 12,
	      paddingRight: 12,
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the label `span` element if `size="small"`. */
	    labelSmall: {
	      paddingLeft: 8,
	      paddingRight: 8
	    },
	
	    /* Styles applied to the `deleteIcon` element. */
	    deleteIcon: {
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      height: 22,
	      width: 22,
	      cursor: 'pointer',
	      margin: '0 5px 0 -6px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    },
	
	    /* Styles applied to the `deleteIcon` element if `size="small"`. */
	    deleteIconSmall: {
	      height: 16,
	      width: 16,
	      marginRight: 4,
	      marginLeft: -4
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
	    deleteIconColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
	    deleteIconColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function isDeleteKeyboardEvent(keyboardEvent) {
	  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
	}
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	var Chip = React.forwardRef(function Chip(props, ref) {
	  var avatarProp = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      clickableProp = props.clickable,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      ComponentProp = props.component,
	      deleteIconProp = props.deleteIcon,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      iconProp = props.icon,
	      label = props.label,
	      onClick = props.onClick,
	      onDelete = props.onDelete,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'default' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);
	  var chipRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(chipRef, ref);
	
	  var handleDeleteIconClick = function handleDeleteIconClick(event) {
	    // Stop the event from bubbling up to the `Chip`
	    event.stopPropagation();
	
	    if (onDelete) {
	      onDelete(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
	      // will be handled in keyUp, otherwise some browsers
	      // might init navigation
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleKeyUp = function handleKeyUp(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target) {
	      if (onDelete && isDeleteKeyboardEvent(event)) {
	        onDelete(event);
	      } else if (event.key === 'Escape' && chipRef.current) {
	        chipRef.current.blur();
	      }
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    }
	  };
	
	  var clickable = clickableProp !== false && onClick ? true : clickableProp;
	  var small = size === 'small';
	  var Component = ComponentProp || (clickable ? _ButtonBase.default : 'div');
	  var moreProps = Component === _ButtonBase.default ? {
	    component: 'div'
	  } : {};
	  var deleteIcon = null;
	
	  if (onDelete) {
	    var customClasses = (0, _clsx.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, _capitalize.default)(color))] : classes["deleteIconOutlinedColor".concat((0, _capitalize.default)(color))]), small && classes.deleteIconSmall);
	    deleteIcon = deleteIconProp && React.isValidElement(deleteIconProp) ? React.cloneElement(deleteIconProp, {
	      className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    }) : /*#__PURE__*/React.createElement(_Cancel.default, {
	      className: (0, _clsx.default)(classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    });
	  }
	
	  var avatar = null;
	
	  if (avatarProp && React.isValidElement(avatarProp)) {
	    avatar = React.cloneElement(avatarProp, {
	      className: (0, _clsx.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  var icon = null;
	
	  if (iconProp && React.isValidElement(iconProp)) {
	    icon = React.cloneElement(iconProp, {
	      className: (0, _clsx.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  if (false) {
	    if (avatar && icon) {
	      console.error('Material-UI: the Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: clickable || onDelete ? 'button' : undefined,
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && [classes["color".concat((0, _capitalize.default)(color))], clickable && classes["clickableColor".concat((0, _capitalize.default)(color))], onDelete && classes["deletableColor".concat((0, _capitalize.default)(color))]], variant !== "default" && [classes.outlined, {
	      'primary': classes.outlinedPrimary,
	      'secondary': classes.outlinedSecondary
	    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
	    "aria-disabled": disabled ? true : undefined,
	    tabIndex: clickable || onDelete ? 0 : undefined,
	    onClick: onClick,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    ref: handleRef
	  }, moreProps, other), avatar || icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, small && classes.labelSmall)
	  }, label), deleteIcon);
	});
	 false ? Chip.propTypes = {
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the chip will appear clickable, and will raise when pressed,
	   * even if the onClick prop is not defined.
	   * If false, the chip will not be clickable, even if onClick prop is defined.
	   * This can be used, for example,
	   * along with the component prop to indicate an anchor Chip is clickable.
	   */
	  clickable: _propTypes.default.bool,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * If `true`, the chip should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Icon element.
	   */
	  icon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The size of the chip.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['default', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var SIZE = 44;
	
	function getRelativeValue(value, min, max) {
	  return (Math.min(Math.max(min, value), max) - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-block'
	    },
	
	    /* Styles applied to the root element if `variant="static"`. */
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {
	      animation: '$circular-rotate 1.4s linear infinite'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the `svg` element. */
	    svg: {
	      display: 'block' // Keeps the progress centered
	
	    },
	
	    /* Styles applied to the `circle` svg path. */
	    circle: {
	      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
	      // strokeLinecap: 'butt',
	
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="static"`. */
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
	    circleIndeterminate: {
	      animation: '$circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-125px'
	      }
	    },
	
	    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
	    circleDisableShrink: {
	      animation: 'none'
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	var CircularProgress = React.forwardRef(function CircularProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$disableShrink = props.disableShrink,
	      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 40 : _props$size,
	      style = props.style,
	      _props$thickness = props.thickness,
	      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], {
	      'indeterminate': classes.indeterminate,
	      'static': classes.static
	    }[variant]),
	    style: (0, _extends2.default)({
	      width: size,
	      height: size
	    }, rootStyle, {}, style),
	    ref: ref,
	    role: "progressbar"
	  }, rootProps, other), /*#__PURE__*/React.createElement("svg", {
	    className: classes.svg,
	    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
	  }, /*#__PURE__*/React.createElement("circle", {
	    className: (0, _clsx.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
	      'indeterminate': classes.circleIndeterminate,
	      'static': classes.circleStatic
	    }[variant]),
	    style: circleStyle,
	    cx: SIZE,
	    cy: SIZE,
	    r: (SIZE - thickness) / 2,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	});
	 false ? CircularProgress.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the shrink animation is disabled.
	   * This only works if variant is `indeterminate`.
	   */
	  disableShrink: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
	      return new Error('Material-UI: you have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The size of the circle.
	   * If using a number, the pixel unit is assumed.
	   * If using a string, you need to provide the CSS unit, e.g '3rem'.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var _utils = __webpack_require__(21);
	
	function mapEventPropToEvent(eventProp) {
	  return eventProp.substring(2).toLowerCase();
	}
	
	function clickedRootScrollbar(event) {
	  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
	}
	/**
	 * Listen for click events that occur somewhere in the document, outside of the element itself.
	 * For instance, if you need to hide a menu when people click anywhere else on your page.
	 */
	
	
	function ClickAwayListener(props) {
	  var children = props.children,
	      _props$disableReactTr = props.disableReactTree,
	      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
	      _props$mouseEvent = props.mouseEvent,
	      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
	      onClickAway = props.onClickAway,
	      _props$touchEvent = props.touchEvent,
	      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
	  var movedRef = React.useRef(false);
	  var nodeRef = React.useRef(null);
	  var mountedRef = React.useRef(false);
	  var syntheticEventRef = React.useRef(false);
	  React.useEffect(function () {
	    mountedRef.current = true;
	    return function () {
	      mountedRef.current = false;
	    };
	  }, []); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    nodeRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
	  //
	  // event.preventDefault() is meant to stop default behaviours like
	  // clicking a checkbox to check it, hitting a button to submit a form,
	  // and hitting left arrow to move the cursor in a text input etc.
	  // Only special HTML elements have these default behaviors.
	
	  var handleClickAway = (0, _useEventCallback.default)(function (event) {
	    // Given developers can stop the propagation of the synthetic event,
	    // we can only be confident with a positive value.
	    var insideReactTree = syntheticEventRef.current;
	    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
	    // 2. The child might render null.
	    // 3. Behave like a blur listener.
	
	    if (!mountedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
	      return;
	    } // Do not act if user performed touchmove
	
	
	    if (movedRef.current) {
	      movedRef.current = false;
	      return;
	    }
	
	    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
	
	    if (event.composedPath) {
	      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
	    } else {
	      var doc = (0, _ownerDocument.default)(nodeRef.current); // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
	      // `doc.contains` works in modern browsers but isn't supported in IE 11:
	      // https://github.com/timmywil/panzoom/issues/450
	      // https://github.com/videojs/video.js/pull/5872
	
	      insideDOM = !(doc.documentElement && doc.documentElement.contains(event.target)) || nodeRef.current.contains(event.target);
	    }
	
	    if (!insideDOM && (disableReactTree || !insideReactTree)) {
	      onClickAway(event);
	    }
	  }); // Keep track of mouse/touch events that bubbled up through the portal.
	
	  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
	    return function (event) {
	      syntheticEventRef.current = true;
	      var childrenPropsHandler = children.props[handlerName];
	
	      if (childrenPropsHandler) {
	        childrenPropsHandler(event);
	      }
	    };
	  };
	
	  var childrenProps = {
	    ref: handleRef
	  };
	
	  if (touchEvent !== false) {
	    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
	  }
	
	  React.useEffect(function () {
	    if (touchEvent !== false) {
	      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	
	      var handleTouchMove = function handleTouchMove() {
	        movedRef.current = true;
	      };
	
	      doc.addEventListener(mappedTouchEvent, handleClickAway);
	      doc.addEventListener('touchmove', handleTouchMove);
	      return function () {
	        doc.removeEventListener(mappedTouchEvent, handleClickAway);
	        doc.removeEventListener('touchmove', handleTouchMove);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, touchEvent]);
	
	  if (mouseEvent !== false) {
	    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
	  }
	
	  React.useEffect(function () {
	    if (mouseEvent !== false) {
	      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	      doc.addEventListener(mappedMouseEvent, handleClickAway);
	      return function () {
	        doc.removeEventListener(mappedMouseEvent, handleClickAway);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, mouseEvent]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, React.cloneElement(children, childrenProps));
	}
	
	 false ? ClickAwayListener.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The wrapped element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  disableReactTree: _propTypes.default.bool,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	
	  /**
	   * Callback fired when a "click away" event is detected.
	   */
	  onClickAway: _propTypes.default.func.isRequired,
	
	  /**
	   * The touch event to listen to. You can disable the listener by providing `false`.
	   */
	  touchEvent: _propTypes.default.oneOf(['onTouchEnd', 'onTouchStart', false])
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  ClickAwayListener['propTypes' + ''] = (0, _utils.exactProp)(ClickAwayListener.propTypes);
	}
	
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(143);
	
	var _utils = __webpack_require__(34);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(314));
	
	/**
	 * @ignore - internal component.
	 */
	var StrictModeCollapse = React.forwardRef(function StrictModeCollapse(props, forwardedRef) {
	  var domRef = React.useRef(null);
	  var ref = (0, _utils.useForkRef)(domRef, forwardedRef);
	  return /*#__PURE__*/React.createElement(_Collapse.default, (0, _extends2.default)({}, props, {
	    findDOMNode: function findDOMNode() {
	      return domRef.current;
	    },
	    ref: ref,
	    TransitionComponent: _reactTransitionGroup.Transition
	  }));
	});
	var _default = StrictModeCollapse;
	exports.default = _default;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _defineProperty2.default)({
	      width: '100%',
	      marginLeft: 'auto',
	      boxSizing: 'border-box',
	      marginRight: 'auto',
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2),
	      display: 'block'
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `disableGutters={true}`. */
	    disableGutters: {
	      paddingLeft: 0,
	      paddingRight: 0
	    },
	
	    /* Styles applied to the root element if `fixed={true}`. */
	    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
	      var value = theme.breakpoints.values[breakpoint];
	
	      if (value !== 0) {
	        acc[theme.breakpoints.up(breakpoint)] = {
	          maxWidth: value
	        };
	      }
	
	      return acc;
	    }, {}),
	
	    /* Styles applied to the root element if `maxWidth="xs"`. */
	    maxWidthXs: (0, _defineProperty2.default)({}, theme.breakpoints.up('xs'), {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
	    }),
	
	    /* Styles applied to the root element if `maxWidth="sm"`. */
	    maxWidthSm: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
	      maxWidth: theme.breakpoints.values.sm
	    }),
	
	    /* Styles applied to the root element if `maxWidth="md"`. */
	    maxWidthMd: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
	      maxWidth: theme.breakpoints.values.md
	    }),
	
	    /* Styles applied to the root element if `maxWidth="lg"`. */
	    maxWidthLg: (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
	      maxWidth: theme.breakpoints.values.lg
	    }),
	
	    /* Styles applied to the root element if `maxWidth="xl"`. */
	    maxWidthXl: (0, _defineProperty2.default)({}, theme.breakpoints.up('xl'), {
	      maxWidth: theme.breakpoints.values.xl
	    })
	  };
	};
	
	exports.styles = styles;
	var Container = React.forwardRef(function Container(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$fixed = props.fixed,
	      fixed = _props$fixed === void 0 ? false : _props$fixed,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, _capitalize.default)(String(maxWidth)))]),
	    ref: ref
	  }, other));
	});
	 false ? Container.propTypes = {
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * Set the max-width to match the min-width of the current breakpoint.
	   * This is useful if you'd prefer to design for a fixed set of sizes
	   * instead of trying to accommodate a fully fluid viewport.
	   * It's fluid by default.
	   */
	  fixed: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the container.
	   * The container width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiContainer'
	})(Container);
	
	exports.default = _default;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	
	var _Container = _interopRequireDefault(__webpack_require__(751));

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.body = exports.html = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(21);
	
	var html = {
	  WebkitFontSmoothing: 'antialiased',
	  // Antialiasing.
	  MozOsxFontSmoothing: 'grayscale',
	  // Antialiasing.
	  // Change from `box-sizing: content-box` so that `width`
	  // is not affected by `padding` or `border`.
	  boxSizing: 'border-box'
	};
	exports.html = html;
	
	var body = function body(theme) {
	  return (0, _extends2.default)({
	    color: theme.palette.text.primary
	  }, theme.typography.body2, {
	    backgroundColor: theme.palette.background.default,
	    '@media print': {
	      // Save printer ink.
	      backgroundColor: theme.palette.common.white
	    }
	  });
	};
	
	exports.body = body;
	
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: html,
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      'strong, b': {
	        fontWeight: theme.typography.fontWeightBold
	      },
	      body: (0, _extends2.default)({
	        margin: 0
	      }, body(theme), {
	        // Add support for document.body.requestFullScreen().
	        // Other elements, if background transparent, are not supported.
	        '&::backdrop': {
	          backgroundColor: theme.palette.background.default
	        }
	      })
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	exports.styles = styles;
	
	function CssBaseline(props) {
	  /* eslint-disable no-unused-vars */
	  var _props$children = props.children,
	      children = _props$children === void 0 ? null : _props$children,
	      classes = props.classes;
	  /* eslint-enable no-unused-vars */
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
	}
	
	 false ? CssBaseline.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  CssBaseline['propTypes' + ''] = (0, _utils.exactProp)(CssBaseline.propTypes);
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(753));

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _Modal = _interopRequireDefault(__webpack_require__(164));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(220));
	
	var _Fade = _interopRequireDefault(__webpack_require__(158));
	
	var _transitions = __webpack_require__(60);
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	/* eslint-disable jsx-a11y/click-events-have-key-events */
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      '@media print': {
	        // Use !important to override the Modal inline-style.
	        position: 'absolute !important'
	      }
	    },
	
	    /* Styles applied to the container element if `scroll="paper"`. */
	    scrollPaper: {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the container element if `scroll="body"`. */
	    scrollBody: {
	      overflowY: 'auto',
	      overflowX: 'hidden',
	      textAlign: 'center',
	      '&:after': {
	        content: '""',
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        height: '100%',
	        width: '0'
	      }
	    },
	
	    /* Styles applied to the container element. */
	    container: {
	      height: '100%',
	      '@media print': {
	        height: 'auto'
	      },
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      margin: 32,
	      position: 'relative',
	      overflowY: 'auto',
	      // Fix IE 11 issue, to remove at some point.
	      '@media print': {
	        overflowY: 'visible',
	        boxShadow: 'none'
	      }
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="paper"`. */
	    paperScrollPaper: {
	      display: 'flex',
	      flexDirection: 'column',
	      maxHeight: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="body"`. */
	    paperScrollBody: {
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      textAlign: 'left' // 'initial' doesn't work on IE 11
	
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth=false`. */
	    paperWidthFalse: {
	      maxWidth: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
	    paperWidthXs: {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.values.sm,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.values.md,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
	    paperWidthLg: {
	      maxWidth: theme.breakpoints.values.lg,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
	    paperWidthXl: {
	      maxWidth: theme.breakpoints.values.xl,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
	    paperFullWidth: {
	      width: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
	    paperFullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: 'none',
	      borderRadius: 0,
	      '&$paperScrollBody': {
	        margin: 0,
	        maxWidth: '100%'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	
	var Dialog = React.forwardRef(function Dialog(props, ref) {
	  var BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$fullScreen = props.fullScreen,
	      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperComponent = props.PaperComponent,
	      PaperComponent = _props$PaperComponent === void 0 ? _Paper.default : _props$PaperComponent,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$scroll = props.scroll,
	      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Fade.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      ariaDescribedby = props['aria-describedby'],
	      ariaLabelledby = props['aria-labelledby'],
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);
	  var mouseDownTarget = React.useRef();
	
	  var handleMouseDown = function handleMouseDown(event) {
	    mouseDownTarget.current = event.target;
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    // Ignore the events not coming from the "backdrop"
	    // We don't want to close the dialog when clicking the dialog content.
	    if (event.target !== event.currentTarget) {
	      return;
	    } // Make sure the event starts and ends on the same DOM element.
	
	
	    if (event.target !== mouseDownTarget.current) {
	      return;
	    }
	
	    mouseDownTarget.current = null;
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    BackdropComponent: _Backdrop.default,
	    BackdropProps: (0, _extends2.default)({
	      transitionDuration: transitionDuration
	    }, BackdropProps),
	    closeAfterTransition: true,
	    disableBackdropClick: disableBackdropClick,
	    disableEscapeKeyDown: disableEscapeKeyDown,
	    onEscapeKeyDown: onEscapeKeyDown,
	    onClose: onClose,
	    open: open,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    timeout: transitionDuration,
	    onEnter: onEnter,
	    onEntering: onEntering,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExiting: onExiting,
	    onExited: onExited,
	    role: "none presentation"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.container, classes["scroll".concat((0, _capitalize.default)(scroll))]),
	    onClick: handleBackdropClick,
	    onMouseDown: handleMouseDown
	  }, /*#__PURE__*/React.createElement(PaperComponent, (0, _extends2.default)({
	    elevation: 24,
	    role: "dialog",
	    "aria-describedby": ariaDescribedby,
	    "aria-labelledby": ariaLabelledby
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperScroll".concat((0, _capitalize.default)(scroll))], classes["paperWidth".concat((0, _capitalize.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
	  }), children))));
	});
	 false ? Dialog.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The id(s) of the element(s) that describe the dialog.
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * The id(s) of the element(s) that label the dialog.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * Dialog children, usually the included sub-components.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clicking the backdrop will not fire the `onClose` callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire the `onClose` callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog will be full-screen
	   */
	  fullScreen: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog stretches to `maxWidth`.
	   *
	   * Notice that the dialog width grow is limited by the default margin.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the dialog.
	   * The dialog width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableKeyboard` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the Dialog is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The component used to render the body of the dialog.
	   */
	  PaperComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Determine the container for scrolling the dialog.
	   */
	  scroll: _propTypes.default.oneOf(['body', 'paper']),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialog'
	})(Dialog);
	
	exports.default = _default;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	
	var _Dialog = _interopRequireDefault(__webpack_require__(755));

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end',
	    flex: '0 0 auto'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var DialogActions = React.forwardRef(function DialogActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? DialogActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogActions'
	})(DialogActions);
	
	exports.default = _default;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	
	var _DialogActions = _interopRequireDefault(__webpack_require__(757));

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto',
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      overflowY: 'auto',
	      padding: '8px 24px',
	      '&:first-child': {
	        // dialog without title
	        paddingTop: 20
	      }
	    },
	
	    /* Styles applied to the root element if `dividers={true}`. */
	    dividers: {
	      padding: '16px 24px',
	      borderTop: "1px solid ".concat(theme.palette.divider),
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    }
	  };
	};
	
	exports.styles = styles;
	var DialogContent = React.forwardRef(function DialogContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$dividers = props.dividers,
	      dividers = _props$dividers === void 0 ? false : _props$dividers,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "dividers"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dividers && classes.dividers),
	    ref: ref
	  }, other));
	});
	 false ? DialogContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display the top and bottom dividers.
	   */
	  dividers: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContent'
	})(DialogContent);
	
	exports.default = _default;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	
	var _DialogContent = _interopRequireDefault(__webpack_require__(759));

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    marginBottom: 12
	  }
	};
	exports.styles = styles;
	var DialogContentText = React.forwardRef(function DialogContentText(props, ref) {
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    component: "p",
	    variant: "body1",
	    color: "textSecondary",
	    ref: ref
	  }, props));
	});
	 false ? DialogContentText.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContentText'
	})(DialogContentText);
	
	exports.default = _default;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	
	var _DialogContentText = _interopRequireDefault(__webpack_require__(761));

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    margin: 0,
	    padding: '16px 24px',
	    flex: '0 0 auto'
	  }
	};
	exports.styles = styles;
	var DialogTitle = React.forwardRef(function DialogTitle(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), disableTypography ? children : /*#__PURE__*/React.createElement(_Typography.default, {
	    component: "h2",
	    variant: "h6"
	  }, children));
	});
	 false ? DialogTitle.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, this can be useful to render an h4 instead of the default h2.
	   */
	  disableTypography: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogTitle'
	})(DialogTitle);
	
	exports.default = _default;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	
	var _DialogTitle = _interopRequireDefault(__webpack_require__(763));

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _colorManipulator = __webpack_require__(41);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 1,
	      margin: 0,
	      // Reset browser default style.
	      border: 'none',
	      flexShrink: 0,
	      backgroundColor: theme.palette.divider
	    },
	
	    /* Styles applied to the root element if `absolute={true}`. */
	    absolute: {
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `variant="inset"`. */
	    inset: {
	      marginLeft: 72
	    },
	
	    /* Styles applied to the root element if `light={true}`. */
	    light: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
	    },
	
	    /* Styles applied to the root element if `variant="middle"`. */
	    middle: {
	      marginLeft: theme.spacing(2),
	      marginRight: theme.spacing(2)
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      height: '100%',
	      width: 1
	    },
	
	    /* Styles applied to the root element if `flexItem={true}`. */
	    flexItem: {
	      alignSelf: 'stretch',
	      height: 'auto'
	    }
	  };
	};
	
	exports.styles = styles;
	var Divider = React.forwardRef(function Divider(props, ref) {
	  var _props$absolute = props.absolute,
	      absolute = _props$absolute === void 0 ? false : _props$absolute,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'hr' : _props$component,
	      _props$flexItem = props.flexItem,
	      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
	      _props$light = props.light,
	      light = _props$light === void 0 ? false : _props$light,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$role = props.role,
	      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
	    role: role,
	    ref: ref
	  }, other));
	});
	 false ? Divider.propTypes = {
	  /**
	   * Absolutely position the element.
	   */
	  absolute: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, a vertical divider will have the correct height when used in flex container.
	   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
	   */
	  flexItem: _propTypes.default.bool,
	
	  /**
	   * If `true`, the divider will have a lighter color.
	   */
	  light: _propTypes.default.bool,
	
	  /**
	   * The divider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['fullWidth', 'inset', 'middle'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDivider'
	})(Divider);
	
	exports.default = _default;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(222));

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toArray2 = _interopRequireDefault(__webpack_require__(703));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(70));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ExpansionPanelContext = _interopRequireDefault(__webpack_require__(315));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(95));
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$expanded': {
	        margin: '16px 0',
	        '&:first-child': {
	          marginTop: 0
	        },
	        '&:last-child': {
	          marginBottom: 0
	        },
	        '&:before': {
	          opacity: 0
	        }
	      },
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: 0,
	      '&:first-child': {
	        borderTopLeftRadius: theme.shape.borderRadius,
	        borderTopRightRadius: theme.shape.borderRadius
	      },
	      '&:last-child': {
	        borderBottomLeftRadius: theme.shape.borderRadius,
	        borderBottomRightRadius: theme.shape.borderRadius,
	        // Fix a rendering issue on Edge
	        '@supports (-ms-ime-align: auto)': {
	          borderBottomLeftRadius: 0,
	          borderBottomRightRadius: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `expanded={true}`. */
	    expanded: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {}
	  };
	};
	
	exports.styles = styles;
	var ExpansionPanel = React.forwardRef(function ExpansionPanel(props, ref) {
	  var childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$defaultExpande = props.defaultExpanded,
	      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      expandedProp = props.expanded,
	      onChange = props.onChange,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: expandedProp,
	    default: defaultExpanded,
	    name: 'ExpansionPanel',
	    state: 'expanded'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      expanded = _useControlled2[0],
	      setExpandedState = _useControlled2[1];
	
	  var handleChange = React.useCallback(function (event) {
	    setExpandedState(!expanded);
	
	    if (onChange) {
	      onChange(event, !expanded);
	    }
	  }, [expanded, onChange, setExpandedState]);
	
	  var _React$Children$toArr = React.Children.toArray(childrenProp),
	      _React$Children$toArr2 = (0, _toArray2.default)(_React$Children$toArr),
	      summary = _React$Children$toArr2[0],
	      children = _React$Children$toArr2.slice(1);
	
	  var contextValue = React.useMemo(function () {
	    return {
	      expanded: expanded,
	      disabled: disabled,
	      toggle: handleChange
	    };
	  }, [expanded, disabled, handleChange]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
	    ref: ref,
	    square: square
	  }, other), /*#__PURE__*/React.createElement(_ExpansionPanelContext.default.Provider, {
	    value: contextValue
	  }, summary), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: expanded,
	    timeout: "auto"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    "aria-labelledby": summary.props.id,
	    id: summary.props['aria-controls'],
	    role: "region"
	  }, children)));
	});
	 false ? ExpansionPanel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node.isRequired, function (props) {
	    var summary = React.Children.toArray(props.children)[0];
	
	    if ((0, _reactIs.isFragment)(summary)) {
	      return new Error("Material-UI: the ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
	    }
	
	    if (!React.isValidElement(summary)) {
	      return new Error('Material-UI: expected the first child of ExpansionPanel to be a valid element.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {boolean} expanded The `expanded` state of the panel.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The component used for the collapse effect.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanel'
	})(ExpansionPanel);
	
	exports.default = _default;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(767));

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var ExpansionPanelActions = React.forwardRef(function ExpansionPanelActions(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableSpacing"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? ExpansionPanelActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelActions'
	})(ExpansionPanelActions);
	
	exports.default = _default;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	
	var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(769));

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      padding: theme.spacing(1, 2, 2)
	    }
	  };
	};
	
	exports.styles = styles;
	var ExpansionPanelDetails = React.forwardRef(function ExpansionPanelDetails(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? ExpansionPanelDetails.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelDetails'
	})(ExpansionPanelDetails);
	
	exports.default = _default;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(771));

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(40));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ExpansionPanelContext = _interopRequireDefault(__webpack_require__(315));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      minHeight: 8 * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: theme.spacing(0, 2),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.action.focus
	      },
	      '&$disabled': {
	        opacity: theme.palette.action.disabledOpacity
	      }
	    },
	
	    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
	    expanded: {},
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children wrapper element. */
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	
	    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
	    expandIcon: {
	      transform: 'rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var ExpansionPanelSummary = React.forwardRef(function ExpansionPanelSummary(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      expandIcon = props.expandIcon,
	      IconButtonProps = props.IconButtonProps,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocusVisible = props.onFocusVisible,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);
	
	  var _React$useState = React.useState(false),
	      focusedState = _React$useState[0],
	      setFocusedState = _React$useState[1];
	
	  var handleFocusVisible = function handleFocusVisible(event) {
	    setFocusedState(true);
	
	    if (onFocusVisible) {
	      onFocusVisible(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    setFocusedState(false);
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var _React$useContext = React.useContext(_ExpansionPanelContext.default),
	      _React$useContext$dis = _React$useContext.disabled,
	      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
	      expanded = _React$useContext.expanded,
	      toggle = _React$useContext.toggle;
	
	  var handleChange = function handleChange(event) {
	    if (toggle) {
	      toggle(event);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: false,
	    disableRipple: true,
	    disabled: disabled,
	    component: "div",
	    "aria-expanded": expanded,
	    className: (0, _clsx.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
	    onFocusVisible: handleFocusVisible,
	    onBlur: handleBlur,
	    onClick: handleChange,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.content, expanded && classes.expanded)
	  }, children), expandIcon && /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.expandIcon, expanded && classes.expanded),
	    edge: "end",
	    component: "div",
	    tabIndex: null,
	    role: null,
	    "aria-hidden": true
	  }, IconButtonProps), expandIcon));
	});
	 false ? ExpansionPanelSummary.propTypes = {
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * Props applied to the `IconButton` element wrapping the expand icon.
	   */
	  IconButtonProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocusVisible: _propTypes.default.func
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelSummary'
	})(ExpansionPanelSummary);
	
	exports.default = _default;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(773));

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minHeight: 36,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      },
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        },
	        textDecoration: 'none'
	      },
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // assure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    primary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    secondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="extended"`. */
	    extended: {
	      borderRadius: 48 / 2,
	      padding: '0 16px',
	      width: 'auto',
	      minHeight: 'auto',
	      minWidth: 48,
	      height: 48,
	      '&$sizeSmall': {
	        width: 'auto',
	        padding: '0 8px',
	        borderRadius: 34 / 2,
	        minWidth: 34,
	        height: 34
	      },
	      '&$sizeMedium': {
	        width: 'auto',
	        padding: '0 16px',
	        borderRadius: 40 / 2,
	        minWidth: 40,
	        height: 40
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `size="small"``. */
	    sizeSmall: {
	      width: 40,
	      height: 40
	    },
	
	    /* Styles applied to the root element if `size="medium"``. */
	    sizeMedium: {
	      width: 48,
	      height: 48
	    }
	  };
	};
	
	exports.styles = styles;
	var Fab = React.forwardRef(function Fab(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'large' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'round' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== "round" && classes.extended, size !== 'large' && classes["size".concat((0, _capitalize.default)(size))], disabled && classes.disabled, {
	      'primary': classes.primary,
	      'secondary': classes.secondary,
	      'inherit': classes.colorInherit
	    }[color]),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? Fab.propTypes = {
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['round', 'extended'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFab'
	})(Fab);
	
	exports.default = _default;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	
	var _Fab = _interopRequireDefault(__webpack_require__(775));

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(143);
	
	var _utils = __webpack_require__(34);
	
	var _Fade = _interopRequireDefault(__webpack_require__(316));
	
	/**
	 * @ignore - internal component.
	 */
	var StrictModeFade = React.forwardRef(function StrictModeFade(props, forwardedRef) {
	  var domRef = React.useRef(null);
	  var ref = (0, _utils.useForkRef)(domRef, forwardedRef);
	  return /*#__PURE__*/React.createElement(_Fade.default, (0, _extends2.default)({}, props, {
	    findDOMNode: function findDOMNode() {
	      return domRef.current;
	    },
	    ref: ref,
	    TransitionComponent: _reactTransitionGroup.Transition
	  }));
	});
	var _default = StrictModeFade;
	exports.default = _default;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(131));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      borderTopLeftRadius: theme.shape.borderRadius,
	      borderTopRightRadius: theme.shape.borderRadius,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '&:hover': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: backgroundColor
	        }
	      },
	      '&$focused': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
	      },
	      '&$disabled': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
	      }
	    },
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:before': {
	        borderBottom: "1px solid ".concat(theme.palette.text.primary)
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 12
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 12
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '27px 12px 10px',
	      '&$marginDense': {
	        paddingTop: 23,
	        paddingBottom: 6
	      }
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '27px 12px 10px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'dark' ? '0 0 0 100px #266798 inset' : null,
	        WebkitTextFillColor: theme.palette.type === 'dark' ? '#fff' : null,
	        borderTopLeftRadius: 'inherit',
	        borderTopRightRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 23,
	      paddingBottom: 6
	    },
	
	    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
	    inputHiddenLabel: {
	      paddingTop: 18,
	      paddingBottom: 19,
	      '&$inputMarginDense': {
	        paddingTop: 10,
	        paddingBottom: 11
	      }
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var FilledInput = React.forwardRef(function FilledInput(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? FilledInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	FilledInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFilledInput'
	})(FilledInput);
	
	exports.default = _default;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(225);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(139));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(159));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    flexDirection: 'column',
	    position: 'relative',
	    // Reset fieldset default style.
	    minWidth: 0,
	    padding: 0,
	    margin: 0,
	    border: 0,
	    verticalAlign: 'top' // Fix alignment issue on Safari.
	
	  },
	
	  /* Styles applied to the root element if `margin="normal"`. */
	  marginNormal: {
	    marginTop: 16,
	    marginBottom: 8
	  },
	
	  /* Styles applied to the root element if `margin="dense"`. */
	  marginDense: {
	    marginTop: 8,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the root element if `fullWidth={true}`. */
	  fullWidth: {
	    width: '100%'
	  }
	};
	/**
	 * Provides context such as filled/focused/error/required for form inputs.
	 * Relying on the context provides high flexibility and ensures that the state always stays
	 * consistent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 *
	 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
	 *
	 * ```jsx
	 * <FormControl>
	 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
	 *   <Input id="my-input" aria-describedby="my-helper-text" />
	 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
	 * </FormControl>
	 * ```
	 *
	 * ⚠️Only one input can be used within a FormControl.
	 */
	
	exports.styles = styles;
	var FormControl = React.forwardRef(function FormControl(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      visuallyFocused = props.focused,
	      _props$hiddenLabel = props.hiddenLabel,
	      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
	      _props$margin = props.margin,
	      margin = _props$margin === void 0 ? 'none' : _props$margin,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      size = props.size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);
	
	  var _React$useState = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialAdornedStart = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        var input = (0, _isMuiElement.default)(child, ['Select']) ? child.props.input : child;
	
	        if (input && (0, _utils.isAdornedStart)(input.props)) {
	          initialAdornedStart = true;
	        }
	      });
	    }
	
	    return initialAdornedStart;
	  }),
	      adornedStart = _React$useState[0],
	      setAdornedStart = _React$useState[1];
	
	  var _React$useState2 = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialFilled = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        if ((0, _utils.isFilled)(child.props, true)) {
	          initialFilled = true;
	        }
	      });
	    }
	
	    return initialFilled;
	  }),
	      filled = _React$useState2[0],
	      setFilled = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      _focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
	
	  if (disabled && focused) {
	    setFocused(false);
	  }
	
	  var registerEffect;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var registeredInput = React.useRef(false);
	
	    registerEffect = function registerEffect() {
	      if (registeredInput.current) {
	        console.error(['Material-UI: there are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
	      }
	
	      registeredInput.current = true;
	      return function () {
	        registeredInput.current = false;
	      };
	    };
	  }
	
	  var onFilled = React.useCallback(function () {
	    setFilled(true);
	  }, []);
	  var onEmpty = React.useCallback(function () {
	    setFilled(false);
	  }, []);
	  var childContext = {
	    adornedStart: adornedStart,
	    setAdornedStart: setAdornedStart,
	    color: color,
	    disabled: disabled,
	    error: error,
	    filled: filled,
	    focused: focused,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    margin: (size === 'small' ? 'dense' : undefined) || margin,
	    onBlur: function onBlur() {
	      setFocused(false);
	    },
	    onEmpty: onEmpty,
	    onFilled: onFilled,
	    onFocus: function onFocus() {
	      setFocused(true);
	    },
	    registerEffect: registerEffect,
	    required: required,
	    variant: variant
	  };
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, _capitalize.default)(margin))], fullWidth && classes.fullWidth),
	    ref: ref
	  }, other), children));
	});
	 false ? FormControl.propTypes = {
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be displayed in focused state.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be hidden.
	   * This is used to increase density for a `FilledInput`.
	   * Be sure to add `aria-label` to the `input` element.
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControl'
	})(FormControl);
	
	exports.default = _default;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _FormControl = __webpack_require__(224);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      cursor: 'pointer',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      WebkitTapHighlightColor: 'transparent',
	      marginLeft: -11,
	      marginRight: 16,
	      // used for row presentation of radio/checkbox
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `labelPlacement="start"`. */
	    labelPlacementStart: {
	      flexDirection: 'row-reverse',
	      marginLeft: 16,
	      // used for row presentation of radio/checkbox
	      marginRight: -11
	    },
	
	    /* Styles applied to the root element if `labelPlacement="top"`. */
	    labelPlacementTop: {
	      flexDirection: 'column-reverse',
	      marginLeft: 16
	    },
	
	    /* Styles applied to the root element if `labelPlacement="bottom"`. */
	    labelPlacementBottom: {
	      flexDirection: 'column',
	      marginLeft: 16
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the label's Typography component. */
	    label: {
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    }
	  };
	};
	/**
	 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
	 * Use this component if you want to display an extra label.
	 */
	
	
	exports.styles = styles;
	var FormControlLabel = React.forwardRef(function FormControlLabel(props, ref) {
	  var checked = props.checked,
	      classes = props.classes,
	      className = props.className,
	      control = props.control,
	      disabledProp = props.disabled,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$labelPlacement = props.labelPlacement,
	      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
	      name = props.name,
	      onChange = props.onChange,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
	  var muiFormControl = (0, _FormControl.useFormControl)();
	  var disabled = disabledProp;
	
	  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
	    disabled = control.props.disabled;
	  }
	
	  if (typeof disabled === 'undefined' && muiFormControl) {
	    disabled = muiFormControl.disabled;
	  }
	
	  var controlProps = {
	    disabled: disabled
	  };
	  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
	    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
	      controlProps[key] = props[key];
	    }
	  });
	  return /*#__PURE__*/React.createElement("label", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0, _capitalize.default)(labelPlacement))], disabled && classes.disabled),
	    ref: ref
	  }, other), React.cloneElement(control, controlProps), /*#__PURE__*/React.createElement(_Typography.default, {
	    component: "span",
	    className: (0, _clsx.default)(classes.label, disabled && classes.disabled)
	  }, label));
	});
	 false ? FormControlLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component appears selected.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
	   */
	  control: _propTypes.default.element.isRequired,
	
	  /**
	   * If `true`, the control will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The text to be used in an enclosing label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The position of the label.
	   */
	  labelPlacement: _propTypes.default.oneOf(['bottom', 'end', 'start', 'top']),
	
	  /**
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControlLabel'
	})(FormControlLabel);
	
	exports.default = _default;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	
	var _FormControlLabel = _interopRequireDefault(__webpack_require__(780));

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    flexWrap: 'wrap'
	  },
	
	  /* Styles applied to the root element if `row={true}`. */
	  row: {
	    flexDirection: 'row'
	  }
	};
	/**
	 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
	 * It provides compact row layout.
	 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
	 */
	
	exports.styles = styles;
	var FormGroup = React.forwardRef(function FormGroup(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$row = props.row,
	      row = _props$row === void 0 ? false : _props$row,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "row"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, row && classes.row),
	    ref: ref
	  }, other));
	});
	 false ? FormGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display group of elements in a compact row.
	   */
	  row: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormGroup'
	})(FormGroup);
	
	exports.default = _default;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(110));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(92));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.caption, {
	      textAlign: 'left',
	      marginTop: 3,
	      margin: 0,
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      marginTop: 4
	    },
	
	    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
	    contained: {
	      marginLeft: 14,
	      marginRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {}
	  };
	};
	
	exports.styles = styles;
	var FormHelperText = React.forwardRef(function FormHelperText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'p' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      margin = props.margin,
	      required = props.required,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), children === ' ' ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : children);
	});
	 false ? FormHelperText.propTypes = {
	  /**
	   * The content of the component.
	   *
	   * If `' '` is provided, the component reserves one line height for displaying a future message.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, helper text should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use focused classes key.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * If `true`, the helper text should use required classes key.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormHelperText'
	})(FormHelperText);
	
	exports.default = _default;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(110));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(92));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.body1, {
	      lineHeight: 1,
	      padding: 0,
	      '&$focused': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused': {
	        color: theme.palette.secondary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Styles applied to the asterisk element. */
	    asterisk: {
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var FormLabel = React.forwardRef(function FormLabel(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'label' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      required = props.required,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
	    ref: ref
	  }, other), children, fcs.required && /*#__PURE__*/React.createElement("span", {
	    "aria-hidden": true,
	    className: (0, _clsx.default)(classes.asterisk, fcs.error && classes.error)
	  }, "\u2009", '*'));
	});
	 false ? FormLabel.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormLabel'
	})(FormLabel);
	
	exports.default = _default;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(358));
	
	// A grid component using the following libs as inspiration.
	//
	// For the implementation:
	// - https://getbootstrap.com/docs/4.3/layout/grid/
	// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
	// - https://github.com/roylee0704/react-flexbox-grid
	// - https://material.angularjs.org/latest/layout/introduction
	//
	// Follow this flexbox Guide to better understand the underlying model:
	// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
	var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	function generateGrid(globalStyles, theme, breakpoint) {
	  var styles = {};
	  GRID_SIZES.forEach(function (size) {
	    var key = "grid-".concat(breakpoint, "-").concat(size);
	
	    if (size === true) {
	      // For the auto layouting
	      styles[key] = {
	        flexBasis: 0,
	        flexGrow: 1,
	        maxWidth: '100%'
	      };
	      return;
	    }
	
	    if (size === 'auto') {
	      styles[key] = {
	        flexBasis: 'auto',
	        flexGrow: 0,
	        maxWidth: 'none'
	      };
	      return;
	    } // Keep 7 significant numbers.
	
	
	    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
	    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
	
	    styles[key] = {
	      flexBasis: width,
	      flexGrow: 0,
	      maxWidth: width
	    };
	  }); // No need for a media query for the first size.
	
	  if (breakpoint === 'xs') {
	    (0, _extends2.default)(globalStyles, styles);
	  } else {
	    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
	  }
	}
	
	function getOffset(val) {
	  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var parse = parseFloat(val);
	  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
	}
	
	function generateGutter(theme, breakpoint) {
	  var styles = {};
	  SPACINGS.forEach(function (spacing) {
	    var themeSpacing = theme.spacing(spacing);
	
	    if (themeSpacing === 0) {
	      return;
	    }
	
	    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
	      margin: "-".concat(getOffset(themeSpacing, 2)),
	      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
	      '& > $item': {
	        padding: getOffset(themeSpacing, 2)
	      }
	    };
	  });
	  return styles;
	} // Default CSS values
	// flex: '0 1 auto',
	// flexDirection: 'row',
	// alignItems: 'flex-start',
	// flexWrap: 'nowrap',
	// justifyContent: 'flex-start',
	
	
	var styles = function styles(theme) {
	  return (0, _extends2.default)({
	    /* Styles applied to the root element */
	    root: {},
	
	    /* Styles applied to the root element if `container={true}`. */
	    container: {
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexWrap: 'wrap',
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `item={true}`. */
	    item: {
	      boxSizing: 'border-box',
	      margin: '0' // For instance, it's useful when used with a `figure` element.
	
	    },
	
	    /* Styles applied to the root element if `zeroMinWidth={true}`. */
	    zeroMinWidth: {
	      minWidth: 0
	    },
	
	    /* Styles applied to the root element if `direction="column"`. */
	    'direction-xs-column': {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the root element if `direction="column-reverse"`. */
	    'direction-xs-column-reverse': {
	      flexDirection: 'column-reverse'
	    },
	
	    /* Styles applied to the root element if `direction="row-reverse"`. */
	    'direction-xs-row-reverse': {
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `wrap="nowrap"`. */
	    'wrap-xs-nowrap': {
	      flexWrap: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `wrap="reverse"`. */
	    'wrap-xs-wrap-reverse': {
	      flexWrap: 'wrap-reverse'
	    },
	
	    /* Styles applied to the root element if `alignItems="center"`. */
	    'align-items-xs-center': {
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-start"`. */
	    'align-items-xs-flex-start': {
	      alignItems: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-end"`. */
	    'align-items-xs-flex-end': {
	      alignItems: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignItems="baseline"`. */
	    'align-items-xs-baseline': {
	      alignItems: 'baseline'
	    },
	
	    /* Styles applied to the root element if `alignContent="center"`. */
	    'align-content-xs-center': {
	      alignContent: 'center'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-start"`. */
	    'align-content-xs-flex-start': {
	      alignContent: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-end"`. */
	    'align-content-xs-flex-end': {
	      alignContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-between"`. */
	    'align-content-xs-space-between': {
	      alignContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-around"`. */
	    'align-content-xs-space-around': {
	      alignContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="center"`. */
	    'justify-xs-center': {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the root element if `justify="flex-end"`. */
	    'justify-xs-flex-end': {
	      justifyContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `justify="space-between"`. */
	    'justify-xs-space-between': {
	      justifyContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `justify="space-around"`. */
	    'justify-xs-space-around': {
	      justifyContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="space-evenly"`. */
	    'justify-xs-space-evenly': {
	      justifyContent: 'space-evenly'
	    }
	  }, generateGutter(theme, 'xs'), {}, theme.breakpoints.keys.reduce(function (accumulator, key) {
	    // Use side effect over immutability for better performance.
	    generateGrid(accumulator, theme, key);
	    return accumulator;
	  }, {}));
	};
	
	exports.styles = styles;
	var Grid = React.forwardRef(function Grid(props, ref) {
	  var _props$alignContent = props.alignContent,
	      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
	      _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$container = props.container,
	      container = _props$container === void 0 ? false : _props$container,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'row' : _props$direction,
	      _props$item = props.item,
	      item = _props$item === void 0 ? false : _props$item,
	      _props$justify = props.justify,
	      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
	      _props$lg = props.lg,
	      lg = _props$lg === void 0 ? false : _props$lg,
	      _props$md = props.md,
	      md = _props$md === void 0 ? false : _props$md,
	      _props$sm = props.sm,
	      sm = _props$sm === void 0 ? false : _props$sm,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
	      _props$wrap = props.wrap,
	      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
	      _props$xl = props.xl,
	      xl = _props$xl === void 0 ? false : _props$xl,
	      _props$xs = props.xs,
	      xs = _props$xs === void 0 ? false : _props$xs,
	      _props$zeroMinWidth = props.zeroMinWidth,
	      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
	  var className = (0, _clsx.default)(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other));
	});
	 false ? Grid.propTypes = {
	  /**
	   * Defines the `align-content` style property.
	   * It's applied for all screen sizes.
	   */
	  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
	
	  /**
	   * Defines the `align-items` style property.
	   * It's applied for all screen sizes.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the component will have the flex *container* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  container: _propTypes.default.bool,
	
	  /**
	   * Defines the `flex-direction` style property.
	   * It is applied for all screen sizes.
	   */
	  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	
	  /**
	   * If `true`, the component will have the flex *item* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  item: _propTypes.default.bool,
	
	  /**
	   * Defines the `justify-content` style property.
	   * It is applied for all screen sizes.
	   */
	  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `lg` breakpoint and wider screens if not overridden.
	   */
	  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `md` breakpoint and wider screens if not overridden.
	   */
	  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `sm` breakpoint and wider screens if not overridden.
	   */
	  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the space between the type `item` component.
	   * It can only be used on a type `container` component.
	   */
	  spacing: _propTypes.default.oneOf(SPACINGS),
	
	  /**
	   * Defines the `flex-wrap` style property.
	   * It's applied for all screen sizes.
	   */
	  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `xl` breakpoint and wider screens.
	   */
	  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for all the screen sizes with the lowest priority.
	   */
	  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * If `true`, it sets `min-width: 0` on the item.
	   * Refer to the limitations section of the documentation to better understand the use case.
	   */
	  zeroMinWidth: _propTypes.default.bool
	} : void 0;
	var StyledGrid = (0, _withStyles.default)(styles, {
	  name: 'MuiGrid'
	})(Grid);
	
	if (false) {
	  var requireProp = (0, _requirePropFactory.default)('Grid');
	  StyledGrid.propTypes = (0, _extends2.default)({}, StyledGrid.propTypes, {
	    alignContent: requireProp('container'),
	    alignItems: requireProp('container'),
	    direction: requireProp('container'),
	    justify: requireProp('container'),
	    lg: requireProp('item'),
	    md: requireProp('item'),
	    sm: requireProp('item'),
	    spacing: requireProp('container'),
	    wrap: requireProp('container'),
	    xs: requireProp('item'),
	    zeroMinWidth: requireProp('item')
	  });
	}
	
	var _default = StyledGrid;
	exports.default = _default;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    listStyle: 'none',
	    padding: 0,
	    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	
	  }
	};
	exports.styles = styles;
	var GridList = React.forwardRef(function GridList(props, ref) {
	  var _props$cellHeight = props.cellHeight,
	      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 2 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    style: (0, _extends2.default)({
	      margin: -spacing / 2
	    }, style)
	  }, other), React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childCols = child.props.cols || 1;
	    var childRows = child.props.rows || 1;
	    return React.cloneElement(child, {
	      style: (0, _extends2.default)({
	        width: "".concat(100 / cols * childCols, "%"),
	        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
	        padding: spacing / 2
	      }, child.props.style)
	    });
	  }));
	});
	 false ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Number of px for the spacing between tiles.
	   */
	  spacing: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridList'
	})(GridList);
	
	exports.default = _default;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	
	var _GridList = _interopRequireDefault(__webpack_require__(786));

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _debounce = _interopRequireDefault(__webpack_require__(93));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(139));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    boxSizing: 'border-box',
	    flexShrink: 0
	  },
	
	  /* Styles applied to the `div` element that wraps the children. */
	  tile: {
	    position: 'relative',
	    display: 'block',
	    // In case it's not rendered with a div.
	    height: '100%',
	    overflow: 'hidden'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullHeight: {
	    height: '100%',
	    transform: 'translateX(-50%)',
	    position: 'relative',
	    left: '50%'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullWidth: {
	    width: '100%',
	    position: 'relative',
	    transform: 'translateY(-50%)',
	    top: '50%'
	  }
	};
	exports.styles = styles;
	
	var fit = function fit(imgEl, classes) {
	  if (!imgEl || !imgEl.complete) {
	    return;
	  }
	
	  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
	    var _imgEl$classList, _imgEl$classList2;
	
	    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	
	    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	  } else {
	    var _imgEl$classList3, _imgEl$classList4;
	
	    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	
	    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	  }
	};
	
	function ensureImageCover(imgEl, classes) {
	  if (!imgEl) {
	    return;
	  }
	
	  if (imgEl.complete) {
	    fit(imgEl, classes);
	  } else {
	    imgEl.addEventListener('load', function () {
	      fit(imgEl, classes);
	    });
	  }
	}
	
	var GridListTile = React.forwardRef(function GridListTile(props, ref) {
	  // cols rows default values are for docs only
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 1 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$rows = props.rows,
	      rows = _props$rows === void 0 ? 1 : _props$rows,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "cols", "component", "rows"]);
	  var imgRef = React.useRef(null);
	  React.useEffect(function () {
	    ensureImageCover(imgRef.current, classes);
	  });
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      fit(imgRef.current, classes);
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [classes]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: classes.tile
	  }, React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (child.type === 'img' || (0, _isMuiElement.default)(child, ['Image'])) {
	      return React.cloneElement(child, {
	        ref: imgRef
	      });
	    }
	
	    return child;
	  })));
	});
	 false ? GridListTile.propTypes = {
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in which case GridListTile takes care of making the image "cover" available space
	   * (similar to `background-size: cover` or to `object-fit: cover`).
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTile'
	})(GridListTile);
	
	exports.default = _default;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	
	var _GridListTile = _interopRequireDefault(__webpack_require__(788));

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: 48,
	      background: 'rgba(0, 0, 0, 0.5)',
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Styles applied to the root element if `titlePosition="bottom"`. */
	    titlePositionBottom: {
	      bottom: 0
	    },
	
	    /* Styles applied to the root element if `titlePosition="top"`. */
	    titlePositionTop: {
	      top: 0
	    },
	
	    /* Styles applied to the root element if a `subtitle` is provided. */
	    rootSubtitle: {
	      height: 68
	    },
	
	    /* Styles applied to the title and subtitle container element. */
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: 16,
	      marginRight: 16,
	      color: theme.palette.common.white,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the container element if `actionPosition="left"`. */
	    titleWrapActionPosLeft: {
	      marginLeft: 0
	    },
	
	    /* Styles applied to the container element if `actionPosition="right"`. */
	    titleWrapActionPosRight: {
	      marginRight: 0
	    },
	
	    /* Styles applied to the title container element. */
	    title: {
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '24px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the subtitle container element. */
	    subtitle: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1,
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the actionIcon if supplied. */
	    actionIcon: {},
	
	    /* Styles applied to the actionIcon if `actionPosition="left"`. */
	    actionIconActionPosLeft: {
	      order: -1
	    }
	  };
	};
	
	exports.styles = styles;
	var GridListTileBar = React.forwardRef(function GridListTileBar(props, ref) {
	  var actionIcon = props.actionIcon,
	      _props$actionPosition = props.actionPosition,
	      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
	      classes = props.classes,
	      className = props.className,
	      subtitle = props.subtitle,
	      title = props.title,
	      _props$titlePosition = props.titlePosition,
	      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
	      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
	  var actionPos = actionIcon && actionPosition;
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.titleWrap, {
	      'left': classes.titleWrapActionPosLeft,
	      'right': classes.titleWrapActionPosRight
	    }[actionPos])
	  }, /*#__PURE__*/React.createElement("div", {
	    className: classes.title
	  }, title), subtitle ? /*#__PURE__*/React.createElement("div", {
	    className: classes.subtitle
	  }, subtitle) : null), actionIcon ? /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.actionIcon, actionPos === 'left' && classes.actionIconActionPosLeft)
	  }, actionIcon) : null);
	});
	 false ? GridListTileBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes.default.node,
	
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes.default.node,
	
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * Position of the title bar.
	   */
	  titlePosition: _propTypes.default.oneOf(['bottom', 'top'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTileBar'
	})(GridListTileBar);
	
	exports.default = _default;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	
	var _GridListTileBar = _interopRequireDefault(__webpack_require__(790));

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(143);
	
	var _utils = __webpack_require__(34);
	
	var _Grow = _interopRequireDefault(__webpack_require__(320));
	
	/**
	 * @ignore - internal component.
	 */
	var StrictModeGrow = React.forwardRef(function StrictModeGrow(props, forwardedRef) {
	  var domRef = React.useRef(null);
	  var ref = (0, _utils.useForkRef)(domRef, forwardedRef);
	  return /*#__PURE__*/React.createElement(_Grow.default, (0, _extends2.default)({}, props, {
	    findDOMNode: function findDOMNode() {
	      return domRef.current;
	    },
	    ref: ref,
	    TransitionComponent: _reactTransitionGroup.Transition
	  }));
	});
	var _default = StrictModeGrow;
	exports.default = _default;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _HiddenJs = _interopRequireDefault(__webpack_require__(795));
	
	var _HiddenCss = _interopRequireDefault(__webpack_require__(794));
	
	/**
	 * Responsively hides children based on the selected implementation.
	 */
	function Hidden(props) {
	  var _props$implementation = props.implementation,
	      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
	      _props$lgDown = props.lgDown,
	      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
	      _props$lgUp = props.lgUp,
	      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
	      _props$mdDown = props.mdDown,
	      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
	      _props$mdUp = props.mdUp,
	      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
	      _props$smDown = props.smDown,
	      smDown = _props$smDown === void 0 ? false : _props$smDown,
	      _props$smUp = props.smUp,
	      smUp = _props$smUp === void 0 ? false : _props$smUp,
	      _props$xlDown = props.xlDown,
	      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
	      _props$xlUp = props.xlUp,
	      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
	      _props$xsDown = props.xsDown,
	      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
	      _props$xsUp = props.xsUp,
	      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
	      other = (0, _objectWithoutProperties2.default)(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
	
	  if (implementation === 'js') {
	    return /*#__PURE__*/React.createElement(_HiddenJs.default, (0, _extends2.default)({
	      lgDown: lgDown,
	      lgUp: lgUp,
	      mdDown: mdDown,
	      mdUp: mdUp,
	      smDown: smDown,
	      smUp: smUp,
	      xlDown: xlDown,
	      xlUp: xlUp,
	      xsDown: xsDown,
	      xsUp: xsUp
	    }, other));
	  }
	
	  return /*#__PURE__*/React.createElement(_HiddenCss.default, (0, _extends2.default)({
	    lgDown: lgDown,
	    lgUp: lgUp,
	    mdDown: mdDown,
	    mdUp: mdUp,
	    smDown: smDown,
	    smUp: smUp,
	    xlDown: xlDown,
	    xlUp: xlUp,
	    xsDown: xsDown,
	    xsUp: xsUp
	  }, other));
	}
	
	 false ? Hidden.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	var _default = Hidden;
	exports.default = _default;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var styles = function styles(theme) {
	  var hidden = {
	    display: 'none'
	  };
	  return theme.breakpoints.keys.reduce(function (acc, key) {
	    acc["only".concat((0, _capitalize.default)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
	    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
	    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
	    return acc;
	  }, {});
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function HiddenCss(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      only = props.only,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "only"]);
	  var theme = (0, _useTheme.default)();
	
	  if (false) {
	    var unknownProps = Object.keys(other).filter(function (propName) {
	      var isUndeclaredBreakpoint = !theme.breakpoints.keys.some(function (breakpoint) {
	        return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
	      });
	      return isUndeclaredBreakpoint;
	    });
	
	    if (unknownProps.length > 0) {
	      console.error("Material-UI: unsupported props received by `<Hidden implementation=\"css\" />`: ".concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
	    }
	  }
	
	  var clsx = [];
	
	  if (className) {
	    clsx.push(className);
	  }
	
	  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
	    var breakpoint = theme.breakpoints.keys[i];
	    var breakpointUp = props["".concat(breakpoint, "Up")];
	    var breakpointDown = props["".concat(breakpoint, "Down")];
	
	    if (breakpointUp) {
	      clsx.push(classes["".concat(breakpoint, "Up")]);
	    }
	
	    if (breakpointDown) {
	      clsx.push(classes["".concat(breakpoint, "Down")]);
	    }
	  }
	
	  if (only) {
	    var onlyBreakpoints = Array.isArray(only) ? only : [only];
	    onlyBreakpoints.forEach(function (breakpoint) {
	      clsx.push(classes["only".concat((0, _capitalize.default)(breakpoint))]);
	    });
	  }
	
	  return /*#__PURE__*/React.createElement("div", {
	    className: clsx.join(' ')
	  }, children);
	}
	
	 false ? HiddenCss.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateHiddenCss'
	})(HiddenCss);
	
	exports.default = _default;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(21);
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(239));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenJs(props) {
	  var children = props.children,
	      only = props.only,
	      width = props.width;
	  var theme = (0, _useTheme.default)();
	  var visible = true; // `only` check is faster to get out sooner if used.
	
	  if (only) {
	    if (Array.isArray(only)) {
	      for (var i = 0; i < only.length; i += 1) {
	        var breakpoint = only[i];
	
	        if (width === breakpoint) {
	          visible = false;
	          break;
	        }
	      }
	    } else if (only && width === only) {
	      visible = false;
	    }
	  } // Allow `only` to be combined with other props. If already hidden, no need to check others.
	
	
	  if (visible) {
	    // determine visibility based on the smallest size up
	    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
	      var _breakpoint = theme.breakpoints.keys[_i];
	      var breakpointUp = props["".concat(_breakpoint, "Up")];
	      var breakpointDown = props["".concat(_breakpoint, "Down")];
	
	      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
	        visible = false;
	        break;
	      }
	    }
	  }
	
	  if (!visible) {
	    return null;
	  }
	
	  return children;
	}
	
	HiddenJs.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * width prop provided by withWidth decorator.
	   */
	  width: _propTypes.default.string.isRequired,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	};
	
	if (false) {
	  HiddenJs.propTypes = (0, _utils.exactProp)(HiddenJs.propTypes);
	}
	
	var _default = (0, _withWidth.default)()(HiddenJs);
	
	exports.default = _default;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	
	var _Hidden = _interopRequireDefault(__webpack_require__(793));

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      fontSize: theme.typography.pxToRem(24),
	      width: '1em',
	      height: '1em',
	      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
	      // To remove at some point.
	      overflow: 'hidden',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(36)
	    }
	  };
	};
	
	exports.styles = styles;
	var Icon = React.forwardRef(function Icon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "fontSize"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    "aria-hidden": true,
	    ref: ref
	  }, other));
	});
	 false ? Icon.propTypes = {
	  /**
	   * The name of the icon font ligature.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
	} : void 0;
	Icon.muiName = 'Icon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIcon'
	})(Icon);
	
	exports.default = _default;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	
	var _Icon = _interopRequireDefault(__webpack_require__(797));

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      padding: 12,
	      borderRadius: '50%',
	      overflow: 'visible',
	      // Explicitly set the default value to solve a bug on IE 11.
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: 'transparent',
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -12,
	      '$sizeSmall&': {
	        marginLeft: -3
	      }
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -12,
	      '$sizeSmall&': {
	        marginRight: -3
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: 3,
	      fontSize: theme.typography.pxToRem(18)
	    },
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/components/icons/) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	var IconButton = React.forwardRef(function IconButton(props, ref) {
	  var _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, _capitalize.default)(size))], {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge]),
	    centerRipple: true,
	    focusRipple: !disableFocusRipple,
	    disabled: disabled,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? IconButton.propTypes = {
	  /**
	   * The icon element.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var found = React.Children.toArray(props.children).some(function (child) {
	      return React.isValidElement(child) && child.props.onClick;
	    });
	
	    if (found) {
	      return new Error(['Material-UI: you are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['start', 'end', false]),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(131));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      'label + &': {
	        marginTop: 16
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:not($disabled):before': {
	        borderBottom: "2px solid ".concat(theme.palette.text.primary),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          borderBottom: "1px solid ".concat(bottomLineColor)
	        }
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {},
	
	    /* Styles applied to the `input` element. */
	    input: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {},
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {},
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {}
	  };
	};
	
	exports.styles = styles;
	var Input = React.forwardRef(function Input(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? Input.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	Input.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInput'
	})(Input);
	
	exports.default = _default;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(159));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    height: '0.01em',
	    // Fix IE 11 flexbox alignment. To remove at some point.
	    maxHeight: '2em',
	    alignItems: 'center',
	    whiteSpace: 'nowrap'
	  },
	
	  /* Styles applied to the root element if `variant="filled"`. */
	  filled: {
	    '&$positionStart:not($hiddenLabel)': {
	      marginTop: 16
	    }
	  },
	
	  /* Styles applied to the root element if `position="start"`. */
	  positionStart: {
	    marginRight: 8
	  },
	
	  /* Styles applied to the root element if `position="end"`. */
	  positionEnd: {
	    marginLeft: 8
	  },
	
	  /* Styles applied to the root element if `disablePointerEvents=true`. */
	  disablePointerEvents: {
	    pointerEvents: 'none'
	  },
	
	  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
	  hiddenLabel: {},
	
	  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
	  marginDense: {}
	};
	exports.styles = styles;
	var InputAdornment = React.forwardRef(function InputAdornment(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disablePointer = props.disablePointerEvents,
	      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      position = props.position,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);
	  var muiFormControl = (0, _FormControlContext.useFormControl)() || {};
	  var variant = variantProp;
	
	  if (variantProp && muiFormControl.variant) {
	    if (false) {
	      if (variantProp === muiFormControl.variant) {
	        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
	      }
	    }
	  }
	
	  if (muiFormControl && !variant) {
	    variant = muiFormControl.variant;
	  }
	
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, {
	      'start': classes.positionStart,
	      'end': classes.positionEnd
	    }[position], muiFormControl.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "textSecondary"
	  }, children) : children));
	});
	 false ? InputAdornment.propTypes = {
	  /**
	   * The content of the component, normally an `IconButton` or string.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Disable pointer events on the root.
	   * This allows for the content of the adornment to focus the input on click.
	   */
	  disablePointerEvents: _propTypes.default.bool,
	
	  /**
	   * If children is a string then disable wrapping in a Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  muiFormControl: _propTypes.default.object,
	
	  /**
	   * The position this adornment should appear relative to the `Input`.
	   */
	  position: _propTypes.default.oneOf(['start', 'end']),
	
	  /**
	   * The variant to use.
	   * Note: If you are using the `TextField` component or the `FormControl` component
	   * you do not have to set this manually.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputAdornment'
	})(InputAdornment);
	
	exports.default = _default;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	
	var _InputAdornment = _interopRequireDefault(__webpack_require__(801));

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _formControlState = _interopRequireDefault(__webpack_require__(110));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(159));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(337));
	
	var _utils2 = __webpack_require__(225);
	
	/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var placeholder = {
	    color: 'currentColor',
	    opacity: light ? 0.42 : 0.5,
	    transition: theme.transitions.create('opacity', {
	      duration: theme.transitions.duration.shorter
	    })
	  };
	  var placeholderHidden = {
	    opacity: '0 !important'
	  };
	  var placeholderVisible = {
	    opacity: light ? 0.42 : 0.5
	  };
	  return {
	    '@global': {
	      '@keyframes mui-auto-fill': {
	        from: {}
	      },
	      '@keyframes mui-auto-fill-cancel': {
	        from: {}
	      }
	    },
	
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body1, {
	      color: theme.palette.text.primary,
	      lineHeight: '1.1876em',
	      // Reset (19px), match the native input line-height
	      boxSizing: 'border-box',
	      // Prevent padding issue with fullWidth.
	      position: 'relative',
	      cursor: 'text',
	      display: 'inline-flex',
	      alignItems: 'center',
	      '&$disabled': {
	        color: theme.palette.text.disabled,
	        cursor: 'default'
	      }
	    }),
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {},
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {},
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      '&$marginDense': {
	        paddingTop: 4 - 1
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      font: 'inherit',
	      color: 'currentColor',
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      border: 0,
	      boxSizing: 'content-box',
	      background: 'none',
	      height: '1.1876em',
	      // Reset (19px), match the native input line-height
	      margin: 0,
	      // Reset for Safari
	      WebkitTapHighlightColor: 'transparent',
	      display: 'block',
	      // Make the flex item shrink with Firefox
	      minWidth: 0,
	      width: '100%',
	      // Fix IE 11 width issue
	      animationName: 'mui-auto-fill-cancel',
	      '&::-webkit-input-placeholder': placeholder,
	      '&::-moz-placeholder': placeholder,
	      // Firefox 19+
	      '&:-ms-input-placeholder': placeholder,
	      // IE 11
	      '&::-ms-input-placeholder': placeholder,
	      // Edge
	      '&:focus': {
	        outline: 0
	      },
	      // Reset Firefox invalid required input style
	      '&:invalid': {
	        boxShadow: 'none'
	      },
	      '&::-webkit-search-decoration': {
	        // Remove the padding when type=search.
	        '-webkit-appearance': 'none'
	      },
	      // Show and hide the placeholder logic
	      'label[data-shrink=false] + $formControl &': {
	        '&::-webkit-input-placeholder': placeholderHidden,
	        '&::-moz-placeholder': placeholderHidden,
	        // Firefox 19+
	        '&:-ms-input-placeholder': placeholderHidden,
	        // IE 11
	        '&::-ms-input-placeholder': placeholderHidden,
	        // Edge
	        '&:focus::-webkit-input-placeholder': placeholderVisible,
	        '&:focus::-moz-placeholder': placeholderVisible,
	        // Firefox 19+
	        '&:focus:-ms-input-placeholder': placeholderVisible,
	        // IE 11
	        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
	
	      },
	      '&$disabled': {
	        opacity: 1 // Reset iOS opacity
	
	      },
	      '&:-webkit-autofill': {
	        animationDuration: '5000s',
	        animationName: 'mui-auto-fill'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 4 - 1
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      height: 'auto',
	      resize: 'none',
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {
	      // Improve type search style.
	      '-moz-appearance': 'textfield',
	      '-webkit-appearance': 'textfield'
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {},
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {},
	
	    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
	    inputHiddenLabel: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * `InputBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating an input.
	 * It contains a load of style reset and some state logic.
	 */
	
	var InputBase = React.forwardRef(function InputBase(props, ref) {
	  var ariaDescribedby = props['aria-describedby'],
	      autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      endAdornment = props.endAdornment,
	      error = props.error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      id = props.id,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$inputProps = props.inputProps,
	      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
	      inputRefProp = props.inputRef,
	      margin = props.margin,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      placeholder = props.placeholder,
	      readOnly = props.readOnly,
	      renderSuffix = props.renderSuffix,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      rowsMin = props.rowsMin,
	      startAdornment = props.startAdornment,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      valueProp = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]);
	  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef();
	  var handleInputRefWarning = React.useCallback(function (instance) {
	    if (false) {
	      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
	        console.error(['Material-UI: you have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
	      }
	    }
	  }, []);
	  var handleInputPropsRefProp = (0, _useForkRef.default)(inputPropsProp.ref, handleInputRefWarning);
	  var handleInputRefProp = (0, _useForkRef.default)(inputRefProp, handleInputPropsRefProp);
	  var handleInputRef = (0, _useForkRef.default)(inputRef, handleInputRefProp);
	
	  var _React$useState = React.useState(false),
	      focused = _React$useState[0],
	      setFocused = _React$useState[1];
	
	  var muiFormControl = (0, _FormControlContext.useFormControl)();
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (muiFormControl) {
	        return muiFormControl.registerEffect();
	      }
	
	      return undefined;
	    }, [muiFormControl]);
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
	  });
	  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
	  // We need to book keep the focused state manually.
	
	  React.useEffect(function () {
	    if (!muiFormControl && disabled && focused) {
	      setFocused(false);
	
	      if (onBlur) {
	        onBlur();
	      }
	    }
	  }, [muiFormControl, disabled, focused, onBlur]);
	  var onFilled = muiFormControl && muiFormControl.onFilled;
	  var onEmpty = muiFormControl && muiFormControl.onEmpty;
	  var checkDirty = React.useCallback(function (obj) {
	    if ((0, _utils2.isFilled)(obj)) {
	      if (onFilled) {
	        onFilled();
	      }
	    } else if (onEmpty) {
	      onEmpty();
	    }
	  }, [onFilled, onEmpty]);
	  useEnhancedEffect(function () {
	    if (isControlled) {
	      checkDirty({
	        value: value
	      });
	    }
	  }, [value, checkDirty, isControlled]);
	
	  var handleFocus = function handleFocus(event) {
	    // Fix a bug with IE 11 where the focus/blur events are triggered
	    // while the input is disabled.
	    if (fcs.disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (inputPropsProp.onFocus) {
	      inputPropsProp.onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    } else {
	      setFocused(true);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (inputPropsProp.onBlur) {
	      inputPropsProp.onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    } else {
	      setFocused(false);
	    }
	  };
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      var element = event.target || inputRef.current;
	
	      if (element == null) {
	        throw new TypeError('Material-UI: Expected valid input target. ' + 'Did you use a custom `inputComponent` and forget to forward refs? ' + 'See https://material-ui.com/r/input-component-ref-interface for more info.');
	      }
	
	      checkDirty({
	        value: element.value
	      });
	    }
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (inputPropsProp.onChange) {
	      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
	    } // Perform in the willUpdate
	
	
	    if (onChange) {
	      onChange.apply(void 0, [event].concat(args));
	    }
	  }; // Check the input state on mount, in case it was filled by the user
	  // or auto filled by the browser before the hydration (for SSR).
	
	
	  React.useEffect(function () {
	    checkDirty(inputRef.current);
	  }, []); // eslint-disable-line react-hooks/exhaustive-deps
	
	  var handleClick = function handleClick(event) {
	    if (inputRef.current && event.currentTarget === event.target) {
	      inputRef.current.focus();
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var InputComponent = inputComponent;
	  var inputProps = (0, _extends2.default)({}, inputPropsProp, {
	    ref: handleInputRef
	  });
	
	  if (typeof InputComponent !== 'string') {
	    inputProps = (0, _extends2.default)({
	      // Rename ref to inputRef as we don't know the
	      // provided `inputComponent` structure.
	      inputRef: handleInputRef,
	      type: type
	    }, inputProps, {
	      ref: null
	    });
	  } else if (multiline) {
	    if (rows && !rowsMax && !rowsMin) {
	      InputComponent = 'textarea';
	    } else {
	      inputProps = (0, _extends2.default)({
	        rows: rows,
	        rowsMax: rowsMax
	      }, inputProps);
	      InputComponent = _TextareaAutosize.default;
	    }
	  } else {
	    inputProps = (0, _extends2.default)({
	      type: type
	    }, inputProps);
	  }
	
	  var handleAutoFill = function handleAutoFill(event) {
	    // Provide a fake value as Chrome might not let you access it for security reasons.
	    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
	      value: 'x'
	    });
	  };
	
	  React.useEffect(function () {
	    if (muiFormControl) {
	      muiFormControl.setAdornedStart(Boolean(startAdornment));
	    }
	  }, [muiFormControl, startAdornment]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
	    onClick: handleClick,
	    ref: ref
	  }, other), startAdornment, /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-invalid": fcs.error,
	    "aria-describedby": ariaDescribedby,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    disabled: fcs.disabled,
	    id: id,
	    onAnimationStart: handleAutoFill,
	    name: name,
	    placeholder: placeholder,
	    readOnly: readOnly,
	    required: fcs.required,
	    rows: rows,
	    value: value,
	    onKeyDown: onKeyDown,
	    onKeyUp: onKeyUp
	  }, inputProps, {
	    className: (0, _clsx.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
	    onBlur: handleBlur,
	    onChange: handleChange,
	    onFocus: handleFocus
	  }))), endAdornment, renderSuffix ? renderSuffix((0, _extends2.default)({}, fcs, {
	    startAdornment: startAdornment
	  })) : null);
	});
	 false ? InputBase.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the input is blurred.
	   *
	   * Notice that the first argument (event) might be undefined.
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  renderSuffix: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display when multiline option is set to true.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputBase'
	})(InputBase);
	
	exports.default = _default;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(110));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(92));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(319));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      transformOrigin: 'top left'
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Pseudo-class applied to the asterisk element. */
	    asterisk: {},
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: 'translate(0, 24px) scale(1)'
	    },
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: 'translate(0, 21px) scale(1)'
	    },
	
	    /* Styles applied to the `input` element if `shrink={true}`. */
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	
	    /* Styles applied to the `input` element if `disableAnimation={false}`. */
	    animated: {
	      transition: theme.transitions.create(['color', 'transform'], {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the root element if `variant="filled"`. */
	    filled: {
	      // Chrome's autofill feature gives the input field a yellow background.
	      // Since the input field is behind the label in the HTML tree,
	      // the input field is drawn last and hides the label with an opaque background color.
	      // zIndex: 1 will raise the label above opaque background-colors of input.
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(12px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(12px, 17px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(12px, 10px) scale(0.75)',
	        '&$marginDense': {
	          transform: 'translate(12px, 7px) scale(0.75)'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      // see comment above on filled.zIndex
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(14px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(14px, 12px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(14px, -6px) scale(0.75)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var InputLabel = React.forwardRef(function InputLabel(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableAnimati = props.disableAnimation,
	      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
	      margin = props.margin,
	      shrinkProp = props.shrink,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['margin', 'variant']
	  });
	  return /*#__PURE__*/React.createElement(_FormLabel.default, (0, _extends2.default)({
	    "data-shrink": shrink,
	    className: (0, _clsx.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
	      'filled': classes.filled,
	      'outlined': classes.outlined
	    }[fcs.variant]),
	    classes: {
	      focused: classes.focused,
	      disabled: classes.disabled,
	      error: classes.error,
	      required: classes.required,
	      asterisk: classes.asterisk
	    },
	    ref: ref
	  }, other));
	});
	 false ? InputLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes.default.bool,
	
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputLabel'
	})(InputLabel);
	
	exports.default = _default;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  var getColor = function getColor(color) {
	    return theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(color, 0.62) : (0, _colorManipulator.darken)(color, 0.5);
	  };
	
	  var backgroundPrimary = getColor(theme.palette.primary.main);
	  var backgroundSecondary = getColor(theme.palette.secondary.main);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 4,
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
	    colorPrimary: {
	      backgroundColor: backgroundPrimary
	    },
	
	    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
	    colorSecondary: {
	      backgroundColor: backgroundSecondary
	    },
	
	    /* Styles applied to the root element if `variant="determinate"`. */
	    determinate: {},
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `variant="buffer"`. */
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	
	    /* Styles applied to the root element if `variant="query"`. */
	    query: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"`. */
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: '$buffer 3s infinite linear'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	
	    /* Styles applied to the layered bar1 and bar2 elements. */
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	
	    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
	    bar1Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	
	    /* Styles applied to the bar1 element if `variant="determinate"`. */
	    bar1Determinate: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar1 element if `variant="buffer"`. */
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
	    bar2Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
	    },
	
	    /* Styles applied to the bar2 element if `variant="buffer"`. */
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0px -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0px -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	var LinearProgress = React.forwardRef(function LinearProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      var transform = value - 100;
	
	      if (theme.direction === 'rtl') {
	        transform = -transform;
	      }
	
	      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: you need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      var _transform = (valueBuffer || 0) - 100;
	
	      if (theme.direction === 'rtl') {
	        _transform = -_transform;
	      }
	
	      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: you need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, {
	      'determinate': classes.determinate,
	      'indeterminate': classes.indeterminate,
	      'buffer': classes.buffer,
	      'query': classes.query
	    }[variant]),
	    role: "progressbar"
	  }, rootProps, {
	    ref: ref
	  }, other), variant === 'buffer' ? /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.dashed, classes["dashedColor".concat((0, _capitalize.default)(color))])
	  }) : null, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, classes["barColor".concat((0, _capitalize.default)(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
	      'determinate': classes.bar1Determinate,
	      'buffer': classes.bar1Buffer
	    }[variant]),
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat((0, _capitalize.default)(color))], classes.bar2Buffer] : classes["barColor".concat((0, _capitalize.default)(color))]),
	    style: inlineStyles.bar2
	  }));
	});
	 false ? LinearProgress.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate or query when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(21);
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(140));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `underline="none"`. */
	  underlineNone: {
	    textDecoration: 'none'
	  },
	
	  /* Styles applied to the root element if `underline="hover"`. */
	  underlineHover: {
	    textDecoration: 'none',
	    '&:hover': {
	      textDecoration: 'underline'
	    }
	  },
	
	  /* Styles applied to the root element if `underline="always"`. */
	  underlineAlways: {
	    textDecoration: 'underline'
	  },
	  // Same reset as ButtonBase.root
	
	  /* Styles applied to the root element if `component="button"`. */
	  button: {
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$focusVisible': {
	      outline: 'auto'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if the link is keyboard focused. */
	  focusVisible: {}
	};
	exports.styles = styles;
	var Link = React.forwardRef(function Link(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'a' : _props$component,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      TypographyClasses = props.TypographyClasses,
	      _props$underline = props.underline,
	      underline = _props$underline === void 0 ? 'hover' : _props$underline,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  var handlerRef = (0, _useForkRef.default)(ref, focusVisibleRef);
	
	  var handleBlur = function handleBlur(event) {
	    if (focusVisible) {
	      onBlurVisible();
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var handleFocus = function handleFocus(event) {
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["underline".concat((0, _capitalize.default)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
	    classes: TypographyClasses,
	    color: color,
	    component: component,
	    onBlur: handleBlur,
	    onFocus: handleFocus,
	    ref: handlerRef,
	    variant: variant
	  }, other));
	});
	 false ? Link.propTypes = {
	  /**
	   * The content of the link.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the link.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * `classes` prop applied to the [`Typography`](/api/typography/) element.
	   */
	  TypographyClasses: _propTypes.default.object,
	
	  /**
	   * Controls when the link should have an underline.
	   */
	  underline: _propTypes.default.oneOf(['none', 'hover', 'always']),
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLink'
	})(Link);
	
	exports.default = _default;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(132));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	var List = React.forwardRef(function List(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disablePadding = props.disablePadding,
	      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
	      subheader = props.subheader,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	  var context = React.useMemo(function () {
	    return {
	      dense: dense
	    };
	  }, [dense]);
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: context
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
	    ref: ref
	  }, other), subheader, children));
	});
	 false ? List.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items.
	   * The prop is available to descendant components as the `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(139));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(132));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left',
	      paddingTop: 8,
	      paddingBottom: 8,
	      '&$focusVisible': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
	    container: {
	      position: 'relative'
	    },
	
	    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
	    focusVisible: {},
	
	    /* Styles applied to the `component` element if dense. */
	    dense: {
	      paddingTop: 4,
	      paddingBottom: 4
	    },
	
	    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      alignItems: 'flex-start'
	    },
	
	    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the inner `component` element if `divider={true}`. */
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the inner `component` element if `button={true}`. */
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positioned.
	      paddingRight: 48
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
	 */
	
	var ListItem = React.forwardRef(function ListItem(props, ref) {
	  var _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$button = props.button,
	      button = _props$button === void 0 ? false : _props$button,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      componentProp = props.component,
	      _props$ContainerCompo = props.ContainerComponent,
	      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
	      _props$ContainerProps = props.ContainerProps;
	  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	  var ContainerClassName = _props$ContainerProps.className,
	      ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$divider = props.divider,
	      divider = _props$divider === void 0 ? false : _props$divider,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
	  var context = React.useContext(_ListContext.default);
	  var childContext = {
	    dense: dense || context.dense || false,
	    alignItems: alignItems
	  };
	  var listItemRef = React.useRef(null);
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      if (listItemRef.current) {
	        listItemRef.current.focus();
	      } else if (false) {
	        console.error('Material-UI: unable to set focus to a ListItem whose component has not been rendered.');
	      }
	    }
	  }, [autoFocus]);
	  var children = React.Children.toArray(childrenProp);
	  var hasSecondaryAction = children.length && (0, _isMuiElement.default)(children[children.length - 1], ['ListItemSecondaryAction']);
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listItemRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  var componentProps = (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
	    disabled: disabled
	  }, other);
	  var Component = componentProp || 'li';
	
	  if (button) {
	    componentProps.component = componentProp || 'div';
	    componentProps.focusVisibleClassName = (0, _clsx.default)(classes.focusVisible, focusVisibleClassName);
	    Component = _ButtonBase.default;
	  }
	
	  if (hasSecondaryAction) {
	    // Use div by default.
	    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	    if (ContainerComponent === 'li') {
	      if (Component === 'li') {
	        Component = 'div';
	      } else if (componentProps.component === 'li') {
	        componentProps.component = 'div';
	      }
	    }
	
	    return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	      value: childContext
	    }, /*#__PURE__*/React.createElement(ContainerComponent, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, ContainerClassName),
	      ref: handleRef
	    }, ContainerProps), /*#__PURE__*/React.createElement(Component, componentProps, children), children.pop()));
	  }
	
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: handleRef
	  }, componentProps), children));
	});
	 false ? ListItem.propTypes = {
	  /**
	   * Defines the `align-items` style property.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center']),
	
	  /**
	   * If `true`, the list item will be focused during the first mount.
	   * Focus will also be triggered if the value changes from false to true.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
	   * for `ButtonBase` can then be applied to `ListItem`.
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component. If a `ListItemSecondaryAction` is used it must
	   * be the last child.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
	
	    var secondaryActionIndex = -1;
	
	    for (var i = children.length - 1; i >= 0; i -= 1) {
	      var child = children[i];
	
	      if ((0, _isMuiElement.default)(child, ['ListItemSecondaryAction'])) {
	        secondaryActionIndex = i;
	        break;
	      }
	    } //  is ListItemSecondaryAction the last child of ListItem
	
	
	    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
	      return new Error('Material-UI: you used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is the last child.
	   */
	  ContainerComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the container component if used.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(132));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    minWidth: 56,
	    flexShrink: 0
	  },
	
	  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	  alignItemsFlexStart: {
	    marginTop: 8
	  }
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Avatar`.
	 */
	
	exports.styles = styles;
	var ListItemAvatar = React.forwardRef(function ListItemAvatar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  var context = React.useContext(_ListContext.default);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	 false ? ListItemAvatar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component – normally `Avatar`.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemAvatar'
	})(ListItemAvatar);
	
	exports.default = _default;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	
	var _ListItemAvatar = _interopRequireDefault(__webpack_require__(809));

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(132));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      minWidth: 56,
	      color: theme.palette.action.active,
	      flexShrink: 0,
	      display: 'inline-flex'
	    },
	
	    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      marginTop: 8
	    }
	  };
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	
	
	exports.styles = styles;
	var ListItemIcon = React.forwardRef(function ListItemIcon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  var context = React.useContext(_ListContext.default);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	 false ? ListItemIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `@material-ui/icons` SVG icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemIcon'
	})(ListItemIcon);
	
	exports.default = _default;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(811));

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    position: 'absolute',
	    right: 16,
	    top: '50%',
	    transform: 'translateY(-50%)'
	  }
	};
	/**
	 * Must be used as the last child of ListItem to function properly.
	 */
	
	exports.styles = styles;
	var ListItemSecondaryAction = React.forwardRef(function ListItemSecondaryAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? ListItemSecondaryAction.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component, normally an `IconButton` or selection control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemSecondaryAction'
	})(ListItemSecondaryAction);
	
	exports.default = _default;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	
	var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(813));

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(132));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    flex: '1 1 auto',
	    minWidth: 0,
	    marginTop: 4,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the `Typography` components if primary and secondary are set. */
	  multiline: {
	    marginTop: 6,
	    marginBottom: 6
	  },
	
	  /* Styles applied to the `Typography` components if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if `inset={true}`. */
	  inset: {
	    paddingLeft: 56
	  },
	
	  /* Styles applied to the primary `Typography` component. */
	  primary: {},
	
	  /* Styles applied to the secondary `Typography` component. */
	  secondary: {}
	};
	exports.styles = styles;
	var ListItemText = React.forwardRef(function ListItemText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      primaryProp = props.primary,
	      primaryTypographyProps = props.primaryTypographyProps,
	      secondaryProp = props.secondary,
	      secondaryTypographyProps = props.secondaryTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
	
	  var _React$useContext = React.useContext(_ListContext.default),
	      dense = _React$useContext.dense;
	
	  var primary = primaryProp != null ? primaryProp : children;
	
	  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
	    primary = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: dense ? 'body2' : 'body1',
	      className: classes.primary,
	      component: "span",
	      display: "block"
	    }, primaryTypographyProps), primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
	    secondary = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: "body2",
	      className: classes.secondary,
	      color: "textSecondary",
	      display: "block"
	    }, secondaryTypographyProps), secondary);
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
	    ref: ref
	  }, other), primary, secondary);
	});
	 false ? ListItemText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Alias for the `primary` prop.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `children` (or `primary`) text, and optional `secondary` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	
	  /**
	   * The main content element.
	   */
	  primary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the primary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  primaryTypographyProps: _propTypes.default.object,
	
	  /**
	   * The secondary content element.
	   */
	  secondary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the secondary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  secondaryTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      boxSizing: 'border-box',
	      lineHeight: '48px',
	      listStyle: 'none',
	      color: theme.palette.text.secondary,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(14)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the root element if `inset={true}`. */
	    inset: {
	      paddingLeft: 72
	    },
	
	    /* Styles applied to the root element if `disableSticky={false}`. */
	    sticky: {
	      position: 'sticky',
	      top: 0,
	      zIndex: 1,
	      backgroundColor: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var ListSubheader = React.forwardRef(function ListSubheader(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$disableSticky = props.disableSticky,
	      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? ListSubheader.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the List Subheader will not have gutters.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will not stick to the top during scroll.
	   */
	  disableSticky: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will be indented.
	   */
	  inset: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListSubheader'
	})(ListSubheader);
	
	exports.default = _default;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	
	var _Menu = _interopRequireDefault(__webpack_require__(324));

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(163));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.body1, (0, _defineProperty2.default)({
	      minHeight: 48,
	      paddingTop: 6,
	      paddingBottom: 6,
	      boxSizing: 'border-box',
	      width: 'auto',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    }, theme.breakpoints.up('sm'), {
	      minHeight: 'auto'
	    })),
	    // TODO v5: remove
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: {},
	
	    /* Styles applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Styles applied to the root element if dense. */
	    dense: (0, _extends3.default)({}, theme.typography.body2, {
	      minHeight: 'auto'
	    })
	  };
	};
	
	exports.styles = styles;
	var MenuItem = React.forwardRef(function MenuItem(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      ListItemClasses = props.ListItemClasses,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'menuitem' : _props$role,
	      selected = props.selected,
	      tabIndexProp = props.tabIndex,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);
	  var tabIndex;
	
	  if (!props.disabled) {
	    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
	  }
	
	  return /*#__PURE__*/React.createElement(_ListItem.default, (0, _extends3.default)({
	    button: true,
	    role: role,
	    tabIndex: tabIndex,
	    component: component,
	    selected: selected,
	    disableGutters: disableGutters,
	    classes: (0, _extends3.default)({
	      dense: classes.dense
	    }, ListItemClasses),
	    className: (0, _clsx.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? MenuItem.propTypes = {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
	   */
	  ListItemClasses: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenuItem'
	})(MenuItem);
	
	exports.default = _default;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _List = _interopRequireDefault(__webpack_require__(162));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(357));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	function nextItem(list, item, disableListWrap) {
	  if (list === item) {
	    return list.firstChild;
	  }
	
	  if (item && item.nextElementSibling) {
	    return item.nextElementSibling;
	  }
	
	  return disableListWrap ? null : list.firstChild;
	}
	
	function previousItem(list, item, disableListWrap) {
	  if (list === item) {
	    return disableListWrap ? list.firstChild : list.lastChild;
	  }
	
	  if (item && item.previousElementSibling) {
	    return item.previousElementSibling;
	  }
	
	  return disableListWrap ? null : list.lastChild;
	}
	
	function textCriteriaMatches(nextFocus, textCriteria) {
	  if (textCriteria === undefined) {
	    return true;
	  }
	
	  var text = nextFocus.innerText;
	
	  if (text === undefined) {
	    // jsdom doesn't support innerText
	    text = nextFocus.textContent;
	  }
	
	  text = text.trim().toLowerCase();
	
	  if (text.length === 0) {
	    return false;
	  }
	
	  if (textCriteria.repeating) {
	    return text[0] === textCriteria.keys[0];
	  }
	
	  return text.indexOf(textCriteria.keys.join('')) === 0;
	}
	
	function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
	  var wrappedOnce = false;
	  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
	
	  while (nextFocus) {
	    // Prevent infinite loop.
	    if (nextFocus === list.firstChild) {
	      if (wrappedOnce) {
	        return;
	      }
	
	      wrappedOnce = true;
	    } // Same logic as useAutocomplete.js
	
	
	    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
	
	    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
	      // Move to the next element.
	      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
	    } else {
	      nextFocus.focus();
	      return;
	    }
	  }
	}
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
	 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
	 * use it separately you need to move focus into the component manually. Once
	 * the focus is placed inside the component it is fully keyboard accessible.
	 */
	
	var MenuList = React.forwardRef(function MenuList(props, ref) {
	  var actions = props.actions,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$autoFocusItem = props.autoFocusItem,
	      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
	      children = props.children,
	      className = props.className,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      onKeyDown = props.onKeyDown,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);
	  var listRef = React.useRef(null);
	  var textCriteriaRef = React.useRef({
	    keys: [],
	    repeating: true,
	    previousKeyMatched: true,
	    lastTime: null
	  });
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      listRef.current.focus();
	    }
	  }, [autoFocus]);
	  React.useImperativeHandle(actions, function () {
	    return {
	      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
	        // Let's ignore that piece of logic if users are already overriding the width
	        // of the menu.
	        var noExplicitWidth = !listRef.current.style.width;
	
	        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
	          var scrollbarSize = "".concat((0, _getScrollbarSize.default)(true), "px");
	          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
	          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
	        }
	
	        return listRef.current;
	      }
	    };
	  }, []);
	
	  var handleKeyDown = function handleKeyDown(event) {
	    var list = listRef.current;
	    var key = event.key;
	    /**
	     * @type {Element} - will always be defined since we are in a keydown handler
	     * attached to an element. A keydown event is either dispatched to the activeElement
	     * or document.body or document.documentElement. Only the first case will
	     * trigger this specific handler.
	     */
	
	    var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	    if (key === 'ArrowDown') {
	      // Prevent scroll of the page
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'ArrowUp') {
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key === 'Home') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'End') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key.length === 1) {
	      var criteria = textCriteriaRef.current;
	      var lowerKey = key.toLowerCase();
	      var currTime = performance.now();
	
	      if (criteria.keys.length > 0) {
	        // Reset
	        if (currTime - criteria.lastTime > 500) {
	          criteria.keys = [];
	          criteria.repeating = true;
	          criteria.previousKeyMatched = true;
	        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
	          criteria.repeating = false;
	        }
	      }
	
	      criteria.lastTime = currTime;
	      criteria.keys.push(lowerKey);
	      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
	
	      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
	        event.preventDefault();
	      } else {
	        criteria.previousKeyMatched = false;
	      }
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.forEach(children, function (child, index) {
	    if (!React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant === 'selectedMenu' && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      var newChildProps = {};
	
	      if (autoFocusItem) {
	        newChildProps.autoFocus = true;
	      }
	
	      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
	        newChildProps.tabIndex = 0;
	      }
	
	      return React.cloneElement(child, newChildProps);
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_List.default, (0, _extends2.default)({
	    role: "menu",
	    ref: handleRef,
	    className: className,
	    onKeyDown: handleKeyDown,
	    tabIndex: autoFocus ? 0 : -1
	  }, other), items);
	});
	 false ? MenuList.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, will focus the `[role="menu"]` container and move into tab order.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
	   * if `variant="selectedMenu"`.
	   */
	  autoFocusItem: _propTypes.default.bool,
	
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the menu items will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	var _default = MenuList;
	exports.default = _default;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(322));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      background: theme.palette.background.default,
	      padding: 8
	    },
	
	    /* Styles applied to the root element if `position="bottom"`. */
	    positionBottom: {
	      position: 'fixed',
	      bottom: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="top"`. */
	    positionTop: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {},
	
	    /* Styles applied to the dots container if `variant="dots"`. */
	    dots: {
	      display: 'flex',
	      flexDirection: 'row'
	    },
	
	    /* Styles applied to each dot if `variant="dots"`. */
	    dot: {
	      backgroundColor: theme.palette.action.disabled,
	      borderRadius: '50%',
	      width: 8,
	      height: 8,
	      margin: '0 2px'
	    },
	
	    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
	    dotActive: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the Linear Progress component if `variant="progress"`. */
	    progress: {
	      width: '50%'
	    }
	  };
	};
	
	exports.styles = styles;
	var MobileStepper = React.forwardRef(function MobileStepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      backButton = props.backButton,
	      classes = props.classes,
	      className = props.className,
	      LinearProgressProps = props.LinearProgressProps,
	      nextButton = props.nextButton,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'bottom' : _props$position,
	      steps = props.steps,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'dots' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _capitalize.default)(position))], className),
	    ref: ref
	  }, other), backButton, variant === 'text' && /*#__PURE__*/React.createElement(React.Fragment, null, activeStep + 1, " / ", steps), variant === 'dots' && /*#__PURE__*/React.createElement("div", {
	    className: classes.dots
	  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, index) {
	    return /*#__PURE__*/React.createElement("div", {
	      key: index,
	      className: (0, _clsx.default)(classes.dot, index === activeStep && classes.dotActive)
	    });
	  })), variant === 'progress' && /*#__PURE__*/React.createElement(_LinearProgress.default, (0, _extends2.default)({
	    className: classes.progress,
	    variant: "determinate",
	    value: Math.ceil(activeStep / (steps - 1) * 100)
	  }, LinearProgressProps)), nextButton);
	});
	 false ? MobileStepper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the active step (zero based index).
	   * Defines which dot is highlighted when the variant is 'dots'.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * A back button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  backButton: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `LinearProgress` element.
	   */
	  LinearProgressProps: _propTypes.default.object,
	
	  /**
	   * A next button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  nextButton: _propTypes.default.node,
	
	  /**
	   * Set the positioning type.
	   */
	  position: _propTypes.default.oneOf(['bottom', 'static', 'top']),
	
	  /**
	   * The total steps.
	   */
	  steps: _propTypes.default.number.isRequired,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dots', 'progress', 'text'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMobileStepper'
	})(MobileStepper);
	
	exports.default = _default;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	
	var _MobileStepper = _interopRequireDefault(__webpack_require__(820));

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _styles = __webpack_require__(52);
	
	var _utils = __webpack_require__(21);
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _Portal = _interopRequireDefault(__webpack_require__(228));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(138));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(355));
	
	var _ModalManager = _interopRequireWildcard(__webpack_require__(325));
	
	var _TrapFocus = _interopRequireDefault(__webpack_require__(824));
	
	var _SimpleBackdrop = _interopRequireDefault(__webpack_require__(823));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container;
	  return ReactDOM.findDOMNode(container);
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	} // A modal manager used to track and manage the state of open Modals.
	// Modals don't open on the server so this won't conflict with concurrent requests.
	
	
	var defaultManager = new _ModalManager.default();
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/**
	 * Modal is a lower-level construct that is leveraged by the following components:
	 *
	 * - [Dialog](/api/dialog/)
	 * - [Drawer](/api/drawer/)
	 * - [Menu](/api/menu/)
	 * - [Popover](/api/popover/)
	 *
	 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
	 * rather than directly using Modal.
	 *
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	exports.styles = styles;
	var Modal = React.forwardRef(function Modal(inProps, ref) {
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiModal',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$BackdropCompon = props.BackdropComponent,
	      BackdropComponent = _props$BackdropCompon === void 0 ? _SimpleBackdrop.default : _props$BackdropCompon,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      _props$closeAfterTran = props.closeAfterTransition,
	      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
	      container = props.container,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      _props$disableScrollL = props.disableScrollLock,
	      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
	      _props$hideBackdrop = props.hideBackdrop,
	      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      _props$manager = props.manager,
	      manager = _props$manager === void 0 ? defaultManager : _props$manager,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onRendered = props.onRendered,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var modal = React.useRef({});
	  var mountNodeRef = React.useRef(null);
	  var modalRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(modalRef, ref);
	  var hasTransition = getHasTransition(props);
	
	  var getDoc = function getDoc() {
	    return (0, _ownerDocument.default)(mountNodeRef.current);
	  };
	
	  var getModal = function getModal() {
	    modal.current.modalRef = modalRef.current;
	    modal.current.mountNode = mountNodeRef.current;
	    return modal.current;
	  };
	
	  var handleMounted = function handleMounted() {
	    manager.mount(getModal(), {
	      disableScrollLock: disableScrollLock
	    }); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	    modalRef.current.scrollTop = 0;
	  };
	
	  var handleOpen = (0, _useEventCallback.default)(function () {
	    var resolvedContainer = getContainer(container) || getDoc().body;
	    manager.add(getModal(), resolvedContainer); // The element was already mounted.
	
	    if (modalRef.current) {
	      handleMounted();
	    }
	  });
	  var isTopModal = React.useCallback(function () {
	    return manager.isTopModal(getModal());
	  }, [manager]);
	  var handlePortalRef = (0, _useEventCallback.default)(function (node) {
	    mountNodeRef.current = node;
	
	    if (!node) {
	      return;
	    }
	
	    if (onRendered) {
	      onRendered();
	    }
	
	    if (open && isTopModal()) {
	      handleMounted();
	    } else {
	      (0, _ModalManager.ariaHidden)(modalRef.current, true);
	    }
	  });
	  var handleClose = React.useCallback(function () {
	    manager.remove(getModal());
	  }, [manager]);
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, [handleClose]);
	  React.useEffect(function () {
	    if (open) {
	      handleOpen();
	    } else if (!hasTransition || !closeAfterTransition) {
	      handleClose();
	    }
	  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
	
	  if (!keepMounted && !open && (!hasTransition || exited)) {
	    return null;
	  }
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	
	    if (closeAfterTransition) {
	      handleClose();
	    }
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    if (event.target !== event.currentTarget) {
	      return;
	    }
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // The handler doesn't take event.defaultPrevented into account:
	    //
	    // event.preventDefault() is meant to stop default behaviours like
	    // clicking a checkbox to check it, hitting a button to submit a form,
	    // and hitting left arrow to move the cursor in a text input etc.
	    // Only special HTML elements have these default behaviors.
	    if (event.key !== 'Escape' || !isTopModal()) {
	      return;
	    } // Swallow the event, in case someone is listening for the escape key on the body.
	
	
	    event.stopPropagation();
	
	    if (onEscapeKeyDown) {
	      onEscapeKeyDown(event);
	    }
	
	    if (!disableEscapeKeyDown && onClose) {
	      onClose(event, 'escapeKeyDown');
	    }
	  };
	
	  var inlineStyle = styles(theme || {
	    zIndex: _zIndex.default
	  });
	  var childProps = {};
	
	  if (children.props.tabIndex === undefined) {
	    childProps.tabIndex = children.props.tabIndex || '-1';
	  } // It's a Transition like component
	
	
	  if (hasTransition) {
	    childProps.onEnter = (0, _createChainedFunction.default)(handleEnter, children.props.onEnter);
	    childProps.onExited = (0, _createChainedFunction.default)(handleExited, children.props.onExited);
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    ref: handlePortalRef,
	    container: container,
	    disablePortal: disablePortal
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    onKeyDown: handleKeyDown,
	    role: "presentation"
	  }, other, {
	    style: (0, _extends2.default)({}, inlineStyle.root, {}, !open && exited ? inlineStyle.hidden : {}, {}, other.style)
	  }), hideBackdrop ? null : /*#__PURE__*/React.createElement(BackdropComponent, (0, _extends2.default)({
	    open: open,
	    onClick: handleBackdropClick
	  }, BackdropProps)), /*#__PURE__*/React.createElement(_TrapFocus.default, {
	    disableEnforceFocus: disableEnforceFocus,
	    disableAutoFocus: disableAutoFocus,
	    disableRestoreFocus: disableRestoreFocus,
	    getDoc: getDoc,
	    isEnabled: isTopModal,
	    open: open
	  }, React.cloneElement(children, childProps))));
	});
	 false ? Modal.propTypes = {
	  /**
	   * A backdrop component. This prop enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Backdrop`](/api/backdrop/) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * When set to true the Modal waits until a nested Transition is completed before closing.
	   */
	  closeAfterTransition: _propTypes.default.bool,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire any callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire any callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Disable the scroll lock behavior.
	   */
	  disableScrollLock: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` prop took effect.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SimpleBackdrop = React.forwardRef(function SimpleBackdrop(props, ref) {
	  var _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["invisible", "open"]);
	  return open ? /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    "aria-hidden": true,
	    ref: ref
	  }, other, {
	    style: (0, _extends2.default)({}, styles.root, {}, invisible ? styles.invisible : {}, {}, other.style)
	  })) : null;
	});
	 false ? SimpleBackdrop.propTypes = {
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = SimpleBackdrop;
	exports.default = _default;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */
	
	/**
	 * @ignore - internal component.
	 */
	function TrapFocus(props) {
	  var children = props.children,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      getDoc = props.getDoc,
	      isEnabled = props.isEnabled,
	      open = props.open;
	  var ignoreNextEnforceFocus = React.useRef();
	  var sentinelStart = React.useRef(null);
	  var sentinelEnd = React.useRef(null);
	  var nodeToRestore = React.useRef();
	  var rootRef = React.useRef(null); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    rootRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // ⚠️ You may rely on React.useMemo as a performance optimization, not as a semantic guarantee.
	  // https://reactjs.org/docs/hooks-reference.html#usememo
	
	  React.useMemo(function () {
	    if (!open || typeof window === 'undefined') {
	      return;
	    }
	
	    nodeToRestore.current = getDoc().activeElement;
	  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
	
	  React.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var doc = (0, _ownerDocument.default)(rootRef.current); // We might render an empty child.
	
	    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	      if (!rootRef.current.hasAttribute('tabIndex')) {
	        if (false) {
	          console.error(['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
	        }
	
	        rootRef.current.setAttribute('tabIndex', -1);
	      }
	
	      rootRef.current.focus();
	    }
	
	    var contain = function contain() {
	      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
	        ignoreNextEnforceFocus.current = false;
	        return;
	      }
	
	      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	        rootRef.current.focus();
	      }
	    };
	
	    var loopFocus = function loopFocus(event) {
	      // 9 = Tab
	      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
	        return;
	      } // Make sure the next tab starts from the right place.
	
	
	      if (doc.activeElement === rootRef.current) {
	        // We need to ignore the next contain as
	        // it will try to move the focus back to the rootRef element.
	        ignoreNextEnforceFocus.current = true;
	
	        if (event.shiftKey) {
	          sentinelEnd.current.focus();
	        } else {
	          sentinelStart.current.focus();
	        }
	      }
	    };
	
	    doc.addEventListener('focus', contain, true);
	    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
	    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
	    //
	    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
	    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
	
	    var interval = setInterval(function () {
	      contain();
	    }, 50);
	    return function () {
	      clearInterval(interval);
	      doc.removeEventListener('focus', contain, true);
	      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
	
	      if (!disableRestoreFocus) {
	        // In IE 11 it is possible for document.activeElement to be null resulting
	        // in nodeToRestore.current being null.
	        // Not all elements in IE 11 have a focus method.
	        // Once IE 11 support is dropped the focus() call can be unconditional.
	        if (nodeToRestore.current && nodeToRestore.current.focus) {
	          nodeToRestore.current.focus();
	        }
	
	        nodeToRestore.current = null;
	      }
	    };
	  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelStart,
	    "data-test": "sentinelStart"
	  }), React.cloneElement(children, {
	    ref: handleRef
	  }), /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelEnd,
	    "data-test": "sentinelEnd"
	  }));
	}
	
	 false ? TrapFocus.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Return the document to consider.
	   * We use it to implement the restore focus between different browser documents.
	   */
	  getDoc: _propTypes.default.func.isRequired,
	
	  /**
	   * Do we still want to enforce the focus?
	   * This prop helps nesting TrapFocus elements.
	   */
	  isEnabled: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	/*
	
	In the future, we should be able to replace TrapFocus with:
	https://github.com/facebook/react/blob/master/packages/react-events/docs/FocusScope.md
	
	```jsx
	import FocusScope from 'react-dom/FocusScope';
	
	function TrapFocus(props) {
	  const {
	    children
	    disableAutoFocus = false,
	    disableEnforceFocus = false,
	    disableRestoreFocus = false,
	    open,
	  } = props;
	
	  if (!open) {
	    return children;
	  }
	
	  return (
	    <FocusScope
	      autoFocus={!disableAutoFocus}
	      contain={!disableEnforceFocus}
	      restoreFocus={!disableRestoreFocus}
	    >
	      {children}
	    </FocusScope>
	  );
	}
	```
	
	*/
	
	var _default = TrapFocus;
	exports.default = _default;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	
	var _NativeSelect = _interopRequireDefault(__webpack_require__(326));

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(21);
	
	var useEnhancedEffect = typeof window !== 'undefined' && ("production") !== 'test' ? React.useLayoutEffect : React.useEffect;
	/**
	 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
	 *
	 * This component can be useful in a variety of situations:
	 * - Escape hatch for broken dependencies not supporting SSR.
	 * - Improve the time-to-first paint on the client by only rendering above the fold.
	 * - Reduce the rendering time on the server.
	 * - Under too heavy server load, you can turn on service degradation.
	 */
	
	function NoSsr(props) {
	  var children = props.children,
	      _props$defer = props.defer,
	      defer = _props$defer === void 0 ? false : _props$defer,
	      _props$fallback = props.fallback,
	      fallback = _props$fallback === void 0 ? null : _props$fallback;
	
	  var _React$useState = React.useState(false),
	      mountedState = _React$useState[0],
	      setMountedState = _React$useState[1];
	
	  useEnhancedEffect(function () {
	    if (!defer) {
	      setMountedState(true);
	    }
	  }, [defer]);
	  React.useEffect(function () {
	    if (defer) {
	      setMountedState(true);
	    }
	  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, mountedState ? children : fallback);
	}
	
	 false ? NoSsr.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * If `true`, the component will not only prevent server-side rendering.
	   * It will also defer the rendering of the children into a different screen frame.
	   */
	  defer: _propTypes.default.bool,
	
	  /**
	   * The fallback content to display.
	   */
	  fallback: _propTypes.default.node
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  NoSsr['propTypes' + ''] = (0, _utils.exactProp)(NoSsr.propTypes);
	}
	
	var _default = NoSsr;
	exports.default = _default;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      top: -5,
	      left: 0,
	      margin: 0,
	      padding: '0 8px',
	      pointerEvents: 'none',
	      borderRadius: 'inherit',
	      borderStyle: 'solid',
	      borderWidth: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the legend element when `labelWidth` is provided. */
	    legend: {
	      textAlign: 'left',
	      padding: 0,
	      lineHeight: '11px',
	      // sync with `height` in `legend` styles
	      transition: theme.transitions.create('width', {
	        duration: 150,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the legend element. */
	    legendLabelled: {
	      display: 'block',
	      width: 'auto',
	      textAlign: 'left',
	      padding: 0,
	      height: 11,
	      // sync with `lineHeight` in `legend` styles
	      fontSize: '0.75em',
	      visibility: 'hidden',
	      maxWidth: 0.01,
	      transition: theme.transitions.create('max-width', {
	        duration: 50,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '& > span': {
	        paddingLeft: 5,
	        paddingRight: 5,
	        display: 'inline-block'
	      }
	    },
	
	    /* Styles applied to the legend element is notched. */
	    legendNotched: {
	      maxWidth: 1000,
	      transition: theme.transitions.create('max-width', {
	        duration: 100,
	        easing: theme.transitions.easing.easeOut,
	        delay: 50
	      })
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var NotchedOutline = React.forwardRef(function NotchedOutline(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      label = props.label,
	      labelWidthProp = props.labelWidth,
	      notched = props.notched,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);
	  var theme = (0, _useTheme.default)();
	  var align = theme.direction === 'rtl' ? 'right' : 'left';
	
	  if (label !== undefined) {
	    return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	      "aria-hidden": true,
	      className: (0, _clsx.default)(classes.root, className),
	      ref: ref,
	      style: style
	    }, other), /*#__PURE__*/React.createElement("legend", {
	      className: (0, _clsx.default)(classes.legendLabelled, notched && classes.legendNotched)
	    }, label ? /*#__PURE__*/React.createElement("span", null, label) : /*#__PURE__*/React.createElement("span", {
	      dangerouslySetInnerHTML: {
	        __html: '&#8203;'
	      }
	    })));
	  }
	
	  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
	  return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	    "aria-hidden": true,
	    style: (0, _extends3.default)((0, _defineProperty2.default)({}, "padding".concat((0, _capitalize.default)(align)), 8), style),
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("legend", {
	    className: classes.legend,
	    style: {
	      // IE 11: fieldset with legend does not render
	      // a border radius. This maintains consistency
	      // by always having a legend rendered
	      width: notched ? labelWidth : 0.01
	    }
	  }, /*#__PURE__*/React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  })));
	});
	 false ? NotchedOutline.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label.
	   */
	  labelWidth: _propTypes.default.number.isRequired,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateNotchedOutline'
	})(NotchedOutline);
	
	exports.default = _default;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(131));
	
	var _NotchedOutline = _interopRequireDefault(__webpack_require__(827));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      borderRadius: theme.shape.borderRadius,
	      '&:hover $notchedOutline': {
	        borderColor: theme.palette.text.primary
	      },
	      // Reset on touch devices, it doesn't add specificity
	      '@media (hover: none)': {
	        '&:hover $notchedOutline': {
	          borderColor: borderColor
	        }
	      },
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.primary.main,
	        borderWidth: 2
	      },
	      '&$error $notchedOutline': {
	        borderColor: theme.palette.error.main
	      },
	      '&$disabled $notchedOutline': {
	        borderColor: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 14
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '18.5px 14px',
	      '&$marginDense': {
	        paddingTop: 10.5,
	        paddingBottom: 10.5
	      }
	    },
	
	    /* Styles applied to the `NotchedOutline` element. */
	    notchedOutline: {
	      borderColor: borderColor
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '18.5px 14px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'dark' ? '0 0 0 100px #266798 inset' : null,
	        WebkitTextFillColor: theme.palette.type === 'dark' ? '#fff' : null,
	        borderRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 10.5,
	      paddingBottom: 10.5
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var OutlinedInput = React.forwardRef(function OutlinedInput(props, ref) {
	  var classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      label = props.label,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      notched = props.notched,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    renderSuffix: function renderSuffix(state) {
	      return /*#__PURE__*/React.createElement(_NotchedOutline.default, {
	        className: classes.notchedOutline,
	        label: label,
	        labelWidth: labelWidth,
	        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
	      });
	    },
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, classes.underline),
	      notchedOutline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? OutlinedInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label of the input. It is only used for layout. The actual labelling
	   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label. Is ignored if `label` is provided. Prefer `label`
	   * if the input label appears with a strike through.
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	OutlinedInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiOutlinedInput'
	})(OutlinedInput);
	
	exports.default = _default;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create('box-shadow')
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` */
	    outlined: {
	      border: "1px solid ".concat(theme.palette.divider)
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	var Paper = React.forwardRef(function Paper(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
	    ref: ref
	  }, other));
	});
	 false ? Paper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It accepts values between 0 and 24 inclusive.
	   */
	  elevation: (0, _utils.chainPropTypes)(_propTypes.default.number, function (props) {
	    var classes = props.classes,
	        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning
	
	    if (classes === undefined) {
	      return null;
	    }
	
	    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
	      return new Error("Material-UI: this elevation `".concat(elevation, "` is not implemented."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['elevation', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOffsetTop = getOffsetTop;
	exports.getOffsetLeft = getOffsetLeft;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _utils = __webpack_require__(21);
	
	var _debounce = _interopRequireDefault(__webpack_require__(93));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(168));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(138));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Modal = _interopRequireDefault(__webpack_require__(164));
	
	var _Grow = _interopRequireDefault(__webpack_require__(80));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	function getOffsetTop(rect, vertical) {
	  var offset = 0;
	
	  if (typeof vertical === 'number') {
	    offset = vertical;
	  } else if (vertical === 'center') {
	    offset = rect.height / 2;
	  } else if (vertical === 'bottom') {
	    offset = rect.height;
	  }
	
	  return offset;
	}
	
	function getOffsetLeft(rect, horizontal) {
	  var offset = 0;
	
	  if (typeof horizontal === 'number') {
	    offset = horizontal;
	  } else if (horizontal === 'center') {
	    offset = rect.width / 2;
	  } else if (horizontal === 'right') {
	    offset = rect.width;
	  }
	
	  return offset;
	}
	
	function getTransformOriginValue(transformOrigin) {
	  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
	    return typeof n === 'number' ? "".concat(n, "px") : n;
	  }).join(' ');
	} // Sum the scrollTop between two elements.
	
	
	function getScrollParent(parent, child) {
	  var element = child;
	  var scrollTop = 0;
	
	  while (element && element !== parent) {
	    element = element.parentElement;
	    scrollTop += element.scrollTop;
	  }
	
	  return scrollTop;
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var styles = {
	  /* Styles applied to the root element */
	  root: {},
	
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    position: 'absolute',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    // So we see the popover when it's empty.
	    // It's most likely on issue on userland.
	    minWidth: 16,
	    minHeight: 16,
	    maxWidth: 'calc(100% - 32px)',
	    maxHeight: 'calc(100% - 32px)',
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Popover = React.forwardRef(function Popover(props, ref) {
	  var action = props.action,
	      anchorEl = props.anchorEl,
	      _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$anchorOrigin,
	      anchorPosition = props.anchorPosition,
	      _props$anchorReferenc = props.anchorReference,
	      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      containerProp = props.container,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
	      getContentAnchorEl = props.getContentAnchorEl,
	      _props$marginThreshol = props.marginThreshold,
	      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$transformOrigi = props.transformOrigin,
	      transformOrigin = _props$transformOrigi === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$transformOrigi,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$TransitionProp = props.TransitionProps,
	      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var paperRef = React.useRef(); // Returns the top/left offset of the position
	  // to attach to on the anchor element (or body if none is provided)
	
	  var getAnchorOffset = React.useCallback(function (contentAnchorOffset) {
	    if (anchorReference === 'anchorPosition') {
	      if (false) {
	        if (!anchorPosition) {
	          console.error('Material-UI: you need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
	        }
	      }
	
	      return anchorPosition;
	    }
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
	
	    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocument.default)(paperRef.current).body;
	    var anchorRect = anchorElement.getBoundingClientRect();
	
	    if (false) {
	      var box = anchorElement.getBoundingClientRect();
	
	      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	        console.warn(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	      }
	    }
	
	    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
	    return {
	      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
	      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
	    };
	  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided
	
	  var getContentAnchorOffset = React.useCallback(function (element) {
	    var contentAnchorOffset = 0;
	
	    if (getContentAnchorEl && anchorReference === 'anchorEl') {
	      var contentAnchorEl = getContentAnchorEl(element);
	
	      if (contentAnchorEl && element.contains(contentAnchorEl)) {
	        var scrollTop = getScrollParent(element, contentAnchorEl);
	        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
	      } // != the default value
	
	
	      if (false) {
	        if (anchorOrigin.vertical !== 'top') {
	          console.error(['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
	        }
	      }
	    }
	
	    return contentAnchorOffset;
	  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
	  // and taking the content anchor offset into account if in use
	
	  var getTransformOrigin = React.useCallback(function (elemRect) {
	    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return {
	      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
	      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
	    };
	  }, [transformOrigin.horizontal, transformOrigin.vertical]);
	  var getPositioningStyle = React.useCallback(function (element) {
	    // Check if the parent has requested anchoring on an inner content node
	    var contentAnchorOffset = getContentAnchorOffset(element);
	    var elemRect = {
	      width: element.offsetWidth,
	      height: element.offsetHeight
	    }; // Get the transform origin point on the element itself
	
	    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
	
	    if (anchorReference === 'none') {
	      return {
	        top: null,
	        left: null,
	        transformOrigin: getTransformOriginValue(elemTransformOrigin)
	      };
	    } // Get the offset of of the anchoring element
	
	
	    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
	
	    var top = anchorOffset.top - elemTransformOrigin.vertical;
	    var left = anchorOffset.left - elemTransformOrigin.horizontal;
	    var bottom = top + elemRect.height;
	    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
	
	    var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
	
	    var heightThreshold = containerWindow.innerHeight - marginThreshold;
	    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
	
	    if (top < marginThreshold) {
	      var diff = top - marginThreshold;
	      top -= diff;
	      elemTransformOrigin.vertical += diff;
	    } else if (bottom > heightThreshold) {
	      var _diff = bottom - heightThreshold;
	
	      top -= _diff;
	      elemTransformOrigin.vertical += _diff;
	    }
	
	    if (false) {
	      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
	        console.error(['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
	      }
	    } // Check if the horizontal axis needs shifting
	
	
	    if (left < marginThreshold) {
	      var _diff2 = left - marginThreshold;
	
	      left -= _diff2;
	      elemTransformOrigin.horizontal += _diff2;
	    } else if (right > widthThreshold) {
	      var _diff3 = right - widthThreshold;
	
	      left -= _diff3;
	      elemTransformOrigin.horizontal += _diff3;
	    }
	
	    return {
	      top: "".concat(Math.round(top), "px"),
	      left: "".concat(Math.round(left), "px"),
	      transformOrigin: getTransformOriginValue(elemTransformOrigin)
	    };
	  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
	  var setPositioningStyles = React.useCallback(function () {
	    var element = paperRef.current;
	
	    if (!element) {
	      return;
	    }
	
	    var positioning = getPositioningStyle(element);
	
	    if (positioning.top !== null) {
	      element.style.top = positioning.top;
	    }
	
	    if (positioning.left !== null) {
	      element.style.left = positioning.left;
	    }
	
	    element.style.transformOrigin = positioning.transformOrigin;
	  }, [getPositioningStyle]);
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	
	    setPositioningStyles();
	  };
	
	  var handlePaperRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    paperRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  React.useEffect(function () {
	    if (open) {
	      setPositioningStyles();
	    }
	  });
	  React.useImperativeHandle(action, function () {
	    return open ? {
	      updatePosition: function updatePosition() {
	        setPositioningStyles();
	      }
	    } : null;
	  }, [open, setPositioningStyles]);
	  React.useEffect(function () {
	    if (!open) {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      setPositioningStyles();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [open, setPositioningStyles]);
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  } // If the container prop is provided, use that
	  // If the anchorEl prop is provided, use its parent body element as the container
	  // If neither are provided let the Modal take care of choosing the container
	
	
	  var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    container: container,
	    open: open,
	    ref: ref,
	    BackdropProps: {
	      invisible: true
	    },
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    onEnter: onEnter,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExited: onExited,
	    onExiting: onExiting,
	    timeout: transitionDuration
	  }, TransitionProps, {
	    onEntering: (0, _createChainedFunction.default)(handleEntering, TransitionProps.onEntering)
	  }), /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: elevation,
	    ref: handlePaperRef
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, PaperProps.className)
	  }), children)));
	});
	 false ? Popover.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A ref for imperative actions.
	   * It currently only supports updatePosition() action.
	   */
	  action: _utils.refType,
	
	  /**
	   * A HTML element, or a function that returns it.
	   * It's used to set the position of the popover.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_utils.HTMLElementType, _propTypes.default.func]), function (props) {
	    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else {
	        return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * This is the point on the anchor where the popover's
	   * `anchorEl` will attach to. This is not used when the
	   * anchorReference is 'anchorPosition'.
	   *
	   * Options:
	   * vertical: [top, center, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * This is the position that may be used
	   * to set the position of the popover.
	   * The coordinates are relative to
	   * the application's client area.
	   */
	  anchorPosition: _propTypes.default.shape({
	    left: _propTypes.default.number.isRequired,
	    top: _propTypes.default.number.isRequired
	  }),
	
	  /**
	   * This determines which anchor prop to refer to to set
	   * the position of the popover.
	   */
	  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   *
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * The elevation of the popover.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * This function is called in order to retrieve the content anchor element.
	   * It's the opposite of the `anchorEl` prop.
	   * The content anchor element should be an element inside the popover.
	   * It's used to correctly scroll and set the position of the popover.
	   * The positioning strategy tries to make the content anchor element just above the
	   * anchor element.
	   */
	  getContentAnchorEl: _propTypes.default.func,
	
	  /**
	   * Specifies how close to the edge of the window the popover can appear.
	   */
	  marginThreshold: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the popover is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .shape({
	    component: _utils.elementTypeAcceptingRef
	  }),
	
	  /**
	   * This is the point on the popover which
	   * will attach to the anchor's origin.
	   *
	   * Options:
	   * vertical: [top, center, bottom, x(px)];
	   * horizontal: [left, center, right, x(px)].
	   */
	  transformOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPopover'
	})(Popover);
	
	exports.default = _default;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _popper = _interopRequireDefault(__webpack_require__(1393));
	
	var _utils = __webpack_require__(21);
	
	var _styles = __webpack_require__(52);
	
	var _Portal = _interopRequireDefault(__webpack_require__(228));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(138));
	
	var _setRef = _interopRequireDefault(__webpack_require__(94));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	function flipPlacement(placement, theme) {
	  var direction = theme && theme.direction || 'ltr';
	
	  if (direction === 'ltr') {
	    return placement;
	  }
	
	  switch (placement) {
	    case 'bottom-end':
	      return 'bottom-start';
	
	    case 'bottom-start':
	      return 'bottom-end';
	
	    case 'top-end':
	      return 'top-start';
	
	    case 'top-start':
	      return 'top-end';
	
	    default:
	      return placement;
	  }
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var defaultPopperOptions = {};
	/**
	 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
	 */
	
	var Popper = React.forwardRef(function Popper(props, ref) {
	  var anchorEl = props.anchorEl,
	      children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      modifiers = props.modifiers,
	      open = props.open,
	      _props$placement = props.placement,
	      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      _props$popperOptions = props.popperOptions,
	      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
	      popperRefProp = props.popperRef,
	      style = props.style,
	      _props$transition = props.transition,
	      transition = _props$transition === void 0 ? false : _props$transition,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);
	  var tooltipRef = React.useRef(null);
	  var ownRef = (0, _useForkRef.default)(tooltipRef, ref);
	  var popperRef = React.useRef(null);
	  var handlePopperRef = (0, _useForkRef.default)(popperRef, popperRefProp);
	  var handlePopperRefRef = React.useRef(handlePopperRef);
	  useEnhancedEffect(function () {
	    handlePopperRefRef.current = handlePopperRef;
	  }, [handlePopperRef]);
	  React.useImperativeHandle(popperRefProp, function () {
	    return popperRef.current;
	  }, []);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var theme = (0, _styles.useTheme)();
	  var rtlPlacement = flipPlacement(initialPlacement, theme);
	  /**
	   * placement initialized from prop but can change during lifetime if modifiers.flip.
	   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
	   */
	
	  var _React$useState2 = React.useState(rtlPlacement),
	      placement = _React$useState2[0],
	      setPlacement = _React$useState2[1];
	
	  React.useEffect(function () {
	    if (popperRef.current) {
	      popperRef.current.update();
	    }
	  });
	  var handleOpen = React.useCallback(function () {
	    if (!tooltipRef.current || !anchorEl || !open) {
	      return;
	    }
	
	    if (popperRef.current) {
	      popperRef.current.destroy();
	      handlePopperRefRef.current(null);
	    }
	
	    var handlePopperUpdate = function handlePopperUpdate(data) {
	      setPlacement(data.placement);
	    };
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl);
	
	    if (false) {
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          console.warn(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      }
	    }
	
	    var popper = new _popper.default(getAnchorEl(anchorEl), tooltipRef.current, (0, _extends2.default)({
	      placement: rtlPlacement
	    }, popperOptions, {
	      modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
	        // It's using scrollParent by default, we can use the viewport when using a portal.
	        preventOverflow: {
	          boundariesElement: 'window'
	        }
	      }, {}, modifiers, {}, popperOptions.modifiers),
	      // We could have been using a custom modifier like react-popper is doing.
	      // But it seems this is the best public API for this use case.
	      onCreate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onCreate),
	      onUpdate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onUpdate)
	    }));
	    handlePopperRefRef.current(popper);
	  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
	  var handleRef = React.useCallback(function (node) {
	    (0, _setRef.default)(ownRef, node);
	    handleOpen();
	  }, [ownRef, handleOpen]);
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleClose = function handleClose() {
	    if (!popperRef.current) {
	      return;
	    }
	
	    popperRef.current.destroy();
	    handlePopperRefRef.current(null);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	    handleClose();
	  };
	
	  React.useEffect(function () {
	    // Let's update the popper position.
	    handleOpen();
	  }, [handleOpen]);
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open && !transition) {
	      // Otherwise handleExited will call this.
	      handleClose();
	    }
	  }, [open, transition]);
	
	  if (!keepMounted && !open && (!transition || exited)) {
	    return null;
	  }
	
	  var childProps = {
	    placement: placement
	  };
	
	  if (transition) {
	    childProps.TransitionProps = {
	      in: open,
	      onEnter: handleEnter,
	      onExited: handleExited
	    };
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    disablePortal: disablePortal,
	    container: container
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    role: "tooltip"
	  }, other, {
	    style: (0, _extends2.default)({
	      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
	      position: 'fixed',
	      // Fix Popper.js display issue
	      top: 0,
	      left: 0
	    }, style)
	  }), typeof children === 'function' ? children(childProps) : children));
	});
	 false ? Popper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
	   * or a function that returns either.
	   * It's used to set the position of the popper.
	   * The return value will passed as the reference object of the Popper instance.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_utils.HTMLElementType, _propTypes.default.object, _propTypes.default.func]), function (props) {
	    if (props.open) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
	        return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * Popper render function or node.
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Popper.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * Popper.js is based on a "plugin-like" architecture,
	   * most of its features are fully encapsulated "modifiers".
	   *
	   * A modifier is a function that is called each time Popper.js needs to
	   * compute the position of the popper.
	   * For this reason, modifiers should be very performant to avoid bottlenecks.
	   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
	   */
	  modifiers: _propTypes.default.object,
	
	  /**
	   * If `true`, the popper is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Popper placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
	   */
	  popperOptions: _propTypes.default.object,
	
	  /**
	   * A ref that points to the used popper instance.
	   */
	  popperRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * Help supporting a react-transition-group/Transition component.
	   */
	  transition: _propTypes.default.bool
	} : void 0;
	var _default = Popper;
	exports.default = _default;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(21);
	
	var _setRef = _interopRequireDefault(__webpack_require__(94));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container; // #StrictMode ready
	
	  return ReactDOM.findDOMNode(container);
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	var Portal = React.forwardRef(function Portal(props, ref) {
	  var children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      onRendered = props.onRendered;
	
	  var _React$useState = React.useState(null),
	      mountNode = _React$useState[0],
	      setMountNode = _React$useState[1];
	
	  var handleRef = (0, _useForkRef.default)(React.isValidElement(children) ? children.ref : null, ref);
	  useEnhancedEffect(function () {
	    if (!disablePortal) {
	      setMountNode(getContainer(container) || document.body);
	    }
	  }, [container, disablePortal]);
	  useEnhancedEffect(function () {
	    if (mountNode && !disablePortal) {
	      (0, _setRef.default)(ref, mountNode);
	      return function () {
	        (0, _setRef.default)(ref, null);
	      };
	    }
	
	    return undefined;
	  }, [ref, mountNode, disablePortal]);
	  useEnhancedEffect(function () {
	    if (onRendered && (mountNode || disablePortal)) {
	      onRendered();
	    }
	  }, [onRendered, mountNode, disablePortal]);
	
	  if (disablePortal) {
	    if (React.isValidElement(children)) {
	      return React.cloneElement(children, {
	        ref: handleRef
	      });
	    }
	
	    return children;
	  }
	
	  return mountNode ? ReactDOM.createPortal(children, mountNode) : mountNode;
	});
	 false ? Portal.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Portal['propTypes' + ''] = (0, _utils.exactProp)(Portal.propTypes);
	}
	
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(236));
	
	var _RadioButtonIcon = _interopRequireDefault(__webpack_require__(834));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(138));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _useRadioGroup = _interopRequireDefault(__webpack_require__(330));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultCheckedIcon = /*#__PURE__*/React.createElement(_RadioButtonIcon.default, {
	  checked: true
	});
	var defaultIcon = /*#__PURE__*/React.createElement(_RadioButtonIcon.default, null);
	var Radio = React.forwardRef(function Radio(props, ref) {
	  var checkedProp = props.checked,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      nameProp = props.name,
	      onChangeProp = props.onChange,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "color", "name", "onChange", "size"]);
	  var radioGroup = (0, _useRadioGroup.default)();
	  var checked = checkedProp;
	  var onChange = (0, _createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
	  var name = nameProp;
	
	  if (radioGroup) {
	    if (typeof checked === 'undefined') {
	      checked = radioGroup.value === props.value;
	    }
	
	    if (typeof name === 'undefined') {
	      name = radioGroup.name;
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    color: color,
	    type: "radio",
	    icon: React.cloneElement(defaultIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    checkedIcon: React.cloneElement(defaultCheckedIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    name: name,
	    checked: checked,
	    onChange: onChange,
	    ref: ref
	  }, other));
	});
	 false ? Radio.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the radio will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the radio.
	   * `small` is equivalent to the dense radio styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiRadio'
	})(Radio);
	
	exports.default = _default;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(915));
	
	var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(914));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      '&$checked $layer': {
	        transform: 'scale(1)',
	        transition: theme.transitions.create('transform', {
	          easing: theme.transitions.easing.easeOut,
	          duration: theme.transitions.duration.shortest
	        })
	      }
	    },
	    layer: {
	      left: 0,
	      position: 'absolute',
	      transform: 'scale(0)',
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeIn,
	        duration: theme.transitions.duration.shortest
	      })
	    },
	    checked: {}
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	function RadioButtonIcon(props) {
	  var checked = props.checked,
	      classes = props.classes,
	      fontSize = props.fontSize;
	  return /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.root, checked && classes.checked)
	  }, /*#__PURE__*/React.createElement(_RadioButtonUnchecked.default, {
	    fontSize: fontSize
	  }), /*#__PURE__*/React.createElement(_RadioButtonChecked.default, {
	    fontSize: fontSize,
	    className: classes.layer
	  }));
	}
	
	 false ? RadioButtonIcon.propTypes = {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The size of the radio.
	   * `small` is equivalent to the dense radio styling.
	   */
	  fontSize: _propTypes.default.oneOf(['small', 'default'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateRadioButtonIcon'
	})(RadioButtonIcon);
	
	exports.default = _default;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	
	var _Radio = _interopRequireDefault(__webpack_require__(833));

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(317));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(95));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(329));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(238));
	
	var RadioGroup = React.forwardRef(function RadioGroup(props, ref) {
	  var actions = props.actions,
	      children = props.children,
	      nameProp = props.name,
	      valueProp = props.value,
	      onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "children", "name", "value", "onChange"]);
	  var rootRef = React.useRef(null);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: props.defaultValue,
	    name: 'RadioGroup'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  React.useImperativeHandle(actions, function () {
	    return {
	      focus: function focus() {
	        var input = rootRef.current.querySelector('input:not(:disabled):checked');
	
	        if (!input) {
	          input = rootRef.current.querySelector('input:not(:disabled)');
	        }
	
	        if (input) {
	          input.focus();
	        }
	      }
	    };
	  }, []);
	  var handleRef = (0, _useForkRef.default)(ref, rootRef);
	
	  var handleChange = function handleChange(event) {
	    setValue(event.target.value);
	
	    if (onChange) {
	      onChange(event, event.target.value);
	    }
	  };
	
	  var name = (0, _unstable_useId.default)(nameProp);
	  return /*#__PURE__*/React.createElement(_RadioGroupContext.default.Provider, {
	    value: {
	      name: name,
	      onChange: handleChange,
	      value: value
	    }
	  }, /*#__PURE__*/React.createElement(_FormGroup.default, (0, _extends2.default)({
	    role: "radiogroup",
	    ref: handleRef
	  }, other), children));
	});
	 false ? RadioGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The name used to reference the value of the control.
	   * If you don't provide this prop, it falls back to a randomly generated name.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when a radio button is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Value of the selected radio button. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	var _default = RadioGroup;
	exports.default = _default;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "useRadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _useRadioGroup.default;
	  }
	});
	
	var _RadioGroup = _interopRequireDefault(__webpack_require__(836));
	
	var _useRadioGroup = _interopRequireDefault(__webpack_require__(330));

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(216));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(155));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(701));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(697));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(698));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(21);
	
	var _setRef = _interopRequireDefault(__webpack_require__(94));
	
	function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	/**
	 * ⚠️⚠️⚠️
	 * If you want the DOM element of a Material-UI component check out
	 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
	 * first.
	 *
	 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
	 *
	 * Helper component to allow attaching a ref to a
	 * wrapped element to access the underlying DOM element.
	 *
	 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
	 * For example:
	 * ```jsx
	 * import React from 'react';
	 * import RootRef from '@material-ui/core/RootRef';
	 *
	 * function MyComponent() {
	 *   const domRef = React.useRef();
	 *
	 *   React.useEffect(() => {
	 *     console.log(domRef.current); // DOM node
	 *   }, []);
	 *
	 *   return (
	 *     <RootRef rootRef={domRef}>
	 *       <SomeChildComponent />
	 *     </RootRef>
	 *   );
	 * }
	 * ```
	 */
	var RootRef = /*#__PURE__*/function (_React$Component) {
	  (0, _inherits2.default)(RootRef, _React$Component);
	
	  var _super = _createSuper(RootRef);
	
	  function RootRef() {
	    (0, _classCallCheck2.default)(this, RootRef);
	    return _super.apply(this, arguments);
	  }
	
	  (0, _createClass2.default)(RootRef, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ref = ReactDOM.findDOMNode(this);
	      (0, _setRef.default)(this.props.rootRef, this.ref);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var ref = ReactDOM.findDOMNode(this);
	
	      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
	        if (prevProps.rootRef !== this.props.rootRef) {
	          (0, _setRef.default)(prevProps.rootRef, null);
	        }
	
	        this.ref = ref;
	        (0, _setRef.default)(this.props.rootRef, this.ref);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.ref = null;
	      (0, _setRef.default)(this.props.rootRef, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RootRef;
	}(React.Component);
	
	 false ? RootRef.propTypes = {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * A ref that points to the first DOM node of the wrapped element.
	   */
	  rootRef: _utils.refType.isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? RootRef.propTypes = (0, _utils.exactProp)(RootRef.propTypes) : void 0;
	}
	
	var _default = RootRef;
	exports.default = _default;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	
	var _RootRef = _interopRequireDefault(__webpack_require__(838));

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _styles = __webpack_require__(52);
	
	var _SelectInput = _interopRequireDefault(__webpack_require__(841));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(110));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(92));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(350));
	
	var _Input = _interopRequireDefault(__webpack_require__(160));
	
	var _NativeSelect = __webpack_require__(326);
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(327));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(223));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(227));
	
	var styles = _NativeSelect.styles;
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_Input.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_FilledInput.default, null);
	
	var Select = React.forwardRef(function Select(props, ref) {
	  var _props$autoWidth = props.autoWidth,
	      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
	      children = props.children,
	      classes = props.classes,
	      _props$displayEmpty = props.displayEmpty,
	      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      id = props.id,
	      input = props.input,
	      inputProps = props.inputProps,
	      label = props.label,
	      labelId = props.labelId,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      MenuProps = props.MenuProps,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$native = props.native,
	      native = _props$native === void 0 ? false : _props$native,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      renderValue = props.renderValue,
	      SelectDisplayProps = props.SelectDisplayProps,
	      _props$variant = props.variant,
	      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
	  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  var variant = fcs.variant || variantProps;
	  var InputComponent = input || {
	    standard: _ref,
	    outlined: /*#__PURE__*/React.createElement(_OutlinedInput.default, {
	      label: label,
	      labelWidth: labelWidth
	    }),
	    filled: _ref2
	  }[variant];
	  return React.cloneElement(InputComponent, (0, _extends2.default)({
	    // Most of the logic is implemented in `SelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: inputComponent,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      IconComponent: IconComponent,
	      variant: variant,
	      type: undefined,
	      // We render a select. We can ignore the type provided by the `Input`.
	      multiple: multiple
	    }, native ? {
	      id: id
	    } : {
	      autoWidth: autoWidth,
	      displayEmpty: displayEmpty,
	      labelId: labelId,
	      MenuProps: MenuProps,
	      onClose: onClose,
	      onOpen: onOpen,
	      open: open,
	      renderValue: renderValue,
	      SelectDisplayProps: (0, _extends2.default)({
	        id: id
	      }, SelectDisplayProps)
	    }, {}, inputProps, {
	      classes: inputProps ? (0, _styles.mergeClasses)({
	        baseClasses: classes,
	        newClasses: inputProps.classes,
	        Component: Select
	      }) : classes
	    }, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? Select.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   *
	   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, a value is displayed even if no items are selected.
	   *
	   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * The `id` of the wrapper element or the `select` elment when `native`.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   * When `native` is `true`, the attributes are applied on the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes.default.bool,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected when `native` is `false` (default).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` prop is `false` (default).
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * The input value. Providing an empty string will select no options.
	   * This prop is required when the `native` prop is `false` (default).
	   * Set to an empty string `''` if you don't want any of the available options to be selected.
	   *
	   * If the value is an object it must have reference equality with the option in order to be selected.
	   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	Select.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSelect'
	})(Select);
	
	exports.default = _default;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(79));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _utils = __webpack_require__(21);
	
	var _Menu = _interopRequireDefault(__webpack_require__(324));
	
	var _utils2 = __webpack_require__(225);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(95));
	
	function areEqualValues(a, b) {
	  if ((0, _typeof2.default)(b) === 'object' && b !== null) {
	    return a === b;
	  }
	
	  return String(a) === String(b);
	}
	
	function isEmpty(display) {
	  return display == null || typeof display === 'string' && !display.trim();
	}
	/**
	 * @ignore - internal component.
	 */
	
	
	var SelectInput = React.forwardRef(function SelectInput(props, ref) {
	  var ariaLabel = props['aria-label'],
	      autoFocus = props.autoFocus,
	      autoWidth = props.autoWidth,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      displayEmpty = props.displayEmpty,
	      IconComponent = props.IconComponent,
	      inputRefProp = props.inputRef,
	      labelId = props.labelId,
	      _props$MenuProps = props.MenuProps,
	      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
	      multiple = props.multiple,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onFocus = props.onFocus,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      readOnly = props.readOnly,
	      renderValue = props.renderValue,
	      required = props.required,
	      _props$SelectDisplayP = props.SelectDisplayProps,
	      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
	      tabIndexProp = props.tabIndex,
	      type = props.type,
	      valueProp = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'SelectInput'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  var inputRef = React.useRef(null);
	
	  var _React$useState = React.useState(null),
	      displayNode = _React$useState[0],
	      setDisplayNode = _React$useState[1];
	
	  var _React$useRef = React.useRef(openProp != null),
	      isOpenControlled = _React$useRef.current;
	
	  var _React$useState2 = React.useState(),
	      menuMinWidthState = _React$useState2[0],
	      setMenuMinWidthState = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      openState = _React$useState3[0],
	      setOpenState = _React$useState3[1];
	
	  var handleRef = (0, _useForkRef.default)(ref, inputRefProp);
	  React.useImperativeHandle(handleRef, function () {
	    return {
	      focus: function focus() {
	        displayNode.focus();
	      },
	      node: inputRef.current,
	      value: value
	    };
	  }, [displayNode, value]);
	  React.useEffect(function () {
	    if (autoFocus && displayNode) {
	      displayNode.focus();
	    }
	  }, [autoFocus, displayNode]);
	
	  var update = function update(open, event) {
	    if (open) {
	      if (onOpen) {
	        onOpen(event);
	      }
	    } else if (onClose) {
	      onClose(event);
	    }
	
	    if (!isOpenControlled) {
	      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
	      setOpenState(open);
	    }
	  };
	
	  var handleMouseDown = function handleMouseDown(event) {
	    // Ignore everything but left-click
	    if (event.button !== 0) {
	      return;
	    } // Hijack the default focus behavior.
	
	
	    event.preventDefault();
	    displayNode.focus();
	    update(true, event);
	  };
	
	  var handleClose = function handleClose(event) {
	    update(false, event);
	  };
	
	  var handleItemClick = function handleItemClick(child) {
	    return function (event) {
	      if (!multiple) {
	        update(false, event);
	      }
	
	      var newValue;
	
	      if (multiple) {
	        newValue = Array.isArray(value) ? (0, _toConsumableArray2.default)(value) : [];
	        var itemIndex = value.indexOf(child.props.value);
	
	        if (itemIndex === -1) {
	          newValue.push(child.props.value);
	        } else {
	          newValue.splice(itemIndex, 1);
	        }
	      } else {
	        newValue = child.props.value;
	      }
	
	      if (child.props.onClick) {
	        child.props.onClick(event);
	      }
	
	      if (value === newValue) {
	        return;
	      }
	
	      setValue(newValue);
	
	      if (onChange) {
	        event.persist(); // Preact support, target is read only property on a native event.
	
	        Object.defineProperty(event, 'target', {
	          writable: true,
	          value: {
	            value: newValue,
	            name: name
	          }
	        });
	        onChange(event, child);
	      }
	    };
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (!readOnly) {
	      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
	      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
	      'Enter'];
	
	      if (validKeys.indexOf(event.key) !== -1) {
	        event.preventDefault();
	        update(true, event);
	      }
	    }
	  };
	
	  var open = displayNode !== null && (isOpenControlled ? openProp : openState);
	
	  var handleBlur = function handleBlur(event) {
	    // if open event.stopImmediatePropagation
	    if (!open && onBlur) {
	      event.persist(); // Preact support, target is read only property on a native event.
	
	      Object.defineProperty(event, 'target', {
	        writable: true,
	        value: {
	          value: value,
	          name: name
	        }
	      });
	      onBlur(event);
	    }
	  };
	
	  delete other['aria-invalid'];
	  var display;
	  var displaySingle;
	  var displayMultiple = [];
	  var computeDisplay = false;
	  var foundMatch = false; // No need to display any value if the field is empty.
	
	  if ((0, _utils2.isFilled)({
	    value: value
	  }) || displayEmpty) {
	    if (renderValue) {
	      display = renderValue(value);
	    } else {
	      computeDisplay = true;
	    }
	  }
	
	  var items = React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var selected;
	
	    if (multiple) {
	      if (!Array.isArray(value)) {
	        throw new Error('Material-UI: the `value` prop must be an array ' + 'when using the `Select` component with `multiple`.');
	      }
	
	      selected = value.some(function (v) {
	        return areEqualValues(v, child.props.value);
	      });
	
	      if (selected && computeDisplay) {
	        displayMultiple.push(child.props.children);
	      }
	    } else {
	      selected = areEqualValues(value, child.props.value);
	
	      if (selected && computeDisplay) {
	        displaySingle = child.props.children;
	      }
	    }
	
	    if (selected) {
	      foundMatch = true;
	    }
	
	    return React.cloneElement(child, {
	      'aria-selected': selected ? 'true' : undefined,
	      onClick: handleItemClick(child),
	      onKeyUp: function onKeyUp(event) {
	        if (event.key === ' ') {
	          // otherwise our MenuItems dispatches a click event
	          // it's not behavior of the native <option> and causes
	          // the select to close immediately since we open on space keydown
	          event.preventDefault();
	        }
	
	        if (child.props.onKeyUp) {
	          child.props.onKeyUp(event);
	        }
	      },
	      role: 'option',
	      selected: selected,
	      value: undefined,
	      // The value is most likely not a valid HTML attribute.
	      'data-value': child.props.value // Instead, we provide it as a data attribute.
	
	    });
	  });
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (!foundMatch && !multiple && value !== '') {
	        var values = React.Children.toArray(children).map(function (child) {
	          return child.props.value;
	        });
	        console.warn(["Material-UI: you have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
	          return x != null;
	        }).map(function (x) {
	          return "`".concat(x, "`");
	        }).join(', ') || '""', ".")].join('\n'));
	      }
	    }, [foundMatch, children, multiple, name, value]);
	  }
	
	  if (computeDisplay) {
	    display = multiple ? displayMultiple.join(', ') : displaySingle;
	  } // Avoid performing a layout computation in the render method.
	
	
	  var menuMinWidth = menuMinWidthState;
	
	  if (!autoWidth && isOpenControlled && displayNode) {
	    menuMinWidth = displayNode.clientWidth;
	  }
	
	  var tabIndex;
	
	  if (typeof tabIndexProp !== 'undefined') {
	    tabIndex = tabIndexProp;
	  } else {
	    tabIndex = disabled ? null : 0;
	  }
	
	  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
	    ref: setDisplayNode,
	    tabIndex: tabIndex,
	    role: "button",
	    "aria-disabled": disabled ? 'true' : undefined,
	    "aria-expanded": open ? 'true' : undefined,
	    "aria-haspopup": "listbox",
	    "aria-label": ariaLabel,
	    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
	    onKeyDown: handleKeyDown,
	    onMouseDown: disabled || readOnly ? null : handleMouseDown,
	    onBlur: handleBlur,
	    onFocus: onFocus
	  }, SelectDisplayProps, {
	    // The id is required for proper a11y
	    id: buttonId
	  }), isEmpty(display) ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : display), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    value: Array.isArray(value) ? value.join(',') : value,
	    name: name,
	    ref: inputRef,
	    type: "hidden",
	    autoFocus: autoFocus
	  }, other)), /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
	  }), /*#__PURE__*/React.createElement(_Menu.default, (0, _extends2.default)({
	    id: "menu-".concat(name || ''),
	    anchorEl: displayNode,
	    open: open,
	    onClose: handleClose
	  }, MenuProps, {
	    MenuListProps: (0, _extends2.default)({
	      'aria-labelledby': labelId,
	      role: 'listbox',
	      disableListWrap: true
	    }, MenuProps.MenuListProps),
	    PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
	      style: (0, _extends2.default)({
	        minWidth: menuMinWidth
	      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
	    })
	  }), items));
	});
	 false ? SelectInput.propTypes = {
	  /**
	   * @ignore
	   */
	  'aria-label': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<MenuItem>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
	   * Equivalent to `ref`
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.any,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = SelectInput;
	exports.default = _default;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(143);
	
	var _utils = __webpack_require__(34);
	
	var _Slide = _interopRequireDefault(__webpack_require__(331));
	
	/**
	 * @ignore - internal component.
	 */
	var StrictModeSlide = React.forwardRef(function StrictModeSlide(props, forwardedRef) {
	  var domRef = React.useRef(null);
	  var ref = (0, _utils.useForkRef)(domRef, forwardedRef);
	  return /*#__PURE__*/React.createElement(_Slide.default, (0, _extends2.default)({}, props, {
	    findDOMNode: function findDOMNode() {
	      return domRef.current;
	    },
	    ref: ref,
	    TransitionComponent: _reactTransitionGroup.Transition
	  }));
	});
	var _default = StrictModeSlide;
	exports.default = _default;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(140));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(95));
	
	var _ValueLabel = _interopRequireDefault(__webpack_require__(844));
	
	function asc(a, b) {
	  return a - b;
	}
	
	function clamp(value, min, max) {
	  return Math.min(Math.max(min, value), max);
	}
	
	function findClosest(values, currentValue) {
	  var _values$reduce = values.reduce(function (acc, value, index) {
	    var distance = Math.abs(currentValue - value);
	
	    if (acc === null || distance < acc.distance || distance === acc.distance) {
	      return {
	        distance: distance,
	        index: index
	      };
	    }
	
	    return acc;
	  }, null),
	      closestIndex = _values$reduce.index;
	
	  return closestIndex;
	}
	
	function trackFinger(event, touchId) {
	  if (touchId.current !== undefined && event.changedTouches) {
	    for (var i = 0; i < event.changedTouches.length; i += 1) {
	      var touch = event.changedTouches[i];
	
	      if (touch.identifier === touchId.current) {
	        return {
	          x: touch.clientX,
	          y: touch.clientY
	        };
	      }
	    }
	
	    return false;
	  }
	
	  return {
	    x: event.clientX,
	    y: event.clientY
	  };
	}
	
	function valueToPercent(value, min, max) {
	  return (value - min) * 100 / (max - min);
	}
	
	function percentToValue(percent, min, max) {
	  return (max - min) * percent + min;
	}
	
	function getDecimalPrecision(num) {
	  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
	  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
	  if (Math.abs(num) < 1) {
	    var parts = num.toExponential().split('e-');
	    var matissaDecimalPart = parts[0].split('.')[1];
	    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
	  }
	
	  var decimalPart = num.toString().split('.')[1];
	  return decimalPart ? decimalPart.length : 0;
	}
	
	function roundValueToStep(value, step, min) {
	  var nearest = Math.round((value - min) / step) * step + min;
	  return Number(nearest.toFixed(getDecimalPrecision(step)));
	}
	
	function setValueIndex(_ref) {
	  var values = _ref.values,
	      source = _ref.source,
	      newValue = _ref.newValue,
	      index = _ref.index;
	
	  // Performance shortcut
	  if (values[index] === newValue) {
	    return source;
	  }
	
	  var output = (0, _toConsumableArray2.default)(values);
	  output[index] = newValue;
	  return output;
	}
	
	function focusThumb(_ref2) {
	  var sliderRef = _ref2.sliderRef,
	      activeIndex = _ref2.activeIndex,
	      setActive = _ref2.setActive;
	
	  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
	    sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
	  }
	
	  if (setActive) {
	    setActive(activeIndex);
	  }
	}
	
	var axisProps = {
	  horizontal: {
	    offset: function offset(percent) {
	      return {
	        left: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  'horizontal-reverse': {
	    offset: function offset(percent) {
	      return {
	        right: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  vertical: {
	    offset: function offset(percent) {
	      return {
	        bottom: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        height: "".concat(percent, "%")
	      };
	    }
	  }
	};
	
	var Identity = function Identity(x) {
	  return x;
	};
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 2,
	      width: '100%',
	      boxSizing: 'content-box',
	      padding: '13px 0',
	      display: 'inline-block',
	      position: 'relative',
	      cursor: 'pointer',
	      touchAction: 'none',
	      color: theme.palette.primary.main,
	      WebkitTapHighlightColor: 'transparent',
	      '&$disabled': {
	        pointerEvents: 'none',
	        cursor: 'default',
	        color: theme.palette.grey[400]
	      },
	      '&$vertical': {
	        width: 2,
	        height: '100%',
	        padding: '0 13px'
	      },
	      // The primary input mechanism of the device includes a pointing device of limited accuracy.
	      '@media (pointer: coarse)': {
	        // Reach 42px touch target, about ~8mm on screen.
	        padding: '20px 0',
	        '&$vertical': {
	          padding: '0 20px'
	        }
	      },
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {// TODO v5: move the style here
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `marks` is provided with at least one label. */
	    marked: {
	      marginBottom: 20,
	      '&$vertical': {
	        marginBottom: 'auto',
	        marginRight: 20
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
	    vertical: {},
	
	    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the rail element. */
	    rail: {
	      display: 'block',
	      position: 'absolute',
	      width: '100%',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      opacity: 0.38,
	      '$vertical &': {
	        height: '100%',
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      display: 'block',
	      position: 'absolute',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      '$vertical &': {
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element if `track={false}`. */
	    trackFalse: {
	      '& $track': {
	        display: 'none'
	      }
	    },
	
	    /* Styles applied to the track element if `track="inverted"`. */
	    trackInverted: {
	      '& $track': {
	        backgroundColor: // Same logic as the LinearProgress track color
	        theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(theme.palette.primary.main, 0.62) : (0, _colorManipulator.darken)(theme.palette.primary.main, 0.5)
	      },
	      '& $rail': {
	        opacity: 1
	      }
	    },
	
	    /* Styles applied to the thumb element. */
	    thumb: {
	      position: 'absolute',
	      width: 12,
	      height: 12,
	      marginLeft: -6,
	      marginTop: -5,
	      boxSizing: 'border-box',
	      borderRadius: '50%',
	      outline: 0,
	      backgroundColor: 'currentColor',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      transition: theme.transitions.create(['box-shadow'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&::after': {
	        position: 'absolute',
	        content: '""',
	        borderRadius: '50%',
	        // reach 42px hit target (2 * 15 + thumb diameter)
	        left: -15,
	        top: -15,
	        right: -15,
	        bottom: -15
	      },
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16)),
	        '@media (hover: none)': {
	          boxShadow: 'none'
	        }
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16))
	      },
	      '&$disabled': {
	        width: 8,
	        height: 8,
	        marginLeft: -4,
	        marginTop: -3,
	        '&:hover': {
	          boxShadow: 'none'
	        }
	      },
	      '$vertical &': {
	        marginLeft: -5,
	        marginBottom: -6
	      },
	      '$vertical &$disabled': {
	        marginLeft: -3,
	        marginBottom: -4
	      }
	    },
	
	    /* Styles applied to the thumb element if `color="primary"`. */
	    thumbColorPrimary: {// TODO v5: move the style here
	    },
	
	    /* Styles applied to the thumb element if `color="secondary"`. */
	    thumbColorSecondary: {
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      }
	    },
	
	    /* Pseudo-class applied to the thumb element if it's active. */
	    active: {},
	
	    /* Pseudo-class applied to the thumb element if keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the thumb label element. */
	    valueLabel: {},
	
	    /* Styles applied to the mark element. */
	    mark: {
	      position: 'absolute',
	      width: 2,
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the mark element if active (depending on the value). */
	    markActive: {
	      backgroundColor: theme.palette.background.paper,
	      opacity: 0.8
	    },
	
	    /* Styles applied to the mark label element. */
	    markLabel: (0, _extends2.default)({}, theme.typography.body2, {
	      color: theme.palette.text.secondary,
	      position: 'absolute',
	      top: 26,
	      transform: 'translateX(-50%)',
	      whiteSpace: 'nowrap',
	      '$vertical &': {
	        top: 'auto',
	        left: 26,
	        transform: 'translateY(50%)'
	      },
	      '@media (pointer: coarse)': {
	        top: 40,
	        '$vertical &': {
	          left: 31
	        }
	      }
	    }),
	
	    /* Styles applied to the mark label element if active (depending on the value). */
	    markLabelActive: {
	      color: theme.palette.text.primary
	    }
	  };
	};
	
	exports.styles = styles;
	var Slider = React.forwardRef(function Slider(props, ref) {
	  var ariaLabel = props['aria-label'],
	      ariaLabelledby = props['aria-labelledby'],
	      ariaValuetext = props['aria-valuetext'],
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      getAriaLabel = props.getAriaLabel,
	      getAriaValueText = props.getAriaValueText,
	      _props$marks = props.marks,
	      marksProp = _props$marks === void 0 ? false : _props$marks,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 100 : _props$max,
	      _props$min = props.min,
	      min = _props$min === void 0 ? 0 : _props$min,
	      name = props.name,
	      onChange = props.onChange,
	      onChangeCommitted = props.onChangeCommitted,
	      onMouseDown = props.onMouseDown,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$scale = props.scale,
	      scale = _props$scale === void 0 ? Identity : _props$scale,
	      _props$step = props.step,
	      step = _props$step === void 0 ? 1 : _props$step,
	      _props$ThumbComponent = props.ThumbComponent,
	      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
	      _props$track = props.track,
	      track = _props$track === void 0 ? 'normal' : _props$track,
	      valueProp = props.value,
	      _props$ValueLabelComp = props.ValueLabelComponent,
	      ValueLabelComponent = _props$ValueLabelComp === void 0 ? _ValueLabel.default : _props$ValueLabelComp,
	      _props$valueLabelDisp = props.valueLabelDisplay,
	      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
	      _props$valueLabelForm = props.valueLabelFormat,
	      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);
	  var theme = (0, _useTheme.default)();
	  var touchId = React.useRef(); // We can't use the :active browser pseudo-classes.
	  // - The active state isn't triggered when clicking on the rail.
	  // - The active state isn't transfered when inversing a range slider.
	
	  var _React$useState = React.useState(-1),
	      active = _React$useState[0],
	      setActive = _React$useState[1];
	
	  var _React$useState2 = React.useState(-1),
	      open = _React$useState2[0],
	      setOpen = _React$useState2[1];
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'Slider'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      valueDerived = _useControlled2[0],
	      setValueState = _useControlled2[1];
	
	  var range = Array.isArray(valueDerived);
	  var instanceRef = React.useRef();
	  var values = range ? (0, _toConsumableArray2.default)(valueDerived).sort(asc) : [valueDerived];
	  values = values.map(function (value) {
	    return clamp(value, min, max);
	  });
	  var marks = marksProp === true && step !== null ? (0, _toConsumableArray2.default)(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
	    return {
	      value: min + step * index
	    };
	  }) : marksProp || [];
	  instanceRef.current = {
	    source: valueDerived // Keep track of the input value to leverage immutable state comparison.
	
	  };
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState3 = React.useState(-1),
	      focusVisible = _React$useState3[0],
	      setFocusVisible = _React$useState3[1];
	
	  var sliderRef = React.useRef();
	  var handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, sliderRef);
	  var handleRef = (0, _useForkRef.default)(ref, handleFocusRef);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(index);
	    }
	
	    setOpen(index);
	  });
	  var handleBlur = (0, _useEventCallback.default)(function () {
	    if (focusVisible !== -1) {
	      setFocusVisible(-1);
	      onBlurVisible();
	    }
	
	    setOpen(-1);
	  });
	  var handleMouseOver = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    setOpen(index);
	  });
	  var handleMouseLeave = (0, _useEventCallback.default)(function () {
	    setOpen(-1);
	  });
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    var value = values[index];
	    var tenPercents = (max - min) / 10;
	    var marksValues = marks.map(function (mark) {
	      return mark.value;
	    });
	    var marksIndex = marksValues.indexOf(value);
	    var newValue;
	
	    switch (event.key) {
	      case 'Home':
	        newValue = min;
	        break;
	
	      case 'End':
	        newValue = max;
	        break;
	
	      case 'PageUp':
	        if (step) {
	          newValue = value + tenPercents;
	        }
	
	        break;
	
	      case 'PageDown':
	        if (step) {
	          newValue = value - tenPercents;
	        }
	
	        break;
	
	      case 'ArrowRight':
	      case 'ArrowUp':
	        if (step) {
	          newValue = value + step;
	        } else {
	          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
	        }
	
	        break;
	
	      case 'ArrowLeft':
	      case 'ArrowDown':
	        if (step) {
	          newValue = value - step;
	        } else {
	          newValue = marksValues[marksIndex - 1] || marksValues[0];
	        }
	
	        break;
	
	      default:
	        return;
	    } // Prevent scroll of the page
	
	
	    event.preventDefault();
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step, min);
	    }
	
	    newValue = clamp(newValue, min, max);
	
	    if (range) {
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values,
	        source: valueDerived,
	        newValue: newValue,
	        index: index
	      }).sort(asc);
	      focusThumb({
	        sliderRef: sliderRef,
	        activeIndex: newValue.indexOf(previousValue)
	      });
	    }
	
	    setValueState(newValue);
	    setFocusVisible(index);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	  });
	  var previousIndex = React.useRef();
	  var axis = orientation;
	
	  if (theme.direction === 'rtl' && orientation !== "vertical") {
	    axis += '-reverse';
	  }
	
	  var getFingerNewValue = function getFingerNewValue(_ref3) {
	    var finger = _ref3.finger,
	        _ref3$move = _ref3.move,
	        move = _ref3$move === void 0 ? false : _ref3$move,
	        values2 = _ref3.values,
	        source = _ref3.source;
	    var slider = sliderRef.current;
	
	    var _slider$getBoundingCl = slider.getBoundingClientRect(),
	        width = _slider$getBoundingCl.width,
	        height = _slider$getBoundingCl.height,
	        bottom = _slider$getBoundingCl.bottom,
	        left = _slider$getBoundingCl.left;
	
	    var percent;
	
	    if (axis.indexOf('vertical') === 0) {
	      percent = (bottom - finger.y) / height;
	    } else {
	      percent = (finger.x - left) / width;
	    }
	
	    if (axis.indexOf('-reverse') !== -1) {
	      percent = 1 - percent;
	    }
	
	    var newValue;
	    newValue = percentToValue(percent, min, max);
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step, min);
	    } else {
	      var marksValues = marks.map(function (mark) {
	        return mark.value;
	      });
	      var closestIndex = findClosest(marksValues, newValue);
	      newValue = marksValues[closestIndex];
	    }
	
	    newValue = clamp(newValue, min, max);
	    var activeIndex = 0;
	
	    if (range) {
	      if (!move) {
	        activeIndex = findClosest(values2, newValue);
	      } else {
	        activeIndex = previousIndex.current;
	      }
	
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values2,
	        source: source,
	        newValue: newValue,
	        index: activeIndex
	      }).sort(asc);
	      activeIndex = newValue.indexOf(previousValue);
	      previousIndex.current = activeIndex;
	    }
	
	    return {
	      newValue: newValue,
	      activeIndex: activeIndex
	    };
	  };
	
	  var handleTouchMove = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue = getFingerNewValue({
	      finger: finger,
	      move: true,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue.newValue,
	        activeIndex = _getFingerNewValue.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	  });
	  var handleTouchEnd = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue2 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue2.newValue;
	
	    setActive(-1);
	
	    if (event.type === 'touchend') {
	      setOpen(-1);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	
	    touchId.current = undefined;
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.removeEventListener('mousemove', handleTouchMove);
	    doc.removeEventListener('mouseup', handleTouchEnd);
	    doc.removeEventListener('touchmove', handleTouchMove);
	    doc.removeEventListener('touchend', handleTouchEnd);
	  });
	  var handleTouchStart = (0, _useEventCallback.default)(function (event) {
	    // Workaround as Safari has partial support for touchAction: 'none'.
	    event.preventDefault();
	    var touch = event.changedTouches[0];
	
	    if (touch != null) {
	      // A number that uniquely identifies the current finger in the touch session.
	      touchId.current = touch.identifier;
	    }
	
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue3 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue3.newValue,
	        activeIndex = _getFingerNewValue3.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.addEventListener('touchmove', handleTouchMove);
	    doc.addEventListener('touchend', handleTouchEnd);
	  });
	  React.useEffect(function () {
	    var slider = sliderRef.current;
	    slider.addEventListener('touchstart', handleTouchStart);
	    var doc = (0, _ownerDocument.default)(slider);
	    return function () {
	      slider.removeEventListener('touchstart', handleTouchStart);
	      doc.removeEventListener('mousemove', handleTouchMove);
	      doc.removeEventListener('mouseup', handleTouchEnd);
	      doc.removeEventListener('touchmove', handleTouchMove);
	      doc.removeEventListener('touchend', handleTouchEnd);
	    };
	  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
	  var handleMouseDown = (0, _useEventCallback.default)(function (event) {
	    if (onMouseDown) {
	      onMouseDown(event);
	    }
	
	    event.preventDefault();
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue4 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue4.newValue,
	        activeIndex = _getFingerNewValue4.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.addEventListener('mousemove', handleTouchMove);
	    doc.addEventListener('mouseup', handleTouchEnd);
	  });
	  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
	  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
	  var trackStyle = (0, _extends2.default)({}, axisProps[axis].offset(trackOffset), {}, axisProps[axis].leap(trackLeap));
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: handleRef,
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
	      return mark.label;
	    }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
	    onMouseDown: handleMouseDown
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.rail
	  }), /*#__PURE__*/React.createElement("span", {
	    className: classes.track,
	    style: trackStyle
	  }), /*#__PURE__*/React.createElement("input", {
	    value: values.join(','),
	    name: name,
	    type: "hidden"
	  }), marks.map(function (mark, index) {
	    var percent = valueToPercent(mark.value, min, max);
	    var style = axisProps[axis].offset(percent);
	    var markActive;
	
	    if (track === false) {
	      markActive = values.indexOf(mark.value) !== -1;
	    } else {
	      markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
	    }
	
	    return /*#__PURE__*/React.createElement(React.Fragment, {
	      key: mark.value
	    }, /*#__PURE__*/React.createElement("span", {
	      style: style,
	      "data-index": index,
	      className: (0, _clsx.default)(classes.mark, markActive && classes.markActive)
	    }), mark.label != null ? /*#__PURE__*/React.createElement("span", {
	      "aria-hidden": true,
	      "data-index": index,
	      style: style,
	      className: (0, _clsx.default)(classes.markLabel, markActive && classes.markLabelActive)
	    }, mark.label) : null);
	  }), values.map(function (value, index) {
	    var percent = valueToPercent(value, min, max);
	    var style = axisProps[axis].offset(percent);
	    return /*#__PURE__*/React.createElement(ValueLabelComponent, {
	      key: index,
	      valueLabelFormat: valueLabelFormat,
	      valueLabelDisplay: valueLabelDisplay,
	      className: classes.valueLabel,
	      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
	      index: index,
	      open: open === index || active === index || valueLabelDisplay === 'on',
	      disabled: disabled
	    }, /*#__PURE__*/React.createElement(ThumbComponent, {
	      className: (0, _clsx.default)(classes.thumb, classes["thumbColor".concat((0, _capitalize.default)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
	      tabIndex: disabled ? null : 0,
	      role: "slider",
	      style: style,
	      "data-index": index,
	      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
	      "aria-labelledby": ariaLabelledby,
	      "aria-orientation": orientation,
	      "aria-valuemax": scale(max),
	      "aria-valuemin": scale(min),
	      "aria-valuenow": scale(value),
	      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
	      onKeyDown: handleKeyDown,
	      onFocus: handleFocus,
	      onBlur: handleBlur,
	      onMouseOver: handleMouseOver,
	      onMouseLeave: handleMouseLeave
	    }));
	  }));
	});
	 false ? Slider.propTypes = {
	  /**
	   * The label of the slider.
	   */
	  'aria-label': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-label'] != null) {
	      return new Error('Material-UI: you need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The id of the element containing a label for the slider.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * A string value that provides a user-friendly name for the current value of the slider.
	   */
	  'aria-valuetext': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-valuetext'] != null) {
	      return new Error('Material-UI: you need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * If `true`, the slider will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
	   *
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaLabel: _propTypes.default.func,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
	   *
	   * @param {number} value The thumb label's value to format.
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaValueText: _propTypes.default.func,
	
	  /**
	   * Marks indicate predetermined values to which the user can move the slider.
	   * If `true` the marks will be spaced according the value of the `step` prop.
	   * If an array, it should contain objects with `value` and an optional `label` keys.
	   */
	  marks: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.array]),
	
	  /**
	   * The maximum allowed value of the slider.
	   * Should not be equal to min.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * The minimum allowed value of the slider.
	   * Should not be equal to max.
	   */
	  min: _propTypes.default.number,
	
	  /**
	   * Name attribute of the hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number | number[]} value The new value.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback function that is fired when the `mouseup` is triggered.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number | number[]} value The new value.
	   */
	  onChangeCommitted: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * The slider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * A transformation function, to change the scale of the slider.
	   */
	  scale: _propTypes.default.func,
	
	  /**
	   * The granularity with which the slider can step through values. (A "discrete" slider.)
	   * The `min` prop serves as the origin for the valid values.
	   * We recommend (max - min) to be evenly divisible by the step.
	   *
	   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
	   */
	  step: _propTypes.default.number,
	
	  /**
	   * The component used to display the value label.
	   */
	  ThumbComponent: _propTypes.default.elementType,
	
	  /**
	   * The track presentation:
	   *
	   * - `normal` the track will render a bar representing the slider value.
	   * - `inverted` the track will render a bar representing the remaining slider value.
	   * - `false` the track will render without a bar.
	   */
	  track: _propTypes.default.oneOf(['normal', false, 'inverted']),
	
	  /**
	   * The value of the slider.
	   * For ranged sliders, provide an array with two values.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * The value label component.
	   */
	  ValueLabelComponent: _propTypes.default.elementType,
	
	  /**
	   * Controls when the value label is displayed:
	   *
	   * - `auto` the value label will display when the thumb is hovered or focused.
	   * - `on` will display persistently.
	   * - `off` will never display.
	   */
	  valueLabelDisplay: _propTypes.default.oneOf(['on', 'auto', 'off']),
	
	  /**
	   * The format function the value label's value.
	   *
	   * When a function is provided, it should have the following signature:
	   *
	   * - {number} value The value label's value to format
	   * - {number} index The value label's index to format
	   */
	  valueLabelFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSlider'
	})(Slider);
	
	exports.default = _default;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    thumb: {
	      '&$open': {
	        '& $offset': {
	          transform: 'scale(1) translateY(-10px)'
	        }
	      }
	    },
	    open: {},
	    offset: (0, _extends2.default)({
	      zIndex: 1
	    }, theme.typography.body2, {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.2,
	      transition: theme.transitions.create(['transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      top: -34,
	      transformOrigin: 'bottom center',
	      transform: 'scale(0)',
	      position: 'absolute'
	    }),
	    circle: {
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: 32,
	      height: 32,
	      borderRadius: '50% 50% 50% 0',
	      backgroundColor: 'currentColor',
	      transform: 'rotate(-45deg)'
	    },
	    label: {
	      color: theme.palette.primary.contrastText,
	      transform: 'rotate(45deg)'
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function ValueLabel(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      open = props.open,
	      value = props.value,
	      valueLabelDisplay = props.valueLabelDisplay;
	
	  if (valueLabelDisplay === 'off') {
	    return children;
	  }
	
	  return React.cloneElement(children, {
	    className: (0, _clsx.default)(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
	  }, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.offset, className)
	  }, /*#__PURE__*/React.createElement("span", {
	    className: classes.circle
	  }, /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, value))));
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateValueLabel'
	})(ValueLabel);
	
	exports.default = _default;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	
	var _Slider = _interopRequireDefault(__webpack_require__(843));

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends8 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _transitions = __webpack_require__(60);
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(109));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(138));
	
	var _Grow = _interopRequireDefault(__webpack_require__(80));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(332));
	
	var styles = function styles(theme) {
	  var top1 = {
	    top: 8
	  };
	  var bottom1 = {
	    bottom: 8
	  };
	  var right = {
	    justifyContent: 'flex-end'
	  };
	  var left = {
	    justifyContent: 'flex-start'
	  };
	  var top3 = {
	    top: 24
	  };
	  var bottom3 = {
	    bottom: 24
	  };
	  var right3 = {
	    right: 24
	  };
	  var left3 = {
	    left: 24
	  };
	  var center = {
	    left: '50%',
	    right: 'auto',
	    transform: 'translateX(-50%)'
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      zIndex: theme.zIndex.snackbar,
	      position: 'fixed',
	      display: 'flex',
	      left: 8,
	      right: 8,
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
	    anchorOriginTopCenter: (0, _extends8.default)({}, top1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, top3, {}, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
	    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, bottom3, {}, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
	    anchorOriginTopRight: (0, _extends8.default)({}, top1, {}, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, top3, {}, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
	    anchorOriginBottomRight: (0, _extends8.default)({}, bottom1, {}, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, bottom3, {}, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
	    anchorOriginTopLeft: (0, _extends8.default)({}, top1, {}, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, top3, {}, left3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
	    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom1, {}, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, bottom3, {}, left3)))
	  };
	};
	
	exports.styles = styles;
	var Snackbar = React.forwardRef(function Snackbar(props, ref) {
	  var action = props.action,
	      _props$anchorOrigin = props.anchorOrigin;
	  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'bottom',
	    horizontal: 'center'
	  } : _props$anchorOrigin;
	  var vertical = _props$anchorOrigin.vertical,
	      horizontal = _props$anchorOrigin.horizontal,
	      _props$autoHideDurati = props.autoHideDuration,
	      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      ClickAwayListenerProps = props.ClickAwayListenerProps,
	      ContentProps = props.ContentProps,
	      _props$disableWindowB = props.disableWindowBlurListener,
	      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
	      message = props.message,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      onMouseEnter = props.onMouseEnter,
	      onMouseLeave = props.onMouseLeave,
	      open = props.open,
	      resumeHideDuration = props.resumeHideDuration,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  } : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var timerAutoHide = React.useRef();
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var handleClose = (0, _useEventCallback.default)(function () {
	    if (onClose) {
	      onClose.apply(void 0, arguments);
	    }
	  });
	  var setAutoHideTimer = (0, _useEventCallback.default)(function (autoHideDurationParam) {
	    if (!onClose || autoHideDurationParam == null) {
	      return;
	    }
	
	    clearTimeout(timerAutoHide.current);
	    timerAutoHide.current = setTimeout(function () {
	      handleClose(null, 'timeout');
	    }, autoHideDurationParam);
	  });
	  React.useEffect(function () {
	    if (open) {
	      setAutoHideTimer(autoHideDuration);
	    }
	
	    return function () {
	      clearTimeout(timerAutoHide.current);
	    };
	  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
	  // or when the user hide the window.
	
	  var handlePause = function handlePause() {
	    clearTimeout(timerAutoHide.current);
	  }; // Restart the timer when the user is no longer interacting with the Snackbar
	  // or when the window is shown back.
	
	
	  var handleResume = React.useCallback(function () {
	    if (autoHideDuration != null) {
	      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
	    }
	  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
	
	  var handleMouseEnter = function handleMouseEnter(event) {
	    if (onMouseEnter) {
	      onMouseEnter(event);
	    }
	
	    handlePause();
	  };
	
	  var handleMouseLeave = function handleMouseLeave(event) {
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	
	    handleResume();
	  };
	
	  var handleClickAway = function handleClickAway(event) {
	    if (onClose) {
	      onClose(event, 'clickaway');
	    }
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	  };
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  React.useEffect(function () {
	    if (!disableWindowBlurListener && open) {
	      window.addEventListener('focus', handleResume);
	      window.addEventListener('blur', handlePause);
	      return function () {
	        window.removeEventListener('focus', handleResume);
	        window.removeEventListener('blur', handlePause);
	      };
	    }
	
	    return undefined;
	  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.
	
	  if (!open && exited) {
	    return null;
	  }
	
	  return /*#__PURE__*/React.createElement(_ClickAwayListener.default, (0, _extends8.default)({
	    onClickAway: handleClickAway
	  }, ClickAwayListenerProps), /*#__PURE__*/React.createElement("div", (0, _extends8.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchorOrigin".concat((0, _capitalize.default)(vertical)).concat((0, _capitalize.default)(horizontal))], className),
	    onMouseEnter: handleMouseEnter,
	    onMouseLeave: handleMouseLeave,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends8.default)({
	    appear: true,
	    in: open,
	    onEnter: (0, _createChainedFunction.default)(handleEnter, onEnter),
	    onEntered: onEntered,
	    onEntering: onEntering,
	    onExit: onExit,
	    onExited: (0, _createChainedFunction.default)(handleExited, onExited),
	    onExiting: onExiting,
	    timeout: transitionDuration,
	    direction: vertical === 'top' ? 'down' : 'up'
	  }, TransitionProps), children || /*#__PURE__*/React.createElement(_SnackbarContent.default, (0, _extends8.default)({
	    message: message,
	    action: action
	  }, ContentProps)))));
	});
	 false ? Snackbar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the snackbar.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The anchor of the `Snackbar`.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['center', 'left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The number of milliseconds to wait before automatically calling the
	   * `onClose` function. `onClose` should then set the state of the `open`
	   * prop to hide the Snackbar. This behavior is disabled by default with
	   * the `null` value.
	   */
	  autoHideDuration: _propTypes.default.number,
	
	  /**
	   * Replace the `SnackbarContent` component.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `ClickAwayListener` element.
	   */
	  ClickAwayListenerProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
	   */
	  ContentProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
	   */
	  disableWindowBlurListener: _propTypes.default.bool,
	
	  /**
	   * When displaying multiple consecutive Snackbars from a parent rendering a single
	   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
	   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
	   * features such as autoHideDuration may be canceled.
	   */
	  key: _propTypes.default.any,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Typically `onClose` is used to set state in the parent component,
	   * which is used to control the `Snackbar` `open` prop.
	   * The `reason` parameter can optionally be used to control the response to `onClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * If `true`, `Snackbar` is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before dismissing after user interaction.
	   * If `autoHideDuration` prop isn't specified, it does nothing.
	   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
	   * we default to `autoHideDuration / 2` ms.
	   */
	  resumeHideDuration: _propTypes.default.number,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiSnackbar'
	})(Snackbar);
	
	exports.default = _default;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	
	var _Snackbar = _interopRequireDefault(__webpack_require__(846));

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var _colorManipulator = __webpack_require__(41);
	
	var styles = function styles(theme) {
	  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
	  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.body2, (0, _defineProperty2.default)({
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      display: 'flex',
	      alignItems: 'center',
	      flexWrap: 'wrap',
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      flexGrow: 1
	    }, theme.breakpoints.up('sm'), {
	      flexGrow: 'initial',
	      minWidth: 288
	    })),
	
	    /* Styles applied to the message wrapper element. */
	    message: {
	      padding: '8px 0'
	    },
	
	    /* Styles applied to the action wrapper element if `action` is provided. */
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: 16,
	      marginRight: -8
	    }
	  };
	};
	
	exports.styles = styles;
	var SnackbarContent = React.forwardRef(function SnackbarContent(props, ref) {
	  var action = props.action,
	      classes = props.classes,
	      className = props.className,
	      message = props.message,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'alert' : _props$role,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message", "role"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends3.default)({
	    role: role,
	    square: true,
	    elevation: 6,
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: classes.message
	  }, message), action ? /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action) : null);
	});
	 false ? SnackbarContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the snackbar.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * The ARIA role attribute of the element.
	   */
	  role: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSnackbarContent'
	})(SnackbarContent);
	
	exports.default = _default;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    paddingLeft: 8,
	    paddingRight: 8
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {},
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    flex: 1,
	    position: 'relative'
	  },
	
	  /* Pseudo-class applied to the root element if `completed={true}`. */
	  completed: {}
	};
	exports.styles = styles;
	var Step = React.forwardRef(function Step(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      connector = props.connector,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$expanded = props.expanded,
	      expanded = _props$expanded === void 0 ? false : _props$expanded,
	      index = props.index,
	      last = props.last,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "expanded", "index", "last", "orientation"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
	    ref: ref
	  }, other), connector && alternativeLabel && index !== 0 && React.cloneElement(connector, {
	    orientation: orientation,
	    alternativeLabel: alternativeLabel,
	    index: index,
	    active: active,
	    completed: completed,
	    disabled: disabled
	  }), React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return React.cloneElement(child, (0, _extends2.default)({
	      active: active,
	      alternativeLabel: alternativeLabel,
	      completed: completed,
	      disabled: disabled,
	      expanded: expanded,
	      last: last,
	      icon: index + 1,
	      orientation: orientation
	    }, child.props));
	  }));
	});
	 false ? Step.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Expand the step.
	   */
	  expanded: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStep'
	})(Step);
	
	exports.default = _default;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	
	var _Step = _interopRequireDefault(__webpack_require__(849));

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(335));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(139));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    padding: '24px 16px',
	    margin: '-24px -16px',
	    boxSizing: 'content-box'
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {},
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    justifyContent: 'flex-start',
	    padding: '8px',
	    margin: '-8px'
	  },
	
	  /* Styles applied to the `ButtonBase` touch-ripple. */
	  touchRipple: {
	    color: 'rgba(0, 0, 0, 0.3)'
	  }
	};
	exports.styles = styles;
	var StepButton = React.forwardRef(function StepButton(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      expanded = props.expanded,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "expanded", "icon", "last", "optional", "orientation"]);
	  var childProps = {
	    active: active,
	    alternativeLabel: alternativeLabel,
	    completed: completed,
	    disabled: disabled,
	    icon: icon,
	    optional: optional,
	    orientation: orientation
	  };
	  var child = (0, _isMuiElement.default)(children, ['StepLabel']) ? React.cloneElement(children, childProps) : /*#__PURE__*/React.createElement(_StepLabel.default, childProps, children);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    disabled: disabled,
	    TouchRippleProps: {
	      className: classes.touchRipple
	    },
	    className: (0, _clsx.default)(classes.root, classes[orientation], className),
	    ref: ref
	  }, other), child);
	});
	 false ? StepButton.propTypes = {
	  /**
	   * @ignore
	   * Passed in via `Step` - passed through to `StepLabel`.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * potentially passed from parent `Step`
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepButton'
	})(StepButton);
	
	exports.default = _default;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	
	var _StepButton = _interopRequireDefault(__webpack_require__(851));

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto'
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      marginLeft: 12,
	      // half icon
	      padding: '0 0 8px'
	    },
	
	    /* Styles applied to the root element if `alternativeLabel={true}`. */
	    alternativeLabel: {
	      position: 'absolute',
	      top: 8 + 4,
	      left: 'calc(-50% + 20px)',
	      right: 'calc(50% + 20px)'
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the line element. */
	    line: {
	      display: 'block',
	      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    lineHorizontal: {
	      borderTopStyle: 'solid',
	      borderTopWidth: 1
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    lineVertical: {
	      borderLeftStyle: 'solid',
	      borderLeftWidth: 1,
	      minHeight: 24
	    }
	  };
	};
	
	exports.styles = styles;
	var StepConnector = React.forwardRef(function StepConnector(props, ref) {
	  var active = props.active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      index = props.index,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.line, {
	      'horizontal': classes.lineHorizontal,
	      'vertical': classes.lineVertical
	    }[orientation])
	  }));
	});
	 false ? StepConnector.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepConnector'
	})(StepConnector);
	
	exports.default = _default;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(70));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      marginTop: 8,
	      marginLeft: 12,
	      // half icon
	      paddingLeft: 8 + 12,
	      // margin + half icon
	      paddingRight: 8,
	      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
	    },
	
	    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
	    last: {
	      borderLeft: 'none'
	    },
	
	    /* Styles applied to the Transition component. */
	    transition: {}
	  };
	};
	
	exports.styles = styles;
	var StepContent = React.forwardRef(function StepContent(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      expanded = props.expanded,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "expanded", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	
	  if (false) {
	    if (orientation !== 'vertical') {
	      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
	    }
	  }
	
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, last && classes.last),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: active || expanded,
	    className: classes.transition,
	    timeout: transitionDuration,
	    unmountOnExit: true
	  }, TransitionProps), children));
	});
	 false ? StepContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Step content.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Adjust the duration of the content expand transition.
	   * Passed as a prop to the transition component.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepContent'
	})(StepContent);
	
	exports.default = _default;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	
	var _StepContent = _interopRequireDefault(__webpack_require__(854));

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _CheckCircle = _interopRequireDefault(__webpack_require__(910));
	
	var _Warning = _interopRequireDefault(__webpack_require__(916));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(166));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      color: theme.palette.text.disabled,
	      '&$completed': {
	        color: theme.palette.primary.main
	      },
	      '&$active': {
	        color: theme.palette.primary.main
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Styles applied to the SVG text element. */
	    text: {
	      fill: theme.palette.primary.contrastText,
	      fontSize: theme.typography.caption.fontSize,
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {}
	  };
	};
	
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "12"
	});
	
	var StepIcon = React.forwardRef(function StepIcon(props, ref) {
	  var _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      icon = props.icon,
	      _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      classes = props.classes;
	
	  if (typeof icon === 'number' || typeof icon === 'string') {
	    var className = (0, _clsx.default)(classes.root, active && classes.active, error && classes.error, completed && classes.completed);
	
	    if (error) {
	      return /*#__PURE__*/React.createElement(_Warning.default, {
	        className: className,
	        ref: ref
	      });
	    }
	
	    if (completed) {
	      return /*#__PURE__*/React.createElement(_CheckCircle.default, {
	        className: className,
	        ref: ref
	      });
	    }
	
	    return /*#__PURE__*/React.createElement(_SvgIcon.default, {
	      className: className,
	      ref: ref
	    }, _ref, /*#__PURE__*/React.createElement("text", {
	      className: classes.text,
	      x: "12",
	      y: "16",
	      textAnchor: "middle"
	    }, icon));
	  }
	
	  return icon;
	});
	 false ? StepIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Whether this step is active.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * The label displayed in the step icon.
	   */
	  icon: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepIcon'
	})(StepIcon);
	
	exports.default = _default;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(334));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      '&$alternativeLabel': {
	        flexDirection: 'column'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal". */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical". */
	    vertical: {},
	
	    /* Styles applied to the `Typography` component which wraps `children`. */
	    label: {
	      color: theme.palette.text.secondary,
	      '&$active': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$completed': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$alternativeLabel': {
	        textAlign: 'center',
	        marginTop: 16
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the `icon` container element. */
	    iconContainer: {
	      flexShrink: 0,
	      // Fix IE 11 issue
	      display: 'flex',
	      paddingRight: 8,
	      '&$alternativeLabel': {
	        paddingRight: 0
	      }
	    },
	
	    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
	    alternativeLabel: {},
	
	    /* Styles applied to the container element which wraps `Typography` and `optional`. */
	    labelContainer: {
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	var StepLabel = React.forwardRef(function StepLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      expanded = props.expanded,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      StepIconComponentProp = props.StepIconComponent,
	      StepIconProps = props.StepIconProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);
	  var StepIconComponent = StepIconComponentProp;
	
	  if (icon && !StepIconComponent) {
	    StepIconComponent = _StepIcon.default;
	  }
	
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
	    ref: ref
	  }, other), icon || StepIconComponent ? /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
	  }, /*#__PURE__*/React.createElement(StepIconComponent, (0, _extends2.default)({
	    completed: completed,
	    active: active,
	    error: error,
	    icon: icon
	  }, StepIconProps))) : null, /*#__PURE__*/React.createElement("span", {
	    className: classes.labelContainer
	  }, /*#__PURE__*/React.createElement(_Typography.default, {
	    variant: "body2",
	    component: "span",
	    className: (0, _clsx.default)(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error),
	    display: "block"
	  }, children), optional));
	});
	 false ? StepLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * In most cases will simply be a string containing a title for the label.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Override the default label of the step icon.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * The component to render in place of the [`StepIcon`](/api/step-icon/).
	   */
	  StepIconComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`StepIcon`](/api/step-icon/) element.
	   */
	  StepIconProps: _propTypes.default.object
	} : void 0;
	StepLabel.muiName = 'StepLabel';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepLabel'
	})(StepLabel);
	
	exports.default = _default;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(333));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    padding: 24
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    flexDirection: 'row',
	    alignItems: 'center'
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    flexDirection: 'column'
	  },
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    alignItems: 'flex-start'
	  }
	};
	exports.styles = styles;
	var defaultConnector = /*#__PURE__*/React.createElement(_StepConnector.default, null);
	var Stepper = React.forwardRef(function Stepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$connector = props.connector,
	      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
	      _props$nonLinear = props.nonLinear,
	      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
	  var connector = React.isValidElement(connectorProp) ? React.cloneElement(connectorProp, {
	    orientation: orientation
	  }) : null;
	  var childrenArray = React.Children.toArray(children);
	  var steps = childrenArray.map(function (step, index) {
	    var controlProps = {
	      alternativeLabel: alternativeLabel,
	      connector: connectorProp,
	      last: index + 1 === childrenArray.length,
	      orientation: orientation
	    };
	    var state = {
	      index: index,
	      active: false,
	      completed: false,
	      disabled: false
	    };
	
	    if (activeStep === index) {
	      state.active = true;
	    } else if (!nonLinear && activeStep > index) {
	      state.completed = true;
	    } else if (!nonLinear && activeStep < index) {
	      state.disabled = true;
	    }
	
	    return [!alternativeLabel && connector && index !== 0 && React.cloneElement(connector, (0, _extends2.default)({
	      key: index
	    }, state)), React.cloneElement(step, (0, _extends2.default)({}, controlProps, {}, state, {}, step.props))];
	  });
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
	    ref: ref
	  }, other), steps);
	});
	 false ? Stepper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the active step (zero based index).
	   * Set to -1 to disable all the steps.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * If set to 'true' and orientation is horizontal,
	   * then the step label will be positioned under the icon.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Two or more `<Step />` components.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * An element to be placed between each step.
	   */
	  connector: _propTypes.default.element,
	
	  /**
	   * If set the `Stepper` will not assist in controlling steps for linear flow.
	   */
	  nonLinear: _propTypes.default.bool,
	
	  /**
	   * The stepper orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepper'
	})(Stepper);
	
	exports.default = _default;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	
	var _Stepper = _interopRequireDefault(__webpack_require__(858));

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: theme.typography.pxToRem(24),
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(35)
	    }
	  };
	};
	
	exports.styles = styles;
	var SvgIcon = React.forwardRef(function SvgIcon(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'svg' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      htmlColor = props.htmlColor,
	      titleAccess = props.titleAccess,
	      _props$viewBox = props.viewBox,
	      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    focusable: "false",
	    viewBox: viewBox,
	    color: htmlColor,
	    "aria-hidden": titleAccess ? undefined : 'true',
	    role: titleAccess ? 'img' : undefined,
	    ref: ref
	  }, other), children, titleAccess ? /*#__PURE__*/React.createElement("title", null, titleAccess) : null);
	});
	 false ? SvgIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['default', 'inherit', 'large', 'small']),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  htmlColor: _propTypes.default.string,
	
	  /**
	   * The shape-rendering attribute. The behavior of the different options is described on the
	   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
	   * If you are having issues with blurry icons you should investigate this property.
	   */
	  shapeRendering: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : void 0;
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _Drawer = __webpack_require__(222);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      bottom: 0,
	      zIndex: theme.zIndex.drawer - 1
	    },
	    anchorLeft: {
	      right: 'auto'
	    },
	    anchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    anchorTop: {
	      bottom: 'auto',
	      right: 0
	    },
	    anchorBottom: {
	      top: 'auto',
	      bottom: 0,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var SwipeArea = React.forwardRef(function SwipeArea(props, ref) {
	  var anchor = props.anchor,
	      classes = props.classes,
	      className = props.className,
	      width = props.width,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "className", "width"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchor".concat((0, _capitalize.default)(anchor))], className),
	    ref: ref,
	    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(anchor) ? 'width' : 'height', width)
	  }, other));
	});
	 false ? SwipeArea.propTypes = {
	  /**
	   * Side on which to attach the discovery area.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  width: _propTypes.default.number.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwipeArea'
	})(SwipeArea);
	
	exports.default = _default;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reset = reset;
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _utils = __webpack_require__(21);
	
	var _styles = __webpack_require__(52);
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(222));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(61));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var _transitions = __webpack_require__(60);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _utils2 = __webpack_require__(112);
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(328));
	
	var _SwipeArea = _interopRequireDefault(__webpack_require__(861));
	
	// This value is closed to what browsers are using internally to
	// trigger a native scroll.
	var UNCERTAINTY_THRESHOLD = 3; // px
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	
	var nodeThatClaimedTheSwipe = null; // Exported for test purposes.
	
	function reset() {
	  nodeThatClaimedTheSwipe = null;
	}
	
	function calculateCurrentX(anchor, touches) {
	  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
	}
	
	function calculateCurrentY(anchor, touches) {
	  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
	}
	
	function getMaxTranslate(horizontalSwipe, paperInstance) {
	  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
	}
	
	function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
	  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
	}
	
	function getDomTreeShapes(element, rootNode) {
	  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode) {
	    var style = window.getComputedStyle(element);
	
	    if ( // Ignore the scroll children if the element is absolute positioned.
	    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
	    style.getPropertyValue('overflow-x') === 'hidden') {
	      domTreeShapes = [];
	    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
	      // Ignore the nodes that have no width.
	      // Keep elements with a scroll
	      domTreeShapes.push(element);
	    }
	
	    element = element.parentElement;
	  }
	
	  return domTreeShapes;
	}
	
	function findNativeHandler(_ref) {
	  var domTreeShapes = _ref.domTreeShapes,
	      start = _ref.start,
	      current = _ref.current,
	      anchor = _ref.anchor;
	  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
	  var axisProperties = {
	    scrollPosition: {
	      x: 'scrollLeft',
	      y: 'scrollTop'
	    },
	    scrollLength: {
	      x: 'scrollWidth',
	      y: 'scrollHeight'
	    },
	    clientLength: {
	      x: 'clientWidth',
	      y: 'clientHeight'
	    }
	  };
	  return domTreeShapes.some(function (shape) {
	    // Determine if we are going backward or forward.
	    var goingForward = current >= start;
	
	    if (anchor === 'top' || anchor === 'left') {
	      goingForward = !goingForward;
	    }
	
	    var axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
	    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
	    var areNotAtStart = scrollPosition > 0;
	    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
	
	    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
	      return shape;
	    }
	
	    return null;
	  });
	}
	
	var disableSwipeToOpenDefault = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
	var transitionDurationDefault = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var SwipeableDrawer = React.forwardRef(function SwipeableDrawer(inProps, ref) {
	  var theme = (0, _useTheme.default)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiSwipeableDrawer',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$anchor = props.anchor,
	      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
	      _props$disableBackdro = props.disableBackdropTransition,
	      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableDiscove = props.disableDiscovery,
	      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
	      _props$disableSwipeTo = props.disableSwipeToOpen,
	      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? disableSwipeToOpenDefault : _props$disableSwipeTo,
	      hideBackdrop = props.hideBackdrop,
	      _props$hysteresis = props.hysteresis,
	      hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis,
	      _props$minFlingVeloci = props.minFlingVelocity,
	      minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropProps = _props$ModalProps.BackdropProps,
	      ModalPropsProp = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SwipeAreaProps = props.SwipeAreaProps,
	      _props$swipeAreaWidth = props.swipeAreaWidth,
	      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);
	
	  var _React$useState = React.useState(false),
	      maybeSwiping = _React$useState[0],
	      setMaybeSwiping = _React$useState[1];
	
	  var swipeInstance = React.useRef({
	    isSwiping: null
	  });
	  var swipeAreaRef = React.useRef();
	  var backdropRef = React.useRef();
	  var paperRef = React.useRef();
	  var touchDetected = React.useRef(false); // Ref for transition duration based on / to match swipe speed
	
	  var calculatedDurationRef = React.useRef(); // Use a ref so the open value used is always up to date inside useCallback.
	
	  useEnhancedEffect(function () {
	    calculatedDurationRef.current = null;
	  }, [open]);
	  var setPosition = React.useCallback(function (translate) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$mode = options.mode,
	        mode = _options$mode === void 0 ? null : _options$mode,
	        _options$changeTransi = options.changeTransition,
	        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
	    var drawerStyle = paperRef.current.style;
	    drawerStyle.webkitTransform = transform;
	    drawerStyle.transform = transform;
	    var transition = '';
	
	    if (mode) {
	      transition = theme.transitions.create('all', (0, _utils2.getTransitionProps)({
	        timeout: transitionDuration
	      }, {
	        mode: mode
	      }));
	    }
	
	    if (changeTransition) {
	      drawerStyle.webkitTransition = transition;
	      drawerStyle.transition = transition;
	    }
	
	    if (!disableBackdropTransition && !hideBackdrop) {
	      var backdropStyle = backdropRef.current.style;
	      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);
	
	      if (changeTransition) {
	        backdropStyle.webkitTransition = transition;
	        backdropStyle.transition = transition;
	      }
	    }
	  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
	  var handleBodyTouchEnd = (0, _useEventCallback.default)(function (event) {
	    if (!touchDetected.current) {
	      return;
	    }
	
	    nodeThatClaimedTheSwipe = null;
	    touchDetected.current = false;
	    setMaybeSwiping(false); // The swipe wasn't started.
	
	    if (!swipeInstance.current.isSwiping) {
	      swipeInstance.current.isSwiping = null;
	      return;
	    }
	
	    swipeInstance.current.isSwiping = null;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontal = (0, _Drawer.isHorizontal)(anchor);
	    var current;
	
	    if (horizontal) {
	      current = calculateCurrentX(anchorRtl, event.changedTouches);
	    } else {
	      current = calculateCurrentY(anchorRtl, event.changedTouches);
	    }
	
	    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
	    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
	    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
	    var translateRatio = currentTranslate / maxTranslate;
	
	    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
	      // Calculate transition duration to match swipe speed
	      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
	    }
	
	    if (open) {
	      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
	        onClose();
	      } else {
	        // Reset the position, the swipe was aborted.
	        setPosition(0, {
	          mode: 'exit'
	        });
	      }
	
	      return;
	    }
	
	    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
	      onOpen();
	    } else {
	      // Reset the position, the swipe was aborted.
	      setPosition(getMaxTranslate(horizontal, paperRef.current), {
	        mode: 'enter'
	      });
	    }
	  });
	  var handleBodyTouchMove = (0, _useEventCallback.default)(function (event) {
	    // the ref may be null when a parent component updates while swiping
	    if (!paperRef.current || !touchDetected.current) {
	      return;
	    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
	
	
	    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
	      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
	      var nativeHandler = findNativeHandler({
	        domTreeShapes: domTreeShapes,
	        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
	        current: horizontalSwipe ? currentX : currentY,
	        anchor: anchor
	      });
	
	      if (nativeHandler) {
	        nodeThatClaimedTheSwipe = nativeHandler;
	        return;
	      }
	
	      nodeThatClaimedTheSwipe = swipeInstance.current;
	    } // We don't know yet.
	
	
	    if (swipeInstance.current.isSwiping == null) {
	      var dx = Math.abs(currentX - swipeInstance.current.startX);
	      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.
	
	      if (dx > dy) {
	        if (event.cancelable) {
	          event.preventDefault();
	        }
	      }
	
	      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
	
	      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
	        swipeInstance.current.isSwiping = definitelySwiping;
	
	        if (!definitelySwiping) {
	          handleBodyTouchEnd(event);
	          return;
	        } // Shift the starting point.
	
	
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.
	
	        if (!disableDiscovery && !open) {
	          if (horizontalSwipe) {
	            swipeInstance.current.startX -= swipeAreaWidth;
	          } else {
	            swipeInstance.current.startY -= swipeAreaWidth;
	          }
	        }
	      }
	    }
	
	    if (!swipeInstance.current.isSwiping) {
	      return;
	    }
	
	    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
	    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
	
	    if (open && !swipeInstance.current.paperHit) {
	      startLocation = Math.min(startLocation, maxTranslate);
	    }
	
	    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
	
	    if (open) {
	      if (!swipeInstance.current.paperHit) {
	        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
	
	        if (paperHit) {
	          swipeInstance.current.paperHit = true;
	          swipeInstance.current.startX = currentX;
	          swipeInstance.current.startY = currentY;
	        } else {
	          return;
	        }
	      } else if (translate === 0) {
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY;
	      }
	    }
	
	    if (swipeInstance.current.lastTranslate === null) {
	      swipeInstance.current.lastTranslate = translate;
	      swipeInstance.current.lastTime = performance.now() + 1;
	    }
	
	    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.
	
	    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
	    swipeInstance.current.lastTranslate = translate;
	    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.
	
	    if (event.cancelable) {
	      event.preventDefault();
	    }
	
	    setPosition(translate);
	  });
	  var handleBodyTouchStart = (0, _useEventCallback.default)(function (event) {
	    // We are not supposed to handle this touch move.
	    // Example of use case: ignore the event if there is a Slider.
	    if (event.defaultPrevented) {
	      return;
	    } // We can only have one node at the time claiming ownership for handling the swipe.
	
	
	    if (event.muiHandled) {
	      return;
	    } // At least one element clogs the drawer interaction zone.
	
	
	    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (!open) {
	      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
	        return;
	      }
	
	      if (horizontalSwipe) {
	        if (currentX > swipeAreaWidth) {
	          return;
	        }
	      } else if (currentY > swipeAreaWidth) {
	        return;
	      }
	    }
	
	    event.muiHandled = true;
	    nodeThatClaimedTheSwipe = null;
	    swipeInstance.current.startX = currentX;
	    swipeInstance.current.startY = currentY;
	    setMaybeSwiping(true);
	
	    if (!open && paperRef.current) {
	      // The ref may be null when a parent component updates while swiping.
	      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
	        changeTransition: false
	      });
	    }
	
	    swipeInstance.current.velocity = 0;
	    swipeInstance.current.lastTime = null;
	    swipeInstance.current.lastTranslate = null;
	    swipeInstance.current.paperHit = false;
	    touchDetected.current = true;
	  });
	  React.useEffect(function () {
	    if (variant === 'temporary') {
	      var doc = (0, _ownerDocument.default)(paperRef.current);
	      doc.addEventListener('touchstart', handleBodyTouchStart);
	      doc.addEventListener('touchmove', handleBodyTouchMove, {
	        passive: false
	      });
	      doc.addEventListener('touchend', handleBodyTouchEnd);
	      return function () {
	        doc.removeEventListener('touchstart', handleBodyTouchStart);
	        doc.removeEventListener('touchmove', handleBodyTouchMove, {
	          passive: false
	        });
	        doc.removeEventListener('touchend', handleBodyTouchEnd);
	      };
	    }
	
	    return undefined;
	  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
	  React.useEffect(function () {
	    return function () {
	      // We need to release the lock.
	      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
	        nodeThatClaimedTheSwipe = null;
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open) {
	      setMaybeSwiping(false);
	    }
	  }, [open]);
	  var handleBackdropRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    backdropRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Drawer.default, (0, _extends2.default)({
	    open: variant === 'temporary' && maybeSwiping ? true : open,
	    variant: variant,
	    ModalProps: (0, _extends2.default)({
	      BackdropProps: (0, _extends2.default)({}, BackdropProps, {
	        ref: handleBackdropRef
	      })
	    }, ModalPropsProp),
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      style: (0, _extends2.default)({
	        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
	      }, PaperProps.style),
	      ref: paperRef
	    }),
	    anchor: anchor,
	    transitionDuration: calculatedDurationRef.current || transitionDuration,
	    onClose: onClose,
	    ref: ref
	  }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/React.createElement(_NoSsr.default, null, /*#__PURE__*/React.createElement(_SwipeArea.default, (0, _extends2.default)({
	    anchor: anchor,
	    ref: swipeAreaRef,
	    width: swipeAreaWidth
	  }, SwipeAreaProps))));
	});
	 false ? SwipeableDrawer.propTypes = {
	  /**
	   * @ignore
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Disable the backdrop transition.
	   * This can improve the FPS on low-end devices.
	   */
	  disableBackdropTransition: _propTypes.default.bool,
	
	  /**
	   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
	   * to promote accidental discovery of the swipe gesture.
	   */
	  disableDiscovery: _propTypes.default.bool,
	
	  /**
	   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
	   * navigation actions. Swipe to open is disabled on iOS browsers by default.
	   */
	  disableSwipeToOpen: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Affects how far the drawer must be opened/closed to change his state.
	   * Specified as percent (0-1) of the width of the drawer
	   */
	  hysteresis: _propTypes.default.number,
	
	  /**
	   * Defines, from which (average) velocity on, the swipe is
	   * defined as complete although hysteresis isn't reached.
	   * Good threshold is between 250 - 1000 px/s
	   */
	  minFlingVelocity: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  ModalProps: _propTypes.default.shape({
	    BackdropProps: _propTypes.default.shape({
	      component: _utils.elementTypeAcceptingRef
	    })
	  }),
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.shape({
	    component: _utils.elementTypeAcceptingRef,
	    style: _propTypes.default.object
	  }),
	
	  /**
	   * The element is used to intercept the touch events on the edge.
	   */
	  SwipeAreaProps: _propTypes.default.object,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  swipeAreaWidth: _propTypes.default.number,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * @ignore
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	var _default = SwipeableDrawer;
	exports.default = _default;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	
	var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(862));

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(236));
	
	// @inheritedComponent IconButton
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      width: 34 + 12 * 2,
	      height: 14 + 12 * 2,
	      overflow: 'hidden',
	      padding: 12,
	      boxSizing: 'border-box',
	      position: 'relative',
	      flexShrink: 0,
	      zIndex: 0,
	      // Reset the stacking context.
	      verticalAlign: 'middle',
	      // For correct alignment with the text.
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -8
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -8
	    },
	
	    /* Styles applied to the internal `SwitchBase` component's `root` class. */
	    switchBase: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      zIndex: 1,
	      // Render above the focus ripple.
	      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
	      transition: theme.transitions.create(['left', 'transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&$checked': {
	        transform: 'translateX(20px)'
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        opacity: 0.5
	      },
	      '&$disabled + $track': {
	        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.primary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.secondary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      width: 40,
	      height: 24,
	      padding: 7,
	      '& $thumb': {
	        width: 16,
	        height: 16
	      },
	      '& $switchBase': {
	        padding: 4,
	        '&$checked': {
	          transform: 'translateX(16px)'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
	    checked: {},
	
	    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
	    disabled: {},
	
	    /* Styles applied to the internal SwitchBase component's input element. */
	    input: {
	      left: '-100%',
	      width: '300%'
	    },
	
	    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
	    thumb: {
	      boxShadow: theme.shadows[1],
	      backgroundColor: 'currentColor',
	      width: 20,
	      height: 20,
	      borderRadius: '50%'
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      height: '100%',
	      width: '100%',
	      borderRadius: 14 / 2,
	      zIndex: -1,
	      transition: theme.transitions.create(['opacity', 'background-color'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
	      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
	    }
	  };
	};
	
	exports.styles = styles;
	var Switch = React.forwardRef(function Switch(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "edge", "size"]);
	  var icon = /*#__PURE__*/React.createElement("span", {
	    className: classes.thumb
	  });
	  return /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.root, className, {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge], size === "small" && classes["size".concat((0, _capitalize.default)(size))])
	  }, /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    icon: icon,
	    checkedIcon: icon,
	    classes: {
	      root: (0, _clsx.default)(classes.switchBase, classes["color".concat((0, _capitalize.default)(color))]),
	      input: classes.input,
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    ref: ref
	  }, other)), /*#__PURE__*/React.createElement("span", {
	    className: classes.track
	  }));
	});
	 false ? Switch.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['end', 'start', false]),
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the switch.
	   * `small` is equivalent to the dense switch styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   * The browser uses "on" as the default value.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSwitch'
	})(Switch);
	
	exports.default = _default;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	
	var _Switch = _interopRequireDefault(__webpack_require__(864));

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(169));
	
	var styles = function styles(theme) {
	  var _extends2;
	
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.button, (_extends2 = {
	      maxWidth: 264,
	      minWidth: 72,
	      position: 'relative',
	      boxSizing: 'border-box',
	      minHeight: 48,
	      flexShrink: 0,
	      padding: '6px 12px'
	    }, (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      padding: '6px 24px'
	    }), (0, _defineProperty2.default)(_extends2, "overflow", 'hidden'), (0, _defineProperty2.default)(_extends2, "whiteSpace", 'normal'), (0, _defineProperty2.default)(_extends2, "textAlign", 'center'), (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      minWidth: 160
	    }), _extends2)),
	
	    /* Styles applied to the root element if both `icon` and `label` are provided. */
	    labelIcon: {
	      minHeight: 72,
	      paddingTop: 9,
	      '& $wrapper > *:first-child': {
	        marginBottom: 6
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
	    textColorInherit: {
	      color: 'inherit',
	      opacity: 0.7,
	      '&$selected': {
	        opacity: 1
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
	    textColorPrimary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
	    textColorSecondary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
	    fullWidth: {
	      flexShrink: 1,
	      flexGrow: 1,
	      flexBasis: 0,
	      maxWidth: 'none'
	    },
	
	    /* Styles applied to the root element if `wrapped={true}`. */
	    wrapped: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.5
	    },
	
	    /* Styles applied to the `icon` and `label`'s wrapper element. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    }
	  };
	};
	
	exports.styles = styles;
	var Tab = React.forwardRef(function Tab(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      indicator = props.indicator,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      selected = props.selected,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$wrapped = props.wrapped,
	      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "selected", "textColor", "value", "wrapped"]);
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends3.default)({
	    focusRipple: !disableFocusRipple,
	    className: (0, _clsx.default)(classes.root, classes["textColor".concat((0, _capitalize.default)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
	    ref: ref,
	    role: "tab",
	    "aria-selected": selected,
	    disabled: disabled,
	    onClick: handleChange
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.wrapper
	  }, icon, label), indicator);
	});
	 false ? Tab.propTypes = {
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the tab will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * For server-side rendering consideration, we let the selected tab
	   * render the indicator.
	   */
	  indicator: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Tab labels appear in a single row.
	   * They can use a second line if needed.
	   */
	  wrapped: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTab'
	})(Tab);
	
	exports.default = _default;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	
	var _Tab = _interopRequireDefault(__webpack_require__(866));

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _TableContext = _interopRequireDefault(__webpack_require__(336));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'table',
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      '& caption': (0, _extends2.default)({}, theme.typography.body2, {
	        padding: theme.spacing(2),
	        color: theme.palette.text.secondary,
	        textAlign: 'left',
	        captionSide: 'bottom'
	      })
	    },
	
	    /* Styles applied to the root element if `stickyHeader={true}`. */
	    stickyHeader: {
	      borderCollapse: 'separate'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultComponent = 'table';
	var Table = React.forwardRef(function Table(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      _props$padding = props.padding,
	      padding = _props$padding === void 0 ? 'default' : _props$padding,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$stickyHeader = props.stickyHeader,
	      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);
	  var table = React.useMemo(function () {
	    return {
	      padding: padding,
	      size: size,
	      stickyHeader: stickyHeader
	    };
	  }, [padding, size, stickyHeader]);
	  return /*#__PURE__*/React.createElement(_TableContext.default.Provider, {
	    value: table
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: Component === defaultComponent ? null : 'table',
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, stickyHeader && classes.stickyHeader)
	  }, other)));
	});
	 false ? Table.propTypes = {
	  /**
	   * The content of the table, normally `TableHead` and `TableBody`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Allows TableCells to inherit padding of the Table.
	   */
	  padding: _propTypes.default.oneOf(['default', 'checkbox', 'none']),
	
	  /**
	   * Allows TableCells to inherit size of the Table.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * Set the header sticky.
	   *
	   * ⚠️ It doesn't work with IE 11.
	   */
	  stickyHeader: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTable'
	})(Table);
	
	exports.default = _default;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(136));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-row-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'body'
	};
	var defaultComponent = 'tbody';
	var TableBody = React.forwardRef(function TableBody(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableBody.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableBody'
	})(TableBody);
	
	exports.default = _default;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _colorManipulator = __webpack_require__(41);
	
	var _TableContext = _interopRequireDefault(__webpack_require__(336));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(136));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body2, {
	      display: 'table-cell',
	      verticalAlign: 'inherit',
	      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
	      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
	      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.68)),
	      textAlign: 'left',
	      padding: 16
	    }),
	
	    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
	    head: {
	      color: theme.palette.text.primary,
	      lineHeight: theme.typography.pxToRem(24),
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
	    body: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
	    footer: {
	      color: theme.palette.text.secondary,
	      lineHeight: theme.typography.pxToRem(21),
	      fontSize: theme.typography.pxToRem(12)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: '6px 24px 6px 16px',
	      '&:last-child': {
	        paddingRight: 16
	      },
	      '&$paddingCheckbox': {
	        width: 24,
	        // prevent the checkbox column from growing
	        padding: '0px 12px 0 16px',
	        '&:last-child': {
	          paddingLeft: 12,
	          paddingRight: 16
	        },
	        '& > *': {
	          padding: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `padding="checkbox"`. */
	    paddingCheckbox: {
	      width: 48,
	      // prevent the checkbox column from growing
	      padding: '0 0 0 4px',
	      '&:last-child': {
	        paddingLeft: 0,
	        paddingRight: 4
	      }
	    },
	
	    /* Styles applied to the root element if `padding="none"`. */
	    paddingNone: {
	      padding: 0,
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right',
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
	    stickyHeader: {
	      position: 'sticky',
	      top: 0,
	      left: 0,
	      zIndex: 2,
	      backgroundColor: theme.palette.background.default
	    }
	  };
	};
	/**
	 * The component renders a `<th>` element when the parent context is a header
	 * or otherwise a `<td>` element.
	 */
	
	
	exports.styles = styles;
	var TableCell = React.forwardRef(function TableCell(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      component = props.component,
	      paddingProp = props.padding,
	      scopeProp = props.scope,
	      sizeProp = props.size,
	      sortDirection = props.sortDirection,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);
	  var table = React.useContext(_TableContext.default);
	  var tablelvl2 = React.useContext(_Tablelvl2Context.default);
	  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
	  var role;
	  var Component;
	
	  if (component) {
	    Component = component;
	    role = isHeadCell ? 'columnheader' : 'cell';
	  } else {
	    Component = isHeadCell ? 'th' : 'td';
	  }
	
	  var scope = scopeProp;
	
	  if (!scope && isHeadCell) {
	    scope = 'col';
	  }
	
	  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
	  var size = sizeProp || (table && table.size ? table.size : 'medium');
	  var variant = variantProp || tablelvl2 && tablelvl2.variant;
	  var ariaSort = null;
	
	  if (sortDirection) {
	    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], padding !== 'default' && classes["padding".concat((0, _capitalize.default)(padding))], size !== 'medium' && classes["size".concat((0, _capitalize.default)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
	    "aria-sort": ariaSort,
	    role: role,
	    scope: scope
	  }, other));
	});
	 false ? TableCell.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the text-align on the table cell content.
	   *
	   * Monetary or generally number fields **should be right aligned** as that allows
	   * you to add them up quickly in your head without having to worry about decimals.
	   */
	  align: _propTypes.default.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
	
	  /**
	   * The table cell contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Sets the padding applied to the cell.
	   * By default, the Table parent component set the value (`default`).
	   */
	  padding: _propTypes.default.oneOf(['checkbox', 'default', 'none']),
	
	  /**
	   * Set scope attribute.
	   */
	  scope: _propTypes.default.string,
	
	  /**
	   * Specify the size of the cell.
	   * By default, the Table parent component set the value (`medium`).
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Set aria-sort direction.
	   */
	  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),
	
	  /**
	   * Specify the cell type.
	   * By default, the TableHead, TableBody or TableFooter parent component set the value.
	   */
	  variant: _propTypes.default.oneOf(['body', 'footer', 'head'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableCell'
	})(TableCell);
	
	exports.default = _default;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    overflowX: 'auto'
	  }
	};
	exports.styles = styles;
	var TableContainer = React.forwardRef(function TableContainer(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className)
	  }, other));
	});
	 false ? TableContainer.propTypes = {
	  /**
	   * The table itself, normally `<Table />`
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableContainer'
	})(TableContainer);
	
	exports.default = _default;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(136));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-footer-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'footer'
	};
	var defaultComponent = 'tfoot';
	var TableFooter = React.forwardRef(function TableFooter(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableFooter.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableFooter'
	})(TableFooter);
	
	exports.default = _default;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	
	var _TableFooter = _interopRequireDefault(__webpack_require__(872));

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(136));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-header-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'head'
	};
	var defaultComponent = 'thead';
	var TableHead = React.forwardRef(function TableHead(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableHead.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableHead'
	})(TableHead);
	
	exports.default = _default;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(21);
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _InputBase = _interopRequireDefault(__webpack_require__(131));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(111));
	
	var _Select = _interopRequireDefault(__webpack_require__(165));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(167));
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(338));
	
	var _Typography = _interopRequireDefault(__webpack_require__(43));
	
	var _TablePaginationActions = _interopRequireDefault(__webpack_require__(876));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.primary,
	      fontSize: theme.typography.pxToRem(14),
	      overflow: 'auto',
	      // Increase the specificity to override TableCell.
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the Toolbar component. */
	    toolbar: {
	      minHeight: 52,
	      paddingRight: 2
	    },
	
	    /* Styles applied to the spacer element. */
	    spacer: {
	      flex: '1 1 100%'
	    },
	
	    /* Styles applied to the caption Typography components if `variant="caption"`. */
	    caption: {
	      flexShrink: 0
	    },
	    // TODO v5: `.selectRoot` should be merged with `.input`
	
	    /* Styles applied to the Select component root element. */
	    selectRoot: {
	      marginRight: 32,
	      marginLeft: 8
	    },
	
	    /* Styles applied to the Select component `select` class. */
	    select: {
	      paddingLeft: 8,
	      paddingRight: 24,
	      textAlign: 'right',
	      textAlignLast: 'right' // Align <select> on Chrome.
	
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the Select component `icon` class. */
	    selectIcon: {},
	
	    /* Styles applied to the `InputBase` component. */
	    input: {
	      color: 'inherit',
	      fontSize: 'inherit',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the MenuItem component. */
	    menuItem: {},
	
	    /* Styles applied to the internal `TablePaginationActions` component. */
	    actions: {
	      flexShrink: 0,
	      marginLeft: 20
	    }
	  };
	};
	
	exports.styles = styles;
	
	var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
	  var from = _ref.from,
	      to = _ref.to,
	      count = _ref.count;
	  return "".concat(from, "-").concat(to === -1 ? count : to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
	};
	
	var defaultRowsPerPageOptions = [10, 25, 50, 100];
	/**
	 * A `TableCell` based component for placing inside `TableFooter` for pagination.
	 */
	
	var TablePagination = React.forwardRef(function TablePagination(props, ref) {
	  var _props$ActionsCompone = props.ActionsComponent,
	      ActionsComponent = _props$ActionsCompone === void 0 ? _TablePaginationActions.default : _props$ActionsCompone,
	      backIconButtonProps = props.backIconButtonProps,
	      _props$backIconButton = props.backIconButtonText,
	      backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton,
	      classes = props.classes,
	      className = props.className,
	      colSpanProp = props.colSpan,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? _TableCell.default : _props$component,
	      count = props.count,
	      _props$labelDisplayed = props.labelDisplayedRows,
	      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
	      _props$labelRowsPerPa = props.labelRowsPerPage,
	      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
	      nextIconButtonProps = props.nextIconButtonProps,
	      _props$nextIconButton = props.nextIconButtonText,
	      nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton,
	      onChangePage = props.onChangePage,
	      onChangeRowsPerPage = props.onChangeRowsPerPage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      _props$rowsPerPageOpt = props.rowsPerPageOptions,
	      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
	      _props$SelectProps = props.SelectProps,
	      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
	  var colSpan;
	
	  if (Component === _TableCell.default || Component === 'td') {
	    colSpan = colSpanProp || 1000; // col-span over everything
	  }
	
	  var MenuItemComponent = SelectProps.native ? 'option' : _MenuItem.default;
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    colSpan: colSpan,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(_Toolbar.default, {
	    className: classes.toolbar
	  }, /*#__PURE__*/React.createElement("div", {
	    className: classes.spacer
	  }), rowsPerPageOptions.length > 1 && /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "body2",
	    className: classes.caption
	  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    classes: {
	      select: classes.select,
	      icon: classes.selectIcon
	    },
	    input: /*#__PURE__*/React.createElement(_InputBase.default, {
	      className: (0, _clsx.default)(classes.input, classes.selectRoot)
	    }),
	    value: rowsPerPage,
	    onChange: onChangeRowsPerPage,
	    inputProps: {
	      'aria-label': labelRowsPerPage
	    }
	  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
	    return /*#__PURE__*/React.createElement(MenuItemComponent, {
	      className: classes.menuItem,
	      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
	      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
	    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
	  })), /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "body2",
	    className: classes.caption
	  }, labelDisplayedRows({
	    from: count === 0 ? 0 : page * rowsPerPage + 1,
	    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
	    count: count,
	    page: page
	  })), /*#__PURE__*/React.createElement(ActionsComponent, {
	    className: classes.actions,
	    backIconButtonProps: (0, _extends2.default)({
	      title: backIconButtonText,
	      'aria-label': backIconButtonText
	    }, backIconButtonProps),
	    count: count,
	    nextIconButtonProps: (0, _extends2.default)({
	      title: nextIconButtonText,
	      'aria-label': nextIconButtonText
	    }, nextIconButtonProps),
	    onChangePage: onChangePage,
	    page: page,
	    rowsPerPage: rowsPerPage
	  })));
	});
	 false ? TablePagination.propTypes = {
	  /**
	   * The component used for displaying the actions.
	   * Either a string to use a HTML element or a component.
	   */
	  ActionsComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Text label for the back arrow icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  backIconButtonText: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  colSpan: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The total number of rows.
	   *
	   * To enable server side pagination for an unknown number of items, provide -1.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
	   * object.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  labelDisplayedRows: _propTypes.default.func,
	
	  /**
	   * Customize the rows per page label.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  labelRowsPerPage: _propTypes.default.string,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Text label for the next arrow icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  nextIconButtonText: _propTypes.default.string,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the number of rows per page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onChangeRowsPerPage: _propTypes.default.func,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: (0, _utils.chainPropTypes)(_propTypes.default.number.isRequired, function (props) {
	    var count = props.count,
	        page = props.page,
	        rowsPerPage = props.rowsPerPage;
	
	    if (count === -1) {
	      return null;
	    }
	
	    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
	
	    if (page < 0 || page > newLastPage) {
	      return new Error('Material-UI: the page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired,
	
	  /**
	   * Customizes the options of the rows per page select field. If less than two options are
	   * available, no select field will be displayed.
	   */
	  rowsPerPageOptions: _propTypes.default.array,
	
	  /**
	   * Props applied to the rows per page [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTablePagination'
	})(TablePagination);
	
	exports.default = _default;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(351));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(352));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(40));
	
	var _ref = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref3 = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref4 = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, null);
	
	/**
	 * @ignore - internal component.
	 */
	var TablePaginationActions = React.forwardRef(function TablePaginationActions(props, ref) {
	  var backIconButtonProps = props.backIconButtonProps,
	      count = props.count,
	      nextIconButtonProps = props.nextIconButtonProps,
	      onChangePage = props.onChangePage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      other = (0, _objectWithoutProperties2.default)(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);
	  var theme = (0, _useTheme.default)();
	
	  var handleBackButtonClick = function handleBackButtonClick(event) {
	    onChangePage(event, page - 1);
	  };
	
	  var handleNextButtonClick = function handleNextButtonClick(event) {
	    onChangePage(event, page + 1);
	  };
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleBackButtonClick,
	    disabled: page === 0,
	    color: "inherit"
	  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleNextButtonClick,
	    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
	    color: "inherit"
	  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
	});
	 false ? TablePaginationActions.propTypes = {
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes.default.number.isRequired,
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired
	} : void 0;
	var _default = TablePaginationActions;
	exports.default = _default;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	
	var _TablePagination = _interopRequireDefault(__webpack_require__(875));

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(136));
	
	var _colorManipulator = __webpack_require__(41);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: 'inherit',
	      display: 'table-row',
	      verticalAlign: 'middle',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      '&$hover:hover': {
	        backgroundColor: theme.palette.action.hover
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `hover={true}`. */
	    hover: {},
	
	    /* Styles applied to the root element if table variant="head". */
	    head: {},
	
	    /* Styles applied to the root element if table variant="footer". */
	    footer: {}
	  };
	};
	
	exports.styles = styles;
	var defaultComponent = 'tr';
	/**
	 * Will automatically set dynamic row height
	 * based on the material table element parent (head, body, etc).
	 */
	
	var TableRow = React.forwardRef(function TableRow(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      _props$hover = props.hover,
	      hover = _props$hover === void 0 ? false : _props$hover,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
	  var tablelvl2 = React.useContext(_Tablelvl2Context.default);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, tablelvl2 && {
	      'head': classes.head,
	      'footer': classes.footer
	    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
	    role: Component === defaultComponent ? null : 'row'
	  }, other));
	});
	 false ? TableRow.propTypes = {
	  /**
	   * Should be valid <tr> children such as `TableCell`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the table row will shade on hover.
	   */
	  hover: _propTypes.default.bool,
	
	  /**
	   * If `true`, the table row will have the selected shading.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableRow'
	})(TableRow);
	
	exports.default = _default;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _ArrowDownward = _interopRequireDefault(__webpack_require__(906));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      cursor: 'pointer',
	      display: 'inline-flex',
	      justifyContent: 'flex-start',
	      flexDirection: 'inherit',
	      alignItems: 'center',
	      '&:focus': {
	        color: theme.palette.text.secondary
	      },
	      '&:hover': {
	        color: theme.palette.text.secondary,
	        '& $icon': {
	          opacity: 0.5
	        }
	      },
	      '&$active': {
	        color: theme.palette.text.primary,
	        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
	        '&& $icon': {
	          opacity: 1,
	          color: theme.palette.text.secondary
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      fontSize: 18,
	      marginRight: 4,
	      marginLeft: 4,
	      opacity: 0,
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shorter
	      }),
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the icon component if `direction="desc"`. */
	    iconDirectionDesc: {
	      transform: 'rotate(0deg)'
	    },
	
	    /* Styles applied to the icon component if `direction="asc"`. */
	    iconDirectionAsc: {
	      transform: 'rotate(180deg)'
	    }
	  };
	};
	/**
	 * A button based label for placing inside `TableCell` for column sorting.
	 */
	
	
	exports.styles = styles;
	var TableSortLabel = React.forwardRef(function TableSortLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'asc' : _props$direction,
	      _props$hideSortIcon = props.hideSortIcon,
	      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDownward.default : _props$IconComponent,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, active && classes.active),
	    component: "span",
	    disableRipple: true,
	    ref: ref
	  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["iconDirection".concat((0, _capitalize.default)(direction))])
	  }));
	});
	 false ? TableSortLabel.propTypes = {
	  /**
	   * If `true`, the label will have the active styling (should be true for the sorted column).
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Label contents, the arrow will be appended automatically.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The current sort direction.
	   */
	  direction: _propTypes.default.oneOf(['asc', 'desc']),
	
	  /**
	   * Hide sort icon when active is false.
	   */
	  hideSortIcon: _propTypes.default.bool,
	
	  /**
	   * Sort icon to use.
	   */
	  IconComponent: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableSortLabel'
	})(TableSortLabel);
	
	exports.default = _default;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	
	var _TableSortLabel = _interopRequireDefault(__webpack_require__(879));

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ScrollbarSize;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _debounce = _interopRequireDefault(__webpack_require__(93));
	
	var styles = {
	  width: 99,
	  height: 99,
	  position: 'absolute',
	  top: -9999,
	  overflow: 'scroll'
	};
	/**
	 * @ignore - internal component.
	 * The component is originates from https://github.com/STORIS/react-scrollbar-size.
	 * It has been moved into the core in order to minimize the bundle size.
	 */
	
	function ScrollbarSize(props) {
	  var onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange"]);
	  var scrollbarHeight = React.useRef();
	  var nodeRef = React.useRef(null);
	
	  var setMeasurements = function setMeasurements() {
	    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
	  };
	
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      var prevHeight = scrollbarHeight.current;
	      setMeasurements();
	
	      if (prevHeight !== scrollbarHeight.current) {
	        onChange(scrollbarHeight.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [onChange]);
	  React.useEffect(function () {
	    setMeasurements();
	    onChange(scrollbarHeight.current);
	  }, [onChange]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    style: styles,
	    ref: nodeRef
	  }, other));
	}
	
	 false ? ScrollbarSize.propTypes = {
	  onChange: _propTypes.default.func.isRequired
	} : void 0;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      height: 2,
	      bottom: 0,
	      width: '100%',
	      transition: theme.transitions.create()
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    vertical: {
	      height: '100%',
	      width: 2,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var TabIndicator = React.forwardRef(function TabIndicator(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "orientation"]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, orientation === 'vertical' && classes.vertical),
	    ref: ref
	  }, other));
	});
	 false ? TabIndicator.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * The color of the tab indicator.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateTabIndicator'
	})(TabIndicator);
	
	exports.default = _default;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(351));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(352));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = {
	  root: {
	    width: 40,
	    flexShrink: 0
	  },
	  vertical: {
	    width: '100%',
	    height: 40,
	    '& svg': {
	      transform: 'rotate(90deg)'
	    }
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, {
	  fontSize: "small"
	});
	
	var _ref2 = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, {
	  fontSize: "small"
	});
	
	var TabScrollButton = React.forwardRef(function TabScrollButton(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      direction = props.direction,
	      orientation = props.orientation,
	      visible = props.visible,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "orientation", "visible"]);
	  var className = (0, _clsx.default)(classes.root, classNameProp, orientation === 'vertical' && classes.vertical);
	
	  if (!visible) {
	    return /*#__PURE__*/React.createElement("div", {
	      className: className
	    });
	  }
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "div",
	    className: className,
	    ref: ref,
	    role: null,
	    tabIndex: null
	  }, other), direction === 'left' ? _ref : _ref2);
	});
	 false ? TabScrollButton.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Which direction should the button indicate?
	   */
	  direction: _propTypes.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired,
	
	  /**
	   * Should the button be present or just consume space.
	   */
	  visible: _propTypes.default.bool.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateTabScrollButton'
	})(TabScrollButton);
	
	exports.default = _default;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _debounce = _interopRequireDefault(__webpack_require__(93));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(168));
	
	var _scrollLeft = __webpack_require__(935);
	
	var _animate = _interopRequireDefault(__webpack_require__(905));
	
	var _ScrollbarSize = _interopRequireDefault(__webpack_require__(881));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _TabIndicator = _interopRequireDefault(__webpack_require__(882));
	
	var _TabScrollButton = _interopRequireDefault(__webpack_require__(883));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(72));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      minHeight: 48,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      display: 'flex'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element. */
	    flexContainer: {
	      display: 'flex'
	    },
	
	    /* Styles applied to the flex container element if `orientation="vertical"`. */
	    flexContainerVertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
	    centered: {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the tablist element. */
	    scroller: {
	      position: 'relative',
	      display: 'inline-block',
	      flex: '1 1 auto',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the tablist element if `!variant="scrollable"`. */
	    fixed: {
	      overflowX: 'hidden',
	      width: '100%'
	    },
	
	    /* Styles applied to the tablist element if `variant="scrollable"`. */
	    scrollable: {
	      overflowX: 'scroll',
	      // Hide dimensionless scrollbar on MacOS
	      scrollbarWidth: 'none',
	      // Firefox
	      '&::-webkit-scrollbar': {
	        display: 'none' // Safari + Chrome
	
	      }
	    },
	
	    /* Styles applied to the `ScrollButtonComponent` component. */
	    scrollButtons: {},
	
	    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
	    scrollButtonsDesktop: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
	      display: 'none'
	    }),
	
	    /* Styles applied to the `TabIndicator` component. */
	    indicator: {}
	  };
	};
	
	exports.styles = styles;
	var Tabs = React.forwardRef(function Tabs(props, ref) {
	  var action = props.action,
	      _props$centered = props.centered,
	      centered = _props$centered === void 0 ? false : _props$centered,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$indicatorColor = props.indicatorColor,
	      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
	      onChange = props.onChange,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$ScrollButtonCo = props.ScrollButtonComponent,
	      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? _TabScrollButton.default : _props$ScrollButtonCo,
	      _props$scrollButtons = props.scrollButtons,
	      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
	      _props$TabIndicatorPr = props.TabIndicatorProps,
	      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "value", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var scrollable = variant === 'scrollable';
	  var isRtl = theme.direction === 'rtl';
	  var vertical = orientation === 'vertical';
	  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
	  var start = vertical ? 'top' : 'left';
	  var end = vertical ? 'bottom' : 'right';
	  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
	  var size = vertical ? 'height' : 'width';
	
	  if (false) {
	    if (centered && scrollable) {
	      console.error('Material-UI: you can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
	    }
	  }
	
	  var _React$useState = React.useState(false),
	      mounted = _React$useState[0],
	      setMounted = _React$useState[1];
	
	  var _React$useState2 = React.useState({}),
	      indicatorStyle = _React$useState2[0],
	      setIndicatorStyle = _React$useState2[1];
	
	  var _React$useState3 = React.useState({
	    start: false,
	    end: false
	  }),
	      displayScroll = _React$useState3[0],
	      setDisplayScroll = _React$useState3[1];
	
	  var _React$useState4 = React.useState({
	    overflow: 'hidden',
	    marginBottom: null
	  }),
	      scrollerStyle = _React$useState4[0],
	      setScrollerStyle = _React$useState4[1];
	
	  var valueToIndex = new Map();
	  var tabsRef = React.useRef(null);
	  var childrenWrapperRef = React.useRef(null);
	
	  var getTabsMeta = function getTabsMeta() {
	    var tabsNode = tabsRef.current;
	    var tabsMeta;
	
	    if (tabsNode) {
	      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
	
	      tabsMeta = {
	        clientWidth: tabsNode.clientWidth,
	        scrollLeft: tabsNode.scrollLeft,
	        scrollTop: tabsNode.scrollTop,
	        scrollLeftNormalized: (0, _scrollLeft.getNormalizedScrollLeft)(tabsNode, theme.direction),
	        scrollWidth: tabsNode.scrollWidth,
	        top: rect.top,
	        bottom: rect.bottom,
	        left: rect.left,
	        right: rect.right
	      };
	    }
	
	    var tabMeta;
	
	    if (tabsNode && value !== false) {
	      var _children = childrenWrapperRef.current.children;
	
	      if (_children.length > 0) {
	        var tab = _children[valueToIndex.get(value)];
	
	        if (false) {
	          if (!tab) {
	            console.error(["Material-UI: the value provided to the Tabs component is invalid.", "None of the Tabs' children match with `".concat(value, "`."), valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
	          }
	        }
	
	        tabMeta = tab ? tab.getBoundingClientRect() : null;
	      }
	    }
	
	    return {
	      tabsMeta: tabsMeta,
	      tabMeta: tabMeta
	    };
	  };
	
	  var updateIndicatorState = (0, _useEventCallback.default)(function () {
	    var _newIndicatorStyle;
	
	    var _getTabsMeta = getTabsMeta(),
	        tabsMeta = _getTabsMeta.tabsMeta,
	        tabMeta = _getTabsMeta.tabMeta;
	
	    var startValue = 0;
	
	    if (tabMeta && tabsMeta) {
	      if (vertical) {
	        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
	      } else {
	        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
	        startValue = tabMeta.left - tabsMeta.left + correction;
	      }
	    }
	
	    var newIndicatorStyle = (_newIndicatorStyle = {}, (0, _defineProperty2.default)(_newIndicatorStyle, start, startValue), (0, _defineProperty2.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
	
	    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
	      setIndicatorStyle(newIndicatorStyle);
	    } else {
	      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
	      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
	
	      if (dStart >= 1 || dSize >= 1) {
	        setIndicatorStyle(newIndicatorStyle);
	      }
	    }
	  });
	
	  var scroll = function scroll(scrollValue) {
	    (0, _animate.default)(scrollStart, tabsRef.current, scrollValue);
	  };
	
	  var moveTabsScroll = function moveTabsScroll(delta) {
	    var scrollValue = tabsRef.current[scrollStart];
	
	    if (vertical) {
	      scrollValue += delta;
	    } else {
	      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
	
	      scrollValue *= isRtl && (0, _scrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
	    }
	
	    scroll(scrollValue);
	  };
	
	  var handleStartScrollClick = function handleStartScrollClick() {
	    moveTabsScroll(-tabsRef.current[clientSize]);
	  };
	
	  var handleEndScrollClick = function handleEndScrollClick() {
	    moveTabsScroll(tabsRef.current[clientSize]);
	  };
	
	  var handleScrollbarSizeChange = React.useCallback(function (scrollbarHeight) {
	    setScrollerStyle({
	      overflow: null,
	      marginBottom: -scrollbarHeight
	    });
	  }, []);
	
	  var getConditionalElements = function getConditionalElements() {
	    var conditionalElements = {};
	    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/React.createElement(_ScrollbarSize.default, {
	      className: classes.scrollable,
	      onChange: handleScrollbarSizeChange
	    }) : null;
	    var scrollButtonsActive = displayScroll.start || displayScroll.end;
	    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
	    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/React.createElement(ScrollButtonComponent, {
	      orientation: orientation,
	      direction: isRtl ? 'right' : 'left',
	      onClick: handleStartScrollClick,
	      visible: displayScroll.start,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }) : null;
	    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/React.createElement(ScrollButtonComponent, {
	      orientation: orientation,
	      direction: isRtl ? 'left' : 'right',
	      onClick: handleEndScrollClick,
	      visible: displayScroll.end,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }) : null;
	    return conditionalElements;
	  };
	
	  var scrollSelectedIntoView = (0, _useEventCallback.default)(function () {
	    var _getTabsMeta2 = getTabsMeta(),
	        tabsMeta = _getTabsMeta2.tabsMeta,
	        tabMeta = _getTabsMeta2.tabMeta;
	
	    if (!tabMeta || !tabsMeta) {
	      return;
	    }
	
	    if (tabMeta[start] < tabsMeta[start]) {
	      // left side of button is out of view
	      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
	      scroll(nextScrollStart);
	    } else if (tabMeta[end] > tabsMeta[end]) {
	      // right side of button is out of view
	      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
	
	      scroll(_nextScrollStart);
	    }
	  });
	  var updateScrollButtonState = (0, _useEventCallback.default)(function () {
	    if (scrollable && scrollButtons !== 'off') {
	      var _tabsRef$current = tabsRef.current,
	          scrollTop = _tabsRef$current.scrollTop,
	          scrollHeight = _tabsRef$current.scrollHeight,
	          clientHeight = _tabsRef$current.clientHeight,
	          scrollWidth = _tabsRef$current.scrollWidth,
	          clientWidth = _tabsRef$current.clientWidth;
	      var showStartScroll;
	      var showEndScroll;
	
	      if (vertical) {
	        showStartScroll = scrollTop > 1;
	        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
	      } else {
	        var scrollLeft = (0, _scrollLeft.getNormalizedScrollLeft)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
	
	        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	      }
	
	      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
	        setDisplayScroll({
	          start: showStartScroll,
	          end: showEndScroll
	        });
	      }
	    }
	  });
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      updateIndicatorState();
	      updateScrollButtonState();
	    });
	    var win = (0, _ownerWindow.default)(tabsRef.current);
	    win.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      win.removeEventListener('resize', handleResize);
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	  var handleTabsScroll = React.useCallback((0, _debounce.default)(function () {
	    updateScrollButtonState();
	  }));
	  React.useEffect(function () {
	    return function () {
	      handleTabsScroll.clear();
	    };
	  }, [handleTabsScroll]);
	  React.useEffect(function () {
	    setMounted(true);
	  }, []);
	  React.useEffect(function () {
	    updateIndicatorState();
	    updateScrollButtonState();
	  });
	  React.useEffect(function () {
	    scrollSelectedIntoView();
	  }, [scrollSelectedIntoView, indicatorStyle]);
	  React.useImperativeHandle(action, function () {
	    return {
	      updateIndicator: updateIndicatorState,
	      updateScrollButtons: updateScrollButtonState
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	  var indicator = /*#__PURE__*/React.createElement(_TabIndicator.default, (0, _extends2.default)({
	    className: classes.indicator,
	    orientation: orientation,
	    color: indicatorColor
	  }, TabIndicatorProps, {
	    style: (0, _extends2.default)({}, indicatorStyle, {}, TabIndicatorProps.style)
	  }));
	  var childIndex = 0;
	  var children = React.Children.map(childrenProp, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    valueToIndex.set(childValue, childIndex);
	    var selected = childValue === value;
	    childIndex += 1;
	    return React.cloneElement(child, {
	      fullWidth: variant === 'fullWidth',
	      indicator: selected && !mounted && indicator,
	      selected: selected,
	      onChange: onChange,
	      textColor: textColor,
	      value: childValue
	    });
	  });
	  var conditionalElements = getConditionalElements();
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, vertical && classes.vertical),
	    ref: ref
	  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
	    style: scrollerStyle,
	    ref: tabsRef,
	    onScroll: handleTabsScroll
	  }, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
	    ref: childrenWrapperRef,
	    role: "tablist"
	  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
	});
	 false ? Tabs.propTypes = {
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _utils.refType,
	
	  /**
	   * If `true`, the tabs will be centered.
	   * This property is intended for large views.
	   */
	  centered: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Determines the color of the indicator.
	   */
	  indicatorColor: _propTypes.default.oneOf(['secondary', 'primary']),
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value We default to the index of the child (number)
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The component used to render the scroll buttons.
	   */
	  ScrollButtonComponent: _propTypes.default.elementType,
	
	  /**
	   * Determine behavior of scroll buttons when tabs are set to scroll:
	   *
	   * - `auto` will only present them when not all the items are visible.
	   * - `desktop` will only present them on medium and larger viewports.
	   * - `on` will always present them.
	   * - `off` will never present them.
	   */
	  scrollButtons: _propTypes.default.oneOf(['auto', 'desktop', 'on', 'off']),
	
	  /**
	   * Props applied to the tab indicator element.
	   */
	  TabIndicatorProps: _propTypes.default.object,
	
	  /**
	   * Determines the color of the `Tab`.
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * The value of the currently selected `Tab`.
	   * If you don't want any selected `Tab`, you can set this property to `false`.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   *  Determines additional display behavior of the tabs:
	   *
	   *  - `scrollable` will invoke scrolling properties and allow for horizontally
	   *  scrolling (or swiping) of the tab bar.
	   *  -`fullWidth` will make the tabs grow to use all the available space,
	   *  which should be used for small views, like on mobile.
	   *  - `standard` will render the default state.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'scrollable', 'fullWidth'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabs'
	})(Tabs);
	
	exports.default = _default;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	
	var _Tabs = _interopRequireDefault(__webpack_require__(884));

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _Input = _interopRequireDefault(__webpack_require__(160));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(223));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(227));
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(321));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(224));
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(318));
	
	var _Select = _interopRequireDefault(__webpack_require__(165));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var variantComponent = {
	  standard: _Input.default,
	  filled: _FilledInput.default,
	  outlined: _OutlinedInput.default
	};
	var styles = {
	  /* Styles applied to the root element. */
	  root: {}
	};
	/**
	 * The `TextField` is a convenience wrapper for the most common cases (80%).
	 * It cannot be all things to all people, otherwise the API would grow out of control.
	 *
	 * ## Advanced Configuration
	 *
	 * It's important to understand that the text field is a simple abstraction
	 * on top of the following components:
	 *
	 * - [FormControl](/api/form-control/)
	 * - [InputLabel](/api/input-label/)
	 * - [FilledInput](/api/filled-input/)
	 * - [OutlinedInput](/api/outlined-input/)
	 * - [Input](/api/input/)
	 * - [FormHelperText](/api/form-helper-text/)
	 *
	 * If you wish to alter the props applied to the `input` element, you can do so as follows:
	 *
	 * ```jsx
	 * const inputProps = {
	 *   step: 300,
	 * };
	 *
	 * return <TextField id="time" type="time" inputProps={inputProps} />;
	 * ```
	 *
	 * For advanced cases, please look at the source of TextField by clicking on the
	 * "Edit this page" button above. Consider either:
	 *
	 * - using the upper case props for passing values directly to the components
	 * - using the underlying components directly as shown in the demos
	 */
	
	exports.styles = styles;
	var TextField = React.forwardRef(function TextField(props, ref) {
	  var autoComplete = props.autoComplete,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      FormHelperTextProps = props.FormHelperTextProps,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      helperText = props.helperText,
	      hiddenLabel = props.hiddenLabel,
	      id = props.id,
	      InputLabelProps = props.InputLabelProps,
	      inputProps = props.inputProps,
	      InputProps = props.InputProps,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      placeholder = props.placeholder,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$select = props.select,
	      select = _props$select === void 0 ? false : _props$select,
	      SelectProps = props.SelectProps,
	      type = props.type,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);
	
	  if (false) {
	    if (select && !children) {
	      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
	    }
	  }
	
	  var InputMore = {};
	
	  if (variant === 'outlined') {
	    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
	      InputMore.notched = InputLabelProps.shrink;
	    }
	
	    if (label) {
	      var _InputLabelProps$requ;
	
	      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
	      InputMore.label = /*#__PURE__*/React.createElement(React.Fragment, null, label, displayRequired && "\xA0*");
	    }
	  }
	
	  if (select) {
	    // unset defaults from textbox inputs
	    if (!SelectProps || !SelectProps.native) {
	      InputMore.id = undefined;
	    }
	
	    InputMore['aria-describedby'] = undefined;
	  }
	
	  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
	  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
	  var InputComponent = variantComponent[variant];
	  var InputElement = /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    fullWidth: fullWidth,
	    multiline: multiline,
	    name: name,
	    rows: rows,
	    rowsMax: rowsMax,
	    type: type,
	    value: value,
	    id: id,
	    inputRef: inputRef,
	    onBlur: onBlur,
	    onChange: onChange,
	    onFocus: onFocus,
	    placeholder: placeholder,
	    inputProps: inputProps
	  }, InputMore, InputProps));
	  return /*#__PURE__*/React.createElement(_FormControl.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    disabled: disabled,
	    error: error,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    ref: ref,
	    required: required,
	    color: color,
	    variant: variant
	  }, other), label && /*#__PURE__*/React.createElement(_InputLabel.default, (0, _extends2.default)({
	    htmlFor: id,
	    id: inputLabelId
	  }, InputLabelProps), label), select ? /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    id: id,
	    labelId: inputLabelId,
	    value: value,
	    input: InputElement
	  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/React.createElement(_FormHelperText.default, (0, _extends2.default)({
	    id: helperTextId
	  }, FormHelperTextProps), helperText));
	});
	 false ? TextField.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default value of the `input` element.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
	   */
	  FormHelperTextProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The helper text content.
	   */
	  helperText: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   * Use this prop to make `label` and `helperText` accessible for screen readers.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`InputLabel`](/api/input-label/) element.
	   */
	  InputLabelProps: _propTypes.default.object,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the Input element.
	   * It will be a [`FilledInput`](/api/filled-input/),
	   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
	   * component depending on the `variant` prop value.
	   */
	  InputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label content.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none', 'normal']),
	
	  /**
	   * If `true`, a textarea element will be rendered instead of an input.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * If `true`, the label is displayed as required and the `input` element` will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
	   * If this option is set you must pass the options of the select as children.
	   */
	  select: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTextField'
	})(TextField);
	
	exports.default = _default;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	
	var _TextField = _interopRequireDefault(__webpack_require__(886));

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _debounce = _interopRequireDefault(__webpack_require__(93));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	function getStyleValue(computedStyle, property) {
	  return parseInt(computedStyle[property], 10) || 0;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var styles = {
	  /* Styles applied to the shadow textarea element. */
	  shadow: {
	    // Visibility needed to hide the extra text area on iPads
	    visibility: 'hidden',
	    // Remove from the content flow
	    position: 'absolute',
	    // Ignore the scrollbar width
	    overflow: 'hidden',
	    height: 0,
	    top: 0,
	    left: 0,
	    // Create a new layer, increase the isolation of the computed values
	    transform: 'translateZ(0)'
	  }
	};
	var TextareaAutosize = React.forwardRef(function TextareaAutosize(props, ref) {
	  var onChange = props.onChange,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$rowsMin = props.rowsMin,
	      rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin,
	      style = props.style,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]);
	  var rowsMin = rows || rowsMinProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(ref, inputRef);
	  var shadowRef = React.useRef(null);
	  var renders = React.useRef(0);
	
	  var _React$useState = React.useState({}),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  var syncHeight = React.useCallback(function () {
	    var input = inputRef.current;
	    var computedStyle = window.getComputedStyle(input);
	    var inputShallow = shadowRef.current;
	    inputShallow.style.width = computedStyle.width;
	    inputShallow.value = input.value || props.placeholder || 'x';
	
	    if (inputShallow.value.slice(-1) === '\n') {
	      // Certain fonts which overflow the line height will cause the textarea
	      // to report a different scrollHeight depending on whether the last line
	      // is empty. Make it non-empty to avoid this issue.
	      inputShallow.value += ' ';
	    }
	
	    var boxSizing = computedStyle['box-sizing'];
	    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
	    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
	
	    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
	
	    inputShallow.value = 'x';
	    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
	
	    var outerHeight = innerHeight;
	
	    if (rowsMin) {
	      outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
	    }
	
	    if (rowsMax) {
	      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
	    }
	
	    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
	
	    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
	    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
	    setState(function (prevState) {
	      // Need a large enough difference to update the height.
	      // This prevents infinite rendering loop.
	      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
	        renders.current += 1;
	        return {
	          overflow: overflow,
	          outerHeightStyle: outerHeightStyle
	        };
	      }
	
	      if (false) {
	        if (renders.current === 20) {
	          console.error(['Material-UI: too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
	        }
	      }
	
	      return prevState;
	    });
	  }, [rowsMax, rowsMin, props.placeholder]);
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      renders.current = 0;
	      syncHeight();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [syncHeight]);
	  useEnhancedEffect(function () {
	    syncHeight();
	  });
	  React.useEffect(function () {
	    renders.current = 0;
	  }, [value]);
	
	  var handleChange = function handleChange(event) {
	    renders.current = 0;
	
	    if (!isControlled) {
	      syncHeight();
	    }
	
	    if (onChange) {
	      onChange(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", (0, _extends2.default)({
	    value: value,
	    onChange: handleChange,
	    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
	    ,
	    rows: rowsMin,
	    style: (0, _extends2.default)({
	      height: state.outerHeightStyle,
	      // Need a large enough difference to allow scrolling.
	      // This prevents infinite rendering loop.
	      overflow: state.overflow ? 'hidden' : null
	    }, style)
	  }, other)), /*#__PURE__*/React.createElement("textarea", {
	    "aria-hidden": true,
	    className: props.className,
	    readOnly: true,
	    ref: shadowRef,
	    tabIndex: -1,
	    style: (0, _extends2.default)({}, styles.shadow, {}, style)
	  }));
	});
	 false ? TextareaAutosize.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * Use `rowsMin` instead. The prop will be removed in v5.
	   *
	   * @deprecated
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string])
	} : void 0;
	var _default = TextareaAutosize;
	exports.default = _default;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: (0, _defineProperty2.default)({
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2)
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `variant="regular"`. */
	    regular: theme.mixins.toolbar,
	
	    /* Styles applied to the root element if `variant="dense"`. */
	    dense: {
	      minHeight: 48
	    }
	  };
	};
	
	exports.styles = styles;
	var Toolbar = React.forwardRef(function Toolbar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'regular' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? Toolbar.propTypes = {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['regular', 'dense'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiToolbar'
	})(Toolbar);
	
	exports.default = _default;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testReset = testReset;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(32));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(21);
	
	var _colorManipulator = __webpack_require__(41);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var _Grow = _interopRequireDefault(__webpack_require__(80));
	
	var _Popper = _interopRequireDefault(__webpack_require__(135));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(33));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(238));
	
	var _setRef = _interopRequireDefault(__webpack_require__(94));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(140));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(95));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	function arrowGenerator() {
	  return {
	    '&[x-placement*="bottom"] $arrow': {
	      top: 0,
	      left: 0,
	      marginTop: '-0.95em',
	      marginLeft: 4,
	      marginRight: 4,
	      width: '2em',
	      height: '1em',
	      '&::before': {
	        borderWidth: '0 1em 1em 1em',
	        borderColor: 'transparent transparent currentcolor transparent'
	      }
	    },
	    '&[x-placement*="top"] $arrow': {
	      bottom: 0,
	      left: 0,
	      marginBottom: '-0.95em',
	      marginLeft: 4,
	      marginRight: 4,
	      width: '2em',
	      height: '1em',
	      '&::before': {
	        borderWidth: '1em 1em 0 1em',
	        borderColor: 'currentcolor transparent transparent transparent'
	      }
	    },
	    '&[x-placement*="right"] $arrow': {
	      left: 0,
	      marginLeft: '-0.95em',
	      marginTop: 4,
	      marginBottom: 4,
	      height: '2em',
	      width: '1em',
	      '&::before': {
	        borderWidth: '1em 1em 1em 0',
	        borderColor: 'transparent currentcolor transparent transparent'
	      }
	    },
	    '&[x-placement*="left"] $arrow': {
	      right: 0,
	      marginRight: '-0.95em',
	      marginTop: 4,
	      marginBottom: 4,
	      height: '2em',
	      width: '1em',
	      '&::before': {
	        borderWidth: '1em 0 1em 1em',
	        borderColor: 'transparent transparent transparent currentcolor'
	      }
	    }
	  };
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the Popper component. */
	    popper: {
	      zIndex: theme.zIndex.tooltip,
	      pointerEvents: 'none' // disable jss-rtl plugin
	
	    },
	
	    /* Styles applied to the Popper component if `interactive={true}`. */
	    popperInteractive: {
	      pointerEvents: 'auto'
	    },
	
	    /* Styles applied to the Popper component if `arrow={true}`. */
	    popperArrow: arrowGenerator(),
	
	    /* Styles applied to the tooltip (label wrapper) element. */
	    tooltip: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.common.white,
	      fontFamily: theme.typography.fontFamily,
	      padding: '4px 8px',
	      fontSize: theme.typography.pxToRem(10),
	      lineHeight: "".concat(round(14 / 10), "em"),
	      maxWidth: 300,
	      wordWrap: 'break-word',
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
	    tooltipArrow: {
	      position: 'relative',
	      margin: '0'
	    },
	
	    /* Styles applied to the arrow element. */
	    arrow: {
	      position: 'absolute',
	      fontSize: 6,
	      color: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      '&::before': {
	        content: '""',
	        margin: 'auto',
	        display: 'block',
	        width: 0,
	        height: 0,
	        borderStyle: 'solid'
	      }
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
	    touch: {
	      padding: '8px 16px',
	      fontSize: theme.typography.pxToRem(14),
	      lineHeight: "".concat(round(16 / 14), "em"),
	      fontWeight: theme.typography.fontWeightRegular
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
	    tooltipPlacementLeft: (0, _defineProperty2.default)({
	      transformOrigin: 'right center',
	      margin: '0 24px '
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
	    tooltipPlacementRight: (0, _defineProperty2.default)({
	      transformOrigin: 'left center',
	      margin: '0 24px'
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
	    tooltipPlacementTop: (0, _defineProperty2.default)({
	      transformOrigin: 'center bottom',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
	    tooltipPlacementBottom: (0, _defineProperty2.default)({
	      transformOrigin: 'center top',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    })
	  };
	};
	
	exports.styles = styles;
	var hystersisOpen = false;
	var hystersisTimer = null;
	
	function testReset() {
	  hystersisOpen = false;
	  clearTimeout(hystersisTimer);
	}
	
	var Tooltip = React.forwardRef(function Tooltip(props, ref) {
	  var _props$arrow = props.arrow,
	      arrow = _props$arrow === void 0 ? false : _props$arrow,
	      children = props.children,
	      classes = props.classes,
	      _props$disableFocusLi = props.disableFocusListener,
	      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
	      _props$disableHoverLi = props.disableHoverListener,
	      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
	      _props$disableTouchLi = props.disableTouchListener,
	      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
	      _props$enterDelay = props.enterDelay,
	      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
	      _props$enterNextDelay = props.enterNextDelay,
	      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
	      _props$enterTouchDela = props.enterTouchDelay,
	      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
	      idProp = props.id,
	      _props$interactive = props.interactive,
	      interactive = _props$interactive === void 0 ? false : _props$interactive,
	      _props$leaveDelay = props.leaveDelay,
	      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
	      _props$leaveTouchDela = props.leaveTouchDelay,
	      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      _props$placement = props.placement,
	      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      PopperProps = props.PopperProps,
	      title = props.title,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);
	  var theme = (0, _useTheme.default)();
	
	  var _React$useState = React.useState(),
	      childNode = _React$useState[0],
	      setChildNode = _React$useState[1];
	
	  var _React$useState2 = React.useState(null),
	      arrowRef = _React$useState2[0],
	      setArrowRef = _React$useState2[1];
	
	  var ignoreNonTouchEvents = React.useRef(false);
	  var closeTimer = React.useRef();
	  var enterTimer = React.useRef();
	  var leaveTimer = React.useRef();
	  var touchTimer = React.useRef();
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: openProp,
	    default: false,
	    name: 'Tooltip',
	    state: 'open'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      openState = _useControlled2[0],
	      setOpenState = _useControlled2[1];
	
	  var open = openState;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var _React$useRef = React.useRef(openProp !== undefined),
	        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks
	
	
	    React.useEffect(function () {
	      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
	        console.error(['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
	      }
	    }, [title, childNode, isControlled]);
	  }
	
	  var id = (0, _unstable_useId.default)(idProp);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(closeTimer.current);
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      clearTimeout(touchTimer.current);
	    };
	  }, []);
	
	  var handleOpen = function handleOpen(event) {
	    clearTimeout(hystersisTimer);
	    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
	    // We can skip rerendering when the tooltip is already open.
	    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
	
	    setOpenState(true);
	
	    if (onOpen) {
	      onOpen(event);
	    }
	  };
	
	  var handleEnter = function handleEnter() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      var childrenProps = children.props;
	
	      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
	        childrenProps.onMouseOver(event);
	      }
	
	      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
	        return;
	      } // Remove the title ahead of time.
	      // We don't want to wait for the next render commit.
	      // We would risk displaying two tooltips at the same time (native + this one).
	
	
	      if (childNode) {
	        childNode.removeAttribute('title');
	      }
	
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	
	      if (enterDelay || hystersisOpen && enterNextDelay) {
	        event.persist();
	        enterTimer.current = setTimeout(function () {
	          handleOpen(event);
	        }, hystersisOpen ? enterNextDelay : enterDelay);
	      } else {
	        handleOpen(event);
	      }
	    };
	  };
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState3 = React.useState(false),
	      childIsFocusVisible = _React$useState3[0],
	      setChildIsFocusVisible = _React$useState3[1];
	
	  var handleBlur = function handleBlur() {
	    if (childIsFocusVisible) {
	      setChildIsFocusVisible(false);
	      onBlurVisible();
	    }
	  };
	
	  var handleFocus = function handleFocus() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      // Workaround for https://github.com/facebook/react/issues/7769
	      // The autoFocus of React might trigger the event before the componentDidMount.
	      // We need to account for this eventuality.
	      if (!childNode) {
	        setChildNode(event.currentTarget);
	      }
	
	      if (isFocusVisible(event)) {
	        setChildIsFocusVisible(true);
	        handleEnter()(event);
	      }
	
	      var childrenProps = children.props;
	
	      if (childrenProps.onFocus && forward) {
	        childrenProps.onFocus(event);
	      }
	    };
	  };
	
	  var handleClose = function handleClose(event) {
	    clearTimeout(hystersisTimer);
	    hystersisTimer = setTimeout(function () {
	      hystersisOpen = false;
	    }, 800 + leaveDelay);
	    setOpenState(false);
	
	    if (onClose) {
	      onClose(event);
	    }
	
	    clearTimeout(closeTimer.current);
	    closeTimer.current = setTimeout(function () {
	      ignoreNonTouchEvents.current = false;
	    }, theme.transitions.duration.shortest);
	  };
	
	  var handleLeave = function handleLeave() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      var childrenProps = children.props;
	
	      if (event.type === 'blur') {
	        if (childrenProps.onBlur && forward) {
	          childrenProps.onBlur(event);
	        }
	
	        handleBlur();
	      }
	
	      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
	        childrenProps.onMouseLeave(event);
	      }
	
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      event.persist();
	      leaveTimer.current = setTimeout(function () {
	        handleClose(event);
	      }, leaveDelay);
	    };
	  };
	
	  var handleTouchStart = function handleTouchStart(event) {
	    ignoreNonTouchEvents.current = true;
	    var childrenProps = children.props;
	
	    if (childrenProps.onTouchStart) {
	      childrenProps.onTouchStart(event);
	    }
	
	    clearTimeout(leaveTimer.current);
	    clearTimeout(closeTimer.current);
	    clearTimeout(touchTimer.current);
	    event.persist();
	    touchTimer.current = setTimeout(function () {
	      handleEnter()(event);
	    }, enterTouchDelay);
	  };
	
	  var handleTouchEnd = function handleTouchEnd(event) {
	    if (children.props.onTouchEnd) {
	      children.props.onTouchEnd(event);
	    }
	
	    clearTimeout(touchTimer.current);
	    clearTimeout(leaveTimer.current);
	    event.persist();
	    leaveTimer.current = setTimeout(function () {
	      handleClose(event);
	    }, leaveTouchDelay);
	  };
	
	  var handleUseRef = (0, _useForkRef.default)(setChildNode, ref);
	  var handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    (0, _setRef.default)(handleFocusRef, ReactDOM.findDOMNode(instance));
	  }, [handleFocusRef]);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
	
	  if (title === '') {
	    open = false;
	  } // For accessibility and SEO concerns, we render the title to the DOM node when
	  // the tooltip is hidden. However, we have made a tradeoff when
	  // `disableHoverListener` is set. This title logic is disabled.
	  // It's allowing us to keep the implementation size minimal.
	  // We are open to change the tradeoff.
	
	
	  var shouldShowNativeTitle = !open && !disableHoverListener;
	  var childrenProps = (0, _extends2.default)({
	    'aria-describedby': open ? id : null,
	    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
	  }, other, {}, children.props, {
	    className: (0, _clsx.default)(other.className, children.props.className),
	    ref: handleRef
	  });
	  var interactiveWrapperListeners = {};
	
	  if (!disableTouchListener) {
	    childrenProps.onTouchStart = handleTouchStart;
	    childrenProps.onTouchEnd = handleTouchEnd;
	  }
	
	  if (!disableHoverListener) {
	    childrenProps.onMouseOver = handleEnter();
	    childrenProps.onMouseLeave = handleLeave();
	
	    if (interactive) {
	      interactiveWrapperListeners.onMouseOver = handleEnter(false);
	      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
	    }
	  }
	
	  if (!disableFocusListener) {
	    childrenProps.onFocus = handleFocus();
	    childrenProps.onBlur = handleLeave();
	
	    if (interactive) {
	      interactiveWrapperListeners.onFocus = handleFocus(false);
	      interactiveWrapperListeners.onBlur = handleLeave(false);
	    }
	  }
	
	  if (false) {
	    if (children.props.title) {
	      console.error(['Material-UI: you have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
	    }
	  }
	
	  var mergedPopperProps = React.useMemo(function () {
	    return (0, _utils.deepmerge)({
	      popperOptions: {
	        modifiers: {
	          arrow: {
	            enabled: Boolean(arrowRef),
	            element: arrowRef
	          }
	        }
	      }
	    }, PopperProps);
	  }, [arrowRef, PopperProps]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, React.cloneElement(children, childrenProps), /*#__PURE__*/React.createElement(_Popper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
	    placement: placement,
	    anchorEl: childNode,
	    open: childNode ? open : false,
	    id: childrenProps['aria-describedby'],
	    transition: true
	  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
	    var placementInner = _ref.placement,
	        TransitionPropsInner = _ref.TransitionProps;
	    return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	      timeout: theme.transitions.duration.shorter
	    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/React.createElement("div", {
	      className: (0, _clsx.default)(classes.tooltip, classes["tooltipPlacement".concat((0, _capitalize.default)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
	    }, title, arrow ? /*#__PURE__*/React.createElement("span", {
	      className: classes.arrow,
	      ref: setArrowRef
	    }) : null));
	  }));
	});
	 false ? Tooltip.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, adds an arrow to the tooltip.
	   */
	  arrow: _propTypes.default.bool,
	
	  /**
	   * Tooltip reference element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Do not respond to focus events.
	   */
	  disableFocusListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to hover events.
	   */
	  disableHoverListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to long press touch events.
	   */
	  disableTouchListener: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip.
	   * This prop won't impact the enter touch delay (`enterTouchDelay`).
	   */
	  enterDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
	   */
	  enterNextDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds a user must touch the element before showing the tooltip.
	   */
	  enterTouchDelay: _propTypes.default.number,
	
	  /**
	   * This prop is used to help implement the accessibility logic.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Makes a tooltip interactive, i.e. will not close when the user
	   * hovers over the tooltip before the `leaveDelay` is expired.
	   */
	  interactive: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before hiding the tooltip.
	   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
	   */
	  leaveDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
	   */
	  leaveTouchDelay: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be open.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * If `true`, the tooltip is shown.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Tooltip placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Props applied to the [`Popper`](/api/popper/) element.
	   */
	  PopperProps: _propTypes.default.object,
	
	  /**
	   * Tooltip title. Zero-length titles string are never displayed.
	   */
	  title: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .node.isRequired,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTooltip',
	  flip: false
	})(Tooltip);
	
	exports.default = _default;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      margin: 0
	    },
	
	    /* Styles applied to the root element if `variant="body2"`. */
	    body2: theme.typography.body2,
	
	    /* Styles applied to the root element if `variant="body1"`. */
	    body1: theme.typography.body1,
	
	    /* Styles applied to the root element if `variant="caption"`. */
	    caption: theme.typography.caption,
	
	    /* Styles applied to the root element if `variant="button"`. */
	    button: theme.typography.button,
	
	    /* Styles applied to the root element if `variant="h1"`. */
	    h1: theme.typography.h1,
	
	    /* Styles applied to the root element if `variant="h2"`. */
	    h2: theme.typography.h2,
	
	    /* Styles applied to the root element if `variant="h3"`. */
	    h3: theme.typography.h3,
	
	    /* Styles applied to the root element if `variant="h4"`. */
	    h4: theme.typography.h4,
	
	    /* Styles applied to the root element if `variant="h5"`. */
	    h5: theme.typography.h5,
	
	    /* Styles applied to the root element if `variant="h6"`. */
	    h6: theme.typography.h6,
	
	    /* Styles applied to the root element if `variant="subtitle1"`. */
	    subtitle1: theme.typography.subtitle1,
	
	    /* Styles applied to the root element if `variant="subtitle2"`. */
	    subtitle2: theme.typography.subtitle2,
	
	    /* Styles applied to the root element if `variant="overline"`. */
	    overline: theme.typography.overline,
	
	    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
	    srOnly: {
	      position: 'absolute',
	      height: 1,
	      width: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `nowrap={true}`. */
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `gutterBottom={true}`. */
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	
	    /* Styles applied to the root element if `paragraph={true}`. */
	    paragraph: {
	      marginBottom: 16
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="textPrimary"`. */
	    colorTextPrimary: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `color="textSecondary"`. */
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `display="inline"`. */
	    displayInline: {
	      display: 'inline'
	    },
	
	    /* Styles applied to the root element if `display="block"`. */
	    displayBlock: {
	      display: 'block'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultVariantMapping = {
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  subtitle1: 'h6',
	  subtitle2: 'h6',
	  body1: 'p',
	  body2: 'p'
	};
	var Typography = React.forwardRef(function Typography(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'initial' : _props$color,
	      component = props.component,
	      _props$display = props.display,
	      display = _props$display === void 0 ? 'initial' : _props$display,
	      _props$gutterBottom = props.gutterBottom,
	      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
	      _props$noWrap = props.noWrap,
	      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
	      _props$paragraph = props.paragraph,
	      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'body1' : _props$variant,
	      _props$variantMapping = props.variantMapping,
	      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);
	  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, _capitalize.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], display !== 'initial' && classes["display".concat((0, _capitalize.default)(display))]),
	    ref: ref
	  }, other));
	});
	 false ? Typography.propTypes = {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   * Overrides the behavior of the `variantMapping` prop.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Controls the display type
	   */
	  display: _propTypes.default.oneOf(['initial', 'block', 'inline']),
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
	   *
	   * Note that text overflow can only happen with block or inline-block level elements
	   * (the element needs to have a width in order to overflow).
	   */
	  noWrap: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes.default.bool,
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),
	
	  /**
	   * The component maps the variant prop to a range of different HTML element types.
	   * For instance, subtitle1 to `<h6>`.
	   * If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` prop.
	   */
	  variantMapping: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTypography'
	})(Typography);
	
	exports.default = _default;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(143);
	
	var _utils = __webpack_require__(34);
	
	var _Zoom = _interopRequireDefault(__webpack_require__(340));
	
	/**
	 * @ignore - internal component.
	 */
	var StrictModeZoom = React.forwardRef(function StrictModeZoom(props, forwardedRef) {
	  var domRef = React.useRef(null);
	  var ref = (0, _utils.useForkRef)(domRef, forwardedRef);
	  return /*#__PURE__*/React.createElement(_Zoom.default, (0, _extends2.default)({}, props, {
	    findDOMNode: function findDOMNode() {
	      return domRef.current;
	    },
	    ref: ref,
	    TransitionComponent: _reactTransitionGroup.Transition
	  }));
	});
	var _default = StrictModeZoom;
	exports.default = _default;

/***/ },
/* 893 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var amber = {
	  50: '#fff8e1',
	  100: '#ffecb3',
	  200: '#ffe082',
	  300: '#ffd54f',
	  400: '#ffca28',
	  500: '#ffc107',
	  600: '#ffb300',
	  700: '#ffa000',
	  800: '#ff8f00',
	  900: '#ff6f00',
	  A100: '#ffe57f',
	  A200: '#ffd740',
	  A400: '#ffc400',
	  A700: '#ffab00'
	};
	var _default = amber;
	exports.default = _default;

/***/ },
/* 894 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blueGrey = {
	  50: '#eceff1',
	  100: '#cfd8dc',
	  200: '#b0bec5',
	  300: '#90a4ae',
	  400: '#78909c',
	  500: '#607d8b',
	  600: '#546e7a',
	  700: '#455a64',
	  800: '#37474f',
	  900: '#263238',
	  A100: '#cfd8dc',
	  A200: '#b0bec5',
	  A400: '#78909c',
	  A700: '#455a64'
	};
	var _default = blueGrey;
	exports.default = _default;

/***/ },
/* 895 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var brown = {
	  50: '#efebe9',
	  100: '#d7ccc8',
	  200: '#bcaaa4',
	  300: '#a1887f',
	  400: '#8d6e63',
	  500: '#795548',
	  600: '#6d4c41',
	  700: '#5d4037',
	  800: '#4e342e',
	  900: '#3e2723',
	  A100: '#d7ccc8',
	  A200: '#bcaaa4',
	  A400: '#8d6e63',
	  A700: '#5d4037'
	};
	var _default = brown;
	exports.default = _default;

/***/ },
/* 896 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var cyan = {
	  50: '#e0f7fa',
	  100: '#b2ebf2',
	  200: '#80deea',
	  300: '#4dd0e1',
	  400: '#26c6da',
	  500: '#00bcd4',
	  600: '#00acc1',
	  700: '#0097a7',
	  800: '#00838f',
	  900: '#006064',
	  A100: '#84ffff',
	  A200: '#18ffff',
	  A400: '#00e5ff',
	  A700: '#00b8d4'
	};
	var _default = cyan;
	exports.default = _default;

/***/ },
/* 897 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepOrange = {
	  50: '#fbe9e7',
	  100: '#ffccbc',
	  200: '#ffab91',
	  300: '#ff8a65',
	  400: '#ff7043',
	  500: '#ff5722',
	  600: '#f4511e',
	  700: '#e64a19',
	  800: '#d84315',
	  900: '#bf360c',
	  A100: '#ff9e80',
	  A200: '#ff6e40',
	  A400: '#ff3d00',
	  A700: '#dd2c00'
	};
	var _default = deepOrange;
	exports.default = _default;

/***/ },
/* 898 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepPurple = {
	  50: '#ede7f6',
	  100: '#d1c4e9',
	  200: '#b39ddb',
	  300: '#9575cd',
	  400: '#7e57c2',
	  500: '#673ab7',
	  600: '#5e35b1',
	  700: '#512da8',
	  800: '#4527a0',
	  900: '#311b92',
	  A100: '#b388ff',
	  A200: '#7c4dff',
	  A400: '#651fff',
	  A700: '#6200ea'
	};
	var _default = deepPurple;
	exports.default = _default;

/***/ },
/* 899 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightBlue = {
	  50: '#e1f5fe',
	  100: '#b3e5fc',
	  200: '#81d4fa',
	  300: '#4fc3f7',
	  400: '#29b6f6',
	  500: '#03a9f4',
	  600: '#039be5',
	  700: '#0288d1',
	  800: '#0277bd',
	  900: '#01579b',
	  A100: '#80d8ff',
	  A200: '#40c4ff',
	  A400: '#00b0ff',
	  A700: '#0091ea'
	};
	var _default = lightBlue;
	exports.default = _default;

/***/ },
/* 900 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightGreen = {
	  50: '#f1f8e9',
	  100: '#dcedc8',
	  200: '#c5e1a5',
	  300: '#aed581',
	  400: '#9ccc65',
	  500: '#8bc34a',
	  600: '#7cb342',
	  700: '#689f38',
	  800: '#558b2f',
	  900: '#33691e',
	  A100: '#ccff90',
	  A200: '#b2ff59',
	  A400: '#76ff03',
	  A700: '#64dd17'
	};
	var _default = lightGreen;
	exports.default = _default;

/***/ },
/* 901 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lime = {
	  50: '#f9fbe7',
	  100: '#f0f4c3',
	  200: '#e6ee9c',
	  300: '#dce775',
	  400: '#d4e157',
	  500: '#cddc39',
	  600: '#c0ca33',
	  700: '#afb42b',
	  800: '#9e9d24',
	  900: '#827717',
	  A100: '#f4ff81',
	  A200: '#eeff41',
	  A400: '#c6ff00',
	  A700: '#aeea00'
	};
	var _default = lime;
	exports.default = _default;

/***/ },
/* 902 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var purple = {
	  50: '#f3e5f5',
	  100: '#e1bee7',
	  200: '#ce93d8',
	  300: '#ba68c8',
	  400: '#ab47bc',
	  500: '#9c27b0',
	  600: '#8e24aa',
	  700: '#7b1fa2',
	  800: '#6a1b9a',
	  900: '#4a148c',
	  A100: '#ea80fc',
	  A200: '#e040fb',
	  A400: '#d500f9',
	  A700: '#aa00ff'
	};
	var _default = purple;
	exports.default = _default;

/***/ },
/* 903 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var teal = {
	  50: '#e0f2f1',
	  100: '#b2dfdb',
	  200: '#80cbc4',
	  300: '#4db6ac',
	  400: '#26a69a',
	  500: '#009688',
	  600: '#00897b',
	  700: '#00796b',
	  800: '#00695c',
	  900: '#004d40',
	  A100: '#a7ffeb',
	  A200: '#64ffda',
	  A400: '#1de9b6',
	  A700: '#00bfa5'
	};
	var _default = teal;
	exports.default = _default;

/***/ },
/* 904 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var yellow = {
	  50: '#fffde7',
	  100: '#fff9c4',
	  200: '#fff59d',
	  300: '#fff176',
	  400: '#ffee58',
	  500: '#ffeb3b',
	  600: '#fdd835',
	  700: '#fbc02d',
	  800: '#f9a825',
	  900: '#f57f17',
	  A100: '#ffff8d',
	  A200: '#ffff00',
	  A400: '#ffea00',
	  A700: '#ffd600'
	};
	var _default = yellow;
	exports.default = _default;

/***/ },
/* 905 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = animate;
	
	function easeInOutSin(time) {
	  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
	}
	
	function animate(property, element, to) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
	  var _options$ease = options.ease,
	      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 300 : _options$duration;
	  var start = null;
	  var from = element[property];
	  var cancelled = false;
	
	  var cancel = function cancel() {
	    cancelled = true;
	  };
	
	  var step = function step(timestamp) {
	    if (cancelled) {
	      cb(new Error('Animation cancelled'));
	      return;
	    }
	
	    if (start === null) {
	      start = timestamp;
	    }
	
	    var time = Math.min(1, (timestamp - start) / duration);
	    element[property] = ease(time) * (to - from) + from;
	
	    if (time >= 1) {
	      requestAnimationFrame(function () {
	        cb(null);
	      });
	      return;
	    }
	
	    requestAnimationFrame(step);
	  };
	
	  if (from === to) {
	    cb(new Error('Element already at target position'));
	    return cancel;
	  }
	
	  requestAnimationFrame(step);
	  return cancel;
	}

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownward');
	
	exports.default = _default;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'Cancel');
	
	exports.default = _default;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckBox');
	
	exports.default = _default;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlank');
	
	exports.default = _default;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
	}), 'CheckCircle');
	
	exports.default = _default;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
	}), 'IndeterminateCheckBox');
	
	exports.default = _default;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHoriz');
	
	exports.default = _default;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'Person');
	
	exports.default = _default;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
	}), 'RadioButtonChecked');
	
	exports.default = _default;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUnchecked');
	
	exports.default = _default;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'Warning');
	
	exports.default = _default;

/***/ },
/* 917 */
[1912, 918],
/* 918 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMixins;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _extends3.default)({
	    gutters: function gutters() {
	      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      // To deprecate in v4.1
	      //       warning(
	      //         false,
	      //         [
	      //           'Material-UI: theme.mixins.gutters() is deprecated.',
	      //           'You can use the source of the mixin directly:',
	      //           `
	      // paddingLeft: theme.spacing(2),
	      // paddingRight: theme.spacing(2),
	      // [theme.breakpoints.up('sm')]: {
	      //   paddingLeft: theme.spacing(3),
	      //   paddingRight: theme.spacing(3),
	      // },
	      // `,
	      //         ].join('\n'),
	      //       );
	      return (0, _extends3.default)({
	        paddingLeft: spacing(2),
	        paddingRight: spacing(2)
	      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
	        paddingLeft: spacing(3),
	        paddingRight: spacing(3)
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
	      minHeight: 48
	    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMuiStrictModeTheme;
	
	var _utils = __webpack_require__(21);
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(237));
	
	var _Collapse = __webpack_require__(70);
	
	var _Fade = __webpack_require__(158);
	
	var _Grow = __webpack_require__(80);
	
	var _Slide = __webpack_require__(229);
	
	var _Zoom = __webpack_require__(341);
	
	function createMuiStrictModeTheme(options) {
	  return (0, _createMuiTheme.default)((0, _utils.deepmerge)({
	    props: {
	      // Collapse
	      MuiExpansionPanel: {
	        TransitionComponent: _Collapse.unstable_StrictModeCollapse
	      },
	      MuiStepContent: {
	        TransitionComponent: _Collapse.unstable_StrictModeCollapse
	      },
	      // Fade
	      MuiBackdrop: {
	        TransitionComponent: _Fade.unstable_StrictModeFade
	      },
	      MuiDialog: {
	        TransitionComponent: _Fade.unstable_StrictModeFade
	      },
	      // Grow
	      MuiPopover: {
	        TransitionComponent: _Grow.unstable_StrictModeGrow
	      },
	      MuiSnackbar: {
	        TransitionComponent: _Grow.unstable_StrictModeGrow
	      },
	      MuiTooltip: {
	        TransitionComponent: _Grow.unstable_StrictModeGrow
	      },
	      // Slide
	      MuiDrawer: {
	        TransitionComponent: _Slide.unstable_StrictModeSlide
	      },
	      // Zoom
	      MuiSpeedDial: {
	        TransitionComponent: _Zoom.unstable_StrictModeZoom
	      }
	    }
	  }, options));
	}

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPalette;
	exports.dark = exports.light = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(21);
	
	var _common = _interopRequireDefault(__webpack_require__(343));
	
	var _grey = _interopRequireDefault(__webpack_require__(345));
	
	var _indigo = _interopRequireDefault(__webpack_require__(346));
	
	var _pink = _interopRequireDefault(__webpack_require__(348));
	
	var _red = _interopRequireDefault(__webpack_require__(349));
	
	var _orange = _interopRequireDefault(__webpack_require__(347));
	
	var _blue = _interopRequireDefault(__webpack_require__(342));
	
	var _green = _interopRequireDefault(__webpack_require__(344));
	
	var _colorManipulator = __webpack_require__(41);
	
	var light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common.default.white,
	    default: _grey.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.04)',
	    hoverOpacity: 0.04,
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.08)',
	    selectedOpacity: 0.08,
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(0, 0, 0, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.12
	  }
	};
	exports.light = light;
	var dark = {
	  text: {
	    primary: _common.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common.default.white,
	    hover: 'rgba(255, 255, 255, 0.08)',
	    hoverOpacity: 0.08,
	    selected: 'rgba(255, 255, 255, 0.16)',
	    selectedOpacity: 0.16,
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(255, 255, 255, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.24
	  }
	};
	exports.dark = dark;
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  var tonalOffsetLight = tonalOffset.light || tonalOffset;
	  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
	
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === void 0 ? {
	    light: _indigo.default[300],
	    main: _indigo.default[500],
	    dark: _indigo.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === void 0 ? {
	    light: _pink.default.A200,
	    main: _pink.default.A400,
	    dark: _pink.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === void 0 ? {
	    light: _red.default[300],
	    main: _red.default[500],
	    dark: _red.default[700]
	  } : _palette$error,
	      _palette$warning = palette.warning,
	      warning = _palette$warning === void 0 ? {
	    light: _orange.default[300],
	    main: _orange.default[500],
	    dark: _orange.default[700]
	  } : _palette$warning,
	      _palette$info = palette.info,
	      info = _palette$info === void 0 ? {
	    light: _blue.default[300],
	    main: _blue.default[500],
	    dark: _blue.default[700]
	  } : _palette$info,
	      _palette$success = palette.success,
	      success = _palette$success === void 0 ? {
	    light: _green.default[300],
	    main: _green.default[500],
	    dark: _green.default[700]
	  } : _palette$success,
	      _palette$type = palette.type,
	      type = _palette$type === void 0 ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
	  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	
	  function getContrastText(background) {
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	
	      if (contrast < 3) {
	        console.error(["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
	      }
	    }
	
	    return contrastText;
	  }
	
	  var augmentColor = function augmentColor(color) {
	    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
	    color = (0, _extends2.default)({}, color);
	
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	
	    if (!color.main) {
	      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
	    }
	
	    if (typeof color.main !== 'string') {
	      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead."), '', 'Did you intend to use one of the following approaches?', '', 'import { green } from "@material-ui/core/colors";', '', 'const theme1 = createMuiTheme({ palette: {', '  primary: green,', '} });', '', 'const theme2 = createMuiTheme({ palette: {', '  primary: { main: green[500] },', '} });'].join('\n'));
	    }
	
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	
	    return color;
	  };
	
	  var types = {
	    dark: dark,
	    light: light
	  };
	
	  if (false) {
	    if (!types[type]) {
	      console.error("Material-UI: the palette type `".concat(type, "` is not supported."));
	    }
	  }
	
	  var paletteOutput = (0, _utils.deepmerge)((0, _extends2.default)({
	    // A collection of common colors.
	    common: _common.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: augmentColor(primary),
	    // The colors used to represent secondary interface elements for a user.
	    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: augmentColor(error),
	    // The colors used to represent potentially dangerous actions or important messages.
	    warning: augmentColor(warning),
	    // The colors used to present information to the user that is neutral and not necessarily important.
	    info: augmentColor(info),
	    // The colors used to indicate the successful completion of an action that user triggered.
	    success: augmentColor(success),
	    // The grey colors.
	    grey: _grey.default,
	    // Used by `getContrastText()` to maximize the contrast between
	    // the background and the text.
	    contrastThreshold: contrastThreshold,
	    // Takes a background color and returns the text color that maximizes the contrast.
	    getContrastText: getContrastText,
	    // Generate a rich color object.
	    augmentColor: augmentColor,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other);
	  return paletteOutput;
	}

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSpacing;
	
	var _system = __webpack_require__(376);
	
	var warnOnce;
	
	function createSpacing() {
	  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
	
	  // Already transformed.
	  if (spacingInput.mui) {
	    return spacingInput;
	  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
	  // Smaller components, such as icons and type, can align to a 4dp grid.
	  // https://material.io/design/layout/understanding-layout.html#usage
	
	
	  var transform = (0, _system.createUnarySpacing)({
	    spacing: spacingInput
	  });
	
	  var spacing = function spacing() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (false) {
	      if (!(args.length <= 4)) {
	        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
	      }
	    }
	
	    if (args.length === 0) {
	      return transform(1);
	    }
	
	    if (args.length === 1) {
	      return transform(args[0]);
	    }
	
	    return args.map(function (argument) {
	      if (typeof argument === 'string') {
	        return argument;
	      }
	
	      var output = transform(argument);
	      return typeof output === 'number' ? "".concat(output, "px") : output;
	    }).join(' ');
	  }; // Backward compatibility, to remove in v5.
	
	
	  Object.defineProperty(spacing, 'unit', {
	    get: function get() {
	      if (false) {
	        if (!warnOnce || process.env.NODE_ENV === 'test') {
	          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
	        }
	
	        warnOnce = true;
	      }
	
	      return spacingInput;
	    }
	  });
	  spacing.mui = true;
	  return spacing;
	}

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	var _styles = __webpack_require__(52);
	
	// let warnOnce = false;
	// To remove in v5
	function createStyles(styles) {
	  // warning(
	  //   warnOnce,
	  //   [
	  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
	  //     'Please use @material-ui/styles/createStyles',
	  //   ].join('\n'),
	  // );
	  // warnOnce = true;
	  return (0, _styles.createStyles)(styles);
	}

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTypography;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(21);
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	var caseAllCaps = {
	  textTransform: 'uppercase'
	};
	var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
	/**
	 * @see @link{https://material.io/design/typography/the-type-system.html}
	 * @see @link{https://material.io/design/typography/understanding-typography.html}
	 */
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
	      _ref$fontWeightBold = _ref.fontWeightBold,
	      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
	      allVariants = _ref.allVariants,
	      pxToRem2 = _ref.pxToRem,
	      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
	
	  if (false) {
	    if (typeof fontSize !== 'number') {
	      console.error('Material-UI: `fontSize` is required to be a number.');
	    }
	
	    if (typeof htmlFontSize !== 'number') {
	      console.error('Material-UI: `htmlFontSize` is required to be a number.');
	    }
	  }
	
	  var coef = fontSize / 14;
	
	  var pxToRem = pxToRem2 || function (size) {
	    return "".concat(size / htmlFontSize * coef, "rem");
	  };
	
	  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
	    return (0, _extends2.default)({
	      fontFamily: fontFamily,
	      fontWeight: fontWeight,
	      fontSize: pxToRem(size),
	      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
	      lineHeight: lineHeight
	    }, fontFamily === defaultFontFamily ? {
	      letterSpacing: "".concat(round(letterSpacing / size), "em")
	    } : {}, {}, casing, {}, allVariants);
	  };
	
	  var variants = {
	    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
	    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
	    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
	    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
	    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
	    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
	    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
	    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
	    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
	    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
	    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
	    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
	    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
	  };
	  return (0, _utils.deepmerge)((0, _extends2.default)({
	    htmlFontSize: htmlFontSize,
	    pxToRem: pxToRem,
	    round: round,
	    // TODO v5: remove
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    fontWeightBold: fontWeightBold
	  }, variants), other, {
	    clone: false // No need to clone deep
	
	  });
	}

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isUnitless = isUnitless;
	exports.getUnit = getUnit;
	exports.toUnitless = toUnitless;
	exports.convertLength = convertLength;
	exports.alignProperty = alignProperty;
	exports.fontGrid = fontGrid;
	exports.responsiveProperty = responsiveProperty;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	function isUnitless(value) {
	  return String(parseFloat(value)).length === String(value).length;
	} // Ported from Compass
	// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
	// Emulate the sass function "unit"
	
	
	function getUnit(input) {
	  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
	} // Emulate the sass function "unitless"
	
	
	function toUnitless(length) {
	  return parseFloat(length);
	} // Convert any CSS <length> or <percentage> value to any another.
	// From https://github.com/KyleAMathews/convert-css-length
	
	
	function convertLength(baseFontSize) {
	  return function (length, toUnit) {
	    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.
	
	    if (fromUnit === toUnit) {
	      return length;
	    } // Convert input length to pixels.
	
	
	    var pxLength = toUnitless(length);
	
	    if (fromUnit !== 'px') {
	      if (fromUnit === 'em') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	      } else if (fromUnit === 'rem') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	        return length;
	      }
	    } // Convert length in pixels to the output unit
	
	
	    var outputLength = pxLength;
	
	    if (toUnit !== 'px') {
	      if (toUnit === 'em') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else if (toUnit === 'rem') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else {
	        return length;
	      }
	    }
	
	    return parseFloat(outputLength.toFixed(5)) + toUnit;
	  };
	}
	
	function alignProperty(_ref) {
	  var size = _ref.size,
	      grid = _ref.grid;
	  var sizeBelow = size - size % grid;
	  var sizeAbove = sizeBelow + grid;
	  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
	} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
	// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
	// without changing the relative line height
	
	
	function fontGrid(_ref2) {
	  var lineHeight = _ref2.lineHeight,
	      pixels = _ref2.pixels,
	      htmlFontSize = _ref2.htmlFontSize;
	  return pixels / (lineHeight * htmlFontSize);
	}
	/**
	 * generate a responsive version of a given CSS property
	 * @example
	 * responsiveProperty({
	 *   cssProperty: 'fontSize',
	 *   min: 15,
	 *   max: 20,
	 *   unit: 'px',
	 *   breakpoints: [300, 600],
	 * })
	 *
	 * // this returns
	 *
	 * {
	 *   fontSize: '15px',
	 *   '@media (min-width:300px)': {
	 *     fontSize: '17.5px',
	 *   },
	 *   '@media (min-width:600px)': {
	 *     fontSize: '20px',
	 *   },
	 * }
	 *
	 * @param {Object} params
	 * @param {string} params.cssProperty - The CSS property to be made responsive
	 * @param {number} params.min - The smallest value of the CSS property
	 * @param {number} params.max - The largest value of the CSS property
	 * @param {string} [params.unit] - The unit to be used for the CSS property
	 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
	 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
	 * @returns {Object} responsive styles for {params.cssProperty}
	 */
	
	
	function responsiveProperty(_ref3) {
	  var cssProperty = _ref3.cssProperty,
	      min = _ref3.min,
	      max = _ref3.max,
	      _ref3$unit = _ref3.unit,
	      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
	      _ref3$breakpoints = _ref3.breakpoints,
	      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
	      _ref3$transform = _ref3.transform,
	      transform = _ref3$transform === void 0 ? null : _ref3$transform;
	  var output = (0, _defineProperty2.default)({}, cssProperty, "".concat(min).concat(unit));
	  var factor = (max - min) / breakpoints[breakpoints.length - 1];
	  breakpoints.forEach(function (breakpoint) {
	    var value = min + factor * breakpoint;
	
	    if (transform !== null) {
	      value = transform(value);
	    }
	
	    output["@media (min-width:".concat(breakpoint, "px)")] = (0, _defineProperty2.default)({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
	  });
	  return output;
	}

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(52);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(137));
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (0, _styles.makeStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = responsiveFontSizes;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _cssUtils = __webpack_require__(925);
	
	function responsiveFontSizes(themeInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
	      _options$disableAlign = options.disableAlign,
	      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
	      _options$factor = options.factor,
	      factor = _options$factor === void 0 ? 2 : _options$factor,
	      _options$variants = options.variants,
	      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;
	  var theme = (0, _extends2.default)({}, themeInput);
	  theme.typography = (0, _extends2.default)({}, theme.typography);
	  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
	  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
	
	  var convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
	  var breakpointValues = breakpoints.map(function (x) {
	    return theme.breakpoints.values[x];
	  });
	  variants.forEach(function (variant) {
	    var style = typography[variant];
	    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));
	
	    if (remFontSize <= 1) {
	      return;
	    }
	
	    var maxFontSize = remFontSize;
	    var minFontSize = 1 + (maxFontSize - 1) / factor;
	    var lineHeight = style.lineHeight;
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) {
	      throw new Error(["Material-UI: unsupported non-unitless line height with grid alignment.", 'Use unitless line heights instead.'].join('\n'));
	    }
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight)) {
	      // make it unitless
	      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
	    }
	
	    var transform = null;
	
	    if (!disableAlign) {
	      transform = function transform(value) {
	        return (0, _cssUtils.alignProperty)({
	          size: value,
	          grid: (0, _cssUtils.fontGrid)({
	            pixels: 4,
	            lineHeight: lineHeight,
	            htmlFontSize: typography.htmlFontSize
	          })
	        });
	      };
	    }
	
	    typography[variant] = (0, _extends2.default)({}, style, {}, (0, _cssUtils.responsiveProperty)({
	      cssProperty: 'fontSize',
	      min: minFontSize,
	      max: maxFontSize,
	      unit: 'rem',
	      breakpoints: breakpointValues,
	      transform: transform
	    }));
	  });
	  return theme;
	}

/***/ },
/* 928 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
	} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
	
	
	var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	var _default = shadows;
	exports.default = _default;

/***/ },
/* 929 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shape = {
	  borderRadius: 4
	};
	var _default = shape;
	exports.default = _default;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _styles = __webpack_require__(52);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(137));
	
	var withTheme = (0, _styles.withThemeCreator)({
	  defaultTheme: _defaultTheme.default
	});
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useMediaQuery;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _styles = __webpack_require__(52);
	
	function useMediaQuery(queryInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    theme: theme,
	    name: 'MuiUseMediaQuery',
	    props: {}
	  });
	
	  if (false) {
	    if (typeof queryInput === 'function' && theme === null) {
	      console.error(['Material-UI: the `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	    }
	  }
	
	  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
	  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
	  // All the browsers Material-UI support have this built-in.
	  // This defensive check is here for simplicity.
	  // Most of the time, the match media logic isn't central to people tests.
	
	  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
	
	  var _props$options = (0, _extends2.default)({}, props, {}, options),
	      _props$options$defaul = _props$options.defaultMatches,
	      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
	      _props$options$matchM = _props$options.matchMedia,
	      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
	      _props$options$noSsr = _props$options.noSsr,
	      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
	      _props$options$ssrMat = _props$options.ssrMatchMedia,
	      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
	
	  var _React$useState = React.useState(function () {
	    if (noSsr && supportMatchMedia) {
	      return matchMedia(query).matches;
	    }
	
	    if (ssrMatchMedia) {
	      return ssrMatchMedia(query).matches;
	    } // Once the component is mounted, we rely on the
	    // event listeners to return the correct matches value.
	
	
	    return defaultMatches;
	  }),
	      match = _React$useState[0],
	      setMatch = _React$useState[1];
	
	  React.useEffect(function () {
	    var active = true;
	
	    if (!supportMatchMedia) {
	      return undefined;
	    }
	
	    var queryList = matchMedia(query);
	
	    var updateMatch = function updateMatch() {
	      // Workaround Safari wrong implementation of matchMedia
	      // TODO can we remove it?
	      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
	      if (active) {
	        setMatch(queryList.matches);
	      }
	    };
	
	    updateMatch();
	    queryList.addListener(updateMatch);
	    return function () {
	      active = false;
	      queryList.removeListener(updateMatch);
	    };
	  }, [query, matchMedia, supportMatchMedia]);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue({
	      query: query,
	      match: match
	    });
	  }
	
	  return match;
	}

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	
	var _useScrollTrigger = _interopRequireDefault(__webpack_require__(933));

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useScrollTrigger;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function defaultTrigger(store, options) {
	  var _options$disableHyste = options.disableHysteresis,
	      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
	      _options$threshold = options.threshold,
	      threshold = _options$threshold === void 0 ? 100 : _options$threshold,
	      target = options.target;
	  var previous = store.current;
	
	  if (target) {
	    // Get vertical scroll
	    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
	  }
	
	  if (!disableHysteresis && previous !== undefined) {
	    if (store.current < previous) {
	      return false;
	    }
	  }
	
	  return store.current > threshold;
	}
	
	var defaultTarget = typeof window !== 'undefined' ? window : null;
	
	function useScrollTrigger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$getTrigger = options.getTrigger,
	      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
	      _options$target = options.target,
	      target = _options$target === void 0 ? defaultTarget : _options$target,
	      other = (0, _objectWithoutProperties2.default)(options, ["getTrigger", "target"]);
	  var store = React.useRef();
	
	  var _React$useState = React.useState(function () {
	    return getTrigger(store, other);
	  }),
	      trigger = _React$useState[0],
	      setTrigger = _React$useState[1];
	
	  React.useEffect(function () {
	    var handleScroll = function handleScroll() {
	      setTrigger(getTrigger(store, (0, _extends2.default)({
	        target: target
	      }, other)));
	    };
	
	    handleScroll(); // Re-evaluate trigger when dependencies change
	
	    target.addEventListener('scroll', handleScroll);
	    return function () {
	      target.removeEventListener('scroll', handleScroll);
	    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [target, getTrigger, JSON.stringify(other)]);
	  return trigger;
	}

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecatedPropType;
	
	function deprecatedPropType(validator, reason) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function (props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (typeof props[propName] !== 'undefined') {
	      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
	    }
	
	    return null;
	  };
	}

/***/ },
/* 935 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectScrollType = detectScrollType;
	exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
	// Source from https://github.com/alitaheri/normalize-scroll-left
	var cachedType;
	/**
	 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
	 *
	 * Types of scrollLeft, assiming scrollWidth=100 and direction is rtl.
	 *
	 * Browser        | Type          | <- Most Left | Most Right -> | Initial
	 * -------------- | ------------- | ------------ | ------------- | -------
	 * WebKit         | default       | 0            | 100           | 100
	 * Firefox/Opera  | negative      | -100         | 0             | 0
	 * IE/Edge        | reverse       | 100          | 0             | 0
	 */
	
	function detectScrollType() {
	  if (cachedType) {
	    return cachedType;
	  }
	
	  var dummy = document.createElement('div');
	  dummy.appendChild(document.createTextNode('ABCD'));
	  dummy.dir = 'rtl';
	  dummy.style.fontSize = '14px';
	  dummy.style.width = '4px';
	  dummy.style.height = '1px';
	  dummy.style.position = 'absolute';
	  dummy.style.top = '-1000px';
	  dummy.style.overflow = 'scroll';
	  document.body.appendChild(dummy);
	  cachedType = 'reverse';
	
	  if (dummy.scrollLeft > 0) {
	    cachedType = 'default';
	  } else {
	    dummy.scrollLeft = 1;
	
	    if (dummy.scrollLeft === 0) {
	      cachedType = 'negative';
	    }
	  }
	
	  document.body.removeChild(dummy);
	  return cachedType;
	} // Based on https://stackoverflow.com/a/24394376
	
	
	function getNormalizedScrollLeft(element, direction) {
	  var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	
	  if (direction !== 'rtl') {
	    return scrollLeft;
	  }
	
	  var type = detectScrollType();
	
	  switch (type) {
	    case 'negative':
	      return element.scrollWidth - element.clientWidth + scrollLeft;
	
	    case 'reverse':
	      return element.scrollWidth - element.clientWidth - scrollLeft;
	
	    default:
	      return scrollLeft;
	  }
	}

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	
	var _withMobileDialog = _interopRequireDefault(__webpack_require__(937));

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(239));
	
	/**
	 * Dialog will responsively be full screen *at or below* the given breakpoint
	 * (defaults to 'sm' for mobile devices).
	 * Notice that this Higher-order Component is incompatible with server-side rendering.
	 */
	var withMobileDialog = function withMobileDialog() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$breakpoint = options.breakpoint,
	        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;
	
	    function WithMobileDialog(props) {
	      return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
	      }, props));
	    }
	
	     false ? WithMobileDialog.propTypes = {
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
	    } : void 0;
	    return (0, _withWidth.default)()(WithMobileDialog);
	  };
	};
	
	var _default = withMobileDialog;
	exports.default = _default;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.isWidthDown = exports.isWidthUp = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(21);
	
	var _styles = __webpack_require__(52);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(82));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(39));
	
	var _createBreakpoints = __webpack_require__(353);
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(356));
	
	// By default, returns true if screen width is the same or greater than the given breakpoint.
	var isWidthUp = function isWidthUp(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
	  }
	
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
	}; // By default, returns true if screen width is the same or less than the given breakpoint.
	
	
	exports.isWidthUp = isWidthUp;
	
	var isWidthDown = function isWidthDown(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	
	  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	exports.isWidthDown = isWidthDown;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	
	var withWidth = function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$withTheme = options.withTheme,
	        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
	        _options$noSSR = options.noSSR,
	        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
	        initialWidthOption = options.initialWidth;
	
	    function WithWidth(props) {
	      var contextTheme = (0, _useTheme.default)();
	      var theme = props.theme || contextTheme;
	
	      var _getThemeProps = (0, _styles.getThemeProps)({
	        theme: theme,
	        name: 'MuiWithWidth',
	        props: (0, _extends2.default)({}, props)
	      }),
	          initialWidth = _getThemeProps.initialWidth,
	          width = _getThemeProps.width,
	          other = (0, _objectWithoutProperties2.default)(_getThemeProps, ["initialWidth", "width"]);
	
	      var _React$useState = React.useState(false),
	          mountedState = _React$useState[0],
	          setMountedState = _React$useState[1];
	
	      useEnhancedEffect(function () {
	        setMountedState(true);
	      }, []);
	      /**
	       * innerWidth |xs      sm      md      lg      xl
	       *            |-------|-------|-------|-------|------>
	       * width      |  xs   |  sm   |  md   |  lg   |  xl
	       */
	
	      var keys = (0, _toConsumableArray2.default)(theme.breakpoints.keys).reverse();
	      var widthComputed = keys.reduce(function (output, key) {
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        var matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
	        return !output && matches ? key : output;
	      }, null);
	      var more = (0, _extends2.default)({
	        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
	      }, withThemeOption ? {
	        theme: theme
	      } : {}, {}, other); // When rendering the component on the server,
	      // we have no idea about the client browser screen width.
	      // In order to prevent blinks and help the reconciliation of the React tree
	      // we are not rendering the child component.
	      //
	      // An alternative is to use the `initialWidth` property.
	
	      if (more.width === undefined) {
	        return null;
	      }
	
	      return /*#__PURE__*/React.createElement(Component, more);
	    }
	
	     false ? WithWidth.propTypes = {
	      /**
	       * As `window.innerWidth` is unavailable on the server,
	       * we default to rendering an empty component during the first mount.
	       * You might want to use an heuristic to approximate
	       * the screen width of the client browser screen width.
	       *
	       * For instance, you could be using the user-agent or the client-hints.
	       * https://caniuse.com/#search=client%20hint
	       */
	      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	      /**
	       * @ignore
	       */
	      theme: _propTypes.default.object,
	
	      /**
	       * Bypass the width calculation logic.
	       */
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
	    } : void 0;
	
	    if (false) {
	      WithWidth.displayName = "WithWidth(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithWidth, Component);
	    return WithWidth;
	  };
	};
	
	var _default = withWidth;
	exports.default = _default;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
	}), 'AccountCircle');
	
	exports.default = _default;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
	}), 'Apps');
	
	exports.default = _default;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownward');
	
	exports.default = _default;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
	}), 'ArrowUpward');
	
	exports.default = _default;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
	}), 'Autorenew');
	
	exports.default = _default;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'Cancel');
	
	exports.default = _default;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckCircle');
	
	exports.default = _default;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
	}), 'ChevronLeft');
	
	exports.default = _default;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
	}), 'ChevronRight');
	
	exports.default = _default;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
	}), 'Cloud');
	
	exports.default = _default;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "8"
	}), 'FiberManualRecord');
	
	exports.default = _default;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
	}), 'Group');
	
	exports.default = _default;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
	}), 'InsertDriveFile');
	
	exports.default = _default;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
	}), 'KeyboardArrowLeft');
	
	exports.default = _default;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
	}), 'KeyboardArrowRight');
	
	exports.default = _default;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
	}), 'Layers');
	
	exports.default = _default;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
	}), 'Notifications');
	
	exports.default = _default;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.92 13.5l-2.2-2.2c-.9.58-2.03.84-3.22.62-1.88-.35-3.38-1.93-3.62-3.83-.38-3.01 2.18-5.52 5.21-5.04 1.88.3 3.39 1.84 3.7 3.71.19 1.16-.08 2.23-.64 3.12l2.2 2.19c.39.39.39 1.03 0 1.42-.4.4-1.04.4-1.43.01z"
	}), 'PageviewRounded');
	
	exports.default = _default;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 5c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1zm2.41 9H9v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-5h1.59c.89 0 1.34-1.08.71-1.71L12.71 7.7a.9959.9959 0 00-1.41 0l-4.59 4.59c-.63.63-.19 1.71.7 1.71z"
	}), 'PublishRounded');
	
	exports.default = _default;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(1.2, 1.2)",
	  d: "M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
	}), 'Settings');
	
	exports.default = _default;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 8v8H8V8h8m2-2H6v12h12V6z"
	}), 'StopOutlined');
	
	exports.default = _default;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 6h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2z"
	}), 'StopRounded');
	
	exports.default = _default;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(142));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _styles = __webpack_require__(30);
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var _SuccessOutlined = _interopRequireDefault(__webpack_require__(977));
	
	var _ReportProblemOutlined = _interopRequireDefault(__webpack_require__(976));
	
	var _ErrorOutline = _interopRequireDefault(__webpack_require__(970));
	
	var _InfoOutlined = _interopRequireDefault(__webpack_require__(972));
	
	var _Close = _interopRequireDefault(__webpack_require__(366));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(40));
	
	var _utils = __webpack_require__(34);
	
	var styles = function styles(theme) {
	  var getColor = theme.palette.type === 'light' ? _styles.darken : _styles.lighten;
	  var getBackgroundColor = theme.palette.type === 'light' ? _styles.lighten : _styles.darken;
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body2, {
	      borderRadius: theme.shape.borderRadius,
	      backgroundColor: 'transparent',
	      display: 'flex',
	      padding: '6px 16px'
	    }),
	
	    /* Styles applied to the root element if `variant="standard"` and `color="success"`. */
	    standardSuccess: {
	      color: getColor(theme.palette.success.main, 0.6),
	      backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
	      '& $icon': {
	        color: theme.palette.success.main
	      }
	    },
	
	    /* Styles applied to the root element if `variant="standard"` and `color="info"`. */
	    standardInfo: {
	      color: getColor(theme.palette.info.main, 0.6),
	      backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
	      '& $icon': {
	        color: theme.palette.info.main
	      }
	    },
	
	    /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */
	    standardWarning: {
	      color: getColor(theme.palette.warning.main, 0.6),
	      backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
	      '& $icon': {
	        color: theme.palette.warning.main
	      }
	    },
	
	    /* Styles applied to the root element if `variant="standard"` and `color="error"`. */
	    standardError: {
	      color: getColor(theme.palette.error.main, 0.6),
	      backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
	      '& $icon': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */
	    outlinedSuccess: {
	      color: getColor(theme.palette.success.main, 0.6),
	      border: "1px solid ".concat(theme.palette.success.main),
	      '& $icon': {
	        color: theme.palette.success.main
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */
	    outlinedInfo: {
	      color: getColor(theme.palette.info.main, 0.6),
	      border: "1px solid ".concat(theme.palette.info.main),
	      '& $icon': {
	        color: theme.palette.info.main
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
	    outlinedWarning: {
	      color: getColor(theme.palette.warning.main, 0.6),
	      border: "1px solid ".concat(theme.palette.warning.main),
	      '& $icon': {
	        color: theme.palette.warning.main
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */
	    outlinedError: {
	      color: getColor(theme.palette.error.main, 0.6),
	      border: "1px solid ".concat(theme.palette.error.main),
	      '& $icon': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Styles applied to the root element if `variant="filled"` and `color="success"`. */
	    filledSuccess: {
	      color: '#fff',
	      fontWeight: theme.typography.fontWeightMedium,
	      backgroundColor: theme.palette.success.main
	    },
	
	    /* Styles applied to the root element if `variant="filled"` and `color="info"`. */
	    filledInfo: {
	      color: '#fff',
	      fontWeight: theme.typography.fontWeightMedium,
	      backgroundColor: theme.palette.info.main
	    },
	
	    /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */
	    filledWarning: {
	      color: '#fff',
	      fontWeight: theme.typography.fontWeightMedium,
	      backgroundColor: theme.palette.warning.main
	    },
	
	    /* Styles applied to the root element if `variant="filled"` and `color="error"`. */
	    filledError: {
	      color: '#fff',
	      fontWeight: theme.typography.fontWeightMedium,
	      backgroundColor: theme.palette.error.main
	    },
	
	    /* Styles applied to the icon wrapper element. */
	    icon: {
	      marginRight: 12,
	      padding: '7px 0',
	      display: 'flex',
	      fontSize: 22,
	      opacity: 0.9
	    },
	
	    /* Styles applied to the message wrapper element. */
	    message: {
	      padding: '8px 0'
	    },
	
	    /* Styles applied to the action wrapper element if `action` is provided. */
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: 16,
	      marginRight: -8
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultIconMapping = {
	  success: /*#__PURE__*/React.createElement(_SuccessOutlined.default, {
	    fontSize: "inherit"
	  }),
	  warning: /*#__PURE__*/React.createElement(_ReportProblemOutlined.default, {
	    fontSize: "inherit"
	  }),
	  error: /*#__PURE__*/React.createElement(_ErrorOutline.default, {
	    fontSize: "inherit"
	  }),
	  info: /*#__PURE__*/React.createElement(_InfoOutlined.default, {
	    fontSize: "inherit"
	  })
	};
	
	var _ref = /*#__PURE__*/React.createElement(_Close.default, {
	  fontSize: "small"
	});
	
	var Alert = React.forwardRef(function Alert(props, ref) {
	  var action = props.action,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$closeText = props.closeText,
	      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
	      color = props.color,
	      icon = props.icon,
	      _props$iconMapping = props.iconMapping,
	      iconMapping = _props$iconMapping === void 0 ? defaultIconMapping : _props$iconMapping,
	      onClose = props.onClose,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'alert' : _props$role,
	      _props$severity = props.severity,
	      severity = _props$severity === void 0 ? 'success' : _props$severity,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "children", "classes", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    role: role,
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes["".concat(variant).concat((0, _utils.capitalize)(color || severity))], className),
	    ref: ref
	  }, other), icon !== false ? /*#__PURE__*/React.createElement("div", {
	    className: classes.icon
	  }, icon || iconMapping[severity] || defaultIconMapping[severity]) : null, /*#__PURE__*/React.createElement("div", {
	    className: classes.message
	  }, children), action != null ? /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action) : null, action == null && onClose ? /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, /*#__PURE__*/React.createElement(_IconButton.default, {
	    size: "small",
	    "aria-label": closeText,
	    title: closeText,
	    color: "inherit",
	    onClick: onClose
	  }, _ref)) : null);
	});
	 false ? Alert.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the alert.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Override the default label for the *close popup* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  closeText: _propTypes.default.string,
	
	  /**
	   * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
	   */
	  color: _propTypes.default.oneOf(['error', 'info', 'success', 'warning']),
	
	  /**
	   * Override the icon displayed before the children.
	   * Unless provided, the icon is mapped to the value of the `severity` prop.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The component maps the `severity` prop to a range of different icons,
	   * for instance success to `<SuccessOutlined>`.
	   * If you wish to change this mapping, you can provide your own.
	   * Alternatively, you can use the `icon` prop to override the icon displayed.
	   */
	  iconMapping: _propTypes.default.shape({
	    error: _propTypes.default.node,
	    info: _propTypes.default.node,
	    success: _propTypes.default.node,
	    warning: _propTypes.default.node
	  }),
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * The ARIA role attribute of the element.
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * The severity of the alert. This defines the color and icon used.
	   */
	  severity: _propTypes.default.oneOf(['error', 'info', 'success', 'warning']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiAlert'
	})(Alert);
	
	exports.default = _default;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Alert.default;
	  }
	});
	
	var _Alert = _interopRequireDefault(__webpack_require__(961));

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete2.createFilterOptions;
	  }
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(142));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _styles = __webpack_require__(30);
	
	var _Popper = _interopRequireDefault(__webpack_require__(135));
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(323));
	
	var _Paper = _interopRequireDefault(__webpack_require__(38));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(40));
	
	var _Chip = _interopRequireDefault(__webpack_require__(157));
	
	var _Close = _interopRequireDefault(__webpack_require__(366));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(969));
	
	var _useAutocomplete2 = _interopRequireWildcard(__webpack_require__(980));
	
	var styles = function styles(theme) {
	  var _option;
	
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      '&:hover $clearIndicatorDirty, &$focused $clearIndicatorDirty': {
	        visibility: 'visible'
	      }
	    },
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Pseudo-class applied to the root element if focused. */
	    focused: {},
	
	    /* Styles applied to the tag elements, e.g. the chips. */
	    tag: {
	      margin: 3,
	      maxWidth: 'calc(100% - 6px)'
	    },
	
	    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
	    tagSizeSmall: {
	      margin: 2,
	      maxWidth: 'calc(100% - 4px)'
	    },
	
	    /* Styles applied when the popup icon is rendered. */
	    hasPopupIcon: {},
	
	    /* Styles applied when the clear icon is rendered. */
	    hasClearIcon: {},
	
	    /* Styles applied to the Input element. */
	    inputRoot: {
	      flexWrap: 'wrap',
	      '$hasPopupIcon &, $hasClearIcon &': {
	        paddingRight: 26 + 4
	      },
	      '$hasPopupIcon$hasClearIcon &': {
	        paddingRight: 52 + 4
	      },
	      '& $input': {
	        width: 0,
	        minWidth: 30
	      },
	      '&[class*="MuiInput-root"]': {
	        paddingBottom: 1,
	        '& $input': {
	          padding: 4
	        },
	        '& $input:first-child': {
	          padding: '6px 0'
	        }
	      },
	      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
	        '& $input': {
	          padding: '4px 4px 5px'
	        },
	        '& $input:first-child': {
	          padding: '3px 0 6px'
	        }
	      },
	      '&[class*="MuiOutlinedInput-root"]': {
	        padding: 9,
	        '$hasPopupIcon &, $hasClearIcon &': {
	          paddingRight: 26 + 4 + 9
	        },
	        '$hasPopupIcon$hasClearIcon &': {
	          paddingRight: 52 + 4 + 9
	        },
	        '& $input': {
	          padding: '9.5px 4px'
	        },
	        '& $input:first-child': {
	          paddingLeft: 6
	        },
	        '& $endAdornment': {
	          right: 9
	        }
	      },
	      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
	        padding: 6,
	        '& $input': {
	          padding: '4.5px 4px'
	        }
	      },
	      '&[class*="MuiFilledInput-root"]': {
	        paddingTop: 19,
	        paddingLeft: 8,
	        '$hasPopupIcon &, $hasClearIcon &': {
	          paddingRight: 26 + 4 + 9
	        },
	        '$hasPopupIcon$hasClearIcon &': {
	          paddingRight: 52 + 4 + 9
	        },
	        '& $input': {
	          padding: '9px 4px'
	        },
	        '& $endAdornment': {
	          right: 9
	        }
	      },
	      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
	        paddingBottom: 1,
	        '& $input': {
	          padding: '4.5px 4px'
	        }
	      }
	    },
	
	    /* Styles applied to the input element. */
	    input: {
	      flexGrow: 1,
	      textOverflow: 'ellipsis',
	      opacity: 0
	    },
	
	    /* Styles applied to the input element if tag focused. */
	    inputFocused: {
	      opacity: 1
	    },
	
	    /* Styles applied to the endAdornment element. */
	    endAdornment: {
	      // We use a position absolute to support wrapping tags.
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 14px)' // Center vertically
	
	    },
	
	    /* Styles applied to the clear indicator. */
	    clearIndicator: {
	      marginRight: -2,
	      padding: 4,
	      visibility: 'hidden'
	    },
	
	    /* Styles applied to the clear indicator if the input is dirty. */
	    clearIndicatorDirty: {},
	
	    /* Styles applied to the popup indicator. */
	    popupIndicator: {
	      padding: 2,
	      marginRight: -2
	    },
	
	    /* Styles applied to the popup indicator if the popup is open. */
	    popupIndicatorOpen: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the popper element. */
	    popper: {
	      zIndex: theme.zIndex.modal
	    },
	
	    /* Styles applied to the popper element if `disablePortal={true}`. */
	    popperDisablePortal: {
	      position: 'absolute'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: (0, _extends2.default)({}, theme.typography.body1, {
	      overflow: 'hidden',
	      margin: '4px 0'
	    }),
	
	    /* Styles applied to the `listbox` component. */
	    listbox: {
	      listStyle: 'none',
	      margin: 0,
	      padding: '8px 0px',
	      maxHeight: '40vh',
	      overflow: 'auto'
	    },
	
	    /* Styles applied to the loading wrapper. */
	    loading: {
	      color: theme.palette.text.secondary,
	      padding: '14px 16px'
	    },
	
	    /* Styles applied to the no option wrapper. */
	    noOptions: {
	      color: theme.palette.text.secondary,
	      padding: '14px 16px'
	    },
	
	    /* Styles applied to the option elements. */
	    option: (_option = {
	      minHeight: 48,
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      cursor: 'pointer',
	      paddingTop: 6,
	      boxSizing: 'border-box',
	      outline: '0',
	      WebkitTapHighlightColor: 'transparent',
	      paddingBottom: 6,
	      paddingLeft: 16,
	      paddingRight: 16
	    }, (0, _defineProperty2.default)(_option, theme.breakpoints.up('sm'), {
	      minHeight: 'auto'
	    }), (0, _defineProperty2.default)(_option, '&[aria-selected="true"]', {
	      backgroundColor: theme.palette.action.selected
	    }), (0, _defineProperty2.default)(_option, '&[data-focus="true"]', {
	      backgroundColor: theme.palette.action.hover
	    }), (0, _defineProperty2.default)(_option, '&:active', {
	      backgroundColor: theme.palette.action.selected
	    }), (0, _defineProperty2.default)(_option, '&[aria-disabled="true"]', {
	      opacity: theme.palette.action.disabledOpacity,
	      pointerEvents: 'none'
	    }), _option),
	
	    /* Styles applied to the group's label elements. */
	    groupLabel: {
	      backgroundColor: theme.palette.background.paper,
	      top: -8
	    },
	
	    /* Styles applied to the group's ul elements. */
	    groupUl: {
	      padding: 0,
	      '& $option': {
	        paddingLeft: 24
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function DisablePortal(props) {
	  // eslint-disable-next-line react/prop-types
	  var anchorEl = props.anchorEl,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "open"]);
	  return /*#__PURE__*/React.createElement("div", other);
	}
	
	var _ref = /*#__PURE__*/React.createElement(_Close.default, {
	  fontSize: "small"
	});
	
	var _ref2 = /*#__PURE__*/React.createElement(_ArrowDropDown.default, null);
	
	var Autocomplete = React.forwardRef(function Autocomplete(props, ref) {
	  /* eslint-disable no-unused-vars */
	  var _props$autoComplete = props.autoComplete,
	      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
	      _props$autoHighlight = props.autoHighlight,
	      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
	      _props$autoSelect = props.autoSelect,
	      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
	      _props$blurOnSelect = props.blurOnSelect,
	      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
	      ChipProps = props.ChipProps,
	      classes = props.classes,
	      className = props.className,
	      _props$clearOnBlur = props.clearOnBlur,
	      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
	      _props$clearOnEscape = props.clearOnEscape,
	      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
	      _props$clearText = props.clearText,
	      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
	      _props$closeIcon = props.closeIcon,
	      closeIcon = _props$closeIcon === void 0 ? _ref : _props$closeIcon,
	      _props$closeText = props.closeText,
	      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
	      _props$debug = props.debug,
	      debug = _props$debug === void 0 ? false : _props$debug,
	      _props$defaultValue = props.defaultValue,
	      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
	      _props$disableClearab = props.disableClearable,
	      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
	      _props$disableCloseOn = props.disableCloseOnSelect,
	      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      filterOptions = props.filterOptions,
	      _props$filterSelected = props.filterSelectedOptions,
	      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
	      _props$forcePopupIcon = props.forcePopupIcon,
	      forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
	      _props$freeSolo = props.freeSolo,
	      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$getLimitTagsTe = props.getLimitTagsText,
	      getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
	    return "+".concat(more);
	  } : _props$getLimitTagsTe,
	      getOptionDisabled = props.getOptionDisabled,
	      _props$getOptionLabel = props.getOptionLabel,
	      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
	    return x;
	  } : _props$getOptionLabel,
	      getOptionSelected = props.getOptionSelected,
	      groupBy = props.groupBy,
	      idProp = props.id,
	      _props$includeInputIn = props.includeInputInList,
	      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
	      inputValueProp = props.inputValue,
	      _props$limitTags = props.limitTags,
	      limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
	      _props$ListboxCompone = props.ListboxComponent,
	      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
	      ListboxProps = props.ListboxProps,
	      _props$loading = props.loading,
	      loading = _props$loading === void 0 ? false : _props$loading,
	      _props$loadingText = props.loadingText,
	      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$noOptionsText = props.noOptionsText,
	      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onHighlightChange = props.onHighlightChange,
	      onInputChange = props.onInputChange,
	      onOpen = props.onOpen,
	      open = props.open,
	      _props$openOnFocus = props.openOnFocus,
	      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
	      _props$openText = props.openText,
	      openText = _props$openText === void 0 ? 'Open' : _props$openText,
	      options = props.options,
	      _props$PaperComponent = props.PaperComponent,
	      PaperComponent = _props$PaperComponent === void 0 ? _Paper.default : _props$PaperComponent,
	      _props$PopperComponen = props.PopperComponent,
	      PopperComponentProp = _props$PopperComponen === void 0 ? _Popper.default : _props$PopperComponen,
	      _props$popupIcon = props.popupIcon,
	      popupIcon = _props$popupIcon === void 0 ? _ref2 : _props$popupIcon,
	      renderGroupProp = props.renderGroup,
	      renderInput = props.renderInput,
	      renderOptionProp = props.renderOption,
	      renderTags = props.renderTags,
	      _props$selectOnFocus = props.selectOnFocus,
	      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      valueProp = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnBlur", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"]);
	  /* eslint-enable no-unused-vars */
	
	  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;
	
	  var _useAutocomplete = (0, _useAutocomplete2.default)((0, _extends2.default)({}, props, {
	    componentName: 'Autocomplete'
	  })),
	      getRootProps = _useAutocomplete.getRootProps,
	      getInputProps = _useAutocomplete.getInputProps,
	      getInputLabelProps = _useAutocomplete.getInputLabelProps,
	      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
	      getClearProps = _useAutocomplete.getClearProps,
	      getTagProps = _useAutocomplete.getTagProps,
	      getListboxProps = _useAutocomplete.getListboxProps,
	      getOptionProps = _useAutocomplete.getOptionProps,
	      value = _useAutocomplete.value,
	      dirty = _useAutocomplete.dirty,
	      id = _useAutocomplete.id,
	      popupOpen = _useAutocomplete.popupOpen,
	      focused = _useAutocomplete.focused,
	      focusedTag = _useAutocomplete.focusedTag,
	      anchorEl = _useAutocomplete.anchorEl,
	      setAnchorEl = _useAutocomplete.setAnchorEl,
	      inputValue = _useAutocomplete.inputValue,
	      groupedOptions = _useAutocomplete.groupedOptions;
	
	  var startAdornment;
	
	  if (multiple && value.length > 0) {
	    var getCustomizedTagProps = function getCustomizedTagProps(params) {
	      return (0, _extends2.default)({
	        className: (0, _clsx.default)(classes.tag, size === 'small' && classes.tagSizeSmall),
	        disabled: disabled
	      }, getTagProps(params));
	    };
	
	    if (renderTags) {
	      startAdornment = renderTags(value, getCustomizedTagProps);
	    } else {
	      startAdornment = value.map(function (option, index) {
	        return /*#__PURE__*/React.createElement(_Chip.default, (0, _extends2.default)({
	          label: getOptionLabel(option),
	          size: size
	        }, getCustomizedTagProps({
	          index: index
	        }), ChipProps));
	      });
	    }
	  }
	
	  if (limitTags > -1 && Array.isArray(startAdornment)) {
	    var more = startAdornment.length - limitTags;
	
	    if (limitTags && !focused && more > 0) {
	      startAdornment = startAdornment.splice(0, limitTags);
	      startAdornment.push( /*#__PURE__*/React.createElement("span", {
	        className: classes.tag,
	        key: startAdornment.length
	      }, getLimitTagsText(more)));
	    }
	  }
	
	  var defaultRenderGroup = function defaultRenderGroup(params) {
	    return /*#__PURE__*/React.createElement("li", {
	      key: params.key
	    }, /*#__PURE__*/React.createElement(_ListSubheader.default, {
	      className: classes.groupLabel,
	      component: "div"
	    }, params.group), /*#__PURE__*/React.createElement("ul", {
	      className: classes.groupUl
	    }, params.children));
	  };
	
	  var renderGroup = renderGroupProp || defaultRenderGroup;
	  var renderOption = renderOptionProp || getOptionLabel;
	
	  var renderListOption = function renderListOption(option, index) {
	    var optionProps = getOptionProps({
	      option: option,
	      index: index
	    });
	    return /*#__PURE__*/React.createElement("li", (0, _extends2.default)({}, optionProps, {
	      className: classes.option
	    }), renderOption(option, {
	      selected: optionProps['aria-selected'],
	      inputValue: inputValue
	    }));
	  };
	
	  var hasClearIcon = !disableClearable && !disabled;
	  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
	  }, getRootProps(other)), renderInput({
	    id: id,
	    disabled: disabled,
	    fullWidth: true,
	    size: size === 'small' ? 'small' : undefined,
	    InputLabelProps: getInputLabelProps(),
	    InputProps: {
	      ref: setAnchorEl,
	      className: classes.inputRoot,
	      startAdornment: startAdornment,
	      endAdornment: /*#__PURE__*/React.createElement("div", {
	        className: classes.endAdornment
	      }, hasClearIcon ? /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({}, getClearProps(), {
	        "aria-label": clearText,
	        title: clearText,
	        className: (0, _clsx.default)(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
	      }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({}, getPopupIndicatorProps(), {
	        disabled: disabled,
	        "aria-label": popupOpen ? closeText : openText,
	        title: popupOpen ? closeText : openText,
	        className: (0, _clsx.default)(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
	      }), popupIcon) : null)
	    },
	    inputProps: (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.input, focusedTag === -1 && classes.inputFocused),
	      disabled: disabled
	    }, getInputProps())
	  })), popupOpen && anchorEl ? /*#__PURE__*/React.createElement(PopperComponent, {
	    className: (0, _clsx.default)(classes.popper, disablePortal && classes.popperDisablePortal),
	    style: {
	      width: anchorEl ? anchorEl.clientWidth : null
	    },
	    role: "presentation",
	    anchorEl: anchorEl,
	    open: true
	  }, /*#__PURE__*/React.createElement(PaperComponent, {
	    className: classes.paper
	  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React.createElement("div", {
	    className: classes.loading
	  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React.createElement("div", {
	    className: classes.noOptions
	  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React.createElement(ListboxComponent, (0, _extends2.default)({
	    className: classes.listbox
	  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
	    if (groupBy) {
	      return renderGroup({
	        key: option.key,
	        group: option.group,
	        children: option.options.map(function (option2, index2) {
	          return renderListOption(option2, option.index + index2);
	        })
	      });
	    }
	
	    return renderListOption(option, index);
	  })) : null)) : null);
	});
	 false ? Autocomplete.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the portion of the selected suggestion that has not been typed by the user,
	   * known as the completion string, appears inline after the input cursor in the textbox.
	   * The inline completion string is visually highlighted and has a selected state.
	   */
	  autoComplete: _propTypes.default.bool,
	
	  /**
	   * If `true`, the first option is automatically highlighted.
	   */
	  autoHighlight: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected option becomes the value of the input
	   * when the Autocomplete loses focus unless the user chooses
	   * a different option or changes the character string in the input.
	   */
	  autoSelect: _propTypes.default.bool,
	
	  /**
	   * Control if the input should be blurred when an option is selected:
	   *
	   * - `false` the input is not blurred.
	   * - `true` the input is always blurred.
	   * - `touch` the input is blurred after a touch event.
	   * - `mouse` the input is blurred after a mouse event.
	   */
	  blurOnSelect: _propTypes.default.oneOfType([_propTypes.default.oneOf(['mouse', 'touch']), _propTypes.default.bool]),
	
	  /**
	   * Props applied to the [`Chip`](/api/chip/) element.
	   */
	  ChipProps: _propTypes.default.object,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the input's text will be cleared on blur if no value is selected.
	   *
	   * Set to `true` if you want to help the user enter a new value.
	   * Set to `false` if you want to help the user resume his search.
	   */
	  clearOnBlur: _propTypes.default.bool,
	
	  /**
	   * If `true`, clear all values when the user presses escape and the popup is closed.
	   */
	  clearOnEscape: _propTypes.default.bool,
	
	  /**
	   * Override the default text for the *clear* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  clearText: _propTypes.default.string,
	
	  /**
	   * The icon to display in place of the default close icon.
	   */
	  closeIcon: _propTypes.default.node,
	
	  /**
	   * Override the default text for the *close popup* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  closeText: _propTypes.default.string,
	
	  /**
	   * If `true`, the popup will ignore the blur event if the input is filled.
	   * You can inspect the popup markup with your browser tools.
	   * Consider this option when you need to customize the component.
	   */
	  debug: _propTypes.default.bool,
	
	  /**
	   * The default input value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.any, _propTypes.default.array]),
	
	  /**
	   * If `true`, the input can't be cleared.
	   */
	  disableClearable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the popup won't close when a value is selected.
	   */
	  disableCloseOnSelect: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list box in the popup will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * A filter function that determines the options that are eligible.
	   *
	   * @param {T[]} options The options to render.
	   * @param {object} state The state of the component.
	   * @returns {T[]}
	   */
	  filterOptions: _propTypes.default.func,
	
	  /**
	   * If `true`, hide the selected options from the list box.
	   */
	  filterSelectedOptions: _propTypes.default.bool,
	
	  /**
	   * Force the visibility display of the popup icon.
	   */
	  forcePopupIcon: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.bool]),
	
	  /**
	   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
	   */
	  freeSolo: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The label to display when the tags are truncated (`limitTags`).
	   *
	   * @param {number} more The number of truncated tags.
	   * @returns {ReactNode}
	   */
	  getLimitTagsText: _propTypes.default.func,
	
	  /**
	   * Used to determine the disabled state for a given option.
	   *
	   * @param {T} option The option to test.
	   * @returns {boolean}
	   */
	  getOptionDisabled: _propTypes.default.func,
	
	  /**
	   * Used to determine the string value for a given option.
	   * It's used to fill the input (and the list box options if `renderOption` is not provided).
	   *
	   * @param {T} option
	   * @returns {string}
	   */
	  getOptionLabel: _propTypes.default.func,
	
	  /**
	   * Used to determine if an option is selected, considering the current value.
	   * Uses strict equality by default.
	   *
	   * @param {T} option The option to test.
	   * @param {T} value The value to test against.
	   * @returns {boolean}
	   */
	  getOptionSelected: _propTypes.default.func,
	
	  /**
	   * If provided, the options will be grouped under the returned string.
	   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
	   *
	   * @param {T} options The options to group.
	   * @returns {string}
	   */
	  groupBy: _propTypes.default.func,
	
	  /**
	   * This prop is used to help implement the accessibility logic.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the highlight can move to the input.
	   */
	  includeInputInList: _propTypes.default.bool,
	
	  /**
	   * The input value.
	   */
	  inputValue: _propTypes.default.string,
	
	  /**
	   * The maximum number of tags that will be visible when not focused.
	   * Set `-1` to disable the limit.
	   */
	  limitTags: _propTypes.default.number,
	
	  /**
	   * The component used to render the listbox.
	   */
	  ListboxComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the Listbox element.
	   */
	  ListboxProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the component is in a loading state.
	   */
	  loading: _propTypes.default.bool,
	
	  /**
	   * Text to display when in a loading state.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  loadingText: _propTypes.default.node,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Text to display when there are no options.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  noOptionsText: _propTypes.default.node,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {T} value The new value of the component.
	   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the popup requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the highlight option changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {T} option The highlighted option.
	   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
	   */
	  onHighlightChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the input value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} value The new value of the text input.
	   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
	   */
	  onInputChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the popup requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control the popup` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * If `true`, the popup will open on input focus.
	   */
	  openOnFocus: _propTypes.default.bool,
	
	  /**
	   * Override the default text for the *open popup* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  openText: _propTypes.default.string,
	
	  /**
	   * Array of options.
	   */
	  options: _propTypes.default.array.isRequired,
	
	  /**
	   * The component used to render the body of the popup.
	   */
	  PaperComponent: _propTypes.default.elementType,
	
	  /**
	   * The component used to position the popup.
	   */
	  PopperComponent: _propTypes.default.elementType,
	
	  /**
	   * The icon to display in place of the default popup icon.
	   */
	  popupIcon: _propTypes.default.node,
	
	  /**
	   * Render the group.
	   *
	   * @param {any} option The group to render.
	   * @returns {ReactNode}
	   */
	  renderGroup: _propTypes.default.func,
	
	  /**
	   * Render the input.
	   *
	   * @param {object} params
	   * @returns {ReactNode}
	   */
	  renderInput: _propTypes.default.func.isRequired,
	
	  /**
	   * Render the option, use `getOptionLabel` by default.
	   *
	   * @param {T} option The option to render.
	   * @param {object} state The state of the component.
	   * @returns {ReactNode}
	   */
	  renderOption: _propTypes.default.func,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {T[]} value The `value` provided to the component.
	   * @param {function} getTagProps A tag props getter.
	   * @returns {ReactNode}
	   */
	  renderTags: _propTypes.default.func,
	
	  /**
	   * If `true`, the input's text will be selected on focus.
	   * It helps the user clear the selected value.
	   */
	  selectOnFocus: _propTypes.default.bool,
	
	  /**
	   * The size of the autocomplete.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the autocomplete.
	   *
	   * The value must have reference equality with the option in order to be selected.
	   * You can customize the equality behavior with the `getOptionSelected` prop.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.any, _propTypes.default.array])
	} : void 0;
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiAutocomplete'
	})(Autocomplete);
	
	exports.default = _default;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(142));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _styles = __webpack_require__(30);
	
	var _usePagination2 = _interopRequireDefault(__webpack_require__(364));
	
	var _PaginationItem = _interopRequireDefault(__webpack_require__(967));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the ul element. */
	  ul: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    alignItems: 'center',
	    padding: 0,
	    margin: 0,
	    listStyle: 'none'
	  }
	};
	exports.styles = styles;
	
	function defaultGetAriaLabel(type, page, selected) {
	  if (type === 'page') {
	    return "".concat(selected ? '' : 'Go to ', "page ").concat(page);
	  }
	
	  return "Go to ".concat(type, " page");
	}
	
	var Pagination = React.forwardRef(function Pagination(props, ref) {
	  var boundaryCount = props.boundaryCount,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'standard' : _props$color,
	      count = props.count,
	      defaultPage = props.defaultPage,
	      disabled = props.disabled,
	      _props$getItemAriaLab = props.getItemAriaLabel,
	      getAriaLabel = _props$getItemAriaLab === void 0 ? defaultGetAriaLabel : _props$getItemAriaLab,
	      hideNextButton = props.hideNextButton,
	      hidePrevButton = props.hidePrevButton,
	      onChange = props.onChange,
	      page = props.page,
	      _props$renderItem = props.renderItem,
	      renderItem = _props$renderItem === void 0 ? function (item) {
	    return /*#__PURE__*/React.createElement(_PaginationItem.default, item);
	  } : _props$renderItem,
	      _props$shape = props.shape,
	      shape = _props$shape === void 0 ? 'round' : _props$shape,
	      showFirstButton = props.showFirstButton,
	      showLastButton = props.showLastButton,
	      siblingCount = props.siblingCount,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'text' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["boundaryCount", "classes", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"]);
	
	  var _usePagination = (0, _usePagination2.default)((0, _extends2.default)({}, props, {
	    componentName: 'Pagination'
	  })),
	      items = _usePagination.items;
	
	  return /*#__PURE__*/React.createElement("nav", (0, _extends2.default)({
	    "aria-label": "pagination navigation",
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("ul", {
	    className: classes.ul
	  }, items.map(function (item, index) {
	    return /*#__PURE__*/React.createElement("li", {
	      key: index
	    }, renderItem((0, _extends2.default)({}, item, {
	      color: color,
	      'aria-label': getAriaLabel(item.type, item.page, item.selected),
	      shape: shape,
	      size: size,
	      variant: variant
	    })));
	  })));
	}); // @default tags synced with default values from usePagination
	
	 false ? Pagination.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Number of always visible pages at the beginning and end.
	   * @default 1
	   */
	  boundaryCount: _propTypes.default.number,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The active color.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'standard']),
	
	  /**
	   * The total number of pages.
	   * @default 1
	   */
	  count: _propTypes.default.number,
	
	  /**
	   * The page selected by default when the component is uncontrolled.
	   * @default 1
	   */
	  defaultPage: _propTypes.default.number,
	
	  /**
	   * If `true`, the pagination component will be disabled.
	   * @default false
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   *
	   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
	   * @param {number} page The page number to format.
	   * @param {bool} selected If true, the current page is selected.
	   * @returns {string}
	   */
	  getItemAriaLabel: _propTypes.default.func,
	
	  /**
	   * If `true`, hide the next-page button.
	   * @default false
	   */
	  hideNextButton: _propTypes.default.bool,
	
	  /**
	   * If `true`, hide the previous-page button.
	   * @default false
	   */
	  hidePrevButton: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The current page.
	   */
	  page: _propTypes.default.number,
	
	  /**
	   * Render the item.
	   *
	   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
	   * @returns {ReactNode}
	   */
	  renderItem: _propTypes.default.func,
	
	  /**
	   * The shape of the pagination items.
	   */
	  shape: _propTypes.default.oneOf(['round', 'rounded']),
	
	  /**
	   * If `true`, show the first-page button.
	   * @default false
	   */
	  showFirstButton: _propTypes.default.bool,
	
	  /**
	   * If `true`, show the last-page button.
	   * @default false
	   */
	  showLastButton: _propTypes.default.bool,
	
	  /**
	   * Number of always visible pages before and after the current page.
	   * @default 1
	   */
	  siblingCount: _propTypes.default.number,
	
	  /**
	   * The size of the pagination component.
	   */
	  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['outlined', 'text'])
	} : void 0;
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiPagination'
	})(Pagination);
	
	exports.default = _default;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Pagination.default;
	  }
	});
	Object.defineProperty(exports, "usePagination", {
	  enumerable: true,
	  get: function get() {
	    return _usePagination.default;
	  }
	});
	
	var _Pagination = _interopRequireDefault(__webpack_require__(964));
	
	var _usePagination = _interopRequireDefault(__webpack_require__(364));

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(142));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _styles = __webpack_require__(30);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(44));
	
	var _FirstPage = _interopRequireDefault(__webpack_require__(971));
	
	var _LastPage = _interopRequireDefault(__webpack_require__(973));
	
	var _NavigateBefore = _interopRequireDefault(__webpack_require__(974));
	
	var _NavigateNext = _interopRequireDefault(__webpack_require__(975));
	
	var _utils = __webpack_require__(34);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body2, {
	      borderRadius: 32 / 2,
	      textAlign: 'center',
	      boxSizing: 'border-box',
	      minWidth: 32,
	      height: 32,
	      padding: '0 6px',
	      margin: '0 3px',
	      color: theme.palette.text.primary
	    }),
	
	    /* Styles applied to the root element if `type="page"`. */
	    page: {
	      transition: theme.transitions.create(['color', 'background-color'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$focusVisible': {
	        backgroundColor: theme.palette.action.focus
	      },
	      '&$selected': {
	        backgroundColor: theme.palette.action.selected,
	        '&:hover, &$focusVisible': {
	          backgroundColor: (0, _styles.fade)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        },
	        '&$disabled': {
	          opacity: 1,
	          color: theme.palette.action.disabled,
	          backgroundColor: theme.palette.action.selected
	        }
	      },
	      '&$disabled': {
	        opacity: theme.palette.action.disabledOpacity
	      }
	    },
	
	    /* Styles applied applied to the root element if `size="small"`. */
	    sizeSmall: {
	      minWidth: 26,
	      height: 26,
	      borderRadius: 26 / 2,
	      margin: '0 1px',
	      padding: '0 4px',
	      '& $icon': {
	        fontSize: theme.typography.pxToRem(18)
	      }
	    },
	
	    /* Styles applied applied to the root element if `size="large"`. */
	    sizeLarge: {
	      minWidth: 40,
	      height: 40,
	      borderRadius: 40 / 2,
	      padding: '0 10px',
	      fontSize: theme.typography.pxToRem(15),
	      '& $icon': {
	        fontSize: theme.typography.pxToRem(22)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
	    textPrimary: {
	      '&$selected': {
	        color: theme.palette.primary.contrastText,
	        backgroundColor: theme.palette.primary.main,
	        '&:hover, &$focusVisible': {
	          backgroundColor: theme.palette.primary.dark,
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: theme.palette.primary.main
	          }
	        },
	        '&$disabled': {
	          color: theme.palette.action.disabled
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
	    textSecondary: {
	      '&$selected': {
	        color: theme.palette.secondary.contrastText,
	        backgroundColor: theme.palette.secondary.main,
	        '&:hover, &$focusVisible': {
	          backgroundColor: theme.palette.secondary.dark,
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: theme.palette.secondary.main
	          }
	        },
	        '&$disabled': {
	          color: theme.palette.action.disabled
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `outlined="true"`. */
	    outlined: {
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '&$selected': {
	        '&$disabled': {
	          border: "1px solid ".concat(theme.palette.action.disabledBackground)
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      '&$selected': {
	        color: theme.palette.primary.main,
	        border: "1px solid ".concat((0, _styles.fade)(theme.palette.primary.main, 0.5)),
	        backgroundColor: (0, _styles.fade)(theme.palette.primary.main, theme.palette.action.activatedOpacity),
	        '&:hover, &$focusVisible': {
	          backgroundColor: (0, _styles.fade)(theme.palette.primary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        },
	        '&$disabled': {
	          color: theme.palette.action.disabled
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      '&$selected': {
	        color: theme.palette.secondary.main,
	        border: "1px solid ".concat((0, _styles.fade)(theme.palette.secondary.main, 0.5)),
	        backgroundColor: (0, _styles.fade)(theme.palette.secondary.main, theme.palette.action.activatedOpacity),
	        '&:hover, &$focusVisible': {
	          backgroundColor: (0, _styles.fade)(theme.palette.secondary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        },
	        '&$disabled': {
	          color: theme.palette.action.disabled
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `rounded="true"`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `type="start-ellipsis"` or `type="end-ellipsis"`. */
	    ellipsis: {
	      height: 'auto',
	      '&$disabled': {
	        opacity: theme.palette.action.disabledOpacity
	      }
	    },
	
	    /* Pseudo-class applied to the root element if keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Styles applied to the icon element. */
	    icon: {
	      fontSize: theme.typography.pxToRem(20),
	      margin: '0 -8px'
	    }
	  };
	};
	
	exports.styles = styles;
	var PaginationItem = React.forwardRef(function PaginationItem(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'standard' : _props$color,
	      component = props.component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      page = props.page,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      _props$shape = props.shape,
	      shape = _props$shape === void 0 ? 'round' : _props$shape,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'page' : _props$type,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'text' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disabled", "page", "selected", "shape", "size", "type", "variant"]);
	  var theme = (0, _styles.useTheme)();
	  var normalizedIcons = theme.direction === 'rtl' ? {
	    previous: _NavigateNext.default,
	    next: _NavigateBefore.default,
	    last: _FirstPage.default,
	    first: _LastPage.default
	  } : {
	    previous: _NavigateBefore.default,
	    next: _NavigateNext.default,
	    first: _FirstPage.default,
	    last: _LastPage.default
	  };
	  var Icon = normalizedIcons[type];
	  return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/React.createElement("div", {
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, classes.ellipsis, disabled && classes.disabled, size !== 'medium' && classes["size".concat((0, _utils.capitalize)(size))])
	  }, "\u2026") : /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    ref: ref,
	    component: component,
	    disabled: disabled,
	    focusVisibleClassName: classes.focusVisible,
	    className: (0, _clsx.default)(classes.root, classes.page, classes[variant], classes[shape], className, color !== 'standard' && classes["".concat(variant).concat((0, _utils.capitalize)(color))], disabled && classes.disabled, selected && classes.selected, size !== 'medium' && classes["size".concat((0, _utils.capitalize)(size))])
	  }, other), type === 'page' && page, Icon ? /*#__PURE__*/React.createElement(Icon, {
	    className: classes.icon
	  }) : null);
	});
	 false ? PaginationItem.propTypes = {
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The active color.
	   */
	  color: _propTypes.default.oneOf(['standard', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The current page number.
	   */
	  page: _propTypes.default.number,
	
	  /**
	   * If `true` the pagination item is selected.
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * The shape of the pagination item.
	   */
	  shape: _propTypes.default.oneOf(['round', 'rounded']),
	
	  /**
	   * The size of the pagination item.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * The type of pagination item.
	   */
	  type: _propTypes.default.oneOf(['page', 'first', 'last', 'next', 'previous', 'start-ellipsis', 'end-ellipsis']),
	
	  /**
	   * The pagination item variant.
	   */
	  variant: _propTypes.default.oneOf(['text', 'outlined'])
	} : void 0;
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiPaginationItem'
	})(PaginationItem);
	
	exports.default = _default;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _PaginationItem.default;
	  }
	});
	
	var _PaginationItem = _interopRequireDefault(__webpack_require__(966));

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(142));
	
	var _styles = __webpack_require__(30);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      backgroundColor: theme.palette.action.hover,
	      height: '1.2em'
	    },
	
	    /* Styles applied to the root element if `variant="text"`. */
	    text: {
	      marginTop: 0,
	      marginBottom: 0,
	      height: 'auto',
	      transformOrigin: '0 60%',
	      transform: 'scale(1, 0.60)',
	      borderRadius: theme.shape.borderRadius,
	      '&:empty:before': {
	        content: '"\\00a0"'
	      }
	    },
	
	    /* Styles applied to the root element if `variant="rect"`. */
	    rect: {},
	
	    /* Styles applied to the root element if `variant="circle"`. */
	    circle: {
	      borderRadius: '50%'
	    },
	
	    /* Styles applied to the root element if `animation="pulse"`. */
	    pulse: {
	      animation: '$pulse 1.5s ease-in-out 0.5s infinite'
	    },
	    '@keyframes pulse': {
	      '0%': {
	        opacity: 1
	      },
	      '50%': {
	        opacity: 0.4
	      },
	      '100%': {
	        opacity: 1
	      }
	    },
	
	    /* Styles applied to the root element if `animation="wave"`. */
	    wave: {
	      position: 'relative',
	      overflow: 'hidden',
	      '&::after': {
	        animation: '$wave 1.6s linear 0.5s infinite',
	        background: "linear-gradient(90deg, transparent, ".concat(theme.palette.action.hover, ", transparent)"),
	        content: '""',
	        position: 'absolute',
	        transform: 'translateX(-100%)',
	        // Avoid flash during server-side hydration
	        bottom: 0,
	        left: 0,
	        right: 0,
	        top: 0,
	        zIndex: 1
	      }
	    },
	    '@keyframes wave': {
	      '0%': {
	        transform: 'translateX(-100%)'
	      },
	      '60%': {
	        // +0.5s of delay between each loop
	        transform: 'translateX(100%)'
	      },
	      '100%': {
	        transform: 'translateX(100%)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var Skeleton = React.forwardRef(function Skeleton(props, ref) {
	  var _props$animation = props.animation,
	      animation = _props$animation === void 0 ? 'pulse' : _props$animation,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      height = props.height,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'text' : _props$variant,
	      width = props.width,
	      other = (0, _objectWithoutProperties2.default)(props, ["animation", "classes", "className", "component", "height", "variant", "width"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, classes[variant], className, animation !== false && classes[animation])
	  }, other, {
	    style: (0, _extends2.default)({
	      width: width,
	      height: height
	    }, other.style)
	  }));
	});
	 false ? Skeleton.propTypes = {
	  /**
	   * The animation.
	   * If `false` the animation effect is disabled.
	   */
	  animation: _propTypes.default.oneOf(['pulse', 'wave', false]),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Height of the skeleton.
	   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
	   */
	  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The type of content that will be rendered.
	   */
	  variant: _propTypes.default.oneOf(['text', 'rect', 'circle']),
	
	  /**
	   * Width of the skeleton.
	   * Useful when the skeleton is inside an inline element with no width of its own.
	   */
	  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	} : void 0;
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiSkeleton'
	})(Skeleton);
	
	exports.default = _default;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'ErrorOutline');
	
	exports.default = _default;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
	}), 'FirstPage');
	
	exports.default = _default;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
	}), 'InfoOutlined');
	
	exports.default = _default;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
	}), 'LastPage');
	
	exports.default = _default;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
	}), 'NavigateBefore');
	
	exports.default = _default;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
	}), 'NavigateNext');
	
	exports.default = _default;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
	}), 'ReportProblemOutlined');
	
	exports.default = _default;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
	}), 'SuccessOutlined');
	
	exports.default = _default;

/***/ },
/* 978 */
[1912, 979],
/* 979 */
918,
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete.default;
	  }
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete.createFilterOptions;
	  }
	});
	
	var _useAutocomplete = _interopRequireWildcard(__webpack_require__(981));

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFilterOptions = createFilterOptions;
	exports.default = useAutocomplete;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(79));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(34);
	
	/* eslint-disable no-constant-condition */
	// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
	// Give up on IE 11 support for this feature
	function stripDiacritics(string) {
	  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
	}
	
	function createFilterOptions() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$ignoreAccents = config.ignoreAccents,
	      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
	      _config$ignoreCase = config.ignoreCase,
	      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
	      limit = config.limit,
	      _config$matchFrom = config.matchFrom,
	      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
	      stringify = config.stringify,
	      _config$trim = config.trim,
	      trim = _config$trim === void 0 ? false : _config$trim;
	  return function (options, _ref) {
	    var inputValue = _ref.inputValue,
	        getOptionLabel = _ref.getOptionLabel;
	    var input = trim ? inputValue.trim() : inputValue;
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = stripDiacritics(input);
	    }
	
	    var filteredOptions = options.filter(function (option) {
	      var candidate = (stringify || getOptionLabel)(option);
	
	      if (ignoreCase) {
	        candidate = candidate.toLowerCase();
	      }
	
	      if (ignoreAccents) {
	        candidate = stripDiacritics(candidate);
	      }
	
	      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
	    });
	    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
	  };
	} // To replace with .findIndex() once we stop IE 11 support.
	
	
	function findIndex(array, comp) {
	  for (var i = 0; i < array.length; i += 1) {
	    if (comp(array[i])) {
	      return i;
	    }
	  }
	
	  return -1;
	}
	
	var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.
	
	var pageSize = 5;
	
	function useAutocomplete(props) {
	  var _props$autoComplete = props.autoComplete,
	      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
	      _props$autoHighlight = props.autoHighlight,
	      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
	      _props$autoSelect = props.autoSelect,
	      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
	      _props$blurOnSelect = props.blurOnSelect,
	      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
	      _props$clearOnBlur = props.clearOnBlur,
	      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
	      _props$clearOnEscape = props.clearOnEscape,
	      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
	      _props$componentName = props.componentName,
	      componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
	      _props$debug = props.debug,
	      debug = _props$debug === void 0 ? false : _props$debug,
	      _props$defaultValue = props.defaultValue,
	      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
	      _props$disableClearab = props.disableClearable,
	      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
	      _props$disableCloseOn = props.disableCloseOnSelect,
	      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      _props$filterOptions = props.filterOptions,
	      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
	      _props$filterSelected = props.filterSelectedOptions,
	      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
	      _props$freeSolo = props.freeSolo,
	      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
	      getOptionDisabled = props.getOptionDisabled,
	      _props$getOptionLabel = props.getOptionLabel,
	      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
	    return x;
	  } : _props$getOptionLabel,
	      _props$getOptionSelec = props.getOptionSelected,
	      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
	    return option === value;
	  } : _props$getOptionSelec,
	      groupBy = props.groupBy,
	      idProp = props.id,
	      _props$includeInputIn = props.includeInputInList,
	      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
	      inputValueProp = props.inputValue,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onHighlightChange = props.onHighlightChange,
	      onInputChange = props.onInputChange,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      _props$openOnFocus = props.openOnFocus,
	      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
	      options = props.options,
	      _props$selectOnFocus = props.selectOnFocus,
	      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
	      valueProp = props.value;
	  var id = (0, _utils.unstable_useId)(idProp);
	  var ignoreFocus = React.useRef(false);
	  var firstFocus = React.useRef(true);
	  var inputRef = React.useRef(null);
	  var listboxRef = React.useRef(null);
	
	  var _React$useState = React.useState(null),
	      anchorEl = _React$useState[0],
	      setAnchorEl = _React$useState[1];
	
	  var _React$useState2 = React.useState(-1),
	      focusedTag = _React$useState2[0],
	      setFocusedTag = _React$useState2[1];
	
	  var defaultHighlighted = autoHighlight ? 0 : -1;
	  var highlightedIndexRef = React.useRef(defaultHighlighted);
	  var setHighlightedIndex = (0, _utils.useEventCallback)(function (index) {
	    var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
	    var event = arguments.length > 2 ? arguments[2] : undefined;
	    highlightedIndexRef.current = index; // does the index exist?
	
	    if (index === -1) {
	      inputRef.current.removeAttribute('aria-activedescendant');
	    } else {
	      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
	    }
	
	    if (!listboxRef.current) {
	      return;
	    }
	
	    var prev = listboxRef.current.querySelector('[data-focus]');
	
	    if (prev) {
	      prev.removeAttribute('data-focus');
	    }
	
	    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"
	
	    if (!listboxNode) {
	      return;
	    }
	
	    if (onHighlightChange) {
	      onHighlightChange(event, options[index], reason);
	    }
	
	    if (index === -1) {
	      listboxNode.scrollTop = 0;
	      return;
	    }
	
	    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));
	
	    if (!option) {
	      return;
	    }
	
	    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
	    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
	    //
	    // Consider this API instead once it has a better browser support:
	    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
	
	    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
	      var element = option;
	      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
	      var elementBottom = element.offsetTop + element.offsetHeight;
	
	      if (elementBottom > scrollBottom) {
	        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
	      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
	        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
	      }
	    }
	  });
	
	  var _useControlled = (0, _utils.useControlled)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: componentName
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  var _useControlled3 = (0, _utils.useControlled)({
	    controlled: inputValueProp,
	    default: '',
	    name: componentName,
	    state: 'inputValue'
	  }),
	      _useControlled4 = (0, _slicedToArray2.default)(_useControlled3, 2),
	      inputValue = _useControlled4[0],
	      setInputValue = _useControlled4[1];
	
	  var _React$useState3 = React.useState(false),
	      focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  var resetInputValue = (0, _utils.useEventCallback)(function (event, newValue) {
	    var newInputValue;
	
	    if (multiple) {
	      newInputValue = '';
	    } else if (newValue == null) {
	      newInputValue = '';
	    } else {
	      var optionLabel = getOptionLabel(newValue);
	
	      if (false) {
	        if (typeof optionLabel !== 'string') {
	          var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat((0, _typeof2.default)(optionLabel), " (").concat(optionLabel, ")");
	          console.error("Material-UI: the `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(newValue), "."));
	        }
	      }
	
	      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
	    }
	
	    if (inputValue === newInputValue) {
	      return;
	    }
	
	    setInputValue(newInputValue);
	
	    if (onInputChange) {
	      onInputChange(event, newInputValue, 'reset');
	    }
	  });
	  React.useEffect(function () {
	    resetInputValue(null, value);
	  }, [value, resetInputValue]);
	
	  var _React$useRef = React.useRef(openProp != null),
	      isOpenControlled = _React$useRef.current;
	
	  var _React$useState4 = React.useState(false),
	      openState = _React$useState4[0],
	      setOpenState = _React$useState4[1];
	
	  var open = isOpenControlled ? openProp : openState;
	  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
	  var popupOpen = open;
	  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
	    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
	      return value2 !== null && getOptionSelected(option, value2);
	    })) {
	      return false;
	    }
	
	    return true;
	  }), // we use the empty string to manipulate `filterOptions` to not filter any options
	  // i.e. the filter predicate always returns true
	  {
	    inputValue: inputValueIsSelectedValue ? '' : inputValue,
	    getOptionLabel: getOptionLabel
	  }) : [];
	  popupOpen = freeSolo && filteredOptions.length === 0 ? false : popupOpen;
	
	  if (false) {
	    if (value !== null && !freeSolo && options.length > 0) {
	      var missingValue = (multiple ? value : [value]).filter(function (value2) {
	        return !options.some(function (option) {
	          return getOptionSelected(option, value2);
	        });
	      });
	
	      if (missingValue.length > 0) {
	        console.warn(["Material-UI: the value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `getOptionSelected` prop to customize the equality test.'].join('\n'));
	      }
	    }
	  }
	
	  var focusTag = (0, _utils.useEventCallback)(function (tagToFocus) {
	    if (tagToFocus === -1) {
	      inputRef.current.focus();
	    } else {
	      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
	    }
	  }); // Ensure the focusedTag is never inconsistent
	
	  React.useEffect(function () {
	    if (multiple && focusedTag > value.length - 1) {
	      setFocusedTag(-1);
	      focusTag(-1);
	    }
	  }, [value, multiple, focusedTag, focusTag]);
	
	  function validOptionIndex(index, direction) {
	    if (!listboxRef.current || index === -1) {
	      return -1;
	    }
	
	    var nextFocus = index;
	
	    while (true) {
	      // Out of range
	      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
	        return -1;
	      }
	
	      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
	
	      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');
	
	      if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
	        // Move to the next element.
	        nextFocus += direction === 'next' ? 1 : -1;
	      } else {
	        return nextFocus;
	      }
	    }
	  }
	
	  var changeHighlightedIndex = (0, _utils.useEventCallback)(function (diff, direction) {
	    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
	    var event = arguments.length > 3 ? arguments[3] : undefined;
	
	    if (!popupOpen) {
	      return;
	    }
	
	    var getNextIndex = function getNextIndex() {
	      var maxIndex = filteredOptions.length - 1;
	
	      if (diff === 'reset') {
	        return defaultHighlighted;
	      }
	
	      if (diff === 'start') {
	        return 0;
	      }
	
	      if (diff === 'end') {
	        return maxIndex;
	      }
	
	      var newIndex = highlightedIndexRef.current + diff;
	
	      if (newIndex < 0) {
	        if (newIndex === -1 && includeInputInList) {
	          return -1;
	        }
	
	        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
	          return 0;
	        }
	
	        return maxIndex;
	      }
	
	      if (newIndex > maxIndex) {
	        if (newIndex === maxIndex + 1 && includeInputInList) {
	          return -1;
	        }
	
	        if (disableListWrap || Math.abs(diff) > 1) {
	          return maxIndex;
	        }
	
	        return 0;
	      }
	
	      return newIndex;
	    };
	
	    var nextIndex = validOptionIndex(getNextIndex(), direction);
	    setHighlightedIndex(nextIndex, reason, event);
	
	    if (autoComplete && diff !== 'reset') {
	      if (nextIndex === -1) {
	        inputRef.current.value = inputValue;
	      } else {
	        var option = getOptionLabel(filteredOptions[nextIndex]);
	        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
	        // a completion string, appears inline after the input cursor in the textbox.
	
	        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());
	
	        if (index === 0 && inputValue.length > 0) {
	          inputRef.current.setSelectionRange(inputValue.length, option.length);
	        }
	      }
	    }
	  });
	  React.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var valueItem = multiple ? value[0] : value; // The popup is empty
	
	    if (filteredOptions.length === 0 || valueItem == null) {
	      changeHighlightedIndex('reset', 'next');
	      return;
	    } // Synchronize the value with the highlighted index
	
	
	    if (!filterSelectedOptions && valueItem != null) {
	      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible
	
	      if (multiple && currentOption && findIndex(value, function (val) {
	        return getOptionSelected(currentOption, val);
	      }) !== -1) {
	        return;
	      }
	
	      var itemIndex = findIndex(filteredOptions, function (optionItem) {
	        return getOptionSelected(optionItem, valueItem);
	      });
	
	      if (itemIndex === -1) {
	        changeHighlightedIndex('reset', 'next');
	      } else {
	        setHighlightedIndex(itemIndex);
	      }
	
	      return;
	    } // Keep the index in the boundaries
	
	
	    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
	      setHighlightedIndex(filteredOptions.length - 1);
	    } // Ignore filterOptions => options, getOptionSelected, getOptionLabel)
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	
	  }, [value, open, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, inputValue, multiple]);
	
	  var handleOpen = function handleOpen(event) {
	    if (open) {
	      return;
	    }
	
	    if (onOpen) {
	      onOpen(event);
	    }
	
	    if (!isOpenControlled) {
	      setOpenState(true);
	    }
	  };
	
	  var handleClose = function handleClose(event, reason) {
	    if (!open) {
	      return;
	    }
	
	    if (onClose) {
	      onClose(event, reason);
	    }
	
	    if (!isOpenControlled) {
	      setOpenState(false);
	    }
	  };
	
	  var handleValue = function handleValue(event, newValue, reason, details) {
	    if (value === newValue) {
	      return;
	    }
	
	    if (onChange) {
	      onChange(event, newValue, reason, details);
	    }
	
	    setValue(newValue);
	  };
	
	  var isTouch = React.useRef(false);
	
	  var selectNewValue = function selectNewValue(event, option) {
	    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
	    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
	    var reason = reasonProp;
	    var newValue = option;
	
	    if (multiple) {
	      newValue = Array.isArray(value) ? (0, _toConsumableArray2.default)(value) : [];
	
	      if (false) {
	        var matches = newValue.filter(function (val) {
	          return getOptionSelected(option, val);
	        });
	
	        if (matches.length > 1) {
	          console.error(["Material-UI: the `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
	        }
	      }
	
	      var itemIndex = findIndex(newValue, function (valueItem) {
	        return getOptionSelected(option, valueItem);
	      });
	
	      if (itemIndex === -1) {
	        newValue.push(option);
	      } else if (origin !== 'freeSolo') {
	        newValue.splice(itemIndex, 1);
	        reason = 'remove-option';
	      }
	    }
	
	    resetInputValue(event, newValue);
	    handleValue(event, newValue, reason, {
	      option: option
	    });
	
	    if (!disableCloseOnSelect) {
	      handleClose(event, reason);
	    }
	
	    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
	      inputRef.current.blur();
	    }
	  };
	
	  function validTagIndex(index, direction) {
	    if (index === -1) {
	      return -1;
	    }
	
	    var nextFocus = index;
	
	    while (true) {
	      // Out of range
	      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
	        return -1;
	      }
	
	      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
	
	      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
	        nextFocus += direction === 'next' ? 1 : -1;
	      } else {
	        return nextFocus;
	      }
	    }
	  }
	
	  var handleFocusTag = function handleFocusTag(event, direction) {
	    if (!multiple) {
	      return;
	    }
	
	    handleClose(event, 'toggleInput');
	    var nextTag = focusedTag;
	
	    if (focusedTag === -1) {
	      if (inputValue === '' && direction === 'previous') {
	        nextTag = value.length - 1;
	      }
	    } else {
	      nextTag += direction === 'next' ? 1 : -1;
	
	      if (nextTag < 0) {
	        nextTag = 0;
	      }
	
	      if (nextTag === value.length) {
	        nextTag = -1;
	      }
	    }
	
	    nextTag = validTagIndex(nextTag, direction);
	    setFocusedTag(nextTag);
	    focusTag(nextTag);
	  };
	
	  var handleClear = function handleClear(event) {
	    ignoreFocus.current = true;
	    setInputValue('');
	
	    if (onInputChange) {
	      onInputChange(event, '', 'clear');
	    }
	
	    handleValue(event, multiple ? [] : null, 'clear');
	  };
	
	  var handleKeyDown = function handleKeyDown(other) {
	    return function (event) {
	      if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
	        setFocusedTag(-1);
	        focusTag(-1);
	      }
	
	      switch (event.key) {
	        case 'Home':
	          if (popupOpen) {
	            // Prevent scroll of the page
	            event.preventDefault();
	            changeHighlightedIndex('start', 'next', 'keyboard', event);
	          }
	
	          break;
	
	        case 'End':
	          if (popupOpen) {
	            // Prevent scroll of the page
	            event.preventDefault();
	            changeHighlightedIndex('end', 'previous', 'keyboard', event);
	          }
	
	          break;
	
	        case 'PageUp':
	          // Prevent scroll of the page
	          event.preventDefault();
	          changeHighlightedIndex(-pageSize, 'previous', 'keyboard', event);
	          handleOpen(event);
	          break;
	
	        case 'PageDown':
	          // Prevent scroll of the page
	          event.preventDefault();
	          changeHighlightedIndex(pageSize, 'next', 'keyboard', event);
	          handleOpen(event);
	          break;
	
	        case 'ArrowDown':
	          // Prevent cursor move
	          event.preventDefault();
	          changeHighlightedIndex(1, 'next', 'keyboard', event);
	          handleOpen(event);
	          break;
	
	        case 'ArrowUp':
	          // Prevent cursor move
	          event.preventDefault();
	          changeHighlightedIndex(-1, 'previous', 'keyboard', event);
	          handleOpen(event);
	          break;
	
	        case 'ArrowLeft':
	          handleFocusTag(event, 'previous');
	          break;
	
	        case 'ArrowRight':
	          handleFocusTag(event, 'next');
	          break;
	
	        case 'Enter':
	          // Wait until IME is settled.
	          if (event.which === 229) {
	            break;
	          }
	
	          if (highlightedIndexRef.current !== -1 && popupOpen) {
	            var option = filteredOptions[highlightedIndexRef.current];
	            var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
	
	            if (disabled) {
	              return;
	            } // We don't want to validate the form.
	
	
	            event.preventDefault();
	            selectNewValue(event, option, 'select-option'); // Move the selection to the end.
	
	            if (autoComplete) {
	              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
	            }
	          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
	            if (multiple) {
	              // Allow people to add new values before they submit the form.
	              event.preventDefault();
	            }
	
	            selectNewValue(event, inputValue, 'create-option', 'freeSolo');
	          }
	
	          break;
	
	        case 'Escape':
	          if (popupOpen) {
	            // Avoid Opera to exit fullscreen mode.
	            event.preventDefault(); // Avoid the Modal to handle the event.
	
	            event.stopPropagation();
	            handleClose(event, 'escape');
	          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
	            // Avoid Opera to exit fullscreen mode.
	            event.preventDefault(); // Avoid the Modal to handle the event.
	
	            event.stopPropagation();
	            handleClear(event);
	          }
	
	          break;
	
	        case 'Backspace':
	          if (multiple && inputValue === '' && value.length > 0) {
	            var index = focusedTag === -1 ? value.length - 1 : focusedTag;
	            var newValue = (0, _toConsumableArray2.default)(value);
	            newValue.splice(index, 1);
	            handleValue(event, newValue, 'remove-option', {
	              option: value[index]
	            });
	          }
	
	          break;
	
	        default:
	      }
	
	      if (other.onKeyDown) {
	        other.onKeyDown(event);
	      }
	    };
	  };
	
	  var handleFocus = function handleFocus(event) {
	    setFocused(true);
	
	    if (openOnFocus && !ignoreFocus.current) {
	      handleOpen(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    // Ignore the event when using the scrollbar with IE 11
	    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
	      inputRef.current.focus();
	      return;
	    }
	
	    setFocused(false);
	    firstFocus.current = true;
	    ignoreFocus.current = false;
	
	    if (debug && inputValue !== '') {
	      return;
	    }
	
	    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
	      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
	    } else if (autoSelect && freeSolo && inputValue !== '') {
	      selectNewValue(event, inputValue, 'blur', 'freeSolo');
	    } else if (clearOnBlur) {
	      resetInputValue(event, value);
	    }
	
	    handleClose(event, 'blur');
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    var newValue = event.target.value;
	
	    if (inputValue !== newValue) {
	      setInputValue(newValue);
	
	      if (onInputChange) {
	        onInputChange(event, newValue, 'input');
	      }
	    }
	
	    if (newValue === '') {
	      if (!disableClearable && !multiple) {
	        handleValue(event, null, 'clear');
	      }
	    } else {
	      handleOpen(event);
	    }
	  };
	
	  var handleOptionMouseOver = function handleOptionMouseOver(event) {
	    var index = Number(event.currentTarget.getAttribute('data-option-index'));
	    setHighlightedIndex(index, 'mouse', event);
	  };
	
	  var handleOptionTouchStart = function handleOptionTouchStart() {
	    isTouch.current = true;
	  };
	
	  var handleOptionClick = function handleOptionClick(event) {
	    var index = Number(event.currentTarget.getAttribute('data-option-index'));
	    selectNewValue(event, filteredOptions[index], 'select-option');
	    isTouch.current = false;
	  };
	
	  var handleTagDelete = function handleTagDelete(index) {
	    return function (event) {
	      var newValue = (0, _toConsumableArray2.default)(value);
	      newValue.splice(index, 1);
	      handleValue(event, newValue, 'remove-option', {
	        option: value[index]
	      });
	    };
	  };
	
	  var handleListboxRef = (0, _utils.useEventCallback)(function (node) {
	    (0, _utils.setRef)(listboxRef, node);
	
	    if (!node) {
	      return;
	    } // Automatically select the first option as the listbox become visible.
	
	
	    if (highlightedIndexRef.current === -1 && autoHighlight) {
	      changeHighlightedIndex('reset', 'next');
	    } else {
	      // Restore the focus to the correct option.
	      setHighlightedIndex(highlightedIndexRef.current);
	    }
	  });
	
	  var handlePopupIndicator = function handlePopupIndicator(event) {
	    if (open) {
	      handleClose(event, 'toggleInput');
	    } else {
	      handleOpen(event);
	    }
	  }; // Prevent input blur when interacting with the combobox
	
	
	  var handleMouseDown = function handleMouseDown(event) {
	    if (event.target.getAttribute('id') !== id) {
	      event.preventDefault();
	    }
	  }; // Focus the input when interacting with the combobox
	
	
	  var handleClick = function handleClick() {
	    inputRef.current.focus();
	
	    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
	      inputRef.current.select();
	    }
	
	    firstFocus.current = false;
	  };
	
	  var handleInputMouseDown = function handleInputMouseDown(event) {
	    if (inputValue === '' || !open) {
	      handlePopupIndicator(event);
	    }
	  };
	
	  var dirty = freeSolo && inputValue.length > 0;
	  dirty = dirty || (multiple ? value.length > 0 : value !== null);
	  var groupedOptions = filteredOptions;
	
	  if (groupBy) {
	    // used to keep track of key and indexes in the result array
	    var indexBy = new Map();
	    var warn = false;
	    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
	      var group = groupBy(option);
	
	      if (acc.length > 0 && acc[acc.length - 1].group === group) {
	        acc[acc.length - 1].options.push(option);
	      } else {
	        if (false) {
	          if (indexBy.get(group) && !warn) {
	            console.warn("Material-UI: the options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
	            warn = true;
	          }
	
	          indexBy.set(group, true);
	        }
	
	        acc.push({
	          key: index,
	          index: index,
	          group: group,
	          options: [option]
	        });
	      }
	
	      return acc;
	    }, []);
	  }
	
	  return {
	    getRootProps: function getRootProps() {
	      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return (0, _extends2.default)({
	        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
	        role: 'combobox',
	        'aria-expanded': popupOpen
	      }, other, {
	        onKeyDown: handleKeyDown(other),
	        onMouseDown: handleMouseDown,
	        onClick: handleClick
	      });
	    },
	    getInputLabelProps: function getInputLabelProps() {
	      return {
	        id: "".concat(id, "-label"),
	        htmlFor: id
	      };
	    },
	    getInputProps: function getInputProps() {
	      return {
	        id: id,
	        value: inputValue,
	        onBlur: handleBlur,
	        onFocus: handleFocus,
	        onChange: handleInputChange,
	        onMouseDown: handleInputMouseDown,
	        // if open then this is handled imperativeley so don't let react override
	        // only have an opinion about this when closed
	        'aria-activedescendant': popupOpen ? '' : null,
	        'aria-autocomplete': autoComplete ? 'both' : 'list',
	        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
	        // Disable browser's suggestion that might overlap with the popup.
	        // Handle autocomplete but not autofill.
	        autoComplete: 'off',
	        ref: inputRef,
	        autoCapitalize: 'none',
	        spellCheck: 'false'
	      };
	    },
	    getClearProps: function getClearProps() {
	      return {
	        tabIndex: -1,
	        onClick: handleClear
	      };
	    },
	    getPopupIndicatorProps: function getPopupIndicatorProps() {
	      return {
	        tabIndex: -1,
	        onClick: handlePopupIndicator
	      };
	    },
	    getTagProps: function getTagProps(_ref2) {
	      var index = _ref2.index;
	      return {
	        key: index,
	        'data-tag-index': index,
	        tabIndex: -1,
	        onDelete: handleTagDelete(index)
	      };
	    },
	    getListboxProps: function getListboxProps() {
	      return {
	        role: 'listbox',
	        id: "".concat(id, "-popup"),
	        'aria-labelledby': "".concat(id, "-label"),
	        ref: handleListboxRef,
	        onMouseDown: function onMouseDown(event) {
	          // Prevent blur
	          event.preventDefault();
	        }
	      };
	    },
	    getOptionProps: function getOptionProps(_ref3) {
	      var index = _ref3.index,
	          option = _ref3.option;
	      var selected = (multiple ? value : [value]).some(function (value2) {
	        return value2 != null && getOptionSelected(option, value2);
	      });
	      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
	      return {
	        key: index,
	        tabIndex: -1,
	        role: 'option',
	        id: "".concat(id, "-option-").concat(index),
	        onMouseOver: handleOptionMouseOver,
	        onClick: handleOptionClick,
	        onTouchStart: handleOptionTouchStart,
	        'data-option-index': index,
	        'aria-disabled': disabled,
	        'aria-selected': selected
	      };
	    },
	    id: id,
	    inputValue: inputValue,
	    value: value,
	    dirty: dirty,
	    popupOpen: popupOpen,
	    focused: focused || focusedTag !== -1,
	    anchorEl: anchorEl,
	    setAnchorEl: setAnchorEl,
	    focusedTag: focusedTag,
	    groupedOptions: groupedOptions
	  };
	}

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(115));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(394));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(395));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(242));
	
	var _PropTypes = __webpack_require__(369);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
	 * use it if you're using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**, so it's
	 * important to add `transition` declaration only to them, otherwise transitions
	 * might not behave as intended! This might not be obvious when the transitions
	 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
	 * the example above (minus `transition`), but it becomes apparent in more
	 * complex transitions.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (node, appearing) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    if (type === 'appear' && phase === 'done') {
	      className += " " + this.getClassNames('enter').doneClassName;
	    } // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	    }
	
	    this.appliedClasses[type][phase] = className;
	
	    _addClass(node, className);
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided, which
	   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
	   *
	   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
	   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
	   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
	   *
	   * A few details to note about how these classes are applied:
	   *
	   * 1. They are _joined_ with the ones that are already defined on the child
	   *    component, so if you want to add some base styles, you can use
	   *    `className` without worrying that it will be overridden.
	   *
	   * 2. If the transition component mounts with `in={false}`, no classes are
	   *    applied yet. You might be expecting `*-exit-done`, but if you think
	   *    about it, a component cannot finish exiting if it hasn't entered yet.
	   *
	   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
	   *    allows you to define different behavior for when appearing is done and
	   *    when regular entering is done, using selectors like
	   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
	   *    an epic entrance animation when element first appears in the DOM using
	   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   *    simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(32));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(367));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler](this.props.findDOMNode(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.findDOMNode;
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  },
	  findDOMNode: _propTypes.default.func
	} : {};
	ReplaceTransition.defaultProps = {
	  findDOMNode: _reactDom.default.findDOMNode
	};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 984 */
[1914, 115, 242, 243],
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = (key in prevChildMapping);
	    var hasNext = (key in nextChildMapping);
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 986 */
[1912, 987],
/* 987 */
918,
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(216));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(155));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _jss = __webpack_require__(96);
	
	var _StylesProvider = _interopRequireDefault(__webpack_require__(244));
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(245));
	
	var ServerStyleSheets = /*#__PURE__*/function () {
	  function ServerStyleSheets() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ServerStyleSheets);
	    this.options = options;
	  }
	
	  (0, _createClass2.default)(ServerStyleSheets, [{
	    key: "collect",
	    value: function collect(children) {
	      // This is needed in order to deduplicate the injection of CSS in the page.
	      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.
	
	      this.sheetsRegistry = new _jss.SheetsRegistry(); // A new class name generator
	
	      var generateClassName = (0, _createGenerateClassName.default)();
	      return /*#__PURE__*/_react.default.createElement(_StylesProvider.default, (0, _extends2.default)({
	        sheetsManager: sheetsManager,
	        serverGenerateClassName: generateClassName,
	        sheetsRegistry: this.sheetsRegistry
	      }, this.options), children);
	    }
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
	    }
	  }, {
	    key: "getStyleElement",
	    value: function getStyleElement(props) {
	      return /*#__PURE__*/_react.default.createElement('style', (0, _extends2.default)({
	        id: 'jss-server-side',
	        key: 'jss-server-side',
	        dangerouslySetInnerHTML: {
	          __html: this.toString()
	        }
	      }, props));
	    }
	  }]);
	  return ServerStyleSheets;
	}();
	
	exports.default = ServerStyleSheets;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	
	var _ServerStyleSheets = _interopRequireDefault(__webpack_require__(988));

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StylesProvider;
	exports.StylesContext = exports.sheetsManager = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(144));
	
	var _utils = __webpack_require__(21);
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(245));
	
	var _jss = __webpack_require__(96);
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(373));
	
	// Default JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
	//
	// The counter-based approach doesn't tolerate any mistake.
	// It's much safer to use the same counter everywhere.
	
	var generateClassName = (0, _createGenerateClassName.default)(); // Exported for test purposes
	
	var sheetsManager = new Map();
	exports.sheetsManager = sheetsManager;
	var defaultOptions = {
	  disableGeneration: false,
	  generateClassName: generateClassName,
	  jss: jss,
	  sheetsCache: null,
	  sheetsManager: sheetsManager,
	  sheetsRegistry: null
	};
	
	var StylesContext = _react.default.createContext(defaultOptions);
	
	exports.StylesContext = StylesContext;
	
	if (false) {
	  StylesContext.displayName = 'StylesContext';
	}
	
	var injectFirstNode;
	
	function StylesProvider(props) {
	  var children = props.children,
	      _props$injectFirst = props.injectFirst,
	      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
	      _props$disableGenerat = props.disableGeneration,
	      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
	      localOptions = (0, _objectWithoutProperties2.default)(props, ["children", "injectFirst", "disableGeneration"]);
	
	  var outerOptions = _react.default.useContext(StylesContext);
	
	  var context = (0, _extends2.default)({}, outerOptions, {
	    disableGeneration: disableGeneration
	  }, localOptions);
	
	  if (false) {
	    if (typeof window === 'undefined' && !context.sheetsManager) {
	      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
	    }
	  }
	
	  if (false) {
	    if (context.jss.options.insertionPoint && injectFirst) {
	      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
	    }
	  }
	
	  if (false) {
	    if (injectFirst && localOptions.jss) {
	      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
	    }
	  }
	
	  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
	    if (!injectFirstNode) {
	      var head = document.head;
	      injectFirstNode = document.createComment('mui-inject-first');
	      head.insertBefore(injectFirstNode, head.firstChild);
	    }
	
	    context.jss = (0, _jss.create)({
	      plugins: (0, _jssPreset.default)().plugins,
	      insertionPoint: injectFirstNode
	    });
	  }
	
	  return /*#__PURE__*/_react.default.createElement(StylesContext.Provider, {
	    value: context
	  }, children);
	}
	
	 false ? StylesProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
	   */
	  disableGeneration: _propTypes.default.bool,
	
	  /**
	   * JSS's class name generator.
	   */
	  generateClassName: _propTypes.default.func,
	
	  /**
	   * By default, the styles are injected last in the <head> element of the page.
	   * As a result, they gain more specificity than any other style sheet.
	   * If you want to override Material-UI's styles, set this prop.
	   */
	  injectFirst: _propTypes.default.bool,
	
	  /**
	   * JSS's instance.
	   */
	  jss: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  serverGenerateClassName: _propTypes.default.func,
	
	  /**
	   * @ignore
	   *
	   * Beta feature.
	   *
	   * Cache for the sheets.
	   */
	  sheetsCache: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * Collect the sheets.
	   */
	  sheetsRegistry: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = (0, _utils.exactProp)(StylesProvider.propTypes) : void 0;
	}

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(144));
	
	var _utils = __webpack_require__(21);
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(375));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(145));
	
	var _nested = _interopRequireDefault(__webpack_require__(370));
	
	// To support composition of theme.
	function mergeOuterLocalTheme(outerTheme, localTheme) {
	  if (typeof localTheme === 'function') {
	    var mergedTheme = localTheme(outerTheme);
	
	    if (false) {
	      if (!mergedTheme) {
	        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
	      }
	    }
	
	    return mergedTheme;
	  }
	
	  return (0, _extends2.default)({}, outerTheme, localTheme);
	}
	/**
	 * This component takes a `theme` prop.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	
	
	function ThemeProvider(props) {
	  var children = props.children,
	      localTheme = props.theme;
	  var outerTheme = (0, _useTheme.default)();
	
	  if (false) {
	    if (outerTheme === null && typeof localTheme === 'function') {
	      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
	    }
	  }
	
	  var theme = _react.default.useMemo(function () {
	    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
	
	    if (output != null) {
	      output[_nested.default] = outerTheme !== null;
	    }
	
	    return output;
	  }, [localTheme, outerTheme]);
	
	  return /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Provider, {
	    value: theme
	  }, children);
	}
	
	 false ? ThemeProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A theme object. You can provide a function to extend the outer theme.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = (0, _utils.exactProp)(ThemeProvider.propTypes) : void 0;
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(991));

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _nested = _interopRequireDefault(__webpack_require__(370));
	
	/**
	 * This is the list of the style rule name we use as drop in replacement for the built-in
	 * pseudo classes (:checked, :disabled, :focused, etc.).
	 *
	 * Why do they exist in the first place?
	 * These classes are used at a specificity of 2.
	 * It allows them to override previously definied styles as well as
	 * being untouched by simple user overrides.
	 */
	var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$disableGloba = options.disableGlobal,
	      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
	      _options$seed = options.seed,
	      seed = _options$seed === void 0 ? '' : _options$seed;
	  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
	  var ruleCounter = 0;
	
	  var getNextCounterId = function getNextCounterId() {
	    ruleCounter += 1;
	
	    if (false) {
	      if (ruleCounter >= 1e10) {
	        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
	      }
	    }
	
	    return ruleCounter;
	  };
	
	  return function (rule, styleSheet) {
	    var name = styleSheet.options.name; // Is a global static MUI style?
	
	    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
	      // We can use a shorthand class name, we never use the keys to style the components.
	      if (pseudoClasses.indexOf(rule.key) !== -1) {
	        return "Mui-".concat(rule.key);
	      }
	
	      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
	
	      if (!styleSheet.options.theme[_nested.default] || seed !== '') {
	        return prefix;
	      }
	
	      return "".concat(prefix, "-").concat(getNextCounterId());
	    }
	
	    if (true) {
	      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
	    }
	
	    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.
	
	    if (styleSheet.options.classNamePrefix) {
	      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
	    }
	
	    return "".concat(seedPrefix).concat(suffix);
	  };
	}

/***/ },
/* 994 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	
	var _createStyles = _interopRequireDefault(__webpack_require__(994));

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getStylesCreator;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(79));
	
	var _utils = __webpack_require__(21);
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(371));
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	
	  if (false) {
	    if ((0, _typeof2.default)(stylesOrCreator) !== 'object' && !themingEnabled) {
	      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
	    }
	  }
	
	  return {
	    create: function create(theme, name) {
	      var styles;
	
	      try {
	        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	      } catch (err) {
	        if (false) {
	          if (themingEnabled === true && theme === _noopTheme.default) {
	            // TODO: prepend error message/name instead
	            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	          }
	        }
	
	        throw err;
	      }
	
	      if (!name || !theme.overrides || !theme.overrides[name]) {
	        return styles;
	      }
	
	      var overrides = theme.overrides[name];
	      var stylesWithOverrides = (0, _extends2.default)({}, styles);
	      Object.keys(overrides).forEach(function (key) {
	        if (false) {
	          if (!stylesWithOverrides[key]) {
	            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
	          }
	        }
	
	        stylesWithOverrides[key] = (0, _utils.deepmerge)(stylesWithOverrides[key], overrides[key]);
	      });
	      return stylesWithOverrides;
	    },
	    options: {}
	  };
	}

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getStylesCreator.default;
	  }
	});
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(996));

/***/ },
/* 998 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getThemeProps;
	
	/* eslint-disable no-restricted-syntax */
	function getThemeProps(params) {
	  var theme = params.theme,
	      name = params.name,
	      props = params.props;
	
	  if (!theme || !theme.props || !theme.props[name]) {
	    return props;
	  } // Resolve default props, code borrow from React source.
	  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
	
	
	  var defaultProps = theme.props[name];
	  var propName;
	
	  for (propName in defaultProps) {
	    if (props[propName] === undefined) {
	      props[propName] = defaultProps[propName];
	    }
	  }
	
	  return props;
	}

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jssPreset;
	
	var _jssPluginRuleValueFunction = _interopRequireDefault(__webpack_require__(1260));
	
	var _jssPluginGlobal = _interopRequireDefault(__webpack_require__(1257));
	
	var _jssPluginNested = _interopRequireDefault(__webpack_require__(1258));
	
	var _jssPluginCamelCase = _interopRequireDefault(__webpack_require__(1255));
	
	var _jssPluginDefaultUnit = _interopRequireDefault(__webpack_require__(1256));
	
	var _jssPluginVendorPrefixer = _interopRequireDefault(__webpack_require__(1261));
	
	var _jssPluginPropsSort = _interopRequireDefault(__webpack_require__(1259));
	
	// Subset of jss-preset-default with only the plugins the Material-UI components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssPluginRuleValueFunction.default)(), (0, _jssPluginGlobal.default)(), (0, _jssPluginNested.default)(), (0, _jssPluginCamelCase.default)(), (0, _jssPluginDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
	    // This way, we can get a performance boost.
	    // In the documentation, we are using `autoprefixer` to solve this problem.
	    typeof window === 'undefined' ? null : (0, _jssPluginVendorPrefixer.default)(), (0, _jssPluginPropsSort.default)()]
	  };
	}

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.increment = increment;
	
	/* eslint-disable import/prefer-default-export */
	// Global index counter to preserve source order.
	// We create the style sheet during the creation of the component,
	// children are handled after the parents, so the order of style elements would be parent->child.
	// It is a problem though when a parent passes a className
	// which needs to override any child's styles.
	// StyleSheet of the child has a higher specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	var indexCounter = -1e9;
	
	function increment() {
	  indexCounter += 1;
	
	  if (false) {
	    if (indexCounter >= 0) {
	      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
	    }
	  }
	
	  return indexCounter;
	}

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeStyles;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _jss = __webpack_require__(96);
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(374));
	
	var _multiKeyStore = _interopRequireDefault(__webpack_require__(1002));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(145));
	
	var _StylesProvider = __webpack_require__(244);
	
	var _indexCounter = __webpack_require__(1000);
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(997));
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(371));
	
	function getClasses(_ref, classes, Component) {
	  var state = _ref.state,
	      stylesOptions = _ref.stylesOptions;
	
	  if (stylesOptions.disableGeneration) {
	    return classes || {};
	  }
	
	  if (!state.cacheClasses) {
	    state.cacheClasses = {
	      // Cache for the finalized classes value.
	      value: null,
	      // Cache for the last used classes prop pointer.
	      lastProp: null,
	      // Cache for the last used rendered classes pointer.
	      lastJSS: {}
	    };
	  } // Tracks if either the rendered classes or classes prop has changed,
	  // requiring the generation of a new finalized classes object.
	
	
	  var generate = false;
	
	  if (state.classes !== state.cacheClasses.lastJSS) {
	    state.cacheClasses.lastJSS = state.classes;
	    generate = true;
	  }
	
	  if (classes !== state.cacheClasses.lastProp) {
	    state.cacheClasses.lastProp = classes;
	    generate = true;
	  }
	
	  if (generate) {
	    state.cacheClasses.value = (0, _mergeClasses.default)({
	      baseClasses: state.cacheClasses.lastJSS,
	      newClasses: classes,
	      Component: Component
	    });
	  }
	
	  return state.cacheClasses.value;
	}
	
	function attach(_ref2, props) {
	  var state = _ref2.state,
	      theme = _ref2.theme,
	      stylesOptions = _ref2.stylesOptions,
	      stylesCreator = _ref2.stylesCreator,
	      name = _ref2.name;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  if (!sheetManager) {
	    sheetManager = {
	      refs: 0,
	      staticSheet: null,
	      dynamicStyles: null
	    };
	
	    _multiKeyStore.default.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
	  }
	
	  var options = (0, _extends2.default)({}, stylesCreator.options, stylesOptions, {
	    theme: theme,
	    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
	  });
	  options.generateId = options.serverGenerateClassName || options.generateClassName;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    var staticSheet;
	
	    if (stylesOptions.sheetsCache) {
	      staticSheet = _multiKeyStore.default.get(stylesOptions.sheetsCache, stylesCreator, theme);
	    }
	
	    var styles = stylesCreator.create(theme, name);
	
	    if (!staticSheet) {
	      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, _extends2.default)({
	        link: false
	      }, options));
	      staticSheet.attach();
	
	      if (stylesOptions.sheetsCache) {
	        _multiKeyStore.default.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
	      }
	    }
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(staticSheet);
	    }
	
	    sheetManager.staticSheet = staticSheet;
	    sheetManager.dynamicStyles = (0, _jss.getDynamicStyles)(styles);
	  }
	
	  if (sheetManager.dynamicStyles) {
	    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, _extends2.default)({
	      link: true
	    }, options));
	    dynamicSheet.update(props);
	    dynamicSheet.attach();
	    state.dynamicSheet = dynamicSheet;
	    state.classes = (0, _mergeClasses.default)({
	      baseClasses: sheetManager.staticSheet.classes,
	      newClasses: dynamicSheet.classes
	    });
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(dynamicSheet);
	    }
	  } else {
	    state.classes = sheetManager.staticSheet.classes;
	  }
	
	  sheetManager.refs += 1;
	}
	
	function update(_ref3, props) {
	  var state = _ref3.state;
	
	  if (state.dynamicSheet) {
	    state.dynamicSheet.update(props);
	  }
	}
	
	function detach(_ref4) {
	  var state = _ref4.state,
	      theme = _ref4.theme,
	      stylesOptions = _ref4.stylesOptions,
	      stylesCreator = _ref4.stylesCreator;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  sheetManager.refs -= 1;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    _multiKeyStore.default.delete(stylesOptions.sheetsManager, stylesCreator, theme);
	
	    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(sheetManager.staticSheet);
	    }
	  }
	
	  if (state.dynamicSheet) {
	    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(state.dynamicSheet);
	    }
	  }
	}
	
	function useSynchronousEffect(func, values) {
	  var key = _react.default.useRef([]);
	
	  var output; // Store "generation" key. Just returns a new object every time
	
	  var currentKey = _react.default.useMemo(function () {
	    return {};
	  }, values); // eslint-disable-line react-hooks/exhaustive-deps
	  // "the first render", or "memo dropped the value"
	
	
	  if (key.current !== currentKey) {
	    key.current = currentKey;
	    output = func();
	  }
	
	  _react.default.useEffect(function () {
	    return function () {
	      if (output) {
	        output();
	      }
	    };
	  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
	  );
	}
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var name = options.name,
	      classNamePrefixOption = options.classNamePrefix,
	      Component = options.Component,
	      _options$defaultTheme = options.defaultTheme,
	      defaultTheme = _options$defaultTheme === void 0 ? _noopTheme.default : _options$defaultTheme,
	      stylesOptions2 = (0, _objectWithoutProperties2.default)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
	  var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
	  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
	  stylesCreator.options = {
	    index: (0, _indexCounter.increment)(),
	    name: name,
	    meta: classNamePrefix,
	    classNamePrefix: classNamePrefix
	  };
	
	  var useStyles = function useStyles() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var theme = (0, _useTheme.default)() || defaultTheme;
	    var stylesOptions = (0, _extends2.default)({}, _react.default.useContext(_StylesProvider.StylesContext), stylesOptions2);
	
	    var instance = _react.default.useRef();
	
	    var shouldUpdate = _react.default.useRef();
	
	    useSynchronousEffect(function () {
	      var current = {
	        name: name,
	        state: {},
	        stylesCreator: stylesCreator,
	        stylesOptions: stylesOptions,
	        theme: theme
	      };
	      attach(current, props);
	      shouldUpdate.current = false;
	      instance.current = current;
	      return function () {
	        detach(current);
	      };
	    }, [theme, stylesCreator]);
	
	    _react.default.useEffect(function () {
	      if (shouldUpdate.current) {
	        update(instance.current, props);
	      }
	
	      shouldUpdate.current = true;
	    });
	
	    var classes = getClasses(instance.current, props.classes, Component);
	
	    if (false) {
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      _react.default.useDebugValue(classes);
	    }
	
	    return classes;
	  };
	
	  return useStyles;
	}

/***/ },
/* 1002 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// Used https://github.com/thinkloop/multi-key-cache as inspiration
	var multiKeyStore = {
	  set: function set(cache, key1, key2, value) {
	    var subCache = cache.get(key1);
	
	    if (!subCache) {
	      subCache = new Map();
	      cache.set(key1, subCache);
	    }
	
	    subCache.set(key2, value);
	  },
	  get: function get(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    return subCache ? subCache.get(key2) : undefined;
	  },
	  delete: function _delete(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    subCache.delete(key2);
	  }
	};
	var _default = multiKeyStore;
	exports.default = _default;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeClasses;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(21);
	
	function mergeClasses() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var baseClasses = options.baseClasses,
	      newClasses = options.newClasses,
	      Component = options.Component;
	
	  if (!newClasses) {
	    return baseClasses;
	  }
	
	  var nextClasses = (0, _extends2.default)({}, baseClasses);
	
	  if (false) {
	    if (typeof newClasses === 'string') {
	      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
	      return baseClasses;
	    }
	  }
	
	  Object.keys(newClasses).forEach(function (key) {
	    if (false) {
	      if (!baseClasses[key] && newClasses[key]) {
	        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
	      }
	
	      if (newClasses[key] && typeof newClasses[key] !== 'string') {
	        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
	      }
	    }
	
	    if (newClasses[key]) {
	      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
	    }
	  });
	  return nextClasses;
	}

/***/ },
/* 1004 */
[1912, 1005],
/* 1005 */
918,
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	
	var _styled = _interopRequireDefault(__webpack_require__(1007));

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = styled;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _clsx = _interopRequireDefault(__webpack_require__(10));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(144));
	
	var _utils = __webpack_require__(21);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(82));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(246));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	} // styled-components's API removes the mapping between components and styles.
	// Using components as a low-level styling construct can be simpler.
	
	
	function styled(Component) {
	  var componentCreator = function componentCreator(style) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["name"]);
	
	    if (false) {
	      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var stylesOrCreator = typeof style === 'function' ? function (theme) {
	      return {
	        root: function root(props) {
	          return style((0, _extends2.default)({
	            theme: theme
	          }, props));
	        }
	      };
	    } : {
	      root: style
	    };
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	    var filterProps;
	    var propTypes = {};
	
	    if (style.filterProps) {
	      filterProps = style.filterProps;
	      delete style.filterProps;
	    }
	    /* eslint-disable react/forbid-foreign-prop-types */
	
	
	    if (style.propTypes) {
	      propTypes = style.propTypes;
	      delete style.propTypes;
	    }
	    /* eslint-enable react/forbid-foreign-prop-types */
	
	
	    var StyledComponent = /*#__PURE__*/_react.default.forwardRef(function StyledComponent(props, ref) {
	      var children = props.children,
	          classNameProp = props.className,
	          clone = props.clone,
	          ComponentProp = props.component,
	          other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "clone", "component"]);
	      var classes = useStyles(props);
	      var className = (0, _clsx.default)(classes.root, classNameProp);
	      var spread = other;
	
	      if (filterProps) {
	        spread = omit(spread, filterProps);
	      }
	
	      if (clone) {
	        return /*#__PURE__*/_react.default.cloneElement(children, (0, _extends2.default)({
	          className: (0, _clsx.default)(children.props.className, className)
	        }, spread));
	      }
	
	      if (typeof children === 'function') {
	        return children((0, _extends2.default)({
	          className: className
	        }, spread));
	      }
	
	      var FinalComponent = ComponentProp || Component;
	      return /*#__PURE__*/_react.default.createElement(FinalComponent, (0, _extends2.default)({
	        ref: ref,
	        className: className
	      }, spread), children);
	    });
	
	     false ? StyledComponent.propTypes = (0, _extends2.default)({
	      /**
	       * A render function or node.
	       */
	      children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	      /**
	       * @ignore
	       */
	      className: _propTypes.default.string,
	
	      /**
	       * If `true`, the component will recycle it's children HTML element.
	       * It's using `React.cloneElement` internally.
	       *
	       * This prop will be deprecated and removed in v5
	       */
	      clone: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	        if (props.clone && props.component) {
	          return new Error('You can not use the clone and component prop at the same time.');
	        }
	
	        return null;
	      }),
	
	      /**
	       * The component used for the root node.
	       * Either a string to use a HTML element or a component.
	       */
	      component: _propTypes.default
	      /* @typescript-to-proptypes-ignore */
	      .elementType
	    }, propTypes) : void 0;
	
	    if (false) {
	      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(StyledComponent, Component);
	    return StyledComponent;
	  };
	
	  return componentCreator;
	}

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(375));
	
	function useTheme() {
	  var theme = _react.default.useContext(_ThemeContext.default);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	
	var _withStyles = _interopRequireDefault(__webpack_require__(1010));

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(144));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(82));
	
	var _utils = __webpack_require__(21);
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(246));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(372));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(145));
	
	// Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var defaultTheme = options.defaultTheme,
	        _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
	        name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["defaultTheme", "withTheme", "name"]);
	
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      defaultTheme: defaultTheme,
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	
	    var WithStyles = /*#__PURE__*/_react.default.forwardRef(function WithStyles(props, ref) {
	      var classesProp = props.classes,
	          innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
	      // the actual props Component might receive due to merging with defaultProps.
	      // So copying it here would give us the same result in the wrapper as well.
	
	      var classes = useStyles((0, _extends2.default)({}, Component.defaultProps, props));
	      var theme;
	      var more = other;
	
	      if (typeof name === 'string' || withTheme) {
	        // name and withTheme are invariant in the outer scope
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        theme = (0, _useTheme.default)() || defaultTheme;
	
	        if (name) {
	          more = (0, _getThemeProps.default)({
	            theme: theme,
	            name: name,
	            props: other
	          });
	        } // Provide the theme to the wrapped component.
	        // So we don't have to use the `withTheme()` Higher-order Component.
	
	
	        if (withTheme && !more.theme) {
	          more.theme = theme;
	        }
	      }
	
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        ref: innerRef || ref,
	        classes: classes
	      }, more));
	    });
	
	     false ? WithStyles.propTypes = {
	      /**
	       * Override or extend the styles applied to the component.
	       */
	      classes: _propTypes.default.object,
	
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return null; // return new Error(
	        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
	        //     'Refs are now automatically forwarded to the inner component.',
	        // );
	      })
	    } : void 0;
	
	    if (false) {
	      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	      WithStyles.useStyles = useStyles;
	    }
	
	    return WithStyles;
	  };
	};
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(1012));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withThemeCreator = withThemeCreator;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(144));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(82));
	
	var _utils = __webpack_require__(21);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(145));
	
	function withThemeCreator() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultTheme = options.defaultTheme;
	
	  var withTheme = function withTheme(Component) {
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var WithTheme = /*#__PURE__*/_react.default.forwardRef(function WithTheme(props, ref) {
	      var innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["innerRef"]);
	      var theme = (0, _useTheme.default)() || defaultTheme;
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        theme: theme,
	        ref: innerRef || ref
	      }, other));
	    });
	
	     false ? WithTheme.propTypes = {
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
	      })
	    } : void 0;
	
	    if (false) {
	      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	
	  return withTheme;
	} // Provide the theme object as a prop to the input component.
	// It's an alternative API to useTheme().
	// We encourage the usage of useTheme() where possible.
	
	
	var withTheme = withThemeCreator();
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.borderRadius = exports.borderColor = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	function getBorder(value) {
	  if (typeof value !== 'number') {
	    return value;
	  }
	
	  return "".concat(value, "px solid");
	}
	
	var border = (0, _style.default)({
	  prop: 'border',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.border = border;
	var borderTop = (0, _style.default)({
	  prop: 'borderTop',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderTop = borderTop;
	var borderRight = (0, _style.default)({
	  prop: 'borderRight',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderRight = borderRight;
	var borderBottom = (0, _style.default)({
	  prop: 'borderBottom',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderBottom = borderBottom;
	var borderLeft = (0, _style.default)({
	  prop: 'borderLeft',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderLeft = borderLeft;
	var borderColor = (0, _style.default)({
	  prop: 'borderColor',
	  themeKey: 'palette'
	});
	exports.borderColor = borderColor;
	var borderRadius = (0, _style.default)({
	  prop: 'borderRadius',
	  themeKey: 'shape'
	});
	exports.borderRadius = borderRadius;
	var borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
	var _default = borders;
	exports.default = _default;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(51));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(248));
	
	var _merge = _interopRequireDefault(__webpack_require__(173));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	}
	
	function css(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var output = styleFunction(props);
	
	    if (props.css) {
	      return (0, _extends2.default)({}, (0, _merge.default)(output, styleFunction((0, _extends2.default)({
	        theme: props.theme
	      }, props.css))), omit(props.css, [styleFunction.filterProps]));
	    }
	
	    return output;
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    css: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['css'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = css;
	exports.default = _default;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.whiteSpace = exports.visibility = exports.textOverflow = exports.overflow = exports.displayRaw = exports.displayPrint = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	var displayPrint = (0, _style.default)({
	  prop: 'displayPrint',
	  cssProperty: false,
	  transform: function transform(value) {
	    return {
	      '@media print': {
	        display: value
	      }
	    };
	  }
	});
	exports.displayPrint = displayPrint;
	var displayRaw = (0, _style.default)({
	  prop: 'display'
	});
	exports.displayRaw = displayRaw;
	var overflow = (0, _style.default)({
	  prop: 'overflow'
	});
	exports.overflow = overflow;
	var textOverflow = (0, _style.default)({
	  prop: 'textOverflow'
	});
	exports.textOverflow = textOverflow;
	var visibility = (0, _style.default)({
	  prop: 'visibility'
	});
	exports.visibility = visibility;
	var whiteSpace = (0, _style.default)({
	  prop: 'whiteSpace'
	});
	exports.whiteSpace = whiteSpace;
	
	var _default = (0, _compose.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);
	
	exports.default = _default;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.justifySelf = exports.justifyItems = exports.alignSelf = exports.flexShrink = exports.flexGrow = exports.flex = exports.order = exports.alignContent = exports.alignItems = exports.justifyContent = exports.flexWrap = exports.flexDirection = exports.flexBasis = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	var flexBasis = (0, _style.default)({
	  prop: 'flexBasis'
	});
	exports.flexBasis = flexBasis;
	var flexDirection = (0, _style.default)({
	  prop: 'flexDirection'
	});
	exports.flexDirection = flexDirection;
	var flexWrap = (0, _style.default)({
	  prop: 'flexWrap'
	});
	exports.flexWrap = flexWrap;
	var justifyContent = (0, _style.default)({
	  prop: 'justifyContent'
	});
	exports.justifyContent = justifyContent;
	var alignItems = (0, _style.default)({
	  prop: 'alignItems'
	});
	exports.alignItems = alignItems;
	var alignContent = (0, _style.default)({
	  prop: 'alignContent'
	});
	exports.alignContent = alignContent;
	var order = (0, _style.default)({
	  prop: 'order'
	});
	exports.order = order;
	var flex = (0, _style.default)({
	  prop: 'flex'
	});
	exports.flex = flex;
	var flexGrow = (0, _style.default)({
	  prop: 'flexGrow'
	});
	exports.flexGrow = flexGrow;
	var flexShrink = (0, _style.default)({
	  prop: 'flexShrink'
	});
	exports.flexShrink = flexShrink;
	var alignSelf = (0, _style.default)({
	  prop: 'alignSelf'
	});
	exports.alignSelf = alignSelf;
	var justifyItems = (0, _style.default)({
	  prop: 'justifyItems'
	});
	exports.justifyItems = justifyItems;
	var justifySelf = (0, _style.default)({
	  prop: 'justifySelf'
	});
	exports.justifySelf = justifySelf;
	var flexbox = (0, _compose.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
	var _default = flexbox;
	exports.default = _default;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.gridArea = exports.gridTemplateAreas = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	var gridGap = (0, _style.default)({
	  prop: 'gridGap'
	});
	exports.gridGap = gridGap;
	var gridColumnGap = (0, _style.default)({
	  prop: 'gridColumnGap'
	});
	exports.gridColumnGap = gridColumnGap;
	var gridRowGap = (0, _style.default)({
	  prop: 'gridRowGap'
	});
	exports.gridRowGap = gridRowGap;
	var gridColumn = (0, _style.default)({
	  prop: 'gridColumn'
	});
	exports.gridColumn = gridColumn;
	var gridRow = (0, _style.default)({
	  prop: 'gridRow'
	});
	exports.gridRow = gridRow;
	var gridAutoFlow = (0, _style.default)({
	  prop: 'gridAutoFlow'
	});
	exports.gridAutoFlow = gridAutoFlow;
	var gridAutoColumns = (0, _style.default)({
	  prop: 'gridAutoColumns'
	});
	exports.gridAutoColumns = gridAutoColumns;
	var gridAutoRows = (0, _style.default)({
	  prop: 'gridAutoRows'
	});
	exports.gridAutoRows = gridAutoRows;
	var gridTemplateColumns = (0, _style.default)({
	  prop: 'gridTemplateColumns'
	});
	exports.gridTemplateColumns = gridTemplateColumns;
	var gridTemplateRows = (0, _style.default)({
	  prop: 'gridTemplateRows'
	});
	exports.gridTemplateRows = gridTemplateRows;
	var gridTemplateAreas = (0, _style.default)({
	  prop: 'gridTemplateAreas'
	});
	exports.gridTemplateAreas = gridTemplateAreas;
	var gridArea = (0, _style.default)({
	  prop: 'gridArea'
	});
	exports.gridArea = gridArea;
	var grid = (0, _compose.default)(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
	var _default = grid;
	exports.default = _default;

/***/ },
/* 1018 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = memoize;
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) {
	      cache[arg] = fn(arg);
	    }
	
	    return cache[arg];
	  };
	}

/***/ },
/* 1019 */
[1912, 1020],
/* 1020 */
918,
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.bgcolor = exports.color = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	var color = (0, _style.default)({
	  prop: 'color',
	  themeKey: 'palette'
	});
	exports.color = color;
	var bgcolor = (0, _style.default)({
	  prop: 'bgcolor',
	  cssProperty: 'backgroundColor',
	  themeKey: 'palette'
	});
	exports.bgcolor = bgcolor;
	var palette = (0, _compose.default)(color, bgcolor);
	var _default = palette;
	exports.default = _default;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	var position = (0, _style.default)({
	  prop: 'position'
	});
	exports.position = position;
	var zIndex = (0, _style.default)({
	  prop: 'zIndex',
	  themeKey: 'zIndex'
	});
	exports.zIndex = zIndex;
	var top = (0, _style.default)({
	  prop: 'top'
	});
	exports.top = top;
	var right = (0, _style.default)({
	  prop: 'right'
	});
	exports.right = right;
	var bottom = (0, _style.default)({
	  prop: 'bottom'
	});
	exports.bottom = bottom;
	var left = (0, _style.default)({
	  prop: 'left'
	});
	exports.left = left;
	
	var _default = (0, _compose.default)(position, zIndex, top, right, bottom, left);
	
	exports.default = _default;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var boxShadow = (0, _style.default)({
	  prop: 'boxShadow',
	  themeKey: 'shadows'
	});
	var _default = boxShadow;
	exports.default = _default;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.boxSizing = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.width = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	function transform(value) {
	  return value <= 1 ? "".concat(value * 100, "%") : value;
	}
	
	var width = (0, _style.default)({
	  prop: 'width',
	  transform: transform
	});
	exports.width = width;
	var maxWidth = (0, _style.default)({
	  prop: 'maxWidth',
	  transform: transform
	});
	exports.maxWidth = maxWidth;
	var minWidth = (0, _style.default)({
	  prop: 'minWidth',
	  transform: transform
	});
	exports.minWidth = minWidth;
	var height = (0, _style.default)({
	  prop: 'height',
	  transform: transform
	});
	exports.height = height;
	var maxHeight = (0, _style.default)({
	  prop: 'maxHeight',
	  transform: transform
	});
	exports.maxHeight = maxHeight;
	var minHeight = (0, _style.default)({
	  prop: 'minHeight',
	  transform: transform
	});
	exports.minHeight = minHeight;
	var sizeWidth = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'width',
	  transform: transform
	});
	exports.sizeWidth = sizeWidth;
	var sizeHeight = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'height',
	  transform: transform
	});
	exports.sizeHeight = sizeHeight;
	var boxSizing = (0, _style.default)({
	  prop: 'boxSizing'
	});
	exports.boxSizing = boxSizing;
	var sizing = (0, _compose.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
	var _default = sizing;
	exports.default = _default;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createUnarySpacing = createUnarySpacing;
	exports.default = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(69));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(377));
	
	var _breakpoints = __webpack_require__(247);
	
	var _merge = _interopRequireDefault(__webpack_require__(173));
	
	var _memoize = _interopRequireDefault(__webpack_require__(1018));
	
	var properties = {
	  m: 'margin',
	  p: 'padding'
	};
	var directions = {
	  t: 'Top',
	  r: 'Right',
	  b: 'Bottom',
	  l: 'Left',
	  x: ['Left', 'Right'],
	  y: ['Top', 'Bottom']
	};
	var aliases = {
	  marginX: 'mx',
	  marginY: 'my',
	  paddingX: 'px',
	  paddingY: 'py'
	}; // memoize() impact:
	// From 300,000 ops/sec
	// To 350,000 ops/sec
	
	var getCssProperties = (0, _memoize.default)(function (prop) {
	  // It's not a shorthand notation.
	  if (prop.length > 2) {
	    if (aliases[prop]) {
	      prop = aliases[prop];
	    } else {
	      return [prop];
	    }
	  }
	
	  var _prop$split = prop.split(''),
	      _prop$split2 = (0, _slicedToArray2.default)(_prop$split, 2),
	      a = _prop$split2[0],
	      b = _prop$split2[1];
	
	  var property = properties[a];
	  var direction = directions[b] || '';
	  return Array.isArray(direction) ? direction.map(function (dir) {
	    return property + dir;
	  }) : [property + direction];
	});
	var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
	
	function createUnarySpacing(theme) {
	  var themeSpacing = theme.spacing || 8;
	
	  if (typeof themeSpacing === 'number') {
	    return function (abs) {
	      if (false) {
	        if (typeof abs !== 'number') {
	          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
	        }
	      }
	
	      return themeSpacing * abs;
	    };
	  }
	
	  if (Array.isArray(themeSpacing)) {
	    return function (abs) {
	      if (false) {
	        if (abs > themeSpacing.length - 1) {
	          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
	        }
	      }
	
	      return themeSpacing[abs];
	    };
	  }
	
	  if (typeof themeSpacing === 'function') {
	    return themeSpacing;
	  }
	
	  if (false) {
	    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
	  }
	
	  return function () {
	    return undefined;
	  };
	}
	
	function getValue(transformer, propValue) {
	  if (typeof propValue === 'string') {
	    return propValue;
	  }
	
	  var abs = Math.abs(propValue);
	  var transformed = transformer(abs);
	
	  if (propValue >= 0) {
	    return transformed;
	  }
	
	  if (typeof transformed === 'number') {
	    return -transformed;
	  }
	
	  return "-".concat(transformed);
	}
	
	function getStyleFromPropValue(cssProperties, transformer) {
	  return function (propValue) {
	    return cssProperties.reduce(function (acc, cssProperty) {
	      acc[cssProperty] = getValue(transformer, propValue);
	      return acc;
	    }, {});
	  };
	}
	
	function spacing(props) {
	  var theme = props.theme;
	  var transformer = createUnarySpacing(theme);
	  return Object.keys(props).map(function (prop) {
	    // Using a hash computation over an array iteration could be faster, but with only 28 items,
	    // it's doesn't worth the bundle size.
	    if (spacingKeys.indexOf(prop) === -1) {
	      return null;
	    }
	
	    var cssProperties = getCssProperties(prop);
	    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
	    var propValue = props[prop];
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  }).reduce(_merge.default, {});
	}
	
	spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
	  obj[key] = _responsivePropType.default;
	  return obj;
	}, {}) : {};
	spacing.filterProps = spacingKeys;
	var _default = spacing;
	exports.default = _default;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.textAlign = exports.lineHeight = exports.letterSpacing = exports.fontWeight = exports.fontStyle = exports.fontSize = exports.fontFamily = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(63));
	
	var _compose = _interopRequireDefault(__webpack_require__(73));
	
	var fontFamily = (0, _style.default)({
	  prop: 'fontFamily',
	  themeKey: 'typography'
	});
	exports.fontFamily = fontFamily;
	var fontSize = (0, _style.default)({
	  prop: 'fontSize',
	  themeKey: 'typography'
	});
	exports.fontSize = fontSize;
	var fontStyle = (0, _style.default)({
	  prop: 'fontStyle',
	  themeKey: 'typography'
	});
	exports.fontStyle = fontStyle;
	var fontWeight = (0, _style.default)({
	  prop: 'fontWeight',
	  themeKey: 'typography'
	});
	exports.fontWeight = fontWeight;
	var letterSpacing = (0, _style.default)({
	  prop: 'letterSpacing'
	});
	exports.letterSpacing = letterSpacing;
	var lineHeight = (0, _style.default)({
	  prop: 'lineHeight'
	});
	exports.lineHeight = lineHeight;
	var textAlign = (0, _style.default)({
	  prop: 'textAlign'
	});
	exports.textAlign = textAlign;
	var typography = (0, _compose.default)(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
	var _default = typography;
	exports.default = _default;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HTMLElementType;
	
	function HTMLElementType(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  if (propValue && propValue.nodeType !== 1) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
	  }
	
	  return null;
	}

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPlainObject = isPlainObject;
	exports.default = deepmerge;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(79));
	
	function isPlainObject(item) {
	  return item && (0, _typeof2.default)(item) === 'object' && item.constructor === Object;
	}
	
	function deepmerge(target, source) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    clone: true
	  };
	  var output = options.clone ? (0, _extends2.default)({}, target) : target;
	
	  if (isPlainObject(target) && isPlainObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      // Avoid prototype pollution
	      if (key === '__proto__') {
	        return;
	      }
	
	      if (isPlainObject(source[key]) && key in target) {
	        output[key] = deepmerge(target[key], source[key], options);
	      } else {
	        output[key] = source[key];
	      }
	    });
	  }
	
	  return output;
	}

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(250));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(249));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function acceptingRef(props, propName, componentName, location, propFullName) {
	  var element = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (element == null) {
	    return null;
	  }
	
	  var warningHint;
	  var elementType = element.type;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
	    warningHint = 'Did you accidentally use a plain function component for an element instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var elementAcceptingRef = (0, _chainPropTypes.default)(_propTypes.default.element, acceptingRef);
	elementAcceptingRef.isRequired = (0, _chainPropTypes.default)(_propTypes.default.element.isRequired, acceptingRef);
	var _default = elementAcceptingRef;
	exports.default = _default;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(250));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(249));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  var warningHint;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
	    warningHint = 'Did you accidentally provide a plain function component instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var _default = (0, _chainPropTypes.default)(PropTypes.elementType, elementTypeAcceptingRef);
	
	exports.default = _default;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exactProp;
	exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}

/***/ },
/* 1032 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatMuiErrorMessage;
	
	/**
	 * WARNING: Don't import this directly.
	 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
	 * @param {number} code
	 */
	function formatMuiErrorMessage(code) {
	  // Apply babel-plugin-transform-template-literals in loose mode
	  // loose mode is safe iff we're concatenating primitives
	  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
	
	  /* eslint-disable prefer-template */
	  var url = 'https://material-ui.com/production-error/?code=' + code;
	
	  for (var i = 1; i < arguments.length; i += 1) {
	    // rest params over-transpile for this case
	    // eslint-disable-next-line prefer-rest-params
	    url += '&args[]=' + encodeURIComponent(arguments[i]);
	  }
	
	  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
	  /* eslint-enable prefer-template */
	}

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFunctionName = getFunctionName;
	exports.default = getDisplayName;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(79));
	
	var _reactIs = __webpack_require__(48);
	
	// Simplified polyfill for IE 11 support
	// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
	var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
	
	function getFunctionName(fn) {
	  var match = "".concat(fn).match(fnNameMatchRegex);
	  var name = match && match[1];
	  return name || '';
	}
	/**
	 * @param {function} Component
	 * @param {string} fallback
	 * @returns {string | undefined}
	 */
	
	
	function getFunctionComponentName(Component) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
	}
	
	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = getFunctionComponentName(innerType);
	  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
	}
	/**
	 * cherry-pick from
	 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
	 * originally forked from recompose/getDisplayName with added IE 11 support
	 *
	 * @param {React.ReactType} Component
	 * @returns {string | undefined}
	 */
	
	
	function getDisplayName(Component) {
	  if (Component == null) {
	    return undefined;
	  }
	
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (typeof Component === 'function') {
	    return getFunctionComponentName(Component, 'Component');
	  }
	
	  if ((0, _typeof2.default)(Component) === 'object') {
	    switch (Component.$$typeof) {
	      case _reactIs.ForwardRef:
	        return getWrappedName(Component, Component.render, 'ForwardRef');
	
	      case _reactIs.Memo:
	        return getWrappedName(Component, Component.type, 'memo');
	
	      default:
	        return undefined;
	    }
	  }
	
	  return undefined;
	}

/***/ },
/* 1034 */
[1912, 1035],
/* 1035 */
918,
/* 1036 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	exports.default = _default;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(250));
	
	var refType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]);
	
	var _default = refType;
	exports.default = _default;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var AddGroupIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19.982 9.85l.001-.096a5.587 5.587 0 00-10.21-3.138 4.5 4.5 0 00-5.757 6.733c-1.136.28-2.03.728-2.688 1.325A11.011 11.011 0 011 12C1 5.928 5.928 1 12 1c5.987 0 10.863 4.792 10.997 10.747a7.252 7.252 0 00-3.015-1.897z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M6.597 15.012c-.86.992-1.283 2.256-1.283 3.757v1.964a11.055 11.055 0 01-3.162-3.829c.443-.972 1.623-1.78 4.445-1.892zm2.36-6.543a5.603 5.603 0 00.402 3.703 2.5 2.5 0 11-.4-3.703z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10.665 15.206a7.278 7.278 0 00-.165 1.544 7.244 7.244 0 003.328 6.099 11.06 11.06 0 01-6.423-.853v-3.14c0-1.44.586-2.953 3.26-3.65zm1.35-2.893a3.496 3.496 0 115.867-2.812L17.75 9.5a7.238 7.238 0 00-5.734 2.813zM17.75 22a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm1-6.188v-2.437h-2v2.438h-2.438v2h2.438v2.437h2v-2.438h2.438v-2H18.75z"
	  })));
	});
	AddGroupIcon.category = 'Profile';
	var _default = AddGroupIcon;
	exports["default"] = _default;

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var AddUserIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M22.998 11.81a7.23 7.23 0 00-5.248-2.248c-.856 0-1.678.149-2.44.422a5.343 5.343 0 10-9.621 2.55c-2.08.614-3.403 1.74-4.002 3.299A10.968 10.968 0 011 12C1 5.928 5.928 1 12 1c6.009 0 10.897 4.826 10.998 10.81z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M13.751 22.861c-.57.092-1.155.139-1.751.139-3.53 0-6.673-1.665-8.686-4.253v-.664c0-1.868 1.031-3.866 6.686-3.866.34 0 .663.007.97.02-.304.8-.47 1.669-.47 2.575a7.243 7.243 0 003.251 6.05zM10 12.721a3.343 3.343 0 110-6.686 3.343 3.343 0 010 6.686zM17.75 22a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm1-6.188v-2.437h-2v2.438h-2.438v2h2.438v2.437h2v-2.438h2.438v-2H18.75z"
	  })));
	});
	AddUserIcon.category = 'Profile';
	var _default = AddUserIcon;
	exports["default"] = _default;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var AlarmIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8.019 19h8a4 4 0 01-8 0z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12 1c2.869 0 5.301 1.986 5.707 4.659l1.069 7.048c.137.905.804 1.662 1.724 1.956l.144.047c.811.26 1.356.976 1.356 1.782V17H2v-.517c0-.812.552-1.531 1.37-1.787l.13-.04c.92-.288 1.586-1.04 1.723-1.942l1.07-7.055C6.7 2.986 9.131 1 12 1z"
	  })));
	});
	AlarmIcon.category = 'Notification';
	var _default = AlarmIcon;
	exports["default"] = _default;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ApplicationMenuIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M16.75 16.75h4.75v4.75h-4.75v-4.75zM9.5 9.5h4.75v4.75H9.5V9.5zm-7 0h4.75v4.75H2.5V9.5zm0-7h4.75v4.75H2.5V2.5z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M9.5 16.75h4.75v4.75H9.5v-4.75zm7.25-7.25h4.75v4.75h-4.75V9.5zM2.5 16.75h4.75v4.75H2.5v-4.75zM16.75 2.5h4.75v4.75h-4.75V2.5zm-7.25 0h4.75v4.75H9.5V2.5z",
	    opacity: ".8"
	  })));
	});
	ApplicationMenuIcon.category = 'Navigation';
	var _default = ApplicationMenuIcon;
	exports["default"] = _default;

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var AreachartIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M2 19a1 1 0 000 2h20a1 1 0 000-2H2z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M20 5l2 12H2l1-8 7.182 5.694z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12 1.996L22 17H2z",
	    opacity: ".6"
	  })));
	});
	AreachartIcon.category = 'Graph';
	var _default = AreachartIcon;
	exports["default"] = _default;

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ArrowCloseIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M12.023 7.044l7.109 6.88c.49.475.49 1.245 0 1.72a1.286 1.286 0 01-1.777 0l-5.378-5.204-5.332 5.16a1.286 1.286 0 01-1.777 0 1.189 1.189 0 010-1.72L11.977 7l.046.044z"
	  }));
	});
	ArrowCloseIcon.category = 'Navigation';
	var _default = ArrowCloseIcon;
	exports["default"] = _default;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ArrowFirstIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M9.565 12.018l7.353-7.35a1 1 0 011.707.707v13.207a1 1 0 01-1.703.711l-7.357-7.275zm-2.75-7.62c.69 0 1.25.56 1.25 1.25v12.813a1.25 1.25 0 01-2.5 0V5.65c0-.69.56-1.25 1.25-1.25z"
	  }));
	});
	ArrowFirstIcon.category = 'Navigation';
	var _default = ArrowFirstIcon;
	exports["default"] = _default;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ArrowLastIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M14.435 12.018l-7.357 7.275a1 1 0 01-1.703-.71V5.374a1 1 0 011.707-.707l7.353 7.35zm2.75-7.62c.69 0 1.25.56 1.25 1.25v12.813a1.25 1.25 0 01-2.5 0V5.65c0-.69.56-1.25 1.25-1.25z"
	  }));
	});
	ArrowLastIcon.category = 'Navigation';
	var _default = ArrowLastIcon;
	exports["default"] = _default;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ArrowNextFilledIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M16.5 11.961l-7.304 7.25a.998.998 0 01-1.405 0 .983.983 0 01-.291-.697V5.486a.99.99 0 01.993-.986c.262 0 .513.102.699.285l7.308 7.176z"
	  }));
	});
	ArrowNextFilledIcon.category = 'Navigation';
	var _default = ArrowNextFilledIcon;
	exports["default"] = _default;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ArrowNextIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M16.956 12.023l-6.88 7.109c-.475.49-1.245.49-1.72 0a1.286 1.286 0 010-1.777l5.204-5.378L8.4 6.645a1.286 1.286 0 010-1.777 1.189 1.189 0 011.72 0L17 11.977l-.044.046z"
	  }));
	});
	ArrowNextIcon.category = 'Navigation';
	var _default = ArrowNextIcon;
	exports["default"] = _default;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ArrowOpenIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M12.023 16.956l-.046.044-7.109-6.88a1.189 1.189 0 010-1.72 1.286 1.286 0 011.777 0l5.332 5.16 5.378-5.204a1.286 1.286 0 011.777 0c.49.475.49 1.245 0 1.72l-7.109 6.88z"
	  }));
	});
	ArrowOpenIcon.category = 'Navigation';
	var _default = ArrowOpenIcon;
	exports["default"] = _default;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ArrowPrevFilledIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M7.5 11.961l7.308-7.176a.997.997 0 01.699-.285.99.99 0 01.993.986v13.028a.983.983 0 01-.29.697.998.998 0 01-1.406 0L7.5 11.961z"
	  }));
	});
	ArrowPrevFilledIcon.category = 'Navigation';
	var _default = ArrowPrevFilledIcon;
	exports["default"] = _default;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ArrowPrevIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M7.044 12.023L7 11.977l6.88-7.109a1.189 1.189 0 011.72 0c.474.49.474 1.287 0 1.777l-5.16 5.332 5.204 5.378c.475.49.475 1.286 0 1.777-.475.49-1.245.49-1.72 0l-6.88-7.109z"
	  }));
	});
	ArrowPrevIcon.category = 'Navigation';
	var _default = ArrowPrevIcon;
	exports["default"] = _default;

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var BackIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M6.827 13l4.634 4.635a1 1 0 11-1.414 1.414l-7.07-7.071.002-.003-.003-.003 7.071-7.071a1 1 0 011.414 1.414L6.777 11h14.25v2h-14.2z"
	  }));
	});
	BackIcon.category = 'Navigation';
	var _default = BackIcon;
	exports["default"] = _default;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var BarGraphIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M16 3h4v14h-4V3zM2 19h20a1 1 0 010 2H2a1 1 0 010-2z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10 7h4v10h-4z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M4 11h4v6H4z",
	    opacity: ".6"
	  })));
	});
	BarGraphIcon.category = 'Graph';
	var _default = BarGraphIcon;
	exports["default"] = _default;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CalendarIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M18 4h3a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2h3V2h3v2h6V2h3v2zM3 8v12h18V8H3z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M15.5 15h3v3h-3v-3zm-5 0h3v3h-3v-3zm-5 0h3v3h-3v-3zm10-5h3v3h-3v-3zm-5 0h3v3h-3v-3z",
	    opacity: ".8"
	  })));
	});
	CalendarIcon.category = 'Time';
	var _default = CalendarIcon;
	exports["default"] = _default;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CellTowerIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M6.545 17.159a9 9 0 1110.862.037l-.968-1.783a7 7 0 10-8.927-.04c-.31.567-.633 1.162-.967 1.786z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8.507 13.578a5 5 0 116.95.034c-.429-.784-.77-1.403-1.024-1.856a3 3 0 10-4.874-.012c-.33.563-.68 1.174-1.052 1.834z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M15.888 23.058a4.002 4.002 0 00-7.776 0H6l5.078-10.03h1.914L18 23.058h-2.112zM12 11.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
	  })));
	});
	CellTowerIcon.category = 'Network';
	var _default = CellTowerIcon;
	exports["default"] = _default;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ChatIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8.523 4.726C9.729 2.799 12 1.5 14.603 1.5c3.866 0 7 2.865 7 6.4 0 .926-.216 1.806-.603 2.6l1.235 2.783a.636.636 0 01.006.505.571.571 0 01-.778.298l-1.866-.894c.004-.097.006-.195.006-.293 0-4.68-4.068-8.399-9-8.399-.715 0-1.412.078-2.08.226z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M2.789 17.966a7.016 7.016 0 01-1.385-4.17c0-4.139 3.67-7.495 8.199-7.495 4.528 0 8.198 3.356 8.198 7.496 0 4.14-3.67 7.495-8.198 7.495a8.78 8.78 0 01-3.842-.872l-2.467 2.115a.669.669 0 01-.97-.1.745.745 0 01-.147-.574l.612-3.895z"
	  })));
	});
	ChatIcon.category = 'Communication';
	var _default = ChatIcon;
	exports["default"] = _default;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CheckmarkIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M10.14 18.412l-.014.014L3.771 12a1.734 1.734 0 01.007-2.445c.67-.67 1.756-.67 2.425 0l.007.007 3.895 3.937 7.486-7.486a1.75 1.75 0 112.475 2.474l-9.925 9.925z"
	  }));
	});
	CheckmarkIcon.category = 'Content';
	var _default = CheckmarkIcon;
	exports["default"] = _default;

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ClockIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M13.25 11.763l2.459 2.546a1.25 1.25 0 01-.031 1.768c-.5.482-1.293.476-1.786-.013L10.75 12.94V7.25a1.25 1.25 0 012.5 0v4.513zM11.991 1C18.071 1 23 5.926 23 12s-4.93 11-11.009 11C5.92 23 1 18.074 1 12S5.92 1 11.991 1zm0 2.5C7.3 3.5 3.5 7.308 3.5 12s3.8 8.5 8.492 8.5c4.7 0 8.508-3.808 8.508-8.5s-3.808-8.5-8.508-8.5z"
	  }));
	});
	ClockIcon.category = 'Time';
	var _default = ClockIcon;
	exports["default"] = _default;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CloseCircleIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M13.648 11.689l3.747-3.747a1.104 1.104 0 10-1.561-1.56l-3.747 3.746-3.746-3.746a1.104 1.104 0 10-1.56 1.56l3.746 3.747-3.747 3.746a1.104 1.104 0 101.561 1.56l3.746-3.745 3.747 3.746a1.104 1.104 0 101.56-1.561l-3.746-3.746zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
	  }));
	});
	CloseCircleIcon.category = 'Content';
	var _default = CloseCircleIcon;
	exports["default"] = _default;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CloseDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M18.364 16.243a1.5 1.5 0 11-2.121 2.121L12 14.121l-4.243 4.243a1.5 1.5 0 11-2.121-2.121L9.879 12 5.636 7.757a1.5 1.5 0 112.121-2.121L12 9.879l4.243-4.243a1.5 1.5 0 112.121 2.121L14.121 12l4.243 4.243z"
	  }));
	});
	CloseDefaultIcon.category = 'Content';
	var _default = CloseDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CloudDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M11 5c3.195 0 5.89 2.14 6.73 5.066A4.5 4.5 0 1118.5 19h-4.258a4.5 4.5 0 00-4.039-6.99A6.002 6.002 0 004.67 9.009 7 7 0 0111 5z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10.5 19a2.5 2.5 0 10-1.528-4.479A4 4 0 105 19h5.5z"
	  })));
	});
	CloudDefaultIcon.category = 'File';
	var _default = CloudDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CloudDownloadIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M9 19l2.48-2.474a2.937 2.937 0 00-2.31-5.003v-6.24a7.003 7.003 0 018.705 4.783 4.5 4.5 0 11.77 8.934H9.002z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M5.174 15.363V6a1 1 0 012 0v9.361l1.57-1.572a.937.937 0 111.324 1.324l-2.576 2.57L6.172 19l-3.897-3.887A.936.936 0 113.6 13.788l1.574 1.575z"
	  })));
	});
	CloudDownloadIcon.category = 'File';
	var _default = CloudDownloadIcon;
	exports["default"] = _default;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CloudUploadIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M9.17 19v-6.698a2.937 2.937 0 002.309-5.004L9.398 5.222a7.003 7.003 0 018.48 4.845 4.5 4.5 0 11.77 8.934H9.17z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M5.174 8.637L3.6 10.212a.937.937 0 11-1.325-1.325L6.171 5l3.897 3.887a.936.936 0 11-1.325 1.324L7.173 8.64V18a1 1 0 01-2 0V8.637z"
	  })));
	});
	CloudUploadIcon.category = 'File';
	var _default = CloudUploadIcon;
	exports["default"] = _default;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ContractIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M1.985 15.232c0-.686.556-1.242 1.243-1.242h6.782v6.782a1.243 1.243 0 01-2.485 0v-4.297H3.228a1.243 1.243 0 01-1.243-1.243zM15.243 2c.686 0 1.242.556 1.242 1.243V7.54h4.298a1.243 1.243 0 010 2.485H14V3.243C14 2.556 14.556 2 15.243 2z"
	  }));
	});
	ContractIcon.category = 'Navigation';
	var _default = ContractIcon;
	exports["default"] = _default;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var CornerDragHandleIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M21.56 14.428a1.26 1.26 0 010 1.783l-5.349 5.348a1.26 1.26 0 01-1.783-1.783l5.348-5.348a1.26 1.26 0 011.783 0zm.07-7.059a1.26 1.26 0 010 1.783L9.153 21.63a1.26 1.26 0 01-1.783-1.783L19.85 7.37a1.26 1.26 0 011.782 0z"
	  }));
	});
	CornerDragHandleIcon.category = 'Navigation';
	var _default = CornerDragHandleIcon;
	exports["default"] = _default;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DashboardIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M17 10h2v6h-2v-6zm-4-2h2v8h-2V8zm-4 3h2v5H9v-5zm-4 2h2v3H5v-3z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M21 19V6H3v13a2 2 0 01-2-2V6a2 2 0 012-2h18a2 2 0 012 2v11a2 2 0 01-2 2zm-2 1v1H5v-1c0-.828 1.047-2 1.875-2h10.25C17.953 18 19 19.172 19 20z"
	  })));
	});
	DashboardIcon.category = 'Action';
	var _default = DashboardIcon;
	exports["default"] = _default;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DataDatabaseIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M3.24 16c.93 1.368 4.443 2.385 8.635 2.385S19.581 17.368 20.51 16c.133.197.213.4.234.61h.006v2.219h-.005c-.156 1.787-4.067 3.217-8.87 3.217-4.803 0-8.714-1.43-8.87-3.217H3V16.61h.006c.02-.21.1-.413.234-.61zm-.036-5.7c.87 1.396 4.422 2.44 8.671 2.44s7.8-1.044 8.67-2.44c.135.214.205.437.205.666 0 .074-.008.148-.022.222h.022v1.775h-.005c.003.036.005.073.005.11 0 1.839-3.973 3.329-8.875 3.329S3 14.912 3 13.073c0-.037.002-.074.005-.11H3v-1.775h.022A1.12 1.12 0 013 10.966c0-.229.07-.452.204-.666z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M20.744 4.995h.006v2.22h-.005c.003.036.005.073.005.11 0 1.838-3.973 3.328-8.875 3.328S3 9.163 3 7.325c0-.037.002-.074.005-.11H3v-2.22h.006C3.172 3.331 7.08 2 11.875 2s8.703 1.331 8.87 2.995z"
	  })));
	});
	DataDatabaseIcon.category = 'Content';
	var _default = DataDatabaseIcon;
	exports["default"] = _default;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DataFirewallIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10.402 15.21c-4.413-.15-7.881-1.505-7.97-3.165L2.431 9.93h.006c.022-.202.1-.398.229-.588.876 1.29 4.106 2.264 8.027 2.344-.406 1.086-.503 2.26-.29 3.523zm2.578 5.245c-.57.043-1.16.066-1.765.066-4.804 0-8.707-1.424-8.783-3.19l-.001-2.115h.006c.022-.201.1-.398.229-.587.89 1.31 4.209 2.294 8.214 2.347.066.18.137.36.214.543a10.181 10.181 0 001.886 2.936z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19.992 4.628H20v2.19c0 1.784-3.933 3.23-8.785 3.23-4.851 0-8.784-1.446-8.784-3.23v-2.19h.008c.203-1.624 4.055-2.92 8.776-2.92 4.722 0 8.574 1.296 8.777 2.92z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12.029 11.952c.994-.585 2.658-.878 4.993-.878 2.336 0 3.989.293 4.96.878.278 1.847.073 3.604-.614 5.27-.762 1.846-2.21 3.31-4.346 4.39-2.175-1.07-3.653-2.533-4.435-4.39-.697-1.656-.883-3.412-.558-5.27z"
	  })));
	});
	DataFirewallIcon.category = 'Content';
	var _default = DataFirewallIcon;
	exports["default"] = _default;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DataSecureIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12.641 11.652a5.894 5.894 0 00-.344 1.996v.602h-.031c-.72 0-1.34.397-1.615.967-4.53-.106-8.129-1.48-8.219-3.172L2.431 9.93h.006c.022-.202.1-.398.229-.588.915 1.347 4.395 2.35 8.55 2.35.485 0 .961-.014 1.425-.04zM10.5 20.51c-4.47-.133-7.996-1.502-8.068-3.18l-.001-2.114h.006c.022-.201.1-.398.229-.587.862 1.268 4 2.231 7.834 2.339v3.542z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19.992 4.628H20v2.19c0 1.784-3.933 3.23-8.785 3.23-4.851 0-8.784-1.446-8.784-3.23v-2.19h.008c.203-1.624 4.055-2.92 8.776-2.92 4.722 0 8.574 1.296 8.777 2.92z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19.5 15h.375c.621 0 1.125.485 1.125 1.083v4.334c0 .598-.504 1.083-1.125 1.083h-6.75c-.621 0-1.125-.485-1.125-1.083v-4.334c0-.598.504-1.083 1.125-1.083h.375v-1.561c0-1.623 1.343-2.939 3-2.939s3 1.316 3 2.939V15zM18 15v-1.476c0-.842-.672-1.524-1.5-1.524s-1.5.682-1.5 1.524V15h3z"
	  })));
	});
	DataSecureIcon.category = 'Content';
	var _default = DataSecureIcon;
	exports["default"] = _default;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DataUnknownIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M9.837 15.184c-4.14-.241-7.32-1.55-7.405-3.14l-.001-2.113h.006c.022-.202.1-.398.229-.588.915 1.347 4.395 2.35 8.55 2.35.135 0 .269-.002.403-.004a6.483 6.483 0 00-1.782 3.495zm1.513 5.336h-.135c-4.804 0-8.707-1.423-8.783-3.19l-.001-2.114h.006c.022-.201.1-.398.229-.587.808 1.189 3.615 2.11 7.12 2.308a6.473 6.473 0 001.564 3.583z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19.992 4.628H20v2.19c0 1.784-3.933 3.23-8.785 3.23-4.851 0-8.784-1.446-8.784-3.23v-2.19h.008c.203-1.624 4.055-2.92 8.776-2.92 4.722 0 8.574 1.296 8.777 2.92z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M16.25 21.5a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm.61-3.37c-.007-.388.026-.657.098-.808.072-.15.256-.349.554-.596.575-.479.95-.856 1.126-1.134.176-.277.263-.572.263-.883 0-.561-.239-1.054-.717-1.477-.478-.423-1.122-.634-1.93-.634-.77 0-1.391.209-1.864.627-.473.418-.728.926-.765 1.524l1.294.161c.09-.418.256-.729.497-.933.24-.204.54-.306.897-.306.371 0 .667.098.886.294.219.195.328.43.328.704a.878.878 0 01-.186.542c-.08.104-.326.323-.737.657s-.685.635-.822.903c-.137.267-.206.608-.206 1.023l.005.336h1.279zm-1.295 2.17h1.41V19h-1.41v1.3z"
	  })));
	});
	DataUnknownIcon.category = 'Content';
	var _default = DataUnknownIcon;
	exports["default"] = _default;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DesktopIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M13 15.5v3h2.125c.828 0 1.875 1.172 1.875 2H7c0-.828 1.047-2 1.875-2H11v-3H4a2 2 0 01-2-2v-8a2 2 0 012-2h16a2 2 0 012 2v8a2 2 0 01-2 2h-7zm-9-10v8h16v-8H4z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M4 7.5h14v6H4z",
	    opacity: ".6"
	  })));
	});
	DesktopIcon.category = 'Device';
	var _default = DesktopIcon;
	exports["default"] = _default;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DownloadFileIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M10.924 14.363L9.35 12.788a.937.937 0 10-1.325 1.325L11.921 18l1.321-1.317 2.576-2.57a.936.936 0 10-1.325-1.324l-1.57 1.572V7a1 1 0 10-2 0v7.363zM4 1h12a4 4 0 014 4v18H4V1z"
	  }));
	});
	DownloadFileIcon.category = 'File';
	var _default = DownloadFileIcon;
	exports["default"] = _default;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DragAndDropHoriIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M21 8v3h-3V8h3zm-5 0v3h-3V8h3zm-5 0v3H8V8h3zM6 8v3H3V8h3zm15 5v3h-3v-3h3zm-5 0v3h-3v-3h3zm-5 0v3H8v-3h3zm-5 0v3H3v-3h3z"
	  }));
	});
	DragAndDropHoriIcon.category = 'Navigation';
	var _default = DragAndDropHoriIcon;
	exports["default"] = _default;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DragAndDropVerticalIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M8 3h3v3H8V3zm0 5h3v3H8V8zm0 5h3v3H8v-3zm0 5h3v3H8v-3zm5-15h3v3h-3V3zm0 5h3v3h-3V8zm0 5h3v3h-3v-3zm0 5h3v3h-3v-3z"
	  }));
	});
	DragAndDropVerticalIcon.category = 'Navigation';
	var _default = DragAndDropVerticalIcon;
	exports["default"] = _default;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DuplicateIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M18 18V7.09C18 5.385 16.545 4 14.75 4H8V1h9.75C19.545 1 21 2.384 21 4.09V18h-3z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M16 9.09V23H3V6h9.75C14.545 6 16 7.384 16 9.09zM6 9v2h5V9H6zm0 3v2h7v-2H6z"
	  })));
	});
	DuplicateIcon.category = 'File';
	var _default = DuplicateIcon;
	exports["default"] = _default;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var EditIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M15.875 4.656l3.469 3.469L8.938 18.53l-3.47-3.469L15.876 4.656zM4.081 16.45l3.47 3.469L2 22l2.081-5.55z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M20.732 2.575l.693.693a1.962 1.962 0 010 2.776l-.693.693-3.47-3.469.694-.693a1.962 1.962 0 012.776 0z",
	    opacity: ".6"
	  })));
	});
	EditIcon.category = 'Action';
	var _default = EditIcon;
	exports["default"] = _default;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var EmailIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M23 8.773V18a2 2 0 01-2 2H3c-.466 0-.894-.16-1.234-.426L12 13.875l11-5.102z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M3 4h18a2 2 0 012 2v.773l-11 5.102L1 6.767V6a2 2 0 012-2z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillOpacity: ".6",
	    d: "M1 18V8.767l11 5.108-10.234 5.699A1.996 1.996 0 011 18z"
	  })));
	});
	EmailIcon.category = 'Communication';
	var _default = EmailIcon;
	exports["default"] = _default;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ExtendIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M13.985 3.232c0-.686.556-1.242 1.243-1.242h6.782v6.782a1.243 1.243 0 11-2.485 0V4.475h-4.297a1.243 1.243 0 01-1.243-1.243zM3.243 14c.686 0 1.242.556 1.242 1.243v4.297h4.298a1.243 1.243 0 010 2.485H2v-6.782C2 14.556 2.556 14 3.243 14z"
	  }));
	});
	ExtendIcon.category = 'Navigation';
	var _default = ExtendIcon;
	exports["default"] = _default;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var FeedbackIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M7 8.681l13.078-6.088A1 1 0 0121.5 3.5v14.863a1 1 0 01-1.422.906L7 13.181v-4.5zm2.883 7.965l-2.335 4.043a1.5 1.5 0 11-2.598-1.5l2.257-3.908 2.676 1.365z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M2.5 8.5H5v5H2.5z",
	    opacity: ".6"
	  })));
	});
	FeedbackIcon.category = 'Communication';
	var _default = FeedbackIcon;
	exports["default"] = _default;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var FilterIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M16.35 8.26l-4.628 5.397A3 3 0 0011 15.61v4.89l-3 2v-6.89a3 3 0 00-.722-1.953L2.65 8.26A2.703 2.703 0 012 6.5a1 1 0 011-1h13a1 1 0 011 1c0 .645-.23 1.27-.65 1.76z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M18.905 7.441c.063-.308.095-.623.095-.941a3 3 0 00-3-3H7v-1a1 1 0 011-1h13a1 1 0 011 1v.059a2.99 2.99 0 01-.666 1.882l-2.43 3zm-2.88 4.27a3 3 0 00-.025.38v5.291L13 19.5v-3.89a1 1 0 01.24-.651l2.784-3.247z",
	    opacity: ".6"
	  })));
	});
	FilterIcon.category = 'Content';
	var _default = FilterIcon;
	exports["default"] = _default;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var FilterMinimalIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M9.5 16h5a1.5 1.5 0 010 3h-5a1.5 1.5 0 010-3z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M6.5 10h11a1.5 1.5 0 010 3h-11a1.5 1.5 0 010-3z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M3.5 4h17a1.5 1.5 0 010 3h-17a1.5 1.5 0 010-3z"
	  })));
	});
	FilterMinimalIcon.category = 'Content';
	var _default = FilterMinimalIcon;
	exports["default"] = _default;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var FlagIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M21 3.833V13c-.647-1.222-1.822-1.833-3.525-1.833-2.554 0-4.28 1.833-6.955 1.833-1.783 0-2.957-.611-3.52-1.833V2c.554 1.222 1.728 1.833 3.52 1.833C13.21 3.833 14.84 2 17.475 2c1.758 0 2.933.611 3.525 1.833zM2.75 3.25a1.25 1.25 0 112.5 0v17.5a1.25 1.25 0 01-2.5 0V3.25z"
	  }));
	});
	FlagIcon.category = 'Content';
	var _default = FlagIcon;
	exports["default"] = _default;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var FolderDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4 3.5a2 2 0 00-2 2v13a2 2 0 002 2h16a2 2 0 002-2v-10a2 2 0 00-2-2h-7l-1.287-2.06a2 2 0 00-1.696-.94H4z"
	  }));
	});
	FolderDefaultIcon.category = 'File';
	var _default = FolderDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var FolderOpenedIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M2 11h19c.692 0 1 .685 1 1.375-1.51 4.12-2.343 6.412-2.5 6.875-.226.665-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25V11z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M20 9H2V5.25C2 4.56 2.56 4 3.25 4h7.182c.431 0 .832.222 1.06.588L13 7h5.75c.69 0 1.25.56 1.25 1.25V9z",
	    opacity: ".6"
	  })));
	});
	FolderOpenedIcon.category = 'File';
	var _default = FolderOpenedIcon;
	exports["default"] = _default;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ForwardIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M17.176 13l-4.635 4.635a1 1 0 101.414 1.414l7.071-7.071-.003-.003.003-.003-7.07-7.071a1 1 0 00-1.415 1.414L17.226 11H2.976v2h14.2z"
	  }));
	});
	ForwardIcon.category = 'Navigation';
	var _default = ForwardIcon;
	exports["default"] = _default;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var FullscreenMaximizeIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M9.919 15.419L11.5 17H7v-4.5l1.504 1.504 5.5-5.5L12.5 7H17v4.5l-1.581-1.581-5.5 5.5zM3 3h18a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V5a2 2 0 012-2zm0 2v14h18V5H3z"
	  }));
	});
	FullscreenMaximizeIcon.category = 'Navigation';
	var _default = FullscreenMaximizeIcon;
	exports["default"] = _default;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var FullscreenMinimizeIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M15.962 9.462L17.5 11H13V6.5l1.548 1.548L17.595 5H3v14h.518l4.491-4.49L6.5 13H11v4.5l-1.577-1.577L6.347 19H21V5h-.576l-4.462 4.462zM4.347 21l-.058.057L4.232 21H3a2 2 0 01-2-2V5a2 2 0 012-2h18a2 2 0 012 2v14a2 2 0 01-2 2H4.347z"
	  }));
	});
	FullscreenMinimizeIcon.category = 'Navigation';
	var _default = FullscreenMinimizeIcon;
	exports["default"] = _default;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var GlobeIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M14.711 16H9.29c.317 2.13.862 3.868 1.469 4.915a8.937 8.937 0 01-2.51-.732c-.444-1.194-.78-2.615-.991-4.183H3.936a8.935 8.935 0 01-.713-2h3.839a31.998 31.998 0 010-4H3.223c.16-.701.4-1.371.713-2h3.32c.211-1.568.548-2.99.992-4.183a8.937 8.937 0 012.51-.732C10.151 4.132 9.606 5.871 9.288 8h5.423c-.317-2.13-.862-3.868-1.469-4.915a8.937 8.937 0 012.51.732c.444 1.194.78 2.615.991 4.183h3.321c.313.629.554 1.299.713 2h-3.839a31.998 31.998 0 010 4h3.839c-.16.701-.4 1.371-.713 2h-3.32c-.211 1.568-.548 2.99-.992 4.183-.783.36-1.626.61-2.51.732.607-1.047 1.152-2.786 1.47-4.915zm.218-2a28.231 28.231 0 000-4H9.071a28.231 28.231 0 000 4h5.858z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M12 21a9 9 0 100-18 9 9 0 000 18zm0 2C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11z",
	    opacity: ".8"
	  })));
	});
	GlobeIcon.category = 'Map';
	var _default = GlobeIcon;
	exports["default"] = _default;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var GrabIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M18 11.002v-1.5c0-.132.054-.258.15-.352a.537.537 0 01.738-.006L22 12l-3.124 2.867a.533.533 0 01-.354.133.512.512 0 01-.522-.502v-1.496h-5V18h1.498c.277 0 .502.234.502.522a.533.533 0 01-.133.354L12 22l-2.856-3.112a.537.537 0 01.006-.738.492.492 0 01.352-.15H11v-4.998H6v1.496a.512.512 0 01-.522.502.533.533 0 01-.354-.133L2 12l3.112-2.856a.537.537 0 01.738.006c.096.094.15.22.15.352v1.5h5V6H9.502a.492.492 0 01-.352-.15.537.537 0 01-.006-.738L12 2l2.867 3.124a.533.533 0 01.133.354.512.512 0 01-.502.522H13v5.002h5z"
	  }));
	});
	GrabIcon.category = 'Navigation';
	var _default = GrabIcon;
	exports["default"] = _default;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var GridIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M2.5 13H11v8.5H2.5V13zM13 13h8.5v8.5H13V13zM2.5 2.5H11V11H2.5V2.5zm10.5 0h8.5V11H13V2.5z"
	  }));
	});
	GridIcon.category = 'Navigation';
	var _default = GridIcon;
	exports["default"] = _default;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var HelpDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm-.929 13.245l.005.18h1.886l.003-.182c.012-.627.055-1.077.126-1.343.071-.264.18-.495.325-.696.149-.206.48-.54.988-.994.786-.7 1.316-1.3 1.593-1.801.28-.509.42-1.064.42-1.665 0-1.037-.398-1.926-1.19-2.655C14.439 5.362 13.385 5 12.077 5c-1.238 0-2.242.338-3.004 1.016-.763.679-1.22 1.652-1.372 2.91l-.022.184 1.99.239.028-.176c.136-.87.416-1.5.836-1.896.419-.394.939-.59 1.57-.59.653 0 1.2.217 1.647.655.448.437.668.937.668 1.509 0 .312-.074.598-.223.86-.152.269-.498.646-1.034 1.123-.557.495-.944.873-1.163 1.137-.301.366-.52.73-.658 1.094-.185.478-.277 1.044-.277 1.694 0 .109.003.27.01.486zm-.114 2.244v2.01h2.073v-2.01h-2.073z"
	  }));
	});
	HelpDefaultIcon.category = 'Communication';
	var _default = HelpDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var HomeIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10 14h4v7.5h-4z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8 21.5H2.5v-9.15a3 3 0 01.998-2.234L12 2.5l8.503 7.616a3 3 0 01.998 2.235V21.5H16v-9.49H8v9.49z"
	  })));
	});
	HomeIcon.category = 'Action';
	var _default = HomeIcon;
	exports["default"] = _default;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var HubIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M13 6.792v10.416a2.5 2.5 0 11-2 0V6.792a2.5 2.5 0 112 0z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M16.858 10.386L8 15.5a2.5 2.5 0 11-.81-1.842l8.811-5.087L16 8.5a2.5 2.5 0 11.858 1.886z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M16 15.464l-8.834-5.1A2.5 2.5 0 118 8.536l8.834 5.1A2.5 2.5 0 1116 15.464z",
	    opacity: ".6"
	  })));
	});
	HubIcon.category = 'Network';
	var _default = HubIcon;
	exports["default"] = _default;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ImageIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M22.414 4.586c.362.362.586.862.586 1.414v12c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0121 20H3a1.994 1.994 0 01-1.414-.586A1.994 1.994 0 011 18V6c0-.552.224-1.052.586-1.414A1.994 1.994 0 013 4h18c.552 0 1.052.224 1.414.586zM21 6H3v12h18V6z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M20 15.923l-1.68-1.147a2.75 2.75 0 00-3.103 0l-2.278 1.557-3.292-3.078a2.75 2.75 0 00-3.756 0L4 15.023V7h16v8.923zM14 13a2 2 0 100-4 2 2 0 000 4z",
	    opacity: ".8"
	  })));
	});
	ImageIcon.category = 'Media';
	var _default = ImageIcon;
	exports["default"] = _default;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var InfoDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 6.493a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.12 9.677V10.5h-2.25v7.67h2.25z"
	  }));
	});
	InfoDefaultIcon.category = 'Communication';
	var _default = InfoDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var IntentDangerIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M3.306 21.45a1.782 1.782 0 01-1.553-2.656l8.655-15.385a1.782 1.782 0 013.107 0l8.655 15.385a1.782 1.782 0 01-1.553 2.656H3.306zM12 18.993a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm1.12-4.826V7.5h-2.25v6.667h2.25z"
	  }));
	});
	IntentDangerIcon.category = 'Notification';
	var _default = IntentDangerIcon;
	exports["default"] = _default;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var IntentDangerSimpleIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M7.496 16.965a.495.495 0 01-.432-.739l4.505-7.974a.495.495 0 01.862 0l4.505 7.974a.495.495 0 01-.431.74h-9.01z"
	  }));
	});
	IntentDangerSimpleIcon.category = 'Notification';
	var _default = IntentDangerSimpleIcon;
	exports["default"] = _default;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var IntentSuccessIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M10.277 16.54l.029.028 7.292-7.292a.985.985 0 10-1.393-1.393L10.3 13.788 7.014 10.5a.985.985 0 10-1.393 1.393l4.65 4.65.006-.005zM12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2z"
	  }));
	});
	IntentSuccessIcon.category = 'Notification';
	var _default = IntentSuccessIcon;
	exports["default"] = _default;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var IntentSuccessSimpleIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M12 8c-2.208 0-4 1.792-4 4s1.792 4 4 4 4-1.792 4-4-1.792-4-4-4z"
	  }));
	});
	IntentSuccessSimpleIcon.category = 'Notification';
	var _default = IntentSuccessSimpleIcon;
	exports["default"] = _default;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var IntentWarningIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M21.435 13.617l-7.818 7.818a2.257 2.257 0 01-3.192 0l-7.818-7.818a2.257 2.257 0 010-3.192l7.818-7.818a2.257 2.257 0 013.192 0l7.818 7.818c.882.881.882 2.31 0 3.192zM12 17.993a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm1.12-4.826V6.5h-2.25v6.667h2.25z"
	  }));
	});
	IntentWarningIcon.category = 'Notification';
	var _default = IntentWarningIcon;
	exports["default"] = _default;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var IntentWarningSimpleIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M12.674 7.28l4.047 4.046a.954.954 0 010 1.348l-4.047 4.047a.954.954 0 01-1.348 0l-4.047-4.047a.954.954 0 010-1.348l4.047-4.047a.954.954 0 011.348 0z"
	  }));
	});
	IntentWarningSimpleIcon.category = 'Notification';
	var _default = IntentWarningSimpleIcon;
	exports["default"] = _default;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var IoDataTransferIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8.5 9H13v2H8.5v8.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L7.5 23l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86V11a2 2 0 012-2z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M15.5 15H11v-2h4.5V4.847l-1.825 1.86a.968.968 0 01-1.388 0 1.013 1.013 0 010-1.414L16.5 1l4.213 4.293c.383.39.383 1.024 0 1.414a.968.968 0 01-1.388 0L17.5 4.847V13a2 2 0 01-2 2z"
	  })));
	});
	IoDataTransferIcon.category = 'Device';
	var _default = IoDataTransferIcon;
	exports["default"] = _default;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var LanNetworkIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M11 15H6v5.883H4V15a2 2 0 012-2h5V9h2v4h5a2 2 0 012 2h-.022v5.505h-2V15H13v4h-2v-4z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M7 2h10a2 2 0 012 2v5a2 2 0 01-2 2H7a2 2 0 01-2-2V4a2 2 0 012-2zm0 2v5h10V4H7zM4 18h2a1 1 0 011 1v3H3v-3a1 1 0 011-1zm7 0h2a1 1 0 011 1v3h-4v-3a1 1 0 011-1zm7 0h2a1 1 0 011 1v3h-4v-3a1 1 0 011-1z"
	  })));
	});
	LanNetworkIcon.category = 'Network';
	var _default = LanNetworkIcon;
	exports["default"] = _default;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var LaptopAndMobilePhoneIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M20.5 6h-5.3a2.7 2.7 0 00-2.7 2.7V13h-8V4.74C4.5 3.778 5.296 3 6.278 3h12.444c.982 0 1.778.779 1.778 1.74V6zm-8 9v3h-8a3 3 0 01-3-3h11z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M16.5 8h4a2 2 0 012 2v9a2 2 0 01-2 2h-4a2 2 0 01-2-2v-9a2 2 0 012-2zm1.5 9a1 1 0 000 2h1a1 1 0 000-2h-1z"
	  })));
	});
	LaptopAndMobilePhoneIcon.category = 'Device';
	var _default = LaptopAndMobilePhoneIcon;
	exports["default"] = _default;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var LaptopIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M21 16h2a3 3 0 01-3 3H4a3 3 0 01-3-3h2V6.913C3 5.856 3.895 5 5 5h14c1.105 0 2 .856 2 1.913V16zM5 16h14V7H5v9z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M5 9h12v7H5z",
	    opacity: ".6"
	  })));
	});
	LaptopIcon.category = 'Device';
	var _default = LaptopIcon;
	exports["default"] = _default;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var LineGraphIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12.879 10.25l7.049-6.394a1.254 1.254 0 011.73.042 1.13 1.13 0 01-.046 1.641l-7.075 6.33a2.53 2.53 0 01-3.556.02L8.783 9.744 4.127 14.47a1.24 1.24 0 01-1.76.006 1.26 1.26 0 01-.008-1.774l4.619-4.689c.239-.242.515-.425.81-.548a2.53 2.53 0 012.768.514l2.323 2.27zM2 19h20a1 1 0 010 2H2a1 1 0 010-2z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12.666 16.95c-.18.033-.402.05-.666.05-1.655 0-2.652-.18-2.993-.542a1.268 1.268 0 01-.068-.064L2.384 9.84a1.25 1.25 0 111.768-1.767l6.555 6.555c.024.023.046.048.068.073h10.1a1.125 1.125 0 010 2.25h-8.21z",
	    opacity: ".6"
	  })));
	});
	LineGraphIcon.category = 'Graph';
	var _default = LineGraphIcon;
	exports["default"] = _default;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var LinkDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M11.45 20.318l-1.06 1.06A5.5 5.5 0 012.61 13.6l6.011-6.01a3.625 3.625 0 015.127 0l2.21 2.21-1.945 1.944-1.768-1.767a1.5 1.5 0 00-2.121 0l-5.569 5.568a2.75 2.75 0 003.89 3.89l1.06-1.062 1.945 1.945zm1.114-16.646l1.061-1.061a5.5 5.5 0 017.778 7.778l-6.01 6.01a3.625 3.625 0 01-5.127 0l-2.21-2.21 1.945-1.944 1.768 1.768a1.5 1.5 0 002.121 0l5.569-5.568a2.75 2.75 0 00-3.89-3.89l-1.06 1.061-1.945-1.944z"
	  }));
	});
	LinkDefaultIcon.category = 'Content';
	var _default = LinkDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var LinkUnlinkIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M7.197 8.752l.532-.513 1.178-1.177a3.625 3.625 0 015.126 0l2.21 2.21-1.945 1.944-1.767-1.768a1.5 1.5 0 00-2.122 0l-.864.865-.02-.02-.4.387-1.928-1.928zm-1.44 1.388l1.933 1.934-3.135 3.042a2.75 2.75 0 003.89 3.89l1.06-1.061 1.945 1.944-1.06 1.061a5.5 5.5 0 01-7.78-7.778l3.147-3.032zm7.601 7.602a3.626 3.626 0 01-3.948-.788l-2.21-2.21 1.58-1.58 4.578 4.578zm3.015-2.41l3.89 3.89a1 1 0 01-1.414 1.415L3.293 5.081a1 1 0 111.414-1.414l9.721 9.72 4.943-4.942a2.75 2.75 0 00-3.889-3.89l-.97.987-1.945-1.944.97-.987a5.5 5.5 0 017.779 7.778l-4.943 4.943z"
	  }));
	});
	LinkUnlinkIcon.category = 'Content';
	var _default = LinkUnlinkIcon;
	exports["default"] = _default;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ListIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M9.5 4.5H20a1.5 1.5 0 010 3H9.5a1.5 1.5 0 010-3zm0 6H20a1.5 1.5 0 010 3H9.5a1.5 1.5 0 010-3zm0 6H20a1.5 1.5 0 010 3H9.5a1.5 1.5 0 010-3zM4 4.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
	  }));
	});
	ListIcon.category = 'Navigation';
	var _default = ListIcon;
	exports["default"] = _default;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var LockDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M7 9V6a5 5 0 1110 0v3h1a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V11a2 2 0 012-2h1zm2.5 0h4.97V5.985a2.485 2.485 0 00-4.97 0V9zm-1 8v2.5h7V17h-7zm0-4.5V15h7v-2.5h-7z"
	  }));
	});
	LockDefaultIcon.category = 'Action';
	var _default = LockDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var LockUnlockedIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M7 9V6a5 5 0 019.87-1.138l-2.434.716a2.486 2.486 0 00-4.936.407V9H18a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V11a2 2 0 012-2h1zm3.5 8v2.5h7V17h-7zm-4-4.5V15h7v-2.5h-7z"
	  }));
	});
	LockUnlockedIcon.category = 'Action';
	var _default = LockUnlockedIcon;
	exports["default"] = _default;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var MaintenanceIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M17.13 13.5l5.026 5.026c1.073 1.073 1.13 2.756.128 3.758-1.002 1.003-2.685.945-3.758-.128L13.5 17.13l3.63-3.63zM5.335 7.038l-1.68.14L1 2.053 2.044 1l5.15 2.61-.14 1.694L9.5 7.771 7.781 9.504 5.335 7.038z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12.188 8.91a5.645 5.645 0 017.92-7.195l-4.562 3.843-.003 2.899 2.905.003 3.837-4.569a5.646 5.646 0 01-7.195 7.921L4.503 22.4a2.052 2.052 0 01-2.902-2.902L12.188 8.91z"
	  })));
	});
	MaintenanceIcon.category = 'Action';
	var _default = MaintenanceIcon;
	exports["default"] = _default;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var MenuClosedIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M11.961 7l7.25 7.304a.998.998 0 010 1.405.983.983 0 01-.697.291H5.486a.99.99 0 01-.986-.993c0-.262.102-.513.285-.699L11.961 7z"
	  }));
	});
	MenuClosedIcon.category = 'Navigation';
	var _default = MenuClosedIcon;
	exports["default"] = _default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var MenuOpenIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M11.961 16L4.785 8.692a.997.997 0 01-.285-.699A.99.99 0 015.486 7h13.028c.261 0 .512.105.697.29a.998.998 0 010 1.406L11.961 16z"
	  }));
	});
	MenuOpenIcon.category = 'Navigation';
	var _default = MenuOpenIcon;
	exports["default"] = _default;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var MicDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M19 12v1a7.002 7.002 0 01-6 6.93V23h-2v-3.07A7.002 7.002 0 015 13v-1a1 1 0 012 0v1a5 5 0 0010 0v-1a1 1 0 012 0zM12 1a3 3 0 013 3v9a3 3 0 01-6 0V4a3 3 0 013-3z"
	  }));
	});
	MicDefaultIcon.category = 'Media';
	var _default = MicDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var MicMuteIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M18.008 16.594l2.64 2.64a1 1 0 01-1.414 1.414l-2.496-2.496A6.976 6.976 0 0113 19.93V23h-2v-3.07A7.002 7.002 0 015 13v-1a1 1 0 012 0v1a5 5 0 008.322 3.737l-1.418-1.419a3.01 3.01 0 01-.014.012L9 10.44v-.026L3.678 5.092a1 1 0 011.414-1.414L9 7.586V4a3 3 0 016 0v9c0 .184-.016.363-.048.538l1.58 1.579c.3-.643.468-1.36.468-2.117v-1a1 1 0 012 0v1a6.967 6.967 0 01-.992 3.594zm-5.597-.622A3 3 0 019 13v-.44l3.411 3.412z"
	  }));
	});
	MicMuteIcon.category = 'Media';
	var _default = MicMuteIcon;
	exports["default"] = _default;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var MinusIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M21 12a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 010-3h15A1.5 1.5 0 0121 12z"
	  }));
	});
	MinusIcon.category = 'Content';
	var _default = MinusIcon;
	exports["default"] = _default;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var MobilePhoneIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8 2h8a2 2 0 012 2v16a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2zm0 2v12h8V4H8zm3.5 14a1 1 0 000 2h1a1 1 0 000-2h-1z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8 6h6v10H8z",
	    opacity: ".6"
	  })));
	});
	MobilePhoneIcon.category = 'Device';
	var _default = MobilePhoneIcon;
	exports["default"] = _default;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var NetworkMapIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M2.688 4.724L8 7v13l-5.71-2.447C1.5 17.214 1 16.52 1 15.763V5.619c0-.552.522-1 1.167-1 .18 0 .36.036.521.106zM16 4l5.894 2.447A2 2 0 0123 8.237v10.145a1 1 0 01-1.447.894L16 17V4z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8 7l8-3v13l-8 3z"
	  })));
	});
	NetworkMapIcon.category = 'Map';
	var _default = NetworkMapIcon;
	exports["default"] = _default;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var NoAccessIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm-6 8.5v3h12v-3H6z"
	  }));
	});
	NoAccessIcon.category = 'Action';
	var _default = NoAccessIcon;
	exports["default"] = _default;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var OverflowMenuHoriIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.76 9.75a2.26 2.26 0 110 4.519 2.26 2.26 0 010-4.519zm7.23 0a2.26 2.26 0 110 4.519 2.26 2.26 0 010-4.519zm7.23 0a2.26 2.26 0 110 4.519 2.26 2.26 0 010-4.519z"
	  }));
	});
	OverflowMenuHoriIcon.category = 'Navigation';
	var _default = OverflowMenuHoriIcon;
	exports["default"] = _default;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var OverflowMenuVerticalIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
	    id: "a",
	    d: "M4.76 9.75a2.26 2.26 0 110 4.519 2.26 2.26 0 010-4.519zm7.23 0a2.26 2.26 0 110 4.519 2.26 2.26 0 010-4.519zm7.23 0a2.26 2.26 0 110 4.519 2.26 2.26 0 010-4.519z"
	  })), /*#__PURE__*/_react["default"].createElement("use", {
	    fillRule: "evenodd",
	    transform: "rotate(90 11.99 12.01)",
	    xlinkHref: "#a"
	  }));
	});
	OverflowMenuVerticalIcon.category = 'Navigation';
	var _default = OverflowMenuVerticalIcon;
	exports["default"] = _default;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PageDownIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M13.026 17.15l4.635-4.635a1 1 0 111.414 1.414L12.005 21 12 20.997l-.003.003-7.07-7.071a1 1 0 011.413-1.414l4.685 4.685V2.95h2v14.2z"
	  }));
	});
	PageDownIcon.category = 'Navigation';
	var _default = PageDownIcon;
	exports["default"] = _default;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PageIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M20 5v18H4V1h12a4 4 0 014 4zM8 5v2h6V5H8zm0 4v2h8V9H8z"
	  }));
	});
	PageIcon.category = 'File';
	var _default = PageIcon;
	exports["default"] = _default;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PageUpIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M13.026 6.8l4.635 4.635a1 1 0 101.414-1.414l-7.07-7.071-.004.003-.003-.003-7.07 7.071a1 1 0 001.413 1.414l4.685-4.685V21h2V6.8z"
	  }));
	});
	PageUpIcon.category = 'Navigation';
	var _default = PageUpIcon;
	exports["default"] = _default;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PauseIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M16 6c1.105 0 2 .768 2 1.714v8.572c0 .946-.895 1.714-2 1.714s-2-.768-2-1.714V7.714C14 6.768 14.895 6 16 6zM8 6c1.105 0 2 .768 2 1.714v8.572C10 17.232 9.105 18 8 18s-2-.768-2-1.714V7.714C6 6.768 6.895 6 8 6z"
	  }));
	});
	PauseIcon.category = 'Action';
	var _default = PauseIcon;
	exports["default"] = _default;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PendingIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "nonzero"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M13.25 13.383v.233H7.117a1.25 1.25 0 010-2.5h3.633V7.25a1.25 1.25 0 012.5 0v6.133zM12.955 1c5.609.51 10 5.222 10 10.954 0 6.072-4.928 11-11.01 11-5.736 0-10.44-4.396-10.945-10h2.536c.494 4.21 4.07 7.478 8.409 7.478 4.688 0 8.488-3.797 8.488-8.478 0-4.339-3.266-7.919-7.478-8.418V1z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10.99 1.045V3.58c-.8.094-1.566.3-2.282.602l-1.27-2.199a10.91 10.91 0 013.552-.94z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M5.694 2.982l1.268 2.196A8.522 8.522 0 005.23 6.893L3.033 5.624c.73-1.025 1.63-1.92 2.661-2.642z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M2.022 7.361L4.218 8.63a8.429 8.429 0 00-.636 2.361H1.046a10.94 10.94 0 01.976-3.629z",
	    opacity: ".4"
	  })));
	});
	PendingIcon.category = 'Time';
	var _default = PendingIcon;
	exports["default"] = _default;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PhoneIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19.98 20.39l-.062.063c-2.674 2.674-8.504 1.18-13.02-3.336C2.38 12.6.888 6.77 3.562 4.097A4.138 4.138 0 013.658 4l1.347-1.346a1.25 1.25 0 011.873.12L9.216 5.8a1.25 1.25 0 01-.196 1.73L6.727 9.412l-.107.107a1.25 1.25 0 00-.164 1.565c1.112 1.712 2.041 2.941 2.787 3.688.746.746 1.975 1.675 3.688 2.787a1.25 1.25 0 001.565-.165l.106-.107 1.883-2.292a1.25 1.25 0 011.73-.196l3.026 2.338a1.25 1.25 0 01.12 1.873l-1.347 1.347a1.266 1.266 0 01-.035.033z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "nonzero",
	    d: "M12 3V1c6.075 0 11 4.925 11 11h-2a9 9 0 00-9-9z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12 5a7 7 0 017 7h-2a5 5 0 00-5-5V5z",
	    opacity: ".8"
	  })));
	});
	PhoneIcon.category = 'Communication';
	var _default = PhoneIcon;
	exports["default"] = _default;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PieChartIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M18.938 14A8.005 8.005 0 0111 21c-4.416 0-8-3.584-8-8a8.005 8.005 0 017-7.938V14h8.938z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12 3.05c4.722.47 8.48 4.228 8.95 8.95H12V3.05z",
	    opacity: ".6"
	  })));
	});
	PieChartIcon.category = 'Graph';
	var _default = PieChartIcon;
	exports["default"] = _default;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PlayIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M7 6.558c0-.293.084-.58.242-.828a1.603 1.603 0 012.187-.492l8.827 5.434a1.54 1.54 0 01.002 2.638l-8.827 5.451a1.608 1.608 0 01-.845.239C7.71 19 7 18.303 7 17.443V6.558z"
	  }));
	});
	PlayIcon.category = 'Action';
	var _default = PlayIcon;
	exports["default"] = _default;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PlusIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M13.5 10.5h6a1.5 1.5 0 010 3h-6v6a1.5 1.5 0 01-3 0v-6h-6a1.5 1.5 0 010-3h6v-6a1.5 1.5 0 013 0v6z"
	  }));
	});
	PlusIcon.category = 'Content';
	var _default = PlusIcon;
	exports["default"] = _default;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PowerDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M11.835 16.413l-2.1 2.1a1 1 0 01-1.414 0l-.707-.707-4.95 4.95-1.414-1.414 4.95-4.95-.707-.707a1 1 0 010-1.414l2.102-2.103-.258-.258a2 2 0 01-.078-2.55l3.866-4.97-.707-.707 1.414-1.415 2.121 2.122 2.829-2.829a1 1 0 011.414 1.415l-2.828 2.828 2.828 2.828 2.828-2.828a1 1 0 011.415 1.414l-2.829 2.829 2.122 2.12-1.415 1.415-.707-.707-4.97 3.866a2 2 0 01-2.642-.165l-.163-.163z"
	  }));
	});
	PowerDefaultIcon.category = 'Device';
	var _default = PowerDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PowerUnplugedIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M8.562 7.378l2.532-3.257-.707-.707L11.801 2l2.122 2.121 2.828-2.828a1 1 0 011.414 1.414l-2.828 2.829 2.828 2.828 2.829-2.828a1 1 0 011.414 1.414L19.58 9.778 21.7 11.9l-1.413 1.415-.707-.707-3.257 2.532 3.94 3.94a1 1 0 11-1.414 1.415L3.293 4.937a1 1 0 011.414-1.414l3.855 3.855zM7.458 17.883l-4.044 4.044L2 20.512l4.043-4.043-.668-.668a1 1 0 010-1.415L7.762 12l4.242 4.243-2.386 2.386a1 1 0 01-1.414 0l-.746-.746z"
	  }));
	});
	PowerUnplugedIcon.category = 'Device';
	var _default = PowerUnplugedIcon;
	exports["default"] = _default;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var PrinterIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19 20v-4H5v4H3a2 2 0 01-2-2v-6a2 2 0 012-2h18a2 2 0 012 2v6a2 2 0 01-2 2h-2zm0-8v2h2v-2h-2z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M7 18h10v4H7z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M15.115 2H6v6h12V4.962C18 3.326 16.709 2 15.115 2z",
	    opacity: ".6"
	  })));
	});
	PrinterIcon.category = 'Device';
	var _default = PrinterIcon;
	exports["default"] = _default;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ProcessingIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.929 4.929l1.768 1.768A7.5 7.5 0 1012 4.5V2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12a9.969 9.969 0 012.929-7.071z"
	  }));
	});
	ProcessingIcon.category = 'File';
	var _default = ProcessingIcon;
	exports["default"] = _default;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var RefreshIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M18.54 5.817v-1.55a1.243 1.243 0 012.485 0v5.784h-5.782a1.243 1.243 0 110-2.486h1.51A6.502 6.502 0 005.59 10.914h-.002a1.25 1.25 0 11-2.468-.394C3.827 6.254 7.533 3 12 3c2.576 0 4.9 1.082 6.54 2.817zM5.51 18.236v1.547a1.243 1.243 0 01-2.485 0V14h5.783a1.243 1.243 0 010 2.485H7.295a6.501 6.501 0 0011.144-3.59l.012.001a1.25 1.25 0 012.449.388l.009.001a8.985 8.985 0 01-.03.195C20.173 17.746 16.467 21 12 21a8.974 8.974 0 01-6.49-2.764z"
	  }));
	});
	RefreshIcon.category = 'Content';
	var _default = RefreshIcon;
	exports["default"] = _default;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var RemoveGroupIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19.982 9.85l.001-.096a5.587 5.587 0 00-10.21-3.138 4.5 4.5 0 00-5.757 6.733c-1.136.28-2.03.728-2.688 1.325A11.011 11.011 0 011 12C1 5.928 5.928 1 12 1c5.987 0 10.863 4.792 10.997 10.747a7.252 7.252 0 00-3.015-1.897z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M6.597 15.012c-.86.992-1.283 2.256-1.283 3.757v1.964a11.055 11.055 0 01-3.162-3.829c.443-.972 1.623-1.78 4.445-1.892zm2.36-6.543a5.603 5.603 0 00.402 3.703 2.5 2.5 0 11-.4-3.703z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10.665 15.206a7.278 7.278 0 00-.165 1.544 7.244 7.244 0 003.328 6.099 11.06 11.06 0 01-6.423-.853v-3.14c0-1.44.586-2.953 3.26-3.65zm1.35-2.893a3.496 3.496 0 115.867-2.812L17.75 9.5a7.238 7.238 0 00-5.734 2.813zM17.75 22a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm-3.438-6.188v2h6.876v-2h-6.875z"
	  })));
	});
	RemoveGroupIcon.category = 'Profile';
	var _default = RemoveGroupIcon;
	exports["default"] = _default;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var RemoveUserIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M22.998 11.81a7.23 7.23 0 00-5.248-2.248c-.856 0-1.678.149-2.44.422a5.343 5.343 0 10-9.621 2.55c-2.08.614-3.403 1.74-4.002 3.299A10.968 10.968 0 011 12C1 5.928 5.928 1 12 1c6.009 0 10.897 4.826 10.998 10.81z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M13.751 22.861c-.57.092-1.155.139-1.751.139-3.53 0-6.673-1.665-8.686-4.253v-.664c0-1.868 1.031-3.866 6.686-3.866.34 0 .663.007.97.02-.304.8-.47 1.669-.47 2.575a7.243 7.243 0 003.251 6.05zM10 12.721a3.343 3.343 0 110-6.686 3.343 3.343 0 010 6.686zM17.75 22a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm3.438-6.188h-6.875v2h6.874v-2z"
	  })));
	});
	RemoveUserIcon.category = 'Profile';
	var _default = RemoveUserIcon;
	exports["default"] = _default;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ReportsIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M6.5 3v2.5a3.5 3.5 0 007 0V3H16a4 4 0 014 4v16H4V3h2.5zM15 13v7h2.5v-7H15zm-4.25-2v9h2.5v-9h-2.5zM6.5 16v4H9v-4H6.5z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M8.5 1h3v4.5a1.5 1.5 0 01-3 0V1z",
	    opacity: ".6"
	  })));
	});
	ReportsIcon.category = 'Action';
	var _default = ReportsIcon;
	exports["default"] = _default;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var RestartIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M18.54 5.817v-1.55a1.243 1.243 0 012.485 0v5.784h-5.782a1.243 1.243 0 110-2.486h1.51a6.5 6.5 0 101.687 5.329l.01.002a1.25 1.25 0 012.45.388l.009.001a8.985 8.985 0 01-.03.195 9 9 0 11-2.339-7.662z"
	  }));
	});
	RestartIcon.category = 'Content';
	var _default = RestartIcon;
	exports["default"] = _default;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var RouterIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4 9h16a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 012-2zm13 2v2h2v-2h-2zm-4 0v2h2v-2h-2zm-4 0v2h2v-2H9zm-4 0v2h2v-2H5z"
	  }));
	});
	RouterIcon.category = 'Device';
	var _default = RouterIcon;
	exports["default"] = _default;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SaveToDeviceIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M11.931 17.357L9.326 14.75 8 16.076l2.556 2.549-.012.01 1.317 1.316.013-.012.012.012.29-.29 3.91-3.585-1.326-1.326-2.829 2.607zM15.938 1L20 5v16a2 2 0 01-2 2H6a2 2 0 01-2-2V3a2 2 0 012-2h9.938zM13 4v5h1.5V4H13zm3.5 2v3H18V6h-1.5zm-7-2v5H11V4H9.5zM6 4v5h1.5V4H6z"
	  }));
	});
	SaveToDeviceIcon.category = 'File';
	var _default = SaveToDeviceIcon;
	exports["default"] = _default;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SearchIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M21.373 20.71a.934.934 0 01-.52.553 1.5 1.5 0 01-1.86-.21l-3.96-3.96a8 8 0 112.11-2.133l3.972 3.972a1.5 1.5 0 01.258 1.777zm-6.975-6.374a5.5 5.5 0 10-7.779-7.778 5.5 5.5 0 007.779 7.778z"
	  }));
	});
	SearchIcon.category = 'Action';
	var _default = SearchIcon;
	exports["default"] = _default;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ServerIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M4.5 15.5h15a2 2 0 012 2v2a2 2 0 01-2 2h-15a2 2 0 01-2-2v-2a2 2 0 012-2zm0 2v2h4v-2h-4z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M21.5 14.035a3.982 3.982 0 00-2-.535h-15c-.729 0-1.412.195-2 .535V4.5a2 2 0 012-2h15a2 2 0 012 2v9.535z",
	    opacity: ".8"
	  })));
	});
	ServerIcon.category = 'Device';
	var _default = ServerIcon;
	exports["default"] = _default;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SettingIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M11 3.237l.504-.54a.637.637 0 01.9-.033l1.174.918a5.105 5.105 0 012.194-.665l.462-1.424a.637.637 0 01.765-.476l1.477.34c.344.08.558.422.479.764l-.228 1.5a5.106 5.106 0 011.625 1.528l1.465-.312a.637.637 0 01.795.424l.444 1.45a.637.637 0 01-.422.796l-1.403.549a5.095 5.095 0 01-.516 2.18l.998 1.108c.257.24.27.643.03.9l-1.034 1.11a.637.637 0 01-.9.032l-.524-.418a2.828 2.828 0 00.396-3.362l-.981-1.7a2.823 2.823 0 00-3.756-1.094l-.572.267a8.625 8.625 0 00-.828-.477l-.05-.665A2.822 2.822 0 0011 3.237z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M2.971 15.498a6.5 6.5 0 01-.016-2.925l-1.548-1.06a.823.823 0 01-.295-1.125l.982-1.7a.823.823 0 011.122-.307l1.718.801a6.624 6.624 0 012.553-1.446l.168-1.918c0-.452.37-.818.826-.818h1.964c.457 0 .827.366.827.818l.149 1.944c.93.293 1.772.785 2.473 1.425l1.729-.806a.823.823 0 011.121.307l.982 1.7c.229.396.096.9-.295 1.126l-1.56 1.068a6.504 6.504 0 01-.017 2.907l1.533 1.074c.391.226.523.73.295 1.125l-.982 1.7a.823.823 0 01-1.122.307l-1.738-.833a6.624 6.624 0 01-2.42 1.376l-.148 1.944c0 .452-.37.818-.827.818H8.481a.823.823 0 01-.826-.818l-.168-1.918a6.623 6.623 0 01-2.499-1.397l-1.728.828a.823.823 0 01-1.122-.307l-.982-1.7a.823.823 0 01.295-1.125l1.52-1.065zm6.447 1.463c1.649 0 2.985-1.323 2.985-2.955 0-1.631-1.336-2.954-2.985-2.954-1.649 0-2.985 1.323-2.985 2.954 0 1.632 1.336 2.955 2.985 2.955z"
	  })));
	});
	SettingIcon.category = 'Action';
	var _default = SettingIcon;
	exports["default"] = _default;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ShowDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M12 19.094c-3.816 0-7.314-2.09-10.745-6.27a1.25 1.25 0 010-1.586c3.43-4.18 6.93-6.27 10.745-6.27 3.816 0 7.314 2.09 10.745 6.27a1.25 1.25 0 010 1.586c-3.43 4.18-6.93 6.27-10.745 6.27zM12 17a5 5 0 100-10 5 5 0 000 10zm0-2a3 3 0 110-6 3 3 0 010 6z"
	  }));
	});
	ShowDefaultIcon.category = 'Action';
	var _default = ShowDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ShowHideIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M7.475 5.768c1.485-.7 3.007-1.05 4.568-1.05 3.82 0 7.409 2.094 10.768 6.28a1.25 1.25 0 010 1.566c-1.414 1.762-2.87 3.154-4.365 4.174l2.11 2.111a1 1 0 01-1.413 1.414L3.586 4.707A1 1 0 115 3.293l2.475 2.475zm8.74 8.74a5 5 0 00-6.929-6.929l6.929 6.928zM4.52 7.662l2.713 2.714a5 5 0 006.182 6.182l1.79 1.79a10.36 10.36 0 01-3.163.495c-3.819 0-7.408-2.094-10.768-6.28a1.25 1.25 0 010-1.565c1.06-1.32 2.141-2.432 3.246-3.336z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M9.221 10.321a3 3 0 114.165 4.165l-4.165-4.165z",
	    opacity: ".8"
	  })));
	});
	ShowHideIcon.category = 'Action';
	var _default = ShowHideIcon;
	exports["default"] = _default;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SideMenuIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4 4.5h16a1.5 1.5 0 010 3H4a1.5 1.5 0 010-3zm0 6h16a1.5 1.5 0 010 3H4a1.5 1.5 0 010-3zm0 6h16a1.5 1.5 0 010 3H4a1.5 1.5 0 010-3z"
	  }));
	});
	SideMenuIcon.category = 'Navigation';
	var _default = SideMenuIcon;
	exports["default"] = _default;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SingleServerIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4 9h16a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 012-2zm0 2v2h4v-2H4z"
	  }));
	});
	SingleServerIcon.category = 'Device';
	var _default = SingleServerIcon;
	exports["default"] = _default;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Sort19Icon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M14.136 20.013l1.494-.165c.037.304.132.53.286.676.153.146.357.22.61.22.318 0 .589-.147.812-.44.224-.293.367-.9.429-1.824-.388.45-.874.676-1.456.676-.633 0-1.18-.245-1.64-.733-.46-.49-.689-1.126-.689-1.91 0-.816.243-1.474.728-1.974s1.103-.75 1.854-.75c.816 0 1.487.316 2.01.948.524.631.786 1.67.786 3.117 0 1.472-.273 2.534-.819 3.186-.545.652-1.256.978-2.131.978-.63 0-1.139-.168-1.527-.503-.388-.335-.637-.836-.747-1.502zm3.494-3.373c0 .454-.102.798-.305 1.033a.955.955 0 01-.75.351.965.965 0 01-.77-.365c-.204-.244-.307-.625-.307-1.145 0-.513.094-.882.283-1.107a.89.89 0 01.711-.338c.3 0 .565.137.794.412.23.275.344.661.344 1.159zm.422-6.515H16.51V4.308a5.321 5.321 0 01-1.994 1.17V4.077c.403-.132.84-.382 1.313-.75.472-.368.796-.797.972-1.288h1.252v8.086zM4.5 17.153V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L5.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86z"
	  }));
	});
	Sort19Icon.category = 'Content';
	var _default = Sort19Icon;
	exports["default"] = _default;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Sort91Icon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M14.136 8.013l1.494-.165c.037.304.132.53.286.676.153.146.357.22.61.22.318 0 .589-.147.812-.44.224-.293.367-.9.429-1.824-.388.45-.874.676-1.456.676-.633 0-1.18-.245-1.64-.733-.46-.49-.689-1.126-.689-1.91 0-.816.243-1.474.728-1.974s1.103-.75 1.854-.75c.816 0 1.487.316 2.01.948.524.631.786 1.67.786 3.117 0 1.472-.273 2.534-.819 3.186-.545.652-1.256.978-2.131.978-.63 0-1.139-.168-1.527-.503-.388-.335-.637-.836-.747-1.502zM17.63 4.64c0-.498-.115-.884-.344-1.159-.229-.275-.493-.412-.794-.412a.89.89 0 00-.71.338c-.19.225-.284.594-.284 1.107 0 .52.103.901.308 1.145a.965.965 0 00.769.365.955.955 0 00.75-.351c.203-.235.305-.579.305-1.033zm.422 16.485H16.51v-5.817a5.321 5.321 0 01-1.994 1.17v-1.401c.403-.132.84-.382 1.313-.75.472-.368.796-.797.972-1.288h1.252v8.086zM4.5 17.153V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L5.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86z"
	  }));
	});
	Sort91Icon.category = 'Content';
	var _default = Sort91Icon;
	exports["default"] = _default;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortAZIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M20.205 10.125h-1.768l-.703-1.83h-3.22l-.664 1.83h-1.725l3.137-8.053h1.719l3.224 8.053zm-2.993-3.186l-1.11-2.988-1.088 2.988h2.198zM12.87 22v-1.467l4.23-5.224h-3.752v-1.362h5.894v1.263l-4.411 5.433h4.581V22h-6.542zM4.5 17.153V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L5.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86z"
	  }));
	});
	SortAZIcon.category = 'Content';
	var _default = SortAZIcon;
	exports["default"] = _default;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortAscendingIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M12 8h5.88a1.25 1.25 0 010 2.5H12V8zm0 5h7.754a1.25 1.25 0 010 2.5H12V13zm0 5h9.754a1.25 1.25 0 010 2.5H12V18zm0-15h3.754a1.25 1.25 0 010 2.5H12V3zM4.5 17.153V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L5.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86z"
	  }));
	});
	SortAscendingIcon.category = 'Content';
	var _default = SortAscendingIcon;
	exports["default"] = _default;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortDefaultDescendingIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4 15.75v-2.5h8.88a1.25 1.25 0 010 2.5H4zm0-5v-2.5h11.754a1.25 1.25 0 010 2.5H4zm0-5v-2.5h14.754a1.25 1.25 0 010 2.5H4zm0 15v-2.5h5.754a1.25 1.25 0 010 2.5H4z"
	  }));
	});
	SortDefaultDescendingIcon.category = 'Content';
	var _default = SortDefaultDescendingIcon;
	exports["default"] = _default;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4 8.25h8.88a1.25 1.25 0 010 2.5H4v-2.5zm0 5h11.754a1.25 1.25 0 010 2.5H4v-2.5zm0 5h14.754a1.25 1.25 0 010 2.5H4v-2.5zm0-15h5.754a1.25 1.25 0 010 2.5H4v-2.5z"
	  }));
	});
	SortDefaultIcon.category = 'Content';
	var _default = SortDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortDescendingIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.5 17.153V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L5.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86zM12 15.5V13h5.88a1.25 1.25 0 010 2.5H12zm0-5V8h7.754a1.25 1.25 0 010 2.5H12zm0-5V3h9.754a1.25 1.25 0 010 2.5H12zm0 15V18h3.754a1.25 1.25 0 010 2.5H12z"
	  }));
	});
	SortDescendingIcon.category = 'Content';
	var _default = SortDescendingIcon;
	exports["default"] = _default;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortDownIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M11 17.153V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L12 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0L11 17.153z"
	  }));
	});
	SortDownIcon.category = 'Content';
	var _default = SortDownIcon;
	exports["default"] = _default;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortMoveToBottomIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M5.5 17.153V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L6.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86zm11 0V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L17.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86z"
	  }));
	});
	SortMoveToBottomIcon.category = 'Content';
	var _default = SortMoveToBottomIcon;
	exports["default"] = _default;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortMoveToTopIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M5.5 6.847l-1.825 1.86a.968.968 0 01-1.388 0 1.013 1.013 0 010-1.414L6.5 3l4.213 4.293c.383.39.383 1.024 0 1.414a.968.968 0 01-1.388 0L7.5 6.847V21h-2V6.847zm11 0l-1.825 1.86a.968.968 0 01-1.388 0 1.013 1.013 0 010-1.414L17.5 3l4.213 4.293c.383.39.383 1.024 0 1.414a.968.968 0 01-1.388 0L18.5 6.847V21h-2V6.847z"
	  }));
	});
	SortMoveToTopIcon.category = 'Content';
	var _default = SortMoveToTopIcon;
	exports["default"] = _default;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortUpAndDownIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M5.5 6.847l-1.825 1.86a.968.968 0 01-1.388 0 1.013 1.013 0 010-1.414L6.5 3l4.213 4.293c.383.39.383 1.024 0 1.414a.968.968 0 01-1.388 0L7.5 6.847V21h-2V6.847zm11 10.306V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L17.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86z"
	  }));
	});
	SortUpAndDownIcon.category = 'Content';
	var _default = SortUpAndDownIcon;
	exports["default"] = _default;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortUpIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M11 6.847l-1.825 1.86a.968.968 0 01-1.388 0 1.013 1.013 0 010-1.414L12 3l4.213 4.293c.383.39.383 1.024 0 1.414a.968.968 0 01-1.388 0L13 6.847V21h-2V6.847z"
	  }));
	});
	SortUpIcon.category = 'Content';
	var _default = SortUpIcon;
	exports["default"] = _default;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SortZAIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M20.205 22h-1.768l-.703-1.83h-3.22L13.85 22h-1.725l3.137-8.053h1.719L20.205 22zm-2.993-3.186l-1.11-2.988-1.088 2.988h2.198zm-4.341-8.689V8.658l4.23-5.224h-3.752V2.072h5.894v1.263l-4.411 5.433h4.581v1.357h-6.542zM4.5 17.153V3h2v14.153l1.825-1.86a.968.968 0 011.388 0c.383.39.383 1.023 0 1.414L5.5 21l-4.213-4.293a1.013 1.013 0 010-1.414.968.968 0 011.388 0l1.825 1.86z"
	  }));
	});
	SortZAIcon.category = 'Content';
	var _default = SortZAIcon;
	exports["default"] = _default;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var StarIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M11.52 18.312a.892.892 0 01.92 0l4.43 2.663a.892.892 0 001.328-.969l-1.18-5.02a.892.892 0 01.286-.88l3.9-3.374a.892.892 0 00-.516-1.565l-5.15-.395a.892.892 0 01-.756-.548l-1.978-4.773a.892.892 0 00-1.648 0L9.177 8.224a.892.892 0 01-.755.548l-5.146.395a.892.892 0 00-.515 1.565l3.91 3.374a.892.892 0 01.284.88l-1.187 5.016a.892.892 0 001.327.97l4.425-2.66z"
	  }));
	});
	StarIcon.category = 'Content';
	var _default = StarIcon;
	exports["default"] = _default;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var StopIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M7.714 6h8.572C17.232 6 18 6.768 18 7.714v8.572c0 .946-.768 1.714-1.714 1.714H7.714A1.714 1.714 0 016 16.286V7.714C6 6.768 6.768 6 7.714 6z"
	  }));
	});
	StopIcon.category = 'Action';
	var _default = StopIcon;
	exports["default"] = _default;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SwitchIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M17.153 15.5l-1.86-1.825a.968.968 0 010-1.388 1.013 1.013 0 011.414 0L21 16.5l-4.293 4.213a1.013 1.013 0 01-1.414 0 .968.968 0 010-1.388l1.86-1.825H3v-2h14.153z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M6.847 6.5l1.86-1.825a.968.968 0 000-1.388 1.013 1.013 0 00-1.414 0L3 7.5l4.293 4.213c.39.383 1.024.383 1.414 0a.968.968 0 000-1.388L6.847 8.5H21v-2H6.847z"
	  })));
	});
	SwitchIcon.category = 'Device';
	var _default = SwitchIcon;
	exports["default"] = _default;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var SyncIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M14.313 6.21l1.628-1.168a7.996 7.996 0 00-11.538 9.452 1.035 1.035 0 102.017-.464l.003-.001a5.972 5.972 0 01-.053-.153 5.914 5.914 0 01.251-4.384 5.925 5.925 0 014.11-3.29v2.593l3.582-2.585zM7.89 18.86A7.996 7.996 0 0019.6 9.514c-.019-.1-.053-.197-.1-.288a8.092 8.092 0 00-.007-.019l-.003.001a1.035 1.035 0 00-1.912.745l-.006.003a5.916 5.916 0 01-.193 4.551 5.928 5.928 0 01-4.38 3.343v-2.734L9.594 17.59l-1.747 1.244.02.011-.011.008.032.005zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
	  }));
	});
	SyncIcon.category = 'Content';
	var _default = SyncIcon;
	exports["default"] = _default;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var TrashIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M4 7h16l-.886 14.121A2 2 0 0117.118 23H6.882a2 2 0 01-1.996-1.879L4 7zm6.25 4a2 2 0 00-2 2v6h2.5v-8h-.5zm5 0a2 2 0 00-2 2v6h2.5v-8h-.5zM10 2c0-.552.298-1 .667-1h2.666c.369 0 .667.448.667 1a.5.5 0 00.5.5h5a1 1 0 011 1V5h-17V3.5a1 1 0 011-1h5A.5.5 0 0010 2z"
	  }));
	});
	TrashIcon.category = 'Action';
	var _default = TrashIcon;
	exports["default"] = _default;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var UnknownGroupIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M19.982 9.85l.001-.096a5.587 5.587 0 00-10.21-3.138 4.5 4.5 0 00-5.757 6.733c-1.136.28-2.03.728-2.688 1.325A11.011 11.011 0 011 12C1 5.928 5.928 1 12 1c5.987 0 10.863 4.792 10.997 10.747a7.252 7.252 0 00-3.015-1.897z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M6.597 15.012c-.86.992-1.283 2.256-1.283 3.757v1.964a11.055 11.055 0 01-3.162-3.829c.443-.972 1.623-1.78 4.445-1.892zm2.36-6.543a5.603 5.603 0 00.402 3.703 2.5 2.5 0 11-.4-3.703z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10.665 15.206a7.278 7.278 0 00-.165 1.544 7.244 7.244 0 003.328 6.099 11.06 11.06 0 01-6.423-.853v-3.14c0-1.44.586-2.953 3.26-3.65zm1.35-2.893a3.496 3.496 0 115.867-2.812L17.75 9.5a7.238 7.238 0 00-5.734 2.813zM17.75 22a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm.545-3.713c-.006-.353.024-.598.09-.735.065-.137.233-.318.504-.543.523-.436.865-.78 1.025-1.033.16-.252.24-.52.24-.803 0-.512-.218-.96-.653-1.345-.436-.385-1.022-.578-1.759-.578-.7 0-1.265.19-1.696.57-.43.381-.663.844-.697 1.39l1.179.145c.082-.38.233-.663.452-.85.219-.185.492-.278.817-.278.338 0 .607.09.806.267.2.179.3.392.3.642a.8.8 0 01-.17.493c-.073.095-.296.294-.67.599-.375.304-.625.578-.75.822-.125.243-.187.554-.187.931 0 .037.001.139.005.306h1.164zm-1.179 1.754H18.4v-1.283h-1.283v1.283z"
	  })));
	});
	UnknownGroupIcon.category = 'Profile';
	var _default = UnknownGroupIcon;
	exports["default"] = _default;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var UnknownUserIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M15.337 9.12a5.343 5.343 0 10-9.649 3.414c-2.078.614-3.402 1.74-4.001 3.299A10.968 10.968 0 011 12C1 5.928 5.928 1 12 1c5.612 0 10.247 4.21 10.917 9.642A7.968 7.968 0 0017.75 8.75c-.84 0-1.652.13-2.413.37z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M12.726 22.976a10.983 10.983 0 01-9.413-4.23v-.663c0-1.868 1.032-3.866 6.687-3.866h.16a7.992 7.992 0 00-.41 2.533 7.985 7.985 0 002.976 6.226zm.533-12.847a8.042 8.042 0 00-2.347 2.466 3.346 3.346 0 01-4.255-3.217 3.343 3.343 0 116.602.75zM17.75 22.75a6 6 0 110-12 6 6 0 010 12zm.675-3.967c-.008-.478.032-.81.12-.995.089-.186.317-.431.683-.736.709-.59 1.172-1.055 1.388-1.397.216-.342.324-.704.324-1.087 0-.693-.294-1.3-.883-1.82-.59-.522-1.383-.782-2.38-.782-.948 0-1.713.257-2.296.772-.583.515-.897 1.141-.942 1.879l1.594.198c.111-.515.315-.898.612-1.15.297-.251.665-.377 1.106-.377.458 0 .821.12 1.091.362.27.24.405.53.405.868 0 .243-.076.466-.229.668-.099.127-.402.397-.908.81-.507.411-.845.782-1.014 1.112-.169.33-.253.75-.253 1.26l.006.415h1.576zM16.8 21.578h1.737v-1.737H16.8v1.737z"
	  })));
	});
	UnknownUserIcon.category = 'Profile';
	var _default = UnknownUserIcon;
	exports["default"] = _default;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var UploadDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M3 19h18a3 3 0 01-3 3H6a3 3 0 01-3-3zM14.874 8.637L13.3 10.212a.937.937 0 11-1.325-1.325L15.871 5l3.897 3.887a.937.937 0 11-1.325 1.324l-1.57-1.572V16a1 1 0 11-2 0V8.637z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M7.174 5.637L5.6 7.212a.937.937 0 11-1.325-1.325L8.171 2l3.897 3.887a.937.937 0 11-1.325 1.324L9.173 5.64V16a1 1 0 01-2 0V5.637z"
	  })));
	});
	UploadDefaultIcon.category = 'File';
	var _default = UploadDefaultIcon;
	exports["default"] = _default;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var UploadDownloadIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M3 19h18a3 3 0 01-3 3H6a3 3 0 01-3-3zm11.874-8.637V3a1 1 0 012 0v7.361l1.57-1.572a.937.937 0 111.324 1.324L15.87 14l-3.896-3.887A.937.937 0 1113.3 8.788l1.574 1.575z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M7.174 13.363L5.6 11.788a.937.937 0 10-1.325 1.325L8.171 17l3.897-3.887a.937.937 0 10-1.325-1.324l-1.57 1.572V3a1 1 0 00-2 0v10.363z"
	  })));
	});
	UploadDownloadIcon.category = 'File';
	var _default = UploadDownloadIcon;
	exports["default"] = _default;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var UserGroupIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M9.773 6.616a4.5 4.5 0 00-5.757 6.733c-1.136.28-2.03.728-2.688 1.325A11.011 11.011 0 011 12C1 5.928 5.928 1 12 1s11 4.928 11 11c0 1.167-.182 2.293-.52 3.348-.751-1.046-1.933-1.825-3.57-2.302a5.587 5.587 0 10-9.138-6.43z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M6.597 15.012c-.86.992-1.283 2.256-1.283 3.757v1.964a11.055 11.055 0 01-3.162-3.829c.443-.972 1.623-1.78 4.445-1.892zm2.36-6.543a5.603 5.603 0 00.402 3.703 2.5 2.5 0 11-.4-3.703z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M7.405 21.996v-3.14c0-1.954 1.078-4.043 6.991-4.043 5.014 0 6.529 1.469 6.893 3.08A10.995 10.995 0 0112 23c-1.64 0-3.197-.36-4.595-1.004zm6.991-8.747a3.496 3.496 0 110-6.991 3.496 3.496 0 010 6.991z"
	  })));
	});
	UserGroupIcon.category = 'Profile';
	var _default = UserGroupIcon;
	exports["default"] = _default;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var UserIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M7.688 14.534c-2.512.742-3.922 2.234-4.282 4.33A10.952 10.952 0 011 12C1 5.928 5.928 1 12 1s11 4.928 11 11c0 2.595-.9 4.98-2.405 6.862-.354-2.107-1.75-3.598-4.277-4.336a5.343 5.343 0 10-8.63.008z",
	    opacity: ".6"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M18.686 20.733A10.95 10.95 0 0112 23a10.95 10.95 0 01-6.686-2.267v-.65c0-1.868 1.031-3.866 6.686-3.866 5.745 0 6.686 2.016 6.686 3.866v.65zM12 14.721a3.343 3.343 0 110-6.686 3.343 3.343 0 010 6.686z"
	  })));
	});
	UserIcon.category = 'Profile';
	var _default = UserIcon;
	exports["default"] = _default;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var VideoIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M3 7h10c1.105 0 2 .746 2 1.667v6.666c0 .92-.895 1.667-2 1.667H3c-1.105 0-2-.746-2-1.667V8.667C1 7.747 1.895 7 3 7zm14.445 2.703l4-2.667A1 1 0 0123 7.87v8.262a1 1 0 01-1.555.833l-4-2.667a1 1 0 01-.445-.832v-2.93a1 1 0 01.445-.832z"
	  }));
	});
	VideoIcon.category = 'Media';
	var _default = VideoIcon;
	exports["default"] = _default;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var WifiRouterIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("g", {
	    fillRule: "evenodd"
	  }, /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M5 15.5v-3a1 1 0 012 0v3h13a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 012-2h1zm12 2v2h2v-2h-2zm-4 0v2h2v-2h-2zm-4 0v2h2v-2H9zm-4 0v2h2v-2H5z"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M10.975 11H8.958A3 3 0 006 8.5v-2a5 5 0 014.975 4.5z",
	    opacity: ".8"
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    d: "M14.986 11h-2.004A7 7 0 006 4.5v-2a9 9 0 018.986 8.5z",
	    opacity: ".6"
	  })));
	});
	WifiRouterIcon.category = 'Device';
	var _default = WifiRouterIcon;
	exports["default"] = _default;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ZoomInIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M11.436 9.436h1.856c.337 0 .644.195.787.5.148.317.148.683 0 1a.869.869 0 01-.787.5h-1.856v1.856a.869.869 0 01-.5.787 1.178 1.178 0 01-1 0 .869.869 0 01-.5-.787v-1.856H7.834a.869.869 0 01-.786-.5 1.178 1.178 0 010-1c.143-.305.45-.5.786-.5h1.602V7.834c0-.337.195-.643.5-.786a1.178 1.178 0 011 0c.305.143.5.45.5.786v1.602zm9.937 11.273a.934.934 0 01-.52.554 1.5 1.5 0 01-1.86-.21l-3.96-3.96a8 8 0 112.11-2.133l3.972 3.972a1.5 1.5 0 01.258 1.777zm-6.975-6.373a5.5 5.5 0 10-7.779-7.778 5.5 5.5 0 007.779 7.778z"
	  }));
	});
	ZoomInIcon.category = 'Action';
	var _default = ZoomInIcon;
	exports["default"] = _default;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _core = __webpack_require__(3);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ZoomOutIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
	    ref: ref
	  }), /*#__PURE__*/_react["default"].createElement("path", {
	    fillRule: "evenodd",
	    d: "M13.292 9.436c.337 0 .644.195.787.5.148.317.148.683 0 1a.869.869 0 01-.787.5H7.834a.869.869 0 01-.786-.5 1.178 1.178 0 010-1c.143-.305.45-.5.786-.5h5.458zm8.081 11.273a.934.934 0 01-.52.554 1.5 1.5 0 01-1.86-.21l-3.96-3.96a8 8 0 112.11-2.133l3.972 3.972a1.5 1.5 0 01.258 1.777zm-6.975-6.373a5.5 5.5 0 10-7.779-7.778 5.5 5.5 0 007.779 7.778z"
	  }));
	});
	ZoomOutIcon.category = 'Action';
	var _default = ZoomOutIcon;
	exports["default"] = _default;

/***/ },
/* 1177 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["AutosuggestHighlightMatch"] = factory();
		else
			root["AutosuggestHighlightMatch"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var removeDiacritics = __webpack_require__(1).clean;
	
	// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
	var specialCharsRegex = /[.*+?^${}()|[\]\\]/g;
	
	// http://www.ecma-international.org/ecma-262/5.1/#sec-15.10.2.6
	var wordCharacterRegex = /[a-z0-9_]/i;
	
	var whitespacesRegex = /\s+/;
	
	function escapeRegexCharacters(str) {
	  return str.replace(specialCharsRegex, '\\$&');
	}
	
	module.exports = function match(text, query) {
	  text = removeDiacritics(text);
	  query = removeDiacritics(query);
	
	  return (
	    query
	      .trim()
	      .split(whitespacesRegex)
	      // If query is blank, we'll get empty string here, so let's filter it out.
	      .filter(function(word) {
	        return word.length > 0;
	      })
	      .reduce(function(result, word) {
	        var wordLen = word.length;
	        var prefix = wordCharacterRegex.test(word[0]) ? '\\b' : '';
	        var regex = new RegExp(prefix + escapeRegexCharacters(word), 'i');
	        var index = text.search(regex);
	
	        if (index > -1) {
	          result.push([index, index + wordLen]);
	
	          // Replace what we just found with spaces so we don't find it again.
	          text =
	            text.slice(0, index) +
	            new Array(wordLen + 1).join(' ') +
	            text.slice(index + wordLen);
	        }
	
	        return result;
	      }, [])
	      .sort(function(match1, match2) {
	        return match1[0] - match2[0];
	      })
	  );
	};
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// Diacritics.js
	// 
	// Started as something to be an equivalent of the Google Java Library diacritics library for JavaScript.
	// Found this: http://jsperf.com/diacritics/6 and converted it into a reusable module.
	// 
	// @author Nijiko Yonskai
	// @license MIT
	// @copyright Nijikokun 2013 <nijikokun@gmail.com>
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
					__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
					(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
					__WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('Diacritics', function () {
	  // Create public object
	  var output = {
	    map: {}
	  };
	
	  // Create private reference map.
	  var reference = [
	    {'base':' ',    'letters':'\u00A0'},
	    {'base':'A',    'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
	    {'base':'AA',   'letters':'\uA732'},
	    {'base':'AE',   'letters':'\u00C6\u01FC\u01E2'},
	    {'base':'AO',   'letters':'\uA734'},
	    {'base':'AU',   'letters':'\uA736'},
	    {'base':'AV',   'letters':'\uA738\uA73A'},
	    {'base':'AY',   'letters':'\uA73C'},
	    {'base':'B',    'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
	    {'base':'C',    'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
	    {'base':'D',    'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
	    {'base':'DZ',   'letters':'\u01F1\u01C4'},
	    {'base':'Dz',   'letters':'\u01F2\u01C5'},
	    {'base':'E',    'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
	    {'base':'F',    'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
	    {'base':'G',    'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
	    {'base':'H',    'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
	    {'base':'I',    'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
	    {'base':'J',    'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
	    {'base':'K',    'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
	    {'base':'L',    'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
	    {'base':'LJ',   'letters':'\u01C7'},
	    {'base':'Lj',   'letters':'\u01C8'},
	    {'base':'M',    'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
	    {'base':'N',    'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
	    {'base':'NJ',   'letters':'\u01CA'},
	    {'base':'Nj',   'letters':'\u01CB'},
	    {'base':'O',    'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
	    {'base':'OI',   'letters':'\u01A2'},
	    {'base':'OO',   'letters':'\uA74E'},
	    {'base':'OU',   'letters':'\u0222'},
	    {'base':'P',    'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
	    {'base':'Q',    'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
	    {'base':'R',    'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
	    {'base':'S',    'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
	    {'base':'T',    'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
	    {'base':'Th',   'letters':'\u00DE'},
	    {'base':'TZ',   'letters':'\uA728'},
	    {'base':'U',    'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
	    {'base':'V',    'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
	    {'base':'VY',   'letters':'\uA760'},
	    {'base':'W',    'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
	    {'base':'X',    'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
	    {'base':'Y',    'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
	    {'base':'Z',    'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
	    {'base':'a',    'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251'},
	    {'base':'aa',   'letters':'\uA733'},
	    {'base':'ae',   'letters':'\u00E6\u01FD\u01E3'},
	    {'base':'ao',   'letters':'\uA735'},
	    {'base':'au',   'letters':'\uA737'},
	    {'base':'av',   'letters':'\uA739\uA73B'},
	    {'base':'ay',   'letters':'\uA73D'},
	    {'base':'b',    'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
	    {'base':'c',    'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
	    {'base':'d',    'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
	    {'base':'dz',   'letters':'\u01F3\u01C6'},
	    {'base':'e',    'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
	    {'base':'f',    'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
	    {'base':'ff',   'letters':'\uFB00'},
	    {'base':'fi',   'letters':'\uFB01'},
	    {'base':'fl',   'letters':'\uFB02'},
	    {'base':'ffi',  'letters':'\uFB03'},
	    {'base':'ffl',  'letters':'\uFB04'},
	    {'base':'g',    'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
	    {'base':'h',    'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
	    {'base':'hv',   'letters':'\u0195'},
	    {'base':'i',    'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
	    {'base':'j',    'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
	    {'base':'k',    'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
	    {'base':'l',    'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
	    {'base':'lj',   'letters':'\u01C9'},
	    {'base':'m',    'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
	    {'base':'n',    'letters':'\x6E\xF1\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509'},
	    {'base':'nj',   'letters':'\u01CC'},
	    {'base':'o',    'letters':'\u07C0\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
	    {'base':'oe',   'letters':'\u0152\u0153'},
	    {'base':'oi',   'letters':'\u01A3'},
	    {'base':'ou',   'letters':'\u0223'},
	    {'base':'oo',   'letters':'\uA74F'},
	    {'base':'p',    'letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
	    {'base':'q',    'letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
	    {'base':'r',    'letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
	    {'base':'s',    'letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
	    {'base':'ss',   'letters':'\xDF'},
	    {'base':'t',    'letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
	    {'base':'th',   'letters':'\u00FE'},
	    {'base':'tz',   'letters':'\uA729'},
	    {'base':'u',    'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
	    {'base':'v',    'letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
	    {'base':'vy',   'letters':'\uA761'},
	    {'base':'w',    'letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
	    {'base':'x',    'letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
	    {'base':'y',    'letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
	    {'base':'z',    'letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
	  ];
	
	  // Generate reference mapping
	  for (var i = 0, refLength = reference.length; i < refLength; i++){
	    var letters = reference[i].letters.split("");
	
	    for (var j = 0, letLength = letters.length; j < letLength; j++){
	      output.map[letters[j]] = reference[i].base;
	    }
	  }
	
	  /**
	   * Clean accents (diacritics) from string.
	   * 
	   * @param  {String} input String to be cleaned of diacritics.
	   * @return {String}
	   */
	  output.clean = function (input) {
	    if (!input || !input.length || input.length < 1) {
	      return "";
	    }
	
	    var string = "";
	    var letters = input.split("");
	    var index = 0;
	    var length = letters.length;
	    var letter;
	
	    for (; index < length; index++) {
	      letter = letters[index];
	      string += letter in output.map ? output.map[letter] : letter;
	    }
	
	    return string;
	  };
	
	  return output;
	});
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["AutosuggestHighlightParse"] = factory();
		else
			root["AutosuggestHighlightParse"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = function parse(text, matches) {
	  var result = [];
	
	  if (matches.length === 0) {
	    result.push({
	      text: text,
	      highlight: false
	    });
	  } else {
	    if (matches[0][0] > 0) {
	      result.push({
	        text: text.slice(0, matches[0][0]),
	        highlight: false
	      });
	    }
	  }
	
	  matches.forEach(function(match, i) {
	    var startIndex = match[0];
	    var endIndex = match[1];
	
	    result.push({
	      text: text.slice(startIndex, endIndex),
	      highlight: true
	    });
	
	    if (i === matches.length - 1) {
	      if (endIndex < text.length) {
	        result.push({
	          text: text.slice(endIndex, text.length),
	          highlight: false
	        });
	      }
	    } else if (endIndex < matches[i + 1][0]) {
	      result.push({
	        text: text.slice(endIndex, matches[i + 1][0]),
	        highlight: false
	      });
	    }
	  });
	
	  return result;
	};
	
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	var bind = __webpack_require__(384);
	var Axios = __webpack_require__(1182);
	var mergeConfig = __webpack_require__(382);
	var defaults = __webpack_require__(383);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(379);
	axios.CancelToken = __webpack_require__(1181);
	axios.isCancel = __webpack_require__(380);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(1194);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(379);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	var buildURL = __webpack_require__(385);
	var InterceptorManager = __webpack_require__(1183);
	var dispatchRequest = __webpack_require__(1184);
	var mergeConfig = __webpack_require__(382);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	  config.method = config.method ? config.method.toLowerCase() : 'get';
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	var transformData = __webpack_require__(1187);
	var isCancel = __webpack_require__(380);
	var defaults = __webpack_require__(383);
	var isAbsoluteURL = __webpack_require__(1190);
	var combineURLs = __webpack_require__(1188);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 1185 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(381);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 1188 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 1190 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 1194 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1196);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1196 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code, and use
		// it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var InvalidCharacterError = function(message) {
			this.message = message;
		};
		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
		var error = function(message) {
			// Note: the error messages used throughout this file match those used by
			// the native `atob`/`btoa` implementation in Chromium.
			throw new InvalidCharacterError(message);
		};
	
		var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		// http://whatwg.org/html/common-microsyntaxes.html#space-character
		var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
	
		// `decode` is designed to be fully compatible with `atob` as described in the
		// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
		// The optimized base64-decoding algorithm used is based on @atk’s excellent
		// implementation. https://gist.github.com/atk/1020396
		var decode = function(input) {
			input = String(input)
				.replace(REGEX_SPACE_CHARACTERS, '');
			var length = input.length;
			if (length % 4 == 0) {
				input = input.replace(/==?$/, '');
				length = input.length;
			}
			if (
				length % 4 == 1 ||
				// http://whatwg.org/C#alphanumeric-ascii-characters
				/[^+a-zA-Z0-9/]/.test(input)
			) {
				error(
					'Invalid character: the string to be decoded is not correctly encoded.'
				);
			}
			var bitCounter = 0;
			var bitStorage;
			var buffer;
			var output = '';
			var position = -1;
			while (++position < length) {
				buffer = TABLE.indexOf(input.charAt(position));
				bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
				// Unless this is the first of a group of 4 characters…
				if (bitCounter++ % 4) {
					// …convert the first 8 bits to a single ASCII character.
					output += String.fromCharCode(
						0xFF & bitStorage >> (-2 * bitCounter & 6)
					);
				}
			}
			return output;
		};
	
		// `encode` is designed to be fully compatible with `btoa` as described in the
		// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
		var encode = function(input) {
			input = String(input);
			if (/[^\0-\xFF]/.test(input)) {
				// Note: no need to special-case astral symbols here, as surrogates are
				// matched, and the input is supposed to only contain ASCII anyway.
				error(
					'The string to be encoded contains characters outside of the ' +
					'Latin1 range.'
				);
			}
			var padding = input.length % 3;
			var output = '';
			var position = -1;
			var a;
			var b;
			var c;
			var d;
			var buffer;
			// Make sure any padding is handled outside of the loop.
			var length = input.length - padding;
	
			while (++position < length) {
				// Read three bytes, i.e. 24 bits.
				a = input.charCodeAt(position) << 16;
				b = input.charCodeAt(++position) << 8;
				c = input.charCodeAt(++position);
				buffer = a + b + c;
				// Turn the 24 bits into four chunks of 6 bits each, and append the
				// matching character for each of them to the output.
				output += (
					TABLE.charAt(buffer >> 18 & 0x3F) +
					TABLE.charAt(buffer >> 12 & 0x3F) +
					TABLE.charAt(buffer >> 6 & 0x3F) +
					TABLE.charAt(buffer & 0x3F)
				);
			}
	
			if (padding == 2) {
				a = input.charCodeAt(position) << 8;
				b = input.charCodeAt(++position);
				buffer = a + b;
				output += (
					TABLE.charAt(buffer >> 10) +
					TABLE.charAt((buffer >> 4) & 0x3F) +
					TABLE.charAt((buffer << 2) & 0x3F) +
					'='
				);
			} else if (padding == 1) {
				buffer = input.charCodeAt(position);
				output += (
					TABLE.charAt(buffer >> 2) +
					TABLE.charAt((buffer << 4) & 0x3F) +
					'=='
				);
			}
	
			return output;
		};
	
		var base64 = {
			'encode': encode,
			'decode': decode,
			'version': '0.1.0'
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return base64;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = base64;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in base64) {
					base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.base64 = base64;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module), (function() { return this; }())))

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.camelCase = exports.camelCaseTransformMerge = exports.camelCaseTransform = void 0;
	var tslib_1 = __webpack_require__(1199);
	var pascal_case_1 = __webpack_require__(588);
	function camelCaseTransform(input, index) {
	    if (index === 0)
	        return input.toLowerCase();
	    return pascal_case_1.pascalCaseTransform(input, index);
	}
	exports.camelCaseTransform = camelCaseTransform;
	function camelCaseTransformMerge(input, index) {
	    if (index === 0)
	        return input.toLowerCase();
	    return pascal_case_1.pascalCaseTransformMerge(input);
	}
	exports.camelCaseTransformMerge = camelCaseTransformMerge;
	function camelCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return pascal_case_1.pascalCase(input, tslib_1.__assign({ transform: camelCaseTransform }, options));
	}
	exports.camelCase = camelCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };
	
	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __spreadArray = function (to, from) {
	        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	            to[j] = from[i];
	        return to;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1200 */
1199,
/* 1201 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(387);
	var route = __webpack_require__(1203);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(387);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(388);
	var swizzle = __webpack_require__(1762);
	
	var reverseNames = {};
	
	// create a list of reverse color names
	for (var name in colorNames) {
		if (colorNames.hasOwnProperty(name)) {
			reverseNames[colorNames[name]] = name;
		}
	}
	
	var cs = module.exports = {
		to: {},
		get: {}
	};
	
	cs.get = function (string) {
		var prefix = string.substring(0, 3).toLowerCase();
		var val;
		var model;
		switch (prefix) {
			case 'hsl':
				val = cs.get.hsl(string);
				model = 'hsl';
				break;
			case 'hwb':
				val = cs.get.hwb(string);
				model = 'hwb';
				break;
			default:
				val = cs.get.rgb(string);
				model = 'rgb';
				break;
		}
	
		if (!val) {
			return null;
		}
	
		return {model: model, value: val};
	};
	
	cs.get.rgb = function (string) {
		if (!string) {
			return null;
		}
	
		var abbr = /^#([a-f0-9]{3,4})$/i;
		var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
		var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var keyword = /(\D+)/;
	
		var rgb = [0, 0, 0, 1];
		var match;
		var i;
		var hexAlpha;
	
		if (match = string.match(hex)) {
			hexAlpha = match[2];
			match = match[1];
	
			for (i = 0; i < 3; i++) {
				// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
				var i2 = i * 2;
				rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
			}
	
			if (hexAlpha) {
				rgb[3] = parseInt(hexAlpha, 16) / 255;
			}
		} else if (match = string.match(abbr)) {
			match = match[1];
			hexAlpha = match[3];
	
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i] + match[i], 16);
			}
	
			if (hexAlpha) {
				rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
			}
		} else if (match = string.match(rgba)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i + 1], 0);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(per)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(keyword)) {
			if (match[1] === 'transparent') {
				return [0, 0, 0, 0];
			}
	
			rgb = colorNames[match[1]];
	
			if (!rgb) {
				return null;
			}
	
			rgb[3] = 1;
	
			return rgb;
		} else {
			return null;
		}
	
		for (i = 0; i < 3; i++) {
			rgb[i] = clamp(rgb[i], 0, 255);
		}
		rgb[3] = clamp(rgb[3], 0, 1);
	
		return rgb;
	};
	
	cs.get.hsl = function (string) {
		if (!string) {
			return null;
		}
	
		var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hsl);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = (parseFloat(match[1]) + 360) % 360;
			var s = clamp(parseFloat(match[2]), 0, 100);
			var l = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	
			return [h, s, l, a];
		}
	
		return null;
	};
	
	cs.get.hwb = function (string) {
		if (!string) {
			return null;
		}
	
		var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hwb);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var w = clamp(parseFloat(match[2]), 0, 100);
			var b = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
			return [h, w, b, a];
		}
	
		return null;
	};
	
	cs.to.hex = function () {
		var rgba = swizzle(arguments);
	
		return (
			'#' +
			hexDouble(rgba[0]) +
			hexDouble(rgba[1]) +
			hexDouble(rgba[2]) +
			(rgba[3] < 1
				? (hexDouble(Math.round(rgba[3] * 255)))
				: '')
		);
	};
	
	cs.to.rgb = function () {
		var rgba = swizzle(arguments);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
			: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
	};
	
	cs.to.rgb.percent = function () {
		var rgba = swizzle(arguments);
	
		var r = Math.round(rgba[0] / 255 * 100);
		var g = Math.round(rgba[1] / 255 * 100);
		var b = Math.round(rgba[2] / 255 * 100);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
			: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
	};
	
	cs.to.hsl = function () {
		var hsla = swizzle(arguments);
		return hsla.length < 4 || hsla[3] === 1
			? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
			: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
	};
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	cs.to.hwb = function () {
		var hwba = swizzle(arguments);
	
		var a = '';
		if (hwba.length >= 4 && hwba[3] !== 1) {
			a = ', ' + hwba[3];
		}
	
		return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
	};
	
	cs.to.keyword = function (rgb) {
		return reverseNames[rgb.slice(0, 3)];
	};
	
	// helpers
	function clamp(num, min, max) {
		return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
		var str = num.toString(16).toUpperCase();
		return (str.length < 2) ? '0' + str : str;
	}


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1211));
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(279);
	
	var _actions = __webpack_require__(174);
	
	var _selectors = _interopRequireDefault(__webpack_require__(389));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var createConnectedRouter = function createConnectedRouter(structure) {
	  var _createSelectors = (0, _selectors.default)(structure),
	      getLocation = _createSelectors.getLocation;
	  /*
	   * ConnectedRouter listens to a history object passed from props.
	   * When history is changed, it dispatches action to redux store.
	   * Then, store will pass props to component to render.
	   * This creates uni-directional flow from history->store->router->components.
	   */
	
	
	  var ConnectedRouter =
	  /*#__PURE__*/
	  function (_PureComponent) {
	    _inherits(ConnectedRouter, _PureComponent);
	
	    function ConnectedRouter(props) {
	      var _this;
	
	      _classCallCheck(this, ConnectedRouter);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(ConnectedRouter).call(this, props));
	      var store = props.store,
	          history = props.history,
	          onLocationChanged = props.onLocationChanged;
	      _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling
	
	      _this.unsubscribe = store.subscribe(function () {
	        // Extract store's location
	        var _getLocation = getLocation(store.getState()),
	            pathnameInStore = _getLocation.pathname,
	            searchInStore = _getLocation.search,
	            hashInStore = _getLocation.hash; // Extract history's location
	
	
	        var _history$location = history.location,
	            pathnameInHistory = _history$location.pathname,
	            searchInHistory = _history$location.search,
	            hashInHistory = _history$location.hash; // If we do time travelling, the location in store is changed but location in history is not changed
	
	        if (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore) {
	          _this.inTimeTravelling = true; // Update history's location to match store's location
	
	          history.push({
	            pathname: pathnameInStore,
	            search: searchInStore,
	            hash: hashInStore
	          });
	        }
	      });
	
	      var handleLocationChange = function handleLocationChange(location, action) {
	        var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        // Dispatch onLocationChanged except when we're in time travelling
	        if (!_this.inTimeTravelling) {
	          onLocationChanged(location, action, isFirstRendering);
	        } else {
	          _this.inTimeTravelling = false;
	        }
	      }; // Listen to history changes
	
	
	      _this.unlisten = history.listen(handleLocationChange); // Dispatch a location change action for the initial location.
	      // This makes it backward-compatible with react-router-redux.
	      // But, we add `isFirstRendering` to `true` to prevent double-rendering.
	
	      handleLocationChange(history.location, history.action, true);
	      return _this;
	    }
	
	    _createClass(ConnectedRouter, [{
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.unlisten();
	        this.unsubscribe();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this$props = this.props,
	            history = _this$props.history,
	            children = _this$props.children;
	        return _react.default.createElement(_reactRouter.Router, {
	          history: history
	        }, children);
	      }
	    }]);
	
	    return ConnectedRouter;
	  }(_react.PureComponent);
	
	  ConnectedRouter.propTypes = {
	    store: _propTypes.default.shape({
	      getState: _propTypes.default.func.isRequired,
	      subscribe: _propTypes.default.func.isRequired
	    }).isRequired,
	    history: _propTypes.default.shape({
	      action: _propTypes.default.string.isRequired,
	      listen: _propTypes.default.func.isRequired,
	      location: _propTypes.default.object.isRequired,
	      push: _propTypes.default.func.isRequired
	    }).isRequired,
	    basename: _propTypes.default.string,
	    children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]),
	    onLocationChanged: _propTypes.default.func.isRequired
	  };
	
	  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	      onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
	        return dispatch((0, _actions.onLocationChanged)(location, action, isFirstRendering));
	      }
	    };
	  };
	
	  var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
	    var Context = props.context || _reactRedux.ReactReduxContext;
	
	    if (Context == null) {
	      throw 'Please upgrade to react-redux v6';
	    }
	
	    return _react.default.createElement(Context.Consumer, null, function (_ref) {
	      var store = _ref.store;
	      return _react.default.createElement(ConnectedRouter, _extends({
	        store: store
	      }, props));
	    });
	  };
	
	  ConnectedRouterWithContext.propTypes = {
	    context: _propTypes.default.object
	  };
	  return (0, _reactRedux.connect)(null, mapDispatchToProps)(ConnectedRouterWithContext);
	};
	
	var _default = createConnectedRouter;
	exports.default = _default;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _actions = __webpack_require__(174);
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	var routerMiddleware = function routerMiddleware(history) {
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        // eslint-disable-line no-unused-vars
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	};
	
	var _default = routerMiddleware;
	exports.default = _default;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _actions = __webpack_require__(174);
	
	var createConnectRouter = function createConnectRouter(structure) {
	  var fromJS = structure.fromJS,
	      merge = structure.merge;
	
	  var createRouterReducer = function createRouterReducer(history) {
	    var initialRouterState = fromJS({
	      location: history.location,
	      action: history.action
	    });
	    /*
	    * This reducer will update the state with the most recent location history
	    * has transitioned to.
	    */
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;
	
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          type = _ref.type,
	          payload = _ref.payload;
	
	      if (type === _actions.LOCATION_CHANGE) {
	        var location = payload.location,
	            action = payload.action,
	            isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
	        // to prevent the double-rendering issue on initilization
	
	        return isFirstRendering ? state : merge(state, {
	          location: fromJS(location),
	          action: action
	        });
	      }
	
	      return state;
	    };
	  };
	
	  return createRouterReducer;
	};
	
	var _default = createConnectRouter;
	exports.default = _default;

/***/ },
/* 1208 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* Code from github.com/erikras/redux-form by Erik Rasmussen */
	var getIn = function getIn(state, path) {
	  if (!state) {
	    return state;
	  }
	
	  var length = path.length;
	
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	
	  for (var i = 0; i < length && !!result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	var _default = getIn;
	exports.default = _default;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _getIn = _interopRequireDefault(__webpack_require__(1208));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var structure = {
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  getIn: _getIn.default,
	  merge: function merge(state, payload) {
	    return _objectSpread({}, state, payload);
	  },
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	var _default = structure;
	exports.default = _default;

/***/ },
/* 1210 */
[1912, 1212],
/* 1211 */
[1913, 1210],
/* 1212 */
918,
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.constantCase = void 0;
	var tslib_1 = __webpack_require__(1214);
	var no_case_1 = __webpack_require__(120);
	var upper_case_1 = __webpack_require__(1771);
	function constantCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return no_case_1.noCase(input, tslib_1.__assign({ delimiter: "_", transform: upper_case_1.upperCase }, options));
	}
	exports.constantCase = constantCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1214 */
1199,
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(704));
	var unitless = _interopDefault(__webpack_require__(706));
	var hashString = _interopDefault(__webpack_require__(1216));
	var Stylis = _interopDefault(__webpack_require__(705));
	var stylisRuleSheet = _interopDefault(__webpack_require__(1767));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    return oldProcessStyleValue(key, value);
	  };
	}
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        if (false) {
	          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
	        }
	
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = ("production") === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	    this.tags = [];
	    this.ctr = 0;
	    this.opts = options;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.inject = function inject() {
	    if (this.injected) {
	      throw new Error('already injected!');
	    }
	
	    this.tags[0] = makeStyleTag(this.opts);
	    this.injected = true;
	  };
	
	  _proto.speedy = function speedy(bool) {
	    if (this.ctr !== 0) {
	      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	      throw new Error("cannot change speedy now");
	    }
	
	    this.isSpeedy = !!bool;
	  };
	
	  _proto.insert = function insert(rule, sourceMap) {
	    // this is the ultrafast version, works across browsers
	    if (this.isSpeedy) {
	      var tag = this.tags[this.tags.length - 1];
	      var sheet = sheetForTag(tag);
	
	      try {
	        sheet.insertRule(rule, sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn('illegal rule', rule); // eslint-disable-line no-console
	        }
	      }
	    } else {
	      var _tag = makeStyleTag(this.opts);
	
	      this.tags.push(_tag);
	
	      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	    }
	
	    this.ctr++;
	
	    if (this.ctr % 65000 === 0) {
	      this.tags.push(makeStyleTag(this.opts));
	    }
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	    this.injected = false;
	  };
	
	  return StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (context.__SECRET_EMOTION__ !== undefined) {
	    return context.__SECRET_EMOTION__;
	  }
	
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (false) {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = stylisRuleSheet(insertRule);
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var caches = {
	    registered: {},
	    inserted: {},
	    nonce: options.nonce,
	    key: key
	  };
	  var sheet = new StyleSheet(options);
	
	  if (isBrowser) {
	    // 🚀
	    sheet.inject();
	  }
	
	  var stylis = new Stylis(stylisOptions);
	  stylis.use(options.stylisPlugins)(insertionPlugin);
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation.__emotion_styles !== undefined) {
	          var selector = interpolation.toString();
	
	          if (selector === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          return selector;
	        }
	
	        if (this === undefined && ("production") !== 'production') {
	          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    if (Array.isArray(obj)) {
	      obj.forEach(function (interpolation) {
	        string += handleInterpolation.call(this, interpolation, false);
	      }, this);
	    } else {
	      Object.keys(obj).forEach(function (key) {
	        if (typeof obj[key] !== 'object') {
	          if (caches.registered[obj[key]] !== undefined) {
	            string += key + "{" + caches.registered[obj[key]] + "}";
	          } else {
	            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	          }
	        } else {
	          if (key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
	            obj[key].forEach(function (value) {
	              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
	            });
	          } else {
	            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	          }
	        }
	      }, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var stylesWithLabel;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createClassName = function createClassName(styles, identifierName) {
	    return hashString(styles + identifierName) + identifierName;
	  };
	
	  if (false) {
	    var oldCreateClassName = createClassName;
	    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
	
	    createClassName = function createClassName(styles, identifierName) {
	      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
	        currentSourceMap = sourceMap;
	        return '';
	      }), identifierName);
	    };
	  }
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    stylesWithLabel = styles;
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = createClassName(styles, identifierName);
	    return styles;
	  };
	
	  if (false) {
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = stylesWithLabel;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  if (isBrowser) {
	    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(chunks, function (node) {
	      // $FlowFixMe
	      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	    });
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  context.__SECRET_EMOTION__ = emotion;
	  return emotion;
	}
	
	module.exports = createEmotion;


/***/ },
/* 1216 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	module.exports = murmurhash2_32_gc;


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var isInBrowser = _interopDefault(__webpack_require__(403));
	var _toConsumableArray = _interopDefault(__webpack_require__(51));
	
	// Export javascript style and css style vendor prefixes.
	var js = '';
	var css = '';
	var vendor = '';
	var browser = '';
	var isTouch = isInBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
	
	if (isInBrowser) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	
	  var _document$createEleme = document.createElement('p'),
	      style = _document$createEleme.style;
	
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  } // Correctly detect the Edge browser.
	
	
	  if (js === 'Webkit' && 'msHyphens' in style) {
	    js = 'ms';
	    css = jsCssMap.ms;
	    browser = 'edge';
	  } // Correctly detect the Safari browser.
	
	
	  if (js === 'Webkit' && '-apple-trailing-word' in style) {
	    vendor = 'apple';
	  }
	}
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String, vendor: String, browser: String}}
	 * @api public
	 */
	
	
	var prefix = {
	  js: js,
	  css: css,
	  vendor: vendor,
	  browser: browser,
	  isTouch: isTouch
	};
	
	/**
	 * Test if a keyframe at-rule should be prefixed or not
	 *
	 * @param {String} vendor prefix string for the current browser.
	 * @return {String}
	 * @api public
	 */
	
	function supportedKeyframes(key) {
	  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
	  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
	  // https://caniuse.com/#search=keyframes
	
	  if (prefix.js === 'ms') return key;
	  return "@" + prefix.css + "keyframes" + key.substr(10);
	}
	
	// https://caniuse.com/#search=appearance
	
	var appearence = {
	  noPrefill: ['appearance'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'appearance') return false;
	    if (prefix.js === 'ms') return "-webkit-" + prop;
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=color-adjust
	
	var colorAdjust = {
	  noPrefill: ['color-adjust'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'color-adjust') return false;
	    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
	    return prop;
	  }
	};
	
	var regExp = /[-\s]+(.)?/g;
	/**
	 * Replaces the letter with the capital letter
	 *
	 * @param {String} match
	 * @param {String} c
	 * @return {String}
	 * @api private
	 */
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}
	/**
	 * Convert dash separated strings to camel-cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	/**
	 * Convert dash separated strings to pascal cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function pascalize(str) {
	  return camelize("-" + str);
	}
	
	// but we can use a longhand property instead.
	// https://caniuse.com/#search=mask
	
	var mask = {
	  noPrefill: ['mask'],
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^mask/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var longhand = 'mask-image';
	
	      if (camelize(longhand) in style) {
	        return prop;
	      }
	
	      if (prefix.js + pascalize(longhand) in style) {
	        return prefix.css + prop;
	      }
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=text-orientation
	
	var textOrientation = {
	  noPrefill: ['text-orientation'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'text-orientation') return false;
	
	    if (prefix.vendor === 'apple' && !prefix.isTouch) {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=transform
	
	var transform = {
	  noPrefill: ['transform'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transform') return false;
	
	    if (options.transform) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=transition
	
	var transition = {
	  noPrefill: ['transition'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transition') return false;
	
	    if (options.transition) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=writing-mode
	
	var writingMode = {
	  noPrefill: ['writing-mode'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'writing-mode') return false;
	
	    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=user-select
	
	var userSelect = {
	  noPrefill: ['user-select'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'user-select') return false;
	
	    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=multicolumn
	// https://github.com/postcss/autoprefixer/issues/491
	// https://github.com/postcss/autoprefixer/issues/177
	
	var breakPropsOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^break-/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var jsProp = "WebkitColumn" + pascalize(prop);
	      return jsProp in style ? prefix.css + "column-" + prop : false;
	    }
	
	    if (prefix.js === 'Moz') {
	      var _jsProp = "page" + pascalize(prop);
	
	      return _jsProp in style ? "page-" + prop : false;
	    }
	
	    return false;
	  }
	};
	
	// See https://github.com/postcss/autoprefixer/issues/324.
	
	var inlineLogicalOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
	    if (prefix.js === 'Moz') return prop;
	    var newProp = prop.replace('-inline', '');
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	// Camelization is required because we can't test using.
	// CSS syntax for e.g. in FF.
	
	var unprefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    return camelize(prop) in style ? prop : false;
	  }
	};
	
	var prefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
	
	    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
	
	    if (prop[0] === '-' && prop[1] === '-') return prop;
	    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
	
	    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
	    return false;
	  }
	};
	
	// https://caniuse.com/#search=scroll-snap
	
	var scrollSnap = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop.substring(0, 11) !== 'scroll-snap') return false;
	
	    if (prefix.js === 'ms') {
	      return "" + prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=overscroll-behavior
	
	var overscrollBehavior = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'overscroll-behavior') return false;
	
	    if (prefix.js === 'ms') {
	      return prefix.css + "scroll-chaining";
	    }
	
	    return prop;
	  }
	};
	
	var propMap = {
	  'flex-grow': 'flex-positive',
	  'flex-shrink': 'flex-negative',
	  'flex-basis': 'flex-preferred-size',
	  'justify-content': 'flex-pack',
	  order: 'flex-order',
	  'align-items': 'flex-align',
	  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
	
	}; // Support old flex spec from 2012.
	
	var flex2012 = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var newProp = propMap[prop];
	    if (!newProp) return false;
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	var propMap$1 = {
	  flex: 'box-flex',
	  'flex-grow': 'box-flex',
	  'flex-direction': ['box-orient', 'box-direction'],
	  order: 'box-ordinal-group',
	  'align-items': 'box-align',
	  'flex-flow': ['box-orient', 'box-direction'],
	  'justify-content': 'box-pack'
	};
	var propKeys = Object.keys(propMap$1);
	
	var prefixCss = function prefixCss(p) {
	  return prefix.css + p;
	}; // Support old flex spec from 2009.
	
	
	var flex2009 = {
	  supportedProperty: function supportedProperty(prop, style, _ref) {
	    var multiple = _ref.multiple;
	
	    if (propKeys.indexOf(prop) > -1) {
	      var newProp = propMap$1[prop];
	
	      if (!Array.isArray(newProp)) {
	        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	      }
	
	      if (!multiple) return false;
	
	      for (var i = 0; i < newProp.length; i++) {
	        if (!(prefix.js + pascalize(newProp[0]) in style)) {
	          return false;
	        }
	      }
	
	      return newProp.map(prefixCss);
	    }
	
	    return false;
	  }
	};
	
	// plugins = [
	//   ...plugins,
	//    breakPropsOld,
	//    inlineLogicalOld,
	//    unprefixed,
	//    prefixed,
	//    scrollSnap,
	//    flex2012,
	//    flex2009
	// ]
	// Plugins without 'noPrefill' value, going last.
	// 'flex-*' plugins should be at the bottom.
	// 'flex2009' going after 'flex2012'.
	// 'prefixed' going after 'unprefixed'
	
	var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
	var propertyDetectors = plugins.filter(function (p) {
	  return p.supportedProperty;
	}).map(function (p) {
	  return p.supportedProperty;
	});
	var noPrefill = plugins.filter(function (p) {
	  return p.noPrefill;
	}).reduce(function (a, p) {
	  a.push.apply(a, _toConsumableArray(p.noPrefill));
	  return a;
	}, []);
	
	var el;
	var cache = {};
	
	if (isInBrowser) {
	  el = document.createElement('p'); // We test every property on vendor prefix requirement.
	  // Once tested, result is cached. It gives us up to 70% perf boost.
	  // http://jsperf.com/element-style-object-access-vs-plain-object
	  //
	  // Prefill cache with known css properties to reduce amount of
	  // properties we need to feature test at runtime.
	  // http://davidwalsh.name/vendor-prefix
	
	  var computed = window.getComputedStyle(document.documentElement, '');
	
	  for (var key$1 in computed) {
	    // eslint-disable-next-line no-restricted-globals
	    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
	  } // Properties that cannot be correctly detected using the
	  // cache prefill method.
	
	
	  noPrefill.forEach(function (x) {
	    return delete cache[x];
	  });
	}
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @param {Object} [options]
	 * @return {String|Boolean}
	 * @api public
	 */
	
	
	function supportedProperty(prop, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  // For server-side rendering.
	  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
	
	  if (("production") !== 'benchmark' && cache[prop] != null) {
	    return cache[prop];
	  } // Check if 'transition' or 'transform' natively supported in browser.
	
	
	  if (prop === 'transition' || prop === 'transform') {
	    options[prop] = prop in el.style;
	  } // Find a plugin for current prefix property.
	
	
	  for (var i = 0; i < propertyDetectors.length; i++) {
	    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
	
	    if (cache[prop]) break;
	  } // Reset styles for current property.
	  // Firefox can even throw an error for invalid properties, e.g., "0".
	
	
	  try {
	    el.style[prop] = '';
	  } catch (err) {
	    return false;
	  }
	
	  return cache[prop];
	}
	
	var cache$1 = {};
	var transitionProperties = {
	  transition: 1,
	  'transition-property': 1,
	  '-webkit-transition': 1,
	  '-webkit-transition-property': 1
	};
	var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
	var el$1;
	/**
	 * Returns prefixed value transition/transform if needed.
	 *
	 * @param {String} match
	 * @param {String} p1
	 * @param {String} p2
	 * @return {String}
	 * @api private
	 */
	
	function prefixTransitionCallback(match, p1, p2) {
	  if (p1 === 'var') return 'var';
	  if (p1 === 'all') return 'all';
	  if (p2 === 'all') return ', all';
	  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
	  if (!prefixedValue) return p1 || p2;
	  return prefixedValue;
	}
	
	if (isInBrowser) el$1 = document.createElement('p');
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	
	function supportedValue(property, value) {
	  // For server-side rendering.
	  var prefixedValue = value;
	  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  // eslint-disable-next-line no-restricted-globals
	
	  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
	    return prefixedValue;
	  } // Create cache key for current value.
	
	
	  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
	
	  if (("production") !== 'benchmark' && cache$1[cacheKey] != null) {
	    return cache$1[cacheKey];
	  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
	
	
	  try {
	    // Test value as it is.
	    el$1.style[property] = prefixedValue;
	  } catch (err) {
	    // Return false if value not supported.
	    cache$1[cacheKey] = false;
	    return false;
	  } // If 'transition' or 'transition-property' property.
	
	
	  if (transitionProperties[property]) {
	    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
	  } else if (el$1.style[property] === '') {
	    // Value with a vendor prefix.
	    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	
	    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
	
	    el$1.style[property] = prefixedValue; // Return false if value not supported.
	
	    if (el$1.style[property] === '') {
	      cache$1[cacheKey] = false;
	      return false;
	    }
	  } // Reset styles for current property.
	
	
	  el$1.style[property] = ''; // Write current value to cache.
	
	  cache$1[cacheKey] = prefixedValue;
	  return cache$1[cacheKey];
	}
	
	exports.prefix = prefix;
	exports.supportedKeyframes = supportedKeyframes;
	exports.supportedProperty = supportedProperty;
	exports.supportedValue = supportedValue;


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ v1.0.7 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return (+t === 1) ? 1 : 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	// tpmt is two power minus ten times t scaled to [0,1]
	function tpmt(x) {
	  return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
	}
	
	function expIn(t) {
	  return tpmt(1 - +t);
	}
	
	function expOut(t) {
	  return 1 - tpmt(t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return (t = +t) * t * (s * (t - 1) + t);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((t + 1) * s + t) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * tpmt(-(--t)) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * tpmt(-t) * Math.sin((s - t) / p)
	        : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackInOut = backInOut;
	exports.easeBackOut = backOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBounceOut = bounceOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleInOut = circleInOut;
	exports.easeCircleOut = circleOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicInOut = cubicInOut;
	exports.easeCubicOut = cubicOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticInOut = elasticInOut;
	exports.easeElasticOut = elasticOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpInOut = expInOut;
	exports.easeExpOut = expOut;
	exports.easeLinear = linear;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyInOut = polyInOut;
	exports.easePolyOut = polyOut;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadInOut = quadInOut;
	exports.easeQuadOut = quadOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinInOut = sinInOut;
	exports.easeSinOut = sinOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.4.5 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.d3 = global.d3 || {}));
	}(this, (function (exports) { 'use strict';
	
	function formatDecimal(x) {
	  return Math.abs(x = Math.round(x)) >= 1e21
	      ? x.toLocaleString("en").replace(/,/g, "")
	      : x.toString(10);
	}
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimalParts(1.23) returns ["123", 0].
	function formatDecimalParts(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  return new FormatSpecifier({
	    fill: match[1],
	    align: match[2],
	    sign: match[3],
	    symbol: match[4],
	    zero: match[5],
	    width: match[6],
	    comma: match[7],
	    precision: match[8] && match[8].slice(1),
	    trim: match[9],
	    type: match[10]
	  });
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
	  this.align = specifier.align === undefined ? ">" : specifier.align + "";
	  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
	  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
	  this.zero = !!specifier.zero;
	  this.width = specifier.width === undefined ? undefined : +specifier.width;
	  this.comma = !!specifier.comma;
	  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
	  this.trim = !!specifier.trim;
	  this.type = specifier.type === undefined ? "" : specifier.type + "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": formatDecimal,
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var map = Array.prototype.map,
	    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
	      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
	      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
	      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
	      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
	      percent = locale.percent === undefined ? "%" : locale.percent + "",
	      minus = locale.minus === undefined ? "-" : locale.minus + "",
	      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision === undefined ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
	        var valueNegative = value < 0 || 1 / value < 0;
	
	        // Perform the initial formatting.
	        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
	        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""],
	  minus: "-"
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.FormatSpecifier = FormatSpecifier;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.9 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r, ccw = !!ccw;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(390), __webpack_require__(1218), __webpack_require__(392), __webpack_require__(1220), __webpack_require__(393), __webpack_require__(1223), __webpack_require__(391)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.3.0 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(393)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newDate(y, m, d) {
	  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "g": formatYearISO,
	    "G": formatFullYearISO,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "q": formatQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "g": formatUTCYearISO,
	    "G": formatUTCFullYearISO,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "q": formatUTCQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "g": parseYear,
	    "G": parseFullYear,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "q": parseQuarter,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, Z) {
	    return function(string) {
	      var d = newDate(1900, undefined, 1),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
	
	      // If this is utcParse, never use the local timezone.
	      if (Z && !("Z" in d)) d.Z = 0;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // If the month was not specified, inherit from the quarter.
	      if (d.m === undefined) d.m = "q" in d ? d.q : 0;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return localDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatQuarter(d) {
	    return 1 + ~~(d.getMonth() / 3);
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  function formatUTCQuarter(d) {
	    return 1 + ~~(d.getUTCMonth() / 3);
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", false);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier += "", true);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseQuarter(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.s = +n[0], i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function dISO(d) {
	  var day = d.getDay();
	  return (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	}
	
	function formatWeekNumberISO(d, p) {
	  d = dISO(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatYearISO(d, p) {
	  d = dISO(d);
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatFullYearISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function UTCdISO(d) {
	  var day = d.getUTCDay();
	  return (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCYearISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCFullYearISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ v1.0.10 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var frame = 0, // is an animation frame pending?
	    timeout = 0, // is a timeout pending?
	    interval = 0, // are any timers active?
	    pokeDelay = 1000, // how frequently we check for clock skew
	    taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = typeof performance === "object" && performance.now ? performance : Date,
	    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	function timeout$1(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	function interval$1(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	exports.interval = interval$1;
	exports.now = now;
	exports.timeout = timeout$1;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-voronoi/ v1.1.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function x(d) {
	  return d[0];
	}
	
	function y(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon || Math.abs(endY - startY) > epsilon) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon && y1 - endY > epsilon ? [x0, Math.abs(startX - x0) < epsilon ? startY : y1]
	              : Math.abs(endY - y1) < epsilon && x1 - endX > epsilon ? [Math.abs(startY - y1) < epsilon ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon && endY - y0 > epsilon ? [x1, Math.abs(startX - x1) < epsilon ? startY : y0]
	              : Math.abs(endY - y0) < epsilon && endX - x0 > epsilon ? [Math.abs(startY - y0) < epsilon ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon
	      && Math.abs(y - lArc.circle.cy) < epsilon) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon
	      && Math.abs(y - rArc.circle.cy) < epsilon) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
	    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	function voronoi() {
	  var x$$1 = x,
	      y$$1 = y,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon) * epsilon, Math.round(y$$1(d, i, data) / epsilon) * epsilon];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	}
	
	exports.voronoi = voronoi;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1226 */
/***/ function(module, exports) {

	'use strict';
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	
	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return decodeURIComponent(components.join(''));
		} catch (err) {
			// Do nothing
		}
	
		if (components.length === 1) {
			return components;
		}
	
		split = split || 1;
	
		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);
	
		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	
	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher);
	
			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');
	
				tokens = input.match(singleMatcher);
			}
	
			return input;
		}
	}
	
	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};
	
		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);
	
				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}
	
			match = multiMatcher.exec(input);
		}
	
		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';
	
		var entries = Object.keys(replaceMap);
	
		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}
	
		return input;
	}
	
	module.exports = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}
	
		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');
	
			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};


/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global = global || self, global.Delaunator = factory());
	}(this, function () { 'use strict';
	
	    var EPSILON = Math.pow(2, -52);
	    var EDGE_STACK = new Uint32Array(512);
	
	    var Delaunator = function Delaunator(coords) {
	        var n = coords.length >> 1;
	        if (n > 0 && typeof coords[0] !== 'number') { throw new Error('Expected coords to contain numbers.'); }
	
	        this.coords = coords;
	
	        // arrays that will store the triangulation graph
	        var maxTriangles = Math.max(2 * n - 5, 0);
	        this._triangles = new Uint32Array(maxTriangles * 3);
	        this._halfedges = new Int32Array(maxTriangles * 3);
	
	        // temporary arrays for tracking the edges of the advancing convex hull
	        this._hashSize = Math.ceil(Math.sqrt(n));
	        this._hullPrev = new Uint32Array(n); // edge to prev edge
	        this._hullNext = new Uint32Array(n); // edge to next edge
	        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
	        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
	
	        // temporary arrays for sorting points
	        this._ids = new Uint32Array(n);
	        this._dists = new Float64Array(n);
	
	        this.update();
	    };
	
	    Delaunator.from = function from (points, getX, getY) {
	            if ( getX === void 0 ) getX = defaultGetX;
	            if ( getY === void 0 ) getY = defaultGetY;
	
	        var n = points.length;
	        var coords = new Float64Array(n * 2);
	
	        for (var i = 0; i < n; i++) {
	            var p = points[i];
	            coords[2 * i] = getX(p);
	            coords[2 * i + 1] = getY(p);
	        }
	
	        return new Delaunator(coords);
	    };
	
	    Delaunator.prototype.update = function update () {
	        var ref =  this;
	            var coords = ref.coords;
	            var hullPrev = ref._hullPrev;
	            var hullNext = ref._hullNext;
	            var hullTri = ref._hullTri;
	            var hullHash = ref._hullHash;
	        var n = coords.length >> 1;
	
	        // populate an array of point indices; calculate input data bbox
	        var minX = Infinity;
	        var minY = Infinity;
	        var maxX = -Infinity;
	        var maxY = -Infinity;
	
	        for (var i = 0; i < n; i++) {
	            var x = coords[2 * i];
	            var y = coords[2 * i + 1];
	            if (x < minX) { minX = x; }
	            if (y < minY) { minY = y; }
	            if (x > maxX) { maxX = x; }
	            if (y > maxY) { maxY = y; }
	            this._ids[i] = i;
	        }
	        var cx = (minX + maxX) / 2;
	        var cy = (minY + maxY) / 2;
	
	        var minDist = Infinity;
	        var i0, i1, i2;
	
	        // pick a seed point close to the center
	        for (var i$1 = 0; i$1 < n; i$1++) {
	            var d = dist(cx, cy, coords[2 * i$1], coords[2 * i$1 + 1]);
	            if (d < minDist) {
	                i0 = i$1;
	                minDist = d;
	            }
	        }
	        var i0x = coords[2 * i0];
	        var i0y = coords[2 * i0 + 1];
	
	        minDist = Infinity;
	
	        // find the point closest to the seed
	        for (var i$2 = 0; i$2 < n; i$2++) {
	            if (i$2 === i0) { continue; }
	            var d$1 = dist(i0x, i0y, coords[2 * i$2], coords[2 * i$2 + 1]);
	            if (d$1 < minDist && d$1 > 0) {
	                i1 = i$2;
	                minDist = d$1;
	            }
	        }
	        var i1x = coords[2 * i1];
	        var i1y = coords[2 * i1 + 1];
	
	        var minRadius = Infinity;
	
	        // find the third point which forms the smallest circumcircle with the first two
	        for (var i$3 = 0; i$3 < n; i$3++) {
	            if (i$3 === i0 || i$3 === i1) { continue; }
	            var r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i$3], coords[2 * i$3 + 1]);
	            if (r < minRadius) {
	                i2 = i$3;
	                minRadius = r;
	            }
	        }
	        var i2x = coords[2 * i2];
	        var i2y = coords[2 * i2 + 1];
	
	        if (minRadius === Infinity) {
	            // order collinear points by dx (or dy if all x are identical)
	            // and return the list as a hull
	            for (var i$4 = 0; i$4 < n; i$4++) {
	                this._dists[i$4] = (coords[2 * i$4] - coords[0]) || (coords[2 * i$4 + 1] - coords[1]);
	            }
	            quicksort(this._ids, this._dists, 0, n - 1);
	            var hull = new Uint32Array(n);
	            var j = 0;
	            for (var i$5 = 0, d0 = -Infinity; i$5 < n; i$5++) {
	                var id = this._ids[i$5];
	                if (this._dists[id] > d0) {
	                    hull[j++] = id;
	                    d0 = this._dists[id];
	                }
	            }
	            this.hull = hull.subarray(0, j);
	            this.triangles = new Uint32Array(0);
	            this.halfedges = new Uint32Array(0);
	            return;
	        }
	
	        // swap the order of the seed points for counter-clockwise orientation
	        if (orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
	            var i$6 = i1;
	            var x$1 = i1x;
	            var y$1 = i1y;
	            i1 = i2;
	            i1x = i2x;
	            i1y = i2y;
	            i2 = i$6;
	            i2x = x$1;
	            i2y = y$1;
	        }
	
	        var center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
	        this._cx = center.x;
	        this._cy = center.y;
	
	        for (var i$7 = 0; i$7 < n; i$7++) {
	            this._dists[i$7] = dist(coords[2 * i$7], coords[2 * i$7 + 1], center.x, center.y);
	        }
	
	        // sort the points by distance from the seed triangle circumcenter
	        quicksort(this._ids, this._dists, 0, n - 1);
	
	        // set up the seed triangle as the starting hull
	        this._hullStart = i0;
	        var hullSize = 3;
	
	        hullNext[i0] = hullPrev[i2] = i1;
	        hullNext[i1] = hullPrev[i0] = i2;
	        hullNext[i2] = hullPrev[i1] = i0;
	
	        hullTri[i0] = 0;
	        hullTri[i1] = 1;
	        hullTri[i2] = 2;
	
	        hullHash.fill(-1);
	        hullHash[this._hashKey(i0x, i0y)] = i0;
	        hullHash[this._hashKey(i1x, i1y)] = i1;
	        hullHash[this._hashKey(i2x, i2y)] = i2;
	
	        this.trianglesLen = 0;
	        this._addTriangle(i0, i1, i2, -1, -1, -1);
	
	        for (var k = 0, xp = (void 0), yp = (void 0); k < this._ids.length; k++) {
	            var i$8 = this._ids[k];
	            var x$2 = coords[2 * i$8];
	            var y$2 = coords[2 * i$8 + 1];
	
	            // skip near-duplicate points
	            if (k > 0 && Math.abs(x$2 - xp) <= EPSILON && Math.abs(y$2 - yp) <= EPSILON) { continue; }
	            xp = x$2;
	            yp = y$2;
	
	            // skip seed triangle points
	            if (i$8 === i0 || i$8 === i1 || i$8 === i2) { continue; }
	
	            // find a visible edge on the convex hull using edge hash
	            var start = 0;
	            for (var j$1 = 0, key = this._hashKey(x$2, y$2); j$1 < this._hashSize; j$1++) {
	                start = hullHash[(key + j$1) % this._hashSize];
	                if (start !== -1 && start !== hullNext[start]) { break; }
	            }
	
	            start = hullPrev[start];
	            var e = start, q = (void 0);
	            while (q = hullNext[e], !orient(x$2, y$2, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])) {
	                e = q;
	                if (e === start) {
	                    e = -1;
	                    break;
	                }
	            }
	            if (e === -1) { continue; } // likely a near-duplicate point; skip it
	
	            // add the first triangle from the point
	            var t = this._addTriangle(e, i$8, hullNext[e], -1, -1, hullTri[e]);
	
	            // recursively flip triangles from the point until they satisfy the Delaunay condition
	            hullTri[i$8] = this._legalize(t + 2);
	            hullTri[e] = t; // keep track of boundary triangles on the hull
	            hullSize++;
	
	            // walk forward through the hull, adding more triangles and flipping recursively
	            var n$1 = hullNext[e];
	            while (q = hullNext[n$1], orient(x$2, y$2, coords[2 * n$1], coords[2 * n$1 + 1], coords[2 * q], coords[2 * q + 1])) {
	                t = this._addTriangle(n$1, i$8, q, hullTri[i$8], -1, hullTri[n$1]);
	                hullTri[i$8] = this._legalize(t + 2);
	                hullNext[n$1] = n$1; // mark as removed
	                hullSize--;
	                n$1 = q;
	            }
	
	            // walk backward from the other side, adding more triangles and flipping
	            if (e === start) {
	                while (q = hullPrev[e], orient(x$2, y$2, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])) {
	                    t = this._addTriangle(q, i$8, e, -1, hullTri[e], hullTri[q]);
	                    this._legalize(t + 2);
	                    hullTri[q] = t;
	                    hullNext[e] = e; // mark as removed
	                    hullSize--;
	                    e = q;
	                }
	            }
	
	            // update the hull indices
	            this._hullStart = hullPrev[i$8] = e;
	            hullNext[e] = hullPrev[n$1] = i$8;
	            hullNext[i$8] = n$1;
	
	            // save the two new edges in the hash table
	            hullHash[this._hashKey(x$2, y$2)] = i$8;
	            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
	        }
	
	        this.hull = new Uint32Array(hullSize);
	        for (var i$9 = 0, e$1 = this._hullStart; i$9 < hullSize; i$9++) {
	            this.hull[i$9] = e$1;
	            e$1 = hullNext[e$1];
	        }
	
	        // trim typed triangle mesh arrays
	        this.triangles = this._triangles.subarray(0, this.trianglesLen);
	        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
	    };
	
	    Delaunator.prototype._hashKey = function _hashKey (x, y) {
	        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
	    };
	
	    Delaunator.prototype._legalize = function _legalize (a) {
	        var ref = this;
	            var triangles = ref._triangles;
	            var halfedges = ref._halfedges;
	            var coords = ref.coords;
	
	        var i = 0;
	        var ar = 0;
	
	        // recursion eliminated with a fixed-size stack
	        while (true) {
	            var b = halfedges[a];
	
	            /* if the pair of triangles doesn't satisfy the Delaunay condition
	             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
	             * then do the same check/flip recursively for the new pair of triangles
	             *
	             *       pl                pl
	             *      /||\              /  \
	             *   al/ || \bl        al/\a
	             *    /  ||  \          /  \
	             *   /  a||b  \flip/___ar___\
	             * p0\   ||   /p1   =>   p0\---bl---/p1
	             *    \  ||  /          \  /
	             *   ar\ || /br         b\/br
	             *      \||/              \  /
	             *       pr                pr
	             */
	            var a0 = a - a % 3;
	            ar = a0 + (a + 2) % 3;
	
	            if (b === -1) { // convex hull edge
	                if (i === 0) { break; }
	                a = EDGE_STACK[--i];
	                continue;
	            }
	
	            var b0 = b - b % 3;
	            var al = a0 + (a + 1) % 3;
	            var bl = b0 + (b + 2) % 3;
	
	            var p0 = triangles[ar];
	            var pr = triangles[a];
	            var pl = triangles[al];
	            var p1 = triangles[bl];
	
	            var illegal = inCircle(
	                coords[2 * p0], coords[2 * p0 + 1],
	                coords[2 * pr], coords[2 * pr + 1],
	                coords[2 * pl], coords[2 * pl + 1],
	                coords[2 * p1], coords[2 * p1 + 1]);
	
	            if (illegal) {
	                triangles[a] = p1;
	                triangles[b] = p0;
	
	                var hbl = halfedges[bl];
	
	                // edge swapped on the other side of the hull (rare); fix the halfedge reference
	                if (hbl === -1) {
	                    var e = this._hullStart;
	                    do {
	                        if (this._hullTri[e] === bl) {
	                            this._hullTri[e] = a;
	                            break;
	                        }
	                        e = this._hullPrev[e];
	                    } while (e !== this._hullStart);
	                }
	                this._link(a, hbl);
	                this._link(b, halfedges[ar]);
	                this._link(ar, bl);
	
	                var br = b0 + (b + 1) % 3;
	
	                // don't worry about hitting the cap: it can only happen on extremely degenerate input
	                if (i < EDGE_STACK.length) {
	                    EDGE_STACK[i++] = br;
	                }
	            } else {
	                if (i === 0) { break; }
	                a = EDGE_STACK[--i];
	            }
	        }
	
	        return ar;
	    };
	
	    Delaunator.prototype._link = function _link (a, b) {
	        this._halfedges[a] = b;
	        if (b !== -1) { this._halfedges[b] = a; }
	    };
	
	    // add a new triangle given vertex indices and adjacent half-edge ids
	    Delaunator.prototype._addTriangle = function _addTriangle (i0, i1, i2, a, b, c) {
	        var t = this.trianglesLen;
	
	        this._triangles[t] = i0;
	        this._triangles[t + 1] = i1;
	        this._triangles[t + 2] = i2;
	
	        this._link(t, a);
	        this._link(t + 1, b);
	        this._link(t + 2, c);
	
	        this.trianglesLen += 3;
	
	        return t;
	    };
	
	    // monotonically increases with real angle, but doesn't need expensive trigonometry
	    function pseudoAngle(dx, dy) {
	        var p = dx / (Math.abs(dx) + Math.abs(dy));
	        return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
	    }
	
	    function dist(ax, ay, bx, by) {
	        var dx = ax - bx;
	        var dy = ay - by;
	        return dx * dx + dy * dy;
	    }
	
	    // return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
	    function orientIfSure(px, py, rx, ry, qx, qy) {
	        var l = (ry - py) * (qx - px);
	        var r = (rx - px) * (qy - py);
	        return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
	    }
	
	    // a more robust orientation test that's stable in a given triangle (to fix robustness issues)
	    function orient(rx, ry, qx, qy, px, py) {
	        var sign = orientIfSure(px, py, rx, ry, qx, qy) ||
	        orientIfSure(rx, ry, qx, qy, px, py) ||
	        orientIfSure(qx, qy, px, py, rx, ry);
	        return sign < 0;
	    }
	
	    function inCircle(ax, ay, bx, by, cx, cy, px, py) {
	        var dx = ax - px;
	        var dy = ay - py;
	        var ex = bx - px;
	        var ey = by - py;
	        var fx = cx - px;
	        var fy = cy - py;
	
	        var ap = dx * dx + dy * dy;
	        var bp = ex * ex + ey * ey;
	        var cp = fx * fx + fy * fy;
	
	        return dx * (ey * cp - bp * fy) -
	               dy * (ex * cp - bp * fx) +
	               ap * (ex * fy - ey * fx) < 0;
	    }
	
	    function circumradius(ax, ay, bx, by, cx, cy) {
	        var dx = bx - ax;
	        var dy = by - ay;
	        var ex = cx - ax;
	        var ey = cy - ay;
	
	        var bl = dx * dx + dy * dy;
	        var cl = ex * ex + ey * ey;
	        var d = 0.5 / (dx * ey - dy * ex);
	
	        var x = (ey * bl - dy * cl) * d;
	        var y = (dx * cl - ex * bl) * d;
	
	        return x * x + y * y;
	    }
	
	    function circumcenter(ax, ay, bx, by, cx, cy) {
	        var dx = bx - ax;
	        var dy = by - ay;
	        var ex = cx - ax;
	        var ey = cy - ay;
	
	        var bl = dx * dx + dy * dy;
	        var cl = ex * ex + ey * ey;
	        var d = 0.5 / (dx * ey - dy * ex);
	
	        var x = ax + (ey * bl - dy * cl) * d;
	        var y = ay + (dx * cl - ex * bl) * d;
	
	        return {x: x, y: y};
	    }
	
	    function quicksort(ids, dists, left, right) {
	        if (right - left <= 20) {
	            for (var i = left + 1; i <= right; i++) {
	                var temp = ids[i];
	                var tempDist = dists[temp];
	                var j = i - 1;
	                while (j >= left && dists[ids[j]] > tempDist) { ids[j + 1] = ids[j--]; }
	                ids[j + 1] = temp;
	            }
	        } else {
	            var median = (left + right) >> 1;
	            var i$1 = left + 1;
	            var j$1 = right;
	            swap(ids, median, i$1);
	            if (dists[ids[left]] > dists[ids[right]]) { swap(ids, left, right); }
	            if (dists[ids[i$1]] > dists[ids[right]]) { swap(ids, i$1, right); }
	            if (dists[ids[left]] > dists[ids[i$1]]) { swap(ids, left, i$1); }
	
	            var temp$1 = ids[i$1];
	            var tempDist$1 = dists[temp$1];
	            while (true) {
	                do { i$1++; } while (dists[ids[i$1]] < tempDist$1);
	                do { j$1--; } while (dists[ids[j$1]] > tempDist$1);
	                if (j$1 < i$1) { break; }
	                swap(ids, i$1, j$1);
	            }
	            ids[left + 1] = ids[j$1];
	            ids[j$1] = temp$1;
	
	            if (right - i$1 + 1 >= j$1 - left) {
	                quicksort(ids, dists, i$1, right);
	                quicksort(ids, dists, left, j$1 - 1);
	            } else {
	                quicksort(ids, dists, left, j$1 - 1);
	                quicksort(ids, dists, i$1, right);
	            }
	        }
	    }
	
	    function swap(arr, i, j) {
	        var tmp = arr[i];
	        arr[i] = arr[j];
	        arr[j] = tmp;
	    }
	
	    function defaultGetX(p) {
	        return p[0];
	    }
	    function defaultGetY(p) {
	        return p[1];
	    }
	
	    return Delaunator;
	
	}));


/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _delaunator = _interopRequireDefault(__webpack_require__(1227));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// From https://github.com/d3/d3-delaunay/blob/master/src/delaunay.js
	function pointX(p) {
	  return p[0];
	}
	
	function pointY(p) {
	  return p[1];
	} // A triangulation is collinear if all its triangles have a non-null area
	
	
	function collinear(d) {
	  var triangles = d.triangles,
	      coords = d.coords;
	
	  for (var i = 0; i < triangles.length; i += 3) {
	    var a = 2 * triangles[i];
	    var b = 2 * triangles[i + 1];
	    var c = 2 * triangles[i + 2];
	    var cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]); // eslint-disable-next-line no-magic-numbers
	
	    if (cross > 1e-10) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function jitter(x, y, r) {
	  return [x + Math.sin(x + y) * r, y + Math.cos(x - y) * r];
	} // eslint-disable-next-line max-params
	
	
	function flatArray(points, fx, fy, that) {
	  var n = points.length;
	  var array = new Float64Array(n * 2);
	
	  for (var i = 0; i < n; ++i) {
	    var p = points[i];
	    array[i * 2] = fx.call(that, p, i, points);
	    array[i * 2 + 1] = fy.call(that, p, i, points);
	  }
	
	  return array;
	}
	
	var Delaunay =
	/*#__PURE__*/
	function () {
	  function Delaunay(points) {
	    var delaunator = new _delaunator["default"](points);
	    this.inedges = new Int32Array(points.length / 2);
	    this._hullIndex = new Int32Array(points.length / 2);
	    this.points = delaunator.coords;
	
	    this._init(delaunator);
	  } // eslint-disable-next-line max-statements, complexity
	
	
	  var _proto = Delaunay.prototype;
	
	  _proto._init = function _init(delaunator) {
	    var d = delaunator;
	    var points = this.points; // check for collinear
	    // eslint-disable-next-line no-magic-numbers
	
	    if (d.hull && d.hull.length > 2 && collinear(d)) {
	      this.collinear = Int32Array.from({
	        length: points.length / 2
	      }, function (_, i) {
	        return i;
	      }).sort(function (i, j) {
	        return points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1];
	      }); // for exact neighbors
	
	      var e = this.collinear[0];
	      var f = this.collinear[this.collinear.length - 1];
	      var bounds = [points[2 * e], points[2 * e + 1], points[2 * f], points[2 * f + 1]];
	      var r = 1e-8 * // eslint-disable-line no-magic-numbers
	      Math.sqrt(Math.pow(bounds[3] - bounds[1], 2) + Math.pow(bounds[2] - bounds[0], 2));
	
	      for (var i = 0, n = points.length / 2; i < n; ++i) {
	        var p = jitter(points[2 * i], points[2 * i + 1], r);
	        points[2 * i] = p[0];
	        points[2 * i + 1] = p[1];
	      }
	
	      delaunator = new _delaunator["default"](points);
	    }
	
	    var halfedges = this.halfedges = delaunator.halfedges;
	    var hull = this.hull = delaunator.hull;
	    var triangles = this.triangles = delaunator.triangles;
	    var inedges = this.inedges.fill(-1);
	
	    var hullIndex = this._hullIndex.fill(-1); // Compute an index from each point to an (arbitrary) incoming halfedge
	    // Used to give the first neighbor of each point; for this reason,
	    // on the hull we give priority to exterior halfedges
	
	
	    for (var _e = 0, _n = halfedges.length; _e < _n; ++_e) {
	      var _p = triangles[_e % 3 === 2 ? _e - 2 : _e + 1];
	      if (halfedges[_e] === -1 || inedges[_p] === -1) inedges[_p] = _e;
	    }
	
	    for (var _i = 0, _n2 = hull.length; _i < _n2; ++_i) {
	      hullIndex[hull[_i]] = _i;
	    } // degenerate case: 1 or 2 (distinct) points
	
	
	    if (hull.length <= 2 && hull.length > 0) {
	      this.triangles = new Int32Array(3).fill(-1);
	      this.halfedges = new Int32Array(3).fill(-1);
	      this.triangles[0] = hull[0];
	      this.triangles[1] = hull[1];
	      this.triangles[2] = hull[1];
	      inedges[hull[0]] = 1;
	      if (hull.length === 2) inedges[hull[1]] = 0;
	    }
	  } // eslint-disable-next-line max-statements
	  ;
	
	  _proto.neighbors = function neighbors(i) {
	    var results = [];
	    var inedges = this.inedges,
	        hull = this.hull,
	        _hullIndex = this._hullIndex,
	        halfedges = this.halfedges,
	        triangles = this.triangles;
	    var e0 = inedges[i];
	    if (e0 === -1) return results; // coincident point
	
	    var e = e0;
	    var p0 = -1;
	
	    do {
	      p0 = triangles[e];
	      results.push(p0);
	      e = e % 3 === 2 ? e - 2 : e + 1;
	      if (triangles[e] !== i) break; // bad triangulation
	
	      e = halfedges[e];
	
	      if (e === -1) {
	        var p = hull[(_hullIndex[i] + 1) % hull.length];
	        if (p !== p0) results.push(p);
	        break;
	      }
	    } while (e !== e0);
	
	    return results;
	  };
	
	  _proto.find = function find(x, y, i) {
	    if (i === void 0) {
	      i = 0;
	    }
	
	    // eslint-disable-next-line no-self-compare
	    if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
	    var i0 = i;
	    var c;
	
	    while ((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0) {
	      i = c;
	    }
	
	    return c;
	  };
	
	  _proto._step = function _step(i, x, y) {
	    var inedges = this.inedges,
	        points = this.points;
	    if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
	    var c = i;
	    var dc = Math.pow(x - points[i * 2], 2) + Math.pow(y - points[i * 2 + 1], 2);
	
	    for (var _iterator = this.neighbors(i), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i2 >= _iterator.length) break;
	        _ref = _iterator[_i2++];
	      } else {
	        _i2 = _iterator.next();
	        if (_i2.done) break;
	        _ref = _i2.value;
	      }
	
	      var t = _ref;
	      var dt = Math.pow(x - points[t * 2], 2) + Math.pow(y - points[t * 2 + 1], 2);
	
	      if (dt < dc) {
	        dc = dt;
	        c = t;
	      }
	    }
	
	    return c;
	  };
	
	  return Delaunay;
	}(); // eslint-disable-next-line max-params
	
	
	exports["default"] = Delaunay;
	
	Delaunay.from = function (points, fx, fy, that) {
	  if (fx === void 0) {
	    fx = pointX;
	  }
	
	  if (fy === void 0) {
	    fy = pointY;
	  }
	
	  return new Delaunay(flatArray(points, fx, fy, that));
	}; // only public methods will be .from and .find

/***/ },
/* 1229 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1230 */
1199,
/* 1231 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1232 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 1234 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ellipsis.7a7f40c7.svg";

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.headerCase = void 0;
	var tslib_1 = __webpack_require__(1237);
	var capital_case_1 = __webpack_require__(386);
	function headerCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return capital_case_1.capitalCase(input, tslib_1.__assign({ delimiter: "-" }, options));
	}
	exports.headerCase = headerCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1237 */
1199,
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(1757)),valueEqual=_interopDefault(__webpack_require__(1837));__webpack_require__(88);var invariant=_interopDefault(__webpack_require__(209));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 1239 */
/***/ function(module, exports) {

	/**
	 * SVG elements are case-sensitive.
	 *
	 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
	 */
	var CASE_SENSITIVE_TAG_NAMES = [
	  'animateMotion',
	  'animateTransform',
	  'clipPath',
	  'feBlend',
	  'feColorMatrix',
	  'feComponentTransfer',
	  'feComposite',
	  'feConvolveMatrix',
	  'feDiffuseLighting',
	  'feDisplacementMap',
	  'feDropShadow',
	  'feFlood',
	  'feFuncA',
	  'feFuncB',
	  'feFuncG',
	  'feFuncR',
	  'feGaussainBlur',
	  'feImage',
	  'feMerge',
	  'feMergeNode',
	  'feMorphology',
	  'feOffset',
	  'fePointLight',
	  'feSpecularLighting',
	  'feSpotLight',
	  'feTile',
	  'feTurbulence',
	  'foreignObject',
	  'linearGradient',
	  'radialGradient',
	  'textPath'
	];
	
	module.exports = {
	  CASE_SENSITIVE_TAG_NAMES: CASE_SENSITIVE_TAG_NAMES
	};


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	var utilities = __webpack_require__(396);
	
	// constants
	var HTML = 'html';
	var HEAD = 'head';
	var BODY = 'body';
	var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
	var HEAD_TAG_REGEX = /<head.*>/i;
	var BODY_TAG_REGEX = /<body.*>/i;
	// http://www.w3.org/TR/html/syntax.html#void-elements
	var VOID_ELEMENTS_REGEX = /<(area|base|br|col|embed|hr|img|input|keygen|link|menuitem|meta|param|source|track|wbr)(.*?)\/?>/gi;
	
	// detect IE browser
	var isIE9 = utilities.isIE(9);
	var isIE = isIE9 || utilities.isIE();
	
	/**
	 * DOMParser (performance: slow).
	 *
	 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
	 */
	var parseFromString;
	
	if (typeof window.DOMParser === 'function') {
	  var domParser = new window.DOMParser();
	
	  // IE9 does not support 'text/html' MIME type
	  // https://msdn.microsoft.com/en-us/library/ff975278(v=vs.85).aspx
	  var mimeType = isIE9 ? 'text/xml' : 'text/html';
	
	  /**
	   * Creates an HTML document using `DOMParser.parseFromString`.
	   *
	   * @param  {string} html      - The HTML string.
	   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
	   * @return {HTMLDocument}
	   */
	  parseFromString = function domStringParser(html, tagName) {
	    if (tagName) {
	      html = '<' + tagName + '>' + html + '</' + tagName + '>';
	    }
	
	    // because IE9 only supports MIME type 'text/xml', void elements need to be self-closed
	    if (isIE9) {
	      html = html.replace(VOID_ELEMENTS_REGEX, '<$1$2$3/>');
	    }
	
	    return domParser.parseFromString(html, mimeType);
	  };
	}
	
	/**
	 * DOMImplementation (performance: fair).
	 *
	 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
	 */
	var parseFromDocument;
	
	if (typeof document.implementation === 'object') {
	  // title parameter is required in IE
	  // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
	  var doc = document.implementation.createHTMLDocument(
	    isIE ? 'HTML_DOM_PARSER_TITLE' : undefined
	  );
	
	  /**
	   * Use HTML document created by `document.implementation.createHTMLDocument`.
	   *
	   * @param  {string} html      - The HTML string.
	   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
	   * @return {HTMLDocument}
	   */
	  parseFromDocument = function createHTMLDocument(html, tagName) {
	    if (tagName) {
	      doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
	      return doc;
	    }
	
	    try {
	      doc.documentElement.innerHTML = html;
	      return doc;
	      // fallback when certain elements in `documentElement` are read-only (IE9)
	    } catch (err) {
	      if (parseFromString) {
	        return parseFromString(html);
	      }
	    }
	  };
	}
	
	/**
	 * Template (performance: fast).
	 *
	 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
	 */
	var parseFromTemplate;
	var template = document.createElement('template');
	
	if (template.content) {
	  /**
	   * Uses a template element (content fragment) to parse HTML.
	   *
	   * @param  {string} html - The HTML string.
	   * @return {NodeList}
	   */
	  parseFromTemplate = function templateParser(html) {
	    template.innerHTML = html;
	    return template.content.childNodes;
	  };
	}
	
	// fallback document parser
	var parseWithFallback = parseFromDocument || parseFromString;
	
	/**
	 * Parses HTML string to DOM nodes.
	 *
	 * @param  {string} html - The HTML string.
	 * @return {NodeList|Array}
	 */
	function domparser(html) {
	  var firstTagName;
	  var match = html.match(FIRST_TAG_REGEX);
	
	  if (match && match[1]) {
	    firstTagName = match[1].toLowerCase();
	  }
	
	  var doc;
	  var element;
	  var elements;
	
	  switch (firstTagName) {
	    case HTML:
	      if (parseFromString) {
	        doc = parseFromString(html);
	
	        // the created document may come with filler head/body elements,
	        // so make sure to remove them if they don't actually exist
	        if (!HEAD_TAG_REGEX.test(html)) {
	          element = doc.getElementsByTagName(HEAD)[0];
	          if (element) {
	            element.parentNode.removeChild(element);
	          }
	        }
	
	        if (!BODY_TAG_REGEX.test(html)) {
	          element = doc.getElementsByTagName(BODY)[0];
	          if (element) {
	            element.parentNode.removeChild(element);
	          }
	        }
	
	        return doc.getElementsByTagName(HTML);
	      }
	      break;
	
	    case HEAD:
	    case BODY:
	      if (parseWithFallback) {
	        elements = parseWithFallback(html).getElementsByTagName(firstTagName);
	
	        // account for possibility of sibling
	        if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
	          return elements[0].parentNode.childNodes;
	        }
	
	        return elements;
	      }
	      break;
	
	    // low-level tag or text
	    default:
	      if (parseFromTemplate) {
	        return parseFromTemplate(html);
	      }
	
	      if (parseWithFallback) {
	        return parseWithFallback(html, BODY).getElementsByTagName(BODY)[0]
	          .childNodes;
	      }
	
	      break;
	  }
	
	  return [];
	}
	
	module.exports = domparser;


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	var domparser = __webpack_require__(1240);
	var utilities = __webpack_require__(396);
	
	var formatDOM = utilities.formatDOM;
	var isIE9 = utilities.isIE(9);
	
	var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
	
	/**
	 * Parses HTML and reformats DOM nodes output.
	 *
	 * @param  {String} html - The HTML string.
	 * @return {Array}       - The formatted DOM nodes.
	 */
	function parseDOM(html) {
	  if (typeof html !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!html) {
	    return [];
	  }
	
	  // match directive
	  var match = html.match(DIRECTIVE_REGEX);
	  var directive;
	
	  if (match && match[1]) {
	    directive = match[1];
	
	    // remove directive in IE9 because DOMParser uses
	    // MIME type 'text/xml' instead of 'text/html'
	    if (isIE9) {
	      html = html.replace(match[0], '');
	    }
	  }
	
	  return formatDOM(domparser(html), null, directive);
	}
	
	module.exports = parseDOM;


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	var domToReact = __webpack_require__(1244);
	var htmlToDOM = __webpack_require__(1241);
	
	// decode HTML entities by default for `htmlparser2`
	var domParserOptions = { decodeEntities: true, lowerCaseAttributeNames: false };
	
	/**
	 * Converts HTML string to React elements.
	 *
	 * @param  {String}   html              - The HTML string to parse to React.
	 * @param  {Object}   [options]         - The parser options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array|String}  - When parsed with HTML string, returns React elements; otherwise, returns string or empty array.
	 */
	function HTMLReactParser(html, options) {
	  if (typeof html !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	  return domToReact(htmlToDOM(html, domParserOptions), options);
	}
	
	HTMLReactParser.domToReact = domToReact;
	HTMLReactParser.htmlToDOM = htmlToDOM;
	
	module.exports = HTMLReactParser;
	module.exports.default = HTMLReactParser;


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	var reactProperty = __webpack_require__(1419);
	var styleToObject = __webpack_require__(1766);
	var utilities = __webpack_require__(397);
	
	var camelCase = utilities.camelCase;
	
	var htmlProperties = reactProperty.html;
	var svgProperties = reactProperty.svg;
	var isCustomAttribute = reactProperty.isCustomAttribute;
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Converts HTML/SVG DOM attributes to React props.
	 *
	 * @param  {Object} [attributes={}] - The HTML/SVG DOM attributes.
	 * @return {Object}                 - The React props.
	 */
	function attributesToProps(attributes) {
	  attributes = attributes || {};
	
	  var attributeName;
	  var attributeNameLowerCased;
	  var attributeValue;
	  var property;
	  var props = {};
	
	  for (attributeName in attributes) {
	    attributeValue = attributes[attributeName];
	
	    // ARIA (aria-*) or custom data (data-*) attribute
	    if (isCustomAttribute(attributeName)) {
	      props[attributeName] = attributeValue;
	      continue;
	    }
	
	    // convert HTML attribute to React prop
	    attributeNameLowerCased = attributeName.toLowerCase();
	    if (hasOwnProperty.call(htmlProperties, attributeNameLowerCased)) {
	      property = htmlProperties[attributeNameLowerCased];
	      props[property.propertyName] =
	        property.hasBooleanValue ||
	        (property.hasOverloadedBooleanValue && !attributeValue)
	          ? true
	          : attributeValue;
	      continue;
	    }
	
	    // convert SVG attribute to React prop
	    if (hasOwnProperty.call(svgProperties, attributeName)) {
	      property = svgProperties[attributeName];
	      props[property.propertyName] = attributeValue;
	      continue;
	    }
	
	    // preserve custom attribute if React >=16
	    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
	      props[attributeName] = attributeValue;
	    }
	  }
	
	  // convert inline style to object
	  if (attributes.style != null) {
	    props.style = cssToJs(attributes.style);
	  }
	
	  return props;
	}
	
	/**
	 * Converts CSS style string to JS style object.
	 *
	 * @param  {String} style - The CSS style.
	 * @return {Object}       - The JS style object.
	 */
	function cssToJs(style) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string.');
	  }
	
	  var styleObj = {};
	
	  styleToObject(style, function(property, value) {
	    // skip if it's a comment node
	    if (property && value) {
	      styleObj[camelCase(property)] = value;
	    }
	  });
	
	  return styleObj;
	}
	
	module.exports = attributesToProps;


/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	var attributesToProps = __webpack_require__(1243);
	var utilities = __webpack_require__(397);
	
	/**
	 * Converts DOM nodes to React elements.
	 *
	 * @param {DomElement[]} nodes - The DOM nodes.
	 * @param {Object} [options={}] - The additional options.
	 * @param {Function} [options.replace] - The replacer.
	 * @param {Object} [options.library] - The library (React, Preact, etc.).
	 * @return {String|ReactElement|ReactElement[]}
	 */
	function domToReact(nodes, options) {
	  options = options || {};
	
	  var React = options.library || __webpack_require__(1);
	  var cloneElement = React.cloneElement;
	  var createElement = React.createElement;
	  var isValidElement = React.isValidElement;
	
	  var result = [];
	  var node;
	  var hasReplace = typeof options.replace === 'function';
	  var replaceElement;
	  var props;
	  var children;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    node = nodes[i];
	
	    // replace with custom React element (if present)
	    if (hasReplace) {
	      replaceElement = options.replace(node);
	
	      if (isValidElement(replaceElement)) {
	        // specify a "key" prop if element has siblings
	        // https://fb.me/react-warning-keys
	        if (len > 1) {
	          replaceElement = cloneElement(replaceElement, {
	            key: replaceElement.key || i
	          });
	        }
	        result.push(replaceElement);
	        continue;
	      }
	    }
	
	    if (node.type === 'text') {
	      result.push(node.data);
	      continue;
	    }
	
	    props = node.attribs;
	    if (!shouldPassAttributesUnaltered(node)) {
	      // update values
	      props = attributesToProps(node.attribs);
	    }
	
	    children = null;
	
	    // node type for <script> is "script"
	    // node type for <style> is "style"
	    if (node.type === 'script' || node.type === 'style') {
	      // prevent text in <script> or <style> from being escaped
	      // https://facebook.github.io/react/tips/dangerously-set-inner-html.html
	      if (node.children[0]) {
	        props.dangerouslySetInnerHTML = {
	          __html: node.children[0].data
	        };
	      }
	    } else if (node.type === 'tag') {
	      // setting textarea value in children is an antipattern in React
	      // https://reactjs.org/docs/forms.html#the-textarea-tag
	      if (node.name === 'textarea' && node.children[0]) {
	        props.defaultValue = node.children[0].data;
	
	        // continue recursion of creating React elements (if applicable)
	      } else if (node.children && node.children.length) {
	        children = domToReact(node.children, options);
	      }
	
	      // skip all other cases (e.g., comment)
	    } else {
	      continue;
	    }
	
	    // specify a "key" prop if element has siblings
	    // https://fb.me/react-warning-keys
	    if (len > 1) {
	      props.key = i;
	    }
	
	    result.push(createElement(node.name, props, children));
	  }
	
	  return result.length === 1 ? result[0] : result;
	}
	
	/**
	 * @param {React.ReactElement} node
	 * @return {Boolean}
	 */
	function shouldPassAttributesUnaltered(node) {
	  return (
	    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
	    node.type === 'tag' &&
	    utilities.isCustomComponent(node.name, node.attribs)
	  );
	}
	
	module.exports = domToReact;


/***/ },
/* 1245 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 1246 */
/***/ function(module, exports) {

	// http://www.w3.org/TR/CSS21/grammar.html
	// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
	var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
	
	var NEWLINE_REGEX = /\n/g;
	var WHITESPACE_REGEX = /^\s*/;
	
	// declaration
	var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
	var COLON_REGEX = /^:\s*/;
	var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
	var SEMICOLON_REGEX = /^[;\s]*/;
	
	// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	var TRIM_REGEX = /^\s+|\s+$/g;
	
	// strings
	var NEWLINE = '\n';
	var FORWARD_SLASH = '/';
	var ASTERISK = '*';
	var EMPTY_STRING = '';
	
	// types
	var TYPE_COMMENT = 'comment';
	var TYPE_DECLARATION = 'declaration';
	
	/**
	 * @param {String} style
	 * @param {Object} [options]
	 * @return {Object[]}
	 * @throws {TypeError}
	 * @throws {Error}
	 */
	module.exports = function(style, options) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!style) return [];
	
	  options = options || {};
	
	  /**
	   * Positional.
	   */
	  var lineno = 1;
	  var column = 1;
	
	  /**
	   * Update lineno and column based on `str`.
	   *
	   * @param {String} str
	   */
	  function updatePosition(str) {
	    var lines = str.match(NEWLINE_REGEX);
	    if (lines) lineno += lines.length;
	    var i = str.lastIndexOf(NEWLINE);
	    column = ~i ? str.length - i : column + str.length;
	  }
	
	  /**
	   * Mark position and patch `node.position`.
	   *
	   * @return {Function}
	   */
	  function position() {
	    var start = { line: lineno, column: column };
	    return function(node) {
	      node.position = new Position(start);
	      whitespace();
	      return node;
	    };
	  }
	
	  /**
	   * Store position information for a node.
	   *
	   * @constructor
	   * @property {Object} start
	   * @property {Object} end
	   * @property {undefined|String} source
	   */
	  function Position(start) {
	    this.start = start;
	    this.end = { line: lineno, column: column };
	    this.source = options.source;
	  }
	
	  /**
	   * Non-enumerable source string.
	   */
	  Position.prototype.content = style;
	
	  var errorsList = [];
	
	  /**
	   * Error `msg`.
	   *
	   * @param {String} msg
	   * @throws {Error}
	   */
	  function error(msg) {
	    var err = new Error(
	      options.source + ':' + lineno + ':' + column + ': ' + msg
	    );
	    err.reason = msg;
	    err.filename = options.source;
	    err.line = lineno;
	    err.column = column;
	    err.source = style;
	
	    if (options.silent) {
	      errorsList.push(err);
	    } else {
	      throw err;
	    }
	  }
	
	  /**
	   * Match `re` and return captures.
	   *
	   * @param {RegExp} re
	   * @return {undefined|Array}
	   */
	  function match(re) {
	    var m = re.exec(style);
	    if (!m) return;
	    var str = m[0];
	    updatePosition(str);
	    style = style.slice(str.length);
	    return m;
	  }
	
	  /**
	   * Parse whitespace.
	   */
	  function whitespace() {
	    match(WHITESPACE_REGEX);
	  }
	
	  /**
	   * Parse comments.
	   *
	   * @param {Object[]} [rules]
	   * @return {Object[]}
	   */
	  function comments(rules) {
	    var c;
	    rules = rules || [];
	    while ((c = comment())) {
	      if (c !== false) {
	        rules.push(c);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Parse comment.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function comment() {
	    var pos = position();
	    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
	
	    var i = 2;
	    while (
	      EMPTY_STRING != style.charAt(i) &&
	      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
	    ) {
	      ++i;
	    }
	    i += 2;
	
	    if (EMPTY_STRING === style.charAt(i - 1)) {
	      return error('End of comment missing');
	    }
	
	    var str = style.slice(2, i - 2);
	    column += 2;
	    updatePosition(str);
	    style = style.slice(i);
	    column += 2;
	
	    return pos({
	      type: TYPE_COMMENT,
	      comment: str
	    });
	  }
	
	  /**
	   * Parse declaration.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function declaration() {
	    var pos = position();
	
	    // prop
	    var prop = match(PROPERTY_REGEX);
	    if (!prop) return;
	    comment();
	
	    // :
	    if (!match(COLON_REGEX)) return error("property missing ':'");
	
	    // val
	    var val = match(VALUE_REGEX);
	
	    var ret = pos({
	      type: TYPE_DECLARATION,
	      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
	      value: val
	        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
	        : EMPTY_STRING
	    });
	
	    // ;
	    match(SEMICOLON_REGEX);
	
	    return ret;
	  }
	
	  /**
	   * Parse declarations.
	   *
	   * @return {Object[]}
	   */
	  function declarations() {
	    var decls = [];
	
	    comments(decls);
	
	    // declarations
	    var decl;
	    while ((decl = declaration())) {
	      if (decl !== false) {
	        decls.push(decl);
	        comments(decls);
	      }
	    }
	
	    return decls;
	  }
	
	  whitespace();
	  return declarations();
	};
	
	/**
	 * Trim `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function trim(str) {
	  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
	}


/***/ },
/* 1247 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function areIntlLocalesSupported(locales, constructorsToCheck) {
	    if (typeof Intl === 'undefined') {
	        return false;
	    }
	    if (!locales) {
	        throw new Error('locales must be supplied.');
	    }
	    if (!Array.isArray(locales)) {
	        locales = [locales];
	    }
	    var intlConstructors = constructorsToCheck || [
	        Intl.DateTimeFormat,
	        Intl.NumberFormat,
	        Intl.PluralRules,
	    ];
	    intlConstructors = intlConstructors.filter(Boolean);
	    if (intlConstructors.length === 0 ||
	        (constructorsToCheck &&
	            intlConstructors.length !== constructorsToCheck.length)) {
	        return false;
	    }
	    return intlConstructors.every(function (intlConstructor) {
	        return intlConstructor.supportedLocalesOf(locales).length === locales.length;
	    });
	}
	exports.default = areIntlLocalesSupported;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(252);
	var parser_1 = __webpack_require__(251);
	var PLURAL_HASHTAG_REGEX = /(^|[^\\])#/g;
	/**
	 * Whether to convert `#` in plural rule options
	 * to `{var, number}`
	 * @param el AST Element
	 * @param pluralStack current plural stack
	 */
	function normalizeHashtagInPlural(els) {
	    els.forEach(function (el) {
	        // If we're encountering a plural el
	        if (!types_1.isPluralElement(el) && !types_1.isSelectElement(el)) {
	            return;
	        }
	        // Go down the options and search for # in any literal element
	        Object.keys(el.options).forEach(function (id) {
	            var _a;
	            var opt = el.options[id];
	            // If we got a match, we have to split this
	            // and inject a NumberElement in the middle
	            var matchingLiteralElIndex = -1;
	            var literalEl = undefined;
	            for (var i = 0; i < opt.value.length; i++) {
	                var el_1 = opt.value[i];
	                if (types_1.isLiteralElement(el_1) && PLURAL_HASHTAG_REGEX.test(el_1.value)) {
	                    matchingLiteralElIndex = i;
	                    literalEl = el_1;
	                    break;
	                }
	            }
	            if (literalEl) {
	                var newValue = literalEl.value.replace(PLURAL_HASHTAG_REGEX, "$1{" + el.value + ", number}");
	                var newEls = parser_1.pegParse(newValue);
	                (_a = opt.value).splice.apply(_a, __spreadArrays([matchingLiteralElIndex, 1], newEls));
	            }
	            normalizeHashtagInPlural(opt.value);
	        });
	    });
	}
	exports.normalizeHashtagInPlural = normalizeHashtagInPlural;


/***/ },
/* 1249 */
/***/ function(module, exports) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
	 * with some tweaks
	 */
	var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	/**
	 * Parse Date time skeleton into Intl.DateTimeFormatOptions
	 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * @public
	 * @param skeleton skeleton string
	 */
	function parseDateTimeSkeleton(skeleton) {
	    var result = {};
	    skeleton.replace(DATE_TIME_REGEX, function (match) {
	        var len = match.length;
	        switch (match[0]) {
	            // Era
	            case 'G':
	                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
	                break;
	            // Year
	            case 'y':
	                result.year = len === 2 ? '2-digit' : 'numeric';
	                break;
	            case 'Y':
	            case 'u':
	            case 'U':
	            case 'r':
	                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
	            // Quarter
	            case 'q':
	            case 'Q':
	                throw new RangeError('`q/Q` (quarter) patterns are not supported');
	            // Month
	            case 'M':
	            case 'L':
	                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
	                break;
	            // Week
	            case 'w':
	            case 'W':
	                throw new RangeError('`w/W` (week) patterns are not supported');
	            case 'd':
	                result.day = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'D':
	            case 'F':
	            case 'g':
	                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
	            // Weekday
	            case 'E':
	                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
	                break;
	            case 'e':
	                if (len < 4) {
	                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
	                }
	                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                break;
	            case 'c':
	                if (len < 4) {
	                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
	                }
	                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                break;
	            // Period
	            case 'a': // AM, PM
	                result.hour12 = true;
	                break;
	            case 'b': // am, pm, noon, midnight
	            case 'B': // flexible day periods
	                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
	            // Hour
	            case 'h':
	                result.hourCycle = 'h12';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'H':
	                result.hourCycle = 'h23';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'K':
	                result.hourCycle = 'h11';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'k':
	                result.hourCycle = 'h24';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'j':
	            case 'J':
	            case 'C':
	                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
	            // Minute
	            case 'm':
	                result.minute = ['numeric', '2-digit'][len - 1];
	                break;
	            // Second
	            case 's':
	                result.second = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'S':
	            case 'A':
	                throw new RangeError('`S/A` (second) pattenrs are not supported, use `s` instead');
	            // Zone
	            case 'z': // 1..3, 4: specific non-location format
	                result.timeZoneName = len < 4 ? 'short' : 'long';
	                break;
	            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	            case 'O': // 1, 4: miliseconds in day short, long
	            case 'v': // 1, 4: generic non-location format
	            case 'V': // 1, 2, 3, 4: time zone ID or city
	            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
	                throw new RangeError('`Z/O/v/V/X/x` (timeZone) pattenrs are not supported, use `z` instead');
	        }
	        return '';
	    });
	    return result;
	}
	exports.parseDateTimeSkeleton = parseDateTimeSkeleton;
	function icuUnitToEcma(unit) {
	    return unit.replace(/^(.*?)-/, '');
	}
	var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\+|#+)?)?$/g;
	var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?$/g;
	function parseSignificantPrecision(str) {
	    var result = {};
	    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
	        // @@@ case
	        if (typeof g2 !== 'string') {
	            result.minimumSignificantDigits = g1.length;
	            result.maximumSignificantDigits = g1.length;
	        }
	        // @@@+ case
	        else if (g2 === '+') {
	            result.minimumSignificantDigits = g1.length;
	        }
	        // .### case
	        else if (g1[0] === '#') {
	            result.maximumSignificantDigits = g1.length;
	        }
	        // .@@## or .@@@ case
	        else {
	            result.minimumSignificantDigits = g1.length;
	            result.maximumSignificantDigits =
	                g1.length + (typeof g2 === 'string' ? g2.length : 0);
	        }
	        return '';
	    });
	    return result;
	}
	function parseSign(str) {
	    switch (str) {
	        case 'sign-auto':
	            return {
	                signDisplay: 'auto',
	            };
	        case 'sign-accounting':
	            return {
	                currencySign: 'accounting',
	            };
	        case 'sign-always':
	            return {
	                signDisplay: 'always',
	            };
	        case 'sign-accounting-always':
	            return {
	                signDisplay: 'always',
	                currencySign: 'accounting',
	            };
	        case 'sign-except-zero':
	            return {
	                signDisplay: 'exceptZero',
	            };
	        case 'sign-accounting-except-zero':
	            return {
	                signDisplay: 'exceptZero',
	                currencySign: 'accounting',
	            };
	        case 'sign-never':
	            return {
	                signDisplay: 'never',
	            };
	    }
	}
	function parseNotationOptions(opt) {
	    var result = {};
	    var signOpts = parseSign(opt);
	    if (signOpts) {
	        return signOpts;
	    }
	    return result;
	}
	/**
	 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
	 */
	function convertNumberSkeletonToNumberFormatOptions(tokens) {
	    var result = {};
	    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
	        var token = tokens_1[_i];
	        switch (token.stem) {
	            case 'percent':
	                result.style = 'percent';
	                continue;
	            case 'currency':
	                result.style = 'currency';
	                result.currency = token.options[0];
	                continue;
	            case 'group-off':
	                result.useGrouping = false;
	                continue;
	            case 'precision-integer':
	                result.maximumFractionDigits = 0;
	                continue;
	            case 'measure-unit':
	                result.style = 'unit';
	                result.unit = icuUnitToEcma(token.options[0]);
	                continue;
	            case 'compact-short':
	                result.notation = 'compact';
	                result.compactDisplay = 'short';
	                continue;
	            case 'compact-long':
	                result.notation = 'compact';
	                result.compactDisplay = 'long';
	                continue;
	            case 'scientific':
	                result = __assign(__assign(__assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
	                continue;
	            case 'engineering':
	                result = __assign(__assign(__assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
	                continue;
	            case 'notation-simple':
	                result.notation = 'standard';
	                continue;
	            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
	            case 'unit-width-narrow':
	                result.currencyDisplay = 'narrowSymbol';
	                result.unitDisplay = 'narrow';
	                continue;
	            case 'unit-width-short':
	                result.currencyDisplay = 'code';
	                result.unitDisplay = 'short';
	                continue;
	            case 'unit-width-full-name':
	                result.currencyDisplay = 'name';
	                result.unitDisplay = 'long';
	                continue;
	            case 'unit-width-iso-code':
	                result.currencyDisplay = 'symbol';
	                continue;
	        }
	        // Precision
	        // https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#fraction-precision
	        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
	            if (token.options.length > 1) {
	                throw new RangeError('Fraction-precision stems only accept a single optional option');
	            }
	            token.stem.replace(FRACTION_PRECISION_REGEX, function (match, g1, g2) {
	                // precision-integer case
	                if (match === '.') {
	                    result.maximumFractionDigits = 0;
	                }
	                // .000+ case
	                else if (g2 === '+') {
	                    result.minimumFractionDigits = g2.length;
	                }
	                // .### case
	                else if (g1[0] === '#') {
	                    result.maximumFractionDigits = g1.length;
	                }
	                // .00## or .000 case
	                else {
	                    result.minimumFractionDigits = g1.length;
	                    result.maximumFractionDigits =
	                        g1.length + (typeof g2 === 'string' ? g2.length : 0);
	                }
	                return '';
	            });
	            if (token.options.length) {
	                result = __assign(__assign({}, result), parseSignificantPrecision(token.options[0]));
	            }
	            continue;
	        }
	        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
	            result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
	            continue;
	        }
	        var signOpts = parseSign(token.stem);
	        if (signOpts) {
	            result = __assign(__assign({}, result), signOpts);
	        }
	    }
	    return result;
	}
	exports.convertNumberSkeletonToNumberFormatOptions = convertNumberSkeletonToNumberFormatOptions;


/***/ },
/* 1250 */
/***/ function(module, exports) {

	module.exports = function isArrayish(obj) {
		if (!obj || typeof obj === 'string') {
			return false;
		}
	
		return obj instanceof Array || Array.isArray(obj) ||
			(obj.length >= 0 && (obj.splice instanceof Function ||
				(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
	};


/***/ },
/* 1251 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ },
/* 1252 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1253 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2020a",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
			"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
			"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
			"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
			"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
			"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|13e2",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
			"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
			"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
			"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
			"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
			"Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|-02|20|0||30",
			"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"EST|EST|50|0||",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Etc/GMT-0|GMT|0|0||",
			"Etc/GMT-1|+01|-10|0||",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Etc/GMT-11|+11|-b0|0||",
			"Pacific/Tarawa|+12|-c0|0||29e3",
			"Etc/GMT-13|+13|-d0|0||",
			"Etc/GMT-14|+14|-e0|0||",
			"Etc/GMT-2|+02|-20|0||",
			"Etc/GMT-3|+03|-30|0||",
			"Etc/GMT-4|+04|-40|0||",
			"Etc/GMT-5|+05|-50|0||",
			"Etc/GMT-6|+06|-60|0||",
			"Indian/Christmas|+07|-70|0||21e2",
			"Etc/GMT-8|+08|-80|0||",
			"Pacific/Palau|+09|-90|0||21e3",
			"Etc/GMT+1|-01|10|0||",
			"Etc/GMT+10|-10|a0|0||",
			"Etc/GMT+11|-11|b0|0||",
			"Etc/GMT+12|-12|c0|0||",
			"Etc/GMT+3|-03|30|0||",
			"Etc/GMT+4|-04|40|0||",
			"Etc/GMT+5|-05|50|0||",
			"Etc/GMT+6|-06|60|0||",
			"Etc/GMT+7|-07|70|0||",
			"Etc/GMT+8|-08|80|0||",
			"Etc/GMT+9|-09|90|0||",
			"Etc/UTC|UTC|0|0||",
			"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0||",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Cocos|+0630|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"MST|MST|70|0||",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1",
			"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
			"Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
			"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
			"Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
			"Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
			"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
			"Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
			"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Godthab|America/Nuuk",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Atlantic/South_Georgia|Etc/GMT+2",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT-0|Etc/GMT",
			"Etc/GMT-0|Etc/GMT+0",
			"Etc/GMT-0|Etc/GMT0",
			"Etc/GMT-0|Etc/Greenwich",
			"Etc/GMT-0|GMT",
			"Etc/GMT-0|GMT+0",
			"Etc/GMT-0|GMT-0",
			"Etc/GMT-0|GMT0",
			"Etc/GMT-0|Greenwich",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Christmas|Etc/GMT-7",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Palau|Etc/GMT-9",
			"Pacific/Pohnpei|Pacific/Ponape",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Tarawa|Etc/GMT-12",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		],
		"countries": [
			"AD|Europe/Andorra",
			"AE|Asia/Dubai",
			"AF|Asia/Kabul",
			"AG|America/Port_of_Spain America/Antigua",
			"AI|America/Port_of_Spain America/Anguilla",
			"AL|Europe/Tirane",
			"AM|Asia/Yerevan",
			"AO|Africa/Lagos Africa/Luanda",
			"AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
			"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
			"AS|Pacific/Pago_Pago",
			"AT|Europe/Vienna",
			"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
			"AW|America/Curacao America/Aruba",
			"AX|Europe/Helsinki Europe/Mariehamn",
			"AZ|Asia/Baku",
			"BA|Europe/Belgrade Europe/Sarajevo",
			"BB|America/Barbados",
			"BD|Asia/Dhaka",
			"BE|Europe/Brussels",
			"BF|Africa/Abidjan Africa/Ouagadougou",
			"BG|Europe/Sofia",
			"BH|Asia/Qatar Asia/Bahrain",
			"BI|Africa/Maputo Africa/Bujumbura",
			"BJ|Africa/Lagos Africa/Porto-Novo",
			"BL|America/Port_of_Spain America/St_Barthelemy",
			"BM|Atlantic/Bermuda",
			"BN|Asia/Brunei",
			"BO|America/La_Paz",
			"BQ|America/Curacao America/Kralendijk",
			"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
			"BS|America/Nassau",
			"BT|Asia/Thimphu",
			"BW|Africa/Maputo Africa/Gaborone",
			"BY|Europe/Minsk",
			"BZ|America/Belize",
			"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson",
			"CC|Indian/Cocos",
			"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
			"CF|Africa/Lagos Africa/Bangui",
			"CG|Africa/Lagos Africa/Brazzaville",
			"CH|Europe/Zurich",
			"CI|Africa/Abidjan",
			"CK|Pacific/Rarotonga",
			"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
			"CM|Africa/Lagos Africa/Douala",
			"CN|Asia/Shanghai Asia/Urumqi",
			"CO|America/Bogota",
			"CR|America/Costa_Rica",
			"CU|America/Havana",
			"CV|Atlantic/Cape_Verde",
			"CW|America/Curacao",
			"CX|Indian/Christmas",
			"CY|Asia/Nicosia Asia/Famagusta",
			"CZ|Europe/Prague",
			"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
			"DJ|Africa/Nairobi Africa/Djibouti",
			"DK|Europe/Copenhagen",
			"DM|America/Port_of_Spain America/Dominica",
			"DO|America/Santo_Domingo",
			"DZ|Africa/Algiers",
			"EC|America/Guayaquil Pacific/Galapagos",
			"EE|Europe/Tallinn",
			"EG|Africa/Cairo",
			"EH|Africa/El_Aaiun",
			"ER|Africa/Nairobi Africa/Asmara",
			"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
			"ET|Africa/Nairobi Africa/Addis_Ababa",
			"FI|Europe/Helsinki",
			"FJ|Pacific/Fiji",
			"FK|Atlantic/Stanley",
			"FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
			"FO|Atlantic/Faroe",
			"FR|Europe/Paris",
			"GA|Africa/Lagos Africa/Libreville",
			"GB|Europe/London",
			"GD|America/Port_of_Spain America/Grenada",
			"GE|Asia/Tbilisi",
			"GF|America/Cayenne",
			"GG|Europe/London Europe/Guernsey",
			"GH|Africa/Accra",
			"GI|Europe/Gibraltar",
			"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
			"GM|Africa/Abidjan Africa/Banjul",
			"GN|Africa/Abidjan Africa/Conakry",
			"GP|America/Port_of_Spain America/Guadeloupe",
			"GQ|Africa/Lagos Africa/Malabo",
			"GR|Europe/Athens",
			"GS|Atlantic/South_Georgia",
			"GT|America/Guatemala",
			"GU|Pacific/Guam",
			"GW|Africa/Bissau",
			"GY|America/Guyana",
			"HK|Asia/Hong_Kong",
			"HN|America/Tegucigalpa",
			"HR|Europe/Belgrade Europe/Zagreb",
			"HT|America/Port-au-Prince",
			"HU|Europe/Budapest",
			"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
			"IE|Europe/Dublin",
			"IL|Asia/Jerusalem",
			"IM|Europe/London Europe/Isle_of_Man",
			"IN|Asia/Kolkata",
			"IO|Indian/Chagos",
			"IQ|Asia/Baghdad",
			"IR|Asia/Tehran",
			"IS|Atlantic/Reykjavik",
			"IT|Europe/Rome",
			"JE|Europe/London Europe/Jersey",
			"JM|America/Jamaica",
			"JO|Asia/Amman",
			"JP|Asia/Tokyo",
			"KE|Africa/Nairobi",
			"KG|Asia/Bishkek",
			"KH|Asia/Bangkok Asia/Phnom_Penh",
			"KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
			"KM|Africa/Nairobi Indian/Comoro",
			"KN|America/Port_of_Spain America/St_Kitts",
			"KP|Asia/Pyongyang",
			"KR|Asia/Seoul",
			"KW|Asia/Riyadh Asia/Kuwait",
			"KY|America/Panama America/Cayman",
			"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
			"LA|Asia/Bangkok Asia/Vientiane",
			"LB|Asia/Beirut",
			"LC|America/Port_of_Spain America/St_Lucia",
			"LI|Europe/Zurich Europe/Vaduz",
			"LK|Asia/Colombo",
			"LR|Africa/Monrovia",
			"LS|Africa/Johannesburg Africa/Maseru",
			"LT|Europe/Vilnius",
			"LU|Europe/Luxembourg",
			"LV|Europe/Riga",
			"LY|Africa/Tripoli",
			"MA|Africa/Casablanca",
			"MC|Europe/Monaco",
			"MD|Europe/Chisinau",
			"ME|Europe/Belgrade Europe/Podgorica",
			"MF|America/Port_of_Spain America/Marigot",
			"MG|Africa/Nairobi Indian/Antananarivo",
			"MH|Pacific/Majuro Pacific/Kwajalein",
			"MK|Europe/Belgrade Europe/Skopje",
			"ML|Africa/Abidjan Africa/Bamako",
			"MM|Asia/Yangon",
			"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
			"MO|Asia/Macau",
			"MP|Pacific/Guam Pacific/Saipan",
			"MQ|America/Martinique",
			"MR|Africa/Abidjan Africa/Nouakchott",
			"MS|America/Port_of_Spain America/Montserrat",
			"MT|Europe/Malta",
			"MU|Indian/Mauritius",
			"MV|Indian/Maldives",
			"MW|Africa/Maputo Africa/Blantyre",
			"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
			"MY|Asia/Kuala_Lumpur Asia/Kuching",
			"MZ|Africa/Maputo",
			"NA|Africa/Windhoek",
			"NC|Pacific/Noumea",
			"NE|Africa/Lagos Africa/Niamey",
			"NF|Pacific/Norfolk",
			"NG|Africa/Lagos",
			"NI|America/Managua",
			"NL|Europe/Amsterdam",
			"NO|Europe/Oslo",
			"NP|Asia/Kathmandu",
			"NR|Pacific/Nauru",
			"NU|Pacific/Niue",
			"NZ|Pacific/Auckland Pacific/Chatham",
			"OM|Asia/Dubai Asia/Muscat",
			"PA|America/Panama",
			"PE|America/Lima",
			"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
			"PG|Pacific/Port_Moresby Pacific/Bougainville",
			"PH|Asia/Manila",
			"PK|Asia/Karachi",
			"PL|Europe/Warsaw",
			"PM|America/Miquelon",
			"PN|Pacific/Pitcairn",
			"PR|America/Puerto_Rico",
			"PS|Asia/Gaza Asia/Hebron",
			"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
			"PW|Pacific/Palau",
			"PY|America/Asuncion",
			"QA|Asia/Qatar",
			"RE|Indian/Reunion",
			"RO|Europe/Bucharest",
			"RS|Europe/Belgrade",
			"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
			"RW|Africa/Maputo Africa/Kigali",
			"SA|Asia/Riyadh",
			"SB|Pacific/Guadalcanal",
			"SC|Indian/Mahe",
			"SD|Africa/Khartoum",
			"SE|Europe/Stockholm",
			"SG|Asia/Singapore",
			"SH|Africa/Abidjan Atlantic/St_Helena",
			"SI|Europe/Belgrade Europe/Ljubljana",
			"SJ|Europe/Oslo Arctic/Longyearbyen",
			"SK|Europe/Prague Europe/Bratislava",
			"SL|Africa/Abidjan Africa/Freetown",
			"SM|Europe/Rome Europe/San_Marino",
			"SN|Africa/Abidjan Africa/Dakar",
			"SO|Africa/Nairobi Africa/Mogadishu",
			"SR|America/Paramaribo",
			"SS|Africa/Juba",
			"ST|Africa/Sao_Tome",
			"SV|America/El_Salvador",
			"SX|America/Curacao America/Lower_Princes",
			"SY|Asia/Damascus",
			"SZ|Africa/Johannesburg Africa/Mbabane",
			"TC|America/Grand_Turk",
			"TD|Africa/Ndjamena",
			"TF|Indian/Reunion Indian/Kerguelen",
			"TG|Africa/Abidjan Africa/Lome",
			"TH|Asia/Bangkok",
			"TJ|Asia/Dushanbe",
			"TK|Pacific/Fakaofo",
			"TL|Asia/Dili",
			"TM|Asia/Ashgabat",
			"TN|Africa/Tunis",
			"TO|Pacific/Tongatapu",
			"TR|Europe/Istanbul",
			"TT|America/Port_of_Spain",
			"TV|Pacific/Funafuti",
			"TW|Asia/Taipei",
			"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
			"UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
			"UG|Africa/Nairobi Africa/Kampala",
			"UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
			"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
			"UY|America/Montevideo",
			"UZ|Asia/Samarkand Asia/Tashkent",
			"VA|Europe/Rome Europe/Vatican",
			"VC|America/Port_of_Spain America/St_Vincent",
			"VE|America/Caracas",
			"VG|America/Port_of_Spain America/Tortola",
			"VI|America/Port_of_Spain America/St_Thomas",
			"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
			"VU|Pacific/Efate",
			"WF|Pacific/Wallis",
			"WS|Pacific/Apia",
			"YE|Asia/Riyadh Asia/Aden",
			"YT|Africa/Nairobi Indian/Mayotte",
			"ZA|Africa/Johannesburg",
			"ZM|Africa/Maputo Africa/Lusaka",
			"ZW|Africa/Maputo Africa/Harare"
		]
	};

/***/ },
/* 1254 */
/***/ function(module, exports) {

	module.exports = {
		"error.status": "Error",
		"error.validation.error": "Validation error",
		"error.deployment.error": "Deployment error",
		"error.required.fields.missing": "Enter all required fields.",
		"error.form": "Form contains errors.",
		"error.title": "Unable to carry out the operation. No updates have been made. See details below.",
		"error.api.file.invalid.json.swagger": "Swagger file has invalid JSON.",
		"error.api.field.unique.name": "API Name must be unique.",
		"error.api.field.unique.proxyUrl": "API URI must be unique.",
		"error.applications.update": "Unable to carry out the operation. No updates have been made. See details below.",
		"error.gateway.bundle.fetch": "Request failed. Unable to fetch Gateway Bundle list.",
		"error.gateway.bundle.delete": "There was an error deleting this Gateway Bundle.",
		"error.gateway.bundle.undeploy": "Error undeploying the Gateway Bundle.",
		"error.gateway.bundle.file.name.unique": "Unable to upload the file. File name must be unique.",
		"error.gateway.bundle.file.count": "Only 3 files can be upload.",
		"error.gateway.bundle.file.size": "Required files: Metadata yml file, Gateway Bundle, Delete Bundle. Maximum size per file is 15 MB.",
		"error.gateway.bundle.file.metadata.yml.count": "Only one yml file can be uploaded.",
		"error.gateway.bundle.file.bundle.count": "Only one bundle file can be upload.",
		"error.gateway.bundle.file.delete.bundle.count": "Only one delete bundle file can be upload.",
		"error.gateway.bundle.proxy.list.fetch": "Request failed. Unable to fetch Gateway Bundle deployments proxy list.",
		"error.organization.list.fetch": "Request failed. Unable to fetch Organizations list.",
		"error.organization.form.load": "Request failed. Unable to populate the form.",
		"error.organization.form.validation": "Request failed. Unable to validate the form.",
		"error.organization.form.submit.create": "Request failed. Failed to create the organization",
		"error.organization.form.submit.update": "Request failed. Failed to update the organization",
		"error.user.fetch": "Request failed. Unable to fetch User list.",
		"error.proxy.delete": "There was an error deleting this Proxy.",
		"warning.status": "Warning",
		"label.dialog.unsaved.changes.title": "Unsaved Changes",
		"label.dialog.unsaved.changes.description": "Your changes will be lost if you leave this page. Are you sure you want to continue away from this page?",
		"label.dialog.unsaved.changes.submit": "Continue",
		"label.dialog.unsaved.changes.cancel": "Stay",
		"label.dialog.unsaved.changes.exit": "Exit",
		"label.filter": "Filter",
		"label.filter.by": "Filter By",
		"label.sort": "Sort",
		"label.sort.by": "Sort By",
		"label.sort.by.name.asc": "Name: A-Z",
		"label.sort.by.name.desc": "Name: Z-A",
		"label.sort.by.api.name.asc": "API Name: A-Z",
		"label.sort.by.api.name.desc": "API Name: Z-A",
		"label.sort.by.date.created.asc": "Date Created: Old to New",
		"label.sort.by.date.created.desc": "Date Created: New to Old",
		"label.sort.by.date.updated.asc": "Date Updated: Old to New",
		"label.sort.by.date.updated.desc": "Date Updated: New to Old",
		"label.sort.by.status.asc": "Status: A-Z",
		"label.sort.by.status.desc": "Status: Z-A",
		"label.pagination.prev": "Previous",
		"label.pagination.next": "Next",
		"label.pagination.rows.per.page": "Rows per page",
		"label.pagination.items.per.page": "Items per page",
		"label.name": "Name",
		"label.username": "Username",
		"label.email": "Email",
		"label.status": "Status",
		"label.role": "Role",
		"label.roles": "Roles",
		"label.group": "Group",
		"label.policyTemplate": "Policy Template",
		"label.version": "Version",
		"label.update.to.version": "Update to version",
		"label.type": "Type",
		"label.metadata": "Metadata",
		"label.description": "Description",
		"label.assets": "Assets",
		"label.assets.help": "This metadata file contains environment dependency information.",
		"label.download": "Download",
		"label.deploy": "Deploy",
		"label.details": "Details",
		"label.redeploy": "Redeploy",
		"label.undeploy": "Undeploy",
		"label.more.info": "More Info",
		"label.check.now": "Check now",
		"label.updating": "Updating...",
		"label.update": "Update",
		"label.validating": "Validating...",
		"label.not.applicable": "N/A",
		"label.information": "Information",
		"label.last.updated": "Last Updated",
		"label.updating.status.check.in": "Updating status: check in",
		"label.update.in": "Update in",
		"label.unit.seconds": "s",
		"label.actions.button": "Actions",
		"label.ok.button": "OK",
		"label.next.button": "Next",
		"label.save.button": "Save",
		"label.save.and.next.button": "Save & Next",
		"label.cancel.button": "Cancel",
		"label.copy.button": "Copy",
		"label.close.button": "Close",
		"label.copy.close.button": "Copy & Close",
		"label.exit.button": "Exit",
		"label.go.to": "Go To",
		"label.go": "Go",
		"label.delete.button": "Delete",
		"label.delete.confirmation.title": "Confirm Delete",
		"label.delete.confirmation.text": "This action cannot be undone.",
		"label.action.confirmation.text": "Are you sure you want to perform this action?",
		"label.no.results": "No results",
		"label.deployments.filter.by.name.placeholder": "Proxy Name",
		"label.deployments.state.all": "All Deployment Status",
		"label.deployments.state.any": "Any Deployment Status",
		"label.deployments.state.deployed": "Deployed",
		"label.deployments.state.not.deployed": "Not Deployed",
		"label.deployments.state.pending.deployment": "Pending Deployment",
		"label.deployments.state.pending.undeployment": "Pending Undeployment",
		"label.deployments.state.error.undeploy": "Error Undeploy",
		"label.deployments.state.error": "Error",
		"label.api.key.delete.confirmation.text": "Key will be removed immediately and all application access via this key will be lost. This cannot be undone. To temporarily revoke access consider disabling the key instead.",
		"label.api.key.delete.button": "Delete Key",
		"label.api.key.delete.loading.title": "Deleting Key",
		"label.api.key.delete.loading.text": "Undeploying and deleting key. This may take several minutes.",
		"label.account.plans": "Account Plans",
		"label.apis": "APIs",
		"label.api.plans": "API Plans",
		"label.application.api.keys": "Application API Keys",
		"label.gateway.bundles": "Gateway Bundles",
		"label.gateway.bundle.no.results": "You have no Gateway Bundles.",
		"label.gateway.bundle.filter.no.results": "There are no Gateway Bundles to match your criteria.",
		"label.gateway.bundle.use.add.button.help": "Use the Add Bundle button to upload your files.",
		"label.gateway.bundle.list.page.title": "Gateway Bundles",
		"label.gateway.bundle.list.page.title.help": "Any Gateway code, configuration, or environment can be exported as a Gateway Bundle from Policy Plugin. It can be managed and deployed to proxies in Portal.",
		"label.gateway.bundle.list.page.filter.by.name.placeholder": "Gateway Bundle Name",
		"label.gateway.bundle.list.page.filter.by.group.placeholder": "Group",
		"label.gateway.bundle.list.page.sort.by.date.created.asc": "Date Created: Old to New",
		"label.gateway.bundle.list.page.sort.by.date.created.desc": "Date Created: New to Old",
		"label.gateway.bundle.api.page.sort.by.date.modified.asc": "Date Modified: Old to New",
		"label.gateway.bundle.api.page.sort.by.date.modified.desc": "Date Modified: New to Old",
		"label.gateway.bundle.add.button": "Add Bundle",
		"label.gateway.bundle.date.created": "Date Created ({zone})",
		"label.gateway.bundle.details.page.title": "GATEWAY BUNDLE DETAILS",
		"label.gateway.bundle.details.page.metadata.title": "Metadata",
		"label.gateway.bundle.details.l7Template": "Policy Template",
		"label.gateway.bundle.details.l7Template.tooltip": "Contains encapsulated assertions that are reusable through API assignment.",
		"label.gateway.bundle.details.apis.tooltip": "Number of Apis that are using the policy template from this bundle",
		"label.gateway.bundle.details.page.deployments.title": "Gateway Bundle Deployments",
		"label.gateway.bundle.details.page.api.title": "APIs",
		"label.gateway.bundle.actions.delete.disabled.tooltip": "Cannot delete a Gateway Bundle. The bundle is deployed on one or more proxies or referred in one or more APIs. Undeploy the bundle from all proxies or remove the policy template of the bundle from the API(s).",
		"label.gateway.bundle.file.uploader": "Click to upload or drag files here",
		"label.gateway.bundle.file.help": "Required files: Metadata yml file, Gateway Bundle, Delete Bundle. Maximum size per file is 15 MB.",
		"label.gateway.bundle.selected.file.metadata.yml.title": "Metadata (.metadata.yml)",
		"label.gateway.bundle.selected.file.bundle.title": "Gateway Bundle (.install.bundle)",
		"label.gateway.bundle.selected.file.delete.bundle.title": "Delete Bundle (.delete.bundle)",
		"label.gateway.bundle.edit.help.title": "Gateway Bundles Help",
		"label.gateway.bundle.edit.help.0.desc": "A Gateway Bundle is a set of files generated by the Policy Plugin. It can be deployed to a proxy.",
		"label.gateway.bundle.edit.help.1.desc": "If the Gateway Bundle is reusable, it can be consumed by a Portal-published API:",
		"label.gateway.bundle.edit.help.1.0": "Portal creates an API policy template from the metadata.",
		"label.gateway.bundle.edit.help.1.1": "Associate the policy with an API.",
		"label.gateway.bundle.edit.help.1.2": "Deploy the Gateway Bundle to a proxy.",
		"label.gateway.bundle.edit.help.1.3": "Deploy the API to the proxy.",
		"label.gateway.bundle.edit.help.2.desc": "Note: The policy must be available on the proxy where the API is deployed.",
		"label.gateway.bundle.delete.confirmation.text": "The Gateway Bundle {bundleName} will be deleted. This action cannot be undone.",
		"label.gateway.bundle.deleted": "Bundle deleted.",
		"label.gateway.bundle.deployment.type": "Deployment type",
		"label.gateway.bundle.deployment.ondemand": "On Demand",
		"label.gateway.bundle.delete.button": "Delete Gateway Bundle",
		"label.gateway.bundle.apis.filter.no.results": "There are no api to match your criteria.",
		"label.gateway.bundle.apis.no.results": "You have no apis associated with this Gateway Bundle.",
		"label.gateway.bundle.apis.filter.by.name.placeholder": "API Name",
		"label.gateway.bundle.apis.filter.by.proxy.name.placeholder": "Proxy Name",
		"label.gateway.bundle.api.states.all": "All States",
		"label.gateway.bundle.api.states.enabled": "Enabled",
		"label.gateway.bundle.api.states.disabled": "Disabled",
		"label.gateway.bundle.api.states.deprecated": "Deprecated",
		"label.gateway.bundle.api.states.unpublished": "Unpublished",
		"label.gateway.bundle.list.page.type.by.all.bundle.types": "All",
		"label.gateway.bundle.list.page.type.by.any.bundle.types": "Any Bundle Types",
		"label.gateway.bundle.list.page.type.by.encapsulated.assertion": "Encapsulated Assertion",
		"label.gateway.bundle.list.page.type.by.environment": "Environment",
		"label.gateway.bundle.list.page.policy.template.by.any": "Policy Template: Any",
		"label.gateway.bundle.list.page.policy.template.by.true": "Policy Template: True",
		"label.gateway.bundle.list.page.policy.template.by.false": "Policy Template: False",
		"label.user.filter.no.results": "There are no Users to match your criteria.",
		"label.organizations": "Organizations",
		"label.organization(s)": "Organization(s)",
		"label.organization.list.page.title": "Organizations",
		"label.organization.list.add.button": "Add Organization",
		"label.organization.list.page.filter.by.name.placeholder": "Enter Org Name",
		"label.organization.name": "Organization Name",
		"label.organization.type": "Type",
		"label.organization.accountplan": "Account Plan",
		"label.organization.state": "State",
		"label.organization.list.error": "Unknown error occured",
		"label.organization.no.results": "You have no Organizations.",
		"label.organization.filter.no.results": "There are no Organizations to match your criteria.",
		"label.organization.list.page.filter.by.all.types": "All Organization Types",
		"label.organization.list.page.filter.by.publisher.types": "Publisher",
		"label.organization.list.page.filter.by.consumer.types": "Consumer",
		"label.organization.list.page.help.text.consumer": "Organization that can only consume APIs",
		"label.organization.list.page.help.text.publisher": "Organization that can publish and consume APIs ",
		"label.organization.form.page.organization.add": "Add Organization",
		"label.organization.form.page.organization.edit": "Edit Organization",
		"label.organization.form.page.organization.name": "Organization Name",
		"label.organization.form.page.organization.type": "Type",
		"label.organization.form.page.organization.account.plan": "Account Plan",
		"label.organization.form.page.organization.public.description": "Public Description",
		"label.organization.form.page.place.holder.text": "Please select an Account Plan",
		"label.organization.form.page.radio.group.option.publisher": "Publisher",
		"label.organization.form.page.radio.group.option.publisher.description": "Organization that can have Org Publishers and be the managing organization of APIs.",
		"label.organization.form.page.radio.group.option.consumer": "Consumer",
		"label.organization.form.page.radio.group.option.consumer.description": "Organization that has users who can view and consume APIs.",
		"label.organization.form.page.helper.text.name": "Maximum name length is 255 characters. Name must be unique.",
		"label.organization.form.page.helper.text.description": "Maximum description length is 255 characters.",
		"label.organization.form.page.side.help.1": "You can add a new organization or edit an existing organization on this page. Organizations must be either one of the following organization types:",
		"label.organization.form.page.side.help.1.0": "Publisher: Allows managing APIs, publishing APIs, and proxy mappings.",
		"label.organization.form.page.side.help.1.1": "Consumer: Allows only consuming APIs.",
		"label.organization.form.page.side.help.2": "You can edit an Organization and change the Organization Type from Publisher to Consumer only after you remove all the following associations with the Publisher organization:",
		"label.organization.form.page.side.help.2.0": "Remove all Org Publishers from the organization",
		"label.organization.form.page.side.help.2.1": "Remove all managed APIs from the organization",
		"label.organization.form.page.side.help.2.2": "Remove all proxy mappings from the organization",
		"label.organization.form.page.side.help.3": "Note: Changing the organization type will supersede user permissions.",
		"label.organization.form.page.side.help.4": "Select the Account Plan from the drop-down menu and add a description. Click Create.",
		"label.organization.created.message": "Organization created.",
		"label.organization.updated.message": "Organization updated.",
		"label.user.list.page.title": "Users",
		"label.user.add.button": "Add User",
		"label.user.list.page.filter.by.name.placeholder": "Name",
		"label.user.list.page.filter.by.email.placeholder": "Email",
		"label.user.list.page.organization.by.all.organizations": "All Organizations",
		"label.user.list.page.role.by.all.roles": "All Roles",
		"label.user.role.portaladministrators": "Admin",
		"label.user.role.apiowners": "API Owner",
		"label.user.role.devorgadministrators": "Organization Admin",
		"label.user.role.orgpublishers": "Organization Publisher",
		"label.user.role.developers": "Developer",
		"label.user.list.page.status.by.all.statuses": "All Statuses",
		"label.user.status.enabled": "Enabled",
		"label.user.status.disabled": "Disabled",
		"label.user.status.locked": "Locked",
		"label.user.status.registration.init": "Pending Activation",
		"label.user.status.registration.pending.approval": "Pending Approval",
		"label.user.deleted": "User Deleted.",
		"label.user.no.name": "(no name given)",
		"label.api.name": "API Name",
		"label.api.tags": "Tags",
		"label.api.version": "Version",
		"label.api.deployed.proxies": "Deployed Proxies",
		"label.api.date.modified": "Date Modified ({zone})",
		"label.api.date.last.deployed": "Last Deployed ({zone})",
		"label.api.state": "State",
		"label.api.publish.source": "Publish Source",
		"label.api.deployed.status": "Deployment Status",
		"label.api.tags.available": "Available Tags",
		"label.api.tags.selected": "Selected Tags",
		"label.api.location": "Location of API",
		"label.api.location.help": "Requests to the API are forwarded to this hosted location. Maximum length is 255 characters.",
		"label.api.proxyUrl": "API URI",
		"label.api.proxyUrl.default": "[API Proxy URL] /",
		"label.api.proxyUrl.help": "Enter the relative URI to the API for applications to access. The URI must be unique and have a maximum length of 127 characters.",
		"label.apis.filter.no.results": "There are no api to match your criteria.",
		"label.apis.states.all": "All States",
		"label.apis.states.enabled": "Enabled",
		"label.apis.states.disabled": "Disabled",
		"label.apis.states.deprecated": "Deprecated",
		"label.apis.states.unpublished": "Unpublished",
		"label.apis.states.deleted": "Deleted",
		"label.apis.states.incomplete": "Incomplete",
		"label.apis.states.pending.bundle": "Pending Bundle",
		"label.apis.states.pending.delete": "Pending Delete",
		"label.apis.publish.source.all": "All Publish Sources",
		"label.apis.publish.source.portal": "Portal",
		"label.apis.publish.source.gateway": "Gateway",
		"label.apis.page.sort.by.last.deployed.asc": "Last Deployed: Old to New",
		"label.apis.page.sort.by.last.deployed.desc": "Last Deployed: New to Old",
		"label.api.keys.name": "Key Name",
		"label.api.keys.client.id": "Client ID",
		"label.api.keys.api.key": "API Key",
		"label.api.keys.status": "Key Status",
		"label.api.keys.deployment.status": "Key Deployment Status",
		"label.api.keys.application.name": "Application Name",
		"label.api.keys.last.deployed": "Last Deployed ({zone})",
		"label.api.keys.key.name.placeholder": "Key Name",
		"label.api.keys.api.key.placeholder": "API Key (Exact Match Only)",
		"label.api.keys.client.id.placeholder": "Client ID (Exact Match Only)",
		"label.api.keys.application.name.placeholder": "Application Name",
		"label.apis.key.status.any": "Any Status",
		"label.api.keys.list.no.results": "No results found",
		"label.api.keys.client.id.list.no.results": "Cliend ID search can only be an exact match. Enter full Client ID.",
		"label.api.keys.api.key.list.no.results": "API Key search can only be an exact match. Enter full API key.",
		"label.application.add": "Add Application",
		"label.application.edit": "Edit Application",
		"label.application.delete": "Delete Application",
		"label.application.apis.selected.api.plan": "API Plan: ",
		"label.application.apis.selected.api.plan.placeholder": "Please Select",
		"label.application.apis.selected.empty": "Add APIs and API groups to your application from the Available APIs/Available API Groups lists, below.",
		"label.application.create.assist.text": "You will receive an API key right away.",
		"label.application.create.select.hashing": "Create & Get Key",
		"label.application.create.after.approval.assist.text": "You will receive an API key right away. The app will work after it is approved.",
		"label.application.create.after.approval.select.hashing": "Submit & Get Key",
		"label.application.create.success": "Application created.",
		"label.application.update.success": "Application updated.",
		"label.application.request.submit": "Submit Request",
		"label.application.request.submit.success": "Application request submitted.",
		"label.application.key.state.enabled": "Enabled",
		"label.application.key.state.disabled": "Disabled",
		"label.application.key": "API Key (Client ID)",
		"label.application.key.name": "Key Name",
		"label.application.key.name.help": "The key name must be unique to this application. Maximum length is 255 characters.",
		"label.application.key.default": "Default Key",
		"label.application.key.default.help": "You can specify only one API key as the default key for the application. Applications require a default key.",
		"label.application.key.oauth.callback.url": "Callback/Redirect URL(s)",
		"label.application.key.oauth.callback.url.help": "Use commas to separate entries. Maximum length is 2048 characters.",
		"label.application.key.oauth.scope": "Scope",
		"label.application.key.oauth.scope.help": "Use spaces to separate entries. Maximum length is 4000 characters (450 characters for OTK versions older than 4.4).",
		"label.application.key.shared.secret": "Shared Secret (Client Secret)",
		"label.application.key.shared.secret.request": "Request",
		"label.application.key.shared.secret.generate.new": "Generate New Secret",
		"label.application.key.shared.secret.request.new": "Request New Secret",
		"label.application.key.shared.secret.plain": "Plaintext Secret",
		"label.application.key.shared.secret.hashed": "Hashed Secret",
		"label.application.key.shared.secret.hashed.generated.help": "Copy this shared secret. It will not be shown again.",
		"label.application.key.shared.secret.generated.info.1": "The newly generated secret is saved when you save the changes to the API key.",
		"label.application.key.shared.secret.generated.info.2": "The old secret is no longer valid. Share the new secret with the developers coding for this application.",
		"label.application.key.deployment.tooltip.title": "Key Deployment Types",
		"label.application.key.deployment.tooltip.subtitle": "Tip! You can change the type in the proxy settings.",
		"label.application.key.deployment.automatic.tooltip.title": "Automatic",
		"label.application.key.deployment.automatic.tooltip.subtitle": "API Portal automatically deploys the API key to all proxies.",
		"label.application.key.deployment.on.demand.tooltip.title": "On Demand",
		"label.application.key.deployment.on.demand.tooltip.subtitle": "The Portal Admin and users with deployment permissions manage the API key deployment to proxies as needed.",
		"label.application.key.create.success": "Key created.",
		"label.application.key.update.success": "Key updated.",
		"label.application.key.delete.success": "Key deleted.",
		"label.application.delete.confirmation.text": "Are you sure you want to delete the application?",
		"label.application.deleting": "Deleting Application",
		"label.application.deleting.status.text": "Undeploying keys and deleting application. This may take several minutes.",
		"label.proxy.details.page.title": "Proxy Details",
		"label.proxy.details.page.status.pending.enrollment": "Pending Enrollment",
		"label.proxy.details.page.overview.title": "Overview",
		"label.proxy.details.page.overview.gateway.version": "Gateway Version",
		"label.proxy.details.page.overview.otk.version": "OTK Version",
		"label.proxy.details.page.overview.proxy.url": "Proxy URL",
		"label.proxy.details.page.overview.organizations": "Organizations",
		"label.proxy.details.page.apis.deployments.title": "API Deployments",
		"label.proxy.details.page.application.api.keys.deployments.title": "API Key Deployments",
		"label.proxy.details.page.select.organization": "Select Organization",
		"label.proxy.details.page.overview.portal.compatibility": "Portal Compatibility",
		"label.proxy.details.page.overview.portal.compatibility.tooltip": "The API Proxy is compatible with the currently installed version of the API Portal, provided the latest Portal Integration Bundle is installed on the proxy after a Portal upgrade.",
		"label.proxy.details.page.overview.portal.incompatibility.tooltip": "The installed Portal Integration Bundle is outdated and requires updating in order for you to optimize API and API Key deployments and continue using all of the Portal's available features. To learn how to update the Portal Integration Bundle, see the 'Integration On-Premise API Proxies' topic in the API Developer Portal documentation.",
		"label.proxy.details.page.overview.portal.compatible": "Up to date",
		"label.proxy.details.page.overview.portal.incompatible": "Update required",
		"label.proxy.details.page.overview.deployment.type": "Deployment Type",
		"label.proxy.details.page.overview.deployment.type.automatic": "Automatic",
		"label.proxy.details.page.overview.deployment.type.on.demand": "On Demand",
		"label.proxy.details.page.overview.deployment.type.scripted": "Scripted",
		"label.proxy.details.page.overview.api.plans": "API Plans",
		"label.proxy.details.page.overview.account.plans": "Account Plans",
		"label.proxy.details.page.source": "Source",
		"label.proxy.details.page.status.published": "Published",
		"label.proxy.details.page.status.all.keys": "All Keys",
		"label.proxy.details.page.status.not.deployed": "Not Deployed",
		"label.proxy.details.page.status.pending": "Pending",
		"label.proxy.details.page.status.deployed": "Deployed",
		"label.proxy.details.page.status.error": "Error",
		"label.proxy.details.page.status.api.key.store": "API Key Store",
		"label.proxy.details.page.status.connected": "Connected",
		"label.proxy.details.page.status.disconnected": "Disconnected",
		"label.proxy.details.proxy.url.copied": "Proxy URL was copied to the clipboard.",
		"label.proxy.details.api.deployment.automatic.tooltip": "Published count is the number of APIs added to API Portal.",
		"label.proxy.details.api.deployment.on.demand.tooltip": "Gateway Published APIs cannot be deployed to On Demand proxies. Published count is the number of APIs added to API Portal.",
		"label.proxy.details.api.newsync": "new sync",
		"label.proxy.details.api.last.deployed": "Last deployed",
		"label.proxy.details.api.total": "Total",
		"label.proxy.details.api.portal": "Portal",
		"label.proxy.details.api.portal.published": "Portal Published",
		"label.proxy.details.api.gateway": "Gateway",
		"label.proxy.details.api.gateway.published": "Gateway Published",
		"label.proxy.details.api.hide.subtotal": "Hide Subtotal",
		"label.proxy.details.api.show.subtotal": "Show Subtotal",
		"label.proxy.details.portal.gateway.counts.different": "Portal & Gateway have different counts.",
		"label.proxy.details.api.proxy": "reporting on Proxy",
		"label.proxy.details.api.title.helptext": "Improved automatic sync running asynchronously.",
		"label.proxy.details.api.card.helptext": "APIs published to the proxy.",
		"label.proxy.details.api.old.card.helptext": "APIs added to the portal.",
		"label.proxy.details.api.key.deployment.tooltip": "All Keys count is the number of API Keys generated within the Applications in API Portal. API Key Store count is the number of API keys synched to the key store.",
		"label.proxy.details.edit.button": "Edit Proxy",
		"label.proxy.details.delete.button": "Delete Proxy",
		"label.proxy.details.delete.confirmation.text": "The Proxy will be deleted. This action cannot be undone.",
		"label.proxy.details.pending.enrollment.title": "Complete Proxy Enrollment",
		"label.proxy.details.pending.enrollment.copy.url.title": "1. Copy URL to Policy Manager",
		"label.proxy.details.pending.enrollment.enrollment.url": "Enrollment URL",
		"label.proxy.details.pending.enrollment.enrollment.url.copied": "Enrollment URL was copied to the clipboard.",
		"label.proxy.details.pending.enrollment.expires.text": "Expires in 24 hrs.",
		"label.proxy.details.pending.enrollment.confirm.enrollment.title": "2. Confirm Enrollment",
		"label.proxy.details.pending.enrollment.post.enrollment.note": "Return to this page to confirm that the proxy has been enrolled via Policy Manager.",
		"label.proxy.details.pending.enrollment.check.status": "Check Status",
		"label.proxy.details.pending.enrollment.checking": "Checking...",
		"label.proxy.details.info.switch.newSync": "This proxy is using a legacy automatic API deployment sync and will be deprecated. Switch over to the new automatic sync to optimize your API deployments.",
		"label.proxy.details.info.switch.linkText": "Switch to new sync",
		"label.proxy.details.apis.no.results": "You have no apis associated with this Proxy.",
		"label.proxy.details.tab.error.copied": "Error copied"
	};

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var hyphenate = __webpack_require__(1245);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var hyphenate__default = /*#__PURE__*/_interopDefaultLegacy(hyphenate);
	
	/**
	 * Convert camel cased property names to dash separated.
	 *
	 * @param {Object} style
	 * @return {Object}
	 */
	
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    var key = prop.indexOf('--') === 0 ? prop : hyphenate__default['default'](prop);
	    converted[key] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 *
	 * @param {Rule} rule
	 */
	
	
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  function onChangeValue(value, prop, rule) {
	    if (prop.indexOf('--') === 0) {
	      return value;
	    }
	
	    var hyphenatedProp = hyphenate__default['default'](prop); // There was no camel case in place
	
	    if (prop === hyphenatedProp) return value;
	    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
	
	    return null;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = camelCase;


/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(96);
	
	var px = jss.hasCSSTOMSupport && CSS ? CSS.px : 'px';
	var ms = jss.hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
	var percent = jss.hasCSSTOMSupport && CSS ? CSS.percent : '%';
	/**
	 * Generated jss-plugin-default-unit CSS property units
	 *
	 * @type object
	 */
	
	var defaultUnits = {
	  // Animation properties
	  'animation-delay': ms,
	  'animation-duration': ms,
	  // Background properties
	  'background-position': px,
	  'background-position-x': px,
	  'background-position-y': px,
	  'background-size': px,
	  // Border Properties
	  border: px,
	  'border-bottom': px,
	  'border-bottom-left-radius': px,
	  'border-bottom-right-radius': px,
	  'border-bottom-width': px,
	  'border-left': px,
	  'border-left-width': px,
	  'border-radius': px,
	  'border-right': px,
	  'border-right-width': px,
	  'border-top': px,
	  'border-top-left-radius': px,
	  'border-top-right-radius': px,
	  'border-top-width': px,
	  'border-width': px,
	  'border-block': px,
	  'border-block-end': px,
	  'border-block-end-width': px,
	  'border-block-start': px,
	  'border-block-start-width': px,
	  'border-block-width': px,
	  'border-inline': px,
	  'border-inline-end': px,
	  'border-inline-end-width': px,
	  'border-inline-start': px,
	  'border-inline-start-width': px,
	  'border-inline-width': px,
	  'border-start-start-radius': px,
	  'border-start-end-radius': px,
	  'border-end-start-radius': px,
	  'border-end-end-radius': px,
	  // Margin properties
	  margin: px,
	  'margin-bottom': px,
	  'margin-left': px,
	  'margin-right': px,
	  'margin-top': px,
	  'margin-block': px,
	  'margin-block-end': px,
	  'margin-block-start': px,
	  'margin-inline': px,
	  'margin-inline-end': px,
	  'margin-inline-start': px,
	  // Padding properties
	  padding: px,
	  'padding-bottom': px,
	  'padding-left': px,
	  'padding-right': px,
	  'padding-top': px,
	  'padding-block': px,
	  'padding-block-end': px,
	  'padding-block-start': px,
	  'padding-inline': px,
	  'padding-inline-end': px,
	  'padding-inline-start': px,
	  // Mask properties
	  'mask-position-x': px,
	  'mask-position-y': px,
	  'mask-size': px,
	  // Width and height properties
	  height: px,
	  width: px,
	  'min-height': px,
	  'max-height': px,
	  'min-width': px,
	  'max-width': px,
	  // Position properties
	  bottom: px,
	  left: px,
	  top: px,
	  right: px,
	  inset: px,
	  'inset-block': px,
	  'inset-block-end': px,
	  'inset-block-start': px,
	  'inset-inline': px,
	  'inset-inline-end': px,
	  'inset-inline-start': px,
	  // Shadow properties
	  'box-shadow': px,
	  'text-shadow': px,
	  // Column properties
	  'column-gap': px,
	  'column-rule': px,
	  'column-rule-width': px,
	  'column-width': px,
	  // Font and text properties
	  'font-size': px,
	  'font-size-delta': px,
	  'letter-spacing': px,
	  'text-indent': px,
	  'text-stroke': px,
	  'text-stroke-width': px,
	  'word-spacing': px,
	  // Motion properties
	  motion: px,
	  'motion-offset': px,
	  // Outline properties
	  outline: px,
	  'outline-offset': px,
	  'outline-width': px,
	  // Perspective properties
	  perspective: px,
	  'perspective-origin-x': percent,
	  'perspective-origin-y': percent,
	  // Transform properties
	  'transform-origin': percent,
	  'transform-origin-x': percent,
	  'transform-origin-y': percent,
	  'transform-origin-z': percent,
	  // Transition properties
	  'transition-delay': ms,
	  'transition-duration': ms,
	  // Alignment properties
	  'vertical-align': px,
	  'flex-basis': px,
	  // Some random properties
	  'shape-margin': px,
	  size: px,
	  gap: px,
	  // Grid properties
	  grid: px,
	  'grid-gap': px,
	  'grid-row-gap': px,
	  'grid-column-gap': px,
	  'grid-template-rows': px,
	  'grid-template-columns': px,
	  'grid-auto-rows': px,
	  'grid-auto-columns': px,
	  // Not existing properties.
	  // Used to avoid issues with jss-plugin-expand integration.
	  'box-shadow-x': px,
	  'box-shadow-y': px,
	  'box-shadow-blur': px,
	  'box-shadow-spread': px,
	  'font-line-height': px,
	  'text-shadow-x': px,
	  'text-shadow-y': px,
	  'text-shadow-blur': px
	};
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	
	  var newObj = {};
	
	  for (var _key in obj) {
	    newObj[_key] = obj[_key];
	    newObj[_key.replace(regExp, replace)] = obj[_key];
	  }
	
	  return newObj;
	}
	
	var units = addCamelCasedVersion(defaultUnits);
	/**
	 * Recursive deep style passing function
	 */
	
	function iterate(prop, value, options) {
	  if (value == null) return value;
	
	  if (Array.isArray(value)) {
	    for (var i = 0; i < value.length; i++) {
	      value[i] = iterate(prop, value[i], options);
	    }
	  } else if (typeof value === 'object') {
	    if (prop === 'fallbacks') {
	      for (var innerProp in value) {
	        value[innerProp] = iterate(innerProp, value[innerProp], options);
	      }
	    } else {
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
	      }
	    }
	  } else if (typeof value === 'number') {
	    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.
	
	    if (unit && !(value === 0 && unit === px)) {
	      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
	    }
	
	    return value.toString();
	  }
	
	  return value;
	}
	/**
	 * Add unit to numeric values.
	 */
	
	
	function defaultUnit(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = defaultUnit;


/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var jss = __webpack_require__(96);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	
	var at = '@global';
	var atPrefix = '@global ';
	
	var GlobalContainerRule =
	/*#__PURE__*/
	function () {
	  function GlobalContainerRule(key, styles, options) {
	    this.type = 'global';
	    this.at = at;
	    this.rules = void 0;
	    this.options = void 0;
	    this.key = void 0;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    this.rules = new jss.RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = GlobalContainerRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (rule) this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.rules.toString();
	  };
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule =
	/*#__PURE__*/
	function () {
	  function GlobalPrefixedRule(key, style, options) {
	    this.type = 'global';
	    this.at = at;
	    this.options = void 0;
	    this.rule = void 0;
	    this.isProcessed = false;
	    this.key = void 0;
	    this.key = key;
	    this.options = options;
	    var selector = key.substr(atPrefix.length);
	    this.rule = options.jss.createRule(selector, style, _extends__default['default']({}, options, {
	      parent: this
	    }));
	  }
	
	  var _proto2 = GlobalPrefixedRule.prototype;
	
	  _proto2.toString = function toString(options) {
	    return this.rule ? this.rule.toString(options) : '';
	  };
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + " " + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule, sheet) {
	  var options = rule.options,
	      style = rule.style;
	  var rules = style ? style[at] : null;
	  if (!rules) return;
	
	  for (var name in rules) {
	    sheet.addRule(name, rules[name], _extends__default['default']({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[at];
	}
	
	function handlePrefixedGlobalRule(rule, sheet) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
	    var selector = addScope(prop.substr(at.length), rule.selector);
	    sheet.addRule(selector, style[prop], _extends__default['default']({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (!name) return null;
	
	    if (name === at) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
	        options.scoped = false;
	      }
	    }
	
	    if (options.scoped === false) {
	      options.selector = name;
	    }
	
	    return null;
	  }
	
	  function onProcessRule(rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return;
	    handleNestedGlobalContainerRule(rule, sheet);
	    handlePrefixedGlobalRule(rule, sheet);
	  }
	
	  return {
	    onCreateRule: onCreateRule,
	    onProcessRule: onProcessRule
	  };
	}
	
	exports.default = jssGlobal;


/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var warning = __webpack_require__(88);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container, sheet) {
	    return function (match, key) {
	      var rule = container.getRule(key) || sheet && sheet.getRule(key);
	
	      if (rule) {
	        rule = rule;
	        return rule.selector;
	      }
	
	       false ? warning__default['default'](false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
	      return key;
	    };
	  }
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
	
	        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, prevOptions) {
	    // Options has been already created, now we only increase index.
	    if (prevOptions) return _extends__default['default']({}, prevOptions, {
	      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]
	
	    });
	    var nestingLevel = rule.options.nestingLevel;
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    var options = _extends__default['default']({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
	
	    });
	
	    delete options.name;
	    return options;
	  }
	
	  function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style') return style;
	    var styleRule = rule;
	    var container = styleRule.options.parent;
	    var options;
	    var replaceRef;
	
	    for (var prop in style) {
	      var isNested = prop.indexOf('&') !== -1;
	      var isNestedConditional = prop[0] === '@';
	      if (!isNested && !isNestedConditional) continue;
	      options = getOptions(styleRule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	
	        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
	
	        selector = selector.replace(refRegExp, replaceRef);
	        container.addRule(selector, style[prop], _extends__default['default']({}, options, {
	          selector: selector
	        }));
	      } else if (isNestedConditional) {
	        // Place conditional right after the parent rule to ensure right ordering.
	        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
	        // And flow doesn't know this will always be a StyleRule which has the addRule method
	        // $FlowFixMe[incompatible-use]
	        // $FlowFixMe[prop-missing]
	        .addRule(styleRule.key, style[prop], {
	          selector: styleRule.selector
	        });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle
	  };
	}
	
	exports.default = jssNested;


/***/ },
/* 1259 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  var sort = function sort(prop0, prop1) {
	    if (prop0.length === prop1.length) {
	      return prop0 > prop1 ? 1 : -1;
	    }
	
	    return prop0.length - prop1.length;
	  };
	
	  return {
	    onProcessStyle: function onProcessStyle(style, rule) {
	      if (rule.type !== 'style') return style;
	      var newStyle = {};
	      var props = Object.keys(style).sort(sort);
	
	      for (var i = 0; i < props.length; i++) {
	        newStyle[props[i]] = style[props[i]];
	      }
	
	      return newStyle;
	    }
	  };
	}
	
	exports.default = jssPropsSort;


/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var warning = __webpack_require__(88);
	var jss = __webpack_require__(96);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	
	var now = Date.now();
	var fnValuesNs = "fnValues" + now;
	var fnRuleNs = "fnStyle" + ++now;
	
	var functionPlugin = function functionPlugin() {
	  return {
	    onCreateRule: function onCreateRule(name, decl, options) {
	      if (typeof decl !== 'function') return null;
	      var rule = jss.createRule(name, {}, options);
	      rule[fnRuleNs] = decl;
	      return rule;
	    },
	    onProcessStyle: function onProcessStyle(style, rule) {
	      // We need to extract function values from the declaration, so that we can keep core unaware of them.
	      // We need to do that only once.
	      // We don't need to extract functions on each style update, since this can happen only once.
	      // We don't support function values inside of function rules.
	      if (fnValuesNs in rule || fnRuleNs in rule) return style;
	      var fnValues = {};
	
	      for (var prop in style) {
	        var value = style[prop];
	        if (typeof value !== 'function') continue;
	        delete style[prop];
	        fnValues[prop] = value;
	      } // $FlowFixMe[prop-missing]
	
	
	      rule[fnValuesNs] = fnValues;
	      return style;
	    },
	    onUpdate: function onUpdate(data, rule, sheet, options) {
	      var styleRule = rule; // $FlowFixMe[prop-missing]
	
	      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
	      // will be returned from that function.
	
	      if (fnRule) {
	        // Empty object will remove all currently defined props
	        // in case function rule returns a falsy value.
	        styleRule.style = fnRule(data) || {};
	
	        if (false) {
	          for (var prop in styleRule.style) {
	            if (typeof styleRule.style[prop] === 'function') {
	              process.env.NODE_ENV !== "production" ? warning__default['default'](false, '[JSS] Function values inside function rules are not supported.') : void 0;
	              break;
	            }
	          }
	        }
	      } // $FlowFixMe[prop-missing]
	
	
	      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
	
	      if (fnValues) {
	        for (var _prop in fnValues) {
	          styleRule.prop(_prop, fnValues[_prop](data), options);
	        }
	      }
	    }
	  };
	};
	
	exports.default = functionPlugin;


/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendor = __webpack_require__(1217);
	var jss = __webpack_require__(96);
	
	/**
	 * Add vendor prefix to a property name when needed.
	 *
	 * @api public
	 */
	
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      var atRule = rule;
	      atRule.at = vendor.supportedKeyframes(atRule.at);
	    }
	  }
	
	  function prefixStyle(style) {
	    for (var prop in style) {
	      var value = style[prop];
	
	      if (prop === 'fallbacks' && Array.isArray(value)) {
	        style[prop] = value.map(prefixStyle);
	        continue;
	      }
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, jss.toCssValue(value));
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    return prefixStyle(style);
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, jss.toCssValue(value)) || value;
	  }
	
	  return {
	    onProcessRule: onProcessRule,
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = jssVendorPrefixer;


/***/ },
/* 1262 */
/***/ function(module, exports) {

	later = function() {
	  "use strict";
	  var later = {
	    version: "1.2.0"
	  };
	  if (!Array.prototype.indexOf) {
	    Array.prototype.indexOf = function(searchElement) {
	      "use strict";
	      if (this == null) {
	        throw new TypeError();
	      }
	      var t = Object(this);
	      var len = t.length >>> 0;
	      if (len === 0) {
	        return -1;
	      }
	      var n = 0;
	      if (arguments.length > 1) {
	        n = Number(arguments[1]);
	        if (n != n) {
	          n = 0;
	        } else if (n != 0 && n != Infinity && n != -Infinity) {
	          n = (n > 0 || -1) * Math.floor(Math.abs(n));
	        }
	      }
	      if (n >= len) {
	        return -1;
	      }
	      var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	      for (;k < len; k++) {
	        if (k in t && t[k] === searchElement) {
	          return k;
	        }
	      }
	      return -1;
	    };
	  }
	  if (!String.prototype.trim) {
	    String.prototype.trim = function() {
	      return this.replace(/^\s+|\s+$/g, "");
	    };
	  }
	  later.array = {};
	  later.array.sort = function(arr, zeroIsLast) {
	    arr.sort(function(a, b) {
	      return +a - +b;
	    });
	    if (zeroIsLast && arr[0] === 0) {
	      arr.push(arr.shift());
	    }
	  };
	  later.array.next = function(val, values, extent) {
	    var cur, zeroIsLargest = extent[0] !== 0, nextIdx = 0;
	    for (var i = values.length - 1; i > -1; --i) {
	      cur = values[i];
	      if (cur === val) {
	        return cur;
	      }
	      if (cur > val || cur === 0 && zeroIsLargest && extent[1] > val) {
	        nextIdx = i;
	        continue;
	      }
	      break;
	    }
	    return values[nextIdx];
	  };
	  later.array.nextInvalid = function(val, values, extent) {
	    var min = extent[0], max = extent[1], len = values.length, zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0, next = val, i = values.indexOf(val), start = next;
	    while (next === (values[i] || zeroVal)) {
	      next++;
	      if (next > max) {
	        next = min;
	      }
	      i++;
	      if (i === len) {
	        i = 0;
	      }
	      if (next === start) {
	        return undefined;
	      }
	    }
	    return next;
	  };
	  later.array.prev = function(val, values, extent) {
	    var cur, len = values.length, zeroIsLargest = extent[0] !== 0, prevIdx = len - 1;
	    for (var i = 0; i < len; i++) {
	      cur = values[i];
	      if (cur === val) {
	        return cur;
	      }
	      if (cur < val || cur === 0 && zeroIsLargest && extent[1] < val) {
	        prevIdx = i;
	        continue;
	      }
	      break;
	    }
	    return values[prevIdx];
	  };
	  later.array.prevInvalid = function(val, values, extent) {
	    var min = extent[0], max = extent[1], len = values.length, zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0, next = val, i = values.indexOf(val), start = next;
	    while (next === (values[i] || zeroVal)) {
	      next--;
	      if (next < min) {
	        next = max;
	      }
	      i--;
	      if (i === -1) {
	        i = len - 1;
	      }
	      if (next === start) {
	        return undefined;
	      }
	    }
	    return next;
	  };
	  later.day = later.D = {
	    name: "day",
	    range: 86400,
	    val: function(d) {
	      return d.D || (d.D = later.date.getDate.call(d));
	    },
	    isValid: function(d, val) {
	      return later.D.val(d) === (val || later.D.extent(d)[1]);
	    },
	    extent: function(d) {
	      if (d.DExtent) return d.DExtent;
	      var month = later.M.val(d), max = later.DAYS_IN_MONTH[month - 1];
	      if (month === 2 && later.dy.extent(d)[1] === 366) {
	        max = max + 1;
	      }
	      return d.DExtent = [ 1, max ];
	    },
	    start: function(d) {
	      return d.DStart || (d.DStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d)));
	    },
	    end: function(d) {
	      return d.DEnd || (d.DEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d)));
	    },
	    next: function(d, val) {
	      val = val > later.D.extent(d)[1] ? 1 : val;
	      var month = later.date.nextRollover(d, val, later.D, later.M), DMax = later.D.extent(month)[1];
	      val = val > DMax ? 1 : val || DMax;
	      return later.date.next(later.Y.val(month), later.M.val(month), val);
	    },
	    prev: function(d, val) {
	      var month = later.date.prevRollover(d, val, later.D, later.M), DMax = later.D.extent(month)[1];
	      return later.date.prev(later.Y.val(month), later.M.val(month), val > DMax ? DMax : val || DMax);
	    }
	  };
	  later.dayOfWeekCount = later.dc = {
	    name: "day of week count",
	    range: 604800,
	    val: function(d) {
	      return d.dc || (d.dc = Math.floor((later.D.val(d) - 1) / 7) + 1);
	    },
	    isValid: function(d, val) {
	      return later.dc.val(d) === val || val === 0 && later.D.val(d) > later.D.extent(d)[1] - 7;
	    },
	    extent: function(d) {
	      return d.dcExtent || (d.dcExtent = [ 1, Math.ceil(later.D.extent(d)[1] / 7) ]);
	    },
	    start: function(d) {
	      return d.dcStart || (d.dcStart = later.date.next(later.Y.val(d), later.M.val(d), Math.max(1, (later.dc.val(d) - 1) * 7 + 1 || 1)));
	    },
	    end: function(d) {
	      return d.dcEnd || (d.dcEnd = later.date.prev(later.Y.val(d), later.M.val(d), Math.min(later.dc.val(d) * 7, later.D.extent(d)[1])));
	    },
	    next: function(d, val) {
	      val = val > later.dc.extent(d)[1] ? 1 : val;
	      var month = later.date.nextRollover(d, val, later.dc, later.M), dcMax = later.dc.extent(month)[1];
	      val = val > dcMax ? 1 : val;
	      var next = later.date.next(later.Y.val(month), later.M.val(month), val === 0 ? later.D.extent(month)[1] - 6 : 1 + 7 * (val - 1));
	      if (next.getTime() <= d.getTime()) {
	        month = later.M.next(d, later.M.val(d) + 1);
	        return later.date.next(later.Y.val(month), later.M.val(month), val === 0 ? later.D.extent(month)[1] - 6 : 1 + 7 * (val - 1));
	      }
	      return next;
	    },
	    prev: function(d, val) {
	      var month = later.date.prevRollover(d, val, later.dc, later.M), dcMax = later.dc.extent(month)[1];
	      val = val > dcMax ? dcMax : val || dcMax;
	      return later.dc.end(later.date.prev(later.Y.val(month), later.M.val(month), 1 + 7 * (val - 1)));
	    }
	  };
	  later.dayOfWeek = later.dw = later.d = {
	    name: "day of week",
	    range: 86400,
	    val: function(d) {
	      return d.dw || (d.dw = later.date.getDay.call(d) + 1);
	    },
	    isValid: function(d, val) {
	      return later.dw.val(d) === (val || 7);
	    },
	    extent: function() {
	      return [ 1, 7 ];
	    },
	    start: function(d) {
	      return later.D.start(d);
	    },
	    end: function(d) {
	      return later.D.end(d);
	    },
	    next: function(d, val) {
	      val = val > 7 ? 1 : val || 7;
	      return later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val - later.dw.val(d)) + (val <= later.dw.val(d) ? 7 : 0));
	    },
	    prev: function(d, val) {
	      val = val > 7 ? 7 : val || 7;
	      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (val - later.dw.val(d)) + (val >= later.dw.val(d) ? -7 : 0));
	    }
	  };
	  later.dayOfYear = later.dy = {
	    name: "day of year",
	    range: 86400,
	    val: function(d) {
	      return d.dy || (d.dy = Math.ceil(1 + (later.D.start(d).getTime() - later.Y.start(d).getTime()) / later.DAY));
	    },
	    isValid: function(d, val) {
	      return later.dy.val(d) === (val || later.dy.extent(d)[1]);
	    },
	    extent: function(d) {
	      var year = later.Y.val(d);
	      return d.dyExtent || (d.dyExtent = [ 1, year % 4 ? 365 : 366 ]);
	    },
	    start: function(d) {
	      return later.D.start(d);
	    },
	    end: function(d) {
	      return later.D.end(d);
	    },
	    next: function(d, val) {
	      val = val > later.dy.extent(d)[1] ? 1 : val;
	      var year = later.date.nextRollover(d, val, later.dy, later.Y), dyMax = later.dy.extent(year)[1];
	      val = val > dyMax ? 1 : val || dyMax;
	      return later.date.next(later.Y.val(year), later.M.val(year), val);
	    },
	    prev: function(d, val) {
	      var year = later.date.prevRollover(d, val, later.dy, later.Y), dyMax = later.dy.extent(year)[1];
	      val = val > dyMax ? dyMax : val || dyMax;
	      return later.date.prev(later.Y.val(year), later.M.val(year), val);
	    }
	  };
	  later.hour = later.h = {
	    name: "hour",
	    range: 3600,
	    val: function(d) {
	      return d.h || (d.h = later.date.getHour.call(d));
	    },
	    isValid: function(d, val) {
	      return later.h.val(d) === val;
	    },
	    extent: function() {
	      return [ 0, 23 ];
	    },
	    start: function(d) {
	      return d.hStart || (d.hStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d)));
	    },
	    end: function(d) {
	      return d.hEnd || (d.hEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d)));
	    },
	    next: function(d, val) {
	      val = val > 23 ? 0 : val;
	      var next = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val <= later.h.val(d) ? 1 : 0), val);
	      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
	        next = later.date.next(later.Y.val(next), later.M.val(next), later.D.val(next), val + 1);
	      }
	      return next;
	    },
	    prev: function(d, val) {
	      val = val > 23 ? 23 : val;
	      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (val >= later.h.val(d) ? -1 : 0), val);
	    }
	  };
	  later.minute = later.m = {
	    name: "minute",
	    range: 60,
	    val: function(d) {
	      return d.m || (d.m = later.date.getMin.call(d));
	    },
	    isValid: function(d, val) {
	      return later.m.val(d) === val;
	    },
	    extent: function(d) {
	      return [ 0, 59 ];
	    },
	    start: function(d) {
	      return d.mStart || (d.mStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d)));
	    },
	    end: function(d) {
	      return d.mEnd || (d.mEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d)));
	    },
	    next: function(d, val) {
	      var m = later.m.val(d), s = later.s.val(d), inc = val > 59 ? 60 - m : val <= m ? 60 - m + val : val - m, next = new Date(d.getTime() + inc * later.MIN - s * later.SEC);
	      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
	        next = new Date(d.getTime() + (inc + 120) * later.MIN - s * later.SEC);
	      }
	      return next;
	    },
	    prev: function(d, val) {
	      val = val > 59 ? 59 : val;
	      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d) + (val >= later.m.val(d) ? -1 : 0), val);
	    }
	  };
	  later.month = later.M = {
	    name: "month",
	    range: 2629740,
	    val: function(d) {
	      return d.M || (d.M = later.date.getMonth.call(d) + 1);
	    },
	    isValid: function(d, val) {
	      return later.M.val(d) === (val || 12);
	    },
	    extent: function() {
	      return [ 1, 12 ];
	    },
	    start: function(d) {
	      return d.MStart || (d.MStart = later.date.next(later.Y.val(d), later.M.val(d)));
	    },
	    end: function(d) {
	      return d.MEnd || (d.MEnd = later.date.prev(later.Y.val(d), later.M.val(d)));
	    },
	    next: function(d, val) {
	      val = val > 12 ? 1 : val || 12;
	      return later.date.next(later.Y.val(d) + (val > later.M.val(d) ? 0 : 1), val);
	    },
	    prev: function(d, val) {
	      val = val > 12 ? 12 : val || 12;
	      return later.date.prev(later.Y.val(d) - (val >= later.M.val(d) ? 1 : 0), val);
	    }
	  };
	  later.second = later.s = {
	    name: "second",
	    range: 1,
	    val: function(d) {
	      return d.s || (d.s = later.date.getSec.call(d));
	    },
	    isValid: function(d, val) {
	      return later.s.val(d) === val;
	    },
	    extent: function() {
	      return [ 0, 59 ];
	    },
	    start: function(d) {
	      return d;
	    },
	    end: function(d) {
	      return d;
	    },
	    next: function(d, val) {
	      var s = later.s.val(d), inc = val > 59 ? 60 - s : val <= s ? 60 - s + val : val - s, next = new Date(d.getTime() + inc * later.SEC);
	      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
	        next = new Date(d.getTime() + (inc + 7200) * later.SEC);
	      }
	      return next;
	    },
	    prev: function(d, val, cache) {
	      val = val > 59 ? 59 : val;
	      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d) + (val >= later.s.val(d) ? -1 : 0), val);
	    }
	  };
	  later.time = later.t = {
	    name: "time",
	    range: 1,
	    val: function(d) {
	      return d.t || (d.t = later.h.val(d) * 3600 + later.m.val(d) * 60 + later.s.val(d));
	    },
	    isValid: function(d, val) {
	      return later.t.val(d) === val;
	    },
	    extent: function() {
	      return [ 0, 86399 ];
	    },
	    start: function(d) {
	      return d;
	    },
	    end: function(d) {
	      return d;
	    },
	    next: function(d, val) {
	      val = val > 86399 ? 0 : val;
	      var next = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val <= later.t.val(d) ? 1 : 0), 0, 0, val);
	      if (!later.date.isUTC && next.getTime() < d.getTime()) {
	        next = later.date.next(later.Y.val(next), later.M.val(next), later.D.val(next), later.h.val(next), later.m.val(next), val + 7200);
	      }
	      return next;
	    },
	    prev: function(d, val) {
	      val = val > 86399 ? 86399 : val;
	      return later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val >= later.t.val(d) ? -1 : 0), 0, 0, val);
	    }
	  };
	  later.weekOfMonth = later.wm = {
	    name: "week of month",
	    range: 604800,
	    val: function(d) {
	      return d.wm || (d.wm = (later.D.val(d) + (later.dw.val(later.M.start(d)) - 1) + (7 - later.dw.val(d))) / 7);
	    },
	    isValid: function(d, val) {
	      return later.wm.val(d) === (val || later.wm.extent(d)[1]);
	    },
	    extent: function(d) {
	      return d.wmExtent || (d.wmExtent = [ 1, (later.D.extent(d)[1] + (later.dw.val(later.M.start(d)) - 1) + (7 - later.dw.val(later.M.end(d)))) / 7 ]);
	    },
	    start: function(d) {
	      return d.wmStart || (d.wmStart = later.date.next(later.Y.val(d), later.M.val(d), Math.max(later.D.val(d) - later.dw.val(d) + 1, 1)));
	    },
	    end: function(d) {
	      return d.wmEnd || (d.wmEnd = later.date.prev(later.Y.val(d), later.M.val(d), Math.min(later.D.val(d) + (7 - later.dw.val(d)), later.D.extent(d)[1])));
	    },
	    next: function(d, val) {
	      val = val > later.wm.extent(d)[1] ? 1 : val;
	      var month = later.date.nextRollover(d, val, later.wm, later.M), wmMax = later.wm.extent(month)[1];
	      val = val > wmMax ? 1 : val || wmMax;
	      return later.date.next(later.Y.val(month), later.M.val(month), Math.max(1, (val - 1) * 7 - (later.dw.val(month) - 2)));
	    },
	    prev: function(d, val) {
	      var month = later.date.prevRollover(d, val, later.wm, later.M), wmMax = later.wm.extent(month)[1];
	      val = val > wmMax ? wmMax : val || wmMax;
	      return later.wm.end(later.date.next(later.Y.val(month), later.M.val(month), Math.max(1, (val - 1) * 7 - (later.dw.val(month) - 2))));
	    }
	  };
	  later.weekOfYear = later.wy = {
	    name: "week of year (ISO)",
	    range: 604800,
	    val: function(d) {
	      if (d.wy) return d.wy;
	      var wThur = later.dw.next(later.wy.start(d), 5), YThur = later.dw.next(later.Y.prev(wThur, later.Y.val(wThur) - 1), 5);
	      return d.wy = 1 + Math.ceil((wThur.getTime() - YThur.getTime()) / later.WEEK);
	    },
	    isValid: function(d, val) {
	      return later.wy.val(d) === (val || later.wy.extent(d)[1]);
	    },
	    extent: function(d) {
	      if (d.wyExtent) return d.wyExtent;
	      var year = later.dw.next(later.wy.start(d), 5), dwFirst = later.dw.val(later.Y.start(year)), dwLast = later.dw.val(later.Y.end(year));
	      return d.wyExtent = [ 1, dwFirst === 5 || dwLast === 5 ? 53 : 52 ];
	    },
	    start: function(d) {
	      return d.wyStart || (d.wyStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) - (later.dw.val(d) > 1 ? later.dw.val(d) - 2 : 6)));
	    },
	    end: function(d) {
	      return d.wyEnd || (d.wyEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (later.dw.val(d) > 1 ? 8 - later.dw.val(d) : 0)));
	    },
	    next: function(d, val) {
	      val = val > later.wy.extent(d)[1] ? 1 : val;
	      var wyThur = later.dw.next(later.wy.start(d), 5), year = later.date.nextRollover(wyThur, val, later.wy, later.Y);
	      if (later.wy.val(year) !== 1) {
	        year = later.dw.next(year, 2);
	      }
	      var wyMax = later.wy.extent(year)[1], wyStart = later.wy.start(year);
	      val = val > wyMax ? 1 : val || wyMax;
	      return later.date.next(later.Y.val(wyStart), later.M.val(wyStart), later.D.val(wyStart) + 7 * (val - 1));
	    },
	    prev: function(d, val) {
	      var wyThur = later.dw.next(later.wy.start(d), 5), year = later.date.prevRollover(wyThur, val, later.wy, later.Y);
	      if (later.wy.val(year) !== 1) {
	        year = later.dw.next(year, 2);
	      }
	      var wyMax = later.wy.extent(year)[1], wyEnd = later.wy.end(year);
	      val = val > wyMax ? wyMax : val || wyMax;
	      return later.wy.end(later.date.next(later.Y.val(wyEnd), later.M.val(wyEnd), later.D.val(wyEnd) + 7 * (val - 1)));
	    }
	  };
	  later.year = later.Y = {
	    name: "year",
	    range: 31556900,
	    val: function(d) {
	      return d.Y || (d.Y = later.date.getYear.call(d));
	    },
	    isValid: function(d, val) {
	      return later.Y.val(d) === val;
	    },
	    extent: function() {
	      return [ 1970, 2099 ];
	    },
	    start: function(d) {
	      return d.YStart || (d.YStart = later.date.next(later.Y.val(d)));
	    },
	    end: function(d) {
	      return d.YEnd || (d.YEnd = later.date.prev(later.Y.val(d)));
	    },
	    next: function(d, val) {
	      return val > later.Y.val(d) && val <= later.Y.extent()[1] ? later.date.next(val) : later.NEVER;
	    },
	    prev: function(d, val) {
	      return val < later.Y.val(d) && val >= later.Y.extent()[0] ? later.date.prev(val) : later.NEVER;
	    }
	  };
	  later.fullDate = later.fd = {
	    name: "full date",
	    range: 1,
	    val: function(d) {
	      return d.fd || (d.fd = d.getTime());
	    },
	    isValid: function(d, val) {
	      return later.fd.val(d) === val;
	    },
	    extent: function() {
	      return [ 0, 3250368e7 ];
	    },
	    start: function(d) {
	      return d;
	    },
	    end: function(d) {
	      return d;
	    },
	    next: function(d, val) {
	      return later.fd.val(d) < val ? new Date(val) : later.NEVER;
	    },
	    prev: function(d, val) {
	      return later.fd.val(d) > val ? new Date(val) : later.NEVER;
	    }
	  };
	  later.modifier = {};
	  later.modifier.after = later.modifier.a = function(constraint, values) {
	    var value = values[0];
	    return {
	      name: "after " + constraint.name,
	      range: (constraint.extent(new Date())[1] - value) * constraint.range,
	      val: constraint.val,
	      isValid: function(d, val) {
	        return this.val(d) >= value;
	      },
	      extent: constraint.extent,
	      start: constraint.start,
	      end: constraint.end,
	      next: function(startDate, val) {
	        if (val != value) val = constraint.extent(startDate)[0];
	        return constraint.next(startDate, val);
	      },
	      prev: function(startDate, val) {
	        val = val === value ? constraint.extent(startDate)[1] : value - 1;
	        return constraint.prev(startDate, val);
	      }
	    };
	  };
	  later.modifier.before = later.modifier.b = function(constraint, values) {
	    var value = values[values.length - 1];
	    return {
	      name: "before " + constraint.name,
	      range: constraint.range * (value - 1),
	      val: constraint.val,
	      isValid: function(d, val) {
	        return this.val(d) < value;
	      },
	      extent: constraint.extent,
	      start: constraint.start,
	      end: constraint.end,
	      next: function(startDate, val) {
	        val = val === value ? constraint.extent(startDate)[0] : value;
	        return constraint.next(startDate, val);
	      },
	      prev: function(startDate, val) {
	        val = val === value ? value - 1 : constraint.extent(startDate)[1];
	        return constraint.prev(startDate, val);
	      }
	    };
	  };
	  later.compile = function(schedDef) {
	    var constraints = [], constraintsLen = 0, tickConstraint;
	    for (var key in schedDef) {
	      var nameParts = key.split("_"), name = nameParts[0], mod = nameParts[1], vals = schedDef[key], constraint = mod ? later.modifier[mod](later[name], vals) : later[name];
	      constraints.push({
	        constraint: constraint,
	        vals: vals
	      });
	      constraintsLen++;
	    }
	    constraints.sort(function(a, b) {
	      var ra = a.constraint.range, rb = b.constraint.range;
	      return rb < ra ? -1 : rb > ra ? 1 : 0;
	    });
	    tickConstraint = constraints[constraintsLen - 1].constraint;
	    function compareFn(dir) {
	      return dir === "next" ? function(a, b) {
	        return a.getTime() > b.getTime();
	      } : function(a, b) {
	        return b.getTime() > a.getTime();
	      };
	    }
	    return {
	      start: function(dir, startDate) {
	        var next = startDate, nextVal = later.array[dir], maxAttempts = 1e3, done;
	        while (maxAttempts-- && !done && next) {
	          done = true;
	          for (var i = 0; i < constraintsLen; i++) {
	            var constraint = constraints[i].constraint, curVal = constraint.val(next), extent = constraint.extent(next), newVal = nextVal(curVal, constraints[i].vals, extent);
	            if (!constraint.isValid(next, newVal)) {
	              next = constraint[dir](next, newVal);
	              done = false;
	              break;
	            }
	          }
	        }
	        if (next !== later.NEVER) {
	          next = dir === "next" ? tickConstraint.start(next) : tickConstraint.end(next);
	        }
	        return next;
	      },
	      end: function(dir, startDate) {
	        var result, nextVal = later.array[dir + "Invalid"], compare = compareFn(dir);
	        for (var i = constraintsLen - 1; i >= 0; i--) {
	          var constraint = constraints[i].constraint, curVal = constraint.val(startDate), extent = constraint.extent(startDate), newVal = nextVal(curVal, constraints[i].vals, extent), next;
	          if (newVal !== undefined) {
	            next = constraint[dir](startDate, newVal);
	            if (next && (!result || compare(result, next))) {
	              result = next;
	            }
	          }
	        }
	        return result;
	      },
	      tick: function(dir, date) {
	        return new Date(dir === "next" ? tickConstraint.end(date).getTime() + later.SEC : tickConstraint.start(date).getTime() - later.SEC);
	      },
	      tickStart: function(date) {
	        return tickConstraint.start(date);
	      }
	    };
	  };
	  later.schedule = function(sched) {
	    if (!sched) throw new Error("Missing schedule definition.");
	    if (!sched.schedules) throw new Error("Definition must include at least one schedule.");
	    var schedules = [], schedulesLen = sched.schedules.length, exceptions = [], exceptionsLen = sched.exceptions ? sched.exceptions.length : 0;
	    for (var i = 0; i < schedulesLen; i++) {
	      schedules.push(later.compile(sched.schedules[i]));
	    }
	    for (var j = 0; j < exceptionsLen; j++) {
	      exceptions.push(later.compile(sched.exceptions[j]));
	    }
	    function getInstances(dir, count, startDate, endDate, isRange) {
	      var compare = compareFn(dir), loopCount = count, maxAttempts = 1e3, schedStarts = [], exceptStarts = [], next, end, results = [], isForward = dir === "next", lastResult, rStart = isForward ? 0 : 1, rEnd = isForward ? 1 : 0;
	      startDate = startDate ? new Date(startDate) : new Date();
	      if (!startDate || !startDate.getTime()) throw new Error("Invalid start date.");
	      setNextStarts(dir, schedules, schedStarts, startDate);
	      setRangeStarts(dir, exceptions, exceptStarts, startDate);
	      while (maxAttempts-- && loopCount && (next = findNext(schedStarts, compare))) {
	        if (endDate && compare(next, endDate)) {
	          break;
	        }
	        if (exceptionsLen) {
	          updateRangeStarts(dir, exceptions, exceptStarts, next);
	          if (end = calcRangeOverlap(dir, exceptStarts, next)) {
	            updateNextStarts(dir, schedules, schedStarts, end);
	            continue;
	          }
	        }
	        if (isRange) {
	          var maxEndDate = calcMaxEndDate(exceptStarts, compare);
	          end = calcEnd(dir, schedules, schedStarts, next, maxEndDate);
	          var r = isForward ? [ new Date(Math.max(startDate, next)), end ? new Date(endDate ? Math.min(end, endDate) : end) : undefined ] : [ end ? new Date(endDate ? Math.max(endDate, end.getTime() + later.SEC) : end.getTime() + later.SEC) : undefined, new Date(Math.min(startDate, next.getTime() + later.SEC)) ];
	          if (lastResult && r[rStart].getTime() === lastResult[rEnd].getTime()) {
	            lastResult[rEnd] = r[rEnd];
	            loopCount++;
	          } else {
	            lastResult = r;
	            results.push(lastResult);
	          }
	          if (!end) break;
	          updateNextStarts(dir, schedules, schedStarts, end);
	        } else {
	          results.push(isForward ? new Date(Math.max(startDate, next)) : getStart(schedules, schedStarts, next, endDate));
	          tickStarts(dir, schedules, schedStarts, next);
	        }
	        loopCount--;
	      }
	      for (var i = 0, len = results.length; i < len; i++) {
	        var result = results[i];
	        results[i] = Object.prototype.toString.call(result) === "[object Array]" ? [ cleanDate(result[0]), cleanDate(result[1]) ] : cleanDate(result);
	      }
	      return results.length === 0 ? later.NEVER : count === 1 ? results[0] : results;
	    }
	    function cleanDate(d) {
	      if (d instanceof Date && !isNaN(d.valueOf())) {
	        return new Date(d);
	      }
	      return undefined;
	    }
	    function setNextStarts(dir, schedArr, startsArr, startDate) {
	      for (var i = 0, len = schedArr.length; i < len; i++) {
	        startsArr[i] = schedArr[i].start(dir, startDate);
	      }
	    }
	    function updateNextStarts(dir, schedArr, startsArr, startDate) {
	      var compare = compareFn(dir);
	      for (var i = 0, len = schedArr.length; i < len; i++) {
	        if (startsArr[i] && !compare(startsArr[i], startDate)) {
	          startsArr[i] = schedArr[i].start(dir, startDate);
	        }
	      }
	    }
	    function setRangeStarts(dir, schedArr, rangesArr, startDate) {
	      var compare = compareFn(dir);
	      for (var i = 0, len = schedArr.length; i < len; i++) {
	        var nextStart = schedArr[i].start(dir, startDate);
	        if (!nextStart) {
	          rangesArr[i] = later.NEVER;
	        } else {
	          rangesArr[i] = [ nextStart, schedArr[i].end(dir, nextStart) ];
	        }
	      }
	    }
	    function updateRangeStarts(dir, schedArr, rangesArr, startDate) {
	      var compare = compareFn(dir);
	      for (var i = 0, len = schedArr.length; i < len; i++) {
	        if (rangesArr[i] && !compare(rangesArr[i][0], startDate)) {
	          var nextStart = schedArr[i].start(dir, startDate);
	          if (!nextStart) {
	            rangesArr[i] = later.NEVER;
	          } else {
	            rangesArr[i] = [ nextStart, schedArr[i].end(dir, nextStart) ];
	          }
	        }
	      }
	    }
	    function tickStarts(dir, schedArr, startsArr, startDate) {
	      for (var i = 0, len = schedArr.length; i < len; i++) {
	        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
	          startsArr[i] = schedArr[i].start(dir, schedArr[i].tick(dir, startDate));
	        }
	      }
	    }
	    function getStart(schedArr, startsArr, startDate, minEndDate) {
	      var result;
	      for (var i = 0, len = startsArr.length; i < len; i++) {
	        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
	          var start = schedArr[i].tickStart(startDate);
	          if (minEndDate && start < minEndDate) {
	            return minEndDate;
	          }
	          if (!result || start > result) {
	            result = start;
	          }
	        }
	      }
	      return result;
	    }
	    function calcRangeOverlap(dir, rangesArr, startDate) {
	      var compare = compareFn(dir), result;
	      for (var i = 0, len = rangesArr.length; i < len; i++) {
	        var range = rangesArr[i];
	        if (range && !compare(range[0], startDate) && (!range[1] || compare(range[1], startDate))) {
	          if (!result || compare(range[1], result)) {
	            result = range[1];
	          }
	        }
	      }
	      return result;
	    }
	    function calcMaxEndDate(exceptsArr, compare) {
	      var result;
	      for (var i = 0, len = exceptsArr.length; i < len; i++) {
	        if (exceptsArr[i] && (!result || compare(result, exceptsArr[i][0]))) {
	          result = exceptsArr[i][0];
	        }
	      }
	      return result;
	    }
	    function calcEnd(dir, schedArr, startsArr, startDate, maxEndDate) {
	      var compare = compareFn(dir), result;
	      for (var i = 0, len = schedArr.length; i < len; i++) {
	        var start = startsArr[i];
	        if (start && start.getTime() === startDate.getTime()) {
	          var end = schedArr[i].end(dir, start);
	          if (maxEndDate && (!end || compare(end, maxEndDate))) {
	            return maxEndDate;
	          }
	          if (!result || compare(end, result)) {
	            result = end;
	          }
	        }
	      }
	      return result;
	    }
	    function compareFn(dir) {
	      return dir === "next" ? function(a, b) {
	        return !b || a.getTime() > b.getTime();
	      } : function(a, b) {
	        return !a || b.getTime() > a.getTime();
	      };
	    }
	    function findNext(arr, compare) {
	      var next = arr[0];
	      for (var i = 1, len = arr.length; i < len; i++) {
	        if (arr[i] && compare(next, arr[i])) {
	          next = arr[i];
	        }
	      }
	      return next;
	    }
	    return {
	      isValid: function(d) {
	        return getInstances("next", 1, d, d) !== later.NEVER;
	      },
	      next: function(count, startDate, endDate) {
	        return getInstances("next", count || 1, startDate, endDate);
	      },
	      prev: function(count, startDate, endDate) {
	        return getInstances("prev", count || 1, startDate, endDate);
	      },
	      nextRange: function(count, startDate, endDate) {
	        return getInstances("next", count || 1, startDate, endDate, true);
	      },
	      prevRange: function(count, startDate, endDate) {
	        return getInstances("prev", count || 1, startDate, endDate, true);
	      }
	    };
	  };
	  later.setTimeout = function(fn, sched) {
	    var s = later.schedule(sched), t;
	    if (fn) {
	      scheduleTimeout();
	    }
	    function scheduleTimeout() {
	      var now = Date.now(), next = s.next(2, now);
	      if (!next[0]) {
	        t = undefined;
	        return;
	      }
	      var diff = next[0].getTime() - now;
	      if (diff < 1e3) {
	        diff = next[1] ? next[1].getTime() - now : 1e3;
	      }
	      if (diff < 2147483647) {
	        t = setTimeout(fn, diff);
	      } else {
	        t = setTimeout(scheduleTimeout, 2147483647);
	      }
	    }
	    return {
	      isDone: function() {
	        return !t;
	      },
	      clear: function() {
	        clearTimeout(t);
	      }
	    };
	  };
	  later.setInterval = function(fn, sched) {
	    if (!fn) {
	      return;
	    }
	    var t = later.setTimeout(scheduleTimeout, sched), done = t.isDone();
	    function scheduleTimeout() {
	      if (!done) {
	        fn();
	        t = later.setTimeout(scheduleTimeout, sched);
	      }
	    }
	    return {
	      isDone: function() {
	        return t.isDone();
	      },
	      clear: function() {
	        done = true;
	        t.clear();
	      }
	    };
	  };
	  later.date = {};
	  later.date.timezone = function(useLocalTime) {
	    later.date.build = useLocalTime ? function(Y, M, D, h, m, s) {
	      return new Date(Y, M, D, h, m, s);
	    } : function(Y, M, D, h, m, s) {
	      return new Date(Date.UTC(Y, M, D, h, m, s));
	    };
	    var get = useLocalTime ? "get" : "getUTC", d = Date.prototype;
	    later.date.getYear = d[get + "FullYear"];
	    later.date.getMonth = d[get + "Month"];
	    later.date.getDate = d[get + "Date"];
	    later.date.getDay = d[get + "Day"];
	    later.date.getHour = d[get + "Hours"];
	    later.date.getMin = d[get + "Minutes"];
	    later.date.getSec = d[get + "Seconds"];
	    later.date.isUTC = !useLocalTime;
	  };
	  later.date.UTC = function() {
	    later.date.timezone(false);
	  };
	  later.date.localTime = function() {
	    later.date.timezone(true);
	  };
	  later.date.UTC();
	  later.SEC = 1e3;
	  later.MIN = later.SEC * 60;
	  later.HOUR = later.MIN * 60;
	  later.DAY = later.HOUR * 24;
	  later.WEEK = later.DAY * 7;
	  later.DAYS_IN_MONTH = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
	  later.NEVER = 0;
	  later.date.next = function(Y, M, D, h, m, s) {
	    return later.date.build(Y, M !== undefined ? M - 1 : 0, D !== undefined ? D : 1, h || 0, m || 0, s || 0);
	  };
	  later.date.nextRollover = function(d, val, constraint, period) {
	    var cur = constraint.val(d), max = constraint.extent(d)[1];
	    return (val || max) <= cur || val > max ? new Date(period.end(d).getTime() + later.SEC) : period.start(d);
	  };
	  later.date.prev = function(Y, M, D, h, m, s) {
	    var len = arguments.length;
	    M = len < 2 ? 11 : M - 1;
	    D = len < 3 ? later.D.extent(later.date.next(Y, M + 1))[1] : D;
	    h = len < 4 ? 23 : h;
	    m = len < 5 ? 59 : m;
	    s = len < 6 ? 59 : s;
	    return later.date.build(Y, M, D, h, m, s);
	  };
	  later.date.prevRollover = function(d, val, constraint, period) {
	    var cur = constraint.val(d);
	    return val >= cur || !val ? period.start(period.prev(d, period.val(d) - 1)) : period.start(d);
	  };
	  later.parse = {};
	  later.parse.cron = function(expr, hasSeconds) {
	    var NAMES = {
	      JAN: 1,
	      FEB: 2,
	      MAR: 3,
	      APR: 4,
	      MAY: 5,
	      JUN: 6,
	      JUL: 7,
	      AUG: 8,
	      SEP: 9,
	      OCT: 10,
	      NOV: 11,
	      DEC: 12,
	      SUN: 1,
	      MON: 2,
	      TUE: 3,
	      WED: 4,
	      THU: 5,
	      FRI: 6,
	      SAT: 7
	    };
	    var REPLACEMENTS = {
	      "* * * * * *": "0/1 * * * * *",
	      "@YEARLY": "0 0 1 1 *",
	      "@ANNUALLY": "0 0 1 1 *",
	      "@MONTHLY": "0 0 1 * *",
	      "@WEEKLY": "0 0 * * 0",
	      "@DAILY": "0 0 * * *",
	      "@HOURLY": "0 * * * *"
	    };
	    var FIELDS = {
	      s: [ 0, 0, 59 ],
	      m: [ 1, 0, 59 ],
	      h: [ 2, 0, 23 ],
	      D: [ 3, 1, 31 ],
	      M: [ 4, 1, 12 ],
	      Y: [ 6, 1970, 2099 ],
	      d: [ 5, 1, 7, 1 ]
	    };
	    function getValue(value, offset, max) {
	      return isNaN(value) ? NAMES[value] || null : Math.min(+value + (offset || 0), max || 9999);
	    }
	    function cloneSchedule(sched) {
	      var clone = {}, field;
	      for (field in sched) {
	        if (field !== "dc" && field !== "d") {
	          clone[field] = sched[field].slice(0);
	        }
	      }
	      return clone;
	    }
	    function add(sched, name, min, max, inc) {
	      var i = min;
	      if (!sched[name]) {
	        sched[name] = [];
	      }
	      while (i <= max) {
	        if (sched[name].indexOf(i) < 0) {
	          sched[name].push(i);
	        }
	        i += inc || 1;
	      }
	      sched[name].sort(function(a, b) {
	        return a - b;
	      });
	    }
	    function addHash(schedules, curSched, value, hash) {
	      if (curSched.d && !curSched.dc || curSched.dc && curSched.dc.indexOf(hash) < 0) {
	        schedules.push(cloneSchedule(curSched));
	        curSched = schedules[schedules.length - 1];
	      }
	      add(curSched, "d", value, value);
	      add(curSched, "dc", hash, hash);
	    }
	    function addWeekday(s, curSched, value) {
	      var except1 = {}, except2 = {};
	      if (value === 1) {
	        add(curSched, "D", 1, 3);
	        add(curSched, "d", NAMES.MON, NAMES.FRI);
	        add(except1, "D", 2, 2);
	        add(except1, "d", NAMES.TUE, NAMES.FRI);
	        add(except2, "D", 3, 3);
	        add(except2, "d", NAMES.TUE, NAMES.FRI);
	      } else {
	        add(curSched, "D", value - 1, value + 1);
	        add(curSched, "d", NAMES.MON, NAMES.FRI);
	        add(except1, "D", value - 1, value - 1);
	        add(except1, "d", NAMES.MON, NAMES.THU);
	        add(except2, "D", value + 1, value + 1);
	        add(except2, "d", NAMES.TUE, NAMES.FRI);
	      }
	      s.exceptions.push(except1);
	      s.exceptions.push(except2);
	    }
	    function addRange(item, curSched, name, min, max, offset) {
	      var incSplit = item.split("/"), inc = +incSplit[1], range = incSplit[0];
	      if (range !== "*" && range !== "0") {
	        var rangeSplit = range.split("-");
	        min = getValue(rangeSplit[0], offset, max);
	        max = getValue(rangeSplit[1], offset, max) || max;
	      }
	      add(curSched, name, min, max, inc);
	    }
	    function parse(item, s, name, min, max, offset) {
	      var value, split, schedules = s.schedules, curSched = schedules[schedules.length - 1];
	      if (item === "L") {
	        item = min - 1;
	      }
	      if ((value = getValue(item, offset, max)) !== null) {
	        add(curSched, name, value, value);
	      } else if ((value = getValue(item.replace("W", ""), offset, max)) !== null) {
	        addWeekday(s, curSched, value);
	      } else if ((value = getValue(item.replace("L", ""), offset, max)) !== null) {
	        addHash(schedules, curSched, value, min - 1);
	      } else if ((split = item.split("#")).length === 2) {
	        value = getValue(split[0], offset, max);
	        addHash(schedules, curSched, value, getValue(split[1]));
	      } else {
	        addRange(item, curSched, name, min, max, offset);
	      }
	    }
	    function isHash(item) {
	      return item.indexOf("#") > -1 || item.indexOf("L") > 0;
	    }
	    function itemSorter(a, b) {
	      return isHash(a) && !isHash(b) ? 1 : a - b;
	    }
	    function parseExpr(expr) {
	      var schedule = {
	        schedules: [ {} ],
	        exceptions: []
	      }, components = expr.replace(/(\s)+/g, " ").split(" "), field, f, component, items;
	      for (field in FIELDS) {
	        f = FIELDS[field];
	        component = components[f[0]];
	        if (component && component !== "*" && component !== "?") {
	          items = component.split(",").sort(itemSorter);
	          var i, length = items.length;
	          for (i = 0; i < length; i++) {
	            parse(items[i], schedule, field, f[1], f[2], f[3]);
	          }
	        }
	      }
	      return schedule;
	    }
	    function prepareExpr(expr) {
	      var prepared = expr.toUpperCase();
	      return REPLACEMENTS[prepared] || prepared;
	    }
	    var e = prepareExpr(expr);
	    return parseExpr(hasSeconds ? e : "0 " + e);
	  };
	  later.parse.recur = function() {
	    var schedules = [], exceptions = [], cur, curArr = schedules, curName, values, every, modifier, applyMin, applyMax, i, last;
	    function add(name, min, max) {
	      name = modifier ? name + "_" + modifier : name;
	      if (!cur) {
	        curArr.push({});
	        cur = curArr[0];
	      }
	      if (!cur[name]) {
	        cur[name] = [];
	      }
	      curName = cur[name];
	      if (every) {
	        values = [];
	        for (i = min; i <= max; i += every) {
	          values.push(i);
	        }
	        last = {
	          n: name,
	          x: every,
	          c: curName.length,
	          m: max
	        };
	      }
	      values = applyMin ? [ min ] : applyMax ? [ max ] : values;
	      var length = values.length;
	      for (i = 0; i < length; i += 1) {
	        var val = values[i];
	        if (curName.indexOf(val) < 0) {
	          curName.push(val);
	        }
	      }
	      values = every = modifier = applyMin = applyMax = 0;
	    }
	    return {
	      schedules: schedules,
	      exceptions: exceptions,
	      on: function() {
	        values = arguments[0] instanceof Array ? arguments[0] : arguments;
	        return this;
	      },
	      every: function(x) {
	        every = x || 1;
	        return this;
	      },
	      after: function(x) {
	        modifier = "a";
	        values = [ x ];
	        return this;
	      },
	      before: function(x) {
	        modifier = "b";
	        values = [ x ];
	        return this;
	      },
	      first: function() {
	        applyMin = 1;
	        return this;
	      },
	      last: function() {
	        applyMax = 1;
	        return this;
	      },
	      time: function() {
	        for (var i = 0, len = values.length; i < len; i++) {
	          var split = values[i].split(":");
	          if (split.length < 3) split.push(0);
	          values[i] = +split[0] * 3600 + +split[1] * 60 + +split[2];
	        }
	        add("t");
	        return this;
	      },
	      second: function() {
	        add("s", 0, 59);
	        return this;
	      },
	      minute: function() {
	        add("m", 0, 59);
	        return this;
	      },
	      hour: function() {
	        add("h", 0, 23);
	        return this;
	      },
	      dayOfMonth: function() {
	        add("D", 1, applyMax ? 0 : 31);
	        return this;
	      },
	      dayOfWeek: function() {
	        add("d", 1, 7);
	        return this;
	      },
	      onWeekend: function() {
	        values = [ 1, 7 ];
	        return this.dayOfWeek();
	      },
	      onWeekday: function() {
	        values = [ 2, 3, 4, 5, 6 ];
	        return this.dayOfWeek();
	      },
	      dayOfWeekCount: function() {
	        add("dc", 1, applyMax ? 0 : 5);
	        return this;
	      },
	      dayOfYear: function() {
	        add("dy", 1, applyMax ? 0 : 366);
	        return this;
	      },
	      weekOfMonth: function() {
	        add("wm", 1, applyMax ? 0 : 5);
	        return this;
	      },
	      weekOfYear: function() {
	        add("wy", 1, applyMax ? 0 : 53);
	        return this;
	      },
	      month: function() {
	        add("M", 1, 12);
	        return this;
	      },
	      year: function() {
	        add("Y", 1970, 2450);
	        return this;
	      },
	      fullDate: function() {
	        for (var i = 0, len = values.length; i < len; i++) {
	          values[i] = values[i].getTime();
	        }
	        add("fd");
	        return this;
	      },
	      customModifier: function(id, vals) {
	        var custom = later.modifier[id];
	        if (!custom) throw new Error("Custom modifier " + id + " not recognized!");
	        modifier = id;
	        values = arguments[1] instanceof Array ? arguments[1] : [ arguments[1] ];
	        return this;
	      },
	      customPeriod: function(id) {
	        var custom = later[id];
	        if (!custom) throw new Error("Custom time period " + id + " not recognized!");
	        add(id, custom.extent(new Date())[0], custom.extent(new Date())[1]);
	        return this;
	      },
	      startingOn: function(start) {
	        return this.between(start, last.m);
	      },
	      between: function(start, end) {
	        cur[last.n] = cur[last.n].splice(0, last.c);
	        every = last.x;
	        add(last.n, start, end);
	        return this;
	      },
	      and: function() {
	        cur = curArr[curArr.push({}) - 1];
	        return this;
	      },
	      except: function() {
	        curArr = exceptions;
	        cur = null;
	        return this;
	      }
	    };
	  };
	  later.parse.text = function(str) {
	    var recur = later.parse.recur, pos = 0, input = "", error;
	    var TOKENTYPES = {
	      eof: /^$/,
	      rank: /^((\d\d\d\d)|([2-5]?1(st)?|[2-5]?2(nd)?|[2-5]?3(rd)?|(0|[1-5]?[4-9]|[1-5]0|1[1-3])(th)?))\b/,
	      time: /^((([0]?[1-9]|1[0-2]):[0-5]\d(\s)?(am|pm))|(([0]?\d|1\d|2[0-3]):[0-5]\d))\b/,
	      dayName: /^((sun|mon|tue(s)?|wed(nes)?|thu(r(s)?)?|fri|sat(ur)?)(day)?)\b/,
	      monthName: /^(jan(uary)?|feb(ruary)?|ma((r(ch)?)?|y)|apr(il)?|ju(ly|ne)|aug(ust)?|oct(ober)?|(sept|nov|dec)(ember)?)\b/,
	      yearIndex: /^(\d\d\d\d)\b/,
	      every: /^every\b/,
	      after: /^after\b/,
	      before: /^before\b/,
	      second: /^(s|sec(ond)?(s)?)\b/,
	      minute: /^(m|min(ute)?(s)?)\b/,
	      hour: /^(h|hour(s)?)\b/,
	      day: /^(day(s)?( of the month)?)\b/,
	      dayInstance: /^day instance\b/,
	      dayOfWeek: /^day(s)? of the week\b/,
	      dayOfYear: /^day(s)? of the year\b/,
	      weekOfYear: /^week(s)?( of the year)?\b/,
	      weekOfMonth: /^week(s)? of the month\b/,
	      weekday: /^weekday\b/,
	      weekend: /^weekend\b/,
	      month: /^month(s)?\b/,
	      year: /^year(s)?\b/,
	      between: /^between (the)?\b/,
	      start: /^(start(ing)? (at|on( the)?)?)\b/,
	      at: /^(at|@)\b/,
	      and: /^(,|and\b)/,
	      except: /^(except\b)/,
	      also: /(also)\b/,
	      first: /^(first)\b/,
	      last: /^last\b/,
	      "in": /^in\b/,
	      of: /^of\b/,
	      onthe: /^on the\b/,
	      on: /^on\b/,
	      through: /(-|^(to|through)\b)/
	    };
	    var NAMES = {
	      jan: 1,
	      feb: 2,
	      mar: 3,
	      apr: 4,
	      may: 5,
	      jun: 6,
	      jul: 7,
	      aug: 8,
	      sep: 9,
	      oct: 10,
	      nov: 11,
	      dec: 12,
	      sun: 1,
	      mon: 2,
	      tue: 3,
	      wed: 4,
	      thu: 5,
	      fri: 6,
	      sat: 7,
	      "1st": 1,
	      fir: 1,
	      "2nd": 2,
	      sec: 2,
	      "3rd": 3,
	      thi: 3,
	      "4th": 4,
	      "for": 4
	    };
	    function t(start, end, text, type) {
	      return {
	        startPos: start,
	        endPos: end,
	        text: text,
	        type: type
	      };
	    }
	    function peek(expected) {
	      var scanTokens = expected instanceof Array ? expected : [ expected ], whiteSpace = /\s+/, token, curInput, m, scanToken, start, len;
	      scanTokens.push(whiteSpace);
	      start = pos;
	      while (!token || token.type === whiteSpace) {
	        len = -1;
	        curInput = input.substring(start);
	        token = t(start, start, input.split(whiteSpace)[0]);
	        var i, length = scanTokens.length;
	        for (i = 0; i < length; i++) {
	          scanToken = scanTokens[i];
	          m = scanToken.exec(curInput);
	          if (m && m.index === 0 && m[0].length > len) {
	            len = m[0].length;
	            token = t(start, start + len, curInput.substring(0, len), scanToken);
	          }
	        }
	        if (token.type === whiteSpace) {
	          start = token.endPos;
	        }
	      }
	      return token;
	    }
	    function scan(expectedToken) {
	      var token = peek(expectedToken);
	      pos = token.endPos;
	      return token;
	    }
	    function parseThroughExpr(tokenType) {
	      var start = +parseTokenValue(tokenType), end = checkAndParse(TOKENTYPES.through) ? +parseTokenValue(tokenType) : start, nums = [];
	      for (var i = start; i <= end; i++) {
	        nums.push(i);
	      }
	      return nums;
	    }
	    function parseRanges(tokenType) {
	      var nums = parseThroughExpr(tokenType);
	      while (checkAndParse(TOKENTYPES.and)) {
	        nums = nums.concat(parseThroughExpr(tokenType));
	      }
	      return nums;
	    }
	    function parseEvery(r) {
	      var num, period, start, end;
	      if (checkAndParse(TOKENTYPES.weekend)) {
	        r.on(NAMES.sun, NAMES.sat).dayOfWeek();
	      } else if (checkAndParse(TOKENTYPES.weekday)) {
	        r.on(NAMES.mon, NAMES.tue, NAMES.wed, NAMES.thu, NAMES.fri).dayOfWeek();
	      } else {
	        num = parseTokenValue(TOKENTYPES.rank);
	        r.every(num);
	        period = parseTimePeriod(r);
	        if (checkAndParse(TOKENTYPES.start)) {
	          num = parseTokenValue(TOKENTYPES.rank);
	          r.startingOn(num);
	          parseToken(period.type);
	        } else if (checkAndParse(TOKENTYPES.between)) {
	          start = parseTokenValue(TOKENTYPES.rank);
	          if (checkAndParse(TOKENTYPES.and)) {
	            end = parseTokenValue(TOKENTYPES.rank);
	            r.between(start, end);
	          }
	        }
	      }
	    }
	    function parseOnThe(r) {
	      if (checkAndParse(TOKENTYPES.first)) {
	        r.first();
	      } else if (checkAndParse(TOKENTYPES.last)) {
	        r.last();
	      } else {
	        r.on(parseRanges(TOKENTYPES.rank));
	      }
	      parseTimePeriod(r);
	    }
	    function parseScheduleExpr(str) {
	      pos = 0;
	      input = str;
	      error = -1;
	      var r = recur();
	      while (pos < input.length && error < 0) {
	        var token = parseToken([ TOKENTYPES.every, TOKENTYPES.after, TOKENTYPES.before, TOKENTYPES.onthe, TOKENTYPES.on, TOKENTYPES.of, TOKENTYPES["in"], TOKENTYPES.at, TOKENTYPES.and, TOKENTYPES.except, TOKENTYPES.also ]);
	        switch (token.type) {
	         case TOKENTYPES.every:
	          parseEvery(r);
	          break;
	
	         case TOKENTYPES.after:
	          if (peek(TOKENTYPES.time).type !== undefined) {
	            r.after(parseTokenValue(TOKENTYPES.time));
	            r.time();
	          } else {
	            r.after(parseTokenValue(TOKENTYPES.rank));
	            parseTimePeriod(r);
	          }
	          break;
	
	         case TOKENTYPES.before:
	          if (peek(TOKENTYPES.time).type !== undefined) {
	            r.before(parseTokenValue(TOKENTYPES.time));
	            r.time();
	          } else {
	            r.before(parseTokenValue(TOKENTYPES.rank));
	            parseTimePeriod(r);
	          }
	          break;
	
	         case TOKENTYPES.onthe:
	          parseOnThe(r);
	          break;
	
	         case TOKENTYPES.on:
	          r.on(parseRanges(TOKENTYPES.dayName)).dayOfWeek();
	          break;
	
	         case TOKENTYPES.of:
	          r.on(parseRanges(TOKENTYPES.monthName)).month();
	          break;
	
	         case TOKENTYPES["in"]:
	          r.on(parseRanges(TOKENTYPES.yearIndex)).year();
	          break;
	
	         case TOKENTYPES.at:
	          r.on(parseTokenValue(TOKENTYPES.time)).time();
	          while (checkAndParse(TOKENTYPES.and)) {
	            r.on(parseTokenValue(TOKENTYPES.time)).time();
	          }
	          break;
	
	         case TOKENTYPES.and:
	          break;
	
	         case TOKENTYPES.also:
	          r.and();
	          break;
	
	         case TOKENTYPES.except:
	          r.except();
	          break;
	
	         default:
	          error = pos;
	        }
	      }
	      return {
	        schedules: r.schedules,
	        exceptions: r.exceptions,
	        error: error
	      };
	    }
	    function parseTimePeriod(r) {
	      var timePeriod = parseToken([ TOKENTYPES.second, TOKENTYPES.minute, TOKENTYPES.hour, TOKENTYPES.dayOfYear, TOKENTYPES.dayOfWeek, TOKENTYPES.dayInstance, TOKENTYPES.day, TOKENTYPES.month, TOKENTYPES.year, TOKENTYPES.weekOfMonth, TOKENTYPES.weekOfYear ]);
	      switch (timePeriod.type) {
	       case TOKENTYPES.second:
	        r.second();
	        break;
	
	       case TOKENTYPES.minute:
	        r.minute();
	        break;
	
	       case TOKENTYPES.hour:
	        r.hour();
	        break;
	
	       case TOKENTYPES.dayOfYear:
	        r.dayOfYear();
	        break;
	
	       case TOKENTYPES.dayOfWeek:
	        r.dayOfWeek();
	        break;
	
	       case TOKENTYPES.dayInstance:
	        r.dayOfWeekCount();
	        break;
	
	       case TOKENTYPES.day:
	        r.dayOfMonth();
	        break;
	
	       case TOKENTYPES.weekOfMonth:
	        r.weekOfMonth();
	        break;
	
	       case TOKENTYPES.weekOfYear:
	        r.weekOfYear();
	        break;
	
	       case TOKENTYPES.month:
	        r.month();
	        break;
	
	       case TOKENTYPES.year:
	        r.year();
	        break;
	
	       default:
	        error = pos;
	      }
	      return timePeriod;
	    }
	    function checkAndParse(tokenType) {
	      var found = peek(tokenType).type === tokenType;
	      if (found) {
	        scan(tokenType);
	      }
	      return found;
	    }
	    function parseToken(tokenType) {
	      var t = scan(tokenType);
	      if (t.type) {
	        t.text = convertString(t.text, tokenType);
	      } else {
	        error = pos;
	      }
	      return t;
	    }
	    function parseTokenValue(tokenType) {
	      return parseToken(tokenType).text;
	    }
	    function convertString(str, tokenType) {
	      var output = str;
	      switch (tokenType) {
	       case TOKENTYPES.time:
	        var parts = str.split(/(:|am|pm)/), hour = parts[3] === "pm" && parts[0] < 12 ? parseInt(parts[0], 10) + 12 : parts[0], min = parts[2].trim();
	        output = (hour.length === 1 ? "0" : "") + hour + ":" + min;
	        break;
	
	       case TOKENTYPES.rank:
	        output = parseInt(/^\d+/.exec(str)[0], 10);
	        break;
	
	       case TOKENTYPES.monthName:
	       case TOKENTYPES.dayName:
	        output = NAMES[str.substring(0, 3)];
	        break;
	      }
	      return output;
	    }
	    return parseScheduleExpr(str.toLowerCase());
	  };
	  return later;
	}();

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(98),
	    root = __webpack_require__(65);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1325),
	    hashDelete = __webpack_require__(1326),
	    hashGet = __webpack_require__(1327),
	    hashHas = __webpack_require__(1328),
	    hashSet = __webpack_require__(1329);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(98),
	    root = __webpack_require__(65);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(65);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1267 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1268 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 1269 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 1270 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(180);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(258),
	    arrayIncludes = __webpack_require__(408),
	    arrayIncludesWith = __webpack_require__(409),
	    arrayMap = __webpack_require__(97),
	    baseUnary = __webpack_require__(183),
	    cacheHas = __webpack_require__(266);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1309);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1274 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(181);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(74),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(406),
	    equalArrays = __webpack_require__(421),
	    equalByTag = __webpack_require__(1316),
	    equalObjects = __webpack_require__(1317),
	    getTag = __webpack_require__(267),
	    isArray = __webpack_require__(36),
	    isBuffer = __webpack_require__(270),
	    isTypedArray = __webpack_require__(272);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(406),
	    baseIsEqual = __webpack_require__(263);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1279 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(31),
	    isMasked = __webpack_require__(1333),
	    isObject = __webpack_require__(47),
	    toSource = __webpack_require__(435);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(74),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObjectLike(value) && baseGetTag(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(74),
	    isLength = __webpack_require__(271),
	    isObjectLike = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(47),
	    isPrototype = __webpack_require__(188),
	    nativeKeysIn = __webpack_require__(1347);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1278),
	    getMatchData = __webpack_require__(1320),
	    matchesStrictComparable = __webpack_require__(430);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(263),
	    get = __webpack_require__(23),
	    hasIn = __webpack_require__(439),
	    isKey = __webpack_require__(268),
	    isStrictComparable = __webpack_require__(428),
	    matchesStrictComparable = __webpack_require__(430),
	    toKey = __webpack_require__(149);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(97),
	    baseIteratee = __webpack_require__(75),
	    baseMap = __webpack_require__(417),
	    baseSortBy = __webpack_require__(1294),
	    baseUnary = __webpack_require__(183),
	    compareMultiple = __webpack_require__(1302),
	    identity = __webpack_require__(76);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(418),
	    hasIn = __webpack_require__(439);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 1288 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(262);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1290 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(260),
	    castPath = __webpack_require__(184),
	    isIndex = __webpack_require__(186),
	    isObject = __webpack_require__(47),
	    toKey = __webpack_require__(149);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(436),
	    defineProperty = __webpack_require__(420),
	    identity = __webpack_require__(76);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(180);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 1294 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(118);
	
	/**
	 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseSortedUniq(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (!index || !eq(computed, seen)) {
	      var seen = computed;
	      result[resIndex++] = value === 0 ? 0 : value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseSortedUniq;


/***/ },
/* 1296 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 1297 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(97);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(148),
	    arrayMap = __webpack_require__(97),
	    isArray = __webpack_require__(36),
	    isSymbol = __webpack_require__(151);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(97);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(151);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1301);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1303 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(260),
	    baseAssignValue = __webpack_require__(179);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(65);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(1268),
	    baseAggregator = __webpack_require__(1271),
	    baseIteratee = __webpack_require__(75),
	    isArray = __webpack_require__(36);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(182),
	    isIterateeCall = __webpack_require__(187);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(66);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1309 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(75),
	    isArrayLike = __webpack_require__(66),
	    keys = __webpack_require__(56);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(255),
	    flatRest = __webpack_require__(422),
	    getData = __webpack_require__(424),
	    getFuncName = __webpack_require__(425),
	    isArray = __webpack_require__(36),
	    isLaziable = __webpack_require__(1332);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(1275);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(1290),
	    isIterateeCall = __webpack_require__(187),
	    toFinite = __webpack_require__(450);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(405),
	    noop = __webpack_require__(448),
	    setToArray = __webpack_require__(269);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(1298),
	    getTag = __webpack_require__(267),
	    mapToArray = __webpack_require__(429),
	    setToPairs = __webpack_require__(1352);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	module.exports = createToPairs;


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(148),
	    Uint8Array = __webpack_require__(1266),
	    eq = __webpack_require__(118),
	    equalArrays = __webpack_require__(421),
	    mapToArray = __webpack_require__(429),
	    setToArray = __webpack_require__(269);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1318);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(414),
	    getSymbols = __webpack_require__(427),
	    keys = __webpack_require__(56);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(414),
	    getSymbolsIn = __webpack_require__(1322),
	    keysIn = __webpack_require__(446);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(428),
	    keys = __webpack_require__(56);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(148);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(259),
	    getPrototype = __webpack_require__(426),
	    getSymbols = __webpack_require__(427),
	    stubArray = __webpack_require__(449);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 1323 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(184),
	    isArguments = __webpack_require__(191),
	    isArray = __webpack_require__(36),
	    isIndex = __webpack_require__(186),
	    isLength = __webpack_require__(271),
	    toKey = __webpack_require__(149);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(189);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1326 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(189);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(189);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(189);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(148),
	    isArguments = __webpack_require__(191),
	    isArray = __webpack_require__(36);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1331 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(254),
	    getData = __webpack_require__(424),
	    getFuncName = __webpack_require__(425),
	    lodash = __webpack_require__(1381);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1305);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1334 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(178);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(178);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(178);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(178);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1264),
	    ListCache = __webpack_require__(177),
	    Map = __webpack_require__(256);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(185);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(185);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(185);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(185);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1372);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(407);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(432);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1347 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1348 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1349 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 1350 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1351 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1352 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	module.exports = setToPairs;


/***/ },
/* 1353 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(177);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1355 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1356 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1357 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(177),
	    Map = __webpack_require__(256),
	    MapCache = __webpack_require__(257);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1359 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1344);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(254),
	    LodashWrapper = __webpack_require__(255),
	    copyArray = __webpack_require__(1303);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(47),
	    now = __webpack_require__(1373),
	    toNumber = __webpack_require__(275);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1310),
	    findIndex = __webpack_require__(1364);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(413),
	    baseIteratee = __webpack_require__(75),
	    toInteger = __webpack_require__(451);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(261),
	    map = __webpack_require__(273);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(1311);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(181),
	    castFunction = __webpack_require__(419);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 1368 */
/***/ function(module, exports) {

	/**
	 * The inverse of `_.toPairs`; this method returns an object composed
	 * from key-value `pairs`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} pairs The key-value pairs.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.fromPairs([['a', 1], ['b', 2]]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function fromPairs(pairs) {
	  var index = -1,
	      length = pairs == null ? 0 : pairs.length,
	      result = {};
	
	  while (++index < length) {
	    var pair = pairs[index];
	    result[pair[0]] = pair[1];
	  }
	  return result;
	}
	
	module.exports = fromPairs;


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(436),
	    createInverter = __webpack_require__(1312),
	    identity = __webpack_require__(76);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite
	 * property assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  if (value != null &&
	      typeof value.toString != 'function') {
	    value = nativeObjectToString.call(value);
	  }
	
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(263);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 1371 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(257);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(65);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(97),
	    baseIteratee = __webpack_require__(75),
	    basePickBy = __webpack_require__(418),
	    getAllKeysIn = __webpack_require__(1319);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(411),
	    baseIteratee = __webpack_require__(75),
	    baseSome = __webpack_require__(1293),
	    isArray = __webpack_require__(36),
	    isIterateeCall = __webpack_require__(187);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedUniq = __webpack_require__(1295);
	
	/**
	 * This method is like `_.uniq` except that it's designed and optimized
	 * for sorted arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.sortedUniq([1, 1, 2]);
	 * // => [1, 2]
	 */
	function sortedUniq(array) {
	  return (array && array.length)
	    ? baseSortedUniq(array)
	    : [];
	}
	
	module.exports = sortedUniq;


/***/ },
/* 1377 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(1296),
	    identity = __webpack_require__(76);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(1315),
	    keys = __webpack_require__(56);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(261),
	    baseRest = __webpack_require__(182),
	    baseUniq = __webpack_require__(265),
	    isArrayLikeObject = __webpack_require__(440);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(254),
	    LodashWrapper = __webpack_require__(255),
	    baseLodash = __webpack_require__(264),
	    isArray = __webpack_require__(36),
	    isObjectLike = __webpack_require__(58),
	    wrapperClone = __webpack_require__(1361);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 1382 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lowerCase = exports.localeLowerCase = void 0;
	/**
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 */
	var SUPPORTED_LOCALE = {
	    tr: {
	        regexp: /\u0130|\u0049|\u0049\u0307/g,
	        map: {
	            İ: "\u0069",
	            I: "\u0131",
	            İ: "\u0069",
	        },
	    },
	    az: {
	        regexp: /\u0130/g,
	        map: {
	            İ: "\u0069",
	            I: "\u0131",
	            İ: "\u0069",
	        },
	    },
	    lt: {
	        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
	        map: {
	            I: "\u0069\u0307",
	            J: "\u006A\u0307",
	            Į: "\u012F\u0307",
	            Ì: "\u0069\u0307\u0300",
	            Í: "\u0069\u0307\u0301",
	            Ĩ: "\u0069\u0307\u0303",
	        },
	    },
	};
	/**
	 * Localized lower case.
	 */
	function localeLowerCase(str, locale) {
	    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
	    if (lang)
	        return lowerCase(str.replace(lang.regexp, function (m) { return lang.map[m]; }));
	    return lowerCase(str);
	}
	exports.localeLowerCase = localeLowerCase;
	/**
	 * Lower case as a function.
	 */
	function lowerCase(str) {
	    return str.toLowerCase();
	}
	exports.lowerCase = lowerCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1384);
	moment.tz.load(__webpack_require__(1253));


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.31
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(7)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.31",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 456,
		"./af.js": 456,
		"./ar": 463,
		"./ar-dz": 457,
		"./ar-dz.js": 457,
		"./ar-kw": 458,
		"./ar-kw.js": 458,
		"./ar-ly": 459,
		"./ar-ly.js": 459,
		"./ar-ma": 460,
		"./ar-ma.js": 460,
		"./ar-sa": 461,
		"./ar-sa.js": 461,
		"./ar-tn": 462,
		"./ar-tn.js": 462,
		"./ar.js": 463,
		"./az": 464,
		"./az.js": 464,
		"./be": 465,
		"./be.js": 465,
		"./bg": 466,
		"./bg.js": 466,
		"./bm": 467,
		"./bm.js": 467,
		"./bn": 468,
		"./bn.js": 468,
		"./bo": 469,
		"./bo.js": 469,
		"./br": 470,
		"./br.js": 470,
		"./bs": 471,
		"./bs.js": 471,
		"./ca": 472,
		"./ca.js": 472,
		"./cs": 473,
		"./cs.js": 473,
		"./cv": 474,
		"./cv.js": 474,
		"./cy": 475,
		"./cy.js": 475,
		"./da": 476,
		"./da.js": 476,
		"./de": 479,
		"./de-at": 477,
		"./de-at.js": 477,
		"./de-ch": 478,
		"./de-ch.js": 478,
		"./de.js": 479,
		"./dv": 480,
		"./dv.js": 480,
		"./el": 481,
		"./el.js": 481,
		"./en-au": 482,
		"./en-au.js": 482,
		"./en-ca": 483,
		"./en-ca.js": 483,
		"./en-gb": 484,
		"./en-gb.js": 484,
		"./en-ie": 485,
		"./en-ie.js": 485,
		"./en-il": 486,
		"./en-il.js": 486,
		"./en-in": 487,
		"./en-in.js": 487,
		"./en-nz": 488,
		"./en-nz.js": 488,
		"./en-sg": 489,
		"./en-sg.js": 489,
		"./eo": 490,
		"./eo.js": 490,
		"./es": 493,
		"./es-do": 491,
		"./es-do.js": 491,
		"./es-us": 492,
		"./es-us.js": 492,
		"./es.js": 493,
		"./et": 494,
		"./et.js": 494,
		"./eu": 495,
		"./eu.js": 495,
		"./fa": 496,
		"./fa.js": 496,
		"./fi": 497,
		"./fi.js": 497,
		"./fil": 498,
		"./fil.js": 498,
		"./fo": 499,
		"./fo.js": 499,
		"./fr": 502,
		"./fr-ca": 500,
		"./fr-ca.js": 500,
		"./fr-ch": 501,
		"./fr-ch.js": 501,
		"./fr.js": 502,
		"./fy": 503,
		"./fy.js": 503,
		"./ga": 504,
		"./ga.js": 504,
		"./gd": 505,
		"./gd.js": 505,
		"./gl": 506,
		"./gl.js": 506,
		"./gom-deva": 507,
		"./gom-deva.js": 507,
		"./gom-latn": 508,
		"./gom-latn.js": 508,
		"./gu": 509,
		"./gu.js": 509,
		"./he": 510,
		"./he.js": 510,
		"./hi": 511,
		"./hi.js": 511,
		"./hr": 512,
		"./hr.js": 512,
		"./hu": 513,
		"./hu.js": 513,
		"./hy-am": 514,
		"./hy-am.js": 514,
		"./id": 515,
		"./id.js": 515,
		"./is": 516,
		"./is.js": 516,
		"./it": 518,
		"./it-ch": 517,
		"./it-ch.js": 517,
		"./it.js": 518,
		"./ja": 519,
		"./ja.js": 519,
		"./jv": 520,
		"./jv.js": 520,
		"./ka": 521,
		"./ka.js": 521,
		"./kk": 522,
		"./kk.js": 522,
		"./km": 523,
		"./km.js": 523,
		"./kn": 524,
		"./kn.js": 524,
		"./ko": 525,
		"./ko.js": 525,
		"./ku": 526,
		"./ku.js": 526,
		"./ky": 527,
		"./ky.js": 527,
		"./lb": 528,
		"./lb.js": 528,
		"./lo": 529,
		"./lo.js": 529,
		"./lt": 530,
		"./lt.js": 530,
		"./lv": 531,
		"./lv.js": 531,
		"./me": 532,
		"./me.js": 532,
		"./mi": 533,
		"./mi.js": 533,
		"./mk": 534,
		"./mk.js": 534,
		"./ml": 535,
		"./ml.js": 535,
		"./mn": 536,
		"./mn.js": 536,
		"./mr": 537,
		"./mr.js": 537,
		"./ms": 539,
		"./ms-my": 538,
		"./ms-my.js": 538,
		"./ms.js": 539,
		"./mt": 540,
		"./mt.js": 540,
		"./my": 541,
		"./my.js": 541,
		"./nb": 542,
		"./nb.js": 542,
		"./ne": 543,
		"./ne.js": 543,
		"./nl": 545,
		"./nl-be": 544,
		"./nl-be.js": 544,
		"./nl.js": 545,
		"./nn": 546,
		"./nn.js": 546,
		"./oc-lnc": 547,
		"./oc-lnc.js": 547,
		"./pa-in": 548,
		"./pa-in.js": 548,
		"./pl": 549,
		"./pl.js": 549,
		"./pt": 551,
		"./pt-br": 550,
		"./pt-br.js": 550,
		"./pt.js": 551,
		"./ro": 552,
		"./ro.js": 552,
		"./ru": 553,
		"./ru.js": 553,
		"./sd": 554,
		"./sd.js": 554,
		"./se": 555,
		"./se.js": 555,
		"./si": 556,
		"./si.js": 556,
		"./sk": 557,
		"./sk.js": 557,
		"./sl": 558,
		"./sl.js": 558,
		"./sq": 559,
		"./sq.js": 559,
		"./sr": 561,
		"./sr-cyrl": 560,
		"./sr-cyrl.js": 560,
		"./sr.js": 561,
		"./ss": 562,
		"./ss.js": 562,
		"./sv": 563,
		"./sv.js": 563,
		"./sw": 564,
		"./sw.js": 564,
		"./ta": 565,
		"./ta.js": 565,
		"./te": 566,
		"./te.js": 566,
		"./tet": 567,
		"./tet.js": 567,
		"./tg": 568,
		"./tg.js": 568,
		"./th": 569,
		"./th.js": 569,
		"./tl-ph": 570,
		"./tl-ph.js": 570,
		"./tlh": 571,
		"./tlh.js": 571,
		"./tr": 572,
		"./tr.js": 572,
		"./tzl": 573,
		"./tzl.js": 573,
		"./tzm": 575,
		"./tzm-latn": 574,
		"./tzm-latn.js": 574,
		"./tzm.js": 575,
		"./ug-cn": 576,
		"./ug-cn.js": 576,
		"./uk": 577,
		"./uk.js": 577,
		"./ur": 578,
		"./ur.js": 578,
		"./uz": 580,
		"./uz-latn": 579,
		"./uz-latn.js": 579,
		"./uz.js": 580,
		"./vi": 581,
		"./vi.js": 581,
		"./x-pseudo": 582,
		"./x-pseudo.js": 582,
		"./yo": 583,
		"./yo.js": 583,
		"./zh-cn": 584,
		"./zh-cn.js": 584,
		"./zh-hk": 585,
		"./zh-hk.js": 585,
		"./zh-mo": 586,
		"./zh-mo.js": 586,
		"./zh-tw": 587,
		"./zh-tw.js": 587
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1385;


/***/ },
/* 1386 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (x) {
		return x === 0 && 1 / x === -Infinity;
	};


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.paramCase = void 0;
	var tslib_1 = __webpack_require__(1388);
	var dot_case_1 = __webpack_require__(175);
	function paramCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return dot_case_1.dotCase(input, tslib_1.__assign({ delimiter: "-" }, options));
	}
	exports.paramCase = paramCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1388 */
1199,
/* 1389 */
1199,
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pathCase = void 0;
	var tslib_1 = __webpack_require__(1391);
	var dot_case_1 = __webpack_require__(175);
	function pathCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return dot_case_1.dotCase(input, tslib_1.__assign({ delimiter: "/" }, options));
	}
	exports.pathCase = pathCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1391 */
1199,
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(590)))

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	////////////////////////////////////////////////////////////////////////////////////
	//
	//  prettycron.js
	//  Generates human-readable sentences from a schedule string in cron format
	//
	//  Based on an earlier version by Pehr Johansson
	//  http://dsysadm.blogspot.com.au/2012/09/human-readable-cron-expressions-using.html
	//
	////////////////////////////////////////////////////////////////////////////////////
	//  This program is free software: you can redistribute it and/or modify
	//  it under the terms of the GNU Lesser General Public License as published
	//  by the Free Software Foundation, either version 3 of the License, or
	//  (at your option) any later version.
	//
	//  This program is distributed in the hope that it will be useful,
	//  but WITHOUT ANY WARRANTY; without even the implied warranty of
	//  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	//  GNU Lesser General Public License for more details.
	//
	//  You should have received a copy of the GNU Lesser General Public License
	//  along with this program.  If not, see <http://www.gnu.org/licenses/>.
	////////////////////////////////////////////////////////////////////////////////////
	
	if ((!moment || !later) && ("function" !== 'undefined')) {
	  var moment = __webpack_require__(7);
	  var later = __webpack_require__(404);
	}
	
	(function() {
	
	  /*
	   * For an array of numbers, e.g. a list of hours in a schedule,
	   * return a string listing out all of the values (complete with
	   * "and" plus ordinal text on the last item).
	   */
	  var numberList = function(numbers) {
	    if (numbers.length < 2) {
	      return moment()._locale.ordinal(numbers);
	    }
	
	    var last_val = numbers.pop();
	    return numbers.join(', ') + ' and ' + moment()._locale.ordinal(last_val);
	  };
	
	  /*
	   * Parse a number into day of week, or a month name;
	   * used in dateList below.
	   */
	  var numberToDateName = function(value, type) {
	    if (type == 'dow') {
	      return moment().day(value - 1).format('ddd');
	    } else if (type == 'mon') {
	      return moment().month(value - 1).format('MMM');
	    }
	  };
	
	  /*
	   * From an array of numbers corresponding to dates (given in type: either
	   * days of the week, or months), return a string listing all the values.
	   */
	  var dateList = function(numbers, type) {
	    if (numbers.length < 2) {
	      return numberToDateName(''+numbers[0], type);
	    }
	
	    var last_val = '' + numbers.pop();
	    var output_text = '';
	
	    for (var i=0, value; value=numbers[i]; i++) {
	      if (output_text.length > 0) {
	        output_text += ', ';
	      }
	      output_text += numberToDateName(value, type);
	    }
	    return output_text + ' and ' + numberToDateName(last_val, type);
	  };
	
	  /*
	   * Pad to equivalent of sprintf('%02d'). Both moment.js and later.js
	   * have zero-fill functions, but alas, they're private.
	   */
	  var zeroPad = function(x) {
	    return (x < 10) ? '0' + x : x;
	  };
	
	  //----------------
	
	  /*
	   * Given a schedule from later.js (i.e. after parsing the cronspec),
	   * generate a friendly sentence description.
	   */
	  var scheduleToSentence = function(schedule) {
	    var output_text = 'Every ';
	
	    if (schedule['h'] && schedule['m'] && schedule['h'].length <= 2 && schedule['m'].length <= 2) {
	      // If there are only one or two specified values for
	      // hour or minute, print them in HH:MM format
	
	      var hm = [];
	      for (var i=0; i < schedule['h'].length; i++) {
	        for (var j=0; j < schedule['m'].length; j++) {
	          hm.push(zeroPad(schedule['h'][i]) + ':' + zeroPad(schedule['m'][j]));
	        }
	      }
	      if (hm.length < 2) {
	        output_text = hm[0];
	      } else {
	        var last_val = hm.pop();
	        output_text = hm.join(', ') + ' and ' + last_val;
	      }
	      if (!schedule['d'] && !schedule['D']) {
	        output_text += ' every day';
	      }
	
	    } else {
	      // Otherwise, list out every specified hour/minute value.
	
	      if(schedule['h']) { // runs only at specific hours
	        if (schedule['m']) { // and only at specific minutes
	          output_text += numberList(schedule['m']) + ' minute past the ' + numberList(schedule['h']) + ' hour';
	        } else { // specific hours, but every minute
	          output_text += 'minute of ' + numberList(schedule['h']) + ' hour';
	        }
	      } else if(schedule['m']) { // every hour, but specific minutes
	        if (schedule['m'].length == 1 && schedule['m'][0] == 0) {
	          output_text += 'hour, on the hour';
	        } else {
	          output_text += numberList(schedule['m']) + ' minute past every hour';
	        }
	      } else { // cronspec has "*" for both hour and minute
	        output_text += 'minute';
	      }
	    }
	
	    if (schedule['D']) { // runs only on specific day(s) of month
	      output_text += ' on the ' + numberList(schedule['D']);
	      if (!schedule['M']) {
	        output_text += ' of every month';
	      }
	    }
	
	    if (schedule['d']) { // runs only on specific day(s) of week
	      if (schedule['D']) {
	        // if both day fields are specified, cron uses both; superuser.com/a/348372
	        output_text += ' and every ';
	      } else {
	        output_text += ' on ';
	      }
	      output_text += dateList(schedule['d'], 'dow');
	    }
	
	    if (schedule['M']) {
	      // runs only in specific months; put this output last
	      output_text += ' in ' + dateList(schedule['M'], 'mon');
	    }
	
	    return output_text;
	  };
	
	  //----------------
	
	  /*
	   * Given a cronspec, return the human-readable string.
	   */
	  var toString = function(cronspec, sixth) {
	    var schedule = later.parse.cron(cronspec, sixth);
	    return scheduleToSentence(schedule['schedules'][0]);
	  };
	
	  /*
	   * Given a cronspec, return the next date for when it will next run.
	   * (This is just a wrapper for later.js)
	   */
	  var getNextDate = function(cronspec, sixth) {
	    var schedule = later.parse.cron(cronspec, sixth);
	    return later.schedule(schedule).next();
	  };
	
	  /*
	   * Given a cronspec, return a friendly string for when it will next run.
	   * (This is just a wrapper for later.js and moment.js)
	   */
	  var getNext = function(cronspec, sixth) {
	    return moment( getNextDate( cronspec, sixth ) ).calendar();
	  };
	
	  //----------------
	
	  // attach ourselves to window in the browser, and to exports in Node,
	  // so our functions can always be called as prettyCron.toString()
	  var global_obj = (typeof exports !== "undefined" && exports !== null) ? exports : window.prettyCron = {};
	
	  global_obj.toString = toString;
	  global_obj.getNext = getNext;
	  global_obj.getNextDate = getNextDate;
	
	}).call(this);


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1232);
	var invariant = __webpack_require__(1233);
	var ReactPropTypesSecret = __webpack_require__(1396);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1396 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1392)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.9.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),m=__webpack_require__(195),q=__webpack_require__(1759);function t(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}if(!aa)throw t(Error(227));var ba=null,ca={};
	function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw t(Error(96),a);if(!ea[c]){if(!b.extractEvents)throw t(Error(97),a);ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;if(fa.hasOwnProperty(g))throw t(Error(99),g);fa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],h,g);e=!0}else f.registrationName?(ha(f.registrationName,h,g),e=!0):e=!1;if(!e)throw t(Error(98),d,a);}}}}
	function ha(a,b,c){if(ia[a])throw t(Error(100),a);ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,h,g,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,h,g,k){la=!1;ma=null;ka.apply(pa,arguments)}
	function ra(a,b,c,d,e,f,h,g,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw t(Error(198));na||(na=!0,oa=l)}}var sa=null,ta=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw t(Error(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw t(Error(95));if(na)throw a=oa,na=!1,oa=null,a;}}
	var Ca={injectEventPluginOrder:function(a){if(ba)throw t(Error(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw t(Error(102),c);ca[c]=d;b=!0}}b&&da()}};
	function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw t(Error(231),b,typeof c);
	return c}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;throw t(Error(33));}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Ma(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}
	function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement);
	function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),ab=Wa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,db=null,eb=null;
	function fb(){if(eb)return eb;var a,b=db,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);return eb=e.slice(a,1<d?1-d:void 0)}function gb(){return!0}function hb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?gb:hb;this.isPropagationStopped=hb;return this}
	m(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=gb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=gb)},persist:function(){this.isPersistent=gb},isPersistent:hb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=hb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;m(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=m({},d.Interface,a);c.extend=d.extend;ib(c);return c};ib(y);function jb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function kb(a){if(!(a instanceof this))throw t(Error(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function ib(a){a.eventPool=[];a.getPooled=jb;a.release=kb}var lb=y.extend({data:null}),mb=y.extend({data:null}),nb=[9,13,27,32],ob=Ra&&"CompositionEvent"in window,pb=null;Ra&&"documentMode"in document&&(pb=document.documentMode);
	var qb=Ra&&"TextEvent"in window&&!pb,sb=Ra&&(!ob||pb&&8<pb&&11>=pb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
	function wb(a,b){switch(a){case "keyup":return-1!==nb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function Ab(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
	function Bb(a,b){if(yb)return"compositionend"===a||!ob&&wb(a,b)?(a=fb(),eb=db=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
	var Cb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(ob)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=fb()):(cb=d,db="value"in cb?cb.value:cb.textContent,yb=
	!0)),e=lb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=qb?Ab(a,c):Bb(a,c))?(b=mb.getPooled(ub.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Db=null,Eb=null,Fb=null;function Gb(a){if(a=ta(a)){if("function"!==typeof Db)throw t(Error(280));var b=sa(a.stateNode);Db(a.stateNode,a.type,b)}}function Hb(a){Eb?Fb?Fb.push(a):Fb=[a]:Eb=a}function Ib(){if(Eb){var a=Eb,b=Fb;Fb=Eb=null;Gb(a);if(b)for(a=0;a<b.length;a++)Gb(b[a])}}
	function Jb(a,b){return a(b)}function Kb(a,b,c,d){return a(b,c,d)}function Lb(){}var Mb=Jb,Nb=!1;function Ob(){if(null!==Eb||null!==Fb)Lb(),Ib()}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
	function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Xb.hasOwnProperty("ReactCurrentDispatcher")||(Xb.ReactCurrentDispatcher={current:null});Xb.hasOwnProperty("ReactCurrentBatchConfig")||(Xb.ReactCurrentBatchConfig={suspense:null});
	var Yb=/^(.*)[\\\/]/,B="function"===typeof Symbol&&Symbol.for,Zb=B?Symbol.for("react.element"):60103,$b=B?Symbol.for("react.portal"):60106,ac=B?Symbol.for("react.fragment"):60107,bc=B?Symbol.for("react.strict_mode"):60108,cc=B?Symbol.for("react.profiler"):60114,dc=B?Symbol.for("react.provider"):60109,ec=B?Symbol.for("react.context"):60110,fc=B?Symbol.for("react.concurrent_mode"):60111,gc=B?Symbol.for("react.forward_ref"):60112,hc=B?Symbol.for("react.suspense"):60113,ic=B?Symbol.for("react.suspense_list"):
	60120,jc=B?Symbol.for("react.memo"):60115,kc=B?Symbol.for("react.lazy"):60116;B&&Symbol.for("react.fundamental");B&&Symbol.for("react.responder");var lc="function"===typeof Symbol&&Symbol.iterator;function mc(a){if(null===a||"object"!==typeof a)return null;a=lc&&a[lc]||a["@@iterator"];return"function"===typeof a?a:null}
	function oc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense";case ic:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jc:return oc(a.type);case kc:if(a=1===a._status?a._result:null)return oc(a)}return null}function pc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=oc(a.type);c=null;d&&(c=oc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var qc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,rc=Object.prototype.hasOwnProperty,sc={},tc={};
	function uc(a){if(rc.call(tc,a))return!0;if(rc.call(sc,a))return!1;if(qc.test(a))return tc[a]=!0;sc[a]=!0;return!1}function vc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function wc(a,b,c,d){if(null===b||"undefined"===typeof b||vc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function D(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var F={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new D(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new D(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new D(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new D(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new D(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){F[a]=new D(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){F[a]=new D(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){F[a]=new D(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){F[a]=new D(a,5,!1,a.toLowerCase(),null,!1)});var xc=/[\-:]([a-z])/g;function yc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(xc,
	yc);F[b]=new D(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!1)});
	F.xlinkHref=new D("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!0)});
	function zc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(wc(b,c,e,d)&&(c=null),d||null===e?uc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function Ac(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Bc(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Cc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ac(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Dc(a,b){b=b.checked;null!=b&&zc(a,"checked",b,!1)}
	function Ec(a,b){Dc(a,b);var c=Ac(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fc(a,b.type,Ac(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Gc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Fc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Hc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Ic(a,b,c){a=y.getPooled(Hc.change,a,b,c);a.type="change";Hb(c);Qa(a);return a}var Jc=null,Kc=null;function Lc(a){Ba(a)}
	function Mc(a){var b=Ja(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Ra&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){if("value"===a.propertyName&&Mc(Kc))if(a=Ic(Kc,a,Rb(a)),Nb)Ba(a);else{Nb=!0;try{Jb(Lc,a)}finally{Nb=!1,Ob()}}}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}
	function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
	var Vc={eventTypes:Hc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,h=Rc):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Ic(f,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fc(e,"number",e.value)}},Wc=y.extend({view:null,detail:null}),Xc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
	var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var h=void 0,g=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)h=dd,g=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
	else if("pointerout"===a||"pointerover"===a)h=ed,g=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var n=null==f?e:Ja(f);e=null==b?e:Ja(b);a=h.getPooled(g,f,c,d);a.type=l+"leave";a.target=n;a.relatedTarget=e;c=h.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=n;d=b;if(f&&d)a:{b=f;e=d;l=0;for(h=b;h;h=La(h))l++;h=0;for(k=e;k;k=La(k))h++;for(;0<l-h;)b=La(b),l--;for(;0<h-l;)e=La(e),h--;for(;l--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
	f.alternate;if(null!==l&&l===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function hd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var id=Object.prototype.hasOwnProperty;
	function jd(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!id.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function kd(a,b){return{responder:a,props:b}}new Map;new Map;new Set;new Map;
	function ld(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function od(a){if(2!==ld(a))throw t(Error(188));}
	function pd(a){var b=a.alternate;if(!b){b=ld(a);if(3===b)throw t(Error(188));return 1===b?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return od(e),a;if(f===d)return od(e),b;f=f.sibling}throw t(Error(188));}if(c.return!==d.return)c=e,d=f;else{for(var h=!1,g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===
	c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}if(!h)throw t(Error(189));}}if(c.alternate!==d)throw t(Error(190));}if(3!==c.tag)throw t(Error(188));return c.stateNode.current===c?a:b}function qd(a){a=pd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var rd=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),sd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),td=Wc.extend({relatedTarget:null});function ud(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var vd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},wd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},xd=Wc.extend({key:function(a){if(a.key){var b=vd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ud(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?wd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
	a.type?ud(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ud(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),yd=dd.extend({dataTransfer:null}),zd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),Ad=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Bd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Cd=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],
	["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",
	1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",2],[Xa,"animationEnd",2],[Ya,"animationIteration",2],[Za,"animationStart",2],["canplay","canPlay",2],["canplaythrough",
	"canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress","progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",
	2],[ab,"transitionEnd",2],["waiting","waiting",2]],Dd={},Ed={},Fd=0;for(;Fd<Cd.length;Fd++){var Gd=Cd[Fd],Hd=Gd[0],Id=Gd[1],Jd=Gd[2],Kd="on"+(Id[0].toUpperCase()+Id.slice(1)),Ld={phasedRegistrationNames:{bubbled:Kd,captured:Kd+"Capture"},dependencies:[Hd],eventPriority:Jd};Dd[Id]=Ld;Ed[Hd]=Ld}
	var Md={eventTypes:Dd,getEventPriority:function(a){a=Ed[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=Ed[a];if(!e)return null;switch(a){case "keypress":if(0===ud(c))return null;case "keydown":case "keyup":a=xd;break;case "blur":case "focus":a=td;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	yd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=zd;break;case Xa:case Ya:case Za:a=rd;break;case ab:a=Ad;break;case "scroll":a=Wc;break;case "wheel":a=Bd;break;case "copy":case "cut":case "paste":a=sd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},Nd=Md.getEventPriority,Od=[];
	function Pd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,h=null,g=0;g<ea.length;g++){var k=ea[g];k&&(k=k.extractEvents(d,b,f,e))&&(h=xa(h,k))}Ba(h)}}var Qd=!0;function G(a,b){Rd(b,a,!1)}
	function Rd(a,b,c){switch(Nd(b)){case 0:var d=Sd.bind(null,b,1);break;case 1:d=Td.bind(null,b,1);break;default:d=Ud.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Sd(a,b,c){Nb||Lb();var d=Ud,e=Nb;Nb=!0;try{Kb(d,a,b,c)}finally{(Nb=e)||Ob()}}function Td(a,b,c){Ud(a,b,c)}
	function Ud(a,b,c){if(Qd){b=Rb(c);b=Ha(b);null===b||"number"!==typeof b.tag||2===ld(b)||(b=null);if(Od.length){var d=Od.pop();d.topLevelType=a;d.nativeEvent=c;d.targetInst=b;a=d}else a={topLevelType:a,nativeEvent:c,targetInst:b,ancestors:[]};try{if(c=a,Nb)Pd(c,void 0);else{Nb=!0;try{Mb(Pd,c,void 0)}finally{Nb=!1,Ob()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Od.length&&Od.push(a)}}}var Vd=new ("function"===typeof WeakMap?WeakMap:Map);
	function Wd(a){var b=Vd.get(a);void 0===b&&(b=new Set,Vd.set(a,b));return b}function Xd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Yd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Zd(a,b){var c=Yd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Yd(c)}}function $d(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?$d(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function ae(){for(var a=window,b=Xd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xd(a.document)}return b}function be(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	var ce=Ra&&"documentMode"in document&&11>=document.documentMode,de={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ee=null,fe=null,ge=null,he=!1;
	function ie(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(he||null==ee||ee!==Xd(c))return null;c=ee;"selectionStart"in c&&be(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return ge&&jd(ge,c)?null:(ge=c,a=y.getPooled(de.select,fe,a,b),a.type="select",a.target=ee,Qa(a),a)}
	var je={eventTypes:de,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Wd(e);f=ja.onSelect;for(var h=0;h<f.length;h++)if(!e.has(f[h])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)ee=e,fe=b,ge=null;break;case "blur":ge=fe=ee=null;break;case "mousedown":he=!0;break;case "contextmenu":case "mouseup":case "dragend":return he=!1,ie(c,d);case "selectionchange":if(ce)break;
	case "keydown":case "keyup":return ie(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));sa=Ka;ta=Ia;va=Ja;Ca.injectEventPluginsByName({SimpleEventPlugin:Md,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:je,BeforeInputEventPlugin:Cb});function ke(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function le(a,b){a=m({children:void 0},b);if(b=ke(b.children))a.children=b;return a}function me(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Ac(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function ne(a,b){if(null!=b.dangerouslySetInnerHTML)throw t(Error(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function oe(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw t(Error(92));if(Array.isArray(b)){if(!(1>=b.length))throw t(Error(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:Ac(c)}}
	function pe(a,b){var c=Ac(b.value),d=Ac(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function qe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var re={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function se(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function te(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?se(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ue=void 0,ve=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==re.svg||"innerHTML"in a)a.innerHTML=b;else{ue=ue||document.createElement("div");ue.innerHTML="<svg>"+b+"</svg>";for(b=ue.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function we(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var xe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ye=["Webkit","ms","Moz","O"];Object.keys(xe).forEach(function(a){ye.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);xe[b]=xe[a]})});function ze(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||xe.hasOwnProperty(a)&&xe[a]?(""+b).trim():b+"px"}
	function Ae(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ze(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ce=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function De(a,b){if(b){if(Ce[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw t(Error(137),a,"");if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw t(Error(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw t(Error(61));}if(null!=b.style&&"object"!==typeof b.style)throw t(Error(62),"");}}
	function Ee(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function Fe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Wd(a);b=ja[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.has(e)){switch(e){case "scroll":Rd(a,"scroll",!0);break;case "focus":case "blur":Rd(a,"focus",!0);Rd(a,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Sb(e)&&Rd(a,e,!0);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c.add(e)}}}function Ge(){}var He=null,Ie=null;
	function Je(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ke(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Le="function"===typeof setTimeout?setTimeout:void 0,Me="function"===typeof clearTimeout?clearTimeout:void 0;
	function Ne(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}new Set;var Oe=[],Pe=-1;function H(a){0>Pe||(a.current=Oe[Pe],Oe[Pe]=null,Pe--)}function J(a,b){Pe++;Oe[Pe]=a.current;a.current=b}var Qe={},L={current:Qe},M={current:!1},Re=Qe;
	function Se(a,b){var c=a.type.contextTypes;if(!c)return Qe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function N(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Te(a){H(M,a);H(L,a)}function Ue(a){H(M,a);H(L,a)}
	function Ve(a,b,c){if(L.current!==Qe)throw t(Error(168));J(L,b,a);J(M,c,a)}function We(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw t(Error(108),oc(b)||"Unknown",e);return m({},c,d)}function Xe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Qe;Re=L.current;J(L,b,a);J(M,M.current,a);return!0}
	function Ye(a,b,c){var d=a.stateNode;if(!d)throw t(Error(169));c?(b=We(a,b,Re),d.__reactInternalMemoizedMergedChildContext=b,H(M,a),H(L,a),J(L,b,a)):H(M,a);J(M,c,a)}
	var Ze=q.unstable_runWithPriority,$e=q.unstable_scheduleCallback,af=q.unstable_cancelCallback,bf=q.unstable_shouldYield,cf=q.unstable_requestPaint,df=q.unstable_now,ef=q.unstable_getCurrentPriorityLevel,ff=q.unstable_ImmediatePriority,hf=q.unstable_UserBlockingPriority,jf=q.unstable_NormalPriority,kf=q.unstable_LowPriority,lf=q.unstable_IdlePriority,mf={},nf=void 0!==cf?cf:function(){},of=null,pf=null,qf=!1,rf=df(),sf=1E4>rf?df:function(){return df()-rf};
	function tf(){switch(ef()){case ff:return 99;case hf:return 98;case jf:return 97;case kf:return 96;case lf:return 95;default:throw t(Error(332));}}function uf(a){switch(a){case 99:return ff;case 98:return hf;case 97:return jf;case 96:return kf;case 95:return lf;default:throw t(Error(332));}}function vf(a,b){a=uf(a);return Ze(a,b)}function wf(a,b,c){a=uf(a);return $e(a,b,c)}function xf(a){null===of?(of=[a],pf=$e(ff,yf)):of.push(a);return mf}function O(){null!==pf&&af(pf);yf()}
	function yf(){if(!qf&&null!==of){qf=!0;var a=0;try{var b=of;vf(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});of=null}catch(c){throw null!==of&&(of=of.slice(a+1)),$e(ff,O),c;}finally{qf=!1}}}function zf(a,b){if(1073741823===b)return 99;if(1===b)return 95;a=10*(1073741821-b)-10*(1073741821-a);return 0>=a?99:250>=a?98:5250>=a?97:95}function Af(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function Bf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var Cf={current:null},Df=null,Ef=null,Ff=null;function Gf(){Ff=Ef=Df=null}
	function Hf(a,b){var c=a.type._context;J(Cf,c._currentValue,a);c._currentValue=b}function If(a){var b=Cf.current;H(Cf,a);a.type._context._currentValue=b}function Jf(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
	function Kf(a,b){Df=a;Ff=Ef=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(Lf=!0),a.firstContext=null)}function Mf(a,b){if(Ff!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Ff=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===Ef){if(null===Df)throw t(Error(308));Ef=b;Df.dependencies={expirationTime:0,firstContext:b,responders:null}}else Ef=Ef.next=b}return a._currentValue}var Nf=!1;
	function Of(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Pf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function Qf(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Rf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function Sf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Of(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Of(a.memoizedState),e=c.updateQueue=Of(c.memoizedState)):d=a.updateQueue=Pf(e):null===e&&(e=c.updateQueue=Pf(d));null===e||d===e?Rf(d,b):null===d.lastUpdate||null===e.lastUpdate?(Rf(d,b),Rf(e,b)):(Rf(d,b),e.lastUpdate=b)}
	function Tf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Of(a.memoizedState):Uf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Uf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Pf(b));return b}
	function Vf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return m({},d,e);case 2:Nf=!0}return d}
	function Wf(a,b,c,d,e){Nf=!1;b=Uf(a,b);for(var f=b.baseState,h=null,g=0,k=b.firstUpdate,l=f;null!==k;){var n=k.expirationTime;n<e?(null===h&&(h=k,f=l),g<n&&(g=n)):(Xf(n,k.suspenseConfig),l=Vf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}n=null;for(k=b.firstCapturedUpdate;null!==k;){var z=k.expirationTime;z<e?(null===n&&(n=k,null===h&&(f=l)),g<z&&(g=z)):(l=Vf(a,b,k,l,c,d),null!==
	k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===h&&(b.lastUpdate=null);null===n?b.lastCapturedUpdate=null:a.effectTag|=32;null===h&&null===n&&(f=l);b.baseState=f;b.firstUpdate=h;b.firstCapturedUpdate=n;a.expirationTime=g;a.memoizedState=l}
	function Yf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Zf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Zf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Zf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw t(Error(191),c);c.call(d)}a=a.nextEffect}}
	var $f=Xb.ReactCurrentBatchConfig,ag=(new aa.Component).refs;function bg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var fg={isMounted:function(a){return(a=a._reactInternalFiber)?2===ld(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=cg(),d=$f.suspense;
	c=dg(c,a,d);d=Qf(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Sf(a,d);eg(a,c)}};function gg(a,b,c,d,e,f,h){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,h):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
	function hg(a,b,c){var d=!1,e=Qe;var f=b.contextType;"object"===typeof f&&null!==f?f=Mf(f):(e=N(b)?Re:L.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Se(a,e):Qe);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=fg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function ig(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&fg.enqueueReplaceState(b,b.state,null)}
	function jg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=ag;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Mf(f):(f=N(b)?Re:L.current,e.context=Se(a,f));f=a.updateQueue;null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(bg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&fg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var kg=Array.isArray;
	function lg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;if(c){if(1!==c.tag)throw t(Error(309));d=c.stateNode}if(!d)throw t(Error(147),a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===ag&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw t(Error(284));if(!c._owner)throw t(Error(290),a);}return a}
	function mg(a,b){if("textarea"!==a.type)throw t(Error(31),"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"");}
	function ng(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=og(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=pg(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=lg(a,b,c),d.return=a,d;d=qg(c.type,c.key,c.props,null,a.mode,d);d.ref=lg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=rg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=sg(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=pg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=qg(b.type,b.key,b.props,null,a.mode,c),c.ref=lg(a,null,b),c.return=a,c;case $b:return b=rg(b,a.mode,c),b.return=a,b}if(kg(b)||
	mc(b))return b=sg(b,a.mode,c,null),b.return=a,b;mg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(kg(c)||mc(c))return null!==e?null:n(a,b,c,d,null);mg(a,c)}return null}function v(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(kg(d)||mc(d))return a=a.get(c)||null,n(b,a,d,e,null);mg(b,d)}return null}function rb(e,h,g,k){for(var l=null,u=null,n=h,w=h=0,C=null;null!==n&&w<g.length;w++){n.index>w?(C=n,n=null):C=n.sibling;var p=x(e,n,g[w],k);if(null===p){null===n&&(n=C);break}a&&
	n&&null===p.alternate&&b(e,n);h=f(p,h,w);null===u?l=p:u.sibling=p;u=p;n=C}if(w===g.length)return c(e,n),l;if(null===n){for(;w<g.length;w++)n=z(e,g[w],k),null!==n&&(h=f(n,h,w),null===u?l=n:u.sibling=n,u=n);return l}for(n=d(e,n);w<g.length;w++)C=v(n,e,w,g[w],k),null!==C&&(a&&null!==C.alternate&&n.delete(null===C.key?w:C.key),h=f(C,h,w),null===u?l=C:u.sibling=C,u=C);a&&n.forEach(function(a){return b(e,a)});return l}function Be(e,h,g,k){var l=mc(g);if("function"!==typeof l)throw t(Error(150));g=l.call(g);
	if(null==g)throw t(Error(151));for(var n=l=null,u=h,w=h=0,C=null,p=g.next();null!==u&&!p.done;w++,p=g.next()){u.index>w?(C=u,u=null):C=u.sibling;var r=x(e,u,p.value,k);if(null===r){null===u&&(u=C);break}a&&u&&null===r.alternate&&b(e,u);h=f(r,h,w);null===n?l=r:n.sibling=r;n=r;u=C}if(p.done)return c(e,u),l;if(null===u){for(;!p.done;w++,p=g.next())p=z(e,p.value,k),null!==p&&(h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);return l}for(u=d(e,u);!p.done;w++,p=g.next())p=v(u,e,w,p.value,k),null!==p&&(a&&null!==
	p.alternate&&u.delete(null===p.key?w:p.key),h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,g){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,g);d.ref=lg(a,k,f);d.return=a;a=d;break a}c(a,
	k);break}else b(a,k);k=k.sibling}f.type===ac?(d=sg(f.props.children,a.mode,g,f.key),d.return=a,a=d):(g=qg(f.type,f.key,f.props,null,a.mode,g),g.ref=lg(a,d,f),g.return=a,a=g)}return h(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d.return=a;a=d;break a}c(a,d);break}else b(a,d);d=d.sibling}d=rg(f,a.mode,g);d.return=a;a=d}return h(a)}if("string"===typeof f||
	"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,g),d.return=a,a=d):(c(a,d),d=pg(f,a.mode,g),d.return=a,a=d),h(a);if(kg(f))return rb(a,d,f,g);if(mc(f))return Be(a,d,f,g);l&&mg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,t(Error(152),a.displayName||a.name||"Component");}return c(a,d)}}var tg=ng(!0),ug=ng(!1),vg={},wg={current:vg},xg={current:vg},yg={current:vg};function zg(a){if(a===vg)throw t(Error(174));return a}
	function Ag(a,b){J(yg,b,a);J(xg,a,a);J(wg,vg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:te(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=te(b,c)}H(wg,a);J(wg,b,a)}function Bg(a){H(wg,a);H(xg,a);H(yg,a)}function Cg(a){zg(yg.current);var b=zg(wg.current);var c=te(b,a.type);b!==c&&(J(xg,a,a),J(wg,c,a))}function Dg(a){xg.current===a&&(H(wg,a),H(xg,a))}var Eg=1,Fg=1,Gg=2,P={current:0};
	function Hg(a){for(var b=a;null!==b;){if(13===b.tag){if(null!==b.memoizedState)return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}
	var Ig=0,Jg=2,Kg=4,Lg=8,Mg=16,Ng=32,Og=64,Pg=128,Qg=Xb.ReactCurrentDispatcher,Rg=0,Sg=null,Q=null,Tg=null,Ug=null,R=null,Vg=null,Wg=0,Xg=null,Yg=0,Zg=!1,$g=null,ah=0;function bh(){throw t(Error(321));}function ch(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!hd(a[c],b[c]))return!1;return!0}
	function dh(a,b,c,d,e,f){Rg=f;Sg=b;Tg=null!==a?a.memoizedState:null;Qg.current=null===Tg?eh:fh;b=c(d,e);if(Zg){do Zg=!1,ah+=1,Tg=null!==a?a.memoizedState:null,Vg=Ug,Xg=R=Q=null,Qg.current=fh,b=c(d,e);while(Zg);$g=null;ah=0}Qg.current=hh;a=Sg;a.memoizedState=Ug;a.expirationTime=Wg;a.updateQueue=Xg;a.effectTag|=Yg;a=null!==Q&&null!==Q.next;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;if(a)throw t(Error(300));return b}
	function ih(){Qg.current=hh;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;Zg=!1;$g=null;ah=0}function jh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===R?Ug=R=a:R=R.next=a;return R}function kh(){if(null!==Vg)R=Vg,Vg=R.next,Q=Tg,Tg=null!==Q?Q.next:null;else{if(null===Tg)throw t(Error(310));Q=Tg;var a={memoizedState:Q.memoizedState,baseState:Q.baseState,queue:Q.queue,baseUpdate:Q.baseUpdate,next:null};R=null===R?Ug=a:R.next=a;Tg=Q.next}return R}
	function lh(a,b){return"function"===typeof b?b(a):b}
	function mh(a){var b=kh(),c=b.queue;if(null===c)throw t(Error(311));c.lastRenderedReducer=a;if(0<ah){var d=c.dispatch;if(null!==$g){var e=$g.get(c);if(void 0!==e){$g.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var h=b.baseUpdate;f=b.baseState;null!==h?(null!==d&&(d.next=null),d=h.next):d=null!==d?d.next:null;if(null!==
	d){var g=e=null,k=d,l=!1;do{var n=k.expirationTime;n<Rg?(l||(l=!0,g=h,e=f),n>Wg&&(Wg=n)):(Xf(n,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));h=k;k=k.next}while(null!==k&&k!==d);l||(g=h,e=f);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate=g;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function nh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===Xg?(Xg={lastEffect:null},Xg.lastEffect=a.next=a):(b=Xg.lastEffect,null===b?Xg.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,Xg.lastEffect=a));return a}function oh(a,b,c,d){var e=jh();Yg|=a;e.memoizedState=nh(b,c,void 0,void 0===d?null:d)}
	function ph(a,b,c,d){var e=kh();d=void 0===d?null:d;var f=void 0;if(null!==Q){var h=Q.memoizedState;f=h.destroy;if(null!==d&&ch(d,h.deps)){nh(Ig,c,f,d);return}}Yg|=a;e.memoizedState=nh(b,c,f,d)}function qh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function rh(){}
	function sh(a,b,c){if(!(25>ah))throw t(Error(301));var d=a.alternate;if(a===Sg||null!==d&&d===Sg)if(Zg=!0,a={expirationTime:Rg,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===$g&&($g=new Map),c=$g.get(b),void 0===c)$g.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=cg(),f=$f.suspense;e=dg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var h=b.last;if(null===h)f.next=f;else{var g=h.next;null!==g&&
	(f.next=g);h.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(hd(l,k))return}catch(n){}finally{}eg(a,e)}}
	var hh={readContext:Mf,useCallback:bh,useContext:bh,useEffect:bh,useImperativeHandle:bh,useLayoutEffect:bh,useMemo:bh,useReducer:bh,useRef:bh,useState:bh,useDebugValue:bh,useResponder:bh},eh={readContext:Mf,useCallback:function(a,b){jh().memoizedState=[a,void 0===b?null:b];return a},useContext:Mf,useEffect:function(a,b){return oh(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return oh(4,Kg|Ng,qh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return oh(4,
	Kg|Ng,a,b)},useMemo:function(a,b){var c=jh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=jh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=sh.bind(null,Sg,a);return[d.memoizedState,a]},useRef:function(a){var b=jh();a={current:a};return b.memoizedState=a},useState:function(a){var b=jh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue=
	{last:null,dispatch:null,lastRenderedReducer:lh,lastRenderedState:a};a=a.dispatch=sh.bind(null,Sg,a);return[b.memoizedState,a]},useDebugValue:rh,useResponder:kd},fh={readContext:Mf,useCallback:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:Mf,useEffect:function(a,b){return ph(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ph(4,Kg|Ng,qh.bind(null,
	b,a),c)},useLayoutEffect:function(a,b){return ph(4,Kg|Ng,a,b)},useMemo:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:mh,useRef:function(){return kh().memoizedState},useState:function(a){return mh(lh,a)},useDebugValue:rh,useResponder:kd},th=null,uh=null,vh=!1;
	function wh(a,b){var c=xh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function yh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function zh(a){if(vh){var b=uh;if(b){var c=b;if(!yh(a,b)){b=Ne(c.nextSibling);if(!b||!yh(a,b)){a.effectTag|=2;vh=!1;th=a;return}wh(th,c)}th=a;uh=Ne(b.firstChild)}else a.effectTag|=2,vh=!1,th=a}}function Ah(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;th=a}
	function Bh(a){if(a!==th)return!1;if(!vh)return Ah(a),vh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ke(b,a.memoizedProps))for(b=uh;b;)wh(a,b),b=Ne(b.nextSibling);Ah(a);uh=th?Ne(a.stateNode.nextSibling):null;return!0}function Ch(){uh=th=null;vh=!1}var Dh=Xb.ReactCurrentOwner,Lf=!1;function S(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
	function Eh(a,b,c,d,e){c=c.render;var f=b.ref;Kf(b,e);d=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Gh(a,b,c,d,e,f){if(null===a){var h=c.type;if("function"===typeof h&&!Hh(h)&&void 0===h.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=h,Ih(a,b,h,d,e,f);a=qg(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}h=a.child;if(e<f&&(e=h.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return Fh(a,b,f);b.effectTag|=1;a=og(h,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Ih(a,b,c,d,e,f){return null!==a&&jd(a.memoizedProps,d)&&a.ref===b.ref&&(Lf=!1,e<f)?Fh(a,b,f):Jh(a,b,c,d,f)}function Kh(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Jh(a,b,c,d,e){var f=N(c)?Re:L.current;f=Se(b,f);Kf(b,e);c=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Lh(a,b,c,d,e){if(N(c)){var f=!0;Xe(b)}else f=!1;Kf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),hg(b,c,d,e),jg(b,c,d,e),d=!0;else if(null===a){var h=b.stateNode,g=b.memoizedProps;h.props=g;var k=h.context,l=c.contextType;"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l));var n=c.getDerivedStateFromProps,z="function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate;z||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l);Nf=!1;var x=b.memoizedState;k=h.state=x;var v=b.updateQueue;null!==v&&(Wf(b,v,d,h,e),k=b.memoizedState);g!==d||x!==k||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),k=b.memoizedState),(g=Nf||gg(b,c,g,d,x,k,l))?(z||"function"!==typeof h.UNSAFE_componentWillMount&&"function"!==typeof h.componentWillMount||("function"===typeof h.componentWillMount&&h.componentWillMount(),"function"===typeof h.UNSAFE_componentWillMount&&
	h.UNSAFE_componentWillMount()),"function"===typeof h.componentDidMount&&(b.effectTag|=4)):("function"===typeof h.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),h.props=d,h.state=k,h.context=l,d=g):("function"===typeof h.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.stateNode,g=b.memoizedProps,h.props=b.type===b.elementType?g:Af(b.type,g),k=h.context,l=c.contextType,"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l)),n=c.getDerivedStateFromProps,(z=
	"function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate)||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l),Nf=!1,k=b.memoizedState,x=h.state=k,v=b.updateQueue,null!==v&&(Wf(b,v,d,h,e),x=b.memoizedState),g!==d||k!==x||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),x=b.memoizedState),(n=Nf||gg(b,c,g,d,k,x,l))?(z||"function"!==typeof h.UNSAFE_componentWillUpdate&&"function"!==typeof h.componentWillUpdate||
	("function"===typeof h.componentWillUpdate&&h.componentWillUpdate(d,x,l),"function"===typeof h.UNSAFE_componentWillUpdate&&h.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof h.componentDidUpdate&&(b.effectTag|=4),"function"===typeof h.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
	d,b.memoizedState=x),h.props=d,h.state=x,h.context=l,d=n):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return Mh(a,b,c,d,f,e)}
	function Mh(a,b,c,d,e,f){Kh(a,b);var h=0!==(b.effectTag&64);if(!d&&!h)return e&&Ye(b,c,!1),Fh(a,b,f);d=b.stateNode;Dh.current=b;var g=h&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&h?(b.child=tg(b,a.child,null,f),b.child=tg(b,null,g,f)):S(a,b,g,f);b.memoizedState=d.state;e&&Ye(b,c,!0);return b.child}function Nh(a){var b=a.stateNode;b.pendingContext?Ve(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ve(a,b.context,!1);Ag(a,b.containerInfo)}
	var Oh={};
	function Ph(a,b,c){var d=b.mode,e=b.pendingProps,f=P.current,h=null,g=!1,k;(k=0!==(b.effectTag&64))||(k=0!==(f&Gg)&&(null===a||null!==a.memoizedState));k?(h=Oh,g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=Fg);f&=Eg;J(P,f,b);if(null===a)if(g){e=e.fallback;a=sg(null,d,0,null);a.return=b;if(0===(b.mode&2))for(g=null!==b.memoizedState?b.child.child:b.child,a.child=g;null!==g;)g.return=a,g=g.sibling;c=sg(e,d,c,null);c.return=b;a.sibling=
	c;d=a}else d=c=ug(b,null,e.children,c);else{if(null!==a.memoizedState)if(f=a.child,d=f.sibling,g){e=e.fallback;c=og(f,f.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==f.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;e=og(d,e,d.expirationTime);e.return=b;c.sibling=e;d=c;c.childExpirationTime=0;c=e}else d=c=tg(b,f.child,e.children,c);else if(f=a.child,g){g=e.fallback;e=sg(null,d,0,null);e.return=b;e.child=f;null!==f&&(f.return=e);if(0===(b.mode&
	2))for(f=null!==b.memoizedState?b.child.child:b.child,e.child=f;null!==f;)f.return=e,f=f.sibling;c=sg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;d=e;e.childExpirationTime=0}else c=d=tg(b,f,e.children,c);b.stateNode=a.stateNode}b.memoizedState=h;b.child=d;return c}function Qh(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.last=d,f.tail=c,f.tailExpiration=0,f.tailMode=e)}
	function Rh(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;S(a,b,d.children,c);d=P.current;if(0!==(d&Gg))d=d&Eg|Gg,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag){if(null!==a.memoizedState){a.expirationTime<c&&(a.expirationTime=c);var h=a.alternate;null!==h&&h.expirationTime<c&&(h.expirationTime=c);Jf(a.return,c)}}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===
	b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=Eg}J(P,d,b);if(0===(b.mode&2))b.memoizedState=null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)d=c.alternate,null!==d&&null===Hg(d)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Qh(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){d=e.alternate;if(null!==d&&null===Hg(d)){b.child=e;break}d=e.sibling;e.sibling=c;c=e;e=d}Qh(b,!0,c,null,f);break;case "together":Qh(b,
	!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}function Fh(a,b,c){null!==a&&(b.dependencies=a.dependencies);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw t(Error(153));if(null!==b.child){a=b.child;c=og(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=og(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Sh(a){a.effectTag|=4}
	var Th=void 0,Uh=void 0,Vh=void 0,Wh=void 0;Th=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(20===c.tag)a.appendChild(c.stateNode.instance);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Uh=function(){};
	Vh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var h=b.stateNode;zg(wg.current);a=null;switch(c){case "input":f=Bc(h,f);d=Bc(h,d);a=[];break;case "option":f=le(h,f);d=le(h,d);a=[];break;case "select":f=m({},f,{value:void 0});d=m({},d,{value:void 0});a=[];break;case "textarea":f=ne(h,f);d=ne(h,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(h.onclick=Ge)}De(c,d);h=c=void 0;var g=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var k=f[c];for(h in k)k.hasOwnProperty(h)&&(g||(g={}),g[h]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ia.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(h in k)!k.hasOwnProperty(h)||l&&l.hasOwnProperty(h)||(g||(g={}),g[h]="");for(h in l)l.hasOwnProperty(h)&&k[h]!==l[h]&&(g||
	(g={}),g[h]=l[h])}else g||(a||(a=[]),a.push(c,g)),g=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ia.hasOwnProperty(c)?(null!=l&&Fe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}g&&(a=a||[]).push("style",g);e=a;(b.updateQueue=e)&&Sh(b)}};Wh=function(a,b,c,d){c!==d&&Sh(b)};
	function $h(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function ai(a){switch(a.tag){case 1:N(a.type)&&Te(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:Bg(a);Ue(a);b=a.effectTag;if(0!==(b&64))throw t(Error(285));a.effectTag=b&-2049|64;return a;case 5:return Dg(a),null;case 13:return H(P,a),b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 19:return H(P,a),null;case 4:return Bg(a),null;case 10:return If(a),null;default:return null}}function bi(a,b){return{value:a,source:b,stack:pc(b)}}
	var ci="function"===typeof WeakSet?WeakSet:Set;function di(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=pc(c));null!==c&&oc(c.type);b=b.value;null!==a&&1===a.tag&&oc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function ei(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){fi(a,c)}}function gi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){fi(a,c)}else b.current=null}
	function hi(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Ig){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Ig&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function ii(a,b){"function"===typeof ji&&ji(a);switch(a.tag){case 0:case 11:case 14:case 15:var c=a.updateQueue;if(null!==c&&(c=c.lastEffect,null!==c)){var d=c.next;vf(97<b?97:b,function(){var b=d;do{var c=b.destroy;if(void 0!==c){var h=a;try{c()}catch(g){fi(h,g)}}b=b.next}while(b!==d)})}break;case 1:gi(a);b=a.stateNode;"function"===typeof b.componentWillUnmount&&ei(a,b);break;case 5:gi(a);break;case 4:ki(a,b)}}
	function li(a,b){for(var c=a;;)if(ii(c,b),null!==c.child&&4!==c.tag)c.child.return=c,c=c.child;else{if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}function mi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function ni(a){a:{for(var b=a.return;null!==b;){if(mi(b)){var c=b;break a}b=b.return}throw t(Error(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw t(Error(161));}c.effectTag&16&&(we(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||mi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f||20===e.tag){var h=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var g=h;h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(h,c);else d?(g=b,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=Ge)):
	b.appendChild(h)}else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function ki(a,b){for(var c=a,d=!1,e=void 0,f=void 0;;){if(!d){d=c.return;a:for(;;){if(null===d)throw t(Error(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag)if(li(c,b),f){var h=e,g=c.stateNode;8===h.nodeType?h.parentNode.removeChild(g):h.removeChild(g)}else e.removeChild(c.stateNode);else if(20===c.tag)g=c.stateNode.instance,li(c,b),f?(h=e,8===h.nodeType?h.parentNode.removeChild(g):
	h.removeChild(g)):e.removeChild(g);else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(ii(c,b),null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
	function oi(a,b){switch(b.tag){case 0:case 11:case 14:case 15:hi(Kg,Lg,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ga]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Dc(c,d);Ee(a,e);b=Ee(a,d);for(e=0;e<f.length;e+=2){var h=f[e],g=f[e+1];"style"===h?Ae(c,g):"dangerouslySetInnerHTML"===h?ve(c,g):"children"===h?we(c,g):zc(c,h,g,b)}switch(a){case "input":Ec(c,d);break;case "textarea":pe(c,
	d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?me(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?me(c,!!d.multiple,d.defaultValue,!0):me(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw t(Error(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,pi=sf());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=
	f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ze("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===
	a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}qi(b);break;case 19:qi(b);break;case 17:break;case 20:break;default:throw t(Error(163));}}function qi(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new ci);b.forEach(function(b){var d=ri.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var si="function"===typeof WeakMap?WeakMap:Map;
	function ti(a,b,c){c=Qf(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){ui||(ui=!0,vi=d);di(a,b)};return c}
	function wi(a,b,c){c=Qf(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){di(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===xi?xi=new Set([this]):xi.add(this),di(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var yi=Math.ceil,zi=Xb.ReactCurrentDispatcher,Ai=Xb.ReactCurrentOwner,T=0,Bi=8,Ci=16,Di=32,Ei=0,Fi=1,Gi=2,Hi=3,Ii=4,U=T,Ji=null,V=null,W=0,X=Ei,Ki=1073741823,Li=1073741823,Mi=null,Ni=!1,pi=0,Oi=500,Y=null,ui=!1,vi=null,xi=null,Pi=!1,Qi=null,Ri=90,Si=0,Ti=null,Ui=0,Vi=null,Wi=0;function cg(){return(U&(Ci|Di))!==T?1073741821-(sf()/10|0):0!==Wi?Wi:Wi=1073741821-(sf()/10|0)}
	function dg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=tf();if(0===(b&4))return 99===d?1073741823:1073741822;if((U&Ci)!==T)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=1;break;default:throw t(Error(326));}null!==Ji&&a===W&&--a;return a}var Xi=0;
	function eg(a,b){if(50<Ui)throw Ui=0,Vi=null,t(Error(185));a=Yi(a,b);if(null!==a){a.pingTime=0;var c=tf();if(1073741823===b)if((U&Bi)!==T&&(U&(Ci|Di))===T)for(var d=Z(a,1073741823,!0);null!==d;)d=d(!0);else Zi(a,99,1073741823),U===T&&O();else Zi(a,c,b);(U&4)===T||98!==c&&99!==c||(null===Ti?Ti=new Map([[a,b]]):(c=Ti.get(a),(void 0===c||c>b)&&Ti.set(a,b)))}}
	function Yi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(b>e.firstPendingTime&&(e.firstPendingTime=b),a=e.lastPendingTime,0===a||b<a)&&(e.lastPendingTime=
	b);return e}function Zi(a,b,c){if(a.callbackExpirationTime<c){var d=a.callbackNode;null!==d&&d!==mf&&af(d);a.callbackExpirationTime=c;1073741823===c?a.callbackNode=xf($i.bind(null,a,Z.bind(null,a,c))):(d=null,1!==c&&(d={timeout:10*(1073741821-c)-sf()}),a.callbackNode=wf(b,$i.bind(null,a,Z.bind(null,a,c)),d))}}function $i(a,b,c){var d=a.callbackNode,e=null;try{return e=b(c),null!==e?$i.bind(null,a,e):null}finally{null===e&&d===a.callbackNode&&(a.callbackNode=null,a.callbackExpirationTime=0)}}
	function aj(){(U&(1|Ci|Di))===T&&(bj(),cj())}function dj(a,b){var c=a.firstBatch;return null!==c&&c._defer&&c._expirationTime>=b?(wf(97,function(){c._onComplete();return null}),!0):!1}function bj(){if(null!==Ti){var a=Ti;Ti=null;a.forEach(function(a,c){xf(Z.bind(null,c,a))});O()}}function ej(a,b){var c=U;U|=1;try{return a(b)}finally{U=c,U===T&&O()}}function fj(a,b,c,d){var e=U;U|=4;try{return vf(98,a.bind(null,b,c,d))}finally{U=e,U===T&&O()}}
	function gj(a,b){var c=U;U&=-2;U|=Bi;try{return a(b)}finally{U=c,U===T&&O()}}
	function hj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Me(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Te(d);break;case 3:Bg(d);Ue(d);break;case 5:Dg(d);break;case 4:Bg(d);break;case 13:H(P,d);break;case 19:H(P,d);break;case 10:If(d)}c=c.return}Ji=a;V=og(a.current,null,b);W=b;X=Ei;Li=Ki=1073741823;Mi=null;Ni=!1}
	function Z(a,b,c){if((U&(Ci|Di))!==T)throw t(Error(327));if(a.firstPendingTime<b)return null;if(c&&a.finishedExpirationTime===b)return ij.bind(null,a);cj();if(a!==Ji||b!==W)hj(a,b);else if(X===Hi)if(Ni)hj(a,b);else{var d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d)}if(null!==V){d=U;U|=Ci;var e=zi.current;null===e&&(e=hh);zi.current=hh;if(c){if(1073741823!==b){var f=cg();if(f<b)return U=d,Gf(),zi.current=e,Z.bind(null,a,f)}}else Wi=0;do try{if(c)for(;null!==V;)V=jj(V);else for(;null!==V&&!bf();)V=
	jj(V);break}catch(rb){Gf();ih();f=V;if(null===f||null===f.return)throw hj(a,b),U=d,rb;a:{var h=a,g=f.return,k=f,l=rb,n=W;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===typeof l&&"function"===typeof l.then){var z=l,x=0!==(P.current&Fg);l=g;do{var v;if(v=13===l.tag)null!==l.memoizedState?v=!1:(v=l.memoizedProps,v=void 0===v.fallback?!1:!0!==v.unstable_avoidThisFallback?!0:x?!1:!0);if(v){g=l.updateQueue;null===g?(g=new Set,g.add(z),l.updateQueue=g):g.add(z);if(0===(l.mode&
	2)){l.effectTag|=64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(n=Qf(1073741823,null),n.tag=2,Sf(k,n)));k.expirationTime=1073741823;break a}k=h;h=n;x=k.pingCache;null===x?(x=k.pingCache=new si,g=new Set,x.set(z,g)):(g=x.get(z),void 0===g&&(g=new Set,x.set(z,g)));g.has(h)||(g.add(h),k=kj.bind(null,k,z,h),z.then(k,k));l.effectTag|=2048;l.expirationTime=n;break a}l=l.return}while(null!==l);l=Error((oc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
	pc(k))}X!==Ii&&(X=Fi);l=bi(l,k);k=g;do{switch(k.tag){case 3:k.effectTag|=2048;k.expirationTime=n;n=ti(k,l,n);Tf(k,n);break a;case 1:if(z=l,h=k.type,g=k.stateNode,0===(k.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==g&&"function"===typeof g.componentDidCatch&&(null===xi||!xi.has(g)))){k.effectTag|=2048;k.expirationTime=n;n=wi(k,z,n);Tf(k,n);break a}}k=k.return}while(null!==k)}V=lj(f)}while(1);U=d;Gf();zi.current=e;if(null!==V)return Z.bind(null,a,b)}a.finishedWork=a.current.alternate;
	a.finishedExpirationTime=b;if(dj(a,b))return null;Ji=null;switch(X){case Ei:throw t(Error(328));case Fi:return d=a.lastPendingTime,d<b?Z.bind(null,a,d):c?ij.bind(null,a):(hj(a,b),xf(Z.bind(null,a,b)),null);case Gi:if(1073741823===Ki&&!c&&(c=pi+Oi-sf(),10<c)){if(Ni)return hj(a,b),Z.bind(null,a,b);d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d);a.timeoutHandle=Le(ij.bind(null,a),c);return null}return ij.bind(null,a);case Hi:if(!c){if(Ni)return hj(a,b),Z.bind(null,a,b);c=a.lastPendingTime;if(c<b)return Z.bind(null,
	a,c);1073741823!==Li?c=10*(1073741821-Li)-sf():1073741823===Ki?c=0:(c=10*(1073741821-Ki)-5E3,d=sf(),b=10*(1073741821-b)-d,c=d-c,0>c&&(c=0),c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>c?4320:1960*yi(c/1960))-c,b<c&&(c=b));if(10<c)return a.timeoutHandle=Le(ij.bind(null,a),c),null}return ij.bind(null,a);case Ii:return!c&&1073741823!==Ki&&null!==Mi&&(d=Ki,e=Mi,b=e.busyMinDurationMs|0,0>=b?b=0:(c=e.busyDelayMs|0,d=sf()-(10*(1073741821-d)-(e.timeoutMs|0||5E3)),b=d<=c?0:c+b-d),10<b)?(a.timeoutHandle=
	Le(ij.bind(null,a),b),null):ij.bind(null,a);default:throw t(Error(329));}}function Xf(a,b){a<Ki&&1<a&&(Ki=a);null!==b&&a<Li&&1<a&&(Li=a,Mi=b)}function jj(a){var b=mj(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=lj(a));Ai.current=null;return b}
	function lj(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&1024)){a:{var c=b;b=V;var d=W,e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:N(b.type)&&Te(b);break;case 3:Bg(b);Ue(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===c||null===c.child)Bh(b),b.effectTag&=-3;Uh(b);break;case 5:Dg(b);d=zg(yg.current);var f=b.type;if(null!==c&&null!=b.stateNode)Vh(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var h=
	zg(wg.current);if(Bh(b)){c=b;e=void 0;f=c.stateNode;var g=c.type,k=c.memoizedProps;f[Fa]=c;f[Ga]=k;switch(g){case "iframe":case "object":case "embed":G("load",f);break;case "video":case "audio":for(var l=0;l<bb.length;l++)G(bb[l],f);break;case "source":G("error",f);break;case "img":case "image":case "link":G("error",f);G("load",f);break;case "form":G("reset",f);G("submit",f);break;case "details":G("toggle",f);break;case "input":Cc(f,k);G("invalid",f);Fe(d,"onChange");break;case "select":f._wrapperState=
	{wasMultiple:!!k.multiple};G("invalid",f);Fe(d,"onChange");break;case "textarea":oe(f,k),G("invalid",f),Fe(d,"onChange")}De(g,k);l=null;for(e in k)k.hasOwnProperty(e)&&(h=k[e],"children"===e?"string"===typeof h?f.textContent!==h&&(l=["children",h]):"number"===typeof h&&f.textContent!==""+h&&(l=["children",""+h]):ia.hasOwnProperty(e)&&null!=h&&Fe(d,e));switch(g){case "input":Vb(f);Gc(f,k,!0);break;case "textarea":Vb(f);qe(f,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
	(f.onclick=Ge)}d=l;c.updateQueue=d;null!==d&&Sh(b)}else{k=f;c=e;g=b;l=9===d.nodeType?d:d.ownerDocument;h===re.html&&(h=se(k));h===re.html?"script"===k?(k=l.createElement("div"),k.innerHTML="<script>\x3c/script>",l=k.removeChild(k.firstChild)):"string"===typeof c.is?l=l.createElement(k,{is:c.is}):(l=l.createElement(k),"select"===k&&(k=l,c.multiple?k.multiple=!0:c.size&&(k.size=c.size))):l=l.createElementNS(h,k);k=l;k[Fa]=g;k[Ga]=c;c=k;Th(c,b,!1,!1);g=c;var n=d,z=Ee(f,e);switch(f){case "iframe":case "object":case "embed":G("load",
	g);d=e;break;case "video":case "audio":for(d=0;d<bb.length;d++)G(bb[d],g);d=e;break;case "source":G("error",g);d=e;break;case "img":case "image":case "link":G("error",g);G("load",g);d=e;break;case "form":G("reset",g);G("submit",g);d=e;break;case "details":G("toggle",g);d=e;break;case "input":Cc(g,e);d=Bc(g,e);G("invalid",g);Fe(n,"onChange");break;case "option":d=le(g,e);break;case "select":g._wrapperState={wasMultiple:!!e.multiple};d=m({},e,{value:void 0});G("invalid",g);Fe(n,"onChange");break;case "textarea":oe(g,
	e);d=ne(g,e);G("invalid",g);Fe(n,"onChange");break;default:d=e}De(f,d);k=void 0;l=f;h=g;var x=d;for(k in x)if(x.hasOwnProperty(k)){var v=x[k];"style"===k?Ae(h,v):"dangerouslySetInnerHTML"===k?(v=v?v.__html:void 0,null!=v&&ve(h,v)):"children"===k?"string"===typeof v?("textarea"!==l||""!==v)&&we(h,v):"number"===typeof v&&we(h,""+v):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(ia.hasOwnProperty(k)?null!=v&&Fe(n,k):null!=v&&zc(h,k,v,z))}switch(f){case "input":Vb(g);
	Gc(g,e,!1);break;case "textarea":Vb(g);qe(g,e);break;case "option":null!=e.value&&g.setAttribute("value",""+Ac(e.value));break;case "select":d=g;g=e;d.multiple=!!g.multiple;k=g.value;null!=k?me(d,!!g.multiple,k,!1):null!=g.defaultValue&&me(d,!!g.multiple,g.defaultValue,!0);break;default:"function"===typeof d.onClick&&(g.onclick=Ge)}Je(f,e)&&Sh(b);b.stateNode=c}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw t(Error(166));break;case 6:if(c&&null!=b.stateNode)Wh(c,b,c.memoizedProps,
	e);else{if("string"!==typeof e&&null===b.stateNode)throw t(Error(166));c=zg(yg.current);zg(wg.current);Bh(b)?(d=b.stateNode,c=b.memoizedProps,d[Fa]=b,d.nodeValue!==c&&Sh(b)):(d=b,c=(9===c.nodeType?c:c.ownerDocument).createTextNode(e),c[Fa]=b,d.stateNode=c)}break;case 11:break;case 13:H(P,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}d=null!==e;e=!1;null===c?Bh(b):(f=c.memoizedState,e=null!==f,d||null===f||(f=c.child.sibling,null!==f&&(g=b.firstEffect,null!==g?(b.firstEffect=
	f,f.nextEffect=g):(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&Fg))X===Ei&&(X=Gi);else if(X===Ei||X===Gi)X=Hi;if(d||e)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Bg(b);Uh(b);break;case 10:If(b);break;case 9:break;case 14:break;case 17:N(b.type)&&Te(b);break;case 18:break;case 19:H(P,b);e=b.memoizedState;if(null===e)break;f=0!==(b.effectTag&64);g=e.rendering;
	if(null===g)if(f)$h(e,!1);else{if(X!==Ei||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){g=Hg(c);if(null!==g){b.effectTag|=64;$h(e,!1);c=g.updateQueue;null!==c&&(b.updateQueue=c,b.effectTag|=4);b.firstEffect=b.lastEffect=null;for(c=b.child;null!==c;)e=c,f=d,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,g=e.alternate,null===g?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=
	g.childExpirationTime,e.expirationTime=g.expirationTime,e.child=g.child,e.memoizedProps=g.memoizedProps,e.memoizedState=g.memoizedState,e.updateQueue=g.updateQueue,f=g.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),c=c.sibling;J(P,P.current&Eg|Gg,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=Hg(g),null!==c){if(b.effectTag|=64,f=!0,$h(e,!0),null===e.tail&&"hidden"===e.tailMode){d=c.updateQueue;null!==d&&(b.updateQueue=
	d,b.effectTag|=4);b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else sf()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,$h(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(g.sibling=b.child,b.child=g):(d=e.last,null!==d?d.sibling=g:b.child=g,e.last=g)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=sf()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=b.lastEffect;d.sibling=null;c=P.current;c=f?c&Eg|Gg:c&Eg;J(P,c,b);b=d;break a}break;case 20:break;
	default:throw t(Error(156));}b=null}d=V;if(1===W||1!==d.childExpirationTime){c=0;for(e=d.child;null!==e;)f=e.expirationTime,g=e.childExpirationTime,f>c&&(c=f),g>c&&(c=g),e=e.sibling;d.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&1024)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,
	a.lastEffect=V))}else{b=ai(V,W);if(null!==b)return b.effectTag&=1023,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=1024)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===Ei&&(X=Ii);return null}function ij(a){var b=tf();vf(99,nj.bind(null,a,b));null!==Qi&&wf(97,function(){cj();return null});return null}
	function nj(a,b){cj();if((U&(Ci|Di))!==T)throw t(Error(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw t(Error(177));a.callbackNode=null;a.callbackExpirationTime=0;var e=c.expirationTime,f=c.childExpirationTime;e=f>e?f:e;a.firstPendingTime=e;e<a.lastPendingTime&&(a.lastPendingTime=e);a===Ji&&(V=Ji=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;
	if(null!==e){f=U;U|=Di;Ai.current=null;He=Qd;var h=ae();if(be(h)){if("selectionStart"in h)var g={start:h.selectionStart,end:h.selectionEnd};else a:{g=(g=h.ownerDocument)&&g.defaultView||window;var k=g.getSelection&&g.getSelection();if(k&&0!==k.rangeCount){g=k.anchorNode;var l=k.anchorOffset,n=k.focusNode;k=k.focusOffset;try{g.nodeType,n.nodeType}catch(zb){g=null;break a}var z=0,x=-1,v=-1,rb=0,Be=0,u=h,w=null;b:for(;;){for(var C;;){u!==g||0!==l&&3!==u.nodeType||(x=z+l);u!==n||0!==k&&3!==u.nodeType||
	(v=z+k);3===u.nodeType&&(z+=u.nodeValue.length);if(null===(C=u.firstChild))break;w=u;u=C}for(;;){if(u===h)break b;w===g&&++rb===l&&(x=z);w===n&&++Be===k&&(v=z);if(null!==(C=u.nextSibling))break;u=w;w=u.parentNode}u=C}g=-1===x||-1===v?null:{start:x,end:v}}else g=null}g=g||{start:0,end:0}}else g=null;Ie={focusedElem:h,selectionRange:g};Qd=!1;Y=e;do try{for(;null!==Y;){if(0!==(Y.effectTag&256)){var I=Y.alternate;h=Y;switch(h.tag){case 0:case 11:case 15:hi(Jg,Ig,h);break;case 1:if(h.effectTag&256&&null!==
	I){var E=I.memoizedProps,ua=I.memoizedState,gh=h.stateNode,oj=gh.getSnapshotBeforeUpdate(h.elementType===h.type?E:Af(h.type,E),ua);gh.__reactInternalSnapshotBeforeUpdate=oj}break;case 3:case 5:case 6:case 4:case 17:break;default:throw t(Error(163));}}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(I=b;null!==Y;){var A=Y.effectTag;A&16&&we(Y.stateNode,"");if(A&128){var p=Y.alternate;if(null!==p){var r=p.ref;null!==r&&("function"===typeof r?
	r(null):r.current=null)}}switch(A&14){case 2:ni(Y);Y.effectTag&=-3;break;case 6:ni(Y);Y.effectTag&=-3;oi(Y.alternate,Y);break;case 4:oi(Y.alternate,Y);break;case 8:E=Y;ki(E,I);E.return=null;E.child=null;E.memoizedState=null;E.updateQueue=null;E.dependencies=null;var K=E.alternate;null!==K&&(K.return=null,K.child=null,K.memoizedState=null,K.updateQueue=null,K.dependencies=null)}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);r=Ie;p=ae();A=r.focusedElem;
	I=r.selectionRange;if(p!==A&&A&&A.ownerDocument&&$d(A.ownerDocument.documentElement,A)){null!==I&&be(A)&&(p=I.start,r=I.end,void 0===r&&(r=p),"selectionStart"in A?(A.selectionStart=p,A.selectionEnd=Math.min(r,A.value.length)):(r=(p=A.ownerDocument||document)&&p.defaultView||window,r.getSelection&&(r=r.getSelection(),E=A.textContent.length,K=Math.min(I.start,E),I=void 0===I.end?K:Math.min(I.end,E),!r.extend&&K>I&&(E=I,I=K,K=E),E=Zd(A,K),ua=Zd(A,I),E&&ua&&(1!==r.rangeCount||r.anchorNode!==E.node||r.anchorOffset!==
	E.offset||r.focusNode!==ua.node||r.focusOffset!==ua.offset)&&(p=p.createRange(),p.setStart(E.node,E.offset),r.removeAllRanges(),K>I?(r.addRange(p),r.extend(ua.node,ua.offset)):(p.setEnd(ua.node,ua.offset),r.addRange(p))))));p=[];for(r=A;r=r.parentNode;)1===r.nodeType&&p.push({element:r,left:r.scrollLeft,top:r.scrollTop});"function"===typeof A.focus&&A.focus();for(A=0;A<p.length;A++)r=p[A],r.element.scrollLeft=r.left,r.element.scrollTop=r.top}Ie=null;Qd=!!He;He=null;a.current=c;Y=e;do try{for(A=d;null!==
	Y;){var $a=Y.effectTag;if($a&36){var nc=Y.alternate;p=Y;r=A;switch(p.tag){case 0:case 11:case 15:hi(Mg,Ng,p);break;case 1:var md=p.stateNode;if(p.effectTag&4)if(null===nc)md.componentDidMount();else{var Fj=p.elementType===p.type?nc.memoizedProps:Af(p.type,nc.memoizedProps);md.componentDidUpdate(Fj,nc.memoizedState,md.__reactInternalSnapshotBeforeUpdate)}var Xh=p.updateQueue;null!==Xh&&Yf(p,Xh,md,r);break;case 3:var Yh=p.updateQueue;if(null!==Yh){K=null;if(null!==p.child)switch(p.child.tag){case 5:K=
	p.child.stateNode;break;case 1:K=p.child.stateNode}Yf(p,Yh,K,r)}break;case 5:var Gj=p.stateNode;null===nc&&p.effectTag&4&&(r=Gj,Je(p.type,p.memoizedProps)&&r.focus());break;case 6:break;case 4:break;case 12:break;case 13:case 19:case 17:case 20:break;default:throw t(Error(163));}}if($a&128){var nd=Y.ref;if(null!==nd){var Zh=Y.stateNode;switch(Y.tag){case 5:var gf=Zh;break;default:gf=Zh}"function"===typeof nd?nd(gf):nd.current=gf}}$a&512&&(Pi=!0);Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));
	fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=null;nf();U=f}else a.current=c;if(Pi)Pi=!1,Qi=a,Si=d,Ri=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0!==b?($a=cg(),$a=zf($a,b),Zi(a,$a,b)):xi=null;"function"===typeof pj&&pj(c.stateNode,d);1073741823===b?a===Vi?Ui++:(Ui=0,Vi=a):Ui=0;if(ui)throw ui=!1,a=vi,vi=null,a;if((U&Bi)!==T)return null;O();return null}
	function cj(){if(null===Qi)return!1;var a=Qi,b=Si,c=Ri;Qi=null;Si=0;Ri=90;return vf(97<c?97:c,qj.bind(null,a,b))}function qj(a){if((U&(Ci|Di))!==T)throw t(Error(331));var b=U;U|=Di;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:hi(Pg,Ig,c),hi(Ig,Og,c)}}catch(d){if(null===a)throw t(Error(330));fi(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}U=b;O();return!0}
	function rj(a,b,c){b=bi(c,b);b=ti(a,b,1073741823);Sf(a,b);a=Yi(a,1073741823);null!==a&&Zi(a,99,1073741823)}function fi(a,b){if(3===a.tag)rj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){rj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===xi||!xi.has(d))){a=bi(b,a);a=wi(c,a,1073741823);Sf(c,a);c=Yi(c,1073741823);null!==c&&Zi(c,99,1073741823);break}}c=c.return}}
	function kj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);Ji===a&&W===c?X===Hi||X===Gi&&1073741823===Ki&&sf()-pi<Oi?hj(a,W):Ni=!0:a.lastPendingTime<c||(b=a.pingTime,0!==b&&b<c||(a.pingTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),b=cg(),b=zf(b,c),Zi(a,b,c)))}function ri(a,b){var c=a.stateNode;null!==c&&c.delete(b);c=cg();b=dg(c,a,null);c=zf(c,b);a=Yi(a,b);null!==a&&Zi(a,c,b)}var mj=void 0;
	mj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||M.current)Lf=!0;else if(d<c){Lf=!1;switch(b.tag){case 3:Nh(b);Ch();break;case 5:Cg(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:N(b.type)&&Xe(b);break;case 4:Ag(b,b.stateNode.containerInfo);break;case 10:Hf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Ph(a,b,c);J(P,P.current&
	Eg,b);b=Fh(a,b,c);return null!==b?b.sibling:null}J(P,P.current&Eg,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Rh(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);J(P,P.current,b);if(!d)return null}return Fh(a,b,c)}}else Lf=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Se(b,L.current);Kf(b,c);e=dh(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&
	null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;ih();if(N(d)){var f=!0;Xe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var h=d.getDerivedStateFromProps;"function"===typeof h&&bg(b,d,h,a);e.updater=fg;b.stateNode=e;e._reactInternalFiber=b;jg(b,d,a,c);b=Mh(null,b,d,!0,f,c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Bf(e);b.type=e;f=b.tag=sj(e);
	a=Af(e,a);switch(f){case 0:b=Jh(null,b,e,a,c);break;case 1:b=Lh(null,b,e,a,c);break;case 11:b=Eh(null,b,e,a,c);break;case 14:b=Gh(null,b,e,Af(e.type,a),d,c);break;default:throw t(Error(306),e,"");}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Jh(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Lh(a,b,d,e,c);case 3:Nh(b);d=b.updateQueue;if(null===d)throw t(Error(282));e=b.memoizedState;e=null!==e?e.element:null;Wf(b,d,b.pendingProps,
	null,c);d=b.memoizedState.element;if(d===e)Ch(),b=Fh(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)uh=Ne(b.stateNode.containerInfo.firstChild),th=b,e=vh=!0;e?(b.effectTag|=2,b.child=ug(b,null,d,c)):(S(a,b,d,c),Ch());b=b.child}return b;case 5:return Cg(b),null===a&&zh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,h=e.children,Ke(d,e)?h=null:null!==f&&Ke(d,f)&&(b.effectTag|=16),Kh(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):
	(S(a,b,h,c),b=b.child),b;case 6:return null===a&&zh(b),null;case 13:return Ph(a,b,c);case 4:return Ag(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=tg(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Eh(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;h=b.memoizedProps;
	f=e.value;Hf(b,f);if(null!==h){var g=h.value;f=hd(g,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(g,f):1073741823)|0;if(0===f){if(h.children===e.children&&!M.current){b=Fh(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){var k=g.dependencies;if(null!==k){h=g.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===g.tag&&(l=Qf(c,null),l.tag=2,Sf(g,l));g.expirationTime<c&&(g.expirationTime=c);l=g.alternate;null!==l&&l.expirationTime<
	c&&(l.expirationTime=c);Jf(g.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else h=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==h)h.return=g;else for(h=g;null!==h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Kf(b,c),e=Mf(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=Af(e,b.pendingProps),
	f=Af(e.type,f),Gh(a,b,e,f,d,c);case 15:return Ih(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,N(d)?(a=!0,Xe(b)):a=!1,Kf(b,c),hg(b,d,e,c),jg(b,d,e,c),Mh(null,b,d,!0,a,c);case 19:return Rh(a,b,c)}throw t(Error(156));};var pj=null,ji=null;
	function tj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);pj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};ji=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function uj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function xh(a,b,c,d){return new uj(a,b,c,d)}
	function Hh(a){a=a.prototype;return!(!a||!a.isReactComponent)}function sj(a){if("function"===typeof a)return Hh(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===jc)return 14}return 2}
	function og(a,b){var c=a.alternate;null===c?(c=xh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function qg(a,b,c,d,e,f){var h=2;d=a;if("function"===typeof a)Hh(a)&&(h=1);else if("string"===typeof a)h=5;else a:switch(a){case ac:return sg(c.children,e,f,b);case fc:h=8;e|=7;break;case bc:h=8;e|=1;break;case cc:return a=xh(12,c,b,e|8),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=xh(13,c,b,e),a.type=hc,a.elementType=hc,a.expirationTime=f,a;case ic:return a=xh(19,c,b,e),a.elementType=ic,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:h=
	10;break a;case ec:h=9;break a;case gc:h=11;break a;case jc:h=14;break a;case kc:h=16;d=null;break a}throw t(Error(130),null==a?a:typeof a,"");}b=xh(h,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function sg(a,b,c,d){a=xh(7,a,d,b);a.expirationTime=c;return a}function pg(a,b,c){a=xh(6,a,null,b);a.expirationTime=c;return a}
	function rg(a,b,c){b=xh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function vj(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=this.firstBatch=null;this.pingTime=this.lastPendingTime=this.firstPendingTime=this.callbackExpirationTime=0}function wj(a,b,c){a=new vj(a,b,c);b=xh(3,null,null,2===b?7:1===b?3:0);a.current=b;return b.stateNode=a}
	function xj(a,b,c,d,e,f){var h=b.current;a:if(c){c=c._reactInternalFiber;b:{if(2!==ld(c)||1!==c.tag)throw t(Error(170));var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(N(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);throw t(Error(171));}if(1===c.tag){var k=c.type;if(N(k)){c=We(c,k,g);break a}}c=g}else c=Qe;null===b.context?b.context=c:b.pendingContext=c;b=f;e=Qf(d,e);e.payload={element:a};b=void 0===b?null:b;null!==b&&
	(e.callback=b);Sf(h,e);eg(h,d);return d}function yj(a,b,c,d){var e=b.current,f=cg(),h=$f.suspense;e=dg(f,e,h);return xj(a,b,c,e,h,d)}function zj(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Aj(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Db=function(a,b,c){switch(b){case "input":Ec(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);if(!e)throw t(Error(90));Wb(d);Ec(d,e)}}}break;case "textarea":pe(a,c);break;case "select":b=c.value,null!=b&&me(a,!!c.multiple,b,!1)}};
	function Bj(a){var b=1073741821-25*(((1073741821-cg()+500)/25|0)+1);b<=Xi&&--b;this._expirationTime=Xi=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bj.prototype.render=function(a){if(!this._defer)throw t(Error(250));this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Cj;xj(a,b,null,c,null,d._onCommit);return d};
	Bj.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Bj.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;if(!this._defer||null===b)throw t(Error(251));if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;if(null===d)throw t(Error(251));d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;if((U&(Ci|Di))!==T)throw t(Error(253));xf(Z.bind(null,a,b));O();b=this._next;this._next=
	null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bj.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Cj(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Cj.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Cj.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];if("function"!==typeof c)throw t(Error(191),c);c()}}};function Dj(a,b,c){this._internalRoot=wj(a,b,c)}function Ej(a,b){this._internalRoot=wj(a,2,b)}Ej.prototype.render=Dj.prototype.render=function(a,b){var c=this._internalRoot,d=new Cj;b=void 0===b?null:b;null!==b&&d.then(b);yj(a,c,null,d._onCommit);return d};
	Ej.prototype.unmount=Dj.prototype.unmount=function(a){var b=this._internalRoot,c=new Cj;a=void 0===a?null:a;null!==a&&c.then(a);yj(null,b,null,c._onCommit);return c};Ej.prototype.createBatch=function(){var a=new Bj(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};
	function Hj(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Jb=ej;Kb=fj;Lb=aj;Mb=function(a,b){var c=U;U|=2;try{return a(b)}finally{U=c,U===T&&O()}};function Ij(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dj(a,0,b)}
	function Jj(a,b,c,d,e){var f=c._reactRootContainer,h=void 0;if(f){h=f._internalRoot;if("function"===typeof e){var g=e;e=function(){var a=zj(h);g.call(a)}}yj(b,h,a,e)}else{f=c._reactRootContainer=Ij(c,d);h=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=zj(h);k.call(a)}}gj(function(){yj(b,h,a,e)})}return zj(h)}function Kj(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Hj(b))throw t(Error(200));return Aj(a,b,null,c)}
	var Nj={createPortal:Kj,findDOMNode:function(a){if(null==a)a=null;else if(1!==a.nodeType){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw t(Error(188));throw t(Error(268),Object.keys(a));}a=qd(b);a=null===a?null:a.stateNode}return a},hydrate:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!0,c)},render:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!Hj(c))throw t(Error(200));
	if(null==a||void 0===a._reactInternalFiber)throw t(Error(38));return Jj(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!Hj(a))throw t(Error(40));return a._reactRootContainer?(gj(function(){Jj(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Kj.apply(void 0,arguments)},unstable_batchedUpdates:ej,unstable_interactiveUpdates:function(a,b,c,d){aj();return fj(a,b,c,d)},unstable_discreteUpdates:fj,unstable_flushDiscreteUpdates:aj,flushSync:function(a,
	b){if((U&(Ci|Di))!==T)throw t(Error(187));var c=U;U|=1;try{return vf(99,a.bind(null,b))}finally{U=c,O()}},unstable_createRoot:Lj,unstable_createSyncRoot:Mj,unstable_flushControlled:function(a){var b=U;U|=1;try{vf(99,a)}finally{U=b,U===T&&O()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ca.injectEventPluginsByName,fa,Qa,function(a){ya(a,Pa)},Hb,Ib,Ud,Ba,cj,{current:!1}]}};
	function Lj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Ej(a,null!=b&&!0===b.hydrate)}function Mj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Dj(a,1,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return tj(m({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Xb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=qd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.9.0",
	rendererPackageName:"react-dom"});var Oj={default:Nj},Pj=Oj&&Nj||Oj;module.exports=Pj.default||Pj;


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,n){ true?n(exports,__webpack_require__(1),__webpack_require__(1401)):"function"==typeof define&&define.amd?define(["exports","react","prop-types"],n):n((e=e||self).reactDropzone={},e.React,e.PropTypes)}(this,function(e,ie,n){"use strict";var u="default"in ie?ie.default:ie;function ue(e,n,r){return n in e?Object.defineProperty(e,n,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[n]=r,e}function t(n,e){var r=Object.keys(n);if(Object.getOwnPropertySymbols){var t=Object.getOwnPropertySymbols(n);e&&(t=t.filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable})),r.push.apply(r,t)}return r}function ae(n){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?t(r,!0).forEach(function(e){ue(n,e,r[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(n,Object.getOwnPropertyDescriptors(r)):t(r).forEach(function(e){Object.defineProperty(n,e,Object.getOwnPropertyDescriptor(r,e))})}return n}function ce(e,n){if(null==e)return{};var r,t,o=function(e,n){if(null==e)return{};var r,t,o={},i=Object.keys(e);for(t=0;t<i.length;t++)r=i[t],0<=n.indexOf(r)||(o[r]=e[r]);return o}(e,n);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(t=0;t<i.length;t++)r=i[t],0<=n.indexOf(r)||Object.prototype.propertyIsEnumerable.call(e,r)&&(o[r]=e[r])}return o}function le(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var r=[],t=!0,o=!1,i=void 0;try{for(var u,a=e[Symbol.iterator]();!(t=(u=a.next()).done)&&(r.push(u.value),!n||r.length!==n);t=!0);}catch(e){o=!0,i=e}finally{try{t||null==a.return||a.return()}finally{if(o)throw i}}return r}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function fe(e){return function(e){if(Array.isArray(e)){for(var n=0,r=new Array(e.length);n<e.length;n++)r[n]=e[n];return r}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function l(i,u,a,c){return new(a=a||Promise)(function(e,n){function r(e){try{o(c.next(e))}catch(e){n(e)}}function t(e){try{o(c.throw(e))}catch(e){n(e)}}function o(n){n.done?e(n.value):new a(function(e){e(n.value)}).then(r,t)}o((c=c.apply(i,u||[])).next())})}function f(r,t){var o,i,u,e,a={label:0,sent:function(){if(1&u[0])throw u[1];return u[1]},trys:[],ops:[]};return e={next:n(0),throw:n(1),return:n(2)},"function"==typeof Symbol&&(e[Symbol.iterator]=function(){return this}),e;function n(n){return function(e){return function(n){if(o)throw new TypeError("Generator is already executing.");for(;a;)try{if(o=1,i&&(u=2&n[0]?i.return:n[0]?i.throw||((u=i.return)&&u.call(i),0):i.next)&&!(u=u.call(i,n[1])).done)return u;switch(i=0,u&&(n=[2&n[0],u.value]),n[0]){case 0:case 1:u=n;break;case 4:return a.label++,{value:n[1],done:!1};case 5:a.label++,i=n[1],n=[0];continue;case 7:n=a.ops.pop(),a.trys.pop();continue;default:if(!(u=0<(u=a.trys).length&&u[u.length-1])&&(6===n[0]||2===n[0])){a=0;continue}if(3===n[0]&&(!u||n[1]>u[0]&&n[1]<u[3])){a.label=n[1];break}if(6===n[0]&&a.label<u[1]){a.label=u[1],u=n;break}if(u&&a.label<u[2]){a.label=u[2],a.ops.push(n);break}u[2]&&a.ops.pop(),a.trys.pop();continue}n=t.call(r,a)}catch(e){n=[6,e],i=0}finally{o=u=0}if(5&n[0])throw n[1];return{value:n[0]?n[1]:void 0,done:!0}}([n,e])}}}function r(e,n){var r="function"==typeof Symbol&&e[Symbol.iterator];if(!r)return e;var t,o,i=r.call(e),u=[];try{for(;(void 0===n||0<n--)&&!(t=i.next()).done;)u.push(t.value)}catch(e){o={error:e}}finally{try{t&&!t.done&&(r=i.return)&&r.call(i)}finally{if(o)throw o.error}}return u}function o(){for(var e=[],n=0;n<arguments.length;n++)e=e.concat(r(arguments[n]));return e}n=n&&n.hasOwnProperty("default")?n.default:n;var i=new Map([["avi","video/avi"],["gif","image/gif"],["ico","image/x-icon"],["jpeg","image/jpeg"],["jpg","image/jpeg"],["mkv","video/x-matroska"],["mov","video/quicktime"],["mp4","video/mp4"],["pdf","application/pdf"],["png","image/png"],["zip","application/zip"],["doc","application/msword"],["docx","application/vnd.openxmlformats-officedocument.wordprocessingml.document"]]);function a(e,n){var r=function(e){var n=e.name;if(n&&-1!==n.lastIndexOf(".")&&!e.type){var r=n.split(".").pop().toLowerCase(),t=i.get(r);t&&Object.defineProperty(e,"type",{value:t,writable:!1,configurable:!1,enumerable:!0})}return e}(e);if("string"!=typeof r.path){var t=e.webkitRelativePath;Object.defineProperty(r,"path",{value:"string"==typeof n?n:"string"==typeof t&&0<t.length?t:e.name,writable:!1,configurable:!1,enumerable:!0})}return r}var c=[".DS_Store","Thumbs.db"];function se(n){return l(this,void 0,void 0,function(){return f(this,function(e){return[2,function(e){return!!e.dataTransfer}(n)&&n.dataTransfer?function(r,t){return l(this,void 0,void 0,function(){var n;return f(this,function(e){switch(e.label){case 0:return r.items?(n=p(r.items).filter(function(e){return"file"===e.kind}),"drop"!==t?[2,n]:[4,Promise.all(n.map(d))]):[3,2];case 1:return[2,s(function r(e){return e.reduce(function(e,n){return o(e,Array.isArray(n)?r(n):[n])},[])}(e.sent()))];case 2:return[2,s(p(r.files).map(function(e){return a(e)}))]}})})}(n.dataTransfer,n.type):function(e){return(function(e){return null!==e}(e.target)&&e.target.files?p(e.target.files):[]).map(function(e){return a(e)})}(n)]})})}function s(e){return e.filter(function(e){return-1===c.indexOf(e.name)})}function p(e){for(var n=[],r=0;r<e.length;r++){var t=e[r];n.push(t)}return n}function d(e){if("function"!=typeof e.webkitGetAsEntry)return v(e);var n=e.webkitGetAsEntry();return n&&n.isDirectory?y(n):v(e)}function v(e){var n=e.getAsFile();if(!n)return Promise.reject(e+" is not a File");var r=a(n);return Promise.resolve(r)}function g(n){return l(this,void 0,void 0,function(){return f(this,function(e){return[2,n.isDirectory?y(n):function(t){return l(this,void 0,void 0,function(){return f(this,function(e){return[2,new Promise(function(r,n){t.file(function(e){var n=a(e,t.fullPath);r(n)},function(e){n(e)})})]})})}(n)]})})}function y(e){var n=e.createReader();return new Promise(function(u,a){var c=[];!function i(){var e=this;n.readEntries(function(o){return l(e,void 0,void 0,function(){var n,r,t;return f(this,function(e){switch(e.label){case 0:if(o.length)return[3,5];e.label=1;case 1:return e.trys.push([1,3,,4]),[4,Promise.all(c)];case 2:return n=e.sent(),u(n),[3,4];case 3:return r=e.sent(),a(r),[3,4];case 4:return[3,6];case 5:t=Promise.all(o.map(g)),c.push(t),i(),e.label=6;case 6:return[2]}})})},function(e){a(e)})}()})}var b,m,h=(function(e){function t(e){if(o[e])return o[e].exports;var n=o[e]={i:e,l:!1,exports:{}};return r[e].call(n.exports,n,n.exports,t),n.l=!0,n.exports}var r,o;e.exports=(o={},t.m=r=[function(e,n,r){n.__esModule=!0,n.default=function(e,n){if(e&&n){var r=Array.isArray(n)?n:n.split(","),t=e.name||"",o=e.type||"",i=o.replace(/\/.*$/,"");return r.some(function(e){var n=e.trim();return"."===n.charAt(0)?t.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0}}],t.c=o,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0))}(b={exports:{}},b.exports),b.exports),D=(m=h)&&m.__esModule&&Object.prototype.hasOwnProperty.call(m,"default")?m.default:m;function pe(e,n){return"application/x-moz-file"===e.type||D(e,n)}function de(e,n,r){if(w(e.size)){if(w(n)&&w(r))return e.size>=n&&e.size<=r;if(w(n))return e.size>=n;if(w(r))return e.size<=r}return!0}function w(e){return null!=e}function ve(e){return"function"==typeof e.isPropagationStopped?e.isPropagationStopped():void 0!==e.cancelBubble&&e.cancelBubble}function ge(e){return e.dataTransfer?Array.prototype.some.call(e.dataTransfer.types,function(e){return"Files"===e||"application/x-moz-file"===e}):!!e.target&&!!e.target.files}function ye(e){e.preventDefault()}function be(e){var n=0<arguments.length&&void 0!==e?e:window.navigator.userAgent;return function(e){return-1!==e.indexOf("MSIE")||-1!==e.indexOf("Trident/")}(n)||function(e){return-1!==e.indexOf("Edge/")}(n)}function me(){for(var e=arguments.length,o=new Array(e),n=0;n<e;n++)o[n]=arguments[n];return function(n){for(var e=arguments.length,r=new Array(1<e?e-1:0),t=1;t<e;t++)r[t-1]=arguments[t];return o.some(function(e){return!ve(n)&&e&&e.apply(void 0,[n].concat(r)),ve(n)})}}var O=ie.forwardRef(function(e,n){var r=e.children,t=F(ce(e,["children"])),o=t.open,i=ce(t,["open"]);return ie.useImperativeHandle(n,function(){return{open:o}},[o]),u.createElement(ie.Fragment,null,r(ae({},i,{open:o})))});O.displayName="Dropzone";var he={isFocused:!(O.propTypes={children:n.func,accept:n.oneOfType([n.string,n.arrayOf(n.string)]),multiple:n.bool,preventDropOnDocument:n.bool,noClick:n.bool,noKeyboard:n.bool,noDrag:n.bool,noDragEventsBubbling:n.bool,minSize:n.number,maxSize:n.number,disabled:n.bool,getFilesFromEvent:n.func,onFileDialogCancel:n.func,onDragEnter:n.func,onDragLeave:n.func,onDragOver:n.func,onDrop:n.func,onDropAccepted:n.func,onDropRejected:n.func}),isFileDialogActive:!1,isDragActive:!1,isDragAccept:!1,isDragReject:!1,draggedFiles:[],acceptedFiles:[],rejectedFiles:[]};function F(){function e(){I&&setTimeout(function(){S.current&&(S.current.files.length||(R({type:"closeDialog"}),"function"==typeof h&&h()))},300)}var n=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},u=n.accept,r=n.disabled,p=void 0!==r&&r,t=n.getFilesFromEvent,o=void 0===t?se:t,i=n.maxSize,a=void 0===i?1/0:i,c=n.minSize,l=void 0===c?0:c,f=n.multiple,s=void 0===f||f,d=n.onDragEnter,v=n.onDragLeave,g=n.onDragOver,y=n.onDrop,b=n.onDropAccepted,m=n.onDropRejected,h=n.onFileDialogCancel,D=n.preventDropOnDocument,w=void 0===D||D,O=n.noClick,F=void 0!==O&&O,j=n.noKeyboard,x=void 0!==j&&j,P=n.noDrag,A=void 0!==P&&P,k=n.noDragEventsBubbling,E=void 0!==k&&k,C=ie.useRef(null),S=ie.useRef(null),T=le(ie.useReducer(De,he),2),z=T[0],R=T[1],L=z.isFocused,I=z.isFileDialogActive,K=z.draggedFiles,_=ie.useCallback(function(){S.current&&(R({type:"openDialog"}),S.current.value=null,S.current.click())},[R]);ie.useEffect(function(){return window.addEventListener("focus",e,!1),function(){window.removeEventListener("focus",e,!1)}},[S,I,h]);function M(e){C.current&&C.current.contains(e.target)||(e.preventDefault(),W.current=[])}var B=ie.useCallback(function(e){C.current&&C.current.isEqualNode(e.target)&&(32!==e.keyCode&&13!==e.keyCode||(e.preventDefault(),_()))},[C,S]),q=ie.useCallback(function(){R({type:"focus"})},[]),G=ie.useCallback(function(){R({type:"blur"})},[]),N=ie.useCallback(function(){F||(be()?setTimeout(_,0):_())},[S,F]),W=ie.useRef([]);ie.useEffect(function(){return w&&(document.addEventListener("dragover",ye,!1),document.addEventListener("drop",M,!1)),function(){w&&(document.removeEventListener("dragover",ye),document.removeEventListener("drop",M))}},[C,w]);function $(e){return p?null:e}function H(e){return x?null:$(e)}function J(e){return A?null:$(e)}var Q=ie.useCallback(function(n){n.preventDefault(),n.persist(),Y(n),-1===W.current.indexOf(n.target)&&(W.current=[].concat(fe(W.current),[n.target])),ge(n)&&Promise.resolve(o(n)).then(function(e){ve(n)&&!E||(R({draggedFiles:e,isDragActive:!0,type:"setDraggedFiles"}),d&&d(n))})},[o,d,E]),U=ie.useCallback(function(e){if(e.preventDefault(),e.persist(),Y(e),e.dataTransfer)try{e.dataTransfer.dropEffect="copy"}catch(e){}return ge(e)&&g&&g(e),!1},[g,E]),V=ie.useCallback(function(n){n.preventDefault(),n.persist(),Y(n);var e=W.current.filter(function(e){return e!==n.target&&C.current&&C.current.contains(e)});0<(W.current=e).length||(R({isDragActive:!1,type:"setDraggedFiles",draggedFiles:[]}),ge(n)&&v&&v(n))},[C,v,E]),X=ie.useCallback(function(t){t.preventDefault(),t.persist(),Y(t),W.current=[],R({type:"reset"}),ge(t)&&Promise.resolve(o(t)).then(function(e){if(!ve(t)||E){var n=[],r=[];e.forEach(function(e){pe(e,u)&&de(e,l,a)?n.push(e):r.push(e)}),!s&&1<n.length&&r.push.apply(r,fe(n.splice(0))),R({acceptedFiles:n,rejectedFiles:r,type:"setFiles"}),y&&y(n,r,t),0<r.length&&m&&m(r,t),0<n.length&&b&&b(n,t)}})},[s,u,l,a,o,y,b,m,E]),Y=function(e){E&&e.stopPropagation()},Z=ie.useMemo(function(){return function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},n=e.refKey,r=void 0===n?"ref":n,t=e.onKeyDown,o=e.onFocus,i=e.onBlur,u=e.onClick,a=e.onDragEnter,c=e.onDragOver,l=e.onDragLeave,f=e.onDrop,s=ce(e,["refKey","onKeyDown","onFocus","onBlur","onClick","onDragEnter","onDragOver","onDragLeave","onDrop"]);return ae(ue({onKeyDown:H(me(t,B)),onFocus:H(me(o,q)),onBlur:H(me(i,G)),onClick:$(me(u,N)),onDragEnter:J(me(a,Q)),onDragOver:J(me(c,U)),onDragLeave:J(me(l,V)),onDrop:J(me(f,X))},r,C),p||x?{}:{tabIndex:0},{},s)}},[C,B,q,G,N,Q,U,V,X,x,A,p]),ee=ie.useCallback(function(e){e.stopPropagation()},[]),ne=ie.useMemo(function(){return function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},n=e.refKey,r=void 0===n?"ref":n,t=e.onChange,o=e.onClick,i=ce(e,["refKey","onChange","onClick"]);return ae({},ue({accept:u,multiple:s,type:"file",style:{display:"none"},onChange:$(me(t,X)),onClick:$(me(o,ee)),autoComplete:"off",tabIndex:-1},r,S),{},i)}},[S,u,s,X,p]),re=K.length,te=s||re<=1,oe=0<re&&function(e,n,r,t){return e.every(function(e){return pe(e,n)&&de(e,r,t)})}(K,u,l,a);return ae({},z,{isDragAccept:oe,isDragReject:0<re&&(!oe||!te),isFocused:L&&!p,getRootProps:Z,getInputProps:ne,rootRef:C,inputRef:S,open:$(_)})}function De(e,n){switch(n.type){case"focus":return ae({},e,{isFocused:!0});case"blur":return ae({},e,{isFocused:!1});case"openDialog":return ae({},e,{isFileDialogActive:!0});case"closeDialog":return ae({},e,{isFileDialogActive:!1});case"setDraggedFiles":var r=n.isDragActive;return ae({},e,{draggedFiles:n.draggedFiles,isDragActive:r});case"setFiles":return ae({},e,{acceptedFiles:n.acceptedFiles,rejectedFiles:n.rejectedFiles});case"reset":return ae({},e,{isFileDialogActive:!1,isDragActive:!1,draggedFiles:[]});default:return e}}e.default=O,e.useDropzone=F,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ },
/* 1400 */
[1912, 1402],
/* 1401 */
[1913, 1400],
/* 1402 */
918,
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var message_1 = __webpack_require__(592);
	var injectIntl_1 = __webpack_require__(84);
	var utils_1 = __webpack_require__(50);
	var FormattedHTMLMessage = /** @class */ (function (_super) {
	    __extends(FormattedHTMLMessage, _super);
	    function FormattedHTMLMessage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FormattedHTMLMessage.prototype.render = function () {
	        var _this = this;
	        return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	            if (!_this.props.defaultMessage) {
	                utils_1.invariantIntlContext(intl);
	            }
	            var formatHTMLMessage = intl.formatHTMLMessage, textComponent = intl.textComponent;
	            var _a = _this.props, id = _a.id, description = _a.description, defaultMessage = _a.defaultMessage, rawValues = _a.values, children = _a.children;
	            var Component = _this.props.tagName;
	            // This is bc of TS3.3 doesn't recognize `defaultProps`
	            if (!Component) {
	                Component = textComponent || 'span';
	            }
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            var html = { __html: formattedHTMLMessage };
	            return React.createElement(Component, { dangerouslySetInnerHTML: html });
	        }));
	    };
	    FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	    FormattedHTMLMessage.defaultProps = __assign(__assign({}, message_1.default.defaultProps), { tagName: 'span' });
	    return FormattedHTMLMessage;
	}(message_1.default));
	exports.default = FormattedHTMLMessage;


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(84);
	var FormattedPlural = function (props) {
	    var value = props.value, other = props.other, children = props.children, _a = props.intl, formatPlural = _a.formatPlural, Text = _a.textComponent;
	    var pluralCategory = formatPlural(value, props);
	    var formattedPlural = props[pluralCategory] || other;
	    if (typeof children === 'function') {
	        return children(formattedPlural);
	    }
	    if (Text) {
	        return React.createElement(Text, null, formattedPlural);
	    }
	    // Work around @types/react where React.FC cannot return string
	    return formattedPlural;
	};
	FormattedPlural.defaultProps = {
	    type: 'cardinal',
	};
	FormattedPlural.displayName = 'FormattedPlural';
	exports.default = injectIntl_1.default(FormattedPlural);


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(84);
	var utils_1 = __webpack_require__(50);
	var intl_locales_supported_1 = __webpack_require__(1247);
	var number_1 = __webpack_require__(1411);
	var relativeTime_1 = __webpack_require__(1413);
	var dateTime_1 = __webpack_require__(1409);
	var plural_1 = __webpack_require__(1412);
	var message_1 = __webpack_require__(593);
	var shallowEquals_ = __webpack_require__(648);
	var list_1 = __webpack_require__(1410);
	var shallowEquals = shallowEquals_.default || shallowEquals_;
	function processIntlConfig(config) {
	    return {
	        locale: config.locale,
	        timeZone: config.timeZone,
	        formats: config.formats,
	        textComponent: config.textComponent,
	        messages: config.messages,
	        defaultLocale: config.defaultLocale,
	        defaultFormats: config.defaultFormats,
	        onError: config.onError,
	    };
	}
	/**
	 * Create intl object
	 * @param config intl config
	 * @param cache cache for formatter instances to prevent memory leak
	 */
	function createIntl(config, cache) {
	    var formatters = utils_1.createFormatters(cache);
	    var resolvedConfig = __assign(__assign({}, utils_1.DEFAULT_INTL_CONFIG), config);
	    if (!resolvedConfig.locale ||
	        !intl_locales_supported_1.default(resolvedConfig.locale)) {
	        var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
	        if (typeof onError === 'function') {
	            onError(utils_1.createError("Missing locale data for locale: \"" + locale + "\". " +
	                ("Using default locale: \"" + defaultLocale + "\" as fallback.")));
	        }
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
	    }
	    return __assign(__assign({}, resolvedConfig), { formatters: formatters, formatNumber: number_1.formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: number_1.formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: relativeTime_1.formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: dateTime_1.formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: dateTime_1.formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: dateTime_1.formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: dateTime_1.formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: plural_1.formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: message_1.formatMessage.bind(null, resolvedConfig, formatters), formatHTMLMessage: message_1.formatHTMLMessage.bind(null, resolvedConfig, formatters), formatList: list_1.formatList.bind(null, resolvedConfig, formatters.getListFormat) });
	}
	exports.createIntl = createIntl;
	var IntlProvider = /** @class */ (function (_super) {
	    __extends(IntlProvider, _super);
	    function IntlProvider() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cache = utils_1.createIntlCache();
	        _this.state = {
	            cache: _this.cache,
	            intl: createIntl(processIntlConfig(_this.props), _this.cache),
	            prevConfig: processIntlConfig(_this.props),
	        };
	        return _this;
	    }
	    IntlProvider.getDerivedStateFromProps = function (props, _a) {
	        var prevConfig = _a.prevConfig, cache = _a.cache;
	        var config = processIntlConfig(props);
	        if (!shallowEquals(prevConfig, config)) {
	            return {
	                intl: createIntl(config, cache),
	                prevConfig: config,
	            };
	        }
	        return null;
	    };
	    IntlProvider.prototype.render = function () {
	        utils_1.invariantIntlContext(this.state.intl);
	        return React.createElement(injectIntl_1.Provider, { value: this.state.intl }, this.props.children);
	    };
	    IntlProvider.displayName = 'IntlProvider';
	    IntlProvider.defaultProps = utils_1.DEFAULT_INTL_CONFIG;
	    return IntlProvider;
	}(React.PureComponent));
	exports.default = IntlProvider;


/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var React = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(84);
	var utils_1 = __webpack_require__(50);
	var intl_utils_1 = __webpack_require__(218);
	var MINUTE = 60;
	var HOUR = 60 * 60;
	var DAY = 60 * 60 * 24;
	function selectUnit(seconds) {
	    var absValue = Math.abs(seconds);
	    if (absValue < MINUTE) {
	        return 'second';
	    }
	    if (absValue < HOUR) {
	        return 'minute';
	    }
	    if (absValue < DAY) {
	        return 'hour';
	    }
	    return 'day';
	}
	function getDurationInSeconds(unit) {
	    switch (unit) {
	        case 'second':
	            return 1;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        default:
	            return DAY;
	    }
	}
	function valueToSeconds(value, unit) {
	    if (!value) {
	        return 0;
	    }
	    switch (unit) {
	        case 'second':
	            return value;
	        case 'minute':
	            return value * MINUTE;
	        default:
	            return value * HOUR;
	    }
	}
	var INCREMENTABLE_UNITS = ['second', 'minute', 'hour'];
	function canIncrement(unit) {
	    if (unit === void 0) { unit = 'second'; }
	    return INCREMENTABLE_UNITS.includes(unit);
	}
	var FormattedRelativeTime = /** @class */ (function (_super) {
	    __extends(FormattedRelativeTime, _super);
	    function FormattedRelativeTime(props) {
	        var _this = _super.call(this, props) || this;
	        // Public for testing
	        _this._updateTimer = null;
	        _this.state = {
	            prevUnit: _this.props.unit,
	            prevValue: _this.props.value,
	            currentValueInSeconds: canIncrement(_this.props.unit)
	                ? valueToSeconds(_this.props.value, _this.props.unit)
	                : 0,
	        };
	        intl_utils_1.invariant(!props.updateIntervalInSeconds ||
	            !!(props.updateIntervalInSeconds && canIncrement(props.unit)), 'Cannot schedule update with unit longer than hour');
	        return _this;
	    }
	    FormattedRelativeTime.prototype.scheduleNextUpdate = function (_a, _b) {
	        var _this = this;
	        var updateIntervalInSeconds = _a.updateIntervalInSeconds, unit = _a.unit;
	        var currentValueInSeconds = _b.currentValueInSeconds;
	        clearTimeout(this._updateTimer);
	        this._updateTimer = null;
	        // If there's no interval and we cannot increment this unit, do nothing
	        if (!updateIntervalInSeconds || !canIncrement(unit)) {
	            return;
	        }
	        // Figure out the next interesting time
	        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
	        var nextUnit = selectUnit(nextValueInSeconds);
	        // We've reached the max auto incrementable unit, don't schedule another update
	        if (nextUnit === 'day') {
	            return;
	        }
	        var unitDuration = getDurationInSeconds(nextUnit);
	        var remainder = nextValueInSeconds % unitDuration;
	        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
	        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds
	            ? prevInterestingValueInSeconds - unitDuration
	            : prevInterestingValueInSeconds;
	        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
	        this._updateTimer = setTimeout(function () {
	            return _this.setState({
	                currentValueInSeconds: nextInterestingValueInSeconds,
	            });
	        }, delayInSeconds * 1e3);
	    };
	    FormattedRelativeTime.prototype.componentDidMount = function () {
	        this.scheduleNextUpdate(this.props, this.state);
	    };
	    FormattedRelativeTime.prototype.componentDidUpdate = function () {
	        this.scheduleNextUpdate(this.props, this.state);
	    };
	    FormattedRelativeTime.prototype.componentWillUnmount = function () {
	        clearTimeout(this._updateTimer);
	        this._updateTimer = null;
	    };
	    FormattedRelativeTime.getDerivedStateFromProps = function (props, state) {
	        if (props.unit !== state.prevUnit || props.value !== state.prevValue) {
	            return {
	                prevValue: props.value,
	                prevUnit: props.unit,
	                currentValueInSeconds: canIncrement(props.unit)
	                    ? valueToSeconds(props.value, props.unit)
	                    : 0,
	            };
	        }
	        return null;
	    };
	    FormattedRelativeTime.prototype.render = function () {
	        var _this = this;
	        return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	            utils_1.invariantIntlContext(intl);
	            var formatRelativeTime = intl.formatRelativeTime, Text = intl.textComponent;
	            var _a = _this.props, children = _a.children, value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds;
	            var currentValueInSeconds = _this.state.currentValueInSeconds;
	            var currentValue = value || 0;
	            var currentUnit = unit;
	            if (canIncrement(unit) &&
	                typeof currentValueInSeconds === 'number' &&
	                updateIntervalInSeconds) {
	                currentUnit = selectUnit(currentValueInSeconds);
	                var unitDuration = getDurationInSeconds(currentUnit);
	                currentValue = Math.round(currentValueInSeconds / unitDuration);
	            }
	            var formattedRelativeTime = formatRelativeTime(currentValue, currentUnit, __assign({}, _this.props));
	            if (typeof children === 'function') {
	                return children(formattedRelativeTime);
	            }
	            if (Text) {
	                return React.createElement(Text, null, formattedRelativeTime);
	            }
	            return formattedRelativeTime;
	        }));
	    };
	    FormattedRelativeTime.displayName = 'FormattedRelativeTime';
	    FormattedRelativeTime.defaultProps = {
	        value: 0,
	        unit: 'second',
	    };
	    return FormattedRelativeTime;
	}(React.PureComponent));
	exports.FormattedRelativeTime = FormattedRelativeTime;
	exports.default = FormattedRelativeTime;


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(84);
	var utils_1 = __webpack_require__(50);
	function useIntl() {
	    var intl = react_1.useContext(injectIntl_1.Context);
	    utils_1.invariantIntlContext(intl);
	    return intl;
	}
	exports.default = useIntl;


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(50);
	var DATE_TIME_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'formatMatcher',
	    'timeZone',
	    'hour12',
	    'weekday',
	    'era',
	    'year',
	    'month',
	    'day',
	    'hour',
	    'minute',
	    'second',
	    'timeZoneName',
	];
	function getFormatter(_a, type, getDateTimeFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = __assign(__assign({}, (timeZone && { timeZone: timeZone })), (format && utils_1.getNamedFormat(formats, type, format, onError)));
	    var filteredOptions = utils_1.filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	    if (type === 'time' &&
	        !filteredOptions.hour &&
	        !filteredOptions.minute &&
	        !filteredOptions.second) {
	        // Add default formatting options if hour, minute, or second isn't defined.
	        filteredOptions = __assign(__assign({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
	    }
	    return getDateTimeFormat(locale, filteredOptions);
	}
	exports.getFormatter = getFormatter;
	function formatDate(config, getDateTimeFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'date', getDateTimeFormat, options).format(date);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting date.', e));
	    }
	    return String(date);
	}
	exports.formatDate = formatDate;
	function formatTime(config, getDateTimeFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'time', getDateTimeFormat, options).format(date);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting time.', e));
	    }
	    return String(date);
	}
	exports.formatTime = formatTime;
	function formatDateToParts(config, getDateTimeFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting date.', e));
	    }
	    return [];
	}
	exports.formatDateToParts = formatDateToParts;
	function formatTimeToParts(config, getDateTimeFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting time.', e));
	    }
	    return [];
	}
	exports.formatTimeToParts = formatTimeToParts;


/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(50);
	var LIST_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'type',
	    'style',
	];
	var now = Date.now();
	function generateToken(i) {
	    return now + "_" + i + "_" + now;
	}
	function formatList(_a, getListFormat, values, options) {
	    var locale = _a.locale, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var ListFormat = Intl.ListFormat;
	    if (!ListFormat) {
	        onError(utils_1.createError("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n"));
	    }
	    var filteredOptions = utils_1.filterProps(options, LIST_FORMAT_OPTIONS);
	    try {
	        var richValues_1 = {};
	        var serializedValues = values.map(function (v, i) {
	            if (typeof v === 'object') {
	                var id = generateToken(i);
	                richValues_1[id] = v;
	                return id;
	            }
	            return String(v);
	        });
	        if (!Object.keys(richValues_1).length) {
	            return getListFormat(locale, filteredOptions).format(serializedValues);
	        }
	        var parts = getListFormat(locale, filteredOptions).formatToParts(serializedValues);
	        return parts.reduce(function (all, el) {
	            var val = el.value;
	            if (richValues_1[val]) {
	                all.push(richValues_1[val]);
	            }
	            else if (typeof all[all.length - 1] === 'string') {
	                all[all.length - 1] += val;
	            }
	            else {
	                all.push(val);
	            }
	            return all;
	        }, []);
	    }
	    catch (e) {
	        onError(utils_1.createError('Error formatting list.', e));
	    }
	    return values;
	}
	exports.formatList = formatList;


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(50);
	var NUMBER_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'style',
	    'currency',
	    'currencyDisplay',
	    'unit',
	    'unitDisplay',
	    'useGrouping',
	    'minimumIntegerDigits',
	    'minimumFractionDigits',
	    'maximumFractionDigits',
	    'minimumSignificantDigits',
	    'maximumSignificantDigits',
	    // Unified NumberFormat (Stage 3 as of 10/22/19)
	    'compactDisplay',
	    'currencyDisplay',
	    'currencySign',
	    'notation',
	    'signDisplay',
	    'unit',
	    'unitDisplay',
	];
	function getFormatter(_a, getNumberFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = ((format &&
	        utils_1.getNamedFormat(formats, 'number', format, onError)) ||
	        {});
	    var filteredOptions = utils_1.filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
	    return getNumberFormat(locale, filteredOptions);
	}
	exports.getFormatter = getFormatter;
	function formatNumber(config, getNumberFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    try {
	        return getFormatter(config, getNumberFormat, options).format(value);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting number.', e));
	    }
	    return String(value);
	}
	exports.formatNumber = formatNumber;
	function formatNumberToParts(config, getNumberFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    try {
	        return getFormatter(config, getNumberFormat, options).formatToParts(value);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting number.', e));
	    }
	    return [];
	}
	exports.formatNumberToParts = formatNumberToParts;


/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(50);
	var PLURAL_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'type',
	];
	function formatPlural(_a, getPluralRules, value, options) {
	    var locale = _a.locale, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    if (!Intl.PluralRules) {
	        onError(utils_1.createError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n"));
	    }
	    var filteredOptions = utils_1.filterProps(options, PLURAL_FORMAT_OPTIONS);
	    try {
	        return getPluralRules(locale, filteredOptions).select(value);
	    }
	    catch (e) {
	        onError(utils_1.createError('Error formatting plural.', e));
	    }
	    return 'other';
	}
	exports.formatPlural = formatPlural;


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(50);
	var RELATIVE_TIME_FORMAT_OPTIONS = [
	    'numeric',
	    'style',
	];
	function getFormatter(_a, getRelativeTimeFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = (!!format && utils_1.getNamedFormat(formats, 'relative', format, onError)) || {};
	    var filteredOptions = utils_1.filterProps(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
	    return getRelativeTimeFormat(locale, filteredOptions);
	}
	function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
	    if (options === void 0) { options = {}; }
	    if (!unit) {
	        unit = 'second';
	    }
	    var RelativeTimeFormat = Intl.RelativeTimeFormat;
	    if (!RelativeTimeFormat) {
	        config.onError(utils_1.createError("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n"));
	    }
	    try {
	        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting relative time.', e));
	    }
	    return String(value);
	}
	exports.formatRelativeTime = formatRelativeTime;


/***/ },
/* 1414 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(6));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(90));
	var _inheritsLoose = _interopDefault(__webpack_require__(156));
	var react = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(1417));
	var ResizeObserver = _interopDefault(__webpack_require__(1755));
	
	var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
	function getTypes(props) {
	  var allowedTypes = [];
	  types.forEach(function (type) {
	    if (props[type]) {
	      allowedTypes.push(type);
	    }
	  });
	  return allowedTypes;
	}
	
	function getContentRect(node, types) {
	  var calculations = {};
	
	  if (types.indexOf('client') > -1) {
	    calculations.client = {
	      top: node.clientTop,
	      left: node.clientLeft,
	      width: node.clientWidth,
	      height: node.clientHeight
	    };
	  }
	
	  if (types.indexOf('offset') > -1) {
	    calculations.offset = {
	      top: node.offsetTop,
	      left: node.offsetLeft,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    };
	  }
	
	  if (types.indexOf('scroll') > -1) {
	    calculations.scroll = {
	      top: node.scrollTop,
	      left: node.scrollLeft,
	      width: node.scrollWidth,
	      height: node.scrollHeight
	    };
	  }
	
	  if (types.indexOf('bounds') > -1) {
	    var rect = node.getBoundingClientRect();
	    calculations.bounds = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.width,
	      height: rect.height
	    };
	  }
	
	  if (types.indexOf('margin') > -1) {
	    var styles = getComputedStyle(node);
	    calculations.margin = {
	      top: styles ? parseInt(styles.marginTop) : 0,
	      right: styles ? parseInt(styles.marginRight) : 0,
	      bottom: styles ? parseInt(styles.marginBottom) : 0,
	      left: styles ? parseInt(styles.marginLeft) : 0
	    };
	  }
	
	  return calculations;
	}
	
	function withContentRect(types) {
	  return function (WrappedComponent) {
	    var _class, _temp;
	
	    return _temp = _class =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithContentRect, _Component);
	
	      function WithContentRect() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          contentRect: {
	            entry: {},
	            client: {},
	            offset: {},
	            scroll: {},
	            bounds: {},
	            margin: {}
	          }
	        };
	        _this._animationFrameID = null;
	        _this._resizeObserver = null;
	        _this._node = null;
	        _this._firstResize = true;
	
	        _this.measure = function (entries) {
	          var contentRect = getContentRect(_this._node, types || getTypes(_this.props));
	
	          if (entries) {
	            contentRect.entry = entries[0].contentRect;
	          }
	
	          _this._animationFrameID = window.requestAnimationFrame(function () {
	            if (_this._resizeObserver !== null && !_this._firstResize) {
	              _this.setState({
	                contentRect: contentRect
	              });
	
	              if (typeof _this.props.onResize === 'function') {
	                _this.props.onResize(contentRect);
	              }
	            }
	
	            _this._firstResize = false;
	          });
	        };
	
	        _this._handleRef = function (node) {
	          if (_this._resizeObserver !== null && _this._node !== null) {
	            _this._resizeObserver.unobserve(_this._node);
	          }
	
	          _this._node = node;
	
	          if (_this._resizeObserver !== null && _this._node !== null) {
	            _this._resizeObserver.observe(_this._node);
	          }
	
	          var innerRef = _this.props.innerRef;
	
	          if (innerRef) {
	            if (typeof innerRef === 'function') {
	              innerRef(_this._node);
	            } else {
	              innerRef.current = _this._node;
	            }
	          }
	        };
	
	        return _this;
	      }
	
	      var _proto = WithContentRect.prototype;
	
	      _proto.componentDidMount = function componentDidMount() {
	        this._resizeObserver = new ResizeObserver(this.measure);
	
	        if (this._node !== null) {
	          this._resizeObserver.observe(this._node);
	
	          if (typeof this.props.onResize === 'function') {
	            this.props.onResize(getContentRect(this._node, types || getTypes(this.props)));
	          }
	        }
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this._resizeObserver !== null) {
	          this._resizeObserver.disconnect();
	
	          this._resizeObserver = null;
	        }
	
	        window.cancelAnimationFrame(this._animationFrameID);
	      };
	
	      _proto.render = function render() {
	        var _this$props = this.props,
	            innerRef = _this$props.innerRef,
	            onResize = _this$props.onResize,
	            props = _objectWithoutPropertiesLoose(_this$props, ["innerRef", "onResize"]);
	
	        return react.createElement(WrappedComponent, _extends({}, props, {
	          measureRef: this._handleRef,
	          measure: this.measure,
	          contentRect: this.state.contentRect
	        }));
	      };
	
	      return WithContentRect;
	    }(react.Component), _class.propTypes = {
	      client: PropTypes.bool,
	      offset: PropTypes.bool,
	      scroll: PropTypes.bool,
	      bounds: PropTypes.bool,
	      margin: PropTypes.bool,
	      innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	      onResize: PropTypes.func
	    }, _temp;
	  };
	}
	
	var Measure = withContentRect()(function (_ref) {
	  var measure = _ref.measure,
	      measureRef = _ref.measureRef,
	      contentRect = _ref.contentRect,
	      children = _ref.children;
	  return children({
	    measure: measure,
	    measureRef: measureRef,
	    contentRect: contentRect
	  });
	});
	Measure.displayName = 'Measure';
	Measure.propTypes.children = PropTypes.func;
	
	exports.default = Measure;
	exports.withContentRect = withContentRect;


/***/ },
/* 1416 */
[1912, 1418],
/* 1417 */
[1913, 1416],
/* 1418 */
918,
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	var HTMLDOMPropertyConfig = __webpack_require__(1420);
	var SVGDOMPropertyConfig = __webpack_require__(1421);
	var injection = __webpack_require__(1422);
	
	var MUST_USE_PROPERTY = injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	/**
	 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L14-L16
	 *
	 * @param  {Number}  value
	 * @param  {Number}  bitmask
	 * @return {Boolean}
	 */
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/**
	 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L57
	 *
	 * @param {Object}  domPropertyConfig - HTMLDOMPropertyConfig or SVGDOMPropertyConfig
	 * @param {Object}  config            - The object to be mutated
	 * @param {Boolean} isSVG             - Whether the injected config is HTML or SVG (it assumes the default is HTML)
	 */
	function injectDOMPropertyConfig(domPropertyConfig, config, isSVG) {
	  var Properties = domPropertyConfig.Properties;
	  var DOMAttributeNames = domPropertyConfig.DOMAttributeNames;
	  var attributeName;
	  var propertyName;
	  var propConfig;
	
	  for (propertyName in Properties) {
	    attributeName =
	      DOMAttributeNames[propertyName] ||
	      (isSVG ? propertyName : propertyName.toLowerCase());
	    propConfig = Properties[propertyName];
	
	    config[attributeName] = {
	      attributeName: attributeName,
	      propertyName: propertyName,
	      mustUseProperty: checkMask(propConfig, MUST_USE_PROPERTY),
	      hasBooleanValue: checkMask(propConfig, HAS_BOOLEAN_VALUE),
	      hasNumericValue: checkMask(propConfig, HAS_NUMERIC_VALUE),
	      hasPositiveNumericValue: checkMask(
	        propConfig,
	        HAS_POSITIVE_NUMERIC_VALUE
	      ),
	      hasOverloadedBooleanValue: checkMask(
	        propConfig,
	        HAS_OVERLOADED_BOOLEAN_VALUE
	      )
	    };
	  }
	}
	
	/**
	 * HTML properties config.
	 *
	 * @type {Object}
	 */
	var html = {};
	injectDOMPropertyConfig(HTMLDOMPropertyConfig, html);
	
	/**
	 * SVG properties config.
	 *
	 * @type {Object}
	 */
	var svg = {};
	injectDOMPropertyConfig(SVGDOMPropertyConfig, svg, true);
	
	/**
	 * HTML and SVG properties config.
	 *
	 * @type {Object}
	 */
	var properties = {};
	injectDOMPropertyConfig(HTMLDOMPropertyConfig, properties);
	injectDOMPropertyConfig(SVGDOMPropertyConfig, properties, true);
	
	var ATTRIBUTE_NAME_START_CHAR =
	  ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR =
	  ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	
	module.exports = {
	  html: html,
	  svg: svg,
	  properties: properties,
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   *
	   * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
	   *
	   * @param {String}
	   * @return {Boolean}
	   */
	  isCustomAttribute: RegExp.prototype.test.bind(
	    new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$')
	  )
	};


/***/ },
/* 1420 */
/***/ function(module, exports) {

	module.exports = {
	  Properties: {
	    autoFocus: 4,
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: 4,
	    allowTransparency: 0,
	    alt: 0,
	    as: 0,
	    async: 4,
	    autoComplete: 0,
	    autoPlay: 4,
	    capture: 4,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: 5,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: 24,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: 4,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0,
	    dateTime: 0,
	    default: 4,
	    defer: 4,
	    dir: 0,
	    disabled: 4,
	    download: 32,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: 4,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: 4,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: 4,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    multiple: 5,
	    muted: 5,
	    name: 0,
	    nonce: 0,
	    noValidate: 4,
	    open: 4,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: 4,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: 4,
	    referrerPolicy: 0,
	    rel: 0,
	    required: 4,
	    reversed: 4,
	    role: 0,
	    rows: 24,
	    rowSpan: 8,
	    sandbox: 0,
	    scope: 0,
	    scoped: 4,
	    scrolling: 0,
	    seamless: 4,
	    selected: 5,
	    shape: 0,
	    size: 24,
	    sizes: 0,
	    span: 24,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: 8,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    property: 0,
	    resource: 0,
	    typeof: 0,
	    vocab: 0,
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    autoSave: 0,
	    color: 0,
	    itemProp: 0,
	    itemScope: 4,
	    itemType: 0,
	    itemID: 0,
	    itemRef: 0,
	    results: 0,
	    security: 0,
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  }
	};


/***/ },
/* 1421 */
/***/ function(module, exports) {

	module.exports = {
	  Properties: {
	    accentHeight: 0,
	    accumulate: 0,
	    additive: 0,
	    alignmentBaseline: 0,
	    allowReorder: 0,
	    alphabetic: 0,
	    amplitude: 0,
	    arabicForm: 0,
	    ascent: 0,
	    attributeName: 0,
	    attributeType: 0,
	    autoReverse: 0,
	    azimuth: 0,
	    baseFrequency: 0,
	    baseProfile: 0,
	    baselineShift: 0,
	    bbox: 0,
	    begin: 0,
	    bias: 0,
	    by: 0,
	    calcMode: 0,
	    capHeight: 0,
	    clip: 0,
	    clipPath: 0,
	    clipRule: 0,
	    clipPathUnits: 0,
	    colorInterpolation: 0,
	    colorInterpolationFilters: 0,
	    colorProfile: 0,
	    colorRendering: 0,
	    contentScriptType: 0,
	    contentStyleType: 0,
	    cursor: 0,
	    cx: 0,
	    cy: 0,
	    d: 0,
	    decelerate: 0,
	    descent: 0,
	    diffuseConstant: 0,
	    direction: 0,
	    display: 0,
	    divisor: 0,
	    dominantBaseline: 0,
	    dur: 0,
	    dx: 0,
	    dy: 0,
	    edgeMode: 0,
	    elevation: 0,
	    enableBackground: 0,
	    end: 0,
	    exponent: 0,
	    externalResourcesRequired: 0,
	    fill: 0,
	    fillOpacity: 0,
	    fillRule: 0,
	    filter: 0,
	    filterRes: 0,
	    filterUnits: 0,
	    floodColor: 0,
	    floodOpacity: 0,
	    focusable: 0,
	    fontFamily: 0,
	    fontSize: 0,
	    fontSizeAdjust: 0,
	    fontStretch: 0,
	    fontStyle: 0,
	    fontVariant: 0,
	    fontWeight: 0,
	    format: 0,
	    from: 0,
	    fx: 0,
	    fy: 0,
	    g1: 0,
	    g2: 0,
	    glyphName: 0,
	    glyphOrientationHorizontal: 0,
	    glyphOrientationVertical: 0,
	    glyphRef: 0,
	    gradientTransform: 0,
	    gradientUnits: 0,
	    hanging: 0,
	    horizAdvX: 0,
	    horizOriginX: 0,
	    ideographic: 0,
	    imageRendering: 0,
	    in: 0,
	    in2: 0,
	    intercept: 0,
	    k: 0,
	    k1: 0,
	    k2: 0,
	    k3: 0,
	    k4: 0,
	    kernelMatrix: 0,
	    kernelUnitLength: 0,
	    kerning: 0,
	    keyPoints: 0,
	    keySplines: 0,
	    keyTimes: 0,
	    lengthAdjust: 0,
	    letterSpacing: 0,
	    lightingColor: 0,
	    limitingConeAngle: 0,
	    local: 0,
	    markerEnd: 0,
	    markerMid: 0,
	    markerStart: 0,
	    markerHeight: 0,
	    markerUnits: 0,
	    markerWidth: 0,
	    mask: 0,
	    maskContentUnits: 0,
	    maskUnits: 0,
	    mathematical: 0,
	    mode: 0,
	    numOctaves: 0,
	    offset: 0,
	    opacity: 0,
	    operator: 0,
	    order: 0,
	    orient: 0,
	    orientation: 0,
	    origin: 0,
	    overflow: 0,
	    overlinePosition: 0,
	    overlineThickness: 0,
	    paintOrder: 0,
	    panose1: 0,
	    pathLength: 0,
	    patternContentUnits: 0,
	    patternTransform: 0,
	    patternUnits: 0,
	    pointerEvents: 0,
	    points: 0,
	    pointsAtX: 0,
	    pointsAtY: 0,
	    pointsAtZ: 0,
	    preserveAlpha: 0,
	    preserveAspectRatio: 0,
	    primitiveUnits: 0,
	    r: 0,
	    radius: 0,
	    refX: 0,
	    refY: 0,
	    renderingIntent: 0,
	    repeatCount: 0,
	    repeatDur: 0,
	    requiredExtensions: 0,
	    requiredFeatures: 0,
	    restart: 0,
	    result: 0,
	    rotate: 0,
	    rx: 0,
	    ry: 0,
	    scale: 0,
	    seed: 0,
	    shapeRendering: 0,
	    slope: 0,
	    spacing: 0,
	    specularConstant: 0,
	    specularExponent: 0,
	    speed: 0,
	    spreadMethod: 0,
	    startOffset: 0,
	    stdDeviation: 0,
	    stemh: 0,
	    stemv: 0,
	    stitchTiles: 0,
	    stopColor: 0,
	    stopOpacity: 0,
	    strikethroughPosition: 0,
	    strikethroughThickness: 0,
	    string: 0,
	    stroke: 0,
	    strokeDasharray: 0,
	    strokeDashoffset: 0,
	    strokeLinecap: 0,
	    strokeLinejoin: 0,
	    strokeMiterlimit: 0,
	    strokeOpacity: 0,
	    strokeWidth: 0,
	    surfaceScale: 0,
	    systemLanguage: 0,
	    tableValues: 0,
	    targetX: 0,
	    targetY: 0,
	    textAnchor: 0,
	    textDecoration: 0,
	    textRendering: 0,
	    textLength: 0,
	    to: 0,
	    transform: 0,
	    u1: 0,
	    u2: 0,
	    underlinePosition: 0,
	    underlineThickness: 0,
	    unicode: 0,
	    unicodeBidi: 0,
	    unicodeRange: 0,
	    unitsPerEm: 0,
	    vAlphabetic: 0,
	    vHanging: 0,
	    vIdeographic: 0,
	    vMathematical: 0,
	    values: 0,
	    vectorEffect: 0,
	    version: 0,
	    vertAdvY: 0,
	    vertOriginX: 0,
	    vertOriginY: 0,
	    viewBox: 0,
	    viewTarget: 0,
	    visibility: 0,
	    widths: 0,
	    wordSpacing: 0,
	    writingMode: 0,
	    x: 0,
	    xHeight: 0,
	    x1: 0,
	    x2: 0,
	    xChannelSelector: 0,
	    xlinkActuate: 0,
	    xlinkArcrole: 0,
	    xlinkHref: 0,
	    xlinkRole: 0,
	    xlinkShow: 0,
	    xlinkTitle: 0,
	    xlinkType: 0,
	    xmlBase: 0,
	    xmlns: 0,
	    xmlnsXlink: 0,
	    xmlLang: 0,
	    xmlSpace: 0,
	    y: 0,
	    y1: 0,
	    y2: 0,
	    yChannelSelector: 0,
	    z: 0,
	    zoomAndPan: 0
	  },
	  DOMAttributeNames: {
	    accentHeight: 'accent-height',
	    alignmentBaseline: 'alignment-baseline',
	    arabicForm: 'arabic-form',
	    baselineShift: 'baseline-shift',
	    capHeight: 'cap-height',
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    dominantBaseline: 'dominant-baseline',
	    enableBackground: 'enable-background',
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    imageRendering: 'image-rendering',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    paintOrder: 'paint-order',
	    panose1: 'panose-1',
	    pointerEvents: 'pointer-events',
	    renderingIntent: 'rendering-intent',
	    shapeRendering: 'shape-rendering',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    strokeDasharray: 'stroke-dasharray',
	    strokeDashoffset: 'stroke-dashoffset',
	    strokeLinecap: 'stroke-linecap',
	    strokeLinejoin: 'stroke-linejoin',
	    strokeMiterlimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    vectorEffect: 'vector-effect',
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    xHeight: 'x-height',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlnsXlink: 'xmlns:xlink',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};


/***/ },
/* 1422 */
/***/ function(module, exports) {

	module.exports = {
	  MUST_USE_PROPERTY: 1,
	  HAS_BOOLEAN_VALUE: 4,
	  HAS_NUMERIC_VALUE: 8,
	  HAS_POSITIVE_NUMERIC_VALUE: 24,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 32
	};


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(4);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1435));
	
	var _Context = __webpack_require__(101);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(278));
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = new _Subscription["default"](store);
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _react.useEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return _react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	Provider.propTypes = {
	  store: _propTypes["default"].shape({
	    subscribe: _propTypes["default"].func.isRequired,
	    dispatch: _propTypes["default"].func.isRequired,
	    getState: _propTypes["default"].func.isRequired
	  }),
	  context: _propTypes["default"].object,
	  children: _propTypes["default"].any
	};
	var _default = Provider;
	exports["default"] = _default;

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(90));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(594));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(599));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(1425));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(1426));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(1427));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(1428));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports["default"] = _default;

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports["default"] = void 0;
	
	var _redux = __webpack_require__(293);
	
	var _wrapMapToProps = __webpack_require__(595);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports["default"] = void 0;
	
	var _wrapMapToProps = __webpack_require__(595);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(600));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, {}, stateProps, {}, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports["default"] = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(90));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(1429));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(601));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(101);
	
	var _useStore = __webpack_require__(597);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(1);
	
	var _invariant = _interopRequireDefault(__webpack_require__(253));
	
	var _useReduxContext2 = __webpack_require__(596);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(278));
	
	var _Context = __webpack_require__(101);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return new _Subscription["default"](store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
	      selectedState = selector(store.getState());
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    var errorMessage = "An error occured while selecting the store state: " + err.message + ".";
	
	    if (latestSubscriptionCallbackError.current) {
	      errorMessage += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\nOriginal stack trace:";
	    }
	
	    throw new Error(errorMessage);
	  }
	
	  useIsomorphicLayoutEffect(function () {
	    latestSelector.current = selector;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  useIsomorphicLayoutEffect(function () {
	    function checkForUpdates() {
	      try {
	        var newSelectedState = latestSelector.current(store.getState());
	
	        if (equalityFn(newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = newSelectedState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender({});
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    (0, _invariant["default"])(selector, "You must pass a selector to useSelectors");
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = createSelectorHook();
	exports.useSelector = useSelector;

/***/ },
/* 1432 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(32);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ },
/* 1434 */
[1912, 1436],
/* 1435 */
[1913, 1434],
/* 1436 */
918,
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1)),reactRouter=__webpack_require__(1442),history=__webpack_require__(176);__webpack_require__(602),__webpack_require__(88);var invariant=_interopDefault(__webpack_require__(209));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(t[o]=r[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var r,o,n={},i=Object.keys(t);for(o=0;o<i.length;o++)r=i[o],0<=e.indexOf(r)||(n[r]=t[r]);return n}var BrowserRouter=function(n){function t(){for(var t,e=arguments.length,r=new Array(e),o=0;o<e;o++)r[o]=arguments[o];return(t=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(t.props),t}return _inheritsLoose(t,n),t.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},t}(React.Component),HashRouter=function(n){function t(){for(var t,e=arguments.length,r=new Array(e),o=0;o<e;o++)r[o]=arguments[o];return(t=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(t.props),t}return _inheritsLoose(t,n),t.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},t}(React.Component);function isModifiedEvent(t){return!!(t.metaKey||t.altKey||t.ctrlKey||t.shiftKey)}var Link=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var r=e.prototype;return r.handleClick=function(e,t){try{this.props.onClick&&this.props.onClick(e)}catch(t){throw e.preventDefault(),t}e.defaultPrevented||0!==e.button||this.props.target&&"_self"!==this.props.target||isModifiedEvent(e)||(e.preventDefault(),(this.props.replace?t.replace:t.push)(this.props.to))},r.render=function(){var o=this,t=this.props,n=t.innerRef,i=(t.replace,t.to),a=_objectWithoutPropertiesLoose(t,["innerRef","replace","to"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t="string"==typeof i?history.createLocation(i,null,null,e.location):i,r=t?e.history.createHref(t):"";return React.createElement("a",_extends({},a,{onClick:function(t){return o.handleClick(t,e.history)},href:r,ref:n}))})},e}(React.Component);function joinClassnames(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return e.filter(function(t){return t}).join(" ")}function NavLink(t){var e=t["aria-current"],a=void 0===e?"page":e,r=t.activeClassName,s=void 0===r?"active":r,c=t.activeStyle,u=t.className,l=t.exact,p=t.isActive,h=t.location,f=t.strict,y=t.style,v=t.to,R=_objectWithoutPropertiesLoose(t,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","strict","style","to"]),o="object"==typeof v?v.pathname:v,d=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1");return React.createElement(reactRouter.__RouterContext.Consumer,null,function(t){t||invariant(!1);var e=h?h.pathname:t.location.pathname,r=d?reactRouter.matchPath(e,{path:d,exact:l,strict:f}):null,o=!!(p?p(r,t.location):r),n=o?joinClassnames(u,s):u,i=o?_extends({},y,c):y;return React.createElement(Link,_extends({"aria-current":o&&a||null,className:n,style:i,to:v},R))})}Object.keys(reactRouter).forEach(function(t){exports[t]=reactRouter[t]}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;


/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(1437);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 1439 */
[1912, 1440],
/* 1440 */
918,
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var createContext=_interopDefault(__webpack_require__(455)),React=_interopDefault(__webpack_require__(1));__webpack_require__(602),__webpack_require__(88);var history=__webpack_require__(176),invariant=_interopDefault(__webpack_require__(209)),pathToRegexp=_interopDefault(__webpack_require__(589));__webpack_require__(48);var hoistStatics=_interopDefault(__webpack_require__(82));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{children:this.props.children||null,value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}})},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(s,t){void 0===t&&(t={}),"string"==typeof t&&(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(s);if(!a)return null;var i=a[0],c=a.slice(1),u=s===i;return p&&!u?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:u,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),"function"==typeof r&&void 0===(r=r(n))&&(r=null),React.createElement(context.Provider,{value:n},r&&!isEmptyChildren(r)?r:n.match?a?React.createElement(a,n):i?i(n):null:null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),u={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler("go"),goBack:staticHandler("goBack"),goForward:staticHandler("goForward"),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:u,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){var t="withRouter("+(o.displayName||o.name)+")",e=function(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})};return e.displayName=t,e.WrappedComponent=o,hoistStatics(e,o)}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.withRouter=withRouter,exports.__RouterContext=context;


/***/ },
/* 1442 */
[1917, 1441],
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1));__webpack_require__(1445);var history=__webpack_require__(176);__webpack_require__(88);var createContext=_interopDefault(__webpack_require__(455)),invariant=_interopDefault(__webpack_require__(209)),pathToRegexp=_interopDefault(__webpack_require__(589));__webpack_require__(48);var hoistStatics=_interopDefault(__webpack_require__(82));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{children:this.props.children||null,value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}})},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(context).history}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){return t?matchPath(useLocation().pathname,t):useContext(context).match}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 1444 */
[1912, 1446],
/* 1445 */
[1913, 1444],
/* 1446 */
918,
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1716).enable();
	  window.Promise = __webpack_require__(1715);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1717);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(195);


/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMessages = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _styles = __webpack_require__(30);
	
	var _reactIntl = __webpack_require__(16);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _store = __webpack_require__(1709);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routes = __webpack_require__(1708);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _theme = __webpack_require__(1710);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Main = __webpack_require__(1563);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _GlobalHeader = __webpack_require__(608);
	
	var _GlobalHeader2 = _interopRequireDefault(_GlobalHeader);
	
	var _Footer = __webpack_require__(607);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _messages_en = __webpack_require__(1254);
	
	var _messages_en2 = _interopRequireDefault(_messages_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prefer-stateless-function */
	
	
	var getMessages = exports.getMessages = function getMessages() {
	  return _messages_en2.default;
	};
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.renderChild = function (component) {
	      switch (component) {
	        case 'root':
	          return _react2.default.createElement(
	            _Main2.default,
	            null,
	            _react2.default.createElement(
	              _connectedReactRouter.ConnectedRouter,
	              { history: _store.history },
	              _react2.default.createElement(_routes2.default, null)
	            )
	          );
	        case 'footer':
	          return _react2.default.createElement(_Footer2.default, null);
	        case 'header':
	          return _react2.default.createElement(_GlobalHeader2.default, null);
	        default:
	          return _react2.default.createElement('span', null);
	      }
	    }, _this.renderFaviconAndTitle = function (_ref2) {
	      var favicon = _ref2.favicon,
	          siteTitle = _ref2.siteTitle;
	
	      if (favicon) {
	        var favIconElement = document.getElementById('layer7-favicon');
	        if (favIconElement) {
	          favIconElement.href = favicon;
	        }
	      }
	      if (siteTitle) {
	        document.title = siteTitle;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          portalConfig = _props.portalConfig,
	          component = _props.component;
	
	      var theme = (0, _theme2.default)(portalConfig);
	      var dict = portalConfig.dict;
	
	      var locale = 'en';
	      var messages = Object.assign({}, dict, getMessages(locale));
	
	      var store = (0, _store2.default)({ portalConfig: portalConfig });
	
	      this.renderFaviconAndTitle(theme);
	      return _react2.default.createElement(
	        _styles.ThemeProvider,
	        { theme: (0, _styles.createMuiTheme)(theme) },
	        _react2.default.createElement(
	          _reactIntl.IntlProvider,
	          { locale: locale, messages: messages },
	          _react2.default.createElement(
	            _reactRedux.Provider,
	            { store: store },
	            this.renderChild(component)
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;
	
	
	App.propTypes = {
	  portalConfig: _propTypes2.default.shape({}),
	  component: _propTypes2.default.string
	};

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUpdateFormData = exports.getUpdateData = exports.getUpdateDetails = exports.getCreateData = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var getCreateData = exports.getCreateData = function getCreateData(userContext, _ref) {
	  var apiName = _ref.apiName,
	      version = _ref.version,
	      eulaUuid = _ref.eulaUuid,
	      privateDescription = _ref.privateDescription,
	      serviceType = _ref.serviceType,
	      publicDescription = _ref.publicDescription,
	      proxyUrl = _ref.proxyUrl,
	      location = _ref.location;
	  return {
	    name: apiName,
	    version: version,
	    apiEulaUuid: eulaUuid,
	    privateDescription: privateDescription,
	    accessStatus: 'PRIVATE', // default to PRIVATE on API Creation
	    description: publicDescription,
	    managingOrgUuid: userContext.organizationUuid,
	    orgUuid: null, // default to no Organization assigned on API Creation
	    ssgUrl: proxyUrl,
	    authenticationType: 'NONE',
	    authenticationParameters: '{}',
	    locationUrl: location,
	    apiServiceType: serviceType,
	    type: 'BASIC'
	  };
	};
	
	var getUpdateDetails = exports.getUpdateDetails = function getUpdateDetails(apiUuid, _ref2) {
	  var apiName = _ref2.apiName,
	      name = _ref2.name,
	      version = _ref2.version,
	      eulaUuid = _ref2.eulaUuid,
	      apiEulaUuid = _ref2.apiEulaUuid,
	      privateDescription = _ref2.privateDescription,
	      accessStatus = _ref2.accessStatus,
	      portalStatus = _ref2.portalStatus,
	      serviceType = _ref2.serviceType,
	      apiServiceType = _ref2.apiServiceType,
	      publicDescription = _ref2.publicDescription,
	      description = _ref2.description,
	      proxyUrl = _ref2.proxyUrl,
	      ssgUrl = _ref2.ssgUrl,
	      authenticationType = _ref2.authenticationType,
	      authenticationParameters = _ref2.authenticationParameters,
	      location = _ref2.location,
	      locationUrl = _ref2.locationUrl,
	      publishedByPortal = _ref2.publishedByPortal,
	      type = _ref2.type,
	      possibleStatuses = _ref2.possibleStatuses,
	      managingOrgUuid = _ref2.managingOrgUuid;
	  return {
	    uuid: apiUuid,
	    name: apiName || name,
	    version: version,
	    apiEulaUuid: eulaUuid || apiEulaUuid,
	    privateDescription: privateDescription,
	    accessStatus: accessStatus,
	    portalStatus: portalStatus,
	    apiServiceType: serviceType || apiServiceType,
	    description: publicDescription || description,
	    ssgUrl: proxyUrl || ssgUrl,
	    authenticationType: authenticationType,
	    authenticationParameters: authenticationParameters && JSON.stringify(authenticationParameters),
	    locationUrl: location || locationUrl,
	    publishedByPortal: publishedByPortal,
	    type: type,
	    possibleStatuses: possibleStatuses,
	    managingOrgUuid: managingOrgUuid
	  };
	};
	
	var getUpdateData = exports.getUpdateData = function getUpdateData(apiUuid, _ref3) {
	  var apiName = _ref3.apiName,
	      name = _ref3.name,
	      version = _ref3.version,
	      eulaUuid = _ref3.eulaUuid,
	      apiEulaUuid = _ref3.apiEulaUuid,
	      privateDescription = _ref3.privateDescription,
	      accessStatus = _ref3.accessStatus,
	      portalStatus = _ref3.portalStatus,
	      serviceType = _ref3.serviceType,
	      apiServiceType = _ref3.apiServiceType,
	      publicDescription = _ref3.publicDescription,
	      description = _ref3.description,
	      proxyUrl = _ref3.proxyUrl,
	      ssgUrl = _ref3.ssgUrl,
	      authenticationType = _ref3.authenticationType,
	      authenticationParameters = _ref3.authenticationParameters,
	      location = _ref3.location,
	      locationUrl = _ref3.locationUrl,
	      publishedByPortal = _ref3.publishedByPortal,
	      type = _ref3.type,
	      possibleStatuses = _ref3.possibleStatuses,
	      managingOrgUuid = _ref3.managingOrgUuid;
	  return Object.assign({
	    uuid: apiUuid,
	    name: apiName || name,
	    version: version,
	    apiEulaUuid: eulaUuid || apiEulaUuid,
	    privateDescription: privateDescription,
	    accessStatus: accessStatus,
	    portalStatus: portalStatus,
	    apiServiceType: serviceType || apiServiceType,
	    description: publicDescription || description,
	    ssgUrl: proxyUrl || ssgUrl,
	    authenticationType: authenticationType,
	    authenticationParameters: authenticationParameters && JSON.stringify(authenticationParameters),
	    locationUrl: location || locationUrl,
	    publishedByPortal: publishedByPortal,
	    type: type,
	    possibleStatuses: possibleStatuses
	  }, managingOrgUuid && { managingOrgUuid: managingOrgUuid });
	};
	
	var getUpdateFormData = exports.getUpdateFormData = function getUpdateFormData(apiUuid, details) {
	  var initialAssets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var uploadedAssets = arguments[3];
	
	  var formData = new FormData();
	  var policyEntities = details.policyEntities,
	      customFieldValues = details.customFieldValues;
	
	
	  (0, _lodash.forEach)(getUpdateData(apiUuid, details), function (value, key) {
	    return formData.append(key, value);
	  });
	
	  // append Policy Entities
	  (0, _lodash.forEach)(policyEntities, function (_ref4, peIndex) {
	    var policyEntityUuid = _ref4.policyEntityUuid,
	        policyTemplateArguments = _ref4.policyTemplateArguments;
	
	    formData.append('policyEntities[' + peIndex + '].policyEntityUuid', policyEntityUuid);
	    (0, _lodash.forEach)(policyTemplateArguments, function (pta, ptaIndex) {
	      var policyTemplateArgumentProp = 'policyEntities[' + peIndex + '].policyTemplateArguments';
	      formData.append(policyTemplateArgumentProp + '[' + ptaIndex + '].name', pta.name);
	      formData.append(policyTemplateArgumentProp + '[' + ptaIndex + '].value', pta.value);
	    });
	  });
	
	  // append Custom Fields
	  (0, _lodash.forEach)(customFieldValues, function (_ref5, cfIndex) {
	    var customFieldUuid = _ref5.customFieldUuid,
	        value = _ref5.value;
	
	    formData.append('customFieldValues[' + cfIndex + '].customFieldUuid', customFieldUuid);
	    formData.append('customFieldValues[' + cfIndex + '].value', value);
	  });
	
	  // append Assets
	  if (uploadedAssets) {
	    (0, _lodash.forEach)(uploadedAssets.files, function (_ref6) {
	      var blob = _ref6.blob,
	          name = _ref6.name;
	
	      if (blob) {
	        formData.append('files', blob, name);
	      }
	    });
	  }
	
	  // remove Assets
	  (0, _lodash.forEach)(initialAssets, function (initialAsset) {
	    var isPresent = (0, _lodash.find)(uploadedAssets.files, function (uploadedAsset) {
	      return uploadedAsset.uuid === initialAsset.uuid;
	    });
	    if (!isPresent) {
	      // formData.append('filesToDelete', initialAsset.uuid);
	    }
	  });
	
	  return formData;
	};
	
	exports.default = {};

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDeleteData = exports.getUpdateData = exports.getCreateData = undefined;
	
	var _map = __webpack_require__(273);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCreateData = exports.getCreateData = function getCreateData(_ref) {
	  var organizationName = _ref.organizationName,
	      description = _ref.description,
	      name = _ref.name,
	      oauthScope = _ref.oauthScope,
	      magScope = _ref.magScope,
	      oauthCallbackUrl = _ref.oauthCallbackUrl,
	      oauthType = _ref.oauthType,
	      organizationUuid = _ref.organizationUuid,
	      _ref$apiIds = _ref.apiIds,
	      apiIds = _ref$apiIds === undefined ? [] : _ref$apiIds,
	      _ref$customFieldValue = _ref.customFieldValues,
	      customFieldValues = _ref$customFieldValue === undefined ? {} : _ref$customFieldValue,
	      _ref$apiApiPlanIds = _ref.apiApiPlanIds,
	      apiApiPlanIds = _ref$apiApiPlanIds === undefined ? [] : _ref$apiApiPlanIds,
	      _ref$apiGroupIds = _ref.apiGroupIds,
	      apiGroupIds = _ref$apiGroupIds === undefined ? [] : _ref$apiGroupIds,
	      shouldHash = _ref.shouldHash;
	  return {
	    Name: name,
	    Description: description,
	    OrganizationUuid: organizationUuid,
	    OrganizationName: organizationName,
	    OauthCallbackUrl: oauthCallbackUrl,
	    OauthScope: oauthScope,
	    OauthType: oauthType,
	    MagScope: magScope,
	    Uuid: '{{GENERATED_GUID}}',
	    ApiIds: { results: apiIds },
	    ApiGroupIds: { results: apiGroupIds },
	    CustomFieldValues: {
	      results: (0, _map2.default)(customFieldValues, function (value, key) {
	        return {
	          Uuid: '{{GENERATED_UUID}}',
	          EntityUuid: '{{GENERATED_UUID}}',
	          CustomFieldUuid: key,
	          Value: value
	        };
	      })
	    },
	    ApiApiPlanIds: {
	      results: (0, _map2.default)(apiApiPlanIds, function (value, key) {
	        return {
	          ApiUuid: key,
	          ApiPlanUuid: value
	        };
	      })
	    },
	    ShouldHash: shouldHash
	  };
	};
	
	var getUpdateData = exports.getUpdateData = function getUpdateData(_ref2) {
	  var uuid = _ref2.uuid,
	      organizationName = _ref2.organizationName,
	      description = _ref2.description,
	      apiKey = _ref2.apiKey,
	      magMasterKey = _ref2.magMasterKey,
	      reason = _ref2.reason,
	      name = _ref2.name,
	      oauthScope = _ref2.oauthScope,
	      keySecret = _ref2.keySecret,
	      magScope = _ref2.magScope,
	      oauthCallbackUrl = _ref2.oauthCallbackUrl,
	      status = _ref2.status,
	      disabledByType = _ref2.disabledByType,
	      oauthType = _ref2.oauthType,
	      organizationUuid = _ref2.organizationUuid,
	      _ref2$apiIds = _ref2.apiIds,
	      apiIds = _ref2$apiIds === undefined ? [] : _ref2$apiIds,
	      _ref2$customFieldValu = _ref2.customFieldValues,
	      customFieldValues = _ref2$customFieldValu === undefined ? {} : _ref2$customFieldValu,
	      _ref2$apiApiPlanIds = _ref2.apiApiPlanIds,
	      apiApiPlanIds = _ref2$apiApiPlanIds === undefined ? [] : _ref2$apiApiPlanIds,
	      _ref2$apiGroupIds = _ref2.apiGroupIds,
	      apiGroupIds = _ref2$apiGroupIds === undefined ? [] : _ref2$apiGroupIds,
	      shouldHash = _ref2.shouldHash;
	  return {
	    Uuid: uuid,
	    OrganizationName: organizationName,
	    Description: description,
	    ApiKey: apiKey,
	    MagMasterKey: magMasterKey,
	    Reason: reason,
	    Name: name,
	    OauthScope: oauthScope,
	    KeySecret: keySecret,
	    MagScope: magScope,
	    OauthCallbackUrl: oauthCallbackUrl,
	    Status: status,
	    DisabledByType: disabledByType,
	    OauthType: oauthType,
	    OrganizationUuid: organizationUuid,
	    ApiIds: { results: apiIds },
	    ApiGroupIds: { results: apiGroupIds },
	    CustomFieldValues: {
	      results: (0, _map2.default)(customFieldValues, function (value, key) {
	        return {
	          Uuid: '{{GENERATED_UUID}}',
	          EntityUuid: '{{GENERATED_UUID}}',
	          CustomFieldUuid: key,
	          Value: value
	        };
	      })
	    },
	    ApiApiPlanIds: {
	      results: (0, _map2.default)(apiApiPlanIds, function (value, key) {
	        return {
	          ApiUuid: key,
	          ApiPlanUuid: value
	        };
	      })
	    },
	    ShouldHash: shouldHash
	  };
	};
	
	var getDeleteData = exports.getDeleteData = function getDeleteData(_ref3) {
	  var uuid = _ref3.uuid,
	      organizationName = _ref3.organizationName,
	      name = _ref3.name,
	      status = _ref3.status,
	      disabledByType = _ref3.disabledByType,
	      organizationUuid = _ref3.organizationUuid;
	  return {
	    uuid: uuid,
	    organizationName: organizationName,
	    name: name,
	    status: status,
	    disabledByType: disabledByType,
	    organizationUuid: organizationUuid
	  };
	};

/***/ },
/* 1451 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getOrgPayload = exports.getOrgPayload = function getOrgPayload(_ref) {
	  var accountPlanUuid = _ref.accountPlanUuid,
	      description = _ref.description,
	      name = _ref.name,
	      type = _ref.type,
	      status = _ref.status,
	      orgUuid = _ref.orgUuid;
	  return {
	    AccountPlanUuid: accountPlanUuid,
	    Description: description,
	    Name: name,
	    Type: type,
	    Status: status,
	    Uuid: orgUuid
	  };
	};
	
	exports.default = {};

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchUsers = exports.showLoading = exports.resetDeleteNotification = exports.resetApp = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _isEmpty = __webpack_require__(35);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _constants = __webpack_require__(14);
	
	var _ = __webpack_require__(196);
	
	var _portalConfig = __webpack_require__(26);
	
	var _utils = __webpack_require__(18);
	
	var _actions = __webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var init = function init(dispatch) {
	  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return dispatch({
	    type: _constants.APP_LOADING,
	    isLoading: isLoading
	  });
	};
	
	var resetApp = exports.resetApp = function resetApp() {
	  return function (dispatch) {
	    return dispatch({ type: _constants.APP_RESET });
	  };
	};
	var resetDeleteNotification = exports.resetDeleteNotification = function resetDeleteNotification() {
	  return function (dispatch) {
	    localStorage.removeItem('isUserDeleteSuccess');
	    dispatch({ type: _constants.USERS_DELETE_RESET });
	  };
	};
	var showLoading = exports.showLoading = function showLoading(isLoading) {
	  return function (dispatch) {
	    return init(dispatch, isLoading);
	  };
	};
	
	var fetchUsers = exports.fetchUsers = function fetchUsers() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      username = _ref.username,
	      name = _ref.name,
	      email = _ref.email,
	      _ref$roleUuids = _ref.roleUuids,
	      roleUuids = _ref$roleUuids === undefined ? [] : _ref$roleUuids,
	      orgUuids = _ref.orgUuids,
	      status = _ref.status,
	      sortBy = _ref.sortBy,
	      sortOrder = _ref.sortOrder,
	      _ref$page = _ref.page,
	      page = _ref$page === undefined ? 0 : _ref$page,
	      _ref$rowsPerPage = _ref.rowsPerPage,
	      rowsPerPage = _ref$rowsPerPage === undefined ? 12 : _ref$rowsPerPage;
	
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	      var config, portal, urlPrefix, url;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              init(dispatch);
	              config = (0, _portalConfig.getConfig)(getState());
	              portal = config.portal;
	              urlPrefix = portal.hostname + '/admin/v2/users';
	              url = (0, _actions.stringifyUrl)({
	                url: urlPrefix,
	                query: {
	                  username: username,
	                  roleUuids: !(0, _isEmpty2.default)(roleUuids) ? roleUuids.join(',') : undefined,
	                  orgUuids: orgUuids,
	                  status: status !== _constants.ALL ? status : undefined,
	                  search: !!(name || email) || undefined,
	                  field: name && 'name' || email && 'email' || undefined,
	                  query: name || email || undefined,
	                  sortBy: sortBy || undefined,
	                  sortOrder: sortOrder || undefined,
	                  offset: page * rowsPerPage,
	                  limit: rowsPerPage,
	                  includeAnonymous: true
	                },
	                options: {
	                  encode: true,
	                  skipNull: true,
	                  arrayFormat: 'comma'
	                }
	              });
	              _context.next = 7;
	              return _axios2.default.get(url, _.AXIOS_DEFAULT_OPTIONS).then(function (response) {
	                return dispatch({
	                  type: _constants.USERS_GET_SUCCESS,
	                  payload: response.data
	                });
	              }).catch(function (error) {
	                return dispatch({
	                  type: _constants.USERS_GET_ERROR,
	                  payload: (0, _utils.getValidationErrors)(error)
	                });
	              });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    dialogContainer: {
	      minWidth: 400,
	      minHeight: 200,
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground')
	    },
	    title: {
	      margin: 0
	    },
	    cancelButton: {
	      textTransform: 'none',
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.primaryButtonText'),
	      borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      borderRadius: 3
	    },
	    submitButton: {
	      textTransform: 'none',
	      color: (0, _lodash.get)(theme, 'color.primaryButtonText'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	    },
	    dialogTitle: {
	      display: 'inline-flex'
	    },
	    closeButton: {
	      height: 12,
	      position: 'absolute',
	      right: 4,
	      top: 20,
	      color: (0, _lodash.get)(theme, 'color.borderColor'),
	      fontSize: 16
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _Alert = __webpack_require__(962);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _propTypes = __webpack_require__(5);
	
	var _styles = __webpack_require__(1455);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertInfo = function AlertInfo(props) {
	  var id = props.id,
	      message = props.message,
	      classes = props.classes,
	      severity = props.severity,
	      onClose = props.onClose,
	      actionText = props.actionText;
	
	  return _react2.default.createElement(
	    _Alert2.default,
	    {
	      variant: 'filled',
	      id: id,
	      'data-apim-test': id,
	      severity: severity,
	      onClose: onClose,
	      classes: {
	        root: classes.root,
	        filledInfo: classes.info,
	        filledSuccess: classes.success,
	        icon: classes.icon,
	        action: classes.action
	      },
	      action: _react2.default.createElement(
	        _core.Link,
	        { onClick: onClose },
	        actionText
	      )
	    },
	    message
	  );
	};
	
	AlertInfo.propTypes = {
	  id: _propTypes.string,
	  message: _propTypes.string,
	  classes: (0, _propTypes.shape)({}),
	  severity: _propTypes.string,
	  onClose: _propTypes.func,
	  actionText: _propTypes.string
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(AlertInfo);

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _colors = __webpack_require__(235);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      marginTop: '-23px',
	      marginBottom: '24px',
	      height: '44px',
	      padding: '4px 30px 0px 30px',
	      color: (0, _lodash.get)(theme, 'palette.primary.light')
	    },
	    success: {
	      backgroundColor: _colors.green[600]
	    },
	    error: {
	      backgroundColor: (0, _lodash.get)(theme, 'palette.error.dark')
	    },
	    info: {
	      backgroundColor: 'rgba(247, 205, 59, 0.15)'
	    },
	    action: {
	      '& .MuiLink-underlineHover:hover': {
	        textDecoration: 'none'
	      },
	      padding: 0,
	      marginRight: 0,
	      marginTop: '-10px',
	      color: (0, _lodash.get)(theme, 'link'),
	      cursor: 'pointer'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _Close = __webpack_require__(141);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _propTypes = __webpack_require__(5);
	
	var _styles = __webpack_require__(1457);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertMessages = function AlertMessages(props) {
	  var id = props.id,
	      message = props.message,
	      classes = props.classes,
	      variant = props.variant,
	      onClose = props.onClose,
	      _props$containerClass = props.containerClass,
	      containerClass = _props$containerClass === undefined ? '' : _props$containerClass,
	      _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className;
	
	  return _react2.default.createElement(_core.SnackbarContent, {
	    className: (0, _clsx2.default)(classes[variant], classes.messageContainer, containerClass, className),
	    id: id, 'data-apim-test': id, 'data-layer7-test': id,
	    'aria-describedby': 'client-snackbar',
	    message: _react2.default.createElement(
	      'span',
	      { id: 'client-snackbar', className: classes.message },
	      message
	    ),
	    action: [_react2.default.createElement(
	      _core.IconButton,
	      {
	        className: classes.closeButton, color: 'inherit',
	        onClick: onClose,
	        id: 'close-alert-message', 'data-layer7-test': 'close-alert-message',
	        key: 'close', 'aria-label': 'close'
	      },
	      _react2.default.createElement(_Close2.default, { className: classes.icon })
	    )]
	  });
	};
	
	AlertMessages.propTypes = {
	  id: _propTypes.string,
	  message: _propTypes.string,
	  classes: (0, _propTypes.shape)({}),
	  containerClass: _propTypes.string,
	  variant: _propTypes.string,
	  onClose: _propTypes.func,
	  className: _propTypes.string
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(AlertMessages);

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _colors = __webpack_require__(235);
	
	var styles = function styles(theme) {
	  return {
	    success: {
	      backgroundColor: _colors.green[600]
	    },
	    error: {
	      backgroundColor: theme.palette.error.dark
	    },
	    icon: {
	      fontSize: 20
	    },
	    message: {
	      alignItems: 'center',
	      display: 'flex',
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText')
	    },
	    messageContainer: {
	      marginRight: 0,
	      paddingTop: 0,
	      paddingBottom: 0,
	      marginTop: '0px',
	      minHeight: '40px',
	      top: '70px',
	      position: 'fixed',
	      zIndex: (0, _lodash.get)(theme, 'zIndex.z800'),
	      marginLeft: '-20px',
	      width: '54%',
	      '& .MuiSnackbarContent-message': {
	        padding: 0,
	        paddingLeft: '0px',
	        width: '80%'
	      },
	      '& .MuiSnackbarContent-action': {
	        borderLeft: '1px solid ' + (0, _lodash.get)(theme, 'color.white'),
	        paddingLeft: '0px',
	        marginRight: '-12px'
	      },
	      '& .MuiIconButton-root': {
	        padding: '10px'
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _recompose = __webpack_require__(105);
	
	var _htmlReactParser = __webpack_require__(1242);
	
	var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);
	
	var _core = __webpack_require__(3);
	
	var _Cancel = __webpack_require__(944);
	
	var _Cancel2 = _interopRequireDefault(_Cancel);
	
	var _Info = __webpack_require__(362);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(18);
	
	var _portalConfig = __webpack_require__(26);
	
	var _styles = __webpack_require__(1459);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CookiePolicyBanner = function CookiePolicyBanner(props) {
	  var classes = props.classes,
	      cookieConsent = props.cookieConsent;
	
	  var _useState = (0, _react.useState)({
	    open: false,
	    vertical: 'top',
	    horizontal: 'center',
	    root: classes.rootDark,
	    content: ''
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      state = _useState2[0],
	      setState = _useState2[1];
	
	  var vertical = state.vertical,
	      horizontal = state.horizontal,
	      open = state.open,
	      root = state.root,
	      content = state.content;
	
	
	  var handleClose = function handleClose() {
	    setState(Object.assign({}, state, { open: false }));
	    var cookie = (0, _utils.readCookie)('cpb');
	    if (cookie === null || cookie.toLowerCase() === 'true') {
	      (0, _utils.createCookie)('cpb', 'false', 365, '/');
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (cookieConsent) {
	      var rootClass = cookieConsent.theme === 'light' ? classes.rootLight : classes.rootDark;
	      var contentText = (0, _utils.getCookieMessage)(cookieConsent.message);
	      var cookie = (0, _utils.readCookie)('cpb');
	      if (!cookie || cookie.toLowerCase() === 'true') {
	        setState(Object.assign({}, state, {
	          root: rootClass,
	          content: contentText,
	          vertical: cookieConsent.position,
	          open: cookieConsent.enabled
	        }));
	      }
	    }
	  }, [cookieConsent]);
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'cookie-policy-container' },
	    _react2.default.createElement(
	      _core.Snackbar,
	      {
	        classes: {
	          root: root
	        },
	        open: open,
	        anchorOrigin: { vertical: vertical, horizontal: horizontal }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: classes.infoContainer },
	          _react2.default.createElement(
	            _core.IconButton,
	            { className: classes.closeButton, color: 'inherit' },
	            _react2.default.createElement(_Info2.default, { className: classes.iconInfo })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.messageContainer },
	          (0, _htmlReactParser2.default)(content)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.closeContainer },
	          _react2.default.createElement(
	            _core.IconButton,
	            { className: classes.closeButton, color: 'inherit', onClick: handleClose },
	            _react2.default.createElement(_Cancel2.default, { className: classes.icon })
	          )
	        )
	      )
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    cookieConsent: (0, _portalConfig.getCookieConsent)(state)
	  };
	};
	
	CookiePolicyBanner.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  cookieConsent: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _recompose.compose)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, {}))(CookiePolicyBanner);

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    rootDark: {
	      width: '80%',
	      backgroundColor: (0, _get2.default)(theme, 'color.darkGreyBackground'),
	      color: (0, _get2.default)(theme, 'color.white'),
	      padding: 5,
	      borderRadius: 4,
	      boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
	      '& > div': {
	        width: '100%'
	      }
	    },
	    rootLight: {
	      width: '80%',
	      backgroundColor: (0, _get2.default)(theme, 'color.white'),
	      color: '#000000',
	      padding: 5,
	      borderRadius: 4,
	      boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
	      '& > div': {
	        width: '100%'
	      }
	    },
	    messageContainer: {
	      width: '90%',
	      float: 'left',
	      paddingLeft: 4,
	      fontSize: (0, _get2.default)(theme, 'fontSize.smallText'),
	      fontFamily: (0, _get2.default)(theme, 'typography.bodyText'),
	      '& a': {
	        color: (0, _get2.default)(theme, 'color.link')
	      }
	    },
	    iconInfo: {
	      fontSize: 30
	    },
	    infoContainer: {
	      width: '5%',
	      float: 'left'
	    },
	    closeContainer: {
	      paddingRight: 5,
	      width: '3%',
	      float: 'left'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DetailsHeader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(1461);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _StatusIndicator = __webpack_require__(612);
	
	var _StatusIndicator2 = _interopRequireDefault(_StatusIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailsHeader = exports.DetailsHeader = function DetailsHeader(props) {
	  var classes = props.classes,
	      headerId = props.headerId,
	      title = props.title,
	      name = props.name,
	      modifyTs = props.modifyTs,
	      status = props.status;
	
	
	  var lastModified = modifyTs && (0, _datetime2.default)(new Date(modifyTs).toString());
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.headerContainer,
	      id: headerId, 'data-apim-test': headerId, 'data-layer7-test': headerId
	    },
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h6', className: classes.pageTitle },
	      title
	    ),
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h1', className: classes.pageTitle },
	      name
	    ),
	    _react2.default.createElement(_StatusIndicator2.default, {
	      status: status,
	      lastModified: lastModified
	    })
	  );
	};
	
	DetailsHeader.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  headerId: _propTypes.string,
	  title: _propTypes.string,
	  name: _propTypes.string,
	  modifyTs: _propTypes.string,
	  status: _propTypes.string
	};
	DetailsHeader.displayName = 'DetailsHeader';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(DetailsHeader);

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      margin = _ref.margin,
	      padding = _ref.padding;
	  return {
	    headerContainer: {
	      padding: '0 ' + (0, _get2.default)(padding, 'p36')
	    },
	    pageTitle: {
	      margin: (0, _get2.default)(margin, 'm5') + ' 0',
	      wordWrap: 'break-word'
	    },
	    statusBar: {
	      margin: (0, _get2.default)(margin, 'm5') + ' 0 ' + (0, _get2.default)(margin, 'm21') + ' 0',
	      '& span': {
	        position: 'relative',
	        display: 'inline-block',
	        marginBottom: '5px',
	        paddingLeft: '15px',
	        verticalAlign: 'middle',
	        fontSize: (0, _get2.default)(fontSize, 'smallText'),
	        letterSpacing: 0
	      }
	    },
	    status: {
	      fontSize: (0, _get2.default)(fontSize, 'bodyText') + ' !important',
	      '&:before': {
	        display: 'inline-block',
	        position: 'absolute',
	        content: '""',
	        left: 0,
	        top: '50%',
	        marginTop: '-6px',
	        height: '10px',
	        width: '10px',
	        borderRadius: '10px'
	      }
	    },
	    available: {
	      color: (0, _get2.default)(color, 'success'),
	      '&:before': {
	        backgroundColor: (0, _get2.default)(color, 'success')
	      }
	    },
	    pendingEnrollment: {
	      color: (0, _get2.default)(color, 'disabledGraphic'),
	      '&:before': {
	        backgroundColor: (0, _get2.default)(color, 'disabledGraphic')
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DetailsPanelContainer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _core = __webpack_require__(3);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _propTypes = __webpack_require__(5);
	
	var _styles = __webpack_require__(1463);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailsPanelContainer = exports.DetailsPanelContainer = function DetailsPanelContainer(props) {
	  var classes = props.classes,
	      id = props.id,
	      title = props.title,
	      tooltip = props.tooltip,
	      subTitle = props.subTitle,
	      content = props.content,
	      smallFont = props.smallFont;
	
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.panelContainer,
	      id: id, 'data-apim-test': id, 'data-layer7-test': id
	    },
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true },
	        _react2.default.createElement(
	          _core.Typography,
	          {
	            variant: 'h5',
	            className: classes.title,
	            id: id + '-title', 'data-apim-test': id + '-title', 'data-layer7-test': id + '-title'
	          },
	          title
	        )
	      ),
	      tooltip && _react2.default.createElement(
	        _core.Tooltip,
	        { arrow: true, placement: 'right', title: tooltip },
	        _react2.default.createElement(
	          _core.IconButton,
	          {
	            size: 'small', edge: 'start', color: 'secondary',
	            className: classes.helpIcon,
	            'aria-label': id + '-help'
	          },
	          _react2.default.createElement(_Help2.default, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _core.Typography,
	      {
	        variant: smallFont ? 'body1' : 'h1',
	        className: smallFont ? (0, _classnames2.default)(classes.subTitle, classes.subTitleBody) : classes.subTitle,
	        id: id + '-sub-title', 'data-apim-test': id + '-sub-title', 'data-layer7-test': id + '-sub-title'
	      },
	      subTitle
	    ),
	    subTitle && content
	  );
	};
	
	DetailsPanelContainer.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  title: _propTypes.string,
	  tooltip: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.string]),
	  subTitle: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.shape)({}), _propTypes.string]),
	  content: (0, _propTypes.shape)({}),
	  smallFont: _propTypes.bool
	};
	DetailsPanelContainer.displayName = 'DetailsPanelContainer';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default))(DetailsPanelContainer);

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      fontWeight = _ref.fontWeight,
	      padding = _ref.padding,
	      margin = _ref.margin,
	      typography = _ref.typography;
	  return {
	    panelContainer: {
	      borderLeft: '1px solid ' + (0, _get2.default)(color, 'borderColor'),
	      borderRight: '1px solid ' + (0, _get2.default)(color, 'borderColor'),
	      height: 'calc(100% - 2 * ' + (0, _get2.default)(padding, 'p20') + ')',
	      padding: (0, _get2.default)(padding, 'p20')
	    },
	    title: {
	      color: (0, _get2.default)(color, 'bodyText'),
	      fontFamily: (0, _get2.default)(typography, 'bodyText'),
	      '-webkit-font-smoothing': 'antialiased'
	    },
	    subTitle: {
	      color: (0, _utils.convertHexToRGB)((0, _get2.default)(color, 'bodyText'), 0.7) + ' !important',
	      fontFamily: (0, _get2.default)(typography, 'bodyText'),
	      fontWeight: (0, _get2.default)(fontWeight, 'normal'),
	      marginBottom: (0, _get2.default)(margin, 'm0'),
	      marginTop: (0, _get2.default)(margin, 'm0'),
	      '-webkit-font-smoothing': 'antialiased'
	    },
	    subTitleBody: {
	      marginTop: (0, _get2.default)(margin, 'm4')
	    },
	    helpIcon: {
	      padding: '0 ' + (0, _get2.default)(padding, 'p4') + ' 0 ' + (0, _get2.default)(padding, 'p8'),
	      '& svg': {
	        fontSize: (0, _get2.default)(fontSize, 'smallText')
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DynamicForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _components = __webpack_require__(17);
	
	var _styles = __webpack_require__(1465);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DynamicForm(props) {
	  var fields = props.fields,
	      _handleChange = props.handleChange,
	      index = props.index;
	
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	
	  return _react2.default.createElement(
	    'div',
	    { 'data-apim-test': 'dynamic-form-container' },
	    fields && fields.map(function (field) {
	      return _react2.default.createElement(
	        'div',
	        { key: field.name },
	        field.type === 'boolean' && _react2.default.createElement(
	          'div',
	          { 'data-apim-test': field.name, className: classes.fieldContainer },
	          _react2.default.createElement(
	            _core.FormLabel,
	            {
	              className: classes.formLabel
	            },
	            field.name
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'No',
	            _react2.default.createElement(_core.Switch, {
	              checked: field.value === 'true',
	              onChange: function onChange(e) {
	                return _handleChange(e.target.checked, field.name, index);
	              }
	            }),
	            'Yes'
	          )
	        ),
	        (field.type === 'string' || field.type === 'int') && _react2.default.createElement(_components.FormTextField, {
	          id: field.name,
	          name: field.label,
	          handleChange: function handleChange(value) {
	            return _handleChange(value, field.name, index);
	          },
	          value: field.value
	        }),
	        field.type === 'radio' && _react2.default.createElement(_components.RadioGroupSection, {
	          id: field.name,
	          name: field.label,
	          onChange: function onChange(e) {
	            return _handleChange(e.target.value, field.name, index);
	          },
	          selected: field.value,
	          data: field.data
	        })
	      );
	    })
	  );
	}
	
	DynamicForm.propTypes = {
	  fields: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.shape({})),
	  handleChange: _propTypes.PropTypes.func,
	  index: _propTypes.PropTypes.number
	};

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    fieldContainer: {
	      marginTop: 20,
	      marginBottom: 20
	    },
	    formLabel: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontWeight: 700,
	      paddingLeft: 0
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ErrorContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(8);
	
	var _core = __webpack_require__(3);
	
	var _Warning = __webpack_require__(363);
	
	var _Warning2 = _interopRequireDefault(_Warning);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1467);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ErrorContainer(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var errors = props.errors;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.errorContainer },
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, direction: 'row' },
	      _react2.default.createElement(_Warning2.default, { className: classes.errorIcon }),
	      _react2.default.createElement(
	        'h3',
	        { className: classes.errorTitle },
	        'Errors (',
	        errors.length,
	        ')'
	      )
	    ),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, direction: 'row' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        errors && errors.map(function (error, i) {
	          var message = (0, _lodash.unescape)(error.error || error.message);
	          return _react2.default.createElement(
	            'li',
	            { key: i.toString() },
	            _react2.default.createElement(
	              'div',
	              { className: classes.errorSubtitleText },
	              message
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	ErrorContainer.propTypes = {
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	};

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    errorContainer: {
	      borderRadius: 8,
	      border: '1px solid #DB4332',
	      maxWidth: '90%',
	      padding: 24,
	      marginTop: 10,
	      marginBottom: 10
	    },
	    errorIcon: {
	      color: (0, _get2.default)(theme, 'color.error'),
	      display: 'inline-block',
	      height: 36
	    },
	    errorPadding: {
	      marginBottom: 20,
	      maxWidth: '95%'
	    },
	    errorSubtitle: {
	      color: (0, _get2.default)(theme, 'color.bodyText'),
	      fontFamily: 'clear-sans-regular',
	      display: 'list-item',
	      marginLeft: 50
	    },
	    errorSubtitleText: {
	      color: (0, _get2.default)(theme, 'color.bodyText'),
	      fontFamily: 'clear-sans-regular'
	    },
	    errorTitle: {
	      color: (0, _get2.default)(theme, 'color.bodyText'),
	      display: 'inline-block',
	      fontFamily: 'ca-sans-light',
	      fontSize: 24,
	      marginLeft: 14,
	      marginTop: 0
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = ExpandPanelContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _ExpandMore = __webpack_require__(81);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _CancelRounded = __webpack_require__(240);
	
	var _CancelRounded2 = _interopRequireDefault(_CancelRounded);
	
	var _AddCircleRounded = __webpack_require__(359);
	
	var _AddCircleRounded2 = _interopRequireDefault(_AddCircleRounded);
	
	var _ArrowUpward = __webpack_require__(942);
	
	var _ArrowUpward2 = _interopRequireDefault(_ArrowUpward);
	
	var _ArrowDownward = __webpack_require__(941);
	
	var _ArrowDownward2 = _interopRequireDefault(_ArrowDownward);
	
	var _PageviewRounded = __webpack_require__(956);
	
	var _PageviewRounded2 = _interopRequireDefault(_PageviewRounded);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _components = __webpack_require__(17);
	
	var _styles = __webpack_require__(1469);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandPanelContainer(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      error = props.error,
	      isDeleteIcon = props.isDeleteIcon,
	      isAddIcon = props.isAddIcon,
	      isMoveUpIcon = props.isMoveUpIcon,
	      isMoveDownIcon = props.isMoveDownIcon,
	      _props$isAdded = props.isAdded,
	      isAdded = _props$isAdded === undefined ? function () {
	    return false;
	  } : _props$isAdded,
	      onDeleteItem = props.onDeleteItem,
	      onAddItem = props.onAddItem,
	      onMoveUpItem = props.onMoveUpItem,
	      onMoveDownItem = props.onMoveDownItem,
	      title = props.title,
	      subtitle = props.subtitle,
	      placeHolderText = props.placeHolderText,
	      _props$defaultList = props.defaultList,
	      defaultList = _props$defaultList === undefined ? [] : _props$defaultList,
	      onLoadMore = props.onLoadMore,
	      isLoadMore = props.isLoadMore,
	      hasSearch = props.hasSearch,
	      onSearchTextChange = props.onSearchTextChange,
	      loadMoreText = props.loadMoreText,
	      handleChangeDynamicForm = props.handleChangeDynamicForm,
	      getSelectedItem = props.getSelectedItem,
	      onSelectItem = props.onSelectItem,
	      SecondaryLabelComponent = props.SecondaryLabelComponent,
	      ExternalFilter = props.ExternalFilter,
	      panelSubtitle = props.panelSubtitle,
	      emptyListMessage = props.emptyListMessage,
	      _props$isApiDetails = props.isApiDetails,
	      isApiDetails = _props$isApiDetails === undefined ? false : _props$isApiDetails,
	      _props$isApiGroup = props.isApiGroup,
	      isApiGroup = _props$isApiGroup === undefined ? false : _props$isApiGroup;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchText = _useState2[0],
	      setSearchText = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(defaultList),
	      _useState4 = _slicedToArray(_useState3, 2),
	      filteredList = _useState4[0],
	      setFilterdList = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    setFilterdList(defaultList);
	  }, [defaultList]);
	
	  var onTextChange = function onTextChange(e) {
	    var searchTerm = e.target.value;
	    setSearchText(searchTerm);
	    if (!onSearchTextChange) {
	      var filtered = defaultList.filter(function (item) {
	        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
	      });
	      setFilterdList(filtered);
	    }
	  };
	
	  var handleSearchKeyPress = function handleSearchKeyPress(e) {
	    if (e.key === 'Enter') {
	      onSearchTextChange(searchText);
	    }
	  };
	
	  var handleSearch = function handleSearch() {
	    onSearchTextChange(searchText);
	  };
	
	  var loadMoreClick = function loadMoreClick() {
	    setSearchText('');
	    onLoadMore();
	  };
	
	  var onDelete = function onDelete(e, item, i) {
	    e.stopPropagation();
	    onDeleteItem(item, i);
	  };
	
	  var onAdd = function onAdd(e, item, i) {
	    e.stopPropagation();
	    onAddItem(item, i);
	  };
	
	  var onMoveUp = function onMoveUp(e, item, i) {
	    e.stopPropagation();
	    onMoveUpItem(item, i);
	  };
	
	  var onMoveDown = function onMoveDown(e, item, i) {
	    e.stopPropagation();
	    onMoveDownItem(item, i);
	  };
	
	  var searchFieldClasses = (0, _clsx2.default)('expand-panel-search', classes.textField);
	  if (hasSearch && ExternalFilter) {
	    searchFieldClasses = (0, _clsx2.default)(searchFieldClasses, classes.smallSearchField);
	  }
	
	  var classRoot = error ? (0, _clsx2.default)(classes.root, classes.rootError) : classes.root;
	  return _react2.default.createElement(
	    'div',
	    { className: classRoot, id: id, 'data-apim-test': id },
	    _react2.default.createElement(
	      'div',
	      { 'data-apim-test': id + '-title', className: classes.listTitle },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { 'data-apim-test': id + '-sub-title', className: (0, _clsx2.default)('listSubtitle', classes.listSubtitle) },
	      subtitle
	    ),
	    _react2.default.createElement(
	      'div',
	      { 'data-apim-test': id + '-search-container', className: classes.searchContainer },
	      hasSearch && _react2.default.createElement(_core.TextField, {
	        className: searchFieldClasses,
	        id: 'expand-search',
	        'data-apim-test': 'expand-search',
	        margin: 'normal',
	        variant: 'outlined',
	        onKeyPress: handleSearchKeyPress,
	        placeholder: placeHolderText,
	        onChange: function onChange(e) {
	          return onTextChange(e);
	        },
	        value: searchText,
	        InputProps: {
	          className: classes.textField,
	          type: 'search'
	        }
	      }),
	      hasSearch && onSearchTextChange && _react2.default.createElement(
	        'div',
	        { 'data-apim-test': 'expand-search-icon-container' },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            className: classes.searchIcon,
	            onClick: function onClick() {
	              return handleSearch();
	            },
	            onFocus: function onFocus(e) {
	              return e.stopPropagation();
	            }
	          },
	          _react2.default.createElement(_PageviewRounded2.default, {
	            className: classes.searchRoundedIcon,
	            size: 'large'
	          })
	        )
	      ),
	      ExternalFilter && _react2.default.createElement(
	        'div',
	        {
	          'data-apim-test': 'expand-search-filter-container',
	          className: (0, _clsx2.default)(classes.smallSearchField, classes.externalFilterContainer)
	        },
	        _react2.default.createElement(ExternalFilter, null)
	      )
	    ),
	    (0, _lodash.isEmpty)(filteredList) && emptyListMessage && _react2.default.createElement(
	      _core.FormLabel,
	      {
	        'data-apim-test': id + '-empty-message',
	        className: classes.emptyListMessage
	      },
	      emptyListMessage
	    ),
	    filteredList.map(function () {
	      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var i = arguments[1];
	      return _react2.default.createElement(
	        _core.ExpansionPanel,
	        {
	          className: 'expand-panel-list-item',
	          key: item.uuid + i.toString(),
	          classes: {
	            root: classes.summaryRoot
	          }
	        },
	        _react2.default.createElement(
	          _core.ExpansionPanelSummary,
	          {
	            expandIcon: _react2.default.createElement(_ExpandMore2.default, null),
	            'aria-label': 'Expand',
	            'aria-controls': 'additional-actions1-content',
	            id: 'additional-actions1-header'
	          },
	          isDeleteIcon && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              _IconButton2.default,
	              {
	                className: classes.iconRoot,
	                size: 'small',
	                onClick: function onClick(e) {
	                  return onDelete(e, item, i);
	                },
	                onFocus: function onFocus(e) {
	                  return e.stopPropagation();
	                }
	              },
	              _react2.default.createElement(_CancelRounded2.default, null)
	            )
	          ),
	          isAddIcon && !isAdded(item) && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              _IconButton2.default,
	              {
	                className: classes.iconRoot,
	                size: 'small',
	                onClick: function onClick(e) {
	                  return onAdd(e, item, i);
	                },
	                onFocus: function onFocus(e) {
	                  return e.stopPropagation();
	                }
	              },
	              _react2.default.createElement(_AddCircleRounded2.default, null)
	            )
	          ),
	          isMoveUpIcon && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              _IconButton2.default,
	              {
	                className: classes.iconRoot,
	                size: 'small',
	                onClick: function onClick(e) {
	                  return onMoveUp(e, item, i);
	                },
	                onFocus: function onFocus(e) {
	                  return e.stopPropagation();
	                }
	              },
	              _react2.default.createElement(_ArrowUpward2.default, null)
	            )
	          ),
	          isMoveDownIcon && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              _IconButton2.default,
	              {
	                className: classes.iconRoot,
	                size: 'small',
	                onClick: function onClick(e) {
	                  return onMoveDown(e, item, i);
	                },
	                onFocus: function onFocus(e) {
	                  return e.stopPropagation();
	                }
	              },
	              _react2.default.createElement(_ArrowDownward2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _core.Grid,
	            { container: true, className: classes.labelContainer },
	            _react2.default.createElement(
	              _core.Grid,
	              Object.assign({ item: true }, panelSubtitle && { md: 6 }),
	              _react2.default.createElement(
	                _core.FormLabel,
	                { classes: { root: classes.labelRoot } },
	                item.name
	              ),
	              SecondaryLabelComponent && _react2.default.createElement(SecondaryLabelComponent, { item: item })
	            ),
	            panelSubtitle && _react2.default.createElement(
	              _core.Grid,
	              { item: true, md: 6 },
	              (0, _lodash.isFunction)(panelSubtitle) ? panelSubtitle(item) : panelSubtitle
	            )
	          ),
	          (item.type === _constants.TYPE_API_GROUP || isApiGroup && !isApiDetails) && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(_core.Badge, {
	              classes: { badge: classes.badge },
	              overlap: 'rectangle',
	              badgeContent: 'API Group'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _core.ExpansionPanelDetails,
	          { classes: { root: classes.expansionPanelDetails } },
	          _react2.default.createElement(
	            _core.Typography,
	            { variant: 'body1' },
	            item.description,
	            !(0, _lodash.isEmpty)(item.arguments) && _react2.default.createElement(_components.DynamicForm, {
	              fields: item.arguments,
	              handleChange: handleChangeDynamicForm,
	              index: i
	            })
	          ),
	          isApiDetails && item.portalStatus && _react2.default.createElement(
	            'div',
	            { className: classes.detailsContainer },
	            _react2.default.createElement(
	              'div',
	              { className: classes.detailsCol },
	              'API State'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: classes.detailsCol },
	              item.portalStatus
	            )
	          ),
	          isApiGroup && item.apis && item.apis.length > 0 && item.apis.map(function () {
	            var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            return _react2.default.createElement(
	              'div',
	              { key: api.uuid, className: classes.detailsContainer },
	              _react2.default.createElement(
	                'div',
	                { className: classes.detailsCol },
	                api.name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: classes.detailsCol },
	                api.status
	              )
	            );
	          }),
	          (isApiDetails || isApiGroup) && _react2.default.createElement(_core.Divider, { className: classes.detailDivider }),
	          !(0, _lodash.isEmpty)(item.availableItems) && _react2.default.createElement(_components.TableWithSelectableRow, {
	            items: item.availableItems,
	            selectedRow: getSelectedItem(item),
	            onSelectRow: function onSelectRow(selectedRow) {
	              return onSelectItem(item.uuid, selectedRow);
	            }
	          })
	        )
	      );
	    }),
	    isLoadMore && _react2.default.createElement(
	      _core.ListItem,
	      { key: 'button-loadmore' },
	      _react2.default.createElement(
	        _core.Grid,
	        { container: true, justify: 'center' },
	        _react2.default.createElement(
	          _core.Button,
	          {
	            variant: 'contained',
	            color: 'secondary',
	            className: classes.loadMore,
	            onClick: loadMoreClick
	          },
	          loadMoreText
	        )
	      )
	    )
	  );
	}
	
	ExpandPanelContainer.propTypes = {
	  id: _propTypes2.default.string,
	  error: _propTypes2.default.bool,
	  isDeleteIcon: _propTypes2.default.bool,
	  onDeleteItem: _propTypes2.default.func,
	  isAddIcon: _propTypes2.default.bool,
	  isAdded: _propTypes2.default.func,
	  onAddItem: _propTypes2.default.func,
	  isMoveUpIcon: _propTypes2.default.bool,
	  onMoveUpItem: _propTypes2.default.func,
	  isMoveDownIcon: _propTypes2.default.bool,
	  onMoveDownItem: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  placeHolderText: _propTypes2.default.string,
	  defaultList: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  onLoadMore: _propTypes2.default.func,
	  isLoadMore: _propTypes2.default.bool,
	  hasSearch: _propTypes2.default.func,
	  onSearchTextChange: _propTypes2.default.func,
	  loadMoreText: _propTypes2.default.string,
	  handleChangeDynamicForm: _propTypes2.default.func,
	  getSelectedItem: _propTypes2.default.func,
	  onSelectItem: _propTypes2.default.func,
	  SecondaryLabelComponent: _propTypes2.default.func,
	  ExternalFilter: _propTypes2.default.func,
	  panelSubtitle: _propTypes2.default.func,
	  emptyListMessage: _propTypes2.default.string,
	  isApiDetails: _propTypes2.default.bool,
	  isApiGroup: _propTypes2.default.bool
	};

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      width: '100%',
	      marginTop: 10,
	      marginBottom: 20,
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      padding: '5px 1px 10px 1px'
	    },
	    rootError: {
	      border: '1px solid ' + (0, _lodash.get)(theme, 'color.error'),
	      borderRadius: 4
	    },
	    labelRoot: {
	      color: (0, _lodash.get)(theme, 'color.bodyText')
	    },
	    iconRoot: {
	      marginTop: 4,
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	    },
	    labelContainer: {
	      marginTop: 5,
	      padding: 5
	    },
	    listTitle: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.title'),
	      marginBottom: 2
	    },
	    emptyListMessage: {
	      borderRadius: (0, _lodash.get)(theme, 'borderRadius.br3'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.warning'),
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      padding: '5px 10px',
	      display: 'inline-block'
	    },
	    textField: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	      borderRadius: (0, _lodash.get)(theme, 'borderRadius.br3'),
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      width: '100%',
	      height: '40px',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      '& .MuiInputBase-root': {
	        backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground')
	      },
	      '& .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.primaryButtonBackground'), 0.4)
	      },
	      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.primaryButtonHover')
	      },
	      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	      },
	      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.error')
	      },
	      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
	        backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.1),
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.5)
	      }
	    },
	    listContainer: {
	      width: '99%',
	      height: '98%'
	    },
	    listSubtitle: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      marginBottom: 10
	    },
	    searchContainer: {
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'baseline',
	      marginBottom: 10,
	      marginTop: 0
	    },
	    smallSearchField: {
	      width: '48%',
	      '& input': {
	        backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground')
	      }
	    },
	    externalFilterContainer: {
	      marginBottom: 8
	    },
	    expansionPanelDetails: {
	      flexFlow: 'wrap'
	    },
	    table: {
	      '& tbody': {
	        cursor: 'pointer'
	      },
	      '& td': {
	        fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	        color: (0, _lodash.get)(theme, 'color.bodyText')
	      },
	      '& .MuiTableRow-root.Mui-selected': {
	        '& td': {
	          fontWeight: 900
	        }
	      }
	    },
	    summaryRoot: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	      border: '1px solid ' + (0, _lodash.get)(theme, 'color.borderColor'),
	      '& .MuiExpansionPanelSummary-expandIcon': {
	        color: (0, _lodash.get)(theme, 'color.link')
	      }
	    },
	    detailsContainer: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      borderTop: '1px solid ' + (0, _lodash.get)(theme, 'color.borderColor'),
	      width: '100%',
	      marginTop: 10
	    },
	    detailsCol: {
	      width: '48%',
	      float: 'left',
	      padding: 5
	    },
	    detailDivider: {
	      height: 0,
	      width: '100%',
	      borderTop: '1px solid ' + (0, _lodash.get)(theme, 'color.borderColor')
	    },
	    badge: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      width: '100px',
	      right: '200px',
	      top: '45%',
	      borderRadius: 2
	    },
	    searchIcon: {
	      padding: 1,
	      marginRight: 10,
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	    },
	    searchRoundedIcon: {
	      fontSize: '3.2rem'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      width: '100%',
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground')
	    },
	    listButton: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.05) + ' !important',
	      color: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.8) + ' !important',
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText')
	    },
	    dropdownIndicator: {
	      color: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.5) + ' !important'
	    },
	    listItem: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	      color: (0, _lodash.get)(theme, 'color.bodyText')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ListFilesRaw;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _CancelRounded = __webpack_require__(240);
	
	var _CancelRounded2 = _interopRequireDefault(_CancelRounded);
	
	var _styles = __webpack_require__(606);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListFilesRaw(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var title = props.title,
	      defaultText = props.defaultText,
	      files = props.files,
	      onRemoveFile = props.onRemoveFile,
	      id = props.id;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: id, className: classes.selectedFileContainer, 'data-apim-test': id },
	    _react2.default.createElement(
	      'h4',
	      { className: classes.formLabel },
	      title
	    ),
	    files.length === 0 && _react2.default.createElement(
	      _core.Box,
	      { className: classes.uploadFileSection, p: 1 },
	      _react2.default.createElement(
	        _core.Typography,
	        null,
	        defaultText
	      )
	    ),
	    files.map(function (file) {
	      return _react2.default.createElement(
	        _core.Box,
	        { key: file.name, className: classes.uploadFileSection, p: 1 },
	        _react2.default.createElement(
	          _core.Typography,
	          null,
	          file.name
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { className: classes.fileSizeText },
	          file.size && file.size + ' bytes'
	        ),
	        _react2.default.createElement(_CancelRounded2.default, {
	          color: 'primary',
	          onClick: function onClick() {
	            return onRemoveFile(file);
	          }
	        })
	      );
	    })
	  );
	}
	
	ListFilesRaw.propTypes = {
	  files: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.shape({})),
	  onRemoveFile: _propTypes.PropTypes.func,
	  defaultText: _propTypes.PropTypes.string,
	  title: _propTypes.PropTypes.string,
	  id: _propTypes.PropTypes.string
	};

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FileDropzone;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(1399);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _PublishRounded = __webpack_require__(957);
	
	var _PublishRounded2 = _interopRequireDefault(_PublishRounded);
	
	var _ListFiles = __webpack_require__(1471);
	
	var _ListFiles2 = _interopRequireDefault(_ListFiles);
	
	var _styles = __webpack_require__(606);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FileDropzone(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var handleFiles = props.handleFiles,
	      allowedFileExtentions = props.allowedFileExtentions,
	      _props$listFileTitles = props.listFileTitles,
	      listFileTitles = _props$listFileTitles === undefined ? ['Selected files'] : _props$listFileTitles,
	      onRemoveFile = props.onRemoveFile,
	      isValidation = props.isValidation,
	      validationMessage = props.validationMessage,
	      id = props.id,
	      _props$defaultUploade = props.defaultUploaderText,
	      defaultUploaderText = _props$defaultUploade === undefined ? 'Uploader' : _props$defaultUploade,
	      _props$defaultSelecte = props.defaultSelectedText,
	      defaultSelectedText = _props$defaultSelecte === undefined ? 'No files selected.' : _props$defaultSelecte,
	      _props$isMultipleTitl = props.isMultipleTitle,
	      isMultipleTitle = _props$isMultipleTitl === undefined ? false : _props$isMultipleTitl,
	      title = props.title,
	      selectedFiles = props.selectedFiles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: id, 'data-apim-test': id },
	    _react2.default.createElement(
	      'h4',
	      { className: classes.formLabel },
	      title
	    ),
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactDropzone2.default,
	        {
	          accept: selectedFiles.acceptFileTypes,
	          maxSize: selectedFiles.maxSize,
	          maxFiles: selectedFiles.maxFiles,
	          onDrop: function onDrop(acceptedFiles) {
	            return handleFiles(acceptedFiles);
	          }
	        },
	        function (_ref) {
	          var getRootProps = _ref.getRootProps,
	              getInputProps = _ref.getInputProps;
	          return _react2.default.createElement(
	            'div',
	            Object.assign({}, getRootProps(), { className: classes.container }),
	            _react2.default.createElement('input', getInputProps()),
	            _react2.default.createElement(
	              'div',
	              { className: classes.fileLabel },
	              _react2.default.createElement(_PublishRounded2.default, { color: 'primary', fontSize: 'large' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                defaultUploaderText
	              )
	            )
	          );
	        }
	      ),
	      _react2.default.createElement(
	        _core.FormHelperText,
	        {
	          classes: {
	            root: classes.root
	          },
	          error: selectedFiles.error
	        },
	        _react2.default.createElement(
	          'div',
	          { className: classes.helperText },
	          selectedFiles.helperText
	        )
	      )
	    ),
	    isValidation && _react2.default.createElement(
	      'div',
	      { className: classes.error },
	      validationMessage
	    ),
	    isMultipleTitle ? allowedFileExtentions.map(function (value, index) {
	      var filterFiles = selectedFiles.files.filter(function (file) {
	        return file.ext === value;
	      });
	      return _react2.default.createElement(_ListFiles2.default, {
	        title: listFileTitles[index] ? listFileTitles[index] : listFileTitles[0],
	        files: filterFiles,
	        defaultText: defaultSelectedText,
	        onRemoveFile: onRemoveFile,
	        id: 'selected-container-' + index.toString(),
	        key: 'file_' + index.toString()
	      });
	    }) : _react2.default.createElement(_ListFiles2.default, {
	      title: listFileTitles[0],
	      files: selectedFiles.files,
	      onRemoveFile: onRemoveFile,
	      defaultText: defaultSelectedText,
	      id: 'file-selected-container'
	    })
	  );
	}
	
	FileDropzone.propTypes = {
	  selectedFiles: _propTypes.PropTypes.shape({}),
	  handleFiles: _propTypes.PropTypes.func,
	  allowedFileExtentions: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.string),
	  listFileTitles: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.string),
	  onRemoveFile: _propTypes.PropTypes.func,
	  isValidation: _propTypes.PropTypes.bool,
	  validationMessage: _propTypes.PropTypes.string,
	  id: _propTypes.PropTypes.string,
	  defaultUploaderText: _propTypes.PropTypes.string,
	  defaultSelectedText: _propTypes.PropTypes.string,
	  isMultipleTitle: _propTypes.PropTypes.bool,
	  title: _propTypes.PropTypes.string
	};

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      borderRadius = _ref.borderRadius,
	      color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	
	  return {
	    Footer: {
	      alignItems: 'center',
	      backgroundColor: (0, _get2.default)(color, 'footerBackground'),
	      bottom: 0,
	      boxSizing: 'border-box',
	      color: (0, _get2.default)(color, 'footerText'),
	      display: 'flex',
	      fontFamily: (0, _get2.default)(typography, 'footerText'),
	      fontSize: (0, _get2.default)(fontSize, 'footerText'),
	      height: (0, _get2.default)(misc, 'footerHeight'),
	      justifyContent: 'space-between',
	      left: 0,
	      padding: '0 40px 0 40px',
	      position: 'fixed',
	      width: '100%',
	      zIndex: 50
	    },
	
	    FooterHelpButton: {
	      backgroundColor: (0, _get2.default)(color, 'footerBackground') + ' !important',
	      border: '1px solid ' + (0, _get2.default)(color, 'footerLink'),
	      borderRadius: (0, _get2.default)(borderRadius, 'br3'),
	      boxShadow: 'none',
	      color: (0, _get2.default)(color, 'footerLink') + ' !important',
	      cursor: 'pointer',
	      fontFamily: (0, _get2.default)(typography, 'footerText'),
	      fontSize: (0, _get2.default)(fontSize, 'footerText'),
	      fontWeight: 'bold',
	      textTransform: 'capitalize',
	
	      '&:hover, &:active': {
	        backgroundColor: (0, _get2.default)(color, 'footerBackground'),
	        boxShadow: 'none',
	        color: (0, _get2.default)(color, 'footerLink') + ' !important'
	      },
	
	      '&:focus': {
	        outlineWidth: '1px !important',
	        outlineOffset: '-4px !important',
	        outlineColor: (0, _get2.default)(color, 'footerLink') + ' !important',
	        outlineStyle: 'solid !important',
	        outlineRadius: '3px !important'
	      }
	    }
	  };
	};

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormActionButtons;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1475);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormActionButtons(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      assistText = props.assistText,
	      _props$cancelText = props.cancelText,
	      cancelText = _props$cancelText === undefined ? 'Cancel' : _props$cancelText,
	      _props$nextText = props.nextText,
	      nextText = _props$nextText === undefined ? 'Next' : _props$nextText,
	      onCancelClick = props.onCancelClick,
	      onNextClick = props.onNextClick,
	      _props$showCancel = props.showCancel,
	      showCancel = _props$showCancel === undefined ? true : _props$showCancel,
	      _props$showNext = props.showNext,
	      showNext = _props$showNext === undefined ? true : _props$showNext,
	      _props$isDisabled = props.isDisabled,
	      isDisabled = _props$isDisabled === undefined ? false : _props$isDisabled;
	
	
	  return _react2.default.createElement(
	    _core.AppBar,
	    { className: classes.appBar, id: id, 'data-layer7-test': id },
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true },
	      _react2.default.createElement(_core.Grid, { md: 2, item: true }),
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 2, item: true, className: classes.cancelContainer },
	        showCancel && _react2.default.createElement(
	          _core.Button,
	          {
	            id: 'cancel-button',
	            'data-apim-test': 'cancel-button',
	            color: 'primary',
	            variant: 'outlined',
	            className: classes.cancelButton,
	            onClick: function onClick() {
	              return onCancelClick();
	            }
	          },
	          cancelText
	        )
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 5, item: true },
	        _react2.default.createElement(
	          'div',
	          { className: classes.saveContainer },
	          assistText && _react2.default.createElement(
	            'div',
	            { className: classes.assistText },
	            assistText
	          ),
	          showNext && _react2.default.createElement(
	            _core.Button,
	            {
	              id: 'next-button',
	              'data-apim-test': 'next-button',
	              variant: 'contained',
	              color: 'secondary',
	              className: classes.saveButton,
	              onClick: function onClick() {
	                return onNextClick();
	              },
	              disabled: isDisabled
	            },
	            nextText
	          )
	        )
	      ),
	      _react2.default.createElement(_core.Grid, { md: 3, item: true })
	    )
	  );
	}
	
	FormActionButtons.propTypes = {
	  id: _propTypes2.default.string,
	  assistText: _propTypes2.default.string,
	  cancelText: _propTypes2.default.string,
	  nextText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({})]),
	  onCancelClick: _propTypes2.default.func,
	  onNextClick: _propTypes2.default.func,
	  showCancel: _propTypes2.default.bool,
	  showNext: _propTypes2.default.bool,
	  isDisabled: _propTypes2.default.bool
	};

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    appBar: {
	      paddingTop: '24px',
	      top: 'auto',
	      bottom: 0,
	      background: (0, _lodash.get)(theme, 'color.uiBackground'),
	      minHeight: '84px',
	      position: 'fixed',
	      width: 'auto !important',
	      right: 0,
	      left: 0,
	      paddingBottom: '2px'
	    },
	    assistText: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      float: 'left',
	      paddingTop: '5px',
	      paddingRight: '8px'
	    },
	    cancelContainer: {
	      paddingLeft: '30px'
	    },
	    cancelButton: {
	      textTransform: 'none',
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.primaryButtonText'),
	      borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      lineHeight: (0, _lodash.get)(theme, 'lineHeight.lh20')
	    },
	    saveContainer: {
	      float: 'right',
	      paddingLeft: '30px',
	      paddingRight: '30px'
	    },
	    saveButton: {
	      textTransform: 'none',
	      color: (0, _lodash.get)(theme, 'color.primaryButtonText'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      float: 'left',
	      marginRight: '10px',
	      lineHeight: (0, _lodash.get)(theme, 'lineHeight.lh20')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormAutoCompleteCombo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Autocomplete = __webpack_require__(241);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _propTypes = __webpack_require__(5);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(1477);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormAutoCompleteCombo(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var getOptionLabelDefaultFn = function getOptionLabelDefaultFn(option) {
	    return (0, _get2.default)(option, 'name');
	  };
	  var getOptionSelectedDefaultFn = function getOptionSelectedDefaultFn(option, value) {
	    return value.name === option.name;
	  };
	  var fieldContainerClass = props.fieldContainerClass,
	      id = props.id,
	      name = props.name,
	      _props$data = props.data,
	      data = _props$data === undefined ? [] : _props$data,
	      selectedValues = props.selectedValues,
	      _onChange = props.onChange,
	      isMultiple = props.isMultiple,
	      isLoading = props.isLoading,
	      helperText = props.helperText,
	      error = props.error,
	      _props$inputLabel = props.inputLabel,
	      inputLabel = _props$inputLabel === undefined ? '' : _props$inputLabel,
	      hideLabel = props.hideLabel,
	      _props$getOptionLabel = props.getOptionLabel,
	      getOptionLabel = _props$getOptionLabel === undefined ? getOptionLabelDefaultFn : _props$getOptionLabel,
	      _props$getOptionSelec = props.getOptionSelected,
	      getOptionSelected = _props$getOptionSelec === undefined ? getOptionSelectedDefaultFn : _props$getOptionSelec;
	
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _clsx2.default)(fieldContainerClass, classes.fieldContainer),
	      id: id, 'data-apim-test': id, 'data-layer7-test': id
	    },
	    _react2.default.createElement(
	      'div',
	      { className: classes.formLabelContainer },
	      _react2.default.createElement(
	        _core.FormLabel,
	        { className: hideLabel && classes.hideFormLabel },
	        name
	      )
	    ),
	    _react2.default.createElement(_Autocomplete2.default, Object.assign({
	      id: id + '-auto-complete-combo',
	      'data-apim-test': id + '-auto-complete-combo',
	      'data-layer7-test': id + '-auto-complete-combo',
	      options: data,
	      getOptionLabel: getOptionLabel,
	      getOptionSelected: getOptionSelected,
	      value: selectedValues,
	      multiple: isMultiple,
	      filterSelectedOptions: true,
	      onChange: function onChange(e, value) {
	        return _onChange(e, value);
	      }
	    }, error && { className: classes.error }, {
	      classes: {
	        root: classes.root
	      },
	      loading: isLoading,
	      loadingText: _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Loading...'
	        ),
	        _react2.default.createElement(_core.CircularProgress, { color: 'inherit', size: 20 })
	      ),
	      renderInput: function renderInput(params) {
	        return _react2.default.createElement(_core.TextField, Object.assign({}, params, {
	          className: classes.textField,
	          variant: 'outlined',
	          fullWidth: true,
	          label: inputLabel,
	          inputProps: Object.assign({}, params.inputProps, {
	            value: params.inputProps.value || getOptionLabel(selectedValues) || ''
	          })
	        }));
	      }
	    })),
	    _react2.default.createElement(
	      'p',
	      { className: (0, _clsx2.default)('MuiFormHelperText-root', classes.helperText, error && classes.error) },
	      helperText
	    )
	  );
	}
	
	FormAutoCompleteCombo.propTypes = {
	  fieldContainerClass: _propTypes.string,
	  id: _propTypes.string,
	  name: _propTypes.string,
	  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  onChange: _propTypes.func,
	  isLoading: _propTypes.bool,
	  isMultiple: _propTypes.bool,
	  selectedValues: (0, _propTypes.shape)({}),
	  helperText: _propTypes.string,
	  error: _propTypes.bool,
	  inputLabel: _propTypes.string,
	  hideLabel: _propTypes.bool,
	  getOptionLabel: _propTypes.func,
	  getOptionSelected: _propTypes.func
	};

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    fieldContainer: {
	      marginTop: 20,
	      marginBottom: 28
	    },
	    root: {
	      width: '100%',
	      '& .MuiInputLabel-outlined': {
	        fontWeight: (0, _get2.default)(theme, 'fontWeight.normal'),
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	        transform: 'translate(10px, 18px) scale(1)',
	        whiteSpace: (0, _get2.default)(theme, 'whiteSpace.nowrap'),
	        width: 'calc(100% - ' + (0, _get2.default)(theme, 'margin.m60') + ')'
	      },
	      '& .MuiInputBase-root': {
	        padding: 0,
	        '& input': {
	          height: (0, _get2.default)(theme, 'height.h40'),
	          padding: '0 10px !important'
	        },
	        '& fieldset': {
	          top: 0,
	          '& legend': {
	            width: 'auto !important',
	            display: 'none'
	          }
	        }
	      },
	      '& .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _utils.convertHexToRGB)((0, _get2.default)(theme, 'color.primaryButtonBackground'), 0.4)
	      },
	      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _get2.default)(theme, 'color.primaryButtonHover')
	      },
	      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _get2.default)(theme, 'color.primaryButtonBackground')
	      },
	      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _get2.default)(theme, 'color.error')
	      },
	      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
	        backgroundColor: (0, _utils.convertHexToRGB)((0, _get2.default)(theme, 'color.bodyText'), 0.1),
	        borderColor: (0, _utils.convertHexToRGB)((0, _get2.default)(theme, 'color.bodyText'), 0.5)
	      },
	      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
	        display: 'none'
	      }
	    },
	    error: {
	      '& fieldset': {
	        borderColor: (0, _get2.default)(theme, 'color.error') + ' !important'
	      },
	      color: (0, _get2.default)(theme, 'color.error')
	    },
	    formLabelContainer: {
	      width: '98%'
	    },
	    hideFormLabel: {
	      visibility: 'hidden'
	    },
	    textField: {
	      padding: (0, _get2.default)(theme, 'padding.p10') + ' 0'
	    },
	    helperText: {
	      color: (0, _get2.default)(theme, 'color.smallText') + ' !important',
	      fontFamily: (0, _get2.default)(theme, 'typography.smallText') + ' !important',
	      fontSize: (0, _get2.default)(theme, 'fontSize.smallText') + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormButtonGroup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1479);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormButtonGroup(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var _props$data = props.data,
	      data = _props$data === undefined ? [] : _props$data,
	      helperText = props.helperText,
	      handleChange = props.handleChange,
	      _props$error = props.error,
	      error = _props$error === undefined ? false : _props$error,
	      id = props.id,
	      value = props.value,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === undefined ? false : _props$disabled;
	
	
	  var isSelected = function isSelected(uuid) {
	    return uuid === null && value === undefined || uuid === value;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.fieldContainer, id: id },
	    _react2.default.createElement(
	      _core.FormLabel,
	      { className: classes.formLabel },
	      props.name
	    ),
	    _react2.default.createElement(
	      _core.ButtonGroup,
	      {
	        className: classes.buttonGroupField,
	        disabled: disabled
	      },
	      data && data.map(function (_ref) {
	        var uuid = _ref.uuid,
	            name = _ref.name;
	        return _react2.default.createElement(
	          _core.Button,
	          {
	            key: uuid,
	            'data-value': uuid,
	            variant: isSelected(uuid) ? 'contained' : 'outlined',
	            color: 'secondary',
	            onClick: function onClick(e) {
	              handleChange(e.currentTarget.dataset.value);
	            },
	            classes: {
	              contained: classes.contained
	            }
	          },
	          name
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _core.FormHelperText,
	      {
	        error: error
	      },
	      helperText
	    )
	  );
	}
	
	FormButtonGroup.propTypes = {
	  name: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  helperText: _propTypes2.default.string,
	  handleChange: _propTypes2.default.func,
	  error: _propTypes2.default.bool,
	  id: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool
	};

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    fieldContainer: {
	      marginTop: 20,
	      marginBottom: 20
	    },
	    formLabel: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontWeight: 700,
	      paddingLeft: 0
	    },
	    buttonGroupField: {
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      width: '99%',
	      borderRadius: 4,
	      padding: '10px 0',
	      '& .MuiButton-root': {
	        textTransform: 'none'
	      },
	      '& .MuiButton-outlined': {
	        color: (0, _lodash.get)(theme, 'color.bodyText'),
	        borderColor: (0, _lodash.get)(theme, 'color.borderColor')
	      }
	    },
	    contained: {
	      color: (0, _lodash.get)(theme, 'color.primaryButtonText'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	    },
	    helperText: {
	      color: (0, _lodash.get)(theme, 'color.smallText') + ' !important',
	      fontFamily: (0, _lodash.get)(theme, 'typography.smallText') + ' !important',
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText') + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = FormComboCheckBox;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _Autocomplete = __webpack_require__(241);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _AddCircleRounded = __webpack_require__(359);
	
	var _AddCircleRounded2 = _interopRequireDefault(_AddCircleRounded);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _styles = __webpack_require__(1481);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormComboCheckBox(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      data = props.data,
	      onSelect = props.onSelect,
	      selectedvalues = props.selectedvalues,
	      _props$inputLabel = props.inputLabel,
	      inputLabel = _props$inputLabel === undefined ? '' : _props$inputLabel;
	
	  var getOptionLabel = function getOptionLabel(option) {
	    return (0, _get2.default)(option, 'name');
	  };
	  var getOptionSelected = function getOptionSelected(option, value) {
	    return value.name === option.name;
	  };
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      highlightedOption = _useState2[0],
	      setHighlightedOption = _useState2[1];
	
	  var onChange = function onChange(e) {
	    if (e.key === 'Enter') {
	      onSelect(highlightedOption);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { id: id, 'data-apim-test': id },
	    _react2.default.createElement(_Autocomplete2.default, {
	      multiple: true,
	      options: data,
	      id: id + '-combo-checkbox',
	      'data-apim-test': id + '-combo-checkbox',
	      classes: {
	        root: classes.root,
	        tag: classes.tag,
	        input: classes.input,
	        focused: classes.focused,
	        inputRoot: classes.inputRoot,
	        listbox: classes.listbox,
	        clearIndicator: classes.clearIndicator,
	        option: classes.optionListContainer
	      },
	      getOptionLabel: getOptionLabel,
	      getOptionSelected: getOptionSelected,
	      value: selectedvalues,
	      onHighlightChange: function onHighlightChange(e, option) {
	        return setHighlightedOption(option);
	      },
	      onChange: onChange,
	      renderOption: function renderOption(option) {
	        return _react2.default.createElement(
	          'div',
	          {
	            onClick: function onClick() {
	              return onSelect(option);
	            },
	            className: classes.optionContainer
	          },
	          _react2.default.createElement(_AddCircleRounded2.default, {
	            fontSize: 'small',
	            className: classes.buttonContainer
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: classes.optionName },
	            option.name
	          )
	        );
	      },
	      className: classes.container,
	      renderInput: function renderInput(params) {
	        return _react2.default.createElement(_core.TextField, Object.assign({}, params, {
	          variant: 'outlined',
	          label: inputLabel,
	          placeholder: inputLabel,
	          fullWidth: true
	        }));
	      }
	    })
	  );
	}
	
	FormComboCheckBox.propTypes = {
	  id: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  onSelect: _propTypes2.default.func,
	  selectedvalues: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  inputLabel: _propTypes2.default.string
	};

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.white'),
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      '& fieldset': {
	        borderColor: (0, _lodash.get)(theme, 'color.borderColor') + ' !important',
	        top: 0,
	        '& legend': {
	          width: 'auto !important',
	          display: 'none'
	        }
	      },
	      '& .MuiIconButton-root': {
	        color: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	      },
	      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
	        display: 'none'
	      }
	    },
	    buttonContainer: {
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      marginRight: 8,
	      width: '4%',
	      float: 'left',
	      paddingTop: 6,
	      paddingBottom: 6
	    },
	    optionName: {
	      float: 'left',
	      paddingTop: 7,
	      paddingBottom: 6
	    },
	    tag: {
	      display: 'none'
	    },
	    input: {
	      color: (0, _lodash.get)(theme, 'color.bodyText')
	    },
	    inputRoot: {
	      color: (0, _lodash.get)(theme, 'color.bodyText')
	    },
	    listbox: {
	      color: (0, _lodash.get)(theme, 'color.bodyText')
	    },
	    clearIndicator: {
	      display: 'none'
	    },
	    optionContainer: {
	      width: '100%',
	      height: '100%'
	    },
	    optionListContainer: {
	      marginTop: 6,
	      marginBottom: 6,
	      paddingTop: 0,
	      paddingBottom: 0
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormDefaultTextField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(1483);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormDefaultTextField(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      name = props.name,
	      value = props.value,
	      helperText = props.helperText,
	      defaultText = props.defaultText,
	      _props$isDisabled = props.isDisabled,
	      isDisabled = _props$isDisabled === undefined ? false : _props$isDisabled,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === undefined ? false : _props$multiline,
	      _props$rows = props.rows,
	      rows = _props$rows === undefined ? 1 : _props$rows,
	      handleChange = props.handleChange,
	      handleBlur = props.handleBlur,
	      _props$error = props.error,
	      error = _props$error === undefined ? false : _props$error;
	
	  var defaultClass = error ? (0, _clsx2.default)(classes.defaultTextField, classes.error) : classes.defaultTextField;
	  return _react2.default.createElement(
	    'div',
	    { className: classes.fieldContainer, id: id, 'data-apim-test': id },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _core.FormLabel,
	        { className: classes.formLabel },
	        name
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      defaultText && _react2.default.createElement(
	        'div',
	        { className: defaultClass },
	        defaultText
	      ),
	      _react2.default.createElement(_core.TextField, {
	        classes: {
	          root: classes.textField
	        },
	        variant: 'outlined',
	        multiline: multiline,
	        error: error,
	        rows: rows,
	        onChange: function onChange(e) {
	          return handleChange(e.target.value);
	        },
	        onBlur: function onBlur(e) {
	          return handleBlur && handleBlur(e.target.value);
	        },
	        value: value,
	        disabled: isDisabled
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _core.FormHelperText,
	        { className: classes.helperText, error: error },
	        helperText
	      )
	    )
	  );
	}
	
	FormDefaultTextField.propTypes = {
	  name: _propTypes2.default.string,
	  helperText: _propTypes2.default.string,
	  handleChange: _propTypes2.default.func,
	  handleBlur: _propTypes2.default.func,
	  error: _propTypes2.default.bool,
	  id: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  rows: _propTypes2.default.number,
	  defaultText: _propTypes2.default.string,
	  multiline: _propTypes2.default.bool,
	  isDisabled: _propTypes2.default.bool
	};

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var styles = function styles(theme) {
	  return {
	    fieldContainer: {
	      marginTop: 20,
	      marginBottom: 20
	    },
	    formLabel: {
	      float: 'unset'
	    },
	    defaultTextField: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      maxWidth: '20%',
	      width: '20%',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      marginTop: 10,
	      paddingBottom: 6,
	      paddingRight: 10,
	      paddingLeft: 10,
	      paddingTop: 7,
	      float: 'left',
	      marginRight: 2,
	      border: '1px solid ' + (0, _lodash.get)(theme, 'color.borderColor'),
	      borderRadius: 4,
	      background: 'rgba(220, 220, 220, 0.80)'
	    },
	    error: {
	      borderColor: (0, _lodash.get)(theme, 'color.error')
	    },
	    textField: {
	      borderRadius: (0, _lodash.get)(theme, 'borderRadius.br3'),
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      marginTop: 10,
	      paddingTop: 10,
	      paddingBottom: 10,
	      width: '73.2%',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      '& input': {
	        padding: '0 10px'
	      },
	      '& .MuiInputBase-root': {
	        backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	        position: 'unset'
	      },
	      '& .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.primaryButtonBackground'), 0.4)
	      },
	      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.primaryButtonHover')
	      },
	      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	      },
	      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.error')
	      },
	      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
	        backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.1),
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.5)
	      },
	      '& .MuiFormHelperText-contained': {
	        marginLeft: 1
	      }
	    },
	    /* Todo - Material ui override style
	    textField: {
	      color: '#000000',
	      fontFamily: theme.typography.bodyText,
	      fontSize: theme.fontSize.bodyText,
	      width: '99%',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      '&$outlined:hover $outlined$notchedOutline': {
	        borderColor: '#cccccc',
	      },
	      '&$notchedOutline$focused $notchedOutline': {
	        borderColor: '#cccccc',
	      },
	      '&$error$notchedOutline': {
	        borderColor: '##f44336',
	      },
	      '&$contained': {
	        marginLeft: 1,
	      },
	      paddingTop: 10,
	      paddingBottom: 10,
	    },
	    notchedOutline: {},
	    outlined: {},
	    focused: {},
	    error: {},
	    contained: {},
	    */
	    helperText: {
	      color: (0, _lodash.get)(theme, 'color.smallText') + ' !important',
	      fontFamily: (0, _lodash.get)(theme, 'typography.smallText') + ' !important',
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText') + ' !important'
	    }
	
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormDialog;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1485);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormDialog(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var children = props.children,
	      isOpen = props.isOpen,
	      cancelText = props.cancelText,
	      submitText = props.submitText,
	      title = props.title,
	      dialogId = props.dialogId,
	      handleClose = props.handleClose,
	      onSubmit = props.onSubmit,
	      onCancel = props.onCancel,
	      submitButtonDisabled = props.submitButtonDisabled,
	      _props$isDialogConten = props.isDialogContentText,
	      isDialogContentText = _props$isDialogConten === undefined ? true : _props$isDialogConten;
	
	
	  return _react2.default.createElement(
	    _core.Dialog,
	    {
	      open: isOpen,
	      onClose: handleClose,
	      'aria-labelledby': 'alert-dialog-title',
	      'aria-describedby': 'alert-dialog-description',
	      id: dialogId,
	      classes: {
	        paper: classes.paper
	      }
	    },
	    _react2.default.createElement(
	      _core.DialogTitle,
	      {
	        id: 'alert-dialog-title',
	        className: classes.title
	      },
	      title
	    ),
	    _react2.default.createElement(
	      _core.DialogContent,
	      null,
	      isDialogContentText && _react2.default.createElement(
	        _core.DialogContentText,
	        { id: 'alert-dialog-content' },
	        children
	      ),
	      !isDialogContentText && _react2.default.createElement(
	        'div',
	        null,
	        children
	      )
	    ),
	    _react2.default.createElement(
	      _core.DialogActions,
	      null,
	      _react2.default.createElement(
	        _core.Button,
	        {
	          onClick: onSubmit,
	          variant: 'contained',
	          color: 'secondary',
	          className: classes.saveButton,
	          disabled: !!submitButtonDisabled
	        },
	        submitText
	      ),
	      _react2.default.createElement(
	        _core.Button,
	        {
	          onClick: onCancel,
	          variant: 'outlined',
	          className: classes.cancelButton
	        },
	        cancelText
	      )
	    )
	  );
	}
	
	FormDialog.propTypes = {
	  children: _propTypes2.default.node,
	  isOpen: _propTypes2.default.bool,
	  cancelText: _propTypes2.default.string,
	  submitText: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  dialogId: _propTypes2.default.string,
	  handleClose: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  submitButtonDisabled: _propTypes2.default.bool,
	  isDialogContentText: _propTypes2.default.bool
	};

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    paper: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground')
	    },
	    title: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.title'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontWeight: 'bold'
	    },
	    cancelButton: {
	      textTransform: 'none',
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.primaryButtonText'),
	      borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	    },
	    saveButton: {
	      textTransform: 'none',
	      color: (0, _lodash.get)(theme, 'color.primaryButtonText'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormRadioGroup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1487);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormRadioGroup(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      name = props.name,
	      data = props.data,
	      selected = props.selected,
	      tooltip = props.tooltip,
	      _onChange = props.onChange;
	
	
	  return _react2.default.createElement(
	    _core.FormControl,
	    {
	      component: 'fieldset',
	      className: classes.formControl,
	      id: id
	    },
	    name && _react2.default.createElement(
	      _core.FormLabel,
	      {
	        component: 'h3',
	        className: classes.formLabel
	      },
	      _react2.default.createElement(
	        'span',
	        null,
	        name
	      ),
	      tooltip && _react2.default.createElement(
	        _core.Tooltip,
	        { placement: 'right', title: tooltip },
	        _react2.default.createElement(_Help2.default, { className: classes.helpIcon })
	      )
	    ),
	    _react2.default.createElement(
	      _core.RadioGroup,
	      {
	        value: selected,
	        onChange: function onChange(e) {
	          _onChange((0, _get2.default)(e, 'target.value'));
	        },
	        name: name
	      },
	      data.map(function (option) {
	        return _react2.default.createElement(_core.FormControlLabel, {
	          key: option.id,
	          value: option.id,
	          control: _react2.default.createElement(_core.Radio, { classes: { root: classes.radio } }),
	          label: _react2.default.createElement(
	            _core.Typography,
	            { className: classes.radioLabel },
	            option.name
	          )
	        });
	      })
	    )
	  );
	}
	
	FormRadioGroup.propTypes = {
	  selected: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  id: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  name: _propTypes2.default.string,
	  tooltip: _propTypes2.default.string
	};

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    formControl: {
	      fontSize: 12
	    },
	    formLabel: {
	      color: (0, _lodash.get)(theme, 'color.bodyText') + ' !important', // avoiding overwrite by white color
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.title'),
	      fontWeight: 700,
	      marginBottom: 10,
	      '& span': {
	        verticalAlign: 'middle'
	      }
	    },
	    radioLabel: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      fontWeight: 700
	    },
	    helpIcon: {
	      color: (0, _lodash.get)(theme, 'color.link'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.title'),
	      marginLeft: 10,
	      verticalAlign: 'middle',
	      cursor: 'pointer'
	    },
	    radio: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      fontWeight: 700,
	      '& svg': {
	        width: 16,
	        height: 16
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormSelect;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(1489);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormSelect(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var fieldContainerClass = props.fieldContainerClass,
	      id = props.id,
	      name = props.name,
	      _props$data = props.data,
	      data = _props$data === undefined ? [] : _props$data,
	      helperText = props.helperText,
	      handleChange = props.handleChange,
	      _props$error = props.error,
	      error = _props$error === undefined ? false : _props$error,
	      defaultText = props.defaultText,
	      value = props.value,
	      _props$selectFieldCla = props.selectFieldClass,
	      selectFieldClass = _props$selectFieldCla === undefined ? null : _props$selectFieldCla,
	      _props$noNoneOption = props.noNoneOption,
	      noNoneOption = _props$noNoneOption === undefined ? false : _props$noNoneOption,
	      _props$noNativeSelect = props.noNativeSelect,
	      noNativeSelect = _props$noNativeSelect === undefined ? false : _props$noNativeSelect,
	      optional = props.optional,
	      warning = props.warning,
	      disabled = props.disabled,
	      hideLabel = props.hideLabel,
	      multiple = props.multiple,
	      renderValue = props.renderValue,
	      displayEmpty = props.displayEmpty;
	
	
	  var rootSelectClass = warning ? (0, _clsx2.default)(classes.selectField, classes.warningSelectField) : classes.selectField;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _clsx2.default)(fieldContainerClass, classes.fieldContainer),
	      id: id, 'data-apim-test': id, 'data-layer7-test': id
	    },
	    _react2.default.createElement(
	      'div',
	      { className: classes.formLabelContainer },
	      _react2.default.createElement(
	        _core.FormLabel,
	        { className: hideLabel && classes.hideFormLabel },
	        name
	      ),
	      optional && _react2.default.createElement(
	        _core.FormLabel,
	        { className: classes.optional },
	        'Optional'
	      )
	    ),
	    noNativeSelect ? _react2.default.createElement(
	      _core.Select,
	      {
	        className: (0, _clsx2.default)(selectFieldClass, rootSelectClass),
	        error: error,
	        onChange: function onChange(e) {
	          return handleChange(e.target.value);
	        },
	        value: value,
	        displayEmpty: displayEmpty,
	        renderValue: renderValue,
	        disabled: disabled,
	        inputProps: {
	          disabled: disabled
	        },
	        multiple: multiple
	      },
	      !noNoneOption && _react2.default.createElement(
	        _core.MenuItem,
	        { value: '0' },
	        defaultText || 'none'
	      ),
	      data && data.map(function (obj) {
	        return _react2.default.createElement(
	          _core.MenuItem,
	          { key: obj.uuid, value: obj.uuid },
	          multiple && _react2.default.createElement(_core.Checkbox, { className: classes.checkbox, checked: value.includes(obj.uuid) }),
	          obj.name || obj.text
	        );
	      })
	    ) : _react2.default.createElement(
	      _core.NativeSelect,
	      {
	        className: (0, _clsx2.default)(selectFieldClass, rootSelectClass),
	        error: error,
	        onChange: function onChange(e) {
	          return handleChange(e);
	        },
	        value: value,
	        disabled: disabled,
	        inputProps: {
	          disabled: disabled
	        }
	      },
	      !noNoneOption && _react2.default.createElement(
	        'option',
	        { value: '0' },
	        defaultText || 'none'
	      ),
	      data && data.map(function (obj) {
	        return _react2.default.createElement(
	          'option',
	          { key: obj.uuid, value: obj.uuid },
	          obj.name || obj.text
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _core.FormHelperText,
	      {
	        className: classes.helperText,
	        error: error
	      },
	      helperText
	    )
	  );
	}
	
	FormSelect.propTypes = {
	  fieldContainerClass: _propTypes.string,
	  id: _propTypes.string,
	  name: _propTypes.string,
	  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  helperText: _propTypes.string,
	  handleChange: _propTypes.func,
	  error: _propTypes.bool,
	  defaultText: _propTypes.string,
	  value: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)(_propTypes.string)]),
	  noNoneOption: _propTypes.bool,
	  noNativeSelect: _propTypes.bool,
	  selectFieldClass: _propTypes.string,
	  optional: _propTypes.bool,
	  warning: _propTypes.bool,
	  disabled: _propTypes.bool,
	  hideLabel: _propTypes.bool,
	  multiple: _propTypes.bool,
	  renderValue: _propTypes.func,
	  displayEmpty: _propTypes.bool
	};

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _modifyColour = __webpack_require__(87);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = function styles(theme) {
	  return _defineProperty({
	    fieldContainer: {
	      marginTop: 20,
	      marginBottom: 20
	    },
	    formLabelContainer: {
	      width: '98%'
	    },
	    hideFormLabel: {
	      visibility: 'hidden'
	    },
	    optional: {
	      float: 'right',
	      opacity: 0.5
	    },
	    selectField: {
	      border: '1px solid ' + (0, _modifyColour.modifyAlpha)((0, _lodash.get)(theme, 'color.primaryButtonBackground'), 0.4),
	      height: (0, _lodash.get)(theme, 'height.h40'),
	      padding: (0, _lodash.get)(theme, 'padding.p5') + ' ' + (0, _lodash.get)(theme, 'padding.p10'),
	      margin: (0, _lodash.get)(theme, 'margin.m10') + ' 0 0 0',
	      width: '100%',
	      '&.MuiNativeSelect-select:focus, .MuiNativeSelect-select, .MuiSelect-select:focus, .MuiSelect-select': {
	        borderRadius: 'unset',
	        backgroundColor: 'transparent'
	      },
	      '&.MuiInput-underline.Mui-error': {
	        borderColor: (0, _lodash.get)(theme, 'color.error') + ' !important'
	      },
	      '&.MuiInput-underline.Mui-error:after': {
	        borderBottomColor: 'transparent'
	      },
	      '&.MuiInput-underline:after, .MuiInput-underline:before': {
	        borderBottom: 0
	      },
	      '&.MuiInput-underline:before': {
	        borderBottom: 0
	      },
	      '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
	        borderBottom: 0
	      }
	    },
	    checkbox: {
	      padding: '0 ' + (0, _lodash.get)(theme, 'padding.p6') + ' 0 0'
	    },
	    warningSelectField: {
	      color: (0, _lodash.get)(theme, 'color.red')
	    },
	    /* Todo : material ui overide style
	    selectField: {
	      fontFamily: theme.typography.bodyText,
	      fontSize: theme.fontSize.bodyText,
	      width: '99%',
	      border: '1px solid #cccccc',
	      borderRadius: 4,
	      color: '#000000',
	      padding: '2px 0px 2px 6px',
	    },
	    selectFieldRoot: {
	      '&$focused': {
	        borderRadius: 'unset',
	        backgroundColor: 'transparent',
	      },
	      '&$outlined$error': {
	        borderColor: '#f44336 !important',
	      },
	      '&$outlined$error:after': {
	        borderBottomColor: 'transparent',
	      },
	      '&$outlined:after, $outlined:before': {
	        borderBottom: 0,
	      },
	    },
	    outlined: {},
	    focused: {},
	    error: {},
	    underline: {},
	    */
	    helperText: {
	      color: (0, _lodash.get)(theme, 'color.smallText') + ' !important',
	      fontFamily: (0, _lodash.get)(theme, 'typography.smallText') + ' !important',
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText') + ' !important'
	    }
	
	  }, '@media (max-width: ' + (0, _lodash.get)(theme, 'breakpoint.xs') + ')', {
	    fieldContainer: {
	      marginTop: 0,
	      marginBottom: 0
	    },
	    hideFormLabel: {
	      display: 'none'
	    }
	  });
	};
	
	exports.default = styles;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormTextField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _propTypes = __webpack_require__(5);
	
	var _styles = __webpack_require__(1491);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormTextField(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var fieldContainerClass = props.fieldContainerClass,
	      id = props.id,
	      name = props.name,
	      value = props.value,
	      helperText = props.helperText,
	      errorHelperText = props.errorHelperText,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === undefined ? false : _props$disabled,
	      handleChange = props.handleChange,
	      handleBlur = props.handleBlur,
	      _props$rows = props.rows,
	      rows = _props$rows === undefined ? 1 : _props$rows,
	      _props$error = props.error,
	      error = _props$error === undefined ? false : _props$error,
	      _props$type = props.type,
	      type = _props$type === undefined ? 'string' : _props$type,
	      optional = props.optional,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === undefined ? false : _props$multiline,
	      maxLength = props.maxLength,
	      onKeyPress = props.onKeyPress,
	      placeholder = props.placeholder,
	      _props$textFieldClass = props.textFieldClass,
	      textFieldClass = _props$textFieldClass === undefined ? null : _props$textFieldClass,
	      hideLabel = props.hideLabel;
	
	
	  var textClass = textFieldClass ? (0, _clsx2.default)(textFieldClass, classes.textField) : classes.textField;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _clsx2.default)(fieldContainerClass, classes.fieldContainer),
	      id: id, 'data-apim-test': id, 'data-layer7-test': id
	    },
	    _react2.default.createElement(
	      'div',
	      { className: classes.formLabelContainer },
	      _react2.default.createElement(
	        _core.FormLabel,
	        { className: hideLabel && classes.hideFormLabel },
	        name
	      ),
	      optional && _react2.default.createElement(
	        _core.FormLabel,
	        { className: classes.optional },
	        'Optional'
	      )
	    ),
	    _react2.default.createElement(_core.TextField, {
	      classes: {
	        root: textClass
	      },
	      variant: 'outlined',
	      disabled: disabled,
	      error: error,
	      onChange: function onChange(e) {
	        return handleChange(e.target.value);
	      },
	      onBlur: function onBlur(e) {
	        return handleBlur && handleBlur(e.target.value);
	      },
	      InputProps: {
	        className: errorHelperText && classes.errorHelperText
	      },
	      inputProps: Object.assign({}, maxLength ? { maxLength: maxLength } : {}),
	      value: value || '',
	      helperText: helperText,
	      FormHelperTextProps: {
	        className: classes.helperText
	      },
	      type: type,
	      multiline: multiline,
	      rows: rows,
	      onKeyPress: onKeyPress,
	      placeholder: placeholder
	    })
	  );
	} /* eslint-disable */
	
	
	FormTextField.propTypes = {
	  fieldContainerClass: _propTypes.string,
	  id: _propTypes.string,
	  name: _propTypes.string,
	  value: _propTypes.string,
	  helperText: _propTypes.string,
	  errorHelperText: _propTypes.bool,
	  disabled: _propTypes.bool,
	  handleChange: _propTypes.func,
	  handleBlur: _propTypes.func,
	  rows: _propTypes.number,
	  error: _propTypes.bool,
	  type: _propTypes.string,
	  optional: _propTypes.bool,
	  multiline: _propTypes.bool,
	  maxLength: _propTypes.string,
	  onKeyPress: _propTypes.func,
	  placeholder: _propTypes.string,
	  textFieldClass: _propTypes.string,
	  hideLabel: _propTypes.bool
	};

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = function styles(theme) {
	  return _defineProperty({
	    fieldContainer: {
	      marginTop: 20,
	      marginBottom: 20
	    },
	    formLabelContainer: {
	      width: '98%'
	    },
	    hideFormLabel: {
	      visibility: 'hidden'
	    },
	    optional: {
	      float: 'right',
	      opacity: 0.5
	    },
	    textField: {
	      padding: '10px 0',
	      width: '100%',
	      '& .MuiInputBase-root': {
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	        width: '99%',
	        '& input': {
	          height: (0, _lodash.get)(theme, 'height.h40'),
	          padding: '0 10px'
	        },
	        '& textarea': {
	          padding: '0 10px'
	        }
	      },
	      '& .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.primaryButtonBackground'), 0.4)
	      },
	      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.primaryButtonHover')
	      },
	      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	      },
	      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.error')
	      },
	      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
	        backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.1),
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.5)
	      },
	      '& .MuiOutlinedInput-multiline': {
	        padding: '10px 0'
	      },
	      '& .MuiFormHelperText-contained': {
	        marginLeft: 1
	      }
	    },
	    errorHelperText: {
	      '& + .MuiFormHelperText-contained': {
	        color: (0, _lodash.get)(theme, 'color.error')
	      }
	    },
	    resetSecretButton: {
	      '& + .Connect(ApplicationEdit)': {
	        color: (0, _lodash.get)(theme, 'color.error')
	      }
	    },
	
	    /* Todo - Material ui override style
	    textField: {
	      color: '#000000',
	      fontFamily: theme.typography.bodyText,
	      fontSize: theme.fontSize.bodyText,
	      width: '99%',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      '&$outlined:hover $outlined$notchedOutline': {
	        borderColor: '#cccccc',
	      },
	      '&$notchedOutline$focused $notchedOutline': {
	        borderColor: '#cccccc',
	      },
	      '&$error$notchedOutline': {
	        borderColor: '##f44336',
	      },
	      '&$contained': {
	        marginLeft: 1,
	      },
	      paddingTop: 10,
	      paddingBottom: 10,
	    },
	    notchedOutline: {},
	    outlined: {},
	    focused: {},
	    error: {},
	    contained: {},
	    */
	    helperText: {
	      color: (0, _lodash.get)(theme, 'color.smallText') + ' !important',
	      fontFamily: (0, _lodash.get)(theme, 'typography.smallText') + ' !important',
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText') + ' !important'
	    }
	
	  }, '@media (max-width: ' + (0, _lodash.get)(theme, 'breakpoint.xs') + ')', {
	    fieldContainer: {
	      marginTop: 0,
	      marginBottom: 0
	    },
	    hideFormLabel: {
	      display: 'none'
	    }
	  });
	};
	
	exports.default = styles;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	var _index = __webpack_require__(1493);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Branding = function Branding(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      homeHref = _ref.homeHref,
	      logo = _ref.logo,
	      siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'a',
	    {
	      className: classes.HeaderBrandingWrapper,
	      href: homeHref,
	      'data-apim-test': 'tenant-home-link'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: classes.HeaderBrandingLogo },
	      _react2.default.createElement(
	        'div',
	        { className: classes.HeaderBrandingLogoImageWrapper },
	        _react2.default.createElement('img', {
	          className: classes.HeaderBrandingLogoImage,
	          alt: 'Logo',
	          src: logo
	        })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: classes.HeaderBrandingSiteTitle },
	        siteTitle
	      )
	    )
	  );
	};
	exports.default = (0, _styles.withStyles)(_index2.default)(Branding);

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return {
	    HeaderBrandingWrapper: {
	      color: (0, _lodash.get)(color, 'title'),
	      textDecoration: 'none',
	      '&:focus': {
	        outline: 'none',
	        '& span': {
	          color: (0, _lodash.get)(color, 'headerLink'),
	          outline: 'none',
	          textDecoration: 'underline',
	          transition: 'none'
	        }
	      }
	    },
	
	    HeaderBrandingLogo: {
	      alignItems: 'center',
	      display: 'flex'
	    },
	
	    HeaderBrandingLogoImageWrapper: {
	      padding: 5,
	      blockSize: '38px',
	      boxSizing: 'content-box'
	    },
	
	    HeaderBrandingLogoImage: {
	      width: 'auto',
	      height: 38
	    },
	
	    HeaderBrandingSiteTitle: _defineProperty({
	      color: (0, _lodash.get)(color, 'siteTitle'),
	      marginLeft: 8,
	      fontFamily: (0, _lodash.get)(typography, 'siteTitle'),
	      fontSize: (0, _lodash.get)(fontSize, 'siteTitle'),
	      fontStyle: 'normal',
	      fontWeight: 600,
	      height: '100%',
	
	      '&:hover': {
	        color: (0, _lodash.get)(color, 'headerLink'),
	        textDecoration: 'none'
	      },
	
	      '&:active': {
	        color: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.75).string(),
	        textDecoration: 'none'
	      },
	
	      '&:focus': {
	        color: (0, _lodash.get)(color, 'headerLink'),
	        transition: 'none',
	        outline: 'none',
	        textDecoration: 'underline'
	      }
	
	    }, '@media screen and (max-width: ' + (0, _lodash.get)(misc, 'breakpointSmall') + 'px)', {
	      display: 'none'
	    })
	  };
	};

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Link;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	var _reactIntl = __webpack_require__(16);
	
	var _intl = __webpack_require__(15);
	
	var _index = __webpack_require__(1495);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Link(_ref) {
	  var link = _ref.link;
	
	  var useStyles = (0, _styles.makeStyles)(_index2.default);
	  var classes = useStyles();
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  return _react2.default.createElement(
	    'a',
	    {
	      href: '//' + window.location.hostname + link.href,
	      className: classes.HeaderNavigationLink,
	      target: link.externalLink ? '_blank' : '_self',
	      rel: link.externalLink ? 'noopener' + (link.titleKey !== 'label.appnav.portalapi' ? ' noreferrer' : '') : '',
	      'data-apim-test': link.titleKey || link.menuTitle
	    },
	    link.titleKey ? intl.getI18nMessage(link.titleKey) : link.menuTitle
	  );
	}

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return {
	    HeaderNavigationLink: {
	      border: '1px solid !important',
	      borderColor: 'rgba(0, 0, 0, 0) !important',
	      borderRadius: '3px !important',
	      color: (0, _get2.default)(color, 'headerLink') + ' !important',
	      display: 'block',
	      fontFamily: (0, _get2.default)(typography, 'siteTitle') + ' !important',
	      fontSize: (0, _get2.default)(fontSize, 'bodyText') + ' !important',
	      fontStyle: 'normal !important',
	      fontWeight: '600 !important',
	      lineHeight: '40px !important',
	      margin: '0 6px 0 6px !important',
	      padding: '0 16px 0 16px !important',
	      textDecoration: 'none !important',
	      transition: (0, _get2.default)(misc, 'colorTransition'),
	
	      '&:hover': {
	        borderColor: (0, _get2.default)(color, 'headerLink') + ' !important',
	        backgroundColor: (0, _color2.default)((0, _get2.default)(color, 'headerLink')).alpha(0.1).string() + ' !important'
	      },
	      '&:focus': {
	        borderColor: (0, _color2.default)((0, _get2.default)(color, 'headerLink')).alpha(0.7).string() + ' !important',
	        outline: 'none !important'
	      },
	      '&:active': {
	        borderColor: (0, _get2.default)(color, 'headerLink') + ' !important'
	      }
	    }
	  };
	};

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = Menu;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	var _Button = __webpack_require__(108);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ClickAwayListener = __webpack_require__(109);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(80);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _Paper = __webpack_require__(38);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Popper = __webpack_require__(135);
	
	var _Popper2 = _interopRequireDefault(_Popper);
	
	var _MenuList = __webpack_require__(133);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _MenuItem = __webpack_require__(111);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _createSvgIcon = __webpack_require__(22);
	
	var _createSvgIcon2 = _interopRequireDefault(_createSvgIcon);
	
	var _ChevronLeft = __webpack_require__(946);
	
	var _ChevronLeft2 = _interopRequireDefault(_ChevronLeft);
	
	var _ChevronRight = __webpack_require__(947);
	
	var _ChevronRight2 = _interopRequireDefault(_ChevronRight);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(16);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _index = __webpack_require__(1497);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// workaround till we update react-scripts > 2.0.0, which supports adding svg images
	var collapseSVG = _react2.default.createElement('path', { d: 'M12.023 7.04426L19.1319 13.9239C19.6227 14.3988 19.6227 15.1689 19.1319 15.6438C18.6412 16.1187 17.8455 16.1187 17.3547 15.6438L11.9771 10.4397L6.6453 15.5995C6.15453 16.0745 5.35884 16.0745 4.86808 15.5995C4.37731 15.1246 4.37731 14.3546 4.86808 13.8796L11.977 7L12.0229 7.04442L12.023 7.04426Z' });
	var expandSVG = _react2.default.createElement('path', { d: 'M12.023 16.9557L12.0229 16.9556L11.977 17L4.86808 10.1204C4.37731 9.64543 4.37731 8.87541 4.86808 8.40047C5.35884 7.92553 6.15453 7.92553 6.6453 8.40047L11.9771 13.5603L17.3547 8.3562C17.8455 7.88127 18.6412 7.88127 19.1319 8.3562C19.6227 8.83114 19.6227 9.60117 19.1319 10.0761L12.023 16.9557Z' });
	/* eslint-disable */
	var mobileNavSVG = _react2.default.createElement(
	  _react.Fragment,
	  null,
	  _react2.default.createElement('path', {
	    fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.25 2.5H2.5V7.25H7.25V2.5ZM2.5 9.5H7.25V14.25H2.5V9.5ZM14.25 9.5H9.5V14.25H14.25V9.5ZM21.5 16.75H16.75V21.5H21.5V16.75Z'
	  }),
	  _react2.default.createElement('path', {
	    opacity: '0.8', fillRule: 'evenodd', clipRule: 'evenodd', d: 'M9.5 16.75H14.25V21.5H9.5V16.75ZM16.75 9.5H21.5V14.25H16.75V9.5ZM2.5 16.75H7.25V21.5H2.5V16.75ZM16.75 2.5H21.5V7.25H16.75V2.5ZM9.5 2.5H14.25V7.25H9.5V2.5Z'
	  })
	);
	/* eslint-enable */
	
	function Menu(props) {
	  var useStyles = (0, _styles.makeStyles)(_index2.default);
	  var classes = useStyles();
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      open = _React$useState2[0],
	      setOpen = _React$useState2[1];
	
	  var navigations = props.navigations,
	      isRootMenu = props.isRootMenu;
	
	  var _React$useState3 = _react2.default.useState([]),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      context = _React$useState4[0],
	      setContext = _React$useState4[1];
	
	  var anchorRef = _react2.default.useRef(null);
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var handleToggle = function handleToggle() {
	    setOpen(function (currentVal) {
	      return !currentVal;
	    });
	  };
	
	  var handleClose = function handleClose(event) {
	    if (anchorRef.current && anchorRef.current.contains(event.target)) {
	      return;
	    }
	    setOpen(false);
	  };
	
	  function handleListKeyDown(event) {
	    if (event.key === 'Tab' || event.key === 'Escape') {
	      event.preventDefault();
	      anchorRef.current.focus();
	      setOpen(false);
	    }
	  }
	
	  function handleBtnKeyDown(event) {
	    if (event.key === 'Escape') {
	      event.preventDefault();
	      setOpen(false);
	    }
	  }
	
	  var getCurrentNode = function getCurrentNode(node, contextParam) {
	    if (contextParam.length === 0) {
	      return node;
	    }
	    var index = contextParam[0];
	    var nextNode = node.navigations[index];
	    return getCurrentNode(nextNode, contextParam.slice(1));
	  };
	
	  var popContext = function popContext() {
	    return setContext(function (contextVal) {
	      return contextVal.splice(0, contextVal.length - 1);
	    });
	  };
	  var pushContext = function pushContext(index) {
	    return setContext(function (contextVal) {
	      return contextVal.concat([index]);
	    });
	  };
	
	  var renderMenuItem = function renderMenuItem(item, index) {
	    var isLink = true;
	    if (item.navigations && item.navigations.length > 0) {
	      isLink = false;
	    }
	    var itemProps = {};
	    var relKey = '';
	    if (item.externalLink) {
	      relKey = 'noopener';
	      if (item.titleKey !== 'label.appnav.portalapi') {
	        relKey += ' noreferrer';
	      }
	    }
	    if (isLink) {
	      itemProps = {
	        href: item.href,
	        target: item.externalLink ? '_blank' : '_self',
	        rel: relKey
	      };
	    } else {
	      itemProps = {
	        onClick: function onClick() {
	          pushContext(index);
	          event.preventDefault();
	        }
	      };
	    }
	    return _react2.default.createElement(
	      _MenuItem2.default,
	      Object.assign({
	        className: classes.MenuItems,
	        component: 'a',
	        key: item.titleKey || item.menuTitle,
	        value: item.titleKey || item.menuTitle
	      }, itemProps, {
	        'data-apim-test': item.titleKey || item.menuTitle
	      }),
	      item.titleKey ? intl.getI18nMessage(item.titleKey) : item.menuTitle,
	      !isLink && _react2.default.createElement(_ChevronRight2.default, { className: classes.arrowRight })
	    );
	  };
	
	  var renderMenu = function renderMenu() {
	    var menuItems = [];
	    var currentNavItems = navigations;
	    if (context.length > 0) {
	      var initialNode = {
	        navigations: currentNavItems
	      };
	      var currentNode = getCurrentNode(initialNode, context);
	      currentNavItems = currentNode.navigations;
	      menuItems.push(_react2.default.createElement(
	        _MenuItem2.default,
	        {
	          className: (0, _clsx2.default)(classes.MenuItems, classes.BackBtn),
	          component: 'a',
	          key: currentNode.titleKey,
	          value: currentNode.titleKey,
	          onClick: popContext,
	          'data-apim-test': currentNode.titleKey || currentNode.menuTitle
	        },
	        _react2.default.createElement(_ChevronLeft2.default, { className: classes.arrowLeft }),
	        intl.getI18nMessage(currentNode.titleKey)
	      ));
	    }
	    menuItems.push(currentNavItems.map(renderMenuItem));
	    return menuItems;
	  };
	
	  var CollapseIcon = (0, _createSvgIcon2.default)(collapseSVG, 'collapse');
	  var ExpandIcon = (0, _createSvgIcon2.default)(expandSVG, 'expand');
	  var MobileNavIcon = (0, _createSvgIcon2.default)(mobileNavSVG, 'mobileNav');
	  return _react2.default.createElement(
	    'div',
	    null,
	    isRootMenu ? _react2.default.createElement(
	      _IconButton2.default,
	      {
	        'aria-controls': open ? 'menu-list-grow' : undefined,
	        'aria-haspopup': 'true',
	        className: classes.collapsedMenuButton,
	        onClick: handleToggle,
	        onKeyDown: handleBtnKeyDown,
	        ref: anchorRef,
	        'data-apim-test': 'mobile-navigation'
	      },
	      _react2.default.createElement(MobileNavIcon, { className: classes.MenuIcon })
	    ) : _react2.default.createElement(
	      _Button2.default,
	      {
	        classes: {
	          root: classes.menuButton
	        },
	        ref: anchorRef,
	        'aria-controls': open ? 'menu-list-grow' : undefined,
	        'aria-haspopup': 'true',
	        onClick: handleToggle,
	        endIcon: open ? _react2.default.createElement(CollapseIcon, null) : _react2.default.createElement(ExpandIcon, null),
	        onKeyDown: handleBtnKeyDown,
	        'data-apim-test': props.titleKey
	      },
	      intl.getI18nMessage(props.titleKey)
	    ),
	    _react2.default.createElement(
	      _Popper2.default,
	      {
	        open: open,
	        anchorEl: anchorRef.current,
	        role: undefined,
	        transition: true,
	        disablePortal: true,
	        placement: 'bottom-start',
	        modifiers: {
	          preventOverflow: {
	            enabled: true,
	            boundariesElement: 'viewport'
	          }
	        }
	      },
	      function (_ref) {
	        var TransitionProps = _ref.TransitionProps,
	            placement = _ref.placement;
	        return _react2.default.createElement(
	          _Grow2.default,
	          Object.assign({}, TransitionProps, {
	            style: {
	              transformOrigin: placement === 'bottom-start' ? 'center top' : 'center bottom'
	            }
	          }),
	          _react2.default.createElement(
	            _Paper2.default,
	            {
	              classes: {
	                root: classes.MenuPaper
	              }
	            },
	            _react2.default.createElement(
	              _ClickAwayListener2.default,
	              { onClickAway: handleClose },
	              _react2.default.createElement(
	                _MenuList2.default,
	                {
	                  classes: {
	                    root: classes.MenuList
	                  },
	                  id: 'menu-list-grow',
	                  onKeyDown: handleListKeyDown
	                },
	                renderMenu()
	              )
	            )
	          )
	        );
	      }
	    )
	  );
	}
	
	Menu.propTypes = {
	  isRootMenu: _propTypes2.default.bool,
	  navigations: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    href: _propTypes2.default.string,
	    titleKey: _propTypes2.default.string,
	    externalLink: _propTypes2.default.bool
	  })),
	  titleKey: _propTypes2.default.string
	};

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      typography = _ref.typography,
	      fontSize = _ref.fontSize;
	  return {
	    menuButton: {
	      color: (0, _lodash.get)(color, 'headerLink') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'siteTitle') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      fontStyle: 'normal !important',
	      fontWeight: '600 !important',
	      margin: '0 6px 0 6px !important',
	      textTransform: 'none',
	      lineHeight: '40px !important',
	      padding: '0 16px 0 16px !important',
	      border: '1px solid !important',
	      borderColor: 'rgba(0, 0, 0, 0) !important',
	      borderRadius: '3px !important',
	      '&:hover': {
	        borderColor: (0, _lodash.get)(color, 'headerLink') + ' !important',
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.1).string() + ' !important'
	      },
	      '&:focus': {
	        borderColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string() + ' !important'
	      },
	      '&:active': {
	        borderColor: (0, _lodash.get)(color, 'headerLink') + ' !important'
	      }
	    },
	    collapsedMenuButton: {
	      padding: 8,
	      color: (0, _lodash.get)(color, 'headerLink'),
	      border: '1px solid',
	      borderRadius: 3,
	      borderColor: 'rgba(0, 0, 0, 0)',
	      marginRight: 8,
	      '&:hover': {
	        color: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string(),
	        backgroundColor: 'rgba(0, 0, 0, 0)'
	      },
	      '&:focus': {
	        borderColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string()
	      },
	      '&:active': {
	        borderColor: (0, _lodash.get)(color, 'headerLink')
	      }
	    },
	    MenuIcon: {
	      height: 24,
	      width: 24
	    },
	    MenuPaper: {
	      borderRadius: 3,
	      boxShadow: 'none',
	      filter: 'drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))',
	      marginTop: 4
	    },
	    MenuList: {
	      margin: '0 0 0 0 !important',
	      padding: '4px 0 12px 0 !important',
	      maxHeight: 500,
	      minWidth: '192 !important',
	      overflowY: 'auto',
	      '&:focus': {
	        outline: 'none'
	      }
	    },
	    MenuItems: {
	      borderLeft: '3px solid !important',
	      borderColor: 'rgba(0, 0, 0, 0) !important',
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	      fontStyle: 'normal !important',
	      fontWeight: 'normal !important',
	      justifyContent: 'space-between !important',
	      lineHeight: '36px !important',
	      padding: '0 12px 0 12px !important',
	      textDecoration: 'none !important',
	      '&:hover': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important'
	      },
	      '&:focus': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important',
	        borderColor: (0, _lodash.get)(color, 'headerLink') + ' !important',
	        outline: 'none !important'
	      }
	    },
	    BackBtn: {
	      justifyContent: 'left !important',
	      paddingLeft: '0 !important'
	    },
	    arrowLeft: {
	      fill: (0, _lodash.get)(color, 'headerLink') + ' !important'
	    },
	    arrowRight: {
	      fill: (0, _lodash.get)(color, 'headerLink') + ' !important'
	    }
	  };
	};

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(30);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(1494);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Menu = __webpack_require__(1496);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _index = __webpack_require__(1499);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = function Nav(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      _ref$navItems = _ref.navItems,
	      navItems = _ref$navItems === undefined ? [] : _ref$navItems,
	      _ref$renderCollapsed = _ref.renderCollapsed,
	      renderCollapsed = _ref$renderCollapsed === undefined ? false : _ref$renderCollapsed;
	
	  var renderExpandedNav = function renderExpandedNav() {
	    return navItems.map(function (item) {
	      return item.navigations && item.navigations.length > 0 ? _react2.default.createElement(_Menu2.default, Object.assign({}, item, {
	        key: item.titleKey
	      })) : _react2.default.createElement(_Link2.default, {
	        link: item,
	        key: item.titleKey || item.title
	      });
	    });
	  };
	  return _react2.default.createElement(
	    'div',
	    { 'data-apim-test': 'header-nav', className: (0, _clsx2.default)(classes.HeaderNav, classes.HeaderDesktopNav) },
	    _react2.default.createElement(
	      'div',
	      { 'data-apim-test': 'header-nav-links', className: classes.HeaderNavLinks },
	      renderCollapsed ? _react2.default.createElement(_Menu2.default, { navigations: navItems, isRootMenu: true, titleKey: '' }) : renderExpandedNav()
	    )
	  );
	};
	
	
	Nav.propTypes = {
	  classes: _propTypes2.default.shape(),
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  renderCollapsed: _propTypes2.default.bool
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(Nav);

/***/ },
/* 1499 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var misc = _ref.misc;
	  return {
	    HeaderNav: {
	      display: 'inline-block',
	      height: '100%',
	      '.skipPrint &': {
	        '@media print': {
	          display: 'none'
	        }
	      }
	    },
	    HeaderDesktopNav: {
	      flex: 1
	    },
	    HeaderNavLinks: _defineProperty({
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center',
	      height: '100%'
	    }, '@media (max-width: ' + (misc && misc.breakpointLarge) + 'px)', {
	      justifyContent: 'flex-end'
	    })
	  };
	};

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	var _Block = __webpack_require__(361);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _core = __webpack_require__(3);
	
	var _createSvgIcon = __webpack_require__(22);
	
	var _createSvgIcon2 = _interopRequireDefault(_createSvgIcon);
	
	var _isEmpty = __webpack_require__(35);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isArray = __webpack_require__(36);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isNumber = __webpack_require__(442);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(1501);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestsSVG = _react2.default.createElement(
	  _react.Fragment,
	  null,
	  _react2.default.createElement('path', { opacity: '0.6', d: 'M8.01874 19H16.0187C16.0091 21.201 14.2219 22.9823 12.0187 22.9823C9.81546 22.9823 8.02827 21.201 8.01874 19Z' }),
	  _react2.default.createElement('path', { d: 'M12 1C14.8689 1 17.3012 2.98557 17.7068 5.65863L18.776 12.7067C18.9134 13.6124 19.5797 14.3687 20.5 14.6635L20.6444 14.7097C21.455 14.9694 22 15.6858 22 16.4917V17H2V16.4825C2 15.6715 2.55194 14.9516 3.36975 14.6961L3.5 14.6554C4.4191 14.3681 5.0865 13.6163 5.22335 12.714L6.29343 5.65866C6.69884 2.98561 9.1311 1 12 1Z' })
	);
	var collapseSVG = _react2.default.createElement('path', { d: 'M12.023 7.04426L19.1319 13.9239C19.6227 14.3988 19.6227 15.1689 19.1319 15.6438C18.6412 16.1187 17.8455 16.1187 17.3547 15.6438L11.9771 10.4397L6.6453 15.5995C6.15453 16.0745 5.35884 16.0745 4.86808 15.5995C4.37731 15.1246 4.37731 14.3546 4.86808 13.8796L11.977 7L12.0229 7.04442L12.023 7.04426Z' });
	
	var NotificationsIcon = (0, _createSvgIcon2.default)(requestsSVG, 'requests');
	var CollapseIcon = (0, _createSvgIcon2.default)(collapseSVG, 'collapse');
	
	var renderRequestItem = function renderRequestItem(requestItem, classes) {
	  var label = requestItem.RequestType.toLowerCase() + ': ' + requestItem.OrganizationName.toLowerCase();
	  return _react2.default.createElement(
	    _core.MenuItem,
	    {
	      className: (0, _clsx2.default)(classes.HeaderRequestsMenuItem, classes.Capitalize),
	      component: 'a',
	      href: '//' + window.location.hostname + '/admin/requests#' + (requestItem.RequestType === 'APPLICATION' ? 'application-details' : 'registration-details') + '/' + requestItem.Uuid,
	      key: requestItem.Uuid,
	      tabIndex: 0,
	      title: label,
	      'data-apim-test': requestItem.Uuid
	    },
	    label
	  );
	};
	
	var renderRequestItems = function renderRequestItems(requestItems, classes) {
	  return requestItems.map(function (item) {
	    return renderRequestItem(item, classes);
	  });
	};
	
	function Requests(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      _ref$fetchRequests = _ref.fetchRequests,
	      fetchRequests = _ref$fetchRequests === undefined ? function () {} : _ref$fetchRequests,
	      _ref$requestItems = _ref.requestItems,
	      requestItems = _ref$requestItems === undefined ? [] : _ref$requestItems;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      _React$useState2$ = _React$useState2[0],
	      anchorEl = _React$useState2$ === undefined ? false : _React$useState2$,
	      setAnchorEl = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(0),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      localRequestsVersion = _React$useState4[0],
	      setLocalRequestsVersion = _React$useState4[1];
	
	  var handleClick = function handleClick(event) {
	    setAnchorEl(event.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    setAnchorEl(null);
	  };
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab' || event.key === 'Escape') {
	      event.preventDefault();
	      anchorEl.focus();
	      setAnchorEl(null);
	    }
	  };
	
	  var handleBtnKeyDown = function handleBtnKeyDown(event) {
	    if (event.key === 'Escape') {
	      event.preventDefault();
	      setAnchorEl(null);
	    } else if ((0, _isEmpty2.default)(requestItems) && event.key === 'Tab') {
	      setAnchorEl(null);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    setLocalRequestsVersion(0);
	    localStorage.setItem('serverRequestsVersion', 0);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var handleStorageChange = function handleStorageChange() {
	      var serverVersionStr = localStorage.getItem('serverRequestsVersion');
	      var versionNum = parseInt(serverVersionStr, 10);
	      if ((0, _isNumber2.default)(versionNum) && versionNum > localRequestsVersion) {
	        setLocalRequestsVersion(versionNum);
	        fetchRequests();
	      }
	    };
	    window.addEventListener('storage', handleStorageChange);
	    return function () {
	      window.removeEventListener('storage', handleStorageChange);
	    };
	  });
	
	  var requestsCount = (0, _isArray2.default)(requestItems) ? requestItems.length : 0;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.HeaderRequestsButton },
	    _react2.default.createElement(
	      _core.IconButton,
	      {
	        onKeyDown: handleBtnKeyDown,
	        onClick: handleClick,
	        'data-apim-test': 'header-requests'
	      },
	      _react2.default.createElement(
	        _core.Badge,
	        {
	          badgeContent: requestsCount,
	          color: 'primary',
	          classes: {
	            colorPrimary: classes.BadgePrimary
	          }
	        },
	        !anchorEl ? _react2.default.createElement(NotificationsIcon, { className: classes.NotificationsIcon }) : _react2.default.createElement(CollapseIcon, { className: classes.NotificationsIcon })
	      )
	    ),
	    _react2.default.createElement(
	      _core.Popper,
	      {
	        open: !!anchorEl,
	        anchorEl: anchorEl,
	        role: undefined,
	        transition: true,
	        className: classes.Popper,
	        disablePortal: true,
	        placement: 'bottom-end',
	        modifiers: {
	          preventOverflow: {
	            enabled: true,
	            boundariesElement: 'viewport'
	          }
	        }
	      },
	      function (_ref2) {
	        var TransitionProps = _ref2.TransitionProps,
	            placement = _ref2.placement;
	        return _react2.default.createElement(
	          _core.Grow,
	          Object.assign({}, TransitionProps, {
	            style: {
	              transformOrigin: placement === 'bottom-end' ? 'center top' : 'center bottom'
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _isEmpty2.default)(requestItems) && _react2.default.createElement(
	              _core.Paper,
	              {
	                classes: {
	                  root: classes.MenuPaper
	                }
	              },
	              _react2.default.createElement(
	                _core.ClickAwayListener,
	                { onClickAway: handleClose },
	                _react2.default.createElement(
	                  'div',
	                  { className: classes.Menu },
	                  _react2.default.createElement(
	                    'div',
	                    { className: classes.HeaderRequestsNoRequestsIcon },
	                    _react2.default.createElement(_Block2.default, { className: classes.NoRequestsIcon })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: classes.HeaderRequestsNoRequestsText,
	                      'data-apim-test': 'no-requests'
	                    },
	                    'No Requests'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: classes.HeaderRequestsNoRequestsMessage },
	                    'All active requests have been resolved'
	                  )
	                )
	              )
	            ),
	            !(0, _isEmpty2.default)(requestItems) && _react2.default.createElement(
	              _core.Paper,
	              {
	                classes: {
	                  root: classes.MenuPaper
	                }
	              },
	              _react2.default.createElement(
	                _core.ClickAwayListener,
	                { onClickAway: handleClose },
	                _react2.default.createElement(
	                  _core.MenuList,
	                  {
	                    classes: {
	                      root: classes.Menu
	                    },
	                    onKeyDown: handleListKeyDown
	                  },
	                  _react2.default.createElement(
	                    _core.MenuItem,
	                    {
	                      className: classes.SubHeaderUppercase,
	                      tabIndex: -1,
	                      disabled: true
	                    },
	                    'Recent Requests'
	                  ),
	                  renderRequestItems(requestItems, classes),
	                  _react2.default.createElement(
	                    _core.MenuItem,
	                    {
	                      className: classes.HeaderRequestsMenuItem,
	                      tabIndex: 0
	                    },
	                    _react2.default.createElement(
	                      'a',
	                      { href: '//' + window.location.hostname + '/admin/requests' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        'Show All'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	    )
	  );
	}
	
	Requests.propTypes = {
	  classes: _propTypes2.default.shape(),
	  fetchRequests: _propTypes2.default.func,
	  requestItems: _propTypes2.default.arrayOf(_propTypes2.default.shape())
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(Requests);

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    HeaderRequestsButton: {
	      display: 'inline-block',
	      marginRight: 8,
	      '& button': {
	        padding: 8,
	        color: (0, _lodash.get)(color, 'headerLink'),
	        border: '1px solid',
	        borderRadius: 3,
	        borderColor: 'rgba(0, 0, 0, 0)',
	        '&:hover': {
	          color: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string(),
	          backgroundColor: 'rgba(0, 0, 0, 0)'
	        },
	        '&:focus': {
	          borderColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string()
	        },
	        '&:active': {
	          borderColor: (0, _lodash.get)(color, 'headerLink')
	        }
	      },
	      '.skipPrint &': {
	        '@media print': {
	          display: 'none'
	        }
	      }
	    },
	
	    NotificationsIcon: {
	      width: 24,
	      height: 24
	    },
	
	    BadgePrimary: {
	      backgroundColor: '#DE1B1B',
	      color: '#FFFFFF',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontStyle: 'normal',
	      fontWeight: 'bold',
	      fontSize: '14px'
	    },
	
	    Popper: {
	      marginTop: 4
	    },
	
	    MenuPaper: {
	      borderRadius: 3,
	      boxShadow: 'none',
	      filter: 'drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))'
	    },
	
	    Menu: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      margin: '0 0 0 0 !important',
	      maxHeight: '500px',
	      overflowY: 'auto',
	      padding: '4px 0 12px 0 !important',
	      width: 225
	    },
	
	    HeaderRequestsMenuItem: {
	      borderLeft: '3px solid !important',
	      borderColor: 'rgba(0, 0, 0, 0) !important',
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      display: 'block',
	      fontSize: '' + (0, _lodash.get)(fontSize, 'bodyText'),
	      lineHeight: '36px !important',
	      overflow: 'hidden',
	      padding: '0 12px 0 12px !important',
	      textDecoration: 'none',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      '&:hover': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important'
	      },
	      '&:focus': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important',
	        borderColor: (0, _lodash.get)(color, 'headerLink') + ' !important',
	        outline: 'none !important'
	      },
	      '& a': {
	        color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontStyle: 'normal !important',
	        fontWeight: 'normal !important',
	        textDecoration: 'none !important'
	      }
	    },
	
	    Capitalize: {
	      textTransform: 'capitalize'
	    },
	
	    HeaderRequestsNoRequestsIcon: {
	      color: (0, _lodash.get)(color, 'headerLink') + ' !important',
	      display: 'inline-block',
	      height: '24px',
	      margin: '0 auto',
	      paddingBottom: '6px',
	      paddingTop: '6px',
	      textAlign: 'center',
	      width: '100%'
	    },
	
	    NoRequestsIcon: {
	      height: '24px !important',
	      width: '24px !important'
	    },
	
	    HeaderRequestsNoRequestsText: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      fontStyle: 'normal !important',
	      fontWeight: 'bold !important',
	      lineHeight: '36px !important',
	      margin: '0 auto !important',
	      textAlign: 'center',
	      width: '100%'
	    },
	
	    HeaderRequestsNoRequestsMessage: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      fontStyle: 'normal !important',
	      fontWeight: '100 !important',
	      margin: '0 auto',
	      paddingBottom: 6,
	      paddingTop: 6,
	      textAlign: 'center',
	      width: '100%'
	    },
	
	    SubHeaderUppercase: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      fontStyle: 'normal !important',
	      fontWeight: 'bold !important',
	      lineHeight: '36px !important',
	      opacity: '1.0 !important',
	      padding: '0 12px 0 12px !important',
	      textDecoration: 'none',
	      textTransform: 'uppercase'
	    }
	  };
	};

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	var _Paper = __webpack_require__(38);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Popper = __webpack_require__(135);
	
	var _Popper2 = _interopRequireDefault(_Popper);
	
	var _MenuList = __webpack_require__(133);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _MenuItem = __webpack_require__(111);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _ClickAwayListener = __webpack_require__(109);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(80);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _createSvgIcon = __webpack_require__(22);
	
	var _createSvgIcon2 = _interopRequireDefault(_createSvgIcon);
	
	var _isEmpty = __webpack_require__(35);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(16);
	
	var _intl = __webpack_require__(15);
	
	var _index = __webpack_require__(1503);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var settingsSVG = _react2.default.createElement(
	  _react.Fragment,
	  null,
	  _react2.default.createElement('path', { opacity: '0.6', fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11 3.23708L11.5041 2.69655C11.7445 2.43872 12.1478 2.42402 12.4048 2.66371L13.5782 3.58168C14.2409 3.20222 14.9898 2.96984 15.7722 2.91727L16.234 1.49301C16.313 1.15057 16.6556 0.937248 16.9991 1.01655L18.4762 1.35758C18.8197 1.43688 19.0341 1.77878 18.955 2.12122L18.7271 3.62027C19.3829 4.00834 19.9345 4.5341 20.3516 5.14917L21.8171 4.83671C22.1532 4.73395 22.5092 4.92395 22.6123 5.26108L23.0555 6.71085C23.1586 7.04798 22.9697 7.40457 22.6336 7.50733L21.2307 8.05582C21.2268 8.41628 21.1842 8.7818 21.0998 9.1474C21.011 9.53196 20.8807 9.89616 20.7147 10.2364L21.7129 11.3437C21.97 11.5834 21.9834 11.9867 21.743 12.2445L20.7091 13.3533C20.4687 13.6111 20.0654 13.6258 19.8084 13.3861L19.2853 12.9678C20.1281 12.0835 20.3221 10.716 19.6815 9.60631L18.6997 7.90578C17.9402 6.59034 16.2804 6.10952 14.9443 6.81243L14.3716 7.07947C14.105 6.90514 13.8288 6.74556 13.5442 6.60157L13.4932 5.93727C13.4448 4.53381 12.3693 3.39696 11 3.23708Z' }),
	  _react2.default.createElement('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.7973 14C2.7973 14.5155 2.85753 15.0172 2.9714 15.4984L1.4512 16.5628C1.05987 16.7888 0.927714 17.2925 1.15602 17.6879L2.13782 19.3885C2.36613 19.7839 2.86845 19.9213 3.25978 19.6954L4.98842 18.8667C5.69893 19.4995 6.54875 19.9821 7.48683 20.264L7.65463 22.1818C7.65463 22.6337 8.02479 23 8.48141 23H10.445C10.9016 23 11.2718 22.6337 11.2718 22.1818L11.4209 20.2379C12.3278 19.9521 13.1498 19.478 13.8399 18.862L15.5784 19.6954C15.9697 19.9213 16.4721 19.7839 16.7004 19.3885L17.6822 17.6879C17.9105 17.2925 17.7783 16.7888 17.387 16.5628L15.8538 15.4893C15.9663 15.0109 16.0258 14.5123 16.0258 14C16.0258 13.513 15.972 13.0385 15.8701 12.5819L17.4311 11.5136C17.8224 11.2876 17.9546 10.7839 17.7263 10.3885L16.7445 8.68794C16.5162 8.2925 16.0139 8.15508 15.6225 8.38102L13.8941 9.18696C13.193 8.54711 12.3517 8.05541 11.4209 7.76205L11.2718 5.81818C11.2718 5.36631 10.9016 5 10.445 5H8.48141C8.02479 5 7.65463 5.36631 7.65463 5.81818L7.48683 7.73599C6.5247 8.02513 5.65541 8.5254 4.93404 9.1823L3.21566 8.38102C2.82433 8.15508 2.32202 8.2925 2.09371 8.68794L1.11191 10.3885C0.883598 10.7839 1.01575 11.2876 1.40708 11.5136L2.95496 12.5729C2.85174 13.0323 2.7973 13.5099 2.7973 14ZM12.4033 14.0064C12.4033 15.638 11.0667 16.9607 9.418 16.9607C7.76925 16.9607 6.43267 15.638 6.43267 14.0064C6.43267 12.3748 7.76925 11.0521 9.418 11.0521C11.0667 11.0521 12.4033 12.3748 12.4033 14.0064Z' })
	);
	var collapseSVG = _react2.default.createElement('path', { d: 'M12.023 7.04426L19.1319 13.9239C19.6227 14.3988 19.6227 15.1689 19.1319 15.6438C18.6412 16.1187 17.8455 16.1187 17.3547 15.6438L11.9771 10.4397L6.6453 15.5995C6.15453 16.0745 5.35884 16.0745 4.86808 15.5995C4.37731 15.1246 4.37731 14.3546 4.86808 13.8796L11.977 7L12.0229 7.04442L12.023 7.04426Z' });
	/* eslint-enable */
	
	var SettingsIcon = (0, _createSvgIcon2.default)(settingsSVG, 'settings');
	var CollapseIcon = (0, _createSvgIcon2.default)(collapseSVG, 'collapse');
	
	function Settings(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      _ref$settingItems = _ref.settingItems,
	      settingItems = _ref$settingItems === undefined ? [] : _ref$settingItems;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      _React$useState2$ = _React$useState2[0],
	      anchorEl = _React$useState2$ === undefined ? false : _React$useState2$,
	      setAnchorEl = _React$useState2[1];
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var handleClick = function handleClick(event) {
	    setAnchorEl(event.currentTarget);
	  };
	
	  var handleClose = function handleClose() {
	    setAnchorEl(null);
	  };
	
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab' || event.key === 'Escape') {
	      event.preventDefault();
	      anchorEl.focus();
	      setAnchorEl(null);
	    }
	  };
	
	  var handleBtnKeyDown = function handleBtnKeyDown(event) {
	    if (event.key === 'Escape') {
	      event.preventDefault();
	      setAnchorEl(null);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.HeaderSettingsButton },
	    _react2.default.createElement(
	      _IconButton2.default,
	      {
	        onKeyDown: handleBtnKeyDown,
	        onClick: handleClick,
	        'data-apim-test': 'header-settings'
	      },
	      !anchorEl ? _react2.default.createElement(SettingsIcon, { className: classes.SettingsIcon }) : _react2.default.createElement(CollapseIcon, { className: classes.SettingsIcon })
	    ),
	    _react2.default.createElement(
	      _Popper2.default,
	      {
	        open: !!anchorEl,
	        anchorEl: anchorEl,
	        role: undefined,
	        transition: true,
	        className: classes.Popper,
	        disablePortal: true,
	        placement: 'bottom-end',
	        modifiers: {
	          preventOverflow: {
	            enabled: true,
	            boundariesElement: 'viewport'
	          }
	        }
	      },
	      function (_ref2) {
	        var TransitionProps = _ref2.TransitionProps,
	            placement = _ref2.placement;
	        return _react2.default.createElement(
	          _Grow2.default,
	          Object.assign({}, TransitionProps, {
	            style: {
	              transformOrigin: placement === 'bottom-end' ? 'center top' : 'center bottom'
	            }
	          }),
	          !(0, _isEmpty2.default)(settingItems) && _react2.default.createElement(
	            _Paper2.default,
	            {
	              classes: {
	                root: classes.MenuPaper
	              }
	            },
	            _react2.default.createElement(
	              _ClickAwayListener2.default,
	              { onClickAway: handleClose },
	              _react2.default.createElement(
	                _MenuList2.default,
	                {
	                  classes: {
	                    root: classes.Menu
	                  },
	                  onKeyDown: handleListKeyDown
	                },
	                settingItems.map(function (item) {
	                  return _react2.default.createElement(
	                    _MenuItem2.default,
	                    {
	                      className: classes.HeaderSettingsMenuItem,
	                      component: 'a',
	                      href: '//' + window.location.hostname + item.href,
	                      key: item.titleKey,
	                      value: item.titleKey,
	                      'data-apim-test': item.titleKey || item.menuItem
	                    },
	                    intl.getI18nMessage(item.titleKey)
	                  );
	                })
	              )
	            )
	          )
	        );
	      }
	    )
	  );
	}
	
	Settings.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  settingItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(Settings);

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return {
	    HeaderSettingsButton: {
	      display: 'inline-block',
	      marginRight: 8,
	      '& button': {
	        padding: 8,
	        color: (0, _lodash.get)(color, 'headerLink'),
	        border: '1px solid',
	        borderRadius: 3,
	        borderColor: 'rgba(0, 0, 0, 0)',
	        '&:hover': {
	          color: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string(),
	          backgroundColor: 'rgba(0, 0, 0, 0)'
	        },
	        '&:focus': {
	          borderColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string()
	        },
	        '&:active': {
	          borderColor: (0, _lodash.get)(color, 'headerLink')
	        }
	      },
	      '.skipPrint &': {
	        '@media print': {
	          display: 'none'
	        }
	      }
	    },
	
	    SettingsIcon: {
	      height: 24,
	      width: 24
	    },
	
	    Popper: {
	      marginTop: 4
	    },
	
	    MenuPaper: {
	      borderRadius: 3,
	      boxShadow: 'none',
	      filter: 'drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))'
	    },
	
	    Menu: {
	      margin: '0 0 0 0 !important',
	      maxWidth: 225,
	      minWidth: 180,
	      padding: '4px 0 12px 0 !important'
	    },
	    HeaderSettingsMenuItem: {
	      borderLeft: '3px solid !important',
	      borderColor: 'rgba(0, 0, 0, 0) !important',
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      display: 'block',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	      fontStyle: 'normal !important',
	      fontWeight: 'normal !important',
	      lineHeight: '36px !important',
	      padding: '0 12px 0 12px !important',
	      textDecoration: 'none',
	      transition: (0, _lodash.get)(misc, 'colorTransition'),
	      '&:hover': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important'
	      },
	      '&:focus': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important',
	        borderColor: (0, _lodash.get)(color, 'headerLink') + ' !important',
	        outline: 'none !important'
	      }
	    }
	  };
	};

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(8);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(30);
	
	var _Check = __webpack_require__(113);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	var _core = __webpack_require__(3);
	
	var _MenuList = __webpack_require__(133);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _MenuItem = __webpack_require__(111);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _ClickAwayListener = __webpack_require__(109);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(80);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _createSvgIcon = __webpack_require__(22);
	
	var _createSvgIcon2 = _interopRequireDefault(_createSvgIcon);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(1505);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var personSVG = _react2.default.createElement(
	  _react.Fragment,
	  null,
	  _react2.default.createElement('path', { opacity: '0.6', fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 1C18.072 1 23 5.928 23 12C23 14.5948 22.1 16.9807 20.5954 18.8624C20.2412 16.755 18.8459 15.2639 16.3176 14.5263C16.9625 13.6434 17.3431 12.5552 17.3431 11.3781C17.3431 8.42714 14.9509 6.03493 12 6.03493C9.04906 6.03493 6.65685 8.42714 6.65685 11.3781C6.65685 12.5587 7.03974 13.6498 7.6881 14.5341C5.17573 15.276 3.76609 16.7677 3.40639 18.8647C1.90069 16.9827 1 14.5959 1 12C1 5.928 5.928 1 12 1Z' }),
	  _react2.default.createElement('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M18.6863 20.7334C16.8329 22.1549 14.5145 23 12 23C9.48546 23 7.16711 22.1549 5.3137 20.7334V20.0826C5.3137 18.2146 6.34508 16.2169 12 16.2169C17.7447 16.2169 18.6863 18.2328 18.6863 20.0826V20.7334ZM12 14.7212C10.1536 14.7212 8.65685 13.2245 8.65685 11.3781C8.65685 9.53172 10.1536 8.03494 12 8.03494C13.8464 8.03494 15.3431 9.53172 15.3431 11.3781C15.3431 13.2245 13.8464 14.7212 12 14.7212Z' })
	);
	/* eslint-enable */
	
	var collapseSVG = _react2.default.createElement('path', { d: 'M12.023 7.04426L19.1319 13.9239C19.6227 14.3988 19.6227 15.1689 19.1319 15.6438C18.6412 16.1187 17.8455 16.1187 17.3547 15.6438L11.9771 10.4397L6.6453 15.5995C6.15453 16.0745 5.35884 16.0745 4.86808 15.5995C4.37731 15.1246 4.37731 14.3546 4.86808 13.8796L11.977 7L12.0229 7.04442L12.023 7.04426Z' });
	
	var PersonIcon = (0, _createSvgIcon2.default)(personSVG, 'person');
	var CollapseIcon = (0, _createSvgIcon2.default)(collapseSVG, 'collapse');
	
	var renderAccessibleOrgs = function renderAccessibleOrgs(userAccessibleOrgs, _ref) {
	  var classes = _ref.classes,
	      userActiveOrgUuid = _ref.userActiveOrgUuid,
	      updateUserContexts = _ref.updateUserContexts;
	
	  var menuItems = [];
	  menuItems.push((0, _lodash.map)(userAccessibleOrgs, function (accessibleOrg) {
	    return _react2.default.createElement(
	      _MenuItem2.default,
	      {
	        className: classes.UserMenuContent__AccessibleOrgWrapper,
	        key: accessibleOrg.uuid,
	        onClick: function onClick() {
	          return updateUserContexts({ orgUuid: accessibleOrg.uuid });
	        },
	        'data-apim-test': accessibleOrg.uuid
	      },
	      _react2.default.createElement(
	        _core.Button,
	        {
	          color: 'secondary',
	          classes: {
	            root: classes.UserMenuContent__AccessibleOrgs,
	            label: classes.UserMenuContent__AccessibleOrgs_label
	          },
	          onClick: function onClick() {
	            return updateUserContexts({ orgUuid: accessibleOrg.uuid });
	          },
	          title: accessibleOrg.name
	        },
	        accessibleOrg.name
	      ),
	      userActiveOrgUuid === accessibleOrg.uuid && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Check2.default, { className: classes.UserMenuContent__Check })
	      )
	    );
	  }));
	  return menuItems;
	};
	
	var renderUser = function renderUser(_ref2) {
	  var classes = _ref2.classes,
	      userAccessibleOrgs = _ref2.userAccessibleOrgs,
	      userActiveOrgUuid = _ref2.userActiveOrgUuid,
	      userDetails = _ref2.userDetails,
	      updateUserContexts = _ref2.updateUserContexts;
	
	  var menuItems = [];
	  menuItems.push(_react2.default.createElement(
	    _MenuItem2.default,
	    {
	      key: 'userName',
	      className: (0, _clsx2.default)(classes.UserMenuContent__Item, classes.UserMenuContent__Name),
	      disabled: true,
	      'data-apim-test': 'user-name'
	    },
	    userDetails.username
	  ));
	  var myProfileHandler = function myProfileHandler() {
	    window.location.href = 'https://' + window.location.hostname + '/admin/my-profile';
	  };
	  menuItems.push(_react2.default.createElement(
	    _MenuItem2.default,
	    {
	      className: classes.UserMenuContent__Item,
	      key: 'myProfile',
	      onClick: myProfileHandler,
	      tabIndex: 0,
	      'data-apim-test': 'my-profile'
	    },
	    _react2.default.createElement(
	      _core.Button,
	      {
	        href: 'https://' + window.location.hostname + '/admin/my-profile',
	        tabIndex: -1
	      },
	      'My Profile'
	    )
	  ));
	  if ((0, _utils.hasOrgBoundRole)(userDetails)) {
	    menuItems.push(renderAccessibleOrgs(userAccessibleOrgs, { classes: classes, userActiveOrgUuid: userActiveOrgUuid, updateUserContexts: updateUserContexts }));
	  }
	  var logOutHandler = function logOutHandler() {
	    localStorage.clear();
	    window.location.href = '//' + window.location.hostname + '/admin/logout';
	  };
	  menuItems.push(_react2.default.createElement(
	    _MenuItem2.default,
	    {
	      className: classes.UserMenuContent__Item,
	      key: 'logout',
	      onClick: logOutHandler,
	      tabIndex: 0,
	      'data-apim-test': 'logout'
	    },
	    _react2.default.createElement(
	      _core.Button,
	      {
	        onClick: logOutHandler
	      },
	      'Logout'
	    )
	  ));
	  return menuItems;
	};
	
	function User(_ref3) {
	  var _ref3$classes = _ref3.classes,
	      classes = _ref3$classes === undefined ? {} : _ref3$classes,
	      userAccessibleOrgs = _ref3.userAccessibleOrgs,
	      userActiveOrgUuid = _ref3.userActiveOrgUuid,
	      userDetails = _ref3.userDetails,
	      updateUserContexts = _ref3.updateUserContexts;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      _React$useState2$ = _React$useState2[0],
	      anchorEl = _React$useState2$ === undefined ? false : _React$useState2$,
	      setAnchorEl = _React$useState2[1];
	
	  var handleClick = function handleClick(event) {
	    setAnchorEl(event.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    setAnchorEl(null);
	  };
	
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab' || event.key === 'Escape') {
	      event.preventDefault();
	      anchorEl.focus();
	      setAnchorEl(null);
	    }
	  };
	
	  var handleBtnKeyDown = function handleBtnKeyDown(event) {
	    if (event.key === 'Escape') {
	      event.preventDefault();
	      setAnchorEl(null);
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: classes.UserMenuButton },
	    _react2.default.createElement(
	      _core.IconButton,
	      {
	        onKeyDown: handleBtnKeyDown,
	        color: 'secondary',
	        onClick: handleClick,
	        'data-apim-test': 'user-menu'
	      },
	      !anchorEl ? _react2.default.createElement(PersonIcon, { className: classes.PersonIcon }) : _react2.default.createElement(CollapseIcon, { className: classes.PersonIcon })
	    ),
	    _react2.default.createElement(
	      _core.Popper,
	      {
	        open: !!anchorEl,
	        anchorEl: anchorEl,
	        role: undefined,
	        transition: true,
	        className: classes.Popper,
	        disablePortal: true,
	        placement: 'bottom-end',
	        modifiers: {
	          preventOverflow: {
	            enabled: true,
	            boundariesElement: 'viewport'
	          }
	        }
	      },
	      function (_ref4) {
	        var TransitionProps = _ref4.TransitionProps,
	            placement = _ref4.placement;
	        return _react2.default.createElement(
	          _Grow2.default,
	          Object.assign({}, TransitionProps, {
	            style: {
	              transformOrigin: placement === 'bottom-end' ? 'center top' : 'center bottom'
	            }
	          }),
	          _react2.default.createElement(
	            _core.Paper,
	            {
	              classes: {
	                root: classes.MenuPaper
	              }
	            },
	            _react2.default.createElement(
	              _ClickAwayListener2.default,
	              { onClickAway: handleClose },
	              _react2.default.createElement(
	                _MenuList2.default,
	                {
	                  classes: {
	                    root: classes.Menu
	                  },
	                  onKeyDown: handleListKeyDown
	                },
	                renderUser({
	                  classes: classes,
	                  userAccessibleOrgs: userAccessibleOrgs,
	                  userActiveOrgUuid: userActiveOrgUuid,
	                  userDetails: userDetails,
	                  updateUserContexts: updateUserContexts
	                })
	              )
	            )
	          )
	        );
	      }
	    )
	  );
	}
	
	User.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  userAccessibleOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  userActiveOrgUuid: _propTypes2.default.string,
	  userDetails: _propTypes2.default.shape({}),
	  updateUserContexts: _propTypes2.default.func
	};
	
	renderUser.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  userAccessibleOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  userActiveOrgUuid: _propTypes2.default.string,
	  userDetails: _propTypes2.default.shape({}),
	  updateUserContexts: _propTypes2.default.func
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(User);

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    UserMenuButton: {
	      display: 'inline-block',
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      '& > button': {
	        border: '1px solid',
	        borderColor: 'rgba(0, 0, 0, 0)',
	        borderRadius: 3,
	        color: (0, _lodash.get)(color, 'headerLink'),
	        padding: 8,
	        '&:hover': {
	          color: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string(),
	          backgroundColor: 'rgba(0, 0, 0, 0)'
	        },
	        '&:focus': {
	          borderColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.7).string()
	        },
	        '&:active': {
	          borderColor: (0, _lodash.get)(color, 'headerLink')
	        }
	      },
	      '.skipPrint &': {
	        '@media print': {
	          display: 'none'
	        }
	      }
	    },
	
	    PersonIcon: {
	      width: 24,
	      height: 24
	    },
	
	    Popper: {
	      marginTop: 4
	    },
	
	    MenuPaper: {
	      borderRadius: 3,
	      boxShadow: 'none',
	      filter: 'drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))'
	    },
	
	    Menu: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      margin: '0 0 0 0 !important',
	      maxHeight: '500px',
	      padding: '4px 0 12px 0 !important',
	      overflowY: 'auto',
	      width: 250
	    },
	
	    UserMenuContent__Item: {
	      borderLeft: '3px solid !important',
	      borderColor: 'rgba(0, 0, 0, 0) !important',
	      height: 36,
	      lineHeight: '36px !important',
	      padding: '0 12px 0 12px !important',
	      '&:hover': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important'
	      },
	      '&:focus': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important',
	        borderColor: (0, _lodash.get)(color, 'headerLink') + ' !important',
	        boxShadow: 'none !important',
	        outline: 'none !important'
	      },
	      '& button, & a': {
	        color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	        display: 'inline-block',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontStyle: 'normal !important',
	        fontWeight: 'normal !important',
	        padding: 0,
	        textTransform: 'capitalize',
	        verticalAlign: 'middle',
	        textAlign: 'left'
	      }
	    },
	
	    UserMenuContent__Name: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      cursor: 'default',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontWeight: 'bold',
	      lineHeight: '36px',
	      whiteSpace: 'nowrap',
	      opacity: '1.0 !important',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      '&:hover': {
	        backgroundColor: 'rgba(0, 0, 0, 0) !important'
	      }
	    },
	
	    UserMenuContent__AccessibleOrgWrapper: {
	      borderLeft: '3px solid !important',
	      borderColor: 'rgba(0, 0, 0, 0) !important',
	      display: 'flex',
	      justifyContent: 'space-between',
	      width: '250px !important',
	      padding: '0 12px 0 12px !important',
	      '& button': {
	        border: '0px solid',
	        color: (0, _lodash.get)(color, 'bodyText'),
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontStyle: 'normal !important',
	        fontWeight: 'normal !important',
	        justifyContent: 'left',
	        lineHeight: '36px'
	      },
	      '&:hover': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important'
	      },
	      '&:focus': {
	        backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'headerLink')).alpha(0.08).string() + ' !important',
	        borderColor: (0, _lodash.get)(color, 'headerLink') + ' !important'
	      }
	    },
	
	    UserMenuContent__AccessibleOrgs: {
	      backgroundColor: 'transparent !important',
	      border: 'none',
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      padding: 0,
	      textAlign: 'left',
	      cursor: 'pointer',
	      outline: 0,
	      textTransform: 'none'
	    },
	
	    UserMenuContent__AccessibleOrgs_label: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis'
	    },
	
	    UserMenuContent__Check: {
	      color: (0, _lodash.get)(color, 'headerLink') + ' !important'
	    },
	
	    SubHeader: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      cursor: 'default',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText'),
	      fontWeight: 'bold',
	      lineHeight: '36px !important',
	      padding: '0 0 0 27px !important',
	      '&:hover': {
	        backgroundColor: 'rgba(0, 0, 0, 0) !important'
	      }
	    },
	
	    SubHeaderUppercase: {
	      textTransform: 'uppercase'
	    }
	  };
	};

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var _Header;
	
	  var color = _ref.color,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return {
	    Header: (_Header = {
	      boxSizing: 'border-box',
	      position: 'fixed',
	      top: 0,
	      width: '100%',
	      backgroundColor: (0, _get2.default)(color, 'headerBackground'),
	      boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.12)',
	      fontFamily: (0, _get2.default)(typography, 'bodyText'),
	      zIndex: 900,
	      marginLeft: 'auto',
	      marginRight: 'auto',
	      paddingLeft: 72,
	      paddingRight: 72
	
	    }, _defineProperty(_Header, '@media screen and (max-width: ' + (0, _get2.default)(misc, 'breakpointSmall') + 'px)', {
	      paddingLeft: 16,
	      paddingRight: 16
	    }), _defineProperty(_Header, '@media screen and (min-width: ' + (0, _get2.default)(misc, 'breakpointSmall') + 'px) and (max-width: ' + (0, _get2.default)(misc, 'breakpointLarge') + 'px)', {
	      paddingLeft: 36,
	      paddingRight: 36
	    }), _Header),
	
	    HeaderInner: {
	      height: 64,
	      width: '100%',
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center'
	    }
	  };
	};

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	var _index = __webpack_require__(1508);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Branding = function Branding(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      homeHref = _ref.homeHref,
	      logo = _ref.logo,
	      serviceTitle = _ref.serviceTitle,
	      siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'a',
	    {
	      className: classes.HeaderBrandingWrapper,
	      href: homeHref
	    },
	    _react2.default.createElement(
	      'div',
	      { className: classes.HeaderBrandingLogo },
	      _react2.default.createElement('img', {
	        className: classes.HeaderBrandingLogoImage,
	        alt: 'Logo',
	        src: logo
	      }),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: classes.HeaderBrandingServiceTitle },
	          serviceTitle
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: classes.HeaderBrandingSiteTitle },
	          siteTitle
	        )
	      )
	    )
	  );
	};
	exports.default = (0, _styles.withStyles)(_index2.default)(Branding);

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var _ref2;
	
	  var color = _ref.color,
	      typography = _ref.typography,
	      misc = _ref.misc;
	  return _ref2 = {
	    HeaderBrandingWrapper: {
	      color: (0, _lodash.get)(color, 'title'),
	      textDecoration: 'none',
	
	      '&:link, &:visited, &:focus': {
	        color: (0, _lodash.get)(color, 'title')
	      },
	
	      '&:hover': {
	        color: (0, _lodash.get)(color, 'title')
	      },
	
	      '&:active': {
	        color: (0, _lodash.get)(color, 'title')
	      },
	
	      '&:focus, &:active': {
	        transition: 'none',
	        outline: 'none'
	      }
	    },
	
	    HeaderBrandingLogo: {
	      alignItems: 'center',
	      display: 'flex'
	    },
	
	    HeaderBrandingLogoImage: {
	      display: 'inline-block',
	      float: 'left',
	      position: 'relative',
	      top: 1,
	      height: 'auto',
	      maxHeight: 33,
	      maxWidth: 50,
	      marginRight: 15
	    },
	
	    HeaderBrandingServiceTitle: {
	      display: 'inherit',
	      height: '100%',
	      marginBottom: 4,
	      color: (0, _lodash.get)(color, 'siteTitle'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: 18
	    },
	
	    HeaderBrandingSiteTitle: {
	      color: (0, _lodash.get)(color, 'smallText'),
	      opacity: 0.6,
	      display: 'inherit',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: 13,
	      height: '100%'
	    }
	
	  }, _defineProperty(_ref2, '@media (min-width: ' + (0, _lodash.get)(misc, 'breakpointMedium') + 'px)', {
	    HeaderBrandingWrapper: {
	      marginLeft: 20,
	      marginRight: 40
	    }
	  }), _defineProperty(_ref2, '@media (min-width: ' + (0, _lodash.get)(misc, 'breakpointMedium') + 'px)', {
	    HeaderBranding__ServiceTitle: {
	      display: 'inherit'
	    },
	    HeaderBranding__SiteTitle: {
	      display: 'inherit'
	    }
	  }), _ref2;
	};

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = HamburgerMenu;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _Check = __webpack_require__(113);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(1510);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HamburgerMenu(props) {
	  var useStyles = (0, _core.makeStyles)(_index2.default);
	  var classes = useStyles();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var navItems = props.navItems,
	      serviceItems = props.serviceItems,
	      userAccessibleOrgs = props.userAccessibleOrgs,
	      userActiveOrgUuid = props.userActiveOrgUuid,
	      userDetails = props.userDetails,
	      updateUserContexts = props.updateUserContexts;
	
	  var hostname = 'https://' + window.location.hostname;
	  var profileLink = hostname + '/admin/my-profile';
	
	  var getImageSource = function getImageSource(serviceItem) {
	    return hostname + serviceItem.link.imagePath.replace('.png', '.svg');
	  };
	
	  var toggleDrawer = function toggleDrawer(flag) {
	    setIsOpen(flag);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'button',
	      { className: classes.HeaderMenuButton, onClick: function onClick() {
	          return toggleDrawer(true);
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: classes.HeaderMenuButtonIcon },
	        _react2.default.createElement('span', { className: classes.HeaderMenuButtonIconMiddleBar })
	      )
	    ),
	    _react2.default.createElement(
	      _core.Drawer,
	      { open: isOpen, onClose: function onClose() {
	          return toggleDrawer(false);
	        } },
	      _react2.default.createElement(
	        'div',
	        {
	          className: classes.list,
	          role: 'presentation',
	          onClick: function onClick() {
	            return toggleDrawer(false);
	          },
	          onKeyDown: function onKeyDown() {
	            return toggleDrawer(false);
	          }
	        },
	        _react2.default.createElement(
	          _core.List,
	          null,
	          navItems.map(function (item) {
	            return _react2.default.createElement(
	              _core.ListItem,
	              { button: true, key: item.id, className: classes.SidemenuNavLink },
	              _react2.default.createElement(
	                'a',
	                { href: item.link.href },
	                _react2.default.createElement(_core.ListItemText, { primary: item.link.title })
	              )
	            );
	          }),
	          !(0, _lodash.isEmpty)(serviceItems) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: classes.subHeader },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Services'
	              )
	            ),
	            serviceItems.map(function (serviceItem) {
	              return _react2.default.createElement(
	                _core.ListItem,
	                { button: true, key: serviceItem.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    key: serviceItem.link.title,
	                    className: (0, _clsx2.default)(classes.ServiceLink, classes.HeaderServiceLink),
	                    href: serviceItem.link.href,
	                    target: serviceItem.link.externalLink ? '_blank' : '_self'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: classes.ServiceLinkImageContainer },
	                    _react2.default.createElement('img', {
	                      alt: serviceItem.link.title + ' Icon',
	                      className: classes.ServiceLinkImage,
	                      src: getImageSource(serviceItem)
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: classes.serviceText },
	                    serviceItem.link.title
	                  )
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.userMenuContent },
	            _react2.default.createElement(
	              _core.ListItem,
	              { button: true, key: 'myProfile', className: (0, _clsx2.default)(classes.SidemenuNavLink, classes.sideMenuPadding) },
	              _react2.default.createElement(
	                _core.Button,
	                {
	                  color: 'secondary',
	                  className: classes.button,
	                  href: profileLink
	                },
	                'My Profile',
	                (0, _utils.hasOrgBoundRole)(userDetails) && _react2.default.createElement(
	                  'div',
	                  { className: (0, _clsx2.default)(classes.SubHeader, classes.SubHeaderUppercase) },
	                  (0, _lodash.upperCase)('organizations')
	                )
	              )
	            ),
	            (0, _utils.hasOrgBoundRole)(userDetails) && _react2.default.createElement(
	              'div',
	              { className: classes.UserMenuContent_Padded },
	              _react2.default.createElement(
	                _core.ListItem,
	                { className: (0, _clsx2.default)(classes.SidemenuNavLink, classes.sideMenuPadding) },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  userAccessibleOrgs.map(function (accessibleOrg) {
	                    return _react2.default.createElement(
	                      'div',
	                      {
	                        key: accessibleOrg.uuid,
	                        className: classes.UserMenuContent__AccessibleOrgWrapper
	                      },
	                      _react2.default.createElement(
	                        _core.Button,
	                        {
	                          color: 'secondary',
	                          className: classes.UserMenuContent__AccessibleOrgs,
	                          onClick: function onClick() {
	                            return updateUserContexts({ orgUuid: accessibleOrg.uuid });
	                          }
	                        },
	                        accessibleOrg.name
	                      ),
	                      userActiveOrgUuid === accessibleOrg.uuid && _react2.default.createElement(_Check2.default, { className: classes.UserMenuContent__Check })
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: classes.UserMenuContent_Padded },
	              _react2.default.createElement(
	                _core.ListItem,
	                { button: true, key: 'logout', className: classes.SidemenuNavLink },
	                _react2.default.createElement(
	                  _core.Button,
	                  {
	                    color: 'secondary',
	                    className: classes.logOutButton,
	                    onClick: function onClick() {
	                      localStorage.clear();
	                      window.location.href = '//' + window.location.hostname + '/admin/logout';
	                    }
	                  },
	                  'Logout'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	HamburgerMenu.propTypes = {
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  serviceItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  userAccessibleOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  userActiveOrgUuid: _propTypes2.default.string,
	  userDetails: _propTypes2.default.shape({}),
	  updateUserContexts: _propTypes2.default.func
	};

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modifyColour = __webpack_require__(87);
	
	var _modifyColour2 = _interopRequireDefault(_modifyColour);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      misc = _ref.misc,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return _defineProperty({
	    HeaderMenuButton: {
	      border: 'none',
	      paddingRight: '50px',
	      position: 'absolute',
	      left: 0,
	      backgroundColor: 'transparent',
	      cursor: 'pointer',
	
	      '&:focus': {
	        outline: 'none'
	      }
	    },
	
	    HeaderMenuButtonIcon: {
	      height: 18,
	      width: 25,
	      marginTop: -9,
	      top: '50%',
	      left: 0,
	      display: 'block',
	      position: 'absolute',
	      padding: 0,
	
	      '&:before': {
	        top: 0
	      },
	
	      '&:after': {
	        bottom: 0
	      },
	
	      '&:before, &:after': {
	        left: 0,
	        right: 0,
	        position: 'absolute',
	        height: 2,
	        content: '" "',
	        display: 'block',
	        backgroundColor: (0, _lodash.get)(color, 'title')
	      }
	    },
	
	    HeaderMenuButtonIconMiddleBar: {
	      display: 'block',
	      height: 2,
	      marginTop: -1,
	      position: 'absolute',
	      top: '50%',
	      left: 0,
	      right: 0,
	      backgroundColor: (0, _lodash.get)(color, 'title')
	    },
	    list: {
	      width: '300px',
	      marginTop: '10px',
	      '& .MuiListItem-root': {
	        paddingTop: '0px'
	
	      },
	
	      '& .MuiListItem-button:hover': {
	        backgroundColor: 'transparent'
	      }
	    },
	    SidemenuNavLink: {
	      display: 'block',
	      padding: '7px 15px 7px 0',
	      marginLeft: '20px',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      '& a': {
	        color: (0, _lodash.get)(color, 'link'),
	        display: 'inline-block',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	        fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	        textDecoration: 'none',
	        transition: (0, _lodash.get)(misc, 'colorTransition'),
	        textTransform: 'capitalize',
	        margin: 0,
	        padding: 0,
	        '&.active': {
	          color: (0, _lodash.get)(color, 'grayDark')
	        },
	        '&:hover': {
	          color: (0, _lodash.get)(color, 'linkHover')
	        }
	      }
	    },
	    logOutButton: {
	      color: (0, _lodash.get)(color, 'link'),
	      display: 'inline-block',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      textDecoration: 'none',
	      transition: (0, _lodash.get)(misc, 'colorTransition'),
	      textTransform: 'capitalize',
	      margin: 0,
	      padding: 0,
	      minWidth: 0,
	      '&.active': {
	        color: (0, _lodash.get)(color, 'grayDark')
	      },
	      '&:hover': {
	        color: (0, _lodash.get)(color, 'linkHover')
	      }
	    },
	    userMenuContent: {
	      marginLeft: '40px'
	    },
	    HeaderServices: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      zIndex: 100
	    },
	    HeaderServicesPanel: {
	      alignItems: 'baseline',
	      display: 'flex',
	      flexWrap: 'wrap',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      padding: '20px 15px',
	      width: '290px'
	    },
	
	    HeaderService: {
	      alignItems: 'center',
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexDirection: 'column',
	      padding: 10,
	      width: 100 / 3 + '%',
	
	      color: (0, _lodash.get)(color, 'grayDark'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText'),
	      textAlign: 'center',
	      textDecoration: 'none'
	    },
	
	    HeaderServiceImage: {
	      marginBottom: '8px',
	      maxHeight: 28,
	      maxWidth: 28
	    },
	
	    HeaderServiceLink: {
	      boxSizing: 'border-box',
	      color: (0, _lodash.get)(color, 'link'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText'),
	      padding: '10px',
	      width: 100 + '%',
	      textAlign: 'center'
	    },
	
	    HeaderServicesButton: {
	      display: 'none',
	      '& button': {
	        color: (0, _lodash.get)(color, 'link')
	      }
	    },
	
	    ServiceLink: {
	      textDecoration: 'none',
	      transition: (0, _lodash.get)(misc, 'colorTransition'),
	
	      '&:hover': {
	        color: (0, _modifyColour2.default)((0, _lodash.get)(color, 'link'), 'lighten', 0.4)
	      }
	    },
	
	    ServiceLinkImageContainer: {
	      margin: '4px',
	      width: 30,
	      height: 30,
	      float: 'left',
	      backgroundColor: (0, _lodash.get)(color, 'link')
	    },
	
	    ServiceLinkImage: {
	      maxHeight: 30,
	      maxWidth: 30
	    },
	    serviceText: {
	      float: 'left',
	      paddingTop: '10px',
	      margin: '4px !important',
	      fontSize: '14px'
	    },
	    subHeader: {
	      marginBottom: 15,
	      color: (0, _lodash.get)(color, 'gray'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText'),
	      textTransform: 'uppercase',
	      margin: '20px 25px',
	      padding: '0'
	    },
	
	    UserMenuContent__Item: {
	      '& button, & a': {
	        color: (0, _lodash.get)(color, 'link'),
	        display: 'inline-block',
	        transition: (0, _lodash.get)(misc, 'colorTransition'),
	
	        '& span': {
	          fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	          fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	          fontWeight: 'normal',
	          marginLeft: 0,
	          textDecoration: 'none'
	        },
	
	        '&:hover': {
	          color: (0, _modifyColour2.default)((0, _lodash.get)(color, 'link'), 'lighten', 0.4),
	          backgroundColor: (0, _lodash.get)(color, 'white') + ' !important'
	        },
	
	        '&:focus': {
	          boxShadow: 'none',
	          outline: 'none'
	        }
	      }
	    },
	
	    UserMenuContent__AccessibleOrgWrapper: {
	      display: 'flex',
	      margin: '2px 0',
	      width: '100%'
	    },
	
	    UserMenuContent__AccessibleOrgs: {
	      backgroundColor: 'transparent !important',
	      border: 'none',
	      color: (0, _lodash.get)(color, 'link'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      paddingLeft: 0,
	      textAlign: 'left',
	      cursor: 'pointer',
	      outline: 0,
	      textTransform: 'none'
	    },
	
	    UserMenuContent__Check: {
	      color: (0, _lodash.get)(color, 'link') + ' !important',
	      margin: '0.5em',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      marginLeft: '10px',
	      paddingTop: '2px'
	    },
	
	    UserMenuContent__ErrorMessage: {
	      padding: '10px 0',
	      width: '100%',
	      backgroundColor: (0, _lodash.get)(color, 'error'),
	      color: (0, _lodash.get)(color, 'white'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      margin: '8px 0',
	      textAlign: 'center'
	    },
	
	    UserMenuContent_OrgsWrapper: {
	      overflowY: 'auto',
	      maxHeight: 200,
	      margin: 8
	    },
	    SubHeader: {
	      marginBottom: 10,
	      color: (0, _lodash.get)(color, 'gray'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText')
	    },
	
	    SubHeaderUppercase: {
	      textTransform: 'uppercase'
	    },
	    sideMenuPadding: {
	      paddingTop: '0px',
	      paddingBottom: ' 0px'
	    }
	  }, '@media (min-width: ' + (0, _lodash.get)(misc, 'breakpointMedium') + 'px)', {
	    HeaderMenuButton: {
	      display: 'none'
	    },
	
	    SubHeader: {
	      marginBottom: 10,
	      color: (0, _lodash.get)(color, 'gray'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText')
	    },
	
	    SubHeaderUppercase: {
	      textTransform: 'uppercase'
	    }
	  });
	};

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(1438);
	
	var _styles = __webpack_require__(30);
	
	var _index = __webpack_require__(1512);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Link = function Link(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      link = _ref.link,
	      useExternalNavLinks = _ref.useExternalNavLinks;
	  return _react2.default.createElement(
	    'li',
	    { className: classes.HeaderNavLink },
	    useExternalNavLinks ? _react2.default.createElement(
	      'a',
	      {
	        className: classes.button,
	        href: link.href
	      },
	      link.title
	    ) : _react2.default.createElement(
	      _reactRouterDom.NavLink,
	      {
	        className: classes.button,
	        to: link.href,
	        activeClassName: classes.active
	      },
	      link.title
	    )
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(Link);

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modifyColour = __webpack_require__(87);
	
	var _modifyColour2 = _interopRequireDefault(_modifyColour);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      typography = _ref.typography,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc;
	  return _defineProperty({
	    HeaderNavLink: {
	      display: 'block',
	      padding: '7px 15px 7px 0',
	
	      '& a': {
	        color: (0, _get2.default)(color, 'headerLink'),
	        display: 'inline-block',
	        fontSize: (0, _get2.default)(fontSize, 'bodyText'),
	        fontFamily: (0, _get2.default)(typography, 'bodyText'),
	        textDecoration: 'none',
	        transition: (0, _get2.default)(misc, 'colorTransition'),
	
	        '&:hover': {
	          color: (0, _modifyColour2.default)((0, _get2.default)(color, 'headerLink'), 'lighten', 0.4)
	        }
	      }
	    }
	
	  }, '@media (min-width: ' + (0, _get2.default)(misc, 'breakpointMedium') + 'px)', {
	    HeaderNavLink: {
	      display: 'inline-block'
	    }
	  });
	};

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(30);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(1511);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _index = __webpack_require__(1514);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = function Nav(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      _ref$navItems = _ref.navItems,
	      navItems = _ref$navItems === undefined ? [] : _ref$navItems,
	      _ref$useExternalNavLi = _ref.useExternalNavLinks,
	      useExternalNavLinks = _ref$useExternalNavLi === undefined ? true : _ref$useExternalNavLi;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _clsx2.default)(classes.HeaderNav, classes.HeaderDesktopNav) },
	    _react2.default.createElement(
	      'div',
	      { className: classes.VerticalAlign },
	      _react2.default.createElement(
	        'div',
	        { className: classes.VerticalAlignInner },
	        _react2.default.createElement(
	          'ul',
	          { className: classes.HeaderNavLinks },
	          navItems.map(function (item) {
	            return _react2.default.createElement(_Link2.default, Object.assign({}, item, {
	              key: item.id,
	              useExternalNavLinks: useExternalNavLinks
	            }));
	          })
	        )
	      )
	    )
	  );
	};
	
	Nav.propTypes = {
	  classes: _propTypes2.default.shape(),
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  useExternalNavLinks: _propTypes2.default.bool
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(Nav);

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var _ref2;
	
	  var misc = _ref.misc;
	  return _ref2 = {
	    HeaderNav: {
	      display: 'none',
	      height: '100%'
	    },
	
	    HeaderDesktopNav: {
	      flex: 1,
	      marginLeft: 20
	    }
	
	  }, _defineProperty(_ref2, '@media (min-width: ' + (0, _lodash.get)(misc, 'breakpointMedium') + 'px)', {
	    HeaderNav: {
	      display: 'inline-block'
	    }
	  }), _defineProperty(_ref2, 'HeaderNavLinks', {
	    display: 'inline-block',
	    listStyle: 'none',
	    padding: 0,
	    margin: 0,
	    position: 'relative',
	    top: 2
	  }), _defineProperty(_ref2, 'VerticalAlign', {
	    height: '100%',
	    display: 'table',
	    textAlign: 'center'
	  }), _defineProperty(_ref2, 'VerticalAlignInner', {
	    display: 'table-cell',
	    verticalAlign: 'middle'
	  }), _ref2;
	};

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(30);
	
	var _Notifications = __webpack_require__(955);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _Block = __webpack_require__(361);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _Paper = __webpack_require__(38);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _isEmpty = __webpack_require__(35);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(1516);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Requests(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      _ref$requestItems = _ref.requestItems,
	      requestItems = _ref$requestItems === undefined ? [] : _ref$requestItems;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      _React$useState2$ = _React$useState2[0],
	      anchorEl = _React$useState2$ === undefined ? false : _React$useState2$,
	      setAnchorEl = _React$useState2[1];
	
	  var handleClick = function handleClick(event) {
	    setAnchorEl(event.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    setAnchorEl(null);
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: classes.HeaderRequestsButton },
	    _react2.default.createElement(
	      _IconButton2.default,
	      { className: classes.button, onClick: handleClick },
	      _react2.default.createElement(_Notifications2.default, { fontSize: 'small' })
	    ),
	    _react2.default.createElement(
	      _Popover2.default,
	      {
	        open: !!anchorEl,
	        anchorEl: anchorEl,
	        onClose: handleClose,
	        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
	        transformOrigin: { vertical: 'top', horizontal: 'right' }
	      },
	      (0, _isEmpty2.default)(requestItems) && _react2.default.createElement(
	        _Paper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: classes.Menu },
	          _react2.default.createElement(
	            'div',
	            { className: classes.HeaderRequestsNoRequestsIcon },
	            _react2.default.createElement(_Block2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.HeaderRequestsNoRequestsText },
	            'No Requests'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.HeaderRequestsNoRequestsMessage },
	            'All active requests have been resolved'
	          )
	        )
	      ),
	      !(0, _isEmpty2.default)(requestItems) && _react2.default.createElement(
	        _Paper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: classes.Menu },
	          _react2.default.createElement(
	            'div',
	            { className: classes.HeaderRequestsMenuWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _clsx2.default)(classes.SubHeader, classes.SubHeaderUppercase) },
	              'Requests'
	            ),
	            requestItems.map(function (requestItem) {
	              return _react2.default.createElement(
	                'a',
	                {
	                  className: classes.HeaderRequestsMenuItem,
	                  href: '//' + window.location.hostname + '/admin/requests#' + (requestItem.RequestType === 'APPLICATION' ? 'application-details' : 'registration-details') + '/' + requestItem.Uuid,
	                  key: requestItem.Uuid
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  requestItem.RequestType.charAt(0) + requestItem.RequestType.slice(1).toLowerCase()
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.HeaderRequestsViewMore },
	          _react2.default.createElement(
	            'a',
	            { href: '//' + window.location.hostname + '/admin/requests' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'View all Requests'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	Requests.propTypes = {
	  classes: _propTypes2.default.shape(),
	  requestItems: _propTypes2.default.arrayOf(_propTypes2.default.shape())
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(Requests);

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modifyColour = __webpack_require__(87);
	
	var _modifyColour2 = _interopRequireDefault(_modifyColour);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return _defineProperty({
	    Menu: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      width: 225,
	      padding: '10px 0 8px'
	    },
	    HeaderRequestsMenu: {
	      paddingBottom: 0
	    },
	    HeaderRequestsMenuWrapper: {
	      padding: '10px 20px'
	    },
	    HeaderRequestsMenuItem: {
	      borderBottom: '1px solid ' + (0, _lodash.get)(color, 'grayLight'),
	      display: 'block',
	      margin: '0px -20px',
	      padding: '10px 20px',
	      color: (0, _lodash.get)(color, 'link'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText'),
	      lineHeight: '1.2em',
	      textDecoration: 'none',
	      transition: (0, _lodash.get)(misc, 'colorTransition'),
	      '&:hover': {
	        color: (0, _modifyColour2.default)((0, _lodash.get)(color, 'link'), 'lighten', 0.4)
	      },
	      '&:first-of-type': {
	        paddingTop: 0
	      },
	      '&:last-of-type': {
	        paddingBottom: 0
	      },
	      '&:last-child': {
	        border: 'none',
	        marginBottom: 0
	      }
	    },
	    HeaderRequestsButton: {
	      display: 'none',
	      '& button': {
	        color: (0, _lodash.get)(color, 'headerLink')
	      }
	    },
	    HeaderRequestsViewMore: {
	      borderTop: '1px solid ' + (0, _lodash.get)(color, 'gray'),
	      padding: '20px 0px',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      textAlign: 'center',
	      '& a': {
	        color: (0, _lodash.get)(color, 'link'),
	        textDecoration: 'none'
	      }
	    },
	    HeaderRequestsNoRequestsIcon: {
	      color: (0, _lodash.get)(color, 'link') + ' !important',
	      display: 'inline-block',
	      margin: '0 auto',
	      paddingTop: '5px',
	      textAlign: 'center',
	      width: '100%'
	    },
	    HeaderRequestsNoRequestsText: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'large'),
	      fontWeight: '100',
	      margin: '0 auto',
	      paddingTop: (0, _lodash.get)(misc, 'gutter'),
	      textAlign: 'center',
	      width: '100%'
	    },
	    HeaderRequestsNoRequestsMessage: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontWeight: '100',
	      margin: '0 auto',
	      paddingBottom: (0, _lodash.get)(misc, 'gutter'),
	      paddingTop: (0, _lodash.get)(misc, 'gutter'),
	      textAlign: 'center',
	      width: '100%'
	    },
	    SubHeader: {
	      marginBottom: 15,
	      color: (0, _lodash.get)(color, 'gray'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText')
	    },
	    SubHeaderUppercase: {
	      textTransform: 'uppercase'
	    }
	  }, '@media (min-width: ' + (0, _lodash.get)(misc, 'breakpointMedium') + 'px)', {
	    HeaderRequestsButton: {
	      display: 'inline-block'
	    }
	  });
	};

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(30);
	
	var _Apps = __webpack_require__(940);
	
	var _Apps2 = _interopRequireDefault(_Apps);
	
	var _Paper = __webpack_require__(38);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _isEmpty = __webpack_require__(35);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(1518);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Services(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      _ref$serviceItems = _ref.serviceItems,
	      serviceItems = _ref$serviceItems === undefined ? [] : _ref$serviceItems;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      _React$useState2$ = _React$useState2[0],
	      anchorEl = _React$useState2$ === undefined ? false : _React$useState2$,
	      setAnchorEl = _React$useState2[1];
	
	  var handleClick = function handleClick(event) {
	    setAnchorEl(event.currentTarget);
	  };
	  var hostname = 'https://' + window.location.hostname;
	  var getImageSource = function getImageSource(serviceItem) {
	    return hostname + serviceItem.link.imagePath.replace('.png', '.svg');
	  };
	  var handleClose = function handleClose() {
	    setAnchorEl(null);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.HeaderServicesButton },
	    _react2.default.createElement(
	      _IconButton2.default,
	      { onClick: handleClick },
	      _react2.default.createElement(_Apps2.default, { fontSize: 'small' })
	    ),
	    _react2.default.createElement(
	      _Popover2.default,
	      {
	        open: !!anchorEl,
	        anchorEl: anchorEl,
	        onClose: handleClose,
	        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
	        transformOrigin: { vertical: 'top', horizontal: 'right' }
	      },
	      !(0, _isEmpty2.default)(serviceItems) && _react2.default.createElement(
	        _Paper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: classes.HeaderServicesPanel },
	          serviceItems.map(function (serviceItem) {
	            return _react2.default.createElement(
	              'a',
	              {
	                key: serviceItem.link.title,
	                className: (0, _clsx2.default)(classes.ServiceLink, classes.HeaderServiceLink),
	                href: serviceItem.link.href,
	                target: serviceItem.link.externalLink ? '_blank' : '_self'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: classes.ServiceLinkImageContainer },
	                _react2.default.createElement('img', {
	                  alt: serviceItem.link.title + ' Icon',
	                  className: classes.ServiceLinkImage,
	                  src: getImageSource(serviceItem)
	                })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                serviceItem.link.title
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	}
	
	Services.propTypes = {
	  classes: _propTypes2.default.shape(),
	  serviceItems: _propTypes2.default.arrayOf(_propTypes2.default.shape())
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(Services);

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modifyColour = __webpack_require__(87);
	
	var _modifyColour2 = _interopRequireDefault(_modifyColour);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return _defineProperty({
	    HeaderServices: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      zIndex: 100
	    },
	
	    Menu: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      width: 225,
	      padding: '10px 0 8px'
	    },
	
	    HeaderServicesPanel: {
	      alignItems: 'baseline',
	      display: 'flex',
	      flexWrap: 'wrap',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      padding: '20px 15px',
	      width: '290px'
	    },
	
	    HeaderService: {
	      alignItems: 'center',
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexDirection: 'column',
	      padding: 10,
	      width: 100 / 3 + '%',
	
	      color: (0, _lodash.get)(color, 'grayDark'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText'),
	      textAlign: 'center',
	      textDecoration: 'none'
	    },
	
	    HeaderServiceImage: {
	      marginBottom: '8px',
	      maxHeight: 28,
	      maxWidth: 28
	    },
	
	    HeaderServiceLink: {
	      alignItems: 'center',
	      boxSizing: 'border-box',
	      color: (0, _lodash.get)(color, 'link'),
	      display: 'flex',
	      flexDirection: 'column',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText'),
	      padding: '10px',
	      width: 100 / 3 + '%',
	      textAlign: 'center'
	    },
	
	    HeaderServicesButton: {
	      display: 'none',
	
	      '& button': {
	        color: (0, _lodash.get)(color, 'headerLink')
	      }
	    },
	
	    ServiceLink: {
	      textDecoration: 'none',
	      transition: (0, _lodash.get)(misc, 'colorTransition'),
	
	      '&:hover': {
	        color: (0, _modifyColour2.default)((0, _lodash.get)(color, 'link'), 'lighten', 0.4)
	      }
	    },
	
	    ServiceLinkImageContainer: {
	      margin: '4px',
	      width: 30,
	      height: 30,
	      textAlign: 'center',
	      backgroundColor: (0, _lodash.get)(color, 'link')
	    },
	
	    ServiceLinkImage: {
	      maxHeight: 30,
	      maxWidth: 30
	    }
	
	  }, '@media (min-width: ' + (0, _lodash.get)(misc, 'breakpointMedium') + 'px)', {
	    HeaderServicesButton: {
	      display: 'inline-block'
	    }
	  });
	};

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(30);
	
	var _Settings = __webpack_require__(958);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _Paper = __webpack_require__(38);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _isEmpty = __webpack_require__(35);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(1520);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Settings(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      _ref$settingItems = _ref.settingItems,
	      settingItems = _ref$settingItems === undefined ? [] : _ref$settingItems;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      _React$useState2$ = _React$useState2[0],
	      anchorEl = _React$useState2$ === undefined ? false : _React$useState2$,
	      setAnchorEl = _React$useState2[1];
	
	  var handleClick = function handleClick(event) {
	    setAnchorEl(event.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    setAnchorEl(null);
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: classes.HeaderSettingsButton },
	    _react2.default.createElement(
	      _IconButton2.default,
	      { onClick: handleClick },
	      _react2.default.createElement(_Settings2.default, { fontSize: 'small' })
	    ),
	    _react2.default.createElement(
	      _Popover2.default,
	      {
	        open: !!anchorEl,
	        anchorEl: anchorEl,
	        onClose: handleClose,
	        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
	        transformOrigin: { vertical: 'top', horizontal: 'right' }
	      },
	      !(0, _isEmpty2.default)(settingItems) && _react2.default.createElement(
	        _Paper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: classes.Menu },
	          _react2.default.createElement(
	            'div',
	            { className: classes.HeaderSettingsMenuWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _clsx2.default)(classes.SubHeader, classes.SubHeaderUppercase) },
	              'Administration'
	            ),
	            settingItems.map(function (settingItem) {
	              return _react2.default.createElement(
	                'a',
	                {
	                  className: classes.HeaderSettingsMenuItem,
	                  href: '//' + window.location.hostname + settingItem.link.href,
	                  key: settingItem.id
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  settingItem.link.title
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	Settings.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  settingItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(Settings);

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modifyColour = __webpack_require__(87);
	
	var _modifyColour2 = _interopRequireDefault(_modifyColour);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return _defineProperty({
	    HeaderSettings: {
	      zIndex: 100
	    },
	
	    Menu: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      width: 225,
	      padding: '10px 0 8px'
	    },
	
	    HeaderSettingsMenuItem: {
	      display: 'block',
	      color: (0, _lodash.get)(color, 'link'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      lineHeight: '1.2em',
	      marginBottom: 10,
	      textDecoration: 'none',
	      transition: (0, _lodash.get)(misc, 'colorTransition'),
	
	      '&:hover': {
	        color: (0, _modifyColour2.default)((0, _lodash.get)(color, 'link'), 'lighten', 0.4)
	      },
	
	      '&:last-child': {
	        marginBottom: 0
	      }
	    },
	
	    HeaderSettingsButton: {
	      display: 'none',
	      '& button': {
	        color: (0, _lodash.get)(color, 'headerLink')
	      }
	    },
	
	    HeaderSettingsMenuWrapper: {
	      padding: '10px 20px 7px'
	    },
	
	    SubHeader: {
	      marginBottom: 15,
	      color: (0, _lodash.get)(color, 'gray'),
	      fontSize: (0, _lodash.get)(fontSize, 'smallText')
	    },
	
	    SubHeaderUppercase: {
	      textTransform: 'uppercase'
	    }
	
	  }, '@media (min-width: ' + (0, _lodash.get)(misc, 'breakpointMedium') + 'px)', {
	    HeaderSettingsButton: {
	      display: 'inline-block'
	    }
	  });
	};

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(8);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _styles = __webpack_require__(30);
	
	var _AccountCircle = __webpack_require__(939);
	
	var _AccountCircle2 = _interopRequireDefault(_AccountCircle);
	
	var _ArrowDropDown = __webpack_require__(360);
	
	var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);
	
	var _Check = __webpack_require__(113);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(1522);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderAccessibleOrgs = function renderAccessibleOrgs(_ref) {
	  var classes = _ref.classes,
	      userActiveOrgUuid = _ref.userActiveOrgUuid,
	      updateUserContexts = _ref.updateUserContexts;
	  return function (accessibleOrg) {
	    return _react2.default.createElement(
	      'div',
	      { key: accessibleOrg.uuid, className: classes.UserMenuContent__AccessibleOrgWrapper },
	      _react2.default.createElement(
	        _core.Button,
	        {
	          color: 'secondary',
	          className: classes.UserMenuContent__AccessibleOrgs,
	          onClick: function onClick() {
	            return updateUserContexts({ orgUuid: accessibleOrg.uuid });
	          }
	        },
	        accessibleOrg.name
	      ),
	      userActiveOrgUuid === accessibleOrg.uuid && _react2.default.createElement(_Check2.default, { className: classes.UserMenuContent__Check })
	    );
	  };
	};
	
	var renderUser = function renderUser(_ref2) {
	  var classes = _ref2.classes,
	      userAccessibleOrgs = _ref2.userAccessibleOrgs,
	      userActiveOrgUuid = _ref2.userActiveOrgUuid,
	      userDetails = _ref2.userDetails,
	      updateUserContexts = _ref2.updateUserContexts;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: classes.UserMenuContent_Padded },
	      _react2.default.createElement(
	        'div',
	        { className: classes.UserMenuContent__Item },
	        _react2.default.createElement(
	          _core.Button,
	          {
	            color: 'secondary',
	            className: classes.button,
	            href: 'https://' + window.location.hostname + '/admin/my-profile'
	          },
	          'My Profile'
	        )
	      )
	    ),
	    (0, _utils.hasOrgBoundRole)(userDetails) && _react2.default.createElement(
	      'div',
	      { className: classes.UserMenuContent_Padded },
	      _react2.default.createElement(
	        'div',
	        { className: classes.UserMenuContent_OrgsWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _clsx2.default)(classes.SubHeader, classes.SubHeaderUppercase) },
	          (0, _lodash.upperCase)('organizations')
	        ),
	        (0, _lodash.map)(userAccessibleOrgs, renderAccessibleOrgs({ classes: classes, userActiveOrgUuid: userActiveOrgUuid, updateUserContexts: updateUserContexts }))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.UserMenuContent_Padded },
	      _react2.default.createElement(
	        'div',
	        { className: classes.UserMenuContent__Item },
	        _react2.default.createElement(
	          _core.Button,
	          {
	            color: 'secondary',
	            className: classes.button,
	            onClick: function onClick() {
	              localStorage.clear();
	              window.location.href = '//' + window.location.hostname + '/admin/logout';
	            }
	          },
	          'Logout'
	        )
	      )
	    )
	  );
	};
	
	function User(_ref3) {
	  var _ref3$classes = _ref3.classes,
	      classes = _ref3$classes === undefined ? {} : _ref3$classes,
	      userAccessibleOrgs = _ref3.userAccessibleOrgs,
	      userActiveOrgUuid = _ref3.userActiveOrgUuid,
	      userDetails = _ref3.userDetails,
	      updateUserContexts = _ref3.updateUserContexts;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      _React$useState2$ = _React$useState2[0],
	      anchorEl = _React$useState2$ === undefined ? false : _React$useState2$,
	      setAnchorEl = _React$useState2[1];
	
	  var handleClick = function handleClick(event) {
	    setAnchorEl(event.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    setAnchorEl(null);
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: classes.UserMenuButton },
	    _react2.default.createElement(
	      _core.IconButton,
	      { color: 'secondary', onClick: handleClick },
	      _react2.default.createElement(_AccountCircle2.default, { fontSize: 'small' })
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: classes.user, onClick: handleClick },
	      userDetails.username
	    ),
	    _react2.default.createElement(
	      _core.IconButton,
	      { color: 'secondary', onClick: handleClick },
	      _react2.default.createElement(_ArrowDropDown2.default, { fontSize: 'default' })
	    ),
	    _react2.default.createElement(
	      _core.Popover,
	      {
	        open: !!anchorEl,
	        anchorEl: anchorEl,
	        onClose: handleClose,
	        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
	        transformOrigin: { vertical: 'top', horizontal: 'right' }
	      },
	      _react2.default.createElement(
	        _core.Paper,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: classes.Menu },
	          renderUser({
	            classes: classes,
	            userAccessibleOrgs: userAccessibleOrgs,
	            userActiveOrgUuid: userActiveOrgUuid,
	            userDetails: userDetails,
	            updateUserContexts: updateUserContexts
	          })
	        )
	      )
	    )
	  );
	}
	
	User.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  userAccessibleOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  userActiveOrgUuid: _propTypes2.default.string,
	  userDetails: _propTypes2.default.shape({}),
	  updateUserContexts: _propTypes2.default.func
	};
	
	renderUser.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  userAccessibleOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  userActiveOrgUuid: _propTypes2.default.string,
	  userDetails: _propTypes2.default.shape({}),
	  updateUserContexts: _propTypes2.default.func
	};
	
	exports.default = (0, _styles.withStyles)(_index2.default)(User);

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modifyColour = __webpack_require__(87);
	
	var _modifyColour2 = _interopRequireDefault(_modifyColour);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var _ref2;
	
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return _ref2 = {
	    Menu: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      width: 250,
	      padding: '10px 0 8px'
	    },
	
	    UserMenu: {
	      zIndex: 100
	    },
	
	    UserMenuButton: {
	      display: 'none',
	      color: (0, _lodash.get)(color, 'headerLink') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      '& span': {
	        verticalAlign: 'middle'
	      },
	      '& button': {
	        color: (0, _lodash.get)(color, 'headerLink') + ' !important'
	      }
	    },
	
	    UserMenuContent_Padded: {
	      padding: '5px 20px'
	    },
	
	    UserMenuContent__Item: {
	      '& button, & a': {
	        color: (0, _lodash.get)(color, 'link'),
	        display: 'inline-block',
	        transition: (0, _lodash.get)(misc, 'colorTransition'),
	        textTransform: 'capitalize',
	
	        '& span': {
	          fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	          fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	          fontWeight: 'normal',
	          marginLeft: 0,
	          textDecoration: 'none'
	        },
	
	        '&:hover': {
	          color: (0, _modifyColour2.default)((0, _lodash.get)(color, 'link'), 'lighten', 0.4),
	          backgroundColor: (0, _lodash.get)(color, 'white') + ' !important'
	        },
	
	        '&:focus': {
	          boxShadow: 'none',
	          outline: 'none'
	        }
	      }
	    },
	
	    UserMenuContent__AccessibleOrgWrapper: {
	      display: 'flex',
	      margin: '2px 0',
	      justifyContent: 'space-between',
	      width: '100%'
	    },
	
	    UserMenuContent__AccessibleOrgs: {
	      backgroundColor: 'transparent !important',
	      border: 'none',
	      color: (0, _lodash.get)(color, 'link'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      paddingLeft: 0,
	      textAlign: 'left',
	      cursor: 'pointer',
	      outline: 0,
	      textTransform: 'none'
	    },
	
	    UserMenuContent__Check: {
	      color: (0, _lodash.get)(color, 'link') + ' !important',
	      margin: '0.5em',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText')
	    },
	
	    UserMenuContent__ErrorMessage: {
	      padding: '10px 0',
	      width: '100%',
	
	      backgroundColor: (0, _lodash.get)(color, 'error'),
	      color: (0, _lodash.get)(color, 'white'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      margin: '8px 0',
	      textAlign: 'center'
	    },
	
	    UserMenuContent_OrgsWrapper: {
	      overflowY: 'auto',
	      maxHeight: 200,
	      margin: 8
	    }
	
	  }, _defineProperty(_ref2, '@media (min-width: ' + (0, _lodash.get)(misc, 'breakpointMedium') + 'px)', {
	    UserMenuButton: {
	      display: 'inline-block'
	    }
	  }), _defineProperty(_ref2, 'SubHeader', {
	    marginBottom: 10,
	    color: (0, _lodash.get)(color, 'gray'),
	    fontSize: (0, _lodash.get)(fontSize, 'smallText')
	  }), _defineProperty(_ref2, 'SubHeaderUppercase', {
	    textTransform: 'uppercase'
	  }), _defineProperty(_ref2, 'user', {
	    cursor: 'pointer'
	  }), _ref2;
	};

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = exports.getNavLabels = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _recompose = __webpack_require__(105);
	
	var _styles = __webpack_require__(30);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _portalConfig = __webpack_require__(85);
	
	var _portalConfig2 = __webpack_require__(26);
	
	var _Branding = __webpack_require__(1507);
	
	var _Branding2 = _interopRequireDefault(_Branding);
	
	var _HamburgerMenu = __webpack_require__(1509);
	
	var _HamburgerMenu2 = _interopRequireDefault(_HamburgerMenu);
	
	var _Nav = __webpack_require__(1513);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Requests = __webpack_require__(1515);
	
	var _Requests2 = _interopRequireDefault(_Requests);
	
	var _Services = __webpack_require__(1517);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _Settings = __webpack_require__(1519);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _User = __webpack_require__(1521);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _index = __webpack_require__(1524);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getNavLabels = exports.getNavLabels = function getNavLabels(navItems, themeBrandedLabels) {
	  return navItems.map(function (navItem) {
	    var link = navItem.link;
	
	    if (themeBrandedLabels && link.titleKey && themeBrandedLabels[link.titleKey]) {
	      return Object.assign({}, navItem, {
	        link: Object.assign({}, link, {
	          title: themeBrandedLabels[link.titleKey]
	        })
	      });
	    }
	    return navItem;
	  });
	};
	
	
	function componentDidMount() {
	  var _props = this.props,
	      isPortalAdmin = _props.isPortalAdmin,
	      isOrgPublisher = _props.isOrgPublisher;
	
	
	  if (isPortalAdmin || isOrgPublisher) {
	    // Publisher Role
	    this.props.fetchRequests();
	  }
	}
	
	var Header = function Header(props) {
	  var logo = props.logo,
	      siteTitle = props.siteTitle,
	      homeHref = props.homeHref,
	      classes = props.classes,
	      themeBrandedLabels = props.themeBrandedLabels,
	      requestItems = props.requestItems,
	      serviceItems = props.serviceItems,
	      settingItems = props.settingItems,
	      userAccessibleOrgs = props.userAccessibleOrgs,
	      userActiveOrgUuid = props.userActiveOrgUuid,
	      userDetails = props.userDetails;
	
	  var navItems = getNavLabels(props.navItems, themeBrandedLabels);
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.Header },
	    _react2.default.createElement(
	      'div',
	      { className: classes.HeaderInner },
	      _react2.default.createElement(_HamburgerMenu2.default, {
	        navItems: navItems,
	        serviceItems: serviceItems,
	        userAccessibleOrgs: userAccessibleOrgs,
	        userActiveOrgUuid: userActiveOrgUuid,
	        userDetails: userDetails,
	        updateUserContexts: props.updateUserContexts
	      }),
	      _react2.default.createElement(_Branding2.default, {
	        logo: logo,
	        siteTitle: siteTitle,
	        homeHref: homeHref
	      }),
	      _react2.default.createElement(_Nav2.default, { navItems: navItems }),
	      _react2.default.createElement(_Requests2.default, { requestItems: requestItems }),
	      _react2.default.createElement(_Services2.default, { serviceItems: serviceItems }),
	      _react2.default.createElement(_Settings2.default, { settingItems: settingItems }),
	      _react2.default.createElement(_User2.default, {
	        userAccessibleOrgs: userAccessibleOrgs,
	        userActiveOrgUuid: userActiveOrgUuid,
	        userDetails: userDetails,
	        updateUserContexts: props.updateUserContexts
	      })
	    )
	  );
	};
	
	var getHomePageRef = function getHomePageRef(state) {
	  var hostName = window.location.hostname;
	  if ((0, _portalConfig2.getIsPortalAdmin)(state)) {
	    return '//' + hostName + '/admin';
	  } else if ((0, _portalConfig2.getIsAnonymousRole)(state)) {
	    return '//' + hostName + '/admin/app/guest/dashboard';
	  }
	  return '//' + hostName + '/admin/app/dashboard';
	};
	
	var getNavItems = function getNavItems(state) {
	  if (window.location.href.includes('/dev')) {
	    return (0, _portalConfig2.getDeveloperNavigations)(state).service_links;
	  } else if (window.location.href.includes('/admin')) {
	    return [];
	  }
	  return (0, _portalConfig2.getPublisherNavigation)(state).service_links;
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  var _getThemes = (0, _portalConfig2.getThemes)(state),
	      logo = _getThemes.logo,
	      siteTitle = _getThemes.siteTitle;
	
	  return {
	    logo: logo,
	    siteTitle: siteTitle,
	    isPortalAdmin: (0, _portalConfig2.getIsPortalAdmin)(state),
	    isOrgPublisher: (0, _portalConfig2.getIsOrgPublisher)(state),
	    homeHref: getHomePageRef(state),
	    navItems: getNavItems(state),
	    themeBrandedLabels: (0, _portalConfig2.getThemeBrandedLabels)(state),
	    serviceItems: (0, _portalConfig2.getServices)(state).services,
	    settingItems: (0, _portalConfig2.getSettingsNavigation)(state).service_links,
	    userAccessibleOrgs: (0, _portalConfig2.getUserAccessibleOrgs)(state),
	    userActiveOrgUuid: (0, _portalConfig2.getUserActiveOrgUuid)(state),
	    userDetails: (0, _portalConfig2.getUserDetails)(state),
	    requestItems: (0, _portalConfig2.getRequests)(state)
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = {
	  updateUserContexts: _portalConfig.updateUserContexts,
	  fetchRequests: _portalConfig.fetchRequests
	};
	
	Header.propTypes = {
	  logo: _propTypes2.default.string,
	  siteTitle: _propTypes2.default.string,
	  homeHref: _propTypes2.default.string,
	  classes: _propTypes2.default.shape({}),
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  themeBrandedLabels: _propTypes2.default.shape({}),
	  serviceItems: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  settingItems: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  userAccessibleOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  userActiveOrgUuid: _propTypes2.default.string,
	  userDetails: _propTypes2.default.shape({}),
	  requestItems: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
	  updateUserContexts: _propTypes2.default.func
	};
	
	exports.default = (0, _recompose.compose)((0, _styles.withStyles)(_index2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.lifecycle)({ componentDidMount: componentDidMount }))(Header);

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      typography = _ref.typography;
	  return {
	    Header: {
	      boxSizing: 'border-box',
	      position: 'fixed',
	      top: 0,
	      width: '100%',
	      backgroundColor: (0, _get2.default)(color, 'headerBackground'),
	      boxShadow: '0 1px 20px 0 rgba(0, 0, 0, 0.1)',
	      fontFamily: (0, _get2.default)(typography, 'bodyText'),
	      zIndex: 900,
	      marginLeft: 'auto',
	      marginRight: 'auto',
	      paddingLeft: 10,
	      paddingRight: 10
	    },
	
	    HeaderInner: {
	      height: 70,
	      width: '100%',
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center'
	    }
	  };
	};

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ListHelpRaw;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _FiberManualRecord = __webpack_require__(949);
	
	var _FiberManualRecord2 = _interopRequireDefault(_FiberManualRecord);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(609);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListHelpRaw(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var lists = props.lists;
	
	
	  return _react2.default.createElement(
	    _core.List,
	    { classes: { root: classes.listRoot } },
	    lists.items.map(function (listItem, index) {
	      return _react2.default.createElement(
	        _core.ListItem,
	        { key: 'list_' + index.toString(), classes: { root: classes.listRoot } },
	        lists.type && _react2.default.createElement(
	          _core.ListItemIcon,
	          { classes: { root: classes.listIconRoot } },
	          lists.type === 'circle' && _react2.default.createElement(_FiberManualRecord2.default, { className: classes.iconText })
	        ),
	        _react2.default.createElement(_core.ListItemText, { primary: listItem })
	      );
	    })
	  );
	}
	
	ListHelpRaw.propTypes = {
	  lists: _propTypes2.default.shape({})
	};

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HelpContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _ListHelp = __webpack_require__(1525);
	
	var _ListHelp2 = _interopRequireDefault(_ListHelp);
	
	var _styles = __webpack_require__(609);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HelpContainer(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      helpItems = props.helpItems;
	
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.helpContainer,
	      id: id, 'data-layer7-test': id
	    },
	    _react2.default.createElement(
	      'h2',
	      { className: classes.helpTitle },
	      helpItems.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.helpDescription },
	      helpItems.descriptions
	    ),
	    helpItems.subItems.map(function (item) {
	      return _react2.default.createElement(
	        'div',
	        { key: item.id, className: classes.helpSubContainer },
	        _react2.default.createElement(
	          'div',
	          { className: classes.helpTextHead },
	          item.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.helpTextBody },
	          item.descriptions,
	          item.list && item.list.items.length > 0 && _react2.default.createElement(_ListHelp2.default, { lists: item.list })
	        )
	      );
	    })
	  );
	}
	
	HelpContainer.propTypes = {
	  id: _propTypes.string,
	  helpItems: (0, _propTypes.shape)({})
	};

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color;
	  return {
	    scrollBar: {
	      display: 'flex',
	      flexDirection: 'row',
	      overflow: 'hidden'
	    },
	    scrollBtn: {
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontSize: 30,
	      outline: 'none',
	      cursor: 'pointer',
	      color: (0, _lodash.get)(color, 'link'),
	      border: 0,
	      height: 130,
	      background: 'transparent linear-gradient(89deg, #FFFFFF00 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box'
	    },
	    scrollBtn__hide: {
	      display: 'none'
	    },
	    container: {
	      position: 'relative'
	    },
	    leftscrollBtn: {
	      position: 'absolute',
	      top: 0,
	      height: 130,
	      fontSize: 30,
	      color: (0, _lodash.get)(color, 'link'),
	      outline: 'none',
	      cursor: 'pointer',
	      left: 0,
	      border: '0',
	      background: 'transparent linear-gradient(89deg, #FFFFFF 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Loading = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1529);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getContainerClass = function getContainerClass(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      _ref$pageLoader = _ref.pageLoader,
	      pageLoader = _ref$pageLoader === undefined ? false : _ref$pageLoader,
	      _ref$sectionLoader = _ref.sectionLoader,
	      sectionLoader = _ref$sectionLoader === undefined ? false : _ref$sectionLoader;
	
	  if (pageLoader) {
	    return (0, _classnames2.default)(classes.root, classes.pageLoader);
	  } else if (sectionLoader) {
	    return (0, _classnames2.default)(classes.root, classes.sectionLoader);
	  } else {
	    return (0, _classnames2.default)(classes.root, classes.progress);
	  }
	};
	
	var Loading = exports.Loading = function Loading(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: getContainerClass(props),
	      id: 'apim-loading',
	      'data-apim-test': 'apim-loading',
	      'data-layer7-test': 'apim-loading'
	    },
	    _react2.default.createElement(_core.CircularProgress, { disableShrink: true })
	  );
	};
	
	Loading.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  pageLoader: _propTypes.bool,
	  sectionLoader: _propTypes.bool
	};
	Loading.displayName = 'Loading';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(Loading);

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      spacing = _ref.spacing;
	  return {
	    root: {
	      height: '100%',
	      width: '100%',
	      '& .MuiCircularProgress-colorPrimary': {
	        color: (0, _get2.default)(color, 'primaryButtonBackground')
	      }
	    },
	    progress: {
	      lineHeight: '600px',
	      margin: spacing(2),
	      textAlign: 'center'
	    },
	    pageLoader: {
	      textAlign: 'center',
	      lineHeight: '600px',
	      left: 0,
	      right: 0,
	      top: 70,
	      bottom: 0,
	      position: 'fixed',
	      background: (0, _get2.default)(color, 'overlayBackground'),
	      opacity: '0.5',
	      zIndex: '2300',
	      alignItems: 'center',
	      justifyContent: 'center'
	    },
	    sectionLoader: {
	      alignItems: 'center',
	      background: (0, _get2.default)(color, 'overlayBackground'),
	      display: 'flex',
	      justifyContent: 'center',
	      opacity: '0.5',
	      zIndex: '2300'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LoadingDialog;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1531);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoadingDialog(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      isOpen = props.isOpen,
	      title = props.title,
	      description = props.description,
	      _props$dialogId = props.dialogId,
	      dialogId = _props$dialogId === undefined ? 'loading-dialog' : _props$dialogId;
	
	
	  return _react2.default.createElement(
	    _core.Dialog,
	    {
	      open: isOpen,
	      'aria-labelledby': 'loading-dialog-title',
	      'aria-describedby': 'loading-dialog-description',
	      id: id || dialogId, 'data-apim-test': id || dialogId, 'data-layer7-test': id || dialogId,
	      classes: {
	        paper: classes.dialogContainer
	      }
	    },
	    _react2.default.createElement(
	      _core.DialogTitle,
	      {
	        id: 'loading-dialog-title',
	        'data-apim-test': 'loading-dialog-title',
	        className: classes.dialogTitle
	      },
	      _react2.default.createElement(
	        _core.Typography,
	        { variant: 'h3', className: classes.title },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      _core.DialogContent,
	      null,
	      _react2.default.createElement(
	        _core.DialogContentText,
	        { id: 'loading-dialog-description', 'data-apim-test': 'loading-dialog-description', className: classes.content },
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'body1' },
	          description
	        ),
	        _react2.default.createElement(_core.CircularProgress, { color: 'primary', className: classes.progress })
	      )
	    )
	  );
	}
	
	LoadingDialog.propTypes = {
	  id: _propTypes2.default.string,
	  isOpen: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  dialogId: _propTypes2.default.string
	};

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    dialogContainer: {
	      minWidth: 400,
	      minHeight: 200,
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground')
	    },
	    title: {
	      margin: 0
	    },
	    dialogTitle: {
	      display: 'inline-flex'
	    },
	    content: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center'
	    },
	    progress: {
	      marginTop: theme.spacing(3),
	      marginBottom: theme.spacing(3),
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(1728);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _core = __webpack_require__(3);
	
	var _ArrowDropDown = __webpack_require__(360);
	
	var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _lodash = __webpack_require__(8);
	
	var _index = __webpack_require__(1533);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var getValueOptions = function getValueOptions(values) {
	  return (0, _lodash.map)(values, function (item) {
	    return {
	      value: item,
	      label: item
	    };
	  });
	};
	
	var sortFn = function sortFn(item1, item2) {
	  return item1 && item1.label && item1.label.toLowerCase().localeCompare(item2 && item2.label && item2.label.toLowerCase());
	};
	
	var MultiSelectRaw = function MultiSelectRaw(props) {
	  var optionsData = props.optionsData,
	      menuIsOpen = props.menuIsOpen,
	      value = props.value,
	      otherProps = _objectWithoutProperties(props, ['optionsData', 'menuIsOpen', 'value']);
	
	  var sortedOptions = optionsData.sort(sortFn);
	
	  var theme = (0, _core.useTheme)();
	  var customStyles = {
	    container: function container(provided) {
	      return Object.assign({}, provided, {
	        minHeight: 30,
	        zIndex: 1
	      });
	    },
	    control: function control(provided) {
	      return Object.assign({}, provided, {
	        borderRadius: (0, _lodash.get)(theme, 'borderRadius.br3'),
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.primaryButtonBackground'), 0.4),
	        minHeight: '40px',
	        '&:active, &:focus': {
	          borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	          boxShadow: 'none'
	        },
	        '&:hover': {
	          borderColor: (0, _lodash.get)(theme, 'color.primaryButtonHover'),
	          boxShadow: 'none'
	        }
	      });
	    },
	    indicatorSeparator: function indicatorSeparator(provided) {
	      return Object.assign({}, provided, {
	        display: 'none'
	      });
	    },
	    option: function option(provided) {
	      return Object.assign({}, provided, {
	        fontSize: 14,
	        color: (0, _lodash.get)(theme, 'color.grayDark', 'gray')
	      });
	    },
	    multiValue: function multiValue(provided) {
	      return Object.assign({}, provided, {
	        backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	        border: '1px solid ' + (0, _lodash.get)(theme, 'color.borderColor', '#C8D1E0')
	      });
	    },
	    multiValueLabel: function multiValueLabel(provided) {
	      return Object.assign({}, provided, {
	        fontSize: 12,
	        fontWeight: 'bold',
	        color: (0, _lodash.get)(theme, 'color.accent', '#09AEEF'),
	        lineHeight: '14px'
	      });
	    },
	    multiValueRemove: function multiValueRemove(provided) {
	      return Object.assign({}, provided, {
	        '&:hover': {
	          backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground', '#FFF')
	        }
	      });
	    }
	  };
	
	  if (menuIsOpen) {
	    customStyles = Object.assign({}, customStyles, {
	      menu: function menu(base) {
	        return Object.assign({}, base, {
	          position: 'relative'
	        });
	      }
	    });
	  }
	
	  var IndicatorsContainer = function IndicatorsContainer() {
	    return _react2.default.createElement(_ArrowDropDown2.default, {
	      className: props.classes.IndicatorsContainer
	    });
	  };
	
	  var MultiValueLabel = function MultiValueLabel(multiValueLabelProps) {
	    return _react2.default.createElement(_reactSelect.components.MultiValueLabel, multiValueLabelProps);
	  };
	
	  var MultiValueRemove = function MultiValueRemove(multiValueRemoveProps) {
	    return _react2.default.createElement(
	      _reactSelect.components.MultiValueRemove,
	      multiValueRemoveProps,
	      _react2.default.createElement(
	        'span',
	        { className: props.classes.MultiValueClose },
	        'X'
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: props.classes.SelectWrapper },
	    _react2.default.createElement(_reactSelect2.default
	    /*
	      disabling captureMenuScroll, as it causing issues application flow in 2.4.4.
	      To reproduce the issue, select a tag.
	      If it is fixed after 2.4.4, captureMenuScroll can enabled.
	    */
	    , Object.assign({ captureMenuScroll: false,
	      isMulti: true,
	      components: {
	        IndicatorsContainer: IndicatorsContainer,
	        MultiValueLabel: MultiValueLabel,
	        MultiValueRemove: MultiValueRemove
	      },
	      menuIsOpen: menuIsOpen,
	      styles: customStyles,
	      options: sortedOptions,
	      value: getValueOptions(value)
	    }, otherProps))
	  );
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_index2.default))(MultiSelectRaw);

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      typography = _ref.typography;
	  return {
	    SelectWrapper: {
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      color: (0, _lodash.get)(color, 'bodyText')
	    },
	    IndicatorsContainer: {
	      color: (0, _lodash.get)(color, 'link'),
	      margin: 7
	    },
	    MultiValueClose: {
	      color: (0, _lodash.get)(color, 'primaryButtonBackground')
	    }
	  };
	}; /**
	    * Copyright (c) 2020 CA. All rights reserved.
	    * This software may be modified and distributed under the terms
	    * of the MIT license. See the LICENSE file for details.
	    */

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RadioGroupSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _lodash = __webpack_require__(8);
	
	var _styles = __webpack_require__(1535);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RadioGroupSection(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var selected = props.selected,
	      data = props.data,
	      id = props.id,
	      name = props.name,
	      _props$isDisable = props.isDisable,
	      isDisable = _props$isDisable === undefined ? false : _props$isDisable,
	      _onChange = props.onChange,
	      _props$disableOptions = props.disableOptions,
	      disableOptions = _props$disableOptions === undefined ? [] : _props$disableOptions,
	      _props$defaultSelect = props.defaultSelect,
	      defaultSelect = _props$defaultSelect === undefined ? '' : _props$defaultSelect;
	
	
	  var getIsDisabled = function getIsDisabled(obj) {
	    if (isDisable && obj.id !== defaultSelect) {
	      return !(0, _lodash.includes)(disableOptions, obj.id);
	    }
	    return false;
	  };
	
	  var getDefaultLabel = function getDefaultLabel(nameParam, labelClass) {
	    return _react2.default.createElement(
	      _core.Typography,
	      { className: labelClass },
	      nameParam
	    );
	  };
	
	  return _react2.default.createElement(
	    _core.FormControl,
	    { component: 'fieldset', className: classes.formControl, id: id },
	    name && _react2.default.createElement(
	      _core.FormLabel,
	      { className: classes.formLabel },
	      name
	    ),
	    _react2.default.createElement(
	      _core.RadioGroup,
	      {
	        value: selected,
	        onChange: function onChange(e) {
	          return _onChange(e);
	        },
	        className: classes.radioGroupContainer
	      },
	      data.map(function (obj) {
	        var disabled = getIsDisabled(obj);
	        var labelClass = disabled ? (0, _clsx2.default)(classes.radioLabel, classes.disabled) : classes.radioLabel;
	        var titleClass = disabled ? (0, _clsx2.default)(classes.radioSubtitle, classes.disabled) : classes.radioSubtitle;
	        return _react2.default.createElement(
	          'div',
	          { key: obj.id },
	          _react2.default.createElement(_core.FormControlLabel, {
	            value: obj.id,
	            control: _react2.default.createElement(_core.Radio, null),
	            label: obj.labelComponent || getDefaultLabel(obj.name, labelClass),
	            disabled: disabled
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: titleClass },
	            obj.description
	          ),
	          _react2.default.createElement('br', null)
	        );
	      })
	    )
	  );
	}
	
	RadioGroupSection.propTypes = {
	  selected: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  id: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  name: _propTypes2.default.string,
	  isDisable: _propTypes2.default.bool,
	  disableOptions: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  defaultSelect: _propTypes2.default.string
	};

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    formControl: {
	      fontSize: 12
	    },
	    radioGroupContainer: {
	      marginTop: 10,
	      marginLeft: 5,
	      '& .MuiRadio-root': {
	        padding: '3px'
	      },
	      '& .MuiSvgIcon-root': {
	        height: '20px',
	        width: '20px'
	      }
	    },
	    formLabel: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontWeight: 700,
	      paddingLeft: 0
	    },
	    radioLabel: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: 'clear-sans-bold',
	      paddingLeft: 0
	    },
	    radioSubtitle: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: 'clear-sans-regular',
	      fontSize: 14,
	      paddingLeft: theme.spacing(2)
	    },
	    disabled: {
	      color: (0, _lodash.get)(theme, 'color.gray')
	    },
	    helpTip: {
	      fontSize: 14,
	      marginLeft: 100
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RefreshCounter = exports.getDefaultTimer = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _isNaN = __webpack_require__(441);
	
	var _isNaN2 = _interopRequireDefault(_isNaN);
	
	var _core = __webpack_require__(3);
	
	var _icons = __webpack_require__(146);
	
	var _propTypes = __webpack_require__(5);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1537);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDefaultTimer = exports.getDefaultTimer = function getDefaultTimer(refreshTime) {
	  var defaultTimer = parseInt(refreshTime, 10);
	  return refreshTime && !(0, _isNaN2.default)(defaultTimer) ? defaultTimer : 10;
	};
	
	var RefreshCounter = exports.RefreshCounter = function RefreshCounter(props) {
	  var _props$classes = props.classes,
	      classes = _props$classes === undefined ? {} : _props$classes,
	      refreshTime = props.refreshTime,
	      checkStatus = props.checkStatus;
	
	  var defaultTimer = getDefaultTimer(refreshTime);
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      timer = _useState2[0],
	      setTimer = _useState2[1];
	
	  var checkNow = function checkNow() {
	    setTimer(defaultTimer);
	    checkStatus();
	  };
	
	  (0, _react.useEffect)(function () {
	    setTimer(defaultTimer);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var interval = setInterval(function () {
	      setTimer(timer - 1);
	      if (timer === 1) {
	        checkNow();
	        clearInterval(interval);
	      }
	    }, 1000);
	    return function () {
	      return clearInterval(interval);
	    };
	  }, [timer]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: 'refresh-counter',
	      'data-layer7-test': 'refresh-counter'
	    },
	    _react2.default.createElement(
	      _core.IconButton,
	      { className: classes.runningIndicatorIcon },
	      _react2.default.createElement(_icons.RefreshIcon, null)
	    ),
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'body1' },
	      ' ' + intl.getI18nMessage('label.update.in') + ' ' + timer + intl.getI18nMessage('label.unit.seconds') + '...'
	    ),
	    _react2.default.createElement(
	      _core.Button,
	      { variant: 'text', color: 'primary', onClick: function onClick() {
	          return checkNow();
	        } },
	      (0, _intl.getI18nFormattedMessage)('label.check.now')
	    )
	  );
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(RefreshCounter);
	
	
	RefreshCounter.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  refreshTime: _propTypes.string,
	  checkStatus: _propTypes.func
	};
	RefreshCounter.displayName = 'RefreshCounter';

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    runningIndicatorIcon: {
	      color: (0, _get2.default)(theme, 'color.pageTitle'),
	      padding: '7px',
	      '& + p': {
	        display: 'inline-block'
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _Autocomplete = __webpack_require__(241);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _match = __webpack_require__(1178);
	
	var _match2 = _interopRequireDefault(_match);
	
	var _parse = __webpack_require__(1179);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _index = __webpack_require__(1539);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchBar(props) {
	  var handleSearch = props.handleSearch,
	      autoSuggestSuggestions = props.autoSuggestSuggestions,
	      selectedDropdownValue = props.selectedDropdownValue,
	      classes = props.classes,
	      dispatchAutoSuggest = props.dispatchAutoSuggest,
	      selectedOption = props.selectedOption;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      value = _useState2[0],
	      setValue = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showSuggestions = _useState4[0],
	      setShowSuggestions = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    handleSearch();
	    setValue('');
	  }, [selectedDropdownValue]);
	
	  var onInputChange = function onInputChange(event) {
	    var _ref = event && event.target,
	        newValue = _ref.value;
	
	    setValue(newValue);
	    handleSearch();
	    if (!newValue || newValue.length < 3) {
	      setShowSuggestions(false);
	    } else {
	      setShowSuggestions(true);
	      dispatchAutoSuggest(newValue);
	    }
	  };
	
	  var onSuggestionSelected = function onSuggestionSelected(event, suggestionValue) {
	    handleSearch(suggestionValue);
	  };
	
	  var renderOption = function renderOption(option) {
	    var name = option.value;
	
	    var matches = (0, _match2.default)(name, value);
	    var parts = (0, _parse2.default)(name, matches);
	
	    return _react2.default.createElement(
	      'div',
	      { 'data-apim-test': 'search-bar-options-container' },
	      parts.map(function (part) {
	        var className = part.highlight ? classes.suggestionText__highlightedText : classes.suggestionText__Text;
	        return _react2.default.createElement(
	          'span',
	          { key: part.text, className: className },
	          part.text
	        );
	      })
	    );
	  };
	
	  var getOptionSelected = function getOptionSelected(option, valueParam) {
	    return option.key === valueParam.key;
	  };
	
	  var getOptionLabel = function getOptionLabel(option) {
	    return option && option.value || '';
	  };
	
	  var suggestions = showSuggestions ? autoSuggestSuggestions : [];
	
	  var renderInput = function renderInput(params) {
	    return _react2.default.createElement(_core.TextField, Object.assign({
	      'data-apim-test': 'search-bar-textfield'
	    }, params, {
	      classes: {
	        root: classes.autoCompleteTFRoot
	      },
	      fullWidth: true,
	      inputProps: Object.assign({}, params.inputProps, {
	        maxLength: 255,
	        value: selectedOption && selectedOption.value || value
	      }),
	      margin: 'none',
	      placeholder: 'Enter ' + selectedDropdownValue + ' name'
	    }));
	  };
	
	  return _react2.default.createElement(_Autocomplete2.default, {
	    classes: {
	      root: classes.autoCompleteRoot,
	      focused: classes.autoCompleteFocused,
	      inputRoot: classes.autoCompleteInputRoot,
	      input: classes.autoCompleteInput,
	      popupIndicator: classes.autoCompleteHidden,
	      paper: classes.autoCompletePaper,
	      popper: showSuggestions ? classes.autoCompleteShow : classes.autoCompleteHidden
	    },
	    disableClearable: true,
	    getOptionLabel: getOptionLabel,
	    getOptionSelected: getOptionSelected,
	    onChange: onSuggestionSelected,
	    onInputChange: onInputChange,
	    options: suggestions,
	    renderInput: renderInput,
	    renderOption: renderOption,
	    size: 'small'
	  });
	}
	
	SearchBar.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  handleSearch: _propTypes2.default.func,
	  autoSuggestSuggestions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  })),
	  selectedDropdownValue: _propTypes2.default.string,
	  selectedOption: _propTypes2.default.shape(),
	  dispatchAutoSuggest: _propTypes2.default.func
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_index2.default))(SearchBar);

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    root: {
	      '& h1': {
	        color: (0, _lodash.get)(color, 'pageTitle'),
	        fontFamily: (0, _lodash.get)(typography, 'siteTitle'),
	        fontSize: (0, _lodash.get)(fontSize, 'siteTitle'),
	        fontWeight: '100',
	        maxWidth: '1160px',
	        padding: '0px 25px',
	        margin: '45px auto 0'
	      }
	    },
	
	    autoCompleteRoot: {
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      border: '1px solid ' + (0, _color2.default)((0, _lodash.get)(color, 'primaryButtonBackground')).alpha(0.4).string(),
	      height: 34
	    },
	
	    autoCompleteFocused: {
	      border: '1px solid ' + (0, _lodash.get)(color, 'primaryButtonBackground'),
	      boxShadow: '0 0 0 1px ' + (0, _lodash.get)(color, 'primaryButtonBackground'),
	      zIndex: 15
	    },
	
	    autoCompleteInput: {
	      padding: '0 !important'
	    },
	
	    autoCompleteInputRoot: {
	      borderRadius: 0,
	      padding: '0 !important',
	      '& input': {
	        border: 'none !important',
	        '&::placeholder': {
	          color: (0, _color2.default)((0, _lodash.get)(color, 'bodyText')).alpha(0.7).string() + ' !important'
	        }
	      },
	      '&::before': {
	        borderBottom: 'none !important',
	        transition: 'none !important'
	      },
	      '&::after': {
	        borderBottom: 'none !important',
	        transition: 'none !important',
	        transform: 'none !important'
	      }
	    },
	
	    autoCompleteHidden: {
	      display: 'none'
	    },
	
	    autoCompleteShow: {
	      display: 'block'
	    },
	
	    autoCompletePaper: {
	      color: '#4B5060',
	      '& ul li:hover': {
	        backgroundColor: '#EFF3FA'
	      }
	    },
	
	    autoCompleteTFRoot: {
	      '& .MuiInput-underline:before': {
	        borderBottom: 'none'
	      }
	    },
	
	    suggestionText__Text: {
	      fontWeight: 'normal',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText')
	    },
	
	    suggestionText__highlightedText: {
	      fontWeight: 'bold',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText')
	    }
	  };
	};

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _core = __webpack_require__(3);
	
	var _CancelRounded = __webpack_require__(240);
	
	var _CancelRounded2 = _interopRequireDefault(_CancelRounded);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1541);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var loadMoreText = 'label.react.components.searchtextlistcontainer.loadmore';
	var selectedDefaultErrorMessage = 'error.react.components.searchtextlistcontainer.default.unselected.errormessage';
	var addItemLabel = 'label.react.components.searchtextlistcontainer.additem';
	var defaultValidationErrMsg = 'error.react.components.searchtextlistcontainer.default.newitem.errormessage';
	
	var defaultGetSecondaryTextFn = function defaultGetSecondaryTextFn(item) {
	  return item.email || '';
	};
	var defaultSortFn = function defaultSortFn(item1, item2) {
	  return item1 && item1.name && item1.name.toLowerCase().localeCompare(item2 && item2.name && item2.name.toLowerCase());
	};
	var DefaultSubTitleComponent = function DefaultSubTitleComponent(_ref) {
	  var classes = _ref.classes,
	      subtitle = _ref.subtitle;
	  return _react2.default.createElement(
	    'div',
	    { className: classes && classes.listSubtitle },
	    subtitle
	  );
	};
	
	var SearchTextListContainer = function SearchTextListContainer(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var title = props.title,
	      subtitle = props.subtitle,
	      placeHolderText = props.placeHolderText,
	      defaultList = props.defaultList,
	      defaultSelectedList = props.defaultSelectedList,
	      listId = props.listId,
	      isLoadMore = props.isLoadMore,
	      isCheckBoxVisible = props.isCheckBoxVisible,
	      isDeleteIconVisible = props.isDeleteIconVisible,
	      isSelectedNumberVisible = props.isSelectedNumberVisible,
	      onSearchListChange = props.onSearchListChange,
	      onLoadMore = props.onLoadMore,
	      _props$isMandatory = props.isMandatory,
	      isMandatory = _props$isMandatory === undefined ? true : _props$isMandatory,
	      _props$isDisableSelec = props.isDisableSelectedOption,
	      isDisableSelectedOption = _props$isDisableSelec === undefined ? false : _props$isDisableSelec,
	      _props$disableSelecte = props.disableSelectedOptions,
	      disableSelectedOptions = _props$disableSelecte === undefined ? [] : _props$disableSelecte,
	      _props$disableSelecti = props.disableSelection,
	      disableSelection = _props$disableSelecti === undefined ? false : _props$disableSelecti,
	      _props$canAddItem = props.canAddItem,
	      canAddItem = _props$canAddItem === undefined ? false : _props$canAddItem,
	      validateItem = props.validateItem,
	      _props$getItemSeconda = props.getItemSecondaryText,
	      getItemSecondaryText = _props$getItemSeconda === undefined ? defaultGetSecondaryTextFn : _props$getItemSeconda,
	      onAddItem = props.onAddItem,
	      _props$SubTitleCompon = props.SubTitleComponent,
	      SubTitleComponent = _props$SubTitleCompon === undefined ? DefaultSubTitleComponent : _props$SubTitleCompon,
	      intl = props.intl;
	
	  var _getI18n = (0, _intl.getI18n)(intl),
	      getI18nMessage = _getI18n.getI18nMessage;
	
	  var _props$selectedItemEr = props.selectedItemErrorMessage,
	      selectedItemErrorMessage = _props$selectedItemEr === undefined ? getI18nMessage(selectedDefaultErrorMessage) : _props$selectedItemEr,
	      _props$addItemText = props.addItemText,
	      addItemText = _props$addItemText === undefined ? getI18nMessage(addItemLabel) : _props$addItemText,
	      _props$validationErro = props.validationErrorMsg,
	      validationErrorMsg = _props$validationErro === undefined ? getI18nMessage(defaultValidationErrMsg) : _props$validationErro;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchText = _useState2[0],
	      setSearchText = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(defaultSelectedList),
	      _useState4 = _slicedToArray(_useState3, 2),
	      selectedList = _useState4[0],
	      setSelectedList = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(defaultList),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filteredList = _useState6[0],
	      setFilterdList = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      exactMatchAvailable = _useState8[0],
	      setExactMatchAvail = _useState8[1];
	
	  var updateFilteredListAndExactMatch = function updateFilteredListAndExactMatch(defaultListParam, searchTerm) {
	    var filtered = defaultListParam.filter(function (item) {
	      return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
	    });
	    setFilterdList(filtered);
	
	    var foundExactMatch = (0, _lodash.findIndex)(defaultListParam, function (item) {
	      return searchTerm && item.name && item.name.trim().toLowerCase() === searchTerm.trim().toLowerCase();
	    });
	    setExactMatchAvail(foundExactMatch !== -1);
	  };
	
	  (0, _react.useEffect)(function () {
	    setSelectedList(defaultSelectedList);
	    updateFilteredListAndExactMatch(defaultList, searchText);
	  }, [defaultList, defaultSelectedList]);
	
	  var onTextChange = function onTextChange(e) {
	    var searchTerm = e.target.value;
	    updateFilteredListAndExactMatch(defaultList, searchTerm);
	    setSearchText(searchTerm);
	  };
	
	  var onListCheck = function onListCheck(selectedUuid, wasSelected) {
	    var selectedItem = filteredList.filter(function (item) {
	      return item.uuid === selectedUuid;
	    });
	
	    var list = selectedList;
	    if (!wasSelected) {
	      list.push(selectedItem[0]);
	    } else {
	      list = (0, _lodash.remove)([].concat(_toConsumableArray(selectedList)), function (currentObject) {
	        return currentObject.uuid !== selectedUuid;
	      });
	    }
	    setSelectedList([].concat(_toConsumableArray(list)));
	    onSearchListChange(list);
	  };
	
	  var onListDelete = function onListDelete(selectedUuid) {
	    var list = (0, _lodash.remove)([].concat(_toConsumableArray(selectedList)), function (currentObject) {
	      return currentObject.uuid !== selectedUuid;
	    });
	    setSelectedList([].concat(_toConsumableArray(list)));
	    onSearchListChange(list);
	  };
	
	  var loadMoreClick = function loadMoreClick() {
	    setSearchText('');
	    onLoadMore();
	  };
	
	  var getSecondaryItems = function getSecondaryItems(text) {
	    return _react2.default.createElement(
	      _core.Tooltip,
	      { title: text, 'aria-label': text },
	      _react2.default.createElement(
	        _core.Typography,
	        {
	          component: 'span',
	          classes: {
	            root: classes.secondaryListText
	          }
	        },
	        text
	      )
	    );
	  };
	
	  var getIsDisabled = function getIsDisabled(item) {
	    if (isDisableSelectedOption) {
	      return (0, _lodash.some)(disableSelectedOptions, ['uuid', item.uuid]);
	    }
	    return false;
	  };
	  var trimmedSearchText = searchText.trim();
	  var showAddOption = canAddItem && searchText && trimmedSearchText.length > 0 && !exactMatchAvailable;
	  var isValidNewItem = true;
	  if (showAddOption && validateItem && trimmedSearchText) {
	    isValidNewItem = validateItem(trimmedSearchText);
	  }
	  var clickHandler = isDeleteIconVisible ? onListDelete : onListCheck;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      { className: classes.listTitle },
	      title,
	      ' ',
	      isSelectedNumberVisible && selectedList.length > 0 ? '(' + selectedList.length + ')' : ''
	    ),
	    _react2.default.createElement(SubTitleComponent, { classes: classes, subtitle: subtitle }),
	    _react2.default.createElement(_core.TextField, {
	      classes: {
	        root: classes.textField
	      },
	      id: 'org-search',
	      placeholder: placeHolderText,
	      margin: 'normal',
	      variant: 'outlined',
	      onChange: function onChange(e) {
	        return onTextChange(e);
	      },
	      InputProps: {
	        type: 'search'
	      },
	      value: searchText
	    }),
	    _react2.default.createElement(
	      _core.List,
	      { className: classes.listContainer, id: listId },
	      isMandatory && isDeleteIconVisible && selectedList.length === 0 && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_core.Divider, { className: classes.lineError }),
	        _react2.default.createElement(
	          _core.ListItem,
	          { button: true, divider: true, className: classes.listError },
	          selectedItemErrorMessage
	        )
	      ),
	      showAddOption && isValidNewItem && _react2.default.createElement(
	        _core.ListItem,
	        { button: true, divider: true, className: classes.listItem },
	        _react2.default.createElement(_core.ListItemText, {
	          className: classes.listItemText,
	          primary: searchText,
	          title: searchText
	        }),
	        _react2.default.createElement(
	          _core.Button,
	          {
	            onClick: function onClick() {
	              return onAddItem(searchText);
	            },
	            className: classes.addItem,
	            color: 'secondary'
	          },
	          addItemText
	        )
	      ),
	      showAddOption && !isValidNewItem && _react2.default.createElement(
	        _core.ListItem,
	        { divider: true, className: classes.listError },
	        validationErrorMsg
	      ),
	      filteredList.sort(defaultSortFn).map(function (item, i) {
	        var selecteItem = (0, _lodash.find)(selectedList, { uuid: item.uuid });
	        var secodaryText = getItemSecondaryText(item);
	        var secondaryItem = getSecondaryItems(secodaryText);
	        var isDisabled = getIsDisabled(item);
	        var isSelected = !(0, _lodash.isEmpty)(selecteItem);
	        isDisabled = disableSelection && isCheckBoxVisible && !isSelected ? true : isDisabled;
	        return _react2.default.createElement(
	          'div',
	          { key: '' + item.uuid },
	          i === 0 && _react2.default.createElement(_core.Divider, { className: classes.divider }),
	          _react2.default.createElement(
	            _core.ListItem,
	            {
	              button: true,
	              divider: true,
	              className: classes.listItem,
	              disabled: isDisabled,
	              onClick: isDisabled ? null : function () {
	                return clickHandler(item.uuid, isSelected);
	              }
	            },
	            isCheckBoxVisible && _react2.default.createElement(
	              _core.ListItemIcon,
	              { className: classes.listItemIcon },
	              _react2.default.createElement(_core.Checkbox, {
	                size: 'small',
	                edge: 'start',
	                disableRipple: true,
	                inputProps: {
	                  'aria-label': 'primary checkbox'
	                },
	                value: item.uuid,
	                checked: isSelected,
	                disabled: isDisabled
	              })
	            ),
	            isDeleteIconVisible && _react2.default.createElement(
	              _core.IconButton,
	              {
	                className: classes.listItemOption,
	                size: 'small',
	                disabled: isDisabled
	              },
	              _react2.default.createElement(_CancelRounded2.default, null)
	            ),
	            _react2.default.createElement(_core.ListItemText, {
	              className: classes.listItemText,
	              primary: item.name,
	              secondary: secondaryItem || '',
	              title: item.name
	            })
	          )
	        );
	      }),
	      isLoadMore && _react2.default.createElement(
	        _core.ListItem,
	        { key: 'button-loadmore' },
	        _react2.default.createElement(
	          _core.Grid,
	          { container: true, justify: 'center' },
	          _react2.default.createElement(
	            _core.Button,
	            {
	              variant: 'contained',
	              color: 'secondary',
	              className: classes.loadMore,
	              onClick: loadMoreClick
	            },
	            getI18nMessage(loadMoreText)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(SearchTextListContainer);
	
	
	SearchTextListContainer.propTypes = {
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  placeHolderText: _propTypes2.default.string,
	  defaultList: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  defaultSelectedList: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  listId: _propTypes2.default.string,
	  isLoadMore: _propTypes2.default.bool,
	  isCheckBoxVisible: _propTypes2.default.bool,
	  isDeleteIconVisible: _propTypes2.default.bool,
	  isSelectedNumberVisible: _propTypes2.default.bool,
	  onSearchListChange: _propTypes2.default.func,
	  onLoadMore: _propTypes2.default.func,
	  isMandatory: _propTypes2.default.bool,
	  isDisableSelectedOption: _propTypes2.default.bool,
	  disableSelectedOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  disableSelection: _propTypes2.default.bool,
	  canAddItem: _propTypes2.default.bool,
	  addItemText: _propTypes2.default.string,
	  getItemSecondaryText: _propTypes2.default.func,
	  validateItem: _propTypes2.default.func,
	  validationErrorMsg: _propTypes2.default.string,
	  onAddItem: _propTypes2.default.func,
	  selectedItemErrorMessage: _propTypes2.default.string,
	  SubTitleComponent: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({})
	};
	
	DefaultSubTitleComponent.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  subtitle: _propTypes2.default.string
	};

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var styles = function styles(theme) {
	  return {
	    listTitle: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.title'),
	      marginBottom: 2
	    },
	    textField: {
	      padding: '10px 0',
	      width: '99%',
	      '& .MuiInputBase-root': {
	        backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	        borderRadius: (0, _lodash.get)(theme, 'borderRadius.br3'),
	        color: (0, _lodash.get)(theme, 'color.bodyText'),
	        fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	        fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	        width: '99%',
	        '& input': {
	          height: '40px',
	          padding: '0 10px'
	        },
	        '& textarea': {
	          padding: '0 10px'
	        }
	      },
	      '& .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.primaryButtonBackground'), 0.4)
	      },
	      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.primaryButtonHover')
	      },
	      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.primaryButtonBackground')
	      },
	      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
	        borderColor: (0, _lodash.get)(theme, 'color.error')
	      },
	      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
	        backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.1),
	        borderColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(theme, 'color.bodyText'), 0.5)
	      },
	      '& .MuiOutlinedInput-multiline': {
	        padding: '10px 0'
	      },
	      '& .MuiFormHelperText-contained': {
	        marginLeft: 1
	      }
	    },
	    listContainer: {
	      width: '99%',
	      height: '98%',
	      '& .MuiListItem-button:hover': {
	        backgroundColor: '#c1e9fb'
	      }
	    },
	    listSubtitle: {
	      color: (0, _lodash.get)(theme, 'color.bodyText')
	    },
	    loadMore: {
	      textTransform: 'none'
	    },
	    addItem: {
	      textTransform: 'none',
	      minWidth: 100
	    },
	    checkbox: {
	      height: 8,
	      width: 8
	    },
	    sizeIcon: {
	      fontSize: 8
	    },
	    listItem: {
	      padding: 2,
	      paddingLeft: 16,
	      paddingRight: 16,
	      '& .MuiCheckbox-root': {
	        padding: '4px'
	      }
	    },
	    listItemText: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      marginLeft: 8,
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      '& .MuiTypography-root': {
	        lineHeight: '1'
	      }
	    },
	    listItemSingleSelected: {
	      paddingLeft: 0,
	      padding: 4
	    },
	    listItemIcon: {
	      minWidth: 0,
	      '& .MuiSvgIcon-root': {
	        paddingRight: '2px',
	        width: '20px',
	        height: '20px'
	      }
	    },
	    listItemOption: {
	      color: (0, _lodash.get)(theme, 'color.primaryButtonBackground'),
	      marginRight: 6,
	      '& .MuiSvgIcon-root': {
	        width: '20px',
	        height: '20px'
	      }
	    },
	    listError: {
	      color: (0, _lodash.get)(theme, 'color.error'),
	      borderColor: (0, _lodash.get)(theme, 'color.error')
	    },
	    lineError: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.error')
	    },
	    secondaryListText: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      fontSize: 10,
	      margin: 0,
	      lineHeight: '1 !important'
	    },
	    divider: {
	      backgroundColor: (0, _lodash.get)(theme, 'color.borderColor')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	    var color = _ref.color;
	    return {
	        cardStatus: {
	            color: (0, _get2.default)(color, 'bodyText'),
	            marginTop: 5,
	            marginBottom: 5
	        },
	        cardStatusIcon: {
	            fontSize: 12,
	            marginRight: 5
	        },
	        DEPLOYED: {
	            color: '#306204'
	        },
	        ENABLED: {
	            color: '#306204'
	        },
	        PENDING_DEPLOYMENT: {
	            color: '#97B081'
	        },
	        PENDING_UNDEPLOYMENT: {
	            color: '#97B081'
	        },
	        UNDEPLOYED: {
	            color: '#D1D1D1'
	        },
	        DISABLED: {
	            color: '#D1D1D1'
	        },
	        ERROR: {
	            color: '#B30303'
	        },
	        ERROR_UNDEPLOY: {
	            color: '#B30303'
	        },
	        UnPublished: {
	            color: '#D1D1D1'
	        },
	        errorContent: {
	            cursor: 'pointer',
	            color: (0, _get2.default)(color, 'link')
	        },
	        dialogAction: {
	            display: 'block !important'
	        },
	        dialogSubmit: {
	            color: (0, _get2.default)(color, 'link') + ' !important',
	            backgroundColor: 'transparent !important',
	            float: 'left !important'
	        },
	        dialogCancel: {
	            float: 'right !important',
	            backgroundColor: (0, _get2.default)(color, 'link') + ' !important',
	            color: (0, _get2.default)(color, 'white') + ' !important'
	        }
	    };
	};
	
	exports.default = styles;

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      margin = _ref.margin,
	      padding = _ref.padding;
	  return {
	    statusBar: {
	      margin: (0, _get2.default)(margin, 'm5') + ' 0 ' + (0, _get2.default)(margin, 'm21') + ' 0',
	      '& span': {
	        position: 'relative',
	        display: 'inline-block',
	        padding: '0 ' + (0, _get2.default)(padding, 'p16'),
	        verticalAlign: 'middle'
	      }
	    },
	    inline: {
	      display: 'inline-block'
	    },
	    status: {
	      '&:before': {
	        display: 'inline-block',
	        position: 'absolute',
	        content: '""',
	        left: 0,
	        top: '50%',
	        marginTop: '-6px',
	        height: '10px',
	        width: '10px',
	        borderRadius: '10px'
	      }
	    },
	    success: {
	      color: (0, _get2.default)(color, 'success'),
	      '&:before': {
	        backgroundColor: (0, _get2.default)(color, 'success')
	      }
	    },
	    error: {
	      color: (0, _get2.default)(color, 'error'),
	      '&:before': {
	        backgroundColor: (0, _get2.default)(color, 'error')
	      }
	    },
	    disabledGraphic: {
	      color: (0, _get2.default)(color, 'disabledGraphic'),
	      '&:before': {
	        backgroundColor: (0, _get2.default)(color, 'disabledGraphic')
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabPanel = function TabPanel(_ref) {
	  var children = _ref.children,
	      id = _ref.id,
	      visible = _ref.visible,
	      classes = _ref.classes;
	  return _react2.default.createElement(
	    _core.Typography,
	    {
	      id: id, 'data-apim-test': id, 'data-layer7-test': id,
	      'aria-labelledby': 'aria-' + id,
	      component: 'div',
	      role: 'tabpanel',
	      hidden: !visible,
	      classes: { root: classes }
	    },
	    _react2.default.createElement(
	      _core.Box,
	      null,
	      children
	    )
	  );
	};
	
	TabPanel.propTypes = {
	  id: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  visible: _propTypes2.default.bool,
	  classes: _propTypes2.default.string
	};
	
	exports.default = TabPanel;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _KeyboardArrowDown = __webpack_require__(170);
	
	var _KeyboardArrowDown2 = _interopRequireDefault(_KeyboardArrowDown);
	
	var _KeyboardArrowUp = __webpack_require__(171);
	
	var _KeyboardArrowUp2 = _interopRequireDefault(_KeyboardArrowUp);
	
	var _styles = __webpack_require__(1546);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandedIcon = function ExpandedIcon(_ref) {
	  var expanded = _ref.expanded;
	  return expanded ? _react2.default.createElement(_KeyboardArrowUp2.default, null) : _react2.default.createElement(_KeyboardArrowDown2.default, null);
	};
	
	ExpandedIcon.propTypes = {
	  expanded: _propTypes.bool
	};
	
	var MultiValueCell = function MultiValueCell(_ref2) {
	  var _ref2$items = _ref2.items,
	      items = _ref2$items === undefined ? [] : _ref2$items,
	      _ref2$expanded = _ref2.expanded,
	      expanded = _ref2$expanded === undefined ? false : _ref2$expanded,
	      uniqueKey = _ref2.uniqueKey,
	      text = _ref2.text,
	      entity = _ref2.entity;
	
	  var isGreaterThanOne = items.length > 1;
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var getListItem = function getListItem(item, index) {
	    return _react2.default.createElement(
	      _core.ListItem,
	      {
	        divider: isGreaterThanOne && index < items.length - 1,
	        dense: true, disableGutters: true,
	        key: uniqueKey(item)
	      },
	      _react2.default.createElement(_core.ListItemText, {
	        primary: text && text(item)
	      })
	    );
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: classes.multiValueCellContainer },
	    isGreaterThanOne ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.IconButton,
	        {
	          className: classes.multiValueCellHeading,
	          id: 'multivalue-cell', 'data-layer7-test': 'multivalue-cell', 'aria-label': 'multivalue cell'
	        },
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'body1' },
	          items.length,
	          ' ',
	          entity
	        ),
	        _react2.default.createElement(ExpandedIcon, { expanded: expanded })
	      ),
	      _react2.default.createElement(
	        _core.Collapse,
	        { 'in': expanded, timeout: 'auto', unmountOnExit: true },
	        _react2.default.createElement(_core.Divider, null),
	        _react2.default.createElement(
	          _core.List,
	          { disablePadding: true },
	          items.map(getListItem)
	        )
	      )
	    ) : _react2.default.createElement(
	      _core.List,
	      { disablePadding: true },
	      items.map(getListItem)
	    )
	  );
	};
	
	MultiValueCell.propTypes = {
	  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  expanded: _propTypes.bool,
	  uniqueKey: _propTypes.func,
	  text: _propTypes.func,
	  entity: _propTypes.string
	};
	
	exports.default = MultiValueCell;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = function styles() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      breakpoint = _ref.breakpoint,
	      color = _ref.color,
	      padding = _ref.padding;
	
	  return _defineProperty({
	    multiValueCellContainer: {
	      cursor: 'pointer'
	    },
	    multiValueCellHeading: {
	      padding: 0,
	      '& > span > p': {
	        color: (0, _get2.default)(color, 'link'),
	        paddingRight: (0, _get2.default)(padding, 'p20')
	      },
	      '& ~ div': {
	        padding: (0, _get2.default)(padding, 'p10') + ' 0 0 0'
	      },
	      '& ~ div ul > li:not(:last-child)': {
	        padding: (0, _get2.default)(padding, 'p10') + ' 0'
	      },
	      '& ~ div ul > li:last-child': {
	        padding: (0, _get2.default)(padding, 'p10') + ' 0 0 0'
	      }
	    }
	
	  }, '@media (max-width: ' + (0, _get2.default)(breakpoint, 'md') + ')', {
	    multiValueCellHeading: {
	      '& > span > p': {
	        paddingRight: (0, _get2.default)(padding, 'p5')
	      }
	    }
	  });
	};
	
	exports.default = styles;

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Pagination = Pagination;
	exports.TablePagination = TablePagination;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _Pagination = __webpack_require__(965);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _KeyboardArrowLeft = __webpack_require__(952);
	
	var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);
	
	var _KeyboardArrowRight = __webpack_require__(953);
	
	var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);
	
	var _styles = __webpack_require__(1548);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Pagination(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      page = _ref.page,
	      pageCount = _ref.pageCount,
	      onChangePage = _ref.onChangePage,
	      onChangePreviousPage = _ref.onChangePreviousPage,
	      onChangeNextPage = _ref.onChangeNextPage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.tablePagination },
	    _react2.default.createElement(
	      _core.IconButton,
	      {
	        className: classes.tablePaginationItem,
	        id: 'previous-page', 'data-layer7-test': 'previous-page',
	        onClick: onChangePreviousPage,
	        disabled: page === 0,
	        'aria-label': 'previous page'
	      },
	      _react2.default.createElement(_KeyboardArrowLeft2.default, null),
	      ' ',
	      (0, _intl.getI18nFormattedMessage)('label.pagination.prev')
	    ),
	    _react2.default.createElement(_Pagination2.default, {
	      className: classes.tablePaginationItem,
	      hideNextButton: true,
	      hidePrevButton: true,
	      count: pageCount,
	      page: page + 1,
	      onChange: onChangePage,
	      shape: 'rounded'
	    }),
	    _react2.default.createElement(
	      _core.IconButton,
	      {
	        className: classes.tablePaginationItem,
	        id: 'next-page', 'data-layer7-test': 'next-page',
	        onClick: onChangeNextPage,
	        disabled: page >= pageCount - 1,
	        'aria-label': 'next page'
	      },
	      (0, _intl.getI18nFormattedMessage)('label.pagination.next'),
	      ' ',
	      _react2.default.createElement(_KeyboardArrowRight2.default, null)
	    )
	  );
	}
	
	Pagination.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  page: _propTypes.number,
	  pageCount: _propTypes.number,
	  onChangePage: _propTypes.func,
	  onChangePreviousPage: _propTypes.func,
	  onChangeNextPage: _propTypes.func
	};
	
	function TablePagination(props) {
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var id = props.id,
	      page = props.page,
	      count = props.count,
	      pageCount = props.pageCount,
	      rowsPerPage = props.rowsPerPage,
	      _onChangeRowsPerPage = props.onChangeRowsPerPage,
	      _onChangePage = props.onChangePage,
	      onChangePreviousPage = props.onChangePreviousPage,
	      onChangeNextPage = props.onChangeNextPage,
	      _props$rowsPerPageOpt = props.rowsPerPageOptions,
	      rowsPerPageOptions = _props$rowsPerPageOpt === undefined ? [10, 20] : _props$rowsPerPageOpt,
	      _props$labelRowsPerPa = props.labelRowsPerPage,
	      labelRowsPerPage = _props$labelRowsPerPa === undefined ? intl.getI18nMessage('label.pagination.rows.per.page') : _props$labelRowsPerPa;
	
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  return _react2.default.createElement(
	    'div',
	    { id: id, 'data-apim-test': id, 'data-layer7-test': id },
	    _react2.default.createElement(_core.TablePagination, {
	      classes: {
	        root: classes.tablePaginationContainer,
	        selectRoot: classes.selectRoot,
	        select: classes.select,
	        selectIcon: classes.selectIcon
	      },
	      rowsPerPageOptions: rowsPerPageOptions,
	      component: 'div',
	      page: page,
	      count: count,
	      rowsPerPage: rowsPerPage,
	      onChangePage: function onChangePage(e, newPage) {
	        _onChangePage(newPage - 1);
	      },
	      onChangeRowsPerPage: function onChangeRowsPerPage(e) {
	        return _onChangeRowsPerPage(e.target.value);
	      },
	      labelRowsPerPage: labelRowsPerPage,
	      ActionsComponent: function ActionsComponent() {
	        return _react2.default.createElement(Pagination, {
	          classes: classes,
	          page: page,
	          onChangePage: function onChangePage(e, newPage) {
	            _onChangePage(newPage - 1);
	          },
	          pageCount: pageCount,
	          onChangePreviousPage: onChangePreviousPage,
	          onChangeNextPage: onChangeNextPage
	        });
	      }
	    })
	  );
	}
	
	TablePagination.propTypes = {
	  id: _propTypes.string,
	  page: _propTypes.number,
	  count: _propTypes.number,
	  pageCount: _propTypes.number,
	  rowsPerPage: _propTypes.number,
	  onChangeRowsPerPage: _propTypes.func,
	  onChangePage: _propTypes.func,
	  onChangePreviousPage: _propTypes.func,
	  onChangeNextPage: _propTypes.func,
	  rowsPerPageOptions: (0, _propTypes.arrayOf)(_propTypes.number),
	  labelRowsPerPage: _propTypes.string
	};

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = function styles(_ref) {
	  var breakpoint = _ref.breakpoint,
	      color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography,
	      borderRadius = _ref.borderRadius;
	  return _defineProperty({
	    tablePaginationContainer: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      width: '100%',
	      '& .MuiTablePagination-toolbar': {
	        margin: '0 36px',
	        padding: 0
	      },
	      '& .MuiTablePagination-spacer': {
	        flex: 'none'
	      },
	      '& p': {
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText')
	      }
	    },
	    tablePagination: {
	      padding: '0',
	      position: 'absolute',
	      right: 0,
	      '& button:disabled': {
	        opacity: 0.8
	      }
	    },
	    tablePaginationItem: {
	      display: 'inline-block',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      height: 32,
	      padding: '0 6px',
	      '& button': {
	        border: '1px solid ' + (0, _lodash.get)(color, 'primaryButtonBackground')
	      },
	      '& button.Mui-selected': {
	        backgroundColor: (0, _lodash.get)(color, 'primaryButtonBackground'),
	        border: '1px solid ' + (0, _lodash.get)(color, 'primaryButtonBackground'),
	        color: (0, _lodash.get)(color, 'primaryButtonText'),
	        '&:hover': {
	          backgroundColor: (0, _lodash.get)(color, 'primaryButtonHover'),
	          borderColor: (0, _lodash.get)(color, 'primaryButtonHover'),
	          color: (0, _lodash.get)(color, 'primaryButtonText')
	        }
	      }
	    },
	    selectRoot: {
	      margin: '0 8px'
	    },
	    select: {
	      border: '1px solid ' + (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'primaryButtonBackground'), 0.4),
	      color: (0, _lodash.get)(color, 'bodyText'),
	      borderRadius: (0, _lodash.get)(borderRadius, 'br3')
	    },
	    selectIcon: {
	      color: (0, _lodash.get)(color, 'primaryButtonBackground')
	    }
	
	  }, '@media (max-width: ' + (0, _lodash.get)(breakpoint, 'xs') + ')', {
	    tablePaginationContainer: {
	      '& .MuiTablePagination-toolbar': {
	        margin: '0 16px'
	      }
	    }
	  });
	};
	
	exports.default = styles;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRows = exports.getPlainCellContent = exports.getHyperlinkCellContent = exports.getColumns = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _core = __webpack_require__(3);
	
	var _StatusContent = __webpack_require__(611);
	
	var _StatusContent2 = _interopRequireDefault(_StatusContent);
	
	var _styles = __webpack_require__(1550);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getColumns = exports.getColumns = function getColumns(_ref) {
	  var columns = _ref.columns;
	  return _react2.default.createElement(
	    _core.TableRow,
	    null,
	    columns.map(function (_ref2) {
	      var id = _ref2.id,
	          label = _ref2.label,
	          minWidth = _ref2.minWidth;
	      return _react2.default.createElement(
	        _core.TableCell,
	        { style: { minWidth: minWidth }, key: id },
	        label
	      );
	    })
	  );
	};
	
	var getHyperlinkCellContent = exports.getHyperlinkCellContent = function getHyperlinkCellContent(_ref3) {
	  var uuid = _ref3.uuid,
	      linkValue = _ref3.linkValue,
	      format = _ref3.format,
	      value = _ref3.value;
	  return _react2.default.createElement(
	    _core.Link,
	    { underline: 'none', href: linkValue + '/' + uuid },
	    format ? format(value) : value
	  );
	};
	
	var getPlainCellContent = exports.getPlainCellContent = function getPlainCellContent(_ref4) {
	  var format = _ref4.format,
	      value = _ref4.value,
	      isStatusIcon = _ref4.isStatusIcon,
	      notifyMessages = _ref4.notifyMessages,
	      message = _ref4.message,
	      id = _ref4.id;
	
	  var content = format ? format(value) : value;
	  return isStatusIcon ? _react2.default.createElement(_StatusContent2.default, { id: id, statusLabel: content, notifyMessages: notifyMessages, message: message }) : content;
	};
	
	var getRows = exports.getRows = function getRows(_ref5) {
	  var userContext = _ref5.userContext,
	      columns = _ref5.columns,
	      rows = _ref5.rows,
	      uuidName = _ref5.uuidName,
	      notifyMessages = _ref5.notifyMessages;
	  return rows.map(function (row) {
	    return _react2.default.createElement(
	      _core.TableRow,
	      {
	        hover: true, tabIndex: -1, key: row.uuid,
	        onClick: function onClick() {
	          if ((0, _lodash.isFunction)(row.onClick)) {
	            row.onClick(row.uuid);
	          }
	        }
	      },
	      columns.map(function (column) {
	        var id = column.id,
	            link = column.link,
	            value = column.value,
	            isStatusIcon = column.isStatusIcon;
	
	        var linkValue = link && (0, _lodash.isFunction)(link) ? link(Object.assign({}, row, { userContext: userContext })) : link;
	        var content = linkValue ? getHyperlinkCellContent(Object.assign({}, column, {
	          uuid: uuidName ? row[uuidName] : row.uuid,
	          linkValue: linkValue,
	          value: value && (0, _lodash.isFunction)(value) ? value(row) : row[id],
	          uuidName: uuidName
	        })) : getPlainCellContent(Object.assign({}, column, {
	          value: value && (0, _lodash.isFunction)(value) ? value(row) : row[id],
	          isStatusIcon: isStatusIcon,
	          notifyMessages: notifyMessages,
	          message: (0, _lodash.get)(row, 'message'),
	          id: id
	        }));
	        return _react2.default.createElement(
	          _core.TableCell,
	          { key: id, align: 'left' },
	          content
	        );
	      })
	    );
	  });
	};
	
	function Table(props) {
	  var userContext = props.userContext,
	      id = props.id,
	      noResultsMessage = props.noResultsMessage;
	
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var columns = getColumns(Object.assign({}, props));
	  var rows = getRows(Object.assign({}, props, { userContext: userContext }));
	
	  return _react2.default.createElement(
	    _core.TableContainer,
	    {
	      className: classes.tableContainer,
	      id: id, 'data-apim-test': id, 'data-layer7-test': id
	    },
	    _react2.default.createElement(
	      _core.Table,
	      { stickyHeader: true, 'aria-label': 'sticky table' },
	      _react2.default.createElement(
	        _core.TableHead,
	        null,
	        columns
	      ),
	      (0, _lodash.isEmpty)(rows) ? _react2.default.createElement(
	        'caption',
	        null,
	        noResultsMessage
	      ) : _react2.default.createElement(
	        _core.TableBody,
	        null,
	        rows
	      )
	    )
	  );
	}
	
	exports.default = Table;
	
	
	getColumns.propTypes = {
	  columns: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}))
	};
	
	getHyperlinkCellContent.propTypes = {
	  uuid: _propTypes.string,
	  linkValue: _propTypes.string,
	  format: _propTypes.string,
	  value: _propTypes.string || _propTypes.number
	};
	
	getPlainCellContent.propTypes = {
	  format: _propTypes.string, value: _propTypes.string || _propTypes.number
	};
	
	Table.propTypes = {
	  userContext: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  noResultsMessage: _propTypes.string
	};

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = function styles(theme) {
	  return _defineProperty({
	    tableContainer: {
	      '& tr th:first-child, tr td:first-child': {
	        paddingLeft: (0, _lodash.get)(theme, 'padding.p36')
	      },
	      '& tr th:last-child, tr td:last-child': {
	        paddingRight: (0, _lodash.get)(theme, 'padding.p36')
	      },
	      '& caption': {
	        color: (0, _lodash.get)(theme, 'color.bodyText'),
	        paddingLeft: (0, _lodash.get)(theme, 'padding.p36'),
	        paddingRight: (0, _lodash.get)(theme, 'padding.p36'),
	        whiteSpace: (0, _lodash.get)(theme, 'whiteSpace.breakSpaces')
	      }
	    }
	  }, '@media (max-width: ' + (0, _lodash.get)(theme, 'breakpoint.xs') + ')', {
	    tableContainer: {
	      '& tr th:first-child, tr td:first-child': {
	        paddingLeft: (0, _lodash.get)(theme, 'padding.p16')
	      },
	      '& tr th:last-child, tr td:last-child': {
	        paddingRight: (0, _lodash.get)(theme, 'padding.p16')
	      }
	    }
	  });
	};
	
	exports.default = styles;

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = TableWithSelectableRow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _styles = __webpack_require__(1552);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getQuota = function getQuota(quota, quotaInterval) {
	  return quota ? quota + ' / ' + (0, _lodash.toLower)(quotaInterval) : 'Unlimited';
	};
	var getRateLimit = function getRateLimit(rateLimit) {
	  return rateLimit ? rateLimit + ' / sec' : 'Unlimited';
	};
	
	function TableWithSelectableRow(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var title = props.title,
	      subtitle = props.subtitle,
	      items = props.items,
	      onSelectRow = props.onSelectRow;
	
	  var _useState = (0, _react.useState)(props.selectedRow),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedRow = _useState2[0],
	      setSelectedRow = _useState2[1];
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(
	      'div',
	      { className: classes.tableTitle },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.tableSubtitle },
	      subtitle
	    ),
	    _react2.default.createElement(
	      _core.Table,
	      { size: 'small', padding: 'none', className: classes.table },
	      _react2.default.createElement(
	        _core.TableHead,
	        null,
	        _react2.default.createElement(
	          _core.TableRow,
	          null,
	          _react2.default.createElement(_core.TableCell, { align: 'center' }),
	          _react2.default.createElement(
	            _core.TableCell,
	            { align: 'center' },
	            'Api Plan'
	          ),
	          _react2.default.createElement(
	            _core.TableCell,
	            { align: 'center' },
	            'Description'
	          ),
	          _react2.default.createElement(
	            _core.TableCell,
	            { align: 'center' },
	            'Quota'
	          ),
	          _react2.default.createElement(
	            _core.TableCell,
	            { align: 'center' },
	            'Rate Limit'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _core.TableBody,
	        null,
	        items.map(function (_ref) {
	          var uuid = _ref.uuid,
	              name = _ref.name,
	              description = _ref.description,
	              quota = _ref.quota,
	              quotaInterval = _ref.quotaInterval,
	              rateLimit = _ref.rateLimit;
	          return _react2.default.createElement(
	            _core.TableRow,
	            {
	              variant: 'body1',
	              key: uuid,
	              selected: uuid === selectedRow,
	              onClick: function onClick() {
	                setSelectedRow(uuid);
	                onSelectRow(uuid);
	              }
	            },
	            _react2.default.createElement(
	              _core.TableCell,
	              { align: 'center' },
	              _react2.default.createElement(_core.Radio, {
	                classes: { root: classes.radioRoot },
	                checked: uuid === selectedRow,
	                name: uuid
	              })
	            ),
	            _react2.default.createElement(
	              _core.TableCell,
	              { align: 'center' },
	              name
	            ),
	            _react2.default.createElement(
	              _core.TableCell,
	              { align: 'center' },
	              description
	            ),
	            _react2.default.createElement(
	              _core.TableCell,
	              { align: 'center' },
	              getQuota(quota, quotaInterval)
	            ),
	            _react2.default.createElement(
	              _core.TableCell,
	              { align: 'center' },
	              getRateLimit(rateLimit)
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	TableWithSelectableRow.propTypes = {
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  selectedRow: _propTypes2.default.string,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  onSelectRow: _propTypes2.default.func
	};

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      width: '100%',
	      marginTop: (0, _lodash.get)(theme, 'margin.m10'),
	      marginBottom: (0, _lodash.get)(theme, 'margin.m21'),
	      color: (0, _lodash.get)(theme, 'color.bodyText')
	    },
	    tableTitle: {
	      color: (0, _lodash.get)(theme, 'color.pageTitle'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.pageTitle'),
	      fontSize: (0, _lodash.get)(theme, 'typography.title'),
	      marginBottom: (0, _lodash.get)(theme, 'margin.m2')
	    },
	    tableSubtitle: {
	      color: (0, _lodash.get)(theme, 'color.pageTitle'),
	      marginBottom: (0, _lodash.get)(theme, 'margin.m10')
	    },
	    table: {
	      '& tbody': {
	        cursor: 'pointer'
	      },
	      '& th': {
	        padding: (0, _lodash.get)(theme, 'padding.p10')
	      },
	      '& .MuiTableRow-root.Mui-selected': {
	        '& td': {
	          fontWeight: (0, _lodash.get)(theme, 'fontWeight.semiBold')
	        }
	      }
	    },
	    radioRoot: {
	      paddingLeft: 0,
	      paddingRight: 0
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1554);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabsContainer = function TabsContainer(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var id = props.id,
	      tabValue = props.tabValue,
	      handleTabChange = props.handleTabChange,
	      tabItems = props.tabItems,
	      useTabId = props.useTabId,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === undefined ? 'vertical' : _props$orientation,
	      _props$tabActiveClass = props.tabActiveClass,
	      tabActiveClass = _props$tabActiveClass === undefined ? classes.tabActive : _props$tabActiveClass,
	      _props$tabDisabledCla = props.tabDisabledClass,
	      tabDisabledClass = _props$tabDisabledCla === undefined ? classes.tabDisabled : _props$tabDisabledCla,
	      _props$tabIndicatorCl = props.tabIndicatorClass,
	      tabIndicatorClass = _props$tabIndicatorCl === undefined ? classes.tabIndicator : _props$tabIndicatorCl;
	
	
	  return _react2.default.createElement(
	    _core.Tabs,
	    {
	      id: id, 'data-apim-test': id, 'data-layer7-test': id,
	      orientation: orientation,
	      variant: 'standard',
	      'aria-label': 'aria-' + id,
	      classes: {
	        root: classes.tabs,
	        indicator: tabIndicatorClass
	      },
	      value: tabValue,
	      onChange: handleTabChange
	    },
	    tabItems.map(function (item) {
	      return _react2.default.createElement(_core.Tab, Object.assign({
	        key: item.tabId,
	        id: item.tabId, 'data-apim-test': item.tabId, 'data-layer7-test': item.tabId,
	        label: item.label
	      }, useTabId && { value: item.tabId }, {
	        classes: {
	          root: classes.tabLabel,
	          selected: tabActiveClass,
	          disabled: tabDisabledClass
	        },
	        disabled: item.disabled
	      }));
	    })
	  );
	};
	
	TabsContainer.propTypes = {
	  id: _propTypes2.default.string,
	  handleTabChange: _propTypes2.default.func,
	  tabItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  tabValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  useTabId: _propTypes2.default.bool,
	  orientation: _propTypes2.default.string,
	  tabActiveClass: _propTypes2.default.node,
	  tabDisabledClass: _propTypes2.default.node,
	  tabIndicatorClass: _propTypes2.default.node
	};
	
	exports.default = TabsContainer;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    tabs: {
	      flexDirection: 'column',
	      minHeight: '40px'
	    },
	    tabLabel: {
	      color: (0, _lodash.get)(color, 'link'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontWeight: 'bold',
	      textAlign: 'left',
	      alignItems: 'flex-start !important',
	      textTransform: 'none',
	      minWidth: 0,
	      maxWidth: '99%',
	      height: '3.0em',
	      minHeight: 'unset',
	      opacity: '1 !important',
	      '& span': {
	        alignSelf: 'center',
	        flexDirection: 'row',
	        justifyContent: 'flex-start'
	      }
	    },
	    tabActive: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      backgroundColor: (0, _color2.default)((0, _lodash.get)(color, 'primaryButtonBackground')).alpha(0.08).string() + ' !important'
	    },
	    tabIndicator: {
	      color: (0, _lodash.get)(color, 'link')
	    },
	    tabDisabled: {
	      color: (0, _color2.default)((0, _lodash.get)(color, 'bodyText')).alpha(0.7).string()
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactMeasure = __webpack_require__(1415);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _reactIntl = __webpack_require__(16);
	
	var _index = __webpack_require__(1556);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sortFn = function sortFn(item1, item2) {
	  return item1 && item1.toLowerCase().localeCompare(item2 && item2.toLowerCase());
	};
	
	var tagsLabel = 'label.react.components.tagsgroup.tags';
	
	var TagsGroupRaw = function (_React$Component) {
	  _inherits(TagsGroupRaw, _React$Component);
	
	  function TagsGroupRaw() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TagsGroupRaw);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagsGroupRaw.__proto__ || Object.getPrototypeOf(TagsGroupRaw)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      collapsed: false
	    }, _this.clickHandler = function (event, tag, onTagClick) {
	      event.stopPropagation();
	      if (onTagClick) {
	        onTagClick(tag);
	      }
	    }, _this.handleContainerResize = function (contentRect) {
	      var containerWidth = contentRect.bounds.width;
	      var scrollWidth = contentRect.scroll.width;
	
	      if (scrollWidth > containerWidth) {
	        _this.setState({ collapsed: true });
	      }
	    }, _this.renderTag = function (tag) {
	      var _this$props = _this.props,
	          classes = _this$props.classes,
	          onTagClick = _this$props.onTagClick;
	
	      return _react2.default.createElement(
	        _reactMeasure2.default,
	        {
	          scroll: true,
	          bounds: true,
	          key: tag
	        },
	        function (_ref2) {
	          var measureRef = _ref2.measureRef;
	          return _react2.default.createElement(
	            'span',
	            {
	              ref: measureRef,
	              key: tag,
	              onClick: function onClick(event) {
	                return _this.clickHandler(event, tag, onTagClick);
	              },
	              className: classes.Tag
	            },
	            tag
	          );
	        }
	      );
	    }, _this.render = function () {
	      var _this$props2 = _this.props,
	          _this$props2$tags = _this$props2.tags,
	          tags = _this$props2$tags === undefined ? [] : _this$props2$tags,
	          classes = _this$props2.classes,
	          onTagClick = _this$props2.onTagClick,
	          intl = _this$props2.intl;
	
	      var _getI18n = (0, _intl.getI18n)(intl),
	          getI18nMessage = _getI18n.getI18nMessage;
	
	      var collapsed = _this.state.collapsed;
	
	      if (tags.length === 0) {
	        return _react2.default.createElement('div', { className: classes.TagGroup });
	      }
	      var sortedTags = tags.sort(sortFn);
	      return _react2.default.createElement(
	        _reactMeasure2.default,
	        {
	          scroll: true,
	          bounds: true,
	          onResize: _this.handleContainerResize
	        },
	        function (_ref3) {
	          var measureRef = _ref3.measureRef;
	          return _react2.default.createElement(
	            'div',
	            { ref: measureRef, className: classes.TagGroup },
	            !collapsed && sortedTags.map(_this.renderTag),
	            collapsed && _react2.default.createElement(
	              'span',
	              {
	                className: classes.Tag,
	                onClick: function onClick(event) {
	                  return _this.clickHandler(event, '', onTagClick);
	                }
	              },
	              getI18nMessage(tagsLabel, { num: sortedTags.length })
	            )
	          );
	        }
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return TagsGroupRaw;
	}(_react2.default.Component);
	
	TagsGroupRaw.displayName = 'TagsGroup';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_index2.default), _reactIntl.injectIntl)(TagsGroupRaw);

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	exports.default = function (_ref) {
	  var color = _ref.color;
	  return {
	    TagGroup: {
	      height: '24px',
	      whiteSpace: 'nowrap',
	      width: '100%'
	    },
	    Tag: {
	      border: '1px solid ' + (0, _lodash.get)(color, 'borderColor', '#C8D1E0'),
	      color: (0, _lodash.get)(color, 'link'),
	      fontSize: 12,
	      marginRight: 4,
	      padding: '2px'
	    }
	  };
	}; /**
	    * Copyright (c) 2017 CA. All rights reserved.
	    * This software may be modified and distributed under the terms
	    * of the MIT license. See the LICENSE file for details.
	    */

/***/ },
/* 1557 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEBOUNCE_DELAY = exports.DEBOUNCE_DELAY = 500;
	
	exports.default = {};

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _env = __webpack_require__(1559);
	
	var env = _interopRequireWildcard(_env);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  portal: {
	    use_papi: env.PORTAL_USE_PAPI,
	    use_session: env.PORTAL_USE_SESSION,
	    hostname: window.location.hostname === 'localhost' ? 'https://apim.dev.ca.com' : 'https://' + window.location.hostname,
	    tenantPrefix: env.PORTAL_TENANT_ID || window.tenant,
	    detect_tenant_id: env.PORTAL_DETECT_TENANT_ID
	  },
	  server: {
	    hostname: env.SERVER_HOSTNAME,
	    port: env.SERVER_PORT,
	    prefix: '',
	    server_certs: []
	  },
	  oauth: {
	    client: {
	      organization: 'CA Technologies',
	      description: 'Phoenix Client',
	      client_name: 'Phoenix Client',
	      client_type: 'public',
	      registered_by: 'admin',
	      client_custom: {},
	      client_ids: [{
	        client_id: env.CLIENT_ID,
	        client_secret: '',
	        scope: env.CLIENT_SCOPE,
	        redirect_uri: env.CLIENT_REDIRECT_URI,
	        environment: 'ALL',
	        status: 'ENABLED',
	        registered_by: 'admin',
	        service_ids: '',
	        account_plan_mapping_ids: '',
	        client_key_custom: {}
	      }]
	    },
	    system_endpoints: {
	      authorization_endpoint_path: '/auth/oauth/v2/authorize',
	      token_endpoint_path: '/auth/oauth/v2/token',
	      token_revocation_endpoint_path: '/auth/oauth/v2/token/revoke',
	      usersession_logout_endpoint_path: '/connect/session/logout',
	      usersession_status_endpoint_path: '/connect/session/status'
	    },
	    oauth_protected_endpoints: {
	      userinfo_endpoint_path: '/openid/connect/v1/userinfo'
	    }
	  }
	}; /**
	    * Copyright (c) 2017 CA. All rights reserved.
	    * This software may be modified and distributed under the terms
	    * of the MIT license. See the LICENSE file for details.
	    */

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright (c) 2017 CA. All rights reserved.
	 * This software may be modified and distributed under the terms
	 * of the MIT license. See the LICENSE file for details.
	 */
	
	// Portal variables
	var PORTAL_USE_PAPI = exports.PORTAL_USE_PAPI = true;
	var PORTAL_USE_SESSION = exports.PORTAL_USE_SESSION = true;
	var PORTAL_TENANT_ID = exports.PORTAL_TENANT_ID = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).PORTAL_TENANT_ID || '';
	var PORTAL_DETECT_TENANT_ID = exports.PORTAL_DETECT_TENANT_ID = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).PORTAL_DETECT_TENANT_ID ? ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).PORTAL_DETECT_TENANT_ID === 'true' : false;
	
	// API gateway variables
	var SERVER_HOSTNAME = exports.SERVER_HOSTNAME = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).SERVER_HOSTNAME || 'apim.dev.ca.com';
	var SERVER_PORT = exports.SERVER_PORT = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).SERVER_PORT || '38443';
	
	// OTK client variables
	var CLIENT_ID = exports.CLIENT_ID = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).CLIENT_ID;
	var CLIENT_SCOPE = exports.CLIENT_SCOPE = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).CLIENT_SCOPE || 'openid profile email';
	var CLIENT_REDIRECT_URI = exports.CLIENT_REDIRECT_URI = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).CLIENT_REDIRECT_URI || 'http://localhost:3000';

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchFeatureFlagLegacyApiPages = exports.fetchFeatureFlag = exports.fetchFeatureFlags = exports.fetchFeatureFlagsForGlobalHeader = exports.fetchDeveloperNavigation = exports.fetchPublisherNavigation = exports.fetchSettingsNavigation = exports.fetchThemes = exports.fetchCqPagesFromNavigationJson = exports.fetchGlobalServicesNavigation = exports.fetchServices = exports.fetchUserContexts = exports.fetchDict = exports.fetchConfig = exports.loadHeaderConfig = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var loadHeaderConfig = exports.loadHeaderConfig = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var hostname, config, portal, userContexts, _ref7, _ref8, dict, themes, featureFlags, globalNavigation, cqNavigation, saasContentMgmtPage, userPrefs;
	
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            hostname = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).REACT_APP_APIM_HOST || window.location.origin;
	            _context2.next = 3;
	            return fetchConfig(hostname);
	
	          case 3:
	            config = _context2.sent;
	            portal = config.portal;
	            _context2.next = 7;
	            return fetchUserContexts(portal);
	
	          case 7:
	            userContexts = _context2.sent;
	            _context2.next = 10;
	            return Promise.all([fetchDict(portal), fetchThemes(portal, userContexts), fetchFeatureFlagsForGlobalHeader(portal), fetchGlobalServicesNavigation(portal)]);
	
	          case 10:
	            _ref7 = _context2.sent;
	            _ref8 = _slicedToArray(_ref7, 4);
	            dict = _ref8[0];
	            themes = _ref8[1];
	            featureFlags = _ref8[2];
	            globalNavigation = _ref8[3];
	            cqNavigation = void 0;
	            saasContentMgmtPage = globalNavigation.filter(function (item) {
	              return 'label.appnav.contentmanagement' === item.titleKey;
	            });
	
	            if (!(saasContentMgmtPage && saasContentMgmtPage.length === 1)) {
	              _context2.next = 22;
	              break;
	            }
	
	            _context2.next = 21;
	            return fetchCqPagesFromNavigationJson(portal);
	
	          case 21:
	            cqNavigation = _context2.sent;
	
	          case 22:
	            userPrefs = getUserPrefs();
	            return _context2.abrupt('return', Object.assign({
	              config: config,
	              userPrefs: userPrefs,
	              dict: dict,
	              userContexts: userContexts,
	              themes: themes,
	              featureFlags: featureFlags,
	              globalNavigation: globalNavigation,
	              cqNavigation: cqNavigation
	            }, cqNavigation ? { cqNavigation: cqNavigation } : {}));
	
	          case 24:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function loadHeaderConfig() {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var fetchConfig = exports.fetchConfig = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(hostname) {
	    var config, fetchedConfig, data;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            config = _defaultConfig2.default;
	            _context3.prev = 1;
	            _context3.next = 4;
	            return _axios2.default.get(hostname + '/dev/config.json');
	
	          case 4:
	            fetchedConfig = _context3.sent;
	            data = fetchedConfig.data;
	            // TODO: Needs to be implemented via a more standard way as in the react-15 code
	
	            if (!data.server) {
	              window.location.href = hostname + '/admin/login?to-default-config=true&referrer=' + window.location.pathname;
	            }
	            data.portal = Object.assign({}, data.portal, { hostname: hostname });
	            config = (0, _lodash.merge)(config, data);
	            _context3.next = 14;
	            break;
	
	          case 11:
	            _context3.prev = 11;
	            _context3.t0 = _context3['catch'](1);
	
	            console.error("Load config json error: ", _context3.t0);
	
	          case 14:
	            return _context3.abrupt('return', config);
	
	          case 15:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this, [[1, 11]]);
	  }));
	
	  return function fetchConfig(_x) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var fetchFeatures = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(hostname) {
	    var response;
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.prev = 0;
	            _context4.next = 3;
	            return _axios2.default.get(hostname + '/admin/features');
	
	          case 3:
	            response = _context4.sent;
	            return _context4.abrupt('return', response && response.data);
	
	          case 7:
	            _context4.prev = 7;
	            _context4.t0 = _context4['catch'](0);
	            return _context4.abrupt('return', []);
	
	          case 10:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this, [[0, 7]]);
	  }));
	
	  return function fetchFeatures(_x2) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var fetchDict = exports.fetchDict = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(_ref11) {
	    var hostname = _ref11.hostname;
	    var response;
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _axios2.default.get(hostname + '/admin/dict.json');
	
	          case 2:
	            response = _context5.sent;
	            return _context5.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function fetchDict(_x3) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var fetchUserContexts = exports.fetchUserContexts = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(_ref13) {
	    var hostname = _ref13.hostname,
	        tenantPrefix = _ref13.tenantPrefix;
	    var response;
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _axios2.default.get(hostname + '/api/' + tenantPrefix + '/userContexts');
	
	          case 2:
	            response = _context6.sent;
	            return _context6.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function fetchUserContexts(_x4) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var fetchServices = exports.fetchServices = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(_ref15) {
	    var hostname = _ref15.hostname,
	        tenantPrefix = _ref15.tenantPrefix;
	    var response;
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _axios2.default.get(hostname + '/api/' + tenantPrefix + '/papi/1.0/services');
	
	          case 2:
	            response = _context7.sent;
	            return _context7.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function fetchServices(_x5) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var fetchGlobalServicesNavigation = exports.fetchGlobalServicesNavigation = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(_ref17) {
	    var hostname = _ref17.hostname;
	    var response;
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.prev = 0;
	            _context8.next = 3;
	            return _axios2.default.get(hostname + '/admin/navigation/internal/header-menu');
	
	          case 3:
	            response = _context8.sent;
	            return _context8.abrupt('return', response && response.data);
	
	          case 7:
	            _context8.prev = 7;
	            _context8.t0 = _context8['catch'](0);
	
	            console.error('Error loading header-menu api', _context8.t0);
	            return _context8.abrupt('return', []);
	
	          case 11:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this, [[0, 7]]);
	  }));
	
	  return function fetchGlobalServicesNavigation(_x6) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	var fetchCqPagesFromNavigationJson = exports.fetchCqPagesFromNavigationJson = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(_ref19) {
	    var hostname = _ref19.hostname;
	    var response;
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return _axios2.default.get(hostname + '/app/navigation.json').catch(function (error) {
	              console.error('Error while invoking navigation.json', error);
	              return [];
	            });
	
	          case 2:
	            response = _context9.sent;
	            return _context9.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function fetchCqPagesFromNavigationJson(_x7) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	var fetchThemes = exports.fetchThemes = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(_ref21, userContexts) {
	    var hostname = _ref21.hostname,
	        tenantPrefix = _ref21.tenantPrefix;
	    var activeOrgUuid, config, response;
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            activeOrgUuid = (0, _lodash.get)(userContexts, 'userContexts[0].activeOrgUuid');
	            config = activeOrgUuid ? { headers: { 'APIM-OrgUuid': activeOrgUuid } } : {};
	            _context10.next = 4;
	            return _axios2.default.get(hostname + '/api/' + tenantPrefix + '/branding/1.0/themes', config);
	
	          case 4:
	            response = _context10.sent;
	            return _context10.abrupt('return', (0, _lodash.get)(response, 'data', {}));
	
	          case 6:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function fetchThemes(_x8, _x9) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	var fetchSettingsNavigation = exports.fetchSettingsNavigation = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(_ref23) {
	    var hostname = _ref23.hostname,
	        tenantPrefix = _ref23.tenantPrefix;
	    var response;
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            _context11.next = 2;
	            return _axios2.default.get(hostname + '/api/' + tenantPrefix + '/papi/1.0/services/' + SETTINGS_SERVICE_ID + '/navigation');
	
	          case 2:
	            response = _context11.sent;
	            return _context11.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function fetchSettingsNavigation(_x10) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	var fetchPublisherNavigation = exports.fetchPublisherNavigation = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(_ref25) {
	    var hostname = _ref25.hostname,
	        tenantPrefix = _ref25.tenantPrefix;
	    var response;
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            _context12.next = 2;
	            return _axios2.default.get(hostname + '/api/' + tenantPrefix + '/papi/1.0/services/' + PUBLISHER_SERVICE_ID + '/navigation');
	
	          case 2:
	            response = _context12.sent;
	            return _context12.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function fetchPublisherNavigation(_x11) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	
	var fetchDeveloperNavigation = exports.fetchDeveloperNavigation = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(_ref27) {
	    var hostname = _ref27.hostname,
	        tenantPrefix = _ref27.tenantPrefix;
	    var response;
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            _context13.next = 2;
	            return _axios2.default.get(hostname + '/api/' + tenantPrefix + '/papi/1.0/services/' + DEVELOPER_SERVICE_ID + '/navigation');
	
	          case 2:
	            response = _context13.sent;
	            return _context13.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function fetchDeveloperNavigation(_x12) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	
	var fetchFeatureFlagsForGlobalHeader = exports.fetchFeatureFlagsForGlobalHeader = function () {
	  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(_ref29) {
	    var hostname = _ref29.hostname,
	        tenantPrefix = _ref29.tenantPrefix;
	    var newLandingPage;
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            _context14.next = 2;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'FEATURE_FLAG_NEW_LANDING_PAGE');
	
	          case 2:
	            newLandingPage = _context14.sent;
	            return _context14.abrupt('return', {
	              newLandingPage: newLandingPage
	            });
	
	          case 4:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function fetchFeatureFlagsForGlobalHeader(_x13) {
	    return _ref30.apply(this, arguments);
	  };
	}();
	
	var fetchFeatureFlags = exports.fetchFeatureFlags = function () {
	  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(_ref31) {
	    var hostname = _ref31.hostname,
	        tenantPrefix = _ref31.tenantPrefix;
	    var apiPlatform, apiPlans, uiSidebar, customPages, newLandingPage, useLegacyApiPages, useLegacyApplicationPages, useMultiApiKeys;
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            _context15.next = 2;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'APIM_PLATFORM');
	
	          case 2:
	            apiPlatform = _context15.sent;
	            _context15.next = 5;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'FEATURE_FLAG_API_PLANS');
	
	          case 5:
	            apiPlans = _context15.sent;
	            _context15.next = 8;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'FEATURE_FLAG_UI_SIDEBAR');
	
	          case 8:
	            uiSidebar = _context15.sent;
	            _context15.next = 11;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'FEATURE_FLAG_CUSTOM_PAGES');
	
	          case 11:
	            customPages = _context15.sent;
	            _context15.next = 14;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'FEATURE_FLAG_NEW_LANDING_PAGE');
	
	          case 14:
	            newLandingPage = _context15.sent;
	            _context15.next = 17;
	            return fetchFeatureFlagLegacyApiPages(hostname, tenantPrefix, 'FEATURE_FLAG_USE_LEGACY_API_PAGES');
	
	          case 17:
	            useLegacyApiPages = _context15.sent;
	            _context15.next = 20;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'FEATURE_FLAG_USE_LEGACY_APPLICATION_PAGES');
	
	          case 20:
	            useLegacyApplicationPages = _context15.sent;
	            _context15.next = 23;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'FEATURE_FLAG_MULTI_API_KEYS');
	
	          case 23:
	            useMultiApiKeys = _context15.sent;
	            return _context15.abrupt('return', {
	              apiPlatform: apiPlatform, apiPlans: apiPlans, uiSidebar: uiSidebar, customPages: customPages, useLegacyApiPages: useLegacyApiPages, useLegacyApplicationPages: useLegacyApplicationPages, newLandingPage: newLandingPage, useMultiApiKeys: useMultiApiKeys
	            });
	
	          case 25:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function fetchFeatureFlags(_x14) {
	    return _ref32.apply(this, arguments);
	  };
	}();
	
	var buildFeatureFlags = function () {
	  var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(_ref33, features) {
	    var hostname = _ref33.hostname,
	        tenantPrefix = _ref33.tenantPrefix;
	    var apiPlatform, apiPlans, uiSidebar, customPages, newLandingPage, useLegacyApiPages, useLegacyApplicationPages, useMultiApiKeys;
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            _context16.next = 2;
	            return fetchFeatureFlag(hostname, tenantPrefix, 'APIM_PLATFORM');
	
	          case 2:
	            apiPlatform = _context16.sent;
	            apiPlans = buildFeatureFlag(features, 'FEATURE_FLAG_API_PLANS');
	            uiSidebar = buildFeatureFlag(features, 'FEATURE_FLAG_UI_SIDEBAR');
	            customPages = buildFeatureFlag(features, 'FEATURE_FLAG_CUSTOM_PAGES');
	            newLandingPage = buildFeatureFlag(features, 'FEATURE_FLAG_NEW_LANDING_PAGE');
	            useLegacyApiPages = buildFeatureFlag(features, 'FEATURE_FLAG_USE_LEGACY_API_PAGES');
	            useLegacyApplicationPages = buildFeatureFlag(features, 'FEATURE_FLAG_USE_LEGACY_APPLICATION_PAGES');
	            useMultiApiKeys = buildFeatureFlag(features, 'FEATURE_FLAG_MULTI_API_KEYS');
	            return _context16.abrupt('return', {
	              apiPlatform: apiPlatform, apiPlans: apiPlans, uiSidebar: uiSidebar, customPages: customPages, useLegacyApiPages: useLegacyApiPages, useLegacyApplicationPages: useLegacyApplicationPages, newLandingPage: newLandingPage, useMultiApiKeys: useMultiApiKeys
	            });
	
	          case 11:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function buildFeatureFlags(_x15, _x16) {
	    return _ref34.apply(this, arguments);
	  };
	}();
	
	var fetchFeatureFlag = exports.fetchFeatureFlag = function () {
	  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(hostname, tenantPrefix, featureFlagName) {
	    var response;
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            _context17.next = 2;
	            return _axios2.default.get(hostname + '/api/' + tenantPrefix + '/Settings(\'' + featureFlagName + '\')').then(function (response) {
	              return response;
	            }).catch(function () {
	              return { data: { Value: 'false' } };
	            });
	
	          case 2:
	            response = _context17.sent;
	            return _context17.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function fetchFeatureFlag(_x17, _x18, _x19) {
	    return _ref35.apply(this, arguments);
	  };
	}();
	
	var fetchFeatureFlagLegacyApiPages = exports.fetchFeatureFlagLegacyApiPages = function () {
	  var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(hostname, tenantPrefix, featureFlagName) {
	    var response;
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            _context18.next = 2;
	            return _axios2.default.get(hostname + '/api/' + tenantPrefix + '/Settings(\'' + featureFlagName + '\')').then(function (response) {
	              return response;
	            }).catch(function () {
	              return { data: { Value: 'false' } };
	            });
	
	          case 2:
	            response = _context18.sent;
	            return _context18.abrupt('return', response && response.data);
	
	          case 4:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function fetchFeatureFlagLegacyApiPages(_x20, _x21, _x22) {
	    return _ref36.apply(this, arguments);
	  };
	}();
	
	exports.getUserPrefs = getUserPrefs;
	
	var _lodash = __webpack_require__(8);
	
	var _defaultConfig = __webpack_require__(1558);
	
	var _defaultConfig2 = _interopRequireDefault(_defaultConfig);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * Services for fetching the Setup data required for bootstrapping Portal.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */
	
	/* eslint-disable import/prefer-default-export */
	
	var SETTINGS_SERVICE_ID = '0084e50c-7a6b-4c4b-808f-fd891f58802d';
	var PUBLISHER_SERVICE_ID = '6633bfa5-2efc-44a9-a8db-1a9233a3edaa';
	var DEVELOPER_SERVICE_ID = 'f3d3d2ba-c84a-4764-876c-c36a4f3cd275';
	var USER_PREFS_COOKIE = 'userPrefs';
	
	exports.default = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	  var hostname, _ref2, _ref3, features, config, portal, userContexts, _ref4, _ref5, dict, themes, featureFlags, globalNavigation, cqNavigation, saasContentMgmtPage, userPrefs, _userContexts;
	
	  return _regenerator2.default.wrap(function _callee$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          hostname = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).REACT_APP_APIM_PORT ? ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).REACT_APP_APIM_HOST + ':' + ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).REACT_APP_APIM_PORT : ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).REACT_APP_APIM_HOST || window.location.origin;
	          _context.next = 3;
	          return Promise.all([fetchFeatures(hostname), fetchConfig(hostname)]);
	
	        case 3:
	          _ref2 = _context.sent;
	          _ref3 = _slicedToArray(_ref2, 2);
	          features = _ref3[0];
	          config = _ref3[1];
	          portal = config.portal;
	
	          if (!(features.FEATURE_FLAG_NEW_LANDING_PAGE === 'true')) {
	            _context.next = 30;
	            break;
	          }
	
	          _context.next = 11;
	          return fetchUserContexts(portal);
	
	        case 11:
	          userContexts = _context.sent;
	          _context.next = 14;
	          return Promise.all([fetchDict(portal), fetchThemes(portal, userContexts), buildFeatureFlags(portal, features), fetchGlobalServicesNavigation(portal)]);
	
	        case 14:
	          _ref4 = _context.sent;
	          _ref5 = _slicedToArray(_ref4, 4);
	          dict = _ref5[0];
	          themes = _ref5[1];
	          featureFlags = _ref5[2];
	          globalNavigation = _ref5[3];
	          cqNavigation = void 0;
	          saasContentMgmtPage = globalNavigation.filter(function (item) {
	            return 'label.appnav.contentmanagement' === item.titleKey;
	          });
	
	          if (!(saasContentMgmtPage && saasContentMgmtPage.length === 1)) {
	            _context.next = 26;
	            break;
	          }
	
	          _context.next = 25;
	          return fetchCqPagesFromNavigationJson(portal);
	
	        case 25:
	          cqNavigation = _context.sent;
	
	        case 26:
	          userPrefs = getUserPrefs();
	          return _context.abrupt('return', Object.assign({
	            config: config,
	            dict: dict,
	            userContexts: userContexts,
	            themes: themes,
	            featureFlags: featureFlags,
	            globalNavigation: globalNavigation,
	            cqNavigation: cqNavigation,
	            userPrefs: userPrefs
	          }, cqNavigation ? { cqNavigation: cqNavigation } : {}));
	
	        case 30:
	          _context.next = 32;
	          return fetchUserContexts(portal);
	
	        case 32:
	          _userContexts = _context.sent;
	          _context.t0 = config;
	          _context.t1 = getUserPrefs();
	          _context.next = 37;
	          return fetchDict(portal);
	
	        case 37:
	          _context.t2 = _context.sent;
	          _context.t3 = _userContexts;
	          _context.next = 41;
	          return fetchServices(portal);
	
	        case 41:
	          _context.t4 = _context.sent;
	          _context.next = 44;
	          return fetchThemes(portal, _userContexts);
	
	        case 44:
	          _context.t5 = _context.sent;
	          _context.next = 47;
	          return fetchPublisherNavigation(portal);
	
	        case 47:
	          _context.t6 = _context.sent;
	          _context.next = 50;
	          return fetchDeveloperNavigation(portal);
	
	        case 50:
	          _context.t7 = _context.sent;
	          _context.next = 53;
	          return fetchSettingsNavigation(portal);
	
	        case 53:
	          _context.t8 = _context.sent;
	          _context.next = 56;
	          return fetchFeatureFlags(portal);
	
	        case 56:
	          _context.t9 = _context.sent;
	          return _context.abrupt('return', {
	            config: _context.t0,
	            userPrefs: _context.t1,
	            dict: _context.t2,
	            userContexts: _context.t3,
	            services: _context.t4,
	            themes: _context.t5,
	            publisherNavigation: _context.t6,
	            developerNavigation: _context.t7,
	            settingsNavigation: _context.t8,
	            featureFlags: _context.t9
	          });
	
	        case 58:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _callee, this);
	}));
	
	
	function buildFeatureFlag(features, flagName) {
	  return {
	    Name: flagName,
	    Value: features[flagName]
	  };
	}
	function getUserPrefs() {
	  return JSON.parse(readCookie(USER_PREFS_COOKIE) || '{}');
	}
	
	function readCookie(name) {
	  var cookieName = name + '=';
	  var cookies = document.cookie.split(';');
	  for (var i = 0; i < cookies.length; i++) {
	    var cookie = cookies[i];
	    while (cookie.charAt(0) === ' ') {
	      cookie = cookie.substring(1, cookie.length);
	    }if (cookie.indexOf(cookieName) === 0) return cookie.substring(cookieName.length, cookie.length);
	  }
	  return null;
	}

/***/ },
/* 1561 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright (c) 2017 CA. All rights reserved.
	 * This software may be modified and distributed under the terms
	 * of the MIT license. See the LICENSE file for details.
	 */
	
	var METRICS_DATA_REQUEST = exports.METRICS_DATA_REQUEST = 'METRICS_DATA_REQUEST';
	var METRICS_DATA_SUCCESS = exports.METRICS_DATA_SUCCESS = 'METRICS_DATA_SUCCESS';
	var METRICS_DATA_ERROR = exports.METRICS_DATA_ERROR = 'METRICS_DATA_ERROR';
	
	var METRICS_API_LIST_REQUEST = exports.METRICS_API_LIST_REQUEST = 'METRICS_API_LIST_REQUEST';
	var METRICS_API_LIST_SUCCESS = exports.METRICS_API_LIST_SUCCESS = 'METRICS_API_LIST_SUCCESS';
	var METRICS_API_LIST_ERROR = exports.METRICS_API_LIST_ERROR = 'METRICS_API_LIST_ERROR';
	
	var METRICS_APP_LIST_REQUEST = exports.METRICS_APP_LIST_REQUEST = 'METRICS_APP_LIST_REQUEST';
	var METRICS_APP_LIST_SUCCESS = exports.METRICS_APP_LIST_SUCCESS = 'METRICS_APP_LIST_SUCCESS';
	var METRICS_APP_LIST_ERROR = exports.METRICS_APP_LIST_ERROR = 'METRICS_APP_LIST_ERROR';
	
	var METRICS_ORG_LIST_REQUEST = exports.METRICS_ORG_LIST_REQUEST = 'METRICS_ORG_LIST_REQUEST';
	var METRICS_ORG_LIST_SUCCESS = exports.METRICS_ORG_LIST_SUCCESS = 'METRICS_ORG_LIST_SUCCESS';
	var METRICS_ORG_LIST_ERROR = exports.METRICS_ORG_LIST_ERROR = 'METRICS_ORG_LIST_ERROR';
	
	var METRICS_GATEWAY_LIST_REQUEST = exports.METRICS_GATEWAY_LIST_REQUEST = 'METRICS_GATEWAY_LIST_REQUEST';
	var METRICS_GATEWAY_LIST_SUCCESS = exports.METRICS_GATEWAY_LIST_SUCCESS = 'METRICS_GATEWAY_LIST_SUCCESS';
	var METRICS_GATEWAY_LIST_ERROR = exports.METRICS_GATEWAY_LIST_ERROR = 'METRICS_GATEWAY_LIST_SUCCESS';
	
	var HISTORICAL_METRIC_30DAYS = exports.HISTORICAL_METRIC_30DAYS = 'HISTORICAL_METRIC_30DAYS';
	var HISTORICAL_METRIC_52WEEKS = exports.HISTORICAL_METRIC_52WEEKS = 'HISTORICAL_METRIC_52WEEKS';
	
	var TYPE_BY_MINUTE = exports.TYPE_BY_MINUTE = 'by-minute';
	var TYPE_BY_DAY = exports.TYPE_BY_DAY = 'by-day';
	var TYPE_BY_HOUR = exports.TYPE_BY_HOUR = 'by-hour';
	var TYPE_BY_WEEK = exports.TYPE_BY_WEEK = 'by-week';
	var TYPE_BY_MONTH = exports.TYPE_BY_MONTH = 'by-month';
	
	var TIME_RANGE_HOUR = exports.TIME_RANGE_HOUR = 'hour';
	var TIME_RANGE_DAY = exports.TIME_RANGE_DAY = 'day';
	var TIME_RANGE_WEEK = exports.TIME_RANGE_WEEK = 'week';
	var TIME_RANGE_MONTH = exports.TIME_RANGE_MONTH = 'month';
	var TIME_RANGE_CUSTOM = exports.TIME_RANGE_CUSTOM = 'custom';
	
	var API_BASED = exports.API_BASED = 'apis';
	var ORG_BASED = exports.ORG_BASED = 'orgs/plan';
	
	var AGGREGATED_DATA_TYPE = exports.AGGREGATED_DATA_TYPE = '1';
	
	var SET_CHART_STATE = exports.SET_CHART_STATE = 'SET_CHART_STATE';
	
	var METRICS_CUSTOM_CHART_DATA_REQUEST = exports.METRICS_CUSTOM_CHART_DATA_REQUEST = 'METRICS_CUSTOM_CHART_DATA_REQUEST';
	var METRICS_CUSTOM_CHART_DATA_SUCCESS = exports.METRICS_CUSTOM_CHART_DATA_SUCCESS = 'METRICS_CUSTOM_CHART_DATA_SUCCESS';
	var METRICS_CUSTOM_CHART_DATA_ERROR = exports.METRICS_CUSTOM_CHART_DATA_ERROR = 'METRICS_CUSTOM_CHART_DATA_ERROR';
	
	var METRICS_CUSTOM_REPORT_REQUEST = exports.METRICS_CUSTOM_REPORT_REQUEST = 'METRICS_CUSTOM_REPORT_REQUEST';
	var METRICS_CUSTOM_REPORT_SUCCESS = exports.METRICS_CUSTOM_REPORT_SUCCESS = 'METRICS_CUSTOM_REPORT_SUCCESS';
	var METRICS_CUSTOM_REPORT_ERROR = exports.METRICS_CUSTOM_REPORT_ERROR = 'METRICS_CUSTOM_REPORT_ERROR';
	
	var METRICS_CUSTOM_REPORT_CREATE_REPORT_REQUEST = exports.METRICS_CUSTOM_REPORT_CREATE_REPORT_REQUEST = 'METRICS_CUSTOM_REPORT_CREATE_REPORT_REQUEST';
	var METRICS_CUSTOM_REPORT_CREATE_REPORT_SUCCESS = exports.METRICS_CUSTOM_REPORT_CREATE_REPORT_SUCCESS = 'METRICS_CUSTOM_REPORT_CREATE_REPORT_SUCCESS';
	var METRICS_CUSTOM_REPORT_CREATE_REPORT_ERROR = exports.METRICS_CUSTOM_REPORT_CREATE_REPORT_ERROR = 'METRICS_CUSTOM_REPORT_CREATE_REPORT_ERROR';
	
	var METRICS_CUSTOM_REPORT_CREATE_CHART_REQUEST = exports.METRICS_CUSTOM_REPORT_CREATE_CHART_REQUEST = 'METRICS_CUSTOM_REPORT_CREATE_CHART_REQUEST';
	var METRICS_CUSTOM_REPORT_CREATE_CHART_SUCCESS = exports.METRICS_CUSTOM_REPORT_CREATE_CHART_SUCCESS = 'METRICS_CUSTOM_REPORT_CREATE_CHART_SUCCESS';
	var METRICS_CUSTOM_REPORT_CREATE_CHART_ERROR = exports.METRICS_CUSTOM_REPORT_CREATE_CHART_ERROR = 'METRICS_CUSTOM_REPORT_CREATE_CHART_ERROR';
	
	var METRICS_CUSTOM_REPORT_GET_PANELS_REQUEST = exports.METRICS_CUSTOM_REPORT_GET_PANELS_REQUEST = 'METRICS_CUSTOM_REPORT_GET_PANELS_REQUEST';
	var METRICS_CUSTOM_REPORT_GET_PANELS_SUCCESS = exports.METRICS_CUSTOM_REPORT_GET_PANELS_SUCCESS = 'METRICS_CUSTOM_REPORT_GET_PANELS_SUCCESS';
	var METRICS_CUSTOM_REPORT_GET_PANELS_ERROR = exports.METRICS_CUSTOM_REPORT_GET_PANELS_ERROR = 'METRICS_CUSTOM_REPORT_GET_PANELS_ERROR';
	
	var METRICS_CUSTOM_REPORT_EDIT_PANEL_REQUEST = exports.METRICS_CUSTOM_REPORT_EDIT_PANEL_REQUEST = 'METRICS_CUSTOM_REPORT_EDIT_PANEL_REQUEST';
	var METRICS_CUSTOM_REPORT_EDIT_PANEL_SUCCESS = exports.METRICS_CUSTOM_REPORT_EDIT_PANEL_SUCCESS = 'METRICS_CUSTOM_REPORT_EDIT_PANEL_SUCCESS';
	var METRICS_CUSTOM_REPORT_EDIT_PANEL_ERROR = exports.METRICS_CUSTOM_REPORT_EDIT_PANEL_ERROR = 'METRICS_CUSTOM_REPORT_EDIT_PANEL_ERROR';

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var init = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var portalConfig, root, globalHeader, footerElement;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            portalConfig = void 0;
	            root = document.getElementById('devconsole-16-root');
	
	            if (!root) {
	              _context.next = 9;
	              break;
	            }
	
	            _context.next = 5;
	            return (0, _config2.default)();
	
	          case 5:
	            portalConfig = _context.sent;
	
	            _reactDom2.default.render(_react2.default.createElement(_App2.default, { portalConfig: portalConfig, component: 'root' }), root);
	            _context.next = 18;
	            break;
	
	          case 9:
	            globalHeader = document.getElementById('global-header');
	
	            if (!globalHeader) {
	              _context.next = 18;
	              break;
	            }
	
	            if (portalConfig) {
	              _context.next = 15;
	              break;
	            }
	
	            _context.next = 14;
	            return (0, _config.loadHeaderConfig)();
	
	          case 14:
	            portalConfig = _context.sent;
	
	          case 15:
	            _reactDom2.default.render(_react2.default.createElement(_App2.default, { portalConfig: portalConfig, component: 'header' }), globalHeader);
	            footerElement = document.getElementById('phoenix-footer');
	
	            if (footerElement) {
	              _reactDom2.default.render(_react2.default.createElement(_App2.default, { portalConfig: portalConfig, component: 'footer' }), footerElement);
	            }
	
	          case 18:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function init() {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1231);
	
	var _App = __webpack_require__(1448);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _config = __webpack_require__(1560);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	window.addEventListener('DOMContentLoaded', function () {
	  return init();
	});

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapStateToProps = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _recompose = __webpack_require__(105);
	
	var _styles = __webpack_require__(30);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(17);
	
	var _index = __webpack_require__(1564);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _portalConfig = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(_ref) {
	  var classes = _ref.classes,
	      children = _ref.children,
	      newLandingPage = _ref.newLandingPage;
	  return _react2.default.createElement(
	    'div',
	    { 'data-apim-test': 'main-container' },
	    newLandingPage ? _react2.default.createElement(_components.GlobalHeader, null) : _react2.default.createElement(_components.Header, null),
	    _react2.default.createElement(
	      'div',
	      { 'data-apim-test': 'main-page-content', className: classes.MainPageContent },
	      children
	    ),
	    _react2.default.createElement(_components.CookiePolicyBanner, null)
	  );
	};
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    newLandingPage: (0, _portalConfig.getNewLandingPage)(state)
	  };
	};
	Main.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  children: _propTypes2.default.shape({}),
	  newLandingPage: _propTypes2.default.bool
	};
	
	exports.default = (0, _recompose.compose)((0, _styles.withStyles)(_index2.default), (0, _reactRedux.connect)(mapStateToProps))(Main);

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      misc = _ref.misc;
	  return {
	    MainPageContent: {
	      backgroundColor: (0, _lodash.get)(color, 'background'),
	      minHeight: 'calc(100vh - (60px))',
	      marginTop: (0, _lodash.get)(misc, 'headerHeight')
	    }
	  };
	};

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = CustomFields;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(71);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getCustomField = function getCustomField(customFieldValues, _ref, customFieldErrors, _handleChange) {
	  var type = _ref.type,
	      uuid = _ref.uuid,
	      name = _ref.name,
	      description = _ref.description,
	      optionsList = _ref.optionsList,
	      required = _ref.required;
	
	  var customFieldValue = customFieldValues[uuid];
	  switch (type) {
	    case 'TEXT':
	      return _react2.default.createElement(_components.FormTextField, Object.assign({
	        key: uuid,
	        id: uuid,
	        name: name,
	        value: customFieldValue,
	        error: customFieldErrors[uuid],
	        handleChange: function handleChange(value) {
	          return _handleChange(uuid, value, required);
	        },
	        helperText: description
	      }, !required && { optional: true }));
	    case 'SINGLE_SELECT':
	      return _react2.default.createElement(_components.FormSelect, Object.assign({
	        key: uuid,
	        id: uuid,
	        name: name,
	        value: customFieldValue,
	        defaultText: 'Select an option.',
	        data: optionsList.map(function (_ref2) {
	          var value = _ref2.value;
	          return { uuid: value, name: value };
	        }),
	        handleChange: function handleChange(e) {
	          return _handleChange(uuid, (0, _lodash.get)(e, 'target.value'), required);
	        },
	        helperText: description,
	        error: customFieldErrors[uuid]
	      }, !required && { optional: true }));
	    default:
	      return null;
	  }
	};
	
	var getCustomFieldValues = function getCustomFieldValues(_ref3) {
	  var _ref3$customFieldValu = _ref3.customFieldValues,
	      customFieldValues = _ref3$customFieldValu === undefined ? [] : _ref3$customFieldValu;
	  return customFieldValues.reduce(function (acc, _ref4) {
	    var customFieldUuid = _ref4.customFieldUuid,
	        value = _ref4.value;
	
	    acc[customFieldUuid] = value;
	    return acc;
	  }, {});
	};
	
	function CustomFields(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      _props$errors = props.errors,
	      errors = _props$errors === undefined ? [] : _props$errors,
	      apiUuid = props.apiUuid,
	      apiDetails = props.apiDetails,
	      _props$customFields = props.customFields,
	      customFields = _props$customFields === undefined ? [] : _props$customFields,
	      saveApiCustomFields = props.saveApiCustomFields,
	      onCancel = props.onCancel;
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      customFieldErrors = _useState2[0],
	      setCustomFieldErrors = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(getCustomFieldValues(apiDetails)),
	      _useState4 = _slicedToArray(_useState3, 2),
	      customFieldValues = _useState4[0],
	      setCustomFieldValues = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isUnsavedChanges = _useState6[0],
	      setIsUnsavedChanges = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    setCustomFieldValues(getCustomFieldValues(apiDetails));
	  }, [apiDetails]);
	
	  var handleChange = function handleChange(fieldName, value, required) {
	    localStorage.setItem('isUnSavedChanges', true);
	    setIsUnsavedChanges(true);
	    setCustomFieldValues(Object.assign({}, customFieldValues, _defineProperty({}, fieldName, value)));
	    setCustomFieldErrors(Object.assign({}, customFieldErrors, _defineProperty({}, fieldName, required && !value)));
	  };
	
	  var onNext = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var fieldErrors;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              setIsUnsavedChanges(false);
	              localStorage.setItem('isUnSavedChanges', false);
	              fieldErrors = customFields.filter(function (_ref6) {
	                var required = _ref6.required;
	                return required;
	              }).reduce(function (acc, _ref7) {
	                var uuid = _ref7.uuid;
	                return Object.assign({}, acc, _defineProperty({}, uuid, !customFieldValues[uuid]));
	              }, {});
	
	              if (!(0, _lodash.some)((0, _lodash.values)(fieldErrors))) {
	                _context.next = 7;
	                break;
	              }
	
	              setCustomFieldErrors(Object.assign({}, customFieldErrors, fieldErrors));
	              _context.next = 9;
	              break;
	
	            case 7:
	              _context.next = 9;
	              return saveApiCustomFields(apiUuid, customFields.reduce(function (acc, _ref8) {
	                var uuid = _ref8.uuid;
	
	                if ((0, _lodash.isUndefined)(acc[uuid])) {
	                  acc[uuid] = '';
	                }
	                return acc;
	              }, customFieldValues));
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function onNext() {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'api-custom-fields-container' },
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      'Custom Fields'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _Grid2.default,
	        { md: 12, item: true },
	        customFields.map(function (customField) {
	          return getCustomField(customFieldValues, customField, customFieldErrors, handleChange);
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      nextText: _labels.SAVE_AND_NEXT_TEXT,
	      onCancelClick: function onCancelClick() {
	        return onCancel(isUnsavedChanges);
	      },
	      id: 'custom-fields-form-buttons'
	    })
	  );
	}
	
	CustomFields.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiUuid: _propTypes2.default.string,
	  apiDetails: _propTypes2.default.shape({}),
	  customFields: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  saveApiCustomFields: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func
	};

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = Details;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _validator = __webpack_require__(651);
	
	var _lodash = __webpack_require__(8);
	
	var _ExpandMore = __webpack_require__(81);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _ExpandLess = __webpack_require__(114);
	
	var _ExpandLess2 = _interopRequireDefault(_ExpandLess);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(77);
	
	var _utils = __webpack_require__(18);
	
	var _intl = __webpack_require__(15);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var MAX_LENGTH = 255;
	var REST_FILE_TYPE = '.wadl,.json';
	var SOAP_FILE_TYPE = '.wsdl,.xsd';
	var MAX_BUNDLE_SIZE_IN_MB = 10;
	var ALLOWED_FILE_EXTENSIONS_FOR_SOAP = ['wsdl', 'xsd'];
	var ALLOWED_FILE_EXTENSIONS_FOR_REST = ['wadl', 'json'];
	var WSDL_FILE_EXTENSION = 'wsdl';
	var JSON_FILE_EXTENSION = 'json';
	var MAX_FILE_SIZE = MAX_BUNDLE_SIZE_IN_MB * 1024 * 1024;
	var MIME_TYPES = {
	  xsd: 'application/x-xsd+xml',
	  wsdl: 'application/octet-stream',
	  json: 'application/json',
	  wadl: 'application/vnd.sun.wadl+xml'
	};
	
	var isGatewayPublishedSoapAPI = function isGatewayPublishedSoapAPI(_ref) {
	  var publishedByPortal = _ref.publishedByPortal,
	      apiServiceType = _ref.apiServiceType;
	  return publishedByPortal === false && apiServiceType === _labels.SOAP_TYPE;
	};
	
	function Details(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      errors = props.errors,
	      eulas = props.eulas,
	      apiUuid = props.apiUuid,
	      apiType = props.apiType,
	      setApiType = props.setApiType,
	      isApiNameUnique = props.isApiNameUnique,
	      isProxyUrlUnique = props.isProxyUrlUnique,
	      apiDetails = props.apiDetails,
	      _props$assets = props.assets,
	      assets = _props$assets === undefined ? [] : _props$assets,
	      _props$usage = props.usage,
	      usage = _props$usage === undefined ? {} : _props$usage,
	      onCancelDetails = props.onCancelDetails;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)({
	    files: assets,
	    acceptFileTypes: REST_FILE_TYPE,
	    maxFiles: 1,
	    error: false,
	    helperText: _labels.REST_FILE_HELPER_TEXT,
	    maxSize: MAX_FILE_SIZE
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      apiFile = _useState2[0],
	      setApiFile = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      apiName = _useState4[0],
	      setApiName = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      portalStatus = _useState6[0],
	      setPortalStatus = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isApiNameError = _useState8[0],
	      setIsApiNameError = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      isApiNameUniqueError = _useState10[0],
	      setIsApiNameUniqueError = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      isFileValidation = _useState12[0],
	      setIsFileValidation = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      fileValidationMessage = _useState14[0],
	      setFileValidationMessage = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      version = _useState16[0],
	      setVersion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      isVersionError = _useState18[0],
	      setIsVersionError = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      location = _useState20[0],
	      setLocation = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      isLocationError = _useState22[0],
	      setIsLocationError = _useState22[1];
	
	  var _useState23 = (0, _react.useState)('0'),
	      _useState24 = _slicedToArray(_useState23, 2),
	      eulaUuid = _useState24[0],
	      setEulaUuid = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      isEulaError = _useState26[0],
	      setIsEulaError = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(''),
	      _useState28 = _slicedToArray(_useState27, 2),
	      publicDescription = _useState28[0],
	      setPublicDescription = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      isPublicDescriptionError = _useState30[0],
	      setIsPublicDescriptionError = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(''),
	      _useState32 = _slicedToArray(_useState31, 2),
	      privateDescription = _useState32[0],
	      setPrivateDescription = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      isPrivateDescriptionError = _useState34[0],
	      setIsPrivateDescriptionError = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(''),
	      _useState36 = _slicedToArray(_useState35, 2),
	      proxyUrl = _useState36[0],
	      setProxyUrl = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(false),
	      _useState38 = _slicedToArray(_useState37, 2),
	      isProxyUrlError = _useState38[0],
	      setIsProxyUrlError = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      isProxyUrlUniqueError = _useState40[0],
	      setIsProxyUrlUniqueError = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(false),
	      _useState42 = _slicedToArray(_useState41, 2),
	      isUnsavedChanges = _useState42[0],
	      setIsUnsavedChanges = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      isToggleForm = _useState44[0],
	      setIsToggleForm = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(false),
	      _useState46 = _slicedToArray(_useState45, 2),
	      isUploadFile = _useState46[0],
	      setIsUploadFile = _useState46[1];
	
	  var _useState47 = (0, _react.useState)([]),
	      _useState48 = _slicedToArray(_useState47, 2),
	      filesToDelete = _useState48[0],
	      setIsFilesToDelete = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(''),
	      _useState50 = _slicedToArray(_useState49, 2),
	      notificationMessage = _useState50[0],
	      setNotificationMessage = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(''),
	      _useState52 = _slicedToArray(_useState51, 2),
	      notificationStatus = _useState52[0],
	      setNotificationStatus = _useState52[1];
	
	  (0, _react.useEffect)(function () {
	    if (apiDetails.apiServiceType) {
	      var type = apiDetails.apiServiceType === _labels.REST_TYPE ? _labels.ID_REST : _labels.ID_SOAP;
	      apiFile.acceptFileTypes = type === _labels.ID_REST ? REST_FILE_TYPE : SOAP_FILE_TYPE;
	      apiFile.maxFiles = type === _labels.ID_REST ? 1 : 2;
	      apiFile.helperText = type === _labels.ID_REST ? _labels.REST_FILE_HELPER_TEXT : _labels.SOAP_FILE_HELPER_TEXT;
	      setApiFile(Object.assign({}, apiFile, { files: assets }));
	      setApiType(type);
	      setIsToggleForm(true);
	    }
	    if (apiDetails.name) {
	      setApiName(apiDetails.name);
	    }
	    if (apiDetails.portalStatus) {
	      setPortalStatus(apiDetails.portalStatus);
	    }
	    if (apiDetails.version) {
	      setVersion(apiDetails.version);
	    }
	    if (apiDetails.locationUrl) {
	      setLocation(apiDetails.locationUrl);
	    }
	    if (apiDetails.apiEulaUuid) {
	      setEulaUuid(apiDetails.apiEulaUuid);
	    }
	    if (apiDetails.description) {
	      setPublicDescription(apiDetails.description);
	    }
	    if (apiDetails.privateDescription) {
	      setPrivateDescription(apiDetails.privateDescription);
	    }
	    if (apiDetails.ssgUrl) {
	      setProxyUrl(apiDetails.ssgUrl);
	    }
	  }, [apiDetails, assets]);
	
	  (0, _react.useEffect)(function () {
	    setIsApiNameUniqueError(!isApiNameUnique);
	    setIsProxyUrlUniqueError(!isProxyUrlUnique);
	  }, [isApiNameUnique, isProxyUrlUnique, apiName, proxyUrl]);
	
	  (0, _react.useEffect)(function () {
	    var apiNameErrorObject = errors.find(function (o) {
	      return o.field === 'name';
	    });
	    var proxyUrlErrorObject = errors.find(function (o) {
	      return o.field === 'ssgUrl';
	    });
	    setIsApiNameError(!!apiNameErrorObject);
	    setIsProxyUrlError(!!proxyUrlErrorObject);
	  }, [errors]);
	
	  var hasError = function hasError(isRequired, value) {
	    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_LENGTH;
	
	    var isError = false;
	    isError = isRequired ? (0, _validator.isEmpty)(value) : isError;
	    isError = !isError ? !(0, _validator.isLength)(value, { max: max }) : isError;
	    return isError;
	  };
	
	  var _handleChange = function _handleChange(fieldName, value) {
	    switch (fieldName) {
	      case 'apiType':
	        {
	          var typeValue = (0, _lodash.get)(value, 'target.value');
	          apiFile.acceptFileTypes = typeValue === _labels.ID_REST ? REST_FILE_TYPE : SOAP_FILE_TYPE;
	          apiFile.maxFiles = typeValue === _labels.ID_REST ? 1 : 2;
	          apiFile.files = [];
	          apiFile.error = false;
	          apiFile.helperText = typeValue === _labels.ID_REST ? _labels.REST_FILE_HELPER_TEXT : _labels.SOAP_FILE_HELPER_TEXT;
	          setApiFile(apiFile);
	          setApiType((0, _lodash.get)(value, 'target.value') || _labels.ID_REST);
	          if (typeValue !== _labels.ID_REST) {
	            setIsToggleForm(true);
	          }
	          break;
	        }
	      case 'apiName':
	        {
	          var apiUiError = hasError(true, value);
	          setApiName(value);
	          setIsApiNameError(apiUiError);
	          break;
	        }
	      case 'version':
	        {
	          var isError = hasError(true, value) || (0, _utils.isNumericVersion)(value);
	          setIsVersionError(isError);
	          setVersion(value);
	          break;
	        }
	      case 'location':
	        setIsLocationError(hasError(true, value));
	        setLocation(value);
	        break;
	      case 'eula':
	        {
	          if (value === '0') {
	            setEulaUuid(value);
	            setIsEulaError(true);
	          } else {
	            setIsEulaError(false);
	            setEulaUuid(value);
	          }
	          break;
	        }
	      case 'publicDescription':
	        setIsPublicDescriptionError(hasError(false, value));
	        setPublicDescription(value);
	        break;
	      case 'privateDescription':
	        setIsPrivateDescriptionError(hasError(false, value));
	        setPrivateDescription(value);
	        break;
	      case 'proxyUrl':
	        {
	          var UrlUiError = hasError(true, value, 127);
	          setProxyUrl(value);
	          setIsProxyUrlError(UrlUiError);
	          break;
	        }
	      default:
	        break;
	    }
	    localStorage.setItem('isUnSavedChanges', true);
	    setIsUnsavedChanges(true);
	  };
	
	  var onCheckApiNameUnique = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(name, currentId) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return props.checkApiNameUnique(name, currentId);
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function onCheckApiNameUnique(_x2, _x3) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var onCheckProxyUrlUnique = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(url) {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return props.checkProxyUrlUnique(url);
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    return function onCheckProxyUrlUnique(_x4) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var _handleBlur = function _handleBlur(fieldName, value) {
	    switch (fieldName) {
	      case 'apiName':
	        {
	          if (value) {
	            onCheckApiNameUnique(value, apiUuid);
	          } else {
	            setIsApiNameError(true);
	          }
	          break;
	        }
	      case 'proxyUrl':
	        if (value) {
	          onCheckProxyUrlUnique(value);
	        } else {
	          setIsProxyUrlError(true);
	        }
	        break;
	      default:
	        break;
	    }
	  };
	
	  var hasWsdlForSoap = function hasWsdlForSoap() {
	    var exts = (0, _lodash.map)(apiFile.files, function (file) {
	      return file.ext;
	    });
	    return (0, _lodash.includes)(exts, 'wsdl');
	  };
	
	  var onNextDetails = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data, initialAssets, uploadedAssets, hasUploadFile, filesDelete) {
	      var details;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if (!apiUuid) {
	                _context3.next = 12;
	                break;
	              }
	
	              details = data;
	              // Gateway published api: To change the portal status as enabled when the status is new
	
	              if (details.publishedByPortal === false && details.portalStatus === _labels.API_PUBLISH_STATE_NEW) {
	                details.portalStatus = _labels.API_PUBLISH_STATE_ENABLED;
	              }
	
	              if (!isGatewayPublishedSoapAPI(details)) {
	                _context3.next = 8;
	                break;
	              }
	
	              _context3.next = 6;
	              return props.updateApiDetails(apiUuid, details);
	
	            case 6:
	              _context3.next = 10;
	              break;
	
	            case 8:
	              _context3.next = 10;
	              return props.updateApiDetailsWithAssets(apiUuid, details, initialAssets, uploadedAssets, hasUploadFile, filesDelete);
	
	            case 10:
	              _context3.next = 14;
	              break;
	
	            case 12:
	              _context3.next = 14;
	              return props.saveApi(data, uploadedAssets);
	
	            case 14:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this);
	    }));
	
	    return function onNextDetails(_x5, _x6, _x7, _x8, _x9) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  var onNext = function onNext() {
	    setIsToggleForm(true);
	    var apiNameUiError = hasError(true, apiName);
	    var versionUiError = hasError(true, version);
	    var locationUiError = apiDetails.publishedByPortal !== false && hasError(true, location);
	    var eulaUuidUiError = eulaUuid === '0';
	    var publicDescriptionUiError = hasError(false, publicDescription);
	    var privateDescriptionUiError = hasError(false, privateDescription);
	    var proxyUrlUiError = hasError(true, proxyUrl, 127);
	    var soapFileError = apiType === _labels.ID_REST ? false : !hasWsdlForSoap();
	    if ((0, _lodash.some)([apiNameUiError, locationUiError, eulaUuidUiError, proxyUrlUiError, isProxyUrlError, isApiNameError, soapFileError])) {
	      if (apiNameUiError || isApiNameError) {
	        setIsApiNameError(true);
	      }
	      setIsVersionError(versionUiError);
	      setIsLocationError(locationUiError);
	      setIsEulaError(eulaUuidUiError);
	      if (proxyUrlUiError || isProxyUrlError) {
	        setIsProxyUrlError(true);
	      }
	      if (soapFileError) {
	        apiFile.error = true;
	        setApiFile(Object.assign({}, apiFile));
	      }
	      setNotificationStatus(_constants.ALERT_ERROR);
	      setNotificationMessage(intl.getI18nMessage('error.required.fields.missing'));
	    } else if (isApiNameUniqueError) {
	      setNotificationStatus(_constants.ALERT_ERROR);
	      setNotificationMessage(intl.getI18nMessage('error.api.field.unique.name'));
	    } else if (isProxyUrlUniqueError) {
	      setNotificationStatus(_constants.ALERT_ERROR);
	      setNotificationMessage(intl.getI18nMessage('error.api.field.unique.proxyUrl'));
	    } else if ((0, _lodash.some)([publicDescriptionUiError, privateDescriptionUiError])) {
	      setIsPublicDescriptionError(publicDescriptionUiError);
	      setIsPrivateDescriptionError(privateDescriptionUiError);
	      setNotificationStatus(_constants.ALERT_ERROR);
	      setNotificationMessage(intl.getI18nMessage('error.form'));
	    } else {
	      setNotificationStatus('');
	      setNotificationMessage('');
	      localStorage.setItem('isUnSavedChanges', false);
	      setIsUnsavedChanges(false);
	      setIsFileValidation(false);
	      setFileValidationMessage('');
	      var uploadFileFlag = isUploadFile;
	      setIsUploadFile(false);
	      var serviceType = apiType === _labels.ID_REST ? _labels.REST_TYPE : _labels.SOAP_TYPE;
	      onNextDetails(Object.assign({}, apiDetails, {
	        serviceType: serviceType,
	        apiName: apiName,
	        portalStatus: portalStatus,
	        version: version,
	        location: location,
	        eulaUuid: eulaUuid,
	        publicDescription: publicDescription,
	        privateDescription: privateDescription,
	        proxyUrl: proxyUrl
	      }), assets, apiFile, uploadFileFlag, filesToDelete);
	    }
	  };
	
	  var onCancel = function onCancel() {
	    onCancelDetails(isUnsavedChanges);
	  };
	
	  var b64DecodeUnicode = function b64DecodeUnicode(str) {
	    var uriStr = atob(str).split('').map(function (c) {
	      var str1 = '00' + c.charCodeAt(0).toString(16);
	      var str2 = str1.slice(-2);
	      return '%' + str2;
	    });
	    return decodeURIComponent(uriStr.join(''));
	  };
	
	  var populateFieldsFromFile = function populateFieldsFromFile(payload) {
	    var result = b64DecodeUnicode(payload.substring(payload.lastIndexOf(',') + 1));
	    try {
	      var parsedResult = JSON.parse(result);
	      if (parsedResult.info) {
	        if (parsedResult.info.title) {
	          _handleChange('apiName', parsedResult.info.title);
	          onCheckApiNameUnique(parsedResult.info.title);
	        }
	        if (parsedResult.info.version) {
	          _handleChange('version', parsedResult.info.version);
	        }
	        if (parsedResult.info.description) {
	          _handleChange('publicDescription', parsedResult.info.description);
	        }
	        if (parsedResult.host) {
	          var protocol = typeof parsedResult.schemes !== 'undefined' && parsedResult.schemes.length > 0 ? parsedResult.schemes[0] : 'http';
	          var host = protocol + '://' + parsedResult.host + parsedResult.basePath;
	          _handleChange('location', host);
	        }
	
	        var eulaStandard = (0, _lodash.find)(eulas, { name: 'Standard EULA' });
	        if (eulaStandard && eulaStandard.uuid) {
	          setEulaUuid(eulaStandard.uuid);
	        }
	      }
	    } catch (e) {
	      setIsFileValidation(true);
	      setFileValidationMessage(intl.getI18nMessage('error.api.file.invalid.json.swagger'));
	    }
	  };
	
	  var isValidFile = function isValidFile(file, allowedExtension) {
	    var extension = (0, _utils.getFileExtension)(file.name);
	    var allowedFileExtensions = allowedExtension;
	    if (!allowedFileExtensions) {
	      allowedFileExtensions = apiType === _labels.ID_REST ? ALLOWED_FILE_EXTENSIONS_FOR_REST : ALLOWED_FILE_EXTENSIONS_FOR_SOAP;
	    }
	    if ((0, _lodash.includes)(allowedFileExtensions, extension)) {
	      return true;
	    }
	    return false;
	  };
	
	  var fileLoad = function fileLoad(file) {
	    var reader = new FileReader();
	    reader.onabort = function () {
	      apiFile.error = true;
	      setApiFile(Object.assign({}, apiFile));
	    };
	    reader.onerror = function () {
	      apiFile.error = true;
	      setApiFile(Object.assign({}, apiFile));
	    };
	    reader.onload = function () {
	      if (isValidFile(file)) {
	        // Todo: Refactor the below code
	        apiFile.error = false;
	        setIsFileValidation(false);
	        setFileValidationMessage('');
	        var fileContent = reader.result;
	        var fileExtenstion = (0, _utils.getFileExtension)(file.name);
	        var fileData = file;
	        fileData.ext = fileExtenstion;
	        if (apiType === _labels.ID_REST) {
	          if (!apiUuid && fileExtenstion === JSON_FILE_EXTENSION) {
	            populateFieldsFromFile(fileContent);
	          }
	          fileContent = window.atob(fileContent.substring(fileContent.lastIndexOf(',') + 1));
	        }
	        fileData.blob = new Blob([fileContent], { type: MIME_TYPES[fileExtenstion] });
	        if (apiType === _labels.ID_REST) {
	          apiFile.files = [fileData];
	          setApiFile(Object.assign({}, apiFile));
	        } else if (fileExtenstion === WSDL_FILE_EXTENSION) {
	          if (hasWsdlForSoap(fileData)) {
	            setIsFileValidation(true);
	            setFileValidationMessage(_labels.VALIDATION_ONE_WSDL_MESSAGE);
	            setApiFile(Object.assign({}, apiFile));
	          } else {
	            apiFile.files.push(fileData);
	            setApiFile(Object.assign({}, apiFile));
	          }
	        } else if ((0, _lodash.some)(apiFile.files, { name: file.name })) {
	          setIsFileValidation(true);
	          setFileValidationMessage(_labels.VALIDATION_FILE_NAME_UNIQUE_MESSAGE);
	        } else {
	          apiFile.files.push(fileData);
	          setApiFile(Object.assign({}, apiFile));
	        }
	      } else {
	        apiFile.error = true;
	        setApiFile(Object.assign({}, apiFile));
	      }
	    };
	
	    if (apiType === _labels.ID_REST) {
	      reader.readAsDataURL(file);
	    } else {
	      reader.readAsText(file);
	    }
	  };
	
	  var handleFiles = function handleFiles(files) {
	    setIsToggleForm(true);
	    if (apiUuid) {
	      setIsUploadFile(true);
	    }
	    if ((0, _lodash.isArray)(files)) {
	      files.forEach(function (file) {
	        fileLoad(file);
	      });
	    } else {
	      fileLoad(files);
	    }
	  };
	
	  var onRemoveFile = function onRemoveFile(file) {
	    if (apiUuid && file.uuid && !(0, _lodash.includes)(filesToDelete, file.uuid)) {
	      filesToDelete.push(file.uuid);
	      setIsFilesToDelete(filesToDelete);
	    }
	    var remainApiFiles = apiFile.files.filter(function (obj) {
	      return obj.name !== file.name;
	    });
	    setApiFile(Object.assign({}, apiFile, { files: remainApiFiles }));
	  };
	
	  var selectedEula = (0, _lodash.find)(eulas, function (_ref5) {
	    var uuid = _ref5.uuid;
	    return uuid === eulaUuid;
	  });
	  var _usage$directAppUsage = usage.directAppUsage,
	      directAppUsage = _usage$directAppUsage === undefined ? 0 : _usage$directAppUsage,
	      _usage$indirectAppUsa = usage.indirectAppUsage,
	      indirectAppUsage = _usage$indirectAppUsa === undefined ? 0 : _usage$indirectAppUsa;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'api-details-container' },
	    notificationMessage && _react2.default.createElement(_components.AlertMessages, {
	      id: 'api-details-notifications',
	      message: notificationMessage,
	      variant: notificationStatus,
	      onClose: function onClose() {
	        setNotificationMessage('');
	        setNotificationStatus('');
	      }
	    }),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h1', className: classes.pageTitle },
	      intl.getI18nMessage('label.details')
	    ),
	    !isGatewayPublishedSoapAPI(apiDetails) && _react2.default.createElement(
	      'div',
	      { className: classes.fileContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 12, item: true },
	        _react2.default.createElement(
	          'div',
	          { className: classes.apiTypeContainer },
	          _react2.default.createElement(
	            _core.FormLabel,
	            { component: 'h4', className: classes.formLabel },
	            'API Type'
	          ),
	          apiUuid ? _react2.default.createElement(
	            'div',
	            { className: classes.apiServiceType },
	            apiDetails.apiServiceType
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_components.RadioGroupSection, {
	              selected: apiType,
	              onChange: function onChange(value) {
	                return _handleChange('apiType', value);
	              },
	              data: _labels.API_DETAILS_TYPE,
	              id: 'api-details-type'
	            })
	          )
	        ),
	        _react2.default.createElement(_components.FileDropzone, {
	          handleFiles: handleFiles,
	          selectedFiles: apiFile,
	          helperText: '',
	          title: 'Upload Definition File',
	          id: 'api-file-upload',
	          onRemoveFile: onRemoveFile,
	          isValidation: isFileValidation,
	          validationMessage: fileValidationMessage
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _clsx2.default)(classes.pageTitle, classes.expandManualContainer),
	        onClick: function onClick() {
	          return setIsToggleForm(!isToggleForm);
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: classes.manualContainer },
	          'Add API Details'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.expandIconContainer },
	        !isToggleForm ? _react2.default.createElement(_ExpandMore2.default, null) : _react2.default.createElement(_ExpandLess2.default, null)
	      )
	    ),
	    _react2.default.createElement(_core.Divider, { className: classes.detailDivider }),
	    _react2.default.createElement(
	      _core.Collapse,
	      { 'in': isToggleForm },
	      _react2.default.createElement(
	        _core.Grid,
	        { container: true, spacing: 3, className: classes.gridContainer },
	        _react2.default.createElement(
	          _core.Grid,
	          { md: 12, item: true },
	          _react2.default.createElement(_components.FormTextField, {
	            id: 'api-details-name',
	            name: 'API Name',
	            value: apiName,
	            error: isApiNameError || isApiNameUniqueError,
	            handleChange: function handleChange(value) {
	              return _handleChange('apiName', value);
	            },
	            handleBlur: function handleBlur(value) {
	              return _handleBlur('apiName', value);
	            },
	            helperText: 'Maximum name length is 255 characters. Name must be unique.'
	          }),
	          apiUuid && apiDetails.portalStatus !== _labels.API_PUBLISH_STATE_INCOMPLETE && _react2.default.createElement(
	            'div',
	            { id: 'api-publish-state-container' },
	            _react2.default.createElement(
	              'div',
	              { className: classes.formLabel },
	              'Publish State'
	            ),
	            apiDetails.portalStatus !== _labels.API_PUBLISH_STATE_NEW ? _react2.default.createElement(_components.RadioGroupSection, {
	              selected: portalStatus,
	              onChange: function onChange(e) {
	                return setPortalStatus(e.target.value);
	              },
	              data: _labels.API_PUBLISH_STATE_TYPES,
	              id: 'api-publish-state',
	              isDisable: true,
	              disableOptions: apiDetails.possibleStatuses,
	              defaultSelect: apiDetails.portalStatus
	            }) : _react2.default.createElement(
	              'div',
	              { id: 'api-publish-state-new', className: classes.statusContainer },
	              'Unpublished',
	              _react2.default.createElement(
	                _core.FormHelperText,
	                null,
	                'The API will be enabled after save.'
	              )
	            )
	          ),
	          _react2.default.createElement(_components.FormTextField, {
	            id: 'api-details-version',
	            name: 'Version',
	            value: version,
	            error: isVersionError,
	            handleChange: function handleChange(value) {
	              return _handleChange('version', value, 50);
	            },
	            helperText: 'The value for this field can only contain 0-9 and delimited with . _ and - characters.'
	          }),
	          apiDetails.publishedByPortal !== false && _react2.default.createElement(_components.FormTextField, {
	            id: 'api-details-location',
	            name: intl.getI18nMessage('label.api.location'),
	            value: location,
	            error: isLocationError,
	            handleChange: function handleChange(value) {
	              return _handleChange('location', value);
	            },
	            helperText: intl.getI18nMessage('label.api.location.help')
	          }),
	          directAppUsage !== 0 || indirectAppUsage !== 0 ? _react2.default.createElement(_components.FormTextField, {
	            id: 'api-details-eula',
	            name: 'API EULA',
	            value: (0, _lodash.get)(selectedEula, 'name'),
	            error: isEulaError,
	            helperText: 'The EULA can\'t be changed after it has been added to an application.',
	            disabled: true
	          }) : _react2.default.createElement(_components.FormSelect, {
	            id: 'api-details-eula',
	            name: 'API EULA',
	            value: eulaUuid,
	            error: isEulaError,
	            data: eulas,
	            handleChange: function handleChange(value) {
	              return _handleChange('eula', value);
	            },
	            helperText: 'Select at least one.',
	            defaultText: 'Select an API EULA.',
	            noNativeSelect: true
	          }),
	          _react2.default.createElement(_components.FormTextField, {
	            id: 'api-details-public-description',
	            name: 'Public Description',
	            value: publicDescription,
	            error: isPublicDescriptionError,
	            handleChange: function handleChange(value) {
	              return _handleChange('publicDescription', value);
	            },
	            helperText: 'Maximum description length is 255 characters.',
	            multiline: true,
	            rows: 4,
	            optional: true
	          }),
	          _react2.default.createElement(_components.FormTextField, {
	            id: 'api-details-private-description',
	            name: 'Private Description',
	            value: privateDescription,
	            error: isPrivateDescriptionError,
	            handleChange: function handleChange(value) {
	              return _handleChange('privateDescription', value);
	            },
	            helperText: 'Maximum description length is 255 characters.',
	            multiline: true,
	            rows: 4,
	            optional: true
	          }),
	          _react2.default.createElement(_components.FormDefaultTextField, {
	            id: 'api-proxy-details',
	            name: intl.getI18nMessage('label.api.proxyUrl'),
	            value: proxyUrl,
	            error: isProxyUrlError || isProxyUrlUniqueError,
	            defaultText: intl.getI18nMessage('label.api.proxyUrl.default'),
	            handleChange: function handleChange(value) {
	              return _handleChange('proxyUrl', value, 127);
	            },
	            handleBlur: function handleBlur(value) {
	              return _handleBlur('proxyUrl', value, 127);
	            },
	            helperText: intl.getI18nMessage('label.api.proxyUrl.help'),
	            isDisabled: !!apiUuid
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      nextText: _labels.SAVE_AND_NEXT_TEXT,
	      onCancelClick: onCancel,
	      id: 'visibility-form-buttons'
	    })
	  );
	}
	
	Details.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  eulas: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiUuid: _propTypes2.default.string,
	  apiType: _propTypes2.default.string,
	  setApiType: _propTypes2.default.func,
	  isApiNameUnique: _propTypes2.default.bool,
	  isProxyUrlUnique: _propTypes2.default.bool,
	  apiDetails: _propTypes2.default.shape({}),
	  assets: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  usage: _propTypes2.default.shape({}),
	  onCancelDetails: _propTypes2.default.func
	};

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = ManagementPermission;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(16);
	
	var _intl = __webpack_require__(15);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(77);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var ADMIN_PERMISSIONS_DATA = _labels.MANAGEMENT_PERMISSIONS_DATA.filter(function (option) {
	  return option.id !== _labels.ID_PRIVATE;
	});
	
	function ManagementPermission(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      userContext = props.userContext,
	      apiUuid = props.apiUuid,
	      tabValue = props.tabValue,
	      apiDetails = props.apiDetails,
	      users = props.users,
	      onCancel = props.onCancel,
	      errors = props.errors,
	      publisherOrgs = props.publisherOrgs,
	      defaultSelectedManageOrg = props.defaultSelectedManageOrg,
	      isLoadMore = props.isLoadMore,
	      onLoadMore = props.onLoadMore,
	      organizationsPage = props.organizationsPage;
	
	
	  var isDisabled = !apiUuid;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isSaveManageOrgApi = _useState2[0],
	      setIsSaveManageOrgApi = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isSavePermissionApi = _useState4[0],
	      setIsSavePermissionApi = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isChangePermission = _useState6[0],
	      setIsChangePermission = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isUnsavedChanges = _useState8[0],
	      setIsUnsavedChanges = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      selectedPermission = _useState10[0],
	      setPermission = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(defaultSelectedManageOrg),
	      _useState12 = _slicedToArray(_useState11, 2),
	      selectedManageOrg = _useState12[0],
	      setSelectedManageOrg = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      isManageOrgLoad = _useState14[0],
	      setIsManageOrgLoad = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mngOrgVisibilityPopupShown = _useState16[0],
	      setMngOrgVisibilityPopupShown = _useState16[1];
	
	  var getDefaultPermission = function getDefaultPermission() {
	    var defaultPermission = selectedPermission;
	    if (!isChangePermission) {
	      if (userContext.portalAdmin) {
	        defaultPermission = props.defaultSelectedUsers.length > 0 ? _labels.ID_RESTRICTED : _labels.ID_PUBLIC;
	      } else if (userContext.apiOwner) {
	        if (props.defaultSelectedUsers.length === 0) {
	          defaultPermission = _labels.ID_PUBLIC;
	        } else if (props.defaultSelectedUsers.length === 1) {
	          defaultPermission = _labels.ID_PRIVATE;
	        } else {
	          defaultPermission = _labels.ID_RESTRICTED;
	        }
	      }
	    }
	    return defaultPermission;
	  };
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState17 = (0, _react.useState)(props.selectedUsers),
	      _useState18 = _slicedToArray(_useState17, 2),
	      selectedUsers = _useState18[0],
	      setSelectedUsers = _useState18[1];
	
	  var data = userContext.portalAdmin ? ADMIN_PERMISSIONS_DATA : _labels.MANAGEMENT_PERMISSIONS_DATA;
	
	  var fetchManagementData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return props.fetchApi(apiUuid);
	
	            case 2:
	              _context.next = 4;
	              return props.fetchSelectedUsers(apiUuid);
	
	            case 4:
	              _context.next = 6;
	              return props.fetchAvailableUsers(apiUuid);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function fetchManagementData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    if ((0, _utils.hasPublisherRole)(userContext) && apiUuid && tabValue === 'management-tab') {
	      fetchManagementData();
	    }
	  }, [tabValue]);
	
	  (0, _react.useEffect)(function () {
	    if (apiDetails.managingOrgUuid && (0, _utils.hasPublisherRole)(userContext) && tabValue === 'management-tab') {
	      props.fetchSelectedManageOrg(apiDetails.managingOrgUuid);
	    }
	  }, [apiDetails]);
	
	  (0, _react.useEffect)(function () {
	    setPermission(getDefaultPermission());
	  }, [props.selectedUsers]);
	
	  (0, _react.useEffect)(function () {
	    setSelectedUsers(props.selectedUsers);
	  }, [props.selectedUsers]);
	
	  (0, _react.useEffect)(function () {
	    if ((0, _lodash.has)(defaultSelectedManageOrg, 'uuid')) {
	      setSelectedManageOrg(defaultSelectedManageOrg);
	    }
	  }, [defaultSelectedManageOrg]);
	
	  (0, _react.useEffect)(function () {
	    setIsManageOrgLoad(isLoadMore);
	  }, [isLoadMore]);
	
	  (0, _react.useEffect)(function () {
	    if (organizationsPage.currentPage < organizationsPage.totalPages - 1) {
	      onLoadMore();
	    }
	  }, [organizationsPage]);
	
	  var onManageOrgChange = function onManageOrgChange(e, value) {
	    setIsUnsavedChanges(true);
	    localStorage.setItem('isUnSavedChanges', true);
	    setIsChangePermission(true);
	    setSelectedManageOrg(value);
	    setIsSaveManageOrgApi(true);
	  };
	
	  var onSearchListChange = function onSearchListChange(selectedUser) {
	    setSelectedUsers([].concat(_toConsumableArray(selectedUser)));
	    setIsUnsavedChanges(true);
	    setIsSavePermissionApi(true);
	    localStorage.setItem('isUnSavedChanges', true);
	  };
	
	  var onChangePermission = function onChangePermission(e) {
	    setPermission(e.target.value);
	    setIsChangePermission(true);
	    setIsUnsavedChanges(true);
	    setIsSavePermissionApi(true);
	    localStorage.setItem('isUnSavedChanges', true);
	  };
	
	  var closeMngOrgVisibilityDialog = function closeMngOrgVisibilityDialog() {
	    return setMngOrgVisibilityPopupShown(false);
	  };
	
	  var onNextManagement = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(permission, manageUsers, manageOrg, retainMngOrgVisibility) {
	      var dataToSave, apiOwner;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              dataToSave = [];
	
	              // only api owner can choose private option
	              // If an API Owner chooses the 'private' option -
	              // add the API Owner UUID to the selected users able to access the API
	
	              if (permission === _labels.ID_PRIVATE) {
	                apiOwner = (0, _utils.getApiOwnerUser)(userContext);
	
	                dataToSave = [{ uuid: apiOwner.uuid }];
	              }
	              if (permission === _labels.ID_RESTRICTED) {
	                (0, _lodash.map)(manageUsers, function (object) {
	                  dataToSave.push({ uuid: object.uuid });
	                });
	              }
	              _context2.next = 5;
	              return props.savePermissions(dataToSave, apiUuid, manageOrg, isSavePermissionApi, isSaveManageOrgApi, retainMngOrgVisibility);
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    return function onNextManagement(_x, _x2, _x3, _x4) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var onNext = function onNext(retainMngOrgVisibility) {
	    if (selectedPermission === _labels.ID_RESTRICTED && selectedUsers.length === 0) {
	      return false;
	    }
	    if (selectedPermission === _labels.ID_PUBLIC) {
	      setSelectedUsers([]);
	    }
	    setIsUnsavedChanges(false);
	    localStorage.setItem('isUnSavedChanges', false);
	    onNextManagement(selectedPermission, selectedUsers, selectedManageOrg, retainMngOrgVisibility);
	    return true;
	  };
	
	  var handleMngOrgVisibilityResponse = function handleMngOrgVisibilityResponse(retainMngOrgVisibility) {
	    closeMngOrgVisibilityDialog();
	    onNext(retainMngOrgVisibility);
	  };
	
	  var onClickNext = function onClickNext() {
	    // A popup should be shown when the access is private and the managing org has been changed.
	    // and also the existing managing org should not be empty.
	    if (apiDetails.accessStatus === 'PRIVATE' && defaultSelectedManageOrg && defaultSelectedManageOrg.uuid && (selectedManageOrg === null || defaultSelectedManageOrg.uuid !== selectedManageOrg.uuid)) {
	      setMngOrgVisibilityPopupShown(true);
	      return;
	    }
	    onNext();
	  };
	
	  var getItemSecondaryText = function getItemSecondaryText(user) {
	    return user.roleOrgs.map(function (role) {
	      return (0, _utils.getSingularRoleName)(role);
	    });
	  };
	  return _react2.default.createElement(
	    'div',
	    { id: 'api-management-container' },
	    mngOrgVisibilityPopupShown && _react2.default.createElement(_components.AlertDialog, {
	      isOpen: mngOrgVisibilityPopupShown,
	      title: intl.getI18nMessage(_labels.API_MANAGING_ORG_POPUP_TITLE),
	      description: intl.getI18nMessage(_labels.API_MANAGING_ORG_POPUP_MESSAGE, { existingOrg: '\'' + defaultSelectedManageOrg.name + '\'' }),
	      submitText: intl.getI18nMessage(_labels.API_MANAGING_ORG_POPUP_SUBMIT_TEXT),
	      cancelText: intl.getI18nMessage(_labels.API_MANAGING_ORG_POPUP_CANCEL_TEXT),
	      onClose: closeMngOrgVisibilityDialog,
	      handleClose: closeMngOrgVisibilityDialog,
	      showCloseButton: true,
	      onSubmit: function onSubmit() {
	        return handleMngOrgVisibilityResponse(true);
	      },
	      onCancel: function onCancel() {
	        return handleMngOrgVisibilityResponse(false);
	      },
	      dialogId: 'mng-org-visibility-dialog'
	    }),
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      'Management Permissions'
	    ),
	    (0, _utils.hasPublisherRole)(userContext) && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: classes.sectionTitle },
	        'Managing Organization'
	      ),
	      _react2.default.createElement(_components.FormAutoCompleteCombo, {
	        data: publisherOrgs,
	        selectedValues: selectedManageOrg,
	        onChange: function onChange(e, value) {
	          return onManageOrgChange(e, value);
	        },
	        loading: isManageOrgLoad,
	        id: 'managing-organizations',
	        inputLabel: 'Select Managing Organization'
	      })
	    ),
	    _react2.default.createElement(
	      'h2',
	      { className: classes.sectionTitle, id: 'manage-user-container' },
	      'API Owner Permissions'
	    ),
	    _react2.default.createElement(_components.RadioGroupSection, {
	      selected: selectedPermission,
	      onChange: onChangePermission,
	      data: data,
	      id: 'management-radio-group'
	    }),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    selectedPermission === _labels.ID_RESTRICTED && _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 6, item: true },
	        _react2.default.createElement(_components.SearchTextListContainer, {
	          title: _labels.MANAGEMENT_USER_TITLE,
	          subtitle: _labels.MANAGEMENT_USER_SUB_TITLE,
	          placeHolderText: _labels.MANAGEMENT_USER_PLACE_HOLDER_TEXT,
	          defaultList: users,
	          defaultSelectedList: selectedUsers,
	          listId: 'users-list',
	          isCheckBoxVisible: true,
	          onSearchListChange: onSearchListChange,
	          isDisableSelectedOption: true,
	          disableSelectedOptions: [userContext],
	          userContext: userContext,
	          getItemSecondaryText: getItemSecondaryText
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 6, item: true },
	        _react2.default.createElement(_components.SearchTextListContainer, {
	          title: _labels.MANAGEMENT_SELECTED_USER_TITLE,
	          subtitle: _labels.MANAGEMENT_SELECTED_USER_SUB_TITLE,
	          placeHolderText: _labels.MANAGEMENT_SELECTED_USER_PLACE_HOLDER_TEXT,
	          isSelectedNumberVisible: true,
	          defaultList: selectedUsers,
	          defaultSelectedList: selectedUsers,
	          listId: 'users-selected-list',
	          onSearchListChange: onSearchListChange,
	          isDeleteIconVisible: true,
	          isDisableSelectedOption: true,
	          userContext: userContext,
	          disableSelectedOptions: [userContext],
	          getItemSecondaryText: getItemSecondaryText,
	          selectedItemErrorMessage: _labels.MANAGEMENT_SELECTED_ITEM_ERROR_MESSAGE
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      nextText: _labels.SAVE_AND_NEXT_TEXT,
	      onNextClick: onClickNext,
	      onCancelClick: function onCancelClick() {
	        return onCancel(isUnsavedChanges);
	      },
	      id: 'management-form-buttons',
	      isDisabled: isDisabled
	    })
	  );
	}
	
	ManagementPermission.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  userContext: _propTypes2.default.shape({}),
	  selectedUsers: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  users: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  onCancel: _propTypes2.default.func,
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  publisherOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  defaultSelectedManageOrg: _propTypes2.default.shape({}),
	  isLoadMore: _propTypes2.default.bool,
	  onLoadMore: _propTypes2.default.func,
	  organizationsPage: _propTypes2.default.shape({}),
	  apiUuid: _propTypes2.default.string,
	  tabValue: _propTypes2.default.string,
	  apiDetails: _propTypes2.default.shape({})
	};

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = PolicyTemplates;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function PolicyTemplates(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      errors = props.errors,
	      apiUuid = props.apiUuid,
	      onCancel = props.onCancel;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isUnsavedChanges = _useState2[0],
	      setIsUnsavedChanges = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      selectedPolicyTemplates = _useState4[0],
	      setSelectedPolicyTemplates = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      policyFormArguments = _useState6[0],
	      setPolicyFormArguments = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    var selectedTemplates = [];
	    if (props.policyTemplates.length > 0 && props.apiDetails.policyEntities && props.apiDetails.policyEntities.length > 0) {
	      var policyTemplates = props.policyTemplates || [];
	      var policyEntities = [];
	      var getApiPolicyTemplateArguments = function getApiPolicyTemplateArguments(policyTemplateArguments) {
	        return policyTemplateArguments.reduce(function (acc, _ref) {
	          var name = _ref.name,
	              value = _ref.value;
	
	          acc[name] = value;
	          return acc;
	        }, {});
	      };
	      (0, _lodash.forEach)(props.apiDetails.policyEntities, function (_ref2) {
	        var policyEntityUuid = _ref2.policyEntityUuid,
	            policyTemplateArguments = _ref2.policyTemplateArguments;
	
	        var entity = {};
	        entity[policyEntityUuid] = getApiPolicyTemplateArguments(policyTemplateArguments);
	        policyEntities.push(entity);
	      });
	      (0, _lodash.forEach)(policyEntities, function (policyEntity) {
	        var selectedEntities = policyTemplates.filter(function (_ref3) {
	          var uuid = _ref3.uuid;
	          return policyEntity[uuid];
	        }).map(function (policyTemplate) {
	          return Object.assign({}, policyTemplate, {
	            arguments: (0, _lodash.get)(policyTemplate, 'arguments', []).map(function (argument) {
	              return Object.assign({}, argument, {
	                value: policyEntity[policyTemplate.uuid][argument.name]
	              });
	            })
	          });
	        });
	        // Adding to the rendered list of Policy Templates
	        // only when the reference implementation exists
	        if (selectedEntities.length > 0) {
	          selectedTemplates.push(selectedEntities[0]);
	        }
	      });
	      (0, _lodash.map)(selectedTemplates, function (policyTemplate, index) {
	        policyFormArguments[index] = policyFormArguments[index] || [];
	        (0, _lodash.map)((0, _lodash.get)(policyTemplate, 'arguments', []), function (arg) {
	          if (arg.value) {
	            var argObj = policyFormArguments[index].find(function (obj) {
	              return obj.name === arg.name;
	            });
	            if (!(0, _lodash.isObject)(argObj)) {
	              policyFormArguments[index].push({ name: arg.name, value: arg.value });
	            }
	          }
	        });
	      });
	      setSelectedPolicyTemplates([].concat(selectedTemplates));
	      setPolicyFormArguments([].concat(_toConsumableArray(policyFormArguments)));
	    }
	  }, [props.apiDetails, props.policyTemplates]);
	
	  var onSelectedPolicyTemplates = function onSelectedPolicyTemplates(obj) {
	    selectedPolicyTemplates.push(obj);
	    setSelectedPolicyTemplates([].concat(_toConsumableArray(selectedPolicyTemplates)));
	  };
	
	  var onDeletePolicyTemplate = function onDeletePolicyTemplate(template, i) {
	    selectedPolicyTemplates.splice(i, 1);
	    policyFormArguments.splice(i, 1);
	    setSelectedPolicyTemplates([].concat(_toConsumableArray(selectedPolicyTemplates)));
	    setPolicyFormArguments([].concat(_toConsumableArray(policyFormArguments)));
	  };
	
	  var onMoveUpPolicyTemplate = function onMoveUpPolicyTemplate(template, i) {
	    if (i > 0) {
	      var moveUpPolicyTemplates = selectedPolicyTemplates.splice(i, 1);
	      selectedPolicyTemplates.splice(i - 1, 0, moveUpPolicyTemplates[0]);
	      var moveUpPolicyFormArguments = policyFormArguments.splice(i, 1);
	      policyFormArguments.splice(i - 1, 0, moveUpPolicyFormArguments[0]);
	    }
	    setSelectedPolicyTemplates([].concat(_toConsumableArray(selectedPolicyTemplates)));
	    setPolicyFormArguments([].concat(_toConsumableArray(policyFormArguments)));
	    localStorage.setItem('isUnSavedChanges', true);
	  };
	
	  var onMoveDownPolicyTemplate = function onMoveDownPolicyTemplate(template, i) {
	    if (i < selectedPolicyTemplates.length - 1) {
	      var moveDownPolicyTemplates = selectedPolicyTemplates.splice(i, 1);
	      selectedPolicyTemplates.splice(i + 1, 0, moveDownPolicyTemplates[0]);
	    }
	    if (i < policyFormArguments.length - 1) {
	      var moveDownPolicyFormArguments = policyFormArguments.splice(i, 1);
	      policyFormArguments.splice(i + 1, 0, moveDownPolicyFormArguments[0]);
	    }
	    setSelectedPolicyTemplates([].concat(_toConsumableArray(selectedPolicyTemplates)));
	    setPolicyFormArguments([].concat(_toConsumableArray(policyFormArguments)));
	    localStorage.setItem('isUnSavedChanges', true);
	  };
	
	  var onChangePolicyTemplateForm = function onChangePolicyTemplateForm(val, name, index) {
	    policyFormArguments[index] = policyFormArguments[index] || [];
	    var objectIndex = (0, _lodash.findIndex)(policyFormArguments[index], { name: name });
	    if (objectIndex > -1) {
	      policyFormArguments[index][objectIndex].value = val.toString();
	    } else {
	      policyFormArguments[index].push({ name: name, value: val.toString() });
	    }
	
	    var policyObjectIndex = (0, _lodash.findIndex)(selectedPolicyTemplates[index].arguments, { name: name });
	    if (policyObjectIndex > -1) {
	      selectedPolicyTemplates[index].arguments[policyObjectIndex].value = val.toString();
	    } else {
	      selectedPolicyTemplates[index].arguments[policyObjectIndex].push({ name: name, value: val.toString() });
	    }
	    setSelectedPolicyTemplates([].concat(_toConsumableArray(selectedPolicyTemplates)));
	    setPolicyFormArguments([].concat(_toConsumableArray(policyFormArguments)));
	  };
	
	  var onNextPolicyTemplates = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              data = selectedPolicyTemplates.map(function (_ref5, i) {
	                var uuid = _ref5.uuid;
	                return {
	                  policyEntityUuid: uuid,
	                  policyTemplateArguments: policyFormArguments[i] || []
	                };
	              });
	              _context.next = 3;
	              return props.saveApiPolicyEntities(apiUuid, data);
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function onNextPolicyTemplates() {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  var onNext = function onNext() {
	    localStorage.setItem('isUnSavedChanges', false);
	    setIsUnsavedChanges(false);
	    onNextPolicyTemplates();
	  };
	
	  var onSelect = function onSelect(template) {
	    localStorage.setItem('isUnSavedChanges', true);
	    setIsUnsavedChanges(true);
	    onSelectedPolicyTemplates(template);
	  };
	
	  var onPolicyFormChange = function onPolicyFormChange(val, name, index) {
	    localStorage.setItem('isUnSavedChanges', true);
	    setIsUnsavedChanges(true);
	    onChangePolicyTemplateForm(val, name, index);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'api-policy-container' },
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      'Policy Templates'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 12, item: true },
	        _react2.default.createElement(
	          'div',
	          { className: classes.expandContainer, id: 'selected-policy-templates-container' },
	          _react2.default.createElement(_components.ExpandPanelContainer, {
	            defaultList: selectedPolicyTemplates,
	            isDeleteIcon: true,
	            onDeleteItem: onDeletePolicyTemplate,
	            handleChangeDynamicForm: function handleChangeDynamicForm(val, name, index) {
	              return onPolicyFormChange(val, name, index);
	            },
	            isMoveUpIcon: true,
	            onMoveUpItem: onMoveUpPolicyTemplate,
	            isMoveDownIcon: true,
	            onMoveDownItem: onMoveDownPolicyTemplate
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.comboBoxContainer, id: 'policy-templates-container' },
	          _react2.default.createElement(_components.FormComboCheckBox, {
	            id: 'api-policy-templates',
	            data: props.policyTemplates,
	            onSelect: onSelect,
	            selectedvalues: selectedPolicyTemplates,
	            inputLabel: 'Select Policy Template'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      nextText: _labels.SAVE_AND_NEXT_TEXT,
	      onCancelClick: function onCancelClick() {
	        return onCancel(isUnsavedChanges);
	      },
	      id: 'visibility-form-buttons'
	    })
	  );
	}
	
	PolicyTemplates.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiUuid: _propTypes2.default.string,
	  policyTemplates: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiDetails: _propTypes2.default.shape({}),
	  onCancel: _propTypes2.default.func
	};

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultAuthenticationParameters = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = SpecAuthentication;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(71);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getDefaultAuthenticationParameters = exports.getDefaultAuthenticationParameters = function getDefaultAuthenticationParameters(authenticationType) {
	  return Object.assign({}, authenticationType === _labels.API_SPEC_AUTHENTICATION_TYPE_API_KEY && { ApiKeyType: _labels.API_SPEC_AUTHENTICATION_TYPE_API_KEY_TYPE_QUERY }, authenticationType === _labels.API_SPEC_AUTHENTICATION_TYPE_OAUTH2 && { GrantType: _labels.API_SPEC_AUTHENTICATION_TYPE_OAUTH2_GRANT_TYPE_CODE });
	};
	
	function SpecAuthentication(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      errors = props.errors,
	      apiUuid = props.apiUuid,
	      apiDetails = props.apiDetails,
	      updateApi = props.updateApi,
	      showLoading = props.showLoading,
	      onCancel = props.onCancel;
	
	  var _useState = (0, _react.useState)(apiDetails.authenticationType),
	      _useState2 = _slicedToArray(_useState, 2),
	      authenticationType = _useState2[0],
	      setAuthenticationType = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(getDefaultAuthenticationParameters(authenticationType)),
	      _useState4 = _slicedToArray(_useState3, 2),
	      authenticationParameters = _useState4[0],
	      setAuthenticationParameters = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isUnsavedChanges = _useState6[0],
	      setIsUnsavedChanges = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    setAuthenticationType(apiDetails.authenticationType);
	    if (apiDetails.authenticationParameters) {
	      setAuthenticationParameters(Object.assign({}, apiDetails.authenticationParameters));
	    }
	  }, [apiDetails.authenticationType, apiDetails.authenticationParameters]);
	
	  var _handleChange = function _handleChange(fieldName, value) {
	    localStorage.setItem('isUnSavedChanges', true);
	    setIsUnsavedChanges(true);
	    switch (fieldName) {
	      case 'authenticationType':
	        {
	          setAuthenticationType(value);
	          setAuthenticationParameters(getDefaultAuthenticationParameters(value));
	          break;
	        }
	      case 'authenticationParameters':
	        {
	          setAuthenticationParameters(value);
	          break;
	        }
	      default:
	    }
	  };
	
	  var onNext = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              localStorage.setItem('isUnSavedChanges', false);
	              setIsUnsavedChanges(false);
	              _context.next = 4;
	              return showLoading(true);
	
	            case 4:
	              _context.next = 6;
	              return updateApi(apiUuid, Object.assign({}, apiDetails, { authenticationType: authenticationType, authenticationParameters: authenticationParameters
	              }));
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function onNext() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'api-spec-auth-container' },
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      'Spec Authentication'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _Grid2.default,
	        { md: 12, item: true },
	        authenticationType && _react2.default.createElement(_components.FormRadioGroup, {
	          id: 'api-spec-authentication-type',
	          name: _labels.API_SPEC_AUTHENTICATION_TYPE_LABEL + ':',
	          selected: authenticationType,
	          onChange: function onChange(value) {
	            return _handleChange('authenticationType', value);
	          },
	          data: _labels.API_SPEC_AUTHENTICATION_TYPES
	        }),
	        authenticationType === _labels.API_SPEC_AUTHENTICATION_TYPE_API_KEY && _react2.default.createElement(_components.FormSelect, {
	          id: 'api-spec-authentication-api-key-type',
	          name: 'API Key Type',
	          value: authenticationParameters.ApiKeyType,
	          data: [{ uuid: 'query', name: 'Query' }, { uuid: 'header', name: 'Header' }],
	          handleChange: function handleChange(ApiKeyType) {
	            return _handleChange('authenticationParameters', Object.assign({}, authenticationParameters, {
	              ApiKeyType: ApiKeyType
	            }));
	          },
	          noNoneOption: true,
	          noNativeSelect: true
	        }),
	        authenticationType === _labels.API_SPEC_AUTHENTICATION_TYPE_OAUTH2 && _react2.default.createElement(_components.FormSelect, {
	          id: 'api-spec-authentication-grant-type',
	          name: 'Grant Type',
	          value: authenticationParameters.GrantType,
	          data: [{ uuid: 'CODE', name: 'Authorization Code' }, { uuid: 'TOKEN', name: 'Implicit' }, { uuid: 'PASSWORD', name: 'Resource Owner Password Credentials' }, { uuid: 'CLIENT_CREDENTIALS', name: 'Client Credentials' }],
	          handleChange: function handleChange(GrantType) {
	            return _handleChange('authenticationParameters', Object.assign({}, authenticationParameters, {
	              GrantType: GrantType
	            }));
	          },
	          noNoneOption: true,
	          noNativeSelect: true
	        }),
	        authenticationType === _labels.API_SPEC_AUTHENTICATION_TYPE_OAUTH2 && (0, _lodash.includes)(['CODE', 'TOKEN'], authenticationParameters.GrantType) && _react2.default.createElement(_components.FormTextField, {
	          id: 'api-spec-authentication-authorization-endpoint',
	          name: 'Authorization Endpoint',
	          value: authenticationParameters.AuthorizeEndpoint,
	          error: (0, _lodash.some)(errors, function (_ref2) {
	            var field = _ref2.field;
	            return field === 'AuthorizeEndpoint';
	          }),
	          handleChange: function handleChange(AuthorizeEndpoint) {
	            return _handleChange('authenticationParameters', Object.assign({}, authenticationParameters, {
	              AuthorizeEndpoint: AuthorizeEndpoint
	            }));
	          },
	          helperText: 'Maximum length is 900 characters. Must be a valid URL.'
	        }),
	        authenticationType === _labels.API_SPEC_AUTHENTICATION_TYPE_OAUTH2 && (0, _lodash.includes)(['CODE', 'PASSWORD', 'CLIENT_CREDENTIALS'], authenticationParameters.GrantType) && _react2.default.createElement(_components.FormTextField, {
	          id: 'api-spec-authentication-token-endpoint',
	          name: 'Token Endpoint',
	          value: authenticationParameters.TokenEndpoint,
	          error: (0, _lodash.some)(errors, function (_ref3) {
	            var field = _ref3.field;
	            return field === 'TokenEndpoint';
	          }),
	          handleChange: function handleChange(TokenEndpoint) {
	            return _handleChange('authenticationParameters', Object.assign({}, authenticationParameters, {
	              TokenEndpoint: TokenEndpoint
	            }));
	          },
	          helperText: 'Maximum length is 900 characters. Must be a valid URL.'
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      nextText: _labels.SAVE_AND_NEXT_TEXT,
	      onCancelClick: function onCancelClick() {
	        return onCancel(isUnsavedChanges);
	      },
	      id: 'spec-form-buttons'
	    })
	  );
	}
	
	SpecAuthentication.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiUuid: _propTypes2.default.string,
	  apiDetails: _propTypes2.default.shape({}),
	  updateApi: _propTypes2.default.func,
	  showLoading: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func
	};

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = Tags;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _lodash = __webpack_require__(8);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(17);
	
	var _intl = __webpack_require__(15);
	
	var _labels = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MAX_TAG_LENGTH = 60;
	var LIMIT_TAGS_ASSOCIATED = 25;
	var TAGS_SOURCE_PORTAL = 'portal';
	var TAGS_SOURCE_SWAGGER = 'swagger';
	
	var getTagsNamesFromSwaggerTagObjects = function getTagsNamesFromSwaggerTagObjects() {
	  var tagObjects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return tagObjects.map(function (item) {
	    return item.name;
	  });
	};
	
	// tag max length MAX_TAG_LENGTH, allowed characters a-z,A-Z,0-9,.,_,#,",:,',-.
	var validateTag = function validateTag(newTag) {
	  return newTag && newTag.length <= MAX_TAG_LENGTH && /^[a-zA-Z0-9._#" :'-]*$/.test(newTag);
	};
	
	var tagsEqual = function tagsEqual(tag1, tag2) {
	  return (tag1 && tag1.toLowerCase()) === (tag2 && tag2.toLowerCase());
	};
	
	// truncates strings longer than MAX_TAG_LENGTH
	// with ellipsis at the end
	var truncateSwaggerTag = function truncateSwaggerTag(tag) {
	  var trimmedTag = tag.trim();
	  // add ellipsis at the end if the tag size > 60
	  if (trimmedTag && trimmedTag.length > MAX_TAG_LENGTH) {
	    trimmedTag = trimmedTag.substring(0, MAX_TAG_LENGTH - 3) + '...';
	  }
	  return trimmedTag;
	};
	
	var extractTagsFromSwaggerData = function extractTagsFromSwaggerData() {
	  var swaggerData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var rootTagObjects = swaggerData.tags || [];
	  var tagsNames = getTagsNamesFromSwaggerTagObjects(rootTagObjects);
	  var pathsObject = swaggerData && swaggerData.paths || {};
	  // iterate over op objects in each path object
	  (0, _lodash.each)(pathsObject, function (pathObject) {
	    (0, _lodash.each)(pathObject, function (opObject) {
	      tagsNames = tagsNames.concat(opObject.tags || []);
	    });
	  });
	  return tagsNames;
	};
	
	var getTagsNamesFromSwaggger = function getTagsNamesFromSwaggger() {
	  var swaggerData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var tagsNames = extractTagsFromSwaggerData(swaggerData);
	
	  // removing empty tags
	  tagsNames = tagsNames.filter(function (tag) {
	    return tag && tag.trim();
	  });
	  // remove duplicate tags
	  tagsNames = (0, _lodash.uniqBy)(tagsNames);
	  var tagsBeforeValidation = tagsNames.length;
	  // truncate longer tags
	  tagsNames = tagsNames.map(truncateSwaggerTag);
	  // removing invalid tags
	  tagsNames = tagsNames.filter(function (tag) {
	    return validateTag(tag);
	  });
	  // get unique tags, ignoring case
	  // this unique operation discards duplicate tags by using caseinsenstive match.
	  // we are doing it here, instead of using caseinsenstive match initially,
	  // as we want to inform user about tags discarded due caseinsenstive match.
	  tagsNames = (0, _lodash.uniqBy)(tagsNames, function (tag) {
	    return tag.toLowerCase();
	  });
	  var tagsAfterValidation = tagsNames.length;
	  var tagsDiscarded = tagsBeforeValidation !== tagsAfterValidation;
	  return {
	    discarded: tagsDiscarded,
	    tags: tagsNames
	  };
	};
	
	var getSwaggerOnlyTagsNames = function getSwaggerOnlyTagsNames(tags) {
	  var swaggerOnlyTags = tags.filter(function (tagObj) {
	    return tagObj.sources.length === 1 && tagObj.sources[0] === TAGS_SOURCE_SWAGGER;
	  });
	  return swaggerOnlyTags.map(function (item) {
	    return item.name;
	  });
	};
	
	var getExistingTagNames = function getExistingTagNames(tags) {
	  var nonSwaggerOnlyTags = tags.filter(function (tagObj) {
	    return tagObj.sources.length !== 1 || tagObj.sources[0] !== TAGS_SOURCE_SWAGGER;
	  });
	  return nonSwaggerOnlyTags.map(function (item) {
	    return item.name;
	  });
	};
	
	var _getItemSecondaryText = function _getItemSecondaryText(item, portalText, swaggerText) {
	  var textArray = [];
	  var _item$sources = item.sources,
	      sources = _item$sources === undefined ? [] : _item$sources;
	
	  (0, _lodash.each)(sources, function (source) {
	    if (source === TAGS_SOURCE_PORTAL) {
	      textArray.push(portalText);
	    } else if (source === TAGS_SOURCE_SWAGGER) {
	      textArray.push(swaggerText);
	    }
	  });
	  return textArray.join(',');
	};
	
	var getDummyTagsFromNames = function getDummyTagsFromNames() {
	  var tagNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return tagNames.map(function (name, i) {
	    return {
	      name: name,
	      uuid: 'dummy-uuid-' + i
	    };
	  });
	};
	
	function Tags(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      apiUuid = props.apiUuid,
	      allPortalTags = props.allPortalTags,
	      apiDetails = props.apiDetails,
	      apiTags = props.apiTags,
	      assets = props.assets,
	      newTags = props.newTags,
	      errors = props.errors,
	      swaggerData = props.swaggerData,
	      createTags = props.createTags,
	      notifyMessages = props.notifyMessages,
	      onCancel = props.onCancel,
	      visible = props.visible;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedTags = _useState2[0],
	      setSelectedTags = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      createdTags = _useState4[0],
	      setCreatedTags = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      hasUnsavedChanges = _useState6[0],
	      setHasUnsavedChanges = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isNextPending = _useState8[0],
	      setIsNextPending = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      defaultListTags = _useState10[0],
	      setDefaultListTags = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      hasSelectionChanged = _useState12[0],
	      setHasSelectionChanged = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      isCreatingTag = _useState14[0],
	      setIsCreatingTag = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      errsInTagImport = _useState16[0],
	      setErrsInTagImport = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      disableSave = _useState18[0],
	      setDisableSave = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      showingTAGLimitErr = _useState20[0],
	      setShowingTAGLimitErr = _useState20[1];
	
	  var portalText = intl.getI18nMessage(_labels.TAGS_SOURCE_PORTAL_TEXT);
	  var swaggerText = intl.getI18nMessage(_labels.TAGS_SOURCE_SWAGGER_TEXT);
	
	  (0, _react.useEffect)(function () {
	    if (errsInTagImport && visible) {
	      var swaggerImporError = intl.getI18nMessage(_labels.TAGS_IMPORT_SWAGGER_TAGS_ERROR);
	      notifyMessages(swaggerImporError, _labels.ERROR_TEXT);
	    }
	  }, [errsInTagImport, visible]);
	
	  (0, _react.useEffect)(function () {
	    var _getTagsNamesFromSwag = getTagsNamesFromSwaggger(swaggerData),
	        swaggerTagsNames = _getTagsNamesFromSwag.tags,
	        swaggerTagsDiscaded = _getTagsNamesFromSwag.discarded;
	
	    var hasAssets = (0, _lodash.isArray)(assets) && assets.length > 0;
	    // Don't show error message when invalid tags
	    // from auto-generated spec content are discarded.
	    // If API doesn't have a swagger file assoicated with it
	    // /speccontent would respond with auto-generated swagger
	    // If API doesn't have swagger file, then assets would be empty
	    if (hasAssets && swaggerTagsDiscaded) {
	      setErrsInTagImport(true);
	    }
	
	    var allTagsNames = [].concat(_toConsumableArray(allPortalTags), _toConsumableArray(createdTags)).map(function (item) {
	      return item.name;
	    });
	    var swaggerOnlyTagsNames = (0, _lodash.differenceWith)(swaggerTagsNames, allTagsNames, tagsEqual);
	    var swaggerOnlyTags = getDummyTagsFromNames(swaggerOnlyTagsNames);
	
	    // populate labels based on sources
	    var allTags = [].concat(_toConsumableArray(allPortalTags), _toConsumableArray(createdTags)).map(function (item) {
	      return swaggerTagsNames && (0, _lodash.find)(swaggerTagsNames, function (tagName) {
	        return tagsEqual(item.name, tagName);
	      }) ? Object.assign({}, item, { sources: [TAGS_SOURCE_PORTAL, TAGS_SOURCE_SWAGGER] }) : Object.assign({}, item, { sources: [TAGS_SOURCE_PORTAL] });
	    });
	    allTags = allTags.concat(swaggerOnlyTags.map(function (item) {
	      return Object.assign({}, item, { sources: [TAGS_SOURCE_SWAGGER] });
	    }));
	    setDefaultListTags(allTags);
	    if (!hasSelectionChanged) {
	      var apiTagsNames = apiTags.map(function (item) {
	        return item.name;
	      });
	      var defaultSelectedTags = allTags.filter(function (item) {
	        return apiTagsNames.includes(item.name);
	      });
	      setSelectedTags(defaultSelectedTags);
	    }
	  }, [swaggerData, allPortalTags, apiTags, createdTags]);
	
	  (0, _react.useEffect)(function () {
	    var updatedSelectedTags = selectedTags;
	    // changes to auto-select tag created using add tag button
	    if (isCreatingTag) {
	      (0, _lodash.each)(newTags, function (newTag) {
	        var newTagOption = (0, _lodash.find)(defaultListTags, function (item) {
	          return item.name === newTag.name;
	        });
	        if (!(0, _lodash.find)(selectedTags, function (item) {
	          return item.name === newTag.name;
	        })) {
	          updatedSelectedTags = [].concat(_toConsumableArray(selectedTags), [newTagOption]);
	        }
	      });
	      setIsCreatingTag(false);
	    }
	    // updating selected tags to use ids from createdTags, whenever defaultListTags changes
	    // this is required when tags are created using swagger tags
	    if (createdTags.length > 0) {
	      var newSelectedOptions = [];
	      var oldSelectedTags = updatedSelectedTags;
	      (0, _lodash.each)(createdTags, function (createdTag) {
	        var newTagOption = (0, _lodash.find)(defaultListTags, function (item) {
	          return tagsEqual(item.name, createdTag.name);
	        });
	        if ((0, _lodash.find)(updatedSelectedTags, function (item) {
	          return item.name === createdTag.name;
	        })) {
	          newSelectedOptions.push(newTagOption);
	          oldSelectedTags = (0, _lodash.filter)(oldSelectedTags, function (item) {
	            return !tagsEqual(item.name, createdTag.name);
	          });
	        }
	      });
	      updatedSelectedTags = [].concat(_toConsumableArray(oldSelectedTags), newSelectedOptions);
	    }
	    if (hasSelectionChanged) {
	      setSelectedTags(updatedSelectedTags);
	    }
	  }, [defaultListTags]);
	
	  var onNextTags = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(tagNames) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return props.saveTagsAssociation(tagNames, apiUuid);
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function onNextTags(_x5) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var associateTags = function associateTags(tagsNames) {
	    localStorage.setItem('isUnSavedChanges', false);
	    setHasUnsavedChanges(false);
	    onNextTags(tagsNames);
	  };
	
	  (0, _react.useEffect)(function () {
	    // using setCreatedTags to maintain list of tags
	    // created by user in this step instead of pulling
	    // all tags after every tag creation
	    if (newTags.length > 0) {
	      // code to remove duplicates
	      // shouldn't happen, but handling it
	      // as i noticed the issue during dev testing
	      var newTagsMap = (0, _lodash.reduce)([].concat(_toConsumableArray(createdTags), _toConsumableArray(newTags)), function (acc, item) {
	        acc[item.uuid] = item;return acc;
	      }, {});
	      var allNewTags = (0, _lodash.values)(newTagsMap);
	      setCreatedTags(allNewTags);
	    }
	  }, [newTags]);
	
	  (0, _react.useEffect)(function () {
	    if (newTags.length > 0) {
	      // if next is pending
	      if (isNextPending) {
	        setIsNextPending(false);
	        var existingTagsNames = getExistingTagNames(selectedTags);
	        var newTagsNames = newTags.map(function (item) {
	          return item.name;
	        });
	        associateTags([].concat(_toConsumableArray(existingTagsNames), _toConsumableArray(newTagsNames)));
	      }
	    }
	  }, [newTags]);
	
	  (0, _react.useEffect)(function () {
	    if (selectedTags.length >= LIMIT_TAGS_ASSOCIATED) {
	      var tagAssociationErr = intl.getI18nMessage(_labels.TAGS_ASSOCIATION_LIMIT_MSG, {
	        MAX_TAGS: LIMIT_TAGS_ASSOCIATED
	      });
	      notifyMessages(tagAssociationErr, _labels.ERROR_TEXT);
	      setShowingTAGLimitErr(true);
	    } else if (showingTAGLimitErr) {
	      notifyMessages('', '');
	      setShowingTAGLimitErr(false);
	    }
	    if (selectedTags.length > LIMIT_TAGS_ASSOCIATED) {
	      setDisableSave(true);
	    } else {
	      setDisableSave(false);
	    }
	  }, [selectedTags]);
	
	  var onSearchListChange = function onSearchListChange(selectedTagsParam) {
	    setHasSelectionChanged(true);
	    setSelectedTags([].concat(_toConsumableArray(selectedTagsParam)));
	    localStorage.setItem('isUnSavedChanges', true);
	    setHasUnsavedChanges(true);
	  };
	
	  var onAddItem = function onAddItem(tagText) {
	    setIsCreatingTag(true);
	    setHasSelectionChanged(true);
	    createTags([{ name: tagText }]);
	  };
	
	  var onNext = function onNext() {
	    var tagObjects = getSwaggerOnlyTagsNames(selectedTags).map(function (item) {
	      return { name: item };
	    });
	    if (tagObjects.length === 0) {
	      associateTags(getExistingTagNames(selectedTags));
	      return;
	    }
	    setIsNextPending(true);
	    createTags(tagObjects);
	  };
	
	  var toggleSwaggerSelection = function toggleSwaggerSelection(deselectAll) {
	    var updatedSelectedTags = selectedTags;
	    if (deselectAll) {
	      updatedSelectedTags = selectedTags.filter(function (item) {
	        return !item.sources.includes(TAGS_SOURCE_SWAGGER);
	      });
	    } else {
	      updatedSelectedTags = defaultListTags.filter(function (item) {
	        return item.sources.includes(TAGS_SOURCE_SWAGGER);
	      });
	      updatedSelectedTags = (0, _lodash.union)(updatedSelectedTags, selectedTags);
	    }
	    setSelectedTags(updatedSelectedTags);
	    setHasSelectionChanged(true);
	    localStorage.setItem('isUnSavedChanges', true);
	    setHasUnsavedChanges(true);
	  };
	
	  var renderSubTitleComponent = function renderSubTitleComponent(_ref2) {
	    var subtitle = _ref2.subtitle;
	
	    var _getTagsNamesFromSwag2 = getTagsNamesFromSwaggger(swaggerData),
	        allSwaggerTags = _getTagsNamesFromSwag2.tags;
	
	    var selectedTagsNames = selectedTags.map(function (item) {
	      return item.name;
	    });
	    var allSwaggerTagsSelected = (0, _lodash.differenceWith)(allSwaggerTags.sort(), selectedTagsNames.sort(), tagsEqual).length === 0;
	    if (apiDetails.apiServiceType !== 'REST' || allSwaggerTags.length === 0) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        subtitle
	      );
	    }
	    var selectTagsText = intl.getI18nMessage(_labels.TAGS_SELECT_SWAGGER_TAGS);
	    var clearTagsText = intl.getI18nMessage(_labels.TAGS_UNSELECT_SWAGGER_TAGS);
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        subtitle
	      ),
	      _react2.default.createElement(
	        _core.Button,
	        {
	          onClick: function onClick() {
	            return toggleSwaggerSelection(allSwaggerTagsSelected);
	          },
	          className: classes.swaggerSelectButton,
	          id: 'select-swagger-tags'
	        },
	        allSwaggerTagsSelected ? clearTagsText : selectTagsText
	      )
	    );
	  };
	  renderSubTitleComponent.propTypes = {
	    subtitle: _propTypes2.default.string
	  };
	
	  var tagSubTitle = intl.getI18nMessage(_labels.TAGS_SUB_TITLE);
	  var placeholderText = intl.getI18nMessage(_labels.TAGS_PLACE_HOLDER_TEXT);
	  var selectedTagsSubTitle = intl.getI18nMessage(_labels.TAGS_SELECTED_TAG_SUB_TITLE);
	  var addNewTagText = intl.getI18nMessage(_labels.TAGS_ADD_NEW_TAG);
	  var tagsInvalidError = intl.getI18nMessage(_labels.TAGS_INVALID_ERROR, { MAX_TAG_LENGTH: MAX_TAG_LENGTH });
	  return _react2.default.createElement(
	    'div',
	    { id: 'api-tags-container' },
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      'Tags'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 6, item: true },
	        _react2.default.createElement(_components.SearchTextListContainer, {
	          title: intl.getI18nMessage('label.api.tags.available'),
	          subtitle: tagSubTitle,
	          placeHolderText: placeholderText,
	          defaultList: defaultListTags,
	          defaultSelectedList: selectedTags,
	          listId: 'tags-list',
	          isCheckBoxVisible: true,
	          disableSelection: disableSave,
	          onSearchListChange: onSearchListChange,
	          userContext: {},
	          canAddItem: true,
	          addItemText: addNewTagText,
	          onAddItem: onAddItem,
	          getItemSecondaryText: function getItemSecondaryText(item) {
	            return _getItemSecondaryText(item, portalText, swaggerText);
	          },
	          validateItem: validateTag,
	          validationErrorMsg: tagsInvalidError,
	          SubTitleComponent: renderSubTitleComponent
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 6, item: true },
	        _react2.default.createElement(_components.SearchTextListContainer, {
	          title: intl.getI18nMessage('label.api.tags.selected'),
	          subtitle: selectedTagsSubTitle,
	          placeHolderText: placeholderText,
	          isSelectedNumberVisible: true,
	          defaultList: selectedTags,
	          defaultSelectedList: selectedTags,
	          isMandatory: false,
	          listId: 'tags-selected-list',
	          onSearchListChange: onSearchListChange,
	          isDeleteIconVisible: true,
	          userContext: {},
	          getItemSecondaryText: function getItemSecondaryText(item) {
	            return _getItemSecondaryText(item, portalText, swaggerText);
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      nextText: _labels.SAVE_TEXT,
	      onCancelClick: function onCancelClick() {
	        return onCancel(hasUnsavedChanges);
	      },
	      isDisabled: disableSave,
	      id: 'tag-form-buttons'
	    })
	  );
	}
	
	Tags.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiUuid: _propTypes2.default.string,
	  allPortalTags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiTags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  assets: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  newTags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  createTags: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  swaggerData: _propTypes2.default.shape({}),
	  apiDetails: _propTypes2.default.shape({}),
	  notifyMessages: _propTypes2.default.func,
	  visible: _propTypes2.default.bool
	};

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = VisibilityPermission;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(71);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var VISIBILITY_ORGADMIN_DEV_DATA = _labels.VISIBILTY_PERMISSIONS_DATA.filter(function (option) {
	  return option.id !== _labels.ID_RESTRICTED;
	});
	
	function VisibilityPermission(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      _props$userContext = props.userContext,
	      userContext = _props$userContext === undefined ? {} : _props$userContext,
	      apiUuid = props.apiUuid,
	      tabValue = props.tabValue,
	      apiDetails = props.apiDetails,
	      organizations = props.organizations,
	      apiAccessStatus = props.apiAccessStatus,
	      onLoadMore = props.onLoadMore,
	      isLoadMore = props.isLoadMore,
	      onCancel = props.onCancel,
	      errors = props.errors;
	
	
	  var isDisabled = !apiUuid;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isUnsavedChanges = _useState2[0],
	      setIsUnsavedChanges = _useState2[1];
	
	  var getDefaultPermission = function getDefaultPermission() {
	    var defaultPermission = _labels.ID_PRIVATE;
	    if (apiDetails.accessStatus === _labels.API_ACCESS_STATUS_PUBLIC) {
	      defaultPermission = _labels.ID_PUBLIC;
	    } else if (props.selectedOrganizations.length === 1 && props.selectedOrganizations[0].uuid === apiDetails.managingOrgUuid) {
	      defaultPermission = _labels.ID_PRIVATE;
	    } else if (props.selectedOrganizations.length > 0) {
	      defaultPermission = _labels.ID_RESTRICTED;
	    }
	    return defaultPermission;
	  };
	
	  var _useState3 = (0, _react.useState)(getDefaultPermission()),
	      _useState4 = _slicedToArray(_useState3, 2),
	      selectedPermission = _useState4[0],
	      setPermission = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(props.selectedOrganizations),
	      _useState6 = _slicedToArray(_useState5, 2),
	      selectedOrganizations = _useState6[0],
	      setSelectedOrganizations = _useState6[1];
	
	  var data = userContext.portalAdmin || userContext.apiOwner || userContext.orgPublisher ? _labels.VISIBILTY_PERMISSIONS_DATA : VISIBILITY_ORGADMIN_DEV_DATA;
	  var isDropDownOrg = false;
	  var disableSelectedOptions = apiDetails ? [{ uuid: apiDetails.managingOrgUuid }] : [];
	
	  var fetchVisibilityData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return props.fetchSelectedOrganizations(apiUuid);
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function fetchVisibilityData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    if (((0, _utils.hasPublisherRole)(userContext) || (0, _utils.hasOrgPublisherRole)(userContext)) && apiUuid && tabValue === 'visibility-tab') {
	      fetchVisibilityData();
	    }
	  }, [tabValue]);
	
	  (0, _react.useEffect)(function () {
	    setSelectedOrganizations(props.selectedOrganizations);
	  }, [props.selectedOrganizations]);
	
	  (0, _react.useEffect)(function () {
	    setPermission(getDefaultPermission());
	  }, [apiAccessStatus, props.selectedOrganizations, apiDetails]);
	
	  var onSearchListChange = function onSearchListChange(selectedOrg) {
	    setSelectedOrganizations([].concat(_toConsumableArray(selectedOrg)));
	    setIsUnsavedChanges(true);
	    localStorage.setItem('isUnSavedChanges', true);
	  };
	
	  var onChangePermission = function onChangePermission(e) {
	    setPermission(e.target.value);
	    setIsUnsavedChanges(true);
	    localStorage.setItem('isUnSavedChanges', true);
	  };
	
	  var onNextVisibility = function onNextVisibility() {
	    var accessStatus = selectedPermission === _labels.ID_PUBLIC ? _labels.API_ACCESS_STATUS_PUBLIC : _labels.API_ACCESS_STATUS_PRIVATE;
	    var canSaveOrgadminDev = userContext.orgAdmin || userContext.developer;
	    var dataToSave = [];
	    if (selectedPermission === _labels.ID_RESTRICTED || selectedPermission === _labels.ID_PRIVATE) {
	      (0, _lodash.map)(selectedOrganizations, function (object) {
	        dataToSave.push(object.uuid);
	      });
	    }
	    props.saveApiAccessStatus(accessStatus, apiUuid, canSaveOrgadminDev, dataToSave);
	  };
	
	  var onNext = function onNext() {
	    if (selectedPermission === _labels.ID_RESTRICTED && selectedOrganizations.length === 0) {
	      return false;
	    }
	    setIsUnsavedChanges(false);
	    localStorage.setItem('isUnSavedChanges', false);
	    onNextVisibility();
	    return true;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'api-visibility-container' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.pageTitle },
	      'API Visibility for Organizations'
	    ),
	    _react2.default.createElement(_components.RadioGroupSection, {
	      selected: selectedPermission,
	      onChange: onChangePermission,
	      data: data,
	      id: 'visibility-radio-group',
	      isDropDown: isDropDownOrg
	    }),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    selectedPermission === _labels.ID_RESTRICTED && _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _Grid2.default,
	        { md: 6, item: true },
	        _react2.default.createElement(_components.SearchTextListContainer, {
	          title: _labels.VISIBILITY_ORG_TITLE,
	          subtitle: _labels.VISIBILITY_ORG_SUB_TITLE,
	          placeHolderText: _labels.VISIBILITY_ORG_PLACE_HOLDER_TEXT,
	          defaultList: organizations,
	          defaultSelectedList: selectedOrganizations,
	          listId: 'organizations-list',
	          isCheckBoxVisible: true,
	          isLoadMore: isLoadMore,
	          onLoadMore: onLoadMore,
	          onSearchListChange: onSearchListChange,
	          userContext: userContext,
	          isDisableSelectedOption: true,
	          disableSelectedOptions: disableSelectedOptions
	        })
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { md: 6, item: true },
	        _react2.default.createElement(_components.SearchTextListContainer, {
	          title: _labels.VISIBILITY_SELECTED_ORG_TITLE,
	          subtitle: _labels.VISIBILITY_SELECTED_ORG_SUB_TITLE,
	          isSelectedNumberVisible: true,
	          placeHolderText: _labels.VISIBILITY_SELECTED_ORG_PLACE_HOLDER_TEXT,
	          defaultList: selectedOrganizations,
	          defaultSelectedList: selectedOrganizations,
	          listId: 'organizations-selected-list',
	          onSearchListChange: onSearchListChange,
	          isDeleteIconVisible: true,
	          userContext: userContext,
	          selectedItemErrorMessage: _labels.VISIBILITY_SELECTED_ITEM_ERROR_MESSAGE,
	          isDisableSelectedOption: true,
	          disableSelectedOptions: disableSelectedOptions
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      assistText: _labels.VISIBILITY_ASSIST_TEXT,
	      nextText: _labels.SAVE_AND_NEXT_TEXT,
	      onCancelClick: function onCancelClick() {
	        return onCancel(isUnsavedChanges);
	      },
	      id: 'visibility-form-buttons',
	      isDisabled: isDisabled
	    })
	  );
	}
	
	VisibilityPermission.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  userContext: _propTypes2.default.shape({}),
	  apiDetails: _propTypes2.default.shape({}),
	  selectedOrganizations: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  organizations: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiAccessStatus: _propTypes2.default.string,
	  onLoadMore: _propTypes2.default.func,
	  isLoadMore: _propTypes2.default.bool,
	  onCancel: _propTypes2.default.func,
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiUuid: _propTypes2.default.string,
	  tabValue: _propTypes2.default.string
	};

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultSelectedTabIndex = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.ApiEdit = ApiEdit;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(27);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _portalConfig = __webpack_require__(26);
	
	var _api = __webpack_require__(603);
	
	var _utils = __webpack_require__(18);
	
	var _api2 = __webpack_require__(202);
	
	var _components = __webpack_require__(17);
	
	var _edit = __webpack_require__(201);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _tabs = __webpack_require__(1574);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _labels = __webpack_require__(77);
	
	var _styles = __webpack_require__(1573);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PAGE_SIZE = '10';
	
	var getApiUuid = function getApiUuid(props) {
	  return (0, _lodash.get)(props, 'match.path') && ((0, _lodash.get)(props, 'match.path').includes('/edit/') || (0, _lodash.get)(props, 'match.path').includes('/permissions/')) && (0, _lodash.get)(props, 'match.params.apiUuid');
	};
	
	var getTabs = function getTabs(tabProps) {
	  return _tabs2.default.filter(function (_ref) {
	    var isHidden = _ref.isHidden;
	    return !(isHidden && isHidden(tabProps));
	  }).map(function (tab) {
	    return Object.assign({}, tab, {
	      disabled: tab.isDisabled && tab.isDisabled(tabProps)
	    });
	  });
	};
	
	var getDefaultSelectedTabIndex = exports.getDefaultSelectedTabIndex = function getDefaultSelectedTabIndex(tabs, match) {
	  var tabName = (0, _lodash.get)(match, 'params.tabName');
	  var index = (0, _lodash.findIndex)(tabs, function (tab) {
	    return tab.id === tabName;
	  });
	  // if none found default to 0
	  return index > 0 ? index : 0;
	};
	
	function ApiEdit(props) {
	  var _this = this;
	
	  var _props$userContext = props.userContext,
	      userContext = _props$userContext === undefined ? {} : _props$userContext,
	      canEdit = props.canEdit,
	      match = props.match,
	      organizationsPage = props.organizationsPage,
	      isError = props.isError,
	      isLoading = props.isLoading,
	      apiErrors = props.apiErrors,
	      customFields = props.customFields,
	      apiDetails = props.apiDetails,
	      assets = props.assets,
	      isApiSaveSuccess = props.isApiSaveSuccess,
	      useLegacyApiPages = props.useLegacyApiPages;
	
	  var apiUuid = getApiUuid(props) || '';
	
	  var headerRef = (0, _react.useRef)(null);
	
	  var getHelpItems = function getHelpItems(id) {
	    var helpItems = { title: '', descriptions: '', subItems: [] };
	    switch (id) {
	      case 'details-tab':
	        helpItems = _labels.HELPITEMS.detailsHelp;
	        break;
	      case 'custom-fields-tab':
	        helpItems = _labels.HELPITEMS.customFieldsHelp;
	        break;
	      case 'policy-templates-tab':
	        helpItems = _labels.HELPITEMS.policyTemplatesHelp;
	        break;
	      case 'spec-authentication-tab':
	        helpItems = _labels.HELPITEMS.specAuthenticationHelp;
	        break;
	      case 'management-tab':
	        {
	          helpItems = _labels.HELPITEMS.permissionsHelp;
	          if ((0, _utils.hasAdminRole)(userContext)) {
	            helpItems.subItems = helpItems.subItems.filter(function (item) {
	              return item.id !== 1;
	            });
	          }
	          break;
	        }
	      case 'visibility-tab':
	        {
	          helpItems = _labels.HELPITEMS.visibilityHelp;
	          if (!(0, _utils.hasPublisherRole)(userContext)) {
	            helpItems.subItems = helpItems.subItems.filter(function (item) {
	              return item.id !== 2;
	            });
	          }
	          break;
	        }
	      case 'tags-tab':
	        helpItems = _labels.HELPITEMS.tagsHelp;
	        break;
	      default:
	    }
	    return helpItems;
	  };
	
	  var getHeaderTitle = function getHeaderTitle() {
	    if (apiUuid) {
	      return 'Edit API: ' + apiDetails.name;
	    }
	    return 'Add API';
	  };
	
	  var _useState = (0, _react.useState)(_labels.ID_REST),
	      _useState2 = _slicedToArray(_useState, 2),
	      apiType = _useState2[0],
	      setApiType = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isDialogOpen = _useState4[0],
	      setIsDialogOpen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isCancelButton = _useState6[0],
	      setIsCancelButton = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(_labels.UNSAVED_DIALOG_EXIT_TEXT),
	      _useState8 = _slicedToArray(_useState7, 2),
	      dialogSubmitText = _useState8[0],
	      setDialogSubmitText = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      notificationMessage = _useState10[0],
	      setNotificationMessage = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      notificationStatus = _useState12[0],
	      setNotificationStatus = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      isLoadMore = _useState14[0],
	      setIsLoadMore = _useState14[1];
	
	  var _useState15 = (0, _react.useState)([]),
	      _useState16 = _slicedToArray(_useState15, 2),
	      errors = _useState16[0],
	      setErrors = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(getTabs({
	    userContext: userContext, apiUuid: apiUuid, apiType: apiType, customFields: customFields, apiDetails: apiDetails, useLegacyApiPages: useLegacyApiPages })),
	      _useState18 = _slicedToArray(_useState17, 2),
	      tabs = _useState18[0],
	      setTabs = _useState18[1];
	
	  var defaultIndex = getDefaultSelectedTabIndex(tabs, match);
	
	  var _useState19 = (0, _react.useState)(defaultIndex),
	      _useState20 = _slicedToArray(_useState19, 2),
	      tabIndex = _useState20[0],
	      setTabIndex = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(tabs[defaultIndex].tabId),
	      _useState22 = _slicedToArray(_useState21, 2),
	      currentTab = _useState22[0],
	      setCurrentTab = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(tabs[defaultIndex].tabId),
	      _useState24 = _slicedToArray(_useState23, 2),
	      redirectTabValue = _useState24[0],
	      setRedirectTabValue = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(getHelpItems(tabs[defaultIndex].tabId)),
	      _useState26 = _slicedToArray(_useState25, 2),
	      helpItems = _useState26[0],
	      setHelpItems = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(getHeaderTitle()),
	      _useState28 = _slicedToArray(_useState27, 2),
	      headerTitle = _useState28[0],
	      setHeaderTitle = _useState28[1];
	
	  var fetchInit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              localStorage.setItem('isSaveApi', false);
	              localStorage.setItem('isUnSavedChanges', false);
	              _context.next = 4;
	              return props.fetchCustomFields();
	
	            case 4:
	              _context.next = 6;
	              return props.fetchApiEulas();
	
	            case 6:
	              _context.next = 8;
	              return props.fetchPolicyTemplates();
	
	            case 8:
	              _context.next = 10;
	              return props.fetchAllTags();
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function fetchInit() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var fetchApiData = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return props.fetchApi(apiUuid);
	
	            case 2:
	              _context2.next = 4;
	              return props.fetchAssets(apiUuid);
	
	            case 4:
	              _context2.next = 6;
	              return props.fetchUsage(apiUuid);
	
	            case 6:
	              _context2.next = 8;
	              return props.fetchApiPermitted(apiUuid);
	
	            case 8:
	              _context2.next = 10;
	              return props.fetchAPITags(apiUuid);
	
	            case 10:
	              if (!((0, _utils.hasPublisherRole)(userContext) || (0, _utils.hasOrgPublisherRole)(userContext))) {
	                _context2.next = 13;
	                break;
	              }
	
	              _context2.next = 13;
	              return props.fetchOrganizations(PAGE_SIZE, 0);
	
	            case 13:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    return function fetchApiData() {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    if (!apiUuid && userContext.permissions && userContext.permissions.API && !userContext.permissions.API.includes('CREATE')) {
	      props.push('/404');
	    }
	  }, [userContext]);
	
	  (0, _react.useEffect)(function () {
	    fetchInit();
	    if (apiUuid) {
	      if ((0, _utils.hasOrgPublisherRole)(userContext) && tabs[tabIndex].id === 'management') {
	        props.push('/404');
	      }
	      fetchApiData();
	    }
	  }, [apiUuid]);
	
	  (0, _react.useEffect)(function () {
	    if (apiUuid && (!canEdit || userContext.permissions.API && !userContext.permissions.API.includes('UPDATE'))) {
	      props.push('/404');
	    }
	  }, [canEdit]);
	
	  (0, _react.useEffect)(function () {
	    setHeaderTitle(getHeaderTitle());
	  }, [apiDetails]);
	
	  (0, _react.useEffect)(function () {
	    var filterTabs = getTabs({
	      userContext: userContext, apiUuid: apiUuid, apiType: apiType, customFields: customFields, apiDetails: apiDetails, useLegacyApiPages: useLegacyApiPages
	    });
	    setTabs(filterTabs);
	    setTabIndex(getDefaultSelectedTabIndex(filterTabs, match));
	  }, [apiUuid, apiType, customFields, apiDetails]);
	  (0, _react.useEffect)(function () {
	    var _tabs$tabIndex = tabs[tabIndex],
	        id = _tabs$tabIndex.id,
	        tabId = _tabs$tabIndex.tabId;
	
	    setCurrentTab(tabId);
	    setHelpItems(getHelpItems(tabId));
	
	    if (id === 'tags' && apiDetails.apiServiceType === _labels.REST_TYPE) {
	      props.fetchSwaggerFile(apiUuid);
	    }
	  }, [tabIndex, tabs]);
	
	  (0, _react.useEffect)(function () {
	    setIsLoadMore(organizationsPage.currentPage < organizationsPage.totalPages - 1);
	  }, [organizationsPage]);
	
	  var notifyMessages = function notifyMessages(message, status) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  var setStateTabs = function setStateTabs(value) {
	    setTabIndex(tabs.findIndex(function (_ref4) {
	      var tabId = _ref4.tabId;
	      return tabId === value;
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    if (isApiSaveSuccess) {
	      setErrors([]);
	      switch (currentTab) {
	        case 'details-tab':
	          if (apiDetails.uuid) {
	            props.fetchApi(apiDetails.uuid);
	            props.fetchAssets(apiDetails.uuid);
	            props.fetchUsage(apiDetails.uuid);
	          }
	          if (!(0, _lodash.isEmpty)(customFields) && apiDetails.publishedByPortal) {
	            setStateTabs('custom-fields-tab');
	            props.push('/publish/apis/edit/' + apiDetails.uuid + '/custom-fields');
	          } else if (apiDetails.publishedByPortal === false) {
	            if ((0, _utils.hasPublisherRole)(userContext)) {
	              setStateTabs('management-tab');
	              props.push('/publish/apis/edit/' + apiDetails.uuid + '/management');
	            } else {
	              setStateTabs('visibility-tab');
	              props.push('/publish/apis/edit/' + apiDetails.uuid + '/visibility');
	            }
	          } else {
	            setStateTabs('policy-templates-tab');
	            props.push('/publish/apis/edit/' + apiDetails.uuid + '/policy-templates');
	          }
	          notifyMessages(apiUuid ? _labels.API_DETAILS_UPDATE_SUCCESS : _labels.API_DETAILS_SAVE_SUCCESS, _labels.SUCCESS_TEXT);
	          window.scrollTo(0, headerRef.offsetTop);
	          break;
	        case 'custom-fields-tab':
	          setStateTabs('policy-templates-tab');
	          props.push('/publish/apis/edit/' + apiDetails.uuid + '/policy-templates');
	          notifyMessages(_labels.API_CUSTOM_FIELDS_UPDATE_SUCCESS, _labels.SUCCESS_TEXT);
	          window.scrollTo(0, headerRef.offsetTop);
	          break;
	        case 'policy-templates-tab':
	          props.fetchApi(apiDetails.uuid); // TODO: Re-fetch the API in store
	          if (apiDetails.apiServiceType === _labels.REST_TYPE) {
	            setStateTabs('spec-authentication-tab');
	            props.push('/publish/apis/edit/' + apiDetails.uuid + '/spec-authentication');
	          } else if ((0, _utils.hasPublisherRole)(userContext)) {
	            setStateTabs('management-tab');
	            props.push('/publish/apis/edit/' + apiDetails.uuid + '/management');
	          } else {
	            setStateTabs('visibility-tab');
	            props.push('/publish/apis/edit/' + apiDetails.uuid + '/visibility');
	          }
	          notifyMessages(_labels.POLICY_TEMPLATE_SAVE_SUCCESS, _labels.SUCCESS_TEXT);
	          window.scrollTo(0, headerRef.offsetTop);
	          break;
	        case 'spec-authentication-tab':
	          props.fetchApi(apiDetails.uuid);
	          if ((0, _utils.hasPublisherRole)(userContext)) {
	            setStateTabs('management-tab');
	            props.push('/publish/apis/edit/' + apiDetails.uuid + '/management');
	          } else {
	            setStateTabs('visibility-tab');
	            props.push('/publish/apis/edit/' + apiDetails.uuid + '/visibility');
	          }
	          notifyMessages(_labels.SPEC_AUTHENTICATION_SAVE_SUCCESS, _labels.SUCCESS_TEXT);
	          window.scrollTo(0, headerRef.offsetTop);
	          break;
	        case 'management-tab':
	          props.fetchApi(apiDetails.uuid);
	          setStateTabs('visibility-tab');
	          props.push('/publish/apis/edit/' + apiDetails.uuid + '/visibility');
	          notifyMessages(_labels.MANAGEMENT_SAVE_SUCCESS, _labels.SUCCESS_TEXT);
	          window.scrollTo(0, headerRef.offsetTop);
	          break;
	        case 'visibility-tab':
	          props.fetchApi(apiDetails.uuid); // TODO: Re-fetch the API in store
	          setStateTabs('tags-tab');
	          props.push('/publish/apis/edit/' + apiDetails.uuid + '/tags');
	          notifyMessages(_labels.VISIBILITY_SAVE_SUCCESS, _labels.SUCCESS_TEXT);
	          window.scrollTo(0, headerRef.offsetTop);
	          break;
	        case 'tags-tab':
	          localStorage.setItem('isSaveApi', true);
	          props.fetchApi(apiDetails.uuid);
	          window.location.href = '/publish/apis/details/' + apiDetails.uuid;
	          notifyMessages(_labels.TAGS_ASSOCIATION_SAVE_SUCCESS, _labels.SUCCESS_TEXT);
	          window.scrollTo(0, headerRef.offsetTop);
	          break;
	        default:
	          break;
	      }
	    }
	  }, [isApiSaveSuccess]);
	
	  (0, _react.useEffect)(function () {
	    if (isError) {
	      notifyMessages(_labels.ERROR_TITLE_TEXT, _labels.ERROR_TEXT);
	      if (apiErrors.length > 0) {
	        setErrors(apiErrors);
	      }
	    }
	  }, [isError, apiErrors]);
	
	  var onLoadMore = function onLoadMore() {
	    var currentPage = organizationsPage.currentPage + 1;
	    props.fetchOrganizations(PAGE_SIZE, currentPage);
	  };
	
	  var redirectTab = function redirectTab(value) {
	    setStateTabs(value);
	    notifyMessages('', '');
	    setErrors([]);
	    var tIndex = tabs.findIndex(function (_ref5) {
	      var tabId = _ref5.tabId;
	      return tabId === value;
	    });
	    var id = tabs[tIndex].id;
	
	    props.push('/publish/apis/edit/' + apiDetails.uuid + '/' + id);
	  };
	
	  var onDialogClose = function onDialogClose() {
	    setIsDialogOpen(false);
	    setDialogSubmitText(_labels.UNSAVED_DIALOG_EXIT_TEXT);
	  };
	
	  var onDialogSubmit = function onDialogSubmit() {
	    localStorage.setItem('isUnSavedChanges', false);
	    setDialogSubmitText(_labels.UNSAVED_DIALOG_EXIT_TEXT);
	    if (isCancelButton) {
	      setIsCancelButton(false);
	      window.location.href = tabs[tabIndex].id === 'details' ? '/publish/apis' : '/publish/apis/details/' + apiUuid;
	    } else {
	      setIsDialogOpen(false);
	      redirectTab(redirectTabValue);
	    }
	  };
	
	  var onCancel = function onCancel(isUnsavedChanges) {
	    if (isUnsavedChanges) {
	      setIsDialogOpen(true);
	      setIsCancelButton(true);
	    } else {
	      window.location.href = '/publish/apis/details/' + apiUuid;
	    }
	  };
	
	  var onCancelDetails = function onCancelDetails(isUnsavedChanges) {
	    if (isUnsavedChanges) {
	      setIsDialogOpen(true);
	      setIsCancelButton(true);
	    } else {
	      window.location.href = '/publish/apis/';
	    }
	  };
	
	  var handleTabChange = function handleTabChange(e, value) {
	    if (currentTab === value) {
	      return;
	    }
	    var hasUnsavedChanges = localStorage.getItem('isUnSavedChanges');
	    if (hasUnsavedChanges === 'true') {
	      setIsCancelButton(false);
	      setDialogSubmitText(_labels.UNSAVED_DIALOG_SUBMIT_TEXT);
	      setIsDialogOpen(true);
	      setRedirectTabValue(value);
	    } else {
	      redirectTab(value);
	    }
	  };
	
	  return _react2.default.createElement(_edit2.default, {
	    editPageId: 'api-edit-page',
	    dialogId: 'api-unsaved-dialog',
	    isDialogOpen: isDialogOpen,
	    onDialogClose: onDialogClose,
	    dialogSubmitText: dialogSubmitText,
	    onDialogSubmit: onDialogSubmit,
	    isLoading: isLoading,
	    leftSidebarId: 'api-left-sidebar',
	    mainContentId: 'api-main-content',
	    notificationId: 'api-notifications',
	    notificationStatus: notificationStatus,
	    setNotificationStatus: setNotificationMessage,
	    notificationMessage: notificationMessage,
	    setNotificationMessage: setNotificationMessage,
	    tabsContainer: _react2.default.createElement(_components.TabsContainer, {
	      useTabId: true,
	      tabValue: currentTab,
	      tabItems: tabs,
	      handleTabChange: handleTabChange
	    }),
	    pageHeaderRef: headerRef,
	    pageHeaderTitle: headerTitle,
	    pageContent: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      tabs.map(function (_ref6) {
	        var tabId = _ref6.tabId,
	            tabPanel = _ref6.tabPanel;
	        return _react2.default.createElement(
	          _components.TabPanel,
	          {
	            id: tabId + '-panel',
	            visible: currentTab === tabId,
	            key: tabId
	          },
	          tabPanel(Object.assign({}, props, {
	            apiUuid: apiUuid,
	            apiDetails: apiDetails,
	            assets: assets,
	            tabValue: currentTab,
	            isLoadMore: isLoadMore,
	            errors: errors,
	            onLoadMore: onLoadMore,
	            onCancel: onCancel,
	            apiType: apiType,
	            setApiType: setApiType,
	            onCancelDetails: onCancelDetails,
	            notifyMessages: notifyMessages,
	            visible: currentTab === tabId,
	            onTabChange: handleTabChange
	          }))
	        );
	      })
	    ),
	    rightSidebarId: 'permissions-right-sidebar',
	    helpItems: helpItems
	  });
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userContext: (0, _portalConfig.getUserDetails)(state),
	    apiPortalStatus: (0, _api2.getApiPortalStatus)(state),
	    canEdit: (0, _api2.getApiCanEditPermitted)(state),
	    organizations: (0, _api2.getOrganizations)(state),
	    selectedOrganizations: (0, _api2.getSelectedOrganizations)(state),
	    apiAccessStatus: (0, _api2.getApiAccessStatus)(state),
	    organizationsPage: (0, _api2.getOrganizationsPage)(state),
	    users: (0, _api2.getAvailableUsers)(state),
	    selectedUsers: (0, _api2.getSelectedUsers)(state),
	    defaultSelectedUsers: (0, _api2.getDefaultSelectedUsers)(state),
	    allPortalTags: (0, _api2.getAllPortalTags)(state),
	    apiTags: (0, _api2.getAPITags)(state),
	    newTags: (0, _api2.getNewTags)(state),
	    swaggerData: (0, _api2.getAPISwaggerData)(state),
	    apiErrors: (0, _api2.getErrors)(state),
	    isError: (0, _api2.getIsError)(state),
	    isLoading: (0, _api2.getIsLoading)(state),
	    assets: (0, _api2.getAssets)(state),
	    usage: (0, _api2.getUsage)(state),
	    customFields: (0, _api2.getCustomFields)(state),
	    eulas: (0, _api2.getEulas)(state),
	    isApiNameUnique: (0, _api2.getIsApiNameUnique)(state),
	    managedGateways: (0, _api2.getManagedGateways)(state),
	    isProxyUrlUnique: (0, _api2.getIsProxyUrlUnique)(state),
	    apiDetails: (0, _api2.getApiDetails)(state),
	    isApiSaveSuccess: (0, _api2.getIsSaveApiSuccess)(state),
	    policyTemplates: (0, _api2.getPolicyTemplates)(state),
	    publisherOrgs: (0, _api2.getPublisherOrganizations)(state),
	    defaultSelectedManageOrg: (0, _api2.getSelectedManageOrg)(state),
	    useLegacyApiPages: (0, _portalConfig.getUseLegacyApiPages)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchAvailableUsers: _api.fetchAvailableUsers,
	  fetchApi: _api.fetchApi,
	  push: _connectedReactRouter.push,
	  fetchSelectedUsers: _api.fetchSelectedUsers,
	  fetchApiPermitted: _api.fetchApiPermitted,
	  fetchOrganizations: _api.fetchOrganizations,
	  fetchSelectedOrganizations: _api.fetchSelectedOrganizations,
	  fetchAllTags: _api.fetchAllTags,
	  fetchAPITags: _api.fetchAPITags,
	  fetchSwaggerFile: _api.fetchSwaggerFile,
	  showLoading: _api.showLoading,
	  saveApiAccessStatus: _api.saveApiAccessStatus,
	  savePermissions: _api.savePermissions,
	  saveTagsAssociation: _api.saveTagsAssociation,
	  createTags: _api.createTags,
	  fetchApiEulas: _api.fetchApiEulas,
	  checkApiNameUnique: _api.checkApiNameUnique,
	  checkProxyUrlUnique: _api.checkProxyUrlUnique,
	  saveApi: _api.saveApi,
	  updateApi: _api.updateApi,
	  updateApiDetails: _api.updateApiDetails,
	  updateApiDetailsWithAssets: _api.updateApiDetailsWithAssets,
	  fetchAssets: _api.fetchAssets,
	  fetchUsage: _api.fetchUsage,
	  fetchCustomFields: _api.fetchCustomFields,
	  saveApiCustomFields: _api.saveApiCustomFields,
	  fetchPolicyTemplates: _api.fetchPolicyTemplates,
	  saveApiPolicyEntities: _api.saveApiPolicyEntities,
	  publishApi: _api.publishApi,
	  fetchAllOrganizations: _api.fetchAllOrganizations,
	  fetchSelectedManageOrg: _api.fetchSelectedManageOrg
	};
	
	ApiEdit.propTypes = {
	  userContext: _propTypes2.default.shape({
	    orgAdmin: _propTypes2.default.bool,
	    developer: _propTypes2.default.bool,
	    firstName: _propTypes2.default.string,
	    lastName: _propTypes2.default.string,
	    uuid: _propTypes2.default.string
	  }),
	  organizationsPage: _propTypes2.default.shape({
	    currentPage: _propTypes2.default.number
	  }),
	  isError: _propTypes2.default.bool,
	  apiErrors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  assets: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  customFields: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  match: _propTypes2.default.shape({
	    params: _propTypes2.default.shape({
	      tabId: _propTypes2.default.string,
	      apiUuid: _propTypes2.default.string
	    })
	  }),
	  isLoading: _propTypes2.default.bool,
	  apiDetails: _propTypes2.default.shape({}),
	  isApiSaveSuccess: _propTypes2.default.bool,
	  canEdit: _propTypes2.default.bool,
	  useLegacyApiPages: _propTypes2.default.bool
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ApiEdit);

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    pageTitle: {
	      color: (0, _lodash.get)(color, 'pageTitle'),
	      fontFamily: (0, _lodash.get)(typography, 'pageTitle'),
	      fontSize: (0, _lodash.get)(fontSize, 'pageTitle'),
	      marginTop: 6
	    },
	    sectionTitle: {
	      color: (0, _lodash.get)(color, 'pageTitle'),
	      fontFamily: (0, _lodash.get)(typography, 'pageTitle'),
	      fontSize: (0, _lodash.get)(fontSize, 'sectionTitle')
	    },
	    apiTypeContainer: {
	      marginTop: 20,
	      marginBottom: 10
	    },
	    expandContainer: {
	      marginTop: 10,
	      marginBottom: 10
	    },
	    expandManualContainer: {
	      cursor: 'pointer'
	    },
	    manualContainer: {
	      width: '90%',
	      float: 'left',
	      fontSize: (0, _lodash.get)(fontSize, 'sectionTitle'),
	      margin: 0
	    },
	    expandIconContainer: {
	      color: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      paddingTop: 6
	    },
	    comboBoxContainer: {
	      marginTop: 10,
	      marginBottom: 10
	    },
	    fileConatiner: {
	      marginTop: 10,
	      marginBottom: 10
	    },
	    selectedFileContainer: {
	      marginTop: 20,
	      marginBottom: 20
	    },
	    formLabel: {
	      display: 'inline',
	      fontSize: (0, _lodash.get)(fontSize, 'smallTitle'),
	      float: 'unset'
	    },
	    apiServiceType: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      padding: '10px 0'
	    },
	    uploadFileSection: {
	      backgroundColor: (0, _lodash.get)(color, 'grayLight'),
	      color: (0, _lodash.get)(color, 'bodyText'),
	      marginBottom: 5
	    },
	    deleteIcon: {
	      float: 'right',
	      fontSize: '1.3rem'
	    },
	    swaggerSelectButton: {
	      color: (0, _lodash.get)(color, 'link'),
	      height: 'auto',
	      lineHeight: 1,
	      padding: 0,
	      margin: 0
	    },
	    error: {
	      color: (0, _lodash.get)(color, 'error'),
	      paddingTop: 10
	    },
	    detailDivider: {
	      width: '98%',
	      backgroundColor: (0, _lodash.get)(color, 'borderColor')
	    },
	    statusContainer: {
	      marginTop: 10,
	      marginBottom: 10
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isEmpty = __webpack_require__(35);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Details = __webpack_require__(1566);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _CustomFields = __webpack_require__(1565);
	
	var _CustomFields2 = _interopRequireDefault(_CustomFields);
	
	var _PolicyTemplates = __webpack_require__(1568);
	
	var _PolicyTemplates2 = _interopRequireDefault(_PolicyTemplates);
	
	var _SpecAuthentication = __webpack_require__(1569);
	
	var _SpecAuthentication2 = _interopRequireDefault(_SpecAuthentication);
	
	var _VisibilityPermissions = __webpack_require__(1571);
	
	var _VisibilityPermissions2 = _interopRequireDefault(_VisibilityPermissions);
	
	var _ManagementPermissions = __webpack_require__(1567);
	
	var _ManagementPermissions2 = _interopRequireDefault(_ManagementPermissions);
	
	var _Tags = __webpack_require__(1570);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _utils = __webpack_require__(18);
	
	var _labels = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isApiIncomplete = function isApiIncomplete(apiDetails) {
	  return apiDetails.portalStatus === _labels.API_PUBLISH_STATE_INCOMPLETE;
	};
	
	var isAPINew = function isAPINew(apiDetails) {
	  return apiDetails.portalStatus === _labels.API_PUBLISH_STATE_NEW;
	};
	
	var isPublishedByGateway = function isPublishedByGateway(apiDetails) {
	  return apiDetails.publishedByPortal === undefined ? false : !apiDetails.publishedByPortal;
	};
	
	exports.default = [{
	  id: 'details',
	  tabId: 'details-tab',
	  label: 'Details',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_Details2.default, props);
	  },
	  onCancel: function onCancel() {
	    window.location.href = '/publish/apis';
	  },
	  isHidden: function isHidden(_ref) {
	    var useLegacyApiPages = _ref.useLegacyApiPages;
	    return useLegacyApiPages;
	  }
	}, {
	  id: 'custom-fields',
	  tabId: 'custom-fields-tab',
	  label: 'Custom Fields',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_CustomFields2.default, props);
	  },
	  isDisabled: function isDisabled(_ref2) {
	    var apiUuid = _ref2.apiUuid;
	    return !apiUuid;
	  },
	  isHidden: function isHidden(_ref3) {
	    var customFields = _ref3.customFields,
	        useLegacyApiPages = _ref3.useLegacyApiPages,
	        apiDetails = _ref3.apiDetails;
	    return (0, _isEmpty2.default)(customFields) || useLegacyApiPages || isPublishedByGateway(apiDetails);
	  }
	}, {
	  id: 'policy-templates',
	  tabId: 'policy-templates-tab',
	  label: 'Policy Templates',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_PolicyTemplates2.default, props);
	  },
	  isHidden: function isHidden(_ref4) {
	    var apiDetails = _ref4.apiDetails,
	        useLegacyApiPages = _ref4.useLegacyApiPages;
	    return isPublishedByGateway(apiDetails) || useLegacyApiPages;
	  },
	  isDisabled: function isDisabled(_ref5) {
	    var apiUuid = _ref5.apiUuid;
	    return !apiUuid;
	  }
	}, {
	  id: 'spec-authentication',
	  tabId: 'spec-authentication-tab',
	  label: 'Spec Authentication',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_SpecAuthentication2.default, props);
	  },
	  isHidden: function isHidden(_ref6) {
	    var apiType = _ref6.apiType,
	        apiDetails = _ref6.apiDetails,
	        useLegacyApiPages = _ref6.useLegacyApiPages;
	    return apiType === _labels.ID_SOAP || isPublishedByGateway(apiDetails) || useLegacyApiPages;
	  },
	  isDisabled: function isDisabled(_ref7) {
	    var apiUuid = _ref7.apiUuid,
	        apiDetails = _ref7.apiDetails;
	    return !apiUuid || isApiIncomplete(apiDetails);
	  }
	}, {
	  id: 'management',
	  tabId: 'management-tab',
	  label: 'Management Permissions',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_ManagementPermissions2.default, props);
	  },
	  isHidden: function isHidden(_ref8) {
	    var userContext = _ref8.userContext;
	    return !(0, _utils.hasPublisherRole)(userContext);
	  },
	  isDisabled: function isDisabled(_ref9) {
	    var apiUuid = _ref9.apiUuid,
	        apiDetails = _ref9.apiDetails;
	    return !apiUuid || isApiIncomplete(apiDetails) || isAPINew(apiDetails);
	  }
	}, {
	  id: 'visibility',
	  tabId: 'visibility-tab',
	  label: 'Visibility Permissions',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_VisibilityPermissions2.default, props);
	  },
	  isHidden: false,
	  isDisabled: function isDisabled(_ref10) {
	    var apiUuid = _ref10.apiUuid,
	        apiDetails = _ref10.apiDetails;
	    return !apiUuid || isApiIncomplete(apiDetails) || isAPINew(apiDetails);
	  }
	}, {
	  id: 'tags',
	  tabId: 'tags-tab',
	  label: 'Tags',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_Tags2.default, props);
	  },
	  isHidden: false,
	  isDisabled: function isDisabled(_ref11) {
	    var apiUuid = _ref11.apiUuid,
	        apiDetails = _ref11.apiDetails;
	    return !apiUuid || isApiIncomplete(apiDetails) || isAPINew(apiDetails);
	  }
	}];

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _reactIntl = __webpack_require__(16);
	
	var _core = __webpack_require__(3);
	
	var _Divider = __webpack_require__(91);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Card = __webpack_require__(129);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContent = __webpack_require__(130);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _Typography = __webpack_require__(43);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Close = __webpack_require__(141);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _Check = __webpack_require__(113);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1576);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getGatewayApiCount = function getGatewayApiCount(gatewayApiSyncLog, selectedCount) {
	  try {
	    return JSON.parse(gatewayApiSyncLog).deployReqCount;
	  } catch (e) {
	    return selectedCount;
	  }
	};
	
	var getPortalApiCount = function getPortalApiCount(gatewayApiSyncLog) {
	  try {
	    return JSON.parse(gatewayApiSyncLog).portalApiCount;
	  } catch (e) {
	    return 0;
	  }
	};
	
	var DetailCardRaw = function DetailCardRaw(_ref) {
	  var details = _ref.details,
	      title = _ref.title,
	      titleIcon = _ref.titleIcon,
	      totalCount = _ref.totalCount,
	      _ref$selectedCount = _ref.selectedCount,
	      selectedCount = _ref$selectedCount === undefined ? 0 : _ref$selectedCount,
	      portalApis = _ref.portalApis,
	      portalPublishedCount = _ref.portalPublishedCount,
	      gatewayPublishedCount = _ref.gatewayPublishedCount,
	      _ref$displayLastSync = _ref.displayLastSync,
	      displayLastSync = _ref$displayLastSync === undefined ? true : _ref$displayLastSync,
	      _ref$displayProxyCoun = _ref.displayProxyCount,
	      displayProxyCount = _ref$displayProxyCoun === undefined ? true : _ref$displayProxyCoun,
	      classes = _ref.classes;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var lastDeployedDate = portalApis.results.length > 0 ? portalApis.results[0].lastTimeDeployedDate : null;
	  var lastSyncDateTime = lastDeployedDate ? new Date(lastDeployedDate).toString() : 'NA';
	  var portalCount = totalCount;
	  var gatewayApiSyncLog = (0, _lodash.get)(details, 'GatewayApiSyncLog');
	  var gatewayApiCount = getGatewayApiCount(gatewayApiSyncLog, selectedCount);
	  var portalApiCount = getPortalApiCount(gatewayApiSyncLog);
	  var totalProxyCount = gatewayApiCount + portalApiCount;
	  var outSync = !(parseInt(portalCount, 10) === parseInt(totalProxyCount, 10));
	
	  return _react2.default.createElement(
	    _Card2.default,
	    { 'data-apim-test': 'proxy-details-api-card', className: classes.card },
	    _react2.default.createElement(
	      _CardContent2.default,
	      null,
	      _react2.default.createElement(
	        _Typography2.default,
	        { component: 'h3', className: classes.title, gutterBottom: true },
	        _react2.default.createElement(
	          'span',
	          { className: classes.titleIcon },
	          titleIcon
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: classes.titleText },
	          title
	        )
	      ),
	      _react2.default.createElement(_Divider2.default, { className: classes.divider }),
	      _react2.default.createElement(
	        _react.Fragment,
	        null,
	        displayLastSync && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { component: 'div', className: classes.lastSync },
	            _react2.default.createElement(
	              'h4',
	              null,
	              (0, _intl.getI18nFormattedMessage)('label.proxy.details.api.last.deployed')
	            )
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { component: 'div', 'data-apim-test': 'proxy-details-api-card-date', className: classes.lastSync },
	            _react2.default.createElement(
	              'span',
	              { className: classes.iconStatusText },
	              lastSyncDateTime
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { component: 'div', 'data-apim-test': 'proxy-details-api-card-description', className: classes.description },
	          _react2.default.createElement(
	            'span',
	            { className: classes.iconStatus },
	            _react2.default.createElement(_Check2.default, { style: { fontSize: 16, color: 'green' } })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: classes.iconStatusText },
	            intl.getI18nMessage('label.proxy.details.api.portal'),
	            ': ',
	            portalCount
	          ),
	          _react2.default.createElement(
	            _core.Tooltip,
	            {
	              'data-apim-test': 'proxy-details-api-card-portal-helptext',
	              title: (0, _intl.getI18nFormattedMessage)('label.proxy.details.api.card.helptext'),
	              arrow: true, placement: 'right'
	            },
	            _react2.default.createElement(_Help2.default, { className: classes.helpIcon })
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { component: 'div', 'data-apim-test': 'proxy-details-api-card-count-container' },
	            _react2.default.createElement(
	              'span',
	              { className: classes.publishText, 'data-apim-test': 'proxy-details-api-card-portal-container' },
	              intl.getI18nMessage('label.proxy.details.api.portal.published') + ': ' + portalPublishedCount
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: classes.publishText, 'data-apim-test': 'proxy-details-api-card-gateway-container' },
	              intl.getI18nMessage('label.proxy.details.api.gateway.published') + ': ' + gatewayPublishedCount
	            )
	          )
	        ),
	        displayProxyCount && _react2.default.createElement(
	          _Typography2.default,
	          { component: 'div', className: classes.description, 'data-apim-test': 'proxy-details-api-card-proxy-container' },
	          _react2.default.createElement(
	            'span',
	            { className: classes.iconStatus },
	            outSync ? _react2.default.createElement(_Close2.default, { className: classes.errorIconRoot }) : _react2.default.createElement(_Check2.default, { className: classes.successIconRoot })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: classes.iconStatusText },
	            totalProxyCount + ' ' + intl.getI18nMessage('label.proxy.details.api.proxy')
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { component: 'div', 'data-apim-test': 'proxy-details-api-card-proxy-count-container' },
	            _react2.default.createElement(
	              'span',
	              { className: classes.publishText, 'data-apim-test': 'proxy-details-api-card-proxy-portal-container' },
	              intl.getI18nMessage('label.proxy.details.api.portal.published') + ': ' + portalApiCount
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: classes.publishText, 'data-apim-test': 'proxy-details-api-card-proxy-gateway-container' },
	              intl.getI18nMessage('label.proxy.details.api.gateway.published') + ': ' + gatewayApiCount
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	DetailCardRaw.propTypes = {
	  details: _propTypes2.default.shape({}),
	  title: _propTypes2.default.string,
	  titleIcon: _propTypes2.default.node,
	  totalCount: _propTypes2.default.number,
	  portalApis: _propTypes2.default.shape({}),
	  portalPublishedCount: _propTypes2.default.number,
	  gatewayPublishedCount: _propTypes2.default.number,
	  selectedCount: _propTypes2.default.number,
	  displayLastSync: _propTypes2.default.bool,
	  displayProxyCount: _propTypes2.default.bool,
	  classes: _propTypes2.default.shape({})
	};
	
	DetailCardRaw.displayName = 'ApiCard';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(DetailCardRaw);

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    card: {
	      width: '19%',
	      display: 'inline-block',
	      margin: '0.5%',
	      verticalAlign: 'top',
	      minHeight: 260,
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground')
	    },
	    title: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.title')
	    },
	    titleText: {
	      paddingLeft: 10
	    },
	    titleIcon: {
	      verticalAlign: 'middle',
	      '& svg': {
	        fontSize: (0, _lodash.get)(theme, 'fontSize.title')
	      }
	    },
	    divider: {
	      marginTop: 4,
	      backgroundColor: (0, _lodash.get)(theme, 'color.borderColor')
	    },
	    description: {
	      marginBottom: 12,
	      marginTop: 12,
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      '& svg': {
	        verticalAlign: 'text-top'
	      }
	    },
	    lastSync: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      marginTop: 5,
	      '& h4': {
	        marginTop: 10,
	        marginBottom: 5
	      }
	    },
	    lastSyncDescription: {
	      color: (0, _lodash.get)(theme, 'color.smallText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.smallText')
	    },
	    errorIconRoot: {
	      color: (0, _lodash.get)(theme, 'color.error'),
	      width: 16,
	      height: 16
	    },
	    successIconRoot: {
	      color: (0, _lodash.get)(theme, 'color.success'),
	      width: 16,
	      height: 16
	    },
	    iconStatus: {
	      paddingRight: 5,
	      verticalAlign: 'middle'
	    },
	    iconStatusText: {
	      verticalAlign: 'middle'
	    },
	    publishText: {
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText'),
	      marginRight: 15
	    },
	    helpIcon: {
	      fontSize: 12,
	      margin: (0, _lodash.get)(theme, 'margin.m4'),
	      verticalAlign: 'inherit',
	      cursor: 'pointer',
	      color: (0, _lodash.get)(theme, 'color.link') + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(3);
	
	var _Divider = __webpack_require__(91);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Card = __webpack_require__(129);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContent = __webpack_require__(130);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _Typography = __webpack_require__(43);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Close = __webpack_require__(141);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _Check = __webpack_require__(113);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _intl = __webpack_require__(15);
	
	var _prettycronOverride = __webpack_require__(1714);
	
	var _prettycronOverride2 = _interopRequireDefault(_prettycronOverride);
	
	var _ExpandableList = __webpack_require__(605);
	
	var _ExpandableList2 = _interopRequireDefault(_ExpandableList);
	
	var _styles = __webpack_require__(1578);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailCardRaw = function DetailCardRaw(_ref) {
	  var details = _ref.details,
	      title = _ref.title,
	      titleIcon = _ref.titleIcon,
	      totalCount = _ref.totalCount,
	      _ref$selectedCount = _ref.selectedCount,
	      selectedCount = _ref$selectedCount === undefined ? 0 : _ref$selectedCount,
	      _ref$selectedList = _ref.selectedList,
	      selectedList = _ref$selectedList === undefined ? [] : _ref$selectedList,
	      keySyncLog = _ref.keySyncLog,
	      keySyncTime = _ref.keySyncTime,
	      keySyncDisruption = _ref.keySyncDisruption,
	      lastSyncErrorMsg = _ref.lastSyncErrorMsg,
	      _ref$displayLastSync = _ref.displayLastSync,
	      displayLastSync = _ref$displayLastSync === undefined ? true : _ref$displayLastSync,
	      _ref$displayProxyCoun = _ref.displayProxyCount,
	      displayProxyCount = _ref$displayProxyCoun === undefined ? true : _ref$displayProxyCoun,
	      _ref$displayPortalCou = _ref.displayPortalCount,
	      displayPortalCount = _ref$displayPortalCou === undefined ? true : _ref$displayPortalCou,
	      _ref$displaySelectedL = _ref.displaySelectedList,
	      displaySelectedList = _ref$displaySelectedL === undefined ? false : _ref$displaySelectedL,
	      _ref$featureFlag = _ref.featureFlag,
	      featureFlag = _ref$featureFlag === undefined ? true : _ref$featureFlag,
	      _ref$isApiCard = _ref.isApiCard,
	      isApiCard = _ref$isApiCard === undefined ? false : _ref$isApiCard,
	      _ref$emptyResultsText = _ref.emptyResultsText,
	      emptyResultsText = _ref$emptyResultsText === undefined ? '' : _ref$emptyResultsText,
	      classes = _ref.classes;
	
	  var syncTime = (0, _lodash.get)(details, keySyncTime);
	  var validSyncTime = syncTime !== null && syncTime !== '0';
	  var lastSyncDateTime = validSyncTime ? new Date(parseInt(syncTime, 10)).toString() : lastSyncErrorMsg;
	
	  var syncLog = (0, _lodash.get)(details, keySyncLog);
	  var validSyncLog = syncLog && syncLog !== null;
	  var cronSyncErrorMsg = '';
	  var cronText = validSyncLog ? _prettycronOverride2.default.toString(JSON.parse(syncLog).cron) : cronSyncErrorMsg;
	
	  var portalCount = totalCount;
	  var proxyCount = selectedCount || (validSyncLog ? JSON.parse(syncLog).count : 0);
	
	  var syncDisruption = (0, _lodash.get)(details, keySyncDisruption) !== null ? (0, _lodash.get)(details, keySyncDisruption) : 0;
	  var outSync = parseInt(syncDisruption, 10) === 1 || !(parseInt(portalCount, 10) === parseInt(proxyCount, 10));
	  var outSyncDateTime = (0, _moment2.default)(new Date(parseInt(syncTime, 10))).fromNow(true);
	
	  return _react2.default.createElement(
	    _Card2.default,
	    { 'data-apim-test': 'proxy-detail-card', className: classes.card },
	    _react2.default.createElement(
	      _CardContent2.default,
	      null,
	      _react2.default.createElement(
	        _Typography2.default,
	        { component: 'h3', className: classes.title, gutterBottom: true },
	        _react2.default.createElement(
	          'span',
	          { className: classes.titleIcon },
	          titleIcon
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: classes.titleText },
	          title
	        )
	      ),
	      _react2.default.createElement(_Divider2.default, { className: classes.divider }),
	      featureFlag ? _react2.default.createElement(
	        _react.Fragment,
	        null,
	        displayLastSync && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { component: 'div', className: classes.lastSync },
	            _react2.default.createElement(
	              'span',
	              { className: classes.iconStatus },
	              outSync ? _react2.default.createElement(_Close2.default, { className: classes.errorIconRoot }) : _react2.default.createElement(_Check2.default, { className: classes.successIconRoot })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: classes.iconStatusText },
	              'Last sync: ',
	              lastSyncDateTime
	            ),
	            validSyncTime && outSync && _react2.default.createElement(
	              'span',
	              { className: classes.lastSyncWarning },
	              '\u2192 ',
	              outSyncDateTime,
	              ' ',
	              'since last sync'
	            )
	          ),
	          cronText && _react2.default.createElement(
	            _Typography2.default,
	            { className: classes.lastSyncDescription },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Syncing every',
	              ' ',
	              cronText
	            )
	          )
	        ),
	        displayPortalCount && _react2.default.createElement(
	          _Typography2.default,
	          { component: 'div', className: classes.description },
	          _react2.default.createElement(
	            'span',
	            { className: classes.iconStatus },
	            _react2.default.createElement(_Check2.default, { style: { fontSize: 16, color: 'green' } })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: classes.iconStatusText },
	            'Portal: ',
	            portalCount
	          ),
	          isApiCard && displayLastSync && _react2.default.createElement(
	            _core.Tooltip,
	            { title: (0, _intl.getI18nFormattedMessage)('label.proxy.details.api.old.card.helptext'), arrow: true, placement: 'right' },
	            _react2.default.createElement(_Help2.default, { className: classes.helpIcon })
	          )
	        ),
	        displayProxyCount && _react2.default.createElement(
	          _Typography2.default,
	          { component: 'div', className: classes.description },
	          _react2.default.createElement(
	            'span',
	            { className: classes.iconStatus },
	            outSync ? _react2.default.createElement(_Close2.default, { className: classes.errorIconRoot }) : _react2.default.createElement(_Check2.default, { className: classes.successIconRoot })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: classes.iconStatusText },
	            'Proxy: ',
	            proxyCount
	          )
	        ),
	        displaySelectedList && _react2.default.createElement(
	          _Typography2.default,
	          { component: 'div', className: classes.description },
	          _react2.default.createElement(_ExpandableList2.default, { list: selectedList, title: 'Organizations' })
	        )
	      ) : _react2.default.createElement(
	        _Typography2.default,
	        { component: 'div', className: classes.lastSync },
	        emptyResultsText
	      )
	    )
	  );
	};
	
	DetailCardRaw.propTypes = {
	  details: _propTypes2.default.shape({}),
	  title: _propTypes2.default.string,
	  titleIcon: _propTypes2.default.node,
	  totalCount: _propTypes2.default.number,
	  selectedCount: _propTypes2.default.number,
	  selectedList: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  keySyncLog: _propTypes2.default.string,
	  keySyncTime: _propTypes2.default.string,
	  keySyncDisruption: _propTypes2.default.string,
	  lastSyncErrorMsg: _propTypes2.default.string,
	  displayLastSync: _propTypes2.default.bool,
	  displayProxyCount: _propTypes2.default.bool,
	  displayPortalCount: _propTypes2.default.bool,
	  displaySelectedList: _propTypes2.default.bool,
	  featureFlag: _propTypes2.default.bool,
	  emptyResultsText: _propTypes2.default.string,
	  classes: _propTypes2.default.shape({}),
	  isApiCard: _propTypes2.default.bool
	};
	
	DetailCardRaw.displayName = 'DetailCard';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(DetailCardRaw);

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    card: {
	      width: '19%',
	      display: 'inline-block',
	      margin: '0.5%',
	      verticalAlign: 'top',
	      minHeight: 260,
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground')
	    },
	    title: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.title')
	    },
	    titleText: {
	      paddingLeft: 10
	    },
	    titleIcon: {
	      verticalAlign: 'middle',
	      '& svg': {
	        fontSize: (0, _lodash.get)(theme, 'fontSize.title')
	      }
	    },
	    divider: {
	      marginTop: 4,
	      backgroundColor: (0, _lodash.get)(theme, 'color.borderColor')
	    },
	    description: {
	      marginBottom: 12,
	      marginTop: 12,
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      '& svg': {
	        verticalAlign: 'text-top'
	      }
	    },
	    lastSync: {
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      marginTop: 12,
	      '& svg': {
	        verticalAlign: 'text-top'
	      }
	    },
	    lastSyncWarning: {
	      paddingLeft: 2,
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      color: (0, _lodash.get)(theme, 'color.error')
	    },
	    lastSyncDescription: {
	      color: (0, _lodash.get)(theme, 'color.smallText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.smallText')
	    },
	    errorIconRoot: {
	      color: (0, _lodash.get)(theme, 'color.error'),
	      width: 16,
	      height: 16
	    },
	    successIconRoot: {
	      color: (0, _lodash.get)(theme, 'color.success'),
	      width: 16,
	      height: 16
	    },
	    iconStatus: {
	      paddingRight: 5,
	      verticalAlign: 'middle'
	    },
	    iconStatusText: {
	      verticalAlign: 'middle'
	    },
	    helpIcon: {
	      fontSize: 12,
	      margin: (0, _lodash.get)(theme, 'margin.m4'),
	      verticalAlign: 'inherit',
	      cursor: 'pointer',
	      color: (0, _lodash.get)(theme, 'color.link') + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApiProxyDetails = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _copyToClipboard = __webpack_require__(117);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _core = __webpack_require__(3);
	
	var _Paper = __webpack_require__(38);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Grid = __webpack_require__(71);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Divider = __webpack_require__(91);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _CircularProgress = __webpack_require__(313);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Cloud = __webpack_require__(948);
	
	var _Cloud2 = _interopRequireDefault(_Cloud);
	
	var _Layers = __webpack_require__(954);
	
	var _Layers2 = _interopRequireDefault(_Layers);
	
	var _InsertDriveFile = __webpack_require__(951);
	
	var _InsertDriveFile2 = _interopRequireDefault(_InsertDriveFile);
	
	var _Group = __webpack_require__(950);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Button = __webpack_require__(108);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _components = __webpack_require__(17);
	
	var _intl = __webpack_require__(15);
	
	var _apiProxy = __webpack_require__(280);
	
	var _apiProxy2 = __webpack_require__(284);
	
	var _portalConfig = __webpack_require__(26);
	
	var _DetailCard = __webpack_require__(1577);
	
	var _DetailCard2 = _interopRequireDefault(_DetailCard);
	
	var _ApiCard = __webpack_require__(1575);
	
	var _ApiCard2 = _interopRequireDefault(_ApiCard);
	
	var _styles = __webpack_require__(1580);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PROXY_TYPE_ITEMS = [{ key: 'AUTOMATIC', name: 'Automatic' }, { key: 'ON_DEMAND', name: 'On Demand' }, { key: 'MANUAL', name: 'Scripted' }];
	
	var refreshTimeInterval = 5 * 1000;
	
	var ApiProxyDetails = exports.ApiProxyDetails = function ApiProxyDetails(props) {
	  var proxyDetails = props.proxyDetails,
	      apiKeyProxyType = props.apiKeyProxyType,
	      gatewayDetails = props.gatewayDetails,
	      gateways = props.gateways,
	      apis = props.apis,
	      applicationApiKeysCount = props.applicationApiKeysCount,
	      accountPlans = props.accountPlans,
	      apiPlansCount = props.apiPlansCount,
	      portalPublishedApis = props.portalPublishedApis,
	      gatewayPublishedApis = props.gatewayPublishedApis,
	      portalApis = props.portalApis,
	      organizations = props.organizations,
	      selectedOrganizations = props.selectedOrganizations,
	      deleteProxyStatus = props.deleteProxyStatus,
	      config = props.config,
	      featureFlags = props.featureFlags,
	      useNewAutoSync = props.useNewAutoSync,
	      history = props.history,
	      classes = props.classes;
	
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var featureFlagApiPlan = JSON.parse((0, _lodash.get)(featureFlags, 'apiPlans.Value'));
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      copied = _useState2[0],
	      setCopied = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showDeleteDialog = _useState4[0],
	      setShowDeleteDialog = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      notificationMessage = _useState6[0],
	      setNotificationMessage = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      notificationStatus = _useState8[0],
	      setNotificationStatus = _useState8[1];
	
	  var proxyUuid = (0, _lodash.get)(props, 'match.params.apiProxyUuid');
	  (0, _react.useEffect)(function () {
	    (0, _apiProxy.fetchApiSyncFeatureFlag)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	    (0, _apiProxy.fetchApiSyncCounts)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	    (0, _apiProxy.fetchProxyDetails)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	    (0, _apiProxy.fetchProxyDeploymentTypes)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	    (0, _apiProxy.fetchGatewayDetails)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	    (0, _apiProxy.fetchGateways)({ config: config, dispatch: dispatch });
	    (0, _apiProxy.fetchApis)({ config: config, dispatch: dispatch });
	    (0, _apiProxy.fetchAccountPlans)({ config: config, dispatch: dispatch });
	    (0, _apiProxy.fetchApplicationApiKeysCount)({ config: config, dispatch: dispatch });
	    if (featureFlagApiPlan) {
	      (0, _apiProxy.fetchApiPlans)({ config: config, dispatch: dispatch });
	    }
	    (0, _apiProxy.fetchAllOrganizations)({ config: config, dispatch: dispatch });
	    (0, _apiProxy.fetchSelectedOrganizations)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	  }, []);
	
	  // checkEnrollmentStatus
	  (0, _react.useEffect)(function () {
	    var timeIntervalObj = null;
	    if ((0, _lodash.get)(gatewayDetails, 'EnrollmentStatus') === 'ACTIVE') {
	      clearTimeout(timeIntervalObj);
	    } else if ((0, _lodash.get)(gatewayDetails, 'EnrollmentStatus') === 'PENDING') {
	      timeIntervalObj = setTimeout(function () {
	        (0, _apiProxy.fetchGatewayDetails)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	      }, refreshTimeInterval);
	    }
	  }, [gatewayDetails]);
	
	  // canDeleteProxy
	  var canDeleteProxy = true;
	  if ((0, _lodash.get)(gatewayDetails, 'EnrollmentStatus') === 'ACTIVE') {
	    var activeProxies = 0;
	    gateways.map(function (obj) {
	      if ((0, _lodash.get)(obj, 'EnrollmentStatus') === 'ACTIVE') {
	        activeProxies++;
	      }
	      return true;
	    });
	    canDeleteProxy = activeProxies > 1;
	  }
	
	  var apiKeyDeploymentTypeValue = '';
	  if (apiKeyProxyType === 'AUTOMATIC') {
	    apiKeyDeploymentTypeValue = 'Automatic';
	  }
	  if (apiKeyProxyType === 'ON_DEMAND') {
	    apiKeyDeploymentTypeValue = 'On Demand';
	  }
	
	  var lastSyncErrorMsg = '';
	  var apiDeploymentTypeValue = '';
	  var ssgProxyUrlValue = '';
	  var ssgVersionValue = '';
	  var otkVersionValue = '';
	  var enrollUrlValue = '';
	  var displayProxyEnrollment = false;
	
	  var deploymentType = PROXY_TYPE_ITEMS.filter(function (obj) {
	    return obj.key === (0, _lodash.get)(gatewayDetails, 'DeploymentType');
	  });
	  if (deploymentType.length === 1) {
	    apiDeploymentTypeValue = deploymentType[0].name;
	  }
	  switch ((0, _lodash.get)(gatewayDetails, 'EnrollmentStatus')) {
	    case 'PENDING':
	      {
	        lastSyncErrorMsg = 'Pending Enrollment';
	        ssgProxyUrlValue = 'Pending Enrollment';
	        ssgVersionValue = 'Pending Enrollment';
	        otkVersionValue = 'Pending Enrollment';
	        enrollUrlValue = (0, _lodash.get)(proxyDetails, 'enrollmentUrl');
	        displayProxyEnrollment = true;
	        break;
	      }
	    default:
	      {
	        lastSyncErrorMsg = 'Service Disruption';
	        var strLogs = (0, _lodash.get)(gatewayDetails, 'Logs');
	        if (strLogs) {
	          var logs = JSON.parse(strLogs);
	          ssgProxyUrlValue = logs.cluster_name;
	          ssgVersionValue = logs.version;
	          otkVersionValue = logs.otk_version ? logs.otk_version : 'Unknown version';
	        }
	      }
	  }
	
	  var onEditProxy = function onEditProxy() {
	    history.push('/publish/api-proxy/edit/' + proxyUuid);
	  };
	
	  var openDeleteDialog = function openDeleteDialog() {
	    setShowDeleteDialog(true);
	  };
	
	  var closeDeleteDialog = function closeDeleteDialog() {
	    setShowDeleteDialog(false);
	  };
	
	  var onDeleteProxy = function onDeleteProxy() {
	    (0, _apiProxy.deleteProxy)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	    closeDeleteDialog();
	  };
	
	  var showCopied = function showCopied() {
	    setCopied(true);
	    setTimeout(function () {
	      setCopied(false);
	    }, 5000);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (deleteProxyStatus === 'SUCCESS') {
	      window.location.href = '/admin/api-proxy';
	    } else if (deleteProxyStatus === 'FAIL') {
	      setNotificationMessage('There was an error while deleting proxy.');
	      setNotificationStatus('error');
	    }
	  }, [deleteProxyStatus]);
	
	  var isApiAutoDeploy = (0, _lodash.get)(gatewayDetails, 'DeploymentType') === 'AUTOMATIC';
	  var isAppAutoDeploy = apiKeyProxyType === 'AUTOMATIC';
	  var selectedOrgsList = selectedOrganizations.filter(function (o) {
	    return organizations.find(function (o2) {
	      return o.x === o2.x;
	    });
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: classes.content, id: 'api-proxy-details-page' },
	    notificationMessage && _react2.default.createElement(_components.AlertMessages, {
	      id: 'api-proxy-details-notifications',
	      message: notificationMessage,
	      variant: notificationStatus,
	      containerClass: classes.notificationWidthClass,
	      onClose: function onClose() {
	        setNotificationMessage('');
	        setNotificationStatus('');
	      }
	    }),
	    showDeleteDialog && _react2.default.createElement(_components.AlertDialog, {
	      isOpen: showDeleteDialog,
	      title: 'Delete Proxy',
	      description: 'Are you sure you want to delete the proxy? Deletion will permanently remove the proxy from the Portal',
	      submitText: 'Ok',
	      cancelText: 'Cancel',
	      onClose: function onClose() {
	        return closeDeleteDialog();
	      },
	      onSubmit: function onSubmit() {
	        return onDeleteProxy();
	      },
	      onCancel: function onCancel() {
	        return closeDeleteDialog();
	      },
	      dialogId: 'api-proxy-delete-dialog'
	    }),
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      (0, _lodash.get)(gatewayDetails, 'Name')
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.actionButtonsContainer },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: function onClick() {
	            return onEditProxy();
	          },
	          color: 'secondary',
	          variant: 'contained',
	          'data-testid': 'edit-proxy'
	        },
	        'Edit'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: openDeleteDialog,
	          color: 'primary',
	          variant: 'outlined',
	          disabled: !canDeleteProxy,
	          'data-testid': 'delete-proxy'
	        },
	        'Delete'
	      )
	    ),
	    _react2.default.createElement(_Divider2.default, { className: classes.divider }),
	    _react2.default.createElement(
	      'div',
	      { className: classes.bodyContent },
	      displayProxyEnrollment && _react2.default.createElement(
	        'div',
	        { id: 'pending-enrollment-section' },
	        _react2.default.createElement(
	          'h2',
	          { className: classes.enrollmentSectionTitle },
	          'Complete Proxy Enrollment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.enrollSection },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 3 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 6 },
	              _react2.default.createElement(
	                _Paper2.default,
	                { className: classes.enrollSectionCard },
	                _react2.default.createElement(
	                  'span',
	                  { className: classes.enrollSectionColTitle },
	                  'Enrollment URL'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { id: 'enrollUrl', type: 'text', readOnly: true, value: enrollUrlValue }),
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    color: 'secondary',
	                    variant: 'contained',
	                    className: classes.selectUrlButton,
	                    onClick: function onClick() {
	                      showCopied();
	                      (0, _copyToClipboard2.default)(enrollUrlValue);
	                    }
	                  },
	                  'Select URL'
	                ),
	                copied && _react2.default.createElement(
	                  'span',
	                  { className: classes.copiedText },
	                  'URL selected!!!'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: classes.enrollSectionColDesc },
	                  'Select the following URL then copy & paste it into the Policy Manager. This URL will expire in 24 hours.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 6 },
	              _react2.default.createElement(
	                _Paper2.default,
	                { className: classes.enrollSectionCard },
	                _react2.default.createElement(
	                  'span',
	                  { className: classes.enrollSectionColTitle },
	                  'Test Connection'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: classes.enrollSectionColDesc },
	                  'Once URL is pasted into Policy Manager, return here to wait for connection.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_CircularProgress2.default, { classes: { root: classes.loadingSpinner } })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_Divider2.default, { className: classes.divider }),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Paper2.default,
	        { classes: { root: classes.attributeContainer } },
	        _react2.default.createElement(
	          'span',
	          null,
	          'API Deployment Type:'
	        ),
	        ' ',
	        apiDeploymentTypeValue,
	        useNewAutoSync && isApiAutoDeploy && _react2.default.createElement(
	          _core.Tooltip,
	          {
	            'data-apim-test': 'proxy-details-api-helptext',
	            title: (0, _intl.getI18nFormattedMessage)('label.proxy.details.api.title.helptext'),
	            arrow: true, placement: 'right'
	          },
	          _react2.default.createElement(_Help2.default, { className: classes.helpIcon })
	        )
	      ),
	      _react2.default.createElement(
	        _Paper2.default,
	        { classes: { root: classes.attributeContainer } },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Key Deployment Type:'
	        ),
	        ' ',
	        apiKeyDeploymentTypeValue
	      ),
	      _react2.default.createElement(
	        _Paper2.default,
	        { classes: { root: classes.attributeContainer } },
	        _react2.default.createElement(
	          'span',
	          null,
	          'API Proxy URL:'
	        ),
	        ' ',
	        ssgProxyUrlValue
	      ),
	      _react2.default.createElement(
	        _Paper2.default,
	        { classes: { root: classes.attributeContainer } },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Proxy Version:'
	        ),
	        ' ',
	        ssgVersionValue
	      ),
	      _react2.default.createElement(
	        _Paper2.default,
	        { classes: { root: classes.attributeContainer } },
	        _react2.default.createElement(
	          'span',
	          null,
	          'OTK Version:'
	        ),
	        ' ',
	        otkVersionValue
	      ),
	      _react2.default.createElement('br', null),
	      useNewAutoSync && isApiAutoDeploy ? _react2.default.createElement(_ApiCard2.default, {
	        details: gatewayDetails,
	        title: 'APIs',
	        titleIcon: _react2.default.createElement(_Cloud2.default, null),
	        totalCount: portalApis.totalElements,
	        portalApis: portalApis,
	        portalPublishedCount: portalPublishedApis.totalElements,
	        gatewayPublishedCount: gatewayPublishedApis.totalElements,
	        keySyncLog: 'ApiSyncLog',
	        keySyncTime: 'ApiSyncTime',
	        keySyncDisruption: 'ApiSyncDisruption',
	        lastSyncErrorMsg: lastSyncErrorMsg,
	        displayLastSync: isApiAutoDeploy,
	        displayProxyCount: isApiAutoDeploy
	      }) : _react2.default.createElement(_DetailCard2.default, {
	        details: gatewayDetails,
	        title: 'APIs',
	        titleIcon: _react2.default.createElement(_Cloud2.default, null),
	        totalCount: apis.length,
	        keySyncLog: 'ApiSyncLog',
	        keySyncTime: 'ApiSyncTime',
	        keySyncDisruption: 'ApiSyncDisruption',
	        lastSyncErrorMsg: lastSyncErrorMsg,
	        displayLastSync: isApiAutoDeploy,
	        displayProxyCount: isApiAutoDeploy,
	        isApiCard: true
	      }),
	      _react2.default.createElement(_DetailCard2.default, {
	        details: gatewayDetails,
	        title: 'Application API Keys',
	        titleIcon: _react2.default.createElement(_Layers2.default, null),
	        totalCount: applicationApiKeysCount,
	        keySyncLog: 'AppSyncLog',
	        keySyncTime: 'AppSyncTime',
	        keySyncDisruption: 'AppSyncDisruption',
	        lastSyncErrorMsg: lastSyncErrorMsg,
	        displayLastSync: isAppAutoDeploy,
	        displayProxyCount: isAppAutoDeploy
	      }),
	      _react2.default.createElement(_DetailCard2.default, {
	        details: gatewayDetails,
	        title: 'Account Plans',
	        titleIcon: _react2.default.createElement(_InsertDriveFile2.default, null),
	        totalCount: accountPlans.length,
	        keySyncLog: 'AccountPlanSyncLog',
	        keySyncTime: 'AccountPlanSyncTime',
	        keySyncDisruption: 'AccountPlanSyncDisruption',
	        lastSyncErrorMsg: lastSyncErrorMsg
	      }),
	      _react2.default.createElement(_DetailCard2.default, {
	        details: gatewayDetails,
	        title: 'API Plans',
	        titleIcon: _react2.default.createElement(_InsertDriveFile2.default, null),
	        totalCount: apiPlansCount,
	        keySyncLog: 'ApiPlanSyncLog',
	        keySyncTime: 'ApiPlanSyncTime',
	        keySyncDisruption: 'ApiPlanSyncDisruption',
	        lastSyncErrorMsg: lastSyncErrorMsg,
	        featureFlag: featureFlagApiPlan,
	        emptyResultsText: 'API Plans are currently disabled.'
	      }),
	      _react2.default.createElement(_DetailCard2.default, {
	        details: gatewayDetails,
	        title: 'Organizations',
	        titleIcon: _react2.default.createElement(_Group2.default, null),
	        displayPortalCount: false,
	        displayProxyCount: false,
	        selectedList: selectedOrgsList.map(function (obj) {
	          return { key: obj.uuid, value: obj.name };
	        }),
	        displaySelectedList: true,
	        displayLastSync: false
	      })
	    ),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    config: (0, _portalConfig.getConfig)(state),
	    featureFlags: (0, _portalConfig.getFeatureFlags)(state),
	    proxyDetails: (0, _apiProxy2.getProxyDetails)(state),
	    apiKeyProxyType: (0, _apiProxy2.getApiKeyProxyType)(state),
	    gateways: (0, _apiProxy2.getGateways)(state),
	    gatewayDetails: (0, _apiProxy2.getGatewayDetails)(state),
	    apis: (0, _apiProxy2.getApis)(state),
	    applicationApiKeysCount: (0, _apiProxy2.getApplicationApiKeysCount)(state),
	    accountPlans: (0, _apiProxy2.getAccountPlans)(state),
	    apiPlansCount: (0, _apiProxy2.getApiPlansCount)(state),
	    organizations: (0, _apiProxy2.getOrganizations)(state),
	    selectedOrganizations: (0, _apiProxy2.getSelectedOrganizations)(state),
	    deleteProxyStatus: (0, _apiProxy2.getDeleteProxyStatus)(state),
	    useNewAutoSync: (0, _apiProxy2.getApiSyncFeatureFlag)(state),
	    portalApis: (0, _apiProxy2.getPortalApis)(state),
	    portalPublishedApis: (0, _apiProxy2.getPortalPublishedApis)(state),
	    gatewayPublishedApis: (0, _apiProxy2.getGatewayPublishedApis)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchProxyDetails: _apiProxy.fetchProxyDetails,
	  fetchGateways: _apiProxy.fetchGateways,
	  fetchGatewayDetails: _apiProxy.fetchGatewayDetails,
	  fetchApis: _apiProxy.fetchApis,
	  fetchApplicationApiKeysCount: _apiProxy.fetchApplicationApiKeysCount,
	  fetchAccountPlans: _apiProxy.fetchAccountPlans,
	  fetchApiPlans: _apiProxy.fetchApiPlans,
	  fetchAllOrganizations: _apiProxy.fetchAllOrganizations,
	  fetchSelectedOrganizations: _apiProxy.fetchSelectedOrganizations,
	  fetchApiSyncFeatureFlag: _apiProxy.fetchApiSyncFeatureFlag,
	  deleteProxy: _apiProxy.deleteProxy
	};
	
	ApiProxyDetails.propTypes = {
	  proxyDetails: _propTypes2.default.shape({}),
	  apiKeyProxyType: _propTypes2.default.string,
	  gatewayDetails: _propTypes2.default.shape({}),
	  gateways: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apis: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  applicationApiKeysCount: _propTypes2.default.number,
	  accountPlans: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiPlansCount: _propTypes2.default.number,
	  organizations: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  selectedOrganizations: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  deleteProxyStatus: _propTypes2.default.string,
	  featureFlags: _propTypes2.default.shape({}),
	  useNewAutoSync: _propTypes2.default.bool,
	  portalApis: _propTypes2.default.shape({}),
	  gatewayPublishedApis: _propTypes2.default.shape({}),
	  portalPublishedApis: _propTypes2.default.shape({}),
	  config: _propTypes2.default.shape({}),
	  history: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ApiProxyDetails);

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(theme) {
	  return {
	    content: {
	      margin: 24,
	      minHeight: 'calc(100vh - 56vw)',
	      backgroundColor: (0, _lodash.get)(theme, 'color.background'),
	      marginBottom: 70
	    },
	    bodyContent: {
	      marginTop: 10,
	      marginBottom: 10
	    },
	    pageTitle: {
	      color: (0, _lodash.get)(theme, 'color.pageTitle'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.pageTitle'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.pageTitle'),
	      margin: 10,
	      display: 'inline-block'
	    },
	    actionButtonsContainer: {
	      display: 'inline-block',
	      float: 'right',
	      '& button': {
	        marginLeft: 10
	      }
	    },
	    divider: {
	      marginTop: 4,
	      backgroundColor: (0, _lodash.get)(theme, 'color.borderColor')
	    },
	    enrollmentSectionTitle: {
	      color: (0, _lodash.get)(theme, 'color.sectionTitle'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.sectionTitle'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.sectionTitle'),
	      margin: 10,
	      display: 'inline-block'
	    },
	    attributeContainer: {
	      width: '16%',
	      display: 'inline-block',
	      margin: '0.5%',
	      padding: '1.5%',
	      verticalAlign: 'top',
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.bodyText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	      '& span': {
	        fontWeight: 'bold'
	      }
	    },
	    copiedText: {
	      color: (0, _lodash.get)(theme, 'color.success'),
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText'),
	      fontFamily: (0, _lodash.get)(theme, 'typography.smallText'),
	      fontStyle: 'italic',
	      fontWeight: 'bold',
	      paddingLeft: 10
	    },
	    enrollSection: {
	      flexGrow: 1
	    },
	    enrollSectionCard: {
	      padding: theme.spacing(2),
	      color: (0, _lodash.get)(theme, 'color.bodyText'),
	      backgroundColor: (0, _lodash.get)(theme, 'color.uiBackground'),
	      minHeight: 100,
	      '& input': {
	        padding: 10,
	        marginTop: 10,
	        marginBottom: 10,
	        width: '60%'
	      }
	    },
	    selectUrlButton: {
	      borderRadius: '0 4px 4px 0',
	      verticalAlign: 'middle'
	    },
	    enrollSectionColTitle: {
	      fontWeight: 'bold'
	    },
	    enrollSectionColDesc: {
	      fontSize: 12
	    },
	    loadingSpinner: {
	      width: 30,
	      height: 30,
	      marginTop: 10,
	      color: (0, _lodash.get)(theme, 'color.bodyText')
	    },
	    notificationWidthClass: {
	      width: '96%',
	      padding: '0 15px',
	      marginLeft: 0
	    },
	    subTitle: {
	      fontSize: (0, _lodash.get)(theme, 'fontSize.smallText'),
	      fontStyle: 'italic',
	      float: 'right',
	      marginRight: 50,
	      marginTop: 5
	    },
	    helpIcon: {
	      fontSize: 12,
	      margin: (0, _lodash.get)(theme, 'margin.m4'),
	      verticalAlign: 'inherit',
	      cursor: 'pointer',
	      color: (0, _lodash.get)(theme, 'color.link') + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Details;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _labels = __webpack_require__(198);
	
	var _apiProxy = __webpack_require__(280);
	
	var _components = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_PROXY_TYPE_ITEMS = [{
	  id: 'AUTOMATIC',
	  name: 'Automatic'
	}, {
	  id: 'ON_DEMAND',
	  name: 'On Demand'
	}, {
	  id: 'MANUAL',
	  name: 'Scripted'
	}];
	
	var API_KEY_PROXY_TYPE_ITEMS = [{
	  id: 'AUTOMATIC',
	  name: 'Automatic'
	}, {
	  id: 'ON_DEMAND',
	  name: 'On Demand'
	}];
	var containsError = function containsError(errors, key) {
	  return errors.filter(function (e) {
	    return e.key === key;
	  }).length > 0;
	};
	var containsErrorByType = function containsErrorByType(errors, key, type) {
	  return errors.filter(function (e) {
	    return e.key === key && e.type === type;
	  }).length > 0;
	};
	
	var ProxyName = function ProxyName(_ref) {
	  var classes = _ref.classes,
	      config = _ref.config,
	      dispatch = _ref.dispatch,
	      currentProxyName = _ref.currentProxyName,
	      setCurrentProxyName = _ref.setCurrentProxyName,
	      proxyDetails = _ref.proxyDetails,
	      errors = _ref.errors;
	  return _react2.default.createElement(
	    'div',
	    { id: 'proxy-name-container', className: classes.fieldContainer },
	    _react2.default.createElement(_components.FormTextField, {
	      id: 'proxy-name',
	      name: _labels.PROXY_NAME_TITLE,
	      value: currentProxyName,
	      error: containsError(errors, 'proxyName'),
	      handleChange: setCurrentProxyName,
	      handleBlur: function handleBlur() {
	        return (0, _apiProxy.validateProxyUniqueName)({
	          config: config,
	          dispatch: dispatch,
	          proxyDetails: proxyDetails,
	          proxyName: currentProxyName
	        });
	      },
	      helperText: containsErrorByType(errors, 'proxyName', 'unique') ? _labels.UNIQUE_PROXY_NAME_WARNING_MSG : _labels.MAXLENGTH_PROXY_NAME_WARNING_MSG,
	      maxLength: '255'
	    })
	  );
	};
	
	ProxyName.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  config: _propTypes2.default.shape({}),
	  currentProxyName: _propTypes2.default.string,
	  setCurrentProxyName: _propTypes2.default.func,
	  proxyDetails: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  dispatch: _propTypes2.default.func
	};
	
	var APIProxyTypes = function APIProxyTypes(_ref2) {
	  var classes = _ref2.classes,
	      items = _ref2.items,
	      currentApiProxyType = _ref2.currentApiProxyType,
	      setCurrentApiProxyType = _ref2.setCurrentApiProxyType;
	  return _react2.default.createElement(
	    'div',
	    { id: 'api-deployment-type-container', className: classes.fieldContainer },
	    _react2.default.createElement(_components.FormRadioGroup, {
	      id: 'api-spec-authentication-type',
	      name: _labels.API_DEPLOYMENT_TYPE_TITLE,
	      tooltip: _labels.API_DEPLOYMENT_TYPE_TOOLTIP_TEXT,
	      selected: currentApiProxyType,
	      onChange: setCurrentApiProxyType,
	      data: items
	    })
	  );
	};
	
	APIProxyTypes.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  currentApiProxyType: _propTypes2.default.string,
	  setCurrentApiProxyType: _propTypes2.default.func,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	};
	
	var APIKeyProxyTypes = function APIKeyProxyTypes(_ref3) {
	  var classes = _ref3.classes,
	      items = _ref3.items,
	      currentApiKeyProxyType = _ref3.currentApiKeyProxyType,
	      setCurrentApiKeyProxyType = _ref3.setCurrentApiKeyProxyType;
	  return _react2.default.createElement(
	    'div',
	    { id: 'apikey-deployment-type-container', className: classes.fieldContainer },
	    _react2.default.createElement(_components.FormRadioGroup, {
	      id: 'api-spec-authentication-type',
	      name: _labels.KEY_DEPLOYMENT_TYPE_TITLE,
	      tooltip: _labels.KEY_DEPLOYMENT_TYPE_TOOLTIP_TEXT,
	      selected: currentApiKeyProxyType,
	      onChange: setCurrentApiKeyProxyType,
	      data: items
	    })
	  );
	};
	
	APIKeyProxyTypes.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  currentApiKeyProxyType: _propTypes2.default.string,
	  setCurrentApiKeyProxyType: _propTypes2.default.func,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	};
	
	function Details(props) {
	  var classes = props.classes,
	      config = props.config,
	      dispatch = props.dispatch,
	      proxyNameUniqueStatus = props.proxyNameUniqueStatus,
	      currentProxyName = props.currentProxyName,
	      setCurrentProxyName = props.setCurrentProxyName,
	      currentApiProxyType = props.currentApiProxyType,
	      setCurrentApiProxyType = props.setCurrentApiProxyType,
	      currentApiKeyProxyType = props.currentApiKeyProxyType,
	      setCurrentApiKeyProxyType = props.setCurrentApiKeyProxyType,
	      proxyDetails = props.proxyDetails,
	      errors = props.errors;
	
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      _labels.DETAILS_TAB_TITLE
	    ),
	    _react2.default.createElement(_core.Divider, null),
	    _react2.default.createElement(ProxyName, {
	      classes: classes,
	      config: config,
	      dispatch: dispatch,
	      proxyNameUniqueStatus: proxyNameUniqueStatus,
	      currentProxyName: currentProxyName,
	      setCurrentProxyName: setCurrentProxyName,
	      proxyDetails: proxyDetails,
	      errors: errors
	    }),
	    _react2.default.createElement(APIProxyTypes, {
	      classes: classes,
	      currentApiProxyType: currentApiProxyType,
	      setCurrentApiProxyType: setCurrentApiProxyType,
	      items: API_PROXY_TYPE_ITEMS
	    }),
	    _react2.default.createElement(APIKeyProxyTypes, {
	      classes: classes,
	      currentApiKeyProxyType: currentApiKeyProxyType,
	      setCurrentApiKeyProxyType: setCurrentApiKeyProxyType,
	      items: API_KEY_PROXY_TYPE_ITEMS
	    })
	  );
	}
	
	Details.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  config: _propTypes2.default.shape({}),
	  currentProxyName: _propTypes2.default.string,
	  setCurrentProxyName: _propTypes2.default.func,
	  proxyNameUniqueStatus: _propTypes2.default.string,
	  currentApiProxyType: _propTypes2.default.string,
	  setCurrentApiProxyType: _propTypes2.default.func,
	  currentApiKeyProxyType: _propTypes2.default.string,
	  setCurrentApiKeyProxyType: _propTypes2.default.func,
	  proxyDetails: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  dispatch: _propTypes2.default.func
	};

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OrganizationAssignment;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function OrganizationAssignment(props) {
	  var classes = props.classes,
	      orgs = props.orgs,
	      selectedOrgs = props.selectedOrgs,
	      setSelectedOrgs = props.setSelectedOrgs;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      _labels.ORG_ASSIGNMENT_TAB_TITLE
	    ),
	    _react2.default.createElement(
	      'h2',
	      { className: classes.sectionTitle },
	      _labels.ORG_ASSIGNMENT_PAGE_SUB_TITLE
	    ),
	    _react2.default.createElement(_core.Divider, null),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, className: classes.fieldContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 6, item: true },
	        _react2.default.createElement(_components.SearchTextListContainer, {
	          listId: 'orgs-list',
	          title: _labels.ORGANIZATIONS_TITLE,
	          subtitle: _labels.AVAILABLE_ORGANIZATIONS_SUBTITLE,
	          placeHolderText: _labels.SEARCH_AVAILABLE_ORGANIZATIONS_SUBTITLE,
	          defaultList: orgs,
	          defaultSelectedList: selectedOrgs,
	          onSearchListChange: function onSearchListChange(selectedList) {
	            return setSelectedOrgs([].concat(_toConsumableArray(selectedList)));
	          },
	          isCheckBoxVisible: true
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 6, item: true },
	        _react2.default.createElement(_components.SearchTextListContainer, {
	          listId: 'selected-orgs-list',
	          title: _labels.SELECTED_ORGANIZATIONS_TITLE,
	          subtitle: _labels.ALL_SELECTED_ORGANIZATIONS_SUBTITLE,
	          placeHolderText: _labels.SEARCH_SELECTED_ORGANIZATIONS_SUBTITLE,
	          defaultList: selectedOrgs,
	          defaultSelectedList: selectedOrgs,
	          onSearchListChange: function onSearchListChange(selectedList) {
	            return setSelectedOrgs([].concat(_toConsumableArray(selectedList)));
	          },
	          isDeleteIconVisible: true,
	          isSelectedNumberVisible: true,
	          isMandatory: false
	        })
	      )
	    )
	  );
	}
	
	OrganizationAssignment.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  orgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  selectedOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  setSelectedOrgs: _propTypes2.default.func
	};

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApiProxy = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _Details = __webpack_require__(1581);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _OrganizationAssignment = __webpack_require__(1582);
	
	var _OrganizationAssignment2 = _interopRequireDefault(_OrganizationAssignment);
	
	var _apiProxy = __webpack_require__(280);
	
	var _apiProxy2 = __webpack_require__(284);
	
	var _portalConfig = __webpack_require__(26);
	
	var _constants = __webpack_require__(14);
	
	var _labels = __webpack_require__(198);
	
	var _tabs = __webpack_require__(1585);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _edit = __webpack_require__(201);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1584);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getHelpItems = function getHelpItems(screen) {
	  return _labels.HELP_ITEMS[screen].details;
	};
	
	var getTabs = function getTabs(proxyUuid) {
	  return _tabs2.default.filter(function (_ref) {
	    var isHidden = _ref.isHidden;
	    return !(isHidden && isHidden(proxyUuid));
	  }).map(function (tab) {
	    return Object.assign({}, tab, {
	      disabled: tab.isDisabled && tab.isDisabled(proxyUuid)
	    });
	  });
	};
	
	var isEditJourney = function isEditJourney(props) {
	  return (0, _lodash.get)(props, 'match.path') && (0, _lodash.get)(props, 'match.path').includes('/edit/') && (0, _lodash.get)(props, 'match.params.apiProxyUuid');
	};
	
	var ApiProxy = exports.ApiProxy = function ApiProxy(props) {
	  var config = props.config,
	      proxyName = props.proxyName,
	      proxyNameUniqueStatus = props.proxyNameUniqueStatus,
	      apiProxyType = props.apiProxyType,
	      apiKeyProxyType = props.apiKeyProxyType,
	      proxyDetails = props.proxyDetails,
	      organizations = props.organizations,
	      selectedOrganizations = props.selectedOrganizations,
	      saveProxyStatus = props.saveProxyStatus,
	      updateKeyDeploymentTypeStatus = props.updateKeyDeploymentTypeStatus,
	      updateProxyOrgsStatus = props.updateProxyOrgsStatus,
	      isLoading = props.isLoading,
	      history = props.history;
	
	  // Edit Journey
	
	  var proxyUuid = props.proxyUuid;
	
	  if (isEditJourney(props)) {
	    proxyUuid = (0, _lodash.get)(props, 'match.params.apiProxyUuid');
	  }
	
	  var tabs = getTabs(proxyUuid);
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(tabs[0].tabId),
	      _useState2 = _slicedToArray(_useState, 2),
	      currentTab = _useState2[0],
	      setCurrentTab = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      pageErrors = _useState4[0],
	      setPageErrors = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      notificationMessage = _useState6[0],
	      setNotificationMessage = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      notificationStatus = _useState8[0],
	      setNotificationStatus = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      showAlert = _useState10[0],
	      setShowAlert = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      currentProxyName = _useState12[0],
	      setCurrentProxyName = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      currentApiProxyType = _useState14[0],
	      setCurrentApiProxyType = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      currentApiKeyProxyType = _useState16[0],
	      setCurrentApiKeyProxyType = _useState16[1];
	
	  var _useState17 = (0, _react.useState)([]),
	      _useState18 = _slicedToArray(_useState17, 2),
	      selectedOrgs = _useState18[0],
	      setSelectedOrgs = _useState18[1];
	
	  var headerRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    setCurrentProxyName(proxyName);
	  }, [proxyName]);
	  (0, _react.useEffect)(function () {
	    setCurrentApiProxyType(apiProxyType);
	  }, [apiProxyType]);
	  (0, _react.useEffect)(function () {
	    setCurrentApiKeyProxyType(apiKeyProxyType);
	  }, [apiKeyProxyType]);
	  (0, _react.useEffect)(function () {
	    setSelectedOrgs(selectedOrganizations);
	  }, [selectedOrganizations]);
	  (0, _react.useEffect)(function () {
	    if (proxyNameUniqueStatus === _constants.FAIL) {
	      setPageErrors([{
	        key: 'proxyName',
	        type: 'unique',
	        message: _labels.UNIQUE_PROXY_NAME_ERROR_MSG
	      }]);
	    } else {
	      setPageErrors([]);
	    }
	  }, [proxyNameUniqueStatus]);
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var handleChange = function handleChange(event, newValue) {
	    if (currentTab !== newValue) {
	      setCurrentTab(newValue);
	      setNotificationMessage('');
	      setNotificationStatus('');
	    }
	    window.scrollTo(0, headerRef.offsetTop);
	  };
	
	  var validateForm = function validateForm() {
	    var errors = [];
	    switch (currentTab) {
	      case 'details-tab':
	        {
	          if (currentProxyName === '') {
	            errors = errors.concat([{
	              key: 'proxyName',
	              type: 'empty',
	              message: _labels.EMPTY_PROXY_NAME_ERROR_MSG
	            }]);
	          } else if (currentProxyName && currentProxyName.length > 255) {
	            errors = errors.concat([{
	              key: 'proxyName',
	              type: 'maxlength',
	              message: _labels.MAXLENGTH_PROXY_NAME_ERROR_MSG
	            }]);
	          }
	          setPageErrors(errors);
	          break;
	        }
	      case 'organization-assignment-tab':
	        break;
	      default:
	        break;
	    }
	  };
	
	  var onNext = function onNext() {
	    validateForm();
	
	    var isValid = pageErrors.length === 0;
	    switch (currentTab) {
	      case 'details-tab':
	        {
	          if (isValid) {
	            var data = { name: currentProxyName, deploymentType: currentApiProxyType };
	            (0, _apiProxy.saveProxy)({ config: config, dispatch: dispatch, data: data, proxyUuid: proxyUuid, apiKeyProxyType: currentApiKeyProxyType });
	          }
	          break;
	        }
	      case 'organization-assignment-tab':
	        {
	          if (isValid) {
	            var _data = selectedOrgs.map(function (selectedOrg) {
	              return { uuid: selectedOrg.uuid };
	            });
	            (0, _apiProxy.updateProxyOrganizations)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid, data: _data });
	          }
	          break;
	        }
	      default:
	        break;
	    }
	  };
	
	  var onCancel = function onCancel() {
	    setShowAlert(true);
	  };
	
	  var onDialogClose = function onDialogClose() {
	    setShowAlert(false);
	  };
	
	  var onDialogSubmit = function onDialogSubmit() {
	    window.location.href = '/admin/api-proxy';
	  };
	
	  (0, _react.useEffect)(function () {
	    if (currentTab === 'details-tab') {
	      if (saveProxyStatus === '') {
	        if (proxyUuid) {
	          (0, _apiProxy.fetchProxyDetails)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	          (0, _apiProxy.fetchProxyDeploymentTypes)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	          (0, _apiProxy.fetchAllOrganizations)({ config: config, dispatch: dispatch });
	          (0, _apiProxy.fetchSelectedOrganizations)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	        }
	      }
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (currentTab === 'details-tab') {
	      if (updateKeyDeploymentTypeStatus === _constants.SUCCESS && (saveProxyStatus === _constants.CREATE_SUCCESS || saveProxyStatus === _constants.UPDATE_SUCCESS)) {
	        if (proxyUuid) {
	          (0, _apiProxy.fetchProxyDetails)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	          (0, _apiProxy.fetchAllOrganizations)({ config: config, dispatch: dispatch });
	          (0, _apiProxy.fetchSelectedOrganizations)({ config: config, dispatch: dispatch, proxyUuid: proxyUuid });
	          setCurrentTab('organization-assignment-tab');
	          window.scrollTo(0, headerRef.offsetTop);
	        }
	      }
	      switch (saveProxyStatus) {
	        case _constants.CREATE_SUCCESS:
	          if (updateKeyDeploymentTypeStatus === _constants.SUCCESS) {
	            setNotificationMessage(_labels.PROXY_CREATE_SUCCESS_MSG);
	            setNotificationStatus(_constants.ALERT_SUCCESS);
	          } else if (updateKeyDeploymentTypeStatus === _constants.FAIL) {
	            setNotificationMessage(_labels.PROXY_CREATE_FAIL_MSG);
	            setNotificationStatus(_constants.ALERT_ERROR);
	          }
	          break;
	        case _constants.CREATE_FAIL:
	          setNotificationMessage(_labels.PROXY_CREATE_FAIL_MSG);
	          setNotificationStatus('error');
	          break;
	        case _constants.UPDATE_SUCCESS:
	          if (updateKeyDeploymentTypeStatus === _constants.SUCCESS) {
	            setNotificationMessage(_labels.PROXY_UPDATE_SUCCESS_MSG);
	            setNotificationStatus('success');
	          } else if (updateKeyDeploymentTypeStatus === _constants.FAIL) {
	            setNotificationMessage(_labels.PROXY_UPDATE_FAIL_MSG);
	            setNotificationStatus('error');
	          }
	          break;
	        case _constants.UPDATE_FAIL:
	          setNotificationMessage(_labels.PROXY_UPDATE_FAIL_MSG);
	          setNotificationStatus('error');
	          break;
	        default:
	          break;
	      }
	    }
	    if (currentTab === 'organization-assignment-tab') {
	      if (updateProxyOrgsStatus === _constants.SUCCESS) {
	        (0, _apiProxy.reinitializeState)({ dispatch: dispatch });
	        history.push('/publish/api-proxy/details/' + proxyUuid);
	      }
	      if (updateProxyOrgsStatus === _constants.FAIL) {
	        setNotificationMessage(_labels.PROXY_ORGS_UPDATE_FAIL_MSG);
	        setNotificationStatus('error');
	      }
	    }
	  }, [proxyUuid, saveProxyStatus, updateKeyDeploymentTypeStatus, updateProxyOrgsStatus]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_edit2.default, {
	      editPageId: 'api-proxy-page',
	      dialogId: 'api-proxy-dialog',
	      isDialogOpen: showAlert,
	      onDialogClose: onDialogClose,
	      dialogSubmitText: _labels.UNSAVED_DIALOG_SUBMIT_TEXT,
	      onDialogSubmit: onDialogSubmit,
	      isLoading: isLoading,
	      leftSidebarId: 'api-proxy-left-sidebar',
	      mainContentId: 'api-proxy-main-content',
	      notificationId: 'api-proxy-notification',
	      notificationStatus: notificationStatus,
	      setNotificationStatus: setNotificationMessage,
	      notificationMessage: notificationMessage,
	      setNotificationMessage: setNotificationMessage,
	      tabsContainer: _react2.default.createElement(_components.TabsContainer, {
	        id: 'api-proxy-tab-container',
	        useTabId: true,
	        tabValue: currentTab,
	        tabItems: tabs,
	        handleTabChange: handleChange
	      }),
	      pageHeaderRef: headerRef,
	      pageHeaderTitle: proxyUuid ? _labels.EDIT_PROXY_LABEL + ': ' + currentProxyName : _labels.ADD_PROXY_LABEL,
	      pageContent: _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _components.TabPanel,
	          {
	            id: 'details-tab-panel',
	            visible: currentTab === 'details-tab'
	          },
	          _react2.default.createElement(_Details2.default, Object.assign({}, props, {
	            proxyNameUniqueStatus: proxyNameUniqueStatus,
	            currentProxyName: currentProxyName,
	            setCurrentProxyName: setCurrentProxyName,
	            currentApiProxyType: currentApiProxyType,
	            setCurrentApiProxyType: setCurrentApiProxyType,
	            currentApiKeyProxyType: currentApiKeyProxyType,
	            setCurrentApiKeyProxyType: setCurrentApiKeyProxyType,
	            proxyDetails: proxyDetails,
	            config: config,
	            dispatch: dispatch,
	            errors: pageErrors
	          }))
	        ),
	        _react2.default.createElement(
	          _components.TabPanel,
	          {
	            id: 'organization-assignment-tab-panel',
	            visible: currentTab === 'organization-assignment-tab'
	          },
	          _react2.default.createElement(_OrganizationAssignment2.default, Object.assign({}, props, {
	            orgs: organizations,
	            selectedOrgs: selectedOrgs,
	            setSelectedOrgs: setSelectedOrgs
	          }))
	        )
	      ),
	      rightSidebarId: 'api-proxy-right-sidebar',
	      helpItems: currentTab === 'details-tab' ? getHelpItems(0) : getHelpItems(1)
	    }),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      onCancelClick: onCancel,
	      nextText: currentTab === 'details-tab' ? intl.getI18nMessage('label.save.and.next.button') : intl.getI18nMessage('label.save.button'),
	      id: 'api-proxy-form-buttons'
	    })
	  );
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    config: (0, _portalConfig.getConfig)(state),
	    proxyUuid: (0, _apiProxy2.getProxyUuid)(state),
	    proxyName: (0, _apiProxy2.getProxyName)(state),
	    proxyNameUniqueStatus: (0, _apiProxy2.getProxyNameUniqueStatus)(state),
	    apiProxyType: (0, _apiProxy2.getApiProxyType)(state),
	    apiKeyProxyType: (0, _apiProxy2.getApiKeyProxyType)(state),
	    proxyDetails: (0, _apiProxy2.getProxyDetails)(state),
	    organizations: (0, _apiProxy2.getOrganizations)(state),
	    selectedOrganizations: (0, _apiProxy2.getSelectedOrganizations)(state),
	    saveProxyStatus: (0, _apiProxy2.getSaveProxyStatus)(state),
	    updateKeyDeploymentTypeStatus: (0, _apiProxy2.getUpdateKeyDeploymentTypeStatus)(state),
	    updateProxyOrgsStatus: (0, _apiProxy2.getUpdateProxyOrgsStatus)(state),
	    isLoading: (0, _apiProxy2.getIsLoading)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  saveProxy: _apiProxy.saveProxy,
	  updateProxyOrganizations: _apiProxy.updateProxyOrganizations,
	  fetchProxyDetails: _apiProxy.fetchProxyDetails,
	  fetchProxyDeploymentTypes: _apiProxy.fetchProxyDeploymentTypes,
	  fetchAllOrganizations: _apiProxy.fetchAllOrganizations,
	  fetchSelectedOrganizations: _apiProxy.fetchSelectedOrganizations
	};
	
	ApiProxy.propTypes = {
	  config: _propTypes2.default.shape({}),
	  proxyUuid: _propTypes2.default.string,
	  proxyName: _propTypes2.default.string,
	  proxyNameUniqueStatus: _propTypes2.default.string,
	  apiProxyType: _propTypes2.default.string,
	  apiKeyProxyType: _propTypes2.default.string,
	  proxyDetails: _propTypes2.default.shape({}),
	  organizations: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  selectedOrganizations: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  saveProxyStatus: _propTypes2.default.string,
	  updateKeyDeploymentTypeStatus: _propTypes2.default.string,
	  updateProxyOrgsStatus: _propTypes2.default.string,
	  isLoading: _propTypes2.default.bool,
	  history: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ApiProxy);

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    pageTitle: {
	      color: (0, _lodash.get)(color, 'pageTitle'),
	      fontFamily: (0, _lodash.get)(typography, 'pageTitle'),
	      fontSize: (0, _lodash.get)(fontSize, 'pageTitle'),
	      marginTop: 6
	    },
	    sectionTitle: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'sectionTitle')
	    },
	    fieldContainer: {
	      margin: '20px 0'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _labels = __webpack_require__(198);
	
	var tabs = [{
	  id: 'details',
	  label: _labels.DETAILS_TAB_TITLE
	}, {
	  id: 'organization-assignment',
	  label: _labels.ORG_ASSIGNMENT_TAB_TITLE,
	  isDisabled: function isDisabled(proxyUuid) {
	    return (0, _lodash.isEmpty)(proxyUuid);
	  }
	}];
	
	exports.default = (0, _lodash.map)(tabs, function (tab) {
	  return Object.assign({}, tab, { tabId: tab.id + '-tab' });
	});

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionsRaw = exports.processErrors = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _lodash = __webpack_require__(8);
	
	var _reactIntl = __webpack_require__(16);
	
	var _List = __webpack_require__(162);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(163);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemText = __webpack_require__(226);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _ClickAwayListener = __webpack_require__(109);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Collapse = __webpack_require__(70);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _ExpandLess = __webpack_require__(114);
	
	var _ExpandLess2 = _interopRequireDefault(_ExpandLess);
	
	var _ExpandMore = __webpack_require__(81);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _components = __webpack_require__(17);
	
	var _application = __webpack_require__(102);
	
	var _application2 = __webpack_require__(86);
	
	var _constants = __webpack_require__(14);
	
	var _utils = __webpack_require__(18);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1587);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var processErrors = exports.processErrors = function processErrors(arrErrors, defaultMessage) {
	  var errorMessage = defaultMessage;
	  if (arrErrors.length > 0) {
	    errorMessage = (0, _lodash.map)(arrErrors, function (validationError) {
	      return validationError.error;
	    }).join('\n');
	  }
	  return errorMessage;
	};
	
	var ActionsRaw = exports.ActionsRaw = function ActionsRaw(props) {
	  var applicationDetails = props.applicationDetails,
	      isEditAppDisabled = props.isEditAppDisabled,
	      isEditAppKeysDisabled = props.isEditAppKeysDisabled,
	      setNotificationStatus = props.setNotificationStatus,
	      setNotificationMessage = props.setNotificationMessage,
	      deleteAppStatus = props.deleteAppStatus,
	      isMultiKeySupport = props.isMultiKeySupport,
	      referrerUrl = props.referrerUrl,
	      errors = props.errors,
	      history = props.history,
	      user = props.user,
	      classes = props.classes;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  var handleClick = function handleClick() {
	    setOpen(!open);
	  };
	  var handleClickAway = function handleClickAway() {
	    setOpen(false);
	  };
	  var appUuid = (0, _lodash.get)(applicationDetails, 'uuid');
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  // canEdit
	  var status = (0, _lodash.get)(applicationDetails, 'status');
	  var editPendingApproval = status === _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL;
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showDeleteAppDialog = _useState4[0],
	      setShowDeleteAppDialog = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      showLoadingDialog = _useState6[0],
	      setShowLoadingDialog = _useState6[1];
	
	  var openDeleteAppDialog = function openDeleteAppDialog() {
	    return setShowDeleteAppDialog(true);
	  };
	  var closeDeleteAppDialog = function closeDeleteAppDialog() {
	    return setShowDeleteAppDialog(false);
	  };
	  var openLoadingDialog = function openLoadingDialog() {
	    return setShowLoadingDialog(true);
	  };
	  var closeLoadingDialog = function closeLoadingDialog() {
	    return setShowLoadingDialog(false);
	  };
	
	  var deleteApp = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return props.deleteApplication(applicationDetails);
	
	            case 2:
	              closeLoadingDialog();
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function deleteApp() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var actions = [{
	    key: '1',
	    value: 'Edit Application',
	    disabled: isEditAppDisabled,
	    onClick: function onClick() {
	      props.resetDeleteApplicationStatus();
	      history.push('/publish/applications/edit/' + appUuid);
	    },
	    visible: true
	  }, {
	    key: '2',
	    value: 'Edit API Assignment',
	    disabled: isEditAppDisabled,
	    onClick: function onClick() {
	      props.resetDeleteApplicationStatus();
	      history.push('/publish/applications/edit/' + appUuid + '/api-management');
	    },
	    visible: true
	  }, {
	    key: '3',
	    value: 'Edit Keys',
	    disabled: isEditAppKeysDisabled,
	    onClick: function onClick() {
	      props.resetDeleteApplicationStatus();
	      history.push('/publish/applications/edit/' + appUuid + '/keys');
	    },
	    visible: isMultiKeySupport && (0, _utils.hasPublisherRole)(user)
	  }, {
	    key: '4',
	    value: 'Delete Application',
	    disabled: editPendingApproval,
	    onClick: function onClick() {
	      return openDeleteAppDialog();
	    },
	    visible: (0, _utils.getUserRole)(user) !== _constants.ROLE_DEVELOPER
	  }];
	
	  var isDevUrl = referrerUrl.indexOf('/dev/') !== -1;
	  (0, _react.useEffect)(function () {
	    if (deleteAppStatus === _constants.SUCCESS) {
	      var redirectUrl = '';
	      if (isDevUrl) {
	        redirectUrl = '/dev/apps';
	      } else {
	        redirectUrl = (0, _utils.hasOrgBoundRole)(user) ? '/admin/app/applications' : '/admin/applications';
	      }
	      window.location.href = redirectUrl;
	    } else if (deleteAppStatus === _constants.FAIL) {
	      var defaultErrorMessage = 'There was an error deleting this application.';
	      var errorMessage = processErrors(errors, defaultErrorMessage);
	      setNotificationStatus('error');
	      setNotificationMessage(errorMessage);
	    }
	  }, [deleteAppStatus]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.actionsContainer,
	      id: 'app-details-actions-container', 'data-layer7-test': 'app-details-actions-container'
	    },
	    _react2.default.createElement(_components.AlertDialog, {
	      isOpen: showDeleteAppDialog,
	      title: intl.getI18nMessage('label.application.delete'),
	      description: intl.getI18nMessage('label.application.delete.confirmation.text'),
	      submitText: intl.getI18nMessage('label.ok.button'),
	      cancelText: intl.getI18nMessage('label.cancel.button'),
	      onClose: closeDeleteAppDialog,
	      onSubmit: function onSubmit() {
	        closeDeleteAppDialog();
	        openLoadingDialog();
	        deleteApp();
	      },
	      onCancel: closeDeleteAppDialog,
	      dialogId: 'app-delete-dialog'
	    }),
	    _react2.default.createElement(_components.LoadingDialog, {
	      isOpen: showLoadingDialog,
	      title: intl.getI18nMessage('label.application.deleting'),
	      description: intl.getI18nMessage('label.application.deleting.status.text'),
	      dialogId: 'deleting-app-dialog'
	    }),
	    _react2.default.createElement(
	      _ClickAwayListener2.default,
	      { onClickAway: handleClickAway },
	      _react2.default.createElement(
	        _List2.default,
	        { component: 'nav' },
	        _react2.default.createElement(
	          _ListItem2.default,
	          { classes: { root: classes.listButton }, button: true, onClick: handleClick },
	          _react2.default.createElement(_ListItemText2.default, { primary: 'Actions' }),
	          open ? _react2.default.createElement(_ExpandLess2.default, null) : _react2.default.createElement(_ExpandMore2.default, null)
	        ),
	        _react2.default.createElement(
	          _Collapse2.default,
	          { className: classes.collapseContainer, 'in': open, unmountOnExit: true },
	          actions.filter(function (_ref2) {
	            var visible = _ref2.visible;
	            return visible;
	          }).map(function (obj) {
	            return _react2.default.createElement(
	              _List2.default,
	              { key: obj.key, component: 'div', disablePadding: true },
	              _react2.default.createElement(
	                _ListItem2.default,
	                {
	                  button: true,
	                  disabled: obj.disabled,
	                  onClick: obj.onClick,
	                  className: classes.listItem,
	                  'data-layer7-test': obj.value
	                },
	                _react2.default.createElement(_ListItemText2.default, { primary: obj.value })
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    deleteAppStatus: (0, _application2.getDeleteApplicationStatus)(state),
	    errors: (0, _application2.getErrors)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  resetDeleteApplicationStatus: _application.resetDeleteApplicationStatus,
	  deleteApplication: _application.deleteApplication
	};
	
	ActionsRaw.propTypes = {
	  applicationDetails: _propTypes2.default.shape({}),
	  isEditAppDisabled: _propTypes2.default.bool,
	  isEditAppKeysDisabled: _propTypes2.default.bool,
	  setNotificationMessage: _propTypes2.default.func,
	  setNotificationStatus: _propTypes2.default.func,
	  deleteAppStatus: _propTypes2.default.string,
	  isMultiKeySupport: _propTypes2.default.bool,
	  referrerUrl: _propTypes2.default.string,
	  user: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  history: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ActionsRaw);

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color;
	  return {
	    actionsContainer: {
	      display: 'inline-block',
	      float: 'right',
	      backgroundColor: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      borderColor: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      color: (0, _lodash.get)(color, 'primaryButtonText') + ' !important',
	      margin: '0 36px',
	      borderRadius: 4,
	      '& nav': {
	        padding: 0,
	        '& > div > div > span': {
	          color: (0, _lodash.get)(color, 'primaryButtonText')
	        }
	      },
	      minWidth: 160
	    },
	    collapseContainer: {
	      position: 'absolute',
	      width: '100%',
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderRadius: 4,
	      zIndex: 1
	    },
	    listButton: {
	      paddingTop: 5,
	      paddingBottom: 5
	    },
	    listItem: {
	      color: (0, _lodash.get)(color, 'link'),
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderRadius: 4
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderTitle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _core = __webpack_require__(3);
	
	var _Card = __webpack_require__(129);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContent = __webpack_require__(130);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _Link = __webpack_require__(161);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Typography = __webpack_require__(43);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Divider = __webpack_require__(91);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Lens = __webpack_require__(172);
	
	var _Lens2 = _interopRequireDefault(_Lens);
	
	var _portalStatusMapper = __webpack_require__(1713);
	
	var _labels = __webpack_require__(199);
	
	var _styles = __webpack_require__(613);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderTitle = exports.renderTitle = function renderTitle() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var uuid = arguments[1];
	  var classes = arguments[2];
	  return _react2.default.createElement(
	    'span',
	    { className: classes.linkWrapper },
	    _react2.default.createElement(
	      _Link2.default,
	      { href: '/publish/apis/details/' + uuid },
	      _react2.default.createElement(
	        'h4',
	        { className: classes.cardTitle },
	        name
	      )
	    )
	  );
	};
	
	var redirectToEditApplication = function redirectToEditApplication(appUuid, history) {
	  history.push('/publish/applications/edit/' + appUuid + '/api-management');
	};
	
	var ApiCard = function ApiCard(_ref) {
	  var appUuid = _ref.appUuid,
	      _ref$details = _ref.details,
	      uuid = _ref$details.uuid,
	      name = _ref$details.name,
	      status = _ref$details.status,
	      version = _ref$details.version,
	      description = _ref$details.description,
	      isEditAppDisabled = _ref.isEditAppDisabled,
	      featureFlagApiPlan = _ref.featureFlagApiPlan,
	      apiPlan = _ref.apiPlan,
	      history = _ref.history,
	      classes = _ref.classes;
	
	  var statusLabel = (0, _portalStatusMapper.getApiStatusLabel)(status);
	  var statusColor = (0, _portalStatusMapper.getApiStatusColor)(status);
	  var statusStyle = {
	    color: statusColor
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _Card2.default,
	      { className: classes.card, id: uuid },
	      _react2.default.createElement(
	        _CardContent2.default,
	        null,
	        _react2.default.createElement(
	          _Typography2.default,
	          null,
	          renderTitle(name, uuid, classes)
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { style: statusStyle, className: (0, _classnames2.default)(classes.cardStatus) },
	          _react2.default.createElement(_Lens2.default, { className: classes.cardStatusIcon }),
	          ' ',
	          statusLabel,
	          '\xA0 \xA0',
	          _react2.default.createElement(
	            'span',
	            { className: classes.versionText },
	            _labels.VERSION_TEXT,
	            ': ',
	            version
	          )
	        ),
	        _react2.default.createElement(_Divider2.default, null),
	        featureFlagApiPlan && _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.cardDescription },
	          apiPlan ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _get2.default)(apiPlan, 'name')
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: (0, _classnames2.default)(classes.linkWrapper, classes.leftMargin, isEditAppDisabled ? classes.disabledClass : '')
	              },
	              _react2.default.createElement(
	                _Link2.default,
	                { onClick: function onClick() {
	                    return redirectToEditApplication(appUuid, history);
	                  } },
	                _labels.CHANGE_ACTION_TEXT
	              )
	            )
	          ) : _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)(classes.linkWrapper, isEditAppDisabled ? classes.disabledClass : '')
	            },
	            _react2.default.createElement(
	              _Link2.default,
	              { onClick: function onClick() {
	                  return redirectToEditApplication(appUuid, history);
	                } },
	              _labels.ADD_APIPLAN_ACTION_TEXT
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.cardDescription },
	          description
	        )
	      )
	    )
	  );
	};
	
	ApiCard.propTypes = {
	  appUuid: _propTypes2.default.string,
	  details: _propTypes2.default.shape({
	    uuid: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    status: _propTypes2.default.string,
	    version: _propTypes2.default.string,
	    description: _propTypes2.default.string
	  }),
	  isEditAppDisabled: _propTypes2.default.bool,
	  featureFlagApiPlan: _propTypes2.default.string,
	  apiPlan: _propTypes2.default.shape({}),
	  history: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(ApiCard);

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApisRaw = exports.getApiApiPlanMapping = exports.getAppApiGroupsApisList = exports.getAppApisList = exports.getApiPlan = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _uniq = __webpack_require__(99);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _flatMap = __webpack_require__(1365);
	
	var _flatMap2 = _interopRequireDefault(_flatMap);
	
	var _union = __webpack_require__(1380);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _map = __webpack_require__(273);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _core = __webpack_require__(3);
	
	var _Box = __webpack_require__(221);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _application = __webpack_require__(102);
	
	var _application2 = __webpack_require__(86);
	
	var _ApiCard = __webpack_require__(1588);
	
	var _ApiCard2 = _interopRequireDefault(_ApiCard);
	
	var _styles = __webpack_require__(613);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getApiPlan = exports.getApiPlan = function getApiPlan(apiUuid, apiApiPlanMapping, allApiPlans) {
	  var apiPlanId = apiApiPlanMapping.find(function (item) {
	    return item.ApiUuid === apiUuid;
	  });
	  var apiPlan = allApiPlans.find(function (item) {
	    return item.uuid === apiPlanId.ApiPlanUuid;
	  });
	
	  return apiPlan;
	};
	var getAppApisList = exports.getAppApisList = function getAppApisList(app) {
	  return (0, _get2.default)(app, 'ApiIds.results', []);
	};
	var getAppApiGroupsApisList = exports.getAppApiGroupsApisList = function getAppApiGroupsApisList(list) {
	  return (0, _uniq2.default)((0, _flatMap2.default)(list, function (_ref) {
	    var apis = _ref.apis;
	    return (0, _map2.default)(apis, function (api) {
	      return api.uuid;
	    });
	  }));
	};
	var getApiApiPlanMapping = exports.getApiApiPlanMapping = function getApiApiPlanMapping(app) {
	  return (0, _get2.default)(app, 'ApiApiPlanIds.results', []);
	};
	
	var ApisRaw = exports.ApisRaw = function ApisRaw(props) {
	  var appUuid = props.appUuid,
	      singleApplication = props.singleApplication,
	      isEditAppDisabled = props.isEditAppDisabled,
	      _props$allApis = props.allApis,
	      allApis = _props$allApis === undefined ? [] : _props$allApis,
	      _props$allApiPlans = props.allApiPlans,
	      allApiPlans = _props$allApiPlans === undefined ? [] : _props$allApiPlans,
	      selectedApiGroups = props.selectedApiGroups,
	      isDevUrl = props.isDevUrl,
	      featureFlagApiPlan = props.featureFlagApiPlan,
	      user = props.user,
	      history = props.history,
	      classes = props.classes;
	
	
	  (0, _react.useEffect)(function () {
	    if (singleApplication && singleApplication.ApiIds) {
	      var apiList = getAppApisList(singleApplication);
	      var apiGroupsList = getAppApiGroupsApisList(selectedApiGroups);
	      var selectedApis = (0, _union2.default)(apiList, apiGroupsList);
	      if (appUuid) {
	        props.fetchAvailableApis({ tags: '', id: selectedApis });
	        props.fetchSelectedApiGroups(appUuid);
	      }
	      if (featureFlagApiPlan) {
	        props.fetchAllApiPlans();
	      }
	    }
	  }, [singleApplication]);
	
	  var apiApiPlanMapping = getApiApiPlanMapping(singleApplication);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.appApisContainer,
	      id: 'app-apis-container', 'data-layer7-test': 'app-apis-container'
	    },
	    allApis.map(function (obj, idx) {
	      return _react2.default.createElement(
	        _Box2.default,
	        { key: appUuid, width: '25%', className: classes.apiCard },
	        _react2.default.createElement(_ApiCard2.default, {
	          index: idx,
	          appUuid: appUuid,
	          details: {
	            uuid: (0, _get2.default)(obj, 'uuid'),
	            name: (0, _get2.default)(obj, 'name'),
	            status: (0, _get2.default)(obj, 'portalStatus'),
	            version: (0, _get2.default)(obj, 'version'),
	            description: (0, _get2.default)(obj, 'description')
	          },
	          isEditAppDisabled: isEditAppDisabled,
	          featureFlagApiPlan: featureFlagApiPlan,
	          apiPlan: getApiPlan((0, _get2.default)(obj, 'uuid'), apiApiPlanMapping, allApiPlans),
	          isDevUrl: isDevUrl,
	          user: user,
	          history: history,
	          classes: classes
	        })
	      );
	    })
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    allApis: (0, _application2.getAvailableApis)(state),
	    selectedApiGroups: (0, _application2.getSelectedApiGroups)(state),
	    allApiPlans: (0, _application2.getAllApiPlans)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchAvailableApis: _application.fetchAvailableApis,
	  fetchSelectedApiGroups: _application.fetchSelectedApiGroups,
	  fetchAllApiPlans: _application.fetchAllApiPlans
	};
	
	ApisRaw.propTypes = {
	  appUuid: _propTypes2.default.string,
	  applicationDetails: _propTypes2.default.shape({}),
	  singleApplication: _propTypes2.default.shape({}),
	  isEditAppDisabled: _propTypes2.default.bool,
	  allApis: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  allApiPlans: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  selectedApiGroups: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  featureFlagApiPlan: _propTypes2.default.string,
	  history: _propTypes2.default.shape({}),
	  user: _propTypes2.default.shape({}),
	  isDevUrl: _propTypes2.default.bool,
	  classes: _propTypes2.default.shape({})
	};
	ApisRaw.displayName = 'Apis';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ApisRaw);

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConfigurationRaw = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(16);
	
	var _changeCase = __webpack_require__(116);
	
	var _core = __webpack_require__(3);
	
	var _Link = __webpack_require__(161);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Typography = __webpack_require__(43);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Grid = __webpack_require__(71);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Table = __webpack_require__(230);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _TableBody = __webpack_require__(231);
	
	var _TableBody2 = _interopRequireDefault(_TableBody);
	
	var _TableCell = __webpack_require__(167);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _TableContainer = __webpack_require__(232);
	
	var _TableContainer2 = _interopRequireDefault(_TableContainer);
	
	var _TableHead = __webpack_require__(233);
	
	var _TableHead2 = _interopRequireDefault(_TableHead);
	
	var _TableRow = __webpack_require__(234);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Chip = __webpack_require__(157);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Collapse = __webpack_require__(70);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _KeyboardArrowDown = __webpack_require__(170);
	
	var _KeyboardArrowDown2 = _interopRequireDefault(_KeyboardArrowDown);
	
	var _KeyboardArrowUp = __webpack_require__(171);
	
	var _KeyboardArrowUp2 = _interopRequireDefault(_KeyboardArrowUp);
	
	var _components = __webpack_require__(17);
	
	var _intl = __webpack_require__(15);
	
	var _labels = __webpack_require__(199);
	
	var _styles = __webpack_require__(1591);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var displayItem = function displayItem(applicationDetails, classes, item) {
	  var value = (0, _get2.default)(applicationDetails, item.key) || '';
	  return _react2.default.createElement(
	    'div',
	    { key: item.id, id: item.id, className: classes.leftPanelItemContainer },
	    _react2.default.createElement(
	      _Typography2.default,
	      { className: classes.leftPanelTitle },
	      item.label
	    ),
	    item.type === 'link' ? _react2.default.createElement(
	      _Link2.default,
	      { href: value },
	      value
	    ) : _react2.default.createElement(
	      _Typography2.default,
	      { className: classes.leftPanelDesc },
	      item.useSentenceCase ? (0, _changeCase.sentenceCase)(value) : value
	    )
	  );
	};
	
	var items = [{
	  id: 'app-client-id',
	  key: 'apiKey',
	  label: (0, _intl.getI18nFormattedMessage)('label.application.key')
	}, {
	  id: 'app-shared-secret',
	  key: 'keySecret',
	  label: (0, _intl.getI18nFormattedMessage)('label.application.key.shared.secret')
	}, {
	  id: 'app-status',
	  key: 'status',
	  label: 'Status',
	  useSentenceCase: true
	}, {
	  id: 'app-oauth-callback-url',
	  key: 'oauthCallbackUrl',
	  label: 'OAuth Callback URL(s)',
	  type: 'link'
	}, {
	  id: 'app-oauth-scope',
	  key: 'oauthScope',
	  label: 'OAuth Scope'
	}, {
	  id: 'app-oauth-type',
	  key: 'oauthType',
	  label: 'OAuth Type',
	  useSentenceCase: true
	}];
	
	var SingleKeyView = function SingleKeyView(_ref) {
	  var keyDetails = _ref.keyDetails,
	      classes = _ref.classes;
	  return _react2.default.createElement(
	    _Grid2.default,
	    { container: true },
	    _react2.default.createElement(
	      _Grid2.default,
	      { item: true, xs: 8, className: classes.leftPanel },
	      items.map(function (item) {
	        return displayItem(keyDetails, classes, item);
	      })
	    )
	  );
	};
	
	SingleKeyView.propTypes = {
	  keyDetails: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	
	var SingleRow = function SingleRow(_ref2) {
	  var row = _ref2.row,
	      idx = _ref2.idx,
	      classes = _ref2.classes;
	
	  var _useState = (0, _react.useState)(idx === 0),
	      _useState2 = _slicedToArray(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _TableRow2.default,
	      { onClick: function onClick() {
	          return setOpen(!open);
	        } },
	      _react2.default.createElement(
	        _TableCell2.default,
	        { component: 'th', scope: 'row' },
	        row.name,
	        (0, _get2.default)(row, 'defaultKey') && _react2.default.createElement(_Chip2.default, {
	          className: classes.defaultChip,
	          size: 'small',
	          label: 'Default'
	        })
	      ),
	      _react2.default.createElement(
	        _TableCell2.default,
	        { component: 'th', scope: 'row', align: 'center' },
	        _react2.default.createElement(_Chip2.default, {
	          className: (0, _get2.default)(row, 'status') === _labels.KEY_STATUS_ENABLED ? classes.enabledChip : classes.disabledChip,
	          size: 'small',
	          label: (0, _changeCase.sentenceCase)((0, _get2.default)(row, 'status'))
	        })
	      ),
	      _react2.default.createElement(
	        _TableCell2.default,
	        null,
	        _react2.default.createElement(
	          _IconButton2.default,
	          { className: classes.expandCollapseButton, size: 'small', onClick: function onClick() {
	              return setOpen(!open);
	            } },
	          open ? _react2.default.createElement(_KeyboardArrowUp2.default, null) : _react2.default.createElement(_KeyboardArrowDown2.default, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _TableRow2.default,
	      null,
	      _react2.default.createElement(
	        _TableCell2.default,
	        { style: { paddingBottom: 0, paddingTop: 0 }, colSpan: 6 },
	        _react2.default.createElement(
	          _Collapse2.default,
	          { 'in': open, timeout: 'auto', unmountOnExit: true },
	          _react2.default.createElement(SingleKeyView, {
	            keyDetails: row,
	            classes: classes
	          })
	        )
	      )
	    )
	  );
	};
	
	SingleRow.propTypes = {
	  row: _propTypes2.default.number,
	  idx: _propTypes2.default.number,
	  classes: _propTypes2.default.shape({})
	};
	
	var GRID_ROWS_PER_PAGE_OPTIONS = [10, 20];
	var GRID_ROWS_PER_PAGE_DEFAULT_OPTION = 10;
	
	var ConfigurationRaw = exports.ConfigurationRaw = function ConfigurationRaw(_ref3) {
	  var applicationUuid = _ref3.applicationUuid,
	      applicationDetails = _ref3.applicationDetails,
	      fetchApplicationKeys = _ref3.fetchApplicationKeys,
	      appKeys = _ref3.appKeys,
	      appKeysTotalPages = _ref3.appKeysTotalPages,
	      appKeysTotalElements = _ref3.appKeysTotalElements,
	      isMultiKeySupport = _ref3.isMultiKeySupport,
	      classes = _ref3.classes;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var rows = isMultiKeySupport ? appKeys : [];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      page = _useState4[0],
	      setPage = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState6 = _slicedToArray(_useState5, 2),
	      rowsPerPage = _useState6[0],
	      setRowsPerPage = _useState6[1];
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    fetchApplicationKeys(applicationUuid, newPage, rowsPerPage);
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    fetchApplicationKeys(applicationUuid, 0, newRowsPerPage);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'app-configuration-container', className: classes.appConfigurationContainer },
	    isMultiKeySupport ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _TableContainer2.default,
	        null,
	        _react2.default.createElement(
	          _Table2.default,
	          { 'aria-label': 'collapsible table' },
	          _react2.default.createElement(
	            _TableHead2.default,
	            { className: classes.tableHead },
	            _react2.default.createElement(
	              _TableRow2.default,
	              null,
	              _react2.default.createElement(
	                _TableCell2.default,
	                null,
	                _labels.KEY_NAME_LABEL
	              ),
	              _react2.default.createElement(
	                _TableCell2.default,
	                { align: 'center' },
	                _labels.STATUS_LABEL
	              ),
	              _react2.default.createElement(_TableCell2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _TableBody2.default,
	            null,
	            rows.map(function (row, idx) {
	              return _react2.default.createElement(SingleRow, { key: idx, row: row, idx: idx, classes: classes });
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.paginationContainer },
	        _react2.default.createElement(_components.TablePagination, {
	          id: 'app-configuration-keys-pagination',
	          'data-apim-test': 'app-configuration-keys-pagination',
	          page: page,
	          count: appKeysTotalElements,
	          pageCount: appKeysTotalPages,
	          rowsPerPage: rowsPerPage,
	          rowsPerPageOptions: GRID_ROWS_PER_PAGE_OPTIONS,
	          onChangeRowsPerPage: onChangeRowsPerPage,
	          onChangePage: onChangePage,
	          onChangePreviousPage: onChangePreviousPage,
	          onChangeNextPage: onChangeNextPage,
	          labelRowsPerPage: intl.getI18nMessage('label.pagination.rows.per.page')
	        })
	      )
	    ) : _react2.default.createElement(SingleKeyView, {
	      keyDetails: applicationDetails,
	      classes: classes
	    })
	  );
	};
	
	ConfigurationRaw.propTypes = {
	  applicationUuid: _propTypes2.default.string,
	  applicationDetails: _propTypes2.default.shape({}),
	  fetchApplicationKeys: _propTypes2.default.func,
	  appKeys: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  appKeysTotalPages: _propTypes2.default.number,
	  appKeysTotalElements: _propTypes2.default.number,
	  isMultiKeySupport: _propTypes2.default.bool,
	  classes: _propTypes2.default.shape({})
	};
	ConfigurationRaw.displayName = 'Configuration';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(ConfigurationRaw);

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    appConfigurationContainer: {
	      padding: '0 36px',
	      '& table': {
	        backgroundColor: (0, _lodash.get)(color, 'uiBackground')
	      },
	      '& tr': {
	        borderTop: '1px solid ' + (0, _lodash.get)(color, 'borderColor')
	      },
	      '& th': {
	        color: (0, _lodash.get)(color, 'primaryButtonBackground'),
	        padding: 12,
	        cursor: 'pointer',
	        border: 'none'
	      },
	      '& td': {
	        padding: 12,
	        border: 'none'
	      }
	    },
	    expandCollapseButton: {
	      color: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      float: 'right'
	    },
	    tableHead: {
	      '& th': {
	        color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontWeight: 'bold !important',
	        cursor: 'auto'
	      }
	    },
	    paginationContainer: {
	      margin: '0 !important',
	      '& .MuiTablePagination-toolbar': {
	        margin: '0 !important'
	      }
	    },
	    defaultChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'bodyText'), 0.05) + ' !important',
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    },
	    enabledChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'success')) + ' !important',
	      color: (0, _lodash.get)(color, 'white') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    },
	    disabledChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'error')) + ' !important',
	      color: (0, _lodash.get)(color, 'white') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    },
	    leftPanel: {
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground') + ' !important',
	      width: '80%',
	      padding: 20,
	      '& a': {
	        color: (0, _lodash.get)(color, 'link')
	      },
	      wordBreak: 'break-all'
	    },
	    leftPanelItemContainer: {
	      marginTop: '10px !important',
	      marginBottom: '10px !important'
	    },
	    leftPanelTitle: {
	      backgroundColor: 'transparent !important',
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontWeight: 'bold !important',
	      outline: 'transparent !important',
	      '-webkit-font-smoothing': 'antialiased',
	      lineHeight: '21px !important'
	    },
	    leftPanelDesc: {
	      backgroundColor: 'transparent !important',
	      lineHeight: '21px !important',
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      outline: 'transparent !important',
	      '-webkit-font-smoothing': 'antialiased'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DeploymentsCard = exports.getStatusColor = exports.formatDateString = exports.renderHelpText = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _changeCase = __webpack_require__(116);
	
	var _reactIntl = __webpack_require__(16);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _core = __webpack_require__(3);
	
	var _Button = __webpack_require__(108);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Card = __webpack_require__(129);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContent = __webpack_require__(130);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _Link = __webpack_require__(161);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Typography = __webpack_require__(43);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Divider = __webpack_require__(91);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Tooltip = __webpack_require__(339);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Lens = __webpack_require__(172);
	
	var _Lens2 = _interopRequireDefault(_Lens);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _AlertDialog = __webpack_require__(197);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _utils = __webpack_require__(18);
	
	var _deployment = __webpack_require__(205);
	
	var _labels = __webpack_require__(199);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(614);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderTitle = function renderTitle() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var uuid = arguments[1];
	  var classes = arguments[2];
	  return _react2.default.createElement(
	    'span',
	    { 'data-test': 'proxy-title', className: classes.linkWrapper },
	    _react2.default.createElement(
	      _Link2.default,
	      { href: '/publish/api-proxy/details/' + uuid },
	      _react2.default.createElement(
	        'h4',
	        { className: classes.cardTitle },
	        ' ',
	        name,
	        ' '
	      )
	    )
	  );
	};
	
	var renderHelpText = exports.renderHelpText = function renderHelpText(classes) {
	  return _react2.default.createElement(
	    'p',
	    { className: classes.helpTextContainer },
	    _react2.default.createElement(
	      'span',
	      { className: classes.boldText },
	      (0, _intl.getI18nFormattedMessage)('label.application.key.deployment.tooltip.title')
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'span',
	      null,
	      (0, _intl.getI18nFormattedMessage)('label.application.key.deployment.tooltip.subtitle')
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: classes.boldText },
	        '\u2022 ',
	        (0, _intl.getI18nFormattedMessage)('label.application.key.deployment.automatic.tooltip.title'),
	        ': '
	      ),
	      (0, _intl.getI18nFormattedMessage)('label.application.key.deployment.automatic.tooltip.subtitle')
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: classes.boldText },
	        '\u2022 ',
	        (0, _intl.getI18nFormattedMessage)('label.application.key.deployment.on.demand.tooltip.title'),
	        ': '
	      ),
	      (0, _intl.getI18nFormattedMessage)('label.application.key.deployment.on.demand.tooltip.subtitle')
	    )
	  );
	};
	
	var formatDateString = exports.formatDateString = function formatDateString(dateString) {
	  if (dateString) {
	    var arrDateFields = dateString.split(' ');
	    var month = arrDateFields[1];
	    var date = arrDateFields[2];
	    var year = arrDateFields[3];
	
	    var formattedTimeString = '';
	    if (arrDateFields[4]) {
	      // time string
	      var arrTimeFields = arrDateFields[4].split(':');
	      var hour = arrTimeFields[0];
	      var mins = arrTimeFields[1];
	      formattedTimeString = hour + ':' + mins;
	    }
	    return month + ' ' + date + ' ' + year + ' ' + formattedTimeString;
	  }
	  return '';
	};
	
	var getStatusColor = exports.getStatusColor = function getStatusColor(errorMessage, status) {
	  var statusLabel = '';
	  var statusColor = '';
	  if (errorMessage) {
	    statusLabel = _labels.DEPLOYMENT_STATUS_LABEL_VALIDATION_ERROR;
	    statusColor = (0, _deployment.getDeployedStatusColor)(_labels.DEPLOYMENT_STATUS_ERROR);
	  } else {
	    statusLabel = status === _labels.DEPLOYMENT_STATUS_ERROR ? _labels.DEPLOYMENT_STATUS_LABEL_DEPLOYMENT_ERROR : (0, _deployment.getDeployedStatusLabel)(status);
	    statusColor = (0, _deployment.getDeployedStatusColor)(status);
	  }
	  return {
	    statusLabel: statusLabel, statusColor: statusColor
	  };
	};
	
	var DeploymentsCard = exports.DeploymentsCard = function DeploymentsCard(_ref) {
	  var index = _ref.index,
	      _ref$details = _ref.details,
	      _ref$details$apiKey = _ref$details.apiKey,
	      apiKey = _ref$details$apiKey === undefined ? '' : _ref$details$apiKey,
	      uuid = _ref$details.uuid,
	      name = _ref$details.name,
	      type = _ref$details.type,
	      status = _ref$details.status,
	      statusMessage = _ref$details.statusMessage,
	      modifyTs = _ref$details.modifyTs,
	      _ref$errorObj = _ref.errorObj,
	      errorObj = _ref$errorObj === undefined ? {} : _ref$errorObj,
	      _ref$refreshTime = _ref.refreshTime,
	      refreshTime = _ref$refreshTime === undefined ? 10 : _ref$refreshTime,
	      deployApiKey = _ref.deployApiKey,
	      redeployApiKey = _ref.redeployApiKey,
	      undeployApiKey = _ref.undeployApiKey,
	      checkStatus = _ref.checkStatus,
	      user = _ref.user,
	      classes = _ref.classes;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showStatusDialog = _useState2[0],
	      setShowStatusDialog = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showConfirmDialog = _useState4[0],
	      setShowConfirmDialog = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      confirmAction = _useState6[0],
	      setConfirmAction = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      updating = _useState8[0],
	      setUpdating = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(parseInt(refreshTime, 10)),
	      _useState10 = _slicedToArray(_useState9, 2),
	      timer = _useState10[0],
	      setTimer = _useState10[1];
	
	  var lastModified = modifyTs ? formatDateString(new Date(modifyTs).toString()) : (0, _intl.getI18nFormattedMessage)('label.not.applicable');
	  // Error Info
	  var errorMessage = (0, _get2.default)(errorObj, 'errorMessage');
	
	  var startAction = function startAction(action) {
	    switch (action) {
	      case _labels.DEPLOYMENT_ACTION_TYPE_DEPLOY:
	        {
	          deployApiKey(apiKey, uuid);
	          break;
	        }
	      case _labels.DEPLOYMENT_ACTION_TYPE_REDEPLOY:
	        {
	          redeployApiKey(apiKey, uuid);
	          break;
	        }
	      case _labels.DEPLOYMENT_ACTION_TYPE_UNDEPLOY:
	        {
	          undeployApiKey(apiKey, uuid);
	          break;
	        }
	      default:
	        {
	          break;
	        }
	    }
	    setUpdating(!updating);
	  };
	
	  var stopAction = function stopAction() {
	    setTimer(refreshTime);
	    setUpdating(false);
	    checkStatus(apiKey);
	  };
	
	  (0, _react.useEffect)(function () {
	    var interval = null;
	    if (updating) {
	      interval = setInterval(function () {
	        setTimer(timer - 1);
	        if (timer === 1) {
	          stopAction();
	          clearInterval(interval);
	        }
	      }, 1000);
	    } else if (!updating && timer !== refreshTime) {
	      clearInterval(interval);
	    }
	    return function () {
	      return clearInterval(interval);
	    };
	  }, [updating, timer]);
	
	  var _getStatusColor = getStatusColor(errorMessage, status),
	      statusLabel = _getStatusColor.statusLabel,
	      statusColor = _getStatusColor.statusColor;
	
	  var statusStyle = { color: statusColor };
	
	  var openStatusDialog = function openStatusDialog() {
	    return setShowStatusDialog(true);
	  };
	  var closeStatusDialog = function closeStatusDialog() {
	    return setShowStatusDialog(false);
	  };
	
	  var openConfirmDialog = function openConfirmDialog(action) {
	    setShowConfirmDialog(true);
	    setConfirmAction(action);
	  };
	
	  var closeConfirmDialog = function closeConfirmDialog() {
	    setShowConfirmDialog(false);
	    setConfirmAction('');
	  };
	
	  var saveConfirmDialog = function saveConfirmDialog() {
	    startAction(confirmAction);
	    closeConfirmDialog();
	  };
	
	  var MofeInfo = function MofeInfo() {
	    return _react2.default.createElement(
	      'span',
	      { 'data-test': 'moreInfoBtn' },
	      _react2.default.createElement(
	        _Button2.default,
	        { onClick: openStatusDialog },
	        _labels.MORE_INFO_TEXT
	      )
	    );
	  };
	
	  var CheckStatus = function CheckStatus() {
	    return _react2.default.createElement(
	      'span',
	      { 'data-test': 'checkStatusBtn' },
	      _react2.default.createElement(
	        _Button2.default,
	        { onClick: stopAction },
	        _labels.CHECK_NOW_TEXT
	      )
	    );
	  };
	
	  var DeploymentActions = function DeploymentActions() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      statusLabel === _labels.DEPLOYMENT_STATUS_LABEL_UNDEPLOYED && _react2.default.createElement(
	        'span',
	        { 'data-test': 'deployBtn' },
	        _react2.default.createElement(
	          _Button2.default,
	          { onClick: function onClick() {
	              return openConfirmDialog(_labels.DEPLOYMENT_ACTION_TYPE_DEPLOY);
	            } },
	          _labels.DEPLOYMENT_ACTION_LABEL_DEPLOY
	        )
	      ),
	      statusLabel !== _labels.DEPLOYMENT_STATUS_LABEL_UNDEPLOYED && _react2.default.createElement(
	        'span',
	        { 'data-test': 'redeployBtn' },
	        _react2.default.createElement(
	          _Button2.default,
	          { onClick: function onClick() {
	              return openConfirmDialog(_labels.DEPLOYMENT_ACTION_TYPE_REDEPLOY);
	            } },
	          _labels.DEPLOYMENT_ACTION_LABEL_REDEPLOY
	        )
	      ),
	      statusLabel !== _labels.DEPLOYMENT_STATUS_LABEL_UNDEPLOYED && _react2.default.createElement(
	        'span',
	        { 'data-test': 'undeployBtn' },
	        _react2.default.createElement(
	          _Button2.default,
	          { onClick: function onClick() {
	              return openConfirmDialog(_labels.DEPLOYMENT_ACTION_TYPE_UNDEPLOY);
	            } },
	          _labels.DEPLOYMENT_ACTION_LABEL_UNDEPLOY
	        )
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    showStatusDialog && _react2.default.createElement(_AlertDialog2.default, {
	      isOpen: showStatusDialog,
	      title: _labels.INFORMATION_TEXT,
	      description: errorMessage || (0, _utils.formatStatusMessage)(statusMessage),
	      submitText: _labels.OK_TEXT,
	      cancelText: _labels.CANCEL_TEXT,
	      onClose: closeStatusDialog,
	      onSubmit: closeStatusDialog,
	      onCancel: closeStatusDialog,
	      showCancel: false,
	      dialogId: 'app-deployment-status-dialog'
	    }),
	    showConfirmDialog && _react2.default.createElement(_AlertDialog2.default, {
	      isOpen: showConfirmDialog,
	      title: _labels.WARNING_TEXT,
	      description: _labels.CONFIRM_ACTION_TEXT,
	      submitText: _labels.OK_TEXT,
	      cancelText: _labels.CANCEL_TEXT,
	      onClose: closeConfirmDialog,
	      onSubmit: saveConfirmDialog,
	      onCancel: closeConfirmDialog,
	      dialogId: 'app-deployment-confirm-dialog'
	    }),
	    _react2.default.createElement(
	      _Card2.default,
	      {
	        id: 'app-deployment-card-' + index, 'data-layer7-test': 'app-deployment-card-' + index,
	        className: classes.card,
	        'data-test': 'app-deployment-card'
	      },
	      _react2.default.createElement(
	        _CardContent2.default,
	        null,
	        _react2.default.createElement(
	          _Typography2.default,
	          null,
	          (0, _utils.hasAdminRole)(user) ? renderTitle(name, uuid, classes) : _react2.default.createElement(
	            'h4',
	            { className: classes.cardTitle },
	            name
	          )
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.cardLastUpdated },
	          intl.getI18nMessage('label.last.updated'),
	          ': ',
	          updating ? intl.getI18nMessage('label.updating') : lastModified
	        ),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.cardType },
	          _react2.default.createElement(
	            'span',
	            { 'data-test': 'deployment-type-label' },
	            _labels.KEY_DEPLOYMENT_TYPE_LABEL
	          ),
	          ': ',
	          (0, _changeCase.capitalCase)(type),
	          _react2.default.createElement(
	            _Tooltip2.default,
	            { title: renderHelpText(classes), arrow: true, placement: 'right' },
	            _react2.default.createElement(_Help2.default, { className: classes.helpIcon })
	          )
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.cardStatus },
	          updating ? _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_Lens2.default, { className: classes.cardStatusIcon }),
	            ' ',
	            _labels.UPDATING_STATUS_TEXT + ' ' + timer + _labels.SECONDS_UNIT_TEXT + '.'
	          ) : _react2.default.createElement(
	            'span',
	            { style: statusStyle },
	            _react2.default.createElement(_Lens2.default, { className: classes.cardStatusIcon }),
	            ' ',
	            statusLabel
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.deploymentButtonsContainer },
	            !updating && (errorMessage || statusMessage) && _react2.default.createElement(MofeInfo, null),
	            type === _labels.APP_DEPLOYMENT_TYPE_ON_DEMAND && _react2.default.createElement(
	              'span',
	              { 'data-test': 'app-deployment-actions' },
	              updating ? _react2.default.createElement(CheckStatus, null) : _react2.default.createElement(DeploymentActions, null)
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	DeploymentsCard.propTypes = {
	  index: _propTypes2.default.number,
	  details: _propTypes2.default.shape({
	    applicationUuid: _propTypes2.default.string,
	    uuid: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    status: _propTypes2.default.string,
	    statusMessage: _propTypes2.default.string,
	    modifyTs: _propTypes2.default.string
	  }),
	  errorObj: _propTypes2.default.shape({}),
	  refreshTime: _propTypes2.default.number,
	  deployApiKey: _propTypes2.default.func,
	  redeployApiKey: _propTypes2.default.func,
	  undeployApiKey: _propTypes2.default.func,
	  checkStatus: _propTypes2.default.func,
	  user: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(DeploymentsCard);

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DeploymentsRaw = exports.getDeploymentList = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(16);
	
	var _changeCase = __webpack_require__(116);
	
	var _Table = __webpack_require__(230);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _TableBody = __webpack_require__(231);
	
	var _TableBody2 = _interopRequireDefault(_TableBody);
	
	var _TableCell = __webpack_require__(167);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _TableContainer = __webpack_require__(232);
	
	var _TableContainer2 = _interopRequireDefault(_TableContainer);
	
	var _TableHead = __webpack_require__(233);
	
	var _TableHead2 = _interopRequireDefault(_TableHead);
	
	var _TableRow = __webpack_require__(234);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Box = __webpack_require__(221);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Chip = __webpack_require__(157);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Button = __webpack_require__(108);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Collapse = __webpack_require__(70);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _KeyboardArrowDown = __webpack_require__(170);
	
	var _KeyboardArrowDown2 = _interopRequireDefault(_KeyboardArrowDown);
	
	var _KeyboardArrowUp = __webpack_require__(171);
	
	var _KeyboardArrowUp2 = _interopRequireDefault(_KeyboardArrowUp);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _intl = __webpack_require__(15);
	
	var _application = __webpack_require__(102);
	
	var _application2 = __webpack_require__(86);
	
	var _portalConfig = __webpack_require__(85);
	
	var _portalConfig2 = __webpack_require__(26);
	
	var _utils = __webpack_require__(18);
	
	var _DeploymentCard = __webpack_require__(1592);
	
	var _DeploymentCard2 = _interopRequireDefault(_DeploymentCard);
	
	var _labels = __webpack_require__(199);
	
	var _styles = __webpack_require__(614);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDeploymentList = exports.getDeploymentList = function getDeploymentList() {
	  var deployments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var apiKeyProxies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var combinedList = [];
	  deployments.map(function (deployment) {
	    var matchedDeployment = apiKeyProxies.find(function (apiKeyDeployment) {
	      return apiKeyDeployment.proxyUuid === deployment.uuid;
	    });
	    if (matchedDeployment) {
	      combinedList.push(Object.assign({}, matchedDeployment, deployment));
	    } else {
	      combinedList.push(Object.assign({}, deployment));
	    }
	    return true;
	  });
	  return combinedList;
	};
	
	var SingleKeyView = function SingleKeyView(props) {
	  var applicationUuid = props.applicationUuid,
	      apiKey = props.apiKey,
	      _props$deploymentList = props.deploymentList,
	      deploymentList = _props$deploymentList === undefined ? [] : _props$deploymentList,
	      deploymentErrors = props.deploymentErrors,
	      user = props.user,
	      history = props.history,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    deploymentList.length > 0 ? deploymentList.map(function (obj, idx) {
	      return _react2.default.createElement(
	        _Box2.default,
	        { key: obj.uuid, width: '25%', className: classes.deploymentCard },
	        _react2.default.createElement(_DeploymentCard2.default, {
	          index: idx,
	          details: {
	            applicationUuid: applicationUuid,
	            apiKey: apiKey,
	            uuid: obj.uuid,
	            name: obj.name,
	            type: obj.appDeploymentType,
	            status: obj.status,
	            statusMessage: obj.message,
	            modifyTs: obj.lastTimeDeployed
	          },
	          errorObj: deploymentErrors.find(function (err) {
	            return err.proxyUuid === obj.uuid && err.apiKey === apiKey;
	          }),
	          refreshTime: props.refreshTime,
	          deployApiKey: props.deployApiKeyToProxy,
	          redeployApiKey: props.redeployApiKeyToProxy,
	          undeployApiKey: props.undeployApiKeyFromProxy,
	          checkStatus: props.fetchProxiesByApiKey,
	          user: user,
	          history: history,
	          classes: classes
	        })
	      );
	    }) : _react2.default.createElement(
	      _Box2.default,
	      { width: '100%', className: classes.emptyResults },
	      _labels.NO_RESULTS_TEXT
	    )
	  );
	};
	
	SingleKeyView.propTypes = {
	  applicationUuid: _propTypes2.default.string,
	  apiKey: _propTypes2.default.string,
	  deploymentList: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  deploymentErrors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchProxiesByApiKey: _propTypes2.default.func,
	  user: _propTypes2.default.shape({}),
	  history: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	
	var SingleRow = function SingleRow(props) {
	  var applicationUuid = props.applicationUuid,
	      idx = props.idx,
	      row = props.row,
	      deployments = props.deployments,
	      classes = props.classes;
	
	
	  var onEditKeyButton = function onEditKeyButton() {
	    localStorage.setItem('editKey', (0, _get2.default)(row, 'apiKey'));
	    history.push('/publish/applications/edit/' + applicationUuid + '/keys');
	  };
	
	  var _useState = (0, _react.useState)(idx === 0),
	      _useState2 = _slicedToArray(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _TableRow2.default,
	      { onClick: function onClick() {
	          return setOpen(!open);
	        } },
	      _react2.default.createElement(
	        _TableCell2.default,
	        { component: 'th', scope: 'row' },
	        row.name,
	        (0, _get2.default)(row, 'defaultKey') && _react2.default.createElement(_Chip2.default, {
	          className: classes.defaultChip,
	          size: 'small',
	          label: 'Default'
	        })
	      ),
	      _react2.default.createElement(
	        _TableCell2.default,
	        { component: 'th', scope: 'row', align: 'center' },
	        _react2.default.createElement(_Chip2.default, {
	          className: (0, _get2.default)(row, 'status') === _labels.KEY_STATUS_ENABLED ? classes.enabledChip : classes.disabledChip,
	          size: 'small',
	          label: (0, _changeCase.sentenceCase)((0, _get2.default)(row, 'status'))
	        })
	      ),
	      _react2.default.createElement(
	        _TableCell2.default,
	        null,
	        false && _react2.default.createElement(
	          _Button2.default,
	          {
	            id: 'edit-key-' + idx,
	            'data-apim-test': 'edit-key-btn-' + idx,
	            variant: 'outlined',
	            className: classes.editKeyButton,
	            onClick: function onClick() {
	              return onEditKeyButton();
	            }
	          },
	          'Edit Key'
	        )
	      ),
	      _react2.default.createElement(
	        _TableCell2.default,
	        null,
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            className: classes.expandCollapseButton,
	            size: 'small',
	            onClick: function onClick() {
	              return setOpen(!open);
	            }
	          },
	          open ? _react2.default.createElement(_KeyboardArrowUp2.default, null) : _react2.default.createElement(_KeyboardArrowDown2.default, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _TableRow2.default,
	      null,
	      _react2.default.createElement(
	        _TableCell2.default,
	        { style: { padding: 0 }, colSpan: 6 },
	        _react2.default.createElement(
	          _Collapse2.default,
	          { 'in': open, timeout: 'auto', unmountOnExit: true },
	          _react2.default.createElement(
	            'div',
	            { style: { padding: 8 } },
	            _react2.default.createElement(SingleKeyView, Object.assign({}, props, {
	              apiKey: (0, _get2.default)(row, 'apiKey'),
	              deploymentList: getDeploymentList(deployments, (0, _get2.default)(row, 'proxies', []))
	            }))
	          )
	        )
	      )
	    )
	  );
	};
	
	SingleRow.propTypes = {
	  applicationUuid: _propTypes2.default.string,
	  idx: _propTypes2.default.number,
	  row: _propTypes2.default.number,
	  deployments: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  classes: _propTypes2.default.shape({})
	};
	
	var GRID_ROWS_PER_PAGE_OPTIONS = [10, 20];
	var GRID_ROWS_PER_PAGE_DEFAULT_OPTION = 10;
	
	var DeploymentsRaw = exports.DeploymentsRaw = function DeploymentsRaw(props) {
	  var applicationUuid = props.applicationUuid,
	      applicationDetails = props.applicationDetails,
	      fetchApplicationKeys = props.fetchApplicationKeys,
	      _props$appKeys = props.appKeys,
	      appKeys = _props$appKeys === undefined ? [] : _props$appKeys,
	      appKeysTotalPages = props.appKeysTotalPages,
	      appKeysTotalElements = props.appKeysTotalElements,
	      isMultiKeySupport = props.isMultiKeySupport,
	      _props$deployments = props.deployments,
	      deployments = _props$deployments === undefined ? [] : _props$deployments,
	      _props$apiKeyProxies = props.apiKeyProxies,
	      apiKeyProxies = _props$apiKeyProxies === undefined ? [] : _props$apiKeyProxies,
	      _props$deploymentErro = props.deploymentErrors,
	      deploymentErrors = _props$deploymentErro === undefined ? [] : _props$deploymentErro,
	      user = props.user,
	      history = props.history,
	      classes = props.classes;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isMultiKeyView = _useState4[0],
	      setIsMultiKeyView = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      deploymentList = _useState6[0],
	      setDeploymentList = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      rows = _useState8[0],
	      setRows = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      page = _useState10[0],
	      setPage = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState12 = _slicedToArray(_useState11, 2),
	      rowsPerPage = _useState12[0],
	      setRowsPerPage = _useState12[1];
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    fetchApplicationKeys(applicationUuid, newPage, rowsPerPage);
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    fetchApplicationKeys(applicationUuid, 0, newRowsPerPage);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (isMultiKeySupport && (0, _utils.hasPublisherRole)(user)) {
	      // Multikey View
	      props.fetchProxies();
	      props.fetchDeploymentRefreshTime();
	      appKeys.map(function (obj) {
	        props.fetchProxiesByApiKey(obj.apiKey);
	        return true;
	      });
	    } else {
	      var apiKey = (0, _get2.default)(applicationDetails, 'apiKey');
	      if (apiKey) {
	        if ((0, _utils.hasPublisherRole)(user)) {
	          props.fetchProxies();
	          props.fetchDeploymentRefreshTime();
	          props.fetchProxiesByApiKey(apiKey);
	        }
	      }
	    }
	  }, [applicationDetails, isMultiKeySupport]);
	
	  (0, _react.useEffect)(function () {
	    if (appKeys.length > 0) {
	      var tempArr = [];
	      appKeys.map(function (obj) {
	        tempArr.push(Object.assign({}, apiKeyProxies.find(function (o) {
	          return o.key === obj.apiKey;
	        }), obj));
	        return true;
	      });
	      setRows(tempArr);
	      setIsMultiKeyView(true);
	    } else {
	      var apiKey = (0, _get2.default)(applicationDetails, 'apiKey');
	      var keyObject = apiKeyProxies.find(function (o) {
	        return o.key === apiKey;
	      });
	      setDeploymentList(getDeploymentList(deployments, (0, _get2.default)(keyObject, 'proxies', [])));
	      setIsMultiKeyView(false);
	    }
	  }, [apiKeyProxies, appKeys.length, apiKeyProxies.length, deployments.length]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.appDeploymentsContainer,
	      id: 'app-deployments-container', 'data-layer7-test': 'app-deployments-container'
	    },
	    isMultiKeyView ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _TableContainer2.default,
	        null,
	        _react2.default.createElement(
	          _Table2.default,
	          { 'aria-label': 'collapsible table' },
	          _react2.default.createElement(
	            _TableHead2.default,
	            { className: classes.tableHead },
	            _react2.default.createElement(
	              _TableRow2.default,
	              null,
	              _react2.default.createElement(
	                _TableCell2.default,
	                null,
	                _labels.KEY_NAME_LABEL
	              ),
	              _react2.default.createElement(
	                _TableCell2.default,
	                { align: 'center' },
	                _labels.STATUS_LABEL
	              ),
	              _react2.default.createElement(_TableCell2.default, null),
	              _react2.default.createElement(_TableCell2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _TableBody2.default,
	            null,
	            rows.map(function (row, idx) {
	              return _react2.default.createElement(SingleRow, Object.assign({ key: idx }, props, { row: row, idx: idx, history: history }));
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.paginationContainer },
	        _react2.default.createElement(_components.TablePagination, {
	          id: 'app-deployments-keys-pagination',
	          'data-apim-test': 'app-deployments-keys-pagination',
	          page: page,
	          count: appKeysTotalElements,
	          pageCount: appKeysTotalPages,
	          rowsPerPage: rowsPerPage,
	          rowsPerPageOptions: GRID_ROWS_PER_PAGE_OPTIONS,
	          onChangeRowsPerPage: onChangeRowsPerPage,
	          onChangePage: onChangePage,
	          onChangePreviousPage: onChangePreviousPage,
	          onChangeNextPage: onChangeNextPage,
	          labelRowsPerPage: intl.getI18nMessage('label.pagination.rows.per.page')
	        })
	      )
	    ) : _react2.default.createElement(SingleKeyView, Object.assign({}, props, {
	      applicationUuid: applicationUuid,
	      apiKey: (0, _get2.default)(applicationDetails, 'apiKey'),
	      deploymentErrors: deploymentErrors,
	      deploymentList: deploymentList,
	      history: history
	    }))
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: (0, _portalConfig2.getUserDetails)(state),
	    deployments: (0, _application2.getProxies)(state),
	    apiKeyProxies: (0, _application2.getProxiesByApiKey)(state),
	    deploymentErrors: (0, _application2.getProxyErrors)(state),
	    refreshTime: (0, _portalConfig2.getDeploymentRefreshTime)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchProxies: _application.fetchProxies,
	  fetchProxiesByApiKey: _application.fetchProxiesByApiKey,
	  fetchDeploymentRefreshTime: _portalConfig.fetchDeploymentRefreshTime,
	  deployApiKeyToProxy: _application.deployApiKeyToProxy,
	  redeployApiKeyToProxy: _application.redeployApiKeyToProxy,
	  undeployApiKeyFromProxy: _application.undeployApiKeyFromProxy
	};
	
	DeploymentsRaw.propTypes = {
	  applicationUuid: _propTypes2.default.string,
	  applicationDetails: _propTypes2.default.shape({}),
	  fetchApplicationKeys: _propTypes2.default.func,
	  appKeys: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  appKeysTotalPages: _propTypes2.default.number,
	  appKeysTotalElements: _propTypes2.default.number,
	  isMultiKeySupport: _propTypes2.default.bool,
	  deployments: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  apiKeyProxies: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  deploymentErrors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  history: _propTypes2.default.shape({}),
	  user: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	DeploymentsRaw.displayName = 'Deployments';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(DeploymentsRaw);

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderRaw = exports.getStatusColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(1595);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStatusColor = exports.getStatusColor = function getStatusColor(classes, status) {
	  var statusLabel = '';
	  var statusColorClass = '';
	  switch (status) {
	    case _constants.APPLICATION_STATUS_ENABLED:
	      statusLabel = 'Enabled';
	      statusColorClass = classes.available;
	      break;
	    case _constants.APPLICATION_STATUS_PENDING_APPROVAL:
	    case _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL:
	      statusLabel = 'Pending Approval';
	      statusColorClass = classes.pending;
	      break;
	    case _constants.APPLICATION_STATUS_REJECTED:
	      statusLabel = 'Rejected';
	      statusColorClass = classes.unavailable;
	      break;
	    default:
	      statusLabel = 'Disabled';
	      statusColorClass = classes.unavailable;
	      break;
	  }
	  return {
	    statusLabel: statusLabel, statusColorClass: statusColorClass
	  };
	};
	
	var HeaderRaw = exports.HeaderRaw = function HeaderRaw(props) {
	  var appUuid = props.appUuid,
	      applicationDetails = props.applicationDetails,
	      isEditAppDisabled = props.isEditAppDisabled,
	      history = props.history,
	      classes = props.classes;
	  var name = applicationDetails.name,
	      status = applicationDetails.status;
	
	  var _getStatusColor = getStatusColor(classes, status),
	      statusLabel = _getStatusColor.statusLabel,
	      statusColorClass = _getStatusColor.statusColorClass;
	
	  var goToEditApplication = function goToEditApplication() {
	    history.push('/publish/applications/edit/' + appUuid + '/details');
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.appHeaderContainer,
	      id: 'app-header-container', 'data-layer7-test': 'app-header-container'
	    },
	    _react2.default.createElement(
	      'h1',
	      { className: classes.pageTitle },
	      name
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.statusBar },
	      statusLabel && _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)(classes.status, statusColorClass) },
	        statusLabel
	      ),
	      _react2.default.createElement(
	        'span',
	        {
	          className: (0, _classnames2.default)(classes.linkWrapper, status === _constants.APPLICATION_STATUS_REJECTED || isEditAppDisabled ? classes.disabledClass : '')
	        },
	        _react2.default.createElement(
	          _core.Link,
	          { onClick: goToEditApplication },
	          '(Change)'
	        )
	      )
	    )
	  );
	};
	
	HeaderRaw.propTypes = {
	  appUuid: _propTypes2.default.string,
	  applicationDetails: _propTypes2.default.shape({}),
	  isEditAppDisabled: _propTypes2.default.bool,
	  history: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	HeaderRaw.displayName = 'Header';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(HeaderRaw);

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    appHeaderContainer: {
	      padding: '0 36px'
	    },
	    pageTitle: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'pageTitle') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	      fontWeight: 'bold',
	      wordWrap: 'break-word',
	      lineHeight: '48px',
	      margin: '5px 0'
	    },
	    statusBar: {
	      margin: '10px 0px',
	      '& span': {
	        position: 'relative',
	        display: 'inline-block',
	        marginBottom: '5px',
	        paddingLeft: '15px',
	        verticalAlign: 'middle',
	        fontSize: (0, _lodash.get)(fontSize, 'smallText'),
	        letterSpacing: 0
	      }
	    },
	    statusIcon: {
	      fontSize: (0, _lodash.get)(fontSize, 'smallText')
	    },
	    status: {
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      '&:before': {
	        display: 'inline-block',
	        position: 'absolute',
	        content: '""',
	        left: 0,
	        top: '50%',
	        marginTop: '-6px',
	        height: '10px',
	        width: '10px',
	        borderRadius: '10px'
	      }
	    },
	    available: {
	      color: (0, _lodash.get)(color, 'success'),
	      '&:before': {
	        backgroundColor: (0, _lodash.get)(color, 'success')
	      }
	    },
	    pending: {
	      color: (0, _lodash.get)(color, 'pending'),
	      '&:before': {
	        backgroundColor: (0, _lodash.get)(color, 'pending')
	      }
	    },
	    unavailable: {
	      color: (0, _lodash.get)(color, 'error'),
	      '&:before': {
	        backgroundColor: (0, _lodash.get)(color, 'error')
	      }
	    },
	    grayText: {
	      color: (0, _lodash.get)(color, 'smallText'),
	      '&:before': {
	        content: '"Client ID: "',
	        textTransform: 'uppercase'
	      }
	    },
	    linkWrapper: {
	      paddingLeft: '5px !important',
	      '& a': {
	        cursor: 'pointer',
	        border: 'none !important',
	        margin: '0px !important',
	        padding: '0px !important',
	        height: '0px !important',
	        fontWeight: '300 !important',
	        color: (0, _lodash.get)(color, 'link') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:hover': {
	        color: (0, _lodash.get)(color, 'linkHover') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:focus': {
	        boxShadow: 'none !important',
	        outline: '0px !important',
	        textDecoration: 'none'
	      }
	    },
	    disabledClass: {
	      pointerEvents: 'none',
	      cursor: 'not-allowed',
	      '& a': {
	        color: (0, _lodash.get)(color, 'gray') + ' !important'
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApplicationDetails = exports.getApplicationUuid = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _core = __webpack_require__(3);
	
	var _Divider = __webpack_require__(91);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Grid = __webpack_require__(71);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _application = __webpack_require__(102);
	
	var _application2 = __webpack_require__(86);
	
	var _portalConfig = __webpack_require__(26);
	
	var _utils = __webpack_require__(18);
	
	var _components = __webpack_require__(17);
	
	var _Header = __webpack_require__(1594);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Actions = __webpack_require__(1586);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _Configuration = __webpack_require__(1590);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _Deployments = __webpack_require__(1593);
	
	var _Deployments2 = _interopRequireDefault(_Deployments);
	
	var _Apis = __webpack_require__(1589);
	
	var _Apis2 = _interopRequireDefault(_Apis);
	
	var _styles = __webpack_require__(1597);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getApplicationUuid = exports.getApplicationUuid = function getApplicationUuid(props) {
	  return (0, _get2.default)(props, 'match.path') && (0, _get2.default)(props, 'match.path').includes('/details/') && (0, _get2.default)(props, 'match.params.applicationUuid');
	};
	
	var getIsDevUrl = function getIsDevUrl(props) {
	  return (0, _get2.default)(props, 'match.path') && (0, _get2.default)(props, 'match.path').includes('/dev/');
	};
	
	var getTabItems = function getTabItems(user) {
	  return [{
	    id: 0,
	    tabId: 'app-config-tab',
	    label: 'Configuration',
	    visible: true
	  }, {
	    id: 1,
	    tabId: 'app-apis-tab',
	    label: 'APIs',
	    visible: true
	  }, {
	    id: 2,
	    tabId: 'app-deployments-tab',
	    label: 'Deployments',
	    visible: (0, _utils.hasPublisherRole)(user)
	  }];
	};
	
	var ApplicationDetails = exports.ApplicationDetails = function ApplicationDetails(props) {
	  var classes = props.classes,
	      user = props.user,
	      history = props.history,
	      featureFlags = props.featureFlags,
	      applicationDetails = props.applicationDetails,
	      singleApplication = props.singleApplication,
	      _props$appKeys = props.appKeys,
	      appKeys = _props$appKeys === undefined ? [] : _props$appKeys,
	      appKeysTotalPages = props.appKeysTotalPages,
	      appKeysTotalElements = props.appKeysTotalElements,
	      hideDeployments = props.hideDeployments;
	
	  var isEditAppDisabled = (0, _utils.isEditApplicationDisabled)(user, applicationDetails);
	  var isEditAppKeysDisabled = (0, _utils.isEditApplicationKeysDisabled)(user, applicationDetails);
	  var featureFlagApiPlan = JSON.parse((0, _get2.default)(featureFlags, 'apiPlans.Value'));
	  var featureFlagMultiApiKeys = JSON.parse((0, _get2.default)(featureFlags, 'useMultiApiKeys.Value'));
	
	  var _useState = (0, _react.useState)(localStorage.getItem('notificationMessage')),
	      _useState2 = _slicedToArray(_useState, 2),
	      notificationMessage = _useState2[0],
	      setNotificationMessage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(localStorage.getItem('notificationStatus')),
	      _useState4 = _slicedToArray(_useState3, 2),
	      notificationStatus = _useState4[0],
	      setNotificationStatus = _useState4[1];
	
	  var isMultiKeySupport = featureFlagMultiApiKeys && appKeys.length > 0;
	
	  var notifyMessages = function notifyMessages(message, status) {
	    setNotificationStatus(status);
	    localStorage.setItem('notificationStatus', status);
	    setNotificationMessage(message);
	    localStorage.setItem('notificationMessage', message);
	  };
	
	  var appUuid = getApplicationUuid(props);
	  (0, _react.useEffect)(function () {
	    if (appUuid) {
	      props.fetchApplication(appUuid);
	      props.fetchSingleApplication(appUuid);
	      props.fetchApplicationKeys(appUuid);
	    }
	    setTimeout(function () {
	      notifyMessages('', '');
	    }, 2500);
	  }, []);
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      currentTab = _useState6[0],
	      setCurrentTab = _useState6[1];
	
	  var handleChange = function handleChange(event, newValue) {
	    setCurrentTab(newValue);
	  };
	
	  var tabItems = getTabItems(user);
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.content,
	      id: 'application-details-page', 'data-layer7-test': 'application-details-page'
	    },
	    notificationMessage && _react2.default.createElement(_components.AlertMessages, {
	      id: 'app-details-notification',
	      variant: notificationStatus,
	      message: notificationMessage,
	      containerClass: classes.notificationWidthClass,
	      onClose: function onClose() {
	        notifyMessages('', '');
	      }
	    }),
	    _react2.default.createElement(_Header2.default, {
	      appUuid: appUuid,
	      applicationDetails: applicationDetails,
	      isEditAppDisabled: isEditAppDisabled,
	      history: history
	    }),
	    _react2.default.createElement(_Actions2.default, {
	      applicationDetails: applicationDetails,
	      isEditAppDisabled: isEditAppDisabled,
	      isEditAppKeysDisabled: isEditAppKeysDisabled,
	      setNotificationMessage: setNotificationMessage,
	      setNotificationStatus: setNotificationStatus,
	      isMultiKeySupport: isMultiKeySupport,
	      referrerUrl: document.referrer,
	      history: history,
	      user: user
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, className: classes.gridContainer },
	      _react2.default.createElement(_components.TabsContainer, {
	        id: 'app-details-tab-container',
	        tabValue: currentTab,
	        orientation: 'horizontal',
	        tabItems: tabItems.filter(function (_ref) {
	          var visible = _ref.visible;
	          return visible;
	        }),
	        handleTabChange: handleChange,
	        tabActiveClass: classes.tabActive,
	        tabIndicatorClass: classes.tabIndicator
	      })
	    ),
	    _react2.default.createElement(_Divider2.default, { className: classes.divider }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, className: classes.bodyContent },
	      _react2.default.createElement(
	        _components.TabPanel,
	        { visible: currentTab === 0, id: 'app-config-tab-panel' },
	        _react2.default.createElement(_Configuration2.default, {
	          applicationUuid: appUuid,
	          applicationDetails: applicationDetails,
	          fetchApplicationKeys: props.fetchApplicationKeys,
	          appKeys: appKeys,
	          appKeysTotalPages: appKeysTotalPages,
	          appKeysTotalElements: appKeysTotalElements,
	          isMultiKeySupport: isMultiKeySupport
	        })
	      ),
	      _react2.default.createElement(
	        _components.TabPanel,
	        { visible: currentTab === 1, id: 'app-apis-tab-panel' },
	        _react2.default.createElement(_Apis2.default, {
	          applicationDetails: applicationDetails,
	          singleApplication: singleApplication,
	          isEditAppDisabled: isEditAppDisabled,
	          appUuid: appUuid,
	          user: user,
	          isDevUrl: getIsDevUrl(props),
	          history: history,
	          featureFlagApiPlan: featureFlagApiPlan
	        })
	      ),
	      _react2.default.createElement(
	        _components.TabPanel,
	        { visible: currentTab === 2, id: 'app-deployments-tab-panel' },
	        !hideDeployments && _react2.default.createElement(_Deployments2.default, {
	          appUuid: appUuid,
	          applicationDetails: applicationDetails,
	          appKeys: appKeys,
	          appKeysTotalPages: appKeysTotalPages,
	          appKeysTotalElements: appKeysTotalElements,
	          isMultiKeySupport: isMultiKeySupport,
	          history: history
	        })
	      )
	    ),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    featureFlags: (0, _portalConfig.getFeatureFlags)(state),
	    applicationDetails: (0, _application2.getApplicationDetails)(state),
	    singleApplication: (0, _application2.getSingleApplication)(state),
	    appKeys: (0, _application2.getKeysResults)(state),
	    appKeysTotalPages: (0, _application2.getKeysTotalPages)(state),
	    appKeysTotalElements: (0, _application2.getKeysTotalElements)(state),
	    user: (0, _portalConfig.getUserDetails)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchApplication: _application.fetchApplication,
	  fetchSingleApplication: _application.fetchSingleApplication,
	  fetchApplicationKeys: _application.fetchApplicationKeys
	};
	
	ApplicationDetails.propTypes = {
	  featureFlags: _propTypes2.default.shape({}),
	  applicationDetails: _propTypes2.default.shape({}),
	  singleApplication: _propTypes2.default.shape({}),
	  fetchApplicationKeys: _propTypes2.default.func,
	  appKeys: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  appKeysTotalPages: _propTypes2.default.number,
	  appKeysTotalElements: _propTypes2.default.number,
	  user: _propTypes2.default.shape({}),
	  history: _propTypes2.default.shape({}),
	  classes: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ApplicationDetails);

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color;
	  return {
	    content: {
	      margin: 36,
	      minHeight: 'calc(100vh - 125px)',
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      marginTop: 0,
	      padding: '24px 0px 36px 0px'
	    },
	    bodyContent: {
	      marginTop: 10,
	      display: 'block'
	    },
	    gridContainer: {
	      display: 'inline-flex',
	      width: 'auto',
	      padding: '0 36px'
	    },
	    tabsContainer: {
	      display: 'inline-flex'
	    },
	    divider: {
	      backgroundColor: (0, _lodash.get)(color, 'bodyText')
	    },
	    notificationWidthClass: {
	      width: '96%',
	      padding: '0 15px',
	      marginLeft: 0
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = ApiManagement;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _ExpandMore = __webpack_require__(81);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _lodash = __webpack_require__(8);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(121);
	
	var _constants = __webpack_require__(14);
	
	var _tabs = __webpack_require__(1599);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _utils = __webpack_require__(18);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getSelectedApis = function getSelectedApis() {
	  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var selected = arguments[1];
	  var available = arguments[2];
	  var apiApiPlanIds = arguments[3];
	  var cached = arguments[4];
	  return (0, _lodash.uniq)(ids).map(function (id) {
	    var selectedApi = selected[id] || available[id] || cached[id];
	    return Object.assign({}, selectedApi, {
	      apiPlanId: apiApiPlanIds[id]
	    });
	  });
	};
	
	var getSelectedApiGroups = function getSelectedApiGroups() {
	  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var selected = arguments[1];
	  var available = arguments[2];
	  var cached = arguments[3];
	  return (0, _lodash.uniq)(ids).map(function (id) {
	    return selected[id] || available[id] || cached[id];
	  });
	};
	
	var getSelectedApiPlan = function getSelectedApiPlan(_ref) {
	  var availableItems = _ref.availableItems,
	      apiPlanId = _ref.apiPlanId;
	  return (0, _lodash.find)(availableItems, function (_ref2) {
	    var uuid = _ref2.uuid;
	    return uuid === apiPlanId;
	  });
	};
	
	var getTabs = function getTabs(tabProps) {
	  return _tabs2.default.filter(function (_ref3) {
	    var isHidden = _ref3.isHidden;
	    return !(isHidden && isHidden(tabProps));
	  });
	};
	
	function ApiManagement(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      headerRef = props.headerRef,
	      _props$errors = props.errors,
	      errors = _props$errors === undefined ? [] : _props$errors,
	      _props$userContext = props.userContext,
	      userContext = _props$userContext === undefined ? {} : _props$userContext,
	      userActiveOrgUuid = props.userActiveOrgUuid,
	      featureFlagApiPlans = props.featureFlagApiPlans,
	      currentTab = props.currentTab,
	      setCurrentTab = props.setCurrentTab,
	      _props$applicationDet = props.applicationDetails,
	      applicationDetails = _props$applicationDet === undefined ? {} : _props$applicationDet,
	      setApplicationDetails = props.setApplicationDetails,
	      _props$availableApis = props.availableApis,
	      availableApis = _props$availableApis === undefined ? [] : _props$availableApis,
	      availableApisCount = props.availableApisCount,
	      _props$apiEula = props.apiEula,
	      apiEula = _props$apiEula === undefined ? {} : _props$apiEula,
	      fetchAvailableApis = props.fetchAvailableApis,
	      _props$availableApiGr = props.availableApiGroups1,
	      availableApiGroups1 = _props$availableApiGr === undefined ? {} : _props$availableApiGr,
	      _props$apiGroupEulas = props.apiGroupEulas,
	      apiGroupEulas = _props$apiGroupEulas === undefined ? [] : _props$apiGroupEulas,
	      fetchAvailableApiGroups = props.fetchAvailableApiGroups,
	      fetchAllTags = props.fetchAllTags,
	      _props$allTags = props.allTags,
	      allTags = _props$allTags === undefined ? [] : _props$allTags,
	      visible = props.visible,
	      fetchAvailableApiPlans = props.fetchAvailableApiPlans,
	      availableApiPlans = props.availableApiPlans,
	      onCancel = props.onCancel,
	      applicationUuid = props.applicationUuid,
	      isSaveApplicationSuccess = props.isSaveApplicationSuccess,
	      isMultiKeySupport = props.isMultiKeySupport;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var tabs = getTabs({ featureFlagApiPlans: featureFlagApiPlans });
	  var organizationUuid = applicationDetails.organizationUuid,
	      apiIds = applicationDetails.apiIds,
	      apiApiPlanIds = applicationDetails.apiApiPlanIds,
	      apiGroupIds = applicationDetails.apiGroupIds;
	
	  var _useState = (0, _react.useState)(tabs[0].tabId),
	      _useState2 = _slicedToArray(_useState, 2),
	      currentAvailableTab = _useState2[0],
	      setCurrentAvailableTab = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      error = _useState4[0],
	      setError = _useState4[1];
	
	  var orgUuid = (0, _utils.hasOrgBoundRole)(userContext) ? userActiveOrgUuid : organizationUuid;
	
	  var getAvailableApiPlans = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(selectedApis) {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              return _context2.abrupt('return', (0, _lodash.forEach)(selectedApis, function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref5) {
	                  var uuid = _ref5.uuid;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!(0, _lodash.isUndefined)(availableApiPlans[uuid])) {
	                            _context.next = 3;
	                            break;
	                          }
	
	                          _context.next = 3;
	                          return fetchAvailableApiPlans(orgUuid, uuid);
	
	                        case 3:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this);
	                }));
	
	                return function (_x4) {
	                  return _ref6.apply(this, arguments);
	                };
	              }()));
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    return function getAvailableApiPlans(_x3) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  /**
	   * APIs
	   */
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      apiUuidToAdd = _useState6[0],
	      setApiUuidToAdd = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isApiEulaDialogOpen = _useState8[0],
	      setIsApiEulaDialogOpen = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      apiPageNumber = _useState10[0],
	      setApiPageNumber = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      apiSearchText = _useState12[0],
	      setApiSearchText = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      apiGroupPageNumber = _useState14[0],
	      setApiGroupPageNumber = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      apiGroupSearchText = _useState16[0],
	      setApiGroupSearchText = _useState16[1];
	
	  var _useState17 = (0, _react.useState)([]),
	      _useState18 = _slicedToArray(_useState17, 2),
	      cachedApis = _useState18[0],
	      setCachedApis = _useState18[1];
	
	  var _useState19 = (0, _react.useState)([]),
	      _useState20 = _slicedToArray(_useState19, 2),
	      cachedApiGroups = _useState20[0],
	      setCachedApiGroups = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(getSelectedApis(apiIds, (0, _utils.listToObject)(props.selectedApis, _constants.TYPE_API), (0, _utils.listToObject)(availableApis, _constants.TYPE_API), apiApiPlanIds, (0, _utils.listToObject)(cachedApis, _constants.TYPE_API))),
	      _useState22 = _slicedToArray(_useState21, 2),
	      selectedApis = _useState22[0],
	      setSelectedApis = _useState22[1];
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _lodash.isEmpty)(apiEula)) {
	      setIsApiEulaDialogOpen(true);
	    }
	  }, [apiEula]);
	
	  // TODO: temp. disabling the excess get calls for available API Plans
	  // if (selectedApis.length > 0 && featureFlagApiPlans) { getAvailableApiPlans(selectedApis); }
	
	  (0, _react.useEffect)(function () {
	    if (currentTab !== 'api-management-tab') {
	      return;
	    }
	    if (selectedApis.length > 0 && featureFlagApiPlans) {
	      getAvailableApiPlans(selectedApis);
	    }
	  }, [selectedApis]);
	
	  var onDeleteApi = function onDeleteApi(uuid) {
	    localStorage.setItem('isAppUnSavedChanges', true);
	    if (featureFlagApiPlans) {
	      delete applicationDetails.apiApiPlanIds[uuid];
	    }
	    setApplicationDetails(Object.assign({}, applicationDetails, {
	      apiIds: apiIds.filter(function (apiId) {
	        return apiId !== uuid;
	      })
	    }));
	  };
	
	  var onAddApi = function onAddApi() {
	    localStorage.setItem('isAppUnSavedChanges', true);
	    var applicationDetailsApiIds = (0, _lodash.uniq)(apiIds.concat(apiUuidToAdd));
	    setApplicationDetails(Object.assign({}, applicationDetails, {
	      apiIds: applicationDetailsApiIds
	    }, featureFlagApiPlans && {
	      apiApiPlanIds: Object.assign({}, apiApiPlanIds, _defineProperty({}, apiUuidToAdd, null))
	    }));
	    setApiUuidToAdd('');
	    setError(false);
	    setCachedApis(getSelectedApis(applicationDetailsApiIds, (0, _utils.listToObject)(props.selectedApis, _constants.TYPE_API), (0, _utils.listToObject)(availableApis, _constants.TYPE_API), apiApiPlanIds, (0, _utils.listToObject)(cachedApis, _constants.TYPE_API)));
	  };
	
	  (0, _react.useEffect)(function () {
	    setSelectedApis(getSelectedApis(applicationDetails.apiIds, (0, _utils.listToObject)(props.selectedApis, _constants.TYPE_API), (0, _utils.listToObject)(availableApis, _constants.TYPE_API), applicationDetails.apiApiPlanIds, (0, _utils.listToObject)(cachedApis, _constants.TYPE_API)));
	  }, [applicationDetails]);
	
	  var onSelectApiPlan = function onSelectApiPlan(apiUuid, apiPlanUuid) {
	    localStorage.setItem('isAppUnSavedChanges', true);
	    setApplicationDetails(Object.assign({}, applicationDetails, {
	      apiApiPlanIds: Object.assign({}, apiApiPlanIds, _defineProperty({}, apiUuid, apiPlanUuid))
	    }));
	    setError(false);
	  };
	
	  var getApiPlanSelectTable = function getApiPlanSelectTable(item) {
	    var selectedApiPlan = getSelectedApiPlan(item);
	    return !(0, _lodash.isEmpty)(item.availableItems) && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.FormLabel,
	        { classes: { root: classes.labelRoot } },
	        (0, _intl.getI18nFormattedMessage)('label.application.apis.selected.api.plan')
	      ),
	      selectedApiPlan ? _react2.default.createElement(
	        _core.FormLabel,
	        { classes: { root: classes.selectedApiPlan } },
	        (0, _lodash.get)(selectedApiPlan, 'name')
	      ) : _react2.default.createElement(
	        _core.FormLabel,
	        { classes: { root: classes.selectApiPlanPlaceholder } },
	        (0, _intl.getI18nFormattedMessage)('label.application.apis.selected.api.plan.placeholder')
	      )
	    );
	  };
	
	  var onLoadMoreApisProps = availableApisCount > availableApis.length ? {
	    isLoadMore: true,
	    onLoadMore: function onLoadMore() {
	      setApiPageNumber(apiPageNumber + 1);
	    },
	    loadMoreText: 'Load More'
	  } : {};
	
	  /**
	   * API Groups
	   */
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      apiGroupUuidToAdd = _useState24[0],
	      setApiGroupUuidToAdd = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      isApiGroupEulaDialogOpen = _useState26[0],
	      setIsApiGroupEulaDialogOpen = _useState26[1];
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _lodash.isEmpty)(apiGroupEulas)) {
	      setIsApiGroupEulaDialogOpen(true);
	    }
	  }, [apiGroupEulas]);
	
	  var selectedApiGroups = getSelectedApiGroups(apiGroupIds, (0, _utils.listToObject)(props.selectedApiGroups, _constants.TYPE_API_GROUP), (0, _utils.listToObject)(availableApiGroups1.results, _constants.TYPE_API_GROUP), (0, _utils.listToObject)(cachedApiGroups, _constants.TYPE_API_GROUP));
	
	  var onDeleteApiGroup = function onDeleteApiGroup(uuid) {
	    localStorage.setItem('isAppUnSavedChanges', true);
	    setApplicationDetails(Object.assign({}, applicationDetails, {
	      apiGroupIds: apiGroupIds.filter(function (apiGroupId) {
	        return apiGroupId !== uuid;
	      })
	    }));
	  };
	
	  var onAddApiGroup = function onAddApiGroup() {
	    localStorage.setItem('isAppUnSavedChanges', true);
	    var applicationDetailsApiGroupIds = (0, _lodash.uniq)(apiGroupIds.concat(apiGroupUuidToAdd));
	    setApplicationDetails(Object.assign({}, applicationDetails, {
	      apiGroupIds: applicationDetailsApiGroupIds
	    }));
	    setApiGroupUuidToAdd('');
	    setError(false);
	    setCachedApiGroups(getSelectedApiGroups(applicationDetailsApiGroupIds, (0, _utils.listToObject)(props.selectedApiGroups, _constants.TYPE_API_GROUP), (0, _utils.listToObject)(availableApiGroups1.results, _constants.TYPE_API_GROUP), (0, _utils.listToObject)(cachedApiGroups, _constants.TYPE_API_GROUP)));
	  };
	
	  var onLoadMoreApiGroupsProps = availableApiGroups1.currentPage + 1 < availableApiGroups1.totalPages ? {
	    isLoadMore: true,
	    onLoadMore: function onLoadMore() {
	      setApiGroupPageNumber(availableApiGroups1.currentPage + 1);
	    },
	    loadMoreText: 'Load More'
	  } : {};
	
	  /**
	   * Tag Selection
	   */
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      isApiTagSelectDialogOpen = _useState28[0],
	      setIsApiTagSelectDialogOpen = _useState28[1];
	
	  var _useState29 = (0, _react.useState)([]),
	      _useState30 = _slicedToArray(_useState29, 2),
	      selectedTags = _useState30[0],
	      setSelectedTags = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      popupTags = _useState32[0],
	      setPopupTags = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      popupSelectedTags = _useState34[0],
	      setPopupSelectedTags = _useState34[1];
	
	  var onTagsSelect = function onTagsSelect(tags, apiTags) {
	    if (!tags) {
	      setPopupTags(apiTags);
	      var popupSelectedTagsParams = (0, _lodash.intersection)(selectedTags, apiTags);
	      setPopupSelectedTags(popupSelectedTagsParams);
	      setIsApiTagSelectDialogOpen(true);
	    } else {
	      setApiPageNumber(0);
	      setSelectedTags((0, _lodash.uniq)(tags));
	    }
	  };
	
	  var onAPISearchTextChange = function onAPISearchTextChange(searchterm) {
	    setApiPageNumber(0);
	    setApiSearchText(searchterm);
	  };
	
	  var onAPIGroupSearchTextChange = function onAPIGroupSearchTextChange(searchterm) {
	    setApiGroupPageNumber(0);
	    setApiGroupSearchText(searchterm);
	  };
	
	  var allTagsOptions = (0, _lodash.map)(allTags, function (_ref7) {
	    var name = _ref7.name;
	    return { value: name, label: name };
	  });
	  var onPopupTagsSelectionChange = function onPopupTagsSelectionChange(tags) {
	    return setPopupSelectedTags((0, _lodash.map)(tags, function (item) {
	      return item.value;
	    }));
	  };
	
	  var onTagsPopupSubmit = function onTagsPopupSubmit() {
	    setApiPageNumber(0);
	    var newTags = (0, _lodash.union)((0, _lodash.difference)(selectedTags, popupTags), popupSelectedTags);
	    setSelectedTags(newTags);
	    setIsApiTagSelectDialogOpen(false);
	  };
	
	  var onTagsSelectionChange = function onTagsSelectionChange(items) {
	    onTagsSelect((0, _lodash.uniq)((0, _lodash.map)(items, function (item) {
	      return item.value;
	    })));
	  };
	
	  var _onTagClick = function _onTagClick(tag, apiTags) {
	    if (tag) {
	      onTagsSelect((0, _lodash.uniq)([].concat(_toConsumableArray(selectedTags), [tag])), apiTags);
	    } else {
	      onTagsSelect(null, apiTags);
	    }
	  };
	
	  var renderTagsLabel = function renderTagsLabel(_ref8) {
	    var item = _ref8.item;
	
	    if (item && item.tags && item.tags.length > 0) {
	      return _react2.default.createElement(
	        'div',
	        { className: classes.tagGroupContainer },
	        _react2.default.createElement(_components.TagsGroup, {
	          tags: item.tags,
	          onTagClick: function onTagClick(tag) {
	            return _onTagClick(tag, item.tags);
	          }
	        })
	      );
	    }
	    return null;
	  };
	  renderTagsLabel.propTypes = {
	    item: _propTypes2.default.shape({})
	  };
	
	  var _getI18n = (0, _intl.getI18n)(intl),
	      getI18nMessage = _getI18n.getI18nMessage;
	
	  var noOptionsText = getI18nMessage(_labels.APPLICATION_API_TAG_NO_OPTIONS_TEXT);
	  var placeHolderText = getI18nMessage(_labels.APPLICATION_API_TAG_PLACEHOLDER_TEXT);
	  var tagPopupDialogTitle = getI18nMessage(_labels.APPLICATION_API_TAG_SELECT_DIALOG_TITLE);
	  var tagPopupDialogBtnText = getI18nMessage(_labels.APPLICATION_API_TAG_SELECT_DIALOG_FILTER_TEXT);
	  var renderTagsFilter = function renderTagsFilter() {
	    return _react2.default.createElement(_components.MultiSelect, {
	      name: 'tags',
	      onChange: onTagsSelectionChange,
	      noOptionsMessage: function noOptionsMessage() {
	        return noOptionsText;
	      },
	      optionsData: allTagsOptions,
	      placeholder: placeHolderText,
	      value: selectedTags
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    if (visible) {
	      fetchAllTags();
	    }
	  }, [visible]);
	
	  var renderTagModalDialog = function renderTagModalDialog() {
	    var apiTagsOptions = popupTags.map(function (name) {
	      return { value: name, label: name };
	    });
	    return _react2.default.createElement(
	      'div',
	      { className: classes.selectWrapper },
	      _react2.default.createElement(_components.MultiSelect, {
	        menuIsOpen: true,
	        name: 'tags',
	        onChange: onPopupTagsSelectionChange,
	        noOptionsMessage: function noOptionsMessage() {
	          return noOptionsText;
	        },
	        optionsData: apiTagsOptions,
	        placeholder: placeHolderText,
	        value: popupSelectedTags
	      })
	    );
	  };
	
	  var renderApiGroupDialog = function renderApiGroupDialog() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      apiGroupEulas.map(function (apiGroupEula) {
	        return _react2.default.createElement(
	          _core.ExpansionPanel,
	          { className: classes.apiGroupPanel, key: apiGroupEula.uuid },
	          _react2.default.createElement(
	            _core.ExpansionPanelSummary,
	            {
	              'aria-controls': 'panel1a-content',
	              expandIcon: _react2.default.createElement(_ExpandMore2.default, null),
	              id: 'panel1a-header'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: classes.heading },
	              apiGroupEula.name
	            )
	          ),
	          _react2.default.createElement(
	            _core.ExpansionPanelDetails,
	            null,
	            _react2.default.createElement('span', {
	              className: classes.panelContent,
	              dangerouslySetInnerHTML: { __html: apiGroupEula.content }
	            })
	          )
	        );
	      })
	    );
	  };
	
	  (0, _react.useEffect)(function () {
	    if (currentTab !== 'api-management-tab') {
	      return;
	    }
	    fetchAvailableApis({
	      orgUuid: orgUuid,
	      page: apiPageNumber,
	      tags: selectedTags,
	      searchText: apiSearchText
	    });
	  }, [apiPageNumber, apiSearchText, selectedTags]);
	
	  (0, _react.useEffect)(function () {
	    if (currentTab !== 'api-management-tab') {
	      return;
	    }
	    if (orgUuid) {
	      fetchAvailableApiGroups({
	        orgUuid: orgUuid,
	        page: apiGroupPageNumber,
	        searchText: apiGroupSearchText
	      });
	    }
	  }, [apiGroupPageNumber, apiGroupSearchText]);
	
	  var selectedApisApiGroups = featureFlagApiPlans ? selectedApis.map(function (selectedApi) {
	    return Object.assign({}, selectedApi, {
	      availableItems: availableApiPlans[selectedApi.uuid]
	    });
	  }) : selectedApis.concat(selectedApiGroups);
	
	  var onNext = function onNext() {
	    // If no APIs / APIGroups have been selected
	    if ((0, _lodash.isEmpty)(selectedApisApiGroups)) {
	      setError(true);
	      return;
	    }
	    // If no API Plan has been mapped to a selected API (which as an available plan)
	    if (featureFlagApiPlans && !(0, _lodash.every)((0, _lodash.keys)(apiApiPlanIds), function (apiApiPlanId) {
	      return (0, _lodash.isEmpty)(availableApiPlans[apiApiPlanId]) || !!apiApiPlanIds[apiApiPlanId];
	    })) {
	      setError(true);
	      return;
	    }
	    if (isMultiKeySupport) {
	      if (applicationUuid) {
	        props.updateApplication(applicationDetails);
	      }
	    } else {
	      setCurrentTab('authentication-tab');
	    }
	    window.scrollTo(0, headerRef.offsetTop);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (isMultiKeySupport && isSaveApplicationSuccess) {
	      setCurrentTab('keys-tab');
	    }
	  }, [isSaveApplicationSuccess]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h1', className: classes.pageTitle },
	      'Api Management'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 12, item: true },
	        _react2.default.createElement(
	          _components.FormDialog,
	          {
	            dialogId: 'application-api-eula-dialog',
	            isOpen: isApiEulaDialogOpen,
	            title: _labels.APPLICATION_API_EULA_DIALOG_TITLE,
	            submitText: _labels.APPLICATION_API_EULA_DIALOG_SUBMIT_TEXT,
	            onSubmit: function onSubmit() {
	              onAddApi();
	              setIsApiEulaDialogOpen(false);
	            },
	            cancelText: _labels.CANCEL_TEXT,
	            onCancel: function onCancel() {
	              setIsApiEulaDialogOpen(false);
	            }
	          },
	          _react2.default.createElement('span', {
	            dangerouslySetInnerHTML: { __html: apiEula.content }
	          })
	        ),
	        _react2.default.createElement(
	          _components.FormDialog,
	          {
	            dialogId: 'application-api-group-eula-dialog',
	            isOpen: isApiGroupEulaDialogOpen,
	            title: _labels.APPLICATION_API_EULA_DIALOG_TITLE,
	            submitText: _labels.APPLICATION_API_EULA_DIALOG_SUBMIT_TEXT,
	            isDialogContentText: false,
	            onSubmit: function onSubmit() {
	              onAddApiGroup();
	              setIsApiGroupEulaDialogOpen(false);
	            },
	            cancelText: _labels.CANCEL_TEXT,
	            onCancel: function onCancel() {
	              setIsApiGroupEulaDialogOpen(false);
	            }
	          },
	          renderApiGroupDialog()
	        ),
	        _react2.default.createElement(
	          _components.FormDialog,
	          {
	            dialogId: 'application-api-tag-dialog',
	            isOpen: isApiTagSelectDialogOpen,
	            title: tagPopupDialogTitle,
	            submitText: tagPopupDialogBtnText,
	            onSubmit: onTagsPopupSubmit,
	            cancelText: _labels.CANCEL_TEXT,
	            onCancel: function onCancel() {
	              setIsApiTagSelectDialogOpen(false);
	            }
	          },
	          renderTagModalDialog()
	        ),
	        _react2.default.createElement(_components.ExpandPanelContainer, Object.assign({
	          id: 'application-selected-apis-api-groups',
	          defaultList: selectedApisApiGroups,
	          error: error,
	          isApiDetails: true,
	          isApiGroup: true,
	          subtitle: featureFlagApiPlans ? _labels.APPLICATION_API_SELECTED_APIS_TITLE : _labels.APPLICATION_API_SELECTED_APIS_AND_API_GROUPS_TITLE
	        }, featureFlagApiPlans && { panelSubtitle: getApiPlanSelectTable }, {
	          isDeleteIcon: true,
	          onDeleteItem: function onDeleteItem(_ref9) {
	            var type = _ref9.type,
	                uuid = _ref9.uuid;
	
	            switch (type) {
	              case _constants.TYPE_API:
	                {
	                  return onDeleteApi(uuid);
	                }
	              case _constants.TYPE_API_GROUP:
	                {
	                  return onDeleteApiGroup(uuid);
	                }
	              default:
	                {
	                  return null;
	                }
	            }
	          },
	          getSelectedItem: function getSelectedItem(item) {
	            return item.apiPlanId;
	          },
	          onSelectItem: onSelectApiPlan,
	          emptyListMessage: getI18nMessage('label.application.apis.selected.empty')
	        })),
	        _react2.default.createElement(_core.Divider, { className: classes.divider }),
	        _react2.default.createElement(_components.TabsContainer, {
	          useTabId: true,
	          orientation: 'horizontal',
	          tabValue: currentAvailableTab,
	          tabItems: tabs,
	          handleTabChange: function handleTabChange(e, newTab) {
	            setCurrentAvailableTab(newTab);
	          }
	        }),
	        tabs.map(function (_ref10) {
	          var tabId = _ref10.tabId,
	              tabPanel = _ref10.tabPanel;
	          return _react2.default.createElement(
	            _components.TabPanel,
	            {
	              id: tabId + '-panel',
	              visible: currentAvailableTab === tabId,
	              key: tabId
	            },
	            tabPanel(Object.assign({}, props, {
	              currentAvailableTab: currentAvailableTab,
	              setApiUuidToAdd: setApiUuidToAdd,
	              onLoadMoreApisProps: onLoadMoreApisProps,
	              setApiGroupUuidToAdd: setApiGroupUuidToAdd,
	              onLoadMoreApiGroupsProps: onLoadMoreApiGroupsProps,
	              SecondaryLabelComponent: renderTagsLabel,
	              ExternalFilter: renderTagsFilter,
	              onAPISearchTextChange: onAPISearchTextChange,
	              onAPIGroupSearchTextChange: onAPIGroupSearchTextChange
	            }))
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      assistText: _labels.APPLICATION_API_MANAGEMENT_ASSIST_TEXT,
	      nextText: isMultiKeySupport ? (0, _intl.getI18nFormattedMessage)('label.save.button') : (0, _intl.getI18nFormattedMessage)('label.next.button'),
	      onCancelClick: onCancel,
	      id: 'organization-form-buttons'
	    })
	  );
	}
	
	ApiManagement.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  headerRef: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  featureFlagApiPlans: _propTypes2.default.bool,
	  userContext: _propTypes2.default.shape({}),
	  userActiveOrgUuid: _propTypes2.default.string,
	  currentTab: _propTypes2.default.string,
	  setCurrentTab: _propTypes2.default.func,
	  visible: _propTypes2.default.bool,
	  applicationDetails: _propTypes2.default.shape({}),
	  setApplicationDetails: _propTypes2.default.func,
	  selectedApis: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  availableApis: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  availableApisCount: _propTypes2.default.number,
	  fetchAvailableApis: _propTypes2.default.func,
	  apiEula: _propTypes2.default.shape({
	    content: _propTypes2.default.string
	  }),
	  selectedApiGroups: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  availableApiGroups1: _propTypes2.default.shape({}),
	  fetchAvailableApiGroups: _propTypes2.default.func,
	  apiGroupEulas: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    content: _propTypes2.default.string
	  })),
	  fetchAllTags: _propTypes2.default.func,
	  allTags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchAvailableApiPlans: _propTypes2.default.func,
	  availableApiPlans: _propTypes2.default.shape({}),
	  onCancel: _propTypes2.default.func,
	  applicationUuid: _propTypes2.default.string,
	  isSaveApplicationSuccess: _propTypes2.default.bool,
	  isMultiKeySupport: _propTypes2.default.bool
	};

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.availableApiGroupsTabPanel = exports.availableApisTabPanel = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(121);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var availableApisTabPanel = exports.availableApisTabPanel = function availableApisTabPanel(_ref) {
	  var applicationDetails = _ref.applicationDetails,
	      availableApis = _ref.availableApis,
	      fetchApiEula = _ref.fetchApiEula,
	      setApiUuidToAdd = _ref.setApiUuidToAdd,
	      onLoadMoreApisProps = _ref.onLoadMoreApisProps,
	      SecondaryLabelComponent = _ref.SecondaryLabelComponent,
	      ExternalFilter = _ref.ExternalFilter,
	      onAPISearchTextChange = _ref.onAPISearchTextChange;
	  return _react2.default.createElement(_components.ExpandPanelContainer, Object.assign({
	    id: 'application-available-apis',
	    defaultList: availableApis,
	    hasTagSearch: true,
	    SecondaryLabelComponent: SecondaryLabelComponent,
	    ExternalFilter: ExternalFilter,
	    onSearchTextChange: onAPISearchTextChange,
	    emptyListMessage: 'No available APIs to be selected.',
	    subtitle: _labels.APPLICATION_API_AVAILABLE_APIS_TITLE,
	    placeHolderText: _labels.APPLICATION_API_SEARCH_AVAILABLE_APIS_PLACEHOLDER,
	    isAddIcon: true,
	    isApiDetails: true,
	    isAdded: function isAdded(_ref2) {
	      var uuid = _ref2.uuid;
	      return applicationDetails.apiIds.includes(uuid);
	    },
	    onAddItem: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref3) {
	        var uuid = _ref3.uuid,
	            apiEulaUuid = _ref3.apiEulaUuid;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return fetchApiEula(apiEulaUuid);
	
	              case 2:
	                setApiUuidToAdd(uuid);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }()
	  }, onLoadMoreApisProps, {
	    hasSearch: function hasSearch() {}
	  }));
	};
	
	var availableApiGroupsTabPanel = exports.availableApiGroupsTabPanel = function availableApiGroupsTabPanel(_ref5) {
	  var _ref5$userContext = _ref5.userContext,
	      userContext = _ref5$userContext === undefined ? {} : _ref5$userContext,
	      userActiveOrgUuid = _ref5.userActiveOrgUuid,
	      applicationDetails = _ref5.applicationDetails,
	      availableApiGroups = _ref5.availableApiGroups,
	      fetchApiGroupEulas = _ref5.fetchApiGroupEulas,
	      setApiGroupUuidToAdd = _ref5.setApiGroupUuidToAdd,
	      onLoadMoreApiGroupsProps = _ref5.onLoadMoreApiGroupsProps,
	      onAPIGroupSearchTextChange = _ref5.onAPIGroupSearchTextChange;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_components.ExpandPanelContainer, Object.assign({
	      id: 'application-available-api-groups',
	      defaultList: availableApiGroups,
	      onSearchTextChange: onAPIGroupSearchTextChange,
	      subtitle: _labels.APPLICATION_API_AVAILABLE_API_GROUPS_TITLE,
	      placeHolderText: _labels.APPLICATION_API_SEARCH_AVAILABLE_API_GROUPS_PLACEHOLDER,
	      isAddIcon: true,
	      isApiGroup: true,
	      emptyListMessage: 'No available API Groups to be selected.',
	      isAdded: function isAdded(_ref6) {
	        var uuid = _ref6.uuid;
	        return applicationDetails.apiGroupIds.includes(uuid);
	      },
	      onAddItem: function () {
	        var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(_ref7) {
	          var uuid = _ref7.uuid;
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  _context2.next = 2;
	                  return fetchApiGroupEulas(uuid, (0, _utils.hasOrgBoundRole)(userContext) ? userActiveOrgUuid : applicationDetails.organizationUuid);
	
	                case 2:
	                  setApiGroupUuidToAdd(uuid);
	
	                case 3:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, undefined);
	        }));
	
	        return function (_x2) {
	          return _ref8.apply(this, arguments);
	        };
	      }()
	    }, onLoadMoreApiGroupsProps, {
	      hasSearch: function hasSearch() {}
	    }))
	  );
	};
	
	exports.default = [{
	  tabId: 'available-apis-tab',
	  label: 'APIs',
	  tabPanel: availableApisTabPanel
	}, {
	  tabId: 'available-api-groups-tab',
	  label: 'API Groups',
	  isHidden: function isHidden(_ref9) {
	    var featureFlagApiPlans = _ref9.featureFlagApiPlans;
	    return !!featureFlagApiPlans;
	  },
	  tabPanel: availableApiGroupsTabPanel
	}];
	
	
	availableApisTabPanel.propTypes = {
	  applicationDetails: _propTypes2.default.shape({}),
	  availableApis: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchApiEula: _propTypes2.default.func,
	  setApiUuidToAdd: _propTypes2.default.func,
	  onLoadMoreApisProps: _propTypes2.default.func,
	  onAPISearchTextChange: _propTypes2.default.func,
	  SecondaryLabelComponent: _propTypes2.default.func,
	  ExternalFilter: _propTypes2.default.func
	};
	
	availableApiGroupsTabPanel.propTypes = {
	  userContext: _propTypes2.default.shape({}),
	  userActiveOrgUuid: _propTypes2.default.string,
	  applicationDetails: _propTypes2.default.shape({}),
	  availableApiGroups: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchApiGroupEulas: _propTypes2.default.func,
	  setApiGroupUuidToAdd: _propTypes2.default.func,
	  onLoadMoreApiGroupsProps: _propTypes2.default.func,
	  onAPIGroupSearchTextChange: _propTypes2.default.func
	};

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = Auth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	var _labels = __webpack_require__(121);
	
	var _intl = __webpack_require__(15);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Auth(props) {
	  var _this = this;
	
	  var classes = props.classes,
	      userContext = props.userContext,
	      headerRef = props.headerRef,
	      _props$errors = props.errors,
	      errors = _props$errors === undefined ? [] : _props$errors,
	      showLoading = props.showLoading,
	      push = props.push,
	      setCurrentTab = props.setCurrentTab,
	      applicationUuid = props.applicationUuid,
	      _props$applicationDet = props.applicationDetails,
	      applicationDetails = _props$applicationDet === undefined ? {} : _props$applicationDet,
	      setApplicationDetails = props.setApplicationDetails,
	      appSecretHashingMetadata = props.appSecretHashingMetadata,
	      setShowOneTimePasswordWarning = props.setShowOneTimePasswordWarning,
	      setIsHashedSecret = props.setIsHashedSecret,
	      isPlainTextCheckBoxSelected = props.isPlainTextCheckBoxSelected,
	      setIsPlainTextCheckBoxSelected = props.setIsPlainTextCheckBoxSelected,
	      onCancel = props.onCancel,
	      onSaveApplication = props.onSaveApplication,
	      isSaveApplicationSuccess = props.isSaveApplicationSuccess,
	      notifyMessages = props.notifyMessages,
	      isApplicationRequestWorkflowEnabled = props.isApplicationRequestWorkflowEnabled,
	      isEditApplicationRequestWorkflowEnabled = props.isEditApplicationRequestWorkflowEnabled;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var oauthCallbackUrl = applicationDetails.oauthCallbackUrl,
	      oauthScope = applicationDetails.oauthScope,
	      oauthType = applicationDetails.oauthType;
	
	  var allowSelectHashing = (0, _get2.default)(appSecretHashingMetadata, 'plaintextAllowed');
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isSelectHashingDialogOpen = _useState2[0],
	      setIsSelectHashingDialogOpen = _useState2[1];
	
	  var _handleChange = function _handleChange(fieldName) {
	    var fieldValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    localStorage.setItem('isAppUnSavedChanges', true);
	    setApplicationDetails(Object.assign({}, applicationDetails, _defineProperty({}, fieldName, fieldValue)));
	  };
	
	  (0, _react.useEffect)(function () {
	    if (isSaveApplicationSuccess && applicationDetails.uuid) {
	      var isHashedSecretEnforced = (0, _get2.default)(appSecretHashingMetadata, 'algorithm') && !(0, _get2.default)(appSecretHashingMetadata, 'plaintextAllowed');
	      var isHashedSecretSelected = (0, _get2.default)(appSecretHashingMetadata, 'plaintextAllowed') && !isPlainTextCheckBoxSelected;
	      var isHashedSecret = isHashedSecretEnforced || isHashedSecretSelected;
	
	      setIsHashedSecret(isHashedSecret);
	      if (!applicationUuid) {
	        setShowOneTimePasswordWarning(isHashedSecret);
	      }
	      setCurrentTab('key-tab');
	      push('/publish/applications/edit/' + applicationDetails.uuid + '/key');
	      showLoading(false);
	      notifyMessages((0, _utils.hasOrgBoundRole)(userContext) && isApplicationRequestWorkflowEnabled ? intl.getI18nMessage('label.application.request.submit.success') : intl.getI18nMessage('label.application.create.success'), _constants.ALERT_SUCCESS);
	      window.scrollTo(0, headerRef.offsetTop);
	    }
	  }, [isSaveApplicationSuccess, applicationDetails]);
	
	  var onNextUpdate = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              setCurrentTab('key-tab');
	              window.scrollTo(0, headerRef.offsetTop);
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function onNextUpdate() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var onNextCreate = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              localStorage.setItem('isAppUnSavedChanges', false);
	
	              if (!allowSelectHashing) {
	                _context2.next = 5;
	                break;
	              }
	
	              setIsSelectHashingDialogOpen(true);
	              _context2.next = 9;
	              break;
	
	            case 5:
	              _context2.next = 7;
	              return showLoading(true);
	
	            case 7:
	              _context2.next = 9;
	              return onSaveApplication();
	
	            case 9:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    return function onNextCreate() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var submitChangeRequestLabel = (0, _intl.getI18nFormattedMessage)('label.application.request.submit');
	  var createApplicationLabel = (0, _utils.hasOrgBoundRole)(userContext) && isApplicationRequestWorkflowEnabled ? submitChangeRequestLabel : _labels.CREATE_TEXT;
	  var createApplicationDialogLabel = (0, _utils.hasOrgBoundRole)(userContext) && isApplicationRequestWorkflowEnabled ? intl.getI18nMessage('label.application.create.after.approval.select.hashing') : intl.getI18nMessage('label.application.create.select.hashing');
	
	  var createApplicationAssistText = (0, _utils.hasOrgBoundRole)(userContext) && isApplicationRequestWorkflowEnabled ? intl.getI18nMessage('label.application.create.after.approval.assist.text') : intl.getI18nMessage('label.application.create.assist.text');
	
	  var getNewSecretLabel = (0, _utils.hasOrgBoundRole)(userContext) && isEditApplicationRequestWorkflowEnabled ? intl.getI18nMessage('label.application.key.shared.secret.request.new') : intl.getI18nMessage('label.application.key.shared.secret.generate.new');
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h1', className: classes.pageTitle },
	      'Authentication'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _components.FormDialog,
	      {
	        dialogId: 'application-select-hashing-dialog',
	        isOpen: isSelectHashingDialogOpen,
	        title: getNewSecretLabel,
	        description: _labels.APPLICATION_AUTH_SELECT_HASHING_DIALOG_SUBTITLE,
	        submitText: createApplicationDialogLabel,
	        onSubmit: _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  setIsSelectHashingDialogOpen(false);
	                  _context3.next = 3;
	                  return showLoading(true);
	
	                case 3:
	                  _context3.next = 5;
	                  return onSaveApplication(!isPlainTextCheckBoxSelected);
	
	                case 5:
	                  notifyMessages(intl.getI18nMessage('label.application.create.success'), _constants.ALERT_SUCCESS);
	
	                case 6:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this);
	        })),
	        cancelText: _labels.CANCEL_TEXT,
	        onCancel: function onCancel() {
	          setIsSelectHashingDialogOpen(false);
	        }
	      },
	      _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _core.Typography,
	          { component: 'span' },
	          _labels.APPLICATION_AUTH_SELECT_HASHING_DIALOG_SUBTITLE
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_core.FormControlLabel, {
	          control: _react2.default.createElement(_core.Checkbox, {
	            classes: { root: classes.iconRoot },
	            checked: isPlainTextCheckBoxSelected,
	            onChange: function onChange(e) {
	              return setIsPlainTextCheckBoxSelected(e.target.checked);
	            }
	          }),
	          label: _labels.APPLICATION_AUTH_SELECT_HASHING_DIALOG_CHECKBOX_LABEL
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 12, item: true },
	        _react2.default.createElement(_components.FormTextField, {
	          id: 'application-details-oauth-callback-url',
	          name: 'Callback/Redirect URL(s)',
	          value: oauthCallbackUrl || '',
	          handleChange: function handleChange(value) {
	            _handleChange('oauthCallbackUrl', value || '');
	          },
	          helperText: 'Maximum length is 2048 characters. Use commas to separate entries.',
	          multiline: true,
	          rows: 4,
	          optional: true,
	          maxLength: '2048'
	        }),
	        _react2.default.createElement(_components.FormTextField, {
	          id: 'application-details-scope',
	          name: 'Scope',
	          value: oauthScope || '',
	          handleChange: function handleChange(value) {
	            _handleChange('oauthScope', value || '');
	          },
	          helperText: 'Maximum length is 4000 characters. Use spaces to separate entries. Maximum length is 450 characters for OTK versions older than 4.3.',
	          multiline: true,
	          rows: 4,
	          optional: true,
	          maxLength: '4000'
	        }),
	        _react2.default.createElement(_components.FormButtonGroup, {
	          id: 'application-details-oauth-type',
	          name: 'Type',
	          value: oauthType,
	          data: [{ uuid: null, name: 'None' }, { uuid: 'PUBLIC', name: 'Public' }, { uuid: 'CONFIDENTIAL', name: 'Confidential' }],
	          handleChange: function handleChange(value) {
	            _handleChange('oauthType', value);
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: applicationUuid ? onNextUpdate : onNextCreate,
	      assistText: applicationUuid ? '' : createApplicationAssistText,
	      nextText: applicationUuid ? (0, _intl.getI18nFormattedMessage)('label.next.button') : createApplicationLabel,
	      onCancelClick: onCancel,
	      id: 'authentication-form-buttons'
	    })
	  );
	}
	
	Auth.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  userContext: _propTypes2.default.shape({}),
	  headerRef: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  showLoading: _propTypes2.default.func,
	  push: _propTypes2.default.func,
	  setCurrentTab: _propTypes2.default.func,
	  applicationUuid: _propTypes2.default.string,
	  applicationDetails: _propTypes2.default.shape({}),
	  setApplicationDetails: _propTypes2.default.func,
	  appSecretHashingMetadata: _propTypes2.default.shape({}),
	  setShowOneTimePasswordWarning: _propTypes2.default.func,
	  setIsHashedSecret: _propTypes2.default.func,
	  isPlainTextCheckBoxSelected: _propTypes2.default.bool,
	  setIsPlainTextCheckBoxSelected: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  onSaveApplication: _propTypes2.default.func,
	  isSaveApplicationSuccess: _propTypes2.default.bool,
	  isApplicationRequestWorkflowEnabled: _propTypes2.default.bool,
	  isEditApplicationRequestWorkflowEnabled: _propTypes2.default.bool,
	  notifyMessages: _propTypes2.default.func
	};

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomField = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = CustomFields;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MAX_LENGTH = 5000;
	
	var getCustomField = exports.getCustomField = function getCustomField(applicationDetails, _ref, applicationCustomFieldErrors, _handleChange) {
	  var type = _ref.type,
	      uuid = _ref.uuid,
	      name = _ref.name,
	      description = _ref.description,
	      optionsList = _ref.optionsList,
	      required = _ref.required;
	
	  var customFieldValue = applicationDetails.customFieldValues[uuid];
	  var helperText = description ? description + '. Maximum field length is 5000 characters.' : 'Maximum field length is 5000 characters.';
	  switch (type) {
	    case 'TEXT':
	      return _react2.default.createElement(_components.FormTextField, Object.assign({
	        key: uuid,
	        id: uuid,
	        name: name,
	        value: customFieldValue,
	        error: applicationCustomFieldErrors[uuid],
	        handleChange: function handleChange(value) {
	          return _handleChange(uuid, value, required);
	        },
	        helperText: helperText
	      }, !required && { optional: true }));
	    case 'SINGLE_SELECT':
	      {
	        var data = optionsList.map(function (_ref2) {
	          var value = _ref2.value;
	          return { uuid: value, name: value };
	        });
	        var handleSingleSelectChange = function handleSingleSelectChange(e) {
	          var singleSelectValue = (0, _lodash.find)(optionsList, function (_ref3) {
	            var value = _ref3.value;
	            return value === (0, _lodash.get)(e, 'target.value');
	          });
	          _handleChange(uuid, (0, _lodash.get)(singleSelectValue, 'value'), required);
	        };
	        return _react2.default.createElement(_components.FormSelect, Object.assign({
	          key: uuid,
	          id: uuid,
	          name: name,
	          value: customFieldValue,
	          defaultText: 'Select an option.',
	          data: data,
	          handleChange: handleSingleSelectChange,
	          helperText: description,
	          error: applicationCustomFieldErrors[uuid]
	        }, !required && { optional: true }));
	      }
	    default:
	      return null;
	  }
	};
	
	function CustomFields(props) {
	  var classes = props.classes,
	      headerRef = props.headerRef,
	      _props$errors = props.errors,
	      errors = _props$errors === undefined ? [] : _props$errors,
	      setCurrentTab = props.setCurrentTab,
	      _props$applicationDet = props.applicationDetails,
	      applicationDetails = _props$applicationDet === undefined ? {} : _props$applicationDet,
	      setApplicationDetails = props.setApplicationDetails,
	      _props$customFields = props.customFields,
	      customFields = _props$customFields === undefined ? [] : _props$customFields,
	      onCancel = props.onCancel;
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      applicationCustomFieldErrors = _useState2[0],
	      setApplicationCustomFieldErrors = _useState2[1];
	
	  var handleChange = function handleChange(fieldName, value, required) {
	    localStorage.setItem('isAppUnSavedChanges', true);
	    var customFieldValues = applicationDetails.customFieldValues;
	
	    if (value.length > MAX_LENGTH) {
	      setApplicationCustomFieldErrors(Object.assign({}, applicationCustomFieldErrors, _defineProperty({}, fieldName, true)));
	    } else {
	      setApplicationDetails(Object.assign({}, applicationDetails, {
	        customFieldValues: Object.assign({}, customFieldValues, _defineProperty({}, fieldName, value))
	      }));
	      setApplicationCustomFieldErrors(Object.assign({}, applicationCustomFieldErrors, _defineProperty({}, fieldName, required && !value)));
	    }
	  };
	
	  var onNext = function onNext() {
	    var customFieldValues = applicationDetails.customFieldValues;
	
	    var customFieldErrors = customFields.filter(function (_ref4) {
	      var required = _ref4.required;
	      return required;
	    }).reduce(function (acc, _ref5) {
	      var uuid = _ref5.uuid;
	      return Object.assign({}, acc, _defineProperty({}, uuid, !customFieldValues[uuid]));
	    }, {});
	
	    if ((0, _lodash.some)((0, _lodash.values)(customFieldErrors)) || (0, _lodash.some)((0, _lodash.values)(applicationCustomFieldErrors))) {
	      if (!(0, _lodash.isEmpty)(applicationCustomFieldErrors)) {
	        (0, _lodash.each)(applicationCustomFieldErrors, function (val, key) {
	          if (customFieldErrors[key]) {
	            applicationCustomFieldErrors[key] = customFieldErrors[key];
	          }
	        });
	        setApplicationCustomFieldErrors(Object.assign({}, applicationCustomFieldErrors));
	      } else {
	        setApplicationCustomFieldErrors(Object.assign({}, applicationCustomFieldErrors, customFieldErrors));
	      }
	    } else {
	      setApplicationDetails(Object.assign({}, applicationDetails, {
	        customFieldValues: customFields.reduce(function (acc, _ref6) {
	          var uuid = _ref6.uuid;
	
	          if ((0, _lodash.isUndefined)(acc[uuid])) {
	            acc[uuid] = '';
	          }
	          return acc;
	        }, applicationDetails.customFieldValues)
	      }));
	      setCurrentTab('api-management-tab');
	      window.scrollTo(0, headerRef.offsetTop);
	    }
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h1', className: classes.pageTitle },
	      'Custom Fields'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 12, item: true },
	        customFields.map(function (customField) {
	          return getCustomField(applicationDetails, customField, applicationCustomFieldErrors, handleChange);
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      assistText: _labels.APPLICATION_CUSTOM_FIELDS_ASSIST_TEXT,
	      nextText: _labels.NEXT_TEXT,
	      onCancelClick: onCancel,
	      id: 'visibility-form-buttons'
	    })
	  );
	}
	
	CustomFields.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  headerRef: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  setCurrentTab: _propTypes2.default.func,
	  applicationDetails: _propTypes2.default.shape({}),
	  setApplicationDetails: _propTypes2.default.func,
	  customFields: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  onCancel: _propTypes2.default.func
	};

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = Details;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	var _labels = __webpack_require__(121);
	
	var _labels2 = _interopRequireDefault(_labels);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getSelectedOrganization = function getSelectedOrganization() {
	  var organizations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var organizationUuid = arguments[1];
	  return organizations.find(function (organization) {
	    return organization.uuid === organizationUuid;
	  }) || {};
	};
	
	var getSelectedOrganizationForOrgBoundUser = function getSelectedOrganizationForOrgBoundUser() {
	  var userAccessibleOrgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var userActiveOrgUuid = arguments[1];
	  return userAccessibleOrgs.find(function (userAccessibleOrg) {
	    return userAccessibleOrg.uuid === userActiveOrgUuid;
	  }) || {};
	};
	
	function Details(_ref) {
	  var _this = this;
	
	  var classes = _ref.classes,
	      headerRef = _ref.headerRef,
	      _ref$dict = _ref.dict,
	      dict = _ref$dict === undefined ? {} : _ref$dict,
	      _ref$errors = _ref.errors,
	      errors = _ref$errors === undefined ? [] : _ref$errors,
	      _ref$userContext = _ref.userContext,
	      userContext = _ref$userContext === undefined ? {} : _ref$userContext,
	      userActiveOrgUuid = _ref.userActiveOrgUuid,
	      userAccessibleOrgs = _ref.userAccessibleOrgs,
	      currentTab = _ref.currentTab,
	      setCurrentTab = _ref.setCurrentTab,
	      isApplicationNameUnique = _ref.isApplicationNameUnique,
	      fetchApplicationNameUnique = _ref.fetchApplicationNameUnique,
	      applicationUuid = _ref.applicationUuid,
	      _ref$applicationDetai = _ref.applicationDetails,
	      applicationDetails = _ref$applicationDetai === undefined ? {} : _ref$applicationDetai,
	      setApplicationDetails = _ref.setApplicationDetails,
	      _ref$organizations = _ref.organizations1,
	      organizations1 = _ref$organizations === undefined ? {} : _ref$organizations,
	      _ref$customFields = _ref.customFields,
	      customFields = _ref$customFields === undefined ? [] : _ref$customFields,
	      fetchOrganizations = _ref.fetchOrganizations,
	      fetchAvailableApis = _ref.fetchAvailableApis,
	      fetchAvailableApiGroups = _ref.fetchAvailableApiGroups,
	      onCancel = _ref.onCancel;
	
	  var i18n = (0, _labels2.default)(dict);
	  var _applicationDetails$n = applicationDetails.name,
	      name = _applicationDetails$n === undefined ? '' : _applicationDetails$n,
	      _applicationDetails$d = applicationDetails.description,
	      description = _applicationDetails$d === undefined ? '' : _applicationDetails$d,
	      organizationUuid = applicationDetails.organizationUuid,
	      organizationName = applicationDetails.organizationName,
	      _applicationDetails$s = applicationDetails.status,
	      status = _applicationDetails$s === undefined ? '' : _applicationDetails$s;
	
	  var selectedOrganization = (0, _utils.hasOrgBoundRole)(userContext) ? getSelectedOrganizationForOrgBoundUser(userAccessibleOrgs, userActiveOrgUuid) : getSelectedOrganization(organizations1.results, organizationUuid);
	
	  var _useState = (0, _react.useState)(name),
	      _useState2 = _slicedToArray(_useState, 2),
	      applicationName = _useState2[0],
	      setApplicationName = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(status),
	      _useState4 = _slicedToArray(_useState3, 2),
	      appStatus = _useState4[0],
	      setAppStatus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(description),
	      _useState6 = _slicedToArray(_useState5, 2),
	      applicationDescription = _useState6[0],
	      setApplicationDescription = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({}),
	      _useState8 = _slicedToArray(_useState7, 2),
	      applicationDetailsErrors = _useState8[0],
	      setApplicationDetailsErrors = _useState8[1];
	
	  (0, _react.useEffect)(function () {
	    setApplicationName(name);
	  }, [name]);
	  (0, _react.useEffect)(function () {
	    setAppStatus(status);
	  }, [status]);
	  (0, _react.useEffect)(function () {
	    setApplicationDescription(description);
	  }, [description]);
	
	  (0, _react.useEffect)(function () {
	    if (currentTab !== 'details-tab') {
	      return;
	    }
	    if (!(0, _utils.hasOrgBoundRole)(userContext)) {
	      fetchOrganizations();
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (currentTab !== 'details-tab') {
	      return;
	    }
	    if (selectedOrganization.uuid) {
	      fetchAvailableApis({ orgUuid: selectedOrganization.uuid });
	      fetchAvailableApiGroups({ orgUuid: selectedOrganization.uuid });
	    }
	  }, [selectedOrganization.uuid]);
	
	  (0, _react.useEffect)(function () {
	    // Re-run Unique Name check on direct navigating from Application Key tab
	    if (currentTab === 'application-key-tab') {
	      if ((0, _utils.hasOrgBoundRole)(userContext)) {
	        fetchApplicationNameUnique(name, applicationUuid);
	      } else if (selectedOrganization.uuid) {
	        fetchApplicationNameUnique(name, applicationUuid, selectedOrganization.uuid);
	      }
	    }
	  }, [name, applicationUuid, selectedOrganization.uuid]);
	  (0, _react.useEffect)(function () {
	    setApplicationDetailsErrors(Object.assign({}, applicationDetailsErrors, {
	      name: isApplicationNameUnique === false
	    }));
	  }, [isApplicationNameUnique]);
	
	  var _handleChange = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(fieldName, fieldValue) {
	      var selectedOrganizationUuid;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              localStorage.setItem('isAppUnSavedChanges', true);
	              _context.t0 = fieldName;
	              _context.next = _context.t0 === 'organizationUuid' ? 4 : _context.t0 === 'name' ? 11 : _context.t0 === 'status' ? 22 : _context.t0 === 'description' ? 25 : 27;
	              break;
	
	            case 4:
	              selectedOrganizationUuid = fieldValue.uuid || organizationUuid;
	              // Re-run unique name check and initialize name error with hasError check if name is set
	
	              if (!(name && selectedOrganizationUuid)) {
	                _context.next = 8;
	                break;
	              }
	
	              _context.next = 8;
	              return fetchApplicationNameUnique(name, applicationUuid, selectedOrganizationUuid);
	
	            case 8:
	              setApplicationDetailsErrors(Object.assign({}, applicationDetailsErrors, name && { name: (0, _utils.hasError)(name, true) }, {
	                organizationUuid: !fieldValue
	              }));
	              setApplicationDetails(Object.assign({}, applicationDetails, {
	                organizationUuid: fieldValue ? fieldValue.uuid : null,
	                organizationName: fieldValue ? fieldValue.name : null
	              }));
	              return _context.abrupt('break', 27);
	
	            case 11:
	              setApplicationDetailsErrors(Object.assign({}, applicationDetailsErrors, { name: (0, _utils.hasError)(fieldValue, true) }));
	              setApplicationName(fieldValue);
	
	              if (!(0, _utils.hasOrgBoundRole)(userContext)) {
	                _context.next = 18;
	                break;
	              }
	
	              _context.next = 16;
	              return fetchApplicationNameUnique(fieldValue, applicationUuid);
	
	            case 16:
	              _context.next = 21;
	              break;
	
	            case 18:
	              if (!selectedOrganization.uuid) {
	                _context.next = 21;
	                break;
	              }
	
	              _context.next = 21;
	              return fetchApplicationNameUnique(fieldValue, applicationUuid, selectedOrganization.uuid);
	
	            case 21:
	              return _context.abrupt('break', 27);
	
	            case 22:
	              setAppStatus(fieldValue);
	              setApplicationDetails(Object.assign({}, applicationDetails, { status: fieldValue }));
	              return _context.abrupt('break', 27);
	
	            case 25:
	              setApplicationDescription(fieldValue);
	              return _context.abrupt('break', 27);
	
	            case 27:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function _handleChange(_x3, _x4) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var handleBlurNameField = function handleBlurNameField(nameValue) {
	    // Set to Application Details on blur to reduce the render cycles
	    setApplicationDetails(Object.assign({}, applicationDetails, { name: nameValue }));
	  };
	  var handleBlurDescriptionField = function handleBlurDescriptionField(descriptionValue) {
	    // Set to Application Details on blur to reduce the render cycles
	    setApplicationDetails(Object.assign({}, applicationDetails, { description: descriptionValue }));
	  };
	
	  (0, _react.useEffect)(function () {
	    // Recurring fetch call to cache the organizations
	    if (organizations1.currentPage + 1 < organizations1.totalPages) {
	      fetchOrganizations(organizations1.currentPage + 1);
	    }
	  }, [organizations1]);
	
	  var onOrgBoundNext = function onOrgBoundNext() {
	    var nameError = (0, _utils.hasError)(name || applicationName, true) || isApplicationNameUnique === false;
	    if (nameError) {
	      setApplicationDetailsErrors(Object.assign({}, applicationDetailsErrors, {
	        name: nameError
	      }));
	    } else if (isApplicationNameUnique === true) {
	      if (!(0, _lodash.isEmpty)(customFields)) {
	        setCurrentTab('custom-fields-tab');
	        window.scrollTo(0, headerRef.offsetTop);
	      } else {
	        setCurrentTab('api-management-tab');
	        window.scrollTo(0, headerRef.offsetTop);
	      }
	    }
	  };
	
	  var onNext = function onNext() {
	    var organizationUuidError = !organizationUuid;
	    var nameError = (0, _utils.hasError)(name || applicationName, true) || isApplicationNameUnique === false;
	    if ((0, _lodash.some)([organizationUuidError, nameError])) {
	      setApplicationDetailsErrors(Object.assign({}, applicationDetailsErrors, {
	        organizationUuid: organizationUuidError,
	        name: nameError
	      }));
	    } else if (isApplicationNameUnique === true) {
	      if (!(0, _lodash.isEmpty)(customFields)) {
	        setCurrentTab('custom-fields-tab');
	        window.scrollTo(0, headerRef.offsetTop);
	      } else {
	        setCurrentTab('api-management-tab');
	        window.scrollTo(0, headerRef.offsetTop);
	      }
	    }
	  };
	
	  var appStatusOptions = [{
	    key: 'ENABLED',
	    label: 'Enabled'
	  }, {
	    key: 'DISABLED',
	    label: 'Disabled'
	  }];
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h1', className: classes.pageTitle },
	      'Details'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 12, item: true },
	        !(0, _utils.hasOrgBoundRole)(userContext) && (applicationUuid ? _react2.default.createElement(_components.FormTextField, {
	          id: 'application-selected-organization',
	          name: 'Organization Name',
	          value: organizationName,
	          disabled: true
	        }) : _react2.default.createElement(_components.FormAutoCompleteCombo, {
	          id: 'application-selected-organization',
	          name: 'Selected Organization',
	          selectedValues: selectedOrganization,
	          data: organizations1.results,
	          error: applicationDetailsErrors.organizationUuid,
	          onChange: function onChange(e, value) {
	            _handleChange('organizationUuid', value);
	          },
	          loading: organizations1.currentPage < organizations1.totalPages - 1,
	          helperText: 'Select at least one organization.'
	        })),
	        _react2.default.createElement(_components.FormTextField, {
	          id: 'application-name',
	          name: 'Application Name',
	          value: applicationName,
	          error: applicationDetailsErrors.name || isApplicationNameUnique === false,
	          handleChange: function handleChange(value) {
	            _handleChange('name', value);
	          },
	          handleBlur: function handleBlur(value) {
	            handleBlurNameField(value);
	          },
	          helperText: 'Maximum name length is 50 characters. Name must be unique.',
	          maxLength: '50'
	        }),
	        applicationUuid && status !== _constants.APPLICATION_STATUS_REJECTED && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            _core.FormControl,
	            { component: 'fieldset', className: classes.statusField },
	            _react2.default.createElement(
	              _core.FormLabel,
	              { component: 'legend', focused: false },
	              'Status'
	            ),
	            [_constants.APPLICATION_STATUS_PENDING_APPROVAL, _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL].includes(status) ? _react2.default.createElement(
	              _react.Fragment,
	              null,
	              _react2.default.createElement(
	                _core.Typography,
	                { classes: { root: classes.labelText }, gutterBottom: true },
	                'Pending Approval'
	              ),
	              _react2.default.createElement(
	                _core.FormHelperText,
	                { classes: { root: classes.helperText } },
	                'Approve or reject the request to enable or disable this app.'
	              )
	            ) : _react2.default.createElement(
	              _core.RadioGroup,
	              {
	                value: appStatus,
	                onChange: function onChange(e) {
	                  return _handleChange('status', e.target.value);
	                }
	              },
	              appStatusOptions.map(function (item) {
	                return _react2.default.createElement(
	                  _react.Fragment,
	                  { key: item.key },
	                  _react2.default.createElement(_core.FormControlLabel, {
	                    control: _react2.default.createElement(_core.Radio, { classes: { root: classes.iconRoot } }),
	                    key: item.key,
	                    label: item.label,
	                    value: item.key
	                  })
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_components.FormTextField, {
	          id: 'application-description',
	          name: 'Public Description',
	          value: applicationDescription,
	          handleChange: function handleChange(value) {
	            _handleChange('description', value || '');
	          },
	          handleBlur: function handleBlur(value) {
	            handleBlurDescriptionField(value);
	          },
	          helperText: 'Maximum description length is 255 characters',
	          multiline: true,
	          rows: 4,
	          optional: true,
	          maxLength: '255'
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: (0, _utils.hasOrgBoundRole)(userContext) ? onOrgBoundNext : onNext,
	      nextText: i18n(_labels.LABEL_BUTTON_NEXT),
	      onCancelClick: onCancel,
	      id: 'details-form-buttons'
	    })
	  );
	}
	
	Details.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  headerRef: _propTypes2.default.shape({}),
	  userContext: _propTypes2.default.shape({}),
	  userActiveOrgUuid: _propTypes2.default.string,
	  userAccessibleOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  dict: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  currentTab: _propTypes2.default.string,
	  setCurrentTab: _propTypes2.default.func,
	  isApplicationNameUnique: _propTypes2.default.bool,
	  fetchApplicationNameUnique: _propTypes2.default.func,
	  applicationUuid: _propTypes2.default.string,
	  applicationDetails: _propTypes2.default.shape({}),
	  organizations1: _propTypes2.default.shape({}),
	  customFields: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  setApplicationDetails: _propTypes2.default.func,
	  fetchOrganizations: _propTypes2.default.func,
	  fetchAvailableApis: _propTypes2.default.func,
	  fetchAvailableApiGroups: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func
	};

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _copyToClipboard = __webpack_require__(117);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _lodash = __webpack_require__(8);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	var _labels = __webpack_require__(121);
	
	var _intl = __webpack_require__(15);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Key = function Key(props) {
	  var classes = props.classes,
	      userContext = props.userContext,
	      _props$errors = props.errors,
	      errors = _props$errors === undefined ? [] : _props$errors,
	      _props$applicationDet = props.applicationDetails,
	      applicationDetails = _props$applicationDet === undefined ? {} : _props$applicationDet,
	      applicationStatus = props.applicationStatus,
	      setApplicationDetails = props.setApplicationDetails,
	      applicationUuid = props.applicationUuid,
	      generateSecret = props.generateSecret,
	      secret = props.secret,
	      onCancel = props.onCancel,
	      appSecretHashingMetadata = props.appSecretHashingMetadata,
	      notifyMessages = props.notifyMessages,
	      appKeys = props.appKeys,
	      push = props.push,
	      onUpdateApplicationSecret = props.onUpdateApplicationSecret,
	      isSaveApplicationSecretSuccess = props.isSaveApplicationSecretSuccess,
	      isEditApplicationRequestWorkflowEnabled = props.isEditApplicationRequestWorkflowEnabled;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var apiKey = applicationDetails.apiKey,
	      keySecret = applicationDetails.keySecret;
	  var status = applicationDetails.status;
	
	  var isSaveApplicationDisabled = [_constants.APPLICATION_STATUS_PENDING_APPROVAL, _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL].includes(status);
	  var isGenerateSecretDisabled = [_constants.APPLICATION_STATUS_DISABLED, _constants.APPLICATION_STATUS_PENDING_APPROVAL, _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL].includes(applicationStatus);
	
	  if (appKeys && appKeys.length > 0) {
	    var defaultKey = appKeys.find(function (key) {
	      return (0, _get2.default)(key, 'defaultKey');
	    });
	    apiKey = (0, _get2.default)(defaultKey, 'apiKey');
	    keySecret = (0, _get2.default)(defaultKey, 'keySecret');
	  }
	
	  var _useState = (0, _react.useState)(secret || keySecret),
	      _useState2 = _slicedToArray(_useState, 2),
	      sharedSecret = _useState2[0],
	      setSharedSecret = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isSecretCopyButtonVisible = _useState4[0],
	      setIsSecretCopyButtonVisible = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isGenerateSecretDialogOpen = _useState6[0],
	      setIsGenerateSecretDialogOpen = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isPlainTextSelected = _useState8[0],
	      setIsPlainTextSelected = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(props.showOneTimePasswordWarning),
	      _useState10 = _slicedToArray(_useState9, 2),
	      showOneTimePasswordWarning = _useState10[0],
	      setShowOneTimePasswordWarning = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      notificationMessage = _useState12[0],
	      setNotificationMessage = _useState12[1];
	
	  var allowSelectHashing = (0, _get2.default)(appSecretHashingMetadata, 'plaintextAllowed');
	
	  var showSecretCopyButton = function showSecretCopyButton() {
	    if ((0, _lodash.isEmpty)(secret) && keySecret === _labels.APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB) {
	      setIsSecretCopyButtonVisible(false);
	    } else if (secret !== _labels.APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB) {
	      setIsSecretCopyButtonVisible(true);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    setTimeout(function () {
	      notifyMessages('', '');
	    }, 2500);
	  }, []);
	  (0, _react.useEffect)(function () {
	    var newSecret = secret || keySecret;
	    setNotificationMessage('');
	    setSharedSecret(newSecret);
	    setApplicationDetails(Object.assign({}, applicationDetails, { keySecret: newSecret }));
	    showSecretCopyButton();
	  }, [secret, keySecret]);
	  (0, _react.useEffect)(function () {
	    setShowOneTimePasswordWarning(props.showOneTimePasswordWarning);
	  }, [props.showOneTimePasswordWarning]);
	  (0, _react.useEffect)(function () {
	    if (isSaveApplicationSecretSuccess) {
	      push('/publish/applications/details/' + applicationUuid);
	      notifyMessages((0, _utils.hasOrgBoundRole)(userContext) && isEditApplicationRequestWorkflowEnabled ? intl.getI18nMessage('label.application.request.submit.success') : intl.getI18nMessage('label.application.update.success'), _constants.ALERT_SUCCESS);
	    }
	  }, [isSaveApplicationSecretSuccess]);
	
	  var generateSecretPopupSubmit = function generateSecretPopupSubmit() {
	    setNotificationMessage('');
	    notifyMessages('', '');
	    setIsGenerateSecretDialogOpen(false);
	    localStorage.setItem('isAppUnSavedChanges', true);
	    generateSecret(applicationUuid, isPlainTextSelected);
	    if (!(0, _lodash.isEmpty)(props.appSecretHashingMetadata) && !isPlainTextSelected) {
	      setShowOneTimePasswordWarning(true);
	    } else {
	      setShowOneTimePasswordWarning(false);
	    }
	  };
	
	  var showGenerateSecretPopup = function showGenerateSecretPopup(dropDownValue) {
	    if (dropDownValue === '0') {
	      return;
	    }
	    if (dropDownValue === '1') {
	      setIsPlainTextSelected(true);
	    } else {
	      setIsPlainTextSelected(false);
	    }
	    setIsGenerateSecretDialogOpen(true);
	  };
	
	  var showKeyCopyMessage = function showKeyCopyMessage(e) {
	    var message = _labels.APPLICATION_API_KEY_MESSAGE1 + e + _labels.APPLICATION_API_KEY_MESSAGE2;
	    setNotificationMessage(message);
	  };
	
	  var showSecretCopyMessage = function showSecretCopyMessage(e) {
	    var message = _labels.APPLICATION_SECRET_COPY_MESSAGE1 + e + _labels.APPLICATION_SECRET_COPY_MESSAGE2;
	    setNotificationMessage(message);
	  };
	
	  var onNext = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              localStorage.setItem('isAppUnSavedChanges', false);
	
	              if (!isSaveApplicationDisabled) {
	                _context.next = 5;
	                break;
	              }
	
	              setTimeout(function () {
	                push('/publish/applications/details/' + applicationUuid);
	              }, 1000);
	              _context.next = 7;
	              break;
	
	            case 5:
	              _context.next = 7;
	              return onUpdateApplicationSecret(!isPlainTextSelected);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function onNext() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var getNewSecretLabel = (0, _utils.hasOrgBoundRole)(userContext) && isEditApplicationRequestWorkflowEnabled ? intl.getI18nMessage('label.application.key.shared.secret.request.new') : intl.getI18nMessage('label.application.key.shared.secret.generate.new');
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      null,
	      notificationMessage && _react2.default.createElement(_components.AlertMessages, {
	        message: notificationMessage,
	        variant: _labels.APPLICATION_SECRET_COPY_CLASS,
	        onClose: function onClose() {
	          setNotificationMessage('');
	        }
	      })
	    ),
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h1', className: classes.pageTitle },
	      'Key'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _components.FormDialog,
	      {
	        dialogId: 'application-generate-secret-dialog',
	        isOpen: isGenerateSecretDialogOpen,
	        title: getNewSecretLabel,
	        submitText: getNewSecretLabel,
	        onSubmit: function onSubmit() {
	          generateSecretPopupSubmit();
	        },
	        cancelText: _labels.CANCEL_TEXT,
	        onCancel: function onCancel() {
	          setIsGenerateSecretDialogOpen(false);
	        }
	      },
	      _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _core.Typography,
	          { component: 'span' },
	          _labels.APPLICATION_APP_KEY_GENERATE_SECRET_DIALOG_SUBTITLE
	        ),
	        _react2.default.createElement('br', null)
	      )
	    ),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 12, item: true },
	        _react2.default.createElement(
	          _core.Grid,
	          { container: true, spacing: 3 },
	          _react2.default.createElement(
	            _core.Grid,
	            { xs: 9, item: true },
	            _react2.default.createElement(_components.FormTextField, {
	              id: 'application-details-api-key',
	              name: intl.getI18nMessage('label.application.key'),
	              value: apiKey,
	              disabled: true
	            })
	          ),
	          _react2.default.createElement(
	            _core.Grid,
	            { xs: 3, item: true },
	            _react2.default.createElement(
	              _core.Button,
	              {
	                className: classes.copyKeyButton,
	                variant: 'outlined',
	                onClick: function onClick() {
	                  (0, _copyToClipboard2.default)(apiKey);
	                  showKeyCopyMessage(apiKey);
	                }
	              },
	              _labels.APPLICATION_APP_KEY_COPY_BUTTON_LABEL
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _core.Grid,
	          { container: true, spacing: 3 },
	          _react2.default.createElement(
	            _core.Grid,
	            { xs: 9, item: true },
	            _react2.default.createElement(_components.FormTextField, Object.assign({
	              id: 'application-details-key-secret',
	              name: intl.getI18nMessage('label.application.key.shared.secret'),
	              value: sharedSecret,
	              disabled: true
	            }, errors.length < 1 && showOneTimePasswordWarning && {
	              helperText: intl.getI18nMessage('label.application.key.shared.secret.hashed.generated.help'),
	              errorHelperText: true
	            }))
	          ),
	          isSecretCopyButtonVisible && _react2.default.createElement(
	            _core.Grid,
	            { xs: 3, item: true },
	            _react2.default.createElement(
	              _core.Button,
	              {
	                className: classes.copyKeyButton,
	                variant: 'outlined',
	                onClick: function onClick() {
	                  (0, _copyToClipboard2.default)(sharedSecret);
	                  showSecretCopyMessage(sharedSecret);
	                }
	              },
	              _labels.APPLICATION_APP_KEY_COPY_BUTTON_LABEL
	            )
	          )
	        ),
	        allowSelectHashing && _react2.default.createElement(
	          _core.Grid,
	          { container: true },
	          _react2.default.createElement(
	            _core.Grid,
	            { item: true, md: 4, xs: 12 },
	            _react2.default.createElement(_components.FormSelect, {
	              value: '0',
	              data: [{ uuid: '0', name: getNewSecretLabel }, { uuid: '1', name: intl.getI18nMessage('label.application.key.shared.secret.plain') }, { uuid: '2', name: intl.getI18nMessage('label.application.key.shared.secret.hashed') }],
	              handleChange: function handleChange(e) {
	                return showGenerateSecretPopup(e.target.value);
	              },
	              noNoneOption: true,
	              warning: true,
	              disabled: isGenerateSecretDisabled
	            })
	          )
	        ),
	        !allowSelectHashing && _react2.default.createElement(
	          _core.Grid,
	          { container: true, spacing: 3 },
	          _react2.default.createElement(
	            _core.Grid,
	            { item: true, md: 4, xs: 12 },
	            _react2.default.createElement(
	              _core.Button,
	              {
	                color: 'primary',
	                variant: 'outlined',
	                className: classes.resetSecretButton,
	                onClick: function onClick(e) {
	                  return showGenerateSecretPopup(e.value);
	                },
	                disabled: isGenerateSecretDisabled
	              },
	              getNewSecretLabel
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      nextText: isSaveApplicationDisabled ? _labels.DONE_TEXT : _labels.SAVE_TEXT,
	      onCancelClick: onCancel,
	      id: 'key-form-buttons'
	    })
	  );
	};
	
	Key.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  userContext: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  applicationDetails: _propTypes2.default.shape({}),
	  applicationStatus: _propTypes2.default.string,
	  applicationUuid: _propTypes2.default.string,
	  generateSecret: _propTypes2.default.func,
	  secret: _propTypes2.default.string,
	  showOneTimePasswordWarning: _propTypes2.default.bool,
	  onCancel: _propTypes2.default.func,
	  appSecretHashingMetadata: _propTypes2.default.shape({}),
	  notifyMessages: _propTypes2.default.func,
	  appKeys: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  setApplicationDetails: _propTypes2.default.func,
	  push: _propTypes2.default.func,
	  onUpdateApplicationSecret: _propTypes2.default.func,
	  isSaveApplicationSecretSuccess: _propTypes2.default.bool,
	  isEditApplicationRequestWorkflowEnabled: _propTypes2.default.bool
	};
	
	exports.default = Key;

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDefaultKeyFieldDisabled = exports.isStatusFieldDisabled = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _copyToClipboard = __webpack_require__(117);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _Warning = __webpack_require__(363);
	
	var _Warning2 = _interopRequireDefault(_Warning);
	
	var _Info = __webpack_require__(362);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _components = __webpack_require__(17);
	
	var _styles = __webpack_require__(1605);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _utils = __webpack_require__(18);
	
	var _intl = __webpack_require__(15);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var keyStatusOptions = [{
	  key: _constants.API_KEY_STATUS_ENABLED,
	  label: (0, _intl.getI18nFormattedMessage)('label.application.key.state.enabled')
	}, {
	  key: _constants.API_KEY_STATUS_DISABLED,
	  label: (0, _intl.getI18nFormattedMessage)('label.application.key.state.disabled')
	}];
	
	var isStatusFieldDisabled = exports.isStatusFieldDisabled = function isStatusFieldDisabled(_ref) {
	  var isDefault = _ref.isDefault,
	      keyIsDefault = _ref.keyIsDefault;
	  return isDefault || keyIsDefault;
	};
	
	var isDefaultKeyFieldDisabled = exports.isDefaultKeyFieldDisabled = function isDefaultKeyFieldDisabled(_ref2) {
	  var editable = _ref2.editable,
	      isDefault = _ref2.isDefault,
	      status = _ref2.status,
	      keyStatus = _ref2.keyStatus;
	  return (0, _lodash.some)([!editable, isDefault, status === _constants.API_KEY_STATUS_DISABLED, // Status persisted is Disabled
	  keyStatus === _constants.API_KEY_STATUS_DISABLED] // Status on the form is Disabled
	  );
	};
	
	var Key = function Key(props) {
	  var idx = props.idx,
	      _props$editable = props.editable,
	      editable = _props$editable === undefined ? true : _props$editable,
	      applicationUuid = props.applicationUuid,
	      _props$details = props.details,
	      _props$details$name = _props$details.name,
	      name = _props$details$name === undefined ? '' : _props$details$name,
	      _props$details$status = _props$details.status,
	      status = _props$details$status === undefined ? '' : _props$details$status,
	      _props$details$isDefa = _props$details.isDefault,
	      isDefault = _props$details$isDefa === undefined ? false : _props$details$isDefa,
	      _props$details$callba = _props$details.callbackUrl,
	      callbackUrl = _props$details$callba === undefined ? '' : _props$details$callba,
	      _props$details$scope = _props$details.scope,
	      scope = _props$details$scope === undefined ? '' : _props$details$scope,
	      _props$details$type = _props$details.type,
	      type = _props$details$type === undefined ? null : _props$details$type,
	      _props$details$client = _props$details.clientId,
	      clientId = _props$details$client === undefined ? '' : _props$details$client,
	      _props$details$client2 = _props$details.clientSecret,
	      clientSecret = _props$details$client2 === undefined ? '' : _props$details$client2,
	      _props$details$isHash = _props$details.isHashed,
	      isHashed = _props$details$isHash === undefined ? '' : _props$details$isHash,
	      _props$details$isRege = _props$details.isRegenerateSecret,
	      isRegenerateSecret = _props$details$isRege === undefined ? false : _props$details$isRege,
	      isCreatedKey = _props$details.isCreatedKey,
	      isUniqueKey = props.isUniqueKey,
	      notifyMessages = props.notifyMessages,
	      appSecretHashingMetadata = props.appSecretHashingMetadata,
	      closeAction = props.closeAction,
	      classes = props.classes;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(name),
	      _useState2 = _slicedToArray(_useState, 2),
	      keyName = _useState2[0],
	      setKeyName = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(status),
	      _useState4 = _slicedToArray(_useState3, 2),
	      keyStatus = _useState4[0],
	      setKeyStatus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(isDefault),
	      _useState6 = _slicedToArray(_useState5, 2),
	      keyIsDefault = _useState6[0],
	      setKeyIsDefault = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(callbackUrl),
	      _useState8 = _slicedToArray(_useState7, 2),
	      keyOAuthCallbackUrl = _useState8[0],
	      setKeyOAuthCallbackUrl = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(scope),
	      _useState10 = _slicedToArray(_useState9, 2),
	      keyOAuthScope = _useState10[0],
	      setKeyOAuthScope = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(type),
	      _useState12 = _slicedToArray(_useState11, 2),
	      keyOAuthType = _useState12[0],
	      setKeyOAuthType = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(clientSecret),
	      _useState14 = _slicedToArray(_useState13, 2),
	      keyClientSecret = _useState14[0],
	      setKeyClientSecret = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(isHashed),
	      _useState16 = _slicedToArray(_useState15, 2),
	      keyIsHashed = _useState16[0],
	      setKeyIsHashed = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({}),
	      _useState18 = _slicedToArray(_useState17, 2),
	      keyErrors = _useState18[0],
	      setKeyErrors = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(isRegenerateSecret),
	      _useState20 = _slicedToArray(_useState19, 2),
	      keyRegenerateSecret = _useState20[0],
	      setRegenerateSecret = _useState20[1];
	
	  var isSecretCopyButtonVisible = keyClientSecret !== _constants.APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB;
	
	  (0, _react.useEffect)(function () {
	    setKeyName(name);
	  }, [name]);
	  (0, _react.useEffect)(function () {
	    setKeyStatus(status);
	  }, [status]);
	  (0, _react.useEffect)(function () {
	    setKeyIsDefault(isDefault);
	  }, [isDefault]);
	  (0, _react.useEffect)(function () {
	    setKeyOAuthCallbackUrl(callbackUrl);
	  }, [callbackUrl]);
	  (0, _react.useEffect)(function () {
	    setKeyOAuthScope(scope);
	  }, [scope]);
	  (0, _react.useEffect)(function () {
	    setKeyOAuthType(type);
	  }, [type]);
	  (0, _react.useEffect)(function () {
	    setKeyClientSecret(clientSecret);
	  }, [clientSecret]);
	  (0, _react.useEffect)(function () {
	    setKeyIsHashed(isHashed);
	  }, [isHashed]);
	  (0, _react.useEffect)(function () {
	    setRegenerateSecret(isRegenerateSecret);
	  }, [isRegenerateSecret]);
	
	  (0, _react.useEffect)(function () {
	    setKeyErrors(Object.assign({}, keyErrors, {
	      name: isUniqueKey === false
	    }));
	  }, [isUniqueKey]);
	
	  (0, _react.useEffect)(function () {
	    if (keyName === name && keyIsDefault === isDefault && keyOAuthCallbackUrl === callbackUrl && keyOAuthScope === scope && keyOAuthType === type && !keyRegenerateSecret) {
	      props.setHasUnsavedChanges(false);
	    } else {
	      props.setHasUnsavedChanges(true);
	    }
	  }, [keyName, keyIsDefault, keyOAuthCallbackUrl, keyOAuthScope, keyOAuthType, keyClientSecret, keyRegenerateSecret]);
	
	  var generateSecret = function generateSecret() {
	    var newSecret = (0, _utils.uuidv4)();
	    setKeyClientSecret(newSecret.replace(/-/g, ''));
	    setRegenerateSecret(true);
	  };
	
	  var checkErrors = function checkErrors(obj) {
	    return Object.keys(obj).filter(function (key) {
	      return obj[key];
	    }).length > 0;
	  };
	
	  var saveKey = function saveKey() {
	    var hasErrors = checkErrors(keyErrors);
	    var errors = Object.assign({}, keyErrors);
	
	    if (keyName === '') {
	      errors = Object.assign({}, errors, { name: true });
	      hasErrors = true;
	    } else if (keyName.length > 255) {
	      errors = Object.assign({}, errors, { name: true });
	      hasErrors = true;
	    }
	
	    if (hasErrors) {
	      setKeyErrors(errors);
	    } else {
	      var keyData = {
	        appUuid: applicationUuid,
	        name: keyName,
	        defaultKey: keyIsDefault,
	        oauthCallbackUrl: keyOAuthCallbackUrl,
	        oauthScope: keyOAuthScope,
	        oauthType: keyOAuthType,
	        keySecretHashed: keyIsHashed === 'HASHED_SECRET'
	      };
	
	      if (clientId) {
	        var data = Object.assign({}, keyData, {
	          status: keyStatus,
	          apiKey: clientId
	        });
	
	        if (keyRegenerateSecret) {
	          data = Object.assign({}, data, {
	            keySecret: keyClientSecret
	          });
	        }
	        setRegenerateSecret(false);
	        props.updateKey(data);
	      } else {
	        var _data = Object.assign({}, keyData);
	        props.createKey(_data);
	      }
	    }
	  };
	
	  var _handleChange = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(fieldName, fieldValue) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.t0 = fieldName;
	              _context.next = _context.t0 === 'name' ? 3 : _context.t0 === 'status' ? 8 : _context.t0 === 'callbackUrl' ? 10 : _context.t0 === 'scope' ? 12 : _context.t0 === 'type' ? 14 : _context.t0 === 'isDefault' ? 16 : _context.t0 === 'isHashed' ? 18 : 21;
	              break;
	
	            case 3:
	              setKeyName(fieldValue);
	              setKeyErrors(Object.assign({}, keyErrors, { name: (0, _utils.hasError)(fieldValue, true) }));
	              _context.next = 7;
	              return props.fetchKeyNameUnique(fieldValue, clientId, applicationUuid);
	
	            case 7:
	              return _context.abrupt('break', 21);
	
	            case 8:
	              setKeyStatus(fieldValue);
	              return _context.abrupt('break', 21);
	
	            case 10:
	              setKeyOAuthCallbackUrl(fieldValue);
	              return _context.abrupt('break', 21);
	
	            case 12:
	              setKeyOAuthScope(fieldValue);
	              return _context.abrupt('break', 21);
	
	            case 14:
	              setKeyOAuthType(fieldValue);
	              return _context.abrupt('break', 21);
	
	            case 16:
	              setKeyIsDefault(fieldValue);
	              return _context.abrupt('break', 21);
	
	            case 18:
	              setKeyIsHashed(fieldValue);
	              setKeyErrors(Object.assign({}, keyErrors, { isHashed: (0, _utils.hasError)(fieldValue, true) }));
	              return _context.abrupt('break', 21);
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function _handleChange(_x, _x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var displayHashingOptions = (0, _lodash.get)(appSecretHashingMetadata, 'plaintextAllowed');
	  var secretOptions = [{
	    id: 0,
	    key: 'HASHED_SECRET',
	    name: 'Hashed'
	  }, {
	    id: 1,
	    key: 'PLAIN_SECRET',
	    name: 'Plaintext'
	  }];
	
	  (0, _react.useEffect)(function () {
	    if (!displayHashingOptions) {
	      if ((0, _lodash.get)(appSecretHashingMetadata, 'algorithm') && !(0, _lodash.get)(appSecretHashingMetadata, 'plaintextAllowed')) {
	        setKeyIsHashed('HASHED_SECRET');
	      } else {
	        setKeyIsHashed('PLAIN_SECRET');
	      }
	    } else {
	      setKeyIsHashed('HASHED_SECRET');
	    }
	  }, [appSecretHashingMetadata]);
	
	  var showCopied = function showCopied(value, valueType) {
	    var strType = '';
	    if (valueType === 'API_KEY') {
	      strType = 'API Key';
	    } else if (valueType === 'SECRET') {
	      strType = 'Secret';
	    }
	    notifyMessages(strType + ': ' + value + ' was copied to the clipboard.', _constants.ALERT_SUCCESS);
	    setTimeout(function () {
	      notifyMessages('', '');
	    }, 3000);
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_components.FormTextField, {
	      id: 'key-name-' + idx,
	      name: intl.getI18nMessage('label.application.key.name'),
	      value: keyName,
	      helperText: intl.getI18nMessage('label.application.key.name.help'),
	      handleChange: function handleChange(value) {
	        _handleChange('name', value);
	      },
	      error: keyErrors.name || isUniqueKey === false,
	      maxLength: '255',
	      disabled: !editable
	    }),
	    _react2.default.createElement(_core.FormControlLabel, {
	      classes: {
	        root: classes.defaultCheckboxContainer
	      },
	      control: _react2.default.createElement(_core.Checkbox, {
	        classes: { root: classes.iconRoot },
	        defaultChecked: isDefault,
	        disabled: isDefaultKeyFieldDisabled({ editable: editable, isDefault: isDefault, status: status, keyStatus: keyStatus }),
	        size: 'small',
	        checked: keyIsDefault,
	        onChange: function onChange(event) {
	          _handleChange('isDefault', event.target.checked);
	        }
	      }),
	      label: intl.getI18nMessage('label.application.key.default')
	    }),
	    _react2.default.createElement(
	      _core.FormHelperText,
	      { classes: { root: classes.checkboxHelpText } },
	      intl.getI18nMessage('label.application.key.default.help')
	    ),
	    isDefault !== keyIsDefault && _react2.default.createElement(
	      _core.FormHelperText,
	      { classes: { root: classes.defaultKeyWarningText } },
	      'Devs will be able to edit this key'
	    ),
	    !editable ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.Typography,
	        { classes: { root: classes.sectionTitle }, gutterBottom: true },
	        'Disabled'
	      ),
	      _react2.default.createElement(
	        _core.FormHelperText,
	        { classes: { root: classes.helperText } },
	        'This key is disabled because the application is pending approval or disabled.'
	      )
	    ) : _react2.default.createElement(
	      _core.FormControl,
	      { component: 'fieldset', className: classes.statusField },
	      _react2.default.createElement(
	        _core.FormLabel,
	        { component: 'legend', focused: false },
	        'Status'
	      ),
	      _react2.default.createElement(
	        _core.RadioGroup,
	        {
	          value: keyStatus,
	          onChange: function onChange(e) {
	            return setKeyStatus(e.target.value);
	          }
	        },
	        keyStatusOptions.map(function (item) {
	          return _react2.default.createElement(
	            _react.Fragment,
	            { key: item.key },
	            _react2.default.createElement(_core.FormControlLabel, {
	              control: _react2.default.createElement(_core.Radio, {
	                classes: { root: classes.iconRoot },
	                disabled: isStatusFieldDisabled({ isDefault: isDefault, keyIsDefault: keyIsDefault })
	              }),
	              key: item.key,
	              label: item.label,
	              value: item.key
	            })
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _core.Typography,
	      { classes: { root: classes.sectionTitle }, gutterBottom: true },
	      'OAuth'
	    ),
	    _react2.default.createElement(_components.FormTextField, {
	      id: 'oauth-callback-url-key-' + idx,
	      name: intl.getI18nMessage('label.application.key.oauth.callback.url'),
	      value: keyOAuthCallbackUrl,
	      helperText: intl.getI18nMessage('label.application.key.oauth.callback.url.help'),
	      multiline: true,
	      rows: 1,
	      optional: true,
	      maxLength: '2048',
	      handleChange: function handleChange(value) {
	        _handleChange('callbackUrl', value);
	      },
	      disabled: !editable
	    }),
	    _react2.default.createElement(_components.FormTextField, {
	      id: 'oauth-scope-key-' + idx,
	      name: intl.getI18nMessage('label.application.key.oauth.scope'),
	      value: keyOAuthScope,
	      helperText: intl.getI18nMessage('label.application.key.oauth.scope.help'),
	      multiline: true,
	      rows: 1,
	      optional: true,
	      maxLength: '4000',
	      handleChange: function handleChange(value) {
	        _handleChange('scope', value);
	      },
	      disabled: !editable
	    }),
	    _react2.default.createElement(_components.FormButtonGroup, {
	      id: 'oauth-type-key-' + idx,
	      name: 'Type',
	      value: keyOAuthType,
	      data: [{ uuid: null, name: 'None' }, { uuid: 'PUBLIC', name: 'Public' }, { uuid: 'CONFIDENTIAL', name: 'Confidential' }],
	      handleChange: function handleChange(value) {
	        _handleChange('type', value || null);
	      },
	      disabled: !editable
	    }),
	    _react2.default.createElement(
	      _core.Typography,
	      { classes: { root: classes.sectionTitle }, gutterBottom: true },
	      'Client ID & Secret'
	    ),
	    clientId ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.Grid,
	        { container: true, className: classes.gridContainer },
	        _react2.default.createElement(
	          _core.Grid,
	          { md: 12, item: true },
	          _react2.default.createElement(
	            _core.Grid,
	            { container: true },
	            _react2.default.createElement(
	              _core.Grid,
	              { xs: 9, item: true },
	              _react2.default.createElement(_components.FormTextField, {
	                id: 'client-id-key-' + idx,
	                name: intl.getI18nMessage('label.application.key'),
	                value: clientId,
	                disabled: true
	              })
	            ),
	            _react2.default.createElement(
	              _core.Grid,
	              { xs: 3, item: true },
	              _react2.default.createElement(
	                _core.Button,
	                {
	                  variant: 'outlined',
	                  onClick: function onClick() {
	                    (0, _copyToClipboard2.default)(clientId);
	                    showCopied(clientId, 'API_KEY');
	                  },
	                  className: classes.copyButton
	                },
	                'Copy'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _core.Grid,
	            { container: true },
	            _react2.default.createElement(
	              _core.Grid,
	              { xs: 9, item: true },
	              _react2.default.createElement(_components.FormTextField, Object.assign({
	                id: 'client-secret-key-' + idx,
	                name: intl.getI18nMessage('label.application.key.shared.secret'),
	                value: keyClientSecret,
	                disabled: true
	              }, isSecretCopyButtonVisible && isCreatedKey && isHashed && {
	                helperText: intl.getI18nMessage('label.application.key.shared.secret.hashed.generated.help'),
	                errorHelperText: true
	              }))
	            ),
	            isSecretCopyButtonVisible && (isHashed === false || keyRegenerateSecret || isCreatedKey) && _react2.default.createElement(
	              _core.Grid,
	              { xs: 3, item: true },
	              _react2.default.createElement(
	                _core.Button,
	                {
	                  variant: 'outlined',
	                  onClick: function onClick() {
	                    (0, _copyToClipboard2.default)(keyClientSecret);
	                    showCopied(keyClientSecret, 'SECRET');
	                  },
	                  className: classes.copyButton
	                },
	                'Copy'
	              )
	            )
	          ),
	          !keyRegenerateSecret ? _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              _core.Grid,
	              { container: true },
	              _react2.default.createElement(
	                _core.Grid,
	                { xs: 9, item: true },
	                _react2.default.createElement(
	                  _core.Button,
	                  {
	                    color: 'primary',
	                    variant: 'outlined',
	                    className: classes.generateSecretButton,
	                    id: 'btn-key-generate-secret-' + idx,
	                    onClick: function onClick() {
	                      return generateSecret();
	                    },
	                    disabled: !editable
	                  },
	                  'Generate New Secret'
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: classes.secretOptionsContainer },
	            _react2.default.createElement(
	              _core.FormHelperText,
	              { classes: { root: classes.helperText } },
	              _react2.default.createElement(_Info2.default, { className: classes.helpIcon }),
	              ' ',
	              (0, _intl.getI18nFormattedMessage)('label.application.key.shared.secret.generated.info.1')
	            ),
	            _react2.default.createElement(
	              _core.FormHelperText,
	              { classes: { root: classes.helperText } },
	              _react2.default.createElement(_Warning2.default, { className: classes.warningIcon }),
	              ' ',
	              (0, _intl.getI18nFormattedMessage)('label.application.key.shared.secret.generated.info.2')
	            ),
	            _react2.default.createElement('br', null),
	            displayHashingOptions && _react2.default.createElement(
	              _react.Fragment,
	              null,
	              _react2.default.createElement(
	                _core.Typography,
	                { classes: { root: classes.sectionTitle }, gutterBottom: true },
	                'Secret Type'
	              ),
	              _react2.default.createElement(
	                _core.RadioGroup,
	                {
	                  value: keyIsHashed,
	                  onChange: function onChange(e) {
	                    return _handleChange('isHashed', e.target.value);
	                  },
	                  defaultValue: 'HASHED_SECRET'
	                },
	                secretOptions.map(function (item) {
	                  return _react2.default.createElement(_core.FormControlLabel, {
	                    control: _react2.default.createElement(_core.Radio, null),
	                    key: item.key,
	                    label: item.name,
	                    value: item.key
	                  });
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('br', null)
	    ) : _react2.default.createElement(
	      'div',
	      { className: classes.secretOptionsContainer },
	      _react2.default.createElement(
	        _core.FormHelperText,
	        { classes: { root: classes.helperText } },
	        'The Client ID & Secret will be generated on save'
	      ),
	      displayHashingOptions && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _core.Typography,
	          { classes: { root: classes.sectionTitle }, gutterBottom: true },
	          'Secret Type'
	        ),
	        _react2.default.createElement(
	          _core.RadioGroup,
	          {
	            value: keyIsHashed,
	            onChange: function onChange(e) {
	              return _handleChange('isHashed', e.target.value);
	            },
	            defaultValue: 'HASHED_SECRET'
	          },
	          secretOptions.map(function (item) {
	            return _react2.default.createElement(_core.FormControlLabel, {
	              control: _react2.default.createElement(_core.Radio, null),
	              key: item.key,
	              label: item.name,
	              value: item.key
	            });
	          })
	        )
	      ),
	      _react2.default.createElement('br', null)
	    ),
	    _react2.default.createElement(
	      _core.Button,
	      {
	        id: 'btn-key-save-' + idx,
	        className: classes.saveButton,
	        color: 'secondary',
	        variant: 'contained',
	        onClick: saveKey,
	        disabled: !editable
	      },
	      'Save Key'
	    ),
	    _react2.default.createElement(
	      _core.Button,
	      {
	        id: 'btn-key-save-' + idx,
	        color: 'primary',
	        variant: 'outlined',
	        onClick: function onClick() {
	          return closeAction();
	        },
	        className: classes.closeButton
	      },
	      'Close'
	    )
	  );
	};
	
	Key.propTypes = {
	  idx: _propTypes2.default.number,
	  applicationUuid: _propTypes2.default.string,
	  editable: _propTypes2.default.bool,
	  details: _propTypes2.default.shape({}),
	  isUniqueKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  notifyMessages: _propTypes2.default.func,
	  appSecretHashingMetadata: _propTypes2.default.shape({}),
	  closeAction: _propTypes2.default.func,
	  classes: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(Key);

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    keyNameContainer: {
	      marginTop: 20,
	      marginBottom: 40
	    },
	    inputFieldContainer: {
	      display: 'block'
	    },
	    inputField: {
	      '& input': {
	        margin: 0,
	        padding: 10,
	        border: '1px solid ' + (0, _lodash.get)(color, 'borderColor'),
	        borderRadius: 3
	      }
	    },
	    notchedOutline: {
	      outline: 0,
	      border: 0
	    },
	    inputHelpText: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      margin: 1,
	      marginTop: 8,
	      marginBottom: 10
	    },
	    statusField: {
	      '& legend': {
	        color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontWeight: 'bold'
	      },
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      marginBottom: 10
	    },
	    helperText: {
	      color: (0, _lodash.get)(color, 'smallText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'smallText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important'
	    },
	    helpIcon: {
	      fontSize: 16,
	      marginLeft: 10,
	      verticalAlign: 'middle'
	    },
	    warningIcon: {
	      fontSize: 16,
	      marginLeft: 10,
	      verticalAlign: 'middle'
	    },
	    sectionTitle: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontWeight: 'bold'
	    },
	    defaultCheckboxContainer: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      fontWeight: 'bold',
	      marginTop: -20
	    },
	    checkboxHelpText: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      marginBottom: 20,
	      marginTop: -10
	    },
	    defaultKeyWarningText: {
	      marginTop: -20,
	      marginBottom: 20,
	      fontFamily: (0, _lodash.get)(typography, 'smallText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      color: (0, _lodash.get)(color, 'warning')
	    },
	    secretTypeErrorText: {
	      marginTop: -5,
	      marginBottom: 5,
	      color: (0, _lodash.get)(color, 'error')
	    },
	    generateSecretButton: {
	      border: '1px solid ' + (0, _lodash.get)(color, 'borderColor'),
	      color: (0, _lodash.get)(color, 'red'),
	      '&:hover': {
	        color: (0, _lodash.get)(color, 'red')
	      }
	    },
	    secretOptionsContainer: {
	      color: (0, _lodash.get)(color, 'bodyText')
	    },
	    copyButton: {
	      color: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      marginTop: 51,
	      width: '70%'
	    },
	    saveButton: {
	      marginBottom: 10
	    },
	    closeButton: {
	      marginBottom: 10,
	      marginLeft: 10
	    },
	    iconRoot: {
	      '& svg': {
	        width: 16,
	        height: 16
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _lodash = __webpack_require__(8);
	
	var _changeCase = __webpack_require__(116);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _Collapse = __webpack_require__(70);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _KeyboardArrowDown = __webpack_require__(170);
	
	var _KeyboardArrowDown2 = _interopRequireDefault(_KeyboardArrowDown);
	
	var _KeyboardArrowUp = __webpack_require__(171);
	
	var _KeyboardArrowUp2 = _interopRequireDefault(_KeyboardArrowUp);
	
	var _Close = __webpack_require__(141);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _constants = __webpack_require__(14);
	
	var _components = __webpack_require__(17);
	
	var _Key = __webpack_require__(1604);
	
	var _Key2 = _interopRequireDefault(_Key);
	
	var _styles = __webpack_require__(1607);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var GRID_ROWS_PER_PAGE_OPTIONS = [10, 20];
	var GRID_ROWS_PER_PAGE_DEFAULT_OPTION = 10;
	
	var blankKeyObject = {
	  isNew: true,
	  applicationUuid: '',
	  name: '',
	  apiKey: '',
	  keySecret: '',
	  defaultKey: false,
	  oauthCallbackUrl: null,
	  oauthScope: null,
	  oauthType: null,
	  status: 'ENABLED',
	  keySecretHashed: false,
	  disabledByType: null
	};
	
	var processErrors = function processErrors(arrErrors, defaultMessage) {
	  var errorMessage = defaultMessage;
	  if (arrErrors.length > 0) {
	    errorMessage = (0, _lodash.map)(arrErrors, function (validationError) {
	      return validationError.error;
	    }).join('\n');
	  }
	  return errorMessage;
	};
	
	var KeyManagement = function KeyManagement(props) {
	  var applicationUuid = props.applicationUuid,
	      applicationDetails = props.applicationDetails,
	      appKeys = props.appKeys,
	      appKeysTotalPages = props.appKeysTotalPages,
	      appKeysTotalElements = props.appKeysTotalElements,
	      fetchKeyNameUnique = props.fetchKeyNameUnique,
	      isUniqueKey = props.isUniqueKey,
	      _createKey = props.createKey,
	      createKeyStatus = props.createKeyStatus,
	      updateKey = props.updateKey,
	      updateKeyStatus = props.updateKeyStatus,
	      deleteKey = props.deleteKey,
	      deleteKeyStatus = props.deleteKeyStatus,
	      isSaveApplicationSuccess = props.isSaveApplicationSuccess,
	      appSecretHashingMetadata = props.appSecretHashingMetadata,
	      _props$userContext = props.userContext,
	      userContext = _props$userContext === undefined ? {} : _props$userContext,
	      _props$errors = props.errors,
	      errors = _props$errors === undefined ? [] : _props$errors,
	      classes = props.classes,
	      resetApp = props.resetApp,
	      createdKey = props.createdKey,
	      notifyMessages = props.notifyMessages;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDialogOpen = _useState2[0],
	      setIsDialogOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(appKeys),
	      _useState4 = _slicedToArray(_useState3, 2),
	      keys = _useState4[0],
	      setKeys = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(-1),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activeIndex = _useState6[0],
	      setActiveIndex = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      lastCreatedKey = _useState8[0],
	      setLastCreatedKey = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      hasUnsavedChanges = _useState10[0],
	      setHasUnsavedChanges = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      showDeleteDialog = _useState12[0],
	      setShowDeleteDialog = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      showLoadingDialog = _useState14[0],
	      setShowLoadingDialog = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      page = _useState16[0],
	      setPage = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState18 = _slicedToArray(_useState17, 2),
	      rowsPerPage = _useState18[0],
	      setRowsPerPage = _useState18[1];
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    props.fetchApplicationKeys(applicationUuid, newPage, rowsPerPage);
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    props.fetchApplicationKeys(applicationUuid, 0, newRowsPerPage);
	  };
	
	  var openDeleteDialog = function openDeleteDialog(e) {
	    e.stopPropagation();
	    setShowDeleteDialog(true);
	  };
	  var closeDeleteDialog = function closeDeleteDialog() {
	    return setShowDeleteDialog(false);
	  };
	
	  var openLoadingDialog = function openLoadingDialog() {
	    return setShowLoadingDialog(true);
	  };
	  var closeLoadingDialog = function closeLoadingDialog() {
	    return setShowLoadingDialog(false);
	  };
	
	  var onDeleteKey = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var key;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              key = keys[activeIndex];
	
	              closeDeleteDialog();
	              openLoadingDialog();
	              _context.next = 5;
	              return deleteKey(Object.assign({}, key, { appUuid: applicationUuid }));
	
	            case 5:
	              closeLoadingDialog();
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function onDeleteKey() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var onRowClick = function onRowClick(idx) {
	    var isNew = (0, _lodash.get)(keys[idx], 'isNew');
	    if (hasUnsavedChanges) {
	      setIsDialogOpen(true);
	    } else if (activeIndex === idx && !isNew) {
	      setActiveIndex(-1);
	    } else {
	      setActiveIndex(idx);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (isSaveApplicationSuccess) {
	      setHasUnsavedChanges(false);
	      notifyMessages(intl.getI18nMessage('label.application.update.success'), _constants.ALERT_SUCCESS);
	    }
	    if (createKeyStatus === 'SUCCESS') {
	      setHasUnsavedChanges(false);
	      notifyMessages(intl.getI18nMessage('label.application.key.create.success'), _constants.ALERT_SUCCESS);
	      props.fetchApplicationKeys(applicationUuid);
	    }
	    if (updateKeyStatus === 'SUCCESS') {
	      setHasUnsavedChanges(false);
	      notifyMessages(intl.getI18nMessage('label.application.key.update.success'), _constants.ALERT_SUCCESS);
	    }
	    if (deleteKeyStatus === 'SUCCESS') {
	      setHasUnsavedChanges(false);
	      notifyMessages(intl.getI18nMessage('label.application.key.delete.success'), _constants.ALERT_SUCCESS);
	      setActiveIndex(-1);
	    }
	    if (createKeyStatus === 'FAIL' || updateKeyStatus === 'FAIL' || deleteKeyStatus === 'FAIL') {
	      notifyMessages(processErrors(errors, 'Save error. Check form for details.'), 'error');
	    }
	  }, [createKeyStatus, updateKeyStatus, deleteKeyStatus, isSaveApplicationSuccess]);
	
	  (0, _react.useEffect)(function () {
	    setKeys(appKeys);
	    if (lastCreatedKey) {
	      setActiveIndex(appKeys.findIndex(function (appKey) {
	        return appKey.name === lastCreatedKey.name;
	      }));
	    }
	  }, [appKeys.length]);
	
	  (0, _react.useEffect)(function () {
	    var newKey = keys.find(function (key) {
	      return (0, _lodash.get)(key, 'isNew');
	    });
	    if (!newKey && (0, _lodash.isNull)(createdKey)) {
	      setKeys(appKeys);
	    }
	  }, [appKeys[activeIndex]]);
	
	  (0, _react.useEffect)(function () {
	    var newKey = keys.find(function (key) {
	      return (0, _lodash.get)(key, 'isNew');
	    });
	    if (newKey) {
	      setPage(0);
	      setActiveIndex(0);
	    }
	  }, [keys.length]);
	
	  var addNewKey = function addNewKey() {
	    var newKey = keys.find(function (key) {
	      return (0, _lodash.get)(key, 'isNew');
	    });
	    if (!newKey) {
	      var arr = [].concat(keys);
	      arr.unshift(blankKeyObject);
	      setKeys(arr);
	    }
	    resetApp();
	  };
	
	  var removeNewKey = function removeNewKey() {
	    var newKey = keys.find(function (key) {
	      return (0, _lodash.get)(key, 'isNew');
	    });
	    if (newKey) {
	      var arr = [].concat(keys);
	      arr.shift();
	      setKeys(arr);
	      setActiveIndex(-1);
	    }
	  };
	
	  var onNext = function onNext() {
	    setTimeout(function () {
	      window.location.href = '/publish/applications/details/' + applicationUuid;
	    }, 1000);
	  };
	
	  var onDialogSubmit = function onDialogSubmit() {
	    setActiveIndex(-1);
	    setHasUnsavedChanges(false);
	    setIsDialogOpen(false);
	  };
	
	  var onDialogClose = function onDialogClose() {
	    setIsDialogOpen(false);
	  };
	
	  var isDisabledApp = (0, _lodash.get)(applicationDetails, 'status') === _constants.APPLICATION_STATUS_DISABLED;
	  var getIsEditable = function getIsEditable(key) {
	    // Edit Pending Approval Application
	    if ((0, _utils.hasPublisherRole)(userContext) && (0, _lodash.get)(applicationDetails, 'status') === _constants.APPLICATION_STATUS_EDIT_PENDING_APPROVAL && (0, _lodash.get)(key, 'defaultKey')) {
	      return false;
	    }
	    // Disabled Application
	    if (isDisabledApp) {
	      return false;
	    }
	    return true;
	  };
	
	  var isNonDefaultKey = !(0, _lodash.get)(keys[activeIndex], 'defaultKey');
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_components.AlertDialog, {
	      id: 'gateway-bundle-details-delete-dialog',
	      isOpen: showDeleteDialog,
	      title: intl.getI18nMessage('label.delete.confirmation.title'),
	      description: intl.getI18nMessage('label.api.key.delete.confirmation.text'),
	      submitText: intl.getI18nMessage('label.api.key.delete.button'),
	      cancelText: intl.getI18nMessage('label.cancel.button'),
	      onClose: closeDeleteDialog,
	      onSubmit: onDeleteKey,
	      onCancel: closeDeleteDialog,
	      submitButtonClass: classes.submitButton
	    }),
	    _react2.default.createElement(_components.AlertDialog, {
	      isOpen: isDialogOpen,
	      title: _constants.UNSAVED_DIALOG_TITLE,
	      description: _constants.UNSAVED_DIALOG_DESCRIPTIONS,
	      submitText: _constants.UNSAVED_DIALOG_SUBMIT_TEXT,
	      cancelText: _constants.UNSAVED_DIALOG_CANCEL_TEXT,
	      onClose: onDialogClose,
	      onSubmit: onDialogSubmit,
	      onCancel: onDialogClose,
	      dialogId: 'application-unsaved-dialog'
	    }),
	    _react2.default.createElement(_components.LoadingDialog, {
	      isOpen: showLoadingDialog,
	      title: intl.getI18nMessage('label.api.key.delete.loading.title'),
	      description: intl.getI18nMessage('label.api.key.delete.loading.text'),
	      dialogId: 'deleting-key-dialog'
	    }),
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'h1', className: classes.pageTitle },
	      'Authentication & Keys'
	    ),
	    _react2.default.createElement(
	      _core.Button,
	      {
	        variant: 'contained',
	        color: 'secondary',
	        className: classes.addButton,
	        onClick: function onClick() {
	          return addNewKey();
	        },
	        disabled: isDisabledApp || hasUnsavedChanges
	      },
	      'Add Key'
	    ),
	    errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, spacing: 3, className: classes.gridContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { md: 12, item: true },
	        _react2.default.createElement(
	          'div',
	          { className: classes.keysContainer },
	          _react2.default.createElement(
	            _core.TableContainer,
	            { className: classes.tableContainer, component: _core.Paper },
	            _react2.default.createElement(
	              _core.Table,
	              { 'aria-label': 'collapsible table' },
	              _react2.default.createElement(
	                _core.TableHead,
	                { className: classes.tableHead },
	                _react2.default.createElement(
	                  _core.TableRow,
	                  null,
	                  _react2.default.createElement(
	                    _core.TableCell,
	                    null,
	                    'Key Name'
	                  ),
	                  _react2.default.createElement(
	                    _core.TableCell,
	                    { align: 'center' },
	                    'Status'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _core.TableBody,
	                null,
	                keys.map(function (row, idx) {
	                  var isNew = (0, _lodash.get)(row, 'isNew');
	                  var isOpen = activeIndex === idx;
	                  var isDisabledRow = hasUnsavedChanges && activeIndex !== idx;
	                  var rowClass = '';
	                  if (isOpen) {
	                    rowClass = classes.openRow;
	                  }
	                  if (isDisabledRow) {
	                    rowClass = classes.isDisabledRow;
	                  }
	                  return _react2.default.createElement(
	                    _react.Fragment,
	                    { key: row.name },
	                    _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        className: rowClass,
	                        onClick: function onClick() {
	                          return onRowClick(idx);
	                        }
	                      },
	                      !isOpen && _react2.default.createElement(
	                        _react.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { component: 'th', scope: 'row' },
	                          _react2.default.createElement(
	                            _IconButton2.default,
	                            {
	                              className: classes.expandCollapseButton,
	                              size: 'small',
	                              onClick: function onClick() {
	                                return onRowClick(idx);
	                              }
	                            },
	                            _react2.default.createElement(_KeyboardArrowDown2.default, null)
	                          ),
	                          (0, _lodash.get)(row, 'isNew') ? '[NEW KEY]' : row.name,
	                          (0, _lodash.get)(row, 'defaultKey') && _react2.default.createElement(_core.Chip, {
	                            className: classes.defaultChip,
	                            size: 'small',
	                            label: 'Default'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { component: 'th', scope: 'row', align: 'center' },
	                          !(0, _lodash.get)(row, 'isNew') && _react2.default.createElement(_core.Chip, {
	                            className: (0, _lodash.get)(row, 'status') === 'ENABLED' ? classes.enabledChip : classes.disabledChip,
	                            size: 'small',
	                            label: (0, _changeCase.sentenceCase)((0, _lodash.get)(row, 'status'))
	                          })
	                        )
	                      ),
	                      isOpen && _react2.default.createElement(
	                        _react.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: classes.openRowTitle, component: 'th', scope: 'row' },
	                          _react2.default.createElement(
	                            _IconButton2.default,
	                            {
	                              className: classes.expandCollapseButton,
	                              size: 'small',
	                              onClick: function onClick() {
	                                return onRowClick(idx);
	                              }
	                            },
	                            _react2.default.createElement(_KeyboardArrowUp2.default, null)
	                          ),
	                          isNew && _react2.default.createElement(
	                            _IconButton2.default,
	                            { size: 'small', onClick: function onClick() {
	                                return removeNewKey();
	                              } },
	                            _react2.default.createElement(_Close2.default, null)
	                          ),
	                          isNew ? 'Add Key' : 'Key Details'
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { component: 'th', scope: 'row', align: 'center' },
	                          isNonDefaultKey && _react2.default.createElement(
	                            _core.Button,
	                            {
	                              color: 'primary',
	                              variant: 'outlined',
	                              id: 'delete-api-key-button',
	                              'data-apim-test': 'delete-api-key-button',
	                              className: classes.deleteButton,
	                              onClick: openDeleteDialog
	                            },
	                            'Delete Key'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _core.TableRow,
	                      null,
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { style: { paddingBottom: 0, paddingTop: 0 }, colSpan: 6 },
	                        _react2.default.createElement(
	                          _Collapse2.default,
	                          { 'in': isOpen, timeout: 'auto', unmountOnExit: true },
	                          _react2.default.createElement(_Key2.default, {
	                            idx: idx,
	                            applicationUuid: applicationUuid,
	                            editable: getIsEditable(row),
	                            details: {
	                              name: (0, _lodash.get)(row, 'name'),
	                              status: (0, _lodash.get)(row, 'status'),
	                              isDefault: (0, _lodash.get)(row, 'defaultKey'),
	                              callbackUrl: (0, _lodash.get)(row, 'oauthCallbackUrl'),
	                              scope: (0, _lodash.get)(row, 'oauthScope'),
	                              type: (0, _lodash.get)(row, 'oauthType'),
	                              clientId: (0, _lodash.get)(row, 'apiKey'),
	                              clientSecret: (0, _lodash.get)(createdKey, 'keySecret') || (0, _lodash.get)(row, 'keySecret'),
	                              isHashed: (0, _lodash.get)(row, 'keySecretHashed'),
	                              isCreatedKey: (0, _lodash.get)(createdKey, 'name') === (0, _lodash.get)(row, 'name')
	                            },
	                            setHasUnsavedChanges: setHasUnsavedChanges,
	                            notifyMessages: notifyMessages,
	                            appSecretHashingMetadata: appSecretHashingMetadata,
	                            fetchKeyNameUnique: fetchKeyNameUnique,
	                            isUniqueKey: isUniqueKey,
	                            createKey: function createKey(data) {
	                              setLastCreatedKey(data);
	                              _createKey(data);
	                            },
	                            updateKey: updateKey,
	                            closeAction: onRowClick
	                          })
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.paginationContainer },
	            _react2.default.createElement(_components.TablePagination, {
	              id: 'app-keys-pagination',
	              'data-apim-test': 'app-keys-pagination',
	              page: page,
	              count: appKeysTotalElements,
	              pageCount: appKeysTotalPages,
	              rowsPerPage: rowsPerPage,
	              rowsPerPageOptions: GRID_ROWS_PER_PAGE_OPTIONS,
	              onChangeRowsPerPage: onChangeRowsPerPage,
	              onChangePage: onChangePage,
	              onChangePreviousPage: onChangePreviousPage,
	              onChangeNextPage: onChangeNextPage,
	              labelRowsPerPage: intl.getI18nMessage('label.pagination.rows.per.page')
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      nextText: _constants.DONE_TEXT,
	      showCancel: false,
	      id: 'manage-keys-form-buttons'
	    })
	  );
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(KeyManagement);
	
	
	KeyManagement.propTypes = {
	  applicationUuid: _propTypes2.default.string,
	  applicationDetails: _propTypes2.default.shape({}),
	  appKeys: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  appKeysTotalPages: _propTypes2.default.number,
	  appKeysTotalElements: _propTypes2.default.number,
	  fetchKeyNameUnique: _propTypes2.default.func,
	  isUniqueKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  createKey: _propTypes2.default.func,
	  updateKey: _propTypes2.default.func,
	  deleteKey: _propTypes2.default.func,
	  createKeyStatus: _propTypes2.default.string,
	  updateKeyStatus: _propTypes2.default.string,
	  deleteKeyStatus: _propTypes2.default.string,
	  isSaveApplicationSuccess: _propTypes2.default.bool,
	  appSecretHashingMetadata: _propTypes2.default.shape({}),
	  userContext: _propTypes2.default.shape({}),
	  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  classes: _propTypes2.default.shape({}),
	  resetApp: _propTypes2.default.func,
	  createdKey: _propTypes2.default.shape({}),
	  notifyMessages: _propTypes2.default.func
	};

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _utils = __webpack_require__(18);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography,
	      lineHeight = _ref.lineHeight;
	  return {
	    keyHeading: {
	      color: (0, _lodash.get)(color, 'link')
	    },
	    keyDetailsContainer: {
	      display: 'block',
	      '& :first-child': {
	        marginTop: 0,
	        marginBottom: 0
	      }
	    },
	    keysContainer: {
	      marginTop: 10,
	      '& table': {
	        backgroundColor: (0, _lodash.get)(color, 'uiBackground')
	      },
	      '& tr': {
	        borderTop: '1px solid ' + (0, _lodash.get)(color, 'borderColor')
	      },
	      '& th': {
	        color: (0, _lodash.get)(color, 'primaryButtonBackground'),
	        padding: 12,
	        cursor: 'pointer',
	        border: 'none'
	      },
	      '& td': {
	        padding: 12,
	        border: 'none'
	      }
	    },
	    expandCollapseButton: {
	      color: (0, _lodash.get)(color, 'primaryButtonBackground')
	    },
	    tableContainer: {
	      boxShadow: 'none'
	    },
	    tableHead: {
	      '& th': {
	        color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontWeight: 'bold !important',
	        cursor: 'auto'
	      }
	    },
	    paginationContainer: {
	      margin: '0 -10px',
	      '& > div:first-child': {
	        borderBottom: '1px solid ' + (0, _lodash.get)(color, 'borderColor')
	      }
	    },
	    pageTitle: {
	      display: 'inline'
	    },
	    addButton: {
	      float: 'right',
	      lineHeight: (0, _lodash.get)(lineHeight, 'lh20')
	    },
	    deleteButton: {
	      border: '1px solid ' + (0, _lodash.get)(color, 'borderColor'),
	      color: (0, _lodash.get)(color, 'red'),
	      float: 'right',
	      '&:hover': {
	        color: (0, _lodash.get)(color, 'red')
	      }
	    },
	    submitButton: {
	      backgroundColor: (0, _lodash.get)(color, 'red') + ' !important'
	    },
	    openRow: {
	      '& th': {
	        borderBottom: '0px',
	        color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontWeight: 'bold !important'
	      },
	      '& td': {
	        borderBottom: '0px'
	      }
	    },
	    openRowTitle: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontWeight: 700
	    },
	    changeButton: {
	      color: (0, _lodash.get)(color, 'link')
	    },
	    disabledRow: {
	      background: (0, _lodash.get)(color, 'gray') + ' !important',
	      opacity: '0.7',
	      pointerEvents: 'none'
	    },
	    defaultChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'bodyText'), 0.05) + ' !important',
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    },
	    enabledChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'success')) + ' !important',
	      color: (0, _lodash.get)(color, 'white') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    },
	    disabledChip: {
	      backgroundColor: (0, _utils.convertHexToRGB)((0, _lodash.get)(color, 'error')) + ' !important',
	      color: (0, _lodash.get)(color, 'white') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important',
	      margin: '0 10px',
	      height: '24px'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApplicationEdit = exports.getDefaultSelectedTabIndex = exports.getTabs = exports.getApplicationUuid = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(27);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _propTypes = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _portalConfig = __webpack_require__(26);
	
	var _portalConfig2 = __webpack_require__(85);
	
	var _application = __webpack_require__(102);
	
	var _api = __webpack_require__(603);
	
	var _application2 = __webpack_require__(86);
	
	var _api2 = __webpack_require__(202);
	
	var _utils = __webpack_require__(18);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	var _edit = __webpack_require__(201);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _intl = __webpack_require__(15);
	
	var _tabs = __webpack_require__(1610);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _styles = __webpack_require__(1609);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getApplicationUuid = exports.getApplicationUuid = function getApplicationUuid(props) {
	  return (0, _lodash.get)(props, 'match.path') && (0, _lodash.get)(props, 'match.path').includes('/edit/') && (0, _lodash.get)(props, 'match.params.applicationUuid');
	};
	
	var getTabs = exports.getTabs = function getTabs(tabProps) {
	  return _tabs2.default.filter(function (_ref) {
	    var isHidden = _ref.isHidden;
	    return !(isHidden && isHidden(tabProps));
	  }).map(function (tab) {
	    return Object.assign({}, tab, {
	      disabled: tab.isDisabled && tab.isDisabled(tabProps)
	    });
	  });
	};
	
	var getDefaultSelectedTabIndex = exports.getDefaultSelectedTabIndex = function getDefaultSelectedTabIndex(tabs, match) {
	  var tabName = (0, _lodash.get)(match, 'params.tabName');
	  var index = (0, _lodash.findIndex)(tabs, function (tab) {
	    return tab.id === tabName;
	  });
	  // if none found default to 0
	  return index > 0 ? index : 0;
	};
	
	var getApplicatonDetailsToPersist = function getApplicatonDetailsToPersist(applicationDetails, isHashingEnabled, shouldHash) {
	  return Object.assign({}, applicationDetails, !(0, _lodash.isUndefined)(isHashingEnabled) && (!(0, _lodash.isUndefined)(shouldHash) || !(0, _lodash.isNull)(shouldHash)) ? { shouldHash: shouldHash } : {});
	};
	
	var ApplicationEdit = exports.ApplicationEdit = function ApplicationEdit(props) {
	  var userContext = props.userContext,
	      applicationErrors = props.applicationErrors,
	      match = props.match,
	      isApplicationNameUnique = props.isApplicationNameUnique,
	      featureFlagApiPlans = props.featureFlagApiPlans,
	      availableApiPlans = props.availableApiPlans,
	      customFields = props.customFields,
	      isSaveApplicationSuccess = props.isSaveApplicationSuccess,
	      useLegacyApplicationPages = props.useLegacyApplicationPages,
	      useMultiApiKeys = props.useMultiApiKeys,
	      _props$appKeys = props.appKeys,
	      appKeys = _props$appKeys === undefined ? [] : _props$appKeys,
	      appKeysTotalPages = props.appKeysTotalPages,
	      appKeysTotalElements = props.appKeysTotalElements,
	      isUniqueKey = props.isUniqueKey,
	      createKeyStatus = props.createKeyStatus,
	      updateKeyStatus = props.updateKeyStatus,
	      deleteKeyStatus = props.deleteKeyStatus,
	      appSecretHashingMetadata = props.appSecretHashingMetadata;
	
	  var applicationUuid = getApplicationUuid(props) || '';
	  if (useLegacyApplicationPages) {
	    window.localStorage.setItem('v4.4.applications', 'true');
	    var prefixUrl = (0, _utils.hasOrgBoundRole)(userContext) ? '/app' : '';
	    if (applicationUuid && (0, _lodash.get)(props, 'match.path').includes('/edit/')) {
	      window.location.href = '/admin' + prefixUrl + '/applications#edit/' + applicationUuid;
	    } else if ((0, _lodash.get)(props, 'match.path').includes('/add')) {
	      window.location.href = '/admin' + prefixUrl + '/applications#add';
	    }
	  }
	  var headerRef = (0, _react.useRef)(null);
	
	  // Retrieving Application Status from the store (persisted value) and not the local state
	  var applicationStatus = (0, _lodash.get)(props.applicationDetails, 'status');
	  var isMultiKeySupport = useMultiApiKeys && (0, _utils.hasPublisherRole)(userContext) && appKeys.length > 0;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isDialogOpen = _useState2[0],
	      setIsDialogOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(intl.getI18nMessage('label.dialog.unsaved.changes.exit')),
	      _useState4 = _slicedToArray(_useState3, 2),
	      dialogSubmitText = _useState4[0],
	      setDialogSubmitText = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isCancelButton = _useState6[0],
	      setIsCancelButton = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(props.applicationDetails),
	      _useState8 = _slicedToArray(_useState7, 2),
	      applicationDetails = _useState8[0],
	      setApplicationDetails = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      isApplicationErrors = _useState10[0],
	      setIsApplicationErrors = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      isHashedSecret = _useState12[0],
	      setIsHashedSecret = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      showOneTimePasswordWarning = _useState14[0],
	      setShowOneTimePasswordWarning = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      isPlainTextCheckBoxSelected = _useState16[0],
	      setIsPlainTextCheckBoxSelected = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      notificationMessage = _useState18[0],
	      setNotificationMessage = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      notificationStatus = _useState20[0],
	      setNotificationStatus = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(props.isLoading),
	      _useState22 = _slicedToArray(_useState21, 2),
	      isLoading = _useState22[0],
	      setIsLoading = _useState22[1];
	
	  var notifyMessages = function notifyMessages(message, status) {
	    setNotificationStatus(status);
	    localStorage.setItem('notificationStatus', status);
	    setNotificationMessage(message);
	    localStorage.setItem('notificationMessage', message);
	  };
	
	  var tabProps = {
	    userContext: userContext,
	    applicationUuid: applicationUuid,
	    applicationDetails: applicationDetails,
	    isApplicationNameUnique: isApplicationNameUnique,
	    featureFlagApiPlans: featureFlagApiPlans,
	    availableApiPlans: availableApiPlans,
	    customFields: customFields,
	    appKeys: appKeys,
	    isMultiKeySupport: isMultiKeySupport
	  };
	
	  var _useState23 = (0, _react.useState)(getTabs(tabProps)),
	      _useState24 = _slicedToArray(_useState23, 2),
	      tabs = _useState24[0],
	      setTabs = _useState24[1];
	
	  var defaultIndex = getDefaultSelectedTabIndex(tabs, match);
	
	  var _useState25 = (0, _react.useState)(defaultIndex),
	      _useState26 = _slicedToArray(_useState25, 2),
	      tabIndex = _useState26[0],
	      setTabIndex = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(tabs[tabIndex].tabId),
	      _useState28 = _slicedToArray(_useState27, 2),
	      currentTab = _useState28[0],
	      setCurrentTab = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(tabs[defaultIndex].tabId),
	      _useState30 = _slicedToArray(_useState29, 2),
	      redirectTabValue = _useState30[0],
	      setRedirectTabValue = _useState30[1];
	
	  var AUTHENTICATION_TAB = 'authentication-tab';
	  var KEY_TAB = 'key-tab';
	
	  (0, _react.useEffect)(function () {
	    localStorage.setItem('isAppUnSavedChanges', false);
	    props.fetchCustomFields();
	    props.fetchAppSecretHashingMetadata();
	    props.fetchApplicationRequestSetting();
	    props.fetchApplicationEditRequestSetting();
	    if (applicationUuid) {
	      props.fetchApplication(applicationUuid);
	      props.fetchSelectedApis(applicationUuid);
	      props.fetchSelectedApiGroups(applicationUuid);
	      props.fetchApplicationKeys(applicationUuid);
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (applicationUuid) {
	      if (updateKeyStatus === 'SUCCESS' || deleteKeyStatus === 'SUCCESS' || isSaveApplicationSuccess) {
	        props.fetchApplicationKeys(applicationUuid);
	      }
	    }
	  }, [createKeyStatus, updateKeyStatus, deleteKeyStatus, isSaveApplicationSuccess]);
	
	  (0, _react.useEffect)(function () {
	    setIsLoading(props.isLoading);
	  }, [props.isLoading]);
	
	  (0, _react.useEffect)(function () {
	    if (!props.applicationDetails) {
	      return;
	    }
	    // Allow the org-bound user to view the Key page
	    // when Edit Application Request workflow is enabled.
	    if (applicationUuid && ['authentication-tab', 'key-tab'].includes(currentTab)) {
	      return;
	    }
	    if (applicationUuid && (0, _utils.isEditApplicationDisabled)(userContext, props.applicationDetails) && (0, _utils.isEditApplicationKeysDisabled)(userContext, props.applicationDetails)) {
	      props.push('/404');
	    }
	
	    // Assigning the fetched Application Details to the local state
	    setApplicationDetails(props.applicationDetails);
	    var organizationUuid = props.applicationDetails.organizationUuid;
	
	    if (organizationUuid) {
	      props.fetchAvailableApis({ orgUuid: organizationUuid });
	      props.fetchAvailableApiGroups({ orgUuid: organizationUuid });
	    }
	  }, [props.applicationDetails]);
	
	  (0, _react.useEffect)(function () {
	    // Assigning the fetched Application Details to the local state
	    // Assigning the fetched APIs & API Groups to the local state
	    setApplicationDetails(Object.assign({}, props.applicationDetails, {
	      apiIds: [].concat(_toConsumableArray(props.applicationDetails.apiIds || []), _toConsumableArray(props.selectedApis ? props.selectedApis.map(function (selectedApi) {
	        return selectedApi.uuid;
	      }) : [])),
	      apiGroupIds: [].concat(_toConsumableArray(props.applicationDetails.apiGroupIds || []), _toConsumableArray(props.selectedApiGroups ? props.selectedApiGroups.map(function (selectedApiGroup) {
	        return selectedApiGroup.uuid;
	      }) : []))
	    }));
	  }, [props.applicationDetails, props.selectedApis, props.selectedApiGroups]);
	
	  (0, _react.useEffect)(function () {
	    var filterTabs = getTabs(tabProps);
	    setTabs(filterTabs);
	  }, [applicationUuid, applicationDetails, isApplicationNameUnique, availableApiPlans, appKeys]);
	
	  (0, _react.useEffect)(function () {
	    setCurrentTab(tabs[defaultIndex].tabId);
	  }, [defaultIndex]);
	
	  (0, _react.useEffect)(function () {
	    var filterTabs = getTabs(tabProps);
	    var newTabIndex = getDefaultSelectedTabIndex(filterTabs, match);
	
	    setTabs(filterTabs);
	    setTabIndex(newTabIndex);
	    setCurrentTab(filterTabs[newTabIndex].tabId);
	  }, [customFields]);
	
	  (0, _react.useEffect)(function () {
	    if (applicationErrors.length > 0) {
	      notifyMessages((0, _intl.getI18nFormattedMessage)('error.applications.update'), _constants.ALERT_ERROR);
	      // TODO: Needs to be retested for more error scenarios
	      // setErrors(applicationErrors);
	    }
	  }, [applicationErrors]);
	
	  var onDialogClose = function onDialogClose() {
	    setIsDialogOpen(false);
	  };
	
	  var redirectTab = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(newTab) {
	      var tIndex, id;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(currentTab === KEY_TAB && newTab !== KEY_TAB)) {
	                _context.next = 14;
	                break;
	              }
	
	              _context.next = 3;
	              return props.showLoading(true);
	
	            case 3:
	              _context.next = 5;
	              return props.resetSecret(applicationUuid);
	
	            case 5:
	              _context.next = 7;
	              return props.fetchApplication(applicationUuid);
	
	            case 7:
	              _context.next = 9;
	              return props.fetchSelectedApis(applicationUuid);
	
	            case 9:
	              _context.next = 11;
	              return props.fetchSelectedApiGroups(applicationUuid);
	
	            case 11:
	              _context.next = 13;
	              return props.fetchApplicationKeys(applicationUuid);
	
	            case 13:
	              // Remove the warning to show Hashed secret once
	              setShowOneTimePasswordWarning(false);
	
	            case 14:
	              setCurrentTab(newTab);
	              if (applicationUuid) {
	                tIndex = tabs.findIndex(function (_ref3) {
	                  var tabId = _ref3.tabId;
	                  return tabId === newTab;
	                });
	                id = tabs[tIndex].id;
	
	                if (
	                // handling a specific scenario for a defect
	                useMultiApiKeys && (0, _utils.hasPublisherRole)(userContext) && currentTab === KEY_TAB && newTab === AUTHENTICATION_TAB) {
	                  props.push('/publish/applications/edit/' + applicationUuid + '/keys');
	                } else {
	                  props.push('/publish/applications/edit/' + applicationUuid + '/' + id);
	                }
	              }
	              window.scrollTo(0, headerRef.offsetTop);
	
	            case 17:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function redirectTab(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var onDialogSubmit = function onDialogSubmit() {
	    localStorage.setItem('isAppUnSavedChanges', false);
	    setDialogSubmitText((0, _intl.getI18nFormattedMessage)('label.dialog.unsaved.changes.exit'));
	    if (isCancelButton) {
	      setIsCancelButton(false);
	      window.location.href = (0, _utils.hasOrgBoundRole)(userContext) ? '/admin/app/applications' : '/admin/applications';
	    } else {
	      setIsDialogOpen(false);
	      redirectTab(redirectTabValue);
	    }
	  };
	
	  var onCancel = function onCancel() {
	    if (localStorage.getItem('isAppUnSavedChanges') === 'true') {
	      setIsCancelButton(true);
	      setIsDialogOpen(true);
	    } else {
	      window.location.href = (0, _utils.hasOrgBoundRole)(userContext) ? '/admin/app/applications' : '/admin/applications';
	    }
	  };
	
	  var onUpdateApplicationSecret = function onUpdateApplicationSecret(shouldHash) {
	    var isHashingEnabled = (0, _lodash.get)(appSecretHashingMetadata, 'algorithm');
	    var applicationDetailsToPersist = getApplicatonDetailsToPersist(applicationDetails, isHashingEnabled, shouldHash);
	    props.updateApplicationSecret(applicationDetailsToPersist);
	  };
	
	  var onSaveApplication = function onSaveApplication(shouldHash, isGet) {
	    var isHashingEnabled = (0, _lodash.get)(appSecretHashingMetadata, 'algorithm');
	    var applicationDetailsToPersist = getApplicatonDetailsToPersist(applicationDetails, isHashingEnabled, shouldHash);
	    if (applicationUuid) {
	      if (isGet) {
	        props.updateAndGetApplication(applicationDetailsToPersist);
	      } else {
	        props.updateApplication(applicationDetailsToPersist);
	      }
	    } else {
	      props.createApplication(applicationDetailsToPersist);
	    }
	  };
	
	  var getHelpItems = function getHelpItems() {
	    return isMultiKeySupport ? _constants.MULTIKEY_HELP_ITEMS.details : _constants.HELP_ITEMS.details;
	  };
	
	  var handleTabChange = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e, newTab) {
	      var hasUnsavedChanges;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(currentTab === newTab)) {
	                _context2.next = 2;
	                break;
	              }
	
	              return _context2.abrupt('return');
	
	            case 2:
	              hasUnsavedChanges = localStorage.getItem('isAppUnSavedChanges');
	
	              if (hasUnsavedChanges === 'true' && newTab === KEY_TAB) {
	                setIsCancelButton(false);
	                setDialogSubmitText((0, _intl.getI18nFormattedMessage)('label.dialog.unsaved.changes.submit'));
	                setIsDialogOpen(true);
	                setRedirectTabValue(newTab);
	              } else {
	                redirectTab(newTab);
	              }
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function handleTabChange(_x2, _x3) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(_edit2.default, {
	    editPageId: 'application-edit-page',
	    dialogId: 'api-unsaved-dialog',
	    isDialogOpen: isDialogOpen,
	    onDialogClose: onDialogClose,
	    dialogSubmitText: dialogSubmitText,
	    onDialogSubmit: onDialogSubmit,
	    isLoading: isLoading,
	    leftSidebarId: 'application-edit-left-sidebar',
	    mainContentId: 'application-edit-main-content',
	    notificationId: 'application-notifications',
	    notificationStatus: notificationStatus,
	    setNotificationStatus: setNotificationMessage,
	    notificationMessage: notificationMessage,
	    setNotificationMessage: setNotificationMessage,
	    tabsContainer: _react2.default.createElement(_components.TabsContainer, {
	      useTabId: true,
	      tabValue: currentTab,
	      tabItems: tabs,
	      handleTabChange: handleTabChange
	    }),
	    pageHeaderRef: headerRef,
	    pageHeaderTitle: applicationUuid ? intl.getI18nMessage('label.application.edit') + ': ' + applicationDetails.name : intl.getI18nMessage('label.application.add'),
	    pageContent: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      tabs.map(function (_ref5) {
	        var tabId = _ref5.tabId,
	            tabPanel = _ref5.tabPanel;
	        return _react2.default.createElement(
	          _components.TabPanel,
	          {
	            id: tabId + '-panel',
	            visible: currentTab === tabId,
	            key: tabId
	          },
	          tabPanel(Object.assign({}, props, {
	            errors: props.applicationErrors,
	            visible: currentTab === tabId,
	            headerRef: headerRef,
	            currentTab: currentTab,
	            setCurrentTab: setCurrentTab,
	            applicationUuid: applicationUuid,
	            onCancel: onCancel,
	            onSaveApplication: onSaveApplication,
	            onUpdateApplicationSecret: onUpdateApplicationSecret,
	            applicationDetails: applicationDetails,
	            setApplicationDetails: setApplicationDetails,
	            applicationStatus: applicationStatus,
	            isHashedSecret: isHashedSecret,
	            setIsHashedSecret: setIsHashedSecret,
	            showOneTimePasswordWarning: showOneTimePasswordWarning,
	            setShowOneTimePasswordWarning: setShowOneTimePasswordWarning,
	            isPlainTextCheckBoxSelected: isPlainTextCheckBoxSelected,
	            setIsPlainTextCheckBoxSelected: setIsPlainTextCheckBoxSelected,
	            isApplicationErrors: isApplicationErrors,
	            setIsApplicationErrors: setIsApplicationErrors,
	            isSaveApplicationSuccess: isSaveApplicationSuccess,
	            notifyMessages: notifyMessages,
	            fetchApplicationKeys: props.fetchApplicationKeys,
	            appKeys: appKeys,
	            appKeysTotalPages: appKeysTotalPages,
	            appKeysTotalElements: appKeysTotalElements,
	            fetchKeyNameUnique: props.fetchKeyNameUnique,
	            createKey: props.createKey,
	            updateKey: props.updateKey,
	            isUniqueKey: isUniqueKey,
	            createKeyStatus: createKeyStatus,
	            updateKeyStatus: updateKeyStatus,
	            isMultiKeySupport: isMultiKeySupport
	          }))
	        );
	      })
	    ),
	    rightSidebarId: 'application-edit-right-sidebar',
	    helpItems: getHelpItems()
	  });
	};
	
	ApplicationEdit.propTypes = {
	  userContext: (0, _propTypes.shape)({}),
	  applicationErrors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  featureFlagApiPlans: _propTypes.bool,
	  isLoading: _propTypes.bool,
	  match: (0, _propTypes.shape)({
	    params: (0, _propTypes.shape)({
	      tabName: _propTypes.string,
	      applicationUuid: _propTypes.string
	    })
	  }),
	  applicationDetails: (0, _propTypes.shape)({}),
	  isApplicationNameUnique: _propTypes.bool,
	  availableApiPlans: (0, _propTypes.shape)({}),
	  isSaveApplicationSuccess: _propTypes.bool,
	  customFields: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  selectedApis: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  selectedApiGroups: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  useLegacyApplicationPages: _propTypes.bool,
	  useMultiApiKeys: _propTypes.bool,
	  appKeys: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  appKeysTotalPages: _propTypes.number,
	  appKeysTotalElements: _propTypes.number,
	  updateKey: _propTypes.func,
	  createKeyStatus: _propTypes.string,
	  updateKeyStatus: _propTypes.string,
	  deleteKeyStatus: _propTypes.string,
	  isUniqueKey: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool]),
	  appSecretHashingMetadata: (0, _propTypes.shape)({})
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    dict: (0, _portalConfig.getDict)(state),
	    userContext: (0, _portalConfig.getUserDetails)(state),
	    userActiveOrgUuid: (0, _portalConfig.getUserActiveOrgUuid)(state),
	    userAccessibleOrgs: (0, _portalConfig.getUserAccessibleOrgs)(state),
	    isLoading: (0, _application2.getIsLoading)(state),
	    isError: (0, _application2.getIsError)(state),
	    applicationErrors: (0, _application2.getErrors)(state),
	    applicationDetails: (0, _application2.getApplicationDetails)(state),
	    isSaveApplicationSuccess: (0, _application2.getIsSaveApplicationSuccess)(state),
	    isSaveApplicationSecretSuccess: (0, _application2.getIsSaveApplicationSecretSuccess)(state),
	    organizations1: (0, _application2.getOrganizations1)(state),
	    organizations: (0, _application2.getOrganizations)(state),
	    organizationsCount: (0, _application2.getOrganizationsCount)(state),
	    isApplicationNameUnique: (0, _application2.getIsApplicationNameUnique)(state),
	    customFields: (0, _application2.getCustomFields)(state),
	    selectedApis: (0, _application2.getSelectedApis)(state),
	    availableApis: (0, _application2.getAvailableApis)(state),
	    availableApisCount: (0, _application2.getAvailableApisCount)(state),
	    apiEula: (0, _application2.getApiEula)(state),
	    selectedApiGroups: (0, _application2.getSelectedApiGroups)(state),
	    secret: (0, _application2.getSecret)(state),
	    availableApiGroups1: (0, _application2.getAvailableApiGroups1)(state),
	    availableApiGroups: (0, _application2.getAvailableApiGroups)(state),
	    availableApiGroupsCount: (0, _application2.getAvailableApiGroupsCount)(state),
	    apiGroupEulas: (0, _application2.getApiGroupEulas)(state),
	    allTags: (0, _api2.getAllPortalTags)(state),
	    featureFlagApiPlans: (0, _portalConfig.getFeatureFlagApiPlans)(state),
	    useLegacyApplicationPages: (0, _portalConfig.getUseLegacyApplicationPages)(state),
	    useMultiApiKeys: (0, _portalConfig.getUseMultiApiKeys)(state),
	    isApplicationRequestWorkflowEnabled: (0, _portalConfig.getIsApplicationRequestWorkflowEnabled)(state),
	    isEditApplicationRequestWorkflowEnabled: (0, _portalConfig.getIsEditApplicationRequestWorkflowEnabled)(state),
	    availableApiPlans: (0, _application2.getAvailableApiPlans)(state),
	    appSecretHashingMetadata: (0, _portalConfig.getAppSecretHashingMetadata)(state),
	    appKeys: (0, _application2.getKeysResults)(state),
	    appKeysTotalPages: (0, _application2.getKeysTotalPages)(state),
	    appKeysTotalElements: (0, _application2.getKeysTotalElements)(state),
	    isUniqueKey: (0, _application2.getIsUniqueKey)(state),
	    createKeyStatus: (0, _application2.getCreateKeyStatus)(state),
	    updateKeyStatus: (0, _application2.getUpdateKeyStatus)(state),
	    deleteKeyStatus: (0, _application2.getDeleteKeyStatus)(state),
	    createdKey: (0, _application2.getCreatedKey)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  push: _connectedReactRouter.push,
	  showLoading: _application.showLoading,
	  resetApp: _application.resetApp,
	  fetchApplication: _application.fetchApplication,
	  fetchOrganizations: _application.fetchOrganizations,
	  fetchAllOrganizations: _application.fetchAllOrganizations,
	  fetchApplicationNameUnique: _application.fetchApplicationNameUnique,
	  fetchCustomFields: _application.fetchCustomFields,
	  fetchSelectedApis: _application.fetchSelectedApis,
	  fetchAvailableApis: _application.fetchAvailableApis,
	  fetchApiEula: _application.fetchApiEula,
	  fetchSelectedApiGroups: _application.fetchSelectedApiGroups,
	  fetchAvailableApiGroups: _application.fetchAvailableApiGroups,
	  generateSecret: _application.generateSecret,
	  resetSecret: _application.resetSecret,
	  fetchApiGroupEulas: _application.fetchApiGroupEulas,
	  fetchAllTags: _api.fetchAllTags,
	  createApplication: _application.createApplication,
	  updateApplication: _application.updateApplication,
	  updateAndGetApplication: _application.updateAndGetApplication,
	  updateApplicationSecret: _application.updateApplicationSecret,
	  fetchAvailableApiPlans: _application.fetchAvailableApiPlans,
	  fetchAppSecretHashingMetadata: _portalConfig2.fetchAppSecretHashingMetadata,
	  fetchApplicationRequestSetting: _portalConfig2.fetchApplicationRequestSetting,
	  fetchApplicationEditRequestSetting: _portalConfig2.fetchApplicationEditRequestSetting,
	  fetchApplicationKeys: _application.fetchApplicationKeys,
	  fetchKeyNameUnique: _application.fetchKeyNameUnique,
	  createKey: _application.createKey,
	  updateKey: _application.updateKey,
	  deleteKey: _application.deleteKey
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ApplicationEdit);

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var borderRadius = _ref.borderRadius,
	      color = _ref.color,
	      fontSize = _ref.fontSize,
	      margin = _ref.margin,
	      padding = _ref.padding,
	      typography = _ref.typography;
	  return {
	    pageTitle: {
	      color: (0, _lodash.get)(color, 'pageTitle'),
	      fontFamily: (0, _lodash.get)(typography, 'pageTitle'),
	      fontSize: (0, _lodash.get)(fontSize, 'pageTitle'),
	      marginTop: 6
	    },
	    statusField: {
	      '& legend': {
	        color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	        fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	        fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	        fontWeight: 'bold',
	        marginBottom: 10
	      }
	    },
	    labelText: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important'
	    },
	    helperText: {
	      color: (0, _lodash.get)(color, 'smallText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'smallText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'smallText') + ' !important'
	    },
	    resetSecretButton: {
	      color: (0, _lodash.get)(color, 'red'),
	      border: '1px solid ' + (0, _lodash.get)(color, 'borderColor'),
	      '&:hover': {
	        color: (0, _lodash.get)(color, 'red')
	      }
	    },
	    copyKeyButton: {
	      color: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      marginTop: 51,
	      width: '70%'
	    },
	    divider: {
	      backgroundColor: (0, _lodash.get)(color, 'borderColor')
	    },
	    selectWrapper: {
	      minHeight: 370,
	      width: 500
	    },
	    selectApiPlanPlaceholder: {
	      color: (0, _lodash.get)(color, 'error'),
	      cursor: 'pointer',
	      border: '1px solid ' + (0, _lodash.get)(color, 'borderColor'),
	      borderRadius: (0, _lodash.get)(borderRadius, 'br4'),
	      margin: (0, _lodash.get)(margin, 'm0') + ' ' + (0, _lodash.get)(margin, 'm10'),
	      padding: (0, _lodash.get)(padding, 'p0') + ' ' + (0, _lodash.get)(padding, 'p10')
	    },
	    selectedApiPlan: {
	      margin: (0, _lodash.get)(margin, 'm0') + ' ' + (0, _lodash.get)(margin, 'm10')
	    },
	    tagGroupContainer: {
	      marginTop: 8,
	      width: '300px'
	    },
	    apiGroupPanel: {
	      color: (0, _lodash.get)(color, 'pageTitle')
	    },
	    panelContent: {
	      color: (0, _lodash.get)(color, 'bodyText') + ' !important',
	      fontFamily: (0, _lodash.get)(typography, 'bodyText') + ' !important',
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText') + ' !important',
	      fontWeight: 400,
	      lineHeight: 1.5
	    },
	    iconRoot: {
	      '& svg': {
	        width: 16,
	        height: 16
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isRequiredCustomFieldsNotSet = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(8);
	
	var _Details = __webpack_require__(1602);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _CustomFields = __webpack_require__(1601);
	
	var _CustomFields2 = _interopRequireDefault(_CustomFields);
	
	var _ApiManagement = __webpack_require__(1598);
	
	var _ApiManagement2 = _interopRequireDefault(_ApiManagement);
	
	var _Auth = __webpack_require__(1600);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Key = __webpack_require__(1603);
	
	var _Key2 = _interopRequireDefault(_Key);
	
	var _KeyManagement = __webpack_require__(1606);
	
	var _KeyManagement2 = _interopRequireDefault(_KeyManagement);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isOrganizationAndNameSet = function isOrganizationAndNameSet(_ref) {
	  var userContext = _ref.userContext,
	      applicationDetails = _ref.applicationDetails,
	      isApplicationNameUnique = _ref.isApplicationNameUnique;
	  return (0, _utils.hasOrgBoundRole)(userContext) ? (0, _lodash.trim)(applicationDetails.name) && isApplicationNameUnique !== false : (0, _lodash.trim)(applicationDetails.name) && isApplicationNameUnique !== false && applicationDetails.organizationUuid;
	};
	
	var isRequiredCustomFieldsNotSet = exports.isRequiredCustomFieldsNotSet = function isRequiredCustomFieldsNotSet(_ref2) {
	  var applicationDetails = _ref2.applicationDetails,
	      _ref2$customFields = _ref2.customFields,
	      customFields = _ref2$customFields === undefined ? [] : _ref2$customFields;
	  var customFieldValues = applicationDetails.customFieldValues;
	
	  return (0, _lodash.some)(customFields.filter(function (_ref3) {
	    var required = _ref3.required;
	    return required;
	  }), function (_ref4) {
	    var uuid = _ref4.uuid;
	    return !customFieldValues[uuid];
	  });
	};
	
	var tabs = [{
	  id: 'details',
	  label: 'Details',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_Details2.default, props);
	  },
	  isDisabled: function isDisabled(_ref5) {
	    var userContext = _ref5.userContext,
	        applicationDetails = _ref5.applicationDetails;
	    return (0, _utils.isEditApplicationDisabled)(userContext, applicationDetails);
	  }
	}, {
	  id: 'custom-fields',
	  label: 'Custom Fields',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_CustomFields2.default, props);
	  },
	  isDisabled: function isDisabled(_ref6) {
	    var userContext = _ref6.userContext,
	        applicationDetails = _ref6.applicationDetails,
	        isApplicationNameUnique = _ref6.isApplicationNameUnique;
	    return (0, _utils.isEditApplicationDisabled)(userContext, applicationDetails) || !isOrganizationAndNameSet({ userContext: userContext, applicationDetails: applicationDetails, isApplicationNameUnique: isApplicationNameUnique });
	  },
	  isHidden: function isHidden(_ref7) {
	    var customFields = _ref7.customFields;
	    return (0, _lodash.isEmpty)(customFields);
	  }
	}, {
	  id: 'api-management',
	  label: 'API Management',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_ApiManagement2.default, props);
	  },
	  isDisabled: function isDisabled(_ref8) {
	    var userContext = _ref8.userContext,
	        applicationDetails = _ref8.applicationDetails,
	        isApplicationNameUnique = _ref8.isApplicationNameUnique,
	        customFields = _ref8.customFields;
	    return (0, _utils.isEditApplicationDisabled)(userContext, applicationDetails) || !isOrganizationAndNameSet({ userContext: userContext, applicationDetails: applicationDetails, isApplicationNameUnique: isApplicationNameUnique }) || isRequiredCustomFieldsNotSet({ applicationDetails: applicationDetails, customFields: customFields });
	  }
	}, {
	  id: 'authentication',
	  label: 'Authentication',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_Auth2.default, props);
	  },
	  isDisabled: function isDisabled(_ref9) {
	    var userContext = _ref9.userContext,
	        applicationDetails = _ref9.applicationDetails,
	        isApplicationNameUnique = _ref9.isApplicationNameUnique,
	        featureFlagApiPlans = _ref9.featureFlagApiPlans,
	        availableApiPlans = _ref9.availableApiPlans,
	        customFields = _ref9.customFields;
	    return (0, _utils.isEditApplicationDisabled)(userContext, applicationDetails) || !isOrganizationAndNameSet({ userContext: userContext, applicationDetails: applicationDetails, isApplicationNameUnique: isApplicationNameUnique }) || isRequiredCustomFieldsNotSet({ applicationDetails: applicationDetails, customFields: customFields }) || (0, _lodash.isEmpty)(applicationDetails.apiIds) && (0, _lodash.isEmpty)(applicationDetails.apiGroupIds) || featureFlagApiPlans && !(0, _lodash.every)((0, _lodash.keys)(applicationDetails.apiApiPlanIds), function (apiApiPlanId) {
	      return (0, _lodash.isEmpty)(availableApiPlans[apiApiPlanId]) || !!applicationDetails.apiApiPlanIds[apiApiPlanId];
	    });
	  },
	  isHidden: function isHidden(_ref10) {
	    var isMultiKeySupport = _ref10.isMultiKeySupport;
	    return isMultiKeySupport;
	  }
	}, {
	  id: 'key',
	  label: 'Key',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_Key2.default, props);
	  },
	  isDisabled: function isDisabled(_ref11) {
	    var applicationUuid = _ref11.applicationUuid;
	    return !applicationUuid;
	  },
	  isHidden: function isHidden(_ref12) {
	    var isMultiKeySupport = _ref12.isMultiKeySupport;
	    return isMultiKeySupport;
	  }
	}, {
	  id: 'keys',
	  label: 'Authentication & Keys',
	  tabPanel: function tabPanel(props) {
	    return _react2.default.createElement(_KeyManagement2.default, props);
	  },
	  isDisabled: function isDisabled(_ref13) {
	    var applicationUuid = _ref13.applicationUuid;
	    return !applicationUuid;
	  },
	  isHidden: function isHidden(_ref14) {
	    var isMultiKeySupport = _ref14.isMultiKeySupport;
	    return !isMultiKeySupport;
	  }
	}];
	
	exports.default = (0, _lodash.map)(tabs, function (tab) {
	  return Object.assign({}, tab, { tabId: tab.id + '-tab' });
	});

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = ChartContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1612);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _PanelDropdown = __webpack_require__(1642);
	
	var _PanelDropdown2 = _interopRequireDefault(_PanelDropdown);
	
	var _GridPanelContainer = __webpack_require__(1633);
	
	var _GridPanelContainer2 = _interopRequireDefault(_GridPanelContainer);
	
	var _labels = __webpack_require__(78);
	
	var _ChartPanel = __webpack_require__(1617);
	
	var _ChartPanel2 = _interopRequireDefault(_ChartPanel);
	
	var _customMetrics = __webpack_require__(616);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChartContainer(props) {
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      isLoading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isTop3EntitiesSelected = _useState4[0],
	      setTop3Entities = _useState4[1];
	
	  var fetchDashboardChartData = props.fetchDashboardChartData,
	      isAnalyticsEnabled = props.isAnalyticsEnabled;
	
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var panelLabels = {
	    api: _labels.APIS_PANEL_TITLE,
	    org: _labels.ORGS_PANEL_TITLE,
	    proxy: _labels.PROXIES_PANEL_TITLE,
	    app: _labels.APPS_PANEL_TITLE
	  };
	  var entityIdMap = {
	    api: 'apiId',
	    org: 'orgId',
	    proxy: 'gatewayServerId',
	    app: 'appId'
	  };
	  var trafficMap = {
	    api: _labels.APIS_TRAFFIC,
	    org: _labels.ORGANIZATIONS_TRAFFIC,
	    app: _labels.APPLICATIONS_TRAFFIC,
	    proxy: _labels.PROXIES_TRAFFIC
	  };
	  var classes = useStyles();
	  var getchartQueryParams = function getchartQueryParams() {
	    return {
	      metrics: { type: 'hits', aggregation: 'count' },
	      timeRange: { type: 'period', period: '30D', aggregation: 'day' },
	      dimensions: { groupBy: [{ dimension: entityIdMap[props.chartEntity], type: 'top', limit: 3 }] }
	    };
	  };
	  var loadChart = function loadChart() {
	    var query = (0, _customMetrics.buildQuery)(getchartQueryParams());
	    fetchDashboardChartData(query, props.chartEntity).then(function () {
	      return setLoading(false);
	    });
	  };
	  var toggleTop3Entities = function toggleTop3Entities() {
	    setTop3Entities(!isTop3EntitiesSelected);
	    loadChart();
	  };
	  // Constructing date string (from 30 days back to today)
	  var dateRange = function dateRange() {
	    return (0, _moment2.default)(new Date().getTime() - 29 * 24 * 60 * 60 * 1000).format('ddd MMM DD, YYYY') + ' - ' + (0, _moment2.default)(new Date()).format('ddd MMM DD, YYYY');
	  };
	
	  if (isAnalyticsEnabled) {
	    (0, _react.useEffect)(function () {
	      loadChart();
	    }, [fetchDashboardChartData]);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.dashboardChartContainer },
	    _react2.default.createElement(
	      'div',
	      { className: classes.chartPanel },
	      _react2.default.createElement(
	        'div',
	        { className: classes.chartHeader },
	        _react2.default.createElement(
	          'span',
	          { className: classes.chartTitle },
	          isAnalyticsEnabled ? trafficMap[props.chartEntity] : panelLabels[props.chartEntity]
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.titleRight },
	          isAnalyticsEnabled && _react2.default.createElement(
	            'div',
	            { className: classes.dateSpan },
	            dateRange()
	          ),
	          _react2.default.createElement(_PanelDropdown2.default, {
	            panelName: props.chartEntity,
	            setCollapsed: props.onCollapse,
	            isCollapsed: props.panelData.isCollapsed,
	            onMovePanel: props.onMovePanel,
	            chartEntity: props.chartEntity,
	            chartIndex: props.chartIndex,
	            chartsCount: props.chartsCount,
	            isTop3EntitiesSelected: isTop3EntitiesSelected,
	            onToggleTop3Entities: toggleTop3Entities,
	            isChartEnabled: props.panelData.isChart,
	            onToggleChartEnabled: props.onChartToggle,
	            isAnalyticsEnabled: isAnalyticsEnabled
	          })
	        )
	      ),
	      isAnalyticsEnabled && props.panelData.isChart && !props.panelData.isCollapsed ? _react2.default.createElement(
	        'div',
	        {
	          className: props.panelData.isCollapsed ? classes.fadeInPanel__hide : classes.fadeInPanel__show
	        },
	        _react2.default.createElement(
	          'div',
	          { className: classes.chart },
	          _react2.default.createElement(_ChartPanel2.default, {
	            id: props.chartEntity + '-ChartPanel',
	            metric: 'hits',
	            selectedDataSource: [{
	              dimension: entityIdMap[props.chartEntity],
	              type: 'top',
	              limit: 3
	            }],
	            chartResp: props.chartData,
	            chartEntity: props.chartEntity,
	            isTop3EntitiesSelected: isTop3EntitiesSelected,
	            isLoading: isLoading,
	            isApiOwnerOrOrgPub: props.isApiOwnerOrOrgPub
	          })
	        )
	      ) : _react2.default.createElement(
	        'div',
	        {
	          className: props.panelData.isCollapsed ? classes.fadeInPanel__hide : classes.fadeInPanel__show
	        },
	        _react2.default.createElement(_GridPanelContainer2.default, {
	          isApiOwnerOrOrgPub: props.isApiOwnerOrOrgPub,
	          chartEntity: props.chartEntity,
	          analytics: isAnalyticsEnabled
	        })
	      )
	    )
	  );
	}
	
	ChartContainer.propTypes = {
	  isCollapsed: _propTypes2.default.bool,
	  chartEntity: _propTypes2.default.string,
	  onMovePanel: _propTypes2.default.func,
	  onCollapse: _propTypes2.default.func,
	  chartIndex: _propTypes2.default.number,
	  chartsCount: _propTypes2.default.number,
	  isApiOwnerOrOrgPub: _propTypes2.default.bool,
	  fetchDashboardChartData: _propTypes2.default.func,
	  panelData: _propTypes2.default.shape({
	    isChart: _propTypes2.default.bool,
	    isCollapsed: _propTypes2.default.bool
	  }),
	  onChartToggle: _propTypes2.default.func,
	  isAnalyticsEnabled: _propTypes2.default.bool,
	  chartData: _propTypes2.default.shape({
	    query: _propTypes2.default.shape({
	      startDate: _propTypes2.default.string,
	      endDate: _propTypes2.default.string
	    }),
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      key: _propTypes2.default.string,
	      value: _propTypes2.default.string
	    }))
	  })
	};

/***/ },
/* 1612 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    chartHeader: {
	      borderBottom: '1px solid ' + color.borderColor,
	      display: 'flex',
	      justifyContent: 'space-between',
	      margin: '0 36px',
	      paddingBottom: 8
	    },
	    chartTitle: {
	      color: color.pageTitle,
	      fontFamily: typography.pageTitle,
	      fontSize: fontSize.sectionTitle
	    },
	    titleRight: {
	      display: 'flex'
	    },
	    dateSpan: {
	      color: color.pageTitle,
	      fontFamily: typography.pageTitle,
	      fontSize: fontSize.smallTitle,
	      lineHeight: 1.6,
	      marginTop: 4
	    },
	    chartPanel: {
	      marginTop: 36,
	      marginBottom: 11
	    },
	    fadeInPanel__show: {
	      transition: 'all 0.5s ease-in',
	      opacity: 1,
	      borderBottom: '1px solid ' + color.borderColor
	    },
	    fadeInPanel__hide: {
	      height: 0,
	      overflow: 'hidden',
	      transition: 'all 0.5s ease-in',
	      opacity: 0
	    },
	    chart: {
	      paddingBottom: 24
	    }
	  };
	};

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DashboardChartLegend;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(615);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DashboardChartLegend() {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  return _react2.default.createElement(
	    'svg',
	    {
	      tabIndex: '0',
	      id: 'Chart_3rd_Button_Full_Interaction',
	      'data-name': 'Chart 3rd Button Full Interaction',
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: '18',
	      height: '18',
	      viewBox: '0 0 18 18',
	      className: classes.graphIcon
	    },
	    _react2.default.createElement('path', {
	      id: 'BG_-_ACTIVE',
	      'data-name': 'BG - ACTIVE',
	      d: 'M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z'
	    }),
	    _react2.default.createElement(
	      'g',
	      { id: 'Graph_icon', 'data-name': 'Graph icon', transform: 'translate(0 -1)' },
	      _react2.default.createElement('rect', {
	        id: 'Rectangle_668',
	        'data-name': 'Rectangle 668',
	        width: '12',
	        height: '2',
	        rx: '1',
	        transform: 'translate(3 12)',
	        className: classes.icon
	      }),
	      _react2.default.createElement('rect', {
	        id: 'Rectangle_824',
	        'data-name': 'Rectangle 824',
	        width: '3',
	        height: '2',
	        transform: 'translate(4 12) rotate(-90)',
	        className: classes.icon
	      }),
	      _react2.default.createElement('rect', {
	        id: 'Rectangle_825',
	        'data-name': 'Rectangle 825',
	        width: '7',
	        height: '2',
	        transform: 'translate(12 12) rotate(-90)',
	        className: classes.icon
	      }),
	      _react2.default.createElement('rect', {
	        id: 'Rectangle_826',
	        'data-name': 'Rectangle 826',
	        width: '5',
	        height: '2',
	        transform: 'translate(8 12) rotate(-90)',
	        className: classes.icon
	      })
	    )
	  );
	}

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = ChartLegend;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _graph_icon = __webpack_require__(1613);
	
	var _graph_icon2 = _interopRequireDefault(_graph_icon);
	
	var _labels = __webpack_require__(78);
	
	var _styles = __webpack_require__(615);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChartLegend(props) {
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      showOnChart = _useState2[0],
	      setShowOnChart = _useState2[1];
	
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var isTop3EntitiesSelected = props.isTop3EntitiesSelected;
	  var entity = props.entity,
	      rank = props.rank,
	      lineColor = props.lineColor,
	      chartEntity = props.chartEntity,
	      clickHandler = props.clickHandler,
	      hoverHandler = props.hoverHandler;
	
	  var mouseHover = function mouseHover(id, flag) {
	    if (!flag) {
	      document.activeElement.blur();
	    }
	    hoverHandler(id, flag);
	  };
	  var detailLinks = {
	    api: '/publish/apis/details/',
	    app: '/publish/applications/details/',
	    proxy: '/publish/api-proxy/details/',
	    org: '/admin/console/organizations/edit/'
	  };
	  var entityRankTitles = {
	    api: _labels.API,
	    app: _labels.APPLICATION,
	    org: _labels.ORGANIZATION,
	    proxy: _labels.PROXY
	  };
	  var isNonClickable = entity.id === _labels.UNAUTHORIZED || props.isApiOwnerOrOrgPub && (chartEntity === 'proxy' || chartEntity === 'org');
	  var navigateToEntity = function navigateToEntity(event, entityId) {
	    event.stopPropagation();
	    if (!isNonClickable) {
	      var url = 'https://' + window.location.hostname + detailLinks[chartEntity] + entityId;
	      window.location.href = url;
	    }
	  };
	  var navigateToEntityByKey = function navigateToEntityByKey(event, entityId) {
	    var code = event.keyCode || event.which;
	    if (code === 13) {
	      navigateToEntity(event, entityId);
	    }
	  };
	  var hideOrShowOnChart = function hideOrShowOnChart(event, id) {
	    event.stopPropagation();
	    setShowOnChart(!showOnChart);
	    clickHandler(id, true);
	  };
	  var classes = useStyles({ lineColor: lineColor, showOnChart: showOnChart, isNonClickable: isNonClickable });
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.legend,
	      onMouseEnter: function onMouseEnter() {
	        return mouseHover(entity.id, true);
	      },
	      onMouseLeave: function onMouseLeave() {
	        return mouseHover(entity.id, false);
	      },
	      onFocus: function onFocus() {
	        return mouseHover(entity.id, true);
	      },
	      onBlur: function onBlur() {
	        return mouseHover(entity.id, false);
	      },
	      onClick: function onClick(e) {
	        return navigateToEntity(e, entity.id);
	      },
	      onKeyDown: function onKeyDown(e) {
	        return navigateToEntityByKey(e, entity.id);
	      },
	      tabIndex: '0',
	      role: 'button'
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      isTop3EntitiesSelected && _react2.default.createElement(
	        'div',
	        { className: classes.relationship },
	        '#' + rank + ' ' + _labels.TRAFFIC + ' ' + entityRankTitles[chartEntity].toUpperCase()
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.title },
	        entity.names[0]
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.count },
	        entity.tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.graphIconContainer },
	      _react2.default.createElement(
	        'div',
	        { className: classes.tooltip },
	        _react2.default.createElement(
	          _core.IconButton,
	          {
	            onClick: function onClick(e) {
	              return hideOrShowOnChart(e, entity.id);
	            },
	            className: classes.graphIconHolder
	          },
	          _react2.default.createElement(_graph_icon2.default, { className: classes.graphIcon })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: classes.tooltiptext },
	          showOnChart ? _labels.REMOVE_FROM_CHART : _labels.ADD_TO_CHART
	        )
	      )
	    )
	  );
	}
	
	ChartLegend.propTypes = {
	  entity: _propTypes2.default.shape({}),
	  rank: _propTypes2.default.number,
	  chartEntity: _propTypes2.default.string,
	  clickHandler: _propTypes2.default.func,
	  hoverHandler: _propTypes2.default.func,
	  isTop3EntitiesSelected: _propTypes2.default.bool,
	  lineColor: _propTypes2.default.string,
	  isApiOwnerOrOrgPub: _propTypes2.default.bool
	};

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ChartLegendPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1616);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _ChartLegend = __webpack_require__(1614);
	
	var _ChartLegend2 = _interopRequireDefault(_ChartLegend);
	
	var _HorizontalScrollBar = __webpack_require__(610);
	
	var _HorizontalScrollBar2 = _interopRequireDefault(_HorizontalScrollBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChartLegendPanel(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var lineColors = props.lineColors,
	      chartData = props.chartData,
	      chartEntity = props.chartEntity,
	      clickHandler = props.clickHandler,
	      hoverHandler = props.hoverHandler;
	
	  return _react2.default.createElement(
	    _HorizontalScrollBar2.default,
	    { scrollEntity: chartEntity + 'LegendPanel' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.dashboardChartLegends },
	      chartData.slice(0, 3).map(function (item, index) {
	        return (
	          // taking only top 3 elements for the dashboard chart.
	          _react2.default.createElement(_ChartLegend2.default, {
	            tabIndex: '0',
	            entity: item,
	            rank: index + 1,
	            lineColor: lineColors[index],
	            chartEntity: chartEntity,
	            key: item.id,
	            clickHandler: clickHandler,
	            hoverHandler: hoverHandler,
	            isTop3EntitiesSelected: props.isTop3EntitiesSelected,
	            isApiOwnerOrOrgPub: props.isApiOwnerOrOrgPub
	          })
	        );
	      })
	    )
	  );
	}
	
	ChartLegendPanel.propTypes = {
	  lineColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  chartData: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  chartEntity: _propTypes2.default.string,
	  clickHandler: _propTypes2.default.func,
	  hoverHandler: _propTypes2.default.func,
	  isApiOwnerOrOrgPub: _propTypes2.default.bool
	};

/***/ },
/* 1616 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styles = function styles() {
	  return {
	    dashboardChartLegends: {
	      display: 'flex'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Skeleton = __webpack_require__(365);
	
	var _Skeleton2 = _interopRequireDefault(_Skeleton);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(30);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _CompositeXYChart = __webpack_require__(1622);
	
	var _CompositeXYChart2 = _interopRequireDefault(_CompositeXYChart);
	
	var _CustomLabelComponent = __webpack_require__(1624);
	
	var _CustomLabelComponent2 = _interopRequireDefault(_CustomLabelComponent);
	
	var _ChartLegendPanel = __webpack_require__(1615);
	
	var _ChartLegendPanel2 = _interopRequireDefault(_ChartLegendPanel);
	
	var _analytics_utils = __webpack_require__(617);
	
	var _permute = __webpack_require__(1645);
	
	var _styles2 = __webpack_require__(1618);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function changeSharedMutation(props, setSharedMutation) {
	  var chartResp = props.chartResp;
	
	  var data = chartResp && chartResp.data && chartResp.data.length ? chartResp.data : [];
	  if (data.length) {
	    var newSourcesIds = (0, _permute.getSourcesIdsFromResponseForCustomReport)(data, props.selectedDataSource);
	    var sharedMutationsObj = {};
	    // reset sharedMutations if sources changes
	    if (newSourcesIds.length > 0) {
	      sharedMutationsObj = (0, _permute.getDefaultSharedMutations)(newSourcesIds, 'CUSTOM_METRICS_CURRENT');
	      if (Object.keys(sharedMutationsObj).length) {
	        setSharedMutation(sharedMutationsObj);
	      }
	    }
	  }
	}
	function ChartPanelRaw(props) {
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      sharedMutations = _useState2[0],
	      setSharedMutation = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    changeSharedMutation(props, setSharedMutation);
	  }, [props.chartResp]);
	  var chartResp = props.chartResp,
	      theme = props.theme;
	
	  var getTimeData = function getTimeData(query, attr) {
	    var retVal = '';
	    if (query && attr) {
	      retVal = query[attr];
	    }
	    return retVal;
	  };
	  var getTimerange = function getTimerange(timePeriodStr) {
	    switch (timePeriodStr) {
	      case '7D':
	        return 'week';
	      case '24H':
	        return 'day';
	      default:
	        return 'custom';
	    }
	  };
	  var getDateRangeProps = function getDateRangeProps(response) {
	    var dateRangeData = {};
	    if (response && response.query && response.query) {
	      dateRangeData = {
	        timerange: getTimerange(getTimeData(response.query, 'period')),
	        timeAgg: getTimeData(response.query, 'aggregation'),
	        startDate: getTimeData(response.query, 'startDate'),
	        endDate: getTimeData(response.query, 'endDate')
	      };
	    }
	    return dateRangeData;
	  };
	
	  var getPointlevelData = function getPointlevelData(xAxisDates, dataPoints, dateRangeProps, tooltipLabel) {
	    var data = [];
	    var metric = props.metric;
	
	    if (_lodash2.default.isUndefined(xAxisDates) || _lodash2.default.isUndefined(dataPoints)) {
	      return data;
	    }
	    _lodash2.default.each(xAxisDates, function (day, index) {
	      var date = (0, _moment2.default)(day);
	      var value = 0;
	      _lodash2.default.each(dataPoints, function (item) {
	        if (date.isSame((0, _moment2.default)(item.date))) {
	          if (metric === 'latency') {
	            value = item.avg;
	          } else if (metric === 'hits') {
	            value = item.count;
	          }
	        }
	      });
	      var timerange = dateRangeProps.timerange,
	          timeAgg = dateRangeProps.timeAgg,
	          startDate = dateRangeProps.startDate,
	          endDate = dateRangeProps.endDate;
	
	      var dateTimeStr = (0, _analytics_utils.getDisplayDate)(_moment2.default.utc(day).toISOString(), timerange, 'by-' + timeAgg, startDate, endDate, 'tooltip');
	      data.push({
	        x: index,
	        y: value,
	        label: tooltipLabel.join(' > ') + '\n\n' + 'Hits' + ': ' + value + '\n' + 'Date time (UTC)' + ':\n' + dateTimeStr + '\n'
	      });
	    });
	    return data;
	  };
	  var createCustomLabelComponent = function createCustomLabelComponent(styles) {
	    var StyledCustomLabelComponent = (0, _CustomLabelComponent2.default)(styles);
	    return _react2.default.createElement(StyledCustomLabelComponent, null);
	  };
	  var TooltipStyle = {
	    fill: 'white',
	    fontSize: 10, // please test tooltips, as changing font sizes affect layout
	    paddingLeft: 10,
	    textAnchor: 'left',
	    fontFamily: _lodash2.default.get(theme, 'typography.bodyText'),
	    fontFamilyBold: _lodash2.default.get(theme, 'typography.pageTitle')
	  };
	  var getChartData = function getChartData(response, xAxisData, selectedDataSource) {
	    var chartData = [];
	    var metric = props.metric;
	
	    if (!response || !response.data || !xAxisData) {
	      return chartData;
	    }
	    var data = [];
	    var dateRangeProps = getDateRangeProps(response);
	    _lodash2.default.each(response.data, function (combination, index) {
	      var entitiesArray = [];
	      if (selectedDataSource.length) {
	        selectedDataSource.forEach(function (datasource) {
	          return entitiesArray.push(datasource.dimension);
	        });
	      }
	      var entitiesStr = entitiesArray.join(',');
	      var permuteObject = (0, _permute.getBucketPermuteIdAndNamesForCustomReport)(combination, entitiesStr, props.chartEntity);
	      var tooltipLabel = permuteObject.tooltipLabel.length ? permuteObject.tooltipLabel : permuteObject.names;
	      data = getPointlevelData(xAxisData.xAxisTickValuesMap, combination.buckets, dateRangeProps, tooltipLabel);
	      var combinationAggregation = metric === 'hits' ? combination.count : combination.avg;
	      if (data.length && combinationAggregation && combination.buckets.length) {
	        chartData.push({
	          customLabelComponent: createCustomLabelComponent(TooltipStyle),
	          id: permuteObject.permuteId,
	          names: permuteObject.names,
	          data: data,
	          legendTooltipLabel: tooltipLabel,
	          tooltipData: combinationAggregation,
	          type: 'CHART_ELEMENT_LINE',
	          colorIndex: index
	        });
	      }
	    });
	    return chartData;
	  };
	
	  var getLineChartsData = function getLineChartsData(chartData, metric) {
	    var lineCharts = [];
	    _lodash2.default.forEach(chartData, function (item) {
	      var id = item.id,
	          data = item.data,
	          names = item.names,
	          customLabelComponent = item.customLabelComponent,
	          tooltipData = item.tooltipData;
	      var colorIndex = item.colorIndex;
	
	      var lineData = [];
	      var sourceMutation = sharedMutations[id] || {};
	      if (sourceMutation && sourceMutation.colorIndex !== undefined) {
	        colorIndex = sourceMutation.colorIndex;
	      }
	      var metricsMutation = sourceMutation.metrics || {};
	
	      var metricMutation = metricsMutation[metric] || {};
	      var highLight = !!metricMutation.hover;
	      if (!sourceMutation.show || !metricMutation.show) {
	        return;
	      }
	      _lodash2.default.forEach(data, function (dataItem) {
	        var x = dataItem.x,
	            y = dataItem.y,
	            label = dataItem.label;
	
	        lineData.push({
	          label: label,
	          x: x,
	          y: y
	        });
	      });
	      lineCharts.push({
	        colorIndex: colorIndex,
	        customLabelComponent: customLabelComponent,
	        data: lineData,
	        highLight: highLight,
	        id: id,
	        names: names,
	        metric: metric,
	        tooltipData: tooltipData,
	        type: 'CHART_ELEMENT_LINE'
	      });
	    });
	    // taking only top 3 elements for the dashboard chart
	    return lineCharts.slice(0, 3);
	  };
	  var legendClickHandler = function legendClickHandler(key) {
	    var sourceMutation = sharedMutations && sharedMutations[key] || {};
	    var updatedMutations = sharedMutations;
	    updatedMutations = Object.assign({}, sharedMutations, _defineProperty({}, key, Object.assign({}, sourceMutation, {
	      show: !sourceMutation.show
	    })));
	    setSharedMutation(updatedMutations);
	  };
	  var legendHoverHandler = function legendHoverHandler(key, hoverState) {
	    var currentSharedMutations = sharedMutations || {};
	    var sourceMutation = currentSharedMutations && currentSharedMutations[key] || {};
	    var metric = 'CUSTOM_METRICS_CURRENT';
	    var metricsMutation = sourceMutation && sourceMutation.metrics || {};
	    if (hoverState) {
	      currentSharedMutations = (0, _analytics_utils.clearMetricsHoverState)(currentSharedMutations);
	    }
	    var metricMutation = metricsMutation && metricsMutation[metric] || {};
	    var updatedMutations = Object.assign({}, currentSharedMutations, _defineProperty({}, key, Object.assign({}, sourceMutation, {
	      metrics: Object.assign({}, metricsMutation, _defineProperty({}, metric, Object.assign({}, metricMutation, {
	        hover: hoverState
	      })))
	    })));
	    setSharedMutation(updatedMutations);
	  };
	  var chartHoverHandler = function chartHoverHandler(id, hoverState) {
	    legendHoverHandler(id, hoverState);
	  };
	  var getXAxisFormatter = function getXAxisFormatter(item, dateRangeObj) {
	    var xAxisTickValuesMap = dateRangeObj.xAxisTickValuesMap;
	    if (xAxisTickValuesMap[item]) {
	      return (0, _analytics_utils.getDisplayDate)(xAxisTickValuesMap[item], dateRangeObj.dateRange, 'by-' + dateRangeObj.timeAgg, dateRangeObj.startDate, dateRangeObj.endDate);
	    }
	    return '';
	  };
	  var chartScale = { x: 'time' };
	
	  var _getDateRangeProps = getDateRangeProps(chartResp),
	      timerange = _getDateRangeProps.timerange,
	      timeAgg = _getDateRangeProps.timeAgg,
	      startDate = _getDateRangeProps.startDate,
	      endDate = _getDateRangeProps.endDate;
	
	  var dateRangeData = (0, _analytics_utils.getDateRangeData)(timerange, timeAgg, startDate, endDate);
	  var chartData = getChartData(chartResp, dateRangeData, props.selectedDataSource);
	  var lineChartData = getLineChartsData(chartData, 'CUSTOM_METRICS_CURRENT');
	  var classes = props.classes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.chartContainer },
	    _react2.default.createElement(
	      'div',
	      { className: classes.chartBody },
	      props.isLoading ? _react2.default.createElement(_Skeleton2.default, { variant: 'rect', animation: 'wave', className: classes.loadingLegends }) : _react2.default.createElement(_ChartLegendPanel2.default, {
	        chartData: chartData,
	        lineColors: _analytics_utils.lineColors,
	        chartEntity: props.chartEntity,
	        clickHandler: legendClickHandler,
	        hoverHandler: legendHoverHandler,
	        isTop3EntitiesSelected: props.isTop3EntitiesSelected,
	        isApiOwnerOrOrgPub: props.isApiOwnerOrOrgPub
	      }),
	      props.isLoading ? _react2.default.createElement(
	        'div',
	        { className: classes.loader },
	        _react2.default.createElement(_core.CircularProgress, null)
	      ) : _react2.default.createElement(_CompositeXYChart2.default, {
	        chartData: lineChartData,
	        chartScale: chartScale,
	        formatXAxisData: function formatXAxisData(item) {
	          return getXAxisFormatter(item, dateRangeData);
	        },
	        lineColors: _analytics_utils.lineColors,
	        lightShadeLineColors: _analytics_utils.lightShadeLineColors,
	        xAxisValues: dateRangeData.xAxisTickValues,
	        hoverHandler: chartHoverHandler
	      })
	    )
	  );
	}
	
	ChartPanelRaw.propTypes = {
	  chartResp: _propTypes2.default.shape({}),
	  selectedDataSource: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  classes: _propTypes2.default.shape({}),
	  isTop3EntitiesSelected: _propTypes2.default.bool,
	  chartEntity: _propTypes2.default.string,
	  isLoading: _propTypes2.default.bool,
	  isApiOwnerOrOrgPub: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({})
	};
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles3.default))((0, _styles.withTheme)(ChartPanelRaw));

/***/ },
/* 1618 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Copyright (c) 2017 CA. All rights reserved.
	 * This software may be modified and distributed under the terms
	 * of the MIT license. See the LICENSE file for details.
	 */
	
	exports.default = function (_ref) {
	  var color = _ref.color;
	  return {
	    chartBody: {
	      width: '100%',
	      borderRight: '1px solid ' + color.borderColorLight,
	      display: 'inline-block',
	      paddingLeft: 20,
	      boxSizing: 'border-box',
	      '& svg': {
	        overflow: 'visible !important',
	        height: 'auto'
	      },
	      '& .VictoryContainer': {
	        bottom: 22,
	        display: 'flex',
	        '& div:last-child': {
	          height: '100%',
	          display: 'flex'
	        }
	      },
	      '@media print': {
	        height: '40vw',
	        width: '100%',
	        borderRight: '0px solid ' + color.borderColorLight
	      }
	    },
	    loader: {
	      textAlign: 'center',
	      height: 400,
	      marginTop: 100,
	      '& .MuiCircularProgress-colorPrimary': {
	        color: color.link
	      }
	    },
	    loadingLegends: {
	      height: 90,
	      width: '96%',
	      marginTop: 16,
	      marginLeft: 16,
	      marginRight: 16
	    }
	  };
	};

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(8);
	
	var _victory = __webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function wordWrap(str) {
	  var contentLength = str.length;
	  var charLimit = 40;
	  if (contentLength > charLimit && contentLength - charLimit > 5) {
	    var numOfSubstr = Math.ceil(contentLength / charLimit);
	    var newContent = Array(numOfSubstr).fill(0).map(function (ele, i) {
	      var index = i;
	      index *= charLimit;
	      if (str.charAt(index + charLimit)) {
	        return str.substring(index, index + charLimit);
	      }
	      return str.substring(index);
	    });
	    return newContent;
	  }
	  return [str];
	}
	
	var ChartTooltipRaw = function ChartTooltipRaw(customLabelComponent, labelKey, active, theme) {
	  var style = {
	    fontSize: 10, // please test tooltips, as changing font sizes affect layout
	    fontFamily: (0, _lodash.get)(theme, 'typography.bodyText'),
	    textAnchor: 'start',
	    padding: 10
	  };
	  return _react2.default.createElement(_victory.VictoryTooltip, {
	    flyoutStyle: {
	      fill: '#313233',
	      stroke: 'none'
	    },
	    labelComponent: customLabelComponent,
	    text: function text(_ref) {
	      var datum = _ref.datum;
	
	      var labelText = datum && (labelKey ? datum[labelKey] : datum.label) || '';
	      if (!active) {
	        labelText = '';
	      }
	      labelText = labelText && labelText.split('\n') || [''];
	      var newContent = wordWrap(labelText[0]);
	      labelText.shift();
	      return [].concat(_toConsumableArray(newContent), _toConsumableArray(labelText));
	    },
	    style: style,
	    pointerLength: 5,
	    pointerWidth: 5,
	    cornerRadius: 2
	  });
	};
	
	exports.default = ChartTooltipRaw;

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = Charts;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _ChartContainer = __webpack_require__(1611);
	
	var _ChartContainer2 = _interopRequireDefault(_ChartContainer);
	
	var _styles = __webpack_require__(1621);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Charts(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var fetchDashboardChartData = props.fetchDashboardChartData,
	      isOrgPublisher = props.isOrgPublisher,
	      isPortalAdmin = props.isPortalAdmin,
	      isApiOwner = props.isApiOwner;
	
	  var defaultPanels = isOrgPublisher || isPortalAdmin ? ['api', 'org', 'proxy', 'app'] : ['api', 'app'];
	
	  var _useState = (0, _react.useState)(defaultPanels),
	      _useState2 = _slicedToArray(_useState, 2),
	      panels = _useState2[0],
	      setPanels = _useState2[1];
	
	  var defaultPanelObject = { isCollapsed: false, isChart: true };
	  var defaultPanelData = { api: defaultPanelObject, app: defaultPanelObject };
	  if (isOrgPublisher || isPortalAdmin) {
	    defaultPanelData.org = defaultPanelObject;
	    defaultPanelData.proxy = defaultPanelObject;
	  }
	
	  var _useState3 = (0, _react.useState)(defaultPanelData),
	      _useState4 = _slicedToArray(_useState3, 2),
	      panelData = _useState4[0],
	      setPanelData = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    var cookieStr = (0, _utils.readCookie)('panels');
	    if (cookieStr) {
	      var cookie = JSON.parse(cookieStr);
	      if (cookie.cookiePanels) {
	        setPanels(cookie.cookiePanels);
	      }
	      if (cookie.cookiePanelData) {
	        setPanelData(cookie.cookiePanelData);
	      }
	    }
	  }, []);
	
	  var updateCookie = function updateCookie(cookiePanels, cookiePanelData) {
	    var cookieObj = {
	      cookiePanels: cookiePanels, cookiePanelData: cookiePanelData
	    };
	    (0, _utils.createCookie)('panels', JSON.stringify(cookieObj), 365, '/admin');
	  };
	  var movePanel = function movePanel(panelName, up) {
	    var index = panels.indexOf(panelName);
	    var moveTo = up ? index - 1 : index + 1;
	    if (!(up && index === 0) && !(!up && index === panels.length - 1)) {
	      var updatePanels = JSON.parse(JSON.stringify(panels));
	      updatePanels.splice(moveTo, 0, updatePanels.splice(index, 1)[0]);
	      setPanels(updatePanels);
	      updateCookie(updatePanels, panelData);
	    }
	  };
	  var collapsePanel = function collapsePanel(panelName) {
	    var tempPanelData = JSON.parse(JSON.stringify(panelData));
	    tempPanelData[panelName].isCollapsed = !tempPanelData[panelName].isCollapsed;
	    setPanelData(tempPanelData);
	    updateCookie(panels, tempPanelData);
	  };
	  var chartToggled = function chartToggled(panelName) {
	    var tempPanelData = JSON.parse(JSON.stringify(panelData));
	    tempPanelData[panelName].isChart = !tempPanelData[panelName].isChart;
	    setPanelData(tempPanelData);
	    updateCookie(panels, tempPanelData);
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: classes.charts },
	    panels.map(function (name, index) {
	      return _react2.default.createElement(_ChartContainer2.default, {
	        chartEntity: name,
	        chartObject: panels[name],
	        onMovePanel: movePanel,
	        onCollapse: collapsePanel,
	        onChartToggle: chartToggled,
	        panelData: panelData[name] || { isCollapsed: false, isChart: true },
	        chartIndex: index,
	        key: name,
	        chartsCount: panels.length,
	        fetchDashboardChartData: fetchDashboardChartData,
	        chartData: props.chartData[name],
	        isAnalyticsEnabled: props.isAnalyticsEnabled,
	        isApiOwnerOrOrgPub: isApiOwner || isOrgPublisher
	      });
	    })
	  );
	}
	
	Charts.propTypes = {
	  fetchDashboardChartData: _propTypes2.default.func,
	  isOrgPublisher: _propTypes2.default.bool,
	  isPortalAdmin: _propTypes2.default.bool,
	  isApiOwner: _propTypes2.default.bool,
	  isAnalyticsEnabled: _propTypes2.default.bool
	};

/***/ },
/* 1621 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    charts: {
	      paddingBottom: 2,
	      marginBottom: 34
	    }
	  };
	};

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victory = __webpack_require__(305);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(30);
	
	var _styles2 = __webpack_require__(1623);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	var _ChartTooltip = __webpack_require__(1619);
	
	var _ChartTooltip2 = _interopRequireDefault(_ChartTooltip);
	
	var _analytics_utils = __webpack_require__(617);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import sizeMe from 'react-sizeme';
	
	
	var STROKE_HIGHLIGHT_WIDTH = 3;
	var STROKE_NORMAL_WIDTH = 2;
	
	var getYAxisFormatter = function getYAxisFormatter(yAxisObj) {
	  return function (item) {
	    if (item === 0) {
	      return '' + item;
	    } else if (yAxisObj.paddingFactor === 1) {
	      return item + ' ' + yAxisObj.suffix;
	    }
	    var result = (item / yAxisObj.paddingFactor).toFixed(0);
	    return result + ' ' + yAxisObj.suffix;
	  };
	};
	
	var getYAxisValues = function getYAxisValues(chartData) {
	  var yMax = -1000;
	  _lodash2.default.each(chartData, function (line) {
	    var yVal = line.type === 'CHART_ELEMENT_AREA' ? 'high' : 'y';
	    _lodash2.default.each(line && line.data, function (item) {
	      yMax = item[yVal] > yMax ? item[yVal] : yMax;
	    });
	  });
	  yMax = yMax === 0 ? 1 : yMax;
	
	  return (0, _analytics_utils.getYAxisTicks)(yMax);
	};
	
	var renderAreaElement = function renderAreaElement(elementData, idx, lineColors, theme) {
	  var highLight = elementData.highLight,
	      colorIndex = elementData.colorIndex,
	      data = elementData.data,
	      customLabelComponent = elementData.customLabelComponent,
	      id = elementData.id,
	      metric = elementData.metric;
	
	  var idMetricStr = id + '___' + metric;
	  var _strokeWidth = highLight ? STROKE_HIGHLIGHT_WIDTH : STROKE_NORMAL_WIDTH;
	  var scatterOpacity = highLight || data.length === 1 ? 1 : 0;
	  var upperLineName = idx + '-area-upper-line____' + idMetricStr;
	  var upperScatterName = idx + '-area-upper-scatter____' + idMetricStr;
	  var areaName = idx + '-area____' + idMetricStr;
	  var lowerLineName = idx + '-area-lower-line____' + idMetricStr;
	  var lowerScatterName = idx + '-area-lower-scatter____' + idMetricStr;
	  return _react2.default.createElement(
	    _victory.VictoryGroup,
	    { key: id + '-' + metric },
	    highLight && _react2.default.createElement(_victory.VictoryLine, {
	      name: upperLineName,
	      y: 'high',
	      data: data,
	      labelComponent: (0, _ChartTooltip2.default)(customLabelComponent, '', highLight, theme),
	      style: {
	        data: {
	          stroke: function stroke() {
	            return (0, _analytics_utils.getStrokeColor)(lineColors, colorIndex);
	          },
	          strokeWidth: function strokeWidth() {
	            return _strokeWidth;
	          }
	        }
	      }
	    }),
	    _react2.default.createElement(_victory.VictoryScatter, {
	      data: data,
	      symbol: 'circle',
	      name: upperScatterName,
	      size: 3,
	      style: {
	        data: {
	          fill: (0, _analytics_utils.getStrokeColor)(lineColors, colorIndex),
	          fillOpacity: function fillOpacity() {
	            return scatterOpacity;
	          }
	        }
	      },
	      labels: function labels(datum) {
	        return datum.y;
	      },
	      labelComponent: (0, _ChartTooltip2.default)(customLabelComponent, 'highLabel', highLight, theme),
	      y: 'high'
	    }),
	    _react2.default.createElement(_victory.VictoryArea, {
	      data: data,
	      name: areaName,
	      y: 'high',
	      y0: 'low',
	      style: {
	        data: {
	          fill: (0, _analytics_utils.getStrokeColor)(lineColors, colorIndex),
	          opacity: 0.2
	        }
	      },
	      labelComponent: (0, _ChartTooltip2.default)(customLabelComponent, '', highLight, theme)
	    }),
	    highLight && _react2.default.createElement(_victory.VictoryLine, {
	      name: lowerLineName,
	      y: 'low',
	      data: data,
	      labelComponent: (0, _ChartTooltip2.default)(customLabelComponent, '', highLight, theme),
	      style: {
	        data: {
	          stroke: (0, _analytics_utils.getStrokeColor)(lineColors, colorIndex),
	          strokeWidth: function strokeWidth() {
	            return _strokeWidth;
	          }
	        }
	      }
	    }),
	    _react2.default.createElement(_victory.VictoryScatter, {
	      data: data,
	      y: 'low',
	      symbol: 'circle',
	      name: lowerScatterName,
	      size: 3,
	      style: {
	        data: {
	          fill: (0, _analytics_utils.getStrokeColor)(lineColors, colorIndex),
	          fillOpacity: function fillOpacity() {
	            return scatterOpacity;
	          }
	        }
	      },
	      labels: function labels(datum) {
	        return datum.y;
	      },
	      labelComponent: (0, _ChartTooltip2.default)(customLabelComponent, 'lowLabel', highLight, theme)
	    })
	  );
	};
	
	var renderLineElement = function renderLineElement(elementData, idx, lineColors, lightShadeLineColors, theme) {
	  var highLight = elementData.highLight,
	      colorIndex = elementData.colorIndex,
	      id = elementData.id,
	      metric = elementData.metric,
	      useLightShadedColor = elementData.useLightShadedColor;
	
	  var idMetricStr = id + '___' + metric;
	  var _strokeWidth2 = highLight ? STROKE_HIGHLIGHT_WIDTH : STROKE_NORMAL_WIDTH;
	  var scatterOpacity = highLight || elementData && elementData.data && elementData.data.length === 1 ? 1 : 0;
	  var lineName = idx + '-line____' + idMetricStr;
	  var scatterName = idx + '-scatter____' + idMetricStr;
	  var strokeDashArray = elementData.pattern === 'dashed' ? '4,4' : null;
	  var colors = useLightShadedColor ? lightShadeLineColors : lineColors;
	  return _react2.default.createElement(
	    _victory.VictoryGroup,
	    { key: id + '-' + metric },
	    _react2.default.createElement(_victory.VictoryLine, {
	      data: elementData.data,
	      labelComponent: (0, _ChartTooltip2.default)(),
	      name: lineName,
	      style: {
	        data: {
	          strokeDasharray: strokeDashArray,
	          stroke: (0, _analytics_utils.getStrokeColor)(colors, colorIndex),
	          strokeWidth: function strokeWidth() {
	            return _strokeWidth2;
	          }
	        }
	      }
	    }),
	    _react2.default.createElement(_victory.VictoryScatter, {
	      data: elementData.data,
	      symbol: 'circle',
	      name: scatterName,
	      size: 3,
	      style: {
	        data: {
	          fill: (0, _analytics_utils.getStrokeColor)(colors, colorIndex),
	          fillOpacity: function fillOpacity() {
	            return scatterOpacity;
	          }
	        }
	      },
	      labels: function labels(datum) {
	        return datum.y;
	      },
	      labelComponent: (0, _ChartTooltip2.default)(elementData.customLabelComponent, '', highLight, theme)
	    })
	  );
	};
	
	var renderChartElement = function renderChartElement(elementData, idx, lineColors, lightShadeLineColors, theme) {
	  if (elementData.type === 'CHART_ELEMENT_AREA') {
	    return renderAreaElement(elementData, idx, lineColors, theme);
	  }
	  return renderLineElement(elementData, idx, lineColors, lightShadeLineColors, theme);
	};
	
	var CompositeXYChartRaw = function (_Component) {
	  _inherits(CompositeXYChartRaw, _Component);
	
	  function CompositeXYChartRaw(props) {
	    _classCallCheck(this, CompositeXYChartRaw);
	
	    var _this = _possibleConstructorReturn(this, (CompositeXYChartRaw.__proto__ || Object.getPrototypeOf(CompositeXYChartRaw)).call(this, props));
	
	    _this.state = {
	      activeCharts: {},
	      windowWidth: window.innerWidth
	    };
	
	    _this.activationChangeHandler = function (points, hoverHandler, activated) {
	      var idMetricMap = {};
	      _lodash2.default.each(points, function (point) {
	        idMetricMap[point.childName.split('____')[1]] = true;
	      });
	      var updatedActiveCharts = _this.state.activeCharts;
	      _lodash2.default.each(idMetricMap, function (value, idMetricCombination) {
	        var id = idMetricCombination.split('___')[0];
	        var count = updatedActiveCharts[idMetricCombination] || 0;
	        if (activated) {
	          count++;
	          hoverHandler(id, true);
	        } else {
	          count--;
	          if (count === 0) {
	            hoverHandler(id, false);
	          }
	        }
	        updatedActiveCharts[idMetricCombination] = count;
	      });
	      _this.setState({
	        activeCharts: updatedActiveCharts
	      });
	    };
	
	    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(CompositeXYChartRaw, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateWindowDimensions();
	      window.addEventListener('resize', this.updateWindowDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateWindowDimensions);
	    }
	  }, {
	    key: 'updateWindowDimensions',
	    value: function updateWindowDimensions() {
	      this.setState({ windowWidth: window.innerWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          chartData = _props.chartData,
	          chartScale = _props.chartScale,
	          formatXAxisData = _props.formatXAxisData,
	          _props$hoverHandler = _props.hoverHandler,
	          hoverHandler = _props$hoverHandler === undefined ? function () {} : _props$hoverHandler,
	          lineColors = _props.lineColors,
	          lightShadeLineColors = _props.lightShadeLineColors,
	          theme = _props.theme,
	          xAxisLabel = _props.xAxisLabel,
	          xAxisValues = _props.xAxisValues,
	          yAxisLabel = _props.yAxisLabel;
	
	      var yAxisObj = getYAxisValues(chartData);
	      var yAxisValues = !_lodash2.default.isEmpty(yAxisObj) ? yAxisObj.yTicks : [];
	      return _react2.default.createElement(
	        _victory.VictoryChart,
	        {
	          containerComponent: _react2.default.createElement(_victory.VictoryVoronoiContainer, {
	            onActivated: function onActivated(points) {
	              return _this2.activationChangeHandler(points, hoverHandler, true);
	            },
	            onDeactivated: function onDeactivated(points) {
	              return _this2.activationChangeHandler(points, hoverHandler, false);
	            },
	            radius: 50,
	            responsive: false
	          }),
	          domainPadding: { x: 5 },
	          padding: { top: 100, bottom: 0, right: 20, left: 25 },
	          width: this.state.windowWidth - 135,
	          scale: chartScale
	        },
	        _react2.default.createElement(_victory.VictoryAxis, {
	          tickValues: xAxisValues,
	          tickCount: 24,
	          width: 900,
	          tickFormat: function tickFormat(tick) {
	            return formatXAxisData(tick);
	          },
	          label: xAxisLabel,
	          axisLabelComponent: _react2.default.createElement(_victory.VictoryLabel, {
	            dy: 10
	          }),
	          style: {
	            ticks: { stroke: theme.color.bodyText, size: 5 },
	            tickLabels: {
	              fontSize: theme.fontSize.bodyText,
	              fontFamily: theme.typography.bodyText,
	              fill: theme.color.bodyText
	            },
	            axis: { stroke: theme.color.bodyText }
	          },
	          fixLabelOverlap: true
	        }),
	        _react2.default.createElement(_victory.VictoryAxis, {
	          tickValues: yAxisValues,
	          tickFormat: getYAxisFormatter(yAxisObj),
	          dependentAxis: true,
	          label: yAxisLabel,
	          tickLabelComponent: _react2.default.createElement(_victory.VictoryLabel, { dy: -10 }),
	          domainPadding: 0,
	          style: {
	            tickLabels: {
	              fontSize: theme.fontSize.bodyText,
	              fontFamily: theme.typography.bodyText,
	              fill: theme.color.bodyText,
	              padding: -25
	            },
	            grid: { stroke: theme.color.bodyText },
	            axis: { display: 'none' }
	          }
	        }),
	        chartData.map(function (elementData, idx) {
	          return renderChartElement(elementData, idx, lineColors, lightShadeLineColors, theme);
	        })
	      );
	    }
	  }]);
	
	  return CompositeXYChartRaw;
	}(_react.Component);
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles3.default))((0, _styles.withTheme)(CompositeXYChartRaw));

/***/ },
/* 1623 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Copyright (c) 2017 CA. All rights reserved.
	 * This software may be modified and distributed under the terms
	 * of the MIT license. See the LICENSE file for details.
	 */
	
	exports.default = function () {
	  return {
	    chart: {
	      width: '95%'
	    }
	  };
	};

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var labelComponent = function labelComponent(styles) {
	  return function (_ref) {
	    var text = _ref.text,
	        x = _ref.x,
	        y = _ref.y;
	
	    var capHeight = 1.71;
	    var fontSize = styles.fontSize,
	        textAnchor = styles.textAnchor,
	        fill = styles.fill,
	        fontFamily = styles.fontFamily,
	        fontFamilyBold = styles.fontFamilyBold;
	
	    var contentLength = text.length;
	    var titleLength = 0;
	    for (var i = 0; i < contentLength; i++) {
	      if (text[i] !== '') {
	        titleLength++;
	      } else {
	        break;
	      }
	    }
	
	    var dy = (capHeight / 2 + (0.5 - contentLength) / 2 /*  * linedHeight */) * 9;
	    var tspanElements = text.map(function (line, index) {
	      var spanDy = void 0;
	      switch (true) {
	        case index === 0:
	          spanDy = undefined;
	          break;
	        case text[index - 1] === '':
	          spanDy = 2 * fontSize;
	          break;
	        default:
	          spanDy = fontSize;
	          break;
	      }
	      var key = 'tspan__' + index;
	      return _react2.default.createElement(
	        'tspan',
	        {
	          key: key,
	          dy: spanDy,
	          dx: 0,
	          x: x,
	          fontSize: fontSize,
	          textAnchor: textAnchor,
	          fill: fill,
	          fontFamily: index <= titleLength ? fontFamilyBold : fontFamily
	        },
	        line
	      );
	    });
	    return _react2.default.createElement(
	      'text',
	      { textAnchor: textAnchor, x: x, y: y, dy: dy },
	      tspanElements
	    );
	  };
	};
	
	exports.default = labelComponent;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EntityCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1626);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _labels = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EntityCard(_ref) {
	  var entity = _ref.entity,
	      isPortalAdmin = _ref.isPortalAdmin;
	
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	
	  var entityTitles = {
	    APIs: _labels.APIS_LABEL,
	    APIPlans: _labels.API_PLANS_LABEL,
	    APIGroups: _labels.API_GROUPS_LABEL,
	    Organizations: _labels.ORGANIZATIONS_LABEL,
	    Users: _labels.USERS_LABEL,
	    Applications: _labels.APPLICATIONS_LABEL,
	    Proxies: _labels.PROXIES_LABEL,
	    AccountPlans: _labels.ACCOUNT_PLANS_LABEL
	  };
	
	  var entityDetailsPageUrlMap = {
	    APIs: 'https://' + window.location.hostname + '/publish/apis',
	    APIPlans: 'https://' + window.location.hostname + '/admin/apis/api-plans',
	    Applications: isPortalAdmin ? 'https://' + window.location.hostname + '/admin/applications' : 'https://' + window.location.hostname + '/admin/app/applications',
	    Organizations: 'https://' + window.location.hostname + '/admin/console/organizations',
	    Users: 'https://' + window.location.hostname + '/admin/console/users',
	    APIGroups: 'https://' + window.location.hostname + '/admin/api-groups',
	    Proxies: 'https://' + window.location.hostname + '/admin/api-proxy',
	    AccountPlans: 'https://' + window.location.hostname + '/admin/organizations/account-plans'
	  };
	
	  var entityAddPageUrlMap = {
	    APIs: 'https://' + window.location.hostname + '/publish/apis/add',
	    APIPlans: 'https://' + window.location.hostname + '/admin/apis/api-plans#add',
	    Applications: 'https://' + window.location.hostname + '/publish/applications/add',
	    Organizations: 'https://' + window.location.hostname + '/admin/console/organizations/add',
	    Users: 'https://' + window.location.hostname + '/admin/users#add',
	    APIGroups: 'https://' + window.location.hostname + '/admin/api-groups#add',
	    Proxies: 'https://' + window.location.hostname + '/publish/api-proxy/add',
	    AccountPlans: 'https://' + window.location.hostname + '/admin/organizations/account-plans#add'
	  };
	
	  var entityAddHelp = {
	    APIs: _labels.API,
	    Applications: _labels.APPLICATION,
	    Organizations: _labels.ORGANIZATION,
	    Users: _labels.USER,
	    APIGroups: _labels.API_GROUP,
	    APIPlans: _labels.API_PLAN,
	    Proxies: _labels.PROXY,
	    AccountPlans: _labels.ACCOUNT_PLAN
	  };
	
	  var handleCardClick = function handleCardClick(event, entityName) {
	    event.stopPropagation();
	    var href = entityDetailsPageUrlMap[entityName];
	    window.location.href = href;
	  };
	
	  var handleAddButtonClick = function handleAddButtonClick(event, entityName) {
	    event.stopPropagation();
	    var href = entityAddPageUrlMap[entityName];
	    window.location.href = href;
	  };
	  var handleEnterKey = function handleEnterKey(event, entityName, isCard) {
	    var code = event.keyCode || event.which;
	    if (code === 13) {
	      if (isCard) {
	        handleCardClick(event, entityName);
	      } else {
	        handleAddButtonClick(event, entityName);
	      }
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    {
	      tabIndex: '0',
	      className: classes.card,
	      onClick: function onClick(e) {
	        return handleCardClick(e, entity.entity);
	      },
	      onKeyDown: function onKeyDown(e) {
	        return handleEnterKey(e, entity.entity, true);
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: classes.entityTitle },
	      entityTitles[entity.entity]
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.entityCount },
	      entity.count
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.addButtonContainer },
	      entity.hasAddPermission ? _react2.default.createElement(
	        'div',
	        { className: classes.tooltip },
	        _react2.default.createElement(
	          'div',
	          {
	            onClick: function onClick(e) {
	              return handleAddButtonClick(e, entity.entity);
	            },
	            onKeyDown: function onKeyDown(e) {
	              return handleEnterKey(e, entity.entity, false);
	            },
	            className: classes.addButton,
	            tabIndex: '0'
	          },
	          '+'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: classes.tooltiptext },
	          'Add ',
	          entityAddHelp[entity.entity]
	        )
	      ) : null
	    )
	  );
	}
	
	EntityCard.propTypes = {
	  entity: _propTypes2.default.shape({}),
	  isPortalAdmin: _propTypes2.default.bool
	};

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    card: {
	      minWidth: 150,
	      height: 116,
	      justifyContent: 'center',
	      boxSizing: 'border-box',
	      flexGrow: 1,
	      borderLeft: '1px solid ' + color.borderColor,
	      borderTop: '1px solid ' + color.borderColor,
	      borderBottom: '1px solid ' + color.borderColor,
	      flexDirection: 'column',
	      alignItems: 'flex-end',
	      paddingRight: 12,
	      display: 'flex',
	      backgroundColor: (0, _color2.default)(color.borderColor).alpha(0.1).string() + ' !important',
	      '&:hover': {
	        borderColor: color.primaryButtonHover,
	        cursor: 'pointer',
	        background: (0, _color2.default)(color.primaryButtonHover).alpha(0.05).string() + ' !important',
	        '& div:last-child': {
	          '& div': {
	            visibility: 'visible'
	          }
	        }
	      },
	      '&:focus-within': {
	        borderColor: color.primaryButtonHover,
	        outline: 'none',
	        cursor: 'pointer',
	        background: (0, _color2.default)(color.primaryButtonHover).alpha(0.05).string() + ' !important',
	        '& div:last-child': {
	          '& div': {
	            visibility: 'visible'
	          }
	        }
	      },
	      '&:active': {
	        border: '3px double ' + color.primaryButtonHover
	      }
	    },
	    addButtonContainer: {
	      height: 20
	    },
	    addButton: {
	      visibility: 'hidden',
	      borderRadius: '50%',
	      background: color.primaryButtonBackground,
	      width: 20,
	      height: 20,
	      display: 'flex',
	      color: '#fff',
	      fontWeight: 'bold',
	      fontSize: 16,
	      alignItems: 'center',
	      justifyContent: 'center',
	      '&:hover': {
	        background: color.primaryButtonHover,
	        cursor: 'pointer',
	        visibility: 'visible !important'
	      },
	      '&:focus': {
	        outline: 'none',
	        visibility: 'visible !important',
	        background: color.primaryButtonHover,
	        cursor: 'pointer'
	      }
	    },
	    entityTitle: {
	      color: color.link,
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.label,
	      marginTop: 12
	    },
	    entityCount: {
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.pageTitle,
	      color: color.bodyText
	    },
	    tooltiptext: {
	      fontSize: fontSize.bodyText,
	      fontFamily: typography.bodyText,
	      width: 120,
	      opacity: 0.9,
	      visibility: 'hidden',
	      backgroundColor: '#5a5f6d',
	      color: '#fff',
	      textAlign: 'center',
	      borderRadius: 3,
	      padding: '5px 0',
	      position: 'absolute',
	      zIndex: 1,
	      bottom: '155%',
	      left: '-478%',
	      '&:after': {
	        content: 'close-quote',
	        position: 'absolute',
	        top: '100%',
	        left: '86%',
	        marginLeft: -5,
	        borderWidth: 7,
	        borderStyle: 'solid',
	        borderColor: '#5a5f6d transparent transparent transparent'
	      }
	    },
	    tooltip: {
	      position: 'relative',
	      '&:hover': {
	        '& span': {
	          visibility: 'visible'
	        }
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EntityScrollBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1628);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _HorizontalScrollBar = __webpack_require__(610);
	
	var _HorizontalScrollBar2 = _interopRequireDefault(_HorizontalScrollBar);
	
	var _EntityCard = __webpack_require__(1625);
	
	var _EntityCard2 = _interopRequireDefault(_EntityCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityOrder = ['APIs', 'APIPlans', 'APIGroups', 'Proxies', 'Applications', 'Organizations', 'Users', 'AccountPlans'];
	function EntityScrollBar(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var getEntityObj = function getEntityObj(entityName) {
	    return props.entities.find(function (entityObj) {
	      return entityObj.entity === entityName;
	    });
	  };
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _HorizontalScrollBar2.default,
	      { scrollEntity: 'referenceCard' },
	      props.entities && props.entities.length > 0 ? _react2.default.createElement('div', { className: classes.leftBorder }) : null,
	      entityOrder.map(function (entityName, id) {
	        return getEntityObj(entityName) && _react2.default.createElement(_EntityCard2.default, {
	          isPortalAdmin: props.isPortalAdmin,
	          entity: getEntityObj(entityName),
	          id: id,
	          key: entityName
	        });
	      }),
	      props.entities && props.entities.length > 0 ? _react2.default.createElement('div', { className: classes.rightBorder }) : null
	    )
	  );
	}
	EntityScrollBar.propTypes = {
	  entities: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  })),
	  isPortalAdmin: _propTypes2.default.bool
	};

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color;
	  return {
	    leftBorder: {
	      width: 36,
	      borderTop: '1px solid ' + color.borderColor,
	      borderBottom: '1px solid ' + color.borderColor,
	      backgroundColor: (0, _color2.default)(color.borderColor).alpha(0.1).string() + ' !important'
	    },
	    rightBorder: {
	      width: 36,
	      borderLeft: '1px solid ' + color.borderColor,
	      borderTop: '1px solid ' + color.borderColor,
	      borderBottom: '1px solid ' + color.borderColor,
	      backgroundColor: (0, _color2.default)(color.borderColor).alpha(0.1).string() + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = GridPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GridPanelCard = __webpack_require__(1631);
	
	var _GridPanelCard2 = _interopRequireDefault(_GridPanelCard);
	
	var _styles = __webpack_require__(1630);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _customMetrics = __webpack_require__(616);
	
	var _labels = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GridPanel(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var fetchAvailableApis = props.fetchAvailableApis,
	      apis = props.apis;
	  var fetchAllOrgs = props.fetchAllOrgs,
	      allOrgs = props.allOrgs;
	  var fetchAvailableApps = props.fetchAvailableApps,
	      apps = props.apps;
	  var fetchAllProxies = props.fetchAllProxies,
	      allProxies = props.allProxies;
	  var fetchDashboardChartData = props.fetchDashboardChartData,
	      chartData = props.chartData,
	      isApiOwnerOrOrgPub = props.isApiOwnerOrOrgPub;
	  var analytics = props.analytics;
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      isLoading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var getchartQueryParams = function getchartQueryParams(entityId) {
	    return {
	      metrics: { type: 'hits', aggregation: 'count' },
	      timeRange: { type: 'period', period: '30D', aggregation: 'day' },
	      dimensions: { groupBy: [{ dimension: entityId, type: 'top', limit: 24 }] }
	    };
	  };
	
	  var entityNameMap = {
	    api: 'apiName',
	    org: 'orgName',
	    proxy: 'gatewayServerName',
	    app: 'appName'
	  };
	
	  var entityIdMap = {
	    api: 'apiId',
	    org: 'orgId',
	    proxy: 'gatewayServerId',
	    app: 'appId'
	  };
	
	  var entityDataMap = {
	    api: apis,
	    org: allOrgs,
	    proxy: allProxies,
	    app: apps
	  };
	
	  (0, _react.useEffect)(function () {
	    if (analytics) {
	      var query = (0, _customMetrics.buildQuery)(getchartQueryParams(entityIdMap[props.chartEntity]));
	      fetchDashboardChartData(query, props.chartEntity).then(function () {
	        return setLoading(false);
	      });
	    } else {
	      if (props.chartEntity === _labels.API_ENTITY) {
	        fetchAvailableApis().then(function () {
	          return setLoading(false);
	        });
	      }
	      if (props.chartEntity === _labels.ORGANIZATION_ENTITY) {
	        fetchAllOrgs().then(function () {
	          return setLoading(false);
	        });
	      }
	      if (props.chartEntity === _labels.APPLICATION_ENTITY) {
	        fetchAvailableApps().then(function () {
	          return setLoading(false);
	        });
	      }
	      if (props.chartEntity === _labels.PROXY_ENTITY) {
	        fetchAllProxies().then(function () {
	          return setLoading(false);
	        });
	      }
	    }
	  }, []);
	
	  var getEntityURL = function getEntityURL(uuid) {
	    var entityURL = '';
	    if (props.chartEntity === _labels.API_ENTITY) {
	      entityURL = 'https://' + window.location.hostname + '/publish/apis/details/' + uuid;
	    }
	    if (props.chartEntity === _labels.ORGANIZATION_ENTITY) {
	      entityURL = 'https://' + window.location.hostname + '/admin/console/organizations/edit/' + uuid;
	    }
	    if (props.chartEntity === _labels.APPLICATION_ENTITY) {
	      entityURL = 'https://' + window.location.hostname + '/publish/applications/details/' + uuid;
	    }
	    if (props.chartEntity === _labels.PROXY_ENTITY) {
	      entityURL = 'https://' + window.location.hostname + '/publish/api-proxy/details/' + uuid;
	    }
	    return entityURL;
	  };
	
	  var showGridPanelCardWithoutAnalytics = function showGridPanelCardWithoutAnalytics(name) {
	    return _react2.default.createElement(_GridPanelCard2.default, {
	      cardEntity: name.Name || name.name,
	      cardEntityUUID: name.Uuid || name.uuid,
	      key: name.Uuid || name.uuid,
	      url: getEntityURL(name.Uuid || name.uuid),
	      isApiOwnerOrOrgPub: props.isApiOwnerOrOrgPub,
	      chartEntity: props.chartEntity
	    });
	  };
	
	  var showGridPanelCardWithAnalytics = function showGridPanelCardWithAnalytics(name, entity) {
	    return _react2.default.createElement(_GridPanelCard2.default, {
	      cardEntity: name[entityNameMap[entity]],
	      cardEntityUUID: name[entityIdMap[entity]],
	      key: name[entityIdMap[entity]],
	      url: getEntityURL(name[entityIdMap[entity]]),
	      count: name.count,
	      isApiOwnerOrOrgPub: isApiOwnerOrOrgPub,
	      chartEntity: props.chartEntity
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.panel },
	    isLoading ? _react2.default.createElement(
	      'div',
	      { className: classes.loader },
	      _react2.default.createElement(_core.CircularProgress, null)
	    ) : !analytics && entityDataMap[props.chartEntity] &&
	    // limiting the number of cards which could be shown to 24
	    entityDataMap[props.chartEntity].slice(0, 24).map(function (name) {
	      return showGridPanelCardWithoutAnalytics(name);
	    }) || chartData[props.chartEntity] && chartData[props.chartEntity].data.map(function (name) {
	      return showGridPanelCardWithAnalytics(name, props.chartEntity);
	    })
	  );
	}
	
	GridPanel.propTypes = {
	  apis: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchAvailableApis: _propTypes2.default.func,
	  allOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchAllOrgs: _propTypes2.default.func,
	  apps: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchAvailableApps: _propTypes2.default.func,
	  allProxies: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchAllProxies: _propTypes2.default.func,
	  chartEntity: _propTypes2.default.string,
	  chartData: _propTypes2.default.shape({}),
	  fetchDashboardChartData: _propTypes2.default.func,
	  analytics: _propTypes2.default.bool,
	  isApiOwnerOrOrgPub: _propTypes2.default.bool
	};

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      typography = _ref.typography;
	  return {
	    panel: {
	      display: 'flow-root',
	      boxSizing: 'border-box',
	      position: 'relative',
	      backgroundColor: (0, _get2.default)(color, 'background'),
	      fontFamily: (0, _get2.default)(typography, 'bodyText'),
	      paddingLeft: 20,
	      paddingRight: 20,
	      paddingBottom: 14
	    },
	    loader: {
	      textAlign: 'center',
	      height: 'auto',
	      marginTop: 28,
	      marginBottom: 20,
	      '& .MuiCircularProgress-colorPrimary': {
	        color: color.link
	      }
	    }
	  };
	};

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = GridPanelCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ellipsis = __webpack_require__(1235);
	
	var _ellipsis2 = _interopRequireDefault(_ellipsis);
	
	var _styles = __webpack_require__(1632);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GridPanelCard(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var cardEntity = props.cardEntity,
	      cardEntityUUID = props.cardEntityUUID,
	      url = props.url,
	      count = props.count,
	      chartEntity = props.chartEntity;
	
	  var handleClick = function handleClick(event) {
	    event.stopPropagation();
	    window.location.href = url;
	  };
	  var handleEnterKey = function handleEnterKey(event) {
	    var code = event.keyCode || event.which;
	    if (code === 13) {
	      event.stopPropagation();
	      window.location.href = url;
	    }
	  };
	  var cardEntityLocal = cardEntity || cardEntityUUID;
	  var isNonClickable = !cardEntityLocal || props.isApiOwnerOrOrgPub && (chartEntity === 'proxy' || chartEntity === 'org');
	  return _react2.default.createElement(
	    'div',
	    null,
	    !isNonClickable ? _react2.default.createElement(
	      'div',
	      {
	        tabIndex: '0',
	        className: count ? classes.cardAnalytics : classes.card,
	        onClick: function onClick(e) {
	          return handleClick(e);
	        },
	        onKeyDown: function onKeyDown(e) {
	          return handleEnterKey(e);
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: classes.cardInner },
	        cardEntityLocal.length > 20 ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: classes.cardNameEllipsis },
	            cardEntityLocal
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.tooltip },
	            _react2.default.createElement('img', {
	              src: _ellipsis2.default,
	              className: classes.ellipsis,
	              alt: 'Ellipsis'
	            }),
	            _react2.default.createElement(
	              'span',
	              { className: classes.tooltiptext },
	              cardEntityLocal
	            )
	          ),
	          count ? _react2.default.createElement(
	            'span',
	            { className: classes.count },
	            count
	          ) : null
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: classes.cardName },
	            cardEntityLocal
	          ),
	          count ? _react2.default.createElement(
	            'span',
	            { className: classes.count },
	            count
	          ) : null
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      {
	        className: count ? classes.cardUnauthorizedAnalytics : classes.cardUnauthorized
	      },
	      _react2.default.createElement(
	        'div',
	        { className: classes.cardInner },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: classes.cardNameUnAuthorized },
	            cardEntityLocal || 'Unauthorized'
	          ),
	          count ? _react2.default.createElement(
	            'span',
	            { className: classes.count },
	            count
	          ) : null
	        )
	      )
	    )
	  );
	}
	
	GridPanelCard.propTypes = {
	  cardEntity: _propTypes2.default.string,
	  cardEntityUUID: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  count: _propTypes2.default.number,
	  isApiOwnerOrOrgPub: _propTypes2.default.bool,
	  chartEntity: _propTypes2.default.string
	};

/***/ },
/* 1632 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    card: {
	      position: 'relative',
	      display: 'inline-block',
	      width: 190,
	      height: 57,
	      border: '1px solid ' + color.borderColor,
	      borderRadius: 4,
	      opacity: 1,
	      marginTop: 14,
	      marginLeft: 15,
	      marginBottom: 1,
	      marginRight: 1,
	      float: 'left',
	      cursor: 'pointer',
	      '&:hover': {
	        border: '1px solid ' + color.primaryButtonHover,
	        transition: 'border-color 0.5s ease'
	      },
	      '&:focus': {
	        marginTop: 13,
	        marginLeft: 14,
	        marginBottom: 0,
	        marginRight: 0,
	        outline: 'none',
	        border: '2px solid ' + color.primaryButtonHover,
	        transition: 'border-color 1s ease'
	      }
	    },
	
	    cardAnalytics: {
	      position: 'relative',
	      display: 'inline-block',
	      width: 190,
	      height: 76,
	      border: '1px solid ' + color.borderColor,
	      borderRadius: 4,
	      opacity: 1,
	      marginTop: 14,
	      marginLeft: 15,
	      float: 'left',
	      cursor: 'pointer',
	      '&:hover': {
	        border: '1px solid ' + color.primaryButtonHover,
	        transition: 'border-color 0.5s ease'
	      },
	      '&:focus': {
	        outline: 'none',
	        border: '2px solid ' + color.primaryButtonHover,
	        transition: 'border-color 1s ease'
	      }
	    },
	
	    cardUnauthorized: {
	      position: 'relative',
	      display: 'inline-block',
	      width: 190,
	      height: 57,
	      border: '1px solid ' + color.borderColor,
	      borderRadius: 4,
	      opacity: 1,
	      marginTop: 14,
	      marginLeft: 15,
	      float: 'left'
	    },
	
	    cardUnauthorizedAnalytics: {
	      position: 'relative',
	      display: 'inline-block',
	      width: 190,
	      height: 76,
	      border: '1px solid ' + color.borderColor,
	      borderRadius: 4,
	      opacity: 1,
	      marginTop: 14,
	      marginLeft: 15,
	      float: 'left'
	    },
	
	    cardNameEllipsis: {
	      textAlign: 'left',
	      float: 'left',
	      width: 144,
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.bodyText,
	      fontWeight: 'bold',
	      color: color.link,
	      paddingTop: 6,
	      display: 'block',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      background: 'linear-gradient(to right, ' + color.link + ' 44%, #FFF 188%)',
	      '-webkit-background-clip': 'text',
	      '-webkit-text-fill-color': 'transparent'
	    },
	
	    cardName: {
	      textAlign: 'left',
	      float: 'left',
	      width: 144,
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.bodyText,
	      fontWeight: 'bold',
	      color: color.link,
	      paddingTop: 6,
	      display: 'block'
	    },
	
	    cardNameUnAuthorized: {
	      textAlign: 'left',
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.bodyText,
	      fontWeight: 'bold',
	      color: color.bodyText,
	      marginTop: 8,
	      display: 'block',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis'
	    },
	
	    cardInner: {
	      height: 33,
	      margin: '12px 12px 12px 16px'
	    },
	
	    count: {
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.bodyText,
	      fontWeight: 'normal',
	      color: color.bodyText
	    },
	
	    tooltip: {
	      '&:hover': {
	        '& span': {
	          visibility: 'visible'
	        }
	      }
	    },
	
	    tooltiptext: {
	      fontSize: typography.bodyText,
	      fontFamily: typography.bodyText,
	      width: 160,
	      opacity: 0.9,
	      visibility: 'hidden',
	      backgroundColor: '#5a5f6d',
	      color: '#fff',
	      textAlign: 'center',
	      borderRadius: 3,
	      padding: '5px 0',
	      position: 'absolute',
	      zIndex: 1,
	      bottom: '81%',
	      left: '78%',
	      '&:after': {
	        content: 'close-quote',
	        position: 'absolute',
	        top: '100%',
	        left: '12%',
	        marginLeft: -5,
	        borderWidth: 7,
	        borderStyle: 'solid',
	        borderColor: '#5a5f6d transparent transparent transparent'
	      }
	    },
	
	    ellipsis: {
	      float: 'left',
	      marginTop: 8
	    }
	  };
	};

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(27);
	
	var _application = __webpack_require__(102);
	
	var _dashboard = __webpack_require__(604);
	
	var _application2 = __webpack_require__(86);
	
	var _dashboard2 = __webpack_require__(285);
	
	var _GridPanel = __webpack_require__(1629);
	
	var _GridPanel2 = _interopRequireDefault(_GridPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    apis: (0, _application2.getAvailableApis)(state),
	    allOrgs: (0, _application2.getOrganizations)(state),
	    apps: (0, _application2.getAvailableApps)(state),
	    allProxies: (0, _application2.getProxies)(state),
	    chartData: (0, _dashboard2.getDashboardChartData)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchAvailableApis: function fetchAvailableApis() {
	      return dispatch((0, _application.fetchAvailableApis)({ tags: '', size: 24 }));
	    },
	    fetchAllOrgs: function fetchAllOrgs() {
	      return dispatch((0, _application.fetchOrganizations)(0, 24));
	    },
	    fetchAvailableApps: function fetchAvailableApps() {
	      return dispatch((0, _application.fetchAvailableApps)({ size: 24, portalStatus: '' }));
	    },
	    fetchAllProxies: function fetchAllProxies() {
	      return dispatch((0, _application.fetchProxies)());
	    },
	    fetchDashboardChartData: function fetchDashboardChartData(query, entity) {
	      return dispatch((0, _dashboard.fetchDashboardChartData)(JSON.stringify(query), entity));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_GridPanel2.default);

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(1635);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _components = __webpack_require__(17);
	
	var _labels = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GuestDashboard = function GuestDashboard() {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        className: classes.dashboard,
	        id: 'dashboard-main',
	        'data-apim-test': 'guest-dashboard-main'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: classes.title },
	        _labels.GUEST_USER_TITLE
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.subTitle },
	        _labels.GUEST_USER_MESSAGE
	      )
	    ),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	
	exports.default = GuestDashboard;

/***/ },
/* 1635 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return {
	    dashboard: {
	      background: color.uiBackground + ' 0% 0% no-repeat padding-box',
	      margin: '-' + misc.headerHeight + 'px 38px 0 38px'
	    },
	    title: {
	      color: color.pageTitle,
	      fontFamily: typography.pageTitle,
	      fontSize: fontSize.pageTitle,
	      lineHeight: '48px',
	      marginTop: 102,
	      paddingLeft: 36
	    },
	    subTitle: {
	      color: color.pageTitle,
	      fontFamily: typography.pageTitle,
	      fontSize: fontSize.smallTitle,
	      lineHeight: '28px',
	      marginTop: 36,
	      paddingLeft: 36
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = DashboardHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(1637);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _HeaderDropdown = __webpack_require__(1638);
	
	var _HeaderDropdown2 = _interopRequireDefault(_HeaderDropdown);
	
	var _SearchBar = __webpack_require__(1644);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _labels = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DashboardHeader(props) {
	  var useStyles = (0, _core.makeStyles)(_index2.default);
	  var classes = useStyles();
	
	  var _React$useState = _react2.default.useState(_labels.API),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      dropdownValue = _React$useState2[0],
	      setDropdownValue = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      selectedEntity = _React$useState4[0],
	      setSelectedEntity = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(true),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      disableButton = _React$useState6[0],
	      setDisableButton = _React$useState6[1];
	
	  var autoSuggestEntities = [];
	  if (dropdownValue === _labels.API) {
	    autoSuggestEntities = props.autoSuggestionsApis;
	  } else if (dropdownValue === _labels.APPLICATION) {
	    autoSuggestEntities = props.autoSuggestionsApps;
	  } else if (dropdownValue === _labels.ORGANIZATION) {
	    autoSuggestEntities = props.autoSuggestionsOrgs;
	  }
	  var autoSuggestSuggestions = autoSuggestEntities.map(function (entity) {
	    return { key: entity.uuid, value: entity.name };
	  });
	
	  var handleDropdownUpdate = function handleDropdownUpdate(value) {
	    setDropdownValue(value);
	  };
	
	  var handleSearch = function handleSearch(entity) {
	    if (entity) setDisableButton(false);
	    setSelectedEntity(entity);
	  };
	  var handleGo = function handleGo() {
	    var selectedUUID = selectedEntity.key;
	    if (dropdownValue === _labels.API) {
	      window.location.href = 'https://' + window.location.hostname + '/publish/apis/details/' + selectedUUID;
	    }
	    if (dropdownValue === _labels.APPLICATION) {
	      window.location.href = 'https://' + window.location.hostname + '/publish/applications/details/' + selectedUUID;
	    }
	    if (dropdownValue === _labels.ORGANIZATION) {
	      window.location.href = 'https://' + window.location.hostname + '/admin/console/organizations/edit/' + selectedUUID;
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.Header,
	      id: 'dashboard-header',
	      'data-apim-test': 'dashboard-header'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: classes.HeaderInner },
	      _react2.default.createElement(
	        'div',
	        { className: classes.WelcomeHeader },
	        _react2.default.createElement(
	          'span',
	          { className: classes.Title },
	          _labels.HELLO,
	          ' ',
	          props.userContexts.firstName
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.HeaderSearch },
	        _react2.default.createElement(_HeaderDropdown2.default, {
	          handleDropdownUpdate: handleDropdownUpdate,
	          selectedDropdownValue: dropdownValue,
	          isOnlyPortalAdmin: props.isOnlyPortalAdmin
	        }),
	        _react2.default.createElement(_SearchBar2.default, {
	          fetchAvailableApis: props.fetchAvailableApis,
	          fetchAvailableApps: props.fetchAvailableApps,
	          fetchAvailableOrgs: props.fetchAvailableOrgs,
	          autoSuggestSuggestions: autoSuggestSuggestions,
	          selectedDropdownValue: dropdownValue,
	          selectedOption: selectedEntity,
	          handleSearch: handleSearch
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: classes.GoButton },
	          _react2.default.createElement(
	            _core.Button,
	            {
	              disabled: disableButton,
	              variant: 'outlined',
	              color: 'secondary',
	              className: classes.HeaderGoButton,
	              onClick: function onClick() {
	                return handleGo();
	              }
	            },
	            _labels.GO
	          )
	        )
	      )
	    )
	  );
	}
	
	DashboardHeader.propTypes = {
	  fetchAvailableApis: _propTypes2.default.func,
	  autoSuggestionsApis: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  })),
	  fetchAvailableApps: _propTypes2.default.func,
	  autoSuggestionsApps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  })),
	  fetchAvailableOrgs: _propTypes2.default.func,
	  autoSuggestionsOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  })),
	  userContexts: _propTypes2.default.shape({
	    firstName: _propTypes2.default.string
	  }),
	  isOnlyPortalAdmin: _propTypes2.default.bool
	};

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    Header: {
	      boxSizing: 'border-box',
	      backgroundColor: (0, _get2.default)(color, 'headerBackground'),
	      padding: '34px 36px 24px 36px'
	    },
	
	    HeaderInner: {
	      display: 'flex',
	      justifyContent: 'space-between'
	    },
	
	    HeaderSearch: {
	      display: 'inline-flex',
	      height: 38,
	      '& input': {
	        backgroundColor: (0, _get2.default)(color, 'uiBackground') + ' !important',
	        fontFamily: typography.bodyText,
	        fontSize: fontSize.bodyText,
	        width: '210px!important',
	        height: '18px!important',
	        margin: '8px 8px 8px 8px !important',
	        borderRadius: '0!important',
	        overflow: 'hidden',
	        whiteSpace: 'nowrap',
	        textOverflow: 'ellipsis',
	        maxWidth: 210
	      }
	    },
	
	    Title: {
	      color: color.pageTitle,
	      fontFamily: typography.pageTitle,
	      fontSize: fontSize.pageTitle
	    },
	
	    GoButton: {
	      width: 50
	    },
	
	    HeaderGoButton: {
	      padding: '0px !important',
	      minWidth: 47,
	      backgroundColor: color.primaryButtonText,
	      width: 47,
	      height: 36,
	      fontSize: fontSize.buttonText + ' !important',
	      fontFamily: typography.buttonText + ' !important',
	      textTransform: 'none',
	      color: color.primaryButtonBackground,
	      boxShadow: 'none',
	      borderRadius: '0px 3px 3px 0px',
	      '&:disabled': {
	        color: (0, _color2.default)(color.bodyText).alpha(0.7).string() + ' !important',
	        backgroundColor: (0, _color2.default)(color.bodyText).alpha(0.1).string() + ' !important'
	      },
	      '&:hover': {
	        background: (0, _color2.default)(color.primaryButtonBackground).alpha(0.08).string() + ' !important',
	        color: color.primaryButtonBackground + ' !important'
	      },
	      '&:focus': {
	        border: '1px solid ' + color.primaryButtonBackground,
	        boxShadow: '0 0 0 1px ' + color.primaryButtonBackground + ' !important',
	        transition: 'none'
	      }
	    },
	
	    '@media screen and (min-width: 330px) and (max-width: 930px)': {
	      HeaderInner: {
	        flexDirection: 'column-reverse'
	      },
	
	      Title: {
	        fontSize: fontSize.siteTitle
	      },
	
	      HeaderSearch: {
	        marginBottom: 34
	      }
	    }
	  };
	};

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = HeaderDropdown;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	var _core = __webpack_require__(3);
	
	var _Select = __webpack_require__(165);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _MenuItem = __webpack_require__(111);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _createSvgIcon = __webpack_require__(22);
	
	var _createSvgIcon2 = _interopRequireDefault(_createSvgIcon);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _styles2 = __webpack_require__(1639);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	var _labels = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// workaround till we update react-scripts > 2.0.0, which supports adding svg images
	var expandSVG = _react2.default.createElement('path', { d: 'M12.023 16.9557L12.0229 16.9556L11.977 17L4.86808 10.1204C4.37731 9.64543 4.37731 8.87541 4.86808 8.40047C5.35884 7.92553 6.15453 7.92553 6.6453 8.40047L11.9771 13.5603L17.3547 8.3562C17.8455 7.88127 18.6412 7.88127 19.1319 8.3562C19.6227 8.83114 19.6227 9.60117 19.1319 10.0761L12.023 16.9557Z' });
	
	function HeaderDropdown(props) {
	  var useStyles = (0, _styles.makeStyles)(_styles3.default);
	  var classes = useStyles();
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      open = _React$useState2[0],
	      setOpen = _React$useState2[1];
	
	  var handleChange = function handleChange(event) {
	    props.handleDropdownUpdate(event.target.value);
	  };
	  var appTheme = (0, _core.useTheme)();
	
	  var handleClose = function handleClose() {
	    setOpen(false);
	  };
	
	  var handleOpen = function handleOpen() {
	    setOpen(true);
	  };
	
	  var muiTheme = (0, _styles.createMuiTheme)({
	    overrides: {
	      MuiSelect: {
	        icon: {
	          color: appTheme.color.primaryButtonBackground
	        }
	      },
	      MuiInput: {
	        root: {
	          border: '1px solid ' + (0, _color2.default)(appTheme.color.primaryButtonBackground).alpha(0.4).string(),
	          borderRadius: '3px 0px 0px 3px',
	          zIndex: 5,
	          '&:hover': {
	            border: '1px solid ' + appTheme.color.primaryButtonHover,
	            zIndex: 10
	          },
	          '&$focused': {
	            border: '1px solid ' + appTheme.color.primaryButtonBackground,
	            boxShadow: '0 0 0 1px ' + appTheme.color.primaryButtonBackground
	          }
	        },
	        focused: {}
	      },
	      MuiPaper: {
	        root: {
	          marginTop: 10,
	          marginLeft: -8,
	          width: 192,
	          boxShadow: '0px 4px 8px #00000033 !important'
	        },
	        rounded: {
	          borderRadius: '3px 3px 0px 0px'
	        }
	      },
	      MuiList: {
	        padding: {
	          paddingTop: '8px !important',
	          paddingBottom: '12px !important'
	        }
	      },
	      MuiListItem: {
	        root: {
	          '&$selected': {
	            backgroundColor: '#fff'
	          },
	          '&$selected:hover': {
	            backgroundColor: (0, _color2.default)(appTheme.color.primaryButtonBackground).alpha(0.08).string() + ' !important'
	          },
	          '&:hover': {
	            backgroundColor: (0, _color2.default)(appTheme.color.primaryButtonBackground).alpha(0.08).string() + ' !important'
	          }
	        }
	      }
	    }
	  });
	  var ExpandIcon = (0, _createSvgIcon2.default)(expandSVG, 'expand');
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.dropdown,
	      id: 'dashboard-header-dropdown',
	      'data-apim-test': 'dashboard-header-dropdown'
	    },
	    _react2.default.createElement(
	      _styles.ThemeProvider,
	      { theme: muiTheme },
	      _react2.default.createElement(
	        _Select2.default,
	        {
	          className: classes.selectDropdown,
	          classes: {
	            select: classes.selectDropdownSelect
	          },
	          disableUnderline: true,
	          IconComponent: ExpandIcon,
	          open: open,
	          onClose: handleClose,
	          onOpen: handleOpen,
	          value: props.selectedDropdownValue,
	          onChange: handleChange,
	          MenuProps: {
	            disableScrollLock: true,
	            anchorOrigin: {
	              vertical: 'bottom',
	              horizontal: 'left'
	            },
	            transformOrigin: {
	              vertical: 'top',
	              horizontal: 'left'
	            },
	            getContentAnchorEl: null
	          },
	          tabIndex: -1
	        },
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { className: classes.menuItems, value: 'API' },
	          _labels.API
	        ),
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { className: classes.menuItems, value: 'Application' },
	          _labels.APPLICATION
	        ),
	        props.isOnlyPortalAdmin && _react2.default.createElement(
	          _MenuItem2.default,
	          { className: classes.menuItems, value: 'Organization' },
	          _labels.ORGANIZATION
	        )
	      )
	    )
	  );
	}
	
	HeaderDropdown.propTypes = {
	  selectedDropdownValue: _propTypes2.default.string,
	  isOnlyPortalAdmin: _propTypes2.default.bool
	};

/***/ },
/* 1639 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    dropdown: {
	      display: 'inline-block',
	      height: 36,
	      width: 118,
	      boxSizing: 'content-box'
	    },
	    selectDropdown: {
	      backgroundColor: color.uiBackground,
	      width: 118,
	      height: 36,
	      color: color.bodyText
	    },
	    selectDropdownSelect: {
	      color: color.bodyText,
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.bodyText,
	      padding: '0 !important',
	      margin: '9px 8px 8px',
	      '&:focus': {
	        backgroundColor: color.uiBackground
	      }
	    },
	    menuItems: {
	      color: color.bodyText,
	      fontFamily: typography.bodyText,
	      fontSize: fontSize.bodyText
	    },
	    '@media screen and (min-width: 330px) and (max-width: 630px)': {
	      dropdown: {
	        width: 76
	      },
	      selectDropdown: {
	        width: 76
	      }
	    }
	  };
	};

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapStateToProps = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _Skeleton = __webpack_require__(365);
	
	var _Skeleton2 = _interopRequireDefault(_Skeleton);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _recompose = __webpack_require__(105);
	
	var _styles = __webpack_require__(1641);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Header = __webpack_require__(1636);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EntityScrollBar = __webpack_require__(1627);
	
	var _EntityScrollBar2 = _interopRequireDefault(_EntityScrollBar);
	
	var _Charts = __webpack_require__(1620);
	
	var _Charts2 = _interopRequireDefault(_Charts);
	
	var _portalConfig = __webpack_require__(26);
	
	var _components = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dashboard = function Dashboard(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var fetchDashboardEntityCount = props.fetchDashboardEntityCount,
	      entities = props.entities,
	      fetchDashboardChartData = props.fetchDashboardChartData,
	      isOrgPublisher = props.isOrgPublisher,
	      isPortalAdmin = props.isPortalAdmin,
	      isApiOwner = props.isApiOwner;
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      isLoading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var isAnalyticsEnabled = window.analyticsEnabled;
	  (0, _react.useEffect)(function () {
	    fetchDashboardEntityCount().then(function () {
	      setLoading(false);
	    });
	  }, [fetchDashboardEntityCount]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        className: classes.dashboard,
	        id: 'dashboard-main',
	        'data-apim-test': 'dashboard-main'
	      },
	      _react2.default.createElement(_Header2.default, props),
	      isLoading ? _react2.default.createElement(_Skeleton2.default, { variant: 'rect', animation: 'wave', height: 116, width: '100%' }) : _react2.default.createElement(_EntityScrollBar2.default, { entities: entities, isPortalAdmin: isPortalAdmin }),
	      _react2.default.createElement(_Charts2.default, {
	        chartData: props.chartData,
	        fetchDashboardChartData: fetchDashboardChartData,
	        isAnalyticsEnabled: isAnalyticsEnabled,
	        isOrgPublisher: isOrgPublisher,
	        isApiOwner: isApiOwner,
	        isPortalAdmin: isPortalAdmin
	      })
	    ),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    isPortalAdmin: (0, _portalConfig.getIsPortalAdmin)(state),
	    isOrgPublisher: (0, _portalConfig.getIsOrgPublisher)(state),
	    isApiOwner: (0, _portalConfig.getIsApiOwner)(state),
	    isOnlyPortalAdmin: (0, _portalConfig.getIsOnlyPortalAdmin)(state)
	  };
	};
	
	Dashboard.propTypes = {
	  entities: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchDashboardEntityCount: _propTypes2.default.func,
	  fetchDashboardChartData: _propTypes2.default.func,
	  isOrgPublisher: _propTypes2.default.bool,
	  isPortalAdmin: _propTypes2.default.bool,
	  isApiOwner: _propTypes2.default.bool,
	  chartData: _propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  })
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps))(Dashboard);

/***/ },
/* 1641 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      misc = _ref.misc;
	  return {
	    dashboard: {
	      background: color.uiBackground + " 0% 0% no-repeat padding-box",
	      margin: "-" + misc.headerHeight + "px 38px 0 38px"
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = PanelDropdown;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExpandMore = __webpack_require__(81);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _ExpandLess = __webpack_require__(114);
	
	var _ExpandLess2 = _interopRequireDefault(_ExpandLess);
	
	var _Check = __webpack_require__(113);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(1643);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _labels = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PanelDropdown(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      _useState2$ = _useState2[0],
	      anchorEl = _useState2$ === undefined ? false : _useState2$,
	      setAnchorEl = _useState2[1];
	
	  var top3EntitiesMap = {
	    api: _labels.TOP_3_APIS,
	    org: _labels.TOP_3_ORGS,
	    proxy: _labels.TOP_3_PROXIES,
	    app: _labels.TOP_3_APPS
	  };
	  var handleClick = function handleClick(event) {
	    event.stopPropagation();
	    setAnchorEl(event.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    setAnchorEl(null);
	  };
	  var toggleChart = function toggleChart() {
	    handleClose();
	    props.onToggleChartEnabled(props.panelName);
	  };
	  var toggleTop3Entities = function toggleTop3Entities() {
	    handleClose();
	    props.onToggleTop3Entities();
	  };
	  var setPanelCollapsed = function setPanelCollapsed() {
	    handleClose();
	    props.setCollapsed(props.panelName);
	  };
	  var movePanel = function movePanel(isUpward) {
	    handleClose();
	    props.onMovePanel(props.chartEntity, isUpward);
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: classes.rootPanel },
	    _react2.default.createElement(
	      _IconButton2.default,
	      {
	        onClick: handleClick,
	        className: classes.DropDownIcon
	      },
	      anchorEl ? _react2.default.createElement(_ExpandLess2.default, { className: classes.DropDownLabel }) : _react2.default.createElement(_ExpandMore2.default, { className: classes.DropDownLabel })
	    ),
	    _react2.default.createElement(
	      _core.Popper,
	      {
	        open: !!anchorEl,
	        anchorEl: anchorEl,
	        className: classes.Popper,
	        role: undefined,
	        transition: true,
	        placement: 'bottom-end'
	      },
	      function (_ref) {
	        var TransitionProps = _ref.TransitionProps,
	            placement = _ref.placement;
	        return _react2.default.createElement(
	          _core.Grow,
	          Object.assign({}, TransitionProps, {
	            style: {
	              transformOrigin: placement === 'bottom-end' ? 'center top' : 'center bottom',
	              zIndex: 50
	            }
	          }),
	          _react2.default.createElement(
	            _core.Paper,
	            {
	              classes: {
	                root: classes.MenuPaper
	              }
	            },
	            _react2.default.createElement(
	              _core.ClickAwayListener,
	              { onClickAway: handleClose },
	              _react2.default.createElement(
	                _core.MenuList,
	                null,
	                !props.isCollapsed && false &&
	                // false &&
	                // Hiding Top 3 Entities Menu till other entries like
	                // favorites and recents arrive.
	                _react2.default.createElement(
	                  _core.MenuItem,
	                  {
	                    className: classes.MenuItem,
	                    onClick: function onClick() {
	                      return toggleTop3Entities();
	                    }
	                  },
	                  top3EntitiesMap[props.chartEntity],
	                  props.isTop3EntitiesSelected ? _react2.default.createElement(_Check2.default, { className: classes.CheckIcon }) : null
	                ),
	                !props.isCollapsed && props.isAnalyticsEnabled && _react2.default.createElement(
	                  _core.MenuItem,
	                  {
	                    className: classes.MenuItem,
	                    onClick: function onClick() {
	                      return toggleChart();
	                    }
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _labels.CHART
	                  ),
	                  props.isChartEnabled ? _react2.default.createElement(_Check2.default, { className: classes.CheckIcon }) : null
	                ),
	                _react2.default.createElement(
	                  _core.MenuItem,
	                  {
	                    className: classes.MenuItem,
	                    onClick: function onClick() {
	                      return movePanel(true);
	                    },
	                    disabled: props.chartIndex === 0
	                  },
	                  _labels.MOVE_PANEL_UP
	                ),
	                _react2.default.createElement(
	                  _core.MenuItem,
	                  {
	                    className: classes.MenuItem,
	                    onClick: function onClick() {
	                      return movePanel(false);
	                    },
	                    disabled: props.chartIndex === props.chartsCount - 1
	                  },
	                  _labels.MOVE_PANEL_DOWN
	                ),
	                _react2.default.createElement(
	                  _core.MenuItem,
	                  {
	                    className: classes.MenuItem,
	                    onClick: function onClick() {
	                      return setPanelCollapsed();
	                    }
	                  },
	                  props.isCollapsed ? _labels.EXPAND_PANEL : _labels.COLLAPSE_PANEL
	                )
	              )
	            )
	          )
	        );
	      }
	    )
	  );
	}
	
	PanelDropdown.propTypes = {
	  isCollapsed: _propTypes2.default.bool,
	  onMovePanel: _propTypes2.default.func,
	  chartEntity: _propTypes2.default.string,
	  chartIndex: _propTypes2.default.number,
	  chartsCount: _propTypes2.default.number,
	  isTop3EntitiesSelected: _propTypes2.default.bool,
	  isChartEnabled: _propTypes2.default.bool,
	  isAnalyticsEnabled: _propTypes2.default.bool
	};

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(46);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      misc = _ref.misc,
	      typography = _ref.typography;
	  return {
	    rootPanel: {
	      fontSize: 20
	    },
	    HeaderSettings: {
	      zIndex: 100
	    },
	    DropDownIcon: {
	      marginLeft: 18,
	      background: color.primaryButtonBackground,
	      borderRadius: 3,
	      color: color.primaryButtonText,
	      opacity: 1,
	      padding: 1,
	      height: 18,
	      width: 18,
	      '&:hover': {
	        background: color.primaryButtonHover
	      },
	      '&:focus': {
	        background: color.primaryButtonHover,
	        border: '1px solid #FFFFFF',
	        outline: '2px solid',
	        outlineColor: color.primaryButtonBackground,
	        borderRadius: 3
	      }
	    },
	    Popper: {
	      marginTop: 4
	    },
	    DropDownLabel: {
	      color: '#ffffff',
	      width: 18,
	      height: 18
	    },
	    CheckIcon: {
	      width: 16,
	      height: 16,
	      color: color.link,
	      float: 'right'
	    },
	    MoveArrowButtons: {
	      width: 18,
	      height: 18,
	      color: color.link,
	      border: '1px solid',
	      borderColor: color.link,
	      borderRadius: 3,
	      float: 'right',
	      marginLeft: 6,
	      marginRight: 2,
	      cursor: 'pointer',
	      padding: 0,
	      '&:hover': {
	        color: color.linkHover,
	        borderColor: color.linkHover
	      },
	      '&:focus-within': {
	        color: color.linkHover,
	        borderColor: color.linkHover,
	        outline: '2px solid',
	        outlineColor: color.linkHover
	      },
	      '&:disabled': {
	        border: '0.4000000059604645px solid #4B5060',
	        opacity: '0.5',
	        pointer: 'none'
	      }
	    },
	    MoveArrows: {
	      height: 14,
	      width: 14
	    },
	    MenuItem: {
	      width: 192,
	      display: 'block',
	      color: color.bodyText,
	      fontSize: fontSize.bodyText,
	      fontFamily: typography.bodyText,
	      lineHeight: '1.2em',
	      paddingBottom: 8,
	      paddingTop: 10,
	      paddingLeft: 16,
	      paddingRight: 10,
	      textDecoration: 'none',
	      transition: misc.colorTransition,
	      cursor: 'pointer',
	      '&:hover': {
	        background: (0, _color2.default)(color.primaryButtonBackground).alpha(0.08).string() + ' !important'
	      },
	      '&:focus': {
	        background: (0, _color2.default)(color.primaryButtonBackground).alpha(0.08).string() + ' !important',
	        outline: 'none'
	      },
	      '&:last-child': {
	        marginBottom: 0
	      }
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SearchBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SearchBar = __webpack_require__(1538);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _labels = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchBar(props) {
	  var dispatchAutoSuggest = void 0;
	  if (props.selectedDropdownValue === _labels.API) {
	    dispatchAutoSuggest = props.fetchAvailableApis;
	  }
	  if (props.selectedDropdownValue === _labels.APPLICATION) {
	    dispatchAutoSuggest = props.fetchAvailableApps;
	  }
	  if (props.selectedDropdownValue === _labels.ORGANIZATION) {
	    dispatchAutoSuggest = props.fetchAvailableOrgs;
	  }
	  return _react2.default.createElement(_SearchBar2.default, {
	    dispatchAutoSuggest: dispatchAutoSuggest,
	    autoSuggestSuggestions: props.autoSuggestSuggestions,
	    selectedDropdownValue: props.selectedDropdownValue,
	    selectedOption: props.selectedOption,
	    handleSearch: props.handleSearch
	  });
	}
	
	SearchBar.propTypes = {
	  handleSearch: _propTypes2.default.func,
	  autoSuggestSuggestions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  })),
	  selectedDropdownValue: _propTypes2.default.string,
	  selectedOption: _propTypes2.default.shape(),
	  fetchAvailableApis: _propTypes2.default.func,
	  fetchAvailableApps: _propTypes2.default.func,
	  fetchAvailableOrgs: _propTypes2.default.func
	};

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMetricFromMetricKey = exports.getSourceFromMetricKey = exports.getMetricKey = exports.getDefaultSharedMutations = exports.getOrgMapFromResponse = exports.getSourcesIdsFromResponseForCustomReport = exports.getBucketPermuteIdAndNamesForCustomReport = exports.getSourcesIdsFromResponse = exports.getEntityPermuteMap = exports.getBucketPermuteIdAndNames = undefined;
	
	var _each = __webpack_require__(437);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _isEmpty = __webpack_require__(35);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isUndefined = __webpack_require__(445);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getEntityIdForEntityType = function getEntityIdForEntityType(entity) {
	  return entity.includes('Id') ? entity : entity.replace('s', '') + 'Id';
	};
	var getEntityMapNameForEntityType = function getEntityMapNameForEntityType(entity) {
	  return entity.replace('s', '') + 'Map';
	};
	
	var getBucketPermuteIdAndNames = exports.getBucketPermuteIdAndNames = function getBucketPermuteIdAndNames(bucket, entitiesStr, entityIdMap) {
	  var idSeparator = '__';
	  var ids = [];
	  var names = [];
	  var entityId = void 0;
	  var entityName = '';
	  if (!entitiesStr) {
	    entityId = '1';
	    entityName = 'All Data';
	    ids.push(entityId);
	    names.push(entityName);
	  } else {
	    var entities = entitiesStr.split(',');
	    (0, _each2.default)(entities, function (entity) {
	      entityId = bucket[getEntityIdForEntityType(entity)];
	      if (!entityId) entityId = '333';
	      if (entityId) {
	        ids.push(entityId);
	      }
	      var entityTypeMap = entityIdMap[getEntityMapNameForEntityType(entity)];
	      entityName = entityTypeMap && entityTypeMap[entityId] || entityId;
	      entityName = (0, _isEmpty2.default)(entityName) || (0, _isUndefined2.default)(entityName) ? 'Unauthorized' : entityName;
	      names.push(entityName);
	    });
	  }
	  var permuteId = ids.join(idSeparator);
	  return {
	    permuteId: permuteId,
	    names: names,
	    ids: ids
	  };
	};
	
	var getEntityPermuteMap = exports.getEntityPermuteMap = function getEntityPermuteMap(dataBuckets, entitiesStr, entityIdMap) {
	  var entityPermuteMap = {};
	  var permuteObject = {};
	  var permuteId = void 0;
	  if (!entitiesStr) {
	    permuteObject = getBucketPermuteIdAndNames({}, entitiesStr, {});
	    permuteId = permuteObject.permuteId;
	    entityPermuteMap[permuteId] = {};
	    entityPermuteMap[permuteId].ids = permuteObject.ids;
	    entityPermuteMap[permuteId].names = permuteObject.names;
	  } else {
	    (0, _each2.default)(dataBuckets, function (bucket) {
	      permuteObject = getBucketPermuteIdAndNames(bucket, entitiesStr, entityIdMap);
	      permuteId = permuteObject.permuteId;
	      entityPermuteMap[permuteId] = {};
	      entityPermuteMap[permuteId].ids = permuteObject.ids;
	      entityPermuteMap[permuteId].names = permuteObject.names;
	    });
	  }
	  return entityPermuteMap;
	};
	
	var getEntityIdForEntityTypeForCustomReport = function getEntityIdForEntityTypeForCustomReport(entity) {
	  return entity;
	};
	
	var getSourcesIdsFromResponse = exports.getSourcesIdsFromResponse = function getSourcesIdsFromResponse() {
	  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var type = arguments[1];
	  var entitiesMap = arguments[2];
	
	  var responseData = response || {};
	  var data = responseData.data || {};
	  var buckets = data && data[type] && data[type].buckets || [];
	  var sourceIds = [];
	  var entitiesStr = response && response.query && response.query.buckets;
	  if (entitiesStr) {
	    (0, _each2.default)(buckets, function (bucket) {
	      var permuteObject = getBucketPermuteIdAndNames(bucket, entitiesStr, entitiesMap);
	      sourceIds.push(permuteObject.permuteId);
	    });
	  } else {
	    sourceIds.push('1');
	  }
	  return sourceIds;
	};
	
	var getBucketPermuteIdAndNamesForCustomReport = exports.getBucketPermuteIdAndNamesForCustomReport = function getBucketPermuteIdAndNamesForCustomReport(bucket, entitiesStr) {
	  var idSeparator = '__';
	  var ids = [];
	  var names = [];
	  var tooltipLabel = [];
	  var entityId = void 0;
	  var entityName = '';
	  if (!entitiesStr) {
	    entityId = '1';
	    entityName = 'ALL_DATA';
	    ids.push(entityId);
	    names.push(entityName);
	  } else {
	    var entities = entitiesStr.split(',');
	    (0, _each2.default)(entities, function (entity) {
	      entityId = bucket[getEntityIdForEntityTypeForCustomReport(entity)] || 'UNAUTHORIZED';
	      ids.push(entityId);
	      if (entity.includes('Id')) {
	        entityName = bucket[entity.replace('Id', 'Name')] || entityId;
	        entityName = (0, _isEmpty2.default)(entityName) || (0, _isUndefined2.default)(entityName) || entityName === 'UNAUTHORIZED' ? 'Unauthorized' : entityName;
	        tooltipLabel.push(entityName);
	      } else {
	        entityName = entityId;
	        tooltipLabel.push(entityName);
	      }
	      entityName = (0, _isEmpty2.default)(entityName) || (0, _isUndefined2.default)(entityName) ? 'Unauthorized' : entityName;
	      names.push(entityName);
	    });
	  }
	  var permuteId = ids.join(idSeparator);
	  return {
	    permuteId: permuteId,
	    names: names,
	    ids: ids,
	    tooltipLabel: tooltipLabel
	  };
	};
	
	var getSourcesIdsFromResponseForCustomReport = exports.getSourcesIdsFromResponseForCustomReport = function getSourcesIdsFromResponseForCustomReport() {
	  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var selectedDataSource = arguments[1];
	
	  var responseData = response || {};
	  var sourceIds = [];
	  var entitiesArray = [];
	  selectedDataSource.forEach(function (dataSource) {
	    entitiesArray.push(dataSource.dimension);
	  });
	  var entitiesStr = entitiesArray.join(',');
	  if (entitiesStr) {
	    (0, _each2.default)(responseData, function (data) {
	      var permuteObject = getBucketPermuteIdAndNamesForCustomReport(data, entitiesStr);
	      if (permuteObject.permuteId) {
	        sourceIds.push(permuteObject.permuteId);
	      }
	    });
	  } else {
	    sourceIds.push('1');
	  }
	  return sourceIds;
	};
	
	var getOrgMapFromResponse = exports.getOrgMapFromResponse = function getOrgMapFromResponse() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var orgMap = {};
	  if (data && data.usageTs) {
	    (0, _each2.default)(data.usageTs, function (bucket) {
	      if (bucket.usage && bucket.usage.length) {
	        (0, _each2.default)(bucket.usage, function (item) {
	          if (!orgMap[item.orgId]) {
	            orgMap[item.orgId] = item.orgName;
	          }
	        });
	      }
	    });
	  }
	  return orgMap;
	};
	
	var getDefaultSharedMutations = exports.getDefaultSharedMutations = function getDefaultSharedMutations(sourceIds, keyMetric) {
	  var sharedMutations = {};
	  (0, _each2.default)(sourceIds, function (permuteId) {
	    var defaultMetricVal = {
	      show: true,
	      hover: false
	    };
	    sharedMutations[permuteId] = {
	      show: true,
	      metrics: _defineProperty({}, keyMetric, defaultMetricVal)
	    };
	  });
	  return sharedMutations;
	};
	
	var SOURCE_METRIC_SEPARATOR = '___';
	var getMetricKey = exports.getMetricKey = function getMetricKey(id, metric) {
	  return '' + id + SOURCE_METRIC_SEPARATOR + metric;
	};
	var getSourceFromMetricKey = exports.getSourceFromMetricKey = function getSourceFromMetricKey(metricKey) {
	  return metricKey.split(SOURCE_METRIC_SEPARATOR)[0];
	};
	var getMetricFromMetricKey = exports.getMetricFromMetricKey = function getMetricFromMetricKey(metricKey) {
	  return metricKey.includes(SOURCE_METRIC_SEPARATOR) && metricKey.split(SOURCE_METRIC_SEPARATOR)[1] || '';
	};

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(27);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(105);
	
	var _application = __webpack_require__(102);
	
	var _dashboard = __webpack_require__(604);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _application2 = __webpack_require__(86);
	
	var _dashboard3 = __webpack_require__(285);
	
	var _portalConfig = __webpack_require__(26);
	
	var _Main = __webpack_require__(1640);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _GuestDashboard = __webpack_require__(1634);
	
	var _GuestDashboard2 = _interopRequireDefault(_GuestDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GUEST_DASHBOARD_URL = '/admin/app/guest/dashboard';
	
	var isGuestUser = function isGuestUser() {
	  return window.location.href.indexOf(GUEST_DASHBOARD_URL) > -1;
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    autoSuggestionsApis: (0, _application2.getAvailableApis)(state),
	    autoSuggestionsApps: (0, _application2.getAvailableApps)(state),
	    autoSuggestionsOrgs: (0, _application2.getAvailableOrgs)(state),
	    userContexts: (0, _portalConfig.getUserDetails)(state),
	    entities: (0, _dashboard3.getDashboardEntityCount)(state),
	    chartData: (0, _dashboard3.getDashboardChartData)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchAvailableApis: function fetchAvailableApis(searchText) {
	      return dispatch((0, _application.fetchAvailableApis)({
	        searchText: searchText
	      }));
	    },
	    fetchAvailableApps: function fetchAvailableApps(searchText) {
	      return dispatch((0, _application.fetchAvailableApps)({
	        searchText: searchText
	      }));
	    },
	    fetchAvailableOrgs: function fetchAvailableOrgs(searchText) {
	      return dispatch((0, _application.fetchAvailableOrgs)({
	        searchText: searchText
	      }));
	    },
	    fetchDashboardEntityCount: function fetchDashboardEntityCount() {
	      return dispatch((0, _dashboard2.default)());
	    },
	    fetchDashboardChartData: function fetchDashboardChartData(query, entity) {
	      return dispatch((0, _dashboard.fetchDashboardChartData)(JSON.stringify(query), entity));
	    }
	  };
	};
	
	var Wrapper = function Wrapper(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    props.children
	  );
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.branch)(isGuestUser, (0, _recompose.renderComponent)(_GuestDashboard2.default), (0, _recompose.renderComponent)(_Main2.default)))(Wrapper);

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionsRaw = exports.processErrors = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _lodash = __webpack_require__(8);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _ExpandLess = __webpack_require__(114);
	
	var _ExpandLess2 = _interopRequireDefault(_ExpandLess);
	
	var _ExpandMore = __webpack_require__(81);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _components = __webpack_require__(17);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1648);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processErrors = exports.processErrors = function processErrors(errors, defaultMessage) {
	  var errorMessage = void 0;
	  if (errors.length > 0) {
	    errorMessage = (0, _lodash.map)(errors, function (validationError) {
	      return validationError.error;
	    }).join('\n');
	  }
	  return errorMessage || defaultMessage;
	};
	
	var ActionsRaw = exports.ActionsRaw = function ActionsRaw(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var gatewayBundleDetails = props.gatewayBundleDetails,
	      notifyMessages = props.notifyMessages,
	      deleteBundleErrors = props.deleteBundleErrors,
	      isBundleDeleteSuccess = props.isBundleDeleteSuccess;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showDeleteDialog = _useState4[0],
	      setShowDeleteDialog = _useState4[1];
	
	  var bundleUuid = (0, _lodash.get)(gatewayBundleDetails, 'uuid');
	  var bundleName = (0, _lodash.get)(gatewayBundleDetails, 'name');
	  var deletable = (0, _lodash.get)(gatewayBundleDetails, 'deletable', true);
	
	  var handleClick = function handleClick() {
	    setOpen(!open);
	  };
	  var handleClickAway = function handleClickAway() {
	    setOpen(false);
	  };
	  var openDeleteDialog = function openDeleteDialog() {
	    return setShowDeleteDialog(true);
	  };
	  var closeDeleteDialog = function closeDeleteDialog() {
	    return setShowDeleteDialog(false);
	  };
	
	  var onDelete = function onDelete() {
	    props.deleteGatewayBundle(bundleUuid);
	    closeDeleteDialog();
	  };
	
	  var actions = [{
	    key: 'delete',
	    value: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.delete.button'),
	    onClick: function onClick() {
	      if (deletable) {
	        openDeleteDialog();
	      }
	    },
	    visible: true,
	    disabled: !deletable,
	    disabledTooltip: !deletable ? (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.actions.delete.disabled.tooltip') : ''
	  }];
	
	  (0, _react.useEffect)(function () {
	    if (isBundleDeleteSuccess) {
	      props.push('/publish/gateway-bundles');
	    }
	  }, [isBundleDeleteSuccess]);
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _lodash.isEmpty)(deleteBundleErrors)) {
	      notifyMessages(_constants.ALERT_ERROR, processErrors(deleteBundleErrors, intl.getI18nMessage('error.gateway.bundle.delete')));
	    }
	  }, [deleteBundleErrors]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: 'gateway-bundle-details-actions-container',
	      'data-apim-test': 'gateway-bundle-details-actions-container',
	      className: classes.actionsContainer
	    },
	    showDeleteDialog && _react2.default.createElement(_components.AlertDialog, {
	      id: 'gateway-bundle-details-delete-dialog',
	      isOpen: showDeleteDialog,
	      title: intl.getI18nMessage('label.delete.confirmation.title'),
	      description: intl.getI18nMessage('label.gateway.bundle.delete.confirmation.text', { bundleName: bundleName }),
	      submitText: intl.getI18nMessage('label.delete.button'),
	      cancelText: intl.getI18nMessage('label.cancel.button'),
	      onClose: closeDeleteDialog,
	      onSubmit: onDelete,
	      onCancel: closeDeleteDialog,
	      submitButtonClass: classes.submitButton
	    }),
	    _react2.default.createElement(
	      _core.ClickAwayListener,
	      { onClickAway: handleClickAway },
	      _react2.default.createElement(
	        _core.List,
	        { component: 'nav' },
	        _react2.default.createElement(
	          _core.ListItem,
	          { id: 'gateway-bundle-details-actions-button', 'data-apim-test': 'gateway-bundle-details-actions-button', classes: { root: classes.listButton }, button: true, onClick: handleClick },
	          _react2.default.createElement(_core.ListItemText, { primary: (0, _intl.getI18nFormattedMessage)('label.actions.button') }),
	          open ? _react2.default.createElement(_ExpandLess2.default, null) : _react2.default.createElement(_ExpandMore2.default, null)
	        ),
	        _react2.default.createElement(
	          _core.Collapse,
	          { className: classes.collapseContainer, 'in': open },
	          _react2.default.createElement(
	            _core.List,
	            { className: classes.list, component: 'div', disablePadding: true },
	            actions.filter(function (_ref) {
	              var visible = _ref.visible;
	              return visible;
	            }).map(function (_ref2) {
	              var key = _ref2.key,
	                  value = _ref2.value,
	                  disabled = _ref2.disabled,
	                  disabledTooltip = _ref2.disabledTooltip,
	                  onClick = _ref2.onClick;
	              return _react2.default.createElement(
	                _core.Tooltip,
	                {
	                  arrow: true, disableFocusListener: true, disableTouchListener: true, placement: 'top',
	                  title: disabledTooltip,
	                  key: key
	                },
	                _react2.default.createElement(
	                  _core.ListItem,
	                  {
	                    id: key,
	                    'data-apim-test': key,
	                    button: true,
	                    className: (0, _clsx2.default)('action', classes.listItem),
	                    disabled: disabled,
	                    onClick: onClick
	                  },
	                  _react2.default.createElement(_core.ListItemText, { primary: value })
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	ActionsRaw.propTypes = {
	  gatewayBundleDetails: (0, _propTypes.shape)({}),
	  notifyMessages: _propTypes.func,
	  deleteBundleErrors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  isBundleDeleteSuccess: _propTypes.bool
	};
	
	ActionsRaw.displayName = 'Actions';
	
	exports.default = ActionsRaw;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography,
	      borderRadius = _ref.borderRadius,
	      margin = _ref.margin,
	      padding = _ref.padding;
	  return {
	    actionsContainer: {
	      display: 'inline-block',
	      float: 'right',
	      backgroundColor: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      borderColor: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      borderRadius: (0, _lodash.get)(borderRadius, 'br4'),
	      margin: '0 ' + (0, _lodash.get)(margin, 'm36'),
	      color: (0, _lodash.get)(color, 'primaryButtonText'),
	      '& nav': {
	        padding: (0, _lodash.get)(padding, 'p0'),
	        '& > div > div > span': {
	          color: (0, _lodash.get)(color, 'primaryButtonText')
	        }
	      },
	      minWidth: 160
	    },
	    collapseContainer: {
	      position: 'absolute',
	      width: '100%',
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderRadius: (0, _lodash.get)(borderRadius, 'br4'),
	      zIndex: 1
	    },
	    listButton: {
	      paddingTop: (0, _lodash.get)(padding, 'p5'),
	      paddingBottom: (0, _lodash.get)(padding, 'p5')
	    },
	    list: {
	      boxShadow: '0px 4px 8px #00000033',
	      '& > div:first-child': {
	        borderRadius: '3px 3px 0 0'
	      },
	      '& > div:last-child': {
	        borderRadius: '0 0 3px 3px'
	      },
	      '& .MuiButtonBase-root.Mui-disabled': {
	        pointerEvents: 'auto'
	      },
	      backgroundColor: (0, _lodash.get)(color, 'color.white'),
	      borderColor: (0, _lodash.get)(color, 'color.white'),
	      color: (0, _lodash.get)(color, 'color.grayDark')
	    },
	    listItem: {
	      color: (0, _lodash.get)(color, 'link'),
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderRadius: (0, _lodash.get)(borderRadius, 'br4')
	    },
	    submitButton: {
	      backgroundColor: (0, _lodash.get)(color, 'red') + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterAndSortSeparator = exports.SortBy = exports.FilterByStates = exports.FilterByTags = exports.FilterByProxyName = exports.FilterByApiName = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterByApiName = exports.FilterByApiName = function FilterByApiName(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'gateway-bundles-apis-filter-by-apiName',
	      'data-apim-test': 'gateway-bundles-apis-filter-by-apiName'
	    }))
	  );
	};
	
	var FilterByProxyName = exports.FilterByProxyName = function FilterByProxyName(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'gateway-bundles-apis-filter-by-proxyName',
	      'data-apim-test': 'gateway-bundles-apis-filter-by-proxyName'
	    }))
	  );
	};
	
	var FilterByTags = exports.FilterByTags = function FilterByTags(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormAutoCompleteCombo, Object.assign({}, props, {
	      id: 'gateway-bundles-apis-filter-by-tags',
	      'data-apim-test': 'gateway-bundles-apis-filter-by-tags'
	    }))
	  );
	};
	
	var FilterByStates = exports.FilterByStates = function FilterByStates(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 2 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'gateway-bundles-apis-filter-state-by',
	      'data-apim-test': 'gateway-bundles-apis-filter-state-by',
	      data: _constants.GATEWAY_BUNDLES_API_STATES_FILTER_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var SortBy = exports.SortBy = function SortBy(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'gateway-bundles-apis-sort-by',
	      'data-apim-test': 'gateway-bundles-apis-sort-by',
	      data: _constants.GATEWAY_BUNDLES_API_SORT_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var FilterAndSortSeparator = exports.FilterAndSortSeparator = function FilterAndSortSeparator() {
	  return _react2.default.createElement(_core.Grid, { item: true, md: 1 });
	};

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApiListRaw = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _gatewayBundle = __webpack_require__(154);
	
	var _gatewayBundle2 = __webpack_require__(123);
	
	var _styles = __webpack_require__(1651);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _constants = __webpack_require__(14);
	
	var _controls = __webpack_require__(1649);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GATEWAY_BUNDLES_LIST_COLUMNS = [{
	  id: 'apiName',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.name'),
	  minWidth: 100,
	  link: '/publish/apis/details'
	}, {
	  id: 'apiVersion',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.version'),
	  minWidth: 50
	}, {
	  id: 'apiProxies',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.deployed.proxies'),
	  minWidth: 50
	}, {
	  id: 'apiModifyTs',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.date.modified', { zone: (0, _datetime.getTimeZoneAbbr)() }),
	  format: function format(value) {
	    return (0, _datetime2.default)(value);
	  },
	  minWidth: 50
	}, {
	  id: 'apiPortalStatus',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.state'),
	  minWidth: 50
	}];
	
	var ApiListRaw = exports.ApiListRaw = function ApiListRaw(props) {
	  var bundleUuid = props.bundleUuid,
	      classes = props.classes,
	      isLoading = props.isLoading,
	      totalPages = props.totalPages,
	      _props$totalElements = props.totalElements,
	      totalElements = _props$totalElements === undefined ? 0 : _props$totalElements,
	      _props$results = props.results,
	      results = _props$results === undefined ? [] : _props$results;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      filterByName = _useState2[0],
	      setFilterByName = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      filterByProxyName = _useState4[0],
	      setFilterByProxyName = _useState4[1];
	
	  var _useState5 = (0, _react.useState)('all'),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filterByState = _useState6[0],
	      setFilterByState = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      filterByNameApplied = _useState8[0],
	      setFilterByNameApplied = _useState8[1];
	
	  var _useState9 = (0, _react.useState)('apiModifyTs,DESC'),
	      _useState10 = _slicedToArray(_useState9, 2),
	      sortBy = _useState10[0],
	      setSortBy = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      page = _useState12[0],
	      setPage = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(_constants.GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState14 = _slicedToArray(_useState13, 2),
	      rowsPerPage = _useState14[0],
	      setRowsPerPage = _useState14[1];
	
	  var emptyFunction = function emptyFunction() {};
	
	  (0, _react.useEffect)(function () {
	    if (bundleUuid) {
	      props.fetchGatewayBundlesApis(bundleUuid, filterByName, filterByProxyName, filterByState, sortBy, page, rowsPerPage);
	    }
	  }, []);
	
	  var onFilterByNameChange = function onFilterByNameChange(value) {
	    setFilterByName(value);
	  };
	
	  var onFilterByNameKeyPress = function onFilterByNameKeyPress(e) {
	    if (e.key === 'Enter') {
	      setFilterByNameApplied(true);
	      props.fetchGatewayBundlesApis(bundleUuid, filterByName, filterByProxyName, filterByState, sortBy, page, rowsPerPage);
	    }
	  };
	
	  var onFilterByProxyNameChange = function onFilterByProxyNameChange(value) {
	    setFilterByProxyName(value);
	  };
	
	  var onFilterByProxyNameKeyPress = function onFilterByProxyNameKeyPress(e) {
	    if (e.key === 'Enter') {
	      setFilterByNameApplied(true);
	      props.fetchGatewayBundlesApis(bundleUuid, filterByName, filterByProxyName, filterByState, sortBy, page, rowsPerPage);
	    }
	  };
	
	  var onFilterByStateChange = function onFilterByStateChange(newStateBy) {
	    setFilterByState(newStateBy);
	    props.fetchGatewayBundlesApis(bundleUuid, filterByName, filterByProxyName, newStateBy, sortBy, page, rowsPerPage);
	  };
	
	  var onSortByChange = function onSortByChange(newSortBy) {
	    setSortBy(newSortBy);
	    props.fetchGatewayBundlesApis(bundleUuid, filterByName, filterByProxyName, filterByState, newSortBy, page, rowsPerPage);
	  };
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    props.fetchGatewayBundlesApis(bundleUuid, filterByName, filterByProxyName, filterByState, sortBy, newPage, rowsPerPage);
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    props.fetchGatewayBundlesApis(bundleUuid, filterByName, filterByProxyName, filterByState, sortBy, 0, newRowsPerPage);
	  };
	
	  var noResultsMessage = filterByNameApplied ? '' + intl.getI18nMessage('label.gateway.bundle.apis.filter.no.results') : intl.getI18nMessage('label.gateway.bundle.apis.no.results');
	
	  return _react2.default.createElement(_list2.default, {
	    listPageId: 'gateway-bundle-apis-list',
	    isLoading: isLoading,
	    notificationId: 'gateway-bundle-notifications',
	    notificationStatus: '',
	    setNotificationStatus: emptyFunction,
	    notificationMessage: '',
	    setNotificationMessage: emptyFunction,
	    pageHeaderTitle: '',
	    pageHeaderTooltipTitle: '',
	    addButtonLabel: '',
	    onAddBundle: emptyFunction,
	    showListHeader: false,
	    pageClass: classes.listContent,
	    pageBodyClass: classes.pageBodyClass,
	    pageFilterAndSortClass: classes.pageFilterAndSortClass,
	    filterAndSortContent: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_controls.FilterByApiName, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        value: filterByName,
	        placeholder: intl.getI18nMessage('label.gateway.bundle.apis.filter.by.name.placeholder'),
	        handleChange: onFilterByNameChange,
	        onKeyPress: onFilterByNameKeyPress
	      }),
	      _react2.default.createElement(_controls.FilterByProxyName, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        value: filterByProxyName,
	        placeholder: intl.getI18nMessage('label.gateway.bundle.apis.filter.by.proxy.name.placeholder'),
	        handleChange: onFilterByProxyNameChange,
	        onKeyPress: onFilterByProxyNameKeyPress,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterByStates, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        selectFieldClass: classes.selectField,
	        value: filterByState,
	        handleChange: onFilterByStateChange,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterAndSortSeparator, null),
	      _react2.default.createElement(_controls.SortBy, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.sort.by'),
	        value: sortBy,
	        handleChange: onSortByChange
	      })
	    ),
	    columns: GATEWAY_BUNDLES_LIST_COLUMNS,
	    rows: results,
	    noResultsMessage: noResultsMessage,
	    page: page,
	    totalElements: totalElements,
	    totalPages: totalPages,
	    rowsPerPage: rowsPerPage,
	    rowsPerPageOptions: _constants.GRID_ROWS_PER_PAGE_OPTIONS,
	    onChangeRowsPerPage: onChangeRowsPerPage,
	    onChangePage: onChangePage,
	    onChangePreviousPage: onChangePreviousPage,
	    onChangeNextPage: onChangeNextPage
	  });
	};
	
	ApiListRaw.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  isLoading: _propTypes.bool,
	  totalPages: _propTypes.number,
	  totalElements: _propTypes.number,
	  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  fetchGatewayBundlesApis: _propTypes.func,
	  bundleUuid: _propTypes.string
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoading: false,
	    totalPages: (0, _gatewayBundle2.getGatewayBundlesApisListTotalPages)(state),
	    totalElements: (0, _gatewayBundle2.getGatewayBundlesApisListTotalElements)(state),
	    results: (0, _gatewayBundle2.getGatewayBundlesApisListResults)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchGatewayBundlesApis: _gatewayBundle.fetchGatewayBundlesApis
	};
	ApiListRaw.displayName = 'Apis';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ApiListRaw);

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var padding = _ref.padding,
	      margin = _ref.margin;
	  return {
	    listContent: {
	      margin: (0, _lodash.get)(margin, 'm0')
	    },
	    pageBodyClass: {
	      paddingTop: (0, _lodash.get)(padding, 'p0')
	    },
	    pageFilterAndSortClass: {
	      marginTop: (0, _lodash.get)(margin, 'm24')
	    },
	    fieldContainer: {
	      margin: (0, _lodash.get)(margin, 'm0') + ' !important'
	    },
	    selectField: {
	      padding: '2px 10px !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DeploymentsCard = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(16);
	
	var _lodash = __webpack_require__(8);
	
	var _core = __webpack_require__(3);
	
	var _Lens = __webpack_require__(172);
	
	var _Lens2 = _interopRequireDefault(_Lens);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _AlertDialog = __webpack_require__(197);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _deployment = __webpack_require__(205);
	
	var _utils = __webpack_require__(18);
	
	var _constants = __webpack_require__(619);
	
	var _styles = __webpack_require__(618);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeploymentsCard = exports.DeploymentsCard = function DeploymentsCard(_ref) {
	  var index = _ref.index,
	      _ref$details = _ref.details,
	      gatewayBundleUuid = _ref$details.gatewayBundleUuid,
	      proxyUuid = _ref$details.proxyUuid,
	      name = _ref$details.name,
	      _ref$details$status = _ref$details.status,
	      status = _ref$details$status === undefined ? _constants.DEPLOYMENT_STATUS_NOT_DEPLOYED : _ref$details$status,
	      statusMessage = _ref$details.statusMessage,
	      modifyTs = _ref$details.modifyTs,
	      deployedGatewayBundleVersion = _ref$details.deployedGatewayBundleVersion,
	      latestGatewayBundleVersion = _ref$details.latestGatewayBundleVersion,
	      _ref$errorObj = _ref.errorObj,
	      errorObj = _ref$errorObj === undefined ? {} : _ref$errorObj,
	      _ref$refreshTime = _ref.refreshTime,
	      refreshTime = _ref$refreshTime === undefined ? 10 : _ref$refreshTime,
	      deployGatewayBundle = _ref.deployGatewayBundle,
	      redeployGatewayBundle = _ref.redeployGatewayBundle,
	      undeployGatewayBundle = _ref.undeployGatewayBundle,
	      checkStatus = _ref.checkStatus,
	      classes = _ref.classes;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showStatusDialog = _useState2[0],
	      setShowStatusDialog = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showConfirmDialog = _useState4[0],
	      setShowConfirmDialog = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      confirmAction = _useState6[0],
	      setConfirmAction = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      updating = _useState8[0],
	      setUpdating = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(parseInt(refreshTime, 10)),
	      _useState10 = _slicedToArray(_useState9, 2),
	      timer = _useState10[0],
	      setTimer = _useState10[1];
	
	  var lastModified = modifyTs ? (0, _datetime2.default)(modifyTs) : (0, _intl.getI18nFormattedMessage)('label.not.applicable');
	  var errorMessage = (0, _lodash.get)(errorObj, 'errorMessage');
	
	  var startAction = function startAction(action) {
	    switch (action) {
	      case _constants.DEPLOYMENT_ACTION_TYPE_DEPLOY:
	        {
	          deployGatewayBundle(gatewayBundleUuid, proxyUuid);
	          break;
	        }
	      case _constants.DEPLOYMENT_ACTION_TYPE_REDEPLOY:
	        {
	          redeployGatewayBundle(gatewayBundleUuid, proxyUuid);
	          break;
	        }
	      case _constants.DEPLOYMENT_ACTION_TYPE_UNDEPLOY:
	        {
	          undeployGatewayBundle(gatewayBundleUuid, proxyUuid);
	          break;
	        }
	      default:
	        {
	          break;
	        }
	    }
	    setUpdating(!updating);
	  };
	
	  var stopAction = function stopAction() {
	    setTimer(refreshTime);
	    setUpdating(false);
	    checkStatus(proxyUuid);
	  };
	
	  (0, _react.useEffect)(function () {
	    var interval = null;
	    if (updating) {
	      interval = setInterval(function () {
	        setTimer(timer - 1);
	        if (timer === 1) {
	          stopAction();
	          clearInterval(interval);
	        }
	      }, 1000);
	    } else if (!updating && timer !== refreshTime) {
	      clearInterval(interval);
	    }
	    return function () {
	      return clearInterval(interval);
	    };
	  }, [updating, timer]);
	
	  var statusLabel = '';
	  var statusColor = '';
	  if (errorMessage) {
	    statusLabel = (0, _intl.getI18nFormattedMessage)('error.validation.error');
	    statusColor = (0, _deployment.getDeployedStatusColor)(_constants.DEPLOYMENT_STATUS_ERROR);
	  } else {
	    statusLabel = status === _constants.DEPLOYMENT_STATUS_ERROR ? (0, _intl.getI18nFormattedMessage)('error.deployment.error') : (0, _deployment.getDeployedStatusLabel)(status);
	    statusColor = (0, _deployment.getDeployedStatusColor)(status);
	  }
	  lastModified = modifyTs ? (0, _datetime2.default)(modifyTs) : (0, _intl.getI18nFormattedMessage)('label.not.applicable');
	
	  var statusStyle = {
	    color: statusColor
	  };
	
	  var openStatusDialog = function openStatusDialog() {
	    return setShowStatusDialog(true);
	  };
	  var closeStatusDialog = function closeStatusDialog() {
	    return setShowStatusDialog(false);
	  };
	
	  var openConfirmDialog = function openConfirmDialog(action) {
	    setShowConfirmDialog(true);
	    setConfirmAction(action);
	  };
	
	  var closeConfirmDialog = function closeConfirmDialog() {
	    setShowConfirmDialog(false);
	    setConfirmAction('');
	  };
	
	  var saveConfirmDialog = function saveConfirmDialog() {
	    startAction(confirmAction);
	    closeConfirmDialog();
	  };
	
	  var MoreInfo = function MoreInfo() {
	    return _react2.default.createElement(
	      'span',
	      { 'data-test': 'moreInfoBtn' },
	      _react2.default.createElement(
	        _core.Button,
	        { onClick: function onClick() {
	            return openStatusDialog();
	          } },
	        (0, _intl.getI18nFormattedMessage)('label.more.info')
	      )
	    );
	  };
	
	  var CheckStatus = function CheckStatus() {
	    return _react2.default.createElement(
	      'span',
	      { 'data-test': 'checkStatusBtn' },
	      _react2.default.createElement(
	        _core.Button,
	        { onClick: function onClick() {
	            return stopAction();
	          } },
	        (0, _intl.getI18nFormattedMessage)('label.check.now')
	      )
	    );
	  };
	
	  var DeploymentActions = function DeploymentActions() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      status === _constants.DEPLOYMENT_STATUS_NOT_DEPLOYED && _react2.default.createElement(
	        'span',
	        { 'data-test': 'deployBtn' },
	        _react2.default.createElement(
	          _core.Button,
	          { onClick: function onClick() {
	              return openConfirmDialog(_constants.DEPLOYMENT_ACTION_TYPE_DEPLOY);
	            } },
	          (0, _intl.getI18nFormattedMessage)('label.deploy')
	        )
	      ),
	      status !== _constants.DEPLOYMENT_STATUS_NOT_DEPLOYED && status !== _constants.DEPLOYMENT_STATUS_UNDEPLOYED_ERROR && (!deployedGatewayBundleVersion || latestGatewayBundleVersion === deployedGatewayBundleVersion) && _react2.default.createElement(
	        'span',
	        { 'data-test': 'redeployBtn' },
	        _react2.default.createElement(
	          _core.Button,
	          { onClick: function onClick() {
	              return openConfirmDialog(_constants.DEPLOYMENT_ACTION_TYPE_REDEPLOY);
	            } },
	          (0, _intl.getI18nFormattedMessage)('label.redeploy')
	        )
	      ),
	      status !== _constants.DEPLOYMENT_STATUS_NOT_DEPLOYED && _react2.default.createElement(
	        'span',
	        { 'data-test': 'undeployBtn' },
	        _react2.default.createElement(
	          _core.Button,
	          { onClick: function onClick() {
	              return openConfirmDialog(_constants.DEPLOYMENT_ACTION_TYPE_UNDEPLOY);
	            } },
	          (0, _intl.getI18nFormattedMessage)('label.undeploy')
	        )
	      )
	    );
	  };
	
	  var UpdateActions = function UpdateActions() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'span',
	        { 'data-test': 'updateBtn' },
	        _react2.default.createElement(
	          _core.Button,
	          { onClick: function onClick() {
	              return openConfirmDialog(_constants.DEPLOYMENT_ACTION_TYPE_REDEPLOY);
	            } },
	          (0, _intl.getI18nFormattedMessage)('label.update')
	        )
	      )
	    );
	  };
	
	  var renderHelpText = function renderHelpText() {
	    return _react2.default.createElement(
	      'p',
	      { className: classes.helpTextContainer },
	      'All Gateway Bundles are deployed On Demand, and this cannot be changed.'
	    );
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    showStatusDialog && _react2.default.createElement(_AlertDialog2.default, {
	      isOpen: showStatusDialog,
	      title: intl.getI18nMessage('label.information'),
	      description: errorMessage || (0, _utils.formatStatusMessage)(statusMessage),
	      submitText: intl.getI18nMessage('label.ok.button'),
	      cancelText: intl.getI18nMessage('label.cancel.button'),
	      onClose: function onClose() {
	        return closeStatusDialog();
	      },
	      onSubmit: function onSubmit() {
	        return closeStatusDialog();
	      },
	      onCancel: function onCancel() {
	        return closeStatusDialog();
	      },
	      showCancel: false,
	      dialogId: 'gateway-bundle-proxy-status-dialog'
	    }),
	    showConfirmDialog && _react2.default.createElement(_AlertDialog2.default, {
	      isOpen: showConfirmDialog,
	      title: intl.getI18nMessage('warning.status'),
	      description: intl.getI18nMessage('label.action.confirmation.text'),
	      submitText: intl.getI18nMessage('label.ok.button'),
	      cancelText: intl.getI18nMessage('label.cancel.button'),
	      onClose: function onClose() {
	        return closeConfirmDialog();
	      },
	      onSubmit: function onSubmit() {
	        return saveConfirmDialog();
	      },
	      onCancel: function onCancel() {
	        return closeConfirmDialog();
	      },
	      dialogId: 'gateway-bundle-proxy-action-dialog'
	    }),
	    _react2.default.createElement(
	      _core.Card,
	      {
	        key: 'gateway-bundle-deployment-card-' + index,
	        id: 'gateway-bundle-deployment-card-' + index,
	        'data-apim-test': 'gateway-deployment-card',
	        className: classes.card
	      },
	      _react2.default.createElement(
	        _core.CardContent,
	        null,
	        _react2.default.createElement(
	          _core.Typography,
	          null,
	          _react2.default.createElement(
	            'span',
	            { 'data-test': 'proxy-title', className: classes.linkWrapper },
	            _react2.default.createElement(
	              _core.Link,
	              { href: '/publish/api-proxy/details/' + proxyUuid },
	              _react2.default.createElement(
	                'h4',
	                { className: classes.cardTitle },
	                name
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { className: classes.cardLastUpdated },
	          intl.getI18nMessage('label.last.updated'),
	          ': ',
	          updating ? intl.getI18nMessage('label.updating') : lastModified
	        ),
	        _react2.default.createElement(_core.Divider, null),
	        _react2.default.createElement(
	          _core.Typography,
	          { className: classes.cardType },
	          _react2.default.createElement(
	            'span',
	            { 'data-test': 'deployment-type-label' },
	            intl.getI18nMessage('label.gateway.bundle.deployment.type')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ': ',
	            intl.getI18nMessage('label.gateway.bundle.deployment.ondemand')
	          ),
	          _react2.default.createElement(
	            _core.Tooltip,
	            { title: renderHelpText(), arrow: true, placement: 'right' },
	            _react2.default.createElement(_Help2.default, { className: classes.helpIcon })
	          )
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { className: classes.cardOldVersion },
	          _react2.default.createElement(
	            'span',
	            { 'data-test': 'deployment-version-label' },
	            intl.getI18nMessage('label.version')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ': ',
	            deployedGatewayBundleVersion
	          ),
	          latestGatewayBundleVersion && deployedGatewayBundleVersion && latestGatewayBundleVersion !== deployedGatewayBundleVersion && errorMessage && _react2.default.createElement(
	            'span',
	            null,
	            '(' + (0, _deployment.getDeployedStatusLabel)(_constants.DEPLOYMENT_STATUS_DEPLOYED) + ')'
	          )
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { component: 'div', className: classes.cardStatus },
	          updating ? _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_Lens2.default, { className: classes.cardStatusIcon }),
	            ' ' + intl.getI18nMessage('label.updating.status.check.in') + ' ' + timer + intl.getI18nMessage('label.unit.seconds') + '.'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: statusStyle },
	              _react2.default.createElement(_Lens2.default, { className: classes.cardStatusIcon }),
	              ' ',
	              statusLabel
	            )
	          ),
	          latestGatewayBundleVersion && deployedGatewayBundleVersion && latestGatewayBundleVersion !== deployedGatewayBundleVersion && _react2.default.createElement(
	            _core.Typography,
	            { className: classes.cardUpdateVersion },
	            _react2.default.createElement(
	              'span',
	              { 'data-test': 'deployment-update-version-label' },
	              intl.getI18nMessage('label.update.to.version')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ': ',
	              latestGatewayBundleVersion
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.deploymentButtonsContainer },
	            _react2.default.createElement(
	              'span',
	              { 'data-test': 'gateway-bundle-deployment-actions' },
	              latestGatewayBundleVersion && deployedGatewayBundleVersion && latestGatewayBundleVersion !== deployedGatewayBundleVersion && !updating && _react2.default.createElement(UpdateActions, null),
	              updating ? _react2.default.createElement(CheckStatus, null) : _react2.default.createElement(DeploymentActions, null)
	            ),
	            !updating && (errorMessage || statusMessage) && _react2.default.createElement(MoreInfo, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	DeploymentsCard.propTypes = {
	  index: _propTypes2.default.number,
	  details: _propTypes2.default.shape({
	    proxyUuid: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    status: _propTypes2.default.string,
	    statusMessage: _propTypes2.default.string,
	    modifyTs: _propTypes2.default.number
	  }),
	  errorObj: _propTypes2.default.shape({}),
	  refreshTime: _propTypes2.default.string,
	  deployGatewayBundle: _propTypes2.default.func,
	  redeployGatewayBundle: _propTypes2.default.func,
	  undeployGatewayBundle: _propTypes2.default.func,
	  checkStatus: _propTypes2.default.func,
	  classes: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(DeploymentsCard);

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterByDeploymentState = exports.FilterByName = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterByName = exports.FilterByName = function FilterByName(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'gateway-bundle-deployments-filter-by-name',
	      'data-apim-test': 'gateway-bundle-deployments-filter-by-name'
	    }))
	  );
	};
	
	var FilterByDeploymentState = exports.FilterByDeploymentState = function FilterByDeploymentState(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'gateway-bundle-deployments-filter-by-state',
	      'data-apim-test': 'gateway-bundle-deployments-filter-by-state',
	      data: _constants.DEPLOYMENT_FILTER_BY_STATE,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DeploymentsRaw = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _controls = __webpack_require__(1653);
	
	var _portalConfig = __webpack_require__(85);
	
	var _portalConfig2 = __webpack_require__(26);
	
	var _gatewayBundle = __webpack_require__(154);
	
	var _gatewayBundle2 = __webpack_require__(123);
	
	var _DeploymentCard = __webpack_require__(1652);
	
	var _DeploymentCard2 = _interopRequireDefault(_DeploymentCard);
	
	var _styles = __webpack_require__(618);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeploymentsRaw = exports.DeploymentsRaw = function DeploymentsRaw(props) {
	  var bundleUuid = props.bundleUuid,
	      gatewayBundleDetails = props.gatewayBundleDetails,
	      _props$deploymentProx = props.deploymentProxyList,
	      deploymentProxyList = _props$deploymentProx === undefined ? [] : _props$deploymentProx,
	      _props$deploymentErro = props.deploymentErrors,
	      deploymentErrors = _props$deploymentErro === undefined ? [] : _props$deploymentErro,
	      _props$listProxyError = props.listProxyErrors,
	      listProxyErrors = _props$listProxyError === undefined ? [] : _props$listProxyError,
	      notifyMessages = props.notifyMessages,
	      totalPages = props.totalPages,
	      _props$totalElements = props.totalElements,
	      totalElements = _props$totalElements === undefined ? 0 : _props$totalElements,
	      classes = props.classes;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      filterByName = _useState2[0],
	      setFilterByName = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('all'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      filterByState = _useState4[0],
	      setFilterByState = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      page = _useState6[0],
	      setPage = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(_constants.GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState8 = _slicedToArray(_useState7, 2),
	      rowsPerPage = _useState8[0],
	      setRowsPerPage = _useState8[1];
	
	  (0, _react.useEffect)(function () {
	    if (bundleUuid) {
	      props.fetchDeploymentProxyList(bundleUuid, filterByName, filterByState, page, rowsPerPage);
	      props.fetchDeploymentRefreshTime();
	    }
	  }, [bundleUuid]);
	
	  (0, _react.useEffect)(function () {
	    if (listProxyErrors.length > 0) {
	      notifyMessages(_constants.ALERT_ERROR, intl.getI18nMessage('error.gateway.bundle.proxy.list.fetch'));
	    } else {
	      notifyMessages('', '');
	    }
	  }, [listProxyErrors]);
	
	  var onFilterByNameChange = function onFilterByNameChange(value) {
	    setFilterByName(value);
	  };
	
	  var onFilterByNameKeyPress = function onFilterByNameKeyPress(e) {
	    if (e.key === 'Enter') {
	      props.fetchDeploymentProxyList(bundleUuid, filterByName, filterByState, page, rowsPerPage);
	    }
	  };
	
	  var onFilterByStateChange = function onFilterByStateChange(newFilterByState) {
	    setFilterByState(newFilterByState);
	    props.fetchDeploymentProxyList(bundleUuid, filterByName, newFilterByState, page, rowsPerPage);
	  };
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    props.fetchDeploymentProxyList(bundleUuid, filterByName, filterByState, newPage, rowsPerPage);
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    props.fetchDeploymentProxyList(bundleUuid, filterByName, filterByState, 0, newRowsPerPage);
	  };
	
	  var checkStatus = function checkStatus() {
	    props.fetchDeploymentStatus(bundleUuid, filterByName, filterByState, page, rowsPerPage);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: 'gatway-bundle-detailsdeployments-container',
	      'data-apim-test': 'gatway-bundle-detailsdeployments-container',
	      className: classes.deploymentsContainer
	    },
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, className: classes.bodyContent },
	      _react2.default.createElement(
	        _core.Grid,
	        {
	          container: true,
	          className: classes.filterContainer,
	          id: 'deployments-filter-container',
	          'data-apim-test': 'deployments-filter-container'
	        },
	        _react2.default.createElement(_controls.FilterByName, {
	          name: intl.getI18nMessage('label.filter.by'),
	          fieldContainerClass: classes.fieldContainer,
	          value: filterByName,
	          placeholder: intl.getI18nMessage('label.deployments.filter.by.name.placeholder'),
	          handleChange: onFilterByNameChange,
	          onKeyPress: onFilterByNameKeyPress
	        }),
	        _react2.default.createElement(_controls.FilterByDeploymentState, {
	          name: intl.getI18nMessage('label.filter.by'),
	          fieldContainerClass: classes.fieldContainer,
	          value: filterByState,
	          handleChange: onFilterByStateChange,
	          selectFieldClass: classes.selectField,
	          hideLabel: true
	        })
	      ),
	      deploymentProxyList.length > 0 ? deploymentProxyList.map(function (obj, idx) {
	        return _react2.default.createElement(
	          _core.Box,
	          { width: '25%', key: obj.proxyUuid, className: classes.deploymentCard },
	          _react2.default.createElement(_DeploymentCard2.default, {
	            index: idx,
	            details: {
	              name: obj.proxyName,
	              status: obj.status,
	              statusMessage: obj.message,
	              modifyTs: obj.lastTimeDeployed,
	              gatewayBundleUuid: obj.gatewayBundleUuid,
	              proxyUuid: obj.proxyUuid,
	              deployedGatewayBundleVersion: obj.deployedGatewayBundleVersion,
	              latestGatewayBundleVersion: gatewayBundleDetails.version
	            },
	            errorObj: deploymentErrors.find(function (err) {
	              return err.proxyUuid === obj.proxyUuid;
	            }),
	            refreshTime: props.refreshTime,
	            deployGatewayBundle: props.deployGatewayBundle,
	            redeployGatewayBundle: props.redeployGatewayBundle,
	            undeployGatewayBundle: props.undeployGatewayBundle,
	            checkStatus: checkStatus,
	            classes: classes
	          })
	        );
	      }) : _react2.default.createElement(
	        _core.Box,
	        { width: '100%' },
	        (0, _intl.getI18nFormattedMessage)('label.no.results')
	      )
	    ),
	    _react2.default.createElement(_components.TablePagination, {
	      id: 'gateway-bundle-deployments-pagination',
	      'data-apim-test': 'gateway-bundle-deployments-pagination',
	      page: page,
	      count: totalElements,
	      pageCount: totalPages,
	      rowsPerPage: rowsPerPage,
	      rowsPerPageOptions: _constants.GRID_ROWS_PER_PAGE_OPTIONS,
	      onChangeRowsPerPage: onChangeRowsPerPage,
	      onChangePage: onChangePage,
	      onChangePreviousPage: onChangePreviousPage,
	      onChangeNextPage: onChangeNextPage,
	      labelRowsPerPage: intl.getI18nMessage('label.pagination.items.per.page')
	    }),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    deploymentProxyList: (0, _gatewayBundle2.getGatewayBundleProxyListResults)(state),
	    totalPages: (0, _gatewayBundle2.getGatewayBundlesProxyListTotalPages)(state),
	    totalElements: (0, _gatewayBundle2.getGatewayBundlesProxyListTotalElements)(state),
	    refreshTime: (0, _portalConfig2.getDeploymentRefreshTime)(state),
	    deploymentErrors: (0, _gatewayBundle2.getProxyErrors)(state),
	    listProxyErrors: (0, _gatewayBundle2.getGatewayBundleProxyListErrors)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchDeploymentProxyList: _gatewayBundle.fetchDeploymentProxyList,
	  fetchDeploymentStatus: _gatewayBundle.fetchDeploymentStatus,
	  fetchDeploymentRefreshTime: _portalConfig.fetchDeploymentRefreshTime,
	  deployGatewayBundle: _gatewayBundle.deployGatewayBundle,
	  undeployGatewayBundle: _gatewayBundle.undeployGatewayBundle,
	  redeployGatewayBundle: _gatewayBundle.redeployGatewayBundle
	};
	
	DeploymentsRaw.propTypes = {
	  bundleUuid: _propTypes2.default.string,
	  gatewayBundleDetails: _propTypes2.default.shape({}),
	  deploymentProxyList: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  deploymentErrors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  totalPages: _propTypes2.default.number,
	  totalElements: _propTypes2.default.number,
	  classes: _propTypes2.default.shape({}),
	  undeployGatewayBundle: _propTypes2.default.func,
	  listProxyErrors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  notifyMessages: _propTypes2.default.func
	};
	DeploymentsRaw.displayName = 'Deployments';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(DeploymentsRaw);

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderRaw = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1656);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderRaw = exports.HeaderRaw = function HeaderRaw(props) {
	  var gatewayBundleDetails = props.gatewayBundleDetails;
	  var name = gatewayBundleDetails.name,
	      version = gatewayBundleDetails.version;
	
	
	  return _react2.default.createElement(_components.DetailsHeader, {
	    headerId: 'gateway-bundle-details-header-container',
	    title: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.details.page.title'),
	    name: name + '-' + version
	  });
	};
	
	HeaderRaw.propTypes = {
	  gatewayBundleDetails: _propTypes2.default.shape({})
	};
	HeaderRaw.displayName = 'Header';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default))(HeaderRaw);

/***/ },
/* 1656 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styles = function styles() {
	  return {};
	};
	
	exports.default = styles;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MetadataRaw = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _styles = __webpack_require__(1658);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _utils = __webpack_require__(18);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _components = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetadataRaw = exports.MetadataRaw = function MetadataRaw(props) {
	  var classes = props.classes,
	      gatewayBundleDetails = props.gatewayBundleDetails,
	      config = props.config,
	      apiUsage = props.apiUsage;
	  var name = gatewayBundleDetails.name,
	      version = gatewayBundleDetails.version,
	      description = gatewayBundleDetails.description,
	      type = gatewayBundleDetails.type,
	      groupName = gatewayBundleDetails.groupName,
	      l7Template = gatewayBundleDetails.l7Template,
	      createTs = gatewayBundleDetails.createTs;
	
	
	  var l7TemplateText = !(0, _lodash.isUndefined)(l7Template) ? l7Template.toString() : '';
	  var apiCount = l7Template ? apiUsage : 'N/A';
	  var link = (0, _lodash.get)(gatewayBundleDetails, '_links.metadata.href');
	  var hostname = (0, _lodash.get)(config, 'portal.hostname');
	  var tenantPrefix = (0, _lodash.get)(config, 'portal.tenantPrefix');
	  var url = hostname + '/api/' + tenantPrefix + link;
	  var fileName = name + '-' + version + '.metadata.yml';
	  var dateUploaded = createTs && (0, _datetime2.default)(createTs);
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: 'gateway-bundle-details-metadata-container',
	      'data-apim-test': 'gateway-bundle-details-metadata-container'
	    },
	    _react2.default.createElement(
	      _core.Grid,
	      {
	        container: true,
	        id: 'metadata-top-panel-container',
	        'data-apim-test': 'metadata-top-panel-container',
	        className: classes.topPanelContainer
	      },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 5 },
	        _react2.default.createElement(_components.DetailsPanelContainer, {
	          id: 'metadata-type-container',
	          title: intl.getI18nMessage('label.type'),
	          subTitle: (0, _utils.getTitleCaseText)(type)
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 2 },
	        _react2.default.createElement(_components.DetailsPanelContainer, {
	          id: 'metadata-reusable-container',
	          title: intl.getI18nMessage('label.gateway.bundle.details.l7Template'),
	          tooltip: intl.getI18nMessage('label.gateway.bundle.details.l7Template.tooltip'),
	          subTitle: (0, _utils.getTitleCaseText)(l7TemplateText)
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 2 },
	        _react2.default.createElement(_components.DetailsPanelContainer, {
	          id: 'metadata-apis-container',
	          title: intl.getI18nMessage('label.apis'),
	          tooltip: intl.getI18nMessage('label.gateway.bundle.details.apis.tooltip'),
	          subTitle: apiCount
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 3 },
	        _react2.default.createElement(_components.DetailsPanelContainer, {
	          id: 'metadata-date-uploaded-container',
	          title: intl.getI18nMessage('label.gateway.bundle.date.created', { zone: (0, _datetime.getTimeZoneAbbr)() }),
	          subTitle: dateUploaded
	        })
	      )
	    ),
	    _react2.default.createElement(_core.Divider, { className: classes.divider }),
	    _react2.default.createElement(
	      _core.Grid,
	      {
	        container: true,
	        id: 'metadata-bottom-panel-container',
	        'data-apim-test': 'metadata-bottom-panel-container',
	        className: classes.bottomPanelContainer
	      },
	      _react2.default.createElement(
	        _core.Grid,
	        {
	          item: true,
	          md: 7,
	          id: 'metadata-description-container',
	          'data-apim-test': 'metadata-description-container'
	        },
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'h3' },
	          (0, _intl.getI18nFormattedMessage)('label.group')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.detailsSubTitle },
	          groupName
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'h3' },
	          (0, _intl.getI18nFormattedMessage)('label.description')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.detailsSubTitle },
	          description
	        )
	      ),
	      _react2.default.createElement(_core.Grid, { item: true, md: 1 }),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 4 },
	        _react2.default.createElement(
	          'div',
	          {
	            className: classes.assestsContainer,
	            id: 'metadata-assets-container',
	            'data-apim-test': 'metadata-assets-container'
	          },
	          _react2.default.createElement(
	            _core.Typography,
	            { variant: 'h3' },
	            (0, _intl.getI18nFormattedMessage)('label.assets')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.detailsSubTitle },
	            (0, _intl.getI18nFormattedMessage)('label.assets.help')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.fileName },
	            fileName
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: classes.linkContainer,
	              id: 'metadata-assets-link-container',
	              'data-apim-test': 'metadata-assets-link-container'
	            },
	            _react2.default.createElement(
	              _core.Link,
	              { href: url },
	              _react2.default.createElement(
	                _core.Button,
	                {
	                  id: 'download-button',
	                  'data-apim-test': 'metadata-assets-download-button',
	                  color: 'primary',
	                  variant: 'outlined',
	                  className: classes.saveButton
	                },
	                (0, _intl.getI18nFormattedMessage)('label.download')
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	
	MetadataRaw.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  gatewayBundleDetails: (0, _propTypes.shape)({}),
	  config: (0, _propTypes.shape)({}),
	  apiUsage: _propTypes.number
	};
	MetadataRaw.displayName = 'Metadata';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default))(MetadataRaw);

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      margin = _ref.margin,
	      typography = _ref.typography,
	      padding = _ref.padding,
	      lineHeight = _ref.lineHeight;
	  return {
	    topPanelContainer: {
	      padding: '0 36px',
	      backgroundColor: '' + (0, _utils.convertHexToRGB)((0, _get2.default)(color, 'borderColor'), 0.1)
	    },
	    bottomPanelContainer: {
	      marginTop: (0, _get2.default)(margin, 'm28'),
	      padding: '0 36px'
	    },
	    detailsTitle: {
	      backgroundColor: 'transparent !important',
	      color: (0, _get2.default)(color, 'bodyText'),
	      fontFamily: (0, _get2.default)(typography, 'bodyText'),
	      fontSize: (0, _get2.default)(fontSize, 'title'),
	      fontWeight: 'bold !important',
	      outline: 'transparent !important',
	      '-webkit-font-smoothing': 'antialiased',
	      lineHeight: (0, _get2.default)(lineHeight, 'lh28') + ' !important',
	      wordWrap: 'break-word'
	    },
	    detailsSubTitle: {
	      backgroundColor: 'transparent !important',
	      fontFamily: (0, _get2.default)(typography, 'bodyText'),
	      fontSize: (0, _get2.default)(fontSize, 'bodyText'),
	      outline: 'transparent !important',
	      '-webkit-font-smoothing': 'antialiased',
	      color: (0, _get2.default)(color, 'bodyText') + ' !important',
	      lineHeight: (0, _get2.default)(lineHeight, 'lh21'),
	      wordWrap: 'break-word',
	      paddingRight: (0, _get2.default)(padding, 'p20')
	    },
	    fileName: {
	      fontWeight: 'bold !important',
	      margin: '20px 0px'
	    },
	    linkContainer: {
	      '& a': {
	        cursor: 'pointer',
	        border: 'none !important',
	        margin: (0, _get2.default)(margin, 'm0') + ' !important',
	        padding: (0, _get2.default)(padding, 'p0') + ' !important',
	        height: '0px !important',
	        fontWeight: '300 !important',
	        color: (0, _get2.default)(color, 'link') + ' !important',
	        fontSize: (0, _get2.default)(fontSize, 'bodyText') + ' !important',
	        fontFamily: (0, _get2.default)(typography, 'bodyText') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:hover': {
	        color: (0, _get2.default)(color, 'linkHover') + ' !important',
	        textDecoration: 'none'
	      },
	      '& a:focus': {
	        boxShadow: 'none !important',
	        outline: '0px !important',
	        textDecoration: 'none'
	      }
	    },
	    divider: {
	      backgroundColor: (0, _get2.default)(color, 'borderColor')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GatewayBundleDetails = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(27);
	
	var _lodash = __webpack_require__(8);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _core = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(5);
	
	var _Header = __webpack_require__(1655);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Actions = __webpack_require__(1647);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _Metadata = __webpack_require__(1657);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Apis = __webpack_require__(1650);
	
	var _Apis2 = _interopRequireDefault(_Apis);
	
	var _Deployments = __webpack_require__(1654);
	
	var _Deployments2 = _interopRequireDefault(_Deployments);
	
	var _components = __webpack_require__(17);
	
	var _details = __webpack_require__(622);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _gatewayBundle = __webpack_require__(154);
	
	var _portalConfig = __webpack_require__(26);
	
	var _gatewayBundle2 = __webpack_require__(123);
	
	var _styles = __webpack_require__(1660);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTabItems = function getTabItems() {
	  return [{
	    id: 0,
	    tabId: 'gateway-bundle-metadata-tab',
	    label: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.details.page.metadata.title'),
	    visible: true
	  }, {
	    id: 1,
	    tabId: 'gateway-bundle-deployment-tab',
	    label: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.details.page.deployments.title'),
	    visible: true
	  }, {
	    id: 2,
	    tabId: 'gateway-bundle-api-tab',
	    label: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.details.page.api.title'),
	    visible: true
	  }];
	};
	
	var GatewayBundleDetails = exports.GatewayBundleDetails = function GatewayBundleDetails(props) {
	  var gatewayBundleDetails = props.gatewayBundleDetails,
	      isLoading = props.isLoading,
	      config = props.config,
	      userContext = props.userContext,
	      bundleErrors = props.bundleErrors,
	      apiUsage = props.apiUsage;
	
	
	  var bundleUuid = (0, _lodash.get)(props, 'match.params.bundleUuid');
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      notificationMessage = _useState2[0],
	      setNotificationMessage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      notificationStatus = _useState4[0],
	      setNotificationStatus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      currentTab = _useState6[0],
	      setCurrentTab = _useState6[1];
	
	  var tabItems = getTabItems();
	
	  (0, _react.useEffect)(function () {
	    if (bundleUuid) {
	      props.fetchGatewayBundleDetails(bundleUuid);
	      props.fetchGatewayBundleUsage(bundleUuid);
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (!userContext.portalAdmin) {
	      props.push('/404');
	    }
	  }, [userContext]);
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _lodash.isEmpty)(bundleErrors)) {
	      props.push('/404');
	    }
	  }, [bundleErrors]);
	
	  var notifyMessages = function notifyMessages(status, message) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  var handleTabChange = function handleTabChange(e, newValue) {
	    setCurrentTab(newValue);
	  };
	
	  return _react2.default.createElement(_details2.default, {
	    detailsPageId: 'gateway-bundle-details-page',
	    isLoading: isLoading,
	    notificationId: 'gateway-bundle-details-notification',
	    notificationStatus: notificationStatus,
	    setNotificationStatus: setNotificationMessage,
	    notificationMessage: notificationMessage,
	    setNotificationMessage: setNotificationMessage,
	    header: _react2.default.createElement(_Header2.default, {
	      gatewayBundleDetails: gatewayBundleDetails
	    }),
	    actions: _react2.default.createElement(_Actions2.default, Object.assign({}, props, {
	      notifyMessages: notifyMessages
	    })),
	    tabs: _react2.default.createElement(_components.TabsContainer, {
	      id: 'gateway-bundle-details-tab-container',
	      tabValue: currentTab,
	      orientation: 'horizontal',
	      tabItems: tabItems.filter(function (_ref) {
	        var visible = _ref.visible;
	        return visible;
	      }),
	      handleTabChange: handleTabChange
	    }),
	    page: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _components.TabPanel,
	        {
	          visible: currentTab === 0,
	          id: 'gateway-bundle-metadata-tab-panel'
	        },
	        _react2.default.createElement(_Metadata2.default, {
	          gatewayBundleDetails: gatewayBundleDetails,
	          apiUsage: apiUsage,
	          config: config
	        })
	      ),
	      _react2.default.createElement(
	        _components.TabPanel,
	        {
	          visible: currentTab === 1,
	          id: 'gateway-bundle-deployments-tab-panel'
	        },
	        _react2.default.createElement(_Deployments2.default, {
	          gatewayBundleDetails: gatewayBundleDetails,
	          bundleUuid: bundleUuid,
	          notifyMessages: notifyMessages
	        })
	      ),
	      _react2.default.createElement(
	        _components.TabPanel,
	        {
	          visible: currentTab === 2,
	          id: 'gateway-bundle-api-tab-panel'
	        },
	        _react2.default.createElement(_Apis2.default, {
	          gatewayBundleDetails: gatewayBundleDetails,
	          bundleUuid: bundleUuid
	        })
	      )
	    )
	  });
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    config: (0, _portalConfig.getConfig)(state),
	    gatewayBundleDetails: (0, _gatewayBundle2.getGatewayBundleDetails)(state),
	    apiUsage: (0, _gatewayBundle2.getGatewayBundleApiUsage)(state),
	    isLoading: (0, _gatewayBundle2.getIsLoading)(state),
	    userContext: (0, _portalConfig.getUserDetails)(state),
	    bundleErrors: (0, _gatewayBundle2.getErrors)(state),
	    deleteBundleErrors: (0, _gatewayBundle2.getDeleteBundleErrors)(state),
	    isBundleDeleteSuccess: (0, _gatewayBundle2.getIsBundleDeleteSuccess)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchGatewayBundleDetails: _gatewayBundle.fetchGatewayBundleDetails,
	  fetchGatewayBundleUsage: _gatewayBundle.fetchGatewayBundleUsage,
	  deleteGatewayBundle: _gatewayBundle.deleteGatewayBundle,
	  push: _connectedReactRouter.push
	};
	
	GatewayBundleDetails.propTypes = {
	  gatewayBundleDetails: (0, _propTypes.shape)({}),
	  apiUsage: _propTypes.number,
	  isLoading: _propTypes.bool,
	  config: (0, _propTypes.shape)({}),
	  userContext: (0, _propTypes.shape)({}),
	  bundleErrors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}))
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(GatewayBundleDetails);

/***/ },
/* 1660 */
1656,
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MIME_TYPES = exports.MAX_FILE_SIZE = exports.MAX_BUNDLE_SIZE_IN_MB = exports.DELETE_BUNDLE_FILE_EXT = exports.BUNDLE_FILE_EXT = exports.YML_FILE_EXT = exports.ALLOWED_FILE_EXTENSIONS = exports.BUNDLE_FILE_TYPE = exports.HELP_ITEMS = undefined;
	
	var _intl = __webpack_require__(15);
	
	var HELP_ITEMS = exports.HELP_ITEMS = {
	  bundleHelp: {
	    title: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.edit.help.title'),
	    descriptions: '',
	    subItems: [{
	      id: 0,
	      title: '',
	      descriptions: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.edit.help.0.desc')
	    }, {
	      id: 1,
	      title: '',
	      descriptions: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.edit.help.1.desc'),
	      list: {
	        type: 'circle',
	        items: [(0, _intl.getI18nFormattedMessage)('label.gateway.bundle.edit.help.1.0'), (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.edit.help.1.1'), (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.edit.help.1.2'), (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.edit.help.1.3')]
	      }
	    }, {
	      id: 2,
	      title: '',
	      descriptions: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.edit.help.2.desc')
	    }]
	  }
	};
	
	var BUNDLE_FILE_TYPE = exports.BUNDLE_FILE_TYPE = '.yml,.bundle';
	var ALLOWED_FILE_EXTENSIONS = exports.ALLOWED_FILE_EXTENSIONS = ['metadata.yml', 'install.bundle', 'delete.bundle'];
	var YML_FILE_EXT = exports.YML_FILE_EXT = 'metadata.yml';
	var BUNDLE_FILE_EXT = exports.BUNDLE_FILE_EXT = 'install.bundle';
	var DELETE_BUNDLE_FILE_EXT = exports.DELETE_BUNDLE_FILE_EXT = 'delete.bundle';
	var MAX_BUNDLE_SIZE_IN_MB = exports.MAX_BUNDLE_SIZE_IN_MB = 15;
	var MAX_FILE_SIZE = exports.MAX_FILE_SIZE = MAX_BUNDLE_SIZE_IN_MB * 1024 * 1024;
	var MIME_TYPES = exports.MIME_TYPES = {
	  'metadata.yml': 'text/yml',
	  'install.bundle': 'application/octet-stream',
	  'delete.bundle': 'application/octet-stream'
	};

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GatewayBundleEdit = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(27);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _core = __webpack_require__(3);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(17);
	
	var _gatewayBundle = __webpack_require__(154);
	
	var _portalConfig = __webpack_require__(26);
	
	var _gatewayBundle2 = __webpack_require__(123);
	
	var _utils = __webpack_require__(18);
	
	var _intl = __webpack_require__(15);
	
	var _constants = __webpack_require__(1661);
	
	var _constants2 = __webpack_require__(14);
	
	var _styles = __webpack_require__(1663);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var GatewayBundleEdit = exports.GatewayBundleEdit = function GatewayBundleEdit(props) {
	  var classes = props.classes,
	      userContext = props.userContext,
	      _props$assets = props.assets,
	      assets = _props$assets === undefined ? [] : _props$assets,
	      isLoading = props.isLoading,
	      bundleErrors = props.bundleErrors,
	      isError = props.isError,
	      isBundleSaveSuccess = props.isBundleSaveSuccess,
	      gatewayBundleDetails = props.gatewayBundleDetails;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)({
	    files: assets,
	    acceptFileTypes: _constants.BUNDLE_FILE_TYPE,
	    maxFiles: 3,
	    error: false,
	    helperText: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.file.help')
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      bundleFiles = _useState2[0],
	      setBundleFiles = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isFileValidation = _useState4[0],
	      setIsFileValidation = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      fileValidationMessage = _useState6[0],
	      setFileValidationMessage = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      errors = _useState8[0],
	      setErrors = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      notificationMessage = _useState10[0],
	      setNotificationMessage = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      notificationStatus = _useState12[0],
	      setNotificationStatus = _useState12[1];
	
	  localStorage.setItem('isSaveBundleAssets', false);
	
	  var notifyMessages = function notifyMessages(message, status) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  var clearErrorMessages = function clearErrorMessages() {
	    setBundleFiles(Object.assign({}, bundleFiles, { error: false }));
	    setIsFileValidation(false);
	    notifyMessages('', '');
	    setErrors([]);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (!userContext.portalAdmin) {
	      props.push('/404');
	    }
	  }, [userContext]);
	
	  (0, _react.useEffect)(function () {
	    if (isError) {
	      notifyMessages(intl.getI18nMessage('error.title'), _constants2.ALERT_ERROR);
	      setErrors(bundleErrors);
	    } else {
	      clearErrorMessages();
	    }
	  }, [isError, bundleErrors]);
	
	  (0, _react.useEffect)(function () {
	    if (isBundleSaveSuccess) {
	      clearErrorMessages();
	      localStorage.setItem('isSaveBundleAssets', true);
	      props.push('/publish/gateway-bundles/details/' + gatewayBundleDetails.uuid);
	    }
	  }, [isBundleSaveSuccess, gatewayBundleDetails]);
	
	  var hasValidateFile = function hasValidateFile(file) {
	    var extension = (0, _utils.getBundlesExtension)(file.name, _constants.ALLOWED_FILE_EXTENSIONS);
	    if (!(0, _lodash.includes)(_constants.ALLOWED_FILE_EXTENSIONS, extension)) {
	      bundleFiles.error = true;
	      return false;
	    }
	
	    if (file.size > _constants.MAX_FILE_SIZE) {
	      bundleFiles.error = true;
	      return false;
	    }
	    if ((0, _lodash.some)(bundleFiles.files, { name: file.name })) {
	      setIsFileValidation(true);
	      setFileValidationMessage((0, _intl.getI18nFormattedMessage)('error.gateway.bundle.file.name.unique'));
	      return false;
	    }
	    if (bundleFiles.files.length === 3) {
	      setIsFileValidation(true);
	      setFileValidationMessage((0, _intl.getI18nFormattedMessage)('error.gateway.bundle.file.count'));
	      return false;
	    }
	    var filterYmlFiles = bundleFiles.files.filter(function (obj) {
	      return obj.ext === _constants.YML_FILE_EXT;
	    });
	    if (filterYmlFiles.length === 1 && extension === _constants.YML_FILE_EXT) {
	      setIsFileValidation(true);
	      setFileValidationMessage((0, _intl.getI18nFormattedMessage)('error.gateway.bundle.file.metadata.yml.count'));
	      return false;
	    }
	    var filterBundleFiles = bundleFiles.files.filter(function (obj) {
	      return obj.ext === _constants.BUNDLE_FILE_EXT;
	    });
	    if (filterBundleFiles.length === 1 && extension === _constants.BUNDLE_FILE_EXT) {
	      setIsFileValidation(true);
	      setFileValidationMessage((0, _intl.getI18nFormattedMessage)('error.gateway.bundle.file.bundle.count'));
	      return false;
	    }
	
	    var filterDeleteBundleFiles = bundleFiles.files.filter(function (obj) {
	      return obj.ext === _constants.DELETE_BUNDLE_FILE_EXT;
	    });
	    if (filterDeleteBundleFiles.length === 1 && extension === _constants.DELETE_BUNDLE_FILE_EXT) {
	      setIsFileValidation(true);
	      setFileValidationMessage((0, _intl.getI18nFormattedMessage)('error.gateway.bundle.file.delete.bundle.count'));
	      return false;
	    }
	    setIsFileValidation(false);
	    return true;
	  };
	
	  var fileLoad = function fileLoad(file) {
	    var reader = new FileReader();
	    reader.onabort = function () {
	      setBundleFiles(Object.assign({}, bundleFiles, { error: true }));
	    };
	    reader.onerror = function () {
	      setBundleFiles(Object.assign({}, bundleFiles, { error: true }));
	    };
	    reader.onload = function () {
	      if (hasValidateFile(file)) {
	        bundleFiles.error = false;
	        var fileContent = reader.result;
	        var fileExtenstion = (0, _utils.getBundlesExtension)(file.name, _constants.ALLOWED_FILE_EXTENSIONS);
	        var fileData = file;
	        fileData.ext = fileExtenstion;
	        fileData.blob = new Blob([fileContent], { type: _constants.MIME_TYPES[fileExtenstion] });
	        bundleFiles.files.push(fileData);
	        setBundleFiles(Object.assign({}, bundleFiles));
	      } else {
	        setBundleFiles(Object.assign({}, bundleFiles));
	      }
	    };
	    reader.readAsText(file);
	  };
	
	  var handleFiles = function handleFiles(files) {
	    clearErrorMessages();
	    if ((0, _lodash.isArray)(files)) {
	      files.forEach(function (file) {
	        fileLoad(file);
	      });
	    } else {
	      fileLoad(files);
	    }
	  };
	
	  var onRemoveFile = function onRemoveFile(file) {
	    clearErrorMessages();
	    var remainBundleFiles = bundleFiles.files.filter(function (obj) {
	      return obj.name !== file.name;
	    });
	    setBundleFiles(Object.assign({}, bundleFiles, { files: remainBundleFiles }));
	  };
	
	  var onCancel = function onCancel() {
	    clearErrorMessages();
	    window.location.href = '/publish/gateway-bundles/';
	  };
	
	  var hasValidSaveButton = function hasValidSaveButton(selectedFiles) {
	    if (selectedFiles.files.length !== 3) {
	      return true;
	    }
	    var filterYmlFiles = selectedFiles.files.filter(function (obj) {
	      return obj.ext === _constants.YML_FILE_EXT;
	    });
	    var filterBundleFiles = selectedFiles.files.filter(function (obj) {
	      return obj.ext === _constants.BUNDLE_FILE_EXT;
	    });
	    var filterDeleteBundleFiles = bundleFiles.files.filter(function (obj) {
	      return obj.ext === _constants.DELETE_BUNDLE_FILE_EXT;
	    });
	    if (filterYmlFiles.length === 1 && filterBundleFiles.length === 1 && filterDeleteBundleFiles.length === 1) {
	      return false;
	    }
	    return true;
	  };
	
	  var onNext = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              clearErrorMessages();
	
	              if (!hasValidSaveButton(bundleFiles)) {
	                _context.next = 7;
	                break;
	              }
	
	              setBundleFiles(Object.assign({}, bundleFiles, { error: true }));
	              setNotificationStatus('error');
	              setNotificationMessage((0, _intl.getI18nFormattedMessage)('error.gateway.bundle.file.size'));
	              _context.next = 9;
	              break;
	
	            case 7:
	              _context.next = 9;
	              return props.saveBundleAssets(bundleFiles.files);
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function onNext() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.content,
	      id: 'gateway-bundle-edit-page',
	      'data-apim-test': 'gateway-bundle-edit-page'
	    },
	    isLoading && _react2.default.createElement(_components.Loading, { pageLoader: true }),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, className: classes.gridContainer },
	      _react2.default.createElement(_core.Grid, {
	        md: 2,
	        item: true,
	        className: classes.leftSideBar,
	        id: 'gateway-bundle-edit-left-sidebar',
	        'data-apim-test': 'gateway-bundle-edit-left-sidebar'
	      }),
	      _react2.default.createElement(
	        _core.Grid,
	        {
	          md: 7,
	          item: true,
	          className: classes.mainContent,
	          id: 'gateway-bundle-edit-main-content',
	          'data-apim-test': 'gateway-bundle-edit-main-content'
	        },
	        notificationMessage && _react2.default.createElement(_components.AlertMessages, {
	          id: 'gateway-bundle-edit-notification',
	          'data-apim-test': 'gateway-bundle-edit-notification',
	          message: notificationMessage,
	          variant: notificationStatus,
	          onClose: function onClose() {
	            setNotificationMessage('');
	            setNotificationStatus('');
	          }
	        }),
	        errors.length > 0 && _react2.default.createElement(_components.ErrorContainer, { errors: errors }),
	        _react2.default.createElement(
	          'h1',
	          { className: classes.pageTitle },
	          ' Add Gateway Bundles'
	        ),
	        _react2.default.createElement(_components.FileDropzone, {
	          handleFiles: handleFiles,
	          selectedFiles: bundleFiles,
	          helperText: '',
	          title: '',
	          id: 'gateway-bundle-edit-file-upload',
	          allowedFileExtentions: _constants.ALLOWED_FILE_EXTENSIONS,
	          listFileTitles: [intl.getI18nMessage('label.gateway.bundle.selected.file.metadata.yml.title'), intl.getI18nMessage('label.gateway.bundle.selected.file.bundle.title'), intl.getI18nMessage('label.gateway.bundle.selected.file.delete.bundle.title')],
	          onRemoveFile: onRemoveFile,
	          isValidation: isFileValidation,
	          validationMessage: fileValidationMessage,
	          defaultUploaderText: intl.getI18nMessage('label.gateway.bundle.file.uploader'),
	          isMultipleTitle: true
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        {
	          md: 3,
	          item: true,
	          className: classes.rightSideBar,
	          id: 'gateway-bundle-edit-right-sidebar',
	          'data-apim-test': 'gateway-bundle-edit-right-sidebar'
	        },
	        _react2.default.createElement(_components.HelpContainer, {
	          helpItems: _constants.HELP_ITEMS.bundleHelp
	        })
	      )
	    ),
	    _react2.default.createElement(_components.FormActionButtons, {
	      onNextClick: onNext,
	      onCancelClick: onCancel,
	      nextText: intl.getI18nMessage('label.save.button'),
	      cancelText: intl.getI18nMessage('label.exit.button'),
	      id: 'bundle-form-buttons'
	    })
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isError: (0, _gatewayBundle2.getIsError)(state),
	    isLoading: (0, _gatewayBundle2.getIsLoading)(state),
	    bundleErrors: (0, _gatewayBundle2.getErrors)(state),
	    isBundleSaveSuccess: (0, _gatewayBundle2.getIsBundleSaveSuccess)(state),
	    gatewayBundleDetails: (0, _gatewayBundle2.getGatewayBundleDetails)(state),
	    userContext: (0, _portalConfig.getUserDetails)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  saveBundleAssets: _gatewayBundle.saveBundleAssets,
	  push: _connectedReactRouter.push
	};
	
	GatewayBundleEdit.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  assets: _propTypes2.default.shape({}),
	  isLoading: _propTypes2.default.bool,
	  isError: _propTypes2.default.bool,
	  isBundleSaveSuccess: _propTypes2.default.bool,
	  bundleErrors: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  saveBundleAssets: _propTypes2.default.func,
	  userContext: _propTypes2.default.shape({}),
	  gatewayBundleDetails: _propTypes2.default.shape({})
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(GatewayBundleEdit);

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography,
	      margin = _ref.margin,
	      padding = _ref.padding;
	  return {
	    content: {
	      margin: (0, _lodash.get)(margin, 'm36'),
	      minHeight: 'calc(100vh - 125px)',
	      backgroundColor: (0, _lodash.get)(color, 'background'),
	      marginTop: (0, _lodash.get)(margin, 'm0')
	    },
	    gridContainer: {
	      minHeight: 'calc(100vh + 56px)',
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      marginTop: (0, _lodash.get)(margin, 'm10'),
	      marginBottom: (0, _lodash.get)(margin, 'm60')
	    },
	    leftSideBar: {
	      paddingTop: (0, _lodash.get)(padding, 'p50'),
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground')
	    },
	    mainContent: {
	      padding: (0, _lodash.get)(padding, 'p20'),
	      paddingTop: (0, _lodash.get)(padding, 'p50'),
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground')
	    },
	    rightSideBar: {
	      padding: (0, _lodash.get)(padding, 'p10'),
	      paddingTop: (0, _lodash.get)(padding, 'p50'),
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderLeft: '8px solid ' + (0, _lodash.get)(color, 'background')
	    },
	    pageTitle: {
	      color: (0, _lodash.get)(color, 'pageTitle'),
	      fontFamily: (0, _lodash.get)(typography, 'pageTitle'),
	      fontSize: (0, _lodash.get)(fontSize, 'pageTitle'),
	      marginTop: (0, _lodash.get)(margin, 'm6')
	    },
	    subTitle: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      marginTop: (0, _lodash.get)(margin, 'm6'),
	      marginBottom: (0, _lodash.get)(margin, 'm10')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterAndSortSeparator = exports.SortBy = exports.FilterByPortalTemplate = exports.FilterByType = exports.FilterByGroup = exports.FilterByName = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var FilterByName = exports.FilterByName = function FilterByName(props) {
	  return React.createElement(
	    _core.Grid,
	    { item: true, md: 3, sm: 3, xs: 12 },
	    React.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'gateway-bundles-filter-by-name',
	      'data-apim-test': 'gateway-bundles-filter-by-name'
	    }))
	  );
	};
	
	var FilterByGroup = exports.FilterByGroup = function FilterByGroup(props) {
	  return React.createElement(
	    _core.Grid,
	    { item: true, md: 2, sm: 3, xs: 12 },
	    React.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'gateway-bundles-filter-by-group',
	      'data-apim-test': 'gateway-bundles-filter-by-group'
	    }))
	  );
	};
	
	var FilterByType = exports.FilterByType = function FilterByType(props) {
	  return React.createElement(
	    _core.Grid,
	    { item: true, md: 2, sm: 3, xs: 12 },
	    React.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'gateway-bundles-filter-by-type',
	      'data-apim-test': 'gateway-bundles-filter-by-type',
	      data: _constants.GATEWAY_BUNDLES_LIST_TYPE_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var FilterByPortalTemplate = exports.FilterByPortalTemplate = function FilterByPortalTemplate(props) {
	  return React.createElement(
	    _core.Grid,
	    { item: true, md: 2, sm: 3, xs: 12 },
	    React.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'gateway-bundles-filter-by-portalTemplate',
	      'data-apim-test': 'gateway-bundles-filter-by-portalTemplate',
	      data: _constants.GATEWAY_BUNDLES_LIST_PORTAL_TEMPLATE_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var SortBy = exports.SortBy = function SortBy(props) {
	  return React.createElement(
	    _core.Grid,
	    { item: true, md: 2, sm: 3, xs: 12 },
	    React.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'gateway-bundles-sort-by',
	      'data-apim-test': 'gateway-bundles-sort-by',
	      data: _constants.GATEWAY_BUNDLES_LIST_SORT_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var FilterAndSortSeparator = exports.FilterAndSortSeparator = function FilterAndSortSeparator() {
	  return React.createElement(_core.Grid, { item: true, md: 1 });
	};

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GatewayBundleList = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _gatewayBundle = __webpack_require__(154);
	
	var _portalConfig = __webpack_require__(26);
	
	var _gatewayBundle2 = __webpack_require__(123);
	
	var _styles = __webpack_require__(1666);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _controls = __webpack_require__(1664);
	
	var _constants = __webpack_require__(14);
	
	var _intl = __webpack_require__(15);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GATEWAY_BUNDLES_LIST_COLUMNS = [{
	  id: 'name',
	  label: (0, _intl.getI18nFormattedMessage)('label.name'),
	  minWidth: 200,
	  link: '/publish/gateway-bundles/details'
	}, {
	  id: 'groupName',
	  label: (0, _intl.getI18nFormattedMessage)('label.group'),
	  minWidth: 100
	}, {
	  id: 'version',
	  label: (0, _intl.getI18nFormattedMessage)('label.version'),
	  format: function format(value) {
	    return (0, _utils.getVersion)(value);
	  },
	  minWidth: 100
	}, {
	  id: 'type',
	  label: (0, _intl.getI18nFormattedMessage)('label.type'),
	  format: function format(value) {
	    return (0, _utils.getTitleCaseText)(value);
	  },
	  minWidth: 100
	}, {
	  id: 'l7Template',
	  label: (0, _intl.getI18nFormattedMessage)('label.policyTemplate'),
	  minWidth: 100,
	  format: function format(value) {
	    return (0, _utils.getTitleCaseText)(value.toString());
	  }
	}, {
	  id: 'createTs',
	  label: (0, _intl.getI18nFormattedMessage)('label.gateway.bundle.date.created', { zone: (0, _datetime.getTimeZoneAbbr)() }),
	  format: function format(value) {
	    return (0, _datetime2.default)(value);
	  }
	}];
	
	var GatewayBundleList = exports.GatewayBundleList = function GatewayBundleList(props) {
	  var classes = props.classes,
	      userContext = props.userContext,
	      isError = props.isError,
	      _props$gatewayBundleE = props.gatewayBundleErrors,
	      gatewayBundleErrors = _props$gatewayBundleE === undefined ? [] : _props$gatewayBundleE,
	      isLoading = props.isLoading,
	      totalPages = props.totalPages,
	      _props$totalElements = props.totalElements,
	      totalElements = _props$totalElements === undefined ? 0 : _props$totalElements,
	      _props$results = props.results,
	      results = _props$results === undefined ? [] : _props$results,
	      isBundleDeleteSuccess = props.isBundleDeleteSuccess;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      notificationMessage = _useState2[0],
	      setNotificationMessage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      notificationStatus = _useState4[0],
	      setNotificationStatus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filterByName = _useState6[0],
	      setFilterByName = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      filterByGroup = _useState8[0],
	      setFilterByGroup = _useState8[1];
	
	  var _useState9 = (0, _react.useState)('any'),
	      _useState10 = _slicedToArray(_useState9, 2),
	      filterByType = _useState10[0],
	      setFilterByType = _useState10[1];
	
	  var _useState11 = (0, _react.useState)('any'),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterByPortalTemplate = _useState12[0],
	      setFilterByPortalTemplate = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      filterByAnyApplied = _useState14[0],
	      setFilterByAnyApplied = _useState14[1];
	
	  var _useState15 = (0, _react.useState)('createTs,DESC'),
	      _useState16 = _slicedToArray(_useState15, 2),
	      sortBy = _useState16[0],
	      setSortBy = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      page = _useState18[0],
	      setPage = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(_constants.GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState20 = _slicedToArray(_useState19, 2),
	      rowsPerPage = _useState20[0],
	      setRowsPerPage = _useState20[1];
	
	  var notifyMessages = function notifyMessages(status, message) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  (0, _react.useEffect)(function () {
	    props.fetchGatewayBundles(filterByName, filterByGroup, sortBy, filterByType, filterByPortalTemplate, page, rowsPerPage);
	    if (isBundleDeleteSuccess) {
	      notifyMessages(_constants.ALERT_SUCCESS, intl.getI18nMessage('label.gateway.bundle.deleted'));
	      setTimeout(props.resetDeleteNotification, 2500);
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (!userContext.portalAdmin) {
	      props.push('/404');
	    }
	  }, [userContext]);
	
	  (0, _react.useEffect)(function () {
	    if (isError) {
	      notifyMessages(_constants.ALERT_ERROR, intl.getI18nMessage('error.gateway.bundle.fetch'));
	    } else if (isBundleDeleteSuccess) {
	      notifyMessages(_constants.ALERT_SUCCESS, intl.getI18nMessage('label.gateway.bundle.deleted'));
	    } else {
	      notifyMessages('', '');
	    }
	  }, [isError, gatewayBundleErrors, isBundleDeleteSuccess]);
	
	  var onFilterByNameChange = function onFilterByNameChange(value) {
	    setFilterByName(value);
	  };
	
	  var onFilterByGroupChange = function onFilterByGroupChange(value) {
	    setFilterByGroup(value);
	  };
	
	  var onFilterByNameKeyPress = function onFilterByNameKeyPress(e) {
	    if (e.key === 'Enter') {
	      setFilterByAnyApplied(true);
	      props.fetchGatewayBundles(filterByName, filterByGroup, sortBy, filterByType, filterByPortalTemplate, page, rowsPerPage);
	    }
	  };
	
	  var onFilterByGroupKeyPress = function onFilterByGroupKeyPress(e) {
	    if (e.key === 'Enter') {
	      setFilterByAnyApplied(true);
	      props.fetchGatewayBundles(filterByName, filterByGroup, sortBy, filterByType, filterByPortalTemplate, page, rowsPerPage);
	    }
	  };
	
	  var onFilterByTypeChange = function onFilterByTypeChange(newType) {
	    setFilterByType(newType);
	    setFilterByAnyApplied(true);
	    props.fetchGatewayBundles(filterByName, filterByGroup, sortBy, newType, filterByPortalTemplate, page, rowsPerPage);
	  };
	  var onFilterByPortalTemplateChange = function onFilterByPortalTemplateChange(newPortalTemplate) {
	    setFilterByPortalTemplate(newPortalTemplate);
	    setFilterByAnyApplied(true);
	    props.fetchGatewayBundles(filterByName, filterByGroup, sortBy, filterByType, newPortalTemplate, page, rowsPerPage);
	  };
	
	  var onSortByChange = function onSortByChange(newSortBy) {
	    setSortBy(newSortBy);
	    props.fetchGatewayBundles(filterByName, filterByGroup, newSortBy, filterByType, filterByPortalTemplate, page, rowsPerPage);
	  };
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    props.fetchGatewayBundles(filterByName, filterByGroup, sortBy, filterByType, filterByPortalTemplate, newPage, rowsPerPage);
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    props.fetchGatewayBundles(filterByName, filterByGroup, sortBy, filterByType, filterByPortalTemplate, 0, newRowsPerPage);
	  };
	
	  var onAddBundle = function onAddBundle() {
	    props.resetApp();
	    props.push('/publish/gateway-bundles/add');
	  };
	
	  var noResultsMessage = filterByAnyApplied ? intl.getI18nMessage('label.gateway.bundle.filter.no.results') + '\n' + intl.getI18nMessage('label.gateway.bundle.list.page.title.help') + '\n' + intl.getI18nMessage('label.gateway.bundle.use.add.button.help') : intl.getI18nMessage('label.gateway.bundle.no.results');
	
	  return _react2.default.createElement(_list2.default, {
	    listPageId: 'gateway-bundle-list-page',
	    isLoading: isLoading,
	    notificationId: 'gateway-bundle-notifications',
	    notificationStatus: notificationStatus,
	    setNotificationStatus: setNotificationMessage,
	    notificationMessage: notificationMessage,
	    setNotificationMessage: setNotificationMessage,
	    pageHeaderTitle: intl.getI18nMessage('label.gateway.bundle.list.page.title'),
	    pageHeaderTooltipTitle: intl.getI18nMessage('label.gateway.bundle.list.page.title.help'),
	    addButtonLabel: intl.getI18nMessage('label.gateway.bundle.add.button'),
	    onAdd: onAddBundle,
	    filterAndSortContent: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_controls.FilterByName, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        value: filterByName,
	        placeholder: intl.getI18nMessage('label.gateway.bundle.list.page.filter.by.name.placeholder'),
	        handleChange: onFilterByNameChange,
	        onKeyPress: onFilterByNameKeyPress
	      }),
	      _react2.default.createElement(_controls.FilterByGroup, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        value: filterByGroup,
	        placeholder: intl.getI18nMessage('label.gateway.bundle.list.page.filter.by.group.placeholder'),
	        handleChange: onFilterByGroupChange,
	        onKeyPress: onFilterByGroupKeyPress,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterByType, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        selectFieldClass: classes.selectField,
	        value: filterByType,
	        handleChange: onFilterByTypeChange,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterByPortalTemplate, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        selectFieldClass: classes.selectField,
	        value: filterByPortalTemplate,
	        handleChange: onFilterByPortalTemplateChange,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterAndSortSeparator, null),
	      _react2.default.createElement(_controls.SortBy, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.sort'),
	        selectFieldClass: classes.selectField,
	        value: sortBy,
	        handleChange: onSortByChange
	      })
	    ),
	    columns: GATEWAY_BUNDLES_LIST_COLUMNS,
	    rows: results,
	    noResultsMessage: noResultsMessage,
	    page: page,
	    totalElements: totalElements,
	    totalPages: totalPages,
	    rowsPerPage: rowsPerPage,
	    onChangeRowsPerPage: onChangeRowsPerPage,
	    onChangePage: onChangePage,
	    onChangePreviousPage: onChangePreviousPage,
	    onChangeNextPage: onChangeNextPage
	  });
	};
	
	GatewayBundleList.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  userContext: (0, _propTypes.shape)({}),
	  isLoading: _propTypes.bool,
	  isError: _propTypes.bool,
	  gatewayBundleErrors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}) || _propTypes.string),
	  push: _propTypes.func,
	  resetApp: _propTypes.func,
	  totalPages: _propTypes.number,
	  totalElements: _propTypes.number,
	  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  isBundleDeleteSuccess: _propTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    config: (0, _portalConfig.getConfig)(state),
	    userContext: (0, _portalConfig.getUserDetails)(state),
	    isError: (0, _gatewayBundle2.getIsError)(state),
	    gatewayBundleErrors: (0, _gatewayBundle2.getErrors)(state),
	    isLoading: false,
	    totalPages: (0, _gatewayBundle2.getGatewayBundlesListTotalPages)(state),
	    totalElements: (0, _gatewayBundle2.getGatewayBundlesListTotalElements)(state),
	    results: (0, _gatewayBundle2.getGatewayBundlesListResults)(state),
	    isBundleDeleteSuccess: (0, _gatewayBundle2.getIsBundleDeleteSuccess)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  push: _connectedReactRouter.push,
	  resetApp: _gatewayBundle.resetApp,
	  fetchGatewayBundles: _gatewayBundle.fetchGatewayBundles,
	  resetDeleteNotification: _gatewayBundle.resetDeleteNotification
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(GatewayBundleList);

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      margin = _ref.margin,
	      padding = _ref.padding;
	
	  return {
	    fieldContainer: {
	      margin: (0, _get2.default)(margin, 'm2') + ' ' + (0, _get2.default)(margin, 'm4') + ' ' + (0, _get2.default)(margin, 'm2') + ' ' + (0, _get2.default)(margin, 'm0') + ' !important'
	    },
	    selectField: {
	      padding: (0, _get2.default)(padding, 'p2') + ' ' + (0, _get2.default)(padding, 'p10') + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrganizationEdit = undefined;
	
	var _regenerator = __webpack_require__(29);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _recompose = __webpack_require__(105);
	
	var _core = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(71);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _lodash = __webpack_require__(8);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _organization = __webpack_require__(281);
	
	var _organization2 = __webpack_require__(203);
	
	var _portalConfig = __webpack_require__(26);
	
	var _edit = __webpack_require__(201);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _styles = __webpack_require__(1669);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _utils = __webpack_require__(18);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	var _labels = __webpack_require__(1668);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getOrgTypes = function getOrgTypes() {
	  return [{
	    id: _constants.ORGANIZATION_TYPE_PUBLISHER,
	    name: (0, _intl.getI18nFormattedMessage)('label.organization.form.page.radio.group.option.publisher'),
	    description: (0, _intl.getI18nFormattedMessage)('label.organization.form.page.radio.group.option.publisher.description')
	  }, {
	    id: _constants.ORGANIZATION_TYPE_CONSUMER,
	    name: (0, _intl.getI18nFormattedMessage)('label.organization.form.page.radio.group.option.consumer'),
	    description: (0, _intl.getI18nFormattedMessage)('label.organization.form.page.radio.group.option.consumer.description')
	  }];
	};
	
	var getOptionLabel = function getOptionLabel(option) {
	  return (0, _lodash.get)(option, 'name', '');
	};
	var getOptionSelected = function getOptionSelected(option, value) {
	  return value.uuid === option.uuid;
	};
	
	// wrapping renderPageContent with dummy function
	// to avoid ES lint bug
	var createPageContent = function createPageContent() {
	  var renderPageContent = function renderPageContent(_ref) {
	    var _handleBlur = _ref.handleBlur,
	        _handleChange = _ref.handleChange,
	        _ref$accountPlans = _ref.accountPlans,
	        accountPlans = _ref$accountPlans === undefined ? [] : _ref$accountPlans,
	        orgName = _ref.orgName,
	        orgDescription = _ref.orgDescription,
	        selectedAccountPlan = _ref.selectedAccountPlan,
	        selectedOrgType = _ref.selectedOrgType,
	        onSave = _ref.onSave,
	        onCancel = _ref.onCancel,
	        isSaveDisabled = _ref.isSaveDisabled,
	        intl = _ref.intl,
	        formErrors = _ref.formErrors,
	        classes = _ref.classes;
	    return _react2.default.createElement(
	      _Grid2.default,
	      { md: 12, item: true },
	      _react2.default.createElement(
	        _core.Typography,
	        { variant: 'h1', className: classes.pageTitle },
	        intl.getI18nMessage('label.details')
	      ),
	      _react2.default.createElement(_components.FormTextField, {
	        id: 'organization-name',
	        name: intl.getI18nMessage('label.organization.form.page.organization.name'),
	        value: orgName,
	        handleChange: function handleChange(value) {
	          return _handleChange('name', value);
	        },
	        handleBlur: function handleBlur(value) {
	          return _handleBlur('name', value);
	        },
	        helperText: intl.getI18nMessage('label.organization.form.page.helper.text.name'),
	        maxLength: '255',
	        error: formErrors.name
	      }),
	      _react2.default.createElement(_components.RadioGroupSection, {
	        name: intl.getI18nMessage('label.organization.form.page.organization.type'),
	        selected: selectedOrgType,
	        onChange: function onChange(event) {
	          return _handleChange('type', event.target.value);
	        },
	        data: getOrgTypes(),
	        id: 'type-radio-group'
	      }),
	      _react2.default.createElement(_components.FormAutoCompleteCombo, {
	        id: 'selected-accountplan',
	        name: intl.getI18nMessage('label.organization.form.page.organization.account.plan'),
	        selectedValues: selectedAccountPlan,
	        data: accountPlans,
	        getOptionLabel: getOptionLabel,
	        getOptionSelected: getOptionSelected,
	        inputLabel: intl.getI18nMessage('label.organization.form.page.place.holder.text'),
	        onChange: function onChange(e, value) {
	          return _handleChange('accountPlan', value);
	        },
	        error: formErrors.accountPlan
	      }),
	      _react2.default.createElement(_components.FormTextField, {
	        id: 'organization-description',
	        name: intl.getI18nMessage('label.organization.form.page.organization.public.description'),
	        value: orgDescription,
	        handleChange: function handleChange(value) {
	          return _handleChange('description', value);
	        },
	        helperText: intl.getI18nMessage('label.organization.form.page.helper.text.description'),
	        multiline: true,
	        rows: 4,
	        optional: true,
	        maxLength: '255'
	      }),
	      _react2.default.createElement(_components.FormActionButtons, {
	        onNextClick: onSave,
	        nextText: intl.getI18nMessage('label.save.button'),
	        onCancelClick: onCancel,
	        id: 'org-edit-form-buttons',
	        isDisabled: isSaveDisabled
	      })
	    );
	  };
	  renderPageContent.propTypes = {
	    accountPlans: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	    handleBlur: _propTypes2.default.func,
	    handleChange: _propTypes2.default.func,
	    orgDescription: _propTypes2.default.string,
	    orgName: _propTypes2.default.string,
	    selectedAccountPlan: _propTypes2.default.shape({}),
	    onSave: _propTypes2.default.func,
	    onCancel: _propTypes2.default.func,
	    selectedOrgType: _propTypes2.default.string,
	    isSaveDisabled: _propTypes2.default.bool,
	    intl: _propTypes2.default.shape({}),
	    formErrors: _propTypes2.default.shape({}),
	    classes: _propTypes2.default.shape({})
	  };
	  return renderPageContent;
	};
	
	var OrganizationEdit = exports.OrganizationEdit = function OrganizationEdit(props) {
	  var history = props.history,
	      orgUuid = props.orgUuid,
	      isEditMode = props.isEditMode,
	      orgDetails = props.orgDetails,
	      userContext = props.userContext,
	      accountPlans = props.accountPlans,
	      isLoading = props.isLoading,
	      isFormLoadingError = props.isFormLoadingError,
	      isOrgNameUnique = props.isOrgNameUnique,
	      isFormValidationError = props.isFormValidationError,
	      isCreateError = props.isCreateError,
	      createErrorMsg = props.createErrorMsg,
	      isUpdateError = props.isUpdateError,
	      updateErrorMsg = props.updateErrorMsg,
	      isFormSubmissionSuccessful = props.isFormSubmissionSuccessful,
	      classes = props.classes;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      notificationMessage = _useState2[0],
	      setNotificationMessage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      notificationStatus = _useState4[0],
	      setNotificationStatus = _useState4[1];
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var onDialogSubmit = function onDialogSubmit() {
	    window.history.back();
	  };
	  var getHelpItems = function getHelpItems() {
	    return _labels.HELP_ITEMS;
	  };
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      orgName = _useState6[0],
	      setOrgName = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      orgDescription = _useState8[0],
	      setOrgDescription = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      initialOrgName = _useState10[0],
	      setInitialOrgName = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({}),
	      _useState12 = _slicedToArray(_useState11, 2),
	      selectedAccountPlan = _useState12[0],
	      setSelectedAccountPlan = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(_constants.ORGANIZATION_TYPE_CONSUMER),
	      _useState14 = _slicedToArray(_useState13, 2),
	      selectedOrgType = _useState14[0],
	      setSelectedOrgType = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      isDialogOpen = _useState16[0],
	      setIsDialogOpen = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      hasUnsavedChanges = _useState18[0],
	      setHasUnsavedChanges = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      isSaveDisabled = _useState20[0],
	      setIsSaveDisabled = _useState20[1];
	
	  var _useState21 = (0, _react.useState)({}),
	      _useState22 = _slicedToArray(_useState21, 2),
	      formErrors = _useState22[0],
	      setFormErrors = _useState22[1];
	
	  var onDialogClose = function onDialogClose() {
	    setIsDialogOpen(false);
	  };
	
	  var notifyMessages = function notifyMessages(status, message) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  (0, _react.useEffect)(function () {
	    props.resetApp();
	    props.fetchAccountPlans();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (isFormLoadingError) {
	      notifyMessages(_constants.ALERT_ERROR, intl.getI18nMessage('error.organization.form.load'));
	      setIsSaveDisabled(true);
	    }
	  }, [isFormLoadingError]);
	
	  (0, _react.useEffect)(function () {
	    if (isFormValidationError) {
	      notifyMessages(_constants.ALERT_ERROR, intl.getI18nMessage('error.organization.form.validation'));
	      setIsSaveDisabled(true);
	    }
	  }, [isFormValidationError]);
	
	  (0, _react.useEffect)(function () {
	    if (isCreateError) {
	      notifyMessages(_constants.ALERT_ERROR, createErrorMsg || intl.getI18nMessage('error.organization.form.submit.create'));
	    }
	  }, [isCreateError]);
	
	  (0, _react.useEffect)(function () {
	    if (isUpdateError) {
	      notifyMessages(_constants.ALERT_ERROR, updateErrorMsg || intl.getI18nMessage('error.organization.form.submit.update'));
	    }
	  }, [isUpdateError]);
	
	  (0, _react.useEffect)(function () {
	    if (!isOrgNameUnique) {
	      setIsSaveDisabled(true);
	      setFormErrors(Object.assign({}, formErrors, {
	        name: true
	      }));
	    }
	  }, [isOrgNameUnique]);
	
	  (0, _react.useEffect)(function () {
	    if (userContext) {
	      if (!(0, _utils.hasAdminRole)(userContext)) {
	        props.push('/404');
	      }
	    }
	  }, [userContext]);
	
	  (0, _react.useEffect)(function () {
	    if (isEditMode && orgDetails && orgDetails.name) {
	      setOrgName(orgDetails.name);
	      setInitialOrgName(orgDetails.name);
	      setOrgDescription(orgDetails.description);
	      setSelectedOrgType(orgDetails.type);
	      setSelectedAccountPlan((0, _lodash.find)(accountPlans, function (plan) {
	        return plan.uuid === orgDetails.accountPlanUuid;
	      }));
	    }
	  }, [accountPlans, orgDetails]);
	
	  (0, _react.useEffect)(function () {
	    if (isFormSubmissionSuccessful) {
	      if (isEditMode) {
	        localStorage.setItem('isUpdateOrg', true);
	      } else {
	        localStorage.setItem('isCreateOrg', true);
	      }
	      history.push('/admin/console/organizations');
	    }
	  }, [isFormSubmissionSuccessful]);
	
	  (0, _react.useEffect)(function () {
	    if (isEditMode && orgUuid) {
	      props.fetchOrganization(orgUuid);
	    }
	  }, [orgUuid]);
	
	  var handleChange = function handleChange(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    setIsSaveDisabled(false);
	    if (name === 'name') {
	      if (value) {
	        setFormErrors(Object.assign({}, formErrors, {
	          name: false
	        }));
	      }
	      setOrgName(value);
	    } else if (name === 'accountPlan') {
	      setFormErrors(Object.assign({}, formErrors, {
	        accountPlan: false
	      }));
	      setSelectedAccountPlan(value);
	    } else if (name === 'type') {
	      setSelectedOrgType(value);
	    } else if (name === 'description') {
	      setOrgDescription(value);
	    }
	    setHasUnsavedChanges(true);
	  };
	
	  var handleBlur = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(name, value) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(name === 'name' && initialOrgName !== value)) {
	                _context.next = 3;
	                break;
	              }
	
	              _context.next = 3;
	              return props.fetchOrganizationNameUnique(value);
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function handleBlur(_x2, _x3) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var validateForm = function validateForm() {
	    if (!orgName || !(0, _lodash.get)(selectedAccountPlan, 'uuid', '')) {
	      var newFormErrors = formErrors;
	      if (!orgName || !isOrgNameUnique) {
	        newFormErrors.name = true;
	      }
	      if (!(0, _lodash.get)(selectedAccountPlan, 'uuid', '')) {
	        newFormErrors.accountPlan = true;
	      }
	      setFormErrors(newFormErrors);
	      return false;
	    }
	    return true;
	  };
	
	  var onSave = function onSave() {
	    if (!validateForm()) {
	      setIsSaveDisabled(true);
	      return;
	    }
	    var payload = Object.assign({
	      accountPlanUuid: selectedAccountPlan.uuid,
	      description: orgDescription,
	      name: orgName,
	      type: selectedOrgType
	    }, isEditMode ? { status: orgDetails.status } : {}, orgUuid && { orgUuid: orgUuid } || { orgUuid: '{{GENERATED_GUID}}' });
	    if (isEditMode) {
	      props.updateOrganization(payload);
	    } else {
	      props.createOrganization(payload);
	    }
	  };
	
	  var onCancel = function onCancel() {
	    if (hasUnsavedChanges) {
	      setIsDialogOpen(true);
	    } else {
	      window.history.back();
	    }
	  };
	
	  return _react2.default.createElement(_edit2.default, {
	    editPageId: 'organization-edit-page',
	    dialogId: 'organization-unsaved-dialog',
	    isDialogOpen: isDialogOpen,
	    onDialogClose: onDialogClose,
	    dialogSubmitText: intl.getI18nMessage('label.dialog.unsaved.changes.exit'),
	    onDialogSubmit: onDialogSubmit,
	    isLoading: isLoading,
	    leftSidebarId: 'organization-edit-left-sidebar',
	    mainContentId: 'organization-edit-main-content',
	    notificationId: 'organization-notifications',
	    notificationStatus: notificationStatus,
	    setNotificationStatus: setNotificationStatus,
	    notificationMessage: notificationMessage,
	    setNotificationMessage: setNotificationMessage,
	    tabsContainer: _react2.default.createElement('div', null),
	    pageHeaderTitle: isEditMode ? intl.getI18nMessage('label.organization.form.page.organization.edit') + ': ' + initialOrgName : intl.getI18nMessage('label.organization.form.page.organization.add'),
	    pageContent: createPageContent()({
	      accountPlans: accountPlans,
	      handleBlur: handleBlur,
	      handleChange: handleChange,
	      orgDescription: orgDescription,
	      orgName: orgName,
	      selectedAccountPlan: selectedAccountPlan,
	      selectedOrgType: selectedOrgType,
	      onSave: onSave,
	      onCancel: onCancel,
	      isSaveDisabled: isSaveDisabled,
	      intl: intl,
	      formErrors: formErrors,
	      classes: classes
	    }),
	    rightSidebarId: 'organization-edit-right-sidebar',
	    helpItems: getHelpItems()
	  });
	};
	
	OrganizationEdit.propTypes = {
	  classes: _propTypes2.default.shape({}),
	  isEditMode: _propTypes2.default.bool,
	  orgUuid: _propTypes2.default.string,
	  isLoading: _propTypes2.default.bool,
	  orgDetails: _propTypes2.default.shape({}),
	  accountPlans: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  isFormLoadingError: _propTypes2.default.bool,
	  isFormValidationError: _propTypes2.default.bool,
	  history: _propTypes2.default.shape({}),
	  isOrgNameUnique: _propTypes2.default.bool,
	  isCreateError: _propTypes2.default.bool,
	  isUpdateError: _propTypes2.default.bool,
	  isFormSubmissionSuccessful: _propTypes2.default.bool,
	  createErrorMsg: _propTypes2.default.string,
	  updateErrorMsg: _propTypes2.default.string,
	  userContext: _propTypes2.default.shape({})
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    orgDetails: (0, _organization2.getOrganizationDetails)(state),
	    accountPlans: (0, _organization2.getAccountPlans)(state),
	    isLoading: (0, _organization2.getIsFormLoading)(state, props.isEditMode),
	    isFormLoadingError: (0, _organization2.getIsFormLoadingError)(state),
	    isFormValidationError: (0, _organization2.getIsFormValidationError)(state),
	    isOrgNameUnique: (0, _organization2.getIsOrganizationNameUnique)(state),
	    isCreateError: (0, _organization2.getIsFormCreateError)(state),
	    isUpdateError: (0, _organization2.getIsFormUpdateError)(state),
	    updateErrorMsg: (0, _organization2.getUpdateErrorMsg)(state),
	    createErrorMsg: (0, _organization2.getCreateErrorMsg)(state),
	    isFormSubmissionSuccessful: (0, _organization2.getIsFormSubmissionSuccessful)(state),
	    userContext: (0, _portalConfig.getUserDetails)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchOrganization: _organization.fetchOrganization,
	  fetchAccountPlans: _organization.fetchAccountPlans,
	  fetchOrganizationNameUnique: _organization.fetchOrganizationNameUnique,
	  createOrganization: _organization.createOrganization,
	  updateOrganization: _organization.updateOrganization,
	  resetApp: _organization.resetApp,
	  push: _connectedReactRouter.push
	};
	
	var getOrgUuid = function getOrgUuid(props) {
	  return (0, _lodash.get)(props, 'match.params.orgUuid', '');
	};
	
	var addProps = function addProps(props) {
	  return {
	    orgUuid: getOrgUuid(props),
	    isEditMode: !!getOrgUuid(props)
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _core.withStyles)(_styles2.default), (0, _recompose.withProps)(addProps), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(OrganizationEdit);

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HELP_ITEMS = undefined;
	
	var _intl = __webpack_require__(15);
	
	var HELP_ITEMS = exports.HELP_ITEMS = {
	  title: '',
	  descriptions: '',
	  subItems: [{
	    id: 0,
	    title: '',
	    descriptions: (0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.1'),
	    list: {
	      type: 'circle',
	      items: [(0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.1.0'), (0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.1.1')]
	    }
	  }, {
	    id: 1,
	    title: '',
	    descriptions: (0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.2'),
	    list: {
	      type: 'circle',
	      items: [(0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.2.0'), (0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.2.1'), (0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.2.2')]
	    }
	  }, {
	    id: 2,
	    title: '',
	    descriptions: (0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.3')
	  }, {
	    id: 3,
	    title: '',
	    descriptions: (0, _intl.getI18nFormattedMessage)('label.organization.form.page.side.help.4')
	  }]
	};
	
	exports.default = HELP_ITEMS;

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography;
	  return {
	    pageTitle: {
	      color: (0, _lodash.get)(color, 'pageTitle'),
	      fontFamily: (0, _lodash.get)(typography, 'pageTitle'),
	      fontSize: (0, _lodash.get)(fontSize, 'pageTitle'),
	      marginTop: 6
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterByType = exports.FilterByName = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _core = __webpack_require__(3);
	
	var _constants = __webpack_require__(14);
	
	var _components = __webpack_require__(17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var FilterByName = exports.FilterByName = function FilterByName(props) {
	  return React.createElement(
	    _core.Grid,
	    { item: true, md: 3, sm: 3, xs: 12 },
	    React.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'organizations-filter-by-name',
	      'data-apim-test': 'organizations-filter-by-name'
	    }))
	  );
	};
	
	var FilterByType = exports.FilterByType = function FilterByType(props) {
	  return React.createElement(
	    _core.Grid,
	    { item: true, md: 3, sm: 3, xs: 12 },
	    React.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'organizations-filter-by-type',
	      'data-apim-test': 'organizations-filter-by-type',
	      data: _constants.ORGANIZATION_LIST_TYPE_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrganizationList = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _lodash = __webpack_require__(8);
	
	var _Help = __webpack_require__(62);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _organization = __webpack_require__(281);
	
	var _portalConfig = __webpack_require__(26);
	
	var _organization2 = __webpack_require__(203);
	
	var _styles = __webpack_require__(1672);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _controls = __webpack_require__(1670);
	
	var _constants = __webpack_require__(14);
	
	var _intl = __webpack_require__(15);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatType = function formatType(type) {
	  return (0, _lodash.upperFirst)((0, _lodash.lowerCase)(type));
	};
	
	var renderTypeHeaderTooltip = function renderTypeHeaderTooltip(intl) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      null,
	      intl.getI18nMessage('label.organization.list.page.filter.by.publisher.types') + ':\n        ' + intl.getI18nMessage('label.organization.list.page.help.text.publisher')
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      intl.getI18nMessage('label.organization.list.page.filter.by.consumer.types') + ':\n       ' + intl.getI18nMessage('label.organization.list.page.help.text.consumer')
	    )
	  );
	};
	
	var renderTypeHeader = function renderTypeHeader(label, classes, intl) {
	  return _react2.default.createElement(
	    'div',
	    { className: classes.helpIconContainer },
	    _react2.default.createElement(
	      'div',
	      null,
	      label
	    ),
	    _react2.default.createElement(
	      _core.Tooltip,
	      { title: renderTypeHeaderTooltip(intl), arrow: true, placement: 'right' },
	      _react2.default.createElement(_Help2.default, { className: classes.helpIcon })
	    )
	  );
	};
	
	var getOrgListColumns = function getOrgListColumns(_ref, intl) {
	  var classes = _ref.classes,
	      userContext = _ref.userContext;
	  return [Object.assign({
	    id: 'name',
	    label: (0, _intl.getI18nFormattedMessage)('label.organization.name'),
	    minWidth: 200
	  }, (0, _utils.hasAdminRole)(userContext) ? { link: '/admin/console/organizations/edit' } : {}), {
	    id: 'type',
	    label: renderTypeHeader((0, _intl.getI18nFormattedMessage)('label.organization.type'), classes, intl),
	    minWidth: 200,
	    value: function value(item) {
	      return formatType(item.type);
	    }
	  }, {
	    id: 'accountPlanName',
	    label: (0, _intl.getI18nFormattedMessage)('label.organization.accountplan'),
	    minWidth: 100
	  }, {
	    id: 'status',
	    label: (0, _intl.getI18nFormattedMessage)('label.organization.state'),
	    minWidth: 100,
	    value: function value(item) {
	      return (0, _lodash.upperFirst)((0, _lodash.lowerCase)(item.status));
	    }
	  }];
	};
	
	var OrganizationList = exports.OrganizationList = function OrganizationList(props) {
	  var classes = props.classes,
	      userContext = props.userContext,
	      isError = props.isError,
	      isLoading = props.isLoading,
	      totalPages = props.totalPages,
	      _props$totalElements = props.totalElements,
	      totalElements = _props$totalElements === undefined ? 0 : _props$totalElements,
	      _props$results = props.results,
	      results = _props$results === undefined ? [] : _props$results;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      notificationMessage = _useState2[0],
	      setNotificationMessage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      notificationStatus = _useState4[0],
	      setNotificationStatus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filterByName = _useState6[0],
	      setFilterByName = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(_constants.ANY),
	      _useState8 = _slicedToArray(_useState7, 2),
	      filterByType = _useState8[0],
	      setFilterByType = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      page = _useState10[0],
	      setPage = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(_constants.GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState12 = _slicedToArray(_useState11, 2),
	      rowsPerPage = _useState12[0],
	      setRowsPerPage = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      filterByAnyApplied = _useState14[0],
	      setFilterByAnyApplied = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      hideAddButton = _useState16[0],
	      setHideAddButton = _useState16[1];
	
	  var notifyMessages = function notifyMessages(status, message) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  (0, _react.useEffect)(function () {
	    props.fetchOrganizations({
	      name: filterByName,
	      type: filterByType,
	      page: page,
	      size: rowsPerPage
	    });
	    var isUpdateOrg = localStorage.getItem('isUpdateOrg');
	    var isCreateOrg = localStorage.getItem('isCreateOrg');
	    if (isUpdateOrg || isCreateOrg) {
	      localStorage.removeItem('isUpdateOrg');
	      localStorage.removeItem('isCreateOrg');
	      var message = isUpdateOrg ? intl.getI18nMessage('label.organization.updated.message') : intl.getI18nMessage('label.organization.created.message');
	      notifyMessages(_constants.ALERT_SUCCESS, message);
	      // make sure to return the function
	      // which clears timer if timer is used
	      var timeoutID = window.setTimeout(function () {
	        notifyMessages();
	      }, 3000);
	      return function () {
	        return window.clearTimeout(timeoutID);
	      };
	    }
	    return function () {};
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _utils.hasPublisherRole)(userContext) && !(0, _utils.hasOrgPublisherRole)(userContext)) {
	      props.push('/404');
	    }
	    if ((0, _utils.hasAdminRole)(userContext)) {
	      setHideAddButton(false);
	    }
	  }, [userContext]);
	
	  (0, _react.useEffect)(function () {
	    if (isError) {
	      notifyMessages(_constants.ALERT_ERROR, intl.getI18nMessage('error.organization.list.fetch'));
	    }
	  }, [isError]);
	
	  var onFilterByNameChange = function onFilterByNameChange(value) {
	    setFilterByName(value);
	  };
	
	  var onFilterByTypeChange = function onFilterByTypeChange(newType) {
	    setFilterByType(newType);
	    props.fetchOrganizations({
	      name: filterByName,
	      type: newType,
	      page: page,
	      size: rowsPerPage
	    });
	  };
	
	  var onFilterByNameKeyPress = function onFilterByNameKeyPress(e) {
	    if (e.key === 'Enter') {
	      setFilterByAnyApplied(true);
	      props.fetchOrganizations({
	        name: filterByName,
	        type: filterByType,
	        page: page,
	        size: rowsPerPage
	      });
	    }
	  };
	
	  var handleBlur = function handleBlur() {
	    setFilterByAnyApplied(true);
	    props.fetchOrganizations({
	      name: filterByName,
	      type: filterByType,
	      page: page,
	      size: rowsPerPage
	    });
	  };
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    props.fetchOrganizations({
	      name: filterByName,
	      type: filterByType,
	      page: newPage,
	      size: rowsPerPage
	    });
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    props.fetchOrganizations({
	      name: filterByName,
	      type: filterByType,
	      page: page,
	      size: rowsPerPage
	    });
	  };
	
	  var onAddOrganization = function onAddOrganization() {
	    props.push('/admin/console/organizations/add');
	  };
	
	  var noResultsMessage = filterByAnyApplied ? intl.getI18nMessage('label.organization.filter.no.results') : intl.getI18nMessage('label.organization.no.results');
	
	  return _react2.default.createElement(_list2.default, {
	    listPageId: 'organization-list-page',
	    isLoading: isLoading,
	    notificationId: 'organization-notifications',
	    notificationStatus: notificationStatus,
	    setNotificationStatus: setNotificationMessage,
	    notificationMessage: notificationMessage,
	    setNotificationMessage: setNotificationMessage,
	    pageHeaderTitle: intl.getI18nMessage('label.organization.list.page.title'),
	    addButtonLabel: intl.getI18nMessage('label.organization.list.add.button'),
	    onAdd: !hideAddButton && onAddOrganization,
	    pageFilterAndSortClass: classes.pageFilterAndSort,
	    filterAndSortContent: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_controls.FilterByName, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        value: filterByName,
	        placeholder: intl.getI18nMessage('label.organization.list.page.filter.by.name.placeholder'),
	        handleChange: onFilterByNameChange,
	        onKeyPress: onFilterByNameKeyPress,
	        handleBlur: handleBlur
	      }),
	      _react2.default.createElement(_controls.FilterByType, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        value: filterByType,
	        placeholder: intl.getI18nMessage('label.gateway.bundle.list.page.filter.by.group.placeholder'),
	        handleChange: onFilterByTypeChange,
	        hideLabel: true
	      })
	    ),
	    columns: getOrgListColumns(props, intl),
	    rows: results,
	    noResultsMessage: noResultsMessage,
	    page: page,
	    totalElements: totalElements,
	    totalPages: totalPages,
	    rowsPerPage: rowsPerPage,
	    onChangeRowsPerPage: onChangeRowsPerPage,
	    onChangePage: onChangePage,
	    onChangePreviousPage: onChangePreviousPage,
	    onChangeNextPage: onChangeNextPage
	  });
	};
	
	OrganizationList.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  userContext: (0, _propTypes.shape)({}),
	  isLoading: _propTypes.bool,
	  isError: _propTypes.bool,
	  push: _propTypes.func,
	  totalPages: _propTypes.number,
	  totalElements: _propTypes.number,
	  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}))
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    config: (0, _portalConfig.getConfig)(state),
	    userContext: (0, _portalConfig.getUserDetails)(state),
	    isError: (0, _organization2.getIsListError)(state),
	    isLoading: (0, _organization2.getIsLoading)(state),
	    totalPages: (0, _organization2.getOrganizationsListTotalPages)(state),
	    totalElements: (0, _organization2.getOrganizationsListTotalElements)(state),
	    results: (0, _organization2.getOrganizationsListResults)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  push: _connectedReactRouter.push,
	  fetchOrganizations: _organization.fetchOrganizations
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(OrganizationList);

/***/ },
/* 1672 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styles = function styles(_ref) {
	  var color = _ref.color;
	  return {
	    pageFilterAndSort: {
	      'justify-content': 'start'
	    },
	    helpIcon: {
	      color: color.primaryButtonBackground,
	      marginLeft: 6,
	      marginTop: 3,
	      height: 16,
	      width: 16
	    },
	    helpIconContainer: {
	      display: 'flex'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PageNotFound;
	function PageNotFound() {
	  var hostname = ({"NODE_ENV":"production","PUBLIC_URL":"/publish"}).REACT_APP_APIM_HOST || window.location.origin;
	  window.location.href = hostname + "/admin/404";
	  return null;
	}

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionsRaw = exports.getActions = exports.isNotLastActiveProxy = exports.processErrors = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _lodash = __webpack_require__(8);
	
	var _clsx = __webpack_require__(10);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _ExpandLess = __webpack_require__(114);
	
	var _ExpandLess2 = _interopRequireDefault(_ExpandLess);
	
	var _ExpandMore = __webpack_require__(81);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _components = __webpack_require__(17);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1675);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processErrors = exports.processErrors = function processErrors(errors, defaultMessage) {
	  var errorMessage = void 0;
	  if (errors.length > 0) {
	    errorMessage = (0, _lodash.map)(errors, function (validationError) {
	      return validationError.error;
	    }).join('\n');
	  }
	  return errorMessage || defaultMessage;
	};
	
	var isNotLastActiveProxy = exports.isNotLastActiveProxy = function isNotLastActiveProxy(_ref) {
	  var enrollmentStatus = _ref.enrollmentStatus,
	      gateways = _ref.gateways;
	
	  if (enrollmentStatus === _constants.PROXY_ENROLMENT_STATUS_ACTIVE) {
	    var activeProxies = gateways.filter(function (gateway) {
	      return (0, _lodash.get)(gateway, 'EnrollmentStatus') === _constants.PROXY_ENROLMENT_STATUS_ACTIVE;
	    });
	    return activeProxies.length > 1;
	  }
	  return true;
	};
	
	var getActions = exports.getActions = function getActions(_ref2) {
	  var props = _ref2.props,
	      proxyUuid = _ref2.proxyUuid,
	      openDeleteDialog = _ref2.openDeleteDialog,
	      enrollmentStatus = _ref2.enrollmentStatus,
	      gateways = _ref2.gateways;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  // Proxy Delete not allowed if it is the last Active Proxy
	  var isProxyDeleteNotAllowed = !isNotLastActiveProxy({ enrollmentStatus: enrollmentStatus, gateways: gateways });
	  return [{
	    key: 'edit',
	    value: intl.getI18nMessage('label.proxy.details.edit.button'),
	    onClick: function onClick() {
	      props.push('/publish/api-proxy/edit/' + proxyUuid);
	    },
	    visible: true,
	    disabled: false
	  }, {
	    key: 'delete',
	    value: intl.getI18nMessage('label.proxy.details.delete.button'),
	    onClick: function onClick() {
	      if (isProxyDeleteNotAllowed) {
	        return;
	      }
	      openDeleteDialog();
	    },
	    visible: true,
	    disabled: isProxyDeleteNotAllowed
	  }];
	};
	
	var ActionsRaw = exports.ActionsRaw = function ActionsRaw(props) {
	  var useStyles = (0, _core.makeStyles)(_styles2.default);
	  var classes = useStyles();
	  var notifyMessages = props.notifyMessages,
	      deleteProxyErrors = props.deleteProxyErrors,
	      isProxyDeleteSuccess = props.isProxyDeleteSuccess,
	      proxyUuid = props.proxyUuid,
	      enrollmentStatus = props.enrollmentStatus,
	      gateways = props.gateways;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showDeleteDialog = _useState4[0],
	      setShowDeleteDialog = _useState4[1];
	
	  var handleClick = function handleClick() {
	    setOpen(!open);
	  };
	  var handleClickAway = function handleClickAway() {
	    setOpen(false);
	  };
	  var openDeleteDialog = function openDeleteDialog() {
	    return setShowDeleteDialog(true);
	  };
	  var closeDeleteDialog = function closeDeleteDialog() {
	    return setShowDeleteDialog(false);
	  };
	
	  var onDelete = function onDelete() {
	    props.deleteProxy(proxyUuid);
	    closeDeleteDialog();
	  };
	
	  var actions = getActions({
	    props: props,
	    proxyUuid: proxyUuid,
	    openDeleteDialog: openDeleteDialog,
	    enrollmentStatus: enrollmentStatus,
	    gateways: gateways
	  });
	
	  (0, _react.useEffect)(function () {
	    if (isProxyDeleteSuccess) {
	      window.location.href = '/admin/api-proxy';
	    }
	  }, [isProxyDeleteSuccess]);
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _lodash.isEmpty)(deleteProxyErrors)) {
	      notifyMessages(_constants.ALERT_ERROR, processErrors(deleteProxyErrors, intl.getI18nMessage('error.proxy.delete')));
	    }
	  }, [deleteProxyErrors]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: 'proxy-details-actions-container',
	      'data-apim-test': 'proxy-details-actions-container',
	      className: classes.actionsContainer
	    },
	    showDeleteDialog && _react2.default.createElement(_components.AlertDialog, {
	      id: 'proxy-details-delete-dialog',
	      isOpen: showDeleteDialog,
	      title: intl.getI18nMessage('label.delete.confirmation.title'),
	      description: intl.getI18nMessage('label.proxy.details.delete.confirmation.text'),
	      submitText: intl.getI18nMessage('label.delete.button'),
	      cancelText: intl.getI18nMessage('label.cancel.button'),
	      onClose: closeDeleteDialog,
	      onSubmit: onDelete,
	      onCancel: closeDeleteDialog,
	      submitButtonClass: classes.submitButton
	    }),
	    _react2.default.createElement(
	      _core.ClickAwayListener,
	      { onClickAway: handleClickAway },
	      _react2.default.createElement(
	        _core.List,
	        { component: 'nav' },
	        _react2.default.createElement(
	          _core.ListItem,
	          { id: 'proxy-details-actions-button', 'data-apim-test': 'proxy-details-actions-button', classes: { root: classes.listButton }, button: true, onClick: handleClick },
	          _react2.default.createElement(_core.ListItemText, { primary: (0, _intl.getI18nFormattedMessage)('label.actions.button') }),
	          open ? _react2.default.createElement(_ExpandLess2.default, null) : _react2.default.createElement(_ExpandMore2.default, null)
	        ),
	        _react2.default.createElement(
	          _core.Collapse,
	          { className: classes.collapseContainer, 'in': open },
	          _react2.default.createElement(
	            _core.List,
	            { className: classes.list, component: 'div', disablePadding: true },
	            actions.filter(function (_ref3) {
	              var visible = _ref3.visible;
	              return visible;
	            }).map(function (_ref4) {
	              var key = _ref4.key,
	                  value = _ref4.value,
	                  disabled = _ref4.disabled,
	                  onClick = _ref4.onClick;
	              return _react2.default.createElement(
	                _core.ListItem,
	                {
	                  key: key,
	                  id: key, 'data-apim-test': key, 'data-layer7-test': key,
	                  button: true,
	                  className: (0, _clsx2.default)('action', classes.listItem),
	                  disabled: disabled,
	                  onClick: onClick
	                },
	                _react2.default.createElement(_core.ListItemText, { primary: value })
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	ActionsRaw.propTypes = {
	  notifyMessages: _propTypes.func,
	  proxyUuid: _propTypes.string,
	  deleteProxyErrors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  isProxyDeleteSuccess: _propTypes.bool,
	  enrollmentStatus: _propTypes.string,
	  gateways: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  deleteProxy: _propTypes.func
	};
	ActionsRaw.displayName = 'Actions';
	
	exports.default = ActionsRaw;

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography,
	      borderRadius = _ref.borderRadius,
	      margin = _ref.margin,
	      padding = _ref.padding;
	  return {
	    actionsContainer: {
	      display: 'inline-block',
	      float: 'right',
	      backgroundColor: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      borderColor: (0, _lodash.get)(color, 'primaryButtonBackground'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      borderRadius: (0, _lodash.get)(borderRadius, 'br4'),
	      margin: '0 ' + (0, _lodash.get)(margin, 'm36'),
	      color: (0, _lodash.get)(color, 'primaryButtonText'),
	      '& nav': {
	        padding: (0, _lodash.get)(padding, 'p0'),
	        '& > div > div > span': {
	          color: (0, _lodash.get)(color, 'primaryButtonText')
	        }
	      },
	      minWidth: 160
	    },
	    collapseContainer: {
	      position: 'absolute',
	      width: '100%',
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderRadius: (0, _lodash.get)(borderRadius, 'br4'),
	      zIndex: 1
	    },
	    listButton: {
	      paddingTop: (0, _lodash.get)(padding, 'p5'),
	      paddingBottom: (0, _lodash.get)(padding, 'p5')
	    },
	    list: {
	      boxShadow: '0px 4px 8px #00000033',
	      '& > div:first-child': {
	        borderRadius: '3px 3px 0 0'
	      },
	      '& > div:last-child': {
	        borderRadius: '0 0 3px 3px'
	      },
	      '& .MuiButtonBase-root.Mui-disabled': {
	        pointerEvents: 'auto'
	      },
	      backgroundColor: (0, _lodash.get)(color, 'white'),
	      borderColor: (0, _lodash.get)(color, 'white'),
	      color: (0, _lodash.get)(color, 'grayDark')
	    },
	    listItem: {
	      color: (0, _lodash.get)(color, 'link'),
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderColor: (0, _lodash.get)(color, 'uiBackground'),
	      borderRadius: (0, _lodash.get)(borderRadius, 'br4')
	    },
	    submitButton: {
	      backgroundColor: (0, _lodash.get)(color, 'red') + ' !important'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterAndSortSeparator = exports.SortBy = exports.FilterByStates = exports.FilterByDeploymentStatus = exports.FilterByPublishSources = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterByPublishSources = exports.FilterByPublishSources = function FilterByPublishSources(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'proxy-details-apis-filter-publish-source-by',
	      'data-apim-test': 'proxy-details-apis-filter-publish-source-by',
	      data: _constants.APIS_PUBLISH_SOURCES_FILTER_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var FilterByDeploymentStatus = exports.FilterByDeploymentStatus = function FilterByDeploymentStatus(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'proxy-details-apis-filter-status-by',
	      'data-apim-test': 'proxy-details-apis-filter-status-by',
	      data: _constants.APIS_DEPLOYMENT_STATUS_FILTER_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var FilterByStates = exports.FilterByStates = function FilterByStates(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 2 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'proxy-details-apis-filter-state-by',
	      'data-apim-test': 'proxy-details-apis-filter-state-by',
	      data: _constants.PROXY_APIS_STATES_FILTER_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var SortBy = exports.SortBy = function SortBy(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'proxy-details-apis-sort-by',
	      'data-apim-test': 'proxy-details-apis-sort-by',
	      data: _constants.PROXY_APIS_SORT_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var FilterAndSortSeparator = exports.FilterAndSortSeparator = function FilterAndSortSeparator() {
	  return _react2.default.createElement(_core.Grid, { item: true, md: 1 });
	};

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApiListRaw = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _lodash = __webpack_require__(8);
	
	var _queryString = __webpack_require__(100);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _proxy = __webpack_require__(282);
	
	var _proxy2 = __webpack_require__(104);
	
	var _styles = __webpack_require__(1678);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _constants = __webpack_require__(14);
	
	var _controls = __webpack_require__(1676);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LIST_COLUMNS = [{
	  id: 'name',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.name'),
	  minWidth: 100,
	  link: '/publish/apis/details'
	}, {
	  id: 'portalStatus',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.state'),
	  format: function format(value) {
	    return (0, _lodash.replace)(value, 'NEW', 'UnPublished');
	  },
	  minWidth: 50,
	  isStatusIcon: true
	}, {
	  id: 'publishedByPortal',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.publish.source'),
	  format: function format(value) {
	    return value ? 'Portal' : 'Gateway';
	  },
	  minWidth: 50
	}, {
	  id: 'lastTimeDeployed',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.date.last.deployed', { zone: (0, _datetime.getTimeZoneAbbr)() }),
	  format: function format(value) {
	    return (0, _datetime2.default)(value);
	  },
	  minWidth: 50
	}, {
	  id: 'status',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.deployed.status'),
	  minWidth: 50,
	  isStatusIcon: true
	}];
	
	var ApiListRaw = exports.ApiListRaw = function ApiListRaw(props) {
	  var proxyUuid = props.proxyUuid,
	      classes = props.classes,
	      isLoading = props.isLoading,
	      totalPages = props.totalPages,
	      _props$totalElements = props.totalElements,
	      totalElements = _props$totalElements === undefined ? 0 : _props$totalElements,
	      _props$results = props.results,
	      results = _props$results === undefined ? [] : _props$results,
	      notifyMessages = props.notifyMessages,
	      isCurrentTab = props.isCurrentTab;
	
	
	  var parsed = _queryString2.default.parse(props.location.search);
	  var deploymentStatus = parsed.status || 'all';
	  var source = parsed.source || 'all';
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)('all'),
	      _useState2 = _slicedToArray(_useState, 2),
	      state = _useState2[0],
	      setState = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(source),
	      _useState4 = _slicedToArray(_useState3, 2),
	      publishSource = _useState4[0],
	      setPublishSource = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(deploymentStatus),
	      _useState6 = _slicedToArray(_useState5, 2),
	      status = _useState6[0],
	      setStatus = _useState6[1];
	
	  var _useState7 = (0, _react.useState)('lastTimeDeployed,DESC'),
	      _useState8 = _slicedToArray(_useState7, 2),
	      sortBy = _useState8[0],
	      setSortBy = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      page = _useState10[0],
	      setPage = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(_constants.GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState12 = _slicedToArray(_useState11, 2),
	      rowsPerPage = _useState12[0],
	      setRowsPerPage = _useState12[1];
	
	  var emptyFunction = function emptyFunction() {};
	
	  (0, _react.useEffect)(function () {
	    if (proxyUuid) {
	      props.fetchProxyApisList({
	        proxyUuid: proxyUuid, publishSource: publishSource, status: status, state: state, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage
	      });
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var parsed = _queryString2.default.parse(props.location.search);
	    var deploymentStatus = parsed.status || 'all';
	    var source = parsed.source || 'all';
	    setPublishSource(source);
	    setStatus(deploymentStatus);
	    if (proxyUuid && isCurrentTab) {
	      props.fetchProxyApisList({
	        proxyUuid: proxyUuid,
	        publishSource: source,
	        status: deploymentStatus,
	        state: state, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage
	      });
	    }
	  }, [props.location, isCurrentTab]);
	
	  var onFilterByPublishSourcesChange = function onFilterByPublishSourcesChange(newSource) {
	    setPublishSource(newSource);
	    props.fetchProxyApisList({ proxyUuid: proxyUuid, publishSource: newSource, status: status,
	      state: state, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	  };
	
	  var onFilterByDeploymentStatus = function onFilterByDeploymentStatus(newStatus) {
	    setStatus(newStatus);
	    props.fetchProxyApisList({ proxyUuid: proxyUuid, publishSource: publishSource, status: newStatus,
	      state: state, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	  };
	
	  var onFilterByStateChange = function onFilterByStateChange(newStateBy) {
	    setState(newStateBy);
	    props.fetchProxyApisList({ proxyUuid: proxyUuid, publishSource: publishSource, status: status,
	      state: newStateBy, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	  };
	
	  var onSortByChange = function onSortByChange(newSortBy) {
	    setSortBy(newSortBy);
	    props.fetchProxyApisList({ proxyUuid: proxyUuid, publishSource: publishSource, status: status,
	      state: state, sortBy: newSortBy, page: page, rowsPerPage: rowsPerPage });
	  };
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    props.fetchProxyApisList({ proxyUuid: proxyUuid, publishSource: publishSource, status: status,
	      state: state, sortBy: sortBy, page: newPage, rowsPerPage: rowsPerPage });
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    props.fetchProxyApisList({ proxyUuid: proxyUuid, publishSource: publishSource, status: status,
	      state: state, sortBy: sortBy, page: 0, rowsPerPage: newRowsPerPage });
	  };
	
	  return _react2.default.createElement(_list2.default, {
	    listPageId: 'proxy-details-apis-list',
	    isLoading: isLoading,
	    notificationId: 'proxy-details-notifications',
	    notificationStatus: '',
	    setNotificationStatus: emptyFunction,
	    notificationMessage: '',
	    setNotificationMessage: emptyFunction,
	    pageHeaderTitle: '',
	    pageHeaderTooltipTitle: '',
	    addButtonLabel: '',
	    onAddBundle: emptyFunction,
	    showListHeader: false,
	    pageClass: classes.listContent,
	    pageBodyClass: classes.pageBodyClass,
	    pageFilterAndSortClass: classes.pageFilterAndSortClass,
	    filterAndSortContent: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_controls.FilterByStates, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        selectFieldClass: classes.selectField,
	        value: state,
	        handleChange: onFilterByStateChange
	      }),
	      _react2.default.createElement(_controls.FilterByPublishSources, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        selectFieldClass: classes.selectField,
	        value: publishSource,
	        handleChange: onFilterByPublishSourcesChange,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterByDeploymentStatus, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        selectFieldClass: classes.selectField,
	        value: status,
	        handleChange: onFilterByDeploymentStatus,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterAndSortSeparator, null),
	      _react2.default.createElement(_controls.SortBy, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.sort.by'),
	        value: sortBy,
	        handleChange: onSortByChange
	      })
	    ),
	    columns: LIST_COLUMNS,
	    rows: results,
	    noResultsMessage: intl.getI18nMessage('label.proxy.details.apis.no.results'),
	    page: page,
	    totalElements: totalElements,
	    totalPages: totalPages,
	    rowsPerPage: rowsPerPage,
	    rowsPerPageOptions: _constants.GRID_ROWS_PER_PAGE_OPTIONS,
	    onChangeRowsPerPage: onChangeRowsPerPage,
	    onChangePage: onChangePage,
	    onChangePreviousPage: onChangePreviousPage,
	    onChangeNextPage: onChangeNextPage,
	    notifyMessages: notifyMessages
	  });
	};
	
	ApiListRaw.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  location: (0, _propTypes.shape)({}),
	  isLoading: _propTypes.bool,
	  totalPages: _propTypes.number,
	  totalElements: _propTypes.number,
	  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  fetchProxyApis: _propTypes.func,
	  fetchProxyApisList: _propTypes.func,
	  proxyUuid: _propTypes.string,
	  notifyMessages: _propTypes.func,
	  isCurrentTab: _propTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoading: false,
	    totalPages: (0, _proxy2.getApisListTotalPages)(state),
	    totalElements: (0, _proxy2.getApisListTotalElements)(state),
	    results: (0, _proxy2.getApisListResults)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchProxyApisList: _proxy.fetchProxyApisList
	};
	ApiListRaw.displayName = 'Apis';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ApiListRaw);

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var padding = _ref.padding,
	      margin = _ref.margin;
	  return {
	    listContent: {
	      margin: (0, _lodash.get)(margin, 'm0')
	    },
	    pageBodyClass: {
	      paddingTop: (0, _lodash.get)(padding, 'p0')
	    },
	    pageFilterAndSortClass: {
	      marginTop: (0, _lodash.get)(margin, 'm24')
	    },
	    fieldContainer: {
	      margin: (0, _lodash.get)(margin, 'm0') + ' !important',
	      marginRight: '5px !important'
	    },
	    selectField: {
	      padding: '2px 10px !important'
	    }
	
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterAndSortSeparator = exports.SortBy = exports.FilterByKeyStatus = exports.FilterByDeploymentStatus = exports.FilterByApiKey = exports.FilterByKeyName = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(3);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterByKeyName = exports.FilterByKeyName = function FilterByKeyName(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 2 },
	    _react2.default.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'proxy-details-keys-filter-by-key-name',
	      'data-apim-test': 'proxy-details-keys-filter-by-key-name'
	    }))
	  );
	};
	
	var FilterByApiKey = exports.FilterByApiKey = function FilterByApiKey(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 3 },
	    _react2.default.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'proxy-details-keys-filter-by-api-key',
	      'data-apim-test': 'proxy-details-keys-filter-by-api-key'
	    }))
	  );
	};
	
	var FilterByDeploymentStatus = exports.FilterByDeploymentStatus = function FilterByDeploymentStatus(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 2 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'proxy-details-keys-filter-status-by',
	      'data-apim-test': 'proxy-details-keys-filter-status-by',
	      data: _constants.APIS_DEPLOYMENT_STATUS_FILTER_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var FilterByKeyStatus = exports.FilterByKeyStatus = function FilterByKeyStatus(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 2 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'proxy-details-keys-filter-by-key-status',
	      'data-apim-test': 'proxy-details-keys-filter-by-key-status',
	      data: _constants.PROXY_APIS_KEY_STATUS_FILTER_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var SortBy = exports.SortBy = function SortBy(props) {
	  return _react2.default.createElement(
	    _core.Grid,
	    { item: true, md: 2 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'proxy-details-keys-sort-by',
	      'data-apim-test': 'proxy-details-keys-sort-by',
	      data: _constants.PROXY_APIS_SORT_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var FilterAndSortSeparator = exports.FilterAndSortSeparator = function FilterAndSortSeparator() {
	  return _react2.default.createElement(_core.Grid, { item: true, md: 1 });
	};

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.KeyListRaw = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _queryString = __webpack_require__(100);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _proxy = __webpack_require__(282);
	
	var _proxy2 = __webpack_require__(104);
	
	var _styles = __webpack_require__(1681);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _constants = __webpack_require__(14);
	
	var _controls = __webpack_require__(1679);
	
	var _datetime = __webpack_require__(68);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LIST_COLUMNS = [{
	  id: 'name',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.keys.name'),
	  minWidth: 100,
	  link: '/publish/applications/details'
	}, {
	  id: 'apiKey',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.keys.api.key'),
	  minWidth: 50
	}, {
	  id: 'keyStatus',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.keys.status'),
	  minWidth: 50,
	  isStatusIcon: true
	}, {
	  id: 'status',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.keys.deployment.status'),
	  minWidth: 50,
	  isStatusIcon: true
	}, {
	  id: 'lastTimeDeployed',
	  label: (0, _intl.getI18nFormattedMessage)('label.api.date.last.deployed', { zone: (0, _datetime.getTimeZoneAbbr)() }),
	  format: function format(value) {
	    return (0, _datetime2.default)(value);
	  },
	  minWidth: 50
	}];
	
	var KeyListRaw = exports.KeyListRaw = function KeyListRaw(props) {
	  var proxyUuid = props.proxyUuid,
	      classes = props.classes,
	      isLoading = props.isLoading,
	      totalPages = props.totalPages,
	      _props$totalElements = props.totalElements,
	      totalElements = _props$totalElements === undefined ? 0 : _props$totalElements,
	      _props$results = props.results,
	      results = _props$results === undefined ? [] : _props$results,
	      notifyMessages = props.notifyMessages,
	      isCurrentTab = props.isCurrentTab;
	
	
	  var parsed = _queryString2.default.parse(props.location.search);
	  var deploymentStatus = parsed.status || 'all';
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      keyName = _useState2[0],
	      setKeyName = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      apiKey = _useState4[0],
	      setApiKey = _useState4[1];
	
	  var _useState5 = (0, _react.useState)('all'),
	      _useState6 = _slicedToArray(_useState5, 2),
	      keyStatus = _useState6[0],
	      setKeyStatus = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(deploymentStatus),
	      _useState8 = _slicedToArray(_useState7, 2),
	      status = _useState8[0],
	      setStatus = _useState8[1];
	
	  var _useState9 = (0, _react.useState)('lastTimeDeployed,DESC'),
	      _useState10 = _slicedToArray(_useState9, 2),
	      sortBy = _useState10[0],
	      setSortBy = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      page = _useState12[0],
	      setPage = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(_constants.GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState14 = _slicedToArray(_useState13, 2),
	      rowsPerPage = _useState14[0],
	      setRowsPerPage = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      filterApiKey = _useState16[0],
	      setFilterApiKey = _useState16[1];
	
	  var emptyFunction = function emptyFunction() {};
	
	  (0, _react.useEffect)(function () {
	    if (proxyUuid) {
	      props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: keyStatus, apiKey: apiKey, status: status,
	        sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var parsed = _queryString2.default.parse(props.location.search);
	    var deploymentStatus = parsed.status || 'all';
	    setStatus(deploymentStatus);
	    if (proxyUuid && isCurrentTab) {
	      props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: keyStatus, apiKey: apiKey,
	        status: deploymentStatus, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	    }
	  }, [props.location, isCurrentTab]);
	
	  var onFilterByKeyNameChange = function onFilterByKeyNameChange(value) {
	    setFilterApiKey(false);
	    setKeyName(value);
	  };
	
	  var onFilterByKeyNameKeyPress = function onFilterByKeyNameKeyPress(e) {
	    if (e.key === 'Enter') {
	      props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: keyStatus, apiKey: apiKey,
	        status: status, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	    }
	  };
	
	  var onFilterByApiKeyChange = function onFilterByApiKeyChange(value) {
	    setApiKey(value);
	  };
	
	  var onFilterByApiKeyPress = function onFilterByApiKeyPress(e) {
	    if (e.key === 'Enter') {
	      setFilterApiKey(true);
	      props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: keyStatus, apiKey: apiKey,
	        status: status, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	    }
	  };
	
	  var onFilterByKeyStatus = function onFilterByKeyStatus(newKeyStatus) {
	    setFilterApiKey(false);
	    setKeyStatus(newKeyStatus);
	    props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: newKeyStatus, apiKey: apiKey,
	      status: status, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	  };
	
	  var onFilterByDeploymentStatus = function onFilterByDeploymentStatus(newStatus) {
	    setFilterApiKey(false);
	    setStatus(newStatus);
	    props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: keyStatus, apiKey: apiKey,
	      status: newStatus, sortBy: sortBy, page: page, rowsPerPage: rowsPerPage });
	  };
	
	  var onSortByChange = function onSortByChange(newSortBy) {
	    setFilterApiKey(false);
	    setSortBy(newSortBy);
	    props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: keyStatus, apiKey: apiKey, status: status,
	      sortBy: newSortBy, page: page, rowsPerPage: rowsPerPage });
	  };
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	    props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: keyStatus, apiKey: apiKey, status: status,
	      sortBy: sortBy, page: newPage, rowsPerPage: rowsPerPage });
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	    props.fetchProxyApiKeysList({ proxyUuid: proxyUuid, keyName: keyName, keyStatus: keyStatus, apiKey: apiKey, status: status,
	      sortBy: sortBy, page: 0, rowsPerPage: newRowsPerPage });
	  };
	
	  var noResultsMessage = filterApiKey ? '' + intl.getI18nMessage('label.api.keys.api.key.list.no.results') : intl.getI18nMessage('label.api.keys.list.no.results');
	
	  return _react2.default.createElement(_list2.default, {
	    listPageId: 'proxy-details-keys-list',
	    isLoading: isLoading,
	    notificationId: 'proxy-details-notifications',
	    notificationStatus: '',
	    setNotificationStatus: emptyFunction,
	    notificationMessage: '',
	    setNotificationMessage: emptyFunction,
	    pageHeaderTitle: '',
	    pageHeaderTooltipTitle: '',
	    addButtonLabel: '',
	    onAddBundle: emptyFunction,
	    showListHeader: false,
	    pageClass: classes.listContent,
	    pageBodyClass: classes.pageBodyClass,
	    pageFilterAndSortClass: classes.pageFilterAndSortClass,
	    filterAndSortContent: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_controls.FilterByKeyName, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        value: keyName,
	        placeholder: intl.getI18nMessage('label.api.keys.key.name.placeholder'),
	        handleChange: onFilterByKeyNameChange,
	        onKeyPress: onFilterByKeyNameKeyPress
	      }),
	      _react2.default.createElement(_controls.FilterByApiKey, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        value: apiKey,
	        placeholder: intl.getI18nMessage('label.api.keys.api.key.placeholder'),
	        handleChange: onFilterByApiKeyChange,
	        onKeyPress: onFilterByApiKeyPress,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterByKeyStatus, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        selectFieldClass: classes.selectField,
	        value: keyStatus,
	        handleChange: onFilterByKeyStatus,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterByDeploymentStatus, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter.by'),
	        selectFieldClass: classes.selectField,
	        value: status,
	        handleChange: onFilterByDeploymentStatus,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterAndSortSeparator, null),
	      _react2.default.createElement(_controls.SortBy, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.sort.by'),
	        value: sortBy,
	        handleChange: onSortByChange
	      })
	    ),
	    columns: LIST_COLUMNS,
	    rows: results,
	    uuidName: 'applicationUuid',
	    noResultsMessage: noResultsMessage,
	    page: page,
	    totalElements: totalElements,
	    totalPages: totalPages,
	    rowsPerPage: rowsPerPage,
	    rowsPerPageOptions: _constants.GRID_ROWS_PER_PAGE_OPTIONS,
	    onChangeRowsPerPage: onChangeRowsPerPage,
	    onChangePage: onChangePage,
	    onChangePreviousPage: onChangePreviousPage,
	    onChangeNextPage: onChangeNextPage,
	    notifyMessages: notifyMessages
	  });
	};
	
	KeyListRaw.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  location: (0, _propTypes.shape)({}),
	  isLoading: _propTypes.bool,
	  totalPages: _propTypes.number,
	  totalElements: _propTypes.number,
	  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  fetchProxyApis: _propTypes.func,
	  proxyUuid: _propTypes.string,
	  fetchProxyApiKeysList: _propTypes.func,
	  notifyMessages: _propTypes.func,
	  isCurrentTab: _propTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoading: false,
	    totalPages: (0, _proxy2.getKeysListTotalPages)(state),
	    totalElements: (0, _proxy2.getKeysListTotalElements)(state),
	    results: (0, _proxy2.getKeysListResults)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchProxyApiKeysList: _proxy.fetchProxyApiKeysList
	};
	KeyListRaw.displayName = 'Keys';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(KeyListRaw);

/***/ },
/* 1681 */
1678,
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Paper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _core = __webpack_require__(3);
	
	var _icons = __webpack_require__(146);
	
	var _propTypes = __webpack_require__(5);
	
	var _footer = __webpack_require__(620);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Paper = exports.Paper = function Paper(props) {
	  var _props$classes = props.classes,
	      classes = _props$classes === undefined ? {} : _props$classes,
	      id = props.id,
	      title = props.title,
	      proxyStatus = props.proxyStatus,
	      content = props.content,
	      contentMore = props.contentMore,
	      deploymentType = props.deploymentType,
	      lastUpdated = props.lastUpdated;
	
	
	  var isProxyDisconnected = proxyStatus === _constants.PROXY_DISCONNECTED;
	  var containerClass = isProxyDisconnected ? (0, _classnames2.default)(classes.paper, classes.disconnectedBackground) : classes.paper;
	
	  return _react2.default.createElement(
	    _core.Paper,
	    {
	      square: true, elevation: 0,
	      className: containerClass,
	      id: id + '-status', 'data-layer7-test': id + '-status'
	    },
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true },
	        _react2.default.createElement(
	          _core.Typography,
	          {
	            variant: 'h2',
	            className: classes.title,
	            id: id + '-status-title', 'data-layer7-test': id + '-status-title'
	          },
	          title
	        )
	      ),
	      isProxyDisconnected && _react2.default.createElement(
	        _core.Grid,
	        { item: true },
	        _react2.default.createElement(
	          _core.IconButton,
	          {
	            className: classes.disconnectedIndicatorIcon,
	            'data-disconnected': true
	          },
	          _react2.default.createElement(_icons.PowerUnplugedIcon, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _core.Typography,
	      {
	        variant: 'h1',
	        className: classes.value
	      },
	      content
	    ),
	    contentMore,
	    _react2.default.createElement(_footer2.default, {
	      id: id,
	      deploymentType: deploymentType,
	      lastUpdated: lastUpdated
	    })
	  );
	};
	
	exports.default = Paper;
	
	
	Paper.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  title: _propTypes.string,
	  proxyStatus: _propTypes.string,
	  content: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
	  contentMore: (0, _propTypes.shape)({}),
	  deploymentType: _propTypes.string,
	  lastUpdated: _propTypes.string
	};

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaperWithStatus = exports.ToggleSubtotal = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _core = __webpack_require__(3);
	
	var _icons = __webpack_require__(146);
	
	var _propTypes = __webpack_require__(5);
	
	var _components = __webpack_require__(17);
	
	var _table = __webpack_require__(621);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _visualization = __webpack_require__(1684);
	
	var _visualization2 = _interopRequireDefault(_visualization);
	
	var _footer = __webpack_require__(620);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _intl = __webpack_require__(15);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleSubtotal = exports.ToggleSubtotal = function ToggleSubtotal(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      hideSubtotal = _ref.hideSubtotal,
	      setHideSubtotal = _ref.setHideSubtotal;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  return _react2.default.createElement(
	    _core.IconButton,
	    {
	      className: classes.hideSubtotal,
	      id: 'hide-subtotal', 'data-layer7-test': 'hide-subtotal',
	      onClick: function onClick() {
	        return setHideSubtotal(!hideSubtotal);
	      }
	    },
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'body1' },
	      hideSubtotal ? intl.getI18nMessage('label.proxy.details.api.show.subtotal') : intl.getI18nMessage('label.proxy.details.api.hide.subtotal')
	    )
	  );
	};
	
	ToggleSubtotal.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  hideSubtotal: _propTypes.bool,
	  setHideSubtotal: _propTypes.func
	};
	
	var PaperWithStatus = exports.PaperWithStatus = function PaperWithStatus(props) {
	  var _props$classes = props.classes,
	      classes = _props$classes === undefined ? {} : _props$classes,
	      id = props.id,
	      title = props.title,
	      deploymentType = props.deploymentType,
	      proxyStatus = props.proxyStatus,
	      bulkDeploymentStatus = props.bulkDeploymentStatus,
	      refreshTime = props.refreshTime,
	      checkStatus = props.checkStatus,
	      _props$errorCount = props.errorCount,
	      errorCount = _props$errorCount === undefined ? 0 : _props$errorCount,
	      lastUpdated = props.lastUpdated,
	      showBreakdown = props.showBreakdown,
	      deploymentTypeTooltip = props.deploymentTypeTooltip;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      hideSubtotal = _useState2[0],
	      setHideSubtotal = _useState2[1];
	
	  var isProxyDisconnected = proxyStatus === _constants.PROXY_DISCONNECTED;
	  var isBulkDeploymentStatusRunning = bulkDeploymentStatus === _constants.BULK_DEPLOYMENT_STATUS_RUNNING;
	  var containerClass = isProxyDisconnected ? (0, _classnames2.default)(classes.paper, classes.disconnectedBackground) : classes.paper;
	
	  return _react2.default.createElement(
	    _core.Paper,
	    {
	      square: true, elevation: 0,
	      className: containerClass,
	      id: id + '-status', 'data-layer7-test': id + '-status'
	    },
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true },
	        _react2.default.createElement(
	          _core.Typography,
	          {
	            variant: 'h2',
	            className: classes.title,
	            id: id + '-status-title', 'data-layer7-test': id + '-status-title'
	          },
	          title
	        )
	      ),
	      isProxyDisconnected && _react2.default.createElement(
	        _core.Grid,
	        { item: true },
	        _react2.default.createElement(
	          _core.IconButton,
	          {
	            className: classes.disconnectedIndicatorIcon,
	            'data-disconnected': true
	          },
	          _react2.default.createElement(_icons.PowerUnplugedIcon, null)
	        )
	      ),
	      !isProxyDisconnected && errorCount > 0 && _react2.default.createElement(
	        _core.Grid,
	        { item: true },
	        _react2.default.createElement(
	          _core.IconButton,
	          {
	            className: classes.errorIndicatorIcon,
	            'data-error': true
	          },
	          _react2.default.createElement(_icons.IntentDangerIcon, null)
	        )
	      ),
	      !isProxyDisconnected && isBulkDeploymentStatusRunning && _react2.default.createElement(
	        _core.Grid,
	        { item: true },
	        _react2.default.createElement(_components.RefreshCounter, {
	          refreshTime: refreshTime,
	          checkStatus: checkStatus
	        })
	      )
	    ),
	    _react2.default.createElement(_visualization2.default, Object.assign({}, props, {
	      isProxyDisconnected: isProxyDisconnected
	    })),
	    _react2.default.createElement(_table2.default, Object.assign({}, props, {
	      hideSubtotal: hideSubtotal,
	      isProxyDisconnected: isProxyDisconnected
	    })),
	    showBreakdown && _react2.default.createElement(ToggleSubtotal, {
	      classes: classes,
	      hideSubtotal: hideSubtotal,
	      setHideSubtotal: setHideSubtotal
	    }),
	    _react2.default.createElement(_footer2.default, {
	      id: id,
	      deploymentType: deploymentType,
	      tooltip: deploymentTypeTooltip,
	      lastUpdated: lastUpdated
	    })
	  );
	};
	
	PaperWithStatus.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  title: _propTypes.string,
	  deploymentType: _propTypes.string,
	  deploymentTypeTooltip: (0, _propTypes.shape)({}),
	  proxyStatus: _propTypes.string,
	  bulkDeploymentStatus: _propTypes.string,
	  refreshTime: _propTypes.string,
	  checkStatus: _propTypes.func,
	  errorCount: _propTypes.number,
	  lastUpdated: _propTypes.string,
	  showBreakdown: _propTypes.bool
	};
	PaperWithStatus.displayName = 'PaperWithStatus';
	
	exports.default = PaperWithStatus;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Visualization = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _victory = __webpack_require__(305);
	
	var _get2 = __webpack_require__(23);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _styles = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Visualization = exports.Visualization = function Visualization(props) {
	  var isProxyDisconnected = props.isProxyDisconnected,
	      _props$publishedCount = props.publishedCount,
	      publishedCount = _props$publishedCount === undefined ? 0 : _props$publishedCount,
	      _props$pendingCount = props.pendingCount,
	      pendingCount = _props$pendingCount === undefined ? 0 : _props$pendingCount,
	      _props$deployedCount = props.deployedCount,
	      deployedCount = _props$deployedCount === undefined ? 0 : _props$deployedCount,
	      _props$errorCount = props.errorCount,
	      errorCount = _props$errorCount === undefined ? 0 : _props$errorCount;
	
	
	  var theme = (0, _styles.useTheme)();
	
	  var _get = (0, _get3.default)(theme, 'color', {}),
	      bodyText = _get.bodyText,
	      disabledBackground = _get.disabledBackground,
	      disabledGraphic = _get.disabledGraphic,
	      success = _get.success,
	      error = _get.error,
	      uiBackground = _get.uiBackground;
	
	  var borderColor = isProxyDisconnected ? disabledBackground : bodyText;
	  var colorScale = [disabledGraphic, disabledBackground, success, error];
	  var visualizationData = isProxyDisconnected ? [0, publishedCount, 0, 0] : [publishedCount - (pendingCount + deployedCount + errorCount), pendingCount, deployedCount, errorCount];
	  var data = visualizationData.map(function (i) {
	    return [{ x: 1, y: i }];
	  });
	
	  var axisStyles = {
	    axis: { stroke: 'transparent' },
	    ticks: { stroke: 'transparent' },
	    tickLabels: { fill: 'transparent' }
	  };
	
	  return _react2.default.createElement(
	    _victory.VictoryChart,
	    {
	      horizontal: true,
	      height: 30,
	      padding: { bottom: 0, left: 2, right: 2, top: 0 },
	      containerComponent: _react2.default.createElement(_victory.VictoryContainer, {
	        height: 20,
	        style: {
	          border: '2px solid ' + borderColor,
	          borderRadius: 4,
	          marginBottom: 20,
	          marginTop: 10
	        }
	      })
	    },
	    _react2.default.createElement(
	      _victory.VictoryStack,
	      {
	        colorScale: colorScale,
	        style: {
	          data: {
	            fillOpacity: 1.0,
	            stroke: uiBackground,
	            strokeWidth: 3
	          }
	        }
	      },
	      data.map(function (d, key) {
	        return _react2.default.createElement(_victory.VictoryBar, {
	          alignment: 'middle',
	          barWidth: 25,
	          data: d,
	          key: key
	        });
	      })
	    ),
	    _react2.default.createElement(_victory.VictoryAxis, { style: axisStyles }),
	    _react2.default.createElement(_victory.VictoryAxis, { style: axisStyles })
	  );
	};
	
	exports.default = Visualization;
	
	
	Visualization.propTypes = {
	  isProxyDisconnected: _propTypes.bool,
	  publishedCount: _propTypes.number,
	  pendingCount: _propTypes.number,
	  deployedCount: _propTypes.number,
	  errorCount: _propTypes.number
	};

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApiKeys = exports.ApiKeysTooltip = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(27);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(103);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _deployment = __webpack_require__(205);
	
	var _proxy = __webpack_require__(104);
	
	var _Paper = __webpack_require__(200);
	
	var _constants = __webpack_require__(14);
	
	var _components = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApiKeysTooltip = exports.ApiKeysTooltip = function ApiKeysTooltip() {
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  return _react2.default.createElement(
	    'div',
	    null,
	    intl.getI18nMessage('label.proxy.details.api.key.deployment.tooltip')
	  );
	};
	
	var ApiKeys = exports.ApiKeys = function ApiKeys(props) {
	  var proxyUuid = props.proxyUuid,
	      proxyDetails = props.proxyDetails,
	      bulkDeploymentStatus = props.bulkDeploymentStatus,
	      deploymentRefreshTime = props.deploymentRefreshTime,
	      proxyStatus = props.proxyStatus,
	      parsedGatewayDetails = props.parsedGatewayDetails,
	      publishedCount = props.publishedCount,
	      _props$apiKeys = props.apiKeys,
	      apiKeys = _props$apiKeys === undefined ? [] : _props$apiKeys,
	      push = props.push,
	      isApiKeysLoading = props.isApiKeysLoading;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _proxyDetails$config = proxyDetails.config,
	      config = _proxyDetails$config === undefined ? {} : _proxyDetails$config,
	      _proxyDetails$deploym = proxyDetails.deploymentTypes,
	      deploymentTypes = _proxyDetails$deploym === undefined ? {} : _proxyDetails$deploym;
	  var application = deploymentTypes.application;
	  var useNewAutoSync = config.useNewAutoSync;
	  var appSyncTime = parsedGatewayDetails.appSyncTime;
	
	
	  var fetchApiKeys = function fetchApiKeys() {
	    props.fetchApiKeysCount();
	    props.fetchApiKeys(proxyUuid);
	  };
	
	  (0, _react.useEffect)(function () {
	    fetchApiKeys(proxyUuid);
	  }, [proxyUuid]);
	
	  var isOverviewWithStatus = [_constants.PROXY_DEPLOYMENT_TYPE_AUTOMATIC, _constants.PROXY_DEPLOYMENT_TYPE_ON_DEMAND].includes(application);
	  var isOverviewWithoutStatus = _constants.PROXY_DEPLOYMENT_TYPE_SCRIPTED === application;
	
	  var deployedCount = (0, _lodash.get)(apiKeys, 'keysDeployed.totalElements') || 0;
	  var pendingDeployCount = (0, _lodash.get)(apiKeys, 'keysPendingDeployment.totalElements') || 0;
	  var pendingUndeployCount = (0, _lodash.get)(apiKeys, 'keysPendingUnDeployment.totalElements') || 0;
	  var pendingCount = pendingDeployCount + pendingUndeployCount;
	  var errorDeployCount = (0, _lodash.get)(apiKeys, 'keysError.totalElements') || 0;
	  var errorUndeployCount = (0, _lodash.get)(apiKeys, 'keysErrorUnDeploy.totalElements') || 0;
	  var errorCount = errorDeployCount + errorUndeployCount;
	  var otkCount = proxyDetails.deployedApiKeyCount || 0;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    isApiKeysLoading && _react2.default.createElement(_components.Loading, { sectionLoader: true }),
	    isOverviewWithStatus && _react2.default.createElement(_Paper.OverviewPaperWithStatus, {
	      id: 'keys',
	      title: intl.getI18nMessage('label.application.api.keys'),
	      deploymentType: (0, _deployment.getDeploymentTypeLabel)(application),
	      deploymentTypeTooltip: _react2.default.createElement(ApiKeysTooltip, null),
	      proxyStatus: proxyStatus,
	      publishedCount: publishedCount,
	      pendingCount: pendingCount,
	      pendingUndeployCount: pendingUndeployCount,
	      deployedCount: deployedCount,
	      bulkDeploymentStatus: bulkDeploymentStatus,
	      refreshTime: deploymentRefreshTime,
	      checkStatus: function checkStatus() {
	        props.fetchProxyDetails(proxyUuid);
	        fetchApiKeys();
	      },
	      errorUndeployCount: errorUndeployCount,
	      errorCount: errorCount,
	      otkCount: otkCount,
	      lastUpdated: useNewAutoSync ? (0, _lodash.get)(apiKeys, 'keys.results[0].lastTimeDeployed', null) : appSyncTime,
	      linkUrl: '' + _constants.PROXY_DETAILS_URL + proxyUuid + '/keys',
	      queryParams: _constants.PROXY_KEYS_QUERY_PARAMS,
	      push: push
	    }),
	    isOverviewWithoutStatus && _react2.default.createElement(_Paper.OverviewPaper, {
	      id: 'keys',
	      title: intl.getI18nMessage('label.application.api.keys'),
	      proxyStatus: proxyStatus,
	      content: publishedCount,
	      deploymentType: (0, _deployment.getDeploymentTypeLabel)(application)
	    })
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bulkDeploymentStatus: (0, _proxy.getProxyDetailsBulkApiKeyDeploymentStatus)(state),
	    publishedCount: (0, _proxy.getApiKeysCount)(state),
	    apiKeys: (0, _proxy.getApiKeys)(state),
	    isApiKeysLoading: (0, _proxy.getIsProxyApisLoading)(state)
	  };
	};
	
	ApiKeys.propTypes = {
	  proxyUuid: _propTypes.string,
	  proxyDetails: (0, _propTypes.shape)({}),
	  bulkDeploymentStatus: _propTypes.string,
	  proxyStatus: _propTypes.string,
	  parsedGatewayDetails: (0, _propTypes.shape)({}),
	  publishedCount: _propTypes.number,
	  apiKeys: (0, _propTypes.shape)({}),
	  deploymentRefreshTime: _propTypes.string,
	  isApiKeysLoading: _propTypes.bool,
	  push: _propTypes.func,
	  fetchApiKeysCount: _propTypes.func,
	  fetchApiKeys: _propTypes.func,
	  fetchProxyDetails: _propTypes.func
	};
	ApiKeys.displayName = 'ApiKeys';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps))(ApiKeys);

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Apis = exports.getLastUpdated = exports.ApisTooltip = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(27);
	
	var _lodash = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(103);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _deployment = __webpack_require__(205);
	
	var _proxy = __webpack_require__(104);
	
	var _components = __webpack_require__(17);
	
	var _Paper = __webpack_require__(200);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApisTooltip = exports.ApisTooltip = function ApisTooltip(_ref) {
	  var api = _ref.api;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  switch (api) {
	    case _constants.PROXY_DEPLOYMENT_TYPE_AUTOMATIC:
	      return _react2.default.createElement(
	        'div',
	        null,
	        intl.getI18nMessage('label.proxy.details.api.deployment.automatic.tooltip')
	      );
	    case _constants.PROXY_DEPLOYMENT_TYPE_ON_DEMAND:
	      return _react2.default.createElement(
	        'div',
	        null,
	        intl.getI18nMessage('label.proxy.details.api.deployment.on.demand.tooltip')
	      );
	    default:
	      return null;
	  }
	};
	
	var getLastUpdated = exports.getLastUpdated = function getLastUpdated(_ref2) {
	  var api = _ref2.api,
	      useNewAutoSync = _ref2.useNewAutoSync,
	      proxyApis = _ref2.proxyApis,
	      apiSyncTime = _ref2.apiSyncTime;
	
	  switch (api) {
	    case _constants.PROXY_DEPLOYMENT_TYPE_AUTOMATIC:
	      return useNewAutoSync ? (0, _lodash.get)(proxyApis, 'apis.results[0].lastTimeDeployedDate', null) : apiSyncTime;
	    case _constants.PROXY_DEPLOYMENT_TYPE_ON_DEMAND:
	      return (0, _lodash.get)(proxyApis, 'apis.results[0].lastTimeDeployedDate', null);
	    case _constants.PROXY_DEPLOYMENT_TYPE_SCRIPTED:
	      return (0, _lodash.get)(proxyApis, 'apis.results[0].lastTimeDeployedDate', null);
	    default:
	      return 0;
	  }
	};
	
	var Apis = exports.Apis = function Apis(props) {
	  var proxyUuid = props.proxyUuid,
	      _props$proxyDetails = props.proxyDetails,
	      proxyDetails = _props$proxyDetails === undefined ? {} : _props$proxyDetails,
	      bulkDeploymentStatus = props.bulkDeploymentStatus,
	      proxyStatus = props.proxyStatus,
	      parsedGatewayDetails = props.parsedGatewayDetails,
	      _props$proxyApis = props.proxyApis,
	      proxyApis = _props$proxyApis === undefined ? {} : _props$proxyApis,
	      apis = props.apis,
	      push = props.push,
	      deploymentRefreshTime = props.deploymentRefreshTime,
	      isProxyApisLoading = props.isProxyApisLoading;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _proxyDetails$config = proxyDetails.config,
	      config = _proxyDetails$config === undefined ? {} : _proxyDetails$config,
	      _proxyDetails$deploym = proxyDetails.deploymentTypes,
	      deploymentTypes = _proxyDetails$deploym === undefined ? {} : _proxyDetails$deploym;
	  var useNewAutoSync = config.useNewAutoSync;
	  var api = deploymentTypes.api;
	  var apiSyncTime = parsedGatewayDetails.apiSyncTime;
	
	
	  var fetchApis = function fetchApis() {
	    props.fetchApis();
	    props.fetchProxyApis(proxyUuid);
	  };
	
	  (0, _react.useEffect)(function () {
	    fetchApis();
	  }, []);
	
	  var counts = {
	    publishedCount: (0, _lodash.get)(apis, 'apis.totalElements'),
	    pendingCount: (0, _lodash.get)(proxyApis, 'apisPendingDeployment.totalElements') + (0, _lodash.get)(proxyApis, 'apisPendingUndeployment.totalElements'),
	    deployedCount: (0, _lodash.get)(proxyApis, 'apisDeployed.totalElements'),
	    errorCount: (0, _lodash.get)(proxyApis, 'apisError.totalElements') + (0, _lodash.get)(proxyApis, 'apisErrorUndeploy.totalElements'),
	    portalPublishedCount: (0, _lodash.get)(apis, 'apisPublishedByPortal.totalElements'),
	    portalPendingCount: (0, _lodash.get)(proxyApis, 'apisPublishedByPortalPendingDeployment.totalElements') + (0, _lodash.get)(proxyApis, 'apisPublishedByPortalPendingUndeployment.totalElements'),
	    portalDeployedCount: (0, _lodash.get)(proxyApis, 'apisPublishedByPortalDeployed.totalElements'),
	    portalErrorCount: (0, _lodash.get)(proxyApis, 'apisPublishedByPortalError.totalElements') + (0, _lodash.get)(proxyApis, 'apisPublishedByPortalErrorUndeploy.totalElements'),
	    gatewayPublishedCount: (0, _lodash.get)(apis, 'apisPublishedByGateway.totalElements'),
	    gatewayPendingCount: api === _constants.PROXY_DEPLOYMENT_TYPE_ON_DEMAND ? intl.getI18nMessage('label.not.applicable') : (0, _lodash.get)(proxyApis, 'apisPublishedByGatewayPendingDeployment.totalElements') + (0, _lodash.get)(proxyApis, 'apisPublishedByGatewayPendingUndeployment.totalElements'),
	    gatewayDeployedCount: api === _constants.PROXY_DEPLOYMENT_TYPE_ON_DEMAND ? intl.getI18nMessage('label.not.applicable') : (0, _lodash.get)(proxyApis, 'apisPublishedByGatewayDeployed.totalElements'),
	    gatewayErrorCount: api === _constants.PROXY_DEPLOYMENT_TYPE_ON_DEMAND ? intl.getI18nMessage('label.not.applicable') : (0, _lodash.get)(proxyApis, 'apisPublishedByGatewayError.totalElements') + (0, _lodash.get)(proxyApis, 'apisPublishedByGatewayErrorUndeploy.totalElements')
	  };
	
	  var isOverviewWithStatus = [_constants.PROXY_DEPLOYMENT_TYPE_AUTOMATIC, _constants.PROXY_DEPLOYMENT_TYPE_ON_DEMAND].includes(api);
	  var isOverviewWithoutStatus = _constants.PROXY_DEPLOYMENT_TYPE_SCRIPTED === api;
	  var lastUpdated = getLastUpdated({
	    api: api, useNewAutoSync: useNewAutoSync, proxyApis: proxyApis, apiSyncTime: apiSyncTime
	  });
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    isProxyApisLoading && _react2.default.createElement(_components.Loading, { sectionLoader: true }),
	    isOverviewWithStatus && _react2.default.createElement(_Paper.OverviewPaperWithStatus, Object.assign({}, counts, {
	      id: 'apis',
	      title: intl.getI18nMessage('label.apis'),
	      deploymentType: (0, _deployment.getDeploymentTypeLabel)(api),
	      deploymentTypeTooltip: _react2.default.createElement(ApisTooltip, { api: api }),
	      proxyStatus: proxyStatus,
	      bulkDeploymentStatus: bulkDeploymentStatus,
	      refreshTime: deploymentRefreshTime,
	      checkStatus: function checkStatus() {
	        props.fetchProxyDetails(proxyUuid);
	        fetchApis();
	      },
	      lastUpdated: lastUpdated,
	      linkUrl: '' + _constants.PROXY_DETAILS_URL + proxyUuid + '/apis',
	      queryParams: _constants.PROXY_API_QUERY_PARAMS,
	      push: push,
	      showBreakdown: true
	    })),
	    isOverviewWithoutStatus && _react2.default.createElement(_Paper.OverviewPaper, {
	      id: 'apis',
	      title: intl.getI18nMessage('label.apis'),
	      proxyStatus: proxyStatus,
	      content: (0, _lodash.get)(apis, 'apis.totalElements'),
	      deploymentType: (0, _deployment.getDeploymentTypeLabel)(api),
	      lastUpdated: lastUpdated
	    })
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bulkDeploymentStatus: (0, _proxy.getProxyDetailsBulkDeploymentStatus)(state),
	    apis: (0, _proxy.getApis)(state),
	    proxyApis: (0, _proxy.getProxyApis)(state),
	    isProxyApisLoading: (0, _proxy.getIsProxyApisLoading)(state)
	  };
	};
	
	Apis.propTypes = {
	  proxyUuid: _propTypes.string,
	  proxyDetails: (0, _propTypes.shape)({}),
	  bulkDeploymentStatus: _propTypes.string,
	  proxyStatus: _propTypes.string,
	  parsedGatewayDetails: (0, _propTypes.shape)({}),
	  proxyApis: (0, _propTypes.shape)({}),
	  apis: (0, _propTypes.shape)({}),
	  deploymentRefreshTime: _propTypes.string,
	  isProxyApisLoading: _propTypes.bool,
	  push: _propTypes.func,
	  fetchApis: _propTypes.func,
	  fetchProxyApis: _propTypes.func,
	  fetchProxyDetails: _propTypes.func
	};
	Apis.displayName = 'Apis';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps))(Apis);

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Overview = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(27);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(103);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _proxy = __webpack_require__(104);
	
	var _portalConfig = __webpack_require__(26);
	
	var _components = __webpack_require__(17);
	
	var _proxyUrl = __webpack_require__(1691);
	
	var _proxyUrl2 = _interopRequireDefault(_proxyUrl);
	
	var _portalCompatibility = __webpack_require__(1690);
	
	var _portalCompatibility2 = _interopRequireDefault(_portalCompatibility);
	
	var _apis = __webpack_require__(1686);
	
	var _apis2 = _interopRequireDefault(_apis);
	
	var _apiKeys = __webpack_require__(1685);
	
	var _apiKeys2 = _interopRequireDefault(_apiKeys);
	
	var _plans = __webpack_require__(1689);
	
	var _plans2 = _interopRequireDefault(_plans);
	
	var _organizations = __webpack_require__(1688);
	
	var _organizations2 = _interopRequireDefault(_organizations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Overview = exports.Overview = function Overview(props) {
	  var classes = props.classes,
	      featureFlagApiPlans = props.featureFlagApiPlans,
	      proxyUuid = props.proxyUuid,
	      proxyStatus = props.proxyStatus,
	      parsedGatewayDetails = props.parsedGatewayDetails,
	      isCompatible = props.isCompatible,
	      _props$proxyOrganizat = props.proxyOrganizations,
	      proxyOrganizations = _props$proxyOrganizat === undefined ? {} : _props$proxyOrganizat,
	      accountPlans = props.accountPlans,
	      apiPlans = props.apiPlans,
	      push = props.push,
	      notifyMessages = props.notifyMessages;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var accountPlanSyncLog = parsedGatewayDetails.accountPlanSyncLog,
	      accountPlanSyncTime = parsedGatewayDetails.accountPlanSyncTime,
	      apiPlanSyncLog = parsedGatewayDetails.apiPlanSyncLog,
	      apiPlanSyncTime = parsedGatewayDetails.apiPlanSyncTime,
	      logs = parsedGatewayDetails.logs;
	
	  var proxyUrl = (0, _get2.default)(logs, 'cluster_name');
	
	  (0, _react.useEffect)(function () {
	    props.fetchAccountPlans();
	    if (featureFlagApiPlans) {
	      props.fetchApiPlans();
	    }
	    props.fetchProxyOrganizations(proxyUuid);
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: 'proxy-details-overview-container',
	      'data-apim-test': 'proxy-details-overview-container',
	      'data-layer7-test': 'proxy-details-overview-container'
	    },
	    _react2.default.createElement(
	      _core.Grid,
	      {
	        container: true,
	        id: 'metadata-top-panel-container',
	        'data-apim-test': 'metadata-top-panel-container',
	        'data-layer7-test': 'metadata-top-panel-container',
	        className: classes.topPanelContainer
	      },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 3, sm: 12, xs: 12 },
	        _react2.default.createElement(_proxyUrl2.default, {
	          proxyUrl: proxyUrl,
	          notifyMessages: notifyMessages
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 3, sm: 6, xs: 12 },
	        _react2.default.createElement(_components.DetailsPanelContainer, {
	          id: 'overview-otk-version',
	          title: intl.getI18nMessage('label.proxy.details.page.overview.otk.version'),
	          subTitle: (0, _get2.default)(logs, 'otk_version')
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 3, sm: 6, xs: 12 },
	        _react2.default.createElement(_components.DetailsPanelContainer, {
	          id: 'overview-gateway-version',
	          title: intl.getI18nMessage('label.proxy.details.page.overview.gateway.version'),
	          subTitle: (0, _get2.default)(logs, 'version')
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 3, sm: 12, xs: 12 },
	        _react2.default.createElement(_portalCompatibility2.default, {
	          isCompatible: isCompatible
	        })
	      )
	    ),
	    _react2.default.createElement(_core.Divider, { className: classes.divider }),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, className: classes.marginPanelContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 6, sm: 12, xs: 12, className: classes.paper },
	        _react2.default.createElement(_apis2.default, props)
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 6, sm: 12, xs: 12, className: classes.paper },
	        _react2.default.createElement(_apiKeys2.default, props)
	      )
	    ),
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true, className: classes.marginPanelContainer },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 4, sm: 4, xs: 12, className: classes.paper },
	        _react2.default.createElement(_plans2.default, {
	          id: 'account-plans',
	          title: intl.getI18nMessage('label.account.plans'),
	          proxyStatus: proxyStatus,
	          portalPlanCounts: (0, _get2.default)(accountPlans, 'd.results', []).length,
	          gatewayPlanCounts: (0, _get2.default)(accountPlanSyncLog, 'count', 0),
	          lastUpdated: accountPlanSyncTime
	        })
	      ),
	      featureFlagApiPlans && _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 4, sm: 4, xs: 12, className: classes.paper },
	        _react2.default.createElement(_plans2.default, {
	          id: 'api-plans',
	          title: intl.getI18nMessage('label.api.plans'),
	          proxyStatus: proxyStatus,
	          portalPlanCounts: (0, _get2.default)(apiPlans, 'totalElements', 0),
	          gatewayPlanCounts: (0, _get2.default)(apiPlanSyncLog, 'count', 0),
	          lastUpdated: apiPlanSyncTime
	        })
	      ),
	      proxyOrganizations.totalElements && _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 4, sm: 4, xs: 12, className: classes.paper },
	        _react2.default.createElement(_organizations2.default, {
	          proxyStatus: proxyStatus,
	          proxyOrganizations: proxyOrganizations,
	          push: push
	        })
	      )
	    ),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    featureFlagApiPlans: (0, _portalConfig.getFeatureFlagApiPlans)(state),
	    proxyOrganizations: (0, _proxy.getProxyOrganizations)(state),
	    accountPlans: (0, _proxy.getAccountPlans)(state),
	    apiPlans: (0, _proxy.getApiPlans)(state)
	  };
	};
	
	Overview.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  featureFlagApiPlans: _propTypes.bool,
	  proxyUuid: _propTypes.string,
	  proxyDetails: (0, _propTypes.shape)({}),
	  proxyStatus: _propTypes.string,
	  parsedGatewayDetails: (0, _propTypes.shape)({}),
	  isCompatible: _propTypes.bool,
	  proxyOrganizations: (0, _propTypes.shape)({}),
	  accountPlans: (0, _propTypes.shape)({}),
	  apiPlans: (0, _propTypes.shape)({}),
	  push: _propTypes.func,
	  notifyMessages: _propTypes.func,
	  fetchAccountPlans: _propTypes.func,
	  fetchApiPlans: _propTypes.func,
	  fetchProxyOrganizations: _propTypes.func
	};
	Overview.displayName = 'Overview';
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps))(Overview);

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Organizations = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(103);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _Paper = __webpack_require__(200);
	
	var _components = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Organizations = exports.Organizations = function Organizations(props) {
	  var _props$classes = props.classes,
	      classes = _props$classes === undefined ? {} : _props$classes,
	      _props$proxyOrganizat = props.proxyOrganizations,
	      proxyOrganizations = _props$proxyOrganizat === undefined ? {} : _props$proxyOrganizat,
	      push = props.push;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedOrganization = _useState2[0],
	      setSelectedOrganization = _useState2[1];
	
	  return _react2.default.createElement(_Paper.OverviewPaper, {
	    id: 'organizations',
	    title: intl.getI18nMessage('label.organizations'),
	    content: proxyOrganizations.totalElements,
	    contentMore: _react2.default.createElement(
	      _core.Grid,
	      { container: true },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 9 },
	        _react2.default.createElement(_components.FormAutoCompleteCombo, {
	          fieldContainerClass: classes.selectOrganization,
	          id: 'select-organization',
	          inputLabel: intl.getI18nMessage('label.proxy.details.page.select.organization'),
	          name: intl.getI18nMessage('label.go.to'),
	          data: proxyOrganizations.results,
	          onChange: function onChange(e, value) {
	            return setSelectedOrganization(value);
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 3 },
	        _react2.default.createElement(
	          _core.Button,
	          {
	            className: classes.selectOrganizationGo,
	            color: 'primary',
	            variant: 'outlined',
	            id: 'select-organization-go', 'data-layer7-test': 'select-organization-go',
	            onClick: function onClick() {
	              return push('/admin/console/organizations/edit/' + selectedOrganization.uuid);
	            },
	            disabled: !selectedOrganization
	          },
	          intl.getI18nFormattedMessage('label.go')
	        )
	      )
	    )
	  });
	};
	
	Organizations.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  proxyOrganizations: (0, _propTypes.shape)({}),
	  push: _propTypes.func
	};
	Organizations.displayName = 'Organizations';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(Organizations);

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Plans = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _toNumber = __webpack_require__(275);
	
	var _toNumber2 = _interopRequireDefault(_toNumber);
	
	var _core = __webpack_require__(3);
	
	var _icons = __webpack_require__(146);
	
	var _propTypes = __webpack_require__(5);
	
	var _styles = __webpack_require__(103);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _Paper = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Plans = exports.Plans = function Plans(props) {
	  var classes = props.classes,
	      id = props.id,
	      title = props.title,
	      proxyStatus = props.proxyStatus,
	      portalPlanCounts = props.portalPlanCounts,
	      gatewayPlanCounts = props.gatewayPlanCounts,
	      lastUpdated = props.lastUpdated;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var arePlanCountsEqual = (0, _toNumber2.default)(portalPlanCounts) === (0, _toNumber2.default)(gatewayPlanCounts);
	
	  return arePlanCountsEqual ? _react2.default.createElement(_Paper.OverviewPaper, {
	    id: id,
	    title: title,
	    proxyStatus: proxyStatus,
	    content: portalPlanCounts,
	    lastUpdated: lastUpdated
	  }) : _react2.default.createElement(_Paper.OverviewPaper, {
	    id: id,
	    title: title,
	    proxyStatus: proxyStatus,
	    contentMore: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _core.TableContainer,
	        null,
	        _react2.default.createElement(
	          _core.Table,
	          { size: 'small' },
	          _react2.default.createElement(_Paper.OverviewPaperWithStatusTableHead, {
	            rowName: intl.getI18nMessage('label.proxy.details.page.source'),
	            cells: [{
	              key: 'published',
	              value: intl.getI18nMessage('label.proxy.details.page.status.published')
	            }]
	          }),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            _react2.default.createElement(_Paper.OverviewPaperWithStatusTableRow, {
	              rowName: intl.getI18nMessage('label.proxy.details.api.portal'),
	              cells: [{ key: 'portal.plan.counts.' + id, value: portalPlanCounts }]
	            }),
	            _react2.default.createElement(_Paper.OverviewPaperWithStatusTableRow, {
	              rowName: intl.getI18nMessage('label.proxy.details.api.gateway'),
	              cells: [{ key: 'gateway.plan.counts.' + id, value: gatewayPlanCounts }]
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { container: true, style: { marginTop: 25, marginBottom: 25 } },
	        _react2.default.createElement(
	          _core.Grid,
	          { item: true },
	          _react2.default.createElement(
	            _core.IconButton,
	            { className: (0, _classnames2.default)(classes.icon, classes.countMismatch) },
	            _react2.default.createElement(_icons.IntentDangerIcon, null)
	          )
	        ),
	        _react2.default.createElement(
	          _core.Grid,
	          { item: true },
	          _react2.default.createElement(
	            _core.Typography,
	            { variant: 'body1' },
	            intl.getI18nMessage('label.proxy.details.portal.gateway.counts.different')
	          )
	        )
	      )
	    ),
	    lastUpdated: lastUpdated
	  });
	};
	
	Plans.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  id: _propTypes.string,
	  title: _propTypes.string,
	  proxyStatus: _propTypes.string,
	  portalPlanCounts: _propTypes.number,
	  gatewayPlanCounts: _propTypes.number,
	  lastUpdated: _propTypes.string
	};
	Plans.displayName = 'Plans';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(Plans);

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalCompatibility = exports.getPortalCompatibilityTooltip = exports.getPortalCompatibility = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _classnames = __webpack_require__(64);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(5);
	
	var _isUndefined = __webpack_require__(445);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _core = __webpack_require__(3);
	
	var _CheckCircle = __webpack_require__(945);
	
	var _CheckCircle2 = _interopRequireDefault(_CheckCircle);
	
	var _icons = __webpack_require__(146);
	
	var _styles = __webpack_require__(103);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _components = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPortalCompatibility = exports.getPortalCompatibility = function getPortalCompatibility(_ref) {
	  var _ref$classes = _ref.classes,
	      classes = _ref$classes === undefined ? {} : _ref$classes,
	      isCompatible = _ref.isCompatible;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  if ((0, _isUndefined2.default)(isCompatible)) {
	    return null;
	  }
	  return isCompatible ? _react2.default.createElement(
	    _core.Grid,
	    { container: true, component: 'span', className: classes.portalCompatibility },
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, component: 'span' },
	      _react2.default.createElement(
	        _core.IconButton,
	        { 'data-compatible': true, className: (0, _classnames2.default)(classes.icon, classes.compatible) },
	        _react2.default.createElement(_CheckCircle2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, component: 'span' },
	      intl.getI18nMessage('label.proxy.details.page.overview.portal.compatible')
	    )
	  ) : _react2.default.createElement(
	    _core.Grid,
	    { container: true, component: 'span', className: classes.portalCompatibility },
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, component: 'span' },
	      _react2.default.createElement(
	        _core.IconButton,
	        { 'data-incompatible': true, className: (0, _classnames2.default)(classes.icon, classes.incompatible) },
	        _react2.default.createElement(_icons.IntentDangerIcon, null)
	      )
	    ),
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, component: 'span' },
	      intl.getI18nMessage('label.proxy.details.page.overview.portal.incompatible')
	    )
	  );
	};
	
	var getPortalCompatibilityTooltip = exports.getPortalCompatibilityTooltip = function getPortalCompatibilityTooltip(isCompatible) {
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      null,
	      isCompatible ? intl.getI18nMessage('label.proxy.details.page.overview.portal.compatibility.tooltip') : intl.getI18nMessage('label.proxy.details.page.overview.portal.incompatibility.tooltip')
	    )
	  );
	};
	
	var PortalCompatibility = exports.PortalCompatibility = function PortalCompatibility(_ref2) {
	  var _ref2$classes = _ref2.classes,
	      classes = _ref2$classes === undefined ? {} : _ref2$classes,
	      isCompatible = _ref2.isCompatible;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var portalCompatibility = getPortalCompatibility({ classes: classes, isCompatible: isCompatible });
	  var PortalCompatibilityTooltip = getPortalCompatibilityTooltip(isCompatible);
	  return _react2.default.createElement(_components.DetailsPanelContainer, {
	    id: 'overview-portal-compatibility',
	    title: intl.getI18nMessage('label.proxy.details.page.overview.portal.compatibility'),
	    subTitle: portalCompatibility,
	    tooltip: PortalCompatibilityTooltip,
	    smallFont: true
	  });
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(PortalCompatibility);
	
	
	PortalCompatibility.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  isCompatible: _propTypes.bool
	};
	PortalCompatibility.displayName = 'PortalCompatibility';

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProxyUrl = exports.ProxyUrlContent = exports.copy = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _copyToClipboard = __webpack_require__(117);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _propTypes = __webpack_require__(5);
	
	var _core = __webpack_require__(3);
	
	var _styles = __webpack_require__(103);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _intl = __webpack_require__(15);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var copy = exports.copy = function copy(_ref) {
	  var intl = _ref.intl,
	      proxyUrl = _ref.proxyUrl,
	      notifyMessages = _ref.notifyMessages;
	
	  notifyMessages(_constants.ALERT_SUCCESS, intl.getI18nMessage('label.proxy.details.proxy.url.copied'));
	  (0, _copyToClipboard2.default)(proxyUrl);
	  setTimeout(function () {
	    return notifyMessages('', '');
	  }, 3000);
	};
	
	var ProxyUrlContent = exports.ProxyUrlContent = function ProxyUrlContent(_ref2) {
	  var _ref2$classes = _ref2.classes,
	      classes = _ref2$classes === undefined ? {} : _ref2$classes,
	      proxyUrl = _ref2.proxyUrl,
	      notifyMessages = _ref2.notifyMessages;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  return _react2.default.createElement(
	    _core.IconButton,
	    {
	      className: classes.copyProxyUrl,
	      onClick: function onClick() {
	        return copy({ intl: intl, proxyUrl: proxyUrl, notifyMessages: notifyMessages });
	      }
	    },
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'body1' },
	      intl.getI18nMessage('label.copy.button')
	    )
	  );
	};
	
	ProxyUrlContent.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  notifyMessages: _propTypes.func,
	  proxyUrl: _propTypes.string
	};
	ProxyUrlContent.displayName = 'ProxyUrlContent';
	
	var ProxyUrl = exports.ProxyUrl = function ProxyUrl(_ref3) {
	  var _ref3$classes = _ref3.classes,
	      classes = _ref3$classes === undefined ? {} : _ref3$classes,
	      proxyUrl = _ref3.proxyUrl,
	      notifyMessages = _ref3.notifyMessages;
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  return _react2.default.createElement(_components.DetailsPanelContainer, {
	    id: 'overview-proxy-url',
	    title: intl.getI18nMessage('label.proxy.details.page.overview.proxy.url'),
	    subTitle: proxyUrl,
	    smallFont: true,
	    content: _react2.default.createElement(ProxyUrlContent, {
	      classes: classes,
	      proxyUrl: proxyUrl,
	      notifyMessages: notifyMessages
	    })
	  });
	};
	
	exports.default = (0, _core.withStyles)(_styles2.default)(ProxyUrl);
	
	
	ProxyUrl.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  proxyUrl: _propTypes.string,
	  notifyMessages: _propTypes.func
	};
	ProxyUrl.displayName = 'ProxyUrl';

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PendingEnrollment = exports.GatewayDetailsLoaded = exports.GatewayDetailsLoading = exports.copy = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _core = __webpack_require__(3);
	
	var _Autorenew = __webpack_require__(943);
	
	var _Autorenew2 = _interopRequireDefault(_Autorenew);
	
	var _copyToClipboard = __webpack_require__(117);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _propTypes = __webpack_require__(5);
	
	var _intl = __webpack_require__(15);
	
	var _styles = __webpack_require__(1693);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var copy = exports.copy = function copy(_ref) {
	  var intl = _ref.intl,
	      enrollmentUrl = _ref.enrollmentUrl,
	      notifyMessages = _ref.notifyMessages;
	
	  notifyMessages(_constants.ALERT_SUCCESS, intl.getI18nMessage('label.proxy.details.pending.enrollment.enrollment.url.copied'));
	  (0, _copyToClipboard2.default)(enrollmentUrl);
	  setTimeout(function () {
	    notifyMessages('', '');
	  }, 3000);
	};
	
	var GatewayDetailsLoading = exports.GatewayDetailsLoading = function GatewayDetailsLoading(_ref2) {
	  var classes = _ref2.classes;
	  return _react2.default.createElement(
	    _core.IconButton,
	    {
	      className: classes.checkingStatus,
	      id: 'checking-status', 'data-layer7-test': 'checking-status'
	    },
	    _react2.default.createElement(_Autorenew2.default, null),
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'body1', className: classes.checkingStatus },
	      (0, _intl.getI18nFormattedMessage)('label.proxy.details.pending.enrollment.checking')
	    )
	  );
	};
	
	GatewayDetailsLoading.propTypes = {
	  classes: (0, _propTypes.shape)({})
	};
	GatewayDetailsLoading.displayName = 'GatewayDetailsLoading';
	
	var GatewayDetailsLoaded = exports.GatewayDetailsLoaded = function GatewayDetailsLoaded(_ref3) {
	  var _ref3$classes = _ref3.classes,
	      classes = _ref3$classes === undefined ? {} : _ref3$classes,
	      fetchProxyGateway = _ref3.fetchProxyGateway,
	      proxyUuid = _ref3.proxyUuid;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.checkStatus,
	      id: 'check-status', 'data-layer7-test': 'check-status'
	    },
	    _react2.default.createElement(_components.StatusIndicator, { inline: true, status: _constants.PROXY_ENROLMENT_STATUS_PENDING }),
	    _react2.default.createElement(
	      _core.IconButton,
	      { onClick: function onClick() {
	          return fetchProxyGateway(proxyUuid);
	        } },
	      _react2.default.createElement(
	        _core.Typography,
	        { variant: 'body1' },
	        (0, _intl.getI18nFormattedMessage)('label.proxy.details.pending.enrollment.check.status')
	      )
	    )
	  );
	};
	
	GatewayDetailsLoaded.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  fetchProxyGateway: _propTypes.func,
	  proxyUuid: _propTypes.string
	};
	GatewayDetailsLoaded.displayName = 'GatewayDetailsLoaded';
	
	var PendingEnrollment = exports.PendingEnrollment = function PendingEnrollment(props) {
	  var classes = props.classes,
	      gatewayDetailsLoading = props.gatewayDetailsLoading,
	      _props$proxy = props.proxy,
	      proxy = _props$proxy === undefined ? {} : _props$proxy,
	      notifyMessages = props.notifyMessages;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _proxy$enrollmentUrl = proxy.enrollmentUrl,
	      enrollmentUrl = _proxy$enrollmentUrl === undefined ? '' : _proxy$enrollmentUrl;
	
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classes.pendingEnrollmentContainer,
	      id: 'proxy-details-overview-pending-enrollment-container',
	      'data-apim-test': 'proxy-details-pending-enrollment-container',
	      'data-layer7-test': 'proxy-details-pending-enrollment-container'
	    },
	    _react2.default.createElement(
	      _core.Grid,
	      { container: true },
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 9, sm: 12, xs: 12 },
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'h2' },
	          intl.getI18nMessage('label.proxy.details.pending.enrollment.title')
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'h4' },
	          intl.getI18nMessage('label.proxy.details.pending.enrollment.copy.url.title')
	        ),
	        _react2.default.createElement(
	          _core.FormLabel,
	          { className: classes.formLabel },
	          intl.getI18nMessage('label.proxy.details.pending.enrollment.enrollment.url')
	        ),
	        _react2.default.createElement(_core.TextField, {
	          variant: 'outlined',
	          size: 'small',
	          disabled: true,
	          classes: { root: classes.enrollmentUrl },
	          id: 'enrollmentUrl', 'data-layer7-test': 'enrollmentUrl',
	          value: enrollmentUrl,
	          helperText: intl.getI18nMessage('label.proxy.details.pending.enrollment.expires.text')
	        }),
	        _react2.default.createElement(
	          _core.Button,
	          {
	            color: 'secondary',
	            variant: 'contained',
	            className: classes.copyEnrollmentUrl,
	            onClick: function onClick() {
	              return copy({ intl: intl, enrollmentUrl: enrollmentUrl, notifyMessages: notifyMessages });
	            }
	          },
	          intl.getI18nMessage('label.copy.button')
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'h4' },
	          intl.getI18nMessage('label.proxy.details.pending.enrollment.confirm.enrollment.title')
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'body1' },
	          intl.getI18nMessage('label.proxy.details.pending.enrollment.post.enrollment.note')
	        ),
	        gatewayDetailsLoading ? _react2.default.createElement(GatewayDetailsLoading, props) : _react2.default.createElement(GatewayDetailsLoaded, props)
	      ),
	      _react2.default.createElement(
	        _core.Grid,
	        { item: true, md: 3, sm: 12, xs: 12 },
	        _react2.default.createElement(_components.HelpContainer, { id: 'proxy-details-pending-enrollment-help', helpItems: _constants.PROXY_ENROLLMENT_HELP_ITEMS })
	      )
	    )
	  );
	};
	
	PendingEnrollment.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  gatewayDetailsLoading: _propTypes.bool,
	  proxy: (0, _propTypes.shape)({}),
	  notifyMessages: _propTypes.func
	};
	PendingEnrollment.displayName = 'PendingEnrollment';
	
	exports.default = (0, _core.withStyles)(_styles2.default)(PendingEnrollment);

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    pendingEnrollmentContainer: {
	      padding: '0 ' + (0, _get2.default)(theme, 'padding.p36')
	    },
	    formLabel: {
	      width: '100%'
	    },
	    enrollmentUrl: {
	      '& > div': {
	        borderRadius: (0, _get2.default)(theme, 'borderRadius.br4') + ' 0 0 ' + (0, _get2.default)(theme, 'borderRadius.br4')
	      },
	      '& input': {
	        height: (0, _get2.default)(theme, 'height.h40'),
	        padding: '0 ' + (0, _get2.default)(theme, 'padding.p10'),
	        width: '500px'
	      },
	      '& p': {
	        color: (0, _get2.default)(theme, 'color.bodyText') + ' !important',
	        margin: (0, _get2.default)(theme, 'margin.m2') + ' 0'
	      }
	    },
	    copyEnrollmentUrl: {
	      borderRadius: '0 ' + (0, _get2.default)(theme, 'borderRadius.br3') + ' ' + (0, _get2.default)(theme, 'borderRadius.br3') + ' 0'
	    },
	    checkStatus: {
	      padding: (0, _get2.default)(theme, 'padding.p16') + ' 0',
	      '& > div': {
	        marginTop: 0
	      },
	      '& > button': {
	        padding: 0
	      },
	      '& button > span > p': {
	        color: (0, _get2.default)(theme, 'color.link')
	      }
	    },
	    checkingStatus: {
	      color: (0, _get2.default)(theme, 'color.disabledText'),
	      paddingLeft: 0
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProxyDetails = exports.getIsCompatible = exports.getProxyStatus = exports.getProxyUuid = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _components = __webpack_require__(17);
	
	var _utils = __webpack_require__(18);
	
	var _intl = __webpack_require__(15);
	
	var _datetime = __webpack_require__(68);
	
	var _proxy = __webpack_require__(282);
	
	var _proxy2 = __webpack_require__(104);
	
	var _portalConfig = __webpack_require__(85);
	
	var _portalConfig2 = __webpack_require__(26);
	
	var _details = __webpack_require__(622);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _Overview = __webpack_require__(1687);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	var _Apis = __webpack_require__(1677);
	
	var _Apis2 = _interopRequireDefault(_Apis);
	
	var _Keys = __webpack_require__(1680);
	
	var _Keys2 = _interopRequireDefault(_Keys);
	
	var _Actions = __webpack_require__(1674);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _PendingEnrollment = __webpack_require__(1692);
	
	var _PendingEnrollment2 = _interopRequireDefault(_PendingEnrollment);
	
	var _constants = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getProxyUuid = exports.getProxyUuid = function getProxyUuid(props) {
	  return (0, _lodash.get)(props, 'match.path') && (0, _lodash.get)(props, 'match.path').includes('/details/') && (0, _lodash.get)(props, 'match.params.apiProxyUuid');
	};
	
	var getProxyStatus = exports.getProxyStatus = function getProxyStatus(proxyDetails) {
	  var mqConnected = (0, _lodash.get)(proxyDetails, 'messageQueueDetails.connected');
	  if ((0, _lodash.isUndefined)(mqConnected)) {
	    return null;
	  }
	  return mqConnected ? _constants.PROXY_CONNECTED : _constants.PROXY_DISCONNECTED;
	};
	
	var getTabItems = function getTabItems() {
	  return [{
	    id: 'overview',
	    tabId: 'proxy-overview-tab',
	    label: (0, _intl.getI18nFormattedMessage)('label.proxy.details.page.overview.title'),
	    visible: true
	  }, {
	    id: 'apis',
	    tabId: 'proxy-apis-tab',
	    label: (0, _intl.getI18nFormattedMessage)('label.proxy.details.page.apis.deployments.title'),
	    visible: true
	  }, {
	    id: 'keys',
	    tabId: 'proxy-keys-tab',
	    label: (0, _intl.getI18nFormattedMessage)('label.proxy.details.page.application.api.keys.deployments.title'),
	    visible: true
	  }];
	};
	
	var getIsCompatible = exports.getIsCompatible = function getIsCompatible(_ref) {
	  var gatewayDetailsLoading = _ref.gatewayDetailsLoading,
	      logs = _ref.logs;
	
	  if (gatewayDetailsLoading) {
	    return;
	  }
	  var bundleVersion = (0, _lodash.get)(logs, 'bundle_version');
	  return (0, _datetime.isCompatibleBundleVersion)(bundleVersion);
	};
	
	var ProxyDetails = exports.ProxyDetails = function ProxyDetails(props) {
	  var isLoading = props.isLoading,
	      proxyDetails = props.proxyDetails,
	      gatewayDetailsLoading = props.gatewayDetailsLoading,
	      _props$parsedGatewayD = props.parsedGatewayDetails,
	      parsedGatewayDetails = _props$parsedGatewayD === undefined ? {} : _props$parsedGatewayD,
	      hasError = props.hasError,
	      pageErrors = props.pageErrors;
	
	
	  var proxyUuid = (0, _lodash.get)(props, 'match.params.apiProxyUuid');
	  var tabItems = getTabItems();
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      notificationMessage = _useState2[0],
	      setNotificationMessage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      notificationStatus = _useState4[0],
	      setNotificationStatus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      errors = _useState6[0],
	      setErrors = _useState6[1];
	
	  var _useState7 = (0, _react.useState)((0, _utils.getTabIndex)(tabItems, props.match)),
	      _useState8 = _slicedToArray(_useState7, 2),
	      currentTab = _useState8[0],
	      setCurrentTab = _useState8[1];
	
	  var enrollmentStatus = parsedGatewayDetails.enrollmentStatus,
	      logs = parsedGatewayDetails.logs;
	
	  var isCompatible = getIsCompatible({
	    gatewayDetailsLoading: gatewayDetailsLoading,
	    logs: logs
	  });
	  var isPendingEnrollment = enrollmentStatus === _constants.PROXY_ENROLMENT_STATUS_PENDING;
	  var proxyStatus = getProxyStatus(proxyDetails);
	
	  (0, _react.useEffect)(function () {
	    props.fetchProxy(proxyUuid);
	    props.fetchProxyGateway(proxyUuid);
	    props.fetchDeploymentRefreshTime();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    setCurrentTab((0, _utils.getTabIndex)(tabItems, props.match));
	  }, [props.match]);
	
	  var notifyMessages = function notifyMessages(status, message) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  (0, _react.useEffect)(function () {
	    setErrors(hasError ? pageErrors : []);
	  }, [hasError, pageErrors]);
	
	  var handleTabChange = function handleTabChange(e, newValue) {
	    setCurrentTab(newValue);
	  };
	
	  var onSwitchNewSync = function onSwitchNewSync() {
	    props.updateNewProxySync(proxyUuid);
	  };
	
	  return _react2.default.createElement(_details2.default, {
	    detailsPageId: 'proxy-details-page',
	    isLoading: isLoading,
	    notificationId: 'proxy-details-notifications',
	    notificationStatus: notificationStatus,
	    setNotificationStatus: setNotificationMessage,
	    notificationMessage: notificationMessage,
	    setNotificationMessage: setNotificationMessage,
	    infoMessage: intl.getI18nMessage('label.proxy.details.info.switch.newSync'),
	    infoLinkText: intl.getI18nMessage('label.proxy.details.info.switch.linkText'),
	    handleInfoClick: onSwitchNewSync,
	    infoSeverity: 'info',
	    infoId: 'proxy-details-info',
	    errors: errors,
	    header: _react2.default.createElement(_components.DetailsHeader, {
	      headerId: 'proxy-details-header-container',
	      title: intl.getI18nMessage('label.proxy.details.page.title'),
	      name: (0, _lodash.get)(proxyDetails, 'name'),
	      status: isPendingEnrollment ? enrollmentStatus : proxyStatus
	    }),
	    actions: _react2.default.createElement(_Actions2.default, Object.assign({}, props, {
	      proxyUuid: proxyUuid,
	      enrollmentStatus: enrollmentStatus,
	      notifyMessages: notifyMessages
	    })),
	    pending: enrollmentStatus && isPendingEnrollment && _react2.default.createElement(_PendingEnrollment2.default, Object.assign({}, props, {
	      proxyUuid: proxyUuid,
	      notifyMessages: notifyMessages
	    })),
	    tabs: _react2.default.createElement(_components.TabsContainer, {
	      id: 'proxy-details-tab-container',
	      tabValue: currentTab,
	      orientation: 'horizontal',
	      tabItems: tabItems.filter(function (_ref2) {
	        var visible = _ref2.visible;
	        return visible;
	      }),
	      handleTabChange: handleTabChange
	    }),
	    page: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _components.TabPanel,
	        {
	          visible: currentTab === 0,
	          id: 'proxy-overview-tab-panel'
	        },
	        _react2.default.createElement(_Overview2.default, Object.assign({}, props, {
	          isCurrentTab: currentTab === 0,
	          proxyUuid: proxyUuid,
	          proxyStatus: proxyStatus,
	          parsedGatewayDetails: parsedGatewayDetails,
	          isCompatible: isCompatible,
	          notifyMessages: notifyMessages
	        }))
	      ),
	      _react2.default.createElement(
	        _components.TabPanel,
	        {
	          visible: currentTab === 1,
	          id: 'proxy-apis-tab-panel'
	        },
	        _react2.default.createElement(_Apis2.default, Object.assign({}, props, {
	          isCurrentTab: currentTab === 1,
	          gatewayBundleDetails: parsedGatewayDetails,
	          proxyUuid: proxyUuid,
	          notifyMessages: notifyMessages
	        }))
	      ),
	      _react2.default.createElement(
	        _components.TabPanel,
	        {
	          visible: currentTab === 2,
	          id: 'proxy-keys-tab-panel'
	        },
	        _react2.default.createElement(_Keys2.default, Object.assign({}, props, {
	          isCurrentTab: currentTab === 2,
	          gatewayBundleDetails: parsedGatewayDetails,
	          proxyUuid: proxyUuid,
	          notifyMessages: notifyMessages
	        }))
	      ),
	      _react2.default.createElement(
	        _components.TabPanel,
	        {
	          visible: currentTab === 3,
	          id: 'proxy-organizations-tab-panel'
	        },
	        _react2.default.createElement('div', null)
	      )
	    ),
	    footer: _react2.default.createElement(_components.Footer, null)
	  });
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    config: (0, _portalConfig2.getConfig)(state),
	    isLoading: (0, _proxy2.getIsLoading)(state),
	    gatewayDetailsLoading: (0, _proxy2.getProxyGatewayDetailsLoading)(state),
	    proxyDetails: (0, _proxy2.getProxyDetails)(state),
	    proxy: (0, _proxy2.getProxy)(state),
	    gateways: (0, _proxy2.getProxyGateways)(state),
	    parsedGatewayDetails: (0, _proxy2.getParsedProxyGatewayDetails)(state),
	    isProxyDeleteSuccess: (0, _proxy2.getIsProxyDeleteSuccess)(state),
	    hasError: (0, _proxy2.getHasError)(state),
	    pageErrors: (0, _proxy2.getPageErrors)(state),
	    deploymentRefreshTime: (0, _portalConfig2.getDeploymentRefreshTime)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  push: _connectedReactRouter.push,
	  fetchProxy: _proxy.fetchProxy,
	  fetchProxyDetails: _proxy.fetchProxyDetails,
	  fetchProxyGateway: _proxy.fetchProxyGateway,
	  deleteProxy: _proxy.deleteProxy,
	  fetchAccountPlans: _proxy.fetchAccountPlans,
	  fetchApiKeysCount: _proxy.fetchApiKeysCount,
	  fetchApiKeys: _proxy.fetchApiKeys,
	  fetchApis: _proxy.fetchApis,
	  fetchApiPlans: _proxy.fetchApiPlans,
	  fetchProxyApis: _proxy.fetchProxyApis,
	  fetchProxyOrganizations: _proxy.fetchProxyOrganizations,
	  updateNewProxySync: _proxy.updateNewProxySync,
	  fetchDeploymentRefreshTime: _portalConfig.fetchDeploymentRefreshTime
	};
	
	ProxyDetails.propTypes = {
	  config: (0, _propTypes.shape)({}),
	  history: (0, _propTypes.shape)({}),
	  proxyDetails: (0, _propTypes.shape)({}),
	  parsedGatewayDetails: (0, _propTypes.shape)({}),
	  gatewayDetailsLoading: _propTypes.bool,
	  gatewayDetails: (0, _propTypes.shape)({}),
	  gateways: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  isLoading: _propTypes.bool,
	  hasError: _propTypes.bool,
	  pageErrors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  match: (0, _propTypes.shape)({}),
	  fetchProxy: _propTypes.func,
	  fetchProxyGateway: _propTypes.func,
	  fetchDeploymentRefreshTime: _propTypes.func,
	  updateNewProxySync: _propTypes.func
	};
	ProxyDetails.displayName = 'ProxyDetails';
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProxyDetails);

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Role = exports.Organization = exports.FilterAndSortSeparator = exports.SortBy = exports.FilterByStatus = exports.FilterByRole = exports.USER_LIST_ORGBOUND_ROLE_FILTER_BY = exports.USER_LIST_PUBLISHER_ROLE_FILTER_BY = exports.FilterByOrganization = exports.FilterByEmail = exports.FilterByName = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _Grid = __webpack_require__(71);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _components = __webpack_require__(17);
	
	var _constants = __webpack_require__(14);
	
	var _intl = __webpack_require__(15);
	
	var _rbac = __webpack_require__(625);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterByName = exports.FilterByName = function FilterByName(props) {
	  return _react2.default.createElement(
	    _Grid2.default,
	    { item: true, md: 2, sm: 3, xs: 12 },
	    _react2.default.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'user-filter-by-name'
	    }))
	  );
	};
	
	var FilterByEmail = exports.FilterByEmail = function FilterByEmail(props) {
	  return _react2.default.createElement(
	    _Grid2.default,
	    { item: true, md: 2, sm: 3, xs: 12 },
	    _react2.default.createElement(_components.FormTextField, Object.assign({}, props, {
	      id: 'user-filter-by-email'
	    }))
	  );
	};
	
	var FilterByOrganization = exports.FilterByOrganization = function FilterByOrganization(props) {
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var onChange = function onChange(e, value) {
	    return props.handleChange((0, _lodash.get)(value, 'uuid'));
	  };
	  return _react2.default.createElement(
	    _Grid2.default,
	    { item: true, md: 2, sm: 2, xs: 12 },
	    _react2.default.createElement(_components.FormAutoCompleteCombo, Object.assign({}, props, {
	      id: 'user-filter-by-organization',
	      inputLabel: intl.getI18nMessage('label.user.list.page.organization.by.all.organizations'),
	      onChange: onChange
	    }))
	  );
	};
	
	FilterByOrganization.propTypes = {
	  handleChange: _propTypes.func
	};
	
	var USER_LIST_PUBLISHER_ROLE_FILTER_BY = exports.USER_LIST_PUBLISHER_ROLE_FILTER_BY = Object.keys(_constants.USER_LIST_ROLE).map(function (role) {
	  return {
	    uuid: role,
	    text: (0, _intl.getI18nFormattedMessage)(_constants.USER_LIST_ROLE[role])
	  };
	});
	
	var USER_LIST_ORGBOUND_ROLE_FILTER_BY = exports.USER_LIST_ORGBOUND_ROLE_FILTER_BY = USER_LIST_PUBLISHER_ROLE_FILTER_BY.filter(function (_ref) {
	  var uuid = _ref.uuid;
	  return [_constants.ROLE_ORG_ADMIN_UUID, _constants.ROLE_ORG_PUBLISHER_UUID, _constants.ROLE_DEVELOPER_UUID].includes(uuid);
	});
	
	var FilterByRole = exports.FilterByRole = function FilterByRole(props) {
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	  var data = props.isPublisher ? USER_LIST_PUBLISHER_ROLE_FILTER_BY : USER_LIST_ORGBOUND_ROLE_FILTER_BY;
	  var renderValue = function renderValue(selected) {
	    if (selected.length === 0) {
	      return intl.getI18nMessage('label.user.list.page.role.by.all.roles');
	    }
	    return selected.map(function (s) {
	      return intl.getI18nMessage(_constants.USER_LIST_ROLE[s]);
	    }).join(', ');
	  };
	  return _react2.default.createElement(
	    _Grid2.default,
	    { item: true, md: 2, sm: 2, xs: 12 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'user-filter-by-role',
	      data: data,
	      noNoneOption: true,
	      noNativeSelect: true,
	      multiple: true,
	      displayEmpty: true,
	      renderValue: renderValue
	    }))
	  );
	};
	
	FilterByRole.propTypes = {
	  isPublisher: _propTypes.bool
	};
	
	var FilterByStatus = exports.FilterByStatus = function FilterByStatus(props) {
	  return _react2.default.createElement(
	    _Grid2.default,
	    { item: true, md: 2, sm: 2, xs: 12 },
	    _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'user-filter-by-status',
	      data: _constants.USER_LIST_STATUS_FILTER_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	var SortBy = exports.SortBy = function SortBy(props) {
	  return _react2.default.createElement(
	    _Grid2.default,
	    { item: true, md: 2, sm: 3, xs: 12 },
	    !props.hidden && _react2.default.createElement(_components.FormSelect, Object.assign({}, props, {
	      id: 'user-sort-by',
	      data: _constants.USER_LIST_SORT_BY,
	      noNoneOption: true,
	      noNativeSelect: true
	    }))
	  );
	};
	
	SortBy.propTypes = {
	  hidden: _propTypes.bool
	};
	
	var FilterAndSortSeparator = exports.FilterAndSortSeparator = function FilterAndSortSeparator() {
	  return _react2.default.createElement(_Grid2.default, { item: true, md: true, sm: 9 });
	};
	
	var Organization = exports.Organization = function Organization(_ref2) {
	  var access = _ref2.access,
	      expanded = _ref2.expanded;
	  return _react2.default.createElement(_components.TableMultiValueCell, {
	    entity: (0, _intl.getI18nFormattedMessage)('label.organizations'),
	    text: function text(role) {
	      return role.orgName && role.orgName + ' (' + (0, _lodash.startCase)((0, _lodash.camelCase)(role.orgType)) + ')';
	    },
	    items: access,
	    expanded: expanded,
	    uniqueKey: function uniqueKey(item) {
	      return item.orgUuid + ' ' + item.roleUuid;
	    }
	  });
	};
	
	Organization.propTypes = {
	  access: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  expanded: _propTypes.bool
	};
	
	var Role = exports.Role = function Role(_ref3) {
	  var access = _ref3.access,
	      expanded = _ref3.expanded;
	  return _react2.default.createElement(_components.TableMultiValueCell, {
	    entity: (0, _intl.getI18nFormattedMessage)('label.roles'),
	    text: function text(role) {
	      return (0, _rbac.getRoleLabel)(role);
	    },
	    items: access,
	    expanded: expanded,
	    uniqueKey: function uniqueKey(item) {
	      return item.orgUuid + ' ' + item.roleUuid;
	    }
	  });
	};
	
	Role.propTypes = {
	  access: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  expanded: _propTypes.bool
	};

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserList = exports.USERS_LIST_COLUMNS = exports.getFullName = exports.getUserEditLink = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(5);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _reactRedux = __webpack_require__(27);
	
	var _compose = __webpack_require__(28);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _core = __webpack_require__(3);
	
	var _isEmail = __webpack_require__(654);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _portalConfig = __webpack_require__(85);
	
	var _organization = __webpack_require__(281);
	
	var _user = __webpack_require__(1452);
	
	var _portalConfig2 = __webpack_require__(26);
	
	var _organization2 = __webpack_require__(203);
	
	var _user2 = __webpack_require__(623);
	
	var _styles = __webpack_require__(1697);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _controls = __webpack_require__(1695);
	
	var _constants = __webpack_require__(14);
	
	var _rbac = __webpack_require__(625);
	
	var _intl = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUserEditLink = exports.getUserEditLink = function getUserEditLink(user) {
	  return (0, _rbac.getCanManageUser)(user) && '/admin/users#edit';
	};
	
	var getFullName = exports.getFullName = function getFullName(_ref) {
	  var _ref$lastName = _ref.lastName,
	      lastName = _ref$lastName === undefined ? '' : _ref$lastName,
	      _ref$firstName = _ref.firstName,
	      firstName = _ref$firstName === undefined ? '' : _ref$firstName;
	  return lastName && firstName ? lastName + ', ' + firstName : lastName || firstName || (0, _intl.getI18nFormattedMessage)('label.user.no.name');
	};
	
	var USERS_LIST_COLUMNS = exports.USERS_LIST_COLUMNS = [{
	  id: 'name',
	  label: (0, _intl.getI18nFormattedMessage)('label.name'),
	  minWidth: 200,
	  link: getUserEditLink,
	  value: getFullName
	}, {
	  id: 'email',
	  label: (0, _intl.getI18nFormattedMessage)('label.email'),
	  minWidth: 100
	}, {
	  id: 'organization',
	  label: (0, _intl.getI18nFormattedMessage)('label.organization(s)'),
	  minWidth: 100,
	  value: _controls.Organization
	}, {
	  id: 'role',
	  label: (0, _intl.getI18nFormattedMessage)('label.role'),
	  minWidth: 100,
	  value: _controls.Role
	}, {
	  id: 'status',
	  label: (0, _intl.getI18nFormattedMessage)('label.status'),
	  minWidth: 100,
	  value: function value(_ref2) {
	    var status = _ref2.status;
	    return _constants.USER_STATUS_LABEL[status] || status;
	  }
	}];
	
	var UserList = exports.UserList = function UserList(props) {
	  var classes = props.classes,
	      userContext = props.userContext,
	      isError = props.isError,
	      _props$userErrors = props.userErrors,
	      userErrors = _props$userErrors === undefined ? [] : _props$userErrors,
	      isLoading = props.isLoading,
	      _props$totalElements = props.totalElements,
	      totalElements = _props$totalElements === undefined ? 0 : _props$totalElements,
	      _props$results = props.results,
	      results = _props$results === undefined ? [] : _props$results,
	      isUserDeleteSuccess = props.isUserDeleteSuccess,
	      lockUserCreation = props.lockUserCreation,
	      organizations = props.organizations;
	
	
	  var intl = (0, _intl.getI18n)((0, _reactIntl.useIntl)());
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      notificationMessage = _useState2[0],
	      setNotificationMessage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      notificationStatus = _useState4[0],
	      setNotificationStatus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filterByName = _useState6[0],
	      setFilterByName = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      filterByEmail = _useState8[0],
	      setFilterByEmail = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(),
	      _useState10 = _slicedToArray(_useState9, 2),
	      filterByOrganization = _useState10[0],
	      setFilterByOrganization = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterByRole = _useState12[0],
	      setFilterByRole = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(_constants.ALL),
	      _useState14 = _slicedToArray(_useState13, 2),
	      filterByStatus = _useState14[0],
	      setFilterByStatus = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      sortBy = _useState16[0],
	      setSortBy = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      page = _useState18[0],
	      setPage = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(_constants.GRID_ROWS_PER_PAGE_DEFAULT_OPTION),
	      _useState20 = _slicedToArray(_useState19, 2),
	      rowsPerPage = _useState20[0],
	      setRowsPerPage = _useState20[1];
	
	  var isPublisher = (0, _rbac.hasPublisherRole)(userContext);
	
	  var notifyMessages = function notifyMessages(status, message) {
	    setNotificationStatus(status);
	    setNotificationMessage(message);
	  };
	
	  (0, _react.useEffect)(function () {
	    props.fetchAllOrganizations();
	
	    var _sortBy$split = sortBy.split(','),
	        _sortBy$split2 = _slicedToArray(_sortBy$split, 2),
	        by = _sortBy$split2[0],
	        order = _sortBy$split2[1];
	
	    props.fetchUsers({
	      name: filterByName,
	      email: filterByEmail,
	      orgUuids: filterByOrganization,
	      roleUuids: filterByRole,
	      status: filterByStatus,
	      sortBy: by,
	      sortOrder: order,
	      page: page,
	      rowsPerPage: rowsPerPage
	    });
	    props.fetchLockUserCreation();
	    if (isUserDeleteSuccess) {
	      notifyMessages(_constants.ALERT_SUCCESS, intl.getI18nMessage('label.user.deleted'));
	      setTimeout(props.resetDeleteNotification, 2500);
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _rbac.getCanListUsers)(userContext)) {
	      props.push('/404');
	    }
	  }, [userContext]);
	
	  (0, _react.useEffect)(function () {
	    if (isError) {
	      notifyMessages(_constants.ALERT_ERROR, intl.getI18nMessage('error.user.fetch'));
	    } else if (isUserDeleteSuccess) {
	      notifyMessages(_constants.ALERT_SUCCESS, intl.getI18nMessage('label.user.deleted'));
	    } else {
	      notifyMessages('', '');
	    }
	  }, [isError, userErrors, isUserDeleteSuccess]);
	
	  var onFilterByNameChange = function onFilterByNameChange(value) {
	    setFilterByName(value);
	  };
	  var onFilterByNameKeyPress = function onFilterByNameKeyPress(e) {
	    if (filterByName && filterByName.length < 3) {
	      return;
	    }
	    if (e.key === _constants.KEY_ENTER) {
	      var _sortBy$split3 = sortBy.split(','),
	          _sortBy$split4 = _slicedToArray(_sortBy$split3, 2),
	          by = _sortBy$split4[0],
	          order = _sortBy$split4[1];
	
	      setPage(0);
	      props.fetchUsers({
	        name: filterByName,
	        email: filterByEmail,
	        orgUuids: filterByOrganization,
	        roleUuids: filterByRole,
	        status: filterByStatus,
	        sortBy: by,
	        sortOrder: order,
	        page: 0,
	        rowsPerPage: rowsPerPage
	      });
	    }
	  };
	  var onFilterByEmailChange = function onFilterByEmailChange(value) {
	    setFilterByEmail(value);
	  };
	  var onFilterByEmailKeyPress = function onFilterByEmailKeyPress(e) {
	    if (filterByEmail && !(0, _isEmail2.default)(filterByEmail)) {
	      return;
	    }
	    if (e.key === _constants.KEY_ENTER) {
	      var _sortBy$split5 = sortBy.split(','),
	          _sortBy$split6 = _slicedToArray(_sortBy$split5, 2),
	          by = _sortBy$split6[0],
	          order = _sortBy$split6[1];
	
	      setPage(0);
	      props.fetchUsers({
	        name: filterByName,
	        email: filterByEmail,
	        orgUuids: filterByOrganization,
	        roleUuids: filterByRole,
	        status: filterByStatus,
	        sortBy: by,
	        sortOrder: order,
	        page: 0,
	        rowsPerPage: rowsPerPage
	      });
	    }
	  };
	  var onFilterByOrganizationChange = function onFilterByOrganizationChange(newOrganization) {
	    setFilterByOrganization(newOrganization);
	
	    var _sortBy$split7 = sortBy.split(','),
	        _sortBy$split8 = _slicedToArray(_sortBy$split7, 2),
	        by = _sortBy$split8[0],
	        order = _sortBy$split8[1];
	
	    setPage(0);
	    props.fetchUsers({
	      name: filterByName,
	      email: filterByEmail,
	      orgUuids: newOrganization,
	      roleUuids: filterByRole,
	      status: filterByStatus,
	      sortBy: by,
	      sortOrder: order,
	      page: 0,
	      rowsPerPage: rowsPerPage
	    });
	  };
	  var onFilterByRoleChange = function onFilterByRoleChange(newRole) {
	    setFilterByRole(newRole);
	
	    var _sortBy$split9 = sortBy.split(','),
	        _sortBy$split10 = _slicedToArray(_sortBy$split9, 2),
	        by = _sortBy$split10[0],
	        order = _sortBy$split10[1];
	
	    setPage(0);
	    props.fetchUsers({
	      name: filterByName,
	      email: filterByEmail,
	      orgUuids: filterByOrganization,
	      roleUuids: newRole,
	      status: filterByStatus,
	      sortBy: by,
	      sortOrder: order,
	      page: 0,
	      rowsPerPage: rowsPerPage
	    });
	  };
	  var onFilterByStatusChange = function onFilterByStatusChange(newStatus) {
	    setFilterByStatus(newStatus);
	
	    var _sortBy$split11 = sortBy.split(','),
	        _sortBy$split12 = _slicedToArray(_sortBy$split11, 2),
	        by = _sortBy$split12[0],
	        order = _sortBy$split12[1];
	
	    setPage(0);
	    props.fetchUsers({
	      name: filterByName,
	      email: filterByEmail,
	      orgUuids: filterByOrganization,
	      roleUuids: filterByRole,
	      status: newStatus,
	      sortBy: by,
	      sortOrder: order,
	      page: 0,
	      rowsPerPage: rowsPerPage
	    });
	  };
	
	  var onSortByChange = function onSortByChange(newSortBy) {
	    setSortBy(newSortBy);
	
	    var _newSortBy$split = newSortBy.split(','),
	        _newSortBy$split2 = _slicedToArray(_newSortBy$split, 2),
	        by = _newSortBy$split2[0],
	        order = _newSortBy$split2[1];
	
	    props.fetchUsers({
	      name: filterByName,
	      email: filterByEmail,
	      orgUuids: filterByOrganization,
	      roleUuids: filterByRole,
	      status: filterByStatus,
	      sortBy: by,
	      sortOrder: order,
	      page: page,
	      rowsPerPage: rowsPerPage
	    });
	  };
	
	  var onChangePage = function onChangePage(newPage) {
	    if (page === newPage) {
	      return;
	    }
	    setPage(newPage);
	
	    var _sortBy$split13 = sortBy.split(','),
	        _sortBy$split14 = _slicedToArray(_sortBy$split13, 2),
	        by = _sortBy$split14[0],
	        order = _sortBy$split14[1];
	
	    props.fetchUsers({
	      name: filterByName,
	      email: filterByEmail,
	      orgUuids: filterByOrganization,
	      roleUuids: filterByRole,
	      status: filterByStatus,
	      sortBy: by,
	      sortOrder: order,
	      page: newPage,
	      rowsPerPage: rowsPerPage
	    });
	  };
	  var onChangePreviousPage = function onChangePreviousPage() {
	    onChangePage(page - 1);
	  };
	  var onChangeNextPage = function onChangeNextPage() {
	    onChangePage(page + 1);
	  };
	
	  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
	    setRowsPerPage(newRowsPerPage);
	    setPage(0);
	
	    var _sortBy$split15 = sortBy.split(','),
	        _sortBy$split16 = _slicedToArray(_sortBy$split15, 2),
	        by = _sortBy$split16[0],
	        order = _sortBy$split16[1];
	
	    props.fetchUsers({
	      name: filterByName,
	      email: filterByEmail,
	      orgUuids: filterByOrganization,
	      roleUuids: filterByRole,
	      status: filterByStatus,
	      sortBy: by,
	      sortOrder: order,
	      page: 0,
	      rowsPerPage: newRowsPerPage
	    });
	  };
	
	  var onAddUser = function onAddUser() {
	    props.resetApp();
	    window.location.href = '/admin/users#add';
	  };
	
	  return _react2.default.createElement(_list2.default, {
	    userContext: userContext,
	    listPageId: 'user-list-page',
	    isLoading: isLoading,
	    notificationId: 'user-notifications',
	    notificationStatus: notificationStatus,
	    setNotificationStatus: setNotificationMessage,
	    notificationMessage: notificationMessage,
	    setNotificationMessage: setNotificationMessage,
	    onCloseNotification: props.resetDeleteNotification,
	    pageHeaderTitle: intl.getI18nMessage('label.user.list.page.title'),
	    addButtonLabel: intl.getI18nMessage('label.user.add.button'),
	    onAdd: (0, _rbac.getCanCreateUser)(userContext) && onAddUser,
	    disableAdd: lockUserCreation,
	    filterAndSortContent: _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_controls.FilterByName, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        value: filterByName,
	        placeholder: intl.getI18nMessage('label.user.list.page.filter.by.name.placeholder'),
	        handleChange: onFilterByNameChange,
	        onKeyPress: onFilterByNameKeyPress,
	        disabled: filterByEmail.length > 0
	      }),
	      _react2.default.createElement(_controls.FilterByEmail, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        value: filterByEmail,
	        placeholder: intl.getI18nMessage('label.user.list.page.filter.by.email.placeholder'),
	        handleChange: onFilterByEmailChange,
	        onKeyPress: onFilterByEmailKeyPress,
	        hideLabel: true,
	        disabled: filterByName.length > 0
	      }),
	      isPublisher && _react2.default.createElement(_controls.FilterByOrganization, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        selectFieldClass: classes.selectField,
	        data: organizations,
	        value: filterByOrganization,
	        handleChange: onFilterByOrganizationChange,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterByRole, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        selectFieldClass: classes.selectField,
	        value: filterByRole,
	        handleChange: onFilterByRoleChange,
	        hideLabel: true,
	        isPublisher: isPublisher
	      }),
	      _react2.default.createElement(_controls.FilterByStatus, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.filter'),
	        selectFieldClass: classes.selectField,
	        value: filterByStatus,
	        handleChange: onFilterByStatusChange,
	        hideLabel: true
	      }),
	      _react2.default.createElement(_controls.FilterAndSortSeparator, null),
	      _react2.default.createElement(_controls.SortBy, {
	        fieldContainerClass: classes.fieldContainer,
	        name: intl.getI18nMessage('label.sort'),
	        selectFieldClass: classes.selectField,
	        value: sortBy,
	        handleChange: onSortByChange,
	        hidden: true
	      })
	    ),
	    columns: USERS_LIST_COLUMNS,
	    rows: results,
	    noResultsMessage: intl.getI18nMessage('label.user.filter.no.results'),
	    page: page,
	    totalElements: totalElements,
	    totalPages: Math.ceil(totalElements / rowsPerPage),
	    rowsPerPage: rowsPerPage,
	    onChangeRowsPerPage: onChangeRowsPerPage,
	    onChangePage: onChangePage,
	    onChangePreviousPage: onChangePreviousPage,
	    onChangeNextPage: onChangeNextPage
	  });
	};
	
	UserList.propTypes = {
	  classes: (0, _propTypes.shape)({}),
	  userContext: (0, _propTypes.shape)({}),
	  isLoading: _propTypes.bool,
	  isError: _propTypes.bool,
	  userErrors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}) || _propTypes.string),
	  totalElements: _propTypes.number,
	  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  isUserDeleteSuccess: _propTypes.bool,
	  lockUserCreation: _propTypes.bool,
	  resetDeleteNotification: _propTypes.func,
	  organizations: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
	  resetApp: _propTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    config: (0, _portalConfig2.getConfig)(state),
	    userContext: (0, _portalConfig2.getUserDetails)(state),
	    isError: (0, _user2.getIsError)(state),
	    userErrors: (0, _user2.getErrors)(state),
	    isLoading: false,
	    totalElements: (0, _user2.getUserListTotalElements)(state),
	    results: (0, _user2.getUserListResults)(state),
	    isUserDeleteSuccess: (0, _user2.getIsUserDeleteSuccess)(state),
	    lockUserCreation: (0, _portalConfig2.getLockUserCreation)(state),
	    organizations: (0, _organization2.getOrganizationListResults)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  push: _connectedReactRouter.push,
	  resetApp: _user.resetApp,
	  fetchUsers: _user.fetchUsers,
	  fetchLockUserCreation: _portalConfig.fetchLockUserCreation,
	  resetDeleteNotification: _user.resetDeleteNotification,
	  fetchAllOrganizations: _organization.fetchAllOrganizations
	};
	
	exports.default = (0, _compose2.default)((0, _core.withStyles)(_styles2.default), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(UserList);

/***/ },
/* 1697 */
1666,
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    content: {
	      margin: (0, _get2.default)(theme, 'margin.m36'),
	      minHeight: 'calc(100vh - 125px)',
	      backgroundColor: (0, _get2.default)(theme, 'color.uiBackground'),
	      marginTop: (0, _get2.default)(theme, 'margin.m0'),
	      padding: '24px 0px 72px 0px'
	    },
	    gridContainer: {
	      display: 'inline-flex',
	      width: 'auto',
	      padding: '0 36px'
	    },
	    divider: {
	      backgroundColor: (0, _get2.default)(theme, 'color.bodyText')
	    },
	    notificationWidthClass: {
	      width: 'calc(100% - 100px)',
	      padding: '0 15px',
	      marginLeft: (0, _get2.default)(theme, 'margin.m0')
	    },
	    actionsContainer: {
	      marginTop: (0, _get2.default)(theme, 'margin.m6')
	    },
	    errorContainer: {
	      marginLeft: '30px'
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var styles = function styles(_ref) {
	  var color = _ref.color,
	      fontSize = _ref.fontSize,
	      typography = _ref.typography,
	      padding = _ref.padding,
	      margin = _ref.margin;
	  return {
	    content: {
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      margin: '0 36px',
	      minHeight: 'calc(100vh - 125px)',
	      marginBottom: '170px'
	    },
	    gridContainer: {
	      minHeight: 'calc(100vh - 125px)',
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      marginTop: (0, _lodash.get)(margin, 'm0'),
	      marginBottom: (0, _lodash.get)(margin, 'm60')
	    },
	    pageHeaderTitle: {
	      color: (0, _lodash.get)(color, 'bodyText'),
	      fontFamily: (0, _lodash.get)(typography, 'bodyText'),
	      fontSize: (0, _lodash.get)(fontSize, 'bodyText'),
	      fontWeight: 'bold',
	      marginBottom: (0, _lodash.get)(margin, 'm0'),
	      marginTop: (0, _lodash.get)(margin, 'm10'),
	      wordWrap: 'break-word'
	    },
	    leftSidebar: {
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      paddingTop: (0, _lodash.get)(padding, 'p50')
	    },
	    mainContent: {
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      padding: (0, _lodash.get)(padding, 'p20'),
	      paddingTop: (0, _lodash.get)(padding, 'p50'),
	      borderLeft: '8px solid ' + (0, _lodash.get)(color, 'background')
	    },
	    rightSidebar: {
	      backgroundColor: (0, _lodash.get)(color, 'uiBackground'),
	      padding: (0, _lodash.get)(padding, 'p10'),
	      paddingTop: (0, _lodash.get)(padding, 'p50'),
	      borderLeft: '8px solid ' + (0, _lodash.get)(color, 'background')
	    }
	  };
	};
	
	exports.default = styles;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PageNotFoundPage = exports.UserListPage = exports.ProxyDetailsPage = exports.OrganizationEditPage = exports.OrganizationListPage = exports.GatewayBundleEditPage = exports.GatewayBundleListPage = exports.GatewayBundleDetailsPage = exports.ApiProxyDetailsPage = exports.ApiProxyEditPage = exports.ApplicationDetailsPage = exports.ApplicationEditPage = exports.ApiEditPage = undefined;
	
	var _index = __webpack_require__(1572);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Edit = __webpack_require__(1608);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _Details = __webpack_require__(1596);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _Edit3 = __webpack_require__(1583);
	
	var _Edit4 = _interopRequireDefault(_Edit3);
	
	var _Details3 = __webpack_require__(1579);
	
	var _Details4 = _interopRequireDefault(_Details3);
	
	var _Details5 = __webpack_require__(1659);
	
	var _Details6 = _interopRequireDefault(_Details5);
	
	var _List = __webpack_require__(1665);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _List3 = __webpack_require__(1671);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _Edit5 = __webpack_require__(1667);
	
	var _Edit6 = _interopRequireDefault(_Edit5);
	
	var _Edit7 = __webpack_require__(1662);
	
	var _Edit8 = _interopRequireDefault(_Edit7);
	
	var _Details7 = __webpack_require__(1694);
	
	var _Details8 = _interopRequireDefault(_Details7);
	
	var _List5 = __webpack_require__(1696);
	
	var _List6 = _interopRequireDefault(_List5);
	
	var _PageNotFoundPage = __webpack_require__(1673);
	
	var _PageNotFoundPage2 = _interopRequireDefault(_PageNotFoundPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ApiEditPage = _index2.default;
	exports.ApplicationEditPage = _Edit2.default;
	exports.ApplicationDetailsPage = _Details2.default;
	exports.ApiProxyEditPage = _Edit4.default;
	exports.ApiProxyDetailsPage = _Details4.default;
	exports.GatewayBundleDetailsPage = _Details6.default;
	exports.GatewayBundleListPage = _List2.default;
	exports.GatewayBundleEditPage = _Edit8.default;
	exports.OrganizationListPage = _List4.default;
	exports.OrganizationEditPage = _Edit6.default;
	exports.ProxyDetailsPage = _Details8.default;
	exports.UserListPage = _List6.default;
	exports.PageNotFoundPage = _PageNotFoundPage2.default;

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = function styles() {
	  var _ref2;
	
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      breakpoint = _ref.breakpoint,
	      color = _ref.color,
	      fontSize = _ref.fontSize,
	      height = _ref.height,
	      padding = _ref.padding,
	      margin = _ref.margin,
	      lineHeight = _ref.lineHeight;
	
	  return _ref2 = {
	    page: {
	      backgroundColor: (0, _get2.default)(color, 'uiBackground'),
	      margin: '0 ' + (0, _get2.default)(margin, 'm36'),
	      minHeight: 'calc(100vh - 125px)'
	    },
	    pageBody: {
	      paddingTop: (0, _get2.default)(padding, 'p38'),
	      paddingBottom: (0, _get2.default)(height, 'h72')
	    },
	    pageHeader: {
	      padding: '0 ' + (0, _get2.default)(padding, 'p36')
	    },
	    pageTitle: {
	      margin: 0
	    },
	    helpIcon: {
	      fontSize: (0, _get2.default)(fontSize, 'pageTitle'),
	      marginTop: (0, _get2.default)(margin, 'm4'),
	      paddingLeft: (0, _get2.default)(padding, 'p12')
	    },
	    addBundleButton: {
	      marginTop: (0, _get2.default)(margin, 'm4'),
	      '& button': {
	        float: 'right',
	        lineHeight: (0, _get2.default)(lineHeight, 'lh20'),
	        marginRight: (0, _get2.default)(margin, 'm4')
	      }
	    },
	    pageFilterAndSort: {
	      marginTop: (0, _get2.default)(margin, 'm12'),
	      padding: '0 ' + (0, _get2.default)(padding, 'p36')
	    },
	    selectField: {
	      padding: (0, _get2.default)(padding, 'p4') + ' ' + (0, _get2.default)(padding, 'p8') + ' !important'
	    },
	    alertMessages: {
	      position: 'fixed',
	      left: (0, _get2.default)(margin, 'm36'),
	      right: (0, _get2.default)(margin, 'm36'),
	      margin: 0,
	      minHeight: (0, _get2.default)(height, 'h40'),
	      width: 'auto'
	    }
	
	  }, _defineProperty(_ref2, '@media (max-width: ' + (0, _get2.default)(breakpoint, 'md') + ')', {
	    page: {
	      margin: 0
	    },
	    alertMessages: {
	      left: 0,
	      right: 0
	    }
	  }), _defineProperty(_ref2, '@media (max-width: ' + (0, _get2.default)(breakpoint, 'xs') + ')', {
	    pageHeader: {
	      padding: '0 ' + (0, _get2.default)(padding, 'p16')
	    },
	    helpIcon: {
	      display: 'none'
	    },
	    addBundleButton: {
	      '& button': {
	        float: 'left'
	      }
	    },
	    pageFilterAndSort: {
	      marginTop: (0, _get2.default)(margin, 'm24'),
	      padding: '0 ' + (0, _get2.default)(padding, 'p16')
	    }
	  }), _ref2;
	};
	
	exports.default = styles;

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getParsedCustomFields = exports.getParsedApiDetails = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var getParsedApiDetails = exports.getParsedApiDetails = function getParsedApiDetails(apiDetails) {
	  return Object.assign({}, apiDetails, {
	    authenticationParameters: (0, _lodash.isString)(apiDetails.authenticationParameters) ? JSON.parse(apiDetails.authenticationParameters) : apiDetails.authenticationParameters
	  });
	};
	
	var getParsedCustomFields = exports.getParsedCustomFields = function getParsedCustomFields(customFields) {
	  return customFields.map(function (customField) {
	    var status = customField.Status,
	        description = customField.Description,
	        name = customField.Name,
	        entityType = customField.EntityType,
	        type = customField.Type,
	        uuid = customField.Uuid,
	        required = customField.Required,
	        optionsList = customField.OptionsList.results;
	
	
	    return {
	      status: status,
	      description: description,
	      name: name,
	      entityType: entityType,
	      type: type,
	      uuid: uuid,
	      required: required,
	      optionsList: optionsList.map(function (_ref) {
	        var ordinal = _ref.Ordinal,
	            value = _ref.Value;
	        return { ordinal: ordinal, value: value };
	      })
	    };
	  });
	};
	
	exports.default = function () {};

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHashingMetadata = exports.getParsedCustomFields = exports.getParsedApiEula = exports.getParsedApplicationDetails = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var getParsedApplicationDetails = exports.getParsedApplicationDetails = function getParsedApplicationDetails(payload) {
	  if (!payload) {
	    return null;
	  }
	  var uuid = payload.Uuid,
	      organizationName = payload.OrganizationName,
	      description = payload.Description,
	      apiKey = payload.ApiKey,
	      magMasterKey = payload.MagMasterKey,
	      reason = payload.Reason,
	      name = payload.Name,
	      oauthScope = payload.OauthScope,
	      keySecret = payload.KeySecret,
	      magScope = payload.MagScope,
	      oauthCallbackUrl = payload.OauthCallbackUrl,
	      status = payload.Status,
	      disabledByType = payload.DisabledByType,
	      oauthType = payload.OauthType,
	      organizationUuid = payload.OrganizationUuid,
	      customFieldValues = payload.CustomFieldValues.results,
	      apiIds = payload.ApiIds.results,
	      apiApiPlanIds = payload.ApiApiPlanIds.results,
	      apiGroupIds = payload.ApiGroupIds.results;
	
	
	  return {
	    uuid: uuid,
	    organizationName: organizationName,
	    description: description,
	    apiKey: apiKey,
	    magMasterKey: magMasterKey,
	    reason: reason,
	    name: name,
	    oauthScope: oauthScope,
	    keySecret: keySecret,
	    magScope: magScope,
	    oauthCallbackUrl: oauthCallbackUrl,
	    status: status,
	    disabledByType: disabledByType,
	    oauthType: oauthType,
	    organizationUuid: organizationUuid,
	    customFieldValues: customFieldValues.reduce(function (acc, _ref) {
	      var CustomFieldUuid = _ref.CustomFieldUuid,
	          Value = _ref.Value;
	
	      acc[CustomFieldUuid] = Value;
	      return acc;
	    }, {}),
	    apiIds: apiIds,
	    apiApiPlanIds: apiApiPlanIds.reduce(function (acc, _ref2) {
	      var ApiUuid = _ref2.ApiUuid,
	          ApiPlanUuid = _ref2.ApiPlanUuid;
	
	      acc[ApiUuid] = ApiPlanUuid;
	      return acc;
	    }, {}),
	    apiGroupIds: apiGroupIds
	  };
	};
	
	var getParsedApiEula = exports.getParsedApiEula = function getParsedApiEula(payload) {
	  var apiUsage = payload.ApiUsage,
	      applicationUsage = payload.ApplicationUsage,
	      uuid = payload.Uuid,
	      content = payload.Content,
	      name = payload.Name,
	      possibleActions = payload.PossibleActions;
	
	
	  return { apiUsage: apiUsage, applicationUsage: applicationUsage, uuid: uuid, content: content, name: name, possibleActions: possibleActions };
	};
	
	var getParsedCustomFields = exports.getParsedCustomFields = function getParsedCustomFields(customFields) {
	  return customFields.map(function (customField) {
	    var status = customField.Status,
	        description = customField.Description,
	        name = customField.Name,
	        entityType = customField.EntityType,
	        type = customField.Type,
	        uuid = customField.Uuid,
	        required = customField.Required,
	        optionsList = customField.OptionsList.results;
	
	
	    return {
	      status: status,
	      description: description,
	      name: name,
	      entityType: entityType,
	      type: type,
	      uuid: uuid,
	      required: required,
	      optionsList: optionsList.map(function (_ref3) {
	        var ordinal = _ref3.Ordinal,
	            value = _ref3.Value;
	        return { ordinal: ordinal, value: value };
	      })
	    };
	  });
	};
	
	var getHashingMetadata = exports.getHashingMetadata = function getHashingMetadata(payload) {
	  var appSecretHashingMetadata = payload.AppSecretHashingMetadata;
	
	
	  return {
	    appSecretHashingMetadata: (0, _lodash.isString)(appSecretHashingMetadata) ? JSON.parse(appSecretHashingMetadata) : appSecretHashingMetadata
	  };
	};

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(293);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _api = __webpack_require__(202);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _apiProxy = __webpack_require__(284);
	
	var _apiProxy2 = _interopRequireDefault(_apiProxy);
	
	var _application = __webpack_require__(86);
	
	var _application2 = _interopRequireDefault(_application);
	
	var _dashboard = __webpack_require__(285);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _gatewayBundle = __webpack_require__(123);
	
	var _gatewayBundle2 = _interopRequireDefault(_gatewayBundle);
	
	var _organization = __webpack_require__(203);
	
	var _organization2 = _interopRequireDefault(_organization);
	
	var _portalConfig = __webpack_require__(26);
	
	var _portalConfig2 = _interopRequireDefault(_portalConfig);
	
	var _proxy = __webpack_require__(104);
	
	var _proxy2 = _interopRequireDefault(_proxy);
	
	var _user = __webpack_require__(623);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducers = {
	  permissions: _api2.default,
	  application: _application2.default,
	  apiProxy: _apiProxy2.default,
	  dashboard: _dashboard2.default,
	  gatewayBundle: _gatewayBundle2.default,
	  organization: _organization2.default,
	  portalConfig: _portalConfig2.default,
	  proxy: _proxy2.default,
	  user: _user2.default
	};
	var createRootReducer = function createRootReducer(history) {
	  return (0, _redux.combineReducers)(history ? Object.assign({}, reducers, { router: (0, _connectedReactRouter.connectRouter)(history) }) : reducers);
	};
	
	exports.default = createRootReducer;

/***/ },
/* 1705 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getParsedAccountPlans = exports.getParsedAccountPlans = function getParsedAccountPlans() {
	  var accountPlans = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return accountPlans.map(function (item) {
	    return {
	      name: item.Name,
	      uuid: item.Uuid
	    };
	  });
	};
	
	exports.default = function () {};

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHashingMetadata = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var getHashingMetadata = exports.getHashingMetadata = function getHashingMetadata(payload) {
	  return (0, _lodash.isString)(payload) ? JSON.parse(payload) : payload;
	};
	
	exports.default = function () {};

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getParsedGatewayDetails = undefined;
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _json = __webpack_require__(1712);
	
	var _json2 = _interopRequireDefault(_json);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getParsedGatewayDetails = exports.getParsedGatewayDetails = function getParsedGatewayDetails(gatewayDetails) {
	  return {
	    accountPlanSyncDisruption: (0, _get2.default)(gatewayDetails, 'AccountPlanSyncDisruption'),
	    accountPlanSyncLog: (0, _json2.default)((0, _get2.default)(gatewayDetails, 'AccountPlanSyncLog'), {}),
	    accountPlanSyncTime: (0, _get2.default)(gatewayDetails, 'AccountPlanSyncTime'),
	    apiPlanSyncDisruption: (0, _get2.default)(gatewayDetails, 'ApiPlanSyncDisruption'),
	    apiPlanSyncLog: (0, _json2.default)((0, _get2.default)(gatewayDetails, 'ApiPlanSyncLog'), {}),
	    apiPlanSyncTime: (0, _get2.default)(gatewayDetails, 'ApiPlanSyncTime'),
	    apiSyncDisruption: (0, _get2.default)(gatewayDetails, 'ApiSyncDisruption'),
	    apiSyncLog: (0, _json2.default)((0, _get2.default)(gatewayDetails, 'ApiSyncLog'), {}),
	    apiSyncTime: (0, _get2.default)(gatewayDetails, 'ApiSyncTime'),
	    appSyncDisruption: (0, _get2.default)(gatewayDetails, 'AppSyncDisruption'),
	    appSyncLog: (0, _json2.default)((0, _get2.default)(gatewayDetails, 'AppSyncLog'), {}),
	    appSyncTime: (0, _get2.default)(gatewayDetails, 'AppSyncTime'),
	    enrollmentStatus: (0, _get2.default)(gatewayDetails, 'EnrollmentStatus'),
	    logs: (0, _json2.default)((0, _get2.default)(gatewayDetails, 'Logs'), {})
	  };
	};
	
	exports.default = function () {};

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Routes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(279);
	
	var _pages = __webpack_require__(1700);
	
	var _Dashboard = __webpack_require__(1646);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Routes() {
	  return _react2.default.createElement(
	    _reactRouter.Switch,
	    null,
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/admin/', component: _Dashboard2.default }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/admin/app/dashboard/', component: _Dashboard2.default }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/admin/app/guest/dashboard/', component: _Dashboard2.default }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/admin/console/users', component: _pages.UserListPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/admin/console/organizations', component: _pages.OrganizationListPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/admin/console/organizations/add', component: _pages.OrganizationEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/admin/console/organizations/edit/:orgUuid', component: _pages.OrganizationEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/apis/add/', component: _pages.ApiEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/apis/edit/:apiUuid/', component: _pages.ApiEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/apis/edit/:apiUuid/:tabName', component: _pages.ApiEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/apis/permissions/:apiUuid', component: _pages.ApiEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/apis/permissions/:apiUuid/:tabName', component: _pages.ApiEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/applications/add/', component: _pages.ApplicationEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/applications/edit/:applicationUuid/', component: _pages.ApplicationEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/applications/details/:applicationUuid/', component: _pages.ApplicationDetailsPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/dev/applications/details/:applicationUuid/', component: _pages.ApplicationDetailsPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/applications/edit/:applicationUuid/:tabName', component: _pages.ApplicationEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/api-proxy/add/', component: _pages.ApiProxyEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/api-proxy/edit/:apiProxyUuid/', component: _pages.ApiProxyEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/gateway-bundles', component: _pages.GatewayBundleListPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/gateway-bundles/add', component: _pages.GatewayBundleEditPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/gateway-bundles/details/:bundleUuid', component: _pages.GatewayBundleDetailsPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/gateway-bundles/details/:bundleUuid/:tabName', component: _pages.GatewayBundleDetailsPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/api-proxy/details/:apiProxyUuid/', component: _pages.ProxyDetailsPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/publish/api-proxy/details/:apiProxyUuid/:tabName', component: _pages.ProxyDetailsPage }),
	    _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/404', component: _pages.PageNotFoundPage }),
	    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _pages.PageNotFoundPage })
	  );
	}

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.history = undefined;
	exports.default = configureStore;
	
	var _redux = __webpack_require__(293);
	
	var _reduxLogger = __webpack_require__(1753);
	
	var _reduxThunk = __webpack_require__(1754);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _connectedReactRouter = __webpack_require__(55);
	
	var _history = __webpack_require__(176);
	
	var _reducers = __webpack_require__(1704);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var history = exports.history = (0, _history.createBrowserHistory)();
	
	var loggerMiddleware = (0, _reduxLogger.createLogger)({
	  level: 'info',
	  collapsed: true
	});
	
	var isDevelopmentMode = ("production") !== 'production';
	
	function configureStore(initialState) {
	  var enableLogger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  // initialState = JSON.parse(window.localStorage.getItem('state')) || initialState;
	  var headerState = window.localStorage && window.localStorage.getItem('publish') && JSON.parse(window.localStorage.getItem('publish'));
	
	  var store = (0, _redux.createStore)((0, _reducers2.default)(history), initialState, _redux.compose.apply(undefined, [_redux.applyMiddleware.apply(undefined, [_reduxThunk2.default, (0, _connectedReactRouter.routerMiddleware)(history)].concat(_toConsumableArray(isDevelopmentMode && enableLogger ? [loggerMiddleware] : [])))].concat(_toConsumableArray(isDevelopmentMode && window.devToolsExtension ? [window.devToolsExtension()] : []))));
	
	  store.subscribe(function () {
	    var persist = {
	      services: headerState && headerState.services,
	      headerServices: headerState && headerState.headerServices,
	      headerSettings: headerState && headerState.headerSettings,
	      navigation: headerState && headerState.navigation,
	      headerNavigation: headerState && headerState.headerNavigation
	    };
	
	    if (window.localStorage) {
	      window.localStorage.setItem('state', JSON.stringify(persist));
	    }
	  });
	  return store;
	}

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(624);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _mapping = __webpack_require__(1711);
	
	var _mapping2 = _interopRequireDefault(_mapping);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var borderRadius = _constants2.default.borderRadius,
	    boxShadow = _constants2.default.boxShadow,
	    color = _constants2.default.color,
	    fontStyle = _constants2.default.fontStyle,
	    fontWeight = _constants2.default.fontWeight,
	    height = _constants2.default.height,
	    letterSpacing = _constants2.default.letterSpacing,
	    lineHeight = _constants2.default.lineHeight,
	    margin = _constants2.default.margin,
	    padding = _constants2.default.padding,
	    position = _constants2.default.position,
	    textTransform = _constants2.default.textTransform;
	
	// Material UI Components
	
	exports.default = function (_ref) {
	  var themes = _ref.themes;
	
	  var themeMapping = (0, _mapping2.default)({ themes: themes });
	  return (0, _lodash.merge)({}, themeMapping, {
	    palette: {
	      primary: {
	        light: '#000000',
	        main: '#ffffff',
	        contrastText: '#000000'
	      },
	      secondary: {
	        light: '#ffffff',
	        main: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	        contrastText: '#ffffff'
	      },
	      text: {
	        primary: (0, _lodash.get)(themes, 'color.primaryButtonText')
	      }
	    },
	    typography: Object.assign({}, themes.typography, {
	      fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	      fontSize: parseInt((0, _lodash.get)(themes, 'fontSize.bodyText'), 10),
	      body1: {
	        fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	        fontSize: parseInt((0, _lodash.get)(themes, 'fontSize.bodyText'), 10)
	      }
	    }),
	    props: {
	      MuiButtonBase: {
	        disableRipple: true /* Disable Ripple Effect */
	      }
	    },
	    overrides: {
	      MuiAutocomplete: {
	        input: {
	          color: (0, _lodash.get)(themes, 'color.bodyText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText')
	        },
	        listbox: {
	          color: (0, _lodash.get)(themes, 'color.bodyText')
	        }
	      },
	      MuiBackdrop: {
	        root: {
	          backgroundColor: themeMapping.color.overlayBackground
	        }
	      },
	      MuiButton: {
	        root: {
	          borderRadius: borderRadius.br3,
	          boxShadow: boxShadow.none + ' !important',
	          fontFamily: (0, _lodash.get)(themes, 'typography.buttonText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.buttonText'),
	          height: height.h40,
	          lineHeight: lineHeight.lh32,
	          padding: padding.p8 + ' ' + padding.p12,
	          textTransform: textTransform.none,
	          '&$disabled': {
	            backgroundColor: themeMapping.color.disabledBackground + ' !important',
	            border: '1px solid ' + themeMapping.color.disabledBackground + ' !important',
	            color: themeMapping.color.disabledText + ' !important'
	          }
	        },
	        // Secondary Button
	        outlinedPrimary: {
	          backgroundColor: (0, _lodash.get)(themes, 'color.primaryButtonText'),
	          border: '1px solid ' + (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          color: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          '&:hover': {
	            backgroundColor: themeMapping.color.secondaryButtonHover + ' !important',
	            borderColor: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	            color: (0, _lodash.get)(themes, 'color.primaryButtonBackground')
	          }
	        },
	        // Primary Button
	        containedSecondary: {
	          backgroundColor: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          border: '1px solid ' + (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          color: (0, _lodash.get)(themes, 'color.primaryButtonText'),
	          '&:hover': {
	            backgroundColor: (0, _lodash.get)(themes, 'color.primaryButtonHover'),
	            borderColor: (0, _lodash.get)(themes, 'color.primaryButtonHover'),
	            color: (0, _lodash.get)(themes, 'color.primaryButtonText')
	          }
	        },
	        textPrimary: {
	          color: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          '&:hover': {
	            color: (0, _lodash.get)(themes, 'color.primaryButtonBackground')
	          }
	        }
	      },
	      MuiDialogActions: {
	        root: {
	          padding: padding.p16 + ' ' + padding.p24
	        }
	      },
	      MuiFormLabel: {
	        root: {
	          color: (0, _lodash.get)(themes, 'color.bodyText'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText'),
	          fontWeight: fontWeight.semiBold,
	          lineHeight: lineHeight.lh21,
	          paddingLeft: 0,
	          float: 'left'
	        }
	      },
	      MuiIconButton: {
	        root: {
	          color: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          '&:hover': {
	            backgroundColor: 'transparent'
	          }
	        },
	        colorPrimary: {
	          '&:hover': {
	            backgroundColor: 'transparent'
	          }
	        },
	        colorSecondary: {
	          '&:hover': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      MuiInputBase: {
	        root: {
	          backgroundColor: (0, _lodash.get)(themes, 'color.uiBackground'),
	          borderRadius: borderRadius.br3,
	          color: (0, _lodash.get)(themes, 'color.bodyText'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText'),
	          '&:focus': {
	            outline: '1px solid ' + (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	            borderColor: (0, _lodash.get)(themes, 'color.primaryButtonBackground')
	          },
	          '&:hover': {
	            borderColor: (0, _lodash.get)(themes, 'color.primaryButtonHover')
	          }
	        }
	      },
	      MuiLink: {
	        root: {
	          color: (0, _lodash.get)(themes, 'color.link'),
	          fontWeight: fontWeight.bold
	        }
	      },
	      MuiListItem: {
	        root: {
	          paddingTop: 0,
	          paddingBottom: 0
	        },
	        button: {
	          '&:hover': {
	            backgroundColor: themeMapping.color.lightHover + ' !important'
	          }
	        }
	      },
	      MuiListItemText: {
	        dense: {
	          '& > span': {
	            fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText')
	          }
	        }
	      },
	      MuiMenuItem: {
	        root: {
	          color: (0, _lodash.get)(themes, 'color.bodyText'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText')
	        }
	      },
	      MuiPaginationItem: {
	        root: {
	          backgroundColor: (0, _lodash.get)(themes, 'color.uiBackground'),
	          color: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText')
	        }
	      },
	      MuiSelect: {
	        icon: {
	          color: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          right: margin.m5
	        }
	      },
	      MuiSvgIcon: {
	        colorPrimary: {
	          cursor: 'pointer',
	          color: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	          '&:hover': {
	            color: (0, _lodash.get)(themes, 'color.primaryButtonHover')
	          }
	        }
	      },
	      MuiTableCell: {
	        body: {
	          color: (0, _lodash.get)(themes, 'color.bodyText')
	        },
	        head: {
	          color: (0, _lodash.get)(themes, 'color.bodyText'),
	          fontWeight: fontWeight.bold,
	          lineHeight: lineHeight.lh21
	        },
	        root: {
	          backgroundColor: (0, _lodash.get)(themes, 'color.uiBackground'),
	          color: (0, _lodash.get)(themes, 'color.bodyText'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText'),
	          fontWeight: fontWeight.normal,
	          lineHeight: lineHeight.lh21,
	          padding: padding.p10 + ' ' + padding.p16,
	          minWidth: '120px',
	          verticalAlign: 'unset',
	          wordBreak: 'break-word'
	        },
	        sizeSmall: {
	          minWidth: 0,
	          padding: padding.p6 + ' ' + padding.p12
	        },
	        stickyHeader: {
	          backgroundColor: (0, _lodash.get)(themes, 'color.uiBackground')
	        }
	      },
	      MuiTooltip: {
	        arrow: {
	          color: color.tooltipBackground
	        },
	        tooltip: {
	          backgroundColor: color.tooltipBackground,
	          borderRadius: borderRadius.br3,
	          color: color.tooltipText,
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	          lineHeight: lineHeight.lh21,
	          padding: padding.p8 + ' ' + padding.p12,
	          margin: position.p3 + ' !important'
	        }
	      },
	      MuiTypography: {
	        root: {
	          color: (0, _lodash.get)(themes, 'color.bodyText'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.normal,
	          lineHeight: lineHeight.lh21
	        },
	        body1: {
	          color: (0, _lodash.get)(themes, 'color.bodyText'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.bodyText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.bodyText'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.normal,
	          lineHeight: lineHeight.lh21,
	          minHeight: lineHeight.lh21
	        },
	        body2: {
	          color: (0, _lodash.get)(themes, 'color.smallText'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.smallText'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.smallText'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.normal,
	          letterSpacing: letterSpacing.ls01,
	          lineHeight: lineHeight.lh14,
	          minHeight: lineHeight.lh14
	        },
	        colorError: {
	          color: (0, _lodash.get)(themes, 'color.error')
	        },
	        h1: {
	          color: (0, _lodash.get)(themes, 'color.pageTitle'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.pageTitle'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.pageTitle'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.bold,
	          lineHeight: lineHeight.lh48,
	          marginBottom: margin.m24,
	          marginTop: margin.m36,
	          minHeight: lineHeight.lh48,
	          textTransform: textTransform.none
	        },
	        h2: {
	          color: (0, _lodash.get)(themes, 'color.pageTitle'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.pageTitle'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.sectionTitle'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.bold,
	          lineHeight: lineHeight.lh36,
	          marginBottom: margin.m12,
	          marginTop: margin.m24,
	          minHeight: lineHeight.lh36,
	          textTransform: textTransform.none
	        },
	        h3: {
	          color: (0, _lodash.get)(themes, 'color.pageTitle'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.pageTitle'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.title'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.bold,
	          lineHeight: lineHeight.lh28,
	          marginBottom: margin.m12,
	          marginTop: margin.m24,
	          minHeight: lineHeight.lh28,
	          textTransform: textTransform.none
	        },
	        h4: {
	          color: (0, _lodash.get)(themes, 'color.pageTitle'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.pageTitle'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.smallTitle'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.bold,
	          lineHeight: lineHeight.lh28,
	          marginBottom: margin.m12,
	          marginTop: margin.m24,
	          minHeight: lineHeight.lh28,
	          textTransform: textTransform.none
	        },
	        h5: {
	          color: (0, _lodash.get)(themes, 'color.pageTitle'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.pageTitle'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.label'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.bold,
	          lineHeight: lineHeight.lh14,
	          marginBottom: 0,
	          marginTop: 0,
	          minHeight: lineHeight.lh14,
	          textTransform: textTransform.uppercase
	        },
	        h6: {
	          color: (0, _lodash.get)(themes, 'color.pageTitle'),
	          fontFamily: (0, _lodash.get)(themes, 'typography.pageTitle'),
	          fontSize: (0, _lodash.get)(themes, 'fontSize.smallLabel'),
	          fontStyle: fontStyle.normal,
	          fontWeight: fontWeight.bold,
	          lineHeight: lineHeight.lh14,
	          marginBottom: 0,
	          marginTop: 0,
	          minHeight: lineHeight.lh14,
	          textTransform: textTransform.uppercase
	        }
	      }
	    }
	  }, themes);
	};

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _constants = __webpack_require__(624);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _modifyColour = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var color = _constants2.default.color; /**
	                                        * Refer to:
	                                        * 1. https://www.figma.com/file/EuhA9sV3JzlTdZuVvbz2L7/Portal-Components?node-id=118%3A1002
	                                        */
	
	exports.default = function (_ref) {
	  var themes = _ref.themes;
	  return (0, _lodash.merge)({}, _constants2.default, {
	    color: Object.assign({}, color, {
	      confirmation: color.success,
	      enabled: color.success,
	
	      // Procedural
	      disabledBackground: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.bodyText'), 0.1),
	      disabledGraphic: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.bodyText'), 0.5),
	      disabledText: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.bodyText'), 0.7),
	      formBorder: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.primaryButtonBackground'), 0.4),
	      lightBackground: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.borderColor'), 0.1),
	      lightGrayBackground: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.borderColor'), 0.3),
	      lightHover: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.primaryButtonBackground'), 0.08),
	      overlayBackground: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.bodyText'), 0.6),
	
	      // Secondary Button (& Unselected Button in Group)
	      secondaryButtonHover: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.primaryButtonBackground'), 0.08),
	      primaryButtonDisabledBackground: (0, _modifyColour.modifyAlpha)((0, _lodash.get)(themes, 'color.bodyText'), 0.05),
	
	      // TODO:
	      // The below properties need to be re-evaluated and deprecated
	      accent: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	      accentLight: '#62C6E5',
	      accentDark: '#677B87',
	
	      title: '#20465F',
	      titleLight: '#2E4448',
	
	      black: '#000000',
	      white: '#FFFFFF',
	      gray: '#D8D8D8',
	      grayLight: '#F7F7F7',
	      grayDark: '#48575F',
	      grayColumnBackground: '#2C353A', // swagge
	      grayDarkBackground: '#222A2E',
	      darkGreyBackground: '#38364d',
	      pending: '#F79232',
	      red: '#FF0000',
	      orange: '#F79232',
	
	      // swagger colours
	      swaggerGreen: '#00A645',
	      swaggerRed: '#DB4332',
	      swaggerBlue: '#0168B7',
	      swaggerOrange: '#FCA130',
	
	      // custom icons
	      iconsMain: '#09AEEF',
	      iconsLight: '#62C6E5',
	      iconsGray: '#677B87',
	      iconsDark: '#408492',
	      iconsDarker: '#20465F',
	
	      // implementation color variables
	      overlay: 'rgba(255, 255, 255, 0.85)',
	
	      // default branding variables
	      background: '#F7F7F7',
	      borderColor: '#D8D8D8',
	
	      headerBackground: '#FFFFFF',
	      siteTitle: '#48575F',
	      headerLink: '#09AEEF',
	
	      pageTitle: '#48575F',
	
	      bodyText: '#48575F',
	      link: (0, _lodash.get)(themes, 'color.link'),
	      linkHover: 'rgba(9, 174, 239, .5)',
	      smallText: 'rgba(72, 87, 95, 0.5)',
	
	      primaryButtonBackground: (0, _lodash.get)(themes, 'color.primaryButtonBackground'),
	      primaryButtonText: (0, _lodash.get)(themes, 'color.primaryButtonText'),
	      primaryButtonHover: 'rgba(9, 174, 239, .5)',
	
	      dropdownOptionHover: '#F5FAFF',
	
	      footerBackground: '#48575F',
	      footerText: '#FFFFFF',
	      footerLink: '#09AEEF'
	    }),
	    misc: {
	      // header
	      headerHeight: 64,
	
	      // footer
	      footerHeight: 72,
	
	      // TODO:
	      // The below properties need to be re-evaluated and deprecated
	
	      // borders
	      borderRadiusLarge: 10,
	      borderRadiusMedium: 6,
	      borderRadiusSmall: 4,
	
	      // shadows
	      boxShadow: '1px 1px 10px rgba(0, 0, 0, 0.1)',
	
	      // buttons
	      buttonFontVerticalOffsetLg: 1,
	      buttonFontVerticalOffset: 1,
	      buttonFontVerticalOffsetSm: 1,
	      buttonFontVerticalOffsetXs: 0,
	
	      // responsive
	      breakpointLarge: 1280,
	      breakpointMedium: 992,
	      breakpointSmall: 600,
	      breakpointXSmall: 480,
	
	      // layout / grid
	      maxWidthLarge: 1177,
	      maxWidthMedium: 1154,
	      maxWidthSmall: 1154,
	
	      gutter: 20,
	      gridWidth: 1160,
	
	      // menu
	      menuHorizontalPadding: 20,
	
	      // modal
	      overlayZIndex: '80',
	
	      // transitions
	      colorTransition: 'color 250ms ease-in-out',
	      backgroundColorTransition: 'background-color 250ms ease-in-out',
	      borderColorTransition: 'border-color 250ms ease-in-out',
	      opacityTransition: 'opacity 250ms ease-in-out'
	    }
	  });
	};

/***/ },
/* 1712 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var jsonParseAsync = exports.jsonParseAsync = function jsonParseAsync(jsonString) {
	  return new Promise(function (resolve) {
	    setTimeout(function () {
	      resolve(JSON.parse(jsonString));
	    });
	  });
	};
	
	var jsonParse = function jsonParse(jsonString, exceptionValue) {
	  try {
	    return JSON.parse(jsonString);
	  } catch (e) {
	    return exceptionValue;
	  }
	};
	
	exports.default = jsonParse;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getApiStatusColor = exports.getApiStatusLabel = undefined;
	
	var _changeCase = __webpack_require__(116);
	
	var _constants = __webpack_require__(14);
	
	var Constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var getApiStatusLabel = exports.getApiStatusLabel = function getApiStatusLabel() {
	  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return status.toUpperCase() === Constants.API_STATUS_NEW ? 'Unpublished' : (0, _changeCase.sentenceCase)(status);
	};
	
	var getApiStatusColor = exports.getApiStatusColor = function getApiStatusColor() {
	  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var greenStates = [Constants.API_STATUS_ENABLED];
	  var grayStates = [Constants.API_STATUS_DISABLED];
	  var orangeStates = [Constants.API_STATUS_DEPRECATED];
	  var darkBlueStates = [Constants.API_STATUS_NEW];
	
	  var statusColor = '#d84332';
	  var apiStatus = status.toUpperCase();
	  if (greenStates.includes(apiStatus)) {
	    statusColor = '#59bb52';
	  } else if (orangeStates.includes(apiStatus)) {
	    statusColor = '#f7922f';
	  } else if (grayStates.includes(apiStatus)) {
	    statusColor = '#b3bdc2';
	  } else if (darkBlueStates.includes(apiStatus)) {
	    statusColor = '#20465f';
	  }
	  return statusColor;
	};

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _prettycron = __webpack_require__(1394);
	
	var _prettycron2 = _interopRequireDefault(_prettycron);
	
	var _later = __webpack_require__(404);
	
	var _later2 = _interopRequireDefault(_later);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _zeropad = __webpack_require__(1911);
	
	var _zeropad2 = _interopRequireDefault(_zeropad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberList = function numberList(numbers) {
	  var andString = 'and';
	  if (numbers.length < 2) {
	    return (0, _moment2.default)().localeData().ordinal(numbers);
	  }
	  var lastVal = numbers.pop();
	  return numbers.join(', ') + ' ' + andString + ' ' + (0, _moment2.default)().localeData().ordinal(lastVal);
	};
	
	var numberToDateName = function numberToDateName(value, type) {
	  if (type === 'dow') {
	    return (0, _moment2.default)().day(value - 1).format('ddd');
	  } else if (type === 'mon') {
	    return (0, _moment2.default)().month(value - 1).format('MMM');
	  }
	  return '';
	};
	
	var dateList = function dateList(numbers, type) {
	  var andString = 'and';
	
	  if (numbers.length < 2) {
	    return numberToDateName(numbers[0].toString(), type);
	  }
	
	  var lastVal = numbers.pop().toString();
	  var outputText = '';
	
	  for (var i = 0; i < numbers.length; i++) {
	    var value = numbers[i];
	    if (outputText.length > 0) {
	      outputText += ', ';
	    }
	    outputText += numberToDateName(value, type);
	  }
	  return outputText + andString + numberToDateName(lastVal, type);
	};
	
	var scheduleToSentence = function scheduleToSentence(schedule, cronspec) {
	  var acs = cronspec.split(' ');
	  var everyMonthString = 'every month';
	  var everyDayString = 'every day';
	  var everyHourString = 'every hour';
	  var ontheString = 'on the';
	  var hourOnTheHour = 'hour, on the hour';
	  var minutesOfString = 'minutes of';
	  var minutePastEveryHourString = 'minutes past every hour';
	  var minutePastString = 'minute past';
	  var minuteString = 'minute';
	  var hourString = 'hour';
	  var inString = 'in';
	  var onString = 'on';
	  var andEveryString = 'and every';
	  var andString = 'and';
	
	  var outputText = '';
	
	  if (schedule.h && schedule.m && schedule.h.length <= 2 && schedule.m.length <= 2) {
	    var hm = [];
	    for (var i = 0; i < schedule.h.length; i++) {
	      for (var j = 0; j < schedule.m.length; j++) {
	        hm.push((0, _zeropad2.default)(schedule.h[i]) + ':' + (0, _zeropad2.default)(schedule.m[j]));
	      }
	    }
	    if (hm.length < 2) {
	      outputText = hm[0];
	    } else {
	      var lastVal = hm.pop();
	      outputText = hm.join(', ') + ' ' + andString + ' ' + lastVal;
	    }
	    if (!schedule.d && !schedule.D) {
	      outputText += ' ' + everyDayString;
	    }
	  } else if (schedule.h) {
	    // runs only at specific hours
	    if (schedule.m) {
	      // and only at specific minutes
	      outputText += numberList(schedule.m) + ' ' + minutePastString + ' ' + numberList(schedule.h) + ' ' + hourString;
	    } else if (schedule.h.length === 24) {
	      outputText += everyHourString;
	    } else if (acs[2].match(/(\?|\*)\/[0-9]+$/) !== null) {
	      outputText += acs[2].replace(acs[2].match(/(\?|\*)\//)[0], '') + ' ' + everyHourString;
	    } else {
	      outputText += minutesOfString + ' ' + numberList(schedule.h) + ' ' + hourString;
	    }
	  } else if (schedule.m) {
	    // every hour, but specific minutes
	    if (schedule.m.length === 1 && schedule.m[0] === 0) {
	      // outputText += 'hour, on the hour';
	      outputText += hourOnTheHour;
	    } else if (schedule.m.length === 60) {
	      outputText += minuteString;
	    } else if (acs[1].match(/(\?|\*)\/[0-9]+$/) !== null) {
	      outputText += acs[1].replace(acs[1].match(/(\?|\*)\//)[0], '') + ' ' + minutePastEveryHourString;
	    } else {
	      outputText += numberList(schedule.m) + ' ' + minutePastEveryHourString;
	    }
	  } else {
	    // cronspec has "*" for both hour and minute
	    outputText += minuteString;
	  }
	
	  if (schedule.D) {
	    // runs only on specific day(s) of month
	    outputText += ' ' + ontheString + ' ' + numberList(schedule.D);
	    if (!schedule.M) {
	      outputText += ' ' + everyMonthString;
	    }
	  }
	
	  if (schedule.d) {
	    // runs only on specific day(s) of week
	    if (schedule.D) {
	      outputText += ' ' + andEveryString + ' ';
	    } else {
	      outputText += ' ' + onString + ' ';
	    }
	    outputText += dateList(schedule.d, 'dow');
	  }
	
	  if (schedule.M) {
	    outputText += ' ' + inString + '  ' + dateList(schedule.M, 'mon');
	  }
	  return outputText;
	};
	
	_prettycron2.default.toString = function (cronspec) {
	  var newCronText = cronspec[0] === ' ' ? cronspec.substring(1, cronspec.length) : cronspec;
	  var schedule = _later2.default.parse.cron(newCronText, 6);
	  return scheduleToSentence(schedule.schedules[0], newCronText);
	};
	
	exports.default = _prettycron2.default;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(626);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(626);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1717 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _Async = __webpack_require__(627);
	
	var _Creatable = __webpack_require__(628);
	
	var _stateManager = _interopRequireDefault(__webpack_require__(207));
	
	var _Select = _interopRequireDefault(__webpack_require__(206));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectCreatable = (0, _Creatable.makeCreatableSelect)(_Select.default);
	var SelectCreatableState = (0, _stateManager.default)(SelectCreatable);
	
	var _default = (0, _Async.makeAsyncSelect)(SelectCreatableState);
	
	exports.default = _default;

/***/ },
/* 1719 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resultsAriaMessage = exports.optionFocusAriaMessage = exports.valueFocusAriaMessage = exports.valueEventAriaMessage = exports.instructionsAriaMessage = void 0;
	
	var instructionsAriaMessage = function instructionsAriaMessage(event) {
	  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isSearchable = context.isSearchable,
	      isMulti = context.isMulti,
	      label = context.label,
	      isDisabled = context.isDisabled;
	
	  switch (event) {
	    case 'menu':
	      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");
	
	    case 'input':
	      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
	
	    case 'value':
	      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
	  }
	};
	
	exports.instructionsAriaMessage = instructionsAriaMessage;
	
	var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
	  var value = context.value,
	      isDisabled = context.isDisabled;
	  if (!value) return;
	
	  switch (event) {
	    case 'deselect-option':
	    case 'pop-value':
	    case 'remove-value':
	      return "option ".concat(value, ", deselected.");
	
	    case 'select-option':
	      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
	  }
	};
	
	exports.valueEventAriaMessage = valueEventAriaMessage;
	
	var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
	  var focusedValue = _ref.focusedValue,
	      getOptionLabel = _ref.getOptionLabel,
	      selectValue = _ref.selectValue;
	  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
	};
	
	exports.valueFocusAriaMessage = valueFocusAriaMessage;
	
	var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
	  var focusedOption = _ref2.focusedOption,
	      getOptionLabel = _ref2.getOptionLabel,
	      options = _ref2.options;
	  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
	};
	
	exports.optionFocusAriaMessage = optionFocusAriaMessage;
	
	var resultsAriaMessage = function resultsAriaMessage(_ref3) {
	  var inputValue = _ref3.inputValue,
	      screenReaderMessage = _ref3.screenReaderMessage;
	  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
	};
	
	exports.resultsAriaMessage = resultsAriaMessage;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// strip transition props off before spreading onto select component
	// note we need to be explicit about innerRef for flow
	var AnimatedInput = function AnimatedInput(WrappedComponent) {
	  return function (_ref) {
	    var inProp = _ref.in,
	        onExited = _ref.onExited,
	        appear = _ref.appear,
	        enter = _ref.enter,
	        exit = _ref.exit,
	        props = _objectWithoutProperties(_ref, ["in", "onExited", "appear", "enter", "exit"]);
	
	    return _react.default.createElement(WrappedComponent, props);
	  };
	};
	
	var _default = AnimatedInput;
	exports.default = _default;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// strip transition props off before spreading onto actual component
	var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
	  return function (_ref) {
	    var inProp = _ref.in,
	        onExited = _ref.onExited,
	        props = _objectWithoutProperties(_ref, ["in", "onExited"]);
	
	    return _react.default.createElement(_transitions.Collapse, {
	      in: inProp,
	      onExited: onExited
	    }, _react.default.createElement(WrappedComponent, _extends({
	      cropWithEllipsis: inProp
	    }, props)));
	  };
	};
	
	var _default = AnimatedMultiValue;
	exports.default = _default;

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// fade in when last multi-value removed, otherwise instant
	var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_transitions.Fade, _extends({
	      component: WrappedComponent,
	      duration: props.isMulti ? _transitions.collapseDuration : 1
	    }, props));
	  };
	};
	
	var _default = AnimatedPlaceholder;
	exports.default = _default;

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _transitions = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// instant fade; all transition-group children must be transitions
	var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_transitions.Fade, _extends({
	      component: WrappedComponent
	    }, props));
	  };
	};
	
	var _default = AnimatedSingleValue;
	exports.default = _default;

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(643);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// make ValueContainer a transition group
	var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
	  return function (props) {
	    return _react.default.createElement(_reactTransitionGroup.TransitionGroup, _extends({
	      component: WrappedComponent
	    }, props));
	  };
	};
	
	var _default = AnimatedValueContainer;
	exports.default = _default;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ValueContainer = exports.SingleValue = exports.Placeholder = exports.MultiValue = exports.Input = void 0;
	
	var _memoizeOne = _interopRequireDefault(__webpack_require__(454));
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(638));
	
	var _index = __webpack_require__(288);
	
	var _Input = _interopRequireDefault(__webpack_require__(1720));
	
	var _MultiValue = _interopRequireDefault(__webpack_require__(1721));
	
	var _Placeholder = _interopRequireDefault(__webpack_require__(1722));
	
	var _SingleValue = _interopRequireDefault(__webpack_require__(1723));
	
	var _ValueContainer = _interopRequireDefault(__webpack_require__(1724));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var makeAnimated = function makeAnimated() {
	  var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var components = (0, _index.defaultComponents)({
	    components: externalComponents
	  });
	
	  var Input = components.Input,
	      MultiValue = components.MultiValue,
	      Placeholder = components.Placeholder,
	      SingleValue = components.SingleValue,
	      ValueContainer = components.ValueContainer,
	      rest = _objectWithoutProperties(components, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);
	
	  return _objectSpread({
	    Input: (0, _Input.default)(Input),
	    MultiValue: (0, _MultiValue.default)(MultiValue),
	    Placeholder: (0, _Placeholder.default)(Placeholder),
	    SingleValue: (0, _SingleValue.default)(SingleValue),
	    ValueContainer: (0, _ValueContainer.default)(ValueContainer)
	  }, rest);
	};
	
	var AnimatedComponents = makeAnimated();
	var Input = AnimatedComponents.Input;
	exports.Input = Input;
	var MultiValue = AnimatedComponents.MultiValue;
	exports.MultiValue = MultiValue;
	var Placeholder = AnimatedComponents.Placeholder;
	exports.Placeholder = Placeholder;
	var SingleValue = AnimatedComponents.SingleValue;
	exports.SingleValue = SingleValue;
	var ValueContainer = AnimatedComponents.ValueContainer;
	exports.ValueContainer = ValueContainer;
	
	var _default = (0, _memoizeOne.default)(makeAnimated, _reactFastCompare.default);
	
	exports.default = _default;

/***/ },
/* 1726 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isOptionDisabled = exports.getOptionValue = exports.getOptionLabel = exports.formatGroupLabel = void 0;
	
	var formatGroupLabel = function formatGroupLabel(group) {
	  return group.label;
	};
	
	exports.formatGroupLabel = formatGroupLabel;
	
	var getOptionLabel = function getOptionLabel(option) {
	  return option.label;
	};
	
	exports.getOptionLabel = getOptionLabel;
	
	var getOptionValue = function getOptionValue(option) {
	  return option.value;
	};
	
	exports.getOptionValue = getOptionValue;
	
	var isOptionDisabled = function isOptionDisabled(option) {
	  return !!option.isDisabled;
	};
	
	exports.isOptionDisabled = isOptionDisabled;

/***/ },
/* 1727 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripDiacritics = void 0;
	var diacritics = [{
	  base: 'A',
	  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
	}, {
	  base: 'AA',
	  letters: /[\uA732]/g
	}, {
	  base: 'AE',
	  letters: /[\u00C6\u01FC\u01E2]/g
	}, {
	  base: 'AO',
	  letters: /[\uA734]/g
	}, {
	  base: 'AU',
	  letters: /[\uA736]/g
	}, {
	  base: 'AV',
	  letters: /[\uA738\uA73A]/g
	}, {
	  base: 'AY',
	  letters: /[\uA73C]/g
	}, {
	  base: 'B',
	  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
	}, {
	  base: 'C',
	  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
	}, {
	  base: 'D',
	  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
	}, {
	  base: 'DZ',
	  letters: /[\u01F1\u01C4]/g
	}, {
	  base: 'Dz',
	  letters: /[\u01F2\u01C5]/g
	}, {
	  base: 'E',
	  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
	}, {
	  base: 'F',
	  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
	}, {
	  base: 'G',
	  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
	}, {
	  base: 'H',
	  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
	}, {
	  base: 'I',
	  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
	}, {
	  base: 'J',
	  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
	}, {
	  base: 'K',
	  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
	}, {
	  base: 'L',
	  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
	}, {
	  base: 'LJ',
	  letters: /[\u01C7]/g
	}, {
	  base: 'Lj',
	  letters: /[\u01C8]/g
	}, {
	  base: 'M',
	  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
	}, {
	  base: 'N',
	  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
	}, {
	  base: 'NJ',
	  letters: /[\u01CA]/g
	}, {
	  base: 'Nj',
	  letters: /[\u01CB]/g
	}, {
	  base: 'O',
	  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
	}, {
	  base: 'OI',
	  letters: /[\u01A2]/g
	}, {
	  base: 'OO',
	  letters: /[\uA74E]/g
	}, {
	  base: 'OU',
	  letters: /[\u0222]/g
	}, {
	  base: 'P',
	  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
	}, {
	  base: 'Q',
	  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
	}, {
	  base: 'R',
	  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
	}, {
	  base: 'S',
	  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
	}, {
	  base: 'T',
	  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
	}, {
	  base: 'TZ',
	  letters: /[\uA728]/g
	}, {
	  base: 'U',
	  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
	}, {
	  base: 'V',
	  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
	}, {
	  base: 'VY',
	  letters: /[\uA760]/g
	}, {
	  base: 'W',
	  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
	}, {
	  base: 'X',
	  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
	}, {
	  base: 'Y',
	  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
	}, {
	  base: 'Z',
	  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
	}, {
	  base: 'a',
	  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
	}, {
	  base: 'aa',
	  letters: /[\uA733]/g
	}, {
	  base: 'ae',
	  letters: /[\u00E6\u01FD\u01E3]/g
	}, {
	  base: 'ao',
	  letters: /[\uA735]/g
	}, {
	  base: 'au',
	  letters: /[\uA737]/g
	}, {
	  base: 'av',
	  letters: /[\uA739\uA73B]/g
	}, {
	  base: 'ay',
	  letters: /[\uA73D]/g
	}, {
	  base: 'b',
	  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
	}, {
	  base: 'c',
	  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
	}, {
	  base: 'd',
	  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
	}, {
	  base: 'dz',
	  letters: /[\u01F3\u01C6]/g
	}, {
	  base: 'e',
	  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
	}, {
	  base: 'f',
	  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
	}, {
	  base: 'g',
	  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
	}, {
	  base: 'h',
	  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
	}, {
	  base: 'hv',
	  letters: /[\u0195]/g
	}, {
	  base: 'i',
	  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
	}, {
	  base: 'j',
	  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
	}, {
	  base: 'k',
	  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
	}, {
	  base: 'l',
	  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
	}, {
	  base: 'lj',
	  letters: /[\u01C9]/g
	}, {
	  base: 'm',
	  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
	}, {
	  base: 'n',
	  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
	}, {
	  base: 'nj',
	  letters: /[\u01CC]/g
	}, {
	  base: 'o',
	  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
	}, {
	  base: 'oi',
	  letters: /[\u01A3]/g
	}, {
	  base: 'ou',
	  letters: /[\u0223]/g
	}, {
	  base: 'oo',
	  letters: /[\uA74F]/g
	}, {
	  base: 'p',
	  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
	}, {
	  base: 'q',
	  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
	}, {
	  base: 'r',
	  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
	}, {
	  base: 's',
	  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
	}, {
	  base: 't',
	  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
	}, {
	  base: 'tz',
	  letters: /[\uA729]/g
	}, {
	  base: 'u',
	  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
	}, {
	  base: 'v',
	  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
	}, {
	  base: 'vy',
	  letters: /[\uA761]/g
	}, {
	  base: 'w',
	  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
	}, {
	  base: 'x',
	  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
	}, {
	  base: 'y',
	  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
	}, {
	  base: 'z',
	  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
	}];
	
	var stripDiacritics = function stripDiacritics(str) {
	  for (var i = 0; i < diacritics.length; i++) {
	    str = str.replace(diacritics[i].letters, diacritics[i].base);
	  }
	
	  return str;
	};
	
	exports.stripDiacritics = stripDiacritics;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "SelectBase", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Async", {
	  enumerable: true,
	  get: function get() {
	    return _Async.default;
	  }
	});
	Object.defineProperty(exports, "makeAsyncSelect", {
	  enumerable: true,
	  get: function get() {
	    return _Async.makeAsyncSelect;
	  }
	});
	Object.defineProperty(exports, "AsyncCreatable", {
	  enumerable: true,
	  get: function get() {
	    return _AsyncCreatable.default;
	  }
	});
	Object.defineProperty(exports, "Creatable", {
	  enumerable: true,
	  get: function get() {
	    return _Creatable.default;
	  }
	});
	Object.defineProperty(exports, "makeCreatableSelect", {
	  enumerable: true,
	  get: function get() {
	    return _Creatable.makeCreatableSelect;
	  }
	});
	Object.defineProperty(exports, "createFilter", {
	  enumerable: true,
	  get: function get() {
	    return _filters.createFilter;
	  }
	});
	Object.defineProperty(exports, "makeAnimated", {
	  enumerable: true,
	  get: function get() {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "components", {
	  enumerable: true,
	  get: function get() {
	    return _index2.components;
	  }
	});
	Object.defineProperty(exports, "mergeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _styles.mergeStyles;
	  }
	});
	Object.defineProperty(exports, "defaultTheme", {
	  enumerable: true,
	  get: function get() {
	    return _theme.defaultTheme;
	  }
	});
	exports.default = void 0;
	
	var _Select = _interopRequireDefault(__webpack_require__(206));
	
	var _stateManager = _interopRequireDefault(__webpack_require__(207));
	
	var _Async = _interopRequireWildcard(__webpack_require__(627));
	
	var _AsyncCreatable = _interopRequireDefault(__webpack_require__(1718));
	
	var _Creatable = _interopRequireWildcard(__webpack_require__(628));
	
	var _filters = __webpack_require__(637);
	
	var _index = _interopRequireDefault(__webpack_require__(1725));
	
	var _index2 = __webpack_require__(288);
	
	var _styles = __webpack_require__(639);
	
	var _theme = __webpack_require__(640);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _stateManager.default)(_Select.default);
	
	exports.default = _default;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// Assistive text to describe visual elements. Hidden for sighted users.
	var A11yText = function A11yText(props) {
	  return _react.default.createElement("span", _extends({
	    className:
	    /*#__PURE__*/
	
	    /*#__PURE__*/
	    (0, _emotion.css)({
	      label: 'a11yText',
	      zIndex: 9999,
	      border: 0,
	      clip: 'rect(1px, 1px, 1px, 1px)',
	      height: 1,
	      width: 1,
	      position: 'absolute',
	      overflow: 'hidden',
	      padding: 0,
	      whiteSpace: 'nowrap',
	      backgroundColor: 'red',
	      color: 'blue'
	    })
	  }, props));
	};
	
	var _default = A11yText;
	exports.default = _default;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DummyInput =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DummyInput, _Component);
	
	  function DummyInput() {
	    _classCallCheck(this, DummyInput);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
	  }
	
	  _createClass(DummyInput, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          inProp = _this$props.in,
	          out = _this$props.out,
	          onExited = _this$props.onExited,
	          appear = _this$props.appear,
	          enter = _this$props.enter,
	          exit = _this$props.exit,
	          innerRef = _this$props.innerRef,
	          emotion = _this$props.emotion,
	          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
	
	      return _react.default.createElement("input", _extends({
	        ref: innerRef
	      }, props, {
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)({
	          label: 'dummyInput',
	          // get rid of any default styles
	          background: 0,
	          border: 0,
	          fontSize: 'inherit',
	          outline: 0,
	          padding: 0,
	          // important! without `width` browsers won't allow focus
	          width: 1,
	          // remove cursor on desktop
	          color: 'transparent',
	          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
	          left: -100,
	          opacity: 0,
	          position: 'relative',
	          transform: 'scale(0)'
	        })
	      }));
	    }
	  }]);
	
	  return DummyInput;
	}(_react.Component);
	
	exports.default = DummyInput;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _emotion = __webpack_require__(54);
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(290));
	
	var _index = _interopRequireDefault(__webpack_require__(1734));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// NOTE:
	// We shouldn't need this after updating to React v16.3.0, which introduces:
	// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
	// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
	var ScrollBlock =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ScrollBlock, _PureComponent);
	
	  function ScrollBlock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollBlock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      touchScrollTarget: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      if (ref === _this.state.touchScrollTarget) return;
	
	      _this.setState({
	        touchScrollTarget: ref
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollBlock, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          isEnabled = _this$props.isEnabled;
	      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
	
	      if (!isEnabled) return children;
	      /*
	       * Div
	       * ------------------------------
	       * blocks scrolling on non-body elements behind the menu
	        * NodeResolver
	       * ------------------------------
	       * we need a reference to the scrollable element to "unlock" scroll on
	       * mobile devices
	        * ScrollLock
	       * ------------------------------
	       * actually does the scroll locking
	       */
	
	      return _react.default.createElement("div", null, _react.default.createElement("div", {
	        onClick: this.blurSelectInput,
	        className:
	        /*#__PURE__*/
	
	        /*#__PURE__*/
	        (0, _emotion.css)({
	          position: 'fixed',
	          left: 0,
	          bottom: 0,
	          right: 0,
	          top: 0
	        })
	      }), _react.default.createElement(_NodeResolver.default, {
	        innerRef: this.getScrollTarget
	      }, children), touchScrollTarget ? _react.default.createElement(_index.default, {
	        touchScrollTarget: touchScrollTarget
	      }) : null);
	    }
	  }]);
	
	  return ScrollBlock;
	}(_react.PureComponent);
	
	exports.default = ScrollBlock;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(290));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ScrollCaptor =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollCaptor, _Component);
	
	  function ScrollCaptor() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollCaptor);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
	      var _this$props = _this.props,
	          onBottomArrive = _this$props.onBottomArrive,
	          onBottomLeave = _this$props.onBottomLeave,
	          onTopArrive = _this$props.onTopArrive,
	          onTopLeave = _this$props.onTopLeave;
	      var _this$scrollTarget = _this.scrollTarget,
	          scrollTop = _this$scrollTarget.scrollTop,
	          scrollHeight = _this$scrollTarget.scrollHeight,
	          clientHeight = _this$scrollTarget.clientHeight;
	      var target = _this.scrollTarget;
	      var isDeltaPositive = delta > 0;
	      var availableScroll = scrollHeight - clientHeight - scrollTop;
	      var shouldCancelScroll = false; // reset bottom/top flags
	
	      if (availableScroll > delta && _this.isBottom) {
	        if (onBottomLeave) onBottomLeave(event);
	        _this.isBottom = false;
	      }
	
	      if (isDeltaPositive && _this.isTop) {
	        if (onTopLeave) onTopLeave(event);
	        _this.isTop = false;
	      } // bottom limit
	
	
	      if (isDeltaPositive && delta > availableScroll) {
	        if (onBottomArrive && !_this.isBottom) {
	          onBottomArrive(event);
	        }
	
	        target.scrollTop = scrollHeight;
	        shouldCancelScroll = true;
	        _this.isBottom = true; // top limit
	      } else if (!isDeltaPositive && -delta > scrollTop) {
	        if (onTopArrive && !_this.isTop) {
	          onTopArrive(event);
	        }
	
	        target.scrollTop = 0;
	        shouldCancelScroll = true;
	        _this.isTop = true;
	      } // cancel scroll
	
	
	      if (shouldCancelScroll) {
	        _this.cancelScroll(event);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
	      _this.handleEventDelta(event, event.deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
	      // set touch start so we can calculate touchmove delta
	      _this.touchStart = event.changedTouches[0].clientY;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
	      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
	
	      _this.handleEventDelta(event, deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      _this.scrollTarget = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollCaptor, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListening(this.scrollTarget);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListening(this.scrollTarget);
	    }
	  }, {
	    key: "startListening",
	    value: function startListening(el) {
	      // bail early if no scroll available
	      if (!el) return;
	      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "stopListening",
	    value: function stopListening(el) {
	      // bail early if no scroll available
	      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react.default.createElement(_NodeResolver.default, {
	        innerRef: this.getScrollTarget
	      }, this.props.children);
	    }
	  }]);
	
	  return ScrollCaptor;
	}(_react.Component);
	
	var ScrollCaptorSwitch =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(ScrollCaptorSwitch, _Component2);
	
	  function ScrollCaptorSwitch() {
	    _classCallCheck(this, ScrollCaptorSwitch);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
	  }
	
	  _createClass(ScrollCaptorSwitch, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          isEnabled = _this$props2.isEnabled,
	          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);
	
	      return isEnabled ? _react.default.createElement(ScrollCaptor, props) : this.props.children;
	    }
	  }]);
	
	  return ScrollCaptorSwitch;
	}(_react.Component);
	
	exports.default = ScrollCaptorSwitch;
	
	_defineProperty(ScrollCaptorSwitch, "defaultProps", {
	  isEnabled: true
	});

/***/ },
/* 1733 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LOCK_STYLES = exports.STYLE_KEYS = void 0;
	var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
	exports.STYLE_KEYS = STYLE_KEYS;
	var LOCK_STYLES = {
	  boxSizing: 'border-box',
	  // account for possible declaration `width: 100%;` on body
	  overflow: 'hidden',
	  position: 'relative',
	  height: '100%'
	};
	exports.LOCK_STYLES = LOCK_STYLES;

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(1733);
	
	var _utils = __webpack_require__(1735);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var activeScrollLocks = 0;
	
	var ScrollLock =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollLock, _Component);
	
	  function ScrollLock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
	      capture: false,
	      passive: false
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollLock, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!canUseDOM) return;
	      var _this$props = this.props,
	          accountForScrollbars = _this$props.accountForScrollbars,
	          touchScrollTarget = _this$props.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style;
	
	      if (accountForScrollbars) {
	        // store any styles already applied to the body
	        _constants.STYLE_KEYS.forEach(function (key) {
	          var val = targetStyle && targetStyle[key];
	          _this2.originalStyles[key] = val;
	        });
	      } // apply the lock styles and padding if this is the first scroll lock
	
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
	        var clientWidth = document.body ? document.body.clientWidth : 0;
	        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	        Object.keys(_constants.LOCK_STYLES).forEach(function (key) {
	          var val = _constants.LOCK_STYLES[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	
	        if (targetStyle) {
	          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
	        }
	      } // account for touch devices
	
	
	      if (target && (0, _utils.isTouchDevice)()) {
	        // Mobile Safari ignores { overflow: hidden } declaration on the body.
	        target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions); // Allow scroll on provided target
	
	        if (touchScrollTarget) {
	          touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	        }
	      } // increment active scroll locks
	
	
	      activeScrollLocks += 1;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (!canUseDOM) return;
	      var _this$props2 = this.props,
	          accountForScrollbars = _this$props2.accountForScrollbars,
	          touchScrollTarget = _this$props2.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style; // safely decrement active scroll locks
	
	      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        _constants.STYLE_KEYS.forEach(function (key) {
	          var val = _this3.originalStyles[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	      } // remove touch listeners
	
	
	      if (target && (0, _utils.isTouchDevice)()) {
	        target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	        if (touchScrollTarget) {
	          touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.Component);
	
	exports.default = ScrollLock;
	
	_defineProperty(ScrollLock, "defaultProps", {
	  accountForScrollbars: true
	});

/***/ },
/* 1735 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventTouchMove = preventTouchMove;
	exports.allowTouchMove = allowTouchMove;
	exports.preventInertiaScroll = preventInertiaScroll;
	exports.isTouchDevice = isTouchDevice;
	
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	} // `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	
	
	function isTouchDevice() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "A11yText", {
	  enumerable: true,
	  get: function get() {
	    return _A11yText.default;
	  }
	});
	Object.defineProperty(exports, "DummyInput", {
	  enumerable: true,
	  get: function get() {
	    return _DummyInput.default;
	  }
	});
	Object.defineProperty(exports, "NodeResolver", {
	  enumerable: true,
	  get: function get() {
	    return _NodeResolver.default;
	  }
	});
	Object.defineProperty(exports, "ScrollBlock", {
	  enumerable: true,
	  get: function get() {
	    return _ScrollBlock.default;
	  }
	});
	Object.defineProperty(exports, "ScrollCaptor", {
	  enumerable: true,
	  get: function get() {
	    return _ScrollCaptor.default;
	  }
	});
	
	var _A11yText = _interopRequireDefault(__webpack_require__(1729));
	
	var _DummyInput = _interopRequireDefault(__webpack_require__(1730));
	
	var _NodeResolver = _interopRequireDefault(__webpack_require__(290));
	
	var _ScrollBlock = _interopRequireDefault(__webpack_require__(1731));
	
	var _ScrollCaptor = _interopRequireDefault(__webpack_require__(1732));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1738));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1738 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1739 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 1740 */
[1912, 1741],
/* 1741 */
918,
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(124));
	
	var _addClass = _interopRequireDefault(__webpack_require__(1737));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1739));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(641));
	
	var _PropTypes = __webpack_require__(644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(124));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(32);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(642));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(126));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(394));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(395));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(291));
	
	var _PropTypes = __webpack_require__(647);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
	 * use it if you're using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**, so it's
	 * important to add `transition` declaration only to them, otherwise transitions
	 * might not behave as intended! This might not be obvious when the transitions
	 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
	 * the example above (minus `transition`), but it becomes apparent in more
	 * complex transitions.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument[0],
	          appearing = _this$resolveArgument[1];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntering = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument2[0],
	          appearing = _this$resolveArgument2[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntered = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument3[0],
	          appearing = _this$resolveArgument3[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onExit = function (maybeNode) {
	      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument4[0];
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(maybeNode);
	      }
	    };
	
	    _this.onExiting = function (maybeNode) {
	      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument5[0];
	
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(maybeNode);
	      }
	    };
	
	    _this.onExited = function (maybeNode) {
	      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument6[0];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(maybeNode);
	      }
	    };
	
	    _this.resolveArguments = function (maybeNode, maybeAppearing) {
	      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
	      : [maybeNode, maybeAppearing];
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    var _this$getClassNames = this.getClassNames('enter'),
	        doneClassName = _this$getClassNames.doneClassName;
	
	    if (type === 'appear' && phase === 'done' && doneClassName) {
	      className += " " + doneClassName;
	    } // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	    }
	
	    if (className) {
	      this.appliedClasses[type][phase] = className;
	
	      _addClass(node, className);
	    }
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided, which
	   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
	   *
	   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
	   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
	   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
	   *
	   * A few details to note about how these classes are applied:
	   *
	   * 1. They are _joined_ with the ones that are already defined on the child
	   *    component, so if you want to add some base styles, you can use
	   *    `className` without worrying that it will be overridden.
	   *
	   * 2. If the transition component mounts with `in={false}`, no classes are
	   *    applied yet. You might be expecting `*-exit-done`, but if you think
	   *    about it, a component cannot finish exiting if it hasn't entered yet.
	   *
	   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
	   *    allows you to define different behavior for when appearing is done and
	   *    when regular entering is done, using selectors like
	   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
	   *    an epic entrance animation when element first appears in the DOM using
	   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   *    simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(126));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(32));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(645));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	
	    if (this.props[handler]) {
	      var maybeNode = child.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this);
	      this.props[handler](maybeNode);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1747 */
[1914, 126, 291, 292],
/* 1748 */
985,
/* 1749 */
[1912, 1750],
/* 1750 */
918,
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.9.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(195),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
	60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");var z="function"===typeof Symbol&&Symbol.iterator;
	function A(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
	function D(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}var G=F.prototype=new E;
	G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:k,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){e=a[k];var f=b+T(e,k);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,k++),g+=S(e,f,d,c);else if("object"===e)throw d=""+a,A(Error(31),"[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,"");return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,d){if(null===a||void 0===a)throw A(Error(267),a);var c=void 0,e=
	h({},a.props),g=a.key,k=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:k,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);
	b.type=a;return b},isValidElement:N,version:"16.9.0",unstable_withSuspenseConfig:function(a,b){var d=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=d}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 1752 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1754 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1756 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1756);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 1758 */
/***/ function(module, exports) {

	/** @license React v0.15.0
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=void 0,e=void 0,g=void 0,m=void 0,n=void 0;exports.unstable_now=void 0;exports.unstable_forceFrameRate=void 0;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,r=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(r,0),b;}};exports.unstable_now=function(){return Date.now()};d=function(a){null!==p?setTimeout(d,0,a):(p=a,setTimeout(r,0))};e=function(a,b){q=setTimeout(a,b)};g=function(){clearTimeout(q)};m=function(){return!1};n=exports.unstable_forceFrameRate=function(){}}else{var t=window.performance,u=window.Date,v=window.setTimeout,
	w=window.clearTimeout,x=window.requestAnimationFrame,y=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof x&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof y&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));exports.unstable_now="object"===typeof t&&
	"function"===typeof t.now?function(){return t.now()}:function(){return u.now()};var z=!1,A=null,B=-1,C=-1,D=33.33,E=-1,F=-1,G=0,H=!1;m=function(){return exports.unstable_now()>=G};n=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):0<a?(D=Math.floor(1E3/a),H=!0):(D=33.33,H=!1)};var J=function(){if(null!==A){var a=exports.unstable_now(),b=0<G-a;try{A(b,
	a)||(A=null)}catch(c){throw I.postMessage(null),c;}}},K=new MessageChannel,I=K.port2;K.port1.onmessage=J;var L=function(a){if(null===A)F=E=-1,z=!1;else{z=!0;x(function(a){w(B);L(a)});var b=function(){G=exports.unstable_now()+D/2;J();B=v(b,3*D)};B=v(b,3*D);if(-1!==E&&.1<a-E){var c=a-E;!H&&-1!==F&&c<D&&F<D&&(D=c<F?F:c,8.33>D&&(D=8.33));F=c}E=a;G=a+D;I.postMessage(null)}};d=function(a){A=a;z||(z=!0,x(function(a){L(a)}))};e=function(a,b){C=v(function(){a(exports.unstable_now())},b)};g=function(){w(C);
	C=-1}}var M=null,N=null,O=null,P=3,Q=!1,R=!1,S=!1;
	function T(a,b){var c=a.next;if(c===a)M=null;else{a===M&&(M=c);var f=a.previous;f.next=c;c.previous=f}a.next=a.previous=null;c=a.callback;f=P;var l=O;P=a.priorityLevel;O=a;try{var h=a.expirationTime<=b;switch(P){case 1:var k=c(h);break;case 2:k=c(h);break;case 3:k=c(h);break;case 4:k=c(h);break;case 5:k=c(h)}}catch(Z){throw Z;}finally{P=f,O=l}if("function"===typeof k)if(b=a.expirationTime,a.callback=k,null===M)M=a.next=a.previous=a;else{k=null;h=M;do{if(b<=h.expirationTime){k=h;break}h=h.next}while(h!==
	M);null===k?k=M:k===M&&(M=a);b=k.previous;b.next=k.previous=a;a.next=k;a.previous=b}}function U(a){if(null!==N&&N.startTime<=a){do{var b=N,c=b.next;if(b===c)N=null;else{N=c;var f=b.previous;f.next=c;c.previous=f}b.next=b.previous=null;V(b,b.expirationTime)}while(null!==N&&N.startTime<=a)}}function W(a){S=!1;U(a);R||(null!==M?(R=!0,d(X)):null!==N&&e(W,N.startTime-a))}
	function X(a,b){R=!1;S&&(S=!1,g());U(b);Q=!0;try{if(!a)for(;null!==M&&M.expirationTime<=b;)T(M,b),b=exports.unstable_now(),U(b);else if(null!==M){do T(M,b),b=exports.unstable_now(),U(b);while(null!==M&&!m())}if(null!==M)return!0;null!==N&&e(W,N.startTime-b);return!1}finally{Q=!1}}function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}
	function V(a,b){if(null===M)M=a.next=a.previous=a;else{var c=null,f=M;do{if(b<f.expirationTime){c=f;break}f=f.next}while(f!==M);null===c?c=M:c===M&&(M=a);b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}}var aa=n;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var f=exports.unstable_now();if("object"===typeof c&&null!==c){var l=c.delay;l="number"===typeof l&&0<l?f+l:f;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),l=f;c=l+c;a={callback:b,priorityLevel:a,startTime:l,expirationTime:c,next:null,previous:null};if(l>f){c=l;if(null===N)N=a.next=a.previous=a;else{b=null;var h=N;do{if(c<h.startTime){b=h;break}h=h.next}while(h!==N);null===b?b=N:b===N&&(N=a);c=b.previous;c.next=b.previous=a;a.next=b;a.previous=
	c}null===M&&N===a&&(S?g():S=!0,e(W,l-f))}else V(a,c),R||Q||(R=!0,d(X));return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(a===b)a===M?M=null:a===N&&(N=null);else{a===M?M=b:a===N&&(N=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};exports.unstable_getCurrentPriorityLevel=function(){return P};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();U(a);return null!==O&&null!==M&&M.startTime<=a&&M.expirationTime<O.expirationTime||m()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){R||Q||(R=!0,d(X))};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M};


/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1758);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sentenceCase = exports.sentenceCaseTransform = void 0;
	var tslib_1 = __webpack_require__(1761);
	var no_case_1 = __webpack_require__(120);
	var upper_case_first_1 = __webpack_require__(650);
	function sentenceCaseTransform(input, index) {
	    var result = input.toLowerCase();
	    if (index === 0)
	        return upper_case_first_1.upperCaseFirst(result);
	    return result;
	}
	exports.sentenceCaseTransform = sentenceCaseTransform;
	function sentenceCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return no_case_1.noCase(input, tslib_1.__assign({ delimiter: " ", transform: sentenceCaseTransform }, options));
	}
	exports.sentenceCase = sentenceCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1761 */
1199,
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArrayish = __webpack_require__(1250);
	
	var concat = Array.prototype.concat;
	var slice = Array.prototype.slice;
	
	var swizzle = module.exports = function swizzle(args) {
		var results = [];
	
		for (var i = 0, len = args.length; i < len; i++) {
			var arg = args[i];
	
			if (isArrayish(arg)) {
				// http://jsperf.com/javascript-array-concat-vs-push/98
				results = concat.call(results, slice.call(arg));
			} else {
				results.push(arg);
			}
		}
	
		return results;
	};
	
	swizzle.wrap = function (fn) {
		return function () {
			return fn(swizzle(arguments));
		};
	};


/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.snakeCase = void 0;
	var tslib_1 = __webpack_require__(1764);
	var dot_case_1 = __webpack_require__(175);
	function snakeCase(input, options) {
	    if (options === void 0) { options = {}; }
	    return dot_case_1.dotCase(input, tslib_1.__assign({ delimiter: "_" }, options));
	}
	exports.snakeCase = snakeCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1764 */
1199,
/* 1765 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(1246);
	
	/**
	 * Parses inline style to object.
	 *
	 * @example
	 * // returns { 'line-height': '42' }
	 * StyleToObject('line-height: 42;');
	 *
	 * @param  {String}      style      - The inline style.
	 * @param  {Function}    [iterator] - The iterator function.
	 * @return {null|Object}
	 */
	function StyleToObject(style, iterator) {
	  var output = null;
	  if (!style || typeof style !== 'string') {
	    return output;
	  }
	
	  var declaration;
	  var declarations = parse(style);
	  var hasIterator = typeof iterator === 'function';
	  var property;
	  var value;
	
	  for (var i = 0, len = declarations.length; i < len; i++) {
	    declaration = declarations[i];
	    property = declaration.property;
	    value = declaration.value;
	
	    if (hasIterator) {
	      iterator(property, value, declaration);
	    } else if (value) {
	      output || (output = {});
	      output[property] = value;
	    }
	  }
	
	  return output;
	}
	
	module.exports = StyleToObject;


/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ },
/* 1768 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1769 */
/***/ function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1771 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.upperCase = exports.localeUpperCase = void 0;
	/**
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 */
	var SUPPORTED_LOCALE = {
	    tr: {
	        regexp: /[\u0069]/g,
	        map: {
	            i: "\u0130",
	        },
	    },
	    az: {
	        regexp: /[\u0069]/g,
	        map: {
	            i: "\u0130",
	        },
	    },
	    lt: {
	        regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
	        map: {
	            i̇: "\u0049",
	            j̇: "\u004A",
	            į̇: "\u012E",
	            i̇̀: "\u00CC",
	            i̇́: "\u00CD",
	            i̇̃: "\u0128",
	        },
	    },
	};
	/**
	 * Localized upper case.
	 */
	function localeUpperCase(str, locale) {
	    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
	    if (lang)
	        return upperCase(str.replace(lang.regexp, function (m) { return lang.map[m]; }));
	    return upperCase(str);
	}
	exports.localeUpperCase = localeUpperCase;
	/**
	 * Upper case as a function.
	 */
	function upperCase(str) {
	    return str.toUpperCase();
	}
	exports.upperCase = upperCase;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	/*! https://mths.be/utf8js v3.0.0 by @mathias */
	;(function(root) {
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		function checkScalarValue(codePoint) {
			if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
		}
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				checkScalarValue(codePoint);
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function utf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read first byte
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					checkScalarValue(codePoint);
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid UTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function utf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		root.version = '3.0.0';
		root.encode = utf8encode;
		root.decode = utf8decode;
	
	}( false ? this.utf8 = {} : exports));


/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _toString = _interopRequireDefault(__webpack_require__(662));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function contains(str, elem) {
	  (0, _assertString.default)(str);
	  return str.indexOf((0, _toString.default)(elem)) >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equals;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equals(str, comparison) {
	  (0, _assertString.default)(str);
	  return str === comparison;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = escape;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escape(str) {
	  (0, _assertString.default)(str);
	  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _toDate = _interopRequireDefault(__webpack_require__(295));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAfter(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	  (0, _assertString.default)(str);
	  var comparison = (0, _toDate.default)(date);
	  var original = (0, _toDate.default)(str);
	  return !!(original && comparison && original > comparison);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlpha;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _alpha = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlpha(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	  (0, _assertString.default)(str);
	
	  if (locale in _alpha.alpha) {
	    return _alpha.alpha[locale].test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(_alpha.alpha);
	exports.locales = locales;

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlphanumeric;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _alpha = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlphanumeric(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	  (0, _assertString.default)(str);
	
	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(_alpha.alphanumeric);
	exports.locales = locales;

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAscii;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var ascii = /^[\x00-\x7F]+$/;
	/* eslint-enable no-control-regex */
	
	function isAscii(str) {
	  (0, _assertString.default)(str);
	  return ascii.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBIC;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isBICReg = /^[A-z]{4}[A-z]{2}\w{2}(\w{3})?$/;
	
	function isBIC(str) {
	  (0, _assertString.default)(str);
	  return isBICReg.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase32;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base32 = /^[A-Z2-7]+=*$/;
	
	function isBase32(str) {
	  (0, _assertString.default)(str);
	  var len = str.length;
	
	  if (len > 0 && len % 8 === 0 && base32.test(str)) {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase64;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notBase64 = /[^A-Z0-9+\/=]/i;
	
	function isBase64(str) {
	  (0, _assertString.default)(str);
	  var len = str.length;
	
	  if (!len || len % 4 !== 0 || notBase64.test(str)) {
	    return false;
	  }
	
	  var firstPaddingChar = str.indexOf('=');
	  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _toDate = _interopRequireDefault(__webpack_require__(295));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBefore(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	  (0, _assertString.default)(str);
	  var comparison = (0, _toDate.default)(date);
	  var original = (0, _toDate.default)(str);
	  return !!(original && comparison && original < comparison);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBoolean;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBoolean(str) {
	  (0, _assertString.default)(str);
	  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString.default)(str);
	  var sanitized = str.replace(/[- ]+/g, '');
	
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	
	  var sum = 0;
	  var digit;
	  var tmpNum;
	  var shouldDouble;
	
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	
	    if (shouldDouble) {
	      tmpNum *= 2;
	
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	
	    shouldDouble = !shouldDouble;
	  }
	
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCurrency;
	
	var _merge = _interopRequireDefault(__webpack_require__(106));
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currencyRegex(options) {
	  var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
	  options.digits_after_decimal.forEach(function (digit, index) {
	    if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
	  });
	  var symbol = "(\\".concat(options.symbol.replace(/\./g, '\\.'), ")").concat(options.require_symbol ? '' : '?'),
	      negative = '-?',
	      whole_dollar_amount_without_sep = '[1-9]\\d*',
	      whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"),
	      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
	      whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"),
	      decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
	  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)
	
	  if (options.allow_negatives && !options.parens_for_negatives) {
	    if (options.negative_sign_after_digits) {
	      pattern += negative;
	    } else if (options.negative_sign_before_digits) {
	      pattern = negative + pattern;
	    }
	  } // South African Rand, for example, uses R 123 (space) and R-123 (no space)
	
	
	  if (options.allow_negative_sign_placeholder) {
	    pattern = "( (?!\\-))?".concat(pattern);
	  } else if (options.allow_space_after_symbol) {
	    pattern = " ?".concat(pattern);
	  } else if (options.allow_space_after_digits) {
	    pattern += '( (?!$))?';
	  }
	
	  if (options.symbol_after_digits) {
	    pattern += symbol;
	  } else {
	    pattern = symbol + pattern;
	  }
	
	  if (options.allow_negatives) {
	    if (options.parens_for_negatives) {
	      pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
	    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
	      pattern = negative + pattern;
	    }
	  } // ensure there's a dollar and/or decimal amount, and that
	  // it doesn't start with a space or a negative sign followed by a space
	
	
	  return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
	}
	
	var default_currency_options = {
	  symbol: '$',
	  require_symbol: false,
	  allow_space_after_symbol: false,
	  symbol_after_digits: false,
	  allow_negatives: true,
	  parens_for_negatives: false,
	  negative_sign_before_digits: false,
	  negative_sign_after_digits: false,
	  allow_negative_sign_placeholder: false,
	  thousands_separator: ',',
	  decimal_separator: '.',
	  allow_decimal: true,
	  require_decimal: false,
	  digits_after_decimal: [2],
	  allow_space_after_digits: false
	};
	
	function isCurrency(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_currency_options);
	  return currencyRegex(options).test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDataURI;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
	var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
	var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
	
	function isDataURI(str) {
	  (0, _assertString.default)(str);
	  var data = str.split(',');
	
	  if (data.length < 2) {
	    return false;
	  }
	
	  var attributes = data.shift().trim().split(';');
	  var schemeAndMediaType = attributes.shift();
	
	  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
	    return false;
	  }
	
	  var mediaType = schemeAndMediaType.substr(5);
	
	  if (mediaType !== '' && !validMediaType.test(mediaType)) {
	    return false;
	  }
	
	  for (var i = 0; i < attributes.length; i++) {
	    if (i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') {// ok
	    } else if (!validAttribute.test(attributes[i])) {
	      return false;
	    }
	  }
	
	  for (var _i = 0; _i < data.length; _i++) {
	    if (!validData.test(data[_i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDecimal;
	
	var _merge = _interopRequireDefault(__webpack_require__(106));
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _includes = _interopRequireDefault(__webpack_require__(296));
	
	var _alpha = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function decimalRegExp(options) {
	  var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
	  return regExp;
	}
	
	var default_decimal_options = {
	  force_decimal: false,
	  decimal_digits: '1,',
	  locale: 'en-US'
	};
	var blacklist = ['', '-', '+'];
	
	function isDecimal(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_decimal_options);
	
	  if (options.locale in _alpha.decimal) {
	    return !(0, _includes.default)(blacklist, str.replace(/ /g, '')) && decimalRegExp(options).test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(options.locale, "'"));
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDivisibleBy;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _toFloat = _interopRequireDefault(__webpack_require__(661));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDivisibleBy(str, num) {
	  (0, _assertString.default)(str);
	  return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _merge = _interopRequireDefault(__webpack_require__(106));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_is_empty_options = {
	  ignore_whitespace: false
	};
	
	function isEmpty(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_is_empty_options);
	  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFloat;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _alpha = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isFloat(str, options) {
	  (0, _assertString.default)(str);
	  options = options || {};
	  var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
	
	  if (str === '' || str === '.' || str === '-' || str === '+') {
	    return false;
	  }
	
	  var value = parseFloat(str.replace(',', '.'));
	  return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
	}
	
	var locales = Object.keys(_alpha.decimal);
	exports.locales = locales;

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHash;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lengths = {
	  md5: 32,
	  md4: 32,
	  sha1: 40,
	  sha256: 64,
	  sha384: 96,
	  sha512: 128,
	  ripemd128: 32,
	  ripemd160: 40,
	  tiger128: 32,
	  tiger160: 40,
	  tiger192: 48,
	  crc32: 8,
	  crc32b: 8
	};
	
	function isHash(str, algorithm) {
	  (0, _assertString.default)(str);
	  var hash = new RegExp("^[a-fA-F0-9]{".concat(lengths[algorithm], "}$"));
	  return hash.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexColor;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
	
	function isHexColor(str) {
	  (0, _assertString.default)(str);
	  return hexcolor.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIPRange;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _isIP = _interopRequireDefault(__webpack_require__(211));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subnetMaybe = /^\d{1,2}$/;
	
	function isIPRange(str) {
	  (0, _assertString.default)(str);
	  var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet
	
	  if (parts.length !== 2) {
	    return false;
	  }
	
	  if (!subnetMaybe.test(parts[1])) {
	    return false;
	  } // Disallow preceding 0 i.e. 01, 02, ...
	
	
	  if (parts[1].length > 1 && parts[1].startsWith('0')) {
	    return false;
	  }
	
	  return (0, _isIP.default)(parts[0], 4) && parts[1] <= 32 && parts[1] >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISBN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
	var isbn13Maybe = /^(?:[0-9]{13})$/;
	var factor = [1, 3];
	
	function isISBN(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  (0, _assertString.default)(str);
	  version = String(version);
	
	  if (!version) {
	    return isISBN(str, 10) || isISBN(str, 13);
	  }
	
	  var sanitized = str.replace(/[\s-]+/g, '');
	  var checksum = 0;
	  var i;
	
	  if (version === '10') {
	    if (!isbn10Maybe.test(sanitized)) {
	      return false;
	    }
	
	    for (i = 0; i < 9; i++) {
	      checksum += (i + 1) * sanitized.charAt(i);
	    }
	
	    if (sanitized.charAt(9) === 'X') {
	      checksum += 10 * 10;
	    } else {
	      checksum += 10 * sanitized.charAt(9);
	    }
	
	    if (checksum % 11 === 0) {
	      return !!sanitized;
	    }
	  } else if (version === '13') {
	    if (!isbn13Maybe.test(sanitized)) {
	      return false;
	    }
	
	    for (i = 0; i < 12; i++) {
	      checksum += factor[i % 2] * sanitized.charAt(i);
	    }
	
	    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
	      return !!sanitized;
	    }
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISIN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
	
	function isISIN(str) {
	  (0, _assertString.default)(str);
	
	  if (!isin.test(str)) {
	    return false;
	  }
	
	  var checksumStr = str.replace(/[A-Z]/g, function (character) {
	    return parseInt(character, 36);
	  });
	  var sum = 0;
	  var digit;
	  var tmpNum;
	  var shouldDouble = true;
	
	  for (var i = checksumStr.length - 2; i >= 0; i--) {
	    digit = checksumStr.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	
	    if (shouldDouble) {
	      tmpNum *= 2;
	
	      if (tmpNum >= 10) {
	        sum += tmpNum + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	
	    shouldDouble = !shouldDouble;
	  }
	
	  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO31661Alpha2;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _includes = _interopRequireDefault(__webpack_require__(296));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	var validISO31661Alpha2CountriesCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];
	
	function isISO31661Alpha2(str) {
	  (0, _assertString.default)(str);
	  return (0, _includes.default)(validISO31661Alpha2CountriesCodes, str.toUpperCase());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO31661Alpha3;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _includes = _interopRequireDefault(__webpack_require__(296));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
	var validISO31661Alpha3CountriesCodes = ['AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE'];
	
	function isISO31661Alpha3(str) {
	  (0, _assertString.default)(str);
	  return (0, _includes.default)(validISO31661Alpha3CountriesCodes, str.toUpperCase());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO8601;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	// from http://goo.gl/0ejHHW
	var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
	/* eslint-enable max-len */
	
	var isValidDate = function isValidDate(str) {
	  // str must have passed the ISO8601 check
	  // this check is meant to catch invalid dates
	  // like 2009-02-31
	  // first check for ordinal dates
	  var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
	
	  if (ordinalMatch) {
	    var oYear = Number(ordinalMatch[1]);
	    var oDay = Number(ordinalMatch[2]); // if is leap year
	
	    if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
	    return oDay <= 365;
	  }
	
	  var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
	  var year = match[1];
	  var month = match[2];
	  var day = match[3];
	  var monthString = month ? "0".concat(month).slice(-2) : month;
	  var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare
	
	  var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));
	
	  if (month && day) {
	    return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
	  }
	
	  return true;
	};
	
	function isISO8601(str, options) {
	  (0, _assertString.default)(str);
	  var check = iso8601.test(str);
	  if (!options) return check;
	  if (check && options.strict) return isValidDate(str);
	  return check;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISRC;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
	var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
	
	function isISRC(str) {
	  (0, _assertString.default)(str);
	  return isrc.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISSN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var issn = '^\\d{4}-?\\d{3}[\\dX]$';
	
	function isISSN(str) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (0, _assertString.default)(str);
	  var testIssn = issn;
	  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
	  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
	
	  if (!testIssn.test(str)) {
	    return false;
	  }
	
	  var digits = str.replace('-', '').toUpperCase();
	  var checksum = 0;
	
	  for (var i = 0; i < digits.length; i++) {
	    var digit = digits[i];
	    checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
	  }
	
	  return checksum % 11 === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIdentityCard;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validators = {
	  ES: function ES(str) {
	    (0, _assertString.default)(str);
	    var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
	    var charsValue = {
	      X: 0,
	      Y: 1,
	      Z: 2
	    };
	    var controlDigits = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']; // sanitize user input
	
	    var sanitized = str.trim().toUpperCase(); // validate the data structure
	
	    if (!DNI.test(sanitized)) {
	      return false;
	    } // validate the control digit
	
	
	    var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function (char) {
	      return charsValue[char];
	    });
	    return sanitized.endsWith(controlDigits[number % 23]);
	  },
	  'he-IL': function heIL(str) {
	    var DNI = /^\d{9}$/; // sanitize user input
	
	    var sanitized = str.trim(); // validate the data structure
	
	    if (!DNI.test(sanitized)) {
	      return false;
	    }
	
	    var id = sanitized;
	    var sum = 0,
	        incNum;
	
	    for (var i = 0; i < id.length; i++) {
	      incNum = Number(id[i]) * (i % 2 + 1); // Multiply number by 1 or 2
	
	      sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
	    }
	
	    return sum % 10 === 0;
	  },
	  'zh-TW': function zhTW(str) {
	    var ALPHABET_CODES = {
	      A: 10,
	      B: 11,
	      C: 12,
	      D: 13,
	      E: 14,
	      F: 15,
	      G: 16,
	      H: 17,
	      I: 34,
	      J: 18,
	      K: 19,
	      L: 20,
	      M: 21,
	      N: 22,
	      O: 35,
	      P: 23,
	      Q: 24,
	      R: 25,
	      S: 26,
	      T: 27,
	      U: 28,
	      V: 29,
	      W: 32,
	      X: 30,
	      Y: 31,
	      Z: 33
	    };
	    var sanitized = str.trim().toUpperCase();
	    if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
	    return Array.from(sanitized).reduce(function (sum, number, index) {
	      if (index === 0) {
	        var code = ALPHABET_CODES[number];
	        return code % 10 * 9 + Math.floor(code / 10);
	      }
	
	      if (index === 9) {
	        return (10 - sum % 10 - Number(number)) % 10 === 0;
	      }
	
	      return sum + Number(number) * (9 - index);
	    }, 0);
	  }
	};
	
	function isIdentityCard(str, locale) {
	  (0, _assertString.default)(str);
	
	  if (locale in validators) {
	    return validators[locale](str);
	  } else if (locale === 'any') {
	    for (var key in validators) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if (validators.hasOwnProperty(key)) {
	        var validator = validators[key];
	
	        if (validator(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIn;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _toString = _interopRequireDefault(__webpack_require__(662));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function isIn(str, options) {
	  (0, _assertString.default)(str);
	  var i;
	
	  if (Object.prototype.toString.call(options) === '[object Array]') {
	    var array = [];
	
	    for (i in options) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if ({}.hasOwnProperty.call(options, i)) {
	        array[i] = (0, _toString.default)(options[i]);
	      }
	    }
	
	    return array.indexOf(str) >= 0;
	  } else if (_typeof(options) === 'object') {
	    return options.hasOwnProperty(str);
	  } else if (options && typeof options.indexOf === 'function') {
	    return options.indexOf(str) >= 0;
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isJSON;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function isJSON(str) {
	  (0, _assertString.default)(str);
	
	  try {
	    var obj = JSON.parse(str);
	    return !!obj && _typeof(obj) === 'object';
	  } catch (e) {
	    /* ignore */
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isJWT;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jwt = /^([A-Za-z0-9\-_~+\/]+[=]{0,2})\.([A-Za-z0-9\-_~+\/]+[=]{0,2})(?:\.([A-Za-z0-9\-_~+\/]+[=]{0,2}))?$/;
	
	function isJWT(str) {
	  (0, _assertString.default)(str);
	  return jwt.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
	var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
	
	function _default(str) {
	  (0, _assertString.default)(str);
	  if (!str.includes(',')) return false;
	  var pair = str.split(',');
	  if (pair[0].startsWith('(') && !pair[1].endsWith(')') || pair[1].endsWith(')') && !pair[0].startsWith('(')) return false;
	  return lat.test(pair[0]) && long.test(pair[1]);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLength;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/* eslint-disable prefer-rest-params */
	function isLength(str, options) {
	  (0, _assertString.default)(str);
	  var min;
	  var max;
	
	  if (_typeof(options) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isLength(str, min [, max])
	    min = arguments[1] || 0;
	    max = arguments[2];
	  }
	
	  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
	  var len = str.length - surrogatePairs.length;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLowercase;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLowercase(str) {
	  (0, _assertString.default)(str);
	  return str === str.toLowerCase();
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMACAddress;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
	var macAddressNoColons = /^([0-9a-fA-F]){12}$/;
	var macAddressWithHyphen = /^([0-9a-fA-F][0-9a-fA-F]-){5}([0-9a-fA-F][0-9a-fA-F])$/;
	var macAddressWithSpaces = /^([0-9a-fA-F][0-9a-fA-F]\s){5}([0-9a-fA-F][0-9a-fA-F])$/;
	
	function isMACAddress(str, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.no_colons) {
	    return macAddressNoColons.test(str);
	  }
	
	  return macAddress.test(str) || macAddressWithHyphen.test(str) || macAddressWithSpaces.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMD5;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md5 = /^[a-f0-9]{32}$/;
	
	function isMD5(str) {
	  (0, _assertString.default)(str);
	  return md5.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMagnetURI;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var magnetURI = /^magnet:\?xt=urn:[a-z0-9]+:[a-z0-9]{32,40}&dn=.+&tr=.+$/i;
	
	function isMagnetURI(url) {
	  (0, _assertString.default)(url);
	  return magnetURI.test(url.trim());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMimeType;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Checks if the provided string matches to a correct Media type format (MIME type)
	
	  This function only checks is the string format follows the
	  etablished rules by the according RFC specifications.
	  This function supports 'charset' in textual media types
	  (https://tools.ietf.org/html/rfc6657).
	
	  This function does not check against all the media types listed
	  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
	  because of lightness purposes : it would require to include
	  all these MIME types in this librairy, which would weigh it
	  significantly. This kind of effort maybe is not worth for the use that
	  this function has in this entire librairy.
	
	  More informations in the RFC specifications :
	  - https://tools.ietf.org/html/rfc2045
	  - https://tools.ietf.org/html/rfc2046
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
	*/
	// Match simple MIME types
	// NB :
	//   Subtype length must not exceed 100 characters.
	//   This rule does not comply to the RFC specs (what is the max length ?).
	var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
	// Handle "charset" in "text/*"
	
	var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
	// Handle "boundary" in "multipart/*"
	
	var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len
	
	function isMimeType(str) {
	  (0, _assertString.default)(str);
	  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobilePhone;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var phones = {
	  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
	  'ar-BH': /^(\+?973)?(3|6)\d{7}$/,
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-EG': /^((\+?20)|0)?1[0125]\d{8}$/,
	  'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
	  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
	  'ar-KW': /^(\+?965)[569]\d{7}$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'ar-TN': /^(\+?216)?[2459]\d{7}$/,
	  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
	  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
	  'bn-BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'de-DE': /^(\+49)?0?1(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
	  'de-AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
	  'el-GR': /^(\+?30|0)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-GG': /^(\+?44|0)1481\d{6}$/,
	  'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28)\d{7}$/,
	  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
	  'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
	  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
	  'en-KE': /^(\+?254|0)(7|1)\d{8}$/,
	  'en-MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
	  'en-MU': /^(\+?230|0)?\d{8}$/,
	  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
	  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
	  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
	  'en-SG': /^(\+65)?[89]\d{7}$/,
	  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
	  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
	  'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'es-CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
	  'es-EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
	  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
	  'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
	  'es-PA': /^(\+?507)\d{7,8}$/,
	  'es-PY': /^(\+?595|0)9[9876]\d{7}$/,
	  'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
	  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
	  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
	  'fj-FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
	  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'fr-GF': /^(\+?594|0|00594)[67]\d{8}$/,
	  'fr-GP': /^(\+?590|0|00590)[67]\d{8}$/,
	  'fr-MQ': /^(\+?596|0|00596)[67]\d{8}$/,
	  'fr-RE': /^(\+?262|0|00262)[67]\d{8}$/,
	  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
	  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
	  'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'ja-JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
	  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
	  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
	  'lt-LT': /^(\+370|8)\d{8}$/,
	  'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'ne-NP': /^(\+?977)?9[78]\d{8}$/,
	  'nl-BE': /^(\+?32|0)4?\d{8}$/,
	  'nl-NL': /^(\+?31|0)6?\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /(?=^(\+?5{2}\-?|0)[1-9]{2}\-?\d{4}\-?\d{4}$)(^(\+?5{2}\-?|0)[1-9]{2}\-?[6-9]{1}\d{3}\-?\d{4}$)|(^(\+?5{2}\-?|0)[1-9]{2}\-?9[6-9]{1}\d{3}\-?\d{4}$)/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
	  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
	  'th-TH': /^(\+66|66|0)\d{9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'uk-UA': /^(\+?38|8)?0\d{9}$/,
	  'vi-VN': /^(\+?84|0)((3([2-9]))|(5([2689]))|(7([0|6-9]))|(8([1-6|89]))|(9([0-9])))([0-9]{7})$/,
	  'zh-CN': /^((\+|00)86)?1([358][0-9]|4[579]|6[67]|7[01235678]|9[189])[0-9]{8}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
	};
	/* eslint-enable max-len */
	// aliases
	
	phones['en-CA'] = phones['en-US'];
	phones['fr-BE'] = phones['nl-BE'];
	phones['zh-HK'] = phones['en-HK'];
	
	function isMobilePhone(str, locale, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.strictMode && !str.startsWith('+')) {
	    return false;
	  }
	
	  if (Array.isArray(locale)) {
	    return locale.some(function (key) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	
	      return false;
	    });
	  } else if (locale in phones) {
	    return phones[locale].test(str); // alias falsey locale as 'any'
	  } else if (!locale || locale === 'any') {
	    for (var key in phones) {
	      // istanbul ignore else
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(phones);
	exports.locales = locales;

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMongoId;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _isHexadecimal = _interopRequireDefault(__webpack_require__(657));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMongoId(str) {
	  (0, _assertString.default)(str);
	  return (0, _isHexadecimal.default)(str) && str.length === 24;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMultibyte;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var multibyte = /[^\x00-\x7F]/;
	/* eslint-enable no-control-regex */
	
	function isMultibyte(str) {
	  (0, _assertString.default)(str);
	  return multibyte.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumeric;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numeric = /^[+-]?([0-9]*[.])?[0-9]+$/;
	var numericNoSymbols = /^[0-9]+$/;
	
	function isNumeric(str, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.no_symbols) {
	    return numericNoSymbols.test(str);
	  }
	
	  return numeric.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOctal;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var octal = /^(0o)?[0-7]+$/i;
	
	function isOctal(str) {
	  (0, _assertString.default)(str);
	  return octal.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPort;
	
	var _isInt = _interopRequireDefault(__webpack_require__(658));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isPort(str) {
	  return (0, _isInt.default)(str, {
	    min: 0,
	    max: 65535
	  });
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// common patterns
	var threeDigit = /^\d{3}$/;
	var fourDigit = /^\d{4}$/;
	var fiveDigit = /^\d{5}$/;
	var sixDigit = /^\d{6}$/;
	var patterns = {
	  AD: /^AD\d{3}$/,
	  AT: fourDigit,
	  AU: fourDigit,
	  BE: fourDigit,
	  BG: fourDigit,
	  BR: /^\d{5}-\d{3}$/,
	  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
	  CH: fourDigit,
	  CZ: /^\d{3}\s?\d{2}$/,
	  DE: fiveDigit,
	  DK: fourDigit,
	  DZ: fiveDigit,
	  EE: fiveDigit,
	  ES: fiveDigit,
	  FI: fiveDigit,
	  FR: /^\d{2}\s?\d{3}$/,
	  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
	  GR: /^\d{3}\s?\d{2}$/,
	  HR: /^([1-5]\d{4}$)/,
	  HU: fourDigit,
	  ID: fiveDigit,
	  IE: /^[A-z]\d[\d|w]\s\w{4}$/i,
	  IL: fiveDigit,
	  IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
	  IS: threeDigit,
	  IT: fiveDigit,
	  JP: /^\d{3}\-\d{4}$/,
	  KE: fiveDigit,
	  LI: /^(948[5-9]|949[0-7])$/,
	  LT: /^LT\-\d{5}$/,
	  LU: fourDigit,
	  LV: /^LV\-\d{4}$/,
	  MX: fiveDigit,
	  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
	  NL: /^\d{4}\s?[a-z]{2}$/i,
	  NO: fourDigit,
	  NZ: fourDigit,
	  PL: /^\d{2}\-\d{3}$/,
	  PR: /^00[679]\d{2}([ -]\d{4})?$/,
	  PT: /^\d{4}\-\d{3}?$/,
	  RO: sixDigit,
	  RU: sixDigit,
	  SA: fiveDigit,
	  SE: /^[1-9]\d{2}\s?\d{2}$/,
	  SI: fourDigit,
	  SK: /^\d{3}\s?\d{2}$/,
	  TN: fourDigit,
	  TW: /^\d{3}(\d{2})?$/,
	  UA: fiveDigit,
	  US: /^\d{5}(-\d{4})?$/,
	  ZA: fourDigit,
	  ZM: fiveDigit
	};
	var locales = Object.keys(patterns);
	exports.locales = locales;
	
	function _default(str, locale) {
	  (0, _assertString.default)(str);
	
	  if (locale in patterns) {
	    return patterns[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in patterns) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if (patterns.hasOwnProperty(key)) {
	        var pattern = patterns[key];
	
	        if (pattern.test(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRFC3339;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */
	var dateFullYear = /[0-9]{4}/;
	var dateMonth = /(0[1-9]|1[0-2])/;
	var dateMDay = /([12]\d|0[1-9]|3[01])/;
	var timeHour = /([01][0-9]|2[0-3])/;
	var timeMinute = /[0-5][0-9]/;
	var timeSecond = /([0-5][0-9]|60)/;
	var timeSecFrac = /(\.[0-9]+)?/;
	var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
	var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
	var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
	var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
	var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
	var rfc3339 = new RegExp("".concat(fullDate.source, "[ tT]").concat(fullTime.source));
	
	function isRFC3339(str) {
	  (0, _assertString.default)(str);
	  return rfc3339.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSlug;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var charsetRegex = /^[^-_](?!.*?[-_]{2,})([a-z0-9\\-]{1,}).*[^-_]$/;
	
	function isSlug(str) {
	  (0, _assertString.default)(str);
	  return charsetRegex.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSurrogatePair;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
	
	function isSurrogatePair(str) {
	  (0, _assertString.default)(str);
	  return surrogatePair.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(294));
	
	var _isIP = _interopRequireDefault(__webpack_require__(211));
	
	var _merge = _interopRequireDefault(__webpack_require__(106));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString.default)(url);
	
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	
	  options = (0, _merge.default)(options, default_url_options);
	  var protocol, auth, host, hostname, port, port_str, split, ipv6;
	  split = url.split('#');
	  url = split.shift();
	  split = url.split('?');
	  url = split.shift();
	  split = url.split('://');
	
	  if (split.length > 1) {
	    protocol = split.shift().toLowerCase();
	
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (url.substr(0, 2) === '//') {
	    if (!options.allow_protocol_relative_urls) {
	      return false;
	    }
	
	    split[0] = url.substr(2);
	  }
	
	  url = split.join('://');
	
	  if (url === '') {
	    return false;
	  }
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	
	  if (split.length > 1) {
	    if (options.disallow_auth) {
	      return false;
	    }
	
	    auth = split.shift();
	
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	
	  hostname = split.join('@');
	  port_str = null;
	  ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUUID;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uuid = {
	  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
	  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	
	function isUUID(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	  (0, _assertString.default)(str);
	  var pattern = uuid[version];
	  return pattern && pattern.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUppercase;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUppercase(str) {
	  (0, _assertString.default)(str);
	  return str === str.toUpperCase();
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isVariableWidth;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _isFullWidth = __webpack_require__(655);
	
	var _isHalfWidth = __webpack_require__(656);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVariableWidth(str) {
	  (0, _assertString.default)(str);
	  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWhitelisted;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWhitelisted(str, chars) {
	  (0, _assertString.default)(str);
	
	  for (var i = str.length - 1; i >= 0; i--) {
	    if (chars.indexOf(str[i]) === -1) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matches(str, pattern, modifiers) {
	  (0, _assertString.default)(str);
	
	  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
	    pattern = new RegExp(pattern, modifiers);
	  }
	
	  return pattern.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeEmail;
	
	var _merge = _interopRequireDefault(__webpack_require__(106));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_normalize_email_options = {
	  // The following options apply to all email addresses
	  // Lowercases the local part of the email address.
	  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
	  // The domain is always lowercased, as per RFC 1035
	  all_lowercase: true,
	  // The following conversions are specific to GMail
	  // Lowercases the local part of the GMail address (known to be case-insensitive)
	  gmail_lowercase: true,
	  // Removes dots from the local part of the email address, as that's ignored by GMail
	  gmail_remove_dots: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  gmail_remove_subaddress: true,
	  // Conversts the googlemail.com domain to gmail.com
	  gmail_convert_googlemaildotcom: true,
	  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
	  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
	  outlookdotcom_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  outlookdotcom_remove_subaddress: true,
	  // The following conversions are specific to Yahoo
	  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
	  yahoo_lowercase: true,
	  // Removes the subaddress (e.g. "-foo") from the email address
	  yahoo_remove_subaddress: true,
	  // The following conversions are specific to Yandex
	  // Lowercases the local part of the Yandex address (known to be case-insensitive)
	  yandex_lowercase: true,
	  // The following conversions are specific to iCloud
	  // Lowercases the local part of the iCloud address (known to be case-insensitive)
	  icloud_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  icloud_remove_subaddress: true
	}; // List of domains used by iCloud
	
	var icloud_domains = ['icloud.com', 'me.com']; // List of domains used by Outlook.com and its predecessors
	// This list is likely incomplete.
	// Partial reference:
	// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
	
	var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com']; // List of domains used by Yahoo Mail
	// This list is likely incomplete
	
	var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com']; // List of domains used by yandex.ru
	
	var yandex_domains = ['yandex.ru', 'yandex.ua', 'yandex.kz', 'yandex.com', 'yandex.by', 'ya.ru']; // replace single dots, but not multiple consecutive dots
	
	function dotsReplacer(match) {
	  if (match.length > 1) {
	    return match;
	  }
	
	  return '';
	}
	
	function normalizeEmail(email, options) {
	  options = (0, _merge.default)(options, default_normalize_email_options);
	  var raw_parts = email.split('@');
	  var domain = raw_parts.pop();
	  var user = raw_parts.join('@');
	  var parts = [user, domain]; // The domain is always lowercased, as it's case-insensitive per RFC 1035
	
	  parts[1] = parts[1].toLowerCase();
	
	  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
	    // Address is GMail
	    if (options.gmail_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (options.gmail_remove_dots) {
	      // this does not replace consecutive dots like example..email@gmail.com
	      parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.gmail_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	
	    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
	  } else if (icloud_domains.indexOf(parts[1]) >= 0) {
	    // Address is iCloud
	    if (options.icloud_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.icloud_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
	    // Address is Outlook.com
	    if (options.outlookdotcom_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.outlookdotcom_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
	    // Address is Yahoo
	    if (options.yahoo_remove_subaddress) {
	      var components = parts[0].split('-');
	      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.yahoo_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (yandex_domains.indexOf(parts[1]) >= 0) {
	    if (options.all_lowercase || options.yandex_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	
	    parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preffered
	  } else if (options.all_lowercase) {
	    // Any other address
	    parts[0] = parts[0].toLowerCase();
	  }
	
	  return parts.join('@');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripLow;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	var _blacklist = _interopRequireDefault(__webpack_require__(652));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripLow(str, keep_new_lines) {
	  (0, _assertString.default)(str);
	  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
	  return (0, _blacklist.default)(str, chars);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toBoolean;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toBoolean(str, strict) {
	  (0, _assertString.default)(str);
	
	  if (strict) {
	    return str === '1' || str === 'true';
	  }
	
	  return str !== '0' && str !== 'false' && str !== '';
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInt;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toInt(str, radix) {
	  (0, _assertString.default)(str);
	  return parseInt(str, radix || 10);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	var _rtrim = _interopRequireDefault(__webpack_require__(660));
	
	var _ltrim = _interopRequireDefault(__webpack_require__(659));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trim(str, chars) {
	  return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unescape;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unescape(str) {
	  (0, _assertString.default)(str);
	  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = whitelist;
	
	var _assertString = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whitelist(str, chars) {
	  (0, _assertString.default)(str);
	  return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1836 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1836);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDataWithBaseline = exports.getBaseProps = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDataWithBaseline = function (props, scale) {
	  var data = _victoryCore.Data.getData(props);
	
	  if (data.length < 2) {
	    data = [];
	  }
	
	  var getDefaultMin = function (axis) {
	    var defaultZero = _victoryCore.Scale.getType(scale[axis]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
	    var domain = scale[axis].domain();
	
	    var minY = _victoryCore.Collection.getMinValue(domain);
	
	    var maxY = _victoryCore.Collection.getMaxValue(domain);
	
	    var defaultMin = defaultZero;
	
	    if (minY < 0 && maxY <= 0) {
	      defaultMin = maxY;
	    } else if (minY >= 0 && maxY > 0) {
	      defaultMin = minY;
	    }
	
	    return _victoryCore.Collection.containsDates(domain) ? new Date(defaultMin) : defaultMin;
	  };
	
	  return data.map(function (datum) {
	    var _y1 = datum._y1 !== undefined ? datum._y1 : datum._y;
	
	    var _y0 = datum._y0 !== undefined ? datum._y0 : getDefaultMin("y");
	
	    var _x1 = datum._x1 !== undefined ? datum._x1 : datum._x;
	
	    var _x0 = datum._x0 !== undefined ? datum._x0 : getDefaultMin("x");
	
	    return (0, _assign2.default)({}, datum, {
	      _y0: _y0,
	      _y1: _y1,
	      _x0: _x0,
	      _x1: _x1
	    });
	  });
	};
	
	exports.getDataWithBaseline = getDataWithBaseline;
	
	var getCalculatedValues = function (props) {
	  var theme = props.theme,
	      polar = props.polar;
	  var defaultStyles = theme && theme.area && theme.area.style ? theme.area.style : {};
	
	  var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var domain = {
	    x: _victoryCore.Domain.getDomainWithZero(props, "x"),
	    y: _victoryCore.Domain.getDomainWithZero(props, "y")
	  };
	  var scale = {
	    x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var origin = polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	  var data = getDataWithBaseline(props, scale);
	  return {
	    style: style,
	    data: data,
	    scale: scale,
	    domain: domain,
	    origin: origin
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "area");
	
	  props = (0, _assign2.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      data = _props.data,
	      domain = _props.domain,
	      events = _props.events,
	      groupComponent = _props.groupComponent,
	      height = _props.height,
	      horizontal = _props.horizontal,
	      interpolation = _props.interpolation,
	      origin = _props.origin,
	      padding = _props.padding,
	      polar = _props.polar,
	      scale = _props.scale,
	      sharedEvents = _props.sharedEvents,
	      standalone = _props.standalone,
	      style = _props.style,
	      theme = _props.theme,
	      width = _props.width,
	      labels = _props.labels,
	      name = _props.name;
	  var initialChildProps = {
	    parent: {
	      style: style.parent,
	      width: width,
	      height: height,
	      scale: scale,
	      data: data,
	      domain: domain,
	      standalone: standalone,
	      theme: theme,
	      polar: polar,
	      origin: origin,
	      padding: padding,
	      name: name,
	      horizontal: horizontal
	    },
	    all: {
	      data: {
	        horizontal: horizontal,
	        polar: polar,
	        origin: origin,
	        scale: scale,
	        data: data,
	        interpolation: interpolation,
	        groupComponent: groupComponent,
	        style: style.data
	      }
	    }
	  };
	  return data.reduce(function (childProps, datum, index) {
	    var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	
	    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
	      var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	      childProps[eventKey] = {
	        labels: _victoryCore.LabelHelpers.getProps(props, index)
	      };
	    }
	
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryArea", {
	  enumerable: true,
	  get: function () {
	    return _victoryArea.default;
	  }
	});
	Object.defineProperty(exports, "Area", {
	  enumerable: true,
	  get: function () {
	    return _area.default;
	  }
	});
	
	var _victoryArea = _interopRequireDefault(__webpack_require__(1840));
	
	var _area = _interopRequireDefault(__webpack_require__(663));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _helperMethods = __webpack_require__(1838);
	
	var _area = _interopRequireDefault(__webpack_require__(663));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  interpolation: "linear"
	};
	var options = {
	  components: [{
	    name: "parent",
	    index: "parent"
	  }, {
	    name: "data",
	    index: "all"
	  }, {
	    name: "labels"
	  }]
	};
	
	var VictoryArea =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryArea, _React$Component);
	
	  function VictoryArea() {
	    _classCallCheck(this, VictoryArea);
	
	    return _possibleConstructorReturn(this, (VictoryArea.__proto__ || Object.getPrototypeOf(VictoryArea)).apply(this, arguments));
	  }
	
	  _createClass(VictoryArea, [{
	    key: "shouldAnimate",
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryArea.animationWhitelist,
	          role = VictoryArea.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderContinuousData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryArea;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryArea, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "domain", "height", "padding", "style", "width"]
	});
	Object.defineProperty(VictoryArea, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    interpolation: _propTypes.default.oneOfType([_propTypes.default.oneOf(["basis", "cardinal", "catmullRom", "linear", "monotoneX", "monotoneY", "natural", "step", "stepAfter", "stepBefore"]), _propTypes.default.func]),
	    label: _victoryCore.PropTypes.deprecated(_propTypes.default.string, "Use `labels` instead for individual data labels")
	  })
	});
	Object.defineProperty(VictoryArea, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    dataComponent: _react.default.createElement(_area.default, null),
	    groupComponent: _react.default.createElement(_victoryCore.VictoryClipContainer, null),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, {
	      renderInPortal: true
	    }),
	    samples: 50,
	    sortKey: "x",
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryArea, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryArea"
	});
	Object.defineProperty(VictoryArea, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "area"
	});
	Object.defineProperty(VictoryArea, "continuous", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: true
	});
	Object.defineProperty(VictoryArea, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.continuousTransitions()
	});
	Object.defineProperty(VictoryArea, "defaultPolarTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.continuousPolarTransitions()
	});
	Object.defineProperty(VictoryArea, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Domain.getDomainWithZero
	});
	Object.defineProperty(VictoryArea, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Data.getData
	});
	Object.defineProperty(VictoryArea, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryArea, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryArea, options);
	
	exports.default = _default;

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStyles = exports.getBaseProps = void 0;
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var orientationSign = {
	  top: -1,
	  left: -1,
	  right: 1,
	  bottom: 1
	};
	
	var getCurrentAxis = function (props, axis) {
	  var orientation = props.orientation,
	      horizontal = props.horizontal;
	
	  if (orientation) {
	    var dimensions = {
	      top: "x",
	      bottom: "x",
	      left: "y",
	      right: "y"
	    };
	    return dimensions[orientation];
	  }
	
	  var otherAxis = axis === "x" ? "y" : "x";
	  return horizontal ? otherAxis : axis;
	};
	
	var getScale = function (props) {
	  var axis = _victoryCore.Axis.getAxis(props);
	
	  var currentAxis = getCurrentAxis(props, axis);
	
	  var scale = _victoryCore.Scale.getBaseScale(props, axis);
	
	  var propsDomain = props.domain && props.domain[axis];
	  var domain = propsDomain || _victoryCore.Axis.getDomain(props) || scale.domain();
	  scale.range(_victoryCore.Helpers.getRange(props, currentAxis));
	  scale.domain(domain);
	  return scale;
	};
	
	var getStyleObject = function (props) {
	  var theme = props.theme,
	      dependentAxis = props.dependentAxis;
	  var generalAxisStyle = theme && theme.axis && theme.axis.style;
	  var axisType = dependentAxis ? "dependentAxis" : "independentAxis";
	  var specificAxisStyle = theme && theme[axisType] && theme[axisType].style;
	
	  var mergeStyles = function () {
	    var styleNamespaces = ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"];
	    return styleNamespaces.reduce(function (memo, curr) {
	      memo[curr] = (0, _defaults2.default)({}, specificAxisStyle[curr], generalAxisStyle[curr]);
	      return memo;
	    }, {});
	  };
	
	  return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
	};
	
	var getStyles = function (props, styleObject) {
	  var style = props.style || {};
	  styleObject = styleObject || {};
	  var parentStyleProps = {
	    height: "100%",
	    width: "100%"
	  };
	  return {
	    parent: (0, _defaults2.default)(style.parent, styleObject.parent, parentStyleProps),
	    axis: (0, _defaults2.default)({}, style.axis, styleObject.axis),
	    axisLabel: (0, _defaults2.default)({}, style.axisLabel, styleObject.axisLabel),
	    grid: (0, _defaults2.default)({}, style.grid, styleObject.grid),
	    ticks: (0, _defaults2.default)({}, style.ticks, styleObject.ticks),
	    tickLabels: (0, _defaults2.default)({}, style.tickLabels, styleObject.tickLabels)
	  };
	};
	
	exports.getStyles = getStyles;
	
	var getTickProps = function (layout, style, datum) {
	  var position = layout.position,
	      transform = layout.transform;
	  return {
	    x1: transform.x,
	    y1: transform.y,
	    x2: transform.x + position.x2,
	    y2: transform.y + position.y2,
	    style: style,
	    datum: datum
	  };
	}; // eslint-disable-next-line max-params
	
	
	var getTickLabelProps = function (layout, style, anchors, datum, text) {
	  var position = layout.position,
	      transform = layout.transform;
	  return {
	    style: style,
	    x: transform.x + position.x,
	    y: transform.y + position.y,
	    verticalAnchor: anchors.verticalAnchor,
	    textAnchor: anchors.textAnchor,
	    angle: style.angle,
	    text: text,
	    datum: datum
	  };
	};
	
	var getGridProps = function (layout, style, datum) {
	  var edge = layout.edge,
	      transform = layout.transform;
	  return {
	    type: "grid",
	    x1: transform.x,
	    y1: transform.y,
	    x2: edge.x + transform.x,
	    y2: edge.y + transform.y,
	    style: style,
	    datum: datum
	  };
	};
	
	var getAxisProps = function (modifiedProps, calculatedValues, globalTransform) {
	  var style = calculatedValues.style,
	      padding = calculatedValues.padding,
	      isVertical = calculatedValues.isVertical;
	  var width = modifiedProps.width,
	      height = modifiedProps.height;
	  return {
	    type: "axis",
	    style: style.axis,
	    x1: isVertical ? globalTransform.x : padding.left + globalTransform.x,
	    x2: isVertical ? globalTransform.x : width - padding.right + globalTransform.x,
	    y1: isVertical ? padding.top + globalTransform.y : globalTransform.y,
	    y2: isVertical ? height - padding.bottom + globalTransform.y : globalTransform.y
	  };
	};
	
	var getEvaluatedStyles = function (style, props) {
	  return {
	    tickStyle: _victoryCore.Helpers.evaluateStyle(style.ticks, props),
	    labelStyle: _victoryCore.Helpers.evaluateStyle(style.tickLabels, props),
	    gridStyle: _victoryCore.Helpers.evaluateStyle(style.grid, props)
	  };
	};
	
	var getAxisLabelProps = function (props, calculatedValues, globalTransform) {
	  var style = calculatedValues.style,
	      orientation = calculatedValues.orientation,
	      padding = calculatedValues.padding,
	      labelPadding = calculatedValues.labelPadding,
	      isVertical = calculatedValues.isVertical;
	  var sign = orientationSign[orientation];
	  var hPadding = padding.left + padding.right;
	  var vPadding = padding.top + padding.bottom;
	  var verticalAnchor = sign < 0 ? "end" : "start";
	  var labelStyle = style.axisLabel;
	  var angle = isVertical ? -90 : 0; // eslint-disable-line no-magic-numbers
	
	  var x = isVertical ? globalTransform.x + sign * labelPadding : (props.width - hPadding) / 2 + padding.left + globalTransform.x;
	  var y = isVertical ? (props.height - vPadding) / 2 + padding.top + globalTransform.y : sign * labelPadding + globalTransform.y;
	  return {
	    x: x,
	    y: y,
	    verticalAnchor: labelStyle.verticalAnchor || verticalAnchor,
	    textAnchor: labelStyle.textAnchor || "middle",
	    angle: labelStyle.angle === undefined ? angle : labelStyle.angle,
	    style: labelStyle,
	    text: props.label
	  };
	};
	
	var getAnchors = function (orientation, isVertical) {
	  var anchorOrientation = {
	    top: "end",
	    left: "end",
	    right: "start",
	    bottom: "start"
	  };
	  var anchor = anchorOrientation[orientation];
	  return {
	    textAnchor: isVertical ? anchor : "middle",
	    verticalAnchor: isVertical ? "middle" : anchor
	  };
	};
	
	var getLabelPadding = function (props, style) {
	  var labelStyle = style.axisLabel || {};
	
	  if (labelStyle.padding !== undefined && labelStyle.padding !== null) {
	    return labelStyle.padding;
	  }
	
	  var isVertical = _victoryCore.Axis.isVertical(props); // TODO: magic numbers
	
	  /*eslint-disable no-magic-numbers*/
	
	
	  var fontSize = labelStyle.fontSize || 14;
	  return props.label ? fontSize * (isVertical ? 2.3 : 1.6) : 0;
	  /*eslint-enable no-magic-numbers*/
	};
	
	var getOffset = function (props, calculatedValues) {
	  var style = calculatedValues.style,
	      padding = calculatedValues.padding,
	      isVertical = calculatedValues.isVertical,
	      orientation = calculatedValues.orientation,
	      labelPadding = calculatedValues.labelPadding,
	      stringTicks = calculatedValues.stringTicks,
	      ticks = calculatedValues.ticks,
	      scale = calculatedValues.scale,
	      axis = calculatedValues.axis;
	  var polar = props.polar,
	      horizontal = props.horizontal;
	  var sharedProps = {
	    scale: _defineProperty({}, axis, scale),
	    polar: polar,
	    horizontal: horizontal,
	    ticks: ticks,
	    stringTicks: stringTicks
	  };
	  var xPadding = orientation === "right" ? padding.right : padding.left;
	  var yPadding = orientation === "top" ? padding.top : padding.bottom;
	  var fontSize = style.axisLabel.fontSize || 14; // eslint-disable-line no-magic-numbers
	
	  var offsetX = props.offsetX !== null && props.offsetX !== undefined ? props.offsetX : xPadding;
	  var offsetY = props.offsetY !== null && props.offsetY !== undefined ? props.offsetY : yPadding;
	  var tickSizes = ticks.map(function (data, index) {
	    var tick = stringTicks ? props.tickValues[data - 1] : data;
	
	    var tickStyle = _victoryCore.Helpers.evaluateStyle(style.ticks, (0, _assign2.default)({}, sharedProps, {
	      tick: tick,
	      index: index
	    }));
	
	    return tickStyle.size || 0;
	  });
	  var totalPadding = fontSize + 2 * Math.max.apply(Math, _toConsumableArray(tickSizes)) + labelPadding;
	  var minimumPadding = 1.2 * fontSize; // eslint-disable-line no-magic-numbers
	
	  var x = isVertical ? totalPadding : minimumPadding;
	  var y = isVertical ? minimumPadding : totalPadding;
	  return {
	    x: offsetX !== null && offsetX !== undefined ? offsetX : x,
	    y: offsetY !== null && offsetY !== undefined ? offsetY : y
	  };
	};
	
	var getTransform = function (props, calculatedValues, offset) {
	  //
	  var orientation = calculatedValues.orientation,
	      axis = calculatedValues.axis;
	
	  var axisValue = _victoryCore.Axis.getAxisValue(props, axis);
	
	  return {
	    top: {
	      x: 0,
	      y: axisValue !== undefined ? axisValue : offset.y
	    },
	    bottom: {
	      x: 0,
	      y: axisValue !== undefined ? axisValue : props.height - offset.y
	    },
	    left: {
	      x: axisValue !== undefined ? axisValue : offset.x,
	      y: 0
	    },
	    right: {
	      x: axisValue !== undefined ? axisValue : props.width - offset.x,
	      y: 0
	    }
	  }[orientation];
	};
	
	var getTickPosition = function (style, orientation, isVertical) {
	  var tickStyle = style.tickStyle,
	      labelStyle = style.labelStyle;
	  var size = tickStyle.size || 0;
	  var tickPadding = tickStyle.padding || 0;
	  var labelPadding = labelStyle.padding || 0;
	  var tickSpacing = size + tickPadding + labelPadding;
	  var sign = orientationSign[orientation];
	  return {
	    x: isVertical ? sign * tickSpacing : 0,
	    x2: isVertical ? sign * size : 0,
	    y: isVertical ? 0 : sign * tickSpacing,
	    y2: isVertical ? 0 : sign * size
	  };
	};
	
	var getTickTransform = function (tick, globalTransform, isVertical) {
	  return {
	    x: isVertical ? globalTransform.x : tick + globalTransform.x,
	    y: isVertical ? tick + globalTransform.y : globalTransform.y
	  };
	};
	
	var getGridEdge = function (props, calculatedValues) {
	  var orientation = calculatedValues.orientation,
	      padding = calculatedValues.padding,
	      isVertical = calculatedValues.isVertical;
	  var sign = -orientationSign[orientation];
	  var x = isVertical ? sign * (props.width - (padding.left + padding.right)) : 0;
	  var y = isVertical ? 0 : sign * (props.height - (padding.top + padding.bottom));
	  return {
	    x: x,
	    y: y
	  };
	};
	
	var getGridOffset = function (props, calculatedValues, offset) {
	  var padding = calculatedValues.padding,
	      orientation = calculatedValues.orientation;
	  var xPadding = orientation === "right" ? padding.right : padding.left;
	  var yPadding = orientation === "top" ? padding.top : padding.bottom;
	  return {
	    x: props.crossAxis ? offset.x - xPadding : 0,
	    y: props.crossAxis ? offset.y - yPadding : 0
	  };
	};
	
	var getLayoutProps = function (modifiedProps, calculatedValues) {
	  var offset = getOffset(modifiedProps, calculatedValues);
	  return {
	    globalTransform: getTransform(modifiedProps, calculatedValues, offset),
	    gridOffset: getGridOffset(modifiedProps, calculatedValues, offset),
	    gridEdge: getGridEdge(modifiedProps, calculatedValues)
	  };
	};
	
	var getOrientation = function (props) {
	  if (props.orientation) {
	    return props.orientation;
	  }
	
	  var defaultOrientations = {
	    dependent: props.horizontal ? "bottom" : "left",
	    independent: props.horizontal ? "left" : "bottom"
	  };
	  return props.dependentAxis ? defaultOrientations.dependent : defaultOrientations.independent;
	};
	
	var getCalculatedValues = function (props) {
	  var defaultStyles = getStyleObject(props);
	  var style = getStyles(props, defaultStyles);
	
	  var padding = _victoryCore.Helpers.getPadding(props);
	
	  var isVertical = _victoryCore.Axis.isVertical(props);
	
	  var labelPadding = getLabelPadding(props, style);
	  var stringTicks = _victoryCore.Axis.stringTicks(props) ? props.tickValues : undefined;
	
	  var axis = _victoryCore.Axis.getAxis(props);
	
	  var orientation = getOrientation(props);
	  var scale = getScale(props);
	
	  var domain = _victoryCore.Axis.getDomain(props);
	
	  var ticks = _victoryCore.Axis.getTicks(props, scale, props.crossAxis);
	
	  var tickFormat = _victoryCore.Axis.getTickFormat(props, scale);
	
	  var anchors = getAnchors(orientation, isVertical);
	  return {
	    axis: axis,
	    style: style,
	    padding: padding,
	    orientation: orientation,
	    isVertical: isVertical,
	    labelPadding: labelPadding,
	    stringTicks: stringTicks,
	    anchors: anchors,
	    scale: scale,
	    ticks: ticks,
	    tickFormat: tickFormat,
	    domain: domain
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  props = _victoryCore.Axis.modifyProps(props, fallbackProps);
	  var calculatedValues = getCalculatedValues(props);
	  var axis = calculatedValues.axis,
	      style = calculatedValues.style,
	      orientation = calculatedValues.orientation,
	      isVertical = calculatedValues.isVertical,
	      scale = calculatedValues.scale,
	      ticks = calculatedValues.ticks,
	      tickFormat = calculatedValues.tickFormat,
	      anchors = calculatedValues.anchors,
	      domain = calculatedValues.domain,
	      stringTicks = calculatedValues.stringTicks,
	      name = calculatedValues.name;
	  var otherAxis = axis === "x" ? "y" : "x";
	  var _props = props,
	      width = _props.width,
	      height = _props.height,
	      standalone = _props.standalone,
	      theme = _props.theme,
	      polar = _props.polar,
	      padding = _props.padding,
	      horizontal = _props.horizontal;
	
	  var _getLayoutProps = getLayoutProps(props, calculatedValues),
	      globalTransform = _getLayoutProps.globalTransform,
	      gridOffset = _getLayoutProps.gridOffset,
	      gridEdge = _getLayoutProps.gridEdge;
	
	  var sharedProps = {
	    scale: _defineProperty({}, axis, scale),
	    polar: polar,
	    horizontal: horizontal,
	    ticks: ticks,
	    stringTicks: stringTicks
	  };
	  var axisProps = getAxisProps(props, calculatedValues, globalTransform);
	  var axisLabelProps = getAxisLabelProps(props, calculatedValues, globalTransform);
	  var initialChildProps = {
	    parent: (0, _assign2.default)({
	      style: style.parent,
	      ticks: ticks,
	      standalone: standalone,
	      theme: theme,
	      width: width,
	      height: height,
	      padding: padding,
	      domain: domain,
	      name: name
	    }, sharedProps)
	  };
	  var gridProps = {
	    dimension: otherAxis,
	    range: _defineProperty({}, otherAxis, _victoryCore.Helpers.getRange(props, otherAxis)),
	    scale: props.scale && props.scale[otherAxis] ? _defineProperty({}, otherAxis, props.scale[otherAxis]) : undefined
	  };
	  return ticks.reduce(function (childProps, tickValue, index) {
	    var tick = stringTicks ? stringTicks[index] : tickValue;
	    var text = tickFormat(tickValue, index, ticks);
	    var styles = getEvaluatedStyles(style, (0, _assign2.default)({}, sharedProps, {
	      tick: tick,
	      tickValue: tickValue,
	      index: index,
	      text: text
	    }));
	    var tickLayout = {
	      position: getTickPosition(styles, orientation, isVertical),
	      transform: getTickTransform(scale(tickValue), globalTransform, isVertical)
	    };
	    var gridLayout = {
	      edge: gridEdge,
	      transform: {
	        x: isVertical ? -gridOffset.x + globalTransform.x : scale(tickValue) + globalTransform.x,
	        y: isVertical ? scale(tickValue) + globalTransform.y : gridOffset.y + globalTransform.y
	      }
	    };
	    childProps[index] = {
	      axis: (0, _assign2.default)({
	        dimension: axis
	      }, sharedProps, axisProps),
	      axisLabel: (0, _assign2.default)({}, sharedProps, axisLabelProps),
	      ticks: (0, _assign2.default)({}, sharedProps, getTickProps(tickLayout, styles.tickStyle, tickValue)),
	      tickLabels: (0, _assign2.default)({}, sharedProps, getTickLabelProps(tickLayout, styles.labelStyle, anchors, tickValue, text)),
	      grid: (0, _assign2.default)({}, sharedProps, gridProps, getGridProps(gridLayout, styles.gridStyle, tickValue))
	    };
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _helperMethods = __webpack_require__(1841);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	var options = {
	  components: [{
	    name: "axis",
	    index: 0
	  }, {
	    name: "axisLabel",
	    index: 0
	  }, {
	    name: "grid"
	  }, {
	    name: "parent",
	    index: "parent"
	  }, {
	    name: "ticks"
	  }, {
	    name: "tickLabels"
	  }]
	};
	
	var VictoryAxis =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryAxis, _React$Component);
	
	  function VictoryAxis() {
	    _classCallCheck(this, VictoryAxis);
	
	    return _possibleConstructorReturn(this, (VictoryAxis.__proto__ || Object.getPrototypeOf(VictoryAxis)).apply(this, arguments));
	  }
	
	  _createClass(VictoryAxis, [{
	    key: "renderLine",
	    value: function renderLine(props) {
	      var axisComponent = props.axisComponent;
	      var axisProps = this.getComponentProps(axisComponent, "axis", 0);
	      return _react.default.cloneElement(axisComponent, axisProps);
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel(props) {
	      var axisLabelComponent = props.axisLabelComponent,
	          label = props.label;
	
	      if (!label) {
	        return null;
	      }
	
	      var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
	      return _react.default.cloneElement(axisLabelComponent, axisLabelProps);
	    }
	  }, {
	    key: "renderGridAndTicks",
	    value: function renderGridAndTicks(props) {
	      var _this = this;
	
	      var tickComponent = props.tickComponent,
	          tickLabelComponent = props.tickLabelComponent,
	          gridComponent = props.gridComponent,
	          name = props.name;
	
	      var shouldRender = function (componentProps) {
	        var _componentProps$style = componentProps.style,
	            style = _componentProps$style === void 0 ? {} : _componentProps$style,
	            _componentProps$event = componentProps.events,
	            events = _componentProps$event === void 0 ? {} : _componentProps$event;
	        var visible = style.stroke !== "transparent" && style.stroke !== "none" && style.strokeWidth !== 0;
	        return visible || !(0, _isEmpty2.default)(events);
	      };
	
	      return this.dataKeys.map(function (key, index) {
	        var tickProps = _this.getComponentProps(tickComponent, "ticks", index);
	
	        var BaseTickComponent = _react.default.cloneElement(tickComponent, tickProps);
	
	        var TickComponent = shouldRender(BaseTickComponent.props) ? BaseTickComponent : undefined;
	
	        var gridProps = _this.getComponentProps(gridComponent, "grid", index);
	
	        var BaseGridComponent = _react.default.cloneElement(gridComponent, gridProps);
	
	        var GridComponent = shouldRender(BaseGridComponent.props) ? BaseGridComponent : undefined;
	
	        var tickLabelProps = _this.getComponentProps(tickLabelComponent, "tickLabels", index);
	
	        var TickLabel = _react.default.cloneElement(tickLabelComponent, tickLabelProps);
	
	        var children = [GridComponent, TickComponent, TickLabel].filter(Boolean);
	        return _react.default.cloneElement(props.groupComponent, {
	          key: "".concat(name, "-tick-group-").concat(key)
	        }, children);
	      });
	    }
	  }, {
	    key: "fixLabelOverlap",
	    value: function fixLabelOverlap(gridAndTicks, props) {
	      var isVertical = _victoryCore.Axis.isVertical(props);
	
	      var size = isVertical ? props.height : props.width;
	
	      var isVictoryLabel = function (child) {
	        return child.type && child.type.role === "label";
	      };
	
	      var labels = gridAndTicks.map(function (gridAndTick) {
	        return gridAndTick.props.children;
	      }).reduce(function (accumulator, childArr) {
	        return accumulator.concat(childArr);
	      }, []).filter(isVictoryLabel).map(function (child) {
	        return child.props;
	      });
	
	      var paddingToObject = function (padding) {
	        return typeof padding === "object" ? (0, _assign2.default)({}, {
	          top: 0,
	          right: 0,
	          bottom: 0,
	          left: 0
	        }, padding) : {
	          top: padding,
	          right: padding,
	          bottom: padding,
	          left: padding
	        };
	      };
	
	      var labelsSumSize = labels.reduce(function (sum, label) {
	        var padding = paddingToObject(label.style.padding);
	
	        var labelSize = _victoryCore.TextSize.approximateTextSize(label.text, {
	          angle: label.angle,
	          fontSize: label.style.fontSize,
	          letterSpacing: label.style.letterSpacing,
	          fontFamily: label.style.fontFamily
	        });
	
	        return sum + (isVertical ? labelSize.height + padding.top + padding.bottom : labelSize.width + padding.right + padding.left);
	      }, 0);
	      var availiableLabelCount = Math.floor(size * gridAndTicks.length / labelsSumSize);
	      var divider = Math.ceil(gridAndTicks.length / availiableLabelCount) || 1;
	
	      var getLabelCoord = function (gridAndTick) {
	        return gridAndTick.props.children.filter(isVictoryLabel).reduce(function (prev, child) {
	          return (isVertical ? child.props.y : child.props.x) || 0;
	        }, 0);
	      };
	
	      var sorted = gridAndTicks.sort(function (a, b) {
	        return isVertical ? getLabelCoord(b) - getLabelCoord(a) //ordinary axis has top-bottom orientation
	        : getLabelCoord(a) - getLabelCoord(b);
	      } //ordinary axis has left-right orientation
	      );
	      return sorted.filter(function (gridAndTick, index) {
	        return index % divider === 0;
	      });
	    } // Overridden in native versions
	
	  }, {
	    key: "shouldAnimate",
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryAxis.animationWhitelist;
	
	      var props = _victoryCore.Axis.modifyProps(this.props, fallbackProps);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var gridAndTicks = this.renderGridAndTicks(props);
	      var modifiedGridAndTicks = props.fixLabelOverlap ? this.fixLabelOverlap(gridAndTicks, props) : gridAndTicks;
	      var children = [this.renderLine(props), this.renderLabel(props)].concat(_toConsumableArray(modifiedGridAndTicks));
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : _react.default.cloneElement(props.groupComponent, {}, children);
	    }
	  }]);
	
	  return VictoryAxis;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryAxis, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["style", "domain", "range", "tickCount", "tickValues", "offsetX", "offsetY", "padding", "width", "height"]
	});
	Object.defineProperty(VictoryAxis, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryAxis"
	});
	Object.defineProperty(VictoryAxis, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "axis"
	});
	Object.defineProperty(VictoryAxis, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    onExit: {
	      duration: 500
	    },
	    onEnter: {
	      duration: 500
	    }
	  }
	});
	Object.defineProperty(VictoryAxis, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, {
	    axisComponent: _propTypes.default.element,
	    axisLabelComponent: _propTypes.default.element,
	    axisValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object]),
	    categories: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.shape({
	      x: _propTypes.default.arrayOf(_propTypes.default.string),
	      y: _propTypes.default.arrayOf(_propTypes.default.string)
	    })]),
	    crossAxis: _propTypes.default.bool,
	    dependentAxis: _propTypes.default.bool,
	    events: _propTypes.default.arrayOf(_propTypes.default.shape({
	      target: _propTypes.default.oneOf(["axis", "axisLabel", "grid", "ticks", "tickLabels"]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      eventHandlers: _propTypes.default.object
	    })),
	    fixLabelOverlap: _propTypes.default.bool,
	    gridComponent: _propTypes.default.element,
	    groupComponent: _propTypes.default.element,
	    invertAxis: _propTypes.default.bool,
	    label: _propTypes.default.any,
	    offsetX: _propTypes.default.number,
	    offsetY: _propTypes.default.number,
	    orientation: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	    origin: _propTypes.default.shape({
	      x: _propTypes.default.number,
	      y: _propTypes.default.number
	    }),
	    stringMap: _propTypes.default.object,
	    style: _propTypes.default.shape({
	      parent: _propTypes.default.object,
	      axis: _propTypes.default.object,
	      axisLabel: _propTypes.default.object,
	      grid: _propTypes.default.object,
	      ticks: _propTypes.default.object,
	      tickLabels: _propTypes.default.object
	    }),
	    tickComponent: _propTypes.default.element,
	    tickCount: _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.greaterThanZero]),
	    tickFormat: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.homogeneousArray]),
	    tickLabelComponent: _propTypes.default.element,
	    tickValues: _victoryCore.PropTypes.homogeneousArray
	  })
	});
	Object.defineProperty(VictoryAxis, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    axisComponent: _react.default.createElement(_victoryCore.LineSegment, {
	      type: "axis"
	    }),
	    axisLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    tickLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    tickComponent: _react.default.createElement(_victoryCore.LineSegment, {
	      type: "tick"
	    }),
	    gridComponent: _react.default.createElement(_victoryCore.LineSegment, {
	      type: "grid"
	    }),
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale,
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    groupComponent: _react.default.createElement("g", {
	      role: "presentation"
	    }),
	    fixLabelOverlap: false
	  }
	});
	Object.defineProperty(VictoryAxis, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Axis.getDomain
	});
	Object.defineProperty(VictoryAxis, "getAxis", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Axis.getAxis
	});
	Object.defineProperty(VictoryAxis, "getStyles", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getStyles)(props, fallbackProps.style);
	  }
	});
	Object.defineProperty(VictoryAxis, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryAxis, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["axisComponent", "axisLabelComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryAxis, options);
	
	exports.default = _default;

/***/ },
/* 1843 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.point = exports.circle = void 0;
	
	/**
	 * A point in the 2d plane
	 * @param {number} x - x coordinate
	 * @param {number} y - y coordinate
	 * @returns {object} - point object
	 */
	var point = function (x, y) {
	  return {
	    x: x,
	    y: y,
	    distance: function (p1) {
	      return Math.sqrt(Math.pow(this.x - p1.x, 2) + Math.pow(this.y - p1.y, 2));
	    },
	    // vector addition in 2d plane
	    add: function (p1) {
	      return point(this.x + p1.x, this.y + p1.y);
	    },
	    // vector subtraction in 2d
	    // returns p0 - p1
	    subtract: function (p1) {
	      return point(this.x - p1.x, this.y - p1.y);
	    },
	    // multiply a 2d point by a scalar
	    scalarMult: function (n) {
	      return point(this.x * n, this.y * n);
	    },
	    scalarDivide: function (n) {
	      if (n === 0) {
	        throw new Error("Division by 0 error");
	      }
	
	      return point(this.x / n, this.y / n);
	    },
	    equals: function (p1) {
	      return this.x === p1.x && this.y === p1.y;
	    }
	  };
	};
	/**
	 * A circle in the 2d plane
	 * @param {point} center - center of circle
	 * @param {number} radius - radius of circle
	 * @returns {object} - point object
	 */
	
	
	exports.point = point;
	
	var circle = function (center, radius) {
	  return {
	    center: center,
	    radius: radius,
	    hasIntersection: function (circle1) {
	      var P0 = this.center;
	      var P1 = circle1.center;
	      var r0 = this.radius;
	      var r1 = circle1.radius;
	      var d = P0.distance(P1);
	
	      if (d > r0 + r1) {
	        return false; // separate circles
	      }
	
	      if (d < Math.abs(r0 - r1)) {
	        return false; // one circle contains another
	      }
	
	      return true;
	    },
	    equals: function (circle1) {
	      var P0 = this.center;
	      var P1 = circle1.center;
	      var r0 = this.radius;
	      var r1 = circle1.radius;
	      return r0 === r1 && P0.equals(P1);
	    },
	    // Source: http://paulbourke.net/geometry/circlesphere/
	    // "Intersection of two circles" by Paul Bourke
	    // Left-most point is returned as 0th element of array
	    // Right-most point is returned as 1st elemennt of array
	    intersection: function (circle1) {
	      // eslint-disable-line max-statements
	      var P0 = this.center;
	      var P1 = circle1.center;
	      var r0 = this.radius;
	      var r1 = circle1.radius;
	      var d = P0.distance(P1);
	
	      if (!this.hasIntersection(circle1) || this.equals(circle1)) {
	        return [];
	      }
	
	      var a = (Math.pow(r0, 2) - Math.pow(r1, 2) + Math.pow(d, 2)) / (2 * d);
	      var h = Math.sqrt(Math.pow(r0, 2) - Math.pow(a, 2));
	      var P2 = P0.add(P1.subtract(P0).scalarMult(a).scalarDivide(d));
	      var x0 = P0.x,
	          y0 = P0.y;
	      var x1 = P1.x,
	          y1 = P1.y;
	      var x2 = P2.x,
	          y2 = P2.y;
	      var P3s = [point(x2 - h * (y1 - y0) / d, y2 + h * (x1 - x0) / d), point(x2 + h * (y1 - y0) / d, y2 - h * (x1 - x0) / d)];
	      P3s.sort(function (Point1, Point2) {
	        return Point1.x - Point2.x;
	      });
	      return P3s;
	    },
	    solveX: function (y) {
	      var sqrt = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(y - this.center.y, 2));
	      return [this.center.x - sqrt, this.center.x + sqrt];
	    },
	    solveY: function (x) {
	      var sqrt = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(x - this.center.x, 2));
	      return [this.center.y - sqrt, this.center.y + sqrt];
	    }
	  };
	};
	
	exports.circle = circle;

/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBaseProps = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getBarPosition = function (props, datum) {
	  var getDefaultMin = function (axis) {
	    var defaultZero = _victoryCore.Scale.getType(props.scale[axis]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
	    var defaultMin = defaultZero;
	
	    var minY = _victoryCore.Collection.getMinValue(props.domain[axis]);
	
	    var maxY = _victoryCore.Collection.getMaxValue(props.domain[axis]);
	
	    if (minY < 0 && maxY <= 0) {
	      defaultMin = maxY;
	    } else if (minY >= 0 && maxY > 0) {
	      defaultMin = minY;
	    }
	
	    return datum["_".concat(axis)] instanceof Date ? new Date(defaultMin) : defaultMin;
	  };
	
	  var _y0 = datum._y0 !== undefined ? datum._y0 : getDefaultMin("y");
	
	  var _x0 = datum._x0 !== undefined ? datum._x0 : getDefaultMin("x");
	
	  return _victoryCore.Helpers.scalePoint(props, (0, _assign2.default)({}, datum, {
	    _y0: _y0,
	    _x0: _x0
	  }));
	};
	
	var getCalculatedValues = function (props) {
	  var theme = props.theme,
	      polar = props.polar;
	  var defaultStyles = theme && theme.bar && theme.bar.style ? theme.bar.style : {};
	
	  var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	
	  var data = _victoryCore.Data.getData(props);
	
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var domain = {
	    x: _victoryCore.Domain.getDomainWithZero(props, "x"),
	    y: _victoryCore.Domain.getDomainWithZero(props, "y")
	  };
	  var scale = {
	    x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var origin = polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	  return {
	    style: style,
	    data: data,
	    scale: scale,
	    domain: domain,
	    origin: origin
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "bar");
	
	  props = (0, _assign2.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      alignment = _props.alignment,
	      barRatio = _props.barRatio,
	      cornerRadius = _props.cornerRadius,
	      data = _props.data,
	      domain = _props.domain,
	      events = _props.events,
	      height = _props.height,
	      horizontal = _props.horizontal,
	      origin = _props.origin,
	      padding = _props.padding,
	      polar = _props.polar,
	      scale = _props.scale,
	      sharedEvents = _props.sharedEvents,
	      standalone = _props.standalone,
	      style = _props.style,
	      theme = _props.theme,
	      width = _props.width,
	      labels = _props.labels,
	      name = _props.name,
	      barWidth = _props.barWidth,
	      getPath = _props.getPath;
	  var initialChildProps = {
	    parent: {
	      horizontal: horizontal,
	      domain: domain,
	      scale: scale,
	      width: width,
	      height: height,
	      data: data,
	      standalone: standalone,
	      name: name,
	      theme: theme,
	      polar: polar,
	      origin: origin,
	      padding: padding,
	      style: style.parent
	    }
	  };
	  return data.reduce(function (childProps, datum, index) {
	    var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	
	    var _getBarPosition = getBarPosition(props, datum),
	        x = _getBarPosition.x,
	        y = _getBarPosition.y,
	        y0 = _getBarPosition.y0,
	        x0 = _getBarPosition.x0;
	
	    var dataProps = {
	      alignment: alignment,
	      barRatio: barRatio,
	      cornerRadius: cornerRadius,
	      data: data,
	      datum: datum,
	      horizontal: horizontal,
	      index: index,
	      polar: polar,
	      origin: origin,
	      scale: scale,
	      style: style.data,
	      width: width,
	      height: height,
	      x: x,
	      y: y,
	      y0: y0,
	      x0: x0,
	      barWidth: barWidth,
	      getPath: getPath
	    };
	    childProps[eventKey] = {
	      data: dataProps
	    };
	
	    var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	
	    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
	      childProps[eventKey].labels = _victoryCore.LabelHelpers.getProps(props, index);
	    }
	
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryBar", {
	  enumerable: true,
	  get: function () {
	    return _victoryBar.default;
	  }
	});
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function () {
	    return _bar.default;
	  }
	});
	Object.defineProperty(exports, "getVerticalBarPath", {
	  enumerable: true,
	  get: function () {
	    return _pathHelperMethods.getVerticalBarPath;
	  }
	});
	Object.defineProperty(exports, "getHorizontalBarPath", {
	  enumerable: true,
	  get: function () {
	    return _pathHelperMethods.getHorizontalBarPath;
	  }
	});
	Object.defineProperty(exports, "getVerticalPolarBarPath", {
	  enumerable: true,
	  get: function () {
	    return _pathHelperMethods.getVerticalPolarBarPath;
	  }
	});
	
	var _victoryBar = _interopRequireDefault(__webpack_require__(1846));
	
	var _bar = _interopRequireDefault(__webpack_require__(665));
	
	var _pathHelperMethods = __webpack_require__(666);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _helperMethods = __webpack_require__(1844);
	
	var _bar = _interopRequireDefault(__webpack_require__(665));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	var defaultData = [{
	  x: 1,
	  y: 1
	}, {
	  x: 2,
	  y: 2
	}, {
	  x: 3,
	  y: 3
	}, {
	  x: 4,
	  y: 4
	}];
	
	var VictoryBar =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryBar, _React$Component);
	
	  function VictoryBar() {
	    _classCallCheck(this, VictoryBar);
	
	    return _possibleConstructorReturn(this, (VictoryBar.__proto__ || Object.getPrototypeOf(VictoryBar)).apply(this, arguments));
	  }
	
	  _createClass(VictoryBar, [{
	    key: "shouldAnimate",
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryBar.animationWhitelist,
	          role = VictoryBar.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryBar;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryBar, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "domain", "height", "padding", "style", "width"]
	});
	Object.defineProperty(VictoryBar, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryBar"
	});
	Object.defineProperty(VictoryBar, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "bar"
	});
	Object.defineProperty(VictoryBar, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    onLoad: {
	      duration: 2000,
	      before: function () {
	        return {
	          _y: 0,
	          _y1: 0,
	          _y0: 0
	        };
	      },
	      after: function (datum) {
	        return {
	          _y: datum._y,
	          _y1: datum._y1,
	          _y0: datum._y0
	        };
	      }
	    },
	    onExit: {
	      duration: 500,
	      before: function () {
	        return {
	          _y: 0,
	          yOffset: 0
	        };
	      }
	    },
	    onEnter: {
	      duration: 500,
	      before: function () {
	        return {
	          _y: 0,
	          _y1: 0,
	          _y0: 0
	        };
	      },
	      after: function (datum) {
	        return {
	          _y: datum._y,
	          _y1: datum._y1,
	          _y0: datum._y0
	        };
	      }
	    }
	  }
	});
	Object.defineProperty(VictoryBar, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    alignment: _propTypes.default.oneOf(["start", "middle", "end"]),
	    barRatio: _propTypes.default.number,
	    barWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	    cornerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func, _propTypes.default.shape({
	      top: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	      topLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	      topRight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	      bottom: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	      bottomLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	      bottomRight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func])
	    })]),
	    getPath: _propTypes.default.func,
	    horizontal: _propTypes.default.bool
	  })
	});
	Object.defineProperty(VictoryBar, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    data: defaultData,
	    dataComponent: _react.default.createElement(_bar.default, null),
	    groupComponent: _react.default.createElement("g", {
	      role: "presentation"
	    }),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    samples: 50,
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryBar, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Domain.getDomainWithZero
	});
	Object.defineProperty(VictoryBar, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Data.getData
	});
	Object.defineProperty(VictoryBar, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryBar, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryBar);
	
	exports.default = _default;

/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBaseProps = exports.getData = exports.getDomain = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(441));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(56));
	
	var _groupBy2 = _interopRequireDefault(__webpack_require__(190));
	
	var _uniq2 = _interopRequireDefault(__webpack_require__(99));
	
	var _assign3 = _interopRequireDefault(__webpack_require__(20));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _orderBy2 = _interopRequireDefault(__webpack_require__(119));
	
	var _victoryCore = __webpack_require__(19);
	
	var _d3Array = __webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TYPES = ["max", "min", "median", "q1", "q3"];
	
	var checkProcessedData = function (data) {
	  /* check if the data is pre-processed. start by checking that it has
	  all required quartile attributes. */
	  var hasQuartileAttributes = data.every(function (datum) {
	    return TYPES.every(function (val) {
	      return typeof datum["_".concat(val)] !== "undefined";
	    });
	  });
	
	  if (hasQuartileAttributes) {
	    // check that the independent variable is distinct
	    var values = data.map(function (d) {
	      return d._x;
	    });
	
	    if (!(0, _uniq2.default)(values).length === values.length) {
	      throw new Error("\n        data prop may only take an array of objects with a unique\n        independent variable. Make sure your x values are distinct.\n      ");
	    }
	
	    return true;
	  }
	
	  return false;
	};
	
	var nanToNull = function (val) {
	  return (0, _isNaN2.default)(val) ? null : val;
	};
	
	var getSummaryStatistics = function (data) {
	  var dependentVars = data.map(function (datum) {
	    return datum._y;
	  });
	  var quartiles = {
	    _q1: nanToNull((0, _d3Array.quantile)(dependentVars, 0.25)),
	    // eslint-disable-line no-magic-numbers
	    _q3: nanToNull((0, _d3Array.quantile)(dependentVars, 0.75)),
	    // eslint-disable-line no-magic-numbers
	    _min: nanToNull((0, _d3Array.min)(dependentVars)),
	    _median: nanToNull((0, _d3Array.quantile)(dependentVars, 0.5)),
	    _max: nanToNull((0, _d3Array.max)(dependentVars))
	  };
	  return (0, _assign3.default)({}, data[0], quartiles, {
	    _y: data[0]._y
	  });
	};
	
	var processData = function (data) {
	  /* check if the data is coming in a pre-processed form,
	  i.e. { x || y, min, max, q1, q3, median }. if not, process it. */
	  var isProcessed = checkProcessedData(data);
	
	  if (!isProcessed) {
	    // check if the data is coming with x or y values as an array
	    var arrayX = data.every(function (datum) {
	      return Array.isArray(datum._x);
	    });
	    var arrayY = data.every(function (datum) {
	      return Array.isArray(datum._y);
	    });
	    var sortKey = "_y";
	    var groupKey = "_x";
	
	    if (arrayX) {
	      throw new Error("\n        data should not be given as in array for x\n      ");
	    } else if (arrayY) {
	      /* generate summary statistics for each datum. to do this, flatten
	      the depedentVarArray and process each datum separately */
	      return data.map(function (datum) {
	        var dataArray = datum[sortKey].map(function (d) {
	          return (0, _assign3.default)({}, datum, _defineProperty({}, sortKey, d));
	        });
	        var sortedData = (0, _orderBy2.default)(dataArray, sortKey);
	        return getSummaryStatistics(sortedData);
	      });
	    } else {
	      /* Group data by independent variable and generate summary statistics for each group */
	      var groupedData = (0, _groupBy2.default)(data, groupKey);
	      return (0, _keys2.default)(groupedData).map(function (key) {
	        var datum = groupedData[key];
	        var sortedData = (0, _orderBy2.default)(datum, sortKey);
	        return getSummaryStatistics(sortedData);
	      });
	    }
	  } else {
	    return data;
	  }
	};
	
	var getData = function (props) {
	  var accessorTypes = TYPES.concat("x", "y");
	
	  var formattedData = _victoryCore.Data.formatData(props.data, props, accessorTypes);
	
	  return formattedData.length ? processData(formattedData) : [];
	};
	
	exports.getData = getData;
	
	var reduceDataset = function (dataset, props, axis) {
	  var minDomain = _victoryCore.Domain.getMinFromProps(props, axis);
	
	  var maxDomain = _victoryCore.Domain.getMaxFromProps(props, axis);
	
	  var minData = minDomain !== undefined ? minDomain : dataset.reduce(function (memo, datum) {
	    return memo < datum["_".concat(axis)] ? memo : datum["_".concat(axis)];
	  }, Infinity);
	  var maxData = maxDomain !== undefined ? maxDomain : dataset.reduce(function (memo, datum) {
	    return memo > datum["_".concat(axis)] ? memo : datum["_".concat(axis)];
	  }, -Infinity);
	  return _victoryCore.Domain.getDomainFromMinMax(minData, maxData);
	};
	
	var getDomainFromMinMaxValues = function (dataset, props, axis) {
	  var minDomain = _victoryCore.Domain.getMinFromProps(props, axis);
	
	  var maxDomain = _victoryCore.Domain.getMaxFromProps(props, axis);
	
	  var minData = minDomain !== undefined ? minDomain : dataset.reduce(function (memo, datum) {
	    return memo < datum._min ? memo : datum._min;
	  }, Infinity);
	  var maxData = maxDomain !== undefined ? maxDomain : dataset.reduce(function (memo, datum) {
	    return memo > datum._max ? memo : datum._max;
	  }, -Infinity);
	  return _victoryCore.Domain.getDomainFromMinMax(minData, maxData);
	};
	
	var getDomainFromData = function (props, axis) {
	  var minDomain = _victoryCore.Domain.getMinFromProps(props, axis);
	
	  var maxDomain = _victoryCore.Domain.getMaxFromProps(props, axis);
	
	  var dataset = getData(props);
	
	  if (dataset.length < 1) {
	    return minDomain !== undefined && maxDomain !== undefined ? _victoryCore.Domain.getDomainFromMinMax(minDomain, maxDomain) : undefined;
	  }
	
	  return axis === "y" ? getDomainFromMinMaxValues(dataset, props, axis) : reduceDataset(dataset, props, axis);
	};
	
	var getDomain = function (props, axis) {
	  return _victoryCore.Domain.createDomainFunction(getDomainFromData)(props, axis);
	};
	
	exports.getDomain = getDomain;
	
	var getStyles = function (props, styleObject) {
	  var style = props.style || {};
	  styleObject = styleObject || {};
	  var parentStyles = {
	    height: "100%",
	    width: "100%"
	  };
	  var labelStyles = (0, _defaults2.default)({}, style.labels, styleObject.labels);
	  var boxStyles = (0, _defaults2.default)({}, style.boxes, styleObject.boxes);
	  var whiskerStyles = (0, _defaults2.default)({}, style.whiskers, styleObject.whiskers);
	  return {
	    boxes: boxStyles,
	    labels: labelStyles,
	    parent: (0, _defaults2.default)({}, style.parent, styleObject.parent, parentStyles),
	    max: (0, _defaults2.default)({}, style.max, styleObject.max, whiskerStyles),
	    maxLabels: (0, _defaults2.default)({}, style.maxLabels, styleObject.maxLabels, labelStyles),
	    median: (0, _defaults2.default)({}, style.median, styleObject.median, whiskerStyles),
	    medianLabels: (0, _defaults2.default)({}, style.medianLabels, styleObject.medianLabels, labelStyles),
	    min: (0, _defaults2.default)({}, style.min, styleObject.min, whiskerStyles),
	    minLabels: (0, _defaults2.default)({}, style.minLabels, styleObject.minLabels, labelStyles),
	    q1: (0, _defaults2.default)({}, style.q1, styleObject.q1, boxStyles),
	    q1Labels: (0, _defaults2.default)({}, style.q1Labels, styleObject.q1Labels, labelStyles),
	    q3: (0, _defaults2.default)({}, style.q3, styleObject.q3, boxStyles),
	    q3Labels: (0, _defaults2.default)({}, style.q3Labels, styleObject.q3Labels, labelStyles),
	    whiskers: whiskerStyles
	  };
	};
	
	var getCalculatedValues = function (props) {
	  var theme = props.theme,
	      horizontal = props.horizontal;
	  var data = getData(props);
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var domain = {
	    x: getDomain(props, "x"),
	    y: getDomain(props, "y")
	  };
	  var scale = {
	    x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var defaultStyles = theme && theme.boxplot && theme.boxplot.style ? theme.boxplot.style : {};
	  var style = getStyles(props, defaultStyles);
	  var defaultOrientation = props.horizontal ? "top" : "right";
	  var labelOrientation = props.labelOrientation || defaultOrientation;
	  var boxWidth = props.boxWidth || 1;
	  return {
	    data: data,
	    horizontal: horizontal,
	    domain: domain,
	    scale: scale,
	    style: style,
	    labelOrientation: labelOrientation,
	    boxWidth: boxWidth
	  };
	}; // eslint-disable-next-line complexity
	
	
	var getWhiskerProps = function (props, type) {
	  var horizontal = props.horizontal,
	      style = props.style,
	      boxWidth = props.boxWidth,
	      whiskerWidth = props.whiskerWidth,
	      datum = props.datum,
	      scale = props.scale,
	      index = props.index;
	  var _props$positions = props.positions,
	      min = _props$positions.min,
	      max = _props$positions.max,
	      q1 = _props$positions.q1,
	      q3 = _props$positions.q3,
	      x = _props$positions.x,
	      y = _props$positions.y;
	  var boxValue = type === "min" ? q1 : q3;
	  var whiskerValue = type === "min" ? min : max;
	  var width = typeof whiskerWidth === "number" ? whiskerWidth : boxWidth;
	  return {
	    datum: datum,
	    index: index,
	    scale: scale,
	    majorWhisker: {
	      x1: horizontal ? boxValue : x,
	      y1: horizontal ? y : boxValue,
	      x2: horizontal ? whiskerValue : x,
	      y2: horizontal ? y : whiskerValue
	    },
	    minorWhisker: {
	      x1: horizontal ? whiskerValue : x - width / 2,
	      y1: horizontal ? y - width / 2 : whiskerValue,
	      x2: horizontal ? whiskerValue : x + width / 2,
	      y2: horizontal ? y + width / 2 : whiskerValue
	    },
	    style: style[type] || style.whisker
	  };
	};
	
	var getBoxProps = function (props, type) {
	  var horizontal = props.horizontal,
	      boxWidth = props.boxWidth,
	      style = props.style,
	      scale = props.scale,
	      datum = props.datum,
	      index = props.index;
	  var _props$positions2 = props.positions,
	      median = _props$positions2.median,
	      q1 = _props$positions2.q1,
	      q3 = _props$positions2.q3,
	      x = _props$positions2.x,
	      y = _props$positions2.y;
	  var defaultX = type === "q1" ? q1 : median;
	  var defaultY = type === "q1" ? median : q3;
	  var defaultWidth = type === "q1" ? median - q1 : q3 - median;
	  var defaultHeight = type === "q1" ? q1 - median : median - q3;
	  return {
	    datum: datum,
	    scale: scale,
	    index: index,
	    x: horizontal ? defaultX : x - boxWidth / 2,
	    y: horizontal ? y - boxWidth / 2 : defaultY,
	    width: horizontal ? defaultWidth : boxWidth,
	    height: horizontal ? boxWidth : defaultHeight,
	    style: style[type] || style.boxes
	  };
	};
	
	var getMedianProps = function (props) {
	  var boxWidth = props.boxWidth,
	      horizontal = props.horizontal,
	      style = props.style,
	      datum = props.datum,
	      scale = props.scale,
	      index = props.index;
	  var _props$positions3 = props.positions,
	      median = _props$positions3.median,
	      x = _props$positions3.x,
	      y = _props$positions3.y;
	  return {
	    datum: datum,
	    scale: scale,
	    index: index,
	    x1: horizontal ? median : x - boxWidth / 2,
	    y1: horizontal ? y - boxWidth / 2 : median,
	    x2: horizontal ? median : x + boxWidth / 2,
	    y2: horizontal ? y + boxWidth / 2 : median,
	    style: style.median
	  };
	};
	
	var getText = function (props, type) {
	  var datum = props.datum,
	      index = props.index,
	      labels = props.labels;
	  var propName = "".concat(type, "Labels");
	  var labelProp = props[propName];
	
	  if (!labelProp && !labels) {
	    return null;
	  } else if (labelProp === true || labels === true) {
	    var dataName = "_".concat(type);
	    return "".concat(datum[dataName]);
	  }
	
	  return Array.isArray(labelProp) ? labelProp[index] : labelProp;
	};
	
	var getOrientation = function (labelOrientation, type) {
	  return typeof labelOrientation === "object" && labelOrientation[type] || labelOrientation;
	};
	
	var getLabelProps = function (props, text, type) {
	  var datum = props.datum,
	      positions = props.positions,
	      index = props.index,
	      boxWidth = props.boxWidth,
	      horizontal = props.horizontal,
	      labelOrientation = props.labelOrientation,
	      style = props.style;
	  var orientation = getOrientation(labelOrientation, type);
	  var namespace = "".concat(type, "Labels");
	  var labelStyle = style[namespace] || style.labels;
	  var defaultVerticalAnchors = {
	    top: "end",
	    bottom: "start",
	    left: "middle",
	    right: "middle"
	  };
	  var defaultTextAnchors = {
	    left: "end",
	    right: "start",
	    top: "middle",
	    bottom: "middle"
	  };
	  var whiskerWidth = typeof props.whiskerWidth === "number" ? props.whiskerWidth : boxWidth;
	  var width = type === "min" || type === "max" ? whiskerWidth : boxWidth;
	
	  var getOffset = function (coord) {
	    var sign = {
	      x: orientation === "left" ? -1 : 1,
	      y: orientation === "top" ? -1 : 1
	    };
	    return sign[coord] * width / 2 + sign[coord] * (labelStyle.padding || 0);
	  };
	
	  return {
	    text: text,
	    datum: datum,
	    index: index,
	    orientation: orientation,
	    style: labelStyle,
	    y: horizontal ? positions.y : positions[type],
	    x: horizontal ? positions[type] : positions.x,
	    dy: horizontal ? getOffset("y") : 0,
	    dx: horizontal ? 0 : getOffset("x"),
	    textAnchor: labelStyle.textAnchor || defaultTextAnchors[labelOrientation],
	    verticalAnchor: labelStyle.verticalAnchor || defaultVerticalAnchors[labelOrientation],
	    angle: labelStyle.angle,
	    horizontal: horizontal
	  };
	};
	
	var getDataProps = function (props, type) {
	  if (type === "median") {
	    return getMedianProps(props);
	  } else if (type === "min" || type === "max") {
	    return getWhiskerProps(props, type);
	  }
	
	  return getBoxProps(props, type);
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "boxplot");
	
	  props = (0, _assign3.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      groupComponent = _props.groupComponent,
	      width = _props.width,
	      height = _props.height,
	      padding = _props.padding,
	      standalone = _props.standalone,
	      theme = _props.theme,
	      events = _props.events,
	      sharedEvents = _props.sharedEvents,
	      scale = _props.scale,
	      horizontal = _props.horizontal,
	      data = _props.data,
	      style = _props.style,
	      domain = _props.domain,
	      name = _props.name;
	  var initialChildProps = {
	    parent: {
	      domain: domain,
	      scale: scale,
	      width: width,
	      height: height,
	      data: data,
	      standalone: standalone,
	      name: name,
	      theme: theme,
	      style: style.parent || {},
	      padding: padding,
	      groupComponent: groupComponent,
	      horizontal: horizontal
	    }
	  };
	  var boxScale = scale.y;
	  return data.reduce(function (acc, datum, index) {
	    var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	    var positions = {
	      x: horizontal ? scale.y(datum._y) : scale.x(datum._x),
	      y: horizontal ? scale.x(datum._x) : scale.y(datum._y),
	      min: boxScale(datum._min),
	      max: boxScale(datum._max),
	      median: boxScale(datum._median),
	      q1: boxScale(datum._q1),
	      q3: boxScale(datum._q3)
	    };
	    var dataProps = (0, _assign3.default)({
	      index: index,
	      datum: datum,
	      positions: positions
	    }, props);
	    var dataObj = TYPES.reduce(function (memo, type) {
	      memo[type] = getDataProps(dataProps, type);
	      return memo;
	    }, {});
	    acc[eventKey] = dataObj;
	    TYPES.forEach(function (type) {
	      var labelText = getText(dataProps, type);
	      var labelProp = props.labels || props["".concat(type, "Labels")];
	
	      if (labelText !== null && labelText !== undefined || labelProp && (events || sharedEvents)) {
	        var target = "".concat(type, "Labels");
	        acc[eventKey][target] = getLabelProps(dataProps, labelText, type);
	      }
	    });
	    return acc;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryBoxPlot", {
	  enumerable: true,
	  get: function () {
	    return _victoryBoxPlot.default;
	  }
	});
	
	var _victoryBoxPlot = _interopRequireDefault(__webpack_require__(1849));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _flatten2 = _interopRequireDefault(__webpack_require__(150));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	var _helperMethods = __webpack_require__(1847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: {
	    top: 20,
	    right: 20,
	    bottom: 20,
	    left: 20
	  }
	};
	var defaultData = [{
	  x: 1,
	  min: 5,
	  q1: 7,
	  median: 12,
	  q3: 18,
	  max: 20
	}, {
	  x: 2,
	  min: 2,
	  q1: 5,
	  median: 8,
	  q3: 12,
	  max: 15
	}];
	var options = {
	  components: [{
	    name: "min"
	  }, {
	    name: "minLabels"
	  }, {
	    name: "max"
	  }, {
	    name: "maxLabels"
	  }, {
	    name: "median"
	  }, {
	    name: "medianLabels"
	  }, {
	    name: "q1"
	  }, {
	    name: "q1Labels"
	  }, {
	    name: "q3"
	  }, {
	    name: "q3Labels"
	  }, {
	    name: "parent",
	    index: "parent"
	  }]
	};
	
	var VictoryBoxPlot =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryBoxPlot, _React$Component);
	
	  function VictoryBoxPlot() {
	    _classCallCheck(this, VictoryBoxPlot);
	
	    return _possibleConstructorReturn(this, (VictoryBoxPlot.__proto__ || Object.getPrototypeOf(VictoryBoxPlot)).apply(this, arguments));
	  }
	
	  _createClass(VictoryBoxPlot, [{
	    key: "renderBoxPlot",
	    value: function renderBoxPlot(props) {
	      var _this = this;
	
	      var types = ["q1", "q3", "max", "min", "median"];
	      var dataComponents = (0, _flatten2.default)(types.map(function (type) {
	        return _this.dataKeys.reduce(function (validDataComponents, _key, index) {
	          var baseComponent = props["".concat(type, "Component")];
	
	          var componentProps = _this.getComponentProps(baseComponent, type, index);
	
	          if (_this.shouldRenderDatum(componentProps.datum)) {
	            validDataComponents.push(_react.default.cloneElement(baseComponent, componentProps));
	          }
	
	          return validDataComponents;
	        }, []);
	      }));
	      var labelComponents = (0, _flatten2.default)(types.map(function (type) {
	        var components = _this.dataKeys.map(function (key, index) {
	          var name = "".concat(type, "Labels");
	          var baseComponent = props["".concat(type, "LabelComponent")];
	
	          var labelProps = _this.getComponentProps(baseComponent, name, index);
	
	          if (labelProps.text !== undefined && labelProps.text !== null) {
	            return _react.default.cloneElement(baseComponent, labelProps);
	          }
	
	          return undefined;
	        });
	
	        return components.filter(Boolean);
	      }));
	
	      var children = _toConsumableArray(dataComponents).concat(_toConsumableArray(labelComponents));
	
	      return this.renderContainer(props.groupComponent, children);
	    } // Overridden in native versions
	
	  }, {
	    key: "shouldAnimate",
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "shouldRenderDatum",
	    value: function shouldRenderDatum(datum) {
	      var hasX = !(0, _isNil2.default)(datum._x);
	      var hasY = !(0, _isNil2.default)(datum._y);
	      var hasSummaryStatistics = !(0, _isNil2.default)(datum._min) && !(0, _isNil2.default)(datum._max) && !(0, _isNil2.default)(datum._median) && !(0, _isNil2.default)(datum._q1) && !(0, _isNil2.default)(datum._q3);
	      return hasSummaryStatistics && (this.props.horizontal ? hasY : hasX);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryBoxPlot.animationWhitelist,
	          role = VictoryBoxPlot.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderBoxPlot(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryBoxPlot;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryBoxPlot, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "domain", "height", "padding", "style", "width"]
	});
	Object.defineProperty(VictoryBoxPlot, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryBoxPlot"
	});
	Object.defineProperty(VictoryBoxPlot, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "boxplot"
	});
	Object.defineProperty(VictoryBoxPlot, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.discreteTransitions()
	});
	Object.defineProperty(VictoryBoxPlot, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    boxWidth: _propTypes.default.number,
	    events: _propTypes.default.arrayOf(_propTypes.default.shape({
	      target: _propTypes.default.oneOf(["max", "maxLabels", "median", "medianLabels", "min", "minLabels", "q1", "q1Labels", "q3", "q3Labels", "parent"]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      eventHandlers: _propTypes.default.object
	    })),
	    horizontal: _propTypes.default.bool,
	    labelOrientation: _propTypes.default.oneOfType([_propTypes.default.oneOf(["top", "bottom", "left", "right"]), _propTypes.default.shape({
	      q1: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	      q3: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	      min: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	      max: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	      median: _propTypes.default.oneOf(["top", "bottom", "left", "right"])
	    })]),
	    labels: _propTypes.default.bool,
	    max: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    maxComponent: _propTypes.default.element,
	    maxLabelComponent: _propTypes.default.element,
	    maxLabels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    median: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    medianComponent: _propTypes.default.element,
	    medianLabelComponent: _propTypes.default.element,
	    medianLabels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    min: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    minComponent: _propTypes.default.element,
	    minLabelComponent: _propTypes.default.element,
	    minLabels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    q1: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    q1Component: _propTypes.default.element,
	    q1LabelComponent: _propTypes.default.element,
	    q1Labels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    q3: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    q3Component: _propTypes.default.element,
	    q3LabelComponent: _propTypes.default.element,
	    q3Labels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    style: _propTypes.default.shape({
	      boxes: _propTypes.default.object,
	      labels: _propTypes.default.object,
	      parent: _propTypes.default.object,
	      max: _propTypes.default.object,
	      maxLabels: _propTypes.default.object,
	      median: _propTypes.default.object,
	      medianLabels: _propTypes.default.object,
	      min: _propTypes.default.object,
	      minLabels: _propTypes.default.object,
	      q1: _propTypes.default.object,
	      q1Labels: _propTypes.default.object,
	      q3: _propTypes.default.object,
	      q3Labels: _propTypes.default.object,
	      whiskers: _propTypes.default.object
	    }),
	    whiskerWidth: _propTypes.default.number
	  })
	});
	Object.defineProperty(VictoryBoxPlot, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    data: defaultData,
	    dataComponent: _react.default.createElement(_victoryCore.Box, null),
	    groupComponent: _react.default.createElement("g", {
	      role: "presentation"
	    }),
	    maxComponent: _react.default.createElement(_victoryCore.Whisker, null),
	    maxLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    medianComponent: _react.default.createElement(_victoryCore.LineSegment, null),
	    medianLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    minComponent: _react.default.createElement(_victoryCore.Whisker, null),
	    minLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    q1Component: _react.default.createElement(_victoryCore.Box, null),
	    q1LabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    q3Component: _react.default.createElement(_victoryCore.Box, null),
	    q3LabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    samples: 50,
	    sortKey: "x",
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryBoxPlot, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getDomain
	});
	Object.defineProperty(VictoryBoxPlot, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getData
	});
	Object.defineProperty(VictoryBoxPlot, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryBoxPlot, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["maxComponent", "maxLabelComponent", "medianComponent", "medianLabelComponent", "minComponent", "minLabelComponent", "q1Component", "q1LabelComponent", "q3Component", "q3LabelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryBoxPlot, options);
	
	exports.default = _default;

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.brushContainerMixin = void 0;
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _brushHelpers = _interopRequireDefault(__webpack_require__(667));
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var brushContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_base) {
	    _inherits(VictoryBrushContainer, _base);
	
	    function VictoryBrushContainer() {
	      _classCallCheck(this, VictoryBrushContainer);
	
	      return _possibleConstructorReturn(this, (VictoryBrushContainer.__proto__ || Object.getPrototypeOf(VictoryBrushContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryBrushContainer, [{
	      key: "getSelectBox",
	      value: function getSelectBox(props, coordinates) {
	        var x = coordinates.x,
	            y = coordinates.y;
	        var brushStyle = props.brushStyle,
	            brushComponent = props.brushComponent,
	            name = props.name;
	        var brushComponentStyle = brushComponent.props && brushComponent.props.style;
	        var cursor = !props.allowDrag && !props.allowResize ? "auto" : "move";
	        return x[0] !== x[1] && y[0] !== y[1] ? _react.default.cloneElement(brushComponent, {
	          key: "".concat(name, "-brush"),
	          width: Math.abs(x[1] - x[0]) || 1,
	          height: Math.abs(y[1] - y[0]) || 1,
	          x: Math.min(x[0], x[1]),
	          y: Math.min(y[0], y[1]),
	          cursor: cursor,
	          style: (0, _defaults2.default)({}, brushComponentStyle, brushStyle)
	        }) : null;
	      }
	    }, {
	      key: "getCursorPointers",
	      value: function getCursorPointers(props) {
	        var cursors = {
	          yProps: "ns-resize",
	          xProps: "ew-resize"
	        };
	
	        if (!props.allowResize && props.allowDrag) {
	          cursors.xProps = "move";
	          cursors.yProps = "move";
	        } else if (!props.allowResize && !props.allowDrag) {
	          cursors.xProps = "auto";
	          cursors.yProps = "auto";
	        }
	
	        return cursors;
	      }
	    }, {
	      key: "getHandles",
	      value: function getHandles(props, domain) {
	        var handleWidth = props.handleWidth,
	            handleStyle = props.handleStyle,
	            handleComponent = props.handleComponent,
	            name = props.name;
	
	        var domainBox = _brushHelpers.default.getDomainBox(props, domain);
	
	        var x1 = domainBox.x1,
	            x2 = domainBox.x2,
	            y1 = domainBox.y1,
	            y2 = domainBox.y2;
	
	        var _BrushHelpers$getHand = _brushHelpers.default.getHandles(props, domainBox),
	            top = _BrushHelpers$getHand.top,
	            bottom = _BrushHelpers$getHand.bottom,
	            left = _BrushHelpers$getHand.left,
	            right = _BrushHelpers$getHand.right;
	
	        var width = Math.abs(x2 - x1) || 1;
	        var height = Math.abs(y2 - y1) || 1;
	        var handleComponentStyle = handleComponent.props && handleComponent.props.style || {};
	        var style = (0, _defaults2.default)({}, handleComponentStyle, handleStyle);
	        var cursors = this.getCursorPointers(props);
	        var yProps = {
	          style: style,
	          width: width,
	          height: handleWidth,
	          cursor: cursors.yProps
	        };
	        var xProps = {
	          style: style,
	          width: handleWidth,
	          height: height,
	          cursor: cursors.xProps
	        };
	        var handleProps = {
	          top: top && (0, _assign2.default)({
	            x: top.x1,
	            y: top.y1
	          }, yProps),
	          bottom: bottom && (0, _assign2.default)({
	            x: bottom.x1,
	            y: bottom.y1
	          }, yProps),
	          left: left && (0, _assign2.default)({
	            y: left.y1,
	            x: left.x1
	          }, xProps),
	          right: right && (0, _assign2.default)({
	            y: right.y1,
	            x: right.x1
	          }, xProps)
	        };
	        var handles = ["top", "bottom", "left", "right"].reduce(function (memo, curr) {
	          memo = handleProps[curr] ? memo.concat(_react.default.cloneElement(handleComponent, (0, _assign2.default)({
	            key: "".concat(name, "-handle-").concat(curr)
	          }, handleProps[curr]))) : memo;
	          return memo;
	        }, []);
	        return handles.length ? handles : null;
	      }
	    }, {
	      key: "getRect",
	      value: function getRect(props) {
	        var currentDomain = props.currentDomain,
	            cachedBrushDomain = props.cachedBrushDomain;
	        var brushDomain = (0, _defaults2.default)({}, props.brushDomain, props.domain);
	        var domain = (0, _reactFastCompare.default)(brushDomain, cachedBrushDomain) ? (0, _defaults2.default)({}, currentDomain, brushDomain) : brushDomain;
	
	        var coordinates = _victoryCore.Selection.getDomainCoordinates(props, domain);
	
	        var selectBox = this.getSelectBox(props, coordinates);
	        return selectBox ? [selectBox, this.getHandles(props, domain)] : [];
	      } // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        return _toConsumableArray(_react.default.Children.toArray(props.children)).concat(_toConsumableArray(this.getRect(props)));
	      }
	    }]);
	
	    return VictoryBrushContainer;
	  }(base), Object.defineProperty(_class, "displayName", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: "VictoryBrushContainer"
	  }), Object.defineProperty(_class, "propTypes", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.propTypes, {
	      allowDrag: _propTypes.default.bool,
	      allowDraw: _propTypes.default.bool,
	      allowResize: _propTypes.default.bool,
	      brushComponent: _propTypes.default.element,
	      brushDimension: _propTypes.default.oneOf(["x", "y"]),
	      brushDomain: _propTypes.default.shape({
	        x: _propTypes.default.array,
	        y: _propTypes.default.array
	      }),
	      brushStyle: _propTypes.default.object,
	      defaultBrushArea: _propTypes.default.oneOf(["all", "disable", "none", "move"]),
	      disable: _propTypes.default.bool,
	      handleComponent: _propTypes.default.element,
	      handleStyle: _propTypes.default.object,
	      handleWidth: _propTypes.default.number,
	      onBrushCleared: _propTypes.default.func,
	      onBrushDomainChange: _propTypes.default.func,
	      onBrushDomainChangeEnd: _propTypes.default.func
	    })
	  }), Object.defineProperty(_class, "defaultProps", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.defaultProps, {
	      allowDrag: true,
	      allowDraw: true,
	      allowResize: true,
	      brushComponent: _react.default.createElement(_victoryCore.Rect, null),
	      brushStyle: {
	        stroke: "transparent",
	        fill: "black",
	        fillOpacity: 0.1
	      },
	      handleComponent: _react.default.createElement(_victoryCore.Rect, null),
	      handleStyle: {
	        stroke: "transparent",
	        fill: "transparent"
	      },
	      handleWidth: 8,
	      mouseMoveThreshold: 0
	    })
	  }), Object.defineProperty(_class, "defaultEvents", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function (props) {
	      return [{
	        target: "parent",
	        eventHandlers: {
	          onMouseDown: function (evt, targetProps) {
	            return props.disable ? {} : _brushHelpers.default.onMouseDown(evt, targetProps);
	          },
	          onTouchStart: function (evt, targetProps) {
	            return props.disable ? {} : _brushHelpers.default.onMouseDown(evt, targetProps);
	          },
	          onMouseMove: function (evt, targetProps) {
	            return props.disable ? {} : _brushHelpers.default.onMouseMove(evt, targetProps);
	          },
	          onTouchMove: function (evt, targetProps) {
	            return props.disable ? {} : _brushHelpers.default.onMouseMove(evt, targetProps);
	          },
	          onMouseUp: function (evt, targetProps) {
	            return props.disable ? {} : _brushHelpers.default.onMouseUp(evt, targetProps);
	          },
	          onTouchEnd: function (evt, targetProps) {
	            return props.disable ? {} : _brushHelpers.default.onMouseUp(evt, targetProps);
	          },
	          onMouseLeave: function (evt, targetProps) {
	            return props.disable ? {} : _brushHelpers.default.onMouseLeave(evt, targetProps);
	          },
	          onTouchCancel: function (evt, targetProps) {
	            return props.disable ? {} : _brushHelpers.default.onMouseLeave(evt, targetProps);
	          }
	        }
	      }];
	    }
	  }), _temp;
	};
	
	exports.brushContainerMixin = brushContainerMixin;
	
	var _default = brushContainerMixin(_victoryCore.VictoryContainer);
	
	exports.default = _default;

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryBrushLine", {
	  enumerable: true,
	  get: function () {
	    return _victoryBrushLine.default;
	  }
	});
	
	var _victoryBrushLine = _interopRequireDefault(__webpack_require__(1852));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _pick2 = _interopRequireDefault(__webpack_require__(152));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var SMALL_NUMBER = 1 / Number.MAX_SAFE_INTEGER;
	
	var getScale = function (props) {
	  var _props$scale = props.scale,
	      scale = _props$scale === void 0 ? {} : _props$scale,
	      _props$dimension = props.dimension,
	      dimension = _props$dimension === void 0 ? "x" : _props$dimension;
	
	  if (scale[dimension]) {
	    return scale[dimension];
	  }
	
	  var fallbackScale = _victoryCore.Scale.getBaseScale(props, dimension);
	
	  var range = _victoryCore.Helpers.getRange(props, dimension);
	
	  var domain = _victoryCore.Domain.getDomainFromProps(props, dimension) || [0, 1];
	  fallbackScale.range(range).domain(domain);
	  return fallbackScale;
	};
	
	var getDimension = function (props) {
	  var horizontal = props.horizontal,
	      _props$dimension2 = props.dimension,
	      dimension = _props$dimension2 === void 0 ? "x" : _props$dimension2;
	
	  if (!horizontal) {
	    return dimension;
	  }
	
	  return dimension === "x" ? "y" : "x";
	};
	
	var toRange = function (props, domain) {
	  var scale = getScale(props);
	  return [scale(Math.min.apply(Math, _toConsumableArray(domain))), scale(Math.max.apply(Math, _toConsumableArray(domain)))];
	};
	
	var toDomain = function (props, range) {
	  var scale = getScale(props);
	  return [scale.invert(Math.min.apply(Math, _toConsumableArray(range))), scale.invert(Math.max.apply(Math, _toConsumableArray(range)))];
	};
	
	var getFullRange = function (props) {
	  var scale = getScale(props);
	  return scale.range();
	};
	
	var getFullDomain = function (props) {
	  var scale = getScale(props);
	  return scale.domain();
	};
	
	var withinBound = function (value, bound) {
	  return value >= _victoryCore.Collection.getMinValue(bound) && value <= _victoryCore.Collection.getMaxValue(bound);
	};
	
	var getBrushDomain = function (brushDomain, fullDomain) {
	  if (brushDomain) {
	    var brushMin = _victoryCore.Collection.getMinValue(brushDomain);
	
	    var brushMax = _victoryCore.Collection.getMaxValue(brushDomain);
	
	    var domainMin = _victoryCore.Collection.getMinValue(fullDomain);
	
	    var domainMax = _victoryCore.Collection.getMaxValue(fullDomain);
	
	    var defaultMin = brushMin < domainMin ? domainMin : domainMax - SMALL_NUMBER;
	    var defaultMax = brushMax > domainMax ? domainMax : domainMin + SMALL_NUMBER;
	    var min = withinBound(brushMin, fullDomain) ? brushMin : defaultMin;
	    var max = withinBound(brushMax, fullDomain) ? brushMax : defaultMax;
	    return [min, max];
	  }
	
	  return fullDomain;
	};
	
	var getActiveHandle = function (props, position, range) {
	  var width = props.handleWidth / 2;
	  var dimension = getDimension(props);
	
	  var getHandle = function (type) {
	    var base = {
	      min: dimension === "x" ? Math.min.apply(Math, _toConsumableArray(range)) : Math.max.apply(Math, _toConsumableArray(range)),
	      max: dimension === "x" ? Math.max.apply(Math, _toConsumableArray(range)) : Math.min.apply(Math, _toConsumableArray(range))
	    };
	    return [base[type] - width, base[type] + width];
	  };
	
	  var active = ["min", "max"].reduce(function (memo, type) {
	    memo[type] = withinBound(position, getHandle(type)) ? type : undefined;
	    return memo;
	  }, {});
	  return active.min && active.max ? "both" : active.min || active.max;
	};
	
	var getMinimumDomain = function () {
	  return [0, SMALL_NUMBER];
	};
	
	var panBox = function (props, position) {
	  var brushDomain = props.brushDomain,
	      startPosition = props.startPosition;
	  var range = toRange(props, brushDomain);
	  var fullRange = getFullRange(props);
	  var size = Math.abs(range[1] - range[0]);
	  var globalMin = Math.min.apply(Math, _toConsumableArray(fullRange));
	  var globalMax = Math.max.apply(Math, _toConsumableArray(fullRange));
	  var delta = startPosition ? startPosition - position : 0;
	  var min = Math.min.apply(Math, _toConsumableArray(range)) - delta;
	  var max = Math.max.apply(Math, _toConsumableArray(range)) - delta;
	  var constrainedMin = min > globalMax - size ? globalMax - size : Math.max(min, globalMin);
	  var constrainedMax = max < globalMin + size ? globalMin + size : Math.min(max, globalMax);
	  return [constrainedMin, constrainedMax];
	};
	
	var fallbackProps = {
	  brushAreaStyle: {
	    stroke: "none",
	    fill: "black",
	    opacity: function (_ref) {
	      var active = _ref.active;
	      return active ? 0.2 : 0.1;
	    } // eslint-disable-line no-magic-numbers
	
	  },
	  brushStyle: {
	    pointerEvents: "none",
	    stroke: "none",
	    fill: "black",
	    opacity: function (_ref2) {
	      var active = _ref2.active;
	      return active ? 0.4 : 0.3;
	    } // eslint-disable-line no-magic-numbers
	
	  },
	  handleStyle: {
	    pointerEvents: "none",
	    stroke: "none",
	    fill: "none"
	  }
	};
	
	var VictoryBrushLine =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryBrushLine, _React$Component);
	
	  function VictoryBrushLine() {
	    _classCallCheck(this, VictoryBrushLine);
	
	    return _possibleConstructorReturn(this, (VictoryBrushLine.__proto__ || Object.getPrototypeOf(VictoryBrushLine)).apply(this, arguments));
	  }
	
	  _createClass(VictoryBrushLine, [{
	    key: "getRectDimensions",
	    value: function getRectDimensions(props, brushWidth, domain) {
	      var brushDomain = props.brushDomain;
	      var dimension = getDimension(props);
	      domain = domain || getBrushDomain(brushDomain, getFullDomain(props));
	      var range = toRange(props, domain);
	      var coordinates = dimension === "x" ? {
	        y1: props.y1,
	        y2: props.y2,
	        x1: Math.min.apply(Math, _toConsumableArray(range)),
	        x2: Math.max.apply(Math, _toConsumableArray(range))
	      } : {
	        x1: props.x1,
	        x2: props.x2,
	        y1: Math.min.apply(Math, _toConsumableArray(range)),
	        y2: Math.max.apply(Math, _toConsumableArray(range))
	      };
	      var x1 = coordinates.x1,
	          x2 = coordinates.x2,
	          y1 = coordinates.y1,
	          y2 = coordinates.y2;
	      var offset = {
	        x: dimension === "x" ? 0 : brushWidth / 2,
	        y: dimension === "y" ? 0 : brushWidth / 2
	      };
	      var x = Math.min(x1, x2) - offset.x;
	      var y = Math.min(y1, y2) - offset.y;
	      var width = Math.max(x1, x2) + offset.x - x;
	      var height = Math.max(y1, y2) + offset.y - y;
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    }
	  }, {
	    key: "getHandleDimensions",
	    value: function getHandleDimensions(props) {
	      var handleWidth = props.handleWidth,
	          x1 = props.x1,
	          x2 = props.x2,
	          y1 = props.y1,
	          y2 = props.y2,
	          brushDomain = props.brushDomain;
	      var dimension = getDimension(props);
	      var brushWidth = props.brushWidth || props.width;
	      var domain = getBrushDomain(brushDomain, getFullDomain(props));
	      var range = toRange(props, domain);
	      var defaultX = Math.min(x1, x2) - brushWidth / 2;
	      var defaultY = Math.min(y1, y2) - brushWidth / 2;
	      var x = {
	        min: dimension === "x" ? Math.min.apply(Math, _toConsumableArray(range)) - handleWidth / 2 : defaultX,
	        max: dimension === "x" ? Math.max.apply(Math, _toConsumableArray(range)) - handleWidth / 2 : defaultX
	      };
	      var y = {
	        min: dimension === "y" ? Math.max.apply(Math, _toConsumableArray(range)) - handleWidth / 2 : defaultY,
	        max: dimension === "y" ? Math.min.apply(Math, _toConsumableArray(range)) - handleWidth / 2 : defaultY
	      };
	      var width = dimension === "x" ? handleWidth : brushWidth;
	      var height = dimension === "x" ? brushWidth : handleWidth;
	      return {
	        min: {
	          x: x.min,
	          y: y.min,
	          width: width,
	          height: height
	        },
	        max: {
	          x: x.max,
	          y: y.max,
	          width: width,
	          height: height
	        }
	      };
	    }
	  }, {
	    key: "getCursor",
	    value: function getCursor(props) {
	      var _props$activeBrushes = props.activeBrushes,
	          activeBrushes = _props$activeBrushes === void 0 ? {} : _props$activeBrushes;
	      var dimension = getDimension(props);
	
	      if (activeBrushes.minHandle || activeBrushes.maxHandle) {
	        return dimension === "x" ? "ew-resize" : "ns-resize";
	      } else if (activeBrushes.brush) {
	        return "move";
	      }
	
	      return "crosshair";
	    }
	  }, {
	    key: "renderHandles",
	    value: function renderHandles(props) {
	      var handleComponent = props.handleComponent,
	          handleStyle = props.handleStyle,
	          id = props.id,
	          brushDomain = props.brushDomain,
	          _props$datum = props.datum,
	          datum = _props$datum === void 0 ? {} : _props$datum,
	          _props$activeBrushes2 = props.activeBrushes,
	          activeBrushes = _props$activeBrushes2 === void 0 ? {} : _props$activeBrushes2;
	
	      if (!brushDomain) {
	        return null;
	      }
	
	      var handleDimensions = this.getHandleDimensions(props);
	      var style = (0, _assign2.default)({}, fallbackProps.handleStyle, handleStyle);
	      var minDatum = (0, _assign2.default)({
	        handleValue: _victoryCore.Collection.getMinValue(brushDomain)
	      }, datum);
	      var maxDatum = (0, _assign2.default)({
	        handleValue: _victoryCore.Collection.getMaxValue(brushDomain)
	      }, datum);
	      var minHandleProps = (0, _assign2.default)({
	        key: "".concat(id, "-min"),
	        style: _victoryCore.Helpers.evaluateStyle(style, {
	          datum: minDatum,
	          active: activeBrushes.minHandle
	        })
	      }, handleDimensions.min);
	      var maxHandleProps = (0, _assign2.default)({
	        key: "".concat(id, "-max"),
	        style: _victoryCore.Helpers.evaluateStyle(style, {
	          datum: maxDatum,
	          active: activeBrushes.maxHandle
	        })
	      }, handleDimensions.max);
	      return [_react.default.cloneElement(handleComponent, minHandleProps), _react.default.cloneElement(handleComponent, maxHandleProps)];
	    }
	  }, {
	    key: "renderBrush",
	    value: function renderBrush(props) {
	      var brushComponent = props.brushComponent,
	          brushStyle = props.brushStyle,
	          _props$activeBrushes3 = props.activeBrushes,
	          activeBrushes = _props$activeBrushes3 === void 0 ? {} : _props$activeBrushes3,
	          _props$datum2 = props.datum,
	          datum = _props$datum2 === void 0 ? {} : _props$datum2,
	          brushDomain = props.brushDomain;
	
	      if (!brushDomain) {
	        return null;
	      }
	
	      var brushWidth = props.brushWidth || props.width;
	      var rectDimensions = this.getRectDimensions(props, brushWidth);
	      var baseStyle = (0, _assign2.default)({}, fallbackProps.brushStyle, brushStyle);
	
	      var style = _victoryCore.Helpers.evaluateStyle(baseStyle, {
	        datum: datum,
	        active: activeBrushes.brush
	      });
	
	      var brushProps = (0, _assign2.default)({
	        style: style
	      }, rectDimensions);
	      return _react.default.cloneElement(brushComponent, brushProps);
	    }
	  }, {
	    key: "renderBrushArea",
	    value: function renderBrushArea(props) {
	      var brushAreaComponent = props.brushAreaComponent,
	          brushAreaStyle = props.brushAreaStyle,
	          _props$activeBrushes4 = props.activeBrushes,
	          activeBrushes = _props$activeBrushes4 === void 0 ? {} : _props$activeBrushes4,
	          _props$datum3 = props.datum,
	          datum = _props$datum3 === void 0 ? {} : _props$datum3;
	      var brushAreaWidth = props.brushAreaWidth || props.width;
	      var cursor = this.getCursor(props);
	      var rectDimensions = this.getRectDimensions(props, brushAreaWidth, getFullDomain(props));
	      var baseStyle = (0, _assign2.default)({
	        cursor: cursor
	      }, fallbackProps.brushAreaStyle, brushAreaStyle);
	
	      var style = _victoryCore.Helpers.evaluateStyle(baseStyle, {
	        datum: datum,
	        active: activeBrushes.brushArea
	      });
	
	      var brushAreaProps = (0, _assign2.default)({
	        style: style
	      }, rectDimensions);
	      return _react.default.cloneElement(brushAreaComponent, brushAreaProps);
	    }
	  }, {
	    key: "renderLine",
	    value: function renderLine(props) {
	      var filteredProps = (0, _pick2.default)(props, ["x1", "x2", "y1", "y2", "datum", "scale", "active", "style"]);
	      return _react.default.cloneElement(props.lineComponent, filteredProps);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react.default.createElement("g", this.props.events, this.renderLine(this.props), this.renderBrushArea(this.props), this.renderBrush(this.props), this.renderHandles(this.props));
	    }
	  }]);
	
	  return VictoryBrushLine;
	}(_react.default.Component);
	
	exports.default = VictoryBrushLine;
	Object.defineProperty(VictoryBrushLine, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    allowDrag: _propTypes.default.bool,
	    allowDraw: _propTypes.default.bool,
	    allowResize: _propTypes.default.bool,
	    brushAreaComponent: _propTypes.default.element,
	    brushAreaStyle: _propTypes.default.object,
	    brushAreaWidth: _propTypes.default.number,
	    brushComponent: _propTypes.default.element,
	    brushDimension: _propTypes.default.oneOf(["x", "y"]),
	    brushDomain: _propTypes.default.array,
	    brushStyle: _propTypes.default.object,
	    brushWidth: _propTypes.default.number,
	    className: _propTypes.default.string,
	    dimension: _propTypes.default.oneOf(["x", "y"]),
	    disable: _propTypes.default.bool,
	    events: _propTypes.default.object,
	    groupComponent: _propTypes.default.element,
	    handleComponent: _propTypes.default.element,
	    handleStyle: _propTypes.default.object,
	    handleWidth: _propTypes.default.number,
	    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    lineComponent: _propTypes.default.element,
	    name: _propTypes.default.string,
	    onBrushDomainChange: _propTypes.default.func,
	    scale: _propTypes.default.object,
	    style: _propTypes.default.object,
	    type: _propTypes.default.string,
	    width: _propTypes.default.number
	  }
	});
	Object.defineProperty(VictoryBrushLine, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    allowDrag: true,
	    allowDraw: true,
	    allowResize: true,
	    brushAreaComponent: _react.default.createElement(_victoryCore.Box, null),
	    brushComponent: _react.default.createElement(_victoryCore.Box, null),
	    groupComponent: _react.default.createElement("g", null),
	    handleComponent: _react.default.createElement(_victoryCore.Box, null),
	    handleWidth: 10,
	    lineComponent: _react.default.createElement(_victoryCore.LineSegment, null),
	    width: 10
	  }
	});
	Object.defineProperty(VictoryBrushLine, "defaultEvents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return props.disable ? undefined : [{
	      target: props.type,
	      eventHandlers: {
	        onMouseEnter: function (evt, targetProps) {
	          evt.preventDefault();
	          var allowResize = targetProps.allowResize,
	              brushDomain = targetProps.brushDomain;
	          var dimension = getDimension(targetProps);
	
	          var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	          var position = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG)[dimension];
	
	          var fullDomain = getFullDomain(targetProps);
	          var currentDomain = getBrushDomain(brushDomain, fullDomain);
	          var range = toRange(targetProps, currentDomain);
	          var activeHandle = allowResize && getActiveHandle(targetProps, position, range);
	          var activeBrushes = {
	            brushArea: !targetProps.brushDomain,
	            brush: withinBound(position, range) && !(0, _reactFastCompare.default)(fullDomain, currentDomain),
	            minHandle: activeHandle === "min" || activeHandle === "both",
	            maxHandle: activeHandle === "min" || activeHandle === "both"
	          };
	          return [{
	            mutation: function () {
	              return {
	                activeBrushes: activeBrushes,
	                brushDomain: targetProps.brushDomain,
	                parentSVG: parentSVG
	              };
	            }
	          }];
	        },
	        onMouseDown: function (evt, targetProps) {
	          evt.preventDefault();
	          var allowResize = targetProps.allowResize,
	              allowDrag = targetProps.allowDrag,
	              allowDraw = targetProps.allowDraw,
	              activeBrushes = targetProps.activeBrushes,
	              brushDomain = targetProps.brushDomain;
	          var dimension = getDimension(targetProps); // Don't trigger events for static brushes
	
	          if (!allowResize && !allowDrag) {
	            return [];
	          }
	
	          var fullDomain = getFullDomain(targetProps);
	          var currentDomain = getBrushDomain(brushDomain, fullDomain);
	
	          var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	          var position = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG)[dimension];
	
	          var range = toRange(targetProps, currentDomain);
	          var activeHandle = allowResize && getActiveHandle(targetProps, position, range); // If the event occurs in any of the handle regions, start a resize
	
	          if (activeHandle) {
	            return [{
	              mutation: function () {
	                return {
	                  parentSVG: parentSVG,
	                  isSelecting: true,
	                  activeHandle: activeHandle,
	                  brushDomain: currentDomain,
	                  startPosition: position,
	                  activeBrushes: activeBrushes
	                };
	              }
	            }];
	          } else if (withinBound(position, range) && !(0, _reactFastCompare.default)(fullDomain, currentDomain)) {
	            // if the event occurs within a selected region start a panning event, unless the whole
	            // domain is selected
	            return [{
	              mutation: function () {
	                return {
	                  isPanning: allowDrag,
	                  startPosition: position,
	                  brushDomain: currentDomain,
	                  activeBrushes: activeBrushes,
	                  parentSVG: parentSVG
	                };
	              }
	            }];
	          } else {
	            // if the event occurs outside the region, or if the whole domain is selected,
	            // start a new selection
	            return allowDraw ? [{
	              mutation: function () {
	                return {
	                  isSelecting: allowResize,
	                  brushDomain: null,
	                  startPosition: position,
	                  activeBrushes: activeBrushes,
	                  parentSVG: parentSVG
	                };
	              }
	            }] : [];
	          }
	        },
	        // eslint-disable-next-line max-statements, complexity
	        onMouseMove: function (evt, targetProps) {
	          var isPanning = targetProps.isPanning,
	              isSelecting = targetProps.isSelecting,
	              allowResize = targetProps.allowResize,
	              allowDrag = targetProps.allowDrag,
	              onBrushDomainChange = targetProps.onBrushDomainChange,
	              brushDomain = targetProps.brushDomain;
	          var dimension = getDimension(targetProps);
	
	          if (isPanning || isSelecting) {
	            evt.preventDefault();
	            evt.stopPropagation();
	          }
	
	          var parentSVG = targetProps.parentSVG || _victoryCore.Selection.getParentSVG(evt);
	
	          var position = _victoryCore.Selection.getSVGEventCoordinates(evt, parentSVG)[dimension];
	
	          var fullDomain = getFullDomain(targetProps);
	          var domain = getBrushDomain(brushDomain, fullDomain);
	          var initialRange = toRange(targetProps, domain);
	          var activeHandle = getActiveHandle(targetProps, position, initialRange);
	          var activeBrushes = {
	            brushArea: !targetProps.brushDomain,
	            brush: withinBound(position, initialRange) && !(0, _reactFastCompare.default)(fullDomain, domain),
	            minHandle: activeHandle === "min" || activeHandle === "both",
	            maxHandle: activeHandle === "max" || activeHandle === "both"
	          };
	
	          if (!targetProps.isPanning && !targetProps.isSelecting) {
	            return [{
	              mutation: function () {
	                return {
	                  activeBrushes: activeBrushes,
	                  brushDomain: targetProps.brushDomain,
	                  parentSVG: parentSVG
	                };
	              }
	            }];
	          }
	
	          if (allowDrag && isPanning) {
	            var fullRange = getFullRange(targetProps);
	            var range = panBox(targetProps, position);
	            var currentDomain = toDomain(targetProps, range);
	            var startPosition = Math.max.apply(Math, _toConsumableArray(range)) >= Math.max.apply(Math, _toConsumableArray(fullRange)) || Math.min.apply(Math, _toConsumableArray(range)) <= Math.min.apply(Math, _toConsumableArray(fullRange)) ? targetProps.startPosition : position;
	            var mutatedProps = {
	              startPosition: startPosition,
	              isPanning: true,
	              brushDomain: currentDomain,
	              activeBrushes: {
	                brush: true
	              },
	              parentSVG: parentSVG
	            };
	
	            if ((0, _isFunction2.default)(onBrushDomainChange)) {
	              onBrushDomainChange(currentDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	            }
	
	            return [{
	              mutation: function () {
	                return mutatedProps;
	              }
	            }];
	          } else if (allowResize && isSelecting) {
	            var _currentDomain = brushDomain || getMinimumDomain();
	
	            var _range = toRange(targetProps, _currentDomain);
	
	            var oppositeHandle = targetProps.activeHandle === "min" ? "max" : "min";
	            var handle = targetProps.activeHandle && getActiveHandle(targetProps, position, _range) === "both" ? oppositeHandle : targetProps.activeHandle;
	
	            if (!handle) {
	              _currentDomain = toDomain(targetProps, [targetProps.startPosition, position]);
	            } else {
	              var rangeMax = dimension === "x" ? Math.max.apply(Math, _toConsumableArray(_range)) : Math.min.apply(Math, _toConsumableArray(_range));
	              var rangeMin = dimension === "x" ? Math.min.apply(Math, _toConsumableArray(_range)) : Math.max.apply(Math, _toConsumableArray(_range));
	              var min = handle === "max" ? rangeMin : position;
	              var max = handle === "min" ? rangeMax : position;
	              _currentDomain = toDomain(targetProps, [min, max]);
	            }
	
	            var _mutatedProps = {
	              brushDomain: _currentDomain,
	              startPosition: targetProps.startPosition,
	              isSelecting: isSelecting,
	              activeHandle: handle,
	              parentSVG: parentSVG,
	              activeBrushes: {
	                brush: true,
	                minHandle: activeHandle === "min",
	                maxHandle: activeHandle === "max"
	              }
	            };
	
	            if ((0, _isFunction2.default)(onBrushDomainChange)) {
	              onBrushDomainChange(_currentDomain, (0, _defaults2.default)({}, _mutatedProps, targetProps));
	            }
	
	            return [{
	              mutation: function () {
	                return _mutatedProps;
	              }
	            }];
	          }
	
	          return [];
	        },
	        onMouseUp: function (evt, targetProps) {
	          var onBrushDomainChange = targetProps.onBrushDomainChange,
	              brushDomain = targetProps.brushDomain,
	              allowResize = targetProps.allowResize,
	              activeBrushes = targetProps.activeBrushes; // if the mouse hasn't moved since a mouseDown event, select the whole domain region
	
	          var mutatedProps = {
	            isPanning: false,
	            isSelecting: false,
	            activeHandle: null,
	            startPosition: null,
	            brushDomain: brushDomain,
	            activeBrushes: activeBrushes
	          };
	
	          if (allowResize && (0, _isFunction2.default)(onBrushDomainChange)) {
	            onBrushDomainChange(brushDomain, (0, _defaults2.default)({}, mutatedProps, targetProps));
	          }
	
	          return [{
	            mutation: function () {
	              return mutatedProps;
	            }
	          }];
	        },
	        onMouseLeave: function (evt, targetProps) {
	          var brushDomain = targetProps.brushDomain;
	          return [{
	            mutation: function () {
	              return {
	                isPanning: false,
	                isSelecting: false,
	                activeHandle: null,
	                startPosition: null,
	                brushDomain: brushDomain,
	                activeBrushes: {}
	              };
	            }
	          }];
	        }
	      }
	    }];
	  }
	});

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getData = exports.getDomain = exports.getBaseProps = void 0;
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = ["close", "open", "high", "low"];
	
	var getData = function (props) {
	  var accessorTypes = ["x", "high", "low", "close", "open"];
	  return _victoryCore.Data.formatData(props.data, props, accessorTypes);
	};
	
	exports.getData = getData;
	
	var reduceData = function (dataset, axis, type) {
	  var yDataTypes = {
	    min: "_low",
	    max: "_high"
	  };
	  var dataType = axis === "x" ? "_x" : yDataTypes[type];
	  var baseCondition = type === "min" ? Infinity : -Infinity;
	  return dataset.reduce(function (memo, datum) {
	    var current = datum[dataType];
	    return memo < current && type === "min" || memo > current && type === "max" ? memo : current;
	  }, baseCondition);
	};
	
	var getDomainFromData = function (props, axis) {
	  var minDomain = _victoryCore.Domain.getMinFromProps(props, axis);
	
	  var maxDomain = _victoryCore.Domain.getMaxFromProps(props, axis);
	
	  var dataset = getData(props);
	
	  if (dataset.length < 1) {
	    return minDomain !== undefined && maxDomain !== undefined ? _victoryCore.Domain.getDomainFromMinMax(minDomain, maxDomain) : undefined;
	  }
	
	  var min = minDomain !== undefined ? minDomain : reduceData(dataset, axis, "min");
	  var max = maxDomain !== undefined ? maxDomain : reduceData(dataset, axis, "max");
	  return _victoryCore.Domain.getDomainFromMinMax(min, max);
	};
	
	var getDomain = function (props, axis) {
	  return _victoryCore.Domain.createDomainFunction(getDomainFromData)(props, axis);
	};
	
	exports.getDomain = getDomain;
	
	var getStyles = function (style) {
	  var defaultStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var width = "100%";
	  var height = "100%";
	
	  if (!style) {
	    return (0, _defaults2.default)({
	      parent: {
	        height: height,
	        width: width
	      }
	    }, defaultStyles);
	  }
	
	  var defaultParent = defaultStyles.parent || {};
	  var defaultLabels = defaultStyles.labels || {};
	  var defaultData = defaultStyles.data || {};
	  var labelStyle = (0, _defaults2.default)({}, style.labels, defaultLabels);
	  return {
	    parent: (0, _defaults2.default)({}, style.parent, defaultParent, {
	      width: width,
	      height: height
	    }),
	    labels: labelStyle,
	    data: (0, _defaults2.default)({}, style.data, defaultData),
	    openLabels: (0, _defaults2.default)({}, style.openLabels, defaultStyles.openLabels, labelStyle),
	    closeLabels: (0, _defaults2.default)({}, style.closeLabels, defaultStyles.closeLabels, labelStyle),
	    lowLabels: (0, _defaults2.default)({}, style.lowLabels, defaultStyles.lowLabels, labelStyle),
	    highLabels: (0, _defaults2.default)({}, style.highLabels, defaultStyles.highLabels, labelStyle)
	  };
	};
	
	var getCalculatedValues = function (props) {
	  var theme = props.theme,
	      polar = props.polar;
	  var defaultStyle = theme && theme.candlestick && theme.candlestick.style ? theme.candlestick.style : {};
	  var style = getStyles(props.style, defaultStyle);
	  var data = getData(props);
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var domain = {
	    x: getDomain(props, "x"),
	    y: getDomain(props, "y")
	  };
	  var scale = {
	    x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var origin = polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	  var defaultOrientation = props.horizontal ? "top" : "right";
	  var labelOrientation = props.labelOrientation || defaultOrientation;
	  return {
	    domain: domain,
	    data: data,
	    scale: scale,
	    style: style,
	    origin: origin,
	    labelOrientation: labelOrientation
	  };
	};
	
	var isTransparent = function (attr) {
	  return attr === "none" || attr === "transparent";
	};
	
	var getDataStyles = function (datum, style, props) {
	  style = style || {};
	  var candleColor = datum._open > datum._close ? props.candleColors.negative : props.candleColors.positive;
	  var fill = style.fill || candleColor;
	  var strokeColor = style.stroke;
	  var stroke = isTransparent(strokeColor) ? fill : strokeColor || "black";
	  return (0, _assign2.default)({}, style, {
	    stroke: stroke,
	    fill: fill
	  });
	};
	
	var getText = function (props, type) {
	  var datum = props.datum,
	      index = props.index,
	      labels = props.labels;
	  var propName = "".concat(type, "Labels");
	  var labelProp = props[propName];
	
	  if (!labelProp && !labels) {
	    return null;
	  } else if (labelProp === true || labels === true) {
	    var dataName = "_".concat(type);
	    return "".concat(datum[dataName]);
	  }
	
	  return Array.isArray(labelProp) ? labelProp[index] : labelProp;
	};
	
	var getCandleWidth = function (props, style) {
	  var data = props.data,
	      candleWidth = props.candleWidth,
	      scale = props.scale,
	      defaultCandleWidth = props.defaultCandleWidth;
	
	  if (candleWidth) {
	    return (0, _isFunction2.default)(candleWidth) ? _victoryCore.Helpers.evaluateProp(candleWidth, props) : candleWidth;
	  } else if (style && style.width) {
	    return style.width;
	  }
	
	  var range = scale.x.range();
	  var extent = Math.abs(range[1] - range[0]);
	  var candles = data.length + 2;
	  var candleRatio = props.candleRatio || 0.5;
	  var defaultWidth = candleRatio * (data.length < 2 ? defaultCandleWidth : extent / candles);
	  return Math.max(1, defaultWidth);
	};
	
	var getOrientation = function (labelOrientation) {
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "labels";
	  return (0, _isPlainObject2.default)(labelOrientation) ? labelOrientation[type] : labelOrientation;
	};
	/* eslint-disable complexity*/
	
	
	var calculatePlotValues = function (props) {
	  var positions = props.positions,
	      labelStyle = props.labelStyle,
	      x = props.x,
	      horizontal = props.horizontal,
	      computedType = props.computedType,
	      candleWidth = props.candleWidth,
	      orientation = props.orientation;
	  positions.labels = (positions.open + positions.close) / 2;
	  var signX = orientation === "left" ? -1 : 1;
	  var signY = orientation === "top" ? -1 : 1;
	
	  if (horizontal) {
	    var yValue = x;
	    var xValue = positions[computedType];
	    var dy = orientation === "top" || orientation === "bottom" ? signY * (candleWidth / 2) + signY * (labelStyle.padding || 0) : 0;
	    var dx = orientation === "top" || orientation === "bottom" ? 0 : signX * (labelStyle.padding || 1);
	    return {
	      yValue: yValue,
	      xValue: xValue,
	      dx: dx,
	      dy: dy
	    };
	  } else {
	    var _xValue = x;
	    var _yValue = positions[computedType];
	
	    var _dy = orientation === "top" || orientation === "bottom" ? signY * (labelStyle.padding || 1) : 0;
	
	    var _dx = orientation === "top" || orientation === "bottom" ? 0 : signX * (candleWidth / 2) + signX * (labelStyle.padding || 0);
	
	    return {
	      yValue: _yValue,
	      xValue: _xValue,
	      dx: _dx,
	      dy: _dy
	    };
	  }
	};
	/* eslint-enable complexity*/
	
	/* eslint-disable max-params*/
	
	
	var getLabelProps = function (props, text, style, type) {
	  var x = props.x,
	      high = props.high,
	      low = props.low,
	      open = props.open,
	      close = props.close,
	      index = props.index,
	      scale = props.scale,
	      datum = props.datum,
	      data = props.data,
	      horizontal = props.horizontal,
	      candleWidth = props.candleWidth,
	      labelOrientation = props.labelOrientation;
	  var component = props["".concat(type, "LabelComponent")] || props.labelComponent;
	  var defaultOrientation = horizontal ? "top" : "right";
	  var orientation = component.props && component.props.orientation || getOrientation(labelOrientation, type) || defaultOrientation;
	  var positions = {
	    high: high,
	    low: low,
	    open: open,
	    close: close
	  };
	  var namespace = type ? "".concat(type, "Labels") : "labels";
	  var labelStyle = style[namespace] || style.labels;
	  var defaultVerticalAnchors = {
	    top: "end",
	    bottom: "start",
	    left: "middle",
	    right: "middle"
	  };
	  var defaultTextAnchors = {
	    left: "end",
	    right: "start",
	    top: "middle",
	    bottom: "middle"
	  };
	  var computedType = type ? type : "labels";
	  var plotProps = {
	    positions: positions,
	    labelStyle: labelStyle,
	    x: x,
	    horizontal: horizontal,
	    computedType: computedType,
	    candleWidth: candleWidth,
	    orientation: orientation
	  };
	
	  var _calculatePlotValues = calculatePlotValues(plotProps),
	      yValue = _calculatePlotValues.yValue,
	      xValue = _calculatePlotValues.xValue,
	      dx = _calculatePlotValues.dx,
	      dy = _calculatePlotValues.dy;
	
	  return {
	    style: labelStyle,
	    y: yValue,
	    x: xValue,
	    dx: dx,
	    dy: dy,
	    text: text,
	    index: index,
	    scale: scale,
	    datum: datum,
	    data: data,
	    orientation: orientation,
	    textAnchor: labelStyle.textAnchor || defaultTextAnchors[orientation],
	    verticalAnchor: labelStyle.verticalAnchor || defaultVerticalAnchors[orientation],
	    angle: labelStyle.angle,
	    horizontal: horizontal
	  };
	};
	/* eslint-enable max-params*/
	
	
	var getBaseProps = function (props, fallbackProps) {
	  // eslint-disable-line max-statements
	  props = _victoryCore.Helpers.modifyProps(props, fallbackProps, "candlestick");
	  var calculatedValues = getCalculatedValues(props);
	  var data = calculatedValues.data,
	      style = calculatedValues.style,
	      scale = calculatedValues.scale,
	      domain = calculatedValues.domain,
	      origin = calculatedValues.origin,
	      labelOrientation = calculatedValues.labelOrientation;
	  var _props = props,
	      groupComponent = _props.groupComponent,
	      width = _props.width,
	      height = _props.height,
	      padding = _props.padding,
	      standalone = _props.standalone,
	      name = _props.name,
	      candleWidth = _props.candleWidth,
	      candleRatio = _props.candleRatio,
	      theme = _props.theme,
	      polar = _props.polar,
	      wickStrokeWidth = _props.wickStrokeWidth,
	      labels = _props.labels,
	      events = _props.events,
	      sharedEvents = _props.sharedEvents,
	      horizontal = _props.horizontal;
	  var initialChildProps = {
	    parent: {
	      domain: domain,
	      scale: scale,
	      width: width,
	      height: height,
	      data: data,
	      standalone: standalone,
	      theme: theme,
	      polar: polar,
	      origin: origin,
	      name: name,
	      style: style.parent,
	      padding: padding,
	      horizontal: horizontal
	    }
	  };
	  return data.reduce(function (childProps, datum, index) {
	    var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	    var x = scale.x(datum._x1 !== undefined ? datum._x1 : datum._x);
	    var high = scale.y(datum._high);
	    var close = scale.y(datum._close);
	    var open = scale.y(datum._open);
	    var low = scale.y(datum._low);
	    var dataStyle = getDataStyles(datum, style.data, props);
	    var dataProps = {
	      x: x,
	      high: high,
	      low: low,
	      candleWidth: candleWidth,
	      candleRatio: candleRatio,
	      scale: scale,
	      data: data,
	      datum: datum,
	      groupComponent: groupComponent,
	      index: index,
	      style: dataStyle,
	      width: width,
	      polar: polar,
	      origin: origin,
	      wickStrokeWidth: wickStrokeWidth,
	      open: open,
	      close: close,
	      horizontal: horizontal,
	      labelOrientation: labelOrientation
	    };
	    dataProps.candleWidth = getCandleWidth(dataProps);
	    var extendedProps = (0, _defaults2.default)(Object.assign({}, dataProps), props);
	    childProps[eventKey] = {
	      data: dataProps
	    };
	
	    if (labels) {
	      var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	
	      if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
	        childProps[eventKey].labels = getLabelProps(extendedProps, text, style);
	      }
	    }
	
	    TYPES.forEach(function (type) {
	      var labelText = getText(extendedProps, type);
	      var labelProp = props.labels || props["".concat(type, "Labels")];
	
	      if (labelText !== null && labelText !== undefined || labelProp && (events || sharedEvents)) {
	        var target = "".concat(type, "Labels");
	        childProps[eventKey][target] = getLabelProps(extendedProps, labelText, style, type);
	      }
	    });
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryCandlestick", {
	  enumerable: true,
	  get: function () {
	    return _victoryCandlestick.default;
	  }
	});
	Object.defineProperty(exports, "Candle", {
	  enumerable: true,
	  get: function () {
	    return _candle.default;
	  }
	});
	
	var _victoryCandlestick = _interopRequireDefault(__webpack_require__(1855));
	
	var _candle = _interopRequireDefault(__webpack_require__(669));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _flatten2 = _interopRequireDefault(__webpack_require__(150));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _candle = _interopRequireDefault(__webpack_require__(669));
	
	var _helperMethods = __webpack_require__(1853);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*eslint-disable no-magic-numbers */
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  candleColors: {
	    positive: "#ffffff",
	    negative: "#252525"
	  }
	};
	var options = {
	  components: [{
	    name: "lowLabels"
	  }, {
	    name: "highLabels"
	  }, {
	    name: "openLabels"
	  }, {
	    name: "closeLabels"
	  }, {
	    name: "labels"
	  }, {
	    name: "data"
	  }, {
	    name: "parent",
	    index: "parent"
	  }]
	};
	var defaultData = [{
	  x: new Date(2016, 6, 1),
	  open: 5,
	  close: 10,
	  high: 15,
	  low: 0
	}, {
	  x: new Date(2016, 6, 2),
	  open: 10,
	  close: 15,
	  high: 20,
	  low: 5
	}, {
	  x: new Date(2016, 6, 3),
	  open: 15,
	  close: 20,
	  high: 25,
	  low: 10
	}, {
	  x: new Date(2016, 6, 4),
	  open: 20,
	  close: 25,
	  high: 30,
	  low: 15
	}, {
	  x: new Date(2016, 6, 5),
	  open: 25,
	  close: 30,
	  high: 35,
	  low: 20
	}, {
	  x: new Date(2016, 6, 6),
	  open: 30,
	  close: 35,
	  high: 40,
	  low: 25
	}, {
	  x: new Date(2016, 6, 7),
	  open: 35,
	  close: 40,
	  high: 45,
	  low: 30
	}, {
	  x: new Date(2016, 6, 8),
	  open: 40,
	  close: 45,
	  high: 50,
	  low: 35
	}];
	/*eslint-enable no-magic-numbers */
	
	var datumHasXandY = function (datum) {
	  return !(0, _isNil2.default)(datum._x) && !(0, _isNil2.default)(datum._y);
	};
	
	var VictoryCandlestick =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryCandlestick, _React$Component);
	
	  function VictoryCandlestick() {
	    _classCallCheck(this, VictoryCandlestick);
	
	    return _possibleConstructorReturn(this, (VictoryCandlestick.__proto__ || Object.getPrototypeOf(VictoryCandlestick)).apply(this, arguments));
	  }
	
	  _createClass(VictoryCandlestick, [{
	    key: "shouldAnimate",
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "shouldRenderDatum",
	    value: function shouldRenderDatum(datum) {
	      return !(0, _isNil2.default)(datum._x) && !(0, _isNil2.default)(datum._high) && !(0, _isNil2.default)(datum._low) && !(0, _isNil2.default)(datum._close) && !(0, _isNil2.default)(datum._open);
	    }
	  }, {
	    key: "renderCandleData",
	    value: function renderCandleData(props) {
	      var _this = this;
	
	      var shouldRenderDatum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : datumHasXandY;
	      var dataComponent = props.dataComponent,
	          labelComponent = props.labelComponent,
	          groupComponent = props.groupComponent;
	      var types = ["close", "open", "low", "high"];
	      var dataComponents = this.dataKeys.reduce(function (validDataComponents, _dataKey, index) {
	        var dataProps = _this.getComponentProps(dataComponent, "data", index);
	
	        if (shouldRenderDatum(dataProps.datum)) {
	          validDataComponents.push(_react.default.cloneElement(dataComponent, dataProps));
	        }
	
	        return validDataComponents;
	      }, []);
	      var labelComponents = (0, _flatten2.default)(types.map(function (type) {
	        var components = _this.dataKeys.map(function (key, index) {
	          var name = "".concat(type, "Labels");
	          var baseComponent = props["".concat(type, "LabelComponent")];
	
	          var labelProps = _this.getComponentProps(baseComponent, name, index);
	
	          if (labelProps.text !== undefined && labelProps.text !== null) {
	            return _react.default.cloneElement(baseComponent, labelProps);
	          }
	
	          return undefined;
	        });
	
	        return components.filter(Boolean);
	      }));
	      var labelsComponents = this.dataKeys.map(function (_dataKey, index) {
	        var labelProps = _this.getComponentProps(labelComponent, "labels", index);
	
	        if (labelProps.text !== undefined && labelProps.text !== null) {
	          return _react.default.cloneElement(labelComponent, labelProps);
	        }
	
	        return undefined;
	      }).filter(Boolean);
	
	      var children = _toConsumableArray(dataComponents).concat(_toConsumableArray(labelComponents), _toConsumableArray(labelsComponents));
	
	      return this.renderContainer(groupComponent, children);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryCandlestick.animationWhitelist,
	          role = VictoryCandlestick.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderCandleData(props, this.shouldRenderDatum);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryCandlestick;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryCandlestick, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "domain", "height", "padding", "samples", "size", "style", "width"]
	});
	Object.defineProperty(VictoryCandlestick, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryCandlestick"
	});
	Object.defineProperty(VictoryCandlestick, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "candlestick"
	});
	Object.defineProperty(VictoryCandlestick, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.discreteTransitions()
	});
	Object.defineProperty(VictoryCandlestick, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    candleColors: _propTypes.default.shape({
	      positive: _propTypes.default.string,
	      negative: _propTypes.default.string
	    }),
	    candleRatio: _propTypes.default.number,
	    candleWidth: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.number]),
	    close: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    closeLabelComponent: _propTypes.default.element,
	    closeLabels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    events: _propTypes.default.arrayOf(_propTypes.default.shape({
	      target: _propTypes.default.oneOf(["data", "labels", "open", "openLabels", "close", "closeLabels", "low", "lowLabels", "high", "highLabels"]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      eventHandlers: _propTypes.default.object
	    })),
	    high: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    highLabelComponent: _propTypes.default.element,
	    highLabels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    labelOrientation: _propTypes.default.oneOfType([_propTypes.default.oneOf(["top", "bottom", "left", "right"]), _propTypes.default.shape({
	      open: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	      close: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	      low: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	      high: _propTypes.default.oneOf(["top", "bottom", "left", "right"])
	    })]),
	    low: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    lowLabelComponent: _propTypes.default.element,
	    lowLabels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    open: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    openLabelComponent: _propTypes.default.element,
	    openLabels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.bool]),
	    style: _propTypes.default.shape({
	      data: _propTypes.default.object,
	      labels: _propTypes.default.object,
	      close: _propTypes.default.object,
	      closeLabels: _propTypes.default.object,
	      open: _propTypes.default.object,
	      openLabels: _propTypes.default.object,
	      high: _propTypes.default.object,
	      highLabels: _propTypes.default.object,
	      low: _propTypes.default.object,
	      lowLabels: _propTypes.default.object
	    }),
	    wickStrokeWidth: _propTypes.default.number
	  })
	});
	Object.defineProperty(VictoryCandlestick, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    defaultCandleWidth: 8,
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    data: defaultData,
	    dataComponent: _react.default.createElement(_candle.default, null),
	    groupComponent: _react.default.createElement("g", {
	      role: "presentation"
	    }),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    highLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    lowLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    openLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    closeLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    samples: 50,
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryCandlestick, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getDomain
	});
	Object.defineProperty(VictoryCandlestick, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getData
	});
	Object.defineProperty(VictoryCandlestick, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryCandlestick, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["openLabelComponent", "closeLabelComponent", "highLabelComponent", "lowLabelComponent", "dataComponent", "labelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryCandlestick, options);
	
	exports.default = _default;

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getChildren = getChildren;
	exports.getCalculatedProps = getCalculatedProps;
	exports.getChildComponents = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable func-style */
	
	/* eslint-disable no-use-before-define */
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	function getAxisProps(child, props, calculatedProps) {
	  var domain = calculatedProps.domain,
	      scale = calculatedProps.scale,
	      stringMap = calculatedProps.stringMap,
	      categories = calculatedProps.categories,
	      horizontal = calculatedProps.horizontal,
	      orientations = calculatedProps.orientations;
	
	  var childProps = _victoryCore.Axis.modifyProps((0, _defaults2.default)({
	    horizontal: horizontal,
	    theme: props.theme
	  }, child.props));
	
	  var axis = child.type.getAxis(childProps);
	  var axisOffset = horizontal ? getHorizontalAxisOffset(props, calculatedProps) : getAxisOffset(props, calculatedProps);
	  var crossAxis = childProps.crossAxis === false ? false : true;
	  var orientation = childProps.orientation || orientations[axis];
	  return {
	    stringMap: stringMap,
	    horizontal: horizontal,
	    categories: categories,
	    startAngle: props.startAngle,
	    endAngle: props.endAngle,
	    innerRadius: props.innerRadius,
	    domain: domain,
	    scale: scale,
	    offsetY: childProps.offsetY !== undefined ? childProps.offsetY : axisOffset.y,
	    offsetX: childProps.offsetX !== undefined ? childProps.offsetX : axisOffset.x,
	    crossAxis: crossAxis,
	    orientation: orientation
	  };
	}
	
	function getChildProps(child, props, calculatedProps) {
	  var axisChild = _victoryCore.Axis.findAxisComponents([child]);
	
	  if (axisChild.length > 0) {
	    return getAxisProps(axisChild[0], props, calculatedProps);
	  }
	
	  var categories = calculatedProps.categories,
	      domain = calculatedProps.domain,
	      range = calculatedProps.range,
	      scale = calculatedProps.scale,
	      stringMap = calculatedProps.stringMap,
	      horizontal = calculatedProps.horizontal;
	  return {
	    categories: categories,
	    domain: domain,
	    range: range,
	    scale: scale,
	    stringMap: stringMap,
	    horizontal: horizontal
	  };
	}
	
	function getStyles(props) {
	  var styleProps = props.style && props.style.parent;
	  return {
	    parent: (0, _defaults2.default)({}, styleProps, {
	      height: "100%",
	      width: "100%",
	      userSelect: "none"
	    })
	  };
	}
	
	function getOrientation(axis, originSign, horizontal) {
	  var sign = originSign || "positive";
	  var orientations = {
	    positive: {
	      x: "bottom",
	      y: "left"
	    },
	    negative: {
	      x: "top",
	      y: "right"
	    }
	  };
	  var horizontalOrientations = {
	    positive: {
	      x: "left",
	      y: "bottom"
	    },
	    negative: {
	      x: "right",
	      y: "top"
	    }
	  };
	  return horizontal ? horizontalOrientations[sign][axis] : orientations[sign][axis];
	}
	
	function getCalculatedProps(props, childComponents) {
	  var style = getStyles(props);
	  props = _victoryCore.Helpers.modifyProps(props, fallbackProps, "chart");
	  var _props = props,
	      horizontal = _props.horizontal,
	      polar = _props.polar;
	
	  var categories = _victoryCore.Wrapper.getCategories(props, childComponents);
	
	  var stringMap = createStringMap(props, childComponents);
	  var domain = {
	    x: getDomain((0, _assign2.default)({}, props, {
	      categories: categories
	    }), "x", childComponents),
	    y: getDomain((0, _assign2.default)({}, props, {
	      categories: categories
	    }), "y", childComponents)
	  };
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var baseScale = {
	    x: _victoryCore.Scale.getScaleFromProps(props, "x") || _victoryCore.Wrapper.getScale(props, "x"),
	    y: _victoryCore.Scale.getScaleFromProps(props, "y") || _victoryCore.Wrapper.getScale(props, "y")
	  };
	  var scale = {
	    x: baseScale.x.domain(domain.x).range(horizontal ? range.y : range.x),
	    y: baseScale.y.domain(domain.y).range(horizontal ? range.x : range.y)
	  };
	  var origin = polar ? _victoryCore.Helpers.getPolarOrigin(props) : _victoryCore.Axis.getOrigin(domain);
	  var originSign = {
	    x: _victoryCore.Axis.getOriginSign(origin.x, domain.x),
	    y: _victoryCore.Axis.getOriginSign(origin.y, domain.y)
	  };
	  var orientations = {
	    x: getOrientation("x", originSign.y, horizontal),
	    y: getOrientation("y", originSign.x, horizontal)
	  };
	
	  var padding = _victoryCore.Helpers.getPadding(props);
	
	  return {
	    categories: categories,
	    domain: domain,
	    range: range,
	    horizontal: horizontal,
	    scale: scale,
	    stringMap: stringMap,
	    style: style,
	    origin: origin,
	    padding: padding,
	    orientations: orientations
	  };
	}
	
	function getChildren(props, childComponents, calculatedProps) {
	  childComponents = childComponents || getChildComponents(props);
	  calculatedProps = calculatedProps || getCalculatedProps(props, childComponents);
	  var baseStyle = calculatedProps.style.parent;
	  var height = props.height,
	      polar = props.polar,
	      theme = props.theme,
	      width = props.width;
	  var _calculatedProps = calculatedProps,
	      origin = _calculatedProps.origin,
	      horizontal = _calculatedProps.horizontal;
	  var parentName = props.name || "chart";
	  return childComponents.map(function (child, index) {
	    var role = child.type && child.type.role;
	    var style = Array.isArray(child.props.style) ? child.props.style : (0, _defaults2.default)({}, child.props.style, {
	      parent: baseStyle
	    });
	    var childProps = getChildProps(child, props, calculatedProps);
	    var name = child.props.name || "".concat(parentName, "-").concat(role, "-").concat(index);
	    var newProps = (0, _defaults2.default)({
	      horizontal: horizontal,
	      height: height,
	      polar: polar,
	      theme: theme,
	      width: width,
	      style: style,
	      name: name,
	      origin: polar ? origin : undefined,
	      padding: calculatedProps.padding,
	      key: "".concat(name, "-key-").concat(index),
	      standalone: false
	    }, childProps);
	    return _react.default.cloneElement(child, newProps);
	  });
	}
	
	var getChildComponents = function (props, defaultAxes) {
	  var childComponents = _react.default.Children.toArray(props.children);
	
	  if (childComponents.length === 0) {
	    return [defaultAxes.independent, defaultAxes.dependent];
	  }
	
	  var axisComponents = {
	    dependent: _victoryCore.Axis.getAxisComponentsWithParent(childComponents, "dependent"),
	    independent: _victoryCore.Axis.getAxisComponentsWithParent(childComponents, "independent")
	  };
	
	  if (axisComponents.dependent.length === 0 && axisComponents.independent.length === 0) {
	    return props.prependDefaultAxes ? [defaultAxes.independent, defaultAxes.dependent].concat(childComponents) : childComponents.concat([defaultAxes.independent, defaultAxes.dependent]);
	  }
	
	  return childComponents;
	};
	
	exports.getChildComponents = getChildComponents;
	
	var getDomain = function (props, axis, childComponents) {
	  childComponents = childComponents || _react.default.Children.toArray(props.children);
	
	  var domain = _victoryCore.Wrapper.getDomain(props, axis, childComponents);
	
	  var axisComponent = _victoryCore.Axis.getAxisComponent(childComponents, axis);
	
	  var invertDomain = axisComponent && axisComponent.props && axisComponent.props.invertAxis;
	  return invertDomain ? domain.concat().reverse() : domain;
	};
	
	var getAxisOffset = function (props, calculatedProps) {
	  var scale = calculatedProps.scale,
	      origin = calculatedProps.origin,
	      domain = calculatedProps.domain,
	      padding = calculatedProps.padding,
	      orientations = calculatedProps.orientations;
	  var top = padding.top,
	      bottom = padding.bottom,
	      left = padding.left,
	      right = padding.right; // make the axes line up, and cross when appropriate
	
	  var orientationOffset = {
	    y: orientations.x === "bottom" ? bottom : top,
	    x: orientations.y === "left" ? left : right
	  };
	  var originOffset = {
	    x: orientations.y === "left" ? 0 : props.width,
	    y: orientations.x === "bottom" ? props.height : 0
	  };
	  var originPosition = {
	    x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
	    y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
	  };
	  return {
	    x: originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x,
	    y: originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y
	  };
	};
	
	var getHorizontalAxisOffset = function (props, calculatedProps) {
	  var scale = calculatedProps.scale,
	      origin = calculatedProps.origin,
	      domain = calculatedProps.domain,
	      padding = calculatedProps.padding,
	      orientations = calculatedProps.orientations;
	  var top = padding.top,
	      bottom = padding.bottom,
	      left = padding.left,
	      right = padding.right; // make the axes line up, and cross when appropriate
	
	  var orientationOffset = {
	    x: orientations.y === "bottom" ? bottom : top,
	    y: orientations.x === "left" ? left : right
	  };
	  var originOffset = {
	    y: orientations.x === "left" ? 0 : props.width,
	    x: orientations.y === "bottom" ? props.height : 0
	  };
	  var originPosition = {
	    x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
	    y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
	  };
	  return {
	    y: originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x,
	    x: originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y
	  };
	};
	
	var createStringMap = function (props, childComponents) {
	  var allStrings = _victoryCore.Wrapper.getStringsFromChildren(props, childComponents);
	
	  var x = !allStrings.x || allStrings.x.length === 0 ? null : allStrings.x.reduce(function (memo, string, index) {
	    memo[string] = index + 1;
	    return memo;
	  }, {});
	  var y = !allStrings.y || allStrings.y.length === 0 ? null : allStrings.y.reduce(function (memo, string, index) {
	    memo[string] = index + 1;
	    return memo;
	  }, {});
	  return {
	    x: x,
	    y: y
	  };
	};

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryChart", {
	  enumerable: true,
	  get: function () {
	    return _victoryChart.default;
	  }
	});
	
	var _victoryChart = _interopRequireDefault(__webpack_require__(1858));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _victorySharedEvents = __webpack_require__(215);
	
	var _victoryAxis = __webpack_require__(664);
	
	var _victoryPolarAxis = __webpack_require__(686);
	
	var _helperMethods = __webpack_require__(1856);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var VictoryChart =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryChart, _React$Component);
	
	  function VictoryChart(props) {
	    var _this;
	
	    _classCallCheck(this, VictoryChart);
	
	    _this = _possibleConstructorReturn(this, (VictoryChart.__proto__ || Object.getPrototypeOf(VictoryChart)).call(this, props));
	    _this.state = {};
	
	    if (props.animate) {
	      _this.state = {
	        nodesShouldLoad: false,
	        nodesDoneLoad: false,
	        animating: true
	      };
	      _this.setAnimationState = _victoryCore.Wrapper.setAnimationState.bind(_assertThisInitialized(_this));
	    }
	
	    return _this;
	  }
	
	  _createClass(VictoryChart, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      if (this.props.animate) {
	        if (!(0, _reactFastCompare.default)(this.props, nextProps)) {
	          this.setAnimationState(this.props, nextProps);
	          return false;
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: "getNewChildren",
	    value: function getNewChildren(props, childComponents, calculatedProps) {
	      var children = (0, _helperMethods.getChildren)(props, childComponents, calculatedProps);
	
	      var getAnimationProps = _victoryCore.Wrapper.getAnimationProps.bind(this);
	
	      return children.map(function (child, index) {
	        var childProps = (0, _assign2.default)({
	          animate: getAnimationProps(props, child, index)
	        }, child.props);
	        return _react.default.cloneElement(child, childProps);
	      });
	    }
	  }, {
	    key: "renderContainer",
	    value: function renderContainer(containerComponent, props) {
	      var containerProps = (0, _defaults2.default)({}, containerComponent.props, props);
	      return _react.default.cloneElement(containerComponent, containerProps);
	    }
	  }, {
	    key: "getContainerProps",
	    value: function getContainerProps(props, calculatedProps) {
	      var width = props.width,
	          height = props.height,
	          standalone = props.standalone,
	          theme = props.theme,
	          polar = props.polar,
	          name = props.name;
	      var domain = calculatedProps.domain,
	          scale = calculatedProps.scale,
	          style = calculatedProps.style,
	          origin = calculatedProps.origin,
	          radius = calculatedProps.radius,
	          horizontal = calculatedProps.horizontal;
	      return {
	        domain: domain,
	        scale: scale,
	        width: width,
	        height: height,
	        standalone: standalone,
	        theme: theme,
	        style: style.parent,
	        horizontal: horizontal,
	        name: name,
	        polar: polar,
	        radius: radius,
	        origin: polar ? origin : undefined
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
	
	      var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "chart");
	
	      var eventKey = modifiedProps.eventKey,
	          containerComponent = modifiedProps.containerComponent,
	          groupComponent = modifiedProps.groupComponent,
	          standalone = modifiedProps.standalone,
	          externalEventMutations = modifiedProps.externalEventMutations;
	      var axes = props.polar ? modifiedProps.defaultPolarAxes : modifiedProps.defaultAxes;
	      var childComponents = (0, _helperMethods.getChildComponents)(modifiedProps, axes);
	      var calculatedProps = (0, _helperMethods.getCalculatedProps)(modifiedProps, childComponents);
	      var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
	      var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
	      var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
	
	      var events = _victoryCore.Wrapper.getAllEvents(props);
	
	      if (!(0, _isEmpty2.default)(events)) {
	        return _react.default.createElement(_victorySharedEvents.VictorySharedEvents, {
	          container: container,
	          eventKey: eventKey,
	          events: events,
	          externalEventMutations: externalEventMutations
	        }, newChildren);
	      }
	
	      return _react.default.cloneElement(container, container.props, newChildren);
	    }
	  }]);
	
	  return VictoryChart;
	}(_react.default.Component);
	
	exports.default = VictoryChart;
	Object.defineProperty(VictoryChart, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryChart"
	});
	Object.defineProperty(VictoryChart, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, {
	    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	    defaultAxes: _propTypes.default.shape({
	      independent: _propTypes.default.element,
	      dependent: _propTypes.default.element
	    }),
	    defaultPolarAxes: _propTypes.default.shape({
	      independent: _propTypes.default.element,
	      dependent: _propTypes.default.element
	    }),
	    endAngle: _propTypes.default.number,
	    innerRadius: _victoryCore.PropTypes.nonNegative,
	    prependDefaultAxes: _propTypes.default.bool,
	    startAngle: _propTypes.default.number
	  })
	});
	Object.defineProperty(VictoryChart, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    defaultAxes: {
	      independent: _react.default.createElement(_victoryAxis.VictoryAxis, null),
	      dependent: _react.default.createElement(_victoryAxis.VictoryAxis, {
	        dependentAxis: true
	      })
	    },
	    defaultPolarAxes: {
	      independent: _react.default.createElement(_victoryPolarAxis.VictoryPolarAxis, null),
	      dependent: _react.default.createElement(_victoryPolarAxis.VictoryPolarAxis, {
	        dependentAxis: true
	      })
	    },
	    groupComponent: _react.default.createElement("g", null),
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryChart, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["groupComponent", "containerComponent"]
	});

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.victoryInterpolator = exports.interpolateString = exports.interpolateObject = exports.interpolateFunction = exports.interpolateImmediate = exports.isInterpolatable = void 0;
	
	var _orderBy2 = _interopRequireDefault(__webpack_require__(119));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _d3Interpolate = __webpack_require__(392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isInterpolatable = function (obj) {
	  // d3 turns null into 0 and undefined into NaN, which we don't want.
	  if (obj !== null) {
	    switch (typeof obj) {
	      case "undefined":
	        return false;
	
	      case "number":
	        // The standard `isNaN` is fine in this case since we already know the
	        // type is number.
	        return !isNaN(obj) && obj !== Number.POSITIVE_INFINITY && obj !== Number.NEGATIVE_INFINITY;
	
	      case "string":
	        // d3 might not *actually* be able to interpolate the string, but it
	        // won't cause any issues to let it try.
	        return true;
	
	      case "boolean":
	        // d3 turns Booleans into integers, which we don't want. Sure, we could
	        // interpolate from 0 -> 1, but we'd be sending a non-Boolean to
	        // something expecting a Boolean.
	        return false;
	
	      case "object":
	        // Don't try to interpolate class instances (except Date or Array).
	        return obj instanceof Date || Array.isArray(obj) || (0, _isPlainObject2.default)(obj);
	
	      case "function":
	        // Careful! There may be extra properties on function objects that the
	        // component expects to access - for instance, it may be a `d3.scale()`
	        // function, which has its own methods attached. We don't know if the
	        // component is only going to call the function (in which case it's
	        // safely interpolatable) or if it's going to access special properties
	        // (in which case our function generated from `interpolateFunction` will
	        // most likely cause an error. We could check for enumerable properties
	        // on the function object here to see if it's a "plain" function, but
	        // let's just require that components prevent such function props from
	        // being animated in the first place.
	        return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * Interpolate immediately to the end value at the given step `when`.
	 * Some nicer default behavior might be to jump at the halfway point or return
	 * `a` if `t` is 0 (instead of always returning `b`). But d3's default
	 * interpolator does not do these things:
	 *
	 *   d3.interpolate('aaa', 'bbb')(0) === 'bbb'
	 *
	 * ...and things might get wonky if we don't replicate that behavior.
	 *
	 * @param {any} a - Start value.
	 * @param {any} b - End value.
	 * @param {Number} when - Step value (0 to 1) at which to jump to `b`.
	 * @returns {Function} An interpolation function.
	 */
	
	
	exports.isInterpolatable = isInterpolatable;
	
	var interpolateImmediate = function (a, b) {
	  var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  return function (t) {
	    return t < when ? a : b;
	  };
	};
	/**
	 * Interpolate to or from a function. The interpolated value will be a function
	 * that calls `a` (if it's a function) and `b` (if it's a function) and calls
	 * `d3.interpolate` on the resulting values. Note that our function won't
	 * necessarily be called (that's up to the component this eventually gets
	 * passed to) - but if it does get called, it will return an appropriately
	 * interpolated value.
	 *
	 * @param {any} a - Start value.
	 * @param {any} b - End value.
	 * @returns {Function} An interpolation function.
	 */
	
	
	exports.interpolateImmediate = interpolateImmediate;
	
	var interpolateFunction = function (a, b) {
	  return function (t) {
	    if (t >= 1) {
	      return b;
	    }
	
	    return function () {
	      /* eslint-disable no-invalid-this */
	      var aval = typeof a === "function" ? a.apply(this, arguments) : a;
	      var bval = typeof b === "function" ? b.apply(this, arguments) : b;
	      return (0, _d3Interpolate.interpolate)(aval, bval)(t);
	    };
	  };
	};
	/**
	 * Interpolate to or from an object. This method is a modification of the object interpolator in
	 * d3-interpolate https://github.com/d3/d3-interpolate/blob/master/src/object.js. This interpolator
	 * differs in that it uses our custom interpolators when interpolating the value of each property in
	 * an object. This allows the correct interpolation of nested objects, including styles
	 *
	 * @param {any} a - Start value.
	 * @param {any} b - End value.
	 * @returns {Function} An interpolation function.
	 */
	
	
	exports.interpolateFunction = interpolateFunction;
	
	var interpolateObject = function (a, b) {
	  var interpolateTypes = function (x, y) {
	    if (x === y || !isInterpolatable(x) || !isInterpolatable(y)) {
	      return interpolateImmediate(x, y);
	    }
	
	    if (typeof x === "function" || typeof y === "function") {
	      return interpolateFunction(x, y);
	    }
	
	    if (typeof x === "object" && (0, _isPlainObject2.default)(x) || typeof y === "object" && (0, _isPlainObject2.default)(y)) {
	      return interpolateObject(x, y);
	    }
	
	    return (0, _d3Interpolate.interpolate)(x, y);
	  }; // When the value is an array, attempt to sort by "key" so that animating nodes may be identified
	  // based on "key" instead of index
	
	
	  var keyData = function (val) {
	    return Array.isArray(val) ? (0, _orderBy2.default)(val, "key") : val;
	  };
	
	  var i = {};
	  var c = {};
	  var k;
	
	  if (a === null || typeof a !== "object") {
	    a = {};
	  }
	
	  if (b === null || typeof b !== "object") {
	    b = {};
	  }
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = interpolateTypes(keyData(a[k]), keyData(b[k]));
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function (t) {
	    for (k in i) {
	      c[k] = i[k](t);
	    }
	
	    return c;
	  };
	};
	
	exports.interpolateObject = interpolateObject;
	
	var interpolateString = function (a, b) {
	  var format = function (val) {
	    return typeof val === "string" ? val.replace(/,/g, "") : val;
	  };
	
	  return (0, _d3Interpolate.interpolate)(format(a), format(b));
	};
	/**
	 * By default, the list of interpolators used by `d3.interpolate` has a few
	 * downsides:
	 *
	 * - `null` values get turned into 0.
	 * - `undefined`, `function`, and some other value types get turned into NaN.
	 * - Boolean types get turned into numbers, which probably will be meaningless
	 *   to whatever is consuming them.
	 * - It tries to interpolate between identical start and end values, doing
	 *   unnecessary calculations that sometimes result in floating point rounding
	 *   errors.
	 *
	 * If only the default interpolators are used, `VictoryAnimation` will happily
	 * pass down NaN (and other bad) values as props to the wrapped component.
	 * The component will then either use the incorrect values or complain that it
	 * was passed props of the incorrect type. This custom interpolator is added
	 * using the `d3.interpolators` API, and prevents such cases from happening
	 * for most values.
	 *
	 * @param {any} a - Start value.
	 * @param {any} b - End value.
	 * @returns {Function|undefined} An interpolation function, if necessary.
	 */
	
	
	exports.interpolateString = interpolateString;
	
	var victoryInterpolator = function (a, b) {
	  // If the values are strictly equal, or either value is not interpolatable,
	  // just use either the start value `a` or end value `b` at every step, as
	  // there is no reasonable in-between value.
	  if (a === b || !isInterpolatable(a) || !isInterpolatable(b)) {
	    return interpolateImmediate(a, b);
	  }
	
	  if (typeof a === "function" || typeof b === "function") {
	    return interpolateFunction(a, b);
	  }
	
	  if ((0, _isPlainObject2.default)(a) || (0, _isPlainObject2.default)(b)) {
	    return interpolateObject(a, b);
	  }
	
	  if (typeof a === "string" || typeof b === "string") {
	    return interpolateString(a, b);
	  }
	
	  return (0, _d3Interpolate.interpolate)(a, b);
	};
	
	exports.victoryInterpolator = victoryInterpolator;

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _uniqueId2 = _interopRequireDefault(__webpack_require__(276));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(47));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _propTypes2 = _interopRequireDefault(__webpack_require__(128));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _clipPath = _interopRequireDefault(__webpack_require__(674));
	
	var _circle = _interopRequireDefault(__webpack_require__(673));
	
	var _rect = _interopRequireDefault(__webpack_require__(299));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VictoryClipContainer =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryClipContainer, _React$Component);
	
	  function VictoryClipContainer(props) {
	    var _this;
	
	    _classCallCheck(this, VictoryClipContainer);
	
	    _this = _possibleConstructorReturn(this, (VictoryClipContainer.__proto__ || Object.getPrototypeOf(VictoryClipContainer)).call(this, props));
	    _this.clipId = !(0, _isObject2.default)(props) || props.clipId === undefined ? (0, _uniqueId2.default)("victory-clip-") : props.clipId;
	    return _this;
	  }
	
	  _createClass(VictoryClipContainer, [{
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var polar = props.polar,
	          origin = props.origin,
	          _props$clipWidth = props.clipWidth,
	          clipWidth = _props$clipWidth === void 0 ? 0 : _props$clipWidth,
	          _props$clipHeight = props.clipHeight,
	          clipHeight = _props$clipHeight === void 0 ? 0 : _props$clipHeight,
	          _props$translateX = props.translateX,
	          translateX = _props$translateX === void 0 ? 0 : _props$translateX,
	          _props$translateY = props.translateY,
	          translateY = _props$translateY === void 0 ? 0 : _props$translateY;
	
	      var clipPadding = _helpers.default.getPadding({
	        padding: props.clipPadding
	      });
	
	      var radius = props.radius || _helpers.default.getRadius(props);
	
	      return {
	        x: (polar ? origin.x : translateX) - clipPadding.left,
	        y: (polar ? origin.y : translateY) - clipPadding.top,
	        width: Math.max((polar ? radius : clipWidth) + clipPadding.left + clipPadding.right, 0),
	        height: Math.max((polar ? radius : clipHeight) + clipPadding.top + clipPadding.bottom, 0)
	      };
	    }
	  }, {
	    key: "renderClippedGroup",
	    value: function renderClippedGroup(props, clipId) {
	      var style = props.style,
	          events = props.events,
	          transform = props.transform,
	          children = props.children,
	          className = props.className,
	          groupComponent = props.groupComponent;
	      var clipComponent = this.renderClipComponent(props, clipId);
	      var groupProps = (0, _assign2.default)({
	        className: className,
	        style: style,
	        transform: transform,
	        key: "clipped-group-".concat(clipId),
	        clipPath: "url(#".concat(clipId, ")")
	      }, events);
	      return _react.default.cloneElement(groupComponent, groupProps, [clipComponent].concat(_toConsumableArray(_react.default.Children.toArray(children))));
	    }
	  }, {
	    key: "renderGroup",
	    value: function renderGroup(props) {
	      var style = props.style,
	          events = props.events,
	          transform = props.transform,
	          children = props.children,
	          className = props.className,
	          groupComponent = props.groupComponent;
	      return _react.default.cloneElement(groupComponent, (0, _assign2.default)({
	        className: className,
	        style: style,
	        transform: transform
	      }, events), children);
	    }
	  }, {
	    key: "renderClipComponent",
	    value: function renderClipComponent(props, clipId) {
	      var polar = props.polar,
	          origin = props.origin,
	          _props$clipWidth2 = props.clipWidth,
	          clipWidth = _props$clipWidth2 === void 0 ? 0 : _props$clipWidth2,
	          _props$clipHeight2 = props.clipHeight,
	          clipHeight = _props$clipHeight2 === void 0 ? 0 : _props$clipHeight2,
	          _props$translateX2 = props.translateX,
	          translateX = _props$translateX2 === void 0 ? 0 : _props$translateX2,
	          _props$translateY2 = props.translateY,
	          translateY = _props$translateY2 === void 0 ? 0 : _props$translateY2,
	          circleComponent = props.circleComponent,
	          rectComponent = props.rectComponent,
	          clipPathComponent = props.clipPathComponent;
	
	      var _Helpers$getPadding = _helpers.default.getPadding({
	        padding: props.clipPadding
	      }),
	          top = _Helpers$getPadding.top,
	          bottom = _Helpers$getPadding.bottom,
	          left = _Helpers$getPadding.left,
	          right = _Helpers$getPadding.right;
	
	      var child;
	
	      if (polar) {
	        var radius = props.radius || _helpers.default.getRadius(props);
	
	        var circleProps = {
	          r: Math.max(radius + left + right, radius + top + bottom, 0),
	          cx: origin.x - left,
	          cy: origin.y - top
	        };
	        child = _react.default.cloneElement(circleComponent, circleProps);
	      } else {
	        var rectProps = {
	          x: translateX - left,
	          y: translateY - top,
	          width: Math.max(clipWidth + left + right, 0),
	          height: Math.max(clipHeight + top + bottom, 0)
	        };
	        child = _react.default.cloneElement(rectComponent, rectProps);
	      }
	
	      return _react.default.cloneElement(clipPathComponent, (0, _assign2.default)({
	        key: "clip-path-".concat(clipId)
	      }, props, {
	        clipId: clipId
	      }), child);
	    }
	  }, {
	    key: "getClipValue",
	    value: function getClipValue(props, axis) {
	      var clipValues = {
	        x: props.clipWidth,
	        y: props.clipHeight
	      };
	
	      if (clipValues[axis] !== undefined) {
	        return clipValues[axis];
	      }
	
	      var range = _helpers.default.getRange(props, axis);
	
	      return range ? Math.abs(range[0] - range[1]) || undefined : undefined;
	    }
	  }, {
	    key: "getTranslateValue",
	    value: function getTranslateValue(props, axis) {
	      var translateValues = {
	        x: props.translateX,
	        y: props.translateY
	      };
	
	      if (translateValues[axis] !== undefined) {
	        return translateValues[axis];
	      }
	
	      var range = _helpers.default.getRange(props, axis);
	
	      return range ? Math.min.apply(Math, _toConsumableArray(range)) : undefined;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var clipHeight = this.getClipValue(this.props, "y");
	      var clipWidth = this.getClipValue(this.props, "x");
	
	      if (clipWidth === undefined || clipHeight === undefined) {
	        return this.renderGroup(this.props);
	      }
	
	      var translateX = this.getTranslateValue(this.props, "x");
	      var translateY = this.getTranslateValue(this.props, "y");
	      var clipProps = (0, _defaults2.default)({}, this.props, {
	        clipHeight: clipHeight,
	        clipWidth: clipWidth,
	        translateX: translateX,
	        translateY: translateY
	      });
	      return this.renderClippedGroup(clipProps, this.clipId);
	    }
	  }]);
	
	  return VictoryClipContainer;
	}(_react.default.Component);
	
	exports.default = VictoryClipContainer;
	Object.defineProperty(VictoryClipContainer, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryClipContainer"
	});
	Object.defineProperty(VictoryClipContainer, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "container"
	});
	Object.defineProperty(VictoryClipContainer, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	    circleComponent: _propTypes.default.element,
	    className: _propTypes.default.string,
	    clipHeight: _propTypes2.default.nonNegative,
	    clipId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    clipPadding: _propTypes.default.shape({
	      top: _propTypes.default.number,
	      bottom: _propTypes.default.number,
	      left: _propTypes.default.number,
	      right: _propTypes.default.number
	    }),
	    clipPathComponent: _propTypes.default.element,
	    clipWidth: _propTypes2.default.nonNegative,
	    events: _propTypes.default.object,
	    groupComponent: _propTypes.default.element,
	    origin: _propTypes.default.shape({
	      x: _propTypes2.default.nonNegative,
	      y: _propTypes2.default.nonNegative
	    }),
	    polar: _propTypes.default.bool,
	    radius: _propTypes2.default.nonNegative,
	    style: _propTypes.default.object,
	    transform: _propTypes.default.string,
	    translateX: _propTypes.default.number,
	    translateY: _propTypes.default.number
	  }
	});
	Object.defineProperty(VictoryClipContainer, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    circleComponent: _react.default.createElement(_circle.default, null),
	    rectComponent: _react.default.createElement(_rect.default, null),
	    clipPathComponent: _react.default.createElement(_clipPath.default, null),
	    groupComponent: _react.default.createElement("g", null)
	  }
	});

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(47));
	
	var _uniqueId2 = _interopRequireDefault(__webpack_require__(276));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _propTypes2 = _interopRequireDefault(__webpack_require__(128));
	
	var _portal = _interopRequireDefault(__webpack_require__(671));
	
	var _timer = _interopRequireDefault(__webpack_require__(214));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var VictoryContainer =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryContainer, _React$Component);
	
	  function VictoryContainer(props) {
	    var _this;
	
	    _classCallCheck(this, VictoryContainer);
	
	    _this = _possibleConstructorReturn(this, (VictoryContainer.__proto__ || Object.getPrototypeOf(VictoryContainer)).call(this, props));
	    _this.getTimer = _this.getTimer.bind(_assertThisInitialized(_this));
	    _this.containerId = !(0, _isObject2.default)(props) || props.containerId === undefined ? (0, _uniqueId2.default)("victory-container-") : props.containerId;
	
	    _this.savePortalRef = function (portal) {
	      _this.portalRef = portal;
	      return portal;
	    };
	
	    _this.portalUpdate = function (key, el) {
	      return _this.portalRef.portalUpdate(key, el);
	    };
	
	    _this.portalRegister = function () {
	      return _this.portalRef.portalRegister();
	    };
	
	    _this.portalDeregister = function (key) {
	      return _this.portalRef.portalDeregister(key);
	    };
	
	    _this.saveContainerRef = props && (0, _isFunction2.default)(props.containerRef) ? props.containerRef : function (container) {
	      _this.containerRef = container;
	      return container;
	    };
	    _this.shouldHandleWheel = props && props.events && props.events.onWheel;
	
	    if (_this.shouldHandleWheel) {
	      _this.handleWheel = function (e) {
	        return e.preventDefault();
	      };
	    }
	
	    return _this;
	  }
	
	  _createClass(VictoryContainer, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        portalUpdate: this.portalUpdate,
	        portalRegister: this.portalRegister,
	        portalDeregister: this.portalDeregister,
	        getTimer: this.getTimer
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.shouldHandleWheel && this.containerRef) {
	        this.containerRef.addEventListener("wheel", this.handleWheel);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!this.context.getTimer) {
	        this.getTimer().stop();
	      }
	
	      if (this.shouldHandleWheel && this.containerRef) {
	        this.containerRef.removeEventListener("wheel", this.handleWheel);
	      }
	    }
	  }, {
	    key: "getTimer",
	    value: function getTimer() {
	      if (this.context.getTimer) {
	        return this.context.getTimer();
	      }
	
	      if (!this.timer) {
	        this.timer = new _timer.default();
	      }
	
	      return this.timer;
	    }
	  }, {
	    key: "getIdForElement",
	    value: function getIdForElement(elementName) {
	      return "".concat(this.containerId, "-").concat(elementName);
	    } // overridden in custom containers
	
	  }, {
	    key: "getChildren",
	    value: function getChildren(props) {
	      return props.children;
	    }
	  }, {
	    key: "renderContainer",
	    value: function renderContainer(props, svgProps, style) {
	      var title = props.title,
	          desc = props.desc,
	          portalComponent = props.portalComponent,
	          className = props.className,
	          width = props.width,
	          height = props.height,
	          portalZIndex = props.portalZIndex,
	          responsive = props.responsive;
	      var children = this.getChildren(props);
	      var dimensions = responsive ? {
	        width: "100%",
	        height: "auto"
	      } : {
	        width: width,
	        height: height
	      };
	      var divStyle = (0, _assign2.default)({
	        pointerEvents: "none",
	        touchAction: "none",
	        position: "relative"
	      }, dimensions);
	      var portalDivStyle = (0, _assign2.default)({
	        zIndex: portalZIndex,
	        position: "absolute",
	        top: 0,
	        left: 0
	      }, dimensions);
	      var svgStyle = (0, _assign2.default)({
	        pointerEvents: "all"
	      }, dimensions);
	      var portalSvgStyle = (0, _assign2.default)({
	        overflow: "visible"
	      }, dimensions);
	      var portalProps = {
	        width: width,
	        height: height,
	        viewBox: svgProps.viewBox,
	        style: portalSvgStyle
	      };
	      return _react.default.createElement("div", {
	        style: (0, _defaults2.default)({}, style, divStyle),
	        className: className,
	        ref: this.saveContainerRef
	      }, _react.default.createElement("svg", _extends({}, svgProps, {
	        style: svgStyle
	      }), title ? _react.default.createElement("title", {
	        id: this.getIdForElement("title")
	      }, title) : null, desc ? _react.default.createElement("desc", {
	        id: this.getIdForElement("desc")
	      }, desc) : null, children), _react.default.createElement("div", {
	        style: portalDivStyle
	      }, _react.default.cloneElement(portalComponent, _objectSpread({}, portalProps, {
	        ref: this.savePortalRef
	      }))));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height,
	          responsive = _props.responsive,
	          events = _props.events,
	          title = _props.title,
	          desc = _props.desc,
	          tabIndex = _props.tabIndex;
	      var style = responsive ? this.props.style : _helpers.default.omit(this.props.style, ["height", "width"]);
	      var svgProps = (0, _assign2.default)({
	        width: width,
	        height: height,
	        tabIndex: tabIndex,
	        role: "img",
	        "aria-labelledby": title ? this.getIdForElement("title") : undefined,
	        "aria-describedby": desc ? this.getIdForElement("desc") : undefined,
	        viewBox: responsive ? "0 0 ".concat(width, " ").concat(height) : undefined
	      }, events);
	      return this.renderContainer(this.props, svgProps, style);
	    }
	  }]);
	
	  return VictoryContainer;
	}(_react.default.Component);
	
	exports.default = VictoryContainer;
	Object.defineProperty(VictoryContainer, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryContainer"
	});
	Object.defineProperty(VictoryContainer, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "container"
	});
	Object.defineProperty(VictoryContainer, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	    className: _propTypes.default.string,
	    containerId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    containerRef: _propTypes.default.func,
	    desc: _propTypes.default.string,
	    events: _propTypes.default.object,
	    height: _propTypes2.default.nonNegative,
	    name: _propTypes.default.string,
	    origin: _propTypes.default.shape({
	      x: _propTypes2.default.nonNegative,
	      y: _propTypes2.default.nonNegative
	    }),
	    polar: _propTypes.default.bool,
	    portalComponent: _propTypes.default.element,
	    portalZIndex: _propTypes2.default.integer,
	    responsive: _propTypes.default.bool,
	    style: _propTypes.default.object,
	    tabIndex: _propTypes.default.number,
	    theme: _propTypes.default.object,
	    title: _propTypes.default.string,
	    width: _propTypes2.default.nonNegative
	  }
	});
	Object.defineProperty(VictoryContainer, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    className: "VictoryContainer",
	    portalComponent: _react.default.createElement(_portal.default, null),
	    portalZIndex: 99,
	    responsive: true
	  }
	});
	Object.defineProperty(VictoryContainer, "contextTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    getTimer: _propTypes.default.func
	  }
	});
	Object.defineProperty(VictoryContainer, "childContextTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    portalUpdate: _propTypes.default.func,
	    portalRegister: _propTypes.default.func,
	    portalDeregister: _propTypes.default.func,
	    getTimer: _propTypes.default.func
	  }
	});

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryPortal = _interopRequireDefault(__webpack_require__(672));
	
	var _propTypes2 = _interopRequireDefault(__webpack_require__(128));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _labelHelpers = _interopRequireDefault(__webpack_require__(680));
	
	var _style = _interopRequireDefault(__webpack_require__(303));
	
	var _log = _interopRequireDefault(__webpack_require__(212));
	
	var _tspan = _interopRequireDefault(__webpack_require__(676));
	
	var _text = _interopRequireDefault(__webpack_require__(675));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultStyles = {
	  fill: "#252525",
	  fontSize: 14,
	  fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
	  stroke: "transparent"
	};
	
	var getPosition = function (props, dimension) {
	  if (!props.datum) {
	    return 0;
	  }
	
	  var scaledPoint = _helpers.default.scalePoint(props, props.datum);
	
	  return scaledPoint[dimension];
	};
	
	var getFontSize = function (style) {
	  var baseSize = style && style.fontSize;
	
	  if (typeof baseSize === "number") {
	    return baseSize;
	  } else if (baseSize === undefined || baseSize === null) {
	    return defaultStyles.fontSize;
	  } else if (typeof baseSize === "string") {
	    var fontSize = +baseSize.replace("px", "");
	
	    if (!isNaN(fontSize)) {
	      return fontSize;
	    } else {
	      _log.default.warn("fontSize should be expressed as a number of pixels");
	
	      return defaultStyles.fontSize;
	    }
	  }
	
	  return defaultStyles.fontSize;
	};
	
	var getStyles = function (style, props) {
	  var getSingleStyle = function (s) {
	    s = s ? (0, _defaults2.default)({}, s, defaultStyles) : defaultStyles;
	
	    var baseStyles = _helpers.default.evaluateStyle(s, props);
	
	    return (0, _assign2.default)({}, baseStyles, {
	      fontSize: getFontSize(baseStyles)
	    });
	  };
	
	  return Array.isArray(style) && !(0, _isEmpty2.default)(style) ? style.map(function (s) {
	    return getSingleStyle(s);
	  }) : [getSingleStyle(style)];
	};
	
	var getHeight = function (props, type) {
	  return _helpers.default.evaluateProp(props[type], props);
	};
	
	var getContent = function (text, props) {
	  if (text === undefined || text === null) {
	    return undefined;
	  }
	
	  if (Array.isArray(text)) {
	    return text.map(function (line) {
	      return _helpers.default.evaluateProp(line, props);
	    });
	  }
	
	  var child = _helpers.default.evaluateProp(text, props);
	
	  if (child === undefined || child === null) {
	    return undefined;
	  }
	
	  return Array.isArray(child) ? child : "".concat(child).split("\n");
	};
	
	var checkLineHeight = function (lineHeight, val, fallbackVal) {
	  if (Array.isArray(lineHeight)) {
	    return (0, _isEmpty2.default)(lineHeight) ? fallbackVal : val;
	  }
	
	  return lineHeight;
	};
	
	var getDy = function (props, lineHeight) {
	  var style = Array.isArray(props.style) ? props.style[0] : props.style;
	  lineHeight = checkLineHeight(lineHeight, lineHeight[0], 1);
	  var fontSize = style.fontSize;
	  var dy = props.dy ? _helpers.default.evaluateProp(props.dy, props) : 0;
	  var length = props.text.length;
	  var capHeight = getHeight(props, "capHeight");
	  var verticalAnchor = style.verticalAnchor || props.verticalAnchor;
	  var anchor = verticalAnchor ? _helpers.default.evaluateProp(verticalAnchor, props) : "middle";
	
	  switch (anchor) {
	    case "end":
	      return dy + (capHeight / 2 + (0.5 - length) * lineHeight) * fontSize;
	
	    case "middle":
	      return dy + (capHeight / 2 + (0.5 - length / 2) * lineHeight) * fontSize;
	
	    default:
	      return dy + (capHeight / 2 + lineHeight / 2) * fontSize;
	  }
	};
	
	var getTransform = function (props) {
	  var x = props.x,
	      y = props.y,
	      polar = props.polar,
	      style = props.style;
	  var defaultAngle = polar ? _labelHelpers.default.getPolarAngle(props) : 0;
	  var baseAngle = style.angle === undefined ? props.angle : style.angle;
	  var angle = baseAngle === undefined ? defaultAngle : baseAngle;
	  var transform = props.transform || style.transform;
	
	  var transformPart = transform && _helpers.default.evaluateProp(transform, props);
	
	  var rotatePart = angle && {
	    rotate: [angle, x, y]
	  };
	  return transformPart || angle ? _style.default.toTransformString(transformPart, rotatePart) : undefined;
	};
	
	var renderElements = function (props) {
	  var inline = props.inline,
	      className = props.className,
	      title = props.title,
	      events = props.events,
	      direction = props.direction,
	      text = props.text,
	      style = props.style;
	  var lineHeight = getHeight(props, "lineHeight");
	  var textAnchor = props.textAnchor ? _helpers.default.evaluateProp(props.textAnchor, props) : "start";
	  var dx = props.dx ? _helpers.default.evaluateProp(props.dx, props) : 0;
	  var dy = getDy(props, lineHeight);
	  var transform = getTransform(props);
	  var x = props.x !== undefined ? props.x : getPosition(props, "x");
	  var y = props.y !== undefined ? props.y : getPosition(props, "y");
	  var textChildren = text.map(function (line, i) {
	    var currentStyle = style[i] || style[0];
	    var lastStyle = style[i - 1] || style[0];
	    var fontSize = (currentStyle.fontSize + lastStyle.fontSize) / 2;
	    var currentLineHeight = checkLineHeight(lineHeight, (lineHeight[i] + (lineHeight[i - 1] || lineHeight[0])) / 2, 1);
	    var tspanProps = {
	      key: "".concat(props.id, "-key-").concat(i),
	      x: !inline ? props.x : undefined,
	      dx: dx,
	      dy: i && !inline ? currentLineHeight * fontSize : undefined,
	      textAnchor: currentStyle.textAnchor || textAnchor,
	      style: currentStyle,
	      children: line
	    };
	    return _react.default.cloneElement(props.tspanComponent, tspanProps);
	  });
	  return _react.default.cloneElement(props.textComponent, _objectSpread({}, events, {
	    direction: direction,
	    dx: dx,
	    dy: dy,
	    x: x,
	    y: y,
	    transform: transform,
	    className: className,
	    title: title,
	    desc: _helpers.default.evaluateProp(props.desc, props),
	    tabIndex: _helpers.default.evaluateProp(props.tabIndex, props),
	    id: props.id
	  }), textChildren);
	};
	
	var evaluateProps = function (props) {
	  /* Potential evaluated props are
	    1) text
	    2) style
	    3) everything else
	  */
	  var text = getContent(props.text, props);
	  var style = getStyles(props.style, (0, _assign2.default)({}, props, {
	    text: text
	  }));
	  return (0, _assign2.default)({}, props, {
	    style: style,
	    text: text
	  });
	};
	
	var VictoryLabel = function (props) {
	  props = evaluateProps(props);
	
	  if (props.text === null || props.text === undefined) {
	    return null;
	  }
	
	  var label = renderElements(props);
	  return props.renderInPortal ? _react.default.createElement(_victoryPortal.default, null, label) : label;
	};
	
	VictoryLabel.displayName = "VictoryLabel";
	VictoryLabel.role = "label";
	VictoryLabel.defaultStyles = defaultStyles;
	VictoryLabel.propTypes = {
	  active: _propTypes.default.bool,
	  angle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  capHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes2.default.nonNegative, _propTypes.default.func]),
	  className: _propTypes.default.string,
	  data: _propTypes.default.array,
	  datum: _propTypes.default.any,
	  desc: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  direction: _propTypes.default.oneOf(["rtl", "ltr", "inherit"]),
	  dx: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.func]),
	  dy: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.func]),
	  events: _propTypes.default.object,
	  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  index: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  inline: _propTypes.default.bool,
	  labelPlacement: _propTypes.default.oneOf(["parallel", "perpendicular", "vertical"]),
	  lineHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes2.default.nonNegative, _propTypes.default.func, _propTypes.default.array]),
	  origin: _propTypes.default.shape({
	    x: _propTypes2.default.nonNegative,
	    y: _propTypes2.default.nonNegative
	  }),
	  polar: _propTypes.default.bool,
	  renderInPortal: _propTypes.default.bool,
	  scale: _propTypes.default.shape({
	    x: _propTypes2.default.scale,
	    y: _propTypes2.default.scale
	  }),
	  style: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func, _propTypes.default.array]),
	  textAnchor: _propTypes.default.oneOfType([_propTypes.default.oneOf(["start", "middle", "end", "inherit"]), _propTypes.default.func]),
	  textComponent: _propTypes.default.element,
	  title: _propTypes.default.string,
	  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func]),
	  tspanComponent: _propTypes.default.element,
	  verticalAnchor: _propTypes.default.oneOfType([_propTypes.default.oneOf(["start", "middle", "end"]), _propTypes.default.func]),
	  x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	};
	VictoryLabel.defaultProps = {
	  direction: "inherit",
	  textComponent: _react.default.createElement(_text.default, null),
	  tspanComponent: _react.default.createElement(_tspan.default, null),
	  capHeight: 0.71,
	  // Magic number from d3.
	  lineHeight: 1
	};
	var _default = VictoryLabel;
	exports.default = _default;

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _commonProps = _interopRequireDefault(__webpack_require__(127));
	
	var _path = _interopRequireDefault(__webpack_require__(298));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getArcPath = function (props) {
	  var cx = props.cx,
	      cy = props.cy,
	      r = props.r,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      closedPath = props.closedPath; // Always draw the path as two arcs so that complete circles may be rendered.
	
	  var halfAngle = Math.abs(endAngle - startAngle) / 2 + startAngle;
	  var x1 = cx + r * Math.cos(_helpers.default.degreesToRadians(startAngle));
	  var y1 = cy - r * Math.sin(_helpers.default.degreesToRadians(startAngle));
	  var x2 = cx + r * Math.cos(_helpers.default.degreesToRadians(halfAngle));
	  var y2 = cy - r * Math.sin(_helpers.default.degreesToRadians(halfAngle));
	  var x3 = cx + r * Math.cos(_helpers.default.degreesToRadians(endAngle));
	  var y3 = cy - r * Math.sin(_helpers.default.degreesToRadians(endAngle));
	  var largerArcFlag1 = halfAngle - startAngle <= 180 ? 0 : 1;
	  var largerArcFlag2 = endAngle - halfAngle <= 180 ? 0 : 1;
	  var arcStart = closedPath ? " M ".concat(cx, ", ").concat(cy, " L ").concat(x1, ", ").concat(y1) : "M ".concat(x1, ", ").concat(y1);
	  var arc1 = "A ".concat(r, ", ").concat(r, ", 0, ").concat(largerArcFlag1, ", 0, ").concat(x2, ", ").concat(y2);
	  var arc2 = "A ".concat(r, ", ").concat(r, ", 0, ").concat(largerArcFlag2, ", 0, ").concat(x3, ", ").concat(y3);
	  var arcEnd = closedPath ? "Z" : "";
	  return "".concat(arcStart, " ").concat(arc1, " ").concat(arc2, " ").concat(arcEnd);
	};
	
	var Arc = function (props) {
	  return _react.default.cloneElement(props.pathComponent, _objectSpread({}, props.events, {
	    d: getArcPath(props),
	    style: _helpers.default.evaluateStyle((0, _assign2.default)({
	      stroke: "black",
	      fill: "none"
	    }, props.style), props),
	    desc: _helpers.default.evaluateProp(props.desc, props),
	    tabIndex: _helpers.default.evaluateProp(props.tabIndex, props),
	    className: props.className,
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    transform: props.transform,
	    clipPath: props.clipPath
	  }));
	};
	
	Arc.propTypes = _objectSpread({}, _commonProps.default.primitiveProps, {
	  closedPath: _propTypes.default.bool,
	  cx: _propTypes.default.number,
	  cy: _propTypes.default.number,
	  datum: _propTypes.default.any,
	  endAngle: _propTypes.default.number,
	  pathComponent: _propTypes.default.element,
	  r: _propTypes.default.number,
	  startAngle: _propTypes.default.number
	});
	Arc.defaultProps = {
	  pathComponent: _react.default.createElement(_path.default, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Arc;
	exports.default = _default;

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _commonProps = _interopRequireDefault(__webpack_require__(127));
	
	var _rect = _interopRequireDefault(__webpack_require__(299));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Border = function (props) {
	  return _react.default.cloneElement(props.rectComponent, _objectSpread({}, props.events, {
	    style: _helpers.default.evaluateStyle((0, _assign2.default)({
	      fill: "none"
	    }, props.style), props),
	    desc: _helpers.default.evaluateProp(props.desc, props),
	    tabIndex: _helpers.default.evaluateProp(props.tabIndex, props),
	    transform: props.transform,
	    className: props.className,
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    x: props.x,
	    y: props.y,
	    width: props.width,
	    height: props.height,
	    clipPath: props.clipPath
	  }));
	};
	
	Border.propTypes = _objectSpread({}, _commonProps.default.primitiveProps, {
	  height: _propTypes.default.number,
	  rectComponent: _propTypes.default.element,
	  width: _propTypes.default.number,
	  x: _propTypes.default.number,
	  y: _propTypes.default.number
	});
	Border.defaultProps = {
	  rectComponent: _react.default.createElement(_rect.default, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Border;
	exports.default = _default;

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _commonProps = _interopRequireDefault(__webpack_require__(127));
	
	var _line = _interopRequireDefault(__webpack_require__(297));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var LineSegment = function (props) {
	  return _react.default.cloneElement(props.lineComponent, _objectSpread({}, props.events, {
	    style: _helpers.default.evaluateStyle((0, _assign2.default)({
	      stroke: "black"
	    }, props.style), props),
	    desc: _helpers.default.evaluateProp(props.desc, props),
	    tabIndex: _helpers.default.evaluateProp(props.tabIndex, props),
	    className: props.className,
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    x1: props.x1,
	    x2: props.x2,
	    y1: props.y1,
	    y2: props.y2,
	    transform: props.transform,
	    clipPath: props.clipPath
	  }));
	};
	
	LineSegment.propTypes = _objectSpread({}, _commonProps.default.primitiveProps, {
	  datum: _propTypes.default.any,
	  lineComponent: _propTypes.default.element,
	  x1: _propTypes.default.number,
	  x2: _propTypes.default.number,
	  y1: _propTypes.default.number,
	  y2: _propTypes.default.number
	});
	LineSegment.defaultProps = {
	  lineComponent: _react.default.createElement(_line.default, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = LineSegment;
	exports.default = _default;

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _range2 = _interopRequireDefault(__webpack_require__(192));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  circle: function (x, y, size) {
	    return "M ".concat(x, ", ").concat(y, "\n      m ").concat(-size, ", 0\n      a ").concat(size, ", ").concat(size, " 0 1,0 ").concat(size * 2, ",0\n      a ").concat(size, ", ").concat(size, " 0 1,0 ").concat(-size * 2, ",0");
	  },
	  square: function (x, y, size) {
	    var baseSize = 0.87 * size; // eslint-disable-line no-magic-numbers
	
	    var x0 = x - baseSize;
	    var y1 = y + baseSize;
	    var distance = x + baseSize - x0;
	    return "M ".concat(x0, ", ").concat(y1, "\n      h").concat(distance, "\n      v-").concat(distance, "\n      h-").concat(distance, "\n      z");
	  },
	  diamond: function (x, y, size) {
	    var baseSize = 0.87 * size; // eslint-disable-line no-magic-numbers
	
	    var length = Math.sqrt(2 * (baseSize * baseSize));
	    return "M ".concat(x, ", ").concat(y + length, "\n      l ").concat(length, ", -").concat(length, "\n      l -").concat(length, ", -").concat(length, "\n      l -").concat(length, ", ").concat(length, "\n      l ").concat(length, ", ").concat(length, "\n      z");
	  },
	  triangleDown: function (x, y, size) {
	    var height = size / 2 * Math.sqrt(3);
	    var x0 = x - size;
	    var x1 = x + size;
	    var y0 = y - size;
	    var y1 = y + height;
	    return "M ".concat(x0, ", ").concat(y0, "\n      L ").concat(x1, ", ").concat(y0, "\n      L ").concat(x, ", ").concat(y1, "\n      z");
	  },
	  triangleUp: function (x, y, size) {
	    var height = size / 2 * Math.sqrt(3);
	    var x0 = x - size;
	    var x1 = x + size;
	    var y0 = y - height;
	    var y1 = y + size;
	    return "M ".concat(x0, ", ").concat(y1, "\n      L ").concat(x1, ", ").concat(y1, "\n      L ").concat(x, ", ").concat(y0, "\n      z");
	  },
	  plus: function (x, y, size) {
	    var baseSize = 1.1 * size; // eslint-disable-line no-magic-numbers
	
	    var distance = baseSize / 1.5; // eslint-disable-line no-magic-numbers
	
	    return "\n      M ".concat(x - distance / 2, ", ").concat(y + baseSize, "\n      v-").concat(distance, "\n      h-").concat(distance, "\n      v-").concat(distance, "\n      h").concat(distance, "\n      v-").concat(distance, "\n      h").concat(distance, "\n      v").concat(distance, "\n      h").concat(distance, "\n      v").concat(distance, "\n      h-").concat(distance, "\n      v").concat(distance, "\n      z");
	  },
	  minus: function (x, y, size) {
	    var baseSize = 1.1 * size; // eslint-disable-line no-magic-numbers
	
	    var lineHeight = baseSize - baseSize * 0.3; // eslint-disable-line no-magic-numbers
	
	    var x0 = x - baseSize;
	    var y1 = y + lineHeight / 2;
	    var distance = x + baseSize - x0;
	    return "M ".concat(x0, ", ").concat(y1, "\n      h").concat(distance, "\n      v-").concat(lineHeight, "\n      h-").concat(distance, "\n      z");
	  },
	  star: function (x, y, size) {
	    var baseSize = 1.35 * size; // eslint-disable-line no-magic-numbers
	
	    var angle = Math.PI / 5; // eslint-disable-line no-magic-numbers
	    // eslint-disable-next-line no-magic-numbers
	
	    var starCoords = (0, _range2.default)(10).map(function (index) {
	      var length = index % 2 === 0 ? baseSize : baseSize / 2;
	      return "".concat(length * Math.sin(angle * (index + 1)) + x, ",\n        ").concat(length * Math.cos(angle * (index + 1)) + y);
	    });
	    return "M ".concat(starCoords.join("L"), " z");
	  }
	};
	exports.default = _default;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _pathHelpers = _interopRequireDefault(__webpack_require__(1866));
	
	var _commonProps = _interopRequireDefault(__webpack_require__(127));
	
	var _path = _interopRequireDefault(__webpack_require__(298));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getPath = function (props) {
	  var x = props.x,
	      y = props.y;
	
	  var size = _helpers.default.evaluateProp(props.size, props);
	
	  if (props.getPath) {
	    return props.getPath(x, y, size);
	  }
	
	  var pathFunctions = {
	    circle: _pathHelpers.default.circle,
	    square: _pathHelpers.default.square,
	    diamond: _pathHelpers.default.diamond,
	    triangleDown: _pathHelpers.default.triangleDown,
	    triangleUp: _pathHelpers.default.triangleUp,
	    plus: _pathHelpers.default.plus,
	    minus: _pathHelpers.default.minus,
	    star: _pathHelpers.default.star
	  };
	
	  var symbol = _helpers.default.evaluateProp(props.symbol, props);
	
	  var symbolFunction = typeof pathFunctions[symbol] === "function" ? pathFunctions[symbol] : pathFunctions.circle;
	  return symbolFunction(x, y, size);
	};
	
	var Point = function (props) {
	  return _react.default.cloneElement(props.pathComponent, _objectSpread({}, props.events, {
	    d: getPath(props),
	    style: _helpers.default.evaluateStyle(props.style, props),
	    desc: _helpers.default.evaluateProp(props.desc, props),
	    tabIndex: _helpers.default.evaluateProp(props.tabIndex, props),
	    role: props.role,
	    shapeRendering: props.shapeRendering,
	    className: props.className,
	    transform: props.transform,
	    clipPath: props.clipPath
	  }));
	};
	
	Point.propTypes = _objectSpread({}, _commonProps.default.primitiveProps, {
	  datum: _propTypes.default.object,
	  getPath: _propTypes.default.func,
	  pathComponent: _propTypes.default.element,
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  symbol: _propTypes.default.oneOfType([_propTypes.default.oneOf(["circle", "diamond", "plus", "minus", "square", "star", "triangleDown", "triangleUp"]), _propTypes.default.func]),
	  x: _propTypes.default.number,
	  y: _propTypes.default.number
	});
	Point.defaultProps = {
	  pathComponent: _react.default.createElement(_path.default, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Point;
	exports.default = _default;

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _commonProps = _interopRequireDefault(__webpack_require__(127));
	
	var _line = _interopRequireDefault(__webpack_require__(297));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Whisker = function (props) {
	  var groupComponent = props.groupComponent,
	      lineComponent = props.lineComponent,
	      events = props.events,
	      className = props.className,
	      majorWhisker = props.majorWhisker,
	      minorWhisker = props.minorWhisker,
	      transform = props.transform,
	      clipPath = props.clipPath,
	      role = props.role,
	      shapeRendering = props.shapeRendering;
	
	  var baseProps = _objectSpread({}, events, {
	    style: _helpers.default.evaluateStyle(props.style, props),
	    desc: _helpers.default.evaluateProp(props.desc, props),
	    tabIndex: _helpers.default.evaluateProp(props.tabIndex, props),
	    className: className,
	    transform: transform,
	    clipPath: clipPath,
	    role: role,
	    shapeRendering: shapeRendering
	  });
	
	  return _react.default.cloneElement(groupComponent, {}, [_react.default.cloneElement(lineComponent, (0, _assign2.default)({
	    key: "major-whisker"
	  }, baseProps, majorWhisker)), _react.default.cloneElement(lineComponent, (0, _assign2.default)({
	    key: "minor-whisker"
	  }, baseProps, minorWhisker))]);
	};
	
	Whisker.propTypes = _objectSpread({}, _commonProps.default.primitiveProps, {
	  groupComponent: _propTypes.default.element,
	  lineComponent: _propTypes.default.element,
	  majorWhisker: _propTypes.default.shape({
	    x1: _propTypes.default.number,
	    x2: _propTypes.default.number,
	    y1: _propTypes.default.number,
	    y2: _propTypes.default.number
	  }),
	  minorWhisker: _propTypes.default.shape({
	    x1: _propTypes.default.number,
	    x2: _propTypes.default.number,
	    y1: _propTypes.default.number,
	    y2: _propTypes.default.number
	  })
	});
	Whisker.defaultProps = {
	  groupComponent: _react.default.createElement("g", null),
	  lineComponent: _react.default.createElement(_line.default, null),
	  role: "presentation",
	  shapeRendering: "auto"
	};
	var _default = Whisker;
	exports.default = _default;

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// *
	// * Colors
	// *
	var colors = ["#252525", "#525252", "#737373", "#969696", "#bdbdbd", "#d9d9d9", "#f0f0f0"];
	var charcoal = "#252525";
	var grey = "#969696"; // *
	// * Typography
	// *
	
	var sansSerif = "'Gill Sans', 'Gill Sans MT', 'Seravek', 'Trebuchet MS', sans-serif";
	var letterSpacing = "normal";
	var fontSize = 14; // *
	// * Layout
	// *
	
	var baseProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  colorScale: colors
	}; // *
	// * Labels
	// *
	
	var baseLabelStyles = {
	  fontFamily: sansSerif,
	  fontSize: fontSize,
	  letterSpacing: letterSpacing,
	  padding: 10,
	  fill: charcoal,
	  stroke: "transparent"
	};
	var centeredLabelStyles = (0, _assign2.default)({
	  textAnchor: "middle"
	}, baseLabelStyles); // *
	// * Strokes
	// *
	
	var strokeLinecap = "round";
	var strokeLinejoin = "round";
	var _default = {
	  area: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: charcoal
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  axis: (0, _assign2.default)({
	    style: {
	      axis: {
	        fill: "transparent",
	        stroke: charcoal,
	        strokeWidth: 1,
	        strokeLinecap: strokeLinecap,
	        strokeLinejoin: strokeLinejoin
	      },
	      axisLabel: (0, _assign2.default)({}, centeredLabelStyles, {
	        padding: 25
	      }),
	      grid: {
	        fill: "none",
	        stroke: "none",
	        pointerEvents: "painted"
	      },
	      ticks: {
	        fill: "transparent",
	        size: 1,
	        stroke: "transparent"
	      },
	      tickLabels: baseLabelStyles
	    }
	  }, baseProps),
	  bar: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: charcoal,
	        padding: 8,
	        strokeWidth: 0
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  boxplot: (0, _assign2.default)({
	    style: {
	      max: {
	        padding: 8,
	        stroke: charcoal,
	        strokeWidth: 1
	      },
	      maxLabels: baseLabelStyles,
	      median: {
	        padding: 8,
	        stroke: charcoal,
	        strokeWidth: 1
	      },
	      medianLabels: baseLabelStyles,
	      min: {
	        padding: 8,
	        stroke: charcoal,
	        strokeWidth: 1
	      },
	      minLabels: baseLabelStyles,
	      q1: {
	        padding: 8,
	        fill: grey
	      },
	      q1Labels: baseLabelStyles,
	      q3: {
	        padding: 8,
	        fill: grey
	      },
	      q3Labels: baseLabelStyles
	    },
	    boxWidth: 20
	  }, baseProps),
	  candlestick: (0, _assign2.default)({
	    style: {
	      data: {
	        stroke: charcoal,
	        strokeWidth: 1
	      },
	      labels: baseLabelStyles
	    },
	    candleColors: {
	      positive: "#ffffff",
	      negative: charcoal
	    }
	  }, baseProps),
	  chart: baseProps,
	  errorbar: (0, _assign2.default)({
	    borderWidth: 8,
	    style: {
	      data: {
	        fill: "transparent",
	        stroke: charcoal,
	        strokeWidth: 2
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  group: (0, _assign2.default)({
	    colorScale: colors
	  }, baseProps),
	  legend: {
	    colorScale: colors,
	    gutter: 10,
	    orientation: "vertical",
	    titleOrientation: "top",
	    style: {
	      data: {
	        type: "circle"
	      },
	      labels: baseLabelStyles,
	      title: (0, _assign2.default)({}, baseLabelStyles, {
	        padding: 5
	      })
	    }
	  },
	  line: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: "transparent",
	        stroke: charcoal,
	        strokeWidth: 2
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  pie: {
	    style: {
	      data: {
	        padding: 10,
	        stroke: "transparent",
	        strokeWidth: 1
	      },
	      labels: (0, _assign2.default)({}, baseLabelStyles, {
	        padding: 20
	      })
	    },
	    colorScale: colors,
	    width: 400,
	    height: 400,
	    padding: 50
	  },
	  scatter: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: charcoal,
	        stroke: "transparent",
	        strokeWidth: 0
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  stack: (0, _assign2.default)({
	    colorScale: colors
	  }, baseProps),
	  tooltip: {
	    style: (0, _assign2.default)({}, baseLabelStyles, {
	      padding: 5,
	      pointerEvents: "none"
	    }),
	    flyoutStyle: {
	      stroke: charcoal,
	      strokeWidth: 1,
	      fill: "#f0f0f0",
	      pointerEvents: "none"
	    },
	    cornerRadius: 5,
	    pointerLength: 10
	  },
	  voronoi: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: "transparent",
	        stroke: "transparent",
	        strokeWidth: 0
	      },
	      labels: (0, _assign2.default)({}, baseLabelStyles, {
	        padding: 5,
	        pointerEvents: "none"
	      }),
	      flyout: {
	        stroke: charcoal,
	        strokeWidth: 1,
	        fill: "#f0f0f0",
	        pointerEvents: "none"
	      }
	    }
	  }, baseProps)
	};
	exports.default = _default;

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// *
	// * Colors
	// *
	var yellow200 = "#FFF59D";
	var deepOrange600 = "#F4511E";
	var lime300 = "#DCE775";
	var lightGreen500 = "#8BC34A";
	var teal700 = "#00796B";
	var cyan900 = "#006064";
	var colors = [deepOrange600, yellow200, lime300, lightGreen500, teal700, cyan900];
	var blueGrey50 = "#ECEFF1";
	var blueGrey300 = "#90A4AE";
	var blueGrey700 = "#455A64";
	var grey900 = "#212121"; // *
	// * Typography
	// *
	
	var sansSerif = "'Roboto', 'Helvetica Neue', Helvetica, sans-serif";
	var letterSpacing = "normal";
	var fontSize = 12; // *
	// * Layout
	// *
	
	var padding = 8;
	var baseProps = {
	  width: 350,
	  height: 350,
	  padding: 50
	}; // *
	// * Labels
	// *
	
	var baseLabelStyles = {
	  fontFamily: sansSerif,
	  fontSize: fontSize,
	  letterSpacing: letterSpacing,
	  padding: padding,
	  fill: blueGrey700,
	  stroke: "transparent",
	  strokeWidth: 0
	};
	var centeredLabelStyles = (0, _assign2.default)({
	  textAnchor: "middle"
	}, baseLabelStyles); // *
	// * Strokes
	// *
	
	var strokeDasharray = "10, 5";
	var strokeLinecap = "round";
	var strokeLinejoin = "round";
	var _default = {
	  area: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: grey900
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  axis: (0, _assign2.default)({
	    style: {
	      axis: {
	        fill: "transparent",
	        stroke: blueGrey300,
	        strokeWidth: 2,
	        strokeLinecap: strokeLinecap,
	        strokeLinejoin: strokeLinejoin
	      },
	      axisLabel: (0, _assign2.default)({}, centeredLabelStyles, {
	        padding: padding,
	        stroke: "transparent"
	      }),
	      grid: {
	        fill: "none",
	        stroke: blueGrey50,
	        strokeDasharray: strokeDasharray,
	        strokeLinecap: strokeLinecap,
	        strokeLinejoin: strokeLinejoin,
	        pointerEvents: "painted"
	      },
	      ticks: {
	        fill: "transparent",
	        size: 5,
	        stroke: blueGrey300,
	        strokeWidth: 1,
	        strokeLinecap: strokeLinecap,
	        strokeLinejoin: strokeLinejoin
	      },
	      tickLabels: (0, _assign2.default)({}, baseLabelStyles, {
	        fill: blueGrey700
	      })
	    }
	  }, baseProps),
	  bar: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: blueGrey700,
	        padding: padding,
	        strokeWidth: 0
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  boxplot: (0, _assign2.default)({
	    style: {
	      max: {
	        padding: padding,
	        stroke: blueGrey700,
	        strokeWidth: 1
	      },
	      maxLabels: baseLabelStyles,
	      median: {
	        padding: padding,
	        stroke: blueGrey700,
	        strokeWidth: 1
	      },
	      medianLabels: baseLabelStyles,
	      min: {
	        padding: padding,
	        stroke: blueGrey700,
	        strokeWidth: 1
	      },
	      minLabels: baseLabelStyles,
	      q1: {
	        padding: padding,
	        fill: blueGrey700
	      },
	      q1Labels: baseLabelStyles,
	      q3: {
	        padding: padding,
	        fill: blueGrey700
	      },
	      q3Labels: baseLabelStyles
	    },
	    boxWidth: 20
	  }, baseProps),
	  candlestick: (0, _assign2.default)({
	    style: {
	      data: {
	        stroke: blueGrey700
	      },
	      labels: baseLabelStyles
	    },
	    candleColors: {
	      positive: "#ffffff",
	      negative: blueGrey700
	    }
	  }, baseProps),
	  chart: baseProps,
	  errorbar: (0, _assign2.default)({
	    borderWidth: 8,
	    style: {
	      data: {
	        fill: "transparent",
	        opacity: 1,
	        stroke: blueGrey700,
	        strokeWidth: 2
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  group: (0, _assign2.default)({
	    colorScale: colors
	  }, baseProps),
	  legend: {
	    colorScale: colors,
	    gutter: 10,
	    orientation: "vertical",
	    titleOrientation: "top",
	    style: {
	      data: {
	        type: "circle"
	      },
	      labels: baseLabelStyles,
	      title: (0, _assign2.default)({}, baseLabelStyles, {
	        padding: 5
	      })
	    }
	  },
	  line: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: "transparent",
	        opacity: 1,
	        stroke: blueGrey700,
	        strokeWidth: 2
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  pie: (0, _assign2.default)({
	    colorScale: colors,
	    style: {
	      data: {
	        padding: padding,
	        stroke: blueGrey50,
	        strokeWidth: 1
	      },
	      labels: (0, _assign2.default)({}, baseLabelStyles, {
	        padding: 20
	      })
	    }
	  }, baseProps),
	  scatter: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: blueGrey700,
	        opacity: 1,
	        stroke: "transparent",
	        strokeWidth: 0
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  stack: (0, _assign2.default)({
	    colorScale: colors
	  }, baseProps),
	  tooltip: {
	    style: (0, _assign2.default)({}, baseLabelStyles, {
	      padding: 5,
	      pointerEvents: "none"
	    }),
	    flyoutStyle: {
	      stroke: grey900,
	      strokeWidth: 1,
	      fill: "#f0f0f0",
	      pointerEvents: "none"
	    },
	    cornerRadius: 5,
	    pointerLength: 10
	  },
	  voronoi: (0, _assign2.default)({
	    style: {
	      data: {
	        fill: "transparent",
	        stroke: "transparent",
	        strokeWidth: 0
	      },
	      labels: (0, _assign2.default)({}, baseLabelStyles, {
	        padding: 5,
	        pointerEvents: "none"
	      }),
	      flyout: {
	        stroke: grey900,
	        strokeWidth: 1,
	        fill: "#f0f0f0",
	        pointerEvents: "none"
	      }
	    }
	  }, baseProps)
	};
	exports.default = _default;

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _material = _interopRequireDefault(__webpack_require__(1870));
	
	var _grayscale = _interopRequireDefault(__webpack_require__(1869));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  material: _material.default,
	  grayscale: _grayscale.default
	};
	exports.default = _default;

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _without2 = _interopRequireDefault(__webpack_require__(194));
	
	var _pick2 = _interopRequireDefault(__webpack_require__(152));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(56));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _events = _interopRequireDefault(__webpack_require__(302));
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	var _victoryTransition = _interopRequireDefault(__webpack_require__(677));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var datumHasXandY = function (datum) {
	  return !(0, _isNil2.default)(datum._x) && !(0, _isNil2.default)(datum._y);
	}; //  used for checking state changes. Expected components can be passed in via options
	
	
	var defaultComponents = [{
	  name: "parent",
	  index: "parent"
	}, {
	  name: "data"
	}, {
	  name: "labels"
	}];
	
	var _default = function _default(WrappedComponent, options) {
	  return (
	    /*#__PURE__*/
	    function (_WrappedComponent) {
	      _inherits(addEvents, _WrappedComponent);
	
	      function addEvents(props) {
	        var _this;
	
	        _classCallCheck(this, addEvents);
	
	        _this = _possibleConstructorReturn(this, (addEvents.__proto__ || Object.getPrototypeOf(addEvents)).call(this, props));
	
	        var getScopedEvents = _events.default.getScopedEvents.bind(_assertThisInitialized(_this));
	
	        var boundGetEvents = _events.default.getEvents.bind(_assertThisInitialized(_this));
	
	        _this.state = {};
	
	        _this.getEvents = function (p, target, eventKey) {
	          return boundGetEvents(p, target, eventKey, getScopedEvents);
	        };
	
	        _this.getEventState = _events.default.getEventState.bind(_assertThisInitialized(_this));
	
	        var calculatedValues = _this.getCalculatedValues(props);
	
	        _this.cacheValues(calculatedValues);
	
	        _this.externalMutations = _this.getExternalMutations(props);
	        _this.calculatedState = _this.getStateChanges(props, calculatedValues);
	        return _this;
	      }
	
	      _createClass(addEvents, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps) {
	          var calculatedValues = this.getCalculatedValues(nextProps);
	          var externalMutations = this.getExternalMutations(nextProps);
	          var animating = this.props.animating || this.props.animate;
	          var newMutation = !(0, _reactFastCompare.default)(externalMutations, this.externalMutations);
	
	          if (animating || newMutation) {
	            this.cacheValues(calculatedValues);
	            this.externalMutations = externalMutations;
	            this.applyExternalMutations(nextProps, externalMutations);
	            return true;
	          }
	
	          var calculatedState = this.getStateChanges(nextProps, calculatedValues);
	
	          if (!(0, _reactFastCompare.default)(this.calculatedState, calculatedState)) {
	            this.calculatedState = calculatedState;
	            this.cacheValues(calculatedValues);
	            return true;
	          }
	
	          if (!(0, _reactFastCompare.default)(this.props, nextProps)) {
	            this.cacheValues(calculatedValues);
	            return true;
	          }
	
	          return false;
	        } // compile all state changes from own and parent state. Order doesn't matter, as any state
	        // state change should trigger a re-render
	
	      }, {
	        key: "getStateChanges",
	        value: function getStateChanges(props, calculatedValues) {
	          var _this2 = this;
	
	          var hasEvents = calculatedValues.hasEvents,
	              getSharedEventState = calculatedValues.getSharedEventState;
	
	          if (!hasEvents) {
	            return {};
	          }
	
	          var getState = function (key, type) {
	            var result = (0, _defaults2.default)({}, _this2.getEventState(key, type), getSharedEventState(key, type));
	            return (0, _isEmpty2.default)(result) ? undefined : result;
	          };
	
	          options = options || {};
	          var components = options.components || defaultComponents;
	          var stateChanges = components.map(function (component) {
	            if (!props.standalone && component.name === "parent") {
	              // don't check for changes on parent props for non-standalone components
	              return undefined;
	            } else {
	              return component.index !== undefined ? getState(component.index, component.name) : calculatedValues.dataKeys.map(function (key) {
	                return getState(key, component.name);
	              }).filter(Boolean);
	            }
	          }).filter(Boolean);
	          return stateChanges;
	        }
	      }, {
	        key: "applyExternalMutations",
	        value: function applyExternalMutations(props, externalMutations) {
	          if (!(0, _isEmpty2.default)(externalMutations)) {
	            var callbacks = props.externalEventMutations.reduce(function (memo, mutation) {
	              memo = (0, _isFunction2.default)(mutation.callback) ? memo.concat(mutation.callback) : memo;
	              return memo;
	            }, []);
	            var compiledCallbacks = callbacks.length ? function () {
	              callbacks.forEach(function (c) {
	                return c();
	              });
	            } : undefined;
	            this.setState(externalMutations, compiledCallbacks);
	          }
	        }
	      }, {
	        key: "getCalculatedValues",
	        value: function getCalculatedValues(props) {
	          var sharedEvents = props.sharedEvents;
	          var components = WrappedComponent.expectedComponents;
	
	          var componentEvents = _events.default.getComponentEvents(props, components);
	
	          var getSharedEventState = sharedEvents && (0, _isFunction2.default)(sharedEvents.getEventState) ? sharedEvents.getEventState : function () {
	            return undefined;
	          };
	          var baseProps = this.getBaseProps(props, getSharedEventState);
	          var dataKeys = (0, _keys2.default)(baseProps).filter(function (key) {
	            return key !== "parent";
	          });
	          var hasEvents = props.events || props.sharedEvents || componentEvents;
	          var events = this.getAllEvents(props);
	          return {
	            componentEvents: componentEvents,
	            getSharedEventState: getSharedEventState,
	            baseProps: baseProps,
	            dataKeys: dataKeys,
	            hasEvents: hasEvents,
	            events: events
	          };
	        }
	      }, {
	        key: "getExternalMutations",
	        value: function getExternalMutations(props) {
	          var sharedEvents = props.sharedEvents,
	              externalEventMutations = props.externalEventMutations;
	          return (0, _isEmpty2.default)(externalEventMutations) || sharedEvents ? undefined : _events.default.getExternalMutations(externalEventMutations, this.baseProps, this.state);
	        }
	      }, {
	        key: "cacheValues",
	        value: function cacheValues(obj) {
	          var _this3 = this;
	
	          (0, _keys2.default)(obj).forEach(function (key) {
	            _this3[key] = obj[key];
	          });
	        }
	      }, {
	        key: "getBaseProps",
	        value: function getBaseProps(props, getSharedEventState) {
	          getSharedEventState = getSharedEventState || this.getSharedEventState;
	          var sharedParentState = getSharedEventState("parent", "parent");
	          var parentState = this.getEventState("parent", "parent");
	          var baseParentProps = (0, _defaults2.default)({}, parentState, sharedParentState);
	          var parentPropsList = baseParentProps.parentControlledProps;
	          var parentProps = parentPropsList ? (0, _pick2.default)(baseParentProps, parentPropsList) : {};
	          var modifiedProps = (0, _defaults2.default)({}, parentProps, props);
	          return (0, _isFunction2.default)(WrappedComponent.getBaseProps) ? WrappedComponent.getBaseProps(modifiedProps) : {};
	        }
	      }, {
	        key: "getAllEvents",
	        value: function getAllEvents(props) {
	          if (Array.isArray(this.componentEvents)) {
	            var _componentEvents;
	
	            return Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray(props.events)) : this.componentEvents;
	          }
	
	          return props.events;
	        }
	      }, {
	        key: "getComponentProps",
	        value: function getComponentProps(component, type, index) {
	          var name = this.props.name || WrappedComponent.role;
	          var key = this.dataKeys && this.dataKeys[index] || index;
	          var id = "".concat(name, "-").concat(type, "-").concat(key);
	          var baseProps = this.baseProps[key] && this.baseProps[key][type] || this.baseProps[key];
	
	          if (!baseProps && !this.hasEvents) {
	            return undefined;
	          }
	
	          if (this.hasEvents) {
	            var baseEvents = this.getEvents(this.props, type, key);
	            var componentProps = (0, _defaults2.default)({
	              index: index,
	              key: id
	            }, this.getEventState(key, type), this.getSharedEventState(key, type), component.props, baseProps, {
	              id: id
	            });
	            var events = (0, _defaults2.default)({}, _events.default.getPartialEvents(baseEvents, key, componentProps), componentProps.events);
	            return (0, _assign2.default)({}, componentProps, {
	              events: events
	            });
	          }
	
	          return (0, _defaults2.default)({
	            index: index,
	            key: id
	          }, component.props, baseProps, {
	            id: id
	          });
	        }
	      }, {
	        key: "renderContainer",
	        value: function renderContainer(component, children) {
	          var isContainer = component.type && component.type.role === "container";
	          var parentProps = isContainer ? this.getComponentProps(component, "parent", "parent") : {};
	          return _react.default.cloneElement(component, parentProps, children);
	        }
	      }, {
	        key: "animateComponent",
	        value: function animateComponent(props, defaultAnimationWhitelist) {
	          var animationWhitelist = props.animate && props.animate.animationWhitelist ? props.animate.animationWhitelist : defaultAnimationWhitelist;
	          return _react.default.createElement(_victoryTransition.default, {
	            animate: props.animate,
	            animationWhitelist: animationWhitelist
	          }, _react.default.createElement(this.constructor, props));
	        } // Used by `VictoryLine` and `VictoryArea`
	
	      }, {
	        key: "renderContinuousData",
	        value: function renderContinuousData(props) {
	          var _this4 = this;
	
	          var dataComponent = props.dataComponent,
	              labelComponent = props.labelComponent,
	              groupComponent = props.groupComponent;
	          var dataKeys = (0, _without2.default)(this.dataKeys, "all");
	          var labelComponents = dataKeys.reduce(function (memo, key) {
	            var labelProps = _this4.getComponentProps(labelComponent, "labels", key);
	
	            if (labelProps && labelProps.text !== undefined && labelProps.text !== null) {
	              memo = memo.concat(_react.default.cloneElement(labelComponent, labelProps));
	            }
	
	            return memo;
	          }, []);
	          var dataProps = this.getComponentProps(dataComponent, "data", "all");
	          var children = [_react.default.cloneElement(dataComponent, dataProps)].concat(_toConsumableArray(labelComponents));
	          return this.renderContainer(groupComponent, children);
	        }
	      }, {
	        key: "renderData",
	        value: function renderData(props) {
	          var _this5 = this;
	
	          var shouldRenderDatum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : datumHasXandY;
	          var dataComponent = props.dataComponent,
	              labelComponent = props.labelComponent,
	              groupComponent = props.groupComponent;
	          var dataComponents = this.dataKeys.reduce(function (validDataComponents, _dataKey, index) {
	            var dataProps = _this5.getComponentProps(dataComponent, "data", index);
	
	            if (shouldRenderDatum(dataProps.datum)) {
	              validDataComponents.push(_react.default.cloneElement(dataComponent, dataProps));
	            }
	
	            return validDataComponents;
	          }, []);
	          var labelComponents = this.dataKeys.map(function (_dataKey, index) {
	            var labelProps = _this5.getComponentProps(labelComponent, "labels", index);
	
	            if (labelProps.text !== undefined && labelProps.text !== null) {
	              return _react.default.cloneElement(labelComponent, labelProps);
	            }
	
	            return undefined;
	          }).filter(Boolean);
	
	          var children = _toConsumableArray(dataComponents).concat(_toConsumableArray(labelComponents));
	
	          return this.renderContainer(groupComponent, children);
	        }
	      }]);
	
	      return addEvents;
	    }(WrappedComponent)
	  );
	};
	
	exports.default = _default;

/***/ },
/* 1873 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable func-style */
	var _default = {
	  continuousTransitions: function () {
	    return {
	      onLoad: {
	        duration: 2000
	      },
	      onExit: {
	        duration: 500
	      },
	      onEnter: {
	        duration: 500
	      }
	    };
	  },
	  continuousPolarTransitions: function () {
	    return {
	      onLoad: {
	        duration: 2000,
	        before: function () {
	          return {
	            _y: 0,
	            _y1: 0,
	            _y0: 0
	          };
	        },
	        after: function (datum) {
	          return {
	            _y: datum._y,
	            _y1: datum._y1,
	            _y0: datum._y0
	          };
	        }
	      },
	      onExit: {
	        duration: 500,
	        before: function (datum, index, data) {
	          var adjacent = function (attr) {
	            var adj = index === 0 ? data[index + 1] : data[index - 1];
	            return adj[attr];
	          };
	
	          return {
	            _x: adjacent("_x"),
	            _y: adjacent("_y"),
	            _y0: adjacent("_y0")
	          };
	        }
	      },
	      onEnter: {
	        duration: 500,
	        before: function (datum, index, data) {
	          var adjacent = function (attr) {
	            var adj = index === 0 ? data[index + 1] : data[index - 1];
	            return adj[attr];
	          };
	
	          return {
	            _x: adjacent("_x"),
	            _y: adjacent("_y"),
	            _y0: adjacent("_y0")
	          };
	        },
	        after: function (datum) {
	          return {
	            _x: datum._x,
	            _y: datum._y,
	            _y1: datum._y1,
	            _y0: datum._y0
	          };
	        }
	      }
	    };
	  },
	  discreteTransitions: function () {
	    return {
	      onLoad: {
	        duration: 2000,
	        before: function () {
	          return {
	            opacity: 0
	          };
	        },
	        after: function (datum) {
	          return datum;
	        }
	      },
	      onExit: {
	        duration: 600,
	        before: function () {
	          return {
	            opacity: 0
	          };
	        }
	      },
	      onEnter: {
	        duration: 600,
	        before: function () {
	          return {
	            opacity: 0
	          };
	        },
	        after: function (datum) {
	          return datum;
	        }
	      }
	    };
	  }
	};
	exports.default = _default;

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _collection = _interopRequireDefault(__webpack_require__(89));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable func-style */
	
	/* eslint-disable no-use-before-define */
	// Private Functions
	function transformTarget(target, matrix, dimension) {
	  var a = matrix.a,
	      d = matrix.d,
	      e = matrix.e,
	      f = matrix.f;
	  return dimension === "y" ? d * target + f : a * target + e;
	}
	
	function getTransformationMatrix(svg) {
	  return svg.getScreenCTM().inverse();
	} // Exported Functions
	
	
	function getParentSVG(evt) {
	  if (evt.nativeEvent && evt.nativeEvent.identifier !== undefined) {
	    return undefined;
	  }
	
	  var getParent = function (target) {
	    if (target.nodeName === "svg") {
	      return target;
	    } else {
	      return target.parentNode ? getParent(target.parentNode) : target;
	    }
	  };
	
	  return getParent(evt.target);
	}
	
	function getSVGEventCoordinates(evt, svg) {
	  if (evt.nativeEvent && evt.nativeEvent.identifier !== undefined) {
	    // react-native override. relies on the RN.View being the _exact_ same size as its child SVG.
	    // this should be fine: the svg is the only child of View and the View shirks to its children
	    return {
	      x: evt.nativeEvent.locationX,
	      y: evt.nativeEvent.locationY
	    };
	  }
	
	  evt = evt.changedTouches && evt.changedTouches.length ? evt.changedTouches[0] : evt;
	  svg = svg || getParentSVG(evt);
	  var matrix = getTransformationMatrix(svg);
	  return {
	    x: transformTarget(evt.clientX, matrix, "x"),
	    y: transformTarget(evt.clientY, matrix, "y")
	  };
	}
	
	function getDomainCoordinates(props, domain) {
	  var scale = props.scale,
	      horizontal = props.horizontal;
	  domain = domain || {
	    x: scale.x.domain(),
	    y: scale.y.domain()
	  };
	  return {
	    x: horizontal ? [scale.y(domain.y[0]), scale.y(domain.y[1])] : [scale.x(domain.x[0]), scale.x(domain.x[1])],
	    y: horizontal ? [scale.x(domain.x[0]), scale.x(domain.x[1])] : [scale.y(domain.y[0]), scale.y(domain.y[1])]
	  };
	} // eslint-disable-next-line max-params
	
	
	function getDataCoordinates(props, scale, x, y) {
	  var polar = props.polar,
	      horizontal = props.horizontal;
	
	  if (!polar) {
	    return {
	      x: horizontal ? scale.x.invert(y) : scale.x.invert(x),
	      y: horizontal ? scale.y.invert(x) : scale.y.invert(y)
	    };
	  } else {
	    var origin = props.origin || {
	      x: 0,
	      y: 0
	    };
	    var baseX = x - origin.x;
	    var baseY = y - origin.y;
	    var radius = Math.abs(baseX * Math.sqrt(1 + Math.pow(-baseY / baseX, 2)));
	    var angle = (-Math.atan2(baseY, baseX) + Math.PI * 2) % (Math.PI * 2);
	    return {
	      x: scale.x.invert(angle),
	      y: scale.y.invert(radius)
	    };
	  }
	}
	
	function getBounds(props) {
	  var x1 = props.x1,
	      x2 = props.x2,
	      y1 = props.y1,
	      y2 = props.y2,
	      scale = props.scale;
	  var point1 = getDataCoordinates(props, scale, x1, y1);
	  var point2 = getDataCoordinates(props, scale, x2, y2);
	
	  var makeBound = function (a, b) {
	    return [_collection.default.getMinValue([a, b]), _collection.default.getMaxValue([a, b])];
	  };
	
	  return {
	    x: makeBound(point1.x, point2.x),
	    y: makeBound(point1.y, point2.y)
	  };
	}
	
	var _default = {
	  getParentSVG: getParentSVG,
	  getSVGEventCoordinates: getSVGEventCoordinates,
	  getDomainCoordinates: getDomainCoordinates,
	  getDataCoordinates: getDataCoordinates,
	  getBounds: getBounds
	};
	exports.default = _default;

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var fontDictionary = {
	  "American Typewriter": 2.09,
	  Baskerville: 2.51,
	  Georgia: 2.27,
	  "Hoefler Text": 2.39,
	  Palatino: 2.26,
	  "Times New Roman": 2.48,
	  Arial: 2.26,
	  "Gill Sans": 2.47,
	  "Gill Sans 300": 2.58,
	  "Helvetica Neue": 2.24,
	  "Lucida Grande": 2.05,
	  Tahoma: 2.25,
	  "Trebuchet MS": 2.2,
	  Verdana: 1.96,
	  "Courier New": 1.67,
	  cursive: 1.84,
	  fantasy: 2.09,
	  monospace: 1.81,
	  serif: 2.04,
	  "sans-serif": 1.89
	}; //https://developer.mozilla.org/en/docs/Web/CSS/length
	// Absolute sizes in pixels for obsolete measurement units.
	
	var absoluteMeasurementUnitsToPixels = {
	  mm: 3.8,
	  sm: 38,
	  pt: 1.33,
	  pc: 16,
	  in: 96,
	  px: 1
	};
	var relativeMeasurementUnitsCoef = {
	  em: 1,
	  ex: 0.5
	};
	var coefficients = {
	  averageFontConstant: 2.1675,
	  // Average pixels per glyph in existing font.
	  widthOverlapCoef: 1.25,
	  // Coefficient for width value to prevent overlap.
	  heightOverlapCoef: 1.05,
	  // Coefficient for height value to prevent overlap.
	  lineCapitalCoef: 1.15,
	  // Coefficient for height value. Reserve space for capital chars.
	  lineSpaceHeightCoef: 0.2 // Coefficient for height value. Reserve space between lines.
	
	};
	var defaultStyle = {
	  lineHeight: 1,
	  letterSpacing: "0px",
	  fontSize: 0,
	  angle: 0,
	  fontFamily: ""
	};
	
	var _degreeToRadian = function (angle) {
	  return angle * Math.PI / 180;
	};
	
	var _getFontCharacterConstant = function (fontFamily) {
	  var firstFont = fontFamily.split(",")[0].replace(/'|"/g, "");
	  return fontDictionary[firstFont] || coefficients.averageFontConstant;
	};
	
	var _splitToLines = function (text) {
	  return Array.isArray(text) ? text : text.toString().split(/\r\n|\r|\n/g);
	};
	
	var _getSizeWithRotate = function (axisSize, dependentSize, angle) {
	  var angleInRadian = _degreeToRadian(angle);
	
	  return Math.abs(Math.cos(angleInRadian) * axisSize) + Math.abs(Math.sin(angleInRadian) * dependentSize);
	};
	/**
	 * Convert length-type parameters from specific measurement units to pixels
	 * @param  {string} length Css length string value.
	 * @param  {number} fontSize Current text font-size.
	 * @returns {number} Approximate Css length in pixels.
	 */
	
	
	var convertLengthToPixels = function (length, fontSize) {
	  var attribute = length.match(/[a-zA-Z%]+/)[0];
	  var value = length.match(/[0-9.,]+/);
	  var result;
	
	  if (absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)) {
	    result = value * absoluteMeasurementUnitsToPixels[attribute];
	  } else if (relativeMeasurementUnitsCoef.hasOwnProperty(attribute)) {
	    result = (fontSize ? value * fontSize : value * defaultStyle.fontSize) * relativeMeasurementUnitsCoef[attribute];
	  } else {
	    result = value;
	  }
	
	  return result;
	};
	
	var _prepareParams = function (inputStyle, index) {
	  var lineStyle = Array.isArray(inputStyle) ? inputStyle[index] : inputStyle;
	  var style = (0, _defaults2.default)({}, lineStyle, defaultStyle);
	  return (0, _assign2.default)({}, style, {
	    characterConstant: style.characterConstant || _getFontCharacterConstant(style.fontFamily),
	    letterSpacing: convertLengthToPixels(style.letterSpacing, style.fontSize),
	    fontSize: typeof style.fontSize === "number" ? style.fontSize : convertLengthToPixels(String(style.fontSize))
	  });
	};
	
	var _approximateTextWidthInternal = function (text, style) {
	  if (text === undefined || text === "" || text === null) {
	    return 0;
	  }
	
	  var widths = _splitToLines(text).map(function (line, index) {
	    var len = line.toString().length;
	
	    var _prepareParams2 = _prepareParams(style, index),
	        fontSize = _prepareParams2.fontSize,
	        characterConstant = _prepareParams2.characterConstant,
	        letterSpacing = _prepareParams2.letterSpacing;
	
	    return len * fontSize / characterConstant + letterSpacing * Math.max(len - 1, 0);
	  });
	
	  return Math.max.apply(Math, _toConsumableArray(widths));
	};
	
	var _approximateTextHeightInternal = function (text, style) {
	  if (text === undefined || text === "" || text === null) {
	    return 0;
	  }
	
	  return _splitToLines(text).reduce(function (total, line, index) {
	    var lineStyle = _prepareParams(style, index);
	
	    var containsCaps = line.toString().match(/[(A-Z)(0-9)]/);
	    var height = containsCaps ? lineStyle.fontSize * coefficients.lineCapitalCoef : lineStyle.fontSize;
	    var emptySpace = index === 0 ? 0 : lineStyle.fontSize * coefficients.lineSpaceHeightCoef;
	    return total + lineStyle.lineHeight * (height + emptySpace);
	  }, 0);
	};
	/**
	 * Predict text size by font params.
	 * @param {string} text Content for width calculation.
	 * @param {Object} style Text styles, ,fontFamily, fontSize, etc.
	 * @param {string} style.fontFamily Text fontFamily.
	 * @param {(number|string)} style.fontSize Text fontSize.
	 * @param {number} style.angle Text rotate angle.
	 * @param {string} style.letterSpacing Text letterSpacing(space between letters).
	 * @param {number} style.characterConstant Average pixels per glyph.
	 * @param {number} style.lineHeight Line height coefficient.
	 * @returns {number} Approximate text label height.
	 */
	
	
	var approximateTextSize = function (text, style) {
	  var angle = Array.isArray(style) ? style[0] && style[0].angle : style && style.angle;
	
	  var height = _approximateTextHeightInternal(text, style);
	
	  var width = _approximateTextWidthInternal(text, style);
	
	  var widthWithRotate = angle ? _getSizeWithRotate(width, height, angle) : width;
	  var heightWithRotate = angle ? _getSizeWithRotate(height, width, angle) : height;
	  return {
	    width: widthWithRotate * coefficients.widthOverlapCoef,
	    height: heightWithRotate * coefficients.heightOverlapCoef
	  };
	};
	
	var _default = {
	  approximateTextSize: approximateTextSize,
	  convertLengthToPixels: convertLengthToPixels
	};
	exports.default = _default;

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _values2 = _interopRequireDefault(__webpack_require__(193));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(453));
	
	var _groupBy2 = _interopRequireDefault(__webpack_require__(190));
	
	var _some2 = _interopRequireDefault(__webpack_require__(1375));
	
	var _uniq2 = _interopRequireDefault(__webpack_require__(99));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _flatten2 = _interopRequireDefault(__webpack_require__(150));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _axis = _interopRequireDefault(__webpack_require__(678));
	
	var _style = _interopRequireDefault(__webpack_require__(303));
	
	var _transitions = _interopRequireDefault(__webpack_require__(304));
	
	var _data = _interopRequireDefault(__webpack_require__(300));
	
	var _domain = _interopRequireDefault(__webpack_require__(301));
	
	var _events = _interopRequireDefault(__webpack_require__(302));
	
	var _collection = _interopRequireDefault(__webpack_require__(89));
	
	var _helpers = _interopRequireDefault(__webpack_require__(42));
	
	var _scale = _interopRequireDefault(__webpack_require__(213));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _default = {
	  getData: function (props, childComponents) {
	    if (props.data) {
	      return _data.default.getData(props);
	    }
	
	    childComponents = childComponents || _react.default.Children.toArray(props.children);
	    return this.getDataFromChildren(childComponents);
	  },
	  getDefaultDomainPadding: function (props, axis, childComponents) {
	    if (props.polar || axis !== "x") {
	      return undefined;
	    }
	
	    var groupComponent = childComponents.filter(function (child) {
	      return child.type && child.type.role && child.type.role === "group";
	    });
	
	    if (groupComponent.length < 1) {
	      return undefined;
	    }
	
	    var _groupComponent$0$pro = groupComponent[0].props,
	        offset = _groupComponent$0$pro.offset,
	        children = _groupComponent$0$pro.children;
	    return {
	      x: offset * children.length / 2
	    };
	  },
	  getDomain: function (props, axis, childComponents) {
	    childComponents = childComponents || _react.default.Children.toArray(props.children);
	
	    var propsDomain = _domain.default.getDomainFromProps(props, axis);
	
	    var minDomain = _domain.default.getMinFromProps(props, axis);
	
	    var maxDomain = _domain.default.getMaxFromProps(props, axis);
	
	    var domainPadding = this.getDefaultDomainPadding(props, axis, childComponents);
	    var domain;
	
	    if (propsDomain) {
	      domain = propsDomain;
	    } else {
	      var dataset = (props.data || props.y) && _data.default.getData(props);
	
	      var dataDomain = dataset ? _domain.default.getDomainFromData(props, axis, dataset) : [];
	      var childDomain = this.getDomainFromChildren(props, axis, childComponents);
	
	      var min = minDomain || _collection.default.getMinValue(_toConsumableArray(dataDomain).concat(_toConsumableArray(childDomain)));
	
	      var max = maxDomain || _collection.default.getMaxValue(_toConsumableArray(dataDomain).concat(_toConsumableArray(childDomain)));
	
	      domain = _domain.default.getDomainFromMinMax(min, max);
	    }
	
	    return _domain.default.formatDomain(domain, (0, _assign2.default)({
	      domainPadding: domainPadding
	    }, props), axis);
	  },
	  getScale: function (props, axis, childComponents) {
	    if (props.data) {
	      return _scale.default.getBaseScale(props, axis);
	    }
	
	    var children = childComponents ? childComponents.slice(0) : _react.default.Children.toArray(props.children);
	
	    var iteratee = function (child) {
	      var sharedProps = (0, _assign2.default)({}, child.props, {
	        horizontal: props.horizontal
	      });
	      return _scale.default.getScaleType(sharedProps, axis);
	    };
	
	    var childScale = (0, _uniq2.default)(_helpers.default.reduceChildren(children, iteratee, props)); // default to linear scale if more than one uniq scale type is given by children
	
	    return childScale.length > 1 ? _scale.default.getScaleFromName("linear") : _scale.default.getScaleFromName(childScale[0]);
	  },
	  setAnimationState: function (props, nextProps) {
	    if (!props.animate) {
	      return;
	    }
	
	    if (props.animate.parentState) {
	      var nodesWillExit = props.animate.parentState.nodesWillExit;
	      var oldProps = nodesWillExit ? props : null;
	      this.setState((0, _defaults2.default)({
	        oldProps: oldProps,
	        nextProps: nextProps
	      }, props.animate.parentState));
	    } else {
	      var oldChildren = _react.default.Children.toArray(props.children);
	
	      var nextChildren = _react.default.Children.toArray(nextProps.children);
	
	      var isContinuous = function (child) {
	        var check = function (c) {
	          return c.type && c.type.continuous;
	        };
	
	        return Array.isArray(child) ? (0, _some2.default)(child, check) : check(child);
	      };
	
	      var continuous = !props.polar && (0, _some2.default)(oldChildren, function (child) {
	        return isContinuous(child) || child.props.children && isContinuous(child.props.children);
	      });
	
	      var _Transitions$getIniti = _transitions.default.getInitialTransitionState(oldChildren, nextChildren),
	          _nodesWillExit = _Transitions$getIniti.nodesWillExit,
	          nodesWillEnter = _Transitions$getIniti.nodesWillEnter,
	          childrenTransitions = _Transitions$getIniti.childrenTransitions,
	          nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;
	
	      this.setState({
	        nodesWillExit: _nodesWillExit,
	        nodesWillEnter: nodesWillEnter,
	        nodesShouldEnter: nodesShouldEnter,
	        childrenTransitions: _collection.default.isArrayOfArrays(childrenTransitions) ? childrenTransitions[0] : childrenTransitions,
	        oldProps: _nodesWillExit ? props : null,
	        nextProps: nextProps,
	        continuous: continuous
	      });
	    }
	  },
	  getAllEvents: function (props) {
	    var components = ["groupComponent", "containerComponent", "labelComponent"];
	    this.componentEvents = _events.default.getComponentEvents(props, components);
	    var events = props.events;
	
	    if (Array.isArray(this.componentEvents)) {
	      var _componentEvents;
	
	      events = Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray(props.events)) : this.componentEvents;
	    }
	
	    return events || [];
	  },
	  getAnimationProps: function (props, child, index) {
	    var _this = this;
	
	    if (!props.animate) {
	      return child.props.animate;
	    }
	
	    var getFilteredState = function () {
	      var childrenTransitions = _this.state && _this.state.childrenTransitions;
	      childrenTransitions = _collection.default.isArrayOfArrays(childrenTransitions) ? childrenTransitions[index] : childrenTransitions;
	      return (0, _defaults2.default)({
	        childrenTransitions: childrenTransitions
	      }, _this.state);
	    };
	
	    var getTransitions = props.animate && props.animate.getTransitions;
	    var state = getFilteredState();
	    var parentState = props.animate && props.animate.parentState || state;
	
	    if (!getTransitions) {
	      var getTransitionProps = _transitions.default.getTransitionPropsFactory(props, state, function (newState) {
	        return _this.setState(newState);
	      });
	
	      getTransitions = function (childComponent) {
	        return getTransitionProps(childComponent, index);
	      };
	    }
	
	    return (0, _defaults2.default)({
	      getTransitions: getTransitions,
	      parentState: parentState
	    }, props.animate, child.props.animate);
	  },
	  getDomainFromChildren: function (props, axis, childComponents) {
	    // eslint-disable-line max-statements, complexity, max-len
	    var children = childComponents ? childComponents.slice(0) : _react.default.Children.toArray(props.children);
	    var parentData = props.data ? _data.default.getData(props, axis) : undefined;
	    var polar = props.polar,
	        startAngle = props.startAngle,
	        endAngle = props.endAngle,
	        categories = props.categories,
	        minDomain = props.minDomain,
	        maxDomain = props.maxDomain,
	        horizontal = props.horizontal;
	    var baseParentProps = {
	      horizontal: horizontal,
	      polar: polar,
	      startAngle: startAngle,
	      endAngle: endAngle,
	      minDomain: minDomain,
	      maxDomain: maxDomain,
	      categories: categories
	    };
	    var parentProps = parentData ? (0, _assign2.default)(baseParentProps, {
	      data: parentData
	    }) : baseParentProps;
	
	    var iteratee = function (child) {
	      var sharedProps = (0, _assign2.default)({}, child.props, parentProps);
	
	      if (!_domain.default.isDomainComponent(child)) {
	        return null;
	      } else if (child.type && (0, _isFunction2.default)(child.type.getDomain)) {
	        return child.props && child.type.getDomain(sharedProps, axis);
	      } else {
	        return _domain.default.getDomain(sharedProps, axis);
	      }
	    };
	
	    var childDomains = _helpers.default.reduceChildren(children, iteratee, props);
	
	    var min = childDomains.length === 0 ? 0 : _collection.default.getMinValue(childDomains);
	    var max = childDomains.length === 0 ? 1 : _collection.default.getMaxValue(childDomains);
	    return [min, max];
	  },
	  getDataFromChildren: function (props, childComponents) {
	    var polar = props.polar,
	        startAngle = props.startAngle,
	        endAngle = props.endAngle,
	        categories = props.categories,
	        minDomain = props.minDomain,
	        maxDomain = props.maxDomain;
	    var parentProps = {
	      polar: polar,
	      startAngle: startAngle,
	      endAngle: endAngle,
	      categories: categories,
	      minDomain: minDomain,
	      maxDomain: maxDomain
	    };
	    var stack = 0;
	
	    var iteratee = function (child, childName, parent) {
	      var childProps = (0, _assign2.default)({}, child.props, parentProps);
	      var childData;
	
	      if (!_data.default.isDataComponent(child)) {
	        return null;
	      } else if (child.type && (0, _isFunction2.default)(child.type.getData)) {
	        child = parent ? _react.default.cloneElement(child, parent.props) : child;
	        childData = child.type.getData(childProps);
	      } else {
	        childData = _data.default.getData(childProps);
	      }
	
	      stack += 1;
	      return childData.map(function (datum, index) {
	        return (0, _assign2.default)({
	          _stack: stack,
	          _group: index
	        }, datum);
	      });
	    };
	
	    var children = childComponents ? childComponents.slice(0) : _react.default.Children.toArray(props.children);
	    var stacked = children.filter(function (c) {
	      return c.type && c.type.role === "stack";
	    }).length;
	
	    var combine = function (memo, val) {
	      return memo.concat((0, _uniqBy2.default)(val, "_group"));
	    };
	
	    var datasets = _helpers.default.reduceChildren(children, iteratee, props, [], combine);
	
	    var group = stacked ? "_group" : "_stack";
	    return (0, _values2.default)((0, _groupBy2.default)(datasets, group));
	  },
	  getColor: function (calculatedProps, child, index) {
	    // check for styles first
	    var style = calculatedProps.style;
	    var colorScale = calculatedProps.colorScale,
	        color = calculatedProps.color;
	
	    if (style && style.data && style.data.fill) {
	      return style.data.fill;
	    }
	
	    colorScale = child.props && child.props.colorScale ? child.props.colorScale : colorScale;
	    color = child.props && child.props.color ? child.props.color : color;
	
	    if (!colorScale && !color) {
	      return undefined;
	    }
	
	    var colors = Array.isArray(colorScale) ? colorScale : _style.default.getColorScale(colorScale);
	    return color || colors[index % colors.length];
	  },
	  getWidth: function (props) {
	    var datasets = props.datasets,
	        scale = props.scale,
	        horizontal = props.horizontal;
	    var range = horizontal ? scale.y.range() : scale.x.range();
	    var extent = Math.abs(range[1] - range[0]);
	    var seriesLength = Array.isArray(datasets[0]) ? datasets[0].length : 1;
	    var bars = datasets.length * seriesLength + 2;
	    var barRatio = 0.5;
	    return {
	      width: Math.round(barRatio * extent / bars)
	    };
	  },
	  getStyle: function (theme, style, role) {
	    var defaultStyle = theme && theme[role] && theme[role].style ? theme[role].style : {};
	    return _helpers.default.getStyles(style, defaultStyle);
	  },
	  getChildStyle: function (child, index, calculatedProps) {
	    var style = calculatedProps.style,
	        role = calculatedProps.role;
	    var childStyle = child.props.style || {};
	
	    if (Array.isArray(childStyle)) {
	      return childStyle;
	    }
	
	    var childRole = child.type && child.type.role;
	    var defaultFill = childRole === "stack" ? undefined : this.getColor(calculatedProps, child, index);
	    var defaultColor = childRole === "line" ? {
	      fill: "none",
	      stroke: defaultFill
	    } : {
	      fill: defaultFill
	    };
	    var dataWidth = role === "stack" ? {} : this.getWidth(calculatedProps);
	    var dataStyle = (0, _defaults2.default)({}, childStyle.data, (0, _assign2.default)({}, dataWidth, style.data, defaultColor));
	    var labelsStyle = (0, _defaults2.default)({}, childStyle.labels, style.labels);
	    return {
	      parent: style.parent,
	      data: dataStyle,
	      labels: labelsStyle
	    };
	  },
	  getStringsFromCategories: function (childComponents, axis) {
	    var iteratee = function (child) {
	      var childProps = child.props || {};
	
	      if (!_domain.default.isDomainComponent(child) || !childProps.categories) {
	        return null;
	      } else {
	        var categories = childProps.categories && !Array.isArray(childProps.categories) ? childProps.categories[axis] : childProps.props.categories;
	        var categoryStrings = categories && categories.filter(function (val) {
	          return typeof val === "string";
	        });
	        return categoryStrings ? _collection.default.removeUndefined(categoryStrings) : [];
	      }
	    };
	
	    return _helpers.default.reduceChildren(childComponents.slice(0), iteratee);
	  },
	  getStringsFromData: function (childComponents) {
	    var iteratee = function (child) {
	      var childProps = child.props || {};
	      var data;
	
	      if (!_data.default.isDataComponent(child)) {
	        return null;
	      } else if (child.type && (0, _isFunction2.default)(child.type.getData)) {
	        data = child.type.getData(childProps);
	      } else {
	        data = _data.default.getData(childProps);
	      }
	
	      return data.map(function (d) {
	        return {
	          x: d.xName,
	          y: d.yName
	        };
	      });
	    };
	
	    var initialMemo = {
	      x: [],
	      y: []
	    };
	
	    var combine = function (memo, datum) {
	      var x = Array.isArray(datum) ? datum.map(function (d) {
	        return d.x;
	      }).filter(Boolean) : datum.x;
	      var y = Array.isArray(datum) ? datum.map(function (d) {
	        return d.y;
	      }).filter(Boolean) : datum.y;
	      return {
	        x: x !== undefined ? memo.x.concat(x) : memo.x,
	        y: y !== undefined ? memo.y.concat(y) : memo.y
	      };
	    };
	
	    return _helpers.default.reduceChildren(childComponents.slice(0), iteratee, {}, initialMemo, combine);
	  },
	  getCategoryAndAxisStringsFromChildren: function (props, axis, childComponents) {
	    var categories = (0, _isPlainObject2.default)(props.categories) ? props.categories[axis] : props.categories;
	
	    var axisComponent = _axis.default.getAxisComponent(childComponents, axis);
	
	    var axisStrings = axisComponent ? _data.default.getStringsFromAxes(axisComponent.props, axis) : [];
	    var categoryStrings = categories || this.getStringsFromCategories(childComponents, axis);
	    return (0, _uniq2.default)((0, _flatten2.default)(_toConsumableArray(categoryStrings).concat(_toConsumableArray(axisStrings))));
	  },
	  getStringsFromChildren: function (props, childComponents) {
	    childComponents = childComponents || _react.default.Children.toArray(props.children);
	    var xStrings = this.getCategoryAndAxisStringsFromChildren(props, "x", childComponents);
	    var yStrings = this.getCategoryAndAxisStringsFromChildren(props, "y", childComponents);
	    var dataStrings = this.getStringsFromData(childComponents);
	    return {
	      x: (0, _uniq2.default)((0, _flatten2.default)(_toConsumableArray(xStrings).concat(_toConsumableArray(dataStrings.x)))),
	      y: (0, _uniq2.default)((0, _flatten2.default)(_toConsumableArray(yStrings).concat(_toConsumableArray(dataStrings.y))))
	    };
	  },
	  getCategories: function (props) {
	    var xPropCategories = props.categories && !Array.isArray(props.categories) ? props.categories.x : props.categories;
	    var yPropCategories = props.categories && !Array.isArray(props.categories) ? props.categories.y : props.categories;
	    var fallbackRequired = !xPropCategories || !yPropCategories;
	    var fallbackProps = fallbackRequired ? this.getStringsFromChildren(props) : {};
	    var xCategories = xPropCategories || fallbackProps.x;
	    var yCategories = yPropCategories || fallbackProps.y;
	    return {
	      x: xCategories.length > 0 ? xCategories : undefined,
	      y: yCategories.length > 0 ? yCategories : undefined
	    };
	  }
	};
	exports.default = _default;

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineContainerMixins = exports.makeCreateContainerFunction = exports.createContainer = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _flow2 = _interopRequireDefault(__webpack_require__(1366));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(83));
	
	var _forOwn2 = _interopRequireDefault(__webpack_require__(1367));
	
	var _groupBy2 = _interopRequireDefault(__webpack_require__(190));
	
	var _toPairs2 = _interopRequireDefault(__webpack_require__(1379));
	
	var _victoryCore = __webpack_require__(19);
	
	var _victoryVoronoiContainer = __webpack_require__(691);
	
	var _victoryZoomContainer = __webpack_require__(694);
	
	var _victorySelectionContainer = __webpack_require__(687);
	
	var _victoryBrushContainer = __webpack_require__(668);
	
	var _victoryCursorContainer = __webpack_require__(682);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var ensureArray = function (thing) {
	  if (!thing) {
	    return [];
	  } else if (!Array.isArray(thing)) {
	    return [thing];
	  } else {
	    return thing;
	  }
	};
	
	var combineEventHandlers = function (eventHandlersArray) {
	  // takes an array of event handler objects and produces one eventHandlers object
	  // creates a custom combinedHandler() for events with multiple conflicting handlers
	  return eventHandlersArray.reduce(function (localHandlers, finalHandlers) {
	    (0, _forOwn2.default)(localHandlers, function (localHandler, eventName) {
	      var existingHandler = finalHandlers[eventName];
	
	      if (existingHandler) {
	        // create new handler for event that concats the existing handler's mutations with new ones
	        finalHandlers[eventName] = function combinedHandler() {
	          // named for debug clarity
	          // sometimes handlers return undefined; use empty array instead, for concat()
	          var existingMutations = ensureArray(existingHandler.apply(void 0, arguments));
	          var localMutations = ensureArray(localHandler.apply(void 0, arguments));
	          return existingMutations.concat(localMutations);
	        };
	      } else {
	        finalHandlers[eventName] = localHandler;
	      }
	    });
	    return finalHandlers;
	  });
	};
	
	var combineDefaultEvents = function (defaultEvents) {
	  // takes a defaultEvents array and returns one equal or lesser length,
	  // by combining any events that have the same target
	  var eventsByTarget = (0, _groupBy2.default)(defaultEvents, "target");
	  var events = (0, _toPairs2.default)(eventsByTarget).map(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        target = _ref2[0],
	        eventsArray = _ref2[1];
	
	    eventsArray = eventsArray.filter(Boolean);
	    return (0, _isEmpty2.default)(eventsArray) ? null : {
	      target: target,
	      eventHandlers: combineEventHandlers(eventsArray.map(function (event) {
	        return event.eventHandlers;
	      })) // note: does not currently handle eventKey or childName
	
	    };
	  });
	  return events.filter(Boolean);
	};
	
	var combineContainerMixins = function (mixins, Container) {
	  var _class, _temp;
	
	  // similar to Object.assign(A, B), this function will decide conflicts in favor mixinB.
	  // this applies to propTypes and defaultProps.
	  // getChildren will call A's getChildren() and pass the resulting children to B's.
	  // defaultEvents attempts to resolve any conflicts between A and B's defaultEvents.
	  var Classes = mixins.map(function (mixin) {
	    return mixin(Container);
	  });
	  var instances = Classes.map(function (Class) {
	    return new Class();
	  });
	  var NaiveCombinedContainer = (0, _flow2.default)(mixins)(Container);
	  var displayType = Classes.map(function (Class) {
	    var match = Class.displayName.match(/Victory(.*)Container/);
	    return match[1] || "";
	  }).join("");
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_NaiveCombinedContain) {
	    _inherits(VictoryCombinedContainer, _NaiveCombinedContain);
	
	    function VictoryCombinedContainer() {
	      _classCallCheck(this, VictoryCombinedContainer);
	
	      return _possibleConstructorReturn(this, (VictoryCombinedContainer.__proto__ || Object.getPrototypeOf(VictoryCombinedContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryCombinedContainer, [{
	      key: "getChildren",
	      value: function getChildren(props) {
	        return instances.reduce(function (children, instance) {
	          return instance.getChildren(_objectSpread({}, props, {
	            children: children
	          }));
	        }, props.children);
	      }
	    }]);
	
	    return VictoryCombinedContainer;
	  }(NaiveCombinedContainer), Object.defineProperty(_class, "displayName", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: "Victory".concat(displayType, "Container")
	  }), Object.defineProperty(_class, "propTypes", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: Classes.reduce(function (propTypes, Class) {
	      return _objectSpread({}, propTypes, Class.propTypes);
	    }, {})
	  }), Object.defineProperty(_class, "defaultProps", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: Classes.reduce(function (defaultProps, Class) {
	      return _objectSpread({}, defaultProps, Class.defaultProps);
	    }, {})
	  }), Object.defineProperty(_class, "defaultEvents", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function (props) {
	      return combineDefaultEvents(Classes.reduce(function (defaultEvents, Class) {
	        var events = (0, _isFunction2.default)(Class.defaultEvents) ? Class.defaultEvents(props) : Class.defaultEvents;
	        return _toConsumableArray(defaultEvents).concat(_toConsumableArray(events));
	      }, []));
	    }
	  }), _temp;
	};
	
	exports.combineContainerMixins = combineContainerMixins;
	
	var checkBehaviorName = function (behavior, behaviors) {
	  if (behavior && !(0, _includes2.default)(behaviors, behavior)) {
	    _victoryCore.Log.warn("\"".concat(behavior, "\" is not a valid behavior. Choose from [").concat(behaviors.join(", "), "]."));
	  }
	};
	
	var makeCreateContainerFunction = function (mixinMap, Container) {
	  return function (behaviorA, behaviorB) {
	    // eslint-disable-line
	    var behaviors = Object.keys(mixinMap);
	    checkBehaviorName(behaviorA, behaviors);
	    checkBehaviorName(behaviorB, behaviors);
	
	    if (arguments.length <= 2 ? 0 : arguments.length - 2) {
	      _victoryCore.Log.warn("too many arguments given to createContainer (maximum accepted: 2).");
	    }
	
	    var firstMixins = mixinMap[behaviorA];
	    var secondMixins = mixinMap[behaviorB] || [];
	
	    if (!firstMixins) {
	      return Container;
	    }
	
	    return combineContainerMixins(_toConsumableArray(firstMixins).concat(_toConsumableArray(secondMixins)), Container);
	  };
	};
	
	exports.makeCreateContainerFunction = makeCreateContainerFunction;
	var createContainer = makeCreateContainerFunction({
	  zoom: [_victoryZoomContainer.zoomContainerMixin],
	  voronoi: [_victoryVoronoiContainer.voronoiContainerMixin],
	  selection: [_victorySelectionContainer.selectionContainerMixin],
	  cursor: [_victoryCursorContainer.cursorContainerMixin],
	  brush: [_victoryBrushContainer.brushContainerMixin]
	}, _victoryCore.VictoryContainer);
	exports.createContainer = createContainer;

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "combineContainerMixins", {
	  enumerable: true,
	  get: function () {
	    return _createContainer.combineContainerMixins;
	  }
	});
	Object.defineProperty(exports, "makeCreateContainerFunction", {
	  enumerable: true,
	  get: function () {
	    return _createContainer.makeCreateContainerFunction;
	  }
	});
	Object.defineProperty(exports, "createContainer", {
	  enumerable: true,
	  get: function () {
	    return _createContainer.createContainer;
	  }
	});
	
	var _createContainer = __webpack_require__(1877);

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.cursorContainerMixin = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(47));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _cursorHelpers = _interopRequireDefault(__webpack_require__(681));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cursorContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_base) {
	    _inherits(VictoryCursorContainer, _base);
	
	    function VictoryCursorContainer() {
	      _classCallCheck(this, VictoryCursorContainer);
	
	      return _possibleConstructorReturn(this, (VictoryCursorContainer.__proto__ || Object.getPrototypeOf(VictoryCursorContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryCursorContainer, [{
	      key: "getCursorPosition",
	      value: function getCursorPosition(props) {
	        var cursorValue = props.cursorValue,
	            defaultCursorValue = props.defaultCursorValue,
	            domain = props.domain,
	            cursorDimension = props.cursorDimension;
	
	        if (cursorValue) {
	          return cursorValue;
	        }
	
	        if (typeof defaultCursorValue === "number") {
	          return _defineProperty({
	            x: (domain.x[0] + domain.x[1]) / 2,
	            y: (domain.y[0] + domain.y[1]) / 2
	          }, cursorDimension, defaultCursorValue);
	        }
	
	        return defaultCursorValue;
	      }
	    }, {
	      key: "getCursorLabelOffset",
	      value: function getCursorLabelOffset(props) {
	        var cursorLabelOffset = props.cursorLabelOffset;
	
	        if (typeof cursorLabelOffset === "number") {
	          return {
	            x: cursorLabelOffset,
	            y: cursorLabelOffset
	          };
	        }
	
	        return cursorLabelOffset;
	      }
	    }, {
	      key: "getPadding",
	      value: function getPadding(props) {
	        if (props.padding === undefined) {
	          var child = props.children.find(function (c) {
	            return (0, _isObject2.default)(c.props) && c.props.padding !== undefined;
	          });
	          return _victoryCore.Helpers.getPadding(child.props);
	        } else {
	          return _victoryCore.Helpers.getPadding(props);
	        }
	      }
	    }, {
	      key: "getCursorElements",
	      value: function getCursorElements(props) {
	        // eslint-disable-line max-statements
	        var scale = props.scale,
	            cursorLabelComponent = props.cursorLabelComponent,
	            cursorLabel = props.cursorLabel,
	            cursorComponent = props.cursorComponent,
	            width = props.width,
	            height = props.height,
	            name = props.name,
	            horizontal = props.horizontal;
	
	        var cursorDimension = _cursorHelpers.default.getDimension(props);
	
	        var cursorValue = this.getCursorPosition(props);
	        var cursorLabelOffset = this.getCursorLabelOffset(props);
	
	        if (!cursorValue) {
	          return [];
	        }
	
	        var newElements = [];
	        var padding = this.getPadding(props);
	        var cursorCoordinates = {
	          x: horizontal ? scale.y(cursorValue.y) : scale.x(cursorValue.x),
	          y: horizontal ? scale.x(cursorValue.x) : scale.y(cursorValue.y)
	        };
	
	        if (cursorLabel) {
	          var labelProps = (0, _defaults2.default)({
	            active: true
	          }, cursorLabelComponent.props, {
	            x: cursorCoordinates.x + cursorLabelOffset.x,
	            y: cursorCoordinates.y + cursorLabelOffset.y,
	            datum: cursorValue,
	            active: true,
	            key: "".concat(name, "-cursor-label")
	          });
	          newElements.push(_react.default.cloneElement(cursorLabelComponent, (0, _defaults2.default)({}, labelProps, {
	            text: _victoryCore.Helpers.evaluateProp(cursorLabel, labelProps)
	          })));
	        }
	
	        var cursorStyle = (0, _assign2.default)({
	          stroke: "black"
	        }, cursorComponent.props.style);
	
	        if (cursorDimension === "x" || cursorDimension === undefined) {
	          newElements.push(_react.default.cloneElement(cursorComponent, {
	            key: "".concat(name, "-x-cursor"),
	            x1: cursorCoordinates.x,
	            x2: cursorCoordinates.x,
	            y1: padding.top,
	            y2: height - padding.bottom,
	            style: cursorStyle
	          }));
	        }
	
	        if (cursorDimension === "y" || cursorDimension === undefined) {
	          newElements.push(_react.default.cloneElement(cursorComponent, {
	            key: "".concat(name, "-y-cursor"),
	            x1: padding.left,
	            x2: width - padding.right,
	            y1: cursorCoordinates.y,
	            y2: cursorCoordinates.y,
	            style: cursorStyle
	          }));
	        }
	
	        return newElements;
	      } // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        return _toConsumableArray(_react.default.Children.toArray(props.children)).concat(_toConsumableArray(this.getCursorElements(props)));
	      }
	    }]);
	
	    return VictoryCursorContainer;
	  }(base), Object.defineProperty(_class, "displayName", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: "VictoryCursorContainer"
	  }), Object.defineProperty(_class, "propTypes", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.propTypes, {
	      cursorDimension: _propTypes.default.oneOf(["x", "y"]),
	      cursorLabel: _propTypes.default.func,
	      cursorLabelComponent: _propTypes.default.element,
	      cursorLabelOffset: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	        x: _propTypes.default.number,
	        y: _propTypes.default.number
	      })]),
	      defaultCursorValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	        x: _propTypes.default.number,
	        y: _propTypes.default.number
	      })]),
	      disable: _propTypes.default.bool,
	      onCursorChange: _propTypes.default.func
	    })
	  }), Object.defineProperty(_class, "defaultProps", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.defaultProps, {
	      cursorLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	      cursorLabelOffset: {
	        x: 5,
	        y: -10
	      },
	      cursorComponent: _react.default.createElement(_victoryCore.LineSegment, null)
	    })
	  }), Object.defineProperty(_class, "defaultEvents", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function (props) {
	      return [{
	        target: "parent",
	        eventHandlers: {
	          onMouseLeave: function () {
	            return [];
	          },
	          onTouchCancel: function () {
	            return [];
	          },
	          onMouseMove: function (evt, targetProps) {
	            return props.disable ? {} : _cursorHelpers.default.onMouseMove(evt, targetProps);
	          },
	          onTouchMove: function (evt, targetProps) {
	            return props.disable ? {} : _cursorHelpers.default.onMouseMove(evt, targetProps);
	          }
	        }
	      }];
	    }
	  }), _temp;
	};
	
	exports.cursorContainerMixin = cursorContainerMixin;
	
	var _default = cursorContainerMixin(_victoryCore.VictoryContainer);
	
	exports.default = _default;

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getData = exports.getDomain = exports.getBaseProps = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getErrors = function (props, datum, axis) {
	  /**
	   * check if it is asymmetric error or symmetric error, asymmetric error should be an array
	   * and the first value is the positive error, the second is the negative error
	   * @param  {Boolean} isArray(errorX)
	   * @return {String or Array}
	   */
	  var errorNames = {
	    x: "_errorX",
	    y: "_errorY"
	  };
	  var errors = datum[errorNames[axis]];
	
	  if (errors === 0) {
	    return false;
	  }
	
	  var scale = props.scale[axis];
	  return Array.isArray(errors) ? [errors[0] === 0 ? false : scale(errors[0] + datum["_".concat(axis)]), errors[1] === 0 ? false : scale(datum["_".concat(axis)] - errors[1])] : [scale(errors + datum["_".concat(axis)]), scale(datum["_".concat(axis)] - errors)];
	};
	
	var getData = function (props) {
	  var accessorTypes = ["x", "y", "errorX", "errorY"];
	
	  if (props.data) {
	    return _victoryCore.Data.formatData(props.data, props, accessorTypes);
	  } else {
	    var generatedData = props.errorX || props.errorY ? _victoryCore.Data.generateData(props) : [];
	    return _victoryCore.Data.formatData(generatedData, props, accessorTypes);
	  }
	};
	
	exports.getData = getData;
	
	var getDomainFromData = function (props, axis) {
	  var minDomain = _victoryCore.Domain.getMinFromProps(props, axis);
	
	  var maxDomain = _victoryCore.Domain.getMaxFromProps(props, axis);
	
	  var dataset = getData(props);
	
	  if (dataset.length < 1) {
	    return minDomain !== undefined && maxDomain !== undefined ? _victoryCore.Domain.getDomainFromMinMax(minDomain, maxDomain) : undefined;
	  }
	
	  var error = axis === "x" ? "_errorX" : "_errorY";
	
	  var reduceErrorData = function (type) {
	    var baseCondition = type === "min" ? Infinity : -Infinity;
	    var errorIndex = type === "min" ? 1 : 0;
	    var sign = type === "min" ? -1 : 1;
	    return dataset.reduce(function (memo, datum) {
	      var currentError = Array.isArray(datum[error]) ? datum[error][errorIndex] : datum[error];
	      var current = datum["_".concat(axis)] + sign * (currentError || 0);
	      return memo < current && type === "min" || memo > current && type === "max" ? memo : current;
	    }, baseCondition);
	  };
	
	  var min = minDomain !== undefined ? minDomain : reduceErrorData("min");
	  var max = maxDomain !== undefined ? maxDomain : reduceErrorData("max");
	  return _victoryCore.Domain.getDomainFromMinMax(min, max);
	};
	
	var getDomain = function (props, axis) {
	  return _victoryCore.Domain.createDomainFunction(getDomainFromData)(props, axis);
	};
	
	exports.getDomain = getDomain;
	
	var getCalculatedValues = function (props) {
	  var defaultStyles = props.theme && props.theme.errorbar && props.theme.errorbar.style ? props.theme.errorbar.style : {};
	  var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles) || {};
	  var data = getData(props);
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var domain = {
	    x: getDomain(props, "x"),
	    y: getDomain(props, "y")
	  };
	  var scale = {
	    x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var origin = props.polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	  return {
	    domain: domain,
	    data: data,
	    scale: scale,
	    style: style,
	    origin: origin
	  };
	};
	
	var getLabelProps = function (dataProps, text, style) {
	  var x = dataProps.x,
	      y = dataProps.y,
	      index = dataProps.index,
	      scale = dataProps.scale,
	      errorY = dataProps.errorY,
	      errorX = dataProps.errorX,
	      horizontal = dataProps.horizontal;
	
	  var getError = function () {
	    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "x";
	    var baseError = type === "y" ? errorY : errorX;
	    var error = baseError && Array.isArray(baseError) ? baseError[0] : baseError;
	    return error || dataProps[type];
	  };
	
	  var labelStyle = style.labels || {};
	  var padding = labelStyle.padding || 0;
	  var textAnchor = horizontal ? "start" : "middle";
	  var verticalAnchor = horizontal ? "middle" : "end";
	  return {
	    style: labelStyle,
	    y: horizontal ? y : getError("y"),
	    x: horizontal ? getError("x") : x,
	    dy: horizontal ? 0 : -padding,
	    dx: horizontal ? padding : 0,
	    text: text,
	    index: index,
	    scale: scale,
	    datum: dataProps.datum,
	    data: dataProps.data,
	    textAnchor: labelStyle.textAnchor || textAnchor,
	    verticalAnchor: labelStyle.verticalAnchor || verticalAnchor,
	    angle: labelStyle.angle,
	    horizontal: horizontal
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "errorbar");
	
	  props = (0, _assign2.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      borderWidth = _props.borderWidth,
	      data = _props.data,
	      domain = _props.domain,
	      events = _props.events,
	      groupComponent = _props.groupComponent,
	      height = _props.height,
	      horizontal = _props.horizontal,
	      labels = _props.labels,
	      name = _props.name,
	      origin = _props.origin,
	      padding = _props.padding,
	      polar = _props.polar,
	      scale = _props.scale,
	      sharedEvents = _props.sharedEvents,
	      standalone = _props.standalone,
	      style = _props.style,
	      theme = _props.theme,
	      width = _props.width;
	  var initialChildProps = {
	    parent: {
	      data: data,
	      domain: domain,
	      height: height,
	      horizontal: horizontal,
	      name: name,
	      origin: origin,
	      padding: padding,
	      polar: polar,
	      scale: scale,
	      standalone: standalone,
	      style: style.parent,
	      theme: theme,
	      width: width
	    }
	  };
	  return data.reduce(function (childProps, datum, index) {
	    var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	
	    var _Helpers$scalePoint = _victoryCore.Helpers.scalePoint((0, _assign2.default)({}, props, {
	      scale: scale
	    }), datum),
	        x = _Helpers$scalePoint.x,
	        y = _Helpers$scalePoint.y;
	
	    var errorX = getErrors(props, datum, "x");
	    var errorY = getErrors(props, datum, "y");
	    var dataProps = {
	      borderWidth: borderWidth,
	      data: data,
	      datum: datum,
	      errorX: horizontal ? errorY : errorX,
	      errorY: horizontal ? errorX : errorY,
	      groupComponent: groupComponent,
	      horizontal: horizontal,
	      index: index,
	      scale: scale,
	      style: style.data,
	      x: x,
	      y: y
	    };
	    childProps[eventKey] = {
	      data: dataProps
	    };
	
	    var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	
	    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
	      childProps[eventKey].labels = getLabelProps(dataProps, text, style);
	    }
	
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryErrorBar", {
	  enumerable: true,
	  get: function () {
	    return _victoryErrorbar.default;
	  }
	});
	Object.defineProperty(exports, "ErrorBar", {
	  enumerable: true,
	  get: function () {
	    return _errorBar.default;
	  }
	});
	
	var _victoryErrorbar = _interopRequireDefault(__webpack_require__(1882));
	
	var _errorBar = _interopRequireDefault(__webpack_require__(683));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _errorBar = _interopRequireDefault(__webpack_require__(683));
	
	var _helperMethods = __webpack_require__(1880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	var defaultData = [{
	  x: 1,
	  y: 1,
	  errorX: 0.1,
	  errorY: 0.1
	}, {
	  x: 2,
	  y: 2,
	  errorX: 0.2,
	  errorY: 0.2
	}, {
	  x: 3,
	  y: 3,
	  errorX: 0.3,
	  errorY: 0.3
	}, {
	  x: 4,
	  y: 4,
	  errorX: 0.4,
	  errorY: 0.4
	}];
	
	var VictoryErrorBar =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryErrorBar, _React$Component);
	
	  function VictoryErrorBar() {
	    _classCallCheck(this, VictoryErrorBar);
	
	    return _possibleConstructorReturn(this, (VictoryErrorBar.__proto__ || Object.getPrototypeOf(VictoryErrorBar)).apply(this, arguments));
	  }
	
	  _createClass(VictoryErrorBar, [{
	    key: "shouldAnimate",
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryErrorBar.animationWhitelist,
	          role = VictoryErrorBar.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryErrorBar;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryErrorBar, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "domain", "height", "padding", "samples", "style", "width", "errorX", "errorY", "borderWidth"]
	});
	Object.defineProperty(VictoryErrorBar, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryErrorBar"
	});
	Object.defineProperty(VictoryErrorBar, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "errorbar"
	});
	Object.defineProperty(VictoryErrorBar, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.discreteTransitions()
	});
	Object.defineProperty(VictoryErrorBar, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    borderWidth: _propTypes.default.number,
	    errorX: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    errorY: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    horizontal: _propTypes.default.bool
	  })
	});
	Object.defineProperty(VictoryErrorBar, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    data: defaultData,
	    dataComponent: _react.default.createElement(_errorBar.default, null),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    groupComponent: _react.default.createElement("g", {
	      role: "presentation"
	    }),
	    samples: 50,
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryErrorBar, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getDomain
	});
	Object.defineProperty(VictoryErrorBar, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getData
	});
	Object.defineProperty(VictoryErrorBar, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryErrorBar, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryErrorBar);
	
	exports.default = _default;

/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getChildren = getChildren;
	exports.getCalculatedProps = getCalculatedProps;
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  offset: 0
	}; // eslint-disable-next-line max-statements
	
	function getCalculatedProps(props, childComponents) {
	  var role = "group";
	  props = _victoryCore.Helpers.modifyProps(props, fallbackProps, role);
	
	  var style = _victoryCore.Wrapper.getStyle(props.theme, props.style, role);
	
	  var _props = props,
	      offset = _props.offset,
	      colorScale = _props.colorScale,
	      color = _props.color,
	      polar = _props.polar,
	      horizontal = _props.horizontal;
	
	  var categories = _victoryCore.Wrapper.getCategories(props, childComponents);
	
	  var datasets = _victoryCore.Wrapper.getDataFromChildren(props);
	
	  var domain = {
	    x: _victoryCore.Wrapper.getDomain((0, _assign2.default)({}, props, {
	      categories: categories
	    }), "x", childComponents),
	    y: _victoryCore.Wrapper.getDomain((0, _assign2.default)({}, props, {
	      categories: categories
	    }), "y", childComponents)
	  };
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var baseScale = {
	    x: _victoryCore.Scale.getScaleFromProps(props, "x") || _victoryCore.Wrapper.getScale(props, "x"),
	    y: _victoryCore.Scale.getScaleFromProps(props, "y") || _victoryCore.Wrapper.getScale(props, "y")
	  };
	  var scale = {
	    x: baseScale.x.domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: baseScale.y.domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var origin = polar ? props.origin : _victoryCore.Helpers.getPolarOrigin(props);
	
	  var padding = _victoryCore.Helpers.getPadding(props);
	
	  return {
	    datasets: datasets,
	    categories: categories,
	    range: range,
	    domain: domain,
	    horizontal: horizontal,
	    scale: scale,
	    style: style,
	    colorScale: colorScale,
	    color: color,
	    offset: offset,
	    origin: origin,
	    padding: padding
	  };
	}
	
	function pixelsToValue(props, axis, calculatedProps) {
	  if (!props.offset) {
	    return 0;
	  }
	
	  var currentAxis = _victoryCore.Helpers.getCurrentAxis(axis, props.horizontal);
	
	  var domain = calculatedProps.domain[axis];
	  var range = calculatedProps.range[currentAxis];
	  var domainExtent = Math.max.apply(Math, _toConsumableArray(domain)) - Math.min.apply(Math, _toConsumableArray(domain));
	  var rangeExtent = Math.max.apply(Math, _toConsumableArray(range)) - Math.min.apply(Math, _toConsumableArray(range));
	  return domainExtent / rangeExtent * props.offset;
	}
	
	function getX0(props, calculatedProps, index) {
	  var center = (calculatedProps.datasets.length - 1) / 2;
	  var totalWidth = pixelsToValue(props, "x", calculatedProps);
	  return (index - center) * totalWidth;
	}
	
	function getPolarX0(props, calculatedProps, index) {
	  var center = (calculatedProps.datasets.length - 1) / 2;
	  var width = getAngularWidth(props, calculatedProps);
	  return (index - center) * width;
	}
	
	function getAngularWidth(props, calculatedProps) {
	  var range = calculatedProps.range;
	  var angularRange = Math.abs(range.x[1] - range.x[0]);
	  var r = Math.max.apply(Math, _toConsumableArray(range.y));
	  return props.offset / (2 * Math.PI * r) * angularRange;
	}
	
	function getLabels(props, datasets, index) {
	  if (!props.labels) {
	    return undefined;
	  }
	
	  return Math.floor(datasets.length / 2) === index ? props.labels : undefined;
	}
	
	function getChildProps(props, calculatedProps) {
	  var categories = calculatedProps.categories,
	      domain = calculatedProps.domain,
	      range = calculatedProps.range,
	      scale = calculatedProps.scale,
	      horizontal = calculatedProps.horizontal,
	      origin = calculatedProps.origin,
	      padding = calculatedProps.padding;
	  var width = props.width,
	      height = props.height,
	      theme = props.theme,
	      polar = props.polar;
	  return {
	    height: height,
	    width: width,
	    theme: theme,
	    polar: polar,
	    origin: origin,
	    categories: categories,
	    domain: domain,
	    range: range,
	    scale: scale,
	    horizontal: horizontal,
	    padding: padding,
	    standalone: false
	  };
	}
	
	function getColorScale(props, child) {
	  var role = child.type && child.type.role;
	  var colorScaleOptions = child.props.colorScale || props.colorScale;
	
	  if (role !== "group" && role !== "stack") {
	    return undefined;
	  }
	
	  return props.theme && props.theme.group ? colorScaleOptions || props.theme.group.colorScale : colorScaleOptions;
	}
	
	function getDataWithOffset(props) {
	  var defaultDataset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var offset = arguments.length > 2 ? arguments[2] : undefined;
	  var dataset = props.data || props.y ? _victoryCore.Data.getData(props) : defaultDataset;
	  var xOffset = offset || 0;
	  return dataset.map(function (datum) {
	    var _x1 = datum._x instanceof Date ? new Date(datum._x.getTime() + xOffset) : datum._x + xOffset;
	
	    return (0, _assign2.default)({}, datum, {
	      _x1: _x1
	    });
	  });
	}
	
	function getChildren(props, childComponents, calculatedProps) {
	  props = _victoryCore.Helpers.modifyProps(props, fallbackProps, "stack");
	  childComponents = childComponents || _react.default.Children.toArray(props.children);
	  calculatedProps = calculatedProps || getCalculatedProps(props, childComponents);
	  var _calculatedProps = calculatedProps,
	      datasets = _calculatedProps.datasets;
	  var _props2 = props,
	      labelComponent = _props2.labelComponent,
	      polar = _props2.polar;
	  var childProps = getChildProps(props, calculatedProps);
	  var parentName = props.name || "group";
	  return childComponents.map(function (child, index) {
	    var role = child.type && child.type.role;
	    var xOffset = polar ? getPolarX0(props, calculatedProps, index) : getX0(props, calculatedProps, index);
	    var style = role === "voronoi" || role === "tooltip" || role === "label" ? child.props.style : _victoryCore.Wrapper.getChildStyle(child, index, calculatedProps);
	    var labels = props.labels ? getLabels(props, datasets, index) : child.props.labels;
	    var name = child.props.name || "".concat(parentName, "-").concat(role, "-").concat(index);
	    return _react.default.cloneElement(child, (0, _assign2.default)({
	      labels: labels,
	      style: style,
	      key: "".concat(name, "-key-").concat(index),
	      name: name,
	      data: getDataWithOffset(props, datasets[index], xOffset),
	      colorScale: getColorScale(props, child),
	      labelComponent: labelComponent || child.props.labelComponent,
	      xOffset: role === "stack" ? xOffset : undefined
	    }, childProps));
	  });
	}

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryGroup", {
	  enumerable: true,
	  get: function () {
	    return _victoryGroup.default;
	  }
	});
	
	var _victoryGroup = _interopRequireDefault(__webpack_require__(1885));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _victorySharedEvents = __webpack_require__(215);
	
	var _helperMethods = __webpack_require__(1883);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  offset: 0
	};
	
	var VictoryGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryGroup, _React$Component);
	
	  function VictoryGroup(props) {
	    var _this;
	
	    _classCallCheck(this, VictoryGroup);
	
	    _this = _possibleConstructorReturn(this, (VictoryGroup.__proto__ || Object.getPrototypeOf(VictoryGroup)).call(this, props));
	
	    if (props.animate) {
	      _this.state = {
	        nodesShouldLoad: false,
	        nodesDoneLoad: false,
	        animating: true
	      };
	      _this.setAnimationState = _victoryCore.Wrapper.setAnimationState.bind(_assertThisInitialized(_this));
	    }
	
	    return _this;
	  }
	
	  _createClass(VictoryGroup, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      if (this.props.animate) {
	        if (!(0, _reactFastCompare.default)(this.props, nextProps)) {
	          this.setAnimationState(this.props, nextProps);
	          return false;
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: "getNewChildren",
	    value: function getNewChildren(props, childComponents, calculatedProps) {
	      var children = (0, _helperMethods.getChildren)(props, childComponents, calculatedProps);
	
	      var getAnimationProps = _victoryCore.Wrapper.getAnimationProps.bind(this);
	
	      return children.map(function (child, index) {
	        var childProps = (0, _assign2.default)({
	          animate: getAnimationProps(props, child, index)
	        }, child.props);
	        return _react.default.cloneElement(child, childProps);
	      });
	    }
	  }, {
	    key: "renderContainer",
	    value: function renderContainer(containerComponent, props) {
	      var containerProps = (0, _defaults2.default)({}, containerComponent.props, props);
	      return _react.default.cloneElement(containerComponent, containerProps);
	    }
	  }, {
	    key: "getContainerProps",
	    value: function getContainerProps(props, calculatedProps) {
	      var width = props.width,
	          height = props.height,
	          standalone = props.standalone,
	          theme = props.theme,
	          polar = props.polar,
	          horizontal = props.horizontal,
	          name = props.name;
	      var domain = calculatedProps.domain,
	          scale = calculatedProps.scale,
	          style = calculatedProps.style,
	          origin = calculatedProps.origin;
	      return {
	        domain: domain,
	        scale: scale,
	        width: width,
	        height: height,
	        standalone: standalone,
	        theme: theme,
	        style: style.parent,
	        horizontal: horizontal,
	        polar: polar,
	        origin: origin,
	        name: name
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	      var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
	
	      var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, role);
	
	      var eventKey = modifiedProps.eventKey,
	          containerComponent = modifiedProps.containerComponent,
	          standalone = modifiedProps.standalone,
	          groupComponent = modifiedProps.groupComponent,
	          externalEventMutations = modifiedProps.externalEventMutations;
	
	      var childComponents = _react.default.Children.toArray(modifiedProps.children);
	
	      var calculatedProps = (0, _helperMethods.getCalculatedProps)(modifiedProps, childComponents);
	      var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
	      var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
	      var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
	
	      var events = _victoryCore.Wrapper.getAllEvents(props);
	
	      if (!(0, _isEmpty2.default)(events)) {
	        return _react.default.createElement(_victorySharedEvents.VictorySharedEvents, {
	          container: container,
	          eventKey: eventKey,
	          events: events,
	          externalEventMutations: externalEventMutations
	        }, newChildren);
	      }
	
	      return _react.default.cloneElement(container, container.props, newChildren);
	    }
	  }]);
	
	  return VictoryGroup;
	}(_react.default.Component);
	
	exports.default = VictoryGroup;
	Object.defineProperty(VictoryGroup, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryGroup"
	});
	Object.defineProperty(VictoryGroup, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "group"
	});
	Object.defineProperty(VictoryGroup, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	    color: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	    colorScale: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
	    horizontal: _propTypes.default.bool,
	    offset: _propTypes.default.number
	  })
	});
	Object.defineProperty(VictoryGroup, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    groupComponent: _react.default.createElement("g", null),
	    samples: 50,
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryGroup, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["groupComponent", "containerComponent", "labelComponent"]
	});
	Object.defineProperty(VictoryGroup, "getChildren", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getChildren
	});

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDimensions = exports.getBaseProps = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _range2 = _interopRequireDefault(__webpack_require__(192));
	
	var _sum2 = _interopRequireDefault(__webpack_require__(1378));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(56));
	
	var _groupBy2 = _interopRequireDefault(__webpack_require__(190));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getColorScale = function (props) {
	  var colorScale = props.colorScale;
	  return typeof colorScale === "string" ? _victoryCore.Style.getColorScale(colorScale) : colorScale || [];
	};
	
	var getLabelStyles = function (props) {
	  var data = props.data,
	      style = props.style;
	  return data.map(function (datum, index) {
	    var baseLabelStyles = (0, _defaults2.default)({}, datum.labels, style.labels);
	    return _victoryCore.Helpers.evaluateStyle(baseLabelStyles, {
	      datum: datum,
	      index: index,
	      data: data
	    });
	  });
	};
	
	var getStyles = function (props, styleObject) {
	  var style = props.style || {};
	  styleObject = styleObject || {};
	  var parentStyleProps = {
	    height: "100%",
	    width: "100%"
	  };
	  return {
	    parent: (0, _defaults2.default)(style.parent, styleObject.parent, parentStyleProps),
	    data: (0, _defaults2.default)({}, style.data, styleObject.data),
	    labels: (0, _defaults2.default)({}, style.labels, styleObject.labels),
	    border: (0, _defaults2.default)({}, style.border, styleObject.border),
	    title: (0, _defaults2.default)({}, style.title, styleObject.title)
	  };
	};
	
	var getCalculatedValues = function (props) {
	  var orientation = props.orientation,
	      theme = props.theme;
	  var defaultStyles = theme && theme.legend && theme.legend.style ? theme.legend.style : {};
	  var style = getStyles(props, defaultStyles);
	  var colorScale = getColorScale(props);
	  var isHorizontal = orientation === "horizontal";
	
	  var borderPadding = _victoryCore.Helpers.getPadding({
	    padding: props.borderPadding
	  });
	
	  return (0, _assign2.default)({}, props, {
	    style: style,
	    isHorizontal: isHorizontal,
	    colorScale: colorScale,
	    borderPadding: borderPadding
	  });
	};
	
	var getColumn = function (props, index) {
	  var itemsPerRow = props.itemsPerRow,
	      isHorizontal = props.isHorizontal;
	
	  if (!itemsPerRow) {
	    return isHorizontal ? index : 0;
	  }
	
	  return isHorizontal ? index % itemsPerRow : Math.floor(index / itemsPerRow);
	};
	
	var getRow = function (props, index) {
	  var itemsPerRow = props.itemsPerRow,
	      isHorizontal = props.isHorizontal;
	
	  if (!itemsPerRow) {
	    return isHorizontal ? 0 : index;
	  }
	
	  return isHorizontal ? Math.floor(index / itemsPerRow) : index % itemsPerRow;
	};
	
	var groupData = function (props) {
	  var data = props.data;
	  var style = props.style && props.style.data || {};
	  var labelStyles = getLabelStyles(props);
	  return data.map(function (datum, index) {
	    var symbol = datum.symbol || {};
	    var fontSize = labelStyles[index].fontSize; // eslint-disable-next-line no-magic-numbers
	
	    var size = symbol.size || style.size || fontSize / 2.5;
	    var symbolSpacer = props.symbolSpacer || Math.max(size, fontSize);
	    return _objectSpread({}, datum, {
	      size: size,
	      symbolSpacer: symbolSpacer,
	      fontSize: fontSize,
	      textSize: _victoryCore.TextSize.approximateTextSize(datum.name, labelStyles[index]),
	      column: getColumn(props, index),
	      row: getRow(props, index)
	    });
	  });
	};
	
	var getColumnWidths = function (props, data) {
	  var gutter = props.gutter || {};
	  var gutterWidth = typeof gutter === "object" ? (gutter.left || 0) + (gutter.right || 0) : gutter || 0;
	  var dataByColumn = (0, _groupBy2.default)(data, "column");
	  var columns = (0, _keys2.default)(dataByColumn);
	  return columns.reduce(function (memo, curr, index) {
	    var lengths = dataByColumn[curr].map(function (d) {
	      return d.textSize.width + d.size + d.symbolSpacer + gutterWidth;
	    });
	    memo[index] = Math.max.apply(Math, _toConsumableArray(lengths));
	    return memo;
	  }, []);
	};
	
	var getRowHeights = function (props, data) {
	  var gutter = props.rowGutter || {};
	  var gutterHeight = typeof gutter === "object" ? (gutter.top || 0) + (gutter.bottom || 0) : gutter || 0;
	  var dataByRow = (0, _groupBy2.default)(data, "row");
	  return (0, _keys2.default)(dataByRow).reduce(function (memo, curr, index) {
	    var rows = dataByRow[curr];
	    var lengths = rows.map(function (d) {
	      return d.textSize.height + d.symbolSpacer + gutterHeight;
	    });
	    memo[index] = Math.max.apply(Math, _toConsumableArray(lengths));
	    return memo;
	  }, []);
	};
	
	var getTitleDimensions = function (props) {
	  var style = props.style && props.style.title || {};
	
	  var textSize = _victoryCore.TextSize.approximateTextSize(props.title, style);
	
	  var padding = style.padding || 0;
	  return {
	    height: textSize.height + 2 * padding || 0,
	    width: textSize.width + 2 * padding || 0
	  };
	};
	
	var getOffset = function (datum, rowHeights, columnWidths) {
	  var column = datum.column,
	      row = datum.row;
	  return {
	    x: (0, _range2.default)(column).reduce(function (memo, curr) {
	      memo += columnWidths[curr];
	      return memo;
	    }, 0),
	    y: (0, _range2.default)(row).reduce(function (memo, curr) {
	      memo += rowHeights[curr];
	      return memo;
	    }, 0)
	  };
	};
	
	var getAnchors = function (titleOrientation, centerTitle) {
	  var standardAnchors = {
	    textAnchor: titleOrientation === "right" ? "end" : "start",
	    verticalAnchor: titleOrientation === "bottom" ? "end" : "start"
	  };
	
	  if (centerTitle) {
	    var horizontal = titleOrientation === "top" || titleOrientation === "bottom";
	    return {
	      textAnchor: horizontal ? "middle" : standardAnchors.textAnchor,
	      verticalAnchor: horizontal ? standardAnchors.verticalAnchor : "middle"
	    };
	  } else {
	    return standardAnchors;
	  }
	};
	
	var getTitleStyle = function (props) {
	  var titleOrientation = props.titleOrientation,
	      centerTitle = props.centerTitle,
	      titleComponent = props.titleComponent;
	  var baseStyle = props.style && props.style.title || {};
	  var componentStyle = titleComponent.props && titleComponent.props.style || {};
	  var anchors = getAnchors(titleOrientation, centerTitle);
	  return Array.isArray(componentStyle) ? componentStyle.map(function (obj) {
	    return (0, _defaults2.default)({}, obj, baseStyle, anchors);
	  }) : (0, _defaults2.default)({}, componentStyle, baseStyle, anchors);
	}; // eslint-disable-next-line complexity
	
	
	var getTitleProps = function (props, borderProps) {
	  var title = props.title,
	      titleOrientation = props.titleOrientation,
	      centerTitle = props.centerTitle,
	      borderPadding = props.borderPadding;
	  var height = borderProps.height,
	      width = borderProps.width;
	  var style = getTitleStyle(props);
	  var padding = Array.isArray(style) ? style[0].padding : style.padding;
	  var horizontal = titleOrientation === "top" || titleOrientation === "bottom";
	  var xOrientation = titleOrientation === "bottom" ? "bottom" : "top";
	  var yOrientation = titleOrientation === "right" ? "right" : "left";
	  var standardPadding = {
	    x: centerTitle ? width / 2 : borderPadding[xOrientation] + (padding || 0),
	    y: centerTitle ? height / 2 : borderPadding[yOrientation] + (padding || 0)
	  };
	
	  var getPadding = function () {
	    return borderPadding[titleOrientation] + (padding || 0);
	  };
	
	  var xOffset = horizontal ? standardPadding.x : getPadding();
	  var yOffset = horizontal ? getPadding() : standardPadding.y;
	  return {
	    x: titleOrientation === "right" ? props.x + width - xOffset : props.x + xOffset,
	    y: titleOrientation === "bottom" ? props.y + height - yOffset : props.y + yOffset,
	    style: style,
	    text: title
	  };
	};
	
	var getBorderProps = function (props, contentHeight, contentWidth) {
	  var x = props.x,
	      y = props.y,
	      borderPadding = props.borderPadding,
	      style = props.style;
	  var height = (contentHeight || 0) + borderPadding.top + borderPadding.bottom;
	  var width = (contentWidth || 0) + borderPadding.left + borderPadding.right;
	  return {
	    x: x,
	    y: y,
	    height: height,
	    width: width,
	    style: (0, _assign2.default)({
	      fill: "none"
	    }, style.border)
	  };
	};
	
	var getDimensions = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "legend");
	
	  props = (0, _assign2.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      title = _props.title,
	      titleOrientation = _props.titleOrientation;
	  var groupedData = groupData(props);
	  var columnWidths = getColumnWidths(props, groupedData);
	  var rowHeights = getRowHeights(props, groupedData);
	  var titleDimensions = title ? getTitleDimensions(props) : {
	    height: 0,
	    width: 0
	  };
	  return {
	    height: titleOrientation === "left" || titleOrientation === "right" ? Math.max((0, _sum2.default)(rowHeights), titleDimensions.height) : (0, _sum2.default)(rowHeights) + titleDimensions.height,
	    width: titleOrientation === "left" || titleOrientation === "right" ? (0, _sum2.default)(columnWidths) + titleDimensions.width : Math.max((0, _sum2.default)(columnWidths), titleDimensions.width)
	  };
	};
	
	exports.getDimensions = getDimensions;
	
	var getBaseProps = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "legend");
	
	  props = (0, _assign2.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props2 = props,
	      data = _props2.data,
	      standalone = _props2.standalone,
	      theme = _props2.theme,
	      padding = _props2.padding,
	      style = _props2.style,
	      colorScale = _props2.colorScale,
	      gutter = _props2.gutter,
	      rowGutter = _props2.rowGutter,
	      borderPadding = _props2.borderPadding,
	      title = _props2.title,
	      titleOrientation = _props2.titleOrientation,
	      name = _props2.name,
	      _props2$x = _props2.x,
	      x = _props2$x === void 0 ? 0 : _props2$x,
	      _props2$y = _props2.y,
	      y = _props2$y === void 0 ? 0 : _props2$y;
	  var groupedData = groupData(props);
	  var columnWidths = getColumnWidths(props, groupedData);
	  var rowHeights = getRowHeights(props, groupedData);
	  var labelStyles = getLabelStyles(props);
	  var titleDimensions = title ? getTitleDimensions(props) : {
	    height: 0,
	    width: 0
	  };
	  var titleOffset = {
	    x: titleOrientation === "left" ? titleDimensions.width : 0,
	    y: titleOrientation === "top" ? titleDimensions.height : 0
	  };
	  var gutterOffset = {
	    x: gutter && typeof gutter === "object" ? gutter.left || 0 : 0,
	    y: rowGutter && typeof rowGutter === "object" ? rowGutter.top || 0 : 0
	  };
	
	  var _getDimensions = getDimensions(props, fallbackProps),
	      height = _getDimensions.height,
	      width = _getDimensions.width;
	
	  var borderProps = getBorderProps(props, height, width);
	  var titleProps = getTitleProps(props, borderProps);
	  var initialProps = {
	    parent: {
	      data: data,
	      standalone: standalone,
	      theme: theme,
	      padding: padding,
	      name: name,
	      height: props.height,
	      width: props.width,
	      style: style.parent
	    },
	    all: {
	      border: borderProps,
	      title: titleProps
	    }
	  };
	  return groupedData.reduce(function (childProps, datum, i) {
	    var color = colorScale[i % colorScale.length];
	    var dataStyle = (0, _defaults2.default)({}, datum.symbol, style.data, {
	      fill: color
	    });
	    var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : i;
	    var offset = getOffset(datum, rowHeights, columnWidths);
	    var originY = y + borderPadding.top + datum.symbolSpacer;
	    var originX = x + borderPadding.left + datum.symbolSpacer;
	    var dataProps = {
	      index: i,
	      data: data,
	      datum: datum,
	      symbol: dataStyle.type || dataStyle.symbol || "circle",
	      size: datum.size,
	      style: dataStyle,
	      y: originY + offset.y + titleOffset.y + gutterOffset.y,
	      x: originX + offset.x + titleOffset.x + gutterOffset.x
	    };
	    var labelProps = {
	      datum: datum,
	      data: data,
	      text: datum.name,
	      style: labelStyles[i],
	      y: dataProps.y,
	      x: dataProps.x + datum.symbolSpacer + datum.size / 2
	    };
	    childProps[eventKey] = {
	      data: dataProps,
	      labels: labelProps
	    };
	    return childProps;
	  }, initialProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryLegend", {
	  enumerable: true,
	  get: function () {
	    return _victoryLegend.default;
	  }
	});
	
	var _victoryLegend = _interopRequireDefault(__webpack_require__(1888));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _helperMethods = __webpack_require__(1886);
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  orientation: "vertical",
	  titleOrientation: "top",
	  width: 450,
	  height: 300,
	  x: 0,
	  y: 0
	};
	var defaultLegendData = [{
	  name: "Series 1"
	}, {
	  name: "Series 2"
	}];
	
	var VictoryLegend =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryLegend, _React$Component);
	
	  function VictoryLegend() {
	    _classCallCheck(this, VictoryLegend);
	
	    return _possibleConstructorReturn(this, (VictoryLegend.__proto__ || Object.getPrototypeOf(VictoryLegend)).apply(this, arguments));
	  }
	
	  _createClass(VictoryLegend, [{
	    key: "renderChildren",
	    value: function renderChildren(props) {
	      var _this = this;
	
	      var dataComponent = props.dataComponent,
	          labelComponent = props.labelComponent,
	          title = props.title;
	      var dataComponents = this.dataKeys.map(function (_dataKey, index) {
	        if (_dataKey === "all") {
	          return undefined;
	        }
	
	        var dataProps = _this.getComponentProps(dataComponent, "data", index);
	
	        return _react.default.cloneElement(dataComponent, dataProps);
	      }).filter(Boolean);
	      var labelComponents = this.dataKeys.map(function (_dataKey, index) {
	        if (_dataKey === "all") {
	          return undefined;
	        }
	
	        var labelProps = _this.getComponentProps(labelComponent, "labels", index);
	
	        if (labelProps.text !== undefined && labelProps.text !== null) {
	          return _react.default.cloneElement(labelComponent, labelProps);
	        }
	
	        return undefined;
	      }).filter(Boolean);
	      var borderProps = this.getComponentProps(props.borderComponent, "border", "all");
	
	      var borderComponent = _react.default.cloneElement(props.borderComponent, borderProps);
	
	      if (title) {
	        var titleProps = this.getComponentProps(props.title, "title", "all");
	
	        var titleComponent = _react.default.cloneElement(props.titleComponent, titleProps);
	
	        return [borderComponent].concat(_toConsumableArray(dataComponents), [titleComponent], _toConsumableArray(labelComponents));
	      }
	
	      return [borderComponent].concat(_toConsumableArray(dataComponents), _toConsumableArray(labelComponents));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      var children = [this.renderChildren(props)];
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : _react.default.cloneElement(props.groupComponent, {}, children);
	    }
	  }]);
	
	  return VictoryLegend;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryLegend, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryLegend"
	});
	Object.defineProperty(VictoryLegend, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "legend"
	});
	Object.defineProperty(VictoryLegend, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    borderComponent: _propTypes.default.element,
	    borderPadding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	      top: _propTypes.default.number,
	      bottom: _propTypes.default.number,
	      left: _propTypes.default.number,
	      right: _propTypes.default.number
	    })]),
	    centerTitle: _propTypes.default.bool,
	    colorScale: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
	    containerComponent: _propTypes.default.element,
	    data: _propTypes.default.arrayOf(_propTypes.default.shape({
	      name: _propTypes.default.string.isRequired,
	      label: _propTypes.default.object,
	      symbol: _propTypes.default.object
	    })),
	    dataComponent: _propTypes.default.element,
	    eventKey: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	    events: _propTypes.default.arrayOf(_propTypes.default.shape({
	      target: _propTypes.default.oneOf(["data", "labels", "parent"]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      eventHandlers: _propTypes.default.object
	    })),
	    externalEventMutations: _propTypes.default.arrayOf(_propTypes.default.shape({
	      callback: _propTypes.default.function,
	      childName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      mutation: _propTypes.default.function,
	      target: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array])
	    })),
	    groupComponent: _propTypes.default.element,
	    gutter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	      left: _propTypes.default.number,
	      right: _propTypes.default.number
	    })]),
	    height: _victoryCore.PropTypes.nonNegative,
	    itemsPerRow: _victoryCore.PropTypes.nonNegative,
	    labelComponent: _propTypes.default.element,
	    name: _propTypes.default.string,
	    orientation: _propTypes.default.oneOf(["horizontal", "vertical"]),
	    padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	      top: _propTypes.default.number,
	      bottom: _propTypes.default.number,
	      left: _propTypes.default.number,
	      right: _propTypes.default.number
	    })]),
	    rowGutter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	      top: _propTypes.default.number,
	      bottom: _propTypes.default.number
	    })]),
	    sharedEvents: _propTypes.default.shape({
	      events: _propTypes.default.array,
	      getEventState: _propTypes.default.func
	    }),
	    standalone: _propTypes.default.bool,
	    style: _propTypes.default.shape({
	      border: _propTypes.default.object,
	      data: _propTypes.default.object,
	      labels: _propTypes.default.object,
	      parent: _propTypes.default.object,
	      title: _propTypes.default.object
	    }),
	    symbolSpacer: _propTypes.default.number,
	    theme: _propTypes.default.object,
	    title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	    titleComponent: _propTypes.default.element,
	    titleOrientation: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
	    width: _victoryCore.PropTypes.nonNegative,
	    x: _victoryCore.PropTypes.nonNegative,
	    y: _victoryCore.PropTypes.nonNegative
	  }
	});
	Object.defineProperty(VictoryLegend, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    borderComponent: _react.default.createElement(_victoryCore.Border, null),
	    data: defaultLegendData,
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    dataComponent: _react.default.createElement(_victoryCore.Point, null),
	    groupComponent: _react.default.createElement("g", null),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale,
	    titleComponent: _react.default.createElement(_victoryCore.VictoryLabel, null)
	  }
	});
	Object.defineProperty(VictoryLegend, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryLegend, "getDimensions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getDimensions)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryLegend, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["borderComponent", "containerComponent", "dataComponent", "groupComponent", "labelComponent", "titleComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryLegend);
	
	exports.default = _default;

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBaseProps = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCalculatedValues = function (props) {
	  var data = _victoryCore.Data.getData(props);
	
	  if (data.length < 2) {
	    data = [];
	  }
	
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var domain = {
	    x: _victoryCore.Domain.getDomain(props, "x"),
	    y: _victoryCore.Domain.getDomain(props, "y")
	  };
	  var scale = {
	    x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var origin = props.polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	  var defaultStyles = props.theme && props.theme.line && props.theme.line.style ? props.theme.line.style : {};
	
	  var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	
	  return {
	    domain: domain,
	    data: data,
	    scale: scale,
	    style: style,
	    origin: origin
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "line");
	
	  props = (0, _assign2.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      data = _props.data,
	      domain = _props.domain,
	      events = _props.events,
	      groupComponent = _props.groupComponent,
	      height = _props.height,
	      horizontal = _props.horizontal,
	      interpolation = _props.interpolation,
	      origin = _props.origin,
	      padding = _props.padding,
	      polar = _props.polar,
	      scale = _props.scale,
	      sharedEvents = _props.sharedEvents,
	      standalone = _props.standalone,
	      style = _props.style,
	      theme = _props.theme,
	      width = _props.width,
	      labels = _props.labels,
	      name = _props.name;
	  var initialChildProps = {
	    parent: {
	      style: style.parent,
	      scale: scale,
	      data: data,
	      height: height,
	      width: width,
	      name: name,
	      domain: domain,
	      standalone: standalone,
	      polar: polar,
	      origin: origin,
	      padding: padding,
	      horizontal: horizontal
	    },
	    all: {
	      data: {
	        horizontal: horizontal,
	        polar: polar,
	        origin: origin,
	        scale: scale,
	        data: data,
	        interpolation: interpolation,
	        groupComponent: groupComponent,
	        theme: theme,
	        style: style.data
	      }
	    }
	  };
	  return data.reduce(function (childProps, datum, index) {
	    var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	
	    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
	      var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	      childProps[eventKey] = {
	        labels: _victoryCore.LabelHelpers.getProps(props, index)
	      };
	    }
	
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryLine", {
	  enumerable: true,
	  get: function () {
	    return _victoryLine.default;
	  }
	});
	Object.defineProperty(exports, "Curve", {
	  enumerable: true,
	  get: function () {
	    return _curve.default;
	  }
	});
	
	var _victoryLine = _interopRequireDefault(__webpack_require__(1891));
	
	var _curve = _interopRequireDefault(__webpack_require__(684));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _helperMethods = __webpack_require__(1889);
	
	var _curve = _interopRequireDefault(__webpack_require__(684));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  interpolation: "linear"
	};
	var options = {
	  components: [{
	    name: "parent",
	    index: "parent"
	  }, {
	    name: "data",
	    index: "all"
	  }, {
	    name: "labels"
	  }]
	};
	
	var VictoryLine =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryLine, _React$Component);
	
	  function VictoryLine() {
	    _classCallCheck(this, VictoryLine);
	
	    return _possibleConstructorReturn(this, (VictoryLine.__proto__ || Object.getPrototypeOf(VictoryLine)).apply(this, arguments));
	  }
	
	  _createClass(VictoryLine, [{
	    key: "shouldAnimate",
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryLine.animationWhitelist,
	          role = VictoryLine.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderContinuousData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryLine;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryLine, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "domain", "height", "padding", "samples", "style", "width"]
	});
	Object.defineProperty(VictoryLine, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryLine"
	});
	Object.defineProperty(VictoryLine, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "line"
	});
	Object.defineProperty(VictoryLine, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.continuousTransitions()
	});
	Object.defineProperty(VictoryLine, "defaultPolarTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.continuousPolarTransitions()
	});
	Object.defineProperty(VictoryLine, "continuous", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: true
	});
	Object.defineProperty(VictoryLine, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    interpolation: _propTypes.default.oneOfType([_propTypes.default.oneOf(["basis", "bundle", "cardinal", "catmullRom", "linear", "monotoneX", "monotoneY", "natural", "step", "stepAfter", "stepBefore"]), _propTypes.default.func]),
	    label: _victoryCore.PropTypes.deprecated(_propTypes.default.string, "Use `labels` instead for individual data labels")
	  })
	});
	Object.defineProperty(VictoryLine, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    dataComponent: _react.default.createElement(_curve.default, null),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, {
	      renderInPortal: true
	    }),
	    groupComponent: _react.default.createElement(_victoryCore.VictoryClipContainer, null),
	    samples: 50,
	    sortKey: "x",
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryLine, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Domain.getDomain
	});
	Object.defineProperty(VictoryLine, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Data.getData
	});
	Object.defineProperty(VictoryLine, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryLine, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryLine, options);
	
	exports.default = _default;

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBaseProps = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var d3Shape = _interopRequireWildcard(__webpack_require__(147));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkForValidText = function (text) {
	  if (text === undefined || text === null || (0, _isFunction2.default)(text)) {
	    return text;
	  } else {
	    return "".concat(text);
	  }
	};
	
	var getColor = function (style, colors, index) {
	  if (style && style.data && style.data.fill) {
	    return style.data.fill;
	  }
	
	  return colors && colors[index % colors.length];
	};
	
	var getRadius = function (props, padding) {
	  if (typeof props.radius === "number") {
	    return props.radius;
	  }
	
	  return Math.min(props.width - padding.left - padding.right, props.height - padding.top - padding.bottom) / 2;
	};
	
	var getOrigin = function (props, padding) {
	  var width = props.width,
	      height = props.height;
	  var origin = (0, _isPlainObject2.default)(props.origin) ? props.origin : {};
	  return {
	    x: origin.x !== undefined ? origin.x : (padding.left - padding.right + width) / 2,
	    y: origin.y !== undefined ? origin.y : (padding.top - padding.bottom + height) / 2
	  };
	};
	
	var getSlices = function (props, data) {
	  var padAngle = (0, _isFunction2.default)(props.padAngle) ? 0 : props.padAngle;
	  var layoutFunction = d3Shape.pie().sort(null).startAngle(_victoryCore.Helpers.degreesToRadians(props.startAngle)).endAngle(_victoryCore.Helpers.degreesToRadians(props.endAngle)).padAngle(_victoryCore.Helpers.degreesToRadians(padAngle)).value(function (datum) {
	    return datum._y;
	  });
	  return layoutFunction(data);
	};
	
	var getCalculatedValues = function (props) {
	  var theme = props.theme,
	      colorScale = props.colorScale;
	  var styleObject = theme && theme.pie && theme.pie.style ? theme.pie.style : {};
	
	  var style = _victoryCore.Helpers.getStyles(props.style, styleObject, "auto", "100%");
	
	  var colors = Array.isArray(colorScale) ? colorScale : _victoryCore.Style.getColorScale(colorScale);
	
	  var padding = _victoryCore.Helpers.getPadding(props);
	
	  var defaultRadius = getRadius(props, padding);
	  var origin = getOrigin(props, padding);
	
	  var data = _victoryCore.Data.getData(props);
	
	  var slices = getSlices(props, data);
	  return (0, _assign2.default)({}, props, {
	    style: style,
	    colors: colors,
	    padding: padding,
	    defaultRadius: defaultRadius,
	    data: data,
	    slices: slices,
	    origin: origin
	  });
	};
	
	var getSliceStyle = function (index, calculatedValues) {
	  var style = calculatedValues.style,
	      colors = calculatedValues.colors;
	  var fill = getColor(style, colors, index);
	  return (0, _assign2.default)({
	    fill: fill
	  }, style.data);
	};
	
	var getLabelText = function (props, datum, index) {
	  var text;
	
	  if (datum.label) {
	    text = datum.label;
	  } else if (Array.isArray(props.labels)) {
	    text = props.labels[index];
	  } else {
	    text = (0, _isFunction2.default)(props.labels) ? props.labels : datum.xName || datum._x;
	  }
	
	  return checkForValidText(text);
	};
	
	var getLabelArc = function (radius, labelRadius, style) {
	  var padding = style && style.padding || 0;
	  var arcRadius = labelRadius || radius + padding;
	  return d3Shape.arc().outerRadius(arcRadius).innerRadius(arcRadius);
	};
	
	var getLabelPosition = function (arc, slice, position) {
	  var construct = {
	    startAngle: position === "startAngle" ? slice.endAngle : slice.startAngle,
	    endAngle: position === "endAngle" ? slice.startAngle : slice.endAngle
	  };
	  var clonedArc = (0, _assign2.default)({}, slice, construct);
	  return arc.centroid(clonedArc);
	};
	
	var getLabelOrientation = function (slice) {
	  var radiansToDegrees = function (radians) {
	    return radians * (180 / Math.PI);
	  };
	
	  var start = radiansToDegrees(slice.startAngle);
	  var end = radiansToDegrees(slice.endAngle);
	  var degree = start + (end - start) / 2;
	
	  if (degree < 45 || degree > 315) {
	    return "top";
	  } else if (degree >= 45 && degree < 135) {
	    return "right";
	  } else if (degree >= 135 && degree < 225) {
	    return "bottom";
	  } else {
	    return "left";
	  }
	};
	
	var getTextAnchor = function (orientation) {
	  if (orientation === "top" || orientation === "bottom") {
	    return "middle";
	  }
	
	  return orientation === "right" ? "start" : "end";
	};
	
	var getVerticalAnchor = function (orientation) {
	  if (orientation === "left" || orientation === "right") {
	    return "middle";
	  }
	
	  return orientation === "bottom" ? "start" : "end";
	};
	
	var getLabelProps = function (text, dataProps, calculatedValues) {
	  var index = dataProps.index,
	      datum = dataProps.datum,
	      data = dataProps.data,
	      slice = dataProps.slice;
	  var style = calculatedValues.style,
	      defaultRadius = calculatedValues.defaultRadius,
	      origin = calculatedValues.origin,
	      width = calculatedValues.width,
	      height = calculatedValues.height;
	
	  var labelRadius = _victoryCore.Helpers.evaluateProp(calculatedValues.labelRadius, (0, _assign2.default)({
	    text: text
	  }, dataProps));
	
	  var labelPosition = _victoryCore.Helpers.evaluateProp(calculatedValues.labelPosition, (0, _assign2.default)({
	    text: text
	  }, dataProps));
	
	  var labelStyle = (0, _assign2.default)({
	    padding: 0
	  }, style.labels);
	
	  var evaluatedStyle = _victoryCore.Helpers.evaluateStyle(labelStyle, (0, _assign2.default)({
	    labelRadius: labelRadius,
	    text: text
	  }, dataProps));
	
	  var labelArc = getLabelArc(defaultRadius, labelRadius, evaluatedStyle);
	  var position = getLabelPosition(labelArc, slice, labelPosition);
	  var orientation = getLabelOrientation(slice);
	  return {
	    width: width,
	    height: height,
	    index: index,
	    datum: datum,
	    data: data,
	    slice: slice,
	    orientation: orientation,
	    text: text,
	    style: labelStyle,
	    x: Math.round(position[0]) + origin.x,
	    y: Math.round(position[1]) + origin.y,
	    textAnchor: labelStyle.textAnchor || getTextAnchor(orientation),
	    verticalAnchor: labelStyle.verticalAnchor || getVerticalAnchor(orientation),
	    angle: labelStyle.angle
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  props = _victoryCore.Helpers.modifyProps(props, fallbackProps, "pie");
	  var calculatedValues = getCalculatedValues(props);
	  var slices = calculatedValues.slices,
	      style = calculatedValues.style,
	      data = calculatedValues.data,
	      origin = calculatedValues.origin,
	      defaultRadius = calculatedValues.defaultRadius,
	      labels = calculatedValues.labels,
	      events = calculatedValues.events,
	      sharedEvents = calculatedValues.sharedEvents,
	      height = calculatedValues.height,
	      width = calculatedValues.width,
	      standalone = calculatedValues.standalone,
	      name = calculatedValues.name,
	      innerRadius = calculatedValues.innerRadius,
	      cornerRadius = calculatedValues.cornerRadius,
	      padAngle = calculatedValues.padAngle;
	  var radius = props.radius || defaultRadius;
	  var initialChildProps = {
	    parent: {
	      standalone: standalone,
	      height: height,
	      width: width,
	      slices: slices,
	      name: name,
	      style: style.parent
	    }
	  };
	  return slices.reduce(function (childProps, slice, index) {
	    var datum = (0, _defaults2.default)({}, data[index], {
	      startAngle: _victoryCore.Helpers.radiansToDegrees(slice.startAngle),
	      endAngle: _victoryCore.Helpers.radiansToDegrees(slice.endAngle),
	      padAngle: _victoryCore.Helpers.radiansToDegrees(slice.padAngle)
	    });
	    var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	    var dataProps = {
	      index: index,
	      slice: slice,
	      datum: datum,
	      data: data,
	      origin: origin,
	      innerRadius: innerRadius,
	      radius: radius,
	      cornerRadius: cornerRadius,
	      padAngle: padAngle,
	      style: getSliceStyle(index, calculatedValues)
	    };
	    childProps[eventKey] = {
	      data: dataProps
	    };
	    var text = getLabelText(props, datum, index);
	
	    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
	      var evaluatedText = _victoryCore.Helpers.evaluateProp(text, dataProps);
	
	      childProps[eventKey].labels = getLabelProps(evaluatedText, dataProps, calculatedValues);
	    }
	
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryPie", {
	  enumerable: true,
	  get: function () {
	    return _victoryPie.default;
	  }
	});
	Object.defineProperty(exports, "Slice", {
	  enumerable: true,
	  get: function () {
	    return _slice.default;
	  }
	});
	
	var _victoryPie = _interopRequireDefault(__webpack_require__(1894));
	
	var _slice = _interopRequireDefault(__webpack_require__(685));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	var _slice = _interopRequireDefault(__webpack_require__(685));
	
	var _helperMethods = __webpack_require__(1892);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  endAngle: 360,
	  height: 400,
	  innerRadius: 0,
	  cornerRadius: 0,
	  padAngle: 0,
	  padding: 30,
	  width: 400,
	  startAngle: 0,
	  colorScale: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
	  labelPosition: "centroid"
	};
	
	var VictoryPie =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryPie, _React$Component);
	
	  function VictoryPie() {
	    _classCallCheck(this, VictoryPie);
	
	    return _possibleConstructorReturn(this, (VictoryPie.__proto__ || Object.getPrototypeOf(VictoryPie)).apply(this, arguments));
	  }
	
	  _createClass(VictoryPie, [{
	    key: "shouldAnimate",
	    // Overridden in victory-native
	    value: function shouldAnimate() {
	      return Boolean(this.props.animate);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryPie.animationWhitelist,
	          role = VictoryPie.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryPie;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryPie, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "endAngle", "height", "innerRadius", "cornerRadius", "padAngle", "padding", "colorScale", "startAngle", "style", "width"]
	});
	Object.defineProperty(VictoryPie, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryPie"
	});
	Object.defineProperty(VictoryPie, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "pie"
	});
	Object.defineProperty(VictoryPie, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    onExit: {
	      duration: 500,
	      before: function () {
	        return {
	          _y: 0,
	          label: " "
	        };
	      }
	    },
	    onEnter: {
	      duration: 500,
	      before: function () {
	        return {
	          _y: 0,
	          label: " "
	        };
	      },
	      after: function (datum) {
	        return {
	          y_: datum._y,
	          label: datum.label
	        };
	      }
	    }
	  }
	});
	Object.defineProperty(VictoryPie, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    animate: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
	    colorScale: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
	    containerComponent: _propTypes.default.element,
	    cornerRadius: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    data: _propTypes.default.array,
	    dataComponent: _propTypes.default.element,
	    endAngle: _propTypes.default.number,
	    eventKey: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	    events: _propTypes.default.arrayOf(_propTypes.default.shape({
	      target: _propTypes.default.oneOf(["data", "labels", "parent"]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      eventHandlers: _propTypes.default.object
	    })),
	    externalEventMutations: _propTypes.default.arrayOf(_propTypes.default.shape({
	      callback: _propTypes.default.function,
	      childName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      mutation: _propTypes.default.function,
	      target: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array])
	    })),
	    groupComponent: _propTypes.default.element,
	    height: _victoryCore.PropTypes.nonNegative,
	    innerRadius: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    labelComponent: _propTypes.default.element,
	    labelPosition: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.oneOf(["startAngle", "centroid", "endAngle"])]),
	    labelRadius: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    labels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array]),
	    name: _propTypes.default.string,
	    origin: _propTypes.default.shape({
	      x: _victoryCore.PropTypes.nonNegative,
	      y: _victoryCore.PropTypes.nonNegative
	    }),
	    padAngle: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	      top: _propTypes.default.number,
	      bottom: _propTypes.default.number,
	      left: _propTypes.default.number,
	      right: _propTypes.default.number
	    })]),
	    radius: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    sharedEvents: _propTypes.default.shape({
	      events: _propTypes.default.array,
	      getEventState: _propTypes.default.func
	    }),
	    sortKey: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    sortOrder: _propTypes.default.oneOf(["ascending", "descending"]),
	    standalone: _propTypes.default.bool,
	    startAngle: _propTypes.default.number,
	    style: _propTypes.default.shape({
	      parent: _propTypes.default.object,
	      data: _propTypes.default.object,
	      labels: _propTypes.default.object
	    }),
	    theme: _propTypes.default.object,
	    width: _victoryCore.PropTypes.nonNegative,
	    x: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	    y: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)])
	  }
	});
	Object.defineProperty(VictoryPie, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    data: [{
	      x: "A",
	      y: 1
	    }, {
	      x: "B",
	      y: 2
	    }, {
	      x: "C",
	      y: 3
	    }, {
	      x: "D",
	      y: 1
	    }, {
	      x: "E",
	      y: 2
	    }],
	    standalone: true,
	    dataComponent: _react.default.createElement(_slice.default, null),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    groupComponent: _react.default.createElement("g", null),
	    sortOrder: "ascending",
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryPie, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryPie, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Data.getData
	});
	Object.defineProperty(VictoryPie, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryPie);
	
	exports.default = _default;

/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBaseProps = exports.getStyles = exports.getScale = void 0;
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(453));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPosition = function (r, angle, axis) {
	  return axis === "x" ? r * Math.cos(angle) : -r * Math.sin(angle);
	};
	
	var getAxisType = function (props) {
	  var typicalType = props.dependentAxis ? "radial" : "angular";
	  var invertedType = typicalType === "angular" ? "radial" : "angular";
	  return props.horizontal ? invertedType : typicalType;
	};
	
	var filterTicks = function (ticks, scale) {
	  var compareTicks = function (t) {
	    return scale(t) % (2 * Math.PI);
	  };
	
	  return (0, _uniqBy2.default)(ticks, compareTicks);
	};
	
	var getEvaluatedStyles = function (style, props) {
	  return {
	    tickStyle: _victoryCore.Helpers.evaluateStyle(style.ticks, props),
	    labelStyle: _victoryCore.Helpers.evaluateStyle(style.tickLabels, props),
	    gridStyle: _victoryCore.Helpers.evaluateStyle(style.grid, props)
	  };
	};
	
	var getStyleObject = function (props) {
	  var theme = props.theme,
	      dependentAxis = props.dependentAxis;
	  var generalAxisStyle = theme && theme.axis && theme.axis.style;
	  var axisType = dependentAxis ? "dependentAxis" : "independentAxis";
	  var specificAxisStyle = theme && theme[axisType] && theme[axisType].style;
	
	  var mergeStyles = function () {
	    var styleNamespaces = ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"];
	    return styleNamespaces.reduce(function (memo, curr) {
	      memo[curr] = (0, _defaults2.default)({}, specificAxisStyle[curr], generalAxisStyle[curr]);
	      return memo;
	    }, {});
	  };
	
	  return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
	};
	
	var getRadius = function (props) {
	  var _Helpers$getPadding = _victoryCore.Helpers.getPadding(props),
	      left = _Helpers$getPadding.left,
	      right = _Helpers$getPadding.right,
	      top = _Helpers$getPadding.top,
	      bottom = _Helpers$getPadding.bottom;
	
	  var width = props.width,
	      height = props.height;
	  return Math.min(width - left - right, height - top - bottom) / 2;
	};
	
	var getRange = function (props, axis) {
	  // Return the range from props if one is given.
	  if (props.range && props.range[axis]) {
	    return props.range[axis];
	  } else if (props.range && Array.isArray(props.range)) {
	    return props.range;
	  }
	
	  var axisType = getAxisType(props);
	
	  if (axisType === "angular") {
	    var startAngle = _victoryCore.Helpers.degreesToRadians(props.startAngle);
	
	    var endAngle = _victoryCore.Helpers.degreesToRadians(props.endAngle);
	
	    return [startAngle, endAngle];
	  }
	
	  var radius = getRadius(props);
	  return [props.innerRadius || 0, radius];
	}; // exposed for use by VictoryChart (necessary?)
	
	
	var getScale = function (props) {
	  var axis = _victoryCore.Axis.getAxis(props);
	
	  var scale = _victoryCore.Scale.getBaseScale(props, axis);
	
	  var domain = _victoryCore.Axis.getDomain(props, axis) || scale.domain();
	  var range = getRange(props, axis);
	  scale.range(range);
	  scale.domain(domain);
	  return scale;
	};
	
	exports.getScale = getScale;
	
	var getStyles = function (props, styleObject) {
	  var style = props.style || {};
	  styleObject = styleObject || {};
	  var parentStyleProps = {
	    height: "auto",
	    width: "100%"
	  };
	  return {
	    parent: (0, _defaults2.default)(parentStyleProps, style.parent, styleObject.parent),
	    axis: (0, _defaults2.default)({}, style.axis, styleObject.axis),
	    axisLabel: (0, _defaults2.default)({}, style.axisLabel, styleObject.axisLabel),
	    grid: (0, _defaults2.default)({}, style.grid, styleObject.grid),
	    ticks: (0, _defaults2.default)({}, style.ticks, styleObject.ticks),
	    tickLabels: (0, _defaults2.default)({}, style.tickLabels, styleObject.tickLabels)
	  };
	};
	
	exports.getStyles = getStyles;
	
	var getAxisAngle = function (props) {
	  var axisAngle = props.axisAngle,
	      startAngle = props.startAngle,
	      dependentAxis = props.dependentAxis;
	
	  var axis = _victoryCore.Axis.getAxis(props);
	
	  var axisValue = _victoryCore.Axis.getAxisValue(props, axis);
	
	  if (axisValue === undefined || !dependentAxis) {
	    return axisAngle === undefined ? startAngle : axisAngle;
	  }
	
	  return _victoryCore.Helpers.radiansToDegrees(axisValue);
	}; //eslint-disable-next-line max-params
	
	
	var getTickProps = function (props, calculatedValues, tickValue, index) {
	  var axisType = calculatedValues.axisType,
	      radius = calculatedValues.radius,
	      scale = calculatedValues.scale,
	      style = calculatedValues.style,
	      stringTicks = calculatedValues.stringTicks,
	      ticks = calculatedValues.ticks,
	      tickFormat = calculatedValues.tickFormat;
	  var text = tickFormat(tickValue, index, ticks);
	  var tick = stringTicks ? stringTicks[index] : tickValue;
	
	  var _getEvaluatedStyles = getEvaluatedStyles(style, {
	    tick: tick,
	    tickValue: tickValue,
	    index: index,
	    ticks: ticks,
	    stringTicks: stringTicks,
	    radius: radius,
	    scale: scale,
	    axisType: axisType,
	    text: text
	  }),
	      tickStyle = _getEvaluatedStyles.tickStyle;
	
	  var tickPadding = tickStyle.padding || 0;
	  var angularPadding = tickPadding; // TODO: do some geometry
	
	  var axisAngle = axisType === "radial" ? getAxisAngle(props, scale) : undefined;
	  return axisType === "angular" ? {
	    index: index,
	    datum: tick,
	    style: tickStyle,
	    x1: radius * Math.cos(scale(tickValue)),
	    y1: -radius * Math.sin(scale(tickValue)),
	    x2: (radius + tickPadding) * Math.cos(scale(tickValue)),
	    y2: -(radius + tickPadding) * Math.sin(scale(tickValue))
	  } : {
	    style: style,
	    index: index,
	    datum: tick,
	    x1: scale(tickValue) / 2 * Math.cos(axisAngle - angularPadding),
	    x2: scale(tickValue) / 2 * Math.cos(axisAngle + angularPadding),
	    y1: -(scale(tickValue) / 2) * Math.sin(axisAngle - angularPadding),
	    y2: -(scale(tickValue) / 2) * Math.sin(axisAngle + angularPadding)
	  };
	}; //eslint-disable-next-line max-params
	
	
	var getTickLabelProps = function (props, calculatedValues, tickValue, index) {
	  var axisType = calculatedValues.axisType,
	      radius = calculatedValues.radius,
	      tickFormat = calculatedValues.tickFormat,
	      style = calculatedValues.style,
	      scale = calculatedValues.scale,
	      ticks = calculatedValues.ticks,
	      stringTicks = calculatedValues.stringTicks;
	  var text = tickFormat(tickValue, index, ticks);
	  var tick = stringTicks ? stringTicks[index] : tickValue;
	
	  var _getEvaluatedStyles2 = getEvaluatedStyles(style, {
	    text: text,
	    tick: tick,
	    tickValue: tickValue,
	    index: index,
	    ticks: ticks,
	    stringTicks: stringTicks,
	    radius: radius,
	    scale: scale,
	    axisType: axisType
	  }),
	      labelStyle = _getEvaluatedStyles2.labelStyle;
	
	  var tickLabelComponent = props.tickLabelComponent;
	  var labelPlacement = tickLabelComponent.props && tickLabelComponent.props.labelPlacement ? tickLabelComponent.props.labelPlacement : props.labelPlacement;
	  var tickPadding = labelStyle.padding || 0;
	  var angularPadding = 0; // TODO: do some geometry
	
	  var axisAngle = axisType === "radial" ? getAxisAngle(props, scale) : undefined;
	  var labelAngle = axisType === "angular" ? _victoryCore.Helpers.radiansToDegrees(scale(tickValue)) : axisAngle + angularPadding;
	  var textAngle = labelStyle.angle === undefined ? _victoryCore.LabelHelpers.getPolarAngle((0, _assign2.default)({}, props, {
	    labelPlacement: labelPlacement
	  }), labelAngle) : labelStyle.angle;
	  var labelRadius = axisType === "angular" ? radius + tickPadding : scale(tickValue);
	
	  var textAnchor = labelStyle.textAnchor || _victoryCore.LabelHelpers.getPolarTextAnchor((0, _assign2.default)({}, props, {
	    labelPlacement: labelPlacement
	  }), labelAngle);
	
	  return {
	    index: index,
	    datum: tick,
	    style: labelStyle,
	    angle: textAngle,
	    textAnchor: textAnchor,
	    text: text,
	    x: labelRadius * Math.cos(_victoryCore.Helpers.degreesToRadians(labelAngle)),
	    y: -labelRadius * Math.sin(_victoryCore.Helpers.degreesToRadians(labelAngle))
	  };
	}; //eslint-disable-next-line max-params
	
	
	var getGridProps = function (props, calculatedValues, tickValue, index) {
	  var axisType = calculatedValues.axisType,
	      radius = calculatedValues.radius,
	      style = calculatedValues.style,
	      scale = calculatedValues.scale,
	      stringTicks = calculatedValues.stringTicks,
	      ticks = calculatedValues.ticks,
	      tickFormat = calculatedValues.tickFormat;
	  var text = tickFormat(tickValue, index, ticks);
	  var startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      _props$innerRadius = props.innerRadius,
	      innerRadius = _props$innerRadius === void 0 ? 0 : _props$innerRadius;
	  var tick = stringTicks ? stringTicks[index] : tickValue;
	
	  var _getEvaluatedStyles3 = getEvaluatedStyles(style, {
	    tick: tick,
	    tickValue: tickValue,
	    index: index,
	    ticks: ticks,
	    stringTicks: stringTicks,
	    radius: radius,
	    scale: scale,
	    axisType: axisType,
	    text: text
	  }),
	      gridStyle = _getEvaluatedStyles3.gridStyle;
	
	  var angle = scale(tickValue);
	  return axisType === "angular" ? {
	    index: index,
	    datum: tick,
	    style: gridStyle,
	    x1: getPosition(radius, angle, "x"),
	    y1: getPosition(radius, angle, "y"),
	    x2: getPosition(innerRadius, angle, "x"),
	    y2: getPosition(innerRadius, angle, "y")
	  } : {
	    style: gridStyle,
	    index: index,
	    datum: tick,
	    cx: 0,
	    cy: 0,
	    r: scale(tickValue),
	    startAngle: startAngle,
	    endAngle: endAngle
	  };
	};
	
	var getAxisLabelProps = function (props, calculatedValues) {
	  var axisType = calculatedValues.axisType,
	      radius = calculatedValues.radius,
	      style = calculatedValues.style,
	      scale = calculatedValues.scale;
	  var axisLabelComponent = props.axisLabelComponent;
	
	  if (axisType !== "radial") {
	    return {};
	  }
	
	  var labelPlacement = axisLabelComponent.props && axisLabelComponent.props.labelPlacement ? axisLabelComponent.props.labelPlacement : props.labelPlacement;
	  var labelStyle = style && style.axisLabel || {};
	  var axisAngle = axisType === "radial" ? getAxisAngle(props, scale) : undefined;
	  var textAngle = labelStyle.angle === undefined ? _victoryCore.LabelHelpers.getPolarAngle((0, _assign2.default)({}, props, {
	    labelPlacement: labelPlacement
	  }), axisAngle) : labelStyle.angle;
	  var labelRadius = radius + (labelStyle.padding || 0);
	
	  var textAnchor = labelStyle.textAnchor || _victoryCore.LabelHelpers.getTextPolarAnchor((0, _assign2.default)({}, props, {
	    labelPlacement: labelPlacement
	  }), axisAngle);
	
	  var verticalAnchor = labelStyle.verticalAnchor || _victoryCore.LabelHelpers.getPolarVerticalAnchor((0, _assign2.default)({}, props, {
	    labelPlacement: labelPlacement
	  }), axisAngle);
	
	  return {
	    style: labelStyle,
	    angle: textAngle,
	    textAnchor: textAnchor,
	    verticalAnchor: verticalAnchor,
	    text: props.label,
	    x: getPosition(labelRadius, _victoryCore.Helpers.degreesToRadians(axisAngle), "x"),
	    y: getPosition(labelRadius, _victoryCore.Helpers.degreesToRadians(axisAngle), "y")
	  };
	};
	
	var getAxisProps = function (modifiedProps, calculatedValues) {
	  var style = calculatedValues.style,
	      axisType = calculatedValues.axisType,
	      radius = calculatedValues.radius,
	      scale = calculatedValues.scale;
	  var startAngle = modifiedProps.startAngle,
	      endAngle = modifiedProps.endAngle,
	      _modifiedProps$innerR = modifiedProps.innerRadius,
	      innerRadius = _modifiedProps$innerR === void 0 ? 0 : _modifiedProps$innerR;
	  var axisAngle = axisType === "radial" ? _victoryCore.Helpers.degreesToRadians(getAxisAngle(modifiedProps, scale)) : undefined;
	  return axisType === "radial" ? {
	    style: style.axis,
	    x1: getPosition(innerRadius, axisAngle, "x"),
	    x2: getPosition(radius, axisAngle, "x"),
	    y1: getPosition(innerRadius, axisAngle, "y"),
	    y2: getPosition(radius, axisAngle, "y")
	  } : {
	    style: style.axis,
	    cx: 0,
	    cy: 0,
	    r: radius,
	    startAngle: startAngle,
	    endAngle: endAngle
	  };
	};
	
	var getCalculatedValues = function (props) {
	  props = (0, _assign2.default)({
	    polar: true
	  }, props);
	  var defaultStyles = getStyleObject(props);
	  var style = getStyles(props, defaultStyles);
	
	  var padding = _victoryCore.Helpers.getPadding(props);
	
	  var axis = _victoryCore.Axis.getAxis(props);
	
	  var axisType = getAxisType(props);
	  var stringTicks = _victoryCore.Axis.stringTicks(props) ? props.tickValues : undefined;
	
	  var domain = _victoryCore.Axis.getDomain(props, axis);
	
	  var range = getRange(props, axis);
	  var scale = getScale(props);
	
	  var initialTicks = _victoryCore.Axis.getTicks(props, scale);
	
	  var ticks = axisType === "angular" ? filterTicks(initialTicks, scale) : initialTicks;
	
	  var tickFormat = _victoryCore.Axis.getTickFormat(props, scale);
	
	  var radius = getRadius(props);
	  return {
	    axis: axis,
	    style: style,
	    padding: padding,
	    stringTicks: stringTicks,
	    axisType: axisType,
	    scale: scale,
	    ticks: ticks,
	    tickFormat: tickFormat,
	    domain: domain,
	    range: range,
	    radius: radius
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  props = _victoryCore.Axis.modifyProps(props, fallbackProps);
	  var calculatedValues = getCalculatedValues(props);
	  var style = calculatedValues.style,
	      scale = calculatedValues.scale,
	      ticks = calculatedValues.ticks,
	      domain = calculatedValues.domain;
	  var _props = props,
	      width = _props.width,
	      height = _props.height,
	      standalone = _props.standalone,
	      theme = _props.theme,
	      name = _props.name;
	  var axisProps = getAxisProps(props, calculatedValues);
	  var axisLabelProps = getAxisLabelProps(props, calculatedValues);
	  var initialChildProps = {
	    parent: {
	      style: style.parent,
	      ticks: ticks,
	      scale: scale,
	      width: width,
	      height: height,
	      domain: domain,
	      standalone: standalone,
	      theme: theme,
	      name: name
	    }
	  };
	  return ticks.reduce(function (childProps, tick, index) {
	    childProps[index] = {
	      axis: axisProps,
	      axisLabel: axisLabelProps,
	      ticks: getTickProps(props, calculatedValues, tick, index),
	      tickLabels: getTickLabelProps(props, calculatedValues, tick, index),
	      grid: getGridProps(props, calculatedValues, tick, index)
	    };
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	var _helperMethods = __webpack_require__(1895);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	var options = {
	  components: [{
	    name: "axis",
	    index: 0
	  }, {
	    name: "axisLabel",
	    index: 0
	  }, {
	    name: "grid"
	  }, {
	    name: "parent",
	    index: "parent"
	  }, {
	    name: "ticks"
	  }, {
	    name: "tickLabels"
	  }]
	};
	
	var VictoryPolarAxis =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryPolarAxis, _React$Component);
	
	  function VictoryPolarAxis() {
	    _classCallCheck(this, VictoryPolarAxis);
	
	    return _possibleConstructorReturn(this, (VictoryPolarAxis.__proto__ || Object.getPrototypeOf(VictoryPolarAxis)).apply(this, arguments));
	  }
	
	  _createClass(VictoryPolarAxis, [{
	    key: "renderAxisLine",
	    value: function renderAxisLine(props) {
	      var dependentAxis = props.dependentAxis;
	      var axisComponent = dependentAxis ? props.axisComponent : props.circularAxisComponent;
	      var axisProps = this.getComponentProps(axisComponent, "axis", 0);
	      return _react.default.cloneElement(axisComponent, axisProps);
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel(props) {
	      var axisLabelComponent = props.axisLabelComponent,
	          dependentAxis = props.dependentAxis,
	          label = props.label;
	
	      if (!label || !dependentAxis) {
	        return null;
	      }
	
	      var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
	      return _react.default.cloneElement(axisLabelComponent, axisLabelProps);
	    }
	  }, {
	    key: "renderAxis",
	    value: function renderAxis(props) {
	      var _this = this;
	
	      var tickComponent = props.tickComponent,
	          tickLabelComponent = props.tickLabelComponent,
	          name = props.name;
	
	      var shouldRender = function (componentProps) {
	        var _componentProps$style = componentProps.style,
	            style = _componentProps$style === void 0 ? {} : _componentProps$style,
	            _componentProps$event = componentProps.events,
	            events = _componentProps$event === void 0 ? {} : _componentProps$event;
	        var visible = style.stroke !== "transparent" && style.stroke !== "none" && style.strokeWidth !== 0;
	        return visible || !(0, _isEmpty2.default)(events);
	      };
	
	      var axisType = props.dependentAxis ? "radial" : "angular";
	      var gridComponent = axisType === "radial" ? props.circularGridComponent : props.gridComponent;
	      var tickComponents = this.dataKeys.map(function (key, index) {
	        var tickProps = (0, _assign2.default)({
	          key: "".concat(name, "-tick-").concat(key)
	        }, _this.getComponentProps(tickComponent, "ticks", index));
	
	        var TickComponent = _react.default.cloneElement(tickComponent, tickProps);
	
	        return shouldRender(TickComponent.props) ? TickComponent : undefined;
	      }).filter(Boolean);
	      var gridComponents = this.dataKeys.map(function (key, index) {
	        var gridProps = (0, _assign2.default)({
	          key: "".concat(name, "-grid-").concat(key)
	        }, _this.getComponentProps(gridComponent, "grid", index));
	
	        var GridComponent = _react.default.cloneElement(gridComponent, gridProps);
	
	        return shouldRender(GridComponent.props) ? GridComponent : undefined;
	      }).filter(Boolean);
	      var tickLabelComponents = this.dataKeys.map(function (key, index) {
	        var tickLabelProps = (0, _assign2.default)({
	          key: "".concat(name, "-tick-").concat(key)
	        }, _this.getComponentProps(tickLabelComponent, "tickLabels", index));
	        return _react.default.cloneElement(tickLabelComponent, tickLabelProps);
	      });
	      var axis = this.renderAxisLine(props);
	      var axisLabel = this.renderLabel(props);
	      var children = [axis, axisLabel].concat(_toConsumableArray(tickComponents), _toConsumableArray(gridComponents), _toConsumableArray(tickLabelComponents));
	      return this.renderGroup(props, children);
	    } // Overridden in victory-native
	
	  }, {
	    key: "renderGroup",
	    value: function renderGroup(props, children) {
	      var groupComponent = props.groupComponent;
	      var groupComponentProps = groupComponent.props || {};
	
	      var origin = _victoryCore.Helpers.getPolarOrigin(props);
	
	      var transform = groupComponentProps.transform || "translate(".concat(origin.x, ", ").concat(origin.y, ")");
	      return _react.default.cloneElement(groupComponent, {
	        transform: transform
	      }, children);
	    }
	  }, {
	    key: "shouldAnimate",
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryPolarAxis.animationWhitelist;
	
	      var props = _victoryCore.Axis.modifyProps(this.props, fallbackProps);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderAxis(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryPolarAxis;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryPolarAxis, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["style", "domain", "range", "tickCount", "tickValues", "padding", "width", "height"]
	});
	Object.defineProperty(VictoryPolarAxis, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryAxis"
	});
	Object.defineProperty(VictoryPolarAxis, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "axis"
	});
	Object.defineProperty(VictoryPolarAxis, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    onExit: {
	      duration: 500
	    },
	    onEnter: {
	      duration: 500
	    }
	  }
	});
	Object.defineProperty(VictoryPolarAxis, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, {
	    axisAngle: _propTypes.default.number,
	    axisComponent: _propTypes.default.element,
	    axisLabelComponent: _propTypes.default.element,
	    axisValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object]),
	    categories: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.shape({
	      x: _propTypes.default.arrayOf(_propTypes.default.string),
	      y: _propTypes.default.arrayOf(_propTypes.default.string)
	    })]),
	    circularAxisComponent: _propTypes.default.element,
	    circularGridComponent: _propTypes.default.element,
	    containerComponent: _propTypes.default.element,
	    dependentAxis: _propTypes.default.bool,
	    endAngle: _propTypes.default.number,
	    events: _propTypes.default.arrayOf(_propTypes.default.shape({
	      target: _propTypes.default.oneOf(["axis", "axisLabel", "grid", "ticks", "tickLabels"]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      eventHandlers: _propTypes.default.object
	    })),
	    gridComponent: _propTypes.default.element,
	    innerRadius: _victoryCore.PropTypes.nonNegative,
	    labelPlacement: _propTypes.default.oneOf(["parallel", "perpendicular", "vertical"]),
	    startAngle: _propTypes.default.number,
	    stringMap: _propTypes.default.object,
	    style: _propTypes.default.shape({
	      parent: _propTypes.default.object,
	      axis: _propTypes.default.object,
	      axisLabel: _propTypes.default.object,
	      grid: _propTypes.default.object,
	      ticks: _propTypes.default.object,
	      tickLabels: _propTypes.default.object
	    }),
	    tickComponent: _propTypes.default.element,
	    tickCount: _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.greaterThanZero]),
	    tickFormat: _propTypes.default.oneOfType([_propTypes.default.func, _victoryCore.PropTypes.homogeneousArray]),
	    tickLabelComponent: _propTypes.default.element,
	    tickValues: _victoryCore.PropTypes.homogeneousArray
	  })
	});
	Object.defineProperty(VictoryPolarAxis, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    axisComponent: _react.default.createElement(_victoryCore.LineSegment, {
	      type: "axis"
	    }),
	    axisLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    circularAxisComponent: _react.default.createElement(_victoryCore.Arc, {
	      type: "axis"
	    }),
	    circularGridComponent: _react.default.createElement(_victoryCore.Arc, {
	      type: "grid"
	    }),
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    endAngle: 360,
	    gridComponent: _react.default.createElement(_victoryCore.LineSegment, {
	      type: "grid"
	    }),
	    groupComponent: _react.default.createElement("g", {
	      role: "presentation"
	    }),
	    labelPlacement: "parallel",
	    startAngle: 0,
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale,
	    tickComponent: _react.default.createElement(_victoryCore.LineSegment, {
	      type: "tick"
	    }),
	    tickLabelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null)
	  }
	});
	Object.defineProperty(VictoryPolarAxis, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Axis.getDomain
	});
	Object.defineProperty(VictoryPolarAxis, "getAxis", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Axis.getAxis
	});
	Object.defineProperty(VictoryPolarAxis, "getScale", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getScale
	});
	Object.defineProperty(VictoryPolarAxis, "getStyles", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getStyles)(props, fallbackProps.style);
	  }
	});
	Object.defineProperty(VictoryPolarAxis, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryPolarAxis, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["axisComponent", "circularAxisComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent", "circularGridComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryPolarAxis, options);
	
	exports.default = _default;

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSymbol = exports.getBubbleSize = exports.getSize = exports.getBaseProps = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _values2 = _interopRequireDefault(__webpack_require__(193));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var getSymbol = function (data, props) {
	  if (props.bubbleProperty) {
	    return "circle";
	  }
	
	  return data.symbol || props.symbol;
	};
	
	exports.getSymbol = getSymbol;
	
	var getBubbleSize = function (datum, props) {
	  var data = props.data,
	      z = props.z,
	      maxBubbleSize = props.maxBubbleSize,
	      minBubbleSize = props.minBubbleSize;
	  var zData = data.map(function (point) {
	    return point[z];
	  });
	  var zMin = Math.min.apply(Math, _toConsumableArray(zData));
	  var zMax = Math.max.apply(Math, _toConsumableArray(zData));
	
	  var getMaxRadius = function () {
	    var minPadding = Math.min.apply(Math, _toConsumableArray((0, _values2.default)(_victoryCore.Helpers.getPadding(props))));
	    return Math.max(minPadding, 5); // eslint-disable-line no-magic-numbers
	  };
	
	  var maxRadius = maxBubbleSize || getMaxRadius();
	  var minRadius = minBubbleSize || maxRadius * 0.1; // eslint-disable-line no-magic-numbers
	
	  if (zMax === zMin) {
	    return Math.max(minRadius, 1);
	  }
	
	  var maxArea = Math.PI * Math.pow(maxRadius, 2);
	  var minArea = Math.PI * Math.pow(minRadius, 2);
	  var pointArea = (datum[z] - zMin) / (zMax - zMin) * maxArea;
	  var area = Math.max(pointArea, minArea);
	  var radius = Math.sqrt(area / Math.PI);
	  return Math.max(radius, 1);
	};
	
	exports.getBubbleSize = getBubbleSize;
	
	var getSize = function (datum, props) {
	  var size = props.size,
	      z = props.z;
	
	  if (datum.size) {
	    return typeof datum.size === "function" ? datum.size : Math.max(datum.size, 1);
	  } else if (typeof props.size === "function") {
	    return size;
	  } else if (datum[z]) {
	    return getBubbleSize(datum, props);
	  } else {
	    return Math.max(size || 0, 1);
	  }
	};
	
	exports.getSize = getSize;
	
	var getCalculatedValues = function (props) {
	  var defaultStyles = props.theme && props.theme.scatter && props.theme.scatter.style ? props.theme.scatter.style : {};
	
	  var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	
	  var data = _victoryCore.Data.getData(props);
	
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var domain = {
	    x: _victoryCore.Domain.getDomain(props, "x"),
	    y: _victoryCore.Domain.getDomain(props, "y")
	  };
	  var scale = {
	    x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var origin = props.polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	  var z = props.bubbleProperty || "z";
	  return {
	    domain: domain,
	    data: data,
	    scale: scale,
	    style: style,
	    origin: origin,
	    z: z
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "scatter");
	
	  props = (0, _assign2.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      data = _props.data,
	      domain = _props.domain,
	      events = _props.events,
	      height = _props.height,
	      origin = _props.origin,
	      padding = _props.padding,
	      polar = _props.polar,
	      scale = _props.scale,
	      name = _props.name,
	      sharedEvents = _props.sharedEvents,
	      standalone = _props.standalone,
	      style = _props.style,
	      theme = _props.theme,
	      width = _props.width,
	      labels = _props.labels,
	      horizontal = _props.horizontal;
	  var initialChildProps = {
	    parent: {
	      style: style.parent,
	      scale: scale,
	      domain: domain,
	      data: data,
	      height: height,
	      width: width,
	      standalone: standalone,
	      theme: theme,
	      origin: origin,
	      polar: polar,
	      padding: padding,
	      name: name,
	      horizontal: horizontal
	    }
	  };
	  return data.reduce(function (childProps, datum, index) {
	    var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	
	    var _Helpers$scalePoint = _victoryCore.Helpers.scalePoint(props, datum),
	        x = _Helpers$scalePoint.x,
	        y = _Helpers$scalePoint.y;
	
	    var dataProps = {
	      x: x,
	      y: y,
	      datum: datum,
	      data: data,
	      index: index,
	      scale: scale,
	      polar: polar,
	      origin: origin,
	      horizontal: horizontal,
	      size: getSize(datum, props),
	      symbol: getSymbol(datum, props),
	      style: style.data
	    };
	    childProps[eventKey] = {
	      data: dataProps
	    };
	
	    var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	
	    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
	      childProps[eventKey].labels = _victoryCore.LabelHelpers.getProps(props, index);
	    }
	
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryScatter", {
	  enumerable: true,
	  get: function () {
	    return _victoryScatter.default;
	  }
	});
	
	var _victoryScatter = _interopRequireDefault(__webpack_require__(1899));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _helperMethods = __webpack_require__(1897);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  size: 3,
	  symbol: "circle"
	};
	
	var VictoryScatter =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryScatter, _React$Component);
	
	  function VictoryScatter() {
	    _classCallCheck(this, VictoryScatter);
	
	    return _possibleConstructorReturn(this, (VictoryScatter.__proto__ || Object.getPrototypeOf(VictoryScatter)).apply(this, arguments));
	  }
	
	  _createClass(VictoryScatter, [{
	    key: "shouldAnimate",
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryScatter.animationWhitelist,
	          role = VictoryScatter.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryScatter;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryScatter, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "domain", "height", "maxBubbleSize", "padding", "samples", "size", "style", "width"]
	});
	Object.defineProperty(VictoryScatter, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryScatter"
	});
	Object.defineProperty(VictoryScatter, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "scatter"
	});
	Object.defineProperty(VictoryScatter, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.discreteTransitions()
	});
	Object.defineProperty(VictoryScatter, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    bubbleProperty: _propTypes.default.string,
	    maxBubbleSize: _victoryCore.PropTypes.nonNegative,
	    minBubbleSize: _victoryCore.PropTypes.nonNegative,
	    size: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    symbol: _propTypes.default.oneOfType([_propTypes.default.oneOf(["circle", "diamond", "plus", "minus", "square", "star", "triangleDown", "triangleUp"]), _propTypes.default.func])
	  })
	});
	Object.defineProperty(VictoryScatter, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    dataComponent: _react.default.createElement(_victoryCore.Point, null),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    groupComponent: _react.default.createElement("g", null),
	    samples: 50,
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryScatter, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Domain.getDomain
	});
	Object.defineProperty(VictoryScatter, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Data.getData
	});
	Object.defineProperty(VictoryScatter, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryScatter, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryScatter);
	
	exports.default = _default;

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.selectionContainerMixin = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _selectionHelpers = _interopRequireDefault(__webpack_require__(688));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var selectionContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_base) {
	    _inherits(VictorySelectionContainer, _base);
	
	    function VictorySelectionContainer() {
	      _classCallCheck(this, VictorySelectionContainer);
	
	      return _possibleConstructorReturn(this, (VictorySelectionContainer.__proto__ || Object.getPrototypeOf(VictorySelectionContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictorySelectionContainer, [{
	      key: "getRect",
	      value: function getRect(props) {
	        var x1 = props.x1,
	            x2 = props.x2,
	            y1 = props.y1,
	            y2 = props.y2,
	            selectionStyle = props.selectionStyle,
	            selectionComponent = props.selectionComponent,
	            name = props.name;
	        var width = Math.abs(x2 - x1) || 1;
	        var height = Math.abs(y2 - y1) || 1;
	        var x = Math.min(x1, x2);
	        var y = Math.min(y1, y2);
	        return y2 && x2 && x1 && y1 ? _react.default.cloneElement(selectionComponent, {
	          key: "".concat(name, "-selection"),
	          x: x,
	          y: y,
	          width: width,
	          height: height,
	          style: selectionStyle
	        }) : null;
	      } // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        return _toConsumableArray(_react.default.Children.toArray(props.children)).concat([this.getRect(props)]);
	      }
	    }]);
	
	    return VictorySelectionContainer;
	  }(base), Object.defineProperty(_class, "displayName", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: "VictorySelectionContainer"
	  }), Object.defineProperty(_class, "propTypes", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.propTypes, {
	      activateSelectedData: _propTypes.default.bool,
	      allowSelection: _propTypes.default.bool,
	      disable: _propTypes.default.bool,
	      onSelection: _propTypes.default.func,
	      onSelectionCleared: _propTypes.default.func,
	      selectionBlacklist: _propTypes.default.arrayOf(_propTypes.default.string),
	      selectionComponent: _propTypes.default.element,
	      selectionDimension: _propTypes.default.oneOf(["x", "y"]),
	      selectionStyle: _propTypes.default.object
	    })
	  }), Object.defineProperty(_class, "defaultProps", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.defaultProps, {
	      activateSelectedData: true,
	      allowSelection: true,
	      selectionComponent: _react.default.createElement(_victoryCore.Rect, null),
	      selectionStyle: {
	        stroke: "transparent",
	        fill: "black",
	        fillOpacity: 0.1
	      }
	    })
	  }), Object.defineProperty(_class, "defaultEvents", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function (props) {
	      return [{
	        target: "parent",
	        eventHandlers: {
	          onMouseDown: function (evt, targetProps) {
	            return props.disable ? {} : _selectionHelpers.default.onMouseDown(evt, targetProps);
	          },
	          onTouchStart: function (evt, targetProps) {
	            return props.disable ? {} : _selectionHelpers.default.onMouseDown(evt, targetProps);
	          },
	          onMouseMove: function (evt, targetProps) {
	            return props.disable ? {} : _selectionHelpers.default.onMouseMove(evt, targetProps);
	          },
	          onTouchMove: function (evt, targetProps) {
	            return props.disable ? {} : _selectionHelpers.default.onMouseMove(evt, targetProps);
	          },
	          onMouseUp: function (evt, targetProps) {
	            return props.disable ? {} : _selectionHelpers.default.onMouseUp(evt, targetProps);
	          },
	          onTouchEnd: function (evt, targetProps) {
	            return props.disable ? {} : _selectionHelpers.default.onMouseUp(evt, targetProps);
	          }
	        }
	      }];
	    }
	  }), _temp;
	};
	
	exports.selectionContainerMixin = selectionContainerMixin;
	
	var _default = selectionContainerMixin(_victoryCore.VictoryContainer);
	
	exports.default = _default;

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _fromPairs2 = _interopRequireDefault(__webpack_require__(1368));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var VictorySharedEvents =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictorySharedEvents, _React$Component);
	
	  function VictorySharedEvents(props) {
	    var _this;
	
	    _classCallCheck(this, VictorySharedEvents);
	
	    _this = _possibleConstructorReturn(this, (VictorySharedEvents.__proto__ || Object.getPrototypeOf(VictorySharedEvents)).call(this, props));
	    _this.state = _this.state || {};
	    _this.getScopedEvents = _victoryCore.Events.getScopedEvents.bind(_assertThisInitialized(_this));
	    _this.getEventState = _victoryCore.Events.getEventState.bind(_assertThisInitialized(_this));
	    _this.getTimer = _this.getTimer.bind(_assertThisInitialized(_this));
	    _this.baseProps = _this.getBaseProps(props);
	    return _this;
	  }
	
	  _createClass(VictorySharedEvents, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        getTimer: this.getTimer
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      if (!(0, _reactFastCompare.default)(this.props, nextProps)) {
	        this.baseProps = this.getBaseProps(nextProps);
	        var externalMutations = this.getExternalMutations(nextProps, this.baseProps);
	        this.applyExternalMutations(nextProps, externalMutations);
	      }
	
	      return true;
	    }
	  }, {
	    key: "getTimer",
	    value: function getTimer() {
	      if (this.context.getTimer) {
	        return this.context.getTimer();
	      }
	
	      if (!this.timer) {
	        this.timer = new _victoryCore.Timer();
	      }
	
	      return this.timer;
	    }
	  }, {
	    key: "getAllEvents",
	    value: function getAllEvents(props) {
	      var components = ["container", "groupComponent"];
	
	      var componentEvents = _victoryCore.Events.getComponentEvents(props, components);
	
	      if (Array.isArray(componentEvents)) {
	        return Array.isArray(props.events) ? componentEvents.concat.apply(componentEvents, _toConsumableArray(props.events)) : componentEvents;
	      }
	
	      return props.events;
	    }
	  }, {
	    key: "applyExternalMutations",
	    value: function applyExternalMutations(props, externalMutations) {
	      if (!(0, _isEmpty2.default)(externalMutations)) {
	        var callbacks = props.externalEventMutations.reduce(function (memo, mutation) {
	          memo = (0, _isFunction2.default)(mutation.callback) ? memo.concat(mutation.callback) : memo;
	          return memo;
	        }, []);
	        var compiledCallbacks = callbacks.length ? function () {
	          callbacks.forEach(function (c) {
	            return c();
	          });
	        } : undefined;
	        this.setState(externalMutations, compiledCallbacks);
	      }
	    }
	  }, {
	    key: "getExternalMutations",
	    value: function getExternalMutations(props, baseProps) {
	      return !(0, _isEmpty2.default)(props.externalEventMutations) ? _victoryCore.Events.getExternalMutationsWithChildren(props.externalEventMutations, baseProps, this.state, Object.keys(baseProps)) : undefined;
	    }
	  }, {
	    key: "getBaseProps",
	    value: function getBaseProps(props) {
	      var container = props.container;
	
	      var children = _react.default.Children.toArray(this.props.children);
	
	      var childBaseProps = this.getBasePropsFromChildren(children);
	      var parentBaseProps = container ? container.props : {};
	      return (0, _assign2.default)({}, childBaseProps, {
	        parent: parentBaseProps
	      });
	    }
	  }, {
	    key: "getBasePropsFromChildren",
	    value: function getBasePropsFromChildren(childComponents) {
	      var iteratee = function (child, childName) {
	        if (child.type && (0, _isFunction2.default)(child.type.getBaseProps)) {
	          var _baseProps = child.props && child.type.getBaseProps(child.props);
	
	          return _baseProps ? [[childName, _baseProps]] : null;
	        } else {
	          return null;
	        }
	      };
	
	      var baseProps = _victoryCore.Helpers.reduceChildren(childComponents, iteratee);
	
	      return (0, _fromPairs2.default)(baseProps);
	    }
	  }, {
	    key: "getNewChildren",
	    value: function getNewChildren(props, baseProps) {
	      var _this2 = this;
	
	      var events = props.events,
	          eventKey = props.eventKey;
	
	      var alterChildren = function (children, childNames) {
	        return children.reduce(function (memo, child, index) {
	          if (child.props.children) {
	            var newChildren = _react.default.Children.toArray(child.props.children);
	
	            var names = childNames.slice(index, index + newChildren.length);
	
	            var results = _react.default.cloneElement(child, child.props, alterChildren(newChildren, names));
	
	            return memo.concat(results);
	          } else if (child.type && (0, _isFunction2.default)(child.type.getBaseProps)) {
	            var name = child.props.name || childNames[index];
	            var childEvents = Array.isArray(events) && events.filter(function (event) {
	              if (event.target === "parent") {
	                return false;
	              }
	
	              return Array.isArray(event.childName) ? event.childName.indexOf(name) > -1 : event.childName === name || event.childName === "all";
	            });
	            var sharedEvents = {
	              events: childEvents,
	              // partially apply child name and baseProps,
	              getEvents: function (evts, target) {
	                return _this2.getScopedEvents(evts, target, name, baseProps);
	              },
	              // partially apply child name
	              getEventState: function (key, target) {
	                return _this2.getEventState(key, target, name);
	              }
	            };
	            return memo.concat(_react.default.cloneElement(child, (0, _assign2.default)({
	              key: "events-".concat(name),
	              sharedEvents: sharedEvents,
	              eventKey: eventKey,
	              name: name
	            }, child.props)));
	          } else {
	            return memo.concat(child);
	          }
	        }, []);
	      };
	
	      var childNames = Object.keys(baseProps);
	
	      var childComponents = _react.default.Children.toArray(props.children);
	
	      return alterChildren(childComponents, childNames);
	    }
	  }, {
	    key: "getContainer",
	    value: function getContainer(props, baseProps, events) {
	      var _this3 = this;
	
	      var children = this.getNewChildren(props, baseProps);
	      var parents = Array.isArray(events) && events.filter(function (event) {
	        return event.target === "parent";
	      });
	      var sharedEvents = parents.length > 0 ? {
	        events: parents,
	        // partially apply childName (null) and baseProps,
	        getEvents: function (evts, target) {
	          return _this3.getScopedEvents(evts, target, null, baseProps);
	        },
	        getEventState: this.getEventState
	      } : null;
	      var container = props.container || props.groupComponent;
	      var role = container.type && container.type.role;
	      var containerProps = container.props || {};
	
	      var boundGetEvents = _victoryCore.Events.getEvents.bind(this);
	
	      var parentEvents = sharedEvents && boundGetEvents({
	        sharedEvents: sharedEvents
	      }, "parent");
	      var parentProps = (0, _defaults2.default)({}, this.getEventState("parent", "parent"), containerProps, baseProps.parent, {
	        children: children
	      });
	      var containerEvents = (0, _defaults2.default)({}, _victoryCore.Events.getPartialEvents(parentEvents, "parent", parentProps), containerProps.events);
	      return role === "container" ? _react.default.cloneElement(container, (0, _assign2.default)({}, parentProps, {
	        events: containerEvents
	      })) : _react.default.cloneElement(container, containerEvents, children);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var events = this.getAllEvents(this.props);
	
	      if (events) {
	        return this.getContainer(this.props, this.baseProps, events);
	      }
	
	      return _react.default.cloneElement(this.props.container, {
	        children: this.props.children
	      });
	    }
	  }]);
	
	  return VictorySharedEvents;
	}(_react.default.Component);
	
	exports.default = VictorySharedEvents;
	Object.defineProperty(VictorySharedEvents, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictorySharedEvents"
	});
	Object.defineProperty(VictorySharedEvents, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "shared-event-wrapper"
	});
	Object.defineProperty(VictorySharedEvents, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	    container: _propTypes.default.node,
	    eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	    events: _propTypes.default.arrayOf(_propTypes.default.shape({
	      childName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	      eventHandlers: _propTypes.default.object,
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      target: _propTypes.default.string
	    })),
	    externalEventMutations: _propTypes.default.arrayOf(_propTypes.default.shape({
	      callback: _propTypes.default.function,
	      childName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	      eventKey: _propTypes.default.oneOfType([_propTypes.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes.default.string]),
	      mutation: _propTypes.default.function,
	      target: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array])
	    })),
	    groupComponent: _propTypes.default.node
	  }
	});
	Object.defineProperty(VictorySharedEvents, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    groupComponent: _react.default.createElement("g", null)
	  }
	});
	Object.defineProperty(VictorySharedEvents, "contextTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    getTimer: _propTypes.default.func
	  }
	});
	Object.defineProperty(VictorySharedEvents, "childContextTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    getTimer: _propTypes.default.func
	  }
	});

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getChildren = getChildren;
	exports.getCalculatedProps = getCalculatedProps;
	
	var _orderBy2 = _interopRequireDefault(__webpack_require__(119));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(56));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	}; // Assumes data in `datasets` is sorted by `Data.getData`.
	
	function fillData(props, datasets) {
	  var fillInMissingData = props.fillInMissingData;
	  var xMap = datasets.reduce(function (prev, dataset) {
	    dataset.forEach(function (datum) {
	      prev[datum._x instanceof Date ? datum._x.getTime() : datum._x] = true;
	    });
	    return prev;
	  }, {});
	  var xKeys = (0, _keys2.default)(xMap).map(function (k) {
	    return +k;
	  });
	  var xArr = (0, _orderBy2.default)(xKeys);
	  return datasets.map(function (dataset) {
	    var indexOffset = 0;
	    var isDate = dataset[0] && dataset[0]._x instanceof Date;
	    var filledInData = xArr.map(function (x, index) {
	      x = +x;
	      var datum = dataset[index - indexOffset];
	
	      if (datum) {
	        var x1 = isDate ? datum._x.getTime() : datum._x;
	
	        if (x1 === x) {
	          return datum;
	        } else {
	          indexOffset++;
	          var y = fillInMissingData ? 0 : null;
	          x = isDate ? new Date(x) : x;
	          return {
	            x: x,
	            y: y,
	            _x: x,
	            _y: y
	          };
	        }
	      } else {
	        var _y = fillInMissingData ? 0 : null;
	
	        x = isDate ? new Date(x) : x;
	        return {
	          x: x,
	          y: _y,
	          _x: x,
	          _y: _y
	        };
	      }
	    });
	    return filledInData;
	  });
	}
	
	function getY0(datum, index, datasets) {
	  if (datum.y0) {
	    return datum.y0;
	  }
	
	  var y = datum._y;
	  var previousDatasets = datasets.slice(0, index);
	  var previousPoints = previousDatasets.reduce(function (prev, dataset) {
	    return prev.concat(dataset.filter(function (previousDatum) {
	      return datum._x instanceof Date ? previousDatum._x.getTime() === datum._x.getTime() : previousDatum._x === datum._x;
	    }).map(function (previousDatum) {
	      return previousDatum._y || 0;
	    }));
	  }, []);
	  var y0 = previousPoints.length && previousPoints.reduce(function (memo, value) {
	    var sameSign = y < 0 && value < 0 || y >= 0 && value >= 0;
	    return sameSign ? +value + memo : memo;
	  }, 0);
	  return previousPoints.some(function (point) {
	    return point instanceof Date;
	  }) ? new Date(y0) : y0;
	}
	/* eslint-disable no-nested-ternary */
	
	
	function addLayoutData(props, datasets, index) {
	  var xOffset = props.xOffset || 0;
	  return datasets[index].map(function (datum) {
	    var yOffset = getY0(datum, index, datasets) || 0;
	    return (0, _assign2.default)({}, datum, {
	      _y0: !(datum._y instanceof Date) ? yOffset : yOffset ? new Date(yOffset) : datum._y,
	      _y1: datum._y === null ? null : datum._y instanceof Date ? new Date(+datum._y + +yOffset) : datum._y + yOffset,
	      _x1: datum._x === null ? null : datum._x instanceof Date ? new Date(+datum._x + +xOffset) : datum._x + xOffset
	    });
	  });
	}
	/* eslint-enable no-nested-ternary */
	
	
	function stackData(props, childComponents) {
	  var dataFromChildren = _victoryCore.Wrapper.getDataFromChildren(props, childComponents);
	
	  var datasets = fillData(props, dataFromChildren);
	  return datasets.map(function (d, i) {
	    return addLayoutData(props, datasets, i);
	  });
	}
	
	function getCalculatedProps(props, childComponents) {
	  childComponents = childComponents || _react.default.Children.toArray(props.children);
	  var role = "stack";
	  props = _victoryCore.Helpers.modifyProps(props, fallbackProps, role);
	
	  var style = _victoryCore.Wrapper.getStyle(props.theme, props.style, role);
	
	  var categories = _victoryCore.Wrapper.getCategories(props, childComponents);
	
	  var datasets = stackData(props, childComponents);
	  var children = childComponents.map(function (c, i) {
	    return _react.default.cloneElement(c, {
	      data: datasets[i]
	    });
	  });
	  var domain = {
	    x: _victoryCore.Wrapper.getDomain((0, _assign2.default)({}, props, {
	      categories: categories
	    }), "x", children),
	    y: _victoryCore.Wrapper.getDomain((0, _assign2.default)({}, props, {
	      categories: categories
	    }), "y", children)
	  };
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var baseScale = {
	    x: _victoryCore.Scale.getScaleFromProps(props, "x") || _victoryCore.Wrapper.getScale(props, "x"),
	    y: _victoryCore.Scale.getScaleFromProps(props, "y") || _victoryCore.Wrapper.getScale(props, "y")
	  };
	  var scale = {
	    x: baseScale.x.domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: baseScale.y.domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var _props = props,
	      colorScale = _props.colorScale,
	      horizontal = _props.horizontal;
	  return {
	    datasets: datasets,
	    categories: categories,
	    range: range,
	    domain: domain,
	    horizontal: horizontal,
	    scale: scale,
	    style: style,
	    colorScale: colorScale,
	    role: role
	  };
	}
	
	function getLabels(props, datasets, index) {
	  if (!props.labels) {
	    return undefined;
	  }
	
	  return datasets.length === index + 1 ? props.labels : undefined;
	}
	
	function getChildProps(props, calculatedProps) {
	  var categories = calculatedProps.categories,
	      domain = calculatedProps.domain,
	      range = calculatedProps.range,
	      scale = calculatedProps.scale,
	      horizontal = calculatedProps.horizontal;
	  return {
	    height: props.height,
	    width: props.width,
	    padding: _victoryCore.Helpers.getPadding(props),
	    standalone: false,
	    theme: props.theme,
	    categories: categories,
	    domain: domain,
	    range: range,
	    scale: scale,
	    horizontal: horizontal
	  };
	}
	
	function getColorScale(props, child) {
	  var role = child.type && child.type.role;
	  var colorScaleOptions = child.props.colorScale || props.colorScale;
	
	  if (role !== "group" && role !== "stack") {
	    return undefined;
	  }
	
	  return props.theme ? colorScaleOptions || props.theme.props.colorScale : colorScaleOptions;
	}
	
	function getChildren(props, childComponents, calculatedProps) {
	  props = _victoryCore.Helpers.modifyProps(props, fallbackProps, "stack");
	  childComponents = childComponents || _react.default.Children.toArray(props.children);
	  calculatedProps = calculatedProps || getCalculatedProps(props, childComponents);
	  var _calculatedProps = calculatedProps,
	      datasets = _calculatedProps.datasets;
	  var childProps = getChildProps(props, calculatedProps);
	  var parentName = props.name || "stack";
	  return childComponents.map(function (child, index) {
	    var role = child.type && child.type.role;
	    var data = datasets[index];
	
	    var style = _victoryCore.Wrapper.getChildStyle(child, index, calculatedProps);
	
	    var labels = props.labels ? getLabels(props, datasets, index) : child.props.labels;
	    var name = child.props.name || "".concat(parentName, "-").concat(role, "-").concat(index);
	    return _react.default.cloneElement(child, (0, _assign2.default)({
	      key: "".concat(name, "-key-").concat(index),
	      labels: labels,
	      name: name,
	      domainPadding: child.props.domainPadding || props.domainPadding,
	      theme: props.theme,
	      labelComponent: props.labelComponent || child.props.labelComponent,
	      style: style,
	      colorScale: getColorScale(props, child),
	      data: data,
	      polar: props.polar
	    }, childProps));
	  });
	}

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryStack", {
	  enumerable: true,
	  get: function () {
	    return _victoryStack.default;
	  }
	});
	
	var _victoryStack = _interopRequireDefault(__webpack_require__(1904));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(35));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _victorySharedEvents = __webpack_require__(215);
	
	var _helperMethods = __webpack_require__(1902);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(59));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var VictoryStack =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryStack, _React$Component);
	
	  function VictoryStack(props) {
	    var _this;
	
	    _classCallCheck(this, VictoryStack);
	
	    _this = _possibleConstructorReturn(this, (VictoryStack.__proto__ || Object.getPrototypeOf(VictoryStack)).call(this, props));
	
	    if (props.animate) {
	      _this.state = {
	        nodesShouldLoad: false,
	        nodesDoneLoad: false,
	        animating: true
	      };
	      _this.setAnimationState = _victoryCore.Wrapper.setAnimationState.bind(_assertThisInitialized(_this));
	    }
	
	    return _this;
	  }
	
	  _createClass(VictoryStack, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      if (this.props.animate) {
	        if (!(0, _reactFastCompare.default)(this.props, nextProps)) {
	          this.setAnimationState(this.props, nextProps);
	          return false;
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: "getNewChildren",
	    value: function getNewChildren(props, childComponents, calculatedProps) {
	      var children = (0, _helperMethods.getChildren)(props, childComponents, calculatedProps);
	
	      var getAnimationProps = _victoryCore.Wrapper.getAnimationProps.bind(this);
	
	      var newChildren = children.map(function (child, index) {
	        var childProps = (0, _assign2.default)({
	          animate: getAnimationProps(props, child, index)
	        }, child.props);
	        return _react.default.cloneElement(child, childProps);
	      });
	      /*
	        reverse render order for children of `VictoryStack` so that higher children in the stack
	        are rendered behind lower children. This looks nicer for stacked bars with cornerRadius, and
	        areas with strokes
	      */
	
	      return newChildren.reverse();
	    }
	  }, {
	    key: "renderContainer",
	    value: function renderContainer(containerComponent, props) {
	      var containerProps = (0, _defaults2.default)({}, containerComponent.props, props);
	      return _react.default.cloneElement(containerComponent, containerProps);
	    }
	  }, {
	    key: "getContainerProps",
	    value: function getContainerProps(props, calculatedProps) {
	      var width = props.width,
	          height = props.height,
	          standalone = props.standalone,
	          theme = props.theme,
	          polar = props.polar,
	          horizontal = props.horizontal,
	          name = props.name;
	      var domain = calculatedProps.domain,
	          scale = calculatedProps.scale,
	          style = calculatedProps.style,
	          origin = calculatedProps.origin;
	      return {
	        domain: domain,
	        scale: scale,
	        width: width,
	        height: height,
	        standalone: standalone,
	        theme: theme,
	        style: style.parent,
	        horizontal: horizontal,
	        polar: polar,
	        origin: origin,
	        name: name
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	      var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
	
	      var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, role);
	
	      var eventKey = modifiedProps.eventKey,
	          containerComponent = modifiedProps.containerComponent,
	          standalone = modifiedProps.standalone,
	          groupComponent = modifiedProps.groupComponent,
	          externalEventMutations = modifiedProps.externalEventMutations;
	
	      var childComponents = _react.default.Children.toArray(modifiedProps.children);
	
	      var calculatedProps = (0, _helperMethods.getCalculatedProps)(modifiedProps, childComponents);
	      var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
	      var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
	      var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
	
	      var events = _victoryCore.Wrapper.getAllEvents(props);
	
	      if (!(0, _isEmpty2.default)(events)) {
	        return _react.default.createElement(_victorySharedEvents.VictorySharedEvents, {
	          container: container,
	          eventKey: eventKey,
	          events: events,
	          externalEventMutations: externalEventMutations
	        }, newChildren);
	      }
	
	      return _react.default.cloneElement(container, container.props, newChildren);
	    }
	  }]);
	
	  return VictoryStack;
	}(_react.default.Component);
	
	exports.default = VictoryStack;
	Object.defineProperty(VictoryStack, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryStack"
	});
	Object.defineProperty(VictoryStack, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "stack"
	});
	Object.defineProperty(VictoryStack, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, {
	    categories: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.shape({
	      x: _propTypes.default.arrayOf(_propTypes.default.string),
	      y: _propTypes.default.arrayOf(_propTypes.default.string)
	    })]),
	    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	    colorScale: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
	    fillInMissingData: _propTypes.default.bool,
	    horizontal: _propTypes.default.bool,
	    labelComponent: _propTypes.default.element,
	    labels: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array]),
	    style: _propTypes.default.shape({
	      parent: _propTypes.default.object,
	      data: _propTypes.default.object,
	      labels: _propTypes.default.object
	    }),
	    xOffset: _propTypes.default.number
	  })
	});
	Object.defineProperty(VictoryStack, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    groupComponent: _react.default.createElement("g", null),
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale,
	    fillInMissingData: true
	  }
	});
	Object.defineProperty(VictoryStack, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["groupComponent", "containerComponent", "labelComponent"]
	});
	Object.defineProperty(VictoryStack, "getChildren", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _helperMethods.getChildren
	});

/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _orderBy2 = _interopRequireDefault(__webpack_require__(119));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(67));
	
	var _uniqueId2 = _interopRequireDefault(__webpack_require__(276));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _victoryCore = __webpack_require__(19);
	
	var _flyout = _interopRequireDefault(__webpack_require__(689));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  cornerRadius: 5,
	  pointerLength: 10,
	  pointerWidth: 10
	};
	
	var VictoryTooltip =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryTooltip, _React$Component);
	
	  function VictoryTooltip(props) {
	    var _this;
	
	    _classCallCheck(this, VictoryTooltip);
	
	    _this = _possibleConstructorReturn(this, (VictoryTooltip.__proto__ || Object.getPrototypeOf(VictoryTooltip)).call(this, props));
	    _this.id = props.id === undefined ? (0, _uniqueId2.default)("tooltip-") : props.id;
	    return _this;
	  }
	
	  _createClass(VictoryTooltip, [{
	    key: "getDefaultOrientation",
	    value: function getDefaultOrientation(props) {
	      var datum = props.datum,
	          horizontal = props.horizontal,
	          polar = props.polar;
	
	      if (!polar) {
	        var positive = horizontal ? "right" : "top";
	        var negative = horizontal ? "left" : "bottom";
	        return datum && datum.y < 0 ? negative : positive;
	      } else {
	        return this.getPolarOrientation(props, datum);
	      }
	    }
	  }, {
	    key: "getPolarOrientation",
	    value: function getPolarOrientation(props, datum) {
	      var degrees = _victoryCore.LabelHelpers.getDegrees(props, datum);
	
	      var placement = props.labelPlacement || "vertical";
	
	      if (placement === " vertical") {
	        return this.getVerticalOrientations(degrees);
	      } else if (placement === "parallel") {
	        return degrees < 90 || degrees > 270 ? "right" : "left";
	      } else {
	        return degrees > 180 ? "bottom" : "top";
	      }
	    }
	  }, {
	    key: "getVerticalOrientations",
	    value: function getVerticalOrientations(degrees) {
	      // eslint-disable-next-line no-magic-numbers
	      if (degrees < 45 || degrees > 315) {
	        return "right"; // eslint-disable-next-line no-magic-numbers
	      } else if (degrees >= 45 && degrees <= 135) {
	        return "top"; // eslint-disable-next-line no-magic-numbers
	      } else if (degrees > 135 && degrees < 225) {
	        return "left";
	      } else {
	        return "bottom";
	      }
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles(props) {
	      var theme = props.theme || _victoryCore.VictoryTheme.grayscale;
	      var defaultLabelStyles = theme && theme.tooltip && theme.tooltip.style ? theme.tooltip.style : {};
	      var baseLabelStyle = Array.isArray(props.style) ? props.style.map(function (s) {
	        return (0, _defaults2.default)({}, s, defaultLabelStyles);
	      }) : (0, _defaults2.default)({}, props.style, defaultLabelStyles);
	      var defaultFlyoutStyles = theme && theme.tooltip && theme.tooltip.flyoutStyle ? theme.tooltip.flyoutStyle : {};
	      var baseFlyoutStyle = props.flyoutStyle ? (0, _defaults2.default)({}, props.flyoutStyle, defaultFlyoutStyles) : defaultFlyoutStyles;
	      var style = Array.isArray(baseLabelStyle) ? baseLabelStyle.map(function (s) {
	        return _victoryCore.Helpers.evaluateStyle(s, props);
	      }) : _victoryCore.Helpers.evaluateStyle(baseLabelStyle, props);
	
	      var flyoutStyle = _victoryCore.Helpers.evaluateStyle(baseFlyoutStyle, (0, _assign2.default)({}, props, {
	        style: style
	      }));
	
	      return {
	        style: style,
	        flyoutStyle: flyoutStyle
	      };
	    }
	  }, {
	    key: "getEvaluatedProps",
	    value: function getEvaluatedProps(props) {
	      var horizontal = props.horizontal,
	          pointerLength = props.pointerLength,
	          pointerWidth = props.pointerWidth,
	          cornerRadius = props.cornerRadius,
	          centerOffset = props.centerOffset,
	          dx = props.dx,
	          dy = props.dy;
	
	      var active = _victoryCore.Helpers.evaluateProp(props.active, props);
	
	      var text = _victoryCore.Helpers.evaluateProp(props.text, (0, _assign2.default)({}, props, {
	        active: active
	      }));
	
	      var _getStyles = this.getStyles((0, _assign2.default)({}, props, {
	        active: active,
	        text: text
	      })),
	          style = _getStyles.style,
	          flyoutStyle = _getStyles.flyoutStyle;
	
	      var orientation = _victoryCore.Helpers.evaluateProp(props.orientation, (0, _assign2.default)({}, props, {
	        active: active,
	        text: text,
	        style: style,
	        flyoutStyle: flyoutStyle
	      })) || this.getDefaultOrientation(props);
	
	      var labelSize = _victoryCore.TextSize.approximateTextSize(text, style);
	
	      var _getDimensions = this.getDimensions((0, _assign2.default)({}, props, {
	        style: style,
	        flyoutStyle: flyoutStyle,
	        active: active,
	        text: text,
	        orientation: orientation
	      }), labelSize),
	          flyoutHeight = _getDimensions.flyoutHeight,
	          flyoutWidth = _getDimensions.flyoutWidth;
	
	      var evaluatedProps = (0, _assign2.default)({}, props, {
	        active: active,
	        text: text,
	        style: style,
	        flyoutStyle: flyoutStyle,
	        orientation: orientation,
	        flyoutHeight: flyoutHeight,
	        flyoutWidth: flyoutWidth
	      });
	      var offsetX = (0, _isPlainObject2.default)(centerOffset) && centerOffset.x !== undefined ? _victoryCore.Helpers.evaluateProp(centerOffset.x, evaluatedProps) : 0;
	      var offsetY = (0, _isPlainObject2.default)(centerOffset) && centerOffset.y !== undefined ? _victoryCore.Helpers.evaluateProp(centerOffset.y, evaluatedProps) : 0;
	      var padding = flyoutStyle && flyoutStyle.padding || 0;
	      var defaultDx = horizontal ? padding : 0;
	      var defaultDy = horizontal ? 0 : padding;
	      return (0, _assign2.default)({}, props, {
	        active: active,
	        text: text,
	        style: style,
	        flyoutStyle: flyoutStyle,
	        orientation: orientation,
	        flyoutHeight: flyoutHeight,
	        flyoutWidth: flyoutWidth,
	        centerOffset: {
	          x: offsetX,
	          y: offsetY
	        },
	        dx: dx !== undefined ? _victoryCore.Helpers.evaluateProp(dx, evaluatedProps) : defaultDx,
	        dy: dy !== undefined ? _victoryCore.Helpers.evaluateProp(dy, evaluatedProps) : defaultDy,
	        cornerRadius: _victoryCore.Helpers.evaluateProp(cornerRadius, evaluatedProps),
	        pointerLength: _victoryCore.Helpers.evaluateProp(pointerLength, evaluatedProps),
	        pointerWidth: _victoryCore.Helpers.evaluateProp(pointerWidth, evaluatedProps)
	      });
	    }
	  }, {
	    key: "getCalculatedValues",
	    value: function getCalculatedValues(props) {
	      var style = props.style,
	          text = props.text,
	          flyoutStyle = props.flyoutStyle,
	          flyoutHeight = props.flyoutHeight,
	          flyoutWidth = props.flyoutWidth;
	
	      var labelSize = _victoryCore.TextSize.approximateTextSize(text, style);
	
	      var flyoutDimensions = {
	        height: flyoutHeight,
	        width: flyoutWidth
	      };
	      var flyoutCenter = this.getFlyoutCenter(props, flyoutDimensions);
	      var transform = this.getTransform(props);
	      return {
	        style: style,
	        flyoutStyle: flyoutStyle,
	        labelSize: labelSize,
	        flyoutDimensions: flyoutDimensions,
	        flyoutCenter: flyoutCenter,
	        transform: transform
	      };
	    }
	  }, {
	    key: "getTransform",
	    value: function getTransform(props) {
	      var x = props.x,
	          y = props.y,
	          style = props.style;
	      var labelStyle = style || {};
	      var angle = labelStyle.angle || props.angle || this.getDefaultAngle(props);
	      return angle ? "rotate(".concat(angle, " ").concat(x, " ").concat(y, ")") : undefined;
	    } // eslint-disable-next-line complexity
	
	  }, {
	    key: "getDefaultAngle",
	    value: function getDefaultAngle(props) {
	      var polar = props.polar,
	          labelPlacement = props.labelPlacement,
	          orientation = props.orientation,
	          datum = props.datum;
	
	      if (!polar || !labelPlacement || labelPlacement === "vertical") {
	        return 0;
	      }
	
	      var degrees = _victoryCore.LabelHelpers.getDegrees(props, datum);
	
	      var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
	      var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
	      var angle;
	
	      if (degrees === 0 || degrees === 180) {
	        angle = orientation === "top" && degrees === 180 ? 270 : 90;
	      } else if (degrees > 0 && degrees < 180) {
	        angle = 90 - degrees;
	      } else if (degrees > 180 && degrees < 360) {
	        angle = 270 - degrees;
	      }
	
	      return angle + sign * labelRotation;
	    }
	  }, {
	    key: "constrainTooltip",
	    value: function constrainTooltip(center, props, dimensions) {
	      var x = center.x,
	          y = center.y;
	      var width = dimensions.width,
	          height = dimensions.height;
	      var extent = {
	        x: [0, props.width],
	        y: [0, props.height]
	      };
	      var flyoutExtent = {
	        x: [x - width / 2, x + width / 2],
	        y: [y - height / 2, y + height / 2]
	      };
	      var adjustments = {
	        x: [flyoutExtent.x[0] < extent.x[0] ? extent.x[0] - flyoutExtent.x[0] : 0, flyoutExtent.x[1] > extent.x[1] ? flyoutExtent.x[1] - extent.x[1] : 0],
	        y: [flyoutExtent.y[0] < extent.y[0] ? extent.y[0] - flyoutExtent.y[0] : 0, flyoutExtent.y[1] > extent.y[1] ? flyoutExtent.y[1] - extent.y[1] : 0]
	      };
	      return {
	        x: Math.round(x + adjustments.x[0] - adjustments.x[1]),
	        y: Math.round(y + adjustments.y[0] - adjustments.y[1])
	      };
	    } // eslint-disable-next-line complexity
	
	  }, {
	    key: "getFlyoutCenter",
	    value: function getFlyoutCenter(props, dimensions) {
	      var x = props.x,
	          y = props.y,
	          dx = props.dx,
	          dy = props.dy,
	          pointerLength = props.pointerLength,
	          orientation = props.orientation,
	          constrainToVisibleArea = props.constrainToVisibleArea,
	          centerOffset = props.centerOffset;
	      var height = dimensions.height,
	          width = dimensions.width;
	      var xSign = orientation === "left" ? -1 : 1;
	      var ySign = orientation === "bottom" ? -1 : 1;
	      var flyoutCenter = {
	        x: orientation === "left" || orientation === "right" ? x + xSign * (pointerLength + width / 2 + xSign * dx) : x + dx,
	        y: orientation === "top" || orientation === "bottom" ? y - ySign * (pointerLength + height / 2 - ySign * dy) : y + dy
	      };
	      var center = {
	        x: (0, _isPlainObject2.default)(props.center) && props.center.x !== undefined ? props.center.x : flyoutCenter.x,
	        y: (0, _isPlainObject2.default)(props.center) && props.center.y !== undefined ? props.center.y : flyoutCenter.y
	      };
	      var centerWithOffset = {
	        x: center.x + centerOffset.x,
	        y: center.y + centerOffset.y
	      };
	      return constrainToVisibleArea ? this.constrainTooltip(centerWithOffset, props, dimensions) : centerWithOffset;
	    }
	  }, {
	    key: "getLabelPadding",
	    value: function getLabelPadding(style) {
	      if (!style) {
	        return 0;
	      }
	
	      var paddings = Array.isArray(style) ? style.map(function (s) {
	        return s.padding;
	      }) : [style.padding];
	      return Math.max.apply(Math, _toConsumableArray(paddings).concat([0]));
	    }
	  }, {
	    key: "getDimensions",
	    value: function getDimensions(props, labelSize) {
	      var orientation = props.orientation,
	          pointerLength = props.pointerLength,
	          pointerWidth = props.pointerWidth,
	          style = props.style,
	          flyoutHeight = props.flyoutHeight,
	          flyoutWidth = props.flyoutWidth;
	      var padding = this.getLabelPadding(style);
	
	      var cornerRadius = _victoryCore.Helpers.evaluateProp(props.cornerRadius, props);
	
	      var getHeight = function () {
	        var calculatedHeight = labelSize.height + padding;
	        var minHeight = orientation === "top" || orientation === "bottom" ? 2 * cornerRadius : 2 * cornerRadius + pointerWidth;
	        return Math.max(minHeight, calculatedHeight);
	      };
	
	      var getWidth = function () {
	        var calculatedWidth = labelSize.width + padding;
	        var minWidth = orientation === "left" || orientation === "right" ? 2 * cornerRadius + pointerLength : 2 * cornerRadius;
	        return Math.max(minWidth, calculatedWidth);
	      };
	
	      return {
	        flyoutHeight: flyoutHeight ? _victoryCore.Helpers.evaluateProp(flyoutHeight, props) : getHeight(props, labelSize, orientation) + padding / 2,
	        flyoutWidth: flyoutWidth ? _victoryCore.Helpers.evaluateProp(flyoutWidth, props) : getWidth(props, labelSize, orientation) + padding
	      };
	    }
	  }, {
	    key: "getLabelProps",
	    value: function getLabelProps(props, calculatedValues) {
	      var flyoutCenter = calculatedValues.flyoutCenter,
	          style = calculatedValues.style,
	          labelSize = calculatedValues.labelSize,
	          dy = calculatedValues.dy,
	          dx = calculatedValues.dx;
	      var text = props.text,
	          datum = props.datum,
	          labelComponent = props.labelComponent,
	          index = props.index;
	      var textAnchor = (Array.isArray(style) && style.length ? style[0].textAnchor : style.textAnchor) || "middle";
	
	      var getLabelX = function () {
	        var sign = textAnchor === "end" ? -1 : 1;
	        return flyoutCenter.x - sign * (labelSize.width / 2);
	      };
	
	      return (0, _defaults2.default)({}, labelComponent.props, {
	        key: "".concat(this.id, "-label-").concat(index),
	        text: text,
	        datum: datum,
	        textAnchor: textAnchor,
	        dy: dy,
	        dx: dx,
	        style: style,
	        x: !textAnchor || textAnchor === "middle" ? flyoutCenter.x : getLabelX(),
	        y: flyoutCenter.y,
	        verticalAnchor: "middle",
	        angle: style.angle
	      });
	    }
	  }, {
	    key: "getPointerOrientation",
	    value: function getPointerOrientation(point, center, flyoutDimensions) {
	      var edges = {
	        bottom: center.y + flyoutDimensions.height / 2,
	        top: center.y - flyoutDimensions.height / 2,
	        left: center.x - flyoutDimensions.width / 2,
	        right: center.x + flyoutDimensions.width / 2
	      };
	      var gaps = [{
	        side: "top",
	        val: edges.top > point.y ? edges.top - point.y : -1
	      }, {
	        side: "bottom",
	        val: edges.bottom < point.y ? point.y - edges.bottom : -1
	      }, {
	        side: "right",
	        val: edges.right < point.x ? point.x - edges.right : -1
	      }, {
	        side: "left",
	        val: edges.left > point.x ? edges.left - point.x : -1
	      }];
	      return (0, _orderBy2.default)(gaps, "val", "desc")[0].side;
	    }
	  }, {
	    key: "getFlyoutProps",
	    value: function getFlyoutProps(props, calculatedValues) {
	      var flyoutDimensions = calculatedValues.flyoutDimensions,
	          flyoutStyle = calculatedValues.flyoutStyle,
	          flyoutCenter = calculatedValues.flyoutCenter;
	      var x = props.x,
	          y = props.y,
	          dx = props.dx,
	          dy = props.dy,
	          datum = props.datum,
	          index = props.index,
	          pointerLength = props.pointerLength,
	          pointerWidth = props.pointerWidth,
	          cornerRadius = props.cornerRadius,
	          events = props.events,
	          flyoutComponent = props.flyoutComponent;
	
	      var pointerOrientation = _victoryCore.Helpers.evaluateProp(props.pointerOrientation, props);
	
	      return (0, _defaults2.default)({}, flyoutComponent.props, {
	        x: x,
	        y: y,
	        dx: dx,
	        dy: dy,
	        datum: datum,
	        index: index,
	        pointerLength: pointerLength,
	        pointerWidth: pointerWidth,
	        cornerRadius: cornerRadius,
	        events: events,
	        orientation: pointerOrientation || this.getPointerOrientation({
	          x: x,
	          y: y
	        }, flyoutCenter, flyoutDimensions),
	        key: "".concat(this.id, "-tooltip-").concat(index),
	        width: flyoutDimensions.width,
	        height: flyoutDimensions.height,
	        style: flyoutStyle,
	        center: flyoutCenter
	      });
	    } // Overridden in victory-core-native
	
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip(props) {
	      var evaluatedProps = this.getEvaluatedProps(props);
	      var flyoutComponent = evaluatedProps.flyoutComponent,
	          labelComponent = evaluatedProps.labelComponent,
	          groupComponent = evaluatedProps.groupComponent,
	          active = evaluatedProps.active,
	          renderInPortal = evaluatedProps.renderInPortal;
	
	      if (!active) {
	        return renderInPortal ? _react.default.createElement(_victoryCore.VictoryPortal, null, null) : null;
	      }
	
	      var calculatedValues = this.getCalculatedValues(evaluatedProps);
	      var children = [_react.default.cloneElement(flyoutComponent, this.getFlyoutProps(evaluatedProps, calculatedValues)), _react.default.cloneElement(labelComponent, this.getLabelProps(evaluatedProps, calculatedValues))];
	
	      var tooltip = _react.default.cloneElement(groupComponent, {
	        role: "presentation",
	        transform: calculatedValues.transform
	      }, children);
	
	      return renderInPortal ? _react.default.createElement(_victoryCore.VictoryPortal, null, tooltip) : tooltip;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, "tooltip");
	
	      return this.renderTooltip(props);
	    }
	  }]);
	
	  return VictoryTooltip;
	}(_react.default.Component);
	
	exports.default = VictoryTooltip;
	Object.defineProperty(VictoryTooltip, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryTooltip"
	});
	Object.defineProperty(VictoryTooltip, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    activateData: _propTypes.default.bool,
	    active: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
	    angle: _propTypes.default.number,
	    center: _propTypes.default.shape({
	      x: _victoryCore.PropTypes.nonNegative,
	      y: _victoryCore.PropTypes.nonNegative
	    }),
	    centerOffset: _propTypes.default.shape({
	      x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	      y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func])
	    }),
	    constrainToVisibleArea: _propTypes.default.bool,
	    cornerRadius: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    data: _propTypes.default.array,
	    datum: _propTypes.default.object,
	    dx: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	    dy: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	    events: _propTypes.default.object,
	    flyoutComponent: _propTypes.default.element,
	    flyoutHeight: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    flyoutStyle: _propTypes.default.object,
	    flyoutWidth: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    groupComponent: _propTypes.default.element,
	    height: _propTypes.default.number,
	    horizontal: _propTypes.default.bool,
	    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    index: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    labelComponent: _propTypes.default.element,
	    orientation: _propTypes.default.oneOfType([_propTypes.default.oneOf(["top", "bottom", "left", "right"]), _propTypes.default.func]),
	    pointerLength: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    pointerOrientation: _propTypes.default.oneOfType([_propTypes.default.oneOf(["top", "bottom", "left", "right"]), _propTypes.default.func]),
	    pointerWidth: _propTypes.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes.default.func]),
	    polar: _propTypes.default.bool,
	    renderInPortal: _propTypes.default.bool,
	    scale: _propTypes.default.shape({
	      x: _victoryCore.PropTypes.scale,
	      y: _victoryCore.PropTypes.scale
	    }),
	    style: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
	    text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func, _propTypes.default.array]),
	    theme: _propTypes.default.object,
	    width: _propTypes.default.number,
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }
	});
	Object.defineProperty(VictoryTooltip, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    active: false,
	    renderInPortal: true,
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    flyoutComponent: _react.default.createElement(_flyout.default, null),
	    groupComponent: _react.default.createElement("g", null)
	  }
	});
	Object.defineProperty(VictoryTooltip, "defaultEvents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return [{
	      target: "data",
	      eventHandlers: {
	        onMouseOver: function () {
	          return props.activateData ? [{
	            target: "labels",
	            mutation: function () {
	              return {
	                active: true
	              };
	            }
	          }, {
	            target: "data",
	            mutation: function () {
	              return {
	                active: true
	              };
	            }
	          }] : [{
	            target: "labels",
	            mutation: function () {
	              return {
	                active: true
	              };
	            }
	          }];
	        },
	        onTouchStart: function () {
	          return props.activateData ? [{
	            target: "labels",
	            mutation: function () {
	              return {
	                active: true
	              };
	            }
	          }, {
	            target: "data",
	            mutation: function () {
	              return {
	                active: true
	              };
	            }
	          }] : [{
	            target: "labels",
	            mutation: function () {
	              return {
	                active: true
	              };
	            }
	          }];
	        },
	        onMouseOut: function () {
	          return props.activateData ? [{
	            target: "labels",
	            mutation: function () {
	              return {
	                active: undefined
	              };
	            }
	          }, {
	            target: "data",
	            mutation: function () {
	              return {
	                active: undefined
	              };
	            }
	          }] : [{
	            target: "labels",
	            mutation: function () {
	              return {
	                active: undefined
	              };
	            }
	          }];
	        },
	        onTouchEnd: function () {
	          return props.activateData ? [{
	            target: "labels",
	            mutation: function () {
	              return {
	                active: undefined
	              };
	            }
	          }, {
	            target: "data",
	            mutation: function () {
	              return {
	                active: undefined
	              };
	            }
	          }] : [{
	            target: "labels",
	            mutation: function () {
	              return {
	                active: undefined
	              };
	            }
	          }];
	        }
	      }
	    }];
	  }
	});

/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.voronoiContainerMixin = void 0;
	
	var _pick2 = _interopRequireDefault(__webpack_require__(152));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryTooltip = __webpack_require__(690);
	
	var _victoryCore = __webpack_require__(19);
	
	var _voronoiHelpers = _interopRequireDefault(__webpack_require__(692));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var voronoiContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_base) {
	    _inherits(VictoryVoronoiContainer, _base);
	
	    function VictoryVoronoiContainer() {
	      _classCallCheck(this, VictoryVoronoiContainer);
	
	      return _possibleConstructorReturn(this, (VictoryVoronoiContainer.__proto__ || Object.getPrototypeOf(VictoryVoronoiContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryVoronoiContainer, [{
	      key: "getDimension",
	      value: function getDimension(props) {
	        var horizontal = props.horizontal,
	            voronoiDimension = props.voronoiDimension;
	
	        if (!horizontal || !voronoiDimension) {
	          return voronoiDimension;
	        }
	
	        return voronoiDimension === "x" ? "y" : "x";
	      }
	    }, {
	      key: "getPoint",
	      value: function getPoint(point) {
	        var whitelist = ["_x", "_x1", "_x0", "_y", "_y1", "_y0"];
	        return (0, _pick2.default)(point, whitelist);
	      }
	    }, {
	      key: "getLabelPosition",
	      value: function getLabelPosition(props, labelProps, points) {
	        var mousePosition = props.mousePosition,
	            mouseFollowTooltips = props.mouseFollowTooltips;
	        var voronoiDimension = this.getDimension(props);
	        var point = this.getPoint(points[0]);
	
	        var basePosition = _victoryCore.Helpers.scalePoint(props, point);
	
	        var center = mouseFollowTooltips ? mousePosition : undefined;
	
	        if (!voronoiDimension || points.length < 2) {
	          return _objectSpread({}, basePosition, {
	            center: (0, _defaults2.default)({}, labelProps.center, center)
	          });
	        }
	
	        var x = voronoiDimension === "y" ? mousePosition.x : basePosition.x;
	        var y = voronoiDimension === "x" ? mousePosition.y : basePosition.y;
	        center = mouseFollowTooltips ? mousePosition : {
	          x: x,
	          y: y
	        };
	        return {
	          x: x,
	          y: y,
	          center: (0, _defaults2.default)({}, labelProps.center, center)
	        };
	      }
	    }, {
	      key: "getStyle",
	      value: function getStyle(props, points, type) {
	        var labels = props.labels,
	            labelComponent = props.labelComponent,
	            theme = props.theme;
	        var componentProps = labelComponent.props || {};
	        var themeStyles = theme && theme.voronoi && theme.voronoi.style ? theme.voronoi.style : {};
	        var componentStyleArray = type === "flyout" ? componentProps.flyoutStyle : componentProps.style;
	        return points.reduce(function (memo, datum, index) {
	          var labelProps = (0, _defaults2.default)({}, componentProps, {
	            datum: datum,
	            active: true
	          });
	          var text = (0, _isFunction2.default)(labels) ? labels(labelProps) : undefined;
	          var textArray = text !== undefined ? "".concat(text).split("\n") : [];
	          var baseStyle = datum.style && datum.style[type] || {};
	          var componentStyle = Array.isArray(componentStyleArray) ? componentStyleArray[index] : componentStyleArray;
	
	          var style = _victoryCore.Helpers.evaluateStyle((0, _defaults2.default)({}, componentStyle, baseStyle, themeStyles[type]), labelProps);
	
	          var styleArray = textArray.length ? textArray.map(function () {
	            return style;
	          }) : [style];
	          memo = memo.concat(styleArray);
	          return memo;
	        }, []);
	      }
	    }, {
	      key: "getDefaultLabelProps",
	      value: function getDefaultLabelProps(props, points) {
	        var voronoiDimension = props.voronoiDimension,
	            horizontal = props.horizontal,
	            mouseFollowTooltips = props.mouseFollowTooltips;
	        var point = this.getPoint(points[0]);
	        var multiPoint = voronoiDimension && points.length > 1;
	        var y = point._y1 !== undefined ? point._y1 : point._y;
	        var defaultHorizontalOrientation = y < 0 ? "left" : "right";
	        var defaultOrientation = y < 0 ? "bottom" : "top";
	        var labelOrientation = horizontal ? defaultHorizontalOrientation : defaultOrientation;
	        var orientation = mouseFollowTooltips ? undefined : labelOrientation;
	        return {
	          orientation: orientation,
	          pointerLength: multiPoint ? 0 : undefined,
	          constrainToVisibleArea: multiPoint || mouseFollowTooltips ? true : undefined
	        };
	      }
	    }, {
	      key: "getLabelProps",
	      value: function getLabelProps(props, points) {
	        var labels = props.labels,
	            scale = props.scale,
	            labelComponent = props.labelComponent,
	            theme = props.theme,
	            width = props.width,
	            height = props.height;
	        var componentProps = labelComponent.props || {};
	        var text = points.reduce(function (memo, datum) {
	          var labelProps = (0, _defaults2.default)({}, componentProps, {
	            datum: datum,
	            active: true
	          });
	          var t = (0, _isFunction2.default)(labels) ? labels(labelProps) : null;
	
	          if (t === null || t === undefined) {
	            return memo;
	          }
	
	          memo = memo.concat("".concat(t).split("\n"));
	          return memo;
	        }, []); // remove properties from first point to make datum
	        // eslint-disable-next-line no-unused-vars
	
	        var _points$ = points[0],
	            childName = _points$.childName,
	            eventKey = _points$.eventKey,
	            style = _points$.style,
	            continuous = _points$.continuous,
	            datum = _objectWithoutProperties(_points$, ["childName", "eventKey", "style", "continuous"]);
	
	        var name = props.name === childName ? childName : "".concat(props.name, "-").concat(childName);
	        var labelProps = (0, _defaults2.default)({
	          key: "".concat(name, "-").concat(eventKey, "-voronoi-tooltip"),
	          id: "".concat(name, "-").concat(eventKey, "-voronoi-tooltip"),
	          active: true,
	          flyoutStyle: this.getStyle(props, points, "flyout")[0],
	          renderInPortal: false,
	          style: this.getStyle(props, points, "labels"),
	          datum: datum,
	          scale: scale,
	          theme: theme,
	          text: text,
	          width: width,
	          height: height
	        }, componentProps, this.getDefaultLabelProps(props, points));
	        var labelPosition = this.getLabelPosition(props, labelProps, points);
	        return (0, _defaults2.default)({}, labelPosition, labelProps);
	      }
	    }, {
	      key: "getTooltip",
	      value: function getTooltip(props) {
	        var labels = props.labels,
	            activePoints = props.activePoints,
	            labelComponent = props.labelComponent;
	
	        if (!labels) {
	          return null;
	        }
	
	        if (Array.isArray(activePoints) && activePoints.length) {
	          var labelProps = this.getLabelProps(props, activePoints);
	          return _react.default.cloneElement(labelComponent, labelProps);
	        } else {
	          return null;
	        }
	      } // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        return _toConsumableArray(_react.default.Children.toArray(props.children)).concat([this.getTooltip(props)]);
	      }
	    }]);
	
	    return VictoryVoronoiContainer;
	  }(base), Object.defineProperty(_class, "displayName", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: "VictoryVoronoiContainer"
	  }), Object.defineProperty(_class, "propTypes", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.propTypes, {
	      activateData: _propTypes.default.bool,
	      activateLabels: _propTypes.default.bool,
	      disable: _propTypes.default.bool,
	      labelComponent: _propTypes.default.element,
	      labels: _propTypes.default.func,
	      mouseFollowTooltips: _propTypes.default.bool,
	      onActivated: _propTypes.default.func,
	      onDeactivated: _propTypes.default.func,
	      radius: _propTypes.default.number,
	      voronoiBlacklist: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _victoryCore.PropTypes.regExp])),
	      voronoiDimension: _propTypes.default.oneOf(["x", "y"]),
	      voronoiPadding: _propTypes.default.number
	    })
	  }), Object.defineProperty(_class, "defaultProps", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.defaultProps, {
	      activateData: true,
	      activateLabels: true,
	      labelComponent: _react.default.createElement(_victoryTooltip.VictoryTooltip, null),
	      voronoiPadding: 5
	    })
	  }), Object.defineProperty(_class, "defaultEvents", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function (props) {
	      return [{
	        target: "parent",
	        eventHandlers: {
	          onMouseLeave: function (evt, targetProps) {
	            return props.disable ? {} : _voronoiHelpers.default.onMouseLeave(evt, targetProps);
	          },
	          onTouchCancel: function (evt, targetProps) {
	            return props.disable ? {} : _voronoiHelpers.default.onMouseLeave(evt, targetProps);
	          },
	          onMouseMove: function (evt, targetProps) {
	            return props.disable ? {} : _voronoiHelpers.default.onMouseMove(evt, targetProps);
	          },
	          onTouchMove: function (evt, targetProps) {
	            return props.disable ? {} : _voronoiHelpers.default.onMouseMove(evt, targetProps);
	          }
	        }
	      }, {
	        target: "data",
	        eventHandlers: props.disable ? {} : {
	          onMouseOver: function () {
	            return null;
	          },
	          onMouseOut: function () {
	            return null;
	          },
	          onMouseMove: function () {
	            return null;
	          }
	        }
	      }];
	    }
	  }), _temp;
	};
	
	exports.voronoiContainerMixin = voronoiContainerMixin;
	
	var _default = voronoiContainerMixin(_victoryCore.VictoryContainer);
	
	exports.default = _default;

/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBaseProps = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(49));
	
	var _without2 = _interopRequireDefault(__webpack_require__(194));
	
	var _assign2 = _interopRequireDefault(__webpack_require__(20));
	
	var _d3Voronoi = __webpack_require__(1225);
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var getVoronoi = function (props, range, scale) {
	  var minRange = [Math.min.apply(Math, _toConsumableArray(range.x)), Math.min.apply(Math, _toConsumableArray(range.y))];
	  var maxRange = [Math.max.apply(Math, _toConsumableArray(range.x)), Math.max.apply(Math, _toConsumableArray(range.y))];
	
	  var angleAccessor = function (d) {
	    var x = scale.x(d._x1 !== undefined ? d._x1 : d._x);
	    return -1 * x + Math.PI / 2;
	  };
	
	  var xAccessor = function (d) {
	    return props.horizontal ? scale.y(d._y1 !== undefined ? d._y1 : d._y) : scale.x(d._x1 !== undefined ? d._x1 : d._x);
	  };
	
	  var yAccessor = function (d) {
	    return props.horizontal ? scale.x(d._x1 !== undefined ? d._x1 : d._x) : scale.y(d._y1 !== undefined ? d._y1 : d._y);
	  };
	
	  return (0, _d3Voronoi.voronoi)().x(function (d) {
	    return props.polar ? angleAccessor(d) : xAccessor(d);
	  }).y(function (d) {
	    return yAccessor(d);
	  }).extent([minRange, maxRange]);
	};
	
	var getCalculatedValues = function (props) {
	  var defaultStyles = props.theme && props.theme.voronoi && props.theme.voronoi.style ? props.theme.voronoi.style : {};
	
	  var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	
	  var data = _victoryCore.Data.getData(props);
	
	  var range = {
	    x: _victoryCore.Helpers.getRange(props, "x"),
	    y: _victoryCore.Helpers.getRange(props, "y")
	  };
	  var domain = {
	    x: _victoryCore.Domain.getDomain(props, "x"),
	    y: _victoryCore.Domain.getDomain(props, "y")
	  };
	  var scale = {
	    x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
	    y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
	  };
	  var voronoi = getVoronoi(props, range, scale);
	  var polygons = voronoi.polygons(data);
	  var origin = props.polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	  return {
	    domain: domain,
	    data: data,
	    scale: scale,
	    style: style,
	    polygons: polygons,
	    origin: origin
	  };
	};
	
	var getBaseProps = function (props, fallbackProps) {
	  var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "scatter");
	
	  props = (0, _assign2.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      data = _props.data,
	      domain = _props.domain,
	      events = _props.events,
	      height = _props.height,
	      origin = _props.origin,
	      padding = _props.padding,
	      polar = _props.polar,
	      polygons = _props.polygons,
	      scale = _props.scale,
	      sharedEvents = _props.sharedEvents,
	      standalone = _props.standalone,
	      style = _props.style,
	      theme = _props.theme,
	      width = _props.width,
	      labels = _props.labels,
	      name = _props.name;
	  var initialChildProps = {
	    parent: {
	      style: style.parent,
	      scale: scale,
	      domain: domain,
	      data: data,
	      standalone: standalone,
	      height: height,
	      width: width,
	      theme: theme,
	      origin: origin,
	      polar: polar,
	      padding: padding,
	      name: name
	    }
	  };
	  return data.reduce(function (childProps, datum, index) {
	    var polygon = (0, _without2.default)(polygons[index], "data");
	    var eventKey = !(0, _isNil2.default)(datum.eventKey) ? datum.eventKey : index;
	
	    var _Helpers$scalePoint = _victoryCore.Helpers.scalePoint(props, datum),
	        x = _Helpers$scalePoint.x,
	        y = _Helpers$scalePoint.y;
	
	    var dataProps = {
	      x: x,
	      y: y,
	      datum: datum,
	      data: data,
	      index: index,
	      scale: scale,
	      polygon: polygon,
	      origin: origin,
	      size: props.size,
	      style: style.data
	    };
	    childProps[eventKey] = {
	      data: dataProps
	    };
	
	    var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	
	    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
	      childProps[eventKey].labels = _victoryCore.LabelHelpers.getProps(props, index);
	    }
	
	    return childProps;
	  }, initialChildProps);
	};
	
	exports.getBaseProps = getBaseProps;

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "VictoryVoronoi", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoi.default;
	  }
	});
	Object.defineProperty(exports, "Voronoi", {
	  enumerable: true,
	  get: function () {
	    return _voronoi.default;
	  }
	});
	
	var _victoryVoronoi = _interopRequireDefault(__webpack_require__(1909));
	
	var _voronoi = _interopRequireDefault(__webpack_require__(693));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _victoryCore = __webpack_require__(19);
	
	var _voronoi = _interopRequireDefault(__webpack_require__(693));
	
	var _helperMethods = __webpack_require__(1907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var VictoryVoronoi =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(VictoryVoronoi, _React$Component);
	
	  function VictoryVoronoi() {
	    _classCallCheck(this, VictoryVoronoi);
	
	    return _possibleConstructorReturn(this, (VictoryVoronoi.__proto__ || Object.getPrototypeOf(VictoryVoronoi)).apply(this, arguments));
	  }
	
	  _createClass(VictoryVoronoi, [{
	    key: "shouldAnimate",
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var animationWhitelist = VictoryVoronoi.animationWhitelist,
	          role = VictoryVoronoi.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryVoronoi;
	}(_react.default.Component);
	
	Object.defineProperty(VictoryVoronoi, "animationWhitelist", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["data", "domain", "height", "padding", "samples", "size", "style", "width"]
	});
	Object.defineProperty(VictoryVoronoi, "displayName", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "VictoryVoronoi"
	});
	Object.defineProperty(VictoryVoronoi, "role", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: "voronoi"
	});
	Object.defineProperty(VictoryVoronoi, "defaultTransitions", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.DefaultTransitions.discreteTransitions()
	});
	Object.defineProperty(VictoryVoronoi, "propTypes", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _objectSpread({}, _victoryCore.CommonProps.baseProps, _victoryCore.CommonProps.dataProps, {
	    size: _victoryCore.PropTypes.nonNegative
	  })
	});
	Object.defineProperty(VictoryVoronoi, "defaultProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: {
	    containerComponent: _react.default.createElement(_victoryCore.VictoryContainer, null),
	    dataComponent: _react.default.createElement(_voronoi.default, null),
	    labelComponent: _react.default.createElement(_victoryCore.VictoryLabel, null),
	    groupComponent: _react.default.createElement("g", {
	      role: "presentation"
	    }),
	    samples: 50,
	    sortOrder: "ascending",
	    standalone: true,
	    theme: _victoryCore.VictoryTheme.grayscale
	  }
	});
	Object.defineProperty(VictoryVoronoi, "getDomain", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Domain.getDomain
	});
	Object.defineProperty(VictoryVoronoi, "getData", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: _victoryCore.Data.getData
	});
	Object.defineProperty(VictoryVoronoi, "getBaseProps", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: function (props) {
	    return (0, _helperMethods.getBaseProps)(props, fallbackProps);
	  }
	});
	Object.defineProperty(VictoryVoronoi, "expectedComponents", {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
	});
	
	var _default = (0, _victoryCore.addEvents)(VictoryVoronoi);
	
	exports.default = _default;

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.zoomContainerMixin = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(31));
	
	var _defaults2 = _interopRequireDefault(__webpack_require__(25));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _zoomHelpers = _interopRequireDefault(__webpack_require__(695));
	
	var _victoryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_DOWNSAMPLE = 150;
	
	var zoomContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_base) {
	    _inherits(VictoryZoomContainer, _base);
	
	    function VictoryZoomContainer() {
	      _classCallCheck(this, VictoryZoomContainer);
	
	      return _possibleConstructorReturn(this, (VictoryZoomContainer.__proto__ || Object.getPrototypeOf(VictoryZoomContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryZoomContainer, [{
	      key: "clipDataComponents",
	      value: function clipDataComponents(children, props) {
	        var scale = props.scale,
	            clipContainerComponent = props.clipContainerComponent,
	            polar = props.polar,
	            origin = props.origin,
	            horizontal = props.horizontal;
	        var rangeX = horizontal ? scale.y.range() : scale.x.range();
	        var rangeY = horizontal ? scale.x.range() : scale.y.range();
	        var plottableWidth = Math.abs(rangeX[0] - rangeX[1]);
	        var plottableHeight = Math.abs(rangeY[0] - rangeY[1]);
	        var radius = Math.max.apply(Math, _toConsumableArray(rangeY));
	
	        var groupComponent = _react.default.cloneElement(clipContainerComponent, _objectSpread({
	          clipWidth: plottableWidth,
	          clipHeight: plottableHeight,
	          translateX: Math.min.apply(Math, _toConsumableArray(rangeX)),
	          translateY: Math.min.apply(Math, _toConsumableArray(rangeY)),
	          polar: polar,
	          origin: polar ? origin : undefined,
	          radius: polar ? radius : undefined
	        }, clipContainerComponent.props));
	
	        return _react.default.Children.toArray(children).map(function (child) {
	          if (!_victoryCore.Data.isDataComponent(child)) {
	            return child;
	          } else {
	            return _react.default.cloneElement(child, {
	              groupComponent: groupComponent
	            });
	          }
	        });
	      }
	    }, {
	      key: "modifyPolarDomain",
	      value: function modifyPolarDomain(domain, originalDomain) {
	        // Only zoom the radius of polar charts. Zooming angles is very confusing
	        return {
	          x: originalDomain.x,
	          y: [0, domain.y[1]]
	        };
	      }
	    }, {
	      key: "downsampleZoomData",
	      value: function downsampleZoomData(props, child, domain) {
	        var downsample = props.downsample;
	
	        var getData = function (childProps) {
	          var data = childProps.data,
	              x = childProps.x,
	              y = childProps.y;
	          var defaultGetData = child.type && (0, _isFunction2.default)(child.type.getData) ? child.type.getData : function () {
	            return undefined;
	          }; // skip costly data formatting if x and y accessors are not present
	
	          return Array.isArray(data) && !x && !y ? data : defaultGetData(childProps);
	        };
	
	        var data = getData(child.props); // return undefined if downsample is not run, then default() will replace with child.props.data
	
	        if (!downsample || !domain || !data) {
	          return undefined;
	        }
	
	        var maxPoints = downsample === true ? DEFAULT_DOWNSAMPLE : downsample;
	        var dimension = props.zoomDimension || "x"; // important: assumes data is ordered by dimension
	        // get the start and end of the data that is in the current visible domain
	
	        var startIndex = data.findIndex(function (d) {
	          return d[dimension] >= domain[dimension][0];
	        });
	        var endIndex = data.findIndex(function (d) {
	          return d[dimension] > domain[dimension][1];
	        }); // pick one more point (if available) at each end so that VictoryLine, VictoryArea connect
	
	        if (startIndex !== 0) {
	          startIndex -= 1;
	        }
	
	        if (endIndex !== -1) {
	          endIndex += 1;
	        }
	
	        var visibleData = data.slice(startIndex, endIndex);
	        return _victoryCore.Data.downsample(visibleData, maxPoints, startIndex);
	      }
	    }, {
	      key: "modifyChildren",
	      value: function modifyChildren(props) {
	        var _this = this;
	
	        var childComponents = _react.default.Children.toArray(props.children); // eslint-disable-next-line max-statements
	
	
	        return childComponents.map(function (child) {
	          var role = child.type && child.type.role;
	
	          var isDataComponent = _victoryCore.Data.isDataComponent(child);
	
	          var currentDomain = props.currentDomain,
	              zoomActive = props.zoomActive,
	              allowZoom = props.allowZoom;
	          var originalDomain = (0, _defaults2.default)({}, props.originalDomain, props.domain);
	          var zoomDomain = (0, _defaults2.default)({}, props.zoomDomain, props.domain);
	          var cachedZoomDomain = (0, _defaults2.default)({}, props.cachedZoomDomain, props.domain);
	          var domain;
	
	          if (!_zoomHelpers.default.checkDomainEquality(zoomDomain, cachedZoomDomain)) {
	            // if zoomDomain has been changed, use it
	            domain = zoomDomain;
	          } else if (allowZoom && !zoomActive) {
	            // if user has zoomed all the way out, use the child domain
	            domain = child.props.domain;
	          } else {
	            // default: use currentDomain, set by the event handlers
	            domain = (0, _defaults2.default)({}, currentDomain, originalDomain);
	          }
	
	          var newDomain = props.polar ? _this.modifyPolarDomain(domain, originalDomain) : domain;
	
	          if (newDomain && props.zoomDimension) {
	            // if zooming is restricted to a dimension, don't squash changes to zoomDomain in other dim
	            newDomain = _objectSpread({}, zoomDomain, _defineProperty({}, props.zoomDimension, newDomain[props.zoomDimension]));
	          } // don't downsample stacked data
	
	
	          var newProps = isDataComponent && role !== "stack" ? {
	            domain: newDomain,
	            data: _this.downsampleZoomData(props, child, newDomain)
	          } : {
	            domain: newDomain
	          };
	          return _react.default.cloneElement(child, (0, _defaults2.default)(newProps, child.props));
	        });
	      } // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        var children = this.modifyChildren(props);
	        return this.clipDataComponents(children, props);
	      }
	    }]);
	
	    return VictoryZoomContainer;
	  }(base), Object.defineProperty(_class, "displayName", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: "VictoryZoomContainer"
	  }), Object.defineProperty(_class, "propTypes", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.propTypes, {
	      allowPan: _propTypes.default.bool,
	      allowZoom: _propTypes.default.bool,
	      clipContainerComponent: _propTypes.default.element.isRequired,
	      disable: _propTypes.default.bool,
	      downsample: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
	      minimumZoom: _propTypes.default.shape({
	        x: _propTypes.default.number,
	        y: _propTypes.default.number
	      }),
	      onZoomDomainChange: _propTypes.default.func,
	      zoomDimension: _propTypes.default.oneOf(["x", "y"]),
	      zoomDomain: _propTypes.default.shape({
	        x: _victoryCore.PropTypes.domain,
	        y: _victoryCore.PropTypes.domain
	      })
	    })
	  }), Object.defineProperty(_class, "defaultProps", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: _objectSpread({}, _victoryCore.VictoryContainer.defaultProps, {
	      clipContainerComponent: _react.default.createElement(_victoryCore.VictoryClipContainer, null),
	      allowPan: true,
	      allowZoom: true,
	      zoomActive: false
	    })
	  }), Object.defineProperty(_class, "defaultEvents", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function (props) {
	      return [{
	        target: "parent",
	        eventHandlers: _objectSpread({
	          onMouseDown: function (evt, targetProps) {
	            return props.disable ? {} : _zoomHelpers.default.onMouseDown(evt, targetProps);
	          },
	          onTouchStart: function (evt, targetProps) {
	            return props.disable ? {} : _zoomHelpers.default.onMouseDown(evt, targetProps);
	          },
	          onMouseUp: function (evt, targetProps) {
	            return props.disable ? {} : _zoomHelpers.default.onMouseUp(evt, targetProps);
	          },
	          onTouchEnd: function (evt, targetProps) {
	            return props.disable ? {} : _zoomHelpers.default.onMouseUp(evt, targetProps);
	          },
	          onMouseLeave: function (evt, targetProps) {
	            return props.disable ? {} : _zoomHelpers.default.onMouseLeave(evt, targetProps);
	          },
	          onTouchCancel: function (evt, targetProps) {
	            return props.disable ? {} : _zoomHelpers.default.onMouseLeave(evt, targetProps);
	          },
	          // eslint-disable-next-line max-params
	          onMouseMove: function (evt, targetProps, eventKey, ctx) {
	            if (props.disable) {
	              return {};
	            }
	
	            return _zoomHelpers.default.onMouseMove(evt, targetProps, eventKey, ctx);
	          },
	          // eslint-disable-next-line max-params
	          onTouchMove: function (evt, targetProps, eventKey, ctx) {
	            if (props.disable) {
	              return {};
	            }
	
	            evt.preventDefault();
	            return _zoomHelpers.default.onMouseMove(evt, targetProps, eventKey, ctx);
	          }
	        }, props.disable || !props.allowZoom ? {} : {
	          onWheel: _zoomHelpers.default.onWheel
	        })
	      }];
	    }
	  }), _temp;
	};
	
	exports.zoomContainerMixin = zoomContainerMixin;
	
	var _default = zoomContainerMixin(_victoryCore.VictoryContainer);
	
	exports.default = _default;

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isNegativeZero = __webpack_require__(1386);
	
	module.exports = function(number, length) {
	    if (isNaN(number)) {
	        throw new SyntaxError('zeropad requires a number or string');
	    }
	
	    if (typeof length !== 'undefined' && (isNaN(length) || length < 0)) {
	        throw new SyntaxError('zeropad requires a positive integer for length');
	    }
	
	    var prefix = isNegativeZero(number) || number < 0 ? '-' : '';
	
	    length = length || 2;
	    number = Math.abs(parseFloat(number));
	    var padLength = (length - String(number).length) + 1;
	
	    var pads = new Array(padLength).join('0');
	    return prefix + pads + number;
	};


/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_0__);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _Transition = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
	 *
	 * **Note**: If you want the animation to happen simultaneously
	 * (that is, to have the old child removed and a new child inserted **at the same time**),
	 * you should use
	 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
	 * instead.
	 *
	 * ```jsx
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <CSSTransition
	 *        key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade'
	 *      >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </CSSTransition>
	 *    </SwitchTransition>
	 *  );
	 * }
	 * ```
	 *
	 * ```css
	 * .fade-enter{
	 *    opacity: 0;
	 * }
	 * .fade-exit{
	 *    opacity: 1;
	 * }
	 * .fade-enter-active{
	 *    opacity: 1;
	 * }
	 * .fade-exit-active{
	 *    opacity: 0;
	 * }
	 * .fade-enter-active,
	 * .fade-exit-active{
	 *    transition: opacity 500ms;
	 * }
	 * ```
	 */
	
	var SwitchTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_4__));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_5__));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.0e25c068.js